import * as angular from 'angular';
import angular__default, { module, element, noop as noop$1, copy, toJson, isDefined } from 'angular';
import * as _$1 from 'lodash';
import ___default, { cloneDeep, merge, isNil, get, set, intersection, uniq, zipObject, chain, isEqual, padStart, isNumber as isNumber$1, isString, isPlainObject, isArray, isNull, isUndefined, forIn, without, startCase, isBoolean, values, map as map$1, flatten, xor, isFunction, truncate, defaults, toPath, throttle, isObject, findLast, maxBy, sortBy, has, find, cloneDeepWith, pick, size, some, reduce, includes, forOwn, pickBy, filter as filter$1, identity, groupBy, isEmpty, every, each, extend, compact, noop as noop$2, head, partition, memoize, fromPairs, omit, omitBy, isDate, uniqBy, kebabCase, union, keyBy, flatMap, debounce, reverse, orderBy, toNumber, keys, unset, capitalize, flow, clone, bindAll, template as template$2, trim, join, last, max, sumBy, sum, assign, toPairs, defaultsDeep, upperFirst, forEach, first as first$1, countBy, range } from 'lodash';
import { $http, $location, $rootScope, $log, $q, $timeout, $templateRequest, $compile, $controller, $window, $interpolate, $templateCache } from 'ngimport';
import * as React from 'react';
import React__default, { useEffect as useEffect$a, useRef as useRef$4, useMemo as useMemo$2, useState as useState$b, useCallback as useCallback$3, memo as memo$1 } from 'react';
import * as rxjs from 'rxjs';
import { fromEvent, defer, from, Subject, of, merge as merge$1, timer, BehaviorSubject, empty, ReplaySubject, combineLatest, forkJoin } from 'rxjs';
import { map, publishReplay, refCount, switchMap, takeUntil, delay, filter, debounceTime, tap, mergeMap, catchError, finalize, toArray, skip, take, startWith, withLatestFrom, distinctUntilChanged, merge as merge$2, first, bufferCount, concatMap, scan } from 'rxjs/operators';
import { Modal as Modal$1, OverlayTrigger, Tooltip as Tooltip$1, Overlay, Popover as Popover$1, Dropdown, Glyphicon, MenuItem, Button as Button$1, Pagination } from 'react-bootstrap';
import * as ReactDOM from 'react-dom';
import ReactDOM__default from 'react-dom';
import Select, { Creatable } from 'react-select';
import VirtualizedSelect from 'react-virtualized-select';
import memoizeOne from 'memoize-one';
import TetherComponent from 'react-tether';
import DiffMatchPatch from 'diff-match-patch';
import $$1 from 'jquery';
import { formatDistanceToNow, formatDistance, format } from 'date-fns';
import { DateTime, Duration } from 'luxon';
import { react2angular } from 'react2angular';
import classNames from 'classnames';
import { Parser, HtmlRenderer } from 'commonmark';
import DOMPurify from 'dompurify';
import { Icon, Illustration } from '@spinnaker/presentation';
export { Icon, Illustration } from '@spinnaker/presentation';
import { CacheFactory } from 'cachefactory';
import * as uiRouterReact from '@uirouter/react';
import { UISref, useSref, useIsActive, useCurrentStateAndParams, UIView, useSrefActive, useRouter, useParentView, UISrefActive, useOnStateChanged } from '@uirouter/react';
import { connect, Formik, FormikConsumer, FastField, Field, getIn as getIn$1, Form, FieldArray } from 'formik';
import version from 'root/version.json';
import { toast, ToastContainer } from 'react-toastify';
import { SpelExpressionEvaluator } from 'spel2js';
import DayPicker from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import AceEditor from 'react-ace';
import 'brace/mode/json';
import 'brace/ext/searchbox';
import { CSSTransition } from 'react-transition-group';
import { UIRouterContextComponent, UIRouterContext, UI_ROUTER_REACT_HYBRID } from '@uirouter/react-hybrid';
import { dump, loadAll, YAMLException, load } from 'js-yaml';
import { angular2react } from 'angular2react';
import 'jquery-textcomplete';
import UIROUTER_ANGULARJS from '@uirouter/angularjs';
import { hri } from 'human-readable-ids';
import { Debounce, Throttle } from 'lodash-decorators';
import * as Apollo from '@apollo/client';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider, gql, useApolloClient } from '@apollo/client';
import { atom, useRecoilValue, useRecoilState, RecoilRoot } from 'recoil';
import isEqual$1 from 'lodash/isEqual';
import ContentLoader from 'react-content-loader';
import AnsiUp from 'ansi_up';
import * as uiRouterCore from '@uirouter/core';
import { RejectType, Category, Glob } from '@uirouter/core';
import { SortableHandle, arrayMove, SortableElement, SortableContainer } from 'react-sortable-hoc';
import * as uiRouterRx from '@uirouter/rx';
import { UIRouterRxPlugin } from '@uirouter/rx';
import * as propTypes from 'prop-types';
import 'brace/mode/yaml';
import 'brace/theme/textmate';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';
import 'ui-select/dist/select.css';
import '@spinnaker/styleguide/public/styleguide.min.css';
import 'select2/select2.css';
import 'select2-bootstrap-css/select2-bootstrap.css';
import 'source-sans/source-sans-3.css';
import '@uirouter/angularjs/release/stateEvents';
import angulartics from 'angulartics';
import angularticsGoogleAnalytics from 'angulartics-google-analytics';
import 'react-toastify/dist/ReactToastify.min.css';
import { createUltimatePagination, ITEM_TYPES } from 'react-ultimate-pagination';
import ANGULAR_UI_BOOTSTRAP from 'angular-ui-bootstrap';
import { CellMeasurer, CellMeasurerCache, AutoSizer, List, SortDirection, Table as Table$1, Column } from 'react-virtualized';
import SearchApi from 'js-worker-search';
import 'angular-ui-sortable';
import ReactGA from 'react-ga';
import UI_SELECT from 'ui-select';
import ANGULAR_MESSAGES from 'angular-messages';
import ANGULAR_SANITIZE from 'angular-sanitize';
import { angularSpinner } from 'angular-spinner';

var spinnakerCore = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AccountSelectInput () { return AccountSelectInput; },
  get AccountService () { return AccountService; },
  get AccountTag () { return AccountTag; },
  get InvalidAPIResponse () { return InvalidAPIResponse; },
  get RequestBuilder () { return RequestBuilder; },
  get DeprecatedRequestBuilder () { return DeprecatedRequestBuilder; },
  get invalidContentMessage () { return invalidContentMessage; },
  get makeRequestBuilderConfig () { return makeRequestBuilderConfig; },
  get API () { return API; },
  get REST () { return REST; },
  get ApplicationContext () { return ApplicationContext; },
  get ApplicationContextProvider () { return ApplicationContextProvider; },
  get ApplicationIcon () { return ApplicationIcon; },
  get Application () { return Application; },
  get ApplicationStateProvider () { return ApplicationStateProvider; },
  get APPLICATION_STATE_PROVIDER () { return APPLICATION_STATE_PROVIDER; },
  get ApplicationModelBuilder () { return ApplicationModelBuilder; },
  get ConfigSectionFooter () { return ConfigSectionFooter; },
  get ConfigSectionFooterController () { return ConfigSectionFooterController; },
  get CONFIG_SECTION_FOOTER () { return CONFIG_SECTION_FOOTER; },
  get AppListExtractor () { return AppListExtractor; },
  get PlatformHealthOverride () { return PlatformHealthOverride; },
  get PlatformHealthOverrideInput () { return PlatformHealthOverrideInput; },
  get ApplicationNameValidator () { return ApplicationNameValidator; },
  get INFRASTRUCTURE_KEY () { return INFRASTRUCTURE_KEY; },
  get DELIVERY_KEY () { return DELIVERY_KEY; },
  get verticalNavExpandedAtom () { return verticalNavExpandedAtom; },
  get NavigationCategoryRegistry () { return NavigationCategoryRegistry; },
  get navigationCategoryRegistry () { return navigationCategoryRegistry; },
  get ApplicationDataSourceRegistry () { return ApplicationDataSourceRegistry; },
  get ApplicationReader () { return ApplicationReader; },
  get ApplicationWriter () { return ApplicationWriter; },
  get ApplicationDataSource () { return ApplicationDataSource; },
  get ArtifactIconService () { return ArtifactIconService; },
  get ArtifactReferenceService () { return ArtifactReferenceService; },
  get EXECUTION_ARTIFACT_TAB () { return EXECUTION_ARTIFACT_TAB; },
  get ExpectedArtifactService () { return ExpectedArtifactService; },
  get IMAGE_SOURCE_SELECTOR_COMPONENT () { return IMAGE_SOURCE_SELECTOR_COMPONENT; },
  get ExecutionArtifactTab () { return ExecutionArtifactTab; },
  get ArtifactIconList () { return ArtifactIconList; },
  get ArtifactTypePatterns () { return ArtifactTypePatterns; },
  get excludeAllTypesExcept () { return excludeAllTypesExcept; },
  get ExpectedArtifactSelectorViewController () { return ExpectedArtifactSelectorViewController; },
  get defaultExcludedArtifactTypes () { return defaultExcludedArtifactTypes; },
  get NgGenericArtifactDelegate () { return NgGenericArtifactDelegate; },
  get NgGCEImageArtifactDelegate () { return NgGCEImageArtifactDelegate; },
  get NgAppEngineDeployArtifactDelegate () { return NgAppEngineDeployArtifactDelegate; },
  get NgBakeManifestArtifactDelegate () { return NgBakeManifestArtifactDelegate; },
  get NgAppengineConfigArtifactDelegate () { return NgAppengineConfigArtifactDelegate; },
  get ArtifactAccountSelector () { return ArtifactAccountSelector; },
  get ARTIFACT_ACCOUNT_SELECTOR_COMPONENT_REACT () { return ARTIFACT_ACCOUNT_SELECTOR_COMPONENT_REACT; },
  get ArtifactIcon () { return ArtifactIcon; },
  get ExpectedArtifactSelector () { return ExpectedArtifactSelector; },
  get EXPECTED_ARTIFACT_SELECTOR_COMPONENT_REACT () { return EXPECTED_ARTIFACT_SELECTOR_COMPONENT_REACT; },
  get ExpectedArtifactEditor () { return ExpectedArtifactEditor; },
  get EXPECTED_ARTIFACT_EDITOR_COMPONENT_REACT () { return EXPECTED_ARTIFACT_EDITOR_COMPONENT_REACT; },
  get ExpectedArtifactSourceSelector () { return ExpectedArtifactSourceSelector; },
  get EXPECTED_ARTIFACT_SOURCE_SELECTOR_COMPONENT_REACT () { return EXPECTED_ARTIFACT_SOURCE_SELECTOR_COMPONENT_REACT; },
  get ExpectedArtifactModal () { return ExpectedArtifactModal; },
  get StageArtifactSelector () { return StageArtifactSelector; },
  get STAGE_ARTIFACT_SELECTOR_COMPONENT_REACT () { return STAGE_ARTIFACT_SELECTOR_COMPONENT_REACT; },
  get StageArtifactSelectorDelegate () { return StageArtifactSelectorDelegate; },
  get AuthenticationService () { return AuthenticationService; },
  get AuthenticationInitializer () { return AuthenticationInitializer; },
  get UserMenu () { return UserMenu; },
  get BannerContainer () { return BannerContainer; },
  get BannerContainerContent () { return BannerContainerContent; },
  get CacheInitializerService () { return CacheInitializerService; },
  get CACHE_INITIALIZER_SERVICE () { return CACHE_INITIALIZER_SERVICE; },
  get CollapsibleSectionStateCacheInternal () { return CollapsibleSectionStateCacheInternal; },
  get CollapsibleSectionStateCache () { return CollapsibleSectionStateCache; },
  get DeckCacheFactory () { return DeckCacheFactory; },
  get InfrastructureCachesInternal () { return InfrastructureCachesInternal; },
  get InfrastructureCaches () { return InfrastructureCaches; },
  get INFRASTRUCTURE_CACHE_CONFIG () { return INFRASTRUCTURE_CACHE_CONFIG; },
  get ViewStateCacheInternal () { return ViewStateCacheInternal; },
  get ViewStateCache () { return ViewStateCache; },
  get CertificateReader () { return CertificateReader; },
  get BuildServiceType () { return BuildServiceType; },
  get IgorService () { return IgorService; },
  get CloudProviderRegistry () { return CloudProviderRegistry; },
  get ProviderSelectionService () { return ProviderSelectionService; },
  get CloudProviderLabel () { return CloudProviderLabel; },
  get CloudProviderLogo () { return CloudProviderLogo; },
  get ProviderServiceDelegate () { return ProviderServiceDelegate; },
  get PROVIDER_SERVICE_DELEGATE () { return PROVIDER_SERVICE_DELEGATE; },
  get ClusterPodTitleWrapper () { return ClusterPodTitleWrapper; },
  get DefaultClusterMatcher () { return DefaultClusterMatcher; },
  get ClusterMatcher () { return ClusterMatcher; },
  get ClusterService () { return ClusterService; },
  get CLUSTER_SERVICE () { return CLUSTER_SERVICE; },
  get TaskMatcher () { return TaskMatcher; },
  get taskMatcher () { return taskMatcher; },
  get ClusterFilterService () { return ClusterFilterService; },
  get FilterSearch () { return FilterSearch; },
  get FilterSection () { return FilterSection; },
  get SETTINGS () { return SETTINGS; },
  get VersionChecker () { return VersionChecker; },
  get ConfirmationModalService () { return ConfirmationModalService; },
  get CoreRedBlackAdditionalFields () { return AdditionalFields$3; },
  get DeploymentStrategySelector () { return DeploymentStrategySelector; },
  get DeploymentStrategyRegistrar () { return DeploymentStrategyRegistrar; },
  get DeploymentStrategyRegistry () { return DeploymentStrategyRegistry; },
  get ARTIFACT_TYPE_EMBEDDED () { return ARTIFACT_TYPE_EMBEDDED; },
  get ARTIFACT_TYPE_REMOTE () { return ARTIFACT_TYPE_REMOTE; },
  get Key () { return Key; },
  get ManagedResourceStatus () { return ManagedResourceStatus; },
  get AddEntityTagLinks () { return AddEntityTagLinks; },
  get EntitySource () { return EntitySource; },
  get EntityTagEditor () { return EntityTagEditor; },
  get ClusterTargetBuilder () { return ClusterTargetBuilder; },
  get EntityTagsReader () { return EntityTagsReader; },
  get EntityTagWriter () { return EntityTagWriter; },
  get CategorizedNotifications () { return CategorizedNotifications; },
  get EntityName () { return EntityName; },
  get GroupedNotificationList () { return GroupedNotificationList; },
  get NotificationCategory () { return NotificationCategory; },
  get NotificationList () { return NotificationList; },
  get NotificationCategories () { return NotificationCategories; },
  get ExecutionMarkerIcon () { return ExecutionMarkerIcon; },
  get EntityNotifications () { return EntityNotifications; },
  get VIEW_CHANGES_LINK () { return VIEW_CHANGES_LINK; },
  get ViewChangesLink () { return ViewChangesLink; },
  get DIFF_MODULE () { return DIFF_MODULE; },
  get EventBus () { return EventBus; },
  get FilterModelService () { return FilterModelService; },
  get FilterCheckbox () { return FilterCheckbox$1; },
  get FilterCollapse () { return FilterCollapse; },
  get FilterTags () { return FilterTags; },
  get digestDependentFilters () { return digestDependentFilters; },
  get MapEditor () { return MapEditor; },
  get MapEditorInput () { return MapEditorInput; },
  get MapPair () { return MapPair; },
  get NumberList () { return NumberList; },
  get HealthCounts () { return HealthCounts; },
  get HelpField () { return HelpField; },
  get HelpMenu () { return HelpMenu; },
  get HelpTextExpandedContext () { return HelpTextExpandedContext; },
  get HelpContentsRegistry () { return HelpContentsRegistry; },
  get RecentHistoryService () { return RecentHistoryService; },
  get RECENT_HISTORY_SERVICE () { return RECENT_HISTORY_SERVICE; },
  get ImageReader () { return ImageReader; },
  get IMAGE_READER () { return IMAGE_READER; },
  get InstanceReader () { return InstanceReader; },
  get ConsoleOutputLink () { return ConsoleOutputLink; },
  get InstanceActions () { return InstanceActions; },
  get InstanceDetails () { return InstanceDetails; },
  get InstanceDetailsCmp () { return InstanceDetailsCmp; },
  get InstanceDetailsHeader () { return InstanceDetailsHeader; },
  get InstanceDetailsPane () { return InstanceDetailsPane; },
  get InstanceInsights () { return InstanceInsights; },
  get InstanceLinks () { return InstanceLinks; },
  get InstanceWriter () { return InstanceWriter; },
  get InstanceTypeService () { return InstanceTypeService; },
  get INSTANCE_TYPE_SERVICE () { return INSTANCE_TYPE_SERVICE; },
  get InstanceLoadBalancerHealth () { return InstanceLoadBalancerHealth; },
  get LoadBalancerDataUtils () { return LoadBalancerDataUtils; },
  get LoadBalancerReader () { return LoadBalancerReader; },
  get LOAD_BALANCER_READ_SERVICE () { return LOAD_BALANCER_READ_SERVICE; },
  get LoadBalancerWriter () { return LoadBalancerWriter; },
  get CreateLoadBalancerButton () { return CreateLoadBalancerButton; },
  get LoadBalancerClusterContainer () { return LoadBalancerClusterContainer; },
  get LoadBalancerInstances () { return LoadBalancerInstances; },
  get LoadBalancerServerGroup () { return LoadBalancerServerGroup; },
  get LoadBalancersTagWrapper () { return LoadBalancersTagWrapper; },
  get FunctionDetails () { return FunctionDetails; },
  get FunctionReader () { return FunctionReader; },
  get FUNCTION_READ_SERVICE () { return FUNCTION_READ_SERVICE; },
  get FunctionWriter () { return FunctionWriter; },
  get CreateFunctionButton () { return CreateFunctionButton; },
  get V2_MODAL_WIZARD_COMPONENT () { return V2_MODAL_WIZARD_COMPONENT; },
  get V2ModalWizard () { return V2ModalWizard; },
  get ModalClose () { return ModalClose; },
  get SubmitButton () { return SubmitButton; },
  get ModalWizard () { return ModalWizard; },
  get WizardModal () { return WizardModal; },
  get WizardPage () { return WizardPage; },
  get WizardStepLabel () { return WizardStepLabel; },
  get DeployingIntoManagedClusterWarning () { return DeployingIntoManagedClusterWarning; },
  get ManagedMenuItem () { return ManagedMenuItem; },
  get addManagedResourceMetadataToServerGroups () { return addManagedResourceMetadataToServerGroups; },
  get addManagedResourceMetadataToLoadBalancers () { return addManagedResourceMetadataToLoadBalancers; },
  get addManagedResourceMetadataToSecurityGroups () { return addManagedResourceMetadataToSecurityGroups; },
  get ManagedResourceDetailsIndicator () { return ManagedResourceDetailsIndicator; },
  get MANAGED_RESOURCE_DETAILS_INDICATOR () { return MANAGED_RESOURCE_DETAILS_INDICATOR; },
  get ManagedResourceStatusIndicator () { return ManagedResourceStatusIndicator; },
  get confirmNotManaged () { return confirmNotManaged; },
  get toggleResourcePause () { return toggleResourcePause; },
  get MANAGED_RESOURCES_DATA_SOURCE () { return MANAGED_RESOURCES_DATA_SOURCE; },
  get CORE_MANAGED_MANAGED_MODULE () { return CORE_MANAGED_MANAGED_MODULE; },
  get getKindName () { return getKindName; },
  get getResourceKindForLoadBalancerType () { return getResourceKindForLoadBalancerType; },
  get ManagedReader () { return ManagedReader; },
  get ManagedWriter () { return ManagedWriter; },
  get registerManagedDeliveryPlugin () { return registerManagedDeliveryPlugin; },
  get resourceManager () { return resourceManager; },
  get ManifestWriter () { return ManifestWriter; },
  get ManifestReader () { return ManifestReader; },
  get JobStageExecutionLogs () { return JobStageExecutionLogs; },
  get JobManifestPodLogs () { return JobManifestPodLogs; },
  get ManifestYaml () { return ManifestYaml; },
  get DefaultPodNameProvider () { return DefaultPodNameProvider; },
  get JobEventBasedPodNameProvider () { return JobEventBasedPodNameProvider; },
  get NameUtils () { return NameUtils; },
  get StateConfigProvider () { return StateConfigProvider; },
  get trueKeyObjectParamType () { return trueKeyObjectParamType; },
  get inverseBooleanParamType () { return inverseBooleanParamType; },
  get booleanParamType () { return booleanParamType; },
  get sortKeyParamType () { return sortKeyParamType; },
  get STATE_CONFIG_PROVIDER () { return STATE_CONFIG_PROVIDER; },
  get UrlBuilderRegistry () { return UrlBuilderRegistry; },
  get UrlBuilder () { return UrlBuilder; },
  get UrlParser () { return UrlParser; },
  get NetworkReader () { return NetworkReader; },
  get NotificationDetails () { return NotificationDetails$1; },
  get EditNotificationModal () { return EditNotificationModal; },
  get NotificationTransformer () { return NotificationTransformer; },
  get NotificationSelector () { return NotificationSelector; },
  get NOTIFICATION_LIST () { return NOTIFICATION_LIST; },
  get NotificationsList () { return NotificationsList; },
  get OrchestratedItemTransformer () { return OrchestratedItemTransformer; },
  get OverrideRegistry () { return OverrideRegistry; },
  get OVERRIDE_REGISTRY () { return OVERRIDE_REGISTRY; },
  get Overridable () { return Overridable; },
  get overridableComponent () { return overridableComponent; },
  get RegistrationQueue () { return RegistrationQueue; },
  get overrideRegistrationQueue () { return overrideRegistrationQueue; },
  get Overrides () { return Overrides; },
  get overridesComponent () { return overridesComponent; },
  get PageTitleService () { return PageTitleService; },
  get PAGE_TITLE_SERVICE () { return PAGE_TITLE_SERVICE; },
  get PagerDutyReader () { return PagerDutyReader; },
  get PagerDutyWriter () { return PagerDutyWriter; },
  get PagerDutyTagComponentController () { return PagerDutyTagComponentController; },
  get PAGER_DUTY_TAG_COMPONENT () { return PAGER_DUTY_TAG_COMPONENT; },
  get PagerDutySelectFieldController () { return PagerDutySelectFieldController; },
  get PAGER_DUTY_SELECT_FIELD_COMPONENT () { return PAGER_DUTY_SELECT_FIELD_COMPONENT; },
  get PipelineRegistry () { return PipelineRegistry; },
  get PipelineConfigService () { return PipelineConfigService; },
  get FormikStageConfig () { return FormikStageConfig; },
  get BakeExecutionLabel () { return BakeExecutionLabel; },
  get BakeryReader () { return BakeryReader; },
  get AsgActionExecutionDetailsSection () { return AsgActionExecutionDetailsSection; },
  get ExecutionDetailsSection () { return ExecutionDetailsSection; },
  get ExecutionBarLabel () { return ExecutionBarLabel; },
  get ExecutionDetailsTasks () { return ExecutionDetailsTasks; },
  get StageConfigField () { return StageConfigField; },
  get applySuspendedStatuses () { return applySuspendedStatuses; },
  get ExecutionStepDetails () { return ExecutionStepDetails; },
  get PipelineStageExecutionDetails () { return PipelineStageExecutionDetails; },
  get TitusExecutionLogs () { return TitusExecutionLogs; },
  get PreconfiguredJobExecutionDetails () { return PreconfiguredJobExecutionDetails; },
  get PreconfiguredJobStageConfig () { return PreconfiguredJobStageConfig; },
  get PreconfiguredJobReader () { return PreconfiguredJobReader; },
  get makePreconfiguredJobStage () { return makePreconfiguredJobStage; },
  get PRECONFIGUREDJOB_STAGE () { return PRECONFIGUREDJOB_STAGE; },
  get StageConstants () { return StageConstants; },
  get PipelineTemplates () { return PipelineTemplates; },
  get PipelineTemplateV2Service () { return PipelineTemplateV2Service; },
  get PipelineTemplateReader () { return PipelineTemplateReader; },
  get RunAsUserInput () { return RunAsUserInput; },
  get Triggers () { return Triggers$1; },
  get BaseBuildTriggerTemplate () { return BaseBuildTriggerTemplate; },
  get PipelineConfigValidator () { return PipelineConfigValidator; },
  get CreatePipelineModal () { return CreatePipelineModal; },
  get ExecutionDetailsSectionService () { return ExecutionDetailsSectionService; },
  get EXECUTION_DETAILS_SECTION_SERVICE () { return EXECUTION_DETAILS_SECTION_SERVICE; },
  get ExecutionDetailsSectionNav () { return ExecutionDetailsSectionNav; },
  get StageExecutionLogs () { return StageExecutionLogs; },
  get StageFailureMessages () { return StageFailureMessages; },
  get StageFailureMessage () { return StageFailureMessage; },
  get StageSummary () { return StageSummary; },
  get Execution () { return Execution$1; },
  get filterModelConfig () { return filterModelConfig$1; },
  get ExecutionFilterModel () { return ExecutionFilterModel; },
  get ManualExecutionModal () { return ManualExecutionModal; },
  get TriggerTemplate () { return TriggerTemplate; },
  get ExecutionsTransformer () { return ExecutionsTransformer; },
  get ExecutionService () { return ExecutionService; },
  get EXECUTION_SERVICE () { return EXECUTION_SERVICE; },
  get ArtifactList () { return ArtifactList; },
  get getBakedArtifacts () { return getBakedArtifacts; },
  get getContentReference () { return getContentReference; },
  get registerPluginExtensions () { return registerPluginExtensions; },
  get PLUGINS_MODULE () { return PLUGINS_MODULE; },
  get PluginRegistry () { return PluginRegistry; },
  get Icon () { return Icon; },
  get Illustration () { return Illustration; },
  get CollapsibleElement () { return CollapsibleElement; },
  get CollapsibleSection () { return CollapsibleSection; },
  get CustomLabels () { return CustomLabels; },
  get Details () { return Details; },
  get SpInput () { return SpInput; },
  get spelNumberCheck () { return spelNumberCheck; },
  get FormikForm () { return FormikForm; },
  get SpinFormik () { return SpinFormik; },
  get FormField () { return FormField; },
  get FormikExpressionField () { return FormikExpressionField; },
  get FormikExpressionRegexField () { return FormikExpressionRegexField; },
  get createFieldValidator () { return createFieldValidator; },
  get FormikFormField () { return FormikFormField; },
  get renderContent () { return renderContent; },
  get useSaveRestoreMutuallyExclusiveFields () { return useSaveRestoreMutuallyExclusiveFields; },
  get useFormInputValueMapper () { return useFormInputValueMapper; },
  get CheckboxInput () { return CheckboxInput; },
  get ChecklistInput () { return ChecklistInput; },
  get DayPickerInput () { return DayPickerInput; },
  get JsonEditor () { return JsonEditor; },
  get NumberInput () { return NumberInput$1; },
  get RadioButtonInput () { return RadioButtonInput; },
  get reactSelectValidationErrorStyle () { return reactSelectValidationErrorStyle; },
  get reactSelectOnChangeAdapter () { return reactSelectOnChangeAdapter; },
  get reactSelectOnBlurAdapter () { return reactSelectOnBlurAdapter; },
  get ReactSelectInput () { return ReactSelectInput; },
  get SelectInput () { return SelectInput; },
  get StringsAsOptions () { return StringsAsOptions; },
  get TextAreaInput () { return TextAreaInput; },
  get TextInput () { return TextInput; },
  get ExpressionError () { return ExpressionError; },
  get ExpressionInput () { return ExpressionInput; },
  get ExpressionPreview () { return ExpressionPreview; },
  get evaluateExpression () { return evaluateExpression; },
  get parseSpelExpressions () { return parseSpelExpressions; },
  get useInternalValidator () { return useInternalValidator; },
  get orEmptyString () { return orEmptyString; },
  get validationClassName () { return validationClassName; },
  get createFakeReactSyntheticEvent () { return createFakeReactSyntheticEvent; },
  get isStringArray () { return isStringArray; },
  get StandardFieldLayout () { return StandardFieldLayout; },
  get LayoutContext () { return LayoutContext; },
  get LayoutProvider () { return LayoutProvider; },
  get LayoutConsumer () { return LayoutConsumer; },
  get ResponsiveFieldLayout () { return ResponsiveFieldLayout; },
  get FormValidator () { return FormValidator; },
  get FormValidatorField () { return FormValidatorField; },
  get ValidationMessage () { return ValidationMessage; },
  get categoryLabels () { return categoryLabels; },
  get asyncMessage () { return asyncMessage; },
  get errorMessage () { return errorMessage; },
  get infoMessage () { return infoMessage; },
  get messageMessage () { return messageMessage; },
  get successMessage () { return successMessage; },
  get warningMessage () { return warningMessage; },
  get categorizeValidationMessage () { return categorizeValidationMessage; },
  get categorizeValidationMessages () { return categorizeValidationMessages; },
  get useValidationData () { return useValidationData; },
  get FORM_VALIDATION_VALIDATABLE_FIELD_IS_VALID_SHORT_CIRCUIT () { return FORM_VALIDATION_VALIDATABLE_FIELD_IS_VALID_SHORT_CIRCUIT; },
  get composeValidators () { return composeValidators; },
  get Validators () { return Validators; },
  get useApplicationContext () { return useApplicationContext; },
  get useApplicationContextSafe () { return useApplicationContextSafe; },
  get useContainerClassNames () { return useContainerClassNames; },
  get useData () { return useData; },
  get useDataSource () { return useDataSource; },
  get useDebouncedValue () { return useDebouncedValue; },
  get useDeepObjectDiff () { return useDeepObjectDiff; },
  get useEscapeKeyPressed () { return useEscapeKeyPressed; },
  get useEventListener () { return useEventListener; },
  get useForceUpdate () { return useForceUpdate; },
  get useInterval () { return useInterval; },
  get useIsMobile () { return useIsMobile; },
  get useIsMountedRef () { return useIsMountedRef; },
  get useLatestCallback () { return useLatestCallback; },
  get useLatestPromise () { return useLatestPromise; },
  get useMountStatusRef () { return useMountStatusRef; },
  get useObservable () { return useObservable; },
  get useObservableValue () { return useObservableValue; },
  get usePollingData () { return usePollingData; },
  get usePrevious () { return usePrevious; },
  get HoverablePopover () { return HoverablePopover; },
  get LabelComponent () { return LabelComponent; },
  get LabeledValue () { return LabeledValue; },
  get LabeledValueList () { return LabeledValueList; },
  get LinkWithClipboard () { return LinkWithClipboard; },
  get LINK_WITH_CLIPBOARD () { return LINK_WITH_CLIPBOARD; },
  get Markdown () { return Markdown; },
  get toMarkdown () { return toMarkdown; },
  get Modal () { return Modal; },
  get ModalHeader () { return ModalHeader; },
  get ModalBody () { return ModalBody; },
  get ModalFooter () { return ModalFooter; },
  get showModal () { return showModal; },
  get PageNavigator () { return PageNavigator; },
  get PageSection () { return PageSection; },
  get ReactModal () { return ReactModal; },
  get RenderOutputFile () { return RenderOutputFile; },
  get robotToHuman () { return robotToHuman; },
  get robotToHumanFilter () { return robotToHumanFilter; },
  get ROBOT_TO_HUMAN_FILTER () { return ROBOT_TO_HUMAN_FILTER; },
  get SortToggle () { return SortToggle; },
  get SpanDropdownTrigger () { return SpanDropdownTrigger; },
  get SpelInput () { return SpelInput; },
  get SimpleSpelInput () { return SimpleSpelInput; },
  get SpelService () { return SpelService; },
  get FormikSpelContext () { return FormikSpelContext; },
  get FormikSpelContextProvider () { return FormikSpelContextProvider; },
  get SpelAwareInputMode () { return SpelAwareInputMode; },
  get SpelToggle () { return SpelToggle; },
  get withErrorBoundary () { return withErrorBoundary; },
  get SpinErrorBoundary () { return SpinErrorBoundary; },
  get UI_ROUTER_REACT_ERROR_BOUNDARY () { return UI_ROUTER_REACT_ERROR_BOUNDARY; },
  get TabBoundary () { return TabBoundary; },
  get Table () { return Table; },
  get TableRow () { return TableRow; },
  get TableCell () { return TableCell; },
  get minimalNativeTableLayout () { return minimalNativeTableLayout; },
  get getGridColumnsStyle () { return getGridColumnsStyle; },
  get standardGridTableLayout () { return standardGridTableLayout; },
  get TetheredCreatable () { return TetheredCreatable; },
  get TetheredSelect () { return TetheredSelect; },
  get BreakString () { return BreakString; },
  get SingleLineString () { return SingleLineString; },
  get ToggleSize () { return ToggleSize; },
  get ToggleButtonGroup () { return ToggleButtonGroup; },
  get Tooltip () { return Tooltip; },
  get WatchValue () { return WatchValue; },
  get IconTooltip () { return IconTooltip; },
  get Applications () { return Applications$1; },
  get Clusters () { return Clusters; },
  get ConfigureProjectModal () { return ConfigureProjectModal; },
  get Pipelines () { return Pipelines$1; },
  get ProjectAttributes () { return ProjectAttributes; },
  get ProjectHeader () { return ProjectHeader; },
  get ProjectReader () { return ProjectReader; },
  get ProjectWriter () { return ProjectWriter; },
  get PubsubSubscriptionReader () { return PubsubSubscriptionReader; },
  get AngularJSAdapter () { return AngularJSAdapter; },
  get CoreModalInject () { return CoreModalInject; },
  get ModalInjector () { return ModalInjector; },
  get NgReactInjector () { return NgReactInjector; },
  get NgReact () { return NgReact; },
  get ReactInject () { return ReactInject; },
  get CoreReactInject () { return CoreReactInject; },
  get ReactInjector () { return ReactInjector; },
  get REACT_MODULE () { return REACT_MODULE; },
  get StateEvents () { return StateEvents; },
  get STATE_EVENTS () { return STATE_EVENTS; },
  get arePropsEqual () { return arePropsEqual; },
  get RegionSelectField () { return RegionSelectField; },
  get RegionSelectInput () { return RegionSelectInput; },
  get Registry () { return Registry; },
  get RetryService () { return RetryService; },
  get SchedulerFactory () { return SchedulerFactory; },
  get GlobalSearch () { return GlobalSearch; },
  get InfrastructureSearcher () { return InfrastructureSearcher; },
  get InfrastructureSearchService () { return InfrastructureSearchService; },
  get INFRASTRUCTURE_SEARCH_SERVICE () { return INFRASTRUCTURE_SEARCH_SERVICE; },
  get SearchService () { return SearchService; },
  get SearchTableHeader () { return SearchTableHeader; },
  get SearchTableRow () { return SearchTableRow; },
  get SearchTableBody () { return SearchTableBody; },
  get HeaderCell () { return HeaderCell; },
  get BasicCell () { return BasicCell; },
  get HrefCell () { return HrefCell; },
  get AccountCell () { return AccountCell; },
  get HealthCountsCell () { return HealthCountsCell; },
  get DefaultSearchResultTab () { return DefaultSearchResultTab; },
  get SearchResultType () { return SearchResultType; },
  get SearchResultTypeRegistry () { return SearchResultTypeRegistry; },
  get searchResultTypeRegistry () { return searchResultTypeRegistry; },
  get SearchResults () { return SearchResults; },
  get SearchStatus () { return SearchStatus; },
  get Filter () { return Filter; },
  get Filters () { return Filters$1; },
  get Search () { return Search; },
  get FilterTypeRegistry () { return FilterTypeRegistry; },
  get SearchFilterTypeRegistry () { return SearchFilterTypeRegistry; },
  get SecurityGroupWriter () { return SecurityGroupWriter; },
  get FirewallLabels () { return FirewallLabels; },
  get SecurityGroupReader () { return SecurityGroupReader; },
  get SECURITY_GROUP_READER () { return SECURITY_GROUP_READER; },
  get ServerGroup () { return ServerGroup$1; },
  get LoadBalancers () { return LoadBalancers$2; },
  get MultiSelectCheckbox () { return MultiSelectCheckbox; },
  get CloudProviderIcon () { return CloudProviderIcon; },
  get ImageList () { return ImageList; },
  get SequenceAndBuildAndImages () { return SequenceAndBuildAndImages; },
  get Alerts () { return Alerts; },
  get Health () { return Health; },
  get RunningTasks () { return RunningTasks$1; },
  get ServerGroupHeader () { return ServerGroupHeader; },
  get DeployInitializer () { return DeployInitializer; },
  get DeployInitializerController () { return DeployInitializerController; },
  get DEPLOY_INITIALIZER_COMPONENT () { return DEPLOY_INITIALIZER_COMPONENT; },
  get setMatchingResourceSummary () { return setMatchingResourceSummary; },
  get ServerGroupCommandBuilderService () { return ServerGroupCommandBuilderService; },
  get SERVER_GROUP_COMMAND_BUILDER_SERVICE () { return SERVER_GROUP_COMMAND_BUILDER_SERVICE; },
  get ServerGroupCommandRegistry () { return ServerGroupCommandRegistry; },
  get SERVER_GROUP_COMMAND_REGISTRY_PROVIDER () { return SERVER_GROUP_COMMAND_REGISTRY_PROVIDER; },
  get ServerGroupConfigurationService () { return ServerGroupConfigurationService; },
  get SERVER_GROUP_CONFIGURATION_SERVICE () { return SERVER_GROUP_CONFIGURATION_SERVICE; },
  get ServerGroupNamePreview () { return ServerGroupNamePreview; },
  get ServerGroupDetailsField () { return ServerGroupDetailsField; },
  get ServerGroupDetails () { return ServerGroupDetails; },
  get ServerGroupDetailsWrapper () { return ServerGroupDetailsWrapper; },
  get ShowUserData () { return ShowUserData; },
  get CapacityDetailsSection () { return CapacityDetailsSection; },
  get CurrentCapacity () { return CurrentCapacity; },
  get DesiredCapacity () { return DesiredCapacity; },
  get ViewScalingActivitiesLink () { return ViewScalingActivitiesLink; },
  get ServerGroupWarningMessageService () { return ServerGroupWarningMessageService; },
  get CloudMetricsReader () { return CloudMetricsReader; },
  get MinMaxDesiredChanges () { return MinMaxDesiredChanges; },
  get ServerGroupReader () { return ServerGroupReader; },
  get ServerGroupWriter () { return ServerGroupWriter; },
  get SERVER_GROUP_WRITER () { return SERVER_GROUP_WRITER; },
  get ServerGroupTemplates () { return ServerGroupTemplates; },
  get SERVER_GROUP_MANAGER_DATA_SOURCE () { return SERVER_GROUP_MANAGER_DATA_SOURCE; },
  get SERVER_GROUP_MANAGER_STATES () { return SERVER_GROUP_MANAGER_STATES; },
  get ServerGroupManagerReader () { return ServerGroupManagerReader; },
  get ServerGroupManagerTag () { return ServerGroupManagerTag; },
  get ServiceAccountReader () { return ServiceAccountReader; },
  get ServicesReader () { return ServicesReader; },
  get SLACK_COMPONENT () { return SLACK_COMPONENT; },
  get SlackReader () { return SlackReader; },
  get ClusterState () { return ClusterState; },
  get ExecutionState () { return ExecutionState; },
  get LoadBalancerState () { return LoadBalancerState; },
  get SecurityGroupState () { return SecurityGroupState; },
  get FunctionState () { return FunctionState; },
  get initialize () { return initialize; },
  get StorageAccountReader () { return StorageAccountReader; },
  get SubnetReader () { return SubnetReader; },
  get SubnetTag () { return SubnetTag; },
  get PlatformHealthOverrideMessage () { return PlatformHealthOverrideMessage; },
  get TaskMonitor () { return TaskMonitor; },
  get TaskMonitorWrapper () { return TaskMonitorWrapper; },
  get TaskReason () { return TaskReason; },
  get TaskMonitorModal () { return TaskMonitorModal; },
  get TaskReader () { return TaskReader; },
  get TaskExecutor () { return TaskExecutor; },
  get UserVerification () { return UserVerification; },
  get RenderWhenVisible () { return RenderWhenVisible; },
  get CopyToClipboard () { return CopyToClipboard; },
  get now () { return now; },
  get DebugTiming () { return DebugTiming; },
  get DebugTimingCumulative () { return DebugTimingCumulative; },
  get firstDefined () { return firstDefined; },
  get JsonUtils () { return JsonUtils; },
  get DiffView () { return DiffView; },
  get traverseObject () { return traverseObject; },
  get noop () { return noop; },
  get toIPromise () { return toIPromise; },
  get RENDER_IF_FEATURE () { return RENDER_IF_FEATURE; },
  get ScrollToService () { return ScrollToService; },
  get duration () { return duration; },
  get timeDiffToString () { return timeDiffToString; },
  get timestamp () { return timestamp; },
  get relativeTime () { return relativeTime; },
  get timePickerTime () { return timePickerTime; },
  get TIME_FORMATTERS () { return TIME_FORMATTERS; },
  get decodeUnicodeBase64 () { return decodeUnicodeBase64; },
  get UUIDGenerator () { return UUIDGenerator; },
  get WorkerPool () { return WorkerPool; },
  get filterObjectValues () { return filterObjectValues; },
  get logger () { return logger; },
  get ApplicationsPickerInput () { return ApplicationsPickerInput; },
  get ScopeClusterSelector () { return ScopeClusterSelector; },
  get ClusterMatches () { return ClusterMatches; },
  get CLUSTER_MATCHES_COMPONENT () { return CLUSTER_MATCHES_COMPONENT; },
  get NotifierService () { return NotifierService; },
  get SpelNumberInput () { return SpelNumberInput; },
  get SpelText () { return SpelText; },
  get Spinner () { return Spinner; },
  get DeleteType () { return DeleteType; },
  get Tag () { return Tag; },
  get TagList () { return TagList; },
  get YAML_EDITOR_COMPONENT () { return YAML_EDITOR_COMPONENT; },
  get yamlStringToDocuments () { return yamlStringToDocuments; },
  get yamlDocumentsToString () { return yamlDocumentsToString; },
  get YamlEditor () { return YamlEditor; },
  get CORE_MODULE () { return CORE_MODULE; }
});

const realModule = angular__default.module;
angular__default.module = function(name, requires, configFn) {
  if (requires && requires.some((dep) => !dep)) {
    const deps = requires.map((r) => typeof r === "string" ? `'${r}'` : `${r}`).join(", ");
    throw new Error(`Got falsey dependency whilst registering angular module '${name}': [${deps}]`);
  }
  return realModule(name, requires, configFn);
};

const defaultUser = {
  name: "[anonymous]",
  roles: [],
  authenticated: false
};
class AuthenticationService {
  static getAuthenticatedUser() {
    return { ...this.user };
  }
  static setAuthenticatedUser(authenticatedUser) {
    if (authenticatedUser && authenticatedUser.name) {
      this.user.name = authenticatedUser.name;
      this.user.authenticated = true;
      this.user.lastAuthenticated = new Date().getTime();
      this.user.roles = authenticatedUser.roles;
    }
    this.authEvents.forEach((event) => event());
  }
  static onAuthentication(event) {
    this.authEvents.push(event);
  }
  static authenticationExpired() {
    this.user.authenticated = false;
  }
  static reset() {
    this.user = { ...defaultUser };
  }
}
AuthenticationService.user = { ...defaultUser };
AuthenticationService.authEvents = [];

class ReactModal {
  static show(ModalComponent, componentProps, modalProps) {
    const modalPromise = new Promise((resolve, reject) => {
      let mountNode = document.createElement("div");
      let show = true;
      function onExited() {
        if (!mountNode) {
          return;
        }
        ReactDOM__default.unmountComponentAtNode(mountNode);
        mountNode = null;
      }
      const destroy = (resultHandler) => (result) => {
        if (!mountNode) {
          return;
        }
        resultHandler(result);
        show = false;
        render();
      };
      const handleClose = destroy(resolve);
      const handleDismiss = destroy(reject);
      function render() {
        ReactDOM__default.render(/* @__PURE__ */ React__default.createElement(Modal$1, {
          show,
          ...modalProps,
          onExited
        }, /* @__PURE__ */ React__default.createElement(ModalComponent, {
          ...componentProps,
          dismissModal: handleDismiss,
          closeModal: handleClose
        })), mountNode);
      }
      render();
    });
    modalPromise.catch(() => {
    });
    return modalPromise;
  }
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2u = ".modal-logged-out {\n  text-align: center;\n  padding: 30px 60px !important;\n}\n.modal-logged-out h3 {\n  margin: 30px 0 !important;\n}\n.modal-logged-out p {\n  margin-bottom: 30px;\n}\n.modal-logged-out .fa-hourglass {\n  position: absolute;\n  display: block;\n  top: 95px;\n  left: 278px;\n  height: 0;\n  font-size: 62px;\n}\n";
styleInject(css_248z$2u);

class LoggedOutModal extends React__default.Component {
  static show() {
    return ReactModal.show(LoggedOutModal, {});
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
      className: "modal-logged-out"
    }, /* @__PURE__ */ React__default.createElement("svg", {
      width: "162px",
      height: "143px",
      viewBox: "0 0 162 143"
    }, /* @__PURE__ */ React__default.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /* @__PURE__ */ React__default.createElement("g", {
      transform: "translate(3.000000, 3.000000)"
    }, /* @__PURE__ */ React__default.createElement("polygon", {
      id: "Fill-1",
      fill: "#E8AE2F",
      points: "0 138 81 0 156 138"
    }), /* @__PURE__ */ React__default.createElement("polygon", {
      id: "Stroke-3",
      stroke: "#000000",
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      points: "0 138 81 0 156 138"
    })))), /* @__PURE__ */ React__default.createElement("i", {
      className: "far fa-hourglass"
    }), /* @__PURE__ */ React__default.createElement("h3", null, "You have been logged out."), /* @__PURE__ */ React__default.createElement("p", null, "Please click below or refresh your browser to log back in."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      onClick: () => window.location.reload()
    }, "Refresh and log me back in")));
  }
}

var _a$2, _b;
const SETTINGS = window.spinnakerSettings || {};
SETTINGS.feature = SETTINGS.feature || {};
SETTINGS.feature.roscoMode = (_a$2 = SETTINGS.feature.roscoMode) != null ? _a$2 : true;
SETTINGS.kubernetesAdHocInfraWritesEnabled = (_b = SETTINGS.kubernetesAdHocInfraWritesEnabled) != null ? _b : true;
SETTINGS.analytics = SETTINGS.analytics || {};
SETTINGS.providers = SETTINGS.providers || {};
SETTINGS.defaultTimeZone = SETTINGS.defaultTimeZone || "America/Los_Angeles";
SETTINGS.dockerInsights = SETTINGS.dockerInsights || { enabled: false, url: "" };
SETTINGS.changelogUrl = SETTINGS.changelogUrl || "https://spinnaker.io/changelogs/:version-changelog";
SETTINGS.managedDelivery = SETTINGS.managedDelivery || {
  defaultManifest: "spinnaker.yml",
  manifestBasePath: ".spinnaker"
};
const originalSettings = cloneDeep(SETTINGS);
SETTINGS.resetToOriginal = () => {
  Object.keys(SETTINGS).filter((k) => typeof SETTINGS[k] !== "function").forEach((k) => delete SETTINGS[k]);
  merge(SETTINGS, originalSettings);
};
SETTINGS.resetProvider = (provider) => {
  return () => {
    const providerSettings = SETTINGS.providers[provider];
    Object.keys(providerSettings).filter((k) => typeof providerSettings[k] !== "function").forEach((k) => delete providerSettings[k]);
    merge(providerSettings, originalSettings.providers[provider]);
  };
};

class ReactInject {
}
class CoreReactInject extends ReactInject {
  get $state() {
    if (!this.wrappedState) {
      this.wrappedState = this.createStateService();
    }
    return this.wrappedState;
  }
  get $q() {
    return this.$injector.get("$q");
  }
  get $rootScope() {
    return this.$injector.get("$rootScope");
  }
  get $stateParams() {
    return this.$injector.get("$stateParams");
  }
  get $uiRouter() {
    return this.$injector.get("$uiRouter");
  }
  get cacheInitializer() {
    return this.$injector.get("cacheInitializer");
  }
  get clusterService() {
    return this.$injector.get("clusterService");
  }
  get executionDetailsSectionService() {
    return this.$injector.get("executionDetailsSectionService");
  }
  get executionService() {
    return this.$injector.get("executionService");
  }
  get imageReader() {
    return this.$injector.get("imageReader");
  }
  get infrastructureSearchService() {
    return this.$injector.get("infrastructureSearchService");
  }
  get insightFilterStateModel() {
    return this.$injector.get("insightFilterStateModel");
  }
  get instanceTypeService() {
    return this.$injector.get("instanceTypeService");
  }
  get instanceWriter() {
    return this.$injector.get("instanceWriter");
  }
  get manualJudgmentService() {
    return this.$injector.get("manualJudgmentService");
  }
  get overrideRegistry() {
    return this.$injector.get("overrideRegistry");
  }
  get pageTitleService() {
    return this.$injector.get("pageTitleService");
  }
  get providerServiceDelegate() {
    return this.$injector.get("providerServiceDelegate");
  }
  get securityGroupReader() {
    return this.$injector.get("securityGroupReader");
  }
  get serverGroupWriter() {
    return this.$injector.get("serverGroupWriter");
  }
  get stateEvents() {
    return this.$injector.get("stateEvents");
  }
  createStateService() {
    const wrappedState = Object.create(this.$injector.get("$state"));
    const $rootScope = this.$injector.get("$rootScope");
    const $q = this.$injector.get("$q");
    const originalGo = wrappedState.go;
    wrappedState.go = function() {
      const args = arguments;
      const deferred = Object.create($q.defer());
      const { promise } = deferred;
      promise.transition = null;
      promise.catch(() => {
      });
      $rootScope.$applyAsync(() => {
        const originalPromise = originalGo.apply(this, args);
        promise.transition = originalPromise.transition;
        originalPromise.then(deferred.resolve, deferred.reject);
      });
      return promise;
    };
    return wrappedState;
  }
  initialize($injector) {
    this.$injector = $injector;
  }
}
const ReactInjector = new CoreReactInject();

class CoreModalInject extends ReactInject {
  get modalService() {
    return this.$injector.get("$uibModal");
  }
  get modalStackService() {
    return this.$injector.get("$uibModalStack");
  }
  initialize($injector) {
    this.$injector = $injector;
  }
}
const ModalInjector = new CoreModalInject();

class AuthenticationInitializer {
  static checkForReauthentication() {
    $http.get(SETTINGS.authEndpoint).then((response) => {
      if (response.data.username) {
        AuthenticationService.setAuthenticatedUser({
          name: response.data.username,
          authenticated: false,
          roles: response.data.roles
        });
        ModalInjector.modalStackService.dismissAll();
        this.visibilityWatch.unsubscribe();
      }
    }).catch(() => {
    });
  }
  static loginNotification() {
    AuthenticationService.authenticationExpired();
    this.userLoggedOut = true;
    this.openLoggedOutModal();
    this.visibilityWatch = fromEvent(document, "visibilitychange").subscribe(() => {
      if (document.visibilityState === "visible") {
        this.checkForReauthentication();
      }
    });
  }
  static openLoggedOutModal() {
    LoggedOutModal.show();
  }
  static loginRedirect() {
    const callback = encodeURIComponent($location.absUrl());
    window.location.href = `${SETTINGS.gateUrl}/auth/redirect?to=${callback}`;
  }
  static authenticateUser() {
    $rootScope.authenticating = true;
    $http.get(SETTINGS.authEndpoint).then((response) => {
      if (response.data.username) {
        AuthenticationService.setAuthenticatedUser({
          name: response.data.username,
          authenticated: false,
          roles: response.data.roles
        });
        $rootScope.authenticating = false;
      } else {
        this.loginRedirect();
      }
    }).catch(() => this.loginRedirect());
  }
  static reauthenticateUser() {
    if (!this.userLoggedOut) {
      this.userLoggedOut = true;
      $http.get(SETTINGS.authEndpoint).then((response) => {
        if (response.data.username) {
          AuthenticationService.setAuthenticatedUser({
            name: response.data.username,
            authenticated: false,
            roles: response.data.roles
          });
          $rootScope.authenticating = false;
          this.userLoggedOut = false;
        } else {
          this.loginNotification();
        }
      }).catch(() => this.loginNotification());
    }
  }
  static logOut() {
    if (!this.userLoggedOut) {
      const config = {
        headers: { "Content-Type": "text/plain" },
        transformResponse: (response) => response
      };
      $http.get(`${SETTINGS.gateUrl}/auth/logout`, config).then(() => this.loggedOutSequence(), () => this.loggedOutSequence());
    }
  }
  static loggedOutSequence() {
    AuthenticationService.authenticationExpired();
    this.userLoggedOut = true;
    this.openLoggedOutModal();
  }
}
AuthenticationInitializer.userLoggedOut = false;
AuthenticationInitializer.visibilityWatch = null;

class InvalidAPIResponse extends Error {
  constructor(message, originalResult) {
    super(message);
    this.originalResult = originalResult;
    this.data = { message };
  }
}
class AngularJSHttpClient {
  constructor() {
    this.delete = (requestConfig) => this.request("DELETE", requestConfig);
    this.get = (requestConfig) => this.request("GET", requestConfig);
    this.post = (requestConfig) => this.request("POST", requestConfig);
    this.put = (requestConfig) => this.request("PUT", requestConfig);
    this.patch = (requestConfig) => this.request("PATCH", requestConfig);
  }
  request(method, requestConfig) {
    return $http({ ...requestConfig, method }).then((response) => {
      const contentType = response.headers("content-type");
      if (contentType) {
        const isJson = contentType.match(/application\/(.+\+)?json/);
        const isYaml = contentType.match(/application\/(.+-)?yaml/);
        const isZeroLengthHtml = contentType.includes("text/html") && response.data === "";
        const isZeroLengthText = contentType.includes("text/plain") && response.data === "";
        if (!(isJson || isYaml || isZeroLengthHtml || isZeroLengthText)) {
          AuthenticationInitializer.reauthenticateUser();
          throw new InvalidAPIResponse(invalidContentMessage, response);
        }
      }
      return response.data;
    });
  }
}
function joinPaths(...paths) {
  return paths.filter((path) => !isNil(path) && path !== "").map((path) => path.toString()).map((path) => path.replace(/^\/+/, "")).map((path) => path.replace(/\/+$/, "")).join("/");
}
const _RequestBuilder = class {
  constructor(config = makeRequestBuilderConfig(), _httpClient, _baseUrl) {
    this.config = config;
    this._httpClient = _httpClient;
    this._baseUrl = _baseUrl;
  }
  builder(newRequest) {
    return new _RequestBuilder(newRequest, this.httpClient, this._baseUrl);
  }
  get httpClient() {
    var _a;
    return (_a = this._httpClient) != null ? _a : _RequestBuilder.defaultHttpClient;
  }
  get baseUrl() {
    var _a;
    return joinPaths((_a = this._baseUrl) != null ? _a : SETTINGS.gateUrl);
  }
  path(...paths) {
    const url = joinPaths(this.config.url, ...paths.map((path) => encodeURIComponent(path)));
    return this.builder({ ...this.config, url });
  }
  headers(headers) {
    return this.builder({ ...this.config, headers: { ...this.config.headers, ...headers } });
  }
  get(queryParams = {}) {
    const params = { ...this.config.params, ...queryParams };
    const url = joinPaths(this.baseUrl, this.config.url);
    return this.httpClient.get({ ...this.config, url, params });
  }
  post(postData) {
    const data = postData != null ? postData : this.config.data;
    const url = joinPaths(this.baseUrl, this.config.url);
    return this.httpClient.post({ ...this.config, url, data });
  }
  put(putData) {
    const data = putData != null ? putData : this.config.data;
    const url = joinPaths(this.baseUrl, this.config.url);
    return this.httpClient.put({ ...this.config, url, data });
  }
  patch(putData) {
    const data = putData != null ? putData : this.config.data;
    const url = joinPaths(this.baseUrl, this.config.url);
    return this.httpClient.patch({ ...this.config, url, data });
  }
  delete(deleteData) {
    const data = deleteData != null ? deleteData : this.config.data;
    const url = joinPaths(this.baseUrl, this.config.url);
    return this.httpClient.delete({ ...this.config, url, data });
  }
  useCache(cache = true) {
    return this.builder({ ...this.config, cache });
  }
  query(queryParams) {
    const params = { ...this.config.params, ...queryParams };
    return this.builder({ ...this.config, params });
  }
};
let RequestBuilder = _RequestBuilder;
RequestBuilder.defaultHttpClient = new AngularJSHttpClient();
class DeprecatedRequestBuilder extends RequestBuilder {
  constructor() {
    super(...arguments);
    this.builder = (newRequest) => {
      return new DeprecatedRequestBuilder(newRequest, this._httpClient, this._baseUrl);
    };
    this.getList = this.get.bind(this);
    this.one = this.path.bind(this);
    this.all = this.path.bind(this);
    this.remove = this.delete.bind(this).bind(this);
    this.data = (data) => this.builder({ ...this.config, data });
    this.withParams = this.query.bind(this);
    this.useCache = (cache = true) => this.builder({ ...this.config, cache });
  }
  get baseUrl() {
    return super.baseUrl;
  }
}
class DeprecatedRequestBuilderRoot extends DeprecatedRequestBuilder {
  constructor() {
    super(...arguments);
    this.one = (...paths) => {
      const url = joinPaths(this.config.url, ...paths);
      return this.builder({ ...this.config, url });
    };
    this.all = (...paths) => {
      const url = joinPaths(this.config.url, ...paths);
      return this.builder({ ...this.config, url });
    };
  }
}
const invalidContentMessage = "API response was neither JSON nor zero-length html or text";
function makeRequestBuilderConfig(pathPrefix) {
  return {
    url: joinPaths(pathPrefix),
    cache: false,
    data: void 0,
    params: {},
    timeout: (SETTINGS.apiTimeoutMs || SETTINGS.pollSchedule || 3e4) * 2 + 5e3,
    headers: { "X-RateLimit-App": "deck" }
  };
}
const API = new DeprecatedRequestBuilderRoot(makeRequestBuilderConfig());
const REST = (staticPathPrefix) => {
  return new RequestBuilder(makeRequestBuilderConfig(staticPathPrefix));
};

const _CloudProviderRegistry = class {
  static registerProvider(cloudProvider, config) {
    if (SETTINGS.providers[cloudProvider]) {
      this.providers.set(cloudProvider, config);
    }
  }
  static getProvider(cloudProvider) {
    return this.providers.has(cloudProvider) ? cloneDeep(this.providers.get(cloudProvider)) : null;
  }
  static listRegisteredProviders() {
    return Array.from(this.providers.keys());
  }
  static overrideValue(cloudProvider, key, overrideValue) {
    if (!this.providers.has(cloudProvider)) {
      console.warn(`Cannot override "${key}" for provider "${cloudProvider}" (provider not registered)`);
      return;
    }
    set(this.providers.get(cloudProvider), key, overrideValue);
  }
  static hasValue(cloudProvider, key) {
    return this.providers.has(cloudProvider) && this.getValue(cloudProvider, key) !== null;
  }
  static getValue(cloudProvider, key) {
    var _a;
    return (_a = get(this.getProvider(cloudProvider), key)) != null ? _a : null;
  }
  static isDisabled(cloudProvider) {
    if (isNil(_CloudProviderRegistry.getValue(cloudProvider, "adHocInfrastructureWritesEnabled"))) {
      return false;
    }
    return _CloudProviderRegistry.getValue(cloudProvider, "adHocInfrastructureWritesEnabled") === false;
  }
};
let CloudProviderRegistry = _CloudProviderRegistry;
CloudProviderRegistry.providers = new Map();

class AccountService {
  static initialize() {
    this.accounts$ = defer(() => {
      const promise = REST("/credentials").useCache().query({ expand: true }).get();
      return from(promise);
    }).pipe(publishReplay(1), refCount());
    this.providers$ = AccountService.accounts$.pipe(map((accounts) => {
      const providersFromAccounts = uniq(accounts.map((account) => account.type));
      return intersection(providersFromAccounts, CloudProviderRegistry.listRegisteredProviders());
    }));
  }
  static challengeDestructiveActions(account) {
    return $q((resolve) => {
      if (account) {
        this.getAccountDetails(account).then((details) => {
          if (details) {
            resolve(details.challengeDestructiveActions);
          } else {
            resolve(false);
          }
        }).catch(() => resolve(false));
      } else {
        resolve(false);
      }
    });
  }
  static getArtifactAccounts() {
    return REST("/artifacts/credentials").useCache().get();
  }
  static getAccountDetails(account) {
    return this.listAllAccounts().then((accounts) => accounts.find((a) => a.name === account));
  }
  static getAllAccountDetailsForProvider(provider) {
    return this.listAccounts(provider).catch((error) => {
      $log.warn(`Failed to load accounts for provider "${provider}"; exception:`, error);
      return [];
    });
  }
  static getAvailabilityZonesForAccountAndRegion(provider, account, region) {
    return this.getPreferredZonesByAccount(provider).then((result) => result[account] && result[account][region] || []);
  }
  static getCredentialsKeyedByAccount(provider = null) {
    return this.listAllAccounts(provider).then((accounts) => {
      const names = accounts.map((account) => account.name);
      return zipObject(names, accounts);
    });
  }
  static getPreferredZonesByAccount(provider) {
    const preferred = {};
    return this.getAllAccountDetailsForProvider(provider).then((accounts) => {
      accounts.forEach((account) => {
        preferred[account.name] = {};
        account.regions.forEach((region) => {
          let zones = region.availabilityZones;
          if (region.preferredZones) {
            zones = intersection(region.preferredZones, region.availabilityZones);
          }
          preferred[account.name][region.name] = zones;
        });
      });
      return preferred;
    });
  }
  static getRegionsForAccount(account) {
    return this.getAccountDetails(account).then((details) => details ? details.regions : []);
  }
  static getUniqueAttributeForAllAccounts(provider, attribute) {
    return this.getCredentialsKeyedByAccount(provider).then((credentials) => {
      return chain(credentials).map(attribute).flatten().compact().map((region) => region.name || region).uniq().value();
    });
  }
  static listAllAccounts(provider = null) {
    return $q.when(this.accounts$.toPromise()).then((accounts) => accounts.filter((account) => !provider || account.type === provider));
  }
  static listAccounts(provider = null) {
    return this.listAllAccounts(provider).then((accounts) => accounts.filter((account) => account.authorized !== false));
  }
  static applicationAccounts(application = null) {
    return $q.all([this.listProviders(application), this.listAccounts()]).then(([providers, accounts]) => {
      return providers.reduce((memo, p) => {
        return memo.concat(accounts.filter((acc) => acc.cloudProvider === p));
      }, []);
    });
  }
  static listProviders$(application = null) {
    return this.providers$.pipe(map((available) => {
      if (!application) {
        return available;
      } else if (application.attributes.cloudProviders.length) {
        return intersection(available, application.attributes.cloudProviders);
      } else if (SETTINGS.defaultProviders) {
        return intersection(available, SETTINGS.defaultProviders);
      } else {
        return available;
      }
    }), map((results) => results.sort()));
  }
  static listProviders(application = null) {
    return $q.when(this.listProviders$(application).toPromise());
  }
  static getAccountForInstance(cloudProvider, instanceId, app) {
    return app.ready().then(() => {
      const serverGroups = app.getDataSource("serverGroups").data;
      const loadBalancers = app.getDataSource("loadBalancers").data;
      const loadBalancerServerGroups = loadBalancers.map((lb) => lb.serverGroups).reduce((acc, sg) => acc.concat(sg), []);
      const hasInstance = (obj) => {
        return obj.cloudProvider === cloudProvider && (obj.instances || []).some((instance) => instance.id === instanceId);
      };
      const all = [].concat(serverGroups).concat(loadBalancers).concat(loadBalancerServerGroups);
      const found = all.find(hasInstance);
      return found && found.account;
    });
  }
}
AccountService.initialize();

const makeOptions = (options) => {
  options = options || [];
  return options.map((str) => ({ label: str, value: str }));
};
class StringsAsOptions extends React__default.Component {
  constructor() {
    super(...arguments);
    this.memoizedMakeOptions = memoizeOne(makeOptions, isEqual);
  }
  render() {
    const options = this.memoizedMakeOptions(this.props.strings);
    const render = this.props.render || this.props.children;
    return render(options);
  }
}

class TetheredSelect extends Select {
  constructor(props) {
    super(props);
    this.renderOuter = this._renderOuter;
  }
  _renderOuter() {
    const menu = super.renderOuter.apply(this, arguments);
    if (!menu) {
      return null;
    }
    const selectWidth = this.wrapper ? this.wrapper.offsetWidth : null;
    return /* @__PURE__ */ React__default.createElement(TetherComponent, {
      classes: { element: "layer-critical" },
      attachment: "top left",
      targetAttachment: "top left",
      constraints: [{ to: "window", attachment: "together", pin: ["top"] }]
    }, /* @__PURE__ */ React__default.createElement("div", null), React__default.cloneElement(menu, { style: { position: "static", width: selectWidth } }));
  }
}

const RenderWhenVisible = ({
  bufferHeight = 0,
  initiallyVisible,
  placeholderHeight,
  render,
  container,
  disableHide
}) => {
  const [isVisible, setIsVisible] = React__default.useState(!!initiallyVisible);
  const [height, setHeight] = React__default.useState(placeholderHeight);
  let observer;
  const nodeRef = React__default.useRef();
  React__default.useEffect(() => {
    let visible = isVisible;
    observer = new IntersectionObserver((entries) => {
      const inView = entries[0].isIntersecting;
      if (inView && !visible) {
        visible = true;
        setIsVisible(true);
      }
      if (!inView && visible && !disableHide) {
        visible = false;
        setHeight(entries[0].boundingClientRect.height);
        setIsVisible(false);
      }
    }, {
      root: container,
      threshold: [0],
      rootMargin: bufferHeight && container ? `${bufferHeight}px 0px` : "0px"
    });
    observer.observe(nodeRef.current);
    return () => {
      observer.disconnect();
    };
  }, []);
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: nodeRef,
    className: "render-when-visible"
  }, isVisible && render(), !isVisible && /* @__PURE__ */ React__default.createElement("div", {
    style: { height: height + "px" }
  }));
};

const LEVELS = {
  DEBUG: 1,
  INFO: 2,
  WARN: 3,
  ERROR: 4
};
const getLevel = (level) => {
  return LEVELS[level || "INFO"];
};
class Logger {
  constructor() {
    this.loggers = [];
    this.ignoredErrors = [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications."
    ];
  }
  subscribe(newLogger) {
    this.loggers.push(newLogger);
    return () => this.loggers.filter((logger2) => logger2 !== newLogger);
  }
  unsubscribe(key) {
    this.loggers.filter((logger2) => logger2.key !== key);
  }
  log(event) {
    var _a;
    if (((_a = event.error) == null ? void 0 : _a.message) && this.ignoredErrors.includes(event.error.message))
      return;
    this.loggers.forEach((logger2) => {
      if (getLevel(event.level) >= getLevel(logger2.level)) {
        logger2.onEvent(event);
      }
    });
  }
}
const logger = new Logger();

var css_248z$2t = ".clipboard-btn {\n  background-color: transparent !important;\n  border-width: 0 !important;\n  color: var(--color-dovegray) !important;\n  display: inline-block !important;\n  margin-left: 2px !important;\n}\n.clipboard-btn:hover {\n  background-color: transparent;\n}\n.copy-to-clipboard-sm .clipboard-btn {\n  margin-bottom: 3px;\n}\n";
styleInject(css_248z$2t);

class CopyToClipboard extends React__default.Component {
  constructor(props) {
    super(props);
    this.inputRef = React__default.createRef();
    this.mounted = false;
    this.handleClick = (e) => {
      e.preventDefault();
      if (this.props.stopPropagation) {
        e.stopPropagation();
      }
      const { analyticsLabel, text } = this.props;
      logger.log({
        category: "Copy to Clipboard",
        action: "copy",
        data: { label: analyticsLabel || text }
      });
      const node = this.inputRef.current;
      node.focus();
      node.select();
      const copiedText = "Copied!";
      try {
        document.execCommand("copy");
        node.blur();
        this.setState({ tooltipCopy: copiedText, shouldUpdatePosition: true });
        window.setTimeout(this.resetToolTip, 3e3);
      } catch (e2) {
        node.blur();
        this.setState({ tooltipCopy: "Couldn't copy!", shouldUpdatePosition: true });
      }
    };
    this.resetToolTip = () => {
      this.mounted && this.setState({ tooltipCopy: false, shouldUpdatePosition: true });
    };
    this.state = {
      tooltipCopy: false,
      shouldUpdatePosition: false
    };
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  renderTooltip(children) {
    const { toolTip, text = "" } = this.props;
    const { tooltipCopy, shouldUpdatePosition } = this.state;
    const persistOverlay = Boolean(tooltipCopy);
    const copy = tooltipCopy || toolTip;
    const id = `clipboardValue-${text.toString().replace(" ", "-")}`;
    const tooltipComponent = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
      id
    }, copy);
    const otherProps = {
      shouldUpdatePosition
    };
    if (!copy) {
      return children;
    }
    return /* @__PURE__ */ React__default.createElement(OverlayTrigger, {
      defaultOverlayShown: persistOverlay,
      placement: "top",
      overlay: tooltipComponent,
      delayHide: 250,
      ...otherProps
    }, children);
  }
  render() {
    const { buttonInnerNode, text = "", className = "btn btn-xs btn-default clipboard-btn" } = this.props;
    const copyButton = /* @__PURE__ */ React__default.createElement("button", {
      onClick: this.handleClick,
      className,
      "aria-label": "Copy to clipboard"
    }, buttonInnerNode ? buttonInnerNode : /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-copy"
    }));
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("textarea", {
      onChange: (e) => e,
      ref: this.inputRef,
      value: text,
      tabIndex: -1,
      style: { zIndex: -1, position: "fixed", opacity: 0, top: 0, left: 0 }
    }), this.renderTooltip(copyButton));
  }
}
CopyToClipboard.defaultProps = {
  displayText: false
};

const now = performance ? performance.now.bind(performance) : Date.now.bind(Date);
const log = console.log.bind(console);
const getMethodName = (target, propertyKey) => {
  if (typeof target === "object" && target.constructor && target.constructor.name) {
    return `${target.constructor.name}.${propertyKey}():`;
  }
  return `${propertyKey}():`;
};
const DebugTiming = (label) => (target, propertyKey, descriptor) => {
  const fn = descriptor.value;
  label = padStart(label ? label : getMethodName(target, propertyKey), 50);
  descriptor.value = function() {
    const start = now();
    const result = fn.apply(this, arguments);
    const delta = now() - start;
    log(`${label} ${delta} ms`);
    return result;
  };
};
const DebugTimingCumulative = (label, logInterval = 5e3) => (target, propertyKey, descriptor) => {
  const fn = descriptor.value;
  let count = 0;
  label = padStart(label ? label : getMethodName(target, propertyKey), 50);
  let cumulativeTime = 0;
  setInterval(() => log(`${label} ${padStart("" + count, 10)} calls in ${cumulativeTime} ms`), logInterval);
  descriptor.value = function() {
    count++;
    const start = now();
    const result = fn.apply(this, arguments);
    cumulativeTime += now() - start;
    return result;
  };
};

function firstDefined(...values) {
  return values.find((val) => !isNil(val));
}

class JsonUtils {
  static generateDiff(left, right) {
    const dmp = new DiffMatchPatch();
    const a = dmp.diff_linesToChars_(left, right);
    const diffs = dmp.diff_main(a.chars1, a.chars2, false);
    dmp.diff_charsToLines_(diffs, a.lineArray);
    return diffs;
  }
  static sortObject(o) {
    if (!o || isNumber$1(o) || isString(o)) {
      return o;
    }
    return Object.keys(o).sort().reduce((r, k) => {
      if (isPlainObject(o[k])) {
        r[k] = this.sortObject(o[k]);
      } else if (isArray(o[k])) {
        r[k] = o[k].map((o2) => this.sortObject(o2));
      } else {
        r[k] = o[k];
      }
      return r;
    }, {});
  }
  static makeSortedString(str) {
    return this.makeSortedStringFromObject(JSON.parse(str));
  }
  static makeSortedStringFromObject(obj) {
    return this.makeStringFromObject(this.sortObject(obj));
  }
  static makeStringFromObject(obj, space = 2) {
    return JSON.stringify(obj, null, space);
  }
  static makeSortedStringFromAngularObject(obj, omit = []) {
    const replacer = (key, value) => {
      let val = value;
      if (typeof key === "string" && key.charAt(0) === "$" && key.charAt(1) === "$") {
        val = void 0;
      }
      if (omit.includes(key)) {
        val = void 0;
      }
      return val;
    };
    return JSON.stringify(this.sortObject(obj), replacer);
  }
  static diff(left, right, sortKeys = false) {
    if (sortKeys) {
      left = this.makeSortedString(left);
      right = this.makeSortedString(right);
    }
    const diffs = this.generateDiff(left, right);
    const diffLines = [];
    let additions = 0;
    let removals = 0;
    let unchanged = 0;
    let total = 0;
    const changeBlocks = [];
    diffs.forEach((diff) => {
      const lines = diff[1].split("\n");
      if (lines[lines.length - 1] === "") {
        lines.pop();
      }
      let type = "match";
      if (diff[0] === 1) {
        type = "add";
        additions += lines.length;
        changeBlocks.push({ type, lines: lines.length, start: total, height: null, top: null });
      }
      if (diff[0] === -1) {
        type = "remove";
        removals += lines.length;
        changeBlocks.push({ type, lines: lines.length, start: total, height: null, top: null });
      }
      if (diff[0] === 0) {
        unchanged += lines.length;
      }
      lines.forEach((l) => diffLines.push({ type, text: l }));
      total += lines.length;
    });
    changeBlocks.forEach((b) => {
      b.height = b.lines * 100 / total;
      b.top = b.start * 100 / total;
    });
    return {
      details: diffLines,
      summary: { additions, removals, unchanged, total },
      changeBlocks
    };
  }
}

var css_248z$2s = ".diff-view {\n  width: 100%;\n  display: block;\n  position: relative;\n}\n.diff-view .diff {\n  color: var(--color-black);\n  font-size: 80%;\n  overflow-x: visible;\n  margin: 0;\n  padding-bottom: 0;\n}\n.diff-view .diff .match,\n.diff-view .diff .add,\n.diff-view .diff .remove {\n  font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n.diff-view .diff .match::before,\n.diff-view .diff .add::before,\n.diff-view .diff .remove::before {\n  position: relative;\n  left: 0;\n}\n.diff-view .diff .match {\n  color: var(--color-dovegray);\n}\n.diff-view .diff .match::before {\n  content: ' ';\n}\n.diff-view .diff .add {\n  background-color: var(--color-github-history-add);\n}\n.diff-view .diff .add::before {\n  content: '+';\n}\n.diff-view .diff .remove {\n  background-color: var(--color-github-history-remove);\n}\n.diff-view .diff .remove::before {\n  content: '-';\n}\n.diff-view .diff .form-group {\n  margin-bottom: 0;\n}\n.diff-view .diff::-webkit-scrollbar {\n  height: 8px;\n}\n.diff-view .summary-nav {\n  cursor: pointer;\n  z-index: 2;\n  width: 12px;\n  position: absolute;\n  top: 0;\n  right: 7px;\n  height: calc(100% - 8px);\n}\n.diff-view .summary-nav .delta {\n  width: 100%;\n  position: absolute;\n  min-height: 3px;\n}\n.diff-view .summary-nav .delta.add {\n  background: var(--color-success);\n}\n.diff-view .summary-nav .delta.remove {\n  background: var(--color-danger);\n}\n";
styleInject(css_248z$2s);

function DiffView(props) {
  const { diff } = props;
  const preRef = React__default.useRef();
  function scrollBody(e) {
    var _a;
    let line;
    const target = e.target;
    const currentTarget = e.currentTarget;
    const lineHeight = preRef.current.firstChild.clientHeight;
    if (target.getAttribute("data-attr-block-line")) {
      line = Number(target.getAttribute("data-attr-block-line"));
    } else {
      line = ((_a = e.nativeEvent) == null ? void 0 : _a.offsetY) / currentTarget.clientHeight * diff.summary.total;
    }
    preRef.current.scroll({ top: (line - 3) * lineHeight, behavior: "smooth" });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("pre", {
    ref: preRef,
    className: "form-control flex-fill diff"
  }, diff.details.map((line, index) => {
    return /* @__PURE__ */ React__default.createElement("div", {
      "data-attr-line": index,
      className: line.type,
      key: index
    }, line.text);
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "summary-nav flex-fill",
    onClick: scrollBody
  }, diff.changeBlocks.map((block, index) => {
    return /* @__PURE__ */ React__default.createElement("div", {
      "data-attr-block-line": block.start,
      key: index,
      style: { height: block.height + "%", top: block.top + "%" },
      className: "delta " + block.type
    });
  })));
}

const traverseObject = (object, callback, traverseLeafNodesOnly = false) => {
  return _traverseObject(null, object, callback, traverseLeafNodesOnly);
};
function constructPath(parent, child) {
  const childSegment = isNumber$1(child) ? `[${child}]` : child.includes(".") ? `["${child}"]` : child;
  const useArraySyntax = childSegment.includes("[");
  const parentSegment = !parent ? "" : useArraySyntax ? parent : `${parent}.`;
  if (useArraySyntax && !parentSegment) {
    throw new Error(`Cannot construct path from '${childSegment}' using array syntax because the parent path is undefined.`);
  }
  return `${parentSegment}${childSegment}`;
}
const _traverseObject = (contextPath, obj, callback, traverseLeafNodesOnly) => {
  function maybeInvokeCallback(isLeafNode) {
    if (contextPath !== null && (isLeafNode || !traverseLeafNodesOnly)) {
      callback(contextPath, obj);
    }
  }
  if (isNull(obj) || isUndefined(obj)) {
    maybeInvokeCallback(true);
    return;
  } else if (isPlainObject(obj)) {
    maybeInvokeCallback(false);
    forIn(obj, (val, key) => _traverseObject(constructPath(contextPath, key), val, callback, traverseLeafNodesOnly));
  } else if (Array.isArray(obj)) {
    maybeInvokeCallback(false);
    obj.forEach((val, idx) => _traverseObject(constructPath(contextPath, idx), val, callback, traverseLeafNodesOnly));
  } else {
    maybeInvokeCallback(true);
  }
};

function noopFn() {
}
const noop = noopFn;

function toIPromise(source) {
  return $q((resolve, reject) => {
    let value;
    source.subscribe((x) => value = x, (err) => reject(err), () => resolve(value));
  });
}

class RenderIfFeatureController {
  constructor() {
    this.featureEnabled = false;
  }
  $onInit() {
    this.featureEnabled = this.feature && SETTINGS.feature[this.feature];
  }
}
const renderIfFeatureComponent = {
  bindings: { feature: "@" },
  controller: RenderIfFeatureController,
  transclude: true,
  template: `<ng-transclude ng-if="$ctrl.featureEnabled"></ng-transclude>`
};
const RENDER_IF_FEATURE = "spinnaker.core.renderIfFeature.directive";
module(RENDER_IF_FEATURE, []).component("renderIfFeature", renderIfFeatureComponent);

class ScrollToService {
  static toDomId(id) {
    return id.replace(/[\W]/g, "-");
  }
  static scrollTo(selector, scrollableContainer, offset = 0, delay = 0) {
    $timeout(() => {
      const elem = $$1(selector);
      if (elem.length) {
        const content = scrollableContainer ? elem.closest(scrollableContainer) : $$1("body");
        if (content.length) {
          const top = content.scrollTop() + elem.offset().top - offset;
          content.animate({ scrollTop: top + "px" }, 200);
        }
      }
    }, delay);
  }
}

const SystemTimezone = () => {
  const zone = SETTINGS.defaultTimeZone;
  const time = DateTime.local().setZone(zone);
  return /* @__PURE__ */ React__default.createElement("span", null, time.offsetNameShort);
};

const MAX_VALID_INPUT = 864e13;
const isInputValid = (input) => !(!input || isNaN(input) || input < 0 || input > MAX_VALID_INPUT);
function duration(input) {
  if (!isInputValid(input)) {
    return "-";
  }
  const baseDuration = Duration.fromMillis(input);
  const days = Math.floor(baseDuration.as("days"));
  const thisDuration = baseDuration.minus({ days: Math.floor(baseDuration.as("days")) });
  const format = thisDuration.days || Math.floor(thisDuration.as("hours")) ? "hh:mm:ss" : "mm:ss";
  let dayLabel = "";
  if (thisDuration.isValid) {
    if (days > 0) {
      dayLabel = days + "d";
    }
  }
  return thisDuration.isValid ? dayLabel + thisDuration.toFormat(format) : "-";
}
function timeDiffToString(startTime, endTime) {
  const duration2 = endTime.diff(startTime).shiftTo("days", "hours", "minutes", "seconds");
  const formatStrings = [];
  let forcePush = false;
  const addUnits = (unit, unitFormat) => {
    if (duration2[unit] || forcePush) {
      formatStrings.push(unitFormat);
      forcePush = true;
    }
  };
  addUnits("days", `d'd'`);
  addUnits("hours", `h'h'`);
  addUnits("minutes", `m'm'`);
  formatStrings.push(`s's'`);
  return duration2.toFormat(formatStrings.join(" "));
}
function timestamp(input) {
  if (!isInputValid(input)) {
    return "-";
  }
  const tz = SETTINGS.feature.displayTimestampsInUserLocalTime ? void 0 : SETTINGS.defaultTimeZone;
  const thisMoment = DateTime.fromMillis(parseInt(input, 10), { zone: tz });
  return thisMoment.isValid ? thisMoment.toFormat("yyyy-MM-dd HH:mm:ss ZZZZ") : "-";
}
function relativeTime(input) {
  if (!isInputValid(input)) {
    return "-";
  }
  const now = Date.now();
  const inFuture = input > now;
  const thisMoment = DateTime.fromMillis(input);
  const baseText = formatDistanceToNow(thisMoment.toJSDate(), { includeSeconds: true });
  return thisMoment.isValid ? `${inFuture ? "in " : ""}${baseText}${inFuture ? "" : " ago"}` : "-";
}
function timePickerTime(input) {
  if (input && !isNaN(input.hours) && !isNaN(input.minutes)) {
    const hours = parseInt(input.hours, 10);
    const minutes = parseInt(input.minutes, 10);
    let result = "";
    if (hours < 10) {
      result += "0";
    }
    result += hours + ":";
    if (minutes < 10) {
      result += "0";
    }
    result += minutes;
    return result;
  }
  return "-";
}
const TIME_FORMATTERS = "spinnaker.core.utils.timeFormatters";
module(TIME_FORMATTERS, []).filter("timestamp", () => timestamp).filter("relativeTime", () => relativeTime).filter("duration", () => duration).filter("timePickerTime", () => timePickerTime).component("systemTimezone", react2angular(SystemTimezone));

const decodeUnicodeBase64 = (encodedString) => decodeURIComponent(atob(encodedString).split("").map((char) => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2)).join(""));

class UUIDGenerator {
  static getRandom(max) {
    return Math.random() * max;
  }
  static generateUuid() {
    let uuid = "";
    for (let i = 0; i < 36; i++) {
      switch (i) {
        case 14:
          uuid += "4";
          break;
        case 19:
          uuid += "89ab".charAt(UUIDGenerator.getRandom(4));
          break;
        case 8:
        case 13:
        case 18:
        case 23:
          uuid += "-";
          break;
        default:
          uuid += "0123456789abcdef".charAt(UUIDGenerator.getRandom(16));
      }
    }
    return uuid;
  }
}

class Worker {
  constructor(task) {
    this.task = task;
    this.workerPromise = new Promise((resolve, reject) => Object.assign(this, { resolve, reject }));
  }
  run() {
    const taskPromise = this.task();
    taskPromise.then(this.resolve, this.reject);
    return taskPromise;
  }
  cancel(reason) {
    this.reject(isUndefined(reason) ? "Cancelled" : reason);
  }
}
class WorkerPool {
  constructor(concurrency) {
    this.concurrency = concurrency;
    this.queuedTasks = [];
    this.runningTasks = [];
  }
  task(task) {
    const worker = new Worker(task);
    this.queuedTasks.push(worker);
    this.flush();
    return worker.workerPromise;
  }
  cancelAll(reason) {
    [].concat(this.runningTasks).concat(this.queuedTasks).forEach((task) => task.cancel(reason));
    this.runningTasks = [];
    this.queuedTasks = [];
  }
  flush() {
    const { queuedTasks, runningTasks } = this;
    if (queuedTasks.length && runningTasks.length < this.concurrency) {
      this.runTask(queuedTasks.shift());
    }
  }
  completeTask(worker) {
    this.runningTasks = without(this.runningTasks, worker);
    this.flush();
  }
  runTask(worker) {
    this.runningTasks.push(worker);
    const done = () => this.completeTask(worker);
    worker.run().then(done, done);
  }
}

function filterObjectValues(object, predicate, options = {
  leafNodesOnly: true
}) {
  const result = {};
  traverseObject(object, (path, value) => {
    if (predicate(value, path)) {
      set(result, path, value);
    }
  }, options.leafNodesOnly);
  return result;
}

const orEmptyString = (val) => isNil(val) ? "" : val;
const validationClassName = (validation = {}) => {
  return classNames({
    "ng-dirty": !!validation.touched,
    "ng-invalid": validation.category === "error",
    "ng-warning": validation.category === "warning"
  });
};
const createFakeReactSyntheticEvent = (target) => ({
  persist: noop,
  stopPropagation: noop,
  preventDefault: noop,
  target
});
const isStringArray = (opts) => opts && opts.length && opts.every(isString);

class FormValidatorField {
  constructor(name, label) {
    this.name = name;
    this.label = label;
    this.validators = [];
  }
  required(message) {
    this.isRequired = true;
    this.isRequiredMessage = message;
    return this;
  }
  optional() {
    this.isRequired = false;
    this.isRequiredMessage = void 0;
    return this;
  }
  spelAware(isSpelAware = true) {
    this.isSpelAware = isSpelAware;
    return this;
  }
  withValidators(...validators) {
    this.validators = this.validators.concat(validators);
    return this;
  }
}

const FORM_VALIDATION_VALIDATABLE_FIELD_IS_VALID_SHORT_CIRCUIT = "__FIELD_IS_VALID_SHORT_CIRCUIT__";
const composeValidators = (validators) => {
  const validatorList = validators.filter((x) => !!x);
  if (!validatorList.length) {
    return null;
  } else if (validatorList.length === 1) {
    return validatorList[0];
  }
  const composedValidators = (value, label) => {
    const results = validatorList.map((validator) => validator(value, label));
    return results.find((error) => !!error);
  };
  return composedValidators;
};

function robotToHuman(input) {
  if (!input) {
    return "";
  }
  let formattedInput = input.charAt(0).toUpperCase() + input.substr(1);
  if (/\s/g.test(formattedInput)) {
    return formattedInput;
  }
  formattedInput = formattedInput.replace(/[A-Z]/g, " $&");
  formattedInput = formattedInput.replace(/_[a-z]/g, function(str) {
    return " " + str.charAt(1).toUpperCase() + str.substr(2);
  });
  formattedInput = formattedInput.replace(/-[a-z]/g, function(str) {
    return " " + str.charAt(1).toUpperCase() + str.substr(2);
  });
  formattedInput = formattedInput.replace(/([A-Z])\s([A-Z])\s/g, "$1$2");
  return formattedInput;
}
function robotToHumanFilter() {
  return robotToHuman;
}
const ROBOT_TO_HUMAN_FILTER = "spinnaker.core.presentation.robotToHuman.filter";
module(ROBOT_TO_HUMAN_FILTER, []).filter("robotToHuman", robotToHumanFilter);

const THIS_FIELD = "This field";
const VALID_EMAIL_REGEX = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');
const emailValue = (message) => {
  return function emailValue2(val, label = THIS_FIELD) {
    message = message || `${label} is not a valid email address.`;
    return val && !VALID_EMAIL_REGEX.test(val) && message;
  };
};
const isRequired = (message) => {
  return function isRequired2(val, label = THIS_FIELD) {
    message = message || `${label} is required.`;
    return (val === void 0 || val === null || val === "") && message;
  };
};
const isNum = (message) => {
  return function isNum2(value) {
    return isNumber$1(value) ? null : message || "Must be a number";
  };
};
const minValue = (min, message) => {
  return function minValue2(val, label = THIS_FIELD) {
    if (!isNumber$1(val)) {
      return message || `${label} must be a number`;
    } else if (val < min) {
      const minText = min === 0 ? "cannot be negative" : `cannot be less than ${min}`;
      return message || `${label} ${minText}`;
    }
    return null;
  };
};
const maxValue = (max, message) => {
  return function maxValue2(val, label = THIS_FIELD) {
    if (!isNumber$1(val)) {
      return message || `${label} must be a number`;
    } else if (val > max) {
      const maxText = `cannot be greater than ${max}`;
      return message || `${label} ${maxText}`;
    }
    return null;
  };
};
const checkBetween = (fieldName, min, max) => {
  return function checkBetween2(value) {
    const sanitizedField = Number.parseInt(value, 10);
    if (!Number.isNaN(sanitizedField)) {
      const error = Validators.minValue(min)(sanitizedField, robotToHuman(fieldName)) || Validators.maxValue(max)(sanitizedField, robotToHuman(fieldName));
      return error;
    }
    return null;
  };
};
const oneOf = (list, message) => {
  return function oneOf2(val, label = THIS_FIELD) {
    list = list || [];
    message = message || `${label} must be one of (${list.join(", ")})`;
    return !list.includes(val) && message;
  };
};
const arrayNotEmpty = (message) => {
  return function arrayNotEmpty2(val, label = THIS_FIELD) {
    message = message || `${label} must contain at least one entry`;
    return val && val.length < 1 && message;
  };
};
const skipIfUndefined = (actualValidator) => {
  return function skipIfUndefined2(val, label = THIS_FIELD) {
    return val !== void 0 && actualValidator(val, label);
  };
};
const skipIfSpel = (actualValidator) => {
  return function skipIfSpel2(val, label = THIS_FIELD) {
    return typeof val === "string" && val.includes("${") ? void 0 : actualValidator(val, label);
  };
};
const valueUnique = (list, message) => {
  return function valueUnique2(val, label = THIS_FIELD) {
    list = list || [];
    message = message || `${label} must be not be included in (${list.join(", ")})`;
    return list.includes(val) && message;
  };
};
const isValidJson = (message) => {
  return function isValidJson2(val, label = "this field") {
    try {
      JSON.parse(val);
    } catch (parseError) {
      message = message || `${label} must be valid JSON: ${parseError.message}`;
      return message;
    }
    return void 0;
  };
};
const isValidXml = (message) => {
  return function isValidXml2(val, label = "this field") {
    const xmlDoc = new DOMParser().parseFromString(val, "text/xml");
    const elements = xmlDoc.getElementsByTagName("parsererror");
    if (elements && elements.length > 0) {
      message = message || `${label} must be valid XML`;
      return message;
    }
    return void 0;
  };
};
const Validators = {
  arrayNotEmpty,
  checkBetween,
  emailValue,
  isNum,
  isRequired,
  isValidJson,
  isValidXml,
  maxValue,
  minValue,
  oneOf,
  skipIfUndefined,
  skipIfSpel,
  valueUnique
};

const runValidators = (validators, value, label) => {
  return validators.reduce((result, next) => result ? result : next(value, label), "");
};
const expandErrors = (errors, isArray) => {
  return errors.reduce((acc, curr) => set(acc, curr.name, curr.error), isArray ? [] : {});
};
const isError = (maybeError) => {
  if (!maybeError) {
    return false;
  } else if (maybeError === FORM_VALIDATION_VALIDATABLE_FIELD_IS_VALID_SHORT_CIRCUIT) {
    return false;
  } else if (typeof maybeError === "string") {
    return true;
  } else if (Array.isArray(maybeError)) {
    return !!maybeError.length;
  } else if (typeof maybeError === "object") {
    return !!Object.keys(maybeError).length;
  }
  return !!maybeError;
};
const createItemBuilder = (arrayBuilder, index) => {
  return {
    item(itemLabel) {
      return arrayBuilder.field(`[${index}]`, itemLabel);
    },
    field(name, itemLabel) {
      return arrayBuilder.field(`[${index}].${name}`, itemLabel);
    },
    validateForm: arrayBuilder.validateForm,
    arrayForEach: arrayBuilder.arrayForEach
  };
};
const arrayForEach = (builder, iteratee) => {
  return (array, arrayLabel) => {
    if (!Array.isArray(array)) {
      return false;
    }
    const arrayBuilder = builder(array);
    array.forEach((item, index) => {
      const itemBuilder = createItemBuilder(arrayBuilder, index);
      iteratee && iteratee(itemBuilder, item, index, array, arrayLabel);
    });
    return arrayBuilder.validateForm();
  };
};
class FormValidator {
  constructor(values) {
    this.values = values;
    this.fields = [];
    this.isSpelAwareDefault = false;
  }
  field(name, label) {
    label = label || startCase(name);
    const field = new FormValidatorField(name, label);
    this.fields.push(field);
    return field;
  }
  spelAware(isSpelAware = true) {
    this.isSpelAwareDefault = isSpelAware;
    return this;
  }
  getFieldValidators(field, isSpelAwareDefault) {
    const isSpelAware = isBoolean(field.isSpelAware) ? field.isSpelAware : isSpelAwareDefault;
    const requiredValidator = field.isRequired ? Validators.isRequired(field.isRequiredMessage) : null;
    const optionalValidator = !field.isRequired ? isOptionalValidator() : null;
    const spelValidator = isSpelAware ? spelAwareValidator() : null;
    return [requiredValidator, optionalValidator, spelValidator, ...field.validators].filter((x) => !!x);
  }
  validateForm() {
    const results = this.fields.map((field) => {
      const { name, label } = field;
      const value = get(this.values, name);
      const fieldValidators = this.getFieldValidators(field, this.isSpelAwareDefault);
      const error = runValidators(fieldValidators, value, label);
      return { name, error };
    });
    const errors = results.filter((fieldResult) => isError(fieldResult.error));
    return expandErrors(errors, Array.isArray(this.values));
  }
  arrayForEach(iteratee) {
    return arrayForEach((values) => new FormValidator(values), iteratee);
  }
}
function isOptionalValidator() {
  return (value) => {
    const isValueMissing = value === void 0 || value === null || value === "";
    return isValueMissing ? FORM_VALIDATION_VALIDATABLE_FIELD_IS_VALID_SHORT_CIRCUIT : null;
  };
}
function spelAwareValidator() {
  return (value) => {
    const isSpelContent = typeof value === "string" && value.includes("${");
    return isSpelContent ? FORM_VALIDATION_VALIDATABLE_FIELD_IS_VALID_SHORT_CIRCUIT : null;
  };
}

var css_248z$2r = ".Markdown p {\n  margin: 0;\n}\n.Markdown p + p {\n  margin-top: 4px;\n}\nspan.Markdown p {\n  display: contents;\n}\n";
styleInject(css_248z$2r);

function Markdown(props) {
  const { message, tag: tagProp, className: classNameProp, trim, tag = "div", ...rest } = props;
  const parser = React__default.useMemo(() => new Parser(), []);
  const renderer = React__default.useMemo(() => new HtmlRenderer(), []);
  const className = `Markdown ${classNameProp || ""}`;
  if (message == null) {
    return null;
  }
  const parseable = trim ? message.trim() : message;
  const restProps = rest;
  const parsed = parser.parse(parseable.toString());
  const rendered = renderer.render(parsed);
  restProps.dangerouslySetInnerHTML = {
    __html: DOMPurify.sanitize(rendered, { ...props.options, RETURN_DOM_FRAGMENT: false, RETURN_DOM: false })
  };
  return React__default.createElement(tag, { ...restProps, className });
}
const toMarkdown = (message, options = {}, inline = false) => /* @__PURE__ */ React__default.createElement(Markdown, {
  message,
  tag: inline ? "span" : "div",
  options
});

var css_248z$2q = ".ValidationMessage {\n  min-height: 40px;\n  display: flex;\n  margin-bottom: 2px;\n}\n.ValidationMessage.errorMessage {\n  color: var(--color-validation-error);\n  background-color: var(--color-validation-error-light);\n}\n.ValidationMessage.infoMessage {\n  color: var(--color-validation-info);\n  background-color: var(--color-validation-info-light);\n}\n.ValidationMessage.previewMessage {\n  color: var(--color-validation-info);\n  background-color: var(--color-validation-info-light);\n}\n.ValidationMessage.successMessage {\n  color: var(--color-validation-success);\n  background-color: var(--color-validation-success-light);\n}\n.ValidationMessage.warningMessage {\n  color: var(--color-validation-black);\n  background-color: var(--color-validation-warning-light);\n}\n.ValidationMessage i {\n  flex: 0 0 40px;\n  height: 40px;\n  font-size: 24px;\n  padding: 7px;\n}\n.ValidationMessage .message {\n  margin: 8px 8px 8px 0;\n  align-self: center;\n}\n";
styleInject(css_248z$2q);

const containerClassNames = {
  async: "infoMessage",
  error: "errorMessage",
  info: "infoMessage",
  message: "infoMessage",
  success: "successMessage",
  warning: "warningMessage"
};
const iconClassNames = {
  async: "fa fa-spinner fa-spin",
  error: "fa fa-exclamation-circle",
  info: "fa fa-info-circle",
  message: "icon-view-1",
  success: "far fa-check-circle",
  warning: "fa icon-alert-triangle"
};
const ValidationMessage = (props) => {
  const { type, message, iconClassName, containerClassName } = props;
  const showIcon = iconClassName !== false;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: `ValidationMessage ${containerClassName || containerClassNames[type] || ""}`
  }, showIcon && /* @__PURE__ */ React__default.createElement("i", {
    className: iconClassName || iconClassNames[type] || ""
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "message"
  }, isString(message) ? /* @__PURE__ */ React__default.createElement(Markdown, {
    message
  }) : message));
};

const categoryLabels = {
  async: "Async",
  error: "Error",
  info: "Info",
  message: "Message",
  success: "Success",
  warning: "Warning"
};
const labels = values(categoryLabels);
const statusKeys = Object.keys(categoryLabels);
const inverseLabels = Object.keys(categoryLabels).reduce((acc, key) => ({ ...acc, [categoryLabels[key]]: key }), {});
const buildCategoryMessage = (type) => (message) => {
  return message ? `${categoryLabels[type]}: ${message}` : null;
};
const asyncMessage = buildCategoryMessage("async");
const errorMessage = buildCategoryMessage("error");
const infoMessage = buildCategoryMessage("info");
const messageMessage = buildCategoryMessage("message");
const successMessage = buildCategoryMessage("success");
const warningMessage = buildCategoryMessage("warning");
const validationMessageRegexp = new RegExp(`^(${labels.join("|")}): ((?:[\r
]|.)*)$`, "m");
const categorizeValidationMessage = (validationMessage) => {
  if (!validationMessage) {
    return [null, null];
  }
  const result = validationMessageRegexp.exec(validationMessage);
  if (!result) {
    return ["error", validationMessage];
  }
  const [label, message] = result.slice(1);
  const status = inverseLabels[label];
  return [status, message];
};
const categorizeValidationMessages = (errors) => {
  const categories = statusKeys.reduce((acc, status) => ({ ...acc, [status]: {} }), {});
  const storeMessageInCategory = (path, validationMessage) => {
    const [status, message] = categorizeValidationMessage(validationMessage);
    if (message) {
      set(categories[status], path, message);
    }
  };
  traverseObject(errors, storeMessageInCategory, true);
  return categories;
};

function useValidationData(validationMessage, touched) {
  return React__default.useMemo(() => {
    if (!validationMessage) {
      return { category: null, messageNode: null, hidden: true };
    }
    if (React__default.isValidElement(validationMessage)) {
      return { category: null, messageNode: validationMessage, hidden: false };
    } else if (isString(validationMessage)) {
      const [category, messageNode] = categorizeValidationMessage(validationMessage);
      const isErrorOrWarning = category === "error" || category === "warning";
      const hidden = !touched && isErrorOrWarning;
      return { category, messageNode, hidden };
    }
    return { category: null, messageNode: validationMessage, hidden: true };
  }, [validationMessage, touched]);
}

const reactSelectValidationErrorStyle = {
  borderColor: "var(--color-danger)",
  WebkitBoxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.075)",
  boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.075)"
};
const reactSelectOnChangeAdapter = (name, onChange) => {
  return (selection) => {
    const value = !selection ? null : Array.isArray(selection) ? selection.map((x) => x.value) : selection.value;
    const target = { name, value };
    const event = createFakeReactSyntheticEvent(target);
    return (onChange || noop)(event);
  };
};
const reactSelectOnBlurAdapter = (name, value, onBlur) => {
  return () => {
    const target = { name, value };
    const event = createFakeReactSyntheticEvent(target);
    return (onBlur || noop)(event);
  };
};
function ReactSelectInput(props) {
  const {
    name,
    onChange,
    onBlur,
    value,
    validation = {},
    stringOptions,
    options: optionOptions,
    ignoreAccents: accents,
    inputClassName,
    ...otherProps
  } = props;
  const ignoreAccents = isNil(accents) ? false : accents;
  const mode = props.mode || "TETHERED";
  const className = orEmptyString(inputClassName);
  const { category } = useValidationData(validation.messageNode, validation.touched);
  const style = category === "error" ? reactSelectValidationErrorStyle : {};
  const fieldValue = props.multi ? isNil(value) ? [] : value : orEmptyString(value);
  const fieldProps = {
    name,
    value: fieldValue,
    onBlur: reactSelectOnBlurAdapter(name, value, onBlur),
    onChange: reactSelectOnChangeAdapter(name, onChange)
  };
  const commonProps = { className, style, ignoreAccents, ...fieldProps, ...otherProps };
  const SelectElement = ({ options }) => mode === "TETHERED" ? /* @__PURE__ */ React__default.createElement(TetheredSelect, {
    ...commonProps,
    options
  }) : mode === "VIRTUALIZED" ? /* @__PURE__ */ React__default.createElement(VirtualizedSelect, {
    ...commonProps,
    options,
    optionRenderer: null
  }) : mode === "CREATABLE" ? /* @__PURE__ */ React__default.createElement(CreatableSelect, {
    ...commonProps,
    options
  }) : /* @__PURE__ */ React__default.createElement(Select, {
    ...commonProps,
    options
  });
  if (isStringArray(stringOptions)) {
    return /* @__PURE__ */ React__default.createElement(StringsAsOptions, {
      strings: stringOptions
    }, (options) => /* @__PURE__ */ React__default.createElement(SelectElement, {
      options
    }));
  } else {
    return /* @__PURE__ */ React__default.createElement(SelectElement, {
      options: optionOptions
    });
  }
}
function CreatableSelect(props) {
  const options = React__default.useMemo(() => {
    var _a, _b;
    const options2 = (_a = props.options) != null ? _a : [];
    const optionsValues = options2.map((o) => o.value);
    const createdOptions = ((_b = props.value) != null ? _b : []).filter((val) => !optionsValues.includes(val)).map((opt) => ({ label: opt, value: opt }));
    return options2.concat(createdOptions);
  }, [props.options, props.value]);
  return /* @__PURE__ */ React__default.createElement(Creatable, {
    ...props,
    options
  });
}

function SelectInput(props) {
  const { value, defaultValue, validation, options, inputClassName, ...otherProps } = props;
  const className = `SelectInput form-control ${orEmptyString(inputClassName)} ${validationClassName(validation)}`;
  useEffect$a(() => {
    if (!isNil(defaultValue)) {
      const values = isStringArray(options) ? options : options.map((o) => o.value);
      if (!values.includes(value)) {
        props.onChange(createFakeReactSyntheticEvent({ name: props.name, value: defaultValue }));
      }
    }
  }, [value, defaultValue, options]);
  const SelectElement = ({ opts }) => /* @__PURE__ */ React__default.createElement("select", {
    className,
    value: orEmptyString(value),
    ...otherProps
  }, opts.map((option) => /* @__PURE__ */ React__default.createElement("option", {
    key: option.value,
    value: option.value,
    disabled: option.disabled
  }, option.label)));
  if (isStringArray(options)) {
    return /* @__PURE__ */ React__default.createElement(StringsAsOptions, {
      strings: options
    }, (opts) => /* @__PURE__ */ React__default.createElement(SelectElement, {
      opts
    }));
  } else {
    return /* @__PURE__ */ React__default.createElement(SelectElement, {
      opts: options
    });
  }
}

const isExpression = (account) => !!account && account.includes("${");
class AccountSelectInput extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      mergedAccounts: [],
      primaryAccounts: [],
      secondaryAccounts: []
    };
    this.groupAccounts = (accounts) => {
      const { name, value, onChange, provider } = this.props;
      if (!accounts || !accounts.length) {
        return;
      }
      if (isExpression(value)) {
        return;
      }
      const accountsAreObjects = Boolean(accounts[0].name);
      let getAccountDetails = $q.when([]);
      if (provider) {
        getAccountDetails = AccountService.getAllAccountDetailsForProvider(provider);
      }
      if (!provider && accountsAreObjects) {
        const providers = uniq(map$1(accounts, "type"));
        getAccountDetails = $q.all(providers.map((p) => AccountService.getAllAccountDetailsForProvider(p))).then((details) => flatten(details));
      }
      getAccountDetails.then((details) => {
        const accountNames = accountsAreObjects ? map$1(accounts, "name") : accounts;
        let mergedAccounts = accountNames;
        let primaryAccounts = [];
        let secondaryAccounts = [];
        if (accountNames) {
          primaryAccounts = accountNames.sort();
        }
        if (accountNames && accountNames.length && details.length) {
          primaryAccounts = accountNames.filter((account) => {
            return details.some((detail) => detail.name === account && detail.primaryAccount);
          }).sort();
          secondaryAccounts = xor(accountNames, primaryAccounts).sort();
          mergedAccounts = flatten([primaryAccounts, secondaryAccounts]);
        }
        if (!mergedAccounts.includes(value)) {
          onChange(createFakeReactSyntheticEvent({ value: "", name }));
        }
        this.setState({ mergedAccounts, primaryAccounts, secondaryAccounts });
      });
    };
  }
  componentDidMount() {
    this.groupAccounts(this.props.accounts);
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.accounts, this.props.accounts)) {
      this.groupAccounts(nextProps.accounts);
    }
  }
  render() {
    const { value, readOnly } = this.props;
    const { mergedAccounts } = this.state;
    const { primaryAccounts, secondaryAccounts } = this.state;
    const showSeparator = primaryAccounts.length > 0 && secondaryAccounts.length > 0;
    const options = [{ label: "Select...", value: "", disabled: true }];
    options.push(...primaryAccounts.map((a) => ({ label: a, value: a })));
    if (showSeparator) {
      options.push({ label: "---------------", value: "-", disabled: true });
    }
    options.push(...secondaryAccounts.map((a) => ({ label: a, value: a })));
    if (isExpression(value)) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "sm-control-field"
      }, /* @__PURE__ */ React__default.createElement("span", null, "Resolved at runtime from expression: ", /* @__PURE__ */ React__default.createElement("code", null, value)));
    }
    if (readOnly) {
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", {
        className: "form-control-static"
      }, value));
    }
    const { renderFilterableSelectThreshold, ...otherProps } = this.props;
    const useSimpleSelect = mergedAccounts.length < renderFilterableSelectThreshold;
    if (useSimpleSelect) {
      const handleChange = (e) => {
        e.persist();
        this.props.onChange(e);
      };
      return /* @__PURE__ */ React__default.createElement(SelectInput, {
        ...otherProps,
        inputClassName: "form-control input-sm",
        onChange: handleChange,
        required: true,
        options
      });
    } else {
      return /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...otherProps,
        clearable: false,
        required: true,
        options,
        mode: "PLAIN",
        menuContainerStyle: { minWidth: "150px" }
      });
    }
  }
}
AccountSelectInput.defaultProps = {
  renderFilterableSelectThreshold: 6
};

const _AccountTag = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { isProdAccount: false };
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  componentDidMount() {
    this.updateAccount(this.props.account);
  }
  componentWillReceiveProps(nextProps) {
    this.updateAccount(nextProps.account);
  }
  updateAccount(account) {
    const { cache } = _AccountTag;
    if (!cache.hasOwnProperty(account)) {
      cache[account] = AccountService.challengeDestructiveActions(account).then((result) => cache[account] = !!result);
    }
    const cachedVal = cache[account];
    if (typeof cachedVal === "boolean") {
      this.setState({ isProdAccount: cachedVal });
    } else {
      cachedVal.then((isProdAccount) => this.mounted && this.setState({ isProdAccount }));
    }
  }
  render() {
    const { account, className } = this.props;
    const { isProdAccount } = this.state;
    const shouldShowTitle = className === "account-tag-wrapper";
    return /* @__PURE__ */ React__default.createElement("span", {
      className: `account-tag account-tag-${isProdAccount ? "prod" : "notprod"} ${className || ""}`
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "account-tag-name",
      title: shouldShowTitle ? account : null
    }, account));
  }
};
let AccountTag = _AccountTag;
AccountTag.cache = {};

const ApplicationContext = React__default.createContext(void 0);
const ApplicationContextProvider = ({ app, children }) => {
  return /* @__PURE__ */ React__default.createElement(ApplicationContext.Provider, {
    value: app
  }, children);
};

class AngularJSAdapter extends React__default.Component {
  constructor(props) {
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    if (this.$scope) {
      this.$scope.props = nextProps;
    }
  }
  refCallback(ref) {
    if (!ref) {
      return;
    }
    const { controller, controllerAs, locals } = this.props;
    const template = this.props.template;
    const templateUrl = this.props.templateUrl;
    const _locals = { ...this.props, ...locals };
    if (templateUrl) {
      $templateRequest(templateUrl).then((templateString) => {
        this.renderAngularTemplateAndController(ref, templateString, controller, controllerAs, _locals);
      });
    } else {
      this.renderAngularTemplateAndController(ref, template, controller, controllerAs, _locals);
    }
  }
  renderAngularTemplateAndController(ref, templateString, controller, controllerAs, locals) {
    const $element = element(ref);
    const parentScope = $element.scope();
    const $scope = this.$scope = parentScope.$new();
    $scope.props = this.props;
    $element.html(templateString);
    $compile(ref)($scope);
    if (controller) {
      const controllerStr = controllerAs ? `${controller} as ${controllerAs}` : controller;
      const controllerInstance = $controller(controllerStr, { $scope, $element, ...locals });
      $element.data("$ngControllerController", controllerInstance);
    }
  }
  componentWillUnmount() {
    this.$scope.$destroy();
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "AngularJSAdapter",
      ref: (ref) => this.refCallback(ref)
    });
  }
}
AngularJSAdapter.defaultProps = { locals: {} };

var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLoadingIndicator = function SvgLoadingIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "0 0",
      display: "block",
      shapeRendering: "auto"
    },
    preserveAspectRatio: "xMidYMid",
    viewBox: "24 24 52 52"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9166666666666666s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8333333333333334s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5833333333333334s",
    repeatCount: "indefinite"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4166666666666667s",
    repeatCount: "indefinite"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16666666666666666s",
    repeatCount: "indefinite"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08333333333333333s",
    repeatCount: "indefinite"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "current",
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
};

const Spinner = ({
  color = "#ffffff",
  fullWidth,
  message,
  className,
  mode = "horizontal",
  size = "small"
}) => {
  if (mode === "circular") {
    const sizeToHeight = {
      nano: 12,
      small: 16,
      medium: 24,
      large: 32
    };
    return /* @__PURE__ */ React__default.createElement(SvgLoadingIndicator, {
      className,
      style: { height: sizeToHeight[size], fill: color }
    });
  }
  const getBarRows = () => {
    let count = 3;
    if (size) {
      if (size === "nano") {
        count = 1;
      } else if (size === "large") {
        count = 5;
      }
    }
    const rows = [];
    let i;
    for (i = 0; i < count; i++) {
      rows.push(/* @__PURE__ */ React__default.createElement("div", {
        key: i,
        className: "bar"
      }));
    }
    return rows;
  };
  const messageClassNames = `message color-text-accent ${size === "medium" ? "heading-4" : "heading-2"}`;
  const messageNode = ["medium", "large"].includes(size) && /* @__PURE__ */ React__default.createElement("div", {
    className: messageClassNames
  }, message || "Loading ...");
  const bars = ["medium", "large"].includes(size) ? /* @__PURE__ */ React__default.createElement("div", {
    className: "bars"
  }, getBarRows()) : getBarRows();
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("load", size || "small", className, { "full-width": fullWidth })
  }, messageNode, bars);
};

function Overridable(key) {
  return function(targetComponent) {
    return overridableComponent(targetComponent, key);
  };
}
function overridableComponent(OriginalComponent, key) {
  class OverridableComponent extends React__default.Component {
    constructor(props) {
      super(props);
      this.account$ = new Subject();
      this.destroy$ = new Subject();
      let constructing = true;
      this.account$.pipe(switchMap((accountName) => {
        if (!accountName) {
          return of(null);
        }
        return AccountService.accounts$.pipe(map((accts) => accts.find((acct) => acct.name === accountName)));
      }), map((accountDetails) => this.getComponent(accountDetails)), takeUntil(this.destroy$)).subscribe((Component) => {
        if (constructing) {
          this.state = { Component };
        } else {
          this.setState({ Component });
        }
      });
      this.account$.next(this.props.accountId);
      constructing = false;
    }
    componentWillUnmount() {
      this.destroy$.next();
    }
    componentWillReceiveProps(nextProps) {
      const { accountId } = nextProps;
      if (this.props.accountId !== accountId) {
        this.account$.next(accountId);
      }
    }
    getComponentFromCloudProvider(accountDetails) {
      const { cloudProvider } = accountDetails;
      if (!cloudProvider) {
        return null;
      }
      const CloudProviderComponentOverride = CloudProviderRegistry.getValue(cloudProvider, key);
      if (CloudProviderComponentOverride) {
        return CloudProviderComponentOverride;
      }
      const cloudProviderTemplateOverride = CloudProviderRegistry.getValue(cloudProvider, key + "TemplateUrl");
      if (cloudProviderTemplateOverride) {
        const cloudProviderController = CloudProviderRegistry.getValue(cloudProvider, key + "Controller");
        const controllerAs = cloudProviderController && cloudProviderController.includes(" as ") ? void 0 : "ctrl";
        const Component = (props) => /* @__PURE__ */ React__default.createElement(AngularJSAdapter, {
          ...props,
          templateUrl: cloudProviderTemplateOverride,
          controller: cloudProviderController,
          controllerAs
        });
        return Component;
      }
      return null;
    }
    getComponentFromOverrideRegistry() {
      const { overrideRegistry } = ReactInjector;
      const ComponentOverride = overrideRegistry.getComponent(key);
      if (ComponentOverride) {
        return ComponentOverride;
      }
      const templateOverride = overrideRegistry.getTemplate(key, null);
      if (templateOverride) {
        const controllerOverride = overrideRegistry.getController(key, null);
        const controllerAs = controllerOverride && controllerOverride.includes(" as ") ? void 0 : "ctrl";
        const Component = (props) => /* @__PURE__ */ React__default.createElement(AngularJSAdapter, {
          ...props,
          templateUrl: templateOverride,
          controller: controllerOverride,
          controllerAs
        });
        return Component;
      }
      return null;
    }
    getComponent(accountDetails) {
      return this.getComponentFromCloudProvider(accountDetails || {}) || this.getComponentFromOverrideRegistry() || OriginalComponent;
    }
    render() {
      const Component = this.state && this.state.Component;
      const isOverridden = Component && Component !== OriginalComponent;
      const props = { ...this.props, ...isOverridden ? { OriginalComponent } : {} };
      if (!Component) {
        return /* @__PURE__ */ React__default.createElement(Spinner, null);
      }
      const isClassComponent = ["render", "prototype.render"].some((prop) => typeof get(Component, prop) === "function");
      return isClassComponent ? /* @__PURE__ */ React__default.createElement(Component, {
        ...props,
        ref: this.props.forwardedRef
      }) : /* @__PURE__ */ React__default.createElement(Component, {
        ...props
      });
    }
  }
  OverridableComponent.OriginalComponent = OriginalComponent;
  const forwardRef = React__default.forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(OverridableComponent, {
    ...props,
    forwardedRef: ref
  }));
  Object.getOwnPropertyNames(OriginalComponent).filter((propName) => propName !== "constructor" && !OverridableComponent.hasOwnProperty(propName)).forEach((propName) => forwardRef[propName] = OriginalComponent[propName]);
  return forwardRef;
}

var __defProp$A = Object.defineProperty;
var __getOwnPropDesc$A = Object.getOwnPropertyDescriptor;
var __decorateClass$A = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$A(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$A(target, key, result);
  return result;
};
let ApplicationIcon = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("i", {
      className: "application-header-icon far fa-window-maximize"
    });
  }
};
ApplicationIcon = __decorateClass$A([
  Overridable("applicationIcon")
], ApplicationIcon);

var css_248z$2p = ".collapsible-element {\n  position: relative;\n}\n.collapsible-element .content {\n  position: relative;\n  overflow: hidden;\n}\n.collapsible-element .content.collapsed:after {\n  content: '';\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  background: linear-gradient(0deg, var(--color-white) 0px, transparent 40px);\n}\n.collapsible-element .expand-button {\n  display: none;\n  position: absolute;\n  bottom: 0;\n  text-align: center;\n  padding-top: 2px;\n  border: none;\n  border-top: 2px solid #009cb8;\n  color: #009cb8;\n  width: 100%;\n  background-color: var(--color-white);\n  outline: none;\n}\n.collapsible-element .expand-button:hover {\n  text-decoration: underline;\n}\n.collapsible-element:hover .expand-button {\n  display: block;\n}\n";
styleInject(css_248z$2p);

const CollapsibleElement = ({ children, maxHeight }) => {
  const [isCollapsed, setIsCollapsed] = React__default.useState(true);
  const [isOverflowing, setIsOverflowing] = React__default.useState(false);
  const contentRef = React__default.useRef(null);
  const checkIsOverflowing = React__default.useCallback(() => {
    if (!contentRef.current)
      return;
    setIsOverflowing(contentRef.current.offsetHeight < contentRef.current.scrollHeight);
  }, []);
  React__default.useLayoutEffect(() => {
    setTimeout(() => {
      checkIsOverflowing();
    });
  }, [checkIsOverflowing]);
  React__default.useEffect(() => {
    window.addEventListener("resize", checkIsOverflowing);
    return () => window.removeEventListener("resize", checkIsOverflowing);
  }, []);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "collapsible-element"
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: { maxHeight: isCollapsed ? maxHeight : void 0 },
    className: classNames(["content", { ["collapsed"]: isCollapsed && isOverflowing }]),
    ref: contentRef
  }, children), (isOverflowing || !isCollapsed) && /* @__PURE__ */ React__default.createElement("button", {
    className: "expand-button",
    onClick: () => setIsCollapsed((state) => !state)
  }, isCollapsed ? "Read more" : "Read less"));
};

class CollapsibleSectionStateCacheInternal {
  constructor() {
    this.cacheFactory = new CacheFactory();
    this.cacheId = "collapsibleSectionStateCache";
    this.handlers = new Map();
    try {
      this.cacheFactory.createCache(this.cacheId, {
        maxAge: 7 * 24 * 60 * 60 * 1e3,
        deleteOnExpire: "aggressive",
        storageMode: "localStorage"
      });
    } catch (e) {
    }
    this.stateCache = this.cacheFactory.get(this.cacheId);
  }
  isSet(heading) {
    return !!heading && this.stateCache.get(heading) !== void 0;
  }
  isExpanded(heading) {
    return !!heading && this.stateCache.get(heading) === true;
  }
  setExpanded(heading, expanded) {
    if (heading) {
      this.stateCache.put(heading, !!expanded);
      const handler = this.handlers.get(heading);
      if (handler) {
        handler(!CollapsibleSectionStateCache.isSet(heading) || CollapsibleSectionStateCache.isExpanded(heading));
      }
    }
  }
  onChange(heading, listener) {
    if (!this.handlers.get(heading)) {
      this.handlers.set(heading, listener);
    }
  }
}
const CollapsibleSectionStateCache = new CollapsibleSectionStateCacheInternal();

const rotationByPosition = {
  left: {
    expanded: "rotate-0",
    collapsed: "rotate-m90"
  },
  right: {
    expanded: "rotate-p180",
    collapsed: "rotate-p270"
  }
};
const CollapsibleSection = ({
  outerDivClassName = "collapsible-section",
  toggleClassName = "section-heading",
  headingClassName = "collapsible-heading",
  bodyClassName = "content-body",
  enableCaching = true,
  cacheKey: cacheKeyInternal,
  defaultExpanded,
  heading,
  expandIconPosition = "left",
  expandIconType = "arrow",
  expandIconSize,
  onToggle,
  children
}) => {
  const cacheKey = React__default.useMemo(() => cacheKeyInternal || (typeof heading === "string" ? heading : void 0), [cacheKeyInternal, heading]);
  const [isExpanded, setIsExpanded] = React__default.useState(enableCaching && CollapsibleSectionStateCache.isSet(cacheKey) ? CollapsibleSectionStateCache.isExpanded(cacheKey) : defaultExpanded);
  const toggle = () => {
    setIsExpanded(!isExpanded);
    if (enableCaching) {
      CollapsibleSectionStateCache.setExpanded(cacheKey, !isExpanded);
    }
    onToggle == null ? void 0 : onToggle(!isExpanded);
  };
  const expandIconProps = {
    size: expandIconSize || "16px",
    color: "concrete"
  };
  const expandIcon = children ? /* @__PURE__ */ React__default.createElement("span", {
    className: classNames("section-heading-chevron", expandIconPosition)
  }, expandIconType === "arrow" ? /* @__PURE__ */ React__default.createElement(Icon, {
    name: "accordionCollapse",
    className: rotationByPosition[expandIconPosition][isExpanded ? "expanded" : "collapsed"],
    ...expandIconProps
  }) : expandIconType === "plus" ? /* @__PURE__ */ React__default.createElement(Icon, {
    name: isExpanded ? "minus" : "plus",
    ...expandIconProps
  }) : /* @__PURE__ */ React__default.createElement(Icon, {
    name: isExpanded ? "closeSmall" : "accordionCollapse",
    ...expandIconProps
  })) : void 0;
  const Heading = typeof heading === "string" ? /* @__PURE__ */ React__default.createElement("h4", {
    className: headingClassName
  }, expandIconPosition === "left" ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, expandIcon, " ", heading) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, heading, " ", expandIcon)) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, heading({ chevron: expandIcon }));
  return /* @__PURE__ */ React__default.createElement("div", {
    className: outerDivClassName
  }, children ? /* @__PURE__ */ React__default.createElement("div", {
    className: classNames(toggleClassName, "clickable", "as-link"),
    onClick: toggle
  }, Heading) : Heading, isExpanded && children && /* @__PURE__ */ React__default.createElement("div", {
    className: bodyClassName
  }, children));
};

class CustomLabels {
  static get(label) {
    return this.labels.get(label) || label;
  }
  static register(label, translation) {
    this.labels.set(label, translation);
  }
}
CustomLabels.labels = new Map();

const CloseButton = /* @__PURE__ */ React__default.createElement("div", {
  className: "close-button"
}, /* @__PURE__ */ React__default.createElement(UISref, {
  to: "^"
}, /* @__PURE__ */ React__default.createElement("a", {
  className: "btn btn-link"
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "glyphicon glyphicon-remove"
}))));
const DetailsHeader = (props) => /* @__PURE__ */ React__default.createElement("div", {
  className: "header"
}, CloseButton, /* @__PURE__ */ React__default.createElement("div", {
  className: "header-text horizontal middle"
}, props.icon, /* @__PURE__ */ React__default.createElement("h3", {
  className: "horizontal middle space-between flex-1"
}, props.name)), /* @__PURE__ */ React__default.createElement("div", null, props.children));
const loading = /* @__PURE__ */ React__default.createElement("div", {
  className: "header"
}, /* @__PURE__ */ React__default.createElement("div", {
  className: "horizontal center middle spinner-container"
}, /* @__PURE__ */ React__default.createElement(Spinner, null)));
const Details = (props) => /* @__PURE__ */ React__default.createElement("div", {
  className: "details-panel"
}, props.loading ? loading : props.children);
Details.Header = DetailsHeader;

class Tooltip extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleRef = (popover) => {
      if (popover) {
        this.popover = popover;
      }
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.popover) {
      if (this.props.value && !nextProps.value) {
        this.popover.hide();
      }
      if (!this.props.value && nextProps.value) {
        this.popover.show();
      }
    }
  }
  render() {
    const { delayShow, id, placement, template, value } = this.props;
    const useId = id || value || "tooltip";
    let tooltip = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
      id: useId
    }, /* @__PURE__ */ React__default.createElement(Markdown, {
      message: value
    }));
    if (template) {
      tooltip = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
        id: useId
      }, template);
    }
    const hasValue = value && value.length > 0 || template;
    const trigger = hasValue ? ["hover", "focus"] : [];
    return /* @__PURE__ */ React__default.createElement(OverlayTrigger, {
      ref: this.handleRef,
      delayShow,
      placement,
      overlay: tooltip,
      trigger
    }, this.props.children);
  }
}
Tooltip.defaultProps = {
  placement: "top",
  value: ""
};

const SpInput = (props) => {
  const { error, ...inputProps } = props;
  if (error) {
    inputProps.className = `${inputProps.className || ""} invalid`;
  }
  inputProps.type = inputProps.type || "text";
  return /* @__PURE__ */ React__default.createElement(Tooltip, {
    id: inputProps.name,
    value: props.error,
    placement: "right"
  }, /* @__PURE__ */ React__default.createElement("input", {
    ...inputProps
  }));
};
const spelNumberCheck = (value, allowNegative) => {
  const invalidError = `Value must be a${!allowNegative ? " positive " : " "}number or a SpEL expression.`;
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) {
    const stringValue = String(value);
    const spelStart = stringValue ? stringValue.indexOf("${") : -1;
    if (spelStart !== -1 && stringValue.includes("}", spelStart)) {
      return null;
    }
    return invalidError;
  }
  return !allowNegative && numberValue < 0 ? invalidError : null;
};

const FormikFormImpl = ({ render, formik }) => render(formik);
const FormikForm = connect(FormikFormImpl);

function SpinFormikImpl(props, ref) {
  const defaultRef = React__default.useRef();
  const formikRef = ref || defaultRef;
  const [refSaved, setRefSaved] = React__default.useState(false);
  const [ready, setReady] = React__default.useState(false);
  const defaultIsInitialValid = () => formikRef.current && Object.keys(formikRef.current.state.errors).length === 0;
  React__default.useEffect(() => {
    if (refSaved) {
      const formik = formikRef.current;
      const initialTouched = {};
      traverseObject(props.initialValues, (path) => set(initialTouched, path, true), true);
      formik.setTouched(initialTouched);
      formik.getFormikActions().validateForm();
      setReady(true);
    }
  }, [refSaved]);
  function saveRef(formik) {
    formikRef.current = formik;
    if (!refSaved) {
      setRefSaved(true);
    }
  }
  return /* @__PURE__ */ React__default.createElement(Formik, {
    ref: saveRef,
    ...props,
    isInitialValid: props.isInitialValid || defaultIsInitialValid,
    render: (renderProps) => ready && props.render && props.render(renderProps)
  });
}
const SpinFormik = React__default.forwardRef(SpinFormikImpl);

class WatchValue extends React__default.Component {
  constructor(props) {
    super(props);
    const { value } = props;
    this.state = { value };
  }
  componentDidUpdate() {
    if (!this.props.onChange) {
      return;
    }
    const { value, isEqual } = this.props;
    const { value: prevValue } = this.state;
    if (!isEqual(value, prevValue)) {
      this.setState({ value });
      this.props.onChange(value, prevValue);
    }
  }
  render() {
    return this.props.children || null;
  }
}
WatchValue.defaultProps = {
  isEqual: (newValue, oldValue) => newValue === oldValue
};

function useMountStatusRef() {
  const mountStatusRef = useRef$4("FIRST_RENDER");
  useEffect$a(() => {
    mountStatusRef.current = "MOUNTED";
    return () => {
      mountStatusRef.current = "UNMOUNTED";
    };
  });
  return mountStatusRef;
}

var css_248z$2o = ".StandardFieldLayout + .StandardFieldLayout {\n  margin-top: 6px;\n}\n\n.StandardFieldLayout .StandardFieldLayout_Label {\n  min-width: 120px;\n}\n\n.StandardFieldLayout .StandardFieldLayout_Contents > *:first-child {\n  flex: 1;\n}\n";
styleInject(css_248z$2o);

function StandardFieldLayout(props) {
  const { label, help, input, actions, validation = {} } = props;
  const { hidden, messageNode, category } = validation;
  const showLabel = !isUndefined(label) || !isUndefined(help);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "StandardFieldLayout flex-container-h baseline margin-between-lg"
  }, showLabel && /* @__PURE__ */ React__default.createElement("div", {
    className: "StandardFieldLayout_Label sm-label-right"
  }, label, " ", help), /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-grow"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-v margin-between-md"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h baseline space-between margin-between-lg StandardFieldLayout_Contents"
  }, input, " ", actions), !hidden && /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    message: messageNode,
    type: category
  }))));
}

const LayoutContext = React__default.createContext(StandardFieldLayout);
const { Provider: LayoutProvider, Consumer: LayoutConsumer } = LayoutContext;

const HelpTextExpandedContext = React__default.createContext(false);

class FirewallLabels {
  static get(label) {
    return this.labels.get(label) || label;
  }
  static register(label, translation) {
    this.labels.set(label, translation);
  }
}
FirewallLabels.labels = new Map();
if (SETTINGS.useClassicFirewallLabels) {
  FirewallLabels.register("firewall", "security group");
  FirewallLabels.register("firewalls", "security groups");
  FirewallLabels.register("Firewall", "Security Group");
  FirewallLabels.register("Firewalls", "Security Groups");
}

function FirewallLabel(props) {
  return /* @__PURE__ */ React__default.createElement("span", null, FirewallLabels.get(props.label));
}

class HelpContentsRegistry {
  static getHelpField(key) {
    let contents = this.helpFields.get(key);
    if (contents) {
      contents = contents.replace(/{{(.+?)}}/g, (_ignored, match) => FirewallLabels.get(match));
    }
    return contents || null;
  }
  static register(key, val) {
    if (!this.overrides.has(key)) {
      this.helpFields.set(key, val);
    }
  }
  static registerOverride(key, val) {
    this.register(key, val);
    this.overrides.add(key);
  }
}
HelpContentsRegistry.helpFields = new Map();
HelpContentsRegistry.overrides = new Set();

var css_248z$2n = ".HoverablePopover {\n  display: inline;\n  -webkit-text-decoration: dotted underline var(--color-dovegray);\n          text-decoration: dotted underline var(--color-dovegray);\n}\n";
styleInject(css_248z$2n);

class HoverablePopover extends React__default.Component {
  constructor(props) {
    super(props);
    this.mouseEvents$ = new Subject();
    this.hidePopoverEvents$ = new Subject();
    this.destroy$ = new Subject();
    this.targetRef = React__default.createRef();
    this.handleMouseEvent = (e) => {
      this.mouseEvents$.next(e);
    };
    this.rendererRefCallback = (ref) => {
      if (ref) {
        const { clientWidth, clientHeight } = ReactDOM__default.findDOMNode(ref);
        const bounds = this.targetRef.current.getBoundingClientRect();
        const bottomSpace = window.innerHeight - bounds.bottom;
        const rightSpace = window.innerWidth - bounds.right;
        let placementOverride;
        switch (this.props.placement) {
          case "top":
            placementOverride = clientHeight > bounds.top && bounds.top < bottomSpace ? "bottom" : void 0;
            break;
          case "bottom":
            placementOverride = clientHeight > bottomSpace && bottomSpace < bounds.top ? "top" : void 0;
            break;
          case "left":
            placementOverride = clientWidth > bounds.left && bounds.left < rightSpace ? "right" : void 0;
            break;
          case "right":
            placementOverride = clientWidth > rightSpace && rightSpace < bounds.left ? "left" : void 0;
            break;
        }
        this.setState({ placementOverride });
      }
    };
    this.Wrapper = ({ children, ...otherProps }) => {
      const { svgMode } = this.props;
      if (svgMode) {
        return /* @__PURE__ */ React__default.createElement("g", {
          ...otherProps,
          ref: this.targetRef
        }, children);
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        ...otherProps,
        ref: this.targetRef
      }, children);
    };
    this.state = { popoverIsOpen: false, animation: true };
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  componentDidMount() {
    const shouldShowEvents = ["mouseenter", "mouseover"];
    const showHideMouseEvents$ = this.mouseEvents$.pipe(map((event) => {
      const shouldOpen = shouldShowEvents.includes(event.type);
      const eventDelay = shouldOpen ? this.props.delayShow : this.props.delayHide;
      return { shouldOpen, eventDelay, animation: true };
    }));
    const hideProgramatically$ = this.hidePopoverEvents$.pipe(map(() => {
      return { shouldOpen: false, eventDelay: 0, animation: false };
    }));
    merge$1(showHideMouseEvents$, hideProgramatically$).pipe(map(({ shouldOpen, eventDelay, animation }) => of({ shouldOpen, animation }).pipe(delay(eventDelay))), switchMap((result) => result), filter(({ shouldOpen }) => shouldOpen !== this.state.popoverIsOpen), takeUntil(this.destroy$)).subscribe(({ shouldOpen, animation }) => this.setPopoverOpen(shouldOpen, animation));
  }
  setPopoverOpen(popoverIsOpen, animation = true) {
    this.setState({ animation, popoverIsOpen });
    const callback = popoverIsOpen ? this.props.onShow : this.props.onHide;
    callback && callback();
  }
  render() {
    const { Component, template, placement, container, hOffsetPercent, id, title, className } = this.props;
    const { popoverIsOpen, animation, placementOverride } = this.state;
    const { Wrapper } = this;
    const popoverContent = Component ? /* @__PURE__ */ React__default.createElement(Component, {
      ...this.props,
      hidePopover: () => this.hidePopoverEvents$.next()
    }) : template;
    return /* @__PURE__ */ React__default.createElement(Wrapper, {
      className: classNames("HoverablePopover", this.props.wrapperClassName),
      onMouseEnter: this.handleMouseEvent,
      onMouseLeave: this.handleMouseEvent
    }, this.props.children, /* @__PURE__ */ React__default.createElement(Overlay, {
      show: popoverIsOpen,
      animation,
      placement: placementOverride || placement,
      target: this.targetRef.current,
      container,
      shouldUpdatePosition: true
    }, /* @__PURE__ */ React__default.createElement(PopoverOffset, {
      ref: this.rendererRefCallback,
      onMouseOver: this.handleMouseEvent,
      onMouseLeave: this.handleMouseEvent,
      offsetPercent: hOffsetPercent,
      id,
      title,
      className
    }, popoverContent)));
  }
}
HoverablePopover.defaultProps = {
  placement: "top",
  id: UUIDGenerator.generateUuid(),
  delayShow: 0,
  delayHide: 300
};
class PopoverOffset extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  componentDidMount() {
    this.setState(this.getState(this.props));
  }
  componentWillReceiveProps(newProps) {
    this.setState(this.getState(newProps));
  }
  getState(props) {
    const { offsetPercent } = props;
    const parsePercent = (str) => {
      const match = /(\d+(?:\.\d+)?)%/.exec(str);
      return match ? parseFloat(match[1]) / 100 : 0.5;
    };
    const desiredPercent = parsePercent(offsetPercent);
    const currentPercent = parsePercent(props.arrowOffsetLeft);
    const deltaPercent = desiredPercent - currentPercent;
    const width = ReactDOM__default.findDOMNode(this).clientWidth;
    const offset = 0 - width * deltaPercent;
    return { offset };
  }
  render() {
    const { offsetPercent, ...rest } = this.props;
    const { offset } = this.state;
    if (offset) {
      const { style } = this.props;
      const left = parseInt(`${style.left}`, 10) + offset;
      const offsetStyle = { ...style, left };
      return /* @__PURE__ */ React__default.createElement(Popover$1, {
        ...rest,
        style: offsetStyle,
        arrowOffsetLeft: offsetPercent
      });
    } else {
      return /* @__PURE__ */ React__default.createElement(Popover$1, {
        ...rest
      });
    }
  }
}

function HelpFieldContents(props) {
  const { id, fallback, content } = props;
  let contentString = content;
  if (id && !contentString) {
    contentString = HelpContentsRegistry.getHelpField(id) || fallback;
  }
  const config = { ADD_ATTR: ["target"] };
  return /* @__PURE__ */ React__default.createElement(Markdown, {
    message: contentString,
    options: config,
    trim: true
  });
}
function HelpField(props) {
  const { content, expand, fallback, id, label, placement } = props;
  const [popoverShownStart, setPopoverShownStart] = React__default.useState();
  const onShow = () => setPopoverShownStart(Date.now());
  const onHide = () => {
    if (Date.now() - popoverShownStart > 500) {
      logger.log({ action: "Help contents viewed", category: "Help", data: { label: props.id || props.content } });
    }
  };
  const icon = /* @__PURE__ */ React__default.createElement("i", {
    className: "small glyphicon glyphicon-question-sign"
  });
  const shouldExpandFromContext = React__default.useContext(HelpTextExpandedContext);
  const expandHelpText = isUndefined(expand) ? shouldExpandFromContext : expand;
  if (!id && !content) {
    return null;
  }
  const contents = /* @__PURE__ */ React__default.createElement(HelpFieldContents, {
    content,
    fallback,
    id
  });
  const popover = /* @__PURE__ */ React__default.createElement(HoverablePopover, {
    placement: placement || "top",
    template: contents,
    onShow,
    onHide
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "clickable help-field"
  }, " ", label || icon, " "));
  if (label) {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "text-only"
    }, !expandHelpText && contents && popover);
  } else {
    const expanded = /* @__PURE__ */ React__default.createElement("div", {
      className: "help-contents small"
    }, " ", contents, " ");
    return /* @__PURE__ */ React__default.createElement("div", {
      style: { display: "inline-block" }
    }, !expandHelpText && contents && popover, expandHelpText && contents && expanded);
  }
}

class SchedulerFactory {
  static createScheduler(pollSchedule = SETTINGS.pollSchedule || 3e4) {
    let scheduler = new Subject();
    let lastRunTimestamp = new Date().getTime();
    let pendingRun = null;
    let suspended = false;
    let source = timer(pollSchedule, pollSchedule);
    const run = () => {
      if (suspended) {
        return;
      }
      $timeout.cancel(pendingRun);
      lastRunTimestamp = new Date().getTime();
      scheduler.next(true);
      pendingRun = null;
    };
    source.subscribe(run);
    const suspendScheduler = () => {
      $log.debug("auto refresh suspended");
      suspended = true;
    };
    const scheduleNextRun = (delay) => {
      suspended = false;
      pendingRun = pendingRun || $timeout(run, delay);
    };
    const resumeScheduler = () => {
      suspended = false;
      const now = new Date().getTime();
      $log.debug("auto refresh resumed");
      if (now - lastRunTimestamp > pollSchedule) {
        run();
      } else {
        scheduleNextRun(pollSchedule - (now - lastRunTimestamp));
      }
    };
    const watchDocumentVisibility = () => {
      $log.debug("document visibilityState changed to: ", document.visibilityState);
      if (document.visibilityState === "visible") {
        resumeScheduler();
      } else {
        suspendScheduler();
      }
    };
    const scheduleImmediate = () => {
      run();
      suspended = true;
      scheduleNextRun(pollSchedule);
    };
    document.addEventListener("visibilitychange", watchDocumentVisibility);
    $window.addEventListener("offline", suspendScheduler);
    $window.addEventListener("online", resumeScheduler);
    scheduler.next(true);
    return {
      subscribe: scheduler.subscribe.bind(scheduler),
      scheduleImmediate,
      unsubscribe: () => {
        suspended = true;
        if (scheduler) {
          scheduler.unsubscribe();
        }
        scheduler = null;
        source = null;
        $timeout.cancel(pendingRun);
        document.removeEventListener("visibilitychange", watchDocumentVisibility);
        $window.removeEventListener("offline", suspendScheduler);
        $window.removeEventListener("online", resumeScheduler);
      }
    };
  }
}

class NotifierService {
  static publish(message) {
    const existing = toast.isActive(message.key);
    if (existing) {
      toast.update(message.key, { render: message.content, ...message.options });
    } else {
      toast(message.content, { toastId: message.key, ...message.options });
    }
  }
  static clear(key) {
    toast.dismiss(key);
  }
}

class VersionChecker {
  static initialize() {
    $log.debug("Deck version", this.currentVersion.version, "created", timestamp(this.currentVersion.created));
    this.scheduler = SchedulerFactory.createScheduler();
    this.scheduler.subscribe(() => this.checkVersion());
  }
  static checkVersion() {
    const url = `/version.json?_=${Date.now()}`;
    $http.get(url).then((resp) => this.versionRetrieved(resp)).catch(() => {
    });
  }
  static versionRetrieved(response) {
    const data = response.data;
    if (data.version === this.currentVersion.version) {
      this.newVersionSeenCount = 0;
    } else {
      this.newVersionSeenCount++;
      if (this.newVersionSeenCount > 5) {
        $log.debug("New Deck version:", data.version, "created", timestamp(data.created));
        NotifierService.publish({
          key: "newVersion",
          action: "create",
          content: /* @__PURE__ */ React__default.createElement("div", null, "A new version of Spinnaker is available", " ", /* @__PURE__ */ React__default.createElement("a", {
            role: "button",
            className: "action",
            onClick: () => document.location.reload(true)
          }, "Refresh"))
        });
        this.scheduler.unsubscribe();
      }
    }
  }
}
VersionChecker.currentVersion = version;
VersionChecker.newVersionSeenCount = 0;

var css_248z$2m = ".help-menu {\n  border: 0;\n}\n.help-menu .dropdown-toggle,\n.help-menu .dropdown-toggle:active {\n  font-size: 14px;\n  font-weight: 200;\n  margin: 0;\n  border: 0;\n  background: transparent;\n  border-radius: 0;\n  color: var(--color-white);\n}\n.help-menu .dropdown-toggle .caret,\n.help-menu .dropdown-toggle:active .caret {\n  margin-left: 3px;\n}\n.help-menu .dropdown.open .dropdown-toggle {\n  background-color: transparent;\n  text-decoration: none;\n  color: var(--color-white);\n  box-shadow: none;\n}\n.help-menu .dropdown-menu {\n  border: 0;\n}\n";
styleInject(css_248z$2m);

const DOCS_URL = "https://spinnaker.io/docs";
const COMMUNITY_URL = "https://spinnaker.io/community";
const Feedback = () => SETTINGS.feedback && SETTINGS.feedback.url ? /* @__PURE__ */ React__default.createElement(MenuItem, {
  href: SETTINGS.feedback.url,
  target: "_blank"
}, /* @__PURE__ */ React__default.createElement("i", {
  className: SETTINGS.feedback.icon || "fa fa-envelope"
}), "\xA0 ", SETTINGS.feedback.text || "Send feedback") : null;
const AdditionalHelpLinks = () => SETTINGS.additionalHelpLinks && SETTINGS.additionalHelpLinks.length ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, SETTINGS.additionalHelpLinks.map((helpLink, i) => /* @__PURE__ */ React__default.createElement(MenuItem, {
  href: helpLink.url,
  key: i,
  target: "_blank"
}, helpLink.icon ? /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("i", {
  className: helpLink.icon
}), " \xA0") : null, helpLink.text || `Additional Help`))) : null;
const Version = () => {
  if (!SETTINGS.version) {
    return null;
  }
  const CHANGELOG_URL = SETTINGS.changelogUrl.replace(":version", SETTINGS.version);
  return /* @__PURE__ */ React__default.createElement(MenuItem, {
    href: CHANGELOG_URL,
    target: "_blank"
  }, "Spinnaker ", SETTINGS.version);
};
const HelpMenu = () => {
  return /* @__PURE__ */ React__default.createElement("li", {
    className: "help-menu"
  }, /* @__PURE__ */ React__default.createElement(Dropdown, {
    id: "help-menu-dropdown",
    pullRight: true
  }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
    className: "hidden-lg",
    noCaret: true
  }, /* @__PURE__ */ React__default.createElement(Glyphicon, {
    glyph: "question-sign"
  })), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, null, /* @__PURE__ */ React__default.createElement(Feedback, null), /* @__PURE__ */ React__default.createElement(AdditionalHelpLinks, null), /* @__PURE__ */ React__default.createElement(MenuItem, {
    href: DOCS_URL,
    target: "_blank"
  }, "Docs"), /* @__PURE__ */ React__default.createElement(MenuItem, {
    divider: true
  }), /* @__PURE__ */ React__default.createElement(MenuItem, {
    href: COMMUNITY_URL,
    target: "_blank"
  }, "Community Resources"), /* @__PURE__ */ React__default.createElement(Version, null), SETTINGS.feature.pagerDuty && /* @__PURE__ */ React__default.createElement("li", {
    role: "presentation"
  }, /* @__PURE__ */ React__default.createElement(UISref, {
    to: "home.page"
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "clickable"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "feedback-item-label"
  }, "Send a Page")))))), /* @__PURE__ */ React__default.createElement(Dropdown, {
    id: "help-menu-dropdown-large",
    pullRight: true
  }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
    className: "hidden-xs hidden-sm hidden-md",
    noCaret: true
  }, /* @__PURE__ */ React__default.createElement(Glyphicon, {
    glyph: "question-sign"
  }), " Help"), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, null, /* @__PURE__ */ React__default.createElement(Feedback, null), /* @__PURE__ */ React__default.createElement(AdditionalHelpLinks, null), /* @__PURE__ */ React__default.createElement(MenuItem, {
    href: DOCS_URL,
    target: "_blank"
  }, "Docs"), /* @__PURE__ */ React__default.createElement(MenuItem, {
    href: COMMUNITY_URL,
    target: "_blank"
  }, "Community Resources"), /* @__PURE__ */ React__default.createElement(Version, null), SETTINGS.feature.pagerDuty && /* @__PURE__ */ React__default.createElement("li", {
    role: "presentation"
  }, /* @__PURE__ */ React__default.createElement(UISref, {
    to: "home.page"
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "clickable"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "feedback-item-label"
  }, "Send a Page")))))));
};

var _a$1;
const helpContents$4 = {
  "core.serverGroup.detail": "(Optional) <b>Detail</b> is a string of free-form alphanumeric characters and hyphens to describe any other variables in naming a cluster.",
  "core.serverGroup.strategy": "The deployment strategy tells Spinnaker what to do with the previous version of the server group.",
  "cluster.search": `
      Quickly filter the displayed server groups by the following fields:
      <ul>
        <li>Build # (e.g. <samp>#337</samp>)</li>
        <li>Jenkins host</li>
        <li>Jenkins job name</li>
        <li>Cluster (prefixed, e.g. <samp>cluster:myapp-int</samp>)
        <li>VPC (prefixed, e.g. <samp>vpc:main</samp>)
        <li>Clusters (comma-separated list, e.g. <samp>clusters:myapp-int, myapp-test</samp>)
        <li>Server Group Name</li>
        <li>Region</li>
        <li>Account</li>
        <li>Load Balancer Name</li>
        <li>Instance ID</li>
        <li>Labels (comma-separated list of key-value pairs that must all apply to entity, e.g. <samp>labels:app=spinnaker, source=prod</samp>)</li>
      </ul>
      <p>You can search for multiple words or word fragments. For instance, to find all server groups in a prod stack with "canary" in the details, enter <samp>prod canary</samp>.</p>
      <p>To find a particular instance, enter the instance ID. Only the containing server group will be displayed, and the instance
      will be highlighted for you.</p>`,
  "loadBalancer.search": `
      Quickly filter the displayed load balancers by the following fields:
      <ul>
        <li>VPC (prefixed, e.g. <samp>vpc:main</samp>)
        <li>Server Group Name</li>
        <li>Load Balancer Name</li>
        <li>Region</li>
        <li>Account</li>
        <li>Instance ID</li>
      </ul>
      <p>You can search for multiple words or word fragments. For instance, to find all load balancers in a prod stack with "canary" in the details, enter <samp>prod canary</samp>.</p>`,
  "securityGroup.search": `
      Filter by the following fields:
      <ul>
        <li>VPC (prefixed, e.g. <samp>vpc:main</samp>)
        <li>Name</li>
        <li>Server Group Name</li>
        <li>Load Balancer Name</li>
        <li>Region</li>
        <li>Account</li>
      </ul>`,
  "executions.search": `
      Quickly filter the displayed executions by the following fields:
      <ul>
        <li>Name</li>
        <li>Trigger</li>
      </ul>`,
  "pipeline.config.triggers.respectQuietPeriod": `
      <p>The quiet period is a system operator designated period of time when automated pipelines and deploys should not run.</p>`,
  "pipeline.config.expectedArtifact": "Artifacts required for trigger to execute.  Only one of the artifacts needs to be present for the trigger to execute.",
  "pipeline.config.artifact.help": `
      <p>There are certain types of triggers (e.g. Pub/Sub triggers) that can produce artifacts and inject them into the execution context for a pipeline.</p>
      <p>You can specify artifacts that your pipeline expects to be present in the execution context in this section.</p>`,
  "pipeline.config.artifact.missingPolicy": `
      <p>The behavior of the pipeline if the Artifact is missing from the pipeline execution.</p>`,
  "pipeline.config.artifact.name": `
      <p>The name of the Artifact.</p>`,
  "pipeline.config.artifact.type": `
      <p>The type of the Artifact, e.g. 'gcs/object' or 'rpm'.</p>`,
  "pipeline.config.lock.allowUnlockUi": `
      <p><strong>Checked</strong> - the pipeline can be unlocked via the Spinnaker UI.</p>
      <p><strong>Unchecked</strong> - the pipeline can only be unlocked via the Spinnaker API.</p>`,
  "pipeline.config.lock.description": `
      <p>Friendly description of why this pipeline is locked.</p>
      <p>Please include an email address or slack channel as appropriate.</p>`,
  "pipeline.config.optionalStage": `
      <p>When this option is enabled, stage will only execute when the supplied expression evaluates true.</p>
      <p>The expression <em>does not</em> need to be wrapped in \${ and }.</p>
      <p>If this expression evaluates to false, the stages following this stage will still execute.</p>`,
  "pipeline.config.checkPreconditions.failPipeline": `
      <p><strong>Checked</strong> - the overall pipeline will fail whenever this precondition is false.</p>
      <p><strong>Unchecked</strong> - the overall pipeline will continue executing but this particular branch will stop.</p>`,
  "pipeline.config.checkPreconditions.failureMessage": `
      <p> This failure message will be shown to the user if the precondition evaluates to false. </p>`,
  "pipeline.config.checkPreconditions.expectedSize": "Number of server groups in the selected cluster",
  "pipeline.config.checkPreconditions.expression": `
      <p>Value must evaluate to "true".</p>
      <p>Use of the <b>Spring Expression Language</b> allows for complex evaluations.</p>`,
  "pipeline.config.deploy.template": `
      <p>Select an existing cluster to use as a template for this deployment, and we'll pre-fill
      the configuration based on the newest server group in the cluster.</p>
      <p>If you want to start from scratch, select "None".</p>
      <p>You can always edit the cluster configuration after you've created it.</p>`,
  "pipeline.config.expectedArtifact.matchArtifact": `
      <p>
        This specifies which fields in your incoming artifact to match against. Every field that
        you supply will be used to match against all incoming artifacts. If all specified fields
        match, the incoming artifact is bound to your pipeline context.
      </p>
      <p>
        The field comparisons are done against the incoming artifact.  Example: if you are parsing
        artifacts from pub/sub messages via a Jinja template, the comparison will be done after
        the pub/sub -> Spinnaker artifact translation.
      </p>
      <p>For example, if you want to match against any GCS object, only supply <b>type</b> = gcs/object. If you also want to restrict the matches by other fields, include those as well.</p>
      <p>Regex is accepted, so you could for example match on a filepath like so <b>name</b> = .*\\.yaml to match all incoming YAML files.</p>
      <p>See the <a href="https://www.spinnaker.io/reference/artifacts/in-pipelines/#expected-artifacts">reference</a> for more information.</p>`,
  "pipeline.config.expectedArtifact.ifMissing": `
      <p>If no artifact was supplied by your trigger to match against this expected artifact, you have a few options:
        <ol>
          <li>Attempt to match against an artifact in the prior pipeline execution's context. This ensures that you will always be using the most recently supplied artifact to this pipeline, and is generally a safe choice.</li>
          <li>If option 1 fails, or isn't specified, you can provide a default artifact with the required fields to use instead.</li>
          <li>Fail the pipeline if options 1 or 2 fail or aren't selected.</li>
        </ol>
      </p>
      <p>See the <a href="https://www.spinnaker.io/reference/artifacts/in-pipelines">reference</a> for more information.</p>`,
  "pipeline.config.expectedArtifact.usePriorExecution": `
      <p>Attempt to match against an artifact in the prior pipeline execution's context. This ensures that you will always be using the most recently supplied artifact to this pipeline, and is generally a safe choice.</p>`,
  "pipeline.config.expectedArtifact.defaultArtifact": `
      <p>If your artifact either wasn't supplied from a trigger, or it wasn't found in a prior execution, the artifact specified below will end up in your pipeline's execution context.</p>
      <p>See the <a href="https://www.spinnaker.io/reference/artifacts/in-pipelines">reference</a> for more information.</p>`,
  "pipeline.config.expectedArtifact.gcs.name": `
      <p>The GCS object name, in the form <code>gs://bucket/path/to/file.yml</code>.</p>`,
  "pipeline.config.expectedArtifact.defaultGcs.reference": `
      <p>The GCS object name, <i>optionally</i> appending the version. An example: <code>gs://bucket/file.yml#123948581</code></p>`,
  "pipeline.config.expectedArtifact.s3.name": `
      <p>The S3 object name, in the form <code>s3://bucket/path/to/file.yml</code>.</p>`,
  "pipeline.config.expectedArtifact.defaultS3.reference": `
      <p>The S3 object name, <i>optionally</i> appending the version. An example: <code>s3://bucket/file.yml#123948581</code></p>`,
  "pipeline.config.expectedArtifact.oracle.name": `
      <p>The Oracle object artifact name, in the form <code>oci://bucket/path/file.yml</code>.</p>`,
  "pipeline.config.expectedArtifact.defaultOracle.reference": `
      <p>The  Oracle object artifact name, <i>optionally</i> appending the version. An example: <code>oci://bucket/file.yml#9ce463aa-d843-4438-b206-5365cd643e2e</code></p>`,
  "pipeline.config.expectedArtifact.docker.name": `
      <p>The Docker image name you want to trigger on changes to. By default, this does <i>not</i> include the image tag or digest, only the registry and image repository.</p>`,
  "pipeline.config.expectedArtifact.defaultDocker.reference": `
      <p>The fully-qualified docker image to deploy. An example: <code>gcr.io/project/image@sha256:59bb771c86</code></p>`,
  "pipeline.config.expectedArtifact.git.name": `
      <p>The file's path from the git root, in the form 'path/to/file.json'</p>`,
  "pipeline.config.expectedArtifact.defaultGithub.version": `
      <p>Either the commit or branch to checkout.</p>`,
  "pipeline.config.expectedArtifact.defaultGithub.reference": `
      <p>The GitHub API content url the artifact lives under. The domain name may change if you're running GHE.</p>
      <p>An example for GitHub.com is <code>https://api.github.com/repos/$ORG/$REPO/contents/$FILEPATH</code>. An example for GitHub Enterprise is <code>https://github.domain.com/api/v3/repos/$ORG/$REPO/contents/$FILEPATH</code>. See <a href="https://www.spinnaker.io/reference/artifacts/types/github-file/#fields">our docs</a> for more info.</p>`,
  "pipeline.config.expectedArtifact.defaultGitlab.version": `
      <p>Either the commit or branch to checkout.</p>`,
  "pipeline.config.expectedArtifact.defaultGitlab.reference": `
      <p>The Gitlab API file url the artifact lives under. The domain name may change if you're running your own Gitlab server. The repository and path to files must be URL encoded.</p>
      <p>An example is <code>https://gitlab.com/api/v4/projects/$ORG%2F$REPO/repository/files/path%2Fto%2Ffile.yml/raw</code>. See <a href="https://www.spinnaker.io/reference/artifacts/types/gitlab-file/#fields">our docs</a> for more info.</p>`,
  "pipeline.config.expectedArtifact.gitrepo.url": "<p>The location of your Git repository.</p>",
  "pipeline.config.expectedArtifact.gitrepo.branch": "<p>The branch of the repository you want to use.</p>",
  "pipeline.config.expectedArtifact.gitrepo.checkoutSubpath": "<p>Check this if you want to specify a subpath; doing so will reduce the size of the generated artifact.</p>",
  "pipeline.config.expectedArtifact.gitrepo.subpath": `
    <p>The subpath within the Git repository you desire to checkout.</p>
    <p>e.g.: <b>examples/wordpress/mysql/</b></p>`,
  "pipeline.config.expectedArtifact.helm.account": `
      <p>The account contains url the charts can be found</p>`,
  "pipeline.config.expectedArtifact.helm.name": `
      <p>The name of chart you want to trigger on changes to</p>`,
  "pipeline.config.expectedArtifact.helm.version": `
      <p>The version of chart you want to trigger on changes to</p>`,
  "pipeline.config.expectedArtifact.defaultBitbucket.reference": `
      <p>The Bitbucket API file url the artifact lives under. The domain name may change if you're running your own Bitbucket server. The repository and path to files must be URL encoded.</p>
      <p>An example is <code>https://api.bitbucket.org/1.0/repositories/$ORG/$REPO/raw/$VERSION/$FILEPATH</code>. See <a href="https://www.spinnaker.io/reference/artifacts/types/bitbucket-file/#fields">our docs</a> for more info.</p>`,
  "pipeline.config.expectedArtifact.defaultBitbucket.filepath": `
      <p>The file path within your repo. path/to/file.yml is an example.</p>`,
  "pipeline.config.trigger.helm.chart": `The Helm chart name.`,
  "pipeline.config.trigger.helm.version": `The Helm chart version, as semver.`,
  "pipeline.config.trigger.helm.version.manual": `The Helm chart version, as an exact version.`,
  "pipeline.config.trigger.webhook.source": `
      <p>Determines the target URL required to trigger this pipeline, as well as how the payload can be transformed into artifacts.</p>
  `,
  "pipeline.config.trigger.webhook.payloadConstraints": `
      <p>When provided, only a webhook with a payload containing at least the specified key/value pairs will be allowed to trigger this pipeline. For example, if you wanted to lock down the systems/users that can trigger this pipeline via this webhook, you could require the key "secret" and value "something-secret" as a constraint.</p>
      <p>The constraint values may be supplied as regex.</p>
  `,
  "pipeline.config.trigger.cdevents.attributeConstraints": `
      <p>CDEvents messages will have mandatory headers id, source, specversion, type accompanying the payload called <b>attributes</b>.</p>
      <p>When provided, only a CDEvents message with attributes containing at least the specified key/value pairs will be allowed to trigger this pipeline.</p>
      <p>The constraint value is a java regex string.</p>
  `,
  "pipeline.config.trigger.pubsub.attributeConstraints": `
      <p>Pubsub messages can have system-specific metadata accompanying the payload called <b>attributes</b>.</p>
      <p>When provided, only a pubsub message with attributes containing at least the specified key/value pairs will be allowed to trigger this pipeline.</p>
      <p>The constraint value is a java regex string.</p>
  `,
  "pipeline.config.trigger.pubsub.payloadConstraints": `
      <p>
        When provided, only a pubsub message with a payload containing at least the specified
        key/value pairs will be allowed to trigger this pipeline. For example, if you wanted
        to restrict the systems/users that can trigger this pipeline via this pubsub
        subscription, you could require the key "secret" and value "something-secret" as a constraint.
      </p>
      <p>
        The key/value pairs are matched against the unprocessed payload body, prior to any
        transformation using, for example, a Jinja template in a pubsub subscription configuration.
      </p>
      <p>The constraint value is a java regex string.</p>
  `,
  "pipeline.config.findArtifactFromExecution.considerExecutions": `
      <p>Select the types of executions to consider. When no selection is made, the default is "any execution".</p>
      <p>This will always evaluate to the most recent execution matching your provided criteria.</p>
  `,
  "pipeline.config.tags": `<p>Pipeline tags let you filter pipelines/executions by addition dimensions in the executions page</p>`,
  "loadBalancer.advancedSettings.healthTimeout": "<p>Configures the timeout, in seconds, for reaching the healthCheck target.  Must be less than the interval.</p><p> Default: <b>5</b></p>",
  "loadBalancer.advancedSettings.idleTimeout": "<p>Configures the idle timeout, in seconds. If no data has been sent or received by the time that the idle timeout period elapses, the load balancer closes the connection. </p><p> Default: <b>60</b></p>",
  "loadBalancer.advancedSettings.deletionProtection": "<p>To prevent your load balancer from being deleted accidentally, you can enable deletion protection.</p><p> Default: <b>false</b></p>",
  "loadBalancer.advancedSettings.healthInterval": "<p>Configures the interval, in seconds, between ELB health checks.  Must be greater than the timeout.</p><p>Default: <b>10</b></p>",
  "loadBalancer.advancedSettings.healthyThreshold": "<p>Configures the number of healthy observations before reinstituting an instance into the ELB\u2019s traffic rotation.</p><p>Default: <b>10</b></p>",
  "loadBalancer.advancedSettings.unhealthyThreshold": "<p>Configures the number of unhealthy observations before deservicing an instance from the ELB.</p><p>Default: <b>2</b></p>",
  "loadBalancer.advancedSettings.loadBalancingCrossZone": "<p>Cross-zone load balancing distributes traffic evenly across all targets in the Availability Zones enabled for the load balancer.</p><p> Default: <b>True</b></p>",
  "loadBalancer.advancedSettings.albIpAddressType": '<p>Assigns both a v4 and v6 IP address to the load balancer. If left unchecked, this value will default to <b>"ipv4"</b>.</p>',
  "loadBalancer.advancedSettings.nlbIpAddressType": '<p>Assigns both a v4 and v6 IP address to the load balancer. This option is only valid for NLBs which are external and only have Ip targets (not instance targets). If left unchecked, this value will default to <b>"ipv4"</b>.</p>',
  "pipeline.config.resizeAsg.action": `
      <p>Configures the resize action for the target server group.
      <ul>
        <li><b>Scale Up</b> increases the size of the target server group by an incremental or percentage amount</li>
        <li><b>Scale Down</b> decreases the size of the target server group by an incremental or percentage amount</li>
        <li><b>Scale to Cluster Size</b> increases the size of the target server group to match the largest server group in the cluster, optionally with an incremental or percentage additional capacity. Additional capacity will not exceed the existing maximum size.</li>
        <li><b>Scale to Exact Size</b> adjusts the size of the target server group to match the provided capacity</li>
      </ul></p>`,
  "pipeline.config.resizeAsg.cluster": "<p>Configures the cluster upon which this resize operation will act. The <em>target</em> specifies what server group to resolve for the operation.</p>",
  "pipeline.config.modifyScalingProcess.cluster": "<p>Configures the cluster upon which this modify scaling process operation will act. The <em>target</em> specifies what server group to resolve for the operation.</p>",
  "pipeline.config.enableAsg.cluster": "<p>Configures the cluster upon which this enable operation will act. The <em>target</em> specifies what server group to resolve for the operation.</p>",
  "pipeline.config.disableAsg.cluster": "<p>Configures the cluster upon which this disable operation will act. The <em>target</em> specifies what server group to resolve for the operation.</p>",
  "pipeline.config.destroyAsg.cluster": "<p>Configures the cluster upon which this destroy operation will act. The <em>target</em> specifies what server group to resolve for the operation.</p>",
  "pipeline.config.jenkins.trigger.propertyFile": '<p>(Optional) Configures the name to the Jenkins artifact file used to pass in properties to later stages in the Spinnaker pipeline. The contents of this file will now be available as a map under the trigger and accessible via <em>trigger.properties</em>. See <a target="_blank" href="https://www.spinnaker.io/guides/user/pipeline-expressions/">Pipeline Expressions docs</a> for more information.</p>',
  "pipeline.config.jenkins.trigger.payloadConstraints": `<p>(Optional, Requires Property File) When provided, only a build that contains a Property File with correct constraints will trigger this pipeline.  For example, you could restrict the trigger to certain branches by placing the branch name in your Property File and adding a constraint with a key like "branch" and value "master".</p>
    <p>The constraint values may be supplied as regex.</p>`,
  "pipeline.config.jenkins.propertyFile": '<p>(Optional) Configures the name to the Jenkins artifact file used to pass in properties to later stages in the Spinnaker pipeline. The contents of this file will now be available as a map under the stage context. See <a target="_blank" href="https://www.spinnaker.io/guides/user/pipeline-expressions/">Pipeline Expressions docs</a> for more information.</p>',
  "pipeline.config.travis.job.isFiltered": "<p>Note that for performance reasons, not all jobs are displayed. Please use the search field to limit the number of jobs.</p>",
  "pipeline.config.travis.trigger.propertyFile": '<p>(Optional) Configures the name to the Travis artifact file used to pass in properties to later stages in the Spinnaker pipeline. The contents of this file will now be available as a map under the trigger and accessible via <em>trigger.properties</em>. See <a target="_blank" href="https://www.spinnaker.io/guides/user/pipeline-expressions/">Pipeline Expressions docs</a> for more information.</p>',
  "pipeline.config.travis.trigger.payloadConstraints": `<p>(Optional, Requires Property File) When provided, only a build that contains a Property File with correct constraints will trigger this pipeline.  For example, you could restrict the trigger to certain branches by placing the branch name in your Property File and adding a constraint with a key like "branch" and value "master".</p>
    <p>The constraint values may be supplied as regex.</p>`,
  "pipeline.config.travis.propertyFile": '<p>(Optional) Configures the name to the Travis artifact file used to pass in properties to later stages in the Spinnaker pipeline. The contents of this file will now be available as a map under the stage context. See <a target="_blank" href="https://www.spinnaker.io/guides/user/pipeline-expressions/">Pipeline Expressions docs</a> for more information.</p>',
  "pipeline.config.bake.skipRegionDetection": `
        <p>By default, Spinnaker will detect regions to bake in from downstream deploy stages.</p>
        <p>To prevent failed deploys from accidentally missed regions during the bake process.</p>
        <p>This setting will disable this detection mechanism.</p>`,
  "pipeline.config.bake.package": `
      <p>The name of the package you want installed (without any version identifiers).</p>
      <p>If your build produces a deb file named "myapp_1.27-h343", you would want to enter "myapp" here.</p>
      <p>If there are multiple packages (space separated), then they will be installed in the order they are entered.</p>`,
  "pipeline.config.bake.packageArtifacts": `
      <p>Artifacts representing packages you want installed.</p>
      <p>These artifacts must be either deb or rpm packages, whichever applies to the operating system on your base image.</p>
      <p>Package artifacts are installed in order, after any packages in the 'Packages' field are installed.</p>`,
  "pipeline.config.docker.bake.targetImage": "<p>The name of the resulting docker image.</p>",
  "pipeline.config.docker.bake.targetImageTag": "<p>The tag of the resulting docker image, defaults to commit hash if available.</p>",
  "pipeline.config.docker.bake.organization": "<p>The name of the organization or repo to use for the resulting docker image.</p>",
  "pipeline.config.bake.baseAmi": "<p>(Optional) If Base AMI is specified, this will be used instead of the Base OS provided",
  "pipeline.config.bake.amiSuffix": "<p>(Optional) String of date in format YYYYMMDDHHmm, default is calculated from timestamp,</p>",
  "pipeline.config.bake.amiName": "<p>(Optional) Default = $package-$arch-$ami_suffix-$store_type</p>",
  "pipeline.config.bake.templateFileName": "<p>(Optional) The explicit packer template to use, instead of resolving one from rosco's configuration.</p>",
  "pipeline.config.bake.varFileName": "<p>(Optional) The name of a json file containing key/value pairs to add to the packer command.</p>",
  "pipeline.config.bake.extendedAttributes": "<p>(Optional) Any additional attributes that you want to pass onto rosco, which will be injected into your packer runtime variables.</p>",
  "pipeline.config.cf.createservice.updatable": "<p>If checked, this will try to update the existing service. If not, if the service exists this stage will succeed and not try to update.</p>",
  "pipeline.config.cf.createservice.versioned": "<p>If checked, this stage should always deploy a new service with an incremented version number (mysql-v001).</p>",
  "pipeline.config.manualJudgment.instructions": "<p>(Optional) Instructions are shown to the user when making a manual judgment.</p><p>May contain HTML.</p>",
  "pipeline.config.manualJudgment.propagateAuthentication": `
      <p><strong>Checked</strong> - the pipeline will continue with the permissions of the approver.</p>
      <p><strong>Unchecked</strong> - the pipeline will continue with its current permissions.</p>`,
  "pipeline.config.manualJudgment.judgmentInputs": `
      <p>(Optional) Entries populate a dropdown displayed when performing a manual judgment.</p>
      <p>The selected value can be used in a subsequent <strong>Check Preconditions</strong> stage to determine branching.</p>
      <p>For example, if the user selects "rollback" from this list of options, that branch can be activated by using the expression:
        <samp class="small">execution.stages[n].context.judgmentInput=="rollback"</samp></p>`,
  "pipeline.config.bake.manifest.expectedArtifact": "<p>This is the template you want to render.</p>",
  "pipeline.config.bake.manifest.overrideExpressionEvaluation": '<p>Explicitly evaluate SpEL expressions in overrides just prior to manifest baking. Can be paired with the "Skip SpEL evaluation" option in the Deploy Manifest stage when baking a third-party manifest artifact with expressions not meant for Spinnaker to evaluate as SpEL.</p>',
  "pipeline.config.bake.manifest.templateRenderer": "<p>This is the engine used for rendering your manifest.</p>",
  "pipeline.config.bake.manifest.helm.chartFilePath": `
    <p>This is the relative path to the directory containing the Chart.yaml file within your Git repo.</p>
    <p>e.g.: <b>helm/my-chart</b></p>`,
  "pipeline.config.bake.manifest.helm.rawOverrides": "Use <i>--set</i> instead of <i>--set-string</i> when injecting override values. Values injected using <i>--set</i> will be converted to primitive types by Helm.",
  "pipeline.config.bake.manifest.helm.includeCRDs": "<p>Include Custom Resource Definitions in the templated output.</p>",
  "pipeline.config.bake.manifest.kustomize.filePath": `
    <p>This is the relative path to the kustomization.yaml file within your Git repo.</p>
    <p>e.g.: <b>examples/wordpress/mysql/kustomization.yaml</b></p>`,
  "pipeline.config.bake.manifest.helmfile.filePath": `
    <p>This is the relative path to the directory containing the helmfile.yaml file within your Git repo.</p>
    <p>e.g.: <b>chart/helmfile.yml</b></p>`,
  "pipeline.config.bake.manifest.helmfile.name": "<p> Name is used to set the expected artifact in the Produces Artifact section. </p>",
  "pipeline.config.bake.cf.manifest.name": "<p> Name should be the same as the expected artifact in the Produces Artifact section. </p>",
  "pipeline.config.bake.cf.manifest.templateArtifact": `
    <p> This is the manifest template needing resolution. Variables in this template should use double parentheses notation.</p>
    <p>e.g.: </p>
    <p>---</p>
    <p>buildpack: ((javabuildpack)) </p>
    <p>foo: ((some.nestedKey)) </p>`,
  "pipeline.config.bake.cf.manifest.varsArtifact": `
    <p> These are the variables that will be substituted in the manifest template. These should be yaml files and follow standard convention. </p>
    <p>e.g.: </p>
    <p>---</p>
    <p>javabuildpack: java_buildpack_offline </p>
    <p>some: </p>
    <p style="padding-left: 1em">nestedKey: bar </p>`,
  "pipeline.config.haltPipelineOnFailure": "Immediately halts execution of all running stages and fails the entire execution.",
  "pipeline.config.haltBranchOnFailure": "Prevents any stages that depend on this stage from running, but allows other branches of the pipeline to run.",
  "pipeline.config.haltBranchOnFailureFailPipeline": "Prevents any stages that depend on this stage from running, but allows other branches of the pipeline to run. The pipeline will be marked as failed once complete.",
  "pipeline.config.ignoreFailure": "Continues execution of downstream stages, marking this stage as failed/continuing.",
  "pipeline.config.jenkins.markUnstableAsSuccessful.true": "If Jenkins reports the build status as UNSTABLE, Spinnaker will mark the stage as SUCCEEDED and continue execution of the pipeline.",
  "pipeline.config.jenkins.markUnstableAsSuccessful.false": `
      If Jenkins reports the build status as UNSTABLE,
      Spinnaker will mark the stage as FAILED; subsequent execution will be determined based on the configuration of the
      <b>If build fails</b> option for this stage.`,
  "pipeline.config.travis.markUnstableAsSuccessful.true": "If Travis reports the build status as UNSTABLE, Spinnaker will mark the stage as SUCCEEDED and continue execution of the pipeline.",
  "pipeline.config.travis.markUnstableAsSuccessful.false": `
      If Travis reports the build status as UNSTABLE,
      Spinnaker will mark the stage as TERMINAL; subsequent execution will be determined based on the configuration of the
      <b>If build fails</b> option for this stage.`,
  "pipeline.config.wercker.markUnstableAsSuccessful.true": "If Wercker reports the build status as UNSTABLE, Spinnaker will mark the stage as SUCCEEDED and continue execution of the pipeline.",
  "pipeline.config.wercker.markUnstableAsSuccessful.false": `
      If Wercker reports the build status as UNSTABLE,
      Spinnaker will mark the stage as FAILED; subsequent execution will be determined based on the configuration of the
      <b>If build fails</b> option for this stage.`,
  "pipeline.config.cron.expression": '<strong>Format (Year is optional)</strong><p><samp>Seconds  Minutes  Hour  DayOfMonth  Month  DayOfWeek  (Year)</samp></p><p><strong>Example: every 30 minutes</strong></p><samp>0 0/30 * * * ?</samp><p><strong>Example: every Monday at 10 am</strong></p><samp>0 0 10 ? * 2</samp><p><strong>Note:</strong> values for "DayOfWeek" are 1-7, where Sunday is 1, Monday is 2, etc. You can also use MON,TUE,WED, etc.',
  "cluster.rollback.explicit": `
      <p>A server group running the previous build will be enabled and appropriately resized.</p>
      <p>The current server group will be disabled after the resize completes.</p>
  `,
  "cluster.rollback.previous_image": `
      <p>The current server group will be cloned with the previous build.</p>
  `,
  "pipeline.config.findAmi.cluster": "The cluster to look at when selecting the image to use in this pipeline.",
  "pipeline.config.findAmi.imageNamePattern": "A regex used to match the name of the image. Must result in exactly one match to succeed. Empty is treated as match any.",
  "pipeline.config.dependsOn": "Declares which stages must be run <em>before</em> this stage begins.",
  "pipeline.config.parallel.cancel.queue": "<p>If concurrent pipeline execution is disabled, then the pipelines that are in the waiting queue will get canceled when the next execution starts. <br><br>Check this box if you want to keep them in the queue.</p>",
  "pipeline.config.parallel.max.concurrent": "<p>If concurrent pipeline execution is enabled, this variable sets the maximum number of concurrent pipelines executing. <br><br>If set to 0, then max is unlimited.</p>",
  "pipeline.config.timeout": `
      <p>Allows you to force the stage to fail if its running time exceeds a specific length.</p>
      <p><b>Note:</b> By default, Spinnaker will use sensible timeouts that depend on the stage type and the operations the stage needs to perform at runtime. These defaults can vary based on chosen configuration and other external factors.
      </p>`,
  "pipeline.config.trigger.runAsUser": "The current user must have access to the specified service account, and the service account must have access to the current application. Otherwise, you'll receive an 'Access is denied' error.",
  "pipeline.config.trigger.authorizedUser": "The current user must have the permission to approve the manual judgment stage. Otherwise, you'll not be able continue to the next pipeline stage.",
  "pipeline.config.script.repoUrl": "<p>Path to the repo hosting the scripts in Stash. (e.g. <samp>CDL/mimir-scripts</samp>). Leave empty to use the default.</p>",
  "pipeline.config.script.repoBranch": "<p>Git Branch. (e.g. <samp>master</samp>). Leave empty to use the master branch.</p>",
  "pipeline.config.script.path": "<p>Path to the folder hosting the scripts in Stash. (e.g. <samp>groovy</samp>, <samp>python</samp> or <samp>shell</samp>)</p>",
  "pipeline.config.script.command": "<p>Executable script and parameters. (e.g. <samp>script.py --ami-id ${deploymentDetails[0].ami}</samp> ) </p>",
  "pipeline.config.script.image": "<p>(Optional) image passed down to script execution as IMAGE_ID</p>",
  "pipeline.config.script.account": "<p>(Optional) account passed down to script execution as ENV_PARAM</p>",
  "pipeline.config.script.region": "<p>(Optional) region passed down to script execution as REGION_PARAM</p>",
  "pipeline.config.script.cluster": "<p>(Optional) cluster passed down to script execution as CLUSTER_PARAM</p>",
  "pipeline.config.script.cmc": "<p>(Optional) cmc passed down to script execution as CMC</p>",
  "pipeline.config.script.propertyFile": "<p>(Optional) The name to the properties file produced by the script execution to be used by later stages of the Spinnaker pipeline. </p>",
  "pipeline.config.docker.trigger.tag": "<p>(Optional) If specified, only the tags that match this Java Regular Expression will be triggered. Leave empty to trigger builds on any tag pushed.</p><p>Builds will not be triggered off the latest tag or updates to existing tags.</p>",
  "pipeline.config.docker.trigger.digest": "<p>The SHA256 hash of the image.</p>",
  "pipeline.config.git.trigger.branch": "<p>(Optional) If specified, only pushes to the branches that match this Java Regular Expression will be triggered. Leave empty to trigger builds for every branch.</p>",
  "pipeline.config.git.trigger.githubSecret": '<p>(Optional, but recommended) If specified, verifies GitHub as the sender of this trigger. See <a target="_blank" href="https://developer.github.com/webhooks/securing/">GitHub docs</a> for more information.</p>',
  "serverGroup.ipv6": `<p>Associating an IPv6 address to nodes allows for ingress and egress communication over IPv6. Most modern software supports IPv6 and enablement is transparent. This is an incremental addition to IPv4 and will not remove the ability for connectivity over IPv4.</p>`,
  "serverGroupCapacity.useSourceCapacityTrue": `
      <p>Spinnaker will use the current capacity of the existing server group when deploying a new server group.</p>
      <p>This setting is intended to support a server group with auto-scaling enabled, where the bounds and desired capacity are controlled by an external process.</p>
      <p>In the event that there is no existing server group, the deploy will fail.</p>`,
  "serverGroupCapacity.useSourceCapacityFalse": "<p>The specified capacity is used regardless of the presence or size of an existing server group.</p>",
  "strategy.redblack.scaleDown": `
      <p>Resizes the target server group to zero instances before disabling it.</p>
      <p>Select this if you wish to retain the launch configuration for the old server group without running any instances.</p>`,
  "strategy.redblack.maxRemainingAsgs": `
      <p><b>Optional</b>: indicates the maximum number of server groups that will remain in this cluster - including the newly created one.</p>
      <p>If you wish to destroy all server groups except the newly created one, select "Highlander" as the strategy.</p>
      <p><strong>Minimum value:</strong> 2</p>`,
  "strategy.redblack.rollback": `
    <p>Disable the new server group and ensure that the previous server group is restored to its original capacity.</p>
    <p>The rollback <strong>will only be</strong> initiated if instances in the new server group fail to launch and become healthy.</p>
    <p>Should an error occur disabling or destroying other server groups in the cluster, the new server group <strong>will not be</strong> rolled back.</p>
  `,
  "strategy.rollingPush.relaunchAll": "<p>Incrementally terminates each instance in the server group, waiting for a new one to come up before terminating the next one.</p>",
  "strategy.rollingPush.totalRelaunches": "<p>Total number of instances to terminate and relaunch.</p>",
  "strategy.rollingPush.concurrentRelaunches": "<p>Number of instances to terminate and relaunch at a time.</p>",
  "strategy.rollingPush.concurrentRelaunches.migration": `
    <p>Number of instances to terminate and relaunch at a time.</p>
    <p>Can be expressed as an explicit instance count or as a percentage of instances in server group being migrated.</p>
  `,
  "strategy.rollingPush.order": `
      <p>Determines the order in which instances will be terminated.
      <ul><li><b>Oldest</b> will terminate the oldest instances first</li>
      <li><b>Newest</b> will terminate those most recently launched.</li></ul></p>`,
  "strategy.rollingRedBlack.targetPercentages": "<p>Rolling red black will slowly scale up the new server group. It will resize the new server group by each percentage defined.</p>",
  "strategy.rollingRedBlack.rollback": "<p>Disable the new server group and ensure that the previous server group is restored to its original capacity.</p>",
  "strategy.monitored.deploySteps": "<p>Monitored Deploy will scale up the new server group as specified by these per cent steps. After each step, the health of the new server group will be evaluated by the specified deployment monitor.</p>",
  "strategy.monitored.rollback": "<p>If deploy fails, disable the new server group and ensure that the previous server group is active and restored to its original capacity.</p>",
  "strategy.monitored.destroyFailedAsg": "<p>If deploy fails and rollback succeeds destroys the server group that failed the deploy instead of just disabling it.</p>",
  "loadBalancers.filter.serverGroups": `
      <p>Displays all server groups configured to use the load balancer.</p>
      <p>If the server group is configured to <em>not</em> add new instances to the load balancer, it will be grayed out.</p>`,
  "loadBalancers.filter.instances": `
      <p>Displays all instances in the context of their parent server group. The color of the instance icon
        indicates <em>only its health in relation to the load balancer</em>. That is, if the load balancer health check reports the instance
        as healthy, the instance will appear green - even if other health indicators (Discovery, other load balancers, etc.) report the instance
        as unhealthy.</p>
      <p>A red icon indicates the instance is failing the health check for the load balancer.</p>
      <p>A gray icon indicates the instance is currently detached from the load balancer.</p>`,
  "loadBalancers.filter.onlyUnhealthy": `
      <p>Filters the list of load balancers and server groups (if enabled)
      to only show load balancers with instances failing the health check for the load balancer.</p>`,
  "project.cluster.stack": "<p>(Optional field)</p><p>Filters displayed clusters by stack.</p><p>Enter <samp>*</samp> to include all stacks; leave blank to omit any clusters with a stack.</p><p>Only <samp>*</samp> is valid for Kubernetes V2 accounts.</p>",
  "project.cluster.detail": "<p>(Optional field)</p><p>Filters displayed clusters by detail.</p><p>Enter <samp>*</samp> to include all details; leave blank to omit any clusters with a detail.</p><p>Only <samp>*</samp> is valid for Kubernetes V2 accounts.</p>",
  "instanceType.storageOverridden": "<p>These storage settings have been cloned from the base server group and differ from the default settings for this instance type.</p>",
  "instanceType.unavailable": "<p>This instance type is not available for the selected configuration.</p>",
  "execution.forceRebake": `
      <p>By default, the bakery will <b>not</b> create a new image if the contents of the package and base image have not changed.
        Instead, it will return the previously baked image, though this behavior is not guaranteed.</p>
      <p>Select this option to force the bakery to create a new image, regardless of whether or not a matching image exists.</p>`,
  "execution.dryRun": `
      <p>Select this option to run the pipeline without <em>really</em> executing anything.</p>
      <p>This is a good way to test parameter-driven behavior, expressions, optional stages, etc.</p>`,
  "user.verification": `
      Typing into this verification field is annoying! But it serves as a reminder that you are
      changing something in an account deemed important, and prevents you from accidentally changing something
      when you meant to click on the "Cancel" button.`,
  "pipeline.skipDownstreamOutput": "when checked, the output of the child pipeline is not added to the pipeline context",
  "pipeline.waitForCompletion": "if unchecked, marks the stage as successful right away without waiting for the pipeline to complete",
  "jenkins.waitForCompletion": "if unchecked, marks the stage as successful right away without waiting for the Jenkins job to complete",
  "travis.waitForCompletion": "if unchecked, marks the stage as successful right away without waiting for the Travis job to complete",
  "wercker.waitForCompletion": "if unchecked, marks the stage as successful right away without waiting for the Wercker job to complete",
  "script.waitForCompletion": "if unchecked, marks the stage as successful right away without waiting for the script to complete",
  "markdown.examples": `
    Some examples of markdown syntax: <br/> \`*italic*\` <br/> \`**bold**\` <br/> \`[link text](http://url-goes-here)\`
  `,
  "pipeline.config.webhook.payload": "JSON payload to be added to the webhook call.",
  "pipeline.config.webhook.cancelPayload": "JSON payload to be added to the webhook call when it is called in response to a cancellation.",
  "pipeline.config.webhook.waitForCompletion": "If not checked, we consider the stage succeeded if the webhook returns an HTTP status code 2xx, otherwise it will be failed. If checked, it will poll a status url (defined below) to determine the progress of the stage.",
  "pipeline.config.webhook.statusUrlResolutionIsGetMethod": "Use the webhook's URL with GET method as status endpoint.",
  "pipeline.config.webhook.statusUrlResolutionIsLocationHeader": "Pick the status url from the Location header of the webhook's response call.",
  "pipeline.config.webhook.statusUrlResolutionIsWebhookResponse": "Pick the status url from the JSON returned by the webhook's response call.",
  "pipeline.config.webhook.statusUrlJsonPath": "JSON path to the status url in the webhook's response JSON. (i.e. <samp>$.buildInfo.url</samp>)",
  "pipeline.config.webhook.retryStatusCodes": "Normally, webhook stages only retry on 429 and 5xx status codes. <br>You can specify additional status codes here that will cause the monitor to retry (e.g. <samp>404, 418</samp>)",
  "pipeline.config.webhook.waitBeforeMonitor": "Optional delay (in seconds) to wait before starting to poll the endpoint for monitoring status",
  "pipeline.config.webhook.statusJsonPath": "JSON path to the status information in the webhook's response JSON (e.g. <samp>$.buildInfo.status</samp>). <br>If left empty, a 200 response from the status endpoint will be treated as a success.",
  "pipeline.config.webhook.progressJsonPath": "JSON path to a descriptive message about the progress in the webhook's response JSON. (e.g. <samp>$.buildInfo.progress</samp>)",
  "pipeline.config.webhook.successStatuses": "Comma-separated list of strings (that will be returned in the response body in the previously defined `statusJsonPath` field) that will be considered as SUCCESS status.",
  "pipeline.config.webhook.canceledStatuses": "Comma-separated list of strings (that will be returned in the response body in the previously defined `statusJsonPath` field) that will be considered as CANCELED status.",
  "pipeline.config.webhook.terminalStatuses": "Comma-separated list of strings (that will be returned in the response body in the previously defined `statusJsonPath` field) that will be considered as TERMINAL status.",
  "pipeline.config.webhook.customHeaders": "Key-value pairs to be sent as additional headers to the service.",
  "pipeline.config.webhook.failFastCodes": "Comma-separated HTTP status codes (4xx or 5xx) that will cause this webhook stage to fail without retrying.",
  "pipeline.config.webhook.signalCancellation": "Trigger a specific webhook if this stage is cancelled by user or due to pipeline failure",
  "pipeline.config.parameter.label": "(Optional): a label to display when users are triggering the pipeline manually",
  "pipeline.config.parameter.description": `(Optional): if supplied, will be displayed to users as a tooltip
      when triggering the pipeline manually. You can include HTML in this field.`,
  "pipeline.config.parameter.pinned": `(Optional): if checked, this parameter will be always shown in a pipeline execution view, otherwise it'll be collapsed by default.`,
  "pipeline.config.parameter.pinAll": `(Optional): if checked, all parameters will be shown in a pipeline execution view.`,
  "pipeline.config.failOnFailedExpressions": `When this option is enabled, the stage will be marked as failed if it contains any failed expressions`,
  "pipeline.config.roles.help": `
    <p> When the pipeline is triggered using an automated trigger, these roles will be used to decide if the pipeline has permissions to access a protected application or account.</p>
    <ul>
    <li>
    To read from a protected application or account, the pipeline must have at least one role that has read access to the application or account.
    </li>
    <li>
    To write to a protected application or account, the pipeline must have at least one role that has write access to the application or account.
    </li>
    </ul>
    <p><strong>Note:</strong> To prevent privilege escalation vulnerabilities, a user must be a member of <strong>all</strong> of the groups specified here in order to modify, and execute the pipeline.</p>`,
  "pipeline.config.entitytags.namespace": `All tags have an associated namespace (<strong>default</strong> will be used if unspecified) that provides a means of grouping tags by a logical owner.`,
  "pipeline.config.entitytags.value": `Value can either be a string or an object. If you want to use an object, input a valid JSON string.`,
  "pipeline.config.entitytags.region": `(Optional) Target a specific region, use * if you want to apply to all regions.`,
  "pipeline.config.deliveryConfig.manifest": `(Optional) Name of the file with your Delivery Config manifest. Leave blank to use the default name (<strong><i>${(_a$1 = SETTINGS.managedDelivery) == null ? void 0 : _a$1.defaultManifest}</i></strong>).`,
  "pipeline.config.codebuild.source": `(Optional) Source of the build. It will be overridden to Spinnaker artifact if checked. If not checked, source configured in CodeBuild project will be used.`,
  "pipeline.config.codebuild.sourceType": `(Optional) Type of the source. It can be specified explicitly; otherwise, it will be inferred from source artifact.`,
  "pipeline.config.codebuild.sourceVersion": `(Optional) Source version of the build. If not specified, the artifact version will be used. If artifact doesn't have a version, the latest version will be used. See the <a href="https://docs.aws.amazon.com/codebuild/latest/APIReference/API_StartBuild.html#CodeBuild-StartBuild-request-sourceVersion">CodeBuild reference</a> for more information.`,
  "pipeline.config.codebuild.buildspec": `(Optional) Inline buildspec definition of the build. If not specified, buildspec configured in CodeBuild project will be used.`,
  "pipeline.config.codebuild.secondarySources": `(Optional) Secondary sources of the build. It can be overridden by adding Spinnaker Artifacts. If not specified, secondary sources configured in CodeBuild project will be used.`,
  "pipeline.config.codebuild.secondarySourcesVersionOverride": `(Optional) Existing secondary sources version overrides. Pre-defined secondary source's version can be overriden by specifying the source identifier and version. If not specified, secondary sources configured in CodeBuild project will be used.`,
  "pipeline.config.codebuild.sourceIdentifier": `(Optional) Name of a pre-defined secondary source.`,
  "pipeline.config.codebuild.secondarySourceVersion": `Version of secondary source identifier to use. Required if specifying a source identifier.`,
  "pipeline.config.codebuild.image": `(Optional) Image in which the build will run. It can be overridden by specifying the name of the image. If not specified, image configured in CodeBuild project will be used.`,
  "pipeline.config.codebuild.envVar": `(Optional) Environment variables that will be propagated into the build.`
};
Object.keys(helpContents$4).forEach((key) => HelpContentsRegistry.register(key, helpContents$4[key]));

var css_248z$2l = ".sp-formSection {\n  border: 1px solid var(--color-concrete);\n  border-radius: 16px;\n  max-width: 800px;\n  overflow: hidden;\n  margin-bottom: 16px;\n  box-shadow: 0 4px 0 0 var(--color-concrete);\n  background-color: var(--color-white);\n  padding-bottom: 8px;\n}\n.sp-formSection__header {\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 1px solid var(--color-concrete);\n  display: flex;\n  align-items: center;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.06);\n  padding: 8px 16px;\n  margin-bottom: 8px;\n}\n.sp-formSection__header .title {\n  flex: 1 1 auto;\n  min-height: 48px;\n}\n.sp-formGroup {\n  border: 1px solid var(--color-titanium);\n  border-radius: 8px;\n  box-shadow: 0 2px 0 0 var(--color-titanium);\n  max-width: 800px;\n  margin-bottom: 16px;\n  overflow: visible;\n}\n.sp-formItem {\n  font-size: 14px;\n  padding: 0 0 8px 16px;\n  max-width: 800px;\n}\n@media only screen and (min-width: 640px) {\n  .sp-formItem {\n    display: flex;\n  }\n}\n.sp-formItem .help-contents {\n  font-style: italic;\n}\n.groupHeader {\n  background-color: rgba(0, 0, 0, 0.025);\n  border-bottom: 1px dotted var(--color-concrete);\n  padding-bottom: 0;\n  margin-bottom: 7px;\n  padding-top: 8px;\n}\n.sp-formItem__left {\n  display: flex;\n}\n@media only screen and (min-width: 640px) {\n  .sp-formItem__left {\n    flex: 0 0 32%;\n  }\n}\n@media only screen and (min-width: 640px) {\n  .sp-formItem__right {\n    flex: 0 0 68%;\n    padding: 0 14px;\n  }\n}\n.sp-formLabel {\n  align-self: flex-end;\n  margin-left: 8px;\n  margin-bottom: 4px;\n  flex: 1 1 100%;\n  font-size: 13px;\n  font-weight: 700;\n}\n@media only screen and (min-width: 640px) {\n  .sp-formLabel {\n    align-self: flex-start;\n    text-align: right;\n    margin: 6px 0 8px 0;\n  }\n}\n.sp-formLabel .optional {\n  font-weight: 600;\n  font-style: italic;\n  font-size: 12px;\n}\n.sp-formActions {\n  white-space: nowrap;\n}\n.sp-formActions .action {\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  padding: 3px 4px;\n  border: 1px solid var(--color-concrete);\n  cursor: pointer;\n  border-radius: 2px;\n  margin-left: 4px;\n}\n@media only screen and (min-width: 640px) {\n  .sp-formActions .action {\n    margin-left: 2px;\n  }\n}\n.sp-formActions .action [class^='icon-'],\n.sp-formActions .action [class*=' icon-'] {\n  font-size: 24px;\n}\n.sp-formActions--mobile {\n  flex: 1 0 1px;\n  margin-bottom: 8px;\n  align-self: flex-end;\n}\n@media only screen and (min-width: 640px) {\n  .sp-formActions--mobile {\n    display: none;\n  }\n}\n.sp-formActions--web {\n  display: none;\n}\n@media only screen and (min-width: 640px) {\n  .sp-formActions--web {\n    display: block;\n  }\n}\n.sp-form {\n  display: flex;\n  width: 100%;\n  margin-bottom: 8px;\n}\n.sp-form .prefix,\n.sp-form .suffix {\n  flex: 0 1 auto;\n  margin: 8px 4px 8px 0;\n  align-self: center;\n  word-break: break-all;\n}\n.sp-form .suffix {\n  margin-left: 4px;\n  margin-right: 6px;\n}\n.sp-form .field {\n  flex: 1 1 auto;\n  min-width: 100px;\n}\n.sp-form .field .input {\n  flex-grow: 1;\n}\n.sp-form .Select-input input {\n  border: none !important;\n  padding: 8px 0 12px;\n}\n.sp-form .is-open .Select-value-label {\n  opacity: 0.6;\n}\n.sp-form input[type='text'] {\n  border: 1px solid var(--color-concrete);\n  border-radius: 2px;\n  width: 100%;\n  height: 32px;\n  padding: 0 8px;\n  background-color: transparent;\n  font-size: 14px;\n}\n.sp-form input[type='checkbox'] {\n  background-color: var(--color-danger);\n}\n";
styleInject(css_248z$2l);

function ResponsiveFieldLayout(props) {
  const { label, help, input, actions, validation = {} } = props;
  const { hidden, messageNode, category } = validation;
  const showLabel = !!label || !!help;
  const helpUnder = false;
  return /* @__PURE__ */ React__default.createElement(HelpTextExpandedContext.Provider, {
    value: helpUnder
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-formItem"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-formItem__left"
  }, showLabel && /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-formLabel"
  }, label, " ", help)), /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-formItem__right"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-form"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "flex-container-h margin-between-lg field"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "input"
  }, input), actions)), helpUnder  , !hidden && /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    message: messageNode,
    type: category
  }))));
}

function renderContent(Content, props) {
  if (isFunction(Content)) {
    const renderFunction = Content;
    return renderFunction(props);
  }
  return Content;
}

class ExpressionError extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { showContextModal: false };
  }
  render() {
    const { spelError } = this.props;
    if (!spelError || !spelError.message) {
      return null;
    }
    const toggleModal = () => this.setState((state) => ({ showContextModal: !state.showContextModal }));
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Modal$1, {
      show: this.state.showContextModal,
      onHide: toggleModal
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, spelError.message)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("pre", null, spelError.context)), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
      className: "primary passive",
      type: "button",
      onClick: toggleModal
    }, "Close"))), /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      type: "error",
      message: spelError.message
    }), /* @__PURE__ */ React__default.createElement("button", {
      className: "link",
      type: "button",
      onClick: toggleModal
    }, "Show expression context where the error occurred"));
  }
}

class TextInput extends React__default.Component {
  render() {
    const { value, validation, inputClassName, prefix, ...otherProps } = this.props;
    const className = `TextInput form-control ${orEmptyString(inputClassName)} ${validationClassName(validation)}`;
    const inputTag = /* @__PURE__ */ React__default.createElement("input", {
      className,
      type: "text",
      autoComplete: "off",
      value: orEmptyString(value),
      ...otherProps
    });
    if (prefix) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "flex-container-h middle"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "sp-padding-xs-right body-regular"
      }, prefix), inputTag);
    } else {
      return inputTag;
    }
  }
}

const literalExpression = (literalString) => SpelExpressionEvaluator.compile(`'${literalString.replace(/'/g, "''")}'`);
class Bracket {
  constructor(bracket, pos) {
    this.bracket = bracket;
    this.pos = pos;
  }
  static theOpenBracketFor(closeBracket) {
    if (closeBracket === "}") {
      return "{";
    } else if (closeBracket === "]") {
      return "[";
    }
    return "(";
  }
  static theCloseBracketFor(openBracket) {
    if (openBracket === "{") {
      return "}";
    } else if (openBracket === "[") {
      return "]";
    }
    return ")";
  }
  compatibleWithCloseBracket(closeBracket) {
    if (this.bracket === "{") {
      return closeBracket === "}";
    } else if (this.bracket === "[") {
      return closeBracket === "]";
    }
    return closeBracket === ")";
  }
}
class TemplateAwareExpressionParser {
  parseExpressions(expressionString) {
    const expressions = [];
    const prefix = "${";
    const suffix = "}";
    let startIdx = 0;
    while (startIdx < expressionString.length) {
      const prefixIndex = expressionString.indexOf(prefix, startIdx);
      if (prefixIndex >= startIdx) {
        if (prefixIndex > startIdx) {
          expressions.push(literalExpression(expressionString.substring(startIdx, prefixIndex)));
        }
        const afterPrefixIndex = prefixIndex + prefix.length;
        const suffixIndex = this.skipToCorrectEndSuffix(suffix, expressionString, afterPrefixIndex);
        if (suffixIndex === -1) {
          throw new Error("No ending suffix '" + suffix + "' for expression starting at character " + prefixIndex + ": " + expressionString.substring(prefixIndex));
        }
        if (suffixIndex === afterPrefixIndex) {
          throw new Error("No expression defined within delimiter '" + prefix + suffix + "' at character " + prefixIndex);
        }
        const expr = expressionString.substring(prefixIndex + prefix.length, suffixIndex).trim();
        if (!expr) {
          throw new Error("No expression defined within delimiter '" + prefix + suffix + "' at character " + prefixIndex);
        }
        expressions.push(SpelExpressionEvaluator.compile(expr));
        startIdx = suffixIndex + suffix.length;
      } else {
        expressions.push(literalExpression(expressionString.substring(startIdx)));
        startIdx = expressionString.length;
      }
    }
    return expressions;
  }
  isSuffixHere(expressionString, pos, suffix) {
    let suffixPosition = 0;
    for (let i = 0; i < suffix.length && pos < expressionString.length; i++) {
      if (expressionString.charAt(pos++) !== suffix.charAt(suffixPosition++)) {
        return false;
      }
    }
    if (suffixPosition !== suffix.length) {
      return false;
    }
    return true;
  }
  skipToCorrectEndSuffix(suffix, expressionString, afterPrefixIndex) {
    let pos = afterPrefixIndex;
    const maxlen = expressionString.length;
    const nextSuffix = expressionString.indexOf(suffix, afterPrefixIndex);
    if (nextSuffix === -1) {
      return -1;
    }
    const stack = [];
    while (pos < maxlen) {
      if (this.isSuffixHere(expressionString, pos, suffix) && !stack.length) {
        break;
      }
      const ch = expressionString.charAt(pos);
      switch (ch) {
        case "{":
        case "[":
        case "(":
          stack.push(new Bracket(ch, pos));
          break;
        case "}":
        case "]":
        case ")": {
          if (!stack.length) {
            throw new Error(`Found closing '${ch}' at position ${pos} without an opening '${Bracket.theOpenBracketFor(ch)}'`);
          }
          const p = stack.pop();
          if (!p.compatibleWithCloseBracket(ch)) {
            throw new Error("Found closing '" + ch + "' at position " + pos + " but most recent opening is '" + p.bracket + "' at position " + p.pos);
          }
          break;
        }
        case "'":
        case '"': {
          const endLiteral = expressionString.indexOf(ch, pos + 1);
          if (endLiteral === -1) {
            throw new Error("Found non terminating string literal starting at position " + pos);
          }
          pos = endLiteral;
          break;
        }
      }
      pos++;
    }
    if (stack.length) {
      const p = stack.pop();
      throw new Error("Missing closing '" + Bracket.theCloseBracketFor(p.bracket) + "' for '" + p.bracket + "' at position " + p.pos);
    }
    if (!this.isSuffixHere(expressionString, pos, suffix)) {
      return -1;
    }
    return pos;
  }
}
function parseSpelExpressions(template) {
  const spelExpressions = new TemplateAwareExpressionParser().parseExpressions(template);
  spelExpressions.forEach((expr) => {
    const getValue = expr._compiledExpression.getValue;
    expr._compiledExpression.getValue = function() {
      const state = arguments[0];
      try {
        return getValue.apply(expr._compiledExpression, arguments);
      } catch (err) {
        err.state = state;
        throw err;
      }
    };
  });
  return spelExpressions;
}

const evaluateExpression = (context, value) => {
  if (!value) {
    return { value, spelError: null, spelPreview: "" };
  }
  const stringify = (obj) => {
    return obj === null ? "null" : obj === void 0 ? "undefined" : JSON.stringify(obj, null, 2);
  };
  try {
    const exprs = parseSpelExpressions(value);
    const results = exprs.map((expr) => expr.eval(context));
    return { value, spelError: null, spelPreview: results.join("") };
  } catch (err) {
    const spelError = {
      message: null,
      context: null,
      contextTruncated: null
    };
    if (err.name && err.message) {
      if (err.name === "NullPointerException" && err.state && err.state.activeContext) {
        spelError.context = stringify(err.state.activeContext.peek());
        spelError.contextTruncated = truncate(spelError.context, { length: 200 });
      }
      spelError.message = `${err.name}: ${err.message}`;
    } else {
      try {
        spelError.message = JSON.stringify(err);
      } catch (ignored) {
        spelError.message = err.toString();
      }
    }
    return { value, spelError, spelPreview: null };
  }
};

class ExpressionInput extends React__default.Component {
  componentDidUpdate(prevProps) {
    const { context, value } = this.props;
    if (value !== prevProps.value || !isEqual(context, prevProps.context)) {
      const expressionChange = evaluateExpression(context, value);
      this.props.onExpressionChange(expressionChange);
    }
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(TextInput, {
      autoComplete: "off",
      ...this.props
    });
  }
}
ExpressionInput.defaultProps = { context: {}, placeholder: "" };

const ExpressionPreview = ({ spelPreview, markdown }) => /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-container-h baseline margin-between-lg"
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "no-grow"
}, "Preview:"), " ", markdown ? /* @__PURE__ */ React__default.createElement(Markdown, {
  message: spelPreview
}) : /* @__PURE__ */ React__default.createElement("span", null, spelPreview));

class SpelService {
  static evaluateExpression(expression, executionId, stageId) {
    return REST("/pipelines").path(executionId, stageId, "evaluateExpression").query({ expression }).get().then((result) => {
      const errors = result.detail || {};
      const firstErrorKey = Object.keys(errors)[0];
      const firstError = errors[firstErrorKey];
      if (firstError && firstError.length) {
        throw new Error(`${firstError[0].exceptionType}: ${firstError[0].description}`);
      }
      return result.result;
    });
  }
  static parseExpressionString(expression) {
    parseSpelExpressions(expression);
  }
  static includesSpel(value) {
    return isString(value) && value.includes("${");
  }
}

const Nbsp = () => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "\xA0");
class CheckboxInput extends React__default.Component {
  render() {
    const { value, validation, inputClassName, text, wrapperClassName, ...otherProps } = this.props;
    const className = `${orEmptyString(inputClassName)} ${validationClassName(validation)}`;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: classNames("checkbox", wrapperClassName)
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      className,
      type: "checkbox",
      checked: !!value,
      ...otherProps
    }), text ? text : /* @__PURE__ */ React__default.createElement(Nbsp, null)));
  }
}

var css_248z$2k = ".ChecklistInput ul {\n  display: flex;\n  flex-flow: column wrap;\n  list-style: none;\n  padding: 0;\n}\n.ChecklistInput.ChecklistInput_inline ul {\n  flex-flow: row wrap;\n}\n.ChecklistInput.ChecklistInput_inline a.btn {\n  margin: 8px 0 0 10px;\n}\n.ChecklistInput.ChecklistInput_inline li {\n  white-space: nowrap;\n  margin-right: 16px;\n}\n.ChecklistInput.ChecklistInput_inline li.last-of-type {\n  margin-right: 0;\n}\n";
styleInject(css_248z$2k);

const { useEffect: useEffect$9 } = React__default;
function ChecklistInput(props) {
  const { inline, showSelectAll, value, validation, inputClassName, options, stringOptions, onChange } = props;
  function touchField() {
    props.onBlur && props.onBlur(createFakeReactSyntheticEvent({ name: props.name, value }));
  }
  useEffect$9(touchField, []);
  const checkListOptions = isStringArray(stringOptions) ? stringOptions.map((s) => ({ label: s, value: s })) : options || [];
  const selectedValues = value || [];
  const updateSelectedValues = (selectedValues2) => {
    onChange(createFakeReactSyntheticEvent({ value: selectedValues2, name: props.name }));
  };
  const isChecked = (checkboxValue) => selectedValues.includes(checkboxValue);
  const toggleValue = (value2) => {
    const newValues = isChecked(value2) ? selectedValues.filter((x) => x !== value2) : selectedValues.concat(value2);
    onChange(createFakeReactSyntheticEvent({ value: newValues, name: props.name }));
  };
  const allSelected = checkListOptions.every((option) => isChecked(option.value));
  const selectNone = () => updateSelectedValues([]);
  const selectAll = () => updateSelectedValues(checkListOptions.map((o) => o.value));
  const checklistClassName = `ChecklistInput ${inline ? "ChecklistInput_inline" : ""}`;
  const className = `${checklistClassName} }${orEmptyString(inputClassName)} ${validationClassName(validation)}`;
  return /* @__PURE__ */ React__default.createElement("div", {
    className
  }, /* @__PURE__ */ React__default.createElement("ul", {
    className: "checklist"
  }, checkListOptions.map((option) => /* @__PURE__ */ React__default.createElement("li", {
    key: option.label
  }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    text: option.label,
    value: option.value,
    onChange: () => toggleValue(option.value),
    checked: isChecked(option.value)
  }))), showSelectAll && checkListOptions.length > 1 && /* @__PURE__ */ React__default.createElement("li", {
    key: "select_all_button"
  }, /* @__PURE__ */ React__default.createElement("a", {
    type: "button",
    onClick: allSelected ? selectNone : selectAll
  }, allSelected ? "Deselect All" : "Select All"))));
}

var css_248z$2j = "/* Kludge while we figure out how to add the form-control ng-invalid classes directly to the nested day-picker input */\n.DayPickerInput.ng-invalid > input {\n  border-color: var(--color-danger);\n}\n";
styleInject(css_248z$2j);

function DayPickerInput(props) {
  const { validation, inputClassName, classNames, onChange, onBlur, name, ...rest } = props;
  const className = `${orEmptyString(inputClassName)} ${validationClassName(validation)}`;
  React__default.useEffect(() => onBlur(createFakeReactSyntheticEvent({ name, value: props.value })), []);
  const defaultClassNames = { container: "", overlayWrapper: "", overlay: "" };
  const managedClassNames = defaults({}, classNames, defaultClassNames);
  managedClassNames.container = `DayPickerInput ${orEmptyString(managedClassNames.container)} ${className}`;
  return /* @__PURE__ */ React__default.createElement(DayPicker, {
    ...rest,
    classNames: managedClassNames,
    onDayChange: (date) => {
      const newValue = date && date.toISOString().slice(0, 10);
      props.onChange(createFakeReactSyntheticEvent({ name, value: newValue }));
    }
  });
}

var css_248z$2i = ".ace-editor div,\n.ace-editor span {\n  font-family: monospace !important;\n}\n.ace-editor > div.ace_gutter {\n  z-index: 0;\n}\n";
styleInject(css_248z$2i);

class JsonEditor extends React__default.Component {
  constructor() {
    super(...arguments);
    this.editorRef = React__default.createRef();
    this.validate = (annotations) => {
      const { onValidation } = this.props;
      if (!onValidation) {
        return;
      }
      if (!annotations || !annotations.length) {
        onValidation(null);
      }
      const errors = annotations.map((a) => {
        return `Line ${a.row + 1}, column ${a.column + 1}: ${a.text}`;
      });
      onValidation(errors.join("; "));
    };
  }
  componentDidMount() {
    if (this.props.autofocus) {
      const { editor } = this.editorRef.current;
      editor.focus();
      editor.navigateFileStart();
    }
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(AceEditor, {
      ...this.props,
      ref: this.editorRef,
      onValidate: this.validate,
      editorProps: { $blockScrolling: Infinity }
    });
  }
}
JsonEditor.defaultProps = {
  mode: "json",
  theme: "textmate",
  style: { width: "100%", border: "1px solid var(--color-concrete)" },
  fontSize: 11,
  showGutter: true,
  showPrintMargin: true,
  highlightActiveLine: true,
  className: "ace-editor flex-fill",
  autofocus: true
};

function useIsMountedRef() {
  const isMounted = useRef$4(false);
  useEffect$a(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
}

function useInternalValidator(validation, validator, revalidateDeps = []) {
  const isMounted = useIsMountedRef().current;
  const validatorRef = React__default.useRef(validator);
  validatorRef.current = validator;
  const internalValidator = React__default.useCallback((value, label) => validatorRef.current(value, label), []);
  React__default.useEffect(() => {
    validation && validation.addValidator && validation.addValidator(internalValidator);
    return () => validation && validation.removeValidator && validation.removeValidator(internalValidator);
  }, []);
  React__default.useEffect(() => {
    isMounted && validation && validation.revalidate && validation.revalidate();
  }, revalidateDeps);
}

var css_248z$2h = "input.NumberInput {\n  max-width: 200px;\n}\n";
styleInject(css_248z$2h);

const isNumber = (val) => typeof val === "number";
function NumberInput$1(props) {
  const { value, validation, inputClassName, ...otherProps } = props;
  const minMaxValidator = (val, label) => {
    const minValidator = isNumber(props.min) ? Validators.minValue(props.min) : void 0;
    const maxValidator = isNumber(props.max) ? Validators.maxValue(props.max) : void 0;
    const validator = composeValidators([minValidator, maxValidator]);
    return validator ? validator(val, label) : null;
  };
  useInternalValidator(validation, minMaxValidator);
  const className = `NumberInput form-control ${orEmptyString(inputClassName)} ${validationClassName(validation)}`;
  return /* @__PURE__ */ React__default.createElement("input", {
    className,
    type: "number",
    value: orEmptyString(value),
    ...otherProps
  });
}

const RadioButtonInput = (props) => {
  const { inline, validation, value, defaultValue, inputClassName, options, stringOptions, ...otherProps } = props;
  const radioOptions = useMemo$2(() => isStringArray(stringOptions) ? stringOptions.map((opt) => ({ value: opt, label: opt })) : options, [options]);
  useEffect$a(() => {
    if (!isNil(defaultValue) && !radioOptions.map((opt) => opt.value).includes(value)) {
      props.onChange(createFakeReactSyntheticEvent({ name: props.name, value: defaultValue }));
    }
  }, [value, defaultValue, radioOptions]);
  const userClassName = orEmptyString(inputClassName);
  const validClassName = validationClassName(validation);
  const layoutClassName = inline ? "flex-container-h margin-between-md" : "flex-container-v margin-between-sm";
  const elementClassName = `RadioButtonInput radio ${userClassName} ${validClassName} ${layoutClassName}`;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: elementClassName
  }, radioOptions.map((option) => /* @__PURE__ */ React__default.createElement(RadioButton, {
    key: option.label,
    value,
    option,
    ...otherProps
  })));
};
const RadioButton = ({ option, value, ...otherProps }) => /* @__PURE__ */ React__default.createElement("label", {
  className: "clickable"
}, /* @__PURE__ */ React__default.createElement("input", {
  type: "radio",
  ...otherProps,
  value: option.value,
  checked: option.value === value
}), /* @__PURE__ */ React__default.createElement(Markdown, {
  message: option.label,
  style: option.help && { display: "inline-block" }
}), option.help && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, option.help));

class TextAreaInput extends React__default.Component {
  render() {
    const { value, validation, inputClassName, ...otherProps } = this.props;
    const className = `TextAreaInput form-control ${orEmptyString(inputClassName)} ${validationClassName(validation)}`;
    return /* @__PURE__ */ React__default.createElement("textarea", {
      className,
      autoComplete: "off",
      value: orEmptyString(value),
      ...otherProps
    });
  }
}

const useApplicationContext = () => {
  const app = React__default.useContext(ApplicationContext);
  if (app === void 0) {
    console.warn("Application context provider is missing");
  }
  return app;
};
const useApplicationContextSafe = () => {
  const app = React__default.useContext(ApplicationContext);
  if (app === void 0) {
    throw new Error("Application context provider is missing");
  }
  return app;
};

const { useEffect: useEffect$8, useRef: useRef$3 } = React__default;
const usePrevious = (value) => {
  const ref = useRef$3();
  useEffect$8(() => {
    ref.current = value;
  });
  return ref.current;
};

const { useEffect: useEffect$7, useRef: useRef$2 } = React__default;
const getContainerElement = () => document.querySelector(".spinnaker-container");
const useContainerClassNames = (classNames) => {
  const previousClassNames = usePrevious(classNames);
  useEffect$7(() => {
    const containerElement = getContainerElement();
    if (!containerElement) {
      return void 0;
    }
    if (previousClassNames) {
      const removedClassNames = previousClassNames.filter((className) => !classNames.includes(className));
      containerElement.classList.remove(...removedClassNames);
    }
    containerElement.classList.add(...classNames);
  }, [classNames.sort().join()]);
  const classNamesRef = useRef$2(classNames);
  classNamesRef.current = classNames;
  useEffect$7(() => {
    return () => {
      const containerElement = getContainerElement();
      if (!containerElement) {
        return void 0;
      }
      containerElement.classList.remove(...classNamesRef.current);
    };
  }, []);
};

const initialPromiseState = {
  error: void 0,
  requestId: 0,
  result: void 0,
  status: "NONE"
};
function useLatestPromise(callback, deps) {
  const isMountedRef = useIsMountedRef();
  const isInitialRender = !isMountedRef.current;
  const requestInFlight = useRef$4();
  const [requestIdTrigger, setRequestIdTrigger] = useState$b(0);
  const [promiseState, setPromiseState] = useState$b(initialPromiseState);
  const { result, error, status, requestId } = promiseState;
  const refresh = () => setRequestIdTrigger((id) => id + 1);
  useEffect$a(() => {
    !isInitialRender && refresh();
  }, deps);
  useEffect$a(() => {
    const promise = callback();
    const isCurrent = () => isMountedRef.current && promise === requestInFlight.current;
    if (!promise) {
      return;
    }
    setPromiseState({ status: "PENDING", error, result, requestId: requestIdTrigger });
    requestInFlight.current = promise;
    const resolve = (newResult) => {
      if (isCurrent()) {
        setPromiseState({ status: "RESOLVED", result: newResult, error: void 0, requestId: requestIdTrigger });
      }
    };
    const reject = (rejection) => {
      if (isCurrent()) {
        setPromiseState({ status: "REJECTED", result: void 0, error: rejection, requestId: requestIdTrigger });
      }
    };
    promise.then(resolve, reject);
  }, [requestIdTrigger]);
  return { result, status, error, refresh, requestId };
}

function useData(callback, defaultResult, deps) {
  const memoizedDefaultResult = useMemo$2(() => defaultResult, []);
  const anyDepsMissing = deps.some((dep) => isNil(dep));
  const result = useLatestPromise(anyDepsMissing ? () => null : callback, deps);
  const hasResolvedAtLeastOnceRef = useRef$4(false);
  if (result.status === "RESOLVED") {
    hasResolvedAtLeastOnceRef.current = true;
  }
  return hasResolvedAtLeastOnceRef.current ? result : { ...result, result: memoizedDefaultResult };
}

const { useRef: useRef$1, useCallback: useCallback$2 } = React__default;
const useLatestCallback = (callback) => {
  const callbackRef = useRef$1(callback);
  callbackRef.current = callback;
  return useCallback$2((...args) => {
    return callbackRef.current && callbackRef.current.apply(null, args);
  }, []);
};

const useObservable = (observable, callback) => {
  useEffect$a(() => {
    if (!observable) {
      return void 0;
    }
    const subscription = observable.subscribe(callback);
    return () => subscription.unsubscribe();
  }, [observable]);
};

const useObservableValue = (observable, defaultValue) => {
  const [value, setValue] = useState$b(defaultValue);
  useObservable(observable, setValue);
  return value;
};

const useDataSource = (dataSource) => {
  const status = useObservableValue(dataSource.status$, dataSource.status$.value);
  const refresh = useLatestCallback(() => {
    dataSource.refresh();
  });
  return {
    ...status,
    refresh
  };
};

function useDebouncedValue(value, debounceMs) {
  const [debouncedValue, setDebouncedValue] = useState$b(value);
  const isDebouncing = value !== debouncedValue;
  useEffect$a(() => {
    const id = setTimeout(() => setDebouncedValue(value), debounceMs);
    return () => clearTimeout(id);
  }, [value, debounceMs]);
  return [debouncedValue, isDebouncing];
}

const { useRef } = React__default;
function useDeepObjectDiff(obj) {
  const ref = useRef(obj);
  const version = useRef(1);
  const deepEqual = obj === ref.current || isEqual(obj, ref.current);
  ref.current = obj;
  if (!deepEqual) {
    version.current++;
  }
  return version.current;
}

const { useEffect: useEffect$6 } = React__default;
const useEventListener = (element, eventName, listener, options) => {
  const memoizedListener = useLatestCallback(listener);
  useEffect$6(() => {
    if (!listener) {
      return void 0;
    }
    element.addEventListener(eventName, memoizedListener, options);
    return () => {
      element.removeEventListener(eventName, memoizedListener, options);
    };
  }, [
    element,
    eventName,
    !!listener,
    Object.values(options || {}).sort().join()
  ]);
};

function useEscapeKeyPressed(callback) {
  useEventListener(document.body, "keyup", (e) => e.key === "Escape" && callback());
}

const useForceUpdate = () => {
  const [, setToggle] = useState$b(true);
  return useCallback$3(() => {
    setToggle((toggle) => !toggle);
  }, []);
};

function useInterval(callback, interval) {
  const stableCallback = useLatestCallback(callback);
  useEffect$a(() => {
    const id = !!callback && interval && setInterval(stableCallback, interval);
    return () => id && clearInterval(id);
  }, [!!callback, interval]);
}

const { useState: useState$a } = React;
const BREAKPOINT_MOBILE = 1024;
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState$a(window.innerWidth <= BREAKPOINT_MOBILE);
  useEventListener(window, "resize", () => {
    const newValue = window.innerWidth <= BREAKPOINT_MOBILE;
    if (newValue !== isMobile) {
      setIsMobile(newValue);
    }
  });
  return isMobile;
};

function usePollingData(callback, defaultResult, pollingInterval, deps) {
  const result = useData(callback, defaultResult, deps);
  const refreshCallback = useLatestCallback(result.refresh);
  useEffect$a(() => {
    const { subscribe, unsubscribe } = SchedulerFactory.createScheduler(pollingInterval);
    subscribe(refreshCallback);
    return unsubscribe;
  }, deps);
  return result;
}

var css_248z$2g = ".SpelInput {\n  font-family: monospace;\n}\n";
styleInject(css_248z$2g);

function SpelInput(props) {
  const { previewStage, ...rest } = props;
  const [expression, isDebouncing] = useDebouncedValue(props.value, 300);
  const isInitialRender = !useIsMountedRef().current;
  function previewExpressionValidator() {
    const { status, error, result } = fetchSpelPreview;
    if (status === "NONE") {
      return null;
    } else if (status === "PENDING" || isDebouncing) {
      if (result) {
        return asyncMessage("Updating preview...\n\n\n```\n" + JSON.stringify(result, null, 2) + "\n```");
      }
      return asyncMessage("Updating preview...");
    } else if (status === "RESOLVED") {
      const previewMessage = `Preview - based on previous execution: ${previewStage.executionLabel}


\`\`\`
` + JSON.stringify(result, null, 2) + "\n```";
      return messageMessage(previewMessage);
    } else if (status === "REJECTED") {
      return warningMessage(error);
    }
    return null;
  }
  useInternalValidator(props.validation, previewExpressionValidator);
  const fetchSpelPreview = useData(() => SpelService.evaluateExpression(expression, previewStage.executionId, previewStage.stageId), null, [expression, previewStage.executionId, previewStage.stageId]);
  React__default.useEffect(() => {
    !isInitialRender && props.validation && props.validation.revalidate && props.validation.revalidate();
  }, [fetchSpelPreview.status, isDebouncing]);
  return /* @__PURE__ */ React__default.createElement(SimpleSpelInput, {
    ...rest
  });
}
function SimpleSpelInput(props) {
  const hasNewlines = !!/\n/.exec(props.value);
  return /* @__PURE__ */ React__default.createElement(TextAreaInput, {
    inputClassName: "SpelInput",
    rows: hasNewlines ? 3 : 1,
    placeholder: props.placeholder || "Variable value, e.g. ${trigger.buildInfo.number}",
    ...props
  });
}

const FormikSpelContext = React.createContext(false);
const { Provider: FormikSpelContextProvider } = FormikSpelContext;

var SpelAwareInputMode;
(function(SpelAwareInputMode2) {
  SpelAwareInputMode2["DEFAULT"] = "DEFAULT";
  SpelAwareInputMode2["FREEFORM"] = "FREEFORM";
})(SpelAwareInputMode || (SpelAwareInputMode = {}));
function SpelToggle(props) {
  return /* @__PURE__ */ React.createElement(Tooltip, {
    value: props.inputMode === SpelAwareInputMode.FREEFORM ? "Return to default input" : "Enter SpEL in freeform input"
  }, /* @__PURE__ */ React.createElement("button", {
    className: classNames("btn btn-sm btn-default", { active: props.inputMode === SpelAwareInputMode.FREEFORM }),
    onClick: props.onClick
  }, /* @__PURE__ */ React.createElement("span", {
    className: "fa icon-spel"
  })));
}

const { useCallback: useCallback$1, useContext: useContext$4, useState: useState$9 } = React__default;
const revalidateMap = new Map();
function coalescedRevalidate(formik) {
  if (!revalidateMap.has(formik)) {
    revalidateMap.set(formik, true);
    setTimeout(() => {
      revalidateMap.delete(formik);
      return formik.validateForm();
    });
  }
}
function getIn(obj, key, defaultValue = void 0) {
  let p = 0;
  const path = toPath(key);
  while (obj && p < path.length) {
    obj = typeof obj == "string" ? void 0 : obj[path[p++]];
  }
  return obj === void 0 ? defaultValue : obj;
}
function FormikFormFieldImpl(props) {
  const { formik } = props;
  const { name, onChange, fastField: fastFieldProp } = props;
  const { input, layout, label, help, required, actions, validate, validationMessage, touched: touchedProp } = props;
  const FieldLayoutFromContext = useContext$4(LayoutContext);
  const SpelAwareFromContext = useContext$4(FormikSpelContext);
  const formikTouched = getIn(formik.touched, name);
  const formikError = getIn(formik.errors, props.name);
  const fastField = firstDefined(fastFieldProp, false);
  const touched = firstDefined(touchedProp, formikTouched);
  const message = firstDefined(validationMessage, formikError);
  const { hidden, category, messageNode } = useValidationData(message, touched);
  const [internalValidators, setInternalValidators] = useState$9([]);
  const addValidator = useCallback$1((v) => setInternalValidators((list) => list.concat(v)), []);
  const removeValidator = useCallback$1((v) => setInternalValidators((list) => list.filter((x) => x !== v)), []);
  const revalidate = () => coalescedRevalidate(formik);
  const mountStatus = useMountStatusRef();
  React__default.useEffect(() => {
    if (mountStatus.current === "FIRST_RENDER" && internalValidators.length === 0) {
      return;
    }
    revalidate();
  }, [internalValidators]);
  const validation = {
    touched,
    revalidate,
    addValidator,
    removeValidator,
    hidden,
    category,
    messageNode
  };
  const freeformInputAllowed = firstDefined(props.spelAware, SpelAwareFromContext, false);
  const initialInputMode = React__default.useMemo(() => {
    const fieldValue = getIn(props.formik.values, name, "");
    return freeformInputAllowed && SpelService.includesSpel(fieldValue) ? SpelAwareInputMode.FREEFORM : SpelAwareInputMode.DEFAULT;
  }, []);
  const [inputMode, setInputMode] = React__default.useState(initialInputMode);
  const onSpelToggleClick = () => {
    formik.setFieldValue(name, null);
    setInputMode(inputMode === SpelAwareInputMode.DEFAULT ? SpelAwareInputMode.FREEFORM : SpelAwareInputMode.DEFAULT);
  };
  const renderField = ({ field }) => {
    const inputOrSpel = inputMode === SpelAwareInputMode.DEFAULT ? input : SimpleSpelInput;
    const layoutFromContext = (fieldLayoutProps) => /* @__PURE__ */ React__default.createElement(FieldLayoutFromContext, {
      ...fieldLayoutProps
    });
    const layoutRenderPropOrNode = firstDefined(layout, layoutFromContext);
    const inputElement = renderContent(inputOrSpel, { ...field, validation });
    const composedActions = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, actions, freeformInputAllowed && /* @__PURE__ */ React__default.createElement(SpelToggle, {
      inputMode,
      onClick: onSpelToggleClick
    }));
    const layoutProps = {
      label,
      help,
      required,
      actions: composedActions,
      input: inputElement,
      validation
    };
    return /* @__PURE__ */ React__default.createElement(WatchValue, {
      onChange,
      value: field.value
    }, renderContent(layoutRenderPropOrNode, layoutProps));
  };
  const validator = createFieldValidator(label, required, [].concat(validate).concat(internalValidators));
  if (fastField) {
    return /* @__PURE__ */ React__default.createElement(FastField, {
      name,
      validate: validator,
      render: renderField
    });
  }
  return /* @__PURE__ */ React__default.createElement(Field, {
    name,
    validate: validator,
    render: renderField
  });
}
function createFieldValidator(label, required, validate) {
  const validators = [!!required && Validators.isRequired()].concat(validate);
  const validator = composeValidators(validators);
  if (!validator) {
    return null;
  }
  const labelString = isString(label) ? label : void 0;
  return (value) => validator(value, labelString);
}
function FormikFormField(props) {
  return /* @__PURE__ */ React__default.createElement(FormikConsumer, null, (formik) => /* @__PURE__ */ React__default.createElement(FormikFormFieldImpl, {
    ...props,
    formik
  }));
}

const { useState: useState$8, useCallback, useContext: useContext$3, useMemo: useMemo$1 } = React__default;
function FormField(props) {
  const { input, layout, label, help, required, actions } = props;
  const { value } = props;
  const [internalValidators, setInternalValidators] = useState$8([]);
  const [revalidateRequestId, setRevalidateRequestId] = useState$8(0);
  const addValidator = useCallback((v) => setInternalValidators((list) => list.concat(v)), []);
  const removeValidator = useCallback((v) => setInternalValidators((list) => list.filter((x) => x !== v)), []);
  const validate = useMemo$1(() => props.validate, []);
  const fieldValidator = useMemo$1(() => createFieldValidator(label, required, [].concat(validate || noop).concat(internalValidators)), [label, required, validate, internalValidators.length]);
  const FieldLayoutFromContext = useContext$3(LayoutContext);
  const inputRenderPropOrNode = firstDefined(input, noop);
  const layoutFromContext = (fieldLayoutProps) => /* @__PURE__ */ React__default.createElement(FieldLayoutFromContext, {
    ...fieldLayoutProps
  });
  const layoutRenderPropOrNode = firstDefined(layout, layoutFromContext);
  const [hasBlurred, setHasBlurred] = useState$8(false);
  const touched = firstDefined(props.touched, hasBlurred);
  const revalidate = () => setRevalidateRequestId((prev) => prev + 1);
  const validatorResult = useMemo$1(() => fieldValidator(value), [fieldValidator, value, revalidateRequestId]);
  const validationMessage = firstDefined(props.validationMessage, validatorResult ? validatorResult : void 0);
  const validationData = useValidationData(validationMessage, touched);
  const validation = {
    touched,
    addValidator,
    removeValidator,
    revalidate,
    ...validationData
  };
  const controlledInputProps = {
    value: props.value,
    name: props.name || "",
    onChange: props.onChange || noop,
    onBlur: (e) => {
      setHasBlurred(true);
      props.onBlur && props.onBlur(e);
    }
  };
  const inputProps = { ...controlledInputProps, validation };
  const inputElement = renderContent(inputRenderPropOrNode, inputProps);
  const layoutProps = { label, help, required, actions, validation, input: inputElement };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, renderContent(layoutRenderPropOrNode, layoutProps));
}

const initialSpelData = {
  value: null,
  spelError: null,
  spelPreview: null
};
function FormikExpressionField(props) {
  const { context, name, label, help, actions, validationMessage: message } = props;
  const [spelData, setSpelData] = React__default.useState(initialSpelData);
  const markdown = firstDefined(props.markdown, false);
  const validationNode = useValidationData(message, true);
  const validationMessage = validationNode.messageNode || spelData.spelError && context && /* @__PURE__ */ React__default.createElement(ExpressionError, {
    spelError: spelData.spelError
  }) || spelData.spelPreview && /* @__PURE__ */ React__default.createElement(ExpressionPreview, {
    spelPreview: spelData.spelPreview,
    markdown
  });
  return /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name,
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ExpressionInput, {
      onExpressionChange: (changes) => setSpelData(changes),
      context,
      ...inputProps
    }),
    label,
    help,
    actions,
    validationMessage
  });
}

class FormikExpressionRegexField extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      spelPreview: null,
      spelError: null
    };
  }
  renderRegexFields(fieldProps, defaultExpanded) {
    const { RegexHelp, regexName, replaceName } = fieldProps;
    const sectionHeading = ({ chevron }) => /* @__PURE__ */ React__default.createElement("span", null, " ", chevron, " Regex ", RegexHelp, " ");
    const validateRegexString = (regexString) => {
      try {
        RegExp(regexString);
        return "";
      } catch (error) {
        return error.message;
      }
    };
    const RegexLayout = ({ input }) => /* @__PURE__ */ React__default.createElement("div", {
      style: { flex: "1 1 40%" }
    }, " ", input, " ");
    return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      heading: sectionHeading,
      outerDivClassName: "",
      toggleClassName: "",
      defaultExpanded
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-h baseline"
    }, /* @__PURE__ */ React__default.createElement("code", null, "s/"), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: regexName,
      validate: validateRegexString,
      layout: (props) => /* @__PURE__ */ React__default.createElement(RegexLayout, {
        ...props
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      touched: true
    }), /* @__PURE__ */ React__default.createElement("code", null, "/"), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: replaceName,
      layout: (props) => /* @__PURE__ */ React__default.createElement(RegexLayout, {
        ...props
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      })
    }), /* @__PURE__ */ React__default.createElement("code", null, "/g")));
  }
  renderPreview(props, spelPreview, regex, replace) {
    const { markdown } = props;
    if (!regex) {
      return /* @__PURE__ */ React__default.createElement(ExpressionPreview, {
        spelPreview,
        markdown
      });
    }
    try {
      const replacedSpelPreview = spelPreview.replace(new RegExp(regex, "g"), replace);
      return !!replacedSpelPreview && /* @__PURE__ */ React__default.createElement(ExpressionPreview, {
        spelPreview: replacedSpelPreview,
        markdown
      });
    } catch (err) {
      return /* @__PURE__ */ React__default.createElement(ExpressionPreview, {
        spelPreview,
        markdown
      });
    }
  }
  renderFormField(validationMessage, regex) {
    const { context, placeholder, help, label, actions } = this.props;
    return /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: this.props.name,
      input: (props) => /* @__PURE__ */ React__default.createElement("div", {
        className: "flex-container-v flex-grow"
      }, /* @__PURE__ */ React__default.createElement(ExpressionInput, {
        onExpressionChange: (exprChange) => this.setState(exprChange),
        context,
        placeholder,
        ...props
      }), this.renderRegexFields(this.props, !!regex)),
      help,
      label,
      actions,
      validationMessage,
      touched: true
    });
  }
  render() {
    const { spelPreview, spelError } = this.state;
    const { regexName, replaceName } = this.props;
    return /* @__PURE__ */ React__default.createElement(FormikForm, {
      render: (formik) => {
        const regex = getIn$1(formik.values, regexName);
        const replace = getIn$1(formik.values, replaceName);
        const regexError = getIn$1(formik.errors, regexName) || getIn$1(formik.errors, replaceName);
        if (regexError) {
          return this.renderFormField(errorMessage(regexError), regex);
        } else if (spelError) {
          return this.renderFormField(/* @__PURE__ */ React__default.createElement(ExpressionError, {
            spelError
          }), regex);
        } else if (spelPreview) {
          const message = this.renderPreview(this.props, spelPreview, regex, replace);
          return this.renderFormField(message, regex);
        }
        return this.renderFormField(messageMessage(null), regex);
      }
    });
  }
}
FormikExpressionRegexField.defaultProps = { markdown: false };

function useSaveRestoreMutuallyExclusiveFields(formik, currentFieldSetKey, mutuallyExclusiveFieldSets) {
  const previousFieldSetKey = usePrevious(currentFieldSetKey);
  const [savedValues, setSavedValues] = useState$b({});
  const [savedTouched, setSavedTouched] = useState$b({});
  useEffect$a(() => {
    var _a, _b;
    if (!!previousFieldSetKey && currentFieldSetKey !== previousFieldSetKey) {
      const fieldsToSave = (_a = mutuallyExclusiveFieldSets[previousFieldSetKey]) != null ? _a : [];
      const fieldsToRestore = (_b = mutuallyExclusiveFieldSets[currentFieldSetKey]) != null ? _b : [];
      const valuesToSave = fieldsToSave.reduce((data, path) => {
        data[path] = get(formik.values, path);
        return data;
      }, {});
      setSavedValues({ ...savedValues, [previousFieldSetKey]: valuesToSave });
      const touchedToSave = fieldsToSave.reduce((data, path) => {
        data[path] = get(formik.touched, path);
        return data;
      }, {});
      setSavedTouched({ ...savedTouched, [previousFieldSetKey]: touchedToSave });
      fieldsToSave.forEach((field) => {
        formik.setFieldValue(field, void 0);
        formik.setFieldTouched(field, null);
      });
      const valuesToRestore = savedValues[currentFieldSetKey] || {};
      const touchedToRestore = savedTouched[currentFieldSetKey] || {};
      fieldsToRestore.forEach((field) => {
        if (valuesToRestore.hasOwnProperty(field)) {
          formik.setFieldValue(field, savedValues[currentFieldSetKey][field]);
        }
        if (touchedToRestore.hasOwnProperty(field)) {
          formik.setFieldTouched(field, savedTouched[currentFieldSetKey][field]);
        }
      });
    }
  }, [currentFieldSetKey]);
}

function useFormInputValueMapper(props, toInputValue, fromInputValue) {
  const value = toInputValue(props.value);
  const onChange = React.useCallback((e) => {
    props.onChange(createFakeReactSyntheticEvent({
      name: e.target.name,
      value: fromInputValue(e.target.value, e)
    }));
  }, [props.onChange, fromInputValue]);
  return { ...props, value, onChange };
}

class LabelComponent extends React__default.Component {
  render() {
    const SubLabelComponent = this.props.stage.labelComponent;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "label-component"
    }, /* @__PURE__ */ React__default.createElement(SubLabelComponent, {
      stage: this.props.stage
    }));
  }
}

function LabeledValue(props) {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("dt", null, props.label, " ", props.helpFieldId && /* @__PURE__ */ React__default.createElement(HelpField, {
    id: props.helpFieldId
  })), /* @__PURE__ */ React__default.createElement("dd", null, props.value));
}

function LabeledValueList(props) {
  const { children, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement("dl", {
    ...rest
  }, children);
}

const LinkWithClipboard = ({ url, text }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("a", {
  href: url,
  target: "_blank"
}, text), /* @__PURE__ */ React__default.createElement(CopyToClipboard, {
  text,
  toolTip: "'Copy to clipboard'"
}));

function withErrorBoundary(Component, category) {
  return React__default.forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(SpinErrorBoundary, {
    category
  }, /* @__PURE__ */ React__default.createElement(Component, {
    ...props,
    ref
  })));
}
class SpinErrorBoundary extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, retrying: false };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, _errorInfo) {
    logger.log({
      level: "ERROR",
      category: `SpinErrorBoundary - ${this.props.category}`,
      action: error.message,
      error,
      data: { label: error.message, componentStack: _errorInfo == null ? void 0 : _errorInfo.componentStack }
    });
  }
  retry() {
    this.setState({ retrying: true });
    setTimeout(() => this.setState({ retrying: false, error: null }), 250);
  }
  render() {
    var _a;
    if (!((_a = this.state) == null ? void 0 : _a.error)) {
      return this.props.children;
    }
    const { message, stack } = this.state.error;
    const { retrying } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-v sp-margin-l"
    }, /* @__PURE__ */ React__default.createElement("h3", null, "Oh dear, something has gone wrong."), /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-l-bottom"
    }, /* @__PURE__ */ React__default.createElement("h4", null, "Spinnaker has encountered an unexpected UI error."), /* @__PURE__ */ React__default.createElement("button", {
      disabled: retrying,
      onClick: () => this.retry()
    }, retrying ? "Retrying..." : "Try again")), message && /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      message,
      type: "error"
    }), stack && /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
      defaultExpanded: false,
      heading: "Stacktrace"
    }, /* @__PURE__ */ React__default.createElement("pre", {
      style: { overflow: "scroll" }
    }, stack)));
  }
}
const UI_ROUTER_REACT_ERROR_BOUNDARY = "ui.router.react.error.boundary";
module(UI_ROUTER_REACT_ERROR_BOUNDARY, ["ui.router"]).config([
  "$uiRouterProvider",
  ($uiRouterProvider) => {
    $uiRouterProvider.stateRegistry.decorator("views", (state, parent) => {
      const views = parent(state);
      Object.values(views).filter((view) => view.$type === "react").forEach((view) => {
        const reactView = view;
        const RoutedComponent = reactView.component;
        reactView.component = (props) => /* @__PURE__ */ React__default.createElement(SpinErrorBoundary, {
          category: state.name
        }, /* @__PURE__ */ React__default.createElement(RoutedComponent, {
          ...props
        }));
      });
      return views;
    });
  }
]);

const LINK_WITH_CLIPBOARD = "spinnaker.core.presentation.linkWithClipboard.component";
module(LINK_WITH_CLIPBOARD, []).component("linkWithClipboard", react2angular(withErrorBoundary(LinkWithClipboard, "linkWithClipboard"), ["url", "text"]));

const ModalContext = React__default.createContext(null);

const TabBoundary = ({ children }) => {
  const boundaryRef = React__default.createRef();
  const keydownCallback = (event) => {
    var _a, _b;
    const { keyCode, shiftKey, target } = event;
    if (keyCode === 9) {
      let targetOverride = null;
      const tabbableElements = Array.from((_b = (_a = boundaryRef.current) == null ? void 0 : _a.querySelectorAll(`
          input:not([tabindex^="-"]):not([disabled]),
          select:not([tabindex^="-"]):not([disabled]),
          textarea:not([tabindex^="-"]):not([disabled]),
          button:not([tabindex^="-"]):not([disabled]),
          a[href]:not([tabindex^="-"]):not([disabled]),
          [tabindex]:not([tabindex^="-"]):not([disabled])
      `)) != null ? _b : []).filter((ele) => ele.offsetParent !== null);
      if (!tabbableElements.length) {
        return;
      }
      const firstElem = tabbableElements[0];
      const lastElem = tabbableElements[tabbableElements.length - 1];
      if (firstElem === target && shiftKey) {
        targetOverride = lastElem;
      }
      if (lastElem === target && !shiftKey) {
        targetOverride = firstElem;
      }
      if (!tabbableElements.includes(target)) {
        targetOverride = shiftKey ? lastElem : firstElem;
      }
      if (targetOverride) {
        targetOverride.focus();
        event.preventDefault();
      }
    }
  };
  useEventListener(document, "keydown", keydownCallback);
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: boundaryRef
  }, children);
};

var css_248z$2f = "@-webkit-keyframes backdropEnter {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes backdropEnter {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes backdropLeave {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes backdropLeave {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@-webkit-keyframes dialogEnter {\n  from {\n    transform: scale3d(0.8, 0.8, 0.8);\n    opacity: 0;\n  }\n  to {\n    transform: scale3d(1, 1, 1);\n    opacity: 1;\n  }\n}\n@keyframes dialogEnter {\n  from {\n    transform: scale3d(0.8, 0.8, 0.8);\n    opacity: 0;\n  }\n  to {\n    transform: scale3d(1, 1, 1);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes dialogLeave {\n  from {\n    transform: scale3d(1, 1, 1);\n    opacity: 1;\n  }\n  to {\n    transform: scale3d(0.8, 0.8, 0.8);\n    opacity: 0;\n  }\n}\n@keyframes dialogLeave {\n  from {\n    transform: scale3d(1, 1, 1);\n    opacity: 1;\n  }\n  to {\n    transform: scale3d(0.8, 0.8, 0.8);\n    opacity: 0;\n  }\n}\n/********************************************************\n  Shared set of properties for both the tinted backdrop\n  and the full screen container that holds a dialog\n********************************************************/\n/**********************************\n  Tinted backdrop (behind dialog)\n***********************************/\n.sp-modal-backdrop {\n  display: flex;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: var(--layer-critical);\n  overflow: hidden;\n  overscroll-behavior: none;\n  background-color: rgba(0, 0, 0, 0.7);\n  will-change: opacity;\n}\n.sp-modal-backdrop.enter {\n  -webkit-animation-name: backdropEnter;\n          animation-name: backdropEnter;\n  -webkit-animation-duration: 300ms;\n          animation-duration: 300ms;\n  -webkit-animation-timing-function: cubic-bezier(0.4, 0, 0, 1);\n          animation-timing-function: cubic-bezier(0.4, 0, 0, 1);\n}\n.sp-modal-backdrop.exit {\n  -webkit-animation-name: backdropLeave;\n          animation-name: backdropLeave;\n  -webkit-animation-duration: 300ms;\n          animation-duration: 300ms;\n  -webkit-animation-timing-function: cubic-bezier(0.76, 0.18, 0.4, 0.92);\n          animation-timing-function: cubic-bezier(0.76, 0.18, 0.4, 0.92);\n}\n.sp-modal-backdrop.enter-active,\n.sp-modal-backdrop.enter-done {\n  opacity: 1;\n}\n.sp-modal-backdrop.exit-active,\n.sp-modal-backdrop.exit-done {\n  opacity: 0;\n}\n.sp-modal-backdrop-blur-effect {\n  transition: filter 300ms cubic-bezier(0.4, 0, 0, 1);\n  filter: saturate(1.3) blur(5px);\n}\n/************************************************\n  Modal dialog and associated layout container\n************************************************/\n.Modal {\n  display: flex;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: var(--layer-critical);\n  overflow: hidden;\n  overscroll-behavior: none;\n  justify-content: center;\n  align-items: center;\n  /* for large screens, place an eventual cap on the height of a modal */\n}\n.Modal .sp-dialog-sizer {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  max-height: calc(100vh - 64px);\n  min-height: 320px;\n  width: calc(100vw - 128px);\n  margin: 0 64px;\n}\n@media screen and (max-width: 1024px) {\n  .Modal .sp-dialog-sizer {\n    max-height: calc(100vh - 32px);\n    width: calc(100vw - 48px);\n    margin: 0 24px;\n  }\n}\n@media screen and (min-height: 1164px) {\n  .Modal .sp-dialog-sizer {\n    max-height: 1100px;\n  }\n}\n.Modal .sp-dialog-content {\n  display: flex;\n  position: relative;\n  grid-column: 1 / -1;\n  grid-row: 1 / -1;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 8px;\n  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);\n  will-change: transform, opacity;\n}\n.Modal.enter .sp-dialog-content {\n  -webkit-animation-name: dialogEnter;\n          animation-name: dialogEnter;\n  -webkit-animation-duration: 300ms;\n          animation-duration: 300ms;\n  -webkit-animation-timing-function: cubic-bezier(0.4, 0, 0, 1);\n          animation-timing-function: cubic-bezier(0.4, 0, 0, 1);\n}\n.Modal.exit .sp-dialog-content {\n  -webkit-animation-name: dialogLeave;\n          animation-name: dialogLeave;\n  -webkit-animation-duration: 300ms;\n          animation-duration: 300ms;\n  -webkit-animation-timing-function: cubic-bezier(0.76, 0.18, 0.4, 0.92);\n          animation-timing-function: cubic-bezier(0.76, 0.18, 0.4, 0.92);\n}\n.Modal.enter-active .sp-dialog-content,\n.Modal.enter-done .sp-dialog-content {\n  transform: scale3d(1, 1, 1);\n  opacity: 1;\n}\n.Modal.exit-active .sp-dialog-content,\n.Modal.exit-done .sp-dialog-content {\n  transform: scale3d(0.8, 0.8, 0.8);\n  opacity: 0;\n}\n";
styleInject(css_248z$2f);

const DEFAULT_MAX_WIDTH = "1400px";
const Modal = ({ isOpen, maxWidth, onRequestClose, onAfterClose, children }) => {
  var _a;
  useContainerClassNames(isOpen ? ["sp-modal-backdrop-blur-effect"] : []);
  const keydownCallback = ({ keyCode }) => {
    if (keyCode === 27) {
      onRequestClose();
    }
  };
  useEventListener(document, "keydown", isOpen ? keydownCallback : null);
  const memoizedRequestClose = useLatestCallback(onRequestClose);
  const modalContext = useMemo$2(() => ({ onRequestClose: memoizedRequestClose }), []);
  return /* @__PURE__ */ React__default.createElement(ModalContext.Provider, {
    value: modalContext
  }, ReactDOM__default.createPortal(/* @__PURE__ */ React__default.createElement(TabBoundary, null, /* @__PURE__ */ React__default.createElement(CSSTransition, {
    in: isOpen,
    timeout: 300,
    mountOnEnter: true,
    unmountOnExit: true
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-modal-backdrop"
  })), /* @__PURE__ */ React__default.createElement(CSSTransition, {
    in: isOpen,
    timeout: 300,
    mountOnEnter: true,
    unmountOnExit: true,
    onExited: onAfterClose
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "Modal"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-dialog-sizer",
    style: {
      maxWidth: (_a = isNumber$1(maxWidth) ? `${maxWidth}px` : maxWidth) != null ? _a : DEFAULT_MAX_WIDTH
    }
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-dialog-content"
  }, children))))), document.body));
};

var css_248z$2e = ".ModalHeader {\n  flex: none;\n  background-color: var(--color-blumine);\n  color: var(--color-white);\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n.ModalHeader .sp-modal-title {\n  margin: 10px 16px;\n  font-size: 22px;\n  font-weight: 500;\n  flex: 1 1 100%;\n  word-break: break-all;\n}\n@media screen and (max-width: 1024px) {\n  .ModalHeader .sp-modal-title {\n    margin: 4px 12px;\n    font-size: 18px;\n  }\n}\n.ModalHeader .sp-modal-close {\n  border: none;\n  background-color: transparent;\n  flex: 0 0 56px;\n  height: 56px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  align-self: flex-start;\n  transition: all 150ms ease-out;\n}\n.ModalHeader .sp-modal-close:hover,\n.ModalHeader .sp-modal-close:focus {\n  background-color: rgba(160, 180, 220, 0.15);\n  outline: none;\n}\n@media screen and (max-width: 1024px) {\n  .ModalHeader .sp-modal-close {\n    flex: 0 0 48px;\n    height: 48px;\n  }\n}\n";
styleInject(css_248z$2e);

const { useContext: useContext$2 } = React__default;
const ModalHeader = ({ className, children }) => {
  const { onRequestClose } = useContext$2(ModalContext);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "ModalHeader"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("sp-modal-title", className)
  }, children), /* @__PURE__ */ React__default.createElement("button", {
    className: "sp-modal-close",
    onClick: () => onRequestClose && onRequestClose()
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "ico icon-close"
  })));
};

var css_248z$2d = ".ModalBody {\n  display: flex;\n  flex: 1 1 auto;\n  overflow: auto;\n  overscroll-behavior: contain;\n  --webkit-overflow-scrolling: touch;\n  background-color: var(--color-smoke);\n  padding: 0 64px;\n}\n@media screen and (max-width: 1024px) {\n  .ModalBody {\n    padding: 0 8px;\n  }\n}\n";
styleInject(css_248z$2d);

const ModalBody = ({ children }) => /* @__PURE__ */ React__default.createElement("div", {
  className: "ModalBody"
}, children);

var css_248z$2c = ".ModalFooter {\n  flex: 0 0 auto;\n  min-height: 64px;\n  background-color: var(--color-white);\n  color: var(--color-white);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  box-shadow: 0 4px 4px 4px rgba(0, 0, 0, 0.12), 0 6px 12px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  padding: 16px;\n}\n.ModalFooter .sp-modal-footer-left {\n  flex: 1 1 100%;\n  margin-right: 16px;\n}\n.ModalFooter .sp-modal-footer-right {\n  flex: 1 0 auto;\n  display: flex;\n  justify-content: flex-end;\n}\n@media screen and (max-width: 1024px) {\n  .ModalFooter .ModalFooter {\n    flex-wrap: wrap;\n  }\n  .ModalFooter .sp-modal-footer-left {\n    margin: 8px 0;\n  }\n}\n";
styleInject(css_248z$2c);

const ModalFooter = ({ primaryActions, secondaryActions }) => /* @__PURE__ */ React__default.createElement("div", {
  className: "ModalFooter"
}, secondaryActions && /* @__PURE__ */ React__default.createElement("div", {
  className: "sp-modal-footer-left"
}, secondaryActions), primaryActions && /* @__PURE__ */ React__default.createElement("div", {
  className: "sp-modal-footer-right"
}, primaryActions));

const showModal = (ModalComponent, componentProps, modalProps) => new Promise((resolve) => {
  let mountNode = document.createElement("div");
  let show = false;
  function onAfterClose() {
    if (!mountNode) {
      return;
    }
    ReactDOM__default.unmountComponentAtNode(mountNode);
    mountNode = null;
  }
  const handleResultWith = (resultHandler) => (result) => {
    if (!mountNode) {
      return;
    }
    resolve(resultHandler(result));
    show = false;
    render();
  };
  const handleClose = handleResultWith((result) => ({ status: "CLOSED", closeResult: result }));
  const handleDismiss = handleResultWith((result) => ({ status: "DISMISSED", dismissResult: result }));
  const handleRequestClose = () => handleDismiss(null);
  function render() {
    ReactDOM__default.render(/* @__PURE__ */ React__default.createElement(Modal, {
      isOpen: show,
      onRequestClose: handleRequestClose,
      onAfterClose,
      ...modalProps
    }, /* @__PURE__ */ React__default.createElement(UIRouterContextComponent, null, /* @__PURE__ */ React__default.createElement(ModalComponent, {
      ...componentProps,
      dismissModal: handleDismiss,
      closeModal: handleClose
    }))), mountNode);
  }
  render();
  setTimeout(() => {
    if (!mountNode) {
      return;
    }
    show = true;
    render();
  });
});

class PageNavigator extends React__default.Component {
  constructor(props) {
    super(props);
    this.refCallback = (element) => {
      if (element) {
        this.element = $(element);
      }
    };
    this.state = {
      id: UUIDGenerator.generateUuid(),
      currentPageKey: null,
      pages: []
    };
  }
  componentDidMount() {
    const { children, deepLinkParam, hideNavigation, scrollableContainer } = this.props;
    this.container = this.element.closest(scrollableContainer);
    if (isFunction(this.container.bind) && !hideNavigation) {
      this.container.bind(this.getEventKey(), throttle(() => this.handleScroll(), 20));
    }
    this.navigator = this.element.find(".page-navigation");
    if (deepLinkParam && this.props.reactInjector.$stateParams[deepLinkParam]) {
      this.setCurrentSection(this.props.reactInjector.$stateParams[deepLinkParam]);
    }
    const pages = React__default.Children.map(children, (child) => {
      if (child.props.pageKey && child.props.label) {
        return {
          key: child.props.pageKey,
          label: child.props.label,
          visible: child.props.visible !== false,
          badge: child.props.badge
        };
      }
      return null;
    });
    this.setState({
      pages,
      currentPageKey: pages.length > 0 ? pages[0].key : null
    });
  }
  componentWillUnmount() {
    if (isFunction(this.container.unbind) && !this.props.hideNavigation) {
      this.container.unbind(this.getEventKey());
    }
  }
  setCurrentSection(key) {
    this.setState({ currentPageKey: key });
    this.syncLocation(key);
    ScrollToService.scrollTo(`[data-page-id=${key}]`, this.props.scrollableContainer, this.container.offset().top);
    this.container.find(".highlighted").removeClass("highlighted");
    this.container.find(`[data-page-id=${key}]`).addClass("highlighted");
  }
  getEventKey() {
    return `scroll.pageNavigation.${this.state.id}`;
  }
  handleScroll() {
    const navigatorRect = this.element.get(0).getBoundingClientRect();
    const scrollableContainerTop = this.container.get(0).getBoundingClientRect().top;
    const currentPage = this.state.pages.find((p) => {
      const content = this.container.find(`[data-page-content=${p.key}]`);
      if (content.length) {
        return content.get(0).getBoundingClientRect().bottom > scrollableContainerTop;
      }
      return false;
    });
    if (currentPage) {
      this.setState({ currentPageKey: currentPage.key });
      this.syncLocation(currentPage.key);
      this.navigator.find("li").removeClass("current");
      this.navigator.find(`[data-page-navigation-link=${currentPage.key}]`).addClass("current");
    }
    if (navigatorRect.top < scrollableContainerTop) {
      this.navigator.css({
        position: "fixed",
        width: this.navigator.get(0).getBoundingClientRect().width,
        top: scrollableContainerTop
      });
    } else {
      this.navigator.css({
        position: "relative",
        top: 0,
        width: "100%"
      });
    }
  }
  syncLocation(key) {
    const { deepLinkParam } = this.props;
    if (deepLinkParam) {
      this.props.reactInjector.$state.go(".", { [deepLinkParam]: key }, { notify: false, location: "replace" });
    }
  }
  updatePagesConfig(page) {
    const pages = [...this.state.pages];
    const pageConfig = pages.find((p) => p.key === page.key);
    if (pageConfig) {
      pageConfig.badge = page.badge;
      pageConfig.label = page.label;
      pageConfig.visible = page.visible;
      this.setState({ pages });
    }
  }
  render() {
    const { children, hideNavigation } = this.props;
    const { currentPageKey, pages } = this.state;
    const updatedChildren = React__default.Children.map(children, (child) => React__default.cloneElement(child, { updatePagesConfig: (p) => this.updatePagesConfig(p) }));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "page-navigator"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row flex-1",
      ref: this.refCallback
    }, !hideNavigation && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 hidden-sm hidden-xs"
    }, /* @__PURE__ */ React__default.createElement("ul", {
      className: "page-navigation"
    }, pages.map((page, index) => {
      return page.visible && /* @__PURE__ */ React__default.createElement("li", {
        key: index,
        "data-page-navigation-link": page.key,
        className: currentPageKey === page.key ? "current" : ""
      }, /* @__PURE__ */ React__default.createElement("a", {
        onClick: () => this.setCurrentSection(page.key)
      }, page.label, page.badge && /* @__PURE__ */ React__default.createElement("span", null, " ", "(" + page.badge + ")")));
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-" + (hideNavigation ? "12" : "9") + " col-sm-12"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "sections"
    }, updatedChildren))));
  }
}

class PageSection extends React__default.Component {
  constructor(props) {
    super(props);
  }
  componentDidUpdate(prevProps) {
    const { badge, pageKey, label, updatePagesConfig, visible } = this.props;
    if (prevProps.visible !== this.props.visible || prevProps.badge !== this.props.badge || prevProps.label !== this.props.label) {
      updatePagesConfig && updatePagesConfig({
        key: pageKey,
        label,
        visible: visible !== false,
        badge
      });
    }
  }
  render() {
    const { children, pageKey, label, noWrapper, visible } = this.props;
    return visible !== false ? /* @__PURE__ */ React__default.createElement("div", {
      className: "page-section"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "page-subheading flex-1",
      "data-page-id": pageKey
    }, /* @__PURE__ */ React__default.createElement("h4", {
      className: "sticky-header"
    }, label), /* @__PURE__ */ React__default.createElement("div", {
      className: noWrapper ? "no-wrapper" : "section-body",
      "data-page-content": pageKey
    }, children))) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
}

const RenderOutputFile = React__default.memo(({ outputFileObject }) => {
  const linkRegex = /(https?:\/\/[^$\s'"]+)/;
  const isLink = (str) => `'${str}'`.match(linkRegex);
  const yaml = dump(outputFileObject);
  let linkCount = 0;
  const segments = yaml.split(linkRegex);
  const renderLink = (url) => /* @__PURE__ */ React__default.createElement("a", {
    key: `${linkCount++}`,
    href: url,
    target: "_blank"
  }, url);
  const renderSegment = (segment) => isLink(segment) ? renderLink(segment) : segment;
  return /* @__PURE__ */ React__default.createElement("pre", {
    style: { overflow: "scroll", maxHeight: "400px" }
  }, segments.map(renderSegment));
});

class SortToggle extends React__default.Component {
  constructor() {
    super(...arguments);
    this.setSortKey = (event) => {
      const { sortKey, onChange } = this.props;
      event.preventDefault();
      const predicate = this.isSortKey() && this.isReverse() ? "" : "-";
      onChange(predicate + sortKey);
    };
  }
  isSortKey() {
    const { currentSort, sortKey } = this.props;
    const field = currentSort;
    return field === sortKey || field === "-" + sortKey;
  }
  isReverse() {
    return this.props.currentSort && this.props.currentSort.startsWith("-");
  }
  render() {
    const isSortKey = this.isSortKey();
    const className = classNames({
      "inactive-sort-key": !isSortKey,
      "sort-toggle": true,
      clickable: true
    });
    return /* @__PURE__ */ React__default.createElement("span", {
      className,
      onClick: this.setSortKey
    }, this.props.label, /* @__PURE__ */ React__default.createElement("a", null, (!this.isReverse() || !isSortKey) && /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-Down-triangle"
    }), this.isReverse() && isSortKey && /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-Up-triangle"
    })));
  }
}
SortToggle.defaultProps = {
  onChange: noop
};

class SpanDropdownTrigger extends React__default.Component {
  render() {
    const { className, onClick, children } = this.props;
    return /* @__PURE__ */ React__default.createElement("span", {
      className,
      onClick
    }, " ", children, " ");
  }
}

const TableContext = React.createContext(null);

const { useState: useState$7, useMemo } = React;
const Table = (props) => {
  const isMobile = useIsMobile();
  const [allExpanded, setAllExpanded] = useState$7(false);
  const { layout, ...propsWithoutLayout } = props;
  const normalizedColumns = props.columns.map((column) => typeof column === "string" ? { name: column } : column);
  const tableContext = useMemo(() => ({
    layout,
    isMobile,
    allExpanded,
    setAllExpanded: () => setAllExpanded(false),
    expandable: props.expandable,
    columns: normalizedColumns
  }), [layout, isMobile, props.expandable, allExpanded, useDeepObjectDiff(props.columns)]);
  const { TableLayout } = layout;
  return /* @__PURE__ */ React.createElement(TableContext.Provider, {
    value: tableContext
  }, /* @__PURE__ */ React.createElement(TableLayout, {
    ...propsWithoutLayout,
    isMobile,
    columns: normalizedColumns,
    expandAll: () => setAllExpanded(true)
  }));
};

const { useState: useState$6, useContext: useContext$1, useEffect: useEffect$5 } = React;
const logDefaultExpandedError = () => {
  console.error(new Error(`You used the defaultExpanded prop on a row inside a <Table/> that's not expandable.
       Either remove the defaultExpanded prop or make the <Table/> expandable.`));
};
const throwCellColumnError = () => {
  throw new Error(`A <TableCell/> was added that didn't match any of the columns defined on its parent <Table/>.
     Check if there are an equal number of <TableCell/> elements to the number of columns provided to the <Table/>.
    `);
};
const TableRow = ({ defaultExpanded, renderExpandedContent, children }) => {
  const { layout, expandable, allExpanded, setAllExpanded, isMobile, columns } = useContext$1(TableContext);
  const [expanded, setExpanded] = useState$6(defaultExpanded || false);
  useEffect$5(() => {
    allExpanded && renderExpandedContent && setExpanded(true);
  }, [allExpanded]);
  if (!expandable && defaultExpanded != null) {
    logDefaultExpandedError();
  }
  const childrenWithIndex = React.Children.map(children, (cell, index) => {
    return React.cloneElement(cell, { index });
  });
  if (childrenWithIndex.length > columns.length) {
    throwCellColumnError();
  }
  const { TableRowLayout } = layout;
  return /* @__PURE__ */ React.createElement(TableRowLayout, {
    tableExpandable: expandable,
    rowExpandable: expandable && !!renderExpandedContent,
    expanded,
    setExpanded: (expand) => {
      setExpanded(expand);
      if (allExpanded && !expand) {
        setAllExpanded(false);
      }
    },
    renderExpandedContent,
    isMobile,
    columns,
    children: childrenWithIndex
  });
};

const { useContext } = React;
const TableCell = (props) => {
  const { layout, expandable, isMobile, columns } = useContext(TableContext);
  const { TableCellLayout } = layout;
  return /* @__PURE__ */ React.createElement(TableCellLayout, {
    ...props,
    expandable,
    isMobile,
    columns
  });
};

var css_248z$2b = ".MinimalNativeTableLayout {\n  text-align: left;\n  font-size: 13px;\n  overflow: hidden;\n}\n.MinimalNativeTableLayout .header-row {\n  height: 24px;\n}\n.MinimalNativeTableLayout .header-cell {\n  color: var(--color-charcoal);\n  font-weight: 400;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--color-porcelain);\n}\n.MinimalNativeTableLayout .header-cell:first-child {\n  font-weight: 900;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: var(--color-black);\n}\n.MinimalNativeTableLayout .cell {\n  color: var(--color-charcoal);\n  padding: 6px 16px;\n  vertical-align: top;\n  min-width: 80px;\n}\n.MinimalNativeTableLayout .cell:first-child {\n  font-weight: 600;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n";
styleInject(css_248z$2b);

const GUTTER_SIZE_PX$1 = 16;
const INDENT_SIZE_PX$1 = 20;
const TableLayout$1 = ({ columns, children }) => {
  return /* @__PURE__ */ React.createElement("table", {
    className: "MinimalNativeTableLayout",
    cellSpacing: "0",
    cellPadding: "0"
  }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", {
    className: "header-row"
  }, columns.map(({ name }) => /* @__PURE__ */ React.createElement("th", {
    key: name,
    className: "header-cell"
  }, name)))), /* @__PURE__ */ React.createElement("tbody", null, children));
};
const TableRowLayout$1 = ({ children }) => {
  return /* @__PURE__ */ React.createElement("tr", null, children);
};
const TableCellLayout$1 = ({ children, indent }) => {
  return /* @__PURE__ */ React.createElement("td", {
    className: "cell",
    style: { paddingLeft: !!indent ? `${GUTTER_SIZE_PX$1 + indent * INDENT_SIZE_PX$1}px` : void 0 }
  }, children);
};
const minimalNativeTableLayout = {
  TableLayout: TableLayout$1,
  TableRowLayout: TableRowLayout$1,
  TableCellLayout: TableCellLayout$1
};

var css_248z$2a = ".StandardGridTableLayout {\n  display: grid;\n}\n.StandardGridTableLayout .standard-grid-table-header {\n  display: grid;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  font-weight: 600;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: var(--color-regal);\n  font-size: 13px;\n  z-index: 100;\n  align-items: flex-end;\n  min-height: 48px;\n  grid-column: 1 / -1;\n  background-color: var(--color-smoke);\n  border-bottom: 2px solid var(--color-blumine);\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell {\n  align-items: flex-end;\n  padding-bottom: 6px;\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.sortable {\n  border-radius: 16px 16px 0 0;\n  cursor: pointer;\n  height: 32px;\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.sortable:hover {\n  background-color: rgba(160, 180, 220, 0.15);\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.sortable > .sort-indicator {\n  border-radius: 16px;\n  background-color: var(--color-blumine);\n  width: 16px;\n  height: 16px;\n  margin-left: 6px;\n  margin-bottom: 1px;\n  position: relative;\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.sortable > .sort-indicator:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  margin-left: -4px;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.sortable > .sort-indicator.ascending:after {\n  margin-top: -2px;\n  border-bottom: 4px solid var(--color-smoke);\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.sortable > .sort-indicator.descending:after {\n  margin-top: -1px;\n  border-top: 4px solid var(--color-smoke);\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.header-expand-toggle {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  cursor: pointer;\n  padding-left: 0;\n  border-radius: 16px 16px 0 0;\n  height: 32px;\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.header-expand-toggle:hover {\n  background-color: rgba(160, 180, 220, 0.15);\n}\n.StandardGridTableLayout .standard-grid-table-header .standard-grid-table-cell.header-expand-toggle > i {\n  font-size: 24px;\n  margin-bottom: -4px;\n}\n.StandardGridTableLayout .standard-grid-table-row-container {\n  display: grid;\n}\n.StandardGridTableLayout .standard-grid-table-row {\n  display: grid;\n  min-height: 40px;\n  overflow: hidden;\n  align-items: center;\n  font-size: 13px;\n  padding: 8px 0;\n  grid-column: 1 / -1;\n  grid-row: 1;\n}\n.StandardGridTableLayout .standard-grid-table-row.expandable {\n  cursor: pointer;\n}\n.StandardGridTableLayout .standard-grid-table-row.expandable:hover {\n  /*\n          Since this becomes a sticky header when rows are expanded\n          and the color we want is semi-transparent, let's use a gradient\n          that grabs the right color but puts a white backdrop behind it\n          so the things scrolling below it don't come through.\n        */\n  background-image: linear-gradient(180deg, rgba(160, 180, 220, 0.15), rgba(160, 180, 220, 0.15));\n}\n.StandardGridTableLayout .standard-grid-table-row.expanded {\n  background-color: var(--color-white);\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n}\n.StandardGridTableLayout .standard-grid-table-row .row-expand-toggle {\n  justify-content: center;\n  padding-left: 0;\n  color: var(--color-nobel);\n}\n.StandardGridTableLayout .standard-grid-table-row .row-expand-toggle > i {\n  font-size: 24px;\n}\n.StandardGridTableLayout .expanded-row-content {\n  /* stretch across entire table width */\n  grid-column: 1 / -1;\n  grid-row: 2;\n  background-color: var(--color-white);\n  padding: 16px;\n  overflow-x: scroll;\n}\n.StandardGridTableLayout .standard-grid-table-cell,\n.StandardGridTableLayout .cell-content {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n.StandardGridTableLayout .standard-grid-table-cell {\n  padding-left: 16px;\n}\n@media screen and (max-width: 1024px) {\n  .StandardGridTableLayout .standard-grid-table-row-container:first-child {\n    margin-top: 16px;\n  }\n  .StandardGridTableLayout .standard-grid-table-row {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0 8px 16px;\n    margin: 0 0 16px;\n    border-bottom: 1px solid var(--color-porcelain);\n  }\n  .StandardGridTableLayout .standard-grid-table-row.expanded {\n    position: static;\n    margin-bottom: 0;\n    padding-left: 6px;\n    /*for border */\n    border-left: 2px solid var(--color-regal);\n    border-bottom: none;\n  }\n  .StandardGridTableLayout .standard-grid-table-row.expanded:hover {\n    background-color: var(--color-white);\n  }\n  .StandardGridTableLayout .expanded-row-content {\n    border-left: 2px solid var(--color-regal);\n  }\n  .StandardGridTableLayout .standard-grid-table-cell {\n    flex: 0 0 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .StandardGridTableLayout .mobile-cell-header {\n    font-weight: 900;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    color: var(--color-regal);\n    margin-top: 9px;\n  }\n  .StandardGridTableLayout .cell-content {\n    margin-top: 4px;\n    margin-left: 4px;\n  }\n}\n";
styleInject(css_248z$2a);

const EXPAND_COLLAPSE_COLUMN_SIZE = "48px";
const GUTTER_SIZE_PX = 16;
const INDENT_SIZE_PX = 20;
const throwSizingError = (invalidSizing) => {
  throw new Error(`Invalid table sizing configuration.
     Expected either a sizing object with 'size' and 'unit' fields or an array of two sizing objects.
     Actual value was ${JSON.stringify(invalidSizing)}`);
};
const getGridColumnsStyle = (sizes, expandable, isMobile) => {
  if (isMobile) {
    return void 0;
  }
  const gridColumns = sizes.map((sizing) => {
    if (typeof sizing === "number") {
      return `${sizing}fr`;
    } else if (Array.isArray(sizing) && sizing.length === 2) {
      const [min, max] = sizing;
      return `minmax(${min.size + min.unit}, ${max.size + max.unit})`;
    } else if (!Array.isArray(sizing) && sizing.size && sizing.unit) {
      return `${sizing.size}${sizing.unit}`;
    } else {
      return throwSizingError(sizing);
    }
  });
  if (expandable) {
    gridColumns.push(EXPAND_COLLAPSE_COLUMN_SIZE);
  }
  return gridColumns.join(" ");
};
const TableLayout = ({
  columns,
  expandable,
  expandAll,
  isMobile,
  children,
  sizes
}) => {
  const gridTemplateColumns = getGridColumnsStyle(sizes, expandable, isMobile);
  return /* @__PURE__ */ React.createElement("div", {
    className: "StandardGridTableLayout"
  }, !isMobile && /* @__PURE__ */ React.createElement("div", {
    className: "standard-grid-table-header",
    style: { gridTemplateColumns }
  }, columns.map(({ name, sortDirection, onSort }) => /* @__PURE__ */ React.createElement("div", {
    key: name,
    className: classNames("standard-grid-table-cell", { sortable: !!onSort }),
    onClick: onSort || null
  }, name, sortDirection ? /* @__PURE__ */ React.createElement("span", {
    className: classNames("sort-indicator", sortDirection)
  }) : null)), expandable && /* @__PURE__ */ React.createElement("div", {
    className: "standard-grid-table-cell header-expand-toggle",
    onClick: expandAll
  }, /* @__PURE__ */ React.createElement("i", {
    className: "ico icon-expand-all"
  }))), children);
};
const TableRowLayout = ({
  tableExpandable,
  rowExpandable,
  expanded,
  setExpanded,
  isMobile,
  sizes,
  children,
  renderExpandedContent
}) => {
  const gridTemplateColumns = getGridColumnsStyle(sizes, tableExpandable, isMobile);
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames("standard-grid-table-row-container", {
      "sp-margin-l-bottom": rowExpandable && expanded
    })
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames("standard-grid-table-row", { expandable: rowExpandable, expanded }),
    style: { gridTemplateColumns },
    onClick: rowExpandable ? () => setExpanded(!expanded) : null
  }, children, tableExpandable && !isMobile && /* @__PURE__ */ React.createElement("div", {
    className: "standard-grid-table-cell row-expand-toggle"
  }, rowExpandable && /* @__PURE__ */ React.createElement("i", {
    className: classNames("ico", { "icon-expand": !expanded, "icon-collapse": expanded })
  }))), rowExpandable && expanded && /* @__PURE__ */ React.createElement("div", {
    className: "expanded-row-content"
  }, renderExpandedContent()));
};
const TableCellLayout = ({ children, indent, index, columns, isMobile }) => {
  const columnName = columns[index].name;
  const indentPx = !!indent && isMobile ? `${GUTTER_SIZE_PX + indent * INDENT_SIZE_PX}px` : void 0;
  return /* @__PURE__ */ React.createElement("div", {
    className: "standard-grid-table-cell",
    style: { paddingLeft: indentPx }
  }, isMobile && /* @__PURE__ */ React.createElement("div", {
    className: "mobile-cell-header"
  }, columnName), /* @__PURE__ */ React.createElement("div", {
    className: "cell-content"
  }, children));
};
const standardGridTableLayout = (sizes) => ({
  TableLayout: (props) => /* @__PURE__ */ React.createElement(TableLayout, {
    ...props,
    sizes
  }),
  TableRowLayout: (props) => /* @__PURE__ */ React.createElement(TableRowLayout, {
    ...props,
    sizes
  }),
  TableCellLayout: (props) => /* @__PURE__ */ React.createElement(TableCellLayout, {
    ...props
  })
});

class TetheredCreatable extends Creatable {
  constructor(props) {
    super(props);
    this.renderOuter = this._renderOuter;
  }
  _renderOuter() {
    const menu = super.render.apply(this, arguments);
    if (!menu) {
      return null;
    }
    const selectWidth = this.wrapper ? this.wrapper.offsetWidth : null;
    return /* @__PURE__ */ React__default.createElement(TetherComponent, {
      classes: { element: "layer-high" },
      attachment: "top left",
      targetAttachment: "top left",
      constraints: [{ to: "window", attachment: "together", pin: ["top"] }]
    }, /* @__PURE__ */ React__default.createElement("div", null), React__default.cloneElement(menu, { style: { position: "static", width: selectWidth } }));
  }
}

const BreakString = ({ className, children }) => /* @__PURE__ */ React__default.createElement("span", {
  className,
  style: { wordBreak: "break-all", overflowWrap: "break-word", hyphens: "none" }
}, children);

const SingleLineString = ({ className, children }) => /* @__PURE__ */ React__default.createElement("span", {
  className,
  style: { whiteSpace: "nowrap" }
}, children);

var ToggleSize;
(function(ToggleSize2) {
  ToggleSize2["XSMALL"] = "xs";
  ToggleSize2["SMALL"] = "sm";
  ToggleSize2["MEDIUM"] = "m";
  ToggleSize2["LARGE"] = "lg";
})(ToggleSize || (ToggleSize = {}));
ToggleButtonGroup.defaultProps = {
  toggleSize: ToggleSize.XSMALL,
  displayTextPropOffBtn: "Off",
  tooltipPropOffBtn: "Toggle to turn OFF",
  displayTextPropOnBtn: "On",
  tooltipPropOnBtn: "Toggle to turn ON",
  isPropertyActive: false
};
function ToggleButtonGroup(props) {
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-4 sm-label-left"
  }, /* @__PURE__ */ React__default.createElement("b", null, props.propLabel), props.propHelpFieldId && /* @__PURE__ */ React__default.createElement(HelpField, {
    id: props.propHelpFieldId
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-8 sm-label-left"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "btn-group btn-group-" + props.toggleSize
  }, /* @__PURE__ */ React__default.createElement("button", {
    name: "prop-off",
    type: "button",
    className: `btn btn-default ${!props.isPropertyActive ? "active btn-primary" : "disabled"}`,
    onClick: () => props.onClick(false)
  }, /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: props.tooltipPropOffBtn
  }, /* @__PURE__ */ React__default.createElement("span", null, props.displayTextPropOffBtn))), /* @__PURE__ */ React__default.createElement("button", {
    name: "prop-on",
    type: "button",
    className: `btn btn-default ${props.isPropertyActive ? "active btn-primary" : "disabled"}`,
    onClick: () => props.onClick(true)
  }, /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: props.tooltipPropOnBtn
  }, /* @__PURE__ */ React__default.createElement("span", null, props.displayTextPropOnBtn))))));
}

const IconTooltip = ({ tooltip, placement, delayShow, wrapperClassName, ...iconProps }) => {
  return /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: tooltip,
    placement,
    delayShow
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: wrapperClassName
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    ...iconProps
  })));
};

const targetSelectComponent = {
  bindings: {
    options: "=",
    model: "=",
    onChange: "<?"
  },
  templateUrl: "core/src/pipeline/config/targetSelect.html"
};
const TARGET_SELECT_COMPONENT = "spinnaker.pipeline.targetSelect.component";
module(TARGET_SELECT_COMPONENT, []).component("targetSelect", targetSelectComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/targetSelect.html", `<ui-select ng-model="$ctrl.model.target" on-select="$ctrl.onChange($ctrl.model.target)" class="form-control input-sm">
  <ui-select-match placeholder="None">{{$select.selected.label}}</ui-select-match>
  <ui-select-choices repeat="r.val as r in $ctrl.options ">
    <strong ng-bind-html="r.label | highlight: $select.search"></strong>
    <div ng-bind-html="r.description"></div>
  </ui-select-choices>
</ui-select>
`);
}]);

class PlatformHealthOverride extends React__default.Component {
  constructor() {
    super(...arguments);
    this.clicked = (event) => {
      const interestingHealthProviderNames = event.target.checked ? [this.props.platformHealthType] : null;
      this.props.onChange(interestingHealthProviderNames);
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: isEqual(this.props.interestingHealthProviderNames, [this.props.platformHealthType]),
      onChange: this.clicked
    }), "Consider only ", this.props.platformHealthType, " health"), " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "application.platformHealthOnly",
      expand: this.props.showHelpDetails
    }));
  }
}
function PlatformHealthOverrideInput(props) {
  const { value, onChange, platformHealthType, showHelpDetails, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(PlatformHealthOverride, {
    ...rest,
    interestingHealthProviderNames: value,
    platformHealthType,
    showHelpDetails,
    onChange: (newVal) => {
      onChange(createFakeReactSyntheticEvent({ name: rest.name, value: newVal }));
    }
  });
}

const ModalClose = ({ dismiss }) => /* @__PURE__ */ React__default.createElement("div", {
  className: "modal-close close-button pull-right"
}, /* @__PURE__ */ React__default.createElement("button", {
  className: "link",
  type: "button",
  onClick: dismiss
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "glyphicon glyphicon-remove"
})));

class SubmitButton extends React__default.Component {
  render() {
    const { className, isDisabled, isFormSubmit, isNew, label, onClick, submitting } = this.props;
    const type = isFormSubmit ? "submit" : "button";
    return /* @__PURE__ */ React__default.createElement("button", {
      className,
      disabled: isDisabled,
      onClick,
      type
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-h horizontal middle"
    }, !submitting && /* @__PURE__ */ React__default.createElement("i", {
      className: "far fa-check-circle"
    }) || /* @__PURE__ */ React__default.createElement(Spinner, {
      mode: "circular"
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "sp-margin-xs-left"
    }, label || (isNew ? "Create" : "Update"))));
  }
}
SubmitButton.defaultProps = {
  className: "btn btn-primary",
  onClick: noop,
  isDisabled: false,
  isFormSubmit: false,
  isNew: false
};

class ModalWizard {
  static setHeading(heading) {
    this.heading = heading;
  }
  static getPage(key) {
    return this.pageRegistry.find((p) => p.key === key);
  }
  static markDirty(key) {
    this.getPage(key).state.dirty = true;
  }
  static markClean(key) {
    this.getPage(key).state.dirty = false;
  }
  static markComplete(key) {
    this.getPage(key).state.done = true;
  }
  static markIncomplete(key) {
    this.getPage(key).state.done = false;
  }
  static setCurrentPage(page, skipScroll) {
    this.pageRegistry.forEach((test) => test.state.current = test === page);
    this.currentPage = page;
    if (page.state.markCleanOnView) {
      this.markClean(page.key);
    }
    if (page.state.markCompleteOnView) {
      this.markComplete(page.key);
    }
    if (!skipScroll) {
      ScrollToService.scrollTo(`[waypoint="${page.key}"]`, "[waypoint-container]", 143);
    }
  }
  static registerPage(key, label, state) {
    state = state || {
      done: false,
      blocked: true,
      rendered: true,
      current: false,
      dirty: false,
      markCleanOnView: true,
      markCompleteOnView: false,
      required: false
    };
    this.pageRegistry.push({ key, label, state });
    this.renderPages();
  }
  static renderPages() {
    const renderedPages = this.pageRegistry.filter((page) => page.state.rendered);
    this.renderedPages = renderedPages;
    if (renderedPages.length === 1) {
      this.setCurrentPage(renderedPages[0]);
    }
  }
  static isComplete() {
    return this.renderedPages.map((p) => p.state).filter((s) => s.rendered && s.required).every((s) => s.done && !s.dirty);
  }
  static allPagesVisited() {
    return this.renderedPages.map((p) => p.state).filter((s) => s.rendered && s.required).every((s) => s.done);
  }
  static setRendered(key, rendered) {
    this.pageRegistry.filter((page) => page.key === key).forEach((page) => page.state.rendered = rendered);
    this.renderPages();
  }
  static includePage(key) {
    this.setRendered(key, true);
  }
  static excludePage(key) {
    this.setRendered(key, false);
  }
  static resetWizard() {
    this.renderedPages.length = 0;
    this.pageRegistry.length = 0;
    this.currentPage = null;
    this.heading = null;
  }
}
ModalWizard.renderedPages = [];
ModalWizard.pageRegistry = [];

class WizardPage extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      errors: {},
      order: 0,
      isLoading: false,
      status: "default"
    };
    this.ref = React__default.createRef();
    this.innerRef = React__default.createRef();
    this.onLoadingChanged = (isLoading) => {
      const status = this.computeStatus(this.state.errors, isLoading);
      return this.setState({ isLoading, status }, this.onWizardPageStateChanged);
    };
    this.validate = (values) => {
      const component = this.innerRef.current;
      const errors = component && isFunction(component.validate) && component.validate(values) || {};
      if (!isEqual(errors, this.state.errors)) {
        const status = this.computeStatus(errors, this.state.isLoading);
        this.setState({ errors, status }, this.onWizardPageStateChanged);
      }
      return errors;
    };
  }
  static getStatusClass(status) {
    const statusToCssClass = { error: "dirty", loading: "waiting", default: "done" };
    return statusToCssClass[status] || statusToCssClass.default;
  }
  computeStatus(errors, isLoading) {
    return Object.keys(errors).length ? "error" : isLoading ? "loading" : "default";
  }
  componentDidMount() {
    this.props.wizard.onWizardPageAdded(this);
  }
  componentWillUnmount() {
    this.props.wizard.onWizardPageRemoved(this);
  }
  componentDidUpdate(prevProps) {
    if (this.props.order !== prevProps.order) {
      this.setState({ order: this.props.order }, this.onWizardPageStateChanged);
    }
  }
  onWizardPageStateChanged() {
    this.props.wizard.onWizardPageStateChanged(this);
  }
  render() {
    const { note, label, render } = this.props;
    const { status } = this.state;
    const { innerRef, onLoadingChanged } = this;
    const pageContents = render({ innerRef, onLoadingChanged });
    const className = WizardPage.getStatusClass(status);
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "modal-page",
      ref: this.ref
    }, label && /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-subheading sticky-header"
    }, /* @__PURE__ */ React__default.createElement("h4", {
      className
    }, label)), /* @__PURE__ */ React__default.createElement("div", {
      className: "wizard-page-body"
    }, pageContents, note && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, note)));
  }
}

const flattenErrors = (errors) => {
  const traverse = (obj, path, flattenedErrors) => {
    if (isArray(obj)) {
      obj.forEach((elem, idx) => traverse(elem, `${path}[${idx}]`, flattenedErrors));
    } else if (isString(obj)) {
      flattenedErrors[path] = obj;
    } else if (isObject(obj)) {
      Object.keys(obj).forEach((key) => traverse(obj[key], `${path}.${key}`, flattenedErrors));
    }
    return flattenedErrors;
  };
  return traverse(errors, "errors", {});
};
class WizardStepLabel extends React__default.Component {
  render() {
    const { current, page, onClick } = this.props;
    const { errors, status } = page.state;
    const { label } = page.props;
    const flattenedErrors = flattenErrors(errors);
    const hasErrors = !!Object.keys(flattenedErrors).length;
    const className = `${WizardPage.getStatusClass(status)} ${current ? "current" : ""}`;
    const pageLabel = /* @__PURE__ */ React__default.createElement("li", {
      className
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: () => onClick(page)
    }, label));
    if (!hasErrors) {
      return pageLabel;
    }
    const Errors = /* @__PURE__ */ React__default.createElement("span", null, Object.keys(flattenedErrors).map((key) => /* @__PURE__ */ React__default.createElement("span", {
      key
    }, flattenedErrors[key], " ", /* @__PURE__ */ React__default.createElement("br", null))));
    return /* @__PURE__ */ React__default.createElement(Tooltip, {
      template: Errors
    }, pageLabel);
  }
}

class TrafficGuardHelperLink extends React__default.Component {
  render() {
    const { errorMessage } = this.props;
    if (!errorMessage.includes("has traffic guards enabled")) {
      return null;
    }
    const { $state, $stateParams } = ReactInjector;
    const { project, application } = $stateParams;
    const nextState = `home.${project ? "project" : "applications"}.application.config`;
    const params = { project, application, section: "traffic-guards" };
    const href = $state.href(nextState, params);
    return /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
      href
    }, "Configure Traffic Guards for this application"));
  }
}

class TaskMonitorError extends React__default.Component {
  getBaseState() {
    const { $stateParams } = ReactInjector;
    return `home.${$stateParams.project ? "project" : "applications"}.application`;
  }
  getParams(extras) {
    const { project, application } = ReactInjector.$stateParams;
    return { project, application, ...extras };
  }
  render() {
    const { errorMessage, task } = this.props;
    const { $state } = ReactInjector;
    if (!errorMessage) {
      return null;
    }
    const taskLink = task.id ? $state.href(this.getBaseState() + ".tasks.taskDetails", this.getParams({ taskId: task.id })) : null;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 overlay-modal-error"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "alert"
    }, /* @__PURE__ */ React__default.createElement("h4", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), " Error:"), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement(Markdown, {
      message: errorMessage
    })), /* @__PURE__ */ React__default.createElement(TrafficGuardHelperLink, {
      errorMessage
    })), taskLink && /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
      href: taskLink
    }, "View this failed task in the tasks pane.")));
  }
}

class StatusGlyph extends React__default.Component {
  render() {
    const { item } = this.props;
    const className = classNames([
      "glyphicon",
      "status-glyph",
      {
        "glyphicon-time": item.hasNotStarted,
        "glyphicon-play": item.isRunning,
        "fa fa-check": item.isCompleted,
        "fa fa-exclamation-triangle": item.isFailed || item.status === "TERMINATED",
        "glyphicon-stop": item.isCanceled,
        "glyphicon-pause": item.isSuspended || item.isPaused
      }
    ]);
    return /* @__PURE__ */ React__default.createElement("span", {
      className
    });
  }
}

function displayableTasks(input) {
  const denylist = ["stageStart", "stageEnd", "determineTargetServerGroup"];
  let result = [];
  if (input) {
    result = input.filter((test) => !denylist.includes(test.name) || test.status === "TERMINAL");
  }
  return result;
}
function displayableTaskFilter() {
  return displayableTasks;
}
const DISPLAYABLE_TASKS_FILTER = "spinnaker.pipelines.stages.common.displayableTasks.filter";
module(DISPLAYABLE_TASKS_FILTER, []).filter("displayableTasks", displayableTaskFilter);

const TaskMonitorStatus = ({ monitor }) => {
  const forceUpdate = useForceUpdate();
  useObservable(monitor.statusUpdatedStream, () => forceUpdate());
  if (!monitor.task) {
    return /* @__PURE__ */ React__default.createElement("ul", {
      className: "task"
    }, "submitting task...");
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("ul", {
    className: "task task-progress"
  }, displayableTasks(monitor.task.steps).map((step, i) => /* @__PURE__ */ React__default.createElement("li", {
    key: i
  }, /* @__PURE__ */ React__default.createElement(StatusGlyph, {
    item: step
  }), " ", robotToHuman(step.name), " ", step.startTime && duration(step.runningTimeInMs)))), monitor.task.isRunning && /* @__PURE__ */ React__default.createElement("ul", {
    className: "task task-progress task-progress-running"
  }, /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement(Spinner, {
    size: "small"
  }))), monitor.task.isCompleted && /* @__PURE__ */ React__default.createElement("ul", {
    className: "task task-progress task-progress-refresh"
  }, /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("span", {
    className: "far fa-check-circle"
  }), " ", /* @__PURE__ */ React__default.createElement("strong", null, "Operation succeeded!"))), monitor.task.id && !monitor.error && monitor.application && /* @__PURE__ */ React__default.createElement("p", null, "You can", " ", /* @__PURE__ */ React__default.createElement("a", {
    href: ReactInjector.$state.href("home.applications.application.tasks.taskDetails", {
      application: monitor.application.name,
      taskId: monitor.task.id
    })
  }, "monitor this task from the Tasks view"), "."));
};

const TaskMonitorWrapper = ({ monitor }) => {
  const forceUpdate = useForceUpdate();
  useEffect$a(() => {
    var _a;
    const subscription = (_a = monitor == null ? void 0 : monitor.statusUpdatedStream) == null ? void 0 : _a.subscribe(() => forceUpdate());
    return () => subscription == null ? void 0 : subscription.unsubscribe();
  }, [monitor]);
  if (!monitor || !monitor.submitting && !monitor.error) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(CSSTransition, {
    appear: true,
    classNames: "overlay-modal",
    timeout: 0,
    in: true
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "overlay overlay-modal vertical"
  }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, monitor.title)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "clearfix"
  }, monitor.task && /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-8 col-md-offset-2 overlay-modal-status"
  }, /* @__PURE__ */ React__default.createElement(TaskMonitorStatus, {
    monitor
  })), /* @__PURE__ */ React__default.createElement(TaskMonitorError, {
    errorMessage: monitor.errorMessage,
    task: monitor.task
  }))), !monitor.error && /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: monitor.closeModal
  }, "Close")), monitor.error && /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: () => monitor.tryToFix()
  }, "Go back and try to fix this"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: monitor.closeModal
  }, "Cancel"))));
};

class WizardModal extends React__default.Component {
  constructor() {
    super(...arguments);
    this.stepsElement = React__default.createRef();
    this.formikRef = React__default.createRef();
    this.state = { pages: [], initialized: false, currentPage: null };
    this.onWizardPageAdded = (wizardPage) => {
      this.setState((prevState) => {
        const pages = prevState.pages.concat(wizardPage);
        const currentPage = prevState.currentPage || pages[0];
        return { pages, currentPage };
      }, this.revalidate);
    };
    this.onWizardPageRemoved = (wizardPage) => {
      this.setState((prevState) => {
        const pages = without(prevState.pages, wizardPage);
        const currentPage = prevState.currentPage || pages[0];
        return { pages, currentPage };
      }, this.revalidate);
    };
    this.setCurrentPage = (currentPage) => {
      if (currentPage && this.stepsElement.current && currentPage.ref.current) {
        this.stepsElement.current.scrollTop = currentPage.ref.current.offsetTop;
      }
      this.setState({ currentPage });
    };
    this.handleStepsScroll = (event) => {
      const pageTops = this.state.pages.map((page) => page.ref.current.offsetTop);
      const scrollTop = event.currentTarget.scrollTop;
      let reversedCurrentPage = pageTops.reverse().findIndex((pageTop) => scrollTop >= pageTop);
      if (reversedCurrentPage === void 0) {
        reversedCurrentPage = pageTops.length - 1;
      }
      const currentPageIndex = pageTops.length - (reversedCurrentPage + 1);
      const currentPage = this.state.pages[currentPageIndex];
      if (currentPage !== this.state.currentPage) {
        this.setState({ currentPage });
      }
    };
    this.validate = (values) => {
      const validateProp = this.props.validate || (() => ({}));
      const errorsForPages = this.state.pages.map((page) => page.validate(values)).concat(validateProp(values));
      return errorsForPages.reduce((mergedErrors, errorsForPage) => merge(mergedErrors, errorsForPage), {});
    };
    this.revalidate = () => this.formik && this.formik.validateForm();
  }
  static incrementer() {
    let idx = 0;
    return () => ++idx;
  }
  get formik() {
    return this.formikRef.current && this.formikRef.current.getFormikBag();
  }
  componentDidMount() {
    this.setState({ initialized: true });
  }
  onWizardPageStateChanged(_page) {
    this.forceUpdate();
  }
  render() {
    const {
      formClassName,
      heading,
      initialValues,
      loading,
      submitButtonLabel,
      taskMonitor,
      closeModal,
      dismissModal
    } = this.props;
    const { currentPage, initialized, pages } = this.state;
    const spinner = /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "large"
    }));
    const pageLabels = pages.sort((a, b) => a.state.order - b.state.order).map((page) => /* @__PURE__ */ React__default.createElement(WizardStepLabel, {
      key: page.props.label,
      current: page === currentPage,
      onClick: this.setCurrentPage,
      page
    }));
    const renderPageContents = () => {
      const formik = this.formik;
      const nextIdx = WizardModal.incrementer();
      return formik ? this.props.render({ formik, nextIdx, wizard: this }) : null;
    };
    const isSubmitting = taskMonitor && taskMonitor.submitting;
    const anyLoading = pages.some((page) => page.state.status === "loading");
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, taskMonitor && /* @__PURE__ */ React__default.createElement(TaskMonitorWrapper, {
      monitor: taskMonitor
    }), /* @__PURE__ */ React__default.createElement(SpinFormik, {
      ref: this.formikRef,
      initialValues,
      onSubmit: closeModal,
      validate: this.validate,
      render: (formik) => /* @__PURE__ */ React__default.createElement(Form, {
        className: `form-horizontal ${formClassName}`
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: dismissModal
      }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, heading && /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, heading)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, loading || !initialized ? spinner : /* @__PURE__ */ React__default.createElement("div", {
        className: "row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-3 hidden-sm hidden-xs"
      }, /* @__PURE__ */ React__default.createElement("ul", {
        className: "steps-indicator wizard-navigation"
      }, pageLabels)), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9 col-sm-12"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "steps",
        ref: this.stepsElement,
        onScroll: this.handleStepsScroll
      }, renderPageContents())))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        disabled: isSubmitting,
        onClick: dismissModal,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !formik.isValid || isSubmitting || anyLoading || loading,
        submitting: isSubmitting,
        isFormSubmit: true,
        label: submitButtonLabel
      })))
    }));
  }
}

class WizardPageController {
  constructor($scope) {
    this.$scope = $scope;
  }
  $onInit() {
    this.render = this.render !== false;
    this.markCleanOnView = this.markCleanOnView !== false;
    this.markCompleteOnView = this.markCompleteOnView !== false;
    this.state = {
      blocked: false,
      current: false,
      rendered: this.render,
      done: this.done || !this.mandatory,
      dirty: false,
      required: this.mandatory,
      markCleanOnView: this.markCleanOnView,
      markCompleteOnView: this.markCompleteOnView
    };
    ModalWizard.registerPage(this.key, this.label, this.state);
    this.$scope.$on("$destroy", () => ModalWizard.setRendered(this.key, false));
  }
}
WizardPageController.$inject = ["$scope"];
const wizardPageComponent = {
  bindings: {
    mandatory: "<",
    done: "<",
    markCleanOnView: "<",
    markCompleteOnView: "<",
    key: "@",
    label: "@",
    render: "<"
  },
  transclude: true,
  templateUrl: "core/src/modal/wizard/v2wizardPage.component.html",
  controller: WizardPageController
};
const V2_WIZARD_PAGE_COMPONENT = "spinnaker.core.modal.wizard.wizardPage.component";
module(V2_WIZARD_PAGE_COMPONENT, []).component("v2WizardPage", wizardPageComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/modal/wizard/v2wizardPage.component.html", `<div class="modal-page" ng-if="$ctrl.state.rendered" waypoint="{{ $ctrl.key }}">
  <div class="wizard-subheading sticky-header">
    <h4
      ng-class="{
        default: !$ctrl.state.done,
        current: $ctrl.state.current,
        done: $ctrl.state.done,
        dirty: $ctrl.state.dirty
      }"
    >
      {{ $ctrl.label }}
    </h4>
  </div>
  <div class="wizard-page-body" ng-transclude></div>
</div>
`);
}]);

var css_248z$29 = "v2-modal-wizard .modal-header,\n.wizard-modal .modal-header {\n  /* Set to keep sticky section headings beneath modal header*/\n  position: relative;\n  z-index: 5;\n}\nv2-modal-wizard ul.wizard-navigation,\n.wizard-modal ul.wizard-navigation {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  height: auto;\n  position: relative;\n  background-color: var(--color-white);\n  z-index: 5;\n}\nv2-modal-wizard ul.wizard-navigation:before,\n.wizard-modal ul.wizard-navigation:before,\nv2-modal-wizard ul.wizard-navigation:after,\n.wizard-modal ul.wizard-navigation:after {\n  display: table;\n  content: \" \";\n}\nv2-modal-wizard ul.wizard-navigation:after,\n.wizard-modal ul.wizard-navigation:after {\n  clear: both;\n}\nv2-modal-wizard ul.wizard-navigation li,\n.wizard-modal ul.wizard-navigation li {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 0;\n  position: relative;\n}\nv2-modal-wizard ul.wizard-navigation li a,\n.wizard-modal ul.wizard-navigation li a {\n  color: var(--color-dovegray);\n  display: block;\n  line-height: 15px;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: 0.25s;\n  width: 100%;\n  font-weight: normal;\n  padding: 10px 5px 10px 32px;\n}\nv2-modal-wizard ul.wizard-navigation li a:before,\n.wizard-modal ul.wizard-navigation li a:before {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  width: 14px;\n  height: 14px;\n  border-radius: 100%;\n  background-color: transparent;\n  content: '';\n  transition: 0.25s;\n  font-size: 110%;\n  font-family: 'Glyphicons Halflings';\n}\nv2-modal-wizard ul.wizard-navigation li.done a:before,\n.wizard-modal ul.wizard-navigation li.done a:before {\n  background-color: var(--color-success);\n}\nv2-modal-wizard ul.wizard-navigation li.default,\n.wizard-modal ul.wizard-navigation li.default {\n  pointer-events: auto;\n}\nv2-modal-wizard ul.wizard-navigation li.default a:before,\n.wizard-modal ul.wizard-navigation li.default a:before {\n  background-color: var(--color-dovegray);\n}\nv2-modal-wizard ul.wizard-navigation li.current,\n.wizard-modal ul.wizard-navigation li.current,\nv2-modal-wizard ul.wizard-navigation li:hover,\n.wizard-modal ul.wizard-navigation li:hover,\nv2-modal-wizard ul.wizard-navigation li:active,\n.wizard-modal ul.wizard-navigation li:active {\n  transition: 0.25s;\n  background-color: var(--color-cirrus);\n}\nv2-modal-wizard ul.wizard-navigation li.current a,\n.wizard-modal ul.wizard-navigation li.current a,\nv2-modal-wizard ul.wizard-navigation li:hover a,\n.wizard-modal ul.wizard-navigation li:hover a,\nv2-modal-wizard ul.wizard-navigation li:active a,\n.wizard-modal ul.wizard-navigation li:active a {\n  color: var(--color-mineshaft);\n  font-weight: 600;\n}\nv2-modal-wizard ul.wizard-navigation li.current a:before,\n.wizard-modal ul.wizard-navigation li.current a:before,\nv2-modal-wizard ul.wizard-navigation li:hover a:before,\n.wizard-modal ul.wizard-navigation li:hover a:before,\nv2-modal-wizard ul.wizard-navigation li:active a:before,\n.wizard-modal ul.wizard-navigation li:active a:before {\n  background-color: var(--color-accent);\n  content: '';\n}\nv2-modal-wizard ul.wizard-navigation li.dirty a:before,\n.wizard-modal ul.wizard-navigation li.dirty a:before {\n  color: var(--color-danger);\n  background-color: transparent;\n  content: '\\e088';\n}\nv2-modal-wizard ul.wizard-navigation li.waiting a:before,\n.wizard-modal ul.wizard-navigation li.waiting a:before {\n  background-color: var(--color-seashell);\n}\nv2-modal-wizard .steps,\n.wizard-modal .steps {\n  overflow-y: auto;\n  overflow-x: hidden;\n  clear: both;\n  max-height: calc(100vh - 215px);\n}\nv2-modal-wizard .steps .wizard-subheading,\n.wizard-modal .steps .wizard-subheading {\n  padding: 0;\n  margin-bottom: 10px;\n}\nv2-modal-wizard .steps .wizard-subheading h4,\n.wizard-modal .steps .wizard-subheading h4 {\n  padding: 10px;\n  margin-bottom: 0;\n  color: var(--color-primary);\n  background-color: var(--color-accent-g2);\n}\n@media (max-width: 992px) {\n  v2-modal-wizard .steps .wizard-subheading h4,\n  .wizard-modal .steps .wizard-subheading h4 {\n    padding-left: 0;\n  }\n  v2-modal-wizard .steps .wizard-subheading h4:before,\n  .wizard-modal .steps .wizard-subheading h4:before {\n    display: inline-block;\n    margin: 0 10px;\n    width: 14px;\n    height: 14px;\n    border-radius: 100%;\n    background-color: var(--color-dovegray);\n    content: '';\n    transition: 0.25s;\n    font-size: 15px;\n  }\n  v2-modal-wizard .steps .wizard-subheading h4.done:before,\n  .wizard-modal .steps .wizard-subheading h4.done:before {\n    background-color: var(--color-success);\n  }\n  v2-modal-wizard .steps .wizard-subheading h4.dirty:before,\n  .wizard-modal .steps .wizard-subheading h4.dirty:before {\n    color: var(--color-danger);\n    background-color: transparent;\n    content: '\\e088';\n    font-family: 'Glyphicons Halflings';\n  }\n  v2-modal-wizard .steps .wizard-subheading h4.waiting:before,\n  .wizard-modal .steps .wizard-subheading h4.waiting:before {\n    background-color: var(--color-seashell);\n  }\n}\nv2-modal-wizard .steps .wizard-page-body,\n.wizard-modal .steps .wizard-page-body {\n  padding: 10px 0 20px;\n}\n";
styleInject(css_248z$29);

class V2ModalWizard {
  constructor($scope) {
    this.$scope = $scope;
    this.wizard = ModalWizard;
  }
  $onInit() {
    this.$scope.$on("waypoints-changed", (_event, snapshot) => {
      const ids = snapshot.lastWindow.map((entry) => entry.elem).filter((key) => ModalWizard.getPage(key));
      ids.reverse().forEach((id) => {
        ModalWizard.setCurrentPage(ModalWizard.getPage(id), true);
      });
    });
    ModalWizard.setHeading(this.heading);
  }
  $onDestroy() {
    ModalWizard.resetWizard();
  }
}
V2ModalWizard.$inject = ["$scope"];
const v2ModalWizardComponent = {
  bindings: {
    heading: "@",
    taskMonitor: "<",
    dismiss: "&"
  },
  transclude: true,
  templateUrl: "core/src/modal/wizard/v2modalWizard.component.html",
  controller: V2ModalWizard
};
const V2_MODAL_WIZARD_COMPONENT = "spinnaker.core.modal.wizard.wizard.component";
module(V2_MODAL_WIZARD_COMPONENT, [V2_WIZARD_PAGE_COMPONENT]).component("v2ModalWizard", v2ModalWizardComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/modal/wizard/v2modalWizard.component.html", `<div modal-page>
  <task-monitor ng-if="$ctrl.taskMonitor" monitor="$ctrl.taskMonitor"></task-monitor>
  <modal-close dismiss="$ctrl.dismiss()"></modal-close>
  <div class="modal-header" ng-if="$ctrl.wizard.heading">
    <h4 class="modal-title">{{ $ctrl.wizard.heading }}</h4>
  </div>
  <div ng-class="{ 'modal-body': !$ctrl.notReallyModal }">
    <div class="row">
      <div class="col-md-3 hidden-sm hidden-xs">
        <ul class="steps-indicator wizard-navigation">
          <li
            ng-repeat="page in $ctrl.wizard.renderedPages"
            ng-class="{
              default: !page.state.done,
              current: page.state.current,
              done: page.state.done,
              dirty: page.state.dirty
            }"
          >
            <a href ng-click="$ctrl.wizard.setCurrentPage(page)">{{ page.label }}</a>
          </li>
        </ul>
      </div>
      <div class="col-md-9 col-sm-12">
        <div
          class="steps"
          ng-transclude
          sticky-headers
          waypoint-container
          waypoint-offset="120"
          waypoint-container-key="#modal-wizard"
        ></div>
      </div>
    </div>
  </div>
</div>
`);
}]);

class PlatformHealthOverrideMessage extends React__default.Component {
  constructor(props) {
    super(props);
    this.tooltipTemplate = /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("p", null, "Task not completing?"), /* @__PURE__ */ React__default.createElement("p", null, "By default, Spinnaker does not consider cloud provider health (i.e. whether your instances have launched and are running) as a reliable indicator of instance health."), /* @__PURE__ */ React__default.createElement("p", null, "If your instances do not provide a health indicator known to Spinnaker (e.g. a discovery service or load balancers), you should configure your application to consider only cloud provider health when executing tasks. This option is available under Application Attributes in the ", /* @__PURE__ */ React__default.createElement("b", null, "Config tab"), "."));
    let showMessage = false;
    const lastCapacity = props.task.getValueFor("lastCapacityCheck");
    if (lastCapacity) {
      const lastCapacityTotal = lastCapacity.up + lastCapacity.down + lastCapacity.outOfService + lastCapacity.unknown + lastCapacity.succeeded + lastCapacity.failed;
      const isRelevantTask = props.task.execution.stages.some((stage) => {
        return (stage.type === "cloneServerGroup" || stage.type === "createServerGroup") && stage.tasks.some((task) => task.startTime === props.step.startTime);
      });
      showMessage = isRelevantTask && props.step.name === "waitForUpInstances" && props.step.runningTimeInMs > Duration.fromObject({ minutes: 5 }).as("milliseconds") && lastCapacity.unknown > 0 && lastCapacity.unknown === lastCapacityTotal && !get(props.application, "attributes.platformHealthOnly");
    }
    this.state = { showMessage };
  }
  render() {
    if (!this.state.showMessage) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement(Tooltip, {
      template: this.tooltipTemplate
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-circle",
      style: { fontSize: "smaller" }
    }));
  }
}

class OrchestratedItemTransformer {
  static addRunningTime(item) {
    const testDescriptor = Object.getOwnPropertyDescriptor(item, "runningTime");
    if (testDescriptor && !testDescriptor.enumerable) {
      return;
    }
    Object.defineProperties(item, {
      runningTimeInMs: {
        get: this.calculateRunningTime(item)
      }
    });
  }
  static shouldReplace(previousValue, currentValue) {
    return (isNil(previousValue) || previousValue === "") && !(isNil(currentValue) || currentValue === "");
  }
  static defineProperties(item) {
    const testDescriptor = Object.getOwnPropertyDescriptor(item, "runningTime");
    if (testDescriptor && !testDescriptor.enumerable) {
      return;
    }
    item.getValueFor = (key) => {
      var _a;
      if (item.context) {
        return item.context[key];
      }
      if (!item.variables) {
        return null;
      }
      const match = item.variables.find((variable) => variable.key === key);
      if (match) {
        return match.value;
      }
      const stages = (_a = item.execution) == null ? void 0 : _a.stages;
      if (stages && Array.isArray(stages) && stages.length > 0) {
        const maybeValue = stages.map((stage) => stage.context && get(stage.context, key)).reduce((prev, curr) => OrchestratedItemTransformer.shouldReplace(prev, curr) ? curr : prev, null);
        if (!isNil(maybeValue) && maybeValue !== "") {
          item.variables.push({ key, value: maybeValue });
          return maybeValue;
        }
      }
      return match ? match.value : null;
    };
    item.getDisplayUser = () => {
      var _a, _b, _c;
      const authenticatedUser = (_c = (_b = (_a = item.execution) == null ? void 0 : _a.authentication) == null ? void 0 : _b.user) != null ? _c : "unknown user";
      const user = item.getValueFor("user");
      if (user === null || user === authenticatedUser) {
        return authenticatedUser;
      }
      return `${user} (${authenticatedUser})`;
    };
    item.originalStatus = item.status;
    Object.defineProperties(item, {
      failureMessages: {
        get: () => this.getFailureMessages(item)
      },
      failureMessage: {
        get: () => this.getFailureMessagesAsString(item)
      },
      isCompleted: {
        get: () => ["SUCCEEDED", "SKIPPED"].includes(item.status)
      },
      isRunning: {
        get: () => item.status === "RUNNING"
      },
      isFailed: {
        get: () => ["TERMINAL", "FAILED_CONTINUE", "STOPPED"].includes(item.status)
      },
      isStopped: {
        get: () => item.status === "STOPPED"
      },
      isActive: {
        get: () => ["RUNNING", "SUSPENDED", "NOT_STARTED", "PAUSED"].includes(item.status)
      },
      hasNotStarted: {
        get: () => ["NOT_STARTED", "BUFFERED"].includes(item.status)
      },
      isBuffered: {
        get: () => item.status === "BUFFERED"
      },
      isCanceled: {
        get: () => item.status === "CANCELED"
      },
      isSuspended: {
        get: () => item.status === "SUSPENDED"
      },
      isPaused: {
        get: () => item.status === "PAUSED"
      },
      status: {
        get: () => this.normalizeStatus(item),
        set: (status) => {
          item.originalStatus = status;
          this.normalizeStatus(item);
        }
      },
      runningTime: {
        get: () => {
          const now = Date.now();
          const start = new Date(now - this.calculateRunningTime(item)());
          return formatDistance(start, now, { includeSeconds: true });
        },
        configurable: true
      },
      runningTimeInMs: {
        get: this.calculateRunningTime(item),
        configurable: true
      }
    });
  }
  static getFailureMessagesAsString(item) {
    const exceptions = this.getFailureMessages(item);
    if (exceptions.length === 0) {
      return null;
    }
    return exceptions.join("\n\n");
  }
  static getFailureMessages(task) {
    return [
      this.getCustomExceptionMessage(task),
      ...this.getGeneralExceptionMessages(task),
      this.getOrchestrationExceptionMessage(task)
    ].filter((it) => !!it);
  }
  static getOrchestrationExceptionMessage(task) {
    const katoTasks = task.getValueFor("kato.tasks");
    if (katoTasks && katoTasks.length) {
      const failedTask = katoTasks.find((t) => t.status && t.status.failed);
      if (!failedTask) {
        return null;
      }
      const steps = failedTask.history;
      const exception = failedTask.exception;
      if (exception) {
        return exception.message;
      }
      if (steps && steps.length) {
        return steps[steps.length - 1].status;
      }
    }
    return null;
  }
  static getLockFailureException(task) {
    const generalException = task.getValueFor("exception");
    if (generalException) {
      const details = generalException.details;
      if (details && details.currentLockValue) {
        let typeDisplay;
        let linkUrl;
        if (details.currentLockValue.type === "orchestration") {
          typeDisplay = "task";
          linkUrl = ReactInjector.$state.href("home.applications.application.tasks.taskDetails", {
            application: details.currentLockValue.application,
            taskId: details.currentLockValue.id
          });
        } else {
          typeDisplay = "pipeline";
          linkUrl = ReactInjector.$state.href("home.applications.application.pipelines.executionDetails.execution", {
            application: details.currentLockValue.application,
            executionId: details.currentLockValue.id
          });
        }
        return `Failed to acquire lock. An <a href="${linkUrl}">existing ${typeDisplay}</a> is currently operating on the cluster.`;
      }
    }
    return null;
  }
  static getCustomExceptionMessage(task) {
    const generalException = task.getValueFor("exception");
    if (generalException) {
      if (generalException.exceptionType && generalException.exceptionType === "LockFailureException") {
        return this.getLockFailureException(task);
      }
    }
    return null;
  }
  static getGeneralExceptionMessages(task) {
    var _a, _b, _c;
    const generalException = task.getValueFor("exception");
    if (generalException) {
      const errors = ((_b = (_a = generalException.details) == null ? void 0 : _a.errors) != null ? _b : []).filter((m) => !!m);
      if (errors.length) {
        return errors;
      }
      return ((_c = generalException.details) == null ? void 0 : _c.error) ? [generalException.details.error] : [];
    }
    return [];
  }
  static calculateRunningTime(item) {
    return () => {
      if (!item.startTime) {
        return null;
      }
      const normalizedNow = Math.max(Date.now(), item.startTime);
      return (item.endTime || normalizedNow) - item.startTime;
    };
  }
  static normalizeStatus(item) {
    switch (item.originalStatus) {
      case "SKIPPED":
        return "SKIPPED";
      case "COMPLETED":
      case "SUCCEEDED":
        return "SUCCEEDED";
      case "STARTED":
      case "EXECUTING":
      case "RUNNING":
        return "RUNNING";
      case "FAILED":
      case "TERMINAL":
        return "TERMINAL";
      case "STOPPED":
        return "STOPPED";
      case "SUSPENDED":
      case "DISABLED":
        return "SUSPENDED";
      case "NOT_STARTED":
        return "NOT_STARTED";
      case "CANCELED":
        return "CANCELED";
      case "UNKNOWN":
        return "UNKNOWN";
      case "TERMINATED":
        return "TERMINATED";
      case "PAUSED":
        return "PAUSED";
      case "FAILED_CONTINUE":
        return "FAILED_CONTINUE";
      case "BUFFERED":
        return "BUFFERED";
      default:
        if (item.originalStatus) {
          $log.warn("Unrecognized status:", item.originalStatus);
        }
        return item.originalStatus;
    }
  }
}

class TaskReader {
  static getTasks(applicationName, statuses = [], limitPerPage = null, page = null) {
    return REST("/applications").path(applicationName, "tasks").query({
      statuses: statuses.join(","),
      limit: limitPerPage,
      page
    }).get().then((tasks) => {
      tasks.forEach((task) => this.setTaskProperties(task));
      return tasks.filter((task) => !task.getValueFor("dryRun"));
    });
  }
  static getRunningTasks(applicationName) {
    return this.getTasks(applicationName, this.activeStatuses);
  }
  static getTask(taskId) {
    return REST("/tasks").path(taskId).get().then((task) => {
      this.setTaskProperties(task);
      if (task.execution) {
        OrchestratedItemTransformer.defineProperties(task.execution);
        if (task.execution.stages) {
          task.execution.stages.forEach((stage) => OrchestratedItemTransformer.defineProperties(stage));
        }
      }
      return task;
    }).catch((error) => {
      $log.warn("There was an issue retrieving taskId: ", taskId, error);
      return void 0;
    });
  }
  static waitUntilTaskMatches(task, closure, failureClosure, interval = 1e3, notifier) {
    const deferred = $q.defer();
    if (!task) {
      deferred.reject(null);
    } else if (closure(task)) {
      deferred.resolve(task);
    } else if (failureClosure && failureClosure(task)) {
      deferred.reject(task);
    } else {
      task.poller = $timeout(() => {
        this.getTask(task.id).then((updated) => {
          this.updateTask(task, updated);
          notifier == null ? void 0 : notifier.next();
          this.waitUntilTaskMatches(task, closure, failureClosure, interval, notifier).then(deferred.resolve, deferred.reject);
        });
      }, interval);
    }
    return deferred.promise;
  }
  static waitUntilTaskCompletes(task, interval = 1e3, notifier) {
    return this.waitUntilTaskMatches(task, (t) => t.isCompleted, (t) => t.isFailed, interval, notifier);
  }
  static updateTask(original, updated) {
    if (!updated) {
      return;
    }
    original.status = updated.status;
    original.variables = updated.variables;
    original.steps = updated.steps;
    original.endTime = updated.endTime;
    original.execution = updated.execution;
    original.history = updated.history;
  }
  static setTaskProperties(task) {
    OrchestratedItemTransformer.defineProperties(task);
    if (task.steps && task.steps.length) {
      task.steps.forEach((step) => OrchestratedItemTransformer.defineProperties(step));
    }
  }
}
TaskReader.activeStatuses = ["RUNNING", "SUSPENDED", "NOT_STARTED"];

class TaskMonitor {
  constructor(config) {
    this.config = config;
    this.statusUpdatedStream = new Subject();
    this.closeModal = (evt) => {
      try {
        evt && evt.stopPropagation();
        this.modalInstance.dismiss();
      } catch (ignored) {
      }
    };
    this.tryToFix = () => {
      this.error = null;
      if (this.onTaskRetry) {
        this.onTaskRetry();
      }
      this.statusUpdatedStream.next();
    };
    this.submit = (submitMethod) => {
      this.startSubmit();
      (submitMethod || this.submitMethod)().then((task) => this.handleTaskSuccess(task)).catch((task) => this.setError(task));
    };
    this.title = config.title;
    this.application = config.application;
    this.modalInstance = config.modalInstance;
    this.onTaskComplete = config.onTaskComplete;
    this.onTaskRetry = config.onTaskRetry;
    this.monitorInterval = config.monitorInterval || 1e3;
    this.submitMethod = config.submitMethod;
    if (this.modalInstance) {
      this.modalInstance.result.then(() => this.onModalClose(), () => this.onModalClose());
    }
  }
  static modalInstanceEmulation(onClose, onDismiss) {
    const deferred = $q.defer();
    deferred.promise.catch(() => {
    });
    return {
      deferred,
      result: deferred.promise,
      close: (result) => {
        deferred.resolve(result);
        return onClose(result);
      },
      dismiss: (result) => {
        deferred.reject(result);
        return (onDismiss || onClose)(result);
      }
    };
  }
  onModalClose() {
    if (this.task && this.task.poller) {
      $timeout.cancel(this.task.poller);
    }
  }
  startSubmit() {
    this.submitting = true;
    this.task = null;
    this.error = false;
    this.errorMessage = null;
    document.activeElement && document.activeElement.blur();
    this.statusUpdatedStream.next();
  }
  setError(task) {
    if (task) {
      this.task = task;
      this.errorMessage = task.failureMessage || "There was an unknown server error.";
    } else {
      this.errorMessage = "There was an unknown server error.";
    }
    this.submitting = false;
    this.error = true;
    this.statusUpdatedStream.next();
  }
  handleTaskComplete() {
    var _a;
    (_a = this.onTaskComplete) == null ? void 0 : _a.call(this);
    this.statusUpdatedStream.next();
  }
  handleTaskSuccess(task) {
    this.task = task;
    if (this.application && this.application.getDataSource("runningTasks")) {
      this.application.getDataSource("runningTasks").refresh();
    }
    TaskReader.waitUntilTaskCompletes(task, this.monitorInterval, this.statusUpdatedStream).then(() => this.handleTaskComplete()).catch(() => this.setError(task));
    this.statusUpdatedStream.next();
  }
  callPreconfiguredSubmit(params) {
    this.startSubmit();
    this.submitMethod(params).then((task) => this.handleTaskSuccess(task)).catch((task) => this.setError(task));
  }
}

class TaskReason extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row",
      style: { marginTop: "10px", marginBottom: "10px" }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Reason"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("textarea", {
      className: "form-control",
      value: this.props.reason,
      onChange: (event) => this.props.onChange(event.target.value),
      "ng-model": "vm.command.reason",
      rows: 3,
      placeholder: "(Optional) anything that might be helpful to explain the reason for this change; HTML is okay"
    })));
  }
}

const injectables = [];
class ConsoleDebugWindow {
  constructor() {
    this.api = REST;
    this.plugins = {
      sharedLibraries: {}
    };
  }
  addInjectable(key) {
    injectables.push(key);
  }
}
const DebugWindow = new ConsoleDebugWindow();
if (window) {
  window.spinnaker = DebugWindow;
}
window.spinnaker = DebugWindow;
const DEBUG_WINDOW = "spinnaker.core.utils.consoleDebug";
module(DEBUG_WINDOW, []).run([
  "$injector",
  ($injector) => {
    DebugWindow.$injector = $injector;
    injectables.forEach((k) => DebugWindow[k] = $injector.get(k));
  }
]);

class TaskWriter {
  static postTaskCommand(taskCommand) {
    return REST("/tasks").post(taskCommand);
  }
  static cancelTask(taskId) {
    return REST("/tasks").path(taskId, "cancel").put().then(() => TaskReader.getTask(taskId).then((task) => TaskReader.waitUntilTaskMatches(task, (updatedTask) => updatedTask.status === "CANCELED")));
  }
}
DebugWindow.TaskWriter = TaskWriter;

class TaskExecutor {
  static executeTask(taskCommand) {
    const owner = taskCommand.application || taskCommand.project || { name: "ad-hoc" };
    if (taskCommand.application && taskCommand.application.name) {
      taskCommand.application = taskCommand.application.name;
    }
    if (taskCommand.project && taskCommand.project.name) {
      taskCommand.project = taskCommand.project.name;
    }
    if (taskCommand.job[0].providerType === "aws") {
      delete taskCommand.job[0].providerType;
    }
    taskCommand.job.forEach((j) => j.user = AuthenticationService.getAuthenticatedUser().name);
    return TaskWriter.postTaskCommand(taskCommand).then((task) => {
      const taskId = task.ref.split("/").pop();
      if (owner.runningTasks && owner.runningTasks.refresh) {
        owner.runningTasks.refresh();
      }
      return TaskReader.getTask(taskId);
    }, (response) => {
      var _a;
      const message = ((_a = response.data) == null ? void 0 : _a.message) || "Sorry, no more information.";
      const error = {
        status: response.status,
        message: response.statusText,
        log: message,
        failureMessage: message
      };
      return $q.reject(error);
    });
  }
}

class TaskMonitorModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.close = () => {
      this.props.dismissModal();
    };
    this.submitTask = (values) => {
      const { application, description } = this.props;
      const onClose = (result) => this.props.closeModal(result);
      const onDismiss = (result) => this.props.dismissModal(result);
      const modalInstance = TaskMonitor.modalInstanceEmulation(onClose, onDismiss);
      const taskMonitor = new TaskMonitor({
        application,
        modalInstance,
        title: description,
        onTaskComplete: () => application.serverGroups.refresh()
      });
      const task = this.props.mapValuesToTask(values);
      task.description = this.props.description;
      const submitMethod = () => {
        const promise = TaskExecutor.executeTask(task);
        const done = () => this.setState({ isSubmitting: false });
        promise.then(done, done);
        return promise;
      };
      taskMonitor.submit(submitMethod);
      this.setState({ taskMonitor, isSubmitting: true });
    };
    this.state = {
      taskMonitor: null,
      isSubmitting: false
    };
  }
  render() {
    const { isSubmitting } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(TaskMonitorWrapper, {
      monitor: this.state.taskMonitor
    }), /* @__PURE__ */ React__default.createElement(SpinFormik, {
      initialValues: this.props.initialValues,
      onSubmit: this.submitTask,
      render: (formik) => /* @__PURE__ */ React__default.createElement(Form, {
        className: "form-horizontal"
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: this.close
      }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, this.props.title)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
        className: "entity-tag-editor-modal"
      }, /* @__PURE__ */ React__default.createElement(LayoutProvider, {
        value: ResponsiveFieldLayout
      }, this.props.render(formik))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        disabled: isSubmitting,
        onClick: this.close,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !formik.isValid || isSubmitting,
        submitting: isSubmitting,
        isFormSubmit: true,
        label: "Submit"
      })))
    }));
  }
}

const { useEffect: useEffect$4, useState: useState$5 } = React__default;
function UserVerification(props) {
  const { label, account } = props;
  const [value, setValue] = useState$5("");
  if (props.account && props.expectedValue) {
    throw new Error("Supply either the 'account' or the 'expectedValue' prop, but not both");
  }
  const expectedValue = props.expectedValue || account;
  const matches = value === expectedValue;
  const [challengeDestructiveActions, setChallengeDestructiveActions] = useState$5(true);
  useEffect$4(() => {
    account && AccountService.challengeDestructiveActions(account).then(setChallengeDestructiveActions);
  }, [account]);
  const hideComponent = account && !challengeDestructiveActions;
  useEffect$4(() => props.onValidChange(hideComponent || matches), [matches, hideComponent]);
  const defaultLabel = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "Type the name of the account (", /* @__PURE__ */ React__default.createElement("span", {
    className: "verification-text"
  }, expectedValue), ") to continue");
  const className = `form-control input-sm highlight-pristine ${matches ? "" : "ng-invalid"}`;
  return hideComponent ? null : /* @__PURE__ */ React__default.createElement("div", {
    className: "row verification user-verification"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-sm-12"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-inline"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-control-static"
  }, label ? /* @__PURE__ */ React__default.createElement(Markdown, {
    tag: "span",
    message: label
  }) : defaultLabel), " ", /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "user.verification"
  }), /* @__PURE__ */ React__default.createElement("input", {
    type: "text",
    className,
    value,
    onChange: (evt) => setValue(evt.target.value)
  })))));
}

var css_248z$28 = ".multi-task-monitor .overlay-modal-status {\n  font-size: 90%;\n}\n.multi-task-monitor ul.task-progress {\n  padding-left: 0;\n}\n";
styleInject(css_248z$28);

const MultiTaskMonitor = ({ monitors = [], title, closeModal }) => {
  const [hasErrors, setHasErrors] = React__default.useState(monitors.some((monitor) => monitor.error));
  const isVisible = monitors.some((monitor) => monitor.submitting || monitor.error);
  const clearErrors = () => {
    monitors.forEach((monitor) => monitor.error = null);
    setHasErrors(false);
  };
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "overlay overlay-modal multi-task-monitor"
  }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, title)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "clearfix"
  }, monitors.map((monitor, idx) => {
    var _a, _b;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 overlay-modal-status",
      key: `${(_b = (_a = monitor.task) == null ? void 0 : _a.id) != null ? _b : idx}`
    }, /* @__PURE__ */ React__default.createElement("h4", null, monitor.title), /* @__PURE__ */ React__default.createElement(TaskMonitorStatus, {
      monitor
    }), /* @__PURE__ */ React__default.createElement(TaskMonitorError, {
      task: monitor.task,
      errorMessage: monitor.errorMessage
    }));
  }))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, !hasErrors && /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: closeModal
  }, "Close"), hasErrors && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: clearErrors
  }, "Go back and try to fix this"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: closeModal
  }, "Cancel"))));
};

const ConfirmModal = (props) => {
  const { account, verificationLabel, textToVerify, taskMonitor, taskMonitors, closeModal, dismissModal } = props;
  const { useState, useEffect } = React__default;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRetry, setIsRetry] = useState(false);
  const [isValid, setIsValid] = useState(!account && !verificationLabel && !textToVerify);
  const [error, setError] = useState({ isError: false });
  const [reason, setReason] = useState();
  const [interestingHealthProviderNames, setInterestingHealthProviderNames] = useState();
  useEscapeKeyPressed(() => dismissModal());
  useEffect(() => {
    if (taskMonitor && !taskMonitor.modalInstance) {
      taskMonitor.modalInstance = TaskMonitor.modalInstanceEmulation(closeModal, dismissModal);
    }
    if (taskMonitor == null ? void 0 : taskMonitor.onTaskRetry) {
      const { onTaskRetry } = taskMonitor;
      taskMonitor.onTaskRetry = () => {
        setIsRetry(true);
        setIsSubmitting(false);
        onTaskRetry();
      };
    }
  }, [taskMonitor]);
  const requiresVerification = account || verificationLabel && textToVerify;
  const isDisabled = isSubmitting || !isValid;
  const showError = (e) => {
    setError({ isError: true, message: e });
    setIsSubmitting(false);
  };
  const submit = () => {
    const { submitMethod, submitJustWithReason } = props;
    if (isDisabled) {
      return;
    }
    setIsSubmitting(true);
    if (taskMonitors) {
      taskMonitors.forEach((m) => m.callPreconfiguredSubmit({ reason }));
    } else if (taskMonitor) {
      taskMonitor.submit(() => {
        return submitMethod({
          interestingHealthProviderNames,
          reason
        });
      });
    } else if (submitJustWithReason) {
      submitMethod({ reason }).then(closeModal, showError);
    } else {
      if (submitMethod) {
        submitMethod().then(closeModal, showError);
      } else {
        closeModal();
      }
    }
  };
  const showReasonInput = (taskMonitor || taskMonitors) && props.askForReason || props.submitJustWithReason;
  const showBody = isRetry && props.retryBody || props.bodyContent || error.isError || props.platformHealthOnlyShowOverride || props.askForReason || props.submitJustWithReason;
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(TaskMonitorWrapper, {
    monitor: taskMonitor
  }), /* @__PURE__ */ React__default.createElement(MultiTaskMonitor, {
    monitors: taskMonitors,
    title: props.multiTaskTitle,
    closeModal: () => dismissModal({ source: "taskmonitor" })
  }), /* @__PURE__ */ React__default.createElement(ModalClose, {
    dismiss: () => dismissModal({ source: "header" })
  }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, props.header)), showBody && /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, props.bodyContent, props.platformHealthOnlyShowOverride && /* @__PURE__ */ React__default.createElement(PlatformHealthOverride, {
    interestingHealthProviderNames,
    showHelpDetails: true,
    platformHealthType: props.platformHealthType,
    onChange: setInterestingHealthProviderNames
  }), error.isError && /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, /* @__PURE__ */ React__default.createElement("h4", null, "An error occurred:"), /* @__PURE__ */ React__default.createElement("p", null, error.message || "No details provided.")), isRetry && props.retryBody && /* @__PURE__ */ React__default.createElement(Markdown, {
    message: props.retryBody
  }), showReasonInput && /* @__PURE__ */ React__default.createElement(TaskReason, {
    reason,
    onChange: setReason
  })), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, !isSubmitting && requiresVerification && /* @__PURE__ */ React__default.createElement(UserVerification, {
    onValidChange: setIsValid,
    account,
    expectedValue: textToVerify,
    label: verificationLabel
  }), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    type: "button",
    onClick: () => dismissModal({ source: "footer" })
  }, props.cancelButtonText), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    type: "button",
    onClick: submit,
    disabled: isDisabled
  }, isSubmitting && /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular"
  }), props.buttonText)));
};

class ConfirmationModalService {
  static confirm(params) {
    const extendedParams = { ...this.defaults, ...params };
    if (params.body) {
      extendedParams.bodyContent = toMarkdown(params.body);
    }
    const { taskMonitorConfig, taskMonitorConfigs } = params;
    if (taskMonitorConfig) {
      extendedParams.taskMonitor = new TaskMonitor(taskMonitorConfig);
    }
    if (taskMonitorConfigs) {
      extendedParams.taskMonitors = taskMonitorConfigs.map((m) => new TaskMonitor(m));
    }
    const { promise, resolve, reject } = $q.defer();
    ReactModal.show(ConfirmModal, extendedParams).then(resolve, reject);
    promise.catch(() => {
    });
    return promise;
  }
}
ConfirmationModalService.defaults = {
  buttonText: "Confirm",
  cancelButtonText: "Cancel"
};

class UrlBuilderRegistry {
  constructor() {
    this.builders = {};
  }
  register(key, builder) {
    this.builders[key] = builder;
  }
  getBuilder(key) {
    return this.builders[key];
  }
}

class ProviderSelectionModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.cancel = () => {
      this.props.dismissModal();
    };
    this.selectProvider = () => {
      this.props.closeModal(this.state.selectedProvider);
    };
    this.state = {};
  }
  static show(props) {
    const modalProps = {};
    return ReactModal.show(ProviderSelectionModal, props, modalProps);
  }
  setProvider(selectedProvider) {
    this.setState({ selectedProvider });
  }
  render() {
    const { selectedProvider } = this.state;
    const { providerOptions } = this.props;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ModalClose, {
      dismiss: this.cancel
    }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Select Your Provider")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "card-choices"
    }, providerOptions.map((provider) => /* @__PURE__ */ React__default.createElement("div", {
      className: `card vertical center middle ${selectedProvider === provider && "active"}`,
      key: provider,
      onClick: () => this.setProvider(provider)
    }, CloudProviderRegistry.hasValue(provider, "logo.path") && /* @__PURE__ */ React__default.createElement("img", {
      src: CloudProviderRegistry.getValue(provider, "logo.path"),
      alt: provider,
      width: "100%",
      height: "auto"
    }), !CloudProviderRegistry.hasValue(provider, "logo.path") && /* @__PURE__ */ React__default.createElement("h3", {
      className: "card-label"
    }, provider))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: this.cancel
    }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      onClick: this.selectProvider,
      disabled: !selectedProvider
    }, "Next")));
  }
}

class ProviderSelectionService {
  static selectProvider(application, feature, filterFn) {
    return AccountService.applicationAccounts(application).then((accounts) => {
      let reducedAccounts = [];
      if (feature) {
        reducedAccounts = accounts.filter((a) => CloudProviderRegistry.hasValue(a.cloudProvider, feature));
      }
      if (filterFn) {
        reducedAccounts = reducedAccounts.filter((acc) => {
          return filterFn(application, acc, CloudProviderRegistry.getProvider(acc.cloudProvider));
        });
      }
      const providerOptions = uniq(reducedAccounts.filter((a) => {
        return !CloudProviderRegistry.isDisabled(a.cloudProvider);
      }).map((a) => {
        const providerFeature = CloudProviderRegistry.getProvider(a.cloudProvider)[feature] || {};
        return providerFeature.useProvider || a.cloudProvider;
      }));
      let provider;
      if (providerOptions.length > 1) {
        return ProviderSelectionModal.show({ providerOptions });
      } else if (providerOptions.length === 1) {
        provider = $q.when(providerOptions[0]);
      } else {
        provider = $q.when(SETTINGS.defaultProvider || "aws");
      }
      return provider;
    });
  }
  static isDisabled(app) {
    return AccountService.applicationAccounts(app).then((accounts) => {
      let isDisable = false;
      const cloudProvidersEnabled = accounts.filter((a) => {
        return !CloudProviderRegistry.isDisabled(a.cloudProvider);
      });
      if (cloudProvidersEnabled.length === 0) {
        isDisable = true;
      }
      return isDisable;
    });
  }
}

class CloudProviderLabel extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      label: this.getProviderLabel(props.provider)
    };
  }
  getProviderLabel(provider) {
    return CloudProviderRegistry.getValue(provider, "name") || provider;
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      label: this.getProviderLabel(nextProps.provider)
    });
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("span", null, this.state.label);
  }
}

var css_248z$27 = ".cloud-provider-logo {\n  display: inline-block;\n  margin-right: 3px;\n}\n.cloud-provider-logo .icon {\n  display: inline-block;\n  vertical-align: sub;\n  -webkit-mask-repeat: no-repeat;\n          mask-repeat: no-repeat;\n  -webkit-mask-position: 50% 50%;\n          mask-position: 50% 50%;\n  -webkit-mask-size: cover;\n          mask-size: cover;\n  background-color: var(--color-success);\n}\n.cloud-provider-logo svg {\n  fill: var(--color-success);\n}\n.disabled .cloud-provider-logo .icon {\n  background-color: var(--color-dovegray);\n}\n.disabled .cloud-provider-logo svg {\n  fill: var(--color-success);\n}\n.header-text .cloud-provider-logo {\n  margin-right: 10px;\n}\n";
styleInject(css_248z$27);

const CloudProviderLogo = ({ height, provider, showTooltip, width }) => {
  const [tooltip, setTooltip] = React__default.useState(void 0);
  const RegistryLogo = CloudProviderRegistry.getValue(provider, "cloudProviderLogo");
  React__default.useEffect(() => {
    if (showTooltip) {
      setTooltip(CloudProviderRegistry.getValue(provider, "name") || provider);
    }
  }, [showTooltip]);
  const ProviderLogo = RegistryLogo ? /* @__PURE__ */ React__default.createElement(RegistryLogo, {
    height,
    width
  }) : /* @__PURE__ */ React__default.createElement("span", {
    className: `icon icon-${provider}`,
    style: { height, width }
  });
  if (tooltip) {
    return /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: tooltip
    }, ProviderLogo);
  }
  return /* @__PURE__ */ React__default.createElement("span", {
    className: "cloud-provider-logo"
  }, ProviderLogo);
};

class ProviderServiceDelegate {
  constructor($injector, $q) {
    this.$injector = $injector;
    this.$q = $q;
  }
  hasDelegate(provider, serviceKey) {
    const service = CloudProviderRegistry.getValue(provider, serviceKey);
    return isFunction(service) || isString(service) && this.$injector.has(service);
  }
  getDelegate(provider, serviceKey) {
    const service = CloudProviderRegistry.getValue(provider, serviceKey);
    if (isString(service) && this.$injector.has(service)) {
      return this.$injector.get(service, "providerDelegate");
    } else if (isFunction(service)) {
      return new service(this.$q);
    } else {
      throw new Error('No "' + serviceKey + '" service found for provider "' + provider + '"');
    }
  }
}
ProviderServiceDelegate.$inject = ["$injector", "$q"];
const PROVIDER_SERVICE_DELEGATE = "spinnaker.core.cloudProvider.service.delegate";
module(PROVIDER_SERVICE_DELEGATE, []).service("providerServiceDelegate", ProviderServiceDelegate);

const PreconfiguredJobReader = {
  list() {
    return REST("/jobs/preconfigured").useCache().get();
  }
};

const ArtifactTypePatterns = {
  BITBUCKET_FILE: /bitbucket\/file/,
  CUSTOM_OBJECT: /custom\/object/,
  DOCKER_IMAGE: /docker\/image/,
  EMBEDDED_BASE64: /embedded\/base64/,
  REMOTE_BASE64: /remote\/base64/,
  GCS_OBJECT: /gcs\/object/,
  GITHUB_FILE: /github\/file/,
  GIT_REPO: /git\/repo/,
  GITLAB_FILE: /gitlab\/file/,
  GCE_MACHINE_IMAGE: /gce\/image/,
  JENKINS_FILE: /jenkins\/file/,
  KUBERNETES: /kubernetes\/(.*)/,
  S3_OBJECT: /s3\/object/,
  HELM_CHART: /helm\/chart/,
  IVY_FILE: /ivy\/file/,
  MAVEN_FILE: /maven\/file/,
  HTTP_FILE: /http\/file/,
  FRONT50_PIPELINE_TEMPLATE: /front50\/pipelineTemplate/,
  ORACLE_OBJECT: /oracle\/object/
};
const excludeAllTypesExcept = (...types) => Object.keys(ArtifactTypePatterns).map((k) => ArtifactTypePatterns[k]).filter((type) => !types.includes(type));

class ArtifactEditor$1 extends React__default.Component {
  constructor(props, type) {
    super(props);
    this.onVersionChange = (version) => {
      const clonedArtifact = cloneDeep(this.props.artifact);
      clonedArtifact.version = version;
      this.props.onChange(clonedArtifact);
    };
    if (props.artifact.type !== type && props.artifact.artifactAccount !== "custom-artifact") {
      const clonedArtifact = cloneDeep(props.artifact);
      clonedArtifact.type = type;
      clonedArtifact.customKind = false;
      props.onChange(clonedArtifact);
    }
  }
}

const ExecutionDetailsSection = (props) => {
  if (props.current === props.name) {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "step-section-details"
    }, props.children);
  }
  return null;
};

class StageExecutionLogs extends React__default.Component {
  render() {
    const logs = get(this.props.stage, "context.execution.logs");
    return logs ? /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "well alert alert-info"
    }, /* @__PURE__ */ React__default.createElement("a", {
      target: "_blank",
      href: logs
    }, "View Execution Logs")))) : null;
  }
}

class EventBus {
  static observe(key) {
    return this.message$.pipe(filter((m) => m.key === key), map((m) => m.payload));
  }
  static publish(key, payload) {
    this.message$.next({ key, payload });
  }
}
EventBus.message$ = new Subject();

class RegistrationQueue {
  constructor() {
    this.queue = [];
  }
  setRegistries(overrideRegistry) {
    this.overrideRegistry = overrideRegistry;
    this.flush();
  }
  register(component, key, cloudProvider) {
    this.queue.push(() => {
      if (!cloudProvider) {
        this.overrideRegistry.overrideComponent(key, component);
      } else {
        CloudProviderRegistry.overrideValue(cloudProvider, key, component);
      }
    });
    this.flush();
  }
  flush() {
    if (!this.overrideRegistry || !CloudProviderRegistry) {
      return;
    }
    while (this.queue.length) {
      this.queue.splice(0, 1)[0]();
    }
  }
}
const overrideRegistrationQueue = new RegistrationQueue();
function Overrides(key, cloudProvider) {
  return function(targetComponent) {
    overrideRegistrationQueue.register(targetComponent, key, cloudProvider);
  };
}
const overridesComponent = (targetComponent, key, cloudProvider) => {
  overrideRegistrationQueue.register(targetComponent, key, cloudProvider);
};

class OverrideRegistry {
  constructor() {
    this.templateOverrides = new Map();
    this.componentOverrides = new Map();
    this.controllerOverrides = new Map();
  }
  overrideTemplate(key, val) {
    this.templateOverrides.set(key, val);
  }
  overrideComponent(key, val) {
    this.componentOverrides.set(key, val);
  }
  overrideController(key, val) {
    this.controllerOverrides.set(key, val);
  }
  getTemplate(key, defaultVal) {
    return this.templateOverrides.get(key) || defaultVal;
  }
  getComponent(key) {
    return this.componentOverrides.get(key);
  }
  getController(key, defaultVal = key) {
    return this.controllerOverrides.get(key) || defaultVal;
  }
}
const OVERRIDE_REGISTRY = "spinnaker.core.override.registry";
module(OVERRIDE_REGISTRY, []).service("overrideRegistry", OverrideRegistry).run([
  "overrideRegistry",
  (overrideRegistry) => {
    overrideRegistrationQueue.setRegistries(overrideRegistry);
  }
]);

var __defProp$z = Object.defineProperty;
var __getOwnPropDesc$z = Object.getOwnPropertyDescriptor;
var __decorateClass$z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$z(target, key, result);
  return result;
};
var StageFailureMessages;
(function(StageFailureMessages2) {
  StageFailureMessages2["NO_REASON_PROVIDED"] = "No reason provided.";
})(StageFailureMessages || (StageFailureMessages = {}));
let StageFailureMessage = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }
  getState(props) {
    const { stage } = props;
    if (stage && (stage.isFailed || stage.isStopped)) {
      const failedTask = (stage.tasks || []).find((t) => t.status === "TERMINAL" || t.status === "STOPPED");
      let failedStageName = stage.name;
      let failedExecutionId;
      let failedStageId;
      if (!failedTask || !props.message && props.messages.length === 0) {
        const exceptionSource = get(stage.context, "exception.source");
        if (exceptionSource) {
          failedStageName = exceptionSource.stageName;
          failedExecutionId = exceptionSource.executionId;
          failedStageId = exceptionSource.stageId;
        } else if (stage.after) {
          const failedStage = stage.after.find((s) => s.status === "TERMINAL" || s.status === "STOPPED");
          if (failedStage) {
            failedStageName = robotToHuman(failedStage.name);
            failedStageId = failedStage.id;
          }
        }
      }
      return { isFailed: true, failedTask, failedExecutionId, failedStageName, failedStageId };
    }
    return { failedTask: void 0, isFailed: false };
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  render() {
    const { message, messages } = this.props;
    const { isFailed, failedTask, failedExecutionId, failedStageName, failedStageId } = this.state;
    if (isFailed || failedTask || message || messages.length) {
      const exceptionTitle = isFailed ? messages.length ? "Exceptions" : "Exception" : "Warning";
      const displayMessages = message || !messages.length ? /* @__PURE__ */ React__default.createElement(Markdown, {
        message: message || StageFailureMessages.NO_REASON_PROVIDED,
        className: "break-word"
      }) : messages.map((m, i) => /* @__PURE__ */ React__default.createElement(Markdown, {
        key: i,
        message: m || StageFailureMessages.NO_REASON_PROVIDED,
        className: "break-word"
      }));
      if (displayMessages) {
        return /* @__PURE__ */ React__default.createElement("div", {
          className: "row"
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "col-md-12"
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: `alert ${exceptionTitle === "Warning" ? "alert-warning" : "alert-danger"}`
        }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h5", null, exceptionTitle, " ", failedTask && /* @__PURE__ */ React__default.createElement("span", null, "( ", robotToHuman(failedTask.name), " )")), displayMessages, /* @__PURE__ */ React__default.createElement(TrafficGuardHelperLink, {
          errorMessage: message || messages.join(",")
        })))));
      }
      if (failedStageId !== void 0) {
        const currentState = ReactInjector.$state.current;
        const params = {
          stageId: failedStageId
        };
        if (failedExecutionId !== void 0) {
          params.executionId = failedExecutionId;
        }
        return /* @__PURE__ */ React__default.createElement("div", {
          className: "row"
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "col-md-12"
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "alert alert-danger"
        }, /* @__PURE__ */ React__default.createElement("div", null, "Stage", " ", /* @__PURE__ */ React__default.createElement(UISref, {
          to: currentState.name,
          params
        }, /* @__PURE__ */ React__default.createElement("a", null, failedStageName)), " ", "failed."))));
      }
      EventBus.publish("stage-failure-message:no-reason", { params: { ...ReactInjector.$state.params } });
    }
    return null;
  }
};
StageFailureMessage.defaultProps = {
  messages: []
};
StageFailureMessage = __decorateClass$z([
  Overridable("stageFailureMessage"),
  UIRouterContext
], StageFailureMessage);

function AsgActionExecutionDetailsSection(props) {
  const { action, stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region), /* @__PURE__ */ React__default.createElement("dt", null, "Server Group"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.serverGroupName)))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage,
    message: stage.failureMessage
  }), stage.isCompleted && stage.context.serverGroupName && /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "well alert alert-info"
  }, /* @__PURE__ */ React__default.createElement("strong", null, action, ": "), stage.context.serverGroupName))), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage
  }));
}

const DAYS_OF_WEEK = [
  {
    key: "sunday",
    label: "Sun",
    ordinal: 1
  },
  {
    key: "monday",
    label: "Mon",
    ordinal: 2
  },
  {
    key: "tuesday",
    label: "Tue",
    ordinal: 3
  },
  {
    key: "wednesday",
    label: "Wed",
    ordinal: 4
  },
  {
    key: "thursday",
    label: "Thu",
    ordinal: 5
  },
  {
    key: "friday",
    label: "Fri",
    ordinal: 6
  },
  {
    key: "saturday",
    label: "Sat",
    ordinal: 7
  }
];

const DEFAULT_SKIP_WINDOW_TEXT = "The pipeline will proceed immediately, continuing to the next step in the stage.";
class ExecutionWindowActions extends React__default.Component {
  constructor(props) {
    super(props);
    this.finishWaiting = (e) => {
      const { executionService } = ReactInjector;
      e.target.blur();
      const { application, execution, stage } = this.props;
      const matcher = (updated) => {
        const match = updated.stages.find((test) => test.id === stage.id);
        return match.status !== "RUNNING";
      };
      const data = { skipRemainingWait: true };
      ConfirmationModalService.confirm({
        header: "Really skip execution window?",
        buttonText: "Skip",
        body: stage.context.skipWindowText || `<p>${DEFAULT_SKIP_WINDOW_TEXT}</p>`,
        submitMethod: () => {
          return executionService.patchExecution(execution.id, stage.id, data).then(() => executionService.waitUntilExecutionMatches(execution.id, matcher)).then((updated) => executionService.updateExecution(application, updated));
        }
      });
    };
    var _a;
    const days = (_a = props.stage.context.restrictedExecutionWindow) == null ? void 0 : _a.days;
    let dayText = "Everyday";
    if (days && days.length > 0) {
      dayText = this.replaceDays(days).join(", ");
    }
    this.state = {
      dayText
    };
  }
  replaceDays(days) {
    const daySet = new Set(days);
    return DAYS_OF_WEEK.filter((day) => daySet.has(day.ordinal)).map((day) => day.label);
  }
  render() {
    const { stage } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h5", null, "Execution Windows Configuration"), /* @__PURE__ */ React__default.createElement("strong", null, "Stage execution can only run:"), /* @__PURE__ */ React__default.createElement("dl", {
      className: "dl-narrow dl-horizontal"
    }, get(stage, "context.restrictedExecutionWindow.whitelist", []).map((entry, index) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        key: index
      }, /* @__PURE__ */ React__default.createElement("dt", null, "From"), /* @__PURE__ */ React__default.createElement("dd", null, timePickerTime({ hours: entry.startHour, minutes: entry.startMin }), /* @__PURE__ */ React__default.createElement("strong", {
        style: { display: "inline-block", margin: "0 5px" }
      }, " to "), timePickerTime({ hours: entry.endHour, minutes: entry.endMin }), /* @__PURE__ */ React__default.createElement("strong", null, " ", /* @__PURE__ */ React__default.createElement(SystemTimezone, null), " ")));
    }), /* @__PURE__ */ React__default.createElement("dt", null, "On"), /* @__PURE__ */ React__default.createElement("dd", null, this.state.dayText)), stage.context.skipRemainingWait && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, "(skipped "), stage.context.lastModifiedBy && /* @__PURE__ */ React__default.createElement("span", null, " by ", stage.context.lastModifiedBy), ")"), stage.isSuspended && /* @__PURE__ */ React__default.createElement("div", {
      className: "action-buttons"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-xs btn-primary",
      onClick: this.finishWaiting
    }, /* @__PURE__ */ React__default.createElement("span", {
      style: { marginRight: "5px" },
      className: "small glyphicon glyphicon-fast-forward"
    }), "Skip remaining window")));
  }
}

const DEFAULT_SKIP_WAIT_TEXT$2 = "The pipeline will proceed immediately, marking this stage completed.";
const skipRemainingWait = (event, stage, execution, application) => {
  const { executionService } = ReactInjector;
  event.target.blur();
  const matcher = ({ stages }) => {
    const match = stages.find((test) => test.id === stage.id);
    return match.status !== "RUNNING";
  };
  const data = { status: "SKIPPED" };
  ConfirmationModalService.confirm({
    header: "Really skip wait?",
    buttonText: "Skip",
    body: stage.context.skipWaitText || DEFAULT_SKIP_WAIT_TEXT$2,
    submitMethod: () => {
      return executionService.patchExecution(execution.id, stage.id, data).then(() => executionService.waitUntilExecutionMatches(execution.id, matcher)).then((updated) => executionService.updateExecution(application, updated));
    }
  });
};
const SkipConditionWait = ({ stage, execution, application }) => {
  const { conditions } = stage.outputs;
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, conditions && conditions.length > 0 && /* @__PURE__ */ React__default.createElement("ul", {
    className: "nostyle",
    style: { marginBottom: "10px" }
  }, conditions.map(({ name, description }, index) => /* @__PURE__ */ React__default.createElement("li", {
    key: name + index
  }, /* @__PURE__ */ React__default.createElement("b", null, name), ": ", description))), stage.context.status === "SKIPPED" && /* @__PURE__ */ React__default.createElement("span", null, "(skipped after ", duration(stage.runningTimeInMs), ")")), stage.isSuspended && /* @__PURE__ */ React__default.createElement("div", {
    className: "action-buttons"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-xs btn-primary",
    onClick: (event) => skipRemainingWait(event, stage, execution, application)
  }, /* @__PURE__ */ React__default.createElement("span", {
    style: { marginRight: "5px" },
    className: "small glyphicon glyphicon-fast-forward"
  }), "Skip remaining wait")));
};

class ExecutionBarLabel extends React__default.Component {
  constructor(props) {
    super(props);
    this.mounted = false;
    this.hydrate = () => {
      const { application, execution } = this.props;
      if (!this.requiresHydration() || !execution) {
        return;
      }
      ReactInjector.executionService.hydrate(application, execution).then(() => {
        if (this.mounted && !this.state.hydrated) {
          this.setState({ hydrated: true });
        }
      });
    };
    this.requiresHydration = () => {
      const { stage } = this.props;
      const { suspendedStageTypes } = stage;
      const requireHydration = ["restrictExecutionDuringTimeWindow", "waitForCondition"];
      return stage.labelComponent !== ExecutionBarLabel || requireHydration.some((s) => suspendedStageTypes.has(s));
    };
    this.DefaultLabel = () => {
      const { stage, application, execution } = this.props;
      const LabelComponent = stage.labelComponent;
      const tooltip = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
        id: stage.id
      }, /* @__PURE__ */ React__default.createElement(LabelComponent, {
        application,
        execution,
        stage
      }));
      return /* @__PURE__ */ React__default.createElement(OverlayTrigger, {
        placement: "top",
        overlay: tooltip
      }, this.props.children);
    };
    this.getExecutionWindowTemplate = () => {
      const { stage, application, execution } = this.props;
      const executionWindowStage = stage.stages.find((s) => s.type === "restrictExecutionDuringTimeWindow");
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, stage.name), " (waiting for execution window)"), /* @__PURE__ */ React__default.createElement(ExecutionWindowActions, {
        application,
        execution,
        stage: executionWindowStage
      }));
    };
    this.getWaitForConditionTemplate = () => {
      const { stage, application, execution } = this.props;
      const waitForConditionStage = stage.stages.find((s) => s.type === "waitForCondition");
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, stage.name), " (waiting until conditions are met)"), "Conditions:", /* @__PURE__ */ React__default.createElement(SkipConditionWait, {
        application,
        execution,
        stage: waitForConditionStage
      }));
    };
    this.state = {
      hydrated: props.execution && props.execution.hydrated
    };
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  getRenderableStageName() {
    const { stage } = this.props;
    let stageName = stage.name ? stage.name : stage.type;
    const params = ReactInjector.$uiRouter.globals.params;
    if (stage.type === "group" && stage.groupStages && stage.index === Number(params.stage)) {
      const subStageIndex = Number(params.subStage);
      if (!Number.isNaN(subStageIndex)) {
        const activeStage = stage.groupStages[subStageIndex];
        if (activeStage) {
          stageName += `: ${activeStage.name}`;
        }
      }
    }
    return stageName;
  }
  render() {
    const { stage, executionMarker } = this.props;
    const { suspendedStageTypes } = stage;
    const { getExecutionWindowTemplate, getWaitForConditionTemplate, DefaultLabel } = this;
    if (executionMarker) {
      const requiresHydration = this.requiresHydration();
      let template = null;
      if (requiresHydration && !this.state.hydrated) {
        template = /* @__PURE__ */ React__default.createElement(Spinner, {
          size: "small"
        });
      } else if (suspendedStageTypes.has("restrictExecutionDuringTimeWindow")) {
        template = getExecutionWindowTemplate();
      } else if (suspendedStageTypes.has("waitForCondition")) {
        template = getWaitForConditionTemplate();
      }
      if (template) {
        return /* @__PURE__ */ React__default.createElement("span", {
          onMouseEnter: this.hydrate
        }, /* @__PURE__ */ React__default.createElement(HoverablePopover, {
          template
        }, this.props.children));
      } else {
        return /* @__PURE__ */ React__default.createElement(DefaultLabel, null);
      }
    }
    return /* @__PURE__ */ React__default.createElement("span", null, this.getRenderableStageName());
  }
}

const runningStatuses = ["RUNNING", "SUSPENDED"];
class OrchestratedItemRunningTime {
  constructor(item, updateCallback) {
    this.item = item;
    this.updateCallback = updateCallback;
    this.checkStatus();
  }
  checkStatus(item = this.item) {
    if (item && item !== this.item) {
      this.item = item;
    }
    if (!runningStatuses.includes(this.item.status)) {
      this.reset();
      this.updateCallback(this.item.runningTimeInMs);
    }
    if (runningStatuses.includes(this.item.status) && !this.updateInterval) {
      this.updateInterval = setInterval(() => this.updateCallback(Date.now() - this.item.startTime), 1e3);
      this.updateCallback(Date.now() - this.item.startTime);
    }
    return void 0;
  }
  reset() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
      this.updateInterval = void 0;
    }
  }
}

class ExecutionStepDetails extends React__default.Component {
  componentWillUnmount() {
    this.runningTime && this.runningTime.reset();
  }
  componentDidMount() {
    const { item } = this.props;
    const runningTask = (item.tasks || []).find((t) => t.status === "RUNNING");
    if (runningTask) {
      this.runningTime = new OrchestratedItemRunningTime(runningTask, (time) => this.setState({ runningTimeInMs: time }));
    }
  }
  render() {
    const { item } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Task")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 text-right"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Duration"))), displayableTasks(item.tasks || []).map((task, index) => /* @__PURE__ */ React__default.createElement("div", {
      key: index,
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "small"
    }, /* @__PURE__ */ React__default.createElement(StatusGlyph, {
      item: task
    })), " ", robotToHuman(task.name)), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 text-right"
    }, duration(task.runningTimeInMs))))));
  }
}

function ExecutionDetailsTasks(props) {
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement(ExecutionStepDetails, {
    item: props.stage
  }));
}
(function(ExecutionDetailsTasks2) {
  ExecutionDetailsTasks2.title = "taskStatus";
})(ExecutionDetailsTasks || (ExecutionDetailsTasks = {}));

const ExecutionMarkerIcon = ({ stage }) => stage.isSuspended || stage.suspendedStageTypes.size > 0 ? /* @__PURE__ */ React__default.createElement("span", {
  className: "far fa-clock sp-margin-xs-right"
}) : null;

const StageConfigField = (props) => /* @__PURE__ */ React__default.createElement("div", {
  className: props.groupClassName != null ? props.groupClassName : "form-group"
}, /* @__PURE__ */ React__default.createElement("label", {
  className: `col-md-${props.labelColumns || 3} sm-label-right`
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "label-text"
}, props.label, " "), props.helpKey && /* @__PURE__ */ React__default.createElement(HelpField, {
  id: props.helpKey
})), /* @__PURE__ */ React__default.createElement("div", {
  className: `col-md-${props.fieldColumns || 8}`
}, props.children));

const applySuspendedStatuses = (execution, stageType) => {
  const runningStagesOfType = execution.stages.filter((stage) => stage.type === stageType && stage.status === "RUNNING");
  runningStagesOfType.forEach((stage) => {
    stage.status = "SUSPENDED";
    stage.tasks.forEach(function(task) {
      task.status = "SUSPENDED";
    });
  });
  if (runningStagesOfType.length > 0 && execution.status === "RUNNING") {
    const hasOtherRunningStages = execution.stages.some((stage) => stage.status === "RUNNING");
    if (!hasOtherRunningStages) {
      execution.status = "SUSPENDED";
    }
  }
};

class JsonListBuilder {
  static convertJsonKeysToBracketedList(json, ignoreList = []) {
    const stack = [];
    const array = [];
    const parentList = [];
    stack.push(json);
    while (stack.length !== 0) {
      const node = stack.pop();
      const keys = Object.keys(node);
      const p = parentList.pop() || "";
      this.processKeys(keys, node, parentList, p, stack, array, ignoreList);
    }
    return array;
  }
  static escapeForRegEx(item) {
    return item ? item.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") : null;
  }
  static processKeys(keys, node, parentList, parent, stack, array, ignoreList) {
    keys.forEach((key) => {
      const entry = isFinite(parseInt(key, 10)) ? `${parent}[${parseInt(key, 10)}]` : `${parent}['${key}']`;
      const value = node[key];
      if (!(isObject(value) || Array.isArray(value))) {
        if (!ignoreList.some((ignoreItem) => {
          const testerString = `['${ignoreItem}`;
          return entry.substr(0, testerString.length) === testerString;
        })) {
          array.push({ leaf: entry, value });
        }
      }
      if (isObject(node[key])) {
        parentList.push(entry);
        stack.push(node[key]);
      }
    });
  }
}

class SpelAutocompleteService {
  constructor($q, executionService) {
    this.$q = $q;
    this.executionService = executionService;
    this.executionCache = {};
    this.brackets = [
      { open: "(", close: ")" },
      { open: "[", close: "]" }
    ];
    this.quotes = [
      { open: "'", close: "'" },
      { open: '"', close: '"' }
    ];
    this.helperFunctions = [
      "alphanumerical",
      "readJson",
      "fromUrl",
      "propertiesFromUrl",
      "jsonFromUrl",
      "judgment",
      "stage",
      "toBoolean",
      "toFloat",
      "toInt",
      "toJson",
      "toBase64",
      "fromBase64",
      "cfServiceKey"
    ];
    this.helperParams = [
      "execution",
      "parameters",
      "trigger",
      "scmInfo",
      "scmInfo.sha1",
      "scmInfo.branch",
      "deployedServerGroups"
    ];
    this.codedHelperParams = this.helperParams.map((param) => {
      return { name: param, type: "param" };
    });
    this.textcompleteConfig = [
      {
        id: "SpEL wrapper",
        match: /\$(\w*)$/,
        search: function(_, callback) {
          callback(["${...}"]);
        },
        index: 1,
        replace: function replace() {
          return ["${ ", " }"];
        }
      },
      {
        id: "match quotes",
        match: /(["'])(\w*)$/,
        index: 1,
        search: (term, callback) => {
          callback(this.quotes.filter((bracket) => bracket.open.indexOf(term) === 0));
        },
        template: function() {
          return `'...'`;
        },
        replace: function replace() {
          return [`'`, `'`];
        }
      },
      {
        id: "match brackets",
        match: /([[('])(\w*)$/,
        index: 1,
        search: (term, callback) => {
          callback(this.brackets.filter((bracket) => bracket.open.indexOf(term) === 0));
        },
        template: (value) => {
          return `${value.open}...${value.close}`;
        },
        replace: (bracket) => {
          return [`${bracket.open}  `, `  ${bracket.close}`];
        }
      }
    ];
  }
  paramInList(checkParam) {
    return (testParam) => checkParam.name === testParam.name;
  }
  addToTextcompleteConfig(configList, textcompleteConfig) {
    const textcompleteConfigCopy = textcompleteConfig.slice(0);
    for (const newConfig of configList) {
      if (textcompleteConfig.filter((config) => config.id === newConfig.id).length === 0) {
        textcompleteConfigCopy.push(newConfig);
      }
    }
    return textcompleteConfigCopy;
  }
  listSearchFn(list) {
    return (term, callback) => {
      callback(list.filter((item) => {
        if (item.leaf.includes(term)) {
          return item;
        }
      }));
    };
  }
  leafTemplateFn(stage) {
    return `${stage.leaf} <span class="glyphicon glyphicon-triangle-right spel-value-separator"/> <span class="marker value"
      title="${stage.value}">${stage.value.length > 90 ? `${stage.value.slice(0, 90)}...` : stage.value}</span>`;
  }
  addExecutionForAutocomplete(execution, textcompleteConfig) {
    if (execution) {
      const executionList = JsonListBuilder.convertJsonKeysToBracketedList(execution, ["task"]);
      const configList = [
        {
          id: `execution: ${execution.id}`,
          match: /execution(\w*|\s*)$/,
          index: 1,
          search: this.listSearchFn(executionList),
          template: this.leafTemplateFn,
          replace: (value) => {
            return `execution${value.leaf}`;
          }
        }
      ];
      return this.addToTextcompleteConfig(configList, textcompleteConfig);
    }
    return textcompleteConfig;
  }
  addDeployedServerGroupsForAutoComplete(execution, textcompleteConfig) {
    if (execution && execution.context && execution.context.deploymentDetails) {
      const deployList = JsonListBuilder.convertJsonKeysToBracketedList(execution.context.deploymentDetails);
      const configList = [
        {
          id: `deploymentServerGroups: ${execution.id}`,
          match: /deployedServerGroups(\w*|\s*)$/,
          index: 1,
          search: this.listSearchFn(deployList),
          template: this.leafTemplateFn,
          replace: (value) => {
            return `deployedServerGroups${value.leaf}`;
          }
        }
      ];
      return this.addToTextcompleteConfig(configList, textcompleteConfig);
    }
    return textcompleteConfig;
  }
  addStageDataForAutocomplete(pipeline, textcompleteConfig) {
    if (pipeline && pipeline.stages) {
      const configList = pipeline.stages.map((stage) => {
        const stageList = JsonListBuilder.convertJsonKeysToBracketedList(stage, ["task"]);
        return {
          id: `stage config for ${stage.name}`,
          match: new RegExp(`#stage\\(\\s*'${JsonListBuilder.escapeForRegEx(stage.name)}'\\s*\\)(.*)$`),
          index: 1,
          search: this.listSearchFn(stageList),
          template: this.leafTemplateFn,
          replace: (param) => {
            return `#stage('${stage.name}')${param.leaf}`;
          }
        };
      });
      return this.addToTextcompleteConfig(configList, textcompleteConfig);
    }
    return textcompleteConfig;
  }
  addManualJudgementConfigForAutocomplete(pipeline, textcompleteConfig) {
    if (pipeline && pipeline.stages) {
      const manualJudgementStageList = pipeline.stages.filter((stage) => stage.type === "manualJudgment");
      const configList = manualJudgementStageList.map((stage) => {
        const stageList = JsonListBuilder.convertJsonKeysToBracketedList(stage);
        return {
          id: `judgement config for ${stage.name}`,
          match: new RegExp(`#judgment\\(\\s*'\\s*${JsonListBuilder.escapeForRegEx(stage.name)}'\\s*\\)(.*)$`),
          index: 1,
          search: this.listSearchFn(stageList),
          template: this.leafTemplateFn,
          replace: (param) => {
            return `#judgement('${stage.name}')${param.leaf}`;
          }
        };
      });
      return this.addToTextcompleteConfig(configList, textcompleteConfig);
    }
    return textcompleteConfig;
  }
  addTriggerConfigForAutocomplete(pipeline, textcompleteConfig) {
    if (pipeline && pipeline.trigger) {
      const triggerAsList = [pipeline.trigger];
      const configList = triggerAsList.map((trigger) => {
        const triggerInfoList = JsonListBuilder.convertJsonKeysToBracketedList(trigger);
        return {
          id: `trigger config: ${trigger.type}`,
          match: /trigger(\w*|\s*)$/,
          index: 1,
          search: this.listSearchFn(triggerInfoList),
          template: this.leafTemplateFn,
          replace: (value) => {
            return `trigger${value.leaf}`;
          }
        };
      });
      return this.addToTextcompleteConfig(configList, textcompleteConfig);
    }
    return textcompleteConfig;
  }
  addParameterConfigForAutocomplete(pipeline, textcompleteConfig) {
    if (pipeline && pipeline.parameterConfig) {
      const paramsAsList = [pipeline.parameterConfig];
      const configList = paramsAsList.map((params) => {
        const paramsInfoList = JsonListBuilder.convertJsonKeysToBracketedList(params);
        return {
          id: `parameter config: ${Object.keys(params).join(",")}`,
          match: /parameters(\w*|\s*)$/,
          index: 1,
          search: this.listSearchFn(paramsInfoList),
          template: this.leafTemplateFn,
          replace: (value) => {
            return `parameters${value.leaf}`;
          }
        };
      });
      return this.addToTextcompleteConfig(configList, textcompleteConfig);
    }
    return textcompleteConfig;
  }
  hasBuildTriggerOrStage(pipeline, ...systems) {
    return systems.some((system) => pipeline.triggers && pipeline.triggers.some((trigger) => trigger.type === system) || pipeline.stages.some((stage) => stage.type === system));
  }
  addStageNamesToCodeHelperList(pipeline, textcompleteConfig) {
    if (pipeline && pipeline.stages) {
      let codedHelperParamsCopy = this.codedHelperParams.slice(0);
      const pipelineHasParameters = pipeline.parameterConfig && pipeline.parameterConfig.length;
      codedHelperParamsCopy = pipelineHasParameters ? codedHelperParamsCopy : codedHelperParamsCopy.filter((param) => param.name !== "parameters");
      codedHelperParamsCopy = this.hasBuildTriggerOrStage(pipeline, "jenkins", "concourse") ? codedHelperParamsCopy : codedHelperParamsCopy.filter((param) => !param.name.includes("scmInfo"));
      pipeline.stages.forEach((stage) => {
        const newParam = { name: stage.name, type: stage.type };
        if (codedHelperParamsCopy.filter(this.paramInList(newParam)).length === 0) {
          codedHelperParamsCopy.push({ name: stage.name, type: "stage" });
        }
      });
      const configList = [
        {
          id: "params",
          match: /(\s*|\w*)\?(\s*|\w*|')$/,
          index: 2,
          search: (term, callback) => {
            callback(codedHelperParamsCopy.filter((param) => param.name.includes(term) || param.type.includes(term)));
          },
          template: (value) => `<span class="marker ${value.type}"/> ${value.name}`,
          replace: (param) => `${param.name}`
        }
      ];
      return this.addToTextcompleteConfig(configList, textcompleteConfig);
    }
    return textcompleteConfig;
  }
  addHelperFunctionsBasedOnStages(pipeline, textcompleteConfig) {
    if (pipeline && pipeline.stages) {
      let helperFunctionsCopy = this.helperFunctions.slice(0);
      const hasManualJudmentStage = pipeline.stages.some((stage) => stage.type === "manualJudgment");
      if (!hasManualJudmentStage) {
        helperFunctionsCopy = this.helperFunctions.filter((fnName) => fnName !== "judgment");
      }
      const hasCreateServiceKeyStage = pipeline.stages.some((stage) => stage.type === "createServiceKey");
      if (!hasCreateServiceKeyStage) {
        helperFunctionsCopy = this.helperFunctions.filter((fnName) => fnName !== "cfServiceKey");
      }
      const configList = [
        {
          id: "helper functions",
          match: /#([\w.]*)$/,
          index: 1,
          search: (term, callback) => {
            callback(helperFunctionsCopy.filter((helper) => helper.startsWith(term)));
          },
          template: (value) => `<span class="marker function"/> #${value}`,
          replace: (helper) => helper === "toJson" ? [`#${helper}(`, ")"] : [`#${helper}( '`, `' )`]
        }
      ];
      return this.addToTextcompleteConfig(configList, textcompleteConfig);
    }
    return textcompleteConfig;
  }
  getLastExecutionByPipelineConfig(pipelineConfig) {
    if (this.executionCache[pipelineConfig.id]) {
      return this.$q.when(this.executionCache[pipelineConfig.id]);
    } else {
      return this.executionService.getLastExecutionForApplicationByConfigId(pipelineConfig.application, pipelineConfig.id).then((execution) => {
        if (execution) {
          this.executionCache[pipelineConfig.id] = execution;
          return execution;
        } else {
          return null;
        }
      });
    }
  }
  buildTextCompleteConfig(pipeline) {
    return this.addStageNamesToCodeHelperList(pipeline, this.addStageDataForAutocomplete(pipeline, this.addManualJudgementConfigForAutocomplete(pipeline, this.addTriggerConfigForAutocomplete(pipeline, this.addParameterConfigForAutocomplete(pipeline, this.addHelperFunctionsBasedOnStages(pipeline, this.addExecutionForAutocomplete(pipeline, this.addDeployedServerGroupsForAutoComplete(pipeline, this.textcompleteConfig.slice(0)))))))));
  }
  addPipelineInfo(pipelineConfig) {
    if (pipelineConfig && pipelineConfig.id) {
      return this.getLastExecutionByPipelineConfig(pipelineConfig).then((lastExecution) => lastExecution || pipelineConfig).then((pipeline) => this.buildTextCompleteConfig(pipeline));
    } else {
      return this.$q.when(this.textcompleteConfig);
    }
  }
}

const _ExecutionsTransformer = class {
  static addDeploymentTargets(execution) {
    const targets = [];
    execution.stages.forEach((stage) => {
      const stageConfig = Registry.pipeline.getStageConfig(stage);
      if (stageConfig && stageConfig.accountExtractor) {
        targets.push(...stageConfig.accountExtractor(stage));
      }
    });
    execution.deploymentTargets = uniq(targets).filter((a) => !!a).sort();
  }
  static siblingStageSorter(a, b) {
    if (!a.startTime && !b.startTime) {
      return 0;
    }
    if (!a.startTime) {
      return 1;
    }
    if (!b.startTime) {
      return -1;
    }
    return a.startTime - b.startTime;
  }
  static flattenStages(stages, stage) {
    const stageSummary = stage;
    if (stageSummary.groupStages) {
      stageSummary.groupStages.forEach((s) => this.flattenStages(stages, s));
      return stages;
    }
    if (stage.before && stage.before.length) {
      stage.before.sort((a, b) => this.siblingStageSorter(a, b));
      stage.before.forEach((beforeStage) => this.flattenStages(stages, beforeStage));
    }
    if (stage.masterStage) {
      stages.push(stage.masterStage);
    } else {
      stages.push(stage);
    }
    if (stage.after && stage.after.length) {
      stage.after.sort((a, b) => this.siblingStageSorter(a, b));
      stage.after.forEach((afterStage) => this.flattenStages(stages, afterStage));
    }
    return stages;
  }
  static flattenAndFilter(stage) {
    return this.flattenStages([], stage).filter((s) => s.isFailed || !this.hiddenStageTypes.includes(s.type) && s.initializationStage !== true);
  }
  static getCurrentStages(execution) {
    const currentStages = execution.stageSummaries.filter((stage) => stage.isRunning);
    if (!currentStages.length) {
      const enqueued = execution.stageSummaries.find((stage) => stage.hasNotStarted);
      if (enqueued) {
        currentStages.push(enqueued);
      }
    }
    return currentStages;
  }
  static setMasterStageStartTime(stages, stage) {
    const allStartTimes = stages.filter((child) => child.startTime).map((child) => child.startTime);
    if (allStartTimes.length) {
      stage.startTime = Math.min(...allStartTimes);
    }
  }
  static getCurrentStage(stages) {
    const lastStage = stages[stages.length - 1];
    const lastNotStartedStage = findLast(stages, (childStage) => childStage.hasNotStarted);
    const lastFailedStage = findLast(stages, (childStage) => childStage.isFailed);
    const lastRunningStage = findLast(stages, (childStage) => childStage.isRunning);
    const lastCanceledStage = findLast(stages, (childStage) => childStage.isCanceled);
    const lastStoppedStage = findLast(stages, (childStage) => childStage.isStopped);
    return lastRunningStage || lastFailedStage || lastStoppedStage || lastCanceledStage || lastNotStartedStage || lastStage;
  }
  static cleanupLockStages(stages) {
    const retainFirstOfType = (type, toRetain) => {
      let foundType = false;
      return toRetain.filter((s) => {
        if (s.type === type) {
          if (foundType) {
            return false;
          }
          foundType = true;
        }
        return true;
      });
    };
    return retainFirstOfType("releaseLock", retainFirstOfType("acquireLock", stages).reverse()).reverse();
  }
  static transformStage(stage) {
    const stages = this.cleanupLockStages(this.flattenAndFilter(stage));
    if (!stages.length) {
      return;
    }
    if (stage.masterStage) {
      this.setMasterStageStartTime(stages, stage);
      const currentStage = this.getCurrentStage(stages);
      stage.status = currentStage.status;
      if (!currentStage.endTime) {
        delete stage.endTime;
      }
      const lastEndingStage = maxBy(stages, "endTime");
      if (currentStage.endTime && lastEndingStage.endTime) {
        stage.endTime = Math.max(currentStage.endTime, lastEndingStage.endTime, stage.endTime);
      }
    }
    stage.stages = stages;
  }
  static cleanRequisiteStageRefIds(execution, stageMap) {
    const { stages } = execution;
    stages.forEach((stage) => {
      if (stage.context && stage.context.requisiteIds) {
        stage.context.requisiteIds = uniq(stage.context.requisiteIds);
      }
      stage.requisiteStageRefIds = uniq(stage.requisiteStageRefIds || []);
      stage.requisiteStageRefIds = stage.requisiteStageRefIds.filter((parentId) => !!stageMap[parentId]);
    });
  }
  static getStagesMappedByRefId(execution) {
    const map = {};
    execution.stages.forEach((s) => map[s.refId] = s);
    return map;
  }
  static applyPhasesAndLink(execution, stageMap) {
    const stages = execution.stages;
    let allPhasesResolved = true;
    stages.forEach((stage) => {
      let phaseResolvable = true;
      let phase = 0;
      if (stage.phase === void 0 && !stage.requisiteStageRefIds.length) {
        stage.phase = phase;
      } else {
        stage.requisiteStageRefIds.forEach((parentId) => {
          const parent = stageMap[parentId];
          if (!parent || parent.phase === void 0) {
            phaseResolvable = false;
          } else {
            phase = Math.max(phase, parent.phase);
          }
        });
        if (phaseResolvable) {
          stage.phase = phase + 1;
        } else {
          allPhasesResolved = false;
        }
      }
    });
    execution.stages = sortBy(stages, "phase", "refId");
    if (!allPhasesResolved) {
      this.applyPhasesAndLink(execution, stageMap);
    }
  }
  static addStageWidths(execution) {
    execution.stageWidth = 100 / execution.stageSummaries.length + "%";
  }
  static styleStage(stage, styleStage) {
    styleStage = styleStage || stage;
    const stageConfig = Registry.pipeline.getStageConfig(styleStage);
    if (stageConfig) {
      stage.labelComponent = stageConfig.executionLabelComponent || ExecutionBarLabel;
      stage.markerIcon = stageConfig.markerIcon || ExecutionMarkerIcon;
      stage.useCustomTooltip = !!stageConfig.useCustomTooltip;
      stage.extraLabelLines = stageConfig.extraLabelLines;
    }
  }
  static findNearestBuildInfo(execution) {
    if (has(execution, "trigger.buildInfo.number")) {
      return execution.trigger.buildInfo;
    }
    if (has(execution, "trigger.parentExecution")) {
      return this.findNearestBuildInfo(execution.trigger.parentExecution);
    }
    return null;
  }
  static addBuildInfo(execution) {
    execution.buildInfo = this.findNearestBuildInfo(execution);
    if (has(execution, "trigger.buildInfo.lastBuild.number")) {
      execution.buildInfo = execution.trigger.buildInfo.lastBuild;
    }
    const deployStage = execution.stages.find((stage) => stage.type === "deploy");
    const deploymentDetails = get(deployStage, "context.deploymentDetails") || get(execution, "context.deploymentDetails");
    if (deploymentDetails && deploymentDetails.length && deploymentDetails[0].jenkins) {
      const jenkins = deploymentDetails[0].jenkins;
      execution.buildInfo = {
        number: jenkins.number,
        url: deploymentDetails[0].buildInfoUrl || `${jenkins.host}job/${jenkins.name}/${jenkins.number}`
      };
    }
  }
  static transformStageSummary(summary, index) {
    summary.index = index;
    summary.stages = this.flattenAndFilter(summary);
    summary.stages.forEach((stage) => delete stage.stages);
    summary.masterStageIndex = summary.stages.includes(summary.masterStage) ? summary.stages.indexOf(summary.masterStage) : 0;
    this.filterStages(summary);
    this.setFirstActiveStage(summary);
    this.setSuspendedStageTypes(summary);
    this.transformStage(summary);
    this.styleStage(summary);
    OrchestratedItemTransformer.defineProperties(summary);
    if (summary.type === "group") {
      summary.groupStages.forEach((stage, i) => this.transformStageSummary(stage, i));
    }
  }
  static filterStages(summary) {
    const stageConfig = Registry.pipeline.getStageConfig(summary.masterStage);
    if (stageConfig && stageConfig.stageFilter) {
      summary.stages = summary.stages.filter((s) => stageConfig.stageFilter(s));
    }
  }
  static setSuspendedStageTypes(summary) {
    summary.suspendedStageTypes = new Set(summary.stages.filter(({ isSuspended }) => isSuspended).map(({ type }) => type));
  }
  static setFirstActiveStage(summary) {
    summary.firstActiveStage = 0;
    const steps = summary.stages || [];
    if (steps.find((s) => s.isRunning)) {
      summary.firstActiveStage = steps.findIndex((s) => s.isRunning);
    }
    if (steps.find((s) => s.isFailed)) {
      summary.firstActiveStage = steps.findIndex((s) => s.isFailed);
    }
    if (steps.find((s) => s.isFailed && !!s.failureMessage)) {
      summary.firstActiveStage = steps.findIndex((s) => s.isFailed && !!s.failureMessage);
    }
  }
  static transformExecution(application, execution) {
    if (execution.trigger) {
      execution.isStrategy = execution.trigger.isPipeline === false && execution.trigger.type === "pipeline";
    }
    const stageRefIdsMap = this.getStagesMappedByRefId(execution);
    this.cleanRequisiteStageRefIds(execution, stageRefIdsMap);
    this.applyPhasesAndLink(execution, stageRefIdsMap);
    Registry.pipeline.getExecutionTransformers().forEach((transformer) => {
      transformer.transform(application, execution);
    });
    execution.context = execution.context || {};
    execution.stages.forEach((stage, index) => {
      stage.before = stage.before || [];
      stage.after = stage.after || [];
      stage.index = index;
      OrchestratedItemTransformer.defineProperties(stage);
      if (stage.tasks && stage.tasks.length) {
        stage.tasks.forEach((t) => OrchestratedItemTransformer.addRunningTime(t));
      }
    });
    execution.stages.forEach((stage) => {
      const parent = find(execution.stages, { id: stage.parentStageId });
      if (parent) {
        if (stage.syntheticStageOwner === "STAGE_BEFORE") {
          parent.before.push(stage);
        }
        if (stage.syntheticStageOwner === "STAGE_AFTER") {
          parent.after.push(stage);
        }
      }
      const context = stage.context || {};
      stage.cloudProvider = context.cloudProvider || context.cloudProviderType;
      if (context.alias) {
        stage.alias = context.alias;
      }
    });
    OrchestratedItemTransformer.defineProperties(execution);
    this.processStageSummaries(execution);
    execution.graphStatusHash = _ExecutionsTransformer.calculateGraphStatusHash(execution);
  }
  static calculateGraphStatusHash(execution) {
    return (execution.stageSummaries || []).map((stage) => {
      const stageConfig = Registry.pipeline.getStageConfig(stage);
      if (stageConfig && stageConfig.extraLabelLines) {
        return [stageConfig.extraLabelLines(stage), stage.status].join("-");
      }
      return stage.status;
    }).join(":");
  }
  static calculateRunningTime(stage) {
    return () => {
      stage.groupStages.forEach((subStage) => {
        if (subStage.startTime && subStage.startTime < stage.startTime) {
          stage.startTime = subStage.startTime;
        }
        if (subStage.endTime && subStage.endTime > stage.endTime) {
          stage.endTime = subStage.endTime;
        }
      });
      if (!stage.startTime) {
        return null;
      }
      const normalizedNow = Math.max(Date.now(), stage.startTime);
      return (stage.endTime || normalizedNow) - stage.startTime;
    };
  }
  static processStageSummaries(execution) {
    let stageSummaries = [];
    execution.stages.forEach((stage) => {
      if (!stage.syntheticStageOwner && !this.hiddenStageTypes.includes(stage.type)) {
        if (stage.status === "RUNNING" && stage.after.some((s) => s.status === "STOPPED")) {
          stage.status = "STOPPED";
        }
        const context = stage.context || {};
        const summary = {
          after: stage.after,
          before: stage.before,
          cloudProvider: stage.cloudProvider,
          comments: context.comments || null,
          endTime: stage.endTime,
          group: context.group,
          id: stage.id,
          index: void 0,
          graphRowOverride: context.graphRowOverride || 0,
          masterStage: stage,
          name: stage.name,
          refId: stage.refId,
          requisiteStageRefIds: stage.requisiteStageRefIds && stage.requisiteStageRefIds[0] === "*" ? [] : stage.requisiteStageRefIds || [],
          stages: [],
          startTime: stage.startTime,
          status: stage.status,
          type: stage.type
        };
        stageSummaries.push(summary);
      }
    });
    const idToGroupIdMap = {};
    stageSummaries = stageSummaries.reduce((groupedStages, stage) => {
      if (!stage.group) {
        groupedStages.push(stage);
        return groupedStages;
      }
      let groupedStage = groupedStages.find((s) => s.type === "group" && s.name === stage.group);
      if (!groupedStage) {
        groupedStage = {
          activeStageType: void 0,
          after: void 0,
          before: stage.before,
          cloudProvider: stage.cloudProvider,
          comments: "",
          endTime: stage.endTime,
          groupStages: [],
          id: stage.group,
          index: void 0,
          masterStage: void 0,
          name: stage.group,
          refId: stage.group,
          requisiteStageRefIds: stage.requisiteStageRefIds && stage.requisiteStageRefIds[0] === "*" ? [] : stage.requisiteStageRefIds || [],
          stages: [],
          startTime: stage.startTime,
          status: void 0,
          type: "group"
        };
        groupedStages.push(groupedStage);
      }
      OrchestratedItemTransformer.defineProperties(stage);
      Object.defineProperties(groupedStage, {
        runningTime: {
          get: () => duration(this.calculateRunningTime(groupedStage)()),
          configurable: true
        },
        runningTimeInMs: {
          get: this.calculateRunningTime(groupedStage),
          configurable: true
        }
      });
      idToGroupIdMap[stage.refId] = groupedStage.refId;
      groupedStage.groupStages.push(stage);
      return groupedStages;
    }, []);
    stageSummaries.forEach((summary, index) => {
      if (summary.type === "group" && !summary.groupStages) {
        summary.groupStages = [];
      }
      if (summary.type === "group") {
        if (summary.groupStages.length === 1) {
          const onlyStage = summary.groupStages[0];
          summary = onlyStage;
          stageSummaries[index] = onlyStage;
          delete idToGroupIdMap[onlyStage.refId];
        } else if (summary.groupStages.length > 1) {
          const subComments = [];
          summary.groupStages.forEach((subStage) => {
            if (subStage.comments) {
              subComments.push(subStage.comments);
            }
          });
          summary.after = summary.groupStages[summary.groupStages.length - 1].after;
          const currentStage = this.getCurrentStage(summary.groupStages);
          summary.activeStageType = currentStage.type;
          summary.status = currentStage.status;
          this.styleStage(summary, currentStage);
          summary.comments = subComments.join(", ");
        }
      }
      summary.requisiteStageRefIds = uniq(summary.requisiteStageRefIds.map((id) => idToGroupIdMap[id] || id));
    });
    stageSummaries.forEach((summary, index) => this.transformStageSummary(summary, index));
    execution.stageSummaries = stageSummaries;
    execution.currentStages = this.getCurrentStages(execution);
    this.addStageWidths(execution);
    this.addBuildInfo(execution);
    this.addDeploymentTargets(execution);
  }
};
let ExecutionsTransformer = _ExecutionsTransformer;
ExecutionsTransformer.hiddenStageTypes = [
  "initialization",
  "pipelineInitialization",
  "waitForRequisiteCompletion",
  "determineTargetServerGroup"
];

class SelfClearingLocalStorage {
  constructor(cacheProxy) {
    this.cacheProxy = cacheProxy;
  }
  setItem(k, v) {
    try {
      if (k.includes(SETTINGS.gateUrl)) {
        const response = JSON.parse(v);
        if (response.value && Array.isArray(response.value) && response.value.length > 2 && response.value[2]["content-type"]) {
          const val = response.value[2]["content-type"];
          if (val && !val.includes("application/json")) {
            return;
          }
        }
      }
      window.localStorage.setItem(k, v);
      this.cacheProxy[k] = v;
    } catch (e) {
      const Console = console;
      Console.warn("Local Storage Error! Clearing caches and trying again.\nException:", e);
      this.cacheProxy = Object.create(null);
      window.localStorage.clear();
      window.localStorage.setItem(k, v);
    }
  }
  getItem(k) {
    let result;
    if (this.cacheProxy[k] !== void 0) {
      result = this.cacheProxy[k];
    } else {
      result = window.localStorage.getItem(k);
    }
    return result;
  }
  removeItem(k) {
    delete this.cacheProxy[k];
    window.localStorage.removeItem(k);
  }
}
const _DeckCacheFactory = class {
  static getStoragePrefix(key, version) {
    return `angular-cache.caches.${key}:${version}.`;
  }
  static buildCacheKey(namespace, cacheId) {
    let result;
    if (!namespace || !cacheId) {
      result = namespace || cacheId;
    } else {
      result = `${namespace}:${cacheId}`;
    }
    return result;
  }
  static bombCorruptedCache(namespace, cacheId, currentVersion) {
    const basekey = _DeckCacheFactory.buildCacheKey(namespace, cacheId);
    const indexKey = `${_DeckCacheFactory.getStoragePrefix(basekey, currentVersion)}${basekey}`;
    if (!window.localStorage[`${indexKey}.keys`] || window.localStorage[`${indexKey}.keys`] === "[]") {
      Object.keys(window.localStorage).filter((key) => key.includes(indexKey)).forEach((key) => window.localStorage.removeItem(key));
    }
  }
  static clearPreviousVersions(namespace, cacheId, currentVersion, cacheFactory) {
    if (currentVersion) {
      _DeckCacheFactory.bombCorruptedCache(namespace, cacheId, currentVersion);
      for (let i = 0; i < currentVersion; i++) {
        const key = _DeckCacheFactory.buildCacheKey(namespace, cacheId);
        if (cacheFactory.exists(key)) {
          cacheFactory.get(key).destroy();
        }
        cacheFactory.createCache(key, {
          storageMode: "localStorage",
          storagePrefix: _DeckCacheFactory.getStoragePrefix(key, i)
        });
        cacheFactory.get(key).removeAll();
        cacheFactory.get(key).destroy();
      }
    }
  }
  static getStats(cache) {
    const keys = cache.keys();
    let ageMin = Date.now();
    let ageMax = 0;
    keys.forEach((key) => {
      const info = cache.info(key) || {};
      ageMin = Math.min(ageMin, info.created);
      ageMax = Math.max(ageMax, info.created);
    });
    return {
      ageMax: ageMax || null,
      ageMin: ageMin || null,
      keys: keys.length
    };
  }
  static createCache(namespace, cacheId, cacheConfig) {
    var _a;
    const key = _DeckCacheFactory.buildCacheKey(namespace, cacheId);
    const cacheFactory = cacheConfig.cacheFactory || this.cacheFactory;
    const currentVersion = cacheConfig.version || 1;
    _DeckCacheFactory.clearPreviousVersions(namespace, cacheId, currentVersion, cacheFactory);
    const storageMode = (_a = cacheConfig.storageMode) != null ? _a : "localStorage";
    cacheFactory.createCache(key, {
      deleteOnExpire: "aggressive",
      maxAge: cacheConfig.maxAge || Duration.fromObject({ days: 2 }).as("milliseconds"),
      recycleFreq: Duration.fromObject({ seconds: 5 }).as("milliseconds"),
      storageMode,
      storageImpl: storageMode === "localStorage" ? new SelfClearingLocalStorage(this.cacheProxy) : null,
      storagePrefix: _DeckCacheFactory.getStoragePrefix(key, currentVersion)
    });
    const cache = cacheFactory.get(key);
    this.caches[key] = cache;
    cache.getStats = _DeckCacheFactory.getStats.bind(null, this.caches[key]);
    cache.config = cacheConfig;
    return cache;
  }
  static clearCache(namespace, key) {
    if (this.caches[key] && this.caches[key].destroy) {
      this.caches[key].destroy();
      this.createCache(namespace, key, this.caches[key].config);
    }
  }
  static getCache(namespace = null, cacheId = null) {
    return this.caches[_DeckCacheFactory.buildCacheKey(namespace, cacheId)];
  }
};
let DeckCacheFactory = _DeckCacheFactory;
DeckCacheFactory.cacheFactory = new CacheFactory();
DeckCacheFactory.caches = Object.create(null);
DeckCacheFactory.cacheProxy = Object.create(null);

class AbstractBaseCache {
  constructor() {
    this.caches = Object.create(null);
  }
  createCache(key, config) {
    DeckCacheFactory.createCache(this.getNamespace(), key, config);
    this.caches[key] = DeckCacheFactory.getCache(this.getNamespace(), key);
    return this.caches[key];
  }
  get(key) {
    return this.caches[key];
  }
  clearCaches() {
    Object.keys(this.caches).forEach((k) => this.clearCache(k));
  }
  destroyCaches() {
    this.caches = Object.create(null);
  }
}

const _ViewStateCacheInternal = class extends AbstractBaseCache {
  getNamespace() {
    return _ViewStateCacheInternal.NAMESPACE;
  }
  clearCache(key) {
    const item = this.caches[key];
    if (item && item.destroy) {
      item.destroy();
      this.createCache(key, item.config);
    }
  }
};
let ViewStateCacheInternal = _ViewStateCacheInternal;
ViewStateCacheInternal.NAMESPACE = "viewStateCache";
const ViewStateCache = new ViewStateCacheInternal();

const _PipelineJSONService = class {
  static removeImmutableFields(pipeline) {
    _PipelineJSONService.immutableFields.forEach((k) => delete pipeline[k]);
  }
  static clone(pipeline) {
    const copy = cloneDeepWith(pipeline, (value) => {
      if (value && value.$$hashKey) {
        delete value.$$hashKey;
      }
      return void 0;
    });
    _PipelineJSONService.removeImmutableFields(copy);
    return copy;
  }
};
let PipelineJSONService = _PipelineJSONService;
PipelineJSONService.immutableFields = new Set(["name", "application", "index", "id", "$$hashKey"]);

var InheritedItem;
(function(InheritedItem2) {
  InheritedItem2["Triggers"] = "triggers";
  InheritedItem2["Notifications"] = "notifications";
  InheritedItem2["ParameterConfig"] = "parameterConfig";
  InheritedItem2["ExpectedArtifacts"] = "expectedArtifacts";
})(InheritedItem || (InheritedItem = {}));
const _PipelineTemplateV2Service = class {
  static createPipelineTemplate(pipeline, owner) {
    return {
      id: UUIDGenerator.generateUuid(),
      metadata: {
        description: `A pipeline template derived from pipeline "${pipeline.name}" in application "${pipeline.application}"`,
        name: hri.random(),
        owner,
        scopes: ["global"]
      },
      pipeline: PipelineJSONService.clone(pipeline),
      protect: false,
      schema: _PipelineTemplateV2Service.schema,
      variables: []
    };
  }
  static isV2PipelineConfig(pipelineConfig) {
    return pipelineConfig.schema === _PipelineTemplateV2Service.schema;
  }
  static idForTemplate(template) {
    const { id, digest = "" } = template;
    return `${id}:${digest}`;
  }
  static getTemplateVersion({ digest, tag, id }) {
    if (digest) {
      return `${id}@sha256:${digest}`;
    } else if (tag) {
      return `${id}:${tag}`;
    } else {
      return id;
    }
  }
  static convertTemplateVersionToId(templateVersion) {
    const versionSplitOnDigest = templateVersion.split("@");
    return versionSplitOnDigest.length > 1 ? versionSplitOnDigest[0] : versionSplitOnDigest[0].split(":")[0];
  }
  static getPipelineTemplateConfigV2(source) {
    return {
      schema: _PipelineTemplateV2Service.schema,
      template: {
        artifactAccount: "front50ArtifactCredentials",
        reference: this.prefixSource(source),
        type: "front50/pipelineTemplate"
      },
      type: "templatedPipeline"
    };
  }
  static prefixSource(source = "") {
    const referencePrefix = "spinnaker://";
    return source.startsWith(referencePrefix) ? source : `${referencePrefix}${source}`;
  }
  static filterInheritedConfig(pipelineConfig) {
    _PipelineTemplateV2Service.inheritedKeys.forEach((key) => {
      if (Array.isArray(pipelineConfig[key])) {
        const configCollection = pipelineConfig[key];
        pipelineConfig[key] = configCollection.filter((item) => !item.inherited);
      }
    });
    return pipelineConfig;
  }
};
let PipelineTemplateV2Service = _PipelineTemplateV2Service;
PipelineTemplateV2Service.schema = "v2";
PipelineTemplateV2Service.inheritedKeys = new Set([
  InheritedItem.Triggers,
  InheritedItem.Notifications,
  InheritedItem.ParameterConfig,
  InheritedItem.ExpectedArtifacts
]);

const _PipelineConfigService = class {
  static buildViewStateCacheKey(applicationName, pipelineName) {
    return `${applicationName}:${pipelineName}`;
  }
  static getPipelinesForApplication(applicationName) {
    return REST("/applications").path(applicationName, "pipelineConfigs").get().then((pipelines) => {
      pipelines.forEach((p) => p.stages = p.stages || []);
      return this.sortPipelines(pipelines);
    });
  }
  static getStrategiesForApplication(applicationName) {
    return REST("/applications").path(applicationName, "strategyConfigs").get().then((pipelines) => {
      pipelines.forEach((p) => p.stages = p.stages || []);
      return this.sortPipelines(pipelines);
    });
  }
  static getHistory(id, isStrategy, count = 20) {
    const endpoint = isStrategy ? "strategyConfigs" : "pipelineConfigs";
    return REST(endpoint).path(id, "history").query({ limit: count }).get();
  }
  static deletePipeline(applicationName, pipeline, pipelineName) {
    const endpoint = pipeline.strategy ? "strategies" : "pipelines";
    return REST(endpoint).path(applicationName, pipelineName.trim()).delete();
  }
  static savePipeline(toSave) {
    let pipeline = cloneDeep(toSave);
    delete pipeline.isNew;
    pipeline.name = pipeline.name.trim();
    if (Array.isArray(pipeline.stages)) {
      pipeline.stages.forEach(function(stage) {
        delete stage.isNew;
        if (!stage.name) {
          delete stage.name;
        }
      });
    }
    if (PipelineTemplateV2Service.isV2PipelineConfig(pipeline)) {
      pipeline = PipelineTemplateV2Service.filterInheritedConfig(pipeline);
    }
    const endpoint = pipeline.strategy ? "strategies" : "pipelines";
    return REST(endpoint).query({ staleCheck: true }).post(pipeline);
  }
  static reorderPipelines(application, idsToIndices, isStrategy = false) {
    const type = isStrategy ? "strategies" : "pipelines";
    return REST("/actions").path(type, "reorder").post({
      application,
      idsToIndices
    });
  }
  static renamePipeline(applicationName, pipeline, currentName, newName) {
    this.configViewStateCache.remove(this.buildViewStateCacheKey(applicationName, currentName));
    pipeline.name = newName.trim();
    const endpoint = pipeline.strategy ? "strategies" : "pipelines";
    return REST(endpoint).path(pipeline.id).put(pipeline);
  }
  static triggerPipeline(applicationName, pipelineName, body = {}) {
    body.user = AuthenticationService.getAuthenticatedUser().name;
    return REST("/pipelines/v2").path(applicationName, pipelineName).post(body).then((result) => {
      return result.ref.split("/").pop();
    });
  }
  static getDownstreamStageIds(map, stage) {
    if (!map || !stage) {
      return [];
    }
    let downstreamStages = [];
    const children = map.get(stage);
    if (children && children.length) {
      downstreamStages = downstreamStages.concat(children);
      children.forEach((child) => {
        downstreamStages = downstreamStages.concat(_PipelineConfigService.getDownstreamStageIds(map, child));
      });
    }
    return uniq(downstreamStages);
  }
  static getDependencyCandidateStages(pipeline, stage) {
    const grouped = _PipelineConfigService.groupStagesByRequisiteStageRefIds(pipeline);
    const downstreamIds = _PipelineConfigService.getDownstreamStageIds(grouped, stage.refId);
    return pipeline.stages.filter((stageToTest) => {
      return stage !== stageToTest && stageToTest.requisiteStageRefIds && !downstreamIds.includes(stageToTest.refId) && stage.requisiteStageRefIds && !stage.requisiteStageRefIds.includes(stageToTest.refId);
    });
  }
  static groupStagesByRequisiteStageRefIds(pipeline) {
    return pipeline.stages.reduce((acc, obj) => {
      const parent = obj["refId"];
      if (obj["requisiteStageRefIds"] === void 0) {
        obj["requisiteStageRefIds"] = [];
      }
      obj.requisiteStageRefIds.forEach((child) => {
        const values = acc.get(child);
        if (values && values.length) {
          values.push(parent);
        } else {
          acc.set(child, [parent]);
        }
      });
      return acc;
    }, new Map());
  }
  static getAllUpstreamDependencies(pipeline, stage) {
    if (!pipeline || !stage) {
      return [];
    }
    let upstreamStages = [];
    if (stage.requisiteStageRefIds && stage.requisiteStageRefIds.length) {
      pipeline.stages.forEach((stageToTest) => {
        if (stage.requisiteStageRefIds.includes(stageToTest.refId)) {
          upstreamStages.push(stageToTest);
          upstreamStages = upstreamStages.concat(this.getAllUpstreamDependencies(pipeline, stageToTest));
        }
      });
    }
    return uniq(upstreamStages);
  }
  static sortPipelines(pipelines) {
    const sorted = sortBy(pipelines, ["index", "name"]);
    const toReindex = [];
    if (sorted && sorted.length) {
      sorted.forEach((pipeline, index) => {
        if (pipeline.index !== index) {
          pipeline.index = index;
          toReindex.push(this.savePipeline(pipeline));
        }
      });
      if (toReindex.length) {
        return $q.all(toReindex).then(() => sorted);
      }
    }
    return $q.resolve(sorted);
  }
};
let PipelineConfigService = _PipelineConfigService;
PipelineConfigService.configViewStateCache = ViewStateCache.createCache("pipelineConfig", { version: 2 });

class FilterModelService {
  static configureFilterModel(filterModel, filterModelConfig) {
    filterModelConfig.forEach((property) => property.param = property.param || property.model);
    filterModel.config = filterModelConfig;
    filterModel.groups = [];
    filterModel.tags = [];
    filterModel.displayOptions = {};
    filterModel.sortFilter = FilterModelService.mapRouterParamsToSortFilter(filterModel, {});
    filterModel.addTags = () => {
      filterModel.tags = [];
      filterModelConfig.filter((property) => !property.displayOption).forEach((property) => this.addTagsForSection(filterModel, property));
    };
    filterModel.clearFilters = () => {
      filterModelConfig.forEach(function(property) {
        if (!property.displayOption) {
          filterModel.sortFilter[property.model] = property.clearValue;
        }
      });
    };
    filterModel.activate = () => {
    };
    filterModel.applyParamsToUrl = () => {
      const toParams = FilterModelService.mapSortFilterToRouterParams(filterModel);
      ReactInjector.$state.go(".", toParams, { location: "replace" });
    };
    return filterModel;
  }
  static mapSortFilterToRouterParams(filterModel) {
    const { sortFilter, config } = filterModel;
    return config.reduce((acc, filter) => ({ ...acc, [filter.param]: sortFilter[filter.model] }), {});
  }
  static mapRouterParamsToSortFilter(filterModel, params) {
    const filterTypeDefaults = {
      trueKeyObject: {},
      string: "",
      boolean: false,
      "inverse-boolean": true
    };
    const iFilterConfigs = filterModel.config;
    return iFilterConfigs.reduce((acc, filter) => {
      const valueIfNil = filterTypeDefaults[filter.type];
      const rawValue = params[filter.param];
      const paramValue = isNil(rawValue) ? valueIfNil : rawValue;
      return { ...acc, [filter.model]: cloneDeep(paramValue) };
    }, {});
  }
  static registerRouterHooks(filterModel, stateGlob) {
    const { transitionService } = ReactInjector.$uiRouter;
    const filterParams = filterModel.config.map((cfg) => cfg.param);
    let savedParamsForScreen = {};
    transitionService.onSuccess({ exiting: stateGlob, retained: "**.application" }, (trans) => {
      const fromParams = trans.params("from");
      savedParamsForScreen = pick(fromParams, filterParams);
    });
    transitionService.onBefore({ entering: stateGlob, retained: "**.application" }, (trans) => {
      const toParams = trans.params();
      const hasFilters = filterParams.some((key) => !isNil(toParams[key]));
      const savedParams = savedParamsForScreen;
      const hasSavedFilters = filterParams.some((key) => !isNil(savedParams[key]));
      const shouldRedirectWithSavedParams = !hasFilters && hasSavedFilters;
      return shouldRedirectWithSavedParams ? trans.targetState().withParams(savedParams) : null;
    });
    transitionService.onStart({ exiting: "**.application" }, () => {
      savedParamsForScreen = {};
    });
    transitionService.onBefore({ to: stateGlob }, (trans) => {
      const toParams = trans.params();
      Object.assign(filterModel.sortFilter, FilterModelService.mapRouterParamsToSortFilter(filterModel, toParams));
    });
  }
  static isFilterable(sortFilterModel) {
    return size(sortFilterModel) > 0 && some(sortFilterModel);
  }
  static getCheckValues(sortFilterModel) {
    return reduce(sortFilterModel, function(acc, val, key) {
      if (val) {
        acc.push(key);
      }
      return acc;
    }, []).sort();
  }
  static checkAccountFilters(model) {
    return (target) => {
      if (this.isFilterable(model.sortFilter.account)) {
        const checkedAccounts = this.getCheckValues(model.sortFilter.account);
        return includes(checkedAccounts, target.account);
      } else {
        return true;
      }
    };
  }
  static checkRegionFilters(model) {
    return (target) => {
      if (this.isFilterable(model.sortFilter.region)) {
        const checkedRegions = this.getCheckValues(model.sortFilter.region);
        return includes(checkedRegions, target.region);
      } else {
        return true;
      }
    };
  }
  static checkStackFilters(model) {
    return (target) => {
      if (this.isFilterable(model.sortFilter.stack)) {
        const checkedStacks = this.getCheckValues(model.sortFilter.stack);
        if (checkedStacks.includes("(none)")) {
          checkedStacks.push("");
          checkedStacks.push(null);
          checkedStacks.push(void 0);
        }
        return includes(checkedStacks, target.stack);
      } else {
        return true;
      }
    };
  }
  static checkDetailFilters(model) {
    return (target) => {
      if (this.isFilterable(model.sortFilter.detail)) {
        const checkedDetails = this.getCheckValues(model.sortFilter.detail);
        if (checkedDetails.includes("(none)")) {
          checkedDetails.push("");
          checkedDetails.push(null);
          checkedDetails.push(void 0);
        }
        return includes(checkedDetails, target.detail);
      } else {
        return true;
      }
    };
  }
  static checkStatusFilters(model) {
    return (target) => {
      if (this.isFilterable(model.sortFilter.status)) {
        const checkedStatus = this.getCheckValues(model.sortFilter.status);
        return includes(checkedStatus, "Up") && target.instanceCounts.down === 0 || includes(checkedStatus, "Down") && target.instanceCounts.down > 0 || includes(checkedStatus, "OutOfService") && target.instanceCounts.outOfService > 0 || includes(checkedStatus, "Starting") && target.instanceCounts.starting > 0 || includes(checkedStatus, "Disabled") && target.isDisabled || includes(checkedStatus, "Unknown") && target.instanceCounts.unknown > 0;
      }
      return true;
    };
  }
  static checkProviderFilters(model) {
    return (target) => {
      if (this.isFilterable(model.sortFilter.providerType)) {
        const checkedProviderTypes = this.getCheckValues(model.sortFilter.providerType);
        return includes(checkedProviderTypes, target.type) || includes(checkedProviderTypes, target.provider);
      } else {
        return true;
      }
    };
  }
  static addTagsForSection(model, property) {
    const key = property.model;
    const label = property.filterLabel || property.model;
    const translator = property.filterTranslator || {};
    const clearValue = property.clearValue;
    const tags = model.tags;
    const modelVal = model.sortFilter[key];
    if (property.type === "trueKeyObject") {
      forOwn(modelVal, (isActive, value) => {
        if (isActive) {
          tags.push({
            key,
            label,
            value: translator[value] || value,
            clear() {
              const toClearFrom = model.sortFilter[key];
              delete toClearFrom[value];
              model.applyParamsToUrl();
            }
          });
        }
      });
    } else {
      if (modelVal !== null && modelVal !== void 0 && modelVal !== "" && modelVal !== false) {
        tags.push({
          key,
          label,
          value: translator[modelVal] || modelVal,
          clear() {
            model.sortFilter[key] = clearValue;
            model.applyParamsToUrl();
          }
        });
      }
    }
    return tags;
  }
}

const FilterCheckbox$1 = (props) => {
  const { heading, isCloudProvider, name, onChange, onChangeEvent, sortFilterType } = props;
  const changeHandler = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    sortFilterType[heading] = Boolean(value);
    onChange();
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
    type: "checkbox",
    checked: Boolean(sortFilterType && sortFilterType[heading]),
    onChange: onChangeEvent || changeHandler,
    name
  }), !isCloudProvider ? heading : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(CloudProviderLogo, {
    provider: "heading",
    height: "'14px'",
    width: "'14px'"
  }), /* @__PURE__ */ React__default.createElement(CloudProviderLabel, {
    provider: heading
  }))));
};

var css_248z$26 = ".filters-toggle {\n  position: absolute;\n}\n.filters-toggle .filters-hidden {\n  margin-top: 11px;\n}\n.filters-toggle .filters-open {\n  background-color: var(--color-accent-g2);\n  height: 32px;\n  font-size: 16px;\n  margin-top: 6px;\n}\n@media (min-width: 768px) and (max-width: 992px) {\n  .filters-toggle .filters-open {\n    width: 104px;\n  }\n}\n@media (min-width: 992px) {\n  .filters-toggle .filters-open {\n    width: 124px;\n  }\n}\n@media (min-width: 1200px) {\n  .filters-toggle .filters-open {\n    width: 154px;\n  }\n}\n@media (min-width: 1400px) {\n  .filters-toggle .filters-open {\n    width: 184px;\n  }\n}\n@media (min-width: 1600px) {\n  .filters-toggle .filters-open {\n    width: 214px;\n  }\n}\n@media (min-width: 1800px) {\n  .filters-toggle .filters-open {\n    width: 224px;\n  }\n}\n@media (min-width: 2000px) {\n  .filters-toggle .filters-open {\n    width: 254px;\n  }\n}\n.filters-toggle button {\n  height: 22px;\n  line-height: 12px;\n}\n.filters-toggle .show-filter-text {\n  border-left: 1px solid var(--color-accessory-light);\n}\n";
styleInject(css_248z$26);

class FilterCollapse extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onClick = (pin) => {
      ReactInjector.insightFilterStateModel.pinFilters(pin);
      $rootScope.$apply();
      this.setState({});
    };
  }
  render() {
    const { filtersExpanded } = ReactInjector.insightFilterStateModel;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "filters-toggle layer-medium"
    }, !filtersExpanded && /* @__PURE__ */ React__default.createElement("div", {
      className: "filters-placeholder filters-hidden"
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Show filters"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-xs btn-default pin clickable sp-padding-xs",
      onClick: () => this.onClick(true),
      style: { display: filtersExpanded ? "none" : "inherit" }
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-forward"
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "show-filter-text"
    }, " Show filters")))), filtersExpanded && /* @__PURE__ */ React__default.createElement("div", {
      className: "filters-placeholder filters-open horizontal middle"
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Hide filters"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-xs btn-default unpin clickable sp-margin-s-xaxis sp-margin-2xs-yaxis sp-padding-xs",
      onClick: () => this.onClick(false),
      style: { display: filtersExpanded ? "inherit" : "none" }
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-backward"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal center flex-1 sp-margin-xl-right"
    }, "Filters")));
  }
}

const INFRASTRUCTURE_CACHE_CONFIG = {
  securityGroups: {
    version: 4,
    storageMode: "memory"
  },
  healthChecks: {
    version: 2
  },
  certificates: {
    version: 2
  },
  backendServices: {
    version: 2
  },
  addresses: {
    version: 2
  }
};

const _InfrastructureCachesInternal = class extends AbstractBaseCache {
  getNamespace() {
    return _InfrastructureCachesInternal.NAMESPACE;
  }
  clearCache(key) {
    const item = this.caches[key];
    if (item && item.removeAll) {
      item.keys() && item.keys().forEach((k) => item.remove(k));
      item.onReset && item.onReset.forEach((method) => method());
    }
  }
  createCache(key, config) {
    const cache = super.createCache(key, config);
    cache.onReset = config.onReset;
    return cache;
  }
};
let InfrastructureCachesInternal = _InfrastructureCachesInternal;
InfrastructureCachesInternal.NAMESPACE = "infrastructure";
const InfrastructureCaches = new InfrastructureCachesInternal();

class EntityTagsReader {
  static getAllEntityTagsForApplication(application) {
    return REST("/tags").query({ maxResults: SETTINGS.entityTags.maxResults || 5e3, application }).get().then((allTags) => this.flattenTagsAndAddMetadata(allTags));
  }
  static addTagsToServerGroups(application) {
    if (!SETTINGS.feature.entityTags) {
      return;
    }
    const allTags = application.entityTags.data;
    const serverGroupTags = allTags.filter(({ entityRef }) => entityRef.entityType === "servergroup");
    const clusterTags = allTags.filter(({ entityRef }) => entityRef.entityType === "cluster");
    const serverGroups = application.serverGroups.data;
    serverGroups.forEach((serverGroup) => {
      serverGroup.entityTags = serverGroupTags.find(({ entityRef }) => entityRef.entityId === serverGroup.name && entityRef.account === serverGroup.account && entityRef.region === serverGroup.region);
      serverGroup.clusterEntityTags = clusterTags.filter(({ entityRef }) => entityRef.entityId === serverGroup.cluster && (entityRef.account === "*" || entityRef.account === serverGroup.account) && (entityRef.region === "*" || entityRef.region === serverGroup.region));
    });
  }
  static addTagsToServerGroupManagers(application) {
    if (!SETTINGS.feature.entityTags) {
      return;
    }
    const allTags = application.entityTags.data;
    const serverGroupManagerTags = allTags.filter(({ entityRef }) => entityRef.entityType === "servergroupmanager");
    const serverGroupManagers = application.serverGroupManagers.data;
    serverGroupManagers.forEach((serverGroupManager) => {
      serverGroupManager.entityTags = serverGroupManagerTags.find(({ entityRef }) => entityRef.entityId === serverGroupManager.name && entityRef.account === serverGroupManager.account && entityRef.region === serverGroupManager.region);
    });
  }
  static addTagsToLoadBalancers(application) {
    if (!SETTINGS.feature.entityTags) {
      return;
    }
    const allTags = application.entityTags.data;
    const loadBalancerTags = allTags.filter(({ entityRef }) => entityRef.entityType === "loadbalancer");
    const loadBalancers = application.loadBalancers.data;
    loadBalancers.forEach((loadBalancer) => {
      loadBalancer.entityTags = loadBalancerTags.find(({ entityRef }) => entityRef.entityId === loadBalancer.name && entityRef.account === loadBalancer.account && entityRef.region === loadBalancer.region);
    });
  }
  static addTagsToFunctions(application) {
    if (!SETTINGS.feature.entityTags || !SETTINGS.feature.functions) {
      return;
    }
    const allTags = application.entityTags.data;
    const functionTags = allTags.filter(({ entityRef }) => entityRef.entityType === "function");
    const functions = application.functions.data;
    functions.forEach((fn) => {
      fn.entityTags = functionTags.find(({ entityRef }) => entityRef.entityId === fn.functionName && entityRef.account === fn.account && entityRef.region === fn.region);
    });
  }
  static addTagsToSecurityGroups(application) {
    if (!SETTINGS.feature.entityTags) {
      return;
    }
    const allTags = application.entityTags.data;
    const securityGroupTags = allTags.filter(({ entityRef }) => entityRef.entityType === "securitygroup");
    const securityGroups = application.securityGroups.data;
    securityGroups.forEach((securityGroup) => {
      securityGroup.entityTags = securityGroupTags.find(({ entityRef }) => entityRef.entityId === securityGroup.name && entityRef.account === securityGroup.account && entityRef.region === securityGroup.region);
    });
  }
  static addTagsToExecutions(application) {
    if (!SETTINGS.feature.entityTags) {
      return;
    }
    const allTags = application.entityTags.data;
    const executionTags = allTags.filter(({ entityRef }) => entityRef.entityType === "execution");
    const executions = application.executions.data;
    executions.forEach((execution) => {
      execution.entityTags = executionTags.find(({ entityRef }) => entityRef.entityId === execution.id);
    });
  }
  static addTagsToPipelines(application) {
    if (!SETTINGS.feature.entityTags) {
      return;
    }
    const allTags = application.entityTags.data;
    const pipelineTags = allTags.filter(({ entityRef }) => entityRef.entityType === "pipeline");
    const pipelineConfigs = application.pipelineConfigs.data;
    pipelineConfigs.forEach((pipeline) => {
      pipeline.entityTags = pipelineTags.find(({ entityRef }) => entityRef.entityId === pipeline.id);
    });
  }
  static getEntityTagsForId(entityType, entityId) {
    if (!entityId) {
      return $q.when([]);
    }
    return REST("/tags").query({
      entityType: entityType.toLowerCase(),
      entityId
    }).get().then((entityTagGroups) => {
      return this.flattenTagsAndAddMetadata(entityTagGroups);
    }).catch(() => {
      return $q.when([]);
    });
  }
  static flattenTagsAndAddMetadata(entityTags) {
    const allTags = [];
    entityTags.forEach((entityTag) => {
      entityTag.tags.forEach((tag) => this.addTagMetadata(entityTag, tag));
      entityTag.alerts = entityTag.tags.filter((t) => t.name.startsWith("spinnaker_ui_alert:"));
      entityTag.notices = entityTag.tags.filter((t) => t.name.startsWith("spinnaker_ui_notice:"));
      entityTag.creationMetadata = entityTag.tags.find((t) => t.name === "spinnaker:metadata");
      allTags.push(entityTag);
    });
    return allTags;
  }
  static addTagMetadata(entityTag, tag) {
    const metadata = entityTag.tagsMetadata.find((m) => m.name === tag.name);
    if (metadata) {
      tag.created = metadata.created;
      tag.createdBy = metadata.createdBy;
      tag.lastModified = metadata.lastModified;
      tag.lastModifiedBy = metadata.lastModifiedBy;
    }
  }
}

const _NameUtils = class {
  static parseServerGroupName(serverGroupName) {
    const result = {
      application: "",
      stack: "",
      freeFormDetails: "",
      cluster: ""
    };
    if (!serverGroupName) {
      return result;
    }
    const split = serverGroupName.split("-");
    const isVersioned = _NameUtils.VERSION_PATTERN.test(split[split.length - 1]);
    result.application = split[0];
    if (isVersioned) {
      split.pop();
    }
    if (split.length > 1) {
      result.stack = split[1];
    }
    if (split.length > 2) {
      result.freeFormDetails = split.slice(2, split.length).join("-");
    }
    result.cluster = _NameUtils.getClusterNameFromServerGroupName(serverGroupName);
    return result;
  }
  static parseClusterName(clusterName) {
    return _NameUtils.parseServerGroupName(clusterName);
  }
  static getClusterName(app, stack, detail) {
    let clusterName = app;
    if (stack) {
      clusterName += `-${stack}`;
    }
    if (!stack && detail) {
      clusterName += `-`;
    }
    if (detail) {
      clusterName += `-${detail}`;
    }
    return clusterName;
  }
  static getClusterNameFromServerGroupName(serverGroupName) {
    const split = serverGroupName.split("-");
    const isVersioned = _NameUtils.VERSION_PATTERN.test(split[split.length - 1]);
    if (isVersioned) {
      split.pop();
    }
    return split.join("-");
  }
  static getSequence(monikerSequence) {
    if (isNil(monikerSequence)) {
      return null;
    } else {
      return `v${padStart(monikerSequence.toString(), 3, "0")}`;
    }
  }
  static parseLoadBalancerName(loadBalancerName) {
    const split = loadBalancerName.split("-");
    const result = {
      application: split[0],
      stack: "",
      freeFormDetails: "",
      cluster: ""
    };
    if (split.length > 1) {
      result.stack = split[1];
    }
    if (split.length > 2) {
      result.freeFormDetails = split.slice(2, split.length).join("-");
    }
    result.cluster = _NameUtils.getClusterName(result.application, result.stack, result.freeFormDetails);
    return result;
  }
  static parseSecurityGroupName(securityGroupName) {
    return _NameUtils.parseLoadBalancerName(securityGroupName);
  }
  static getMoniker(app, stack, detail) {
    return pickBy({ app, stack, detail });
  }
  static getMonikerForInstance(cloudProvider, instanceId, app) {
    return app.ready().then(() => {
      const serverGroups = app.getDataSource("serverGroups").data;
      const loadBalancers = app.getDataSource("loadBalancers").data;
      const loadBalancerServerGroups = loadBalancers.map((lb) => lb.serverGroups).reduce((acc, sg) => acc.concat(sg), []);
      const hasInstance = (obj) => {
        return obj.cloudProvider === cloudProvider && (obj.instances || []).some((instance) => instance.id === instanceId);
      };
      const all = [].concat(serverGroups).concat(loadBalancers).concat(loadBalancerServerGroups);
      const found = all.find(hasInstance);
      return found && found.moniker;
    });
  }
};
let NameUtils = _NameUtils;
NameUtils.VERSION_PATTERN = /(v\d{3})/;

const getFallbackResults = () => {
  return { results: [] };
};
class SearchService {
  static get DEFAULT_PAGE_SIZE() {
    return 500;
  }
  static search(searchParams, cache = null) {
    const defaultParams = {
      pageSize: SearchService.DEFAULT_PAGE_SIZE
    };
    const params = { ...searchParams, ...defaultParams };
    let requestBuilder = API.one("search").query(params);
    if (cache) {
      requestBuilder = requestBuilder.useCache(cache);
    }
    return requestBuilder.get().then((response) => {
      return response[0] || getFallbackResults();
    }).catch((response) => {
      $log.error(response.data, response);
      return getFallbackResults();
    });
  }
}

class SecurityGroupTransformerService {
  constructor(providerServiceDelegate) {
    this.providerServiceDelegate = providerServiceDelegate;
  }
  normalizeSecurityGroup(securityGroup) {
    return this.providerServiceDelegate.getDelegate(securityGroup.provider || securityGroup.type, "securityGroup.transformer").normalizeSecurityGroup(securityGroup);
  }
}
SecurityGroupTransformerService.$inject = ["providerServiceDelegate"];
const SECURITY_GROUP_TRANSFORMER_SERVICE = "spinnaker.core.securityGroup.transformer.service";
module(SECURITY_GROUP_TRANSFORMER_SERVICE, [PROVIDER_SERVICE_DELEGATE]).service("securityGroupTransformer", SecurityGroupTransformerService);

const _SecurityGroupReader = class {
  constructor($log, $q, securityGroupTransformer, providerServiceDelegate) {
    this.$log = $log;
    this.$q = $q;
    this.securityGroupTransformer = securityGroupTransformer;
    this.providerServiceDelegate = providerServiceDelegate;
  }
  static indexSecurityGroups(securityGroups) {
    const securityGroupIndex = {};
    securityGroups.forEach((securityGroup) => {
      const accountName = securityGroup.account;
      securityGroupIndex[accountName] = {};
      const accountIndex = securityGroupIndex[accountName];
      forOwn(securityGroup.securityGroups, (groups, region) => {
        const regionIndex = {};
        accountIndex[region] = regionIndex;
        groups.forEach((group) => {
          group.accountName = accountName;
          group.region = region;
          regionIndex[group.id] = group;
          regionIndex[group.name] = group;
        });
      });
    });
    return securityGroupIndex;
  }
  static attachUsageFields(securityGroup) {
    if (!securityGroup.usages) {
      securityGroup.usages = {
        loadBalancers: [],
        serverGroups: []
      };
    }
  }
  static sortUsages(securityGroup) {
    if (!securityGroup.usages) {
      return;
    }
    securityGroup.usages.serverGroups.sort((a, b) => b.name.localeCompare(a.name));
    securityGroup.usages.loadBalancers.sort((a, b) => b.name.localeCompare(a.name));
  }
  resolve(index, container, securityGroupId) {
    return this.providerServiceDelegate.getDelegate(container.provider || container.type || container.cloudProvider, "securityGroup.reader").resolveIndexedSecurityGroup(index, container, securityGroupId);
  }
  addLoadBalancerSecurityGroups(application) {
    let notFoundCaught = false;
    const securityGroups = [];
    application.getDataSource("loadBalancers").data.forEach((loadBalancer) => {
      if (loadBalancer.securityGroups) {
        loadBalancer.securityGroups.forEach((securityGroupId) => {
          try {
            const securityGroup = this.resolve(application["securityGroupsIndex"], loadBalancer, securityGroupId);
            _SecurityGroupReader.attachUsageFields(securityGroup);
            if (!securityGroup.usages.loadBalancers.some((lb) => lb.name === loadBalancer.name)) {
              securityGroup.usages.loadBalancers.push({ name: loadBalancer.name });
            }
            securityGroups.push(securityGroup);
          } catch (e) {
            this.$log.warn("could not attach firewall to load balancer:", loadBalancer.name, securityGroupId, e);
            notFoundCaught = true;
          }
        });
      }
    });
    securityGroups.forEach(_SecurityGroupReader.sortUsages);
    return { notFoundCaught, securityGroups };
  }
  addNameBasedSecurityGroups(application, nameBasedSecurityGroups) {
    let notFoundCaught = false;
    const securityGroups = [];
    nameBasedSecurityGroups.forEach((securityGroup) => {
      try {
        const match = this.resolve(application["securityGroupsIndex"], securityGroup, securityGroup.id);
        _SecurityGroupReader.attachUsageFields(match);
        securityGroups.push(match);
      } catch (e) {
        this.$log.warn("could not initialize application firewall:", securityGroup);
        notFoundCaught = true;
      }
    });
    return { notFoundCaught, securityGroups };
  }
  addServerGroupSecurityGroups(application) {
    let notFoundCaught = false;
    const sgSet = new Set();
    application.getDataSource("serverGroups").data.forEach((serverGroup) => {
      if (serverGroup.securityGroups) {
        serverGroup.securityGroups.forEach((securityGroupId) => {
          try {
            const securityGroup = this.resolve(application["securityGroupsIndex"], serverGroup, securityGroupId);
            _SecurityGroupReader.attachUsageFields(securityGroup);
            if (!securityGroup.usages.serverGroups.some((sg) => sg.name === serverGroup.name)) {
              const { account, isDisabled, name, cloudProvider, region } = serverGroup;
              securityGroup.usages.serverGroups.push({ account, isDisabled, name, cloudProvider, region });
            }
            sgSet.add(securityGroup);
          } catch (e) {
            this.$log.warn("could not attach firewall to server group:", serverGroup.name, securityGroupId);
            notFoundCaught = true;
          }
        });
      }
    });
    const securityGroups = Array.from(sgSet);
    securityGroups.forEach(_SecurityGroupReader.sortUsages);
    return { notFoundCaught, securityGroups };
  }
  clearCacheAndRetryAttachingSecurityGroups(application, nameBasedSecurityGroups) {
    InfrastructureCaches.clearCache("securityGroups");
    return this.loadSecurityGroups().then((refreshedSecurityGroups) => {
      application["securityGroupsIndex"] = refreshedSecurityGroups;
      return this.attachSecurityGroups(application, nameBasedSecurityGroups, false);
    });
  }
  addNamePartsToSecurityGroup(securityGroup) {
    const nameParts = NameUtils.parseSecurityGroupName(securityGroup.name);
    securityGroup.stack = nameParts.stack;
    securityGroup.detail = nameParts.freeFormDetails;
    securityGroup.moniker = NameUtils.getMoniker(nameParts.application, nameParts.stack, nameParts.freeFormDetails);
  }
  attachSecurityGroups(application, nameBasedSecurityGroups, retryIfNotFound) {
    let data = [];
    let notFoundCaught = false;
    if (nameBasedSecurityGroups) {
      application.getDataSource("securityGroups").data = [];
      const nameBasedGroups = this.addNameBasedSecurityGroups(application, nameBasedSecurityGroups);
      notFoundCaught = nameBasedGroups.notFoundCaught;
      if (!nameBasedGroups.notFoundCaught) {
        data = nameBasedGroups.securityGroups;
      }
    } else {
      data = application.getDataSource("securityGroups").data.filter((group) => !group.usages.serverGroups.length && !group.usages.loadBalancers.length);
    }
    if (!notFoundCaught) {
      const loadBalancerSecurityGroups = this.addLoadBalancerSecurityGroups(application);
      notFoundCaught = loadBalancerSecurityGroups.notFoundCaught;
      if (!notFoundCaught) {
        data = data.concat(loadBalancerSecurityGroups.securityGroups.filter((sg) => !data.includes(sg)));
        const serverGroupSecurityGroups = this.addServerGroupSecurityGroups(application);
        notFoundCaught = serverGroupSecurityGroups.notFoundCaught;
        if (!notFoundCaught) {
          data = data.concat(serverGroupSecurityGroups.securityGroups.filter((sg) => !data.includes(sg)));
        }
      }
    }
    data = uniq(data);
    if (notFoundCaught && retryIfNotFound) {
      this.$log.warn("Clearing firewall cache and trying again...");
      return this.clearCacheAndRetryAttachingSecurityGroups(application, nameBasedSecurityGroups);
    } else {
      data.forEach((sg) => this.addNamePartsToSecurityGroup(sg));
      return this.$q.all(data.map((sg) => this.securityGroupTransformer.normalizeSecurityGroup(sg))).then(() => data);
    }
  }
  getAllSecurityGroups() {
    const cache = InfrastructureCaches.get("securityGroups");
    const cached = cache ? cache.get("allGroups") : null;
    if (cached) {
      return this.$q.resolve(this.decompress(cloneDeep(cached)));
    } else if (this.getAllSecurityGroupsPromise) {
      return this.getAllSecurityGroupsPromise;
    }
    this.getAllSecurityGroupsPromise = REST("/securityGroups").get().then((groupsByAccount) => {
      if (cache) {
        cache.put("allGroups", this.compress(groupsByAccount));
      }
      return groupsByAccount;
    }).finally(() => {
      delete this.getAllSecurityGroupsPromise;
    });
    return this.getAllSecurityGroupsPromise;
  }
  compress(data) {
    const compressed = {};
    Object.keys(data).forEach((account) => {
      compressed[account] = {};
      Object.keys(data[account]).forEach((provider) => {
        compressed[account][provider] = {};
        Object.keys(data[account][provider]).forEach((region) => {
          data[account][provider][region].forEach((group) => delete group.moniker);
        });
        if (this.providerServiceDelegate.hasDelegate(provider, "securityGroup.transformer")) {
          const service = this.providerServiceDelegate.getDelegate(provider, "securityGroup.transformer");
          if (service.supportsCompression) {
            Object.keys(data[account][provider]).forEach((region) => {
              compressed[account][provider][region] = service.compress(data[account][provider][region]);
            });
          } else {
            compressed[account][provider] = data[account][provider];
          }
        } else {
          compressed[account][provider] = data[account][provider];
        }
      });
    });
    return compressed;
  }
  decompress(data) {
    Object.keys(data).forEach((account) => {
      Object.keys(data[account]).forEach((provider) => {
        if (this.providerServiceDelegate.hasDelegate(provider, "securityGroup.transformer")) {
          const service = this.providerServiceDelegate.getDelegate(provider, "securityGroup.transformer");
          if (service && service.supportsCompression) {
            Object.keys(data[account][provider]).forEach((region) => {
              data[account][provider][region] = service.decompress(data[account][provider][region]);
            });
          }
        }
      });
    });
    return data;
  }
  getApplicationSecurityGroup(application, account, region, id) {
    let result = null;
    if (has(application["securityGroupsIndex"], [account, region, id])) {
      result = application["securityGroupsIndex"][account][region][id];
    }
    return result;
  }
  getApplicationSecurityGroups(application, nameBasedSecurityGroups) {
    return this.loadSecurityGroups().then((allSecurityGroups) => {
      application["securityGroupsIndex"] = allSecurityGroups;
    }).then(() => this.$q.all([application.getDataSource("serverGroups").ready(), application.getDataSource("loadBalancers").ready()]).then(() => this.attachSecurityGroups(application, nameBasedSecurityGroups, true)));
  }
  getSecurityGroupDetails(application, account, provider, region, vpcId, id) {
    return REST("/securityGroups").path(account, region, id).query({ provider, vpcId }).get().then((details) => {
      if (details && details.inboundRules) {
        details.ipRangeRules = details.inboundRules.filter((rule) => rule.range);
        details.securityGroupRules = details.inboundRules.filter((rule) => rule.securityGroup);
        details.securityGroupRules.forEach((inboundRule) => {
          const inboundGroup = inboundRule.securityGroup;
          if (!inboundGroup.name) {
            const applicationSecurityGroup = this.getApplicationSecurityGroup(application, inboundGroup.accountName, details.region, inboundGroup.id);
            if (applicationSecurityGroup) {
              inboundGroup.name = applicationSecurityGroup.name;
            } else {
              inboundGroup.name = inboundGroup.id;
              inboundGroup.inferredName = true;
            }
          }
        });
      }
      if (SETTINGS.feature.entityTags && application.isStandalone) {
        return EntityTagsReader.getEntityTagsForId("securitygroup", details.name).then((tags) => {
          details.entityTags = tags.find((t) => t.entityRef.entityId === details.name && t.entityRef["account"] === account && t.entityRef["region"] === region);
          return details;
        });
      }
      return details;
    });
  }
  loadSecurityGroups() {
    return this.getAllSecurityGroups().then((groupsByAccount) => {
      const securityGroups = [];
      forOwn(groupsByAccount, (groupsByProvider, account) => {
        return forOwn(groupsByProvider, (groupsByRegion, provider) => {
          forOwn(groupsByRegion, (groups) => {
            groups.forEach((group) => {
              group.provider = provider;
              group.account = account;
            });
          });
          securityGroups.push({ account, provider, securityGroups: groupsByProvider[provider] });
        });
      });
      return _SecurityGroupReader.indexSecurityGroups(securityGroups);
    });
  }
  loadSecurityGroupsByApplicationName(applicationName) {
    return SearchService.search({
      q: applicationName,
      type: "securityGroups",
      pageSize: 1e3
    }).then((searchResults) => {
      let result = [];
      if (!searchResults || !searchResults.results) {
        this.$log.warn("WARNING: Gate firewall endpoint appears to be down.");
      } else {
        result = filter$1(searchResults.results, { application: applicationName });
      }
      return result;
    });
  }
};
let SecurityGroupReader = _SecurityGroupReader;
SecurityGroupReader.$inject = ["$log", "$q", "securityGroupTransformer", "providerServiceDelegate"];
const SECURITY_GROUP_READER = "spinnaker.core.securityGroup.read.service";
module(SECURITY_GROUP_READER, [SECURITY_GROUP_TRANSFORMER_SERVICE, PROVIDER_SERVICE_DELEGATE]).service("securityGroupReader", SecurityGroupReader);

class CacheInitializerService {
  constructor($q, securityGroupReader, providerServiceDelegate) {
    this.$q = $q;
    this.securityGroupReader = securityGroupReader;
    this.providerServiceDelegate = providerServiceDelegate;
    this.cacheConfig = cloneDeep(INFRASTRUCTURE_CACHE_CONFIG);
    this.initializers = {
      securityGroups: [() => this.securityGroupReader.getAllSecurityGroups()]
    };
  }
  setConfigDefaults(key, config) {
    config.version = config.version || 1;
    config.maxAge = config.maxAge || Duration.fromObject({ days: 2 }).as("milliseconds");
    config.initializers = config.initializers || this.initializers[key] || [];
    config.onReset = config.onReset || [noop$1];
  }
  extendConfig() {
    Object.keys(this.cacheConfig).forEach((key) => {
      this.setConfigDefaults(key, this.cacheConfig[key]);
    });
    return AccountService.listProviders().then((availableProviders) => {
      return CloudProviderRegistry.listRegisteredProviders().forEach((provider) => {
        if (!availableProviders.includes(provider)) {
          return;
        }
        if (this.providerServiceDelegate.hasDelegate(provider, "cache.configurer")) {
          const providerConfig = this.providerServiceDelegate.getDelegate(provider, "cache.configurer");
          Object.keys(providerConfig).forEach((key) => {
            this.setConfigDefaults(key, providerConfig[key]);
            if (!this.cacheConfig[key]) {
              this.cacheConfig[key] = providerConfig[key];
            }
            this.cacheConfig[key].initializers = uniq(this.cacheConfig[key].initializers.concat(providerConfig[key].initializers));
            this.cacheConfig[key].onReset = uniq(this.cacheConfig[key].onReset.concat(providerConfig[key].onReset));
            this.cacheConfig[key].version = Math.max(this.cacheConfig[key].version, providerConfig[key].version);
            this.cacheConfig[key].maxAge = Math.min(this.cacheConfig[key].maxAge, providerConfig[key].maxAge);
          });
        }
      });
    });
  }
  initializeCache(key) {
    InfrastructureCaches.createCache(key, this.cacheConfig[key]);
    if (this.cacheConfig[key].initializers) {
      const initializer = this.cacheConfig[key].initializers;
      const all = [];
      initializer.forEach((method) => {
        all.push(method());
      });
      return this.$q.all(all);
    } else {
      return this.$q.resolve(void 0);
    }
  }
  initialize() {
    return this.extendConfig().then(() => {
      const all = [];
      Object.keys(this.cacheConfig).forEach((key) => {
        all.push(this.initializeCache(key));
      });
      return this.$q.all(all);
    });
  }
  refreshCache(key) {
    InfrastructureCaches.clearCache(key);
    return this.initializeCache(key);
  }
  refreshCaches() {
    const all = [];
    Object.keys(this.cacheConfig).forEach((key) => {
      all.push(this.refreshCache(key));
    });
    return this.$q.all(all);
  }
}
CacheInitializerService.$inject = ["$q", "securityGroupReader", "providerServiceDelegate"];
const CACHE_INITIALIZER_SERVICE = "spinnaker.core.cache.initializer";
module(CACHE_INITIALIZER_SERVICE, [SECURITY_GROUP_READER]).service("cacheInitializer", CacheInitializerService);

const FilterTags = ({ clearFilters, tags, tagCleared }) => {
  const hasExtraTags = (tags == null ? void 0 : tags.length) > 5;
  const [showExtraTags, setShowExtraTags] = React__default.useState(hasExtraTags && CollapsibleSectionStateCache.isExpanded("filterTags"));
  const visibleTags = !hasExtraTags || showExtraTags ? tags : tags.slice(0, 5);
  const toggleExtraTags = () => {
    CollapsibleSectionStateCache.setExpanded("filterTags", !showExtraTags);
    setShowExtraTags(!showExtraTags);
  };
  const clearAllFilters = () => {
    if (clearFilters) {
      clearFilters();
    }
    logger.log({ category: "Filter Tags", action: "Clear All clicked" });
  };
  const clearIndividualFilter = (tag) => {
    tag.clear();
    tagCleared();
    logger.log({ category: "Filter Tags", action: "Individual tag removed" });
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12 filter-tags"
  }, visibleTags && visibleTags.length > 0 && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", null, "Filtered by: "), visibleTags.map((tag) => /* @__PURE__ */ React__default.createElement("span", {
    className: "filter-tag",
    key: [tag.label, tag.value].join(":")
  }, /* @__PURE__ */ React__default.createElement("strong", null, tag.label), ": ", tag.value, /* @__PURE__ */ React__default.createElement("a", {
    className: "clickable clear-filters",
    onClick: () => clearIndividualFilter(tag)
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-remove-sign"
  })))), hasExtraTags && /* @__PURE__ */ React__default.createElement("span", {
    className: "filter-toggle",
    onClick: toggleExtraTags
  }, showExtraTags ? "Hide List" : `See all ${tags.length} current filters`), visibleTags.length > 1 && /* @__PURE__ */ React__default.createElement("a", {
    className: "clickable clear-filters",
    onClick: clearAllFilters
  }, "Clear All")));
};

function generateIterator(sortFilter) {
  return function iterator(acc, headingType) {
    const { headings, pool } = acc;
    headings[headingType] = chain(pool).map(headingType).uniq().compact().value().sort();
    unselectUnavailableHeadings(headings[headingType], sortFilter[headingType]);
    acc.pool = filterPoolBySelectedHeadings(pool, headingType, sortFilter);
    return acc;
  };
}
function filterPoolBySelectedHeadings(pool, headingType, sortFilter) {
  const selectedHeadings = sortFilter[headingType];
  if (!Object.keys(pickBy(selectedHeadings, identity)).length) {
    return pool;
  }
  return pool.filter((unit) => selectedHeadings[unit[headingType]]);
}
function unselectUnavailableHeadings(headings, selectedHeadings) {
  if (!selectedHeadings) {
    return;
  }
  const headingSet = new Set(headings);
  Object.keys(selectedHeadings).forEach((key) => {
    if (!headingSet.has(key)) {
      delete selectedHeadings[key];
    }
  });
}
function digestDependentFilters({
  pool,
  dependencyOrder,
  sortFilter
}) {
  return dependencyOrder.reduce(generateIterator(sortFilter), { pool, headings: {} }).headings;
}

const filterModelConfig$4 = [
  { model: "filter", param: "q", clearValue: "", type: "string", filterLabel: "search" },
  { model: "account", param: "acct", type: "trueKeyObject" },
  { model: "region", param: "reg", type: "trueKeyObject" },
  { model: "stack", param: "stack", type: "trueKeyObject" },
  { model: "detail", param: "detail", type: "trueKeyObject" },
  { model: "category", param: "category", type: "trueKeyObject" },
  {
    model: "status",
    type: "trueKeyObject",
    filterTranslator: { Up: "Healthy", Down: "Unhealthy", OutOfService: "Out of Service" }
  },
  { model: "availabilityZone", param: "zone", type: "trueKeyObject", filterLabel: "availability zone" },
  { model: "instanceType", type: "trueKeyObject", filterLabel: "instance type" },
  { model: "providerType", type: "trueKeyObject", filterLabel: "provider" },
  { model: "minInstances", type: "int", filterLabel: "instance count (min)" },
  { model: "maxInstances", type: "int", filterLabel: "instance count (max)" },
  { model: "showAllInstances", param: "hideInstances", displayOption: true, type: "inverse-boolean" },
  { model: "listInstances", displayOption: true, type: "boolean" },
  { model: "instanceSort", displayOption: true, type: "string", defaultValue: "launchTime" },
  { model: "multiselect", displayOption: true, type: "boolean" },
  { model: "clusters", type: "trueKeyObject" },
  { model: "labels", type: "trueKeyObject", filterLabel: "label", clearValue: {} }
];
class ClusterFilterModel {
  constructor() {
    this.asFilterModel = FilterModelService.configureFilterModel(this, filterModelConfig$4);
    FilterModelService.registerRouterHooks(this.asFilterModel, "**.application.insight.clusters.**");
    this.asFilterModel.activate();
  }
}

function buildLabelsMap(serverGroups) {
  return reduce(serverGroups, (map, serverGroup) => {
    const labelKeys = Object.keys(serverGroup.labels || {});
    labelKeys.forEach((key) => {
      if (!map[key]) {
        map[key] = [];
      }
      if (!map[key].includes(serverGroup.labels[key])) {
        map[key].push(serverGroup.labels[key]);
      }
    });
    return map;
  }, {});
}
function labelFiltersToTrueKeyObject(labelFilters) {
  if (!labelFilters) {
    return {};
  }
  return reduce(labelFilters, (trueKeyObj, labelFilter) => {
    const key = `${labelFilter.key}:${labelFilter.value}`;
    trueKeyObj[key] = true;
    return trueKeyObj;
  }, {});
}
function trueKeyObjectToLabelFilters(trueKeyObject) {
  if (!trueKeyObject) {
    return [];
  }
  return reduce(trueKeyObject, (labelFilters, _val, composedKey) => {
    let [key, value] = composedKey.split(":");
    if (key === "null") {
      key = null;
    }
    if (value === "null") {
      value = null;
    }
    return labelFilters.concat([{ key, value }]);
  }, []);
}

var __defProp$y = Object.defineProperty;
var __getOwnPropDesc$y = Object.getOwnPropertyDescriptor;
var __decorateClass$y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$y(target, key, result);
  return result;
};
class ClusterFilterService {
  constructor() {
    this.groupsUpdatedStream = new Subject();
    this.isFilterable = FilterModelService.isFilterable;
  }
  updateClusterGroups(application) {
    if (!application) {
      application = this.lastApplication;
      if (!this.lastApplication) {
        return null;
      }
    }
    const groups = [];
    const serverGroups = this.filterServerGroupsForDisplay(application.getDataSource("serverGroups").data);
    const accountGroupings = groupBy(serverGroups, "account");
    forOwn(accountGroupings, (accountGroup, account) => {
      const categoryGroupings = groupBy(accountGroup, "category");
      const clusterGroups = [];
      forOwn(categoryGroupings, (categoryGroup, category) => {
        const clusterGroupings = groupBy(categoryGroup, "cluster");
        forOwn(clusterGroupings, (clusterGroup, cluster) => {
          const regionGroupings = groupBy(clusterGroup, "region");
          const regionGroups = [];
          forOwn(regionGroupings, (regionGroup, region) => {
            regionGroups.push({
              heading: region,
              category,
              serverGroups: regionGroup,
              key: `${region}:${category}`,
              entityTags: (regionGroup[0].clusterEntityTags || []).find((t) => t.entityRef["region"] === region),
              isManaged: !!regionGroup[0].isManaged,
              managedResourceSummary: regionGroup[0].managedResourceSummary
            });
          });
          const appCluster = (application.clusters || []).find((c) => c.account === account && c.name === cluster && c.category === category);
          if (appCluster) {
            const isEntireClusterManaged = regionGroups.every(({ isManaged }) => isManaged);
            clusterGroups.push({
              heading: cluster,
              category,
              key: `${cluster}:${category}`,
              cluster: appCluster,
              subgroups: sortBy(regionGroups, "heading"),
              entityTags: (clusterGroup[0].clusterEntityTags || []).find((t) => t.entityRef["region"] === "*" || t.entityRef["region"] === void 0),
              isManaged: isEntireClusterManaged,
              managedResourceSummary: isEntireClusterManaged ? regionGroups[0].managedResourceSummary : void 0
            });
          }
        });
      });
      groups.push({
        heading: account,
        key: account,
        subgroups: sortBy(clusterGroups, ["heading", "category"])
      });
    });
    this.sortGroupsByHeading(groups);
    ClusterState.filterModel.asFilterModel.addTags();
    this.lastApplication = application;
    this.addHealthFlags();
    this.groupsUpdatedStream.next(ClusterState.filterModel.asFilterModel.groups);
  }
  clearFilters() {
    ClusterState.filterModel.asFilterModel.clearFilters();
    ClusterState.filterModel.asFilterModel.applyParamsToUrl();
  }
  shouldShowInstance(instance) {
    const sortFilter = ClusterState.filterModel.asFilterModel.sortFilter;
    if (this.isFilterable(sortFilter.availabilityZone)) {
      const checkedAvailabilityZones = FilterModelService.getCheckValues(sortFilter.availabilityZone);
      if (!checkedAvailabilityZones.includes(instance.availabilityZone)) {
        return false;
      }
    }
    if (this.isFilterable(sortFilter.status)) {
      const allCheckedValues = FilterModelService.getCheckValues(sortFilter.status);
      const checkedStatus = allCheckedValues.filter((s) => s !== "Disabled");
      if (!checkedStatus.length) {
        return true;
      }
      if (sortFilter.status.Disabled) {
        return true;
      }
      return checkedStatus.includes(instance.healthState);
    }
    return true;
  }
  overrideFiltersForUrl(result) {
    if (result.href.includes("/clusters")) {
      ClusterState.filterModel.asFilterModel.clearFilters();
      const sortFilter = ClusterState.filterModel.asFilterModel.sortFilter;
      sortFilter.filter = result.serverGroup ? result.serverGroup : result.cluster ? "cluster:" + result.cluster : "";
      if (result.account) {
        const acct = {};
        acct[result.account] = true;
        sortFilter.account = acct;
      }
      if (result.region) {
        const reg = {};
        reg[result.region] = true;
        sortFilter.region = reg;
      }
      if (result.stack) {
        const stack = {};
        stack[result.stack] = true;
        sortFilter.stack = stack;
      }
      if (result.detail) {
        const detail = {};
        detail[result.detail] = true;
        sortFilter.detail = detail;
      }
      if (result.category) {
        const category = {};
        category[result.category] = true;
        sortFilter.category = category;
      }
      if (ReactInjector.$stateParams.application === result.application) {
        this.updateClusterGroups();
      }
    }
  }
  filterServerGroupsForDisplay(serverGroups) {
    const filtered = serverGroups.filter((g) => this.textFilter(g)).filter((g) => this.instanceCountFilter(g)).filter((g) => FilterModelService.checkAccountFilters(ClusterState.filterModel.asFilterModel)(g)).filter((g) => FilterModelService.checkRegionFilters(ClusterState.filterModel.asFilterModel)(g)).filter((g) => FilterModelService.checkStackFilters(ClusterState.filterModel.asFilterModel)(g)).filter((g) => FilterModelService.checkDetailFilters(ClusterState.filterModel.asFilterModel)(g)).filter((g) => FilterModelService.checkStatusFilters(ClusterState.filterModel.asFilterModel)(g)).filter((g) => FilterModelService.checkProviderFilters(ClusterState.filterModel.asFilterModel)(g)).filter((g) => this.instanceTypeFilters(g)).filter((g) => this.instanceFilters(g)).filter((g) => this.labelFilters(g));
    this.updateMultiselectInstanceGroups(filtered);
    this.updateMultiselectServerGroups(filtered);
    return filtered;
  }
  updateMultiselectInstanceGroups(serverGroups) {
    const sortFilter = ClusterState.filterModel.asFilterModel.sortFilter;
    if (sortFilter.listInstances && sortFilter.multiselect) {
      ClusterState.multiselectModel.instanceGroups.forEach((instanceGroup) => {
        const match = serverGroups.find((serverGroup) => {
          return serverGroup.name === instanceGroup.serverGroup && serverGroup.region === instanceGroup.region && serverGroup.account === instanceGroup.account && serverGroup.type === instanceGroup.cloudProvider;
        });
        if (!match) {
          instanceGroup.instanceIds.length = 0;
        } else {
          const filteredInstances = match.instances.filter((i) => this.shouldShowInstance(i));
          if (instanceGroup.selectAll) {
            instanceGroup.instanceIds = filteredInstances.map((i) => i.id);
          } else {
            instanceGroup.instanceIds = filteredInstances.filter((instance) => instanceGroup.instanceIds.includes(instance.id)).map((instance) => instance.id);
          }
        }
      });
      ClusterState.multiselectModel.instancesStream.next();
      ClusterState.multiselectModel.syncNavigation();
    } else {
      ClusterState.multiselectModel.instanceGroups.length = 0;
    }
  }
  updateMultiselectServerGroups(serverGroups) {
    if (ClusterState.filterModel.asFilterModel.sortFilter.multiselect) {
      if (ClusterState.multiselectModel.serverGroups.length) {
        const remainingKeys = serverGroups.map((s) => ClusterState.multiselectModel.makeServerGroupKey(s));
        const toRemove = [];
        ClusterState.multiselectModel.serverGroups.forEach((group, index) => {
          if (!remainingKeys.includes(group.key)) {
            toRemove.push(index);
          }
        });
        toRemove.reverse().forEach((index) => ClusterState.multiselectModel.serverGroups.splice(index, 1));
      }
      ClusterState.multiselectModel.serverGroupsStream.next();
      ClusterState.multiselectModel.syncNavigation();
    }
  }
  instanceTypeFilters(serverGroup) {
    const sortFilter = ClusterState.filterModel.asFilterModel.sortFilter;
    if (this.isFilterable(sortFilter.instanceType)) {
      const checkedInstanceTypes = FilterModelService.getCheckValues(sortFilter.instanceType);
      return checkedInstanceTypes.includes(serverGroup.instanceType);
    } else {
      return true;
    }
  }
  instanceFilters(serverGroup) {
    return !this.shouldFilterInstances() || serverGroup.instances.some((i) => this.shouldShowInstance(i));
  }
  shouldFilterInstances() {
    const sortFilter = ClusterState.filterModel.asFilterModel.sortFilter;
    return this.isFilterable(sortFilter.availabilityZone) || this.isFilterable(sortFilter.status) && !sortFilter.status.hasOwnProperty("Disabled");
  }
  instanceCountFilter(serverGroup) {
    let shouldInclude = true;
    const sortFilter = ClusterState.filterModel.asFilterModel.sortFilter;
    if (sortFilter.minInstances && !isNaN(sortFilter.minInstances)) {
      shouldInclude = serverGroup.instances.length >= sortFilter.minInstances;
    }
    if (shouldInclude && sortFilter.maxInstances !== null && !isNaN(sortFilter.maxInstances)) {
      shouldInclude = serverGroup.instances.length <= sortFilter.maxInstances;
    }
    return shouldInclude;
  }
  labelFilters(serverGroup) {
    const labelFiltersAsTrueKeyObj = ClusterState.filterModel.asFilterModel.sortFilter.labels;
    const labelFilters = trueKeyObjectToLabelFilters(labelFiltersAsTrueKeyObj);
    if (isEmpty(labelFilters)) {
      return true;
    }
    return every(labelFilters, ({ key: filterKey, value: filterValue }) => {
      if (filterKey === null || filterValue === null) {
        return true;
      }
      return some(serverGroup.labels || {}, (value, key) => {
        const keyMatch = filterKey && filterKey === key;
        const valueMatch = filterValue && filterValue === value;
        return keyMatch && valueMatch;
      });
    });
  }
  textFilter(serverGroup) {
    const filter = ClusterState.filterModel.asFilterModel.sortFilter.filter.toLowerCase();
    if (!filter) {
      return true;
    }
    if (filter.includes("clusters:")) {
      const clusterNames = filter.split("clusters:")[1].replace(/\s/g, "").split(",");
      return clusterNames.includes(serverGroup.cluster);
    }
    if (filter.includes("vpc:")) {
      const vpcName = filter.split("vpc:")[1];
      return serverGroup.vpcName.toLowerCase() === vpcName.toLowerCase();
    }
    if (filter.includes("tag:")) {
      let match = false;
      const [, tag] = filter.split("tag:");
      let tagKey = null;
      let tagValue = null;
      if (tag.includes("=")) {
        [tagKey, tagValue] = tag.split("=");
      }
      each(serverGroup.tags || {}, (val, key) => {
        if (tagKey) {
          if (tagKey.toLowerCase() === key.toLowerCase() && val.toLowerCase().includes(tagValue.toLowerCase())) {
            match = true;
          }
        } else if (val.toLowerCase().includes(tag.toLowerCase())) {
          match = true;
        }
      });
      return match;
    }
    if (filter.includes("detail:")) {
      const detailName = filter.split("detail:")[1];
      return serverGroup.detail === detailName.toLowerCase();
    }
    if (filter.includes("cluster:")) {
      const clusterName = filter.split("cluster:")[1];
      return serverGroup.cluster === clusterName;
    }
    if (filter.includes("labels:")) {
      const caseSensitiveFilter = ClusterState.filterModel.asFilterModel.sortFilter.filter;
      const labelsStr = caseSensitiveFilter.split("labels:")[1];
      const labels = labelsStr.split(",").map((l) => l.trim());
      return every(labels, (label) => {
        let labelKey;
        let labelValue;
        if (label.includes("=")) {
          [labelKey, labelValue] = label.split("=");
        }
        if (!labelKey || !labelValue) {
          return false;
        }
        return some(serverGroup.labels || {}, (val, key) => {
          return labelKey === key && val === labelValue;
        });
      });
    } else {
      this.addSearchField(serverGroup);
      return filter.split(" ").every((testWord) => {
        return serverGroup.searchField.includes(testWord);
      });
    }
  }
  addSearchField(serverGroup) {
    if (serverGroup.searchField) {
      return;
    }
    let buildInfo = "";
    if (serverGroup.buildInfo && serverGroup.buildInfo["jenkins"]) {
      buildInfo = [
        "#" + serverGroup.buildInfo["jenkins"]["number"],
        serverGroup.buildInfo.jenkins.host,
        serverGroup.buildInfo.jenkins.name
      ].join(" ").toLowerCase();
    }
    if (!serverGroup.searchField) {
      serverGroup.searchField = [
        serverGroup.region.toLowerCase(),
        serverGroup.name.toLowerCase(),
        serverGroup.account.toLowerCase(),
        buildInfo,
        (serverGroup.loadBalancers || []).join(" "),
        (serverGroup.instances || []).map((i) => i.id).join(" ")
      ].join(" ");
    }
  }
  sortGroupsByHeading(groups) {
    this.diffSubgroups(ClusterState.filterModel.asFilterModel.groups, groups);
    ClusterState.filterModel.asFilterModel.groups.sort((a, b) => a.heading.localeCompare(b.heading));
  }
  addHealthFlags() {
    ClusterState.filterModel.asFilterModel.groups.forEach((group) => {
      group.subgroups.forEach((subgroup) => {
        subgroup.hasDiscovery = subgroup.subgroups.some((g) => this.hasDiscovery(g));
        subgroup.hasLoadBalancers = subgroup.subgroups.some((g) => this.hasLoadBalancers(g));
      });
    });
  }
  hasDiscovery(group) {
    return group.serverGroups.some((serverGroup) => (serverGroup.instances || []).some((instance) => (instance.health || []).some((health) => health.type === "Discovery")));
  }
  hasLoadBalancers(group) {
    return group.serverGroups.some((serverGroup) => (serverGroup.instances || []).some((instance) => (instance.health || []).some((health) => health.type === "LoadBalancer")));
  }
  diffSubgroups(oldGroups, newGroups) {
    const groupsToRemove = [];
    oldGroups.forEach((oldGroup, idx) => {
      const newGroup = (newGroups || []).find((group) => group.key === oldGroup.key);
      if (!newGroup) {
        groupsToRemove.push(idx);
      } else {
        if (newGroup.hasOwnProperty("subgroups")) {
          this.diffSubgroups(oldGroup.subgroups, newGroup.subgroups);
        }
        if (newGroup.hasOwnProperty("cluster")) {
          oldGroup.cluster = newGroup.cluster;
          this.diffSubgroups(oldGroup.subgroups, newGroup.subgroups);
        }
        if (newGroup.hasOwnProperty("serverGroups")) {
          this.diffServerGroups(oldGroup, newGroup);
        }
        if (oldGroup.entityTags || newGroup.entityTags) {
          oldGroup.entityTags = newGroup.entityTags;
        }
        if (oldGroup.hasOwnProperty("isManaged") || newGroup.hasOwnProperty("isManaged")) {
          const oldSubGroup = oldGroup;
          const newSubGroup = newGroup;
          oldSubGroup.isManaged = newSubGroup.isManaged;
          oldSubGroup.managedResourceSummary = newSubGroup.managedResourceSummary;
        }
      }
    });
    groupsToRemove.reverse().forEach((idx) => {
      oldGroups.splice(idx, 1);
    });
    newGroups.forEach((newGroup) => {
      const match = oldGroups.find((g) => g.key === newGroup.key);
      if (!match) {
        oldGroups.push(newGroup);
      }
    });
  }
  diffServerGroups(oldGroup, newGroup) {
    if (oldGroup.category !== newGroup.category) {
      return;
    }
    const toRemove = [];
    oldGroup.serverGroups.forEach((serverGroup, idx) => {
      const newServerGroup = newGroup.serverGroups.find((g) => g.name === serverGroup.name && g.account === serverGroup.account && g.region === serverGroup.region);
      if (!newServerGroup) {
        $log.debug("server group no longer found, removing:", serverGroup.name, serverGroup.account, serverGroup.region, serverGroup.category);
        toRemove.push(idx);
      } else {
        if (serverGroup.stringVal !== newServerGroup.stringVal) {
          $log.debug("change detected, updating server group:", serverGroup.name, serverGroup.account, serverGroup.region, serverGroup.category);
          oldGroup.serverGroups[idx] = newServerGroup;
        }
        if (serverGroup.runningExecutions || newServerGroup.runningExecutions) {
          serverGroup.runningExecutions = newServerGroup.runningExecutions;
        }
        if (serverGroup.runningTasks || newServerGroup.runningTasks) {
          serverGroup.runningTasks = newServerGroup.runningTasks;
        }
      }
    });
    toRemove.reverse().forEach((idx) => {
      oldGroup.serverGroups.splice(idx, 1);
    });
    newGroup.serverGroups.forEach((serverGroup) => {
      const oldServerGroup = oldGroup.serverGroups.find((g) => g.name === serverGroup.name && g.account === serverGroup.account && g.region === serverGroup.region);
      if (!oldServerGroup) {
        $log.debug("new server group found, adding", serverGroup.name, serverGroup.account, serverGroup.region);
        oldGroup.serverGroups.push(serverGroup);
      }
    });
  }
}
__decorateClass$y([
  Debounce(25)
], ClusterFilterService.prototype, "updateClusterGroups", 1);

class MultiselectModel {
  constructor() {
    this.instanceGroups = [];
    this.instancesStream = new Subject();
    this.serverGroups = [];
    this.serverGroupsStream = new Subject();
  }
  syncNavigation() {
    const { $state } = ReactInjector;
    if (!ClusterState.filterModel.asFilterModel.sortFilter.multiselect && $state.params.multiselect) {
      $state.go(".", { multiselect: null }, { inherit: true });
    }
    if (ClusterState.filterModel.asFilterModel.sortFilter.multiselect && !$state.params.multiselect) {
      $state.go(".", { multiselect: true }, { inherit: true });
    }
    if ($state.includes("**.multipleInstances") && !ClusterState.filterModel.asFilterModel.sortFilter.multiselect) {
      this.deselectAllInstances();
      $state.go("^");
      return;
    }
    if ($state.includes("**.multipleServerGroups") && !ClusterState.filterModel.asFilterModel.sortFilter.multiselect) {
      this.clearAllServerGroups();
      $state.go("^");
      return;
    }
    const instancesSelected = this.instanceGroups.reduce((acc, group) => acc + group.instanceIds.length, 0);
    if ($state.includes("**.multipleInstances") && !instancesSelected) {
      $state.go("^");
    }
    if (!$state.includes("**.multipleInstances") && instancesSelected) {
      if (this.isClusterChildState()) {
        $state.go("^.multipleInstances");
      } else {
        $state.go(".multipleInstances");
      }
    }
    if ($state.includes("**.multipleServerGroups") && !this.serverGroups.length) {
      $state.go("^");
      return;
    }
    if (!$state.includes("**.multipleServerGroups") && this.serverGroups.length) {
      if (this.isClusterChildState()) {
        $state.go("^.multipleServerGroups");
      } else {
        $state.go(".multipleServerGroups");
      }
    }
  }
  deselectAllInstances() {
    this.instanceGroups.forEach((instanceGroup) => {
      instanceGroup.instanceIds.length = 0;
      instanceGroup.selectAll = false;
    });
  }
  clearAllInstanceGroups() {
    this.instanceGroups.length = 0;
    this.instancesStream.next();
  }
  clearAllServerGroups() {
    this.serverGroups.length = 0;
    this.serverGroupsStream.next();
  }
  clearAll() {
    this.clearAllInstanceGroups();
    this.clearAllServerGroups();
  }
  getOrCreateInstanceGroup(serverGroup) {
    const serverGroupName = serverGroup.name;
    const account = serverGroup.account;
    const region = serverGroup.region;
    const cloudProvider = serverGroup.type;
    let result = this.instanceGroups.find((instanceGroup) => instanceGroup.serverGroup === serverGroupName && instanceGroup.account === account && instanceGroup.region === region && instanceGroup.cloudProvider === cloudProvider);
    if (!result) {
      const params = ReactInjector.$state.params;
      const instanceIds = (serverGroup.instances || []).filter((instance) => instance.provider === params.provider && instance.id === params.instanceId).map((instance) => instance.id);
      result = {
        serverGroup: serverGroupName,
        account,
        region,
        cloudProvider,
        instanceIds,
        instances: [],
        selectAll: false
      };
      this.instanceGroups.push(result);
    }
    return result;
  }
  makeServerGroupKey(serverGroup) {
    return [serverGroup.type, serverGroup.account, serverGroup.region, serverGroup.name, serverGroup.category].join(":");
  }
  serverGroupIsSelected(serverGroup) {
    if (!this.serverGroups.length) {
      return false;
    }
    const key = this.makeServerGroupKey(serverGroup);
    return this.serverGroups.filter((sg) => sg.key === key).length > 0;
  }
  toggleServerGroup(serverGroup) {
    const { $state } = ReactInjector;
    if (!ClusterState.filterModel.asFilterModel.sortFilter.multiselect) {
      const params = {
        provider: serverGroup.type,
        accountId: serverGroup.account,
        region: serverGroup.region,
        serverGroup: serverGroup.name,
        job: serverGroup.name
      };
      if (this.isClusterChildState()) {
        if ($state.includes("**.serverGroup", params)) {
          return;
        }
        $state.go("^." + serverGroup.category, params);
      } else {
        $state.go("." + serverGroup.category, params);
      }
      return;
    }
    this.deselectAllInstances();
    const key = this.makeServerGroupKey(serverGroup);
    const selected = this.serverGroups.find((sg) => sg.key === key);
    if (selected) {
      this.serverGroups.splice(this.serverGroups.indexOf(selected), 1);
    } else {
      this.serverGroups.push({
        key,
        account: serverGroup.account,
        region: serverGroup.region,
        provider: serverGroup.type,
        name: serverGroup.name,
        moniker: serverGroup.moniker
      });
    }
    this.serverGroupsStream.next();
    this.syncNavigation();
  }
  toggleInstance(serverGroup, instanceId) {
    const { $state } = ReactInjector;
    if (!ClusterState.filterModel.asFilterModel.sortFilter.multiselect) {
      const params = { provider: serverGroup.type, instanceId };
      if (this.isClusterChildState()) {
        if ($state.includes("**.instanceDetails", params)) {
          return;
        }
        $state.go("^.instanceDetails", params);
      } else {
        $state.go(".instanceDetails", params);
      }
      return;
    }
    this.clearAllServerGroups();
    const group = this.getOrCreateInstanceGroup(serverGroup);
    if (group.instanceIds.includes(instanceId)) {
      group.instanceIds.splice(group.instanceIds.indexOf(instanceId), 1);
      group.selectAll = false;
    } else {
      group.instanceIds.push(instanceId);
    }
    this.instancesStream.next();
    this.syncNavigation();
  }
  toggleSelectAll(serverGroup, allInstanceIds) {
    const group = this.getOrCreateInstanceGroup(serverGroup);
    group.selectAll = !group.selectAll;
    group.instanceIds = group.selectAll ? allInstanceIds : [];
    if (group.selectAll) {
      this.clearAllServerGroups();
    }
    this.instancesStream.next();
    this.syncNavigation();
  }
  instanceIsSelected(serverGroup, instanceId) {
    const group = this.getOrCreateInstanceGroup(serverGroup);
    return group.instanceIds.includes(instanceId);
  }
  isClusterChildState() {
    return ReactInjector.$state.$current.name.split(".").pop() !== "clusters";
  }
}

const filterModelConfig$3 = [
  { model: "account", param: "acct", type: "trueKeyObject" },
  { model: "detail", param: "detail", type: "trueKeyObject" },
  { model: "filter", param: "q", clearValue: "", type: "string", filterLabel: "search" },
  { model: "providerType", type: "trueKeyObject", filterLabel: "provider" },
  { model: "region", param: "reg", type: "trueKeyObject" }
];
class FunctionFilterModel {
  constructor() {
    this.asFilterModel = FilterModelService.configureFilterModel(this, filterModelConfig$3);
    FilterModelService.registerRouterHooks(this.asFilterModel, "**.application.insight.functions.**");
    this.asFilterModel.activate();
  }
}

var __defProp$x = Object.defineProperty;
var __getOwnPropDesc$x = Object.getOwnPropertyDescriptor;
var __decorateClass$x = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$x(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$x(target, key, result);
  return result;
};
class FunctionFilterService {
  constructor() {
    this.groupsUpdatedStream = new Subject();
  }
  addSearchFields(functionDef) {
    if (!functionDef.searchField) {
      functionDef.searchField = [functionDef.functionName, functionDef.region.toLowerCase(), functionDef.account].join(" ");
    }
  }
  checkSearchTextFilter(functionDef) {
    const filter = FunctionState.filterModel.asFilterModel.sortFilter.filter;
    if (!filter) {
      return true;
    }
    if (filter.includes("vpc:")) {
      const [, vpcName] = /vpc:([\w-]*)/.exec(filter);
      return functionDef.vpcName.toLowerCase() === vpcName.toLowerCase();
    }
    this.addSearchFields(functionDef);
    return filter.split(" ").every((testWord) => {
      return functionDef.searchField.includes(testWord);
    });
  }
  filterFunctionsForDisplay(functions) {
    return chain(functions).filter((fn) => this.checkSearchTextFilter(fn)).filter((fn) => FilterModelService.checkAccountFilters(FunctionState.filterModel.asFilterModel)(fn)).filter((fn) => FilterModelService.checkRegionFilters(FunctionState.filterModel.asFilterModel)(fn)).filter((fn) => FilterModelService.checkProviderFilters(FunctionState.filterModel.asFilterModel)(fn)).value();
  }
  sortGroupsByHeading() {
    FunctionState.filterModel.asFilterModel.groups.sort((a, b) => {
      return a.heading.localeCompare(b.heading);
    });
  }
  clearFilters() {
    FunctionState.filterModel.asFilterModel.clearFilters();
    FunctionState.filterModel.asFilterModel.applyParamsToUrl();
  }
  getFunctionGroups(groupedByAccount) {
    const groups = [];
    forOwn(groupedByAccount, (group, account) => {
      const groupedByRegion = values(groupBy(group, "region"));
      const namesByRegion = groupedByRegion.map((g) => g.map((fn) => fn.functionName));
      const functionNames = namesByRegion.length > 1 ? intersection(...namesByRegion).reduce((acc, name) => {
        acc[name] = true;
        return acc;
      }, {}) : {};
      const subGroupings = groupBy(group, (fn) => `${fn.functionName}:${fn.region}`);
      const subGroups = [];
      forOwn(subGroupings, (subGroup, nameAndRegion) => {
        const [name, region] = nameAndRegion.split(":");
        const subSubGroups = [];
        subGroup.forEach((functionDef) => {
          subSubGroups.push({
            heading: functionDef.region,
            functionDef
          });
        });
        const heading = `${name}${functionNames[name] && region ? ` (${region})` : ""}`;
        subGroups.push({
          heading,
          subgroups: sortBy(subSubGroups, "heading")
        });
      });
      groups.push({ heading: account, subgroups: sortBy(subGroups, "heading") });
    });
    return groups;
  }
  updateFunctionGroups(application) {
    if (!application) {
      application = this.lastApplication;
      if (!this.lastApplication) {
        return null;
      }
    }
    const functions = this.filterFunctionsForDisplay(application.functions.data);
    const grouped = groupBy(functions, "account");
    const groups = this.getFunctionGroups(grouped);
    FunctionState.filterModel.asFilterModel.groups = groups;
    this.sortGroupsByHeading();
    FunctionState.filterModel.asFilterModel.addTags();
    this.lastApplication = application;
    this.groupsUpdatedStream.next(groups);
  }
}
__decorateClass$x([
  Debounce(25)
], FunctionFilterService.prototype, "updateFunctionGroups", 1);

const filterModelConfig$2 = [
  { model: "account", param: "acct", type: "trueKeyObject" },
  { model: "availabilityZone", param: "zone", type: "trueKeyObject", filterLabel: "availability zone" },
  { model: "detail", param: "detail", type: "trueKeyObject" },
  { model: "filter", param: "q", clearValue: "", type: "string", filterLabel: "search" },
  { model: "loadBalancerType", param: "loadBalancerType", filterLabel: "type", type: "trueKeyObject" },
  { model: "providerType", type: "trueKeyObject", filterLabel: "provider" },
  { model: "region", param: "reg", type: "trueKeyObject" },
  { model: "showInstances", displayOption: true, type: "boolean" },
  { model: "showServerGroups", param: "hideServerGroups", displayOption: true, type: "inverse-boolean" },
  { model: "stack", param: "stack", type: "trueKeyObject" },
  {
    model: "status",
    type: "trueKeyObject",
    filterTranslator: { Up: "Healthy", Down: "Unhealthy", OutOfService: "Out of Service" }
  }
];
class LoadBalancerFilterModel {
  constructor() {
    this.asFilterModel = FilterModelService.configureFilterModel(this, filterModelConfig$2);
    FilterModelService.registerRouterHooks(this.asFilterModel, "**.application.insight.loadBalancers.**");
    this.asFilterModel.activate();
  }
}

var __defProp$w = Object.defineProperty;
var __getOwnPropDesc$w = Object.getOwnPropertyDescriptor;
var __decorateClass$w = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$w(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$w(target, key, result);
  return result;
};
class LoadBalancerFilterService {
  constructor() {
    this.groupsUpdatedStream = new Subject();
    this.isFilterable = FilterModelService.isFilterable;
    this.getCheckValues = FilterModelService.getCheckValues;
  }
  addSearchFields(loadBalancer) {
    if (!loadBalancer.searchField) {
      loadBalancer.searchField = [
        loadBalancer.name,
        loadBalancer.region.toLowerCase(),
        loadBalancer.account,
        map$1(loadBalancer.serverGroups, "name").join(" "),
        map$1(loadBalancer.instances, "id").join(" ")
      ].join(" ");
    }
  }
  checkSearchTextFilter(loadBalancer) {
    const filter = LoadBalancerState.filterModel.asFilterModel.sortFilter.filter;
    if (!filter) {
      return true;
    }
    if (filter.includes("vpc:")) {
      const [, vpcName] = /vpc:([\w-]*)/.exec(filter);
      return loadBalancer.vpcName.toLowerCase() === vpcName.toLowerCase();
    }
    this.addSearchFields(loadBalancer);
    return filter.split(" ").every((testWord) => {
      return loadBalancer.searchField.includes(testWord);
    });
  }
  checkLoadBalancerTypeFilters(loadBalancer) {
    const sortFilter = LoadBalancerState.filterModel.asFilterModel.sortFilter;
    if (this.isFilterable(sortFilter.loadBalancerType)) {
      const checkedLoadBalancerTypes = this.getCheckValues(sortFilter.loadBalancerType);
      if (!checkedLoadBalancerTypes.includes(loadBalancer.loadBalancerType)) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }
  filterLoadBalancersForDisplay(loadBalancers) {
    return chain(loadBalancers).filter((lb) => this.checkSearchTextFilter(lb)).filter((lb) => this.checkLoadBalancerTypeFilters(lb)).filter((lb) => FilterModelService.checkAccountFilters(LoadBalancerState.filterModel.asFilterModel)(lb)).filter((lb) => FilterModelService.checkRegionFilters(LoadBalancerState.filterModel.asFilterModel)(lb)).filter((lb) => FilterModelService.checkStackFilters(LoadBalancerState.filterModel.asFilterModel)(lb)).filter((lb) => FilterModelService.checkDetailFilters(LoadBalancerState.filterModel.asFilterModel)(lb)).filter((lb) => FilterModelService.checkStatusFilters(LoadBalancerState.filterModel.asFilterModel)(lb)).filter((lb) => FilterModelService.checkProviderFilters(LoadBalancerState.filterModel.asFilterModel)(lb)).filter((lb) => this.instanceFilters(lb)).value();
  }
  instanceFilters(loadBalancer) {
    return !this.shouldFilterInstances() || some(loadBalancer.instances, (instance) => this.shouldShowInstance(instance));
  }
  shouldFilterInstances() {
    const sortFilter = LoadBalancerState.filterModel.asFilterModel.sortFilter;
    return this.isFilterable(sortFilter.status) || this.isFilterable(sortFilter.availabilityZone);
  }
  shouldShowInstance(instance) {
    const sortFilter = LoadBalancerState.filterModel.asFilterModel.sortFilter;
    if (this.isFilterable(sortFilter.availabilityZone)) {
      const checkedAvailabilityZones = this.getCheckValues(sortFilter.availabilityZone);
      if (!checkedAvailabilityZones.includes(instance.zone)) {
        return false;
      }
    }
    if (this.isFilterable(sortFilter.status)) {
      const allCheckedValues = this.getCheckValues(sortFilter.status);
      const checkedStatus = without(allCheckedValues, "Disabled");
      if (!checkedStatus.length) {
        return true;
      }
      return includes(checkedStatus, instance.healthState);
    }
    return true;
  }
  diffSubgroups(oldGroups, newGroups) {
    const groupsToRemove = [];
    oldGroups.forEach((oldGroup, idx) => {
      const newGroup = find(newGroups, { heading: oldGroup.heading });
      if (!newGroup) {
        groupsToRemove.push(idx);
      } else {
        if (newGroup.loadBalancer) {
          oldGroup.loadBalancer = newGroup.loadBalancer;
        }
        if (newGroup.serverGroups) {
          this.diffServerGroups(oldGroup, newGroup);
        }
        if (newGroup.subgroups) {
          this.diffSubgroups(oldGroup.subgroups, newGroup.subgroups);
        }
        if (oldGroup.hasOwnProperty("isManaged") || newGroup.hasOwnProperty("isManaged")) {
          oldGroup.isManaged = newGroup.isManaged;
          oldGroup.managedResourceSummary = newGroup.managedResourceSummary;
        }
      }
    });
    groupsToRemove.reverse().forEach((idx) => {
      oldGroups.splice(idx, 1);
    });
    newGroups.forEach((newGroup) => {
      const match = find(oldGroups, { heading: newGroup.heading });
      if (!match) {
        oldGroups.push(newGroup);
      }
    });
  }
  diffServerGroups(oldGroup, newGroup) {
    const toRemove = [];
    oldGroup.serverGroups.forEach((serverGroup, idx) => {
      serverGroup.stringVal = serverGroup.stringVal || JSON.stringify(serverGroup, this.jsonReplacer);
      const newServerGroup = find(newGroup.serverGroups, {
        name: serverGroup.name,
        account: serverGroup.account,
        region: serverGroup.region
      });
      if (!newServerGroup) {
        $log.debug("server group no longer found, removing:", serverGroup.name, serverGroup.account, serverGroup.region);
        toRemove.push(idx);
      } else {
        newServerGroup.stringVal = newServerGroup.stringVal || JSON.stringify(newServerGroup, this.jsonReplacer);
        if (serverGroup.stringVal !== newServerGroup.stringVal) {
          $log.debug("change detected, updating server group:", serverGroup.name, serverGroup.account, serverGroup.region);
          oldGroup.serverGroups[idx] = newServerGroup;
        }
      }
    });
    toRemove.reverse().forEach((idx) => {
      oldGroup.serverGroups.splice(idx, 1);
    });
    newGroup.serverGroups.forEach((serverGroup) => {
      const oldServerGroup = find(oldGroup.serverGroups, {
        name: serverGroup.name,
        account: serverGroup.account,
        region: serverGroup.region
      });
      if (!oldServerGroup) {
        $log.debug("new server group found, adding", serverGroup.name, serverGroup.account, serverGroup.region);
        oldGroup.serverGroups.push(serverGroup);
      }
    });
  }
  sortGroupsByHeading(groups) {
    this.diffSubgroups(LoadBalancerState.filterModel.asFilterModel.groups, groups);
    LoadBalancerState.filterModel.asFilterModel.groups.sort((a, b) => {
      if (a.heading < b.heading) {
        return -1;
      }
      if (a.heading > b.heading) {
        return 1;
      }
      return 0;
    });
  }
  clearFilters() {
    LoadBalancerState.filterModel.asFilterModel.clearFilters();
    LoadBalancerState.filterModel.asFilterModel.applyParamsToUrl();
  }
  filterServerGroups(loadBalancer) {
    if (this.shouldFilterInstances()) {
      return loadBalancer.serverGroups.filter((serverGroup) => {
        return serverGroup.instances.some((instance) => this.shouldShowInstance(instance));
      });
    }
    return loadBalancer.serverGroups;
  }
  jsonReplacer(key, val) {
    if (typeof key === "string" && key.charAt(0) === "$" && key.charAt(1) === "$") {
      val = void 0;
    }
    return val;
  }
  updateLoadBalancerGroups(application) {
    if (!application) {
      application = this.lastApplication;
      if (!this.lastApplication) {
        return null;
      }
    }
    const groups = [];
    const loadBalancers = this.filterLoadBalancersForDisplay(application.loadBalancers.data);
    const grouped = groupBy(loadBalancers, "account");
    forOwn(grouped, (group, account) => {
      const groupedByType = values(groupBy(group, "loadBalancerType"));
      const namesByType = groupedByType.map((g) => g.map((lb) => lb.name));
      const crossTypeLoadBalancerNames = namesByType.length > 1 ? intersection(...namesByType).reduce((acc, name) => {
        acc[name] = true;
        return acc;
      }, {}) : {};
      const subGroupings = groupBy(group, (lb) => `${lb.name}:${lb.loadBalancerType}`);
      const subGroups = [];
      forOwn(subGroupings, (subGroup, nameAndType) => {
        const [name, type] = nameAndType.split(":");
        const subSubGroups = [];
        subGroup.forEach((loadBalancer) => {
          subSubGroups.push({
            heading: loadBalancer.region,
            loadBalancer,
            serverGroups: this.filterServerGroups(loadBalancer),
            isManaged: !!loadBalancer.isManaged,
            managedResourceSummary: loadBalancer.managedResourceSummary
          });
        });
        const heading = `${name}${crossTypeLoadBalancerNames[name] && type ? ` (${type})` : ""}`;
        const allRegionsManaged = subSubGroups.every(({ isManaged }) => isManaged);
        subGroups.push({
          heading,
          subgroups: sortBy(subSubGroups, "heading"),
          isManaged: allRegionsManaged,
          managedResourceSummary: allRegionsManaged ? subSubGroups[0].managedResourceSummary : void 0
        });
      });
      groups.push({ heading: account, subgroups: sortBy(subGroups, "heading") });
    });
    this.sortGroupsByHeading(groups);
    LoadBalancerState.filterModel.asFilterModel.addTags();
    this.lastApplication = application;
    this.groupsUpdatedStream.next(groups);
  }
}
__decorateClass$w([
  Debounce(25)
], LoadBalancerFilterService.prototype, "updateLoadBalancerGroups", 1);

const filterModelConfig$1 = [
  { model: "awaitingJudgement", type: "boolean", clearValue: false },
  { model: "filter", param: "q", clearValue: "", type: "string", filterLabel: "search" },
  { model: "pipeline", param: "pipeline", type: "trueKeyObject", clearValue: {} },
  { model: "status", type: "trueKeyObject", clearValue: {} },
  { model: "tags", type: "trueKeyObject", clearValue: {} }
];
const GLOBAL_CACHE_KEY = "#global";
class ExecutionFilterModel {
  constructor() {
    this.expandSubject = new Subject();
    const { transitionService } = ReactInjector.$uiRouter;
    this.configViewStateCache = ViewStateCache.createCache("executionFilters", {
      version: 2,
      maxAge: SETTINGS.maxPipelineAgeDays * 24 * 60 * 60 * 1e3
    });
    this.asFilterModel = FilterModelService.configureFilterModel(this, filterModelConfig$1);
    FilterModelService.registerRouterHooks(this.asFilterModel, "**.application.pipelines.executions.**");
    this.asFilterModel.activate();
    transitionService.onBefore({
      entering: (state) => !!(state.self.name.match(".application.pipelines.executions$") || state.self.name.match(".application.pipelines.executionDetails.execution$"))
    }, (trans) => {
      this.mostRecentApplication = trans.params().application;
      this.assignViewStateFromCache();
    });
    Object.defineProperty(this.asFilterModel.sortFilter, "count", {
      get: () => this.groupCount,
      set: (count) => {
        this.groupCount = count;
        this.cacheConfigViewState();
      }
    });
    Object.defineProperty(this.asFilterModel.sortFilter, "groupBy", {
      get: () => this.groupBy,
      set: (grouping) => {
        this.groupBy = grouping;
        this.cacheConfigViewState();
      }
    });
    Object.defineProperty(this.asFilterModel.sortFilter, "showDurations", {
      get: () => this.showDurations,
      set: (newVal) => {
        this.showDurations = newVal;
        this.cacheConfigViewState();
      }
    });
    this.asFilterModel.activate();
  }
  assignViewStateFromCache() {
    const viewState = this.getCachedViewState();
    this.groupCount = viewState.count;
    this.groupBy = viewState.groupBy;
    this.showDurations = viewState.showDurations;
  }
  getCachedViewState(key) {
    key = key || this.mostRecentApplication || GLOBAL_CACHE_KEY;
    const cachedApp = this.configViewStateCache.get(key) || {};
    const cachedGlobal = this.configViewStateCache.get(GLOBAL_CACHE_KEY) || {};
    const defaults = { count: 2, groupBy: "name", showDurations: true };
    this.configViewStateCache.touch(key);
    return extend(defaults, cachedApp, cachedGlobal.showDurations != null ? { showDurations: cachedGlobal.showDurations } : void 0);
  }
  cacheConfigViewState() {
    const appCacheData = this.getCachedViewState();
    appCacheData.showDurations = this.showDurations;
    if (!Object.keys(this.asFilterModel.sortFilter.pipeline).length) {
      appCacheData.count = this.groupCount;
      appCacheData.groupBy = this.groupBy;
    }
    const appCacheKey = this.mostRecentApplication || GLOBAL_CACHE_KEY;
    this.configViewStateCache.put(appCacheKey, appCacheData);
    if (appCacheKey !== GLOBAL_CACHE_KEY) {
      const globalCacheData = this.getCachedViewState(GLOBAL_CACHE_KEY);
      globalCacheData.showDurations = this.showDurations;
      this.configViewStateCache.put(GLOBAL_CACHE_KEY, globalCacheData);
    }
  }
}

const SECURITY_GROUP_FILTER_MODEL = "spinnaker.core.securityGroup.filter.model";
const filterModelConfig = [
  { model: "account", param: "acct", type: "trueKeyObject" },
  { model: "detail", param: "detail", type: "trueKeyObject" },
  { model: "filter", param: "q", clearValue: "", type: "string", filterLabel: "search" },
  { model: "providerType", type: "trueKeyObject", filterLabel: "provider" },
  { model: "region", param: "reg", type: "trueKeyObject" },
  { model: "showLoadBalancers", param: "hideLoadBalancers", displayOption: true, type: "inverse-boolean" },
  { model: "showServerGroups", param: "hideServerGroups", displayOption: true, type: "inverse-boolean" },
  { model: "stack", param: "stack", type: "trueKeyObject" }
];
class SecurityGroupFilterModel {
  constructor() {
    this.asFilterModel = FilterModelService.configureFilterModel(this, filterModelConfig);
    FilterModelService.registerRouterHooks(this.asFilterModel, "**.application.insight.firewalls.**");
    this.asFilterModel.activate();
  }
}
module(SECURITY_GROUP_FILTER_MODEL, []).service("securityGroupFilterModel", SecurityGroupFilterModel);

class SecurityGroupFilterService {
  constructor() {
    this.groupsUpdatedStream = new Subject();
  }
  addSearchFields(securityGroup) {
    if (!securityGroup.searchField) {
      securityGroup.searchField = [
        securityGroup.name,
        securityGroup.id,
        securityGroup.accountName,
        securityGroup.region,
        securityGroup.vpcName,
        securityGroup.vpcId,
        map$1(securityGroup.usages.serverGroups, "name").join(" "),
        map$1(securityGroup.usages.loadBalancers, "name").join(" ")
      ].join(" ");
    }
  }
  checkSearchTextFilter(securityGroup) {
    const filter = SecurityGroupState.filterModel.asFilterModel.sortFilter.filter;
    if (!filter) {
      return true;
    }
    if (filter.includes("vpc:")) {
      const [, vpcName] = /vpc:([\w-]*)/.exec(filter);
      return securityGroup.vpcName.toLowerCase() === vpcName.toLowerCase();
    }
    this.addSearchFields(securityGroup);
    return filter.split(" ").every((testWord) => {
      return securityGroup.searchField.includes(testWord);
    });
  }
  clearFilters() {
    SecurityGroupState.filterModel.asFilterModel.clearFilters();
    SecurityGroupState.filterModel.asFilterModel.applyParamsToUrl();
  }
  filterSecurityGroupsForDisplay(securityGroups) {
    const service = FilterModelService;
    const model = SecurityGroupState.filterModel.asFilterModel;
    return chain(securityGroups).filter((sg) => this.checkSearchTextFilter(sg)).filter((sg) => service.checkAccountFilters(model)(sg)).filter((sg) => service.checkRegionFilters(model)(sg)).filter((sg) => service.checkStackFilters(model)(sg)).filter((sg) => service.checkDetailFilters(model)(sg)).filter((sg) => service.checkProviderFilters(model)(sg)).value();
  }
  sortGroupsByHeading(groups) {
    const currentGroups = SecurityGroupState.filterModel.asFilterModel.groups;
    this.diffSubgroups(currentGroups, groups);
    currentGroups.sort((a, b) => {
      if (a.heading < b.heading) {
        return -1;
      }
      if (a.heading > b.heading) {
        return 1;
      }
      return 0;
    });
  }
  diffSubgroups(oldGroups, newGroups) {
    const groupsToRemove = [];
    oldGroups.forEach((oldGroup, idx) => {
      const newGroup = (newGroups || []).find((g) => g.heading === oldGroup.heading && g.vpcName === oldGroup.vpcName);
      if (!newGroup) {
        groupsToRemove.push(idx);
      } else {
        if (newGroup.securityGroup) {
          oldGroup.securityGroup = newGroup.securityGroup;
        }
        if (newGroup.subgroups) {
          this.diffSubgroups(oldGroup.subgroups, newGroup.subgroups);
        }
        if (oldGroup.hasOwnProperty("isManaged") || newGroup.hasOwnProperty("isManaged")) {
          oldGroup.isManaged = newGroup.isManaged;
          oldGroup.managedResourceSummary = newGroup.managedResourceSummary;
        }
      }
    });
    groupsToRemove.reverse().forEach((idx) => {
      oldGroups.splice(idx, 1);
    });
    newGroups.forEach((newGroup) => {
      const match = find(oldGroups, { heading: newGroup.heading });
      if (!match) {
        oldGroups.push(newGroup);
      }
    });
  }
  updateSecurityGroups(application) {
    if (!application) {
      application = this.lastApplication;
      if (!this.lastApplication) {
        return null;
      }
    }
    const groups = [];
    const securityGroups = this.filterSecurityGroupsForDisplay(application.securityGroups.data);
    const grouped = groupBy(securityGroups, "account");
    forOwn(grouped, (group, key) => {
      const subGroupings = groupBy(group, "name");
      const subGroups = [];
      forOwn(subGroupings, (subGroup, subKey) => {
        const subSubGroups = [];
        subGroup.forEach((securityGroup) => {
          const heading = securityGroup.vpcName ? `${securityGroup.region} (${securityGroup.vpcName})` : securityGroup.region;
          subSubGroups.push({
            heading,
            vpcName: securityGroup.vpcName,
            securityGroup,
            isManaged: !!securityGroup.isManaged,
            managedResourceSummary: securityGroup.managedResourceSummary
          });
        });
        const allRegionsManaged = subSubGroups.every(({ isManaged }) => isManaged);
        subGroups.push({
          heading: subKey,
          subgroups: sortBy(subSubGroups, ["heading", "vpcName"]),
          isManaged: allRegionsManaged,
          managedResourceSummary: allRegionsManaged ? subSubGroups[0].managedResourceSummary : void 0
        });
      });
      groups.push({ heading: key, subgroups: sortBy(subGroups, "heading") });
    });
    this.sortGroupsByHeading(groups);
    SecurityGroupState.filterModel.asFilterModel.addTags();
    this.lastApplication = application;
    this.groupsUpdatedStream.next(groups);
  }
}

const ClusterState = {};
const ExecutionState = {};
const LoadBalancerState = {};
const SecurityGroupState = {};
const FunctionState = {};
function initialize() {
  ClusterState.filterModel = new ClusterFilterModel();
  ClusterState.filterService = new ClusterFilterService();
  ClusterState.multiselectModel = new MultiselectModel();
  ExecutionState.filterModel = new ExecutionFilterModel();
  LoadBalancerState.filterModel = new LoadBalancerFilterModel();
  LoadBalancerState.filterService = new LoadBalancerFilterService();
  FunctionState.filterModel = new FunctionFilterModel();
  FunctionState.filterService = new FunctionFilterService();
  SecurityGroupState.filterModel = new SecurityGroupFilterModel();
  SecurityGroupState.filterService = new SecurityGroupFilterService();
  if (SETTINGS.checkForUpdates) {
    VersionChecker.initialize();
  }
}

var __defProp$v = Object.defineProperty;
var __getOwnPropDesc$v = Object.getOwnPropertyDescriptor;
var __decorateClass$v = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$v(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$v(target, key, result);
  return result;
};
const boundaries = [
  {
    name: "Today",
    after: () => DateTime.local().startOf("day").toMillis()
  },
  {
    name: "Yesterday",
    after: () => DateTime.local().startOf("day").minus(Duration.fromObject({ days: 1 })).toMillis()
  },
  {
    name: "This Week",
    after: () => DateTime.local().startOf("week").toMillis()
  },
  {
    name: "Last Week",
    after: () => DateTime.local().startOf("week").minus(Duration.fromObject({ weeks: 1 })).toMillis()
  },
  {
    name: "Last Month",
    after: () => DateTime.local().startOf("month").toMillis()
  },
  {
    name: "This Year",
    after: () => DateTime.local().startOf("year").toMillis()
  },
  { name: "Prior Years", after: () => 0 }
];
class ExecutionFilterService {
  static groupByTimeBoundary(executions) {
    return groupBy(executions, (execution) => boundaries.find((boundary) => (execution.startTime || execution.buildTime) > boundary.after()).name);
  }
  static updateExecutionGroups(application = this.lastApplication) {
    if (!application) {
      return null;
    }
    const executions = application.executions.data || [];
    executions.forEach((execution) => this.fixName(execution, application));
    const filtered = this.filterExecutionsForDisplay(application.executions.data, application);
    const groups = this.groupExecutions(filtered, application);
    this.applyGroupsToModel(groups);
    ExecutionState.filterModel.asFilterModel.addTags();
    this.lastApplication = application;
    this.groupsUpdatedStream.next(groups);
  }
  static doesPipelineMatchCheckedTags(config, checkedTags) {
    if (checkedTags.length === 0 || !config.tags || config.tags.length === 0) {
      return false;
    }
    const decoded = checkedTags.map((encoded) => encoded.split(":").map(decodeURIComponent)).map(([name, value]) => ({ name, value }));
    const grouped = groupBy(decoded, "name");
    const groups = Object.keys(grouped);
    return groups.every((group) => {
      const checkedValues = grouped[group].map((tag) => tag.value);
      const relevantValues = (config.tags || []).filter((tag) => tag.name === group).map((tag) => tag.value);
      return checkedValues.some((checkedValue) => relevantValues.includes(checkedValue));
    });
  }
  static tagsFilter(execution, application) {
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    if (this.isFilterable(sortFilter.tags)) {
      const checkedPipelines = application.pipelineConfigs.data.filter((config) => this.doesPipelineMatchCheckedTags(config, FilterModelService.getCheckValues(sortFilter.tags)));
      return includes(checkedPipelines.map((config) => config.id), execution.pipelineConfigId);
    } else {
      return true;
    }
  }
  static pipelineNameFilter(execution) {
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    if (this.isFilterable(sortFilter.pipeline)) {
      const checkedPipelineNames = FilterModelService.getCheckValues(sortFilter.pipeline);
      return includes(checkedPipelineNames, execution.name);
    } else {
      return true;
    }
  }
  static getValuesAsString(object, denylist = []) {
    if (typeof object === "string") {
      return object;
    }
    if (typeof object === "number") {
      return "" + object;
    }
    if (object instanceof Array) {
      return object.map((val) => this.getValuesAsString(val, denylist)).join(" ");
    }
    if (object instanceof Object) {
      return Object.keys(object).map((key) => {
        if (denylist.includes(key)) {
          return "";
        }
        return this.getValuesAsString(object[key], denylist);
      }).join(" ");
    }
    return "";
  }
  static addSearchText(execution) {
    if (execution.searchField) {
      return;
    }
    const searchText = [execution.name];
    searchText.push(execution.id);
    searchText.push(this.getValuesAsString(execution.trigger, ["parentExecution"]));
    execution.searchField = searchText.join(" ").toLowerCase();
  }
  static textFilter(execution) {
    const filter = ExecutionState.filterModel.asFilterModel.sortFilter.filter.toLowerCase();
    if (!filter) {
      return true;
    }
    this.addSearchText(execution);
    return execution.searchField.includes(filter);
  }
  static statusFilter(execution) {
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    if (this.isFilterable(sortFilter.status)) {
      const checkedStatus = FilterModelService.getCheckValues(sortFilter.status);
      return includes(checkedStatus, execution.status);
    } else {
      return true;
    }
  }
  static awaitingJudgementFilter(execution) {
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    if (sortFilter.awaitingJudgement) {
      return execution.stages.some(({ type, status }) => type === "manualJudgment" && status === "RUNNING");
    } else {
      return true;
    }
  }
  static filterExecutionsForDisplay(executions, application) {
    return chain(executions).filter((e) => this.textFilter(e)).filter((e) => this.tagsFilter(e, application)).filter((e) => this.pipelineNameFilter(e)).filter((e) => this.statusFilter(e)).filter((e) => this.awaitingJudgementFilter(e)).value();
  }
  static addEmptyPipelines(groups, application) {
    const configs = (application.pipelineConfigs.data || []).concat(application.strategyConfigs.data || []);
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    const groupNames = {};
    groups.forEach((g) => groupNames[g.heading] = true);
    let toAdd = [];
    if (!this.isFilterable(sortFilter.pipeline) && !this.isFilterable(sortFilter.status) && !sortFilter.filter && !this.isFilterable(sortFilter.tags)) {
      toAdd = configs.filter((config) => !groupNames[config.name]);
    } else {
      toAdd = configs.filter((config) => {
        const filterMatches = (sortFilter.filter || "").toLowerCase().includes(config.name.toLowerCase());
        const tagsMatch = this.doesPipelineMatchCheckedTags(config, FilterModelService.getCheckValues(sortFilter.tags));
        return !groupNames[config.name] && (sortFilter.pipeline[config.name] || filterMatches || tagsMatch);
      });
    }
    toAdd.forEach((config) => {
      groups.push({
        heading: config.name,
        config,
        executions: [],
        targetAccounts: this.extractAccounts(config),
        fromTemplate: config && config.type === "templatedPipeline" || false
      });
    });
  }
  static extractAccounts(config) {
    if (!config) {
      return [];
    }
    const configAccounts = [];
    (config.stages || []).forEach((stage) => {
      const stageConfig = Registry.pipeline.getStageConfig(stage);
      if (stageConfig && stageConfig.configAccountExtractor) {
        configAccounts.push(...stageConfig.configAccountExtractor(stage));
      }
    });
    return uniq(compact(configAccounts)).filter((a) => !a.includes("${"));
  }
  static fixName(execution, application) {
    const config = application.pipelineConfigs.data.find((p) => p.id === execution.pipelineConfigId);
    if (config) {
      execution.name = config.name;
    }
  }
  static groupExecutions(filteredExecutions, application) {
    const groups = [];
    let executions = [];
    forOwn(groupBy(filteredExecutions, "name"), (groupedExecutions) => {
      executions = executions.concat(groupedExecutions.sort((a, b) => this.executionSorter(a, b)));
    });
    executions.forEach((execution) => {
      const config = application.pipelineConfigs.data.find((p) => p.id === execution.pipelineConfigId);
      if (config != null && config.type === "templatedPipeline") {
        execution.fromTemplate = true;
      }
    });
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    if (sortFilter.groupBy === "name") {
      const executionGroups = groupBy(executions, "name");
      forOwn(executionGroups, (groupExecutions, key) => {
        var _a, _b;
        const matchId = (pipelineConfig) => pipelineConfig.id === groupExecutions[0].pipelineConfigId;
        const config = application.pipelineConfigs.data.concat((_b = (_a = application.strategyConfigs) == null ? void 0 : _a.data) != null ? _b : []).find(matchId);
        groupExecutions.sort((a, b) => this.executionSorter(a, b));
        groups.push({
          heading: key,
          config: config || null,
          executions: groupExecutions,
          runningExecutions: groupExecutions.filter((execution) => execution.isActive),
          targetAccounts: this.extractAccounts(config),
          fromTemplate: config && config.type === "templatedPipeline" || false
        });
      });
      this.addEmptyPipelines(groups, application);
    }
    if (sortFilter.groupBy === "timeBoundary") {
      const grouped = this.groupByTimeBoundary(executions);
      forOwn(grouped, (groupExecutions, key) => {
        groupExecutions.sort((a, b) => this.executionSorter(a, b));
        groups.push({
          heading: key,
          config: null,
          executions: groupExecutions,
          runningExecutions: groupExecutions.filter((execution) => execution.isActive)
        });
      });
    }
    if (sortFilter.groupBy === "none") {
      executions.sort((a, b) => this.executionSorter(a, b));
      groups.push({
        heading: "",
        executions,
        runningExecutions: []
      });
    }
    return groups;
  }
  static diffExecutionGroups(oldGroups, newGroups) {
    const diffedGroups = [];
    newGroups.forEach((newGroup) => {
      const oldGroup = oldGroups.find((g) => g.heading === newGroup.heading);
      if (!oldGroup) {
        diffedGroups.push(newGroup);
      } else {
        if (this.executionsAreDifferent(oldGroup, newGroup)) {
          diffedGroups.push(newGroup);
        } else {
          diffedGroups.push(oldGroup);
        }
      }
    });
    oldGroups.forEach((group) => group.executions.sort((a, b) => this.executionSorter(a, b)));
    return diffedGroups;
  }
  static executionsAreDifferent(oldGroup, newGroup) {
    let changeDetected = false;
    oldGroup.executions.forEach((execution) => {
      const newExecution = newGroup.executions.find((g) => g.id === execution.id);
      if (!newExecution) {
        changeDetected = true;
        $log.debug("execution no longer found, removing:", execution.id);
      } else {
        if (execution.stringVal !== newExecution.stringVal) {
          changeDetected = true;
          $log.debug("change detected, updating execution:", execution.id);
        }
      }
    });
    newGroup.executions.forEach((execution) => {
      const oldExecution = oldGroup.executions.find((g) => g.id === execution.id);
      if (!oldExecution) {
        changeDetected = true;
        $log.debug("new execution found, adding", execution.id);
        oldGroup.executions.push(execution);
      }
    });
    return changeDetected;
  }
  static applyGroupsToModel(groups) {
    const filterModel = ExecutionState.filterModel.asFilterModel;
    filterModel.groups = this.diffExecutionGroups(filterModel.groups, groups).sort((a, b) => this.executionGroupSorter(a, b));
  }
  static executionGroupSorter(a, b) {
    if (ExecutionState.filterModel.asFilterModel.sortFilter.groupBy === "timeBoundary") {
      return (b.executions[0].startTime || b.executions[0].buildTime) - (a.executions[0].startTime || a.executions[0].buildTime);
    }
    if (a.config && b.config) {
      if (a.config.strategy === b.config.strategy) {
        return a.config.index - b.config.index;
      }
      return a.config.strategy ? 1 : -1;
    }
    if (a.config) {
      return -1;
    }
    if (b.config) {
      return 1;
    }
    if (a.heading < b.heading) {
      return -1;
    }
    if (a.heading > b.heading) {
      return 1;
    }
    return 0;
  }
  static executionSorter(a, b) {
    if (a.isActive && b.isActive) {
      return b.startTime - a.startTime;
    }
    if (a.isActive) {
      return -1;
    }
    if (b.isActive) {
      return 1;
    }
    if (!a.endTime && !b.endTime) {
      return b.buildTime - a.buildTime;
    }
    if (!a.endTime) {
      return -1;
    }
    if (!b.endTime) {
      return 1;
    }
    return b.startTime - a.startTime;
  }
  static clearFilters() {
    ExecutionState.filterModel.asFilterModel.clearFilters();
    ExecutionState.filterModel.asFilterModel.applyParamsToUrl();
  }
}
ExecutionFilterService.groupsUpdatedStream = new Subject();
ExecutionFilterService.lastApplication = null;
ExecutionFilterService.isFilterable = FilterModelService.isFilterable;
__decorateClass$v([
  Debounce(25)
], ExecutionFilterService, "updateExecutionGroups", 1);

const retryablePromise = (closure, interval = 1e3, maxTries = 0) => {
  let currentTimeout;
  let currentTries = 0;
  const retryPromise = () => {
    currentTries++;
    if (maxTries === 0 || currentTries <= maxTries) {
      return closure().catch(() => {
        currentTimeout = $timeout(retryPromise, interval);
        return currentTimeout;
      });
    } else {
      return closure();
    }
  };
  const promise = retryPromise();
  const cancel = () => {
    if (currentTimeout) {
      $timeout.cancel(currentTimeout);
    }
  };
  return { promise, cancel };
};

class ExecutionService {
  constructor($q, $state, $timeout) {
    this.$q = $q;
    this.$state = $state;
    this.$timeout = $timeout;
    this.runningLimit = SETTINGS.maxRunningExecutionsToRetrieve || 30;
    this.ignoredStringValFields = [
      "asg",
      "commits",
      "history",
      "hydrator",
      "hydrated",
      "instances",
      "requisiteIds",
      "requisiteStageRefIds",
      "$$hashKey"
    ];
  }
  get activeStatuses() {
    return ["RUNNING", "SUSPENDED", "PAUSED", "NOT_STARTED"];
  }
  getRunningExecutions(applicationName) {
    return this.getFilteredExecutions(applicationName, this.activeStatuses, this.runningLimit, null, true);
  }
  getFilteredExecutions(applicationName, statuses, limit, pipelineConfigIds = null, expand = false) {
    const statusString = statuses.map((status) => status.toUpperCase()).join(",") || null;
    const call = pipelineConfigIds ? REST("/executions").query({ limit, pipelineConfigIds, statuses }).get() : REST("/applications").path(applicationName, "pipelines").query({ limit, statuses: statusString, pipelineConfigIds, expand }).get();
    return call.then((data) => {
      if (data) {
        data.forEach((execution) => {
          execution.hydrated = expand;
          return this.cleanExecutionForDiffing(execution);
        });
        return data;
      }
      return [];
    });
  }
  getExecutions(applicationName, application = null, expand = false) {
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    const tags = FilterModelService.getCheckValues(sortFilter.tags);
    const pipelines = Object.keys(sortFilter.pipeline);
    const statuses = Object.keys(pickBy(sortFilter.status || {}, identity));
    const limit = sortFilter.count;
    if (application && (pipelines.length || tags.length)) {
      return this.getConfigIdsFromFilterModel(application).then((pipelineConfigIds) => {
        return this.getFilteredExecutions(application.name, statuses, limit, pipelineConfigIds, expand);
      });
    }
    return this.getFilteredExecutions(applicationName, statuses, limit, null, expand);
  }
  getExecution(executionId, pipelineConfigs = []) {
    return REST("/pipelines").path(executionId).get().then((execution) => {
      const { application, name } = execution;
      execution.hydrated = true;
      this.cleanExecutionForDiffing(execution);
      if (application && name) {
        const cached = pipelineConfigs.find((config) => config.id === execution.pipelineConfigId);
        if (cached) {
          execution.pipelineConfig = cached;
          return Promise.resolve(execution);
        }
        return REST("/applications").path(application, "pipelineConfigs", name).get().then((pipelineConfig) => {
          execution.pipelineConfig = pipelineConfig;
          return execution;
        }).catch(() => execution);
      }
      return execution;
    });
  }
  transformExecutions(application, executions, currentData = []) {
    if (!executions || !executions.length) {
      return;
    }
    executions.forEach((execution) => {
      const stringVal = this.stringifyExecution(execution);
      const match = currentData.find((test) => test.id === execution.id);
      if (!match || !match.stringVal || match.stringVal !== stringVal) {
        execution.stringVal = stringVal;
        ExecutionsTransformer.transformExecution(application, execution);
      }
    });
  }
  getConfigIdsFromFilterModel(application) {
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    const tags = FilterModelService.getCheckValues(sortFilter.tags);
    const pipelines = Object.keys(sortFilter.pipeline);
    application.pipelineConfigs.activate();
    return application.pipelineConfigs.ready().then(() => {
      const data = application.pipelineConfigs.data.concat(application.strategyConfigs.data);
      const configIdsFromCheckedPipelines = pipelines.map((p) => {
        const match = data.find((c) => c.name === p);
        return match ? match.id : null;
      }).filter((id) => !!id);
      const configIdsFromCheckedTags = data.filter((p) => ExecutionFilterService.doesPipelineMatchCheckedTags(p, tags)).map((p) => p.id);
      return configIdsFromCheckedPipelines.concat(uniq(configIdsFromCheckedTags));
    });
  }
  cleanExecutionForDiffing(execution) {
    (execution.stages || []).forEach((stage) => this.removeInstances(stage));
  }
  toggleDetails(execution, stageIndex, subIndex) {
    const standalone = this.$state.current.name.endsWith(".executionDetails.execution");
    if (execution.id === this.$state.params.executionId && this.$state.current.name.includes(".execution") && stageIndex === void 0) {
      this.$state.go("^");
      return;
    }
    const index = stageIndex || 0;
    let stageSummary = get(execution, ["stageSummaries", index]);
    if (stageSummary && stageSummary.type === "group") {
      if (subIndex === void 0) {
        return;
      }
      stageSummary = get(stageSummary, ["groupStages", subIndex]);
    }
    stageSummary = stageSummary || { firstActiveStage: 0 };
    const params = {
      executionId: execution.id,
      stage: index,
      subStage: subIndex,
      step: stageSummary.firstActiveStage
    };
    if (subIndex === void 0 && stageSummary.type === "group") {
      params.stage = null;
      params.step = null;
      return;
    }
    if (this.$state.includes("**.execution", params)) {
      if (!standalone) {
        this.$state.go("^");
      }
    } else {
      if (this.$state.current.name.endsWith(".execution") || standalone) {
        this.$state.go(".", params);
      } else {
        this.$state.go(".execution", params);
      }
    }
  }
  removeInstances(stage) {
    if (stage.context) {
      delete stage.context.instances;
      delete stage.context.asg;
      if (stage.context.targetReferences) {
        stage.context.targetReferences.forEach((targetReference) => {
          delete targetReference.instances;
          delete targetReference.asg;
        });
      }
    }
  }
  startAndMonitorPipeline(app, pipeline, trigger) {
    const { executionService } = ReactInjector;
    return PipelineConfigService.triggerPipeline(app.name, pipeline, trigger).then((triggerResult) => executionService.waitUntilTriggeredPipelineAppears(app, triggerResult));
  }
  waitUntilTriggeredPipelineAppears(application, triggeredPipelineId) {
    const closure = () => this.getExecution(triggeredPipelineId).then(() => application.executions.refresh());
    return retryablePromise(closure, 1e3, 10);
  }
  waitUntilPipelineIsCancelled(application, executionId) {
    return this.waitUntilExecutionMatches(executionId, (execution) => execution.status === "CANCELED").then(() => application.executions.refresh());
  }
  waitUntilPipelineIsDeleted(application, executionId) {
    const deferred = this.$q.defer();
    this.getExecution(executionId).then(() => this.$timeout(() => this.waitUntilPipelineIsDeleted(application, executionId).then(deferred.resolve), 1e3), () => deferred.resolve());
    deferred.promise.then(() => application.executions.refresh());
    return deferred.promise;
  }
  cancelExecution(application, executionId, force, reason) {
    return REST("/pipelines").path(executionId, "cancel").query({ force, reason }).put().then(() => this.waitUntilPipelineIsCancelled(application, executionId)).catch((exception) => {
      throw exception && exception.data ? exception.message : null;
    });
  }
  pauseExecution(application, executionId) {
    return REST("/pipelines").path(executionId, "pause").put().then(() => this.waitUntilExecutionMatches(executionId, (execution) => execution.status === "PAUSED")).then(() => application.executions.refresh()).catch((exception) => {
      throw exception && exception.data ? exception.message : null;
    });
  }
  resumeExecution(application, executionId) {
    return REST("/pipelines").path(executionId, "resume").put().then(() => this.waitUntilExecutionMatches(executionId, (execution) => execution.status === "RUNNING")).then(() => application.executions.refresh()).catch((exception) => {
      throw exception && exception.data ? exception.message : null;
    });
  }
  deleteExecution(application, executionId) {
    const promiseLike = REST("/pipelines").path(executionId).delete().then(() => this.waitUntilPipelineIsDeleted(application, executionId)).then(() => application.executions.refresh()).catch((exception) => {
      throw exception && exception.data ? exception.message : null;
    });
    return promiseLike;
  }
  waitUntilExecutionMatches(executionId, matchPredicate) {
    return this.getExecution(executionId).then((execution) => {
      if (matchPredicate(execution)) {
        return execution;
      }
      return this.$timeout(() => this.waitUntilExecutionMatches(executionId, matchPredicate), 1e3);
    });
  }
  getSectionCacheKey(groupBy, application, heading) {
    return ["pipeline", groupBy, application, heading].join("#");
  }
  getProjectExecutions(project, limit = 1) {
    return REST("/projects").path(project, "pipelines").query({ limit }).get().then((executions) => {
      if (!executions || !executions.length) {
        return [];
      }
      executions.forEach((execution) => ExecutionsTransformer.transformExecution({}, execution));
      return executions.sort((a, b) => b.startTime - (a.startTime || Date.now()));
    });
  }
  addExecutionsToApplication(application, executions = []) {
    if (application.executions.data && application.executions.data.length && executions.length) {
      const existingData = application.executions.data;
      const runningData = application.runningExecutions.data;
      const toRemove = [];
      existingData.forEach((execution, idx) => {
        const match = executions.find((test) => test.id === execution.id);
        const runningMatch = runningData.find((t) => t.id === execution.id);
        if (match) {
          if (execution.stringVal && match.stringVal && execution.stringVal !== match.stringVal) {
            if (execution.status !== match.status) {
              application.executions.data[idx] = match;
            } else {
              if (execution.hydrated === match.hydrated) {
                application.executions.data[idx] = match;
              }
            }
          }
        }
        if (!match && !runningMatch) {
          toRemove.push(idx);
        }
      });
      toRemove.reverse().forEach((idx) => existingData.splice(idx, 1));
      executions.forEach((execution) => {
        if (!existingData.filter((test) => test.id === execution.id).length) {
          existingData.push(execution);
        }
      });
      return [...existingData];
    } else {
      return executions;
    }
  }
  mergeRunningExecutionsIntoExecutions(application) {
    let updated = false;
    application.runningExecutions.data.forEach((re) => {
      const match = application.executions.data.findIndex((e) => e.id === re.id);
      if (match !== -1) {
        const oldKey = application.executions.data[match].stringVal;
        if (re.stringVal !== oldKey) {
          updated = true;
          application.executions.data[match] = re;
        }
      } else {
        updated = true;
        application.executions.data.push(re);
      }
    });
    application.executions.data.forEach((execution) => {
      var _a;
      if (execution.isActive && application.runningExecutions.data.every((e) => e.id !== execution.id)) {
        this.getExecution(execution.id, (_a = application.pipelineConfigs) == null ? void 0 : _a.data).then((updatedExecution) => {
          this.updateExecution(application, updatedExecution);
        });
      }
    });
    if (updated && !application.executions.reloadingForFilters) {
      application.executions.dataUpdated();
    }
  }
  removeCompletedExecutionsFromRunningData(application) {
    const data = application.executions.data;
    const runningData = application.runningExecutions.data;
    data.forEach((e) => {
      const match = runningData.findIndex((re) => e.id === re.id);
      if (match !== -1 && !e.isActive) {
        runningData.splice(match, 1);
      }
    });
    application.runningExecutions.dataUpdated();
  }
  updateExecution(application, updatedExecution, dataSource = application.executions) {
    if (dataSource.data && dataSource.data.length) {
      dataSource.data.forEach((currentExecution, idx) => {
        if (updatedExecution.id === currentExecution.id) {
          updatedExecution.stringVal = this.stringifyExecution(updatedExecution);
          if (updatedExecution.status !== currentExecution.status || currentExecution.stringVal !== updatedExecution.stringVal) {
            ExecutionsTransformer.transformExecution(application, updatedExecution);
            dataSource.data[idx] = updatedExecution;
            dataSource.dataUpdated();
          }
        }
      });
    }
  }
  hydrate(application, unhydrated) {
    if (unhydrated.hydrator) {
      return unhydrated.hydrator;
    }
    if (unhydrated.hydrated) {
      return Promise.resolve(unhydrated);
    }
    const executionHydrator = this.getExecution(unhydrated.id).then((hydrated) => {
      ExecutionsTransformer.transformExecution(application, hydrated);
      unhydrated.stages.forEach((s, i) => {
        const hydratedStage = hydrated.stages.length === unhydrated.stages.length && hydrated.stages[i].id === s.id ? hydrated.stages[i] : hydrated.stages.find((s2) => s.id === s2.id);
        if (hydratedStage) {
          s.context = hydratedStage.context;
          s.outputs = hydratedStage.outputs;
          s.tasks = hydratedStage.tasks;
        }
      });
      unhydrated.hydrated = true;
      unhydrated.graphStatusHash = hydrated.graphStatusHash;
      unhydrated.stageSummaries = hydrated.stageSummaries;
      return unhydrated;
    });
    unhydrated.hydrator = Promise.resolve(executionHydrator);
    return unhydrated.hydrator;
  }
  getLastExecutionForApplicationByConfigId(appName, configId) {
    return this.getFilteredExecutions(appName, [], 1).then((executions) => {
      return executions.filter((execution) => {
        return execution.pipelineConfigId === configId;
      });
    }).then((executionsByConfigId) => {
      return executionsByConfigId[0];
    });
  }
  getExecutionsForConfigIds(pipelineConfigIds, options = {}) {
    const { limit, statuses, transform, application } = options;
    return REST("/executions").query({ limit, pipelineConfigIds: (pipelineConfigIds || []).join(","), statuses }).get().then((data) => {
      if (data) {
        if (transform && application) {
          data.forEach((execution) => ExecutionsTransformer.transformExecution(application, execution));
        }
        return data.sort((a, b) => (b.buildTime || 0) - (a.buildTime || 0));
      }
      return [];
    }).catch(() => []);
  }
  patchExecution(executionId, stageId, data) {
    return REST("/pipelines").path(executionId, "stages", stageId).patch(data);
  }
  stringifyExecution(execution) {
    const transient = { ...execution };
    transient.stages = transient.stages.filter((s) => s.status !== "SUCCEEDED" && s.status !== "NOT_STARTED");
    return this.stringify(transient);
  }
  stringify(object) {
    return JsonUtils.makeSortedStringFromAngularObject({ ...object }, this.ignoredStringValFields);
  }
}
const EXECUTION_SERVICE = "spinnaker.core.pipeline.executions.service";
module(EXECUTION_SERVICE, [UIROUTER_ANGULARJS]).factory("executionService", [
  "$q",
  "$state",
  "$timeout",
  ($q, $state, $timeout) => new ExecutionService($q, $state, $timeout)
]);
DebugWindow.addInjectable("executionService");

var css_248z$25 = "a.spelLink {\n  margin-left: 10px;\n  -webkit-animation: fadein 1s;\n          animation: fadein 1s;\n}\n@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\ninput.borderless,\n.borderless select {\n  border: none;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.button-input {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border: 1px var(--color-alto) solid;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  background: var(--color-white);\n}\n.button-input .input {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n}\n.button-input.invalid {\n  border-color: var(--color-danger);\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px var(--color-danger-light);\n}\n.button-input.focus {\n  border-color: var(--color-accent);\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n.button-input .input select,\n.button-input input {\n  flex-grow: 1;\n}\n.button-input.number {\n  width: 245px;\n}\n.button-input:focus {\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n.button-input .btn-group {\n  margin-left: 5px;\n}\n.button-input .btn-group button.active {\n  font-weight: 700;\n}\n.button-input .btn-group button:focus {\n  outline: none;\n}\n.button-input .form-control:focus {\n  box-shadow: none;\n}\n.button-input .select2-container .select2-choice,\n.button-input .select2-dropdown-open .select2-choice,\n.button-input .select2-container-active {\n  border: none;\n  background-image: none;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\nspan.marker {\n  display: inline;\n  padding: 0.2em 0.6em 0.3em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: var(--color-white);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25em;\n}\nspan.marker.param {\n  background-color: var(--color-alert);\n  color: var(--color-dovegray);\n}\nspan.marker.stage {\n  background-color: var(--color-accessory-light);\n  color: var(--color-mineshaft);\n}\nspan.marker.function {\n  background-color: var(--color-accent-g1);\n  color: var(--color-primary);\n}\nspan.marker.value {\n  background-color: var(--color-accent-g1);\n  color: var(--color-primary);\n}\nspan.marker.param:before {\n  content: 'p';\n}\nspan.marker.stage:before {\n  content: 'stage';\n}\nspan.marker.function:before {\n  content: 'fn';\n}\n.spel-dropdown {\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.spel-value-separator {\n  font-size: 70%;\n  color: var(--color-primary);\n}\n.textcomplete-item.active .spel-value-separator {\n  color: var(--color-white);\n}\n.monospace {\n  font-family: monospace;\n}\n";
styleInject(css_248z$25);

class SpelText extends React__default.Component {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.onChange = (e) => {
      this.props.onChange(e.target.value);
    };
    this.state = { textcompleteConfig: [] };
    this.autocompleteService = new SpelAutocompleteService($q, new ExecutionService($q, {}, $timeout));
    from(this.autocompleteService.addPipelineInfo(this.props.pipeline)).pipe(takeUntil(this.destroy$)).subscribe((textcompleteConfig) => {
      this.setState({ textcompleteConfig });
    });
    this.spelInputRef = React__default.createRef();
  }
  componentWillUnmount() {
    this.$input.off("change", this.onChange);
    this.destroy$.next();
  }
  componentDidMount() {
    this.$input = $$1(this.spelInputRef.current);
    this.renderSuggestions();
    this.$input.on("change", this.onChange);
  }
  componentDidUpdate(_, prevState) {
    if (prevState.textcompleteConfig !== this.state.textcompleteConfig) {
      this.renderSuggestions();
    }
  }
  renderSuggestions() {
    this.$input.attr("contenteditable", "true");
    this.$input.textcomplete(this.state.textcompleteConfig, {
      maxCount: 1e3,
      zIndex: 9e3,
      dropdownClassName: "dropdown-menu textcomplete-dropdown spel-dropdown"
    });
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      placeholder: this.props.placeholder,
      className: classNames({
        "form-control": true,
        "no-doc-link": !this.props.docLink
      }),
      value: this.props.value || "",
      onChange: this.onChange,
      ref: this.spelInputRef
    });
  }
}
SpelText.defaultProps = {
  placeholder: ""
};

const singleFieldArtifactEditor = (fieldKey, type, label, placeholder, helpTextKey) => {
  return class extends ArtifactEditor$1 {
    constructor(props) {
      super(props, type);
    }
    render() {
      return /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label,
        helpKey: helpTextKey
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder,
        value: this.props.artifact[fieldKey] || "",
        onChange: (value) => {
          const clone = cloneDeep(this.props.artifact);
          clone[fieldKey] = value;
          clone.type = type;
          this.props.onChange(clone);
        },
        pipeline: this.props.pipeline,
        docLink: true
      }));
    }
  };
};

const BASE_64_ARTIFACT_TYPE = "embedded/base64";
const BASE_64_ARTIFACT_ACCOUNT = "embedded-artifact";
const _DefaultBase64ArtifactEditor = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.convert = (fn, str) => {
      if (!str || str.length === 0) {
        return [str, ""];
      }
      try {
        const converted = fn(str);
        return [converted, ""];
      } catch (e) {
        if (has(_DefaultBase64ArtifactEditor.DOMBase64Errors, e.code)) {
          return ["", _DefaultBase64ArtifactEditor.DOMBase64Errors[e.code]];
        } else {
          return ["", e.message];
        }
      }
    };
    this.onNameChanged = (name) => {
      const artifact = cloneDeep(this.props.artifact);
      artifact.name = name;
      this.props.onChange(artifact);
    };
    this.onContentChanged = (event) => {
      const [encoded, encodeDecodeError] = this.convert(btoa, event.target.value);
      if (!encodeDecodeError) {
        const artifact = cloneDeep(this.props.artifact);
        artifact.reference = encoded;
        this.props.onChange(artifact);
      }
      this.setState({
        decoded: event.target.value,
        encodeDecodeError
      });
    };
    if (props.artifact.type !== BASE_64_ARTIFACT_TYPE) {
      const clonedArtifact = cloneDeep(props.artifact);
      clonedArtifact.type = BASE_64_ARTIFACT_TYPE;
      props.onChange(clonedArtifact);
    }
    const [decoded, encodeDecodeError] = this.convert(atob, props.artifact.reference);
    this.state = { decoded, encodeDecodeError };
  }
  render() {
    const { pipeline } = this.props;
    const { name, reference } = this.props.artifact;
    const { decoded, encodeDecodeError } = this.state;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Name"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "base64-artifact",
      value: name,
      pipeline,
      onChange: this.onNameChanged,
      docLink: false
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Contents"
    }, /* @__PURE__ */ React__default.createElement("textarea", {
      autoCapitalize: "none",
      autoComplete: "off",
      rows: 16,
      className: "form-control code",
      value: decoded,
      onChange: this.onContentChanged
    }), /* @__PURE__ */ React__default.createElement(CopyToClipboard, {
      text: reference,
      toolTip: "Copy base64-encoded content to clipboard",
      analyticsLabel: "Copy Base64 Artifact Content"
    })), encodeDecodeError && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 error-message"
    }, "Error encoding/decoding artifact content: ", encodeDecodeError)));
  }
};
let DefaultBase64ArtifactEditor = _DefaultBase64ArtifactEditor;
DefaultBase64ArtifactEditor.DOMBase64Errors = {
  5: "The string to encode contains characters outside the latin1 range."
};
const Base64Match = {
  label: "Base64",
  typePattern: ArtifactTypePatterns.EMBEDDED_BASE64,
  type: BASE_64_ARTIFACT_TYPE,
  description: "An artifact that includes its referenced resource as part of its payload.",
  key: "base64",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("name", BASE_64_ARTIFACT_TYPE, "Name", "base64-artifact", "")
};
const Base64Default = {
  label: "Base64",
  typePattern: ArtifactTypePatterns.EMBEDDED_BASE64,
  type: BASE_64_ARTIFACT_TYPE,
  description: "An artifact that includes its referenced resource as part of its payload.",
  key: "default.base64",
  isDefault: true,
  isMatch: false,
  editCmp: DefaultBase64ArtifactEditor
};

const TYPE$8 = "bitbucket/file";
const BitbucketMatch = {
  label: "Bitbucket",
  typePattern: ArtifactTypePatterns.BITBUCKET_FILE,
  type: TYPE$8,
  description: "A file stored in git, hosted by Bitbucket.",
  key: "bitbucket",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("name", TYPE$8, "File path", "manifests/frontend.yaml", "pipeline.config.expectedArtifact.git.name")
};
const BitbucketDefault = {
  label: "Bitbucket",
  typePattern: ArtifactTypePatterns.BITBUCKET_FILE,
  type: TYPE$8,
  description: "A file stored in git, hosted by Bitbucket.",
  key: "default.bitbucket",
  isDefault: true,
  isMatch: false,
  editCmp: class extends ArtifactEditor$1 {
    constructor(props) {
      super(props, TYPE$8);
      this.onReferenceChanged = (reference) => {
        const clonedArtifact = cloneDeep(this.props.artifact);
        clonedArtifact.reference = reference;
        this.props.onChange(clonedArtifact);
      };
      this.onFilePathChanged = (name) => {
        const clonedArtifact = cloneDeep(this.props.artifact);
        clonedArtifact.name = name;
        this.props.onChange(clonedArtifact);
      };
    }
    render() {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Object path",
        helpKey: "pipeline.config.expectedArtifact.defaultBitbucket.reference"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "https://api.bitbucket.com/rest/api/1.0/$PROJECTS/$PROJECTKEY/repos/$REPONAME/raw/$FILEPATH",
        value: this.props.artifact.reference,
        onChange: this.onReferenceChanged,
        pipeline: this.props.pipeline,
        docLink: true
      })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "File Path",
        helpKey: "pipeline.config.expectedArtifact.defaultBitbucket.filepath"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "path/to/file.yml",
        onChange: this.onFilePathChanged,
        value: this.props.artifact.name,
        pipeline: this.props.pipeline,
        docLink: true
      })));
    }
  }
};

const TYPE$7 = "custom/object";
const CUSTOM_ARTIFACT_ACCOUNT = "custom-artifact";
class CustomArtifactEditor extends ArtifactEditor$1 {
  constructor(props) {
    super(props, TYPE$7);
    this.onTypeChanged = (type) => {
      this.updateArtifact({ type });
    };
    this.onNameChanged = (name) => {
      this.updateArtifact({ name });
    };
    this.onVersionChanged = (version) => {
      this.updateArtifact({ version });
    };
    this.onLocationChanged = (location) => {
      this.updateArtifact({ location });
    };
    this.onReferenceChanged = (reference) => {
      this.updateArtifact({ reference });
    };
    this.updateArtifact = (changes) => {
      const clonedArtifact = cloneDeep(this.props.artifact);
      extend(clonedArtifact, changes);
      this.props.onChange(clonedArtifact);
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Type"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "",
      value: this.props.artifact.type,
      onChange: this.onTypeChanged,
      pipeline: this.props.pipeline,
      docLink: true
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Name"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "",
      value: this.props.artifact.name,
      onChange: this.onNameChanged,
      pipeline: this.props.pipeline,
      docLink: true
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Version"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "",
      value: this.props.artifact.version,
      onChange: this.onVersionChanged,
      pipeline: this.props.pipeline,
      docLink: true
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Location"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "",
      value: this.props.artifact.location,
      onChange: this.onLocationChanged,
      pipeline: this.props.pipeline,
      docLink: true
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Reference"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "",
      value: this.props.artifact.reference,
      onChange: this.onReferenceChanged,
      pipeline: this.props.pipeline,
      docLink: true
    })));
  }
}
const CustomMatch = {
  label: "Custom",
  typePattern: ArtifactTypePatterns.CUSTOM_OBJECT,
  type: TYPE$7,
  description: "A custom-defined artifact.",
  key: "custom",
  isDefault: false,
  isMatch: true,
  editCmp: CustomArtifactEditor
};
const CustomDefault = {
  label: "Custom",
  typePattern: ArtifactTypePatterns.CUSTOM_OBJECT,
  type: TYPE$7,
  description: "A custom-defined artifact.",
  key: "default.custom",
  isDefault: true,
  isMatch: false,
  editCmp: CustomArtifactEditor
};

const TYPE$6 = "docker/image";
const setNameAndVersionFromReference = (artifact) => {
  const ref = artifact.reference;
  if (isNil(ref)) {
    return artifact;
  }
  const atIndex = ref.indexOf("@");
  const lastColonIndex = ref.lastIndexOf(":");
  if (atIndex >= 0) {
    const split = ref.split("@");
    artifact.name = split[0];
    artifact.version = split[1];
  } else if (lastColonIndex > 0) {
    artifact.name = ref.substring(0, lastColonIndex);
    artifact.version = ref.substring(lastColonIndex + 1);
  } else {
    artifact.name = ref;
  }
  return artifact;
};
const DockerMatch = {
  label: "Docker",
  typePattern: ArtifactTypePatterns.DOCKER_IMAGE,
  type: TYPE$6,
  isDefault: false,
  isMatch: true,
  description: "A Docker image to be deployed.",
  key: "docker",
  editCmp: singleFieldArtifactEditor("name", TYPE$6, "Docker image", "gcr.io/project/image", "pipeline.config.expectedArtifact.docker.name")
};
const DockerDefault = {
  label: "Docker",
  typePattern: ArtifactTypePatterns.DOCKER_IMAGE,
  type: TYPE$6,
  isDefault: true,
  isMatch: false,
  description: "A Docker image to be deployed.",
  key: "default.docker",
  editCmp: class extends ArtifactEditor$1 {
    constructor(props) {
      super(props, TYPE$6);
      this.onReferenceChanged = (reference) => {
        const clonedArtifact = cloneDeep(this.props.artifact);
        clonedArtifact.reference = reference;
        this.props.onChange(setNameAndVersionFromReference(clonedArtifact));
      };
    }
    render() {
      return /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Object path",
        helpKey: "pipeline.config.expectedArtifact.defaultDocker.reference"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "gcr.io/project/image@sha256:9efcc2818c9...",
        value: this.props.artifact.reference,
        onChange: this.onReferenceChanged,
        pipeline: this.props.pipeline,
        docLink: true
      }));
    }
  }
};

const TYPE$5 = "gcs/object";
const GcsMatch = {
  label: "GCS",
  typePattern: ArtifactTypePatterns.GCS_OBJECT,
  type: TYPE$5,
  description: "A GCS object.",
  key: "gcs",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("name", TYPE$5, "Object path", "gs://bucket/path/to/file", "pipeline.config.expectedArtifact.gcs.name")
};
const GcsDefault = {
  label: "GCS",
  typePattern: ArtifactTypePatterns.GCS_OBJECT,
  type: TYPE$5,
  description: "A GCS object.",
  key: "default.gcs",
  isDefault: true,
  isMatch: false,
  editCmp: class extends ArtifactEditor$1 {
    constructor(props) {
      super(props, TYPE$5);
      this.onReferenceChange = (reference) => {
        if (isNil(reference)) {
          return;
        }
        const clonedArtifact = cloneDeep(this.props.artifact);
        clonedArtifact.reference = reference;
        if (reference.indexOf("#") >= 0) {
          const split = reference.split("#");
          clonedArtifact.name = split[0];
          clonedArtifact.version = split[1];
        } else {
          clonedArtifact.name = reference;
        }
        this.props.onChange(clonedArtifact);
      };
    }
    render() {
      return /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Object path",
        helpKey: "pipeline.config.expectedArtifact.defaultGcs.reference"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "gs://bucket/path/to/file",
        value: this.props.artifact.reference,
        onChange: this.onReferenceChange,
        pipeline: this.props.pipeline,
        docLink: true
      }));
    }
  }
};

const TYPE$4 = "github/file";
const GithubMatch = {
  label: "GitHub",
  description: "A file stored in git, hosted by GitHub.",
  key: "github",
  typePattern: ArtifactTypePatterns.GITHUB_FILE,
  type: TYPE$4,
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("name", TYPE$4, "File path", "manifests/frontend.yaml", "pipeline.config.expectedArtifact.git.name")
};
const GithubDefault = {
  label: "GitHub",
  typePattern: ArtifactTypePatterns.GITHUB_FILE,
  type: TYPE$4,
  description: "A file stored in git, hosted by GitHub.",
  key: "default.github",
  isDefault: true,
  isMatch: false,
  editCmp: class extends ArtifactEditor$1 {
    constructor(props) {
      super(props, TYPE$4);
      this.pathRegex = new RegExp("/repos/[^/]*/[^/]*/contents/(.*)$");
      this.onReferenceChange = (reference) => {
        const results = this.pathRegex.exec(reference);
        const clonedArtifact = cloneDeep(this.props.artifact);
        if (results !== null) {
          clonedArtifact.name = results[1];
          clonedArtifact.reference = reference;
        } else {
          clonedArtifact.name = reference;
          clonedArtifact.reference = reference;
        }
        this.props.onChange(clonedArtifact);
      };
    }
    render() {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Content URL",
        helpKey: "pipeline.config.expectedArtifact.defaultGithub.reference"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "https://api.github.com/repos/$ORG/$REPO/contents/$FILEPATH",
        value: this.props.artifact.reference,
        onChange: this.onReferenceChange,
        pipeline: this.props.pipeline,
        docLink: false
      })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Commit/Branch",
        helpKey: "pipeline.config.expectedArtifact.defaultGithub.version"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "master",
        value: this.props.artifact.version,
        onChange: this.onVersionChange,
        pipeline: this.props.pipeline,
        docLink: false
      })));
    }
  }
};

const TYPE$3 = "gitlab/file";
const GitlabMatch = {
  label: "Gitlab",
  typePattern: ArtifactTypePatterns.GITLAB_FILE,
  type: TYPE$3,
  description: "A file stored in git, hosted by Gitlab.",
  key: "gitlab",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("name", TYPE$3, "File path", "manifests/frontend.yaml", "pipeline.config.expectedArtifact.git.name")
};
const GitlabDefault = {
  label: "Gitlab",
  typePattern: ArtifactTypePatterns.GITLAB_FILE,
  type: TYPE$3,
  description: "A file stored in git, hosted by Gitlab.",
  key: "default.gitlab",
  isDefault: true,
  isMatch: false,
  editCmp: class extends ArtifactEditor$1 {
    constructor(props) {
      super(props, TYPE$3);
      this.pathRegex = new RegExp("/repos/[^/]*/[^/]*/contents/(.*)$");
      this.onReferenceChange = (reference) => {
        const results = this.pathRegex.exec(reference);
        const clonedArtifact = cloneDeep(this.props.artifact);
        if (results !== null) {
          clonedArtifact.name = results[1];
          clonedArtifact.reference = reference;
        } else {
          clonedArtifact.name = reference;
          clonedArtifact.reference = reference;
        }
        this.props.onChange(clonedArtifact);
      };
    }
    render() {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Content URL",
        helpKey: "pipeline.config.expectedArtifact.defaultGitlab.reference"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "https://gitlab.com/api/v4/projects/$ORG%2F$REPO/repository/files/path%2Fto%2Ffile.yml/raw",
        value: this.props.artifact.reference,
        onChange: this.onReferenceChange,
        pipeline: this.props.pipeline,
        docLink: false
      })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Commit/Branch",
        helpKey: "pipeline.config.expectedArtifact.defaultGitlab.version"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "master",
        value: this.props.artifact.version,
        onChange: this.onVersionChange,
        pipeline: this.props.pipeline,
        docLink: false
      })));
    }
  }
};

const TYPE$2 = "git/repo";
class GitRepoArtifactEditor extends React__default.Component {
  constructor(props) {
    super(props);
    this.onIncludesSubPathChange = (event) => {
      this.setState({ includesSubPath: event.target.checked });
    };
    this.onReferenceChanged = (reference) => {
      const clonedArtifact = cloneDeep(this.props.artifact);
      clonedArtifact.reference = reference;
      this.props.onChange(clonedArtifact);
    };
    this.onVersionChanged = (version) => {
      const clonedArtifact = cloneDeep(this.props.artifact);
      clonedArtifact.version = version;
      this.props.onChange(clonedArtifact);
    };
    this.onSubPathChanged = (subPath) => {
      const clonedArtifact = cloneDeep(this.props.artifact);
      clonedArtifact.location = subPath;
      this.props.onChange(clonedArtifact);
    };
    var _a, _b;
    const { artifact } = this.props;
    this.state = {
      includesSubPath: ((_b = artifact.location) != null ? _b : (_a = artifact.metadata) == null ? void 0 : _a.subPath) !== void 0
    };
  }
  render() {
    var _a, _b;
    const { artifact } = this.props;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "URL",
      helpKey: "pipeline.config.expectedArtifact.gitrepo.url"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "https or ssh to your git repo",
      value: artifact.reference,
      onChange: this.onReferenceChanged,
      pipeline: this.props.pipeline,
      docLink: true
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Branch",
      helpKey: "pipeline.config.expectedArtifact.gitrepo.branch"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "master",
      value: artifact.version,
      onChange: this.onVersionChanged,
      pipeline: this.props.pipeline,
      docLink: true
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Checkout subpath",
      helpKey: "pipeline.config.expectedArtifact.gitrepo.checkoutSubpath"
    }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      checked: this.state.includesSubPath,
      onChange: this.onIncludesSubPathChange
    })), this.state.includesSubPath && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Subpath",
      helpKey: "pipeline.config.expectedArtifact.gitrepo.subpath"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "path/to/subdirectory",
      value: (_b = artifact.location) != null ? _b : (_a = artifact.metadata) == null ? void 0 : _a.subPath,
      onChange: this.onSubPathChanged,
      pipeline: this.props.pipeline,
      docLink: true
    })));
  }
}
const GitRepoMatch = {
  label: "GitRepo",
  description: "A Git repository.",
  key: "gitrepo",
  typePattern: ArtifactTypePatterns.GIT_REPO,
  type: TYPE$2,
  isDefault: false,
  isMatch: true,
  editCmp: GitRepoArtifactEditor
};
const GitRepoDefault = {
  label: "GitRepo",
  typePattern: ArtifactTypePatterns.GIT_REPO,
  type: TYPE$2,
  description: "A Git repository.",
  key: "default.gitrepo",
  isDefault: true,
  isMatch: false,
  editCmp: GitRepoArtifactEditor
};

class ArtifactService {
  static getArtifactNames(type, accountName) {
    return REST("/artifacts/account").path(accountName, "names").query({ type }).get();
  }
  static getArtifactVersions(type, accountName, artifactName) {
    return REST("/artifacts/account").path(accountName, "versions").query({ type, artifactName }).get();
  }
  static getArtifactByContentReference(contentRef) {
    return REST(`/artifacts/content-address/${contentRef}`).get();
  }
}

const TYPE$1 = "helm/chart";
class HelmEditor$1 extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      names: [],
      versions: [],
      versionsLoading: true,
      namesLoading: true
    };
    this.SEMVER = new RegExp(/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(-(0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(\.(0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*)?(\+[0-9a-zA-Z-]+(\.[0-9a-zA-Z-]+)*)?$/);
    this.onChange = (e, field) => {
      const clone = cloneDeep(this.props.artifact);
      clone[field] = e.value.toString();
      this.props.onChange(clone);
    };
    const { artifact } = this.props;
    if (artifact.type !== TYPE$1) {
      const clonedArtifact = cloneDeep(artifact);
      clonedArtifact.type = TYPE$1;
      props.onChange(clonedArtifact);
    }
    ArtifactService.getArtifactNames(TYPE$1, this.props.account.name).then((names) => {
      this.setState({
        names,
        namesLoading: false
      });
    }, () => {
      this.setState({
        names: [],
        namesLoading: false,
        versionsLoading: false,
        versions: []
      });
    });
  }
  componentDidMount() {
    const { artifact } = this.props;
    if (artifact.name) {
      this.getChartVersionOptions(artifact.name);
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.account.name !== prevProps.account.name) {
      ArtifactService.getArtifactNames(TYPE$1, this.props.account.name).then((names) => {
        this.setState({
          names,
          namesLoading: false,
          versions: []
        });
      }, () => {
        this.setState({
          names: [],
          namesLoading: false,
          versions: []
        });
      });
    }
  }
  render() {
    const { artifact } = this.props;
    const nameOptions = this.state.names.map((name) => ({ value: name, label: name }));
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Name"
    }, !this.state.namesLoading && /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      options: nameOptions,
      value: artifact.name || "",
      onChange: (e) => {
        this.onChange(e, "name");
        this.getChartVersionOptions(e.value.toString());
      },
      clearable: false
    }), this.state.namesLoading && /* @__PURE__ */ React__default.createElement(Spinner, null)), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Version"
    }, !this.state.versionsLoading && /* @__PURE__ */ React__default.createElement(TetheredCreatable, {
      options: this.state.versions,
      value: artifact.version || "",
      onChange: (e) => {
        this.onChange(e, "version");
      },
      clearable: false
    }), this.state.versionsLoading && /* @__PURE__ */ React__default.createElement(Spinner, null)));
  }
  getChartVersionOptions(chartName) {
    const { artifact, account } = this.props;
    this.setState({ versionsLoading: true });
    ArtifactService.getArtifactVersions(TYPE$1, account.name, chartName).then((versions) => {
      if (artifact.version && !this.SEMVER.test(artifact.version)) {
        versions = versions.concat(artifact.version);
      }
      this.setState({
        versions: versions.map((v) => ({ label: v, value: v })),
        versionsLoading: false
      });
    });
  }
}
const HelmMatch = {
  label: "Helm",
  typePattern: ArtifactTypePatterns.HELM_CHART,
  type: TYPE$1,
  isDefault: false,
  isMatch: true,
  description: "A helm chart to be deployed",
  key: "helm",
  editCmp: HelmEditor$1
};
const HelmDefault = {
  label: "Helm",
  typePattern: ArtifactTypePatterns.HELM_CHART,
  type: TYPE$1,
  isDefault: true,
  isMatch: false,
  description: "A helm chart to be deployed",
  key: "default.helm",
  editCmp: HelmEditor$1
};

const HttpMatch = {
  label: "HTTP",
  typePattern: ArtifactTypePatterns.HTTP_FILE,
  type: "http/file",
  description: "An HTTP artifact.",
  key: "http",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("reference", "http/file", "URL", "path/file.ext", "")
};
const HttpDefault = {
  label: "HTTP",
  typePattern: ArtifactTypePatterns.HTTP_FILE,
  type: "http/file",
  description: "An HTTP artifact.",
  key: "default.http",
  isDefault: true,
  isMatch: false,
  editCmp: singleFieldArtifactEditor("reference", "http/file", "URL", "http://host/path/file.ext", "")
};

const IvyMatch = {
  label: "Ivy",
  typePattern: ArtifactTypePatterns.IVY_FILE,
  type: "ivy/file",
  description: "An Ivy repository artifact.",
  key: "ivy",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("reference", "ivy/file", "Ivy Coordinate", "group:artifact:version", "")
};
const IvyDefault = {
  label: "Ivy",
  typePattern: ArtifactTypePatterns.IVY_FILE,
  type: "ivy/file",
  description: "An Ivy repository artifact.",
  key: "ivy",
  isDefault: true,
  isMatch: false,
  editCmp: singleFieldArtifactEditor("reference", "ivy/file", "Ivy Coordinate", "group:artifact:version", "")
};

var BuildServiceType;
(function(BuildServiceType2) {
  BuildServiceType2["Jenkins"] = "jenkins";
  BuildServiceType2["Travis"] = "travis";
  BuildServiceType2["Wercker"] = "wercker";
  BuildServiceType2["Concourse"] = "concourse";
})(BuildServiceType || (BuildServiceType = {}));
class IgorService {
  static listMasters(buildType = null) {
    const allMasters = REST("/v2/builds").query({ type: buildType }).get();
    if (!allMasters) {
      return $q.reject("An error occurred when retrieving build masters");
    }
    switch (buildType) {
      case BuildServiceType.Jenkins:
        return allMasters.then((masters) => masters.filter((master) => !/^travis-/.test(master)));
      case BuildServiceType.Travis:
        return allMasters.then((masters) => masters.filter((master) => /^travis-/.test(master)));
      case BuildServiceType.Concourse:
        return allMasters.then((masters) => masters.filter((master) => /^concourse-/.test(master)));
      default:
        return allMasters;
    }
  }
  static listJobsForMaster(master) {
    return REST("/v3/builds").path(master, "jobs").get();
  }
  static listBuildsForJob(master, job) {
    return REST("/v3/builds").path(master, "builds").query({ job }).get();
  }
  static getJobConfig(master, job) {
    return REST("/v3/builds").path(master, "job").query({ job }).get();
  }
  static getGcbAccounts() {
    return REST("/gcb/accounts").get();
  }
  static getGcbTriggers(account) {
    return REST("/gcb/triggers").path(account).get();
  }
  static getCodeBuildAccounts() {
    return REST("/codebuild/accounts").get();
  }
  static getCodeBuildProjects(account) {
    return REST("/codebuild/projects").path(account).get();
  }
}

const TYPE = "jenkins/file";
const JenkinsMatch = {
  label: "Jenkins",
  typePattern: ArtifactTypePatterns.JENKINS_FILE,
  type: TYPE,
  isDefault: false,
  isMatch: true,
  description: "A Jenkins artifact file.",
  key: "default.jenkins",
  editCmp: singleFieldArtifactEditor("reference", TYPE, "Relative path", "pathFromWorkspaceRoot/file.ext", "")
};
const JenkinsDefault = {
  label: "Jenkins",
  typePattern: ArtifactTypePatterns.JENKINS_FILE,
  type: TYPE,
  isDefault: true,
  isMatch: false,
  description: "A Jenkins artifact file.",
  key: "default.jenkins",
  editCmp: class extends ArtifactEditor$1 {
    constructor(props) {
      super(props, TYPE);
      this.onReferenceChange = (reference) => {
        const clonedArtifact = cloneDeep(this.props.artifact);
        clonedArtifact.reference = reference;
        this.props.onChange(clonedArtifact);
      };
      this.onNameChange = (name) => {
        const clonedArtifact = cloneDeep(this.props.artifact);
        clonedArtifact.name = name;
        this.props.onChange(clonedArtifact);
        IgorService.listBuildsForJob(this.props.account.name, name).then((allBuilds) => {
          const buildNumbers = allBuilds.filter((build) => !build.building && build.result === "SUCCESS").sort((a, b) => b.number - a.number).map((b) => b.number);
          this.setState({ buildNumbers });
        }, () => {
          this.setState({ buildNumbers: [] });
        });
      };
      this.state = {
        jobs: [],
        buildNumbers: []
      };
    }
    componentDidMount() {
      IgorService.listJobsForMaster(this.props.account.name).then((jobs) => {
        this.setState({ jobs });
      });
    }
    render() {
      const { buildNumbers, jobs } = this.state;
      const { artifact } = this.props;
      const buildOptions = buildNumbers.map((b) => ({ label: b, value: b }));
      buildOptions.splice(0, 0, { label: "lastSuccessfulBuild", value: "lastSuccessfulBuild" });
      const jobOptions = jobs.map((j) => ({ label: j, value: j }));
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Job"
      }, /* @__PURE__ */ React__default.createElement(TetheredSelect, {
        options: jobOptions,
        onChange: (option) => this.onNameChange(option.value),
        value: artifact.name,
        clearable: false
      })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Build Number"
      }, /* @__PURE__ */ React__default.createElement(TetheredSelect, {
        options: buildOptions,
        onChange: (option) => this.onVersionChange(option.value),
        value: artifact.version,
        clearable: false
      })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
        label: "Relative path"
      }, /* @__PURE__ */ React__default.createElement(SpelText, {
        placeholder: "pathFromWorkspaceRoot/file.ext",
        value: this.props.artifact.reference,
        onChange: this.onReferenceChange,
        pipeline: this.props.pipeline,
        docLink: false
      })));
    }
  }
};

class KubernetesArtifactEditor extends ArtifactEditor$1 {
  constructor(props) {
    super(props, props.artifact.type || "kubernetes/configMap");
    this.onReferenceChange = (reference) => {
      const clonedArtifact = cloneDeep(this.props.artifact);
      clonedArtifact.reference = reference;
      this.props.onChange(clonedArtifact);
    };
    this.onTypeChange = (option) => {
      const clonedArtifact = cloneDeep(this.props.artifact);
      clonedArtifact.type = option.value;
      this.props.onChange(clonedArtifact);
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Resource Type"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      options: [
        { label: "ConfigMap", value: "kubernetes/configMap" },
        { label: "Deployment", value: "kubernetes/deployment" },
        { label: "ReplicaSet", value: "kubernetes/replicaSet" },
        { label: "Secret", value: "kubernetes/secret" }
      ],
      clearable: false,
      value: this.props.artifact.type,
      onChange: this.onTypeChange
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Reference"
    }, /* @__PURE__ */ React__default.createElement(SpelText, {
      placeholder: "",
      value: this.props.artifact.reference,
      onChange: this.onReferenceChange,
      pipeline: this.props.pipeline,
      docLink: true
    })));
  }
}
const KubernetesMatch = {
  label: "Kubernetes",
  typePattern: ArtifactTypePatterns.KUBERNETES,
  type: "kubernetes/*",
  description: "A kubernetes resource.",
  key: "kubernetes",
  isDefault: false,
  isMatch: true,
  editCmp: KubernetesArtifactEditor
};
const KubernetesDefault = {
  label: "Kubernetes",
  typePattern: ArtifactTypePatterns.KUBERNETES,
  type: "kubernetes/*",
  description: "A kubernetes resource.",
  key: "default.kubernetes",
  isDefault: true,
  isMatch: false,
  editCmp: KubernetesArtifactEditor
};

const MavenMatch = {
  label: "Maven",
  typePattern: ArtifactTypePatterns.MAVEN_FILE,
  type: "maven/file",
  description: "A Maven repository artifact.",
  key: "maven",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("reference", "maven/file", "Maven Coordinate", "group:artifact:version", "")
};
const MavenDefault = {
  label: "Maven",
  typePattern: ArtifactTypePatterns.MAVEN_FILE,
  type: "maven/file",
  description: "A Maven repository artifact.",
  key: "maven",
  isDefault: true,
  isMatch: false,
  editCmp: singleFieldArtifactEditor("reference", "maven/file", "Maven Coordinate", "group:artifact:version", "")
};

const OracleMatch = {
  label: "Oracle",
  typePattern: ArtifactTypePatterns.ORACLE_OBJECT,
  type: "oracle/object",
  description: "An oracle object.",
  key: "oracle",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("name", "oracle/object", "reference", "oci://bucket/file-path", "pipeline.config.expectedArtifact.oracle.name")
};
const OracleDefault = {
  label: "Oracle",
  typePattern: ArtifactTypePatterns.ORACLE_OBJECT,
  type: "oracle/object",
  description: "An oracle object.",
  key: "oracle",
  isDefault: true,
  isMatch: false,
  editCmp: singleFieldArtifactEditor("reference", "oracle/object", "Reference", "oci://bucket/file-path", "pipeline.config.expectedArtifact.defaultOracle.reference")
};

const S3Match = {
  label: "S3",
  typePattern: ArtifactTypePatterns.S3_OBJECT,
  type: "s3/object",
  description: "An S3 object.",
  key: "s3",
  isDefault: false,
  isMatch: true,
  editCmp: singleFieldArtifactEditor("name", "s3/object", "Object path", "s3://bucket/path/to/file", "pipeline.config.expectedArtifact.s3.name")
};
const S3Default = {
  label: "S3",
  typePattern: ArtifactTypePatterns.S3_OBJECT,
  type: "s3/object",
  description: "An S3 object.",
  key: "s3",
  isDefault: true,
  isMatch: false,
  editCmp: singleFieldArtifactEditor("reference", "s3/object", "Object path", "s3://bucket/path/to/file", "pipeline.config.expectedArtifact.defaultS3.reference")
};

var bitbucketFileIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2065%2063.27%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E.cls-2%7Bfill%3Anone%3B%7D.cls-3%7Bfill%3A%232684ff%3B%7D.cls-4%7Bfill%3Aurl%28%23New_Gradient_Swatch_1%29%3B%7D%3C%2Fstyle%3E%20%20%20%20%3ClinearGradient%20id%3D%22New_Gradient_Swatch_1%22%20x1%3D%2264.01%22%20y1%3D%2230.27%22%20x2%3D%2232.99%22%20y2%3D%2254.48%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.18%22%20stop-color%3D%22%230052cc%22%2F%3E%20%20%20%20%20%20%3Cstop%20offset%3D%221%22%20stop-color%3D%22%232684ff%22%2F%3E%20%20%20%20%3C%2FlinearGradient%3E%20%20%3C%2Fdefs%3E%20%20%3Ctitle%3EBitbucket-blue%3C%2Ftitle%3E%20%20%3Cg%20id%3D%22Layer_2%22%20data-name%3D%22Layer%202%22%3E%20%20%20%20%3Cg%20id%3D%22Blue%22%3E%20%20%20%20%20%20%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2224.7%2043.51%2037.75%2043.51%2040.9%2025.12%2021.23%2025.12%2024.7%2043.51%22%2F%3E%20%20%20%20%20%20%3Cpath%20class%3D%22cls-3%22%20d%3D%22M2%2C6.26A2%2C2%2C0%2C0%2C0%2C0%2C8.58L8.49%2C60.12a2.72%2C2.72%2C0%2C0%2C0%2C2.66%2C2.27H51.88a2%2C2%2C0%2C0%2C0%2C2-1.68L62.37%2C8.59a2%2C2%2C0%2C0%2C0-2-2.32ZM37.75%2C43.51h-13L21.23%2C25.12H40.9Z%22%2F%3E%20%20%20%20%20%20%3Cpath%20class%3D%22cls-4%22%20d%3D%22M59.67%2C25.12H40.9L37.75%2C43.51h-13L9.4%2C61.73a2.71%2C2.71%2C0%2C0%2C0%2C1.75.66H51.89a2%2C2%2C0%2C0%2C0%2C2-1.68Z%22%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var dockerIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%3Csvg%20%20%20xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%20%20%20xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%20%20%20xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%20%20%20xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20viewBox%3D%220%200%20482%20439%22%20%20%20height%3D%22439%22%20%20%20width%3D%22482%22%20%20%20xml%3Aspace%3D%22preserve%22%20%20%20id%3D%22svg3718%22%20%20%20version%3D%221.1%22%3E%3Cmetadata%20%20%20%20%20id%3D%22metadata3724%22%3E%3Crdf%3ARDF%3E%3Ccc%3AWork%20%20%20%20%20%20%20%20%20rdf%3Aabout%3D%22%22%3E%3Cdc%3Aformat%3Eimage%2Fsvg%2Bxml%3C%2Fdc%3Aformat%3E%3Cdc%3Atype%20%20%20%20%20%20%20%20%20%20%20rdf%3Aresource%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Fdcmitype%2FStillImage%22%20%2F%3E%3Cdc%3Atitle%3E%3C%2Fdc%3Atitle%3E%3C%2Fcc%3AWork%3E%3C%2Frdf%3ARDF%3E%3C%2Fmetadata%3E%3Cdefs%20%20%20%20%20id%3D%22defs3722%22%3E%3CclipPath%20%20%20%20%20%20%20id%3D%22clipPath3734%22%20%20%20%20%20%20%20clipPathUnits%3D%22userSpaceOnUse%22%3E%3Cpath%20%20%20%20%20%20%20%20%20id%3D%22path3732%22%20%20%20%20%20%20%20%20%20d%3D%22M%200%2C329.25%20H%20361.5%20V%200%20H%200%20Z%22%20%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3Cg%20%20%20%20%20transform%3D%22matrix%281.3333333%2C0%2C0%2C-1.3333333%2C0%2C439%29%22%20%20%20%20%20id%3D%22g3726%22%3E%3Cg%20%20%20%20%20%20%20id%3D%22g3728%22%3E%3Cg%20%20%20%20%20%20%20%20%20clip-path%3D%22url%28%23clipPath3734%29%22%20%20%20%20%20%20%20%20%20id%3D%22g3730%22%3E%3Cg%20%20%20%20%20%20%20%20%20%20%20transform%3D%22translate%28344.626%2C78.6162%29%22%20%20%20%20%20%20%20%20%20%20%20id%3D%22g3736%22%3E%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20%20id%3D%22path3738%22%20%20%20%20%20%20%20%20%20%20%20%20%20style%3D%22fill%3A%23066da5%3Bfill-opacity%3A1%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%22%20%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22m%200%2C0%20c%20-0.915%2C0.881%20-2.067%2C1.574%20-3.455%2C2.083%20-1.39%2C0.505%20-2.909%2C0.858%20-4.559%2C1.055%20-1.652%2C0.196%20-3.197%2C0.292%20-4.634%2C0.292%20-3.268%2C0%20-6.342%2C-0.523%20-9.217%2C-1.568%20-2.876%2C-1.048%20-5.539%2C-2.549%20-7.992%2C-4.511%20v%200.981%20c%200%2C1.403%20-0.497%2C2.605%20-1.495%2C3.604%20-0.995%2C0.997%20-2.2%2C1.494%20-3.603%2C1.494%20-1.44%2C0%20-2.656%2C-0.497%20-3.653%2C-1.494%20-0.996%2C-0.999%20-1.496%2C-2.201%20-1.496%2C-3.604%20v%20-44.713%20c%200%2C-1.406%200.5%2C-2.606%201.496%2C-3.603%200.997%2C-0.997%202.213%2C-1.495%203.653%2C-1.495%201.403%2C0%202.608%2C0.498%203.603%2C1.495%200.998%2C0.997%201.495%2C2.197%201.495%2C3.603%20v%2022.357%20c%200%2C2.384%200.452%2C4.625%201.348%2C6.717%200.9%2C2.091%202.125%2C3.911%203.677%2C5.466%201.554%2C1.552%203.375%2C2.777%205.468%2C3.676%202.09%2C0.899%204.329%2C1.349%206.716%2C1.349%202.419%2C0%204.657%2C-0.409%206.717%2C-1.226%200.815%2C-0.36%201.536%2C-0.538%202.157%2C-0.538%200.716%2C0%201.387%2C0.128%202.01%2C0.392%200.618%2C0.26%201.16%2C0.627%201.618%2C1.102%200.457%2C0.473%200.824%2C1.021%201.102%2C1.644%200.278%2C0.618%200.418%2C1.289%200.418%2C2.009%20C%201.374%2C-2.028%200.915%2C-0.883%200%2C0%20m%20-88.54%2C-18.925%20c%200.52%2C1.796%201.323%2C3.437%202.4%2C4.927%201.079%2C1.486%202.353%2C2.762%203.825%2C3.825%201.472%2C1.059%203.089%2C1.887%204.854%2C2.476%201.764%2C0.587%203.578%2C0.881%205.442%2C0.881%201.863%2C0%203.667%2C-0.294%205.415%2C-0.881%201.749%2C-0.589%203.352%2C-1.417%204.804%2C-2.476%201.456%2C-1.063%202.732%2C-2.339%203.824%2C-3.825%201.098%2C-1.49%201.922%2C-3.131%202.479%2C-4.927%20z%20m%2035.936%2C14.316%20c%20-5.428%2C5.36%20-11.9%2C8.039%20-19.415%2C8.039%20-7.585%2C0%20-14.057%2C-2.679%20-19.415%2C-8.039%20-5.363%2C-5.364%20-8.042%2C-11.832%20-8.042%2C-19.415%200%2C-7.583%202.679%2C-14.055%208.042%2C-19.415%205.358%2C-5.361%2011.83%2C-8.04%2019.415%2C-8.04%206.894%2C0%2012.875%2C2.222%2017.944%2C6.667%200.98%2C1.012%201.471%2C2.237%201.471%2C3.677%200%2C1.472%20-0.484%2C2.689%20-1.449%2C3.654%20-0.963%2C0.962%20-2.179%2C1.446%20-3.651%2C1.446%20-1.274%2C-0.034%20-2.402%2C-0.461%20-3.382%2C-1.276%20-1.538%2C-1.307%20-3.206%2C-2.289%20-5.002%2C-2.941%20-1.801%2C-0.654%20-3.774%2C-0.981%20-5.931%2C-0.981%20-1.898%2C0%20-3.719%2C0.295%20-5.469%2C0.883%20-1.746%2C0.589%20-3.351%2C1.412%20-4.804%2C2.476%20-1.454%2C1.061%20-2.721%2C2.335%20-3.798%2C3.824%20-1.079%2C1.487%20-1.898%2C3.129%20-2.45%2C4.927%20h%2038.827%20c%201.436%2C0%202.654%2C0.482%203.651%2C1.447%200.998%2C0.963%201.498%2C2.182%201.498%2C3.652%200%2C3.79%20-0.673%2C7.311%20-2.011%2C10.565%20-1.342%2C3.252%20-3.352%2C6.202%20-6.029%2C8.85%20m%20-51.511%2C2.941%20c%200%2C0.687%20-0.137%2C1.339%20-0.415%2C1.96%20-0.279%2C0.621%20-0.646%2C1.168%20-1.105%2C1.644%20-0.458%2C0.471%20-0.997%2C0.838%20-1.618%2C1.103%20-0.62%2C0.261%20-1.291%2C0.391%20-2.01%2C0.391%20-1.013%2C0%20-1.928%2C-0.263%20-2.745%2C-0.783%20l%20-29.316%2C-19.073%20v%2038.241%20c%200%2C1.438%20-0.5%2C2.655%20-1.497%2C3.654%20-0.995%2C0.995%20-2.199%2C1.495%20-3.604%2C1.495%20-1.44%2C0%20-2.656%2C-0.5%20-3.651%2C-1.495%20-0.997%2C-0.999%20-1.497%2C-2.216%20-1.497%2C-3.654%20v%20-68.146%20c%200%2C-1.405%200.5%2C-2.617%201.497%2C-3.628%200.995%2C-1.014%202.211%2C-1.52%203.651%2C-1.52%201.405%2C0%202.609%2C0.506%203.604%2C1.52%200.997%2C1.011%201.497%2C2.223%201.497%2C3.628%20v%2017.699%20l%205.98%2C3.92%2022.652%2C-25.443%20c%200.912%2C-0.884%202.057%2C-1.324%203.429%2C-1.324%200.719%2C0%201.39%2C0.13%202.01%2C0.392%200.621%2C0.261%201.16%2C0.628%201.618%2C1.103%200.459%2C0.472%200.826%2C1.022%201.105%2C1.642%200.278%2C0.619%200.415%2C1.277%200.415%2C1.961%200%2C1.339%20-0.475%2C2.532%20-1.421%2C3.58%20l%20-21.081%2C23.728%2020.542%2C13.336%20c%201.305%2C0.883%201.96%2C2.236%201.96%2C4.069%20m%20-84.207%2C-10.173%20c%201.568%2C1.552%203.398%2C2.777%205.49%2C3.676%202.093%2C0.899%204.332%2C1.349%206.719%2C1.349%202.156%2C0%204.148%2C-0.361%205.981%2C-1.078%201.828%2C-0.72%203.578%2C-1.784%205.244%2C-3.187%200.981%2C-0.785%202.092%2C-1.178%203.334%2C-1.178%201.471%2C0%202.688%2C0.49%203.653%2C1.472%200.964%2C0.981%201.447%2C2.207%201.447%2C3.677%200%2C1.535%20-0.589%2C2.827%20-1.766%2C3.874%20-5.034%2C4.443%20-10.997%2C6.666%20-17.893%2C6.666%20-7.586%2C0%20-14.057%2C-2.679%20-19.415%2C-8.039%20-5.361%2C-5.364%20-8.042%2C-11.832%20-8.042%2C-19.415%200%2C-7.583%202.681%2C-14.055%208.042%2C-19.415%205.358%2C-5.361%2011.829%2C-8.04%2019.415%2C-8.04%206.862%2C0%2012.827%2C2.222%2017.893%2C6.667%201.079%2C1.081%201.617%2C2.335%201.617%2C3.775%200%2C1.473%20-0.483%2C2.688%20-1.444%2C3.653%20-0.965%2C0.964%20-2.184%2C1.447%20-3.653%2C1.447%20-1.242%2C-0.034%20-2.321%2C-0.392%20-3.236%2C-1.079%20-1.634%2C-1.406%20-3.368%2C-2.46%20-5.196%2C-3.163%20-1.833%2C-0.703%20-3.825%2C-1.054%20-5.981%2C-1.054%20-2.387%2C0%20-4.626%2C0.45%20-6.719%2C1.348%20-2.092%2C0.9%20-3.922%2C2.125%20-5.49%2C3.677%20-1.57%2C1.552%20-2.804%2C3.375%20-3.701%2C5.468%20-0.899%2C2.09%20-1.349%2C4.329%20-1.349%2C6.716%200%2C2.384%200.45%2C4.625%201.349%2C6.717%200.897%2C2.091%202.131%2C3.911%203.701%2C5.466%20m%20-31.676%2C-18.827%20c%20-0.899%2C-2.076%20-2.127%2C-3.897%20-3.678%2C-5.465%20-1.552%2C-1.57%20-3.376%2C-2.813%20-5.466%2C-3.726%20-2.092%2C-0.917%20-4.331%2C-1.374%20-6.718%2C-1.374%20-2.419%2C0%20-4.673%2C0.457%20-6.764%2C1.374%20-2.092%2C0.913%20-3.906%2C2.147%20-5.442%2C3.701%20-1.538%2C1.552%20-2.755%2C3.373%20-3.654%2C5.466%20-0.899%2C2.089%20-1.348%2C4.315%20-1.348%2C6.668%200%2C2.352%200.449%2C4.575%201.348%2C6.668%200.899%2C2.089%202.116%2C3.913%203.654%2C5.467%201.536%2C1.549%203.35%2C2.784%205.442%2C3.701%202.091%2C0.913%204.345%2C1.372%206.764%2C1.372%202.387%2C0%204.626%2C-0.459%206.718%2C-1.372%202.09%2C-0.917%203.914%2C-2.159%205.466%2C-3.726%201.551%2C-1.57%202.779%2C-3.392%203.678%2C-5.468%200.897%2C-2.076%201.347%2C-4.29%201.347%2C-6.642%200%2C-2.353%20-0.45%2C-4.569%20-1.347%2C-6.644%20m%203.553%2C26.059%20c%20-5.427%2C5.36%20-11.898%2C8.039%20-19.415%2C8.039%20-7.583%2C0%20-14.055%2C-2.679%20-19.412%2C-8.039%20-5.363%2C-5.364%20-8.042%2C-11.832%20-8.042%2C-19.415%200%2C-7.583%202.679%2C-14.055%208.042%2C-19.415%205.357%2C-5.361%2011.829%2C-8.04%2019.412%2C-8.04%207.517%2C0%2013.988%2C2.679%2019.415%2C8.04%205.361%2C5.295%208.042%2C11.767%208.042%2C19.415%20-0.034%2C3.79%20-0.712%2C7.304%20-2.036%2C10.54%20-1.323%2C3.236%20-3.325%2C6.193%20-6.006%2C8.875%20m%20-63.398%2C-26.059%20c%20-0.899%2C-2.076%20-2.124%2C-3.897%20-3.676%2C-5.465%20-1.552%2C-1.57%20-3.375%2C-2.813%20-5.465%2C-3.726%20-2.093%2C-0.917%20-4.331%2C-1.374%20-6.719%2C-1.374%20-2.418%2C0%20-4.673%2C0.457%20-6.765%2C1.374%20-2.093%2C0.913%20-3.907%2C2.147%20-5.441%2C3.701%20-1.538%2C1.552%20-2.754%2C3.373%20-3.653%2C5.466%20-0.899%2C2.089%20-1.349%2C4.315%20-1.349%2C6.668%200%2C2.352%200.45%2C4.575%201.349%2C6.668%200.899%2C2.089%202.115%2C3.913%203.653%2C5.467%201.534%2C1.549%203.348%2C2.784%205.441%2C3.701%202.092%2C0.913%204.347%2C1.372%206.765%2C1.372%202.388%2C0%204.626%2C-0.459%206.719%2C-1.372%202.09%2C-0.917%203.913%2C-2.159%205.465%2C-3.726%201.552%2C-1.57%202.777%2C-3.392%203.676%2C-5.468%200.9%2C-2.076%201.349%2C-4.29%201.349%2C-6.642%200%2C-2.353%20-0.449%2C-4.569%20-1.349%2C-6.644%20m%206.449%2C57.632%20c%20-1.472%2C0%20-2.69%2C-0.485%20-3.653%2C-1.447%20-0.966%2C-0.965%20-1.447%2C-2.182%20-1.447%2C-3.651%20V%20-2.6%20c%20-4.968%2C4.022%20-10.705%2C6.03%20-17.209%2C6.03%20-7.583%2C0%20-14.054%2C-2.679%20-19.415%2C-8.039%20-5.36%2C-5.364%20-8.039%2C-11.832%20-8.039%2C-19.415%200%2C-7.583%202.679%2C-14.055%208.039%2C-19.415%205.361%2C-5.361%2011.832%2C-8.04%2019.415%2C-8.04%207.517%2C0%2013.989%2C2.679%2019.415%2C8.04%205.361%2C5.295%208.04%2C11.767%208.04%2C19.415%20v%2045.89%20c%200%2C1.469%20-0.498%2C2.686%20-1.495%2C3.651%20-0.997%2C0.962%20-2.213%2C1.447%20-3.651%2C1.447%20m%20142.279%2C113.243%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%20-29.666%2C0%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%20-29.665%2C0%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%20-29.666%2C0%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%20-29.666%2C0%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%2029.666%2C27.383%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%2029.666%2C0%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%2029.665%2C0%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%200%2C27.384%20h%2025.102%20v%2022.82%20h%20-25.102%20z%20m%20135.273%2C-44.843%20-5.068%2C3.382%20c%20-5.484%2C3.667%20-18.077%2C5.011%20-27.772%2C3.183%20-1.248%2C9.13%20-6.337%2C17.047%20-15.592%2C24.203%20l%20-5.322%2C3.548%20-3.551%2C-5.326%20c%20-4.545%2C-6.855%20-6.816%2C-16.352%20-6.072%2C-25.46%200.335%2C-3.203%201.388%2C-8.934%204.685%2C-13.973%20-3.295%2C-1.77%20-9.808%2C-4.209%20-18.391%2C-4.045%20h%20-165.087%20l%20-0.323%2C-1.901%20c%20-1.552%2C-9.153%20-1.518%2C-37.714%2017.025%2C-59.667%2014.096%2C-16.686%2035.229%2C-25.147%2062.811%2C-25.147%2059.795%2C0%20104.033%2C27.525%20124.749%2C77.557%208.146%2C-0.162%2025.687%2C-0.047%2034.697%2C17.167%200.234%2C0.395%200.775%2C1.429%202.349%2C4.69%20z%22%20%2F%3E%3C%2Fg%3E%3Cg%20%20%20%20%20%20%20%20%20%20%20transform%3D%22translate%28323.4053%2C29.5137%29%22%20%20%20%20%20%20%20%20%20%20%20id%3D%22g3740%22%3E%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20%20id%3D%22path3742%22%20%20%20%20%20%20%20%20%20%20%20%20%20style%3D%22fill%3A%23066da5%3Bfill-opacity%3A1%3Bfill-rule%3Anonzero%3Bstroke%3Anone%22%20%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M%200%2C0%20H%200.233%20C%200.507%2C0%200.728%2C0.091%200.728%2C0.312%200.728%2C0.507%200.585%2C0.638%200.272%2C0.638%200.143%2C0.638%200.052%2C0.624%200%2C0.61%20Z%20m%20-0.013%2C-1.209%20h%20-0.494%20v%202.132%20c%200.195%2C0.039%200.468%2C0.065%200.819%2C0.065%200.403%2C0%200.584%2C-0.065%200.741%2C-0.156%20C%201.17%2C0.741%201.261%2C0.572%201.261%2C0.364%201.261%2C0.13%201.079%2C-0.052%200.819%2C-0.13%20v%20-0.026%20c%200.207%2C-0.077%200.325%2C-0.234%200.39%2C-0.52%200.064%2C-0.325%200.103%2C-0.455%200.156%2C-0.533%20H%200.832%20c%20-0.065%2C0.078%20-0.104%2C0.272%20-0.169%2C0.521%20-0.039%2C0.233%20-0.169%2C0.337%20-0.442%2C0.337%20h%20-0.234%20z%20m%20-1.313%2C1.118%20c%200%2C-0.949%200.702%2C-1.703%201.664%2C-1.703%200.935%2C0%201.625%2C0.754%201.625%2C1.69%200%2C0.949%20-0.69%2C1.716%20-1.638%2C1.716%20-0.949%2C0%20-1.651%2C-0.767%20-1.651%2C-1.703%20m%203.835%2C0%20c%200%2C-1.209%20-0.949%2C-2.158%20-2.184%2C-2.158%20-1.222%2C0%20-2.197%2C0.949%20-2.197%2C2.158%200%2C1.183%200.975%2C2.132%202.197%2C2.132%201.235%2C0%202.184%2C-0.949%202.184%2C-2.132%22%20%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var embeddedBase64Icon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22110.37mm%22%20height%3D%22110.37mm%22%20version%3D%221.1%22%20viewBox%3D%220%200%20110.36904%20110.36904%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%20xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%20xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%3E%20%3Cmetadata%3E%20%20%3Crdf%3ARDF%3E%20%20%20%3Ccc%3AWork%20rdf%3Aabout%3D%22%22%3E%20%20%20%20%3Cdc%3Aformat%3Eimage%2Fsvg%2Bxml%3C%2Fdc%3Aformat%3E%20%20%20%20%3Cdc%3Atype%20rdf%3Aresource%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Fdcmitype%2FStillImage%22%2F%3E%20%20%20%20%3Cdc%3Atitle%2F%3E%20%20%20%3C%2Fcc%3AWork%3E%20%20%3C%2Frdf%3ARDF%3E%20%3C%2Fmetadata%3E%20%3Cg%20transform%3D%22translate%28-43.089%20-111.04%29%22%3E%20%20%3Crect%20x%3D%2243.089%22%20y%3D%22111.04%22%20width%3D%22110.37%22%20height%3D%22110.37%22%20stroke-width%3D%22.26458%22%2F%3E%20%20%3Cg%20fill%3D%22%23fff%22%3E%20%20%20%3Cpath%20d%3D%22m70.081%20171.06q0-6.0035-2.3648-9.4046-2.3366-3.4306-6.4468-3.4306t-6.475%203.4306q-2.3366%203.401-2.3366%209.4046t2.3366%209.4341q2.3648%203.401%206.475%203.401t6.4468-3.401q2.3648-3.4306%202.3648-9.4341zm-17.623-11.563q1.6328-2.9574%204.1102-4.377%202.5055-1.4491%205.9683-1.4491%205.743%200%209.3184%204.791%203.6035%204.791%203.6035%2012.599%200%207.8076-3.6035%2012.599-3.5753%204.791-9.3184%204.791-3.4627%200-5.9683-1.4196-2.4774-1.4491-4.1102-4.4066v4.9685h-5.2081v-46.017h5.2081z%22%2F%3E%20%20%20%3Cpath%20d%3D%22m97.744%20163.14q-3.8287%200-6.0809%202.7504-2.224%202.7504-2.224%207.5414%200%204.7614%202.224%207.5414%202.2522%202.7504%206.0809%202.7504%203.8287%200%206.0528-2.7504%202.2522-2.78%202.2522-7.5414%200-4.791-2.2522-7.5414-2.224-2.7504-6.0528-2.7504zm11.289-18.72v5.4416q-2.1396-1.0647-4.3355-1.6266-2.1677-0.5619-4.3073-0.5619-5.6304%200-8.6146%203.9925-2.956%203.9925-3.3783%2012.066%201.661-2.573%204.1665-3.9334%202.5055-1.39%205.5178-1.39%206.3343%200%209.9941%204.0517%203.6879%204.0221%203.6879%2010.972%200%206.802-3.8287%2010.913-3.8287%204.1108-10.191%204.1108-7.2914%200-11.148-5.8557-3.8568-5.8853-3.8568-17.035%200-10.469%204.7296-16.68%204.7296-6.2401%2012.697-6.2401%202.1396%200%204.3073%200.44361%202.1959%200.44361%204.5607%201.3308z%22%2F%3E%20%20%20%3Cpath%20d%3D%22m137.32%20148.64-14.358%2023.571h14.358zm-1.4921-5.205h7.1506v28.776h5.9964v4.9684h-5.9964v10.41h-5.6586v-10.41h-18.975v-5.7669z%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fsvg%3E";

var gcsObjectIcon = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22128%22%20height%3D%22128%22%20viewBox%3D%220%200%20128%20128%22%3E%20%20%3Ctitle%3ECloud%20Storage%3C%2Ftitle%3E%20%20%3Cpath%20d%3D%22M126.47%2C58.12l-26.3-45.74A11.56%2C11.56%2C0%2C0%2C0%2C90.31%2C6.5H37.7a11.55%2C11.55%2C0%2C0%2C0-9.86%2C5.88L1.53%2C58a11.48%2C11.48%2C0%2C0%2C0%2C0%2C11.44l26.3%2C46a11.77%2C11.77%2C0%2C0%2C0%2C9.86%2C6.09H90.3a11.73%2C11.73%2C0%2C0%2C0%2C9.87-6.06l26.3-45.74A11.73%2C11.73%2C0%2C0%2C0%2C126.47%2C58.12Z%22%20style%3D%22fill%3A%20%234285f4%22%2F%3E%20%20%3Cpath%20d%3D%22M85.49%2C50.55%2C49.31%2C53.88l-7%2C7%2C6%2C6L42.36%2C77.3l44.2%2C44.2H90.3a11.73%2C11.73%2C0%2C0%2C0%2C9.87-6.06L118.5%2C83.56Z%22%20style%3D%22opacity%3A%200.070000000298023%3Bisolation%3A%20isolate%22%2F%3E%20%20%3Cg%20id%3D%22art%22%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20d%3D%22M84.7%2C50.27H43.26A1.22%2C1.22%2C0%2C0%2C0%2C42%2C51.48v8.57a1.21%2C1.21%2C0%2C0%2C0%2C1.21%2C1.21H84.7a1.22%2C1.22%2C0%2C0%2C0%2C1.21-1.21V51.48a1.22%2C1.22%2C0%2C0%2C0-1.21-1.21m-6.41%2C8a2.48%2C2.48%2C0%2C1%2C1%2C2.48-2.48%2C2.48%2C2.48%2C0%2C0%2C1-2.48%2C2.48%22%20style%3D%22fill%3A%20%23fff%22%2F%3E%20%20%20%20%20%20%3Cpath%20d%3D%22M84.7%2C66.74H43.26A1.22%2C1.22%2C0%2C0%2C0%2C42%2C68v8.57a1.22%2C1.22%2C0%2C0%2C0%2C1.21%2C1.21H84.7a1.22%2C1.22%2C0%2C0%2C0%2C1.21-1.21V67.95a1.22%2C1.22%2C0%2C0%2C0-1.21-1.21m-6.41%2C8a2.48%2C2.48%2C0%2C1%2C1%2C2.48-2.48%2C2.48%2C2.48%2C0%2C0%2C1-2.48%2C2.48%22%20style%3D%22fill%3A%20%23fff%22%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var gitRepoIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2297px%22%20height%3D%2297px%22%20viewBox%3D%220%200%2097%2097%22%20enable-background%3D%22new%200%200%2097%2097%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23F05133%22%20d%3D%22M92.71%2C44.408L52.591%2C4.291c-2.31-2.311-6.057-2.311-8.369%2C0l-8.33%2C8.332L46.459%2C23.19%20%20c2.456-0.83%2C5.272-0.273%2C7.229%2C1.685c1.969%2C1.97%2C2.521%2C4.81%2C1.67%2C7.275l10.186%2C10.185c2.465-0.85%2C5.307-0.3%2C7.275%2C1.671%20%20c2.75%2C2.75%2C2.75%2C7.206%2C0%2C9.958c-2.752%2C2.751-7.208%2C2.751-9.961%2C0c-2.068-2.07-2.58-5.11-1.531-7.658l-9.5-9.499v24.997%20%20c0.67%2C0.332%2C1.303%2C0.774%2C1.861%2C1.332c2.75%2C2.75%2C2.75%2C7.206%2C0%2C9.959c-2.75%2C2.749-7.209%2C2.749-9.957%2C0c-2.75-2.754-2.75-7.21%2C0-9.959%20%20c0.68-0.679%2C1.467-1.193%2C2.307-1.537V36.369c-0.84-0.344-1.625-0.853-2.307-1.537c-2.083-2.082-2.584-5.14-1.516-7.698%20%20L31.798%2C16.715L4.288%2C44.222c-2.311%2C2.313-2.311%2C6.06%2C0%2C8.371l40.121%2C40.118c2.31%2C2.311%2C6.056%2C2.311%2C8.369%2C0L92.71%2C52.779%20%20C95.021%2C50.468%2C95.021%2C46.719%2C92.71%2C44.408z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var gitHubFileIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22161.03%22%20height%3D%22157.06%22%20version%3D%221.1%22%20viewBox%3D%220%200%20161.03467%20157.05798%22%20xml%3Aspace%3D%22preserve%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%20xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%20xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%3E%3Cmetadata%3E%3Crdf%3ARDF%3E%3Ccc%3AWork%20rdf%3Aabout%3D%22%22%3E%3Cdc%3Aformat%3Eimage%2Fsvg%2Bxml%3C%2Fdc%3Aformat%3E%3Cdc%3Atype%20rdf%3Aresource%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Fdcmitype%2FStillImage%22%2F%3E%3Cdc%3Atitle%2F%3E%3C%2Fcc%3AWork%3E%3C%2Frdf%3ARDF%3E%3C%2Fmetadata%3E%3Cg%20transform%3D%22matrix%281.3333%200%200%20-1.3333%20-386.96%20658.07%29%22%3E%3Cg%20transform%3D%22translate%28350.61%20493.55%29%22%3E%3Cpath%20d%3D%22m0%200c-33.347%200-60.388-27.035-60.388-60.388%200-26.68%2017.303-49.316%2041.297-57.301%203.018-0.559%204.126%201.31%204.126%202.905%200%201.439-0.056%206.197-0.082%2011.243-16.8-3.653-20.345%207.125-20.345%207.125-2.747%206.979-6.705%208.836-6.705%208.836-5.479%203.748%200.413%203.671%200.413%203.671%206.064-0.426%209.257-6.224%209.257-6.224%205.386-9.231%2014.127-6.562%2017.573-5.019%200.543%203.902%202.107%206.567%203.834%208.075-13.413%201.526-27.513%206.705-27.513%2029.844%200%206.592%202.359%2011.98%206.222%2016.209-0.627%201.521-2.694%207.663%200.586%2015.981%200%200%205.071%201.622%2016.61-6.191%204.817%201.338%209.983%202.009%2015.115%202.033%205.132-0.024%2010.302-0.695%2015.128-2.033%2011.526%207.813%2016.59%206.191%2016.59%206.191%203.287-8.318%201.22-14.46%200.593-15.981%203.872-4.229%206.214-9.617%206.214-16.209%200-23.195-14.127-28.301-27.574-29.796%202.166-1.874%204.096-5.549%204.096-11.183%200-8.08-0.069-14.583-0.069-16.572%200-1.608%201.086-3.49%204.147-2.898%2023.982%207.994%2041.263%2030.622%2041.263%2057.294%200%2033.353-27.037%2060.388-60.388%2060.388%22%20fill%3D%22%231b1817%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var gitLabFileIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%3Csvg%20width%3D%22494px%22%20height%3D%22455px%22%20viewBox%3D%220%200%20494%20455%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20xmlns%3Asketch%3D%22http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch%2Fns%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3Elogo%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20id%3D%22path-1%22%20d%3D%22M0%2C1173.3333%20L1999.99995%2C1173.3333%20L1999.99995%2C0%20L0%2C0%20L0%2C1173.3333%20L0%2C1173.3333%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22gitlab_logo%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28-359.000000%2C%20-360.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g10%22%20transform%3D%22translate%28999.999975%2C%20587.666648%29%20scale%281%2C%20-1%29%20translate%28-999.999975%2C%20-587.666648%29%20translate%280.000000%2C%200.999996%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g16%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g18-Clipped%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20sketch%3Aname%3D%22path22%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22path22%22%3E%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g18%22%20mask%3D%22url%28%23mask-2%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28358.666658%2C%20358.666658%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g44%22%20transform%3D%22translate%280.532000%2C%200.774933%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M491.999988%2C194.666662%20L464.441322%2C279.481326%20L409.82399%2C447.578655%20C407.014656%2C456.226655%20394.778657%2C456.226655%20391.96799%2C447.578655%20L337.349325%2C279.481326%20L155.982663%2C279.481326%20L101.362664%2C447.578655%20C98.5533309%2C456.226655%2086.3173312%2C456.226655%2083.5066646%2C447.578655%20L28.8893326%2C279.481326%20L1.33199997%2C194.666662%20C-1.18266664%2C186.930662%201.57199996%2C178.455996%208.1519998%2C173.674662%20L246.665327%2C0.385333324%20L485.179988%2C173.674662%20C491.759988%2C178.455996%20494.513321%2C186.930662%20491.999988%2C194.666662%22%20id%3D%22path46%22%20fill%3D%22%23FC6D26%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g48%22%20transform%3D%22translate%28155.197863%2C%201.160267%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M91.9999977%2C0%20L91.9999977%2C0%20L182.683995%2C279.095993%20L1.31599997%2C279.095993%20L91.9999977%2C0%20L91.9999977%2C0%20Z%22%20id%3D%22path50%22%20fill%3D%22%23E24329%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g52%22%20transform%3D%22translate%28247.197860%2C%201.160267%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22path54%22%3E%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g56%22%20transform%3D%22translate%2828.531199%2C%201.160800%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M218.666661%2C0%20L127.982663%2C279.09466%20L0.890666644%2C279.09466%20L218.666661%2C0%20L218.666661%2C0%20Z%22%20id%3D%22path58%22%20fill%3D%22%23FC6D26%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g60%22%20transform%3D%22translate%28247.197860%2C%201.160800%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22path62%22%3E%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g64%22%20transform%3D%22translate%280.088533%2C%200.255867%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M29.3333326%2C279.999993%20L29.3333326%2C279.999993%20L1.77466662%2C195.185328%20C-0.738666648%2C187.449329%202.01466662%2C178.974662%208.59599979%2C174.194662%20L247.109327%2C0.905333311%20L29.3333326%2C279.999993%20L29.3333326%2C279.999993%20Z%22%20id%3D%22path66%22%20fill%3D%22%23FCA326%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g68%22%20transform%3D%22translate%28247.197860%2C%201.160267%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22path70%22%3E%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g72%22%20transform%3D%22translate%2829.421866%2C%20280.255593%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C0%20L127.091997%2C0%20L72.4733315%2C168.097329%20C69.6626649%2C176.746662%2057.4266652%2C176.746662%2054.617332%2C168.097329%20L0%2C0%20L0%2C0%20Z%22%20id%3D%22path74%22%20fill%3D%22%23E24329%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g76%22%20transform%3D%22translate%28247.197860%2C%201.160800%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C0%20L90.6839977%2C279.09466%20L217.775995%2C279.09466%20L0%2C0%20L0%2C0%20Z%22%20id%3D%22path78%22%20fill%3D%22%23FC6D26%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g80%22%20transform%3D%22translate%28246.307061%2C%200.255867%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M218.666661%2C279.999993%20L218.666661%2C279.999993%20L246.225327%2C195.185328%20C248.73866%2C187.449329%20245.985327%2C178.974662%20239.403994%2C174.194662%20L0.890666644%2C0.905333311%20L218.666661%2C279.999993%20L218.666661%2C279.999993%20Z%22%20id%3D%22path82%22%20fill%3D%22%23FCA326%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22g84%22%20transform%3D%22translate%28336.973725%2C%20280.255593%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M127.999997%2C0%20L0.907999977%2C0%20L55.5266653%2C168.097329%20C58.3373319%2C176.746662%2070.5733316%2C176.746662%2073.3826648%2C168.097329%20L127.999997%2C0%20L127.999997%2C0%20Z%22%20id%3D%22path86%22%20fill%3D%22%23E24329%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var helmChartIcon = "helm-chart-artifact2320ab55b431ba0a.svg";

var httpFileIcon = "data:image/svg+xml,%3Csvg%20id%3D%22svg2%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%22145mm%22%20width%3D%22145mm%22%20version%3D%221.1%22%20viewBox%3D%220%200%20513.77953%20513.77951%22%3E%20%3Cg%20id%3D%22layer1%22%20transform%3D%22translate%28-87.403%20-17.44%29%22%3E%20%20%3Cg%20id%3D%22text3336%22%3E%20%20%20%3Cpath%20id%3D%22path3372%22%20d%3D%22m145.34%20318.08v-51.12q0-10.98-3.06-15.84t-11.16-4.86q-5.94%200-10.98%204.14-4.86%203.96-6.48%2010.26v57.42h-23.4v-126h23.4v46.08h0.72q4.32-5.76%2010.62-9.18t16.02-3.42q6.84%200%2012.06%201.8t8.64%205.94q3.6%204.14%205.22%2011.34%201.8%207.02%201.8%2017.46v55.98h-23.4z%22%2F%3E%20%20%20%3Cpath%20id%3D%22path3374%22%20d%3D%22m178.99%20228.08h12.42v-16.92l23.4-6.66v23.58h21.96v19.8h-21.96v34.56q0%209.36%201.8%2013.5%201.98%203.96%207.2%203.96%203.6%200%206.12-0.72%202.7-0.72%205.94-2.16l4.14%2018q-4.86%202.34-11.34%203.96t-13.14%201.62q-12.42%200-18.36-6.3-5.76-6.48-5.76-21.06v-45.36h-12.42v-19.8z%22%2F%3E%20%20%20%3Cpath%20id%3D%22path3376%22%20d%3D%22m240.51%20228.08h12.42v-16.92l23.4-6.66v23.58h21.96v19.8h-21.96v34.56q0%209.36%201.8%2013.5%201.98%203.96%207.2%203.96%203.6%200%206.12-0.72%202.7-0.72%205.94-2.16l4.14%2018q-4.86%202.34-11.34%203.96t-13.14%201.62q-12.42%200-18.36-6.3-5.76-6.48-5.76-21.06v-45.36h-12.42v-19.8z%22%2F%3E%20%20%20%3Cpath%20id%3D%22path3378%22%20d%3D%22m312.8%20228.08h17.1l2.7%2010.8h0.72q4.68-6.84%2010.98-10.08%206.48-3.24%2015.66-3.24%2016.92%200%2025.38%2010.8%208.46%2010.62%208.46%2034.38%200%2011.52-2.7%2020.88-2.7%209.18-8.1%2015.66-5.22%206.48-12.96%209.9-7.56%203.42-17.46%203.42-5.58%200-9.18-0.9-3.6-0.72-7.2-2.52v36.9h-23.4v-126zm40.14%2017.28q-6.84%200-10.8%203.42-3.78%203.42-5.94%2010.26v37.44q2.52%201.98%205.4%203.24%203.06%201.08%207.92%201.08%2010.08%200%2015.12-7.02%205.04-7.2%205.04-23.58%200-11.88-3.96-18.36t-12.78-6.48z%22%2F%3E%20%20%20%3Cpath%20id%3D%22path3380%22%20d%3D%22m416.66%20241.04q0-6.3%203.96-9.9%203.96-3.78%2010.44-3.78%206.84%200%2010.8%203.78%203.96%203.6%203.96%209.9t-3.96%2010.08-10.8%203.78q-6.48%200-10.44-3.78t-3.96-10.08zm0%2065.16q0-6.3%203.96-9.9%203.96-3.78%2010.44-3.78%206.84%200%2010.8%203.78%203.96%203.6%203.96%209.9t-3.96%2010.08-10.8%203.78q-6.48%200-10.44-3.78t-3.96-10.08z%22%2F%3E%20%20%20%3Cpath%20id%3D%22path3382%22%20d%3D%22m508.38%20189.92%2017.64%207.92-64.26%20145.44-17.64-8.28%2064.26-145.08z%22%2F%3E%20%20%20%3Cpath%20id%3D%22path3384%22%20d%3D%22m581.85%20189.92%2017.64%207.92-64.26%20145.44-17.64-8.28%2064.26-145.08z%22%2F%3E%20%20%3C%2Fg%3E%20%20%3Ctext%20id%3D%22text3340%22%20style%3D%22word-spacing%3A0px%3Bletter-spacing%3A0px%22%20xml%3Aspace%3D%22preserve%22%20font-size%3D%2240px%22%20font-stretch%3D%22condensed%22%20line-height%3D%22125%25%22%20y%3D%2292.362206%22%20x%3D%22-511.42856%22%20font-family%3D%22Impact%22%20fill%3D%22%23000000%22%3E%3Ctspan%20id%3D%22tspan3342%22%20x%3D%22-511.42856%22%20y%3D%2292.362206%22%2F%3E%3C%2Ftext%3E%20%20%3CflowRoot%20id%3D%22flowRoot3344%22%20style%3D%22word-spacing%3A0px%3Bletter-spacing%3A0px%22%20xml%3Aspace%3D%22preserve%22%20font-size%3D%2240px%22%20font-stretch%3D%22condensed%22%20line-height%3D%22125%25%22%20font-family%3D%22Impact%22%20fill%3D%22%23000000%22%3E%3CflowRegion%20id%3D%22flowRegion3346%22%3E%3Crect%20id%3D%22rect3348%22%20height%3D%2257.143%22%20width%3D%22225.71%22%20y%3D%22489.51%22%20x%3D%2274.286%22%2F%3E%3C%2FflowRegion%3E%3CflowPara%20id%3D%22flowPara3350%22%2F%3E%3C%2FflowRoot%3E%20%3C%2Fg%3E%3C%2Fsvg%3E";

var ivyFileIcon = "ivy-artifact537f2ce5956f4038.svg";

var jenkinsFileIcon = "jenkins-file-artifactffa863534b26f298.svg";

var kubernetesIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%3Csvg%20%20%20xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%20%20%20xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%20%20%20xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%20%20%20xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20xmlns%3Asodipodi%3D%22http%3A%2F%2Fsodipodi.sourceforge.net%2FDTD%2Fsodipodi-0.dtd%22%20%20%20xmlns%3Ainkscape%3D%22http%3A%2F%2Fwww.inkscape.org%2Fnamespaces%2Finkscape%22%20%20%20width%3D%22722.8457%22%20%20%20height%3D%22701.96637%22%20%20%20id%3D%22svg2%22%20%20%20version%3D%221.1%22%20%20%20inkscape%3Aversion%3D%220.48.4%20r9939%22%20%20%20sodipodi%3Adocname%3D%22logo.svg%22%20%20%20inkscape%3Aexport-filename%3D%22%2Fhome%2Fthockin%2Fsrc%2Fkubernetes%2Fnew.png%22%20%20%20inkscape%3Aexport-xdpi%3D%22460.95001%22%20%20%20inkscape%3Aexport-ydpi%3D%22460.95001%22%3E%20%20%3Cdefs%20%20%20%20%20id%3D%22defs4%22%20%2F%3E%20%20%3Csodipodi%3Anamedview%20%20%20%20%20id%3D%22base%22%20%20%20%20%20pagecolor%3D%22%23ffffff%22%20%20%20%20%20bordercolor%3D%22%23666666%22%20%20%20%20%20borderopacity%3D%221.0%22%20%20%20%20%20inkscape%3Apageopacity%3D%220.0%22%20%20%20%20%20inkscape%3Apageshadow%3D%222%22%20%20%20%20%20inkscape%3Azoom%3D%2216.190509%22%20%20%20%20%20inkscape%3Acx%3D%22277.56851%22%20%20%20%20%20inkscape%3Acy%3D%22157.54494%22%20%20%20%20%20inkscape%3Adocument-units%3D%22px%22%20%20%20%20%20inkscape%3Acurrent-layer%3D%22g3052%22%20%20%20%20%20showgrid%3D%22false%22%20%20%20%20%20inkscape%3Awindow-width%3D%221519%22%20%20%20%20%20inkscape%3Awindow-height%3D%22822%22%20%20%20%20%20inkscape%3Awindow-x%3D%2251%22%20%20%20%20%20inkscape%3Awindow-y%3D%2225%22%20%20%20%20%20inkscape%3Awindow-maximized%3D%220%22%20%20%20%20%20inkscape%3Asnap-global%3D%22false%22%20%20%20%20%20fit-margin-top%3D%2210%22%20%20%20%20%20fit-margin-left%3D%2210%22%20%20%20%20%20fit-margin-right%3D%2210%22%20%20%20%20%20fit-margin-bottom%3D%2210%22%20%2F%3E%20%20%3Cmetadata%20%20%20%20%20id%3D%22metadata7%22%3E%20%20%20%20%3Crdf%3ARDF%3E%20%20%20%20%20%20%3Ccc%3AWork%20%20%20%20%20%20%20%20%20rdf%3Aabout%3D%22%22%3E%20%20%20%20%20%20%20%20%3Cdc%3Aformat%3Eimage%2Fsvg%2Bxml%3C%2Fdc%3Aformat%3E%20%20%20%20%20%20%20%20%3Cdc%3Atype%20%20%20%20%20%20%20%20%20%20%20rdf%3Aresource%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Fdcmitype%2FStillImage%22%20%2F%3E%20%20%20%20%20%20%20%20%3Cdc%3Atitle%20%2F%3E%20%20%20%20%20%20%3C%2Fcc%3AWork%3E%20%20%20%20%3C%2Frdf%3ARDF%3E%20%20%3C%2Fmetadata%3E%20%20%3Cg%20%20%20%20%20inkscape%3Alabel%3D%22Layer%201%22%20%20%20%20%20inkscape%3Agroupmode%3D%22layer%22%20%20%20%20%20id%3D%22layer1%22%20%20%20%20%20transform%3D%22translate%28-6.3260942%2C-174.7524%29%22%3E%20%20%20%20%3Cg%20%20%20%20%20%20%20id%3D%22g3052%22%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20style%3D%22fill%3A%23326ce5%3Bfill-opacity%3A1%3Bstroke%3A%23ffffff%3Bstroke-width%3A0%3Bstroke-miterlimit%3A4%3Bstroke-opacity%3A1%3Bstroke-dasharray%3Anone%22%20%20%20%20%20%20%20%20%20d%3D%22m%20365.3125%2C184.8125%20a%2046.724621%2C46.342246%200%200%200%20-17.90625%2C4.53125%20l%20-244.34375%2C116.75%20a%2046.724621%2C46.342246%200%200%200%20-25.28125%2C31.4375%20L%2017.5%2C599.78125%20A%2046.724621%2C46.342246%200%200%200%2023.84375%2C635.3125%2046.724621%2C46.342246%200%200%200%2026.5%2C639%20l%20169.125%2C210.28125%20a%2046.724621%2C46.342246%200%200%200%2036.53125%2C17.4375%20L%20503.375%2C866.65625%20A%2046.724621%2C46.342246%200%200%200%20539.90625%2C849.25%20L%20708.96875%2C638.9375%20A%2046.724621%2C46.342246%200%200%200%20718%2C599.71875%20l%20-60.375%2C-262.25%20a%2046.724621%2C46.342246%200%200%200%20-25.28125%2C-31.4375%20l%20-244.375%2C-116.6875%20A%2046.724621%2C46.342246%200%200%200%20365.3125%2C184.8125%20z%22%20%20%20%20%20%20%20%20%20id%3D%22path3055%22%20%20%20%20%20%20%20%20%20inkscape%3Aconnector-curvature%3D%220%22%20%20%20%20%20%20%20%20%20inkscape%3Aexport-filename%3D%22new.png%22%20%20%20%20%20%20%20%20%20inkscape%3Aexport-xdpi%3D%22250.55%22%20%20%20%20%20%20%20%20%20inkscape%3Aexport-ydpi%3D%22250.55%22%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20inkscape%3Aconnector-curvature%3D%220%22%20%20%20%20%20%20%20%20%20id%3D%22path3059%22%20%20%20%20%20%20%20%20%20d%3D%22m%20367.73366%2C274.05962%20c%20-8.07696%2C8.2e-4%20-14.62596%2C7.27591%20-14.625%2C16.25%201e-5%2C0.13773%200.0282%2C0.26934%200.0312%2C0.40625%20-0.0119%2C1.21936%20-0.0708%2C2.68836%20-0.0312%2C3.75%200.19262%2C5.176%201.3209%2C9.13749%202%2C13.90625%201.23028%2C10.20666%202.26117%2C18.66736%201.625%2C26.53125%20-0.61869%2C2.9654%20-2.80288%2C5.67741%20-4.75%2C7.5625%20l%20-0.34375%2C6.1875%20c%20-8.77682%2C0.72717%20-17.61235%2C2.05874%20-26.4375%2C4.0625%20-37.97461%2C8.62218%20-70.67008%2C28.18307%20-95.5625%2C54.59375%20-1.61522%2C-1.10193%20-4.44103%2C-3.12914%20-5.2813%2C-3.75%20-2.61117%2C0.35262%20-5.25021%2C1.15829%20-8.6875%2C-0.84375%20-6.54491%2C-4.40563%20-12.50587%2C-10.48693%20-19.71875%2C-17.8125%20-3.30498%2C-3.50419%20-5.69832%2C-6.84101%20-9.625%2C-10.21875%20-0.89172%2C-0.76707%20-2.25258%2C-1.80455%20-3.25%2C-2.59375%20-3.06988%2C-2.44757%20-6.6907%2C-3.72402%20-10.1875%2C-3.84375%20-4.49589%2C-0.15394%20-8.82394%2C1.60385%20-11.65625%2C5.15625%20-5.03521%2C6.31538%20-3.42312%2C15.96805%203.59375%2C21.5625%200.0712%2C0.0567%200.14702%2C0.10078%200.21875%2C0.15625%200.96422%2C0.78162%202.14496%2C1.78313%203.03125%2C2.4375%204.16687%2C3.07655%207.9732%2C4.65145%2012.125%2C7.09375%208.747%2C5.40181%2015.99837%2C9.88086%2021.75%2C15.28125%202.24602%2C2.39417%202.63858%2C6.61292%202.9375%2C8.4375%20l%204.6875%2C4.1875%20c%20-25.09342%2C37.76368%20-36.70686%2C84.40946%20-29.8437%2C131.9375%20l%20-6.125%2C1.78125%20c%20-1.6143%2C2.08461%20-3.89541%2C5.36474%20-6.2813%2C6.34375%20-7.52513%2C2.37021%20-15.99424%2C3.24059%20-26.21875%2C4.3125%20-4.80031%2C0.39915%20-8.94218%2C0.16095%20-14.03125%2C1.125%20-1.12008%2C0.21218%20-2.68072%2C0.61877%20-3.90625%2C0.90625%20-0.0426%2C0.009%20-0.0824%2C0.0216%20-0.125%2C0.0312%20-0.0668%2C0.0155%20-0.15456%2C0.0479%20-0.21875%2C0.0625%20-8.62014%2C2.08279%20-14.15774%2C10.006%20-12.375%2C17.8125%201.78316%2C7.80833%2010.20314%2C12.55677%2018.875%2C10.6875%200.0626%2C-0.0143%200.1535%2C-0.0167%200.21875%2C-0.0312%200.0979%2C-0.0224%200.18409%2C-0.0699%200.28125%2C-0.0937%201.20885%2C-0.26536%202.72377%2C-0.5606%203.78125%2C-0.84375%205.00334%2C-1.33963%208.62694%2C-3.30796%2013.125%2C-5.03125%209.67694%2C-3.47077%2017.69173%2C-6.37022%2025.5%2C-7.5%203.26118%2C-0.25542%206.69711%2C2.01216%208.40625%2C2.96875%20l%206.375%2C-1.09375%20c%2014.67018%2C45.48282%2045.41416%2C82.24502%2084.34375%2C105.3125%20l%20-2.65625%2C6.375%20c%200.95742%2C2.47542%202.01341%2C5.8247%201.30022%2C8.26932%20-2.83868%2C7.3612%20-7.70097%2C15.13097%20-13.23772%2C23.79318%20-2.68085%2C4.00192%20-5.42453%2C7.10761%20-7.84375%2C11.6875%20-0.5789%2C1.09589%20-1.31618%2C2.77932%20-1.875%2C3.9375%20-3.75884%2C8.04236%20-1.00164%2C17.3052%206.21875%2C20.78125%207.26575%2C3.49788%2016.28447%2C-0.19134%2020.1875%2C-8.25%200.006%2C-0.0114%200.0257%2C-0.0198%200.0312%2C-0.0312%200.004%2C-0.009%20-0.004%2C-0.0225%200%2C-0.0312%200.55593%2C-1.14255%201.34353%2C-2.64437%201.8125%2C-3.71875%202.07213%2C-4.74702%202.76161%2C-8.81506%204.21875%2C-13.40625%203.86962%2C-9.72014%205.99567%2C-19.91903%2011.32258%2C-26.27411%201.45868%2C-1.74023%203.83681%2C-2.4095%206.30242%2C-3.06964%20l%203.3125%2C-6%20c%2033.93824%2C13.0268%2071.92666%2C16.52246%20109.875%2C7.90625%208.65697%2C-1.96557%2017.01444%2C-4.50945%2025.09375%2C-7.5625%200.93098%2C1.65133%202.66113%2C4.8257%203.125%2C5.625%202.50559%2C0.81518%205.24044%2C1.23614%207.46875%2C4.53125%203.98539%2C6.80898%206.7109%2C14.86416%2010.03125%2C24.59375%201.45738%2C4.59111%202.17762%2C8.65933%204.25%2C13.40625%200.47234%2C1.08195%201.256%2C2.60486%201.8125%2C3.75%203.89482%2C8.08484%2012.94212%2C11.78667%2020.21875%2C8.28125%207.2195%2C-3.4779%209.97974%2C-12.7399%206.21875%2C-20.78125%20-0.55889%2C-1.15814%20-1.3273%2C-2.84164%20-1.90625%2C-3.9375%20-2.41946%2C-4.57976%20-5.1627%2C-7.65448%20-7.84375%2C-11.65625%20-5.53721%2C-8.66192%20-10.12968%2C-15.8577%20-12.96875%2C-23.21875%20-1.18711%2C-3.79657%200.20028%2C-6.15774%201.125%2C-8.625%20-0.55378%2C-0.63477%20-1.73881%2C-4.22009%20-2.4375%2C-5.90625%2040.4574%2C-23.88816%2070.29856%2C-62.02129%2084.3125%2C-106.0625%201.8924%2C0.29742%205.18154%2C0.87936%206.25%2C1.09375%202.19954%2C-1.4507%204.22194%2C-3.34352%208.1875%2C-3.03125%207.80832%2C1.12937%2015.82288%2C4.02973%2025.5%2C7.5%204.49815%2C1.72306%208.1216%2C3.72313%2013.125%2C5.0625%201.05749%2C0.28309%202.57238%2C0.5472%203.78125%2C0.8125%200.0972%2C0.0238%200.1833%2C0.0714%200.28125%2C0.0937%200.0653%2C0.0146%200.15615%2C0.0169%200.21875%2C0.0312%208.67236%2C1.86695%2017.09384%2C-2.87871%2018.875%2C-10.6875%201.78074%2C-7.80696%20-3.7543%2C-15.73201%20-12.375%2C-17.8125%20-1.25393%2C-0.28513%20-3.03225%2C-0.76938%20-4.25%2C-1%20-5.08912%2C-0.96378%20-9.23092%2C-0.7261%20-14.03125%2C-1.125%20-10.22456%2C-1.07138%20-18.6935%2C-1.94269%20-26.21875%2C-4.3125%20-3.06826%2C-1.19028%20-5.25103%2C-4.84124%20-6.31255%2C-6.34375%20l%20-5.90625%2C-1.71875%20c%203.06226%2C-22.15442%202.23655%2C-45.21134%20-3.0625%2C-68.28125%20-5.34839%2C-23.28471%20-14.80037%2C-44.58084%20-27.40625%2C-63.34375%201.51505%2C-1.37729%204.37619%2C-3.91091%205.1875%2C-4.65625%200.23716%2C-2.62417%200.0334%2C-5.37553%202.75%2C-8.28125%205.75134%2C-5.40069%2013.00329%2C-9.87898%2021.75%2C-15.28125%204.15167%2C-2.44252%207.98954%2C-4.01698%2012.15625%2C-7.09375%200.94225%2C-0.69576%202.2289%2C-1.79759%203.21875%2C-2.59375%207.01538%2C-5.59633%208.63058%2C-15.24842%203.59375%2C-21.5625%20-5.03683%2C-6.31408%20-14.79712%2C-6.90883%20-21.8125%2C-1.3125%20-0.99856%2C0.79085%20-2.35353%2C1.82252%20-3.25%2C2.59375%20-3.9265%2C3.37796%20-6.35145%2C6.71439%20-9.65625%2C10.21875%20-7.21249%2C7.32595%20-13.17407%2C13.43777%20-19.71875%2C17.84375%20-2.83601%2C1.65106%20-6.98996%2C1.07978%20-8.87505%2C0.96875%20l%20-5.5625%2C3.96875%20c%20-31.7188%2C-33.26057%20-74.90466%2C-54.52546%20-121.40605%2C-58.6563%20-0.13006%2C-1.94872%20-0.30045%2C-5.47117%20-0.34375%2C-6.53125%20-1.90371%2C-1.82165%20-4.20342%2C-3.37686%20-4.78125%2C-7.3125%20-0.63617%2C-7.86389%200.42597%2C-16.32459%201.65625%2C-26.53125%200.6791%2C-4.76876%201.80738%2C-8.73025%202%2C-13.90625%200.0438%2C-1.17663%20-0.0265%2C-2.88401%20-0.0312%2C-4.15625%20-9.6e-4%2C-8.97409%20-6.54804%2C-16.25082%20-14.625%2C-16.25%20z%20m%20-18.3125%2C113.4375%20-4.34375%2C76.71875%20-0.3125%2C0.15625%20c%20-0.29134%2C6.86335%20-5.93996%2C12.34375%20-12.875%2C12.34375%20-2.84081%2C0%20-5.46294%2C-0.91229%20-7.59375%2C-2.46875%20l%20-0.125%2C0.0625%20-62.90625%2C-44.59375%20c%2019.33365%2C-19.01115%2044.06291%2C-33.06039%2072.5625%2C-39.53125%205.20599%2C-1.18203%2010.40966%2C-2.0591%2015.59375%2C-2.6875%20z%20m%2036.65625%2C0%20c%2033.27347%2C4.09232%2064.04501%2C19.15882%2087.625%2C42.25%20l%20-62.5%2C44.3125%20-0.21875%2C-0.0937%20c%20-5.54745%2C4.05169%20-13.36343%2C3.04639%20-17.6875%2C-2.375%20-1.77132%2C-2.22096%20-2.70072%2C-4.83239%20-2.8125%2C-7.46875%20l%20-0.0625%2C-0.0312%20z%20m%20-147.625%2C70.875%2057.4375%2C51.375%20-0.0625%2C0.3125%20c%205.18437%2C4.50697%205.94888%2C12.32794%201.625%2C17.75%20-1.7712%2C2.22105%20-4.14208%2C3.71074%20-6.6875%2C4.40625%20l%20-0.0625%2C0.25%20-73.625%2C21.25%20c%20-3.74728%2C-34.26517%204.32855%2C-67.57364%2021.375%2C-95.34375%20z%20m%20258.15625%2C0.0312%20c%208.5341%2C13.83256%2014.99655%2C29.28214%2018.84375%2C46.03125%203.80106%2C16.54828%204.75499%2C33.06697%203.1875%2C49.03125%20l%20-74%2C-21.3125%20-0.0625%2C-0.3125%20c%20-6.6265%2C-1.81104%20-10.69893%2C-8.55162%20-9.15625%2C-15.3125%200.63203%2C-2.76962%202.10222%2C-5.11264%204.09375%2C-6.84375%20l%20-0.0312%2C-0.15625%2057.125%2C-51.125%20z%20m%20-140.65625%2C55.3125%2023.53125%2C0%2014.625%2C18.28125%20-5.25%2C22.8125%20-21.125%2C10.15625%20-21.1875%2C-10.1875%20-5.25%2C-22.8125%20z%20m%2075.4375%2C62.5625%20c%200.99997%2C-0.0505%201.99558%2C0.0396%202.96875%2C0.21875%20l%200.125%2C-0.15625%2076.15625%2C12.875%20c%20-11.1455%2C31.3131%20-32.47281%2C58.44018%20-60.96875%2C76.59375%20l%20-29.5625%2C-71.40625%200.0937%2C-0.125%20c%20-2.71561%2C-6.30999%200.002%2C-13.70956%206.25%2C-16.71875%201.59965%2C-0.77041%203.27089%2C-1.19701%204.9375%2C-1.28125%20z%20m%20-127.90625%2C0.3125%20c%205.81174%2C0.0815%2011.02462%2C4.11525%2012.375%2C10.03125%200.63219%2C2.76958%200.3245%2C5.51375%20-0.71875%2C7.9375%20l%200.21875%2C0.28125%20-29.25%2C70.6875%20c%20-27.34716%2C-17.5486%20-49.12927%2C-43.82403%20-60.78125%2C-76.06245%20l%2075.5%2C-12.8125%200.125%2C0.15625%20c%200.84451%2C-0.15541%201.701%2C-0.2304%202.53125%2C-0.21875%20z%20m%2063.78125%2C30.9688%20c%202.02445%2C-0.0744%204.07865%2C0.34098%206.03125%2C1.28125%202.55951%2C1.23253%204.53673%2C3.17319%205.78125%2C5.5%20l%200.28125%2C0%2037.21875%2C67.25%20c%20-4.83029%2C1.61923%20-9.79609%2C3.00308%20-14.875%2C4.15625%20-28.46453%2C6.4629%20-56.83862%2C4.50467%20-82.53125%2C-4.25%20l%2037.125%2C-67.125%200.0625%2C0%20c%202.22767%2C-4.16441%206.45247%2C-6.64887%2010.90625%2C-6.8125%20z%22%20%20%20%20%20%20%20%20%20style%3D%22font-size%3Amedium%3Bfont-style%3Anormal%3Bfont-variant%3Anormal%3Bfont-weight%3Anormal%3Bfont-stretch%3Anormal%3Btext-indent%3A0%3Btext-align%3Astart%3Btext-decoration%3Anone%3Bline-height%3Anormal%3Bletter-spacing%3Anormal%3Bword-spacing%3Anormal%3Btext-transform%3Anone%3Bdirection%3Altr%3Bblock-progression%3Atb%3Bwriting-mode%3Alr-tb%3Btext-anchor%3Astart%3Bbaseline-shift%3Abaseline%3Bcolor%3A%23000000%3Bfill%3A%23ffffff%3Bfill-opacity%3A1%3Bstroke%3A%23ffffff%3Bstroke-width%3A0.25%3Bstroke-miterlimit%3A4%3Bstroke-opacity%3A1%3Bstroke-dasharray%3Anone%3Bmarker%3Anone%3Bvisibility%3Avisible%3Bdisplay%3Ainline%3Boverflow%3Avisible%3Benable-background%3Aaccumulate%3Bfont-family%3ASans%3B-inkscape-font-specification%3ASans%22%20%20%20%20%20%20%20%20%20sodipodi%3Anodetypes%3D%22ccccccccsccccscssccsccccccccscccsccccccccccccccscccscsccsccccscscsccccccccscccscsccccsccccscscscccccccccccccccscccsccccccccccccscccccscccccccccccccccccccccccscccscccccccccscccscccc%22%20%20%20%20%20%20%20%20%20inkscape%3Aexport-filename%3D%22.%2Fpath3059.png%22%20%20%20%20%20%20%20%20%20inkscape%3Aexport-xdpi%3D%22250.55%22%20%20%20%20%20%20%20%20%20inkscape%3Aexport-ydpi%3D%22250.55%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var mavenFileIcon = "data:image/svg+xml,%3Csvg%20xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2232mm%22%20width%3D%2232mm%22%20version%3D%221.1%22%20xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%20xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%20viewBox%3D%220%200%20113.38583%20113.38582%22%3E%20%3Cg%20transform%3D%22translate%28-212.06%20-472.38%29%22%3E%20%20%3Cg%20transform%3D%22translate%288.4853%20-1.4142%29%22%3E%20%20%20%3Cpath%20fill%3D%22%23e8a1a2%22%20d%3D%22m240.91%20580.01c-1.4824-4.2852-3.0745-9.2894-3.538-11.12-1.1372-4.4931-1.6472-4.8098-4.1569-2.5813-2.1418%201.9018-2.1462%201.9003-0.97095-0.33946%201.0077-1.9204%200.9278-2.25-0.54562-2.25-1.5731%200-1.5619-0.12023%200.12599-1.3544%201.7365-1.2698%201.6088-1.5199-2.041-4-2.4685-1.6774-3.2594-2.6456-2.1612-2.6456%202.1818%200%202.2506%200.42403-1.1547-7.1117-6.3934-14.148-9.1638-31.223-8.7054-53.655%200.26565-13%200.57841-15.561%202.1071-17.25%202.169-2.3967%202.745-2.4287%207.0398-0.39064%202.1654%201.0275%204.0683%203.0685%205.3612%205.75%202.5118%205.2098%204.2463%2018.35%202.7926%2021.157-0.92374%201.7835-0.85705%201.8525%200.61602%200.63738%202.0383-1.6814%202.7958-0.21965%203.0241%205.835%200.0833%202.209%200.54518%204.0188%201.0264%204.0219%200.48125%200.003%200.605%201.3557%200.275%203.0057s-0.19352%203%200.30328%203c2.6941%200%203.7428%2017.64%201.4808%2024.906-1.6203%205.2051%201.6784%200.7327%205.5919-7.5816%207.4605-15.85%2018.983-31.543%2033.937-46.223%2010.047-9.862%2014.218-12.61%2016.932-11.158%207.3999%203.9603%204.4295%2017.155-6.47%2028.741-2.791%202.9668-4.4785%205.1654-3.75%204.8858%202.3126-0.88743%201.4341%201.8404-1.8925%205.8761-1.7694%202.1466-3.3115%204.5462-3.4269%205.3325s-1.1503%202.0883-2.2997%202.8934c-1.1494%200.80509-1.8715%201.8172-1.6045%202.2491%200.64529%201.0441-4.8466%209.7279-8.8005%2013.915-3.6411%203.8562-9.5531%207.1556-12.862%207.1777-1.6096%200.0108-1.8993%200.26298-0.97519%200.84897%201.5334%200.97236%206.1197%200.31492%207.9595-1.141%200.70079-0.55456%201.5178-0.76462%201.8157-0.46679%200.68106%200.68106-5.8716%205.7435-7.4342%205.7435-0.63559%200-1.1556%200.43588-1.1556%200.96861%200%200.53274%200.74882%200.68127%201.664%200.33007%201.1573-0.44408%201.4322-0.26346%200.90287%200.59306-1.0808%201.7487-5.096%203.1042-9.7336%203.2859-3.501%200.13718-3.9164%200.40636-3.456%202.2391%200.50216%201.9991%200.4667%202.0075-0.87842%200.20849-1.2384-1.6564-1.0516-2.5682%201.604-7.8289%202.721-5.3903%2013.868-24.641%2017.811-30.758%200.8725-1.3537%201.0905-2.1559%200.4845-1.7825-1.7197%201.0594-17.765%2028.347-24.189%2041.136l-2.5006%204.9786%202.7335%208.3935c3.4677%2010.648%202.7166%2011.942-0.88644%201.5269zm-0.10056-17.041c0.42418-1.404%200.25625-2.25-0.44662-2.25-0.61952%200-0.86751%200.41891-0.55108%200.9309%200.31644%200.512%200.16515%201.1844-0.33619%201.4943-0.50134%200.30984-1.1943-0.17347-1.5398-1.074-0.34558-0.90056-0.85533-1.4104-1.1328-1.133-0.27744%200.27744-0.0251%201.7651%200.5607%203.306%201.1274%202.9652%202.2955%202.5332%203.4458-1.2742zm-5.5256-9.9968c-1.0612-3.7108-1.9294-7.1608-1.9294-7.6667%200-0.50592-0.25022-0.66963-0.55604-0.36381-0.52233%200.52233%202.1863%2012.37%203.2048%2014.018%201.2636%202.0446%201.0362%200.15112-0.71935-5.9875zm-4.4557-17.727c-0.93421-4.1991-1.9183-7.415-2.1869-7.1464-0.26861%200.2686%200.31288%203.8871%201.2922%208.0411%200.97931%204.154%201.9634%207.3699%202.1869%207.1464%200.2235-0.22351-0.35799-3.842-1.2922-8.0411zm-3.0737-14.426c-0.36648-2.2918-0.87608-3.9572-1.1324-3.7009-0.25636%200.25637-0.15176%202.3268%200.23245%204.6009s0.89381%203.9395%201.1324%203.7009c0.23863-0.23864%200.13403-2.309-0.23245-4.6009zm45.009-6.1437c3.0475-4.424%205.0948-7.768%204.5497-7.4311-1.1721%200.72439-11.233%2015.475-10.555%2015.475%200.25562%200%202.9582-3.6196%206.0056-8.0437zm-46.726-1.1438c-0.31922-0.79773-0.55618-0.56078-0.60416%200.60417-0.0434%201.0542%200.19292%201.6448%200.52522%201.3125%200.33229-0.3323%200.36781-1.1948%200.0789-1.9167zm-0.99378-9.5625c-0.25153-0.9625-0.45733-0.175-0.45733%201.75s0.2058%202.7125%200.45733%201.75c0.25152-0.9625%200.25152-2.5375%200-3.5zm55.438%200c1.2439-1.5861%201.2085-1.6214-0.37756-0.37756-1.6658%201.3064-2.1955%202.1276-1.3724%202.1276%200.20765%200%200.99515-0.7875%201.75-1.75zm-50.173%2080.37c1.8714-4.922%206.1906-12.808%206.7233-12.275%200.64112%200.64113-5.4132%2013.374-6.7529%2014.202-0.54189%200.33491-0.52977-0.45565%200.0295-1.9267z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23f8a52a%22%20d%3D%22m233.34%20578.74c2.2061-4.3878%204.0112-8.9144%204.0112-10.059%200-1.1447%200.36736-1.8542%200.81635-1.5767%200.44899%200.27749%201.5191-1.046%202.3781-2.941%201.2158-2.6824%201.275-3.4455%200.26698-3.4455-0.7121%200-1.4875%200.5625-1.723%201.25-1.3539%203.9511-11.385-39.693-14.286-62.157l-1.368-10.593%200.37967%2010c0.51206%2013.487%205.5806%2038.798%2012.514%2062.493%201.2478%204.2643%201.2661%204.9404%200.0831%203.0709-0.70095-1.1077-1.2282-1.1704-2.3079-0.27424-1.1575%200.96065-1.324%200.64698-0.96271-1.8143%200.24021-1.6367%200.0482-2.9858-0.42675-2.998-0.47493-0.0122-1.9885-0.95412-3.3635-2.0931-1.7885-1.4815-1.9782-1.9019-0.66644-1.4771%201.0085%200.32657%201.6639%200.25596%201.4566-0.15691-8.5314-16.99-11.952-33.628-11.87-57.739%200.0614-18.043%200.65624-20.888%204.4601-21.335%207.1233-0.83622%2011.788%207.2931%2011.99%2020.896%200.0995%206.7048%200.41125%208.5089%201.3385%207.7456%201.6189-1.3328%202.7298%203.0911%201.9629%207.8168-0.49112%203.0264-0.36328%203.3534%200.90085%202.3043%201.1834-0.98217%201.3868-0.94897%201.0338%200.1688-0.24165%200.76529-0.73025%202.7075-1.0858%204.3161-0.54261%202.455-0.41766%202.7348%200.7782%201.7423%201.1895-0.98722%201.6353-0.18963%202.7012%204.8334%201.5414%207.2635%200.83326%2014.446-1.9652%2019.931-1.1416%202.2376-1.649%204.0684-1.1278%204.0684%201.6726%200%204.659-4.6191%2010.471-16.196%206.6604-13.266%2015.19-25.095%2027.19-37.705%2015.39-16.173%2021.504-19.166%2024.479-11.986%201.047%202.5278%201.06%204.0393%200.0665%207.7627-2.0495%207.6813-10.5%2019.159-15.205%2020.653-2.5932%200.82304-1.4824%202.4338%201.1954%201.7336%202.0694-0.54117%202.0658-0.49392-0.23563%203.0169-1.2859%201.9617-3.6686%204.3527-5.295%205.3134-2.5848%201.5269-2.7263%201.8276-1.1244%202.3896%201.576%200.55283%201.3578%200.9467-1.5584%202.8134-2.2594%201.4463-2.8101%202.1762-1.6502%202.1875%201.4874%200.0144%201.3089%200.71866-1.2265%204.8392-5.5503%209.0204-14.408%2016.082-20.264%2016.156-0.9625%200.0121-1.75%200.47196-1.75%201.022%200%201.3119%205.5942%201.2875%208.0657-0.0352%201.0638-0.56935%201.9343-0.75399%201.9343-0.4103%200%201.1947-4.5108%204.3792-6.25%204.4122-1.9687%200.0374-2.4476%202.0155-0.5%202.0651%200.70412%200.0179%200.40229%200.67298-0.69113%201.5-1.0894%200.82402-4.077%201.4682-6.809%201.4682-3.4249%200-4.6564%200.34222-4.1544%201.1545%200.43457%200.70315%200.2751%200.88354-0.40791%200.46142-2.661-1.6446%2023.158-44.042%2037.881-62.204%209.6668-11.925%2010.352-13.178%202.9574-5.4121-11.195%2011.758-25.777%2033.509-40.138%2059.871-6.1651%2011.317-7.6224%2014.756-6.8581%2016.184%200.53378%200.99738%200.94199%202.4055%200.90712%203.1292-0.0349%200.72366-0.52319%200.19074-1.0852-1.1843-0.97068-2.375-1.2182-2.1124-4.9487%205.25-2.1598%204.2625-4.1515%207.75-4.426%207.75-0.27449%200%201.306-3.59%203.5121-7.9778zm9.0901%205.3096c-0.0434-0.64252-0.33793-1.9925-0.65446-3-0.54705-1.7412-0.51883-1.7434%200.57078-0.0441%200.63045%200.98322%200.92496%202.3332%200.65445%203-0.35498%200.87499-0.51379%200.88727-0.57077%200.0441z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23ee8a2e%22%20d%3D%22m233.34%20578.74c2.2061-4.3878%204.0112-8.9144%204.0112-10.059%200-1.1447%200.36736-1.8542%200.81635-1.5767%200.44899%200.27749%201.5191-1.046%202.3781-2.941%201.2158-2.6824%201.275-3.4455%200.26698-3.4455-0.7121%200-1.4875%200.5625-1.723%201.25-1.4444%204.2152-12.641-45.572-14.224-63.25l-0.67174-7.5%203.9696-3.8462%203.9696-3.8462%201.2942%203.8462c0.71181%202.1154%201.3235%207.2934%201.3593%2011.507%200.0499%205.8679%200.34798%207.4268%201.2739%206.6618%201.6189-1.3376%202.7301%203.0854%201.9629%207.8133-0.49112%203.0264-0.36328%203.3534%200.90085%202.3043%201.1834-0.98217%201.3868-0.94897%201.0338%200.1688-0.24165%200.76529-0.73025%202.7075-1.0858%204.3161-0.54261%202.455-0.41766%202.7348%200.7782%201.7423%201.1895-0.98722%201.6353-0.18963%202.7012%204.8334%201.5414%207.2635%200.83326%2014.446-1.9652%2019.931-1.1416%202.2376-1.649%204.0684-1.1278%204.0684%201.6726%200%204.659-4.6191%2010.471-16.196%203.1212-6.217%208.5466-15.168%2012.056-19.89%206.4511-8.6802%2022.123-25.914%2023.566-25.914%200.4305%200%201.0767%201.1712%201.4359%202.6026%200.51967%202.0705-0.0742%203.4504-2.9048%206.75-10.644%2012.407-25.113%2034.515-37.644%2057.518-6.1651%2011.317-7.6224%2014.756-6.8581%2016.184%200.53378%200.99738%200.94199%202.4055%200.90712%203.1292-0.0349%200.72366-0.52319%200.19074-1.0852-1.1843-0.97068-2.375-1.2182-2.1124-4.9487%205.25-2.1598%204.2625-4.1515%207.75-4.426%207.75-0.27449%200%201.306-3.59%203.5121-7.9778zm9.0901%205.3096c-0.0434-0.64252-0.33793-1.9925-0.65446-3-0.54705-1.7412-0.51883-1.7434%200.57078-0.0441%200.63045%200.98322%200.92496%202.3332%200.65445%203-0.35498%200.87499-0.51379%200.88727-0.57077%200.0441zm-9.2887-21.356c0.24021-1.6367%200.0482-2.9858-0.42675-2.998-0.47493-0.0122-1.9885-0.95412-3.3635-2.0931-1.7885-1.4815-1.9782-1.9019-0.66644-1.4771%201.0085%200.32657%201.6639%200.25596%201.4566-0.15691-8.9594-17.843-12.488-36.385-11.898-62.524l0.10773-4.7731%202.3532%201.5419c2.083%201.3648%202.42%202.5444%202.9354%2010.273%200.87913%2013.184%206.336%2039.513%2012.689%2061.225%201.2478%204.2643%201.2661%204.9404%200.0831%203.0709-0.70095-1.1077-1.2282-1.1704-2.3079-0.27424-1.1575%200.96065-1.324%200.64698-0.96271-1.8143zm11.943%200.42401c-1.8279-1.8279%2024.6-44.87%2037.239-60.65l6.2075-7.75h5.9103c7.0286%200%207.2251%200.58116%202.5402%207.5134-4.0552%206.0005-8.1478%2010.199-10.746%2011.023-2.5763%200.81769-1.4423%202.422%201.2199%201.7258%202.0694-0.54117%202.0658-0.49392-0.23563%203.0169-1.2859%201.9617-3.6686%204.3527-5.295%205.3134-2.5848%201.5269-2.7263%201.8276-1.1244%202.3896%201.576%200.55283%201.3578%200.9467-1.5584%202.8134-2.2594%201.4463-2.8101%202.1762-1.6502%202.1875%201.4874%200.0144%201.3089%200.71866-1.2265%204.8392-5.5503%209.0204-14.408%2016.082-20.264%2016.156-0.9625%200.0121-1.75%200.47196-1.75%201.022%200%201.3119%205.5942%201.2875%208.0657-0.0352%201.0638-0.56935%201.9343-0.75399%201.9343-0.4103%200%201.1947-4.5108%204.3792-6.25%204.4122-1.9687%200.0374-2.4476%202.0155-0.5%202.0651%200.70412%200.0179%200.40229%200.67298-0.69113%201.5-1.0894%200.82402-4.077%201.4682-6.809%201.4682-2.9906%200-4.6295%200.38564-4.2498%201%200.67773%201.0966%200.18616%201.3528-0.76691%200.39976z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23a0579b%22%20d%3D%22m233.34%20578.74c2.2061-4.3878%204.0112-8.9144%204.0112-10.059%200-1.1447%200.36736-1.8542%200.81635-1.5767%200.44899%200.27749%201.5191-1.046%202.3781-2.941%201.2158-2.6824%201.275-3.4455%200.26698-3.4455-0.7121%200-1.4875%200.5625-1.723%201.25-1.4255%204.1602-13.738-50.443-13.738-60.925%200-3.9763%200.2069-4.3251%202.5657-4.3251%201.4112%200%203.4251-0.45991%204.4754-1.022%201.6085-0.86085%202.0116-0.61573%202.5563%201.5543%200.35564%201.417%200.38906%204.1634%200.0743%206.1032-0.47971%202.9561-0.34429%203.3376%200.83677%202.3575%201.1386-0.94491%201.5364-0.66207%202.0723%201.4731%200.36478%201.4534%200.40568%204.2296%200.0909%206.1694-0.49112%203.0264-0.36327%203.3534%200.90086%202.3043%201.1834-0.98217%201.3868-0.94897%201.0338%200.1688-0.24166%200.76529-0.73026%202.7075-1.0858%204.3161-0.54261%202.455-0.41766%202.7348%200.7782%201.7423%201.1895-0.98722%201.6353-0.18963%202.7012%204.8334%201.5414%207.2635%200.83326%2014.446-1.9652%2019.931-1.1416%202.2376-1.649%204.0684-1.1278%204.0684%201.6726%200%204.659-4.6191%2010.471-16.196%205.815-11.583%2014.544-24.164%2023.356-33.663%204.7543-5.1249%205.0822-5.2996%207.5078-4l2.5364%201.359-7.9171%2010.904c-9.8621%2013.583-20.076%2029.991-29.524%2047.428-5.6996%2010.52-7.063%2013.813-6.3051%2015.229%200.53191%200.99388%200.93859%202.3991%200.90372%203.1228-0.0349%200.72366-0.52319%200.19074-1.0852-1.1843-0.97068-2.375-1.2182-2.1124-4.9487%205.25-2.1598%204.2625-4.1515%207.75-4.426%207.75-0.27449%200%201.306-3.59%203.5121-7.9778zm9.0901%205.3096c-0.0434-0.64252-0.33793-1.9925-0.65446-3-0.54705-1.7412-0.51883-1.7434%200.57078-0.0441%200.63045%200.98322%200.92496%202.3332%200.65445%203-0.35498%200.87499-0.51379%200.88727-0.57077%200.0441zm-9.2887-21.356c0.24021-1.6367%200.0482-2.9858-0.42675-2.998-0.47493-0.0122-1.9885-0.95412-3.3635-2.0931-1.7885-1.4815-1.9782-1.9019-0.66644-1.4771%201.0085%200.32657%201.6639%200.25596%201.4566-0.15691-7.5974-15.13-11.778-32.994-11.786-50.362-0.004-8.5328%200.0177-8.6072%202.3774-8.1561%202.1048%200.40235%202.4608%201.1704%203.0642%206.6113%201.4438%2013.019%207.1395%2039.22%2012.532%2057.649%201.2478%204.2643%201.2661%204.9404%200.0831%203.0709-0.70095-1.1077-1.2282-1.1704-2.3079-0.27424-1.1575%200.96065-1.324%200.64698-0.96271-1.8143zm11.943%200.42401c-1.6524-1.6524%2024.342-44.54%2035.278-58.204%204.2053-5.2544%204.2649-5.2867%206.367-3.4544%201.1671%201.0173%203.3335%202.4537%204.8144%203.1922%202.6064%201.2997%202.6383%201.4164%201%203.6512-0.93085%201.2697-3.1274%203.0951-4.8813%204.0563-3.4635%201.8982-3.5904%203.506-0.20681%202.6212%202.0694-0.54117%202.0658-0.49392-0.23563%203.0169-1.2859%201.9617-3.6686%204.3527-5.295%205.3134-2.5848%201.5269-2.7263%201.8276-1.1244%202.3896%201.576%200.55283%201.3578%200.9467-1.5584%202.8134-2.2594%201.4463-2.8101%202.1762-1.6502%202.1875%201.4874%200.0144%201.3089%200.71866-1.2265%204.8392-5.5503%209.0204-14.408%2016.082-20.264%2016.156-0.9625%200.0121-1.75%200.47196-1.75%201.022%200%201.3119%205.5942%201.2875%208.0657-0.0352%201.0638-0.56935%201.9343-0.75399%201.9343-0.4103%200%201.1947-4.5108%204.3792-6.25%204.4122-1.9687%200.0374-2.4476%202.0155-0.5%202.0651%200.70412%200.0179%200.40229%200.67298-0.69113%201.5-1.0894%200.82402-4.077%201.4682-6.809%201.4682-2.9906%200-4.6295%200.38564-4.2498%201%200.67773%201.0966%200.18616%201.3528-0.76691%200.39976z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23d9555d%22%20d%3D%22m232.38%20581.22c0-0.55%200.43621-1.675%200.96937-2.5s0.96937-1.05%200.96937-0.5-0.43621%201.675-0.96937%202.5-0.96937%201.05-0.96937%200.5zm1.9694-18.927c0-0.78508-1.1097-2.3003-2.4661-3.3672s-2.1836-2.2223-1.8383-2.5676c0.34526-0.34526-0.53192-2.7675-1.9493-5.3828-5.633-10.394-9.7349-29.495-9.7423-45.366-0.004-8.5328%200.0177-8.6072%202.3774-8.1561%202.1048%200.40235%202.4608%201.1704%203.0642%206.6113%201.3157%2011.864%207.161%2039.457%2012.161%2057.406%200.38001%201.3642%200.18716%202.25-0.48987%202.25-0.61415%200-1.1166-0.64234-1.1166-1.4274zm13.085-1.4621c-1.1463-0.75519-0.12074-3.2717%205.4085-13.271%207.5732-13.696%2020.99-34.488%2027.517-42.643%204.2053-5.2544%204.2649-5.2867%206.367-3.4544%201.1671%201.0173%203.3335%202.4537%204.8144%203.1922%202.6064%201.2997%202.6383%201.4164%201%203.6512-0.93085%201.2697-3.1274%203.0951-4.8813%204.0563-3.4635%201.8982-3.5904%203.506-0.20681%202.6212%202.0694-0.54117%202.0658-0.49392-0.23563%203.0169-1.2859%201.9617-3.6686%204.3527-5.295%205.3134-2.5848%201.5269-2.7263%201.8276-1.1244%202.3896%201.576%200.55283%201.3578%200.9467-1.5584%202.8134-2.2594%201.4463-2.8101%202.1762-1.6502%202.1875%201.4874%200.0144%201.3089%200.71866-1.2265%204.8392-5.7488%209.343-14.425%2016.094-20.764%2016.156-1.2375%200.0121-2.25%200.52921-2.25%201.1492%200%200.75009%201.6731%200.96646%205.0007%200.64673%204.0039-0.38473%204.7874-0.22358%203.9309%200.80849-0.58837%200.70895-2.3887%201.5787-4.0007%201.9327-3.1838%200.69928-4.0133%202.466-1.1809%202.5152%201.4792%200.0257%201.5179%200.16633%200.25%200.90866-2.5006%201.4641-8.4104%202.1624-9.9146%201.1714zm-10.35-2.8605c-0.27024-1.5125-1.9027-7.925-3.6276-14.25-3.8171-13.997-8.108-36.524-8.108-42.567%200-4.0926%200.19724-4.4334%202.5657-4.4334%201.4112%200%203.4251-0.45991%204.4754-1.022%201.6085-0.86085%202.0116-0.61573%202.5563%201.5543%200.35564%201.417%200.38906%204.1634%200.0743%206.1032-0.47971%202.9561-0.34429%203.3376%200.83677%202.3575%201.1386-0.94491%201.5364-0.66207%202.0723%201.4731%200.36478%201.4534%200.40568%204.2296%200.0909%206.1694-0.49112%203.0264-0.36327%203.3534%200.90086%202.3043%201.1834-0.98217%201.3868-0.94897%201.0338%200.1688-0.24166%200.76529-0.73026%202.7075-1.0858%204.3161-0.54261%202.455-0.41766%202.7348%200.7782%201.7423%201.1895-0.98722%201.6353-0.18963%202.7012%204.8334%201.6176%207.6223%200.76802%2014.931-2.3929%2020.587-1.3565%202.4271-2.0831%204.4129-1.6147%204.4129%201.1318%200%208.0075-8.072%208.0075-9.4007%200-0.57236%202.0354-5.1039%204.5232-10.07%204.7721-9.5263%2013.911-22.441%2022.211-31.388%204.7543-5.1249%205.0822-5.2996%207.5078-4l2.5364%201.359-7.9327%2010.926c-7.9323%2010.925-20.408%2030.492-27.181%2042.63-1.9776%203.5442-4.045%206.3369-4.5942%206.206-0.54923-0.13091-0.74165%200.43159-0.4276%201.25%200.42714%201.1131-0.18318%201.488-2.4225%201.488-2.4798%200-3.0778-0.47187-3.4848-2.75zm8.3919-7c1.2439-1.5861%201.2085-1.6214-0.37756-0.37756-0.9625%200.75485-1.75%201.5424-1.75%201.75%200%200.82304%200.82119%200.29331%202.1276-1.3724z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23e56636%22%20d%3D%22m232.38%20581.22c0-0.55%200.43621-1.675%200.96937-2.5s0.96937-1.05%200.96937-0.5-0.43621%201.675-0.96937%202.5-0.96937%201.05-0.96937%200.5zm1.9694-18.927c0-0.78508-1.1097-2.3003-2.4661-3.3672s-2.2127-2.1932-1.903-2.5029c0.30969-0.30968-0.82795-3.4069-2.5281-6.8828-5.2654-10.765-9.0932-30.085-9.1-45.931-0.003-6.4246%200.0644-6.5985%202.3772-6.1564%202.1594%200.4128%202.4441%201.1183%203.0718%207.6113%201.2154%2012.574%205.1314%2030.731%2012.165%2056.406%200.37202%201.358%200.1737%202.25-0.50025%202.25-0.61415%200-1.1166-0.64234-1.1166-1.4274zm13.104-1.4505c-1.1331-0.7471-0.60134-2.3678%202.8256-8.6118%2010.132-18.462%2019.444-33.053%2029.884-46.83%204.3859-5.7876%204.4216-5.8091%206.5482-3.9544%201.176%201.0257%203.3498%202.469%204.8307%203.2075%202.6064%201.2997%202.6383%201.4164%201%203.6512-0.93085%201.2697-3.155%203.1099-4.9424%204.0892-3.581%201.9619-4.4062%203.8275-1.25%202.8258%202.4434-0.77549%202.495-0.14656%200.29394%203.5796-0.93834%201.5885-3.3008%203.6544-5.25%204.591-3.3984%201.6329-3.4459%201.7267-1.1565%202.2847%202.2951%200.55931%202.2467%200.65759-1.25%202.5407-3.5284%201.9002-5.1631%204.3035-2.1374%203.1424%200.825-0.31658%201.5-0.24622%201.5%200.15636%200%201.1908-6.5289%2010.495-9.2884%2013.237-3.1139%203.094-10.659%206.968-13.571%206.968-1.1773%200-2.1405%200.50725-2.1405%201.1272%200%200.75009%201.6731%200.96646%205.0007%200.64673%204.0039-0.38473%204.7874-0.22358%203.9309%200.80849-0.58837%200.70895-2.3887%201.5787-4.0007%201.9327-3.1838%200.69928-4.0133%202.466-1.1809%202.5152%201.4792%200.0257%201.5179%200.16633%200.25%200.90866-2.4882%201.4568-8.4073%202.1645-9.8958%201.183zm-10.397-2.8721c-0.28577-1.5125-2.0781-8.8284-3.9828-16.257-3.797-14.809-7.7246-35.885-7.7246-41.451%200-3.1933%200.27052-3.5432%202.75-3.557%201.5125-0.008%203.4131-0.43467%204.2236-0.94722%203.1162-1.9707%204.1457%204.8974%201.5007%2010.012-1.7991%203.479-1.3116%203.7654%201.4196%200.83387l1.9718-2.1165%200.7143%203.8075c0.41102%202.191%200.25033%205.0367-0.37849%206.7026-0.93555%202.4786-0.86844%202.809%200.46645%202.2968%201.3089-0.50226%201.4477-0.004%200.86477%203.1034-0.60046%203.2007-0.49366%203.5351%200.78905%202.4706%201.2738-1.0572%201.653-0.22631%202.6826%205.8779%201.3301%207.8859%200.41614%2013.825-3.0354%2019.724-1.0458%201.7875-1.5018%203.25-1.0132%203.25%201.615%200%207.5499-7.7426%208.934-11.655%203.177-8.9807%2016.825-29.501%2026.607-40.005%204.0422-4.3404%204.3511-4.4839%206.8431-3.1782l2.6098%201.3674-5.7565%207.4853c-5.5704%207.2434-16.25%2022.982-18.921%2027.883-0.71861%201.3188-2.8308%204.9188-4.6938%208s-4.7645%208.0772-6.4478%2011.102c-1.6833%203.025-3.51%205.3929-4.0594%205.262-0.5494-0.13091-0.74195%200.43159-0.4279%201.25%200.42714%201.1131-0.18318%201.488-2.4225%201.488-2.473%200-3.0838-0.47816-3.5131-2.75zm8.4202-7c1.2439-1.5861%201.2085-1.6214-0.37756-0.37756-0.9625%200.75485-1.75%201.5424-1.75%201.75%200%200.82304%200.82119%200.29331%202.1276-1.3724z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23953a8a%22%20d%3D%22m232.38%20581.22c0-0.55%200.43621-1.675%200.96937-2.5s0.96937-1.05%200.96937-0.5-0.43621%201.675-0.96937%202.5-0.96937%201.05-0.96937%200.5zm1.9694-18.927c0-0.78508-1.1097-2.3003-2.4661-3.3672s-2.1836-2.2223-1.8383-2.5676c0.34526-0.34526-0.52619-2.7675-1.9366-5.3828-4.3364-8.041-6.7059-17.289-9.1878-35.861-0.53866-4.0306-0.49396-4.104%202.4378-4%201.6426%200.0583%202.9875%200.19557%202.9888%200.30515%200.0403%203.5253%206.5198%2031.436%2011.619%2050.051%200.37202%201.358%200.1737%202.25-0.50025%202.25-0.61415%200-1.1166-0.64234-1.1166-1.4274zm13.16-1.4157c-1.0904-0.72083-0.96415-1.6213%200.67868-4.8416%203.6946-7.2419%2015.279-26.709%2020.784-34.927l5.4342-8.112%205.5666%201.294c3.0616%200.7117%206.1987%201.0515%206.9712%200.75503%203.9642-1.5212-1.2122%206.2605-5.5515%208.3455-3.3984%201.6329-3.4459%201.7267-1.1565%202.2847%202.2951%200.55931%202.2467%200.65759-1.25%202.5407-3.5284%201.9002-5.1631%204.3035-2.1374%203.1424%200.825-0.31658%201.5-0.24622%201.5%200.15636%200%201.1908-6.5289%2010.495-9.2884%2013.237-3.1139%203.094-10.659%206.968-13.571%206.968-1.1773%200-2.1405%200.50725-2.1405%201.1272%200%200.75009%201.6731%200.96646%205.0007%200.64673%204.0039-0.38473%204.7874-0.22358%203.9309%200.80849-0.58837%200.70895-2.3887%201.5787-4.0007%201.9327-3.1838%200.69928-4.0133%202.466-1.1809%202.5152%201.4792%200.0257%201.5179%200.16633%200.25%200.90866-2.4503%201.4347-8.398%202.1708-9.8395%201.2178zm-10.808-4.4068c-3.9503-15.231-8.4522-35.009-8.9341-39.25-0.55928-4.9215-0.50815-5.0392%203.2567-7.4996%202.1037-1.3748%204.347-3.1691%204.9851-3.9874%201.7148-2.199%202.9854%205.4383%201.5413%209.2642-0.93555%202.4786-0.86844%202.809%200.46645%202.2968%201.3089-0.50226%201.4477-0.004%200.86477%203.1034-0.60046%203.2007-0.49366%203.5351%200.78905%202.4706%201.2738-1.0572%201.653-0.22631%202.6826%205.8779%201.3301%207.8859%200.41614%2013.825-3.0354%2019.724-1.0458%201.7875-1.5018%203.25-1.0132%203.25%201.615%200%207.5499-7.7426%208.934-11.655%202.7833-7.8678%2019.916-34.345%2022.223-34.345%200.41358%200%201.0679%201.0125%201.4541%202.25s1.0456%202.475%201.4654%202.75c0.41975%200.275-2.3409%205.1993-6.1348%2010.943-3.7939%205.7436-6.898%2010.565-6.898%2010.715%200%200.14937-1.9826%203.55-4.4059%207.557-2.4232%204.007-5.7825%209.7605-7.4651%2012.785-1.6826%203.025-3.5088%205.3929-4.0581%205.262-0.5494-0.13091-0.74195%200.43159-0.4279%201.25%200.42404%201.105-0.17012%201.488-2.3086%201.488-2.5482%200-3.0065-0.48911-3.9819-4.25zm8.7751-5.5c1.2439-1.5861%201.2085-1.6214-0.37756-0.37756-0.9625%200.75485-1.75%201.5424-1.75%201.75%200%200.82304%200.82119%200.29331%202.1276-1.3724z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23b93368%22%20d%3D%22m229.62%20550.73c-4.5614-2.7739-7.6998-13.229-10.692-35.62-0.53866-4.0306-0.49396-4.104%202.4378-4%201.6426%200.0583%202.9875%200.19557%202.9888%200.30515%200.0207%201.8074%204.784%2024.184%206.6332%2031.161%201.3645%205.1484%202.3225%209.5192%202.1287%209.713-0.19376%200.19375-1.7671-0.50814-3.4964-1.5598zm3.3618-8.7222c-3.6221-15.214-5.6262-25.062-5.6183-27.607%200.004-1.4075%201.3383-3.0738%203.75-4.6842%202.0587-1.3748%204.2652-3.1691%204.9033-3.9874%201.7148-2.199%202.9854%205.4383%201.5413%209.2642-0.93555%202.4786-0.86844%202.809%200.46645%202.2968%201.3089-0.50226%201.4477-0.004%200.86477%203.1034-0.60046%203.2007-0.49366%203.5351%200.78905%202.4706%202.2862-1.8974%204.3241%2011.23%202.7275%2017.571-1.3475%205.3514-3.3184%209.43-5.3861%2011.146-1.2562%201.0426-1.8405-0.3426-4.038-9.5728zm18.076%2010.076c-0.64872-0.64871%2010.414-19.771%2017.923-30.98l5.4342-8.112%205.5666%201.294c3.0616%200.7117%206.1987%201.0515%206.9712%200.75503%203.9642-1.5212-1.2122%206.2605-5.5515%208.3455-3.3984%201.6329-3.4459%201.7267-1.1565%202.2847%202.2951%200.55931%202.2467%200.65759-1.25%202.5407-3.5284%201.9002-5.1631%204.3035-2.1374%203.1424%200.825-0.31658%201.5-0.24622%201.5%200.15636%200%201.1908-6.5289%2010.495-9.2884%2013.237-4.225%204.198-16.251%209.0958-18.011%207.3356zm-3.7203-5.4144c-1.6525-3.9895-0.58695-7.2754%206.0354-18.612%205.1782-8.8643%2014.889-22.341%2016.097-22.341%200.41358%200%201.0679%201.0125%201.4541%202.25s1.0456%202.475%201.4654%202.75c0.41975%200.275-2.3409%205.1993-6.1348%2010.943-3.7939%205.7436-6.898%2010.565-6.898%2010.715%200%200.41204-9.2079%2015.725-10.011%2016.648-0.38541%200.4431-1.2894-0.61555-2.0089-2.3526z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23d0334d%22%20d%3D%22m268.92%20543.41c0.39936-1.0407%200.16314-1.6939-0.61257-1.6939-0.69443%200-2.7035-1.099-4.4647-2.4423-2.5028-1.909-3.4785-2.182-4.4679-1.25-1.964%201.8499%203.5846-7.9204%209.6087-16.92l5.4301-8.112%205.5666%201.294c3.0616%200.7117%206.1987%201.0515%206.9712%200.75503%203.9642-1.5212-1.2122%206.2605-5.5515%208.3455-3.3984%201.6329-3.4459%201.7267-1.1565%202.2847%202.2951%200.55931%202.2467%200.65759-1.25%202.5407-3.5284%201.9002-5.1631%204.3035-2.1374%203.1424%202.1429-0.82232%201.8896%200.0794-1.5114%205.3794-3.4044%205.3054-7.5528%209.6161-6.4246%206.6761zm-46.308-7.299c-1.065-3.6153-2.3791-11.094-3.6902-21.001-0.53331-4.0299-0.48805-4.104%202.4446-4%202.6018%200.0922%203.0678%200.55823%203.6051%203.6059%200.33938%201.925%201.4647%207.712%202.5008%2012.86%201.036%205.148%201.8837%209.5355%201.8837%209.75%200%200.21446-1.0875%200.38992-2.4167%200.38992s-2.5884%200.5152-2.7983%201.1449c-0.20989%200.62969-0.89795-0.60781-1.529-2.75zm6.8793-9.4428c-2.8681-13.469-2.8186-13.987%201.6215-16.952%202.0587-1.3748%204.2652-3.1691%204.9033-3.9874%201.7148-2.199%202.9854%205.4383%201.5413%209.2642-0.93555%202.4786-0.86844%202.809%200.46645%202.2968%201.3089-0.50226%201.4477-0.004%200.86477%203.1034-0.60089%203.203-0.4943%203.5356%200.79119%202.4688%201.2587-1.0446%201.5813-0.65346%202.1116%202.5604%201.4575%208.8336%201.4278%209.864-0.28538%209.8878-0.90753%200.0126-3.5016%200.32963-5.7647%200.70445l-4.1146%200.68151-2.1354-10.028zm25.578%206.8509c-0.98257-1.0318-2.2201-1.608-2.75-1.2804-0.52994%200.32752-0.96237%200.23144-0.96096-0.21352%200.008-2.4071%2016.461-26.309%2018.111-26.309%200.41358%200%201.0679%201.0125%201.4541%202.25s1.0456%202.475%201.4654%202.75c0.41975%200.275-2.3409%205.1993-6.1348%2010.943-3.7939%205.7436-6.898%2010.751-6.898%2011.128%200%202.0224-2.63%202.4718-4.2865%200.73246z%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fsvg%3E";

var oracleObjectIcon = "data:image/svg+xml,%3Csvg%20width%3D%2236%22%20height%3D%2236%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M0%200h36v36H0V0z%22%20fill%3D%22%23C74634%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M21.541%2022.139c2.277%200%204.126-1.855%204.126-4.143a4.134%204.134%200%2000-4.126-4.139H14.46a4.134%204.134%200%2000-4.128%204.139%204.135%204.135%200%20004.128%204.143h7.082zm-7.245%202.257c-3.52%200-6.376-2.865-6.376-6.4%200-3.534%202.855-6.393%206.376-6.393h7.408c3.52%200%206.373%202.86%206.373%206.393%200%203.54-2.853%206.403-6.373%206.403l-7.409-.003z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E";

var s3ObjectIcon = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%22%20height%3D%22100%22%20viewBox%3D%220%200%20100%20100%22%3E%20%20%3Ctitle%3EStorage%3C%2Ftitle%3E%20%20%3Cg%3E%20%20%20%20%3Cpolygon%20points%3D%2221.54%2023.23%2016.08%2025.96%2016.08%2073.93%2021.54%2076.66%2034.94%2049.94%2021.54%2023.23%22%20fill%3D%22%238c3123%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2250%2069.76%2021.54%2076.65%2021.54%2023.23%2050%2030.12%2063.45%2050.02%2050%2069.76%22%20fill%3D%22%23e05243%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2250%2069.76%2078.45%2076.65%2083.37%2050.62%2078.45%2023.23%2050%2030.12%2050%2069.76%22%20fill%3D%22%238c3123%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2278.45%2023.23%2083.92%2025.96%2083.92%2073.93%2078.45%2076.66%2078.45%2023.23%22%20fill%3D%22%23e05243%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2237.59%2058.78%2050%2060.37%2059.84%2050.02%2050%2039.68%2037.59%2041.24%2037.59%2058.78%22%20fill%3D%22%238c3123%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2262.41%2032.75%2050%2035.01%2037.59%2032.75%2050%209%2062.41%2032.75%22%20fill%3D%22%235e1f18%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2262.41%2067.25%2050%2064.97%2037.59%2067.25%2050%2091%2062.41%2067.25%22%20fill%3D%22%23f2b0a9%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2262.41%2032.75%2050%2029.68%2050%209%2062.41%2015.2%2062.41%2032.75%22%20fill%3D%22%23e05243%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2237.59%2032.75%2050%2029.68%2050%209%2037.59%2015.2%2037.59%2032.75%22%20fill%3D%22%238c3123%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2250%2091%2062.41%2084.8%2062.41%2067.25%2050%2070.32%2050%2091%22%20fill%3D%22%23e05243%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2250%2091%2037.59%2084.8%2037.59%2067.25%2050%2070.32%2050%2091%22%20fill%3D%22%238c3123%22%2F%3E%20%20%20%20%3Cpolygon%20points%3D%2262.41%2058.78%2050%2060.37%2050%2039.68%2062.41%2041.24%2062.41%2058.78%22%20fill%3D%22%23e05243%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var unknownArtifactIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22110.37mm%22%20height%3D%22110.37mm%22%20version%3D%221.1%22%20viewBox%3D%220%200%20110.36904%20110.36904%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%20xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%20xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%3E%20%3Cmetadata%3E%20%20%3Crdf%3ARDF%3E%20%20%20%3Ccc%3AWork%20rdf%3Aabout%3D%22%22%3E%20%20%20%20%3Cdc%3Aformat%3Eimage%2Fsvg%2Bxml%3C%2Fdc%3Aformat%3E%20%20%20%20%3Cdc%3Atype%20rdf%3Aresource%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Fdcmitype%2FStillImage%22%2F%3E%20%20%20%20%3Cdc%3Atitle%2F%3E%20%20%20%3C%2Fcc%3AWork%3E%20%20%3C%2Frdf%3ARDF%3E%20%3C%2Fmetadata%3E%20%3Cg%20transform%3D%22translate%28-43.089%20-111.04%29%22%3E%20%20%3Crect%20x%3D%2243.089%22%20y%3D%22111.04%22%20width%3D%22110.37%22%20height%3D%22110.37%22%20stroke-width%3D%22.26458%22%2F%3E%20%20%3Cg%20transform%3D%22matrix%28.56848%200%200%20.56848%2034.64%2080.686%29%22%20aria-label%3D%22%3F%22%3E%20%20%20%3Cpath%20d%3D%22m96.688%20198.91h19.031v23.812h-19.031zm18.469-13.781h-17.906v-14.438q0-9.4688%202.625-15.562t11.062-14.156l8.4375-8.3438q5.3438-4.9688%207.6875-9.375%202.4375-4.4062%202.4375-9%200-8.3438-6.1875-13.5-6.0938-5.1563-16.219-5.1563-7.4062%200-15.844%203.2812-8.3438%203.2813-17.438%209.5625v-17.625q8.8125-5.3438%2017.812-7.9688%209.0938-2.625%2018.75-2.625%2017.25%200%2027.656%209.0938%2010.5%209.0938%2010.5%2024%200%207.125-3.375%2013.594-3.375%206.375-11.812%2014.438l-8.25%208.0625q-4.4062%204.4062-6.2812%206.9375-1.7812%202.4375-2.5312%204.7812-0.5625%201.9688-0.84375%204.7812t-0.28125%207.6875z%22%20fill%3D%22%23fff%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fsvg%3E";

const _ArtifactIconService = class {
  static registerType(type, path) {
    _ArtifactIconService.icons.push({ type, path });
  }
  static getPath(type) {
    if (type == null) {
      return unknownArtifactIcon;
    }
    const icon = _ArtifactIconService.icons.find((entry) => entry.type.test(type));
    if (icon === void 0) {
      return null;
    }
    return icon.path;
  }
};
let ArtifactIconService = _ArtifactIconService;
ArtifactIconService.icons = [];
ArtifactIconService.registerType(ArtifactTypePatterns.CUSTOM_OBJECT, unknownArtifactIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.DOCKER_IMAGE, dockerIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.KUBERNETES, kubernetesIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.EMBEDDED_BASE64, embeddedBase64Icon);
ArtifactIconService.registerType(ArtifactTypePatterns.REMOTE_BASE64, embeddedBase64Icon);
ArtifactIconService.registerType(ArtifactTypePatterns.GCS_OBJECT, gcsObjectIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.GITHUB_FILE, gitHubFileIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.GIT_REPO, gitRepoIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.GITLAB_FILE, gitLabFileIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.BITBUCKET_FILE, bitbucketFileIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.S3_OBJECT, s3ObjectIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.HELM_CHART, helmChartIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.IVY_FILE, ivyFileIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.JENKINS_FILE, jenkinsFileIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.MAVEN_FILE, mavenFileIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.HTTP_FILE, httpFileIcon);
ArtifactIconService.registerType(ArtifactTypePatterns.ORACLE_OBJECT, oracleObjectIcon);

class ArtifactReferenceService {
  static removeReferenceFromStages(reference, stages) {
    (stages || []).forEach((stage) => {
      const stageConfig = Registry.pipeline.getStageConfig(stage);
      const artifactRemover = get(stageConfig, ["artifactRemover"], noop$2);
      artifactRemover(stage, reference);
    });
  }
  static removeReferencesFromStages(references, stages) {
    references.forEach((reference) => ArtifactReferenceService.removeReferenceFromStages(reference, stages));
  }
  static removeArtifactFromField(path, obj, artifactId) {
    const reference = get(obj, path);
    if (Array.isArray(reference)) {
      set(obj, path, reference.filter((a) => a !== artifactId));
    } else if (reference === artifactId) {
      set(obj, path, null);
    }
  }
  static removeArtifactFromFields(paths) {
    return (stage, artifactId) => paths.forEach((path) => this.removeArtifactFromField(path, stage, artifactId));
  }
}

const ArtifactIconList = (props) => {
  return props.artifacts.map((artifact, i) => {
    const { location, reference, type } = artifact;
    let { name } = artifact;
    const iconPath = ArtifactIconService.getPath(type);
    const key = `${location || ""}${type || ""}${reference || ""}` || String(i);
    let title = type;
    if (isString(type) && type.length > 0) {
      const k8sKindMatch = type.match(ArtifactTypePatterns.KUBERNETES);
      if (k8sKindMatch != null && k8sKindMatch[1].length > 0) {
        const kind = k8sKindMatch[1].substr(0, 1).toUpperCase() + k8sKindMatch[1].substr(1);
        name = `${kind} ${name}`;
        title = name;
      }
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      key,
      className: "artifact-list-item",
      title
    }, iconPath && /* @__PURE__ */ React__default.createElement("img", {
      className: "artifact-list-item-icon",
      width: "20",
      height: "20",
      src: iconPath
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "artifact-list-item-name"
    }, name, artifact.version && /* @__PURE__ */ React__default.createElement("span", null, " - ", artifact.version)));
  });
};

var css_248z$24 = ".execution-artifacts {\n  background: var(--color-alabaster);\n  display: flex;\n  margin-right: 0;\n  padding: 6px;\n}\n.artifact-list-container {\n  background: var(--color-white);\n  padding: 8px 6px 6px;\n}\n.artifact-list-container > h5 {\n  margin-top: 0;\n}\n.artifact-list-item {\n  height: 28px;\n  position: relative;\n  line-height: 28px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-bottom: 0.1em;\n}\n.artifact-list-item-icon {\n  position: absolute;\n  top: 4px;\n}\n.artifact-list-item-name {\n  padding-left: 24px;\n}\n";
styleInject(css_248z$24);

class ExecutionArtifactTab extends React__default.Component {
  extractBoundArtifactsFromExecution(execution) {
    const triggerArtifacts = get(execution, ["trigger", "resolvedExpectedArtifacts"], []);
    const stageOutputArtifacts = get(execution, "stages", []).reduce((out, stage) => {
      const outputArtifacts = get(stage, ["outputs", "resolvedExpectedArtifacts"], []);
      return out.concat(outputArtifacts);
    }, []);
    const allArtifacts = triggerArtifacts.concat(stageOutputArtifacts);
    return allArtifacts.filter((a) => has(a, "boundArtifact"));
  }
  artifactLists() {
    const { stage, execution } = this.props;
    const stageConfig = Registry.pipeline.getStageConfig(stage);
    const stageContext = get(stage, ["context"], {});
    const consumedIds = new Set(stageConfig && stageConfig.artifactExtractor ? stageConfig.artifactExtractor(stageContext) : []);
    const boundArtifacts = this.extractBoundArtifactsFromExecution(execution);
    const consumedArtifacts = boundArtifacts.filter((rea) => consumedIds.has(rea.id)).map((rea) => rea.boundArtifact).filter(({ name, type }) => name && type);
    const producedArtifacts = get(stage, ["outputs", "artifacts"], []).slice();
    return { consumedArtifacts, producedArtifacts };
  }
  render() {
    const { consumedArtifacts, producedArtifacts } = this.artifactLists();
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name: this.props.name,
      current: this.props.current
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row execution-artifacts"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-sm-6 artifact-list-container"
    }, /* @__PURE__ */ React__default.createElement("h5", null, "Consumed Artifacts"), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(ArtifactIconList, {
      artifacts: consumedArtifacts
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-sm-6 artifact-list-container"
    }, /* @__PURE__ */ React__default.createElement("h5", null, "Produced Artifacts"), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(ArtifactIconList, {
      artifacts: producedArtifacts
    })))));
  }
}
ExecutionArtifactTab.title = "artifactStatus";

const EXECUTION_ARTIFACT_TAB = "spinnaker.core.artifact.artifactTab.component";
module(EXECUTION_ARTIFACT_TAB, []).component("executionArtifactTab", react2angular(withErrorBoundary(ExecutionArtifactTab, "executionArtifactTab"), ["config", "stage", "execution"]));

class ExpectedArtifactService {
  static getExpectedArtifactsAvailableToStage(stage, pipeline) {
    if (!stage || !pipeline) {
      return [];
    }
    let result = pipeline.expectedArtifacts || [];
    PipelineConfigService.getAllUpstreamDependencies(pipeline, stage).forEach((s) => {
      const expectedArtifact = s.expectedArtifact;
      if (expectedArtifact) {
        result = result.concat(expectedArtifact);
      }
      const expectedArtifacts = s.expectedArtifacts;
      if (expectedArtifacts) {
        result = result.concat(expectedArtifacts);
      }
    });
    return result;
  }
  static accumulateArtifacts(fields) {
    return (stageContext) => fields.map((field) => get(stageContext, field)).filter((v) => v).reduce((array, value) => array.concat(value), []);
  }
  static createEmptyArtifact() {
    return {
      id: UUIDGenerator.generateUuid(),
      usePriorArtifact: false,
      useDefaultArtifact: false,
      matchArtifact: {
        id: UUIDGenerator.generateUuid(),
        customKind: true
      },
      defaultArtifact: {
        id: UUIDGenerator.generateUuid(),
        customKind: true
      },
      displayName: hri.random()
    };
  }
  static addArtifactTo(artifact, obj) {
    if (obj.expectedArtifacts == null) {
      obj.expectedArtifacts = [];
    }
    obj.expectedArtifacts.push(artifact);
    return artifact;
  }
  static addNewArtifactTo(obj) {
    return ExpectedArtifactService.addArtifactTo(ExpectedArtifactService.createEmptyArtifact(), obj);
  }
  static artifactFromExpected(expected) {
    if (expected && expected.matchArtifact) {
      return expected.matchArtifact;
    } else {
      return null;
    }
  }
  static sourcesForPipelineStage(pipelineGetter, stage) {
    const sources = [
      {
        get source() {
          return pipelineGetter();
        },
        label: "Pipeline Trigger"
      }
    ];
    PipelineConfigService.getAllUpstreamDependencies(pipelineGetter(), stage).filter((s) => Registry.pipeline.getStageConfig(s).producesArtifacts).map((s) => ({ source: s, label: "Stage (" + s.name + ")" })).forEach((s) => sources.push(s));
    return sources;
  }
  static getKindConfig(artifact, isDefault) {
    if (artifact == null || artifact.customKind || artifact.kind === "custom") {
      return Registry.pipeline.getCustomArtifactKind();
    }
    const kinds = isDefault ? Registry.pipeline.getDefaultArtifactKinds() : Registry.pipeline.getMatchArtifactKinds();
    const inferredKindConfig = kinds.find((k) => k.type === artifact.type);
    if (inferredKindConfig !== void 0) {
      return inferredKindConfig;
    }
    return Registry.pipeline.getCustomArtifactKind();
  }
}

const imageSourceSelectorComponent = {
  bindings: {
    command: "=",
    imageSources: "<",
    helpFieldKey: "@",
    idField: "@",
    imageSourceText: "<"
  },
  controllerAs: "ctrl",
  template: `
    <div class="form-group" ng-if="ctrl.imageSourceText">
      <div class="col-md-3 sm-label-right">
        Image Source
      </div>
      <div class="col-md-7" style="margin-top: 5px;">
        <span ng-bind-html="ctrl.imageSourceText"></span>
      </div>
    </div>
    <div class="form-group" ng-if="!ctrl.imageSourceText">
      <div class="col-md-3 sm-label-right">
        Image Source
        <help-field key="{{ ctrl.helpFieldKey }}"></help-field>
      </div>
      <div class="col-md-7">
        <div class="radio" ng-repeat="imageSource in ctrl.imageSources">
          <label>
            <input type="radio" ng-model="ctrl.command[ctrl.idField]" value="{{ imageSource }}">
            {{ imageSource | robotToHuman }}
          </label>
        </div>
      </div>
    </div>
  `
};
const IMAGE_SOURCE_SELECTOR_COMPONENT = "spinnaker.core.artifacts.expected.image.selector";
module(IMAGE_SOURCE_SELECTOR_COMPONENT, []).component("imageSourceSelector", imageSourceSelectorComponent);

class ExpectedArtifactSelectorViewController {
  constructor(delegate) {
    this.delegate = delegate;
    this.accountsForArtifact = [];
    this.updateAccounts = (expectedArtifact) => {
      if (expectedArtifact == null) {
        this.accountsForArtifact = [];
      } else {
        const artifact = ExpectedArtifactService.artifactFromExpected(expectedArtifact);
        const allAccounts = this.delegate.getExpectedArtifactAccounts();
        this.accountsForArtifact = artifact.type === "helm/chart" ? allAccounts.filter((a) => a.types.includes(artifact.type) && a.name === artifact.artifactAccount) : allAccounts.filter((a) => a.types.includes(artifact.type));
        const selected = this.delegate.getSelectedAccount();
        if (!selected || !this.accountsForArtifact.find((a) => a.name === selected.name)) {
          if (this.accountsForArtifact.length) {
            this.delegate.setSelectedArtifactAccount(this.accountsForArtifact[0]);
          } else {
            this.delegate.setSelectedArtifactAccount(null);
          }
        }
      }
    };
    this.onArtifactChange = (expectedArtifact) => {
      this.delegate.setSelectedExpectedArtifact(expectedArtifact);
      this.updateAccounts(expectedArtifact);
    };
    this.onArtifactCreated = (event) => {
      ExpectedArtifactService.addArtifactTo(event.expectedArtifact, event.source.source);
      this.delegate.refreshExpectedArtifacts();
      this.updateAccounts(event.expectedArtifact);
      this.delegate.setSelectedExpectedArtifact(event.expectedArtifact);
      this.delegate.setSelectedArtifactAccount(event.account);
    };
    this.onRequestCreate = () => {
      this.delegate.createArtifact();
    };
    this.onAccountChange = (account) => {
      this.delegate.setSelectedArtifactAccount(account);
    };
  }
}
ExpectedArtifactSelectorViewController.$inject = ["delegate"];

class ExpectedArtifactSelectorViewControllerAngularDelegate {
  constructor($scope) {
    this.$scope = $scope;
    this.sources = [];
    this.kinds = [];
    this.accounts = [];
    this.setAccounts = (accounts) => {
      this.accounts = [...accounts];
    };
  }
  getExpectedArtifactSources() {
    return this.sources;
  }
  getSupportedArtifactKinds() {
    return this.kinds;
  }
  getExpectedArtifactAccounts() {
    return this.accounts;
  }
  scopeApply() {
    this.$scope.$evalAsync();
  }
}

const defaultExcludedArtifactTypes = [ArtifactTypePatterns.KUBERNETES, ArtifactTypePatterns.DOCKER_IMAGE];
class NgGenericArtifactDelegate extends ExpectedArtifactSelectorViewControllerAngularDelegate {
  constructor($scope, tag, excludedArtifactTypes = defaultExcludedArtifactTypes) {
    super($scope);
    this.$scope = $scope;
    this.tag = tag;
    this.excludedArtifactTypes = excludedArtifactTypes;
    this.getExcludedArtifactTypes = () => {
      return this.excludedArtifactTypes;
    };
    this.getExpectedArtifacts = () => {
      return ExpectedArtifactService.getExpectedArtifactsAvailableToStage(this.$scope.stage, this.$scope.$parent.pipeline);
    };
    this.getSelectedExpectedArtifact = () => {
      const id = this.$scope.stage[`${this.tag}ArtifactId`];
      if (id == null) {
        return null;
      }
      return this.getExpectedArtifacts().find((ea) => ea.id === id);
    };
    this.getSelectedAccount = () => {
      const accountName = this.$scope.stage[`${this.tag}ArtifactAccount`];
      if (accountName == null) {
        return null;
      }
      return this.getExpectedArtifactAccounts().find((a) => a.name === accountName);
    };
    this.setSelectedExpectedArtifact = (expectedArtifact) => {
      this.$scope.showCreateArtifactForm = false;
      this.$scope.stage[`${this.tag}ArtifactId`] = expectedArtifact.id;
      this.scopeApply();
    };
    this.sources = ExpectedArtifactService.sourcesForPipelineStage(() => this.$scope.$parent.pipeline, this.$scope.stage);
    this.kinds = Registry.pipeline.getMatchArtifactKinds().filter((a) => !this.getExcludedArtifactTypes().find((t) => t.test(a.type)));
    this.refreshExpectedArtifacts();
  }
  setSelectedArtifactAccount(account) {
    if (account) {
      this.$scope.stage[`${this.tag}ArtifactAccount`] = account.name;
    } else {
      this.$scope.stage[`${this.tag}ArtifactAccount`] = "";
    }
    this.scopeApply();
  }
  createArtifact() {
    this.$scope.showCreateArtifactForm = true;
    this.scopeApply();
  }
  refreshExpectedArtifacts() {
    this.$scope.expectedArtifacts = this.getExpectedArtifacts();
  }
}

const offeredArtifactTypes = [ArtifactTypePatterns.GCE_MACHINE_IMAGE];
class NgGCEImageArtifactDelegate extends ExpectedArtifactSelectorViewControllerAngularDelegate {
  constructor($scope) {
    super($scope);
    this.$scope = $scope;
    this.kinds = [Registry.pipeline.getCustomArtifactKind()];
    const { viewState } = $scope.command;
    this.sources = ExpectedArtifactService.sourcesForPipelineStage(() => viewState.pipeline, viewState.stage);
    this.refreshExpectedArtifacts();
  }
  getExpectedArtifacts() {
    const { viewState } = this.$scope.command;
    return ExpectedArtifactService.getExpectedArtifactsAvailableToStage(viewState.stage, viewState.pipeline);
  }
  getSelectedExpectedArtifact() {
    return (this.getExpectedArtifacts() || []).find((ea) => ea.id === this.$scope.command.imageArtifactId);
  }
  getSelectedAccount() {
    return null;
  }
  getOfferedArtifactTypes() {
    return offeredArtifactTypes;
  }
  setSelectedExpectedArtifact(e) {
    this.$scope.command.imageArtifactId = e.id;
    this.$scope.gceImageArtifact.showCreateArtifactForm = false;
    this.scopeApply();
  }
  setSelectedArtifactAccount(_a) {
    return;
  }
  createArtifact() {
    this.$scope.gceImageArtifact.showCreateArtifactForm = true;
    this.scopeApply();
  }
  refreshExpectedArtifacts() {
    this.$scope.command.viewState.expectedArtifacts = this.getExpectedArtifacts();
  }
}

class NgAppEngineDeployArtifactDelegate extends ExpectedArtifactSelectorViewControllerAngularDelegate {
  constructor($scope, offeredArtifactTypes = null) {
    super($scope);
    this.$scope = $scope;
    this.offeredArtifactTypes = offeredArtifactTypes;
    const { viewState } = $scope.command;
    this.sources = ExpectedArtifactService.sourcesForPipelineStage(() => viewState.pipeline, viewState.stage);
    this.kinds = Registry.pipeline.getMatchArtifactKinds().filter((a) => {
      return a.customKind || offeredArtifactTypes.find((oat) => oat.test(a.type));
    });
    this.refreshExpectedArtifacts();
  }
  getExpectedArtifacts() {
    const { viewState } = this.$scope.command;
    return ExpectedArtifactService.getExpectedArtifactsAvailableToStage(viewState.stage, viewState.pipeline);
  }
  getSelectedExpectedArtifact() {
    return (this.getExpectedArtifacts() || []).find((ea) => ea.id === this.$scope.command.expectedArtifactId);
  }
  getSelectedAccount() {
    return null;
  }
  getOfferedArtifactTypes() {
    return this.offeredArtifactTypes;
  }
  setSelectedExpectedArtifact(e) {
    this.$scope.command.expectedArtifactId = e.id;
    this.$scope.showCreateArtifactForm = false;
    this.scopeApply();
  }
  setSelectedArtifactAccount(_a) {
  }
  createArtifact() {
    this.$scope.showCreateArtifactForm = true;
    this.scopeApply();
  }
  refreshExpectedArtifacts() {
    this.$scope.command.backingData.expectedArtifacts = this.getExpectedArtifacts();
  }
}

class NgBakeManifestArtifactDelegate extends ExpectedArtifactSelectorViewControllerAngularDelegate {
  constructor(artifact) {
    super(artifact.$scope);
    this.artifact = artifact;
    this.requestingNew = false;
    this.setAccounts = (accounts) => {
      this.accounts = [...accounts];
    };
    this.refreshExpectedArtifacts();
    this.sources = ExpectedArtifactService.sourcesForPipelineStage(() => this.$scope.$parent.pipeline, this.$scope.stage);
    this.kinds = Registry.pipeline.getMatchArtifactKinds();
  }
  getExpectedArtifacts() {
    return ExpectedArtifactService.getExpectedArtifactsAvailableToStage(this.$scope.stage, this.$scope.$parent.pipeline);
  }
  getSelectedExpectedArtifact() {
    return this.expectedArtifacts.find((ea) => ea.id === this.artifact.id);
  }
  getSelectedAccount() {
    return this.accounts.find((a) => a.name === this.artifact.account);
  }
  setSelectedExpectedArtifact(e) {
    this.artifact.id = e.id;
    this.requestingNew = false;
    this.scopeApply();
  }
  setSelectedArtifactAccount(a) {
    if (a == null) {
      this.artifact.account = "";
    } else {
      this.artifact.account = a.name;
    }
    this.scopeApply();
  }
  createArtifact() {
    this.requestingNew = true;
    this.scopeApply();
  }
  refreshExpectedArtifacts() {
    this.expectedArtifacts = this.getExpectedArtifacts();
  }
}

class NgAppengineConfigArtifactDelegate extends ExpectedArtifactSelectorViewControllerAngularDelegate {
  constructor(artifact) {
    super(artifact.$scope);
    this.artifact = artifact;
    this.requestingNew = false;
    this.setAccounts = (accounts) => {
      this.accounts = [...accounts];
    };
    this.refreshExpectedArtifacts();
    this.sources = ExpectedArtifactService.sourcesForPipelineStage(() => this.getPipeline(), this.getStage());
    this.kinds = Registry.pipeline.getMatchArtifactKinds();
  }
  getStage() {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = this.artifact) == null ? void 0 : _a.$scope) == null ? void 0 : _b.command) == null ? void 0 : _c.viewState) == null ? void 0 : _d.stage;
  }
  getPipeline() {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = this.artifact) == null ? void 0 : _a.$scope) == null ? void 0 : _b.command) == null ? void 0 : _c.viewState) == null ? void 0 : _d.pipeline;
  }
  getExpectedArtifacts() {
    return ExpectedArtifactService.getExpectedArtifactsAvailableToStage(this.getStage(), this.getPipeline());
  }
  getSelectedExpectedArtifact() {
    return this.expectedArtifacts.find((ea) => ea.id === this.artifact.id);
  }
  getSelectedAccount() {
    return this.accounts.find((a) => a.name === this.artifact.account);
  }
  setSelectedExpectedArtifact(e) {
    this.artifact.id = e.id;
    this.requestingNew = false;
    this.scopeApply();
  }
  setSelectedArtifactAccount(a) {
    if (a == null) {
      this.artifact.account = "";
    } else {
      this.artifact.account = a.name;
    }
    this.scopeApply();
  }
  createArtifact() {
    this.requestingNew = true;
    this.scopeApply();
  }
  refreshExpectedArtifacts() {
    this.expectedArtifacts = this.getExpectedArtifacts();
  }
}

const ArtifactIcon = (props) => {
  let type;
  if (props.type) {
    type = props.type;
  } else if (props.artifact) {
    type = props.artifact.type;
  } else if (props.kind) {
    type = props.kind.type;
  } else if (props.expectedArtifact) {
    type = ExpectedArtifactService.artifactFromExpected(props.expectedArtifact).type;
  }
  return /* @__PURE__ */ React__default.createElement("img", {
    style: { verticalAlign: "text-top", marginRight: "4px" },
    src: ArtifactIconService.getPath(type),
    width: props.width,
    height: props.height
  });
};

class ArtifactAccountSelector extends React__default.Component {
  constructor(props) {
    super(props);
    this.renderOption = (account) => {
      return /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(ArtifactIcon, {
        type: account.types[0],
        width: "16",
        height: "16"
      }), account.name);
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      className: this.props.className || "",
      options: this.props.accounts,
      value: this.props.selected,
      onChange: this.props.onChange,
      optionRenderer: this.renderOption,
      valueRenderer: this.renderOption,
      clearable: false,
      valueKey: "name"
    });
  }
}
const ARTIFACT_ACCOUNT_SELECTOR_COMPONENT_REACT = "spinnaker.core.artifacts.account.selector.react";
module(ARTIFACT_ACCOUNT_SELECTOR_COMPONENT_REACT, []).component("artifactAccountSelectorReact", react2angular(withErrorBoundary(ArtifactAccountSelector, "artifactAccountSelectorReact"), [
  "accounts",
  "className",
  "onChange",
  "selected"
]));

class ExpectedArtifactKindSelector extends React__default.Component {
  constructor(props) {
    super(props);
    this.renderOption = (o) => {
      return /* @__PURE__ */ React__default.createElement("span", null, this.props.showIcons && /* @__PURE__ */ React__default.createElement(ArtifactIcon, {
        type: o.type,
        width: "16",
        height: "16"
      }), o.label, " - ", o.description);
    };
    this.onChange = (option) => {
      const kind = this.props.kinds.find((k) => k.key === option.value);
      this.setState({ selected: option });
      this.props.onChange(kind);
    };
    this.optionFromKindConfig = (ak) => {
      if (!ak) {
        return null;
      }
      return {
        label: ak.label,
        description: ak.description,
        type: ak.type,
        value: ak.key
      };
    };
    this.state = {
      selected: this.optionFromKindConfig(props.selected)
    };
  }
  render() {
    const options = this.props.kinds.map(this.optionFromKindConfig);
    const value = this.state.selected;
    return /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      className: this.props.className || "",
      options,
      value,
      optionRenderer: this.renderOption,
      valueRenderer: this.renderOption,
      onChange: this.onChange,
      clearable: false
    });
  }
}
ExpectedArtifactKindSelector.defaultProps = {
  showIcons: true
};
const EXPECTED_ARTIFACT_KIND_SELECTOR_COMPONENT_REACT = "spinnaker.core.artifacts.expected.kind.selector.react";
module(EXPECTED_ARTIFACT_KIND_SELECTOR_COMPONENT_REACT, []).component("expectedArtifactKindSelectorReact", react2angular(withErrorBoundary(ExpectedArtifactKindSelector, "expectedArtifactKindSelectorReact"), [
  "kinds",
  "selected",
  "onChange",
  "showIcons",
  "className"
]));

class ExpectedArtifactSourceSelector extends React__default.Component {
  constructor(props) {
    super(props);
    this.renderOption = (option) => {
      return /* @__PURE__ */ React__default.createElement("span", null, option.label);
    };
    this.onChange = (option) => {
      const source = this.props.sources.find((s) => s.source === option.source);
      this.props.onChange(source);
    };
    this.state = {
      options: props.sources.map((s) => {
        if (s.value) {
          return s;
        } else {
          return { ...s, value: UUIDGenerator.generateUuid() };
        }
      })
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      className: this.props.className || "",
      options: this.state.options,
      optionRenderer: this.renderOption,
      value: this.props.selected,
      valueRenderer: this.renderOption,
      onChange: this.onChange,
      clearable: false
    });
  }
}
const EXPECTED_ARTIFACT_SOURCE_SELECTOR_COMPONENT_REACT = "spinnaker.core.artifacts.expected.source.selector.react";
module(EXPECTED_ARTIFACT_SOURCE_SELECTOR_COMPONENT_REACT, []).component("expectedArtifactSourceSelectorReact", react2angular(withErrorBoundary(ExpectedArtifactSourceSelector, "expectedArtifactSourceSelectorReact"), [
  "sources",
  "className",
  "onChange",
  "selected"
]));

class ExpectedArtifactSelector extends React__default.Component {
  constructor() {
    super(...arguments);
    this.renderOption = (e) => {
      if (!e.expectedArtifact && !e.requestingNew) {
        return /* @__PURE__ */ React__default.createElement("span", null);
      }
      if (e.requestingNew) {
        return /* @__PURE__ */ React__default.createElement("span", null, "Create new...");
      } else {
        return /* @__PURE__ */ React__default.createElement("span", null, this.props.showIcons && /* @__PURE__ */ React__default.createElement(ArtifactIcon, {
          expectedArtifact: e.expectedArtifact,
          width: "16",
          height: "16"
        }), e.expectedArtifact.displayName);
      }
    };
    this.onChange = (e) => {
      if (e.requestingNew) {
        this.props.onRequestCreate();
      } else {
        this.props.onChange(e.expectedArtifact);
      }
    };
  }
  filterExpectedArtifacts(fn) {
    return (this.props.expectedArtifacts || []).filter((ea) => {
      const artifact = ExpectedArtifactService.artifactFromExpected(ea);
      if (!artifact) {
        return false;
      }
      return fn(ea, artifact);
    });
  }
  getExpectedArtifacts() {
    return this.filterExpectedArtifacts((_expectedArtifact, artifact) => {
      const { offeredArtifactTypes, excludedArtifactTypes } = this.props;
      let isIncluded = true;
      let isExcluded = false;
      if (offeredArtifactTypes && offeredArtifactTypes.length > 0) {
        isIncluded = !!offeredArtifactTypes.find((patt) => patt.test(artifact.type));
      }
      if (excludedArtifactTypes && excludedArtifactTypes.length > 0) {
        isExcluded = !!excludedArtifactTypes.find((patt) => patt.test(artifact.type));
      }
      return isIncluded && !isExcluded;
    });
  }
  render() {
    const options = this.getExpectedArtifacts().map((ea) => {
      return { value: ea.id, expectedArtifact: ea, requestingNew: false };
    });
    if (this.props.onRequestCreate) {
      options.push({ value: "", expectedArtifact: null, requestingNew: true });
    }
    const value = {
      value: this.props.selected ? this.props.selected.id : "",
      expectedArtifact: this.props.selected,
      requestingNew: this.props.requestingNew
    };
    return /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      className: this.props.className || "",
      options,
      optionRenderer: this.renderOption,
      value,
      valueRenderer: this.renderOption,
      onChange: this.onChange,
      clearable: false
    });
  }
}
ExpectedArtifactSelector.defaultProps = {
  requestingNew: false,
  showIcons: true
};
const EXPECTED_ARTIFACT_SELECTOR_COMPONENT_REACT = "spinnaker.core.artifacts.expected.selector.react";
module(EXPECTED_ARTIFACT_SELECTOR_COMPONENT_REACT, [
  EXPECTED_ARTIFACT_KIND_SELECTOR_COMPONENT_REACT,
  EXPECTED_ARTIFACT_SOURCE_SELECTOR_COMPONENT_REACT,
  ARTIFACT_ACCOUNT_SELECTOR_COMPONENT_REACT
]).component("expectedArtifactSelectorReact", react2angular(withErrorBoundary(ExpectedArtifactSelector, "expectedArtifactSelectorReact"), [
  "expectedArtifacts",
  "selected",
  "requestingNew",
  "onRequestCreate",
  "onChange",
  "showIcons",
  "className",
  "offeredArtifactTypes",
  "excludedArtifactTypes"
]));

class ExpectedArtifactEditor extends React__default.Component {
  constructor(props) {
    super(props);
    this.onSave = () => {
      this.props.onSave({
        expectedArtifact: this.state.expectedArtifact,
        source: this.state.source,
        account: this.state.account
      });
    };
    this.onSourceChange = (e) => {
      this.setState({ source: e });
    };
    this.onKindChange = (kind) => {
      const expectedArtifact = cloneDeep(this.state.expectedArtifact);
      expectedArtifact.matchArtifact.type = kind.type;
      delete expectedArtifact.matchArtifact.kind;
      expectedArtifact.matchArtifact.customKind = kind.customKind;
      const accounts = this.accountsForExpectedArtifact(expectedArtifact);
      this.setState({ expectedArtifact, account: accounts[0] });
    };
    this.onAccountChange = (account) => {
      const { expectedArtifact } = this.state;
      this.props.onArtifactChange && this.props.onArtifactChange({
        artifactAccount: account.name,
        id: expectedArtifact.matchArtifact.id,
        reference: expectedArtifact.matchArtifact.name,
        type: expectedArtifact.matchArtifact.type
      });
      this.setState({ account });
    };
    this.onArtifactEdit = (artifact) => {
      const expectedArtifact = { ...this.state.expectedArtifact, matchArtifact: { ...artifact } };
      let account = this.state.account;
      if (this.state.expectedArtifact.matchArtifact.type !== artifact.type) {
        const accounts = this.accountsForExpectedArtifact(expectedArtifact);
        account = accounts[0];
      }
      this.props.onArtifactChange && this.props.onArtifactChange({
        artifactAccount: account ? account.name : "",
        id: artifact.id,
        reference: artifact.name,
        type: artifact.type
      });
      this.setState({ expectedArtifact, account });
    };
    this.availableKinds = () => {
      const kinds = this.props.kinds || [];
      const accounts = this.props.accounts || [];
      if (this.props.showAccounts) {
        return kinds.filter((k) => k.customKind || accounts.find((a) => a.types.includes(k.type)));
      } else {
        return kinds.slice(0);
      }
    };
    this.onArtifactDisplayNameEdit = (event) => {
      const displayName = event.target.value;
      const { expectedArtifact } = this.state;
      const newExpectedArtifact = {
        ...expectedArtifact,
        displayName
      };
      this.setState({ expectedArtifact: newExpectedArtifact });
    };
    const expectedArtifact = props.default ? cloneDeep(props.default) : ExpectedArtifactService.createEmptyArtifact();
    this.state = {
      expectedArtifact,
      source: props.sources[0],
      account: this.accountsForExpectedArtifact(expectedArtifact)[0]
    };
  }
  accountsForExpectedArtifact(expectedArtifact) {
    const artifact = ExpectedArtifactService.artifactFromExpected(expectedArtifact);
    if (!artifact || !this.props.accounts) {
      return [];
    }
    return this.props.accounts.filter((a) => a.types.includes(artifact.type));
  }
  render() {
    const { sources, showIcons, showAccounts, hidePipelineFields } = this.props;
    const { expectedArtifact, source, account } = this.state;
    const accounts = this.accountsForExpectedArtifact(expectedArtifact);
    const artifact = ExpectedArtifactService.artifactFromExpected(expectedArtifact);
    const kinds = this.availableKinds().sort((a, b) => a.label.localeCompare(b.label));
    const kind = ExpectedArtifactService.getKindConfig(artifact, false);
    const EditCmp = kind && kind.editCmp;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, !hidePipelineFields && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Display Name"
    }, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control",
      value: expectedArtifact.displayName,
      onChange: this.onArtifactDisplayNameEdit
    })), sources.length > 1 && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Artifact Source"
    }, /* @__PURE__ */ React__default.createElement(ExpectedArtifactSourceSelector, {
      sources,
      selected: source,
      onChange: this.onSourceChange
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Artifact Kind"
    }, /* @__PURE__ */ React__default.createElement(ExpectedArtifactKindSelector, {
      kinds,
      selected: kind,
      onChange: this.onKindChange,
      showIcons
    })), showAccounts && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Artifact Account"
    }, /* @__PURE__ */ React__default.createElement(ArtifactAccountSelector, {
      accounts,
      selected: account,
      onChange: this.onAccountChange
    })), EditCmp && /* @__PURE__ */ React__default.createElement(EditCmp, {
      account,
      artifact,
      onChange: this.onArtifactEdit,
      pipeline: this.props.pipeline
    }), !hidePipelineFields && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: ""
    }, /* @__PURE__ */ React__default.createElement("button", {
      onClick: this.onSave,
      type: "button",
      className: "btn btn-block btn-primary btn-sm"
    }, "Confirm")));
  }
}
ExpectedArtifactEditor.defaultProps = {
  showIcons: true,
  showAccounts: true,
  fieldColumns: 8,
  singleColumn: false
};
const EXPECTED_ARTIFACT_EDITOR_COMPONENT_REACT = "spinnaker.core.artifacts.expected.editor.react";
module(EXPECTED_ARTIFACT_EDITOR_COMPONENT_REACT, [
  EXPECTED_ARTIFACT_KIND_SELECTOR_COMPONENT_REACT,
  EXPECTED_ARTIFACT_SOURCE_SELECTOR_COMPONENT_REACT
]).component("expectedArtifactEditorReact", react2angular(withErrorBoundary(ExpectedArtifactEditor, "expectedArtifactEditorReact"), [
  "default",
  "kinds",
  "sources",
  "accounts",
  "onSave",
  "showIcons",
  "showAccounts",
  "className",
  "pipeline"
]));

class ArtifactEditor extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onArtifactAccountChanged = (artifactAccount) => {
      const artifact = this.props.artifact && (!this.props.artifact.type || artifactAccount.types.includes(this.props.artifact.type) || artifactAccount.name === CUSTOM_ARTIFACT_ACCOUNT) ? cloneDeep(this.props.artifact) : { id: UUIDGenerator.generateUuid() };
      artifact.artifactAccount = artifactAccount.name;
      if (!artifact.type || artifactAccount.name !== CUSTOM_ARTIFACT_ACCOUNT) {
        artifact.type = artifactAccount.types && artifactAccount.types.length > 0 ? artifactAccount.types[0] : "";
      }
      this.props.onArtifactEdit(artifact);
    };
  }
  defaultArtifactAccountIfNecessary() {
    const { artifact, artifactAccounts } = this.props;
    if (!artifact.artifactAccount && artifactAccounts.length > 0) {
      this.onArtifactAccountChanged(head(artifactAccounts.filter((a) => a.types.includes(artifact.type))) || head(artifactAccounts.filter((a) => a.types.includes(TYPE$7))) || head(artifactAccounts));
    }
  }
  componentDidMount() {
    this.defaultArtifactAccountIfNecessary();
  }
  componentDidUpdate() {
    this.defaultArtifactAccountIfNecessary();
  }
  render() {
    const { pipeline, artifact, artifactAccounts, onArtifactEdit, isDefault } = this.props;
    const artifactAccount = artifactAccounts.find((acc) => acc.name === artifact.artifactAccount) || artifactAccounts[0];
    const accountTypes = artifactAccount ? artifactAccount.types : void 0;
    const kinds = isDefault ? Registry.pipeline.getDefaultArtifactKinds() : Registry.pipeline.getMatchArtifactKinds();
    const kind = accountTypes ? kinds.find((a) => accountTypes.some((typ) => a.typePattern.test(typ))) : void 0;
    const EditCmp = kind && kind.editCmp;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Account",
      fieldColumns: 8
    }, /* @__PURE__ */ React__default.createElement(ArtifactAccountSelector, {
      accounts: artifactAccounts,
      selected: artifactAccount,
      onChange: this.onArtifactAccountChanged
    })), EditCmp && /* @__PURE__ */ React__default.createElement(EditCmp, {
      account: artifactAccount,
      artifact,
      onChange: onArtifactEdit,
      pipeline
    }));
  }
}

const _ExpectedArtifactModal = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.editArtifact = (formik, field, artifact) => {
      formik.setFieldValue(field, artifact);
      formik.setFieldValue(`${field}.artifactAccount`, artifact.artifactAccount);
    };
    this.state = {
      matchArtifactAccounts: [],
      defaultArtifactAccounts: [],
      taskMonitor: new TaskMonitor({ title: "I'm never used" })
    };
  }
  componentDidMount() {
    const { excludedArtifactTypePatterns, excludedDefaultArtifactTypePatterns } = this.props;
    AccountService.getArtifactAccounts().then((artifactAccounts) => {
      this.setState({
        matchArtifactAccounts: excludedArtifactTypePatterns ? artifactAccounts.filter((account) => !account.types.some((typ) => excludedArtifactTypePatterns.some((typPattern) => typPattern.test(typ)))) : artifactAccounts,
        defaultArtifactAccounts: excludedDefaultArtifactTypePatterns ? artifactAccounts.filter((account) => !account.types.some((typ) => excludedDefaultArtifactTypePatterns.some((typPattern) => typPattern.test(typ)))) : artifactAccounts
      });
    });
  }
  static show(props) {
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    return ReactModal.show(_ExpectedArtifactModal, props, modalProps);
  }
  render() {
    const { matchArtifactAccounts, defaultArtifactAccounts } = this.state;
    return /* @__PURE__ */ React__default.createElement(WizardModal, {
      heading: "Expected Artifact",
      initialValues: this.props.expectedArtifact || ExpectedArtifactService.createEmptyArtifact(),
      taskMonitor: this.state.taskMonitor,
      dismissModal: this.props.dismissModal,
      closeModal: this.props.closeModal,
      submitButtonLabel: "Save Artifact",
      render: ({ formik, nextIdx, wizard }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "General",
        wizard,
        order: nextIdx(),
        render: () => /* @__PURE__ */ React__default.createElement(FormikFormField, {
          name: "displayName",
          label: "Display Name",
          input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
            ...props
          }),
          required: true
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Match Artifact",
        wizard,
        order: nextIdx(),
        render: () => /* @__PURE__ */ React__default.createElement(ArtifactEditor, {
          pipeline: this.props.pipeline,
          artifact: formik.values.matchArtifact,
          artifactAccounts: matchArtifactAccounts,
          onArtifactEdit: (artifact) => this.editArtifact(formik, "matchArtifact", artifact),
          isDefault: false
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "If Missing",
        wizard,
        order: nextIdx(),
        render: () => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
          name: "usePriorArtifact",
          label: "Use prior execution",
          input: (props) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
            ...props
          }),
          help: /* @__PURE__ */ React__default.createElement(HelpField, {
            id: "pipeline.config.expectedArtifact.usePriorExecution"
          })
        }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
          name: "useDefaultArtifact",
          label: "Use default artifact",
          input: (props) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
            ...props
          }),
          help: /* @__PURE__ */ React__default.createElement(HelpField, {
            id: "pipeline.config.expectedArtifact.defaultArtifact"
          })
        }), formik.values.useDefaultArtifact && /* @__PURE__ */ React__default.createElement(ArtifactEditor, {
          pipeline: this.props.pipeline,
          artifact: formik.values.defaultArtifact,
          artifactAccounts: defaultArtifactAccounts,
          onArtifactEdit: (artifact) => this.editArtifact(formik, "defaultArtifact", artifact),
          isDefault: true
        }))
      }))
    });
  }
};
let ExpectedArtifactModal = _ExpectedArtifactModal;
ExpectedArtifactModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

const DEFINE_NEW_ARTIFACT = "__inline.artifact__";
class StageArtifactSelector extends React__default.Component {
  constructor(props) {
    super(props);
    this.defineNewArtifactOption = {
      ...ExpectedArtifactService.createEmptyArtifact(),
      displayName: "Define a new artifact...",
      id: DEFINE_NEW_ARTIFACT
    };
    this.destroy$ = new Subject();
    this.renderArtifact = (value) => {
      return /* @__PURE__ */ React__default.createElement("span", null, value.id !== DEFINE_NEW_ARTIFACT && /* @__PURE__ */ React__default.createElement(ArtifactIcon, {
        type: value.matchArtifact && value.matchArtifact.type || value.defaultArtifact && value.defaultArtifact.type,
        width: "16",
        height: "16"
      }), value && value.displayName);
    };
    this.onExpectedArtifactSelected = (value) => {
      if (value.id !== DEFINE_NEW_ARTIFACT) {
        this.props.onExpectedArtifactSelected(value);
      } else {
        this.props.onArtifactEdited(value.defaultArtifact);
      }
    };
    this.onInlineArtifactChanged = (value) => {
      this.props.onArtifactEdited(value);
    };
    this.state = {
      artifactAccounts: []
    };
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  componentDidMount() {
    const excludedPatterns = this.props.excludedArtifactTypePatterns;
    from(AccountService.getArtifactAccounts()).pipe(takeUntil(this.destroy$)).subscribe((artifactAccounts) => {
      this.setState({
        artifactAccounts: excludedPatterns ? artifactAccounts.filter((account) => !account.types.some((typ) => excludedPatterns.some((typPattern) => typPattern.test(typ)))) : artifactAccounts
      });
    });
  }
  render() {
    const { pipeline, stage, expectedArtifactId, artifact, excludedArtifactIds, renderLabel } = this.props;
    const expectedArtifacts = ExpectedArtifactService.getExpectedArtifactsAvailableToStage(stage, pipeline);
    const expectedArtifact = expectedArtifactId ? expectedArtifacts.find((a) => a.id === expectedArtifactId) : artifact ? {
      id: DEFINE_NEW_ARTIFACT,
      displayName: "Artifact from execution context",
      defaultArtifact: artifact
    } : void 0;
    const options = [
      this.defineNewArtifactOption,
      ...expectedArtifacts.filter((a) => !excludedArtifactIds || !excludedArtifactIds.includes(a.id))
    ];
    const select = /* @__PURE__ */ React__default.createElement(Select, {
      clearable: false,
      options,
      value: expectedArtifact,
      optionRenderer: this.renderArtifact,
      valueRenderer: this.renderArtifact,
      onChange: this.onExpectedArtifactSelected,
      placeholder: "Select an artifact..."
    });
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-m-bottom",
      "data-test-id": "Stage.artifactSelector"
    }, renderLabel ? renderLabel(select) : select), !!artifact && /* @__PURE__ */ React__default.createElement(ArtifactEditor, {
      pipeline,
      artifact,
      artifactAccounts: this.state.artifactAccounts,
      onArtifactEdit: (edited) => this.onInlineArtifactChanged(edited),
      isDefault: true
    }));
  }
}
const STAGE_ARTIFACT_SELECTOR_COMPONENT_REACT = "spinnaker.core.artifacts.stage.artifact.selector.react";
module(STAGE_ARTIFACT_SELECTOR_COMPONENT_REACT, []).component("stageArtifactSelectorReact", react2angular(withErrorBoundary(StageArtifactSelector, "stageArtifactSelectorReact"), [
  "pipeline",
  "stage",
  "expectedArtifactId",
  "artifact",
  "onExpectedArtifactSelected",
  "onArtifactEdited",
  "excludedArtifactIds",
  "excludedArtifactTypePatterns"
]));

const StageArtifactSelectorDelegate = (props) => {
  return /* @__PURE__ */ React__default.createElement(StageConfigField, {
    label: props.label,
    helpKey: props.helpKey,
    fieldColumns: props.fieldColumns
  }, /* @__PURE__ */ React__default.createElement(StageArtifactSelector, {
    ...props
  }));
};

var css_248z$23 = ".TriggerArtifactConstraintSelector_Selects > * + * {\n  margin-top: 4px;\n}\n";
styleInject(css_248z$23);

class TriggerArtifactConstraintSelectorInput extends React__default.Component {
  constructor() {
    super(...arguments);
    this.defaultExcludedArtifactTypePatterns = [
      ArtifactTypePatterns.KUBERNETES,
      ArtifactTypePatterns.FRONT50_PIPELINE_TEMPLATE
    ];
    this.excludedArtifactTypes = () => {
      const triggerConfig = Registry.pipeline.getTriggerConfig(this.props.triggerType);
      return this.defaultExcludedArtifactTypePatterns.concat(triggerConfig && triggerConfig.excludedArtifactTypePatterns || []);
    };
    this.handleChange = (index, selectedArtifact) => {
      if (selectedArtifact.id === "__create.new.artifact") {
        ExpectedArtifactModal.show({
          pipeline: this.props.pipeline,
          excludedArtifactTypePatterns: this.excludedArtifactTypes(),
          excludedDefaultArtifactTypePatterns: this.defaultExcludedArtifactTypePatterns
        }).then((artifact) => {
          this.props.addExpectedArtifact(artifact);
          this.props.onChange(createFakeReactSyntheticEvent({
            name: this.props.name,
            value: (this.props.value || []).concat([artifact.id])
          }));
        }, () => null);
        return;
      }
      const selected = (this.props.value || []).slice(0);
      selected[index] = selectedArtifact.id;
      this.props.onChange(createFakeReactSyntheticEvent({ name: this.props.name, value: selected }));
    };
    this.removeExpectedArtifact = (artifact) => {
      const selected = (this.props.value || []).slice();
      this.props.removeExpectedArtifact(artifact);
      this.props.onChange(createFakeReactSyntheticEvent({
        name: this.props.name,
        value: selected.filter((id) => id !== artifact.id)
      }));
    };
    this.editExpectedArtifact = (artifact) => {
      ExpectedArtifactModal.show({
        expectedArtifact: artifact,
        pipeline: this.props.pipeline,
        excludedArtifactTypePatterns: this.excludedArtifactTypes(),
        excludedDefaultArtifactTypePatterns: this.defaultExcludedArtifactTypePatterns
      }).then((artifact2) => this.props.updateExpectedArtifact(artifact2), () => null);
    };
    this.renderArtifact = (artifact) => {
      return /* @__PURE__ */ React__default.createElement("span", null, artifact && artifact.displayName);
    };
  }
  render() {
    const { pipeline } = this.props;
    const selected = this.props.value || [];
    const expectedArtifacts = pipeline.expectedArtifacts || [];
    const isSelected = (artifact) => selected.includes(artifact.id);
    const [selectedArtifacts, availableArtifacts] = partition(expectedArtifacts, isSelected);
    const createNewArtifact = ExpectedArtifactService.createEmptyArtifact();
    createNewArtifact.id = "__create.new.artifact";
    createNewArtifact.displayName = "Define a new artifact...";
    availableArtifacts.push(createNewArtifact);
    const renderSelect = (i, artifact) => {
      const editButtons = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable glyphicon glyphicon-edit",
        onClick: () => this.editExpectedArtifact(artifact)
      }), /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable glyphicon glyphicon-trash",
        onClick: () => this.removeExpectedArtifact(artifact)
      }));
      return /* @__PURE__ */ React__default.createElement("div", {
        key: artifact && artifact.id || "new",
        className: "flex-container-h baseline margin-between-md"
      }, /* @__PURE__ */ React__default.createElement(Select, {
        className: "flex-grow",
        clearable: false,
        value: artifact,
        onChange: (a) => this.handleChange(i, a),
        options: availableArtifacts,
        optionRenderer: this.renderArtifact,
        valueRenderer: this.renderArtifact,
        placeholder: "Select or define an artifact..."
      }), /* @__PURE__ */ React__default.createElement("div", {
        style: { minWidth: "50px" },
        className: "flex-container-h baseline margin-between-md"
      }, artifact && editButtons));
    };
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "TriggerArtifactConstraintSelector_Selects flex-container-v margin-between-md"
    }, selectedArtifacts.map((artifact, i) => renderSelect(i, artifact)), renderSelect(selected.length));
  }
}

const artifactKindConfigs = [
  Base64Match,
  Base64Default,
  BitbucketMatch,
  BitbucketDefault,
  CustomMatch,
  CustomDefault,
  DockerMatch,
  DockerDefault,
  GcsMatch,
  GcsDefault,
  GithubMatch,
  GithubDefault,
  GitRepoMatch,
  GitRepoDefault,
  GitlabMatch,
  GitlabDefault,
  HelmMatch,
  HelmDefault,
  HttpMatch,
  HttpDefault,
  IvyMatch,
  IvyDefault,
  JenkinsMatch,
  JenkinsDefault,
  MavenMatch,
  MavenDefault,
  S3Match,
  S3Default,
  OracleMatch,
  OracleDefault,
  KubernetesMatch,
  KubernetesDefault
];

class PipelineRegistry {
  constructor() {
    this.triggerTypes = [];
    this.stageTypes = [];
    this.transformers = [];
    this.notificationTypes = [];
    this.artifactKinds = artifactKindConfigs;
    this.getStageConfig = memoize(this.getStageConfig.bind(this), (stage) => [stage ? stage.type : "", stage ? PipelineRegistry.resolveCloudProvider(stage) : ""].join(":"));
  }
  normalizeStageTypes() {
    this.stageTypes.filter((stageType) => {
      return stageType.provides;
    }).forEach((stageType) => {
      const parent = this.stageTypes.find((parentType) => {
        return parentType.key === stageType.provides && !parentType.provides;
      });
      if (parent) {
        stageType.label = stageType.label || parent.label;
        stageType.description = stageType.description || parent.description;
        stageType.key = stageType.key || parent.key;
        stageType.manualExecutionComponent = stageType.manualExecutionComponent || parent.manualExecutionComponent;
        if (parent.executionDetailsUrl && !stageType.executionDetailsUrl) {
          stageType.executionDetailsUrl = parent.executionDetailsUrl;
        }
        if (parent.executionConfigSections && !stageType.executionConfigSections) {
          stageType.executionConfigSections = parent.executionConfigSections;
        }
        if (parent.executionDetailsSections && !stageType.executionDetailsSections) {
          stageType.executionDetailsSections = parent.executionDetailsSections;
        }
      }
    });
  }
  registerNotification(notificationConfig) {
    this.notificationTypes.push(notificationConfig);
  }
  registerTrigger(triggerConfig) {
    if (SETTINGS.triggerTypes) {
      if (SETTINGS.triggerTypes.indexOf(triggerConfig.key) >= 0) {
        this.triggerTypes.push(triggerConfig);
      }
    } else {
      this.triggerTypes.push(triggerConfig);
    }
  }
  registerTransformer(transformer) {
    this.transformers.push(transformer);
  }
  registerStage(stageConfig) {
    if ((SETTINGS.hiddenStages || []).includes(stageConfig.key)) {
      return;
    }
    this.stageTypes.push(stageConfig);
    this.normalizeStageTypes();
  }
  async registerPreconfiguredJobStage(stageConfigSkeleton) {
    var _a;
    const preconfiguredJobsFromGate = await PreconfiguredJobReader.list();
    const job = preconfiguredJobsFromGate.find((j) => j.type === stageConfigSkeleton.key);
    if (!job) {
      throw new Error(`Preconfigured Job of type '${stageConfigSkeleton.key}' not found in /jobs/preconfigured from gate.  Is the preconfigured job registered in orca?`);
    }
    const parameters = (_a = job == null ? void 0 : job.parameters) != null ? _a : [];
    const paramsWithDefaults = parameters.filter((p) => !isNil(p.defaultValue));
    const defaultParameterValues = fromPairs(paramsWithDefaults.map((p) => [p.name, p.defaultValue]));
    const { label, description, waitForCompletion, producesArtifacts } = job;
    const stageConfig = {
      ...stageConfigSkeleton,
      configuration: {
        ...stageConfigSkeleton.configuration,
        parameters,
        waitForCompletion
      },
      defaults: {
        parameters: defaultParameterValues
      },
      description,
      label,
      producesArtifacts
    };
    this.registerStage(stageConfig);
    return stageConfig;
  }
  registerArtifactKind(artifactKindConfig) {
    this.artifactKinds.push(artifactKindConfig);
    return artifactKindConfig.editCmp;
  }
  getExecutionTransformers() {
    return this.transformers;
  }
  getNotificationTypes() {
    return cloneDeep(this.notificationTypes);
  }
  getTriggerTypes() {
    return cloneDeep(this.triggerTypes);
  }
  getStageTypes() {
    return cloneDeep(this.stageTypes);
  }
  getMatchArtifactKinds() {
    return cloneDeep(this.artifactKinds.filter((k) => k.isMatch));
  }
  getDefaultArtifactKinds() {
    return cloneDeep(this.artifactKinds.filter((k) => k.isDefault));
  }
  getCustomArtifactKind() {
    return cloneDeep(this.artifactKinds.find((k) => k.key === "custom"));
  }
  getCloudProvidersForStage(type, allStageTypes, accounts) {
    const providersFromAccounts = uniq(accounts.map((acc) => acc.cloudProvider));
    let providersFromStage = [];
    if (type.providesFor) {
      providersFromStage = type.providesFor;
    } else if (type.cloudProvider) {
      providersFromStage = [type.cloudProvider];
    } else if (type.useBaseProvider) {
      const stageProviders = allStageTypes.filter((s) => s.provides === type.key);
      stageProviders.forEach((sp) => {
        if (sp.providesFor) {
          providersFromStage = providersFromStage.concat(sp.providesFor);
        } else {
          providersFromStage.push(sp.cloudProvider);
        }
      });
    } else {
      providersFromStage = providersFromAccounts.slice(0);
    }
    providersFromStage = providersFromStage.filter((providerKey) => {
      const providerAccounts = accounts.filter((acc) => acc.cloudProvider === providerKey);
      return !!providerAccounts.find((acc) => {
        const provider = CloudProviderRegistry.getProvider(acc.cloudProvider);
        return !isExcludedStageType(type, provider);
      });
    });
    if (SETTINGS.feature.dockerBake && type.key === "bake") {
      providersFromAccounts.push("docker");
    }
    return intersection(providersFromAccounts, providersFromStage);
  }
  getConfigurableStageTypes(accounts) {
    const providers = isNil(accounts) ? [] : Array.from(new Set(accounts.map((a) => a.cloudProvider)));
    const allStageTypes = this.getStageTypes();
    let configurableStageTypes = allStageTypes.filter((stageType) => !stageType.synthetic && !stageType.provides);
    if (providers.length === 0) {
      return configurableStageTypes;
    }
    configurableStageTypes.forEach((type) => type.cloudProviders = this.getCloudProvidersForStage(type, allStageTypes, accounts));
    configurableStageTypes = configurableStageTypes.filter((type) => {
      return !accounts.every((a) => {
        const p = CloudProviderRegistry.getProvider(a.cloudProvider);
        return isExcludedStageType(type, p);
      });
    });
    return configurableStageTypes.filter((stageType) => stageType.cloudProviders.length).sort((a, b) => a.label.localeCompare(b.label));
  }
  getProvidersFor(key) {
    let baseKey = key;
    const stageTypes = this.getStageTypes();
    const candidates = stageTypes.filter((stageType) => {
      return stageType.provides && (stageType.provides === key || stageType.key === key || stageType.alias === key);
    });
    if (candidates.length) {
      baseKey = candidates[0].provides;
    }
    return this.getStageTypes().filter((stageType) => {
      return stageType.provides && stageType.provides === baseKey;
    });
  }
  getNotificationConfig(type) {
    return this.getNotificationTypes().find((notificationType) => notificationType.key === type);
  }
  getTriggerConfig(type) {
    return this.getTriggerTypes().find((triggerType) => triggerType.key === type);
  }
  overrideManualExecutionComponent(triggerType, component) {
    const triggerConfig = this.triggerTypes.find((t) => t.key === triggerType);
    if (triggerConfig) {
      triggerConfig.manualExecutionComponent = component;
    }
  }
  checkAliasedStageTypes(stage) {
    const aliasedMatches = this.getStageTypes().filter((stageType) => stageType.alias === stage.type);
    if (aliasedMatches.length === 1) {
      return aliasedMatches[0];
    }
    return null;
  }
  checkAliasFallback(stage) {
    if (stage.alias) {
      const aliasMatches = this.getStageTypes().filter((stageType) => stageType.key === stage.alias);
      if (aliasMatches.length === 1) {
        return aliasMatches[0];
      }
    }
    return null;
  }
  getStageConfig(stage) {
    var _a;
    if (!stage || !stage.type) {
      return null;
    }
    const matches = this.getStageTypes().filter((stageType) => {
      return stageType.key === stage.type || stageType.provides === stage.type;
    });
    switch (matches.length) {
      case 0: {
        const aliasMatch = this.checkAliasedStageTypes(stage) || this.checkAliasFallback(stage);
        const unmatchedStageType = this.getStageTypes().find((s) => s.key === "unmatched");
        return aliasMatch != null ? aliasMatch : unmatchedStageType;
      }
      case 1:
        return matches[0];
      default: {
        const provider = PipelineRegistry.resolveCloudProvider(stage);
        const matchesThisCloudProvider = matches.find((stageType) => stageType.cloudProvider === provider);
        const matchesAnyCloudProvider = matches.find((stageType) => !!stageType.cloudProvider);
        return (_a = matchesThisCloudProvider != null ? matchesThisCloudProvider : matchesAnyCloudProvider) != null ? _a : matches[0];
      }
    }
  }
  static resolveCloudProvider(stage) {
    var _a, _b, _c, _d, _e, _f;
    return (_f = (_e = (_c = (_a = stage.cloudProvider) != null ? _a : stage.cloudProviderType) != null ? _c : (_b = stage.context) == null ? void 0 : _b.cloudProvider) != null ? _e : (_d = stage.context) == null ? void 0 : _d.cloudProviderType) != null ? _f : "aws";
  }
  getManualExecutionComponent(config) {
    if (config && config.manualExecutionComponent) {
      return config.manualExecutionComponent;
    }
    return null;
  }
  getManualExecutionComponentForTriggerType(triggerType) {
    return this.getManualExecutionComponent(this.getTriggerConfig(triggerType));
  }
  hasManualExecutionComponentForTriggerType(triggerType) {
    return this.getManualExecutionComponent(this.getTriggerConfig(triggerType)) !== null;
  }
  getManualExecutionComponentForStage(stage) {
    return this.getStageConfig(stage).manualExecutionComponent;
  }
}
function isExcludedStageType(type, provider) {
  if (!provider || !provider.unsupportedStageTypes) {
    return false;
  }
  return provider.unsupportedStageTypes.indexOf(type.key) > -1;
}

const _Registry = class {
};
let Registry = _Registry;
Registry.pipeline = new PipelineRegistry();
Registry.urlBuilder = new UrlBuilderRegistry();
Registry.reinitialize = () => {
  _Registry.pipeline = new PipelineRegistry();
  _Registry.urlBuilder = new UrlBuilderRegistry();
};
DebugWindow.Registry = Registry;

class StageSummaryController {
  constructor($scope, $stateParams, $state, executionService) {
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.executionService = executionService;
    this.parser = new Parser();
    this.renderer = new HtmlRenderer();
  }
  $onInit() {
    this.updateScope();
  }
  $onChanges() {
    this.updateScope();
  }
  updateScope() {
    this.$scope.application = this.application;
    this.$scope.execution = this.execution;
    this.$scope.stage = this.stage;
    this.$scope.stageSummary = this.stageSummary;
  }
  getStepLabel(stage) {
    const stageConfig = Registry.pipeline.getStageConfig(stage);
    if (stageConfig && stageConfig.executionStepLabelUrl) {
      return stageConfig.executionStepLabelUrl;
    } else {
      return "core/src/pipeline/config/stages/common/stepLabel.html";
    }
  }
  getComments() {
    const parsed = this.parser.parse(this.stageSummary.comments + "");
    return this.renderer.render(parsed);
  }
  getCurrentStep() {
    return parseInt(this.$stateParams.step, 10);
  }
  isStepCurrent(index) {
    return index === this.getCurrentStep();
  }
  isRestartable(stage) {
    if (stage.isRunning || stage.isCompleted) {
      return false;
    }
    const stageConfig = Registry.pipeline.getStageConfig(stage);
    if (!stageConfig || stage.isRestarting === true) {
      return false;
    }
    const allowRestart = this.application.attributes.enableRestartRunningExecutions || false;
    if (this.execution.isRunning && !allowRestart) {
      return false;
    }
    return stageConfig.restartable || false;
  }
  canManuallySkip() {
    const topLevelStage = this.getTopLevelStage();
    return this.stage.isRunning && topLevelStage && topLevelStage.context.canManuallySkip;
  }
  getTopLevelStage() {
    let parentStageId = this.stage.parentStageId;
    let topLevelStage = this.stage;
    while (parentStageId) {
      topLevelStage = this.execution.stages.find((stage) => stage.id === parentStageId);
      parentStageId = topLevelStage.parentStageId;
    }
    return topLevelStage;
  }
  openManualSkipStageModal() {
    const topLevelStage = this.getTopLevelStage();
    ConfirmationModalService.confirm({
      header: "Really skip this stage?",
      buttonText: "Skip",
      askForReason: true,
      submitJustWithReason: true,
      body: `<div class="alert alert-warning">
          <b>Warning:</b> Skipping this stage may have unpredictable results.
          <ul>
            <li>Mutating changes initiated by this stage will continue and will need to be cleaned up manually.</li>
            <li>Downstream stages that depend on the outputs of this stage may fail or behave unexpectedly.</li>
          </ul>
        </div>
      `,
      submitMethod: (reason) => this.executionService.patchExecution(this.execution.id, topLevelStage.id, { manualSkip: true, reason }).then(() => this.executionService.waitUntilExecutionMatches(this.execution.id, (execution) => {
        const updatedStage = execution.stages.find((stage) => stage.id === topLevelStage.id);
        return updatedStage && updatedStage.status === "SKIPPED";
      })).then((updated) => this.executionService.updateExecution(this.application, updated))
    });
  }
  toggleDetails(index) {
    const newStepDetails = this.getCurrentStep() === index ? null : index;
    if (newStepDetails !== null) {
      const newState = { step: newStepDetails };
      const stage = parseInt(this.$stateParams.stage, 10);
      if (stage) {
        newState.stage = stage;
      }
      const subStage = parseInt(this.$stateParams.subStage, 10);
      if (subStage) {
        newState.subStage = subStage;
      }
      this.$state.go(".", newState);
    }
  }
}
StageSummaryController.$inject = ["$scope", "$stateParams", "$state", "executionService"];
const stageSummaryComponent = {
  bindings: {
    application: "<",
    execution: "<",
    sourceUrl: "<",
    stage: "<",
    stageSummary: "<"
  },
  controller: StageSummaryController,
  template: '<div className="stage-summary-wrapper" ng-include="$ctrl.sourceUrl"></div>'
};
const STAGE_SUMMARY_COMPONENT = "spinnaker.core.pipeline.stageSummary.component";
module(STAGE_SUMMARY_COMPONENT, []).component("stageSummary", stageSummaryComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/common/stepLabel.html", `<span class="task-label">{{ step.name | robotToHuman }}</span>
`);
}]);

class StepExecutionDetailsController {
  constructor($scope) {
    this.$scope = $scope;
  }
  $onInit() {
    this.updateScope();
  }
  $onChanges() {
    this.updateScope();
  }
  updateScope() {
    this.$scope.application = this.application;
    this.$scope.config = this.config;
    this.$scope.configSections = this.configSections;
    this.$scope.execution = this.execution;
    this.$scope.stage = this.stage;
  }
}
StepExecutionDetailsController.$inject = ["$scope"];
const stepExecutionDetailsComponent = {
  bindings: {
    application: "<",
    config: "<",
    configSections: "<",
    execution: "<",
    sourceUrl: "<",
    stage: "<"
  },
  controller: StepExecutionDetailsController,
  template: '<div ng-include="$ctrl.sourceUrl"></div>'
};
const STEP_EXECUTION_DETAILS_COMPONENT = "spinnaker.core.pipeline.stepExecutionDetails.component";
module(STEP_EXECUTION_DETAILS_COMPONENT, []).component("stepExecutionDetails", stepExecutionDetailsComponent);

var css_248z$22 = "instance-type-selector tr.unavailable {\n  opacity: 0.5;\n}\n";
styleInject(css_248z$22);

class V2InstanceTypeSelectorController {
  constructor($scope, instanceTypeService) {
    this.$scope = $scope;
    this.instanceTypeService = instanceTypeService;
    this.selectInstanceType = (type) => {
      if (type.unavailable) {
        return;
      }
      this.command.instanceType = type.name;
      if (this.command.viewState.dirty && this.command.viewState.dirty.instanceType) {
        delete this.command.viewState.dirty.instanceType;
      }
      this.instanceTypeService.getInstanceTypeDetails(this.command.selectedProvider, type.name).then((instanceTypeDetails) => {
        this.command.viewState.instanceTypeDetails = instanceTypeDetails;
      });
      this.onTypeChanged && this.onTypeChanged(this.command.instanceType);
    };
    this.getStorageDescription = (instanceType) => {
      if (this.command.instanceType === instanceType.name && this.command.viewState.overriddenStorageDescription) {
        return this.command.viewState.overriddenStorageDescription;
      } else {
        return instanceType.storage.count + "x" + instanceType.storage.size;
      }
    };
    this.getStorageDescriptionHelpKey = (instanceType) => {
      return this.command.instanceType === instanceType.name && this.command.viewState.overriddenStorageDescription ? "instanceType.storageOverridden" : null;
    };
  }
  $onInit() {
    this.instanceProfile = this.command.viewState.instanceProfile;
    this.instanceTypes = this.command.backingData && this.command.backingData.filtered ? this.command.backingData.filtered.instanceTypes : [];
    this.updateFamilies();
  }
  $doCheck() {
    let updateProfiles = false;
    if (this.command.viewState.instanceProfile !== this.instanceProfile) {
      this.instanceProfile = this.command.viewState.instanceProfile;
      updateProfiles = true;
    }
    const hasFilteredBackingData = this.command.backingData && this.command.backingData.filtered;
    if (hasFilteredBackingData && this.command.backingData.filtered.instanceTypes !== this.instanceTypes) {
      this.instanceTypes = this.command.backingData.filtered.instanceTypes;
      updateProfiles = true;
    }
    if (updateProfiles) {
      this.updateFamilies();
    }
  }
  updateFamilies() {
    let availableTypes = [];
    if (this.command.backingData && this.command.backingData.filtered) {
      availableTypes = this.command.backingData.filtered.instanceTypes || [];
    }
    this.instanceTypeService.getCategories(this.command.selectedProvider).then((categories) => {
      categories.forEach((profile) => {
        if (profile.type === this.command.viewState.instanceProfile) {
          if (!this.command.viewState.disableImageSelection) {
            profile.families.forEach((family) => {
              family.instanceTypes.forEach((instanceType) => {
                instanceType.unavailable = availableTypes.every((available) => available !== instanceType.name);
              });
            });
          }
          this.$scope.selectedInstanceProfile = profile;
        }
      });
    });
  }
}
V2InstanceTypeSelectorController.$inject = ["$scope", "instanceTypeService"];
const v2InstanceTypeSelector = {
  bindings: {
    command: "<",
    onTypeChanged: "="
  },
  controller: V2InstanceTypeSelectorController,
  controllerAs: "instanceTypeCtrl",
  templateUrl: "core/src/serverGroup/configure/common/instanceTypeDirective.html"
};
const V2_INSTANCE_TYPE_SELECTOR = "spinnaker.core.serverGroup.configure.common.v2instanceTypeSelector";
module(V2_INSTANCE_TYPE_SELECTOR, []).component("v2InstanceTypeSelector", v2InstanceTypeSelector);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/serverGroup/configure/common/instanceTypeDirective.html", `<dirty-instance-type-notification command="command"></dirty-instance-type-notification>
<div class="row" ng-repeat="family in selectedInstanceProfile.families">
  <div class="col-md-12">
    <h4>{{selectedInstanceProfile.label}}: {{family.type}}</h4>
    <p>{{family.description}}</p>
    <table class="table table-hover">
      <thead>
        <tr>
          <th></th>
          <th>Size</th>
          <th>vCPU</th>
          <th>Mem (GiB)</th>
          <th>
            {{family.storageType || 'SSD'}} Storage (GB)
            <help-field ng-if="family.storageHelpFieldKey" key="{{family.storageHelpFieldKey}}"></help-field>
          </th>
          <th>Cost</th>
        </tr>
      </thead>
      <tbody>
        <tr
          ng-repeat="instanceType in family.instanceTypes"
          ng-class="{info: instanceTypeCtrl.command.instanceType === instanceType.name, clickable: !instanceType.unavailable, unavailable: instanceType.unavailable}"
          ng-click="instanceTypeCtrl.selectInstanceType(instanceType)"
        >
          <td>
            <help-field ng-if="instanceType.unavailable" key="instanceType.unavailable"></help-field>
            <help-field ng-if="instanceType.helpFieldKey" key="{{instanceType.helpFieldKey}}"></help-field>
            <input
              type="radio"
              ng-value="instanceType.name"
              ng-model="instanceTypeCtrl.command.instanceType"
              ng-disabled="instanceType.unavailable"
            />
          </td>
          <td>{{instanceType.label}}</td>
          <td>{{instanceType.cpu}}</td>
          <td>{{instanceType.memory}}</td>
          <td ng-if="instanceType.storage.type === 'EBS'">EBS Only</td>
          <td ng-if="instanceType.storage.type === 'SSD' || family.storageType">
            <help-field
              ng-if="instanceTypeCtrl.getStorageDescriptionHelpKey(instanceType)"
              key="{{instanceTypeCtrl.getStorageDescriptionHelpKey(instanceType)}}"
            ></help-field>
            {{instanceTypeCtrl.getStorageDescription(instanceType)}}
          </td>
          <td><cost-factor factor="instanceType.costFactor"></cost-factor></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
`);
}]);

const CORE_SERVERGROUP_CONFIGURE_COMMON_COSTFACTOR = "spinnaker.core.serverGroup.configure.common.costFactor";
module(CORE_SERVERGROUP_CONFIGURE_COMMON_COSTFACTOR, []).directive("costFactor", function() {
  return {
    restrict: "E",
    scope: {
      factor: "=",
      range: "="
    },
    templateUrl: "core/src/serverGroup/configure/common/costFactor.html",
    link: function(scope) {
      function getUsage(factor) {
        return {
          used: new Array(factor + 1).join("$"),
          unused: new Array(5 - factor).join("$")
        };
      }
      function applyFactors() {
        if (!scope.range) {
          const usage = getUsage(scope.factor);
          scope.used = usage.used;
          scope.unused = usage.unused;
        } else {
          scope.min = getUsage(scope.range.min);
          scope.max = getUsage(scope.range.max);
        }
      }
      applyFactors();
      scope.$watch("range", applyFactors);
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/serverGroup/configure/common/costFactor.html", `<span class="cost-factor" ng-if="!range"> <span class="cost">{{used}}</span>{{unused}} </span>
<span class="cost-factor" ng-if="range">
  <span class="cost">{{min.used}}</span>{{min.unused}} &ndash; <span class="cost">{{max.used}}</span>{{max.unused}}
</span>
`);
}]);

const CORE_PRESENTATION_ISVISIBLE_ISVISIBLE_DIRECTIVE = "spinnaker.core.presentation.isVisible.directive";
module(CORE_PRESENTATION_ISVISIBLE_ISVISIBLE_DIRECTIVE, []).directive("isVisible", function() {
  return function(scope, element, attr) {
    scope.$watch(attr.isVisible, function(visible) {
      element.css("visibility", visible ? "visible" : "hidden");
    });
  };
});

class V2InstanceArchetypeSelectorController {
  constructor($scope, instanceTypeService) {
    this.$scope = $scope;
    this.instanceTypeService = instanceTypeService;
    this.selectInstanceType = (type) => {
      const { $scope } = this;
      if ($scope.selectedInstanceProfile && $scope.selectedInstanceProfile.type === type) {
        type = null;
        $scope.selectedInstanceProfile = null;
      }
      this.command.viewState.instanceProfile = type;
      $scope.instanceProfiles.forEach((profile) => {
        if (profile.type === type) {
          $scope.selectedInstanceProfile = profile;
          const current = this.command.instanceType;
          if (current && !includes(["custom", "buildCustom"], profile.type)) {
            const found = profile.families.some((family) => family.instanceTypes.some((instanceType) => instanceType.name === current && !instanceType.unavailable));
            if (!found) {
              this.command.instanceType = null;
            }
          }
        }
      });
      this.onProfileChanged && this.onProfileChanged(type);
    };
    this.updateInstanceType = () => {
      if (ModalWizard.renderedPages.length > 0) {
        if (this.command.instanceType) {
          ModalWizard.markComplete("instance-type");
        } else {
          ModalWizard.markIncomplete("instance-type");
        }
      }
    };
    this.updateInstanceTypeDetails = () => {
      this.instanceTypeService.getInstanceTypeDetails(this.command.selectedProvider, this.command.instanceType).then((instanceTypeDetails) => {
        this.command.viewState.instanceTypeDetails = instanceTypeDetails;
      });
      this.onTypeChanged && this.onTypeChanged(this.command.instanceType);
    };
  }
  $onInit() {
    const { $scope } = this;
    this.instanceTypeService.getCategories(this.command.selectedProvider).then((categories) => {
      $scope.instanceProfiles = categories;
      categories.forEach((profile) => {
        if (profile.type === this.command.viewState.instanceProfile) {
          profile.families.forEach((family) => {
            family.instanceTypes.forEach((instanceType) => {
              instanceType.unavailable = false;
            });
          });
        }
      });
      if ($scope.instanceProfiles.length % 3 === 0) {
        $scope.columns = 3;
      }
      if ($scope.instanceProfiles.length % 4 === 0) {
        $scope.columns = 4;
      }
      if ($scope.instanceProfiles.length % 5 === 0 || $scope.instanceProfiles.length === 7) {
        $scope.columns = 5;
      }
      this.selectInstanceType(this.command.viewState.instanceProfile);
    });
    if (this.command.region && this.command.instanceType && !this.command.viewState.instanceProfile) {
      this.selectInstanceType("custom");
    }
    this.getInstanceBuilderTemplate = CloudProviderRegistry.getValue.bind(CloudProviderRegistry, this.command.cloudProvider, "instance.customInstanceBuilderTemplateUrl");
    $scope.$watch("$ctrl.command.instanceType", () => this.updateInstanceType());
  }
}
V2InstanceArchetypeSelectorController.$inject = ["$scope", "instanceTypeService"];
const v2InstanceArchetypeSelector = {
  bindings: {
    command: "<",
    onProfileChanged: "=",
    onTypeChanged: "="
  },
  controller: V2InstanceArchetypeSelectorController,
  controllerAs: "instanceArchetypeCtrl",
  templateUrl: "core/src/serverGroup/configure/common/v2instanceArchetype.directive.html"
};
const V2_INSTANCE_ARCHETYPE_SELECTOR = "spinnaker.core.serverGroup.configure.common.v2instanceArchetypeSelector";
module(V2_INSTANCE_ARCHETYPE_SELECTOR, [
  CORE_SERVERGROUP_CONFIGURE_COMMON_COSTFACTOR,
  CORE_PRESENTATION_ISVISIBLE_ISVISIBLE_DIRECTIVE
]).component("v2InstanceArchetypeSelector", v2InstanceArchetypeSelector);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/serverGroup/configure/common/v2instanceArchetype.directive.html", `<h4 class="col-md-12" style="margin-top: 10px">This application is:</h4>
<div class="archetype-columns archetype-columns-{{columns}}" ng-repeat="instanceProfile in instanceProfiles">
  <button
    class="instance-profile"
    type="button"
    ng-class="{active: instanceArchetypeCtrl.command.viewState.instanceProfile === instanceProfile.type}"
    ng-click="instanceArchetypeCtrl.selectInstanceType(instanceProfile.type)"
  >
    <span
      is-visible="instanceArchetypeCtrl.command.viewState.instanceProfile === instanceProfile.type"
      class="far fa-check-circle selected-indicator"
    ></span>
    <div class="panel-heading">
      <h4>
        <span class="glyphicon glyphicon-{{instanceProfile.icon}}"></span>
        <div>{{instanceProfile.label}}</div>
      </h4>
    </div>
  </button>
</div>
<div class="clearfix" ng-if="instanceArchetypeCtrl.command.viewState.instanceProfile === 'custom'">
  <dirty-instance-type-notification command="instanceArchetypeCtrl.command"></dirty-instance-type-notification>
  <div class="col-md-8">
    <select
      class="form-control input-sm"
      ng-model="instanceArchetypeCtrl.command.instanceType"
      ng-options="customType for customType in instanceArchetypeCtrl.command.backingData.filtered.instanceTypes"
      ng-change="instanceArchetypeCtrl.updateInstanceTypeDetails()"
      required
    >
      <option value="">Select an instance type...</option>
    </select>
  </div>
</div>
<ng-include
  src="instanceArchetypeCtrl.getInstanceBuilderTemplate()"
  ng-if="instanceArchetypeCtrl.command.viewState.instanceProfile === 'buildCustom'"
>
</ng-include>
`);
}]);

const accountRegionClusterSelectorWrapperComponent = {
  bindings: {
    application: "<",
    component: "<",
    accounts: "<",
    clusterField: "<",
    singleRegion: "<",
    showAllRegions: "<?",
    onAccountUpdate: "<?",
    disableRegionSelect: "<?"
  },
  template: `
    <account-region-cluster-selector
      application="$ctrl.application"
      component="$ctrl.component"
      accounts="$ctrl.accounts"
      cluster-field="{{::$ctrl.clusterField}}"
      single-region="$ctrl.singleRegion"
      show-all-regions="$ctrl.showAllRegions"
      on-account-update="$ctrl.onAccountUpdate"
      disable-region-select="$ctrl.disableRegionSelect">
    </account-region-cluster-selector>
  `
};
const ACCOUNT_REGION_CLUSTER_SELECTOR_WRAPPER = "spinnaker.core.accountRegionClusterSelectorWrapper.component";
module(ACCOUNT_REGION_CLUSTER_SELECTOR_WRAPPER, []).component("accountRegionClusterSelectorWrapper", accountRegionClusterSelectorWrapperComponent);

class NgReactInjector extends ReactInject {
  constructor() {
    super(...arguments);
    this.$injectorProxy = {};
    this.AccountRegionClusterSelector = angular2react("accountRegionClusterSelectorWrapper", accountRegionClusterSelectorWrapperComponent, this.$injectorProxy);
    this.InstanceArchetypeSelector = angular2react("v2InstanceArchetypeSelector", v2InstanceArchetypeSelector, this.$injectorProxy);
    this.InstanceTypeSelector = angular2react("v2InstanceTypeSelector", v2InstanceTypeSelector, this.$injectorProxy);
    this.StageSummaryWrapper = angular2react("stageSummary", stageSummaryComponent, this.$injectorProxy);
    this.StepExecutionDetailsWrapper = angular2react("stepExecutionDetails", stepExecutionDetailsComponent, this.$injectorProxy);
    this.TargetSelect = angular2react("targetSelect", targetSelectComponent, this.$injectorProxy);
  }
  initialize($injector) {
    const realInjector = $injector;
    const proxyInjector = this.$injectorProxy;
    Object.keys($injector).filter((key) => typeof realInjector[key] === "function").forEach((key) => proxyInjector[key] = realInjector[key].bind(realInjector));
  }
}
const NgReact = new NgReactInjector();

class StateEvents {
  constructor($rootScope) {
    this.$rootScope = $rootScope;
    this.stateChangeSuccess = new Subject();
    this.locationChangeSuccess = new Subject();
    const onChangeSuccess = (_event, to, toParams, from, fromParams) => {
      this.stateChangeSuccess.next({ to, toParams, from, fromParams });
    };
    const onLocationChangeSuccess = (_event, newUrl) => this.locationChangeSuccess.next(newUrl);
    this.$rootScope.$on("$stateChangeSuccess", onChangeSuccess);
    this.$rootScope.$on("$locationChangeSuccess", onLocationChangeSuccess);
  }
}
StateEvents.$inject = ["$rootScope"];
const STATE_EVENTS = "spinnaker.core.state.events";
module(STATE_EVENTS, []).service("stateEvents", StateEvents);

var css_248z$21 = "react-ui-view-adapter {\n  flex: 1 1 auto;\n  display: flex;\n  height: 100%;\n}\n";
styleInject(css_248z$21);

const REACT_MODULE = "spinnaker.core.react";
module(REACT_MODULE, ["bcherny/ngimport", "ui.router", STATE_EVENTS]).run([
  "$injector",
  function($injector) {
    ReactInjector.initialize($injector);
    ModalInjector.initialize($injector);
    NgReact.initialize($injector);
  }
]);

function arePropsEqual(propsA, propsB, keys, isEqual = (a, b) => a === b) {
  return keys.every((key) => isEqual(propsA[key], propsB[key]));
}

class SecurityGroupWriter {
  static deleteSecurityGroup(securityGroup, application, params) {
    params.type = "deleteSecurityGroup";
    params.securityGroupName = securityGroup.name;
    params.regions = [securityGroup.region];
    params.credentials = securityGroup.accountId;
    const operation = TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Delete ${FirewallLabels.get("Firewall")}: ${securityGroup.name}`
    });
    InfrastructureCaches.clearCache("securityGroups");
    return operation;
  }
  static upsertSecurityGroup(securityGroup, application, description, params = {}) {
    params.type = "upsertSecurityGroup";
    params.securityGroupName = securityGroup.name;
    params.credentials = securityGroup.credentials || securityGroup.accountName;
    const job = { ...securityGroup, ...params };
    const operation = TaskExecutor.executeTask({
      job: [job],
      application,
      description: `${description} ${FirewallLabels.get("Firewall")}: ${securityGroup.name}`
    });
    InfrastructureCaches.clearCache("securityGroups");
    return operation;
  }
}

var css_248z$20 = ".search-result {\n  display: inline-block;\n  width: calc(100% - 20px);\n}\n.search-result > span + span {\n  margin-left: 6px;\n}\n";
styleInject(css_248z$20);

class SearchResult extends React__default.Component {
  render() {
    const { displayName, account } = this.props;
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "search-result"
    }, account && /* @__PURE__ */ React__default.createElement(AccountTag, {
      account
    }), /* @__PURE__ */ React__default.createElement(Markdown, {
      tag: "span",
      message: displayName
    }));
  }
}

const GlobalSearchRecentItems = ({
  categories,
  onItemKeyDown,
  onResultClick,
  resultRef
}) => {
  if (!categories.length) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("ul", {
    className: "dropdown-menu",
    role: "menu"
  }, categories.map((category, categoryIndex) => [
    /* @__PURE__ */ React__default.createElement("li", {
      key: category.category,
      className: "category-heading"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "category-heading"
    }, "Recent ", category.category)),
    ...category.results.map((result, index) => {
      const params = result.params || {};
      const account = result.account || params.account || params.accountId || params.accountName;
      return /* @__PURE__ */ React__default.createElement("li", {
        key: result.id,
        className: "result",
        onClick: () => onResultClick(category.category)
      }, /* @__PURE__ */ React__default.createElement(UISref, {
        to: result.state,
        params: result.params
      }, /* @__PURE__ */ React__default.createElement("a", {
        ref: (ref) => resultRef(categoryIndex, index, ref),
        onKeyDown: onItemKeyDown
      }, /* @__PURE__ */ React__default.createElement(SearchResult, {
        displayName: result.displayName,
        account
      }))));
    })
  ]));
};

const findMatchingApplicationResultToQuery = (categories, query) => {
  if (!categories) {
    return void 0;
  }
  for (const category of categories) {
    if (category.type.id === "applications") {
      const matchingApp = category.results.find((result) => result.application.toLowerCase() === query.toLowerCase());
      if (matchingApp) {
        return { category, result: matchingApp };
      }
    }
  }
  return void 0;
};
const getSearchQuery = (query, tab) => {
  return SETTINGS.searchVersion === 2 ? { key: query, tab } : { q: query };
};

const GlobalSearchResults = ({
  categories,
  query,
  onItemKeyDown,
  onResultClick,
  onSeeMoreClick,
  resultRef
}) => {
  if (!categories.length) {
    return /* @__PURE__ */ React__default.createElement("ul", {
      className: "dropdown-menu",
      role: "menu"
    }, /* @__PURE__ */ React__default.createElement("li", {
      className: "result"
    }, /* @__PURE__ */ React__default.createElement("a", null, "No matches")));
  }
  const matchingApp = findMatchingApplicationResultToQuery(categories, query);
  return /* @__PURE__ */ React__default.createElement("ul", {
    className: "dropdown-menu",
    role: "menu"
  }, categories.map((category, categoryIndex) => {
    const showMoreParams = getSearchQuery(query, category.type.id);
    return [
      /* @__PURE__ */ React__default.createElement("li", {
        key: category.type.id,
        className: "category-heading flex-container-h no-wrap space-between baseline"
      }, /* @__PURE__ */ React__default.createElement("span", null, category.type.displayName), /* @__PURE__ */ React__default.createElement(UISref, {
        to: "home.search",
        params: showMoreParams
      }, /* @__PURE__ */ React__default.createElement("a", {
        target: "_self",
        className: "expand-results",
        ref: (ref) => resultRef(categoryIndex, 0, ref),
        onClick: onSeeMoreClick,
        onKeyDown: onItemKeyDown
      }, "show all"))),
      category.results.map((result, index) => /* @__PURE__ */ React__default.createElement("li", {
        key: result.href,
        className: "result"
      }, /* @__PURE__ */ React__default.createElement("a", {
        onKeyDown: onItemKeyDown,
        onClick: () => onResultClick(result),
        ref: (ref) => resultRef(categoryIndex, index + 1, ref),
        href: result.href,
        className: result === (matchingApp == null ? void 0 : matchingApp.result) ? "query-match" : void 0
      }, /* @__PURE__ */ React__default.createElement(SearchResult, {
        displayName: result.displayName,
        account: result.account
      }))))
    ];
  }));
};

var css_248z$1$ = ".infrastructure-project {\n  display: block;\n  border: 1px solid var(--color-mineshaft);\n  background-color: var(--color-white);\n  margin-bottom: 15px;\n}\n.infrastructure-project a {\n  color: var(--color-mineshaft);\n  display: block;\n}\n.infrastructure-project a:active,\n.infrastructure-project a:hover {\n  font-weight: 600;\n}\n.infrastructure-project .project-summary {\n  padding: 10px;\n  background-color: var(--color-primary);\n  color: var(--color-alabaster);\n}\n.infrastructure-project .project-summary .remove-result-link {\n  opacity: 0;\n}\n.infrastructure-project .project-summary:hover .remove-result-link {\n  opacity: 1;\n  transition: opacity 0.25s ease-in;\n  color: var(--color-concrete);\n}\n.infrastructure-project .project-summary:hover .remove-result-link:hover,\n.infrastructure-project .project-summary:hover .remove-result-link:active {\n  color: var(--color-accent);\n}\n.infrastructure-project .project-summary .project-name {\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 120%;\n}\n.infrastructure-project .project-summary .project-name a {\n  color: var(--color-accessory-light);\n  display: inline-block;\n  width: calc(100% - 20px);\n}\n.infrastructure-project .application-list {\n  padding: 10px 15px;\n  margin-bottom: 0;\n  border-top: 1px solid var(--color-mineshaft);\n  background-color: var(--color-cirrus);\n}\n.infrastructure-project .application-list li {\n  list-style-type: none;\n}\n.infrastructure-project .application-list li a {\n  color: var(--color-mineshaft);\n}\n";
styleInject(css_248z$1$);

var __defProp$u = Object.defineProperty;
var __getOwnPropDesc$u = Object.getOwnPropertyDescriptor;
var __decorateClass$u = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$u(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$u(target, key, result);
  return result;
};
let ProjectSummaryPod = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleRemoveClicked = (evt) => {
      evt.preventDefault();
      this.props.onRemoveProject(this.props.id);
    };
    this.handleResultClick = () => {
      if (this.props.onResultClick) {
        this.props.onResultClick("projects");
      }
    };
  }
  render() {
    const { projectName, applications, onRemoveProject } = this.props;
    const showRemoveButton = !!onRemoveProject;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure-project",
      onClick: this.handleResultClick
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "project-summary"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "project-name"
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: "home.project.dashboard",
      params: { project: projectName }
    }, /* @__PURE__ */ React__default.createElement("a", null, projectName)), showRemoveButton && /* @__PURE__ */ React__default.createElement("span", {
      className: "small clickable remove-result-link",
      onClick: this.handleRemoveClicked
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "remove from history",
      placement: "left",
      delayShow: 300
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-remove"
    })))), /* @__PURE__ */ React__default.createElement("div", {
      className: "application-count"
    }, applications.length || 0, " Application", applications.length !== 1 ? "s" : "")), /* @__PURE__ */ React__default.createElement("ul", {
      className: "application-list"
    }, applications.map((application) => /* @__PURE__ */ React__default.createElement("li", {
      key: application
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: "home.project.application.insight.clusters",
      params: { project: projectName, application }
    }, /* @__PURE__ */ React__default.createElement("a", null, application))))));
  }
};
ProjectSummaryPod = __decorateClass$u([
  UIRouterContext
], ProjectSummaryPod);

var __defProp$t = Object.defineProperty;
var __getOwnPropDesc$t = Object.getOwnPropertyDescriptor;
var __decorateClass$t = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$t(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$t(target, key, result);
  return result;
};
let SearchResultPodItem = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleResultClick = () => {
      if (this.props.onResultClick) {
        this.props.onResultClick(this.props.categoryName);
      }
    };
  }
  handleRemoveClicked(evt, categoryName, itemId) {
    evt.preventDefault();
    this.props.onRemoveItem(categoryName, itemId);
  }
  render() {
    const { categoryName, result, onRemoveItem } = this.props;
    const showRemoveButton = !!onRemoveItem;
    const params = result.params || {};
    const account = result.account || params.account || params.accountId || params.accountName;
    return /* @__PURE__ */ React__default.createElement(UISref, {
      to: result.state,
      params: result.params
    }, /* @__PURE__ */ React__default.createElement("a", {
      target: "_self",
      className: "list-group-item"
    }, /* @__PURE__ */ React__default.createElement("span", {
      onClick: this.handleResultClick
    }, /* @__PURE__ */ React__default.createElement(SearchResult, {
      displayName: result.displayName,
      account
    }), showRemoveButton && /* @__PURE__ */ React__default.createElement("span", {
      className: "small clickable remove-result-link",
      onClick: (evt) => this.handleRemoveClicked(evt, categoryName, result.id)
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "remove from history",
      placement: "left",
      delayShow: 300
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-remove"
    }))))));
  }
};
SearchResultPodItem = __decorateClass$t([
  UIRouterContext
], SearchResultPodItem);

class SearchResultPod extends React__default.Component {
  render() {
    const { podData } = this.props;
    const { category } = podData;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4 category-container",
      key: category
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "panel category row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "summary"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "category-icon"
    }, podData.config.iconClass && /* @__PURE__ */ React__default.createElement("span", {
      className: podData.config.iconClass
    })), robotToHuman(category), " (", podData.results.length, ")"), /* @__PURE__ */ React__default.createElement("div", {
      className: "details-container list-group"
    }, podData.results.map((result) => /* @__PURE__ */ React__default.createElement(SearchResultPodItem, {
      key: result.id,
      categoryName: category,
      result,
      onResultClick: this.props.onResultClick,
      onRemoveItem: this.props.onRemoveItem
    })))));
  }
}

class SearchResultPods extends React__default.Component {
  render() {
    const { results } = this.props;
    if (!results.length) {
      return null;
    }
    const projects = results.find((x) => x.category === "projects");
    const otherCategories = results.filter((x) => x.category !== "projects").sort((a, b) => a.category.localeCompare(b.category));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure-section container"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "recent-items"
    }, /* @__PURE__ */ React__default.createElement("h3", null, "Recently viewed"), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, projects && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, projects.results.map((project) => /* @__PURE__ */ React__default.createElement(ProjectSummaryPod, {
      key: project.id,
      id: project.id,
      projectName: get(project, "params.project"),
      applications: get(project, "extraData.config.applications", []),
      onRemoveProject: this.props.onRemoveProject,
      onResultClick: this.props.onResultClick
    }))))), /* @__PURE__ */ React__default.createElement("div", {
      className: `col-md-${projects ? 9 : 12}`
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, otherCategories.map((category) => /* @__PURE__ */ React__default.createElement(SearchResultPod, {
      key: category.category,
      podData: category,
      onRemoveItem: this.props.onRemoveItem,
      onResultClick: () => this.props.onResultClick(category.category)
    })))))));
  }
}

const MAX_ITEMS = 5;
class RecentHistoryService {
  static getItems(type) {
    const replacements = [
      {
        state: "securityGroup",
        replacement: "firewall"
      },
      {
        state: "securityGroupDetails",
        replacement: "firewallDetails"
      }
    ];
    const items = this.cache.get(type) || [];
    items.forEach((item) => {
      replacements.forEach((replacement) => {
        if (item.state && item.state.includes(replacement.state)) {
          item.state = item.state.replace(replacement.state, replacement.replacement);
        }
      });
    });
    return sortBy(items, "accessTime").reverse();
  }
  static addItem(type, state, params, keyParams = []) {
    const items = this.getItems(type).slice(0, MAX_ITEMS);
    const existing = this.getExisting(items, params, keyParams);
    const entry = {
      params,
      state,
      accessTime: new Date().getTime(),
      extraData: {},
      id: UUIDGenerator.generateUuid()
    };
    if (existing) {
      items.splice(items.indexOf(existing), 1);
    }
    if (items.length === MAX_ITEMS) {
      items.pop();
    }
    items.push(entry);
    this.cache.put(type, items);
  }
  static removeItem(type, id) {
    const items = this.getItems(type);
    const existing = items.find((i) => i.id === id);
    if (existing) {
      items.splice(items.indexOf(existing), 1);
      this.cache.put(type, items);
    }
  }
  static removeLastItem(type) {
    const items = this.getItems(type);
    if (items.length) {
      items.splice(0, 1);
      this.cache.put(type, items);
    }
  }
  static addExtraDataToLatest(type, extraData) {
    const items = this.getItems(type);
    if (items.length) {
      items[0].extraData = extraData;
      this.cache.put(type, items);
    }
  }
  static removeByAppName(appName) {
    const type = "applications";
    const items = this.getItems(type);
    const remaining = items.filter((item) => item.params.application !== appName);
    if (remaining) {
      this.cache.put(type, remaining);
    }
  }
  static getExisting(items, params, keyParams) {
    if (!keyParams || !keyParams.length) {
      return find(items, { params: omitBy(params, isUndefined) });
    }
    return items.find((item) => keyParams.every((p) => item.params[p] === params[p]));
  }
}
RecentHistoryService.cache = DeckCacheFactory.createCache("history", "user", {
  version: 3,
  maxAge: Duration.fromObject({ days: 90 }).as("milliseconds")
});
const RECENT_HISTORY_SERVICE = "spinnaker.core.history.recentHistory.service";
module(RECENT_HISTORY_SERVICE, []).run([
  "$rootScope",
  ($rootScope) => {
    $rootScope.$on("$stateChangeSuccess", (_event, toState, toParams) => {
      var _a;
      const history = (_a = toState.data) == null ? void 0 : _a.history;
      if (history) {
        const params = omit(toParams || {}, ["debug", "vis", "trace"]);
        const state = history.state || toState.name;
        RecentHistoryService.addItem(history.type, state, params, history.keyParams);
      }
    });
  }
]);

function RecentlyViewedItems(props) {
  const { Component } = props;
  const categoryNames = ["projects", "applications", "loadBalancers", "serverGroups", "instances", "securityGroups"];
  const search = React__default.useMemo(() => ReactInjector.infrastructureSearchService.getSearcher(), []);
  function getFullHistoryEntry(category, item) {
    const routeParams = { ...item.params, ...item.extraData };
    return search.formatRouteResult(category, routeParams).then((displayName) => ({ ...item, displayName }));
  }
  const { result, refresh } = useData(async () => {
    const getCategoryResults = async (category) => {
      const config = search.getCategoryConfig(category);
      const items = RecentHistoryService.getItems(category);
      const results = await Promise.all(items.map((item) => getFullHistoryEntry(category, item)));
      return { category, config, results };
    };
    const categories = await Promise.all(categoryNames.map((category) => getCategoryResults(category)));
    return categories.filter((category) => category.results.length);
  }, [], []);
  const handleRemoveItem = (categoryName, itemId) => {
    RecentHistoryService.removeItem(categoryName, itemId);
    refresh();
  };
  const handleResultClick = (categoryName) => {
    logger.log({ category: "Primary Search", action: `Recent item selected from ${categoryName}` });
  };
  return Component ? /* @__PURE__ */ React__default.createElement(Component, {
    results: result,
    onRemoveItem: handleRemoveItem,
    onRemoveProject: (projectId) => handleRemoveItem("projects", projectId),
    onResultClick: handleResultClick
  }) : /* @__PURE__ */ React__default.createElement(SearchResultPods, {
    results: result,
    onRemoveItem: handleRemoveItem,
    onRemoveProject: (projectId) => handleRemoveItem("projects", projectId),
    onResultClick: handleResultClick
  });
}

const searchRank = (input, query = "") => {
  if (!input || !input.length) {
    return [];
  }
  const normalizedQuery = query.toLowerCase();
  return input.slice().sort((a, b) => {
    if (a.displayName && b.displayName) {
      const aIndex = a.displayName.toLowerCase().indexOf(normalizedQuery);
      const bIndex = b.displayName.toLowerCase().indexOf(normalizedQuery);
      return aIndex === bIndex ? a.displayName.localeCompare(b.displayName) : aIndex - bIndex;
    }
    return 0;
  });
};
const searchRankFilter = () => searchRank;
const SEARCH_RANK_FILTER = "spinnaker.core.search.searchResult.searchRank.filter";
module(SEARCH_RANK_FILTER, []).filter("searchRank", searchRankFilter);

var __defProp$s = Object.defineProperty;
var __getOwnPropDesc$s = Object.getOwnPropertyDescriptor;
var __decorateClass$s = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$s(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$s(target, key, result);
  return result;
};
const SLASH_KEY = "/";
const MIN_SEARCH_LENGTH = 3;
const isQuestionMark = ({ key, shiftKey }) => key === "/" && shiftKey;
let GlobalSearch = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.query$ = new Subject();
    this.destroy$ = new Subject();
    this.handleWindowKeyup = (event) => {
      const { target, key } = event;
      if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || isQuestionMark(event) || key !== SLASH_KEY) {
        return;
      }
      this.searchField.focus();
    };
    this.handleWindowClick = (event) => {
      if (!this.container.contains(event.target)) {
        this.hideDropdown();
      }
    };
    this.searchFieldBlurred = ({ relatedTarget }) => {
      if (!this.container.contains(relatedTarget)) {
        this.hideDropdown();
      }
    };
    this.searchFieldKeyUp = (event) => {
      if (!this.state.showDropdown) {
        return;
      }
      const { key, shiftKey } = event;
      if (key === "Escape") {
        logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "escape (from input)" } });
        this.searchField.blur();
      } else if (key === "ArrowDown") {
        logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "arrow down (from input)" } });
        event.preventDefault();
        this.focusFirstSearchResult();
      } else if (key === "ArrowUp") {
        logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "arrow up (from input)" } });
        event.preventDefault();
        this.focusLastSearchResult();
      } else if (key === "Tab") {
        if (!shiftKey) {
          logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "tab (from input)" } });
          event.preventDefault();
          this.focusFirstSearchResult();
        }
      } else if (key === "Enter") {
        const { $state } = ReactInjector;
        if (this.state.categories) {
          const matchingQueryResult = findMatchingApplicationResultToQuery(this.state.categories, this.state.query);
          if (matchingQueryResult) {
            $state.go("home.applications.application", {
              application: matchingQueryResult.result.application
            });
            this.hideDropdown();
          } else {
            $state.go("home.search", getSearchQuery(this.state.query));
          }
        }
        event.preventDefault();
      }
    };
    this.focusFirstSearchResult = () => {
      const refToFocus = this.resultRefs[0] && this.resultRefs[0][0];
      refToFocus && refToFocus.focus();
    };
    this.focusLastSearchResult = () => {
      const flattenedRefs = flatten(this.resultRefs);
      const refToFocus = flattenedRefs[flattenedRefs.length - 1];
      refToFocus && refToFocus.focus();
    };
    this.navigateResult = (event) => {
      const { key, target } = event;
      if (key === "Escape") {
        logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "escape (from result)" } });
        this.setState({
          showDropdown: false,
          showMinLengthWarning: false,
          query: "",
          querying: false,
          categories: null
        });
      } else if (key === "Tab") {
        const flattenedRefs = flatten(this.resultRefs);
        const lastResultRef = flattenedRefs[flattenedRefs.length - 1];
        if (target === lastResultRef) {
          logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "tab (from result)" } });
          this.hideDropdown();
          return;
        }
      } else if (key === "ArrowDown") {
        logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "down (from result)" } });
        const flattenedRefs = flatten(this.resultRefs);
        const currentRefIndex = flattenedRefs.indexOf(target);
        const nextResultRef = flattenedRefs[currentRefIndex + 1];
        nextResultRef && nextResultRef.focus();
        event.preventDefault();
      } else if (key === "ArrowUp") {
        logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "up (from result)" } });
        const flattenedRefs = flatten(this.resultRefs);
        const currentRefIndex = flattenedRefs.indexOf(target);
        const prevResultRef = flattenedRefs[currentRefIndex - 1];
        prevResultRef && prevResultRef.focus();
        event.preventDefault();
      } else if (key === "Enter") {
        logger.log({ category: "Global Search", action: "Keyboard Nav", data: { label: "enter (from result)" } });
        setTimeout(() => this.hideDropdown(), 100);
      }
    };
    this.queryChanged = ({ target }) => {
      const query = target.value;
      const { showMinLengthWarning } = this.state;
      const shouldKeepWarningVisible = !!query && query.length < MIN_SEARCH_LENGTH && showMinLengthWarning;
      this.setState({
        query,
        querying: false,
        showMinLengthWarning: shouldKeepWarningVisible,
        categories: null
      }, () => {
        if (query.length >= MIN_SEARCH_LENGTH) {
          this.query$.next(query.trim());
        } else if (!shouldKeepWarningVisible) {
          this.considerMinLengthWarning();
        }
      });
    };
    this.showDropdown = () => {
      this.setState({ showDropdown: true });
    };
    this.hideDropdown = () => {
      this.setState({ showDropdown: false });
    };
    this.clearFilters = (result) => {
      ClusterState.filterService.overrideFiltersForUrl(result);
    };
    this.SpinnerDropdown = () => /* @__PURE__ */ React__default.createElement("ul", {
      className: "dropdown-menu",
      role: "menu"
    }, /* @__PURE__ */ React__default.createElement("li", {
      className: "horizontal middle center spinner-section"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "small"
    })));
    this.MinLengthWarning = () => /* @__PURE__ */ React__default.createElement("ul", {
      className: "dropdown-menu",
      role: "menu"
    }, /* @__PURE__ */ React__default.createElement("li", {
      className: "horizontal middle center spinner-section"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "error-message"
    }, "Please enter at least ", MIN_SEARCH_LENGTH, " characters")));
    this.RecentlyViewed = () => /* @__PURE__ */ React__default.createElement(RecentlyViewedItems, {
      limit: 5,
      Component: ({ results }) => {
        this.resultRefs = results.map(() => []);
        return /* @__PURE__ */ React__default.createElement(GlobalSearchRecentItems, {
          categories: results,
          onItemKeyDown: this.navigateResult,
          onResultClick: (category) => {
            this.hideDropdown();
            logger.log({ category: "Global Search", action: `Recent item selected from ${category}` });
          },
          resultRef: (categoryIndex, resultIndex, ref) => {
            if (this.resultRefs[categoryIndex]) {
              this.resultRefs[categoryIndex][resultIndex] = ref;
            }
          }
        });
      }
    });
    this.SearchResults = () => {
      const { query, categories } = this.state;
      return /* @__PURE__ */ React__default.createElement(GlobalSearchResults, {
        categories,
        query,
        onItemKeyDown: this.navigateResult,
        onResultClick: (result) => {
          logger.log({ category: "Global Search", action: "Result Selected" });
          this.hideDropdown();
          this.clearFilters(result);
        },
        onSeeMoreClick: () => {
          logger.log({ category: "Global Search", action: "See all results selected" });
          this.hideDropdown();
        },
        resultRef: (categoryIndex, resultIndex, ref) => {
          if (this.resultRefs[categoryIndex]) {
            this.resultRefs[categoryIndex][resultIndex] = ref;
          }
        }
      });
    };
    this.state = {
      showDropdown: false,
      showMinLengthWarning: false,
      query: "",
      querying: false,
      categories: null
    };
  }
  componentDidMount() {
    window.addEventListener("keyup", this.handleWindowKeyup);
    window.addEventListener("click", this.handleWindowClick);
    const { infrastructureSearchService } = ReactInjector;
    const search = infrastructureSearchService.getSearcher();
    this.query$.pipe(debounceTime(300), tap((query) => {
      logger.log({ category: "Global Search", action: "Query", data: { label: query } });
      this.setState({ querying: true });
    }), switchMap((query) => from(search.query(query))), map((result) => result.filter(({ results }) => results.length).map((category) => ({
      ...category,
      results: searchRank(category.results, category.query).slice(0, 5)
    })).sort((a, b) => a.type.order - b.type.order)), takeUntil(this.destroy$)).subscribe((categories) => {
      this.resultRefs = categories.map(() => []);
      this.setState({ querying: false, categories });
    });
  }
  componentWillUnmount() {
    window.removeEventListener("keyup", this.handleWindowKeyup);
    window.removeEventListener("click", this.handleWindowClick);
    this.destroy$.next();
  }
  considerMinLengthWarning() {
    const { query } = this.state;
    this.setState({ showMinLengthWarning: !!query && query.length < MIN_SEARCH_LENGTH });
  }
  renderDropdown() {
    const { query, querying, showMinLengthWarning, categories } = this.state;
    const { SpinnerDropdown, MinLengthWarning, SearchResults, RecentlyViewed } = this;
    if (!query) {
      return /* @__PURE__ */ React__default.createElement(RecentlyViewed, null);
    }
    if (querying) {
      return /* @__PURE__ */ React__default.createElement(SpinnerDropdown, null);
    }
    if (query.length < MIN_SEARCH_LENGTH && showMinLengthWarning) {
      return /* @__PURE__ */ React__default.createElement(MinLengthWarning, null);
    } else if (categories) {
      return /* @__PURE__ */ React__default.createElement(SearchResults, null);
    }
    return null;
  }
  render() {
    const { showDropdown, query } = this.state;
    return /* @__PURE__ */ React__default.createElement("li", {
      ref: (ref) => this.container = ref,
      className: "global-search open"
    }, /* @__PURE__ */ React__default.createElement("form", {
      className: "right global-search",
      onSubmit: (e) => e.preventDefault()
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group has-feedback"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "input-group"
    }, /* @__PURE__ */ React__default.createElement("input", {
      ref: (ref) => this.searchField = ref,
      type: "search",
      className: "form-control flat input-sm no-border",
      placeholder: "Search",
      value: query,
      onBlur: this.searchFieldBlurred,
      onFocus: this.showDropdown,
      onChange: this.queryChanged,
      onKeyUp: this.searchFieldKeyUp
    }), /* @__PURE__ */ React__default.createElement(Tooltip, {
      placement: "right",
      template: /* @__PURE__ */ React__default.createElement("span", null, "Keyboard shortcut: ", /* @__PURE__ */ React__default.createElement("span", {
        className: "keyboard-key"
      }, "/"))
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "glyphicon glyphicon-search form-control-feedback"
    }))))), showDropdown && this.renderDropdown());
  }
};
__decorateClass$s([
  Debounce(300)
], GlobalSearch.prototype, "considerMinLengthWarning", 1);
GlobalSearch = __decorateClass$s([
  UIRouterContext
], GlobalSearch);

class StateHelper {
  constructor($stateRegistryProvider) {
    this.$stateRegistryProvider = $stateRegistryProvider;
    this.registeredStates = [];
  }
  setNestedState(state, keepOriginalNames = false) {
    const newState = copy(state);
    if (!keepOriginalNames) {
      this.fixStateName(newState);
      this.fixStateViews(newState);
      newState.parent = null;
    }
    if (!this.registeredStates.includes(newState.name)) {
      this.registeredStates.push(newState.name);
      this.$stateRegistryProvider.register(newState);
    }
    if (newState.children && newState.children.length) {
      newState.children.forEach((childState) => {
        childState.parent = newState.name;
        this.setNestedState(childState, keepOriginalNames);
      });
    }
  }
  fixStateName(state) {
    if (state.parent) {
      state.name = `${state.parent}.${state.name}`;
    }
  }
  fixStateViews(state) {
    const views = state.views || {};
    const replaced = [];
    Object.keys(views).forEach((key) => {
      const relative = key.match("../");
      if (relative && relative.length && typeof state.parent === "string") {
        const relativePath = state.parent.split(".").slice(0, -1 - relative.length).join(".") + ".";
        views[key.replace(/(..\/)+/, relativePath)] = views[key];
        replaced.push(key);
      }
    });
    replaced.forEach((key) => delete views[key]);
  }
  $get() {
    return this;
  }
}
StateHelper.$inject = ["$stateRegistryProvider"];
const STATE_HELPER = "spinnaker.core.navigation.stateHelper.provider";
module(STATE_HELPER, []).provider("stateHelper", StateHelper);

var css_248z$1_ = ".secondary-panel > div {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.secondary-panel .nav {\n  margin: 52px 24px 32px 4px;\n}\n.secondary-panel .nav h3 {\n  margin-right: 10px;\n  font-weight: 600;\n}\n.secondary-panel .nav h4 {\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-bottom: 0;\n  font-size: 16px;\n}\n.secondary-panel .nav .list-group-item.active {\n  font-weight: 700;\n}\n.secondary-panel .nav .nav-search {\n  margin-top: 10px;\n}\n.secondary-panel .nav-content .header {\n  border-bottom: none;\n  padding: 0;\n  position: relative;\n  z-index: 10;\n  background-color: var(--color-alabaster);\n}\n.secondary-panel .nav-content .header h3 {\n  display: inline-block;\n  font-weight: 600;\n}\n.secondary-panel .nav-content .header .actions {\n  display: inline-block;\n}\n.secondary-panel .nav-content .header .filters {\n  display: inline-block;\n}\n.secondary-panel .nav-content .header .filters label {\n  font-weight: normal;\n  margin-bottom: 0;\n  margin-left: 10px;\n}\n.secondary-panel .nav-content .header.header-clusters {\n  padding-top: 0;\n}\n.secondary-panel .nav-content .header.header-clusters h3 {\n  padding-bottom: 5px;\n}\n@media (min-width: 708px) and (max-width: 992px) {\n  .secondary-panel .nav-content .header.header-clusters h3 {\n    font-size: 110%;\n  }\n}\n.secondary-panel .nav-content .header.header-clusters .filters {\n  height: 40px;\n  line-height: 40px;\n  vertical-align: top;\n  font-size: 90%;\n}\n.secondary-panel .nav-content .content {\n  padding: 0 0 10px;\n}\n@media (min-width: 708px) and (max-width: 992px) {\n  .secondary-panel .nav-content .content {\n    padding: 0 5px;\n  }\n}\n.nav.navbar-nav .remove-border-top:hover,\n.nav.navbar-nav .remove-border-top:active {\n  border-top-color: transparent;\n  transition: none;\n}\n.nav.navbar-nav .glyphicon {\n  padding-right: 4px;\n}\n";
styleInject(css_248z$1_);

class StateConfigProvider {
  constructor($urlRouterProvider, stateHelperProvider) {
    this.$urlRouterProvider = $urlRouterProvider;
    this.stateHelperProvider = stateHelperProvider;
    this.root = {
      name: "home",
      abstract: true,
      params: {
        allowModalToStayOpen: { dynamic: true, value: null }
      },
      url: "?{debug:boolean}&{vis:query}&{trace:query}",
      dynamic: true,
      children: []
    };
  }
  addToRootState(child) {
    const current = this.root.children.find((c) => c.name === child.name);
    if (!current) {
      this.root.children.push(child);
    }
    this.setStates();
  }
  setStates() {
    this.stateHelperProvider.setNestedState(this.root);
  }
  addRewriteRule(base, replacement) {
    this.$urlRouterProvider.when(base, replacement);
  }
  buildDynamicParams(paramConfig) {
    return paramConfig.reduce((acc, p) => {
      const param = p.param || p.model;
      acc[param] = {
        type: p.type || "string",
        dynamic: true
      };
      if (p.array) {
        acc[param].array = true;
      }
      return acc;
    }, {});
  }
  paramsToQuery(paramConfig) {
    return paramConfig.map((p) => p.param || p.model).join("&");
  }
  $get() {
    return this;
  }
}
StateConfigProvider.$inject = ["$urlRouterProvider", "stateHelperProvider"];
const trueKeyObjectParamType = {
  decode: (val) => {
    if (val) {
      const r = {};
      val.split(",").map((k) => k.replace(/%2c/g, ",")).forEach((k) => r[k] = true);
      return r;
    }
    return {};
  },
  encode: (val) => {
    if (val) {
      const r = Object.keys(val).filter((k) => val[k]);
      return r.length ? r.sort().map((k) => k.replace(/,/g, "%2c")).join(",") : null;
    }
    return null;
  },
  equals: (a, b) => isEqual(a, b),
  is: (val) => isPlainObject(val)
};
const inverseBooleanParamType = {
  decode: (val) => {
    if (val) {
      return val !== "true";
    }
    return true;
  },
  encode: (val) => {
    return val ? null : "true";
  },
  equals: (a, b) => a === b,
  is: () => true
};
const booleanParamType = {
  decode: (val) => {
    if (val) {
      return val === "true";
    }
    return false;
  },
  encode: (val) => {
    return val ? "true" : null;
  },
  equals: (a, b) => a === b,
  is: () => true
};
const sortKeyParamType = {
  decode: (val) => {
    return { key: val };
  },
  encode: (val) => {
    if (val) {
      return val.key;
    }
    return null;
  },
  equals: (a, b) => isEqual(a, b),
  is: (val) => isPlainObject(val)
};
const STATE_CONFIG_PROVIDER = "spinnaker.core.navigation.state.config.provider";
module(STATE_CONFIG_PROVIDER, [UIROUTER_ANGULARJS, STATE_HELPER]).provider("stateConfig", StateConfigProvider).config([
  "$urlRouterProvider",
  ($urlRouterProvider) => {
    $urlRouterProvider.otherwise("/");
    $urlRouterProvider.when("/{path:.*}/", [
      "$match",
      ($match) => {
        return "/" + $match.path;
      }
    ]);
  }
]).config([
  "$urlServiceProvider",
  ($urlServiceProvider) => {
    $urlServiceProvider.config.type("trueKeyObject", trueKeyObjectParamType);
    $urlServiceProvider.config.type("inverse-boolean", inverseBooleanParamType);
    $urlServiceProvider.config.type("boolean", booleanParamType);
    $urlServiceProvider.config.type("sortKey", sortKeyParamType);
  }
]);

class UrlBuilderUtils {
  static forEachSorted(obj, iterator, context) {
    const keys = Object.keys(obj).sort();
    keys.forEach((key) => {
      iterator.call(context, obj[key], key);
    });
  }
  static encodeUriQuery(value) {
    return encodeURIComponent(value).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
  }
  static buildUrl(url, params = {}) {
    if (!params) {
      return url;
    }
    const parts = [];
    UrlBuilderUtils.forEachSorted(params, (value, key) => {
      if (value === null || isUndefined(value)) {
        return;
      }
      let val;
      if (Array.isArray(value)) {
        val = value;
      } else {
        val = [value];
      }
      val.forEach((v) => {
        if (isObject(v)) {
          if (isDate(v)) {
            v = v.toISOString();
          } else {
            v = JSON.stringify(v);
          }
        }
        parts.push(`${UrlBuilderUtils.encodeUriQuery(key)}=${UrlBuilderUtils.encodeUriQuery(v)}`);
      });
    });
    if (parts.length > 0 && url) {
      url += (url.includes("?") ? "&" : "?") + parts.join("&");
    }
    return url;
  }
}
class ApplicationsUrlBuilder {
  build(input, $state) {
    let result;
    if (input.project) {
      result = $state.href("home.project.application", { application: input.application, project: input.project }, { inherit: false });
    } else {
      result = $state.href("home.applications.application", {
        application: input.application
      }, { inherit: false });
    }
    return result;
  }
}
class ClustersUrlBuilder {
  build(input, $state) {
    const filters = {
      acct: input.account
    };
    if (input.cluster) {
      filters.q = `cluster:${input.cluster}`;
    }
    if (input.stack) {
      filters.stack = input.stack;
    }
    if (input.detail) {
      filters.q = `detail:${input.detail}`;
    }
    if (input.region) {
      filters.reg = input.region;
    }
    let href;
    if (input.project) {
      href = $state.href("home.project.application.insight.clusters", {
        application: input.application,
        project: input.project
      }, { inherit: false });
    } else {
      href = $state.href("home.applications.application.insight.clusters", {
        application: input.application
      }, { inherit: false });
    }
    return UrlBuilderUtils.buildUrl(href, filters);
  }
}
class InstancesUrlBuilder {
  build(input, $state) {
    let result;
    if (!input.application) {
      result = $state.href("home.instanceDetails", {
        account: input.account,
        region: input.region,
        instanceId: input.instanceId,
        provider: input.provider
      });
    } else {
      const href = $state.href("home.applications.application.insight.clusters.instanceDetails", {
        application: input.application,
        instanceId: input.instanceId,
        provider: input.provider
      }, { inherit: false });
      result = UrlBuilderUtils.buildUrl(href, { q: input.serverGroup, acct: input.account, reg: input.region });
    }
    return result;
  }
}
class LoadBalancersUrlBuilder {
  build(input, $state) {
    const href = $state.href("home.applications.application.insight.loadBalancers.loadBalancerDetails", {
      application: input.application,
      name: input.loadBalancer,
      region: input.region || input.namespace,
      accountId: input.account,
      vpcId: input.vpcId,
      provider: input.provider
    }, { inherit: false });
    return UrlBuilderUtils.buildUrl(href, { q: input.loadBalancer, reg: input.region, acct: input.account });
  }
}
class ProjectsUrlBuilder {
  build(input, $state) {
    return $state.href("home.project.dashboard", { project: input.name }, { inherit: false });
  }
}
class SecurityGroupsUrlBuilder {
  build(input, $state) {
    const href = $state.href("home.firewallDetails", {
      accountId: input.account,
      region: input.region,
      name: input.name,
      vpcId: input.vpcId,
      provider: input.provider
    });
    return UrlBuilderUtils.buildUrl(href);
  }
}
class ServerGroupsUrlBuilder {
  build(input, $state) {
    const baseName = input.project ? "project" : "applications";
    const href = $state.href(`home.${baseName}.application.insight.clusters.serverGroup`, {
      application: input.application,
      accountId: input.account,
      region: input.region,
      serverGroup: input.serverGroup,
      provider: input.provider,
      project: input.project
    }, { inherit: false });
    return UrlBuilderUtils.buildUrl(href, { q: input.serverGroup, acct: input.account, reg: input.region });
  }
}
class TaskUrlBuilder {
  build(input, $state) {
    return $state.href("home.applications.application.tasks.taskDetails", {
      application: input.application,
      taskId: input.taskId
    }, { inherit: false });
  }
}
class TasksUrlBuilder {
  build(input, $state) {
    return $state.href("home.applications.application.tasks", {
      application: input.application
    }, { inherit: false });
  }
}
class UrlBuilder {
  constructor($state) {
    this.$state = $state;
  }
  createCloneTask(task) {
    const regionAndName = task.getValueFor("deploy.server.groups");
    const account = task.getValueFor("deploy.account.name");
    let result;
    if (!regionAndName || !Object.keys(regionAndName)[0]) {
      result = false;
    } else {
      const regions = Object.keys(regionAndName);
      const region = regions[0];
      const asgName = regionAndName[region][0];
      if (!asgName) {
        result = false;
      } else if (!asgName.match(NameUtils.VERSION_PATTERN)) {
        result = false;
      } else {
        result = this.$state.href("home.applications.application.insight.clusters.serverGroup", {
          application: asgName.split("-")[0],
          cluster: asgName.replace(NameUtils.VERSION_PATTERN, ""),
          account,
          accountId: account,
          region: regions,
          serverGroup: asgName,
          q: asgName
        });
      }
    }
    return result;
  }
  asgTask(task) {
    const asgName = task.getValueFor("asgName");
    const account = task.getValueFor("credentials");
    let result;
    if (!asgName) {
      result = false;
    } else if (!asgName.match(NameUtils.VERSION_PATTERN)) {
      result = "/";
    } else {
      result = this.$state.href("home.applications.application.insight.clusters.serverGroup", {
        application: asgName.split("-")[0],
        cluster: asgName.replace(NameUtils.VERSION_PATTERN, ""),
        account,
        accountId: account,
        region: task.getValueFor("regions")[0],
        serverGroup: asgName
      });
    }
    return result;
  }
  static buildFromMetadata(input) {
    const builder = Registry.urlBuilder.getBuilder(input.type);
    let result;
    if (builder) {
      result = builder.build(input, ReactInjector.$state);
    } else {
      result = "/";
    }
    return result;
  }
  buildFromTask(task) {
    const description = task.name || "";
    function contains(str) {
      return description.includes(str);
    }
    let result;
    switch (true) {
      case contains("Destroy Server Group"):
        result = false;
        break;
      case contains("Disable Server Group"):
        result = this.asgTask(task);
        break;
      case contains("Enable Server Group"):
        result = this.asgTask(task);
        break;
      case contains("Resize Server Group"):
        result = this.asgTask(task);
        break;
      case contains("Create Cloned Server Group"):
        result = this.createCloneTask(task);
        break;
      case contains("Create New Server Group"):
        result = this.createCloneTask(task);
        break;
      default:
        result = false;
    }
    return result;
  }
}
Registry.urlBuilder.register("applications", new ApplicationsUrlBuilder());
Registry.urlBuilder.register("clusters", new ClustersUrlBuilder());
Registry.urlBuilder.register("instances", new InstancesUrlBuilder());
Registry.urlBuilder.register("loadBalancers", new LoadBalancersUrlBuilder());
Registry.urlBuilder.register("projects", new ProjectsUrlBuilder());
Registry.urlBuilder.register("securityGroups", new SecurityGroupsUrlBuilder());
Registry.urlBuilder.register("serverGroups", new ServerGroupsUrlBuilder());
Registry.urlBuilder.register("task", new TaskUrlBuilder());
Registry.urlBuilder.register("tasks", new TasksUrlBuilder());

class UrlParser {
  static parseQueryString(query = "") {
    const result = {};
    query.split("&").forEach((keyValue) => {
      let splitPoint, key, val;
      if (keyValue) {
        key = keyValue = keyValue.replace(/\+/g, "%20");
        splitPoint = keyValue.indexOf("=");
        if (splitPoint !== -1) {
          key = keyValue.substring(0, splitPoint);
          val = keyValue.substring(splitPoint + 1);
        }
        key = this.tryDecodeURIComponent(key);
        if (key !== null) {
          val = val && val.length > 0 ? this.tryDecodeURIComponent(val) : true;
          if (result[key] === void 0) {
            result[key] = val;
          } else if (Array.isArray(result[key])) {
            result[key].push(val);
          } else {
            result[key] = [result[key], val];
          }
        }
      }
    });
    return result;
  }
  static tryDecodeURIComponent(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
      return null;
    }
  }
}

var SearchStatus;
(function(SearchStatus2) {
  SearchStatus2[SearchStatus2["INITIAL"] = 0] = "INITIAL";
  SearchStatus2[SearchStatus2["SEARCHING"] = 1] = "SEARCHING";
  SearchStatus2[SearchStatus2["FINISHED"] = 2] = "FINISHED";
  SearchStatus2[SearchStatus2["NO_RESULTS"] = 3] = "NO_RESULTS";
  SearchStatus2[SearchStatus2["ERROR"] = 4] = "ERROR";
})(SearchStatus || (SearchStatus = {}));

class SearchResultTypeRegistry {
  constructor() {
    this.types = [];
  }
  register(searchResultType) {
    this.types.push(searchResultType);
  }
  get(typeId) {
    return this.types.find((f) => f.id === typeId);
  }
  getAll() {
    return this.types.slice().sort((a, b) => a.order - b.order);
  }
  getSearchCategories() {
    return this.types.map((f) => f.id);
  }
}
const searchResultTypeRegistry = new SearchResultTypeRegistry();

class InfrastructureSearchServiceV2 {
  static search(apiParams) {
    if (isEmpty(apiParams)) {
      return from(this.EMPTY_RESULTS);
    }
    const params = { ...apiParams };
    const types = searchResultTypeRegistry.getAll();
    const otherResults$ = new Subject();
    const addComputedAttributes = (result, type) => {
      return {
        ...result,
        href: UrlBuilder.buildFromMetadata(result),
        displayName: type.displayFormatter(result)
      };
    };
    const makeResultSet = (searchResults, type) => {
      const results = uniqBy(searchResults.results.map((result) => addComputedAttributes(result, type)).filter((r) => r.href), (r) => r.href);
      const query = apiParams.key;
      return { type, results, status: SearchStatus.FINISHED, query };
    };
    const emitErrorResultSet = (error, type) => {
      return of({ error, type, results: [], status: SearchStatus.ERROR });
    };
    return from(types).pipe(mergeMap((type) => {
      return type.search(params, otherResults$).pipe(map((searchResults) => makeResultSet(searchResults, type)), catchError((error) => emitErrorResultSet(error, type)));
    }), tap((result) => otherResults$.next(result)), finalize(() => otherResults$.complete()));
  }
}
InfrastructureSearchServiceV2.EMPTY_RESULTS = searchResultTypeRegistry.getAll().map((type) => ({ type, results: [], status: SearchStatus.FINISHED }));

var css_248z$1Z = ".glyphicon.healthy,\n.fa.healthy {\n  color: var(--color-success);\n}\n.glyphicon.unhealthy,\n.fa.unhealthy {\n  color: var(--color-danger);\n}\n.glyphicon.unknown,\n.fa.unknown {\n  color: var(--color-dovegray);\n}\nhealth-counts {\n  display: inherit;\n}\n.health-counts .instance-health-counts .glyphicon {\n  top: 0;\n}\n.health-counts .instance-health-counts .healthy {\n  color: var(--color-success);\n}\n.health-counts .instance-health-counts .unhealthy {\n  color: var(--color-alert);\n}\n.health-counts .instance-health-counts .dead {\n  color: var(--color-danger);\n}\n";
styleInject(css_248z$1Z);

class HealthCounts extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = this.calculatePercent(props.container);
  }
  calculatePercent(container) {
    container = container || {};
    const up = container.up || 0;
    const down = container.down || 0;
    const succeeded = container.succeeded || 0;
    const failed = container.failed || 0;
    const unknown = container.unknown || 0;
    const starting = container.starting || 0;
    const total = container.total || up + down + unknown + starting + succeeded + failed;
    const percent = total ? Math.floor((up + succeeded) * 100 / total) : void 0;
    const percentLabel = percent === void 0 ? "n/a" : percent + "%";
    const statusClass = percent === void 0 ? "disabled" : percent === 100 ? "healthy" : percent < 100 && percent > 0 ? "unhealthy" : percent === 0 ? "dead" : "disabled";
    return { percentLabel, statusClass, total };
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.container, this.props.container)) {
      this.setState(this.calculatePercent(nextProps.container));
    }
  }
  render() {
    const legend = /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("table", {
      className: "tooltip-table"
    }, /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-Up-triangle healthy"
    })), /* @__PURE__ */ React__default.createElement("td", null, "Up")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-Down-triangle dead"
    })), /* @__PURE__ */ React__default.createElement("td", null, "Down")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-Unknown-triangle unknown"
    })), /* @__PURE__ */ React__default.createElement("td", null, "In transition or no status reported")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-minus disabled small"
    })), /* @__PURE__ */ React__default.createElement("td", null, "Out of Service")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-Succeeded-triangle small"
    })), /* @__PURE__ */ React__default.createElement("td", null, "Terminated successfully")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-Failed-triangle small"
    })), /* @__PURE__ */ React__default.createElement("td", null, "Terminated unsuccessfully")))), /* @__PURE__ */ React__default.createElement("span", null, this.props.additionalLegendText));
    const container = this.props.container;
    const percentLabel = this.state.percentLabel;
    let hasValue = false;
    const counts = [];
    if (container.up) {
      counts.push(/* @__PURE__ */ React__default.createElement("span", {
        key: "up"
      }, " ", container.up, " ", /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-Up-triangle healthy"
      })));
      hasValue = true;
    }
    if (container.down && container.down !== container.missingHealthCount) {
      if (hasValue) {
        counts.push(/* @__PURE__ */ React__default.createElement("span", {
          key: "downslash"
        }, " / "));
      }
      counts.push(/* @__PURE__ */ React__default.createElement("span", {
        key: "down"
      }, " ", container.down, " ", /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-Down-triangle dead"
      })));
      hasValue = true;
    }
    if (container.unknown || container.starting) {
      if (hasValue) {
        counts.push(/* @__PURE__ */ React__default.createElement("span", {
          key: "unknownslash"
        }, " / "));
      }
      counts.push(/* @__PURE__ */ React__default.createElement("span", {
        key: "unknown"
      }, " ", container.unknown + container.starting, " ", /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-Unknown-triangle unknown"
      })));
      hasValue = true;
    }
    if (container.outOfService) {
      if (hasValue) {
        counts.push(/* @__PURE__ */ React__default.createElement("span", {
          key: "outOfServiceslash"
        }, " / "));
      }
      counts.push(/* @__PURE__ */ React__default.createElement("span", {
        key: "outOfService"
      }, " ", container.outOfService, " ", /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-OutOfService-triangle disabled small"
      })));
      hasValue = true;
    }
    if (container.succeeded) {
      if (hasValue) {
        counts.push(/* @__PURE__ */ React__default.createElement("span", {
          key: "succeededslash"
        }, " / "));
      }
      counts.push(/* @__PURE__ */ React__default.createElement("span", {
        key: "succeeded"
      }, " ", container.succeeded, " ", /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-Succeeded-triangle disabled small"
      })));
      hasValue = true;
    }
    if (container.failed) {
      if (hasValue) {
        counts.push(/* @__PURE__ */ React__default.createElement("span", {
          key: "failedslash"
        }, " / "));
      }
      counts.push(/* @__PURE__ */ React__default.createElement("span", {
        key: "failed"
      }, " ", container.failed, " ", /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-Failed-triangle disabled small"
      })));
    }
    const className = this.props.className || "";
    if (percentLabel !== "n/a") {
      return /* @__PURE__ */ React__default.createElement("span", {
        className: `health-counts ${className}`
      }, /* @__PURE__ */ React__default.createElement(Tooltip, {
        template: legend,
        placement: this.props.legendPlacement
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "counter instance-health-counts"
      }, counts, container.unknown !== this.state.total && /* @__PURE__ */ React__default.createElement("span", null, " ", ": ", /* @__PURE__ */ React__default.createElement("span", {
        className: this.state.statusClass
      }, percentLabel)))));
    } else if (container.outOfService) {
      return /* @__PURE__ */ React__default.createElement("span", {
        className: `health-counts ${className}`
      }, /* @__PURE__ */ React__default.createElement(Tooltip, {
        template: legend
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "counter instance-health-counts"
      }, /* @__PURE__ */ React__default.createElement("span", null, container.outOfService, " ", /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-minus disabled small"
      })))));
    } else {
      return null;
    }
  }
}
HealthCounts.defaultProps = {
  legendPlacement: "top",
  container: {}
};

class ApplicationDataSourceRegistry {
  static setDataSourceOrder(keys) {
    this.dataSourceOrder = keys;
    this.sortDataSources();
  }
  static sortDataSources() {
    let order = this.defaultDataSourceOrder;
    if (this.dataSourceOrder.length) {
      order = this.dataSourceOrder;
    }
    this.dataSources.forEach((ds) => {
      if (!order.includes(ds.key)) {
        order.push(ds.key);
      }
    });
    this.dataSources.sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
  }
  static registerDataSource(config) {
    this.dataSources.push(config);
    this.sortDataSources();
  }
  static getDataSources() {
    return cloneDeep(this.dataSources);
  }
  static removeDataSource(key) {
    this.dataSources = this.dataSources.filter((data) => {
      return data.key !== key;
    });
  }
  static clearDataSources() {
    this.dataSources.length = 0;
  }
}
ApplicationDataSourceRegistry.defaultDataSourceOrder = [
  "environments",
  "serverGroups",
  "executions",
  "loadBalancers",
  "securityGroups",
  "tasks",
  "config"
];
ApplicationDataSourceRegistry.dataSources = [];
ApplicationDataSourceRegistry.dataSourceOrder = [];

class InferredApplicationWarningService {
  static resetViewedApplications() {
    this.viewedApplications.length = 0;
  }
  static isInferredApplication(app) {
    return !app.attributes || !app.attributes.email;
  }
  static checkIfInferredAndWarn(app) {
    if (this.check(app)) {
      this.warn(app.name);
    }
  }
  static check(app) {
    const { name } = app;
    const hasViewed = this.viewedApplications.includes(name);
    this.viewedApplications.push(name);
    return !hasViewed && this.isInferredApplication(app);
  }
  static warn(appName) {
    NotifierService.publish({
      key: "inferredApplicationWarning",
      action: "create",
      content: /* @__PURE__ */ React__default.createElement("div", null, "The application ", /* @__PURE__ */ React__default.createElement("b", null, appName), " has not been ", /* @__PURE__ */ React__default.createElement("a", {
        href: `#/applications/${appName}/config`
      }, "configured"), ".")
    });
  }
}
InferredApplicationWarningService.viewedApplications = [];

class ApplicationReader {
  static listApplications() {
    return REST("/applications").useCache().get();
  }
  static getApplicationAttributes(name) {
    return REST("/applications").path(name).query({ expand: false }).get().then((fromServer) => {
      this.splitAttributes(fromServer.attributes, ["accounts", "cloudProviders"]);
      return fromServer.attributes;
    });
  }
  static getApplicationPermissions(applicationName) {
    return REST("/applications").path(applicationName).query({
      expand: false
    }).get().then((application) => {
      return application.attributes.permissions;
    });
  }
  static getApplication(name, expand = true) {
    return REST("/applications").path(name).query({ expand }).get().then((fromServer) => {
      const configs = ApplicationDataSourceRegistry.getDataSources();
      const application = new Application(fromServer.name, SchedulerFactory.createScheduler(), configs);
      application.attributes = fromServer.attributes;
      this.splitAttributes(application.attributes, ["accounts", "cloudProviders"]);
      this.setDisabledDataSources(application);
      application.refresh();
      return application;
    });
  }
  static splitAttributes(attributes, fields) {
    fields.forEach((field) => {
      if (attributes[field]) {
        if (!Array.isArray(attributes[field])) {
          attributes[field] = attributes[field].split(",").map((s) => s.trim());
        }
      } else {
        attributes[field] = [];
      }
    });
  }
  static setDisabledDataSources(application) {
    const allDataSources = application.dataSources;
    const appDataSources = application.attributes.dataSources;
    if (!appDataSources) {
      allDataSources.filter((ds) => ds.optIn).forEach((ds) => this.setDataSourceDisabled(ds, application, true));
      if (InferredApplicationWarningService.isInferredApplication(application)) {
        allDataSources.filter((ds) => ds.requireConfiguredApp).forEach((ds) => this.setDataSourceDisabled(ds, application, true));
      }
    } else {
      allDataSources.forEach((ds) => {
        if (ds.optional) {
          if (ds.optIn) {
            this.setDataSourceDisabled(ds, application, !appDataSources.enabled.includes(ds.key));
          } else {
            this.setDataSourceDisabled(ds, application, appDataSources.disabled.includes(ds.key));
          }
        }
      });
    }
    allDataSources.filter((ds) => ds.requiresDataSource).forEach((ds) => {
      const parent = allDataSources.find((p) => p.key === ds.requiresDataSource);
      if (parent) {
        this.setDataSourceDisabled(ds, application, parent.disabled);
      }
    });
  }
  static setDataSourceDisabled(dataSource, application, disabled) {
    dataSource.disabled = disabled;
    if (dataSource.badge) {
      application.dataSources.find((ds) => ds.key === dataSource.badge).disabled = disabled;
    }
  }
}

function ApplicationsPickerInput(props) {
  const getAppNames = () => ApplicationReader.listApplications().then((apps2) => apps2.map((app) => app.name).sort());
  const { result: apps, status } = useData(getAppNames, [], []);
  const options = useMemo$2(() => apps.map((app) => ({ label: app, value: app })), [apps]);
  const validator = useLatestCallback((value) => {
    if (status === "PENDING") {
      return asyncMessage("Loading apps...");
    }
    const selectedApps = !value ? [] : typeof value === "string" ? [value] : value;
    const missing = selectedApps.find((app) => !apps.includes(app));
    return missing ? errorMessage(`Application ${missing} does not exist.`) : void 0;
  });
  useInternalValidator(props.validation, validator, [apps, status]);
  return /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
    ...props,
    mode: "VIRTUALIZED",
    options,
    isLoading: status === "PENDING"
  });
}

class Key {
  static get BACKSPACE() {
    return "Backspace";
  }
  static get DOWN_ARROW() {
    return "ArrowDown";
  }
  static get DELETE() {
    return "Delete";
  }
  static get ENTER() {
    return "Enter";
  }
  static get ESCAPE() {
    return "Escape";
  }
  static get LEFT_ARROW() {
    return "ArrowLeft";
  }
  static get RIGHT_ARROW() {
    return "ArrowRight";
  }
  static get UP_ARROW() {
    return "ArrowUp";
  }
}

class ScopeClusterSelector extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleClusterChange = (event) => {
      this.props.onChange && this.props.onChange({ clusterName: event.currentTarget.value });
    };
    this.toggleFreeFormClusterField = () => this.setState({ freeFormClusterField: !this.state.freeFormClusterField });
    const { clusters, model } = this.props;
    const selectedNotInClusterList = !(Array.isArray(clusters) && clusters.some((cluster) => cluster === model));
    const modelIsSet = model != null || (model || "").trim() !== "";
    this.state = {
      freeFormClusterField: modelIsSet ? selectedNotInClusterList : false
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, !this.state.freeFormClusterField && /* @__PURE__ */ React__default.createElement("select", {
      className: "form-control input-sm",
      onChange: this.handleClusterChange,
      required: this.props.required,
      value: this.props.model || ""
    }, /* @__PURE__ */ React__default.createElement("option", {
      value: ""
    }, "-- select cluster --"), (this.props.clusters || []).map((cluster) => /* @__PURE__ */ React__default.createElement("option", {
      key: cluster,
      value: cluster
    }, cluster))), this.state.freeFormClusterField && /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: "form-control input-sm",
      required: this.props.required,
      value: this.props.model || "",
      onChange: this.handleClusterChange,
      onBlur: this.handleClusterChange
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "pull-right"
    }, !this.state.freeFormClusterField && /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.toggleFreeFormClusterField
    }, "Toggle for text input"), this.state.freeFormClusterField && /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.toggleFreeFormClusterField
    }, "Toggle for list of existing clusters")));
  }
}

class ClusterMatches extends React__default.Component {
  render() {
    const { matches } = this.props;
    if (!matches || !matches.length) {
      return /* @__PURE__ */ React__default.createElement("div", null, "(no matches)");
    }
    return /* @__PURE__ */ React__default.createElement("ul", {
      className: "nostyle"
    }, matches.map((match, index) => /* @__PURE__ */ React__default.createElement("li", {
      key: index
    }, /* @__PURE__ */ React__default.createElement(AccountTag, {
      account: match.account
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "break-word"
    }, match.name), match.regions && match.regions.length && /* @__PURE__ */ React__default.createElement("i", null, " in ", match.regions.join(", ")))));
  }
}

const CLUSTER_MATCHES_COMPONENT = "spinnaker.core.widget.cluster.clusterMatches.component";
module(CLUSTER_MATCHES_COMPONENT, []).component("clusterMatches", react2angular(withErrorBoundary(ClusterMatches, "clusterMatches"), ["matches"]));

class SpelNumberInput extends React__default.Component {
  constructor(props) {
    super(props);
    this.valueChanged = ({ target: { value } }) => {
      const num = parseInt(value, 10);
      this.props.onChange(isNaN(num) ? value : num);
    };
    this.state = {
      expressionActive: isString(props.value),
      glowing: false
    };
  }
  componentWillReceiveProps(nextProps) {
    const expressionActive = isString(nextProps.value);
    if (this.state.expressionActive !== expressionActive) {
      this.setState({ expressionActive });
    }
  }
  setExpressionActive(expressionActive) {
    this.setState({ expressionActive });
  }
  setGlow(glowing) {
    this.setState({ glowing });
  }
  render() {
    const { expressionActive, glowing } = this.state;
    const { value, min, max, required = false, error, disabled } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "navbar-form",
      style: { padding: 0, margin: 0, display: "inline-block" }
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: error,
      placement: "right"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: `button-input${glowing && !error ? " focus" : ""}${error ? " invalid" : ""}`
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "btn-group btn-group-xs",
      role: "group"
    }, /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      disabled,
      className: `btn btn-default ${expressionActive ? "" : "active"}`,
      onClick: () => this.setExpressionActive(false),
      onFocus: () => this.setGlow(true),
      onBlur: () => this.setGlow(false)
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Toggle to enter number"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Num"))), /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      disabled,
      className: `btn btn-default ${expressionActive ? "active" : ""}`,
      onClick: () => this.setExpressionActive(true),
      onFocus: () => this.setGlow(true),
      onBlur: () => this.setGlow(false)
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Toggle to enter expression"
    }, /* @__PURE__ */ React__default.createElement("span", null, "${", "\u2026", "}")))), /* @__PURE__ */ React__default.createElement("input", {
      type: expressionActive ? "text" : "number",
      disabled,
      className: `form-control borderless inline-${expressionActive ? "text" : "number"}`,
      value,
      min,
      max,
      onChange: this.valueChanged,
      onFocus: () => this.setGlow(true),
      onBlur: () => this.setGlow(false),
      required
    }))));
  }
}

var DeleteType;
(function(DeleteType2) {
  DeleteType2[DeleteType2["BACKSPACE"] = 0] = "BACKSPACE";
  DeleteType2[DeleteType2["REMOVE"] = 1] = "REMOVE";
})(DeleteType || (DeleteType = {}));
class Tag extends React__default.Component {
  constructor() {
    super(...arguments);
    this.refCallback = (element) => {
      if (element) {
        this.props.onCreate(element);
      }
    };
    this.handleFocus = () => {
      this.props.onFocus();
    };
    this.handleBlur = () => {
      this.props.onBlur();
    };
    this.handleKeyUp = (event) => {
      switch (event.key) {
        case Key.BACKSPACE:
        case Key.DELETE:
          this.props.onDelete(this.props.tag, 0);
          break;
        case Key.LEFT_ARROW:
        case Key.RIGHT_ARROW:
          this.props.onKeyUp(this.props.tag, event.key);
          break;
      }
    };
    this.handleRemoveClick = () => {
      this.props.onDelete(this.props.tag, 1);
    };
  }
  render() {
    const { key, text } = this.props.tag;
    return /* @__PURE__ */ React__default.createElement("div", {
      ref: this.refCallback,
      className: "tag",
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onKeyUp: this.handleKeyUp,
      tabIndex: -1
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "tag__category"
    }, key.toLocaleUpperCase()), /* @__PURE__ */ React__default.createElement("div", {
      className: "tag__label"
    }, text), /* @__PURE__ */ React__default.createElement("div", {
      className: "tag__remove"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-times-circle",
      onClick: this.handleRemoveClick
    })));
  }
}
Tag.defaultProps = {
  onBlur: () => {
  },
  onCreate: () => {
  },
  onDelete: () => {
  },
  onFocus: () => {
  },
  onKeyUp: () => {
  }
};

var css_248z$1Y = ".tag-list {\n  align-items: center;\n  display: flex;\n}\n.tag-list .tag {\n  align-items: center;\n  cursor: default;\n  display: flex;\n  font-size: 14px;\n  margin-right: 10px;\n}\n.tag-list .tag .tag__category {\n  background-color: var(--color-primary);\n  border-radius: 4px 0 0 4px;\n  color: var(--color-white);\n  padding: 8px;\n}\n.tag-list .tag .tag__label {\n  background-color: var(--color-accent-g2);\n  color: var(--color-primary);\n  flex: 1 0 auto;\n  padding: 8px;\n}\n.tag-list .tag .tag__remove {\n  background-color: var(--color-accent-g2);\n  border-radius: 0 4px 4px 0;\n  color: var(--color-primary);\n  padding: 8px;\n}\n.tag-list .tag .tag__remove .fa.fa-times-circle {\n  cursor: pointer;\n}\n";
styleInject(css_248z$1Y);

class TagList extends React__default.Component {
  constructor() {
    super(...arguments);
    this.tagElements = [];
    this.handleBlur = () => {
      this.props.onBlur();
    };
    this.handleCreate = (element) => {
      this.tagElements.push(element);
      this.props.onUpdate(this.tagElements);
    };
    this.handleDelete = (tag, deleteType) => {
      const index = this.findIndex(tag);
      this.tagElements.splice(index, 1);
      this.props.onUpdate(this.tagElements);
      switch (deleteType) {
        case DeleteType.BACKSPACE:
          if (this.tagElements.length) {
            if (index === 0) {
              this.tagElements[0].focus();
            } else {
              if (index <= this.tagElements.length - 1) {
                this.tagElements[index].focus();
              } else {
                this.tagElements[index - 1].focus();
              }
            }
            this.props.onDelete(tag, false);
          } else {
            this.props.onDelete(tag, true);
          }
          break;
        case DeleteType.REMOVE:
          this.props.onDelete(tag, true);
          break;
      }
      logger.log({ category: "Infrastructure Search Tags", action: "Individual tag removed" });
    };
    this.handleFocus = () => {
      this.props.onFocus();
    };
    this.handleKeyUp = (tag, key) => {
      const index = this.findIndex(tag);
      switch (key) {
        case Key.LEFT_ARROW:
          if (index === 0) {
            this.props.onKeyUp();
          } else {
            this.tagElements[index - 1].focus();
          }
          break;
        case Key.RIGHT_ARROW:
          if (index === this.tagElements.length - 1) {
            this.props.onKeyUp();
          } else {
            this.tagElements[index + 1].focus();
          }
          break;
      }
    };
  }
  findIndex(tag) {
    return this.props.tags.findIndex((t) => {
      return tag === t;
    });
  }
  render() {
    const tags = this.props.tags || [];
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "tag-list"
    }, tags.map((tag) => /* @__PURE__ */ React__default.createElement(Tag, {
      key: [tag.key, tag.text].join("|"),
      tag,
      onBlur: this.handleBlur,
      onCreate: this.handleCreate,
      onDelete: this.handleDelete,
      onFocus: this.handleFocus,
      onKeyUp: this.handleKeyUp
    })));
  }
}
TagList.defaultProps = {
  onBlur: () => {
  },
  onDelete: () => {
  },
  onFocus: () => {
  },
  onKeyUp: () => {
  },
  onUpdate: () => {
  }
};

class SearchTableHeader extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "table-header"
    }, this.props.children);
  }
}
class SearchTableRow extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "table-row small"
    }, this.props.children);
  }
}
class SearchTableBody extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "table-contents flex-fill"
    }, this.props.children);
  }
}
const colClass = (key) => `col-${kebabCase(key)}`;
class HeaderCell extends React__default.Component {
  render() {
    const { col } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: colClass(col.key)
    }, col.label || startCase(col.key));
  }
}
class BasicCell extends React__default.Component {
  render() {
    const { item, col, defaultValue, children } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: colClass(col.key)
    }, children || item[col.key] || defaultValue);
  }
}
class HrefCell extends React__default.Component {
  render() {
    const { item, col } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: colClass(col.key)
    }, /* @__PURE__ */ React__default.createElement("a", {
      href: item.href
    }, item[col.key]));
  }
}
class AccountCell extends React__default.Component {
  render() {
    const { item, col } = this.props;
    const value = item[col.key];
    if (!value) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: colClass(col.key)
      }, "-");
    }
    const accounts = (Array.isArray(value) ? value : value.split(",")).sort();
    return /* @__PURE__ */ React__default.createElement("div", {
      className: colClass(col.key)
    }, accounts.map((account) => /* @__PURE__ */ React__default.createElement(AccountTag, {
      key: account,
      account
    })));
  }
}
class HealthCountsCell extends React__default.Component {
  cellContent(instanceCounts) {
    switch (instanceCounts) {
      case void 0:
        return /* @__PURE__ */ React__default.createElement(Spinner, {
          size: "small"
        });
      case null:
        return /* @__PURE__ */ React__default.createElement("span", null, "?");
      default:
        return /* @__PURE__ */ React__default.createElement(HealthCounts, {
          container: instanceCounts
        });
    }
  }
  render() {
    const { item, col } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: colClass(col.key)
    }, this.cellContent(item[col.key]));
  }
}

class DefaultSearchResultTab extends React__default.Component {
  render() {
    const { isActive, resultSet } = this.props;
    const { type, results, status, error } = resultSet;
    const iconClass = type.iconClass;
    const resultsCount = results.length;
    const countLabel = resultsCount < SearchService.DEFAULT_PAGE_SIZE ? `${resultsCount}` : `${resultsCount}+`;
    const Badge = () => {
      switch (status) {
        case SearchStatus.SEARCHING:
          return /* @__PURE__ */ React__default.createElement(Spinner, {
            size: "small"
          });
        case SearchStatus.ERROR:
          return /* @__PURE__ */ React__default.createElement(Tooltip, {
            value: error && error.toString()
          }, /* @__PURE__ */ React__default.createElement("i", {
            className: "fa fa-exclamation-triangle"
          }));
        default:
          if (results.length) {
            return /* @__PURE__ */ React__default.createElement("div", {
              className: "badge"
            }, countLabel);
          }
          return /* @__PURE__ */ React__default.createElement("div", {
            className: "badge faded"
          }, countLabel);
      }
    };
    const focusOrBlurClass = isActive ? "search-group--focus" : "search-group--blur";
    return /* @__PURE__ */ React__default.createElement("div", {
      className: `flex-container-h baseline search-group ${focusOrBlurClass}`
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: `flex-nogrow search-group-icon ${iconClass}`
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-grow search-group-name"
    }, type.displayName), /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-nogrow"
    }, /* @__PURE__ */ React__default.createElement(Badge, null)));
  }
}

class SearchResultType {
  constructor() {
    this.fieldsRequired = [];
    this.TabComponent = DefaultSearchResultTab;
  }
  search(params, _otherResults) {
    const { cloudProvider, key, ...otherParams } = params;
    const searchParams = { ...otherParams, q: key, cloudProvider, type: this.id };
    if (Object.keys(otherParams).length > 0) {
      searchParams.allowShortQuery = "true";
    }
    return from(SearchService.search(searchParams));
  }
}

const Searching = () => /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-grow vertical center middle"
}, /* @__PURE__ */ React__default.createElement(Spinner, {
  size: "large",
  message: "Fetching search results ..."
}));
const NoResults$1 = ({ resultSet }) => /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-grow vertical center middle"
}, /* @__PURE__ */ React__default.createElement("h3", null, "No ", resultSet.type.displayName, " found for the specified search query"));
const Results = ({ resultSet }) => {
  const { type } = resultSet;
  const { HeaderComponent, DataComponent } = type;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "search-result-grid flex-fill",
    style: { height: "initial" }
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: `table table-search-results table-search-results-${kebabCase(type.id)}`
  }, /* @__PURE__ */ React__default.createElement(HeaderComponent, {
    resultSet
  }), /* @__PURE__ */ React__default.createElement(DataComponent, {
    resultSet
  })));
};
const FetchError = ({ resultSet }) => /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-grow vertical center middle"
}, /* @__PURE__ */ React__default.createElement("h4", {
  className: "error-message"
}, "Could not fetch ", resultSet.type.displayName), /* @__PURE__ */ React__default.createElement("div", {
  className: "error-message"
}, resultSet && resultSet.error && resultSet.error.toString()));
class SearchResultGrid extends React__default.Component {
  render() {
    const resultSet = this.props.resultSet || {};
    const { status, results } = resultSet;
    switch (status) {
      case SearchStatus.INITIAL:
      case void 0:
        return null;
      case SearchStatus.ERROR:
        return /* @__PURE__ */ React__default.createElement(FetchError, {
          resultSet
        });
      case SearchStatus.SEARCHING:
        return /* @__PURE__ */ React__default.createElement(Searching, null);
      case SearchStatus.FINISHED:
        if (!results.length) {
          return /* @__PURE__ */ React__default.createElement(NoResults$1, {
            resultSet
          });
        }
        return /* @__PURE__ */ React__default.createElement(Results, {
          resultSet
        });
      default:
        return null;
    }
  }
}

var __defProp$r = Object.defineProperty;
var __getOwnPropDesc$r = Object.getOwnPropertyDescriptor;
var __decorateClass$r = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$r(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$r(target, key, result);
  return result;
};
let SearchResultTabs = class extends React__default.Component {
  render() {
    const { activeSearchResultType } = this.props;
    const resultSets = this.props.resultSets.slice().sort((a, b) => a.type.order - b.type.order);
    return /* @__PURE__ */ React__default.createElement("ul", {
      className: "search-groups nostyle"
    }, resultSets.map((resultSet) => {
      const { type } = resultSet;
      const { TabComponent } = type;
      const active = type === activeSearchResultType;
      return /* @__PURE__ */ React__default.createElement(UISref, {
        key: type.id,
        to: ".",
        params: { tab: type.id }
      }, /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement(TabComponent, {
        resultSet,
        isActive: active
      })));
    }));
  }
};
SearchResultTabs = __decorateClass$r([
  UIRouterContext
], SearchResultTabs);

var css_248z$1X = ".table-search-results {\n  width: auto;\n  overflow-x: auto;\n  white-space: nowrap;\n  word-break: break-all;\n}\n.table-search-results .table-header {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  font-weight: 600;\n  background-color: var(--color-alabaster);\n  z-index: 2;\n}\n.table-search-results .table-header .fa {\n  padding-left: 2px;\n}\n.table-search-results .table-header .fa.disabled {\n  color: var(--color-alto);\n}\n.table-search-results .table-header .table-header {\n  background-color: var(--color-alabaster);\n}\n.table-search-results .table-header,\n.table-search-results .table-row {\n  display: flex;\n  flex: 1 1 auto;\n}\n.table-search-results .table-header > div,\n.table-search-results .table-row > div {\n  flex: 1 1 auto;\n  padding: 10px;\n  display: inline-block;\n  width: 150px;\n  word-break: break-all;\n  white-space: normal;\n  border-bottom: 1px solid var(--color-alto);\n}\n.table-search-results .table-row > div {\n  background-color: var(--color-alabaster);\n  flex: 1 1 auto;\n}\n.table-search-results .table-row:nth-child(even) > div {\n  background-color: var(--color-white);\n}\n.table-search-results .table-row:hover > div {\n  background-color: var(--color-cirrus);\n}\n.table-search-results .table-row.active > div {\n  background-color: var(--color-accent-g2);\n}\n.search-results {\n  display: flex;\n  margin-top: 10px;\n  height: 100%;\n  overflow: hidden;\n}\n.search-results .faded {\n  opacity: 0.2;\n}\n.search-results .search-groups {\n  background-color: var(--color-alabaster);\n  cursor: default;\n  min-width: 275px;\n  width: 275px;\n}\n.search-results .search-groups .search-group {\n  cursor: pointer;\n  padding: 10px;\n  margin-bottom: 1px;\n}\n.search-results .search-groups .search-group .search-group-icon {\n  background-color: var(--color-primary);\n  border: 2px solid var(--color-white);\n  border-radius: 50%;\n  color: var(--color-white);\n  display: inline-block;\n  height: 32px;\n  line-height: 29px;\n  margin-right: 10px;\n  text-align: center;\n  width: 32px;\n}\n.search-results .search-groups .search-group .search-group-name {\n  color: var(--color-primary);\n  font-size: 110%;\n  font-weight: 600;\n  text-transform: uppercase;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.search-results .search-groups .search-group .badge {\n  background-color: var(--color-primary);\n  border-radius: 3px;\n}\n.search-results .search-groups .search-group.search-group--focus {\n  background-color: var(--color-accent-g2);\n}\n.search-results .search-groups .search-group.search-group--blur {\n  background-color: var(--color-alabaster);\n}\n.search-results .search-groups .search-group:hover {\n  background-color: var(--color-accent-g2);\n  transition: all 0.15s ease-in-out;\n}\n.search-results .search-groups .search-group:hover.faded {\n  background-color: var(--color-alabaster);\n}\n.search-results .search-result-grid {\n  padding-left: 15px;\n}\n.search-results .search-result-grid .small {\n  font-size: 90%;\n}\n.search-results .search-result-grid .table-contents.flex-fill {\n  height: inherit;\n}\n";
styleInject(css_248z$1X);

const NoResults = () => /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-grow vertical center middle"
}, /* @__PURE__ */ React__default.createElement("h3", null, "No results found for the specified search query"));
class SearchResults extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { active: null };
  }
  componentWillReceiveProps(newProps) {
    const { resultSets, selectedTab } = newProps;
    const active = resultSets.map((x) => x.type).find((type) => type.id === selectedTab);
    this.setState({ active });
  }
  render() {
    const { resultSets, isSearching } = this.props;
    const { active } = this.state;
    const activeResultSet = active && resultSets.find((resultSet) => resultSet.type === active);
    const noResults = resultSets.every((r) => r.status === SearchStatus.FINISHED && r.results.length === 0);
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "search-results"
    }, /* @__PURE__ */ React__default.createElement(SearchResultTabs, {
      resultSets,
      activeSearchResultType: active
    }), activeResultSet && /* @__PURE__ */ React__default.createElement(SearchResultGrid, {
      resultSet: activeResultSet
    }), !activeResultSet && isSearching && /* @__PURE__ */ React__default.createElement(Searching, null), noResults && !active && /* @__PURE__ */ React__default.createElement(NoResults, null));
  }
}

class InfrastructureSearcher {
  constructor($q, providerServiceDelegate) {
    this.$q = $q;
    this.providerServiceDelegate = providerServiceDelegate;
    this.querySubject = new Subject();
    this.querySubject.pipe(switchMap((query) => {
      if (!query || query.trim() === "") {
        const fallbackResults = searchResultTypeRegistry.getAll().map((type) => ({ type, results: [], status: SearchStatus.INITIAL }));
        return of(fallbackResults);
      }
      return InfrastructureSearchServiceV2.search({ key: query }).pipe(toArray());
    })).subscribe((result) => {
      this.deferred.resolve(result);
    });
  }
  query(q) {
    this.deferred = this.$q.defer();
    this.querySubject.next(q);
    return this.deferred.promise;
  }
  getCategoryConfig(category) {
    return searchResultTypeRegistry.get(category);
  }
  formatRouteResult(category, entry) {
    return this.formatResult(category, entry, true);
  }
  formatResult(category, entry, fromRoute = false) {
    const type = searchResultTypeRegistry.get(category);
    if (!type) {
      return this.$q.when("");
    }
    let formatter = type.displayFormatter;
    if (this.providerServiceDelegate.hasDelegate(entry.provider, "search.resultFormatter")) {
      const providerFormatter = this.providerServiceDelegate.getDelegate(entry.provider, "search.resultFormatter");
      if (providerFormatter[category]) {
        formatter = providerFormatter[category];
      }
    }
    return this.$q.when(formatter(entry, fromRoute));
  }
}
class InfrastructureSearchService {
  constructor($q, providerServiceDelegate) {
    this.$q = $q;
    this.providerServiceDelegate = providerServiceDelegate;
  }
  getSearcher() {
    return new InfrastructureSearcher(this.$q, this.providerServiceDelegate);
  }
}
InfrastructureSearchService.$inject = ["$q", "providerServiceDelegate"];
const INFRASTRUCTURE_SEARCH_SERVICE = "spinnaker.infrastructure.search.service";
module(INFRASTRUCTURE_SEARCH_SERVICE, [PROVIDER_SERVICE_DELEGATE]).service("infrastructureSearchService", InfrastructureSearchService);

class Filter extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleClick = () => {
      const { filterType, onClick } = this.props;
      const { name, key } = filterType;
      onClick([name, key].join("|"));
    };
    this.handleKeyUp = (event) => {
      this.props.onKeyUp(event);
    };
    this.handleMouseDown = (event) => {
      this.props.onMouseDown(event);
    };
  }
  render() {
    const { isActive } = this.props;
    const className = classNames({
      filter: true,
      "filter--focus": isActive,
      "filter--blur": !isActive
    });
    const { key, name } = this.props.filterType;
    return /* @__PURE__ */ React__default.createElement("div", {
      role: "option",
      className,
      onClick: this.handleClick,
      onKeyUp: this.handleKeyUp,
      onMouseDown: this.handleMouseDown
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "filter__text"
    }, name), /* @__PURE__ */ React__default.createElement("div", {
      className: "filter__modifier"
    }, "[", key.toLocaleUpperCase(), ":]"));
  }
}
Filter.defaultProps = {
  onClick: () => {
  },
  onKeyUp: () => {
  },
  onMouseDown: () => {
  }
};

var css_248z$1W = ".filter-list {\n  background-color: var(--color-white);\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  cursor: default;\n  margin-top: 40px;\n  position: absolute;\n  white-space: pre;\n  width: 200px;\n  z-index: 1000;\n}\n.filter-list.filter-list__open {\n  display: block;\n}\n.filter-list.filter-list__closed {\n  display: none;\n}\n.filter-list .filter-list__header {\n  color: var(--color-concrete);\n  margin-left: 5px;\n  margin-top: 10px;\n  margin-left: 10px;\n}\n.filter-list .filter {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  padding: 5px 5px 5px 10px;\n}\n.filter-list .filter .filter__text {\n  font-size: 14px;\n  color: var(--color-mineshaft);\n}\n.filter-list .filter .filter__modifier {\n  font-size: 14px;\n  color: var(--color-concrete);\n  margin-left: 5px;\n}\n.filter-list .filter.filter--focus {\n  border-color: var(--color-accent-g1);\n  background-color: var(--color-accent-g2);\n}\n.filter-list .filter.filter--blur {\n  background-color: var(--color-white);\n}\n.filter-list .filter:hover {\n  background-color: var(--color-accent-g2);\n  border-color: var(--color-accent-g1);\n}\n";
styleInject(css_248z$1W);

class Filters$1 extends React__default.Component {
  constructor() {
    super(...arguments);
    this.filters = [];
    this.refCallback = (filter) => {
      this.filters.push(filter);
    };
    this.handleClick = (str) => {
      const clickedFilter = this.filters.find((filter) => {
        const { name, key } = filter.props.filterType;
        return str === [name, key].join("|");
      });
      this.props.filterClicked(clickedFilter);
    };
    this.handleKeyUp = (event) => {
      switch (event.key) {
        case Key.UP_ARROW:
        case Key.DOWN_ARROW:
          this.props.onKeyUp(event.key);
          break;
      }
    };
    this.handleMouseDown = () => {
      this.props.onMouseDown();
    };
  }
  generateFilterElement(filterType) {
    const { name, key } = filterType;
    return /* @__PURE__ */ React__default.createElement(Filter, {
      key: [name, key].join("|"),
      ref: this.refCallback,
      filterType,
      isActive: this.props.activeFilter.key === key,
      onClick: this.handleClick,
      onKeyUp: this.handleKeyUp,
      onMouseDown: this.handleMouseDown
    });
  }
  renderFilterLayout(layout) {
    const { header, filterTypes } = layout;
    const types = (filterTypes || []).map((type) => this.generateFilterElement(type));
    return /* @__PURE__ */ React__default.createElement("div", {
      key: [header, filterTypes.length].join("|")
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "filter-list__header"
    }, header), /* @__PURE__ */ React__default.createElement("div", {
      role: "listbox"
    }, types));
  }
  render() {
    const { layouts, isOpen } = this.props;
    const className = classNames({
      "filter-list": true,
      "filter-list__open": isOpen,
      "filter-list__closed": !isOpen
    });
    const menuLayouts = (layouts || []).map((layout) => this.renderFilterLayout(layout));
    return /* @__PURE__ */ React__default.createElement("div", {
      className
    }, menuLayouts);
  }
}
Filters$1.defaultProps = {
  filterClicked: () => {
  },
  onKeyUp: () => {
  },
  onMouseDown: () => {
  }
};

class FilterTypeRegistry {
  constructor() {
    this.KEYWORD_FILTER = Object.freeze({
      key: "key",
      name: "Keyword"
    });
    this.NAME_FILTER = Object.freeze({
      key: "name",
      name: "Name"
    });
    this.registry = new Map();
    this.register(this.KEYWORD_FILTER);
    this.register(this.NAME_FILTER);
  }
  register(filterType) {
    this.registry.set(filterType.key, filterType);
  }
  getFilterType(key) {
    return this.registry.get(key);
  }
  getFilterByModifier(key) {
    return [...this.registry.values()].find((type) => key === type.key);
  }
  getRegisteredFilterKeys() {
    return [...this.registry.keys()];
  }
  getValues() {
    const filterTypes = Array.from(this.registry.values());
    filterTypes.sort((a, b) => a.name.localeCompare(b.name));
    return filterTypes;
  }
}
const SearchFilterTypeRegistry = new FilterTypeRegistry();

var css_248z$1V = ".search {\n  align-items: center;\n  display: flex;\n}\n.search .search__icon {\n  flex: 1 0 auto;\n}\n.search .search__input {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  color: var(--color-mineshaft);\n  background: var(--color-white) none;\n  border: 1px solid;\n  border-radius: 4px;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n.search .search__input .search__input-wrapper {\n  align-items: baseline;\n  display: flex;\n  flex: 1 1;\n  width: 100%;\n}\n.search .search__input .search__input-wrapper .search__input-control {\n  border: none;\n  max-width: 100%;\n  outline: 0;\n  padding-right: 10px;\n  width: 100%;\n}\n.search .search__input .search__input-wrapper .search__input-control::-moz-placeholder {\n  color: var(--color-concrete);\n  opacity: 1;\n}\n.search .search__input .search__input-wrapper .search__input-control:-ms-input-placeholder {\n  color: var(--color-concrete);\n}\n.search .search__input .search__input-wrapper .search__input-control::-webkit-input-placeholder {\n  color: var(--color-concrete);\n}\n.search .search__input .search__input-wrapper .fa.fa-times {\n  cursor: pointer;\n}\n.search .search__input.search__input--focus {\n  border-color: var(--color-accent);\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px -2px var(--color-accent);\n}\n.search .search__input.search__input--blur {\n  border-color: var(--color-alto);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n";
styleInject(css_248z$1V);

class Search extends React__default.Component {
  constructor(props) {
    super(props);
    this.filterTypes = [];
    this.tagElements = [];
    this.mouseDownFired = false;
    this.handleTagListUpdate = (elements) => {
      this.tagElements = elements;
    };
    this.refCallback = (element) => {
      this.inputElement = element;
    };
    this.handleBlur = () => {
      if (!this.mouseDownFired) {
        this.setState({
          isFocused: false,
          isOpen: false
        });
      }
    };
    this.handleChange = () => {
      let newState;
      const value = this.inputElement.value.trim();
      if (this.hasModifier(value)) {
        const key = this.getModifier(value);
        newState = {
          activeFilter: this.filterTypes.find((type) => type.key === key),
          isOpen: true
        };
      } else {
        newState = { isOpen: !!value };
      }
      this.setState(newState);
    };
    this.handleDelete = (tag, focus) => {
      const tags = this.state.tags.filter((t) => tag !== t);
      this.setState({
        isFocused: true,
        tags
      });
      this.props.onChange(tags);
      if (focus) {
        this.inputElement.focus();
      }
    };
    this.handleFocus = () => {
      this.setState({
        isFocused: true
      });
    };
    this.handleKeyUpFromInput = (event) => {
      const length = this.tagElements.length;
      switch (event.key) {
        case Key.LEFT_ARROW:
          if (!this.inputElement.value && length >= 1) {
            this.tagElements[length - 1].focus();
          }
          break;
        case Key.RIGHT_ARROW:
          if (!this.inputElement.value && length !== 0) {
            this.tagElements[0].focus();
          }
          break;
        case Key.UP_ARROW:
          this.navigateUp();
          break;
        case Key.DOWN_ARROW:
          this.navigateDown();
          break;
        case Key.ENTER:
          this.handleFilterSelection();
          break;
        case Key.ESCAPE: {
          const text = this.inputElement.value;
          if (this.hasModifier(text) && !this.getSearchText(text)) {
            this.inputElement.value = "";
          }
          this.setState({
            activeFilter: SearchFilterTypeRegistry.KEYWORD_FILTER,
            isOpen: false
          });
          break;
        }
      }
    };
    this.handleKeyUpFromTag = () => {
      this.inputElement.focus();
    };
    this.filterClicked = (filter) => {
      this.handleFilterSelection(filter.props.filterType);
      this.mouseDownFired = false;
    };
    this.handleKeyUp = (key) => {
      switch (key) {
        case Key.UP_ARROW:
          this.navigateUp();
          break;
        case Key.DOWN_ARROW:
          this.navigateDown();
          break;
      }
    };
    this.handleMouseDown = () => {
      this.mouseDownFired = true;
    };
    this.handleClearClick = () => {
      this.setState({
        isOpen: false,
        tags: []
      });
      this.inputElement.value = "";
      this.inputElement.focus();
      this.props.onChange([]);
    };
    const layouts = [];
    layouts.push({
      header: "SEARCH",
      filterTypes: [SearchFilterTypeRegistry.KEYWORD_FILTER]
    });
    this.filterTypes = this.reorderFilterTypesForSearch(SearchFilterTypeRegistry.getValues());
    layouts.push({
      header: "FILTER ON",
      filterTypes: this.filterTypes.filter((type) => type.key !== SearchFilterTypeRegistry.KEYWORD_FILTER.key)
    });
    this.keys = new Set(SearchFilterTypeRegistry.getValues().map((type) => type.key));
    this.state = {
      activeFilter: SearchFilterTypeRegistry.KEYWORD_FILTER,
      isFocused: true,
      isOpen: false,
      layouts,
      tags: this.buildTagsFromParams(props.params, [])
    };
  }
  componentWillReceiveProps(props) {
    const tags = this.buildTagsFromParams(props.params, this.state.tags);
    this.setState({ tags });
  }
  reorderFilterTypesForSearch(filterTypes) {
    const mods = new Set([
      SearchFilterTypeRegistry.KEYWORD_FILTER.key,
      SearchFilterTypeRegistry.NAME_FILTER.key
    ]);
    const result = filterTypes.filter((type) => !mods.has(type.key));
    result.unshift(SearchFilterTypeRegistry.NAME_FILTER);
    result.unshift(SearchFilterTypeRegistry.KEYWORD_FILTER);
    return result;
  }
  buildTagsFromParams(params, currentTags) {
    const tagsToKeep = currentTags.filter((tag) => params[tag.key]).map((tag) => ({ key: tag.key, text: params[tag.key] }));
    const tagsToAdd = Object.keys(params).filter((key) => !!params[key] && !tagsToKeep.some((tag) => tag.key === key)).map((key) => ({ key, text: params[key] }));
    return tagsToKeep.concat(tagsToAdd);
  }
  isLongEnoughIfKeyword(tag) {
    return tag.key !== SearchFilterTypeRegistry.KEYWORD_FILTER.key || tag.key === SearchFilterTypeRegistry.KEYWORD_FILTER.key && tag.text.length > 2;
  }
  hasModifier(input) {
    const index = input.indexOf(":");
    return this.keys.has(input.substring(0, index).toLocaleLowerCase()) && index !== input.length;
  }
  getModifier(input) {
    return input.substring(0, input.indexOf(":")).toLocaleLowerCase();
  }
  getSearchText(input) {
    const trimmed = input.trim();
    const searchText = trimmed.split(":")[1] || "";
    return this.hasModifier(trimmed) ? searchText.trim() : trimmed;
  }
  buildTagFromInputString(filter = this.state.activeFilter) {
    const value = this.inputElement.value.trim();
    const text = this.getSearchText(value).trim();
    if (!value || !text) {
      return null;
    }
    const key = this.hasModifier(value) ? this.getModifier(value) : filter.key;
    return { key, text };
  }
  getActiveFilterIndex() {
    return this.filterTypes.findIndex((type) => type === this.state.activeFilter);
  }
  getActiveFilterText(filterType) {
    let result;
    const text = this.inputElement.value.trim();
    if (this.hasModifier(text)) {
      const key = this.getModifier(text);
      const regex = new RegExp(key, "i");
      result = `${text.replace(regex, filterType.key)}`;
    } else {
      result = `${filterType.key}:${text}`;
    }
    return result;
  }
  navigateUp() {
    const { filterTypes } = this;
    const activeIndex = this.getActiveFilterIndex();
    const activeFilter = activeIndex === 0 ? filterTypes[filterTypes.length - 1] : filterTypes[activeIndex - 1];
    this.navigate(activeFilter);
  }
  navigateDown() {
    const { filterTypes } = this;
    const activeIndex = this.getActiveFilterIndex();
    const activeFilter = activeIndex === filterTypes.length - 1 ? filterTypes[0] : filterTypes[activeIndex + 1];
    this.navigate(activeFilter);
  }
  navigate(active) {
    const activeFilter = this.state.isOpen ? active : SearchFilterTypeRegistry.KEYWORD_FILTER;
    const newState = { activeFilter };
    this.inputElement.value = this.getActiveFilterText(activeFilter);
    this.setState({ ...newState, isOpen: true });
  }
  handleFilterSelection(filter) {
    const tag = this.buildTagFromInputString(filter);
    if (tag && this.isLongEnoughIfKeyword(tag)) {
      const tags = this.state.tags.filter((x) => x.key !== tag.key).concat(tag);
      this.setState({
        activeFilter: SearchFilterTypeRegistry.KEYWORD_FILTER,
        isOpen: false,
        tags
      });
      this.inputElement.value = "";
      this.props.onChange(tags);
    }
  }
  render() {
    const { activeFilter, isFocused, isOpen, layouts, tags } = this.state;
    const className = classNames({
      "search__input": true,
      "search__input--focus": isFocused,
      "search__input--blur": !isFocused
    });
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "search"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-search search__icon"
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "search-label"
    }, "Search"), /* @__PURE__ */ React__default.createElement("div", {
      className
    }, /* @__PURE__ */ React__default.createElement(TagList, {
      tags,
      onBlur: this.handleBlur,
      onDelete: this.handleDelete,
      onFocus: this.handleFocus,
      onKeyUp: this.handleKeyUpFromTag,
      onUpdate: this.handleTagListUpdate
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "search__input-wrapper"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      ref: this.refCallback,
      autoFocus: true,
      className: "search__input-control",
      placeholder: `projects, applications, clusters, load balancers, server groups, ${FirewallLabels.get("firewalls")}`,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onKeyUp: this.handleKeyUpFromInput
    }), /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-times",
      onClick: this.handleClearClick
    }), /* @__PURE__ */ React__default.createElement(Filters$1, {
      activeFilter,
      isOpen,
      layouts,
      filterClicked: this.filterClicked,
      onKeyUp: this.handleKeyUp,
      onMouseDown: this.handleMouseDown
    }))));
  }
}

class SecurityGroupsSearchResultType extends SearchResultType {
  constructor() {
    super(...arguments);
    this.id = "securityGroups";
    this.order = 6;
    this.displayName = FirewallLabels.get("Firewalls");
    this.iconClass = "fa fa-exchange-alt";
    this.cols = {
      NAME: { key: "name" },
      ACCOUNT: { key: "account" },
      REGION: { key: "region" }
    };
    this.TabComponent = DefaultSearchResultTab;
    this.HeaderComponent = () => /* @__PURE__ */ React__default.createElement(SearchTableHeader, null, /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.NAME
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.ACCOUNT
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.REGION
    }));
    this.DataComponent = ({ resultSet }) => {
      const itemKeyFn = (item) => [item.id, item.name, item.account, item.region].join("|");
      const itemSortFn = (a, b) => {
        const order = a.name.localeCompare(b.name);
        return order !== 0 ? order : a.region.localeCompare(b.region);
      };
      const results = resultSet.results.slice().sort(itemSortFn);
      return /* @__PURE__ */ React__default.createElement(SearchTableBody, null, results.slice().sort(itemSortFn).map((item) => /* @__PURE__ */ React__default.createElement(SearchTableRow, {
        key: itemKeyFn(item)
      }, /* @__PURE__ */ React__default.createElement(HrefCell, {
        item,
        col: this.cols.NAME
      }), /* @__PURE__ */ React__default.createElement(AccountCell, {
        item,
        col: this.cols.ACCOUNT
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.REGION
      }))));
    };
  }
  displayFormatter(searchResult) {
    return `${searchResult.name} (${searchResult.region})`;
  }
}
searchResultTypeRegistry.register(new SecurityGroupsSearchResultType());

class ApplicationDataSource {
  constructor(config, application) {
    this.application = application;
    this.autoActivate = false;
    this.lazy = false;
    this.optIn = false;
    this.optional = false;
    this.primary = false;
    this.requireConfiguredApp = false;
    this.visible = true;
    this.hidden = false;
    this.loaded = false;
    this.loading = false;
    this.disabled = false;
    this.loadFailure = false;
    this.active = false;
    this.debugEnabled = false;
    Object.assign(this, config);
    if (!config.hasOwnProperty("defaultData")) {
      throw new Error("The defaultData field is required when registering a data source.\n\ndefaultData accepts the initial default value that will be used before data has been fetched.\nFor example, if your data source holds an array of objects, you should set defaultData to an empty array.");
    }
    this.data = this.data || this.defaultData;
    this.label = FirewallLabels.get(config.label || robotToHuman(config.key));
    if (!config.activeState && this.sref) {
      this.activeState = "**" + this.sref + ".**";
    }
    if (config.autoActivate) {
      ReactInjector.$uiRouter.transitionService.onSuccess({ entering: this.activeState }, () => this.activate());
      ReactInjector.$uiRouter.transitionService.onSuccess({ exiting: this.activeState }, () => this.deactivate());
    }
    this.destroy$ = new Subject();
    this.fetchRequest$ = new Subject();
    this.status$ = new BehaviorSubject({
      status: "NOT_INITIALIZED",
      loaded: this.loaded,
      lastRefresh: 0,
      error: null,
      data: this.data
    });
    this.data$ = new BehaviorSubject(this.data);
    this.refresh$ = this.data$.pipe(skip(1));
    this.refreshFailure$ = this.status$.pipe(skip(1), filter(({ status }) => status === "ERROR"));
    this.throwFailures$ = this.refreshFailure$.pipe(map(({ error }) => {
      throw error;
    }));
    this.nextRefresh$ = merge$1(this.data$.pipe(skip(1)), this.throwFailures$).pipe(take(1));
    const fetchStream$ = this.fetchRequest$.pipe(tap(() => this.debug("fetch requested...")), switchMap(() => {
      return from(this.loader(this.application)).pipe(mergeMap((data) => this.onLoad(this.application, data)), map((data) => ({ status: "FETCHED", lastRefresh: Date.now(), data })), catchError((error) => of({ status: "ERROR", lastRefresh: this.lastRefresh, data: this.data, error })), startWith({ status: "FETCHING", lastRefresh: this.lastRefresh, data: this.data }));
    }), startWith(this.status$.value), takeUntil(this.destroy$));
    const nextTick$ = from($q.resolve());
    fetchStream$.pipe(withLatestFrom(nextTick$)).subscribe(([fetchStatus, _void]) => {
      this.statusUpdated(fetchStatus);
      fetchStatus.loaded = this.loaded;
      if (fetchStatus.status === "FETCHED") {
        this.updateData(fetchStatus.data);
        this.afterLoad && this.afterLoad(this.application);
        this.addAlerts();
      }
      this.status$.next(fetchStatus);
    });
  }
  dataUpdated(data) {
    if (this.loaded) {
      this.updateData(data !== void 0 ? data : this.data);
      const updatedStatus = { data: this.data, ...this.status$.value };
      this.status$.next(updatedStatus);
    }
  }
  statusUpdated(fetchStatus) {
    const { status } = fetchStatus;
    this.status = fetchStatus;
    this.loaded = status === "FETCHED" || this.loaded;
    this.loading = status === "FETCHING";
    this.loadFailure = status === "ERROR";
    this.lastRefresh = fetchStatus.lastRefresh;
    this.debug(`status: ${fetchStatus.status}`);
  }
  destroy() {
    this.destroy$.next();
  }
  onNextRefresh($scope, callback, onError) {
    const subscription = this.nextRefresh$.subscribe((data) => callback(data), (error) => onError && onError(error));
    $scope && $scope.$on("$destroy", () => subscription.unsubscribe());
    return () => subscription.unsubscribe();
  }
  onRefresh($scope, callback, onError) {
    const failures$ = this.refreshFailure$.pipe(mergeMap(({ error }) => {
      onError && onError(error);
      return empty();
    }));
    const subscription = merge$1(this.data$.pipe(skip(1)), failures$).subscribe((data) => callback(data));
    $scope && $scope.$on("$destroy", () => subscription.unsubscribe());
    return () => subscription.unsubscribe();
  }
  ready() {
    if (this.disabled || this.loaded || this.lazy && !this.active) {
      return $q.resolve(this.data);
    }
    return toIPromise(this.nextRefresh$);
  }
  activate() {
    if (!this.active) {
      this.active = true;
      if (!this.loaded) {
        this.refresh();
      }
    }
  }
  deactivate() {
    this.active = false;
  }
  updateData(data) {
    this.data = data || this.defaultData;
    this.data$.next(this.data);
    this.debug(`this.data:`, this.data);
  }
  refresh(forceRefresh) {
    this.debug(`refresh(${forceRefresh})`);
    if (!this.loader || this.disabled || this.lazy && !this.active) {
      this.loaded = false;
      this.updateData(this.defaultData);
      return $q.resolve(this.data);
    }
    const promise = toIPromise(this.data$.pipe(skip(1), take(1)));
    if (this.loading && !forceRefresh) {
      $log.info(`${this.key} still loading, skipping refresh`);
    } else {
      this.fetchRequest$.next();
    }
    return promise;
  }
  addAlerts() {
    this.alerts = [];
    if (Array.isArray(this.data) && this.data.length) {
      this.alerts = this.data.filter((d) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = d.entityTags) == null ? void 0 : _a.alerts) == null ? void 0 : _b.length) != null ? _c : 0;
      }).map((d) => d["entityTags"]);
    }
  }
  debug(message, object) {
    if (this.debugEnabled) {
      console.log(`DEBUG ${this.application.name}.${this.key}: ${message}`, object);
    }
  }
}

class Application {
  constructor(applicationName, scheduler, dataSourceConfigs) {
    this.applicationName = applicationName;
    this.scheduler = scheduler;
    this.dataSources = [];
    this.accounts = [];
    this.clusters = [];
    this.defaultCredentials = {};
    this.defaultRegions = {};
    this.attributes = {};
    this.notFound = false;
    this.hasError = false;
    this.isStandalone = false;
    this.isManagementPaused = false;
    this.activeState = null;
    this.refreshListeners = [];
    this.activeDataSource$ = new ReplaySubject(1);
    this.activeStateChangeStream = new Subject();
    this.refreshStream = new Subject();
    this.refreshFailureStream = new Subject();
    dataSourceConfigs.forEach((config) => this.addDataSource(config));
    this.status$ = combineLatest(this.dataSources.map((ds) => ds.status$)).pipe(map((statuses) => this.getDerivedApplicationStatus(statuses)));
  }
  get name() {
    return this.applicationName;
  }
  getDerivedApplicationStatus(statuses) {
    const ERROR_STATUS = statuses.some(({ status }) => status === "ERROR") ? "ERROR" : void 0;
    const FETCHING_STATUS = statuses.some(({ status }) => status === "FETCHING") ? "FETCHING" : void 0;
    const FETCHED_STATUS = statuses.some(({ status }) => status === "FETCHED") ? "FETCHED" : void 0;
    const rolledUpStatus = ERROR_STATUS || FETCHING_STATUS || FETCHED_STATUS || "NOT_INITIALIZED";
    const noneLeftToFetch = statuses.every(({ status }) => ["FETCHED", "NOT_INITIALIZED"].includes(status));
    const lastFetch = statuses.reduce((latest, status) => Math.max(latest, status.lastRefresh || 0), 0);
    const allLoaded = statuses.every(({ loaded }) => loaded);
    return {
      status: rolledUpStatus,
      lastRefresh: noneLeftToFetch ? lastFetch : this.lastRefresh,
      loaded: allLoaded,
      data: void 0
    };
  }
  addDataSource(config) {
    const dataSource = new ApplicationDataSource(config, this);
    this.dataSources.push(dataSource);
    this[config.key] = dataSource;
  }
  getDataSource(key) {
    return this.dataSources.find((ds) => ds.key === key);
  }
  refresh(forceRefresh) {
    this.dataSources.filter((ds) => !ds.visible).forEach((ds) => ds.refresh(forceRefresh));
    this.refreshListeners.forEach((cb) => cb());
    return $q.all(this.dataSources.filter((ds) => ds.visible).map((source) => source.refresh(forceRefresh))).then(() => this.applicationLoadSuccess(), (error) => this.applicationLoadError(error));
  }
  ready() {
    return $q.all(this.dataSources.filter((ds) => ds.onLoad !== void 0 && ds.visible).map((dataSource) => dataSource.ready()));
  }
  onRefresh($scope, method, failureMethod) {
    const success = this.refreshStream.subscribe(method);
    let failure = null;
    if (failureMethod) {
      failure = this.refreshFailureStream.subscribe(failureMethod);
    }
    const unsubscribe = () => {
      success.unsubscribe();
      if (failure) {
        failure.unsubscribe();
      }
    };
    if ($scope) {
      $scope.$on("$destroy", () => unsubscribe());
    }
    return unsubscribe;
  }
  enableAutoRefresh() {
    this.dataLoader = this.scheduler.subscribe(() => this.refresh());
  }
  disableAutoRefresh() {
    this.dataLoader && this.dataLoader.unsubscribe();
    this.scheduler.unsubscribe();
  }
  setActiveState(dataSource = null) {
    if (this.activeState !== dataSource) {
      this.activeState = dataSource;
      this.activeDataSource$.next(dataSource);
      this.activeStateChangeStream.next(null);
    }
  }
  applicationLoadError(err) {
    $log.error(err, "Failed to load application, will retry on next scheduler execution.");
    this.refreshFailureStream.next(err);
  }
  applicationLoadSuccess() {
    this.setApplicationAccounts();
    this.setDefaults();
    this.lastRefresh = new Date().getTime();
    this.refreshStream.next(null);
  }
  setApplicationAccounts() {
    let accounts = this.accounts.concat(this.attributes.accounts || []);
    this.dataSources.filter((ds) => Array.isArray(ds.data) && ds.credentialsField !== void 0).forEach((ds) => accounts = accounts.concat(ds.data.map((d) => d[ds.credentialsField])));
    this.accounts = uniq(accounts);
  }
  extractProviderDefault(field) {
    const results = new Map();
    const sources = this.dataSources.filter((ds) => ds[field] !== void 0 && Array.isArray(ds.data) && ds.providerField !== void 0);
    const providers = sources.map((ds) => ds.data.map((d) => d[ds.providerField])).filter((p) => p.length > 0);
    const allProviders = union(...providers);
    allProviders.forEach((provider) => {
      const vals = sources.map((ds) => map$1(ds.data.filter((d) => typeof d === "object" && d[ds.providerField] === provider), ds[field])).filter((v) => v.length > 0);
      const allValues = union(...vals);
      if (allValues.length === 1) {
        results[provider] = allValues[0];
      }
    });
    return results;
  }
  setDefaults() {
    this.defaultCredentials = this.extractProviderDefault("credentialsField");
    this.defaultRegions = this.extractProviderDefault("regionField");
  }
  subscribeToRefresh(onRefreshCb) {
    this.refreshListeners.push(onRefreshCb);
    const unsubscribeCb = () => {
      this.refreshListeners.filter((cb) => cb !== onRefreshCb);
    };
    return unsubscribeCb;
  }
}

const customFetch = (uri, options) => {
  return new Promise((resolve, reject) => {
    REST(uri).post(options == null ? void 0 : options.body).then((res) => {
      const result = {
        ok: true,
        status: 200,
        text: () => new Promise((innerResolve) => {
          innerResolve(JSON.stringify(res));
        })
      };
      resolve(result);
    }).catch((e) => reject(e));
  });
};
const createApolloClient = () => {
  const client = new ApolloClient({
    cache: new InMemoryCache()
  });
  const link = new HttpLink({ uri: "/managed/graphql", fetch: customFetch });
  client.setLink(link);
  const onRefresh = () => client.reFetchObservableQueries();
  return { client, onRefresh };
};

var __defProp$q = Object.defineProperty;
var __getOwnPropDesc$q = Object.getOwnPropertyDescriptor;
var __decorateClass$q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$q(target, key, result);
  return result;
};
let ApplicationFreshIcon = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement(Illustration, {
      className: "app-fresh-icon horizontal middle",
      name: "appSynced"
    });
  }
};
ApplicationFreshIcon = __decorateClass$q([
  Overridable("applicationIcon")
], ApplicationFreshIcon);

const AppRefresherIcon = ({ appName, lastRefresh, refresh, refreshing }) => {
  const activeRefresher = SchedulerFactory.createScheduler(2e3);
  const [timeSinceRefresh, setTimeSinceRefresh] = React__default.useState(relativeTime(lastRefresh));
  const [iconPulsing, setIconPulsing] = React__default.useState(false);
  React__default.useEffect(() => {
    activeRefresher.subscribe(() => {
      setTimeSinceRefresh(relativeTime(lastRefresh));
    });
    return () => activeRefresher.unsubscribe();
  }, [lastRefresh]);
  const oldAge = 2 * 60 * 1e3;
  const age = new Date().getTime() - lastRefresh;
  const isStale = age > oldAge;
  const refreshApp = () => {
    setIconPulsing(true);
    setTimeout(() => {
      setIconPulsing(false);
    }, 3e3);
    refresh();
  };
  const RefresherTooltip = /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, appName)), /* @__PURE__ */ React__default.createElement("p", null, `app data is ${refreshing ? "refreshing" : "up to date (click to refresh)"}`), /* @__PURE__ */ React__default.createElement("p", null, "Last refresh: ", timestamp(lastRefresh), " ", /* @__PURE__ */ React__default.createElement("br", null), " ", timeSinceRefresh), /* @__PURE__ */ React__default.createElement("p", null, "Note: Due to caching, data may be delayed up to 2 minutes"));
  const isRefreshing = iconPulsing || refreshing;
  return /* @__PURE__ */ React__default.createElement(Tooltip, {
    template: RefresherTooltip,
    placement: $window.innerWidth < 1100 ? "bottom" : "right"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: `application-header-icon${isRefreshing ? " header-icon-pulsing" : ""}`,
    onClick: refreshApp
  }, !isStale && !isRefreshing && /* @__PURE__ */ React__default.createElement(ApplicationFreshIcon, null), (isStale || isRefreshing) && /* @__PURE__ */ React__default.createElement(Illustration, {
    className: "app-fresh-icon horizontal middle",
    name: "appUnsynced"
  })));
};

const AppRefresher = ({ app }) => {
  const [isRefreshing, setIsRefreshing] = React__default.useState(false);
  const [lastRefresh, setLastRefresh] = React__default.useState(0);
  const updateStatus = (fetchStatus) => {
    if (fetchStatus.status === "FETCHING") {
      setIsRefreshing(true);
    } else if (fetchStatus.status === "FETCHED") {
      setIsRefreshing(false);
      setLastRefresh(fetchStatus.lastRefresh);
    } else {
      setIsRefreshing(false);
    }
  };
  useObservable(app.status$, updateStatus);
  const handleRefresh = () => {
    app.refresh(true);
  };
  return /* @__PURE__ */ React__default.createElement(AppRefresherIcon, {
    appName: app.name,
    lastRefresh,
    refreshing: isRefreshing,
    refresh: handleRefresh
  });
};

var __defProp$p = Object.defineProperty;
var __getOwnPropDesc$p = Object.getOwnPropertyDescriptor;
var __decorateClass$p = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$p(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$p(target, key, result);
  return result;
};
let BottomSection = class extends React__default.Component {
  render() {
    return null;
  }
};
BottomSection = __decorateClass$p([
  Overridable("core.nav.bottom")
], BottomSection);

class EntityName extends React__default.Component {
  render() {
    const entityRef = this.props.tag.entityRef;
    if (!entityRef.account && !entityRef.region) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "entityname"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "entityref"
    }, /* @__PURE__ */ React__default.createElement("strong", null, entityRef.entityId)), /* @__PURE__ */ React__default.createElement("span", {
      className: "account-region"
    }, " ( ", entityRef.account && /* @__PURE__ */ React__default.createElement(AccountTag, {
      account: entityRef.account
    }), " ", /* @__PURE__ */ React__default.createElement("span", null, entityRef.region), " ) "));
  }
}

class GroupedNotificationList extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      alertsByMessage: this.getAlertsByMessage(props.notifications)
    };
  }
  componentWillReceiveProps(newProps) {
    this.setState({ alertsByMessage: this.getAlertsByMessage(newProps.notifications) });
  }
  getAlertsByMessage(notifications) {
    const grouped = groupBy(notifications, "entityTag.value.message");
    return Object.keys(grouped).map((message) => ({
      message,
      tagline: grouped[message][0].entityTag.value.tagline,
      title: grouped[message][0].entityTag.value.title,
      notifications: grouped[message]
    }));
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "notification-list"
    }, this.state.alertsByMessage.map((alertsForMessage) => /* @__PURE__ */ React__default.createElement(AlertsForMessage, {
      key: alertsForMessage.message,
      alertsForMessage
    })));
  }
}
GroupedNotificationList.defaultProps = {
  notifications: []
};
class AlertsForMessage extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      collapsed: true
    };
    this.toggleCollapsed = () => {
      this.setState({ collapsed: !this.state.collapsed });
    };
    this.renderServerGroupName = (notification) => {
      const { entityTags } = notification;
      const {
        entityRef: { region, entityId }
      } = entityTags;
      const alertKey = `${region}+${entityId}`;
      return /* @__PURE__ */ React__default.createElement(EntityName, {
        key: alertKey,
        tag: entityTags
      });
    };
  }
  renderServerGroupNames(notifications) {
    if (notifications.length === 1) {
      return this.renderServerGroupName(notifications[0]);
    }
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.toggleCollapsed
    }, /* @__PURE__ */ React__default.createElement("strong", null, /* @__PURE__ */ React__default.createElement("span", null, " ", this.state.collapsed ? "Show" : "Hide", " ", notifications.length, " entities"))), /* @__PURE__ */ React__default.createElement("div", {
      className: "server-group-list"
    }, !this.state.collapsed && notifications.map(this.renderServerGroupName)));
  }
  render() {
    const {
      alertsForMessage: { notifications, title, message, tagline }
    } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "notification-message"
    }, title && /* @__PURE__ */ React__default.createElement("div", {
      className: "notification-title"
    }, /* @__PURE__ */ React__default.createElement(Markdown, {
      message: title
    })), this.renderServerGroupNames(notifications), /* @__PURE__ */ React__default.createElement(Markdown, {
      message
    }), /* @__PURE__ */ React__default.createElement(Markdown, {
      className: "small",
      message: tagline
    }));
  }
}

class NotificationCategory extends React__default.Component {
  constructor() {
    super(...arguments);
    this.selectCategory = () => {
      this.props.onCategorySelected(this.props.category);
    };
  }
  render() {
    const { category, notifications } = this.props;
    const categoryClass = `clickable list-group-item flex-container-h baseline alerts-severity-${category.severity} ` + (this.props.isSelected ? "selected " : " ");
    return /* @__PURE__ */ React__default.createElement("li", {
      className: categoryClass,
      onClick: this.selectCategory,
      key: category.id
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: `notification-category-icon fa ${category.icon}`
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "notification-category-label flex-grow"
    }, category.label), /* @__PURE__ */ React__default.createElement("span", {
      className: "badge"
    }, notifications.length));
  }
}

class NotificationList extends React__default.Component {
  render() {
    const { notifications, onEditTag, onDeleteTag } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "notification-list"
    }, notifications.map((notification, idx) => {
      const {
        entityTag: {
          lastModified,
          value: { title, message, tagline }
        }
      } = notification;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "notification-message",
        key: idx
      }, title && /* @__PURE__ */ React__default.createElement("div", {
        className: "notification-title"
      }, /* @__PURE__ */ React__default.createElement(Markdown, {
        message: title
      })), /* @__PURE__ */ React__default.createElement(Markdown, {
        message
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: "notification-tagline flex-container-h baseline"
      }, /* @__PURE__ */ React__default.createElement(Markdown, {
        className: "small",
        message: tagline
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: "small flex-grow",
        title: timestamp(lastModified)
      }, relativeTime(lastModified)), /* @__PURE__ */ React__default.createElement(NotificationActions, {
        notification,
        onEditTag,
        onDeleteTag
      })));
    }));
  }
}
class NotificationActions extends React__default.Component {
  constructor() {
    super(...arguments);
    this.editTag = () => {
      this.props.onEditTag(this.props.notification);
    };
    this.deleteTag = () => {
      this.props.onDeleteTag(this.props.notification);
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-nogrow actions actions-popover",
      style: { position: "relative" }
    }, /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.editTag
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-cog clickable"
    })), /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.deleteTag
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash clickable"
    })));
  }
}

const NOTIFICATION_CATEGORIES = [
  {
    id: "urgentissues",
    label: "Urgent Issues",
    icon: "fa-exclamation",
    severity: 2
  },
  {
    id: "deprecation",
    label: "Deprecations",
    icon: "fa-wrench",
    severity: 1
  },
  {
    id: "default",
    label: "Uncategorized",
    icon: "fa-exclamation-circle",
    severity: 0
  }
];
const BY_NAME = keyBy(NOTIFICATION_CATEGORIES, "id");
class NotificationCategories {
  static defineCategory(id, label = id, severity = 0, icon = "fa-exclamation-circle") {
    return BY_NAME[id] = { id, label, severity, icon };
  }
  static getCategory(categoryName) {
    if (!categoryName) {
      return BY_NAME["default"];
    }
    categoryName = categoryName === "blacklist" ? "urgentissues" : categoryName;
    return BY_NAME[categoryName] || NotificationCategories.defineCategory(categoryName);
  }
}

class CategorizedNotifications extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleCategorySelected = (selectedCategory) => {
      this.setState({ selectedCategory });
    };
    const categorizedAlerts = this.categorizeNotifications(props.notifications);
    this.state = {
      categorizedAlerts,
      selectedCategory: categorizedAlerts[0].category
    };
  }
  componentWillReceiveProps(props) {
    const categorizedAlerts = this.categorizeNotifications(props.notifications);
    this.setState({ categorizedAlerts });
  }
  categorizeNotifications(allNotifications) {
    const getCategory = (notification) => NotificationCategories.getCategory(notification.entityTag.category).id;
    const makeAlertCategory = (name) => {
      const category = NotificationCategories.getCategory(name);
      return {
        category,
        notifications: allNotifications.filter((n) => getCategory(n) === name)
      };
    };
    const categories = uniq(allNotifications.map(getCategory));
    return categories.map(makeAlertCategory).sort((a, b) => b.category.severity - a.category.severity);
  }
  render() {
    const { categorizedAlerts, selectedCategory } = this.state;
    const { onEditTag, onDeleteTag } = this.props;
    if (!categorizedAlerts || !selectedCategory) {
      return null;
    }
    const selectedNotifications = categorizedAlerts.find((tuple) => tuple.category === selectedCategory).notifications;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-h"
    }, /* @__PURE__ */ React__default.createElement("ul", {
      className: "list-group notification-categories"
    }, categorizedAlerts.map(({ category, notifications }) => /* @__PURE__ */ React__default.createElement(NotificationCategory, {
      isSelected: category === selectedCategory,
      key: category.id,
      category,
      notifications,
      onCategorySelected: this.handleCategorySelected
    }))), this.props.grouped ? /* @__PURE__ */ React__default.createElement(GroupedNotificationList, {
      notifications: selectedNotifications
    }) : /* @__PURE__ */ React__default.createElement(NotificationList, {
      notifications: selectedNotifications,
      onEditTag,
      onDeleteTag
    }));
  }
}

class EntityRefBuilder {
  static buildServerGroupRef(serverGroup) {
    return {
      cloudProvider: serverGroup.cloudProvider,
      entityType: "servergroup",
      entityId: serverGroup.name,
      account: serverGroup.account,
      region: serverGroup.region
    };
  }
  static buildServerGroupManagerRef(serverGroupManager) {
    return {
      cloudProvider: serverGroupManager.cloudProvider,
      entityType: "servergroupmanager",
      entityId: serverGroupManager.name,
      account: serverGroupManager.account,
      region: serverGroupManager.region
    };
  }
  static buildLoadBalancerRef(loadBalancer) {
    return {
      cloudProvider: loadBalancer.cloudProvider,
      entityType: "loadbalancer",
      entityId: loadBalancer.name,
      account: loadBalancer.account,
      region: loadBalancer.region
    };
  }
  static buildApplicationRef(application) {
    return {
      cloudProvider: "*",
      entityType: "application",
      entityId: application.name
    };
  }
  static buildRegionalClusterRef(cluster) {
    return {
      cloudProvider: cluster.cloudProvider,
      entityType: "cluster",
      entityId: cluster.name,
      account: cluster.account,
      region: cluster.region
    };
  }
  static buildSecurityGroupRef(securityGroup) {
    return {
      cloudProvider: securityGroup.cloudProvider,
      entityType: "securitygroup",
      entityId: securityGroup.name,
      account: securityGroup.accountName,
      region: securityGroup.region,
      vpcId: securityGroup.vpcId
    };
  }
  static getBuilder(type) {
    switch (type) {
      case "application":
        return this.buildApplicationRef;
      case "serverGroup":
        return this.buildServerGroupRef;
      case "serverGroupManager":
        return this.buildServerGroupManagerRef;
      case "loadBalancer":
        return this.buildLoadBalancerRef;
      case "cluster":
        return this.buildRegionalClusterRef;
      case "securityGroup":
        return this.buildSecurityGroupRef;
      default:
        return null;
    }
  }
}

class EntityTagWriter {
  static upsertEntityTag(application, tag, entityRef, isNew) {
    return TaskExecutor.executeTask({
      application,
      description: `${isNew ? "Create" : "Update"} entity tag on ${entityRef.entityId}`,
      job: [
        {
          type: "upsertEntityTags",
          application: application.name,
          entityId: entityRef.entityId,
          entityRef,
          tags: [tag],
          isPartial: true
        }
      ]
    });
  }
  static deleteEntityTag(application, owner, entityTag, tag) {
    return TaskExecutor.executeTask({
      application,
      description: `Delete entity tag on ${owner.name}`,
      job: [
        {
          type: "deleteEntityTags",
          application: application.name,
          id: entityTag.id,
          tags: [tag]
        }
      ]
    });
  }
}

var css_248z$1U = ".entity-tag-editor-modal .preview {\n  background-color: var(--color-accent-g2);\n}\n.entity-tag-editor-modal .preview .marked,\n.entity-tag-editor-modal .preview [marked] {\n  padding-top: 5px;\n}\n.entity-tag-editor-modal label .marked p,\n.entity-tag-editor-modal label [marked] p {\n  margin-bottom: 0;\n}\n";
styleInject(css_248z$1U);

const _EntityTagEditor = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.close = (args) => {
      this.props.dismissModal.apply(null, args);
    };
    this.upsertTag = (values) => {
      const { application, isNew, tag, onUpdate } = this.props;
      const owner = values.ownerOption ? values.ownerOption.owner : this.props.owner;
      const entityType = values.ownerOption ? values.ownerOption.type : this.props.entityType;
      const entityRef = this.props.entityRef || EntityRefBuilder.getBuilder(entityType)(owner);
      if (!entityRef.application) {
        entityRef.application = application.name;
      }
      tag.value.message = values.message;
      const onClose = (result) => this.props.closeModal(result);
      const onDismiss = (result) => this.props.dismissModal(result);
      const modalInstance = TaskMonitor.modalInstanceEmulation(onClose, onDismiss);
      const taskMonitor = new TaskMonitor({
        application,
        modalInstance,
        title: `${isNew ? "Create" : "Update"} ${this.props.tag.value.type} for ${entityRef.entityId}`,
        onTaskComplete: () => application.entityTags.refresh().then(() => onUpdate())
      });
      const submitMethod = () => {
        const promise = EntityTagWriter.upsertEntityTag(application, tag, entityRef, isNew);
        const done = () => this.setState({ isSubmitting: false });
        promise.then(done, done);
        return promise;
      };
      taskMonitor.submit(submitMethod);
      this.setState({ taskMonitor, isSubmitting: true });
    };
    const { tag } = this.props;
    const ownerOptions = this.props.ownerOptions || [];
    const defaultOwnerOption = ownerOptions.find((opt) => opt.isDefault) || ownerOptions[0];
    tag.name = tag.name || `spinnaker_ui_${tag.value.type}:${UUIDGenerator.generateUuid()}`;
    this.state = {
      taskMonitor: null,
      initialValues: {
        message: tag.value && tag.value.message || "",
        ownerOption: defaultOwnerOption
      },
      isSubmitting: false
    };
  }
  static show(props) {
    return ReactModal.show(_EntityTagEditor, props);
  }
  render() {
    const { isNew, tag, ownerOptions: opts } = this.props;
    const { initialValues, isSubmitting } = this.state;
    const ownerOptions = opts || [];
    const submitLabel = `${isNew ? " Create" : " Update"} ${tag.value.type}`;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(TaskMonitorWrapper, {
      monitor: this.state.taskMonitor
    }), /* @__PURE__ */ React__default.createElement(SpinFormik, {
      initialValues,
      onSubmit: this.upsertTag,
      render: ({ isValid, values, setFieldValue }) => /* @__PURE__ */ React__default.createElement(Form, {
        className: "form-horizontal"
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: this.close
      }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, isNew ? "Create" : "Update", " ", tag.value.type)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
        className: "entity-tag-editor-modal"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: ""
      }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
        label: "Message",
        name: "message",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextAreaInput, {
          ...props,
          rows: 5,
          required: true
        })
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: "small text-right"
      }, "Markdown is okay ", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "markdown.examples"
      })), values.message && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group preview"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-3 sm-label-right"
      }, /* @__PURE__ */ React__default.createElement("strong", null, "Preview")), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9"
      }, /* @__PURE__ */ React__default.createElement(Markdown, {
        message: values.message
      })))), !!ownerOptions.length && /* @__PURE__ */ React__default.createElement(FormField, {
        name: "ownerOption",
        label: "Applies To",
        required: true,
        value: values.ownerOption.label,
        onChange: (evt) => {
          const option = ownerOptions.find((opt) => opt.label === evt.target.value);
          setFieldValue("ownerOption", option);
        },
        input: (props) => /* @__PURE__ */ React__default.createElement(RadioButtonInput, {
          ...props,
          stringOptions: ownerOptions.map((opt) => opt.label)
        })
      })), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        disabled: isSubmitting,
        onClick: this.close,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !isValid || isSubmitting,
        submitting: isSubmitting,
        isFormSubmit: true,
        label: submitLabel
      })))
    }));
  }
};
let EntityTagEditor = _EntityTagEditor;
EntityTagEditor.defaultProps = {
  onUpdate: noop,
  ownerOptions: []
};

var css_248z$1T = ".notices-severity-0,\n.notices-severity-1,\n.notices-severity-2 {\n  --color-notice: var(--color-accent);\n  --color-notice-light: var(--color-accent-g2);\n}\n.alerts-severity-0 {\n  --color-notice: var(--color-warning);\n  --color-notice-light: var(--color-warning-light);\n}\n.alerts-severity-1 {\n  --color-notice: var(--color-alert);\n  --color-notice-light: var(--color-alert-light);\n}\n.alerts-severity-2 {\n  --color-notice: var(--color-danger);\n  --color-notice-light: var(--color-danger-light);\n}\n.notification.fa,\n.notifications-popover.fa {\n  color: var(--color-notice);\n}\n.notification .popover-title,\n.notifications-popover .popover-title,\n.notification.inverse .notification.fa,\n.notifications-popover.inverse .notification.fa {\n  background-color: var(--color-notice);\n  color: var(--color-white);\n}\n.notification.bottom > div.arrow:after,\n.notifications-popover.bottom > div.arrow:after {\n  border-bottom-color: var(--color-notice);\n}\n.notifications-popover .notification-categories li {\n  color: var(--color-notice);\n}\n.notifications-popover .notification-categories li .notification-category-label {\n  color: var(--color-black);\n}\n.notifications-popover .notification-categories li .badge {\n  background-color: var(--color-notice);\n}\n.notifications-popover .notification-categories li.selected {\n  background-color: var(--color-notice-light);\n}\n.notifications-popover .notification-categories li:hover {\n  background-color: var(--color-notice-light);\n}\n.alert-severity-2 .notification-category-label {\n  color: var(--color-danger);\n}\n.notification-category-icon {\n  flex: 0 0 1em;\n  text-align: center;\n}\n.entity-notifications {\n  display: flex;\n}\n.entity-notifications .tag-marker {\n  display: inline-block;\n  margin-left: 5px;\n  font-size: 15px;\n}\n.entity-notifications .tag-marker.inverse .fa {\n  border-radius: 3px;\n  padding: 2px;\n  font-size: 90%;\n}\n.ephemeral.fa,\n.ephemeral-popover.fa {\n  color: var(--color-mineshaft);\n}\n.ephemeral .popover-title,\n.ephemeral-popover .popover-title {\n  background-color: var(--color-mineshaft);\n  color: var(--color-white);\n}\n";
styleInject(css_248z$1T);

var css_248z$1S = "@-webkit-keyframes animate-glow {\n  0% {\n    opacity: 0.9;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 0.9;\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.25;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.25;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* Common mixins extracted from Bootstrap */\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes slideDown {\n  0% {\n    height: 0;\n    opacity: 0;\n  }\n  100% {\n    height: 100%;\n    opacity: 1;\n  }\n}\n@keyframes slideDown {\n  0% {\n    height: 0;\n    opacity: 0;\n  }\n  100% {\n    height: 100%;\n    opacity: 1;\n  }\n}\n.popover.notifications-popover {\n  padding: 0;\n  min-width: 200px;\n  max-width: 500px;\n  text-align: left;\n}\n.popover.notifications-popover .popover-title {\n  padding: 0.6em 0.8em;\n  margin: 0;\n  border-bottom: none;\n}\n.popover.notifications-popover .list-group-item {\n  padding: 0.333em 1em;\n  border-radius: 0;\n  background-color: var(--color-alabaster);\n  border-left: none;\n  border-right: none;\n}\n.popover.notifications-popover .notification-categories {\n  margin: 0;\n  background-color: var(--color-alabaster);\n  border-right: 1px solid var(--color-alto);\n}\n.popover.notifications-popover .notification-categories .notification-category-label {\n  padding: 0 1em;\n}\n.popover.notifications-popover .notification-categories .badge {\n  border-radius: 3px;\n  padding: 3px 6px;\n}\n.popover.notifications-popover .notification-list {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  max-height: 15em;\n  padding: 1em;\n}\n.popover.notifications-popover .server-group-list {\n  margin: 0.75em 0;\n}\n.popover.notifications-popover .entityname {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n.popover.notifications-popover .entityname .account-region {\n  flex: 1 1 auto;\n  text-align: end;\n}\n.popover.notifications-popover .entityname span {\n  white-space: nowrap;\n}\n.popover.notifications-popover .notification-message {\n  min-width: 150px;\n}\n.popover.notifications-popover .notification-message .notification-title {\n  font-weight: bold;\n  margin-bottom: 0.25em;\n}\n.popover.notifications-popover .notification-message:not(:first-child) {\n  padding-top: 10px;\n  margin-top: 5px;\n  border-top: 1px solid var(--color-alto);\n}\n.popover.notifications-popover .notification-message .notification-tagline > *:not(:first-child) {\n  margin-left: 0.5em;\n}\n";
styleInject(css_248z$1S);

const types = {
  alerts: { title: "Alerts", icon: "fa-exclamation-triangle" },
  notices: { title: "Notices", icon: "fa-flag" }
};
class NotificationsPopover extends React__default.Component {
  constructor(props) {
    super(props);
    this.fireGAEvent = () => {
      const analyticsLabel = this.props.gaLabelFn(this.props);
      logger.log({ action: "SPAN", category: "Alerts hovered", data: { label: analyticsLabel } });
    };
    this.PopoverContent = ({ hidePopover }) => {
      const { type, categorized, grouped } = this.props;
      const { notifications } = this.state;
      const handleEditNotification = (notification) => {
        hidePopover();
        this.handleEditNotification(notification);
      };
      const handleDeleteNotification = (notification) => {
        hidePopover();
        this.handleDeleteNotification(notification);
      };
      return /* @__PURE__ */ React__default.createElement(NotificationsPopoverContents, {
        type,
        categorized,
        grouped,
        notifications,
        hidePopover,
        handleEditNotification,
        handleDeleteNotification
      });
    };
    this.state = this.getState(props);
  }
  getState(newProps) {
    const { tags, type } = newProps;
    const buildNotifications = (list, entityTags) => list.concat(entityTags[type].map((entityTag) => ({ entityTags, entityTag })));
    const notifications = tags.filter((x) => !!x).reduce(buildNotifications, []);
    const count = notifications.length;
    const severity = uniq(notifications.map((notification) => notification.entityTag.category)).map((category) => NotificationCategories.getCategory(category)).reduce((max, category) => Math.max(max, category.severity), 0);
    return { notifications, count, severity };
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  handleEditNotification(notification) {
    const { entity, application, onUpdate } = this.props;
    const { entityTags, entityTag } = notification;
    const tag = pick(entityTag, "name", "namespace", "category");
    tag.value = { ...entityTag.value };
    const props = {
      tag,
      isNew: false,
      owner: entity,
      entityType: entityTags.entityRef.entityType,
      application,
      onUpdate,
      ownerOptions: null,
      entityRef: entityTags.entityRef
    };
    EntityTagEditor.show(props);
  }
  handleDeleteNotification(notification) {
    const { application, entity, onUpdate } = this.props;
    const { entityTags, entityTag } = notification;
    const type = entityTag.value["type"];
    const taskMonitorConfig = {
      application,
      title: `Deleting ${type} on ${entity.name}`,
      onTaskComplete: () => application.entityTags.refresh().then(() => onUpdate())
    };
    ConfirmationModalService.confirm({
      header: `Really delete ${type}?`,
      buttonText: `Delete ${type}`,
      account: entity.account,
      taskMonitorConfig,
      submitMethod: () => EntityTagWriter.deleteEntityTag(application, entity, entityTags, entityTag.name)
    });
  }
  render() {
    const { type, className, placement, hOffsetPercent } = this.props;
    const { count, severity } = this.state;
    const { title, icon } = types[type];
    if (count < 1) {
      return null;
    }
    const severityClass = `${type}-severity-${Math.min(Math.max(severity, 0), 2)}`;
    return /* @__PURE__ */ React__default.createElement("span", {
      className: `tag-marker small ${className || ""}`,
      onMouseEnter: this.fireGAEvent
    }, /* @__PURE__ */ React__default.createElement(HoverablePopover, {
      delayShow: 100,
      placement,
      hOffsetPercent,
      Component: this.PopoverContent,
      title,
      className: `no-padding notifications-popover ${severityClass}`
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: `notification fa ${icon} ${severityClass}`
    })));
  }
}
NotificationsPopover.defaultProps = {
  tags: [],
  categorized: true,
  className: "",
  entity: null,
  grouped: false,
  onUpdate: noop,
  placement: "bottom",
  type: "alerts"
};
const NotificationsPopoverContents = (props) => {
  const { type, grouped, categorized, notifications, handleEditNotification, handleDeleteNotification } = props;
  const { title } = types[type];
  if (categorized) {
    return /* @__PURE__ */ React__default.createElement(CategorizedNotifications, {
      notifications,
      onEditTag: handleEditNotification,
      onDeleteTag: handleDeleteNotification,
      grouped,
      title
    });
  } else if (grouped) {
    return /* @__PURE__ */ React__default.createElement(GroupedNotificationList, {
      notifications
    });
  } else {
    return /* @__PURE__ */ React__default.createElement(NotificationList, {
      notifications,
      onEditTag: handleEditNotification,
      onDeleteTag: handleDeleteNotification
    });
  }
};

class DataSourceNotifications extends React__default.Component {
  constructor() {
    super(...arguments);
    this.getDataSourceAnalyticsLabel = () => {
      const { tabName, application, tags } = this.props;
      const alertsStr = tags.map((tag) => tag.alerts.map((alert) => alert.name).join(","));
      return [tabName, application.name, alertsStr].join(":");
    };
  }
  render() {
    const { application, tags } = this.props;
    return /* @__PURE__ */ React__default.createElement(NotificationsPopover, {
      tags,
      application,
      type: "alerts",
      gaLabelFn: this.getDataSourceAnalyticsLabel,
      grouped: true,
      categorized: true,
      placement: "right"
    });
  }
}
const DATA_SOURCE_NOTIFICATIONS = "spinnaker.core.entityTag.alerts.datasourcenotifications";
const ngmodule$4 = module(DATA_SOURCE_NOTIFICATIONS, []);
ngmodule$4.component("dataSourceNotifications", react2angular(withErrorBoundary(DataSourceNotifications, "dataSourceNotifications"), [
  "tags",
  "application",
  "tabName"
]));

const verticalNavExpandedAtom = atom({
  key: "verticalNavExpanded",
  default: !CollapsibleSectionStateCache.isSet("verticalNav") || CollapsibleSectionStateCache.isExpanded("verticalNav"),
  effects: [
    ({ setSelf, trigger }) => {
      if (trigger === "get") {
        setSelf(!CollapsibleSectionStateCache.isSet("verticalNav") || CollapsibleSectionStateCache.isExpanded("verticalNav"));
      }
      CollapsibleSectionStateCache.onChange("verticalNav", (expanded) => {
        setSelf(expanded);
      });
      return () => {
        CollapsibleSectionStateCache.onChange("verticalNav", null);
      };
    }
  ]
});

const NavItem = ({ app, dataSource, isActive }) => {
  const isExpanded = useRecoilValue(verticalNavExpandedAtom);
  const { alerts, badge, iconName, key, label } = dataSource;
  const { data: badgeData } = useDataSource(app.getDataSource(badge || key));
  const runningCount = badge ? badgeData.length : 0;
  useDataSource(dataSource);
  const tags = alerts || [];
  const badgeClassNames = runningCount ? "badge-running-count" : "badge-none";
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", {
    className: badgeClassNames
  }, runningCount > 0 ? runningCount : ""), /* @__PURE__ */ React__default.createElement("span", {
    className: "nav-row-item"
  }, iconName && (!isExpanded ? /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: dataSource.label,
    placement: "right"
  }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Icon, {
    className: "nav-icon",
    name: iconName,
    size: "medium",
    color: isActive ? "primary" : "accent"
  }))) : /* @__PURE__ */ React__default.createElement(Icon, {
    className: "nav-icon",
    name: iconName || "config",
    size: "medium",
    color: isActive ? "primary" : "accent"
  }))), /* @__PURE__ */ React__default.createElement("span", {
    className: "nav-row-item nav-name"
  }, " " + dataSource.label), /* @__PURE__ */ React__default.createElement(DataSourceNotifications, {
    tags,
    application: app,
    tabName: label
  }));
};

const NavRoute = ({ app, dataSource }) => {
  const sref = useSref(dataSource.sref);
  const isActive = useIsActive(dataSource.activeState);
  return /* @__PURE__ */ React__default.createElement("a", {
    ...sref,
    className: `nav-category flex-container-h middle sp-padding-s-yaxis${isActive ? " active" : ""}`
  }, /* @__PURE__ */ React__default.createElement(NavItem, {
    app,
    dataSource,
    isActive
  }));
};

const NavSection = ({ app, dataSources }) => /* @__PURE__ */ React__default.createElement("div", {
  className: "nav-section sp-padding-s-yaxis text-semibold"
}, dataSources.map((dataSource) => /* @__PURE__ */ React__default.createElement(NavRoute, {
  key: dataSource.label,
  dataSource,
  app
})));

class NavigationCategoryRegistry {
  constructor() {
    this.categories = [];
    this.orderOverrides = new Map();
  }
  register(category) {
    this.categories.push(category);
  }
  get(key) {
    return cloneDeep(this.categories.find((c) => c.key === key));
  }
  has(key) {
    return this.categories.some((c) => c.key === key);
  }
  getAll() {
    return this.categories.slice().sort((a, b) => this.getOrder(a) - this.getOrder(b));
  }
  overrideCategoryOrder(key, order) {
    this.orderOverrides.set(key, order);
  }
  getHighestOrder() {
    return Math.max(...this.categories.map((c) => c.order).concat(Array.from(this.orderOverrides.values())));
  }
  getOrder(category) {
    const { key, order } = category;
    return this.orderOverrides.has(key) ? this.orderOverrides.get(key) : order;
  }
}
const navigationCategoryRegistry = new NavigationCategoryRegistry();

class PagerDutyReader {
  static listServices() {
    return from(REST("/pagerDuty/services").get());
  }
  static listOnCalls() {
    return from(REST("/pagerDuty/oncalls").get());
  }
}

class PagerDutyWriter {
  static pageApplicationOwnerModal(app) {
    ModalInjector.modalService.open({
      templateUrl: "core/src/pagerDuty/pageApplicationOwner.html",
      controller: "PageModalCtrl as ctrl",
      resolve: {
        application: () => app
      }
    }).result.catch(() => {
    });
  }
  static sendPage(applications, keys, reason, ownerApp, details) {
    const job = {
      type: "pageApplicationOwner",
      message: reason,
      details
    };
    if (applications && applications.length > 0) {
      job.applications = applications.map((app) => app.name);
    }
    if (keys && keys.length > 0) {
      job.keys = keys;
    }
    const task = {
      application: ownerApp,
      job: [job],
      description: "Send Page"
    };
    return TaskExecutor.executeTask(task);
  }
  static pageApplicationOwner(application, reason, details) {
    return this.sendPage([application], void 0, reason, application, { details });
  }
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pagerDuty/pageApplicationOwner.html", `<div modal-page>
  <task-monitor monitor="ctrl.taskMonitor"></task-monitor>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Page {{ctrl.application.name}} Owner</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="pageApplicationOwnerForm">
    <div class="modal-body">
      <div class="row" style="margin-top: 10px; margin-bottom: 10px">
        <div class="col-md-3 sm-label-right">Reason</div>
        <div class="col-md-7">
          <textarea
            class="form-control required"
            ng-model="ctrl.reason"
            rows="3"
            placeholder="Brief description of incident, severity and expected action."
          ></textarea>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <button type="submit" class="btn btn-primary" ng-click="ctrl.submit()" ng-disabled="!ctrl.reason">
        Page Now
      </button>
    </div>
  </form>
</div>
`);
}]);

class PagerDutyTagComponentController {
  constructor() {
    this.servicesLoaded = false;
  }
  setCurrentService() {
    this.servicesLoaded = false;
    PagerDutyReader.listServices().subscribe((pagerDutyServices) => {
      this.currentService = pagerDutyServices.find((service) => {
        return service.integration_key === this.apiKey;
      });
      this.servicesLoaded = true;
    });
  }
  $onInit() {
    this.setCurrentService();
  }
  $onChanges() {
    this.setCurrentService();
  }
}
const pagerDutyTagComponent = {
  bindings: {
    apiKey: "<"
  },
  controller: PagerDutyTagComponentController,
  template: `
    <span>
      <span ng-if="!$ctrl.servicesLoaded">
        <i class="fa fa-asterisk fa-spin fa-fw"></i> Loading...
      </span>
      <span ng-if="$ctrl.servicesLoaded && $ctrl.currentService">
        {{ $ctrl.currentService.name }} ({{ $ctrl.currentService.integration_key }})
      </span>
      <span ng-if="$ctrl.servicesLoaded && !$ctrl.currentService">
        Unable to locate PagerDuty key ({{ $ctrl.apiKey }})
      </span>
    </span>
  `
};
const PAGER_DUTY_TAG_COMPONENT = "spinnaker.core.pagerDuty.pagerDutyTag.component";
module(PAGER_DUTY_TAG_COMPONENT, []).component("pagerDutyTag", pagerDutyTagComponent);

class PagerDutySelectFieldController {
  constructor() {
    this.helpContents = `<p>Make sure your service exists in Pager Duty and includes the "Generic API"
      integration.</p>
      <h5><b>Setting up a new integration</b></h5>
      <ol>
        <li>Find your service in Pager Duty</li>
        <li>Click "New Integration"</li>
        <li>Select "Use our API directly"</li>
        <li>Make sure to select "Events API v1" (Spinnaker is not compatible with v2)</li>
      </ol>
      <p><b>Note:</b> it can take up to five minutes for the service to appear in Spinnaker</p>`;
    this.required = SETTINGS.pagerDuty && SETTINGS.pagerDuty.required || false;
    this.label = `PagerDuty${this.required ? " *" : ""}`;
  }
  $onInit() {
    this.scheduler = SchedulerFactory.createScheduler(1e4);
    this.scheduler.subscribe(() => this.loadPagerDutyServices());
    this.loadPagerDutyServices();
  }
  $onDestroy() {
    this.scheduler.unsubscribe();
  }
  loadPagerDutyServices() {
    PagerDutyReader.listServices().subscribe((pagerDutyServices) => {
      this.pagerDutyServices = pagerDutyServices.filter((service) => service.integration_key);
      this.servicesLoaded = true;
    });
  }
}
const pagerDutySelectField = {
  bindings: {
    component: "="
  },
  controller: PagerDutySelectFieldController,
  template: `
    <div class="form-group row">
      <div class="col-sm-3 sm-label-right">{{$ctrl.label}} <help-field content="{{$ctrl.helpContents}}"></help-field></div>
      <div class="col-sm-9">
        <ui-select ng-if="$ctrl.servicesLoaded" ng-model="$ctrl.component.pdApiKey" class="form-control input-sm" ng-required="$ctrl.required">
          <ui-select-match placeholder="Select a PagerDuty Service">{{$select.selected.name}}</ui-select-match>
          <ui-select-choices repeat="pagerDuty.integration_key as pagerDuty in $ctrl.pagerDutyServices | filter: $select.search">
            {{pagerDuty.name}}
          </ui-select-choices>
        </ui-select>
    </div>
  </div>
`
};
const PAGER_DUTY_SELECT_FIELD_COMPONENT = "spinnaker.core.pagerDuty.pagerDutySelectField.component";
module(PAGER_DUTY_SELECT_FIELD_COMPONENT, []).component("pagerDutySelectField", pagerDutySelectField);

var css_248z$1R = ".vertical-navigation {\n  background-color: var(--color-accent-g2);\n  box-shadow: 2px 0 3px 1px var(--color-alto);\n  min-width: 226px;\n  max-width: 300px;\n  display: grid;\n  height: 100%;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto 1fr auto;\n  grid-template-areas: 'nav-header' 'nav-content' 'nav-bottom';\n}\n@media (max-width: 1640px) {\n  .vertical-navigation {\n    max-width: 226px;\n  }\n}\n.vertical-navigation .nav-header {\n  grid-area: nav-header;\n  color: var(--color-primary);\n  margin-bottom: unset;\n}\n.vertical-navigation .nav-header .application-header-icon {\n  display: flex;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: var(--color-primary);\n  color: var(--color-white);\n  text-align: center;\n  width: 36px;\n  height: 36px;\n  font-size: 15px;\n  cursor: pointer;\n}\n.vertical-navigation .nav-header .app-fresh-icon {\n  width: 20px;\n}\n.vertical-navigation .nav-header .header-icon-pulsing {\n  -webkit-animation: pulse 4s steps(48) infinite;\n  animation: pulse 4s steps(48) infinite;\n}\n.vertical-navigation .nav-header .application-name {\n  word-break: break-word;\n}\n.vertical-navigation .nav-content {\n  grid-area: nav-content;\n  overflow: auto;\n}\n.vertical-navigation .nav-content .nav-section {\n  font-size: 16px;\n  text-transform: uppercase;\n}\n.vertical-navigation .nav-content .nav-section .nav-category {\n  color: var(--color-accent);\n  padding-left: 12px;\n  align-items: center;\n}\n.vertical-navigation .nav-content .nav-section .nav-category .badge-running-count {\n  min-width: 16px;\n  height: 16px;\n  margin-right: -12px;\n  margin-top: 18px;\n  border-radius: 3px;\n  color: var(--color-white);\n  background-color: var(--color-primary);\n  line-height: 16px;\n  text-align: center;\n  font-size: 12px;\n  z-index: 100;\n}\n.vertical-navigation .nav-content .nav-section .nav-category .badge-none {\n  min-width: 16px;\n  margin-right: -12px;\n  margin-top: 18px;\n}\n.vertical-navigation .nav-content .nav-section .nav-category .nav-row-item {\n  min-width: 16px;\n  margin-right: 8px;\n  line-height: 10px;\n  padding: 0;\n  font-size: 16px;\n}\n.vertical-navigation .nav-content .nav-section .nav-category .nav-row-item .bs-tooltip-right {\n  display: none;\n}\n.vertical-navigation .nav-content .nav-section a {\n  text-decoration: none;\n}\n.vertical-navigation .nav-content .nav-section .active.nav-category {\n  background: #bbdee8;\n  color: var(--color-primary);\n}\n.vertical-navigation .nav-content .nav-section .active.nav-category .nav-icon {\n  color: var(--color-primary);\n}\n.vertical-navigation .nav-content .nav-section .active.nav-category .nav-name {\n  color: var(--color-primary);\n}\n.vertical-navigation .nav-content .nav-section .page-category {\n  color: var(--color-accent);\n  padding-left: 16px;\n  margin-top: -4px;\n}\n.vertical-navigation .nav-content .nav-section .page-category .nav-row-item {\n  min-width: 16px;\n  line-height: 10px;\n  padding: 0;\n  font-size: 16px;\n}\n.vertical-navigation .nav-content .nav-section:not(:first-of-type) {\n  border-top: 1px solid var(--color-white);\n}\n.vertical-navigation .nav-bottom {\n  max-height: 100px;\n  grid-area: nav-bottom;\n  overflow: auto;\n}\n.vertical-nav-collapsed {\n  min-width: 60px;\n  max-width: 60px;\n}\n.vertical-nav-collapsed .nav-header {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n.vertical-nav-collapsed .application-name {\n  display: none;\n}\n.vertical-nav-collapsed .nav-section .nav-category .nav-name,\n.vertical-nav-collapsed .nav-section .page-category .nav-name,\n.vertical-nav-collapsed .nav-section .nav-category .HoverablePopover,\n.vertical-nav-collapsed .nav-section .page-category .HoverablePopover {\n  display: none;\n}\n.vertical-nav-collapsed .nav-section .nav-category .tooltip,\n.vertical-nav-collapsed .nav-section .page-category .tooltip {\n  color: red;\n}\n";
styleInject(css_248z$1R);

const ApplicationNavigation = ({ app }) => {
  const prevDataSourceAttr = usePrevious(app.attributes.dataSources);
  useCurrentStateAndParams();
  const isMobile = useIsMobile();
  const isExpanded = useRecoilValue(verticalNavExpandedAtom);
  const getNavigationCategories = (dataSources) => {
    const appSources = dataSources.filter((ds) => ds.visible !== false && !ds.disabled && ds.sref);
    const allCategories = navigationCategoryRegistry.getAll();
    const categories = allCategories.map((c) => appSources.filter((as) => as.category === c.key));
    const uncategorizedSources = appSources.filter((as) => !as.category || !find(allCategories, (c) => c.key == as.category));
    categories.push(uncategorizedSources);
    return categories;
  };
  const initialCategories = getNavigationCategories(app.dataSources);
  const [navSections, setNavSections] = React__default.useState(initialCategories);
  const appRefreshSubscription = app.onRefresh(null, () => {
    if (!isEqual(app.attributes.dataSources, prevDataSourceAttr)) {
      const categories = getNavigationCategories(app.dataSources);
      setNavSections(categories);
    }
  });
  React__default.useEffect(() => {
    const unsubscribe = appRefreshSubscription();
    return unsubscribe;
  }, []);
  const pageApplicationOwner = () => {
    PagerDutyWriter.pageApplicationOwnerModal(app);
  };
  if (!isExpanded && isMobile) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames(["vertical-navigation", "layer-high", { "vertical-nav-collapsed": !isExpanded }])
  }, /* @__PURE__ */ React__default.createElement("h3", {
    className: "heading-2 horizontal middle nav-header sp-margin-m-xaxis sp-margin-l-top"
  }, /* @__PURE__ */ React__default.createElement(AppRefresher, {
    app
  }), /* @__PURE__ */ React__default.createElement("span", {
    className: "application-name text-semibold heading-2 sp-margin-m-left"
  }, app.name)), /* @__PURE__ */ React__default.createElement("div", {
    className: "nav-content"
  }, navSections.filter((section) => section.length).map((section, i) => /* @__PURE__ */ React__default.createElement(NavSection, {
    key: `section-${i}`,
    dataSources: section,
    app
  })), SETTINGS.feature.pagerDuty && app.attributes.pdApiKey && /* @__PURE__ */ React__default.createElement("div", {
    className: "nav-section sp-padding-s-yaxis"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "page-category flex-container-h middle text-semibold sp-padding-s-yaxis clickable",
    onClick: pageApplicationOwner
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "nav-row-item sp-margin-s-right"
  }, !isExpanded ? /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: "Page App Owner",
    placement: "right"
  }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Icon, {
    className: "nav-item-icon",
    name: "spMenuPager",
    size: "medium",
    color: "danger"
  }))) : /* @__PURE__ */ React__default.createElement(Icon, {
    className: "nav-item-icon",
    name: "spMenuPager",
    size: "medium",
    color: "danger"
  })), /* @__PURE__ */ React__default.createElement("span", {
    className: "nav-name"
  }, " Page App Owner")))), /* @__PURE__ */ React__default.createElement("div", {
    className: "nav-bottom"
  }, /* @__PURE__ */ React__default.createElement(BottomSection, {
    app
  })));
};

var css_248z$1Q = ".application {\n  display: flex;\n  flex-direction: row;\n  flex: 1 1 auto;\n  overflow-y: hidden;\n}\n.glyphicon-cloud {\n  top: 4px;\n}\n.application-actions {\n  margin-bottom: 10px;\n  padding-top: 5px;\n  display: inline-block;\n  float: right !important;\n}\n.filter-tags {\n  padding: 5px 15px 0;\n}\n.filter-tags .filter-tag {\n  border-radius: 2px;\n  display: inline-block;\n  padding: 3px 5px;\n  margin-right: 10px;\n  margin-bottom: 5px;\n  background-color: var(--color-cirrus);\n  font-size: 90%;\n}\n.filter-tags .filter-tag strong {\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.filter-tags .filter-tag a {\n  font-size: 90%;\n  color: var(--color-dovegray);\n}\n.filter-tags .filter-toggle {\n  background-color: var(--color-accent);\n  border-radius: 2px;\n  color: var(--color-white);\n  cursor: pointer;\n  display: inline-block;\n  font-size: 90%;\n  font-weight: 600;\n  margin-bottom: 5px;\n  margin-right: 10px;\n  padding: 3px 5px;\n  text-transform: uppercase;\n}\n.filter-tags .clear-filters {\n  display: inline-block;\n  margin-left: 5px;\n  color: var(--color-mineshaft);\n  font-size: 90%;\n}\n.select2-highlighted .icon {\n  color: inherit;\n}\n.glyphicon-none:before {\n  content: '\\e113';\n  color: transparent !important;\n}\ninput[type='checkbox'],\ninput[type='radio'] {\n  cursor: pointer;\n}\n.table-search-results-application .table-header .col-application,\n.table-search-results-application .table-row .col-application {\n  width: 200px;\n}\n.table-search-results-application .table-header .col-account,\n.table-search-results-application .table-row .col-account,\n.table-search-results-application .table-header .col-accounts,\n.table-search-results-application .table-row .col-accounts {\n  width: 250px;\n}\n.table-search-results-application .table-header .col-email,\n.table-search-results-application .table-row .col-email {\n  width: 250px;\n}\n";
styleInject(css_248z$1Q);

class ApplicationComponent extends React__default.Component {
  constructor(props) {
    super(props);
    this.apolloClient = createApolloClient();
    this.mountApplication(props.app);
  }
  componentWillUnmount() {
    this.unmountApplication(this.props.app);
  }
  componentWillReceiveProps(nextProps) {
    this.unmountApplication(this.props.app);
    this.mountApplication(nextProps.app);
  }
  mountApplication(app) {
    var _a;
    if (app.notFound || app.hasError) {
      RecentHistoryService.removeLastItem("applications");
      return;
    }
    DebugWindow.application = app;
    if (!((_a = app.attributes) == null ? void 0 : _a.disableAutoRefresh)) {
      this.unsubscribeAppRefresh = this.props.app.subscribeToRefresh(this.apolloClient.onRefresh);
      app.enableAutoRefresh();
    }
  }
  unmountApplication(app) {
    var _a;
    if (app.notFound || app.hasError) {
      return;
    }
    DebugWindow.application = void 0;
    (_a = this.unsubscribeAppRefresh) == null ? void 0 : _a.call(this);
    this.unsubscribeAppRefresh = void 0;
    app.disableAutoRefresh();
  }
  render() {
    const { app } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "application"
    }, !app.notFound && !app.hasError && /* @__PURE__ */ React__default.createElement(ApplicationNavigation, {
      app
    }), app.notFound && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h2", {
      className: "text-center"
    }, "Application Not Found"), /* @__PURE__ */ React__default.createElement("p", {
      className: "text-center",
      style: { marginBottom: "20px" }
    }, "Please check your URL - we can't find any data for ", /* @__PURE__ */ React__default.createElement("em", null, app.name), ".")), app.hasError && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h2", {
      className: "text-center"
    }, "Something went wrong"), /* @__PURE__ */ React__default.createElement("p", {
      className: "text-center",
      style: { marginBottom: "20px" }
    }, "There was a problem loading ", /* @__PURE__ */ React__default.createElement("em", null, app.name), ". Try checking your browser console for errors.")), /* @__PURE__ */ React__default.createElement(ApplicationContextProvider, {
      app
    }, /* @__PURE__ */ React__default.createElement(ApolloProvider, {
      client: this.apolloClient.client
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "container scrollable-columns"
    }, /* @__PURE__ */ React__default.createElement(UIView, {
      className: "secondary-panel",
      name: "insight"
    })))));
  }
}

class ApplicationModelBuilder {
  static createApplicationForTests(name, ...dataSources) {
    return new Application(name, SchedulerFactory.createScheduler(), dataSources);
  }
  static createStandaloneApplication(name) {
    const application = new Application(name, SchedulerFactory.createScheduler(), []);
    application.isStandalone = true;
    return application;
  }
  static createNotFoundApplication(name) {
    const config = { key: "serverGroups", lazy: true, defaultData: [] };
    const application = new Application(name, SchedulerFactory.createScheduler(), [config]);
    application.notFound = true;
    return application;
  }
  static createApplicationWithError(name) {
    const config = { key: "serverGroups", lazy: true, defaultData: [] };
    const application = new Application(name, SchedulerFactory.createScheduler(), [config]);
    application.hasError = true;
    return application;
  }
}

const InsightLayout = ({ app }) => {
  const [expandFilters, setExpandFilters] = React__default.useState(ReactInjector.insightFilterStateModel.filtersExpanded);
  const { filtersHidden } = ReactInjector.insightFilterStateModel;
  const filterClass = expandFilters ? "filters-expanded" : "filters-collapsed";
  const toggleFilters = () => {
    ReactInjector.insightFilterStateModel.pinFilters(!expandFilters);
    setExpandFilters(!expandFilters);
  };
  const navClass = useRecoilValue(verticalNavExpandedAtom) ? "nav-expanded" : "nav-collapsed";
  const { state: currentState } = useCurrentStateAndParams();
  const showDetailsView = Boolean(Object.keys(currentState.views).find((v) => v.indexOf("detail@") !== -1));
  const detailsClass = showDetailsView ? "details-open" : "details-closed";
  if (app.notFound || app.hasError) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: `insight ${filterClass} ${navClass} ${detailsClass}`
  }, !filtersHidden && /* @__PURE__ */ React__default.createElement("div", {
    onClick: toggleFilters
  }, /* @__PURE__ */ React__default.createElement(FilterCollapse, null)), !filtersHidden && expandFilters && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(UIView, {
    name: "nav",
    className: "nav ng-scope"
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-1"
  }, /* @__PURE__ */ React__default.createElement(UIView, {
    name: "master",
    className: "nav-content ng-scope",
    "data-scroll-id": "nav-content"
  }), showDetailsView && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(UIView, {
    name: "detail",
    className: "detail-content"
  }))));
};

class ApplicationStateProvider {
  constructor(stateConfigProvider) {
    this.stateConfigProvider = stateConfigProvider;
    this.childStates = [];
    this.detailStates = [];
    this.insightStates = [];
    this.insightState = {
      name: "insight",
      abstract: true,
      views: {
        insight: {
          component: InsightLayout,
          $type: "react"
        }
      },
      resolve: {
        app: ["app", (app) => app]
      },
      children: this.insightStates
    };
    this.childStates.push(this.insightState);
  }
  addChildState(state) {
    this.childStates.push(state);
    this.stateConfigProvider.setStates();
  }
  addInsightState(state) {
    this.insightStates.push(state);
    state.children = this.detailStates;
    this.stateConfigProvider.setStates();
  }
  addInsightDetailState(state) {
    this.detailStates.push(state);
    this.insightState.children.forEach((c) => {
      c.children = c.children || [];
      if (!c.children.some((child) => child.name === state.name)) {
        c.children.push(state);
      }
    });
    this.stateConfigProvider.setStates();
  }
  addParentState(parentState, mainView, relativeUrl = "") {
    const applicationConfig = {
      name: "application",
      url: `${relativeUrl}/:application`,
      redirectTo: (transition) => {
        return transition.injector().getAsync("app").then((app) => {
          var _a;
          const defaultDataSource = (_a = app.dataSources.find((ds) => ds.sref && !ds.disabled)) == null ? void 0 : _a.sref;
          const params = transition.params();
          const options = { relative: defaultDataSource ? transition.to().name : void 0 };
          return transition.router.stateService.target(defaultDataSource || "home.search", params, options);
        });
      },
      resolve: {
        app: [
          "$stateParams",
          ($stateParams) => {
            return ApplicationReader.getApplication($stateParams.application, false).then((app) => {
              InferredApplicationWarningService.checkIfInferredAndWarn(app);
              return app || ApplicationModelBuilder.createNotFoundApplication($stateParams.application);
            }).catch((error) => {
              if (error.status && error.status === 404) {
                return ApplicationModelBuilder.createNotFoundApplication($stateParams.application);
              } else {
                console.error(error);
                return ApplicationModelBuilder.createApplicationWithError($stateParams.application);
              }
            });
          }
        ]
      },
      data: {
        pageTitleMain: {
          field: "application"
        },
        history: {
          type: "applications",
          state: "home.applications.application",
          keyParams: ["application"]
        }
      },
      children: this.childStates
    };
    applicationConfig.views = {};
    applicationConfig.views[mainView] = {
      component: ApplicationComponent,
      $type: "react"
    };
    parentState.children.push(applicationConfig);
    this.stateConfigProvider.setStates();
  }
  $get() {
    return this;
  }
}
ApplicationStateProvider.$inject = ["stateConfigProvider"];
const APPLICATION_STATE_PROVIDER = "spinnaker.core.application.state.provider";
module(APPLICATION_STATE_PROVIDER, [STATE_CONFIG_PROVIDER]).provider("applicationState", ApplicationStateProvider);

class ConfigSectionFooter extends React__default.Component {
  render() {
    const { isValid, isDirty, isSaving, saveError, onRevertClicked, onSaveClicked } = this.props;
    if (!isDirty) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "row footer"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-12 text-right"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "btn btn-link disabled"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "far fa-check-circle"
      }), " In sync with server")));
    }
    const saveButton = /* @__PURE__ */ React__default.createElement("button", {
      className: `btn btn-primary ${isValid ? "" : "disabled"}`,
      onClick: onSaveClicked
    }, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "far fa-check-circle"
    }), " Save Changes"));
    const savingButton = /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      disabled: true
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "pulsing"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "nano"
    }), " Saving\u2026"));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row footer"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: onRevertClicked,
      style: { visibility: "visible" }
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-flash"
    }), " Revert")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9 text-right"
    }, isSaving ? savingButton : saveButton, !!saveError && /* @__PURE__ */ React__default.createElement("div", {
      className: "error-message"
    }, "There was an error saving your changes. Please try again.")));
  }
}

class ApplicationWriter {
  static createApplication(application) {
    const jobs = this.buildJobs(application, "createApplication", cloneDeep);
    return TaskExecutor.executeTask({
      job: jobs,
      application,
      description: "Create Application: " + application.name
    });
  }
  static updateApplication(application) {
    const jobs = this.buildJobs(application, "updateApplication", cloneDeep);
    return TaskExecutor.executeTask({
      job: jobs,
      application,
      description: "Update Application: " + application.name
    });
  }
  static deleteApplication(application) {
    const jobs = this.buildJobs(application, "deleteApplication", (app) => {
      return { name: app.name };
    });
    return TaskExecutor.executeTask({
      job: jobs,
      application,
      description: "Deleting Application: " + application.name
    }).then((task) => {
      RecentHistoryService.removeByAppName(application.name);
      return task;
    }).catch((task) => task);
  }
  static buildJobs(application, type, commandTransformer) {
    const jobs = [];
    const command = commandTransformer(application);
    if (application.cloudProviders) {
      command.cloudProviders = application.cloudProviders.join(",");
    }
    delete command.accounts;
    jobs.push({
      type,
      application: command
    });
    return jobs;
  }
}

class ConfigSectionFooterController {
  revert() {
    copy(this.viewState.originalConfig, this.config);
    this.viewState.isDirty = false;
  }
  saveSuccess() {
    this.viewState.originalConfig = cloneDeep(this.config);
    this.viewState.originalStringVal = toJson(this.config);
    this.viewState.isDirty = false;
    this.viewState.saving = false;
    this.application.attributes[this.configField] = this.config;
  }
  saveError() {
    this.viewState.saving = false;
    this.viewState.saveError = true;
  }
  save() {
    this.viewState.saving = true;
    this.viewState.saveError = false;
    const updateCommand = {
      name: this.application.name,
      accounts: this.application.attributes.accounts
    };
    updateCommand[this.configField] = this.config;
    ApplicationWriter.updateApplication(updateCommand).then(() => this.saveSuccess(), () => this.saveError());
  }
}
const configSectionFooterComponent = {
  bindings: {
    application: "=",
    config: "=",
    viewState: "=",
    configField: "@",
    revert: "&?",
    afterSave: "&?",
    saveDisabled: "<"
  },
  controller: ConfigSectionFooterController,
  templateUrl: "core/src/application/config/footer/configSectionFooter.component.html"
};
const CONFIG_SECTION_FOOTER = "spinnaker.core.application.config.section.footer.component";
module(CONFIG_SECTION_FOOTER, []).component("configSectionFooter", configSectionFooterComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/footer/configSectionFooter.component.html", `<div class="row footer">
  <div class="col-md-3">
    <button
      class="btn btn-default"
      ng-click="$ctrl.revert()"
      ng-if="$ctrl.viewState.isDirty"
      style="visibility: visible"
    >
      <span class="glyphicon glyphicon-flash"></span> Revert
    </button>
  </div>
  <div class="col-md-9 text-right">
    <button
      class="btn btn-primary"
      ng-if="$ctrl.viewState.isDirty"
      ng-click="$ctrl.save()"
      ng-disabled="$ctrl.saveDisabled"
    >
      <span ng-if="!$ctrl.viewState.saving"> <span class="far fa-check-circle"></span> Save Changes </span>
      <span ng-if="$ctrl.viewState.saving" class="pulsing">
        <span class="fa fa-cog fa-spin"></span> Saving&hellip;
      </span>
    </button>
    <div class="error-message" ng-if="$ctrl.viewState.saveError">
      There was an error saving your changes. Please try again.
    </div>
    <span ng-if="!$ctrl.viewState.isDirty" class="btn btn-link disabled"
      ><span class="far fa-check-circle"></span> In sync with server</span
    >
  </div>
</div>
`);
}]);

const defaultFilter = () => true;
class AppListExtractor {
  static getMonikers(applications, filter = defaultFilter) {
    const allMonikers = applications.map((a) => a.getDataSource("serverGroups").data.filter(filter).map((serverGroup) => serverGroup.moniker));
    return compact(flatten(allMonikers));
  }
  static getRegions(applications, filter = defaultFilter) {
    const allRegions = applications.map((a) => a.getDataSource("serverGroups").data.filter(filter).map((serverGroup) => serverGroup.region));
    return uniq(compact(flatten(allRegions))).sort();
  }
  static getStacks(applications, filter = defaultFilter) {
    const allStacks = applications.map((a) => a.getDataSource("serverGroups").data.filter(filter).map((serverGroup) => serverGroup.stack));
    return uniq(compact(flatten(allStacks))).sort();
  }
  static getClusters(applications, filter = defaultFilter) {
    const allClusters = applications.map((a) => a.getDataSource("serverGroups").data.filter(filter).map((serverGroup) => serverGroup.cluster));
    return uniq(compact(flatten(allClusters))).sort();
  }
  static getAsgs(applications, clusterFilter = defaultFilter) {
    const allNames = applications.map((a) => a.getDataSource("serverGroups").data.filter(clusterFilter).map((s) => s.name));
    return uniq(compact(flatten(allNames))).sort();
  }
  static getZones(applications, clusterFilter = defaultFilter, regionFilter = defaultFilter, nameFilter = defaultFilter) {
    const allInstances = applications.map((a) => a.getDataSource("serverGroups").data.filter(clusterFilter).filter(regionFilter).filter(nameFilter).map((serverGroup) => serverGroup.instances));
    const instanceZones = flatten(flatten(allInstances)).map((i) => i.availabilityZone);
    return uniq(compact(instanceZones)).sort();
  }
  static getInstances(applications, clusterFilter = defaultFilter, serverGroupFilter = defaultFilter, instanceFilter = defaultFilter) {
    const allInstances = applications.map((a) => a.getDataSource("serverGroups").data.filter(clusterFilter).filter(serverGroupFilter).map((serverGroup) => serverGroup.instances));
    return uniq(compact(flatten(flatten(allInstances)).filter(instanceFilter)));
  }
  static clusterFilterForCredentials(credentials) {
    return (serverGroup) => {
      return credentials ? serverGroup.account === credentials : true;
    };
  }
  static monikerClusterNameFilter(clusterName) {
    return (serverGroup) => {
      return serverGroup.moniker.cluster === clusterName;
    };
  }
  static clusterFilterForCredentialsAndRegion(credentials, region) {
    return (serverGroup) => {
      const accountMatches = credentials ? serverGroup.account === credentials : true;
      const regionMatches = serverGroup && Array.isArray(region) && region.length ? region.includes(serverGroup.region) : region ? serverGroup.region === region : true;
      return accountMatches && regionMatches;
    };
  }
}

class ApplicationNameValidator {
  static registerValidator(cloudProvider, validator) {
    if (!this.providerMap.has(cloudProvider)) {
      this.providerMap.set(cloudProvider, []);
    }
    this.providerMap.get(cloudProvider).push(validator);
  }
  static setValidators(cloudProvider, validators) {
    this.providerMap.set(cloudProvider, validators);
  }
  static validate(applicationName, providersToTest) {
    return AccountService.listProviders().then((availableProviders) => {
      const toCheck = providersToTest && providersToTest.length ? providersToTest : availableProviders;
      const errors = [];
      const warnings = [];
      toCheck.forEach((provider) => {
        if (this.providerMap.has(provider)) {
          this.providerMap.get(provider).forEach((validator) => {
            const results = validator.validate(applicationName);
            results.warnings.forEach((message) => warnings.push({ cloudProvider: provider, message }));
            results.errors.forEach((message) => errors.push({ cloudProvider: provider, message }));
          });
        }
      });
      return { errors, warnings };
    });
  }
}
ApplicationNameValidator.providerMap = new Map();

const INFRASTRUCTURE_KEY = "infrastructure";
const DELIVERY_KEY = "delivery";
navigationCategoryRegistry.register({
  key: DELIVERY_KEY,
  label: "Delivery",
  icon: "fa fa-fw fa-xs fa-tasks",
  primary: true,
  order: 100
});
navigationCategoryRegistry.register({
  key: INFRASTRUCTURE_KEY,
  label: "Infrastructure",
  icon: "fa fa-fw fa-xs fa-cloud",
  primary: true,
  order: 200
});

var css_248z$1P = ".user-menu .dropdown-toggle {\n  background-color: var(--color-primary);\n  border: none;\n  box-shadow: none;\n  color: var(--color-white);\n  font-weight: 200;\n  padding: var(--padd);\n}\n.user-menu .dropdown-menu {\n  top: 80%;\n  min-width: 125px;\n  border: 0;\n}\n@media (max-width: 480px) {\n  .user-menu .dropdown-menu {\n    position: static;\n  }\n}\n";
styleInject(css_248z$1P);

const UserMenu = () => {
  const authenticatedUser = AuthenticationService.getAuthenticatedUser();
  const showLogOutDropdown = authenticatedUser.authenticated;
  if (!SETTINGS.authEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "user-menu"
  }, /* @__PURE__ */ React.createElement(Dropdown, {
    id: "user-menu-dropdown"
  }, /* @__PURE__ */ React.createElement(Dropdown.Toggle, null, /* @__PURE__ */ React.createElement("i", {
    className: "hidden-lg glyphicon glyphicon-user"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "hidden-xs hidden-sm hidden-md"
  }, authenticatedUser.name)), showLogOutDropdown && /* @__PURE__ */ React.createElement(Dropdown.Menu, null, /* @__PURE__ */ React.createElement("li", {
    className: "sp-padding-xs",
    onClick: () => AuthenticationInitializer.logOut()
  }, "Log Out"))));
};

const customBannersByName = {};

var __defProp$o = Object.defineProperty;
var __getOwnPropDesc$o = Object.getOwnPropertyDescriptor;
var __decorateClass$o = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$o(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$o(target, key, result);
  return result;
};
let BannerContainer = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement(UIRouterContextComponent, null, /* @__PURE__ */ React__default.createElement(BannerContainerContent, {
      app: this.props.app
    }));
  }
};
BannerContainer = __decorateClass$o([
  Overridable("core.insight.banners")
], BannerContainer);
const BannerContainerContent = ({ app }) => {
  const { state: currentState } = useCurrentStateAndParams();
  const validBanners = (SETTINGS.banners || []).filter((m) => {
    const validRoute = m.routes.some((route) => currentState.name.includes(route));
    return m.active && validRoute && Boolean(customBannersByName[m.key]);
  }).map((m) => {
    const CustomBanner = customBannersByName[m.key];
    return /* @__PURE__ */ React__default.createElement(CustomBanner, {
      key: `banner-${m.key}`,
      app
    });
  });
  if (!validBanners.length) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-sm vertical"
  }, validBanners);
};

class CertificateReader {
  static listCertificates() {
    return REST("/certificates").get();
  }
  static listCertificatesByProvider(cloudProvider) {
    return REST("/certificates").path(cloudProvider).get();
  }
}

class EphemeralPopover extends React__default.Component {
  constructor(props) {
    super(props);
    this.PopoverContent = () => {
      const { ttl } = this.state;
      const isInPast = !!ttl && Date.now() > ttl;
      const ttlPhrase = relativeTime(ttl);
      return /* @__PURE__ */ React__default.createElement("div", null, "This server group ", isInPast ? "was scheduled to be" : "will be", " automatically destroyed", " ", /* @__PURE__ */ React__default.createElement("strong", null, ttlPhrase), ".");
    };
    this.state = this.getState(props);
  }
  getState(props) {
    const entityTags = props.entity && props.entity.entityTags;
    if (entityTags) {
      const ephemeralTag = entityTags.tags.filter((x) => x.name === "spinnaker:ttl")[0];
      if (ephemeralTag) {
        return {
          ttl: ephemeralTag.value.expiry
        };
      }
    }
    return {};
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  render() {
    const { ttl } = this.state;
    if (!ttl) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "tag-marker small"
    }, /* @__PURE__ */ React__default.createElement(HoverablePopover, {
      Component: this.PopoverContent,
      title: "Ephemeral Server Group",
      className: `ephemeral-popover`
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: `ephemeral fa fa-clock`
    })));
  }
}

class EntityNotifications extends React__default.Component {
  constructor() {
    super(...arguments);
    this.getAlertAnalyticsLabel = () => {
      const { entity, pageLocation, entityType } = this.props;
      const entityTags = entity.entityTags;
      const { account, region, entityId } = entityTags.entityRef;
      const alertsStr = entityTags.alerts.map((tag) => tag.name).join(",");
      return [pageLocation, entityType, account, region, entityId, region, alertsStr].join(":");
    };
    this.getNoticeAnalyticsLabel = () => {
      const { entity, pageLocation, entityType } = this.props;
      const entityTags = entity.entityTags;
      const { account, region, entityId } = entityTags.entityRef;
      const noticesStr = entityTags.notices.map((tag) => tag.name).join(",");
      return [pageLocation, entityType, account, region, entityId, noticesStr].join(":");
    };
  }
  render() {
    const { entity, application, placement, hOffsetPercent, className, onUpdate } = this.props;
    const entityTags = entity && entity.entityTags;
    const tags = entityTags ? [entityTags] : [];
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "entity-notifications"
    }, /* @__PURE__ */ React__default.createElement(NotificationsPopover, {
      entity,
      tags,
      application,
      type: "alerts",
      gaLabelFn: this.getAlertAnalyticsLabel,
      grouped: false,
      categorized: true,
      className,
      placement,
      hOffsetPercent,
      onUpdate
    }), /* @__PURE__ */ React__default.createElement(NotificationsPopover, {
      entity,
      tags,
      application,
      type: "notices",
      gaLabelFn: this.getNoticeAnalyticsLabel,
      grouped: false,
      categorized: false,
      className,
      placement,
      hOffsetPercent,
      onUpdate
    }), /* @__PURE__ */ React__default.createElement(EphemeralPopover, {
      entity
    }));
  }
}
EntityNotifications.defaultProps = {
  placement: "bottom",
  hOffsetPercent: "50%",
  className: "",
  onUpdate: noop
};

class ManagedWriter {
  static pauseResourceManagement(resourceId) {
    return REST("/managed/resources").path(resourceId, "pause").post();
  }
  static resumeResourceManagement(resourceId) {
    return REST("/managed/resources").path(resourceId, "pause").delete();
  }
}

const ARTIFACT_TYPE_EMBEDDED = "embedded/base64";
const ARTIFACT_TYPE_REMOTE = "remote/base64";

var ManagedResourceStatus;
(function(ManagedResourceStatus2) {
  ManagedResourceStatus2["ACTUATING"] = "ACTUATING";
  ManagedResourceStatus2["CREATED"] = "CREATED";
  ManagedResourceStatus2["DIFF"] = "DIFF";
  ManagedResourceStatus2["DIFF_NOT_ACTIONABLE"] = "DIFF_NOT_ACTIONABLE";
  ManagedResourceStatus2["CURRENTLY_UNRESOLVABLE"] = "CURRENTLY_UNRESOLVABLE";
  ManagedResourceStatus2["MISSING_DEPENDENCY"] = "MISSING_DEPENDENCY";
  ManagedResourceStatus2["ERROR"] = "ERROR";
  ManagedResourceStatus2["HAPPY"] = "HAPPY";
  ManagedResourceStatus2["PAUSED"] = "PAUSED";
  ManagedResourceStatus2["RESUMED"] = "RESUMED";
  ManagedResourceStatus2["UNHAPPY"] = "UNHAPPY";
  ManagedResourceStatus2["UNKNOWN"] = "UNKNOWN";
  ManagedResourceStatus2["WAITING"] = "WAITING";
  ManagedResourceStatus2["DELETING"] = "DELETING";
})(ManagedResourceStatus || (ManagedResourceStatus = {}));

const ActuationWarning = () => /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("div", {
  className: "horizontal top sp-padding-m alert alert-warning"
}, /* @__PURE__ */ React__default.createElement("i", {
  className: "fa fa-exclamation-triangle sp-margin-m-right sp-margin-xs-top"
}), /* @__PURE__ */ React__default.createElement("span", null, "Pausing management will not interrupt the action Spinnaker is currently performing to resolve the difference from desired state.")));
const ToggleResourceManagement = ({ isPaused, isActuating, regions }) => {
  if (isPaused) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "Spinnaker will resume taking action to correct differences from the desired state."), /* @__PURE__ */ React__default.createElement(MultiRegionWarning, {
      isPaused: true,
      regions
    }));
  } else {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "While a resource is paused, Spinnaker will not take action to correct differences from the desired state."), isActuating && /* @__PURE__ */ React__default.createElement(ActuationWarning, null), /* @__PURE__ */ React__default.createElement(MultiRegionWarning, {
      isPaused: true,
      regions
    }));
  }
};
const MultiRegionWarning = ({ isPaused, regions }) => {
  if (regions.length < 2) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "horizontal top sp-padding-m alert alert-warning"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-exclamation-triangle sp-margin-m-right sp-margin-xs-top"
  }), /* @__PURE__ */ React__default.createElement("span", null, isPaused ? "Resuming" : "Pausing", " management of this resource will affect the following regions:", " ", /* @__PURE__ */ React__default.createElement("b", null, regions.join(", ")), "."));
};

var css_248z$1O = ".ManagedResourceStatusIndicator .HoverablePopover {\n  display: flex;\n}\n.ManagedResourceStatusIndicator .info {\n  background-color: var(--color-status-info);\n}\n.ManagedResourceStatusIndicator .warning {\n  background-color: var(--color-status-warning);\n}\n.ManagedResourceStatusIndicator .error {\n  background-color: var(--color-status-error);\n}\n.ManagedResourceStatusIndicator .square {\n  padding: 0 8px;\n  font-size: 20px;\n}\n.ManagedResourceStatusIndicator .circle {\n  padding: 4px;\n  font-size: 14px;\n  border-radius: 50%;\n}\n";
styleInject(css_248z$1O);

const confirmNotManaged = (resource, application) => {
  const { managedResourceSummary, isManaged } = resource;
  if (!isManaged || !managedResourceSummary || managedResourceSummary.isPaused) {
    return $q.when(true);
  }
  const submitMethod = () => {
    return ManagedWriter.pauseResourceManagement(managedResourceSummary.id).then(() => application.managedResources.refresh(true));
  };
  return ConfirmationModalService.confirm({
    header: `Pause Management?`,
    bodyContent: /* @__PURE__ */ React__default.createElement(BodyText, {
      resourceSummary: managedResourceSummary
    }),
    account: managedResourceSummary.locations.account,
    buttonText: "Pause management",
    submitMethod
  }).then(() => true, () => false);
};
const toggleResourcePause = (resourceSummary, application, hidePopover) => {
  hidePopover == null ? void 0 : hidePopover();
  const { id, isPaused } = resourceSummary;
  const toggle = () => isPaused ? ManagedWriter.resumeResourceManagement(id) : ManagedWriter.pauseResourceManagement(id);
  const submitMethod = () => toggle().then(() => application.managedResources.refresh(true));
  return ConfirmationModalService.confirm({
    header: `Really ${isPaused ? "resume" : "pause"} resource management?`,
    bodyContent: /* @__PURE__ */ React__default.createElement(ToggleResourceManagement, {
      isActuating: resourceSummary.status === ManagedResourceStatus.ACTUATING,
      isPaused,
      regions: getRegions(resourceSummary)
    }),
    account: resourceSummary.locations.account,
    buttonText: `${isPaused ? "Resume" : "Pause"} management`,
    submitMethod
  });
};
const getRegions = (resourceSummary) => resourceSummary.locations.regions.map((r) => r.name).sort();
const BodyText = ({ resourceSummary }) => {
  const { status } = resourceSummary;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "\u{1F308} ", /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker is managing this resource.")), /* @__PURE__ */ React__default.createElement("p", null, "If you need to temporarily stop Spinnaker from managing this resource \u2014 for example, if something is wrong and manual intervention is required \u2014 you can pause management and resume it later."), status === ManagedResourceStatus.ACTUATING && /* @__PURE__ */ React__default.createElement(ActuationWarning, null), /* @__PURE__ */ React__default.createElement(MultiRegionWarning, {
    isPaused: true,
    regions: getRegions(resourceSummary)
  }));
};

const DeployingIntoManagedClusterWarning = ({ app, formik }) => {
  const [userPaused, setUserPaused] = React__default.useState(false);
  const command = formik.values;
  const pauseResource = React__default.useCallback(() => {
    const { resourceSummary, backingData } = formik.values;
    if (!resourceSummary)
      return;
    toggleResourcePause(resourceSummary, app).then(() => {
      var _a, _b;
      backingData.managedResources = (_b = (_a = app.getDataSource("managedResources")) == null ? void 0 : _a.data) == null ? void 0 : _b.resources;
      setUserPaused(true);
      formik.setFieldValue("resourceSummary", null);
    }, () => {
    });
  }, [app, formik]);
  if (!command.resourceSummary && !userPaused) {
    return null;
  }
  if (userPaused) {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-info"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal top"
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-check-circle"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-m-left"
    }, "Resource management has been paused.")));
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "\u{1F308} Spinnaker is managing this resource.")), /* @__PURE__ */ React__default.createElement("p", null, "Any changes you make to this cluster will be overridden in favor of the desired state."), /* @__PURE__ */ React__default.createElement("p", null, "If you need to manually deploy a new version of this server group, you should pause management."), /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-m-top"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: "passive",
    onClick: pauseResource
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-pause"
  }), " Pause management")));
};

const ManagedMenuItem = ({ resource, application, onClick, children }) => {
  if (!resource) {
    return null;
  }
  const resourceIsPaused = resource.isManaged && (!resource.managedResourceSummary || resource.managedResourceSummary.isPaused);
  const appIsPaused = application.isManagementPaused;
  const showInterstitial = resource.isManaged && !resourceIsPaused && !appIsPaused;
  const interstitial = () => showInterstitial ? confirmNotManaged(resource, application) : $q.when(true);
  const handleClick = () => interstitial().then((isNotManaged) => {
    isNotManaged && (onClick == null ? void 0 : onClick());
  });
  return /* @__PURE__ */ React__default.createElement(MenuItem, {
    onClick: handleClick
  }, children);
};

class BasePluginManager {
  constructor(baseHandlers) {
    this.handlers = {};
    for (const handler of baseHandlers) {
      this.registerHandler(handler);
    }
  }
  normalizeKind(kind) {
    return kind.split("@")[0];
  }
  getHandler(kind) {
    return this.handlers[kind] || this.handlers[this.normalizeKind(kind)];
  }
  isSupported(kind) {
    return Boolean(this.getHandler(kind));
  }
  registerHandler(handler) {
    this.handlers[handler.kind] = handler;
    this.handlers[this.normalizeKind(handler.kind)] = handler;
  }
}

const UNKNOWN_RESOURCE_ICON = "placeholder";
class ResourcesManager extends BasePluginManager {
  getIcon(kind) {
    var _a, _b;
    return (_b = (_a = this.getHandler(kind)) == null ? void 0 : _a.iconName) != null ? _b : UNKNOWN_RESOURCE_ICON;
  }
  getExperimentalDisplayLink(resource) {
    var _a, _b;
    return (_b = (_a = this.getHandler(resource.kind)) == null ? void 0 : _a.experimentalDisplayLink) == null ? void 0 : _b.call(_a, resource);
  }
  getSpinnakerType(kind) {
    var _a;
    const normalizedKind = this.normalizeKind(kind);
    const spinnakerType = (_a = normalizedKind.split("/")) == null ? void 0 : _a[1];
    return spinnakerType || normalizedKind;
  }
  getNativeResourceRoutingInfo({
    kind,
    account,
    stack,
    detail,
    displayName
  }) {
    const kindName = this.getSpinnakerType(kind);
    const params = {
      acct: account,
      stack,
      detail,
      q: displayName
    };
    switch (kindName) {
      case "cluster":
        return { state: "home.applications.application.insight.clusters", params };
      case "security-group":
        return { state: "home.applications.application.insight.firewalls", params };
      case "classic-load-balancer":
      case "application-load-balancer":
        return { state: "home.applications.application.insight.loadBalancers", params };
    }
    return void 0;
  }
}
const DEFAULT_RESOURCES = [
  {
    kind: "titus/cluster",
    iconName: "cluster"
  },
  {
    kind: "ec2/cluster",
    iconName: "cluster"
  },
  {
    kind: "ec2/security-group",
    iconName: "securityGroup"
  },
  {
    kind: "ec2/classic-load-balancer",
    iconName: "loadBalancer"
  },
  {
    kind: "ec2/application-load-balancer",
    iconName: "loadBalancer"
  }
];
const resourceManager = new ResourcesManager(DEFAULT_RESOURCES);

const RESOURCE_DIFF_LIST_MATCHER = /^(.*)\[(.*)\]$/i;
const getKindName = (kind) => {
  return resourceManager.getSpinnakerType(kind);
};
const getResourceKindForLoadBalancerType = (type) => {
  switch (type) {
    case "classic":
      return "classic-load-balancer";
    case "application":
      return "application-load-balancer";
    default:
      return null;
  }
};
const transformManagedResourceDiff = (diff) => {
  if (!diff)
    return {};
  return Object.keys(diff).reduce((transformed, key) => {
    const diffNode = diff[key];
    const fieldKeys = flatMap(key.split("/").filter(Boolean), (fieldKey) => {
      if (fieldKey.startsWith("{") && fieldKey.endsWith("}")) {
        return fieldKey.substring(1, fieldKey.length - 1);
      }
      const listMatch = fieldKey.match(RESOURCE_DIFF_LIST_MATCHER);
      if (listMatch) {
        const parentField = listMatch[1];
        const listItem = listMatch[2];
        return [parentField, listItem];
      }
      return fieldKey;
    });
    const path = `["${fieldKeys.join(`"]["fields"]["`)}"]`;
    const existingTransformedNode = get(transformed, path);
    set(transformed, path, {
      ...existingTransformedNode,
      key,
      diffType: diffNode.state,
      actual: diffNode.current,
      desired: diffNode.desired
    });
    return transformed;
  }, {});
};
class ManagedReader {
  static decorateResources(response) {
    if (response.applicationPaused) {
      response.resources.forEach((resource) => resource.status = ManagedResourceStatus.PAUSED);
    }
    response.resources.forEach((resource) => resource.isPaused = resource.status === ManagedResourceStatus.PAUSED);
    return response;
  }
  static getApplicationSummary(app) {
    return REST("/managed/application").path(app).query({ entities: "resources" }).get().then(this.decorateResources);
  }
  static getResourceHistory(resourceId) {
    return REST("/history").path(resourceId).query({ limit: 100 }).get().then((response) => {
      response.forEach((event) => {
        if (event.delta) {
          event.delta = transformManagedResourceDiff(event.delta);
        }
      });
      return response;
    });
  }
}

const isMonikerEqual = (a, b) => a && b && a.app === b.app && a.stack === b.stack && a.detail === b.detail;
const getResourcesOfKind = (application, kinds) => {
  const resources = application.managedResources.data.resources;
  return resources.filter(({ kind }) => kinds.includes(getKindName(kind)));
};
const addManagedResourceMetadataToServerGroups = (application) => {
  if (!SETTINGS.feature.managedResources) {
    return;
  }
  const clusterResources = getResourcesOfKind(application, ["cluster"]);
  const serverGroups = application.serverGroups.data;
  serverGroups.forEach((serverGroup) => {
    const matchingResource = clusterResources.find(({ moniker, locations: { account, regions } }) => isMonikerEqual(moniker, serverGroup.moniker) && account === serverGroup.account && regions.some(({ name }) => name === serverGroup.region));
    serverGroup.isManaged = !!matchingResource;
    serverGroup.managedResourceSummary = matchingResource;
  });
  application.serverGroups.dataUpdated();
};
const addManagedResourceMetadataToLoadBalancers = (application) => {
  if (!SETTINGS.feature.managedResources) {
    return;
  }
  const loadBalancerResources = getResourcesOfKind(application, ["classic-load-balancer", "application-load-balancer"]);
  const loadBalancers = application.loadBalancers.data;
  loadBalancers.forEach((loadBalancer) => {
    const matchingResource = loadBalancerResources.find(({ kind, moniker, locations: { account, regions } }) => loadBalancer.loadBalancerType && getKindName(kind) === getResourceKindForLoadBalancerType(loadBalancer.loadBalancerType) && isMonikerEqual(moniker, loadBalancer.moniker) && account === loadBalancer.account && regions.some(({ name }) => name === loadBalancer.region));
    loadBalancer.isManaged = !!matchingResource;
    loadBalancer.managedResourceSummary = matchingResource;
  });
  application.loadBalancers.dataUpdated();
};
const addManagedResourceMetadataToSecurityGroups = (application) => {
  if (!SETTINGS.feature.managedResources) {
    return;
  }
  const securityGroupResources = getResourcesOfKind(application, ["security-group"]);
  const securityGroups = application.securityGroups.data;
  securityGroups.forEach((securityGroup) => {
    const matchingResource = securityGroupResources.find(({ moniker, locations: { account, regions } }) => isMonikerEqual(moniker, securityGroup.moniker) && account === securityGroup.account && regions.some(({ name }) => name === securityGroup.region));
    securityGroup.isManaged = !!matchingResource;
    securityGroup.managedResourceSummary = matchingResource;
  });
  application.securityGroups.dataUpdated();
};

var managedDeliveryLogo = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2014.37557%2015.52748%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E%20%20%20%20%20%20.a%20%7B%20%20%20%20%20%20%20%20fill%3A%20%23de4d53%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.b%20%7B%20%20%20%20%20%20%20%20fill%3A%20%23eeac3c%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.c%20%7B%20%20%20%20%20%20%20%20fill%3A%20%2396c25e%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.d%20%7B%20%20%20%20%20%20%20%20fill%3A%20%2349a9df%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.e%20%7B%20%20%20%20%20%20%20%20fill%3A%20%238f429b%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.f%20%7B%20%20%20%20%20%20%20%20opacity%3A%200.25%3B%20%20%20%20%20%20%20%20fill%3A%20url%28%23a%29%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.g%20%7B%20%20%20%20%20%20%20%20fill%3A%20url%28%23b%29%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.h%20%7B%20%20%20%20%20%20%20%20fill%3A%20url%28%23c%29%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.i%20%7B%20%20%20%20%20%20%20%20fill%3A%20%23fff%3B%20%20%20%20%20%20%7D%20%20%20%20%3C%2Fstyle%3E%20%20%20%20%3ClinearGradient%20id%3D%22a%22%20x1%3D%225.51119%22%20y1%3D%229.27236%22%20x2%3D%225.9233%22%20y2%3D%229.32662%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.26839%22%20stop-color%3D%22%23441b19%22%2F%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.73261%22%20stop-color%3D%22%23441b19%22%20stop-opacity%3D%220%22%2F%3E%20%20%20%20%3C%2FlinearGradient%3E%20%20%20%20%3ClinearGradient%20id%3D%22b%22%20x1%3D%225.00789%22%20y1%3D%227.58774%22%20x2%3D%227.13963%22%20y2%3D%226.85373%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.21861%22%20stop-color%3D%22%234b0726%22%20stop-opacity%3D%220%22%2F%3E%20%20%20%20%20%20%3Cstop%20offset%3D%221%22%20stop-color%3D%22%234b0726%22%20stop-opacity%3D%220.6%22%2F%3E%20%20%20%20%3C%2FlinearGradient%3E%20%20%20%20%3ClinearGradient%20id%3D%22c%22%20x1%3D%224.24719%22%20y1%3D%2215.7319%22%20x2%3D%226.15272%22%20y2%3D%220.21263%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.35048%22%20stop-color%3D%22%23ff0%22%2F%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.40939%22%20stop-color%3D%22%23ffff1c%22%2F%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.53687%22%20stop-color%3D%22%23ffff64%22%2F%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.72174%22%20stop-color%3D%22%23ffffd5%22%2F%3E%20%20%20%20%20%20%3Cstop%20offset%3D%220.7878%22%20stop-color%3D%22%23fff%22%2F%3E%20%20%20%20%3C%2FlinearGradient%3E%20%20%3C%2Fdefs%3E%20%20%3Cpath%20class%3D%22a%22%20d%3D%22M5.7%2C15.16747a.5.5%2C0%2C0%2C0%2C.43.56H6.2a.50007.50007%2C0%2C0%2C0%2C.5-.44L7.91827%2C6.45482%2C7.198%2C4.30693Z%22%20transform%3D%22translate%28-0.7%20-0.2%29%22%2F%3E%20%20%3Cpath%20class%3D%22b%22%20d%3D%22M6.58716%2C1.48546%2C4.7%2C15.16747a.5.5%2C0%2C0%2C0%2C.43.56H5.2a.50007.50007%2C0%2C0%2C0%2C.5-.44L7.3075%2C3.63335Z%22%20transform%3D%22translate%28-0.7%20-0.2%29%22%2F%3E%20%20%3Cpath%20class%3D%22c%22%20d%3D%22M3.20043%2C15.72258a.557.557%2C0%2C0%2C1-.06885-.00488.49923.49923%2C0%2C0%2C1-.42676-.56348l2-14.50049A.49241.49241%2C0%2C0%2C1%2C5.2683.227a.4995.4995%2C0%2C0%2C1%2C.42676.56348l-2%2C14.50049A.49982.49982%2C0%2C0%2C1%2C3.20043%2C15.72258Z%22%20transform%3D%22translate%28-0.7%20-0.2%29%22%2F%3E%20%20%3Cpath%20class%3D%22d%22%20d%3D%22M2.20043%2C15.72258a.557.557%2C0%2C0%2C1-.06885-.00488.49923.49923%2C0%2C0%2C1-.42676-.56348l2-14.50049A.49241.49241%2C0%2C0%2C1%2C4.2683.227a.4995.4995%2C0%2C0%2C1%2C.42676.56348l-2%2C14.50049A.49982.49982%2C0%2C0%2C1%2C2.20043%2C15.72258Z%22%20transform%3D%22translate%28-0.7%20-0.2%29%22%2F%3E%20%20%3Cpath%20class%3D%22e%22%20d%3D%22M1.20043%2C15.72258a.557.557%2C0%2C0%2C1-.06885-.00488.49923.49923%2C0%2C0%2C1-.42676-.56348l2-14.50049A.49241.49241%2C0%2C0%2C1%2C3.2683.227a.4995.4995%2C0%2C0%2C1%2C.42676.56348l-2%2C14.50049A.49982.49982%2C0%2C0%2C1%2C1.20043%2C15.72258Z%22%20transform%3D%22translate%28-0.7%20-0.2%29%22%2F%3E%20%20%3Cpath%20class%3D%22f%22%20d%3D%22M6.6712%2C3.77776%2C6.397%2C2.95122l-1.68982%2C12.242a.49324.49324%2C0%2C0%2C0%2C.21478.43933.51145.51145%2C0%2C0%2C0%2C.16754-.31134Z%22%20transform%3D%22translate%28-0.7%20-0.2%29%22%2F%3E%20%20%3Cpolygon%20class%3D%22g%22%20points%3D%225.692%202.719%205.02%207.591%206.46%2011.721%207.11%207.005%205.692%202.719%22%2F%3E%20%20%3Cpath%20class%3D%22h%22%20d%3D%22M4.20043%2C15.72258a.557.557%2C0%2C0%2C1-.06885-.00488.49923.49923%2C0%2C0%2C1-.42676-.56348l2-14.50049A.49241.49241%2C0%2C0%2C1%2C6.2683.227a.4995.4995%2C0%2C0%2C1%2C.42676.56348l-2%2C14.50049A.49982.49982%2C0%2C0%2C1%2C4.20043%2C15.72258Z%22%20transform%3D%22translate%28-0.7%20-0.2%29%22%2F%3E%20%20%3Cpath%20class%3D%22i%22%20d%3D%22M13.07062.66277A.55391.55391%2C0%2C0%2C0%2C12.59216.2a.5261.5261%2C0%2C0%2C0-.53333.4549l-2.513%2C8.61346L6.68512.6278a.48865.48865%2C0%2C0%2C1%2C.00995.16266L6.37059%2C2.86276%2C9.101%2C11.10332a.49483.49483%2C0%2C0%2C0%2C.4834.34277.50023.50023%2C0%2C0%2C0%2C.47119-.35937l2.34375-8.00879%2C1.68115%2C12.18652a.49939.49939%2C0%2C0%2C0%2C.49463.43164.47593.47593%2C0%2C0%2C0%2C.06885-.00488.4995.4995%2C0%2C0%2C0%2C.42676-.56348Z%22%20transform%3D%22translate%28-0.7%20-0.2%29%22%2F%3E%3C%2Fsvg%3E";

const { memo } = React__default;
const traverseDiffFields = (diff, depth, rows) => {
  Object.keys(diff).sort((a, b) => a.localeCompare(b)).forEach((name) => {
    const { key, diffType, actual, desired, fields } = diff[name];
    rows.push({
      key,
      name,
      depth,
      actual,
      desired,
      type: diffType,
      isLeafNode: !fields
    });
    if (fields) {
      traverseDiffFields(fields, depth + 1, rows);
    }
  });
  return rows;
};
const tableRowsFromDiff = (diff) => traverseDiffFields(diff, 0, []);
const ManagedResourceDiffTable = memo(({ diff }) => {
  const diffRows = tableRowsFromDiff(diff);
  return /* @__PURE__ */ React__default.createElement(Table, {
    layout: minimalNativeTableLayout,
    columns: ["configuration", "change", "actual", "desired"]
  }, diffRows.map(({ key, name, depth, isLeafNode, type, actual, desired }) => /* @__PURE__ */ React__default.createElement(TableRow, {
    key
  }, /* @__PURE__ */ React__default.createElement(TableCell, {
    indent: depth
  }, /* @__PURE__ */ React__default.createElement(SingleLineString, null, name)), /* @__PURE__ */ React__default.createElement(TableCell, null, isLeafNode && /* @__PURE__ */ React__default.createElement(SingleLineString, {
    className: "text-italic"
  }, type.toLowerCase())), /* @__PURE__ */ React__default.createElement(TableCell, null, /* @__PURE__ */ React__default.createElement(BreakString, null, actual)), /* @__PURE__ */ React__default.createElement(TableCell, null, /* @__PURE__ */ React__default.createElement(BreakString, null, desired)))));
});

const TOOLTIP_DELAY_SHOW = 400;
const TOOLTIP_DELAY_HIDE = 100;
const tooltipShowHideProps = {
  delayShow: TOOLTIP_DELAY_SHOW,
  delayHide: TOOLTIP_DELAY_HIDE
};
const MODAL_MAX_WIDTH = 750;
const ACTION_BUTTON_CLASS_NAME = "btn btn-default md-btn md-action-button";
const spinnerProps = {
  size: "medium",
  fullWidth: true
};
const ABSOLUTE_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss ZZZZ";
const DOCS_URLS = {
  root: "https://www.spinnaker.io/guides/user/managed-delivery",
  pinning: "https://www.spinnaker.io/guides/user/managed-delivery/pinning/",
  gettingStarted: "https://www.spinnaker.io/guides/user/managed-delivery/getting-started/",
  markAsBad: "https://www.spinnaker.io/guides/user/managed-delivery/marking-as-bad/",
  resourceStatus: "https://www.spinnaker.io/guides/user/managed-delivery/resource-status/"
};
const getDocsUrl = (doc) => {
  var _a, _b;
  return ((_b = (_a = SETTINGS.managedDelivery) == null ? void 0 : _a.urls) == null ? void 0 : _b[doc]) || DOCS_URLS[doc];
};

const TIMEZONE = SETTINGS.feature.displayTimestampsInUserLocalTime ? void 0 : SETTINGS.defaultTimeZone;
const DurationRender = ({ startedAt, completedAt }) => {
  const [, setRefresh] = React__default.useState(false);
  useInterval(() => {
    if (!completedAt) {
      setRefresh((state) => !state);
    }
  }, !completedAt ? 1e3 : 0);
  const startAtDateTime = DateTime.fromISO(startedAt);
  const endTime = !completedAt ? DateTime.utc() : DateTime.fromISO(completedAt);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, timeDiffToString(startAtDateTime, endTime));
};
const toDateTime = (timestamp) => typeof timestamp === "number" ? DateTime.fromMillis(timestamp) : typeof timestamp === "string" ? DateTime.fromISO(timestamp) : timestamp;
const formatToRelativeTimestamp = (timestamp, withSuffix) => {
  const distance = getDistanceFromNow(timestamp);
  const suffix = withSuffix ? " ago" : "";
  if (distance.years || distance.months) {
    let currentTime = DateTime.local();
    if (TIMEZONE) {
      currentTime = currentTime.setZone(TIMEZONE);
    }
    if (timestamp.year === currentTime.year) {
      return timestamp.toFormat("MMM d");
    } else {
      return timestamp.toFormat("MMM d, y");
    }
  } else if (distance.days) {
    return distance.toFormat("d") + "d" + suffix;
  } else if (distance.hours) {
    return distance.toFormat("h") + "h" + suffix;
  } else if (distance.minutes) {
    return distance.toFormat("m") + "m" + suffix;
  } else if (distance.seconds) {
    return distance.toFormat("s") + "s" + suffix;
  } else {
    return null;
  }
};
const getDistanceFromNow = (timestamp) => timestamp.diffNow().negate().shiftTo("years", "months", "days", "hours", "minutes", "seconds");
const RelativeTimestamp = memo$1(({
  timestamp: originalTimestamp,
  clickToCopy,
  delayShow,
  removeStyles,
  withSuffix = false
}) => {
  const dateTimeTimestamp = toDateTime(originalTimestamp);
  const timestamp = TIMEZONE ? dateTimeTimestamp.setZone(TIMEZONE) : dateTimeTimestamp;
  const [formattedTimestamp, setFormattedTimestamp] = useState$b(formatToRelativeTimestamp(timestamp, withSuffix));
  const updateTimestamp = () => {
    setFormattedTimestamp(formatToRelativeTimestamp(timestamp, withSuffix));
  };
  useInterval(updateTimestamp, 1e3);
  useEffect$a(updateTimestamp, [timestamp]);
  if (!formattedTimestamp) {
    return null;
  }
  const absoluteTimestamp = timestamp.toFormat(ABSOLUTE_TIME_FORMAT);
  const relativeTimestamp = /* @__PURE__ */ React__default.createElement("span", {
    className: removeStyles ? void 0 : "text-regular text-italic",
    style: removeStyles ? void 0 : { fontSize: 13, lineHeight: 1 }
  }, formattedTimestamp);
  if (clickToCopy) {
    return /* @__PURE__ */ React__default.createElement(CopyToClipboard, {
      buttonInnerNode: relativeTimestamp,
      text: absoluteTimestamp,
      toolTip: `${absoluteTimestamp} (click to copy)`
    });
  } else {
    return /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: absoluteTimestamp,
      delayShow
    }, relativeTimestamp);
  }
});

const eventLevelToClass = {
  WARNING: "event-warning",
  ERROR: "event-error",
  SUCCESS: "event-success"
};
const ExpandedRowContent = ({ level, diff, tasks, dismissModal, message }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-v left"
  }, message && /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("sp-padding-xs-yaxis", eventLevelToClass[level])
  }, message), tasks && /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-v"
  }, tasks.map(({ id, name }) => /* @__PURE__ */ React__default.createElement(UISref, {
    key: id,
    to: "home.applications.application.tasks.taskDetails",
    params: { taskId: id }
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "sp-padding-xs-yaxis",
    onClick: () => dismissModal == null ? void 0 : dismissModal()
  }, name)))), diff && /* @__PURE__ */ React__default.createElement(ManagedResourceDiffTable, {
    diff
  }));
};
const HistoryEventRow = React__default.memo(({ event, dismissModal }) => {
  const { timestamp, delta, tasks, message, reason, exceptionMessage, level } = event;
  const eventDate = React__default.useMemo(() => DateTime.fromISO(timestamp), [timestamp]);
  const hasDetails = delta || tasks || message || reason || exceptionMessage;
  return /* @__PURE__ */ React__default.createElement(TableRow, {
    renderExpandedContent: hasDetails ? () => /* @__PURE__ */ React__default.createElement(ExpandedRowContent, {
      level: event.level,
      diff: delta,
      tasks,
      message: message || reason || exceptionMessage,
      dismissModal
    }) : void 0
  }, /* @__PURE__ */ React__default.createElement(TableCell, null, /* @__PURE__ */ React__default.createElement("span", {
    className: classNames(eventLevelToClass[level] || "event-info", "event-level")
  }, event.level)), /* @__PURE__ */ React__default.createElement(TableCell, null, /* @__PURE__ */ React__default.createElement("span", {
    className: "event-type"
  }, event.displayName)), /* @__PURE__ */ React__default.createElement(TableCell, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle wrap"
  }, /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: eventDate,
    clickToCopy: true
  }))));
}, isEqual$1);

var css_248z$1N = ".ManagedResourceHistoryModal {\n  width: 100%;\n}\n.ManagedResourceHistoryModal .event-type {\n  color: var(--color-charcoal);\n}\n.ManagedResourceHistoryModal .event-level {\n  font-size: 12px;\n  line-height: 1;\n}\n.ManagedResourceHistoryModal .event-type-icon {\n  font-size: 18px;\n}\n.ManagedResourceHistoryModal .event-time {\n  white-space: nowrap;\n}\n.ManagedResourceHistoryModal .event-info {\n  color: var(--color-charcoal);\n}\n.ManagedResourceHistoryModal .event-success {\n  color: var(--color-success);\n}\n.ManagedResourceHistoryModal .event-warning {\n  color: var(--color-alert);\n}\n.ManagedResourceHistoryModal .event-error {\n  color: var(--color-danger);\n}\n.ManagedResourceHistoryModal .loading-error-message {\n  color: var(--color-danger);\n}\n";
styleInject(css_248z$1N);

const EVENT_POLLING_INTERVAL = 10 * 1e3;
const showManagedResourceHistoryModal = (props) => showModal(ManagedResourceHistoryModal, props);
const tableLayout = standardGridTableLayout([{ unit: "px", size: 70 }, 8, 1.5]);
const ManagedResourceHistoryModal = ({ id, displayName, dismissModal }) => {
  const { status: historyEventStatus, result: historyEvents, refresh } = usePollingData(() => ManagedReader.getResourceHistory(id), null, EVENT_POLLING_INTERVAL, []);
  const isLoading = !historyEvents && ["NONE", "PENDING"].includes(historyEventStatus);
  const shouldShowExistingData = !isLoading && historyEventStatus !== "REJECTED";
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ModalHeader, null, "Resource history - ", displayName), /* @__PURE__ */ React__default.createElement(ModalBody, null, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("ManagedResourceHistoryModal", {
      "flex-container-h middle center flex-grow": !shouldShowExistingData
    })
  }, isLoading && /* @__PURE__ */ React__default.createElement(Spinner, {
    size: "medium"
  }), historyEventStatus === "REJECTED" && /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-v middle center"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "loading-error-message text-semibold sp-margin-m-bottom"
  }, "Something went wrong."), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: refresh
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-xs fa-sync-alt sp-margin-xs-right"
  }), " Try again")), shouldShowExistingData && /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement(Table, {
    layout: tableLayout,
    columns: ["Level", "Event", "Time"],
    expandable: historyEvents == null ? void 0 : historyEvents.some(({ delta, tasks, message, reason, exceptionMessage }) => delta || tasks || message || reason || exceptionMessage)
  }, (historyEvents || []).map((event) => /* @__PURE__ */ React__default.createElement(HistoryEventRow, {
    key: event.type + event.timestamp,
    event,
    dismissModal
  })))))));
};

var css_248z$1M = ".ManagedResourceDetailsIndicator {\n  background-color: var(--color-mineshaft);\n  color: var(--color-white);\n}\n\n.ManagedResourceDetailsIndicator .md-logo {\n  background-color: var(--color-black);\n  padding: 18px;\n}\n\n.ManagedResourceDetailsIndicator .summary-message {\n  font-size: 12px;\n  font-weight: 300;\n}\n\n.ManagedResourceDetailsIndicator .resource-actions > .dropdown-toggle {\n  color: var(--color-white);\n  background-color: transparent;\n  padding: 3px 10px;\n}\n";
styleInject(css_248z$1M);

const logClick$2 = (label, resourceId) => logger.log({
  category: "Managed Resource Menu",
  action: `${label} clicked`,
  data: { label: resourceId }
});
const ManagedResourceDetailsIndicator = ({
  resourceSummary,
  application
}) => {
  if (!resourceSummary) {
    return null;
  }
  const { id, isPaused } = resourceSummary;
  const helpText = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker is managing this resource.")), /* @__PURE__ */ React__default.createElement("p", null, "If a difference from the desired state is detected, Spinnaker will act to correct it.", " ", /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    onClick: () => logClick$2("Learn More", id),
    href: getDocsUrl("root")
  }, "Learn More")));
  const allowNavigation = (e) => {
    const target = e.target;
    const href = target == null ? void 0 : target.getAttribute("href");
    if (href) {
      window.location.href = href;
    }
  };
  const appPausedHelpContent = `
    <p>Resource management is currently disabled for the entire application.
    <a
      href=${ReactInjector.$state.href("home.applications.application.config", {
    section: "managed-resources"
  })}
    >
      Resume application management
    </a>
</p>`;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle ManagedResourceDetailsIndicator"
  }, /* @__PURE__ */ React__default.createElement(HoverablePopover, {
    template: helpText,
    placement: "left"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "md-logo flex-container-h middle"
  }, /* @__PURE__ */ React__default.createElement("img", {
    src: managedDeliveryLogo,
    width: "36px"
  }))), /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-v middle flex-1 sp-margin-l-left"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "summary-message sp-margin-s-bottom"
  }, "Managed by Spinnaker"), /* @__PURE__ */ React__default.createElement(Dropdown, {
    className: "resource-actions sp-margin-xs-bottom flex-pull-left",
    id: "server-group-managed-resource-dropdown",
    pullRight: true
  }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
    className: "btn btn-sm btn-default dropdown-toggle"
  }, "Resource Actions"), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, {
    className: "dropdown-menu"
  }, !application.isManagementPaused && /* @__PURE__ */ React__default.createElement(MenuItem, {
    onClick: () => toggleResourcePause(resourceSummary, application)
  }, isPaused ? "Resume " : "Pause ", " Management"), application.isManagementPaused && /* @__PURE__ */ React__default.createElement(MenuItem, {
    disabled: true,
    onClick: allowNavigation
  }, "Resume Management ", /* @__PURE__ */ React__default.createElement(HelpField, {
    content: appPausedHelpContent
  })), /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("a", {
    onClick: () => {
      showManagedResourceHistoryModal(resourceSummary);
      logClick$2("History", id);
    }
  }, "History")), /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    onClick: () => logClick$2("Raw Source", id),
    href: `${SETTINGS.gateUrl}/managed/resources/${id}`
  }, "Raw Source"))))));
};

const MANAGED_RESOURCE_DETAILS_INDICATOR = "spinnaker.core.managed.resourceDetailsIndicator.component";
module(MANAGED_RESOURCE_DETAILS_INDICATOR, []).component("managedResourceDetailsIndicator", react2angular(withErrorBoundary(ManagedResourceDetailsIndicator, "managedResourceDetailsIndicator"), [
  "resourceSummary",
  "application"
]));

const logClick$1 = (label, resourceId, status) => logger.log({
  category: "Managed Resource Status Indicator",
  action: `${label} clicked`,
  data: { label: `${resourceId},${status}` }
});
const LearnMoreLink = ({ resourceSummary }) => /* @__PURE__ */ React__default.createElement("a", {
  target: "_blank",
  onClick: () => logClick$1("Status docs link", resourceSummary.id, resourceSummary.status),
  href: `${getDocsUrl("resourceStatus")}#${resourceSummary.status.toLowerCase().replace("_", "-")}`
}, "Learn more");
const viewConfigurationByStatus = {
  DELETING: {
    appearance: "warning",
    iconName: "mdActuating",
    popoverContents: () => /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker is deleting this temporary managed resource"))
  },
  ACTUATING: {
    appearance: "info",
    iconName: "mdActuating",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker is taking action to resolve a difference from this resource's desired state.")), /* @__PURE__ */ React__default.createElement("p", null, "You can click History to see more. ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  CREATED: {
    appearance: "info",
    iconName: "mdCreated",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker has started managing this resource.")), /* @__PURE__ */ React__default.createElement("p", null, "If a difference from the desired state is detected, Spinnaker will act to correct it.", " ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  DIFF: {
    appearance: "info",
    iconName: "mdDiff",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker detected a difference from the desired state.")), /* @__PURE__ */ React__default.createElement("p", null, "In a moment, Spinnaker will take action to bring this resource back to its desired state. You can click History to see more. ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  DIFF_NOT_ACTIONABLE: {
    appearance: "warning",
    iconName: "mdDiff",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker detected a difference from the desired state, but can't take action to resolve it.")), /* @__PURE__ */ React__default.createElement("p", null, "Spinnaker doesn't have a way of resolving this kind of difference. Manual action might be required. You can click History to see more. ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  CURRENTLY_UNRESOLVABLE: {
    appearance: "warning",
    iconName: "mdError",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Waiting for a temporary issue to pass.")), /* @__PURE__ */ React__default.createElement("p", null, "Something required for management is temporarily experiencing issues. Spinnaker can't take action right now, but should be able to soon. You can click History to see more.", " ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  MISSING_DEPENDENCY: {
    appearance: "warning",
    iconName: "mdError",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Waiting for a missing dependency to become available.")), /* @__PURE__ */ React__default.createElement("p", null, "Something required for management isn't ready yet. Spinnaker can't take action right now, but will resume once the missing dependencies exist. You can click History to see more.", " ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  ERROR: {
    appearance: "error",
    iconName: "mdError",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Something went wrong.")), /* @__PURE__ */ React__default.createElement("p", null, "Something went wrong while trying to check this resource's current state. Spinnaker can't take action right now, and manual intervention might be required. You can click History to see more.", " ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  HAPPY: {
    appearance: "info",
    iconName: "md",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker is managing this resource.")), /* @__PURE__ */ React__default.createElement("p", null, "If a difference from the desired state is detected, Spinnaker will act to correct it.", " ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  PAUSED: {
    appearance: "warning",
    iconName: "mdPaused",
    popoverContents: (resourceSummary, application) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Management is paused.")), application.isManagementPaused && /* @__PURE__ */ React__default.createElement("p", null, "Spinnaker is configured to manage this resource, but management for the entire application is temporarily paused. ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })), !application.isManagementPaused && /* @__PURE__ */ React__default.createElement("p", null, "Spinnaker is configured to manage this resource, but management has been temporarily paused.", " ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  RESUMED: {
    appearance: "info",
    iconName: "mdResumed",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Management was just resumed.")), /* @__PURE__ */ React__default.createElement("p", null, "Management was resumed after being temporarily paused. If Spinnaker detects that a difference from the desired state occurred while paused, it will act to correct it. ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  UNHAPPY: {
    appearance: "error",
    iconName: "mdUnhappy",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker detected a difference from the desired state, but hasn't been able to correct it.")), /* @__PURE__ */ React__default.createElement("p", null, "Spinnaker has been trying to correct a difference, but taking action hasn't helped. Manual intervention might be required. You can click History to see more. ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  UNKNOWN: {
    appearance: "warning",
    iconName: "mdUnknown",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Unable to determine resource status.")), /* @__PURE__ */ React__default.createElement("p", null, "Spinnaker is configured to manage this resource, but can't calculate its current status.", " ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  },
  WAITING: {
    appearance: "info",
    iconName: "mdCreated",
    popoverContents: (resourceSummary) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Waiting for information.")), /* @__PURE__ */ React__default.createElement("p", null, "This resource is part of a brand new environment. Spinnaker is waiting for an artifact to become available to deploy. It normally takes less than 5 minutes for a newly created artifact to be seen, and after that all constraints need to pass in order for it to start deploying. You can click History to see a more detailed message. ", /* @__PURE__ */ React__default.createElement(LearnMoreLink, {
      resourceSummary
    })))
  }
};

const PopoverActions = ({
  resourceSummary,
  application,
  hidePopover
}) => {
  const historyButton = /* @__PURE__ */ React__default.createElement("button", {
    className: "passive flex-none",
    onClick: () => {
      hidePopover == null ? void 0 : hidePopover();
      showManagedResourceHistoryModal(resourceSummary);
    }
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-history"
  }), " History");
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "horizontal right"
  }, /* @__PURE__ */ React__default.createElement("p", {
    className: "flex-container-h middle sp-margin-m-top sp-margin-xs-bottom sp-group-margin-s-xaxis"
  }, historyButton, !resourceSummary.isPaused && /* @__PURE__ */ React__default.createElement("button", {
    className: "passive flex-none",
    onClick: () => toggleResourcePause(resourceSummary, application, hidePopover)
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-pause"
  }), " Pause management of this resource"), resourceSummary.isPaused && !application.isManagementPaused && /* @__PURE__ */ React__default.createElement("button", {
    className: "passive flex-none",
    onClick: () => toggleResourcePause(resourceSummary, application, hidePopover)
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-play"
  }), " Resume management of this resource"), application.isManagementPaused && /* @__PURE__ */ React__default.createElement(UISref, {
    to: "home.applications.application.config",
    params: { section: "managed-resources" }
  }, /* @__PURE__ */ React__default.createElement("a", null, "Resume application management"))));
};
const ManagedResourceStatusPopover = ({
  application,
  children,
  placement,
  resourceSummary
}) => {
  const { status } = resourceSummary;
  const PopoverContents = ({ hidePopover }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, viewConfigurationByStatus[status].popoverContents(resourceSummary, application), /* @__PURE__ */ React__default.createElement(PopoverActions, {
    resourceSummary,
    application,
    hidePopover
  }));
  return /* @__PURE__ */ React__default.createElement(HoverablePopover, {
    Component: PopoverContents,
    delayHide: 200,
    delayShow: 200,
    placement
  }, children);
};

const ManagedResourceStatusIndicator = ({
  shape,
  resourceSummary,
  application
}) => {
  const { status } = resourceSummary;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h stretch ManagedResourceStatusIndicator"
  }, /* @__PURE__ */ React__default.createElement(ManagedResourceStatusPopover, {
    application,
    placement: "left",
    resourceSummary
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("flex-container-h middle", shape, viewConfigurationByStatus[status].appearance)
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    appearance: "light",
    name: viewConfigurationByStatus[status].iconName,
    size: "small"
  }))));
};

const MANAGED_RESOURCES_DATA_SOURCE = "spinnaker.core.managed.dataSource";
module(MANAGED_RESOURCES_DATA_SOURCE, []).run([
  "$q",
  ($q) => {
    if (!SETTINGS.feature.managedResources) {
      return;
    }
    const loadManagedResources = (application) => {
      return ManagedReader.getApplicationSummary(application.name);
    };
    const addManagedResources = (application, data) => {
      application.isManagementPaused = data.applicationPaused;
      return $q.when(data);
    };
    const addManagedMetadataToResources = (application) => {
      application.serverGroups.ready().then(() => addManagedResourceMetadataToServerGroups(application), noop);
      application.loadBalancers.ready().then(() => addManagedResourceMetadataToLoadBalancers(application), noop);
      application.securityGroups.ready().then(() => addManagedResourceMetadataToSecurityGroups(application), noop);
    };
    ApplicationDataSourceRegistry.registerDataSource({
      key: "managedResources",
      visible: false,
      loader: loadManagedResources,
      onLoad: addManagedResources,
      afterLoad: addManagedMetadataToResources,
      defaultData: { applicationPaused: false, hasManagedResources: false, resources: [] }
    });
    ApplicationDataSourceRegistry.registerDataSource({
      key: "environments",
      sref: ".environments",
      category: DELIVERY_KEY,
      optional: true,
      optIn: true,
      label: "Environments",
      icon: "fa fa-fw fa-xs fa-code-branch",
      iconName: "spEnvironments",
      description: "Artifacts and environments managed by Spinnaker",
      defaultData: {
        applicationPaused: false,
        hasManagedResources: false,
        environments: [],
        artifacts: [],
        resources: []
      }
    });
  }
]);

const getElementDimensions = (ref) => ref.current ? { width: ref.current.offsetWidth, height: ref.current.offsetHeight } : { width: 0, height: 0 };
const useDimensions = (ref, {
  delay = 100,
  isActive = true
}) => {
  const [dimension, setDimension] = React__default.useState(getElementDimensions(ref));
  React__default.useLayoutEffect(() => {
    const debouncedResizeHandler = debounce(() => {
      setDimension(getElementDimensions(ref));
    }, delay, { leading: true });
    if (isActive && ref.current) {
      const observer = new ResizeObserver(debouncedResizeHandler);
      observer.observe(ref.current);
      return () => observer.disconnect();
    } else {
      return () => {
      };
    }
  }, [delay, isActive, ref.current]);
  return dimension;
};

const CATEGORY_PREFIX = "MD__";
const useLogEvent = (category, action) => {
  const app = useApplicationContext();
  const logFn = React__default.useCallback((props) => {
    logger.log({
      ...props,
      category: `${CATEGORY_PREFIX}${category}`,
      action: (props == null ? void 0 : props.action) || action || "",
      data: { label: props == null ? void 0 : props.label, application: app == null ? void 0 : app.name, ...props == null ? void 0 : props.data }
    });
  }, [app == null ? void 0 : app.name, category, action]);
  return logFn;
};

const STORAGE_KEY = "MD_environmentsDirection";
const DIRECTIONS = ["listView", "gridView"];
const isDirection = (value) => {
  return Boolean(value && DIRECTIONS.includes(value));
};
const storedDirection = localStorage.getItem(STORAGE_KEY);
const environmentsDirectionState = atom({
  key: "environmentsDisplay",
  default: isDirection(storedDirection) ? storedDirection : "gridView"
});
const useEnvironmentDirectionState = () => {
  const [direction, setDirection] = useRecoilState(environmentsDirectionState);
  React__default.useEffect(() => {
    localStorage.setItem(STORAGE_KEY, direction);
  }, [direction]);
  return { direction, setDirection };
};
const EnvironmentsDirectionController = () => {
  const { direction, setDirection } = useEnvironmentDirectionState();
  const logEvent = useLogEvent("environmentsDirection");
  React__default.useEffect(() => {
    logEvent({ action: direction });
  }, [direction]);
  return /* @__PURE__ */ React__default.createElement("button", {
    type: "button",
    className: "btn env-direction-btn",
    onClick: () => setDirection((state) => state === "listView" ? "gridView" : "listView")
  }, direction === "listView" ? "Grid view" : "List view", /* @__PURE__ */ React__default.createElement("i", {
    className: classNames(direction === "listView" ? "fas fa-columns" : "far fa-list-alt", "sp-margin-xs-left")
  }));
};
const MIN_WIDTH_PER_COLUMN = 500;
const useOrderedEnvironment = (ref, environments) => {
  const { direction } = useEnvironmentDirectionState();
  const { width } = useDimensions(ref, { isActive: direction === "gridView" });
  const numColumns = Math.min(Math.round(width / MIN_WIDTH_PER_COLUMN), environments.length);
  const orderedEnvironments = direction === "gridView" ? reverse(environments) : environments;
  const style = direction === "gridView" ? { gridTemplateColumns: `repeat(${numColumns}, 1fr)` } : {};
  const className = direction === "gridView" ? "grid-view" : void 0;
  return { environments: orderedEnvironments, style, className };
};
const EnvironmentsRender = React__default.forwardRef(({ className, style, children }, ref) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    ref,
    className: classNames(className, "environments-list"),
    style
  }, children);
});

var css_248z$1L = ".HorizontalTabs {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  border-bottom: 1px solid var(--color-alto);\n  margin-bottom: var(--xl-spacing);\n}\n.HorizontalTabs .tab {\n  background: none;\n  border: none;\n  padding: 0;\n  min-width: 150px;\n  max-width: 33%;\n  padding: var(--xs-spacing) var(--m-spacing);\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  border-bottom: 3px solid transparent;\n  color: var(--color-concrete);\n  text-align: center;\n}\n@media (max-width: 768px) {\n  .HorizontalTabs .tab {\n    min-width: 80px;\n  }\n}\n.HorizontalTabs .tab:focus:active {\n  text-decoration: none;\n}\n.HorizontalTabs .tab:hover {\n  text-decoration: none;\n  color: var(--color-dovegray);\n  border-bottom: 3px solid var(--color-accent-g2);\n}\n.HorizontalTabs .tab.selected-tab {\n  border-bottom: 3px solid var(--color-accent);\n  color: var(--color-black);\n}\n.HorizontalTabs .right-element {\n  margin-left: auto;\n  align-self: center;\n}\n";
styleInject(css_248z$1L);

const HorizontalTabs = ({ tabs, className, onClick, rightElement }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames(className, "HorizontalTabs")
  }, tabs.map((tab) => /* @__PURE__ */ React__default.createElement(TabTitle, {
    key: tab.path,
    data: tab,
    onClick
  })), rightElement && /* @__PURE__ */ React__default.createElement("div", {
    className: "right-element"
  }, rightElement));
};
const TabTitle = ({ data, onClick }) => {
  const sRefProps = useSrefActive(data.path, {}, "selected-tab");
  return /* @__PURE__ */ React__default.createElement("a", {
    href: sRefProps.href,
    className: classNames("tab", sRefProps.className),
    onClick: (e) => {
      sRefProps.onClick(e);
      onClick == null ? void 0 : onClick(data);
    }
  }, data.title);
};

const debugFeatureFlag = {
  key: "MD_debug",
  value: "1"
};
const getIsDebugMode = () => {
  return localStorage.getItem(debugFeatureFlag.key) === debugFeatureFlag.value;
};
const setDebugMode = (isDebug) => {
  if (isDebug) {
    localStorage.setItem(debugFeatureFlag.key, debugFeatureFlag.value);
  } else {
    localStorage.removeItem(debugFeatureFlag.key);
  }
};

var css_248z$1K = ".Environments {\n  width: 100%;\n  padding: 0 var(--l-spacing);\n  --base-horizontal-padding: 20px;\n}\n@media (max-width: 768px) {\n  .Environments {\n    padding: 0;\n    --base-horizontal-padding: var(--m-spacing);\n  }\n}\n.Environments a,\n.Environments .btn-link {\n  color: var(--color-text-link-g1);\n}\n.Environments a:focus,\n.Environments .btn-link:focus,\n.Environments a:active,\n.Environments .btn-link:active {\n  outline: none;\n  box-shadow: none;\n}\n.Environments a:focus:active,\n.Environments .btn-link:focus:active {\n  outline: none;\n  box-shadow: none;\n}\n.Environments .env-direction-btn {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  line-height: 1;\n  padding: var(--xs-spacing);\n  background-color: transparent;\n  color: var(--color-dovegray);\n}\n.Environments .env-direction-btn > i {\n  margin-top: 1px;\n  font-size: 16px;\n}\n.Environments .env-direction-btn:focus,\n.Environments .env-direction-btn:active:focus {\n  outline: none;\n}\n@media (max-width: 768px) {\n  .Environments .env-direction-btn {\n    display: none;\n  }\n}\n.Environments .environments-list {\n  width: 100%;\n  display: grid;\n  gap: var(--m-spacing);\n  align-items: flex-start;\n  --row-element-icon-width: 32px;\n}\n.Environments .environments-list.grid-view {\n  gap: var(--xl-spacing) var(--m-spacing);\n  --row-element-icon-width: 26px;\n}\n.ui-switcher {\n  background-color: var(--color-white);\n  padding: var(--xs-spacing) var(--s-spacing);\n  position: absolute;\n  border-radius: 4px;\n  border: 1px solid var(--color-alto);\n  bottom: 4px;\n  right: 30px;\n}\n@media (max-width: 768px) {\n  .ui-switcher {\n    right: 8px;\n  }\n}\n";
styleInject(css_248z$1K);

var css_248z$1J = ".Environments .environment-row-element,\n.ActionModal .environment-row-element {\n  display: grid;\n  grid-template-columns: [icon] var(--row-element-icon-width) [details] 1fr;\n  position: relative;\n}\n.Environments .environment-row-element.with-padding,\n.ActionModal .environment-row-element.with-padding {\n  padding: var(--l-spacing) var(--base-horizontal-padding) var(--s-spacing) var(--base-horizontal-padding);\n}\n@media (max-width: 768px) {\n  .Environments .environment-row-element,\n  .ActionModal .environment-row-element {\n    grid-template-columns: [icon] 30px [details] 1fr;\n  }\n}\n.Environments .environment-row-element .no-items-message,\n.ActionModal .environment-row-element .no-items-message {\n  grid-column: 1 / 3;\n}\n.Environments .environment-row-element .row-details,\n.ActionModal .environment-row-element .row-details {\n  grid-column: details;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.Environments .environment-row-element .row-icon,\n.ActionModal .environment-row-element .row-icon {\n  grid-column: icon;\n  display: flex;\n  align-self: flex-start;\n  padding-top: var(--2xs-spacing);\n}\n.Environments .environment-row-element .row-icon.small,\n.ActionModal .environment-row-element .row-icon.small {\n  padding-top: var(--3xs-spacing);\n}\n.Environments .environment-row-element .row-title,\n.ActionModal .environment-row-element .row-title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--color-charcoal);\n  display: grid;\n  grid-template-columns: 1fr auto;\n}\n.Environments .environment-row-element .row-title.small,\n.ActionModal .environment-row-element .row-title.small {\n  font-size: 14px;\n}\n.Environments .environment-row-element .row-title > a,\n.ActionModal .environment-row-element .row-title > a {\n  color: inherit;\n}\n.Environments .md-icon-success,\n.ActionModal .md-icon-success {\n  color: var(--color-status-success);\n}\n.Environments .md-icon-pending,\n.ActionModal .md-icon-pending {\n  color: var(--color-titanium);\n}\n.Environments .md-icon-fail,\n.ActionModal .md-icon-fail {\n  color: var(--color-status-error);\n}\n.Environments .delimited-element:not(:last-child),\n.ActionModal .delimited-element:not(:last-child) {\n  margin-right: 6px;\n}\n.Environments .delimited-element:not(:first-child)::before,\n.ActionModal .delimited-element:not(:first-child)::before {\n  content: '•';\n  margin-right: 6px;\n}\n.Environments .delimited-elements > *:not(:last-child),\n.ActionModal .delimited-elements > *:not(:last-child) {\n  margin-right: 6px;\n}\n.Environments .delimited-elements > *:not(:first-child)::before,\n.ActionModal .delimited-elements > *:not(:first-child)::before {\n  content: '•';\n  margin-right: 6px;\n}\n.Environments .truncate,\n.ActionModal .truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.Environments button.md-btn,\n.ActionModal button.md-btn {\n  background-color: transparent;\n  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.03);\n}\n.Environments button.md-btn:hover,\n.ActionModal button.md-btn:hover {\n  background-color: var(--color-cirrus);\n}\n.Environments button.md-btn:active,\n.ActionModal button.md-btn:active,\n.Environments button.md-btn:focus,\n.ActionModal button.md-btn:focus {\n  outline: none;\n}\n.Environments button.md-btn-accent,\n.ActionModal button.md-btn-accent,\n.Environments button.md-btn-accent:hover,\n.ActionModal button.md-btn-accent:hover {\n  color: var(--color-accent);\n  border-color: var(--color-accent);\n}\n.Environments button.md-btn-success,\n.ActionModal button.md-btn-success,\n.Environments button.md-btn-success:hover,\n.ActionModal button.md-btn-success:hover {\n  color: var(--color-validation-success);\n  border-color: var(--color-validation-success);\n}\n.Environments button.md-btn-danger,\n.ActionModal button.md-btn-danger,\n.Environments button.md-btn-danger:hover,\n.ActionModal button.md-btn-danger:hover {\n  color: var(--color-danger);\n  border: 1px solid var(--color-danger);\n}\n.Environments .md-action-button,\n.ActionModal .md-action-button {\n  padding: 0 var(--xs-spacing);\n  text-transform: uppercase;\n  color: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 2px var(--s-spacing);\n  color: var(--color-primary-g1);\n  letter-spacing: 0.2px;\n}\n.Environments .md-action-button:hover,\n.ActionModal .md-action-button:hover {\n  background-color: var(--color-alabaster);\n}\n.Environments .no-underline,\n.ActionModal .no-underline {\n  text-decoration: none;\n}\n.Environments .md-actions-gap,\n.ActionModal .md-actions-gap {\n  gap: var(--s-spacing);\n}\n.Environments .in-progress-dot,\n.ActionModal .in-progress-dot {\n  height: 8px;\n  width: 8px;\n  border-radius: 999px;\n  display: flex;\n  -webkit-animation: deployingAnimation 2s infinite;\n          animation: deployingAnimation 2s infinite;\n}\n@-webkit-keyframes deployingAnimation {\n  0% {\n    background-color: var(--color-status-success);\n  }\n  50% {\n    background-color: var(--color-status-success-light);\n  }\n  100% {\n    background-color: var(--color-status-success);\n  }\n}\n@keyframes deployingAnimation {\n  0% {\n    background-color: var(--color-status-success);\n  }\n  50% {\n    background-color: var(--color-status-success-light);\n  }\n  100% {\n    background-color: var(--color-status-success);\n  }\n}\n@-webkit-keyframes deletingAnimation {\n  0% {\n    background-color: var(--color-danger);\n  }\n  50% {\n    background-color: var(--color-danger-medium);\n  }\n  100% {\n    background-color: var(--color-danger);\n  }\n}\n@keyframes deletingAnimation {\n  0% {\n    background-color: var(--color-danger);\n  }\n  50% {\n    background-color: var(--color-danger-medium);\n  }\n  100% {\n    background-color: var(--color-danger);\n  }\n}\n";
styleInject(css_248z$1J);

const tabsInternal = {
  overview: "Overview",
  history: "History",
  config: "Configuration"
};
const tabs = Object.entries(tabsInternal).map(([key, title]) => ({ title, path: `.${key}` }));
const Environments = () => {
  var _a;
  const logEvent = useLogEvent("EnvironmentsTab");
  const { state, params } = useCurrentStateAndParams();
  React__default.useEffect(() => {
    if (params.md_debug === "enabled") {
      setDebugMode(true);
    } else if (params.md_debug === "disabled") {
      setDebugMode(false);
    }
  }, [params]);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "vertical Environments"
  }, /* @__PURE__ */ React__default.createElement(HorizontalTabs, {
    tabs,
    rightElement: !((_a = state.name) == null ? void 0 : _a.endsWith(".config")) ? /* @__PURE__ */ React__default.createElement(EnvironmentsDirectionController, null) : void 0,
    onClick: ({ title, path }) => {
      logEvent({ action: `Open_${title}`, data: { path } });
    }
  }), /* @__PURE__ */ React__default.createElement(UIView, null), /* @__PURE__ */ React__default.createElement("div", {
    style: { minHeight: 32, minWidth: 32 }
  }));
};

const UnmanagedMessage = () => {
  const gettingStartedLink = getDocsUrl("gettingStarted");
  return /* @__PURE__ */ React__default.createElement("div", {
    style: { width: "100%" }
  }, "Welcome! This application does not have any environments or artifacts. Check out the", " ", /* @__PURE__ */ React__default.createElement("a", {
    href: gettingStartedLink,
    target: "_blank"
  }, "getting started guide"), " ", "to set some up!");
};

const ApplicationQueryError = ({ hasApplicationData, error }) => {
  const logEvent = useLogEvent("Error", "AppQuery");
  React__default.useEffect(() => {
    if (error && hasApplicationData) {
      logEvent({ level: "ERROR", error });
    }
  }, [error, logEvent, hasApplicationData]);
  if (!hasApplicationData) {
    return /* @__PURE__ */ React__default.createElement(UnmanagedMessage, null);
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    style: { width: "100%" }
  }, "Failed to load application data, please refresh and try again.", /* @__PURE__ */ React__default.createElement("p", null, error.message));
};

const defaultOptions = {};
const ActionDetailsFragmentDoc = gql`
  fragment actionDetails on MdAction {
    id
    actionId
    actionType
    status
    startedAt
    completedAt
    link
  }
`;
const DetailedVersionFieldsFragmentDoc = gql`
  fragment detailedVersionFields on MdArtifactVersionInEnvironment {
    id
    buildNumber
    version
    createdAt
    status
    isCurrent
    gitMetadata {
      commit
      author
      branch
      commitInfo {
        sha
        link
        message
      }
      pullRequest {
        number
        link
      }
      comparisonLinks {
        toPreviousVersion
        toCurrentVersion
      }
    }
    deployedAt
    lifecycleSteps {
      startedAt
      completedAt
      type
      status
      link
    }
    constraints {
      type
      status
      judgedBy
      judgedAt
      attributes
    }
    verifications {
      ...actionDetails
    }
    postDeploy {
      ...actionDetails
    }
    veto {
      vetoedBy
      vetoedAt
      comment
    }
  }
  ${ActionDetailsFragmentDoc}
`;
const ArtifactPinnedVersionFieldsFragmentDoc = gql`
  fragment artifactPinnedVersionFields on MdArtifact {
    pinnedVersion {
      id
      version
      buildNumber
      pinnedAt
      pinnedBy
      comment
      gitMetadata {
        commitInfo {
          message
        }
      }
    }
  }
`;
const BaseEnvironmentFieldsFragmentDoc = gql`
  fragment baseEnvironmentFields on MdEnvironment {
    id
    name
    isPreview
    gitMetadata {
      branch
      pullRequest {
        link
      }
    }
    basedOn
  }
`;
const BaesResourceFieldsFragmentDoc = gql`
  fragment baesResourceFields on MdResource {
    id
    kind
    displayName
    moniker {
      app
      stack
      detail
    }
    location {
      account
      regions
    }
    rawDefinition
  }
`;
const FetchApplicationDocument = gql`
  query fetchApplication($appName: String!, $statuses: [MdArtifactStatusInEnvironment!]) {
    application(appName: $appName) {
      id
      name
      config {
        id
        previewEnvironmentsConfigured
      }
      environments {
        ...baseEnvironmentFields
        isDeleting
        state {
          id
          artifacts {
            id
            name
            environment
            type
            reference
            versions(statuses: $statuses) {
              ...detailedVersionFields
            }
            ...artifactPinnedVersionFields
            resources {
              ...baesResourceFields
            }
          }
          resources {
            ...baesResourceFields
          }
        }
      }
    }
  }
  ${BaseEnvironmentFieldsFragmentDoc}
  ${DetailedVersionFieldsFragmentDoc}
  ${ArtifactPinnedVersionFieldsFragmentDoc}
  ${BaesResourceFieldsFragmentDoc}
`;
function useFetchApplicationQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchApplicationDocument, options);
}
const FetchCurrentVersionDocument = gql`
  query fetchCurrentVersion($appName: String!) {
    application(appName: $appName) {
      id
      name
      environments {
        id
        name
        state {
          artifacts {
            id
            name
            reference
            environment
            versions(statuses: [CURRENT]) {
              id
              version
              buildNumber
              createdAt
              gitMetadata {
                commit
                commitInfo {
                  sha
                  message
                }
              }
            }
          }
        }
      }
    }
  }
`;
function useFetchCurrentVersionQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchCurrentVersionDocument, options);
}
const FetchVersionsHistoryDocument = gql`
  query fetchVersionsHistory($appName: String!, $limit: Int) {
    application(appName: $appName) {
      id
      name
      environments {
        ...baseEnvironmentFields
        state {
          id
          artifacts {
            id
            name
            environment
            type
            reference
            versions(limit: $limit) {
              id
              buildNumber
              version
              createdAt
              status
              isCurrent
              gitMetadata {
                commit
                author
                branch
                commitInfo {
                  sha
                  link
                  message
                }
                pullRequest {
                  number
                  link
                }
              }
            }
            ...artifactPinnedVersionFields
          }
        }
      }
    }
  }
  ${BaseEnvironmentFieldsFragmentDoc}
  ${ArtifactPinnedVersionFieldsFragmentDoc}
`;
function useFetchVersionsHistoryQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchVersionsHistoryDocument, options);
}
const FetchPinnedVersionsDocument = gql`
  query fetchPinnedVersions($appName: String!) {
    application(appName: $appName) {
      id
      name
      account
      environments {
        id
        name
        state {
          id
          artifacts {
            id
            name
            environment
            type
            reference
            ...artifactPinnedVersionFields
          }
        }
      }
    }
  }
  ${ArtifactPinnedVersionFieldsFragmentDoc}
`;
const FetchVersionDocument = gql`
  query fetchVersion($appName: String!, $versions: [String!]) {
    application(appName: $appName) {
      id
      name
      account
      environments {
        id
        name
        state {
          id
          artifacts {
            id
            name
            environment
            type
            reference
            versions(versions: $versions) {
              ...detailedVersionFields
            }
          }
        }
      }
    }
  }
  ${DetailedVersionFieldsFragmentDoc}
`;
function useFetchVersionQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchVersionDocument, options);
}
const FetchResourceStatusDocument = gql`
  query fetchResourceStatus($appName: String!) {
    application(appName: $appName) {
      id
      name
      environments {
        id
        name
        state {
          id
          resources {
            id
            kind
            state {
              status
              reason
              event
              tasks {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
function useFetchResourceStatusQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchResourceStatusDocument, options);
}
const FetchNotificationsDocument = gql`
  query fetchNotifications($appName: String!) {
    application(appName: $appName) {
      id
      name
      notifications {
        id
        level
        message
        triggeredAt
        link
        id
      }
    }
  }
`;
function useFetchNotificationsQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchNotificationsDocument, options);
}
const FetchApplicationManagementDataDocument = gql`
  query fetchApplicationManagementData($appName: String!) {
    application(appName: $appName) {
      id
      name
      isPaused
      config {
        id
        updatedAt
        rawConfig
        processedConfig
      }
      gitIntegration {
        id
        repository
        branch
        isEnabled
        link
        manifestPath
      }
    }
  }
`;
function useFetchApplicationManagementDataQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchApplicationManagementDataDocument, options);
}
const FetchApplicationManagementStatusDocument = gql`
  query fetchApplicationManagementStatus($appName: String!) {
    application(appName: $appName) {
      id
      name
      isPaused
    }
  }
`;
function useFetchApplicationManagementStatusQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchApplicationManagementStatusDocument, options);
}
const UpdateConstraintDocument = gql`
  mutation UpdateConstraint($payload: MdConstraintStatusPayload!) {
    updateConstraintStatus(payload: $payload)
  }
`;
function useUpdateConstraintMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(UpdateConstraintDocument, options);
}
const ToggleManagementDocument = gql`
  mutation ToggleManagement($application: ID!, $isPaused: Boolean!) {
    toggleManagement(application: $application, isPaused: $isPaused)
  }
`;
function useToggleManagementMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(ToggleManagementDocument, options);
}
const PinVersionDocument = gql`
  mutation PinVersion($payload: MdArtifactVersionActionPayload!) {
    pinArtifactVersion(payload: $payload)
  }
`;
function usePinVersionMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(PinVersionDocument, options);
}
const UnpinVersionDocument = gql`
  mutation UnpinVersion($payload: MdUnpinArtifactVersionPayload!) {
    unpinArtifactVersion(payload: $payload)
  }
`;
function useUnpinVersionMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(UnpinVersionDocument, options);
}
const MarkVersionAsBadDocument = gql`
  mutation MarkVersionAsBad($payload: MdArtifactVersionActionPayload!) {
    markArtifactVersionAsBad(payload: $payload)
  }
`;
function useMarkVersionAsBadMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(MarkVersionAsBadDocument, options);
}
const MarkVersionAsGoodDocument = gql`
  mutation MarkVersionAsGood($payload: MdMarkArtifactVersionAsGoodPayload!) {
    markArtifactVersionAsGood(payload: $payload)
  }
`;
function useMarkVersionAsGoodMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(MarkVersionAsGoodDocument, options);
}
const RetryVersionActionDocument = gql`
  mutation RetryVersionAction($payload: MdRetryArtifactActionPayload!) {
    retryArtifactVersionAction(payload: $payload) {
      ...actionDetails
    }
  }
  ${ActionDetailsFragmentDoc}
`;
function useRetryVersionActionMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(RetryVersionActionDocument, options);
}
const UpdateGitIntegrationDocument = gql`
  mutation UpdateGitIntegration($payload: MdUpdateGitIntegrationPayload!) {
    updateGitIntegration(payload: $payload) {
      id
      isEnabled
    }
  }
`;
function useUpdateGitIntegrationMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(UpdateGitIntegrationDocument, options);
}
const DismissNotificationDocument = gql`
  mutation DismissNotification($payload: MdDismissNotificationPayload!) {
    dismissNotification(payload: $payload)
  }
`;
function useDismissNotificationMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(DismissNotificationDocument, options);
}
const ImportDeliveryConfigDocument = gql`
  mutation ImportDeliveryConfig($application: String!) {
    importDeliveryConfig(application: $application)
  }
`;
function useImportDeliveryConfigMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(ImportDeliveryConfigDocument, options);
}
const ToggleResourceManagementDocument = gql`
  mutation ToggleResourceManagement($payload: MdToggleResourceManagementPayload) {
    toggleResourceManagement(payload: $payload)
  }
`;
function useToggleResourceManagementMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(ToggleResourceManagementDocument, options);
}
const RestartConstraintEvaluationDocument = gql`
  mutation RestartConstraintEvaluation($payload: MdRestartConstraintEvaluationPayload!) {
    restartConstraintEvaluation(payload: $payload)
  }
`;
function useRestartConstraintEvaluationMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(RestartConstraintEvaluationDocument, options);
}

const YamlViewer = ({ content }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "full-width"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement(AceEditor, {
    mode: "yaml",
    theme: "textmate",
    readOnly: true,
    fontSize: 12,
    cursorStart: 0,
    showPrintMargin: false,
    highlightActiveLine: true,
    maxLines: Infinity,
    value: content,
    setOptions: {
      firstLineNumber: 1,
      tabSize: 2,
      showLineNumbers: true,
      showFoldWidgets: true
    },
    style: { width: "auto" },
    className: "ace-editor sp-margin-m-top",
    editorProps: { $blockScrolling: true },
    onLoad: (editor) => {
      var _a;
      (_a = editor.commands) == null ? void 0 : _a.removeCommand("find");
    }
  })));
};

const useNotifyOnError = ({
  key,
  content,
  error
}) => {
  React__default.useEffect(() => {
    if (!error)
      return;
    NotifierService.publish({
      key,
      content: (content ? `${content} - ` : "") + error.message,
      options: { type: "error" }
    });
  }, [error]);
};

const ReImportConfig = () => {
  const appName = useApplicationContextSafe().name;
  const refetchVariables = { appName };
  const [importDeliveryConfig, { error, loading }] = useImportDeliveryConfigMutation({
    variables: { application: appName },
    refetchQueries: [{ query: FetchApplicationManagementDataDocument, variables: refetchVariables }]
  });
  const logEvent = useLogEvent("GitIntegration", "ImportNow");
  useNotifyOnError({ key: "import-error", content: `Failed to import delivery config`, error });
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("small", null, "(", /* @__PURE__ */ React__default.createElement("button", {
    className: "btn-link no-padding no-margin no-border",
    onClick: () => {
      importDeliveryConfig();
      logEvent();
    },
    disabled: loading
  }, "Import now"), ")"), loading && /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular",
    size: "nano",
    color: "var(--color-accent)",
    className: "sp-margin-xs-left"
  }));
};
const DeliveryConfig = ({ config, updatedAt, isProcessed, children }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-xl-top"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-m-bottom"
  }, /* @__PURE__ */ React__default.createElement("h4", {
    className: "sp-margin-3xs-bottom"
  }, isProcessed ? "Processed Delivery Config" : "Delivery config"), /* @__PURE__ */ React__default.createElement("div", {
    className: "horizontal middle sp-margin-xs-top"
  }, updatedAt && /* @__PURE__ */ React__default.createElement("small", {
    className: "sp-margin-xs-right"
  }, "Last update: ", /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: updatedAt,
    withSuffix: true,
    removeStyles: true
  })), !isProcessed && /* @__PURE__ */ React__default.createElement(ReImportConfig, null))), children, config && /* @__PURE__ */ React__default.createElement(YamlViewer, {
    content: config
  }));
};

var css_248z$1I = ".GitIntegration .help-text {\n  font-size: 13px;\n  color: var(--color-dovegray);\n  margin-left: 20px;\n}\n.GitIntegration .ManifestPath {\n  min-height: 30px;\n}\n.GitIntegration .ManifestPath .manifest-input {\n  width: auto;\n  min-width: 200px;\n  padding-right: 24px;\n}\n.GitIntegration .ManifestPath code {\n  color: var(--color-accent);\n  background-color: transparent;\n}\n";
styleInject(css_248z$1I);

const ManifestPath = ({ manifestPath }) => {
  var _a;
  const [currentPath, setCurrentPath] = React__default.useState(manifestPath);
  const [isEditing, setIsEditing] = React__default.useState(false);
  const appName = useApplicationContextSafe().name;
  const [updateIntegration, { loading }] = useUpdateGitIntegrationMutation({
    refetchQueries: [{ query: FetchApplicationManagementDataDocument, variables: { appName } }],
    onCompleted: () => {
      setIsEditing(false);
    }
  });
  const baseManifestPath = ((_a = SETTINGS.managedDelivery) == null ? void 0 : _a.manifestBasePath) + "/";
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-s-top horizontal middle ManifestPath"
  }, "Config file path:", " ", isEditing ? /* @__PURE__ */ React__default.createElement("form", {
    className: "horizontal middle",
    onSubmit: (e) => {
      e.preventDefault();
      updateIntegration({ variables: { payload: { application: appName, manifestPath: currentPath } } });
    }
  }, /* @__PURE__ */ React__default.createElement("code", null, baseManifestPath), /* @__PURE__ */ React__default.createElement("input", {
    value: currentPath,
    className: "form-control horizontal manifest-input input-sm sp-margin-xs-left",
    onChange: (e) => setCurrentPath(e.target.value),
    autoFocus: true
  }), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn md-btn md-btn-accent sp-padding-xs-yaxis sp-padding-s-xaxis sp-margin-s-left",
    type: "submit",
    disabled: loading
  }, "Save")) : /* @__PURE__ */ React__default.createElement("code", null, baseManifestPath, manifestPath), loading ? /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular",
    size: "nano",
    color: "var(--color-accent)",
    className: "sp-margin-s-left"
  }) : /* @__PURE__ */ React__default.createElement("button", {
    className: "btn-link no-padding no-border sp-margin-s-left",
    onClick: () => {
      setIsEditing((state) => !state);
    }
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: isEditing ? "fas fa-times" : "far fa-edit"
  })));
};
const GitIntegration = ({ isEnabled, branch, link, repository, manifestPath }) => {
  const appName = useApplicationContextSafe().name;
  const [updateIntegration, { loading, error }] = useUpdateGitIntegrationMutation({
    refetchQueries: [{ query: FetchApplicationManagementDataDocument, variables: { appName } }]
  });
  const logEvent = useLogEvent("GitIntegration");
  useNotifyOnError({
    key: "toggleGitIntegration",
    content: `Failed to ${isEnabled ? "disable" : "enable"} auto-import`,
    error
  });
  const repoAndBranch = [repository, branch].join(":");
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "GitIntegration sp-margin-m-bottom"
  }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    checked: Boolean(isEnabled),
    wrapperClassName: "sp-margin-3xs-yaxis",
    text: /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "horizontal middle"
    }, "Auto-import delivery config from\xA0", link ? /* @__PURE__ */ React__default.createElement("a", {
      href: link,
      target: "_blank",
      onClick: (e) => e.stopPropagation()
    }, repoAndBranch) : repoAndBranch, loading && /* @__PURE__ */ React__default.createElement(Spinner, {
      mode: "circular",
      size: "nano",
      color: "var(--color-accent)",
      className: "sp-margin-s-left"
    }))),
    disabled: loading,
    onChange: (e) => {
      updateIntegration({ variables: { payload: { application: appName, isEnabled: e.target.checked } } });
      logEvent({ action: e.target.checked ? "EnableIntegration" : "DisableIntegration" });
    }
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "help-text"
  }, "Turning this on will automatically import your config from git when a new commit is made to", " ", branch || "your main branch"), /* @__PURE__ */ React__default.createElement(ManifestPath, {
    manifestPath
  }));
};

var css_248z$1H = ".MessageBox {\n  --main-color: var(--color-accent);\n  background-color: var(--color-white);\n  border-left: 4px solid var(--main-color);\n  box-shadow: 2px 2px 5px 0px var(--color-alto);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: var(--xl-spacing);\n}\n.MessageBox.warning {\n  --main-color: var(--color-status-warning);\n}\n.MessageBox.error {\n  --main-color: var(--color-status-error);\n}\n.MessageBox .message-icon {\n  border-radius: 999px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--main-color);\n  margin-right: var(--m-spacing);\n  color: var(--color-white);\n}\n.MessageBox .dismiss {\n  color: var(--color-text-link-g1);\n}\n.MessagesSection {\n  width: 100%;\n  background-color: var(--color-alabaster);\n  border-bottom: 1px solid var(--color-alto);\n  margin-bottom: var(--xl-spacing);\n}\n.MessagesSection.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n";
styleInject(css_248z$1H);

const typeToClassName = {
  ERROR: "fas fa-times",
  WARNING: "fas fa-exclamation"
};
const MessageBox = ({ children, type, onDismiss }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("MessageBox sp-padding-m", type == null ? void 0 : type.toLowerCase())
  }, type && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("i", {
    className: classNames(typeToClassName[type], "message-icon")
  })), /* @__PURE__ */ React__default.createElement("div", null, children), onDismiss && /* @__PURE__ */ React__default.createElement("button", {
    className: "as-link dismiss sp-margin-m-left",
    onClick: onDismiss
  }, "Dismiss"));
};
const MessagesSection = ({ children, sticky }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("MessagesSection", { sticky })
  }, children);
};

const ManagementWarning = ({ appName }) => {
  var _a;
  const { data } = useFetchApplicationManagementStatusQuery({ variables: { appName } });
  const [toggleManagement] = useToggleManagementMutation({
    refetchQueries: [{ query: FetchApplicationManagementStatusDocument, variables: { appName } }]
  });
  const onClick = React__default.useCallback(() => {
    showModal(ResumeManagementModal, {
      application: appName,
      onAction: async () => {
        await toggleManagement({ variables: { application: appName, isPaused: false } });
      },
      logCategory: "App::Management",
      withComment: false
    }, { maxWidth: MODAL_MAX_WIDTH });
  }, [appName]);
  if ((_a = data == null ? void 0 : data.application) == null ? void 0 : _a.isPaused) {
    return /* @__PURE__ */ React__default.createElement(MessagesSection, {
      sticky: true
    }, /* @__PURE__ */ React__default.createElement(MessageBox, {
      type: "WARNING"
    }, "Application management is disabled.", " ", /* @__PURE__ */ React__default.createElement("a", {
      href: "#",
      onClick: (e) => {
        e.preventDefault();
        onClick();
      }
    }, "Click here to enable")));
  }
  return null;
};

const AppNotifications = () => {
  var _a;
  const app = useApplicationContextSafe();
  const logEvent = useLogEvent("Error", "AppNotifications");
  const variables = { appName: app.name };
  const { data, error } = useFetchNotificationsQuery({ variables });
  const [onDismiss] = useDismissNotificationMutation({
    refetchQueries: [{ query: FetchNotificationsDocument, variables }]
  });
  React__default.useEffect(() => {
    if (error) {
      logEvent({ level: "ERROR", error });
    }
  }, [error, logEvent]);
  const notifications = ((_a = data == null ? void 0 : data.application) == null ? void 0 : _a.notifications) || [];
  const isDebug = getIsDebugMode();
  if (!notifications.length)
    return null;
  return /* @__PURE__ */ React__default.createElement(MessagesSection, null, notifications.map((notification) => /* @__PURE__ */ React__default.createElement(MessageBox, {
    key: notification.id,
    type: notification.level,
    onDismiss: isDebug ? () => onDismiss({ variables: { payload: { application: app.name, id: notification.id } } }) : void 0
  }, notification.message, " ", notification.triggeredAt && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "(", /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: notification.triggeredAt,
    withSuffix: true
  }), ")"), notification.link && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, " ", "-", " ", /* @__PURE__ */ React__default.createElement("a", {
    href: notification.link,
    target: "_blank"
  }, "View")))));
};
const Messages = ({ showManagementWarning = true }) => {
  const app = useApplicationContextSafe();
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(AppNotifications, null), showManagementWarning && /* @__PURE__ */ React__default.createElement(ManagementWarning, {
    appName: app.name
  }));
};

var css_248z$1G = ".action-button {\n  color: #5a5fb4;\n  background-color: transparent;\n  font-size: 14px;\n  border: 1px solid #5a5fb4;\n  border-radius: 2px;\n  padding: 4px 20px;\n  transition: all 90ms ease-in;\n}\n.action-button-primary {\n  background-color: #5a5fb4;\n  color: var(--color-white);\n}\n.action-button:not([disabled]) {\n  cursor: pointer;\n}\n.action-button[disabled] {\n  cursor: not-allowed;\n  opacity: 0.66;\n}\n.action-button:not([disabled]):hover {\n  background-color: rgba(90, 95, 180, 0.15);\n}\n.action-button-primary:not([disabled]):hover {\n  background-color: #3c4085;\n}\n.action-button:not([disabled]):focus,\n.action-button:not([disabled]):active {\n  outline: none;\n}\n.action-button:not([disabled]):active {\n  box-shadow: none !important;\n  background-color: rgba(90, 95, 180, 0.8);\n  color: var(--color-white);\n}\n.action-button-primary:not([disabled]):active {\n  background-color: rgba(90, 95, 180, 0.2);\n  color: #5a5fb4;\n}\n";
styleInject(css_248z$1G);

const DEFAULT_APPEARANCE = "secondary";
const Button = ({ iconName, appearance = DEFAULT_APPEARANCE, disabled, onClick, children }) => {
  return /* @__PURE__ */ React__default.createElement("button", {
    disabled,
    className: `flex-container-h center middle text-bold action-button action-button-${appearance}`,
    onClick
  }, iconName && /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-s-right flex-container-h center middle"
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    name: iconName,
    appearance: appearance === "primary" ? "light" : "neutral",
    size: "small"
  })), children);
};

const ActionModal = ({
  title,
  dismissModal,
  closeModal,
  onAction,
  onSuccess,
  actionName,
  withComment = true,
  logCategory,
  className,
  children
}) => {
  const logEvent = useLogEvent(logCategory || "ActionModal", actionName);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ModalHeader, {
    className: "truncate"
  }, title), /* @__PURE__ */ React__default.createElement(SpinFormik, {
    initialValues: {},
    onSubmit: async ({ comment }, { setSubmitting, setStatus }) => {
      if (withComment && !comment)
        return;
      logEvent();
      try {
        await onAction(comment);
        onSuccess == null ? void 0 : onSuccess();
        closeModal == null ? void 0 : closeModal();
      } catch (error) {
        setStatus({ error });
      } finally {
        setSubmitting(false);
      }
    },
    render: ({ status, isValid, isSubmitting, submitForm }) => {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ModalBody, null, /* @__PURE__ */ React__default.createElement("div", {
        className: classNames("flex-container-v middle sp-padding-xl-yaxis ActionModal", className)
      }, children, withComment && /* @__PURE__ */ React__default.createElement(FormikFormField, {
        label: "Reason",
        name: "comment",
        required: true,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextAreaInput, {
          ...props,
          rows: 5,
          required: true,
          placeholder: "Please provide a reason. Markdown is supported :)"
        })
      }), (status == null ? void 0 : status.error) && /* @__PURE__ */ React__default.createElement("div", {
        className: "sp-margin-xl-top"
      }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
        type: "error",
        message: /* @__PURE__ */ React__default.createElement("span", {
          className: "flex-container-v"
        }, /* @__PURE__ */ React__default.createElement("span", {
          className: "text-bold"
        }, "Something went wrong:"), status.error.message && /* @__PURE__ */ React__default.createElement("span", null, status.error.message))
      })))), /* @__PURE__ */ React__default.createElement(ModalFooter, {
        primaryActions: /* @__PURE__ */ React__default.createElement("div", {
          className: "flex-container-h sp-group-margin-s-xaxis"
        }, /* @__PURE__ */ React__default.createElement(Button, {
          onClick: () => dismissModal == null ? void 0 : dismissModal()
        }, "Cancel"), /* @__PURE__ */ React__default.createElement(Button, {
          appearance: "primary",
          disabled: !isValid || isSubmitting,
          onClick: () => submitForm()
        }, actionName))
      }));
    }
  }));
};

const BTN_CLASSNAMES = "btn md-btn";
const managementStatusToContent = {
  PAUSED: {
    title: "Application management is disabled",
    btnText: "Resume management...",
    btnClassName: "md-btn-success"
  },
  ENABLED: {
    title: "Application is managed by Spinnaker \u{1F64C}",
    btnText: "Disable management...",
    btnClassName: "md-btn-danger"
  }
};
const Configuration = () => {
  var _a, _b, _c;
  const appName = useApplicationContextSafe().name;
  const { data, error, loading } = useFetchApplicationManagementDataQuery({
    variables: { appName },
    errorPolicy: "all"
  });
  const logError = useLogEvent("DeliveryConfig");
  React__default.useEffect(() => {
    if (error) {
      logError({ action: "LoadingFailed", data: { error } });
    }
  }, [error, logError]);
  if (loading || !data) {
    return /* @__PURE__ */ React__default.createElement(Spinner, {
      ...spinnerProps,
      message: "Loading configuration..."
    });
  }
  if (error && !Boolean(data == null ? void 0 : data.application)) {
    return /* @__PURE__ */ React__default.createElement(UnmanagedMessage, null);
  }
  const gitIntegration = (_a = data.application) == null ? void 0 : _a.gitIntegration;
  const isDebug = getIsDebugMode();
  const config = (_b = data.application) == null ? void 0 : _b.config;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "full-width"
  }, /* @__PURE__ */ React__default.createElement(Messages, {
    showManagementWarning: false
  }), error && /* @__PURE__ */ React__default.createElement(ApplicationQueryError, {
    hasApplicationData: Boolean(data == null ? void 0 : data.application),
    error
  }), /* @__PURE__ */ React__default.createElement(ManagementToggle, {
    isPaused: (_c = data.application) == null ? void 0 : _c.isPaused
  }), /* @__PURE__ */ React__default.createElement(DeliveryConfig, {
    config: config == null ? void 0 : config.rawConfig,
    updatedAt: config == null ? void 0 : config.updatedAt
  }, SETTINGS.feature.mdGitIntegration && gitIntegration && /* @__PURE__ */ React__default.createElement(GitIntegration, {
    ...gitIntegration
  })), isDebug && /* @__PURE__ */ React__default.createElement(DeliveryConfig, {
    config: config == null ? void 0 : config.processedConfig,
    isProcessed: true
  }));
};
const ManagementToggle = ({ isPaused }) => {
  const appName = useApplicationContextSafe().name;
  const logEvent = useLogEvent("Management");
  const [toggleManagement, { loading: mutationInFlight, error }] = useToggleManagementMutation({
    refetchQueries: [{ query: FetchApplicationManagementDataDocument, variables: { appName } }]
  });
  useNotifyOnError({
    key: "toggleManagement",
    content: `Failed to ${isPaused ? "enable" : "disable"} management`,
    error
  });
  const onShowToggleManagementModal = React__default.useCallback((shouldPause) => {
    logEvent({ action: "OpenModal", data: { shouldPause } });
    showModal(shouldPause ? DisableManagementModal : ResumeManagementModal, {
      application: appName,
      onAction: async () => {
        toggleManagement({ variables: { application: appName, isPaused: shouldPause } });
      },
      logCategory: "Management",
      withComment: false
    }, { maxWidth: MODAL_MAX_WIDTH });
  }, []);
  const state = managementStatusToContent[isPaused ? "PAUSED" : "ENABLED"];
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h4", null, "Management"), /* @__PURE__ */ React__default.createElement("div", null, state.title), /* @__PURE__ */ React__default.createElement("div", {
    className: "horizontal middle sp-margin-s-top"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: classNames(BTN_CLASSNAMES, state.btnClassName),
    onClick: () => onShowToggleManagementModal(!isPaused)
  }, state.btnText), mutationInFlight && /* @__PURE__ */ React__default.createElement("span", {
    className: "sp-margin-s-left"
  }, /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular",
    size: "nano",
    color: "var(--color-accent)"
  }))));
};
const ResumeManagementModal = ({ application, ...props }) => {
  return /* @__PURE__ */ React__default.createElement(ActionModal, {
    actionName: "Resume",
    title: "Resume Management",
    ...props
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "sp-margin-m-right",
    style: { minWidth: 145 }
  }, /* @__PURE__ */ React__default.createElement(Illustration, {
    name: "runManagement"
  })), /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("p", null, "You\u2019re about to resume management for this application. The latest good version approved for deployment will be deployed to each environment, and any configuration changes made while disabled will take effect."))));
};
const DisableManagementModal = ({ application, ...props }) => {
  return /* @__PURE__ */ React__default.createElement(ActionModal, {
    actionName: "Disable",
    title: "Disable Management",
    ...props
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "sp-margin-m-right",
    style: { minWidth: 145 }
  }, /* @__PURE__ */ React__default.createElement(Illustration, {
    name: "disableManagement"
  })), /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("span", {
    className: "bold"
  }, "Careful! You\u2019re about to stop Spinnaker from managing all resources in your application."), "This feature should only be used if management is not working properly and manual intervention is required.", " ", /* @__PURE__ */ React__default.createElement("a", {
    href: getDocsUrl("root"),
    target: "_blank"
  }, "Check our documentation for more information"), "."), /* @__PURE__ */ React__default.createElement("p", null, "Need to rollback?", " ", /* @__PURE__ */ React__default.createElement("a", {
    href: getDocsUrl("pinning"),
    target: "_blank"
  }, "Try pinning a version instead"), "."))));
};

const LoadingAnimation = () => /* @__PURE__ */ React__default.createElement(ContentLoader, {
  width: "100%",
  height: 30
}, /* @__PURE__ */ React__default.createElement("rect", {
  x: "0",
  y: "8",
  rx: "5",
  ry: "5",
  width: "60%",
  height: "8"
}), /* @__PURE__ */ React__default.createElement("rect", {
  x: "0",
  y: "22",
  rx: "5",
  ry: "5",
  width: "50%",
  height: "8"
}));

function useDataWithRefresh(callback, defaultResult, deps) {
  const app = useApplicationContextSafe();
  const result = useData(callback, defaultResult, [...deps, app]);
  const refreshCallback = useLatestCallback(result.refresh);
  useEffect$a(() => {
    if (!app)
      return () => {
      };
    const unsubscribe = app.subscribeToRefresh(refreshCallback);
    return unsubscribe;
  }, [app, refreshCallback]);
  return result;
}

function TaskProgressBar(props) {
  const { task, className } = props;
  const { steps, id } = task;
  let tooltip;
  if (task.isRunning) {
    const currentStep = steps.find((step) => step.hasNotStarted || step.isRunning);
    if (currentStep) {
      const currentStepIndex = steps.indexOf(currentStep) + 1;
      tooltip = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
        id
      }, `Step ${currentStepIndex} of ${steps.length}: ${robotToHuman(currentStep.name)}`);
    }
  }
  if (task.isFailed) {
    const failedStep = steps.find((step) => step.isFailed || step.isSuspended);
    if (failedStep && task.failureMessage) {
      const failedStepIndex = steps.indexOf(failedStep) + 1;
      const ellipses = String.fromCharCode(8230);
      const clipped = task.failureMessage.length > 400 ? task.failureMessage.substring(0, 400) + ellipses : task.failureMessage;
      tooltip = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
        id
      }, `Failed on Step ${failedStepIndex} of ${steps.length}:`, /* @__PURE__ */ React__default.createElement("br", null), robotToHuman(failedStep.name), /* @__PURE__ */ React__default.createElement("br", null), /* @__PURE__ */ React__default.createElement("br", null), /* @__PURE__ */ React__default.createElement("strong", null, "Exception:"), /* @__PURE__ */ React__default.createElement("p", null, clipped));
    } else {
      tooltip = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
        id
      }, "Task failed; sorry, no reason provided");
    }
  }
  const stepsComplete = steps.filter((step) => step.isCompleted);
  const progressBarClassName = classNames({
    "progress-bar": true,
    "progress-bar-info": task.isRunning || task.hasNotStarted,
    "progress-bar-success": task.isCompleted,
    "progress-bar-disabled": task.isCanceled,
    "progress-bar-danger": task.isFailed
  });
  const progressBar = /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("progress", className)
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: progressBarClassName,
    style: { width: `${10 + stepsComplete.length / steps.length * 90}%` }
  }));
  if (tooltip) {
    return /* @__PURE__ */ React__default.createElement(OverlayTrigger, {
      placement: "top",
      overlay: tooltip
    }, progressBar);
  }
  return progressBar;
}

const DEFAULT_ICON_CLASSNAMES = "far fa-hourglass md-icon-pending";
const getTaskStatusIconProps = (task) => {
  if (!task)
    return DEFAULT_ICON_CLASSNAMES;
  if (task.isCompleted)
    return "fas fa-check md-icon-success";
  if (task.isCanceled || task.isFailed)
    return "fas fa-times md-icon-fail";
  return DEFAULT_ICON_CLASSNAMES;
};
const ResourceTask = ({ id, name }) => {
  var _a;
  const { status, result } = useDataWithRefresh(() => TaskReader.getTask(id), void 0, [id]);
  if (status === "PENDING" && !result) {
    return /* @__PURE__ */ React__default.createElement(LoadingAnimation, null);
  }
  const iconClassnames = getTaskStatusIconProps(result);
  const currentStage = (_a = result == null ? void 0 : result.steps) == null ? void 0 : _a.find((step) => step.isRunning);
  return /* @__PURE__ */ React__default.createElement("li", {
    key: id,
    className: "resource-task"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: iconClassnames
  }), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(UISref, {
    to: "home.applications.application.tasks.taskDetails",
    params: { taskId: id }
  }, /* @__PURE__ */ React__default.createElement("a", null, name)), result && !result.isCompleted && /* @__PURE__ */ React__default.createElement(TaskProgressBar, {
    task: result,
    className: "task-progress"
  }), result && /* @__PURE__ */ React__default.createElement("div", {
    className: "delimited-elements task-metadata"
  }, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: "Started at",
    delayShow: TOOLTIP_DELAY_SHOW
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "far fa-clock task-runtime"
  })), /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: result.startTime,
    withSuffix: true,
    removeStyles: true
  })), currentStage && !result.isCompleted && /* @__PURE__ */ React__default.createElement("span", null, "Current stage: ", robotToHuman(currentStage.name), " (", /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: currentStage.startTime,
    withSuffix: true
  }), ")"))));
};

const EnvironmentItem = ({
  title,
  size = "regular",
  iconName,
  iconTooltip,
  className,
  rightElement,
  withPadding = true,
  children
}) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames(className, "environment-row-element", { "with-padding": withPadding })
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("row-icon", size)
  }, /* @__PURE__ */ React__default.createElement(IconTooltip, {
    tooltip: iconTooltip,
    name: iconName,
    color: "primary-g1",
    size: size === "regular" ? "17px" : "15px",
    delayShow: TOOLTIP_DELAY_SHOW
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "row-details"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("row-title", size)
  }, title, rightElement && /* @__PURE__ */ React__default.createElement("div", null, rightElement)), children));
};

var css_248z$1F = ".ResourceDefinitionModal .modal-subtitle {\n  font-size: 11pt;\n}\n";
styleInject(css_248z$1F);

const showResourceDefinitionModal = (props) => showModal(ResourceDefinitionModal, props);
const ResourceDefinitionModal = ({ resource }) => {
  if (!resource.rawDefinition)
    return null;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "ResourceDefinitionModal"
  }, /* @__PURE__ */ React__default.createElement(ModalHeader, null, "Resource definition - ", resource.displayName, /* @__PURE__ */ React__default.createElement("div", {
    className: "modal-subtitle"
  }, "(Includes resolved fields and metadata added by the system)")), /* @__PURE__ */ React__default.createElement(ModalBody, null, /* @__PURE__ */ React__default.createElement(YamlViewer, {
    content: resource.rawDefinition
  })));
};

const useGenerateLink = (props) => {
  var _a;
  const externalLink = resourceManager.getExperimentalDisplayLink(props);
  const routingInfo = (_a = resourceManager.getNativeResourceRoutingInfo(props)) != null ? _a : { state: "", params: {} };
  const routeProps = useSref(routingInfo.state, routingInfo.params);
  if (externalLink) {
    return { href: externalLink, isExternal: true };
  }
  if (routeProps.href) {
    return { href: routeProps.href };
  }
  return void 0;
};

const ResourceTitle = ({ resource }) => {
  var _a, _b, _c;
  const account = (_a = resource.location) == null ? void 0 : _a.account;
  const { displayName, kind } = resource;
  const linkProps = useGenerateLink({
    kind,
    displayName,
    account,
    detail: (_b = resource.moniker) == null ? void 0 : _b.detail,
    stack: (_c = resource.moniker) == null ? void 0 : _c.stack
  });
  const logEvent = useLogEvent("Resource");
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, linkProps ? /* @__PURE__ */ React__default.createElement("a", {
    href: linkProps.href,
    ...linkProps.isExternal ? { target: "_blank", rel: "noopener noreferrer" } : void 0,
    onClick: () => {
      logEvent({ action: "OpenCommit", data: { kind, account } });
    }
  }, displayName) : displayName);
};

var css_248z$1E = ".Resource .resource-metadata {\n  margin-top: var(--xs-spacing);\n  color: var(--color-nobel);\n}\n.Resource .resource-status {\n  margin-top: var(--s-spacing);\n  display: grid;\n  grid-template-columns: 14px auto;\n  -moz-column-gap: 6px;\n       column-gap: 6px;\n}\n.Resource .resource-status > i {\n  line-height: 20px;\n}\n.Resource .resource-status .event {\n  word-break: break-word;\n}\n.Resource .resource-status .tasks-list {\n  margin-top: var(--xs-spacing);\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style-type: none;\n}\n.Resource .resource-status .task-runtime {\n  font-size: 12px;\n  margin-right: var(--xs-spacing);\n}\n.Resource .resource-status .resource-task {\n  display: grid;\n  grid-template-columns: 14px auto;\n  -moz-column-gap: 6px;\n       column-gap: 6px;\n  align-items: flex-start;\n}\n.Resource .resource-status .resource-task > i {\n  margin-top: 2px;\n}\n.Resource .resource-status .resource-task .task-progress {\n  width: 70px;\n  height: 10px;\n  margin-bottom: 0;\n  margin-left: var(--s-spacing);\n  display: inline-flex;\n}\n.Resource .resource-status .resource-task .task-metadata {\n  color: var(--color-concrete);\n}\n";
styleInject(css_248z$1E);

const statusUtils = {
  ERROR: { color: "var(--color-status-error)", icon: "fas fa-times", defaultReason: "Failed to update resource" },
  NOT_MANAGED: {
    color: "var(--color-status-warning)",
    icon: "fas fa-pause",
    defaultReason: "Resource management is paused"
  },
  WAITING: { icon: "far fa-hourglass", defaultReason: "Resource is currently locked and can not be updated" },
  PROCESSING: { icon: "far fa-hourglass", defaultReason: "Resource is being updated" },
  DELETING: { icon: "far fa-trash-alt", defaultReason: "Resource is being deleted" }
};
const Status = ({ appName, environmentName, resourceId, regions, account }) => {
  var _a, _b, _c, _d, _e, _f;
  const { data: resourceStatuses, error, loading } = useFetchResourceStatusQuery({ variables: { appName } });
  const [enableResourceManagement] = useToggleResourceManagementMutation({
    variables: { payload: { id: resourceId, isPaused: false } },
    refetchQueries: [{ query: FetchResourceStatusDocument, variables: { appName } }]
  });
  const state = (_d = (_c = (_b = (_a = resourceStatuses == null ? void 0 : resourceStatuses.application) == null ? void 0 : _a.environments.find((env) => env.name === environmentName)) == null ? void 0 : _b.state.resources) == null ? void 0 : _c.find((resource) => resource.id === resourceId)) == null ? void 0 : _d.state;
  if (error || !loading && !state) {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "resource-status"
    }, /* @__PURE__ */ React__default.createElement(Icon, {
      name: "mdUnknown",
      size: "14px",
      color: "status-warning"
    }), /* @__PURE__ */ React__default.createElement("span", null, "Failed to fetch resource status"));
  }
  if (!state)
    return /* @__PURE__ */ React__default.createElement(Spinner, {
      className: "sp-margin-xs-top",
      mode: "circular",
      size: "nano",
      color: "var(--color-accent)"
    });
  if (state.status === "UP_TO_DATE")
    return null;
  const isNotManaged = state.status === "NOT_MANAGED";
  const reasonElem = /* @__PURE__ */ React__default.createElement("div", null, state.reason || statusUtils[state.status].defaultReason, isNotManaged ? " (click to enable...)" : void 0);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "resource-status"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: statusUtils[state.status].icon,
    style: {
      color: statusUtils[state.status].color || "var(--color-titanium)"
    }
  }), /* @__PURE__ */ React__default.createElement("div", null, isNotManaged ? /* @__PURE__ */ React__default.createElement("button", {
    className: "as-link",
    onClick: () => {
      ConfirmationModalService.confirm({
        header: `Really resume resource management?`,
        bodyContent: /* @__PURE__ */ React__default.createElement(ToggleResourceManagement, {
          isPaused: true,
          regions
        }),
        account,
        buttonText: `Resume management`,
        submitMethod: enableResourceManagement
      });
    }
  }, reasonElem) : reasonElem, state.event && state.event !== state.reason && /* @__PURE__ */ React__default.createElement(Markdown, {
    className: "event",
    message: state.event
  }), Boolean((_e = state.tasks) == null ? void 0 : _e.length) && /* @__PURE__ */ React__default.createElement("ul", {
    className: "tasks-list"
  }, (_f = state.tasks) == null ? void 0 : _f.map(({ id, name }) => /* @__PURE__ */ React__default.createElement(ResourceTask, {
    key: id,
    id,
    name
  })))));
};
const ResourceMetadata = ({ resource }) => {
  var _a, _b;
  const logEvent = useLogEvent("Resource");
  const isDebug = getIsDebugMode();
  const account = (_a = resource.location) == null ? void 0 : _a.account;
  const regions = ((_b = resource.location) == null ? void 0 : _b.regions) || [];
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "resource-metadata delimited-elements"
  }, /* @__PURE__ */ React__default.createElement("span", null, regions.map((region, index) => /* @__PURE__ */ React__default.createElement("span", {
    key: region
  }, region, index < regions.length - 1 && ", "))), account && /* @__PURE__ */ React__default.createElement("span", null, account), /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("a", {
    href: "#",
    onClick: (e) => {
      e.preventDefault();
      showManagedResourceHistoryModal({ id: resource.id, displayName: resource.displayName || resource.id });
      logEvent({ action: "ViewHistory" });
    }
  }, "View history")), isDebug && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("a", {
    href: "#",
    onClick: (e) => {
      e.preventDefault();
      showResourceDefinitionModal({ resource });
      logEvent({ action: "ViewDefinition" });
    }
  }, "View definition")));
};
const Resource = ({
  resource,
  environment,
  withPadding,
  size,
  className
}) => {
  var _a, _b;
  const icon = resourceManager.getIcon(resource.kind);
  const app = useApplicationContextSafe();
  const account = (_a = resource.location) == null ? void 0 : _a.account;
  const regions = ((_b = resource.location) == null ? void 0 : _b.regions) || [];
  return /* @__PURE__ */ React__default.createElement(EnvironmentItem, {
    iconName: icon,
    iconTooltip: resource.kind,
    className: classNames("Resource", className),
    title: /* @__PURE__ */ React__default.createElement(ResourceTitle, {
      resource
    }),
    size,
    withPadding
  }, /* @__PURE__ */ React__default.createElement(ResourceMetadata, {
    environment,
    resource
  }), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Status, {
    appName: app.name,
    environmentName: environment,
    resourceId: resource.id,
    account,
    regions
  })));
};

const ArtifactCollapsibleSection = ({
  heading,
  isUpdating,
  ...props
}) => {
  return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    outerDivClassName: "artifact-section",
    bodyClassName: "sp-padding-xl-bottom sp-padding-l-left",
    toggleClassName: "artifact-section-title sp-margin-l-bottom",
    enableCaching: false,
    expandIconSize: "14px",
    expandIconPosition: "left",
    heading: ({ chevron }) => /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal middle"
    }, chevron, heading, isUpdating && /* @__PURE__ */ React__default.createElement("span", {
      className: "in-progress-dot"
    })),
    ...props
  });
};

var css_248z$1D = ".VersionOperationIcon.small-icon {\n  font-size: 12px;\n}\n";
styleInject(css_248z$1D);

const ACTION_DISPLAY_NAMES = ["passed", "overridden", "pending", "failed"];
const DEFAULT_ICON_CLASSNAME = "far fa-hourglass md-icon-pending";
const actionStatusUtilsInternal = {
  FAIL: { className: "fas fa-times md-icon-fail", displayName: "failed" },
  FORCE_PASS: { className: "fas fa-check md-icon-success", displayName: "overridden" },
  PASS: { className: "fas fa-check md-icon-success", displayName: "passed" },
  PENDING: { displayName: "pending" },
  NOT_EVALUATED: { displayName: "pending" },
  BLOCKED: { displayName: "pending" }
};
const getActionStatusData = (status) => {
  const data = actionStatusUtilsInternal[status];
  if (!data) {
    console.error(`Missing data for action status ${status}`);
  }
  return data;
};
const VersionOperationIcon = ({ status, className, size = "medium" }) => {
  var _a;
  return /* @__PURE__ */ React__default.createElement("i", {
    className: classNames("VersionOperationIcon", ((_a = getActionStatusData(status)) == null ? void 0 : _a.className) || DEFAULT_ICON_CLASSNAME, `${size}-icon`, className)
  });
};

var css_248z$1C = ".DeploymentWindow {\n  font-size: 13px;\n}\n";
styleInject(css_248z$1C);

const groupConsecutiveNumbers = (values) => {
  const groups = [];
  for (const value of sortBy(values)) {
    const lastGroup = groups[groups.length - 1];
    if (!lastGroup || lastGroup.end !== value - 1) {
      groups.push({ start: value, end: value });
    } else {
      lastGroup.end = value;
    }
  }
  return groups;
};
const DAYS_TO_STRING = {
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat",
  7: "Sun"
};
const hourToString = (hour) => {
  const hourString = padStart(`${hour === 25 ? 1 : hour}`, 2, "0");
  return `${hourString}:00`;
};
const groupHours = (hours) => {
  const hourGroups = groupConsecutiveNumbers(hours);
  return hourGroups.map((group) => `${hourToString(group.start)}-${hourToString(group.end + 1)}`);
};
const groupDays = (days) => {
  const dayGroups = groupConsecutiveNumbers(days);
  const daysString = dayGroups.map((group) => {
    if (group.start === group.end) {
      return DAYS_TO_STRING[group.start];
    }
    return `${DAYS_TO_STRING[group.start]}-${DAYS_TO_STRING[group.end]}`;
  });
  return daysString;
};
const timeWindowToString = (window, timeZone = "PST") => {
  const hoursString = groupHours(window.hours);
  const daysString = groupDays(window.days);
  const prettyTimezone = timeZone === "America/Los_Angeles" ? "PST" : timeZone || "PST";
  return `${hoursString.join(", ")} on ${daysString.join(", ")} (${prettyTimezone})`;
};
const DeploymentWindow = ({ attributes }) => {
  if (!attributes)
    return null;
  const { allowedTimes, timezone, actualDeploys, maxDeploys } = attributes;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "DeploymentWindow"
  }, /* @__PURE__ */ React__default.createElement("ul", {
    className: "sp-margin-xs-top sp-padding-l-left sp-margin-2xs-bottom"
  }, allowedTimes.map((window, index) => /* @__PURE__ */ React__default.createElement("li", {
    key: index
  }, timeWindowToString(window, timezone)))), maxDeploys !== null && /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-xs-top"
  }, "Deployed ", actualDeploys || 0, " out of ", maxDeploys, " times in the current window"));
};
const getAllowedTimesStatus = ({ constraint }) => {
  var _a, _b, _c, _d;
  const maxDeploys = (_a = constraint.attributes) == null ? void 0 : _a.maxDeploys;
  switch (constraint.status) {
    case "BLOCKED":
      return "waiting for other constraints";
    case "OVERRIDE_PASS":
    case "FORCE_PASS":
      return "overridden by user";
    case "PASS":
      return "Deployed during the allowed windows";
    case "FAIL":
    case "PENDING":
      if (maxDeploys !== void 0 && (((_b = constraint.attributes) == null ? void 0 : _b.actualDeploys) || 0) >= maxDeploys) {
        return `reached the maximum allowed times per window`;
      }
      return `can only occur during the allowed window${((_d = (_c = constraint.attributes) == null ? void 0 : _c.allowedTimes.length) != null ? _d : 0) > 1 ? "s" : ""}`;
    default:
      return constraint.status;
  }
};
const AllowedTimesDescription = ({ constraint }) => {
  return /* @__PURE__ */ React__default.createElement(DeploymentWindow, {
    attributes: constraint.attributes
  });
};

const getDependsOnStatus = ({ constraint }) => {
  const prerequisiteEnv = constraint.attributes.dependsOnEnvironment.toUpperCase();
  switch (constraint.status) {
    case "PASS":
      return `deployment to ${prerequisiteEnv} succeeded`;
    case "FORCE_PASS":
      return `deployment to ${prerequisiteEnv} was overridden`;
    case "FAIL":
      return `deployment to ${prerequisiteEnv} failed`;
    case "PENDING":
      return `awaiting deployment to ${prerequisiteEnv}`;
    default:
      return `Environment: ${prerequisiteEnv}, status: ${constraint.status}`;
  }
};

const getManualJudgementStatus = ({ constraint }) => {
  switch (constraint.status) {
    case "NOT_EVALUATED":
    case "BLOCKED":
      return "waiting for other constraints";
    case "PENDING":
      return "pending";
    case "OVERRIDE_PASS":
    case "FORCE_PASS":
    case "PASS":
      return `approved by ${constraint.judgedBy}`;
    case "FAIL":
    case "OVERRIDE_FAIL":
      return `rejected by ${constraint.judgedBy}`;
    default:
      console.error(new Error(`Unrecognized constraint status - ${JSON.stringify(constraint)}`));
      return constraint.status;
  }
};

const UNKNOWN_CONSTRAINT_ICON = "mdConstraintGeneric";
const constraintHasNotStarted = ["PENDING", "NOT_EVALUATED"];
const constraintBlocked = ["BLOCKED", "NOT_EVALUATED"];
const hasSkippedConstraint = (constraint, environment) => environment.state === "skipped" && constraintHasNotStarted.includes(constraint.status);
class ConstraintsManager extends BasePluginManager {
  constructor() {
    super(...arguments);
    this.defaultShowRestart = ({ constraint }) => {
      return constraint.status === "FAIL";
    };
  }
  getIcon(constraint) {
    var _a;
    const iconName = (_a = this.getHandler(constraint.type)) == null ? void 0 : _a.iconName;
    if (typeof iconName === "string") {
      return iconName;
    }
    return (iconName == null ? void 0 : iconName[constraint.status]) || (iconName == null ? void 0 : iconName["DEFAULT"]) || UNKNOWN_CONSTRAINT_ICON;
  }
  renderTitle(constraint) {
    const handler = this.getHandler(constraint.type);
    if (handler == null ? void 0 : handler.displayTitle) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, handler.displayTitle.displayName, " - ", handler.displayTitle.displayStatus({ constraint }));
    }
    const Component = handler == null ? void 0 : handler.titleRender;
    if (Component) {
      return /* @__PURE__ */ React__default.createElement(Component, {
        constraint
      });
    }
    return `${constraint.type} - ${constraint.status}`;
  }
  hasContent(constraint) {
    var _a;
    const overrideActions = this.getActions(constraint);
    return Boolean((_a = this.getHandler(constraint.type)) == null ? void 0 : _a.descriptionRender) || !isEmpty(overrideActions);
  }
  renderDescription(constraint) {
    var _a;
    const Component = (_a = this.getHandler(constraint.type)) == null ? void 0 : _a.descriptionRender;
    if (Component) {
      return /* @__PURE__ */ React__default.createElement(Component, {
        constraint
      });
    }
    return null;
  }
  getTimestamp(constraint, environment) {
    const { startedAt, judgedAt } = constraint;
    if (hasSkippedConstraint(constraint, environment)) {
      return void 0;
    }
    const finalTime = judgedAt != null ? judgedAt : startedAt;
    return finalTime ? DateTime.fromISO(finalTime) : void 0;
  }
  getActions(constraint, environmentState) {
    var _a;
    if (environmentState === "skipped" || constraintBlocked.includes(constraint.status)) {
      return void 0;
    }
    const actions = (_a = this.getHandler(constraint.type)) == null ? void 0 : _a.overrideActions;
    return actions == null ? void 0 : actions[constraint.status];
  }
  isRestartVisible(constraint) {
    var _a, _b;
    const showRestartFunc = ((_b = (_a = this.getHandler(constraint.type)) == null ? void 0 : _a.restartProps) == null ? void 0 : _b.isVisible) || this.defaultShowRestart;
    return showRestartFunc({ constraint });
  }
  getRestartDisplayName(constraint) {
    var _a, _b;
    return ((_b = (_a = this.getHandler(constraint.type)) == null ? void 0 : _a.restartProps) == null ? void 0 : _b.displayName) || "Reset";
  }
}
const baseHandlers = [
  {
    kind: "allowed-times",
    iconName: { DEFAULT: "mdConstraintAllowedTimes" },
    displayTitle: {
      displayName: "Deployment Window",
      displayStatus: getAllowedTimesStatus
    },
    descriptionRender: AllowedTimesDescription,
    overrideActions: {
      FAIL: [
        {
          title: "Skip constraint",
          pass: true
        }
      ]
    },
    restartProps: {
      isVisible: () => false
    }
  },
  {
    kind: "depends-on",
    iconName: { DEFAULT: "mdConstraintDependsOn" },
    displayTitle: {
      displayName: "Depends on",
      displayStatus: getDependsOnStatus
    },
    restartProps: {
      isVisible: () => false
    }
  },
  {
    kind: "manual-judgement",
    iconName: {
      PASS: "manualJudgementApproved",
      OVERRIDE_PASS: "manualJudgementApproved",
      FAIL: "manualJudgementRejected",
      OVERRIDE_FAIL: "manualJudgementRejected",
      DEFAULT: "manualJudgement"
    },
    displayTitle: {
      displayName: "Manual Judgement",
      displayStatus: getManualJudgementStatus
    },
    overrideActions: {
      PENDING: [
        {
          title: "Reject",
          pass: false
        },
        {
          title: "Approve",
          pass: true
        }
      ]
    }
  }
];
const constraintsManager = new ConstraintsManager(baseHandlers);

const getConstraintsStatusSummary = (constraints) => {
  let finalStatus = "PASS";
  for (const { status } of constraints) {
    if (status === "FAIL") {
      finalStatus = "FAIL";
      break;
    } else if (status === "PENDING" || status === "BLOCKED") {
      finalStatus = "PENDING";
    } else if (status === "FORCE_PASS" && finalStatus !== "PENDING") {
      finalStatus = "FORCE_PASS";
    }
  }
  const byStatus = groupBy(constraints, (c) => {
    var _a;
    return ((_a = getActionStatusData(c.status)) == null ? void 0 : _a.displayName) || "pending";
  });
  const summary = ACTION_DISPLAY_NAMES.map((displayName) => {
    const constraintsOfStatus = byStatus[displayName];
    return constraintsOfStatus ? `${constraintsOfStatus.length} ${displayName}` : void 0;
  }).filter(Boolean).join(", ");
  return { text: summary, status: finalStatus };
};
const getLifecycleEventByType = (version, type) => {
  var _a;
  return (_a = version == null ? void 0 : version.lifecycleSteps) == null ? void 0 : _a.find((step) => step.type === type);
};
const getLifecycleEventDuration = (version, type) => {
  const event = getLifecycleEventByType(version, type);
  if (!event)
    return void 0;
  const { startedAt, completedAt } = event;
  if (startedAt && completedAt) {
    return timeDiffToString(DateTime.fromISO(startedAt), DateTime.fromISO(completedAt));
  }
  return void 0;
};
const isBaking = (version) => {
  var _a;
  return ((_a = getLifecycleEventByType(version, "BAKE")) == null ? void 0 : _a.status) === "RUNNING";
};
const getLifecycleEventSummary = (version, type) => {
  const event = getLifecycleEventByType(version, type);
  if (!event)
    return void 0;
  return {
    startedAt: event.startedAt ? DateTime.fromISO(event.startedAt) : void 0,
    duration: getLifecycleEventDuration(version, type),
    isRunning: event.status === "RUNNING",
    link: event.link
  };
};
const isVersionVetoed = (version) => (version == null ? void 0 : version.status) === "VETOED";
const isVersionPending = (version) => (version == null ? void 0 : version.status) === "APPROVED" || (version == null ? void 0 : version.status) === "PENDING";
const getRelativeAgeToCurrent = ({
  isCurrent,
  createdAt,
  currentVersion
}) => {
  if (isCurrent)
    return "CURRENT";
  if (!createdAt || !(currentVersion == null ? void 0 : currentVersion.createdAt) || new Date(createdAt).getTime() < new Date(currentVersion.createdAt).getTime())
    return "OLDER";
  return "NEWER";
};
const extractVersionRollbackDetails = (version) => {
  var _a, _b, _c;
  return {
    buildNumber: version.buildNumber,
    commitMessage: (_b = (_a = version.gitMetadata) == null ? void 0 : _a.commitInfo) == null ? void 0 : _b.message,
    commitSha: (_c = version.gitMetadata) == null ? void 0 : _c.commit,
    createdAt: version.createdAt
  };
};

var css_248z$1B = ".Constraints {\n  margin-top: var(--s-spacing);\n  color: var(--color-dovegray);\n}\n.Constraints .constraints-icon {\n  margin-top: 3px;\n  align-self: flex-start;\n}\n.Constraints .version-constraint {\n  display: grid;\n  grid-template-columns: 14px auto;\n  -moz-column-gap: 6px;\n       column-gap: 6px;\n  align-items: center;\n}\n.Constraints .version-constraint .constraint-toggle {\n  color: inherit;\n  display: flex;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.Constraints .version-constraint .constraint-title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: inherit;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n.Constraints .version-constraint .constraint-title > svg {\n  margin-left: var(--2xs-spacing);\n  padding-top: 2px;\n  transition: transform 0.15s ease;\n}\n.Constraints .version-constraint .constraint-icon {\n  margin-top: 5px;\n  align-self: flex-start;\n}\n.Constraints .version-constraint.single-constraint {\n  grid-template-columns: 12px auto;\n}\n.Constraints .single-constraint .constraint-content {\n  margin-top: var(--s-spacing);\n  margin-bottom: var(--m-spacing);\n}\n.Constraints .single-constraint .constraint-content .constraint-action-button {\n  min-width: 80px;\n  font-size: 13px;\n  padding: var(--2xs-spacing) var(--s-spacing);\n  margin-right: var(--s-spacing);\n}\n.Constraints .single-constraint:last-child .constraint-content {\n  margin-bottom: 0;\n}\n";
styleInject(css_248z$1B);

const ConstraintContent = ({ constraint, versionProps }) => {
  var _a;
  const description = constraintsManager.renderDescription(constraint);
  const actions = (_a = constraintsManager.getActions(constraint)) == null ? void 0 : _a.sort((action) => action.pass ? -1 : 1);
  const application = useApplicationContextSafe();
  const logEvent = useLogEvent("ArtifactConstraints", "UpdateStatus");
  const refetchVariables = { appName: application.name, versions: [versionProps.version] };
  const refetchQueries = [{ query: FetchVersionDocument, variables: refetchVariables }];
  const showRestartButton = constraintsManager.isRestartVisible(constraint);
  const baseRequestProps = {
    application: application.name,
    environment: versionProps.environment,
    version: versionProps.version,
    reference: versionProps.reference,
    type: constraint.type
  };
  const [
    updateConstraint,
    { loading: isUpdatingConstraint, error: updateConstraintError }
  ] = useUpdateConstraintMutation({ refetchQueries });
  const [
    restartConstraint,
    { loading: isRestartingConstraint, error: restartConstraintError }
  ] = useRestartConstraintEvaluationMutation({
    variables: { payload: baseRequestProps },
    refetchQueries
  });
  useNotifyOnError({
    key: "updateConstraintError",
    content: `Failed to update constraint`,
    error: updateConstraintError
  });
  useNotifyOnError({
    key: "restartConstraintError",
    content: `Failed to restart constraint`,
    error: restartConstraintError
  });
  return /* @__PURE__ */ React__default.createElement("dl", {
    className: "constraint-content"
  }, description && /* @__PURE__ */ React__default.createElement("dd", null, description), (!isEmpty(actions) || showRestartButton) && /* @__PURE__ */ React__default.createElement("dd", {
    className: classNames(description ? "sp-margin-s-top" : void 0, "horizontal middle")
  }, actions == null ? void 0 : actions.map(({ title, pass }) => /* @__PURE__ */ React__default.createElement("button", {
    className: classNames("btn md-btn constraint-action-button", pass ? "md-btn-success" : "md-btn-danger"),
    key: title,
    disabled: isUpdatingConstraint,
    onClick: () => {
      logEvent({ data: { newStatus: pass } });
      updateConstraint({
        variables: { payload: { ...baseRequestProps, status: pass ? "FORCE_PASS" : "FAIL" } }
      });
    }
  }, title)), showRestartButton && /* @__PURE__ */ React__default.createElement("button", {
    className: "btn md-btn constraint-action-button md-btn-accent",
    disabled: isUpdatingConstraint,
    onClick: () => {
      restartConstraint();
    }
  }, constraintsManager.getRestartDisplayName(constraint)), isUpdatingConstraint || isRestartingConstraint && /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular",
    size: "nano",
    color: "var(--color-accent)"
  })));
};
const Constraint = ({ constraint, versionProps }) => {
  const hasContent = constraintsManager.hasContent(constraint);
  const title = constraintsManager.renderTitle(constraint);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "version-constraint single-constraint"
  }, /* @__PURE__ */ React__default.createElement(VersionOperationIcon, {
    status: constraint.status,
    size: "small",
    className: "constraint-icon"
  }), /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    outerDivClassName: "",
    defaultExpanded: true,
    toggleClassName: "constraint-toggle",
    enableCaching: false,
    expandIconSize: "12px",
    expandIconPosition: "right",
    heading: ({ chevron }) => /* @__PURE__ */ React__default.createElement("div", {
      className: "constraint-title"
    }, /* @__PURE__ */ React__default.createElement("div", null, title, constraint.judgedAt && /* @__PURE__ */ React__default.createElement("span", {
      className: "sp-margin-xs-left"
    }, "(", /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
      timestamp: constraint.judgedAt,
      withSuffix: true
    }), ")")), chevron)
  }, hasContent || constraintsManager.isRestartVisible(constraint) ? /* @__PURE__ */ React__default.createElement(ConstraintContent, {
    constraint,
    versionProps
  }) : void 0));
};
const Constraints = ({
  constraints,
  versionProps,
  expandedByDefault
}) => {
  if (!constraints || !constraints.length)
    return null;
  const summary = getConstraintsStatusSummary(constraints);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "Constraints"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "version-constraint"
  }, /* @__PURE__ */ React__default.createElement(VersionOperationIcon, {
    status: summary.status,
    className: "constraints-icon"
  }), /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: ({ chevron }) => /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "uppercase"
    }, "Constraints"), ": ", summary.text, " ", chevron),
    outerDivClassName: "",
    toggleClassName: "constraint-toggle",
    bodyClassName: "sp-margin-xs-top sp-margin-xs-bottom",
    expandIconSize: "12px",
    expandIconPosition: "right",
    defaultExpanded: expandedByDefault,
    enableCaching: false
  }, constraints == null ? void 0 : constraints.map((constraint, index) => /* @__PURE__ */ React__default.createElement(Constraint, {
    key: index,
    constraint,
    versionProps
  })))));
};

var css_248z$1A = ".GitLink {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.GitLink .git-link-inner {\n  display: flex;\n  flex-direction: row;\n  align-self: flex-start;\n  max-width: 100%;\n}\n.GitLink .commit-message {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 600;\n  color: var(--color-text-link-g1);\n}\n.git-commit-tooltip {\n  max-height: 300px;\n  overflow: auto;\n}\n";
styleInject(css_248z$1A);

const GitLink = ({ gitMetadata: { commit, commitInfo, pullRequest }, asLink = true }) => {
  const link = (pullRequest == null ? void 0 : pullRequest.link) || (commitInfo == null ? void 0 : commitInfo.link);
  let message = (commitInfo == null ? void 0 : commitInfo.message) || commit;
  message = (commit ? `[${commit}] ` : ``) + (message == null ? void 0 : message.split("\n")[0]);
  const logEvent = useLogEvent("Artifact", "OpenCommit");
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "GitLink"
  }, /* @__PURE__ */ React__default.createElement(HoverablePopover, {
    ...tooltipShowHideProps,
    wrapperClassName: "git-link-inner no-underline",
    placement: "top",
    Component: () => /* @__PURE__ */ React__default.createElement("div", {
      className: "git-commit-tooltip"
    }, commit && !asLink && /* @__PURE__ */ React__default.createElement("a", {
      href: link,
      target: "_blank",
      className: "horizontal sp-margin-m-bottom",
      onClick: () => {
        logEvent();
      }
    }, "Open commit ", commit), (commitInfo == null ? void 0 : commitInfo.message) && /* @__PURE__ */ React__default.createElement(Markdown, {
      message: commitInfo == null ? void 0 : commitInfo.message
    }))
  }, asLink ? /* @__PURE__ */ React__default.createElement("a", {
    href: link || "#",
    className: "commit-message",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: () => {
      logEvent();
    }
  }, message) : /* @__PURE__ */ React__default.createElement("span", {
    className: "commit-message"
  }, message)));
};

const VersionTitle = ({ gitMetadata, buildNumber }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "VersionTitle"
  }, gitMetadata ? /* @__PURE__ */ React__default.createElement(GitLink, {
    gitMetadata
  }) : /* @__PURE__ */ React__default.createElement("div", null, "Build ", buildNumber));
};

const ArtifactActions = ({ version, buildNumber, actions, compareLinks, className }) => {
  const compareActions = [
    { content: "Current version", href: compareLinks == null ? void 0 : compareLinks.current, disabled: !(compareLinks == null ? void 0 : compareLinks.current) },
    { content: "Previous version", href: compareLinks == null ? void 0 : compareLinks.previous, disabled: !(compareLinks == null ? void 0 : compareLinks.previous) }
  ];
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("horizontal md-actions-gap", className)
  }, actions == null ? void 0 : actions.map((action) => /* @__PURE__ */ React__default.createElement("button", {
    key: action.content,
    className: ACTION_BUTTON_CLASS_NAME,
    disabled: action.disabled,
    onClick: action.onClick
  }, action.content)), /* @__PURE__ */ React__default.createElement(CompareToMenu, {
    id: `${version}-${buildNumber}-compare`,
    title: "Compare to",
    actions: compareActions
  }));
};
const CompareToMenu = ({ id, title, actions, className, pullRight }) => {
  const logEvent = useLogEvent("ArtifactActions");
  return /* @__PURE__ */ React__default.createElement(Dropdown, {
    id,
    className: classNames("ArtifactActionsMenu", className),
    pullRight
  }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
    className: "md-btn md-action-button"
  }, title), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, null, actions.map((action, index) => /* @__PURE__ */ React__default.createElement(MenuItem, {
    key: index,
    disabled: action.disabled,
    onClick: () => {
      var _a;
      (_a = action.onClick) == null ? void 0 : _a.call(action);
      logEvent({ action: `Compare to - ${action.content}` });
    },
    href: action.href,
    target: "_blank"
  }, action.content))));
};

var css_248z$1z = ".ArtifactActionModal .details {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  -moz-column-gap: 10px;\n       column-gap: 10px;\n  align-items: baseline;\n}\n.ArtifactActionModal .details dd {\n  min-width: 0;\n}\n.ArtifactActionModal .details dt {\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 13px;\n  color: var(--color-concrete);\n}\n";
styleInject(css_248z$1z);

const MARK_BAD_DOCS_URL = getDocsUrl("markAsBad");
const PINNING_DOCS_URL = getDocsUrl("pinning");
const CLASS_NAME = "ArtifactActionModal";
const VersionDetails = ({ buildNumber, commitMessage, commitSha, title }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-xl-top"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "uppercase bold"
  }, title), /* @__PURE__ */ React__default.createElement("dl", {
    className: "details sp-margin-s-top"
  }, commitMessage && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Commit",
    value: /* @__PURE__ */ React__default.createElement(GitLink, {
      gitMetadata: { commitInfo: { message: commitMessage }, commit: commitSha },
      asLink: false
    })
  }), buildNumber && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Build #",
    value: buildNumber
  })));
};
const PinActionModal = ({
  actionProps,
  ...props
}) => {
  const {
    application,
    selectedVersion: { buildNumber },
    isCurrent,
    environment,
    ageRelativeToCurrent,
    currentVersion
  } = actionProps;
  const rollingType = ageRelativeToCurrent === "NEWER" ? "forward" : "back";
  return /* @__PURE__ */ React__default.createElement(ActionModal, {
    logCategory: "Environments::Artifact",
    className: CLASS_NAME,
    ...props
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "sp-margin-m-right",
    style: { minWidth: 145 }
  }, /* @__PURE__ */ React__default.createElement(Illustration, {
    name: "pinArtifactVersion"
  })), /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("p", null, isCurrent ? `Pinning ensures an environment uses a specific version, even if Spinnaker would've normally deployed a
  different one. New versions won't be deployed until you unpin this version.` : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "Rolling ", rollingType, " will:", /* @__PURE__ */ React__default.createElement("ul", {
    className: "sp-margin-xs-top"
  }, /* @__PURE__ */ React__default.createElement("li", null, "Ignore any constraints on this version"), /* @__PURE__ */ React__default.createElement("li", null, "Deploy this version immediately"), /* @__PURE__ */ React__default.createElement("li", null, "Pin this version to ", environment.toLocaleUpperCase(), " so no other versions deploy until you unpin")))), "For more information", " ", /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    onClick: () => logger.log({
      category: "Environments - pin version modal",
      action: "Pinning docs link clicked",
      data: { label: application, application }
    }),
    href: PINNING_DOCS_URL
  }, "check out our documentation"), ".", /* @__PURE__ */ React__default.createElement("p", null), isCurrent ? /* @__PURE__ */ React__default.createElement("p", null, "Version #", buildNumber, " is already live and no actions will be take immediately") : /* @__PURE__ */ React__default.createElement("div", null, currentVersion && /* @__PURE__ */ React__default.createElement(VersionDetails, {
    title: "Live Version",
    ...extractVersionRollbackDetails(currentVersion)
  }), /* @__PURE__ */ React__default.createElement(VersionDetails, {
    title: `Rolling ${rollingType} to`,
    ...actionProps.selectedVersion
  })))));
};
const UnpinActionModal = ({ actionProps, ...props }) => {
  const { application, environment, isCurrent } = actionProps;
  return /* @__PURE__ */ React__default.createElement(ActionModal, {
    logCategory: "Environments::Artifact",
    className: CLASS_NAME,
    ...props
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "sp-margin-m-right",
    style: { minWidth: 145 }
  }, /* @__PURE__ */ React__default.createElement(Illustration, {
    name: "unpinArtifactVersion"
  })), /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("p", null, "When you unpin this version from ", environment.toUpperCase(), ", Spinnaker will use the latest version that's approved for deployment. For more information,", " ", /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    onClick: () => logger.log({
      category: "Environments - unpin version modal",
      action: "Pinning docs link clicked",
      data: { label: application, application }
    }),
    href: PINNING_DOCS_URL
  }, "Check out our documentation"), "."), /* @__PURE__ */ React__default.createElement(VersionDetails, {
    title: isCurrent ? "Current version" : "Unpinned version",
    ...actionProps.selectedVersion
  }))));
};
const MarkAsBadActionModal = ({ actionProps, ...props }) => {
  const {
    application,
    isCurrent,
    selectedVersion: { buildNumber }
  } = actionProps;
  const environment = actionProps.environment.toUpperCase();
  return /* @__PURE__ */ React__default.createElement(ActionModal, {
    logCategory: "Environments::Artifact",
    className: CLASS_NAME,
    ...props
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "sp-margin-m-right",
    style: { minWidth: 145 }
  }, /* @__PURE__ */ React__default.createElement(Illustration, {
    name: "markArtifactVersionAsBad"
  })), /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("p", null, isCurrent ? `Spinnaker will immediately deploy the latest version approved for deployment to ${environment}. Version #${buildNumber} will be rejected and will not be deployed again` : `This action will reject version ${buildNumber} and Spinnaker will not be deploy it to ${environment}. This will not affect the live version`, ". For more information,", " ", /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    onClick: () => logger.log({
      category: "Environments - mark version as bad modal",
      action: "Mark as bad docs link clicked",
      data: { label: application, application }
    }),
    href: MARK_BAD_DOCS_URL
  }, "Check out our documentation"), "."), /* @__PURE__ */ React__default.createElement(VersionDetails, {
    title: "Rejected version",
    ...actionProps.selectedVersion
  }))));
};
const MarkAsGoodActionModal = ({ actionProps, ...props }) => {
  return /* @__PURE__ */ React__default.createElement(ActionModal, {
    logCategory: "Environments::Artifact",
    className: CLASS_NAME,
    ...props
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "sp-margin-m-right",
    style: { minWidth: 145 }
  }, /* @__PURE__ */ React__default.createElement(Illustration, {
    name: "markArtifactVersionAsGood"
  })), /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("p", null, "This action will allow Spinnaker to deploy this version again. If this is the latest version, it will be deployed immediately."), /* @__PURE__ */ React__default.createElement(VersionDetails, {
    title: "Allowed Version",
    ...actionProps.selectedVersion
  }))));
};

const useUnpinVersion = (payload) => {
  const {
    application,
    environment,
    reference,
    selectedVersion: { buildNumber, commitMessage }
  } = payload;
  const [onUnpin] = useUnpinVersionMutation({
    variables: { payload: { application, environment, reference } },
    refetchQueries: [{ query: FetchPinnedVersionsDocument, variables: { appName: application } }]
  });
  return () => {
    showModal(UnpinActionModal, {
      title: [`Unpin #${buildNumber}`, commitMessage].filter(Boolean).join(" - "),
      actionName: "Unpin",
      onAction: async () => {
        await onUnpin();
      },
      withComment: false,
      actionProps: payload
    }, { maxWidth: MODAL_MAX_WIDTH });
  };
};
const pinAction = {
  CURRENT: "Pin",
  NEWER: "Roll forward",
  OLDER: "Roll back"
};
const usePinVersion = (payload, currentVersion, ageRelativeToCurrent) => {
  const {
    application,
    environment,
    version,
    reference,
    selectedVersion: { buildNumber }
  } = payload;
  const [onPin] = usePinVersionMutation({
    refetchQueries: [{ query: FetchPinnedVersionsDocument, variables: { appName: payload.application } }]
  });
  const titleOptions = {
    CURRENT: `Pin #${buildNumber}`,
    NEWER: `Roll forward to #${buildNumber} and pin to ${environment.toUpperCase()}`,
    OLDER: `Roll back to #${buildNumber} and pin to ${environment.toUpperCase()}`
  };
  return () => {
    showModal(PinActionModal, {
      title: titleOptions[ageRelativeToCurrent],
      actionName: pinAction[ageRelativeToCurrent],
      onAction: async (comment) => {
        if (!comment)
          throw new Error("Comment is required");
        await onPin({ variables: { payload: { application, environment, reference, version, comment } } });
      },
      actionProps: { ...payload, ageRelativeToCurrent, currentVersion }
    }, { maxWidth: MODAL_MAX_WIDTH });
  };
};
const useMarkVersionAsBad = (payload) => {
  const {
    application,
    environment,
    reference,
    version,
    isCurrent,
    selectedVersion: { buildNumber }
  } = payload;
  const [onMarkAsBad] = useMarkVersionAsBadMutation({
    refetchQueries: [{ query: FetchVersionDocument, variables: { appName: payload.application, versions: [version] } }]
  });
  return () => {
    showModal(MarkAsBadActionModal, {
      title: (isCurrent ? `Roll back ${environment.toUpperCase()} to previous version and reject ` : "Reject") + ` #${buildNumber}`,
      actionName: "Rollback",
      onAction: async (comment) => {
        if (!comment)
          throw new Error("Comment is required");
        await onMarkAsBad({ variables: { payload: { application, environment, reference, version, comment } } });
      },
      actionProps: payload,
      isCurrent
    }, { maxWidth: MODAL_MAX_WIDTH });
  };
};
const useMarkVersionAsGood = (payload) => {
  const {
    application,
    environment,
    reference,
    version,
    selectedVersion: { buildNumber, commitMessage }
  } = payload;
  const [onMarkAsBad] = useMarkVersionAsGoodMutation({
    refetchQueries: [{ query: FetchVersionDocument, variables: { appName: payload.application, versions: [version] } }]
  });
  return () => {
    showModal(MarkAsGoodActionModal, {
      title: [`Allow deploying #${buildNumber}`, commitMessage].filter(Boolean).join(" - "),
      actionName: "Allow",
      onAction: async () => {
        await onMarkAsBad({ variables: { payload: { application, environment, reference, version } } });
      },
      withComment: false,
      actionProps: payload
    }, { maxWidth: MODAL_MAX_WIDTH });
  };
};

const useGetCurrentVersion = (environment, reference) => {
  var _a, _b, _c, _d, _e;
  const application = useApplicationContextSafe();
  const { data: currentVersionData } = useFetchCurrentVersionQuery({ variables: { appName: application.name } });
  const currentVersion = (_e = (_d = (_c = (_b = (_a = currentVersionData == null ? void 0 : currentVersionData.application) == null ? void 0 : _a.environments.find((e) => e.name === environment)) == null ? void 0 : _b.state.artifacts) == null ? void 0 : _c.find((artifact) => artifact.reference === reference)) == null ? void 0 : _d.versions) == null ? void 0 : _e[0];
  return currentVersion;
};
const rollbackText = {
  CURRENT: "Pin version...",
  NEWER: "Roll forward to...",
  OLDER: "Roll back to..."
};
const useCreateVersionRollbackActions = (props) => {
  const application = useApplicationContextSafe();
  const { environment, reference, isPinned, isVetoed, isCurrent, selectedVersion } = props;
  const currentVersion = useGetCurrentVersion(environment, reference);
  const relativeAgeToCurrent = getRelativeAgeToCurrent({
    isCurrent,
    createdAt: selectedVersion.createdAt,
    currentVersion
  });
  const basePayload = { application: application.name, ...props };
  const onUnpin = useUnpinVersion(basePayload);
  const onPin = usePinVersion(basePayload, currentVersion, relativeAgeToCurrent);
  const onMarkAsBad = useMarkVersionAsBad(basePayload);
  const onMarkAsGood = useMarkVersionAsGood(basePayload);
  const actions = [
    isPinned ? {
      content: "Unpin version...",
      onClick: onUnpin
    } : {
      content: rollbackText[relativeAgeToCurrent],
      onClick: onPin
    }
  ];
  if (isVetoed) {
    actions.push({
      content: "Allow deploying...",
      onClick: onMarkAsGood
    });
  } else {
    if (!isCurrent) {
      actions.push({
        content: isCurrent ? "Rollback..." : "Reject...",
        onClick: onMarkAsBad
      });
    }
  }
  return actions;
};

const copyTextToClipboard = (text) => {
  const input = document.createElement("textarea");
  input.style.opacity = "0";
  input.innerHTML = text;
  document.body.appendChild(input);
  input.select();
  const result = document.execCommand("copy");
  document.body.removeChild(input);
  return result;
};

var css_248z$1y = ".VersionMetadata {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 6px;\n  color: var(--color-nobel);\n  white-space: pre-wrap;\n  font-size: 13px;\n  flex-wrap: wrap;\n  line-height: 1.6;\n}\n.VersionMetadata i {\n  color: var(--color-nobel);\n}\n.VersionMetadata .HoverablePopover {\n  text-decoration: none;\n}\n.VersionMetadata .metadata-icon {\n  margin-right: 6px;\n  display: flex;\n}\n.VersionMetadata .metadata-icon > svg {\n  height: 16px;\n}\n.VersionMetadata i.metadata-icon {\n  font-size: 12px;\n}\n.VersionMetadata .version-badge {\n  border-radius: 3px;\n  padding: 1px var(--s-spacing) 0;\n  display: flex;\n  min-width: 50px;\n  justify-content: center;\n  flex-direction: row;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 12px;\n  letter-spacing: 0.4px;\n}\n.VersionMetadata .version-deploying {\n  -webkit-animation: deployingAnimation 2s infinite;\n          animation: deployingAnimation 2s infinite;\n  color: var(--color-mineshaft);\n}\n.VersionMetadata .version-baking {\n  background-color: var(--color-accent-g1);\n  color: var(--color-black);\n}\n.VersionMetadata .version-deployed {\n  background-color: var(--color-status-success);\n  color: var(--color-white);\n}\n.VersionMetadata .version-pinned {\n  background-color: var(--color-status-warning-light);\n}\n.VersionMetadata .version-vetoed {\n  background-color: var(--color-status-error-light);\n}\n.VersionMetadata .version-message {\n  color: var(--color-mineshaft);\n  border-radius: 4px;\n  padding: var(--s-spacing);\n  padding-right: var(--l-spacing);\n  display: grid;\n  grid-gap: var(--xs-spacing);\n  grid-template-columns: auto auto;\n  align-items: flex-start;\n}\n.VersionMetadata .created-at a {\n  color: inherit;\n}\n.LifecycleEventDetails .title {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.LifecycleEventDetails .details {\n  display: grid;\n  grid-template-columns: minmax(80px, auto) auto;\n  -moz-column-gap: 10px;\n       column-gap: 10px;\n  align-items: baseline;\n}\n.LifecycleEventDetails .details dt {\n  text-transform: uppercase;\n  font-size: 13px;\n  color: var(--color-concrete);\n  font-weight: 600;\n}\n";
styleInject(css_248z$1y);

const MetadataElement = ({ className, children }) => {
  return /* @__PURE__ */ React__default.createElement("span", {
    className: classNames("delimited-element horizontal middle", className)
  }, children);
};
const METADATA_TEXT_COLOR = "nobel";
const toPinnedMetadata = (data) => ({
  by: data.pinnedBy,
  at: data.pinnedAt,
  comment: data.comment
});
const toVetoedMetadata = (data) => ({
  by: data.vetoedBy,
  at: data.vetoedAt,
  comment: data.comment
});
const useCreateVersionLink = (linkProps) => {
  return useSref("home.applications.application.environments.history", linkProps);
};
const VersionCreatedAt = ({ createdAt, linkProps }) => {
  const { href } = useCreateVersionLink(linkProps);
  if (!createdAt)
    return null;
  return /* @__PURE__ */ React__default.createElement(MetadataElement, {
    className: "created-at"
  }, /* @__PURE__ */ React__default.createElement(Tooltip, {
    delayShow: TOOLTIP_DELAY_SHOW,
    value: "Created at"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "far fa-calendar-alt metadata-icon"
  })), /* @__PURE__ */ React__default.createElement("a", {
    href,
    onClick: (e) => {
      href && copyTextToClipboard([window.location.origin, href].join("/"));
      e.stopPropagation();
    }
  }, /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: createdAt,
    delayShow: TOOLTIP_DELAY_SHOW,
    removeStyles: true,
    withSuffix: true
  })));
};
const badgeTypeToDetails = {
  deploying: { className: "version-deploying", text: "Deploying" },
  baking: { className: "version-baking", text: "Baking" },
  deployed: { className: "version-deployed", text: "Live" }
};
const MetadataBadge = ({ type, link, tooltip }) => {
  const details = badgeTypeToDetails[type];
  const className = classNames("version-badge", details.className);
  const baseBadge = link ? /* @__PURE__ */ React__default.createElement("a", {
    href: link,
    className
  }, details.text) : /* @__PURE__ */ React__default.createElement("span", {
    className
  }, details.text);
  return /* @__PURE__ */ React__default.createElement(MetadataElement, null, tooltip ? /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: tooltip,
    delayShow: TOOLTIP_DELAY_SHOW
  }, baseBadge) : baseBadge);
};
const versionTypeProps = {
  pinned: {
    text: "Pinned by",
    className: "version-pinned",
    icon: "pin"
  },
  vetoed: {
    text: "Rejected by",
    className: "version-vetoed",
    icon: "artifactBad"
  }
};
const VersionMessage = ({ data, type, newRow = true }) => {
  const typeProps = versionTypeProps[type];
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, newRow && /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-break sp-margin-s-top"
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("version-message", typeProps.className)
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    name: typeProps.icon,
    size: "14px",
    color: METADATA_TEXT_COLOR,
    className: "sp-margin-2xs-top"
  }), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, typeProps.text, " ", data.by, ",", " ", data.at && /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: data.at,
    delayShow: TOOLTIP_DELAY_SHOW,
    withSuffix: true,
    removeStyles: true
  })), data.comment && /* @__PURE__ */ React__default.createElement("div", null, "Reason: ", data.comment))));
};
const VersionAuthor = ({ author }) => {
  if (!author)
    return null;
  return /* @__PURE__ */ React__default.createElement(MetadataElement, null, "By ", author);
};
const VersionBranch = ({ branch }) => {
  if (!branch)
    return null;
  return /* @__PURE__ */ React__default.createElement(MetadataElement, null, /* @__PURE__ */ React__default.createElement(Icon, {
    name: "spCIBranch",
    size: "11px",
    className: "sp-margin-xs-right",
    color: METADATA_TEXT_COLOR
  }), " ", branch);
};
const VersionBuild = ({ build, withPrefix }) => {
  const logEvent = useLogEvent("ArtifactBuild", "OpenBuild");
  const text = `${withPrefix ? `Build ` : ""}#${build.buildNumber}`;
  const content = build.link ? /* @__PURE__ */ React__default.createElement("a", {
    href: build.link,
    onClick: () => logEvent({ data: { build: build.buildNumber } })
  }, text) : text;
  return build.version ? /* @__PURE__ */ React__default.createElement(HoverablePopover, {
    Component: () => /* @__PURE__ */ React__default.createElement(LifecycleEventDetails, {
      ...build,
      title: "Build",
      showLink: false
    }),
    delayShow: TOOLTIP_DELAY_SHOW
  }, /* @__PURE__ */ React__default.createElement("span", null, content)) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, content);
};
const VersionBuilds = ({ builds }) => {
  if (!builds.length)
    return null;
  return /* @__PURE__ */ React__default.createElement(MetadataElement, null, builds.length === 1 ? /* @__PURE__ */ React__default.createElement(VersionBuild, {
    build: builds[0],
    withPrefix: true
  }) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "Builds", " ", sortBy(builds, (build) => build.buildNumber).map((build, index) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
    key: index
  }, /* @__PURE__ */ React__default.createElement(VersionBuild, {
    build,
    withPrefix: false
  }), Boolean(index < builds.length - 1) && ", "))));
};
const BaseVersionMetadata = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "VersionMetadata"
  }, children);
};
const LifecycleEventDetails = ({
  version,
  duration,
  link,
  startedAt,
  title,
  showLink = true
}) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "LifecycleEventDetails"
  }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
    className: "title sp-margin-xs-bottom"
  }, title), /* @__PURE__ */ React__default.createElement("dl", {
    className: "details sp-margin-s-bottom"
  }, version && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Version",
    value: version
  }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Started at",
    value: `${(startedAt == null ? void 0 : startedAt.toFormat(ABSOLUTE_TIME_FORMAT)) || "N/A"} ${startedAt ? ` (${formatToRelativeTimestamp(startedAt, true)})` : ""}`
  }), /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Duration",
    value: duration || "N/A"
  }), showLink && link && /* @__PURE__ */ React__default.createElement(LabeledValue, {
    label: "Link",
    value: /* @__PURE__ */ React__default.createElement("a", {
      href: link
    }, "Open")
  }))));
};
const statusToProps = {
  CURRENT: {
    icon: "cloudDeployed",
    tooltip: "Deployed at"
  },
  PENDING: {
    icon: "cloudWaiting",
    tooltip: "Deployment pending"
  },
  PREVIOUS: {
    icon: "cloudDecommissioned",
    tooltip: "Replaced by another version"
  },
  SKIPPED: {
    icon: "artifactSkipped",
    tooltip: "Deployment skipped"
  }
};
const DeploymentStatus = ({ deployedAt, isCurrent, isPending, isDeploying }) => {
  if (!deployedAt && isDeploying)
    return null;
  const props = statusToProps[deployedAt ? isCurrent ? "CURRENT" : "PREVIOUS" : isPending ? "PENDING" : "SKIPPED"];
  return /* @__PURE__ */ React__default.createElement(MetadataElement, null, /* @__PURE__ */ React__default.createElement(IconTooltip, {
    tooltip: props.tooltip,
    name: props.icon,
    size: "14px",
    wrapperClassName: "metadata-icon",
    delayShow: TOOLTIP_DELAY_SHOW,
    color: METADATA_TEXT_COLOR
  }), deployedAt ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "Deployed ", /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: deployedAt,
    delayShow: TOOLTIP_DELAY_SHOW,
    removeStyles: true,
    withSuffix: true
  })) : isPending ? "Pending" : "Not deployed");
};

const getVersionCompareLinks = (version) => {
  var _a, _b, _c, _d;
  return {
    current: (_b = (_a = version.gitMetadata) == null ? void 0 : _a.comparisonLinks) == null ? void 0 : _b.toCurrentVersion,
    previous: (_d = (_c = version.gitMetadata) == null ? void 0 : _c.comparisonLinks) == null ? void 0 : _d.toPreviousVersion
  };
};
const getBaseMetadata = (version) => {
  var _a;
  return {
    build: {
      buildNumber: version.buildNumber,
      version: version.version,
      ...getLifecycleEventSummary(version, "BUILD")
    },
    author: (_a = version.gitMetadata) == null ? void 0 : _a.author,
    isPending: isVersionPending(version),
    deployedAt: version.deployedAt,
    isCurrent: version.isCurrent,
    isDeploying: version.status === "DEPLOYING",
    bake: getLifecycleEventSummary(version, "BAKE"),
    vetoed: version.veto ? toVetoedMetadata(version.veto) : void 0
  };
};
const VersionMetadata = ({
  build,
  author,
  deployedAt,
  isPending,
  isCurrent,
  isDeploying,
  buildsBehind,
  bake,
  pinned,
  vetoed
}) => {
  return /* @__PURE__ */ React__default.createElement(BaseVersionMetadata, null, isCurrent && /* @__PURE__ */ React__default.createElement(MetadataBadge, {
    type: "deployed"
  }), isDeploying && /* @__PURE__ */ React__default.createElement(MetadataBadge, {
    type: "deploying"
  }), (bake == null ? void 0 : bake.isRunning) && /* @__PURE__ */ React__default.createElement(MetadataBadge, {
    type: "baking",
    link: bake.link,
    tooltip: `${bake.startedAt ? formatToRelativeTimestamp(bake.startedAt, true) : ""} (Click to view task)`
  }), (build == null ? void 0 : build.buildNumber) && /* @__PURE__ */ React__default.createElement(VersionBuilds, {
    builds: [build]
  }), /* @__PURE__ */ React__default.createElement(VersionAuthor, {
    author
  }), /* @__PURE__ */ React__default.createElement(DeploymentStatus, {
    ...{ deployedAt, isCurrent, isPending, isDeploying }
  }), (bake == null ? void 0 : bake.duration) && /* @__PURE__ */ React__default.createElement(MetadataElement, null, /* @__PURE__ */ React__default.createElement(HoverablePopover, {
    delayShow: 200,
    wrapperClassName: "vertical",
    Component: () => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(LifecycleEventDetails, {
      title: "Bake",
      ...bake
    }))
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    name: "bake",
    size: "13px",
    color: METADATA_TEXT_COLOR
  }))), buildsBehind ? /* @__PURE__ */ React__default.createElement(MetadataElement, null, buildsBehind, " build", buildsBehind > 1 ? "s" : "", " behind") : null, pinned && /* @__PURE__ */ React__default.createElement(VersionMessage, {
    type: "pinned",
    data: pinned
  }), vetoed && /* @__PURE__ */ React__default.createElement(VersionMessage, {
    type: "vetoed",
    data: vetoed
  }));
};

const NUM_VERSIONS_WHEN_COLLAPSED = 1;
const ArtifactVersions = ({ artifact, versions, title, isDeploying }) => {
  const numVersions = (versions == null ? void 0 : versions.length) || 0;
  const [isExpanded, setIsExpanded] = React__default.useState(false);
  const logEvent = useLogEvent("ArtifactPendingVersion");
  if (!versions || !numVersions)
    return null;
  const versionsToShow = isExpanded ? versions : versions.slice(0, NUM_VERSIONS_WHEN_COLLAPSED);
  const { pinnedVersion } = artifact;
  return /* @__PURE__ */ React__default.createElement(ArtifactCollapsibleSection, {
    outerDivClassName: "artifact-versions artifact-section",
    heading: title,
    isUpdating: isDeploying
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "artifact-pending-versions-list"
  }, versionsToShow.map((version, index) => /* @__PURE__ */ React__default.createElement(PendingVersion, {
    key: version.version,
    index,
    environment: artifact.environment,
    reference: artifact.reference,
    data: version,
    pinned: (pinnedVersion == null ? void 0 : pinnedVersion.version) === version.version ? toPinnedMetadata(pinnedVersion) : void 0
  })), numVersions > NUM_VERSIONS_WHEN_COLLAPSED ? /* @__PURE__ */ React__default.createElement("div", {
    className: "artifact-pending-version"
  }, /* @__PURE__ */ React__default.createElement("button", {
    type: "button",
    className: "btn btn-link show-more-versions",
    onClick: () => {
      setIsExpanded((state) => !state);
      logEvent({ action: isExpanded ? "ShowLess" : "ShowMore" });
    }
  }, isExpanded ? "Hide versions..." : "Show all versions...")) : void 0));
};
const PendingVersion = ({ data, reference, environment, pinned, index }) => {
  const { version, gitMetadata, constraints, isCurrent } = data;
  const actions = useCreateVersionRollbackActions({
    environment,
    reference,
    version,
    isVetoed: isVersionVetoed(data),
    isPinned: Boolean(pinned),
    isCurrent,
    selectedVersion: extractVersionRollbackDetails(data)
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "artifact-pending-version"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "artifact-pending-version-commit"
  }, /* @__PURE__ */ React__default.createElement(VersionTitle, {
    gitMetadata,
    buildNumber: data == null ? void 0 : data.buildNumber,
    version: data.version
  })), /* @__PURE__ */ React__default.createElement(VersionMetadata, {
    ...getBaseMetadata(data),
    pinned
  }), /* @__PURE__ */ React__default.createElement(ArtifactActions, {
    buildNumber: data == null ? void 0 : data.buildNumber,
    version: data.version,
    actions,
    compareLinks: getVersionCompareLinks(data),
    className: "sp-margin-s-yaxis"
  }), constraints && !isEmpty(constraints) && /* @__PURE__ */ React__default.createElement(Constraints, {
    key: index,
    constraints,
    versionProps: { environment, reference, version: data.version },
    expandedByDefault: index === 0
  }));
};

var css_248z$1x = ".ArtifactVersionTasks {\n  margin-top: var(--xs-spacing);\n  color: var(--color-dovegray);\n}\n.ArtifactVersionTasks .version-task {\n  display: grid;\n  grid-template-columns: 14px auto;\n  -moz-column-gap: 6px;\n       column-gap: 6px;\n  align-items: center;\n}\n.ArtifactVersionTasks .version-task > i {\n  font-size: 14px;\n  margin-top: 4px;\n  align-self: flex-start;\n}\n.ArtifactVersionTasks .version-task .task-runtime > i {\n  font-size: 12px;\n  margin-right: var(--xs-spacing);\n}\n.ArtifactVersionTasks .version-task .retry-task {\n  margin-top: var(--xs-spacing);\n}\n.ArtifactVersionTasks .version-task .retry-task button {\n  padding: var(--2xs-spacing) var(--s-spacing);\n}\n";
styleInject(css_248z$1x);

const statusToText$1 = {
  FAIL: "failed",
  FORCE_PASS: "has been overridden",
  PASS: "passed",
  PENDING: "in progress",
  NOT_EVALUATED: "has not started yet"
};
const ArtifactVersionTask = ({ type, artifact, task }) => {
  const status = task.status || "PENDING";
  const { link, startedAt, completedAt } = task;
  const logEvent = useLogEvent("ArtifactVersionTask");
  const app = useApplicationContextSafe();
  const [retryTask, { loading: mutationInFlight, error }] = useRetryVersionActionMutation({
    variables: {
      payload: {
        application: app.name,
        environment: artifact.environment,
        reference: artifact.reference,
        version: artifact.version,
        actionId: task.actionId,
        actionType: task.actionType
      }
    }
  });
  useNotifyOnError({ key: task.id, content: `Failed to re-run ${type}`, error });
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "version-task"
  }, /* @__PURE__ */ React__default.createElement(VersionOperationIcon, {
    status
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "task-content"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "delimited-element"
  }, type, " ", task.actionId, " ", statusToText$1[status], " ", startedAt && completedAt && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "(", /* @__PURE__ */ React__default.createElement(RelativeTimestamp, {
    timestamp: completedAt,
    withSuffix: true
  }), ")")), startedAt && /* @__PURE__ */ React__default.createElement("span", {
    className: "delimited-element task-runtime"
  }, /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: "Runtime duration",
    delayShow: TOOLTIP_DELAY_SHOW
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "far fa-clock"
  })), /* @__PURE__ */ React__default.createElement(DurationRender, {
    ...{ startedAt, completedAt }
  })), link && /* @__PURE__ */ React__default.createElement("span", {
    className: "delimited-element"
  }, /* @__PURE__ */ React__default.createElement("a", {
    href: link,
    target: "_blank",
    rel: "noreferrer"
  }, "View logs")), status === "FAIL" && artifact.isCurrent && /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-s-top horizontal middle"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default btn-sm sp-padding-2xs-yaxis sp-padding-s-xaxis",
    disabled: mutationInFlight,
    onClick: () => {
      retryTask();
      logEvent({ action: `Retry_${type}` });
    }
  }, "Retry ", type.toLowerCase()), mutationInFlight && /* @__PURE__ */ React__default.createElement(Spinner, {
    className: "sp-margin-s-left",
    mode: "circular",
    size: "nano",
    color: "var(--color-accent)"
  }))));
};
const ArtifactVersionTasks = ({ tasks, ...restProps }) => {
  if (!tasks || !tasks.length)
    return null;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "ArtifactVersionTasks"
  }, tasks.map((task) => /* @__PURE__ */ React__default.createElement(ArtifactVersionTask, {
    key: task.id,
    ...restProps,
    task
  })));
};

const CurrentVersionInternal = ({
  data,
  environment,
  reference,
  numNewerVersions,
  pinnedVersion,
  isPreview
}) => {
  const { gitMetadata, constraints, verifications, postDeploy, isCurrent } = data;
  const pinnedMetadata = (pinnedVersion == null ? void 0 : pinnedVersion.version) === data.version ? toPinnedMetadata(pinnedVersion) : void 0;
  const actions = useCreateVersionRollbackActions({
    environment,
    reference,
    version: data.version,
    isVetoed: isVersionVetoed(data),
    isPinned: Boolean(pinnedVersion),
    isCurrent,
    selectedVersion: extractVersionRollbackDetails(data)
  });
  const versionProps = {
    environment,
    reference,
    version: data.version,
    isCurrent
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "artifact-current-version"
  }, /* @__PURE__ */ React__default.createElement(VersionTitle, {
    gitMetadata,
    buildNumber: data == null ? void 0 : data.buildNumber,
    version: data.version
  }), /* @__PURE__ */ React__default.createElement(VersionMetadata, {
    ...getBaseMetadata(data),
    buildsBehind: numNewerVersions,
    pinned: pinnedMetadata
  }), !isPreview && /* @__PURE__ */ React__default.createElement(ArtifactActions, {
    buildNumber: data == null ? void 0 : data.buildNumber,
    version: data.version,
    actions,
    compareLinks: getVersionCompareLinks(data),
    className: "sp-margin-s-yaxis"
  }), constraints && /* @__PURE__ */ React__default.createElement(Constraints, {
    constraints,
    versionProps: { environment, reference, version: data.version }
  }), verifications && /* @__PURE__ */ React__default.createElement(ArtifactVersionTasks, {
    type: "Verification",
    artifact: versionProps,
    tasks: verifications
  }), postDeploy && /* @__PURE__ */ React__default.createElement(ArtifactVersionTasks, {
    type: "Post deploy",
    artifact: versionProps,
    tasks: postDeploy
  }));
};
const CurrentVersion = ({ data, ...otherProps }) => {
  return data ? /* @__PURE__ */ React__default.createElement(CurrentVersionInternal, {
    data,
    ...otherProps
  }) : /* @__PURE__ */ React__default.createElement("div", null, "No version is deployed");
};

const useIsUpdatingResources = (environment) => {
  var _a, _b;
  const app = useApplicationContextSafe();
  const { data } = useFetchResourceStatusQuery({ variables: { appName: app.name } });
  const resources = (_b = (_a = data == null ? void 0 : data.application) == null ? void 0 : _a.environments.find((env) => env.name === environment)) == null ? void 0 : _b.state.resources;
  return resources == null ? void 0 : resources.some((resource) => {
    var _a2;
    return ((_a2 = resource.state) == null ? void 0 : _a2.status) !== "UP_TO_DATE";
  });
};

var css_248z$1w = ".Artifact .artifact-current-version {\n  display: flex;\n  flex-direction: column;\n}\n.Artifact .artifact-section {\n  margin-left: -16px;\n}\n.Artifact .artifact-section-title {\n  text-transform: uppercase;\n  color: #737373;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n.Artifact .artifact-section-title .section-heading-chevron {\n  margin-top: -1px;\n}\n.Artifact .artifact-section-title .in-progress-dot {\n  margin-left: 6px;\n  margin-top: -1px;\n}\n.Artifact .artifact-versions {\n  position: relative;\n}\n.Artifact .artifact-versions .artifact-pending-versions-list .show-more-versions {\n  display: flex;\n  padding: 0;\n  flex-direction: row;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.Artifact .artifact-versions .artifact-pending-versions-list .artifact-pending-version {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.Artifact .artifact-versions .artifact-pending-versions-list .artifact-pending-version:not(:last-of-type) {\n  padding-bottom: 32px;\n}\n.Artifact .artifact-versions .artifact-pending-versions-list .artifact-pending-version .artifact-pending-version-commit {\n  font-weight: 600;\n  display: flex;\n  flex-direction: row;\n  white-space: pre-wrap;\n}\n.Artifact .another-version-pinned-warning {\n  margin-top: var(--s-spacing);\n  font-weight: 600;\n}\n.Artifact .another-version-pinned-warning > i {\n  color: var(--color-warning);\n}\n.Artifact .VersionTitle {\n  display: grid;\n  grid-template-columns: minmax(auto, -webkit-max-content) auto;\n  grid-template-columns: minmax(auto, max-content) auto;\n  align-items: baseline;\n  -moz-column-gap: 20px;\n       column-gap: 20px;\n  justify-content: flex-start;\n}\n";
styleInject(css_248z$1w);

const hasCreatedAt = (version) => {
  return Boolean(version == null ? void 0 : version.createdAt);
};
const sortVersions = (versions) => {
  return orderBy(versions || [], (version) => version.createdAt ? new Date(version.createdAt).getTime() : 0, [
    "desc"
  ]);
};
const filterPendingVersions = (versions, currentVersion) => {
  var _a;
  if (!hasCreatedAt(currentVersion)) {
    return sortVersions(versions);
  }
  const currentVersionCreatedAt = new Date(currentVersion.createdAt);
  const newerVersions = (_a = versions == null ? void 0 : versions.filter(hasCreatedAt)) == null ? void 0 : _a.filter((version) => new Date(version.createdAt) > currentVersionCreatedAt || version.status === "DEPLOYING");
  return sortVersions(newerVersions);
};
const PinnedVersion = ({ version }) => {
  var _a, _b;
  const commitMessage = (_b = (_a = version.gitMetadata) == null ? void 0 : _a.commitInfo) == null ? void 0 : _b.message;
  const build = `#${version.buildNumber}`;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "another-version-pinned-warning"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fas fa-exclamation-triangle"
  }), " Version", " ", commitMessage ? /* @__PURE__ */ React__default.createElement(HoverablePopover, {
    ...tooltipShowHideProps,
    placement: "top",
    Component: () => /* @__PURE__ */ React__default.createElement(Markdown, {
      className: "git-commit-tooltip",
      message: commitMessage
    })
  }, build) : build, " ", "was pinned and will be deployed shortly");
};
const RollbackAction = ({ currentVersion, environment, reference, isPinned }) => {
  var _a, _b, _c;
  const appName = useApplicationContextSafe().name;
  const onMarkAsBad = useMarkVersionAsBad({
    application: appName,
    environment,
    reference,
    version: currentVersion.version,
    isVetoed: isVersionVetoed(currentVersion),
    isPinned,
    isCurrent: true,
    selectedVersion: {
      buildNumber: currentVersion.buildNumber,
      commitMessage: (_b = (_a = currentVersion.gitMetadata) == null ? void 0 : _a.commitInfo) == null ? void 0 : _b.message,
      commitSha: (_c = currentVersion.gitMetadata) == null ? void 0 : _c.commit
    }
  });
  return /* @__PURE__ */ React__default.createElement("button", {
    className: ACTION_BUTTON_CLASS_NAME,
    onClick: onMarkAsBad
  }, "Rollback...");
};
const ArtifactResources = ({ environment, resources }) => {
  const isUpdatingResources = useIsUpdatingResources(environment);
  return /* @__PURE__ */ React__default.createElement(ArtifactCollapsibleSection, {
    heading: "DEPLOYED TO",
    isUpdating: isUpdatingResources
  }, resources == null ? void 0 : resources.map((resource) => /* @__PURE__ */ React__default.createElement(Resource, {
    key: resource.id,
    resource,
    environment,
    size: "small",
    className: "sp-margin-m-top",
    withPadding: false
  })));
};
const Artifact$1 = ({ artifact, isPreview }) => {
  const { environment, type, reference, versions, pinnedVersion, resources } = artifact;
  const currentVersion = versions == null ? void 0 : versions.find((version) => version.isCurrent === true);
  const newerVersions = filterPendingVersions(versions, currentVersion);
  const deployingVersion = newerVersions.filter((version) => version.status === "DEPLOYING");
  const pendingVersions = newerVersions.filter((version) => version.status !== "DEPLOYING");
  return /* @__PURE__ */ React__default.createElement(EnvironmentItem, {
    iconName: "artifact",
    iconTooltip: `Artifact - ${type}`,
    className: "Artifact",
    title: reference,
    rightElement: currentVersion && !isPreview ? /* @__PURE__ */ React__default.createElement(RollbackAction, {
      ...{ environment, currentVersion, reference },
      isPinned: Boolean(pinnedVersion)
    }) : void 0
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-m-top sp-margin-xl-bottom"
  }, /* @__PURE__ */ React__default.createElement(CurrentVersion, {
    data: currentVersion,
    environment,
    reference,
    numNewerVersions: newerVersions == null ? void 0 : newerVersions.length,
    pinnedVersion,
    isPreview
  }), pinnedVersion && pinnedVersion.buildNumber !== (currentVersion == null ? void 0 : currentVersion.buildNumber) && !deployingVersion.some((v) => v.buildNumber === pinnedVersion.buildNumber) && /* @__PURE__ */ React__default.createElement(PinnedVersion, {
    version: pinnedVersion
  })), /* @__PURE__ */ React__default.createElement(ArtifactVersions, {
    title: "Now deploying",
    artifact,
    versions: deployingVersion,
    isDeploying: true
  }), /* @__PURE__ */ React__default.createElement(ArtifactResources, {
    ...{ environment, resources }
  }), /* @__PURE__ */ React__default.createElement(ArtifactVersions, {
    title: `${pendingVersions.length} pending version` + (pendingVersions.length > 1 ? "s" : ""),
    artifact,
    versions: pendingVersions
  }));
};

var css_248z$1v = ".BaseEnvironment {\n  width: 100%;\n  border: 1px solid var(--color-cirrus);\n  border-radius: 4px;\n  background-color: var(--color-white);\n}\n.BaseEnvironment .EnvironmentTitle {\n  position: relative;\n  width: 100%;\n  min-height: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: var(--m-spacing) var(--base-horizontal-padding);\n  color: var(--color-white);\n  background-color: var(--color-primary-g1);\n  border-radius: 4px 4px 0 0;\n}\n.BaseEnvironment .EnvironmentTitle .env-link {\n  color: inherit;\n  text-decoration: none;\n}\n.BaseEnvironment .EnvironmentTitle .env-link .env-name:hover {\n  text-decoration: underline;\n}\n.BaseEnvironment .EnvironmentTitle .env-link i {\n  font-size: 12px;\n}\n.BaseEnvironment .EnvironmentTitle .env-name {\n  font-size: 20px;\n  font-weight: 700;\n}\n.BaseEnvironment .EnvironmentTitle .env-name:not(.preview-env) {\n  text-transform: uppercase;\n}\n.BaseEnvironment .EnvironmentTitle .env-deleting {\n  position: absolute;\n  right: 8px;\n  font-size: 13px;\n  color: var(--color-white);\n  -webkit-animation: deletingAnimation 2s infinite;\n          animation: deletingAnimation 2s infinite;\n  padding: var(--3xs-spacing) var(--xs-spacing);\n  border-radius: 3px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.BaseEnvironment .EnvironmentTitle.small {\n  padding: var(--s-spacing) var(--base-horizontal-padding);\n}\n.BaseEnvironment .EnvironmentTitle.small .env-name {\n  font-size: 15px;\n}\n";
styleInject(css_248z$1v);

const getEnvTitle = ({
  name,
  gitMetadata,
  isPreview
}) => {
  return isPreview ? (gitMetadata == null ? void 0 : gitMetadata.branch) || name : name;
};
const EnvironmentTitle = ({
  name,
  basedOn,
  gitMetadata,
  isPreview,
  isDeleting,
  size = "regular"
}) => {
  var _a;
  const baseTitle = /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("env-name", { "preview-env": Boolean(isPreview) })
  }, getEnvTitle({ name, isPreview, gitMetadata }));
  const link = (_a = gitMetadata == null ? void 0 : gitMetadata.pullRequest) == null ? void 0 : _a.link;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("EnvironmentTitle", size)
  }, link ? /* @__PURE__ */ React__default.createElement("a", {
    href: link,
    target: "_blank",
    className: "env-link horizontal middle"
  }, baseTitle, " ", /* @__PURE__ */ React__default.createElement("i", {
    className: "fas fa-external-link-alt sp-margin-s-left"
  })) : baseTitle, basedOn && /* @__PURE__ */ React__default.createElement("div", null, "Based on ", /* @__PURE__ */ React__default.createElement("span", {
    className: "uppercase"
  }, basedOn)), isDeleting && /* @__PURE__ */ React__default.createElement("div", {
    className: "env-deleting"
  }, "Deleting"));
};
const BaseEnvironment = ({ children, className, ...otherProps }) => {
  return /* @__PURE__ */ React__default.createElement("section", {
    className: classNames("BaseEnvironment", className)
  }, /* @__PURE__ */ React__default.createElement(EnvironmentTitle, {
    ...otherProps
  }), children);
};

const sectionProps = {
  outerDivClassName: "environment-section",
  headingClassName: "environment-section-heading",
  bodyClassName: "environment-section-body"
};
const EnvironmentOverview = ({ environment }) => {
  var _a, _b;
  const state = environment.state;
  return /* @__PURE__ */ React__default.createElement(BaseEnvironment, {
    name: environment.name,
    basedOn: environment.basedOn,
    gitMetadata: environment.gitMetadata,
    isPreview: environment.isPreview,
    isDeleting: environment.isDeleting
  }, /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: "Code deployments",
    ...sectionProps,
    defaultExpanded: true,
    cacheKey: `${environment.name}-artifacts`
  }, ((_a = state.artifacts) == null ? void 0 : _a.length) ? state.artifacts.map((artifact) => /* @__PURE__ */ React__default.createElement(Artifact$1, {
    key: artifact.reference,
    artifact,
    isPreview: environment.isPreview
  })) : /* @__PURE__ */ React__default.createElement(NoItemsMessage, null, "No artifacts found")), /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: "Infrastructure",
    ...sectionProps,
    enableCaching: false
  }, ((_b = state.resources) == null ? void 0 : _b.length) ? state.resources.map((resource) => /* @__PURE__ */ React__default.createElement(Resource, {
    key: resource.id,
    resource,
    environment: environment.name
  })) : /* @__PURE__ */ React__default.createElement(NoItemsMessage, null, "No resources found")));
};
const NoItemsMessage = ({ children }) => /* @__PURE__ */ React__default.createElement("div", {
  className: "environment-row-element"
}, /* @__PURE__ */ React__default.createElement("div", {
  className: "no-items-message"
}, children));

const PreviewEnvironments = ({ orderedEnvironments, isConfigured }) => {
  const { environments: previewEnvironments, ...previewEnvironmentsProps } = orderedEnvironments;
  const logClick = useLogEvent("PreviewEnvironments");
  const docsLink = getDocsUrl("previewEnvironments");
  const hasActivePreviewEnvironments = previewEnvironments.length > 0;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (isConfigured || hasActivePreviewEnvironments) && /* @__PURE__ */ React__default.createElement("h4", {
    className: "sp-margin-2xl-top sp-margin-m-bottom self-left"
  }, /* @__PURE__ */ React__default.createElement("b", null, "Preview Environments")), isConfigured && !hasActivePreviewEnvironments && /* @__PURE__ */ React__default.createElement("div", {
    className: "self-left"
  }, "No PRs matching your branch filter were found.", docsLink && /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    onClick: () => logClick({ action: "Learn More" }),
    href: docsLink
  }, "Learn More")), /* @__PURE__ */ React__default.createElement(EnvironmentsRender, {
    ...previewEnvironmentsProps
  }, previewEnvironments.map((env) => /* @__PURE__ */ React__default.createElement(EnvironmentOverview, {
    key: env.name,
    environment: env
  }))));
};

const OVERVIEW_VERSION_STATUSES = [
  "PENDING",
  "APPROVED",
  "DEPLOYING",
  "CURRENT"
];

var css_248z$1u = ".EnvironmentsOverview {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.EnvironmentsOverview .environment-section .environment-section-heading {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  padding: var(--l-spacing) var(--base-horizontal-padding);\n  text-transform: uppercase;\n  color: var(--color-primary);\n  margin: 0;\n  font-weight: 700;\n  font-size: 16px;\n  letter-spacing: 0.3px;\n  line-height: 1;\n  border-bottom: 1px solid var(--color-cirrus);\n}\n.EnvironmentsOverview .environment-section .environment-section-body {\n  padding-bottom: var(--l-spacing);\n}\n.EnvironmentsOverview .environment-section:not(:last-of-type) .environment-section-body {\n  border-bottom: 1px solid var(--color-cirrus);\n}\n";
styleInject(css_248z$1u);

const EnvironmentsOverview = () => {
  var _a, _b, _c;
  const app = useApplicationContextSafe();
  const { data, error, loading } = useFetchApplicationQuery({
    variables: { appName: app.name, statuses: OVERVIEW_VERSION_STATUSES }
  });
  const wrapperRef = React__default.useRef(null);
  const environments = ((_a = data == null ? void 0 : data.application) == null ? void 0 : _a.environments) || [];
  const { environments: regularEnvironments, ...regularEnvironmentsProps } = useOrderedEnvironment(wrapperRef, environments.filter((env) => !env.isPreview));
  const previewEnvironments = useOrderedEnvironment(wrapperRef, environments.filter((env) => env.isPreview));
  const previewEnvironmentsConfigured = (_c = (_b = data == null ? void 0 : data.application) == null ? void 0 : _b.config) == null ? void 0 : _c.previewEnvironmentsConfigured;
  let content;
  if (loading && !data) {
    content = /* @__PURE__ */ React__default.createElement(Spinner, {
      ...spinnerProps,
      message: "Loading environments..."
    });
  } else if (error) {
    content = /* @__PURE__ */ React__default.createElement(ApplicationQueryError, {
      hasApplicationData: Boolean(data == null ? void 0 : data.application),
      error
    });
  } else {
    content = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Messages, null), environments.length ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(EnvironmentsRender, {
      ...regularEnvironmentsProps
    }, regularEnvironments.map((env) => /* @__PURE__ */ React__default.createElement(EnvironmentOverview, {
      key: env.name,
      environment: env
    }))), /* @__PURE__ */ React__default.createElement(PreviewEnvironments, {
      orderedEnvironments: previewEnvironments,
      isConfigured: previewEnvironmentsConfigured
    })) : /* @__PURE__ */ React__default.createElement("div", {
      className: "error-message"
    }, "No environments found"));
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "EnvironmentsOverview",
    ref: wrapperRef
  }, content);
};

var css_248z$1t = ".VersionsHistory {\n  width: 100%;\n}\n.VersionsHistory .version-item {\n  background-color: var(--color-white);\n  padding: var(--m-spacing);\n  margin-bottom: var(--xl-spacing);\n  box-shadow: 1px 3px 6px 0 rgba(0, 0, 0, 0.05);\n}\n@media (max-width: 768px) {\n  .VersionsHistory .version-item {\n    padding: var(--m-spacing) var(--s-spacing);\n    margin-bottom: var(--l-spacing);\n  }\n}\n.VersionsHistory .version-item .version-heading {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.VersionsHistory .version-item .version-heading .version-heading-content {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.VersionsHistory .version-item .version-heading .section-heading-chevron {\n  border-radius: 999px;\n  padding: 4px;\n}\n.VersionsHistory .version-item .version-heading:hover .section-heading-chevron {\n  background-color: var(--color-cirrus);\n}\n.VersionsHistory .version-item .version-body {\n  margin-top: var(--l-spacing);\n}\n.VersionsHistory .version-toggle:hover {\n  text-decoration: none;\n}\n.VersionsHistory .version-environments {\n  display: flex;\n  flex-direction: row;\n  padding-top: var(--m-spacing);\n  overflow: auto;\n}\n.VersionsHistory .EnvironmentBadge {\n  line-height: 1;\n  border-radius: 999px;\n  padding: var(--2xs-spacing) var(--l-spacing);\n  display: flex;\n  flex-direction: row;\n  color: var(--color-mineshaft);\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 100px;\n  justify-content: center;\n  margin-right: var(--m-spacing);\n  position: relative;\n}\n.VersionsHistory .EnvironmentBadge .marker {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  padding: 2px;\n  box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.5);\n  border-radius: 999px;\n  font-size: 12px;\n  background-color: var(--color-white);\n}\n.VersionsHistory .EnvironmentBadge .marker.pinned {\n  background-color: var(--color-status-warning-light);\n}\n.VersionsHistory .EnvironmentBadge .marker.vetoed {\n  padding-right: 0px;\n  padding-top: 3px;\n  padding-bottom: 1px;\n}\n.VersionsHistory .EnvironmentBadge .secondary-status {\n  margin-left: 4px;\n  font-size: 11px;\n  border-radius: 4px;\n  font-weight: 400;\n  line-height: 1;\n  text-transform: none;\n  padding: var(--3xs-spacing) var(--xs-spacing);\n}\n.VersionsHistory .EnvironmentBadge .secondary-status.deploying {\n  -webkit-animation: deployingAnimation 2s infinite;\n          animation: deployingAnimation 2s infinite;\n}\n.VersionsHistory .EnvironmentBadge .secondary-status.vetoed {\n  background-color: var(--color-status-error-light);\n}\n.VersionsHistory .EnvironmentBadge:not(.preview-env) {\n  text-transform: uppercase;\n}\n@media (max-width: 768px) {\n  .VersionsHistory .EnvironmentBadge {\n    min-width: 60px;\n    padding: var(--3xs-spacing) var(--m-spacing);\n    margin-right: var(--s-spacing);\n  }\n}\n.VersionsHistory .EnvironmentBadge.skipped {\n  border: 1px solid var(--color-silver);\n  background-image: linear-gradient(to top right, var(--color-white) calc(50% - 1px), var(--color-silver), var(--color-white) calc(50% + 1px));\n}\n.VersionsHistory .EnvironmentBadge.approved {\n  background-color: var(--color-status-progress-light);\n}\n.VersionsHistory .EnvironmentBadge.pending {\n  background-color: var(--color-status-progress-light);\n}\n.VersionsHistory .EnvironmentBadge.vetoed {\n  background-color: var(--color-status-error-light);\n}\n.VersionsHistory .EnvironmentBadge.current {\n  background-color: var(--color-status-success);\n}\n.VersionsHistory .EnvironmentBadge.previous {\n  background-color: rgba(110, 214, 110, 0.2);\n}\n.VersionsHistory .EnvironmentBadge.deploying {\n  -webkit-animation: deployingAnimation 2s infinite;\n          animation: deployingAnimation 2s infinite;\n}\n";
styleInject(css_248z$1t);

const VersionInEnvironment = ({
  environment,
  version,
  isPreview,
  envPinnedVersions,
  detailedVersionData,
  loading
}) => {
  let pinnedData;
  const currentPinnedVersion = envPinnedVersions == null ? void 0 : envPinnedVersions[version.reference];
  if (currentPinnedVersion && currentPinnedVersion.buildNumber === version.buildNumber) {
    pinnedData = toPinnedMetadata(currentPinnedVersion);
  }
  const actions = useCreateVersionRollbackActions({
    environment,
    reference: version.reference,
    version: version.version,
    isVetoed: isVersionVetoed(version),
    isPinned: Boolean(pinnedData),
    isCurrent: version.isCurrent,
    selectedVersion: extractVersionRollbackDetails(version)
  });
  const versionProps = {
    environment,
    reference: version.reference,
    version: version.version,
    isCurrent: version.isCurrent
  };
  return /* @__PURE__ */ React__default.createElement(EnvironmentItem, {
    title: version.reference,
    iconName: "artifact",
    iconTooltip: `Artifact - ${version.type}`,
    size: "small"
  }, /* @__PURE__ */ React__default.createElement(VersionMetadata, {
    key: version.id,
    ...detailedVersionData ? omit(getBaseMetadata(detailedVersionData), "author", "buildDuration") : void 0,
    pinned: pinnedData
  }), !isPreview && /* @__PURE__ */ React__default.createElement(ArtifactActions, {
    buildNumber: version.buildNumber,
    version: version.version,
    actions,
    compareLinks: detailedVersionData ? getVersionCompareLinks(detailedVersionData) : void 0,
    className: "sp-margin-s-yaxis"
  }), loading && /* @__PURE__ */ React__default.createElement(LoadingAnimation, null), /* @__PURE__ */ React__default.createElement(Constraints, {
    constraints: detailedVersionData == null ? void 0 : detailedVersionData.constraints,
    versionProps: { environment, reference: version.reference, version: version.version },
    expandedByDefault: false
  }), /* @__PURE__ */ React__default.createElement(ArtifactVersionTasks, {
    type: "Verification",
    artifact: versionProps,
    tasks: detailedVersionData == null ? void 0 : detailedVersionData.verifications
  }), /* @__PURE__ */ React__default.createElement(ArtifactVersionTasks, {
    type: "Post deploy",
    artifact: versionProps,
    tasks: detailedVersionData == null ? void 0 : detailedVersionData.postDeploy
  }));
};
const getDetailedVersionData = ({
  environment,
  version,
  versionsDetails
}) => {
  var _a, _b, _c, _d;
  const environmentData = (_b = (_a = versionsDetails == null ? void 0 : versionsDetails.application) == null ? void 0 : _a.environments) == null ? void 0 : _b.find((env) => env.name === environment);
  const artifactData = (_c = environmentData == null ? void 0 : environmentData.state.artifacts) == null ? void 0 : _c.find((artifact) => artifact.reference === version.reference);
  return (_d = artifactData == null ? void 0 : artifactData.versions) == null ? void 0 : _d.find((v) => v.version === version.version);
};
const VersionContent = ({ versionData, pinnedVersions }) => {
  const ref = React__default.useRef(null);
  const { environments, ...renderProps } = useOrderedEnvironment(ref, Object.entries(versionData.environments));
  const app = useApplicationContextSafe();
  const versions = uniq(flatten(environments.map(([_, env]) => env.versions.map((v) => v.version))));
  const { data: versionsDetails, loading } = useFetchVersionQuery({
    variables: { appName: app.name, versions }
  });
  return /* @__PURE__ */ React__default.createElement(EnvironmentsRender, {
    ...renderProps,
    ref
  }, environments.map(([env, { versions: versions2, isPreview, basedOn, gitMetadata }]) => {
    return /* @__PURE__ */ React__default.createElement(BaseEnvironment, {
      key: env,
      name: env,
      basedOn,
      gitMetadata,
      isPreview,
      size: "small"
    }, versions2.map((version) => /* @__PURE__ */ React__default.createElement(VersionInEnvironment, {
      environment: env,
      key: version.id,
      version,
      isPreview,
      envPinnedVersions: pinnedVersions == null ? void 0 : pinnedVersions[env],
      loading,
      detailedVersionData: getDetailedVersionData({ environment: env, version, versionsDetails })
    })));
  }));
};

const getEnvStatusSummary = (artifacts) => {
  const sortedArtifacts = sortBy(artifacts, (artifact) => -1 * toNumber(artifact.buildNumber || 0));
  let status = "SKIPPED";
  for (const artifact of sortedArtifacts) {
    switch (artifact.status) {
      case "CURRENT":
      case "VETOED":
        return artifact.status;
      case "APPROVED":
      case "PENDING":
        if (status !== "DEPLOYING") {
          status = artifact.status;
        }
        break;
      case "PREVIOUS":
        if (status === "SKIPPED") {
          status = artifact.status;
        }
        break;
      case "DEPLOYING":
        status = artifact.status;
        break;
    }
  }
  return status;
};
const getIsCurrent = (artifacts) => {
  return artifacts.some((artifact) => artifact.isCurrent);
};
const statusToClassName = {
  APPROVED: `approved`,
  PENDING: `pending`,
  CURRENT: `current`,
  VETOED: `vetoed`,
  PREVIOUS: `previous`,
  DEPLOYING: `deploying`,
  SKIPPED: "skipped"
};
const statusToText = {
  APPROVED: `Ready to deploy`,
  PENDING: `Pending`,
  CURRENT: `Currently deployed`,
  VETOED: `Marked as bad`,
  PREVIOUS: `Previously deployed`,
  DEPLOYING: `Deploying`,
  SKIPPED: "Not deployed"
};
const secondaryStatusToIcon = {
  VETOED: `\u{1F494}`,
  DEPLOYING: `\u{1F6A2}`
};
const VersionHeading = ({ group, chevron }) => {
  const gitMetadata = group.gitMetadata;
  const client = useApolloClient();
  const app = useApplicationContextSafe();
  const prefetchData = () => {
    client.query({
      query: FetchVersionDocument,
      variables: { appName: app.name, versions: Array.from(group.versions) }
    });
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "version-heading",
    onMouseOver: prefetchData
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "version-heading-content"
  }, gitMetadata ? /* @__PURE__ */ React__default.createElement(GitLink, {
    gitMetadata,
    asLink: false
  }) : /* @__PURE__ */ React__default.createElement("div", null, "Build ", Array.from(group.buildNumbers).join(", ")), /* @__PURE__ */ React__default.createElement(BaseVersionMetadata, null, group.isBaking && /* @__PURE__ */ React__default.createElement(MetadataBadge, {
    type: "baking"
  }), /* @__PURE__ */ React__default.createElement(VersionAuthor, {
    author: gitMetadata == null ? void 0 : gitMetadata.author
  }), /* @__PURE__ */ React__default.createElement(VersionBuilds, {
    builds: Array.from(group.buildNumbers).map((buildNumber) => ({ buildNumber }))
  }), /* @__PURE__ */ React__default.createElement(VersionBranch, {
    branch: gitMetadata == null ? void 0 : gitMetadata.branch
  }), /* @__PURE__ */ React__default.createElement(VersionCreatedAt, {
    createdAt: group.createdAt,
    linkProps: { sha: group.key }
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "version-environments"
  }, Object.entries(group.environments).reverse().map(([env, artifacts]) => /* @__PURE__ */ React__default.createElement(EnvironmentBadge, {
    key: env,
    name: env,
    data: artifacts
  })))), /* @__PURE__ */ React__default.createElement("div", null, chevron));
};
const EnvironmentBadge = ({ name, data: { isPreview, versions, gitMetadata, isPinned } }) => {
  const statusSummary = getEnvStatusSummary(versions);
  const isCurrent = getIsCurrent(versions);
  const statusClassName = statusToClassName[isCurrent ? "CURRENT" : statusSummary];
  const statusText = statusToText[statusSummary];
  const hasSecondaryStatus = Boolean(isCurrent && statusSummary !== "CURRENT");
  const secondaryIcon = hasSecondaryStatus ? secondaryStatusToIcon[statusSummary] : void 0;
  return /* @__PURE__ */ React__default.createElement(Tooltip, {
    delayShow: TOOLTIP_DELAY_SHOW,
    value: isCurrent && statusSummary !== "CURRENT" ? `Current & ${statusText}` : statusText
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("EnvironmentBadge", "horizontal", "middle", { "preview-env": isPreview }, statusClassName)
  }, isPinned && /* @__PURE__ */ React__default.createElement(Icon, {
    name: "pin",
    size: "16px",
    className: "marker pinned",
    color: "black"
  }), secondaryIcon && /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("marker", statusToClassName[statusSummary])
  }, secondaryIcon), getEnvTitle({ name, gitMetadata, isPreview })));
};

const setValueIfMissing = (obj, key, value, fn) => {
  if (!obj[key]) {
    if (fn !== void 0) {
      obj[key] = fn();
    } else if (value !== void 0) {
      obj[key] = value;
    }
  }
};
const getIsFocused = (version, params) => {
  var _a, _b;
  if (params.sha && params.sha === ((_a = version.gitMetadata) == null ? void 0 : _a.commit)) {
    return true;
  }
  if ((_b = params.version) == null ? void 0 : _b.includes(version.version)) {
    return true;
  }
  return false;
};
const groupVersionsByShaOrBuild = (environments, params) => {
  var _a, _b, _c;
  const groupedVersions = {};
  for (const env of environments) {
    for (const artifact of env.state.artifacts || []) {
      for (const version of artifact.versions || []) {
        const key = ((_a = version.gitMetadata) == null ? void 0 : _a.commit) || version.buildNumber;
        if (key === void 0 || key === null)
          continue;
        const type = ((_b = version.gitMetadata) == null ? void 0 : _b.commit) ? "SHA" : "BUILD_NUMBER";
        if (!groupedVersions[key]) {
          groupedVersions[key] = { key, environments: {}, type, buildNumbers: new Set(), versions: new Set() };
        }
        if (version.buildNumber) {
          groupedVersions[key].buildNumbers.add(version.buildNumber);
        }
        if (isBaking(version)) {
          groupedVersions[key].isBaking = true;
        }
        if (getIsFocused(version, params)) {
          groupedVersions[key].isFocused = true;
        }
        groupedVersions[key].versions.add(version.version);
        setValueIfMissing(groupedVersions[key], "createdAt", void 0, () => version.createdAt ? DateTime.fromISO(version.createdAt) : void 0);
        setValueIfMissing(groupedVersions[key], "gitMetadata", version.gitMetadata);
        const buildEnvironments = groupedVersions[key].environments;
        if (!buildEnvironments[env.name]) {
          buildEnvironments[env.name] = {
            versions: [],
            isPreview: env.isPreview,
            basedOn: env.basedOn,
            gitMetadata: env.gitMetadata
          };
        }
        if (((_c = artifact.pinnedVersion) == null ? void 0 : _c.version) === version.version) {
          buildEnvironments[env.name].isPinned = true;
        }
        buildEnvironments[env.name].versions.push({ ...version, reference: artifact.reference, type: artifact.type });
      }
    }
  }
  return sortBy(Object.values(groupedVersions), (g) => g.createdAt ? -1 * g.createdAt.toMillis() : -1);
};
const getPinnedVersions = (environments) => {
  const allPinnedVersions = {};
  for (const env of environments) {
    for (const { reference, pinnedVersion } of env.state.artifacts || []) {
      if (pinnedVersion) {
        setValueIfMissing(allPinnedVersions, env.name, {});
        allPinnedVersions[env.name][reference] = pinnedVersion;
      }
    }
  }
  return allPinnedVersions;
};
const VersionsHistory = () => {
  var _a, _b;
  const app = useApplicationContextSafe();
  const { params } = useCurrentStateAndParams();
  const { data, error, loading } = useFetchVersionsHistoryQuery({
    variables: { appName: app.name, limit: 50 }
  });
  if (loading && !data) {
    return /* @__PURE__ */ React__default.createElement(Spinner, {
      ...spinnerProps,
      message: "Loading versions history..."
    });
  }
  if (error) {
    return /* @__PURE__ */ React__default.createElement(ApplicationQueryError, {
      hasApplicationData: Boolean(data == null ? void 0 : data.application),
      error
    });
  }
  const groupedVersions = groupVersionsByShaOrBuild(((_a = data == null ? void 0 : data.application) == null ? void 0 : _a.environments) || [], params);
  const pinnedVersions = getPinnedVersions(((_b = data == null ? void 0 : data.application) == null ? void 0 : _b.environments) || []);
  return /* @__PURE__ */ React__default.createElement("main", {
    className: "VersionsHistory"
  }, /* @__PURE__ */ React__default.createElement(Messages, null), groupedVersions.map((group) => {
    return /* @__PURE__ */ React__default.createElement(SingleVersion, {
      key: group.key,
      versionData: group,
      pinnedVersions
    });
  }));
};
const SingleVersion = ({ versionData, pinnedVersions }) => {
  const ref = React__default.useRef(null);
  const routerState = useRouter().stateService;
  React__default.useEffect(() => {
    if (versionData.isFocused && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  return /* @__PURE__ */ React__default.createElement("div", {
    ref
  }, /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    outerDivClassName: "version-item",
    toggleClassName: "version-toggle",
    bodyClassName: "version-body",
    expandIconType: "arrowCross",
    defaultExpanded: versionData.isFocused,
    heading: ({ chevron }) => /* @__PURE__ */ React__default.createElement(VersionHeading, {
      group: versionData,
      chevron
    }),
    onToggle: (isExpanded) => {
      if (!isExpanded)
        return;
      routerState.go(".", { sha: versionData.key }, { location: "replace" });
    }
  }, /* @__PURE__ */ React__default.createElement(VersionContent, {
    versionData,
    pinnedVersions
  })));
};

const routes = [
  {
    name: "overview",
    url: "/overview",
    component: EnvironmentsOverview,
    $type: "react",
    children: [],
    data: {
      pageTitleSection: {
        title: "Environments overview"
      }
    }
  },
  {
    name: "config",
    url: "/config",
    component: Configuration,
    $type: "react",
    children: [],
    data: {
      pageTitleSection: {
        title: "Environments config"
      }
    }
  },
  {
    name: "history",
    url: "/history/{version:.*}?sha",
    component: VersionsHistory,
    $type: "react",
    children: [],
    params: {
      version: { isOptional: true, value: null },
      sha: { isOptional: true, value: null, dynamic: true }
    },
    data: {
      pageTitleSection: {
        title: "Environments history"
      }
    }
  }
];
const MANAGED_STATES = "spinnaker.core.managed.states";
module(MANAGED_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  (applicationStateProvider) => {
    if (SETTINGS.feature.managedDelivery) {
      const artifactVersion = {
        name: "artifactVersion",
        url: `/{reference}/{version}`,
        params: {
          reference: { dynamic: true },
          version: { dynamic: true }
        },
        children: [],
        redirectTo: (transition) => {
          return transition.targetState().withState("home.applications.application.environments.history");
        }
      };
      const environments = {
        name: "environments",
        url: `/environments?{md_debug:query}`,
        views: {
          insight: { component: Environments, $type: "react" }
        },
        data: {
          pageTitleSection: {
            title: "Environments"
          }
        },
        children: [artifactVersion, ...routes],
        redirectTo: (transition) => {
          return transition.targetState().withState("home.applications.application.environments.overview");
        }
      };
      applicationStateProvider.addChildState(environments);
    }
  }
]);

const CORE_MANAGED_MANAGED_MODULE = "spinnaker.managed";
module(CORE_MANAGED_MANAGED_MODULE, [MANAGED_STATES]);

const registerManagedDeliveryPlugin = (plugin) => {
  var _a, _b;
  (_a = plugin.resources) == null ? void 0 : _a.forEach((resource) => resourceManager.registerHandler(resource));
  (_b = plugin.constraints) == null ? void 0 : _b.forEach((constraint) => constraintsManager.registerHandler(constraint));
};

class DefaultClusterPodTitle extends React__default.Component {
  render() {
    const { grouping, application, parentHeading } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-title-cell"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "heading-tag"
    }, /* @__PURE__ */ React__default.createElement(AccountTag, {
      account: parentHeading
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: classNames("pod-center horizontal space-between flex-1", {
        "no-right-padding": grouping.isManaged
      })
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-th"
    }), " " + grouping.heading), /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-h margin-between-md"
    }, /* @__PURE__ */ React__default.createElement(EntityNotifications, {
      entity: grouping,
      application,
      placement: "top",
      hOffsetPercent: "90%",
      entityType: "cluster",
      pageLocation: "pod",
      className: "inverse",
      onUpdate: () => application.serverGroups.refresh()
    }), grouping.isManaged && /* @__PURE__ */ React__default.createElement(ManagedResourceStatusIndicator, {
      shape: "square",
      resourceSummary: grouping.managedResourceSummary,
      application
    }))), /* @__PURE__ */ React__default.createElement(HealthCounts, {
      container: grouping.cluster.instanceCounts
    }));
  }
}

class ClusterPodTitleWrapper extends React__default.Component {
  render() {
    const { overrideRegistry } = ReactInjector;
    const config = overrideRegistry.getComponent("clusterPodTitle");
    const Title = config || DefaultClusterPodTitle;
    return /* @__PURE__ */ React__default.createElement(Title, {
      ...this.props
    });
  }
}

class DefaultClusterMatcher {
  getMatchingRule(account, location, clusterName, rules) {
    if (!rules || !rules.length) {
      return null;
    }
    const nameParts = NameUtils.parseClusterName(clusterName);
    const matchedRules = rules.filter((r) => {
      const ruleAccount = r.account || "";
      const ruleLocation = r.location || "";
      const ruleStack = r.stack || "";
      const ruleDetail = r.detail || "";
      const stack = nameParts.stack || "";
      const detail = nameParts.freeFormDetails || "";
      return (ruleAccount === "*" || account === ruleAccount) && (ruleLocation === "*" || location === ruleLocation) && (ruleStack === "*" || stack === ruleStack) && (ruleDetail === "*" || detail === ruleDetail);
    }).sort((a, b) => {
      if (a.account !== b.account) {
        return a.account === "*" ? 1 : -1;
      }
      if (a.location !== b.location) {
        return a.location === "*" ? 1 : -1;
      }
      if (a.stack !== b.stack) {
        return a.stack === "*" ? 1 : -1;
      }
      if (a.detail !== b.detail) {
        return a.detail === "*" ? 1 : -1;
      }
      return a.priority - b.priority;
    });
    return matchedRules.length ? matchedRules[0] : null;
  }
}
const ClusterMatcher = new DefaultClusterMatcher();

const CORE_SERVERGROUP_SERVERGROUP_TRANSFORMER = "spinnaker.core.serverGroup.transformer";
module(CORE_SERVERGROUP_SERVERGROUP_TRANSFORMER, [PROVIDER_SERVICE_DELEGATE]).factory("serverGroupTransformer", [
  "providerServiceDelegate",
  "$q",
  function(providerServiceDelegate, $q) {
    function normalizeServerGroup(serverGroup, application) {
      if (!providerServiceDelegate.hasDelegate(serverGroup.provider || serverGroup.type, "serverGroup.transformer")) {
        return null;
      }
      return providerServiceDelegate.getDelegate(serverGroup.provider || serverGroup.type, "serverGroup.transformer").normalizeServerGroup(serverGroup, application);
    }
    function convertServerGroupCommandToDeployConfiguration(base) {
      const service = providerServiceDelegate.getDelegate(base.selectedProvider, "serverGroup.transformer");
      return service ? service.convertServerGroupCommandToDeployConfiguration(base) : null;
    }
    return {
      normalizeServerGroup,
      convertServerGroupCommandToDeployConfiguration
    };
  }
]);

class TaskMatcher {
  constructor() {
    this.customMatchers = {
      createcopylastasg: createcopylastasgMatcher,
      createdeploy: createdeployMatcher,
      rollbackServerGroup: rollbackServerGroupTaskMatcher
    };
    this.instanceIdMatchers = [
      "deregisterinstancesfromloadbalancer",
      "disableinstances",
      "disableinstancesindiscovery",
      "enableinstancesindiscovery",
      "rebootinstances",
      "registerinstanceswithloadbalancer",
      "terminateinstances"
    ];
    this.baseTaskMatchers = [
      "destroyasg",
      "destroyservergroup",
      "disableasg",
      "disablegoogleservergroup",
      "disableservergroup",
      "enableasg",
      "enablegoogleservergroup",
      "enableservergroup",
      "resizeasg",
      "resizeservergroup",
      "resumeasgprocessesdescription"
    ];
  }
  addMatcher(stageName, matcher) {
    if (typeof matcher === "function") {
      this.customMatchers[stageName] = matcher;
    } else if (matcher === "instanceIdMatchers") {
      this.instanceIdMatchers.push(stageName);
    } else if (matcher === "baseTaskMatchers") {
      this.baseTaskMatchers.push(stageName);
    }
  }
  taskMatches(task, serverGroup) {
    var _a, _b, _c;
    const matchers = { ...this.customMatchers };
    this.instanceIdMatchers.forEach((m) => matchers[m] = instanceIdsTaskMatcher);
    this.baseTaskMatchers.forEach((m) => matchers[m] = baseTaskMatcher);
    const firstStage = (_c = (_b = (_a = task.execution) == null ? void 0 : _a.stages) == null ? void 0 : _b[0]) != null ? _c : { context: {} };
    const notificationType = firstStage.context["notification.type"] || firstStage.type || task.getValueFor("notification.type");
    const matcher = notificationType && (matchers[notificationType] || matchers[notificationType.toLowerCase()]);
    return !!matcher && matcher(task, serverGroup);
  }
}
function createcopylastasgMatcher(task, serverGroup) {
  const source = task.getValueFor("source");
  const targetAccount = task.getValueFor("deploy.account.name");
  const targetRegion = task.getValueFor("availabilityZones") ? Object.keys(task.getValueFor("availabilityZones"))[0] : null;
  const deployedServerGroups = task.getValueFor("deploy.server.groups");
  const targetServerGroup = targetRegion && deployedServerGroups && deployedServerGroups[targetRegion] ? deployedServerGroups[targetRegion][0] : null;
  const sourceServerGroup = source.asgName;
  const sourceAccount = source.account;
  const sourceRegion = source.region;
  const targetMatches = serverGroup.account === targetAccount && serverGroup.region === targetRegion && serverGroup.name === targetServerGroup;
  const sourceMatches = serverGroup.account === sourceAccount && serverGroup.region === sourceRegion && serverGroup.name === sourceServerGroup;
  return targetMatches || sourceMatches;
}
function createdeployMatcher(task, serverGroup) {
  const account = task.getValueFor("deploy.account.name");
  const region = task.getValueFor("deploy.server.groups") ? Object.keys(task.getValueFor("deploy.server.groups"))[0] : null;
  const serverGroupName = serverGroup && region ? task.getValueFor("deploy.server.groups")[region][0] : null;
  if (account && serverGroup && region) {
    return serverGroup.account === account && serverGroup.region === region && serverGroup.name === serverGroupName;
  }
  return false;
}
function baseTaskMatcher(task, serverGroup) {
  const taskRegion = task.getValueFor("regions") ? task.getValueFor("regions")[0] : task.getValueFor("region") || null;
  return serverGroup.account === task.getValueFor("credentials") && serverGroup.region === taskRegion && serverGroup.name === task.getValueFor("asgName");
}
function instanceIdsTaskMatcher(task, serverGroup) {
  if (task.getValueFor("region") === serverGroup.region && task.getValueFor("credentials") === serverGroup.account) {
    if (task.getValueFor("knownInstanceIds")) {
      return intersection(map$1(serverGroup.instances, "id"), task.getValueFor("knownInstanceIds")).length > 0;
    } else {
      return intersection(map$1(serverGroup.instances, "id"), task.getValueFor("instanceIds")).length > 0;
    }
  }
  return false;
}
function rollbackServerGroupTaskMatcher(task, serverGroup) {
  const account = task.getValueFor("credentials");
  const region = task.getValueFor("region");
  if (account && serverGroup.account === account && region && serverGroup.region === region) {
    return serverGroup.name === task.getValueFor("targetop.asg.disableServerGroup.name") || serverGroup.name === task.getValueFor("targetop.asg.enableServerGroup.name");
  }
  return false;
}
const taskMatcher = new TaskMatcher();

class ClusterService {
  constructor($q, serverGroupTransformer, providerServiceDelegate) {
    this.$q = $q;
    this.serverGroupTransformer = serverGroupTransformer;
    this.providerServiceDelegate = providerServiceDelegate;
  }
  loadServerGroups(application) {
    return this.getClusters(application.name).then((clusters) => {
      const dataSource = application.getDataSource("serverGroups");
      let serverGroupLoader = REST("/applications").path(application.name, "serverGroups");
      dataSource.fetchOnDemand = clusters.length > SETTINGS.onDemandClusterThreshold;
      if (dataSource.fetchOnDemand) {
        dataSource.clusters = clusters;
        serverGroupLoader = serverGroupLoader.query({
          clusters: FilterModelService.getCheckValues(ClusterState.filterModel.asFilterModel.sortFilter.clusters).join()
        });
      } else {
        this.reconcileClusterDeepLink();
      }
      return serverGroupLoader.get().then((serverGroups) => {
        serverGroups.forEach((sg) => this.addHealthStatusCheck(sg));
        serverGroups.forEach((sg) => this.addNameParts(sg));
        return this.$q.all(serverGroups.map((sg) => this.serverGroupTransformer.normalizeServerGroup(sg, application))).then((normalized) => normalized.filter(Boolean));
      });
    });
  }
  reconcileClusterDeepLink() {
    const selectedClusters = FilterModelService.getCheckValues(ClusterState.filterModel.asFilterModel.sortFilter.clusters);
    if (selectedClusters && selectedClusters.length) {
      const clusterNames = [];
      const accountNames = [];
      selectedClusters.forEach((clusterKey) => {
        const [account, cluster] = clusterKey.split(":");
        accountNames.push(account);
        if (cluster) {
          clusterNames.push(cluster);
        }
      });
      if (clusterNames.length) {
        accountNames.forEach((account) => ClusterState.filterModel.asFilterModel.sortFilter.account[account] = true);
        ClusterState.filterModel.asFilterModel.sortFilter.filter = `clusters:${clusterNames.join()}`;
        ClusterState.filterModel.asFilterModel.sortFilter.clusters = {};
        ClusterState.filterModel.asFilterModel.applyParamsToUrl();
      }
    }
  }
  generateServerGroupLookupKey(serverGroup) {
    const { name, account, region, category } = serverGroup;
    return [name, account, region, category].join("-");
  }
  addServerGroupsToApplication(application, serverGroups = []) {
    const remoteMap = keyBy(serverGroups, this.generateServerGroupLookupKey);
    const localMap = keyBy(application.serverGroups.data, this.generateServerGroupLookupKey);
    if (application.serverGroups.data) {
      const data = application.serverGroups.data;
      const toRemove = [];
      data.forEach((serverGroup, idx) => {
        const match = remoteMap[this.generateServerGroupLookupKey(serverGroup)];
        if (match) {
          if (serverGroup.stringVal && match.stringVal && serverGroup.stringVal !== match.stringVal) {
            data[idx] = match;
          }
        } else {
          toRemove.push(idx);
        }
      });
      toRemove.sort().reverse().forEach((idx) => data.splice(idx, 1));
      serverGroups.forEach((serverGroup) => {
        const match = localMap[this.generateServerGroupLookupKey(serverGroup)];
        if (!match) {
          data.push(serverGroup);
        }
      });
      return data;
    } else {
      return serverGroups;
    }
  }
  createServerGroupClusters(serverGroups) {
    const clusters = [];
    const groupedByAccount = groupBy(serverGroups, "account");
    forOwn(groupedByAccount, (accountServerGroups, account) => {
      const groupedByCategory = groupBy(accountServerGroups, "category");
      forOwn(groupedByCategory, (categoryServerGroups, category) => {
        const groupedByCluster = groupBy(categoryServerGroups, "cluster");
        forOwn(groupedByCluster, (clusterServerGroups, clusterName) => {
          const cluster = {
            account,
            category,
            name: clusterName,
            serverGroups: clusterServerGroups,
            cloudProvider: clusterServerGroups[0].cloudProvider
          };
          this.addHealthCountsToCluster(cluster);
          clusters.push(cluster);
        });
      });
    });
    this.addProvidersAndServerGroupsToInstances(serverGroups);
    return clusters;
  }
  addExecutionsToServerGroups(application) {
    var _a, _b;
    const executions = (_b = (_a = application.runningExecutions) == null ? void 0 : _a.data) != null ? _b : [];
    if (!application.serverGroups.data) {
      return;
    }
    application.serverGroups.data.forEach((serverGroup) => {
      serverGroup.runningExecutions = [];
      executions.forEach((execution) => {
        this.findStagesWithServerGroupInfo(execution.stages).forEach((stage) => {
          const stageServerGroup = stage ? this.extractServerGroupNameFromContext(stage.context) : "";
          const stageAccount = stage && stage.context ? stage.context.account || stage.context.credentials : "";
          const stageRegion = stage ? this.extractRegionFromContext(stage.context) : "";
          if (stageServerGroup.includes(serverGroup.name) && stageAccount === serverGroup.account && stageRegion === serverGroup.region) {
            serverGroup.runningExecutions.push(execution);
          }
        });
      });
    });
  }
  addTasksToServerGroups(application) {
    var _a, _b;
    const runningTasks = (_b = (_a = application.runningTasks) == null ? void 0 : _a.data) != null ? _b : [];
    if (!application.serverGroups.data) {
      return;
    }
    application.serverGroups.data.forEach((serverGroup) => {
      if (!serverGroup.runningTasks) {
        serverGroup.runningTasks = [];
      } else {
        serverGroup.runningTasks.length = 0;
      }
      runningTasks.forEach((task) => {
        if (taskMatcher.taskMatches(task, serverGroup)) {
          serverGroup.runningTasks.push(task);
        }
      });
    });
  }
  isDeployingArtifact(cluster) {
    return cluster.imageSource === "artifact";
  }
  defaultArtifactExtractor() {
    return {
      extractArtifacts: (cluster) => this.isDeployingArtifact(cluster) ? [cluster.imageArtifactId] : [],
      removeArtifact: (cluster, artifactId) => {
        ArtifactReferenceService.removeArtifactFromField("imageArtifactId", cluster, artifactId);
      }
    };
  }
  getArtifactExtractor(cloudProvider) {
    return this.providerServiceDelegate.hasDelegate(cloudProvider, "serverGroup.artifactExtractor") ? this.providerServiceDelegate.getDelegate(cloudProvider, "serverGroup.artifactExtractor") : this.defaultArtifactExtractor();
  }
  extractArtifacts(cluster) {
    return this.getArtifactExtractor(cluster.cloudProvider).extractArtifacts(cluster);
  }
  removeArtifact(cluster, artifactId) {
    this.getArtifactExtractor(cluster.cloudProvider).removeArtifact(cluster, artifactId);
  }
  getClusters(application) {
    return REST("/applications").path(application, "clusters").get().then((clustersMap) => {
      const clusters = [];
      Object.keys(clustersMap).forEach((account) => {
        clustersMap[account].forEach((name) => {
          clusters.push({ account, name });
        });
      });
      return clusters;
    });
  }
  extractServerGroupNameFromContext(context) {
    return head(values(context["deploy.server.groups"])) || context["targetop.asg.disableAsg.name"] || flatten(values(context["outputs.manifestNamesByNamespace"])) || "";
  }
  extractRegionFromContext(context) {
    return head(keys(context["deploy.server.groups"])) || head(context["targetop.asg.disableAsg.regions"]) || head(keys(context["outputs.manifestNamesByNamespace"])) || "";
  }
  findStagesWithServerGroupInfo(stages) {
    return (stages || []).filter((stage) => ["createServerGroup", "deploy", "destroyAsg", "resizeAsg"].includes(stage.type) && has(stage.context, "deploy.server.groups") || stage.type === "disableAsg" && has(stage.context, "targetop.asg.disableAsg.name") || has(stage.context, "outputs.manifestNamesByNamespace"));
  }
  addProvidersAndServerGroupsToInstances(serverGroups) {
    serverGroups.forEach((serverGroup) => {
      serverGroup.instances.forEach((instance) => {
        instance.provider = serverGroup.type || serverGroup.provider;
        instance.serverGroup = instance.serverGroup || serverGroup.name;
        instance.vpcId = serverGroup.vpcId;
      });
    });
  }
  addNameParts(serverGroup) {
    const nameParts = NameUtils.parseServerGroupName(serverGroup.name);
    if (serverGroup.moniker) {
      Object.assign(serverGroup, serverGroup.moniker);
    } else {
      serverGroup.app = nameParts.application;
      serverGroup.stack = nameParts.stack;
      serverGroup.detail = nameParts.freeFormDetails;
      serverGroup.cluster = nameParts.cluster;
    }
    serverGroup.category = "serverGroup";
  }
  addHealthStatusCheck(serverGroup) {
    serverGroup.instances.forEach((instance) => {
      instance.hasHealthStatus = (instance.health || []).some((h) => h.state !== "Unknown");
    });
  }
  addHealthCountsToCluster(cluster) {
    cluster.instanceCounts = {
      up: 0,
      down: 0,
      unknown: 0,
      starting: 0,
      outOfService: 0,
      succeeded: 0,
      failed: 0,
      total: 0
    };
    const operand = cluster.serverGroups || [];
    operand.forEach((serverGroup) => {
      if (!serverGroup.instanceCounts) {
        return;
      }
      cluster.instanceCounts.total += serverGroup.instanceCounts.total || 0;
      cluster.instanceCounts.up += serverGroup.instanceCounts.up || 0;
      cluster.instanceCounts.down += serverGroup.instanceCounts.down || 0;
      cluster.instanceCounts.unknown += serverGroup.instanceCounts.unknown || 0;
      cluster.instanceCounts.starting += serverGroup.instanceCounts.starting || 0;
      cluster.instanceCounts.outOfService += serverGroup.instanceCounts.outOfService || 0;
      cluster.instanceCounts.succeeded += serverGroup.instanceCounts.succeeded || 0;
      cluster.instanceCounts.failed += serverGroup.instanceCounts.failed || 0;
    });
  }
}
ClusterService.$inject = ["$q", "serverGroupTransformer", "providerServiceDelegate"];
const CLUSTER_SERVICE = "spinnaker.core.cluster.service";
module(CLUSTER_SERVICE, [CORE_SERVERGROUP_SERVERGROUP_TRANSFORMER]).service("clusterService", ClusterService);

var css_248z$1s = ".FilterSearch .help-field {\n  margin-left: 8px;\n  color: var(--color-titanium);\n}\n.FilterSearch .help-field i {\n  font-size: 16px;\n}\n";
styleInject(css_248z$1s);

const FilterSearch = ({ helpKey, onBlur, onSearchChange, value }) => /* @__PURE__ */ React__default.createElement("form", {
  className: "FilterSearch flex-container-h baseline",
  role: "form",
  onSubmit: (e) => e.preventDefault()
}, /* @__PURE__ */ React__default.createElement(TextInput, {
  type: "search",
  value,
  onBlur,
  onChange: onSearchChange,
  placeholder: "Search by field"
}), helpKey && /* @__PURE__ */ React__default.createElement(HelpField, {
  id: helpKey,
  placement: "right"
}));

class FilterSection extends React__default.Component {
  constructor(props) {
    super(props);
    this.toggle = () => {
      this.setState({ expanded: !this.state.expanded });
    };
    this.state = { expanded: props.expanded };
  }
  getIcon() {
    return this.state.expanded ? "down" : "right";
  }
  render() {
    const chevronStyle = {
      transform: this.state.expanded ? "rotate(-90deg)" : "rotate(0deg)",
      transition: "all ease 0.15s"
    };
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "collapsible-filter-section"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "section-heading clickable",
      onClick: this.toggle
    }, /* @__PURE__ */ React__default.createElement("h4", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-xs-right"
    }, ` ${this.props.heading}`), this.props.helpKey && /* @__PURE__ */ React__default.createElement("div", null, " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: this.props.helpKey,
      placement: "right"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: `arrow glyphicon glyphicon-chevron-left`,
      style: chevronStyle
    }))), this.state.expanded && /* @__PURE__ */ React__default.createElement("div", {
      className: "content-body"
    }, this.props.children));
  }
}

class DeploymentStrategyRegistrar {
  constructor() {
    this.strategies = [];
    this.providerRegistry = {};
  }
  registerStrategy(strategy) {
    this.strategies.push(strategy);
    this.configureProviderRegistryEntry(strategy.key);
  }
  listStrategies(cloudProvider) {
    return this.strategies.filter((s) => !s.providerRestricted || this.providerRegistry[s.key].includes(cloudProvider)).map(cloneDeep);
  }
  registerProvider(provider, strategies) {
    strategies.forEach((strategy) => {
      this.configureProviderRegistryEntry(strategy);
      this.providerRegistry[strategy].push(provider);
    });
  }
  getStrategy(key) {
    return this.strategies.find((s) => s.key === key);
  }
  configureProviderRegistryEntry(key) {
    if (!this.providerRegistry[key]) {
      this.providerRegistry[key] = [];
    }
  }
}
const DeploymentStrategyRegistry = new DeploymentStrategyRegistrar();

class DeploymentStrategySelector extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      strategies: DeploymentStrategyRegistry.listStrategies(this.props.command.selectedProvider || this.props.command.cloudProvider),
      currentStrategy: null,
      AdditionalFieldsComponent: void 0
    };
    this.strategyChanged = (option) => {
      this.selectStrategy(option.key);
    };
    this.strategyOptionRenderer = (option) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "body-regular"
      }, /* @__PURE__ */ React__default.createElement("strong", null, /* @__PURE__ */ React__default.createElement(Markdown, {
        tag: "span",
        message: option.label
      })), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Markdown, {
        tag: "span",
        message: option.description
      })));
    };
  }
  selectStrategy(strategy, onMount = false) {
    const { command, onStrategyChange } = this.props;
    const oldStrategy = DeploymentStrategyRegistry.getStrategy(this.state.currentStrategy);
    const newStrategy = DeploymentStrategyRegistry.getStrategy(strategy);
    if (oldStrategy && oldStrategy.additionalFields) {
      oldStrategy.additionalFields.forEach((field) => {
        if (!newStrategy || !newStrategy.additionalFields || !newStrategy.additionalFields.includes(field)) {
          unset(command, field);
        }
      });
    }
    let AdditionalFieldsComponent;
    if (newStrategy) {
      AdditionalFieldsComponent = newStrategy.AdditionalFieldsComponent;
      if (newStrategy.initializationMethod && !onMount) {
        newStrategy.initializationMethod(command);
      }
    }
    command.strategy = strategy;
    if (onStrategyChange && newStrategy) {
      onStrategyChange(command, newStrategy);
    }
    this.setState({ currentStrategy: strategy, AdditionalFieldsComponent });
  }
  componentDidMount() {
    this.selectStrategy(this.props.command.strategy, true);
  }
  render() {
    const { command, fieldColumns, labelColumns, onFieldChange } = this.props;
    const { AdditionalFieldsComponent, currentStrategy, strategies } = this.state;
    const hasAdditionalFields = Boolean(AdditionalFieldsComponent);
    if (strategies && strategies.length) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: `col-md-${labelColumns} sm-label-right`,
        style: { paddingLeft: "13px" }
      }, "Strategy", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "core.serverGroup.strategy"
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: `col-md-${fieldColumns}`
      }, /* @__PURE__ */ React__default.createElement(Select, {
        clearable: false,
        required: true,
        options: strategies,
        placeholder: "None",
        valueKey: "key",
        value: currentStrategy,
        optionRenderer: this.strategyOptionRenderer,
        valueRenderer: (o) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, o.label),
        onChange: this.strategyChanged
      })), hasAdditionalFields && /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9 col-md-offset-3",
        style: { marginTop: "5px" }
      }, /* @__PURE__ */ React__default.createElement(AdditionalFieldsComponent, {
        command,
        onChange: onFieldChange
      })));
    }
    return null;
  }
}
DeploymentStrategySelector.defaultProps = {
  fieldColumns: "7",
  labelColumns: "3"
};

class AdditionalFields$3 extends React__default.Component {
  constructor() {
    super(...arguments);
    this.rollbackOnFailureChange = (e) => {
      this.props.command.rollback.onFailure = e.target.checked;
      this.forceUpdate();
    };
    this.scaleDownChange = (e) => {
      this.props.command.scaleDown = e.target.checked;
      this.forceUpdate();
    };
    this.maxRemainingAsgsChange = (e) => {
      this.props.command.maxRemainingAsgs = parseInt(e.target.value, 10);
      this.forceUpdate();
    };
    this.delayBeforeDisableSecChange = (e) => {
      this.props.command.delayBeforeDisableSec = parseInt(e.target.value, 10);
      this.forceUpdate();
    };
    this.delayBeforeScaleDownSecChange = (e) => {
      this.props.command.delayBeforeScaleDownSec = parseInt(e.target.value, 10);
      this.forceUpdate();
    };
  }
  render() {
    var _a, _b;
    const { command } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 checkbox",
      style: { marginTop: 0 }
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: (_b = (_a = command.rollback) == null ? void 0 : _a.onFailure) != null ? _b : false,
      onChange: this.rollbackOnFailureChange
    }), "Rollback to previous server group if deployment fails ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.redblack.rollback"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: command.scaleDown,
      onChange: this.scaleDownChange
    }), "Scale down replaced server groups to zero instances ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.redblack.scaleDown"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 form-inline"
    }, /* @__PURE__ */ React__default.createElement("label", null, "Maximum number of server groups to leave", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.redblack.maxRemainingAsgs"
    })), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      style: { width: "50px" },
      type: "number",
      value: command.maxRemainingAsgs,
      onChange: this.maxRemainingAsgsChange,
      min: "2"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 form-inline"
    }, /* @__PURE__ */ React__default.createElement("label", null, "Wait Before Disable", /* @__PURE__ */ React__default.createElement(HelpField, {
      content: "Time to wait before disabling all old server groups in this cluster"
    })), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      style: { width: "60px" },
      min: "0",
      type: "number",
      value: command.delayBeforeDisableSec,
      onChange: this.delayBeforeDisableSecChange,
      placeholder: "0"
    }), "seconds"), command.scaleDown && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 form-inline",
      style: { marginTop: "5px" }
    }, /* @__PURE__ */ React__default.createElement("label", null, "Wait Before Scale Down", /* @__PURE__ */ React__default.createElement(HelpField, {
      content: "Time to wait before scaling down all old server groups in this cluster"
    })), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      style: { width: "60px" },
      min: "0",
      type: "number",
      value: command.delayBeforeScaleDownSec,
      onChange: this.delayBeforeScaleDownSecChange,
      placeholder: "0"
    }), "seconds"));
  }
}

const AddEntityTagLinks = ({
  application,
  component,
  entityType,
  onUpdate,
  ownerOptions
}) => {
  const addTag = (tagType) => {
    const tagProps = {
      application,
      entityType,
      entityRef: null,
      isNew: true,
      onUpdate,
      owner: component,
      ownerOptions,
      tag: {
        name: null,
        value: {
          message: null,
          type: tagType
        }
      }
    };
    EntityTagEditor.show(tagProps);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("li", {
    className: "divider"
  }), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    onClick: () => addTag("notice")
  }, "Add notice ", /* @__PURE__ */ React.createElement(HelpField, {
    id: `entityTags.${entityType}.notice`
  }))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    onClick: () => addTag("alert")
  }, "Add alert ", /* @__PURE__ */ React.createElement(HelpField, {
    id: `entityTags.${entityType}.alert`
  }))));
};

const EntitySourcePopover = ({ comments, execution, executionType, metadata }) => {
  const { description, previousServerGroup, user } = metadata || {};
  return /* @__PURE__ */ React.createElement(LabeledValueList, null, /* @__PURE__ */ React.createElement(LabeledValue, {
    label: capitalize(executionType),
    value: description
  }), execution && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Triggered By",
    value: user || execution.trigger.type
  }), !execution && user && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "User",
    value: user
  }), previousServerGroup && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Replaced",
    value: previousServerGroup.name
  }), previousServerGroup && /* @__PURE__ */ React.createElement("dd", null, `${previousServerGroup.imageName}${previousServerGroup.imageId !== previousServerGroup.imageName ? `${previousServerGroup.imageId}` : ""}`), comments && /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Comments",
    value: /* @__PURE__ */ React.createElement(Markdown, {
      message: comments
    })
  }));
};

const EntitySource = ({ metadata, relativePath = "^.^.^" }) => {
  var _a, _b;
  const executionType = ((_a = metadata == null ? void 0 : metadata.value) == null ? void 0 : _a.executionType) === "pipeline" ? "pipeline" : "task";
  const { application, comments, executionId, stageId } = (metadata == null ? void 0 : metadata.value) || {};
  const fetchExecution = () => {
    var _a2;
    if (executionType === "pipeline") {
      return ReactInjector.executionService.getExecution((_a2 = metadata == null ? void 0 : metadata.value) == null ? void 0 : _a2.executionId);
    }
    return new Promise(() => {
    });
  };
  const { result: execution, status, error } = useData(fetchExecution, void 0, [
    executionType,
    (_b = metadata == null ? void 0 : metadata.value) == null ? void 0 : _b.executionId
  ]);
  const isLoading = status !== "RESOLVED";
  const srefPath = executionType === "pipeline" ? `${relativePath}.pipelines.executionDetails.execution` : `${relativePath}.tasks.taskDetails`;
  const srefParams = executionType === "pipeline" ? { application, executionId, stageId } : { application, taskId: executionId };
  const PopoverContent = () => /* @__PURE__ */ React.createElement(EntitySourcePopover, {
    comments,
    execution,
    executionType,
    metadata: metadata.value
  });
  if (!metadata || executionType === "pipeline" && isLoading) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dt", null, "Source"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(HoverablePopover, {
    Component: PopoverContent
  }, error && /* @__PURE__ */ React.createElement("span", null, "pipeline (not found)"), !error && /* @__PURE__ */ React.createElement(UIRouterContextComponent, null, /* @__PURE__ */ React.createElement(UISref, {
    to: srefPath,
    params: srefParams
  }, /* @__PURE__ */ React.createElement("a", {
    className: "clickable"
  }, executionType))))));
};

class ClusterTargetBuilder {
  static buildClusterTargets(serverGroup) {
    const clusterName = serverGroup.moniker.cluster;
    const regionName = serverGroup.cloudProvider === "kubernetes" ? "namespace" : "region";
    return [
      {
        type: "serverGroup",
        label: `just ${serverGroup.name}`,
        owner: serverGroup,
        isDefault: true
      },
      {
        type: "cluster",
        label: `all server groups in **${serverGroup.region}** in ${clusterName}`,
        owner: {
          name: clusterName,
          cloudProvider: serverGroup.cloudProvider,
          region: serverGroup.region,
          account: serverGroup.account
        },
        isDefault: false
      },
      {
        type: "cluster",
        label: `all server groups in **all ${regionName}s** in ${clusterName}`,
        owner: {
          name: clusterName,
          cloudProvider: serverGroup.cloudProvider,
          region: "*",
          account: serverGroup.account
        },
        isDefault: false
      }
    ];
  }
  static buildManagerClusterTargets(serverGroupManager) {
    const clusterName = serverGroupManager.moniker.cluster;
    return [
      {
        type: "serverGroupManager",
        label: `all server groups in **${serverGroupManager.name}** in ${clusterName}`,
        owner: {
          name: serverGroupManager.name,
          cloudProvider: serverGroupManager.cloudProvider,
          region: serverGroupManager.region,
          account: serverGroupManager.account
        },
        isDefault: true
      },
      {
        type: "cluster",
        label: `all server groups in **${serverGroupManager.region}** in ${clusterName}`,
        owner: {
          name: clusterName,
          cloudProvider: serverGroupManager.cloudProvider,
          region: serverGroupManager.region,
          account: serverGroupManager.account
        },
        isDefault: true
      },
      {
        type: "cluster",
        label: `all server groups in **all namespaces** in ${clusterName}`,
        owner: {
          name: clusterName,
          cloudProvider: serverGroupManager.cloudProvider,
          region: "*",
          account: serverGroupManager.account
        },
        isDefault: false
      }
    ];
  }
}

const CommitHistory = ({ commits }) => {
  const formatDate = (timestamp) => {
    return typeof timestamp === "string" ? DateTime.fromISO(timestamp).toFormat("MM/dd") : DateTime.fromMillis(timestamp).toFormat("MM/dd");
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("table", {
    className: "table table-condensed"
  }, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Date"), /* @__PURE__ */ React.createElement("th", null, "Commit"), /* @__PURE__ */ React.createElement("th", null, "Message"), /* @__PURE__ */ React.createElement("th", null, "Author")), commits.map((commit) => /* @__PURE__ */ React.createElement("tr", {
    key: commit.id
  }, /* @__PURE__ */ React.createElement("td", null, formatDate(commit.timestamp)), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("a", {
    target: "_blank",
    href: commit.commitUrl
  }, commit.displayId)), /* @__PURE__ */ React.createElement("td", null, commit.message.slice(0, 50)), /* @__PURE__ */ React.createElement("td", null, commit.authorDisplayName || "N/A"))))));
};

const JarDiffTable = ({ heading, jars }) => /* @__PURE__ */ React.createElement("table", {
  className: "table table-condensed no-lines"
}, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, heading)), jars.map((jar) => /* @__PURE__ */ React.createElement("tr", {
  key: jar.displayDiff
}, /* @__PURE__ */ React.createElement("td", null, jar.displayDiff)))));
const JarDiffs = ({ jarDiffs }) => {
  var _a, _b, _c, _d, _e, _f;
  const hasJarDiffs = Object.keys(jarDiffs).some((key) => jarDiffs[key].length > 0);
  if (!hasJarDiffs) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", null, Boolean((_a = jarDiffs.added) == null ? void 0 : _a.length) && /* @__PURE__ */ React.createElement(JarDiffTable, {
    heading: "Added",
    jars: jarDiffs.added
  }), Boolean((_b = jarDiffs.removed) == null ? void 0 : _b.length) && /* @__PURE__ */ React.createElement(JarDiffTable, {
    heading: "Removed",
    jars: jarDiffs.removed
  }), Boolean((_c = jarDiffs.upgraded) == null ? void 0 : _c.length) && /* @__PURE__ */ React.createElement(JarDiffTable, {
    heading: "Upgraded",
    jars: jarDiffs.upgraded
  }), Boolean((_d = jarDiffs.downgraded) == null ? void 0 : _d.length) && /* @__PURE__ */ React.createElement(JarDiffTable, {
    heading: "Downgraded",
    jars: jarDiffs.downgraded
  }), Boolean((_e = jarDiffs.duplicates) == null ? void 0 : _e.length) && /* @__PURE__ */ React.createElement(JarDiffTable, {
    heading: "Duplicates",
    jars: jarDiffs.duplicates
  }), Boolean((_f = jarDiffs.unknown) == null ? void 0 : _f.length) && /* @__PURE__ */ React.createElement(JarDiffTable, {
    heading: "Unknown",
    jars: jarDiffs.unknown
  }));
};

const buildJenkinsLink = (jenkins, build) => build ? `${jenkins.host}job/${jenkins.name}/${build}` : void 0;
const ChangesModal = ({ buildInfo, commits, dismissModal, jarDiffs, nameItem }) => {
  const previousBuildLink = buildJenkinsLink(buildInfo.jenkins, buildInfo.ancestor);
  const currentBuildLink = buildJenkinsLink(buildInfo.jenkins, buildInfo.target);
  const hasJarChanges = Object.keys(jarDiffs).some((key) => jarDiffs[key].length > 0);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ModalHeader, null, `Changes to ${nameItem.name}`), /* @__PURE__ */ React.createElement(ModalBody, null, /* @__PURE__ */ React.createElement("div", {
    className: "flex-container-v flex-1 sp-margin-s-top"
  }, /* @__PURE__ */ React.createElement("div", null, (buildInfo == null ? void 0 : buildInfo.ancestor) && /* @__PURE__ */ React.createElement("div", {
    className: "col-md-6"
  }, /* @__PURE__ */ React.createElement("strong", null, "Previous: "), previousBuildLink ? /* @__PURE__ */ React.createElement("a", {
    href: previousBuildLink,
    target: "_blank"
  }, `Build: #${buildInfo.ancestor}`) : /* @__PURE__ */ React.createElement("span", null, `Build: #${buildInfo.ancestor}`)), (buildInfo == null ? void 0 : buildInfo.target) && /* @__PURE__ */ React.createElement("div", {
    className: "col-md-6"
  }, /* @__PURE__ */ React.createElement("strong", null, "Current: "), currentBuildLink ? /* @__PURE__ */ React.createElement("a", {
    href: currentBuildLink,
    target: "_blank"
  }, `Build: #${buildInfo.target}`) : /* @__PURE__ */ React.createElement("span", null, `Build: #${buildInfo.target}`))), Boolean(commits == null ? void 0 : commits.length) && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: "component-heading sticky-header"
  }, /* @__PURE__ */ React.createElement("h4", null, "Commits")), /* @__PURE__ */ React.createElement("div", {
    className: "component-body"
  }, /* @__PURE__ */ React.createElement(CommitHistory, {
    commits
  }))), hasJarChanges && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: "component-heading sticky-header"
  }, /* @__PURE__ */ React.createElement("h4", null, "JAR Changes")), /* @__PURE__ */ React.createElement("div", {
    className: "component-body"
  }, /* @__PURE__ */ React.createElement(JarDiffs, {
    jarDiffs
  }))))), /* @__PURE__ */ React.createElement(ModalFooter, {
    primaryActions: /* @__PURE__ */ React.createElement("button", {
      className: "btn btn-primary",
      onClick: dismissModal
    }, "Close")
  }));
};

const ViewChangesLink = ({ changeConfig, linkText, nameItem, viewType }) => {
  var _a, _b, _c;
  const changeConfigValue = ((_a = changeConfig == null ? void 0 : changeConfig.metadata) == null ? void 0 : _a.value) || {};
  const fetchExecution = () => {
    const isExecution = changeConfigValue.executionType === "pipeline";
    if (isExecution) {
      return ReactInjector.executionService.getExecution(changeConfigValue.executionId);
    }
    return Promise.resolve({});
  };
  const { result: executionDetails, status } = useData(fetchExecution, {}, [
    changeConfigValue.executionId,
    changeConfigValue.stageId
  ]);
  const stage = (executionDetails.stages || []).find((s) => s.id === changeConfigValue.stageId);
  const commits = ((_b = stage == null ? void 0 : stage.context) == null ? void 0 : _b.commits) || changeConfig.commits || [];
  const jarDiffs = ((_c = stage == null ? void 0 : stage.context) == null ? void 0 : _c.jarDiffs) || changeConfig.jarDiffs;
  const buildInfo = stage ? {
    ...changeConfig.buildInfo,
    ...stage.context.buildInfo
  } : changeConfig.buildInfo;
  const isLoaded = status === "RESOLVED";
  const hasJarDiffs = Object.keys(jarDiffs || {}).some((key) => jarDiffs[key].length > 0);
  const hasChanges = hasJarDiffs || commits.length;
  const showChangesModal = () => {
    const modalProps = {
      buildInfo,
      commits,
      jarDiffs,
      nameItem
    };
    showModal(ChangesModal, modalProps, { maxWidth: 700 });
  };
  const viewChanges = /* @__PURE__ */ React.createElement("a", {
    className: "clickable",
    onClick: showChangesModal
  }, linkText || "View Changes");
  if (!isLoaded || !hasChanges) {
    return null;
  }
  if (viewType === "linkOnly") {
    return /* @__PURE__ */ React.createElement("span", null, viewChanges);
  }
  return /* @__PURE__ */ React.createElement(LabeledValue, {
    label: "Changes",
    value: viewChanges
  });
};

const VIEW_CHANGES_LINK = "spinnaker.diffs.view.changes.link";
module(VIEW_CHANGES_LINK, []).component("viewChangesLink", react2angular(withErrorBoundary(ViewChangesLink, "viewChangesLink"), [
  "changeConfig",
  "linkText",
  "nameItem",
  "viewType"
]));

const DIFF_MODULE = "spinnaker.diff.module";
module(DIFF_MODULE, [VIEW_CHANGES_LINK]);

const MapPair = (props) => {
  const { keyLabel, labelsLeft, pair, onChange, onDelete, valueLabel, valueCanContainSpel, pipeline } = props;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("tr", {
    className: "MapPair"
  }, labelsLeft && /* @__PURE__ */ React__default.createElement("td", {
    className: "table-label"
  }, /* @__PURE__ */ React__default.createElement("b", null, keyLabel)), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("input", {
    className: "form-control input input-sm",
    type: "text",
    value: pair.key,
    onChange: (e) => onChange({ key: e.target.value, value: pair.value })
  })), labelsLeft && /* @__PURE__ */ React__default.createElement("td", {
    className: "table-label"
  }, /* @__PURE__ */ React__default.createElement("b", null, valueLabel)), /* @__PURE__ */ React__default.createElement("td", null, valueCanContainSpel ? /* @__PURE__ */ React__default.createElement(SpelText, {
    value: pair.value,
    pipeline,
    docLink: true,
    onChange: (value) => onChange({ key: pair.key, value })
  }) : /* @__PURE__ */ React__default.createElement("input", {
    className: "form-control input input-sm",
    type: "text",
    value: pair.value,
    onChange: (e) => onChange({ key: pair.key, value: e.target.value })
  })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-control-static"
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "clickable button",
    onClick: onDelete
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-trash"
  }), /* @__PURE__ */ React__default.createElement("span", {
    className: "sr-only"
  }, "Remove field"))))), pair.error && /* @__PURE__ */ React__default.createElement("tr", {
    className: "MapPair_error"
  }, /* @__PURE__ */ React__default.createElement("td", {
    colSpan: 3
  }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    message: pair.error,
    type: "error"
  }))));
};

var css_248z$1r = ".MapEditor tr.MapPair_error td {\n  border-top: 0;\n  padding-top: 0;\n  margin-top: 0;\n}\n.MapEditor .MapPair a.button {\n  position: relative;\n}\n";
styleInject(css_248z$1r);

class MapEditor extends React__default.Component {
  constructor(props) {
    super(props);
    this.onChange = (newPair, index) => {
      this.state.backingModel[index] = newPair;
      this.handleChanged();
    };
    this.onDelete = (index) => {
      this.state.backingModel.splice(index, 1);
      this.handleChanged();
    };
    this.onAdd = () => {
      this.state.backingModel.push({ key: "", value: "" });
      this.handleChanged();
    };
    const isParameterized = isString(props.model);
    this.state = {
      backingModel: !isParameterized ? this.mapModel(props.model) : null
    };
  }
  componentDidUpdate(prevProps) {
    const isModelObj = !isString(this.props.model);
    if (isModelObj && !isEqual(prevProps.model, this.props.model)) {
      this.setState({ backingModel: this.mapModel(this.props.model) });
    }
  }
  mapModel(model) {
    return Object.keys(model).map((key) => ({ key, value: model[key] }));
  }
  reduceModel(backingModel) {
    return backingModel.reduce((acc, pair) => {
      if (this.props.allowEmpty || pair.value) {
        acc[pair.key] = pair.value;
      }
      return acc;
    }, {});
  }
  validateUnique(model) {
    let error = false;
    const usedKeys = new Set();
    model.forEach((p) => {
      if (usedKeys.has(p.key)) {
        p.error = "Duplicate key";
        error = true;
      } else {
        delete p.error;
      }
      usedKeys.add(p.key);
    });
    return error;
  }
  handleChanged() {
    const error = this.validateUnique(this.state.backingModel);
    const newModel = this.reduceModel(this.state.backingModel);
    this.props.onChange(newModel, error);
  }
  render() {
    const {
      addButtonLabel,
      hiddenKeys,
      keyLabel,
      label,
      labelsLeft,
      model,
      valueLabel,
      valueCanContainSpel,
      pipeline
    } = this.props;
    const { backingModel } = this.state;
    const rowProps = { keyLabel, valueLabel, labelsLeft };
    const columnCount = this.props.labelsLeft ? 5 : 3;
    const tableClass = this.props.label ? "" : "no-border-top";
    const isParameterized = isString(this.props.model);
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "MapEditor"
    }, label && /* @__PURE__ */ React__default.createElement("div", {
      className: "sm-label-left"
    }, /* @__PURE__ */ React__default.createElement("b", null, label)), isParameterized && /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      value: model
    }), !isParameterized && /* @__PURE__ */ React__default.createElement("table", {
      className: `table table-condensed packed tags ${tableClass}`
    }, /* @__PURE__ */ React__default.createElement("thead", null, !labelsLeft && /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, keyLabel), /* @__PURE__ */ React__default.createElement("th", null, valueLabel), /* @__PURE__ */ React__default.createElement("th", null))), /* @__PURE__ */ React__default.createElement("tbody", null, backingModel.filter((p) => !hiddenKeys.includes(p.key)).map((pair, index) => /* @__PURE__ */ React__default.createElement(MapPair, {
      key: index,
      ...rowProps,
      onChange: (value) => this.onChange(value, index),
      onDelete: () => this.onDelete(index),
      pair,
      valueCanContainSpel,
      pipeline
    }))), /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
      colSpan: columnCount
    }, /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: "btn btn-block btn-sm add-new",
      onClick: this.onAdd
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), addButtonLabel))))));
  }
}
MapEditor.defaultProps = {
  addButtonLabel: "Add Field",
  allowEmpty: false,
  hiddenKeys: [],
  keyLabel: "Key",
  labelsLeft: false,
  valueLabel: "Value",
  valueCanContainSpel: false
};

const duplicateKeyPattern = /^__MapEditorDuplicateKey__\d+__/;
function objectToTuples(model, errors) {
  model = model || {};
  errors = errors || {};
  return Object.keys(model).map((key) => {
    const keyWithoutMagicString = key.split(duplicateKeyPattern).pop();
    return { key: keyWithoutMagicString, value: model[key], error: errors[key] };
  });
}
function tuplesToObject(pairs) {
  return pairs.reduce((acc, pair, idx) => {
    const key = isNil(acc[pair.key]) ? pair.key : `__MapEditorDuplicateKey__${idx}__${pair.key}`;
    return { ...acc, [key]: pair.value };
  }, {});
}
function mapEditorValidator(options) {
  const opts = defaults({}, options, { allowEmptyValues: false });
  return function(values) {
    const errors = Object.keys(values || {}).reduce((acc, key) => {
      if (!key) {
        return { ...acc, [key]: "Empty key" };
      } else if (duplicateKeyPattern.exec(key)) {
        return { ...acc, [key]: "Duplicate key" };
      } else if (!opts.allowEmptyValues && !values[key]) {
        return { ...acc, [key]: "Empty value" };
      }
      return acc;
    }, {});
    return Object.keys(errors).length ? errors : null;
  };
}
function MapEditorInput({
  addButtonLabel = "Add Field",
  allowEmptyValues = false,
  hiddenKeys = [],
  keyLabel = "Key",
  label,
  labelsLeft = false,
  name,
  onChange,
  value,
  valueLabel = "Value",
  valueCanContainSpel = false,
  validation,
  pipeline
}) {
  const rowProps = { keyLabel, valueLabel, labelsLeft };
  const validator = React__default.useRef(mapEditorValidator({ allowEmptyValues }));
  const columnCount = labelsLeft ? 5 : 3;
  const tableClass = label ? "" : "no-border-top";
  const isParameterized = isString(value);
  const backingModel = !isString(value) ? objectToTuples(value, validation && validation.messageNode || {}) : null;
  React__default.useEffect(() => {
    if (validation && isFunction(validation.addValidator)) {
      validation.addValidator(validator.current);
    }
    return () => {
      if (validation && isFunction(validation.removeValidator)) {
        validation.removeValidator(validator.current);
      }
    };
  }, []);
  const handleChanged = () => {
    onChange(createFakeReactSyntheticEvent({ name, value: tuplesToObject(backingModel) }));
  };
  const handlePairChanged = (newPair, index) => {
    backingModel[index] = newPair;
    handleChanged();
  };
  const handleDeletePair = (index) => {
    backingModel.splice(index, 1);
    handleChanged();
  };
  const handleAddPair = () => {
    backingModel.push({ key: "", value: "" });
    handleChanged();
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "MapEditor"
  }, label && /* @__PURE__ */ React__default.createElement("div", {
    className: "sm-label-left"
  }, /* @__PURE__ */ React__default.createElement("b", null, label)), isParameterized && /* @__PURE__ */ React__default.createElement("input", {
    className: "form-control input-sm",
    value
  }), !isParameterized && /* @__PURE__ */ React__default.createElement("table", {
    className: `table table-condensed packed tags ${tableClass}`
  }, /* @__PURE__ */ React__default.createElement("thead", null, !labelsLeft && /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, keyLabel), /* @__PURE__ */ React__default.createElement("th", null, valueLabel), /* @__PURE__ */ React__default.createElement("th", null))), /* @__PURE__ */ React__default.createElement("tbody", null, backingModel.filter((p) => !hiddenKeys.includes(p.key)).map((pair, index) => /* @__PURE__ */ React__default.createElement(MapPair, {
    key: index,
    ...rowProps,
    onChange: (x) => handlePairChanged(x, index),
    onDelete: () => handleDeletePair(index),
    pair,
    valueCanContainSpel,
    pipeline
  }))), /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
    colSpan: columnCount
  }, /* @__PURE__ */ React__default.createElement("button", {
    type: "button",
    className: "btn btn-block btn-sm add-new",
    onClick: handleAddPair
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-plus-sign"
  }), addButtonLabel))))));
}

const NumberListToggle = ({ isNumber, toggle }) => /* @__PURE__ */ React.createElement("div", {
  className: "flex-container-h btn-group btn-group-xs sp-padding-s-yaxis sp-margin-s-left"
}, /* @__PURE__ */ React.createElement("button", {
  type: "button",
  className: `btn btn-default ${isNumber ? "active" : ""}`,
  onClick: () => toggle(true)
}, /* @__PURE__ */ React.createElement(Tooltip, {
  value: "Toggle to enter number"
}, /* @__PURE__ */ React.createElement("span", null, "Num"))), /* @__PURE__ */ React.createElement("button", {
  type: "button",
  className: `btn btn-default ${isNumber ? "" : "active"}`,
  onClick: () => toggle(false)
}, /* @__PURE__ */ React.createElement(Tooltip, {
  value: "Toggle to enter expression"
}, /* @__PURE__ */ React.createElement("span", null, "${", "\u2026", "}"))));
const NumberList = ({ constraints, label, model, onChange }) => {
  const [isNumList, setIsNumList] = React.useState(typeof model !== "string");
  const [numListModel, setNumListModel] = React.useState(isNumList ? model : []);
  const spelModel = isNumList ? "" : model;
  const updateModel = (list) => {
    setNumListModel(list);
    const sortedList = list.filter((n) => n !== null).sort((a, b) => a - b);
    onChange(sortedList);
  };
  const addNumber = () => {
    const newNumList = [...numListModel, null];
    updateModel(newNumList);
  };
  const removeNumber = (index) => {
    const newNumListModel = numListModel.filter((_, i) => i !== index);
    updateModel(newNumListModel);
  };
  const updateNumber = (num, index) => {
    const newNumList = [...numListModel];
    newNumList[index] = Number.parseInt(num, 10);
    updateModel(newNumList);
  };
  const toggleMode = (isNum) => {
    const newModel = isNum ? [] : "${}";
    setIsNumList(isNum);
    onChange(newModel);
  };
  return /* @__PURE__ */ React.createElement("div", null, !isNumList && /* @__PURE__ */ React.createElement("div", {
    className: "flex-container-h"
  }, /* @__PURE__ */ React.createElement(TextInput, {
    className: "form-control",
    type: "text",
    value: spelModel,
    onChange: (e) => onChange(e.target.value)
  }), /* @__PURE__ */ React.createElement(NumberListToggle, {
    isNumber: isNumList,
    toggle: toggleMode
  })), isNumList && /* @__PURE__ */ React.createElement("div", null, (numListModel || []).map((num, i) => /* @__PURE__ */ React.createElement("div", {
    key: `number-list-${i}`,
    className: "flex-container-h sp-padding-xs-yaxis"
  }, /* @__PURE__ */ React.createElement(NumberInput$1, {
    value: num,
    max: constraints == null ? void 0 : constraints.max,
    min: constraints == null ? void 0 : constraints.min,
    onChange: (e) => updateNumber(e.target.value, i)
  }), i === 0 && /* @__PURE__ */ React.createElement(NumberListToggle, {
    isNumber: isNumList,
    toggle: toggleMode
  }), i > 0 && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "btn btn-link btn-sm sp-margin-l-right sp-padding-xl-xaxis",
    onClick: () => removeNumber(i)
  }, /* @__PURE__ */ React.createElement("i", {
    className: "glyphicon glyphicon-trash"
  })))), /* @__PURE__ */ React.createElement("button", {
    className: "btn btn-xs btn-block add-new",
    type: "button",
    onClick: addNumber
  }, /* @__PURE__ */ React.createElement("i", {
    className: "glyphicon glyphicon-plus-sign"
  }), /* @__PURE__ */ React.createElement("span", null, `Add ${label || "Item"}`))));
};

class ImageReader {
  constructor(providerServiceDelegate) {
    this.providerServiceDelegate = providerServiceDelegate;
  }
  getDelegate(cloudProvider) {
    return this.providerServiceDelegate.getDelegate(cloudProvider, "image.reader");
  }
  findImages(params) {
    return this.getDelegate(params.provider).findImages(params);
  }
  getImage(cloudProvider, imageName, region, credentials) {
    return this.getDelegate(cloudProvider).getImage(imageName, region, credentials);
  }
}
ImageReader.$inject = ["providerServiceDelegate"];
const IMAGE_READER = "spinnaker.core.image.reader";
module(IMAGE_READER, [PROVIDER_SERVICE_DELEGATE]).service("imageReader", ImageReader);

class InstanceReader {
  static getInstanceDetails(account, region, id) {
    return REST("/instances").path(account, region, id).get();
  }
  static getConsoleOutput(account, region, id, cloudProvider) {
    return REST("/instances").path(account, region, id, "console").query({ provider: cloudProvider }).get();
  }
}

var css_248z$1q = ".console-output-tabs {\n  list-style: none;\n  overflow-x: scroll;\n  padding: 0 20px;\n}\n.console-output-tab {\n  min-width: 50px;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n";
styleInject(css_248z$1q);

const ConsoleOutputModal = ({ dismissModal, instance, usesMultiOutput }) => {
  const logContainerEnd = React.useRef(null);
  const getConsoleOutput = () => {
    return InstanceReader.getConsoleOutput(instance.account, instance.region, instance.id, instance.provider);
  };
  const { result: consoleOutputResponse, status, error, refresh: refreshLogs } = useData(getConsoleOutput, null, []);
  const consoleOutput = consoleOutputResponse == null ? void 0 : consoleOutputResponse.output;
  const [selectedLog, setSelectedLog] = React.useState(((consoleOutputResponse == null ? void 0 : consoleOutputResponse.output) || [])[0]);
  const loading = status === "PENDING";
  const jumpToEnd = () => {
    logContainerEnd.current.scrollIntoView({ behavior: "smooth" });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ModalHeader, null, "Console Output: ", instance.id), /* @__PURE__ */ React.createElement(ModalBody, null, /* @__PURE__ */ React.createElement("div", {
    id: "console-output"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-12"
  }, loading && /* @__PURE__ */ React.createElement("div", {
    className: "horizontal center middle spinner-container"
  }, /* @__PURE__ */ React.createElement(Spinner, {
    size: "small"
  })), usesMultiOutput && !loading && Boolean(consoleOutput == null ? void 0 : consoleOutput.length) && /* @__PURE__ */ React.createElement("div", null, (consoleOutput || []).map((log) => /* @__PURE__ */ React.createElement("ul", {
    className: "tabs-basic console-output-tabs"
  }, /* @__PURE__ */ React.createElement("li", {
    className: `console-output-tab ${(log == null ? void 0 : log.name) === (selectedLog == null ? void 0 : selectedLog.name) ? "selected" : ""}`,
    onClick: () => setSelectedLog(log),
    "ng-repeat": "log in vm.consoleOutput"
  }, log.name))), selectedLog && /* @__PURE__ */ React.createElement("pre", {
    className: "body-small"
  }, selectedLog == null ? void 0 : selectedLog.output)), !usesMultiOutput && !loading && Boolean(consoleOutput == null ? void 0 : consoleOutput.length) && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("pre", {
    className: "body-small"
  }, consoleOutput)), error && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, "An error occurred trying to load console output. Please try again later."), /* @__PURE__ */ React.createElement("p", null, "Exception:"), /* @__PURE__ */ React.createElement("pre", null, error.data.body)))), /* @__PURE__ */ React.createElement("div", {
    ref: logContainerEnd
  }))), /* @__PURE__ */ React.createElement(ModalFooter, {
    primaryActions: /* @__PURE__ */ React.createElement(React.Fragment, null, consoleOutput && /* @__PURE__ */ React.createElement("button", {
      className: "btn btn-link",
      onClick: refreshLogs
    }, "Refresh"), consoleOutput && /* @__PURE__ */ React.createElement("button", {
      className: "btn btn-link",
      onClick: jumpToEnd
    }, "Scroll to End"), /* @__PURE__ */ React.createElement("button", {
      className: "btn btn-primary",
      onClick: dismissModal
    }, "Close"))
  }));
};

const ConsoleOutputLink = ({ instance, text, usesMultiOutput }) => {
  const showConsoleOutput = () => {
    showModal(ConsoleOutputModal, { instance, usesMultiOutput });
  };
  return /* @__PURE__ */ React.createElement("button", {
    className: "btn btn-link",
    onClick: showConsoleOutput
  }, text || "Console Output (Raw)");
};

const InstanceActions = ({ actions, title }) => /* @__PURE__ */ React__default.createElement("div", {
  style: { display: "inline-block" }
}, /* @__PURE__ */ React__default.createElement(Dropdown, {
  className: "dropdown",
  id: "instace-actions-dropdown"
}, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
  className: "btn btn-sm btn-primary dropdown-toggle"
}, /* @__PURE__ */ React__default.createElement("span", null, title || "Instance Actions")), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, null, (actions || []).map((action) => /* @__PURE__ */ React__default.createElement("li", {
  key: `action-${action.label}`,
  id: `instance-action-${action.label}`
}, /* @__PURE__ */ React__default.createElement("a", {
  onClick: action.triggerAction
}, action.label))))));

const InstanceDetailsPane = (props) => {
  const isStandalone = ReactInjector.$uiRouter.globals.current.name === "instanceDetails";
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "details-panel"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "header"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "close-button"
  }, /* @__PURE__ */ React__default.createElement(UISref, {
    to: isStandalone ? "home.infrastructure" : "^"
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "btn btn-link"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-remove"
  })))), props.children));
};

var __defProp$n = Object.defineProperty;
var __getOwnPropDesc$n = Object.getOwnPropertyDescriptor;
var __decorateClass$n = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$n(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$n(target, key, result);
  return result;
};
class InstanceDetails extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      accountId: null,
      environment: null,
      instanceId: null,
      loading: false,
      moniker: null,
      provider: null
    };
    this.destroy$ = new Subject();
    this.props$ = new Subject();
  }
  componentDidMount() {
    this.props$.pipe(tap(({ $stateParams: { provider, instanceId } }) => {
      this.setState({ provider, instanceId, loading: true, accountId: null, moniker: null, environment: null });
    }), switchMap(({ app, $stateParams }) => {
      const { provider, instanceId } = $stateParams;
      const accountId = from(AccountService.getAccountForInstance(provider, instanceId, app));
      const moniker = from(NameUtils.getMonikerForInstance(provider, instanceId, app));
      const accountDetails = accountId.pipe(mergeMap((id) => AccountService.getAccountDetails(id)));
      return forkJoin(accountId, moniker, accountDetails);
    }), takeUntil(this.destroy$)).subscribe(([accountId, moniker, accountDetails]) => {
      const environment = accountDetails && accountDetails.environment;
      this.setState({ accountId, moniker, environment, loading: false });
    });
    this.props$.next(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.props$.next(nextProps);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { accountId, instanceId, moniker, environment, loading, provider } = this.state;
    if (loading) {
      return /* @__PURE__ */ React__default.createElement(InstanceDetailsPane, null, /* @__PURE__ */ React__default.createElement(Spinner, {
        size: "medium",
        message: " "
      }));
    } else if (!accountId || !moniker || !environment) {
      return /* @__PURE__ */ React__default.createElement(InstanceDetailsPane, null, /* @__PURE__ */ React__default.createElement("h4", null, "Could not find ", provider, " instance ", instanceId, "."));
    }
    return /* @__PURE__ */ React__default.createElement(InstanceDetailsCmp, {
      ...this.props,
      accountId,
      moniker,
      environment
    });
  }
}
let InstanceDetailsCmp = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("h3", null, "Instance Details");
  }
};
InstanceDetailsCmp = __decorateClass$n([
  Overridable("instance.details")
], InstanceDetailsCmp);

var css_248z$1p = ".InstanceDetailsHeader .spinner-container {\n  height: 8px;\n  width: 100%;\n}\n.InstanceDetailsHeader .header-text .clipboard-btn .glyphicon {\n  color: inherit;\n  font-size: 150%;\n}\n";
styleInject(css_248z$1p);

const InstanceDetailsHeader = ({
  cloudProvider,
  healthState,
  instanceId,
  loading,
  sshLink,
  standalone
}) => /* @__PURE__ */ React__default.createElement("div", {
  className: "InstanceDetailsHeader"
}, !standalone && /* @__PURE__ */ React__default.createElement("div", {
  className: "close-button"
}, /* @__PURE__ */ React__default.createElement(UIRouterContextComponent, null, /* @__PURE__ */ React__default.createElement(UISref, {
  to: "^"
}, /* @__PURE__ */ React__default.createElement("a", {
  className: "btn btn-link"
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "glyphicon glyphicon-remove"
}))))), loading && /* @__PURE__ */ React__default.createElement("div", {
  className: "horizontal center spinner-container"
}, /* @__PURE__ */ React__default.createElement(Spinner, {
  size: "small"
})), !loading && /* @__PURE__ */ React__default.createElement("div", {
  className: "header-text horizontal middle"
}, cloudProvider && /* @__PURE__ */ React__default.createElement(CloudProviderLogo, {
  provider: cloudProvider,
  height: "36px",
  width: "36px"
}), !cloudProvider && /* @__PURE__ */ React__default.createElement("span", {
  className: `glyphicon glyphicon-hdd ${healthState}`
}), /* @__PURE__ */ React__default.createElement("h3", {
  className: "horizontal middle space-between flex-1"
}, instanceId), /* @__PURE__ */ React__default.createElement(CopyToClipboard, {
  text: sshLink || instanceId,
  toolTip: "Copy to clipboard"
})));

const InstanceInsights = ({ analytics, insights, instance, title }) => {
  const logClickEvent = (label) => {
    logger.log({
      category: "Insight Menu (Instance)",
      action: `${label} clicked`,
      data: { label: `${instance.account}/${instance.region}/${instance.name}/${instance.serverGroup}` }
    });
  };
  if (!(insights == null ? void 0 : insights.length)) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    style: { display: "inline-block" }
  }, /* @__PURE__ */ React__default.createElement(Dropdown, {
    className: "dropdown",
    id: "instace-actions-dropdown"
  }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
    className: "btn btn-sm dropdown-toggle"
  }, /* @__PURE__ */ React__default.createElement("span", null, title || "Insight")), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, null, insights.map((insight) => /* @__PURE__ */ React__default.createElement("li", {
    key: `insight-${insight.label}`,
    id: `insight-action-${insight.label}`,
    onClick: () => analytics ? logClickEvent(insight.label) : null
  }, /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    href: insight.url
  }, insight.label))))));
};

const InstanceLinks = ({ address, application, instance, moniker, environment }) => {
  const port = ___default.get(application, "attributes.instancePort", SETTINGS.defaultInstancePort) || 80;
  const linkSections = ___default.cloneDeep(___default.get(application, "attributes.instanceLinks", SETTINGS.defaultInstanceLinks) || []).filter((section) => !section.cloudProviders || !section.cloudProviders.length || !instance.cloudProvider || section.cloudProviders.includes(instance.cloudProvider));
  linkSections.forEach((section) => {
    section.links = section.links.map((link) => {
      const linkPort = link.path.indexOf(":") === 0 || !port ? "" : ":" + port;
      let url = link.path;
      if (url.includes("{{")) {
        url = $interpolate(url)(Object.assign({}, instance, moniker, {
          ipAddress: address,
          environment,
          embeddableIpAddress: (address || "").split(".").join("-")
        }));
      }
      if (!url.includes("//") && !url.startsWith("{{")) {
        url = `http://${address + linkPort + url}`;
      }
      return {
        url,
        title: link.title || link.path
      };
    });
  });
  return /* @__PURE__ */ React__default.createElement("div", null, linkSections.map((section) => !section.links.length ? null : /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    key: `link-section-${section.title}`,
    heading: section.title
  }, /* @__PURE__ */ React__default.createElement("ul", null, section.links.map((link) => /* @__PURE__ */ React__default.createElement("li", {
    key: link.title
  }, /* @__PURE__ */ React__default.createElement("a", {
    href: link.url,
    target: "_blank"
  }, link.title)))))));
};

class ServerGroupReader {
  static getScalingActivities(serverGroup) {
    return REST("/applications").path(serverGroup.app, "clusters", serverGroup.account, serverGroup.cluster, "serverGroups", serverGroup.name, "scalingActivities").query({
      region: serverGroup.region,
      provider: serverGroup.cloudProvider
    }).get().catch((error) => {
      $log.error(error, "error retrieving scaling activities");
      return [];
    });
  }
  static getServerGroup(application, account, region, serverGroupName) {
    return REST("/applications").path(application, "serverGroups", account, region, serverGroupName).query({ includeDetails: "false" }).get();
  }
}

class InstanceWriter {
  static terminateInstance(instance, application, params = {}) {
    params.type = "terminateInstances";
    params["instanceIds"] = [instance.id];
    params["region"] = instance.region;
    params["zone"] = instance.zone;
    params["credentials"] = instance.account;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Terminate instance: ${instance.id}`
    });
  }
  static terminateInstances(instanceGroups, application) {
    return InstanceWriter.executeMultiInstanceTask(instanceGroups, application, "terminateInstances", "Terminate");
  }
  static executeMultiInstanceTask(instanceGroups, application, type, baseDescriptor, descriptorSuffix, additionalJobProperties = {}) {
    const jobs = InstanceWriter.buildMultiInstanceJob(instanceGroups, type, additionalJobProperties);
    const descriptor = InstanceWriter.buildMultiInstanceDescriptor(jobs, baseDescriptor, descriptorSuffix);
    return TaskExecutor.executeTask({
      job: jobs,
      application,
      description: descriptor
    });
  }
  static rebootInstances(instanceGroups, application) {
    return InstanceWriter.executeMultiInstanceTask(instanceGroups, application, "rebootInstances", "Reboot");
  }
  static rebootInstance(instance, application, params = {}) {
    params.type = "rebootInstances";
    params.instanceIds = [instance.id];
    params.region = instance.region;
    params.zone = instance.zone;
    params.credentials = instance.account;
    params.cloudProvider = instance.cloudProvider;
    params.application = application.name;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Reboot instance: ${instance.id}`
    });
  }
  static deregisterInstancesFromLoadBalancer(instanceGroups, application, loadBalancerNames) {
    const jobs = InstanceWriter.buildMultiInstanceJob(instanceGroups, "deregisterInstancesFromLoadBalancer");
    jobs.forEach((job) => job.loadBalancerNames = loadBalancerNames);
    const descriptor = InstanceWriter.buildMultiInstanceDescriptor(jobs, "Deregister", `from ${loadBalancerNames.join(" and ")}`);
    return TaskExecutor.executeTask({
      job: jobs,
      application,
      description: descriptor
    });
  }
  static deregisterInstanceFromLoadBalancer(instance, application, params = {}) {
    params.type = "deregisterInstancesFromLoadBalancer";
    params.instanceIds = [instance.id];
    params.loadBalancerNames = instance.loadBalancers;
    params.region = instance.region;
    params.credentials = instance.account;
    params.cloudProvider = instance.cloudProvider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Deregister instance: ${instance.id}`
    });
  }
  static registerInstancesWithLoadBalancer(instanceGroups, application, loadBalancerNames) {
    const jobs = InstanceWriter.buildMultiInstanceJob(instanceGroups, "registerInstancesWithLoadBalancer");
    jobs.forEach((job) => job.loadBalancerNames = loadBalancerNames);
    const descriptor = InstanceWriter.buildMultiInstanceDescriptor(jobs, "Register", `with ${loadBalancerNames.join(" and ")}`);
    return TaskExecutor.executeTask({
      job: jobs,
      application,
      description: descriptor
    });
  }
  static registerInstanceWithLoadBalancer(instance, application, params = {}) {
    params.type = "registerInstancesWithLoadBalancer";
    params.instanceIds = [instance.id];
    params.loadBalancerNames = instance.loadBalancers;
    params.region = instance.region;
    params.credentials = instance.account;
    params.cloudProvider = instance.cloudProvider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Register instance: ${instance.id}`
    });
  }
  static enableInstancesInDiscovery(instanceGroups, application) {
    return InstanceWriter.executeMultiInstanceTask(instanceGroups, application, "enableInstancesInDiscovery", "Enable", "in discovery");
  }
  static enableInstanceInDiscovery(instance, application) {
    return TaskExecutor.executeTask({
      job: [
        {
          type: "enableInstancesInDiscovery",
          instanceIds: [instance.id],
          region: instance.region,
          credentials: instance.account,
          cloudProvider: instance.cloudProvider,
          serverGroupName: instance.serverGroup,
          asgName: instance.serverGroup
        }
      ],
      application,
      description: `Enable instance: ${instance.id}`
    });
  }
  static disableInstancesInDiscovery(instanceGroups, application) {
    return InstanceWriter.executeMultiInstanceTask(instanceGroups, application, "disableInstancesInDiscovery", "Disable", "in discovery");
  }
  static disableInstanceInDiscovery(instance, application) {
    return TaskExecutor.executeTask({
      job: [
        {
          type: "disableInstancesInDiscovery",
          instanceIds: [instance.id],
          region: instance.region,
          credentials: instance.account,
          cloudProvider: instance.cloudProvider,
          serverGroupName: instance.serverGroup,
          asgName: instance.serverGroup
        }
      ],
      application,
      description: `Disable instance: ${instance.id}`
    });
  }
  static terminateInstancesAndShrinkServerGroups(instanceGroups, application) {
    return InstanceWriter.executeMultiInstanceTask(instanceGroups, application, "detachInstances", "Terminate", "and shrink server groups", {
      terminateDetachedInstances: true,
      decrementDesiredCapacity: true,
      adjustMinIfNecessary: true
    });
  }
  static terminateInstanceAndShrinkServerGroup(instance, application, params = {}) {
    return ServerGroupReader.getServerGroup(application.name, instance.account, instance.region, instance.serverGroup).then((serverGroup) => {
      params.type = "terminateInstanceAndDecrementServerGroup";
      params.instance = instance.id;
      params.serverGroupName = instance.serverGroup;
      params.asgName = instance.serverGroup;
      params.region = instance.region;
      params.credentials = instance.account;
      params.cloudProvider = instance.cloudProvider;
      params.adjustMinIfNecessary = true;
      params.setMaxToNewDesired = serverGroup.asg.minSize === serverGroup.asg.maxSize;
      return TaskExecutor.executeTask({
        job: [params],
        application,
        description: `Terminate instance ${instance.id} and shrink ${instance.serverGroup}`
      });
    });
  }
  static buildMultiInstanceJob(instanceGroups, type, additionalJobProperties = {}) {
    return instanceGroups.filter((instanceGroup) => instanceGroup.instances.length > 0).map((instanceGroup) => InstanceWriter.convertGroupToJob(instanceGroup, type, additionalJobProperties));
  }
  static buildMultiInstanceDescriptor(jobs, base, suffix) {
    let totalInstances = 0;
    jobs.forEach((job) => totalInstances += job.instanceIds.length);
    let descriptor = `${base} ${totalInstances} instance`;
    if (totalInstances > 1) {
      descriptor += "s";
    }
    if (suffix) {
      descriptor += " " + suffix;
    }
    return descriptor;
  }
  static convertGroupToJob(instanceGroup, type, additionalJobProperties = {}) {
    const job = {
      type,
      cloudProvider: instanceGroup.cloudProvider,
      instanceIds: instanceGroup.instanceIds,
      credentials: instanceGroup.account,
      region: instanceGroup.region,
      serverGroupName: instanceGroup.serverGroup,
      asgName: instanceGroup.serverGroup
    };
    Object.assign(job, additionalJobProperties);
    InstanceWriter.transform(instanceGroup, job);
    return job;
  }
  static transform(instanceGroup, job) {
    const serviceKey = "instance.multiInstanceTaskTransformer";
    const { providerServiceDelegate } = ReactInjector;
    if (providerServiceDelegate.hasDelegate(instanceGroup.cloudProvider, serviceKey)) {
      const transformer = providerServiceDelegate.getDelegate(instanceGroup.cloudProvider, serviceKey);
      transformer.transform(instanceGroup, job);
    }
  }
}

class InstanceTypeService {
  constructor(providerServiceDelegate) {
    this.providerServiceDelegate = providerServiceDelegate;
  }
  getCategories(cloudProvider) {
    return this.getDelegate(cloudProvider).getCategories();
  }
  getAllTypesByRegion(cloudProvider) {
    return this.getDelegate(cloudProvider).getAllTypesByRegion();
  }
  getAvailableTypesForRegions(cloudProvider, instanceTypes, regions) {
    return this.getDelegate(cloudProvider).getAvailableTypesForRegions(instanceTypes, regions);
  }
  getCategoryForInstanceType(cloudProvider, instanceType) {
    return this.getInstanceTypeCategory(cloudProvider, instanceType).then((category) => {
      return category ? category.type : "custom";
    });
  }
  getCategoryForMultipleInstanceTypes(cloudProvider, instanceTypes) {
    const promises = instanceTypes.map((it) => this.getCategoryForInstanceType(cloudProvider, it));
    return Promise.all(promises).then((categories) => {
      const distinctCategories = uniq(categories);
      return distinctCategories.length === 1 ? distinctCategories[0] : "custom";
    });
  }
  getInstanceTypeDetails(cloudProvider, instanceType) {
    return this.getInstanceTypeCategory(cloudProvider, instanceType).then((category) => {
      if (category && category.families && category.families.length && category.families[0].instanceTypes) {
        return category.families[0].instanceTypes.find((i) => i.name === instanceType);
      } else {
        if (this.getDelegate(cloudProvider).resolveInstanceTypeDetails) {
          return this.getDelegate(cloudProvider).resolveInstanceTypeDetails(instanceType);
        }
        return null;
      }
    });
  }
  getInstanceTypeCategory(cloudProvider, instanceType) {
    return this.getCategories(cloudProvider).then((categories) => {
      return (categories || []).find((c) => c.families.some((f) => f.instanceTypes.some((i) => i.name === instanceType || i.nameRegex && i.nameRegex.test(instanceType))));
    });
  }
  getDelegate(cloudProvider) {
    return this.providerServiceDelegate.getDelegate(cloudProvider, "instance.instanceTypeService");
  }
}
InstanceTypeService.$inject = ["providerServiceDelegate"];
const INSTANCE_TYPE_SERVICE = "spinnaker.core.instanceType.service";
module(INSTANCE_TYPE_SERVICE, [PROVIDER_SERVICE_DELEGATE]).service("instanceTypeService", InstanceTypeService);

class InstanceLoadBalancerHealth extends React__default.Component {
  render() {
    const {
      loadBalancer: { healthState, state, name, description, loadBalancerName, healthCheckProtocol, healthCheckPath },
      ipAddress
    } = this.props;
    const health = healthState || (state === "InService" ? "Up" : "OutOfService");
    let icon = null;
    if (health === "Up") {
      icon = /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-Up-triangle"
      });
    } else if (health === "OutOfService" || health === "Down") {
      icon = /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-Down-triangle"
      });
    } else if (health === "Starting") {
      icon = /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-Starting-triangle"
      });
    }
    const displayName = /* @__PURE__ */ React__default.createElement("span", null, name || loadBalancerName);
    const downReason = healthState !== "Up" && !!description ? /* @__PURE__ */ React__default.createElement("span", {
      style: { color: "var(--color-danger)" }
    }, description) : null;
    const healthCheck = (healthCheckProtocol == null ? void 0 : healthCheckProtocol.toLowerCase().startsWith("http")) ? /* @__PURE__ */ React__default.createElement("a", {
      target: "_blank",
      href: `${healthCheckProtocol}://${ipAddress}${healthCheckPath}`
    }, "Health Check") : `${healthCheckProtocol}://${ipAddress}${healthCheckPath}`;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-h"
    }, /* @__PURE__ */ React__default.createElement("div", {
      style: { flex: "none", width: "16px" }
    }, icon), /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-v"
    }, displayName, downReason, ipAddress && healthCheckPath && healthCheck));
  }
}

class LoadBalancerDataUtils {
  static buildLoadBalancer(match, serverGroup) {
    if (!match) {
      return null;
    }
    const loadBalancer = { name: match.name, vpcId: match.vpcId, cloudProvider: match.cloudProvider };
    loadBalancer.instanceCounts = { up: 0, down: 0, succeeded: 0, failed: 0, outOfService: 0, unknown: 0, starting: 0 };
    serverGroup.instances.forEach((instance) => {
      const lbHealth = instance.health.find((h) => h.type === "LoadBalancer");
      if (lbHealth) {
        const matchedHealth = lbHealth.loadBalancers.find((lb) => lb.name === match.name);
        if (matchedHealth !== void 0 && matchedHealth.healthState !== void 0 && loadBalancer.instanceCounts[matchedHealth.healthState.toLowerCase()] !== void 0) {
          loadBalancer.instanceCounts[matchedHealth.healthState.toLowerCase()]++;
        }
      }
    });
    return loadBalancer;
  }
  static populateLoadBalancers(application, serverGroup) {
    return application.getDataSource("loadBalancers").ready().then(() => {
      const loadBalancers = serverGroup.loadBalancers.map((lbName) => {
        const match = application.getDataSource("loadBalancers").data.find((lb) => {
          return lb.name === lbName && lb.account === serverGroup.account && (lb.region === serverGroup.region || lb.region === "global");
        });
        return this.buildLoadBalancer(match, serverGroup);
      });
      return loadBalancers.filter((x) => !!x);
    });
  }
}

const CORE_LOADBALANCER_LOADBALANCER_TRANSFORMER = "spinnaker.core.loadBalancer.transformer";
module(CORE_LOADBALANCER_LOADBALANCER_TRANSFORMER, [PROVIDER_SERVICE_DELEGATE]).factory("loadBalancerTransformer", [
  "providerServiceDelegate",
  function(providerServiceDelegate) {
    function normalizeLoadBalancer(loadBalancer) {
      return providerServiceDelegate.getDelegate(loadBalancer.provider || loadBalancer.type, "loadBalancer.transformer").normalizeLoadBalancer(loadBalancer);
    }
    function normalizeLoadBalancerSet(loadBalancers) {
      const setNormalizers = chain(loadBalancers).filter((lb) => providerServiceDelegate.hasDelegate(lb.provider || lb.type, "loadBalancer.setTransformer")).compact().map((lb) => providerServiceDelegate.getDelegate(lb.provider || lb.type, "loadBalancer.setTransformer").normalizeLoadBalancerSet).uniq().value();
      if (setNormalizers.length) {
        return flow(setNormalizers)(loadBalancers);
      } else {
        return loadBalancers;
      }
    }
    return {
      normalizeLoadBalancer,
      normalizeLoadBalancerSet
    };
  }
]);

class LoadBalancerReader {
  constructor($q, loadBalancerTransformer) {
    this.$q = $q;
    this.loadBalancerTransformer = loadBalancerTransformer;
  }
  loadLoadBalancers(applicationName) {
    return REST("/applications").path(applicationName, "loadBalancers").get().then((loadBalancers) => {
      loadBalancers = this.loadBalancerTransformer.normalizeLoadBalancerSet(loadBalancers);
      return this.$q.all(loadBalancers.map((lb) => this.normalizeLoadBalancer(lb)));
    });
  }
  getLoadBalancerDetails(cloudProvider, account, region, name) {
    return REST("/loadBalancers").path(account, region, name).query({ provider: cloudProvider }).get();
  }
  listLoadBalancers(cloudProvider) {
    return REST("/loadBalancers").query({ provider: cloudProvider }).get();
  }
  normalizeLoadBalancer(loadBalancer) {
    return this.loadBalancerTransformer.normalizeLoadBalancer(loadBalancer).then((lb) => {
      const nameParts = NameUtils.parseLoadBalancerName(lb.name);
      lb.stack = nameParts.stack;
      lb.detail = nameParts.freeFormDetails;
      lb.cloudProvider = lb.cloudProvider || lb.type || lb.provider;
      return lb;
    });
  }
}
LoadBalancerReader.$inject = ["$q", "loadBalancerTransformer"];
const LOAD_BALANCER_READ_SERVICE = "spinnaker.core.loadBalancer.read.service";
module(LOAD_BALANCER_READ_SERVICE, [CORE_LOADBALANCER_LOADBALANCER_TRANSFORMER]).service("loadBalancerReader", LoadBalancerReader);

class LoadBalancerWriter {
  static deleteLoadBalancer(command, application) {
    command.type = "deleteLoadBalancer";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description: `Delete load balancer: ${command.loadBalancerName}`
    });
  }
  static upsertLoadBalancer(command, application, descriptor, params = {}) {
    Object.assign(command, params);
    command.type = "upsertLoadBalancer";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description: `${descriptor} Load Balancer: ${command["name"]}`
    });
  }
}

class CreateLoadBalancerButton extends React__default.Component {
  constructor(props) {
    super(props);
    this.createLoadBalancerProviderFilterFn = (_app, _acc, provider) => {
      const lbConfig = provider.loadBalancer;
      return lbConfig && (lbConfig.CreateLoadBalancerModal || lbConfig.createLoadBalancerTemplateUrl && lbConfig.createLoadBalancerController);
    };
    this.createLoadBalancer = () => {
      const { app } = this.props;
      ProviderSelectionService.selectProvider(app, "loadBalancer", this.createLoadBalancerProviderFilterFn).then((selectedProvider) => {
        const provider = CloudProviderRegistry.getValue(selectedProvider, "loadBalancer");
        if (provider.CreateLoadBalancerModal) {
          provider.CreateLoadBalancerModal.show({
            app,
            application: app,
            forPipelineConfig: false,
            loadBalancer: null,
            isNew: true
          });
        } else {
          ModalInjector.modalService.open({
            templateUrl: provider.createLoadBalancerTemplateUrl,
            controller: `${provider.createLoadBalancerController} as ctrl`,
            size: "lg",
            windowClass: "modal-z-index",
            resolve: {
              application: () => this.props.app,
              loadBalancer: () => null,
              isNew: () => true,
              forPipelineConfig: () => false
            }
          }).result.catch(() => {
          });
        }
      });
    };
    const { app } = this.props;
    this.state = { isDisabled: true };
    ProviderSelectionService.isDisabled(app).then((val) => {
      this.setState({
        isDisabled: val
      });
    });
  }
  render() {
    if (!this.state.isDisabled) {
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-sm btn-default",
        onClick: this.createLoadBalancer
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-plus-sign visible-lg-inline"
      }), /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "Create Load Balancer"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-plus-sign visible-md-inline visible-sm-inline"
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "visible-lg-inline"
      }, " Create Load Balancer")));
    } else {
      return /* @__PURE__ */ React__default.createElement("div", null);
    }
  }
}

const Instance = React__default.memo(function Instance2(props) {
  const { instance, active, highlight, onInstanceClicked } = props;
  const { name, id, healthState } = instance;
  const [mouseOver, setMouseOver] = React__default.useState(false);
  const handleClick = (event) => {
    event.preventDefault();
    onInstanceClicked(instance);
  };
  const className = classNames({ highlighted: highlight === id, active });
  const anchor = /* @__PURE__ */ React__default.createElement("a", {
    className: `instance health-status-${healthState} ${className}`,
    title: name || id,
    onMouseOver: () => setMouseOver(true),
    onMouseOut: () => setMouseOver(false),
    onClick: handleClick
  });
  return mouseOver ? /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: name || id
  }, anchor) : anchor;
});

const Instances = (props) => {
  const router = useRouter();
  const uiview = useParentView();
  return /* @__PURE__ */ React__default.createElement(InstancesInternal, {
    ...props,
    router,
    uiview
  });
};
class InstancesInternal extends React__default.Component {
  constructor(props) {
    super(props);
    this.onStateChange = (transition) => {
      const isShowingDetails = !!/\.instanceDetails/.exec(transition.to().name);
      const detailsInstanceId = isShowingDetails ? transition.params().instanceId : null;
      this.setState({ detailsInstanceId });
    };
    this.handleInstanceClicked = (instance) => {
      const { router, uiview } = this.props;
      const params = { instanceId: instance.id, provider: instance.cloudProvider || instance.provider };
      const options = { relative: uiview.context };
      router.stateService.go(".instanceDetails", params, options);
    };
    this.state = {
      detailsInstanceId: null
    };
  }
  componentDidMount() {
    this.subscription = this.props.router.globals.success$.subscribe(this.onStateChange);
  }
  componentWillUnmount() {
    this.subscription.unsubscribe();
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propsKeys = ["instances", "highlight"];
    if (propsKeys.some((key) => this.props[key] !== nextProps[key])) {
      return true;
    }
    if (this.state.detailsInstanceId !== nextState.detailsInstanceId) {
      const ids = nextProps.instances.map((x) => x.id);
      if (ids.includes(this.state.detailsInstanceId) || ids.includes(nextState.detailsInstanceId)) {
        return true;
      }
    }
    return false;
  }
  partitionInstances() {
    const partitions = [];
    const instances = (this.props.instances || []).sort((a, b) => a.launchTime - b.launchTime || a.id.localeCompare(b.id));
    if (!instances.length) {
      return partitions;
    }
    let currentPartition = [];
    let currentState = instances[0].healthState;
    instances.forEach((i) => {
      if (i.healthState !== currentState) {
        partitions.push(currentPartition);
        currentPartition = [];
      }
      currentPartition.push(i);
      currentState = i.healthState;
    });
    partitions.push(currentPartition);
    return partitions;
  }
  render() {
    const partitions = this.partitionInstances();
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "instances"
    }, partitions.map((p, i) => /* @__PURE__ */ React__default.createElement("span", {
      key: i,
      className: `instance-group instance-group-${p[0].healthState}`
    }, p.map((instance) => /* @__PURE__ */ React__default.createElement(Instance, {
      key: instance.id,
      instance,
      active: this.state.detailsInstanceId === instance.id,
      highlight: this.props.highlight,
      onInstanceClicked: this.handleInstanceClicked
    })))));
  }
}

class LoadBalancerInstances extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = this.getState(props);
    this.clusterChangeListener = ClusterState.filterService.groupsUpdatedStream.subscribe(() => this.setState(this.getState(this.props)));
  }
  getState(props) {
    return {
      instances: props.instances.concat(flatten(map$1(props.serverGroups, "detachedInstances")))
    };
  }
  componentWillUnmount() {
    this.clusterChangeListener.unsubscribe();
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "instance-list"
    }, /* @__PURE__ */ React__default.createElement(Instances, {
      instances: this.state.instances
    }));
  }
}

class LoadBalancerServerGroup extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }
  getState(props) {
    return {
      instances: clone(props.serverGroup.instances)
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  render() {
    const { serverGroup, showInstances, account, region } = this.props;
    const className = classNames({
      clickable: true,
      "clickable-row": true,
      "no-margin-y": true,
      disabled: serverGroup.isDisabled
    });
    const params = {
      region: serverGroup.region || region,
      accountId: serverGroup.account || account,
      serverGroup: serverGroup.name,
      provider: serverGroup.cloudProvider
    };
    return /* @__PURE__ */ React__default.createElement(UISrefActive, {
      class: "active"
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: ".serverGroup",
      params
    }, /* @__PURE__ */ React__default.createElement("div", {
      className
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "server-group-title container-fluid no-padding"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(CloudProviderLogo, {
      provider: serverGroup.cloudProvider,
      height: "14px",
      width: "14px"
    }), " ", serverGroup.name), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4 text-right"
    }, /* @__PURE__ */ React__default.createElement(HealthCounts, {
      container: serverGroup.instanceCounts
    })))), showInstances && /* @__PURE__ */ React__default.createElement("div", {
      className: "instance-list"
    }, /* @__PURE__ */ React__default.createElement(Instances, {
      instances: this.state.instances
    })))));
  }
}

class LoadBalancerClusterContainer extends React__default.Component {
  shouldComponentUpdate(nextProps) {
    const serverGroupsEqual = () => isEqual((nextProps.serverGroups || []).map((g) => g.name), (this.props.serverGroups || []).map((g) => g.name));
    return nextProps.showInstances !== this.props.showInstances || nextProps.showServerGroups !== this.props.showServerGroups || nextProps.loadBalancer !== this.props.loadBalancer || !serverGroupsEqual();
  }
  render() {
    const { loadBalancer, serverGroups, showInstances, showServerGroups } = this.props;
    const ServerGroups = orderBy(serverGroups, ["isDisabled", "name"], ["asc", "desc"]).map((serverGroup) => /* @__PURE__ */ React__default.createElement(LoadBalancerServerGroup, {
      key: serverGroup.name,
      account: serverGroup.account,
      region: serverGroup.region,
      serverGroup,
      showInstances
    }));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "cluster-container"
    }, showServerGroups && ServerGroups, !showServerGroups && showInstances && /* @__PURE__ */ React__default.createElement(LoadBalancerInstances, {
      serverGroups: loadBalancer.serverGroups,
      instances: loadBalancer.instances
    }));
  }
}

class LoadBalancerListItem extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onClick = (e) => {
      this.props.onItemClick(this.props.loadBalancer);
      e.nativeEvent.preventDefault();
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.onClick
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "name"
    }, this.props.loadBalancer.name), /* @__PURE__ */ React__default.createElement(HealthCounts, {
      container: this.props.loadBalancer.instanceCounts
    }));
  }
}
class LoadBalancerButton extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onClick = (e) => {
      this.props.onItemClick(this.props.loadBalancer);
      e.nativeEvent.preventDefault();
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: `Load Balancer: ${this.props.loadBalancer.name}`
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-link no-padding",
      onClick: this.onClick
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "badge badge-counter"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "icon"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa icon-sitemap"
    })))));
  }
}
class LoadBalancersTag extends React__default.Component {
  constructor(props) {
    super(props);
    this.showLoadBalancerDetails = (loadBalancer) => {
      const { $state } = ReactInjector;
      const serverGroup = this.props.serverGroup;
      logger.log({ category: "Cluster Pod", action: `Load Load Balancer Details (multiple menu)` });
      const nextState = $state.current.name.endsWith(".clusters") ? ".loadBalancerDetails" : "^.loadBalancerDetails";
      $state.go(nextState, {
        region: serverGroup.region,
        accountId: serverGroup.account,
        name: loadBalancer.name,
        provider: serverGroup.type
      });
    };
    this.handleShowPopover = () => {
      logger.log({ category: "Cluster Pod", action: `Show Load Balancers Menu` });
    };
    this.handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    this.state = {
      loadBalancers: [],
      isLoading: true
    };
  }
  componentDidMount() {
    LoadBalancerDataUtils.populateLoadBalancers(this.props.application, this.props.serverGroup).then((loadBalancers) => this.setState({ loadBalancers, isLoading: false }));
    this.loadBalancersRefreshUnsubscribe = this.props.application.getDataSource("loadBalancers").onRefresh(null, () => {
      this.forceUpdate();
    });
  }
  componentWillUnmount() {
    this.loadBalancersRefreshUnsubscribe();
  }
  render() {
    const { loadBalancers, isLoading } = this.state;
    const totalCount = loadBalancers.length;
    if (isLoading) {
      return /* @__PURE__ */ React__default.createElement(Spinner, {
        size: "nano"
      });
    } else if (!totalCount) {
      return null;
    }
    const className = `load-balancers-tag ${totalCount > 1 ? "overflowing" : ""}`;
    const popover = /* @__PURE__ */ React__default.createElement("div", {
      className: "menu-load-balancers"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "menu-load-balancers-header"
    }, " Load Balancers "), sortBy(loadBalancers, "name").map((loadBalancer) => /* @__PURE__ */ React__default.createElement(LoadBalancerListItem, {
      key: loadBalancer.name,
      loadBalancer,
      onItemClick: this.showLoadBalancerDetails
    })));
    return /* @__PURE__ */ React__default.createElement("span", {
      className
    }, totalCount > 1 && /* @__PURE__ */ React__default.createElement(HoverablePopover, {
      delayShow: 100,
      delayHide: 150,
      onShow: this.handleShowPopover,
      placement: "bottom",
      template: popover,
      hOffsetPercent: "80%",
      container: this.props.container,
      className: "no-padding menu-load-balancers"
    }, /* @__PURE__ */ React__default.createElement("button", {
      onClick: this.handleClick,
      className: "btn btn-link btn-multiple-load-balancers clearfix no-padding"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "badge badge-counter"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "icon"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa icon-sitemap"
    })), " ", totalCount))), totalCount === 1 && /* @__PURE__ */ React__default.createElement("span", {
      className: "btn-load-balancer"
    }, sortBy(loadBalancers, "name").map((loadBalancer) => /* @__PURE__ */ React__default.createElement(LoadBalancerButton, {
      key: loadBalancer.name,
      loadBalancer,
      onItemClick: this.showLoadBalancerDetails
    }))));
  }
}

class LoadBalancersTagWrapper extends React__default.Component {
  render() {
    const { serverGroup } = this.props;
    const config = CloudProviderRegistry.getValue(serverGroup.provider || serverGroup.cloudProvider, "loadBalancer");
    const Tags = config && config.LoadBalancersTag || LoadBalancersTag;
    return /* @__PURE__ */ React__default.createElement(Tags, {
      ...this.props
    });
  }
}

var __defProp$m = Object.defineProperty;
var __getOwnPropDesc$m = Object.getOwnPropertyDescriptor;
var __decorateClass$m = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$m(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$m(target, key, result);
  return result;
};
let FunctionDetails = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("h3", null, "Function Details");
  }
};
FunctionDetails = __decorateClass$m([
  Overridable("function.details")
], FunctionDetails);

const CORE_FUNCTION_FUNCTION_TRANSFORMER = "spinnaker.core.function.transformer";
module(CORE_FUNCTION_FUNCTION_TRANSFORMER, [PROVIDER_SERVICE_DELEGATE]).factory("functionTransformer", [
  "providerServiceDelegate",
  function(providerServiceDelegate) {
    function normalizeFunction(functionDef) {
      return providerServiceDelegate.getDelegate(functionDef.provider ? functionDef.provider : "aws", "function.transformer").normalizeFunction(functionDef);
    }
    function normalizeFunctionSet(functions) {
      const setNormalizers = chain(functions).filter((fn) => providerServiceDelegate.hasDelegate(fn.provider ? fn.provider : "aws", "function.setTransformer")).compact().map((fn) => providerServiceDelegate.getDelegate(fn.provider, "function.setTransformer").normalizeFunctionSet).uniq().value();
      if (setNormalizers.length) {
        return flow(setNormalizers)(functions);
      } else {
        return functions;
      }
    }
    return {
      normalizeFunction,
      normalizeFunctionSet
    };
  }
]);

class FunctionReader {
  constructor(functionTransformer) {
    this.functionTransformer = functionTransformer;
  }
  loadFunctions(applicationName) {
    return REST("/applications").path(applicationName, "functions").get().then((functions) => {
      functions = this.functionTransformer.normalizeFunctionSet(functions);
      return functions.map((fn) => this.normalizeFunction(fn));
    });
  }
  getFunctionDetails(cloudProvider, account, region, name) {
    return REST("/functions").query({ provider: cloudProvider, functionName: name, region, account }).get().then((functions) => {
      functions = this.functionTransformer.normalizeFunctionSet(functions);
      return functions.map((fn) => this.normalizeFunction(fn));
    });
  }
  listFunctions(cloudProvider) {
    return REST("/functions").query({ provider: cloudProvider }).get();
  }
  normalizeFunction(functionDef) {
    const fn = this.functionTransformer.normalizeFunction(functionDef);
    fn.cloudProvider = fn.cloudProvider || "aws";
    return fn;
  }
}
FunctionReader.$inject = ["functionTransformer"];
const FUNCTION_READ_SERVICE = "spinnaker.core.function.read.service";
module(FUNCTION_READ_SERVICE, [CORE_FUNCTION_FUNCTION_TRANSFORMER]).service("functionReader", FunctionReader);

class FunctionWriter {
  static deleteFunction(command, application) {
    command.type = "lambdaFunction";
    command.operation = "deleteLambdaFunction";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description: `Delete Function: ${command.functionName}`
    });
  }
  static upsertFunction(command, application, descriptor, params = {}) {
    Object.assign(command, params);
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description: `${descriptor} Function: ${command.functionName || ""}`
    });
  }
}

class CreateFunctionButton extends React__default.Component {
  constructor(props) {
    super(props);
    this.createFunction = () => {
      const { app } = this.props;
      ProviderSelectionService.selectProvider(app, "function").then((selectedProvider) => {
        const provider = CloudProviderRegistry.getValue(selectedProvider, "function");
        provider.CreateFunctionModal.show({
          app,
          application: app,
          forPipelineConfig: false,
          function: null,
          isNew: true
        });
      });
    };
    const { app } = this.props;
    this.state = { isDisabled: true };
    ProviderSelectionService.isDisabled(app).then((val) => {
      this.setState({
        isDisabled: val
      });
    });
  }
  render() {
    const { isDisabled } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, !isDisabled && /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-sm btn-default",
      onClick: this.createFunction
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign visible-lg-inline"
    }), /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Create Function"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign visible-md-inline visible-sm-inline"
    })), /* @__PURE__ */ React__default.createElement("span", {
      className: "visible-lg-inline"
    }, " Create Function ")));
  }
}

class ManifestWriter {
  static deployManifest(command, application) {
    const description = "Deploy manifest";
    command.type = "deployManifest";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description
    });
  }
  static deleteManifest(command, application) {
    const description = "Delete manifest";
    command.type = "deleteManifest";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description
    });
  }
  static scaleManifest(command, application) {
    const description = "Scale manifest";
    command.type = "scaleManifest";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description
    });
  }
  static undoRolloutManifest(command, application) {
    const description = "Undo rollout of manifest";
    command.type = "undoRolloutManifest";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description
    });
  }
  static resumeRolloutManifest(command, application) {
    const description = "Resume rollout of manifest";
    command.type = "resumeRolloutManifest";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description
    });
  }
  static pauseRolloutManifest(command, application) {
    const description = "Pause rollout of manifest";
    command.type = "pauseRolloutManifest";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description
    });
  }
  static rollingRestartManifest(command, application) {
    const description = "Rolling restart of manifest";
    command.type = "rollingRestartManifest";
    return TaskExecutor.executeTask({
      job: [command],
      application,
      description
    });
  }
}

class ManifestReader {
  static getManifest(account, location, name) {
    return REST("/manifests").path(account, location, name).get();
  }
}

class JobManifestPodLogs extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      containerLogs: [],
      selectedContainerLog: null,
      showModal: false,
      errorMessage: null,
      loadingLogs: false
    };
    bindAll(this, ["open", "close", "onClick"]);
    this.ansiUp = new AnsiUp();
  }
  canShow() {
    const { podNamesProviders } = this.props;
    return podNamesProviders.every((pod) => pod.getPodName() !== "") && !this.state.loadingLogs;
  }
  resourceRegion() {
    return this.props.location;
  }
  podName(pod) {
    return `pod ${pod.getPodName()}`;
  }
  close() {
    this.setState({ showModal: false });
  }
  open() {
    this.setState({ showModal: true });
  }
  onClick() {
    const { account, podNamesProviders } = this.props;
    const region = this.resourceRegion();
    this.setState({ loadingLogs: true });
    const promises = podNamesProviders.map((p) => {
      const podName = this.podName(p);
      return InstanceReader.getConsoleOutput(account, region, podName, "kubernetes");
    });
    Promise.all(promises).then((response) => {
      const tempLogs = [];
      response.forEach((r) => {
        const containerLogs = r.output;
        containerLogs.forEach((log) => {
          log.formattedOutput = DOMPurify.sanitize(this.ansiUp.ansi_to_html(log.output));
        });
        tempLogs.push(...containerLogs);
      });
      this.setState({
        containerLogs: tempLogs,
        selectedContainerLog: tempLogs[0],
        loadingLogs: false
      });
      this.open();
    }).catch((exception) => {
      this.setState({ errorMessage: exception.data.message });
      this.open();
    });
  }
  selectLog(log) {
    this.setState({ selectedContainerLog: log });
  }
  render() {
    const { showModal, containerLogs, errorMessage, selectedContainerLog } = this.state;
    if (this.canShow()) {
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("a", {
        onClick: this.onClick,
        className: "clickable"
      }, this.props.linkName), /* @__PURE__ */ React__default.createElement(Modal$1, {
        show: showModal,
        onHide: this.close,
        dialogClassName: "modal-lg modal-fullscreen flex-fill"
      }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, {
        closeButton: true
      }, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Console Output")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
        className: "flex-fill"
      }, containerLogs.length && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("ul", {
        className: "tabs-basic console-output-tabs"
      }, containerLogs.map((log, i) => /* @__PURE__ */ React__default.createElement("li", {
        key: `${log.name}-${i + 1}}`,
        className: classNames("console-output-tab", {
          selected: log.name === selectedContainerLog.name
        }),
        onClick: () => this.selectLog(log)
      }, `${log.name}-${i + 1}`))), /* @__PURE__ */ React__default.createElement("pre", {
        className: "body-small fill-no-flex",
        dangerouslySetInnerHTML: { __html: selectedContainerLog.formattedOutput }
      })), errorMessage && /* @__PURE__ */ React__default.createElement("pre", {
        className: "body-small"
      }, errorMessage)), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement(Button$1, {
        onClick: this.close
      }, "Close"))));
    } else {
      return null;
    }
  }
}

class JobStageExecutionLogs extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      manifest: {}
    };
    this.destroy$ = new Subject();
  }
  componentDidMount() {
    const { account, location, deployedName } = this.props;
    from(ManifestReader.getManifest(account, location, deployedName)).pipe(takeUntil(this.destroy$)).subscribe((manifest) => this.setState({ manifest }), () => {
    });
  }
  renderExternalLink(link, manifest) {
    if (!link.includes("{{")) {
      return link;
    }
    return template$2(link, { interpolate: /{{([\s\S]+?)}}/g })({ ...manifest });
  }
  render() {
    const { manifest } = this.state;
    const { externalLink, podNamesProviders, location, account } = this.props;
    if (externalLink) {
      return /* @__PURE__ */ React__default.createElement("a", {
        target: "_blank",
        href: this.renderExternalLink(externalLink, manifest)
      }, "Console Output (External)");
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, location && /* @__PURE__ */ React__default.createElement(JobManifestPodLogs, {
      account,
      location,
      podNamesProviders,
      linkName: "Console Output"
    }));
  }
}

function ManifestYaml({ linkName, modalTitle, manifestText, manifestUri }) {
  const [modalVisible, setModalVisible] = React__default.useState(false);
  const toggle = () => setModalVisible(!modalVisible);
  const [fetchedManifestText, setFetchedManifestText] = React__default.useState("Loading...");
  const [error, setError] = React__default.useState(null);
  React__default.useEffect(() => {
    if (manifestUri) {
      ArtifactService.getArtifactByContentReference(manifestUri).then((manifest) => setFetchedManifestText(decodeUnicodeBase64(manifest.reference))).catch((e) => {
        var _a, _b;
        return setError(`Error: ${typeof e !== "string" ? (_b = (_a = e.data) == null ? void 0 : _a.message) != null ? _b : JSON.stringify(e) : e}`);
      });
    }
  }, []);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("a", {
    key: "modal-link",
    onClick: toggle,
    className: "clickable"
  }, linkName), /* @__PURE__ */ React__default.createElement(Modal$1, {
    key: "modal",
    show: modalVisible,
    onHide: toggle
  }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, {
    closeButton: true
  }, /* @__PURE__ */ React__default.createElement("h3", null, modalTitle)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, error ? /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-warning"
  }, /* @__PURE__ */ React__default.createElement("p", null, error)) : null, /* @__PURE__ */ React__default.createElement("textarea", {
    readOnly: true,
    rows: 15,
    className: "code",
    value: manifestUri ? fetchedManifestText : manifestText
  })), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: toggle
  }, "Close"))));
}

class DefaultPodNameProvider {
  constructor(podName) {
    this.podName = podName;
  }
  getPodName() {
    return this.podName;
  }
}
class JobEventBasedPodNameProvider {
  constructor(manifest, manifestEvent) {
    this.manifest = manifest;
    this.manifestEvent = manifestEvent;
  }
  getPodName() {
    var _a;
    const { manifestEvent } = this;
    return this.canParsePodName() ? trim((_a = manifestEvent.message) == null ? void 0 : _a.split(":")[1]) : "";
  }
  canParsePodName() {
    var _a;
    const { manifest, manifestEvent } = this;
    return !!manifest.manifest && !!manifest.manifest.status && !!manifestEvent && !!((_a = manifestEvent.message) == null ? void 0 : _a.startsWith("Created pod")) && manifest.manifest.kind.toLowerCase() === "job";
  }
}

class NetworkReader {
  static listNetworks() {
    return REST("/networks").get();
  }
  static listNetworksByProvider(cloudProvider) {
    return REST("/networks").path(cloudProvider).get();
  }
}

const { useEffect: useEffect$3 } = React__default;
function CheckBox({ option, selected, onChange, inputClassName, inputProps }) {
  function handleChange({ target }) {
    const newValue = !selected.includes(target.value) ? selected.concat(target.value) : selected.filter((v) => v !== target.value);
    onChange(createFakeReactSyntheticEvent({ value: newValue, name: target.name }));
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("label", {
    className: "clickable",
    key: option.value
  }, /* @__PURE__ */ React__default.createElement("input", {
    className: inputClassName,
    type: "checkbox",
    value: option.value,
    onChange: handleChange,
    checked: selected.includes(option.value),
    ...inputProps
  }), option.label), selected.includes(option.value) && option.additionalFields);
}
function WhenChecklistInput(props) {
  const { value, validation, inputClassName, options, onChange, ...inputProps } = props;
  function touchField() {
    props.onBlur && props.onBlur(createFakeReactSyntheticEvent({ name: props.name, value }));
  }
  useEffect$3(touchField, []);
  const selectedValues = value || [];
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React__default.createElement("ul", {
    className: "checklist"
  }, options.map((option) => /* @__PURE__ */ React__default.createElement("li", {
    key: option.label
  }, /* @__PURE__ */ React__default.createElement(CheckBox, {
    option,
    selected: selectedValues,
    inputClassName: `${orEmptyString(inputClassName)} ${validationClassName(validation)}`,
    inputProps,
    onChange
  })))));
}

class NotificationTransformer {
}
NotificationTransformer.getNotificationWhenDisplayName = (whenOption, level, stageType) => {
  if (stageType === "manualJudgment") {
    let filteredInput = "This stage ";
    if (whenOption === "manualJudgment") {
      filteredInput += "is awaiting judgment";
    } else {
      filteredInput += "was judged to " + whenOption.slice(14).toLowerCase();
    }
    return filteredInput;
  } else {
    whenOption = whenOption.replace(".", " ").replace("pipeline", (level === "application" ? "Any " : "This ") + "pipeline is");
    whenOption = whenOption.replace(".", " ").replace("stage", "This stage is ");
    if (whenOption.includes("failed")) {
      whenOption = whenOption.replace("pipeline is", "pipeline has");
      whenOption = whenOption.replace("stage is", "stage has");
    }
    return whenOption;
  }
};
NotificationTransformer.getNotificationDetails = (notification) => {
  if (notification.type === "pubsub") {
    return "Publisher Name: " + notification.publisherName;
  } else if (notification.type !== "email") {
    return notification.address;
  } else {
    const addresses = [];
    if (notification.address) {
      addresses.push(notification.address);
    }
    if (notification.cc) {
      addresses.push("cc:" + notification.cc);
    }
    return join(addresses, ", ");
  }
};

var css_248z$1o = ".notification-type-select {\n  width: 100%;\n}\n";
styleInject(css_248z$1o);

class NotificationSelector extends React__default.Component {
  constructor(props) {
    super(props);
    this.NotificationDetailFields = (props) => {
      const notificationConfig = Registry.pipeline.getNotificationConfig(props.type);
      if (notificationConfig && notificationConfig.component) {
        const notificationProps = {
          botName: notificationConfig.config.botName,
          fieldName: props.fieldName
        };
        return React__default.createElement(notificationConfig.component, notificationProps);
      }
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
    };
    this.state = {
      notificationTypes: Registry.pipeline.getNotificationTypes().map((type) => ({
        label: type.label,
        value: type.key
      }))
    };
  }
  render() {
    const { NotificationDetailFields } = this;
    const { fieldName, onNotificationTypeChange, type } = this.props;
    const { notificationTypes } = this.state;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Notify via",
      name: fieldName ? `${fieldName}.type` : "type",
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        clearable: false,
        ...props,
        inputClassName: "notification-type-select",
        options: notificationTypes
      }),
      onChange: onNotificationTypeChange,
      required: true
    }), /* @__PURE__ */ React__default.createElement(NotificationDetailFields, {
      type,
      fieldName
    }));
  }
}

const MANUAL_JUDGEMENT_WHEN_OPTIONS = ["manualJudgment", "manualJudgmentContinue", "manualJudgmentStop"];
const PIPELINE_WHEN_OPTIONS = ["pipeline.starting", "pipeline.complete", "pipeline.failed"];
const STAGE_WHEN_OPTIONS = ["stage.starting", "stage.complete", "stage.failed"];

var css_248z$1n = ".notification-details .checkbox {\n  width: 100%;\n}\n.notification-details .checklist {\n  -webkit-padding-start: 0px;\n          padding-inline-start: 0px;\n}\n";
styleInject(css_248z$1n);

class NotificationDetails$1 extends React__default.Component {
  constructor(props) {
    super(props);
    this.renderCustomMessage = (type, whenOption) => {
      if (whenOption !== "manualJudgment" && ["email", "slack", "googlechat", "microsoftteams"].includes(type)) {
        return /* @__PURE__ */ React__default.createElement(FormikFormField, {
          name: `message["${whenOption}"].text`,
          input: (props) => /* @__PURE__ */ React__default.createElement(TextAreaInput, {
            ...props,
            placeholder: "enter a custom notification message (optional)"
          })
        });
      } else {
        return null;
      }
    };
    this.onNotificationTypeChange = (type) => {
      const notificationTypeUpdate = Registry.pipeline.getNotificationConfig(type);
      if (!!notificationTypeUpdate) {
        this.props.formik.setFieldValue("address", "");
      }
      this.props.formik.setFieldValue("when", [...this.props.formik.values.when]);
    };
    let whenOptions = [];
    if (props.level === "application" || props.level === "pipeline") {
      whenOptions = PIPELINE_WHEN_OPTIONS;
    } else if (props.stageType === "manualJudgment") {
      whenOptions = MANUAL_JUDGEMENT_WHEN_OPTIONS;
    } else {
      whenOptions = STAGE_WHEN_OPTIONS;
    }
    this.state = {
      notificationTypes: Registry.pipeline.getNotificationTypes().map((type) => ({
        label: type.label,
        value: type.key
      })),
      whenOptions
    };
  }
  componentDidMount() {
    const { formik } = this.props;
    if (!formik.values.type) {
      const { notificationTypes } = this.state;
      formik.setFieldValue("type", notificationTypes && notificationTypes[0] ? notificationTypes[0].value : "");
    }
  }
  render() {
    const { onNotificationTypeChange, renderCustomMessage } = this;
    const { formik, level, stageType } = this.props;
    const { values } = formik;
    const { whenOptions } = this.state;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "notification-details"
    }, /* @__PURE__ */ React__default.createElement(NotificationSelector, {
      onNotificationTypeChange,
      type: values.type
    }), (stageType || level) && /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-m-bottom"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-4 sm-label-right"
    }, "Notify when"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "when",
      input: (props) => /* @__PURE__ */ React__default.createElement(WhenChecklistInput, {
        ...props,
        options: whenOptions.map((o) => ({
          value: o,
          label: NotificationTransformer.getNotificationWhenDisplayName(o, level, stageType),
          additionalFields: renderCustomMessage(values.type, o)
        }))
      }),
      required: true
    }))))));
  }
}

class EditNotificationModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.formikRef = React__default.createRef();
    this.submit = (values) => {
      if (this.props.editNotification) {
        this.setState({ isSubmitting: true });
        this.props.editNotification(values).then(() => {
          this.setState({ isSubmitting: false });
          this.props.closeModal();
        });
      } else {
        this.props.closeModal(values);
      }
    };
    this.validate = (values) => {
      const formValidator = new FormValidator(values);
      formValidator.field("when", "Notify when").required().withValidators((value) => !value.length && "Please select when the notification should execute");
      return formValidator.validateForm();
    };
    this.state = {
      isSubmitting: false
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "modal-md" };
    return ReactModal.show(EditNotificationModal, props, modalProps);
  }
  render() {
    const { dismissModal, level, notification, stageType } = this.props;
    return /* @__PURE__ */ React__default.createElement(SpinFormik, {
      ref: this.formikRef,
      initialValues: notification,
      onSubmit: this.submit,
      validate: this.validate,
      render: (formik) => /* @__PURE__ */ React__default.createElement(Form, {
        className: `form-horizontal`
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: dismissModal
      }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Edit Notification")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("div", {
        className: "row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "container-fluid modal-body-content"
      }, /* @__PURE__ */ React__default.createElement(NotificationDetails$1, {
        formik,
        level,
        stageType
      })))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        onClick: dismissModal,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !formik.isValid,
        isFormSubmit: true,
        submitting: this.state.isSubmitting,
        label: "Update"
      })))
    });
  }
}

class AppNotificationsService {
  static getNotificationsForApplication(applicationName) {
    return REST("/notifications/application").path(applicationName).get();
  }
  static saveNotificationsForApplication(applicationName, notifications) {
    return REST("/notifications/application").path(applicationName).post(notifications);
  }
}

class NotificationsList extends React__default.Component {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.getEditFunctionality = (notification, index) => {
      if (this.props.level === "application") {
        this.showEditModal(notification, index);
      } else {
        this.editNotification(notification, index);
      }
    };
    this.addNotification = () => {
      this.getEditFunctionality();
    };
    this.editNotification = (notification, index) => {
      const { level, notifications, stageType, updateNotifications } = this.props;
      EditNotificationModal.show({
        notification: notification || { level, when: [] },
        level,
        stageType
      }).then((newNotification) => {
        const notificationsCopy = notifications || [];
        if (!notification) {
          updateNotifications(notificationsCopy.concat(newNotification));
        } else {
          const update = [...notificationsCopy];
          update[index] = newNotification;
          updateNotifications(update);
        }
        this.setState({ isNotificationsDirty: true });
      }).catch(() => {
      });
    };
    this.saveAppNotifications = (newNotifications) => {
      const { application } = this.props;
      const toSaveNotifications = {
        application: application.name
      };
      newNotifications.forEach((n) => {
        if (isEmpty(get(toSaveNotifications, n.type))) {
          toSaveNotifications[n.type] = [];
        }
        toSaveNotifications[n.type].push(n);
      });
      return AppNotificationsService.saveNotificationsForApplication(application.name, toSaveNotifications).then(() => this.revertNotificationChanges());
    };
    this.editAppNotification = (newNotification) => {
      const { notifications } = this.props;
      const { indexEdited } = this.state;
      let notificationsToSave = notifications || [];
      if (indexEdited || indexEdited === 0) {
        notificationsToSave[indexEdited] = newNotification;
      } else {
        notificationsToSave = notificationsToSave.concat(newNotification);
      }
      return this.saveAppNotifications(notificationsToSave);
    };
    this.showEditModal = (notification, index) => {
      const { level, stageType } = this.props;
      this.setState({ indexEdited: index });
      EditNotificationModal.show({
        notification: notification || { level, when: [] },
        level,
        stageType,
        editNotification: this.editAppNotification
      });
    };
    this.removeNotification = (index) => {
      const notifications = [...this.props.notifications];
      notifications.splice(index, 1);
      this.props.updateNotifications(notifications);
      this.setState({
        isNotificationsDirty: true
      });
    };
    this.revertNotificationChanges = () => {
      const { application, updateNotifications } = this.props;
      const { supportedNotificationTypes } = this.state;
      from(AppNotificationsService.getNotificationsForApplication(application.name)).pipe(takeUntil(this.destroy$)).subscribe((notifications) => {
        const results = filter$1(flatten(supportedNotificationTypes.map((type) => {
          return get(notifications, type) || [];
        })), (allow) => allow !== void 0 && allow.level === "application");
        updateNotifications(results);
      });
      this.setState({ isNotificationsDirty: false });
    };
    this.state = {
      indexEdited: null,
      isNotificationsDirty: false,
      supportedNotificationTypes: Registry.pipeline.getNotificationTypes().map((type) => type.key)
    };
  }
  componentDidMount() {
    if (this.props.level === "application") {
      this.revertNotificationChanges();
    }
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { level, handleSendNotificationsChanged, notifications, sendNotifications, stageType } = this.props;
    const { isNotificationsDirty } = this.state;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, level === "stage" && stageType !== "manualJudgment" && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      onChange: handleSendNotificationsChanged,
      checked: sendNotifications
    }), /* @__PURE__ */ React__default.createElement("strong", null, "Send notifications for this stage"))))), (level !== "stage" || sendNotifications) && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed"
    }, notifications && notifications.length > 0 && /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, "Type"), /* @__PURE__ */ React__default.createElement("th", null, "Details"), /* @__PURE__ */ React__default.createElement("th", null, "Notify When"), /* @__PURE__ */ React__default.createElement("th", null, "Actions"))), /* @__PURE__ */ React__default.createElement("tbody", null, notifications && notifications.map((n, i) => {
      return /* @__PURE__ */ React__default.createElement("tr", {
        key: i,
        className: classNames({ "templated-pipeline-item": n.inherited })
      }, /* @__PURE__ */ React__default.createElement("td", null, capitalize(n.type)), /* @__PURE__ */ React__default.createElement("td", null, NotificationTransformer.getNotificationDetails(n)), /* @__PURE__ */ React__default.createElement("td", null, n.when && n.when.map((w, k) => /* @__PURE__ */ React__default.createElement("div", {
        key: k
      }, NotificationTransformer.getNotificationWhenDisplayName(w, level, stageType)))), /* @__PURE__ */ React__default.createElement("td", null, !n.inherited && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-xs btn-link",
        onClick: () => this.getEditFunctionality(n, i)
      }, "Edit"), /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-xs btn-link pad-left",
        onClick: () => this.removeNotification(i)
      }, "Remove")), n.inherited && /* @__PURE__ */ React__default.createElement("span", {
        className: "btn btn-xs pad-left"
      }, "Inherited from template")));
    })), /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
      colSpan: 7
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-block add-new",
      onClick: () => this.addNotification()
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add Notification Preference"))))))), level === "application" && /* @__PURE__ */ React__default.createElement("div", {
      className: "row main-footer"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3"
    }, isNotificationsDirty && /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: () => this.revertNotificationChanges(),
      style: { visibility: "visible" }
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-flash"
    }), " Revert")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9 text-right"
    }, isNotificationsDirty && /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      onClick: () => this.saveAppNotifications(this.props.notifications)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "far fa-check-circle"
    }), " Save Changes"), isNotificationsDirty === false && /* @__PURE__ */ React__default.createElement("span", {
      className: "btn btn-link disabled"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "far fa-check-circle"
    }), " In sync with server"))));
  }
}

const NOTIFICATION_LIST = "spinnaker.core.notifications.notificationList";
module(NOTIFICATION_LIST, []).component("notificationList", react2angular(withErrorBoundary(NotificationsList, "notificationList"), [
  "application",
  "level",
  "stageType",
  "sendNotifications",
  "handleSendNotificationsChanged",
  "notifications",
  "updateNotifications"
]));

class PageTitleService {
  constructor($rootScope, $stateParams, $transitions) {
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;
    this.previousPageTitle = "Spinnaker";
    this.routeCount = 0;
    document.title = "Spinnaker: Loading...";
    $transitions.onStart({}, (transition) => {
      this.handleRoutingStart();
      const onSuccess = () => this.handleRoutingSuccess(transition.to().data);
      const onReject = (err) => this.handleRoutingError(err);
      transition.promise.then(onSuccess, onReject);
    });
  }
  handleRoutingStart() {
    this.routeCount++;
    this.previousPageTitle = document.title;
    this.setRoutingFlag();
    document.title = "Spinnaker: Loading...";
  }
  handleRoutingError(rejection) {
    this.routeCount--;
    this.setRoutingFlag();
    const cancelled = rejection.type === RejectType.ABORTED;
    document.title = cancelled ? this.previousPageTitle : "Spinnaker: Error";
  }
  handleRoutingSuccess(config) {
    const parts = this.configurePageTitle(config);
    let title = parts.main || "Spinnaker";
    if (parts.section) {
      title += " \xB7 " + parts.section;
    }
    if (parts.details) {
      title += " \xB7 " + parts.details;
    }
    this.$rootScope.routing = false;
    document.title = title;
  }
  resolveStateParams(config) {
    if (!config) {
      return null;
    }
    const { $stateParams } = this;
    const { title, nameParam, accountParam, regionParam } = config;
    let result = title;
    if (nameParam) {
      result += ": " + $stateParams[nameParam];
    }
    if (accountParam || regionParam) {
      result += " (";
      if (accountParam && regionParam) {
        result += $stateParams[accountParam] + ":" + $stateParams[regionParam];
      } else {
        result += $stateParams[accountParam] || $stateParams[regionParam];
      }
      result += ")";
    }
    return result;
  }
  configureSection(sectionConfig) {
    return this.resolveStateParams(sectionConfig);
  }
  configureDetails(detailsConfig) {
    return this.resolveStateParams(detailsConfig);
  }
  configureMain(mainConfig) {
    const { $stateParams } = this;
    let main = null;
    if (!mainConfig) {
      return main;
    }
    if (mainConfig.field) {
      main = $stateParams[mainConfig.field];
    }
    if (mainConfig.label) {
      main = mainConfig.label;
    }
    return main;
  }
  configurePageTitle(data = {}) {
    return {
      main: this.configureMain(data.pageTitleMain),
      section: this.configureSection(data.pageTitleSection),
      details: this.configureDetails(data.pageTitleDetails)
    };
  }
  setRoutingFlag() {
    this.$rootScope.routing = this.routeCount > 0;
  }
}
PageTitleService.$inject = ["$rootScope", "$stateParams", "$transitions"];
const PAGE_TITLE_SERVICE = "spinnaker.core.pageTitle.service";
module(PAGE_TITLE_SERVICE, [UIROUTER_ANGULARJS]).service("pageTitleService", PageTitleService).run(["pageTitleService", (pageTitleService) => pageTitleService]);

const decorate = (validate, props) => {
  const { application, pipeline } = props;
  return (values) => validate(values, { application, pipeline });
};
class FormikStageConfig extends React__default.Component {
  render() {
    const { render, onChange, stage, validate, application, pipeline } = this.props;
    return /* @__PURE__ */ React__default.createElement(SpinFormik, {
      validate: validate && decorate(validate, this.props),
      initialValues: stage,
      onSubmit: () => {
      },
      render: (formik) => /* @__PURE__ */ React__default.createElement(LayoutProvider, {
        value: ResponsiveFieldLayout
      }, /* @__PURE__ */ React__default.createElement(WatchValue, {
        onChange,
        value: formik.values
      }), render({ application, pipeline, formik }))
    });
  }
}

class BakeExecutionLabel extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "stage-label"
    }, this.props.stage.name, this.props.stage.masterStage.context.allPreviouslyBaked && /* @__PURE__ */ React__default.createElement("span", {
      className: "small"
    }, /* @__PURE__ */ React__default.createElement("br", null), "(previously baked)"), this.props.stage.masterStage.context.somePreviouslyBaked && /* @__PURE__ */ React__default.createElement("span", {
      className: "small"
    }, /* @__PURE__ */ React__default.createElement("br", null), "(some previously baked)"));
  }
}

class BakeryReader {
  static getRegions(provider) {
    if (has(SETTINGS, `providers.${provider}.bakeryRegions`)) {
      return $q.when(get(SETTINGS, `providers.${provider}.bakeryRegions`));
    }
    return AccountService.getUniqueAttributeForAllAccounts(provider, "regions").then((regions) => regions.sort());
  }
  static getBaseOsOptions(provider) {
    return this.getAllBaseOsOptions().then((options) => {
      return options.find((o) => o.cloudProvider === provider);
    });
  }
  static getAllBaseOsOptions() {
    return REST("/bakery/options").useCache().get();
  }
  static getBaseLabelOptions() {
    return $q.when(["release", "candidate", "previous", "unstable"]);
  }
}

class ExecutionDetailsSectionService {
  constructor($stateParams, $state, $timeout) {
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$timeout = $timeout;
  }
  sectionIsValid(availableSections) {
    return availableSections.includes(this.$stateParams.details);
  }
  synchronizeSection(availableSections, onComplete) {
    this.$timeout.cancel(this.pendingOnComplete);
    if (!this.$state.includes("**.execution")) {
      return;
    }
    let details = this.$stateParams.details || availableSections[0];
    if (!availableSections.includes(details)) {
      details = availableSections[0];
    }
    if (!this.sectionIsValid(availableSections)) {
      this.$timeout(() => {
        this.$state.go(".", { details }, { location: "replace" });
      });
    }
    if (onComplete) {
      this.pendingOnComplete = this.$timeout(onComplete);
    }
  }
}
ExecutionDetailsSectionService.$inject = ["$stateParams", "$state", "$timeout"];
const EXECUTION_DETAILS_SECTION_SERVICE = "spinnaker.executionDetails.section.service";
module(EXECUTION_DETAILS_SECTION_SERVICE, [UIROUTER_ANGULARJS]).service("executionDetailsSectionService", ExecutionDetailsSectionService);

class ExecutionDetailsSectionNav extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }
  componentDidMount() {
    this.stateChangeSuccessSubscription = ReactInjector.stateEvents.stateChangeSuccess.subscribe(() => this.setState(this.getState(this.props)));
  }
  getState(props) {
    const { $stateParams } = ReactInjector;
    const activeSection = $stateParams.details || props.sections[0];
    return { activeSection };
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  componentWillUnmount() {
    this.stateChangeSuccessSubscription.unsubscribe();
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("ul", {
      className: "nav nav-pills"
    }, this.props.sections.map((section) => /* @__PURE__ */ React__default.createElement(Section, {
      key: section,
      section,
      active: this.state.activeSection === section
    })));
  }
}
const Section = (props) => {
  const clicked = () => {
    logger.log({ category: "Pipeline", action: "Execution details section selected", data: { label: props.section } });
    ReactInjector.$state.go(".", { details: props.section });
  };
  return /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("a", {
    className: `clickable ${props.active ? "active" : ""}`,
    onClick: clicked
  }, robotToHuman(props.section)));
};

function StageSummary(props) {
  var _a;
  const { application, execution, stage, stageSummary, config } = props;
  const sourceUrl = (_a = config == null ? void 0 : config.executionSummaryUrl) != null ? _a : "core/src/pipeline/config/stages/common/executionSummary.html";
  const SummaryComponent = config == null ? void 0 : config.executionSummaryComponent;
  if (SummaryComponent) {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "stage-summary"
    }, /* @__PURE__ */ React__default.createElement(SummaryComponent, {
      ...props
    }));
  }
  const { StageSummaryWrapper } = NgReact;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "stage-summary"
  }, /* @__PURE__ */ React__default.createElement(StageSummaryWrapper, {
    application,
    execution,
    sourceUrl,
    stage,
    stageSummary
  }));
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/common/executionSummary.html", `<div class="execution-details-summary">
  <h5 class="execution-details-title">
    Stage details: {{stageSummary.name || stageSummary.type }}

    <div ng-if="$ctrl.isRestartable(stage) || $ctrl.canManuallySkip()" uib-dropdown class="btn-group pull-right">
      <button
        type="button"
        class="btn btn-default btn-sm dropdown-toggle"
        analytics-on="click"
        analytics-category="Pipeline"
        analytics-event="Execution actions menu toggled"
        aria-expanded="false"
        uib-dropdown-toggle
      >
        Actions
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu" uib-dropdown-menu uib-dropdown-append-to-body="true" role="menu">
        <li ng-if="$ctrl.isRestartable(stage)">
          <a
            href
            ng-controller="RestartStageCtrl as restartCtrl"
            analytics-on="click"
            analytics-category="Pipeline"
            analytics-event="Execution restart clicked"
            ng-click="restartCtrl.restart()"
            >Restart {{ stageSummary.name }}</a
          >
        </li>
        <li ng-if="$ctrl.canManuallySkip()">
          <a
            href
            analytics-on="click"
            analytics-category="Pipeline"
            analytics-event="Stage skip clicked"
            ng-click="$ctrl.openManualSkipStageModal()"
            >Skip {{ $ctrl.getTopLevelStage().name }}</a
          >
        </li>
      </ul>
    </div>
  </h5>
  <h6 class="duration">Duration: {{stageSummary.runningTimeInMs | duration}}</h6>
  <h6 ng-if="stage.context.restartDetails">
    Restarted by {{stage.context.restartDetails.restartedBy}} &mdash; {{stage.context.restartDetails.restartTime |
    timestamp}}
  </h6>
  <h6 ng-if="$ctrl.getTopLevelStage().context.manualSkip" uib-tooltip="{{$ctrl.getTopLevelStage().context.reason}}">
    Manually skipped by {{$ctrl.getTopLevelStage().lastModified.user}} &mdash;
    {{$ctrl.getTopLevelStage().lastModified.lastModifiedTime | timestamp}}
  </h6>

  <table class="table">
    <thead>
      <tr>
        <th width="30%">Step</th>
        <th>Started</th>
        <th>Completed</th>
        <th>Duration</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr
        class="clickable"
        analytics-on="click"
        analytics-category="Pipeline"
        analytics-event="Execution step selected"
        analytics-label="{{$ctrl.getStepLabel(step)}}"
        ng-repeat="step in stageSummary.stages"
        ng-class="{ info: $ctrl.isStepCurrent($index) }"
        ng-click="$ctrl.toggleDetails($index)"
      >
        <td><span ng-include="$ctrl.getStepLabel(step)"></span></td>
        <td>{{ step.startTime | timestamp }}</td>
        <td>{{ step.endTime | timestamp }}</td>
        <td>{{ step.runningTimeInMs | duration }}</td>
        <td>
          <span class="label label-default label-{{ step.status | lowercase }}">
            {{ step.status | lowercase | robotToHuman }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
  <div ng-if="stageSummary.comments" class="execution-details-comments">
    <strong>Comments</strong>
    <p ng-bind-html="$ctrl.getComments()"></p>
  </div>
</div>
`);
}]);

function PipelineStageExecutionDetails(props) {
  const {
    application,
    stage: { context = {} },
    stage,
    name,
    current
  } = props;
  const { result: pipelineConfigs } = useLatestPromise(() => {
    application.pipelineConfigs.activate();
    return application.pipelineConfigs.ready();
  }, []);
  const pipelineConfig = pipelineConfigs && context.pipeline && pipelineConfigs.find(({ id }) => context.pipeline === id);
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name,
    current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("h5", null, "Pipeline Stage Configuration"), /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Application"), /* @__PURE__ */ React__default.createElement("dd", null, context.application), /* @__PURE__ */ React__default.createElement("dt", null, "Pipeline"), /* @__PURE__ */ React__default.createElement("dd", null, pipelineConfig && pipelineConfig.name || context.executionName || "N/A"), /* @__PURE__ */ React__default.createElement("dt", null, "Status"), /* @__PURE__ */ React__default.createElement("dd", null, context.status || "N/A")))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage,
    message: stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "well alert alert-info"
  }, (stage.hasNotStarted || !context.executionId) && /* @__PURE__ */ React__default.createElement("span", null, "No Execution Started"), !stage.hasNotStarted && context.executionId && /* @__PURE__ */ React__default.createElement(UISref, {
    to: "home.applications.application.pipelines.executionDetails.execution",
    params: {
      application: stage.context.application,
      executionId: stage.context.executionId
    },
    options: { inherit: false }
  }, /* @__PURE__ */ React__default.createElement("a", null, "View Pipeline Execution"))))));
}
(function(PipelineStageExecutionDetails2) {
  PipelineStageExecutionDetails2.title = "pipelineConfig";
})(PipelineStageExecutionDetails || (PipelineStageExecutionDetails = {}));

class TitusExecutionLogs extends React__default.Component {
  constructor(props) {
    super(props);
    this.mounted = false;
    this.state = {};
  }
  componentDidMount() {
    this.mounted = true;
    this.setEndpoint();
  }
  setEndpoint() {
    const { context } = this.props.stage;
    AccountService.getAccountDetails(context.credentials).then((details) => {
      const titusUiEndpoint = details.regions.find((r) => r.name === context.cluster.region).endpoint;
      this.mounted && this.setState({ titusUiEndpoint });
    });
  }
  render() {
    const artificialStageJustForLogs = {};
    const { stage } = this.props;
    const { titusUiEndpoint } = this.state;
    const { context } = stage;
    const { cluster } = context;
    const jobId = cluster ? get(context["deploy.jobs"], cluster.region, [])[0] : null;
    const taskId = get(context, "jobStatus.completionDetails.taskId");
    if (titusUiEndpoint) {
      artificialStageJustForLogs.context = {
        execution: {
          logs: `${titusUiEndpoint}jobs/${jobId}/tasks/${taskId}/logs`
        }
      };
      return /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
        stage: artificialStageJustForLogs
      });
    }
    return null;
  }
}
class PreconfiguredJobExecutionDetails extends React__default.Component {
  mostRecentlyCreatedPodName(podsStatuses) {
    const sorted = sortBy(podsStatuses, (p) => p.status.startTime);
    const mostRecent = last(sorted);
    return mostRecent ? mostRecent.name : "";
  }
  executionLogsComponent(cloudProvider) {
    const { stage } = this.props;
    if (cloudProvider === "kubernetes") {
      const namespace = get(stage, ["context", "jobStatus", "location"]);
      const deployedJobs = get(this.props.stage, ["context", "deploy.jobs"]);
      const deployedName = get(deployedJobs, namespace, [])[0] || "";
      const externalLink = get(this.props.stage, ["context", "execution", "logs"]);
      const podName = this.mostRecentlyCreatedPodName(get(stage.context, ["jobStatus", "pods"], []));
      const podNameProvider = new DefaultPodNameProvider(podName);
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "well"
      }, /* @__PURE__ */ React__default.createElement(JobStageExecutionLogs, {
        deployedName,
        account: this.props.stage.context.account,
        application: this.props.application,
        location: namespace,
        externalLink,
        podNamesProviders: [podNameProvider]
      }));
    } else if (cloudProvider === "titus") {
      return /* @__PURE__ */ React__default.createElement(TitusExecutionLogs, {
        stage
      });
    }
    return /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
      stage
    });
  }
  render() {
    const { stage, name, current } = this.props;
    const { cloudProvider } = stage.context;
    const parameters = stage.context.preconfiguredJobParameters && stage.context.parameters ? /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("dl", {
      className: "dl-horizontal"
    }, stage.context.preconfiguredJobParameters.map((parameter) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("dt", null, parameter.label), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.parameters[parameter.name]))))) : /* @__PURE__ */ React__default.createElement("div", null, "No details provided.");
    const logsComponent = this.executionLogsComponent(cloudProvider);
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, parameters, /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: stage.failureMessage
    }), logsComponent);
  }
}
PreconfiguredJobExecutionDetails.title = "preconfiguredJobConfig";

function PreconfiguredJobStageConfig(props) {
  var _a;
  const parameters = (_a = props.configuration.parameters) != null ? _a : [];
  return /* @__PURE__ */ React__default.createElement(FormikStageConfig, {
    ...props,
    onChange: props.updateStage,
    render: () => parameters.map((param) => /* @__PURE__ */ React__default.createElement(FormikFormField, {
      key: param.name,
      name: `parameters.${param.name}`,
      label: param.label,
      help: param.description ? /* @__PURE__ */ React__default.createElement(HelpField, {
        content: param.description
      }) : null,
      input: (props2) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props2
      }),
      ...props
    }))
  });
}

function makePreconfiguredJobStage(preconfiguredJobType) {
  return {
    label: "",
    description: "",
    key: preconfiguredJobType,
    alias: "preconfiguredJob",
    addAliasToConfig: true,
    restartable: true,
    defaults: { parameters: {} },
    component: PreconfiguredJobStageConfig,
    executionDetailsSections: [PreconfiguredJobExecutionDetails, ExecutionDetailsTasks],
    configuration: {
      waitForCompletion: true,
      parameters: []
    },
    producesArtifacts: false
  };
}
const PRECONFIGUREDJOB_STAGE = "spinnaker.core.pipeline.stage.preconfiguredJobStage";
module(PRECONFIGUREDJOB_STAGE, []).run(() => {
  PreconfiguredJobReader.list().then((preconfiguredJobs) => {
    const basicPreconfiguredJobs = preconfiguredJobs.filter((job) => job.uiType !== "CUSTOM");
    return Promise.all(basicPreconfiguredJobs.map((job) => {
      const stageConfig = makePreconfiguredJobStage(job.type);
      return Registry.pipeline.registerPreconfiguredJobStage(stageConfig);
    }));
  });
});

const _StageConstants = class {
  static get TARGET_LIST() {
    return _StageConstants.targetList;
  }
  static get STRATEGY_TRAFFIC_OPTIONS() {
    return _StageConstants.strategyTrafficOptions;
  }
  static get IMAGE_PRODUCING_STAGES() {
    return ["bake", "findImageFromTags", "findImage", "findAmi"];
  }
  static get MANIFEST_CRITERIA_OPTIONS() {
    return _StageConstants.manifestCriteriaOptions;
  }
};
let StageConstants = _StageConstants;
StageConstants.targetList = [
  {
    label: "Newest Server Group",
    val: "current_asg_dynamic",
    description: "Selects the most recently deployed server group when this <b>stage</b> starts."
  },
  {
    label: "Previous Server Group",
    val: "ancestor_asg_dynamic",
    description: "Selects the second-most recently deployed server group when this <b>stage</b> starts."
  },
  {
    label: "Oldest Server Group",
    val: "oldest_asg_dynamic",
    description: "Selects the least recently deployed server group when this <b>stage</b> starts."
  },
  {
    label: "(Deprecated) Current Server Group",
    val: "current_asg",
    description: "Selects the most recently deployed server group when the <b>pipeline</b> starts, ignoring any changes to the state of the cluster caused by upstream stages."
  },
  {
    label: "(Deprecated) Last Server Group",
    val: "ancestor_asg",
    description: "Selects the second-most recently deployed server group when the <b>pipeline</b> starts, ignoring any changes to the state of the cluster caused by upstream stages."
  }
];
StageConstants.strategyTrafficOptions = [
  {
    label: "From Cluster Configuration",
    val: "inherit",
    description: "Traffic options are set in the advanced options tab of the deploy stage that calls the strategy"
  },
  {
    label: "Always Enable",
    description: "Always send client requests to new instances",
    val: "enable"
  },
  {
    label: "Always Disable",
    description: "Never send client requests to new instances",
    val: "disable"
  }
];
StageConstants.manifestCriteriaOptions = [
  {
    label: "Newest",
    val: "newest",
    description: "Selects the most recently deployed manifest in the cluster when this <b>stage</b> starts."
  },
  {
    label: "Second Newest",
    val: "second_newest",
    description: "Selects the second-most recently deployed manifest in the cluster when this <b>stage</b> starts."
  },
  {
    label: "Oldest",
    val: "oldest",
    description: "Selects the least recently deployed manifest in the cluster when this <b>stage</b> starts."
  },
  {
    label: "Largest",
    val: "largest",
    description: "Selects the largest (by number of pods) manifest in the cluster when this <b>stage</b> starts."
  },
  {
    label: "Smallest",
    val: "smallest",
    description: "Selects the smallest (by number of pods) manifest in the cluster when this <b>stage</b> starts."
  }
];

const PipelineTemplates = {
  addExtendedAttributes: "core/src/pipeline/config/stages/bake/modal/addExtendedAttribute.html"
};
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/bake/modal/addExtendedAttribute.html", `<div modal-page>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Add Extended Attribute</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="addExtendedAttributeForm">
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Key</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="extendedAttribute.key"
            placeholder="enter an attribute key"
            required
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Value</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="extendedAttribute.value"
            placeholder="enter an attribute value"
          />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <button
        type="submit"
        class="btn btn-primary"
        data-purpose="submit"
        ng-click="addExtendedAttribute.submit()"
        ng-disabled="addExtendedAttributeForm.$invalid"
      >
        <span class="far fa-check-circle"></span> Add
      </button>
    </div>
  </form>
</div>
`);
}]);

class PipelineTemplateReader {
  static getPipelineTemplateFromSourceUrl(source, executionId, pipelineConfigId) {
    return REST("/pipelineTemplates/resolve").query({ source, executionId, pipelineConfigId }).get().then((template) => {
      template.selfLink = source;
      return template;
    });
  }
  static getPipelinePlan(config, executionId) {
    const endpoint = PipelineTemplateV2Service.isV2PipelineConfig(config) ? "/v2/pipelineTemplates/plan" : "/pipelines/start";
    return REST(endpoint).post({ ...config, plan: true, executionId });
  }
  static getPipelineTemplatesByScopes(scopes) {
    return $q.all(scopes.map(this.getPipelineTemplatesByScope)).then((templates) => flatten(templates)).then((templates) => {
      templates.forEach((template) => template.selfLink = `spinnaker://${template.id}`);
      return templates;
    });
  }
  static getPipelineTemplateConfig({
    name,
    application,
    source
  }) {
    return {
      config: {
        schema: "1",
        pipeline: {
          name,
          application,
          template: { source }
        }
      }
    };
  }
  static getV2PipelineTemplateList() {
    return REST("/v2/pipelineTemplates/versions").get();
  }
}
PipelineTemplateReader.getPipelineTemplatesByScope = (scope) => {
  return REST("/pipelineTemplates").query({ scope }).get();
};

class ServiceAccountReader {
  static getServiceAccounts() {
    if (!SETTINGS.feature.fiatEnabled) {
      return $q.resolve([]);
    } else {
      return REST("/auth/user/serviceAccounts").get();
    }
  }
  static getServiceAccountsForApplication(application) {
    if (!SETTINGS.feature.fiatEnabled) {
      return $q.resolve([]);
    } else {
      return REST("/auth/user/serviceAccounts").query({ application }).get();
    }
  }
}

function RunAsUserInput(props) {
  const fetchServiceAccounts = useLatestPromise(() => ServiceAccountReader.getServiceAccountsForApplication(props.application), []);
  const isLoading = fetchServiceAccounts.status === "PENDING";
  return /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
    ...props,
    isLoading,
    stringOptions: fetchServiceAccounts.result || [],
    placeholder: "Select Run As User"
  });
}

function ExecutionOptionsPageContent(props) {
  const { pipeline, updatePipelineConfig } = props;
  const [currentMaxConcurrent, setCurrentMaxConcurrent] = useState$b(pipeline.maxConcurrentExecutions || 0);
  const handleMaxConcurrentChange = (changeEvent) => {
    const value = Number.parseInt(changeEvent.target.value);
    setCurrentMaxConcurrent(value);
    updatePipelineConfig({ maxConcurrentExecutions: value });
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-11 col-md-offset-1"
  }, /* @__PURE__ */ React__default.createElement(FormField, {
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      ...inputProps,
      text: /* @__PURE__ */ React__default.createElement("strong", null, "Disable concurrent pipeline executions (only run one at a time). ")
    }),
    onChange: () => {
      updatePipelineConfig({ limitConcurrent: !pipeline.limitConcurrent });
      if (!pipeline.limitConcurrent && !pipeline.keepWaitingPipelines) {
        pipeline.keepWaitingPipelines = true;
        updatePipelineConfig({ keepWaitingPipelines: true });
      }
    },
    value: pipeline.limitConcurrent
  }), pipeline.limitConcurrent && /* @__PURE__ */ React__default.createElement(FormField, {
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      ...inputProps,
      text: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("strong", null, "Do not automatically cancel pipelines waiting in queue. "), /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.parallel.cancel.queue"
      }))
    }),
    onChange: () => {
      updatePipelineConfig({ keepWaitingPipelines: !pipeline.keepWaitingPipelines });
    },
    value: pipeline.keepWaitingPipelines
  }), !pipeline.limitConcurrent && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("label", {
    className: "col-md-3 sm-label-right"
  }, "Maximum concurrent pipeline executions ", /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "pipeline.config.parallel.max.concurrent"
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-8"
  }, /* @__PURE__ */ React__default.createElement(FormField, {
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(NumberInput$1, {
      ...inputProps,
      min: 0,
      max: 65534
    }),
    onChange: handleMaxConcurrentChange,
    value: currentMaxConcurrent
  })))));
}

function TagsInput({ name, onChange, value, validation }) {
  const errors = validation && validation.messageNode || [];
  const handleChange = (tag, index) => {
    const newTags = value.map((x, i) => i === index ? tag : x);
    onChange(createFakeReactSyntheticEvent({ name, value: newTags }));
  };
  const handleDelete = (index) => {
    const newTags = value.filter((_x, i) => i !== index);
    onChange(createFakeReactSyntheticEvent({ name, value: newTags }));
  };
  const handleAddPair = () => {
    const newTags = (value || []).concat({ name: "", value: "" });
    onChange(createFakeReactSyntheticEvent({ name, value: newTags }));
  };
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("table", {
    className: `table table-condensed packed tags no-border-top`
  }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, "Name"), /* @__PURE__ */ React__default.createElement("th", null, "Value"), /* @__PURE__ */ React__default.createElement("th", null))), /* @__PURE__ */ React__default.createElement("tbody", null, (value || []).map((tag, i) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
    key: i
  }, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("input", {
    className: "form-control input input-sm",
    type: "text",
    value: tag.name,
    onChange: (e) => handleChange({ name: e.target.value, value: tag.value }, i)
  })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("input", {
    className: "form-control input input-sm",
    type: "text",
    value: tag.value,
    onChange: (e) => handleChange({ name: tag.name, value: e.target.value }, i)
  })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-control-static"
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "clickable button",
    onClick: () => handleDelete(i)
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-trash"
  }), /* @__PURE__ */ React__default.createElement("span", {
    className: "sr-only"
  }, "Remove field"))))), errors[i] && /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
    colSpan: 3
  }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    message: errors[i],
    type: "error"
  })))))), /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
    colSpan: 3
  }, /* @__PURE__ */ React__default.createElement("button", {
    type: "button",
    className: "btn btn-block btn-sm add-new",
    onClick: handleAddPair
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-plus-sign"
  }), "Add tag"))))));
}
function MetadataPage(props) {
  const { pipeline, updatePipelineConfig } = props;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormField, {
    name: "description",
    label: "Description",
    value: pipeline.description,
    onChange: (e) => updatePipelineConfig({ description: e.target.value }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextAreaInput, {
      ...inputProps,
      placeholder: "(Optional) anything that might be helpful to explain the purpose of this pipeline; Markdown is okay",
      rows: 3
    })
  }), /* @__PURE__ */ React__default.createElement(FormField, {
    name: "tags",
    label: "Tags",
    value: pipeline.tags,
    onChange: (e) => updatePipelineConfig({ tags: e.target.value }),
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.tags"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(TagsInput, {
      ...inputProps
    })
  }));
}
const MetadataPageContent = overridableComponent(MetadataPage, "metadataPageContent");

function NotificationsPageContent(props) {
  const { pipeline, updatePipelineConfig } = props;
  function updateNotification(notifications) {
    updatePipelineConfig({ notifications });
  }
  return /* @__PURE__ */ React__default.createElement(NotificationsList, {
    level: "pipeline",
    stageType: pipeline.type,
    notifications: pipeline.notifications,
    updateNotifications: updateNotification
  });
}

class Parameter extends React__default.Component {
  constructor(props) {
    super(props);
    this.addOption = () => {
      const { options, updateParameterField } = this.props;
      const newOptions = options.splice(0);
      newOptions.push({ value: "" });
      updateParameterField({ options: newOptions });
    };
    this.removeOption = (index) => {
      const { options, updateParameterField } = this.props;
      updateParameterField({ options: options.filter((o) => o !== options[index]) });
    };
    this.handleNameChange = (event) => {
      const name = event.target.value;
      this.props.updateParameterField({ name });
    };
    this.handleLabelChange = (event) => {
      const label = event.target.value;
      this.props.updateParameterField({ label });
    };
    this.handleRequiredChange = (event) => {
      const required = event.target.checked;
      this.props.updateParameterField({ required });
    };
    this.handleDescriptionChange = (event) => {
      const description = event.target.value;
      this.props.updateParameterField({ description });
    };
    this.handleDefaultChange = (event) => {
      const defaultValue = event.target.value;
      this.props.updateParameterField({ default: defaultValue });
    };
    this.handleOptionChange = (index, option) => {
      const { options, updateParameterField } = this.props;
      const newOptions = options.splice(0);
      newOptions.splice(index, 1, { value: option });
      updateParameterField({ options: newOptions });
    };
    this.handlePinnedChange = (event) => {
      this.props.updateParameterField({ pinned: event.target.checked });
    };
    this.handleHasOptionChange = (event) => {
      const { options, updateParameterField } = this.props;
      updateParameterField({ hasOptions: event.target.checked });
      if (!options) {
        updateParameterField({ options: [{ value: "" }] });
      }
    };
  }
  render() {
    const {
      name,
      label,
      required,
      pinned,
      description,
      hasOptions,
      options,
      isMultiple,
      removeParameter,
      inherited
    } = this.props;
    const {
      addOption,
      handleLabelChange,
      handleNameChange,
      handleDefaultChange,
      handleDescriptionChange,
      handleHasOptionChange,
      handleOptionChange,
      handlePinnedChange,
      handleRequiredChange,
      removeOption
    } = this;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "parameter-config"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("fieldset", {
      disabled: inherited,
      className: classNames({ "templated-pipeline-item": inherited })
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-horizontal panel-pipeline-phase"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row name-field"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-1"
    }, isMultiple && /* @__PURE__ */ React__default.createElement(DragHandler, null)), /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-2 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "label-text"
    }, "Name")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4"
    }, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "text",
      required: true,
      value: name,
      onChange: handleNameChange
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-2 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "label-text"
    }, "Label "), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.parameter.label"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4"
    }, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "text",
      value: label,
      onChange: handleLabelChange
    })), !inherited && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-1 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Remove parameter"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-link glyphicon glyphicon-trash",
      onClick: removeParameter
    })))))), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Required"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: required,
      onChange: handleRequiredChange
    })))), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Pin Parameter",
      helpKey: "pipeline.config.parameter.pinned"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: pinned,
      onChange: handlePinnedChange
    })))), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Description",
      helpKey: "pipeline.config.parameter.description"
    }, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "text",
      value: description,
      onChange: handleDescriptionChange
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Default Value"
    }, /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "text",
      value: this.props.default,
      onChange: handleDefaultChange
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Show Options"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: hasOptions,
      onChange: handleHasOptionChange
    })))), hasOptions && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Options"
    }, options.map(function(option, index) {
      return /* @__PURE__ */ React__default.createElement("div", {
        key: index,
        style: { marginBottom: "5px" }
      }, /* @__PURE__ */ React__default.createElement("input", {
        className: "col-md-4 form-control input-sm",
        style: { width: "90%" },
        type: "text",
        value: option.value,
        onChange: (event) => handleOptionChange(index, event.target.value)
      }), !inherited && /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "Remove parameter"
      }, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-link glyphicon glyphicon-trash",
        onClick: () => removeOption(index)
      })));
    }), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-sm btn-default add-new",
      onClick: () => addOption(),
      style: { marginTop: "10px" }
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add New Option")))))));
  }
}
const DragHandler = SortableHandle(() => /* @__PURE__ */ React__default.createElement("span", {
  className: "clickable glyphicon glyphicon-resize-vertical"
}));

class Parameters$1 extends React__default.Component {
  constructor(props) {
    super(props);
    this.setPinAllParametersState = () => {
      this.setState({ allParametersPinned: (this.props.parameters || []).every((p) => p.pinned) });
    };
    this.togglePins = () => {
      const parameters = this.props.parameters.slice(0);
      const { allParametersPinned } = this.state;
      parameters.filter((param) => !param.inherited).forEach((param) => {
        param.pinned = !allParametersPinned;
      });
      this.props.updateAllParameters(parameters);
      this.setPinAllParametersState();
    };
    this.addParameter = () => {
      this.props.addParameter();
      this.setPinAllParametersState();
    };
    this.removeParameter = (index) => {
      this.props.removeParameter(index);
      this.setPinAllParametersState();
    };
    this.updateParameter = (index, changes) => {
      this.props.updateParameter(index, changes);
      this.setPinAllParametersState();
    };
    this.handleSortEnd = (sortEnd) => {
      const parameters = arrayMove(this.props.parameters.slice(0), sortEnd.oldIndex, sortEnd.newIndex);
      this.props.updateAllParameters(parameters);
    };
    this.state = {
      allParametersPinned: false
    };
  }
  componentDidMount() {
    this.setPinAllParametersState();
  }
  render() {
    const { parameters, pipelineName } = this.props;
    const { allParametersPinned } = this.state;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(SortableParameters, {
      parameters,
      allParametersPinned,
      setPinAllParametersState: this.setPinAllParametersState,
      togglePins: this.togglePins,
      removeParameter: this.removeParameter,
      updateParameter: this.updateParameter,
      isMultiple: parameters && parameters.length > 1,
      onSortEnd: this.handleSortEnd,
      lockAxis: "y",
      useDragHandle: true
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, parameters && !parameters.length && /* @__PURE__ */ React__default.createElement("p", null, "You don't have any parameters configured for ", pipelineName), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-block btn-add-trigger add-new",
      onClick: this.addParameter
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add Parameter"))));
  }
}
const SortableParameterElement = SortableElement((props) => /* @__PURE__ */ React__default.createElement(Parameter, {
  ...props
}));
const SortableParameters = SortableContainer((props) => /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
  className: "checkbox"
}, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
  type: "checkbox",
  checked: props.allParametersPinned,
  onChange: props.togglePins
}), /* @__PURE__ */ React__default.createElement("span", {
  className: "label-text sm-label-right"
}, "Pin all parameters "), /* @__PURE__ */ React__default.createElement(HelpField, {
  id: "pipeline.config.parameter.pinAll"
}))), props.parameters && props.parameters.map((parameter, index) => {
  return /* @__PURE__ */ React__default.createElement(SortableParameterElement, {
    key: index,
    index,
    ...parameter,
    removeParameter: () => props.removeParameter(index),
    setPinAllParametersState: props.setPinAllParametersState,
    updateParameterField: (changes) => props.updateParameter(index, changes),
    isMultiple: props.isMultiple
  });
})));

function ParametersPageContent(props) {
  const { pipeline, updatePipelineConfig } = props;
  function addParameter() {
    const parameterConfig = pipeline.parameterConfig || [];
    const updatedParameterConfig = parameterConfig.concat({
      name: "",
      label: "",
      required: false,
      pinned: false,
      description: "",
      default: "",
      hasOptions: false,
      options: [{ value: "" }]
    });
    updatePipelineConfig({ parameterConfig: updatedParameterConfig });
  }
  function removeParameter(index) {
    const parameterConfig = pipeline.parameterConfig.slice(0);
    parameterConfig.splice(index, 1);
    updatePipelineConfig({ parameterConfig });
  }
  function updateParameter(index, changes) {
    const parameterConfig = pipeline.parameterConfig.slice(0);
    extend(parameterConfig[index], changes);
    updatePipelineConfig({ parameterConfig });
  }
  function updateAllParameters(parameters) {
    const parameterConfig = parameters.slice(0);
    updatePipelineConfig({ parameterConfig });
  }
  return /* @__PURE__ */ React__default.createElement(Parameters$1, {
    addParameter,
    parameters: pipeline.parameterConfig,
    pipelineName: pipeline.name,
    removeParameter,
    updateParameter,
    updateAllParameters
  });
}

const { useState: useState$4, useEffect: useEffect$2 } = React__default;
const PipelineRoles = (props) => {
  const [allowedRoles, setAllowedRoles] = useState$4([]);
  useEffect$2(() => {
    setAllowedRoles(AuthenticationService.getAuthenticatedUser().roles);
  }, []);
  const onAllowedRolesChanged = (options) => {
    const roles = options.map((o) => o.value);
    props.updateRoles(roles);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("label", {
    className: "col-md-3 sm-label-right"
  }, /* @__PURE__ */ React__default.createElement("span", null, "Permissions "), /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "pipeline.config.roles.help"
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement(Select, {
    multi: true,
    onChange: onAllowedRolesChanged,
    options: allowedRoles.map((a) => ({ label: a, value: a })),
    value: props.roles || []
  })))));
};

var css_248z$1m = ".Trigger .StandardFieldLayout_Label {\n  min-width: 140px;\n}\n";
styleInject(css_248z$1m);

const Trigger = (props) => {
  function getValidateFn() {
    const triggerType = Registry.pipeline.getTriggerTypes().find((type) => type.key === props.triggerInitialValues.type);
    const validateWithContext = (values) => triggerType.validateFn(values, { pipeline: props.pipeline });
    return triggerType && triggerType.validateFn ? validateWithContext : void 0;
  }
  return /* @__PURE__ */ React__default.createElement(SpinFormik, {
    onSubmit: () => null,
    initialValues: props.triggerInitialValues,
    validate: getValidateFn(),
    render: (formik) => /* @__PURE__ */ React__default.createElement(TriggerForm, {
      ...props,
      formik
    })
  });
};
const commonTriggerFields = [
  "enabled",
  "rebake",
  "user",
  "type",
  "expectedArtifactIds",
  "runAsUser",
  "excludedArtifactTypePatterns"
];
function TriggerForm(triggerFormProps) {
  const {
    formik,
    pipeline,
    index,
    updateTrigger,
    addExpectedArtifact,
    updateExpectedArtifact,
    removeExpectedArtifact
  } = triggerFormProps;
  const trigger = formik.values;
  const { type } = trigger;
  const triggerTypes = React__default.useMemo(() => Registry.pipeline.getTriggerTypes(), []);
  const triggerConfig = React__default.useMemo(() => triggerTypes.find((x) => x.key === trigger.type), [
    triggerTypes,
    trigger.type
  ]);
  const disableAutoTriggering = SETTINGS.disableAutoTriggering || [];
  const handleTypeChange = (newType) => {
    const newValues = pick(trigger, commonTriggerFields);
    newValues.enabled = disableAutoTriggering.includes(newType) ? false : trigger.enabled;
    newValues.type = newType;
    formik.setValues(newValues);
  };
  const updateTriggerFields = (changes) => {
    const updatedTrigger = { ...trigger, ...changes };
    formik.setValues(updatedTrigger);
  };
  const updateTriggerExpectedArtifacts = (availableExpectedArtifactIds2) => {
    formik.setFieldValue("expectedArtifactIds", (trigger.expectedArtifactIds || []).filter((artifactId) => availableExpectedArtifactIds2.includes(artifactId)));
  };
  const triggerComponentProps = {
    ...triggerFormProps,
    trigger: formik.values,
    formik,
    pipelineId: pipeline.id,
    triggerUpdated: updateTriggerFields
  };
  const EmptyComponent = () => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  const TriggerComponent = triggerConfig && triggerConfig.component || EmptyComponent;
  const showRunAsUser = SETTINGS.feature.fiatEnabled && !SETTINGS.feature.managedServiceAccounts;
  const fieldSetClassName = classNames({ "templated-pipeline-item": trigger.inherited, Trigger: true });
  const availableExpectedArtifacts = pipeline.expectedArtifacts || [];
  const availableExpectedArtifactIds = availableExpectedArtifacts.map((a) => a.id);
  return /* @__PURE__ */ React__default.createElement("fieldset", {
    disabled: trigger.inherited,
    className: fieldSetClassName
  }, /* @__PURE__ */ React__default.createElement(WatchValue, {
    value: trigger,
    isEqual,
    onChange: (updatedTrigger) => updateTrigger(index, updatedTrigger)
  }), /* @__PURE__ */ React__default.createElement(WatchValue, {
    value: availableExpectedArtifactIds,
    isEqual,
    onChange: updateTriggerExpectedArtifacts
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "form-horizontal panel-pipeline-phase"
  }, /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Type",
    actions: trigger.inherited ? /* @__PURE__ */ React__default.createElement(FromTemplateMessage, null) : /* @__PURE__ */ React__default.createElement(RemoveTriggerButton, {
      onClick: () => triggerFormProps.removeTrigger(index)
    }),
    value: trigger.type,
    onChange: (e) => handleTypeChange(e.target.value),
    input: (props) => /* @__PURE__ */ React__default.createElement(TriggerTypeSelectInput, {
      ...props,
      triggerConfig
    })
  }), /* @__PURE__ */ React__default.createElement(TriggerComponent, {
    ...triggerComponentProps
  }), showRunAsUser && /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "runAsUser",
    label: "Run As User",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.trigger.runAsUser"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(RunAsUserInput, {
      ...props,
      application: triggerFormProps.application.name
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "expectedArtifactIds",
    label: "Artifact Constraints",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.expectedArtifact"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TriggerArtifactConstraintSelectorInput, {
      ...props,
      pipeline,
      triggerType: trigger.type,
      addExpectedArtifact,
      updateExpectedArtifact,
      removeExpectedArtifact
    })
  }), type && disableAutoTriggering.includes(type) && /* @__PURE__ */ React__default.createElement(AutoTriggeringDisabledMessage, null), type && !disableAutoTriggering.includes(type) && /* @__PURE__ */ React__default.createElement(FormField, {
    label: "",
    value: trigger.enabled,
    onChange: () => formik.setFieldValue("enabled", !trigger.enabled),
    input: (props) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      ...props,
      inputClassName: "enable-trigger-checkbox",
      text: "Trigger Enabled"
    })
  })));
}
function TriggerTypeSelectInput(props) {
  const triggerTypes = Registry.pipeline.getTriggerTypes().map((t) => ({ label: t.label, value: t.key, description: t.description }));
  const optionRenderer = (option) => /* @__PURE__ */ React__default.createElement("p", {
    className: "flex-container-h baseline margin-between-md"
  }, /* @__PURE__ */ React__default.createElement("span", {
    style: { fontWeight: "bold", minWidth: "100px" }
  }, option.label), /* @__PURE__ */ React__default.createElement("span", null, option.description));
  return /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
    ...props,
    options: triggerTypes,
    optionRenderer
  });
}
function RemoveTriggerButton(props) {
  return /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-sm btn-default",
    onClick: props.onClick
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-trash"
  }), /* @__PURE__ */ React__default.createElement("span", {
    className: "visible-xl-inline"
  }, "Remove trigger"));
}
function AutoTriggeringDisabledMessage() {
  const message = "Automatic triggering is disabled for this trigger type. You can still use this as a trigger to supply data to downstream stages, but will need to manually execute this pipeline.";
  return /* @__PURE__ */ React__default.createElement(FormField, {
    label: "",
    input: () => /* @__PURE__ */ React__default.createElement(ValidationMessage, {
      message,
      type: "warning"
    })
  });
}
function FromTemplateMessage() {
  return /* @__PURE__ */ React__default.createElement("span", {
    className: "templated-pipeline-item__status btn btn-sm btn-default"
  }, /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: "From Template"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "from-template fa fa-table"
  })), /* @__PURE__ */ React__default.createElement("span", {
    className: "visible-xl-inline"
  }, "From Template"));
}

function isNumberOrSpel(valInput) {
  return isNumber$1(valInput) && valInput > 0 || typeof valInput === "string" && valInput.includes("${");
}
const _PipelineConfigValidator = class {
  static registerValidator(type, validator) {
    this.validators.set(type, validator);
  }
  static validatePipeline(pipeline) {
    const stages = pipeline.stages || [];
    const triggers = pipeline.triggers || [];
    const validations = [];
    const pipelineValidations = this.getPipelineLevelValidations(pipeline);
    const stageValidations = new Map();
    let preventSave = false;
    triggers.forEach((trigger, index) => {
      const config = Registry.pipeline.getTriggerConfig(trigger.type);
      if (config && config.validators) {
        config.validators.forEach((validator) => {
          const typedValidator = this.getValidator(validator);
          if (!typedValidator) {
            $log.warn(`No validator of type "${validator.type}" found, ignoring validation on trigger "${index + 1}" (${trigger.type})`);
          } else {
            validations.push($q.resolve(typedValidator.validate(pipeline, trigger, validator, config)).then((message) => {
              if (message && !pipelineValidations.includes(message)) {
                pipelineValidations.push(message);
                if (validator.preventSave) {
                  preventSave = true;
                }
              }
            }));
          }
        });
      } else if (config && config.validateFn) {
        validations.push($q((resolve, reject) => Promise.resolve(config.validateFn(trigger, { pipeline })).then(resolve, reject)).then((errors) => {
          _PipelineConfigValidator.flattenValues(errors).forEach((message) => {
            pipelineValidations.push(message);
          });
        }));
      }
    });
    stages.forEach((stage) => {
      const config = Registry.pipeline.getStageConfig(stage);
      if (config && config.validators) {
        config.validators.forEach((validator) => {
          if (validator.skipValidation && validator.skipValidation(pipeline, stage)) {
            return;
          }
          const typedValidator = this.getValidator(validator);
          if (!typedValidator) {
            $log.warn(`No validator of type "${validator.type}" found, ignoring validation on stage "${stage.name}" (${stage.type})`);
          } else {
            validations.push($q.resolve(typedValidator.validate(pipeline, stage, validator, config)).then((message) => {
              if (message) {
                if (!stageValidations.has(stage)) {
                  stageValidations.set(stage, []);
                }
                if (!stageValidations.get(stage).includes(message)) {
                  stageValidations.get(stage).push(message);
                  if (validator.preventSave) {
                    preventSave = true;
                  }
                }
              }
            }));
          }
        });
      } else if (config && config.validateFn) {
        validations.push($q((resolve, reject) => Promise.resolve(config.validateFn(stage, { pipeline })).then(resolve, reject)).then((errors) => {
          const array = _PipelineConfigValidator.flattenValues(errors);
          if (array && array.length > 0) {
            stageValidations.set(stage, array);
          }
        }));
      }
      if (stage.stageTimeoutMs !== void 0 && !isNumberOrSpel(stage.stageTimeoutMs)) {
        stageValidations.set(stage, [
          ...stageValidations.get(stage) || [],
          "Stage is configured to fail after a specific amount of time, but no time is set."
        ]);
      }
    });
    return $q.all(validations).then(() => {
      const results = {
        stages: Array.from(stageValidations).map(([stage, messages]) => ({ stage, messages })),
        pipeline: pipelineValidations,
        hasWarnings: false,
        preventSave
      };
      results.hasWarnings = results.pipeline.length > 0 || results.stages.length > 0;
      this.validationStream.next(results);
      return results;
    });
  }
  static getValidator(validator) {
    return validator.type === "custom" ? validator : this.validators.get(validator.type);
  }
  static getPipelineLevelValidations(pipeline) {
    const messages = [];
    if ((pipeline.parameterConfig || []).some((p) => !p.name)) {
      messages.push("<b>Name</b> is a required field for parameters.");
    }
    if (pipeline.strategy && !pipeline.stages.some((stage) => stage.type === "deploy")) {
      messages.push("To be able to create new server groups, a custom strategy should contain a Deploy stage.");
    }
    if ((pipeline.expectedArtifacts || []).some((a) => !a.matchArtifact || a.matchArtifact === {})) {
      messages.push("Every expected artifact must specify an artifact to match against.");
    }
    return messages;
  }
  static subscribe(method) {
    return this.validationStream.subscribe(method);
  }
};
let PipelineConfigValidator = _PipelineConfigValidator;
PipelineConfigValidator.validators = new Map();
PipelineConfigValidator.validationStream = new Subject();
PipelineConfigValidator.flattenValues = (maybeObj) => {
  if (typeof maybeObj === "string") {
    return [maybeObj];
  }
  return flatten(values(maybeObj).map(_PipelineConfigValidator.flattenValues));
};
PipelineConfigValidator.registerValidator("custom", null);

const { useState: useState$3 } = React__default;
function TriggersPageContent(props) {
  var _a, _b;
  const showProperties = SETTINGS.feature.quietPeriod || SETTINGS.feature.managedServiceAccounts;
  const { pipeline, application, updatePipelineConfig } = props;
  const expectedArtifacts = (_a = pipeline == null ? void 0 : pipeline.expectedArtifacts) != null ? _a : [];
  const triggers = (_b = pipeline == null ? void 0 : pipeline.triggers) != null ? _b : [];
  const [deleteCount, setDeleteCount] = useState$3(0);
  function updateRoles(roles) {
    updatePipelineConfig({ roles });
  }
  function addTrigger() {
    const triggerTypes = Registry.pipeline.getTriggerTypes();
    let newTrigger = { enabled: true, type: null };
    if (triggerTypes.length === 1) {
      newTrigger = { enabled: true, type: triggerTypes[0].key };
    }
    updatePipelineConfig({ triggers: [...triggers, newTrigger] });
  }
  function removeTrigger(indexToRemove) {
    var _a2;
    const triggerToRemove = triggers[indexToRemove];
    const updatedTriggers = triggers.filter((_t, i) => i !== indexToRemove);
    const artifactIdsToRemove = ((_a2 = triggerToRemove == null ? void 0 : triggerToRemove.expectedArtifactIds) != null ? _a2 : []).filter((id) => {
      return !updatedTriggers.some((trigger) => (trigger.expectedArtifactIds || []).includes(id));
    });
    const pipelineUpdate = {
      triggers: updatedTriggers
    };
    if (artifactIdsToRemove.length > 0) {
      const updatedExpectedArtifacts = expectedArtifacts.filter(({ id }) => !artifactIdsToRemove.includes(id));
      pipelineUpdate.expectedArtifacts = updatedExpectedArtifacts;
      ArtifactReferenceService.removeReferencesFromStages(artifactIdsToRemove, pipeline.stages);
    }
    updatePipelineConfig(pipelineUpdate);
    setDeleteCount(deleteCount + 1);
  }
  function updateTrigger(indexToUpdate, updatedTrigger) {
    PipelineConfigValidator.validatePipeline(pipeline);
    updatePipelineConfig({
      triggers: triggers.map((trigger, index) => {
        if (index === indexToUpdate) {
          return updatedTrigger;
        }
        return trigger;
      })
    });
  }
  function addExpectedArtifact(artifact) {
    updatePipelineConfig({
      expectedArtifacts: expectedArtifacts.concat([artifact])
    });
  }
  function updateExpectedArtifact(updatedArtifact) {
    updatePipelineConfig({
      expectedArtifacts: expectedArtifacts.map((artifact) => {
        if (artifact.id === updatedArtifact.id) {
          return updatedArtifact;
        }
        return artifact;
      })
    });
  }
  function removeExpectedArtifact(artifactToRemove) {
    updatePipelineConfig({
      expectedArtifacts: expectedArtifacts.filter((a) => a.id !== artifactToRemove.id)
    });
    ArtifactReferenceService.removeReferenceFromStages(artifactToRemove.id, pipeline.stages);
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "triggers"
  }, triggers.length > 0 && showProperties && /* @__PURE__ */ React__default.createElement("div", {
    className: "form-horizontal panel-pipeline-phase"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "trigger-config"
  }, SETTINGS.feature.managedServiceAccounts && /* @__PURE__ */ React__default.createElement(PipelineRoles, {
    roles: pipeline.roles,
    updateRoles
  }), SETTINGS.feature.quietPeriod && /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9 col-md-offset-3"
  }, /* @__PURE__ */ React__default.createElement(FormField, {
    name: "respectQuietPeriod",
    onChange: () => {
      updatePipelineConfig({ respectQuietPeriod: !pipeline.respectQuietPeriod });
    },
    value: pipeline.respectQuietPeriod,
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      ...inputProps,
      text: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "Disable automated triggers during quiet period.", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.triggers.respectQuietPeriod"
      }))
    })
  })))))))), triggers.map((trigger, index) => /* @__PURE__ */ React__default.createElement("div", {
    className: "trigger-config",
    key: `${deleteCount}:${index}`
  }, /* @__PURE__ */ React__default.createElement(Trigger, {
    application,
    index,
    pipeline,
    removeTrigger,
    triggerInitialValues: trigger,
    updateTrigger,
    addExpectedArtifact,
    updateExpectedArtifact,
    removeExpectedArtifact
  }))), triggers.length === 0 && /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("p", {
    className: "col-md-12"
  }, "You don't have any triggers configured for ", pipeline.name, ".")), /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-block btn-add-trigger add-new",
    onClick: () => addTrigger()
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-plus-sign"
  }), " Add Trigger"))));
}

function Triggers$1(props) {
  const pipeline = props.pipeline;
  const revertCountKLUDGE = props.revertCount;
  return /* @__PURE__ */ React__default.createElement(PageNavigator, {
    scrollableContainer: "[ui-view]",
    reactInjector: ReactInjector
  }, /* @__PURE__ */ React__default.createElement(PageSection, {
    pageKey: "concurrent",
    label: "Execution Options",
    visible: !pipeline.strategy
  }, /* @__PURE__ */ React__default.createElement(ExecutionOptionsPageContent, {
    ...props
  })), /* @__PURE__ */ React__default.createElement(PageSection, {
    pageKey: "triggers",
    label: "Automated Triggers",
    badge: pipeline.triggers ? pipeline.triggers.length.toString() : "0",
    noWrapper: true
  }, /* @__PURE__ */ React__default.createElement(TriggersPageContent, {
    ...props,
    key: revertCountKLUDGE
  })), /* @__PURE__ */ React__default.createElement(PageSection, {
    pageKey: "parameters",
    label: "Parameters",
    badge: pipeline.parameterConfig ? pipeline.parameterConfig.length.toString() : "0",
    noWrapper: true
  }, /* @__PURE__ */ React__default.createElement(ParametersPageContent, {
    ...props
  })), /* @__PURE__ */ React__default.createElement(PageSection, {
    pageKey: "notifications",
    label: "Notifications",
    badge: pipeline.notifications ? pipeline.notifications.length.toString() : "0",
    visible: !pipeline.strategy
  }, /* @__PURE__ */ React__default.createElement(NotificationsPageContent, {
    ...props
  })), /* @__PURE__ */ React__default.createElement(PageSection, {
    pageKey: "description",
    label: "Metadata",
    noWrapper: true
  }, /* @__PURE__ */ React__default.createElement(MetadataPageContent, {
    ...props,
    key: revertCountKLUDGE
  })));
}

function buildDisplayName(input) {
  if (!input) {
    return "";
  }
  let formattedInput = "";
  if (input.fullDisplayName !== void 0) {
    formattedInput = input.fullDisplayName.split("#" + input.number).pop();
  }
  return formattedInput;
}
function buildDisplayNameFilter() {
  return buildDisplayName;
}
const BUILD_DISPLAY_NAME_FILTER = "spinnaker.core.pipeline.buildDisplayName.filter";
module(BUILD_DISPLAY_NAME_FILTER, []).filter("buildDisplayName", buildDisplayNameFilter);

class BaseBuildTriggerTemplate extends React__default.Component {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.buildLoadSuccess = (allBuilds) => {
      const newState = {
        buildsLoading: false
      };
      const trigger = this.props.command.trigger;
      newState.builds = (allBuilds || []).filter((build) => !build.building && build.result === "SUCCESS").sort((a, b) => b.number - a.number);
      if (newState.builds.length) {
        const defaultSelection = newState.builds.find((b) => b.number === trigger.buildNumber) || newState.builds[0];
        newState.selectedBuild = defaultSelection.number;
        this.updateSelectedBuild(defaultSelection);
      }
      this.setState(newState);
    };
    this.buildLoadFailure = () => {
      this.setState({
        buildsLoading: false,
        loadError: true
      });
    };
    this.updateSelectedBuild = (item) => {
      const { updateCommand } = this.props;
      updateCommand("extraFields.buildNumber", item.number);
      this.setState({ selectedBuild: item.number });
    };
    this.initialize = (command) => {
      this.props.updateCommand("triggerInvalid", true);
      const trigger = command.trigger;
      this.props.updateCommand("extraFields", { buildNumber: get(command, "extraFields.buildNumber", "") });
      this.setState({
        buildsLoading: true,
        loadError: false
      });
      if (trigger.buildNumber) {
        this.updateSelectedBuild(trigger.buildInfo);
      }
      if (trigger.type !== this.props.buildTriggerType) {
        return;
      }
      from(IgorService.listBuildsForJob(trigger.master, trigger.job)).pipe(takeUntil(this.destroy$)).subscribe(this.buildLoadSuccess, this.buildLoadFailure);
    };
    this.manuallySpecify = () => {
      this.setState({
        explicitBuild: true
      });
    };
    this.explicitlyUpdateBuildNumber = (event) => {
      this.updateSelectedBuild({ number: event.target.value });
    };
    this.handleBuildChanged = (option) => {
      this.updateSelectedBuild({ number: option.number });
    };
    this.optionRenderer = (build) => {
      return /* @__PURE__ */ React__default.createElement("span", {
        style: { fontSize: "13px" }
      }, /* @__PURE__ */ React__default.createElement("strong", null, "Build ", build.number, " "), buildDisplayName(build), "(", timestamp(build.timestamp), ")");
    };
    this.state = {
      builds: [],
      buildsLoading: false,
      loadError: false,
      selectedBuild: 0,
      explicitBuild: false
    };
  }
  static formatLabel(trigger) {
    return $q.when(`(${capitalize(trigger.type)}) ${trigger.master}: ${trigger.job}`);
  }
  componentDidMount() {
    this.initialize(this.props.command);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { builds, buildsLoading, loadError, selectedBuild, explicitBuild } = this.state;
    const loadingBuilds = /* @__PURE__ */ React__default.createElement("div", {
      className: "form-control-static text-center"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "small"
    }));
    const errorLoadingBuilds = /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, "Error loading builds!");
    const noBuildsFound = /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "No builds found"));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-4 sm-label-right"
    }, "Build"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("div", null, explicitBuild ? /* @__PURE__ */ React__default.createElement(TextInput, {
      inputClassName: "input-sm",
      value: this.props.command.extraFields.buildNumber,
      onChange: this.explicitlyUpdateBuildNumber
    }) : buildsLoading ? loadingBuilds : loadError ? errorLoadingBuilds : builds.length <= 0 ? noBuildsFound : /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      options: builds,
      valueKey: "number",
      optionRenderer: this.props.optionRenderer ? this.props.optionRenderer : this.optionRenderer,
      clearable: false,
      value: selectedBuild,
      valueRenderer: this.props.optionRenderer ? this.props.optionRenderer : this.optionRenderer,
      onChange: this.handleBuildChanged
    })), !explicitBuild && /* @__PURE__ */ React__default.createElement("div", {
      className: "small",
      style: { marginTop: "5px" }
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.manuallySpecify
    }, "Manually specify build"))));
  }
}

class ManagedTemplateSelector extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleTemplateSelect = (option) => {
      let selectedTemplate;
      if (option) {
        selectedTemplate = this.props.templates.find((t) => t.id === option.value);
      }
      this.props.onChange(selectedTemplate);
    };
    this.templateOptionRenderer = (option) => {
      const template = this.props.templates.find((t) => t.id === option.value);
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h5", {
        style: { marginBottom: "0" }
      }, template.metadata.name), template.selfLink && /* @__PURE__ */ React__default.createElement("p", {
        className: "small"
      }, template.selfLink), template.metadata.owner && /* @__PURE__ */ React__default.createElement("p", {
        className: "small"
      }, template.metadata.owner), template.metadata.description && /* @__PURE__ */ React__default.createElement("p", {
        className: "small"
      }, template.metadata.description));
    };
  }
  render() {
    const selected = this.props.selectedTemplate;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7 col-md-offset-3"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      options: this.createOptionsFromTemplates(),
      clearable: true,
      value: selected ? { label: selected.metadata.name, value: selected.id } : null,
      onChange: this.handleTemplateSelect,
      optionRenderer: this.templateOptionRenderer,
      onSelectResetsInput: false
    })));
  }
  createOptionsFromTemplates() {
    return this.props.templates.map((t) => ({ label: t.metadata.name, value: t.id }));
  }
}

var css_248z$1l = ".template-description {\n  margin-top: 10px;\n  padding-left: 5%;\n}\n.template-description--loading {\n  margin-bottom: 10px;\n}\n.template-description .spinner {\n  display: block;\n  margin: 0 auto;\n}\n";
styleInject(css_248z$1l);

class TemplateDescription extends React__default.Component {
  isV1Template(template) {
    return template.schema === "1";
  }
  render() {
    const { loading, loadingError, template } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: classNames("col-md-12", "template-description", { "template-description--loading": loading })
    }, loading && /* @__PURE__ */ React__default.createElement("div", {
      className: "spinner"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "small"
    })), template && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-info"
    }, /* @__PURE__ */ React__default.createElement("strong", null, template.metadata.name), this.isV1Template(template) && template.selfLink && /* @__PURE__ */ React__default.createElement("p", {
      className: "small"
    }, /* @__PURE__ */ React__default.createElement("a", {
      href: this.buildTemplateResolutionLink(template.selfLink),
      target: "_blank"
    }, template.selfLink)), template.metadata.owner && /* @__PURE__ */ React__default.createElement("p", {
      className: "small"
    }, template.metadata.owner), /* @__PURE__ */ React__default.createElement("p", {
      className: "small"
    }, template.metadata.description || "No template description provided.")), loadingError && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-danger"
    }, /* @__PURE__ */ React__default.createElement("p", null, "There was an error loading the template.")));
  }
  buildTemplateResolutionLink(templateLink) {
    return `${SETTINGS.gateUrl}/pipelineTemplates/resolve?source=${templateLink}`;
  }
}

var css_248z$1k = ".create-pipeline-modal-overflow-visible .modal-content {\n  overflow: visible;\n}\n.create-pipeline-modal-overflow-visible .modal-content a {\n  cursor: pointer;\n}\n.create-pipeline-modal-overflow-visible .modal-content label.radio-inline {\n  margin-top: 5px;\n}\n";
styleInject(css_248z$1k);

var __defProp$l = Object.defineProperty;
var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
var __decorateClass$l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$l(target, key, result);
  return result;
};
let CreatePipelineModal = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.submit = () => {
      const command = cloneDeep(this.state.command);
      const pipelineConfig = command.strategy ? this.getDefaultConfig() : command.config;
      pipelineConfig.name = command.name.trim();
      pipelineConfig.index = this.props.application.getDataSource("pipelineConfigs").data.length;
      delete pipelineConfig.id;
      if (command.strategy) {
        pipelineConfig.strategy = true;
        pipelineConfig.limitConcurrent = false;
      }
      if (pipelineConfig.type === "templatedPipeline") {
        delete pipelineConfig.config.pipeline.pipelineConfigId;
        pipelineConfig.config.pipeline.name = command.name;
      }
      this.setState({ submitting: true });
      PipelineConfigService.savePipeline(pipelineConfig).then(() => this.onSaveSuccess(pipelineConfig), this.onSaveFailure);
    };
    this.submitPipelineTemplateConfig = () => {
      const { application, preselectedTemplate } = this.props;
      const { command } = this.state;
      const pipelineConfig = {
        name: command.name,
        application: application.name,
        type: "templatedPipeline",
        limitConcurrent: true,
        keepWaitingPipelines: false,
        triggers: []
      };
      const config = {
        ...pipelineConfig,
        ...preselectedTemplate ? PipelineTemplateV2Service.getPipelineTemplateConfigV2(PipelineTemplateV2Service.getTemplateVersion(preselectedTemplate)) : PipelineTemplateReader.getPipelineTemplateConfig({
          name: command.name,
          application: application.name,
          source: command.template.selfLink
        })
      };
      this.setState({ submitting: true });
      PipelineConfigService.savePipeline(config).then(() => this.onSaveSuccess(config), this.onSaveFailure);
    };
    this.onSaveFailure = (response) => {
      $log.warn(response);
      this.setState({
        submitting: false,
        saveError: true,
        saveErrorMessage: response && response.data && response.data.message || "No message provided"
      });
    };
    this.close = (evt) => {
      evt && evt.stopPropagation();
      this.setState(this.getDefaultState());
      this.props.showCallback(false);
    };
    this.handleTypeChange = (option) => {
      const strategy = option.value;
      this.setState({ command: { ...this.state.command, strategy } });
    };
    this.handleNameChange = (e) => {
      this.setState({ command: { ...this.state.command, name: e.target.value } });
    };
    this.handleConfigChange = (option) => {
      const config = this.state.configs.find((t) => t.name === option.value);
      this.setState({ command: { ...this.state.command, config } });
    };
    this.handleSaveErrorDismiss = () => {
      this.setState({ saveError: false });
    };
    this.handleLoadErrorDismiss = () => {
      this.setState({ loadError: false });
    };
    this.handleTemplateSelection = (template) => {
      this.setState({ command: { ...this.state.command, template } });
    };
    this.handleSourceUrlChange = (e) => {
      const templateSourceUrl = e.target.value;
      this.setState({ templateSourceUrl });
      this.loadPipelineTemplateFromSource(templateSourceUrl);
    };
    this.configOptionRenderer = (option) => {
      const config = this.state.configs.find((t) => t.name === option.value);
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h5", null, config.name), config.stages.length > 0 && /* @__PURE__ */ React__default.createElement("div", {
        className: "small"
      }, /* @__PURE__ */ React__default.createElement("b", null, "Stages: "), /* @__PURE__ */ React__default.createElement("ul", null, config.stages.map((stage) => /* @__PURE__ */ React__default.createElement("li", {
        key: stage.refId
      }, stage.name || stage.type)))));
    };
    this.handleFormSubmit = (e) => e.preventDefault();
    this.state = this.getDefaultState();
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show && !this.state.loading) {
      this.loadPipelineTemplates();
    }
  }
  getDefaultConfig() {
    return {
      name: "None",
      stages: [],
      triggers: [],
      application: this.props.application.name,
      limitConcurrent: true,
      keepWaitingPipelines: false,
      spelEvaluator: "v4"
    };
  }
  getDefaultState() {
    const defaultConfig = this.getDefaultConfig();
    const { application } = this.props;
    const configs = [defaultConfig].concat(get(application, "pipelineConfigs.data", []));
    const configOptions = configs.map((config) => ({ value: config.name, label: config.name }));
    const existingNames = [defaultConfig].concat(get(application, "pipelineConfigs.data", [])).concat(get(application, "strategyConfigs.data", [])).map((config) => config.name);
    return {
      submitting: false,
      saveError: false,
      saveErrorMessage: null,
      loading: false,
      loadError: false,
      loadErrorMessage: null,
      configs,
      configOptions,
      templates: [],
      existingNames,
      command: { strategy: false, name: "", config: defaultConfig, template: null },
      useTemplate: false,
      useManagedTemplate: true,
      loadingTemplateFromSource: false,
      loadingTemplateFromSourceError: false,
      templateSourceUrl: "",
      inheritTemplateParameters: true,
      inheritTemplateExpectedArtifacts: true,
      inheritTemplateTriggers: true
    };
  }
  onSaveSuccess(config) {
    const application = this.props.application;
    application.pipelineConfigs.refresh(true).then(() => {
      const configs = config.strategy ? application.strategyConfigs.data : application.pipelineConfigs.data;
      const newPipeline = configs.find((_config) => _config.name === config.name);
      if (!newPipeline) {
        $log.warn("Could not find new pipeline after save succeeded.");
        this.setState({
          saveError: true,
          saveErrorMessage: "Sorry, there was an error retrieving your new pipeline. Please refresh the browser.",
          submitting: false
        });
      } else {
        newPipeline.isNew = true;
        this.setState(this.getDefaultState());
        this.props.pipelineSavedCallback(newPipeline.id);
      }
    });
  }
  handleUseTemplateSelection(useTemplate) {
    return () => this.setState({ useTemplate });
  }
  handleUseManagedTemplateSelection(useManagedTemplate) {
    return () => {
      this.setState({
        useManagedTemplate,
        templateSourceUrl: "",
        loadingTemplateFromSourceError: false,
        command: { ...this.state.command, template: null }
      });
    };
  }
  validateNameCharacters() {
    return /^[^\\^/?%#]*$/.test(this.state.command.name);
  }
  validateNameIsUnique() {
    return this.state.existingNames.every((name) => name !== this.state.command.name.trim());
  }
  loadPipelineTemplates() {
    if (SETTINGS.feature.pipelineTemplates) {
      this.setState({ loading: true });
      PipelineTemplateReader.getPipelineTemplatesByScopes([this.props.application.name, "global"]).then((templates) => {
        templates = uniqBy(templates, "id").filter(({ schema }) => schema !== "v2");
        this.setState({ templates, loading: false });
      }).catch((response) => {
        this.setState({
          loadError: true,
          loadErrorMessage: response && response.data && response.data.message || "No message provided",
          loading: false
        });
      }).finally(() => {
        if (!this.state.templates.length) {
          this.setState({ useManagedTemplate: false });
        }
      });
    }
  }
  loadPipelineTemplateFromSource(sourceUrl) {
    if (sourceUrl) {
      this.setState({ loadingTemplateFromSource: true, loadingTemplateFromSourceError: false });
      PipelineTemplateReader.getPipelineTemplateFromSourceUrl(sourceUrl).then((template) => this.state.command.template = template).catch(() => this.setState({ loadingTemplateFromSourceError: true })).finally(() => this.setState({ loadingTemplateFromSource: false }));
    }
  }
  render() {
    const { preselectedTemplate } = this.props;
    const hasSelectedATemplate = this.state.useTemplate || preselectedTemplate;
    const nameHasError = !this.validateNameCharacters();
    const nameIsNotUnique = !this.validateNameIsUnique();
    const formValid = !nameHasError && !nameIsNotUnique && this.state.command.name.length > 0 && (!this.state.useTemplate || !!this.state.command.template);
    return /* @__PURE__ */ React__default.createElement(Modal$1, {
      show: this.props.show,
      onHide: this.close,
      className: "create-pipeline-modal-overflow-visible",
      backdrop: "static"
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, {
      closeButton: true
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Create New ", this.state.command.strategy ? "Strategy" : "Pipeline")), this.state.loading && /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
      style: { height: "200px" }
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    })), !this.state.loading && /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, this.state.loadError && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-danger"
    }, /* @__PURE__ */ React__default.createElement("p", null, "Could not load pipeline templates."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, "Reason: "), " ", this.state.loadErrorMessage), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.handleLoadErrorDismiss
    }, "[dismiss]"))), this.state.saveError && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-danger"
    }, /* @__PURE__ */ React__default.createElement("p", null, "Could not save pipeline."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, "Reason: "), " ", this.state.saveErrorMessage), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.handleSaveErrorDismiss
    }, "[dismiss]"))), !(this.state.saveError || this.state.loadError) && /* @__PURE__ */ React__default.createElement("form", {
      role: "form",
      name: "form",
      className: "clearfix",
      onSubmit: this.handleFormSubmit
    }, !preselectedTemplate && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Type")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      options: [
        { label: "Pipeline", value: false },
        { label: "Strategy", value: true }
      ],
      clearable: false,
      value: this.state.command.strategy ? { label: "Strategy" } : { label: "Pipeline" },
      onChange: this.handleTypeChange
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, this.state.command.strategy ? "Strategy" : "Pipeline", " Name")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: "form-control",
      value: this.state.command.name,
      onChange: this.handleNameChange,
      required: true,
      autoFocus: true
    }))), nameHasError && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group row slide-in"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-sm-9 col-sm-offset-3 error-message"
    }, /* @__PURE__ */ React__default.createElement("div", null, this.state.command.strategy ? "Strategy" : "Pipeline", " name cannot contain any of the following characters:"), /* @__PURE__ */ React__default.createElement("code", null, "/ \\ ? % #"))), nameIsNotUnique && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group row slide-in"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-sm-9 col-sm-offset-3 error-message"
    }, /* @__PURE__ */ React__default.createElement("span", null, "There is already a ", this.state.command.strategy ? "strategy" : "pipeline", " with that name."))), SETTINGS.feature.pipelineTemplates && !preselectedTemplate && !this.state.command.strategy && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Create From")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "radio-inline"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      checked: !this.state.useTemplate,
      onChange: this.handleUseTemplateSelection(false)
    }), "Pipeline"), /* @__PURE__ */ React__default.createElement("label", {
      className: "radio-inline"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      checked: this.state.useTemplate,
      onChange: this.handleUseTemplateSelection(true)
    }), "Template"))), this.state.configs.length > 1 && !this.state.command.strategy && !this.state.useTemplate && /* @__PURE__ */ React__default.createElement("div", null, SETTINGS.feature.pipelineTemplates && /* @__PURE__ */ React__default.createElement("hr", null), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Copy From")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      options: this.state.configOptions,
      clearable: false,
      value: { value: this.state.command.config.name, label: this.state.command.config.name },
      optionRenderer: this.configOptionRenderer,
      onChange: this.handleConfigChange,
      onSelectResetsInput: false
    })))), SETTINGS.feature.pipelineTemplates && hasSelectedATemplate && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("hr", null), this.state.templates.length > 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Template Source *"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "radio-inline"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      checked: this.state.useManagedTemplate,
      onChange: this.handleUseManagedTemplateSelection(true)
    }), "Managed Templates"), /* @__PURE__ */ React__default.createElement("label", {
      className: "radio-inline"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      checked: !this.state.useManagedTemplate,
      onChange: this.handleUseManagedTemplateSelection(false)
    }), "URL"))), this.state.useManagedTemplate && !preselectedTemplate && /* @__PURE__ */ React__default.createElement(ManagedTemplateSelector, {
      templates: this.state.templates,
      onChange: this.handleTemplateSelection,
      selectedTemplate: this.state.command.template
    }), !this.state.useManagedTemplate && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, this.state.templates.length === 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Source URL"), /* @__PURE__ */ React__default.createElement("div", {
      className: this.state.templates.length ? "col-md-7 col-md-offset-3" : "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: "form-control",
      value: this.state.templateSourceUrl,
      onChange: this.handleSourceUrlChange
    }))), /* @__PURE__ */ React__default.createElement(TemplateDescription, {
      loading: this.state.loadingTemplateFromSource,
      loadingError: this.state.loadingTemplateFromSourceError,
      template: this.state.command.template || preselectedTemplate
    }), !preselectedTemplate && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("em", null, "* v1 templates only. For creating pipelines from v2 templates, use the", " ", /* @__PURE__ */ React__default.createElement(UISref, {
      to: "home.pipeline-templates"
    }, /* @__PURE__ */ React__default.createElement("a", null, "Pipeline Templates view.")))))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement(Button$1, {
      onClick: this.close
    }, "Cancel"), SETTINGS.feature.pipelineTemplates && hasSelectedATemplate && /* @__PURE__ */ React__default.createElement(SubmitButton, {
      label: "Continue",
      submitting: this.state.submitting,
      isDisabled: !formValid || this.state.submitting || this.state.saveError || this.state.loading,
      onClick: this.submitPipelineTemplateConfig
    }), !hasSelectedATemplate && /* @__PURE__ */ React__default.createElement(SubmitButton, {
      label: "Create",
      onClick: this.submit,
      submitting: this.state.submitting,
      isDisabled: !formValid || this.state.submitting || this.state.saveError || this.state.loading
    })));
  }
};
CreatePipelineModal.defaultProps = {
  preselectedTemplate: null
};
__decorateClass$l([
  Debounce(200)
], CreatePipelineModal.prototype, "loadPipelineTemplateFromSource", 1);
CreatePipelineModal = __decorateClass$l([
  Overridable("core.pipeline.CreatePipelineModal")
], CreatePipelineModal);

class ExecutionInformationService {
  constructor() {
    this.getExecution = async (executionId) => {
      if (this.calledExecutions.hasOwnProperty(executionId)) {
        return this.calledExecutions[executionId];
      }
      return REST("/pipelines").path(executionId).get().then((execution) => {
        this.calledExecutions[executionId] = execution;
        ExecutionsTransformer.processStageSummaries(execution);
        return execution;
      });
    };
    this.getAllParentExecutions = (execution) => {
      const executions = [];
      executions.push(execution);
      if (execution.trigger.parentExecution) {
        executions.push(...this.getAllParentExecutions(execution.trigger.parentExecution));
      }
      return executions;
    };
    this.getPipelineConfig = async (application, pipelineConfigId) => {
      let pipelineConfig;
      if (this.calledPipelineConfigs.hasOwnProperty(application)) {
        pipelineConfig = this.calledPipelineConfigs[application].find((config) => config.id === pipelineConfigId);
        Promise.resolve(pipelineConfig);
      }
      return REST("/applications").path(application, "pipelineConfigs").get().then((pipelineConfigs) => {
        this.calledPipelineConfigs[application] = pipelineConfigs;
        return this.calledPipelineConfigs[application].find((config) => config.id === pipelineConfigId);
      });
    };
    if (!ExecutionInformationService.instance) {
      this.calledExecutions = {};
      this.calledPipelineConfigs = {};
      ExecutionInformationService.instance = this;
    }
    return ExecutionInformationService.instance;
  }
}

const ExecutionBreadcrumbs = ({ execution }) => {
  const parentExecutions = React__default.useMemo(() => {
    return new ExecutionInformationService().getAllParentExecutions(execution).filter((x) => x !== execution).reverse();
  }, [execution]);
  const label = parentExecutions.length === 1 ? "Parent Execution" : "Parent Executions";
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, label, ": "), parentExecutions.map((execution2, index, array) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
    key: execution2.id
  }, /* @__PURE__ */ React__default.createElement(ExecutionPermaLink, {
    execution: execution2
  }), index !== array.length - 1 && /* @__PURE__ */ React__default.createElement("i", {
    className: "fas fa-angle-right execution-breadcrumb-marker"
  }))));
};
function ExecutionPermaLink({ execution }) {
  const { application, id: executionId } = execution;
  const { state } = useCurrentStateAndParams();
  const isProject = state.name.includes(".project.");
  const executionDetails = `home.${isProject ? "project." : "applications."}application.pipelines.executionDetails`;
  const toState = executionDetails + ".execution";
  const srefParams = { application, executionId };
  const srefOptions = { reload: executionDetails };
  const sref = useSref(toState, srefParams, srefOptions);
  const handleClick = (e) => {
    logger.log({ category: "Pipeline", action: "Execution build number clicked - parent pipeline" });
    sref.onClick(e);
  };
  return /* @__PURE__ */ React__default.createElement("a", {
    href: sref.href,
    onClick: handleClick,
    style: { display: "inline" },
    className: "execution-build-number clickable"
  }, execution.name);
}

class PipelineGraphLink extends React__default.Component {
  render() {
    const { link, x, y } = this.props;
    const { child, isHighlighted, parent } = link;
    const className = classNames("link", {
      highlighted: isHighlighted,
      active: child.isActive || parent.isActive,
      target: !child.executionStage && child.isActive,
      source: !child.executionStage && !child.isActive,
      "has-status": child.executionStage,
      [`${(child.status || "").toLowerCase()}`]: child.executionStage && child.hasNotStarted,
      [`${(parent.status || "").toLowerCase()}`]: child.executionStage && !child.hasNotStarted
    });
    return /* @__PURE__ */ React__default.createElement("path", {
      d: link.line,
      className,
      transform: `translate(${0 - x}, ${0 - y})`
    });
  }
}

class Popover extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onEntering = (element) => {
      const { onEnter } = this.props;
      if (onEnter) {
        onEnter(element);
      }
    };
  }
  render() {
    const { value, template, placement, children } = this.props;
    let popover = /* @__PURE__ */ React__default.createElement(Popover$1, {
      id: value
    }, /* @__PURE__ */ React__default.createElement(Markdown, {
      message: value
    }));
    if (template) {
      popover = /* @__PURE__ */ React__default.createElement(Popover$1, {
        id: value
      }, template);
    }
    return /* @__PURE__ */ React__default.createElement(OverlayTrigger, {
      onEntering: this.onEntering,
      placement,
      overlay: popover
    }, children);
  }
}
Popover.defaultProps = {
  placement: "top",
  value: ""
};

var css_248z$1j = ".group-execution-label-list {\n  list-style-type: none;\n  padding: 3px 10px 0 10px;\n  max-height: 185px;\n  overflow-y: auto;\n}\n.group-execution-label-list > a,\n.group-execution-label-list > a:hover,\n.group-execution-label-list > a:visited {\n  text-decoration: none;\n  color: inherit;\n}\n.group-execution-label-list li {\n  font-size: 13px;\n}\n.group-execution-label-list li div {\n  display: flex;\n  padding: 3px;\n}\n.group-execution-label-list li > :hover {\n  background-color: var(--color-primary-g1);\n}\n.group-execution-label-list li span + span {\n  padding-left: 20px;\n}\n.group-execution-label-list li .stage-status {\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  border-radius: 15px;\n  margin-right: 7px;\n  margin-top: 2px;\n}\n.group-execution-label-list a:first-child > li {\n  border-top: none;\n}\n.group-stages-list-popover {\n  background-color: var(--color-primary) !important;\n}\n.group-stages-list-popover .popover-content,\n.group-stages-list-popover.inverse {\n  background-color: var(--color-primary);\n  color: var(--color-white);\n  padding: 5px;\n}\n.group-stages-list-popover.top > div.arrow:after {\n  border-top-color: var(--color-primary);\n}\n.group-stages-list-popover.bottom > div.arrow:after {\n  border-bottom-color: var(--color-primary);\n}\n.group-stages-list-popover .group-name {\n  color: var(--color-accessory);\n  border-bottom: 1px var(--color-accessory-light) solid;\n  margin: 5px 10px 7px 10px;\n}\n.marker-group-icon {\n  display: inline-block;\n  vertical-align: middle;\n}\n.marker-group-icon svg {\n  fill: var(--color-text-secondary);\n}\n";
styleInject(css_248z$1j);

class GroupedStageListItem extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onClick = () => {
      if (this.props.stageClicked) {
        this.props.stageClicked(this.props.stage);
      }
    };
  }
  render() {
    const { stage } = this.props;
    const markerClassName = [
      "clickable",
      "stage-status",
      "execution-marker",
      `stage-type-${stage.type.toLowerCase()}`,
      `execution-marker-${stage.status.toLowerCase()}`,
      stage.isRunning ? "glowing" : ""
    ].join(" ");
    return /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.onClick,
      className: "clickable"
    }, /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: markerClassName
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "stage-name"
    }, stage.name))));
  }
}
class GroupExecutionPopover extends React__default.Component {
  constructor() {
    super(...arguments);
    this.subStageClicked = (subStage) => {
      if (this.props.subStageClicked) {
        this.props.subStageClicked(this.props.stage, subStage);
      }
    };
  }
  render() {
    const { stage, width, svgMode } = this.props;
    const template = /* @__PURE__ */ React__default.createElement("div", {
      style: { maxWidth: width - 30 + "px" }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "group-name"
    }, stage.name.toUpperCase()), /* @__PURE__ */ React__default.createElement("ul", {
      className: "group-execution-label-list"
    }, stage.groupStages.map((s) => /* @__PURE__ */ React__default.createElement(GroupedStageListItem, {
      key: s.name,
      stage: s,
      stageClicked: this.subStageClicked
    }))));
    return /* @__PURE__ */ React__default.createElement(HoverablePopover, {
      className: "group-stages-list-popover",
      svgMode,
      delayHide: 50,
      placement: "bottom",
      template
    }, this.props.children);
  }
}

class PipelineGraphNode extends React__default.Component {
  constructor() {
    super(...arguments);
    this.highlight = () => {
      this.props.highlight(this.props.node, true);
    };
    this.removeHighlight = () => {
      this.props.highlight(this.props.node, false);
    };
    this.handleClick = () => {
      logger.log({
        category: `Pipeline Graph (${this.props.isExecution ? "execution" : "config"})`,
        action: `Node clicked`
      });
      this.props.nodeClicked(this.props.node);
    };
    this.subStageClicked = (groupStage, stage) => {
      logger.log({
        category: `Pipeline Graph (${this.props.isExecution ? "execution" : "config"})`,
        action: `Grouped stage clicked`
      });
      this.props.nodeClicked(groupStage, stage.index);
    };
  }
  render() {
    const { labelOffsetX, labelOffsetY, maxLabelWidth, nodeRadius, node } = this.props;
    const isGroup = node.stage && node.stage.type === "group";
    let stageType = get(node, ["masterStage", "type"], void 0);
    stageType = stageType || get(node, ["stage", "activeStageType"], "");
    const circleClassName = classNames(`stage-type-${stageType.toLowerCase()}`, "execution-marker", `execution-marker-${(node.status || "").toLowerCase()}`, "graph-node", {
      active: node.isActive,
      clickable: !isGroup
    });
    const warningsPopover = /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", null, "The following errors may affect the ability to run this pipeline:"), /* @__PURE__ */ React__default.createElement("ul", null, node.hasWarnings && node.warnings.messages.map((message) => /* @__PURE__ */ React__default.createElement("li", {
      key: message
    }, /* @__PURE__ */ React__default.createElement(Markdown, {
      message,
      trim: true
    })))));
    let GraphNode = /* @__PURE__ */ React__default.createElement("g", null, isGroup && /* @__PURE__ */ React__default.createElement("path", {
      className: circleClassName,
      fillOpacity: !node.isActive && node.executionStage ? 0.4 : 1,
      transform: "translate(-7,-9)",
      d: "M8 9l-8-4 8-4 8 4zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z"
    }), !isGroup && /* @__PURE__ */ React__default.createElement("circle", {
      r: nodeRadius,
      className: circleClassName,
      fillOpacity: !node.isActive && node.executionStage ? 0.4 : 1
    }), (node.root || node.leaf) && !node.executionStage && !isGroup && /* @__PURE__ */ React__default.createElement("rect", {
      transform: node.root ? `translate(${nodeRadius * -1},${nodeRadius * -1})` : `translate(0,${nodeRadius * -1})`,
      className: circleClassName,
      height: nodeRadius * 2,
      width: nodeRadius
    }));
    if (node.hasWarnings) {
      GraphNode = /* @__PURE__ */ React__default.createElement(Popover, {
        placement: "bottom",
        template: warningsPopover
      }, GraphNode);
    }
    let GraphLabel = node.labelComponent ? /* @__PURE__ */ React__default.createElement("div", {
      className: `execution-stage-label ${!isGroup ? "clickable" : "stage-group"} ${(node.status || "").toLowerCase()}`
    }, /* @__PURE__ */ React__default.createElement(LabelComponent, {
      stage: node.stage
    })) : /* @__PURE__ */ React__default.createElement("div", {
      className: `label-body node ${!isGroup ? "clickable" : ""}`
    }, /* @__PURE__ */ React__default.createElement("a", null, node.name));
    GraphLabel = /* @__PURE__ */ React__default.createElement("g", {
      transform: `translate(${labelOffsetX}, ${node.leaf && !node.executionStage ? -8 : labelOffsetY * -1})`
    }, /* @__PURE__ */ React__default.createElement("foreignObject", {
      width: maxLabelWidth,
      height: node.height
    }, GraphLabel));
    let NodeContents = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, GraphNode, GraphLabel);
    if (node.stage && node.stage.type === "group") {
      NodeContents = /* @__PURE__ */ React__default.createElement(GroupExecutionPopover, {
        stage: node.stage,
        subStageClicked: this.subStageClicked,
        width: maxLabelWidth,
        svgMode: true
      }, NodeContents);
    }
    return /* @__PURE__ */ React__default.createElement("g", {
      onMouseEnter: this.highlight,
      onMouseLeave: this.removeHighlight,
      onClick: this.handleClick,
      style: { cursor: "pointer", pointerEvents: "all" }
    }, NodeContents);
  }
}

class PipelineGraphService {
  static generateExecutionGraph(execution, viewState) {
    const nodes = [];
    (execution.stageSummaries || []).forEach((stage, idx) => {
      const parentIds = (stage.requisiteStageRefIds || []).slice();
      const node = {
        childLinks: [],
        children: [],
        executionStage: true,
        extraLabelLines: stage.extraLabelLines ? stage.extraLabelLines(stage) : 0,
        graphRowOverride: stage.graphRowOverride || 0,
        hasNotStarted: stage.hasNotStarted,
        id: stage.refId,
        index: idx,
        isActive: viewState.activeStageId === stage.index,
        isHighlighted: false,
        labelComponent: stage.labelComponent,
        masterStage: stage.masterStage,
        name: stage.name,
        parentIds,
        parentLinks: [],
        parents: [],
        stage,
        status: stage.status
      };
      if (!node.parentIds.length) {
        node.root = true;
      }
      nodes.push(node);
    });
    return nodes;
  }
  static generateConfigGraph(pipeline, viewState, pipelineValidations) {
    const nodes = [];
    const configWarnings = pipelineValidations.pipeline;
    const configNode = {
      childLinks: [],
      children: [],
      hasWarnings: !!configWarnings.length,
      id: -1,
      isActive: viewState.section === "triggers",
      isHighlighted: false,
      name: "Configuration",
      parentIds: [],
      parentLinks: [],
      parents: [],
      phase: 0,
      root: true,
      section: "triggers",
      warnings: configWarnings.length ? { messages: configWarnings } : null
    };
    nodes.push(configNode);
    pipeline.stages.forEach(function(stage, idx) {
      const warnings = pipelineValidations.stages.find((e) => e.stage === stage);
      const parentIds = (stage.requisiteStageRefIds || []).slice();
      const node = {
        childLinks: [],
        children: [],
        graphRowOverride: stage.graphRowOverride || 0,
        hasWarnings: !!warnings,
        id: stage.refId,
        index: idx,
        isActive: viewState.stageIndex === idx && viewState.section === "stage",
        isHighlighted: false,
        name: stage.name || "[new stage]",
        parentIds,
        parentLinks: [],
        parents: [],
        root: false,
        section: "stage",
        warnings
      };
      if (!node.parentIds.length) {
        node.parentIds.push(configNode.id);
      }
      nodes.push(node);
    });
    return nodes;
  }
}
PipelineGraphService.xScrollOffset = {};

var css_248z$1i = ".pipeline-config-graph svg g.active circle,\n.pipeline-config-graph svg g.highlighted circle,\n.pipeline-config-graph svg g.active rect,\n.pipeline-config-graph svg g.highlighted rect {\n  fill: var(--color-success);\n}\npipeline-graph,\n.pipeline-graph {\n  display: block;\n  overflow-x: auto;\n}\npipeline-graph .pipeline-loading,\n.pipeline-graph .pipeline-loading {\n  padding: 0px 0px 10px 0px;\n}\npipeline-graph svg path.link,\n.pipeline-graph svg path.link {\n  fill: none;\n  transition: stroke 0.2s, stroke-width 0.2s;\n  stroke: var(--color-alto);\n  stroke-width: 1px;\n  stroke-opacity: 0.3;\n}\npipeline-graph svg path.link.active,\n.pipeline-graph svg path.link.active,\npipeline-graph svg path.link.highlighted,\n.pipeline-graph svg path.link.highlighted {\n  stroke-opacity: 1;\n}\npipeline-graph svg path.link.active.has-status,\n.pipeline-graph svg path.link.active.has-status,\npipeline-graph svg path.link.highlighted.has-status,\n.pipeline-graph svg path.link.highlighted.has-status {\n  stroke-width: 4px;\n}\npipeline-graph svg path.link.active,\n.pipeline-graph svg path.link.active {\n  stroke-width: 4px;\n}\npipeline-graph svg path.link.active.target,\n.pipeline-graph svg path.link.active.target {\n  stroke: var(--color-success-light);\n}\npipeline-graph svg path.link.active.source,\n.pipeline-graph svg path.link.active.source {\n  stroke: var(--color-accent);\n}\npipeline-graph svg path.link.highlighted,\n.pipeline-graph svg path.link.highlighted {\n  stroke-width: 2.5px;\n}\npipeline-graph svg path.link.highlighted.target,\n.pipeline-graph svg path.link.highlighted.target {\n  stroke: var(--color-success-light);\n}\npipeline-graph svg path.link.highlighted.source,\n.pipeline-graph svg path.link.highlighted.source {\n  stroke: var(--color-accent-g1);\n}\npipeline-graph svg path.link.highlighted.has-status,\n.pipeline-graph svg path.link.highlighted.has-status {\n  stroke-width: 4px;\n}\npipeline-graph svg path.link.running,\n.pipeline-graph svg path.link.running {\n  stroke: var(--color-accent);\n}\npipeline-graph svg path.link.failed,\n.pipeline-graph svg path.link.failed {\n  stroke: var(--color-danger);\n}\npipeline-graph svg path.link.completed,\n.pipeline-graph svg path.link.completed {\n  stroke: var(--color-success);\n}\npipeline-graph svg path.link.not_started,\n.pipeline-graph svg path.link.not_started,\npipeline-graph svg path.link.suspended,\n.pipeline-graph svg path.link.suspended,\npipeline-graph svg path.link.canceled,\n.pipeline-graph svg path.link.canceled,\npipeline-graph svg path.link.unknown,\n.pipeline-graph svg path.link.unknown {\n  stroke: var(--color-alto);\n}\npipeline-graph svg g rect,\n.pipeline-graph svg g rect {\n  fill: var(--color-alto);\n}\npipeline-graph svg g .label-component,\n.pipeline-graph svg g .label-component {\n  transition: all 0.1s;\n  display: inline-block;\n}\npipeline-graph svg g.active circle,\n.pipeline-graph svg g.active circle,\npipeline-graph svg g.highlighted circle,\n.pipeline-graph svg g.highlighted circle,\npipeline-graph svg g.active rect,\n.pipeline-graph svg g.active rect,\npipeline-graph svg g.highlighted rect,\n.pipeline-graph svg g.highlighted rect,\npipeline-graph svg g.active path.graph-node,\n.pipeline-graph svg g.active path.graph-node,\npipeline-graph svg g.highlighted path.graph-node,\n.pipeline-graph svg g.highlighted path.graph-node {\n  transition: fill 0.2s;\n}\npipeline-graph svg g.active.has-status circle.graph-node,\n.pipeline-graph svg g.active.has-status circle.graph-node,\npipeline-graph svg g.highlighted.has-status circle.graph-node,\n.pipeline-graph svg g.highlighted.has-status circle.graph-node,\npipeline-graph svg g.active.has-status path.graph-node,\n.pipeline-graph svg g.active.has-status path.graph-node,\npipeline-graph svg g.highlighted.has-status path.graph-node,\n.pipeline-graph svg g.highlighted.has-status path.graph-node {\n  fill-opacity: 1;\n  stroke-width: 1px;\n  stroke: var(--color-dovegray);\n}\npipeline-graph svg g.warning circle,\n.pipeline-graph svg g.warning circle,\npipeline-graph svg g.warning rect,\n.pipeline-graph svg g.warning rect {\n  fill: var(--color-danger);\n}\npipeline-graph svg g a,\n.pipeline-graph svg g a {\n  color: var(--color-mineshaft);\n}\npipeline-graph svg g a:hover,\n.pipeline-graph svg g a:hover {\n  color: var(--color-mineshaft);\n  font-weight: 600;\n  letter-spacing: 0;\n  text-decoration: none;\n}\npipeline-graph svg g div.execution-stage-label,\n.pipeline-graph svg g div.execution-stage-label {\n  color: var(--color-dovegray);\n  font-weight: 400;\n  padding: 0 5px 0 0;\n  border: 2px solid transparent;\n  min-height: 25px;\n}\npipeline-graph svg g div.label-body,\n.pipeline-graph svg g div.label-body,\npipeline-graph svg g div.execution-stage-label,\n.pipeline-graph svg g div.execution-stage-label {\n  line-height: 17px;\n  text-shadow: 0 1px 0 var(--color-white), 1px 0 0 var(--color-white), 0 -1px 0 var(--color-white), -1px 0 0 var(--color-white);\n  word-wrap: break-word;\n  transition: color 0.2s;\n  letter-spacing: 0.015em;\n}\npipeline-graph svg g.active div.label-body,\n.pipeline-graph svg g.active div.label-body,\npipeline-graph svg g.highlighted div.label-body,\n.pipeline-graph svg g.highlighted div.label-body {\n  color: var(--color-mineshaft);\n  font-weight: 600;\n  letter-spacing: 0;\n}\npipeline-graph svg g.active div.execution-stage-label,\n.pipeline-graph svg g.active div.execution-stage-label,\npipeline-graph svg g.highlighted div.execution-stage-label,\n.pipeline-graph svg g.highlighted div.execution-stage-label {\n  font-weight: 600;\n  letter-spacing: 0;\n  margin-left: -12px;\n  padding-left: 12px;\n}\npipeline-graph svg g.active div.execution-stage-label .label-component,\n.pipeline-graph svg g.active div.execution-stage-label .label-component,\npipeline-graph svg g.highlighted div.execution-stage-label .label-component,\n.pipeline-graph svg g.highlighted div.execution-stage-label .label-component {\n  padding: 3px;\n  margin: -3px;\n  color: var(--color-white);\n  background-color: var(--color-accent);\n  border-radius: 2px;\n  text-shadow: none;\n}\npipeline-graph svg g.highlighted div.label-body,\n.pipeline-graph svg g.highlighted div.label-body {\n  font-weight: 400;\n  letter-spacing: 0.015em;\n}\nsvg.pipeline-graph:not(:root) {\n  overflow: visible;\n}\n.stage-group .label-component {\n  cursor: default;\n}\n.execution-graph {\n  margin: 0 20px;\n  padding: 10px 10px 20px 10px;\n  background-color: var(--color-cirrus);\n  border: 1px solid var(--color-alto);\n  border-top: none;\n}\n";
styleInject(css_248z$1i);

var __defProp$k = Object.defineProperty;
var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
var __decorateClass$k = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$k(target, key, result);
  return result;
};
class PipelineGraph extends React__default.Component {
  constructor(props) {
    super(props);
    this.defaultNodeRadius = 8;
    this.defaultState = {
      allNodes: [],
      graphHeight: 0,
      graphWidth: "",
      labelOffsetX: this.defaultNodeRadius + 3,
      labelOffsetY: this.defaultNodeRadius + 10,
      maxLabelWidth: 0,
      nodeRadius: this.defaultNodeRadius,
      phaseCount: 0,
      rowHeights: [],
      showGraph: true,
      loading: false
    };
    this.graphVerticalPadding = 11;
    this.minExecutionGraphHeight = 40;
    this.minLabelWidth = 100;
    this.pipelineValidations = { pipeline: [], stages: [] };
    this.rowPadding = 20;
    this.windowResize = this.handleWindowResize.bind(this);
    this.expandPipelineStageThreshold = SETTINGS.feature.renderPipelineStageThreshold;
    this.highlight = (node, highlight) => {
      if (node.isActive) {
        return;
      }
      node.isHighlighted = highlight;
      node.parentLinks.forEach((link) => link.isHighlighted = highlight);
      node.childLinks.forEach((link) => link.isHighlighted = highlight);
      this.applyAllNodes(this.state);
    };
    this.handleWheel = (e) => {
      if (this.props.execution) {
        PipelineGraphService.xScrollOffset[this.props.execution.id] = e.target.parentElement.scrollLeft;
      }
    };
    this.refCallback = (element) => {
      if (element) {
        this.element = $$1(element);
      }
    };
    const { execution } = props;
    this.state = this.defaultState;
    this.handleExpandSectionClick = this.handleExpandSectionClick.bind(this);
    if (execution) {
      this.graphStatusHash = execution.graphStatusHash;
    }
  }
  handleWindowResize() {
    this.updateGraph(this.props);
  }
  curvedLink(d) {
    const sourceX = d.source.x + this.state.nodeRadius;
    const targetX = d.target.x - this.state.nodeRadius;
    const curve = (sourceX + targetX) / 2;
    return `M${sourceX},${d.source.y}C${curve},${d.source.y} ${curve},${d.target.y} ${targetX},${d.target.y}`;
  }
  getLastPhase(node) {
    if (!node.children.length) {
      return node.phase;
    }
    const checkedNodeIds = new Set();
    const result = [];
    this.collect(node.children, result, checkedNodeIds);
    return max(result);
  }
  collect(nodes, result, checkedNodeIds) {
    nodes.forEach((node) => {
      if (checkedNodeIds.has(node.id)) {
        return;
      } else {
        checkedNodeIds.add(node.id);
      }
      if (node.children.length) {
        this.collect(node.children, result, checkedNodeIds);
      } else {
        result.push(node.phase);
      }
    });
  }
  createNodes(props) {
    const { execution, pipeline, viewState } = props;
    return pipeline ? PipelineGraphService.generateConfigGraph(pipeline, viewState, this.pipelineValidations) : PipelineGraphService.generateExecutionGraph(execution, viewState);
  }
  applyPhasesAndLink(props, nodes, newState) {
    nodes = nodes || this.createNodes(props);
    let allPhasesResolved = true;
    nodes.forEach((node) => {
      let phaseResolvable = true;
      let phase = 0;
      if (!node.parentIds.length) {
        node.phase = phase;
      } else {
        node.parentIds.forEach((parentId) => {
          const parent = find(nodes, { id: parentId });
          if (parent && parent.phase !== void 0) {
            phase = Math.max(phase, parent.phase);
            parent.children.push(node);
            node.parents.push(parent);
          } else {
            phaseResolvable = false;
          }
        });
        if (phaseResolvable) {
          node.phase = phase + 1;
        } else {
          allPhasesResolved = false;
        }
      }
    });
    if (!allPhasesResolved) {
      return this.applyPhasesAndLink(props, nodes, newState);
    } else {
      const highestPhaseNode = maxBy(nodes, "phase");
      newState.phaseCount = highestPhaseNode ? highestPhaseNode.phase : 0;
      if (newState.phaseCount > 6) {
        newState.nodeRadius = 6;
        newState.labelOffsetX = newState.nodeRadius + 3;
        newState.labelOffsetY = 15;
      }
      const groupedNodes = [];
      nodes.forEach((node) => {
        node.children = uniq(node.children);
        node.parents = uniq(node.parents);
        node.leaf = node.children.length === 0;
      });
      nodes.forEach((node) => node.lastPhase = this.getLastPhase(node));
      const grouped = groupBy(nodes, "phase");
      forOwn(grouped, (group, phase) => {
        const sortedPhase = sortBy(group, (node) => {
          if (node.parents.length) {
            const parents = sortBy(node.parents, (parent) => 1 - parent.phase, (parent) => parent.row);
            const firstParent = parents[0];
            return firstParent.phase * 100 + firstParent.row;
          }
          return 0;
        }, (node) => node.graphRowOverride ? node.graphRowOverride : 1e3, (node) => 1 - node.lastPhase, (node) => node.children.filter((child) => !child.children.length).length || 100, (node) => node.parents.length, (node) => 1 - node.children.length, (node) => 1 - sumBy(node.children, (child) => child.children.length), (node) => sortBy(node.children, "phase").map((child) => [child.phase - node.phase, child.name].join("-")).join(":"), (node) => Number.isNaN(Number(node.id)) ? Number.MAX_SAFE_INTEGER : Number(node.id), ["id"]);
        sortedPhase.forEach((node, index) => {
          node.row = index;
        });
        groupedNodes[phase] = sortedPhase;
      });
      this.fixOverlaps(groupedNodes);
      return groupedNodes;
    }
  }
  fixOverlaps(nodes) {
    nodes.forEach((column) => {
      column.forEach((node) => {
        const nonImmediateChildren = node.children.filter((c) => c.phase - node.phase > 1 && c.row === node.row);
        nonImmediateChildren.forEach((child) => {
          for (let phase = node.phase + 1; phase < child.phase; phase++) {
            if (nodes[phase].length >= node.row) {
              nodes[phase].splice(node.row, 0, this.createPlaceholderNode(node.row, phase));
              nodes[phase].forEach((n, index) => {
                n.row = index;
              });
            }
          }
        });
      });
    });
  }
  createPlaceholderNode(row, phase) {
    return {
      childLinks: [],
      children: [],
      id: UUIDGenerator.generateUuid(),
      isActive: false,
      isHighlighted: false,
      name: "",
      parentIds: [],
      parentLinks: [],
      parents: [],
      phase,
      placeholder: true,
      row
    };
  }
  applyPhaseWidth(props, newState) {
    const phaseOffset = 2 * newState.nodeRadius + newState.labelOffsetX;
    newState.maxLabelWidth = this.element.width() - 2 * newState.nodeRadius;
    if (newState.phaseCount) {
      newState.maxLabelWidth = newState.maxLabelWidth / (newState.phaseCount + 1) - phaseOffset;
    }
    newState.maxLabelWidth = Math.max(this.minLabelWidth, newState.maxLabelWidth);
    if (newState.maxLabelWidth === this.minLabelWidth) {
      newState.graphWidth = (newState.phaseCount + 1) * (newState.maxLabelWidth + phaseOffset) + 5 + "px";
    } else {
      newState.graphWidth = "100%";
    }
    if (props.execution) {
      const offsetForId = PipelineGraphService.xScrollOffset[props.execution.id] || 0;
      this.element.scrollLeft(offsetForId);
    }
  }
  applyNodeHeights(groupedNodes, newState) {
    const placeholderNode = this.element.find("g.placeholder div");
    placeholderNode.width(newState.maxLabelWidth);
    let graphHeight = 0;
    groupedNodes.forEach((nodes) => {
      nodes.forEach((node) => {
        const extraLines = node.extraLabelLines ? "<div>x</div>".repeat(node.extraLabelLines) : "";
        placeholderNode.html(`<a href>${DOMPurify.sanitize(node.name)}${extraLines}</a>`);
        node.height = placeholderNode.height() + this.rowPadding;
      });
      graphHeight = Math.max(sumBy(nodes, "height"), graphHeight);
    });
    placeholderNode.empty();
    newState.graphHeight += 3 * this.graphVerticalPadding;
  }
  setNodePositions(groupedNodes, newState) {
    groupedNodes.forEach((nodes, idx) => {
      let nodeOffset = this.graphVerticalPadding;
      nodes.forEach((node, rowNumber) => {
        node.x = (newState.maxLabelWidth + 2 * newState.nodeRadius + newState.labelOffsetX) * idx;
        node.y = nodeOffset;
        nodeOffset += newState.rowHeights[rowNumber];
      });
    });
  }
  createLinks(newState) {
    newState.allNodes.forEach((node) => {
      node.children.forEach((child) => {
        this.linkNodes(child, node);
      });
    });
  }
  linkNodes(child, parent) {
    const link = {
      parent,
      child,
      line: this.curvedLink({ source: parent, target: child })
    };
    parent.childLinks.push(link);
    child.parentLinks.push(link);
  }
  applyAllNodes(newState) {
    const highlightedNodeIndex = newState.allNodes.findIndex((node) => node.isHighlighted);
    const activeNodeIndex = newState.allNodes.findIndex((node) => node.isActive);
    if (activeNodeIndex !== -1) {
      const node = newState.allNodes.splice(highlightedNodeIndex, 1)[0];
      newState.allNodes.push(node);
    }
    if (highlightedNodeIndex !== -1) {
      const node = newState.allNodes.splice(highlightedNodeIndex, 1)[0];
      newState.allNodes.push(node);
    }
    this.setState(newState);
  }
  establishRowHeights(groupedNodes, newState) {
    const rowHeights = [];
    groupedNodes.forEach((column) => {
      column.forEach((node, rowNumber) => {
        if (!rowHeights[rowNumber]) {
          rowHeights[rowNumber] = 0;
        }
        rowHeights[rowNumber] = Math.max(rowHeights[rowNumber], node.height);
      });
    });
    newState.rowHeights = rowHeights;
    newState.graphHeight = Math.max(sum(newState.rowHeights) + this.graphVerticalPadding, this.minExecutionGraphHeight);
  }
  updateGraph(props, expand = false, statesOnly = false) {
    let newState;
    const nodes = this.createNodes(props);
    const isConfigurePage = props.pipeline;
    if (this.expandPipelineStageThreshold && nodes.length > this.expandPipelineStageThreshold && !expand && !isConfigurePage) {
      newState = clone(this.defaultState);
      newState.showGraph = false;
    } else if (!statesOnly) {
      newState = clone(this.defaultState);
      const groupedNodes = this.applyPhasesAndLink(props, nodes, newState);
      this.applyPhaseWidth(props, newState);
      this.applyNodeHeights(groupedNodes, newState);
      this.establishRowHeights(groupedNodes, newState);
      this.setNodePositions(groupedNodes, newState);
      newState.allNodes = flatten(groupedNodes);
      this.createLinks(newState);
      newState.showGraph = true;
    } else {
      newState = { allNodes: this.state.allNodes };
      newState.allNodes.forEach((node) => this.resetLinks(props, node));
      newState.showGraph = true;
    }
    this.applyAllNodes(newState);
  }
  handleExpandSectionClick() {
    const newState = clone(this.defaultState);
    newState.loading = true;
    newState.showGraph = false;
    this.setState(newState);
  }
  resetLinks(props, node) {
    const { activeStageId, section, stageIndex } = props.viewState;
    if (props.execution) {
      node.isActive = activeStageId === node.index;
    } else {
      if (node.section === "triggers") {
        node.isActive = section === node.section;
      } else {
        node.isActive = stageIndex === node.index && section === "stage";
      }
    }
    node.isHighlighted = false;
    node.parentLinks.forEach((link) => link.isHighlighted = false);
    node.childLinks.forEach((link) => link.isHighlighted = false);
  }
  componentDidMount() {
    window.addEventListener("resize", this.windowResize);
    this.validationSubscription = PipelineConfigValidator.subscribe((validations) => {
      this.pipelineValidations = validations;
      this.updateGraph(this.props);
    });
    this.updateGraph(this.props);
  }
  validatePipeline(pipeline) {
    PipelineConfigValidator.validatePipeline(pipeline).catch(() => {
    });
  }
  componentWillReceiveProps(nextProps) {
    let updateGraph = false;
    let stateOnly = true;
    if (nextProps.execution && this.graphStatusHash !== nextProps.execution.graphStatusHash || nextProps.execution !== this.props.execution) {
      this.graphStatusHash = nextProps.execution.graphStatusHash;
      updateGraph = true;
      stateOnly = false;
    }
    if (nextProps.pipeline !== this.props.pipeline) {
      updateGraph = true;
      stateOnly = false;
      if (this.props.shouldValidate) {
        this.validatePipeline(nextProps.pipeline);
      }
    }
    if (nextProps.viewState !== this.props.viewState) {
      updateGraph = true;
    }
    if (updateGraph) {
      this.updateGraph(nextProps, this.state.showGraph, stateOnly);
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    if (prevState.loading !== this.state.loading && this.state.loading == true) {
      const showGraph = true;
      setTimeout(() => {
        this.updateGraph(this.props, showGraph);
      });
    }
  }
  componentWillUnmount() {
    this.validationSubscription.unsubscribe();
    window.removeEventListener("resize", this.windowResize);
  }
  render() {
    const { execution } = this.props;
    const {
      allNodes,
      graphHeight,
      graphWidth,
      labelOffsetX,
      labelOffsetY,
      maxLabelWidth,
      nodeRadius,
      showGraph,
      loading
    } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "pipeline-graph",
      ref: this.refCallback,
      onWheel: this.handleWheel
    }, showGraph && /* @__PURE__ */ React__default.createElement("svg", {
      className: "pipeline-graph",
      style: {
        height: graphHeight,
        width: graphWidth,
        padding: this.graphVerticalPadding + "px " + nodeRadius * 2 + "px 0 " + nodeRadius * 2 + "px"
      }
    }, /* @__PURE__ */ React__default.createElement("g", {
      className: "placeholder"
    }, /* @__PURE__ */ React__default.createElement("foreignObject", {
      width: maxLabelWidth > 0 ? maxLabelWidth : 1,
      height: "200"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "label-body node active"
    }))), allNodes.map((node) => !node.placeholder && /* @__PURE__ */ React__default.createElement("g", {
      key: node.id,
      className: classNames({
        "has-status": !!node.status,
        active: node.isActive,
        highlighted: node.isHighlighted,
        warning: node.hasWarnings
      }),
      transform: `translate(${node.x},${node.y})`
    }, node.childLinks.map((link) => /* @__PURE__ */ React__default.createElement(PipelineGraphLink, {
      key: `${link.child.id}_${link.parent.name}`,
      link,
      x: node.x,
      y: node.y
    })), /* @__PURE__ */ React__default.createElement(PipelineGraphNode, {
      isExecution: !!execution,
      labelOffsetX,
      labelOffsetY,
      maxLabelWidth,
      nodeClicked: this.props.onNodeClick,
      highlight: this.highlight,
      nodeRadius,
      node
    })))), this.expandPipelineStageThreshold && !showGraph && (() => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, loading ? /* @__PURE__ */ React__default.createElement("div", {
      className: "pipeline-loading"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    })) : /* @__PURE__ */ React__default.createElement("p", null, "Pipeline graph not rendered to save resoures. Pipelines with more than " + this.expandPipelineStageThreshold + " stages are not rendered initially. ", /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.handleExpandSectionClick
    }, "Expand")), /* @__PURE__ */ React__default.createElement("svg", {
      className: "pipeline-graph",
      style: {
        height: "0",
        width: graphWidth
      }
    }, /* @__PURE__ */ React__default.createElement("g", {
      className: "placeholder"
    }, /* @__PURE__ */ React__default.createElement("foreignObject", {
      width: maxLabelWidth > 0 ? maxLabelWidth : 1,
      height: "200"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "label-body node active"
    }))))))());
  }
}
__decorateClass$k([
  Throttle(300)
], PipelineGraph.prototype, "handleWindowResize", 1);
__decorateClass$k([
  Debounce(300)
], PipelineGraph.prototype, "validatePipeline", 1);

var css_248z$1h = ".execution-parameters {\n  font-size: 0.8em;\n  line-height: 12px;\n  overflow: scroll;\n  margin-bottom: 10px;\n  padding-left: 1.2em;\n}\n.execution-parameters-column {\n  width: 50%;\n  float: left;\n}\n.params-title {\n  margin-top: 5px;\n  margin-bottom: 2px;\n  font-weight: 600;\n}\n.an-execution-parameter {\n  display: table-row;\n}\n.parameter-key {\n  display: table-cell;\n  color: var(--color-concrete);\n  padding: 1px 2px 1px 1px;\n}\n.parameter-value {\n  display: table-cell;\n  padding: 1px;\n  word-break: break-word;\n}\n.parameter-value .truncate-toggle {\n  padding: 0;\n  align-self: flex-start;\n  outline: none;\n  line-height: 30px;\n}\n";
styleInject(css_248z$1h);

var css_248z$1g = ".execution-status-section {\n  display: inline-block;\n  width: 180px;\n  overflow: hidden;\n  font-size: 0.8em;\n  line-height: 12px;\n}\n.execution-status-section .status {\n  line-height: 35px;\n  font-weight: bold;\n}\n.execution-status-section .execution-type,\n.execution-status-section .execution-build-number {\n  text-transform: uppercase;\n}\n.execution-status-section .execution-name,\n.execution-status-section .execution-type,\n.execution-status-section .execution-build-number {\n  font-weight: 600;\n}\n.execution-status-section .execution-dry-run {\n  font-style: italic;\n}\n.execution-status-section ul.trigger-details {\n  margin-bottom: 5px;\n}\n.execution-status-section h6,\n.execution-status-section h5,\n.execution-status-section h4 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.execution-status-section ul {\n  padding: 0;\n}\n.execution-status-section ul li {\n  list-style: none;\n}\n";
styleInject(css_248z$1g);

class ExecutionParameters extends React__default.Component {
  constructor(props) {
    super(props);
  }
  toggleParameterTruncation(parameter) {
    if (parameter.valueTruncated) {
      return () => {
        parameter.showTruncatedValue = !parameter.showTruncatedValue;
        this.forceUpdate();
      };
    }
    return null;
  }
  render() {
    const { shouldShowAllParams, displayableParameters, pinnedDisplayableParameters } = this.props;
    let parameters = pinnedDisplayableParameters;
    if (shouldShowAllParams) {
      parameters = displayableParameters;
    }
    if (!parameters.length) {
      return null;
    }
    const halfWay = Math.ceil(parameters.length / 2);
    const paramsSplitIntoColumns = [parameters.slice(0, halfWay), parameters.slice(halfWay)];
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-parameters"
    }, /* @__PURE__ */ React__default.createElement("h6", {
      className: "params-title"
    }, shouldShowAllParams && "Parameters"), /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-parameters-container"
    }, paramsSplitIntoColumns.map((c, i) => /* @__PURE__ */ React__default.createElement("div", {
      key: `execution-params-column-${i}`,
      className: "execution-parameters-column"
    }, c.map((p) => /* @__PURE__ */ React__default.createElement("div", {
      key: p.key,
      className: "an-execution-parameter"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "parameter-key"
    }, p.key, ":"), /* @__PURE__ */ React__default.createElement("div", {
      className: "parameter-value"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "vertical"
    }, /* @__PURE__ */ React__default.createElement("span", null, p.showTruncatedValue ? p.valueTruncated : p.value), p.valueTruncated && /* @__PURE__ */ React__default.createElement("button", {
      className: "link truncate-toggle",
      onClick: this.toggleParameterTruncation(p)
    }, p.showTruncatedValue ? " Show more" : " Show Less")))))))));
  }
}

var css_248z$1f = ".artifact-details {\n  text-overflow: ellipsis;\n  font-size: inherit;\n  line-height: 18px;\n  word-break: break-word;\n}\n.artifact-details dl {\n  margin: 0;\n}\n.artifact-detail {\n  display: inline-flex;\n  padding: 0.1px;\n}\n.artifact-detail .artifact-icon {\n  padding-right: 4px;\n}\n.artifact-detail dd,\n.artifact-detail dt {\n  display: inline;\n}\n.artifact-detail dt {\n  font-weight: normal;\n}\n.artifact-name {\n  padding-right: 2px;\n  float: left;\n}\n.artifact-version {\n  float: left;\n}\n";
styleInject(css_248z$1f);

class Artifact extends React__default.Component {
  tooltip(artifact, isDefault) {
    const tooltipEntries = [];
    if (isDefault) {
      tooltipEntries.push("Default Artifact");
    }
    if (artifact.name) {
      tooltipEntries.push(`Name: ${artifact.name}`);
    }
    if (artifact.type) {
      tooltipEntries.push(`Type: ${artifact.type}`);
    }
    if (artifact.version) {
      tooltipEntries.push(`Version: ${artifact.version}`);
    }
    if (artifact.reference) {
      tooltipEntries.push(`Reference: ${artifact.reference}`);
    }
    return tooltipEntries.join("\n");
  }
  render() {
    const { artifact, isDefault } = this.props;
    const { name, reference, version, type } = artifact;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "artifact-details"
    }, /* @__PURE__ */ React__default.createElement("dl", {
      title: this.tooltip(artifact, isDefault)
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "artifact-detail"
    }, /* @__PURE__ */ React__default.createElement("dt", null, ArtifactIconService.getPath(type) ? /* @__PURE__ */ React__default.createElement("img", {
      className: "artifact-icon",
      src: ArtifactIconService.getPath(type),
      width: "18",
      height: "18"
    }) : /* @__PURE__ */ React__default.createElement("span", null, "[", type, "] ")), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "artifact-name"
    }, name || reference), version && /* @__PURE__ */ React__default.createElement("div", {
      className: "artifact-version"
    }, " - ", version)))));
  }
}

var css_248z$1e = ".artifact-list ul {\n  padding: 0;\n}\n.artifact-list li {\n  list-style: none;\n  margin-bottom: 4px;\n}\n.resolved-artifacts {\n  font-size: 0.8em;\n  line-height: 12px;\n  margin-bottom: 10px;\n  padding-left: 1.2em;\n}\n.resolved-artifact-list {\n  display: inline-block;\n  width: 100%;\n  overflow-y: hidden;\n}\n.resolved-artifact-list .resolved-artifact-list::after {\n  clear: both;\n  content: '';\n}\n.artifacts-title {\n  margin-top: 5px;\n  margin-bottom: 2px;\n  font-weight: 600;\n}\n.artifact-list-column {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 50%;\n  float: left;\n}\n";
styleInject(css_248z$1e);

class ResolvedArtifactList extends React__default.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let { artifacts, resolvedExpectedArtifacts } = this.props;
    const { showingExpandedArtifacts } = this.props;
    artifacts = artifacts || [];
    resolvedExpectedArtifacts = resolvedExpectedArtifacts || [];
    const defaultArtifactRefs = resolvedExpectedArtifacts.reduce((set, rea) => {
      if (rea && rea.defaultArtifact && rea.defaultArtifact.reference) {
        set.add(rea.defaultArtifact.reference);
      }
      return set;
    }, new Set());
    const decoratedArtifacts = artifacts.filter(({ name: name2, reference, type }) => (name2 || reference) && type);
    const decoratedExpectedArtifacts = resolvedExpectedArtifacts.map((rea) => rea.boundArtifact).filter(({ name: name2, reference, type }) => (name2 || reference) && type);
    if (!showingExpandedArtifacts || decoratedArtifacts.length === 0 && decoratedExpectedArtifacts.length === 0) {
      return null;
    }
    if (!showingExpandedArtifacts) {
      return null;
    }
    const halfIndex = Math.ceil(decoratedArtifacts.length / 2);
    const columns = [decoratedArtifacts.slice(0, halfIndex), decoratedArtifacts.slice(halfIndex)];
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "resolved-artifacts"
    }, /* @__PURE__ */ React__default.createElement("h6", {
      className: "artifacts-title"
    }, "Artifacts"), /* @__PURE__ */ React__default.createElement("div", {
      className: "resolved-artifact-list"
    }, columns.map((artifactSubset, colNum) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        key: `artifact-list-column-${colNum}`,
        className: "artifact-list-column"
      }, artifactSubset.map((artifact, i) => {
        const { reference } = artifact;
        const isDefault = defaultArtifactRefs.has(reference);
        return /* @__PURE__ */ React__default.createElement("div", {
          key: `${i}-${name}`,
          className: "break-word"
        }, /* @__PURE__ */ React__default.createElement(Artifact, {
          artifact,
          isDefault
        }));
      }));
    })), decoratedArtifacts.length > decoratedExpectedArtifacts.length && /* @__PURE__ */ React__default.createElement("div", {
      className: "extraneous-artifacts"
    }, decoratedArtifacts.length - decoratedExpectedArtifacts.length, " received artifacts were not consumed"));
  }
}

class ParametersAndArtifacts extends React__default.Component {
  constructor(props) {
    super(props);
    this.toggleParams = () => {
      const { showingParams } = this.state;
      this.setState({ showingParams: !showingParams });
    };
    this.getDisplayableParameters = memoizeOne((execution, pipelineConfig) => {
      const strategyExclusions = ["parentPipelineId", "strategy", "parentStageId", "deploymentDetails", "cloudProvider"];
      const truncateLength = 200;
      const isParamDisplayable = (paramKey) => execution.isStrategy ? !strategyExclusions.includes(paramKey) : true;
      const displayableParameters = Object.keys(execution.trigger && execution.trigger.parameters || {}).filter(isParamDisplayable).sort().map((key) => {
        const value = JSON.stringify(execution.trigger.parameters[key]);
        const showTruncatedValue = value.length > truncateLength;
        let valueTruncated;
        if (showTruncatedValue) {
          valueTruncated = truncate(value, { length: truncateLength });
        }
        return { key, value, valueTruncated, showTruncatedValue };
      });
      let pinnedDisplayableParameters = [];
      if (pipelineConfig) {
        const paramConfigIndexByName = keyBy(pipelineConfig.parameterConfig, "name");
        const isParamPinned = (param) => paramConfigIndexByName[param.key] && paramConfigIndexByName[param.key].pinned;
        pinnedDisplayableParameters = displayableParameters.filter(isParamPinned);
      }
      return { displayableParameters, pinnedDisplayableParameters };
    });
    this.state = {
      showingParams: props.expandParamsOnInit
    };
  }
  getLabel(displayableParameters) {
    const { execution } = this.props;
    const { trigger } = execution;
    const { resolvedExpectedArtifacts } = trigger;
    const showParameters = displayableParameters.length > 0;
    const showArtifacts = resolvedExpectedArtifacts.length > 0;
    if (showParameters && showArtifacts) {
      return `Parameters/Artifacts (${displayableParameters.length}/${resolvedExpectedArtifacts.length})`;
    }
    if (showParameters) {
      return `Parameters (${displayableParameters.length})`;
    }
    return `Artifacts (${resolvedExpectedArtifacts.length})`;
  }
  render() {
    const { execution, pipelineConfig } = this.props;
    const { showingParams } = this.state;
    const { displayableParameters, pinnedDisplayableParameters } = this.getDisplayableParameters(execution, pipelineConfig);
    const { trigger } = execution;
    const { artifacts, resolvedExpectedArtifacts } = trigger;
    const parametersAndArtifactsExpanded = showingParams || displayableParameters.length === pinnedDisplayableParameters.length && !resolvedExpectedArtifacts.length;
    if (!displayableParameters.length && !resolvedExpectedArtifacts.length) {
      return null;
    }
    const label = this.getLabel(displayableParameters);
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-parameters-button"
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.toggleParams
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: `small glyphicon ${parametersAndArtifactsExpanded ? "glyphicon-chevron-down" : "glyphicon-chevron-right"}`
    }), parametersAndArtifactsExpanded ? "" : "View All ", label)), /* @__PURE__ */ React__default.createElement(ExecutionParameters, {
      shouldShowAllParams: showingParams,
      displayableParameters,
      pinnedDisplayableParameters
    }), /* @__PURE__ */ React__default.createElement(ResolvedArtifactList, {
      artifacts,
      resolvedExpectedArtifacts,
      showingExpandedArtifacts: showingParams
    }));
  }
}

var css_248z$1d = ".execution-marker-information-popover .modal-dialog {\n  max-width: calc(100vw - 20%);\n  width: calc(100vw - 20%);\n  min-width: 800px;\n}\n.execution-marker-information-popover .pipeline-name {\n  color: var(--color-accent);\n  text-transform: uppercase;\n}\n.execution-marker-information-popover .bottom-margin {\n  margin-bottom: 10px;\n}\n.execution-marker-information-popover .status {\n  color: var(--color-danger);\n}\n.execution-marker-information-popover .parameters {\n  color: var(--color-accent);\n  font-size: 12px;\n}\n.execution-marker-information-popover .execution-marker-information-popver-footer {\n  margin-top: 15px;\n  border-top: 1px solid var(--color-status-neutral-light);\n}\n.execution-marker-information-popover .execution-marker-information-popver-footer a {\n  font-size: 14px;\n}\n.execution-marker-information-popover .graph-all-buttons {\n  padding-left: 6px;\n}\n.execution-marker-information-popover .information-history-note {\n  font-style: italic;\n  font-size: smaller;\n}\n.execution-marker-information-popover .information-pipeline-execution-history {\n  width: 100%;\n}\n.execution-marker-information-popover .information-pipeline-execution-history thead {\n  background-color: var(--color-alabaster);\n}\n.execution-marker-information-popover .information-pipeline-execution-history th {\n  line-height: 25px;\n  padding: 2px;\n}\n.execution-marker-information-popover .information-pipeline-execution-history .information-section .fa-circle {\n  color: var(--color-danger);\n  font-size: 0.5em;\n  line-height: 25px;\n}\n.execution-marker-information-popover .information-pipeline-execution-history .information-section .information-app {\n  color: var(--color-primary);\n  font-weight: 600;\n}\n.execution-marker-information-popover .information-pipeline-execution-history .information-section .information-execution {\n  text-transform: uppercase;\n  color: var(--color-accent);\n  font-weight: 600;\n}\n.execution-marker-information-popover .information-pipeline-execution-history .information-section .information-stage-status {\n  padding: 2px;\n}\n.execution-marker-information-popover .information-pipeline-execution-history .information-section .information-stage-status .information-terminal-stage {\n  color: var(--color-white);\n  padding: 2px;\n  background-color: var(--color-danger);\n  font-size: 10px;\n}\n.execution-marker-information-popover .information-pipeline-execution-history tr {\n  line-height: 25px;\n}\n.execution-marker-information-popover .information-pipeline-execution-history tr:hover {\n  background-color: var(--color-accent-g2);\n  cursor: pointer;\n}\n.execution-marker-information-popover .information-pipeline-execution-history tr:nth-child(even) {\n  background: var(--color-accent-g3);\n}\n.execution-marker-information-popover .information-pipeline-execution-history tr:nth-child(even):hover {\n  background-color: var(--color-accent-g2);\n}\n.execution-marker-information-popover .information-pipeline-execution-history td {\n  padding: 1px 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.execution-marker-information-popover .information-pipeline-execution-history td .color-white a {\n  color: var(--color-white);\n}\n.execution-marker-information-popover .information-back {\n  margin-right: 4px;\n}\n.execution-marker-information-popover .information-stage-details {\n  font-size: 0.9em;\n}\n";
styleInject(css_248z$1d);

class ExecutionMarkerInformationModal extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.getPipelineLink = async (stageId, executionId) => {
      try {
        const currentExecution = await this.informationService.getExecution(executionId);
        let stageIndex;
        const currentStage = currentExecution.stageSummaries.find((stage, index) => {
          if (stage.id === stageId) {
            stageIndex = index;
            return stage;
          }
          return null;
        });
        this.allExecutions.push({
          execution: currentExecution,
          stageId,
          stageIndex
        });
        const childExecution = await this.informationService.getExecution(currentStage.masterStage.context.executionId);
        const childTerminalStage = childExecution.stageSummaries.find((stage, index) => {
          if (stage.status.toLocaleLowerCase() === "terminal")
            stageIndex = index;
          return stage.status.toLowerCase() === "terminal";
        });
        const childTerminalPipelineStage = childExecution.stageSummaries.find((stage) => stage.status.toLowerCase() === "terminal" && stage.type === "pipeline");
        const childPipelineConfig = await this.informationService.getPipelineConfig(childExecution.application, childExecution.pipelineConfigId);
        if (childExecution && !childTerminalPipelineStage) {
          this.childExecution = childExecution;
          this.childPipelineConfig = childPipelineConfig;
          this.allExecutions.push({
            execution: childExecution,
            stageId,
            stageIndex
          });
        }
        if (childTerminalPipelineStage) {
          this.getPipelineLink(childTerminalPipelineStage.id, childExecution.id);
          this.childTerminalPipelineStage = childTerminalPipelineStage;
        } else {
          this.allExecutions.reverse();
          this.allExecutions.pop();
          this.setState({
            executionDetails: this.childExecution || currentExecution,
            failedInApplication: currentStage.masterStage.context.application,
            link: {
              application: currentStage.masterStage.context.application,
              executionId: currentStage.masterStage.context.executionId,
              stageIndex: this.allExecutions[0].stageIndex
            },
            stageDetails: childTerminalStage || this.childTerminalPipelineStage || currentStage
          });
        }
      } catch (err) {
        if (console) {
          console.error("Error retrieving pipeline execution data.");
          this.props.onClose();
        }
      }
    };
    this.showPipelineGraph = () => {
      this.setState({ showPipelineGraph: true });
    };
    this.hidePipelineGraph = () => {
      this.setState({ showPipelineGraph: false });
    };
    this.state = {
      executionDetails: null,
      failedInApplication: null,
      link: null,
      showPipelineGraph: false,
      stageDetails: null
    };
    this.allExecutions = [];
    this.informationService = new ExecutionInformationService();
  }
  componentDidMount() {
    this.getPipelineLink(this.props.stageId, this.props.executionId);
  }
  render() {
    const { executionDetails, failedInApplication, link, stageDetails } = this.state;
    const content = this.state.showPipelineGraph ? /* @__PURE__ */ React__default.createElement("div", {
      className: ""
    }, this.allExecutions.map((item) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        key: `${item.execution.id}-${item.execution.name}`,
        className: "execution-graph"
      }, item.execution.application, " - ", item.execution.name, /* @__PURE__ */ React__default.createElement(PipelineGraph, {
        execution: item.execution,
        onNodeClick: () => {
        },
        viewState: {
          activeStageId: item.stageIndex,
          activeSubStageId: null,
          canTriggerPipelineManually: false,
          canConfigure: false
        }
      }));
    })) : /* @__PURE__ */ React__default.createElement("div", null, !executionDetails ? /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    })) : /* @__PURE__ */ React__default.createElement("div", {
      className: "information-details"
    }, /* @__PURE__ */ React__default.createElement("h5", {
      className: "pipeline-name"
    }, executionDetails.name), /* @__PURE__ */ React__default.createElement("div", {
      style: { fontWeight: "bold" }
    }, "PIPELINE"), /* @__PURE__ */ React__default.createElement("div", {
      className: "bottom-margin"
    }, /* @__PURE__ */ React__default.createElement("div", null, `[${executionDetails.authentication.user}] ${executionDetails.user ? `(${executionDetails.user})` : ""}`), /* @__PURE__ */ React__default.createElement("div", null, relativeTime(executionDetails.startTime || executionDetails.buildTime)), /* @__PURE__ */ React__default.createElement("div", null, "Status: ", /* @__PURE__ */ React__default.createElement("span", {
      className: "status"
    }, executionDetails.status), " by parent pipeline", " ", timestamp(executionDetails.trigger.parentExecution.buildTime))), /* @__PURE__ */ React__default.createElement("div", {
      className: "bottom-margin parameters"
    }, /* @__PURE__ */ React__default.createElement(ParametersAndArtifacts, {
      execution: executionDetails,
      expandParamsOnInit: false,
      pipelineConfig: this.childPipelineConfig
    })), stageDetails && /* @__PURE__ */ React__default.createElement("div", {
      className: "bottom-margin information-stage-details"
    }, /* @__PURE__ */ React__default.createElement("div", null, "STAGE DETAILS"), /* @__PURE__ */ React__default.createElement("div", null, "Name: ", stageDetails.name), /* @__PURE__ */ React__default.createElement("div", null, "Duration: ", duration(stageDetails.endTime - stageDetails.startTime)), /* @__PURE__ */ React__default.createElement("div", null, "Exception: ", stageDetails.getErrorMessage || "No message available"), /* @__PURE__ */ React__default.createElement("div", null, "Pipeline Execution History ", /* @__PURE__ */ React__default.createElement("span", {
      className: "information-history-note"
    }, "(Decending order)"), /* @__PURE__ */ React__default.createElement("table", {
      className: "information-pipeline-execution-history"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null), /* @__PURE__ */ React__default.createElement("th", null, "APPLICATION"), /* @__PURE__ */ React__default.createElement("th", null, "PIPELINE NAME"), /* @__PURE__ */ React__default.createElement("th", null, "STAGE"), /* @__PURE__ */ React__default.createElement("th", null, "STATUS"), /* @__PURE__ */ React__default.createElement("th", null, "DURATION"))), /* @__PURE__ */ React__default.createElement("tbody", {
      className: "information-section"
    }, this.allExecutions.map((item, index) => {
      return /* @__PURE__ */ React__default.createElement("tr", {
        key: `execution-history-for-${item.execution.id}-${item.stageId}`
      }, /* @__PURE__ */ React__default.createElement("td", null, index === 0 && /* @__PURE__ */ React__default.createElement("i", {
        className: "fa fa-circle"
      })), /* @__PURE__ */ React__default.createElement("td", {
        className: "information-app"
      }, /* @__PURE__ */ React__default.createElement(UISref, {
        to: "home.applications.application.pipelines.executionDetails.execution",
        params: {
          application: item.execution.application,
          executionId: item.execution.id,
          executionParams: {
            application: item.execution.application,
            executionId: item.execution.id,
            stage: item.stageId
          }
        },
        options: {
          inherit: false,
          reload: "home.applications.application.pipelines.executionDetails"
        }
      }, /* @__PURE__ */ React__default.createElement("a", {
        id: `stage-${item.stageId}`,
        target: "_blank"
      }, item.execution.application))), /* @__PURE__ */ React__default.createElement("td", {
        className: "information-execution"
      }, /* @__PURE__ */ React__default.createElement(UISref, {
        to: "home.applications.application.pipelines.executionDetails.execution",
        params: {
          application: item.execution.application,
          executionId: item.execution.id,
          executionParams: {
            application: item.execution.application,
            executionId: item.execution.id,
            stage: item.stageId
          }
        },
        options: {
          inherit: false,
          reload: "home.applications.application.pipelines.executionDetails"
        }
      }, /* @__PURE__ */ React__default.createElement("a", {
        id: `stage-${item.stageId}`,
        target: "_blank"
      }, item.execution.name))), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(UISref, {
        to: "home.applications.application.pipelines.executionDetails.execution",
        params: {
          application: item.execution.application,
          executionId: item.execution.id,
          executionParams: {
            application: item.execution.application,
            executionId: item.execution.id,
            stage: item.stageId
          }
        },
        options: {
          inherit: false,
          reload: "home.applications.application.pipelines.executionDetails"
        }
      }, /* @__PURE__ */ React__default.createElement("a", {
        id: `stage-${item.stageId}`,
        target: "_blank"
      }, item.execution.stageSummaries[item.stageIndex].name))), /* @__PURE__ */ React__default.createElement("td", {
        className: "information-stage-status"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "information-terminal-stage color-white"
      }, /* @__PURE__ */ React__default.createElement(UISref, {
        to: "home.applications.application.pipelines.executionDetails.execution",
        params: {
          application: item.execution.application,
          executionId: item.execution.id,
          executionParams: {
            application: item.execution.application,
            executionId: item.execution.id,
            stage: item.stageId
          }
        },
        options: {
          inherit: false,
          reload: "home.applications.application.pipelines.executionDetails"
        }
      }, /* @__PURE__ */ React__default.createElement("a", {
        id: `stage-${item.stageId}`,
        target: "_blank"
      }, item.execution.stageSummaries[item.stageIndex].status)))), /* @__PURE__ */ React__default.createElement("td", null, duration(item.execution.endTime - item.execution.startTime)));
    })))))), link && /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-marker-information-popver-footer"
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-link graph-all-buttons",
      "aria-disabled": "false",
      onClick: this.showPipelineGraph
    }, "Show Pipeline Execution History Graphs")), /* @__PURE__ */ React__default.createElement("div", {
      className: "graph-all-buttons"
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: "home.applications.application.pipelines.executionDetails.execution",
      params: {
        application: link.application,
        executionId: link.executionId,
        executionParams: {
          application: link.application,
          executionId: link.executionId,
          stage: link.stageIndex
        }
      },
      options: { inherit: false, reload: "home.applications.application.pipelines.executionDetails" }
    }, /* @__PURE__ */ React__default.createElement("a", {
      target: "_self"
    }, "Link to the Last Failed Execution Stage")))));
    const title = this.state.showPipelineGraph ? /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "clickable information-back"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-chevron-left",
      onClick: () => {
        this.hidePipelineGraph();
      }
    })), "Pipeline Execution History Graphs ", /* @__PURE__ */ React__default.createElement("span", {
      className: "information-history-note"
    }, "(Decending order)")) : /* @__PURE__ */ React__default.createElement("span", null, failedInApplication ? failedInApplication : "-");
    return /* @__PURE__ */ React__default.createElement(Modal$1, {
      show: true,
      onHide: this.props.onClose,
      className: "execution-marker-information-popover",
      backdrop: "static"
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, {
      closeButton: true
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, title)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, content));
  }
}

var css_248z$1c = ".execution-marker.stage {\n  margin-top: 0;\n  display: inline-block;\n  height: 20px;\n  opacity: 0.65;\n  transition: 0.2s all;\n  text-align: center;\n  padding: 0;\n  color: var(--color-black);\n  font-size: 90%;\n  border: 1px solid transparent;\n  border-left-color: var(--color-white);\n  vertical-align: middle;\n}\n.execution-marker.stage:hover,\n.execution-marker.stage.active {\n  opacity: 1;\n}\n.execution-marker.stage.after-active {\n  border-left-color: transparent;\n}\n.execution-marker.stage.active {\n  border-color: var(--color-mineshaft);\n}\n.execution-marker.stage.active:first-child {\n  border-left-width: 1px;\n}\n.execution-marker.stage.active:last-child {\n  border-right-width: 1px;\n}\n.execution-marker.stage.glowing {\n  -webkit-animation: animate-glow 2.5s steps(30) infinite;\n  -moz-animation: animate-glow 2.5s steps(30) infinite;\n}\n.execution-marker.stage.requires-attention {\n  background-color: var(--color-alert);\n}\n.execution-marker.stage i {\n  color: var(--color-white);\n  margin-left: 3px;\n  font-size: 0.7em;\n  position: relative;\n}\n.execution-marker-waiting {\n  color: var(--color-black);\n  background-color: var(--color-alert) !important;\n}\n.execution-marker-waiting .execution-waiting-link {\n  text-decoration: none;\n  color: var(--color-black);\n}\n.execution-marker-waiting .execution-waiting-link .execution-waiting-fa {\n  color: var(--color-black);\n}\n";
styleInject(css_248z$1c);

class ExecutionMarker extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleStageClick = () => {
      logger.log({ category: "Pipeline", action: "Stage clicked (bar)" });
      this.props.onClick(this.props.stage.index);
    };
    this.handleStageInformationClick = (event) => {
      logger.log({ category: "Pipeline", action: "Stage show context menu (bar)" });
      event.preventDefault();
      event.stopPropagation();
      this.showExecutionMarkerInformationModal();
    };
    this.showExecutionMarkerInformationModal = () => {
      this.setState({
        showingExecutionMarkerInformationModal: true
      });
    };
    this.hideExecutionMarkerInformationModal = () => {
      this.setState({
        showingExecutionMarkerInformationModal: false
      });
    };
    this.stageStatus = (stageStatus) => {
      if (stageStatus === "running") {
        const currentStatus = this.props.stage.stages.filter((stage) => stage.status.toLowerCase() === "running" && stage.type === "pipeline" && !isEmpty(stage.others));
        if (!isEmpty(currentStatus))
          return "waiting";
      }
      return stageStatus;
    };
    const { stage, execution } = props;
    this.state = {
      duration: duration(stage.runningTimeInMs),
      hydrated: execution.hydrated,
      showingExecutionMarkerInformationModal: false
    };
  }
  componentDidMount() {
    this.runningTime = new OrchestratedItemRunningTime(this.props.stage, (time) => this.setState({ duration: duration(time) }));
  }
  componentWillReceiveProps(nextProps) {
    this.runningTime.checkStatus(nextProps.stage);
  }
  componentWillUnmount() {
    this.runningTime.reset();
  }
  render() {
    const { stage, application, execution, active, previousStageActive, width } = this.props;
    let stageType = (stage.activeStageType || stage.type).toLowerCase();
    if (SETTINGS.feature.manualJudgmentParentPipeline) {
      stage.stages.forEach((childStage) => {
        if (childStage.type == "pipeline" && application.executions != void 0 && application.executions.data != void 0) {
          const childPipeline = application.executions.data.find((p) => p.id === childStage.context.executionId);
          if (childPipeline != void 0) {
            childPipeline.stages.forEach((stageToCheck) => {
              if (stageToCheck.type == "manualJudgment" && stageToCheck.status == "RUNNING") {
                stageType = "manualjudgment";
              }
            });
          }
        }
      });
    }
    const pipelineStatus = this.stageStatus(stage.status.toLowerCase());
    const markerClassName = [
      stage.type !== "group" ? "clickable" : "",
      "stage",
      "execution-marker",
      `stage-type-${stageType}`,
      `execution-marker-${pipelineStatus}`,
      active ? "active" : "",
      previousStageActive ? "after-active" : "",
      stage.isRunning ? "glowing" : "",
      stage.requiresAttention ? "requires-attention" : ""
    ].join(" ");
    const TooltipComponent = stage.useCustomTooltip ? stage.labelComponent : ExecutionBarLabel;
    const MarkerIcon = stage.markerIcon;
    const showInfoIcon = SETTINGS.feature.executionMarkerInformationModal && stage.status.toLowerCase() === "terminal" && stage.type === "pipeline";
    const stageContents = pipelineStatus === "waiting" ? /* @__PURE__ */ React__default.createElement("div", {
      className: markerClassName,
      style: { width, backgroundColor: stage.color }
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: "home.applications.application.pipelines.executionDetails.execution",
      params: {
        application: stage.stages[0].others.leafnodeApplicationName,
        executionId: stage.stages[0].others.leafnodePipelineExecutionId,
        executionParams: { application: application.name, executionId: execution.id }
      }
    }, /* @__PURE__ */ React__default.createElement("a", {
      target: "_self",
      className: "execution-waiting-link"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "horizontal center middle"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "duration"
    }, "waiting "), /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-clock execution-waiting-fa"
    }))))) : /* @__PURE__ */ React__default.createElement("div", {
      className: markerClassName,
      style: { width, backgroundColor: stage.color },
      onClick: this.handleStageClick
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "horizontal center middle"
    }, /* @__PURE__ */ React__default.createElement(MarkerIcon, {
      stage
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "duration"
    }, this.state.duration), showInfoIcon && /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-info-circle",
      onClick: this.handleStageInformationClick
    })));
    return /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(TooltipComponent, {
      application,
      execution,
      stage,
      executionMarker: true
    }, stageContents), this.state.showingExecutionMarkerInformationModal && /* @__PURE__ */ React__default.createElement(ExecutionMarkerInformationModal, {
      executionId: execution.id,
      onClose: this.hideExecutionMarkerInformationModal,
      stageId: execution.stageSummaries[stage.index].id
    }));
  }
}

const ExecutionPermalink = ({ standalone }) => {
  const asPermalink = (link) => standalone ? link : link.replace("/executions", "/executions/details");
  const [url, setUrl] = React__default.useState(asPermalink(location.href));
  React__default.useEffect(() => {
    const subscription = ReactInjector.stateEvents.locationChangeSuccess.subscribe((newUrl) => {
      if (url !== newUrl) {
        setUrl(asPermalink(newUrl));
      }
    });
    return () => subscription.unsubscribe();
  }, []);
  const handlePermalinkClick = () => {
    logger.log({ category: "Pipeline", action: "Permalink clicked" });
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("a", {
    onClick: handlePermalinkClick,
    href: url
  }, "Permalink"), /* @__PURE__ */ React__default.createElement(CopyToClipboard, {
    text: url,
    toolTip: "Copy permalink to clipboard"
  }));
};

const _CancelModal = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { isSubmitting: false, error: false };
    this.close = (args) => {
      this.props.dismissModal.apply(null, args);
    };
    this.showError = (exception) => {
      this.setState({
        error: true,
        errorMessage: exception,
        isSubmitting: false
      });
    };
    this.submitConfirmation = (values) => {
      this.setState({ isSubmitting: true });
      this.props.submitMethod(values.reason).then(this.close, this.showError);
    };
  }
  static confirm(props) {
    return ReactModal.show(_CancelModal, props);
  }
  render() {
    const { header, body, buttonText, cancelButtonText } = this.props;
    const { isSubmitting } = this.state;
    const error = this.state.error ? /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-danger"
    }, /* @__PURE__ */ React__default.createElement("h4", null, "An exception occurred:"), /* @__PURE__ */ React__default.createElement("p", null, this.state.errorMessage || "No details provided."))) : null;
    return /* @__PURE__ */ React__default.createElement(Formik, {
      initialValues: {},
      onSubmit: this.submitConfirmation,
      render: () => {
        const wrappedBody = body ? /* @__PURE__ */ React__default.createElement(Markdown, {
          message: body,
          trim: true
        }) : null;
        return /* @__PURE__ */ React__default.createElement(Form, {
          className: "form-horizontal"
        }, /* @__PURE__ */ React__default.createElement(ModalClose, {
          dismiss: this.close
        }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, header)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, wrappedBody, error, /* @__PURE__ */ React__default.createElement("div", {
          className: "row",
          style: {
            marginTop: "10px",
            marginBottom: "10px"
          }
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "col-md-3 sm-label-right"
        }, "Reason"), /* @__PURE__ */ React__default.createElement("div", {
          className: "col-md-7"
        }, /* @__PURE__ */ React__default.createElement(Field, {
          name: "reason",
          render: ({ field }) => /* @__PURE__ */ React__default.createElement("textarea", {
            className: "form-control",
            ...field,
            rows: 3,
            placeholder: "(Optional) anything that might be helpful to explain the reason for this change; HTML is okay"
          })
        })))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
          className: "btn btn-default",
          disabled: isSubmitting,
          onClick: this.close,
          type: "button"
        }, cancelButtonText), /* @__PURE__ */ React__default.createElement(SubmitButton, {
          isDisabled: isSubmitting,
          submitting: isSubmitting,
          isFormSubmit: true,
          label: buttonText
        })));
      }
    });
  }
};
let CancelModal = _CancelModal;
CancelModal.defaultProps = {
  cancelButtonText: "Cancel"
};

class StepExecutionDetails extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      configSections: props.detailsSections.map((s) => s.title),
      currentSection: null
    };
  }
  updateCurrentSection() {
    const currentSection = ReactInjector.$stateParams.details;
    if (this.state.currentSection !== currentSection) {
      this.setState({ currentSection });
    }
  }
  syncDetails(configSections) {
    ReactInjector.executionDetailsSectionService.synchronizeSection(configSections, () => this.updateCurrentSection());
  }
  componentDidMount() {
    this.syncDetails(this.state.configSections);
  }
  componentWillReceiveProps(nextProps) {
    const configSections = nextProps.detailsSections.map((s) => s.title);
    if (!isEqual(this.state.configSections, configSections)) {
      this.setState({ configSections });
      this.syncDetails(configSections);
    } else {
      this.updateCurrentSection();
    }
  }
  render() {
    const { configSections, currentSection } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(ExecutionDetailsSectionNav, {
      sections: configSections
    }), this.props.detailsSections.map((Section) => /* @__PURE__ */ React__default.createElement(SpinErrorBoundary, {
      category: "StepExecutionDetails.Section",
      key: Section.title
    }, /* @__PURE__ */ React__default.createElement(Section, {
      name: Section.title,
      current: currentSection,
      ...this.props
    }))));
  }
}

class StepDetails extends React__default.Component {
  constructor(props) {
    super(props);
  }
  deriveSectionsFromProps() {
    let configSections = [];
    let sourceUrl;
    let executionDetailsSections;
    let provider;
    const stageConfig = this.props.config;
    if (stageConfig) {
      if (stageConfig.executionConfigSections) {
        configSections = stageConfig.executionConfigSections;
      }
      if (stageConfig.executionDetailsSections) {
        executionDetailsSections = stageConfig.executionDetailsSections;
      } else {
        sourceUrl = stageConfig.executionDetailsUrl || "core/src/pipeline/details/defaultExecutionDetails.html";
      }
      provider = stageConfig.cloudProvider;
    }
    return { configSections, executionDetailsSections, provider, sourceUrl };
  }
  render() {
    const { application, config, execution, stage } = this.props;
    const { executionDetailsSections, provider, sourceUrl, configSections } = this.deriveSectionsFromProps();
    const { StepExecutionDetailsWrapper } = NgReact;
    const detailsProps = { application, config, execution, provider, stage };
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "stage-details"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "stage-details-heading"
    }, stage && /* @__PURE__ */ React__default.createElement("h5", null, /* @__PURE__ */ React__default.createElement(StatusGlyph, {
      item: stage
    }), robotToHuman(stage.name || stage.type))), sourceUrl && /* @__PURE__ */ React__default.createElement(StepExecutionDetailsWrapper, {
      ...detailsProps,
      sourceUrl,
      configSections
    }), executionDetailsSections && /* @__PURE__ */ React__default.createElement(StepExecutionDetails, {
      ...detailsProps,
      detailsSections: executionDetailsSections
    }));
  }
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/details/defaultExecutionDetails.html", `<div class="step-section-details">
  <div class="row">
    <execution-step-details item="stage"></execution-step-details>
  </div>
</div>

<stage-failure-message stage="stage" message="stage.failureMessage"></stage-failure-message>
`);
}]);

var css_248z$1b = ".execution .execution-details {\n  width: 100%;\n}\n.execution .execution-details-container {\n  background-color: var(--color-white);\n  padding: 0 0 0 20px;\n  margin: -20px 50px 0;\n  border: 1px solid var(--color-alto);\n  box-shadow: 0 0 4px 2px var(--color-accent-g1);\n  border-radius: 1px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.execution .execution-details-container .execution-details {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n}\n.execution .execution-details-container .execution-details .stage-summary,\n.execution .execution-details-container .execution-details .stage-details {\n  flex: 1 0 50%;\n  min-width: 400px;\n}\n.execution .execution-details-container .execution-details .stage-details {\n  padding-left: 20px;\n  background-color: var(--color-accent-g2);\n  box-shadow: none;\n}\n.execution .execution-details-container th {\n  font-weight: 600;\n}\n.execution .execution-details-container .nav.nav-pills {\n  background-color: transparent;\n  border: 0;\n  width: auto;\n  margin: 0;\n  padding: 0;\n}\n.execution .execution-details-container .nav.nav-pills a {\n  margin: 10px 0 0;\n  border-radius: 0;\n  padding: 5px 15px;\n  border-bottom-width: 0;\n  font-weight: 600;\n  color: var(--color-mineshaft);\n  background-color: var(--color-alabaster);\n}\n.execution .execution-details-container .nav.nav-pills a:hover {\n  background-color: var(--color-concrete);\n  transition: background-color 0.15s;\n}\n.execution .execution-details-container .nav.nav-pills a.active {\n  color: var(--color-white);\n  background-color: var(--color-accent);\n}\n.execution .execution-details-container .step-section-details {\n  padding: 15px;\n  margin-bottom: 5px;\n}\n.execution .execution-details-container .execution-details-summary h6.duration {\n  margin-top: 0;\n}\n.execution .execution-details-container .execution-details-title {\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-bottom: 0;\n  padding-bottom: 5px;\n}\n.execution .execution-details-container .execution-details-title .btn-group {\n  margin-left: 20px;\n  text-transform: none;\n  margin-right: 10px;\n}\n.execution .execution-details-container .execution-details-comments {\n  word-break: break-all;\n  margin-right: 10px;\n}\n.execution .execution-details-container tbody tr.stage-summary {\n  font-weight: 600;\n}\n.execution .execution-details-container tbody tr {\n  font-size: 85%;\n}\n.execution .execution-details-container tbody tr.clickable {\n  cursor: pointer;\n}\n.execution .execution-details-container tbody tr.clickable:hover {\n  background-color: var(--color-alabaster);\n}\n.execution .execution-details-container .glyphicon-remove {\n  cursor: pointer;\n  color: var(--color-dovegray);\n}\n.execution .execution-details-container h5 {\n  font-weight: 600;\n  padding-bottom: 0;\n}\n.execution .execution-details-container .stage-name {\n  margin-top: 5px;\n}\n.execution .execution-details-container .well,\n.execution .execution-details-container .alert-info {\n  margin-top: 10px;\n  background-color: var(--color-alabaster);\n  padding: 10px;\n  border: 1px solid var(--color-accent);\n  border-radius: 2px;\n  color: var(--color-mineshaft);\n}\n.execution .execution-details-container .alert-danger {\n  border: 1px solid var(--color-danger);\n  color: var(--color-mineshaft);\n}\n.execution .stage-details .stage-details-heading {\n  text-transform: uppercase;\n  margin-top: 0;\n}\n.execution .stage-details .stage-details-heading .status-glyph {\n  margin-right: 3px;\n}\n.execution .stage-details .stage-details-heading h4 {\n  font-weight: 600;\n}\n.execution .stage-details .stage-details-section-heading {\n  border-bottom: 1px solid var(--color-primary);\n  margin-bottom: 5px;\n}\n.execution .stage-details .stage-details-section-heading h4 {\n  font-weight: 600;\n}\n.execution .stage-details h4 {\n  margin-top: 0;\n}\n.execution .subinput-note {\n  font-style: italic;\n  font-size: 11px;\n  color: var(--color-dovegray);\n}\n.execution .hide-details-link {\n  display: block;\n  text-align: right;\n  padding-top: 5px;\n  color: var(--color-mineshaft);\n  text-transform: none;\n  font-size: 90%;\n}\n.execution .hide-details-link .glyphicon {\n  top: 2px;\n}\n.execution .hide-details-link:hover {\n  text-decoration: none;\n}\n.execution-details .action-buttons {\n  margin: 10px -10px 0;\n}\n.execution-details .action-buttons button {\n  margin: 0 10px;\n}\n.popover-content .action-buttons {\n  display: flex;\n  align-items: stretch;\n  margin: 10px -5px 0;\n}\n.popover-content .action-buttons button {\n  flex: 1 0 auto;\n  margin: 0 5px;\n}\n";
styleInject(css_248z$1b);

class StageExecutionDetails extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = this.getUpdatedState();
  }
  getStageParamsFromStageId(stageId, summaries) {
    let stage, subStage, step;
    summaries.some((summary, index) => {
      let stepIndex = (summary.stages || []).findIndex((s2) => s2.id === stageId);
      if (stepIndex !== -1) {
        step = stepIndex;
        stage = index;
        return true;
      }
      if (summary.type === "group" && summary.groupStages) {
        summary.groupStages.some((groupStage, subIndex) => {
          stepIndex = (groupStage.stages || []).findIndex((gs) => gs.id === stageId);
          if (stepIndex !== -1) {
            step = stepIndex;
            stage = index;
            subStage = subIndex;
            return true;
          }
          return false;
        });
      }
      return false;
    });
    if (stage) {
      return { stage, subStage, step, stageId: null };
    }
    return null;
  }
  getStageParamsFromRefId(refId, summaries) {
    let stage, subStage;
    const stageIndex = summaries.findIndex((summary) => summary.refId === refId);
    if (stageIndex !== -1) {
      return { stage: stageIndex, refId: null };
    }
    summaries.some((summary, index) => {
      if (summary.type === "group" && summary.groupStages) {
        const subStageIndex = summary.groupStages.findIndex((s2) => s2.refId === refId);
        if (subStageIndex !== -1) {
          stage = index;
          subStage = subStageIndex;
          return true;
        }
      }
      return false;
    });
    if (stage && subStage !== void 0) {
      return { stage, subStage, refId: null };
    }
    return { refId: null };
  }
  validateStageExists(summaries, stage, subStage) {
    if (isNaN(subStage)) {
      subStage = void 0;
    }
    const foundStage = summaries[stage];
    let foundSubStage;
    if (foundStage) {
      if (foundStage.groupStages) {
        foundSubStage = foundStage.groupStages[subStage];
        subStage = foundSubStage ? subStage : 0;
      } else {
        subStage = void 0;
      }
    } else {
      stage = 0;
    }
    return { stage, subStage };
  }
  getCurrentStage(summaries) {
    const { $state, $stateParams } = ReactInjector;
    if ($stateParams.stageId) {
      const params = this.getStageParamsFromStageId($stateParams.stageId, summaries);
      if (params) {
        $state.go(".", params, { location: "replace" });
        return { stage: params.stage, subStage: params.subStage };
      }
    }
    if ($stateParams.refId) {
      const params = this.getStageParamsFromRefId($stateParams.refId, summaries);
      if (params) {
        $state.go(".", params, { location: "replace" });
        return { stage: params.stage, subStage: params.subStage };
      }
    }
    const stateStage = parseInt($stateParams.stage, 10);
    const stateSubStage = $stateParams.subStage !== void 0 ? parseInt($stateParams.subStage, 10) : void 0;
    const { stage, subStage } = this.validateStageExists(summaries, stateStage, stateSubStage);
    if (stage !== stateStage || subStage !== stateSubStage) {
      $state.go(".", { stage, subStage }, { location: "replace" });
    }
    return { stage, subStage };
  }
  getCurrentStep() {
    return parseInt(ReactInjector.$stateParams.step, 10);
  }
  getStageSummary() {
    const stages = this.props.execution.stageSummaries || [];
    const { stage, subStage } = this.getCurrentStage(stages);
    let currentStage = null;
    if (stage !== void 0) {
      currentStage = stages[stage];
      if (currentStage && subStage !== void 0 && currentStage.groupStages) {
        currentStage = currentStage.groupStages[subStage];
      }
    }
    return currentStage;
  }
  getDetailsStageConfig(stageSummary) {
    if (stageSummary && ReactInjector.$stateParams.step !== void 0) {
      const step = stageSummary.stages[this.getCurrentStep()] || stageSummary.masterStage;
      return Registry.pipeline.getStageConfig(step);
    }
    return null;
  }
  getSummaryStageConfig(stageSummary) {
    if (stageSummary && ReactInjector.$stateParams.stage !== void 0) {
      return Registry.pipeline.getStageConfig(stageSummary);
    }
    return {};
  }
  getUpdatedState() {
    const stageSummary = this.getStageSummary();
    if (stageSummary) {
      const stage = stageSummary.stages[this.getCurrentStep()] || stageSummary.masterStage;
      const summaryStageConfig = this.getSummaryStageConfig(stageSummary);
      const detailsStageConfig = this.getDetailsStageConfig(stageSummary);
      return { stageSummary, stage, summaryStageConfig, detailsStageConfig };
    }
    return {};
  }
  updateStage() {
    this.setState(this.getUpdatedState());
  }
  componentDidMount() {
    this.locationChangeUnsubscribe = ReactInjector.$uiRouter.transitionService.onSuccess({}, () => this.updateStage());
    this.groupsUpdatedSubscription = ExecutionFilterService.groupsUpdatedStream.subscribe(() => this.updateStage());
    this.updateStage();
  }
  componentWillReceiveProps() {
    this.updateStage();
  }
  componentWillUnmount() {
    this.groupsUpdatedSubscription.unsubscribe();
    this.locationChangeUnsubscribe();
  }
  render() {
    const { application, execution } = this.props;
    const { detailsStageConfig, stage, stageSummary, summaryStageConfig } = this.state;
    return /* @__PURE__ */ React__default.createElement(SpinErrorBoundary, {
      category: "StageExecutionDetails"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-details"
    }, /* @__PURE__ */ React__default.createElement(StageSummary, {
      application,
      execution,
      config: summaryStageConfig,
      stage,
      stageSummary
    }), /* @__PURE__ */ React__default.createElement(StepDetails, {
      application,
      execution,
      stage,
      config: detailsStageConfig
    })));
  }
}
StageExecutionDetails.defaultProps = {
  standalone: false
};

var css_248z$1a = ".execution-cancellation-reason-text {\n  white-space: pre-wrap;\n}\n";
styleInject(css_248z$1a);

function ExecutionCancellationReason({ cancellationReason }) {
  const [isExpanded, setIsExpanded] = React__default.useState(true);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "execution-cancellation-reason-button"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "clickable btn-link",
    onClick: () => setIsExpanded(!isExpanded)
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: `small glyphicon ${isExpanded ? "glyphicon-chevron-down" : "glyphicon-chevron-right"}`
  }), "Cancellation Reason")), isExpanded && /* @__PURE__ */ React__default.createElement("pre", {
    className: "execution-cancellation-reason-text"
  }, cancellationReason));
}

class ExecutionUserStatus extends React__default.Component {
  render() {
    var _a, _b;
    const { authentication, trigger } = this.props;
    const authenticatedUser = (_a = authentication.user) != null ? _a : "[anonymous]";
    const triggerUser = (_b = trigger.user) != null ? _b : "unknown user";
    return triggerUser === authenticatedUser ? authenticatedUser : `${triggerUser} (${authenticatedUser})`;
  }
}

var css_248z$19 = "a.execution-build-number {\n  display: block;\n}\n";
styleInject(css_248z$19);

class ExecutionBuildLink extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleBuildInfoClick = (event) => {
      logger.log({ category: "Pipeline", action: "Execution build number clicked - build info" });
      event.stopPropagation();
    };
    this.getBuildLink = () => {
      const { execution } = this.props;
      if (!(execution.trigger.linkText && execution.trigger.link) && !(execution.buildInfo && execution.buildInfo.number)) {
        return null;
      }
      if (execution.trigger.linkText && !(execution.trigger.link || execution.buildInfo.url)) {
        return null;
      }
      if (execution.trigger.link && !(execution.trigger.linkText || execution.buildInfo.number)) {
        return null;
      }
      return /* @__PURE__ */ React__default.createElement("a", {
        className: "execution-build-number clickable",
        onClick: this.handleBuildInfoClick,
        href: execution.trigger.link ? execution.trigger.link : execution.buildInfo.url,
        target: "_blank"
      }, this.getBuildText(execution));
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("span", null, this.getBuildLink());
  }
  getBuildText(execution) {
    if (execution.trigger.linkText) {
      return /* @__PURE__ */ React__default.createElement("span", {
        className: "build-label"
      }, execution.trigger.linkText);
    } else {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", {
        className: "build-label"
      }, "Build"), " #", execution.buildInfo.number);
    }
  }
}

class ExecutionStatus extends React__default.Component {
  constructor(props) {
    super(props);
    const { execution } = this.props;
    this.state = {
      sortFilter: ExecutionState.filterModel.asFilterModel.sortFilter,
      timestamp: relativeTime(execution.startTime || execution.buildTime)
    };
  }
  validateTimestamp() {
    const newTimestamp = relativeTime(this.props.execution.startTime || this.props.execution.buildTime);
    if (newTimestamp !== this.state.timestamp) {
      this.setState({ timestamp: newTimestamp });
    }
  }
  componentDidMount() {
    this.timestampScheduler = SchedulerFactory.createScheduler();
    this.timestampScheduler.subscribe(() => this.validateTimestamp());
  }
  componentWillUnmount() {
    this.timestampScheduler.unsubscribe();
  }
  getExecutionTypeDisplay() {
    const trigger = this.props.execution.trigger;
    if (trigger.type === "manual") {
      return "Manual Start";
    }
    const config = Registry.pipeline.getTriggerConfig(trigger.type);
    if (config && config.executionTriggerLabel) {
      return config.executionTriggerLabel(trigger);
    }
    return trigger.type;
  }
  getTriggerExecutionStatus() {
    const { trigger } = this.props.execution;
    const triggerConfig = Registry.pipeline.getTriggerConfig(trigger.type);
    if (triggerConfig) {
      return triggerConfig.executionStatusComponent;
    }
    if (trigger.type === "manual") {
      return ExecutionUserStatus;
    }
    return null;
  }
  render() {
    const { execution } = this.props;
    const { trigger, authentication } = execution;
    const TriggerExecutionStatus = this.getTriggerExecutionStatus();
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-status-section"
    }, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("h5", {
      className: "build-number"
    }, /* @__PURE__ */ React__default.createElement(ExecutionBuildLink, {
      execution
    })), /* @__PURE__ */ React__default.createElement("h5", {
      className: `execution-type ${trigger.dryRun ? "execution-dry-run" : ""}`
    }, trigger.dryRun && "DRY RUN: ", this.getExecutionTypeDisplay())), /* @__PURE__ */ React__default.createElement("ul", {
      className: "trigger-details"
    }, has(trigger, "buildInfo.url") && /* @__PURE__ */ React__default.createElement("li", null, buildDisplayName(trigger.buildInfo)), TriggerExecutionStatus && /* @__PURE__ */ React__default.createElement(TriggerExecutionStatus, {
      trigger,
      authentication
    }), /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement(HoverablePopover, {
      delayShow: 100,
      delayHide: 0,
      template: /* @__PURE__ */ React__default.createElement("span", null, timestamp(execution.startTime || execution.buildTime))
    }, this.state.timestamp))));
  }
}

var css_248z$18 = ".execution .label {\n  text-transform: uppercase;\n  border-radius: 0;\n  color: var(--color-white);\n  font-weight: 600;\n}\n.execution .label .glyphicon {\n  color: var(--color-white);\n}\n.execution .label.label-succeeded {\n  background-color: var(--color-success);\n}\n.execution .label.label-terminal,\n.execution .label.label-terminated {\n  background-color: var(--color-danger);\n}\n.execution .label.label-failed_continue {\n  background-color: var(--color-alert);\n  color: var(--color-mineshaft);\n}\n.execution .label.label-running,\n.execution .label.label-launched {\n  background-color: var(--color-accent);\n}\n.execution .label.label-stopped {\n  background-color: var(--color-danger-light);\n  color: var(--color-mineshaft);\n}\n.execution .timestamp {\n  color: var(--color-dovegray);\n  font-size: 0.8em;\n  padding-top: 22px;\n}\n.execution .panel .summary {\n  background-color: var(--color-alto);\n  cursor: pointer;\n  padding-bottom: 0px;\n}\n.execution .panel .summary h5 {\n  font-weight: bold;\n  display: inline-block;\n}\n.execution .panel .summary.current {\n  background-color: var(--color-white);\n}\n.execution .panel .details .tr {\n  background-color: var(--color-accent-g1);\n}\n.execution-actions {\n  display: inline-block;\n  width: 42px;\n  vertical-align: top;\n  padding-top: 20px;\n  margin-left: 6px;\n}\n.execution-actions .fa-times-circle {\n  color: var(--color-danger);\n}\n.execution-actions button.link {\n  padding: 2px 3px 0;\n}\n.execution-actions button.link:first-child {\n  padding-right: 5px;\n}\n.execution-summary {\n  padding: 0 5px 5px;\n  font-size: 90%;\n}\nexecution-details-section-nav {\n  display: block;\n}\n.execution-bar {\n  display: inline-block;\n  width: calc(100% - 235px);\n  vertical-align: top;\n}\n.execution-bar .stage .fa {\n  display: inline-block;\n}\n.execution-bar .stage .duration {\n  font-weight: 600;\n  line-height: 20px;\n  visibility: hidden;\n  width: 0;\n  display: inline-block;\n  overflow: hidden;\n}\n.show-durations .stage {\n  min-width: 50px;\n}\n.show-durations .stage .fa + .duration {\n  margin-left: 3px;\n}\n.show-durations .stage .duration {\n  visibility: visible;\n  width: auto;\n}\n.execution-parameters-button,\n.execution-details-button,\n.execution-cancellation-reason-button {\n  font-size: 0.8em;\n  line-height: 12px;\n}\n.execution-parameters-button span.glyphicon,\n.execution-details-button span.glyphicon,\n.execution-cancellation-reason-button span.glyphicon {\n  width: 1.4em;\n}\n.execution-parameters-button,\n.execution-cancellation-reason-button {\n  margin-bottom: 6px;\n}\n.execution-breadcrumbs {\n  margin-bottom: 5px;\n}\n.execution-breadcrumb-marker {\n  margin: 0px 3px;\n}\n";
styleInject(css_248z$18);

var __defProp$j = Object.defineProperty;
var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
var __decorateClass$j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$j(target, key, result);
  return result;
};
const findChildIndex = (child, execution) => {
  var _a;
  const result = (_a = execution.stageSummaries) == null ? void 0 : _a.findIndex((s) => {
    var _a2, _b;
    return s.type === "pipeline" && ((_b = (_a2 = s.masterStage) == null ? void 0 : _a2.context) == null ? void 0 : _b.executionId) === child;
  });
  return result;
};
let Execution$1 = class extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.wrapperRef = React__default.createRef();
    this.toggleDetails = (stageIndex, subIndex) => {
      const { executionService } = ReactInjector;
      const { execution, application } = this.props;
      executionService.hydrate(application, execution).then(() => {
        executionService.toggleDetails(execution, stageIndex, subIndex);
      });
    };
    this.handleNodeClick = (node, subIndex) => {
      this.toggleDetails(node.index, subIndex);
    };
    this.handleSourceNoStagesClick = () => {
      logger.log({ category: "Pipeline", action: "Execution source clicked (no stages found)" });
    };
    this.handlePauseClick = () => {
      logger.log({ category: "Pipeline", action: "Execution pause clicked" });
      this.pauseExecution();
    };
    this.handleResumeClick = () => {
      logger.log({ category: "Pipeline", action: "Execution resume clicked" });
      this.resumeExecution();
    };
    this.handleDeleteClick = () => {
      logger.log({ category: "Pipeline", action: "Execution delete clicked" });
      this.deleteExecution();
    };
    this.handleCancelClick = () => {
      logger.log({ category: "Pipeline", action: "Execution cancel clicked" });
      this.cancelExecution();
    };
    this.handleRerunClick = () => {
      logger.log({ category: "Pipeline", action: "Execution rerun clicked" });
      const { application, execution } = this.props;
      const pipelineConfig = application.pipelineConfigs.data.find((p) => p.id === execution.pipelineConfigId);
      this.props.onRerun(execution, pipelineConfig);
    };
    this.handleSourceClick = () => {
      logger.log({ category: "Pipeline", action: "Execution source clicked" });
    };
    this.handleToggleDetails = (showingDetails) => {
      logger.log({ category: "Pipeline", action: "Execution details toggled (Details link)" });
      showingDetails ? this.toggleDetails() : this.toggleDetails(0, 0);
    };
    this.handleConfigureClicked = (e) => {
      const { application, execution } = this.props;
      logger.log({ category: "Execution", action: "Configuration" });
      ReactInjector.$state.go("^.pipelineConfig", {
        application: application.name,
        pipelineId: execution.pipelineConfigId
      });
      e.stopPropagation();
    };
    this.scrollIntoView = (forceScroll = false) => {
      const element = this.wrapperRef.current;
      const { scrollIntoView, execution } = this.props;
      (scrollIntoView || forceScroll) && element && execution.hydrated && setTimeout(() => {
        element.scrollIntoView();
        const parent = element.closest(".all-execution-groups");
        parent && (parent.scrollTop -= 45);
      });
    };
    const { execution, standalone } = this.props;
    const { $stateParams } = ReactInjector;
    const initialViewState = {
      activeStageId: Number($stateParams.stage),
      activeSubStageId: Number($stateParams.subStage),
      executionId: $stateParams.executionId,
      canTriggerPipelineManually: false,
      canConfigure: false
    };
    if ($stateParams.executionId !== props.execution.id && props.descendantExecutionId) {
      initialViewState.activeStageId = findChildIndex(props.descendantExecutionId, props.execution);
    }
    const restartedStage = execution.stages.find((stage) => stage.context.restartDetails !== void 0);
    this.state = {
      showingDetails: this.invalidateShowingDetails(props, true),
      showingParams: standalone,
      pipelinesUrl: [SETTINGS.gateUrl, "pipelines/"].join("/"),
      viewState: initialViewState,
      sortFilter: ExecutionState.filterModel.asFilterModel.sortFilter,
      restartDetails: restartedStage ? restartedStage.context.restartDetails : null,
      runningTimeInMs: props.execution.runningTimeInMs
    };
  }
  updateViewStateDetails(toParams, fromParams) {
    const { descendantExecutionId, execution } = this.props;
    const { viewState } = this.state;
    const shouldShowDetails = toParams.executionId === execution.id;
    const shouldScroll = toParams.executionId === execution.id && fromParams.executionId !== execution.id;
    const newViewState = { ...viewState };
    newViewState.activeStageId = Number(toParams.stage);
    newViewState.activeSubStageId = Number(toParams.subStage);
    if (toParams.executionId !== execution.id && descendantExecutionId) {
      newViewState.activeStageId = findChildIndex(descendantExecutionId, execution);
    }
    if (this.state.showingDetails !== shouldShowDetails) {
      this.setState({
        showingDetails: this.invalidateShowingDetails(this.props, shouldScroll),
        viewState: newViewState
      });
    } else {
      if (this.state.showingDetails && !isEqual(viewState, newViewState)) {
        this.setState({ viewState: newViewState });
      }
    }
  }
  invalidateShowingDetails(props = this.props, forceScroll = false) {
    const { $state, $stateParams, executionService } = ReactInjector;
    const { execution, application, standalone } = props;
    const showing = standalone === true || execution.id === $stateParams.executionId && $state.includes("**.execution.**");
    if (showing && !execution.hydrated) {
      executionService.hydrate(application, execution).then(() => {
        this.setState({ showingDetails: true }, () => this.scrollIntoView(forceScroll));
      });
      return false;
    }
    if (forceScroll) {
      this.scrollIntoView(true);
    }
    return showing;
  }
  isActive(stage) {
    var _a, _b;
    if (!stage) {
      return false;
    }
    if (this.props.execution.id !== ReactInjector.$stateParams.executionId) {
      return this.props.descendantExecutionId && stage && stage.type === "pipeline" && ((_b = (_a = stage.masterStage) == null ? void 0 : _a.context) == null ? void 0 : _b.executionId) === this.props.descendantExecutionId;
    }
    return this.state.showingDetails && Number(ReactInjector.$stateParams.stage) === stage.index;
  }
  getUrl() {
    let url = $location.absUrl();
    if (!this.props.standalone) {
      url = url.replace("/executions", "/executions/details");
    }
    return url;
  }
  deleteExecution() {
    const { executionService } = ReactInjector;
    ConfirmationModalService.confirm({
      header: "Really delete execution?",
      buttonText: "Delete",
      body: "<p>This will permanently delete the execution history.</p>",
      submitMethod: () => executionService.deleteExecution(this.props.application, this.props.execution.id).then(() => {
        if (this.props.standalone) {
          ReactInjector.$state.go("^");
        }
      })
    });
  }
  cancelExecution() {
    const { application, execution, cancelConfirmationText } = this.props;
    const { executionService } = ReactInjector;
    const hasDeployStage = execution.stages && execution.stages.some((stage) => stage.type === "deploy" || stage.type === "cloneServerGroup");
    CancelModal.confirm({
      header: `Really stop execution of ${execution.name}?`,
      buttonText: `Stop running ${execution.name}`,
      body: hasDeployStage && !cancelConfirmationText ? "*Note:* Any deployments that have begun will continue and need to be cleaned up manually." : cancelConfirmationText,
      submitMethod: (reason, force) => executionService.cancelExecution(application, execution.id, force, reason)
    });
  }
  pauseExecution() {
    const { executionService } = ReactInjector;
    ConfirmationModalService.confirm({
      header: "Really pause execution?",
      buttonText: "Pause",
      submitMethod: () => executionService.pauseExecution(this.props.application, this.props.execution.id)
    });
  }
  resumeExecution() {
    const { executionService } = ReactInjector;
    ConfirmationModalService.confirm({
      header: "Really resume execution?",
      buttonText: "Resume",
      submitMethod: () => executionService.resumeExecution(this.props.application, this.props.execution.id)
    });
  }
  componentDidMount() {
    const { execution } = this.props;
    this.runningTime = new OrchestratedItemRunningTime(execution, (time) => this.setState({ runningTimeInMs: time }));
    this.stateChangeSuccessSubscription = ReactInjector.stateEvents.stateChangeSuccess.subscribe(({ toParams, fromParams }) => {
      this.updateViewStateDetails(toParams, fromParams);
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.execution !== this.props.execution) {
      this.runningTime.checkStatus(nextProps.execution);
      this.setState({
        showingDetails: this.invalidateShowingDetails(nextProps)
      });
    }
  }
  componentWillUnmount() {
    this.runningTime.reset();
    this.stateChangeSuccessSubscription.unsubscribe();
  }
  render() {
    var _a;
    const {
      application,
      descendantExecutionId,
      execution,
      showAccountLabels,
      showConfigureButton,
      showDurations,
      standalone,
      title,
      cancelHelpText,
      pipelineConfig
    } = this.props;
    const { pipelinesUrl, restartDetails, showingDetails, sortFilter, viewState } = this.state;
    const { $state, $stateParams } = ReactInjector;
    const accountLabels = this.props.execution.deploymentTargets.map((account) => /* @__PURE__ */ React__default.createElement(AccountTag, {
      key: account,
      account
    }));
    const executionMarkerWidth = `${100 / execution.stageSummaries.length}%`;
    const showExecutionName = standalone || !title && sortFilter.groupBy !== "name";
    const executionMarkers = execution.stageSummaries.map((stage, index, allStages) => /* @__PURE__ */ React__default.createElement(ExecutionMarker, {
      key: stage.refId,
      application,
      execution,
      stage,
      onClick: this.toggleDetails,
      active: this.isActive(stage),
      previousStageActive: this.isActive(index > 0 ? allStages[index - 1] : null),
      width: executionMarkerWidth
    }));
    const className = classNames({
      execution: true,
      "show-details": showingDetails,
      "details-hidden": !showingDetails,
      "show-durations": showDurations
    });
    const hasParentExecution = !!((_a = execution.trigger) == null ? void 0 : _a.parentExecution);
    return /* @__PURE__ */ React__default.createElement("div", {
      className,
      id: `execution-${execution.id}`,
      ref: this.wrapperRef
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: `execution-overview group-by-${sortFilter.groupBy}`
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-h"
    }, (title || showExecutionName) && /* @__PURE__ */ React__default.createElement("h4", {
      className: "execution-name"
    }, (showAccountLabels || showExecutionName) && accountLabels, execution.fromTemplate && /* @__PURE__ */ React__default.createElement("i", {
      className: "from-template fa fa-table",
      title: "Pipeline from template"
    }), title || execution.name), showConfigureButton && /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-pull-right"
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Navigate to Pipeline Configuration"
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: "^.pipelineConfig",
      params: { application: application.name, pipelineId: execution.pipelineConfigId }
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-xs btn-default single-execution-details__configure",
      onClick: this.handleConfigureClicked
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-cog"
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "visible-md-inline visible-lg-inline"
    }, " Configure")))))), hasParentExecution && /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-breadcrumbs"
    }, /* @__PURE__ */ React__default.createElement(ExecutionBreadcrumbs, {
      execution
    })), /* @__PURE__ */ React__default.createElement(ExecutionStatus, {
      execution,
      showingDetails,
      standalone
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-bar"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "stages"
    }, executionMarkers, !execution.stageSummaries.length && /* @__PURE__ */ React__default.createElement("div", {
      className: "text-center"
    }, "No stages found.", " ", /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.handleSourceNoStagesClick,
      target: "_blank",
      href: pipelinesUrl + execution.id
    }, "View as JSON"))), /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-summary"
    }, "Status:", " ", /* @__PURE__ */ React__default.createElement("span", {
      className: `status execution-status execution-status-${execution.status.toLowerCase()}`
    }, execution.status, execution.status === "NOT_STARTED" && execution.limitConcurrent && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, " (", "waiting on", " ", /* @__PURE__ */ React__default.createElement(UISref, {
      to: `${$state.current.name.endsWith(".execution") ? "^" : ""}.^.executions`,
      params: { pipeline: execution.name, status: "RUNNING" }
    }, /* @__PURE__ */ React__default.createElement("a", null, "RUNNING")), " ", "executions)")), execution.cancellationReason && /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "See Cancellation Reason below for additional details."
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-info-sign"
    })), execution.canceledBy && /* @__PURE__ */ React__default.createElement("span", null, " ", "by ", execution.canceledBy, " \u2014 ", timestamp(execution.endTime)), restartDetails && /* @__PURE__ */ React__default.createElement("span", null, " ", "Restarted by ", restartDetails.restartedBy, " \u2014 ", timestamp(restartDetails.restartTime)), /* @__PURE__ */ React__default.createElement("span", {
      className: "pull-right"
    }, "Duration: ", duration(execution.runningTimeInMs)))), /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-actions"
    }, execution.isRunning && /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Pause execution"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "link",
      onClick: this.handlePauseClick
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-pause"
    }))), execution.isPaused && /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Resume execution"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "link",
      onClick: this.handleResumeClick
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-play"
    }))), (!execution.isActive || application.attributes.enableRerunActiveExecutions) && this.props.onRerun && /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Re-run execution with same parameters"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "link",
      onClick: this.handleRerunClick
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-redo"
    }))), !execution.isActive && /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Delete execution"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "link",
      onClick: this.handleDeleteClick
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    }))), execution.isActive && /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: cancelHelpText
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "link",
      onClick: this.handleCancelClick
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "far fa-times-circle"
    })))), execution.cancellationReason && /* @__PURE__ */ React__default.createElement(ExecutionCancellationReason, {
      cancellationReason: execution.cancellationReason
    }), /* @__PURE__ */ React__default.createElement(ParametersAndArtifacts, {
      execution,
      expandParamsOnInit: standalone && !descendantExecutionId,
      pipelineConfig
    }), !standalone && /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-details-button"
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: () => this.handleToggleDetails(showingDetails)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: `small glyphicon ${showingDetails ? "glyphicon-chevron-down" : "glyphicon-chevron-right"}`
    }), "Execution Details"))), showingDetails && /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-graph"
    }, /* @__PURE__ */ React__default.createElement(PipelineGraph, {
      execution,
      onNodeClick: this.handleNodeClick,
      viewState
    })), showingDetails && (!standalone || execution.id === $stateParams.executionId) && /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-details-container"
    }, /* @__PURE__ */ React__default.createElement(StageExecutionDetails, {
      execution,
      application,
      standalone
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "permalinks"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "permalinks-content"
    }, /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.handleSourceClick,
      target: "_blank",
      href: pipelinesUrl + execution.id
    }, "View as JSON"), " | ", /* @__PURE__ */ React__default.createElement(ExecutionPermalink, {
      standalone
    })))));
  }
};
Execution$1.defaultProps = {
  dataSourceKey: "executions",
  cancelHelpText: "Cancel execution"
};
Execution$1 = __decorateClass$j([
  Overridable("PipelineExecution")
], Execution$1);

class CurrentlyRunningExecutions extends React__default.Component {
  render() {
    const { currentlyRunningExecutions } = this.props;
    const currentlyRunningExecution = head(currentlyRunningExecutions);
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), "This pipeline is currently executing!")), /* @__PURE__ */ React__default.createElement("div", {
      className: "pad-left"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Execution started: "), timestamp(currentlyRunningExecution.startTime), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("strong", null, "Current stage: "), currentlyRunningExecution.currentStages && currentlyRunningExecution.currentStages.map((s, i) => {
      return /* @__PURE__ */ React__default.createElement("span", {
        key: i
      }, s.name);
    }))), currentlyRunningExecutions.length > 1 && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("em", null, currentlyRunningExecutions.length - 1 + " other execution(s)")));
  }
}

const DryRun = () => /* @__PURE__ */ React__default.createElement(FormikFormField, {
  name: "dryRun",
  label: "Dry run",
  help: /* @__PURE__ */ React__default.createElement(HelpField, {
    id: "execution.dryRun"
  }),
  input: (props) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    ...props,
    text: "Run a test execution"
  })
});

class NotificationDetails extends React__default.Component {
  constructor(props) {
    super(props);
    this.notificationToolTip = (notifications) => /* @__PURE__ */ React__default.createElement("div", {
      className: "notifications-list"
    }, /* @__PURE__ */ React__default.createElement("ul", null, notifications.map((notification, i) => {
      return /* @__PURE__ */ React__default.createElement("li", {
        key: i
      }, /* @__PURE__ */ React__default.createElement("b", null, notification.address), " when:", notification.when.map((w, j) => {
        return /* @__PURE__ */ React__default.createElement("ul", {
          key: j
        }, /* @__PURE__ */ React__default.createElement("li", null, NotificationTransformer.getNotificationWhenDisplayName(w)));
      }));
    })));
    this.onNotificationTypeChange = (type) => {
      const notificationTypeUpdate = Registry.pipeline.getNotificationConfig(type);
      const { values } = this.props.formik;
      if (!!notificationTypeUpdate && values.notification && values.notification.address) {
        this.props.formik.setFieldValue("notification.address", "");
      }
    };
    this.state = {
      notificationTypes: Registry.pipeline.getNotificationTypes().map((type) => ({
        label: type.label,
        value: type.key
      }))
    };
  }
  render() {
    const { notificationToolTip, onNotificationTypeChange } = this;
    const { formik, notifications } = this.props;
    const { values } = formik;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "notificationEnabled",
      label: "Notifications",
      input: (props) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
        ...props,
        text: "Notify me when the pipeline completes"
      })
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, notifications.length === 1 && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-offset-4 col-md-6"
    }, "There is", " ", /* @__PURE__ */ React__default.createElement(HoverablePopover, {
      placement: "bottom",
      template: notificationToolTip(notifications)
    }, /* @__PURE__ */ React__default.createElement("a", null, "one notification")), " ", "for this pipeline"), notifications.length > 1 && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-offset-4 col-md-6"
    }, "There are", " ", /* @__PURE__ */ React__default.createElement(HoverablePopover, {
      placement: "bottom",
      template: notificationToolTip(notifications)
    }, /* @__PURE__ */ React__default.createElement("a", null, notifications.length, " notifications")), " ", "configured for this pipeline")), values.notificationEnabled && /* @__PURE__ */ React__default.createElement(NotificationSelector, {
      onNotificationTypeChange,
      fieldName: "notification",
      type: values.notification.type
    }));
  }
}

class Parameters extends React__default.Component {
  constructor() {
    super(...arguments);
    this.shouldInclude = (p) => {
      const { values } = this.props.formik;
      if (p.conditional) {
        const comparingTo = values.parameters[p.conditional.parameter];
        const value = p.conditional.comparatorValue;
        switch (p.conditional.comparator) {
          case ">":
            return parseFloat(comparingTo) > parseFloat(value);
          case ">=":
            return parseFloat(comparingTo) >= parseFloat(value);
          case "<":
            return parseFloat(comparingTo) < parseFloat(value);
          case "<=":
            return parseFloat(comparingTo) <= parseFloat(value);
          case "!=":
            return comparingTo !== value;
          case "=":
            return comparingTo === value;
        }
      }
      return true;
    };
  }
  render() {
    const { parameters } = this.props;
    const hasRequiredParameters = parameters.some((p) => p.required);
    const visibleParameters = parameters.filter((p) => !p.conditional || this.shouldInclude(p));
    const formikFieldNameForParam = (param) => `parameters["${param.name}"]`;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", {
      className: "manual-execution-parameters-description"
    }, "This pipeline is parameterized. Please enter values for the parameters below."), visibleParameters && visibleParameters.map((parameter, i) => {
      const fieldProps = {
        name: formikFieldNameForParam(parameter),
        label: parameter.label || parameter.name,
        help: parameter.description && /* @__PURE__ */ React__default.createElement(HelpField, {
          content: parameter.description
        }),
        fastField: false,
        required: parameter.required
      };
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
        key: i
      }, !parameter.hasOptions && parameter.constraint === "date" && /* @__PURE__ */ React__default.createElement(FormikFormField, {
        ...fieldProps,
        input: (props) => /* @__PURE__ */ React__default.createElement(DayPickerInput, {
          ...props,
          format: "yyyy-MM-dd"
        })
      }), !parameter.hasOptions && !parameter.constraint && /* @__PURE__ */ React__default.createElement(FormikFormField, {
        ...fieldProps,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props,
          inputClassName: "form-control input-sm"
        })
      }), parameter.hasOptions && /* @__PURE__ */ React__default.createElement(FormikFormField, {
        ...fieldProps,
        input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
          ...props,
          clearable: false,
          inputClassName: "parameter-option-select",
          options: parameter.options.map((o) => ({ label: `${o.value}`, value: o.value }))
        })
      }));
    }), hasRequiredParameters && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group sp-margin-l-top"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4 col-md-offset-4"
    }, /* @__PURE__ */ React__default.createElement("em", null, "* Required"))));
  }
}

class PipelineOptions extends React__default.Component {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.setPipelinePlan = (pipeline) => {
      const isV1PipelineMissingStages = pipeline.type === "templatedPipeline" && (pipeline.stages === void 0 || pipeline.stages.length === 0);
      const isV2Pipeline = PipelineTemplateV2Service.isV2PipelineConfig(pipeline);
      const { formatPipeline } = this.props;
      if (isV1PipelineMissingStages || isV2Pipeline) {
        const pipelineTemplateConfig = {
          type: "templatedPipeline",
          ...pipeline
        };
        from(PipelineTemplateReader.getPipelinePlan(pipelineTemplateConfig)).pipe(takeUntil(this.destroy$)).subscribe((plan) => {
          this.setPipelineSelectedValues(isV2Pipeline ? formatPipeline(plan) : pipeline);
        }, () => {
          this.setPipelineSelectedValues(pipeline);
          if (isV2Pipeline) {
            this.setState({ planError: true });
          }
        });
      } else {
        this.setPipelineSelectedValues(pipeline);
      }
    };
    this.pipelineSelected = (option) => {
      const { formatPipeline, pipelineOptions } = this.props;
      const pipelineId = option.value;
      const pipeline = formatPipeline(pipelineOptions.find((p) => p.id === pipelineId));
      this.setPipelinePlan(pipeline);
    };
    this.setPipelineSelectedValues = (pipeline) => {
      const {
        formatParameterConfig,
        formatTriggers,
        formik,
        pipelineChanged,
        triggerChanged,
        updateTriggerOptions
      } = this.props;
      const parameters = formatParameterConfig(pipeline.parameterConfig || []);
      const triggers = pipeline.triggers || [];
      const manualExecutionTriggers = formatTriggers(triggers);
      const manualTrigger = head(manualExecutionTriggers);
      updateTriggerOptions(manualExecutionTriggers);
      formik.setFieldValue("pipeline", pipeline);
      formik.setFieldValue("parameters", parameters);
      formik.setFieldValue("trigger", manualTrigger);
      pipelineChanged(pipeline);
      triggerChanged(manualTrigger);
    };
    this.state = { planError: false };
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { formik, pipelineOptions } = this.props;
    if (this.state.planError) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "alert alert-danger"
      }, /* @__PURE__ */ React__default.createElement("p", null, "Could not load pipeline plan. Please try reloading.")));
    } else {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group row"
      }, /* @__PURE__ */ React__default.createElement(FormField, {
        label: "Pipeline",
        onChange: this.pipelineSelected,
        value: formik.values.pipeline ? formik.values.pipeline.id : "",
        input: (props) => /* @__PURE__ */ React__default.createElement(TetheredSelect, {
          ...props,
          clearable: false,
          className: "pipeline-select",
          options: pipelineOptions.map((p) => ({
            label: p.name,
            value: p.id
          }))
        })
      }));
    }
  }
}

class StageManualComponents extends React__default.Component {
  render() {
    const { command, components, updateCommand } = this.props;
    return components.map((Comp, index) => /* @__PURE__ */ React__default.createElement(Comp, {
      key: index,
      command,
      updateCommand
    }));
  }
}

class TriggerTemplate extends React__default.Component {
  render() {
    const { component: Component, updateCommand, command } = this.props;
    return /* @__PURE__ */ React__default.createElement(Component, {
      updateCommand,
      command
    });
  }
}

class Triggers extends React__default.Component {
  constructor() {
    super(...arguments);
    this.destroy$ = new Subject();
    this.updateCommand = (path, value) => {
      const { formik } = this.props;
      formik.setFieldValue(path, value);
    };
    this.updateTriggerDescription = (trigger) => {
      if (trigger && !trigger.description && Registry.pipeline.hasManualExecutionComponentForTriggerType(trigger.type)) {
        from(Registry.pipeline.getManualExecutionComponentForTriggerType(trigger.type).formatLabel(trigger)).pipe(takeUntil(this.destroy$)).subscribe((label) => {
          const newTrigger = clone(trigger);
          newTrigger.description = label;
          this.props.formik.setFieldValue("trigger", newTrigger);
          this.props.triggerChanged(newTrigger);
        });
      } else {
        this.props.triggerChanged(trigger);
      }
    };
    this.triggerSelected = (option) => {
      const triggerDescription = option.value;
      const { formik, triggers, triggerChanged } = this.props;
      const trigger = triggers.find((t) => t.description === triggerDescription);
      formik.setFieldValue("trigger", trigger);
      formik.setFieldValue("triggerInvalid", false);
      triggerChanged(trigger);
    };
  }
  componentDidMount() {
    this.updateTriggerDescription(this.props.formik.values.trigger);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { formik, triggerComponent, triggers } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group row"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      label: "Trigger",
      onChange: this.triggerSelected,
      value: formik.values.trigger ? formik.values.trigger.description : "",
      input: (props) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, triggers.length > 1 && /* @__PURE__ */ React__default.createElement(Select, {
        ...props,
        className: "trigger-select",
        clearable: false,
        options: triggers.map((t) => ({
          label: t.description,
          value: t.description
        }))
      }), triggers.length === 1 && /* @__PURE__ */ React__default.createElement("p", {
        className: "form-control-static"
      }, head(triggers).description))
    }), triggerComponent && /* @__PURE__ */ React__default.createElement("div", {
      className: "trigger-template"
    }, /* @__PURE__ */ React__default.createElement(TriggerTemplate, {
      key: formik.values.trigger.description,
      updateCommand: this.updateCommand,
      component: triggerComponent,
      command: formik.values
    })));
  }
}

function ManualExecutionFieldLayout(props) {
  const { label, help, input, actions, validation, required } = props;
  const showLabel = !isEmpty(label) || !isEmpty(help);
  const { hidden, messageNode } = validation;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-m-bottom"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, showLabel && /* @__PURE__ */ React__default.createElement("label", {
    className: "col-md-4 sm-label-right break-word"
  }, label, required && /* @__PURE__ */ React__default.createElement("span", null, "*"), " ", help), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-6"
  }, /* @__PURE__ */ React__default.createElement("div", null, input, " ", actions), !hidden && /* @__PURE__ */ React__default.createElement("div", {
    className: "message"
  }, messageNode))));
}

class ArtifactList extends React__default.Component {
  render() {
    let { artifacts } = this.props;
    artifacts = artifacts || [];
    if (artifacts.length === 0) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "artifact-list"
    }, /* @__PURE__ */ React__default.createElement("ul", null, artifacts.map((artifact, i) => {
      return /* @__PURE__ */ React__default.createElement("li", {
        key: `${i}-${name}`,
        className: "break-word"
      }, /* @__PURE__ */ React__default.createElement(Artifact, {
        artifact
      }));
    })));
  }
}

var css_248z$17 = ".manual-execution-dialog .modal-body-content {\n  overflow-y: auto;\n  overflow-x: hidden;\n  clear: both;\n  max-height: calc(100vh - 215px);\n}\n.manual-execution-dialog .modal-content {\n  overflow: visible;\n}\n.manual-execution-dialog .manual-execution-parameters-description {\n  margin-top: 20px;\n}\n.manual-execution-dialog .pipeline-select {\n  width: 100%;\n}\n.manual-execution-dialog .trigger-select {\n  width: 100%;\n}\n.manual-execution-dialog .trigger-template {\n  padding: 5px 0;\n}\n.manual-execution-dialog .parameter-option-select {\n  width: 100%;\n}\n";
styleInject(css_248z$17);

const TRIGGER_FIELDS_TO_EXCLUDE = ["correlationId", "eventId", "executionId"];
class ManualExecutionModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.formikRef = React__default.createRef();
    this.destroy$ = new Subject();
    this.submit = (values) => {
      const selectedTrigger = clone(values.trigger || {});
      const command = {
        trigger: selectedTrigger
      };
      const pipeline = values.pipeline;
      if (values.notificationEnabled && values.notification.address) {
        selectedTrigger.notifications = [values.notification];
      }
      extend(selectedTrigger, values.extraFields);
      command.pipelineName = pipeline.name;
      selectedTrigger.type = "manual";
      selectedTrigger.dryRun = values.dryRun;
      delete selectedTrigger.description;
      if (pipeline.parameterConfig && pipeline.parameterConfig.length) {
        selectedTrigger.parameters = values.parameters;
      }
      this.props.closeModal(command);
    };
    this.pipelineChanged = (pipeline) => {
      if (pipeline) {
        const executions = this.props.application.executions.data || [];
        const currentPipelineExecutions = executions.filter((execution) => execution.pipelineConfigId === pipeline.id && execution.isActive);
        this.setState({
          currentPipelineExecutions,
          pipelineNotifications: pipeline.notifications || []
        });
        this.parseManualExecution(pipeline);
      }
    };
    this.triggerChanged = (trigger) => {
      let triggerComponent = null;
      if (trigger && Registry.pipeline.hasManualExecutionComponentForTriggerType(trigger.type)) {
        triggerComponent = Registry.pipeline.getManualExecutionComponentForTriggerType(trigger.type);
      }
      this.setState({
        triggerComponent
      });
    };
    this.parseManualExecution = (pipeline) => {
      if (pipeline.type === "templatedPipeline" && (pipeline.stages === void 0 || pipeline.stages.length === 0)) {
        PipelineTemplateReader.getPipelinePlan(pipeline).then((plan) => this.setStageComponentsForManualExecution(plan.stages)).catch(() => this.setStageComponentsForManualExecution(pipeline.stages));
      } else {
        this.setStageComponentsForManualExecution(pipeline.stages);
      }
    };
    this.setStageComponentsForManualExecution = (stages) => {
      const additionalComponents = stages.map((stage) => Registry.pipeline.getManualExecutionComponentForStage(stage));
      this.setState({ stageComponents: uniq(compact(additionalComponents)) });
    };
    this.formatTriggers = (triggers) => {
      return triggers.filter((t) => Registry.pipeline.hasManualExecutionComponentForTriggerType(t.type));
    };
    this.formatPipeline = (pipeline) => {
      const newPipeline = clone(pipeline);
      newPipeline && newPipeline.parameterConfig && newPipeline.parameterConfig.forEach((parameterConfig) => {
        if (parameterConfig.default && parameterConfig.options && !parameterConfig.options.some((option) => option.value === parameterConfig.default)) {
          parameterConfig.options.unshift({ value: parameterConfig.default });
        }
      });
      return newPipeline;
    };
    this.formatParameterConfig = (parameters) => {
      const [, queryString] = window.location.href.split("?");
      const queryParams = UrlParser.parseQueryString(queryString);
      const result = {};
      parameters.forEach((parameter) => {
        const { name } = parameter;
        const { trigger } = this.props;
        const triggerParameters = trigger ? trigger.parameters : {};
        if (queryParams[name]) {
          result[name] = queryParams[name];
        } else {
          result[name] = triggerParameters[name] !== void 0 ? triggerParameters[name] : parameter.default;
        }
      });
      return result;
    };
    this.updateTriggerOptions = (triggers) => {
      triggers.map((t, i) => {
        from(Registry.pipeline.getManualExecutionComponentForTriggerType(t.type).formatLabel(t)).pipe(takeUntil(this.destroy$)).subscribe((label) => {
          const newTriggers = triggers.slice(0);
          newTriggers[i].description = label;
          this.setState({ triggers: newTriggers });
        }, () => {
          this.setState({ triggers });
        });
      });
    };
    this.generateInitialValues = (pipeline) => {
      const user = AuthenticationService.getAuthenticatedUser();
      const userEmail = user.authenticated && user.name.includes("@") ? user.name : "";
      const triggers = this.formatTriggers(pipeline && pipeline.triggers ? pipeline.triggers : []);
      let trigger;
      if (this.props.trigger) {
        trigger = pickBy(this.props.trigger, (_, key) => !TRIGGER_FIELDS_TO_EXCLUDE.includes(key));
        if (trigger.type === "manual" && triggers.length) {
          trigger.type = head(triggers).type;
        }
        const matchingTrigger = (pipeline.triggers || []).find((t) => Object.keys(t).filter((k) => k !== "description").every((k) => isEqual(get(t, k), get(trigger, k))));
        trigger = matchingTrigger ? assign(matchingTrigger, trigger) : trigger;
        if (Registry.pipeline.hasManualExecutionComponentForTriggerType(trigger.type)) {
          trigger.artifacts = [];
        }
      } else {
        trigger = head(triggers);
      }
      let parameters = {};
      if (pipeline && pipeline.parameterConfig) {
        parameters = this.formatParameterConfig(pipeline.parameterConfig);
      }
      return {
        pipeline: this.formatPipeline(pipeline),
        pipelineName: pipeline ? pipeline.name : "",
        dryRun: false,
        extraFields: {
          buildNumber: ""
        },
        notificationEnabled: false,
        notification: {
          type: "email",
          address: userEmail,
          when: ["pipeline.complete", "pipeline.failed"]
        },
        parameters,
        trigger,
        triggerInvalid: false
      };
    };
    this.validate = (values) => {
      const formValidator = new FormValidator(values);
      return formValidator.validateForm();
    };
    let modalHeader;
    if (props.pipeline) {
      modalHeader = "Select Pipeline";
      if (props.pipeline.triggers) {
        modalHeader = "Select Execution Parameters";
      } else {
        modalHeader = "Confirm Execution";
      }
    } else {
      modalHeader = "Select Pipeline";
    }
    this.state = {
      applicationNotifications: [],
      currentPipelineExecutions: props.currentlyRunningExecutions || [],
      modalHeader,
      pipelineNotifications: [],
      pipelineOptions: [],
      stageComponents: [],
      triggers: []
    };
  }
  static getPipelineTriggers(pipeline, trigger) {
    if (!isEmpty(pipeline.triggers)) {
      return pipeline.triggers;
    }
    if (trigger && trigger.type === "pipeline" && trigger.parentPipelineStageId) {
      return [
        {
          enabled: true,
          parentExecution: trigger.parentExecution,
          type: trigger.type
        }
      ];
    }
    return [];
  }
  componentDidMount() {
    const { application, pipeline, trigger } = this.props;
    let pipelineOptions = [];
    let pipelineNotifications = [];
    if (pipeline) {
      pipelineNotifications = pipeline.notifications || [];
      const pipelineTriggers = ManualExecutionModal.getPipelineTriggers(pipeline, trigger);
      const triggers = this.formatTriggers(pipelineTriggers);
      this.updateTriggerOptions(triggers);
    } else {
      pipelineOptions = application.pipelineConfigs.data.filter((c) => !c.disabled);
    }
    this.triggerChanged(trigger);
    from(AppNotificationsService.getNotificationsForApplication(application.name)).pipe(takeUntil(this.destroy$)).subscribe((notifications) => {
      const applicationNotifications = [];
      Object.keys(notifications).sort().filter((k) => Array.isArray(notifications[k])).forEach((type) => {
        if (isArray(notifications[type])) {
          notifications[type].forEach((notification) => {
            applicationNotifications.push(notification);
          });
        }
      });
      this.setState({ applicationNotifications });
    });
    this.pipelineChanged(pipeline);
    this.setState({
      dryRunEnabled: SETTINGS.feature.dryRunEnabled,
      pipelineOptions,
      pipelineNotifications
    });
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  static show(props) {
    const modalProps = {
      dialogClassName: "manual-execution-dialog modal-md"
    };
    return ReactModal.show(ManualExecutionModal, props, modalProps);
  }
  render() {
    const { dismissModal, pipeline } = this.props;
    const {
      applicationNotifications,
      currentPipelineExecutions,
      dryRunEnabled,
      modalHeader,
      pipelineNotifications,
      pipelineOptions,
      stageComponents,
      triggerComponent,
      triggers
    } = this.state;
    const notifications = applicationNotifications.concat(pipelineNotifications);
    const pipelineCommand = this.generateInitialValues(pipeline);
    return /* @__PURE__ */ React__default.createElement(SpinFormik, {
      ref: this.formikRef,
      initialValues: pipelineCommand,
      onSubmit: this.submit,
      validate: this.validate,
      render: (formik) => /* @__PURE__ */ React__default.createElement(Form, {
        className: `form-horizontal`
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: dismissModal
      }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, modalHeader)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement(LayoutProvider, {
        value: ManualExecutionFieldLayout
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "container-fluid modal-body-content"
      }, pipelineOptions.length > 0 && /* @__PURE__ */ React__default.createElement(PipelineOptions, {
        formik,
        formatPipeline: this.formatPipeline,
        formatTriggers: this.formatTriggers,
        formatParameterConfig: this.formatParameterConfig,
        pipelineOptions,
        pipelineChanged: this.pipelineChanged,
        triggerChanged: this.triggerChanged,
        updateTriggerOptions: this.updateTriggerOptions
      }), formik.values.pipeline && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: pipelineOptions.length > 0 ? "col-md-6 col-md-offset-4" : "col-md-10"
      }, /* @__PURE__ */ React__default.createElement("p", null, "This will start a new run of ", /* @__PURE__ */ React__default.createElement("strong", null, formik.values.pipeline.name), "."))), currentPipelineExecutions.length > 0 && /* @__PURE__ */ React__default.createElement(CurrentlyRunningExecutions, {
        currentlyRunningExecutions: currentPipelineExecutions
      }), pipeline && pipeline.manualStartAlert && /* @__PURE__ */ React__default.createElement(Markdown, {
        className: `alert alert-${["danger", "warning", "info"].includes(pipeline.manualStartAlert.type) ? pipeline.manualStartAlert.type : "warning"}`,
        message: pipeline.manualStartAlert.message
      }), triggers && triggers.length > 0 && /* @__PURE__ */ React__default.createElement(Triggers, {
        formik,
        triggers,
        triggerChanged: this.triggerChanged,
        triggerComponent
      }), formik.values.pipeline && formik.values.pipeline.parameterConfig && formik.values.pipeline.parameterConfig.length > 0 && /* @__PURE__ */ React__default.createElement(Parameters, {
        formik,
        parameters: formik.values.pipeline.parameterConfig
      }), stageComponents.length > 0 && /* @__PURE__ */ React__default.createElement(StageManualComponents, {
        command: formik.values,
        components: stageComponents,
        updateCommand: (path, value) => {
          formik.setFieldValue(path, value);
        }
      }), !isEmpty(get(formik.values, "trigger.artifacts")) && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("label", {
        className: "col-md-4 sm-label-right"
      }, "Artifacts"), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-8"
      }, /* @__PURE__ */ React__default.createElement(ArtifactList, {
        artifacts: formik.values.trigger.artifacts
      }))), dryRunEnabled && /* @__PURE__ */ React__default.createElement(DryRun, null), /* @__PURE__ */ React__default.createElement(NotificationDetails, {
        formik,
        notifications
      })))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        onClick: dismissModal,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !formik.isValid,
        isFormSubmit: true,
        submitting: false,
        label: "Run"
      })))
    });
  }
}

const getBakedArtifacts = (context) => {
  if ("artifacts" in context) {
    return context.artifacts.filter((a) => (a.type === ARTIFACT_TYPE_EMBEDDED || a.type === ARTIFACT_TYPE_REMOTE) && a.reference);
  } else {
    return [];
  }
};

const getContentReference = (uri) => {
  return uri.replace(/^ref?:\/\//, "");
};

function registerPluginExtensions(plugin) {
  var _a, _b, _c, _d, _e, _f;
  (_a = plugin.stages) == null ? void 0 : _a.forEach((stage) => Registry.pipeline.registerStage(stage));
  (_b = plugin.preconfiguredJobStages) == null ? void 0 : _b.forEach((stage) => Registry.pipeline.registerPreconfiguredJobStage(stage));
  toPairs((_c = plugin.help) != null ? _c : {}).forEach(([key, value]) => HelpContentsRegistry.register(key, value));
  (_d = plugin.search) == null ? void 0 : _d.forEach((search) => searchResultTypeRegistry.register(search));
  if (plugin.managedDelivery || plugin.resourceKinds) {
    const managedDeliveryPlugin = {
      ...plugin.managedDelivery,
      resources: plugin.resourceKinds || ((_e = plugin.managedDelivery) == null ? void 0 : _e.resources)
    };
    registerManagedDeliveryPlugin(managedDeliveryPlugin);
  }
  return Promise.resolve((_f = plugin.initialize) == null ? void 0 : _f.call(plugin, plugin));
}

class PluginRegistry {
  constructor() {
    this.pluginManifests = [];
  }
  getRegisteredPlugins() {
    return this.pluginManifests.slice();
  }
  registerPluginMetaData(source, pluginMetaData) {
    const metaData = this.normalize(source, pluginMetaData);
    const duplicateMetaData = this.pluginManifests.find((x) => x.id === metaData.id);
    if (duplicateMetaData) {
      if (metaData.source === duplicateMetaData.source) {
        console.error(`Attempted to load two copies of the same plugin from ${source}`, metaData, duplicateMetaData);
        throw new Error(`Attempted to load two copies of the same plugin from ${source}`);
      } else {
        console.log(`Attempted to load plugin ${pluginMetaData.id} from gate and deck.   Using plugin from deck.`);
        if (source === "deck") {
          this.pluginManifests = this.pluginManifests.filter((x) => x !== duplicateMetaData);
        } else if (source === "gate") {
          return void 0;
        }
      }
    }
    this.validateMetaData(metaData);
    this.pluginManifests.push(metaData);
    return metaData;
  }
  normalize(source, pluginMetaData) {
    const { devUrl, url, id, name, ...rest } = pluginMetaData;
    return {
      id: id != null ? id : name,
      url: url != null ? url : devUrl,
      source,
      ...rest
    };
  }
  validateMetaData(pluginMetaData) {
    if (!pluginMetaData) {
      throw new Error(`Invalid plugin manifest: received ${pluginMetaData} object`);
    }
    const keys = ["id", "version"];
    const missingKeys = keys.filter((key) => !pluginMetaData[key]);
    if (missingKeys.length) {
      throw new Error(`Invalid plugin manifest: Required key is missing: '${missingKeys.join(", ")}'`);
    }
  }
  loadPluginManifestFromDeck() {
    const source = "deck";
    const uri = "/plugin-manifest.json";
    const loadPromise = Promise.resolve($http.get(uri)).then((response) => response.data).catch((error) => {
      console.error(`Failed to load ${uri} from ${source}`);
      throw error;
    });
    return this.loadPluginManifest(source, uri, loadPromise);
  }
  loadPluginManifestFromGate() {
    const source = "gate";
    const uri = "/plugins/deck/plugin-manifest.json";
    const loadPromise = REST(uri).get().catch((error) => {
      console.error(`Failed to load ${uri} from ${source}`);
      if (error.data.status === 404) {
        console.error(error);
        return Promise.resolve([]);
      }
      throw error;
    });
    return this.loadPluginManifest(source, uri, loadPromise);
  }
  async loadPluginManifest(source, location, pluginsMetaDataPromise) {
    try {
      const plugins = await pluginsMetaDataPromise;
      return plugins.map((pluginMetaData) => this.registerPluginMetaData(source, pluginMetaData));
    } catch (error) {
      console.error(`Error loading plugin manifest from ${location}`);
      throw error;
    }
  }
  loadPlugins() {
    return Promise.all(this.pluginManifests.map((plugin) => this.load(plugin)));
  }
  async load(pluginMetaData) {
    var _a;
    this.validateMetaData(pluginMetaData);
    const { devUrl, url } = pluginMetaData;
    const gateUrl = `${SETTINGS.gateUrl}/plugins/deck/${pluginMetaData.id}/${pluginMetaData.version}/index.js`;
    const pluginUrl = (_a = url != null ? url : devUrl) != null ? _a : gateUrl;
    try {
      const module = await this.loadModuleFromUrl(pluginUrl);
      Object.assign(pluginMetaData, { module });
      if (!module || !module.plugin) {
        throw new Error(`Successfully loaded plugin module from ${pluginUrl}, but it doesn't export an object called 'plugin'`);
      }
      return registerPluginExtensions(module.plugin).then(() => module);
    } catch (error) {
      console.error(`Failed to load plugin code from ${pluginUrl}`);
      throw error;
    }
  }
  loadModuleFromUrl(url) {
    return import(
      /* webpackIgnore: true */
      /* @vite-ignore */
      url
    );
  }
}

const sharedLibraries = {
  globalVariablePrefix: "spinnaker.plugins.sharedLibraries",
  sanitizeLibraryName(libraryName) {
    return libraryName.replace(/[^\w]/g, "_");
  },
  exposeSharedLibraries() {
    const destinationObject = _$1.get(window, this.globalVariablePrefix);
    const exposeSharedLibrary = (libraryName, library) => {
      const sanitizedLibraryName = this.sanitizeLibraryName(libraryName);
      destinationObject[sanitizedLibraryName] = library;
    };
    if (destinationObject) {
      exposeSharedLibrary("ajv", require("ajv"));
      exposeSharedLibrary("@spinnaker/core", spinnakerCore);
      exposeSharedLibrary("@spinnaker/kayenta", require("@spinnaker/kayenta"));
      exposeSharedLibrary("@uirouter/core", uiRouterCore);
      exposeSharedLibrary("@uirouter/react", uiRouterReact);
      exposeSharedLibrary("@uirouter/rx", uiRouterRx);
      exposeSharedLibrary("lodash", _$1);
      exposeSharedLibrary("prop-types", propTypes);
      exposeSharedLibrary("react", React);
      exposeSharedLibrary("react-dom", ReactDOM);
      exposeSharedLibrary("react-redux", require("react-redux"));
      exposeSharedLibrary("redux-actions", require("redux-actions"));
      exposeSharedLibrary("reselect", require("reselect"));
      exposeSharedLibrary("rxjs", rxjs);
      exposeSharedLibrary("rxjs/Observable", { Observable: rxjs.Observable });
    }
  }
};

const PLUGINS_MODULE = "netflix.spinnaker.plugins";
module(PLUGINS_MODULE, ["ui.router"]).config([
  "$uiRouterProvider",
  ($uiRouterProvider) => {
    $uiRouterProvider.urlService.deferIntercept();
    sharedLibraries.exposeSharedLibraries();
  }
]).run([
  "$rootScope",
  "$uiRouter",
  async ($rootScope, $uiRouter) => {
    const pluginRegistry = new PluginRegistry();
    try {
      await Promise.all([pluginRegistry.loadPluginManifestFromDeck(), pluginRegistry.loadPluginManifestFromGate()]);
      await pluginRegistry.loadPlugins();
    } finally {
      $rootScope.$applyAsync(() => {
        $uiRouter.urlService.listen();
        $uiRouter.urlService.sync();
      });
    }
  }
]);

class Applications$1 extends React__default.Component {
  validate(project) {
    const configuredApps = project.config && project.config.applications || [];
    const getApplicationError = (app) => this.props.allApplications.includes(app) ? void 0 : `Application '${app}' does not exist.`;
    const applicationErrors = configuredApps.map(getApplicationError);
    if (!applicationErrors.some((err) => !!err)) {
      return {};
    }
    return {
      config: {
        applications: applicationErrors
      }
    };
  }
  componentDidUpdate(prevProps) {
    const prevApps = getIn$1(prevProps.formik.values, "config.applications", []);
    const nextApps = getIn$1(this.props.formik.values, "config.applications", []);
    if (!isEqual(prevApps, nextApps)) {
      const existingPipelineConfigs = getIn$1(this.props.formik.values, "config.pipelineConfigs", []);
      const newPipelineConfigs = existingPipelineConfigs.filter(({ application }) => nextApps.includes(application));
      this.props.formik.setFieldValue("config.pipelineConfigs", newPipelineConfigs);
    }
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "config.applications",
      input: (props) => /* @__PURE__ */ React__default.createElement(ApplicationsPickerInput, {
        multi: true,
        ...props
      })
    });
  }
}

class Clusters extends React__default.Component {
  constructor() {
    super(...arguments);
    this.validate = (value) => {
      const applications = value.config.applications || [];
      if (value.config.clusters && value.config.clusters.length) {
        const clusterErrors = value.config.clusters.map((cluster) => {
          const errors = {};
          if (!cluster.account) {
            errors.account = "Account must be specified";
          }
          const apps = cluster.applications || [];
          const applicationErrors = apps.map((app) => !applications.includes(app) && "This app is not in the project");
          if (applicationErrors.some((val) => !!val)) {
            errors.applications = applicationErrors;
          }
          const areStackAndDetailDisabled = this.areStackAndDetailDisabled(cluster);
          const stackErrors = areStackAndDetailDisabled && cluster.stack !== "*" && "Only * is valid for the selected account";
          if (stackErrors) {
            errors.stack = stackErrors;
          }
          const detailErrors = areStackAndDetailDisabled && cluster.detail !== "*" && "Only * is valid for the selected account";
          if (detailErrors) {
            errors.detail = detailErrors;
          }
          return Object.keys(errors).length ? errors : null;
        });
        if (clusterErrors.some((val) => !!val)) {
          return {
            config: {
              clusters: clusterErrors
            }
          };
        }
      }
      return {};
    };
  }
  toggleAllApps(formik, path) {
    const isChecked = !getIn$1(formik.values, path);
    formik.setFieldValue(path, isChecked ? [] : null);
  }
  areStackAndDetailDisabled(cluster) {
    if (!cluster || !cluster.account) {
      return false;
    }
    const account = this.props.accounts.find(({ name }) => name === cluster.account);
    return account.type === "kubernetes";
  }
  render() {
    const { accounts } = this.props;
    const tableHeader = /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
      style: { width: "200px" }
    }, "Application"), /* @__PURE__ */ React__default.createElement("td", {
      style: { width: "200px" }
    }, "Account"), /* @__PURE__ */ React__default.createElement("td", null, "Stack ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "project.cluster.stack"
    })), /* @__PURE__ */ React__default.createElement("td", null, "Detail ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "project.cluster.detail"
    })), /* @__PURE__ */ React__default.createElement("td", {
      style: { width: "30px" }
    }));
    return /* @__PURE__ */ React__default.createElement(FieldArray, {
      name: "config.clusters",
      render: (clustersArrayHelpers) => {
        const formik = clustersArrayHelpers.form;
        const values = formik.values;
        const clusters = values.config.clusters || [];
        const applications = values.config.applications || [];
        const accountNames = accounts.map((account) => account.name);
        return /* @__PURE__ */ React__default.createElement("section", {
          className: "ConfigureProject-Clusters vertical center"
        }, /* @__PURE__ */ React__default.createElement("table", {
          style: { width: "100%" },
          className: "table-condensed"
        }, /* @__PURE__ */ React__default.createElement("thead", null, tableHeader), /* @__PURE__ */ React__default.createElement("tbody", null, clusters.map((cluster, idx) => {
          const clusterPath = `config.clusters[${idx}]`;
          const applicationsPath = `${clusterPath}.applications`;
          return /* @__PURE__ */ React__default.createElement("tr", {
            key: idx
          }, /* @__PURE__ */ React__default.createElement("td", {
            className: "vertical"
          }, /* @__PURE__ */ React__default.createElement("label", {
            className: "sp-group-margin-s-xaxis"
          }, /* @__PURE__ */ React__default.createElement("input", {
            type: "checkbox",
            onChange: () => this.toggleAllApps(formik, applicationsPath),
            checked: !Array.isArray(cluster.applications)
          }), /* @__PURE__ */ React__default.createElement("span", null, "All")), !!cluster.applications && /* @__PURE__ */ React__default.createElement(FormikFormField, {
            name: applicationsPath,
            input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
              multi: true,
              stringOptions: applications,
              ...props
            })
          })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
            name: `${clusterPath}.account`,
            layout: ({ input }) => /* @__PURE__ */ React__default.createElement("div", null, input),
            input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
              ...props,
              clearable: false,
              stringOptions: accountNames
            })
          })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
            name: `${clusterPath}.stack`,
            input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
              ...props,
              inputClassName: "sp-padding-xs-xaxis"
            })
          })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
            name: `${clusterPath}.detail`,
            input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
              ...props,
              inputClassName: "sp-padding-xs-xaxis"
            })
          })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
            className: "nostyle",
            onClick: () => clustersArrayHelpers.remove(idx)
          }, /* @__PURE__ */ React__default.createElement("i", {
            className: "fas fa-trash-alt"
          }))));
        }))), /* @__PURE__ */ React__default.createElement("a", {
          className: "button zombie sp-margin-m horizontal middle center",
          onClick: () => clustersArrayHelpers.push({ stack: "*", detail: "*" })
        }, /* @__PURE__ */ React__default.createElement("i", {
          className: "fas fa-plus-circle"
        }), " Add Cluster"));
      }
    });
  }
}

const _Pipelines = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      appsPipelines: {},
      initialized: false
    };
    this.validate = (value) => {
      const projectApplications = value.config && value.config.applications || [];
      const { appsPipelines, initialized } = this.state;
      if (initialized && value.config && value.config.pipelineConfigs && value.config.pipelineConfigs.length) {
        const pipelineConfigErrors = value.config.pipelineConfigs.map((config) => {
          const pipelineIdsForApp = appsPipelines[config.application].map((p) => p.id);
          if (!config.application) {
            return { application: "Application must be specified" };
          } else if (!projectApplications.includes(config.application)) {
            return { application: "This application is not part of the project" };
          } else if (!config.pipelineConfigId) {
            return { pipelineConfigId: "Pipeline must be specified" };
          } else if (!pipelineIdsForApp.includes(config.pipelineConfigId)) {
            return { pipelineConfigId: `Pipeline does not exist in ${config.application}` };
          }
          return null;
        });
        if (pipelineConfigErrors.some((val) => !!val)) {
          return {
            config: {
              pipelineConfigs: pipelineConfigErrors
            }
          };
        }
      }
      return {};
    };
    this.getProjectPipelines = (props) => {
      return get(props.formik.values, _Pipelines.pipelineConfigsPath, []);
    };
    this.fetchPipelinesForApps = (projectPipelines) => {
      const appsToFetch = chain(projectPipelines).map("application").uniq().filter((appName) => appName && !this.state.appsPipelines[appName]).value();
      const appsPipelines = { ...this.state.appsPipelines };
      Promise.all(appsToFetch.map((appName) => {
        return PipelineConfigService.getPipelinesForApplication(appName).then((pipelines) => {
          appsPipelines[appName] = pipelines;
        }).catch(() => {
          appsPipelines[appName] = [];
        });
      })).then(() => {
        this.setState({ appsPipelines, initialized: true });
      });
    };
  }
  componentDidMount() {
    this.fetchPipelinesForApps(this.getProjectPipelines(this.props));
  }
  componentDidUpdate(prevProps) {
    if (!isEqual(this.getProjectPipelines(prevProps), this.getProjectPipelines(this.props))) {
      this.fetchPipelinesForApps(this.getProjectPipelines(this.props));
    }
  }
  render() {
    const { appsPipelines, initialized } = this.state;
    if (!initialized) {
      return /* @__PURE__ */ React__default.createElement("div", {
        style: { height: "200px" }
      }, /* @__PURE__ */ React__default.createElement(Spinner, {
        size: "medium"
      }));
    }
    const tableHeader = /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, "App"), /* @__PURE__ */ React__default.createElement("td", null, "Pipeline"), /* @__PURE__ */ React__default.createElement("td", {
      style: { width: "30px" }
    }));
    return /* @__PURE__ */ React__default.createElement(FieldArray, {
      name: _Pipelines.pipelineConfigsPath,
      render: (pipelinesArrayHelper) => {
        const project = pipelinesArrayHelper.form.values;
        const configs = getIn$1(project, _Pipelines.pipelineConfigsPath);
        const apps = getIn$1(project, "config.applications");
        return /* @__PURE__ */ React__default.createElement("div", {
          className: "ConfigureProject-Pipelines vertical center"
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "vertical center",
          style: { width: "100%" }
        }, /* @__PURE__ */ React__default.createElement("table", {
          style: { width: "100%" },
          className: "table-condensed"
        }, /* @__PURE__ */ React__default.createElement("thead", null, tableHeader), /* @__PURE__ */ React__default.createElement("tbody", null, configs.map((config, idx) => {
          const pipelinePath = `${_Pipelines.pipelineConfigsPath}[${idx}]`;
          const application = config && config.application;
          const appPipelines = application && appsPipelines[application];
          const pipelineOptions = appPipelines && appPipelines.map((p) => ({ label: p.name, value: p.id }));
          const key = `${application}-${config && config.pipelineConfigId}-${idx}`;
          return /* @__PURE__ */ React__default.createElement("tr", {
            key
          }, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
            name: `${pipelinePath}.application`,
            layout: ({ input }) => /* @__PURE__ */ React__default.createElement("div", null, input),
            input: (props) => /* @__PURE__ */ React__default.createElement(StringsAsOptions, {
              strings: apps
            }, (options) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
              ...props,
              clearable: false,
              options
            }))
          })), /* @__PURE__ */ React__default.createElement("td", null, !application ? null : !pipelineOptions ? /* @__PURE__ */ React__default.createElement(Spinner, null) : /* @__PURE__ */ React__default.createElement(FormikFormField, {
            name: `${pipelinePath}.pipelineConfigId`,
            layout: ({ input }) => /* @__PURE__ */ React__default.createElement("div", null, input),
            input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
              ...props,
              clearable: false,
              options: pipelineOptions
            })
          })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
            className: "nostyle",
            onClick: () => pipelinesArrayHelper.remove(idx)
          }, /* @__PURE__ */ React__default.createElement("i", {
            className: "fas fa-trash-alt"
          }))));
        }))), /* @__PURE__ */ React__default.createElement("a", {
          className: "button zombie sp-margin-m horizontal middle center",
          onClick: () => pipelinesArrayHelper.push({})
        }, /* @__PURE__ */ React__default.createElement("i", {
          className: "fas fa-plus-circle"
        }), " Add Pipeline")));
      }
    });
  }
};
let Pipelines$1 = _Pipelines;
Pipelines$1.pipelineConfigsPath = "config.pipelineConfigs";

class ProjectAttributes extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      showProjectDeleteForm: false,
      projectNameForDeletion: null
    };
    this.DeleteConfirmation = ({ projectName }) => {
      const { onDelete } = this.props;
      const { projectNameForDeletion } = this.state;
      const matchError = projectNameForDeletion !== projectName;
      const handleCancelClicked = () => this.setState({ showProjectDeleteForm: false, projectNameForDeletion: null });
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "well"
      }, /* @__PURE__ */ React__default.createElement("p", null, `Type the name of the project (${projectName}) below to continue.`), /* @__PURE__ */ React__default.createElement(FormField, {
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props,
          id: "projectNameForDeletion",
          placeholder: "Project Name"
        }),
        value: projectNameForDeletion || "",
        onChange: (evt) => this.setState({ projectNameForDeletion: evt.target.value }),
        validate: () => matchError && "Project name does not match",
        touched: projectNameForDeletion != null,
        required: true
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: "sp-margin-m-top sp-group-margin-s-xaxis"
      }, /* @__PURE__ */ React__default.createElement("button", {
        type: "button",
        className: "passive",
        onClick: handleCancelClicked
      }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
        type: "button",
        className: "primary",
        disabled: matchError,
        onClick: () => onDelete()
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-trash"
      }), " Delete project")));
    };
    this.DeleteButton = () => {
      const handleDeleteClicked = () => {
        this.setState({ showProjectDeleteForm: true }, () => document.getElementById("projectNameForDeletion").focus());
      };
      return /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default btn-sm",
        onClick: handleDeleteClicked
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-trash"
      }), " Delete Project");
    };
  }
  validate(values) {
    const errors = {};
    const isValidName = (name) => {
      const namePattern = /^[^\\^/?%#]*$/;
      return name.match(namePattern);
    };
    const isValidEmail = (email) => {
      const emailPattern = /^(.+)@(.+).([A-Za-z]{2,6})/;
      return email.match(emailPattern);
    };
    const { allProjects } = this.props;
    const allProjectNames = allProjects.map((project) => project.name.toLowerCase());
    if (!values.name) {
      errors.name = "Please enter a project name";
    } else if (!isValidName(values.name)) {
      errors.name = "Project name cannot contain any of the following characters:  / % #";
    } else if (allProjectNames.includes(values.name.toLowerCase())) {
      errors.name = "There is already a project with that name";
    }
    if (!values.email) {
      errors.email = "Please enter an email address";
    } else if (values.email && !isValidEmail(values.email)) {
      errors.email = "Please enter a valid email address";
    }
    return errors;
  }
  render() {
    const { formik } = this.props;
    const { DeleteConfirmation, DeleteButton } = this;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-m-bottom"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props,
        placeholder: "Project Name"
      }),
      name: "name",
      label: "Project Name",
      required: true
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-m-bottom"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props,
        placeholder: "Enter an email address"
      }),
      name: "email",
      label: "Owner Email",
      required: true
    })), this.state.showProjectDeleteForm ? /* @__PURE__ */ React__default.createElement(DeleteConfirmation, {
      projectName: formik.values.name
    }) : /* @__PURE__ */ React__default.createElement(DeleteButton, null));
  }
}

class ProjectReader {
  static listProjects() {
    return REST("/projects").get();
  }
  static getProjectConfig(projectName) {
    return REST("/projects").path(projectName).get();
  }
  static getProjectClusters(projectName) {
    return REST("/projects").path(projectName, "clusters").get();
  }
}

class ProjectWriter {
  static upsertProject(project) {
    const descriptor = project.id ? "Update" : "Create";
    return TaskExecutor.executeTask({
      application: "spinnaker",
      job: [
        {
          type: "upsertProject",
          project
        }
      ],
      project,
      description: `${descriptor} project: ${project.name}`
    });
  }
  static deleteProject(project) {
    return TaskExecutor.executeTask({
      application: "spinnaker",
      job: [
        {
          type: "deleteProject",
          project: {
            id: project.id
          }
        }
      ],
      project,
      description: "Delete project: " + project.name
    });
  }
}

var css_248z$16 = ".ConfigureProject-Applications i,\n.ConfigureProject-Pipelines i,\n.ConfigureProject-Clusters i {\n  color: var(--color-accent);\n}\n\n.ConfigureProject-Pipelines table thead td,\n.ConfigureProject-Clusters table thead td {\n  border-bottom: 1px solid var(--color-divider);\n}\n\n.ConfigureProject-Pipelines .button.zombie,\n.ConfigureProject-Clusters .button.zombie {\n  width: 80%;\n}\n\n.ConfigureProject-Clusters table td {\n  vertical-align: top;\n}\n";
styleInject(css_248z$16);

const _ConfigureProjectModal = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      loading: true,
      allAccounts: [],
      allProjects: [],
      allApplications: []
    };
    this.submit = (project) => {
      const { name } = project;
      const taskMonitor = new TaskMonitor({
        title: "Updating Project",
        modalInstance: TaskMonitor.modalInstanceEmulation(() => this.props.closeModal({ name, action: "upsert" }))
      });
      this.setState({ taskMonitor });
      taskMonitor.submit(() => ProjectWriter.upsertProject(project));
    };
    this.onDelete = () => {
      const { projectConfiguration } = this.props;
      const { name } = projectConfiguration;
      if (projectConfiguration) {
        const taskMonitor = new TaskMonitor({
          title: "Deleting Project",
          modalInstance: TaskMonitor.modalInstanceEmulation(() => this.props.closeModal({ name, action: "delete" }))
        });
        this.setState({ taskMonitor });
        taskMonitor.submit(() => ProjectWriter.deleteProject(projectConfiguration));
      }
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "wizard-modal modal-lg" };
    if (props) {
      return ReactModal.show(_ConfigureProjectModal, props, modalProps);
    }
    const title = "Create Project";
    const projectConfiguration = {
      config: {
        applications: [],
        clusters: [],
        pipelineConfigs: []
      },
      email: "",
      name: ""
    };
    const projectProps = { title, projectConfiguration };
    return ReactModal.show(_ConfigureProjectModal, projectProps, modalProps);
  }
  componentDidMount() {
    this.initialFetch().then(() => this.setState({ loading: false }));
  }
  initialFetch() {
    const fetchAccounts = AccountService.listAccounts();
    const fetchApps = ApplicationReader.listApplications();
    const fetchProjects = ProjectReader.listProjects();
    const currentProject = this.props.projectConfiguration.name;
    return Promise.all([fetchAccounts, fetchApps, fetchProjects]).then(([allAccounts, allApplications, allProjects]) => {
      allProjects = allProjects.filter((project) => project.name !== currentProject);
      this.setState({ allAccounts, allApplications, allProjects });
    });
  }
  render() {
    const { dismissModal, projectConfiguration } = this.props;
    const { allAccounts, allApplications, allProjects, loading, taskMonitor } = this.state;
    const appNames = allApplications.map((app) => app.name);
    return /* @__PURE__ */ React__default.createElement(WizardModal, {
      closeModal: this.submit,
      dismissModal,
      heading: "Configure Project",
      initialValues: projectConfiguration,
      loading,
      submitButtonLabel: "Save",
      taskMonitor,
      render: ({ nextIdx, wizard, formik }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Project Attributes",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(ProjectAttributes, {
          ref: innerRef,
          formik,
          allProjects,
          onDelete: this.onDelete
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Applications",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(Applications$1, {
          ref: innerRef,
          formik,
          allApplications: appNames
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Clusters",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(Clusters, {
          ref: innerRef,
          accounts: allAccounts
        })
      }), /* @__PURE__ */ React__default.createElement(WizardPage, {
        label: "Pipelines",
        wizard,
        order: nextIdx(),
        render: ({ innerRef }) => /* @__PURE__ */ React__default.createElement(Pipelines$1, {
          ref: innerRef,
          formik
        })
      }))
    });
  }
};
let ConfigureProjectModal = _ConfigureProjectModal;
ConfigureProjectModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

var css_248z$15 = ".project-header {\n  background-color: var(--color-white);\n  border-bottom: 1px solid var(--color-alto);\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-bottom: 0;\n  flex: 0 0 auto;\n}\n.project-header .container {\n  width: 100%;\n}\n.project-header h2 {\n  display: inline-block;\n  margin-top: 10px;\n  margin-left: 46px;\n}\n.project-header .nav-popover-menu {\n  z-index: 25;\n}\n.project-header .project-name {\n  font-weight: 300;\n}\n.project-header .project-view {\n  position: relative;\n  display: inline-block;\n}\n.project-header .configure-project-link {\n  margin: 10px 0 5px;\n  color: var(--color-dovegray);\n  font-size: 120%;\n}\n.project-details {\n  overflow-y: hidden;\n}\n.project-details .insight .detail-content {\n  height: calc(100% - 54px);\n}\n.table-search-results-project .table-header .col-name,\n.table-search-results-project .table-row .col-name {\n  width: 250px;\n}\n";
styleInject(css_248z$15);

var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __decorateClass$i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$i(target, key, result);
  return result;
};
let ProjectHeader = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { state: null, application: null, isOpen: false };
    this.destroy$ = new Subject();
    this.handleDropdownToggle = (isOpen) => this.setState({ isOpen });
    this.configureProject = () => {
      const { projectConfiguration } = this.props;
      const { $state } = ReactInjector;
      const title = "Configure project";
      ConfigureProjectModal.show({ title, projectConfiguration }).then((result) => {
        if (result.action === "delete") {
          $state.go("home.infrastructure");
        } else if (result.action === "upsert") {
          $state.go($state.current, { project: result.name }, { location: "replace", reload: true });
        }
      });
    };
  }
  componentDidMount() {
    const { success$ } = this.props.transition.router.globals;
    success$.pipe(takeUntil(this.destroy$)).subscribe((success) => {
      const state = success.to().name;
      const application = success.params().application;
      this.setState({ state, application });
    });
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { projectConfiguration: project } = this.props;
    const { application, state } = this.state;
    const config = project.config;
    const isDashboard = state === "home.project.dashboard";
    const title = isDashboard ? "Project Dashboard" : application;
    if (project.notFound) {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "flex-fill application"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "row",
        "ng-if": "vm.project.notFound"
      }, /* @__PURE__ */ React__default.createElement("h1", {
        className: "text-center"
      }, "<404>"), /* @__PURE__ */ React__default.createElement("p", {
        className: "text-center"
      }, "Please check your URL - we can't find any data for the project ", /* @__PURE__ */ React__default.createElement("em", null, project.name), ".")));
    }
    const chevronStyle = {
      transition: "transform 0.15s ease",
      transform: `rotate(${this.state.isOpen ? 180 : 0}deg)`
    };
    const closeDropdown = () => document.body.click();
    const projectConfiguration = /* @__PURE__ */ React__default.createElement("div", {
      className: "pull-right",
      "ng-if": "vm.viewState.dashboard"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "passive medium btn-configure configure-project-link",
      onClick: this.configureProject
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-cog"
    }), " Project Configuration"));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-fill application"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "project-header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "container"
    }, /* @__PURE__ */ React__default.createElement("h2", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "project-name"
    }, project.name, " / "), /* @__PURE__ */ React__default.createElement("div", {
      className: "project-view"
    }, /* @__PURE__ */ React__default.createElement(Dropdown, {
      id: "project",
      pullRight: true,
      componentClass: "div",
      onToggle: this.handleDropdownToggle
    }, /* @__PURE__ */ React__default.createElement(SpanDropdownTrigger, {
      bsRole: "toggle",
      className: "clickable"
    }, title, " ", /* @__PURE__ */ React__default.createElement("span", {
      className: "small glyphicon glyphicon-chevron-down",
      style: chevronStyle
    })), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, null, /* @__PURE__ */ React__default.createElement(UISref, {
      to: ".dashboard"
    }, /* @__PURE__ */ React__default.createElement(MenuItem, {
      onClick: closeDropdown
    }, "Project Dashboard")), /* @__PURE__ */ React__default.createElement(MenuItem, {
      divider: true
    }), config.applications && config.applications.sort().map((app) => /* @__PURE__ */ React__default.createElement(UISref, {
      key: app,
      to: ".application",
      params: { application: app }
    }, /* @__PURE__ */ React__default.createElement(MenuItem, {
      onClick: closeDropdown
    }, " ", app, " "))))))), isDashboard && projectConfiguration)), /* @__PURE__ */ React__default.createElement(UIView, {
      name: "detail",
      className: "project-details flex-fill"
    }));
  }
};
ProjectHeader = __decorateClass$i([
  Overridable("createProjectHeader")
], ProjectHeader);

class ProjectsSearchResultType extends SearchResultType {
  constructor() {
    super(...arguments);
    this.id = "projects";
    this.order = 0;
    this.displayName = "Projects";
    this.iconClass = "far fa-folder";
    this.cols = {
      NAME: { key: "name" },
      EMAIL: { key: "email" }
    };
    this.TabComponent = DefaultSearchResultTab;
    this.HeaderComponent = () => /* @__PURE__ */ React__default.createElement(SearchTableHeader, null, /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.NAME
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.EMAIL
    }));
    this.DataComponent = ({ resultSet }) => {
      const itemKeyFn = (item) => item.id;
      const itemSortFn = (a, b) => a.name.localeCompare(b.name);
      const results = resultSet.results.slice().sort(itemSortFn);
      return /* @__PURE__ */ React__default.createElement(SearchTableBody, null, results.slice().sort(itemSortFn).map((item) => /* @__PURE__ */ React__default.createElement(SearchTableRow, {
        key: itemKeyFn(item)
      }, /* @__PURE__ */ React__default.createElement(HrefCell, {
        item,
        col: this.cols.NAME
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.EMAIL
      }))));
    };
  }
  displayFormatter(searchResult) {
    const applications = searchResult.config && searchResult.config.applications ? ` (${searchResult.config.applications.join(", ")})` : "";
    const project = searchResult.name || searchResult.project;
    return project + applications;
  }
}
searchResultTypeRegistry.register(new ProjectsSearchResultType());

class PubsubSubscriptionReader {
  static getPubsubSubscriptions() {
    return REST("/pubsub/subscriptions").get();
  }
}

function RegionSelectInput(props) {
  const { account, readOnly, regions, ...otherProps } = props;
  if (!account) {
    return /* @__PURE__ */ React__default.createElement("div", null, "(Select an account)");
  } else if (readOnly) {
    return /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, props.value);
  }
  const allRegions = regions ? regions : [];
  const options = allRegions.map((region) => ({
    value: region.name,
    label: `${region.name}${region.deprecated ? " (deprecated in the '" + account + "' account)" : ""}`
  }));
  options.unshift({ label: "Select...", value: "", disabled: true });
  return /* @__PURE__ */ React__default.createElement(SelectInput, {
    ...otherProps,
    className: "form-control input-sm",
    options
  });
}

class RegionSelectField extends React__default.Component {
  handleChange(event) {
    const { component, onChange, field } = this.props;
    component[field] = event.target.value;
    onChange(event.target.value);
    $rootScope.$apply();
    this.setState({});
  }
  render() {
    const { labelColumns, fieldColumns, account, regions, readOnly, component, field } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: `col-md-${labelColumns} sm-label-right`
    }, "Region"), /* @__PURE__ */ React__default.createElement("div", {
      className: `col-md-${fieldColumns || 7}`
    }, /* @__PURE__ */ React__default.createElement(RegionSelectInput, {
      account,
      regions,
      readOnly,
      value: component[field],
      onChange: (evt) => this.handleChange(evt)
    })));
  }
}

class RetryService {
  static buildRetrySequence(func, stopCondition, limit, interval) {
    const call = func();
    const promise = call.hasOwnProperty("then") ? call : $q.resolve(call);
    if (limit === 0) {
      return promise;
    } else {
      return promise.then((result) => {
        if (stopCondition(result)) {
          return result;
        } else {
          return $timeout(interval).then(() => this.buildRetrySequence(func, stopCondition, limit - 1, interval));
        }
      }).catch(() => $timeout(interval).then(() => this.buildRetrySequence(func, stopCondition, limit - 1, interval)));
    }
  }
}

const ItemDetails = ({ item, transformName }) => /* @__PURE__ */ React.createElement("div", {
  className: "flex-container-h"
}, /* @__PURE__ */ React.createElement("div", {
  className: "flex-grow"
}, /* @__PURE__ */ React.createElement("span", {
  className: "small"
}, /* @__PURE__ */ React.createElement(StatusGlyph, {
  item
})), transformName ? robotToHuman(item.name) : item.name), /* @__PURE__ */ React.createElement("div", {
  className: "flex-pull-right"
}, duration(item.runningTimeInMs)));
const RunningTasksPopoverContent = ({ executions, tasks }) => {
  const sortedTasks = orderBy(tasks || [], ["startTime"], ["asc"]);
  return /* @__PURE__ */ React.createElement("div", {
    className: "RunningTasksPopoverContent"
  }, /* @__PURE__ */ React.createElement("div", null, sortedTasks.map((task, index) => /* @__PURE__ */ React.createElement("div", {
    key: `task-${index}`
  }, /* @__PURE__ */ React.createElement("strong", null, task.name), displayableTasks(task.steps).map((step, i) => /* @__PURE__ */ React.createElement(ItemDetails, {
    key: `task-step-${i}`,
    item: step,
    transformName: true
  }))))), /* @__PURE__ */ React.createElement("div", null, executions.map((execution, index) => /* @__PURE__ */ React.createElement("div", {
    key: `execution-${index}`
  }, /* @__PURE__ */ React.createElement("strong", null, " Pipeline: ", execution.name, " "), (execution.stages || []).map((stage, i) => /* @__PURE__ */ React.createElement(ItemDetails, {
    key: `execution-stage-${i}`,
    item: stage
  }))))));
};

const RunningTasksTag = ({ executions, tasks }) => {
  const runningExecutions = (executions || []).filter((e) => e.isRunning || e.hasNotStarted);
  const PopoverContent = React.useCallback(() => /* @__PURE__ */ React.createElement(RunningTasksPopoverContent, {
    executions: runningExecutions,
    tasks
  }), [tasks, runningExecutions]);
  if (!(tasks == null ? void 0 : tasks.length) && !runningExecutions.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("span", {
    className: "RunningTasksTag"
  }, /* @__PURE__ */ React.createElement(HoverablePopover, {
    Component: PopoverContent,
    className: "menu-running-tasks"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "icon"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon icon-spinner fa-spin-slow"
  }))));
};

var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __decorateClass$h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$h(target, key, result);
  return result;
};
class LoadBalancers$2 extends React__default.Component {
  render() {
    const { application, serverGroup } = this.props;
    const hasLoadBalancer = !!get(serverGroup, "loadBalancers.length") || !!get(serverGroup, "targetGroups.length");
    return hasLoadBalancer && /* @__PURE__ */ React__default.createElement(LoadBalancersTagWrapper, {
      key: "lbwrapper",
      application,
      serverGroup
    });
  }
}
class MultiSelectCheckbox extends React__default.Component {
  render() {
    const {
      isMultiSelected,
      sortFilter: { multiselect }
    } = this.props;
    return multiselect && /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: isMultiSelected
    });
  }
}
class CloudProviderIcon extends React__default.Component {
  render() {
    const { serverGroup } = this.props;
    return /* @__PURE__ */ React__default.createElement(CloudProviderLogo, {
      provider: serverGroup.type,
      height: "16px",
      width: "16px"
    });
  }
}
class ImageList extends React__default.Component {
  toggle() {
    this.setState((previousState) => {
      return { collapsed: !previousState.collapsed };
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true
    };
    this.toggle = this.toggle.bind(this);
  }
  render() {
    const images = this.props.images.sort();
    const { collapsed } = this.state;
    const buttonStyle = {
      padding: 0,
      fontSize: "13px"
    };
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, collapsed && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", null, images[0]), "\xA0", images.length > 1 && /* @__PURE__ */ React__default.createElement("button", {
      className: "link",
      onClick: this.toggle,
      style: buttonStyle
    }, "(+ ", images.length - 1, " more)")), !collapsed && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, images.map((image, index) => /* @__PURE__ */ React__default.createElement("span", {
      key: image
    }, index > 0 && /* @__PURE__ */ React__default.createElement("br", null), image, index < images.length - 1 ? "," : "")), /* @__PURE__ */ React__default.createElement("br", null), /* @__PURE__ */ React__default.createElement("button", {
      className: "link",
      onClick: this.toggle,
      style: buttonStyle
    }, "collapse")));
  }
}
class SequenceAndBuildAndImages extends React__default.Component {
  render() {
    const { serverGroup, jenkins, images, docker } = this.props;
    const serverGroupSequence = NameUtils.getSequence(serverGroup.moniker.sequence);
    const ciBuild = serverGroup.buildInfo && serverGroup.buildInfo.ciBuild;
    const appArtifact = serverGroup.buildInfo && serverGroup.buildInfo.appArtifact;
    return /* @__PURE__ */ React__default.createElement("div", null, !!serverGroupSequence && /* @__PURE__ */ React__default.createElement("span", {
      className: "server-group-sequence"
    }, " ", serverGroupSequence), !!serverGroupSequence && (!!jenkins || !!images) && /* @__PURE__ */ React__default.createElement("span", null, ": "), !!jenkins && /* @__PURE__ */ React__default.createElement("a", {
      className: "build-link sp-margin-xs-right",
      href: jenkins.href,
      target: "_blank"
    }, "Build: #", jenkins.number), !!docker && /* @__PURE__ */ React__default.createElement("a", {
      className: "build-link",
      href: docker.href,
      target: "_blank"
    }, docker.image, ":", docker.tag || docker.digest), !!appArtifact && !!appArtifact.version ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "\xA0\xA0\xA0\xA0", /* @__PURE__ */ React__default.createElement("img", {
      className: "artifact-icon",
      src: ArtifactIconService.getPath("maven/file"),
      width: "18",
      height: "18"
    }), !!appArtifact.url ? /* @__PURE__ */ React__default.createElement("a", {
      className: "build-link",
      href: appArtifact.url,
      target: "_blank"
    }, appArtifact.version) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, appArtifact.version)) : !!ciBuild && !!ciBuild.jobNumber && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "\xA0\xA0\xA0\xA0", /* @__PURE__ */ React__default.createElement("img", {
      className: "artifact-icon",
      src: ArtifactIconService.getPath("jenkins/file"),
      width: "18",
      height: "18"
    }), !!ciBuild.jobUrl ? /* @__PURE__ */ React__default.createElement("a", {
      className: "build-link",
      href: ciBuild.jobUrl,
      target: "_blank"
    }, ciBuild.jobNumber) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, ciBuild.jobNumber)), !!images && /* @__PURE__ */ React__default.createElement(ImageList, {
      ...this.props
    }));
  }
}
class Alerts extends React__default.Component {
  render() {
    const { application, serverGroup } = this.props;
    return /* @__PURE__ */ React__default.createElement(EntityNotifications, {
      application,
      entity: serverGroup,
      entityType: "serverGroup",
      hOffsetPercent: "20%",
      onUpdate: () => application.serverGroups.refresh(),
      pageLocation: "pod",
      placement: "top"
    });
  }
}
let Health = class extends React__default.Component {
  render() {
    const { serverGroup } = this.props;
    return /* @__PURE__ */ React__default.createElement(HealthCounts, {
      container: serverGroup.instanceCounts
    });
  }
};
Health = __decorateClass$h([
  Overridable("serverGroups.pod.header.health")
], Health);
class RunningTasks$1 extends React__default.Component {
  render() {
    const { serverGroup } = this.props;
    const hasRunningExecutions = !!serverGroup.runningExecutions.length || !!serverGroup.runningTasks.length;
    return hasRunningExecutions && /* @__PURE__ */ React__default.createElement(RunningTasksTag, {
      tasks: serverGroup.runningTasks,
      executions: serverGroup.runningExecutions
    });
  }
}
let ServerGroupHeader = class extends React__default.Component {
  render() {
    const props = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal top server-group-title sticky-header-3"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal section-title flex-1"
    }, /* @__PURE__ */ React__default.createElement(MultiSelectCheckbox, {
      ...props
    }), /* @__PURE__ */ React__default.createElement(CloudProviderIcon, {
      ...props
    }), /* @__PURE__ */ React__default.createElement(SequenceAndBuildAndImages, {
      ...props
    }), /* @__PURE__ */ React__default.createElement(Alerts, {
      ...props
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal center flex-none"
    }, /* @__PURE__ */ React__default.createElement(RunningTasks$1, {
      ...props
    }), /* @__PURE__ */ React__default.createElement(LoadBalancers$2, {
      ...props
    }), /* @__PURE__ */ React__default.createElement(Health, {
      ...props
    })));
  }
};
ServerGroupHeader = __decorateClass$h([
  Overridable("serverGroups.pod.header")
], ServerGroupHeader);

class InstanceListBody extends React__default.Component {
  constructor(props) {
    super(props);
    this.$uiRouter = ReactInjector.$uiRouter;
    this.$state = ReactInjector.$state;
    this.destroy$ = new Subject();
    this.instanceSorter = (a1, b1) => {
      const { instanceSort = "launchTime" } = this.state;
      const filterSplit = instanceSort.split("-");
      const filterType = filterSplit.length === 1 ? filterSplit[0] : filterSplit[1];
      const reverse = filterSplit.length === 2;
      const a = reverse ? b1 : a1;
      const b = reverse ? a1 : b1;
      switch (filterType) {
        case "id":
          return a.id.localeCompare(b.id);
        case "launchTime":
          return a.launchTime === b.launchTime ? a.id.localeCompare(b.id) : a.launchTime - b.launchTime;
        case "availabilityZone":
          return a.availabilityZone === b.availabilityZone ? a.launchTime === b.launchTime ? a.id.localeCompare(b.id) : a.launchTime - b.launchTime : a.availabilityZone.localeCompare(b.availabilityZone);
        case "discoveryState": {
          const aHealth = (a.health || []).filter((health) => health.type === "Discovery");
          const bHealth = (b.health || []).filter((health) => health.type === "Discovery");
          if (aHealth.length && !bHealth.length) {
            return -1;
          }
          if (!aHealth.length && bHealth.length) {
            return 1;
          }
          return !aHealth.length && !bHealth.length || aHealth[0].state === bHealth[0].state ? a.launchTime === b.launchTime ? a.id.localeCompare(b.id) : a.launchTime - b.launchTime : aHealth[0].state.localeCompare(bHealth[0].state);
        }
        case "loadBalancerSort": {
          const aHealth2 = (a.health || []).filter((health) => health.type === "LoadBalancer");
          const bHealth2 = (b.health || []).filter((health) => health.type === "LoadBalancer");
          if (aHealth2.length && !bHealth2.length) {
            return -1;
          }
          if (!aHealth2.length && bHealth2.length) {
            return 1;
          }
          const aHealthStr = aHealth2.map((h) => h.loadBalancers.map((l) => l.name + ":" + l.state)).join(",");
          const bHealthStr = bHealth2.map((h) => h.loadBalancers.map((l) => l.name + ":" + l.state)).join(",");
          return aHealthStr === bHealthStr ? a.launchTime === b.launchTime ? a.id.localeCompare(b.id) : a.launchTime - b.launchTime : aHealthStr.localeCompare(bHealthStr);
        }
        default:
          return -1;
      }
    };
    this.instanceBodyClicked = (event) => {
      const target = event.target;
      const targetRow = target.closest("tr");
      if (!targetRow) {
        return;
      }
      ClusterState.multiselectModel.toggleInstance(this.props.serverGroup, targetRow.getAttribute("data-instance-id"));
      event.stopPropagation();
    };
    this.state = {
      selectedInstanceIds: this.getSelectedInstanceIds(),
      activeInstanceId: this.$state.params.instanceId,
      multiselect: this.$state.params.multiselect,
      instanceSort: this.$state.params.instanceSort
    };
  }
  componentDidMount() {
    ClusterState.multiselectModel.instancesStream.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.setState({ selectedInstanceIds: this.getSelectedInstanceIds() });
    });
    this.$uiRouter.globals.params$.pipe(map((params) => [params.instanceId, params.multiselect, params.instanceSort]), distinctUntilChanged(isEqual), takeUntil(this.destroy$)).subscribe(() => {
      const { params } = this.$state;
      this.setState({
        activeInstanceId: params.instanceId,
        multiselect: params.multiselect,
        instanceSort: params.instanceSort
      });
    });
  }
  getSelectedInstanceIds() {
    const { instances, serverGroup } = this.props;
    if (this.$state.params.multiselect) {
      return instances.filter((i) => ClusterState.multiselectModel.instanceIsSelected(serverGroup, i.id)).map((i) => i.id);
    }
    return [];
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.serverGroup.stringVal !== nextProps.serverGroup.stringVal) {
      return true;
    }
    if (this.props.instances.map((i) => i.id).sort().join(",") !== nextProps.instances.map((i) => i.id).sort().join(",")) {
      return true;
    }
    const { state } = this;
    return state.activeInstanceId !== nextState.activeInstanceId || state.selectedInstanceIds.sort().join(",") !== nextState.selectedInstanceIds.sort().join(",") || state.multiselect !== nextState.multiselect || state.instanceSort !== nextState.instanceSort;
  }
  renderRow(instance) {
    const { hasLoadBalancers, hasDiscovery } = this.props;
    const showProviderHealth = !hasLoadBalancers && !hasDiscovery;
    const healthMetrics = instance.health || [];
    let discoveryStatus = "-";
    let providerStatus = "";
    let loadBalancers = [];
    healthMetrics.forEach((health) => {
      if (hasLoadBalancers && health.type === "LoadBalancer") {
        loadBalancers = health.loadBalancers;
      }
      if (hasDiscovery && health.type === "Discovery") {
        discoveryStatus = health.state;
      }
      if (showProviderHealth) {
        providerStatus = health.state;
      }
    });
    const isActive = this.state.activeInstanceId === instance.id;
    const rowClass = classNames({
      clickable: true,
      active: isActive
    });
    return /* @__PURE__ */ React__default.createElement("tr", {
      key: instance.id,
      "data-instance-id": instance.id,
      className: rowClass
    }, this.$state.params.multiselect && /* @__PURE__ */ React__default.createElement("td", {
      className: "no-hover"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: this.state.selectedInstanceIds.includes(instance.id)
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("span", {
      className: `glyphicon glyphicon-${instance.healthState}-triangle`
    }), instance.name || instance.id), /* @__PURE__ */ React__default.createElement("td", null, timestamp(instance.launchTime)), /* @__PURE__ */ React__default.createElement("td", null, instance.availabilityZone), hasDiscovery && /* @__PURE__ */ React__default.createElement("td", {
      className: "text-center small"
    }, discoveryStatus), hasLoadBalancers && this.renderLoadBalancerCell(loadBalancers), showProviderHealth && /* @__PURE__ */ React__default.createElement("td", {
      className: "text-center small"
    }, providerStatus));
  }
  renderLoadBalancerCell(loadBalancerHealths) {
    return /* @__PURE__ */ React__default.createElement("td", null, loadBalancerHealths.length === 0 && /* @__PURE__ */ React__default.createElement("span", null, "-"), loadBalancerHealths.map((h) => {
      const tooltip = h.state === "OutOfService" ? h.description.replace(/"/g, "&quot;") : null;
      const icon = h.healthState === "Up" || h.state === "InService" ? "Up" : "Down";
      return /* @__PURE__ */ React__default.createElement("div", {
        key: h.name
      }, tooltip && /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: tooltip,
        placement: "left"
      }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", {
        className: `glyphicon-${icon}-triangle`
      }), h.name)), !tooltip && /* @__PURE__ */ React__default.createElement("span", {
        className: `glyphicon-${icon}-triangle`
      }, h.name));
    }));
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("tbody", {
      onClick: this.instanceBodyClicked
    }, this.props.instances.sort(this.instanceSorter).map((i) => this.renderRow(i)));
  }
}

class InstanceList extends React__default.Component {
  constructor(props) {
    super(props);
    this.clusterFilterModel = ClusterState.filterModel.asFilterModel;
    this.$state = ReactInjector.$state;
    this.$uiRouter = ReactInjector.$uiRouter;
    this.destroy$ = new Subject();
    this.toggleSelectAll = (event) => {
      event.stopPropagation();
      const { instances, serverGroup } = this.props;
      const selectedInstances = instances.map((i) => i.id);
      ClusterState.multiselectModel.toggleSelectAll(serverGroup, selectedInstances);
      this.setState({ allSelected: !this.state.allSelected });
    };
    this.toggleSort = (sortKey) => {
      this.clusterFilterModel.sortFilter.instanceSort = sortKey;
      this.clusterFilterModel.applyParamsToUrl();
    };
    this.instanceGroup = ClusterState.multiselectModel.getOrCreateInstanceGroup(props.serverGroup);
    this.state = {
      multiselect: this.$state.params.multiselect,
      allSelected: this.instanceGroup.selectAll,
      instanceSort: this.$state.params.instanceSort
    };
  }
  componentDidMount() {
    ClusterState.multiselectModel.instancesStream.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.setState({ allSelected: this.instanceGroup.selectAll });
    });
    this.$uiRouter.globals.params$.pipe(map((params) => [params.multiselect, params.instanceSort]), distinctUntilChanged(isEqual), takeUntil(this.destroy$)).subscribe(() => {
      this.setState({
        multiselect: this.$state.params.multiselect,
        instanceSort: this.$state.params.instanceSort
      });
    });
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  getColumnWidths() {
    const { hasDiscovery, hasLoadBalancers } = this.props;
    let additionalOffset = 0;
    if (!hasDiscovery) {
      additionalOffset += 3;
    }
    if (!hasLoadBalancers) {
      additionalOffset += 7;
    }
    if (!hasDiscovery && !hasLoadBalancers) {
      additionalOffset -= 7;
    }
    return {
      id: 21 + additionalOffset,
      launchTime: 23 + additionalOffset,
      zone: 12 + additionalOffset,
      discovery: 14 + additionalOffset,
      loadBalancers: 31 + additionalOffset,
      cloudProvider: 31
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.serverGroup.stringVal !== nextProps.serverGroup.stringVal) {
      return true;
    }
    if (this.props.instances.map((i) => i.id).sort().join(",") !== nextProps.instances.map((i) => i.id).sort().join(",")) {
      return true;
    }
    return this.state.multiselect !== nextState.multiselect || this.state.allSelected !== nextState.allSelected || this.state.instanceSort !== nextState.instanceSort;
  }
  renderHeader() {
    const { hasDiscovery, hasLoadBalancers } = this.props;
    const sortKey = this.state.instanceSort;
    const showProviderHealth = !hasDiscovery && !hasLoadBalancers;
    const columnWidths = this.getColumnWidths();
    return /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, this.state.multiselect && /* @__PURE__ */ React__default.createElement("th", {
      style: { width: "3%" }
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      readOnly: true,
      checked: this.state.allSelected,
      onClick: this.toggleSelectAll
    })), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: columnWidths.id + "%" }
    }, /* @__PURE__ */ React__default.createElement(SortToggle, {
      currentSort: sortKey,
      onChange: this.toggleSort,
      sortKey: "id",
      label: "Instance"
    })), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: columnWidths.launchTime + "%" }
    }, /* @__PURE__ */ React__default.createElement(SortToggle, {
      currentSort: sortKey,
      onChange: this.toggleSort,
      sortKey: "launchTime",
      label: "Launch Time"
    })), /* @__PURE__ */ React__default.createElement("th", {
      style: { width: columnWidths.zone + "%" }
    }, /* @__PURE__ */ React__default.createElement(SortToggle, {
      currentSort: sortKey,
      onChange: this.toggleSort,
      sortKey: "availabilityZone",
      label: "Zone"
    })), hasDiscovery && /* @__PURE__ */ React__default.createElement("th", {
      style: { width: columnWidths.discovery + "%" },
      className: "text-center"
    }, /* @__PURE__ */ React__default.createElement(SortToggle, {
      currentSort: sortKey,
      onChange: this.toggleSort,
      sortKey: "discoveryState",
      label: "Discovery"
    })), hasLoadBalancers && /* @__PURE__ */ React__default.createElement("th", {
      style: { width: columnWidths.loadBalancers + "%" }
    }, /* @__PURE__ */ React__default.createElement(SortToggle, {
      currentSort: sortKey,
      onChange: this.toggleSort,
      sortKey: "loadBalancerSort",
      label: "Load Balancers"
    })), showProviderHealth && /* @__PURE__ */ React__default.createElement("th", {
      style: { width: columnWidths.cloudProvider + "%" },
      className: "text-center"
    }, /* @__PURE__ */ React__default.createElement(SortToggle, {
      currentSort: sortKey,
      onChange: this.toggleSort,
      sortKey: "providerHealth",
      label: "Provider"
    }))));
  }
  render() {
    const { instances } = this.props;
    if (!instances.length) {
      return /* @__PURE__ */ React__default.createElement("div", null);
    }
    const Header = this.renderHeader();
    return /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-hover table-condensed instances"
    }, Header, /* @__PURE__ */ React__default.createElement(InstanceListBody, {
      ...this.props
    }));
  }
}

class ServerGroup$1 extends React__default.Component {
  constructor(props) {
    super(props);
    this.onServerGroupsChanged = () => {
      const isMultiSelected = this.isMultiSelected(this.props.sortFilter.multiselect, this.props.serverGroup);
      this.setState({ isMultiSelected });
      ReactInjector.$rootScope.$applyAsync(() => false);
    };
    this.onStateChanged = () => {
      this.setState({ isSelected: this.isSelected(this.props.serverGroup) });
    };
    this.handleServerGroupClicked = (event) => {
      logger.log({ category: "Cluster Pod", action: "Load Server Group Details" });
      this.loadDetails(event);
    };
    this.state = this.getState(props);
  }
  getState(props) {
    const { serverGroup } = props;
    const instances = serverGroup.instances.filter((i) => ClusterState.filterService.shouldShowInstance(i));
    const isSelected = this.isSelected(serverGroup);
    const isMultiSelected = this.isMultiSelected(props.sortFilter.multiselect, serverGroup);
    const jenkinsConfig = serverGroup.buildInfo && serverGroup.buildInfo.jenkins;
    const dockerConfig = serverGroup.buildInfo && serverGroup.buildInfo.docker;
    let jenkins = null;
    let images = null;
    let docker = null;
    if (jenkinsConfig && (jenkinsConfig.host || jenkinsConfig.fullUrl || serverGroup.buildInfo.buildInfoUrl)) {
      const fromHost = jenkinsConfig.host && [jenkinsConfig.host + "job", jenkinsConfig.name, jenkinsConfig.number, ""].join("/");
      const fromFullUrl = jenkinsConfig.fullUrl;
      const fromBuildInfo = serverGroup.buildInfo.buildInfoUrl;
      jenkins = {
        number: jenkinsConfig.number,
        href: fromBuildInfo || fromFullUrl || fromHost
      };
    }
    if (SETTINGS.dockerInsights.enabled && dockerConfig) {
      docker = {
        digest: dockerConfig.digest,
        tag: dockerConfig.tag,
        image: dockerConfig.image,
        href: $interpolate(SETTINGS.dockerInsights.url)(serverGroup) + "images/" + encodeURIComponent(dockerConfig.image) + "/" + (dockerConfig.tag || dockerConfig.digest)
      };
    } else if (has(serverGroup, "buildInfo.images")) {
      images = serverGroup.buildInfo.images.map((val) => this.getShortSha(val));
    }
    return {
      jenkins,
      instances,
      images,
      docker,
      isSelected,
      isMultiSelected
    };
  }
  getShortSha(val) {
    const sha = val.lastIndexOf("sha256:");
    if (sha > -1) {
      val = val.substring(0, sha + 14) + "...";
    }
    return val;
  }
  isSelected(serverGroup) {
    const params = {
      region: serverGroup.region,
      accountId: serverGroup.account,
      serverGroup: serverGroup.name,
      provider: serverGroup.type
    };
    return ReactInjector.$state.includes("**.serverGroup", params);
  }
  isMultiSelected(multiselect, serverGroup) {
    return multiselect && ClusterState.multiselectModel.serverGroupIsSelected(serverGroup);
  }
  componentDidMount() {
    const { serverGroupsStream, instancesStream } = ClusterState.multiselectModel;
    this.serverGroupsSubscription = serverGroupsStream.pipe(merge$2(instancesStream)).subscribe(this.onServerGroupsChanged);
    this.stateChangeSubscription = ReactInjector.$uiRouter.globals.success$.subscribe(this.onStateChanged);
    this.onStateChanged();
  }
  componentWillUnmount() {
    this.stateChangeSubscription.unsubscribe();
    this.serverGroupsSubscription.unsubscribe();
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  loadDetails(event) {
    event.persist();
    setTimeout(() => {
      if (event.isDefaultPrevented() || event.nativeEvent.defaultPrevented) {
        return;
      }
      ClusterState.multiselectModel.toggleServerGroup(this.props.serverGroup);
      event.preventDefault();
    });
  }
  render() {
    const { instances, images, jenkins, docker, isSelected, isMultiSelected } = this.state;
    const { serverGroup, application, sortFilter, hasDiscovery, hasLoadBalancers, hasManager } = this.props;
    const { account, region, name } = serverGroup;
    const { showAllInstances, listInstances } = sortFilter;
    const key = ScrollToService.toDomId(["serverGroup", account, region, name].join("-"));
    const serverGroupClassName = classNames({
      "server-group": true,
      "rollup-pod-server-group": true,
      clickable: true,
      "clickable-row": true,
      disabled: serverGroup.isDisabled,
      active: isSelected,
      managed: hasManager
    });
    return /* @__PURE__ */ React__default.createElement("div", {
      id: key,
      className: serverGroupClassName,
      onClick: this.handleServerGroupClicked
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "cluster-container"
    }, /* @__PURE__ */ React__default.createElement(ServerGroupHeader, {
      application,
      images,
      isMultiSelected,
      jenkins,
      serverGroup,
      sortFilter,
      docker
    }), showAllInstances && /* @__PURE__ */ React__default.createElement("div", {
      className: "instance-list"
    }, listInstances ? /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(InstanceList, {
      hasDiscovery,
      hasLoadBalancers,
      instances,
      serverGroup
    })) : /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Instances, {
      highlight: sortFilter.filter,
      instances
    })))));
  }
}

class DeployInitializer extends React__default.Component {
  constructor(props) {
    super(props);
    this.noTemplate = { label: "None", serverGroup: null, cluster: null };
    this.buildEmptyCommand = () => {
      const { application, cloudProvider } = this.props;
      const commandBuilder = ReactInjector.providerServiceDelegate.getDelegate(cloudProvider, "serverGroup.commandBuilder");
      return commandBuilder.buildNewServerGroupCommand(application, { mode: "createPipeline" });
    };
    this.selectTemplate = () => {
      const buildCommand = this.state.selectedTemplate === this.noTemplate ? this.buildEmptyCommand() : this.buildCommandFromTemplate(this.state.selectedTemplate.serverGroup);
      return buildCommand.then((command) => this.applyCommandToScope(command));
    };
    this.useTemplate = () => {
      this.selectTemplate().then(() => this.props.onTemplateSelected());
    };
    this.templateChanged = (option) => {
      this.setState({ selectedTemplate: option });
    };
    this.templateValueRenderer = (option) => {
      if (option.label) {
        return /* @__PURE__ */ React__default.createElement("span", null, option.label);
      }
      return /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
        account: option.account
      }), option.serverGroup && /* @__PURE__ */ React__default.createElement("span", null, " ", option.serverGroupName), " (", option.region, ")");
    };
    this.templateOptionRenderer = (option) => {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, !option.label && /* @__PURE__ */ React__default.createElement("h5", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
        account: option.account
      }), " ", option.cluster, " (", option.region, ")"), option.label && /* @__PURE__ */ React__default.createElement("h5", null, option.label), option.serverGroup && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, "Most recent server group: "), " ", option.serverGroupName));
    };
    const templates = [];
    let selectedTemplate;
    const { viewState } = props.command;
    if (!viewState.disableNoTemplateSelection) {
      templates.push(this.noTemplate);
    }
    selectedTemplate = this.noTemplate;
    const serverGroups = props.application.getDataSource("serverGroups").data.filter((s) => s.cloudProvider === props.cloudProvider && s.category === "serverGroup");
    const grouped = groupBy(serverGroups, (serverGroup) => [serverGroup.cluster, serverGroup.account, serverGroup.region].join(":"));
    Object.keys(grouped).forEach((key) => {
      const latest = sortBy(grouped[key], "name").pop();
      templates.push({
        cluster: latest.cluster,
        account: latest.account,
        region: latest.region,
        serverGroupName: latest.name,
        serverGroup: latest,
        key: [latest.account, latest.region, latest.name].join(":")
      });
    });
    if (viewState.disableNoTemplateSelection && templates.length === 1) {
      selectedTemplate = templates[0];
    } else if (!viewState.disableNoTemplateSelection && templates.length === 2) {
      selectedTemplate = templates[1];
    }
    this.state = {
      selectedTemplate,
      templates
    };
  }
  applyCommandToScope(command) {
    const { viewState } = command;
    const baseCommand = this.props.command;
    viewState.disableImageSelection = true;
    viewState.showImageSourceSelector = true;
    viewState.disableStrategySelection = baseCommand.viewState.disableStrategySelection || false;
    viewState.expectedArtifacts = baseCommand.viewState.expectedArtifacts || [];
    viewState.imageId = null;
    viewState.readOnlyFields = baseCommand.viewState.readOnlyFields || {};
    viewState.submitButtonLabel = "Add";
    viewState.hideClusterNamePreview = baseCommand.viewState.hideClusterNamePreview || false;
    viewState.templatingEnabled = true;
    viewState.imageSourceText = baseCommand.viewState.imageSourceText;
    Object.assign(command, baseCommand.viewState.overrides || {});
    Object.assign(baseCommand, command);
  }
  buildCommandFromTemplate(serverGroup) {
    const { application, cloudProvider } = this.props;
    const commandBuilder = ReactInjector.providerServiceDelegate.getDelegate(cloudProvider, "serverGroup.commandBuilder");
    return ServerGroupReader.getServerGroup(application.name, serverGroup.account, serverGroup.region, serverGroup.name).then((details) => {
      details.account = serverGroup.account;
      return commandBuilder.buildServerGroupCommandFromExisting(application, details, "editPipeline");
    });
  }
  componentDidMount() {
    if (this.state.templates.length === 1) {
      this.useTemplate();
    }
  }
  render() {
    const { command, onDismiss, templateSelectionText } = this.props;
    const { selectedTemplate, templates } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(ModalClose, {
      dismiss: onDismiss
    }), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Template Selection")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("form", {
      className: "form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4 col-md-offset-1 sm-label-left"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Copy configuration from"))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      value: selectedTemplate.key,
      placeholder: "Select...",
      valueRenderer: this.templateValueRenderer,
      optionRenderer: this.templateOptionRenderer,
      options: templates,
      valueKey: "key",
      onChange: this.templateChanged,
      clearable: false
    }))), command.viewState.customTemplateMessage && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("p", {
      className: "col-md-10 col-md-offset-1"
    }, command.viewState.customTemplateMessage)), selectedTemplate.serverGroup && templateSelectionText && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group",
      style: { marginTop: "20px" }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-10 col-md-offset-1 well"
    }, templateSelectionText.copied.length > 0 && /* @__PURE__ */ React__default.createElement("div", null, "These fields ", /* @__PURE__ */ React__default.createElement("strong", null, "will be"), " copied over from the most recent server group:", /* @__PURE__ */ React__default.createElement("ul", null, templateSelectionText.copied.map((text, i) => /* @__PURE__ */ React__default.createElement("li", {
      key: i
    }, text)))), templateSelectionText.notCopied.length > 0 && /* @__PURE__ */ React__default.createElement("div", null, "These fields ", /* @__PURE__ */ React__default.createElement("strong", null, "will NOT"), " be copied over, and will be reset to defaults:", /* @__PURE__ */ React__default.createElement("ul", null, templateSelectionText.notCopied.map((text, i) => /* @__PURE__ */ React__default.createElement("li", {
      key: i
    }, text)))), templateSelectionText.additionalCopyText && /* @__PURE__ */ React__default.createElement("div", null, templateSelectionText.additionalCopyText))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "modal-footer"
    }, (selectedTemplate.serverGroup || !command.viewState.disableNoTemplateSelection) && /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      onClick: this.useTemplate
    }, selectedTemplate.serverGroup && /* @__PURE__ */ React__default.createElement("span", null, "Use this template"), !selectedTemplate.serverGroup && /* @__PURE__ */ React__default.createElement("span", null, "Continue without a template"), /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-chevron-right"
    })))));
  }
}

class DeployInitializerController {
  constructor(providerServiceDelegate) {
    this.providerServiceDelegate = providerServiceDelegate;
    this.templates = [];
    this.noTemplate = { label: "None", serverGroup: null, cluster: null };
  }
  $onInit() {
    const { viewState } = this.command;
    if (!viewState.disableNoTemplateSelection) {
      this.templates.push(this.noTemplate);
      this.selectedTemplate = this.noTemplate;
    }
    const serverGroups = this.application.getDataSource("serverGroups").data.filter((s) => s.cloudProvider === this.cloudProvider && s.category === "serverGroup");
    const grouped = groupBy(serverGroups, (serverGroup) => [serverGroup.cluster, serverGroup.account, serverGroup.region].join(":"));
    Object.keys(grouped).forEach((key) => {
      const latest = sortBy(grouped[key], "name").pop();
      this.templates.push({
        cluster: latest.cluster,
        account: latest.account,
        region: latest.region,
        serverGroupName: latest.name,
        serverGroup: latest
      });
    });
    if (this.templates.length === 1) {
      this.selectedTemplate = this.templates[0];
      this.useTemplate();
    }
  }
  applyCommandToScope(command) {
    const { viewState } = command;
    const baseCommand = this.command;
    viewState.disableImageSelection = true;
    viewState.showImageSourceSelector = true;
    viewState.disableStrategySelection = baseCommand.viewState.disableStrategySelection || false;
    viewState.expectedArtifacts = baseCommand.viewState.expectedArtifacts || [];
    viewState.imageId = null;
    viewState.readOnlyFields = baseCommand.viewState.readOnlyFields || {};
    viewState.submitButtonLabel = "Add";
    viewState.hideClusterNamePreview = baseCommand.viewState.hideClusterNamePreview || false;
    viewState.templatingEnabled = true;
    viewState.imageSourceText = baseCommand.viewState.imageSourceText;
    viewState.pipeline = baseCommand.viewState.pipeline;
    viewState.stage = baseCommand.viewState.stage;
    Object.assign(command, baseCommand.viewState.overrides || {});
    Object.assign(baseCommand, command);
  }
  buildCommandFromTemplate(serverGroup) {
    const commandBuilder = this.providerServiceDelegate.getDelegate(this.cloudProvider, "serverGroup.commandBuilder");
    return ServerGroupReader.getServerGroup(this.application.name, serverGroup.account, serverGroup.region, serverGroup.name).then((details) => {
      details.account = serverGroup.account;
      return commandBuilder.buildServerGroupCommandFromExisting(this.application, details, "editPipeline");
    });
  }
  buildEmptyCommand() {
    const commandBuilder = this.providerServiceDelegate.getDelegate(this.cloudProvider, "serverGroup.commandBuilder");
    return commandBuilder.buildNewServerGroupCommand(this.application, { mode: "createPipeline" });
  }
  selectTemplate() {
    const buildCommand = this.selectedTemplate === this.noTemplate ? this.buildEmptyCommand() : this.buildCommandFromTemplate(this.selectedTemplate.serverGroup);
    return buildCommand.then((command) => this.applyCommandToScope(command));
  }
  useTemplate() {
    if (this.parentState) {
      this.parentState.loaded = false;
    }
    this.selectTemplate().then(() => this.onTemplateSelected());
  }
}
DeployInitializerController.$inject = ["providerServiceDelegate"];
const component = {
  bindings: {
    application: "<",
    cloudProvider: "@",
    command: "<",
    dismiss: "&",
    onTemplateSelected: "&",
    parentState: "<",
    templateSelectionText: "<"
  },
  templateUrl: "core/src/serverGroup/configure/common/deployInitializer.component.html",
  controller: DeployInitializerController
};
const DEPLOY_INITIALIZER_COMPONENT = "spinnaker.core.serverGroup.configure.deployInitializer";
module(DEPLOY_INITIALIZER_COMPONENT, [PROVIDER_SERVICE_DELEGATE]).component("deployInitializer", component);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/serverGroup/configure/common/deployInitializer.component.html", `<div modal-page>
  <modal-close dismiss="$ctrl.dismiss()"></modal-close>
  <div ng-if="$ctrl.parentState.loaded">
    <div class="modal-header">
      <h4 class="modal-title">Template Selection</h4>
    </div>
    <div class="modal-body">
      <form class="form-horizontal">
        <div class="form-group">
          <div class="col-md-4 col-md-offset-1 sm-label-left">
            <b>Copy configuration from</b>
          </div>
        </div>
        <div class="form-group">
          <div class="col-md-6 col-md-offset-1">
            <ui-select ng-model="$ctrl.selectedTemplate" class="form-control input-sm">
              <ui-select-match placeholder="Select...">
                <span ng-if="!$select.selected.label">
                  <account-tag account="$select.selected.account"></account-tag>
                  <span ng-if="$select.selected.serverGroup">{{ $select.selected.serverGroupName }}</span>
                  ({{ $select.selected.region }})
                </span>
                <span ng-if="$select.selected.label">{{ $select.selected.label }}</span>
              </ui-select-match>
              <ui-select-choices repeat="template in $ctrl.templates | filter: $select.search">
                <h5 ng-if="!template.label">
                  <account-tag account="template.account"></account-tag> {{ template.cluster }} ({{ template.region }})
                </h5>
                <h5 ng-if="template.label">{{ template.label }}</h5>
                <div ng-if="template.serverGroup"><b>Most recent server group: </b> {{ template.serverGroupName }}</div>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="form-group" ng-if="$ctrl.command.viewState.customTemplateMessage">
          <p class="col-md-10 col-md-offset-1" ng-bind-html="$ctrl.command.viewState.customTemplateMessage"></p>
        </div>
        <div class="form-group" ng-if="$ctrl.selectedTemplate.serverGroup" style="margin-top: 20px">
          <div class="col-md-10 col-md-offset-1 well">
            <div ng-if="$ctrl.templateSelectionText.copied.length">
              These fields <strong>will be</strong> copied over from the most recent server group:
              <ul>
                <li ng-repeat="text in $ctrl.templateSelectionText.copied" ng-bind="text"></li>
              </ul>
            </div>
            <div ng-if="$ctrl.templateSelectionText.notCopied.length">
              These fields <strong>will NOT</strong> be copied over, and will be reset to defaults:
              <ul>
                <li ng-repeat="text in $ctrl.templateSelectionText.notCopied" ng-bind="text"></li>
              </ul>
            </div>
            <div
              ng-if="$ctrl.templateSelectionText.additionalCopyText"
              ng-bind="$ctrl.templateSelectionText.additionalCopyText"
            ></div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-primary"
        ng-click="$ctrl.useTemplate()"
        ng-if="$ctrl.selectedTemplate.serverGroup || !$ctrl.command.viewState.disableNoTemplateSelection"
      >
        <span ng-if="$ctrl.selectedTemplate.serverGroup">Use this template</span>
        <span ng-if="!$ctrl.selectedTemplate.serverGroup">Continue without a template</span>
        <span class="glyphicon glyphicon-chevron-right"></span>
      </button>
    </div>
  </div>
</div>
`);
}]);

const setMatchingResourceSummary = (command) => {
  var _a;
  command.resourceSummary = ((_a = command.backingData.managedResources) != null ? _a : []).find((resource) => {
    var _a2, _b;
    return !resource.isPaused && getKindName(resource.kind) === "cluster" && resource.locations.regions.some((r) => r.name === command.region) && ((_a2 = resource.moniker.stack) != null ? _a2 : "") === command.stack && ((_b = resource.moniker.detail) != null ? _b : "") === command.freeFormDetails && resource.locations.account === command.credentials;
  });
};
class ServerGroupCommandBuilderService {
  constructor(providerServiceDelegate) {
    this.providerServiceDelegate = providerServiceDelegate;
  }
  getDelegate(provider) {
    return this.providerServiceDelegate.getDelegate(provider, "serverGroup.commandBuilder");
  }
  buildNewServerGroupCommand(application, provider, options) {
    return this.getDelegate(provider).buildNewServerGroupCommand(application, options);
  }
  buildServerGroupCommandFromExisting(application, serverGroup, mode) {
    return this.getDelegate(serverGroup.type).buildServerGroupCommandFromExisting(application, serverGroup, mode);
  }
  buildNewServerGroupCommandForPipeline(provider, currentStage, pipeline) {
    return this.getDelegate(provider).buildNewServerGroupCommandForPipeline(currentStage, pipeline);
  }
  buildServerGroupCommandFromPipeline(application, cluster, currentStage, pipeline) {
    return this.getDelegate(cluster.provider).buildServerGroupCommandFromPipeline(application, cluster, currentStage, pipeline);
  }
}
ServerGroupCommandBuilderService.$inject = ["providerServiceDelegate"];
const SERVER_GROUP_COMMAND_BUILDER_SERVICE = "spinnaker.core.serverGroup.configure.common.service";
module(SERVER_GROUP_COMMAND_BUILDER_SERVICE, [PROVIDER_SERVICE_DELEGATE]).service("serverGroupCommandBuilder", ServerGroupCommandBuilderService);

class ServerGroupCommandRegistry {
  constructor() {
    this.providers = new Map();
  }
  $get() {
    return this;
  }
  getCommandOverrides(provider) {
    let result = [];
    if (this.providers.has(provider)) {
      result = cloneDeep(this.providers.get(provider));
    }
    return result;
  }
  register(provider, handler) {
    if (!this.providers.has(provider)) {
      this.providers.set(provider, []);
    }
    this.providers.get(provider).push(handler);
  }
}
const SERVER_GROUP_COMMAND_REGISTRY_PROVIDER = "spinnaker.core.serverGroup.configure.command.registry";
module(SERVER_GROUP_COMMAND_REGISTRY_PROVIDER, []).provider("serverGroupCommandRegistry", ServerGroupCommandRegistry);

class ServerGroupConfigurationService {
  constructor(providerServiceDelegate) {
    this.providerServiceDelegate = providerServiceDelegate;
  }
  getDelegate(provider) {
    return this.providerServiceDelegate.getDelegate(provider, "serverGroup.configurationService");
  }
  refreshInstanceTypes(provider, command) {
    return this.getDelegate(provider).refreshInstanceTypes(command);
  }
}
ServerGroupConfigurationService.$inject = ["providerServiceDelegate"];
const SERVER_GROUP_CONFIGURATION_SERVICE = "spinnaker.core.serverGroup.configure.common.configure.service";
module(SERVER_GROUP_CONFIGURATION_SERVICE, [PROVIDER_SERVICE_DELEGATE]).service("serverGroupConfigurationService", ServerGroupConfigurationService);

const SPEL_EXPRESSION_REGEX = /\${[^}]+}/g;
const SPEL_WITH_DEFAULT_AND_ALPHANUMERICAL_REGEX = /^\${\s*#alphanumerical\(.*\)\s*\?:\s*[^\s]+\s*}$/;
const ServerGroupNamePreview = ({
  createsNewCluster,
  latestServerGroupName,
  mode,
  namePreview,
  navigateToLatestServerGroup
}) => {
  const spelMatches = namePreview.match(SPEL_EXPRESSION_REGEX);
  if (!isEmpty(spelMatches)) {
    const anyInvalidSpel = [...spelMatches].some((match) => !SPEL_WITH_DEFAULT_AND_ALPHANUMERICAL_REGEX.test(match));
    return /* @__PURE__ */ React.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React.createElement("div", {
      className: `well-compact ${anyInvalidSpel ? "alert alert-warning" : "well"}`
    }, /* @__PURE__ */ React.createElement("h5", {
      className: "text-center"
    }, /* @__PURE__ */ React.createElement("p", null, "Your server group cluster will be determined by evaluating the expressions dynamically"), anyInvalidSpel && /* @__PURE__ */ React.createElement("div", {
      className: "text-left"
    }, "NOTE: Please wrap your expression with #alphanumerical and provide a default value to make sure only valid values are used after evaluation. i.e ", "${#alphanumerical(yourExpression) ?: 'defaultValue'}")))));
  }
  const showPreviewAsWarning = mode === "create" && !createsNewCluster || mode !== "create" && createsNewCluster;
  return /* @__PURE__ */ React.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React.createElement("div", {
    className: `well-compact ${showPreviewAsWarning ? "alert alert-warning" : "well"}`
  }, /* @__PURE__ */ React.createElement("h5", {
    className: "text-center"
  }, /* @__PURE__ */ React.createElement("p", null, "Your server group will be in the cluster:"), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, namePreview, createsNewCluster && /* @__PURE__ */ React.createElement("span", null, " (new cluster)"))), !createsNewCluster && mode === "create" && latestServerGroupName && /* @__PURE__ */ React.createElement("div", {
    className: "text-left"
  }, /* @__PURE__ */ React.createElement("p", null, "There is already a server group in this cluster. Do you want to clone it?"), /* @__PURE__ */ React.createElement("p", null, "Cloning copies the entire configuration from the selected server group, allowing you to modify whichever fields (e.g. image) you need to change in the new server group."), /* @__PURE__ */ React.createElement("p", null, 'To clone a server group, select "Clone" from the "Server Group Actions" menu in the details view of the server group.'), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("a", {
    className: "clickable",
    onClick: navigateToLatestServerGroup
  }, "Go to details for ", latestServerGroupName)))))));
};

var __defProp$g = Object.defineProperty;
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __decorateClass$g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$g(target, key, result);
  return result;
};
let ServerGroupDetailsField = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.freeFormDetailsChanged = (freeFormDetails) => {
      const { setFieldValue, values } = this.props.formik;
      values.freeFormDetails = freeFormDetails;
      setFieldValue("freeFormDetails", freeFormDetails);
      values.clusterChanged(values);
    };
  }
  render() {
    const { errors, values } = this.props.formik;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, "Detail ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "core.serverGroup.detail"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: "form-control input-sm no-spel",
      value: values.freeFormDetails,
      onChange: (e) => this.freeFormDetailsChanged(e.target.value)
    }))), errors.freeFormDetails && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group row slide-in"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-sm-9 col-sm-offset-2 error-message"
    }, /* @__PURE__ */ React__default.createElement("span", null, errors.freeFormDetails))));
  }
};
ServerGroupDetailsField = __decorateClass$g([
  Overridable("serverGroup.configure.detailsField")
], ServerGroupDetailsField);

class RunningTasks extends React__default.Component {
  render() {
    const { application, serverGroup } = this.props;
    const tasks = serverGroup.runningTasks || [];
    const executions = serverGroup.runningExecutions || [];
    if (tasks.length > 0 || executions.length > 0) {
      return /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
        heading: "Running Tasks",
        defaultExpanded: true,
        bodyClassName: "content-body details-running-tasks"
      }, tasks.sort((a, b) => a.startTime - b.startTime).map((task) => /* @__PURE__ */ React__default.createElement(Task, {
        key: task.id,
        task,
        application
      })), executions.map((execution) => /* @__PURE__ */ React__default.createElement(Execution, {
        key: execution.id,
        execution
      })));
    }
    return null;
  }
}
const Task = (props) => /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("strong", null, props.task.name), displayableTasks(props.task.steps).map((step, index) => /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-container-h baseline margin-between-sm",
  key: index
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "small"
}, /* @__PURE__ */ React__default.createElement(StatusGlyph, {
  item: step
})), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, robotToHuman(step.name)), step.name === "waitForUpInstances" && /* @__PURE__ */ React__default.createElement(PlatformHealthOverrideMessage, {
  step,
  task: props.task,
  application: props.application
})), /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-pull-right"
}, duration(step.runningTimeInMs)))));
const Execution = (props) => /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("strong", null, "Pipeline: ", props.execution.name), props.execution.stages.map((stage) => /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-container-h baseline margin-between-sm"
}, /* @__PURE__ */ React__default.createElement("span", {
  className: "small"
}, /* @__PURE__ */ React__default.createElement(StatusGlyph, {
  item: stage
})), /* @__PURE__ */ React__default.createElement("span", null, robotToHuman(stage.name)), /* @__PURE__ */ React__default.createElement("div", {
  className: "flex-pull-right"
}, duration(stage.runningTimeInMs)))));

class ServerGroupInsightActions extends React__default.Component {
  onClick(label) {
    const { serverGroup } = this.props;
    logger.log({
      category: "Insight Menu (Server Group)",
      action: `${label} clicked`,
      data: { label: `${serverGroup.account}/${serverGroup.region}/${serverGroup.name}` }
    });
  }
  render() {
    const { serverGroup } = this.props;
    const hasInsightActions = serverGroup && serverGroup.insightActions && serverGroup.insightActions.length > 0;
    if (hasInsightActions) {
      return /* @__PURE__ */ React__default.createElement(Dropdown, {
        className: "dropdown",
        id: "server-group-insight-dropdown",
        pullRight: true
      }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
        className: "btn btn-sm btn-default dropdown-toggle"
      }, "Insight"), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, {
        className: "dropdown-menu"
      }, serverGroup.insightActions.map((action) => /* @__PURE__ */ React__default.createElement("li", {
        key: action.label
      }, /* @__PURE__ */ React__default.createElement("a", {
        target: "_blank",
        onClick: () => this.onClick(action.label),
        href: action.url
      }, action.label)))));
    }
    return null;
  }
}

class ServerGroupDetails extends React__default.Component {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.updateServerGroup = (serverGroup) => {
      this.setState({ serverGroup, loading: false });
    };
    this.state = {
      loading: true,
      serverGroup: void 0
    };
  }
  autoClose() {
    ReactInjector.$state.params.allowModalToStayOpen = true;
    ReactInjector.$state.go("^", null, { location: "replace" });
  }
  componentDidMount() {
    this.props.detailsGetter(this.props, this.autoClose).pipe(takeUntil(this.destroy$)).subscribe(this.updateServerGroup);
    this.serverGroupsRefreshUnsubscribe = this.props.app.serverGroups.onRefresh(null, () => {
      this.props.detailsGetter(this.props, this.autoClose).pipe(takeUntil(this.destroy$)).subscribe(this.updateServerGroup);
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.serverGroup !== this.props.serverGroup) {
      this.props.detailsGetter(nextProps, this.autoClose).pipe(takeUntil(this.destroy$)).subscribe(this.updateServerGroup);
    }
  }
  componentWillUnmount() {
    this.destroy$.next();
    this.serverGroupsRefreshUnsubscribe();
  }
  render() {
    const { Actions, app, sections } = this.props;
    const { loading, serverGroup } = this.state;
    const showEntityTags = SETTINGS.feature && SETTINGS.feature.entityTags;
    const hasInsightActions = serverGroup && serverGroup.insightActions && serverGroup.insightActions.length > 0;
    const CloseButton = /* @__PURE__ */ React__default.createElement("div", {
      className: "close-button"
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: "^"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-remove"
    })));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: `details-panel ${serverGroup && serverGroup.isDisabled ? "disabled" : ""}`
    }, loading && /* @__PURE__ */ React__default.createElement("div", {
      className: "header"
    }, CloseButton, /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal center middle"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "small"
    }))), !loading && /* @__PURE__ */ React__default.createElement("div", {
      className: "header"
    }, CloseButton, /* @__PURE__ */ React__default.createElement("div", {
      className: "header-text horizontal middle"
    }, /* @__PURE__ */ React__default.createElement(CloudProviderLogo, {
      provider: serverGroup.type,
      height: "36px",
      width: "36px"
    }), /* @__PURE__ */ React__default.createElement("h3", {
      className: "horizontal middle space-between flex-1"
    }, serverGroup.name, showEntityTags && /* @__PURE__ */ React__default.createElement(EntityNotifications, {
      entity: serverGroup,
      application: app,
      placement: "bottom",
      hOffsetPercent: "90%",
      entityType: "serverGroup",
      pageLocation: "details",
      onUpdate: () => app.serverGroups.refresh()
    }))), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: `actions ${hasInsightActions ? "insights" : ""}`
    }, /* @__PURE__ */ React__default.createElement(Actions, {
      app,
      serverGroup
    }), /* @__PURE__ */ React__default.createElement(ServerGroupInsightActions, {
      serverGroup
    })))), serverGroup && serverGroup.isDisabled && /* @__PURE__ */ React__default.createElement("div", {
      className: "band band-info"
    }, "Disabled ", timestamp(serverGroup.disabledDate)), !loading && serverGroup.isManaged && /* @__PURE__ */ React__default.createElement(ManagedResourceDetailsIndicator, {
      resourceSummary: serverGroup.managedResourceSummary,
      application: app
    }), !loading && /* @__PURE__ */ React__default.createElement("div", {
      className: "content"
    }, /* @__PURE__ */ React__default.createElement(RunningTasks, {
      serverGroup,
      application: app
    }), sections.map((Section, index) => /* @__PURE__ */ React__default.createElement(Section, {
      key: index,
      app,
      serverGroup
    }))));
  }
}

class ServerGroupDetailsWrapper extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      angular: {
        template: void 0,
        controller: void 0
      },
      Actions: void 0,
      detailsGetter: void 0,
      sections: []
    };
  }
  getServerGroupDetailsTemplate() {
    const { provider } = ReactInjector.$stateParams;
    $q.all([
      CloudProviderRegistry.getValue(provider, "serverGroup.detailsActions"),
      CloudProviderRegistry.getValue(provider, "serverGroup.detailsGetter"),
      CloudProviderRegistry.getValue(provider, "serverGroup.detailsSections"),
      CloudProviderRegistry.getValue(provider, "serverGroup.detailsTemplateUrl"),
      CloudProviderRegistry.getValue(provider, "serverGroup.detailsController")
    ]).then((values) => {
      const [Actions, detailsGetter, sections, templateUrl, controller] = values;
      const template = templateUrl ? $templateCache.get(templateUrl) : void 0;
      this.setState({ angular: { template, controller }, Actions, detailsGetter, sections });
    });
  }
  componentDidMount() {
    this.getServerGroupDetailsTemplate();
  }
  componentWillReceiveProps() {
    this.getServerGroupDetailsTemplate();
  }
  render() {
    const { app, serverGroup } = this.props;
    const {
      angular: { template, controller },
      Actions,
      detailsGetter,
      sections
    } = this.state;
    if (Actions && detailsGetter && sections) {
      return /* @__PURE__ */ React__default.createElement(ServerGroupDetails, {
        app,
        serverGroup,
        sections,
        Actions,
        detailsGetter
      });
    }
    if (template && controller) {
      return /* @__PURE__ */ React__default.createElement(AngularJSAdapter, {
        className: "detail-content flex-container-h",
        template,
        controller: `${controller} as ctrl`,
        locals: { app, serverGroup }
      });
    }
    return null;
  }
}

class ShowUserData extends React__default.Component {
  constructor(props) {
    super(props);
    this.close = () => {
      this.setState({ show: false });
    };
    this.open = () => {
      this.setState({ show: true });
    };
    this.onDecodeChange = ({ target }) => {
      this.setState({ decodeAsText: target.checked });
    };
    this.state = {
      show: false,
      decodeAsText: true
    };
  }
  render() {
    const { serverGroupName, title, userData } = this.props;
    const { show, decodeAsText } = this.state;
    return /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable",
      onClick: this.open
    }, "Show User Data"), /* @__PURE__ */ React__default.createElement(Modal$1, {
      show,
      onHide: this.close
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, {
      closeButton: true
    }, /* @__PURE__ */ React__default.createElement("h3", null, title || "User Data", " for ", serverGroupName)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("textarea", {
      className: "code",
      readOnly: true,
      rows: 15,
      value: decodeAsText ? decodeUnicodeBase64(userData) : userData
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox",
      style: { marginBottom: "0" }
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: decodeAsText,
      onChange: this.onDecodeChange
    }), "Decode as text")))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: this.close
    }, "Close"))));
  }
}

function CurrentCapacity(props) {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("dt", null, "Current"), /* @__PURE__ */ React__default.createElement("dd", null, props.currentCapacity));
}

function DesiredCapacity(props) {
  const SimpleCapacity = () => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("dt", null, "Min/Max"), /* @__PURE__ */ React__default.createElement("dd", null, props.capacity.desired));
  const AdvancedCapacity = () => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("dt", null, "Min"), /* @__PURE__ */ React__default.createElement("dd", null, props.capacity.min), /* @__PURE__ */ React__default.createElement("dt", null, "Desired"), /* @__PURE__ */ React__default.createElement("dd", null, props.capacity.desired), /* @__PURE__ */ React__default.createElement("dt", null, "Max"), /* @__PURE__ */ React__default.createElement("dd", null, props.capacity.max));
  return props.simpleMode ? /* @__PURE__ */ React__default.createElement(SimpleCapacity, null) : /* @__PURE__ */ React__default.createElement(AdvancedCapacity, null);
}

function CapacityDetailsSection(props) {
  const { capacity, current } = props;
  const simpleMode = capacity.min === capacity.max;
  return /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-horizontal dl-narrow"
  }, /* @__PURE__ */ React__default.createElement(DesiredCapacity, {
    capacity,
    simpleMode
  }), /* @__PURE__ */ React__default.createElement(CurrentCapacity, {
    currentCapacity: current
  }));
}

var css_248z$14 = ".ScalingAcivitiesModalBody {\n  font-size: 16px;\n}\n";
styleInject(css_248z$14);

const groupScalingActivities = (activities) => {
  const grouped = groupBy(activities, "cause");
  const results = [];
  forOwn(grouped, (group) => {
    if (group.length) {
      const events = [];
      group.forEach((entry) => {
        let availabilityZone = "unknown";
        try {
          availabilityZone = JSON.parse(entry.details)["Availability Zone"] || availabilityZone;
        } catch (e) {
        }
        events.push({ description: entry.description, availabilityZone });
      });
      results.push({
        cause: group[0].cause,
        events,
        startTime: group[0].startTime,
        statusCode: group[0].statusCode,
        isSuccessful: group[0].statusCode === "Successful"
      });
    }
  });
  return sortBy(results, "startTime").reverse();
};
const ScalingActivitiesModal = ({ dismissModal, serverGroup }) => {
  const fetchScalingActivities = () => ServerGroupReader.getScalingActivities(serverGroup).then((a) => groupScalingActivities(a));
  const { result: scalingActivities, status, error } = useData(fetchScalingActivities, [], [serverGroup.name]);
  const loading = status === "PENDING";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ModalHeader, null, `Scaling Activities for ${serverGroup.name}`), /* @__PURE__ */ React.createElement(ModalBody, null, loading && /* @__PURE__ */ React.createElement("div", {
    className: "ScalingAcivitiesModalBody middle center sp-margin-xl-yaxis"
  }, /* @__PURE__ */ React.createElement(Spinner, null)), !loading && Boolean(error) && /* @__PURE__ */ React.createElement("div", {
    className: "ScalingAcivitiesModalBody middle sp-margin-xl-yaxis"
  }, /* @__PURE__ */ React.createElement("p", null, `There was an error loading scaling activities for ${serverGroup.name}. Please try again later.`)), !loading && !error && !scalingActivities.length && /* @__PURE__ */ React.createElement("div", {
    className: "ScalingAcivitiesModalBody middle sp-margin-xl-yaxis"
  }, /* @__PURE__ */ React.createElement("p", null, `No scaling activities found for ${serverGroup.name}.`)), !loading && !error && scalingActivities.length > 0 && /* @__PURE__ */ React.createElement("div", {
    className: "ScalingAcivitiesModalBody middle sp-margin-xl-yaxis"
  }, scalingActivities.map((a, i) => /* @__PURE__ */ React.createElement("div", {
    key: a.cause
  }, /* @__PURE__ */ React.createElement("p", {
    className: "clearfix"
  }, /* @__PURE__ */ React.createElement("span", {
    className: `label label-${a.isSuccessful ? "success" : "danger"} pull-left`
  }, a.statusCode), /* @__PURE__ */ React.createElement("span", {
    className: "label label-default pull-right"
  }, timestamp(a.startTime))), /* @__PURE__ */ React.createElement("p", null, a.cause), /* @__PURE__ */ React.createElement("p", null, "Summary of activities:"), /* @__PURE__ */ React.createElement("ul", null, sortBy(a.events, "availabilityZone", "description").map((e) => /* @__PURE__ */ React.createElement("li", {
    key: e.description
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sp-margin-xs-right"
  }, e.description), e.availabilityZone && /* @__PURE__ */ React.createElement("span", null, e.availabilityZone)))), i !== scalingActivities.length - 1 && /* @__PURE__ */ React.createElement("hr", null))))), /* @__PURE__ */ React.createElement(ModalFooter, {
    primaryActions: /* @__PURE__ */ React.createElement("button", {
      className: "btn btn-primary",
      onClick: dismissModal
    }, "Close")
  }));
};

const ViewScalingActivitiesLink = ({ serverGroup }) => /* @__PURE__ */ React.createElement("a", {
  className: "clickable",
  onClick: () => showModal(ScalingActivitiesModal, { serverGroup }, { maxWidth: "1000px" })
}, "View Scaling Activities");

class ServerGroupWarningMessageService {
  static addDestroyWarningMessage(application, serverGroup, params) {
    const remainingServerGroups = this.getOtherServerGroupsInCluster(application, serverGroup);
    if (!remainingServerGroups.length) {
      params.body = `<h4 class="error-message">You are destroying the last Server Group in the Cluster.</h4>
        <dl class="dl-horizontal dl-narrow">
          <dt>Account: </dt>
          <dd>${serverGroup.account}</dd>
          <dt>Region: </dt>
          <dd>${serverGroup.region}</dd>
          <dt>Cluster: </dt>
          <dd>${serverGroup.cluster}</dd>
        </dl>`;
    }
  }
  static addDisableWarningMessage(application, serverGroup, params) {
    if (!serverGroup.instanceCounts.up) {
      return;
    }
    const otherServerGroupsInCluster = this.getOtherServerGroupsInCluster(application, serverGroup);
    const remainingActiveServerGroups = otherServerGroupsInCluster.filter((s) => !s.isDisabled && s.instanceCounts.up > 0);
    const hasOtherInstances = otherServerGroupsInCluster.some((s) => s.instances.length > 0);
    if (hasOtherInstances || remainingActiveServerGroups.length === 0 || otherServerGroupsInCluster.length === 0) {
      const totalActiveInstances = remainingActiveServerGroups.reduce((acc, s) => {
        return s.instanceCounts.up + acc;
      }, serverGroup.instanceCounts.up);
      const activeInstancesAfterDisable = totalActiveInstances - serverGroup.instanceCounts.up;
      const activePercentRemaining = Math.round(activeInstancesAfterDisable / totalActiveInstances * 100);
      params.body = `<h4>You are disabling <b>${serverGroup.instanceCounts.up}</b>
            instance${serverGroup.instanceCounts.up === 1 ? "" : "s"}.</h4>
        <p>This will reduce the cluster to <b>${activePercentRemaining}</b> percent of its current capacity,
           leaving <b>${activeInstancesAfterDisable}</b> instance${activeInstancesAfterDisable === 1 ? "" : "s"} taking
            traffic.</p>
        <ul>${this.getRemainingServerGroupsForDisplay(remainingActiveServerGroups)}</ul>`;
      params.verificationLabel = `Verify the number of remaining active instances
          (<span class="verification-text">${activeInstancesAfterDisable}</span>) after disabling this server group.`;
      params.textToVerify = `${activeInstancesAfterDisable}`;
      delete params.account;
    }
  }
  static getOtherServerGroupsInCluster(application, serverGroup) {
    const cluster = application.clusters.find((c) => c.account === serverGroup.account && c.name === serverGroup.cluster);
    return cluster ? cluster.serverGroups.filter((s) => s.region === serverGroup.region && s.name !== serverGroup.name) : [];
  }
  static getRemainingServerGroupsForDisplay(serverGroups) {
    return serverGroups.sort((a, b) => b.name.localeCompare(a.name)).map((sg) => {
      let label = sg.name;
      if (has(sg, "buildInfo.jenkins.number")) {
        label = `${sg.name} (build #${sg.buildInfo.jenkins.number})`;
      }
      return `<li>${label}: ${sg.instanceCounts.up} instance${sg.instanceCounts.up === 1 ? "" : "s"}</li>`;
    }).join("\n");
  }
}

class CloudMetricsReader {
  static listMetrics(provider, account, region, filters) {
    return REST("/cloudMetrics").path(provider, account, region).query(filters).get();
  }
  static getMetricStatistics(provider, account, region, name, filters) {
    return REST("/cloudMetrics").path(provider, account, region, name, "statistics").query(filters).get();
  }
}

function MinMaxDesiredChanges(props) {
  const { current, next } = props;
  const fields = ["min", "max", "desired"];
  const changedCapacityFields = fields.map((field) => {
    const hasChanged = current[field] !== next[field];
    return hasChanged ? { field, currentValue: current[field], nextValue: next[field] } : null;
  }).filter((x) => !!x);
  if (!changedCapacityFields.length) {
    return /* @__PURE__ */ React__default.createElement("span", null, "No changes");
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, changedCapacityFields.map((field) => /* @__PURE__ */ React__default.createElement("div", {
    key: field.field
  }, startCase(field.field), ": ", /* @__PURE__ */ React__default.createElement("b", null, field.currentValue), " ", /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-long-arrow-alt-right"
  }), " ", /* @__PURE__ */ React__default.createElement("b", null, field.nextValue))));
}

class ServerGroupWriter {
  constructor(serverGroupTransformer) {
    this.serverGroupTransformer = serverGroupTransformer;
  }
  cloneServerGroup(command, application) {
    let description;
    if (command.viewState.mode === "clone") {
      description = `Create Cloned Server Group from ${command.source.asgName}`;
      command.type = "cloneServerGroup";
    } else {
      command.type = "createServerGroup";
      description = `Create New Server Group in cluster ${NameUtils.getClusterName(application.name, command.stack, command.freeFormDetails)}`;
    }
    return TaskExecutor.executeTask({
      job: [this.serverGroupTransformer.convertServerGroupCommandToDeployConfiguration(command)],
      application,
      description
    });
  }
  destroyServerGroup(serverGroup, application, params = {}) {
    params.asgName = serverGroup.name;
    params.moniker = serverGroup.moniker;
    params.serverGroupName = serverGroup.name;
    params.type = "destroyServerGroup";
    params.region = serverGroup.region;
    params.credentials = serverGroup.account;
    params.cloudProvider = serverGroup.type || serverGroup.provider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Destroy Server Group: ${serverGroup.name}`
    });
  }
  disableServerGroup(serverGroup, appName, params = {}) {
    params.asgName = serverGroup.name;
    params.serverGroupName = serverGroup.name;
    params.moniker = serverGroup.moniker;
    params.type = "disableServerGroup";
    params.region = serverGroup.region;
    params.credentials = serverGroup.account;
    params.cloudProvider = serverGroup.type || serverGroup.provider;
    return TaskExecutor.executeTask({
      job: [params],
      application: appName,
      description: `Disable Server Group: ${serverGroup.name}`
    });
  }
  enableServerGroup(serverGroup, application, params = {}) {
    params.asgName = serverGroup.name;
    params.serverGroupName = serverGroup.name;
    params.moniker = serverGroup.moniker;
    params.type = "enableServerGroup";
    params.region = serverGroup.region;
    params.credentials = serverGroup.account;
    params.cloudProvider = serverGroup.type || serverGroup.provider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Enable Server Group: ${serverGroup.name}`
    });
  }
  getCapacityString(capacity) {
    if (!capacity) {
      return null;
    }
    return Object.keys(capacity).map((k) => `${k}: ${capacity[k]}`).join(", ");
  }
  mapLoadBalancers(serverGroup, application, params = {}) {
    params.type = "mapLoadBalancers";
    params.name = [serverGroup.name];
    params.loadBalancerNames = serverGroup.loadBalancers;
    params.region = serverGroup.region;
    params.credentials = serverGroup.account;
    params.cloudProvider = serverGroup.cloudProvider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Map load balancers for server group: ${serverGroup.name}`
    });
  }
  resizeServerGroup(serverGroup, application, params = {}) {
    params.asgName = serverGroup.name;
    params.serverGroupName = serverGroup.name;
    params.moniker = serverGroup.moniker;
    params.type = "resizeServerGroup";
    params.region = serverGroup.region;
    params.credentials = serverGroup.account;
    params.cloudProvider = serverGroup.type || serverGroup.provider;
    const currentSize = this.getCapacityString(serverGroup.capacity);
    const newSize = this.getCapacityString(params.capacity);
    const currentSizeText = currentSize ? ` from (${currentSize}) ` : " ";
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Resize Server Group: ${serverGroup.name}${currentSizeText}to (${newSize})`
    });
  }
  rollbackServerGroup(serverGroup, application, params = {}) {
    params.type = "rollbackServerGroup";
    params.moniker = serverGroup.moniker;
    params.region = serverGroup.region;
    params.credentials = serverGroup.account;
    params.cloudProvider = serverGroup.type || serverGroup.provider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Rollback Server Group: ${serverGroup.name}`
    });
  }
  unmapLoadBalancers(serverGroup, application, params = {}) {
    params.type = "unmapLoadBalancers";
    params.name = [serverGroup.name];
    params.loadBalancerNames = serverGroup.loadBalancers;
    params.region = serverGroup.region;
    params.credentials = serverGroup.account;
    params.cloudProvider = serverGroup.cloudProvider;
    return TaskExecutor.executeTask({
      job: [params],
      application,
      description: `Unmap load balancers for server group: ${serverGroup.name}`
    });
  }
  updateSecurityGroups(serverGroup, securityGroups, application, hasLaunchTemplate) {
    const job = {
      amiName: serverGroup.image.name,
      imageId: serverGroup.image.imageId,
      moniker: serverGroup.moniker,
      cloudProvider: serverGroup.type || serverGroup.provider,
      credentials: serverGroup.account,
      region: serverGroup.region,
      securityGroups: securityGroups.map((group) => group.id),
      serverGroupName: serverGroup.name,
      type: "updateSecurityGroupsForServerGroup"
    };
    if (hasLaunchTemplate) {
      job.hasLaunchTemplate = hasLaunchTemplate;
    }
    return TaskExecutor.executeTask({
      job: [job],
      application,
      description: `Update ${FirewallLabels.get("firewalls")} for ${serverGroup.name}`
    });
  }
}
ServerGroupWriter.$inject = ["serverGroupTransformer"];
const SERVER_GROUP_WRITER = "spinnaker.core.serverGroup.write.service";
module(SERVER_GROUP_WRITER, [CORE_SERVERGROUP_SERVERGROUP_TRANSFORMER]).service("serverGroupWriter", ServerGroupWriter);

const ServerGroupTemplates = {
  userData: "core/src/serverGroup/details/userData.html"
};
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/serverGroup/details/userData.html", `<div modal-page>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">{{userDataModalTitle || 'User Data'}} for {{serverGroup.name}}</h4>
  </div>
  <form role="form">
    <div class="modal-body">
      <textarea readonly="readonly" rows="15" class="code">{{userData}}</textarea>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" ng-click="$close()">Close</button>
    </div>
  </form>
</div>
`);
}]);

class ServerGroupManagerReader {
  static getServerGroupManagersForApplication(application) {
    return REST("/applications").path(application, "serverGroupManagers").get();
  }
}

const SERVER_GROUP_MANAGER_DATA_SOURCE = "spinnaker.core.serverGroupManager.dataSource";
module(SERVER_GROUP_MANAGER_DATA_SOURCE, []).run([
  "$q",
  ($q) => {
    const loader = (application) => ServerGroupManagerReader.getServerGroupManagersForApplication(application.name);
    const onLoad = (_application, serverGroupManagers) => $q.resolve(serverGroupManagers);
    const addTags = (application) => {
      EntityTagsReader.addTagsToServerGroupManagers(application);
    };
    ApplicationDataSourceRegistry.registerDataSource({
      key: "serverGroupManagers",
      visible: false,
      loader,
      onLoad,
      afterLoad: addTags,
      defaultData: []
    });
  }
]);

var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __decorateClass$f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$f(target, key, result);
  return result;
};
let ServerGroupManagerDetails = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("h3", null, "Server Group Manager Details");
  }
};
ServerGroupManagerDetails = __decorateClass$f([
  Overridable("serverGroupManager.details")
], ServerGroupManagerDetails);

const SERVER_GROUP_MANAGER_STATES = "spinnaker.core.serverGroupManager.states";
module(SERVER_GROUP_MANAGER_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  (applicationStateProvider) => {
    const serverGroupManagerDetails = {
      name: "serverGroupManager",
      url: "/serverGroupManagerDetails/:provider/:accountId/:region/:serverGroupManager",
      views: {
        "detail@../insight": {
          component: ServerGroupManagerDetails,
          $type: "react"
        }
      },
      resolve: {
        accountId: ["$stateParams", ($stateParams) => $stateParams.accountId],
        serverGroupManager: ["$stateParams", ($stateParams) => $stateParams]
      },
      data: {
        pageTitleDetails: {
          title: "Server Group Manager Details",
          nameParam: "serverGroupManager",
          accountParam: "accountId",
          regionParam: "region"
        },
        history: {
          type: "serverGroupManagers"
        }
      }
    };
    applicationStateProvider.addInsightDetailState(serverGroupManagerDetails);
  }
]);

class ServerGroupManagerTag extends React__default.Component {
  constructor() {
    super(...arguments);
    this.openDetails = (event) => {
      event.preventDefault();
      const { $state } = ReactInjector;
      const nextState = $state.current.name.endsWith(".clusters") ? ".serverGroupManager" : "^.serverGroupManager";
      $state.go(nextState, this.buildStateParams());
    };
  }
  render() {
    const serverGroupManager = this.extractServerGroupManager();
    if (!serverGroupManager) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "server-group-manager-tag"
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: `Server Group Manager: ${serverGroupManager.name}`
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-link no-padding btn-server-group-manager",
      onClick: this.openDetails
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "badge badge-counter"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "fa fa-server"
    })))));
  }
  extractServerGroupManager() {
    const { application, serverGroup } = this.props;
    return application.getDataSource("serverGroupManagers").data.find((manager) => manager.serverGroups.some((group) => serverGroup.name === group.name && serverGroup.region === manager.region && serverGroup.account === manager.account));
  }
  buildStateParams() {
    const serverGroupManager = this.extractServerGroupManager();
    return {
      accountId: serverGroupManager.account,
      region: serverGroupManager.region,
      provider: serverGroupManager.cloudProvider,
      serverGroupManager: serverGroupManager.name
    };
  }
}

class ServicesReader {
  static getServices(account, region) {
    return REST("/servicebroker").path(account, "services").query({
      cloudProvider: "cloudfoundry",
      region
    }).get();
  }
}

class SlackReader {
  static getChannels() {
    return REST("/slack/channels").get().catch(() => []);
  }
}

function SlackChannelSelector({ channel, callback }) {
  const [selectedChannel, setSelectedChannel] = React__default.useState(channel);
  const fetchChannels = useLatestPromise(() => SlackReader.getChannels(), []);
  const channels = fetchChannels.result;
  const isLoading = fetchChannels.status === "PENDING";
  const onInputChange = (evt) => {
    const newChannel = evt ? evt.target.value : null;
    callback("slackChannel", newChannel || {});
    setSelectedChannel(newChannel);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-sm-3 sm-label-right"
  }, "Slack Channel"), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-sm-9"
  }, /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
    inputClassName: "form-control input-sm",
    mode: "VIRTUALIZED",
    options: (channels || []).map((ch) => ({ value: ch, label: ch.name })),
    value: selectedChannel && { value: selectedChannel, label: selectedChannel.name },
    onChange: onInputChange,
    isLoading
  })));
}

const SLACK_COMPONENT = "spinnaker.application.slackChannelSelector.component";
module(SLACK_COMPONENT, []).component("slackChannelSelector", react2angular(withErrorBoundary(SlackChannelSelector, "slackChannelSelector"), ["channel", "callback"]));

class StorageAccountReader {
  static getStorageAccounts() {
    return REST("/storage").get();
  }
}

class SubnetReader {
  static listSubnets() {
    if (this.cache) {
      return this.cache;
    }
    this.cache = REST("/subnets").get().then((subnets) => {
      subnets.forEach((subnet) => {
        subnet.label = subnet.purpose;
        subnet.deprecated = !!subnet.deprecated;
        if (subnet.deprecated) {
          subnet.label += " (deprecated)";
        }
      });
      return subnets.filter((s) => s.label);
    });
    return this.cache;
  }
  static listSubnetsByProvider(cloudProvider) {
    return REST("/subnets").path(cloudProvider).get();
  }
  static getSubnetByIdAndProvider(subnetId, cloudProvider = "aws") {
    return this.listSubnetsByProvider(cloudProvider).then((subnets) => {
      return subnets.find((subnet) => subnet.id === subnetId);
    });
  }
  static getSubnetPurpose(subnetId) {
    return this.listSubnets().then((subnets) => {
      const match = subnets.find((test) => test.id === subnetId);
      return match ? match.purpose : null;
    });
  }
}

class SubnetTag extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { subnetLabel: this.props.subnetId ? `(${this.props.subnetId})` : null };
  }
  componentDidMount() {
    const { subnetId } = this.props;
    if (subnetId) {
      SubnetReader.getSubnetPurpose(subnetId).then((name) => {
        this.setState({
          subnetLabel: name
        });
      });
    }
  }
  render() {
    const { subnetId } = this.props;
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "subnet-tag"
    }, this.state.subnetLabel, /* @__PURE__ */ React__default.createElement(CopyToClipboard, {
      text: subnetId,
      toolTip: `${subnetId} (click to copy)`
    }));
  }
}

function yamlStringToDocuments(yamlString) {
  try {
    const yamlDocuments = loadAll(yamlString, null);
    if (Array.isArray(head(yamlDocuments))) {
      return head(yamlDocuments);
    }
    return yamlDocuments;
  } catch (e) {
    return null;
  }
}
function yamlDocumentsToString(yamlDocuments) {
  try {
    return yamlDocuments.map((m) => dump(m)).join("---\n");
  } catch (e) {
    return "";
  }
}

class YamlEditor extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleChange = (raw) => {
      const yamlDocuments = yamlStringToDocuments(raw);
      this.props.onChange ? this.props.onChange(raw, yamlDocuments) : $log.warn("No `onChange` handler provided for YAML editor.");
    };
    this.calculateErrors = (value) => {
      try {
        loadAll(value, null);
      } catch (e) {
        if (e instanceof YAMLException) {
          const mark = e.mark;
          return [
            {
              column: mark.column,
              row: mark.line,
              type: "error",
              text: e.message
            }
          ];
        }
      }
      return [];
    };
    this.render = () => {
      const { value } = this.props;
      return /* @__PURE__ */ React__default.createElement(AceEditor, {
        mode: "yaml",
        theme: "textmate",
        name: "yaml-editor",
        style: { width: "auto" },
        onChange: this.handleChange,
        fontSize: 12,
        showGutter: true,
        cursorStart: 0,
        showPrintMargin: false,
        minLines: 50,
        maxLines: 100,
        highlightActiveLine: true,
        value: value || void 0,
        annotations: this.calculateErrors(value),
        setOptions: {
          firstLineNumber: 1,
          tabSize: 2,
          showLineNumbers: false,
          showFoldWidgets: false
        },
        editorProps: { $blockScrolling: Infinity },
        className: "ace-editor"
      });
    };
  }
}

const YAML_EDITOR_COMPONENT = "spinnaker.core.yamlEditor.component";
module(YAML_EDITOR_COMPONENT, []).component("yamlEditor", react2angular(withErrorBoundary(YamlEditor, "yamlEditor"), ["onChange", "value"]));

var css_248z$13 = "@font-face {\n  font-family: 'icomoon';\n  src: url('data:font/woff2;base64,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') format('woff2'), url('data:font/ttf;base64,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') format('truetype'),\n    url('data:font/woff;base64,d09GRgABAAAAAJwMAAsAAAAAm8AAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAABCAAAAGAAAABgDxIdJmNtYXAAAAFoAAAArAAAAKwXbJOoZ2FzcAAAAhQAAAAIAAAACAAAABBnbHlmAAACHAAAlaAAAJWgwx+VE2hlYWQAAJe8AAAANgAAADYY6NJIaGhlYQAAl/QAAAAkAAAAJAiZBPZobXR4AACYGAAAAXAAAAFwZt4R52xvY2EAAJmIAAAAugAAALpXCjAsbWF4cAAAmkQAAAAgAAAAIAB6A7puYW1lAACaZAAAAYYAAAGGmUoJ+3Bvc3QAAJvsAAAAIAAAACAAAwAAAAMD/QGQAAUAAAKZAswAAACPApkCzAAAAesAMwEJAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAA//8DwP/AAEADwABAAAAAAQAAAAAAAAAAAAAAIAAAAAAABgAAAAMAAAA0AAAABAAAAGwAAQADAAAANAABAAQAAABsAAMAAQAAADQAAwAKAAAAbAAEADgAAAAKAAgAAgACAAEAIOlW//3//wAAAAAAIOkA//3//wAB/+MXBAADAAEAAAAAAAAAAAAAAAwAAAAAAEAAAAAAAAAABAAAAAAAAAABAAAAAQAAACAAAAAgAAAAAwAA6QAAAOlWAAAABAAB9fYAAfX2AAAAWwABAAH//wAPAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAMBdf/AAosDwAALABcAIwAAARQGIyImNTQ2MzIWERQGIyImNTQ2MzIWERQGIyImNTQ2MzIWAotSOTlSUjk5UlI5OVJSOTlSUjk5UlI5OVIDNTlRUTk6UVH+UTlSUjk5UlL+UjpRUTo5UVEAAAUAAP/ABAADwABoAH8AjwCnALcAAAUiJj0BNDY7ASYnLgEnJisBFTMyFh0BFAYrASImPQE0NjsBNSMiBw4BBwYHMzIWHQEUBisBIiY9ATQ2OwE2Nz4BNzY7AREjIiY9ATQ2OwEyFh0BFAYrAREzMhceARcWFzMyFh0BFAYrATUiBh0BFBY7ATI2PQE0JisBMCIxMCIxISIGHQEUFjsBMjY9ATQmIyEiBh0BFBY7ATI2PQE0JisBMCIxMCIxIwEiBh0BFBY7ATI2PQE0JiMDQBomJhoqBBQUPygpLmsrGiYmGoAaJiYaK2suKSg/FBQEKhomJhqAGiYmGiwEFxdKMTA3aysaJiYagBomJhorazcwMUoXFwQsGiYmGoAJDAwJgAkMDAk/AQH+QQkMDAmACQwMCf4ACQwMCYAJDAwJPwEBPwGACQwMCYAJDAwJQCYagBslLScnOhAQ1SUbgBomJhqAGyXVEBA6JyctJRuAGiYmGoAbJTYvL0UTFAEAJhqAGyUlG4AaJv8AFBNFLy82JRuAGibVDAmACQwMCYAJDAwJgAkMDAmACQwMCYAJDAwJgAkMAwAMCYAJDAwJgAkMAAACAFUAWgOrA00AHgA9AAABJSYiBwUOAR0BFBYXFjI3JToBMwUWMjc+AT0BNCYnESUmIgcFDgEdARQWFxYyNyU6ATMFFjI3PgE9ATQmJwOJ/pUQIBD+mRASCAkKEwoBagQKBAFqChMKCQgSEP6VECAQ/pUNEQgJChMKAWoECgQBagoTCgkIEhACicQGBsQKHhBaCREDBATExAcHAxEJWhAeCv6AxAYGxAoeEFoJEQMEBMTEBwcDEQlaEB4KAAIAFQAVA+sDawBEAIYAACUiJy4BJyYnJicuAScmNz4BNyMiJjU0NjsBMhYdARQGIyImPQEOAQcGFhcWFx4BFxYzOAExMjY3PgEzMhYXFgYHDgEjMSUjIiY9ATQ2MzIWHQE+ATc2JicmJy4BJyYjIgYHDgEjIiYnJjY3PgEzMhceARcWFxYXHgEXFgcOAQczMhYVFAYjMQIALCsrUCQkHh0WFh4GBwEDNDCRCQ0NCcAJDA0ICQ0nLAIDNjQbISBIJicoN2kvAgYDBgkDBQQHNHU9AdXACQwNCAkNJywCAzU1GyAhSCYnKDZpLgIGAwYJAwUECDN0PC0rK08kJB4dFxYdBwYBAjUwkQkNDQkVCQkiGhkgHyQjTiopK0mHNw0JCA0NCMAJDQ0IhzB2P02OOB0XFh8ICB4eAgIGBAgRBSEiawwJwAkMDAmHMXU/TY44HRcXHwgIHh0CAQUECBEFICIJCSMZGSAgIyROKSkrSYc3DQkIDQAAAAAEABUAmgPrAuYAXABrANQBPQAANzUuAScuASc3HgEXHgEzMjY3PgE1NCYnLgEnLgEnLgEnLgEnLgE1NDY3PgE3NTMVHgEXHgEXBy4BJy4BIyIGBw4BFRQWFx4BFx4BFx4BFx4BFx4BFRQGBw4BBxUjASc3JzcXNzMXNxcHFwcnEzUzMjY3PgE1PAE1PAE1NDY3PgE3MS4BJy4BNTwBNTwBNTQmJy4BKwE1MzIWFx4BFx4BFR4BFRQGBxQGFRQWFx4BMxUiBgcOAQcOARUUBhUcARUcARUcARUcARUUBgcOAQcOASMOASsBARUjIgYHDgEVHAEVHAEVFAYHDgEHMR4BFx4BFRwBFRwBFRQWFx4BOwEVIyImJy4BJy4BNS4BNTQ2NzQ2NTQmJy4BIzUyNjc+ATc+ATU0NjU8ATU8ATU8ATU8ATU0Njc+ATc+ATM+ATsBiRAgEBAaChoKGA0NHxATHgYKBwYHBhIKCRkNDRUNCRIHBgcNDQ0lFyoQHgoMFQkeCRMKChgNEBkKCgcGBwYSCgkZDQ0YCgkSBwYHDhANKhYmAeYaJ0UNRQQiBE0JRScaL6sRDRMGAwYFAwQRCQkRBAMFBgMDExARHgkSBwYNBgcGAwEBAwQGBwYZEAoOBgcHAwMGBAEDBAYDBwwHBhIKFf6iEQ0TBwMFBQQDDgwJEQMEBQUDBBMQER4KEgYGDQcGBgQBAQQEBwYGGRAKDgYGCAMDBgQBAwMHAwYNBgcSChWaRAMIBgYSCiYJEgcGBgsKCRoQDRgKCg0HBg0GBw4JBxMNDRYQFicQEBMDREQDCAYGEgoiCQ4HAwUHCgkWEA0UCQoOBgcLBAYNBgoTCgwcExonEBAUA0QBERVAGiIRSEgRHhlAFjj+ryIGBwYYEBAfDRAgEBAaCQoNAwMNCgkaEBAgEBAcEBAYBgcGIgEDAwYEBg4KCRQNEyEQECAQChIHCQgiAQMDBwMDCwMDDAYKDwkHEQYHEgkKDwoMGAYKDgYGBwMBAkgiBgcGGBAQHw0QIBAQGgkKDQMDDQoJGhAQIBAQHBAQGAYHBiIBAwMGBAYOCgkUDRMhEBAgEAoSBwkIIgEDAwcDAwsDAwwGCg8JBxEGBxIJCg8KDBgGBxEGBgcDAQAEAAH/wAPVA74AMAA0ADkARwAAFyImJy4BNxMwNjU0NjcyNDEBPgE7ATIWFxYUDwEUMCMBFCIxDgEjMBQxKgEVBSIGIz8BJwc3AScBFwE3NjQnLgEnIyIGDwEXFgUHAwUDAlsBAgEBAqAWNR0DHjYVKioeAf1+AQEDAQEB/vABBAEhx4VC7gJkl/2clwKCDx4eDyYWAhQnDw+XQAMDBQsGARABAQEDAQECoBUVGBUseCwdAf1+AQECAQFaATdChMZXAmSX/ZyXAoIPH1YfEBABEA4PlwAAAAAEACT/wQPVA4AAGwA6AEkAYgAABSoBIyEqASMiJicmNjcBPgEzMhYXARYGBw4BIyUOARUwBjEeATM2MjMhOgEXOAExMjYxNjQ1LgE1CQElIiY1ETQ2MzIWFREUBiMVIiY1NDY3PgE3HgEXFAYHDgEjMCIxOAExA64BAwH8rgICAhEZAwEDBQGvCRcGBxYJAa8JBg8GDQj8owEBAQEBAQECAQNVAQIBAQEBAQH+Uf5RAa8JDQ0JCQwMCQ0TBAUEDAYOEgEFBAQMBgE/FREJEAcDXRMJChL8ow8kCwQEMgEBAQIBAgEBAQECAQEBAQNe/KLjDQkBKgkNDQn+1gkNahIMBwwFBAUBARIMBwwFBAUAAAMAAP/ABAADwAA2AE0AZAAABSInLgEnJiciJjEwJicmJy4BJyY1NDc+ATc2MzIXHgEXFhcyFjEwFhUWFx4BFxYVFAcOAQcGIyUWFx4BFxYzMjc+ATc2NTQnLgEnJicBASIHDgEHBhUUFx4BFxYXASYnLgEnJiMCADMxMVwpKiQBAQEBIxwcJQoKKCmLXV1qMzExXCkqJAEBASQcHCYJCigpi11dav7EICUlUSorLGFWVX8lJQgIHxcXHv1qATxhVlV/JSUICB8XFx4CliAlJVEqKyxACgkmHBwkAQEBJCopXDExM2pdXYspKAoJJhwcJAEBASQqKVwxMTNqXV2LKSimHhcXHwgIJSV/VVZhLCsqUSUlIP1qAy8lJX9VVmEsKypRJSUgApYeFxcfCAgAAAAGAAD/wAQAA8AAIgAtADgARgBUAGIAABciJjURIyImNTQ2MyE1NDYzITIWHQEhMhYVFAYrAREUBiMhJxQWMyEyNjURIREBNTQmIyEiBh0BIQEiJjURNDYzMhYVERQGMyImNRE0NjMyFhURFAYzIiY1ETQ2MzIWFREUBsAaJmsIDQ0IARYlGwEqGyUBFggNDQhrJhr9gBUMCQKACQz9VgIADQn+1gkNAVb+lQkMDAkJDAy3CQwMCQkMDLcJDAwJCQwMQCYaAxUNCQgNQBomJhpADQgJDfzrGiZACQwMCQMV/OsDQEAJDAwJQP1ADQgCAAkNDQn+AAgNDQgCAAkNDQn+AAgNDQgCAAkNDQn+AAgNAAwA1f/rAysDlQAMABkAJQAyAD8ATABZAGYAcwCAAIwAmQAAATIWFRQGIyImNTQ2MzUiBhUUFjMyNjU0JiMFMhYVFAYjIiY1NDY3IgYVFBYzMjY1NCYjATIWFRQGIyImNTQ2MzUiBhUUFjMyNjU0JiMFMhYVFAYjIiY1NDYzNSIGFRQWMzI2NTQmIwEyFhUUBiMiJjU0NjM1IgYVFBYzMjY1NCYjBTIWFRQGIyImNTQ2NyIGFRQWMzI2NTQmIwFVJDIyJCMyMiM2Sko2N0lJNwFWIzIyIyQyMiQ3SUk3NkpKNv6qJDIyJCMyMiM2Sko2N0lJNwFWIzIyIyQyMiQ3SUk3NkpKNv6qJDIyJCMyMiM2Sko2N0lJNwFWIzIyIyQyMiQ3SUk3NkpKNgNrMiQjMjIjJDIqSTc2Sko2N0kqMiQjMjIjJDIqSTc2Sko2N0n+gDIjIzIyIyMyK0o2NkpKNjZKKzIjIzIyIyMyK0o2NkpKNjZK/oAyIyQyMiQjMitKNjdJSTc2SisyIyQyMiQjMitKNjdJSTc2SgAAAAAEAAsAlQP2AusACwAXAD0AWQAAASImNTQ2MzIWFRQGAyIGFRQWMzI2NTQmAyInLgEnJicmNDc2Nz4BNzYzMhceARcWFzgBMxYUBwYHDgEHBiMRIgcOAQcGBxYXHgEXFjMyNz4BNzY3JicuAScmAgBHZGRHR2RkRzVLSzU1S0s1W1JShC8uFQsLFS4vhFJSW1tSUoQvLhUBCgoVLy+EUlFcVUxNeywsFBQsLHtNTFVVTE18LCwTEywte01MARVkR0dkZEdHZAErSzU1S0s1NUv+VSIhWi0tGAwgDBgtLVohIiIhWS4tGAwgDBgtLVohIgIrIB9VKysWFyorVR8gIB9VKysWFyorVR8gAAAACQAA/8AEAAPAAAEANgB3AI8AmQCeAKIAqQCxAAABMQUiJicuATU0Njc+ATc+ATM6ARc2Nz4BNzY3PgEzMhYXHgEXFhceARcWFRQHDgEHBiMwIjEhAyIGBw4BBw4BFRQWFx4BMyE2Nz4BNzY1NCYnLgErASIGIzAiMSImJyYnLgEnJiMiBgcOAQcOAQcOASMqASMuASMTIiYnIjA1IjAxLgE1NDYzITIWFRQGIyElMjY1NCYrAQchITcjBzMjNyMHJx4BOwE3IyMiBhUUFhc3A/X8ygdfKRgYAgIHKR4WMxoEBwMFEA8uHx8lIEQkGzcaOVocMCkqPhISISBPISEBAv2UChQmERgfBQIBERIgTwICaggcHDwYGB0bG0YmAgEDAQEGCwMRGhpCJiUpHjscRVUEAQQEAwYEAQIBBw8HCw8cDQEBKjFXPgKAPldXPv2AAoAsPz8svVgBFf68WVJYUYBZUliABQsFPFlSQyw/GRZRAivrDygXQCcKEwkjOxQPDwEoJiVAGhkSDw8JChRPNQETEz8qKjBNLi4yCAgBQAsLEC0bBw4IHjASHwsBCAcpJSY8JkYbGx4BBwYkHR0qCwsNDSB+TAUIAwICAgH9QAYFARJLLD5YWD49WCs+LC0+1dXV1dUCAQHVPi0aLw/DAAQAFf/rA+sDlQBzAI8AqwDXAAATKgEjLgE3PgE3PgE3PgEzOgEzNjc+ATc2OwEXNTIXHgEXFhcWFx4BFxYXFgYHDgEjMSImJy4BNz4BNz4BJy4BKwEqASM4ATEiJicuASsBIgcOAQcGBxQGBw4BIyoBIy4BIyIGBw4BBw4BFQYWFx4BBw4BIwEiJy4BJyY1NDc+ATc2MzIXHgEXFhUUBw4BBwYDIgcOAQcGFRQXHgEXFjMyNz4BNzY1NCcuAScmAyImJy4BLwEuATU0Njc+ATMyFh8BMhQxHgEzMjY/AT4BMzIWFx4BDwEOASOVAQIBOUYDAQIBCCcdFTAYBAcECBsaUTIzOQMCKSgoRh0dFC0nKDwREgECQTgCBQIHCgMBAQIBBgQsNAIBaUoCAgMCBwoDIYFKBjMuLUcWFgQEBAMGBAECAQcPBxIkEBYdBgECAjMpCQkCAQwIAWs5MzJMFhUVFkwyMzk5MzJMFhUVFkwyMzkxKitAEhMTEkArKjExKitAEhMTEkArKlQJEAcCAwFAAwMDAwMIBAQIA0ABAgMCAgUBfAMJBQQGAwcDBnsIFwwBSQxcOggRCCI4Ew0ONy8vRRQTCgoLCykeHSQBERI7KCctPmkaAQEHBgQIBAQGAhVTMUloBgZDUBMTQSwsMgUIAwICAgILCg4qGgYNBypDCQIPCQcJ/qIVFkwyMzk5MzJMFRYWFUwyMzk5MzJMFhUCABMSQCsrMDEqK0ASExMSQCsqMTArK0ASE/6YBQYBAgJAAwcFBAgDAwMDA0ABAQECAqUEBQICBhEHpgoLAAAABwACAAED/gN+AEkAlwDPAOoBBAESASwAACUiJi8BLgE3EzQ2Nz4BMzIWHwEWMjM6AT8BPgEzMhYfARYyMzoBMzc+ATc6ATMyFhceARUTFgYPAQYiIyImLwEiJiMiBiMHDgEjNzIWHwEyFjM6AT8BPgEnAy4BJy4BKwEiBiMHDgEjIiYvASImIyIGIwcOASMiJi8BJiIjIgYHHAEVMAcGAgcGMQYWHwEWMjM6AT8BPgEzASImLwEHDgEjIiYnLgE1NDY/AScuATU0Njc+ATMyFh8BNz4BMzIWFx4BFRQGDwEXHgEVFAYHDgEFIiYnJjY3PgE/AToBMzIWFxYGBw4BDwEqASMXIiYvAS4BNz4BNz4BMzIWHwEeARUOAQcOARciJjU0NjsBMhYVFAYjNyImJy4BNTQ2PwE+ATMyFhceARUUBg8BDgEBFQQIBNMWGwEmAQEGIhYECQSsAQMBAgMBvgQJBQUJBL4BAwIBAwKrBAYEAQEBDBYJCgsmARsW0wQIBAQJBNQCAwECAgLUBAkE6wQJBNQCAwEBAwHTCAkBJQEDAwMIBAEBAgGsBAkEBQkFvQEDAgIDAb0FCQUECQSrAgMBBwwCBgYPBQYBCQjTAQMBAQMB1QQJBAFABAgDRkcDBwUECAMDAwMDR0cDAwMDAwgEBQcDR0YDCAQECAMDAwMDRkYDAwMDAwj9ZwgLAgEBAwIHBEMCAgEICwIBAQMCBwRDAgIBwAYJAyECAgEBBQMDBgMFCgMgAwEBBQMDBlIJDAwJQAkMDAlABAgDAwMDAysDBwUECAMDAwMDKwMIAQEBNQYlFwK9BAYEFBsBAS8BATkBAQEBOQEvAQEBCQgIFw39QxclBjUBAQE6AQE6AQJoAQE6AQE1AQ0HAr4ECAMCAwEvAQEBAjkBATkBAgECLgEJBwECAW5t/vlubgcNAjQBAToBAQFXAwNHRwMDAwMDCAUECANGRgMIBAQIAwMEBANGRgMEBAMDCAQECANGRgMIBAUIAwMDKgkHBAgEBAUBEAkHBAkDBAUBEFYFBTEECAQEBwMBAgUEMgMIBQQHAgICVQwJCQ0NCQkMQAMDAwgEBAgDKwMDAwMDCAQECAMrAwMAAAABAAAAagQAAxYAOAAAEwEeATMyNjcxAT4BNTQmJzEnLgEjIgYHMQEOASMiJicxAS4BIzEqASMiBgcxBw4BBzEcARUUFhcxCwHUBhEKChEGAdQFBggHTwYOCAoRBv6jAQUCAgUB/qMFDwkBAgEIDgZPBggBBgUCjf3rBggIBgIUBg4IChEGQgUGCQb+bAICAgIBlAYIBQVCBg8IAQIBCA4GAAAAAAQAFf/rA+sDlQB2AJMAsADeAAATKgEjLgE3NDY3PgE3PgEzOgEzNjc+ATc2OwEyFx4BFxYXFhceARcWFxYGBw4BIzgBMSImJy4BNz4BNz4BJy4BKwEqASM4ATEiJicuASsBIgcOAQcGBxQGBw4BIyoBJy4BIyIGBw4BBw4BFQYWFx4BFx4BBw4BIwEiJy4BJyY1NDc+ATc2MzIXHgEXFhUUBw4BBwYjESIHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJiMTIiYvAQcOASMiJicmND8BJyY0Nz4BMzIWHwE3PgEzMTIWFxYUDwEXFhQHDgEjlQECATlGAwICCCcdFTAYBAcDCRsaUDMzOAYpKChGHR0ULScoPBESAQJBOAMEAgcKAwEBAgEGBCw0AgFpSgICAwIHCgMhgkoFMy4tRxYWBAQEAwYEAQIBBw8HEiQQFh0GAQICMykEBwIDAQEBDAgBazkzMkwWFRUWTDIzOTkzMkwWFRUWTDIzOTEqK0ASExMSQCsqMTEqK0ASExMSQCsqMVoECANLSwMIBAUIAwYGTEwGBgMIBQQIA0tLAwgEBQgDBgZMTAYGAwgFAUkMXDoIEQgiOBMNDjcvL0UUEwsLKR4dJAEREjsoJy0+aRoBAQcGBAgEBAYCFVMxSWgGBkNQExNBLCwyBQgDAgIBAQILCg4qGgYNBypDCQEFBAMJBAcJ/qIVFkwyMzk5MzJMFhUVFkwyMzk5MzJMFhUCABMSQCsqMTEqK0ASExMSQCsqMTEqK0ASE/6lAwNMTAMDAwMHEQdLSwcRBwMDAwNMTAMDAwMHEQdLSwcRBwMDAAAAAAEAAP/ABAADgABVAAAlIzU0JiMhNTMyNj0BNCYrASIGHQEUFjsBFSEiBh0BIyIGHQEUFjsBMjY9ATQmKwE1IRUjIgYdARQWOwEyNj0BNCYrATUhFSMiBh0BFBY7ATI2PQE0JgPQEEIu/vAQFBwcFKAUHBwUEP7wLkIQFBwcFKAUHBwUEAEAEBQcHBSgFBwcFBABABAUHBwUoBQcHMDQLkKAHBSgFBwcFKAUHIBCLtAcFKAUHBwUoBQcwMAcFKAUHBwUoBQcwMAcFKAUHBwUoBQcAAAAAwAA/8AEAAPAABsANwB6AAABIgcOAQcGFRQXHgEXFjMyNz4BNzY1NCcuAScmAzIXHgEXFhUUBw4BBwYjIicuAScmNTQ3PgE3NgEGBw4BBwYjIicuAScmJyYnLgEnJjU0Nz4BNzY3FzgBMQYHBhQXFhceATMyNjc2NzY0JyYnNxYXHgEXFhUUBw4BBwYCAGpdXosoKCgoi15dampdXosoKCgoi15dajUvLkYUFBQURi4vNTUvLkYUFBQURi4vAWYeIyRNKiorKyoqTSQjHh8YFyAJCAgJIBcYH0MxGBkZGDEwe0NDezAxGBkZGDFDHxgXIAkICAkgFxgDwCgoi15dampdXosoKCgoi15dampdXosoKP8AFBRGLi81NS8uRhQUFBRGLi81NS8uRhQU/c8fGBcgCQgICSAXGB8eIyRNKiorKyoqTSQjHkMyPj2CPT4yLzMzLzI+PYI9PjJDHiMkTSoqKysqKk0kIwAAAAMAFf/VA+sDqwAcADgAeAAABSInLgEnJjU0Nz4BNzYzMhceARcWFRQHDgEHBiMRIgcOAQcGFRQXHgEXFjMyNz4BNzY1NCcuAScmEyImNTQ2Nz4BNTQmJy4BIyEXFhQHDgEjIiYvAS4BJzQmMTwBNTgBMTQ2PwE+ATMyFhcWFA8BITIWFx4BFRQGIwIAZVpZhScnJyeFWVplZVpZhScnJyeFWVplXVFSeSQjIyR5UlFdXVFSeSQjIyR5UlFjCQwLCAchCQgKIBb+n1sGBgMIBAQIA4ABAwEBAwOAAwgEBAgDBgZcAWIgMRANDi4jKycnhVlaZWZZWYYmJycmhllZZmVaWYUnJwOrIyN6UlFdXVFSeSQjIyR5UlFdXVFSeiMj/VUNCQgMAQZILxQgCw0MWwYSBgMEBAN/AgQCAQIBAgIECAOAAwMDAwYSBlwVFRAuGzJ2AAAHAAD/yQPVA8AAMwA8AF8A0AEAASUBNQAAASYnLgEnJicwIjE4ATEuASMhIgYVERQWMzI2NRE0NjMhOgEzFRQWOwERFBYzMjY1ETwBNSc1HgEXIyImNQEiJicuASc3HgEXHgEzMjY3PgE9ATMVFAYHDgEHDgEHDgEjMyImJy4BJzceARceATMyNjc+ATU0JicuASMiJicuASMnLgEjLgEnLgEnLgE1NDY3PgE3PgE3PgEzMhYXHgEXBy4BJy4BIyIGBw4BFRQWFx4BMzIWFx4BHwEeARceARceARceARUUBgcUBgcOAQcOASMhIiYnLgEnLgEnLgE1NDY3PgE3PgE3PgEzMhYXHgEXHgEXHgEVFAYHDgEHDgEHDgEnMjY3PgE3PgE1NDY1NCYnLgEjIgYHDgEVFBYXHgEXHgEXHgEzJTMRIycUFRwBFRQxIxEzFwNVBhQUPScnLQQKFwr+ABomDAkKDAsKAgAGCQYnGZYLCgoL1TpYEI0JDP3mEBYNCRMGIgMMBwYNBgoOBgYDMwEEAwYDBw0GBhsK6w0eDA0ZCR4GEgoJEwoNEwYHAgEDAwMDAwYEAwcHJgYJBgcHAwQGAwMCBgMDDAYHDgkHEgkNFQ0NEwcaBg4KCQsKCRIHAwUBAwMCAwQGAwMLAycGDAMGCAMDBwMDAQUDCwYHDgkKFwoBAA0ZDQ0TBwYQAwMGBgMDDQkKEwoNFhANGQ0NEwcJDQMDBgYDAw0JChMKCRoQCg4GBgwDAwoECwoKGRAQGgkKDAEEAwYDBAsHEBAGAVUvM2suM28C0S0oKD4VFAcDASYa/VUJDAwJAqsKC5UaJv7rCgwMCgEZAwcDL40QVjwLCvzJBgYHEgkaBgwDAwYHBgYVELvACRIHCQ4HBgwDAwUFAwYOCiYGDAMDBgYDAw0KAwYDBAUFAwQFEQMGAwcHAwwGBg0HCQ4GBw0GBggDBwIGAwMQBh4GCAMDAQUEAw0JAwcDAwUGAwMCBBEDBgMEBwYECwcGDQYKDwoDCwcGCAMDBQUDBg4KChgNDR8QEB8MDRkJCg4GBwIGAwMRCgkWEAwfEBAfDQ0YCgoOBgMFKgYDAwwGBhMJChQNFiYMDQ0NDQwmFg0UCgkPCgYMAwMG8/7rxAQgH0cdHQEV0QAAAAAKAAD/wAQAA7cAfACIAJEAmgCmALQAwADdAPkBEwAABSYnLgEnJicuATUuATc1PgE3NDY1Njc+ATc2NzE6ATM6ATMWFx4BFxYXFAYHDgErASImNS4BJyMeARcUBgcjIiY1LgEnIQ4BFTMyFhUUBisBHgEXMzIWFRQGKwEeARcVMBQdATAUFTEwFB0BMBQVFCYHMSMwIiMyIiMyIjEBFhceARcWFy4BJyM3LgEnIxQWFzMDNDY3Iw4BBzMBJicuAScmJx4BFzMjLgEnKgEjKgEjDgEHISE+ATcGBw4BBwYHMwEiJy4BJyY1NDc+ATc2MzIXHgEXFhUUBw4BBwYjESIHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJgMGJi8BJjQ3NjIfATc2MhcWFAcwBw4BBwYHAeJBPj5sLC0gAwEgHwMDLCYFISsqYzY3OgkPCgYNBlpQUH4rKxABAwMHAwQHDgQjGcAJEgcICQUGDwYTCf7EExieCgwMCp4EFBMzCgwMCiIXQyYBAwQCBwcEAwMD/pUcIyNTLi0wIzgT0sATFAPiGRrZKhcTwCAlA94CXhofIEcnJyggLxO04hc5JAYJBgYJBiQ5FwES/sATMh0oJidGIB8ctAGiOjIzSxYWFhZLMzI6OTMyTBUWFhVMMjM5MCsrQBITExJAKyswMCorQBMSEhNAKypXBhEHVQYGBhIGTaYHEQYGBhkZQR8fC0ADFBNDLy85AwMDOYRDCEeAOQQCAzAnJjgREAMEIiJwS0tYAwsDAwYLBzZbJh0/IAkNAwoHI0EgM2w2DAoJDDNsNgwKCQw2cTcEAQMFAQMBAwQCAwMCAwEAKiIjNhISCDNoNis2bDM2bzABADZsMzBsOQEAIBsbKQ4OBydPLDBUJilVLClSJwcODikbGyD81RYVTDIzOToyM0sWFhYWSzMyOjkzMkwVFgIAExJAKyswMCorQBMSEhNAKyowMCsrQBIT/p4DAQZVBxEGBwdIpgcHBhEHGRlAHh4JAAAAAAUADf/NA/8DwAAZACcAMwDCAN0AACUDLgErASIGByIGBwMGFBceATMhMjY3PgE1ATQ2MzIWHQEUBiMiJjUXIiY1NDYzMhYVFAYFIy4BJzEmJy4BJyY3NTQ2NTY3PgE3NjMyFhcWFx4BFxYXFhceAQcGBw4BBxQGIyoBIy4BNz4BNzY3NiYnJicuAScjIgYHDgEVFBYXMzIWHwEyFhUUBgcOASMiJi8BLgErASImNTQ2Nz4BOwEuAScuASMiBw4BBwYHMzIWHwEeAQ8BDgEdAR4BFx4BFQ4BIwEGFx4BFxYXNTQ2PwE2Ji8BLgEjNCcuASMiMQPV2QMHAwQEAgMDAgPaAwMDCAYBrwYIAwMB/wAMCgkMDAkKDBYNFRIQDBYW/p4EECAQVkRDVxAQEAQSLi6EUVJaHTgaMi4uUSMjGxsSExEBAQsGDgoKBwMCAwoGAwoMBAkBAQ8QEBgNGxDvEBkKCQwsHBEnQhMEBwIFBAMGAwcHAwUQMBkRMEQTEBAqF8AqZDcZMxpSS0p6KysS6x03Fy8pBSo8DQwMFg0JCAQLB/6aCw8OSTg4RhMTPB0EHS8QJhcmJlsmJgABmgMFAQMFBP5nAwsDBAUFBAYJBgEeCQwMCYAKCxAJgBIQEBISEBASVQMMBiA7OpdYWFwEBgkGV0hJah0eBgcLFRQ6JCUrKy8vYjMzMxcrFAYGAxEKEycXLi4uWisrKBMhEAwJCh0NICkDJSAICgMDBwMDAQUECBYZQzAXKhAQEiQtDQoHGxthQkNOGBMvKnYtRBAiF3cDBwMDDQkHBgIzTUtLgjQzH2cdMhNAIFQdLxAOAQEBAQAAAAAOAAAAKwQAA1UANgBuAH4AjgCeAKIApgCqALYAwgDOANoA5gDyAAA3IiY1ETQ2MzIWHQEzETQ2OwEyFhURMxE0NjsBMhYVETMRNDY7ATIWFREzNTQ2MzIWFREUBiMhJxQWMyEyNjURIxUUBgcOASMiJiMuATc1IxUUBgcOASMiJiMuATc1IxUUBgcOASMiJiMuATc1IxElFBYXOgEzMjY3PgE1ESMVIQYWFzoBMzI2Nz4BNREjFSEGFhc6ATMyNjc+ATURIxUBNSMVIzUjFSM1IxUXFAYjIiY1NDYzMhYXFAYjIiY1NDYzMhYlFAYjIiY1NDYzMhYFFAYjIiY1NDYzMhYHFAYjIiY1NDYzMhYFFAYjIiY1NDYzMhbAT3ENCAkNKhkSqxEZKxkSqhIZKxkRqxIZKg0JCQxxT/2AlVc+AoA+VyoUEhIvGQQGBDJBASsTEhMuGgMHAzJCASsTEhIvGgMHAzJCASoCqiwiAQQDER8MDA2r/tYBLCICBAIRHwwMDar+1QEtIQIEAhEgDAwNqwMAq4CqgKtgEw0NExMNDRMrEw0OEhIODRMBABMNDhISDg0TAVUTDQ0TEw0NEysSDg0TEw0OEv8AEg4NExMNDhIrcFABqgkNDQlqAQARGRkR/wABABEZGRH/AAEAERkZEf8AagkNDQn+VlBwwD5YWD4BFasZLxISFAEHTTKkqxkvEhIUAQdNMqSrGS8SEhQBB00ypP7rcCI0BQ0MDB8RAQD6IjQFDQwMHxEBAPoiNAUNDAwfEQEA+gElq6urq6uraw0TEw0OEhK4DhISDg0TE50NExMNDhISIw0TEw0NExN4DRMTDQ4SEg4NExMNDhISAAAAAAQAdf/rA4cDlQAtAIEAmgCoAAABIiYnLgEvAS4BNTQ2MzoBMzI2NyU+ATc+ATMyFhceARcWBgcFDgEHDgEHDgEjNT4BNycmNjc+ATMyFh8BNycmNDc+ATc2MjMyFh8BNycmNDc+ATc+ATMyFh8BNycuATc+ATcyNjMyFh8BNz4BJy4BJy4BIyIGBw4BBwUOASMqASMXAyImNTQ2Nz4BNzoBMzIWFx4BFx4BFRQGIzUOARUUFjMyNjU0JicxAR8ECAQHDQNuAgIZEgIDAhkwFwGgBw4HCBEIFSkSGSIHCzMx/mQYKhEDCAQECQQOIhMsBAYIAgUCBgsDK04aAgECBgQCBAIHCgMaTiwCAgEGBAIEAwYKAyxOGwEBAgEGBAIFAgYLAhs2JCQIBBkSDR0PBQwGBgoF/mAaOh0CAwJuPyw/JSQFDwkBAwEHDQYCBAElJD4sJBwlGxomHSMBbwECAwsI9QQJBREZCgq7AwUBAgILDBAwHTVhFbkLIBQEBgIBAioRHgtkCBAEAQEHBmEjOgQJBAQGAgEGBjsjYgQIBAQGAgEBBwZhIzoECQQEBgIBBgY7GBBGJhQjCwgIAQEBBAK7DAz1/lI+LBdHLwcJAQUEAgMCMEcXLD7dLjoLGiYmGgs6LgAIAAD/wAQAA8AAVgBkAHIAgQCPAJ0ArAC6AAAFIiY1NDY3NTQmJw4BIyImJyMiJy4BJyYnLgE1NDY3Njc+ATc2OwE+ATMyFh0BFAYjIiYnIyIGBx4BFRQGBx4BOwE+ATMyFhcWFx4BFxYdAR4BFRQGKwE1IgYVFBY7ATI2NTQmIyc1NCcuAScmJxUeAR0BAyIGHQEUFjMyNj0BNCYjJRYXHgEXFjsBNSMiJicnIgYVFBY7ATI2NTQmIwEiBh0BFBYzMjY9ATQmIwE+ATsBNSMiBw4BBwYHAusbJRcTGxcIHhIVIQeuQDo7Wx4dCBQZHhcPHyBYNjU6rgchFRomJhoVIQeuDBgKDA0fFgsoF64HIRUVIgY/NzdSFxcTGCYa1QkNDQnVCQwMCRUUE0UvLjcmL5UJDQ0JCA0NCP3tCBsaTzIyOKurKUIOxwkMDAnrCA0NCAFACQ0NCQgNDQj+thIyG6urMi0uSxwcDkAmGhQiBlcZKwsPExgTFxdSNzc/BiIVGCMEOC8vRRMTExgmGtUbJRcTBwYJGw8XJAQUFxMXGRQIHh9bOzpAVwYhFRomVQwJCQwMCQkMK1M4MjJQGhsIrw5DKVMBqw0J1QkMDAnVCQ0qNy4vRRMUqy8mVg0JCA0NCAkNASoMCdUJDQ0J1QkM/wAVFqsQEDgnJzAABAAC/8AEAgPAABwAOQBYAIQAAAUiJy4BJyY1NDc+ATc2MzIXHgEXFhUUBw4BBwYjESIHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJiMDKgEjLgE3ESY2Nz4BNzI2MzIWFwUeARUUBgcFDgEjESIGMRQGFTIUFREwFAcUFjEUMjM4ATE6ATEyNjclMCcuAScmMSImIzQiIzECAmpdXosoKCgoi15dampdXYsoKSkoi11damFWVYAlJSUlgFVWYWFVVn8lJSUlf1ZVYX4BBAISFgIBBAUGDwkCBAEHDQUBMxIJCRL+zQUNBwEBAQEBAQEBAQEBAQEBNDAwdDAwAQEBAQFAKCmLXV1qal1diykoKCmLXV1qal1diykoA9UlJX9VVmFhVVZ/JSUlJX9WVWFhVlV/JSX9TwMeEgEoCBEHBwkCAQQEmQkXBgcWCZoDBAFjAQEBAQIB/tUCAQEBAQEBmhgYORkYAQEABwAA/8AD1QPAAEUAXQBqAH4AkwChAK8AADciJjURNDY7AT4BOwE4ATE0NjMyFhU4ATEzMhYXMzIWHQEUBiMiJj0BNCYrARUUBiMhIiY9ASMiBhURFBYzITIWFRQGIyETIgYdARQWMyEyNj0BNCYrAQ4BIyImJyM3IgYVFBYzMjY1NCYjEyImNRE0NjMhMhYfAR4BFREUBiMBIgYVERQWMyEyNjURNCYvAS4BIyEXIiY1NDY7ATIWFRQGIwciJjU0NjsBMhYVFAYjQBomJhpEBiIUVTIkIzJVFSEHQxslDAkJDA0JQCUb/qsaJkAJDAwJAVUJDQ0J/quACQwMCQFVCQ0NCWELKBYXKAthqxIZGRIRGRkRqhomJhoBLw0XCVIJCSUb/oAIDQ0IAYAJDQQDUQMIBP7RVgkNDQnVCQwMCdUJDQ0J1QkMDAkVJhoCqxomExgjMjIjGBMmGpUJDQ0JlQkMFRomJhoVDAn9VQgNDQgJDQMrDQgrCQwMCSsIDRQXFxRVGRESGRkSERn8KyYaAesaJgoJUgkXDf5nGiYCQA0I/hUJDAwJAZkECANSAwPADQgJDQ0JCA2ADQgJDQ0JCA0AAAAHAAD/wAP8A8AAMAA0AE4AXAB3AKEArQAANyImNRE0NjMyFhURMxE0NjsBMhYVETMRNDY7ATIWHQEUBiMiJj0BIxEzMhYVFAYjITcRIxEDIiYjJzQmNTQ2NTQ2MzIWMxcUFhUUBhUUBjciJj0BNDYzMhYdARQGFyImIyImNTQ2NTcyNjMyFjMyFhUUBhUHIgYjASImIycOASMiJy4BJyY1NDc+ATc2MzIXHgEXFhUUBgcXHgEVFAYVFCYjASIGFRQWMzI2NTQmFQkMDAkKDFUXFFUTGCoYE1UUFwwJCgxVIgoLCwr+c+tVKwMLAysEBA4DBAoDKwQEDlIJDAwJCgwMTAQKAwQBBSoDCwMECgMEAQUqAwsDAsAECgN8HUUnLCcnOhARERE7JicrLCYnOhIRGRZ7BAEFCQP+6kZkZEZHZGFrCwoC1QoMDAr9QAIrExgYE/3VAVYTFxcTVgkMDAlW/qoLCgoLKgIr/dUClgQrAwoEAwsDAwEEKwMLAwMLAwMBKgwKQAkMDAlACgwqBA4DAwsDKwQEDgMECgMrBPyVBHwWGREROyYnKywmJzoSERESOicmLCZFHXwDCAYGCAMDAwHVZEZHZGRHRmQABf/8/8ADhAO8AAsAEABaAGYAcgAAASImNTQ2MzIWFRQGAzMHIycTLgEvAS4BNSYnLgEnJgcGBw4BBwYVFAYjOAExLgEnLgEHDgEVFhceARcWFx4BBzAGIw4BBw4BFx4BMyEyNz4BNzY3NDY/AT4BJwUiJjU+ATceARcUBjciJjU0NjMyFhUUBgNEEDAwEBAwMFCACHMFIgMGA2cGBwQWFUAqKS0oIyM0Dw8QCSpPHAodDQwNAQsLKBscIwcEBgEEDCw3DAEJDRQKAQBFPT5eHR4FBgZrBwQH/kkWIgobExMbCSF7ExgYExMYGAI8KxAQLCwQDC8BgNbW/bcDBwMrAwcHLSUlNA0NBQcUFDwmJisKEAMpHQkFBgYYDSkoKUggHxgHEQYECi0wDSIMBAUZGVg8PEcGBwQ7BBEJGRwXGTMWFjMZFxxRFxMUFxcUExcABP/8/8AD4gOiAEkAhgCfAK0AAAEuAS8BLgE1JicuAScmBwYHDgEHBhUUBiM4ATEuAScuAQcOARUWFx4BFxYXHgEHMAYjDgEHDgEXHgEzITI3PgE3Njc0Nj8BPgEnJxYUDwEwBjEwJjUnOAExBzAGMTAmNScmND8BOAExJyY0PwEwNjEwFhUXOAExNzA2MTAWFRcWFA8BOAExFxMnOAExJyYiBw4BBwYWHwEWMjc4ATE3Jzc3LgEHDgEPARcHFzc+AQMmAwYDZwYHBBYVQCopLSgjIzQPDxAJKk8cCh0NDA0BCwsoGxwjBwQGAQQMLDcMAQkNFAoBAEU9Pl4dHgUGBmsHBAfiAwMNBAQmIwQEDQMDIiIDAwQFBCIrBAQNAwMiJuJIDR1SGQcHBAwHF5EGFQcqUVG8E04jBwsDHjdNUWcWDAFzAwcDKwMHBy0lJTQNDQUHFBQ8JiYrChADKR0JBQYGGA0pKClIIB8YBxEGBAotMA0iDAQFGRlYPDxHBgcEOwQRCUQDBgMNBAEDIiIEAQMNAwYDIyIDBgQRBAEDIyMEAQMNAwcDIicBiUkMHR0GCQYdPBaVBwcqSVE3JBoTAwgGGjdNUWsTPgAAAAMAAP/ABAADwABkAHIAoQAAAScuASc1JicuAScmIyoBBzMGBw4BBwYVHAEVMTgBMRQGIzAiIzMuAScxLgEjIgYHNQ4BFRwBFTEWFx4BFxYfAR4BFRQGBzEOAQcOARUUFjMhMjc+ATc2NzU+ATc1Nz4BNTQmJzElIiY1NDYzMhYVMRQGIwEuASMiBgcxBw4BIyImJzEnLgEjIgYHFQ4BFRQWFzEXHgEzMjY3MTc+ATU0JicVAxxmBgYBBRITOiUlKgUMBQEqIyQ0Dw8OCwEBAS1MHAYQCQUKBAsNAgsMJxwbIQEEBgQDCy40BwcZEgEART49Xh0dBQEGBGoGBwkG/uQSGRkSEhkZEgH2DS4cFCMNDAMIBAQIAwwNIxQcLg0FBQ8NkwMJBQUJA5MNDwUFAX4sAwkFASgkIzQPDgEFFBM7JiYrAQEBCg4EJx8GBwIDAQYUDAEDASspKEgeHxcBAwkGBAgDCyoxBhAJEhkZGlg7O0QBBgkCATkECwcIDAMtGRESGRkSERkB4BgdDw0MAgQEAgwNDx0XAQkWCxQjDZYDBAQDlg0jFAsWCgEACgAA/8AEAAPAAJQAnwCoALEAvADKANUA8gEOATsAAAUmJy4BJyYnLgE1LgE3NCY1NDY9AT4BNz4BNzY3PgE3NjcwMjMyNjMyFjMWFx4BFxYXFAYHDgEHKgEjIiYnLgEnIx4BFxYGByoBIyImJy4BJyEOAQczMhYVFAYrAR4BFzMyFhUUBisBHgEXFBYVMBYXHAEXMBQVHAEjHAEVFAYHFAYHMAYHIhQjDgEjMAYxBiIjKgExJRYXHgEXFhcuAScnLgEnIxQWFzMDPgE3Iw4BBzMBJicuAScmJx4BFyMuAScqASMqASMOAQchIT4BNwYHDgEHBgcBIicuAScmNTQ3PgE3NjMyFx4BFxYVFAcOAQcGIxEiBw4BBwYVFBceARcWMzI3PgE3NjU0Jy4BJyYTIiYvAQcOASMiJicmND8BJyY0Nz4BMzIWHwE3PgEzMhYXFhQPARcWFAcOASMB5EI9PmwsLSACAyAeAgEBBCwmAQMCIiorYzc3OgEBCBEIBw0HWVBQfiorEAEDAgcFAQEBCAwBCSIawQsRBQIKCQECAQcMAgUTDP7HFBYBnQkNDQmdAxYTMQkNDQkgGEEpAQEBAQEBAQEBAQEBAQEBAQICBAEBAf6THCMjUi4uMSM4FRASFQLkGhrZKgEVE78gJQbhAl0aIB9HJycpHzITLxY6JAUKBQUMBSQ7FgET/r8TMx8pJidHHyAaAlQ6MjNLFhYWFkszMjo5MzJLFhYWFksyMzkxKypAExISE0AqKzEwKys/ExISEz8rKyoECANLTAMIBAQIAwYGS0sGBgMIBAQIA0xLAwgEBAgDBwdLSwcHAwgEPwMUFEMvLzoBBQI8g0MBAgECAwEBRYM5AgQCMCcmOBARBAEBBSEicEtLWAQIBAMFAQoIL1coHj8fCQ8BCgciQiAzazcNCQkMNWs1DQkJDDhvNgECAQIBAQIBAgEBAQEBAQECAQEBAQIBAQEBAQH/KiMjNRIRCDNoNSs1azU4bDEBADZrNDBsOQEAIBobKQ8OCCZRLC5WJihWLCpSJwgODykbGiD81RYWSzIzOToyM0sWFhYWSzMyOjkzMksWFgIAExJAKisxMCsrPxMSEhM/KyswMSsqQBIT/qUEA0tLAwQEAwYSBktMBhIGAwMDA0xMAwMDAwYSBkxLBhIGAwQAAAUAJv/mA8QDiQAVAC8AMQA/AF4AAAUiJicBLgE1NDY3ATYyFwEWFAcBDgEDIgYHATgBMRQGFRQWFQEWMjcBNjQnATQmIwExBSImNRE0NjMyFhURFAYHOAExOAExKgEjMCIjIgYVDgEVFBYzMjY3PgE1NiYjAgANGAr+ZgkICwYBmhMzFAGZExP+ZwcXDQMLA/5mBAQBmgYRBwGZBwf+ZwoD/kkBtwoLCwoKCwsKAwIEAQMDCgMFEhAGDAMEBQMUDRoICQGaChgNDRgKAZoTE/5mEzMU/mcKDAOJAQP+ZgMLAwMLA/5mBgYBmgYRBwGZBAX+b4kMCgEqCgwMCv7WCgwqBgMDDAYNEQUDBAsHCRUAAgAA/8AEAAPAACkARgAABSImJwEOASMiJy4BJyY1NDc+ATc2MzIXHgEXFhUUBgcBHgEVFAYHDgEjASIHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJiMD6wUHA/5/MnxCS0JCYxwdHRxjQkJLS0JCYh0cLywBgAMDAwMDCAT9gEI7OlcZGRkZVzo7QkI6OlcZGhoZVzo6QkADAwGALC8cHWJCQktLQkJjHB0dHGNCQktCfDL+fwMHBQQIAwMDA9UZGVc6O0JCOjpXGRoaGVc6OkJCOzpXGRkABAAA/8AEAAPAAAsAUgBvAIwAAAE1MxUzFSMVIzUjNQUiJicuASc3HgEzMjY3PgE/ASM1NzM3PgE3PgEzMhYXHgEXBy4BJy4BIyIGBw4BBw4BBw4BFQczFSMHDgEHDgEHDgEHDgEjEzIXHgEXFhUUBw4BBwYjIicuAScmNTQ3PgE3NjM1IgcOAQcGFRQXHgEXFjMyNz4BNzY1NCcuAScmIwLVK1VVK1X+4gkPCgoIAwwKEwoTGgYGDAMRQDQVBAMUEAwtIAoPCQoNAw0DCwMGCgkKDgYHCwQDBgMEBQRiZxUDBgQDDAYGFAwNGxCeYlVWfyUkJCV/VlViYlVWfyUkJCV/VlVial1diykoKCmLXV1qal1diykoKCmLXV1qAZVWVipWVir3AQMDAgQvBAUOEBAtHaYvBCsmOhMWFQEEAwIDLwMCAwQBBgMDDAYHEQYGGwovL7cTIA0QFg0KEgYHBgL3JCV/VlViYlVWfyUkJCV/VlViYlVWfyUkKygpi11dampdXYspKCgpi11dampdXYspKAADAAD/wAQAA8AAGwA4AFoAAAEiBw4BBwYVFBceARcWMzI3PgE3NjU0Jy4BJyYDIicuAScmNTQ3PgE3NjMyFx4BFxYVFAcOAQcGIy8BEycuAScuASMiBgciBgcnPgE3PgEzMhYXHgEXEyMDIwMCAGpdXYspKCgpi11dampdXYspKCgpi11dalhOTXQiIiIidE1OWFhOTXQiIiIidE1OWFF4owUDDQkKFA0KDQcGDQYWChMKCRsTE0UTEyANiHdJBGIDwCgpi11dampdXYspKCgpi11dampdXYspKPxVIiJ0TU5YWE5NdCIiIiJ0TU5YWE5NdCIiogkBgAkQFAYHCgEDBQReBAYDAwETExM/Kv58AQD+9wAGAAAAAAQAA4AAEAAbACUAMQA9AEkAADciJjURNDYzITIWFREUBiMhJxQWMyEyNjURIREBNTQmIyEiBh0BNxQGIyImNTQ2MzIWFxQGIyImNTQ2MzIWFxQGIyImNTQ2MzIWayw/PywDKiw/Pyz81kAlGwMqGyX8VgOqJRv81hsloBMNDhISDg0TgBMNDhISDg0TgBMNDhISDg0TAD4sAqssPz8s/VUsPmoaJiYaAhb96gJAaxslJRtrVg0TEw0NExMNDRMTDQ0TEw0NExMNDRMTAAAAAAMAngDJA2ICtwANABsAKQAAEyEyNjU0JiMhIgYVFBYBISIGFRQWMyEyNjU0JiUhMjY1NCYjISIGFRQWwAKADRUSEP2ADRUVAo39gA0VEhACgA0VFf1zAoANFRIQ/YANFRUCcxIQEBIVDQwW/poSEBASEhAQEpESEBASEhAQEgAAAwAJAMkD9wK3ACoAOQBHAAABITc+ATU0JicmIg8BDgEjBhQXFBYzFx4BMzI2Nz4BNTQmLwEhMjY1NCYjJSEyNjU0JiMhIgYVFBYzASEiBhUUFjMhMjY1NCYD1fyidAYCAgYKHAmrAwIDBAQFA6sDDAYGDAMEBQUEcwNiDRUVDf2AAoANFRUN/YAMFhYMAoD9gAwWEhACgA0VFQHicwQLBwYMAwoKqwMFBwwHAwWrAwYGAwMMBgcLBHMSEA0VkRIQEBIVDQwW/poSEBASEhAQEgAAAAABAAb/wAP6A8AAKwAABSImJwkBDgEjIiYnJjQ3CQEmNDc+ATMyFhcJAT4BMzIWFxYUBwkBFhQHDgED6wUHA/4k/iQDBwUECAMGBgHc/iQGBgMIBAUHAwHcAdwDBwUECAMGBv4kAdwGBgMIQAMDAdz+JAMDAwMHEQYB3AHcBhIGAwMDA/4kAdwDAwMDBhIG/iT+JAYRBwMDAAIBKwBjAtUDHQAFAAsAAAEXNxcHJyUnByc3FwFdo6My1dUBeKOjMtXVAWukpDLW1tykpDLW1gAAAQErATkC1QJAAAUAAAEXNxcHJwFdo6My1dUCQKOjMtXVAAAAAQF8AOcChAKSAAUAAAEHFwcnNwKEpKQy1tYCYKSjMtXWAAAACAAG/8YD9wPAAAsAFwBaAJ0BDgF/AYwBmAAAATI2NTQmIyIGFRQWNyImNTQ2MzIWFRQGNx4BPwE2FhcWBg8BBhQfAR4BBw4BLwEiBg8BDgEjIiYvAS4BDwEGJicmNj8BNjQvAS4BNz4BHwEWNj8BPgEzMhYfAScuASMiBg8BDgEvASYGBwYWHwEWFA8BDgEXHgE/ATYWHwEeATMyNj8BPgEfARY2NzYmLwEmND8BPgEnLgEPAQYmLwEBHgEzMjY/AT4BFx4BDwEUFhceAT8BNhYXFgYPAQ4BFRQWHwEeAQcOAS8BIgYHDgEVFxYGBwYmLwEuASMiBg8BDgEnLgE/ATQmJy4BIwcGJicmNj8BPgE1NCYvAS4BNz4BHwEWNjc+ATUnJjY3NhYfAScuAQcOAR8BFAYHDgEvASYGBwYWHwEeARUUBg8BDgEXHgEzNzIWFx4BDwEUFhcWNj8BPgEzMhYfAR4BNz4BLwEmNjc+ATMXMjY3NiYvAS4BNTQ2PwE+AScuAQ8BBiYnLgE/ATYmJyYGDwEOASMiJi8BEzI2NTQmIyIGFRQWMzUiJjU0NjMyFhUUBgMtIjExIiIxMSIRFxcRERcXOgEHBC4VJgoLBQ4hAgIhDgULCiYVLgQHAQ4GIhUVIgYOAQcDLxUmCgsFDiEDAyEOBQsKJhUvAwcBDgYiFRUiBg43AgsHBwsCDgYkFC4HDQMEAgUgDg4gBQIEAw0GLxQkBg4CCwcHCwIOBiQULwYNAwQCBCEODiEEAgQDDQYvFCQGDv37BQ0HCA0FGxAwFhcaAQIFBQUOBygYKgkJChMdBgYGBh0TCgkJKhgoBw4FBQUCARoXFjAQGwUNBwgNBRsQMBcWGwICBQUFDgcoGSkJCQoSHgYFBQYeEgsKCSoYKAcOBQUFAgEaFhcvERs7BxUKCgwBAgsMCx8QKAsTBAQFCB4MDQ0MHggFBAUSCygQHgwLDAECCwsKFQcbCx4REB4LGggVCgoMAQIBDAwLHxAoCxIFBAUIHgwNDQweCAUEBRILKBAfCwwMAQIBDAoKFQgaCx4REB4LG1RHZGRHRmRkRjVLSzU1S0sCgzAiIzAwIyIwKhgQERcXERAYuAQEAQsFERISKg8kAwgDIw8qEhIRBQsEAy4UGRkULQQEAQsEERISKg8jAwgDIw8qEhIRBAsBBAQuFBkZFC4iBggIBi8UFAQLAgYGBg4FIw8qDyMFDgYGBQELBRUULgcICAcuFBUFCwEFBgYOBSMPKg8kBQ4GBgUBCwUVFC7+rQYGBgYdEgsJCikYKAgNBQUGAQIBGhcWMBAbBQ0IBw0FGxAwFxYaAQIFBQUOBygYKgkKCxIeBgUGBR4SCwoJKhgoBw4FBQUCARoWFy8RGwUNBwcOBRoRMBYXGgECAQUGBQ0IKBgpCgkLEh0BCAQEBBILKBEeDAsMAQIBDAoKFgcbCx0REB4LGwcVCgoMAwsMDB4QKAsTBAQFCB4MDQ0MHggFBAQTCygQHgwMCwMMCgoVBxsLHhARHgobCBUKCgwBAgEMDAsfECgLEgQFBQgeDA4ODB7+NmRGR2RkR0ZkKks1NUtLNTVLAAAAAAQAXf/1A6sDmgADAAYAIgBGAAAJASEBFQMhNyIHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJhcHDgEHKgEjIiYvASY0Nz4BHwEeATMyNj8BPgEXHgEXFgYHMQGAASP9ugEj3QG6QzcxMEkVFRUVSTAxNzcxMEkVFRUVSTAxUHcIGA4BAgENFwg+CAkJGgo0AgQDAgQCbQUQCQkOAwQDBgOa/bsCRV/+RYsVFUkwMTc3MTBJFRUVFUkwMTc3MTBJFRXXngsNAQoIPgkaCQkBCTUBAgMBlQcIAQELCAgSBwAABQBdABsDugOaABsAJwA2ADoAPQAAJTI3PgE3NjU0Jy4BJyYjIgcOAQcGFRQXHgEXFjciJjU0NjMyFhUUBjcXFjI3NjQvASYiBwYUFwkBIQEVAyECgDEqK0ASExMSQCsqMTEqK0ASExMSQCsqMVBwcFBQcHBEiAYSBgYGiAYSBgYG/mwBI/26ASPdAbpqExJAKyswMSsqQBITExJAKisxMCsrQBITK3FPUHBwUE9xDogGBgcRB4cGBgYSBgL3/bsCRV/+RQAAAAAdAAD/+QQAA5QAEwAhAC8ARABSAGAAbgB8AIsAoACuAL0AywDgAO4A/AERAR8BLQE8AUsBWgFpAXcBhQGTAakBuAHGAAABFAYjIiY9ATQmJy4BNz4BFx4BFRUUBiMiJj0BNDYzMhYVERQGIyImPQE0NjMyFhUDDgEnLgE3PAE9ATQ2MzIWHQEUBgcHBiYnJjY/ATYWFxYGBwcGJicmNj8BNhYXFgYHBwYmJyY2PwE2FhcWBgclLgE3PgEfAR4BBw4BJycuATc+AR8BHgEHDgEvAScuATc+ARceATMXHgEHDgEvAS4BJyc0NjMyFh0BFAYjIiY1ETQ2MzIWHQEUBiMiJj0BNTQ2MzIWHQEUBiMiJjU3NhYXFgYPAQ4BBw4BJy4BNz4BPwE3NhYXFgYPAQYmJyY2Nzc2FhcWBg8BBiYnJjY3JR4BBw4BLwEwIjEuATc+ARc6AR8BFx4BBw4BLwEuATc+ARcXHgEHDgEvAS4BNz4BFwUVFBYzMjY9ATQmIyIGFR0BFBYzMjY9ATQmIyIGFR0BFBYzMjY9ATQmIyIGFR0BFBYzMjY9ATQmIyIGFQEHDgEXHgE/AT4BJy4BDwEOARceAT8BPgEnLgEPAQ4BFx4BPwE+AScuAQ8BFzcnJgYHBhYfARYyPwE+AScuAQcvASYGBwYWHwEWNjc2JicvASYGBwYWHwEWNjc2JgQADAkJDQkHCAkCAhAIFRsMCQkNDQkJDAwJCQ0NCQkMAgIPCQkJAw0JCQwBAacIEAMCCAhRCBADAwgJ8gkQAgMICFEIEAMDCAjzCRACAwgIUQgQAwMICP7+CAcDAxAIUAgIAwMQCPEICAMDEAlQCAgEAxAIUKQHBQUEEQgBAgFICQcDAxAISQMFAx8MCQkNDQkJDAwJCQ0NCQkMDAkJDQ0JCQxkCQ8DAgkJNgQGAgQRCAcFBAYSDTemCBACAgkJUgkPAgIJCPgIEAICCQhTCQ8CAgkIAQQICQICEAhQAQkKAQIPCAIBAlClCAkCAg8JUwgJAgIQCPgICQICDwlSCQkCAw8I/n4NCQkMDAkJDQ0JCQwMCQkNDQkJDAwJCQ0NCQkMDAkJDQIFUwkJAwIPCFMJCQICEK5TCAkCAg8JUwgJAgIPrlMJCQIDDwhTCQkCAw+uBAYFTgkPAwIJCE8DBQMDCQkCAg8JmlIJDwIDCQlSCQ8CAwkJpFMIEAICCQhSCQ8DAgkCwAkMDAkhBwwCAg8JCAkCBSMWzAgNDQhWCQwMCf8ACQ0NCVUJDAwJ/vsJCQMCDwgCAgJKCQ0NCUoECARWAwgICBADGwMICQgQAlEDCAgIEAMbAwgICRACUQMICAgQAxsDCAgJEAIIAxAICQcDHQMQCAkHA1cDEAkIBwMdAxAICAgDHT0FEQcIBAQBARoEEAgICAMbAQICuQkMDAlWCA0NCAEACQ0NCVUJDAwJVasJDAwJVQkNDQnhAgkICQ8DDgEFBAcFBAQRCAsPBA8rAgkJCA8DFQIJCAkPAkADCQkIEAIVAwkJCQ8CEgMPCAkJAhUCDgkJCgIBFCsCEAgJCQMVAg8JCQgCQAIPCQkIAhUCEAgJCQO9VQkMDAlVCQ0NCapWCA0NCFYJDAwJq1UJDQ0JVQkMDAmrVQkMDAlVCQ0NCQKSFQIPCAkJAhUCDwkICSsVAg8JCAkCFAMPCAkJLBQCEAgJCQIVAg8JCAosARUVFQMJCQgPAxUBAQECDwgJCQIrFgMJCQgPAxYDCQkIEAItFgMJCQgQAhYDCQkIEAAAAAEAqv/AA1YDwAA0AAAFAT4BNTQmJzEBLgEjIgYHMQcOARUUFhcxAR4BFRQGBzEBDgEVMRwBFRQWFzEXHgEzMjY3MQEzAhUGCAgG/ewGDggKEQZCBQYJBgGUAgICAv5tBwgFBUIGEQoIDgY1AdQGEQoKEQYB1AUGCAdPBg4IChEG/qMBBQICBQH+owUPCQECAQgOBk8HCAYFAAAAAAEABwCbA/wC5QAfAAAlIiYnASY2Nz4BMzIWFwkBPgEzMhYXHgEHAQ4BBw4BIwICCREG/iUGAQcDBwQFCAMB2wHaAwkEBAgDBgEG/iYBAgEGDwebCAYCGQYSBgIDBAP96AIYBAMCAwYSBv3nAQEBBQYAAAAAAQAHAJsD/ALlACIAADciJicuATcBNDY3PgEzMhYXARYGBw4BIzgBMSImJwkBDgEjFwQHAwcBBgHbAgEGDwcKEAYB2wYBBwMHBAQJA/4m/iUDCQSbAwIGEgYCGQEBAQYFBwf95wYSBgIDBAMCGP3oAwQAAAAHAFUARAOrA2YADQAbACoAOQBLAGAAggAAJSMiBhUUFjsBMjY1NCYDNTQmIyIGHQEUFjMyNgUjIgYVFBY7ATI2NTQmIyEjIgYVFBY7ATI2NTQmIyUuAQcOARcwFjEXFjI3NjQvAQU2NCcmIgc4ATEHBhQXFjI3OAExNwUiBhUcARUGFhceAR0BFBY7ATI2PQE0NjU+ASc0JiMUBiMCN24QGxcUbhAbGxwYExMYGBMTGP6mURAbGBNREBsbEAKvURAbGBNREBsYE/1eDSINDQEKBEQNIg0NDUQCfAwMDSINRA0NDCMMRf6mTXMDJioDARAKpg0NBCYqA2tNAQOaGBMQGxgTEBsCUVEQGhcTURAbF/UXFBMXFxMUFxcUExcXExQX/A0BCgkmDQREDQ0NIQlJPA0iDQ0NRA0iDQ0NRCZrTQMCAzBWHAQGAxENDRAKFQMHAxlZME1zAwEAAAAKABX/1QPrA8AAJAAoADAARQBTAGIAdACDAJQAtQAAAQYHDgEHBgcUFx4BFxYXFRQWMzI2PQE2Nz4BNzY1JicuAScmJxMjNTMHIiY1MxQGIzcjLgE1Njc+ATc2NxYXHgEXFhUUBgMyNj0BNCYjIgYdARQWASMiBhUUFjsBMjY1NCYjNx4BMzI2NzY0LwEmIgcOAR8BBSMiBhUUFjsBMjY1NCYjJzI2PwE2NCcmIg8BBhQXFBYHMjY1NCYrASIGFRQWOwEVIyIGFRQWOwEyNjU0JisBNTMCAD42NlAYFwIKCyYcGyQ1YGA1JBscJgsKAhcYUDY2PmvW1mtQG9YbUGbMR1MCFBRFLi41NS4vRhQUU60KCwsKCgsL/pdiCgwMCmIJDAwJTQMHBwYIAwMDVgYRBgcBA1YC+2IJDAwJYgoMDArABAoDVgYGBxEGVQcHCdIKCwsKgAoLCworKwoLCwqACgsLCisrAwACFxhQNTY/KCYnRBwcE5EdTk4dkRMcHEQnJig/NjVQGBcC/WtVwDMNDTPrHIJMNS4uRRQVAQEVFEUuLjVMggI5DAlWCQwMCVYJDP7VCwoKCwsKCgvFBAEBBAYVB1UGBgYWBlXFCwoKCwsKCgvAAQRVBhEHBgZWBhEGBAGqCwoKCwsKCgurDAkKDAwKCQyrAAADADsAGQPCA0sARABgAH0AACUjLgE1PAE1MRMwNDU0NjMyFhcxGwE+ATMyFhUUBhUxExwBFRQGBzEqASMiJic1CwEOASM4ATkBOAExIiYnNQsBDgEjMSsBLgE1PAE1MRM+ATMyFhUcATkBAw4BIzgBOQErAS4BNTwBNTETPgEzOgEzMR4BFRwBFTEDDgEjMQEjAwcLagwJCAwCxsUBDAgJDQFqCggBAQEIDAFivAILBgcKA7tgAQwIaQMIC2oBDAgJDWoBDAhqAwgKagELCAECAQcLagEMCBsBDAgBAQEDAAIBCQwKCP5DAbsICw0JAQEB/QABAQEIDAELBwECtf5cBgcHBQEBpP1MCAoBDAgBAQEDAAgKDAkBAv0ACAoBDAgBAQEDAAgKAQwIAQEB/QAICgAAAAQACf/ABAEDxQAfAD8AkQC8AAATMCIxIgYHMQMwFBUUFhcxMzgBMTI2NzUTMDQ1NCYnIyMwIiMiBgcxAzAUMRQWFzEzOAExMjY3MRM8ATU0JicxASIGBzcDPAExNCYjIgYVMQcnLgEjIgYVMBQVMQMwFBUUFjMyNjc1ExcUFjMyNjUxNxcGBw4BBwYVFBceARcWMzI3PgE3NjU0Jy4BJyYjMCI5ARMjFQ4BIyImJzE1Iy4BNTQ2NzEzNSI0NTQ2MzIWFRwBFTUVMx4BFRQGBzGgAQkMASsLCAIJDAEqCwcBVQEBCAwBKwsIAggMASsLCAI1MFgoAh8MCQkMQEEBDAkJDCsNCQgMASA3DQkJDDcVJx8gLAwMHh5oRkZQT0ZGaB8eHh9oRkZPAdW6ARAKCg8BuwoODgq7ARALCxC6Cg4OCgPACwj+gAEBCAwBCwcBAYABAQgMAQsI/oACCQwBCwgBgAEBAQgMAf8AFxUBARgBAQkNDAjOzggMDQkBAf6AAQEJDQsIAQEbrwkMDAmvxRsiIlIuLjJQRUZpHh4eHmlGRVBQRUZpHh7+X7sKDg4KuwEPCgsPAbsCAQsQEAsBAgEBuwIPCgoPAgAAAAAFAAn/wAQBA8UAHwA/AEMAlQC0AAATMCIxIgYHMQMwFBUUFhcxMzgBMTI2NzUTMDQ1NCYnIyMwIiMiBgcxAzAUMRQWFzEzOAExMjY3MRM8ATU0JicxASELARMiBgc3AzwBMTQmIyIGFTEHJy4BIyIGFTAUFTEDMBQVFBYzMjY3NRMXFBYzMjY1MTcXBgcOAQcGFRQXHgEXFjMyNz4BNzY1NCcuAScmIzAiOQETDgEjOAExISImNTQ2NzETPgEzMhYXMRMeARUUBgcxoAEJDAErCwgCCQwBKgsHAVUBAQgMASsLCAIIDAErCwgBjgFOp6enMFgoAh8MCQkMQEEBDAkJDCsNCQgMASA3DQkJDDcVJx8gLAwMHh5oRkZQT0ZGaB8eHh9oRkZPAewDDAj+VgsQAgLVBAwHBwwE1QICAgIDwAsI/oABAQgMAQsHAQGAAQEIDAELCP6AAgkMAQsIAYABAQEIDAH9BQEi/t4B+xcVAQEYAQEJDQwIzs4IDA0JAQH+gAEBCQ0LCAEBG68JDAwJr8UbIiJSLi4yUEVGaR4eHh5pRkVQUEVGaR4e/d0GBxALBAYDAXIFBwcF/o4DBgQEBwMAAAQACf/ABAEDxQAfAD8AkQDBAAATMCIxIgYHMQMwFBUUFhcxMzgBMTI2NzUTMDQ1NCYnIyMwIiMiBgcxAzAUMRQWFzEzOAExMjY3MRM8ATU0JicxASIGBzcDPAExNCYjIgYVMQcnLgEjIgYVMBQVMQMwFBUUFjMyNjc1ExcUFjMyNjUxNxcGBw4BBwYVFBceARcWMzI3PgE3NjU0Jy4BJyYjMCI5ARMeARUUBiMiJicxJwcOASMiJjU0NjcxNycuATU0NjMyFhcxFzc+ATMyFhUUBgcxB6ABCQwBKwsIAgkMASoLBwFVAQEIDAErCwgCCAwBKwsIAjUwWCgCHwwJCQxAQQEMCQkMKw0JCAwBIDcNCQkMNxUnHyAsDAweHmhGRlBPRkZoHx4eH2hGRk8BvQMDEAsFCAOYmAMIBQsQAwOXlwQEDwsGCgOYmAMIBQsQAwOXA8ALCP6AAQEIDAELBwEBgAEBCAwBCwj+gAIJDAELCAGAAQEBCAwB/wAXFQEBGAEBCQ0MCM7OCAwNCQEB/oABAQkNCwgBARuvCQwMCa/FGyIiUi4uMlBFRmkeHh4eaUZFUFBFRmkeHv3oAwgFCxADA5eXAwMQCwUIA5iYAwoGCw8EBJeXAwMQCwUIA5gAAAcACf/ABAEDxQDSAOcA8wFFAb4B3gH+AAABLgEnMSYiIyoBBzEHDgEjIiYnMS4BLwEuATU4ATkBNTQmIzEjIgYVMRU4ATEUBgcxDgEHMw4BIyImJzEnIiYjIgYjMQ4BBzEHDgEVFBYXMRceARUcARUxDgEVFBYXNRwBFRQGBzEHDgEVFBYXMRceATMyNj8BPgEzMhYXMR4BHwEeARU4ATkBFRQWMzEzMjY1MTU4ATE0NjcxPgE3MT4BMzIWFzEXHgEzMjY3MTc+ATU0JicxJy4BNTwBNTE+ATU0JicVPAE1NDY3MTc+ATU0JicxBzAiIyImNTQ2MzIWFTE4ATEUBiMxNxQGIyImNTQ2MzIWAyIGBzcDPAExNCYjIgYVMQcnLgEjIgYVMBQVMQMwFBUUFjMyNjc1ExcUFjMyNjUxNxcGBw4BBwYVFBceARcWMzI3PgE3NjU0Jy4BJyYjMCI5ARMXHgEVFAYHMQcOASMiJicxJw4BDwEVFAYjMSMiJjUxNS4BJxUHDgEjIiYnMScuATU0Njc1Ny4BNTQ2NxUnLgE1NDY3MTc+ATMyFhcxFz4BPwE1NDYzMTMyFhUxFR4BFyM3PgEzMhYXMRceARUUBgcxBx4BFRQGBzUBMCIxIgYHMQMwFBUUFhcxMzgBMTI2NzUTMDQ1NCYnIyMwIiMiBgcxAzAUMRQWFzEzOAExMjY3MRM8ATU0JicxA0ACBQQCAwICAwIZAwUDBAgDDSESAQcICwcnCAoJBhMhDgEDCAQDBQMaAQQBAgQBBAYBFAECBQQaBQYCAgICBgUZBAUBARQCCAUDBAIaAgYCBQcDDiASAQcICwcnCAoJBhMhDgIIBAMGAhkCBQIFCQIUAQEFBBoEBgICAgIFBRoEBQEC0gEBKTs7KSo7Oik4IhgYISEYGCI4MFgoAh8MCQkMQEEBDAkJDCsNCQgMASA3DQkJDDcVJx8gLAwMHh5oRkZQT0ZGaB8eHh9oRkZPAdUNDhAEBBMIHBEIEAYNDBoPASQZJxkkEBsMDAYQCBEcCBMEBBAODQECAgENDhAEBBMIHBEIEAYNDBoPASQZJxkkDxsNAQwHDwkRGwgUBAQRDQ0BAQEB/UsBCQwBKwsIAgkMASoLBwFVAQEIDAErCwgCCAwBKwsIAcYEBAEBAQ8BAQMCDRMGAQILBxsHCwsHHQgLAgYUDAMDAgEPAQEBBQMiAgUCBQgDDwIKBgEDAQgTCgoUCQEBAgEGCgMPAggFAwQCIwQEAQEPAQEDAg0TBgECCwcdBwsLBx8ICwIGFAwDAwIBDwEBBQQiAgUCBQkCDwMJBgICAQgTCgoUCQEBAgIFCgMPAgkEAwUCyToqKjo6Kik7ZBgiIhgYIiIBaBcVAQEYAQEJDQwIzs4IDA0JAQH+gAEBCQ0LCAEBG68JDAwJr8UbIiJSLi4yUEVGaR4eHh5pRkVQUEVGaR4e/mEHCBwRCBAGIg4RBQQGCRAGAQ4ZIyMZDgYRCgEHBAQRDSIHDwkRGwgBBwcQCAkQCAEHCBwQCQ8HIg0RBAQHCRAGAQ4ZIyMZDgYQCgcEBBAOIgYQCBEcCAcHEQkIEAcBAp8LCP6AAQEIDAELBwEBgAEBCAwBCwj+gAIJDAELCAGAAQEBCAwBAAAEAAn/wAQCA8UAHwA/AIoA8AAAEzAiMSIGBzEDMBQVFBYXMTM4ATEyNjc1EzA0NTQmJyMjMCIjIgYHMQMwFDEUFhcxMzgBMTI2NzETPAE1NCYnMQEiBhU4ATkBFQ4BIyImJz0BPAE1NCYjIgYVHAEXMRUOASMiJic9ATQmIzEiBgcxDgEVFBceARcWMzI3PgE3NjU0JicXLgEjMCIjMQUVFBYzMjY1MTU8ATU0NjMyFhUcAQczFR4BMzI2NzE1NDYzMTMmJy4BJyYjIgYHNwM8ATE0JiMiBhUxBycuASMiBhUwFBUxAzAUMRQWMzI2NzUTFxQWMzI2NTE3Fw4BDwEzMhYXMaABCQwBKwsIAgkMASoLBwFVAQEIDAErCwgCCAwBKwsIA3YWHwQ9Kio9AyAWFiABBD0qKj0EHxcOGAcICR4eaUVGUE9GRmkeHgkJAQcYDwEB/eofFhcfPi0sPwEBAR8VFR8CPi0LGiMjVTExNTBZKAIfDAkJDEBBAQwJCQwrDQkIDAEgNw0JCQw3FSU7FgEMLD4BA8ALCP6AAQEIDAELBwEBgAEBCAwBCwj+gAIJDAELCAGAAQEBCAwB/gsgFrcpOTkoAbcBAwEWICAWAQMBtyk5OSgBtxcfDwwZOR5QRkZoHh4eHmhGRlAeOhsDDA82txYgIBa3AgUDLD8/LAMFArcVHBwVty0+LCMjMg4NFhUBARgBAQkNDAjOzggMDQkBAf6AAgkNCwgBARuvCQwMCa/FGUAlAj4sAAUACf/ABAEDxQAfAD8AkQChALcAABMwIjEiBgcxAzAUFRQWFzEzOAExMjY3NRMwNDU0JicjIzAiIyIGBzEDMBQxFBYXMTM4ATEyNjcxEzwBNTQmJzEBIgYHNwM8ATE0JiMiBhUxBycuASMiBhUwFBUxAzAUFRQWMzI2NzUTFxQWMzI2NTE3FwYHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJiMwIjkBAw4BIyImJzERPgEzMhYXMRMcARUUBiMiJjU8ATUxET4BMzIWFzGgAQkMASsLCAIJDAEqCwcBVQEBCAwBKwsIAggMASsLCAI1MFgoAh8MCQkMQEEBDAkJDCsNCQgMASA3DQkJDDcVJx8gLAwMHh5oRkZQT0ZGaB8eHh9oRkZPAVABDwoLDwEBDwsKDwHWEAsLEAIPCgoPAgPACwj+gAEBCAwBCwcBAYABAQgMAQsI/oACCQwBCwgBgAEBAQgMAf8AFxUBARgBAQkNDAjOzggMDQkBAf6AAQEJDQsIAQEbrwkMDAmvxRsiIlIuLjJQRUZpHh4eHmlGRVBQRUZpHh79zgoNDQoBcgoODgr+jgEBAQsQEAsBAQEBcgoNDQoABQAJ/8AEAQPFAB8APwCRAJ8AywAAEzAiMSIGBzEDMBQVFBYXMTM4ATEyNjc1EzA0NTQmJyMjMCIjIgYHMQMwFDEUFhcxMzgBMTI2NzETPAE1NCYnMQEiBgc3AzwBMTQmIyIGFTEHJy4BIyIGFTAUFTEDMBQVFBYzMjY3NRMXFBYzMjY1MTcXBgcOAQcGFRQXHgEXFjMyNz4BNzY1NCcuAScmIzAiOQETIiY1NDYzMhYVMRQGIzcVDgEjIiYnMTU0NjM4ATkBMjY1NCYjIgYVMQ4BIyImJzE+ATMyFhUUBgcjoAEJDAErCwgCCQwBKgsHAVUBAQgMASsLCAIIDAErCwgCNTBYKAIfDAkJDEBBAQwJCQwrDQkIDAEgNw0JCQw3FScfICwMDB4eaEZGUE9GRmgfHh4faEZGTwEGEBcXEA8XFw8aAQ8KChABEAsqPDwqKjwBDwoKEAEBWkBAW0k3AQPACwj+gAEBCAwBCwcBAYABAQgMAQsI/oACCQwBCwgBgAEBAQgMAf8AFxUBARgBAQkNDAjOzggMDQkBAf6AAQEJDQsIAQEbrwkMDAmvxRsiIlIuLjJQRUZpHh4eHmlGRVBQRUZpHh79axYQEBYWEBAW6ioKDg4KRAsPPCoqOzsqCg4OCkBaW0A5VgoABABVABUDqwNmAAoAFQAfAFAAAAEtATAiMTAiMQ0BJTgBMREUFhcFESUBJT4BNREwNDEFAyImJyImJyUuATURNDY3OAExPgE3JToBMzoBMwUeARc4ATEeARURFAYHBSIGBw4BIwHrAVX+xAQE/sABL/6VBgcBSP6rAYABcwcG/oAVBAYDAwIE/qsTGAgJBxEGAWsDCAYDCwMBawkOBwYLGBP+gAMCBAMGAwJramtrakz+PAYMA5UB+3P9kpkDDAYBvARz/dEBBAEDmQciEwHADRQKCQkDc3MDBwcJFQ3+QBMiBp4BAwQBAAYAVQBqA6sDFQAPABkAIwA9AEwAZQAANyImNRE0NjMhMhYVERQGIyUUFjMhMjY1ESElNTQmIyEiBh0BNyImNTQ2NzgBMToBMzAyMzAyOwEeARUUBiMzIiY1NDYzMjAzMhYVFAYzIiY1NDY3OAExOgEzMDIxOgExMhYVFAYjwCw/PywCgCw/Pyz9QCYaAoAaJv0AAwAmGv2AGiZrDhIPDAEBAQEBAQEBDBETDVUNExIMAQENExNIDRMQDAEBAQEBAQ0REg5qPywB1S0+Pi3+Kyw/axomJhoBaypAGyUlG0AgEw0MEgIBEg0NExMNDRMSDg0TEw0MEgITDQ0TABIAgAAVA6sDQAADABUAGQAqAC4APwBEAFYAWwBsAHEAggCGAJgAnACtALEAwgAAARUjNTcjIgYdARQWOwEyNj0BNCYjMQUVIzU3IyIGHQEUFjsBMjY9ATQmIwUVIzU3IyIGHQEUFjsBMjY9ATQmIwEVIzUzNSMiBh0BFBY7ATI2PQE0JiMxBRUjNTM1IyIGHQEUFjsBMjY9ATQmIwUVIzUzNSMiBh0BFBY7ATI2PQE0JiMBFSM1NyMiBh0BFBY7ATI2PQE0JiMxBRUjNTcjIgYdARQWOwEyNj0BNCYjBRUjNTcjIgYdARQWOwEyNj0BNCYjASuAgIAUFxcUgBMXFxMBKoCAgBMXFxOAFBcXFAErgICAExgYE4ATGBgT/auAgIAUFxcUgBMXFxMBKoCAgBMXFxOAFBcXFAErgICAExgYE4ATGBgT/auAgIAUFxcUgBMXFxMBKoCAgBMXFxOAFBcXFAErgICAExgYE4ATGBgTAxWAgCsXFIATFxcTgBQXK4CAKxcUgBMXFxOAFBcrgIArFxSAExcXE4AUF/6rgIAqFxOAFBcXFIATFyqAgCoXE4AUFxcUgBMXKoCAKhcTgBQXFxSAExf+q4CAKxgTgBMYGBOAExgrgIArGBOAExgYE4ATGCuAgCsYE4ATGBgTgBMYAAAABAAA/8kD+gO3ABoALwA7AEgAAAUiJicBLgEnETQ2MyEeARcBFhQHAQ4BIzgBMQEiBhURHgEXAR4BMzI2NwkBLgEnIRMiJjU0NjMyFhUUBiciBhUUFjMyNjU0JiMCgQ0XCf3RERICJhoBFRksEgJOBgb+tAkYDP2/CQwBDQsCLQQHBQQIAwE9/cIMHhH+7KssPz8sLD4+LBslJRsaJiYaNwkJAi8SLRgBFhslARMQ/bMHEQf+tQkKA8QNCf7rEB4M/dIDBAQDATwCPwoNAf7VPi0sPj4sLT6rJhobJSUbGiYAAAAABAAJ/8AEAAPAAB8APwCIAKMAABMwIiMiBgcxAxwBMRQWFzE6ATkBMjY3MRM8ATU0JicxIzAiIyIGBzEDHAExFBYXMTAyMzEyNjcxEzwBNTQmJzEBIgYHNwMuASMiBgcxBycuASMiBgcxAxwBMRQWMzI2NzETFx4BMzI2NzE3FwYHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJiMxEwUOASMiJjU0NjUxETQmNTQ2MzIWFzEFFhQHoAEBCAwBKwsIAQEJDAEqCwhVAQEIDAIqCwgBAQgMASsLCAI1MFgoAh8BDAgHCwJBQQILCAgMASsNCQgMAR83AgwHBwsCNxYnHyAsDAweHmlGRVBQRUZpHh4eHmlGRVDF/swDBwQKDwEBDwoEBwMBNA8PA8ALCP6AAQEJDAELCAGAAQEBCAwBCwj+gAEBCQwBCwgBgAEBAQgMAf8AFhUBARcICwgHz88HCAsI/oABAQkNCwgBHK8HCAgHr8UaIyJSLi4yUEVGaR4eHh5pRkVQUEVGaR4e/m2aAgIOCgECAQEqAQIBCg4CApoIFggAAwAA/8AEAAPAAA8AIQAlAAABMhYVERQGIyEiJjURNDYzJSEiBhURFBYzITI2NRE0JiMxASMBMwNVN0lJN/1WN0lJNwKq/VZHZGRHAqpHZGRH/lZWAQBWA5VJN/1WN0lJNwKqN0krZEf9VkdkZEcCqkdk/KsCqgAAAv/7AGsD6wLrADUAZAAAASImPQE0NjMhJyY0Nz4BMzIWHwEeARU4ATEUBhUwFAcOAQ8BDgEjIiYnJjQ/ASEiBh0BFAYjBSImNRE0NjMhMhYdARQGIyImPQE0JiMhIgYVERQWMyEyNj0BNDYzMhYdARQGIyEBZgkMcFABkYYHBwMHBQQIA6oDBAEBAQICqgMIBAUHAwcHhv5vPlgMCf7VGiYmGgIAGyUMCQkMDQn+AAkMDAkCAAkNDAkJDCUb/gABFQ0JVU9xhgcRBgQDAwOrAwgEAgIBAgECBAKqAwMDAwYSBoZXPlUJDaolGwIAGiYmGhYIDQ0IFggNDQj+AAkNDQnqCQ0NCeobJQAAAAMALP/rA9QDswAiACUAWwAAATgBMTIWFzEBHgEVFAYjOAExISImNTQ2NzEBPgE3MT4BMzEVASEBOAExMhYXMQEeARUUBiM4ATEjIiY1NDYzMTMJATMyFhUUBiMxIyImNTQ2NzEBPgE3MT4BMzECAAoSBgGpBAUZEvyuEhkFBAGqAQQCBQ4H/lcDUv5XChIGAakEBRkRagkMDAlq/lb+V2kJDAwJaRIZBQQBqgEEAgUOBwJdCAj94wYNCBEZGREIDQYCHQIEAQUEKv3iA54JB/3iBQ4HEhkMCQkNAh394w0JCA0ZEgcOBQIdAgQCBAUAAAsAJ//nA9kDmQCwAOsBKwGKAb4BzAHaAekB+AIlAlYAABMyFhUUBgc3Fz4BMzIWFyc3LgE1NDYzMhYXMRceARUUBiMiJiczBx4BFTAUOQEUBgc3Fz4BMzE6ARcxHgEXMR4BFRQGBzEHDgErATE4ATEiJjU0NjcHJw4BIzgBOQEiJicxDgEjIiYnNQ4BIzE4ATEiJicxBx4BFRQGIyImJzEnLgE1NDY3MTYyMzEyFhcnNy4BNTEwNDE0NjcHJw4BIyImJzEuATU0Nj8BPgEzOAE5ARMHDgEjIiYnMy4BIzgBOQE4ATEqAQcxDgEHMQ4BFRQWHwEeATMyNjU0JicxLgE1NDY3MTcuAT0BLgEnIQYHFRQGBzUXHgEVFAYHMQ4BFRQWFzEeATMwMjkBMjY3MTc+ATU0JicxLgEnMSYiIzgBOQEiBgcxDgEjIiYnMQEiBw4BBwYVFBYXMR4BFTgBOQEVFBYXOQEeATMyNjU4ATkBNDYzMhYVMTgBFRQWMzI2NTQwOQE0NjMyFhUxOAEVFBYzMjY1NDA5ATU4ATE0NjcxPgE1NCYnFycuASMxETIWFzEeARUUBgcxDgEjMTgBMSImJzEuASMiBgcOASMiJiMxJy4BNTE8ATE8ATcxPgEzMScyFhUUBiMiJjUxNDYzMzIWFRQGIyImNTE0NjMHIgYVFBYzMjY1MTQmIzEzIgYVFBYzMjY1MTQmIzEBOAExIgYPAQ4BFRQWMzI2NyM+ATMyFhcxFz4BNzMnLgE1NDY3FT4BNTQmIzEhIgYVFBYXMR4BFRQGBzEHHgEXHgEfATc+ATMyFhcxHgEzMjY1NCYnMScuASM4ATkBxiU0BQUBTiFQKyxPIgFOBAQ0JBMgDEYMDjQlChQJAVsKCxoXAXYIEwsDBwMSHQsICg4MRgwgEgElNAUFATkLHhIRHwsLHhISHgsLHxESHgs5BAU0JRMgDEYMDiwgAwcDCxMJAXYWGgsLAVsIFAoTIAwMDg4MRgwgE29+AggEAwYDAQcPCAIDAgoRBQUFCAZGBxIKFB0FBQICAwNOAQEBAwIBlgMDAQFOAwMCAgUFCAYHEgoBChEHRgYIBQUFEQoCAwIIDwcCBgMECAL+tzErK0ATEichAwMCAQQUDRAXDAgIDBcQEBcMCAgMFxAQGAMDIScMCwEBHXJGEh4HAgIFBAIGAwUIAwgIBwcICAEFAgICAhACAgEIHRN2IC8vICEuLiHsIS4uISAvLyDsEBgYEBAXFxDsEBcXEBAYGBD+UAoSB0YHCB0VCA8HAQMGAwQIAlwLGQ4BVwMDAgIFBR0UAnQUHQUFAgIDA1YCBAIMFAkBXAIIBAMGAwYPCBUdCAdGBhILA5k0JQoUCQFPFhoaFwFPCBMLJTMNDUUMIRIlNAUEWhc1HAErUCEBdgQEAQISDgsbDxMgDEYMDjQlChQJAToNDg4NDQ4ODAENDg4MOQgUCiU0DgxGDCATITIEAQQFAXYhTysBHDUYAVoEBQ8MDCASEiEMRgwO/ZR+AwMCAgUFAQEKCAYPCAsSBkYHCB0VCA8GAwYDBAcDTgMIBFICAwIDBFIECAQBTgIIBAMGAwYPCAsSBgcICAdGBhILCA8GCAoBAQUFAgIDAwIlExNAKysxMlggAwcEWwQHAwsPFxEICwsIARAXFxABCAsLCAEQFxcQAVsEBwMgWDIcMxcBATxL/pEUDwMFBAUIAwIBBAQMBwYNAgIBCwEDAgEBAgMBEBTRLiEgLi4gIS4uISAuLiAhLicXERAXFxARFxcREBcXEBEXAWIHB0YHEgoUHQUFAgIDA1wRHw1XAgcFAwYDAQcPCBUcHRQIEAYCBgMECAJXAgQCCxsOAVwDAwICBQUdFAoSB0YGCAAGAAL/wAQCA8AALgBRAHQAkQCtAM0AABciJjURNDYzITIWHwEeAR0BFAYjIiY9ATQmLwEuASMhIgYVERQWMyEyFhUUBiMhEyImLwEuATU0Nj8BPgEzMhYXHgEVFAYPARceARUUBgcOASMzIiYnLgE1NDY/AScuATU0Njc+ATMyFh8BHgEVFAYPAQ4BIwEiJy4BJyY1NDc+ATc2MzIXHgEXFhUUBw4BBwYjESIHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJgMiJj0BIyImNTQ2OwE1NDYzMhYdATMyFhUUBisBFRQGQhslJRsCNw0XCZ4JCgwJCQ0DA54DCAT9yQkNDQkBgAkMDAn+gNUECAOAAwMDA4ADCAQECAMDAwMDcXEDAwMDAwgEgAQIAwMDAwNxcQMDAwMDCAQECAOAAwMDA4ADCAQBVTkyM0sWFhYWSzMyOToyM0sWFhYWSzMyOjArKz8TEhITPysrMDErKkATEhITQCorMQgNawgNDQhrDQgJDWoJDQ0Jag1AJhoDgBomCgmeCRcNjQgNDQiNBAgDngMDDAn8gAkMDQkIDQHAAwOAAwgEBAgDgAMDAwMDCAQECANxcQMIBAQIAwMDAwMDCAQECANxcQMIBAQIAwMDAwOAAwgEBAgDgAMD/kAWFUwyMzk6MjNLFhUVFkszMjo5MzJMFRYCABMSQCsqMTArK0ASExMSQCsrMDEqK0ASE/6ADAlrDAkJDGsJDAwJawwJCQxrCQwAAAAAAQAA/8ACKwHrACwAACU3PgE1NCYjIgYPAScuASMiBhUUFh8BBw4BFRQWMzI2PwEXHgEzMjY1NCYnMQEz8QMEDQkECAPx8QIIBQgNAwPx8QMDDAkFCALx8QMIBAkNBAPV8QMIBAkNBAPx8QMEDQkECAPx8QIIBQkMAwPx8QMDDQgFCAIAAgCrAGsDVQMVABAAIwAAASEiBhURFBYzITI2NRE2JiMHAQ4BLwEuATc+AR8BEz4BFx4BAxr90RomJhoCKh0jBCYZHv7vDSINog0EDQwiDYX3DSINCQQDFSYa/dodJyYaAioaJsz+uw0EDYkMIg0NBAxvASYNBA0NIgAAAAIAqwBrA1UDFQAQACAAAAEhIgYVERQWMyEyNjURNiYjAxQGIyEiJjUxNDYzITIWFQMa/dEaJiYaAiodIwQmGUUXE/6qEBoXEwFWExcDFSYa/dodJyYaAioaJv6rEBsYExAbGBMAAAAAAgCkAGQDXAMcABQAKAAAEyEyFhUxERQGIzEhIiY1MRE0NjMxFSIGFTERFBYzMSEyNjUxETQmIzHkAjgbJSUb/cgbJSUbCQ0NCQI4CQ0NCQMcJRv9yBslJRsCOBslKg0J/cgJDQ0JAjgJDQAABQBV/8AD1QPAAFoAmQDTAOgA9AAABSImLwEuAT0BJyY0PwE1JyY0PwE1JicuAScmNTQ3PgE3Njc1NDYzMhYdAR4BFx4BFxYGBxceAR0BFAYrASImLwEjIiY9AScjIiY9AScOASMiJicRFAYPAQ4BIzU3ETQ2Nz4BNTQnLgEnJicVHgEVFAYjIiY1NDY3NQYHDgEHBhUUFhceAR0BFAYPARceAR0BFAYPARceAR0BFyU1Jy4BNz4BJy4BJy4BJx4BFRQHDgEHBgcVHgEzMjY3PgEzMhYfAR4BHQEzMhYfAR4BHQEzMhYfATMBDgEVFBYzMjY1NCYnFRQGIyImPQE3HgEXNTQmIyIGHQEBVQQIA0ADAyQHByQkBwckJh8gLQwNEhM/KyoyPywsPh46Gi0/DgwHFd4DAwwJWgUHAycwCQwJNwkNGxo5HRgxFgQDQAMHBSsJB0RXDw8zIyQoJTA/LCw+MCUpIyMzDw9XRAcJBAMbGwMEBAMbGwMEKgJW4wUCBBQKDAs1JRQqFhscDA0tHyAlFjEZGzUXAwUDBAcDLgMEKwQIAxUDAyMECAMnPf2VExgmGhslGBINCQgNKyNAHSYaGyVAAwNAAwgEOCQGEgYkGiQGEgYkHA0ZGEAlJigzLC1EFhUEFiw/PyxLARAPGU8xLV0q3gMIBFsIDQMDJQwJNgoNCDcYDA0JCv73BAgDQAMDMysBQAgLAhNzRyklJTkSEgQrCDsmLD8/LCY7CCsEEhI5JSQqR3MTAgsIMwUHAxwcAwcFKgUHAxwcAwcFNyt4POIFDwYlVCkpQhULDQIiUSwoJiY/GBkNAwsLDQ4BAQIDKQMIBSoEAxYDCAQqAwIlAlEGIRUaJiYaFSEGJwgNDQgngwMYFEUbJSUbFgAABwAA/8AD5wPAABAAGwBWAGMAdwB7AJ0AABciJj0BNDYzITIWHQEUBiMhNyIGHQEhNTQmIyElIiYnAQcWBgcOASMiJi8BJjQ3PgEzMhYXNy4BNTQ2Nz4BMzIWHwEeARUUBgcOASMiJicHAR4BBw4BIyceATMyNjc2NCcBBwEBIgYHBhQfAR4BMzI2NzY0LwEuARc3JwclHgEzMjY3PgE1NCYvAS4BIyIGBw4BFRQWFzAWMRc4ATMXKxIZJRsBKxomGRL+qxUJDAFVDQj+1QNpER4M/v48EQQUChsPDxwKxBYWChsPDRYK1AcIDAoLGw8PGwvECwsLCwsbDwwXCjwBHRkBGA0fEh0GDwgJEAYMDP7iIAEC/aQGDAQKCsQEDAcGDAQKCsQFC9zTl9MBnwQMBgcLBQQFBQTEBQwGBgwFBAUFBAi1AQdAGRJAGiYmGkASGYANCEBACA1nDQsBHjwWOBQKCwsKxRU+FgsLBwjVCRcMDxwKCwsLC8QLGw8PGwsKDAgHPP8AGkUZDA42BQYHBgwjDAEBIP7iAXsEBQkbCcQFBQUFCRsJxAUEmNOX00QFBQUEBQwGBgwFxAQFBQQFCwcGDAQItQcAAwAV/9UD6wOrABwAOABYAAAFIicuAScmNTQ3PgE3NjMyFx4BFxYVFAcOAQcGIxEiBw4BBwYVFBceARcWMzI3PgE3NjU0Jy4BJyYDIiY9ASMiJjU0NjsBNTQ2MzIWHQEzMhYVFAYrARUUBgIAZVpZhScnJyeFWVplZVpZhScnJyeFWVplXVFSeSQjIyR5UlFdXVFSeSQjIyR5UlFdCQzrCQwMCesMCQkM6wkMDAnrDCsnJ4VZWmVlWlmFJycnJ4VZWmVlWlmFJycDqyMkeVJRXV1RUnkkIyMkeVJRXV1RUnkkI/0rDAnrDAkJDOsJDAwJ6wwJCQzrCQwAAAAABQBCACsDwANVADgBDAH/AtkDtwAANyImPQEuAScmNjcnNTQ2Nz4BNzYmJy4BPQE0NjMhMhYXHgEXFjIzMjY3PgE3PgE7ATIWFREUBiMhJTI2NREjIiYnLgE1LgEnNS4BJy4BLwEuAScwJjEuAScuASMuAS8BLgEvASImIyImIyoBIzAiMSoBIzAGMSoBIw4BIyIGIw4BIw4BIw4BIw4BFSIGBw4BBw4BBxQGBw4BBxQGFQ4BFQcOARUOASsBMBQxHgEXMBYzHgEXHgEXHgEXHgEXMhYxHgEXFBYXMBYxHgEXFBYXHgEfAR4BFxQWFRQGFRQGDwEOAQcOATEOAQcwBjEOARUOAQcVDgEHDgEHDgEHDgEHMCIxDgEHMAYjDgEHFyEBFAYHDgEXHgEXHgEdARQWMyE1NDY3PgEzNz4BNz4BPwE+ATcwNjE+ATc2NDc+ATc1PgE3NT4BNzwBNTY0NTwBJzwBJzQmJzUuAS8BNCYnIiY1LgEnMCYxLgEnIiYxLgEnIjA1IiYnIy4BJy4BPQEjDgEHFAYVDgEHFAYVDgEHDgEHDgEHDgEHDgEHDgEHDgEHDgEHDgEjDgEjDgEHKgEjByoBIyIGKwEwIiM4ASMwIiMiJiMiJiMqASMiJiMuASciJiMwJjEuAScuASciJiMwJjEuAScuAS8BLgEnLgEnMCY1LgEnOAEnLgEnNCY1LgEnIxU3MhYXHgEXFBYfAR4BFx4BHwEeARcwFjMeATMeATMeAR8BHgEfATIWMzIWMzAyMToBMzAyMTMyNjsBPgEzNjIzPgE3MjY3MjYzPgE1PgE3PgE3PgE3NDY3PgE1Nz4BNTc+ATU+ATsBNSImJyImIy4BJzAmMS4BJy4BJy4BJy4BJy4BJy4BJzAmMS4BJy4BNS4BLwEuAScwNDE8ATU8ATU+AT8BPgE/AT4BNzA2MT4BNz4BPwE0NjE+ATc+ATc+ATcwMjE+ATcyNjM+ATcnISIGHQEeAQcOAQcXMyUyFh8BHgEXFjIXHgEXFjAzHgEXHgEXHgEzHgEXHgEVHgEXMBYxHgEXFhQXHgEVMxE0JisBDgEHDgEjIiYnLgEnIxUUBgcOASMHDgEHIgYjDgEHIgYHDgEVDgEHDgEVDgEHIgYVDgEHFAYVFAYVDgEVMAYVMBQxFRwBFRwBFxQWHwEUFh8BHgEXHgEVHgEfAR4BHwEeARceARczHgEXHgEdATM+AT8BPgE3NDYzPgE3MjYxNz4BPwE0NjU+ATc+ATc+ATc0Mjc+AT8BPgEzMDYxMDIxMjY7ATI2MzgBMdUaJh8uBgkyKwETDxMcBAUeGg8TJhoBrQ8YAwQbEwMHAwkSCAsOAgQXDy0aJiYa/VUCqwkMQg0VBQEBAQEBAQIBAQIBAgEDAQEBAwEBAQEBAwECAgMCAgIEAgIDAgEDAQMBAgECAgEBAgQCAQEBAQIBAgICAQEBAQIBAQEBAwEBAQEBAQEBAQEBAgEBAQMYD0IDBwQBAQQGAwMGAwEBAQMEAgECAgMCAgEBAgIBAQEBAgIBAgIBAQEDAgECAgEBAQECAgEBAgIDAgEBAQIFAgEBAQMFAwEDBgQCAQQHAwEBQP1AEw4bHQUDHBMPEwwJAUATDwIEAgICBAICAwICAQMCAQECAQEBAQIBAQIBAQEBAQEBAQEBAgEBAgEBAQECAQIBAwEBAQIDAQECBAICAgQCDxNCAQECAQECAgECAwEBAgEBAwECAwIBAwEBAwIBBAIBBAECBQIBAgEEBgMBAgECAQICAQIBAwIBAQEBAgYCAgIBAQEBAQEBAwUCAgMBAgIDAQIFAgEBAQECAgECBAEBAQEBAgQCAgIDAgEBAwEBAQIBQkMMFQUBAQEBAQEBAQEBAwEBAQMBAQEBAgEBAQEBAwECAgMCAgIEAgIDAgEBAwEDAwEBAQMCBAIBAQEBAwEBAgEBAgEBAgECAQECAQEBAQEBAQIBAQIBAQEEFw9CAwYEAQEBBAYDAQMFAgECAQIEAgECAQIDAQECAQEBAgEBAQICAQECAwEBAwIBAQMBAQICAQEBAgEBAwIBAgIFAgECAQIGAgEDBgQBAQEEBwMB/sAIDSsxCQYuIAFDAegJEQgDAwYDAQEBAgMCAQEBAgIBBAIBAQECBAIBAQIEAQEBAwEBAQECQgwJLQQXEg0eEAULBSAuBkITDgMEAgICAwEBAQEBAwEBAQEBAgICAQEBAQEBAQEBAQECAQEBAQEBAQECAQEBAQEBAQECAQIBAwECAgMCAgQCAgIEAg8TQgEBAgEBAgIBAQEDAgEBAQEDAgECAgUCAQIBAwQDAgEDBgMCAwYEAQECBAICAgUDKyUbLQYtIStJCVdYDhgDBBsUGiwFAxgPLBslEg8THAQBBQYHFQ0OEyUb/VYbJSoNCQFADgwCAwICBQIBAgQCAgQBAgIDAQEBAgEBAQECAQEBAQEBAgEBAQEBAQEBAgEBAQEBAQEBAwEBAQEBAQEBAwEBAQEBAwICAgQDDhNCAQIBAQEDAgIDAgEBAQIEAgMCAwIBAgIBAgQCAQEBAwUEAgYNBgMFAgIFAgcNBgMDBQMBAgIEAgECAgECAwIBAQEBAgQBAQEBAgMCAgMBAQECAUIBEw4YAwUsGhQbBAMYDywJDUMOGAMBAQEBAgEBAgEBAgIBAgECAQEBAQEDAgIBBAIBAgUCAQQBAgMBAQMBAgQBAgUCAQIEAQICAwECAQECAQIBAgIBAQIBAQIBAQEBAxgPQgMHAwECAQMFAwEBAQMEAwECAQIDAQIDAgECAgECAQECAQECAQECAQEBAgEBAQEBAQEBAQIBAQEBAQICAQEBAgECAwEBAQEBAgQDAgEDBQMBAgcDAQIBAwcDQ20NDAIEAgIFAgECBAICBAECAgMBAQEDAQEBAgEBAQEBAQIBAQEBAQEBAQEBAgEBAQEBAQECAQEBAQEBAQEDAgIBAwICAgQDDhNDAgEBAgICAQEDAgEBAQIDAgECAQIDAgECAgECBAIBAQEDBQQCBg0GAQIFAgIFAgcNBgIEBQMDAgQCAQICAQIDAgEBAQMEAQEBAQIDAgICAgEBAgFCDQktCEkrIS0HQlYDAwEBAwEBAQECAQECAQECAwEBAgIFAwEBAQMFAwECBwMBAgEDBwMBQAkNFSMMCQkBAQYuIEMOGAMBAQEBAQEBAQIBAQEBAQEBAgEBAQEBAgECAQEDAQEDAQEBAQEEAgYBAgQBAwECBAECBAMBAgQBAgICAgEBAQECAQIBAgIBAQIBAQIBAQEBAxgPQgMHBAIDBgMBAgMFAwIBAgMCAQEBAQIDAgEBAQIDAQEBAQMBAQECAQEBAAADADP/wAQBA7wAdwDVAU0AAAE+ATU0JiMiBg8BJy4BIyIGDwEOARUUFhcxHgEXMR4BFzEeARUUBiMiJicxLgEnMS4BIyIGBzUOAQcxBw4BFRQWHwEeATMyNj8BPgE1NCYnMS4BJzEuATU0NjM4ATkBOAExMhYXFR4BMzI2NyM+AT8BPgE1NCYnMQ8BLgEjIgYHMQ4BFRQWFzMHDgEjIiYvAS4BNTQ2NzE3HgEzMjY3MT4BNTQmJzEuAScxNz4BMzIWHwEeATMxMjYzIz4BNzM+ATMyFhUUBgcxDgEVFBYfAR4BFRQGBzEBLgEjIgYPAiYnLgEnJiMiBw4BBwYVFBYXNR4BMzE4ATEyNjMxPgE1NCY1MS4BNTQ3PgE3NjMyFx4BFxYfARUnLgEjIgYVFBYXMRcxHgEXFTIWMzE6ATEzOAExOwEwMjE+ATcxMjY5AT4BNTEyNDM3PgE1NCYnMQJ7Fho+LRsvDgEuCRcODRcJPgUHBgYCAwIDBQIICiYaDRcJAgQCBhILBwwFAgMBPwgKCgjyCBgNDRcJQwYGDwwGCwUICiUbFCAHBRUOBAgEAQUHA0MICgoIHkMMNiEWJw8OESYdAUMDCAQECAPxAwQEAj8OLhwVJg8PERAOBAgEPQMIBAUIA0QDBwUBAwIBBggBAQUiFhslGhUHCQMDRQIEBAIBawMFAwYKAgFSBSQkcktLVFhOTnQhIgcHAQwHAgICBwkBBgYeHmlGRVBNRERnIB8EAXcDBwUJDAMDngIDAgIDAQEBAQEBAQIEAQEBAQMBAXUCAQYEAWsPLxstPhoVAS8ICgoIPgYPCQkQBQIDAQIEAggXDRslCQkCBQIJCwQEAQICAj0JFw4NFwnxCQoKCUIGEAkNFQUDBwUIFw4aJhcRAQwPAgECBQNCCRcNDhcJPUIeJRAPDicWIjUMQwMDAwPxAwgEBQcDPhUaEA4PJxcWJg4EBwM+AwMDA0UDAwEBCAYVGiUbFiIFAgwHBAgDRAMIBAUIAwHBAQIGBAGKVEhJax8eISJzTk5YHDcaAwcJAQILCAEDARUxGVBGRmgeHhwcYkNCSwEHeQMEDQgFBwOjAQIBAQEBAQEBAQMBAccCBgMFCgMAAAAIAAD/wAQAA8AAGwA4AFIAagCJAJcApgC0AAABIicuAScmNTQ3PgE3NjMyFx4BFxYVFAcOAQcGAyIHDgEHBhUUFx4BFxYzMjc+ATc2NTQnLgEnJiMDIiYnAS4BJzU0NjMyFh0BHgEXARYUBw4BIwEiJicmNDc+ATcnNDYzMhYdAQ4BBw4BIwEjIiY1ETQ2MzIWFREUFjsBMjY9ATQ2MzIWHQEUBiMTIiY1NDYzITIWFRQGIwUiJjU0NjMhMhYVFAYjIRUiJjU0NjsBMhYVFAYjAatNTE15JiYmJnlNTE1MTUx6JSYmJXpMTUxVR0ZmHBwcHGZGR1VUR0dlHB0dHGVHR1RABAoD/uYdIAMMCQoMAxsZARoGBgMLAwGZAwYEBgYaGwMECwoKCwMgHQMLA/68KxknDAoJDAwJKwoLDAoJDCYaqwoMDAoBgAkMDAn+gAoMDAoBKgoMDAr+1goMDArVCgsLCgJrCwsrICApKiAgKwsLCwsrICAqKSAgKwsLASoLDCUWFxcWFxckDAwMDCQXFxYXFxYlDAv9VgEDARojUi1qCgwMCmokRB3+5wcRBgMBARkBBAYRBh1EJGoKDAwKai1RIAcC/bwmGgEACgsLCv8ACgsLCloJDAwJWhomAdUMCgkMDAkKDKoLCgoLCwoKC6sMCQoMDAoJDAAAGQCAAEADgANAAAMABwALAA8AEwAXABsAHwAjACcAKwAvADMANwA7AD8AQwBHAEsATwBTAFcAWwBfAGMAADcVIzUhFSM1IRUjNSEVIzUhFSM1JRUjNSEVIzUhFSM1IRUjNSEVIzUlFSM1IRUjNSEVIzUhFSM1IRUjNSUVIzUhFSM1IRUjNSEVIzUhFSM1JRUjNSEVIzUhFSM1IRUjNSEVIzXVVQEAVQEAVgEAVQEAVf2qVQEAVQEAVgEAVQEAVf2qVQEAVQEAVgEAVQEAVf2qVQEAVQEAVgEAVQEAVf2qVQEAVQEAVgEAVQEAVZVVVVVVVVVVVVVVq1VVVVVVVVVVVVWrVlZWVlZWVlZWVqpVVVVVVVVVVVVVq1VVVVVVVVVVVVUAAAQAFf/VA+sDqwAbAC8AQwBfAAABOAExMjY1NCYnMScuASM4ATEjIgYVMRUUFjMxBSIGFTERFBYzMSEyNjUxETQmIzEBNDYzMSEyFhUxFRQGIzEhIiY1MQM0JiMxIzgBMSIGBzEHDgEVFBYzOAExITI2NTEDqgkNAgKaBhIL3wkMDAn+CwkNGRIDgBIZDQn+QA0JASoJDQ0J/tYJDUoNCbQLEgaaAgINCQFfCQ0CoAwJBAYD1wgKDQngCQxADAn9tRIZGRICSwkM/mAJDAwJVQkNDQkDKgkNCgjXAwYECQwMCQAAAAEBVf/AAqsDwABiAAABHgEVFAYHIw4BBzEOARUcARUcARUwFDEUFjMxHgEXFR4BFRQGBzcOAQ8BDgEjIiYnFy4BLwEuATU0NjcVPgE/AT4BNzM+ATU8ATU8ATcwNDE0JicxLgEnNS4BNTQ2MzoBOQECAkZjPTABAwUDBQIEBCs8CwMDAwQBCzMkAQ8hEQwXCwEnOw4BBggBAQU1KAEECwUBBAIBBQQlOA4GBmRGAQEDwAFjRjZWEwECAQEFBC1ZLSdPKAEEBg1AKgIJFQsMFwoBJzsPAQYHAwQBCzMjAQ8gEgYLBQEuRxIBAgQBAQUEGTQaOnU7AQQGAQszIwEOIBFHZAAAAQBV/8ADqwPBAIgAAAEwNDE0JiMiBhUUFhczFRQGIyImIyIGBzc0NTQ2Nz4BNzE+ATU0JiMiBhUUFhc1HgEXMx4BFTAUOQEGFBUUHQExHAEVFAYHDgEHNw4BBxUOARUUFhcnHgEfAR4BMzI2Nwc+AT8BPgE1NCYnFS4BLwEiJjUwNDUVPAE1NDYzMjc+ATc2PQE+ATUxA6tkR0dkSDcBXXgIEwowWioEAgUDBgIwPWRGR2MGBg44JAEEBQECBAYLBQEpNQUBAQgHAQ87JQIKFwwRIg8BJDQKAQMDAwMKPSoBBARdeC81NFkdHTdJAxUBR2RkRztcDjE3HgEQDwFOTQQFAQECARNVNkdkZEcRIA8BJDMLAQYEATt1Oh8eAQoVCgQFAQEEAwETRy0BBAsGEiEPASQzCgEDAwcHARA7JgEKFgwLFQsCLEAMAQYEAQEBCxQKNh4DAyAiI0AxDls7AAIAgAEVA4ACagDFANMAAAEqASMwBjEiJicxLgEnFTA0MTUuASczLgEvAS4BJy4BJzEqASMqASMOAQczIgYjDgEHMyoBBzAiMQYiMQ4BBw4BBzMOAQcOAQcVDgEHFQ4BBw4BBxUGFAcUBiMwIjUxKgEjFToBMzIWFx4BFzUeARceARc1HgEXMR4BFx4BFxUeARceAR8BHgEfATIWFzoBFzIWMx4BMzI2NyMyNjM2MjcyNjc+ATcjPgE3IzAyNz4BNzE2Nz4BPwE+ATMwMjkBOgEzNSoBIwUiJjU0NjMyFhUxFAYjA2kaiRoBAwQBAgQCBQwIAQYNBwECAwIULhoDBgMCBAIFCgUBAQMBBgoFAQECAQEBAQMEAwcLBgEDBgMEBwQECAQBAwEDBwMBAQYEASp/KiqAKgQEAQIDAQIEAgIFAgMGAwIFAwMIBQMGAwQHBAEFCwYBAgMCAQMBAgMCCBAJBw4HAQIDAgIDAgICAgUJBAEFCQQBAQEIDwcDAw8WBgEBBQMBH5QfBgwF/pcjMjIjIzIyIwHrAQQDBgoFAQEBCxMJBwwFAQEDAQ4PAQEBAQECAwIBAQEDAgMHAwIFAwMHAwEFCgYBAgMBBw8JAQEBAQQFAVYCBAUJBAEDBwQECAQBBQgDAwUDAwcDAQIEAgIEAgECBAIBAgEBAQICAgEBAQEBAQEDAQIFAgEFCgYDAw8kFAEDA1aAMiMjMjIjIzIAAAAAAgAA/8AEAAPAAGYA8AAAEx4BFRQGByMOAQcjDgEVHAEVFBYHMBQxFBYzMR4BFxUeARUUBgc1DgEPAQ4BIyImJxcuASc1LgE1NDY3FT4BPwE+ATczPgE1PAE1PAE1MDQxNCYnMS4BJzUuATU0Njc1PgEzOgE5AQUXDgEHDgEHBiInJicuATU0NjcxNjc2MhceARceARcHMhYzMjM6ATMyFhcnHgEfAR4BFRwBFTEUFRQwFRQWMzEeAR8BHgEVFAYHNQ4BDwEOASMiJicXLgEnNS4BNTQ2Nwc+AT8BPgE3Mz4BNTA0OQEmNjU0NTA0MTQmJzEuASMwIjkBJiIHKgEjMa1GYj0vAgIFAwEEAwEBBQQqPQsDAwQDCjQkAQ4hEgwXCwEmOw8HBwEBBTUnAgQKBgEDAwUEJTcOBgchHBY4IAEBAZFDAgMBDRkMAwUCREMGBwcGQ0MDBQMMGg0BAQFCBAQCQ0MBAwEUJBABITELAQQFBQMiNQ8BCAkDBAo0IwEPIREMGAsCJzsPBggDAgEJMyQBBQoFAQMEAQERDgsbDwEkSSQCAwIDwAFjRjZWEwECAQEFBC1ZLSdPKAEEBg1AKgIJFQsMFwoBJzsPAQYHAwQBCzMjAQ8gEgYLBQEuRxIBAgQBAQUEGTQaOnU7AQQGAQszIwEOIREnQxcBEhbWQQMDAQ0ZDAMDQ0MGEAkJEAZEQwMDDRkNAQICQgEHCAEPNCIBDRwPAQEBvLwBAQQGCy0fARAlFA0XCwEnOw4BBgcDBAELMyQBDiESCRIJASk/EAECBAEBBAMBGzUbiYkCFCIMCQoBAQAAAAYAAP/ABNsDwAACAAUANwBEAGgAiwAAAQMhAQMhEw4BBxEhMhYdARQGIyEiJj0BNDYzIREuASchIiY9ATQ2MyE+ATMyFhchMhYdARQGIyEHMjY1NCYjIgYVFBYzARQHDgEHBiMiJy4BJyY1MTQ3PgE3Njc+ATMyFhcWFx4BFxYVIRQHDgEHBiMiJy4BJyY1MTQ3PgE3Njc+ATMyFhcWFx4BFxYD29sBt/xJ2wG2+ggkFwFcBwsLB/0ACAsLCAFbFyQI/ugICwsIARgMOCQkOAsBGQcLCwf+52cTGhoTExsbEwJtGhtPLC0jIi0sTxsbICBPJCQJBRIJChIECiQkTyAf/SUbG04tLCMjLC1OGxsgH08lJAkFEQoKEQUJJCVPHyACwP5uAZL+bgIAFyQI/R4KCCUHCwsHJQgKAuIIJBcKCCUHCyApKSALByUICgkaExMbGxMTGv4JLCAfKAkJCQkoHyAsCDw9kUBBEQgLCwgRQUCRPTwILCAfKAkJCQkoHyAsCDw9kUBBEQgLCwgRQUCRPTwABQAV/+ID1QOrADIATwBpAHcAgwAANyImNRE0NjsBNTQ2MzIWHQEhNTQ2MzIWHQEzMhYVERQGIyImPQEhERQWMyEyFhUUBiMhATU0JisBFRQGIyImPQEhFRQGIyImPQEjIgYdASETAy4BKwEiBgciBgcDBhQXHgEzITI2Nz4BNQE0NjMyFh0BFAYjIiY1FyImNTQ2MzIWFRQGVRknJxmWCwoKCwGADAoJDJUaJgsKCgv81QwJAVYJDAwJ/qoDFgwKlQwJCgz+gAsKCguWCQwDK2rZAwcDBAQCAwMCA9oDAwMIBgGvBggDAwH/AAwKCQwMCQoMFg0VEhAMFhaAJhoCVRomQAoMDApAQAoMDApAJhr+6woLCwpV/msKCwwKCQwCAJUKDGsKCwsKa2sKCwsKawwKlf2AAZoDBQEDBQT+ZwMLAwQFBQQGCQYBHgkMDAmACgsQCYASEBASEhAQEgAAAAEAAAABAAB4ko9/Xw889QALBAAAAAAA2nnG4wAAAADaecbj//v/wATbA8UAAAAIAAIAAAAAAAAAAQAAA8D/wAAABNv/+//+BNsAAQAAAAAAAAAAAAAAAAAAAFwEAAAAAAAAAAAAAAACAAAABAABdQQAAAAEAABVBAAAFQQAABUEAAABBAAAJAQAAAAEAAAABAAA1QQAAAsEAAAABAAAFQQAAAIEAAAABAAAFQQAAAAEAAAABAAAFQQAAAAEAAAABAAADQQAAAAEAAB1BAAAAAQAAAIEAAAABAAAAAQA//wEAP/8BAAAAAQAAAAEAAAmBAAAAAQAAAAEAAAABAAAAAQAAJ4EAAAJBAAABgQAASsEAAErBAABfAQAAAYEAABdBAAAXQQAAAAEAACqBAAABwQAAAcEAABVBAAAFQQAADsEAAAJBAAACQQAAAkEAAAJBAAACQQAAAkEAAAJBAAAVQQAAFUEAACABAAAAAQAAAkEAAAABAD/+wQAACwEAAAnBAAAAgQAAAAEAACrBAAAqwQAAKQEAABVBAAAAAQAABUEAABCBAAAMwQAAAAEAACABAAAFQQAAVUEAABVBAAAgAQAAAAE2wAABAAAFQAAAAAACgAUAB4AVAE0AZICTgP4BGQE7AWEBgwG2gdgCFgJiAsqC3wMtA0eDdQOfhAuEawS5hQoFRoWGBbMF64YlBk8GiIa+BywHTgdpB5uHvgfYh+iIAwgWCB0IIYgmCLsI1wjwCZYJqYm4CcaJ8goxCleKkQrJiwWLnwvmjB8MXIx5jJkM14z0DSiNN41ZDXcOJw5uDn6Ojg6bDqiO/I81j1UQjhD3ETaRWxF3kZgRxBIIklWSiBK0AAAAAEAAABcA7gAHQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAHAAAAAQAAAAAAAgAHAGAAAQAAAAAAAwAHADYAAQAAAAAABAAHAHUAAQAAAAAABQALABUAAQAAAAAABgAHAEsAAQAAAAAACgAaAIoAAwABBAkAAQAOAAcAAwABBAkAAgAOAGcAAwABBAkAAwAOAD0AAwABBAkABAAOAHwAAwABBAkABQAWACAAAwABBAkABgAOAFIAAwABBAkACgA0AKRpY29tb29uAGkAYwBvAG0AbwBvAG5WZXJzaW9uIDEuMABWAGUAcgBzAGkAbwBuACAAMQAuADBpY29tb29uAGkAYwBvAG0AbwBvAG5pY29tb29uAGkAYwBvAG0AbwBvAG5SZWd1bGFyAFIAZQBnAHUAbABhAHJpY29tb29uAGkAYwBvAG0AbwBvAG5Gb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA') format('woff'), url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22 %3E%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cmetadata%3EGenerated by IcoMoon%3C%2Fmetadata%3E%3Cdefs%3E%3Cfont id%3D%22icomoon%22 horiz-adv-x%3D%221024%22%3E%3Cfont-face units-per-em%3D%221024%22 ascent%3D%22960%22 descent%3D%22-64%22 %2F%3E%3Cmissing-glyph horiz-adv-x%3D%221024%22 %2F%3E%3Cglyph unicode%3D%22%26%23x20%3B%22 horiz-adv-x%3D%22512%22 d%3D%22%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe900%3B%22 glyph-name%3D%22menu-kebab%22 d%3D%22M650.667 821.333c0-76.583-62.083-138.667-138.667-138.667s-138.667 62.083-138.667 138.667c0 76.583 62.083 138.667 138.667 138.667s138.667-62.083 138.667-138.667zM650.667 448c0-76.583-62.083-138.667-138.667-138.667s-138.667 62.083-138.667 138.667c0 76.583 62.083 138.667 138.667 138.667s138.667-62.083 138.667-138.667zM650.667 74.667c0-76.583-62.083-138.667-138.667-138.667s-138.667 62.083-138.667 138.667c0 76.583 62.083 138.667 138.667 138.667s138.667-62.083 138.667-138.667z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe901%3B%22 glyph-name%3D%22load-balancer%22 d%3D%22M832-63.957c-35.285 0-64 28.715-64 64v128c0 35.285 28.715 64 64 64h41.685c-10.837 120.491-111.403 213.291-233.685 213.291h-106.667v-213.291h42.667c35.285 0 64-28.715 64-64v-128c0-35.285-28.715-64-64-64h-128c-35.285 0-64 28.715-64 64v128c0 35.285 28.715 64 64 64h42.667v213.291h-106.667c-122.283 0-222.848-92.8-233.685-213.291h41.685c35.285 0 64-28.715 64-64v-128c0-35.285-28.715-64-64-64h-128c-35.285 0-64 28.715-64 64v128c0 35.285 28.715 64 64 64h43.52c10.965 144.341 130.475 255.957 276.48 255.957h106.667v256.043h-42.667c-35.285 0-64 28.715-64 64v128c0 35.285 28.715 64 64 64h128c35.285 0 64-28.715 64-64v-128c0-35.285-28.715-64-64-64h-42.667v-256.043h106.667c146.005 0 265.515-111.616 276.437-255.957h43.563c35.285 0 64-28.715 64-64v-128c0-35.285-28.715-64-64-64h-128zM832 149.376c-11.776 0-21.333-9.557-21.333-21.333v-128c0-11.776 9.557-21.333 21.333-21.333h128c11.776 0 21.333 9.557 21.333 21.333v128c0 11.776-9.557 21.333-21.333 21.333h-63.104c-0.299-0.043-0.597-0.043-0.896-0.043s-0.597 0-0.896 0.043h-63.104zM448 149.376c-11.776 0-21.333-9.557-21.333-21.333v-128c0-11.776 9.557-21.333 21.333-21.333h128c11.776 0 21.333 9.557 21.333 21.333v128c0 11.776-9.557 21.333-21.333 21.333h-128zM64 149.376c-11.776 0-21.333-9.557-21.333-21.333v-128c0-11.776 9.557-21.333 21.333-21.333h128c11.776 0 21.333 9.557 21.333 21.333v128c0 11.776-9.557 21.333-21.333 21.333h-63.104c-0.299-0.043-0.597-0.043-0.896-0.043s-0.597 0-0.896 0.043h-63.104zM448 917.376c-11.776 0-21.333-9.557-21.333-21.333v-128c0-11.776 9.557-21.333 21.333-21.333h128c11.776 0 21.333 9.557 21.333 21.333v128c0 11.776-9.557 21.333-21.333 21.333h-128z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe902%3B%22 glyph-name%3D%22critical%22 d%3D%22M904.533 648.533l-362.667 196.267c-21.333 8.533-42.667 8.533-64 0l-358.4-196.267c-21.333-12.8-34.133-34.133-34.133-55.467v-89.6c0-12.8 4.267-25.6 17.067-29.867s25.6-4.267 38.4 0l362.667 196.267c4.267 0 12.8 0 17.067 0l362.667-196.267c12.8-8.533 25.6-8.533 38.4 0 12.8 4.267 17.067 17.067 17.067 29.867v89.6c0 21.333-12.8 42.667-34.133 55.467zM904.533 264.533l-362.667 196.267c-21.333 8.533-42.667 8.533-64 0l-362.667-196.267c-17.067-12.8-29.867-34.133-29.867-55.467v-89.6c0-12.8 4.267-25.6 17.067-29.867s25.6-4.267 38.4 0l362.667 196.267c4.267 0 12.8 0 17.067 0l362.667-196.267c12.8-8.533 25.6-8.533 38.4 0 12.8 4.267 17.067 17.067 17.067 29.867v89.6c0 21.333-12.8 42.667-34.133 55.467z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe903%3B%22 glyph-name%3D%22button-refresh-arrows%22 d%3D%22M511.8 20.8c-117.7 0-231.3 49.2-311.7 135.1-77.9 83.3-118.7 191.9-114.9 305.8 3.2 97.5 39.5 190.2 102.5 263.6h-145c-11.8 0-21.3 9.6-21.3 21.3s9.6 21.3 21.3 21.3h192c11.8 0 21.3-9.6 21.3-21.3v-192c0-11.8-9.6-21.4-21.3-21.4s-21.3 9.6-21.3 21.3v134.7c-52.6-64.7-82.7-145-85.5-229-3.4-102.5 33.3-200.2 103.4-275.1 72.3-77.3 174.6-121.6 280.5-121.6 0 0 0 0 0 0 73.4 0 145 21 207 60.7 3.5 2.2 7.4 3.4 11.5 3.4 7.3 0 14-3.7 18-9.8 6.4-9.9 3.5-23.1-6.4-29.5-68.9-44.1-148.5-67.5-230.1-67.5v0zM981.3 127.9h-192c-11.8 0-21.3 9.6-21.3 21.3v192c0 11.8 9.6 21.3 21.3 21.3 11.8 0 21.3-9.6 21.3-21.3v-134.9c52.7 64.7 82.9 145 85.7 229 3.5 102.5-33.2 200.2-103.2 275.2-72.3 77.3-174.7 121.7-280.9 121.7-72.6 0-143.4-20.5-204.8-59.3-3.4-2.2-7.4-3.3-11.4-3.3-7.4 0-14.1 3.7-18 9.9-6.3 9.9-3.3 23.2 6.7 29.4 68.2 43.1 146.9 65.9 227.6 65.9 118 0 231.7-49.3 312-135.3 77.8-83.1 118.5-191.7 114.7-305.5-3.3-97.5-39.5-190.1-102.6-263.4h144.9c11.8 0 21.3-9.6 21.3-21.3s-9.5-21.4-21.3-21.4v0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe904%3B%22 glyph-name%3D%22spel%22 d%3D%22M136.533 153.6v68.267c-21.333 4.267-42.667 8.533-64 17.067s-38.4 21.333-51.2 34.133l25.6 38.4c12.8-12.8 29.867-25.6 46.933-34.133s38.4-12.8 59.733-12.8c25.6 0 46.933 8.533 55.467 21.333 12.8 12.8 17.067 29.867 17.067 51.2 0 17.067-4.267 34.133-12.8 46.933s-21.333 21.333-34.133 29.867c-12.8 8.533-29.867 17.067-46.933 25.6s-29.867 17.067-46.933 29.867c-12.8 8.533-25.6 21.333-34.133 38.4s-12.8 29.867-12.8 51.2c0 29.867 8.533 55.467 25.6 76.8s42.667 34.133 72.533 38.4v68.267h42.667v-68.267c21.333-4.267 42.667-8.533 55.467-17.067 17.067-8.533 29.867-21.333 42.667-34.133l-29.867-34.133c-12.8 12.8-25.6 21.333-38.4 29.867-12.8 4.267-29.867 8.533-46.933 8.533-21.333 0-38.4-4.267-51.2-17.067s-17.067-25.6-17.067-46.933c0-17.067 4.267-29.867 12.8-42.667s21.333-21.333 34.133-29.867c12.8-8.533 29.867-17.067 46.933-21.333 17.067-8.533 34.133-17.067 46.933-25.6 12.8-12.8 25.6-25.6 34.133-38.4 8.533-17.067 12.8-34.133 12.8-59.733 0-34.133-8.533-59.733-29.867-81.067-17.067-21.333-46.933-34.133-76.8-38.4v-68.267h-38.4zM622.933 430.933l-25.6 21.333 38.4 64-68.267 25.6 12.8 34.133 68.267-17.067 4.267 72.533h34.133l4.267-72.533 76.8 17.067 8.533-29.867-68.267-25.6 38.4-64-25.6-21.333-46.933 55.467-51.2-59.733zM844.8 153.6v34.133h17.067c17.067 0 29.867 4.267 38.4 12.8 4.267 8.533 8.533 25.6 8.533 46.933s0 42.667 0 59.733c0 21.333 0 42.667 0 64s4.267 38.4 8.533 51.2c4.267 12.8 17.067 21.333 29.867 25.6v0c-12.8 4.267-25.6 12.8-29.867 25.6s-8.533 29.867-8.533 51.2c0 21.333 0 42.667 0 64s0 38.4 0 59.733c0 21.333-4.267 38.4-8.533 46.933s-17.067 12.8-38.4 12.8h-17.067v34.133h29.867c12.8 0 25.6 0 34.133-4.267s17.067-8.533 25.6-12.8c8.533-8.533 12.8-17.067 12.8-29.867 4.267-12.8 4.267-25.6 4.267-42.667 0-25.6 0-46.933-4.267-68.267 0-21.333-4.267-42.667-4.267-64 0-12.8 4.267-25.6 12.8-34.133 8.533-12.8 25.6-17.067 46.933-17.067v-34.133c-12.8 0-21.333 0-29.867-4.267s-12.8-8.533-17.067-12.8c-4.267-4.267-8.533-12.8-8.533-17.067s-4.267-12.8-4.267-21.333c0-12.8 0-21.333 0-34.133 0-8.533 0-21.333 0-29.867s0-21.333 0-34.133c0-12.8 0-21.333 0-34.133 0-17.067 0-34.133-4.267-42.667-4.267-12.8-8.533-21.333-12.8-29.867-8.533-8.533-17.067-12.8-25.6-12.8-8.533-4.267-21.333-4.267-34.133-4.267h-21.333zM494.933 742.4v-34.133h-17.067c-17.067 0-29.867-4.267-38.4-12.8-4.267-8.533-8.533-25.6-8.533-46.933s0-42.667 0-59.733c0-21.333 0-42.667 0-64s-4.267-38.4-8.533-51.2-12.8-21.333-29.867-25.6v0c12.8-4.267 25.6-12.8 29.867-25.6s8.533-29.867 8.533-51.2c0-21.333 0-42.667 0-64s0-38.4 0-59.733c0-21.333 4.267-38.4 8.533-46.933s17.067-12.8 38.4-12.8h17.067v-34.133h-29.867c-12.8 0-25.6 0-34.133 4.267s-17.067 8.533-25.6 12.8c-8.533 8.533-12.8 17.067-12.8 29.867-4.267 12.8-4.267 25.6-4.267 42.667 0 25.6 0 46.933 4.267 68.267 0 21.333 4.267 42.667 4.267 64 0 12.8-4.267 25.6-12.8 34.133-8.533 12.8-25.6 17.067-46.933 17.067v34.133c12.8 0 21.333 0 29.867 4.267s12.8 8.533 17.067 12.8c4.267 4.267 8.533 12.8 8.533 17.067s4.267 12.8 4.267 21.333c0 12.8 0 21.333 0 34.133 0 8.533 0 21.333 0 29.867s0 21.333 0 34.133c0 12.8 0 21.333 0 34.133 0 17.067 0 34.133 4.267 42.667s8.533 21.333 12.8 29.867c8.533 8.533 17.067 12.8 25.6 12.8 8.533 4.267 21.333 4.267 34.133 4.267h21.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe905%3B%22 glyph-name%3D%22pencil%22 d%3D%22M21.632-64c-5.632 0-11.093 2.261-15.104 6.229-5.76 5.76-7.723 14.123-5.163 21.803l90.496 271.531c0.213 0.597 0.597 1.451 0.896 2.005 0.853 2.005 2.133 3.968 3.712 5.675 0.128 0.128 0.256 0.299 0.384 0.427l672.555 672.597c28.203 27.264 65.024 42.197 103.808 42.197l2.773-0.043c39.893-0.683 77.099-16.896 104.832-45.568 56.192-58.197 56.192-149.333 0-207.488l-29.781-29.781c-0.213-0.256-0.427-0.469-0.64-0.683l-642.133-642.133c-0.427-0.427-0.896-0.811-1.408-1.195-1.493-1.237-3.072-2.219-4.779-3.029-0.043 0-0.128-0.043-0.213-0.085-0.512-0.299-1.28-0.683-2.304-0.981l-271.189-90.368c-2.133-0.725-4.395-1.109-6.741-1.109zM55.381-8.917l198.315 66.091-132.224 132.224-66.091-198.315zM293.205 77.995l611.968 611.968-150.869 150.869-611.968-611.968 150.869-150.869zM935.296 720.171l15.104 15.104c39.936 41.344 39.851 106.411-0.256 147.925-19.797 20.48-46.379 32.043-74.88 32.555h-1.92c-27.733 0-54.059-10.624-74.069-29.952l-14.805-14.805 150.827-150.827z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe906%3B%22 glyph-name%3D%22alert-triangle%22 d%3D%22M942.464-63.275c-1.792 0-3.627 0.085-5.419 0.341h-850.432c-1.749-0.213-3.499-0.299-5.248-0.299-22.528 0-41.515 16.085-45.099 38.272-1.835 11.307 0.597 22.784 6.869 32.341l430.549 861.013c12.416 24.875 30.805 27.52 38.144 27.52 9.131 0 26.197-3.584 38.144-27.52l430.549-861.056c13.269-20.181 8.192-47.872-11.477-62.037-7.808-5.589-16.981-8.576-26.581-8.576zM80.683-13.013c-0.512-0.981-1.067-1.963-1.749-2.859-0.512-0.725-0.683-1.451-0.555-2.219 0.256-1.536 1.621-2.475 2.816-2.475 1.664 0.256 2.816 0.341 3.968 0.341h853.333c1.152 0 2.304-0.085 3.456-0.299 0.128 0 0.213 0 0.341 0 0.853 0 1.323 0.171 1.792 0.512 1.323 0.939 1.621 2.773 0.683 4.096-0.64 0.853-1.237 1.835-1.749 2.859l-431.189 862.379-431.147-862.336zM511.829 214.229c-11.776 0-21.333 9.557-21.333 21.333v298.667c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-298.667c0-11.776-9.557-21.333-21.333-21.333zM512.427 107.563c-17.579 0.043-31.872 13.611-32.555 30.933-0.171 8.832 2.944 16.981 8.832 23.168s13.824 9.728 22.357 9.856c18.091-0.341 32.128-13.952 32.768-30.976 0.171-8.832-2.944-16.981-8.832-23.168s-13.824-9.685-22.357-9.856c-0.043 0.043-0.128 0.043-0.213 0.043 0 0 0 0 0 0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe907%3B%22 glyph-name%3D%22delete%22 d%3D%22M512-64c-135.723 0-263.595 52.736-360.192 148.523-0.555 0.384-1.152 0.853-1.792 1.493-0.469 0.469-1.067 1.195-1.536 1.92-95.531 95.915-148.48 224.043-148.48 360.064 0 282.325 229.675 512 512 512 135.723 0 263.595-52.736 360.235-148.523 0.512-0.341 1.152-0.853 1.792-1.451 0.427-0.427 0.939-1.067 1.365-1.707 95.829-96.64 148.608-224.555 148.608-360.32 0-282.325-229.675-512-512-512zM195.797 101.632c86.827-79.403 198.699-122.965 316.203-122.965 258.773 0 469.333 210.56 469.333 469.333 0 117.504-43.563 229.376-122.965 316.203l-662.571-662.571zM512 917.333c-258.773 0-469.333-210.56-469.333-469.333 0-117.504 43.563-229.376 122.965-316.203l662.571 662.571c-86.827 79.403-198.699 122.965-316.203 122.965z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe908%3B%22 glyph-name%3D%22bin%22 d%3D%22M192-64c-35.285 0-64 28.715-64 64v789.333h-106.667c-11.776 0-21.333 9.557-21.333 21.333s9.557 21.333 21.333 21.333h277.333v64c0 35.285 28.715 64 64 64h298.667c35.285 0 64-28.715 64-64v-64h277.333c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-106.667v-789.333c0-35.285-28.715-64-64-64h-640zM170.667 0c0-11.776 9.557-21.333 21.333-21.333h640c11.776 0 21.333 9.557 21.333 21.333v789.333h-682.667v-789.333zM682.667 832v64c0 11.776-9.557 21.333-21.333 21.333h-298.667c-11.776 0-21.333-9.557-21.333-21.333v-64h341.333zM320 128c-11.776 0-21.333 9.557-21.333 21.333v512c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-512c0-11.776-9.557-21.333-21.333-21.333zM512 128c-11.776 0-21.333 9.557-21.333 21.333v512c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-512c0-11.776-9.557-21.333-21.333-21.333zM704 128c-11.776 0-21.333 9.557-21.333 21.333v512c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-512c0-11.776-9.557-21.333-21.333-21.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe909%3B%22 glyph-name%3D%22sp-handle%22 d%3D%22M341.333 874.667c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM341.333 917.333c-72.533 0-128-55.467-128-128s55.467-128 128-128 128 55.467 128 128c0 72.533-55.467 128-128 128v0zM682.667 874.667c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM682.667 917.333c-72.533 0-128-55.467-128-128s55.467-128 128-128 128 55.467 128 128c0 72.533-55.467 128-128 128v0zM341.333 533.333c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM341.333 576c-72.533 0-128-55.467-128-128s55.467-128 128-128 128 55.467 128 128c0 72.533-55.467 128-128 128v0zM682.667 533.333c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM682.667 576c-72.533 0-128-55.467-128-128s55.467-128 128-128 128 55.467 128 128c0 72.533-55.467 128-128 128v0zM341.333 192c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM341.333 234.667c-72.533 0-128-55.467-128-128s55.467-128 128-128 128 55.467 128 128c0 72.533-55.467 128-128 128v0zM682.667 192c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM682.667 234.667c-72.533 0-128-55.467-128-128s55.467-128 128-128 128 55.467 128 128c0 72.533-55.467 128-128 128v0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe90a%3B%22 glyph-name%3D%22view-1%22 d%3D%22M512.043 277.333c-94.123 0-170.667 76.544-170.667 170.667s76.544 170.667 170.667 170.667 170.667-76.544 170.667-170.667-76.587-170.667-170.667-170.667zM512.043 576c-70.571 0-128-57.429-128-128s57.429-128 128-128c70.571 0 128 57.429 128 128s-57.429 128-128 128zM512.043 149.333c-244.053 0-445.483 207.104-501.376 270.592-13.952 16.043-13.952 40.107-0.085 56.107 55.936 63.488 257.408 270.635 501.461 270.635 243.797 0 445.099-206.72 501.205-270.379 0.085-0.085 0.171-0.171 0.256-0.299 13.867-15.957 13.867-40.021 0-55.979-55.979-63.531-257.451-270.677-501.461-270.677zM512.043 704c-226.133 0-416.469-196.011-469.376-256.128 52.949-59.861 243.2-255.872 469.376-255.872 226.133 0 416.427 196.011 469.376 256.128-52.992 59.861-243.285 255.872-469.376 255.872z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe90b%3B%22 glyph-name%3D%22cloud-loading%22 d%3D%22M1013.333 554.795v0 0zM191.104 320.128c-8.96 0-88.917 1.536-142.933 54.741-31.957 31.488-48.171 74.112-48.171 126.592 0 12.501 1.323 25.045 3.883 37.248 9.941 47.403 37.76 88.107 78.336 114.603 29.611 19.328 63.787 29.568 98.773 29.568 4.693 0 9.429-0.171 14.165-0.555 14.080 107.093 82.517 201.216 180.651 247.424 43.136 20.309 88.875 30.635 135.936 30.635 36.779 0 73.216-6.4 108.331-19.029 75.776-27.264 137.6-81.152 174.805-152.192 127.317-3.115 229.248-107.093 229.163-234.368 0-204.971-208.469-234.197-210.603-234.496-0.853-0.128-1.792-0.171-2.731-0.171h-619.605zM181.077 640.171c-26.752 0-52.864-7.808-75.52-22.613-31.019-20.224-52.309-51.371-59.947-87.637-1.963-9.301-2.944-18.901-2.944-28.459 0-40.661 11.947-73.003 35.456-96.213 42.624-41.984 110.208-42.496 113.067-42.496h617.984c20.864 3.157 172.16 31.445 172.16 192.043 0.043 51.115-19.883 99.2-56.107 135.467s-84.267 56.235-135.381 56.277h-1.707c-1.92 0-3.755-0.085-5.632-0.171 0 0-0.043 0-0.043 0-9.045 0-16.64 4.821-20.096 12.245-45.44 96.469-143.915 158.848-250.88 158.848-40.832 0-80.341-8.875-117.504-26.368-91.819-43.221-152.491-132.992-158.421-234.283-0.384-6.229-3.413-11.947-8.363-15.701-3.669-2.859-8.277-4.395-12.885-4.395-1.493 0-3.029 0.171-4.48 0.469-9.472 2.005-19.157 2.987-28.757 2.987zM192-63.872c-19.371 0-38.272 3.712-56.235 11.051-0.384 0.085-0.725 0.213-1.067 0.341-0.384 0.171-0.811 0.341-1.195 0.555-55.339 23.808-90.837 77.525-90.837 137.387 0 82.347 66.987 149.333 149.333 149.333h640c82.347 0 149.333-66.987 149.333-149.333s-66.987-149.333-149.333-149.333h-640zM832-21.205c58.795 0 106.667 47.872 106.667 106.667s-47.872 106.667-106.667 106.667h-189.056l-88.363-213.333h277.419zM508.416-21.205l88.363 213.333h-81.835l-88.363-213.333h81.835zM380.416-21.205l88.363 213.333h-81.835l-88.363-213.333h81.835zM171.435-19.2c6.741-1.323 13.653-2.005 20.565-2.005h60.416l88.363 213.333h-81.835l-87.509-211.328zM192 192.128c-58.837 0-106.667-47.872-106.667-106.667 0-35.584 17.664-68.395 46.763-88.149l80.683 194.816h-20.779z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe90c%3B%22 glyph-name%3D%22cloud-check%22 d%3D%22M149.376 328.533c-1.493 0-3.029 0.171-4.565 0.469-75.648 16.555-127.573 84.693-123.435 162.005 0.213 10.752 1.536 22.016 3.968 33.109 9.941 45.227 36.907 83.883 75.904 108.8 27.947 17.877 60.16 27.349 93.099 27.349 4.693 0 9.429-0.213 14.165-0.597 22.315 147.627 149.547 257.664 300.288 257.664h3.499l1.579-10.667v10.667c110.464 0 215.253-62.037 268.843-158.592 119.723-1.237 218.197-99.029 219.947-219.051 2.56-82.176-44.16-157.781-119.040-192.427-2.773-1.323-5.803-2.005-8.96-2.005v0c-8.277 0-15.872 4.864-19.371 12.416-2.389 5.163-2.645 10.965-0.64 16.299 1.963 5.333 5.888 9.6 11.093 11.989 59.307 27.435 96.341 87.381 94.293 152.704-1.451 97.877-82.048 177.365-179.627 177.365h-2.688c-2.219-0.043-4.437-0.128-6.656-0.213 0 0-0.043 0-0.085 0-9.216 0-16.555 4.523-20.139 11.819-44.331 89.344-137.045 147.029-236.117 147.029h-6.016c-135.765 0-250.069-105.813-260.224-240.939-0.469-6.144-3.584-11.819-8.533-15.488-3.712-2.731-8.107-4.224-12.715-4.224-1.536 0-3.072 0.171-4.523 0.469-9.387 2.091-18.901 3.115-28.373 3.115-24.747 0-48.981-7.125-70.101-20.651-29.397-18.816-49.707-47.915-57.173-82.005-1.835-8.363-2.859-16.939-3.029-25.515-3.029-56.917 34.773-106.709 89.899-118.784 11.477-2.517 18.773-13.909 16.299-25.387-2.176-9.685-10.923-16.725-20.864-16.725zM512-21.376c-152.917 0-277.333 124.416-277.333 277.333s124.416 277.333 277.333 277.333c152.917 0 277.333-124.416 277.333-277.333s-124.373-277.333-277.333-277.333zM512 490.624c-129.408 0-234.667-105.259-234.667-234.667s105.259-234.667 234.667-234.667 234.667 105.259 234.667 234.667-105.259 234.667-234.667 234.667zM476.715 130.987c-11.605 0-22.656 3.669-31.957 10.667-2.005 1.493-3.883 3.115-5.632 4.907l-64.043 64.043c-4.011 4.011-6.229 9.387-6.229 15.104s2.219 11.051 6.229 15.104 9.387 6.229 15.104 6.229 11.051-2.219 15.104-6.229l64-64c0.341-0.341 0.768-0.683 1.195-1.024 1.835-1.365 4.011-2.091 6.357-2.091 3.413 0 6.528 1.536 8.533 4.267l123.733 165.291c4.011 5.333 10.411 8.533 17.109 8.533 4.651 0 9.045-1.493 12.8-4.267 9.387-7.040 11.307-20.437 4.267-29.867l-123.733-165.291c-10.112-13.44-26.069-21.376-42.837-21.376z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe90d%3B%22 glyph-name%3D%22maps-mark%22 d%3D%22M276.864 1.451c-5.248 0-10.496 0.64-15.573 1.92l-210.944 52.736c-29.824 7.467-50.133 35.115-48.341 65.792l38.059 701.44c0.256 4.523 0.981 9.003 2.176 13.355 7.552 27.733 32.981 47.147 61.781 47.147 5.675 0 11.307-0.768 16.811-2.261l171.691-46.848c1.835-0.512 3.755-0.768 5.632-0.768 2.048 0 4.053 0.299 6.016 0.896l189.483 56.832c5.973 1.749 12.16 2.688 18.347 2.688s12.373-0.896 18.389-2.688l189.483-57.088c2.005-0.597 4.053-0.896 6.101-0.896 1.877 0 3.755 0.256 5.547 0.768l171.947 46.933c4.395 1.195 8.875 1.92 13.355 2.176 1.152 0.043 2.261 0.085 3.371 0.085 15.872 0 31.104-5.803 42.837-16.341 12.757-11.435 20.267-27.093 21.205-44.16l37.888-701.44c1.621-30.549-18.731-58.112-48.427-65.536l-211.072-52.736c-5.035-1.28-10.283-1.92-15.573-1.92-5.675 0-11.307 0.768-16.811 2.219l-212.736 57.984c-1.835 0.512-3.712 0.768-5.589 0.768-1.92 0-3.797-0.256-5.632-0.768l-212.693-57.984c-5.419-1.536-11.051-2.304-16.725-2.304zM511.957 105.131c5.675 0 11.349-0.768 16.811-2.261l212.693-57.984c1.792-0.469 3.669-0.725 5.589-0.725 1.749 0 3.541 0.213 5.248 0.64l211.072 52.736c9.899 2.475 16.683 11.648 16.128 21.845l-37.888 701.44c-0.299 5.675-2.816 10.88-7.040 14.72-3.883 3.499-9.003 5.419-14.379 5.419l-1.109-0.043c-1.408-0.085-2.944-0.341-4.437-0.725l-171.861-46.933c-5.461-1.493-11.136-2.261-16.853-2.261-6.229 0-12.459 0.896-18.432 2.731l-189.397 57.088c-1.963 0.555-4.011 0.896-6.101 0.896s-4.139-0.299-6.144-0.896l-189.355-56.832c-5.931-1.792-12.117-2.688-18.347-2.688-5.717 0-11.392 0.768-16.896 2.304l-171.648 46.805c-1.877 0.512-3.755 0.768-5.632 0.768-9.6 0-18.048-6.443-20.565-15.701-0.427-1.493-0.64-2.987-0.725-4.48 0 0-38.101-701.611-38.101-701.696-0.512-10.155 6.229-19.328 16.085-21.803l210.987-52.736c1.707-0.427 3.456-0.64 5.205-0.64 1.92 0 3.797 0.256 5.589 0.725l212.651 57.984c5.504 1.536 11.179 2.304 16.853 2.304zM832.043 448.213c-5.717 0-11.051 2.219-15.104 6.229l-70.229 70.229-70.229-70.229c-4.011-4.011-9.387-6.229-15.104-6.229s-11.051 2.219-15.104 6.229-6.229 9.387-6.229 15.104 2.219 11.051 6.229 15.104l70.229 70.229-70.229 70.229c-4.011 4.011-6.229 9.387-6.229 15.104s2.219 11.051 6.229 15.104 9.387 6.229 15.104 6.229 11.051-2.219 15.104-6.229l70.229-70.229 70.229 70.229c4.011 4.011 9.387 6.229 15.104 6.229s11.051-2.219 15.104-6.229 6.229-9.387 6.229-15.104-2.219-11.051-6.229-15.104l-70.229-70.229 70.229-70.229c4.011-4.011 6.229-9.387 6.229-15.104s-2.219-11.051-6.229-15.104-9.387-6.229-15.104-6.229zM170.667 405.547c-9.941 0-18.475 6.741-20.736 16.427-1.323 5.547-0.384 11.264 2.603 16.128s7.68 8.235 13.227 9.557l67.541 16c1.621 0.384 3.243 0.555 4.907 0.555 9.941 0 18.475-6.741 20.779-16.427 1.323-5.547 0.384-11.264-2.603-16.128s-7.68-8.235-13.227-9.557l-67.541-16c-1.621-0.341-3.285-0.555-4.949-0.555zM362.709 320.213c-7.168 0-13.781 3.541-17.749 9.515l-32.811 49.237c-3.157 4.736-4.267 10.453-3.157 16 1.109 5.589 4.352 10.411 9.088 13.568 3.499 2.347 7.595 3.584 11.819 3.584 7.168 0 13.781-3.541 17.749-9.515l32.811-49.237c3.157-4.736 4.267-10.453 3.157-16-1.109-5.589-4.352-10.411-9.088-13.568-3.541-2.347-7.637-3.584-11.819-3.584zM448 234.88c-11.776 0-21.333 9.557-21.333 21.333s9.557 21.333 21.333 21.333h64c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-64zM576 298.88c-5.717 0-11.051 2.219-15.104 6.229s-6.229 9.429-6.229 15.104 2.219 11.051 6.229 15.104l42.667 42.667c4.011 4.011 9.387 6.229 15.104 6.229s11.051-2.219 15.104-6.229 6.229-9.387 6.229-15.104-2.219-11.051-6.229-15.104l-42.667-42.667c-4.053-4.011-9.387-6.229-15.104-6.229z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe90e%3B%22 glyph-name%3D%22arrow-button-down%22 d%3D%22M10.624 652.512l468.64-532.096c8.288-8.64 19.936-14.016 32.832-14.016s24.544 5.376 32.832 13.984v0l468.448 532.096c6.592 7.392 10.624 17.216 10.624 27.968 0 12.992-5.888 24.608-15.104 32.32l-0.064 0.064-78.944 66.432c-7.584 6.432-17.472 10.336-28.288 10.336-13.184 0-24.992-5.824-33.024-15.008l-0.032-0.064-348.384-403.328c-1.952-2.272-4.864-3.712-8.096-3.712s-6.112 1.44-8.064 3.712v0l-348.512 403.36c-7.36 8.384-17.824 13.888-29.568 14.752h-0.128c-1.12 0.096-2.464 0.16-3.776 0.16-10.656 0-20.416-3.904-27.872-10.368l0.064 0.032-78.976-66.336c-8.576-7.104-14.24-17.408-15.168-29.088v-0.16c-0.064-0.96-0.128-2.048-0.128-3.168 0-10.752 4.064-20.576 10.784-28l-0.032 0.032z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe90f%3B%22 glyph-name%3D%22cloud-remove%22 d%3D%22M149.333 328.533c-1.536 0-3.072 0.171-4.565 0.469-75.648 16.555-127.531 84.693-123.435 162.005 0.213 10.752 1.536 22.016 3.968 33.109 9.941 45.227 36.907 83.84 75.861 108.757 27.989 17.877 60.16 27.349 93.099 27.349 4.693 0 9.472-0.213 14.208-0.597 22.272 147.627 149.291 257.664 299.691 257.664h5.717c110.421 0 215.211-62.037 268.8-158.549 119.723-1.28 218.197-99.029 219.947-219.051 2.603-82.219-44.117-157.781-119.040-192.427-2.816-1.323-5.845-1.963-8.96-1.963 0 0 0 0 0 0-8.277 0-15.872 4.864-19.328 12.373-2.389 5.163-2.645 10.965-0.683 16.341 1.963 5.333 5.888 9.6 11.093 11.989 59.349 27.435 96.341 87.381 94.293 152.747-1.451 97.877-82.048 177.365-179.627 177.365h-2.688c-2.261-0.043-4.48-0.128-6.699-0.213 0 0-0.043 0-0.085 0-9.173 0-16.469 4.523-20.096 11.776-44.288 89.301-137.387 146.987-237.099 146.987h-5.035c-135.765 0-250.027-105.813-260.224-240.939-0.427-6.144-3.541-11.819-8.491-15.488-3.712-2.731-8.107-4.224-12.715-4.224-1.536 0-3.072 0.171-4.565 0.512-9.387 2.048-18.944 3.072-28.373 3.072-24.747 0-48.981-7.125-70.059-20.651-29.397-18.773-49.707-47.872-57.216-81.963-1.835-8.363-2.859-16.939-3.029-25.515-3.029-56.917 34.773-106.709 89.899-118.784 5.547-1.237 10.325-4.523 13.397-9.344s4.096-10.496 2.901-16.085c-2.133-9.685-10.88-16.725-20.864-16.725zM512-21.333c-152.917 0-277.333 124.416-277.333 277.333s124.416 277.333 277.333 277.333 277.333-124.416 277.333-277.333-124.416-277.333-277.333-277.333zM512 490.667c-129.408 0-234.667-105.259-234.667-234.667s105.301-234.667 234.667-234.667c129.408 0 234.667 105.259 234.667 234.667s-105.259 234.667-234.667 234.667zM602.496 144.171c-5.717 0-11.051 2.219-15.104 6.229l-75.392 75.435-75.392-75.435c-4.011-4.011-9.387-6.229-15.104-6.229s-11.051 2.219-15.104 6.229c-8.32 8.32-8.32 21.845 0 30.165l75.392 75.435-75.392 75.435c-8.32 8.32-8.32 21.845 0 30.165 4.011 4.011 9.387 6.229 15.104 6.229s11.051-2.219 15.104-6.229l75.392-75.435 75.392 75.435c4.011 4.011 9.387 6.229 15.104 6.229v0c5.717 0 11.051-2.219 15.104-6.229 8.32-8.32 8.32-21.845 0-30.165l-75.435-75.435 75.435-75.435c8.32-8.32 8.32-21.845 0-30.165-4.053-4.011-9.387-6.229-15.104-6.229z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe910%3B%22 glyph-name%3D%22sitemap%22 d%3D%22M976 192h-16v208c0 61.76-50.24 112-112 112h-272v128h16c26.389 0 48 21.611 48 48v160c0 26.411-21.611 48-48 48h-160c-26.389 0-48-21.589-48-48v-160c0-26.389 21.611-48 48-48h16v-128h-272c-61.76 0-112-50.24-112-112v-208h-16c-26.389 0-48-21.611-48-48v-160c0-26.389 21.611-48 48-48h160c26.411 0 48 21.611 48 48v160c0 26.389-21.589 48-48 48h-16v192h256v-192h-16c-26.389 0-48-21.611-48-48v-160c0-26.389 21.611-48 48-48h160c26.389 0 48 21.611 48 48v160c0 26.389-21.611 48-48 48h-16v192h256v-192h-16c-26.389 0-48-21.611-48-48v-160c0-26.389 21.611-48 48-48h160c26.389 0 48 21.611 48 48v160c0 26.389-21.611 48-48 48z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe911%3B%22 glyph-name%3D%22spinner%22 d%3D%22M512 960c-282.773 0-512-229.227-512-512s229.227-512 512-512 512 229.227 512 512-229.227 512-512 512zM512 704c141.376 0 256-114.624 256-256s-114.624-256-256-256-256 114.624-256 256 114.624 256 256 256zM817.472 142.528c-81.6-81.6-190.080-126.528-305.472-126.528s-223.872 44.928-305.472 126.528-126.528 190.080-126.528 305.472c0 115.392 44.928 223.872 126.528 305.472l67.883-67.883c0 0 0 0 0 0-131.008-131.008-131.008-344.171 0-475.179 63.467-63.467 147.84-98.411 237.589-98.411s174.123 34.944 237.589 98.411c131.008 131.008 131.008 344.171 0 475.179l67.883 67.883c81.6-81.6 126.528-190.080 126.528-305.472s-44.928-223.872-126.528-305.472z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe912%3B%22 glyph-name%3D%22navigation-left-circle%22 d%3D%22M512-42.581c-270.549 0-490.667 220.117-490.667 490.667s220.117 490.667 490.667 490.667 490.667-220.117 490.667-490.667-220.117-490.667-490.667-490.667zM512 896.085c-247.040 0-448-200.96-448-448s200.96-448 448-448c247.040 0 448 200.96 448 448s-200.96 448-448 448zM704 213.333c-11.776 0-21.333 9.557-21.333 21.333 0 11.093 8.491 20.224 19.328 21.248 9.6 7.467 40.107 62.080 40.107 124.715 0 26.795-6.059 48.725-17.536 63.445-13.056 16.768-34.347 25.259-63.232 25.259h-353.749l91.52-91.52c8.32-8.32 8.32-21.845 0-30.165-4.053-4.011-9.387-6.229-15.104-6.229s-11.051 2.219-15.104 6.229l-127.744 127.744c-2.048 1.92-3.797 4.48-4.949 7.339-0.64 1.579-0.811 2.944-0.896 3.627-0.213 0.768-0.64 2.304-0.64 4.309 0 0.171 0 0.384 0 0.555 0.085 5.504 2.304 10.709 6.229 14.635l128 128c4.053 4.011 9.387 6.229 15.104 6.229s11.051-2.219 15.104-6.272c8.32-8.32 8.32-21.845 0-30.165l-91.691-91.648h353.92c42.667 0 75.264-14.037 96.853-41.685 17.365-22.272 26.581-53.291 26.581-89.685 0-65.792-34.688-167.296-80.768-167.296z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe913%3B%22 glyph-name%3D%22file-json%22 d%3D%22M853.333 721.067c-17.067 119.467-110.933 217.6-230.4 234.667 0 0-4.267 0-4.267 0s0 0 0 0c-12.8 4.267-29.867 4.267-42.667 4.267h-512c-34.133 0-64-29.867-64-64v-682.667c0-12.8 8.533-21.333 21.333-21.333s21.333 8.533 21.333 21.333v682.667c0 12.8 8.533 21.333 21.333 21.333h512c8.533 0 12.8 0 21.333 0v-149.333c0-34.133 29.867-64 64-64h149.333v-277.333c0-12.8 8.533-21.333 21.333-21.333s21.333 8.533 21.333 21.333v281.6c0 4.267 0 8.533 0 12.8zM640 768v140.8c76.8-21.333 140.8-81.067 162.133-162.133h-140.8c-12.8 0-21.333 8.533-21.333 21.333zM102.4-55.467c-21.333 0-34.133 4.267-51.2 12.8-12.8 8.533-25.6 21.333-34.133 34.133l34.133 25.6c4.267-8.533 12.8-17.067 21.333-21.333s17.067-8.533 25.6-8.533c12.8 0 21.333 4.267 29.867 12.8s8.533 21.333 8.533 42.667v187.733h51.2v-192c0-12.8 0-25.6-4.267-34.133-4.267-12.8-8.533-21.333-12.8-29.867-8.533-8.533-17.067-17.067-25.6-21.333s-29.867-8.533-42.667-8.533zM337.067-55.467c-17.067 0-38.4 4.267-55.467 8.533-17.067 8.533-34.133 17.067-46.933 29.867l29.867 38.4c8.533-8.533 21.333-17.067 34.133-21.333s25.6-8.533 38.4-8.533c17.067 0 29.867 4.267 38.4 8.533s8.533 12.8 8.533 25.6c0 4.267 0 8.533-4.267 12.8s-4.267 8.533-8.533 8.533-8.533 4.267-12.8 8.533c-4.267 4.267-8.533 8.533-17.067 8.533l-38.4 17.067c-8.533 4.267-12.8 8.533-21.333 8.533-8.533 4.267-12.8 8.533-17.067 17.067-4.267 4.267-8.533 12.8-12.8 21.333s-4.267 17.067-4.267 25.6c0 12.8 4.267 21.333 8.533 29.867s12.8 17.067 21.333 25.6 17.067 12.8 29.867 17.067c8.533 8.533 21.333 8.533 34.133 8.533 17.067 0 29.867-4.267 46.933-8.533s29.867-17.067 38.4-25.6l-25.6-29.867c-8.533 8.533-17.067 12.8-29.867 17.067s-17.067 4.267-29.867 4.267c-12.8 0-25.6-4.267-34.133-8.533-4.267-4.267-8.533-12.8-8.533-25.6 0-4.267 0-8.533 4.267-12.8s4.267-8.533 8.533-8.533 8.533-4.267 12.8-8.533c4.267-4.267 12.8-4.267 17.067-8.533l38.4-17.067c8.533-4.267 17.067-8.533 21.333-12.8 8.533-4.267 12.8-8.533 17.067-17.067 4.267-4.267 8.533-12.8 12.8-21.333s4.267-17.067 4.267-25.6c0-12.8-4.267-21.333-8.533-34.133 0-4.267-8.533-12.8-17.067-21.333s-17.067-12.8-29.867-17.067-29.867-8.533-42.667-8.533zM593.067-55.467c-17.067 0-34.133 4.267-51.2 8.533-17.067 8.533-29.867 17.067-38.4 29.867s-21.333 29.867-25.6 46.933c-4.267 17.067-8.533 38.4-8.533 59.733s4.267 42.667 8.533 59.733c4.267 17.067 12.8 34.133 25.6 46.933s25.6 21.333 38.4 29.867c17.067 8.533 29.867 8.533 51.2 8.533 17.067 0 34.133-4.267 51.2-8.533s29.867-17.067 38.4-29.867c12.8-12.8 21.333-25.6 25.6-46.933 4.267-17.067 8.533-38.4 8.533-59.733s-4.267-42.667-8.533-59.733c-4.267-17.067-12.8-34.133-25.6-46.933s-25.6-21.333-38.4-29.867c-12.8-4.267-29.867-8.533-51.2-8.533zM593.067-12.8c12.8 0 21.333 4.267 29.867 8.533s17.067 12.8 21.333 21.333c4.267 8.533 12.8 21.333 12.8 34.133s4.267 25.6 4.267 42.667c0 29.867-8.533 55.467-21.333 72.533s-29.867 25.6-51.2 25.6-38.4-8.533-51.2-25.6c-12.8-17.067-21.333-42.667-21.333-72.533 0-17.067 0-29.867 4.267-42.667s8.533-21.333 12.8-34.133c4.267-8.533 12.8-17.067 21.333-21.333 21.333-4.267 29.867-8.533 38.4-8.533zM934.4 230.4h46.933v-277.333h-51.2l-106.667 196.267c0-12.8 0-196.267 0-196.267h-46.933v277.333h51.2l110.933-209.067z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe914%3B%22 glyph-name%3D%22network-good%22 d%3D%22M482.133-64c-174.933 8.533-332.8 106.667-418.133 260.267-4.267 4.267-4.267 4.267-4.267 8.533-42.667 76.8-64 166.4-59.733 256v8.533c4.267 93.867 34.133 179.2 85.333 256 0 4.267 4.267 4.267 4.267 8.533 89.6 128 230.4 209.067 384 217.6v0c12.8 0 21.333 0 34.133 0 8.533 0 17.067 0 25.6 0 238.933-12.8 435.2-187.733 477.867-422.4 0-4.267 0-12.8-4.267-17.067s-8.533-8.533-12.8-8.533h-4.267c-8.533 0-21.333 8.533-21.333 17.067-4.267 72.533-29.867 132.267-64 183.467h-192c12.8-38.4 25.6-81.067 34.133-123.733 0-12.8-4.267-21.333-17.067-25.6h-4.267c-8.533 0-21.333 8.533-21.333 17.067-8.533 46.933-21.333 89.6-34.133 132.267h-315.733c-25.6-68.267-42.667-140.8-42.667-213.333h157.867c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.333-21.333-21.333h-157.867c4.267-68.267 17.067-140.8 42.667-213.333h51.2c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.333-21.333-21.333h-34.133c29.867-72.533 76.8-149.333 128-221.867v-4.267c0 0 0 0 0-4.267v-4.267c0 0 0 0 0-4.267v0c0 0 0 0 0-4.267v-4.267c0 0 0 0 0-4.267s0 0-4.267-4.267v0h-4.267c0 0 0 0-8.533 0 8.533 0 4.267 0 0 0 4.267 0 0 0 0 0zM119.467 192c72.533-110.933 192-187.733 320-209.067-46.933 68.267-85.333 136.533-110.933 209.067h-209.067zM311.467 234.667c-25.6 72.533-38.4 145.067-42.667 213.333h-226.133c0-72.533 17.067-149.333 51.2-213.333h217.6zM268.8 490.667c0 72.533 17.067 145.067 42.667 213.333h-192c-42.667-64-68.267-136.533-72.533-213.333h221.867zM874.667 746.667c-68.267 85.333-170.667 145.067-277.333 162.133 42.667-51.2 72.533-102.4 98.133-162.133h179.2zM648.533 746.667c-29.867 64-68.267 119.467-115.2 170.667-8.533 0-12.8 0-21.333 0s-12.8 0-21.333 0c-46.933-55.467-85.333-110.933-115.2-170.667h273.067zM328.533 746.667c25.6 55.467 59.733 110.933 98.133 162.133-106.667-17.067-204.8-76.8-277.333-162.133h179.2zM746.667-64c-153.6 0-277.333 123.733-277.333 277.333s123.733 277.333 277.333 277.333 277.333-123.733 277.333-277.333-123.733-277.333-277.333-277.333zM746.667 448c-128 0-234.667-106.667-234.667-234.667s106.667-234.667 234.667-234.667 234.667 106.667 234.667 234.667-106.667 234.667-234.667 234.667zM708.267 93.867c-8.533-4.267-21.333-4.267-29.867 4.267l-85.333 85.333c-8.533 8.533-8.533 21.333 0 29.867s21.333 8.533 29.867 0l76.8-72.533 166.4 166.4c8.533 8.533 21.333 8.533 29.867 0s8.533-21.333 0-29.867c0 0-157.867-157.867-187.733-183.467z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe915%3B%22 glyph-name%3D%22earth-warning%22 d%3D%22M981.333 0l-217.6 409.6c-4.267 4.267-8.533 8.533-12.8 8.533h-4.267c-4.267 0-4.267 0-8.533-4.267-4.267 0-4.267-4.267-8.533-8.533l-217.6-409.6c-4.267-4.267-4.267-12.8 0-17.067s8.533-8.533 17.067-8.533h430.933c8.533 0 12.8 4.267 17.067 8.533 4.267 8.533 4.267 12.8 4.267 21.333zM725.333 285.867c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-128c0-12.8-8.533-21.333-21.333-21.333s-21.333 12.8-21.333 25.6v123.733zM746.667 34.133c-17.067 0-34.133 12.8-34.133 34.133s12.8 34.133 34.133 34.133c17.067 0 34.133-12.8 34.133-34.133s-17.067-34.133-34.133-34.133zM405.333-51.2h-4.267c-21.333 4.267-42.667 12.8-64 21.333v0c-230.4 85.333-366.933 324.267-324.267 567.467v4.267c0 8.533 4.267 12.8 4.267 21.333 46.933 230.4 256 396.8 494.933 396.8 38.4 0 76.8-4.267 110.933-12.8 132.267-29.867 247.467-110.933 320-226.133s98.133-251.733 68.267-388.267c-8.533-29.867-17.067-59.733-29.867-85.333 0-8.533-8.533-12.8-17.067-12.8-4.267 0-4.267 0-8.533 0-12.8 4.267-17.067 17.067-12.8 29.867 12.8 25.6 21.333 51.2 25.6 81.067 25.6 123.733 4.267 247.467-59.733 354.133-17.067 25.6-34.133 46.933-55.467 68.267h-238.933c-21.333 0-38.4-8.533-51.2-21.333s-21.333-34.133-21.333-51.2c0-42.667 34.133-72.533 72.533-76.8h17.067c51.2 0 98.133-25.6 123.733-68.267l4.267-8.533c8.533 0 8.533-8.533 8.533-12.8s-4.267-8.533-8.533-12.8-8.533-4.267-12.8-4.267c-8.533 0-12.8 4.267-17.067 8.533l-4.267 8.533c-21.333 29.867-55.467 46.933-89.6 46.933h-17.067c-64 0-115.2 51.2-115.2 115.2 0 29.867 12.8 59.733 34.133 81.067s51.2 34.133 81.067 34.133h192c-55.467 46.933-123.733 76.8-196.267 93.867-34.133 12.8-68.267 17.067-102.4 17.067-217.6 0-409.6-153.6-456.533-362.667h234.667c38.4 0 76.8-17.067 106.667-42.667l46.933-46.933c55.467-55.467 59.733-145.067 4.267-204.8l-59.733-68.267c-17.067-21.333-25.6-42.667-25.6-72.533v-119.467c17.067-4.267 29.867-8.533 46.933-12.8 12.8-4.267 17.067-12.8 17.067-25.6-4.267-8.533-12.8-12.8-21.333-12.8zM46.933 512c-29.867-204.8 85.333-409.6 273.067-490.667v102.4c0 38.4 12.8 72.533 38.4 98.133l59.733 64c38.4 42.667 34.133 106.667-4.267 145.067l-46.933 46.933c-21.333 21.333-46.933 29.867-76.8 29.867 0 4.267-243.2 4.267-243.2 4.267z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe916%3B%22 glyph-name%3D%22lab-tubes%22 d%3D%22M192 42.667c-105.856 0-192 86.144-192 192v426.667c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-106.667h42.667v256c0 23.509 19.157 42.667 42.667 42.667h170.667c23.509 0 42.667-19.157 42.667-42.667v-256h42.667v256c0 23.509 19.157 42.667 42.667 42.667h170.667c23.552 0 42.667-19.157 42.667-42.667v-256h42.667v256c0 23.509 19.115 42.667 42.667 42.667h170.667c23.552 0 42.667-19.157 42.667-42.667v-256h42.667v106.667c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-426.667c0-105.856-86.144-192-192-192h-640zM42.667 234.667c0-82.347 66.987-149.333 149.333-149.333h640c82.347 0 149.333 66.987 149.333 149.333v277.333h-42.667v-170.667c0-34.176-13.312-66.304-37.461-90.496-24.192-24.192-56.32-37.504-90.539-37.504-4.395 0-8.789 0.213-13.184 0.683-67.029 9.301-116.224 66.816-114.816 133.845v164.139h-42.667v-170.667c0-34.176-13.312-66.304-37.461-90.496-24.192-24.192-56.32-37.504-90.539-37.504-4.395 0-8.789 0.213-13.184 0.683-66.987 9.259-116.181 66.816-114.816 133.803v164.181h-42.667v-170.667c0-34.176-13.312-66.347-37.461-90.496-24.192-24.192-56.32-37.504-90.539-37.504-4.395 0-8.789 0.213-13.184 0.683-66.987 9.259-116.181 66.816-114.816 133.803v164.181h-42.667v-277.333zM725.333 347.392c-0.939-45.739 32.256-84.779 77.269-91.051 2.176-0.213 5.12-0.341 8.064-0.341 22.784 0 44.203 8.875 60.331 25.003 16.128 16.085 25.003 37.547 25.003 60.331v256h-170.667v-249.941zM426.667 347.392c-0.939-45.739 32.256-84.779 77.269-91.051 2.176-0.213 5.12-0.341 8.107-0.341 22.784 0 44.203 8.875 60.331 25.003 16.085 16.085 24.96 37.547 24.96 60.331v256h-170.667v-249.941zM128 347.392c-0.939-45.739 32.256-84.779 77.269-91.051 2.176-0.213 5.12-0.341 8.064-0.341 22.784 0 44.203 8.875 60.331 25.003s25.003 37.547 25.003 60.331v256h-170.667v-249.941zM896 640v170.667h-170.667v-170.667h170.667zM597.333 640v170.667h-170.667v-170.667h170.667zM298.667 640v170.667h-170.667v-170.667h170.667zM224 533.333c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32zM266.667 362.667c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32zM522.667 533.333c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32zM864 512c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32zM821.333 405.333c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32zM565.333 405.333c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe917%3B%22 glyph-name%3D%22lab-tube%22 d%3D%22M286.635 366.763c-5.205 0-10.283 0.939-15.189 2.816-10.581 4.053-18.944 11.989-23.552 22.357l-110.123 244.864c-2.517 5.76-3.755 11.904-3.669 17.963 0.384 23.509 19.328 41.941 43.136 41.984 2.432-0.085 4.523-0.085 6.656-0.085 32.896 0 66.005 7.083 95.744 20.437l416.171 186.923c9.088 4.096 18.603 7.296 28.331 9.472 10.965 2.475 22.144 3.755 33.28 3.755 27.989 0 55.424-7.979 79.36-23.040 33.749-21.291 57.173-54.4 66.005-93.312 14.635-70.997-22.912-142.976-89.216-171.392l-411.477-185.003c-31.829-14.251-60.501-35.84-82.901-62.549-4.053-4.907-9.344-8.875-15.275-11.52-5.547-2.432-11.349-3.669-17.28-3.669zM286.848 409.344c18.859 22.869 41.6 42.368 67.456 58.027l-44.715 99.456c-4.821 10.709 0 23.381 10.709 28.203 2.773 1.237 5.717 1.877 8.747 1.877 8.405 0 16.043-4.949 19.456-12.587l43.819-97.451 77.867 34.987-26.325 58.539c-2.347 5.205-2.517 11.008-0.469 16.299 2.005 5.333 6.016 9.557 11.179 11.904 2.773 1.237 5.717 1.877 8.747 1.877 8.363 0 16-4.949 19.456-12.544l26.368-58.581 77.824 34.987-43.819 97.408c-2.347 5.205-2.517 11.008-0.469 16.299s6.016 9.557 11.179 11.904c2.773 1.237 5.717 1.877 8.747 1.877 8.363 0 16-4.949 19.456-12.587l43.861-97.451 77.824 34.987-26.283 58.581c-2.347 5.205-2.517 11.008-0.469 16.341 2.005 5.333 6.016 9.557 11.179 11.861 2.773 1.237 5.717 1.877 8.789 1.877 8.405 0 16-4.949 19.456-12.629l26.283-58.539 53.845 24.192c48.043 20.608 75.136 72.405 64.64 123.307-6.229 27.435-22.955 51.029-47.061 66.219-17.109 10.795-36.693 16.469-56.661 16.469-7.936 0-15.957-0.896-23.808-2.688-6.912-1.579-13.739-3.84-20.224-6.784l-416.341-186.795c-35.2-15.829-74.325-24.192-113.195-24.192-2.347 0-4.736 0.043-7.083 0.085l110.037-244.736zM223.829-21.291c-58.837 0-106.667 47.872-106.667 106.667 0 30.421 24.533 77.824 72.875 140.971 7.083 9.088 17.195 14.848 28.501 16.256 1.792 0.213 3.541 0.341 5.291 0.341 9.557 0 18.603-3.115 26.197-9.003 2.773-2.176 5.291-4.651 7.424-7.424 48.512-63.232 73.045-110.677 73.045-141.141 0-58.795-47.872-106.667-106.667-106.667zM223.744 200.277c-47.189-61.653-63.957-100.437-63.957-114.901 0-35.285 28.715-64 64-64s64 28.715 64 64c0 14.507-16.768 53.291-64.043 114.944v-0.043z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe918%3B%22 glyph-name%3D%22pipeline%22 d%3D%22M746.667-64c-35.285 0-64 28.715-64 64 0 27.307 17.493 51.413 42.667 60.331v86.315c-0.043 34.304-19.925 65.109-50.347 79.488-10.923-20.779-32.384-34.133-56.32-34.133-27.307 0-51.413 17.493-60.331 42.667h-174.336c-171.392 0.213-318.805 132.096-338.901 301.653-26.581 8.149-45.099 32.64-45.099 61.013 0 31.616 22.827 57.856 53.333 62.933 38.357 149.205 176.171 256.853 330.624 257.067h174.379c8.917 25.173 33.024 42.667 60.331 42.667 35.285 0 64-28.715 64-64v-213.333c0-35.285-28.715-64-64-64-27.307 0-51.413 17.493-60.331 42.667h-174.336c-16.256-0.043-32.128-4.821-45.824-13.653 15.275-11.947 24.491-30.379 24.491-50.347 0-31.531-22.912-57.813-52.992-63.061 14.976-26.539 43.307-43.563 74.325-43.605h174.293c8.917 25.173 33.024 42.667 60.331 42.667 28.501 0 53.035-18.688 61.099-45.397 169.515-21.376 301.397-169.813 301.568-341.248v-86.315c25.173-8.917 42.667-33.024 42.667-60.331 0-35.285-28.715-64-64-64h-213.291zM746.667 21.333c-11.776 0-21.333-9.557-21.333-21.333s9.557-21.333 21.333-21.333h213.333c11.776 0 21.333 9.557 21.333 21.333s-9.557 21.333-21.333 21.333zM938.667 64v82.645c-0.171 149.419-109.397 275.413-256 297.813v-175.317c51.243-18.859 85.248-67.115 85.333-122.453v-82.688zM618.667 490.667c-11.776 0-21.333-9.557-21.333-21.333v-213.333c0-11.776 9.557-21.333 21.333-21.333s21.333 9.557 21.333 21.333v213.333c0 11.776-9.557 21.333-21.333 21.333zM88.491 533.333c21.205-146.603 146.219-255.829 295.509-256h170.667v170.667h-170.667c-54.144 0.043-102.656 34.773-120.661 85.333zM64 618.667c-11.776 0-21.333-9.557-21.333-21.333s9.557-21.333 21.333-21.333h234.667c11.776 0 21.333 9.557 21.333 21.333s-9.557 21.333-21.333 21.333zM618.667 917.333c-11.776 0-21.333-9.557-21.333-21.333v-213.333c0-11.776 9.557-21.333 21.333-21.333s21.333 9.557 21.333 21.333v213.333c0 11.776-9.557 21.333-21.333 21.333zM289.067 661.333c24.32 27.093 58.624 42.581 94.891 42.667h170.709v170.667h-170.667c-132.651-0.171-248.448-87.211-286.208-213.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe919%3B%22 glyph-name%3D%22button-play%22 d%3D%22M513.707-63.957c-282.325 0-512 229.675-512 512s229.675 512 512 512c282.325 0 512-229.675 512-512s-229.675-512-512-512zM513.707 917.376c-258.773 0-469.333-210.56-469.333-469.333s210.56-469.333 469.333-469.333 469.333 210.56 469.333 469.333-210.56 469.333-469.333 469.333zM388.395 227.84c-2.432 0-4.907 0.213-7.339 0.597-23.936 3.883-40.832 26.368-38.016 50.347v295.765c-1.323 11.221 1.664 22.869 8.277 32.043 7.125 9.899 17.664 16.427 29.696 18.347 2.475 0.384 4.949 0.597 7.381 0.597 8.917 0 17.536-2.603 24.96-7.467l306.432-153.259c23.936-11.989 27.52-29.056 27.52-38.144s-3.584-26.155-27.477-38.144l-306.432-153.216c-7.509-4.907-16.085-7.467-25.003-7.467zM387.84 582.827c-0.768-0.128-1.408-0.512-1.92-1.195-0.427-0.597-0.64-1.451-0.512-2.176 0.213-1.109 0.299-2.304 0.299-3.456v-298.667c0-1.109-0.085-2.261-0.256-3.371s0.256-1.877 0.512-2.261c0.341-0.427 0.939-1.024 1.92-1.195 0.128 0 0.256 0 0.384 0 0.896 0 1.365 0.171 1.835 0.512 0.896 0.64 1.835 1.237 2.859 1.749l307.797 153.899c0 0-307.712 153.899-307.712 153.899-1.067 0.512-2.048 1.109-2.987 1.749-0.512 0.384-1.109 0.555-1.707 0.555l-0.512-0.043z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe91a%3B%22 glyph-name%3D%22copy-paste%22 d%3D%22M64 21.333c-35.285 0-64 28.715-64 64v682.667c0 35.285 28.715 64 64 64h67.669c8.917 25.173 33.024 42.667 60.331 42.667h85.333c0 0 0 0.043 0 0.043 0 47.061 38.272 85.333 85.333 85.333s85.333-38.272 85.333-85.333c0 0 0-0.043 0-0.043h85.333c27.307 0 51.413-17.493 60.331-42.667h67.669c35.285 0 64-28.715 64-64v-149.333c0-11.776-9.557-21.333-21.333-21.333s-21.333 9.557-21.333 21.333v149.333c0 11.776-9.557 21.333-21.333 21.333h-64v-21.333c0-35.285-28.715-64-64-64h-341.333c-35.285 0-64 28.715-64 64v21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-682.667c0-11.776 9.557-21.333 21.333-21.333h341.333c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-341.333zM192 832c-11.776 0-21.333-9.557-21.333-21.333v-42.667c0-11.776 9.557-21.333 21.333-21.333h341.333c11.776 0 21.333 9.557 21.333 21.333v42.667c0 11.776-9.557 21.333-21.333 21.333h-96.896c-15.189-26.112-43.435-42.624-73.771-42.624s-58.581 16.512-73.771 42.624h-96.896zM362.667 917.376c-23.509 0-42.667-19.157-42.667-42.667s19.157-42.667 42.667-42.667 42.667 19.157 42.667 42.667-19.157 42.667-42.667 42.667zM533.333-64c-35.285 0-64 28.715-64 64v490.667c0 35.285 28.715 64 64 64h302.336c17.109 0 33.152-6.656 45.269-18.731l81.664-81.664c11.904-11.947 18.731-28.416 18.731-45.269v-409.003c0-35.285-28.715-64-64-64h-384zM533.333 512c-11.776 0-21.333-9.557-21.333-21.333v-490.667c0-11.776 9.557-21.333 21.333-21.333h384c11.776 0 21.333 9.557 21.333 21.333v409.003c0 5.632-2.261 11.093-6.229 15.061l-81.664 81.664c-4.011 4.011-9.387 6.229-15.104 6.229h-302.336zM618.667 320.043c-11.776 0-21.333 9.557-21.333 21.333s9.557 21.333 21.333 21.333h213.333c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-213.333zM618.667 192.043c-11.776 0-21.333 9.557-21.333 21.333s9.557 21.333 21.333 21.333h213.333c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-213.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe91b%3B%22 glyph-name%3D%22explore-data%22 d%3D%22M21.333 106.667c-12.8 0-21.333 8.533-21.333 21.333v725.333c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-704h85.333v554.667c0 25.6 17.067 42.667 42.667 42.667h85.333c25.6 0 42.667-17.067 42.667-42.667v-554.667h42.667v341.333c0 25.6 17.067 42.667 42.667 42.667h85.333c25.6 0 42.667-17.067 42.667-42.667v-85.333c0-12.8-8.533-21.333-21.333-21.333s-21.333 8.533-21.333 21.333v85.333h-85.333v-341.333h34.133c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.333-21.333-21.333h-396.8zM256 149.333v554.667h-85.333v-554.667h85.333zM128 810.667c-4.267 0-12.8 4.267-17.067 4.267l-42.667 42.667c0 4.267-4.267 12.8-4.267 17.067s4.267 12.8 4.267 17.067 12.8 4.267 17.067 4.267 12.8-4.267 17.067-4.267l42.667-42.667c0-4.267 4.267-12.8 4.267-17.067s-4.267-12.8-4.267-17.067-12.8-4.267-17.067-4.267zM213.333 853.333c-12.8 0-21.333 8.533-21.333 21.333v64c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-64c0-12.8-8.533-21.333-21.333-21.333zM298.667 810.667c-4.267 0-12.8 4.267-17.067 4.267s-4.267 12.8-4.267 17.067 4.267 12.8 4.267 17.067l42.667 42.667c4.267 0 12.8 4.267 17.067 4.267s12.8-4.267 17.067-4.267 4.267-12.8 4.267-17.067-4.267-12.8-4.267-17.067l-42.667-42.667c-4.267 0-12.8-4.267-17.067-4.267zM1002.667-64c-4.267 0-12.8 4.267-17.067 4.267l-123.733 123.733c-38.4-29.867-85.333-46.933-136.533-46.933-119.467 0-213.333 98.133-213.333 213.333s98.133 213.333 213.333 213.333 213.333-98.133 213.333-213.333c0-51.2-17.067-98.133-46.933-136.533l123.733-123.733c4.267-4.267 4.267-8.533 4.267-17.067s-4.267-12.8-4.267-17.067-8.533 0-12.8 0zM725.333 405.333c-93.867 0-170.667-76.8-170.667-170.667s76.8-170.667 170.667-170.667 170.667 76.8 170.667 170.667-72.533 170.667-170.667 170.667z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe91c%3B%22 glyph-name%3D%22canary-marginal%22 d%3D%22M836.267 571.733c-21.333 0-64 38.4-64 59.733s42.667 59.733 64 59.733c21.333 0 64-38.4 64-59.733 0-17.067-42.667-59.733-64-59.733zM772.267 955.733h128l-8.533-213.333h-115.2l-4.267 213.333zM806.4 371.2c-4.267 4.267-8.533 8.533-12.8 12.8l-102.4 42.667c-8.533 4.267-12.8 8.533-12.8 17.067-12.8 119.467-119.467 204.8-238.933 192-106.667-17.067-192-110.933-192-226.133 0-12.8-12.8-25.6-25.6-25.6 0 0 0 0 0 0-55.467 4.267-110.933 34.133-149.333 72.533-12.8 12.8-34.133 17.067-51.2 8.533s-25.6-25.6-25.6-42.667c4.267-110.933 59.733-217.6 153.6-281.6 8.533-8.533 12.8-21.333 4.267-29.867 0 0 0-4.267-4.267-4.267-17.067-12.8-38.4-38.4-110.933-102.4-17.067-17.067-17.067-42.667-4.267-59.733 17.067-4.267 29.867-8.533 42.667-8.533h256c183.467 0 337.067 140.8 349.867 328.533 0 8.533 4.267 12.8 12.8 17.067l106.667 59.733c8.533 4.267 12.8 17.067 4.267 29.867zM366.933 345.6c-29.867 0-55.467 21.333-55.467 51.2 12.8 34.133 29.867 68.267 55.467 98.133 25.6-29.867 42.667-64 55.467-98.133 0-29.867-25.6-51.2-55.467-51.2zM512 426.667c-25.6 0-42.667 17.067-42.667 42.667s17.067 42.667 42.667 42.667 42.667-17.067 42.667-42.667-17.067-42.667-42.667-42.667z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe91d%3B%22 glyph-name%3D%22canary-fail%22 d%3D%22M806.4 371.2c-4.267 4.267-8.533 8.533-12.8 12.8l-102.4 42.667c-8.533 4.267-12.8 8.533-12.8 17.067-12.8 119.467-119.467 204.8-238.933 192-106.667-17.067-192-110.933-192-226.133 0-12.8-12.8-25.6-25.6-25.6 0 0 0 0 0 0-55.467 4.267-110.933 34.133-149.333 72.533-12.8 12.8-34.133 17.067-51.2 8.533s-25.6-25.6-25.6-42.667c4.267-110.933 59.733-217.6 153.6-281.6 8.533-8.533 12.8-21.333 4.267-29.867 0 0 0-4.267-4.267-4.267-17.067-12.8-38.4-38.4-110.933-102.4-17.067-17.067-17.067-42.667-4.267-59.733 17.067-4.267 29.867-8.533 42.667-8.533h256c183.467 0 337.067 140.8 349.867 328.533 0 8.533 4.267 12.8 12.8 17.067l106.667 59.733c8.533 4.267 12.8 17.067 4.267 29.867zM580.267 439.467c4.267-4.267 4.267-8.533 0-12.8l-12.8-12.8c0 0-4.267-4.267-4.267-4.267s-4.267 0-4.267 4.267l-38.4 34.133c0 0 0 0 0 0l-34.133-34.133c0 0-4.267-4.267-4.267-4.267s-4.267 0-4.267 4.267l-12.8 12.8c-4.267 4.267-4.267 8.533 0 12.8l34.133 34.133c0 0 0 0 0 0l-34.133 34.133c-4.267 4.267-4.267 8.533 0 12.8l4.267 17.067c0 0 4.267 4.267 4.267 4.267s4.267 0 4.267-4.267l34.133-34.133c0 0 0 0 0 0l42.667 34.133c0 0 4.267 4.267 4.267 4.267s4.267 0 4.267-4.267l12.8-12.8c4.267-4.267 4.267-8.533 0-12.8l-34.133-34.133c0 0 0 0 0 0l38.4-38.4zM806.4 832l-72.533 72.533c0 0 0 0 0 0l-12.8 12.8c-38.4 38.4-102.4 38.4-136.533 0-8.533-8.533-12.8-12.8-17.067-21.333-17.067-38.4-12.8-81.067 17.067-110.933l145.067-149.333c8.533-8.533 25.6-8.533 34.133 0 0 0 0 0 0 0l42.667 42.667-81.067 72.533 81.067 81.067zM994.133 887.467c-25.6 46.933-85.333 68.267-132.267 42.667-8.533-4.267-17.067-8.533-21.333-17.067l-29.867-25.6 55.467-55.467-76.8-76.8 81.067-81.067 102.4 106.667c29.867 25.6 38.4 72.533 21.333 106.667z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe91e%3B%22 glyph-name%3D%22canary-pass%22 d%3D%22M795.563 381.952l-101.888 44.501c-6.906 3.004-11.846 9.363-12.789 16.963l-0.011 0.104c-12.561 109.003-104.316 192.853-215.655 192.853-7.567 0-15.044-0.387-22.411-1.143l0.924 0.077c-110.469-15.006-194.706-108.723-194.706-222.114 0-1.008 0.007-2.015 0.020-3.020l-0.002 0.153c0-0.007 0-0.014 0-0.022 0-13.667-11.079-24.747-24.747-24.747-0.631 0-1.256 0.024-1.874 0.070l0.082-0.005c-59.271 6.085-111.207 33.448-148.847 74.209l-0.145 0.159c-7.757 7.952-18.579 12.884-30.552 12.884-6.833 0-13.292-1.606-19.018-4.462l0.247 0.112c-14.325-6.815-24.050-21.171-24.050-37.798 0-1.58 0.088-3.139 0.259-4.673l-0.017 0.189c4.32-116.192 63.179-217.785 151.586-280.421l1.118-0.752c5.853-3.867 9.661-10.417 9.661-17.857 0-5.975-2.456-11.376-6.414-15.249l-0.004-0.004c-15.104-14.72-40.107-36.821-109.696-102.016-8.403-7.815-13.644-18.933-13.644-31.275 0-23.561 19.097-42.661 42.656-42.667h256.257c184.963 0.301 336.35 143.647 349.46 325.308l0.066 1.135c0.593 7.375 4.855 13.638 10.941 17.011l0.109 0.056 105.643 57.728c7.652 4.351 12.729 12.449 12.729 21.733 0 10.286-6.232 19.116-15.126 22.92l-0.162 0.062zM512 426.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667c23.564 0 42.667-19.103 42.667-42.667v0c0-23.564-19.103-42.667-42.667-42.667v0zM1013.76 907.349c-16.639 31.522-49.2 52.641-86.693 52.641-26.619 0-50.752-10.645-68.374-27.91l0.017 0.016-11.776-11.605c-3.845-3.771-9.117-6.098-14.933-6.098s-11.088 2.327-14.937 6.102l0.003-0.003-11.776 11.605c-17.602 17.266-41.741 27.922-68.369 27.922-37.497 0-70.059-21.132-86.425-52.136l-0.256-0.532c-6.471-12.411-10.266-27.104-10.266-42.684 0-26.368 10.872-50.197 28.379-67.248l0.021-0.020 146.304-150.144c4.408-4.487 10.541-7.268 17.323-7.268s12.914 2.781 17.319 7.265l0.003 0.004 146.304 150.144c17.527 17.071 28.4 40.9 28.4 67.268 0 15.58-3.796 30.273-10.513 43.205l0.246-0.521z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe91f%3B%22 glyph-name%3D%22network-bad%22 d%3D%22M483.755-63.36c-175.36 9.685-331.776 107.605-418.133 261.973-2.347 2.475-4.011 5.504-4.949 8.875-42.069 78.763-62.677 167.765-59.648 257.493-0.299 1.195-0.555 2.603-0.555 4.224 0 2.005 0.299 3.968 0.853 5.931l0.043 0.939c5.077 91.904 34.859 180.651 86.101 256.811 1.195 3.072 3.029 5.76 5.504 7.979 89.856 128.256 230.485 207.573 386.091 217.728 0.469 0.043 1.109 0.085 1.792 0.085 10.837 0.683 22.272 1.067 33.28 1.067 9.003 0 18.005-0.256 26.752-0.725 238.592-13.184 434.261-186.752 475.861-422.059 0.981-5.589-0.256-11.264-3.541-15.957-3.243-4.651-8.149-7.765-13.781-8.789-1.28-0.213-2.475-0.299-3.712-0.299-10.411 0-19.243 7.424-21.035 17.621-11.093 62.72-34.133 121.344-68.437 174.379h-192.853c14.763-40.533 25.856-82.304 32.981-124.416 1.963-11.605-5.888-22.656-17.493-24.619-1.152-0.213-2.347-0.299-3.541-0.299-10.411 0-19.285 7.467-21.035 17.749-7.595 44.843-19.883 89.045-36.48 131.584h-312.32c-27.264-68.224-41.899-139.904-43.605-213.333h157.483c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-156.971c3.115-70.187 17.792-141.824 43.733-213.333h49.195c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-32.256c31.573-74.325 75.051-148.651 129.451-221.184 0.597-0.768 1.451-2.389 1.792-3.285 0.213-0.299 0.939-1.579 1.493-3.328 0.512-1.707 0.64-3.243 0.725-4.181 0.043-0.043 0.341-1.408 0.256-3.115-0.043-0.597-0.128-1.28-0.299-1.963-0.213-1.195-0.512-2.133-0.683-2.773-0.384-1.323-0.768-2.645-1.536-4.139-0.512-0.939-1.152-1.835-1.835-2.731s-1.493-1.92-2.56-2.944c-0.555-0.597-1.195-1.195-1.792-1.621-0.981-0.768-2.133-1.28-2.731-1.536-0.469-0.256-1.835-0.939-2.389-1.152-2.603-0.939-5.035-1.408-7.467-1.408-0.427 0-1.365 0.043-1.749 0.085zM119.381 191.915c72.789-111.403 190.379-187.435 321.109-207.829-47.061 68.096-84.949 137.856-112.896 207.829h-208.213zM311.893 234.581c-24.491 71.808-38.357 143.445-41.301 213.333h-227.2c-0.043-74.197 17.621-147.584 51.285-213.333h217.216zM270.080 490.581c1.579 72.875 15.232 144.512 40.619 213.333h-191.189c-41.728-63.829-67.243-137.259-74.197-213.333h224.768zM875.136 746.581c-70.187 85.205-169.685 143.317-278.784 163.029 40.576-49.579 74.112-104.277 99.925-163.029h178.859zM649.344 746.581c-29.525 62.336-68.48 119.467-116.011 170.112-6.784 0.299-13.568 0.427-20.267 0.427-7.339 0-14.805-0.171-22.315-0.512-48.256-53.376-87.339-110.507-116.352-170.027h274.944zM328.149 746.581c25.557 57.045 59.264 111.701 100.523 162.944-108.075-19.755-207.189-77.824-277.76-162.944h177.237zM746.667-64.085c-152.917 0-277.333 124.416-277.333 277.333s124.416 277.333 277.333 277.333 277.333-124.416 277.333-277.333-124.416-277.333-277.333-277.333zM746.667 447.915c-129.408 0-234.667-105.259-234.667-234.667s105.259-234.667 234.667-234.667 234.667 105.259 234.667 234.667-105.259 234.667-234.667 234.667zM837.163 101.376c-5.717 0-11.051 2.219-15.104 6.229l-75.392 75.477-75.435-75.435c-4.011-4.011-9.387-6.229-15.104-6.229s-11.051 2.219-15.104 6.229c-8.32 8.32-8.32 21.845 0 30.165l75.435 75.435-75.435 75.435c-8.32 8.32-8.32 21.845 0 30.165 4.011 4.011 9.387 6.229 15.104 6.229s11.051-2.219 15.104-6.229l75.435-75.435 75.435 75.435c4.011 4.011 9.387 6.229 15.104 6.229s11.051-2.219 15.104-6.229c8.32-8.32 8.32-21.845 0-30.165l-75.435-75.435 75.435-75.435c8.32-8.32 8.32-21.845 0-30.165-4.096-4.053-9.429-6.272-15.147-6.272z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe920%3B%22 glyph-name%3D%22warn-diamond%22 d%3D%22M512-25.6c-17.067 0-34.133 4.267-46.933 17.067l-409.6 409.6c-12.8 12.8-17.067 29.867-17.067 46.933s8.533 34.133 17.067 46.933l409.6 409.6c25.6 25.6 64 25.6 89.6 0l409.6-409.6c25.6-25.6 25.6-64 0-89.6l-409.6-409.6c-8.533-12.8-25.6-21.333-42.667-21.333zM512 878.933c-4.267 0-12.8 0-17.067-4.267l-409.6-409.6c0 0 0 0 0 0 0-4.267-4.267-12.8-4.267-17.067s4.267-12.8 4.267-17.067l409.6-409.6c8.533-8.533 21.333-8.533 29.867 0l409.6 409.6c8.533 8.533 8.533 21.333 0 29.867l-409.6 409.6c0 4.267-8.533 8.533-12.8 8.533zM72.533 477.867v0 0zM512 341.333c-12.8 0-21.333 8.533-21.333 21.333v298.667c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-298.667c0-12.8-8.533-21.333-21.333-21.333zM512 298.667c0 0 0 0 0 0s0 0 0 0c-4.267 0-4.267 0-8.533 0 0 0 0 0-4.267 0s-12.8-4.267-12.8-8.533c-4.267-4.267-8.533-12.8-8.533-21.333 0-17.067 12.8-29.867 34.133-29.867 8.533 0 17.067 4.267 21.333 8.533s8.533 12.8 8.533 21.333c4.267 12.8-12.8 29.867-29.867 29.867z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe921%3B%22 glyph-name%3D%22search%22 d%3D%22M1002.667-64c-5.717 0-11.051 2.219-15.104 6.229l-384.171 384.171c-66.56-59.221-151.637-91.733-240.725-91.733-199.979 0-362.667 162.688-362.667 362.667s162.688 362.667 362.667 362.667c199.979 0 362.667-162.688 362.667-362.667 0-89.088-32.512-174.165-91.776-240.725l384.171-384.171c4.053-4.053 6.272-9.387 6.272-15.104s-2.219-11.051-6.229-15.104-9.387-6.229-15.104-6.229zM362.667 917.333c-176.427 0-320-143.573-320-320s143.573-320 320-320 320 143.573 320 320-143.573 320-320 320z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe922%3B%22 glyph-name%3D%22new-function%22 d%3D%22M725.333 405.333v85.333h42.667v-85.333h85.333v-42.667h-85.333v-85.333h-42.667v85.333h-85.333v42.667zM354.133 157.867c-12.8 0-21.333 0-34.133 4.267s-17.067 4.267-21.333 8.533l12.8 46.933c12.8-4.267 25.6-8.533 38.4-8.533 25.6 0 42.667 8.533 51.2 29.867s17.067 51.2 21.333 89.6l17.067 166.4h-64v46.933l51.2 4.267h21.333l4.267 42.667c4.267 51.2 17.067 89.6 38.4 115.2 17.067 29.867 46.933 42.667 89.6 42.667 12.8 0 21.333 0 34.133-4.267s21.333-4.267 25.6-8.533l-12.8-46.933c-4.267 4.267-12.8 4.267-17.067 8.533-8.533 4.267-12.8 4.267-25.6 4.267s-21.333-4.267-29.867-8.533c-8.533-4.267-17.067-12.8-21.333-21.333s-8.533-21.333-12.8-29.867-8.533-29.867-8.533-42.667l-4.267-46.933h98.133v-46.933h-102.4l-21.333-183.467c-4.267-25.6-8.533-46.933-12.8-64-4.267-21.333-12.8-34.133-21.333-51.2-8.533-12.8-21.333-25.6-38.4-34.133s-34.133-12.8-55.467-12.8zM512 917.333c260.267 0 469.333-209.067 469.333-469.333s-209.067-469.333-469.333-469.333-469.333 209.067-469.333 469.333 209.067 469.333 469.333 469.333zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512c0 281.6-230.4 512-512 512v0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe923%3B%22 glyph-name%3D%22lambda%22 d%3D%22M512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 21.333c-234.667 0-426.667 192-426.667 426.667s192 426.667 426.667 426.667 426.667-192 426.667-426.667c0-234.667-192-426.667-426.667-426.667zM430.933 183.467l-119.467 8.533 162.133 384-4.267 8.533c-4.267 21.333-12.8 34.133-25.6 42.667s-25.6 17.067-42.667 17.067c-12.8 0-21.333 0-29.867-4.267-8.533 0-17.067-4.267-25.6-8.533l-21.333 93.867c12.8 4.267 25.6 8.533 38.4 12.8s29.867 4.267 55.467 4.267 81.067-12.8 106.667-38.4c25.6-25.6 46.933-68.267 64-123.733l136.533-388.267h-119.467l-72.533 256h-4.267l-98.133-264.533z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe924%3B%22 glyph-name%3D%22app-window%22 d%3D%22M106.667-0.171c-58.837 0-106.667 47.872-106.667 106.667v682.667c0 58.837 47.829 106.667 106.667 106.667h810.667c58.795 0 106.667-47.829 106.667-106.667v-682.667c0-58.795-47.872-106.667-106.667-106.667h-810.667zM42.667 106.496c0-35.285 28.715-64 64-64h810.667c35.285 0 64 28.715 64 64v533.333h-938.667v-533.333zM981.333 682.496v106.667c0 35.285-28.715 64-64 64h-810.667c-35.285 0-64-28.715-64-64v-106.667h938.667zM202.667 767.829c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32zM330.667 767.829c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32zM458.667 767.829c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 17.673 14.327 32 32 32s32-14.327 32-32z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe925%3B%22 glyph-name%3D%22menu%22 d%3D%22M192 627.2h640c17.067 0 34.133 12.8 34.133 34.133s-12.8 34.133-34.133 34.133h-640c-17.067 0-34.133-17.067-34.133-34.133s17.067-34.133 34.133-34.133zM832 268.8h-640c-17.067 0-34.133-12.8-34.133-34.133s12.8-34.133 34.133-34.133h640c17.067 0 34.133 12.8 34.133 34.133s-17.067 34.133-34.133 34.133zM192 413.867h640c17.067 0 34.133 12.8 34.133 34.133s-12.8 34.133-34.133 34.133h-640c-17.067 0-34.133-12.8-34.133-34.133s17.067-34.133 34.133-34.133z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe926%3B%22 glyph-name%3D%22menu-close%22 d%3D%22M981.333 482.133h-861.867l115.2 115.2c8.533 4.267 8.533 12.8 8.533 21.333s0 17.067-8.533 21.333c-12.8 12.8-34.133 12.8-46.933 0l-170.667-170.667c-4.267-4.267-4.267-8.533-8.533-8.533-4.267-8.533-4.267-17.067 0-25.6 0-4.267 4.267-8.533 8.533-8.533l170.667-170.667c4.267-4.267 12.8-8.533 21.333-8.533s17.067 4.267 21.333 8.533 8.533 12.8 8.533 21.333-4.267 17.067-8.533 21.333l-115.2 115.2h866.133c17.067 0 34.133 12.8 34.133 34.133 0 17.067-17.067 34.133-34.133 34.133zM341.333 627.2h640c17.067 0 34.133 12.8 34.133 34.133s-17.067 34.133-34.133 34.133h-640c-17.067 0-34.133-17.067-34.133-34.133s17.067-34.133 34.133-34.133zM981.333 268.8h-640c-17.067 0-34.133-12.8-34.133-34.133s12.8-34.133 34.133-34.133h640c17.067 0 34.133 12.8 34.133 34.133s-17.067 34.133-34.133 34.133z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe927%3B%22 glyph-name%3D%22close%22 d%3D%22M1002.667-63.957c-5.717 0-11.051 2.219-15.104 6.229l-475.563 475.605-475.563-475.605c-4.011-4.011-9.387-6.229-15.104-6.229s-11.051 2.219-15.104 6.229c-8.32 8.32-8.32 21.845 0 30.165l475.563 475.563-475.52 475.605c-8.32 8.32-8.32 21.845 0 30.165 4.011 4.053 9.387 6.272 15.061 6.272s11.051-2.219 15.104-6.229l475.563-475.605 475.605 475.563c4.011 4.011 9.387 6.229 15.104 6.229s11.051-2.219 15.104-6.229c8.32-8.32 8.32-21.845 0-30.165l-475.648-475.563 475.563-475.563c8.32-8.32 8.32-21.845 0-30.165-4.011-4.053-9.344-6.272-15.061-6.272z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe928%3B%22 glyph-name%3D%22expand-all%22 d%3D%22M348.667 362.667l163.333-163.333 163.333 163.333 50-50-213.333-213.333-213.333 213.333zM675.333 533.253l-163.333 163.333-163.333-163.333-50 50 213.333 213.333 213.333-213.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe929%3B%22 glyph-name%3D%22collapse%22 d%3D%22M348.667 576l163.333-163.333 163.333 163.333 50-50-213.333-213.333-213.333 213.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe92a%3B%22 glyph-name%3D%22expand%22 d%3D%22M643.667 607.667l-163.333-163.333 163.333-163.333-50-50-213.333 213.333 213.333 213.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe92b%3B%22 glyph-name%3D%22md-actuation-launched%22 d%3D%22M813.056 642.645c45.644 0 82.645 37.002 82.645 82.645s-37.002 82.645-82.645 82.645c-45.644 0-82.645-37.002-82.645-82.645s37.002-82.645 82.645-82.645zM813.056 685.312c-22.080 0-39.979 17.899-39.979 39.979s17.899 39.979 39.979 39.979c22.080 0 39.979-17.899 39.979-39.979s-17.899-39.979-39.979-39.979zM887.712 869.183c1.557-5.044 6.746-8.029 11.874-6.844l46.674 10.823c27.241 6.145 55.307-6.182 69.213-30.399s10.405-54.67-8.519-74.975l-32.699-35.651c-3.656-3.931-3.656-10.018 0.033-13.984l32.534-35.135c18.98-20.437 22.445-50.85 8.55-75.033s-41.914-36.506-69.35-30.351l-46.292 10.903c-5.143 1.189-10.332-1.796-11.875-6.794l-14.087-46.004c-8.037-26.805-32.707-45.162-60.691-45.162s-52.653 18.358-60.662 45.069l-13.973 45.837c-1.557 5.044-6.746 8.029-11.874 6.844l-46.7-10.829c-27.215-6.104-55.234 6.218-69.129 30.402s-10.429 54.596 8.529 75.010l32.587 35.193c3.656 3.931 3.656 10.018-0.024 13.974l-32.517 35.074c-19.039 20.43-22.54 50.882-8.634 75.1s41.971 36.544 69.338 30.371l46.534-10.791c5.143-1.189 10.332 1.796 11.843 6.688l13.937 46.372c8.001 26.859 32.697 45.27 60.723 45.27 28 0 52.677-18.379 60.701-45.199l13.955-45.779zM832.927 902.579c-2.652 8.902-10.718 14.915-19.871 14.915s-17.219-6.013-19.847-14.835l-13.998-46.573c-8.155-26.418-35.328-42.052-62.281-35.823l-46.424 10.766c-8.983 2.026-18.238-2.039-22.823-10.024s-3.431-18.028 2.885-24.805l32.531-35.089c18.891-20.309 18.891-51.759 0.033-72.032l-32.576-35.18c-6.259-6.739-7.402-16.768-2.82-24.743s13.822-12.038 22.646-10.059l46.564 10.798c26.938 6.226 54.111-9.408 62.288-35.898l14.023-46.003c2.625-8.754 10.682-14.75 19.821-14.75s17.197 5.996 19.857 14.869l14.137 46.169c8.155 26.418 35.328 42.052 62.352 35.806l46.157-10.872c8.974-2.013 18.214 2.050 22.796 10.025s3.439 18.003-2.841 24.766l-32.522 35.122c-18.891 20.309-18.891 51.759-0.102 71.957l32.713 35.666c6.278 6.737 7.433 16.779 2.847 24.765s-13.84 12.051-22.699 10.053l-46.564-10.798c-26.938-6.226-54.111 9.408-62.288 35.898l-13.995 45.909zM315.774 563.642c6.593-7.37 15.846-11.509 25.56-11.509s18.967 4.139 25.56 11.509l26.867 29.549c21.846 24.217 56.574 32.058 86.706 19.576s49.142-42.583 47.464-75.152l-2.047-39.827c-0.489-9.721 3.159-19.194 10.041-26.077s16.356-10.53 26.053-10.043l39.848 2.048c32.572 1.678 62.673-17.332 75.155-47.464s4.642-64.859-19.564-86.695l-29.691-26.824c-7.24-6.475-11.379-15.729-11.379-25.442s4.139-18.967 11.459-25.514l29.599-26.741c24.217-21.846 32.058-56.574 19.576-86.706s-42.583-49.142-75.152-47.464l-39.827 2.047c-9.721 0.489-19.194-3.159-26.077-10.041s-10.53-16.356-10.043-26.053l2.048-39.848c1.678-32.572-17.332-62.673-47.464-75.155s-64.859-4.642-86.695 19.564l-26.824 29.691c-6.475 7.24-15.729 11.379-25.442 11.379s-18.967-4.139-25.605-11.558l-26.992-29.499c-21.846-24.217-56.574-32.058-86.706-19.576s-49.142 42.583-47.464 75.152l2.047 39.827c0.489 9.721-3.159 19.194-10.041 26.077s-16.356 10.53-26.053 10.043l-39.974-2.054c-32.443-1.479-62.331 17.542-74.73 47.56s-4.645 64.586 19.435 86.477l29.691 26.824c7.24 6.475 11.379 15.729 11.379 25.442s-4.139 18.967-11.459 25.514l-29.599 26.741c-24.217 21.846-32.058 56.574-19.576 86.706s42.583 49.142 75.152 47.464l39.827-2.047c9.721-0.489 19.194 3.159 26.077 10.041s10.53 16.356 10.042 26.057l-2.051 40.048c-1.556 32.459 17.418 62.406 47.433 74.861s64.617 4.742 86.513-19.296l26.923-29.611zM257.295 564.535c-9.766 10.722-25.209 14.164-38.604 8.605s-21.863-18.924-21.172-33.34l2.049-39.999c1.095-21.766-7.074-42.979-22.484-58.39s-36.623-23.579-58.413-22.483l-39.854 2.048c-14.537 0.749-27.97-7.735-33.541-21.183s-2.072-28.946 8.748-38.707l29.531-26.68c16.291-14.57 25.602-35.39 25.602-57.246s-9.312-42.676-25.523-57.174l-29.562-26.708c-10.725-9.75-14.185-25.178-8.652-38.574s18.872-21.886 33.228-21.231l39.874 2.049c21.766 1.095 42.979-7.074 58.39-22.484s23.579-36.623 22.483-58.413l-2.048-39.854c-0.749-14.537 7.735-27.97 21.183-33.541s28.946-2.072 38.797 8.848l26.931 29.431c14.57 16.291 35.39 25.602 57.246 25.602s42.676-9.312 57.174-25.523l26.763-29.623c9.75-10.808 25.248-14.307 38.696-8.736s21.932 19.004 21.182 33.544l-2.049 39.874c-1.095 21.766 7.074 42.979 22.484 58.39s36.623 23.579 58.413 22.483l39.854-2.048c14.537-0.749 27.97 7.735 33.541 21.183s2.072 28.946-8.748 38.707l-29.531 26.68c-16.291 14.57-25.602 35.39-25.602 57.246s9.312 42.676 25.523 57.174l29.623 26.763c10.808 9.75 14.307 25.248 8.736 38.696s-19.004 21.932-33.544 21.182l-39.874-2.049c-21.766-1.095-42.979 7.074-58.39 22.484s-23.579 36.623-22.483 58.413l2.048 39.854c0.749 14.537-7.735 27.97-21.183 33.541s-28.946 2.072-38.752-8.798l-26.805-29.481c-14.57-16.291-35.39-25.602-57.246-25.602-21.824 0-42.616 9.285-57.182 25.532l-26.856 29.537zM341.333 106.624c94.257 0 170.667 76.41 170.667 170.667s-76.41 170.667-170.667 170.667c-94.257 0-170.667-76.41-170.667-170.667s76.41-170.667 170.667-170.667zM341.333 149.291c-70.692 0-128 57.308-128 128s57.308 128 128 128c70.692 0 128-57.308 128-128s-57.308-128-128-128z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe92c%3B%22 glyph-name%3D%22md-delta-resolved%22 d%3D%22M384 922.369l290.518-581.036h-581.036l290.518 581.036zM384 826.964l-221.482-442.964h442.964l-221.482 442.964zM672 522.667c-147.276 0-266.667-119.391-266.667-266.667s119.391-266.667 266.667-266.667c147.276 0 266.667 119.391 266.667 266.667-0.165 147.208-119.459 266.502-266.667 266.667zM806.955 308.139l-118.741-158.379c-10.922-14.615-27.702-23.706-45.909-24.875-1.493 0-3.072 0-4.565 0-16.605 0.014-32.511 6.684-44.16 18.517l-61.227 61.269c-11.749 12.608-11.402 32.256 0.784 44.443s31.834 12.533 44.443 0.784l52.651-52.651c2.249-2.237 5.374-3.362 8.533-3.072 3.090 0.212 5.93 1.773 7.765 4.267l109.355 148.267c6.607 9.828 18.097 15.21 29.877 13.996s21.93-8.827 26.394-19.796c4.464-10.969 2.514-23.506-5.071-32.601l-0.128-0.171z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe92d%3B%22 glyph-name%3D%22md-delta-detected%22 d%3D%22M640 106.496c129.603 0 234.667 105.064 234.667 234.667s-105.064 234.667-234.667 234.667c-129.603 0-234.667-105.064-234.667-234.667s105.064-234.667 234.667-234.667zM640 149.163c-106.039 0-192 85.961-192 192s85.961 192 192 192c106.039 0 192-85.961 192-192s-85.961-192-192-192zM788.243 162.75l135.339-135.339c8.331-8.331 21.839-8.331 30.17 0s8.331 21.839 0 30.17l-135.339 135.339c-8.331 8.331-21.839 8.331-30.17 0s-8.331-21.839 0-30.17zM384 922.369l290.518-581.036h-581.036l290.518 581.036zM384 826.964l-221.482-442.964h442.964l-221.482 442.964z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe92e%3B%22 glyph-name%3D%22md-missing-resource%22 d%3D%22M1024 704.083c0-11.782-9.551-21.333-21.333-21.333s-21.333 9.551-21.333 21.333v33.112c0 9.72-6.57 18.211-15.979 20.651-11.405 2.957-18.253 14.6-15.296 26.005s14.6 18.253 26.005 15.296c28.226-7.319 47.936-32.792 47.936-61.952v-33.112zM1024 533.416c0-11.782-9.551-21.333-21.333-21.333s-21.333 9.551-21.333 21.333v85.333c0 11.782 9.551 21.333 21.333 21.333s21.333-9.551 21.333-21.333v-85.333zM1024 362.749c0-11.782-9.551-21.333-21.333-21.333s-21.333 9.551-21.333 21.333v85.333c0 11.782 9.551 21.333 21.333 21.333s21.333-9.551 21.333-21.333v-85.333zM1021.972 186.837c-2.944-11.408-14.578-18.27-25.987-15.327s-18.27 14.578-15.327 25.987c0.447 1.732 0.675 3.521 0.675 5.34v74.579c0 11.782 9.551 21.333 21.333 21.333s21.333-9.551 21.333-21.333v-74.579c0-5.425-0.685-10.795-2.028-16zM855.468 100.521c-11.177-3.726-23.259 2.315-26.985 13.492s2.315 23.259 13.492 26.985l80.954 26.985c11.177 3.726 23.259-2.315 26.985-13.492s-2.315-23.259-13.492-26.985l-80.954-26.985zM693.559 46.552c-11.177-3.726-23.259 2.315-26.985 13.492s2.315 23.259 13.492 26.985l80.954 26.985c11.177 3.726 23.259-2.315 26.985-13.492s-2.315-23.259-13.492-26.985l-80.954-26.985zM531.651-7.418c-11.177-3.726-23.259 2.315-26.985 13.492s2.315 23.259 13.492 26.985l80.954 26.985c11.177 3.726 23.259-2.315 26.985-13.492s-2.315-23.259-13.492-26.985l-80.954-26.985zM355.347 27.91c-11.073 4.027-16.784 16.268-12.757 27.34s16.268 16.784 27.34 12.757l80.194-29.166c11.073-4.027 16.784-16.268 12.757-27.34s-16.268-16.784-27.34-12.757l-80.194 29.166zM194.958 86.242c-11.073 4.027-16.784 16.268-12.757 27.34s16.268 16.784 27.34 12.757l80.194-29.166c11.073-4.027 16.784-16.268 12.757-27.34s-16.268-16.784-27.34-12.757l-80.194 29.166zM31.232 146.994c-10.121 6.031-13.437 19.125-7.406 29.247s19.125 13.437 29.247 7.406c1.146-0.683 2.36-1.259 3.627-1.721l72.648-26.421c11.073-4.027 16.784-16.268 12.757-27.34s-16.268-16.784-27.34-12.757l-72.652 26.423c-3.796 1.381-7.435 3.111-10.88 5.163zM0 331.724c0 11.782 9.551 21.333 21.333 21.333s21.333-9.551 21.333-21.333v-85.333c0-11.782-9.551-21.333-21.333-21.333s-21.333 9.551-21.333 21.333v85.333zM0 502.391c0 11.782 9.551 21.333 21.333 21.333s21.333-9.551 21.333-21.333v-85.333c0-11.782-9.551-21.333-21.333-21.333s-21.333 9.551-21.333 21.333v85.333zM0 673.058c0 11.782 9.551 21.333 21.333 21.333s21.333-9.551 21.333-21.333v-85.333c0-11.782-9.551-21.333-21.333-21.333s-21.333 9.551-21.333 21.333v85.333zM100.47 812.765c11.4 2.978 23.055-3.849 26.032-15.249s-3.849-23.055-15.249-26.032l-54.066-14.071c-5.092-1.71-9.321-5.275-11.893-9.957-5.674-10.326-18.644-14.098-28.97-8.424s-14.098 18.644-8.424 28.97c7.699 14.012 20.395 24.715 37.102 30.275l55.467 14.489zM265.714 855.603c11.405 2.957 23.048-3.892 26.004-15.297s-3.892-23.048-15.297-26.004l-82.603-21.414c-11.405-2.957-23.048 3.892-26.004 15.297s3.892 23.048 15.297 26.004l82.603 21.414zM430.919 898.43c11.405 2.957 23.048-3.892 26.004-15.297s-3.892-23.048-15.297-26.004l-82.603-21.414c-11.405-2.957-23.048 3.892-26.004 15.297s3.892 23.048 15.297 26.004l82.603 21.414zM607.514 894.67c11.405-2.956 18.255-14.598 15.298-26.003s-14.598-18.255-26.003-15.298l-79.599 20.631c-0.765 0.187-0.765 0.187-1.536 0.336-11.597 2.082-19.31 13.171-17.228 24.767s13.171 19.31 24.767 17.228c2.336-0.449 2.336-0.449 4.677-1.022l79.624-20.638zM772.722 851.85c11.405-2.956 18.255-14.598 15.298-26.003s-14.598-18.255-26.003-15.298l-82.604 21.41c-11.405 2.956-18.255 14.598-15.298 26.003s14.598 18.255 26.003 15.298l82.604-21.41zM937.93 809.030c11.405-2.956 18.255-14.598 15.298-26.003s-14.598-18.255-26.003-15.298l-82.604 21.41c-11.405 2.956-18.255 14.598-15.298 26.003s14.598 18.255 26.003 15.298l82.604-21.41zM469.333 641.408v-85.333c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v85.333c0 11.782-9.551 21.333-21.333 21.333s-21.333-9.551-21.333-21.333zM469.333 470.741v-85.333c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v85.333c0 11.782-9.551 21.333-21.333 21.333s-21.333-9.551-21.333-21.333zM469.333 300.075v-85.333c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v85.333c0 11.782-9.551 21.333-21.333 21.333s-21.333-9.551-21.333-21.333zM469.333 129.408v-85.333c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v85.333c0 11.782-9.551 21.333-21.333 21.333s-21.333-9.551-21.333-21.333zM985.846 787.161l-82.787-20.692c-11.43-2.857-18.381-14.439-15.524-25.869s14.439-18.381 25.87-15.524l82.787 20.691c11.43 2.857 18.381 14.439 15.524 25.87s-14.439 18.381-25.87 15.524zM820.272 745.778l-82.787-20.692c-11.43-2.857-18.381-14.439-15.524-25.869s14.439-18.381 25.87-15.524l82.787 20.691c11.43 2.857 18.381 14.439 15.524 25.87s-14.439 18.381-25.87 15.524zM654.699 704.395l-82.787-20.692c-11.43-2.857-18.381-14.439-15.524-25.869s14.439-18.381 25.87-15.524l82.787 20.691c11.43 2.857 18.381 14.439 15.524 25.87s-14.439 18.381-25.87 15.524zM489.125 663.012l-3.632-0.908 5.173-20.697 5.614 20.581-78.714 21.472c-11.367 3.101-23.095-3.6-26.196-14.967s3.6-23.095 14.967-26.196l78.714-21.472c3.526-0.962 7.241-1.002 10.787-0.115l3.632 0.908c11.43 2.857 18.381 14.439 15.524 25.87s-14.439 18.381-25.87 15.524zM335.242 705.919l-82.325 22.457c-11.367 3.101-23.095-3.6-26.196-14.967s3.6-23.095 14.967-26.196l82.325-22.457c11.367-3.101 23.095 3.6 26.196 14.967s-3.6 23.095-14.967 26.196zM170.591 750.833l-82.325 22.457c-11.367 3.101-23.095-3.6-26.196-14.967s3.6-23.095 14.967-26.196l82.325-22.457c11.367-3.101 23.095 3.6 26.196 14.967s-3.6 23.095-14.967 26.196z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe92f%3B%22 glyph-name%3D%22arrow-button-right%22 d%3D%22M307.488-53.376l532.096 468.64c8.64 8.288 14.016 19.936 14.016 32.832s-5.376 24.544-13.984 32.832v0l-532.096 468.448c-7.392 6.592-17.216 10.624-27.968 10.624-12.992 0-24.608-5.888-32.32-15.104l-0.064-0.064-66.432-78.944c-6.432-7.584-10.336-17.472-10.336-28.288 0-13.184 5.824-24.992 15.008-33.024l0.064-0.032 403.328-348.384c2.272-1.952 3.712-4.864 3.712-8.096s-1.44-6.112-3.712-8.064v0l-403.2-348.512c-8.48-7.392-14.048-17.888-14.88-29.728v-0.128c-0.096-1.12-0.16-2.464-0.16-3.776 0-10.656 3.904-20.416 10.368-27.872l-0.032 0.064 66.464-78.976c7.808-9.28 19.392-15.136 32.384-15.136 10.752 0 20.544 4 28 10.624l-0.032-0.032z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe930%3B%22 glyph-name%3D%22arrow-down-1%22 d%3D%22M513.696 155.008c-12.192 0-23.84 5.248-31.968 14.336l-474.624 536.48c-7.808 8.8-7.008 22.304 1.824 30.080 3.936 3.456 8.928 5.376 14.112 5.376 6.112 0 11.936-2.656 16-7.2l474.656-536.448 474.72 536.448c4.064 4.576 9.856 7.2 16 7.2 5.216 0 10.24-1.92 14.112-5.344 8.832-7.808 9.632-21.344 1.824-30.112l-474.72-536.48c-1.12-1.28-2.304-2.432-3.552-3.552-7.936-7.008-18.016-10.784-28.448-10.784z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe931%3B%22 glyph-name%3D%22arrow-up-1%22 d%3D%22M22.816 154.752c-5.216 0-10.208 1.888-14.112 5.344-8.832 7.808-9.632 21.344-1.888 30.112l474.72 536.448c1.12 1.28 2.336 2.528 3.68 3.68 7.808 6.912 17.824 10.72 28.256 10.72 12.256 0 23.904-5.248 32-14.368l474.72-536.448c7.808-8.832 6.944-22.304-1.824-30.112-3.936-3.456-8.928-5.344-14.112-5.344 0 0 0 0 0 0-6.112 0-11.904 2.592-15.968 7.168l-474.752 536.48-474.656-536.48c-4.064-4.576-9.888-7.168-16-7.168z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe932%3B%22 glyph-name%3D%22illuminated-sm%22 d%3D%22M567.467 153.6h-110.933c-21.333 0-42.667-17.067-42.667-42.667 0-21.333 17.067-42.667 42.667-42.667h110.933c21.333 0 42.667 17.067 42.667 42.667 0 21.333-21.333 42.667-42.667 42.667zM554.667 746.667v81.067c0 21.333-17.067 42.667-42.667 42.667s-42.667-17.067-42.667-42.667v-81.067c0-21.333 17.067-42.667 42.667-42.667s42.667 17.067 42.667 42.667zM209.067 482.133h-81.067c-21.333 0-42.667-17.067-42.667-42.667s17.067-42.667 42.667-42.667h81.067c21.333 0 42.667 17.067 42.667 42.667s-21.333 42.667-42.667 42.667zM896 482.133h-81.067c-21.333 0-42.667-17.067-42.667-42.667s17.067-42.667 42.667-42.667h81.067c21.333 0 42.667 17.067 42.667 42.667s-17.067 42.667-42.667 42.667zM221.867 733.867c-17.067 17.067-42.667 17.067-59.733 4.267s-17.067-42.667-4.267-59.733c0 0 4.267-4.267 4.267-4.267l68.267-68.267c17.067-17.067 42.667-17.067 59.733 0s17.067 42.667 0 55.467l-68.267 72.533zM857.6 674.133c17.067 17.067 17.067 42.667 0 59.733s-42.667 17.067-59.733 0c0 0 0 0 0 0l-68.267-68.267c-17.067-17.067-17.067-42.667 0-59.733s42.667-17.067 59.733 0c0 0 0 0 0 0l68.267 68.267zM512 635.733c-102.4 0-192-81.067-192-183.467 0-4.267 0-4.267 0-8.533-4.267-64 21.333-123.733 76.8-162.133 4.267-4.267 4.267-8.533 4.267-12.8v-17.067c0-17.067 12.8-25.6 25.6-25.6h166.4c17.067 0 25.6 12.8 25.6 25.6v21.333c0 4.267 4.267 8.533 4.267 12.8 51.2 34.133 81.067 98.133 76.8 162.133 0 102.4-81.067 192-183.467 192 0-4.267 0-4.267-4.267-4.267z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe933%3B%22 glyph-name%3D%22illuminated%22 d%3D%22M512 768c-166.4-4.267-294.4-132.267-298.667-298.667 0-106.667 55.467-209.067 149.333-260.267v-145.067c0-38.4 21.333-106.667 149.333-106.667s149.333 68.267 149.333 106.667v145.067c93.867 51.2 149.333 153.6 149.333 260.267-4.267 166.4-132.267 294.4-298.667 298.667zM618.667 106.667h-213.333v85.333h213.333v-85.333zM512 0c-106.667 0-106.667 46.933-106.667 64h213.333c0-17.067 0-64-106.667-64zM614.4 234.667h-204.8c-93.867 38.4-153.6 132.267-153.6 234.667 4.267 140.8 115.2 251.733 256 256 140.8-4.267 256-115.2 256-256 0-102.4-59.733-196.267-153.6-234.667zM512 832c12.8 0 21.333 8.533 21.333 21.333v85.333c0 12.8-8.533 21.333-21.333 21.333s-21.333-8.533-21.333-21.333v-85.333c0-12.8 8.533-21.333 21.333-21.333zM140.8 533.333h-98.133c-12.8 0-21.333-8.533-21.333-21.333s8.533-21.333 21.333-21.333h98.133c12.8 0 21.333 8.533 21.333 21.333s-8.533 21.333-21.333 21.333zM217.6 729.6c4.267-4.267 8.533-4.267 17.067-4.267s12.8 0 17.067 4.267c4.267 8.533 4.267 25.6 0 34.133l-85.333 85.333c-8.533 8.533-21.333 8.533-29.867 0s-8.533-25.6-4.267-34.133l85.333-85.333zM981.333 533.333h-98.133c-12.8 0-21.333-8.533-21.333-21.333s8.533-21.333 21.333-21.333h98.133c12.8 0 21.333 8.533 21.333 21.333s-8.533 21.333-21.333 21.333zM789.333 725.333c4.267 0 12.8 0 17.067 4.267l85.333 85.333c8.533 8.533 8.533 21.333 0 29.867s-21.333 8.533-29.867 0l-85.333-85.333c-8.533-8.533-8.533-21.333 0-29.867 0-4.267 8.533-4.267 12.8-4.267zM576 554.667c12.8 0 21.333 8.533 21.333 21.333s-8.533 21.333-21.333 21.333h-128c-12.8 0-21.333-8.533-21.333-21.333s8.533-21.333 21.333-21.333h42.667v-170.667h-42.667c-12.8 0-21.333-8.533-21.333-21.333s8.533-21.333 21.333-21.333h128c12.8 0 21.333 8.533 21.333 21.333s-8.533 21.333-21.333 21.333h-42.667v170.667h42.667z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe934%3B%22 glyph-name%3D%22md%22 d%3D%22M291.413 26.88h-2.987c-10.511 1.436-18.524 10.356-18.524 21.148 0 0.968 0.064 1.921 0.189 2.855l-0.012-0.109 105.813 768c-0.132 0.897-0.208 1.933-0.208 2.987 0 11.897 9.644 21.541 21.541 21.541 10.843 0 19.816-8.012 21.32-18.439l0.014-0.116 198.4-445.013 196.693 443.307c1.518 10.543 10.49 18.555 21.333 18.555 11.897 0 21.541-9.644 21.541-21.541 0-1.053-0.076-2.089-0.222-3.102l0.014 0.116 105.813-768c0.113-0.825 0.177-1.778 0.177-2.746 0-10.791-8.013-19.712-18.413-21.135l-0.111-0.012c-0.715-0.083-1.543-0.131-2.382-0.131-10.859 0-19.86 7.954-21.495 18.354l-0.016 0.123-97.707 693.76-187.733-420.693c-3.377-7.598-10.857-12.8-19.552-12.8-0.026 0-0.052 0-0.078 0h0.004c-0.022 0-0.048 0-0.074 0-8.695 0-16.176 5.202-19.498 12.664l-0.054 0.136-187.307 420.693-95.573-692.053c-1.505-10.354-10.269-18.235-20.895-18.347h-0.012zM185.6 26.88h-2.987c-10.511 1.436-18.524 10.356-18.524 21.148 0 0.968 0.064 1.921 0.189 2.855l-0.012-0.109 105.813 768c1.518 10.543 10.49 18.555 21.333 18.555 11.897 0 21.541-9.644 21.541-21.541 0-1.053-0.076-2.089-0.222-3.102l0.014 0.116-105.813-768c-1.702-10.224-10.481-17.922-21.059-17.922-0.097 0-0.193 0.001-0.289 0.002h0.015zM80.213 26.88h-2.987c-10.511 1.436-18.524 10.356-18.524 21.148 0 0.968 0.064 1.921 0.189 2.855l-0.012-0.109 105.813 768c1.21 10.502 10.050 18.58 20.777 18.58 1.1 0 2.18-0.085 3.234-0.249l-0.117 0.015c10.511-1.436 18.524-10.356 18.524-21.148 0-0.968-0.064-1.921-0.189-2.855l0.012 0.109-105.813-768c-1.505-10.354-10.269-18.235-20.895-18.347h-0.012z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe935%3B%22 glyph-name%3D%22md-created%22 d%3D%22M160.427 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.077-0.682-0.121-1.472-0.121-2.273 0-10.923 8.209-19.928 18.794-21.184l0.101-0.010h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.077 0.682 0.121 1.472 0.121 2.273 0 10.923-8.209 19.928-18.794 21.184l-0.101 0.010zM75.093 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.109-0.809-0.171-1.744-0.171-2.694 0-10.94 8.235-19.957 18.845-21.19l0.099-0.009h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.109 0.809 0.171 1.744 0.171 2.694 0 10.94-8.235 19.957-18.845 21.19l-0.099 0.009zM640 704c-63.486-0.389-123.209-16.123-175.764-43.674l2.11 1.008-31.147 279.893c0.055 0.575 0.086 1.244 0.086 1.92 0 11.83-9.59 21.42-21.42 21.42-11.154 0-20.316-8.525-21.327-19.415l-0.006-0.085-64-206.507-64.853 206.507c-1.017 10.974-10.18 19.5-21.333 19.5-11.83 0-21.42-9.59-21.42-21.42 0-0.676 0.031-1.345 0.093-2.005l-0.006 0.085-42.667-384c-0.082-0.704-0.129-1.52-0.129-2.347 0-11.853 9.609-21.462 21.462-21.462 11.026 0 20.111 8.315 21.324 19.017l0.009 0.098 31.573 283.307 55.893-174.507c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v0l55.040 174.933 20.48-197.547c-103.021-69.937-169.817-186.528-169.817-318.719 0-212.077 171.923-384 384-384s384 171.923 384 384c0 212.077-171.923 384-384 384-0.299 0-0.597 0-0.895-0.001h0.046zM853.333 286.72h-186.453v-186.88c-1.737-13.32-13.013-23.5-26.667-23.5s-24.93 10.18-26.652 23.365l-0.014 0.136v186.88h-186.88c-13.32 1.737-23.5 13.013-23.5 26.667s10.18 24.93 23.365 26.652l0.136 0.014h186.88v186.453c-0.136 1.015-0.213 2.188-0.213 3.38 0 14.845 12.035 26.88 26.88 26.88s26.88-12.035 26.88-26.88c0-1.191-0.078-2.365-0.228-3.515l0.014 0.136v-186.88h186.453c13.32-1.737 23.5-13.013 23.5-26.667s-10.18-24.93-23.365-26.652l-0.136-0.014z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe936%3B%22 glyph-name%3D%22md-diff%22 d%3D%22M160.427 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.077-0.682-0.121-1.472-0.121-2.273 0-10.923 8.209-19.928 18.794-21.184l0.101-0.010h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.077 0.682 0.121 1.472 0.121 2.273 0 10.923-8.209 19.928-18.794 21.184l-0.101 0.010zM75.093 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.109-0.809-0.171-1.744-0.171-2.694 0-10.94 8.235-19.957 18.845-21.19l0.099-0.009h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.109 0.809 0.171 1.744 0.171 2.694 0 10.94-8.235 19.957-18.845 21.19l-0.099 0.009zM472.747 197.12h334.507l-167.253 289.707-167.253-289.707zM640 704c-63.486-0.389-123.209-16.123-175.764-43.674l2.11 1.008-31.147 279.893c0.055 0.575 0.086 1.244 0.086 1.92 0 11.83-9.59 21.42-21.42 21.42-11.154 0-20.316-8.525-21.327-19.415l-0.006-0.085-64-206.507-64.853 206.507c-1.017 10.974-10.18 19.5-21.333 19.5-11.83 0-21.42-9.59-21.42-21.42 0-0.676 0.031-1.345 0.093-2.005l-0.006 0.085-42.667-384c-0.082-0.704-0.129-1.52-0.129-2.347 0-11.853 9.609-21.462 21.462-21.462 11.026 0 20.111 8.315 21.324 19.017l0.009 0.098 31.573 283.307 55.893-174.507c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v0l55.040 174.933 20.48-197.547c-103.021-69.937-169.817-186.528-169.817-318.719 0-212.077 171.923-384 384-384s384 171.923 384 384c0 212.077-171.923 384-384 384-0.299 0-0.597 0-0.895-0.001h0.046zM876.373 157.44c-4.659-7.963-13.169-13.227-22.909-13.227-0.046 0-0.092 0-0.138 0h-426.66c-14.69 0.203-26.521 12.159-26.521 26.878 0 4.863 1.291 9.424 3.55 13.36l-0.069-0.131 213.333 369.493c5.049 7.459 13.479 12.296 23.040 12.296s17.991-4.838 22.978-12.199l0.062-0.097 213.333-369.493c2.305-3.845 3.669-8.483 3.669-13.44s-1.363-9.595-3.735-13.561l0.067 0.121z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe937%3B%22 glyph-name%3D%22md-error%22 d%3D%22M160.427 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.077-0.682-0.121-1.472-0.121-2.273 0-10.923 8.209-19.928 18.794-21.184l0.101-0.010h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.077 0.682 0.121 1.472 0.121 2.273 0 10.923-8.209 19.928-18.794 21.184l-0.101 0.010zM75.093 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.109-0.809-0.171-1.744-0.171-2.694 0-10.94 8.235-19.957 18.845-21.19l0.099-0.009h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.109 0.809 0.171 1.744 0.171 2.694 0 10.94-8.235 19.957-18.845 21.19l-0.099 0.009zM640 704c-63.486-0.389-123.209-16.123-175.764-43.674l2.11 1.008-31.147 279.893c0.055 0.575 0.086 1.244 0.086 1.92 0 11.83-9.59 21.42-21.42 21.42-11.154 0-20.316-8.525-21.327-19.415l-0.006-0.085-64-206.507-64.853 206.507c-1.017 10.974-10.18 19.5-21.333 19.5-11.83 0-21.42-9.59-21.42-21.42 0-0.676 0.031-1.345 0.093-2.005l-0.006 0.085-42.667-384c-0.082-0.704-0.129-1.52-0.129-2.347 0-11.853 9.609-21.462 21.462-21.462 11.026 0 20.111 8.315 21.324 19.017l0.009 0.098 31.573 283.307 55.893-174.507c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v0l55.040 174.933 20.48-197.547c-103.021-69.937-169.817-186.528-169.817-318.719 0-212.077 171.923-384 384-384s384 171.923 384 384c0 212.077-171.923 384-384 384-0.299 0-0.597 0-0.895-0.001h0.046zM829.44 168.107c3.209-4.374 5.135-9.863 5.135-15.802 0-14.845-12.035-26.88-26.88-26.88-5.939 0-11.428 1.926-15.877 5.188l0.075-0.053-151.893 151.893-151.893-151.893c-4.374-3.209-9.863-5.135-15.802-5.135-14.845 0-26.88 12.035-26.88 26.88 0 5.939 1.926 11.428 5.188 15.877l-0.053-0.075 151.893 151.893-151.893 151.893c-4.805 4.805-7.776 11.442-7.776 18.773 0 14.663 11.887 26.55 26.55 26.55 7.331 0 13.969-2.972 18.773-7.776v0l151.893-151.893 151.893 151.893c4.374 3.209 9.863 5.135 15.802 5.135 14.845 0 26.88-12.035 26.88-26.88 0-5.939-1.926-11.428-5.188-15.877l0.053 0.075-151.893-151.893z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe938%3B%22 glyph-name%3D%22md-actuating%22 d%3D%22M832 454.4c-2.392 4.18-6.305 7.259-10.968 8.505l-0.125 0.028c-2.018 0.855-4.364 1.351-6.827 1.351s-4.809-0.497-6.945-1.395l0.118 0.044-25.6-14.507c-3.035-1.761-6.679-2.8-10.565-2.8-5.658 0-10.801 2.202-14.619 5.797l0.011-0.010c-18.199 16.929-40.16 30.080-64.47 38.049l-1.237 0.351c-8.728 2.807-14.934 10.854-14.934 20.351 0 0.045 0 0.091 0 0.136v-0.007 26.453c0 9.897-8.023 17.92-17.92 17.92v0h-39.253c-9.897 0-17.92-8.023-17.92-17.92v0-29.013c0-0.038 0-0.084 0-0.129 0-9.497-6.205-17.544-14.783-20.309l-0.151-0.042c-25.368-8.432-47.169-21.566-65.39-38.501l0.11 0.101c-3.807-3.584-8.951-5.786-14.608-5.786-3.886 0-7.53 1.039-10.668 2.855l0.103-0.055-26.027 14.933c-2.021 0.833-4.367 1.317-6.827 1.317s-4.806-0.484-6.949-1.362l0.122 0.044c-4.788-1.274-8.702-4.353-11.047-8.446l-0.046-0.088-19.627-34.133c-1.607-2.634-2.559-5.82-2.559-9.228 0-6.597 3.565-12.362 8.874-15.473l0.085-0.046 26.027-14.933c6.455-3.749 10.727-10.631 10.727-18.51 0-1.605-0.177-3.169-0.513-4.673l0.027 0.142c-2.598-11.284-4.087-24.241-4.087-37.547s1.489-26.263 4.31-38.715l-0.222 1.168c0.309-1.362 0.487-2.925 0.487-4.53 0-7.879-4.271-14.76-10.625-18.455l-0.102-0.055-25.6-14.933c-5.572-3.111-9.279-8.972-9.279-15.699 0-3.335 0.911-6.457 2.497-9.131l-0.045 0.083 19.627-34.133c3.156-5.394 8.921-8.959 15.518-8.959 3.408 0 6.595 0.952 9.307 2.604l25.521 14.462c3.035 1.761 6.679 2.8 10.565 2.8 5.658 0 10.801-2.202 14.619-5.797l-0.011 0.010c18.085-16.881 39.897-30.023 64.045-38.044l1.235-0.356c8.728-2.807 14.934-10.854 14.934-20.351 0-0.045 0-0.091 0-0.136v0.007-28.587c0-9.897 8.023-17.92 17.92-17.92v0h39.253c9.897 0 17.92 8.023 17.92 17.92v0 31.147c0 0.038 0 0.084 0 0.129 0 9.497 6.205 17.544 14.783 20.309l0.151 0.042c25.372 8.419 47.176 21.554 65.388 38.499l-0.108-0.099c3.807 3.584 8.951 5.786 14.608 5.786 3.886 0 7.53-1.039 10.668-2.855l-0.103 0.055 25.6-14.933c2.591-1.541 5.713-2.452 9.048-2.452 6.727 0 12.587 3.706 15.652 9.188l0.047 0.091 19.627 34.133c1.541 2.591 2.452 5.713 2.452 9.048 0 6.727-3.706 12.587-9.188 15.652l-0.091 0.047-25.6 14.933c-6.455 3.749-10.727 10.631-10.727 18.51 0 1.605 0.177 3.169 0.513 4.673l-0.027-0.142c2.618 11.284 4.118 24.24 4.118 37.547s-1.5 26.263-4.341 38.709l0.223-1.163c-0.309 1.362-0.487 2.925-0.487 4.53 0 7.879 4.271 14.76 10.625 18.455l0.102 0.055 25.6 14.933c5.394 3.156 8.959 8.921 8.959 15.518 0 3.408-0.952 6.595-2.604 9.307l0.045-0.079zM640 219.733c-0.508-0.009-1.107-0.015-1.707-0.015-55.376 0-100.267 44.891-100.267 100.267s44.891 100.267 100.267 100.267c55.371 0 100.258-44.883 100.267-100.251v-0.001c0-0.004 0-0.009 0-0.015 0-54.776-43.923-99.292-98.47-100.251l-0.090-0.001zM695.893 320c0-31.812-25.788-57.6-57.6-57.6s-57.6 25.788-57.6 57.6c0 31.812 25.788 57.6 57.6 57.6s57.6-25.788 57.6-57.6zM640 704c-63.486-0.389-123.209-16.123-175.764-43.674l2.11 1.008-31.147 279.893c0.055 0.575 0.086 1.244 0.086 1.92 0 11.83-9.59 21.42-21.42 21.42-11.154 0-20.316-8.525-21.327-19.415l-0.006-0.085-64-206.507-64.853 206.507c-1.017 10.974-10.18 19.5-21.333 19.5-11.83 0-21.42-9.59-21.42-21.42 0-0.676 0.031-1.345 0.093-2.005l-0.006 0.085-42.667-384c-0.082-0.704-0.129-1.52-0.129-2.347 0-11.853 9.609-21.462 21.462-21.462 11.026 0 20.111 8.315 21.324 19.017l0.009 0.098 31.573 283.307 55.893-174.507c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v0l55.040 174.933 20.48-197.547c-103.021-69.937-169.817-186.528-169.817-318.719 0-212.077 171.923-384 384-384s384 171.923 384 384c0 212.077-171.923 384-384 384-0.299 0-0.597 0-0.895-0.001h0.046zM853.333 288.853l12.8-7.253c18.244-10.669 30.306-30.164 30.306-52.477 0-11.155-3.015-21.606-8.274-30.582l0.155 0.286-19.627-34.133c-10.669-18.244-30.164-30.306-52.477-30.306-11.155 0-21.606 3.015-30.582 8.274l0.286-0.155-12.8 6.827c-15.719-12.654-33.735-23.408-53.154-31.464l-1.459-0.536v-14.080c0-33.461-27.126-60.587-60.587-60.587v0h-39.253c-33.461 0-60.587 27.126-60.587 60.587v0 13.653c-20.883 8.717-38.897 19.609-55.013 32.742l0.399-0.315-12.373-7.253c-8.663-5.009-19.057-7.965-30.141-7.965-22.32 0-41.841 11.985-52.478 29.871l-0.155 0.281-19.627 34.133c-5.123 8.74-8.148 19.247-8.148 30.461 0 22.394 12.065 41.971 30.050 52.584l0.285 0.155 12.8 7.253c-1.437 9.424-2.258 20.296-2.258 31.36s0.821 21.936 2.405 32.56l-0.147-1.2-12.8 7.253c-18.244 10.669-30.306 30.164-30.306 52.477 0 11.155 3.015 21.606 8.274 30.582l-0.155-0.286 19.627 34.133c10.669 18.244 30.164 30.306 52.477 30.306 11.155 0 21.606-3.015 30.582-8.274l-0.286 0.155 12.8-7.253c15.603 12.618 33.473 23.366 52.734 31.459l1.452 0.541v14.080c0 33.461 27.126 60.587 60.587 60.587v0h39.253c33.461 0 60.587-27.126 60.587-60.587v0-13.653c20.883-8.553 38.904-19.311 55.028-32.324l-0.415 0.324 12.373 7.253c8.691 5.104 19.142 8.119 30.297 8.119 22.312 0 41.808-12.061 52.322-30.019l0.155-0.286 19.627-34.133c5.104-8.691 8.119-19.142 8.119-30.297 0-22.312-12.061-41.808-30.019-52.322l-0.286-0.155-12.8-7.253c1.604-9.927 2.521-21.37 2.521-33.028 0-10.624-0.761-21.070-2.232-31.286l0.138 1.167zM160.427 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.077-0.682-0.121-1.472-0.121-2.273 0-10.923 8.209-19.928 18.794-21.184l0.101-0.010h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.077 0.682 0.121 1.472 0.121 2.273 0 10.923-8.209 19.928-18.794 21.184l-0.101 0.010zM75.093 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.109-0.809-0.171-1.744-0.171-2.694 0-10.94 8.235-19.957 18.845-21.19l0.099-0.009h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.109 0.809 0.171 1.744 0.171 2.694 0 10.94-8.235 19.957-18.845 21.19l-0.099 0.009z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe939%3B%22 glyph-name%3D%22md-flapping%22 d%3D%22M160.427 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.077-0.682-0.121-1.472-0.121-2.273 0-10.923 8.209-19.928 18.794-21.184l0.101-0.010h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.077 0.682 0.121 1.472 0.121 2.273 0 10.923-8.209 19.928-18.794 21.184l-0.101 0.010zM75.093 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.109-0.809-0.171-1.744-0.171-2.694 0-10.94 8.235-19.957 18.845-21.19l0.099-0.009h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.109 0.809 0.171 1.744 0.171 2.694 0 10.94-8.235 19.957-18.845 21.19l-0.099 0.009zM961.28 459.093c-29.507-0.242-53.333-24.217-53.333-53.758 0-0.001 0-0.001 0-0.002v0-183.467c-5.061-54.892-50.883-97.543-106.667-97.543s-101.606 42.651-106.635 97.122l-0.031 0.421v183.467c0.136 1.434 0.213 3.1 0.213 4.785 0 29.691-24.069 53.76-53.76 53.76s-53.76-24.069-53.76-53.76c0-1.684 0.077-3.351 0.229-4.996l-0.016 0.211v-183.467c-5.061-54.892-50.883-97.543-106.667-97.543s-101.606 42.651-106.635 97.122l-0.031 0.421v183.467c0 29.691-24.069 53.76-53.76 53.76v0c-19.494-0.156-36.46-10.831-45.517-26.622l-0.136-0.258c-10.692-33.656-16.853-72.365-16.853-112.514 0-212.077 171.923-384 384-384s384 171.923 384 384c0 40.148-6.161 78.858-17.59 115.234l0.737-2.72c-9.256 16.18-26.414 26.908-46.078 26.908-0.601 0-1.199-0.010-1.796-0.030l0.087 0.002zM426.667 405.333v-183.467c0-29.691 24.069-53.76 53.76-53.76s53.76 24.069 53.76 53.76v0 183.467c-0.272 2.862-0.427 6.188-0.427 9.55 0 59.146 47.947 107.093 107.093 107.093s107.093-47.947 107.093-107.093c0-3.362-0.155-6.688-0.458-9.971l0.031 0.421v-183.467c2.536-27.56 25.54-48.975 53.547-48.975s51.011 21.416 53.531 48.764l0.016 0.211v183.467c0 59.146 47.947 107.093 107.093 107.093v0h11.093c-67.778 114.957-190.974 190.873-331.9 190.873-63.71 0-123.797-15.515-176.687-42.974l2.134 1.008-31.147 279.893c0.055 0.575 0.086 1.244 0.086 1.92 0 11.83-9.59 21.42-21.42 21.42-11.154 0-20.316-8.525-21.327-19.415l-0.006-0.085-64-206.507-64.853 206.507c-1.017 10.974-10.18 19.5-21.333 19.5-11.83 0-21.42-9.59-21.42-21.42 0-0.676 0.031-1.345 0.093-2.005l-0.006 0.085-42.667-384c-0.082-0.704-0.129-1.52-0.129-2.347 0-11.853 9.609-21.462 21.462-21.462 11.026 0 20.111 8.315 21.324 19.017l0.009 0.098 31.573 283.307 55.893-174.507c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v0l55.040 174.933 20.48-197.547c-48.68-33.351-88.397-76.202-117.199-126.143l-0.988-1.857h11.52c58.369-0.232 105.709-47.124 106.665-105.297l0.001-0.090z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe93a%3B%22 glyph-name%3D%22md-paused%22 d%3D%22M160.427 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.077-0.682-0.121-1.472-0.121-2.273 0-10.923 8.209-19.928 18.794-21.184l0.101-0.010h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.077 0.682 0.121 1.472 0.121 2.273 0 10.923-8.209 19.928-18.794 21.184l-0.101 0.010zM75.093 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.109-0.809-0.171-1.744-0.171-2.694 0-10.94 8.235-19.957 18.845-21.19l0.099-0.009h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.109 0.809 0.171 1.744 0.171 2.694 0 10.94-8.235 19.957-18.845 21.19l-0.099 0.009zM640 704c-63.486-0.389-123.209-16.123-175.764-43.674l2.11 1.008-31.147 279.893c0.055 0.575 0.086 1.244 0.086 1.92 0 11.83-9.59 21.42-21.42 21.42-11.154 0-20.316-8.525-21.327-19.415l-0.006-0.085-64-206.507-64.853 206.507c-1.017 10.974-10.18 19.5-21.333 19.5-11.83 0-21.42-9.59-21.42-21.42 0-0.676 0.031-1.345 0.093-2.005l-0.006 0.085-42.667-384c-0.082-0.704-0.129-1.52-0.129-2.347 0-11.853 9.609-21.462 21.462-21.462 11.026 0 20.111 8.315 21.324 19.017l0.009 0.098 31.573 283.307 55.893-174.507c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v0l55.040 174.933 20.48-197.547c-103.021-69.937-169.817-186.528-169.817-318.719 0-212.077 171.923-384 384-384s384 171.923 384 384c0 212.077-171.923 384-384 384-0.299 0-0.597 0-0.895-0.001h0.046zM560.213 142.080c-1.737-13.32-13.013-23.5-26.667-23.5s-24.93 10.18-26.652 23.365l-0.014 0.136v369.92c1.737 13.32 13.013 23.5 26.667 23.5s24.93-10.18 26.652-23.365l0.014-0.136zM773.547 142.080c0.136-1.015 0.213-2.188 0.213-3.38 0-14.845-12.035-26.88-26.88-26.88s-26.88 12.035-26.88 26.88c0 1.191 0.078 2.365 0.228 3.515l-0.014-0.136v369.92c1.737 13.32 13.013 23.5 26.667 23.5s24.93-10.18 26.652-23.365l0.014-0.136z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe93b%3B%22 glyph-name%3D%22md-unknown%22 d%3D%22M160.427 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.077-0.682-0.121-1.472-0.121-2.273 0-10.923 8.209-19.928 18.794-21.184l0.101-0.010h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.077 0.682 0.121 1.472 0.121 2.273 0 10.923-8.209 19.928-18.794 21.184l-0.101 0.010zM75.093 960c-0.57 0.053-1.232 0.083-1.901 0.083-10.994 0-20.083-8.153-21.552-18.742l-0.013-0.114-42.667-384c-0.109-0.809-0.171-1.744-0.171-2.694 0-10.94 8.235-19.957 18.845-21.19l0.099-0.009h2.133c0.046 0 0.1-0.001 0.154-0.001 10.88 0 19.858 8.145 21.169 18.67l0.011 0.104 42.667 384c0.109 0.809 0.171 1.744 0.171 2.694 0 10.94-8.235 19.957-18.845 21.19l-0.099 0.009zM640 704c-63.486-0.389-123.209-16.123-175.764-43.674l2.11 1.008-31.147 279.893c0.055 0.575 0.086 1.244 0.086 1.92 0 11.83-9.59 21.42-21.42 21.42-11.154 0-20.316-8.525-21.327-19.415l-0.006-0.085-64-206.507-64.853 206.507c-1.017 10.974-10.18 19.5-21.333 19.5-11.83 0-21.42-9.59-21.42-21.42 0-0.676 0.031-1.345 0.093-2.005l-0.006 0.085-42.667-384c-0.082-0.704-0.129-1.52-0.129-2.347 0-11.853 9.609-21.462 21.462-21.462 11.026 0 20.111 8.315 21.324 19.017l0.009 0.098 31.573 283.307 55.893-174.507c0-11.782 9.551-21.333 21.333-21.333s21.333 9.551 21.333 21.333v0l55.040 174.933 20.48-197.547c-103.021-69.937-169.817-186.528-169.817-318.719 0-212.077 171.923-384 384-384s384 171.923 384 384c0 212.077-171.923 384-384 384-0.299 0-0.597 0-0.895-0.001h0.046zM645.547 42.667c-21.208 0-38.4 17.192-38.4 38.4s17.192 38.4 38.4 38.4c21.208 0 38.4-17.192 38.4-38.4v0c0-21.208-17.192-38.4-38.4-38.4v0zM672.427 277.333v-42.667c-1.737-13.32-13.013-23.5-26.667-23.5s-24.93 10.18-26.652 23.365l-0.014 0.136v68.267c0.24 14.661 12.181 26.453 26.877 26.453 0.001 0 0.002 0 0.004 0v0c56.083 0 101.547 45.464 101.547 101.547s-45.464 101.547-101.547 101.547c-56.083 0-101.547-45.464-101.547-101.547v0c-1.737-13.32-13.013-23.5-26.667-23.5s-24.93 10.18-26.652 23.365l-0.014 0.136c0.565 85.108 69.689 153.884 154.877 153.884 85.538 0 154.88-69.342 154.88-154.88 0-76.19-55.014-139.531-127.486-152.465l-0.937-0.139z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe93c%3B%22 glyph-name%3D%22servergroup-aws%22 d%3D%22M490.667 618.667l341.333 106.667-315.733 106.667c0 0-4.267 0-4.267 0s-4.267 0-4.267 0l-320-106.667 302.933-106.667zM128 695.467c0 0 0 0 0 0v-452.267c0-8.533 4.267-17.067 12.8-21.333l328.533-149.333v507.733l-341.333 115.2zM512 72.533l371.2 153.6c8.533 4.267 12.8 12.8 12.8 21.333v443.733c0 0 0 4.267 0 4.267l-384-115.2v-507.733zM490.667 21.333c-4.267 0-8.533 0-12.8 4.267-4.267 0-4.267 0-8.533 4.267l-341.333 153.6c-25.6 8.533-42.667 34.133-42.667 59.733v448c0 17.067 4.267 29.867 17.067 42.667 0 0 0 0 0 0 8.533 12.8 21.333 17.067 29.867 21.333l362.667 115.2c4.267 0 8.533 0 17.067 0 4.267 0 12.8 0 17.067 0l362.667-115.2c12.8-4.267 21.333-8.533 29.867-17.067 0 0 0 0 0 0 8.533-12.8 17.067-25.6 17.067-42.667v-448c0-25.6-17.067-51.2-42.667-59.733l-384-157.867c-4.267 0-4.267 0-8.533-4.267s-8.533-4.267-12.8-4.267z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe93d%3B%22 glyph-name%3D%22app-window-sm%22 d%3D%22M192 106.496c-58.837 0-106.667 47.872-106.667 106.667v469.333c0 58.837 47.829 106.667 106.667 106.667h640c58.795 0 106.667-47.829 106.667-106.667v-469.333c0-58.795-47.872-106.667-106.667-106.667h-640zM128 213.163c0-35.285 28.715-64 64-64h640c35.285 0 64 28.715 64 64v362.667h-768v-362.667zM896 618.496v64c0 35.285-28.715 64-64 64h-640c-35.285 0-64-28.715-64-64v-64h768zM234.667 650.496c-17.664 0-32 14.336-32 32 0 16 11.819 29.44 27.648 31.616 0.043 0 0.085 0 0.128 0 0.683 0.128 1.621 0.256 2.347 0.256 0.469 0.043 1.365 0.128 1.877 0.128 0.597 0 1.237-0.043 1.835-0.128l1.067-0.128c15.957-1.024 29.099-15.019 29.099-31.744 0-17.621-14.336-32-32-32zM320 650.496c-17.664 0-32 14.336-32 32 0 16.939 13.269 30.933 30.251 31.872 0.427 0.085 1.067 0.128 1.749 0.128 17.664 0 32-14.336 32-32s-14.336-32-32-32zM405.333 650.496c-17.664 0-32 14.336-32 32 0 16 11.861 29.44 27.691 31.616 0.128 0.043 0.213 0.043 0.299 0.085 0.555 0.085 1.707 0.213 2.261 0.213 0.341 0.043 1.024 0.085 1.749 0.085 0.427 0 1.792-0.128 1.92-0.128 16.597-0.683 30.080-14.677 30.080-31.872 0-17.621-14.336-32-32-32z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe93e%3B%22 glyph-name%3D%22cluster%22 d%3D%22M298.667 789.333v-128h-128v128h128zM298.667 832h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0zM597.333 789.333v-128h-128v128h128zM597.333 832h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0zM896 789.333v-128h-128v128h128zM896 832h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0zM298.667 490.667v-128h-128v128h128zM298.667 533.333h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0zM597.333 490.667v-128h-128v128h128zM597.333 533.333h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0zM896 490.667v-128h-128v128h128zM896 533.333h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0zM298.667 192v-128h-128v128h128zM298.667 234.667h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0zM597.333 192v-128h-128v128h128zM597.333 234.667h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0zM896 192v-128h-128v128h128zM896 234.667h-128c-25.6 0-42.667-17.067-42.667-42.667v-128c0-25.6 17.067-42.667 42.667-42.667h128c25.6 0 42.667 17.067 42.667 42.667v128c0 25.6-17.067 42.667-42.667 42.667v0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe93f%3B%22 glyph-name%3D%22label%22 d%3D%22M640.64-55.168c-16.939 0-32.896 6.528-44.928 18.389l-558.976 558.933c-21.888 24.32-34.688 54.997-36.437 86.784l-0.299 278.187c0 35.328 28.715 64 64 64h276.992c32.683-1.707 63.445-14.379 87.125-35.627l589.611-589.952c8.32-8.32 8.32-21.845 0-30.165l-331.861-331.819c-12.075-12.075-28.117-18.731-45.227-18.731 0 0 0 0 0 0zM64 908.501c-11.776 0-21.333-9.557-21.333-21.333l0.299-277.035c1.195-21.163 9.984-42.197 24.747-58.624l557.568-557.525c4.309-4.267 9.643-6.485 15.36-6.485s11.051 2.219 15.061 6.229l316.8 316.757-573.739 574.080c-15.701 14.080-36.651 22.699-58.624 23.936h-276.139zM234.667 609.835c-58.837 0-106.667 47.829-106.667 106.667s47.829 106.667 106.667 106.667 106.667-47.872 106.667-106.667-47.872-106.667-106.667-106.667zM234.667 780.501c-35.285 0-64-28.715-64-64s28.715-64 64-64 64 28.715 64 64-28.715 64-64 64z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe940%3B%22 glyph-name%3D%22md-resumed%22 d%3D%22M160.354 959.875c-0.64 0.067-1.383 0.106-2.134 0.106-10.997 0-20.073-8.222-21.418-18.853l-0.011-0.107-42.667-384c-0.082-0.701-0.128-1.514-0.128-2.338 0-10.959 8.253-19.99 18.883-21.216l0.099-0.009c0.712-0.080 1.538-0.125 2.375-0.125v0c10.946 0.010 19.961 8.26 21.178 18.881l0.009 0.098 42.667 384c0.082 0.701 0.128 1.514 0.128 2.338 0 10.959-8.253 19.99-18.883 21.216l-0.099 0.009zM75.021 959.875c-0.617 0.062-1.334 0.098-2.060 0.098-11.011 0-20.104-8.21-21.491-18.843l-0.012-0.109-42.667-384c-0.082-0.701-0.128-1.514-0.128-2.338 0-10.959 8.253-19.99 18.883-21.216l0.099-0.009c0.712-0.080 1.538-0.125 2.375-0.125v0c10.946 0.010 19.961 8.26 21.178 18.881l0.009 0.098 42.667 384c0.082 0.701 0.128 1.514 0.128 2.338 0 10.959-8.253 19.99-18.883 21.216l-0.099 0.009zM640 704c-63.448-0.017-123.274-15.507-175.916-42.901l2.116 1.002-30.992 278.92c-1.23 10.724-10.255 18.976-21.208 18.976-9.498 0-17.547-6.206-20.313-14.784l-0.042-0.151-64.958-206.667-64.875 206.667c-2.809 8.728-10.857 14.933-20.355 14.933-10.952 0-19.977-8.251-21.198-18.875l-0.009-0.099-42.792-384c-0.083-0.706-0.13-1.525-0.13-2.354 0-11.785 9.554-21.339 21.339-21.339 10.956 0 19.983 8.256 21.199 18.886l0.009 0.098 31.562 283.314 54.875-174.814c2.807-8.73 10.855-14.937 20.354-14.937s17.548 6.207 20.312 14.786l0.042 0.151 54.959 174.833 21.877-196.89c-103.058-69.936-169.881-186.548-169.881-318.769 0-212.085 171.929-384.013 384.013-384.013s384.013 171.929 384.013 384.013c0 212.081-171.922 384.007-384.001 384.013v0zM836.505 300.919l-307.677-153.839c-3.933-2.857-8.857-4.57-14.182-4.57-13.415 0-24.289 10.875-24.289 24.289 0 1.365 0.113 2.705 0.329 4.009l-0.019-0.142v298.667c-0.197 1.163-0.31 2.502-0.31 3.867 0 13.415 10.875 24.289 24.289 24.289 5.325 0 10.249-1.713 14.252-4.619l-0.070 0.049 307.677-153.839c20.989-10.495 20.989-27.667 0-38.161z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe941%3B%22 glyph-name%3D%22search-slash%22 d%3D%22M853.333 917.333c72.533 0 128-55.467 128-128v-682.667c0-72.533-55.467-128-128-128h-682.667c-72.533 0-128 55.467-128 128v682.667c0 72.533 55.467 128 128 128h682.667zM853.333 960h-682.667c-93.867 0-170.667-76.8-170.667-170.667v-682.667c0-93.867 76.8-170.667 170.667-170.667h682.667c93.867 0 170.667 76.8 170.667 170.667v682.667c0 93.867-76.8 170.667-170.667 170.667v0zM426.667 106.667h-85.333l256 682.667h85.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe942%3B%22 glyph-name%3D%22navigation-out%22 d%3D%22M357.845 277.333c-11.776 0-21.333 9.557-21.333 21.333v85.333c0 105.856 86.144 192 192 192h401.408l-134.315 134.315c-8.32 8.32-8.32 21.845 0 30.165 4.011 4.053 9.387 6.272 15.061 6.272s11.051-2.219 15.104-6.229l170.667-170.667c3.925-3.925 6.101-9.088 6.229-14.592 0-0.213 0-0.384 0-0.597 0-2.048-0.427-3.627-0.683-4.523-0.085-0.555-0.256-1.963-0.939-3.584-1.024-2.645-2.773-5.205-5.077-7.381l-170.197-170.197c-4.011-4.011-9.387-6.229-15.104-6.229s-11.051 2.219-15.104 6.229c-8.32 8.32-8.32 21.845 0 30.165l134.187 134.187h-401.237c-82.347 0-149.333-66.987-149.333-149.333v-85.333c0-11.776-9.557-21.333-21.333-21.333zM59.179 106.667c-35.285 0-64 28.715-64 64v512c0 35.285 28.715 64 64 64h512c35.285 0 64-28.715 64-64v-21.333c0-11.776-9.557-21.333-21.333-21.333s-21.333 9.557-21.333 21.333v21.333c0 11.776-9.557 21.333-21.333 21.333h-512c-11.776 0-21.333-9.557-21.333-21.333v-512c0-11.776 9.557-21.333 21.333-21.333h512c11.776 0 21.333 9.557 21.333 21.333v234.667c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-234.667c0-35.285-28.715-64-64-64h-512z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe943%3B%22 glyph-name%3D%22update%22 d%3D%22M512 605.44c0.050 0 0.11 0 0.169 0 13.53 0 25.579-6.338 33.341-16.208l0.069-0.091 425.429-541.483c5.692-7.184 9.131-16.378 9.131-26.375 0-23.56-19.099-42.659-42.659-42.659-0.003 0-0.005 0-0.008 0l-850.858 0.128c-23.553 0.002-42.645 19.095-42.645 42.648 0 9.984 3.431 19.166 9.177 26.433l-0.068-0.089 425.429 541.397c2.122 2.691 4.477 5.046 7.079 7.1l0.089 0.068c7.172 5.68 16.346 9.117 26.322 9.131h0.003zM512.043 562.773l-425.429-541.355 850.859-0.085zM512 946.773c0.048 0 0.104 0 0.16 0 13.524 0 25.571-6.32 33.35-16.167l0.068-0.089 425.557-541.483c5.692-7.184 9.131-16.378 9.131-26.375 0-23.56-19.099-42.659-42.659-42.659-0.003 0-0.005 0-0.008 0h-105.557c-11.782 0-21.333 9.551-21.333 21.333s9.551 21.333 21.333 21.333v0h105.557l-425.557 541.483-425.429-541.397h105.429c11.782 0 21.333-9.551 21.333-21.333s-9.551-21.333-21.333-21.333v0h-105.429c-23.553 0.002-42.645 19.095-42.645 42.648 0 9.984 3.431 19.166 9.177 26.433l-0.068-0.089 425.429 541.397c2.122 2.691 4.477 5.046 7.079 7.1l0.089 0.068c7.172 5.68 16.346 9.117 26.322 9.131h0.003z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe944%3B%22 glyph-name%3D%22skull%22 d%3D%22M197.987 920.812c48.918-0.023 88.566-39.685 88.566-88.606 0-14.075-3.282-27.384-9.122-39.203l0.232 0.518 78.809-78.73c43.551 30.177 97.512 48.207 155.684 48.207 58.074 0 111.952-17.969 156.375-48.651l-0.921 0.602 78.769 78.651c-5.451 11.168-8.638 24.3-8.638 38.176 0 48.977 39.704 88.681 88.681 88.681 24.498 0 46.676-9.934 62.726-25.993v0l69.553-69.475c16.207-16.072 26.24-38.347 26.24-62.965 0-48.969-39.697-88.666-88.666-88.666-14.025 0-27.289 3.256-39.078 9.054l0.521-0.232-90.505-90.427c12.954-30.728 20.48-66.45 20.48-103.931 0-0.182 0-0.364-0.001-0.546v0.028c-0.146-58.099-18.12-111.97-48.737-156.467l0.609 0.937 118.115-118.233c11.158 5.483 24.285 8.693 38.16 8.704h0.004c4.481-0.008 8.878-0.337 13.177-0.965l-0.495 0.059c24.013-3.447 44.542-16.152 58.206-34.315l0.162-0.226c11.010-14.647 17.631-33.139 17.631-53.177 0-24.535-9.927-46.751-25.983-62.851l0.002 0.002-69.475-69.553c-15.87-16.167-37.925-26.216-62.328-26.309h-0.727v0.039c-0.001 0-0.003 0-0.005 0-48.941 0-88.615 39.674-88.615 88.615 0 14.087 3.287 27.407 9.136 39.234l-0.232-0.518-57.187 57.226c-14.437-16.382-35.466-26.663-58.896-26.663-0.022 0-0.044 0-0.066 0h0.003c-23.485 0.084-44.55 10.373-59.006 26.66l-0.071 0.082c-14.482-16.431-35.575-26.742-59.077-26.742s-44.595 10.311-59.003 26.656l-0.074 0.086c-14.537-16.355-35.596-26.639-59.059-26.742h-0.018c-0.028 0-0.061 0-0.094 0-23.373 0-44.356 10.232-58.714 26.462l-0.072 0.083-57.264-57.108c5.6-11.295 8.877-24.595 8.877-38.662 0-48.949-39.681-88.629-88.629-88.629-24.706 0-47.051 10.109-63.124 26.416l-0.010 0.011-69.435 69.514c-16.098 16.051-26.059 38.25-26.059 62.775 0 44.537 32.846 81.402 75.635 87.695l0.482 0.058c3.804 0.568 8.201 0.897 12.673 0.906h0.009c13.879-0.006 27.006-3.217 38.684-8.934l-0.52 0.23 118.154 118.272c-29.95 43.542-47.913 97.358-48.128 155.358v0.054c0 0.093 0 0.203 0 0.312 0 37.517 7.556 73.27 21.23 105.818l-0.671-1.801-90.545 90.545c-11.284-5.566-24.565-8.822-38.607-8.822-24.72 0-47.083 10.092-63.195 26.38l-0.008 0.008c-15.757 15.98-25.488 37.938-25.488 62.169 0 24.7 10.112 47.039 26.421 63.103l69.486 69.486c15.945 16.219 38.121 26.27 62.644 26.27 0.145 0 0.289 0 0.434-0.001h-0.022zM309.091 300.78l-125.795-125.913c-3.58-3.554-8.511-5.75-13.956-5.75-4.445 0-8.548 1.464-11.854 3.936l0.052-0.037c-8.069 6.146-18.289 9.846-29.374 9.846-0.030 0-0.060 0-0.090 0h0.005c-0.043 0-0.094 0-0.145 0-2.437 0-4.83-0.186-7.166-0.545l0.261 0.033c-13.335-1.912-24.737-8.967-32.323-19.055l-0.090-0.125c-6.117-8.132-9.796-18.4-9.796-29.528 0-13.629 5.519-25.968 14.444-34.906l69.553-69.631c8.943-9.141 21.404-14.809 35.189-14.809 27.179 0 49.213 22.033 49.213 49.213 0 11.252-3.776 21.621-10.13 29.911l0.087-0.118c-2.491 3.274-3.99 7.42-3.99 11.916 0 5.448 2.201 10.382 5.763 13.96l-0.001-0.001 77.627 77.43c-0.937 4.505-1.481 9.687-1.497 14.993v82.799c-1.969 2.048-3.978 4.135-5.986 6.38zM714.949 300.82q-3.013-3.308-6.026-6.38v-82.747c-0.001-5.227-0.531-10.329-1.541-15.257l0.083 0.488 77.588-77.706c3.548-3.567 5.741-8.485 5.741-13.915 0-4.5-1.506-8.649-4.042-11.969l0.035 0.048c-6.243-8.17-10.003-18.528-10.003-29.764 0-13.716 5.603-26.123 14.645-35.058l0.005-0.005c9.053-8.772 21.41-14.179 35.031-14.179 0.021 0 0.043 0 0.064 0h-0.003c13.54 0.109 25.751 5.71 34.532 14.682l0.008 0.009 69.632 69.711c8.938 8.948 14.465 21.304 14.465 34.95 0 11.123-3.672 21.389-9.87 29.65l0.092-0.128c-7.677 10.213-19.078 17.269-32.151 19.149l-0.262 0.031c-2.083 0.326-4.486 0.512-6.932 0.512-0.041 0-0.083 0-0.124 0h0.006c-11.113 0-21.361-3.7-29.581-9.935l0.122 0.089c-3.256-2.459-7.371-3.939-11.831-3.939-5.435 0-10.357 2.197-13.927 5.751l0.001-0.001zM512 723.613c-130.511-0.009-236.307-105.811-236.307-236.323 0-66.975 27.861-127.442 72.624-170.445l0.079-0.076c3.74-3.575 6.065-8.604 6.065-14.176 0-0.001 0-0.002 0-0.003v0-90.979c0.052-4.899 1.002-9.562 2.691-13.852l-0.092 0.264 0.039-0.157c5.709-15.099 20.044-25.64 36.842-25.64 21.699 0 39.289 17.59 39.289 39.289 0 0.034 0 0.068 0 0.102v-0.005c0 10.876 8.817 19.692 19.692 19.692s19.692-8.817 19.692-19.692v0c0-0.038 0-0.084 0-0.13 0-21.752 17.633-39.385 39.385-39.385s39.385 17.633 39.385 39.385c0 0.046 0 0.091 0 0.137v-0.007c0 10.876 8.817 19.692 19.692 19.692s19.692-8.817 19.692-19.692v0c0-0.038 0-0.084 0-0.13 0-21.752 17.633-39.385 39.385-39.385s39.385 17.633 39.385 39.385c0 0.046 0 0.091 0 0.137v-0.007 90.979c0 0.005 0 0.011 0 0.017 0 5.587 2.341 10.627 6.096 14.193l0.008 0.008c44.823 43.152 72.665 103.67 72.665 170.69 0 36.482-8.25 71.037-22.985 101.902l0.614-1.429-0.512 1.181c-39.107 80.108-119.919 134.342-213.409 134.459h-0.016zM512 357.297c24.342-0.492 45.232-14.783 55.212-35.349l0.163-0.373c2.151-3.131 3.435-7.004 3.435-11.177 0-6.797-3.407-12.798-8.607-16.388l-0.067-0.043c-3.138-2.1-6.992-3.361-11.139-3.387h-0.007c-0.004 0-0.009 0-0.014 0-6.643 0-12.496 3.381-15.933 8.516l-0.044 0.069c-10.713 16.029-13.312 18.787-23.001 18.787-9.531 0-11.894-1.93-22.922-18.668-1.782-2.696-4.801-4.45-8.228-4.45-2.009 0-3.878 0.603-5.435 1.637l0.036-0.023-16.463 10.791c-2.152 1.414-3.696 3.601-4.242 6.159l-0.011 0.064c-0.138 0.611-0.217 1.313-0.217 2.034 0 2.003 0.611 3.863 1.656 5.404l-0.022-0.034c9.962 21.417 31.151 36.074 55.801 36.43l0.046 0.001zM393.846 566.075c43.503 0 78.769-35.266 78.769-78.769s-35.266-78.769-78.769-78.769c-43.503 0-78.769 35.266-78.769 78.769v0c0.045 43.485 35.284 78.724 78.765 78.769h0.004zM630.154 566.075c43.503 0 78.769-35.266 78.769-78.769s-35.266-78.769-78.769-78.769c-43.503 0-78.769 35.266-78.769 78.769v0c0.045 43.485 35.284 78.724 78.765 78.769h0.004zM393.846 526.69c-21.752 0-39.385-17.633-39.385-39.385s17.633-39.385 39.385-39.385c21.752 0 39.385 17.633 39.385 39.385v0c-0.037 21.737-17.648 39.348-39.381 39.385h-0.004zM630.154 526.69c-21.752 0-39.385-17.633-39.385-39.385s17.633-39.385 39.385-39.385c21.752 0 39.385 17.633 39.385 39.385v0c-0.022 21.743-17.642 39.363-39.383 39.385h-0.002zM198.026 881.467c-0.061 0-0.134 0-0.207 0-13.673 0-26.036-5.606-34.917-14.644l-69.718-69.718c-9.101-8.94-14.741-21.376-14.741-35.13 0-27.189 22.041-49.231 49.231-49.231 11.23 0 21.582 3.76 29.866 10.090l-0.119-0.087c3.271 2.507 7.421 4.017 11.924 4.017 5.45 0 10.384-2.213 13.951-5.789v0l92.16-92.199c14.198 23.477 30.785 43.661 49.859 61.181l0.199 0.181-86.567 86.488c-3.569 3.565-5.776 8.491-5.776 13.934 0 4.494 1.505 8.636 4.039 11.95l-0.035-0.048c6.273 8.173 10.052 18.546 10.052 29.802 0 27.173-22.028 49.202-49.201 49.203v0zM826.171 881.112c-27.139-0.007-49.136-22.009-49.136-49.148 0-11.143 3.709-21.421 9.959-29.665l-0.089 0.122c2.435-3.26 3.899-7.369 3.899-11.82 0-5.432-2.18-10.354-5.713-13.94l0.002 0.002-86.528-86.41c2.954-2.717 5.75-5.356 8.389-7.995 15.653-15.629 29.444-33.117 41.016-52.105l0.692-1.222 92.042 92.081c3.574 3.554 8.501 5.75 13.941 5.75 4.487 0 8.626-1.495 11.944-4.014l-0.049 0.036c8.176-6.269 18.55-10.046 29.807-10.046 27.194 0 49.24 22.045 49.24 49.24 0 13.731-5.62 26.149-14.686 35.080l-0.006 0.006-69.711 69.593c-8.884 8.929-21.181 14.455-34.769 14.455-0.086 0-0.172 0-0.258-0.001h0.013z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe945%3B%22 glyph-name%3D%22template-add%22 d%3D%22M65.792-64c-35.285 0-64 28.715-64 64v896c0 35.285 28.715 64 64 64h567.168c17.024-0.128 33.579-7.125 45.397-19.2l157.995-157.696c12.117-12.117 18.773-28.16 18.773-45.269v-140.501c0-11.776-9.557-21.333-21.333-21.333s-21.333 9.557-21.333 21.333v140.501c0 5.675-2.219 11.051-6.229 15.061l-158.165 157.867c-4.096 4.181-9.6 6.528-15.232 6.571h-567.040c-11.776 0-21.333-9.557-21.333-21.333v-896c0-11.776 9.557-21.333 21.333-21.333h384c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-384zM279.125 383.829c-5.717 0-11.051 2.219-15.104 6.229l-128 128c-4.011 4.011-6.229 9.387-6.229 15.104s2.219 11.051 6.229 15.104l128 128c4.011 4.011 9.387 6.229 15.104 6.229s11.051-2.219 15.104-6.229 6.229-9.387 6.229-15.104-2.219-11.051-6.229-15.061l-112.896-112.896 112.896-112.896c4.011-4.011 6.229-9.387 6.229-15.104s-2.219-11.051-6.229-15.104-9.387-6.272-15.104-6.272zM407.125 383.829c-5.717 0-11.051 2.219-15.104 6.229s-6.229 9.387-6.229 15.104 2.219 11.051 6.229 15.104l112.896 112.896-112.896 112.939c-4.011 4.011-6.229 9.387-6.229 15.104s2.219 11.008 6.229 15.061 9.387 6.229 15.104 6.229 11.051-2.219 15.104-6.229l128-128c4.011-4.011 6.229-9.387 6.229-15.104s-2.219-11.051-6.229-15.104l-128-128c-4.053-4.011-9.387-6.229-15.104-6.229zM748.459-64.171c-152.917 0-277.333 124.416-277.333 277.333s124.416 277.333 277.333 277.333 277.333-124.416 277.333-277.333-124.416-277.333-277.333-277.333zM748.459 447.829c-129.408 0-234.667-105.259-234.667-234.667s105.259-234.667 234.667-234.667 234.667 105.259 234.667 234.667-105.259 234.667-234.667 234.667zM748.459 63.829c-11.776 0-21.333 9.557-21.333 21.333v106.667h-106.667c-11.776 0-21.333 9.557-21.333 21.333s9.557 21.333 21.333 21.333h106.667v106.667c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-106.667h106.667c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-106.667v-106.667c0-11.776-9.557-21.333-21.333-21.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe946%3B%22 glyph-name%3D%22close-small%22 d%3D%22M307.499 213.333l240.916 240.916c3.77 3.844 6.096 9.116 6.096 14.93 0 11.781-9.55 21.331-21.331 21.331-5.815 0-11.086-2.327-14.934-6.1l-240.913-240.913-240.916 240.918c-3.844 3.77-9.116 6.096-14.93 6.096-11.781 0-21.331-9.55-21.331-21.331 0-5.815 2.327-11.086 6.1-14.934l240.913-240.915-240.918-240.916c-3.952-3.875-6.401-9.269-6.401-15.235 0-11.781 9.55-21.331 21.331-21.331 5.966 0 11.36 2.449 15.232 6.397l240.921 240.919 240.916-240.916c3.844-3.77 9.116-6.096 14.93-6.096 11.781 0 21.331 9.55 21.331 21.331 0 5.815-2.327 11.086-6.1 14.934l0.003-0.003z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe947%3B%22 glyph-name%3D%22checkbox-checked%22 d%3D%22M793.6 789.333h-558.933c-34.133 0-64-29.867-64-64v-550.4c0-38.4 29.867-68.267 64-68.267h554.667c38.4 0 64 29.867 64 64v554.667c4.267 34.133-25.6 64-59.733 64zM763.733 584.533l-273.067-324.267c-17.067-17.067-42.667-21.333-59.733-4.267l-162.133 136.533c-17.067 17.067-21.333 42.667-4.267 59.733s42.667 21.333 59.733 4.267l132.267-110.933 247.467 294.4c17.067 17.067 42.667 21.333 59.733 4.267 12.8-17.067 17.067-42.667 0-59.733z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe948%3B%22 glyph-name%3D%22checkbox-indeterminate%22 d%3D%22M793.6 789.333h-558.933c-34.133 0-64-29.867-64-64v-550.4c0-38.4 29.867-68.267 64-68.267h554.667c38.4 0 64 29.867 64 64v554.667c4.267 34.133-25.6 64-59.733 64zM725.333 448c0-21.333-17.067-42.667-42.667-42.667h-341.333c-21.333 0-42.667 17.067-42.667 42.667v0c0 21.333 17.067 42.667 42.667 42.667h341.333c25.6 0 42.667-17.067 42.667-42.667v0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe949%3B%22 glyph-name%3D%22checkbox-unchecked%22 d%3D%22M227.555 796.473h568.889c35.346 0 64-28.654 64-64v0-568.889c0-35.346-28.654-64-64-64v0h-568.889c-35.346 0-64 28.654-64 64v0 568.889c0 35.346 28.654 64 64 64v0zM227.555 753.806c-11.782 0-21.333-9.551-21.333-21.333v0-568.889c0-11.782 9.551-21.333 21.333-21.333v0h568.889c11.782 0 21.333 9.551 21.333 21.333v0 568.889c0 11.782-9.551 21.333-21.333 21.333v0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe94a%3B%22 glyph-name%3D%22account%22 d%3D%22M341.333-64c-5.717 0-11.051 2.219-15.104 6.229l-64 64c-4.011 4.053-6.229 9.387-6.229 15.104v55.168l-36.437 36.437c-8.32 8.32-8.32 21.845 0 30.165l36.437 36.395v25.003l-36.437 36.437c-8.32 8.32-8.32 21.845 0 30.165l36.437 36.395v27.349c-100.949 35.84-170.752 134.016-170.667 241.579 0.085 133.931 102.4 243.968 234.667 254.848v22.059c0 58.837 47.829 106.667 106.667 106.667s106.667-47.829 106.667-106.667v-74.923c39.765-1.664 78.848-12.672 113.579-32 59.733-33.28 102.955-87.851 121.643-153.6 17.152-60.288 11.733-123.947-15.147-180.181l221.696-221.696c4.011-4.053 6.229-9.387 6.229-15.104v-90.496c0-11.776-9.557-21.333-21.333-21.333h-90.496c-5.419 0-10.624 2.048-14.592 5.76l-39.168 36.907h-47.744c-11.776 0-21.333 9.557-21.333 21.333v54.4l-9.131 9.6h-54.869c-11.776 0-21.333 9.557-21.333 21.333v54.4l-27.733 24.619c-34.389-16.512-72.619-25.216-111.147-25.216-32.768 0-65.536 6.315-95.787 18.432v-264.235c0-5.717-2.219-11.051-6.229-15.104l-64-64c-4.053-4.011-9.387-6.229-15.104-6.229zM341.333-12.501l42.667 42.667v320.256c0 9.472 6.4 17.92 15.531 20.523 91.264 25.856 155.051 110.208 155.136 205.056 0.085 110.251-83.371 201.387-192 212.139v-43.605c49.28-9.984 85.333-53.333 85.333-104.491 0-58.837-47.829-106.667-106.667-106.667s-106.667 47.829-106.667 106.667c0 51.157 36.053 94.507 85.333 104.491v43.648c-108.459-10.752-191.915-101.717-192-211.797-0.085-95.019 63.744-179.499 155.136-205.44 9.131-2.603 15.531-11.051 15.531-20.523v-51.755c0-5.717-2.219-11.051-6.229-15.104l-27.605-27.563 27.563-27.563c4.053-4.053 6.272-9.387 6.272-15.104v-42.667c0-5.717-2.219-11.051-6.229-15.104l-27.605-27.563 27.563-27.563c4.053-4.053 6.272-9.387 6.272-15.104v-55.168l42.667-42.667zM938.667 106.667v60.331l-226.475 226.432c-6.699 6.699-8.149 17.195-3.541 25.472 27.733 49.749 34.432 107.349 18.816 162.176-15.573 54.827-51.584 100.267-101.333 128-26.411 14.72-54.699 23.424-84.352 26.027 36.053-45.184 55.595-100.821 55.552-159.104-0.085-107.349-69.888-205.355-170.667-241.152v-2.517c29.525-14.763 62.549-22.528 95.872-22.528 36.48 0 72.405 9.301 103.893 26.837 3.2 1.792 6.784 2.688 10.411 2.688 5.205 0 10.24-1.877 14.165-5.333l45.867-40.704c4.523-4.011 7.125-9.856 7.125-15.957v-42.667h42.667c5.803 0 11.435-2.432 15.445-6.613l21.333-22.4c3.797-3.968 5.888-9.173 5.888-14.72v-41.6h34.859c5.419 0 10.624-2.048 14.592-5.76l39.168-36.907h60.715zM320 700.331c-25.003-8.917-42.667-32.939-42.667-60.245 0-35.285 28.715-64 64-64s64 28.715 64 64c0 27.307-17.664 51.328-42.667 60.245v-38.997c0-11.776-9.557-21.333-21.333-21.333s-21.333 9.557-21.333 21.333v38.997zM362.667 831.275c46.464-3.84 90.24-20.011 128-47.275v69.333c0 35.285-28.715 64-64 64s-64-28.715-64-64v-22.059z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe94b%3B%22 glyph-name%3D%22manual-judgement%22 d%3D%22M42.539-64.043c-23.509 0-42.667 19.115-42.667 42.667v64c0 35.285 28.715 64 64 64h298.667c35.285 0 64-28.715 64-64v-64c0-23.552-19.157-42.667-42.667-42.667h-341.333zM63.872 63.957c-11.776 0-21.333-9.557-21.333-21.333v-64h341.333v64c0 11.776-9.557 21.333-21.333 21.333h-298.667zM937.088 167.211c-22.229 0-43.307 8.491-59.264 23.893l-257.536 286.080-60.075-60.075c22.059-29.355 19.755-71.125-6.827-97.707-14.080-14.080-32.853-21.845-52.821-21.845s-38.699 7.765-52.779 21.845l-196.267 196.267c-29.099 29.099-29.099 76.501 0 105.6 14.080 14.080 32.853 21.845 52.821 21.845 16.341 0 31.872-5.205 44.715-14.805l212.267 212.267c-9.643 12.843-14.848 28.373-14.848 44.715 0 19.968 7.765 38.699 21.888 52.779 14.080 14.080 32.811 21.845 52.779 21.845s38.699-7.765 52.821-21.845l196.267-196.267c14.123-14.165 21.845-32.939 21.803-52.907s-7.851-38.699-22.016-52.736c-14.080-14.037-32.768-21.76-52.693-21.76-16.469 0.043-32 5.291-44.843 14.933l-60.032-60.032 285.013-256.512c32.939-34.048 33.195-86.357 1.067-119.595-16.299-16.768-38.059-25.984-61.44-25.984zM908.459 220.757c7.168-6.869 17.451-10.965 28.416-10.965 11.776 0 22.741 4.651 30.891 13.056 16.043 16.64 16.043 42.667 0 59.307l-285.611 256.981-31.701-31.701 258.005-286.677zM304.299 600.491c-8.576 0-16.597-3.328-22.656-9.344-12.459-12.459-12.459-32.768 0-45.269l196.267-196.267c6.016-6.016 14.080-9.344 22.656-9.344s16.597 3.328 22.613 9.344c12.459 12.459 12.459 32.811 0 45.269l-196.267 196.267c-6.016 6.016-14.037 9.344-22.613 9.344zM530.603 447.872l211.157 211.157-150.869 150.869-211.157-211.157 150.869-150.869zM794.539 666.581c6.059-6.101 14.123-9.429 22.656-9.472 8.576 0 16.597 3.328 22.656 9.344s9.387 14.080 9.429 22.613c0 8.533-3.285 16.597-9.344 22.656l-196.224 196.224c-6.016 6.016-14.080 9.344-22.656 9.344s-16.597-3.328-22.656-9.344c-6.059-6.059-9.387-14.080-9.387-22.613s3.328-16.597 9.387-22.656c0 0 7.339-7.296 7.552-7.509l181.077-181.035c0.171-0.171 0.384-0.384 0.555-0.597l6.955-6.955z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe94c%3B%22 glyph-name%3D%22add-another%22 d%3D%22M512-42.667c-270.549 0-490.667 220.117-490.667 490.667s220.117 490.667 490.667 490.667 490.667-220.117 490.667-490.667-220.117-490.667-490.667-490.667zM512 896c-247.040 0-448-200.96-448-448s200.96-448 448-448c247.040 0 448 200.96 448 448s-200.96 448-448 448zM512 170.667c-11.776 0-21.333 9.557-21.333 21.333v234.667h-234.667c-11.776 0-21.333 9.557-21.333 21.333s9.557 21.333 21.333 21.333h234.667v234.667c0 11.776 9.557 21.333 21.333 21.333s21.333-9.557 21.333-21.333v-234.667h234.667c11.776 0 21.333-9.557 21.333-21.333s-9.557-21.333-21.333-21.333h-234.667v-234.667c0-11.776-9.557-21.333-21.333-21.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe94d%3B%22 glyph-name%3D%22template%22 d%3D%22M213.333 42.667c-35.285 0-64 28.715-64 64v44.843c-42.155 8.149-75.136 41.216-83.499 84.053-11.264 57.728 26.539 113.835 84.267 125.099l-0.768 87.339v87.509c-0.299 19.797 13.696 37.333 33.28 41.6 26.027 5.077 45.995 24.96 50.987 50.645 6.741 34.645-15.915 68.309-50.56 75.093-19.84 4.267-33.92 21.845-33.707 41.813v44.672c0 35.285 28.715 64 64 64h428.843c20.096 0 37.376-13.995 41.6-33.28 5.077-26.069 24.917-45.995 50.645-51.029 4.096-0.811 8.277-1.195 12.416-1.195 12.672 0 24.96 3.797 35.584 10.923 14.165 9.557 23.765 24.064 27.051 40.832 4.224 19.627 21.632 33.707 41.344 33.707h45.184c35.285 0 64-28.715 64-64v-682.667c0-35.285-28.715-64-64-64h-682.667zM896 85.333c11.776 0 21.333 9.557 21.333 21.333v320h-66.133c-17.408 0-33.067 10.581-39.467 26.283-0.896 2.261-1.621 4.565-2.176 6.997-0.597 3.157-1.451 5.931-2.389 8.661l-0.64 1.792c-1.024 2.773-2.133 5.419-3.499 7.936-1.408 2.603-2.901 4.864-4.48 7.083l-1.195 1.621c-1.664 2.176-3.413 4.224-5.291 6.144-0.128 0.128-1.152 1.067-1.28 1.152-1.493 1.408-3.072 2.816-4.736 4.096-0.853 0.64-1.664 1.28-2.56 1.877-1.792 1.28-3.669 2.475-5.632 3.584l-1.92 1.067c-2.219 1.109-4.523 2.176-6.912 3.029l-1.749 0.64c-2.688 0.939-5.547 1.749-8.491 2.347-2.133 0.427-4.267 0.725-6.4 0.896-2.432 0.171-4.139 0.256-5.845 0.256 0 0-2.261-0.085-2.347-0.085-1.408-0.043-2.816-0.085-4.224-0.256 0 0-2.389-0.341-2.432-0.341-1.664-0.256-2.688-0.384-3.712-0.597-2.603-0.512-5.12-1.28-7.595-2.091-0.981-0.341-2.005-0.725-2.987-1.109-1.579-0.64-3.029-1.28-4.48-1.963-1.877-0.896-3.755-1.92-5.547-3.029-1.195-0.725-2.133-1.28-2.987-1.877-1.28-0.896-2.517-1.792-3.712-2.773-0.725-0.597-1.365-1.152-2.048-1.749-2.091-1.835-3.797-3.541-5.419-5.376-0.896-0.981-1.749-1.92-2.56-2.944s-1.579-2.048-2.347-3.115c-1.109-1.579-2.219-3.285-3.2-5.077-0.469-0.811-0.939-1.664-1.365-2.56-0.981-2.005-1.92-4.096-2.773-6.272l-0.811-2.261c-0.896-2.688-1.707-5.419-2.261-8.235-4.267-19.627-21.632-33.707-41.387-33.707h-66.347c0 0 0-66.091 0-66.091 3.883-0.811 8.32-2.048 13.525-3.797 0.811-0.256 1.749-0.597 2.645-0.939 4.907-1.835 9.259-3.755 13.099-5.845 4.096-2.261 7.765-4.565 11.605-7.339 0.981-0.725 2.048-1.493 3.115-2.304 3.541-2.731 6.656-5.376 9.429-8.149 0.725-0.725 2.987-3.157 2.987-3.157 2.176-2.304 4.224-4.651 6.187-7.168 1.195-1.493 2.304-3.029 3.413-4.565 0.597-0.768 0.981-1.28 1.365-1.835 1.579-2.389 3.072-4.864 4.437-7.381 0.725-1.28 1.28-2.219 1.792-3.243 1.835-3.541 3.499-7.339 5.077-11.563l0.939-2.56c2.859-8.32 4.693-16.683 5.461-24.917 0.299-3.84 0.469-6.912 0.469-9.984 0-2.987-0.171-6.059-0.427-9.131-0.811-9.088-2.645-17.451-5.504-25.643l-0.939-2.603c-1.621-4.309-3.328-8.107-5.163-11.648-0.555-1.067-1.195-2.219-1.835-3.328-1.365-2.432-2.773-4.864-4.352-7.211-0.341-0.512-0.725-1.024-1.152-1.536-1.323-1.835-2.432-3.328-3.584-4.821-1.963-2.475-4.011-4.821-6.101-7.083l-0.768-0.853c-0.853-0.939-1.749-1.835-2.645-2.731-2.816-2.773-5.845-5.333-9.003-7.765-1.152-0.896-2.261-1.707-3.413-2.517-3.541-2.517-6.955-4.693-10.411-6.571-0.384-0.256-0.811-0.512-1.323-0.768-3.584-1.92-7.723-3.755-12.587-5.547-1.067-0.427-2.176-0.768-3.285-1.152-5.12-1.749-9.515-2.944-13.824-3.797l0.683-65.963h320.085zM192 360.491c0.299-19.755-13.696-37.333-33.28-41.6-34.987-6.827-57.771-40.533-51.029-75.136 5.035-25.685 24.875-45.525 50.56-50.56 19.883-4.309 34.005-21.931 33.707-41.941v-44.587c0-11.776 9.557-21.333 21.333-21.333h320v66.176c-0.299 19.797 13.696 37.333 33.28 41.6 3.115 0.597 5.931 1.408 8.661 2.347l1.792 0.597c2.816 1.024 5.461 2.176 7.979 3.499 2.56 1.408 4.821 2.859 6.997 4.437l1.835 1.365c2.005 1.536 4.011 3.2 5.845 5.077 0.043 0.043 1.237 1.323 1.28 1.365 1.451 1.536 2.816 3.115 4.053 4.693 0.683 0.853 1.323 1.749 1.963 2.645 1.237 1.792 2.432 3.627 3.541 5.589l0.981 1.835c1.152 2.219 2.176 4.565 3.072 6.997l0.64 1.707c0.896 2.645 1.749 5.547 2.304 8.491 0.427 2.091 0.725 4.224 0.896 6.315 0.171 2.347 0.256 4.139 0.256 5.931s-0.085 3.584-0.256 5.376c-0.213 2.645-0.512 4.736-0.939 6.827-0.597 2.987-1.408 5.845-2.389 8.661l-0.512 1.493c-0.939 2.475-1.963 4.821-3.115 7.083l-1.024 1.877c-1.067 1.92-2.261 3.755-3.499 5.504-0.64 0.896-1.323 1.792-2.048 2.688-1.195 1.536-2.432 2.944-3.712 4.309 0 0-1.92 2.048-1.92 2.048-1.707 1.664-3.541 3.243-5.461 4.693-0.64 0.512-1.323 0.981-2.005 1.493-2.005 1.408-4.053 2.773-6.187 3.925-0.213 0.128-0.811 0.469-1.024 0.597-2.176 1.152-4.736 2.219-7.339 3.2l-1.963 0.683c-2.773 0.939-5.504 1.749-8.363 2.304-20.011 4.352-34.005 21.973-33.749 41.984v65.92h-66.176c-0.683-3.712-1.877-8.064-3.584-13.141-0.427-1.237-0.853-2.475-1.323-3.669-1.408-3.755-3.029-7.424-4.864-10.965-0.512-0.981-1.067-2.005-1.621-3.029-1.835-3.285-3.883-6.443-6.016-9.515-1.067-1.536-2.219-3.072-3.413-4.565-1.707-2.133-3.456-4.139-5.248-6.101-2.133-2.304-4.352-4.48-6.699-6.613-1.749-1.579-3.541-3.157-5.376-4.608-1.749-1.408-3.541-2.731-5.419-4.053-2.261-1.579-4.608-3.029-6.997-4.395-2.176-1.28-4.395-2.475-6.656-3.627-2.859-1.408-5.803-2.731-8.789-3.883-1.707-0.725-2.944-1.195-4.181-1.579-4.48-1.536-8.832-2.688-13.141-3.584-1.536-0.341-2.517-0.469-3.499-0.597l-2.219-0.341c-1.493-0.256-2.987-0.469-4.48-0.64-1.621-0.171-3.285-0.256-4.949-0.341l-2.091-0.085c-1.024-0.043-2.091-0.128-3.115-0.128-0.299 0-0.555 0-0.811 0-1.024 0-1.621 0.043-2.176 0.128-3.541 0.085-7.168 0.384-10.752 0.811-1.664 0.213-3.285 0.427-4.907 0.683-1.152 0.128-1.749 0.256-2.347 0.341-1.109 0.213-2.133 0.512-3.157 0.853-4.011 0.981-7.125 1.792-10.197 2.816-2.219 0.768-4.352 1.621-6.443 2.475 0 0-1.451 0.597-1.493 0.597-2.048 0.853-4.053 1.707-6.016 2.688-2.944 1.493-5.803 3.157-8.619 4.907-1.536 0.811-2.389 1.323-3.243 1.877-0.213 0.128-1.195 0.896-1.408 1.024-1.963 1.408-3.499 2.56-5.035 3.755-2.432 1.92-4.779 3.925-6.997 6.059l-0.853 0.725c-0.939 0.853-1.835 1.707-2.731 2.645-2.773 2.859-5.376 5.888-7.808 9.045-0.853 1.109-1.664 2.219-2.517 3.413-2.56 3.584-4.736 7.040-6.656 10.496-0.213 0.299-0.469 0.725-0.683 1.195-1.92 3.627-3.797 7.808-5.589 12.672-0.384 1.067-0.768 2.133-1.152 3.2-1.579 4.821-2.773 9.003-3.584 13.056h-66.133v-66.176zM258.645 469.333c16.597 0 31.701-9.941 38.485-25.301 1.365-3.2 2.133-5.547 2.645-7.979 0.597-3.115 1.451-5.931 2.389-8.661l0.64-1.835c1.024-2.731 2.133-5.376 3.456-7.893 1.408-2.603 2.901-4.864 4.48-7.083l1.237-1.707c1.621-2.133 3.328-4.139 5.205-6.059 0.085-0.085 1.237-1.109 1.323-1.195 1.536-1.493 3.115-2.816 4.736-4.096 0.811-0.597 1.664-1.28 2.517-1.877 1.835-1.323 3.712-2.517 5.675-3.627l1.792-0.981c2.261-1.152 4.565-2.176 6.955-3.072l1.749-0.64c2.773-0.939 5.589-1.792 8.533-2.347 2.091-0.427 4.224-0.725 6.272-0.896 0.085 0 1.536-0.085 1.621-0.085 1.451 0 2.859-0.128 4.309-0.128 0.939 0 3.499 0.171 3.499 0.171l2.859 0.171c1.024 0.085 2.005 0.256 3.029 0.427l3.2 0.512c2.731 0.555 5.376 1.323 7.979 2.219 0.768 0.213 1.579 0.555 2.347 0.853 1.963 0.768 3.712 1.579 5.461 2.432 1.28 0.64 2.645 1.365 3.968 2.176 1.451 0.853 2.816 1.707 4.139 2.645 1.152 0.811 2.261 1.621 3.328 2.475s2.091 1.749 3.115 2.688c1.451 1.323 2.816 2.688 4.139 4.139 1.067 1.152 2.091 2.304 3.072 3.541 0.725 0.939 1.451 1.877 2.133 2.816 1.28 1.792 2.475 3.627 3.541 5.589l1.024 1.963c1.109 2.005 2.048 4.181 2.901 6.443l0.768 2.176c0.896 2.688 1.749 5.461 2.304 8.277 4.267 19.627 21.76 33.707 41.685 33.707h66.176v66.219c-3.84 0.725-8.149 1.877-13.141 3.584-1.109 0.384-2.261 0.768-3.371 1.195-4.779 1.792-8.875 3.627-12.544 5.547-0.213 0.128-1.152 0.683-1.365 0.811-3.584 2.005-6.912 4.139-10.155 6.443-1.237 0.896-2.432 1.749-3.627 2.688-2.987 2.304-5.845 4.779-8.619 7.424-1.195 1.152-2.304 2.347-3.413 3.541-2.475 2.645-4.395 4.864-6.229 7.211-1.195 1.536-2.389 3.115-3.499 4.693-0.597 0.768-0.939 1.237-1.28 1.749-1.579 2.389-2.987 4.779-4.395 7.253-0.768 1.323-1.323 2.347-1.877 3.413-1.835 3.499-3.499 7.296-5.12 11.52l-0.981 2.688c-2.816 8.149-4.651 16.512-5.419 24.747 0 0.213-0.043 0.853-0.043 1.067-0.213 2.944-0.384 5.931-0.384 8.917 0 2.944 0.171 5.931 0.427 8.917 0.811 9.301 2.645 17.664 5.504 25.856l0.853 2.347c1.707 4.565 3.413 8.405 5.291 12.032l1.493 2.773c1.536 2.731 2.987 5.248 4.651 7.68 0.341 0.512 0.725 1.024 1.109 1.493 1.365 1.877 2.475 3.371 3.627 4.821 2.005 2.517 4.096 4.949 6.272 7.253l0.768 0.896c0.725 0.768 1.451 1.536 2.219 2.304 2.944 2.859 6.059 5.504 9.259 8.021 1.109 0.853 2.219 1.664 3.328 2.475 3.627 2.603 7.125 4.779 10.581 6.699 0.043 0 0.981 0.555 1.024 0.597 3.797 2.005 7.936 3.84 12.8 5.675 1.024 0.384 2.091 0.768 3.2 1.109 5.163 1.749 9.557 2.944 13.867 3.797l-0.725 65.92h-320.085c-11.776 0-21.333-9.557-21.333-21.333v-44.843c57.045-11.093 94.763-67.2 83.499-124.928-8.363-42.837-41.429-75.904-84.267-84.267l0.683-65.963h66.731zM746.965 554.795c11.648 0 23.253-2.005 34.475-5.888l2.389-0.853c4.48-1.664 8.32-3.371 11.947-5.248 1.024-0.512 2.005-1.067 3.029-1.664 2.56-1.451 5.077-2.901 7.467-4.523 0.512-0.341 1.024-0.725 1.493-1.109 1.877-1.365 3.371-2.475 4.821-3.627 2.517-1.963 4.992-4.096 7.339-6.315 1.493-1.365 2.304-2.091 3.029-2.859 2.688-2.773 5.333-5.803 8.107-9.387 0.853-1.109 1.621-2.176 2.389-3.243 2.645-3.755 4.907-7.253 6.784-10.752 0.043-0.043 0.555-0.939 0.597-1.024 1.92-3.627 3.797-7.808 5.632-12.715 0.384-1.024 0.768-2.048 1.109-3.157 1.749-5.205 2.987-9.643 3.797-13.909l65.963 0.683v320.128c0 11.776-9.557 21.333-21.333 21.333h-44.843c-5.248-27.264-21.248-51.371-44.885-67.285-17.707-11.904-38.272-18.219-59.392-18.219-6.869 0-13.824 0.683-20.608 2.005-42.837 8.363-75.947 41.429-84.267 84.267l-66.005-0.64v-66.304c0.299-19.797-13.696-37.333-33.28-41.6-3.072-0.597-5.845-1.408-8.533-2.347l-2.219-0.811c-2.219-0.853-4.352-1.792-6.443-2.816-0.811-0.427-1.664-0.853-2.475-1.323-1.792-1.024-3.499-2.091-5.163-3.285-1.024-0.725-2.048-1.493-3.029-2.261-1.067-0.853-2.133-1.792-3.157-2.731-1.664-1.493-3.243-3.115-4.779-4.779-0.853-0.939-1.579-1.749-2.261-2.603-0.896-1.152-1.792-2.347-2.645-3.541-0.768-1.109-1.536-2.304-2.219-3.541-0.981-1.579-1.835-3.157-2.603-4.779-0.768-1.579-1.536-3.243-2.176-4.907-0.427-0.981-0.725-1.835-1.067-2.731-0.853-2.517-1.621-5.12-2.133-7.808 0 0-0.853-5.376-0.939-6.144-0.085-0.939-0.128-1.835-0.171-2.731l-0.171-3.413c0-1.749 0.085-3.541 0.213-5.333 0.213-2.944 0.512-5.077 0.939-7.211 0.512-2.645 1.28-5.461 2.347-8.619l0.555-1.493c0.939-2.517 1.963-4.864 3.157-7.125l0.939-1.707c1.109-2.005 2.304-3.883 3.584-5.675 0.64-0.939 1.323-1.835 2.005-2.688 1.152-1.493 2.432-2.944 3.755-4.309l1.792-1.92c1.749-1.707 3.627-3.285 5.547-4.779l1.963-1.451c2.048-1.451 4.139-2.816 6.357-4.053 3.072-1.664 5.632-2.773 8.277-3.755l1.877-0.683c2.731-0.939 5.504-1.749 8.405-2.304 19.925-4.309 34.005-21.973 33.707-41.984v-65.92h66.176c0.683 3.797 1.92 8.32 3.627 13.312l0.896 2.645c1.493 4.011 3.285 8.064 5.333 11.989 0.512 0.981 1.109 2.005 1.664 3.029 2.091 3.712 4.181 7.083 6.528 10.283 0.64 0.896 1.365 1.792 2.091 2.688l0.683 0.853c1.877 2.389 3.84 4.651 5.888 6.827l0.896 0.939c0.896 0.981 1.792 1.92 2.731 2.816 2.603 2.517 5.333 4.821 8.192 7.040 1.493 1.195 3.029 2.304 4.565 3.413 3.072 2.133 6.187 4.139 9.387 5.931 1.109 0.64 2.261 1.195 3.371 1.749 4.267 2.133 7.808 3.755 11.52 5.12l2.176 0.768c4.224 1.451 8.533 2.645 13.269 3.627 0.128 0.085 0.725 0.213 1.323 0.341 0.213 0.043 0.896 0.128 1.067 0.171 2.219 0.427 4.821 0.768 7.381 1.067l2.219 0.299c3.2 0.299 6.4 0.427 9.643 0.427 0.171 0.128 0.256 0.128 0.384 0.128z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe94e%3B%22 glyph-name%3D%22workflow%22 d%3D%22M635.136 363.307c29.053 19.369 47.934 52.003 47.934 89.046 0 58.916-47.761 106.676-106.676 106.676-37.022 0-69.639-18.859-88.768-47.494l-0.244-0.388-46.635 46.635c-11.602 11.548-27.602 18.687-45.269 18.687s-33.667-7.139-45.272-18.69l-61.779-61.779c-7.766-7.739-12.571-18.445-12.571-30.272 0-11.722 4.719-22.341 12.361-30.062l-0.004 0.004c2.033-2.044 4.266-3.884 6.669-5.49l0.157-0.099c3.625-2.367 6.78-4.94 9.642-7.807l0.001-0.001c11.169-11.508 18.054-27.226 18.054-44.553 0-35.346-28.654-64-64-64-17.242 0-32.891 6.818-44.399 17.905l0.020-0.019c-2.962 2.929-5.618 6.154-7.924 9.632l-0.14 0.224c-7.75 11.613-20.799 19.159-35.611 19.159-8.743 0-16.871-2.629-23.638-7.139l0.156 0.098c-2.499-1.649-4.677-3.434-6.655-5.418l-0.001-0.001-62.251-61.568c-11.567-11.586-18.721-27.581-18.721-45.248s7.153-33.662 18.722-45.249l241.364-241.364c11.583-11.574 27.579-18.732 45.248-18.732s33.665 7.158 45.248 18.733l66.602 66.56c7.774 7.726 12.586 18.426 12.586 30.249 0 17.971-11.116 33.345-26.848 39.623l-0.288 0.101c-8.527 3.345-15.802 8.181-21.843 14.248l-0.002 0.002c-11.559 11.574-18.708 27.556-18.708 45.207 0 35.333 28.643 63.977 63.977 63.977 0.015 0 0.030 0 0.045 0h-0.002c0.024 0 0.053 0 0.081 0 26.859 0 49.846-16.579 59.286-40.061l0.153-0.43c6.38-16.019 21.755-27.135 39.727-27.135 5.604 0 10.955 1.081 15.856 3.045l-0.287-0.102c5.718 2.229 10.594 5.475 14.631 9.554l66.606 66.648c11.572 11.584 18.728 27.58 18.728 45.248s-7.157 33.664-18.729 45.249l0.001-0.001zM651.563 256.427l-66.603-66.603c-16.045 39.916-54.434 67.583-99.285 67.583-29.393 0-56.010-11.883-75.311-31.106l0.004 0.003c-19.373-19.306-31.361-46.013-31.361-75.519 0-44.863 27.712-83.254 66.952-98.989l0.718-0.254-66.645-66.603c-3.865-3.85-9.196-6.23-15.083-6.23s-11.218 2.38-15.083 6.23l-241.364 241.364c-3.862 3.859-6.25 9.192-6.25 15.083 0 5.848 2.354 11.147 6.167 14.999l-0.002-0.002 62.251 61.611c19.314-28.472 51.526-46.934 88.049-46.934 28.795 0 54.91 11.475 74.021 30.103l-0.023-0.022c20.042 19.452 32.48 46.642 32.48 76.738 0 28.885-11.458 55.095-30.076 74.331l0.028-0.029c-4.953 4.976-10.381 9.469-16.214 13.409l-0.383 0.244 61.824 61.824c3.865 3.849 9.196 6.229 15.083 6.229s11.218-2.38 15.083-6.229l68.266-68.266c3.863-3.872 9.203-6.269 15.103-6.272h0.001c1.959 0.005 3.854 0.27 5.656 0.761l-0.152-0.035c7.382 2.025 13.079 7.722 15.069 14.954l0.035 0.15c7.554 27.541 32.363 47.442 61.821 47.442 35.346 0 64-28.654 64-64 0-29.458-19.902-54.267-46.993-61.716l-0.449-0.105c-9.191-2.521-15.834-10.8-15.834-20.632 0-5.887 2.382-11.218 6.234-15.081l68.266-68.266c3.855-3.862 6.24-9.194 6.24-15.083s-2.384-11.221-6.24-15.083v0zM1014.708 704.958c-3.108 1.875-6.86 2.984-10.872 2.984-7.766 0-14.561-4.156-18.283-10.366l-0.054-0.097-82.033-138.393c-15.743 222.666-200.242 397.339-425.538 397.339-235.571 0-426.539-190.968-426.539-426.539 0-37.487 4.836-73.844 13.918-108.482l-0.662 2.97c2.427-9.299 10.746-16.053 20.645-16.062h0.001c0.010 0 0.023 0 0.035 0 1.868 0 3.678 0.243 5.402 0.7l-0.147-0.033c9.304 2.424 16.061 10.751 16.061 20.656 0 1.877-0.243 3.696-0.698 5.43l0.033-0.148c-7.614 28.573-11.987 61.377-11.987 95.203 0 212.103 171.943 384.046 384.046 384.046 204.926 0 372.365-160.505 383.461-362.66l0.043-0.985 0.364-6.893-118.573 121.852c-3.875 3.954-9.271 6.405-15.24 6.405-11.782 0-21.333-9.551-21.333-21.333 0-5.761 2.284-10.989 5.995-14.827l-0.006 0.006 158.165-162.521 0.555-0.378c1.953-1.468 4.183-2.948 6.498-4.3l0.333-0.18c1.761-0.657 3.798-1.091 5.919-1.208l0.054-0.002c0.661-0.062 1.265-0.391 1.932-0.391l0.508 0.029c0.213 0.005 0.401-0.102 0.617-0.091l0.633 0.164 0.784 0.043c0.536 0.065 0.956 0.435 1.482 0.539 2.534 0.461 4.795 1.315 6.836 2.507l-0.099-0.053c0.777 0.516 1.449 1.027 2.086 1.577l-0.026-0.022c1.722 1.322 3.193 2.858 4.406 4.587l0.044 0.066c0.299 0.43 0.794 0.659 1.062 1.112l117.626 198.523c1.883 3.113 2.997 6.874 2.997 10.896 0 7.763-4.152 14.556-10.357 18.28l-0.097 0.054z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe94f%3B%22 glyph-name%3D%22filter%22 d%3D%22M426.667 618.667c-204.8 0-426.667 59.733-426.667 170.667s221.867 170.667 426.667 170.667 426.667-59.733 426.667-170.667-221.867-170.667-426.667-170.667zM426.667 917.333c-226.133 0-384-68.267-384-128s157.867-128 384-128 384 68.267 384 128-157.867 128-384 128zM362.667 234.667c-4.267 0-12.8 0-17.067 4.267l-281.6 281.6c-38.4 46.933-59.733 102.4-64 162.133v106.667c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-106.667c4.267-46.933 21.333-93.867 55.467-132.267l281.6-281.6c8.533-8.533 8.533-21.333 0-29.867-4.267-4.267-12.8-4.267-17.067-4.267zM772.267 516.267c-4.267 0-8.533 0-12.8 4.267-8.533 8.533-8.533 21.333 0 29.867 34.133 38.4 51.2 85.333 55.467 132.267l-4.267 106.667c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-106.667c-4.267-59.733-25.6-115.2-64-157.867-4.267-8.533-12.8-8.533-17.067-8.533zM448-64h-42.667c-34.133 0-64 29.867-64 64v256c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-256c0-12.8 8.533-21.333 21.333-21.333h42.667c12.8 0 21.333 8.533 21.333 21.333v89.6c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-89.6c0-34.133-29.867-64-64-64zM618.667 405.333c-12.8 0-21.333 8.533-21.333 21.333s8.533 21.333 21.333 21.333h384c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.333-21.333-21.333h-384zM618.667 234.667c-12.8 0-21.333 8.533-21.333 21.333s8.533 21.333 21.333 21.333h298.667c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.333-21.333-21.333h-298.667zM618.667 64c-12.8 0-21.333 8.533-21.333 21.333s8.533 21.333 21.333 21.333h213.333c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.333-21.333-21.333h-213.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe950%3B%22 glyph-name%3D%22instances%22 d%3D%22M213.333 149.333v-85.333h-85.333v85.333zM384 149.333v-85.333h-85.333v85.333zM554.667 149.333v-85.333h-85.333v85.333zM725.333 149.333v-85.333h-85.333v85.333zM896 149.333v-85.333h-85.333v85.333zM213.333 320v-85.333h-85.333v85.333zM384 320v-85.333h-85.333v85.333zM554.667 320v-85.333h-85.333v85.333zM725.333 320v-85.333h-85.333v85.333zM896 320v-85.333h-85.333v85.333zM213.333 490.667v-85.333h-85.333v85.333zM384 490.667v-85.333h-85.333v85.333zM554.667 490.667v-85.333h-85.333v85.333zM725.333 490.667v-85.333h-85.333v85.333zM896 490.667v-85.333h-85.333v85.333zM213.333 661.333v-85.333h-85.333v85.333zM384 661.333v-85.333h-85.333v85.333zM554.667 661.333v-85.333h-85.333v85.333zM725.333 661.333v-85.333h-85.333v85.333zM896 661.333v-85.333h-85.333v85.333zM213.333 832v-85.333h-85.333v85.333zM384 832v-85.333h-85.333v85.333zM554.667 832v-85.333h-85.333v85.333zM725.333 832v-85.333h-85.333v85.333zM896 832v-85.333h-85.333v85.333z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe951%3B%22 glyph-name%3D%22ci-build%22 d%3D%22M938.368 672c0.005 0 0.011 0 0.017 0 11.782 0 21.333 9.551 21.333 21.333 0 4.659-1.494 8.97-4.028 12.479l0.043-0.063-153.6 215.040c-7.834 10.878-20.463 17.877-34.727 17.877-0.016 0-0.033 0-0.049 0h-223.357c-11.782 0-21.333-9.551-21.333-21.333v0-224c0-11.782 9.551-21.333 21.333-21.333v0zM42.667 608c-11.782 0-21.333-9.551-21.333-21.333v0-586.667c0-23.564 19.103-42.667 42.667-42.667v0h896c23.564 0 42.667 19.103 42.667 42.667v0 586.667c0 11.782-9.551 21.333-21.333 21.333v0zM533.333 192c0 11.782 9.551 21.333 21.333 21.333v0h298.667c11.782 0 21.333-9.551 21.333-21.333v0-85.333c0-11.782-9.551-21.333-21.333-21.333v0h-298.667c-11.782 0-21.333 9.551-21.333 21.333v0zM458.667 917.333c0 11.782-9.551 21.333-21.333 21.333v0h-180.693c-0.014 0-0.030 0-0.047 0-14.264 0-26.893-6.999-34.64-17.751l-0.087-0.126-153.6-215.040c-2.492-3.446-3.985-7.757-3.985-12.416 0-11.782 9.551-21.333 21.333-21.333 0.006 0 0.012 0 0.018 0h351.7c11.782 0 21.333 9.551 21.333 21.333v0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe952%3B%22 glyph-name%3D%22ci-master%22 d%3D%22M514.339 960c93.165-1.128 168.256-76.915 168.256-170.241 0-72.289-45.054-134.056-108.614-158.752l-1.161-0.397c-3.097-1.343-6.837-2.609-10.693-3.583l-0.531-0.114c-5.619-1.155-6.955-4.322-6.939-9.754 0.179-59.553 0.116-119.107 0.128-178.661 0.009-52.682 0.147-105.364-0.106-158.045-0.089-0.51-0.14-1.097-0.14-1.696 0-5.083 3.656-9.312 8.481-10.201l0.064-0.010c56.651-17.244 99.836-62.334 114.080-118.926l0.245-1.15c3.52-12.439 5.544-26.724 5.544-41.481 0-15.776-2.313-31.012-6.618-45.388l0.288 1.118c-13.584-51.845-50.166-93.099-97.907-112.826l-1.108-0.405c-19.073-8.589-41.347-13.593-64.79-13.593-16.095 0-31.64 2.359-46.306 6.75l1.141-0.293c-51.387 13.59-92.303 49.775-112.101 97.004l-0.409 1.099c-8.666 18.991-13.717 41.192-13.717 64.572 0 7.562 0.528 15 1.55 22.28l-0.096-0.839c6.788 60.62 45.085 110.927 97.911 134.636l1.059 0.425c5.894 2.872 12.87 5.51 20.108 7.524l0.893 0.212c5.248 1.483 6.608 4.243 6.58 9.364-0.183 34.357-0.095 68.716-0.095 103.073 0 78.086-0.1 156.173 0.176 234.258 0.060 0.419 0.094 0.904 0.094 1.396 0 5.189-3.809 9.488-8.783 10.255l-0.058 0.007c-49.286 14.94-88.085 50.972-106.484 97.321l-0.391 1.115c-7.699 18.74-12.169 40.493-12.169 63.289 0 94.257 76.41 170.667 170.667 170.667 0.686 0 1.37-0.004 2.054-0.012l-0.104 0.001z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe953%3B%22 glyph-name%3D%22ci-branch%22 d%3D%22M938.667 789.333c0.001 0.182 0.001 0.398 0.001 0.614 0 94.257-76.41 170.667-170.667 170.667s-170.667-76.41-170.667-170.667c0-79.094 53.804-145.621 126.808-164.979l1.191-0.269v-48.701c0-73-53.248-85.333-213.333-85.333-11.143 0.825-24.139 1.295-37.245 1.295-63.045 0-123.549-10.876-179.74-30.853l3.75 1.163q0.008 77.44-0.109 154.891c-0.016 5.432 1.32 8.599 6.94 9.753 4.388 1.090 8.128 2.357 11.727 3.89l-0.503-0.19c64.402 25.227 109.18 86.822 109.18 158.876 0 93.991-76.195 170.186-170.186 170.186s-170.186-76.195-170.186-170.186c0-22.854 4.505-44.655 12.674-64.565l-0.412 1.134c18.79-47.465 57.589-83.498 105.707-98.133l1.168-0.306c5.032-0.775 8.841-5.074 8.841-10.263 0-0.492-0.034-0.976-0.1-1.45l0.006 0.055c-0.276-78.083-0.175-156.172-0.177-234.258q0-30.398 0.057-60.797l-0.059-0.906h0.060c0.010-13.789-0.034-27.581 0.039-41.37 0.026-5.12-1.333-7.883-6.581-9.364-8.13-2.225-15.106-4.863-21.761-8.064l0.761 0.33c-53.885-24.134-92.182-74.44-98.902-134.299l-0.069-0.761c-0.925-6.441-1.453-13.878-1.453-21.44 0-23.381 5.051-45.581 14.121-65.571l-0.405 0.997c20.207-48.329 61.124-84.514 111.349-97.842l1.163-0.263c13.525-4.097 29.069-6.456 45.164-6.456 23.443 0 45.718 5.004 65.814 14.003l-1.022-0.409c48.846 20.132 85.427 61.384 98.752 112.066l0.26 1.162c4.017 13.256 6.329 28.49 6.329 44.265 0 14.759-2.024 29.046-5.81 42.597l0.265-1.111c-14.489 57.74-57.673 102.83-113.142 119.766l-1.181 0.31c-4.889 0.898-8.545 5.127-8.545 10.209 0 0.599 0.051 1.187 0.148 1.758l-0.009-0.061c0.065 13.432 0.005 26.867 0.026 40.3 0.384 72.298 53.814 84.582 213.296 84.582 126.042 0 298.667 0 298.667 170.667v48.701c74.073 19.449 127.852 85.74 128 164.616v0.017z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe954%3B%22 glyph-name%3D%22ci-commit%22 d%3D%22M872.557 490.685c-34.357 0-154.049 0.089-188.406-0.094-0.411-0.075-0.885-0.118-1.368-0.118-3.867 0-7.092 2.748-7.829 6.398l-0.009 0.051c-2.413 8.040-4.959 14.726-7.912 21.186l0.42-1.025c-0.164 0.349-0.232 0.742-0.401 1.088l-0.396 0.633c-6.663 14.909-14.743 27.76-24.352 39.291l0.217-0.268c-7.934 9.124-16.582 17.239-25.985 24.415l-0.422 0.309c-2.406 1.891-4.878 3.693-7.391 5.44-25.675 18.105-57.4 29.258-91.68 30.139l-0.216 0.004c-3.888 0.154-7.768 0.25-11.617 0.122-2.763-0.125-5.504-0.346-8.271-0.609-7.135-0.63-13.552-1.618-19.829-2.982l1.032 0.188c-1.789-0.375-3.57-0.719-5.357-1.156-7.846-1.968-14.383-4.096-20.727-6.606l1.118 0.39c-1.411-0.531-2.862-0.781-4.267-1.352-0.409-0.167-0.716-0.43-1.123-0.597-0.597-0.253-1.213-0.393-1.81-0.654-3.662-1.599-6.557-3.885-10.034-5.649-8.928-4.214-16.468-8.529-23.635-13.355l0.633 0.401c-4.206-2.953-7.601-6.62-11.453-9.885-5.609-4.466-10.623-9.017-15.328-13.869l-0.039-0.040c-5.792-6.644-11.178-13.99-15.92-21.772l-0.401-0.707c-1.373-2.203-3.084-4.091-4.364-6.38-5.049-8.912-9.68-19.301-13.313-30.148l-0.372-1.279c-0.354-1.041-0.939-1.883-1.28-2.938-0.773-5.032-5.072-8.841-10.26-8.841-0.493 0-0.978 0.034-1.453 0.101l0.055-0.006c-56.047 0.195-154.766 0.138-210.816 0.125v-85.388c56.448 0.005 155.565-0.049 212.016 0.117 5.149 0.018 8.117-1.448 9.411-6.357 1.908-6.824 3.813-12.341 5.988-17.72l-0.403 1.126c2.195-5.086 5.268-9.216 7.784-13.952 3.083-6.279 5.997-11.423 9.165-16.39l-0.405 0.679c4.138-5.914 8.232-11.062 12.609-15.951l-0.14 0.159c3.115-3.609 6.12-7.258 9.508-10.568 5.004-4.862 10.371-9.428 16.027-13.625l0.426-0.302c4.036-3.047 8.146-5.854 12.425-8.524 4.21-2.702 9.278-5.566 14.499-8.166l0.977-0.441c6.259-3.098 13.822-6.144 21.629-8.646l1.214-0.336c2.622-0.847 4.807-2.2 7.509-2.953 1.513-0.422 3.034-0.591 4.55-0.972 2.5-0.609 4.984-1.107 7.509-1.604 9.777-2.164 21.006-3.403 32.525-3.403 9.632 0 19.061 0.867 28.215 2.526l-0.958-0.144c2.414 0.399 4.786 0.945 7.193 1.453 2.234 0.512 4.487 0.739 6.716 1.359 2.159 0.597 3.836 1.721 5.943 2.378 6.813 1.624 12.392 3.316 17.836 5.289l-1.135-0.36c6.899 2.999 12.539 5.883 17.986 9.061l-0.809-0.436c0.721 0.384 1.498 0.716 2.214 1.112 11.167 6.468 20.829 13.554 29.653 21.548l-0.145-0.129q3.301 2.961 6.435 6.094c19.746 19.495 34.771 43.725 43.236 70.85l0.327 1.214c1.581 3.661 5.16 6.176 9.326 6.176 0.393 0 0.782-0.022 1.163-0.066l-0.047 0.004c41.565-0.201 168.461-0.115 210.026-0.085v85.402c-7.81-0.003-15.622 0.018-23.438 0.018zM512 362.581c-47.128 0-85.333 38.205-85.333 85.333s38.205 85.333 85.333 85.333c47.128 0 85.333-38.205 85.333-85.333v0c0-47.128-38.205-85.333-85.333-85.333v0z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe955%3B%22 glyph-name%3D%22ci-pr%22 d%3D%22M173.005 960c93.165-1.128 168.256-76.915 168.256-170.241 0-72.289-45.054-134.056-108.614-158.752l-1.161-0.397c-3.097-1.343-6.837-2.609-10.693-3.583l-0.531-0.114c-5.619-1.155-6.955-4.322-6.939-9.754 0.179-59.553 0.116-119.107 0.126-178.661 0.009-52.682 0.147-105.364-0.106-158.045-0.089-0.51-0.14-1.097-0.14-1.696 0-5.083 3.656-9.312 8.481-10.201l0.064-0.010c56.651-17.244 99.836-62.334 114.080-118.926l0.245-1.15c3.521-12.44 5.545-26.726 5.545-41.485 0-15.775-2.312-31.010-6.616-45.384l0.288 1.118c-13.584-51.845-50.166-93.099-97.907-112.826l-1.108-0.405c-19.073-8.589-41.347-13.593-64.79-13.593-16.095 0-31.64 2.359-46.306 6.75l1.141-0.293c-51.387 13.59-92.303 49.775-112.101 97.004l-0.409 1.099c-8.666 18.991-13.717 41.192-13.717 64.572 0 7.562 0.528 15 1.55 22.28l-0.096-0.839c6.788 60.62 45.085 110.927 97.911 134.636l1.059 0.425c5.894 2.872 12.87 5.51 20.108 7.524l0.893 0.212c5.248 1.483 6.608 4.243 6.58 9.364-0.183 34.357-0.095 68.716-0.095 103.073 0 78.086-0.1 156.173 0.176 234.258 0.060 0.419 0.094 0.904 0.094 1.396 0 5.189-3.809 9.488-8.783 10.255l-0.058 0.007c-49.286 14.94-88.085 50.972-106.484 97.321l-0.391 1.115c-7.911 18.869-12.508 40.797-12.508 63.799 0 52.050 23.535 98.603 60.545 129.597l0.264 0.215c29.5 25.087 68.036 40.346 110.135 40.346 0.707 0 1.414-0.004 2.119-0.013l-0.107 0.001zM574.357 745.728l66.508-64.887c-3.037-3.464-4.407-5.21-5.963-6.772-16.75-16.803-33.621-33.484-50.229-50.428-3.797-3.873-6.249-3.947-10.135-0.043q-67.147 67.466-134.535 134.695c-8.308 7.736-13.489 18.736-13.489 30.946 0 12.203 5.174 23.197 13.448 30.909l0.025 0.023q67.217 67.413 134.51 134.749c3.808 3.828 6.262 4.005 10.121 0.069 16.905-17.242 34.086-34.214 51.145-51.306 1.158-1.161 2.13-2.506 3.72-4.397l-66.241-66.49c4.576-0.365 7.165-0.75 9.754-0.751q67.157-0.029 134.318 0.032c1.533 0.047 3.336 0.073 5.145 0.073 25.397 0 49.57-5.235 71.501-14.685l-1.174 0.45c44.349-19.363 78.19-55.816 93.646-100.815l0.356-1.194c5.796-16.67 9.143-35.883 9.143-55.879 0-1.075-0.010-2.148-0.029-3.218l0.002 0.161q0.149-188.045-0.125-376.090c-0.103-0.556-0.161-1.195-0.161-1.849 0-5.232 3.766-9.583 8.735-10.492l0.065-0.010c45.438-13.887 81.805-45.524 101.679-86.625l0.431-0.988c11.028-21.335 17.494-46.57 17.494-73.314 0-16.274-2.394-31.99-6.85-46.813l0.297 1.15c-13.625-51.607-50.175-92.624-97.814-112.114l-1.107-0.401c-19.027-8.511-41.235-13.468-64.601-13.468-16.165 0-31.776 2.372-46.503 6.788l1.144-0.295c-51.588 13.664-92.615 50.13-112.261 97.678l-0.405 1.106c-8.529 18.976-13.498 41.133-13.498 64.45 0 12.467 1.42 24.601 4.108 36.252l-0.21-1.082c11.054 54.466 47.354 98.612 95.885 120.315l1.061 0.424c5.831 2.83 12.79 5.501 19.992 7.602l0.977 0.244c3.668 0.642 6.421 3.803 6.421 7.607 0 0.472-0.042 0.935-0.124 1.384l0.007-0.047c-0.128 35.401-0.031 70.803-0.028 106.204q0.010 137.131 0.023 274.258c0.026 0.781 0.041 1.699 0.041 2.621 0 26.297-11.984 49.796-30.788 65.332l-0.143 0.115c-14.085 12.15-32.564 19.549-52.772 19.549-0.209 0-0.417-0.001-0.626-0.002h0.032c-48.519 0.132-97.038 0.062-145.557 0.034-2.405-0.164-4.589-0.437-6.733-0.824l0.367 0.055z%22 %2F%3E%3Cglyph unicode%3D%22%26%23xe956%3B%22 glyph-name%3D%22balance-scale%22 horiz-adv-x%3D%221243%22 d%3D%22M987.429 704l-219.429-402.286h438.857zM256 704l-219.429-402.286h438.857zM725.143 813.714c-10.857-30.857-36-56-66.857-66.857v-737.714h347.429c10.286 0 18.286-8 18.286-18.286v-36.571c0-10.286-8-18.286-18.286-18.286h-768c-10.286 0-18.286 8-18.286 18.286v36.571c0 10.286 8 18.286 18.286 18.286h347.429v737.714c-30.857 10.857-56 36-66.857 66.857h-280.571c-10.286 0-18.286 8-18.286 18.286v36.571c0 10.286 8 18.286 18.286 18.286h280.571c15.429 42.857 55.429 73.143 103.429 73.143s88-30.286 103.429-73.143h280.571c10.286 0 18.286-8 18.286-18.286v-36.571c0-10.286-8-18.286-18.286-18.286h-280.571zM621.714 804.571c25.143 0 45.714 20.571 45.714 45.714s-20.571 45.714-45.714 45.714-45.714-20.571-45.714-45.714 20.571-45.714 45.714-45.714zM1243.429 301.714c0-117.714-162.857-164.571-256-164.571s-256 46.857-256 164.571v0c0 22.286 199.429 375.429 224 420 6.286 11.429 18.857 18.857 32 18.857s25.714-7.429 32-18.857c24.571-44.571 224-397.714 224-420v0zM512 301.714c0-117.714-162.857-164.571-256-164.571s-256 46.857-256 164.571v0c0 22.286 199.429 375.429 224 420 6.286 11.429 18.857 18.857 32 18.857s25.714-7.429 32-18.857c24.571-44.571 224-397.714 224-420z%22 %2F%3E%3Cglyph unicode%3D%22%26%23x1f5f6%3B%22 glyph-name%3D%22calendar-warning%22 d%3D%22M85.333 128c-34.133 0-64 29.867-64 64v597.333c0 34.133 29.867 64 64 64h149.333v64c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-64h384v64c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-64h149.333c34.133 0 64-29.867 64-64v-277.333c0-12.8-8.533-21.333-21.333-21.333s-21.333 8.533-21.333 21.333v85.333h-810.667v-405.333c0-12.8 8.533-21.333 21.333-21.333h341.333c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.333-21.333-21.333h-341.333zM874.667 640v149.333c0 12.8-8.533 21.333-21.333 21.333h-149.333v-106.667c0-12.8-8.533-21.333-21.333-21.333s-21.333 8.533-21.333 21.333v106.667h-384v-106.667c0-12.8-8.533-21.333-21.333-21.333s-21.333 8.533-21.333 21.333v106.667h-149.333c-12.8 0-21.333-8.533-21.333-21.333v-149.333h810.667zM981.333 0l-217.6 409.6c-4.267 4.267-8.533 8.533-12.8 8.533h-4.267c-4.267 0-4.267 0-8.533-4.267-4.267 0-4.267-4.267-8.533-8.533l-217.6-409.6c-4.267-4.267-4.267-12.8 0-17.067s8.533-8.533 17.067-8.533h430.933c8.533 0 12.8 4.267 17.067 8.533 4.267 8.533 4.267 12.8 4.267 21.333zM725.333 285.867c0 12.8 8.533 21.333 21.333 21.333s21.333-8.533 21.333-21.333v-128c0-12.8-8.533-21.333-21.333-21.333s-21.333 12.8-21.333 25.6v123.733zM746.667 34.133c-17.067 0-34.133 12.8-34.133 34.133s12.8 34.133 34.133 34.133c17.067 0 34.133-12.8 34.133-34.133s-17.067-34.133-34.133-34.133z%22 %2F%3E%3C%2Ffont%3E%3C%2Fdefs%3E%3C%2Fsvg%3E\") format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^='icon-'],\n[class*=' icon-'] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-balance-scale:before {\n  content: '\\e956';\n}\n.icon-ci-build:before {\n  content: '\\e951';\n}\n.icon-ci-master:before {\n  content: '\\e952';\n}\n.icon-ci-branch:before {\n  content: '\\e953';\n}\n.icon-ci-commit:before {\n  content: '\\e954';\n}\n.icon-ci-pr:before {\n  content: '\\e955';\n}\n.icon-update:before {\n  content: '\\e943';\n}\n.icon-skull:before {\n  content: '\\e944';\n}\n.icon-template-add:before {\n  content: '\\e945';\n}\n.icon-close-small:before {\n  content: '\\e946';\n}\n.icon-checkbox-checked:before {\n  content: '\\e947';\n}\n.icon-checkbox-indeterminate:before {\n  content: '\\e948';\n}\n.icon-checkbox-unchecked:before {\n  content: '\\e949';\n}\n.icon-account:before {\n  content: '\\e94a';\n}\n.icon-manual-judgement:before {\n  content: '\\e94b';\n}\n.icon-add-another:before {\n  content: '\\e94c';\n}\n.icon-template:before {\n  content: '\\e94d';\n}\n.icon-workflow:before {\n  content: '\\e94e';\n}\n.icon-filter:before {\n  content: '\\e94f';\n}\n.icon-navigation-out:before {\n  content: '\\e942';\n}\n.icon-search-slash:before {\n  content: '\\e941';\n}\n.icon-servergroup-aws:before {\n  content: '\\e93c';\n}\n.icon-instances:before {\n  content: '\\e950';\n}\n.icon-cluster:before {\n  content: '\\e93e';\n}\n.icon-label:before {\n  content: '\\e93f';\n}\n.icon-md:before {\n  content: '\\e934';\n}\n.icon-md-created:before {\n  content: '\\e935';\n}\n.icon-md-diff:before {\n  content: '\\e936';\n}\n.icon-md-error:before {\n  content: '\\e937';\n}\n.icon-md-actuating:before {\n  content: '\\e938';\n}\n.icon-md-flapping:before {\n  content: '\\e939';\n}\n.icon-md-paused:before {\n  content: '\\e93a';\n}\n.icon-md-resumed:before {\n  content: '\\e940';\n}\n.icon-md-unknown:before {\n  content: '\\e93b';\n}\n.icon-illuminated-sm:before {\n  content: '\\e932';\n}\n.icon-illuminated:before {\n  content: '\\e933';\n}\n.icon-maps-mark:before {\n  content: '\\e90d';\n}\n.icon-menu-kebab:before {\n  content: '\\e900';\n}\n.icon-load-balancer:before {\n  content: '\\e901';\n}\n.icon-expand-all:before {\n  content: '\\e928';\n}\n.icon-collapse:before {\n  content: '\\e929';\n}\n.icon-expand:before {\n  content: '\\e92a';\n}\n.icon-md-actuation-launched:before {\n  content: '\\e92b';\n}\n.icon-md-delta-resolved:before {\n  content: '\\e92c';\n}\n.icon-md-delta-detected:before {\n  content: '\\e92d';\n}\n.icon-md-missing-resource:before {\n  content: '\\e92e';\n}\n.icon-close:before {\n  content: '\\e927';\n}\n.icon-app-window:before {\n  content: '\\e924';\n}\n.icon-app-window-sm:before {\n  content: '\\e93d';\n}\n.icon-warn-diamond:before {\n  content: '\\e920';\n}\n.icon-search:before {\n  content: '\\e921';\n}\n.icon-new-function:before {\n  content: '\\e922';\n}\n.icon-lambda:before {\n  content: '\\e923';\n}\n.icon-menu:before {\n  content: '\\e925';\n}\n.icon-menu-close:before {\n  content: '\\e926';\n}\n.icon-network-good:before {\n  content: '\\e914';\n}\n.icon-network-bad:before {\n  content: '\\e91f';\n}\n.icon-cloud-remove:before {\n  content: '\\e90f';\n}\n.icon-cloud-loading:before {\n  content: '\\e90b';\n}\n.icon-cloud-check:before {\n  content: '\\e90c';\n}\n.icon-button-refresh-arrows:before {\n  content: '\\e903';\n}\n.icon-spel:before {\n  content: '\\e904';\n}\n.icon-pencil:before {\n  content: '\\e905';\n}\n.icon-alert-triangle:before {\n  content: '\\e906';\n}\n.icon-delete:before {\n  content: '\\e907';\n}\n.icon-bin:before {\n  content: '\\e908';\n}\n.icon-sp-handle:before {\n  content: '\\e909';\n}\n.icon-view-1:before {\n  content: '\\e90a';\n}\n.icon-navigation-left-circle:before {\n  content: '\\e912';\n}\n.icon-earth-warning:before {\n  content: '\\e915';\n}\n.icon-lab-tubes:before {\n  content: '\\e916';\n}\n.icon-lab-tube:before {\n  content: '\\e917';\n}\n.icon-calendar-warning:before {\n  content: '\\1f5f6';\n}\n.icon-explore-data:before {\n  content: '\\e91b';\n}\n.icon-canary-marginal:before {\n  content: '\\e91c';\n}\n.icon-canary-fail:before {\n  content: '\\e91d';\n}\n.icon-canary-pass:before {\n  content: '\\e91e';\n}\n.icon-file-json:before {\n  content: '\\e913';\n}\n.icon-copy-paste:before {\n  content: '\\e91a';\n}\n.icon-pipeline:before {\n  content: '\\e918';\n}\n.icon-button-play:before {\n  content: '\\e919';\n}\n.icon-critical:before {\n  content: '\\e902';\n}\n.icon-sitemap:before {\n  content: '\\e910';\n}\n.icon-spinner:before {\n  content: '\\e911';\n}\n.icon-arrow-button-down:before {\n  content: '\\e90e';\n}\n.icon-arrow-button-right:before {\n  content: '\\e92f';\n}\n.icon-arrow-down-1:before {\n  content: '\\e930';\n}\n.icon-arrow-up-1:before {\n  content: '\\e931';\n}\n";
styleInject(css_248z$13);

if (SETTINGS.analytics.ga || SETTINGS.analytics.customConfig) {
  window.addEventListener("load", () => {
    if (SETTINGS.analytics.customConfig) {
      window.ga("create", SETTINGS.analytics.ga, SETTINGS.analytics.customConfig);
    } else {
      window.ga("create", SETTINGS.analytics.ga, "auto");
    }
  });
}

const ANALYTICS_MODULE = "spinnaker.core.analytics";
module(ANALYTICS_MODULE, [angulartics, angularticsGoogleAnalytics]);

var css_248z$12 = ".spinnaker-header {\n  border-radius: 0;\n  margin-bottom: 0;\n  z-index: 25;\n  min-height: 40px;\n  width: 100%;\n}\n\n.navbar-right {\n  margin-left: auto;\n}\n\n.spinnaker-header .navbar-header .navbar-menu-icon {\n  display: flex;\n  justify-content: center;\n  min-width: 24px;\n  cursor: pointer;\n  width: 60px;\n  height: 40px !important;\n  cursor: pointer;\n}\n\n.spinnaker-header .app-view-menu {\n  background-color: var(--color-accent-g2);\n}\n\n.spinnaker-header a {\n  color: var(--color-text-on-dark);\n}\n\n.spinnaker-header .nav-layout {\n  display: flex;\n}\n\n.spinnaker-header .nav-items {\n  display: flex;\n  align-items: center;\n}\n\n.spinnaker-header .page-nav a.active,\n.spinnaker-header .page-nav a:active,\n.spinnaker-header .page-nav a:hover,\n.spinnaker-header .page-nav a:focus {\n  background-color: var(--color-primary-g1);\n}\n\n@media (max-width: 480px) {\n  .spinnaker-header .nav-items {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .spinnaker-header .nav-container {\n    overflow: hidden;\n  }\n}\n\n@media (min-width: 480px) {\n  .spinnaker-header .nav-container {\n    height: auto !important;\n  }\n}\n";
styleInject(css_248z$12);

const LOG_CATEGORY = "Navbar";
const SpinnakerHeaderContent = () => {
  const { state: currentState } = useCurrentStateAndParams();
  const isApplicationView = currentState.name.includes("project.application.") || currentState.name.includes("applications.application.");
  const [verticalNavExpanded, setVerticalNavExpanded] = useRecoilState(verticalNavExpandedAtom);
  const toggleNav = () => {
    setVerticalNavExpanded(!verticalNavExpanded);
    CollapsibleSectionStateCache.setExpanded("verticalNav", !verticalNavExpanded);
    logger.log({ category: LOG_CATEGORY, action: !verticalNavExpanded ? "ExpandVerticalNav" : "CollapseVerticalNav" });
  };
  const isDevicePhoneOrSmaller = () => {
    const bodyStyles = window.getComputedStyle(document.body);
    const isPhone = bodyStyles.getPropertyValue("--is-phone");
    return isPhone.toLowerCase() === "true";
  };
  const [navExpanded] = React__default.useState(!isDevicePhoneOrSmaller());
  const searchSref = useSrefActive("home.infrastructure", null, "active");
  const projectsSref = useSrefActive("home.projects", null, "active");
  const appsSref = useSrefActive("home.applications", null, "active");
  const templatesSref = useSrefActive("home.pipeline-templates", null, "active");
  const navItems = [
    {
      key: "navHome",
      text: "Search",
      srefProps: searchSref
    },
    {
      key: "navProjects",
      text: "Projects",
      srefProps: projectsSref
    },
    {
      key: "navApplications",
      text: "Applications",
      srefProps: appsSref
    },
    {
      key: "navPipelineTemplates",
      text: "Pipeline Templates",
      srefProps: templatesSref
    }
  ];
  return /* @__PURE__ */ React__default.createElement("nav", {
    className: "container spinnaker-header",
    role: "navigation",
    "aria-label": "Main Menu"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "navbar-header horizontal middle"
  }, /* @__PURE__ */ React__default.createElement("div", {
    onClick: toggleNav,
    className: `nav-container navbar-menu-icon horizontal middle center sp-margin-xl-right ${isApplicationView ? "app-view-menu" : ""}`
  }, isApplicationView && /* @__PURE__ */ React__default.createElement(Icon, {
    name: verticalNavExpanded ? "menuClose" : "menu",
    size: "medium",
    color: "primary"
  })), /* @__PURE__ */ React__default.createElement("a", {
    className: "navbar-brand flex-1",
    href: "#"
  }, "SPINNAKER")), navExpanded && /* @__PURE__ */ React__default.createElement("div", {
    className: "nav-container nav-items"
  }, /* @__PURE__ */ React__default.createElement("ul", {
    className: "nav nav-items flex-1 page-nav"
  }, navItems.map((item) => {
    const { onClick, ...restProps } = item.srefProps;
    return /* @__PURE__ */ React__default.createElement("li", {
      key: item.key
    }, /* @__PURE__ */ React__default.createElement("a", {
      ...restProps,
      onClick: (e) => {
        onClick(e);
        logger.log({ category: LOG_CATEGORY, action: item.key });
      }
    }, item.text));
  }), /* @__PURE__ */ React__default.createElement(GlobalSearch, null)), /* @__PURE__ */ React__default.createElement("ul", {
    className: "nav nav-items"
  }, /* @__PURE__ */ React__default.createElement(UserMenu, null), /* @__PURE__ */ React__default.createElement(HelpMenu, null))));
};
const SpinnakerHeader = overridableComponent(SpinnakerHeaderContent, "spinnakerHeader");

var css_248z$11 = ".custom-banner {\n  height: 30px;\n  line-height: 30px;\n  overflow: hidden;\n  padding: 0 10px;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n";
styleInject(css_248z$11);

class CustomBanner extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      applicationName: null,
      bannerConfig: null
    };
  }
  componentDidMount() {
    this.locationChangeUnsubscribe = ReactInjector.$uiRouter.transitionService.onSuccess({}, () => this.updateApplication());
  }
  updateApplication() {
    const applicationName = get(ReactInjector, "$stateParams.application");
    if (applicationName !== this.state.applicationName) {
      this.setState({
        applicationName,
        bannerConfig: null
      });
      if (applicationName) {
        ApplicationReader.getApplicationAttributes(applicationName).then((attributes) => {
          this.updateBannerConfig(attributes);
        }).catch(noop);
      }
    }
  }
  updateBannerConfig(attributes) {
    const bannerConfigs = get(attributes, "customBanners") || [];
    const bannerConfig = bannerConfigs.find((config) => config.enabled) || null;
    this.setState({
      bannerConfig
    });
  }
  render() {
    const { bannerConfig } = this.state;
    if (bannerConfig == null) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "custom-banner",
      style: {
        background: bannerConfig.backgroundColor,
        color: bannerConfig.textColor
      }
    }, /* @__PURE__ */ React__default.createElement(Markdown, {
      message: bannerConfig.text
    }));
  }
  componentWillUnmount() {
    this.locationChangeUnsubscribe();
  }
}

var css_248z$10 = ".Toastify__toast-container .Toastify__toast {\n  color: var(--color-text-primary);\n}\n.Toastify__toast-container .Toastify__toast-body {\n  overflow: hidden;\n  overflow-wrap: break-word;\n}\n.Toastify__toast-container .Toastify__toast--info {\n  background-color: var(--color-status-info-light);\n}\n.Toastify__toast-container .Toastify__toast--info .Toastify__close-button {\n  color: var(--color-dovegray);\n}\n.Toastify__toast-container .Toastify__toast--warning {\n  background-color: var(--color-status-warning-light);\n}\n.Toastify__toast-container .Toastify__toast--warning .Toastify__close-button {\n  color: var(--color-dovegray);\n}\n.Toastify__toast-container .Toastify__toast--error {\n  color: var(--color-white);\n}\n";
styleInject(css_248z$10);

const Notifier = () => {
  return /* @__PURE__ */ React__default.createElement(ToastContainer, {
    position: "bottom-right",
    autoClose: false,
    newestOnTop: true,
    closeOnClick: false
  });
};

const SpinnakerContainer = ({ authenticating, routing }) => /* @__PURE__ */ React.createElement(SpinErrorBoundary, {
  category: "SpinnakerContainer"
}, /* @__PURE__ */ React.createElement(RecoilRoot, null, /* @__PURE__ */ React.createElement("div", {
  className: "spinnaker-container grid-container"
}, !authenticating && routing && /* @__PURE__ */ React.createElement("div", {
  className: "transition-overlay"
}, /* @__PURE__ */ React.createElement(Spinner, {
  size: "medium"
})), /* @__PURE__ */ React.createElement("div", {
  className: "navbar-inverse grid-header"
}, /* @__PURE__ */ React.createElement(CustomBanner, null), /* @__PURE__ */ React.createElement(UIRouterContextComponent, null, /* @__PURE__ */ React.createElement(SpinnakerHeader, null))), /* @__PURE__ */ React.createElement("div", {
  className: "spinnaker-content grid-contents"
}, !authenticating && /* @__PURE__ */ React.createElement(UIView, {
  name: "main"
}))), /* @__PURE__ */ React.createElement(Notifier, null)));

const SPINNAKER_CONTAINER_COMPONENT = "spinnaker.core.container.component";
module(SPINNAKER_CONTAINER_COMPONENT, []).component("spinnakerContainer", react2angular(withErrorBoundary(SpinnakerContainer, "spinnakerContainer"), ["authenticating", "routing"]));

const APPLICATION_BOOTSTRAP_MODULE = "spinnaker.core.applicationBootstrap";
const bootstrapModule = module(APPLICATION_BOOTSTRAP_MODULE, [
  OVERRIDE_REGISTRY,
  SPINNAKER_CONTAINER_COMPONENT
]);

const paramChangedHelper = (paramName, changedHandler) => {
  return (transition) => {
    const previousValue = transition.params("from")[paramName];
    const newValue = transition.params("to")[paramName];
    if (previousValue === newValue) {
      return null;
    }
    return changedHandler(newValue, previousValue);
  };
};

bootstrapModule.config([
  "$logProvider",
  ($logProvider) => {
    $logProvider.debugEnabled(SETTINGS.debugEnabled);
  }
]);
bootstrapModule.config([
  "$httpProvider",
  ($httpProvider) => {
    $httpProvider.defaults.headers.patch = {
      "Content-Type": "application/json;charset=utf-8"
    };
  }
]);
bootstrapModule.config([
  "$compileProvider",
  ($compileProvider) => {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|slack|ssh):/);
  }
]);
bootstrapModule.config([
  "$locationProvider",
  ($locationProvider) => {
    $locationProvider.hashPrefix("");
    $locationProvider.html5Mode({
      enabled: SETTINGS.feature.html5Routing,
      rewriteLinks: false,
      requireBase: false
    });
  }
]);

bootstrapModule.run([
  "$rootScope",
  "$state",
  ($rootScope, $state) => {
    $rootScope.feature = SETTINGS.feature;
    $rootScope.$state = $state;
  }
]);
bootstrapModule.run([
  "cacheInitializer",
  (cacheInitializer) => {
    cacheInitializer.initialize();
  }
]);

const template$1 = `
  <spinnaker-container authenticating="$ctrl.authenticating" routing="$ctrl.routing"></spinnaker-container>
`;
class SpinnakerController {
  constructor($rootScope) {
    this.feature = SETTINGS.feature;
    this.authenticating = $rootScope.authenticating;
    this.routing = $rootScope.routing;
  }
}
SpinnakerController.$inject = ["$rootScope"];
bootstrapModule.component("spinnaker", {
  template: template$1,
  controller: SpinnakerController
});

bootstrapModule.run([
  "$uiRouter",
  "$log",
  ($uiRouter, $log) => {
    const subscription = $uiRouter.globals.start$.subscribe((transition) => {
      const details = {
        transition,
        toState: transition.to(),
        toParams: transition.params("to"),
        fromState: transition.from(),
        fromParams: transition.params("from")
      };
      $log.debug("$stateChangeStart", details);
      const success = () => $log.debug("$stateChangeSuccess", details);
      const failure = (error) => $log.debug("$stateChangeError", { ...details, error });
      transition.promise.then(success, failure);
    });
    $uiRouter.disposable({ dispose: () => subscription.unsubscribe() });
  }
]);

bootstrapModule.run([
  "$uiRouter",
  ($uiRouter) => {
    const changeTraceSetting = (newValue) => {
      const trace = $uiRouter.trace;
      trace.disable();
      if (typeof newValue === "string") {
        if (newValue.toUpperCase() === "TRUE") {
          trace.enable(Category.TRANSITION);
        } else if (newValue.toUpperCase() === "ALL") {
          trace.enable();
        } else {
          const traceValues = newValue.split(",").map((str) => str.trim().toUpperCase());
          trace.enable(...traceValues);
        }
      }
    };
    $uiRouter.transitionService.onBefore({}, paramChangedHelper("trace", changeTraceSetting));
  }
]);

bootstrapModule.config([
  "$uibTooltipProvider",
  ($uibTooltipProvider) => {
    $uibTooltipProvider.options({
      appendToBody: true
    });
    $uibTooltipProvider.setTriggers({
      "mouseenter focus": "mouseleave blur"
    });
  }
]);
bootstrapModule.config([
  "$uibModalProvider",
  ($uibModalProvider) => {
    $uibModalProvider.options.backdrop = "static";
    $uibModalProvider.options.keyboard = false;
  }
]);

bootstrapModule.config([
  "$uiRouterProvider",
  ($uiRouterProvider) => {
    $uiRouterProvider.plugin(UIRouterRxPlugin);
  }
]);

bootstrapModule.run([
  "$uiRouter",
  ($uiRouter) => {
    let visualizerEnabled = "false";
    let VisualizerPlugin = null;
    function loadVisualizer() {
      const collapseGlobs = ["home.*", "home.*.application.*", "home.*.application.insight.*"].map((globStr) => new Glob(globStr));
      const collapsedStates = $uiRouter.stateRegistry.get().filter((state) => collapseGlobs.some((glob) => glob.matches(state.name)));
      collapsedStates.forEach((state) => state.$$state()._collapsed = true);
      return import('@uirouter/visualizer').then((vis) => VisualizerPlugin = vis.Visualizer).then(createVisualizer);
    }
    function createVisualizer() {
      if (visualizerEnabled !== "true") {
        return;
      }
      destroyVisualizer();
      if (VisualizerPlugin) {
        $uiRouter.plugin(VisualizerPlugin);
      } else {
        loadVisualizer();
      }
    }
    function destroyVisualizer() {
      const plugin = $uiRouter.getPlugin("visualizer");
      plugin && $uiRouter.dispose(plugin);
    }
    function toggleVisualizer(trans) {
      const enabled = trans.paramsChanged().vis;
      if (enabled === void 0) {
        return null;
      }
      if (enabled === visualizerEnabled) {
        return trans.targetState().withParams({ vis: void 0 });
      }
      visualizerEnabled = enabled;
      if (enabled === "true") {
        createVisualizer();
      } else if (enabled === "false") {
        destroyVisualizer();
      }
      return trans.targetState().withParams({ vis: void 0 });
    }
    window.vis = createVisualizer;
    $uiRouter.transitionService.onStart({}, toggleVisualizer);
  }
]);

uiSelectDecorator.$inject = ["$provide"];
function uiSelectDecorator($provide) {
  $provide.decorator("uiSelectMultipleDirective", [
    "$delegate",
    "$timeout",
    function($delegate, $timeout) {
      const [uiSelect] = $delegate;
      const originalLink = uiSelect.link;
      const SELECT_EVENT_KEY = "uis:select";
      uiSelect.link = function(scope, _element, _attrs, ctrls) {
        originalLink.apply(this, arguments);
        const [$select] = ctrls;
        scope.$$listeners[SELECT_EVENT_KEY] = [];
        scope.$on(SELECT_EVENT_KEY, function(event, item) {
          if ($select.selected.length >= $select.limit) {
            return;
          }
          if (!event.defaultPrevented) {
            $select.selected.push(item);
            const locals = {
              [$select.parserResult.itemName]: item
            };
            $timeout(function() {
              if ($select.onSelectCallback) {
                $select.onSelectCallback(scope, {
                  $item: item,
                  $model: $select.parserResult.modelMapper(scope, locals)
                });
              }
            });
            scope.$selectMultiple.updateModel();
          }
        });
      };
      return $delegate;
    }
  ]);
  $provide.decorator("uiSelectMinErr", [
    "$delegate",
    function($delegate) {
      return function handledError() {
        const original = $delegate;
        if (arguments.length === 3) {
          if (arguments[0] === "choices" && arguments[1] === `Expected multiple .ui-select-choices-row but got '{0}'.` && arguments[2] === 0) {
            throw new Error("IGNORE", "IGNORE");
          }
        }
        return original.apply(this, arguments);
      };
    }
  ]);
  $provide.decorator("$exceptionHandler", [
    "$delegate",
    function($delegate) {
      return function(exception, cause) {
        if (exception && exception.message === "IGNORE") {
          return;
        }
        if (Array.isArray(exception) && exception.length && exception[0] instanceof Error) {
          exception.forEach((e) => $delegate(e, cause));
        } else {
          $delegate(exception, cause);
        }
      };
    }
  ]);
}
bootstrapModule.config(uiSelectDecorator);
bootstrapModule.config([
  "uiSelectConfig",
  (uiSelectConfig) => {
    uiSelectConfig.theme = "select2";
    uiSelectConfig.appendToBody = true;
  }
]);

class ApplicationSearchResultType extends SearchResultType {
  constructor() {
    super(...arguments);
    this.id = "applications";
    this.order = 1;
    this.displayName = "Applications";
    this.iconClass = "far fa-window-maximize";
    this.cols = {
      APPLICATION: { key: "application", label: "Name" },
      ACCOUNT: { key: "accounts", label: "Account" },
      EMAIL: { key: "email" }
    };
    this.TabComponent = DefaultSearchResultTab;
    this.HeaderComponent = () => /* @__PURE__ */ React__default.createElement(SearchTableHeader, null, /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.APPLICATION
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.ACCOUNT
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.EMAIL
    }));
    this.DataComponent = ({ resultSet }) => {
      const itemKeyFn = (item) => item.application;
      const itemSortFn = (a, b) => a.application.localeCompare(b.application);
      const results = resultSet.results.slice().sort(itemSortFn);
      return /* @__PURE__ */ React__default.createElement(SearchTableBody, null, results.map((item) => /* @__PURE__ */ React__default.createElement(SearchTableRow, {
        key: itemKeyFn(item)
      }, /* @__PURE__ */ React__default.createElement(HrefCell, {
        item,
        col: this.cols.APPLICATION
      }), /* @__PURE__ */ React__default.createElement(AccountCell, {
        item,
        col: this.cols.ACCOUNT
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.EMAIL
      }))));
    };
  }
  displayFormatter(searchResult) {
    return searchResult.application;
  }
}
searchResultTypeRegistry.register(new ApplicationSearchResultType());

const ApplicationTable = ({ currentSort, toggleSort, applications }) => /* @__PURE__ */ React__default.createElement("table", {
  className: "table table-hover"
}, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", {
  style: { width: "18%" }
}, /* @__PURE__ */ React__default.createElement(SortToggle, {
  currentSort,
  onChange: toggleSort,
  label: "Name",
  sortKey: "name"
})), /* @__PURE__ */ React__default.createElement("th", {
  style: { width: "15%" }
}, /* @__PURE__ */ React__default.createElement(SortToggle, {
  currentSort,
  onChange: toggleSort,
  label: "Created",
  sortKey: "createTs"
})), /* @__PURE__ */ React__default.createElement("th", {
  style: { width: "15%" }
}, /* @__PURE__ */ React__default.createElement(SortToggle, {
  currentSort,
  onChange: toggleSort,
  label: "Updated",
  sortKey: "updateTs"
})), /* @__PURE__ */ React__default.createElement("th", {
  style: { width: "15%" }
}, /* @__PURE__ */ React__default.createElement(SortToggle, {
  currentSort,
  onChange: toggleSort,
  label: "Owner",
  sortKey: "email"
})), /* @__PURE__ */ React__default.createElement("th", null, /* @__PURE__ */ React__default.createElement(SortToggle, {
  currentSort,
  onChange: toggleSort,
  label: "Account(s)",
  sortKey: "accounts"
})), SETTINGS.feature.slack && /* @__PURE__ */ React__default.createElement("th", {
  style: { width: "22%" }
}, "Slack Channel"), /* @__PURE__ */ React__default.createElement("th", {
  style: { width: "22%" }
}, "Description"))), /* @__PURE__ */ React__default.createElement("tbody", null, applications.map((app) => {
  var _a;
  const appName = app.name.toLowerCase();
  return /* @__PURE__ */ React__default.createElement(UISref, {
    key: appName,
    to: ".application",
    params: { application: appName }
  }, /* @__PURE__ */ React__default.createElement("tr", {
    className: "clickable"
  }, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(UISref, {
    to: ".application",
    params: { application: appName }
  }, /* @__PURE__ */ React__default.createElement("a", null, appName))), /* @__PURE__ */ React__default.createElement("td", null, timestamp(app.createTs)), /* @__PURE__ */ React__default.createElement("td", null, timestamp(app.updateTs)), /* @__PURE__ */ React__default.createElement("td", null, app.email), /* @__PURE__ */ React__default.createElement("td", null, app.accounts), SETTINGS.feature.slack && /* @__PURE__ */ React__default.createElement("td", null, (_a = app.slackChannel) == null ? void 0 : _a.name), /* @__PURE__ */ React__default.createElement("td", null, app.description)));
})));

const PaginationControls = ({ onPageChanged, activePage, totalPages }) => {
  const Item = (props) => /* @__PURE__ */ React__default.createElement("li", {
    className: `${props.isActive ? "active" : ""} ${props.disabled ? "disabled" : ""}`
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: `${!props.disabled ? "clickable" : ""}`,
    onClick: props.onClick
  }, props.value));
  const Paging = createUltimatePagination({
    WrapperComponent: Pagination,
    itemTypeToComponent: {
      [ITEM_TYPES.PAGE]: ({ value, isActive, onClick }) => /* @__PURE__ */ React__default.createElement(Item, {
        value,
        isActive,
        onClick
      }),
      [ITEM_TYPES.ELLIPSIS]: ({ isActive, onClick }) => /* @__PURE__ */ React__default.createElement(Item, {
        value: `\u2026`,
        disabled: isActive,
        onClick
      }),
      [ITEM_TYPES.FIRST_PAGE_LINK]: ({ isActive, onClick }) => /* @__PURE__ */ React__default.createElement(Item, {
        value: `\xAB`,
        disabled: isActive,
        onClick
      }),
      [ITEM_TYPES.PREVIOUS_PAGE_LINK]: ({ isActive, onClick }) => /* @__PURE__ */ React__default.createElement(Item, {
        value: `\u2039`,
        disabled: isActive,
        onClick
      }),
      [ITEM_TYPES.NEXT_PAGE_LINK]: ({ isActive, onClick }) => /* @__PURE__ */ React__default.createElement(Item, {
        value: `\u203A`,
        disabled: isActive,
        onClick
      }),
      [ITEM_TYPES.LAST_PAGE_LINK]: ({ isActive, onClick }) => /* @__PURE__ */ React__default.createElement(Item, {
        value: `\xBB`,
        disabled: isActive,
        onClick
      })
    }
  });
  return /* @__PURE__ */ React__default.createElement(Paging, {
    onChange: onPageChanged,
    currentPage: activePage,
    totalPages
  });
};

var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __decorateClass$e = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$e(target, key, result);
  return result;
};
let InsightMenu = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.createProject = () => ConfigureProjectModal.show().then((result) => {
      this.$state.go("home.project.dashboard", { project: result.name });
    }).catch(() => {
    });
    this.createApplication = () => {
      this.$uibModal.open({
        scope: this.$rootScope.$new(),
        templateUrl: this.overrideRegistry.getTemplate("createApplicationModal", "core/src/application/modal/newapplication.html"),
        resolve: {
          name: () => ""
        },
        controller: this.overrideRegistry.getController("CreateApplicationModalCtrl"),
        controllerAs: "newAppModal"
      }).result.then(this.routeToApplication).catch(() => {
      });
    };
    this.routeToApplication = (app) => {
      this.$state.go("home.applications.application", { application: app.name });
    };
    this.refreshAllCaches = () => {
      if (this.state.refreshingCache) {
        return;
      }
      this.setState({ refreshingCache: true });
      this.cacheInitializer.refreshCaches().then(() => {
        this.setState({ refreshingCache: false });
      });
    };
    this.state = {};
    this.$state = ReactInjector.$state;
    this.$uibModal = ModalInjector.modalService;
    this.$rootScope = ReactInjector.$rootScope;
    this.overrideRegistry = ReactInjector.overrideRegistry;
    this.cacheInitializer = ReactInjector.cacheInitializer;
  }
  render() {
    const { createApp, createProject, refreshCaches } = this.props;
    const refreshMarkup = this.state.refreshingCache ? /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "fa fa-sync-alt fa-spin"
    }), " Refreshing...") : /* @__PURE__ */ React__default.createElement("span", null, "Refresh all caches");
    return /* @__PURE__ */ React__default.createElement("div", {
      id: "insight-menu"
    }, createProject && /* @__PURE__ */ React__default.createElement(Button$1, {
      bsStyle: createApp ? "default" : "primary",
      href: "javascript:void(0)",
      onClick: this.createProject,
      style: { marginRight: createApp ? "5px" : "" }
    }, "Create Project"), createApp && /* @__PURE__ */ React__default.createElement(Button$1, {
      bsStyle: "primary",
      href: "javascript:void(0)",
      onClick: this.createApplication,
      style: { marginRight: refreshCaches ? "5px" : "" }
    }, "Create Application"), refreshCaches && /* @__PURE__ */ React__default.createElement(Button$1, {
      href: "javascript:void(0)",
      onClick: this.refreshAllCaches
    }, refreshMarkup));
  }
};
InsightMenu.defaultProps = { createApp: true, createProject: true, refreshCaches: true };
InsightMenu = __decorateClass$e([
  Overridable("createInsightMenu")
], InsightMenu);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/modal/newapplication.html", `<div class="modal-page">
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">New Application</h4>
  </div>
  <div ng-if="newAppModal.state.initializing" style="height: 200px">
    <loading-spinner size="'medium'"></loading-spinner>
  </div>
  <div ng-if="newAppModal.state.initializeFailed" style="...">
    <div
      class="horizontal middle center heading-4"
      style="padding-left: 15px; padding-right: 15px; margin-bottom: 250px; height: 150px"
    >
      <i class="fa fa-exclamation-triangle" style="padding-right: 8px"></i>
      <span>
        Error initializing dialog. Check that your gate endpoint is accessible. Further information on troubleshooting
        this error is available <a href="https://www.spinnaker.io/setup/quickstart/faq/">here</a>.
      </span>
    </div>
  </div>
  <form
    role="form"
    class="container-fluid"
    novalidate
    name="newApplicationForm"
    ng-if="!(newAppModal.state.initializing || newAppModal.state.initializeFailed)"
  >
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Name *</div>
        <div class="col-sm-9">
          <input
            type="text"
            autofocus
            name="name"
            class="form-control input-sm"
            data-purpose="application-name"
            ng-model="newAppModal.application.name"
            placeholder="Enter an application name"
            validate-unique="newAppModal.data.appNameList"
            ng-model-options="{allowInvalid: true}"
            validate-application-name
            cloud-providers="newAppModal.application.cloudProviders"
            required
          />
        </div>
      </div>

      <application-name-validation-messages
        name="newAppModal.application.name"
        cloud-providers="newAppModal.application.cloudProviders"
      ></application-name-validation-messages>

      <div class="form-group row slide-in" ng-if="newApplicationForm.name.$error.validateUnique">
        <div class="col-sm-9 col-sm-offset-3 error-message">
          <span>Application name must be unique.</span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Owner Email *</div>
        <div class="col-sm-9">
          <input
            type="email"
            name="email"
            class="form-control input-sm"
            data-purpose="application-email"
            ng-model="newAppModal.application.email"
            placeholder="Enter an email address"
            required
          />
        </div>
      </div>

      <div class="form-group row slide-in" ng-if="newApplicationForm.email.$dirty && newApplicationForm.email.$invalid">
        <div class="col-sm-9 col-sm-offset-3 error-message">
          <span>Please enter a valid email address</span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Repo Type</div>
        <div class="col-sm-9">
          <select
            class="form-control input-sm"
            ng-options="repoType for repoType in newAppModal.data.gitSources"
            ng-model="newAppModal.application.repoType"
          >
            <option value="">Select Repo Type</option>
          </select>
        </div>
      </div>
      <div class="form-group row" ng-if="newAppModal.application.repoType">
        <div class="col-sm-3 sm-label-right">Repo Project</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="newAppModal.application.repoProjectKey"
            placeholder="Enter your source repository project name"
          />
        </div>
      </div>
      <div class="form-group row" ng-if="newAppModal.application.repoType">
        <div class="col-sm-3 sm-label-right">Repo Name</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="newAppModal.application.repoSlug"
            placeholder="Enter your source repository name (not the URL)"
            pattern="^((?!://).)*$"
            name="repoSlug"
          />
        </div>
      </div>

      <div class="form-group row slide-in" ng-messages="newApplicationForm.repoSlug.$error">
        <div class="col-sm-9 col-sm-offset-3 error-message" ng-message="pattern">
          Enter your source repository name (not the URL).
        </div>
      </div>

      <chaos-monkey-new-application-config
        application-config="newAppModal.application"
      ></chaos-monkey-new-application-config>

      <render-if-feature feature="pagerDuty">
        <pager-duty-select-field component="newAppModal.application"></pager-duty-select-field>
      </render-if-feature>

      <render-if-feature feature="slack">
        <slack-channel-selector
          channel="newAppModal.application.slackChannel"
          callback="newAppModal.setAttribute"
        ></slack-channel-selector>
      </render-if-feature>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Description</div>
        <div class="col-sm-9">
          <textarea
            class="form-control input-sm"
            ng-model="newAppModal.application.description"
            placeholder="Enter a description"
            data-purpose="application-description"
          >
          </textarea>
        </div>
      </div>

      <div class="form-group row" ng-if="newAppModal.data.cloudProviders.length > 1">
        <div class="col-md-3 sm-label-right">Cloud Providers</div>
        <div class="col-md-5">
          <ui-select multiple ng-model="newAppModal.application.cloudProviders" class="form-control input-sm">
            <ui-select-match> {{$item}} </ui-select-match>
            <ui-select-choices repeat="provider in newAppModal.data.cloudProviders | filter: $select.search">
              {{provider}}
            </ui-select-choices>
          </ui-select>
        </div>
      </div>

      <application-provider-fields
        cloud-providers="newAppModal.data.cloudProviders"
        application="newAppModal.application"
      >
      </application-provider-fields>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Instance Health</div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input type="checkbox" ng-model="newAppModal.application.platformHealthOnly" />
            Consider only cloud provider health when executing tasks
            <help-field key="application.platformHealthOnly"></help-field>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right"></div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input
              type="checkbox"
              ng-model="newAppModal.application.platformHealthOnlyShowOverride"
              ng-click="newAppModal.updateCloudProviderHealthWarning()"
            />
            Show health override option for each operation
            <help-field key="application.showPlatformHealthOverride"></help-field>
          </label>
        </div>
      </div>

      <div class="col-md-12" ng-if="newAppModal.data.showOverrideWarning">
        <div class="alert alert-warning">
          <p>
            <i class="fa fa-exclamation-triangle"></i>
            {{newAppModal.data.showOverrideWarning}}
          </p>
          <p class="text-right">
            <a
              class="btn btn-sm btn-default dirty-flag-dismiss"
              href
              ng-click="newAppModal.data.showOverrideWarning = null"
              >Okay</a
            >
          </p>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">
          Instance Port
          <help-field key="application.instance.port"></help-field>
        </div>
        <div class="col-sm-2">
          <input
            type="number"
            min="0"
            max="65536"
            class="form-control input-sm"
            ng-model="newAppModal.application.instancePort"
            name="instancePort"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Pipeline Behavior</div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input type="checkbox" ng-model="editApp.applicationAttributes.enableRestartRunningExecutions" />
            Enable restarting running pipelines
          </label>
          <help-field key="application.enableRestartRunningExecutions"></help-field>
          <label>
            <input type="checkbox" ng-model="editApp.applicationAttributes.enableRerunActiveExecutions" />
            Enable re-run button on active pipelines
          </label>
          <help-field key="application.enableRerunActiveExecutions"></help-field>
        </div>
      </div>

      <render-if-feature feature="fiatEnabled">
        <div class="form-group row">
          <div class="col-sm-3 sm-label-right">Permissions <help-field key="application.permissions"></help-field></div>
          <div class="col-sm-9">
            <permissions-configurer
              permissions="newAppModal.application.permissions"
              on-permissions-change="newAppModal.handlePermissionsChange"
              required-group-membership="newAppModal.application.requiredGroupMembership"
            >
            </permissions-configurer>
          </div>
        </div>
      </render-if-feature>

      <div class="form-group row slide-in" ng-if="newAppModal.state.errorMessages.length">
        <div class="col-md-12">
          <div class="alert alert-danger">
            <div ng-repeat="errorMessage in newAppModal.state.errorMessages">
              <status-glyph item="{isFailed: true}"></status-glyph> {{errorMessage}}
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <em>* Required</em>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <submit-button
        is-new="true"
        is-disabled="newApplicationForm.$invalid || newAppModal.state.submitting || newAppModal.data.showOverrideWarning || newAppModal.state.permissionsInvalid"
        submitting="newAppModal.state.submitting"
        on-click="newAppModal.submit()"
      ></submit-button>
    </div>
  </form>
</div>
`);
}]);

var css_248z$$ = ".applications {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n}\n";
styleInject(css_248z$$);

class Applications extends React__default.Component {
  constructor(props) {
    super(props);
    this.filter$ = new BehaviorSubject(null);
    this.sort$ = new BehaviorSubject(null);
    this.pagination$ = new BehaviorSubject(this.getDefaultPagination());
    this.destroy$ = new Subject();
    this.applyCachedViewState();
    const pagination = this.getDefaultPagination();
    this.state = { pagination };
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  applyCachedViewState() {
    this.applicationsCache = ViewStateCache.get("applications") || ViewStateCache.createCache("applications", { version: 2 });
    const viewState = this.applicationsCache.get("#global") || { filter: "", sort: "+name" };
    this.filter$.next(viewState.filter);
    this.sort$.next(viewState.sort);
  }
  componentDidMount() {
    const appMatchesQuery = (query, app) => {
      const searchableValues = [app.name, app.email, app.accounts, app.description].filter((f) => !!f).map((f) => f.toLowerCase());
      return searchableValues.some((value) => value.includes(query));
    };
    const appSort = (column, a, b) => {
      const reverse = column[0] === "-";
      const key = reverse ? column.slice(1) : column;
      return (a[key] || "").localeCompare(b[key] || "") * (reverse ? -1 : 1);
    };
    const applicationSummaries$ = from(ApplicationReader.listApplications()).pipe(map((apps) => apps.map((app) => this.fixAccount(app))));
    const filteredApps$ = combineLatest([applicationSummaries$, this.filter$, this.sort$]).pipe(map(([apps, filter, sort]) => {
      const viewState = { filter, sort };
      this.applicationsCache.put("#global", viewState);
      return apps.filter((app) => appMatchesQuery(filter, app)).sort((a, b) => appSort(sort, a, b));
    }));
    combineLatest([filteredApps$, this.pagination$.pipe(distinctUntilChanged(isEqual))]).pipe(map(([applications, pagination]) => {
      const lastPage = Math.floor(applications.length / pagination.itemsPerPage) + 1;
      const currentPage = Math.min(pagination.currentPage, lastPage);
      const maxSize = applications.length;
      const validatedPagination = { ...pagination, currentPage, maxSize };
      return { applications, pagination: validatedPagination };
    }), takeUntil(this.destroy$)).subscribe(({ applications, pagination }) => {
      const { currentPage, itemsPerPage } = pagination;
      const start = (currentPage - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      this.setState({ applications: applications.slice(start, end), pagination });
    }, (error) => {
      this.setState({ errorState: true });
      throw error;
    });
    const { $stateParams, $state, $rootScope, overrideRegistry } = ReactInjector;
    const { create } = $stateParams;
    applicationSummaries$.subscribe((applications) => {
      if (create) {
        const found = applications.find((app) => app.name === create);
        if (found) {
          if (found.email) {
            $state.go("home.applications.application", { application: create, create: null });
          } else {
            $state.go("home.applications.application.config", { application: create, create: null });
          }
        } else {
          ModalInjector.modalService.open({
            scope: $rootScope.$new(),
            templateUrl: overrideRegistry.getTemplate("createApplicationModal", "core/src/application/modal/newapplication.html"),
            resolve: {
              name: () => create
            },
            controller: overrideRegistry.getController("CreateApplicationModalCtrl"),
            controllerAs: "newAppModal"
          }).result.then((app) => {
            $state.go("home.applications.application", { application: app.name, create: null });
          }, () => {
            $state.go("home.applications", { create: null });
          }).catch(() => {
          });
        }
      }
    });
  }
  toggleSort(column) {
    const current = this.sort$.getValue();
    const newSort = current === column ? `-${column}` : column;
    this.sort$.next(newSort);
  }
  fixAccount(application) {
    if (application.accounts) {
      application.accounts = application.accounts.split(",").sort().join(", ");
    }
    return application;
  }
  getDefaultPagination() {
    return {
      currentPage: 1,
      itemsPerPage: 12,
      maxSize: 12
    };
  }
  render() {
    const { applications, pagination, errorState } = this.state;
    const { maxSize, currentPage, itemsPerPage } = pagination;
    const currentSort = this.sort$.value;
    const changePage = (page) => {
      return this.pagination$.next({ ...pagination, currentPage: page });
    };
    const LoadingSpinner = () => /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal middle center",
      style: { marginBottom: "250px", height: "150px" }
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    }));
    const ErrorIndicator = () => /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal middle center heading-4",
      style: { marginBottom: "250px", height: "150px" }
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle",
      style: { paddingRight: "8px" }
    }), /* @__PURE__ */ React__default.createElement("span", null, "Error fetching applications. Check that your gate endpoint is accessible. Further information on troubleshooting this error is available ", /* @__PURE__ */ React__default.createElement("a", {
      href: "https://www.spinnaker.io/setup/quickstart/faq/"
    }, "here"), "."));
    const ApplicationData = () => {
      if (errorState) {
        return /* @__PURE__ */ React__default.createElement(ErrorIndicator, null);
      }
      if (!applications) {
        return /* @__PURE__ */ React__default.createElement(LoadingSpinner, null);
      }
      if (applications.length === 0) {
        return /* @__PURE__ */ React__default.createElement("h4", null, "No matches found for '", this.filter$.value, "'");
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "infrastructure-section"
      }, /* @__PURE__ */ React__default.createElement(ApplicationTable, {
        currentSort,
        applications,
        toggleSort: (column) => this.toggleSort(column)
      }), /* @__PURE__ */ React__default.createElement(PaginationControls, {
        onPageChanged: changePage,
        activePage: currentPage,
        totalPages: Math.ceil(maxSize / itemsPerPage)
      }));
    };
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure-section search-header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "container"
    }, /* @__PURE__ */ React__default.createElement("h2", {
      className: "header-section"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "search-label"
    }, "Applications"), /* @__PURE__ */ React__default.createElement("input", {
      type: "search",
      placeholder: "Search applications",
      className: "form-control input-md",
      ref: (input) => input && input.focus(),
      onChange: (evt) => this.filter$.next(evt.target.value),
      value: this.filter$.value
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "header-actions"
    }, /* @__PURE__ */ React__default.createElement(InsightMenu, {
      createApp: true,
      createProject: false,
      refreshCaches: false
    })))), /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure-section container"
    }, /* @__PURE__ */ React__default.createElement(ApplicationData, null)));
  }
}
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/modal/newapplication.html", `<div class="modal-page">
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">New Application</h4>
  </div>
  <div ng-if="newAppModal.state.initializing" style="height: 200px">
    <loading-spinner size="'medium'"></loading-spinner>
  </div>
  <div ng-if="newAppModal.state.initializeFailed" style="...">
    <div
      class="horizontal middle center heading-4"
      style="padding-left: 15px; padding-right: 15px; margin-bottom: 250px; height: 150px"
    >
      <i class="fa fa-exclamation-triangle" style="padding-right: 8px"></i>
      <span>
        Error initializing dialog. Check that your gate endpoint is accessible. Further information on troubleshooting
        this error is available <a href="https://www.spinnaker.io/setup/quickstart/faq/">here</a>.
      </span>
    </div>
  </div>
  <form
    role="form"
    class="container-fluid"
    novalidate
    name="newApplicationForm"
    ng-if="!(newAppModal.state.initializing || newAppModal.state.initializeFailed)"
  >
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Name *</div>
        <div class="col-sm-9">
          <input
            type="text"
            autofocus
            name="name"
            class="form-control input-sm"
            data-purpose="application-name"
            ng-model="newAppModal.application.name"
            placeholder="Enter an application name"
            validate-unique="newAppModal.data.appNameList"
            ng-model-options="{allowInvalid: true}"
            validate-application-name
            cloud-providers="newAppModal.application.cloudProviders"
            required
          />
        </div>
      </div>

      <application-name-validation-messages
        name="newAppModal.application.name"
        cloud-providers="newAppModal.application.cloudProviders"
      ></application-name-validation-messages>

      <div class="form-group row slide-in" ng-if="newApplicationForm.name.$error.validateUnique">
        <div class="col-sm-9 col-sm-offset-3 error-message">
          <span>Application name must be unique.</span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Owner Email *</div>
        <div class="col-sm-9">
          <input
            type="email"
            name="email"
            class="form-control input-sm"
            data-purpose="application-email"
            ng-model="newAppModal.application.email"
            placeholder="Enter an email address"
            required
          />
        </div>
      </div>

      <div class="form-group row slide-in" ng-if="newApplicationForm.email.$dirty && newApplicationForm.email.$invalid">
        <div class="col-sm-9 col-sm-offset-3 error-message">
          <span>Please enter a valid email address</span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Repo Type</div>
        <div class="col-sm-9">
          <select
            class="form-control input-sm"
            ng-options="repoType for repoType in newAppModal.data.gitSources"
            ng-model="newAppModal.application.repoType"
          >
            <option value="">Select Repo Type</option>
          </select>
        </div>
      </div>
      <div class="form-group row" ng-if="newAppModal.application.repoType">
        <div class="col-sm-3 sm-label-right">Repo Project</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="newAppModal.application.repoProjectKey"
            placeholder="Enter your source repository project name"
          />
        </div>
      </div>
      <div class="form-group row" ng-if="newAppModal.application.repoType">
        <div class="col-sm-3 sm-label-right">Repo Name</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="newAppModal.application.repoSlug"
            placeholder="Enter your source repository name (not the URL)"
            pattern="^((?!://).)*$"
            name="repoSlug"
          />
        </div>
      </div>

      <div class="form-group row slide-in" ng-messages="newApplicationForm.repoSlug.$error">
        <div class="col-sm-9 col-sm-offset-3 error-message" ng-message="pattern">
          Enter your source repository name (not the URL).
        </div>
      </div>

      <chaos-monkey-new-application-config
        application-config="newAppModal.application"
      ></chaos-monkey-new-application-config>

      <render-if-feature feature="pagerDuty">
        <pager-duty-select-field component="newAppModal.application"></pager-duty-select-field>
      </render-if-feature>

      <render-if-feature feature="slack">
        <slack-channel-selector
          channel="newAppModal.application.slackChannel"
          callback="newAppModal.setAttribute"
        ></slack-channel-selector>
      </render-if-feature>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Description</div>
        <div class="col-sm-9">
          <textarea
            class="form-control input-sm"
            ng-model="newAppModal.application.description"
            placeholder="Enter a description"
            data-purpose="application-description"
          >
          </textarea>
        </div>
      </div>

      <div class="form-group row" ng-if="newAppModal.data.cloudProviders.length > 1">
        <div class="col-md-3 sm-label-right">Cloud Providers</div>
        <div class="col-md-5">
          <ui-select multiple ng-model="newAppModal.application.cloudProviders" class="form-control input-sm">
            <ui-select-match> {{$item}} </ui-select-match>
            <ui-select-choices repeat="provider in newAppModal.data.cloudProviders | filter: $select.search">
              {{provider}}
            </ui-select-choices>
          </ui-select>
        </div>
      </div>

      <application-provider-fields
        cloud-providers="newAppModal.data.cloudProviders"
        application="newAppModal.application"
      >
      </application-provider-fields>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Instance Health</div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input type="checkbox" ng-model="newAppModal.application.platformHealthOnly" />
            Consider only cloud provider health when executing tasks
            <help-field key="application.platformHealthOnly"></help-field>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right"></div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input
              type="checkbox"
              ng-model="newAppModal.application.platformHealthOnlyShowOverride"
              ng-click="newAppModal.updateCloudProviderHealthWarning()"
            />
            Show health override option for each operation
            <help-field key="application.showPlatformHealthOverride"></help-field>
          </label>
        </div>
      </div>

      <div class="col-md-12" ng-if="newAppModal.data.showOverrideWarning">
        <div class="alert alert-warning">
          <p>
            <i class="fa fa-exclamation-triangle"></i>
            {{newAppModal.data.showOverrideWarning}}
          </p>
          <p class="text-right">
            <a
              class="btn btn-sm btn-default dirty-flag-dismiss"
              href
              ng-click="newAppModal.data.showOverrideWarning = null"
              >Okay</a
            >
          </p>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">
          Instance Port
          <help-field key="application.instance.port"></help-field>
        </div>
        <div class="col-sm-2">
          <input
            type="number"
            min="0"
            max="65536"
            class="form-control input-sm"
            ng-model="newAppModal.application.instancePort"
            name="instancePort"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Pipeline Behavior</div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input type="checkbox" ng-model="editApp.applicationAttributes.enableRestartRunningExecutions" />
            Enable restarting running pipelines
          </label>
          <help-field key="application.enableRestartRunningExecutions"></help-field>
          <label>
            <input type="checkbox" ng-model="editApp.applicationAttributes.enableRerunActiveExecutions" />
            Enable re-run button on active pipelines
          </label>
          <help-field key="application.enableRerunActiveExecutions"></help-field>
        </div>
      </div>

      <render-if-feature feature="fiatEnabled">
        <div class="form-group row">
          <div class="col-sm-3 sm-label-right">Permissions <help-field key="application.permissions"></help-field></div>
          <div class="col-sm-9">
            <permissions-configurer
              permissions="newAppModal.application.permissions"
              on-permissions-change="newAppModal.handlePermissionsChange"
              required-group-membership="newAppModal.application.requiredGroupMembership"
            >
            </permissions-configurer>
          </div>
        </div>
      </render-if-feature>

      <div class="form-group row slide-in" ng-if="newAppModal.state.errorMessages.length">
        <div class="col-md-12">
          <div class="alert alert-danger">
            <div ng-repeat="errorMessage in newAppModal.state.errorMessages">
              <status-glyph item="{isFailed: true}"></status-glyph> {{errorMessage}}
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <em>* Required</em>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <submit-button
        is-new="true"
        is-disabled="newApplicationForm.$invalid || newAppModal.state.submitting || newAppModal.data.showOverrideWarning || newAppModal.state.permissionsInvalid"
        submitting="newAppModal.state.submitting"
        on-click="newAppModal.submit()"
      ></submit-button>
    </div>
  </form>
</div>
`);
}]);

const APPLICATIONS_STATE_PROVIDER = "spinnaker.core.application.applications.state";
module(APPLICATIONS_STATE_PROVIDER, [STATE_CONFIG_PROVIDER, APPLICATION_STATE_PROVIDER]).config([
  "stateConfigProvider",
  "applicationStateProvider",
  (stateConfigProvider, applicationStateProvider) => {
    const applicationsState = {
      name: "applications",
      url: "/applications?create",
      views: {
        "main@": {
          component: Applications,
          $type: "react"
        }
      },
      data: {
        pageTitleMain: {
          label: "Applications"
        }
      },
      children: []
    };
    applicationStateProvider.addParentState(applicationsState, "main@");
    stateConfigProvider.addToRootState(applicationsState);
  }
]);

var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __decorateClass$d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$d(target, key, result);
  return result;
};
let ApplicationConfig = class extends React__default.Component {
  render() {
    const templateUrl = "core/src/application/config/applicationConfig.view.html";
    return /* @__PURE__ */ React__default.createElement(AngularJSAdapter, {
      ...this.props,
      templateUrl,
      controller: "ApplicationConfigController",
      controllerAs: "config"
    });
  }
};
ApplicationConfig = __decorateClass$d([
  Overridable("applicationConfigView")
], ApplicationConfig);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/applicationConfig.view.html", `<div style="overflow-y: auto" sticky-headers>
  <page-navigator
    scrollable-container="[sticky-headers]"
    deep-link-param="section"
    ng-if="(!config.application.attributes || !config.application.attributes.email)"
  >
    <page-section key="location" label="Application Attributes">
      <application-attributes application="config.application"></application-attributes>
    </page-section>
  </page-navigator>
  <page-navigator
    scrollable-container="[sticky-headers]"
    deep-link-param="section"
    ng-if="(config.application.attributes && config.application.attributes.email)"
  >
    <page-section key="location" label="Application Attributes">
      <application-attributes application="config.application"></application-attributes>
    </page-section>
    <page-section
      key="managed-resources"
      label="Managed Resources"
      visible="(config.feature.managedResources && config.hasManagedResources) || false"
    >
      <managed-resource-config application="config.application"> </managed-resource-config>
    </page-section>
    <page-section key="notifications" label="Notifications">
      <application-notifications
        application="config.application"
        notifications="config.notifications"
        update-notifications="config.updateNotifications"
      ></application-notifications>
    </page-section>
    <page-section key="features" label="Features">
      <application-data-source-editor application="config.application"></application-data-source-editor>
    </page-section>
    <page-section key="links" label="Links" no-wrapper="true">
      <application-links application="config.application"></application-links>
    </page-section>
    <page-section key="chaos" label="Chaos Monkey" visible="config.feature.chaosMonkey">
      <chaos-monkey-config application="config.application"></chaos-monkey-config>
    </page-section>
    <page-section key="traffic-guards" label="Traffic Guards">
      <traffic-guard-config application="config.application"></traffic-guard-config>
    </page-section>
    <page-section key="snapshot" label="Serialize Application" visible="config.feature.snapshots">
      <application-snapshot-section application="config.application"></application-snapshot-section>
    </page-section>
    <page-section key="banner" label="Custom Banners">
      <custom-banner-config
        banner-configs="config.application.attributes.customBanners"
        is-saving="config.bannerConfigProps.isSaving"
        save-error="config.bannerConfigProps.saveError"
        update-banner-configs="config.updateBannerConfigs"
      >
      </custom-banner-config>
    </page-section>
    <page-section key="default-filters" label="Default Filters">
      <default-tag-filter-config
        default-tag-filter-configs="config.application.attributes.defaultFilteredTags"
        is-saving="config.defaultTagFilterProps.isSaving"
        save-error="config.defaultTagFilterProps.saveError"
        update-default-tag-filter-configs="config.updateDefaultTagFilterConfigs"
      >
      </default-tag-filter-config>
    </page-section>
    <page-section key="delete" label="Delete Application">
      <delete-application-section application="config.application"></delete-application-section>
    </page-section>
  </page-navigator>
</div>
`);
}]);

const APP_CONFIG_STATES = "spinnaker.core.application.states";
module(APP_CONFIG_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  (applicationStateProvider) => {
    const configState = {
      name: "config",
      url: "/config?section",
      views: {
        insight: {
          component: ApplicationConfig,
          $type: "react"
        }
      },
      params: {
        section: {
          dynamic: true
        }
      },
      data: {
        pageTitleSection: {
          title: "Config"
        }
      }
    };
    applicationStateProvider.addChildState(configState);
  }
]);

const CORE_APPLICATION_CONFIG_APPCONFIG_DATASOURCE = "spinnaker.core.application.config.dataSource";
module(CORE_APPLICATION_CONFIG_APPCONFIG_DATASOURCE, [APP_CONFIG_STATES]).run(function() {
  ApplicationDataSourceRegistry.registerDataSource({
    key: "config",
    label: "Config",
    sref: ".config",
    active: "**.config.**",
    defaultData: [],
    iconName: "spMenuConfig"
  });
});

const CORE_APPLICATION_MODAL_APPLICATIONPROVIDERFIELDS_COMPONENT = "spinnaker.core.application.modal.applicationProviderFields.directive";
module(CORE_APPLICATION_MODAL_APPLICATIONPROVIDERFIELDS_COMPONENT, []).component("applicationProviderFields", {
  templateUrl: "core/src/application/modal/applicationProviderFields.component.html",
  bindings: {
    application: "=",
    cloudProviders: "="
  },
  controller: "ApplicationProviderFieldsCtrl"
}).controller("ApplicationProviderFieldsCtrl", function() {
  const templateUrlPath = "applicationProviderFields.templateUrl";
  const defaultProviderFields = SETTINGS.providers;
  this.initializeApplicationField = (fieldPath) => {
    const applicationFieldPath = "providerSettings." + fieldPath;
    if (___default.has(defaultProviderFields, fieldPath) && !___default.has(this.application, applicationFieldPath)) {
      ___default.set(this.application, applicationFieldPath, ___default.get(defaultProviderFields, fieldPath));
    }
  };
  this.getRelevantProviderFieldsTemplates = () => {
    let candidateProvidersToShow;
    const appCloudProviders = this.application.cloudProviders;
    if (appCloudProviders.length === 0) {
      candidateProvidersToShow = this.cloudProviders;
    } else {
      candidateProvidersToShow = ___default.isString(appCloudProviders) ? appCloudProviders.split(",") : appCloudProviders;
    }
    return (candidateProvidersToShow || []).filter((provider) => CloudProviderRegistry.hasValue(provider, templateUrlPath)).map((provider) => CloudProviderRegistry.getValue(provider, templateUrlPath));
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/modal/applicationProviderFields.component.html", `<ng-include src="template" ng-repeat="template in $ctrl.getRelevantProviderFieldsTemplates()"> </ng-include>
`);
}]);

const CORE_APPLICATION_MODAL_EDITAPPLICATION_CONTROLLER_MODAL = "spinnaker.editApplication.modal.controller";
angular.module(CORE_APPLICATION_MODAL_EDITAPPLICATION_CONTROLLER_MODAL, [
  CORE_APPLICATION_MODAL_APPLICATIONPROVIDERFIELDS_COMPONENT
]).controller("EditApplicationController", [
  "$scope",
  "$window",
  "$state",
  "$uibModalInstance",
  "application",
  function($scope, $window, $state, $uibModalInstance, application) {
    const vm = this;
    this.data = {
      gitSources: SETTINGS.gitSources || ["stash", "github", "bitbucket", "gitlab"]
    };
    this.state = {
      submitting: false,
      permissionsInvalid: false
    };
    vm.errorMsgs = [];
    vm.application = application;
    vm.isNew = !application.attributes || !application.attributes.email;
    vm.applicationAttributes = ___default.cloneDeep(application.attributes);
    AccountService.listProviders().then((providers) => vm.data.cloudProviders = providers);
    function closeModal() {
      $uibModalInstance.close(vm.applicationAttributes);
    }
    function extractErrorMsg(error) {
      const exceptions = ___default.chain(error.variables).filter({ key: "exception" }).head().value().value.details.errors;
      angular.copy(exceptions, vm.errorMsgs);
      assignErrorMsgs();
      goIdle();
    }
    function assignErrorMsgs() {
      vm.emailErrorMsg = vm.errorMsgs.filter(function(msg) {
        return msg.toLowerCase().includes("email");
      });
    }
    function goIdle() {
      vm.state.submitting = false;
    }
    function submitting() {
      vm.state.submitting = true;
    }
    vm.updateCloudProviderHealthWarning = (platformHealthOnlyShowOverrideClicked) => {
      if (vm.applicationAttributes.platformHealthOnlyShowOverride && (platformHealthOnlyShowOverrideClicked || vm.applicationAttributes.platformHealthOnly)) {
        vm.data.showOverrideWarning = `Note that disabling this setting will not have an effect on any
          pipeline stages with the "Consider only 'platform' health?" option explicitly enabled. You will
          need to update each of those pipeline stages individually if desired.`;
      } else if (!vm.applicationAttributes.platformHealthOnlyShowOverride && platformHealthOnlyShowOverrideClicked) {
        vm.data.showOverrideWarning = `Simply enabling the "Consider only cloud provider health when executing tasks"
          option above is usually sufficient for most applications that want the same health provider behavior for
          all stages. Note that pipelines will require manual updating if this setting is disabled in the future.`;
      }
    };
    vm.clearEmailMsg = function() {
      vm.state.emailErrorMsg = "";
    };
    vm.setAttribute = function(name2, value) {
      vm.applicationAttributes[name2] = value;
    };
    vm.submit = function() {
      submitting();
      if (vm.applicationAttributes.aliases === "") {
        delete vm.applicationAttributes.aliases;
      }
      if (vm.applicationAttributes.aliases) {
        vm.applicationAttributes.aliases = vm.applicationAttributes.aliases.split(/\s*,\s*/).filter((s) => s !== "").join(",");
      }
      ApplicationWriter.updateApplication(vm.applicationAttributes).then((task) => TaskReader.waitUntilTaskCompletes(task).then(closeModal, extractErrorMsg), () => vm.errorMsgs.push("Could not update application"));
    };
    function permissionsAreValid(permissions) {
      if (permissions.READ.includes(null) || permissions.WRITE.includes(null)) {
        return false;
      }
      if (permissions.READ.length > 0 && permissions.WRITE.length === 0) {
        return false;
      }
      return true;
    }
    vm.handlePermissionsChange = (permissions) => {
      $scope.$evalAsync(() => {
        vm.state.permissionsInvalid = !permissionsAreValid(permissions);
        vm.applicationAttributes.permissions = permissions;
        delete vm.applicationAttributes.requiredGroupMembership;
      });
    };
    return vm;
  }
]);

const CORE_APPLICATION_CONFIG_APPLICATIONATTRIBUTES_DIRECTIVE = "spinnaker.core.application.config.attributes.directive";
module(CORE_APPLICATION_CONFIG_APPLICATIONATTRIBUTES_DIRECTIVE, [
  CORE_APPLICATION_MODAL_EDITAPPLICATION_CONTROLLER_MODAL,
  OVERRIDE_REGISTRY
]).directive("applicationAttributes", [
  "overrideRegistry",
  function(overrideRegistry) {
    return {
      restrict: "E",
      templateUrl: overrideRegistry.getTemplate("applicationAttributesDirective", "core/src/application/config/applicationAttributes.directive.html"),
      scope: {},
      bindToController: {
        application: "="
      },
      controller: "ApplicationAttributesCtrl",
      controllerAs: "vm"
    };
  }
]).controller("ApplicationAttributesCtrl", [
  "$uibModal",
  "overrideRegistry",
  function($uibModal, overrideRegistry) {
    const cpHealthMsg = "considers only cloud provider health when executing tasks";
    const healthOverrideMsg = "shows a health override option for each operation";
    const setHealthMessage = () => {
      const hasHealth = get(this.application, "attributes.platformHealthOnly", false);
      const hasOverride = get(this.application, "attributes.platformHealthOnlyShowOverride", false);
      this.healthMessage = "This application ";
      if (hasHealth) {
        this.healthMessage += cpHealthMsg;
        if (hasOverride) {
          this.healthMessage += `. and ${healthOverrideMsg}.`;
        } else {
          this.healthMessage += ".";
        }
      } else if (hasOverride) {
        this.healthMessage += `${healthOverrideMsg}.`;
      }
    };
    setHealthMessage();
    const setPermissions = () => {
      const permissions = get(this.application, "attributes.permissions");
      if (permissions) {
        const permissionsMap = new Map();
        (permissions.READ || []).forEach((role) => {
          permissionsMap.set(role, "read");
        });
        (permissions.EXECUTE || []).forEach((role) => {
          if (permissionsMap.has(role)) {
            permissionsMap.set(role, permissionsMap.get(role) + ", execute");
          } else {
            permissionsMap.set(role, "execute");
          }
        });
        (permissions.WRITE || []).forEach((role) => {
          if (permissionsMap.has(role)) {
            permissionsMap.set(role, permissionsMap.get(role) + ", write");
          } else {
            permissionsMap.set(role, "write");
          }
        });
        if (permissionsMap.size) {
          this.permissions = Array.from(permissionsMap).map(([role, accessTypes]) => `${role} (${accessTypes})`).join(", ");
        } else {
          this.permissions = null;
        }
      } else {
        this.permissions = null;
      }
    };
    setPermissions();
    this.editApplication = () => {
      $uibModal.open({
        templateUrl: overrideRegistry.getTemplate("editApplicationModal", "core/src/application/modal/editApplication.html"),
        controller: overrideRegistry.getController("EditApplicationController"),
        controllerAs: "editApp",
        resolve: {
          application: () => {
            return this.application;
          }
        }
      }).result.then((newAttributes) => {
        this.application.attributes = newAttributes;
        setHealthMessage();
        setPermissions();
      }).catch(() => {
      });
    };
    if (this.application && (!this.application.attributes || !this.application.attributes.email)) {
      this.editApplication();
    }
    this.slackBaseUrl = get(SETTINGS, "slack.baseUrl", "");
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/applicationAttributes.directive.html", `<dl class="dl-horizontal" ng-if="(vm.application.attributes && vm.application.attributes.email)">
  <dt>Owner</dt>
  <dd>{{vm.application.attributes.email}}</dd>
  <dt ng-if="vm.application.attributes.appGroup">App Group <help-field key="application.group"></help-field></dt>
  <dd ng-if="vm.application.attributes.appGroup">{{vm.application.attributes.appGroup}}</dd>
  <dt ng-if="vm.application.attributes.aliases">Alias(es)</dt>
  <dd ng-if="vm.application.attributes.aliases">{{vm.application.attributes.aliases}}</dd>
  <render-if-feature feature="pagerDuty">
    <dt ng-if="vm.application.attributes.pdApiKey">Pager Duty</dt>
    <dd ng-if="vm.application.attributes.pdApiKey">
      <pager-duty-tag api-key="vm.application.attributes.pdApiKey"></pager-duty-tag>
    </dd>
  </render-if-feature>
  <render-if-feature feature="slack">
    <dt ng-if="vm.application.attributes.slackChannel && vm.application.attributes.slackChannel.name">Slack Channel</dt>
    <dd ng-if="vm.application.attributes.slackChannel && vm.application.attributes.slackChannel.name">
      <a target="_blank" href="{{vm.slackBaseUrl}}/app_redirect?channel={{vm.application.attributes.slackChannel.id}}"
        >#{{vm.application.attributes.slackChannel.name}}</a
      >
    </dd>
  </render-if-feature>
  <dt ng-if="vm.application.attributes.repoType">Source Repo Type</dt>
  <dd ng-if="vm.application.attributes.repoType">{{vm.application.attributes.repoType}}</dd>
  <dt ng-if="vm.application.attributes.repoProjectKey">Source Repo Project</dt>
  <dd ng-if="vm.application.attributes.repoProjectKey">{{vm.application.attributes.repoProjectKey}}</dd>
  <dt ng-if="vm.application.attributes.repoSlug">Source Repo</dt>
  <dd ng-if="vm.application.attributes.repoSlug">{{vm.application.attributes.repoSlug}}</dd>
  <dt>Description</dt>
  <dd>{{vm.application.attributes.description}}</dd>
  <dt>Account(s)</dt>
  <dd>{{vm.application.attributes.accounts.join(', ')}}</dd>
  <dt ng-if="vm.application.attributes.cloudProviders.length">Cloud Provider(s)</dt>
  <dd ng-if="vm.application.attributes.cloudProviders.length">
    {{vm.application.attributes.cloudProviders.join(', ')}}
  </dd>
  <dt ng-if="vm.application.attributes.platformHealthOnly || vm.application.attributes.platformHealthOnlyShowOverride">
    Instance health
  </dt>
  <dd ng-if="vm.application.attributes.platformHealthOnly || vm.application.attributes.platformHealthOnlyShowOverride">
    {{vm.healthMessage}}
  </dd>
  <dt>Instance Port</dt>
  <dd>{{vm.application.attributes.instancePort}}</dd>
  <dt
    ng-if="vm.application.attributes.enableRestartRunningExecutions || vm.application.attributes.enableRerunActiveExecutions"
  >
    Pipeline Behavior
  </dt>
  <dd ng-if="vm.application.attributes.enableRestartRunningExecutions">Allows restarting running pipelines</dd>
  <dd ng-if="vm.application.attributes.enableRerunActiveExecutions">Allows re-running active executions</dd>
  <dt ng-if="vm.application.attributes.legacyUdf">User Data Format</dt>
  <dd ng-if="vm.application.attributes.legacyUdf">This application requires legacy user data format.</dd>
  <render-if-feature feature="fiatEnabled" ng-if="vm.permissions">
    <dt>Permissions</dt>
    <dd>{{vm.permissions}}</dd>
  </render-if-feature>
</dl>
<p ng-if="(!vm.application.attributes || !vm.application.attributes.email)">
  This application has not been configured.
</p>
<button class="btn btn-link" ng-click="vm.editApplication()">
  <span class="glyphicon glyphicon-cog"></span>
  {{ (!vm.application.attributes || !vm.application.attributes.email) ? "Create Application" : "Edit Application
  Attributes"}}
</button>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/modal/editApplication.html", `<div class="modal-page">
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">{{editApp.isNew ? "Create" : "Edit"}} Application</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="editApplicationForm">
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Name</div>
        <div class="col-sm-9">
          <p class="form-control-static">{{editApp.applicationAttributes.name}}</p>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Owner Email *</div>
        <div class="col-sm-9">
          <input
            type="email"
            name="email"
            ng-class="{'ng-invalid ng-dirty':editApp.emailErrorMsg.length > 0 }"
            class="form-control input-sm"
            data-purpose="application-email"
            ng-model="editApp.applicationAttributes.email"
            placeholder="Enter an email address"
            required
          />
        </div>
      </div>

      <div
        class="form-group row slide-in"
        ng-if="editApplicationForm.email.$dirty && editApplicationForm.email.$invalid"
      >
        <div class="col-sm-9 col-sm-offset-3 error-message">
          <span>Please enter a valid email address</span>
        </div>
      </div>

      <div class="form-group row slide-in" ng-if="editApp.emailErrorMsg">
        <div class="col-sm-9 col-sm-offset-3 error-message" ng-repeat="errorMsg in editApp.emailErrorMsg">
          {{errorMsg}}
          <small
            ><span
              class="glyphicon glyphicon-remove"
              ng-click="editApp.clearEmailMsg()"
              style="cursor: pointer; padding-left: 10px"
            ></span
          ></small>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-3 sm-label-right">Alias(es)</div>
        <div class="col-md-9">
          <input
            class="form-control input-sm"
            type="text"
            placeholder="List of aliases"
            ng-model="editApp.applicationAttributes.aliases"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Repo Type</div>
        <div class="col-sm-9">
          <select
            class="form-control input-sm"
            ng-options="repoType for repoType in editApp.data.gitSources"
            ng-model="editApp.applicationAttributes.repoType"
          >
            <option value="">Select Repo Type</option>
          </select>
        </div>
      </div>
      <div class="form-group row" ng-if="editApp.applicationAttributes.repoType">
        <div class="col-sm-3 sm-label-right">Repo Project</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="editApp.applicationAttributes.repoProjectKey"
            placeholder="Enter your source repository project name"
          />
        </div>
      </div>
      <div class="form-group row" ng-if="editApp.applicationAttributes.repoType">
        <div class="col-sm-3 sm-label-right">Repo Name</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="editApp.applicationAttributes.repoSlug"
            placeholder="Enter your source repository name (not the url)"
            pattern="^((?!://).)*$"
            name="repoSlug"
          />
        </div>
      </div>

      <div class="form-group row slide-in" ng-messages="editApplicationForm.repoSlug.$error">
        <div class="col-sm-9 col-sm-offset-3 error-message" ng-message="pattern">
          Enter your source repository name (not the URL).
        </div>
      </div>

      <render-if-feature feature="pagerDuty">
        <pager-duty-select-field component="editApp.applicationAttributes"></pager-duty-select-field>
      </render-if-feature>

      <render-if-feature feature="slack">
        <slack-channel-selector
          channel="editApp.applicationAttributes.slackChannel"
          callback="editApp.setAttribute"
        ></slack-channel-selector>
      </render-if-feature>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Description</div>
        <div class="col-sm-9">
          <textarea
            class="form-control input-sm"
            ng-model="editApp.applicationAttributes.description"
            placeholder="Enter a description"
            data-purpose="application-description"
          >
          </textarea>
        </div>
      </div>

      <div class="form-group row" ng-if="editApp.data.cloudProviders.length > 1">
        <div class="col-md-3 sm-label-right">Cloud Provider</div>
        <div class="col-md-9">
          <ui-select multiple ng-model="editApp.applicationAttributes.cloudProviders" class="form-control input-sm">
            <ui-select-match> {{$item}} </ui-select-match>
            <ui-select-choices repeat="provider in editApp.data.cloudProviders | filter: $select.search">
              {{provider}}
            </ui-select-choices>
          </ui-select>
        </div>
      </div>

      <application-provider-fields
        cloud-providers="editApp.data.cloudProviders"
        application="editApp.applicationAttributes"
      >
      </application-provider-fields>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Instance Health</div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input
              type="checkbox"
              ng-model="editApp.applicationAttributes.platformHealthOnly"
              ng-click="editApp.updateCloudProviderHealthWarning(false)"
            />
            Consider only cloud provider health when executing tasks
            <help-field key="application.platformHealthOnly"></help-field>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-9 col-sm-offset-3 sm-control-field checkbox">
          <label>
            <input
              type="checkbox"
              ng-model="editApp.applicationAttributes.platformHealthOnlyShowOverride"
              ng-click="editApp.updateCloudProviderHealthWarning(true)"
            />
            Show health override option for each operation
            <help-field key="application.showPlatformHealthOverride"></help-field>
          </label>
        </div>
      </div>

      <div class="col-md-12" ng-if="editApp.data.showOverrideWarning">
        <div class="alert alert-warning">
          <p>
            <i class="fa fa-exclamation-triangle"></i>
            {{editApp.data.showOverrideWarning}}
          </p>
          <p class="text-right">
            <a class="btn btn-sm btn-default dirty-flag-dismiss" href ng-click="editApp.data.showOverrideWarning = null"
              >Okay</a
            >
          </p>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">
          Instance Port
          <help-field key="application.instance.port"></help-field>
        </div>
        <div class="col-sm-2">
          <input
            type="number"
            min="0"
            max="65536"
            class="form-control input-sm"
            ng-model="editApp.applicationAttributes.instancePort"
            name="instancePort"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Pipeline Behavior</div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input type="checkbox" ng-model="editApp.applicationAttributes.enableRestartRunningExecutions" />
            Enable restarting running pipelines
          </label>
          <help-field key="application.enableRestartRunningExecutions"></help-field>
          <label>
            <input type="checkbox" ng-model="editApp.applicationAttributes.enableRerunActiveExecutions" />
            Enable re-run button on active pipelines
          </label>
          <help-field key="application.enableRerunActiveExecutions"></help-field>
        </div>
      </div>

      <render-if-feature feature="fiatEnabled">
        <div class="form-group row">
          <div class="col-sm-3 sm-label-right">Permissions <help-field key="application.permissions"></help-field></div>
          <div class="col-sm-9">
            <permissions-configurer
              permissions="editApp.applicationAttributes.permissions"
              on-permissions-change="editApp.handlePermissionsChange"
              required-group-membership="editApp.applicationAttributes.requiredGroupMembership"
            >
            </permissions-configurer>
          </div>
        </div>
      </render-if-feature>

      <div class="form-group row slide-in" ng-if="editApp.errorMsgs">
        <div class="col-sm-9 col-sm-offset-3 error-message" ng-repeat="errorMsg in editApp.errorMsgs">{{errorMsg}}</div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <em>* Required</em>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <submit-button
        is-new="editApp.isNew"
        is-disabled="!editApplicationForm.$valid || editApp.state.submitting || editApp.data.showOverrideWarning || editApp.state.permissionsInvalid"
        submitting="editApp.state.submitting"
        on-click="editApp.submit()"
      ></submit-button>
    </div>
  </form>
</div>
`);
}]);

const CORE_APPLICATION_CONFIG_APPLICATIONNOTIFICATIONS_DIRECTIVE = "spinnaker.core.application.config.notifications.directive";
angular.module(CORE_APPLICATION_CONFIG_APPLICATIONNOTIFICATIONS_DIRECTIVE, [OVERRIDE_REGISTRY]).directive("applicationNotifications", [
  "overrideRegistry",
  function(overrideRegistry) {
    return {
      restrict: "E",
      templateUrl: overrideRegistry.getTemplate("applicationNotificationsDirective", "core/src/application/config/applicationNotifications.directive.html"),
      scope: {},
      bindToController: {
        application: "=",
        notifications: "=",
        updateNotifications: "="
      },
      controllerAs: "vm",
      controller: angular.noop
    };
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/applicationNotifications.directive.html", `<p>You can edit notification settings for this application</p>
<notification-list
  application="vm.application"
  notifications="vm.notifications"
  level="'application'"
  update-notifications="vm.updateNotifications"
></notification-list>
`);
}]);

class SnapshotWriter {
  static buildSaveSnapshotJobs(app, accountDetails) {
    const jobs = [];
    accountDetails.forEach((accountDetail) => {
      if (CloudProviderRegistry.getValue(accountDetail.cloudProvider, "snapshotsEnabled")) {
        jobs.push({
          type: "saveSnapshot",
          credentials: accountDetail.name,
          applicationName: app.name,
          cloudProvider: accountDetail.cloudProvider
        });
      }
    });
    return jobs;
  }
  static buildRestoreSnapshotJob(app, accountDetail, timestamp) {
    const jobs = [];
    if (CloudProviderRegistry.getValue(accountDetail.cloudProvider, "snapshotsEnabled")) {
      jobs.push({
        type: "restoreSnapshot",
        credentials: accountDetail.name,
        applicationName: app.name,
        snapshotTimestamp: timestamp,
        cloudProvider: accountDetail.cloudProvider
      });
    }
    return jobs;
  }
  static loadAccountDetails(app) {
    const accounts = isString(app.accounts) ? app.accounts.split(",") : [];
    const accountDetailPromises = accounts.map((account) => AccountService.getAccountDetails(account));
    return $q.all(accountDetailPromises);
  }
  static takeSnapshot(app) {
    return this.loadAccountDetails(app).then((accountDetails) => {
      const jobs = this.buildSaveSnapshotJobs(app, accountDetails);
      return TaskExecutor.executeTask({
        job: jobs,
        application: app,
        description: "Take Snapshot of " + app.name
      });
    });
  }
  static restoreSnapshot(app, account, timestamp) {
    return AccountService.getAccountDetails(account).then((accountDetail) => {
      const jobs = this.buildRestoreSnapshotJob(app, accountDetail, timestamp);
      return TaskExecutor.executeTask({
        job: jobs,
        application: app,
        description: `Restore Snapshot ${timestamp} of application: ${app.name} for account: ${accountDetail.name}`
      });
    });
  }
}

class SnapshotReader {
  static getSnapshotHistory(application, account, params = {}) {
    return REST("/applications").path(application, "snapshots", account, "history").query(params).get();
  }
}

function DiffSummary(props) {
  const { summary } = props;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "diff-summary"
  }, summary.additions > 0 && /* @__PURE__ */ React__default.createElement("span", {
    className: "footer-additions"
  }, "+ ", summary.additions), summary.removals > 0 && /* @__PURE__ */ React__default.createElement("span", {
    className: "footer-removals"
  }, "- ", summary.removals));
}

const DIFF_SUMMARY_COMPONENT = "spinnaker.core.pipeline.config.diffSummary.component";
module(DIFF_SUMMARY_COMPONENT, []).component("diffSummary", react2angular(withErrorBoundary(DiffSummary, "diffSummary"), ["summary"]));

const DIFF_VIEW_COMPONENT = "spinnaker.core.pipeline.config.diffView.component";
module(DIFF_VIEW_COMPONENT, []).component("diffView", react2angular(withErrorBoundary(DiffView, "diffView"), ["diff"]));

var css_248z$_ = ".snapshot-history [for='compare-account'] {\n  margin-left: 5px;\n}\n";
styleInject(css_248z$_);

const CORE_SNAPSHOT_DIFF_SNAPSHOTDIFF_MODAL_CONTROLLER = "spinnaker.deck.core.snapshot.diff.modal.controller";
module(CORE_SNAPSHOT_DIFF_SNAPSHOTDIFF_MODAL_CONTROLLER, [DIFF_SUMMARY_COMPONENT, DIFF_VIEW_COMPONENT]).controller("SnapshotDiffModalCtrl", [
  "availableAccounts",
  "application",
  "$filter",
  "$uibModalInstance",
  function(availableAccounts, application, $filter, $uibModalInstance) {
    this.availableAccounts = availableAccounts;
    this.selectedAccount = ___default.head(availableAccounts);
    this.compareOptions = ["most recent", "previous version"];
    this.compareTo = ___default.last(this.compareOptions);
    this.findLeftMap = {
      "most recent": () => ___default.head(this.snapshots).contents,
      "previous version": (right, version) => {
        let left = right;
        if (version < this.snapshots.length - 1) {
          left = this.snapshots[version + 1].contents;
        }
        return left;
      }
    };
    const resetView = () => {
      this.state = {
        loading: true,
        error: false
      };
      this.diff = JsonUtils.diff([], []);
      this.snapshots = [];
      this.version = 0;
    };
    const formatSnapshots = (snapshots) => {
      const formatted = snapshots.sort((a, b) => b.timestamp - a.timestamp).map((s, index) => {
        return {
          formattedTimestamp: $filter("timestamp")(s.timestamp),
          timestamp: s.timestamp,
          contents: JSON.stringify(s.infrastructure, null, 2),
          json: s.infrastructure,
          index
        };
      });
      ___default.head(formatted).formattedTimestamp += " (most recent)";
      return formatted;
    };
    const loadSuccess = (snapshots) => {
      this.state.loading = false;
      if (!snapshots.length) {
        return;
      }
      this.snapshots = formatSnapshots(snapshots);
      this.updateDiff();
    };
    const loadError = () => {
      this.state.loading = false;
      this.state.error = true;
    };
    this.getSnapshotHistoryForAccount = (account) => {
      resetView();
      if (account) {
        SnapshotReader.getSnapshotHistory(application.name, account).then(loadSuccess, loadError);
      } else {
        loadSuccess([]);
      }
    };
    this.restoreSnapshot = () => {
      const submitMethod = () => {
        return SnapshotWriter.restoreSnapshot(application, this.selectedAccount, this.snapshots[this.version].timestamp);
      };
      const taskMonitor = {
        application,
        title: "Restoring snapshot of " + application.name
      };
      ConfirmationModalService.confirm({
        header: `Are you sure you want to restore snapshot of: ${application.name}?`,
        buttonText: "Restore snapshot",
        body: "<p>This will change your infrastructure to the state specified in the snapshot selected</p>",
        taskMonitorConfig: taskMonitor,
        submitMethod
      });
    };
    this.updateDiff = () => {
      if (!this.snapshots.length) {
        resetView();
        return;
      }
      this.right = this.snapshots[this.version].contents;
      this.left = this.findLeftMap[this.compareTo](this.right, this.version);
      this.diff = JsonUtils.diff(this.left, this.right);
    };
    this.getSnapshotHistoryForAccount(this.selectedAccount);
    this.close = $uibModalInstance.dismiss;
  }
]);

const CORE_SNAPSHOT_DIFF_VIEWSNAPSHOTDIFFBUTTON_COMPONENT = "spinnaker.deck.core.viewSnapshotDiff.component";
module(CORE_SNAPSHOT_DIFF_VIEWSNAPSHOTDIFFBUTTON_COMPONENT, [
  CORE_SNAPSHOT_DIFF_SNAPSHOTDIFF_MODAL_CONTROLLER
]).component("viewSnapshotDiffButton", {
  bindings: {
    application: "="
  },
  template: `<button class="btn btn-link" ng-click="$ctrl.viewSnapshotDiffs()">
                  <span class="glyphicon glyphicon-cloud"></span> View Snapshot History
               </button>`,
  controller: [
    "$q",
    "$uibModal",
    function($q, $uibModal) {
      function getSnapshotEnabledAccounts(application) {
        return AccountService.listProviders(application).then((providers) => providers.filter((provider) => CloudProviderRegistry.getValue(provider, "snapshotsEnabled"))).then((snapshotEnabledProviders) => $q.all(snapshotEnabledProviders.map((provider) => AccountService.listAccounts(provider)))).then((accounts) => ___default.chain(accounts).flatten().map("name").value());
      }
      this.viewSnapshotDiffs = () => {
        $uibModal.open({
          templateUrl: "core/src/snapshot/diff/snapshotDiff.modal.html",
          controller: "SnapshotDiffModalCtrl",
          controllerAs: "ctrl",
          size: "lg modal-fullscreen",
          resolve: {
            availableAccounts: () => getSnapshotEnabledAccounts(this.application),
            application: () => this.application
          }
        });
      };
    }
  ]
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/snapshot/diff/snapshotDiff.modal.html", `<div modal-page class="flex-fill modal-show-history snapshot-history">
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Application Snapshot History</h4>
  </div>
  <div class="modal-body" ng-if="ctrl.state.loading">
    <div class="horizontal center">
      <loading-spinner size="'small'"></loading-spinner>
    </div>
  </div>
  <div class="modal-body flex-fill" ng-if="!ctrl.state.loading">
    <div class="form-inline modal-history-header">
      <label for="compare-base">Timestamp</label>
      <select
        id="compare-base"
        ng-options="snapshot.index as snapshot.formattedTimestamp for snapshot in ctrl.snapshots"
        ng-model="ctrl.version"
        ng-change="ctrl.updateDiff()"
        class="form-control input-sm"
      ></select>
      <label for="compare-account">Account</label>
      <select
        id="compare-account"
        ng-options="account for account in ctrl.availableAccounts"
        ng-model="ctrl.selectedAccount"
        ng-change="ctrl.getSnapshotHistoryForAccount(ctrl.selectedAccount)"
        class="form-control input-sm"
      ></select>
      <diff-summary summary="ctrl.diff.summary"></diff-summary>
      <div class="pull-right">
        <label for="compare-compare" class="middle">compare to </label>
        <select
          class="form-control input-sm"
          id="compare-compare"
          ng-options="entry for entry in ctrl.compareOptions"
          ng-change="ctrl.updateDiff()"
          ng-model="ctrl.compareTo"
        ></select>
      </div>
    </div>
    <div ng-if="ctrl.state.error">
      <h4 class="text-center">There was an error loading the snapshot history for this application.</h4>
    </div>
    <form role="form" class="form-horizontal flex-fill" ng-if="ctrl.snapshots.length > 1">
      <div class="form-group flex-fill">
        <h3 class="text-center" ng-if="ctrl.state.loading">loading...</h3>
        <diff-view diff="ctrl.diff" ng-if="ctrl.snapshots" class="flex-fill"></diff-view>
      </div>
    </form>
  </div>
  <div class="modal-body" ng-if="ctrl.snapshots.length <= 1 && !ctrl.state.loading && !ctrl.state.error">
    <h4 class="text-center">Sorry, we couldn't find any snapshot history for this application.</h4>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" ng-click="ctrl.restoreSnapshot()">Restore Snapshot</button>
    <button class="btn btn-primary" ng-click="ctrl.close()">Close</button>
  </div>
</div>
`);
}]);

const CORE_APPLICATION_CONFIG_APPLICATIONSNAPSHOTSECTION_COMPONENT = "spinnaker.core.application.config.serialize.component";
module(CORE_APPLICATION_CONFIG_APPLICATIONSNAPSHOTSECTION_COMPONENT, [
  UIROUTER_ANGULARJS,
  CORE_SNAPSHOT_DIFF_VIEWSNAPSHOTDIFFBUTTON_COMPONENT
]).component("applicationSnapshotSection", {
  templateUrl: "core/src/application/config/applicationSnapshotSection.component.html",
  bindings: {
    application: "="
  },
  controller: [
    "$state",
    function($state) {
      if (this.application.notFound || this.application.hasError) {
        return;
      }
      this.takeSnapshot = () => {
        const submitMethod = () => {
          return SnapshotWriter.takeSnapshot(this.application.attributes);
        };
        const taskMonitor = {
          application: this.application,
          title: "Taking snapshot of " + this.application.name
        };
        ConfirmationModalService.confirm({
          header: "Are you sure you want to take a snapshot of: " + this.application.name + "?",
          buttonText: "Take snapshot",
          taskMonitorConfig: taskMonitor,
          submitMethod
        });
      };
    }
  ]
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/applicationSnapshotSection.component.html", `<p>
  Taking an application snapshot will save the current state of the infrastructure to a storage bucket <br />
  using <a href="https://www.terraform.io/docs/configuration/index.html">Terraform's config language</a>. Currently only
  GCE infrastructure and GCS or S3 storage are supported.
</p>

<button class="btn btn-link" ng-click="$ctrl.takeSnapshot()">
  <span class="glyphicon glyphicon-cloud-download"></span> Take application snapshot
</button>

<view-snapshot-diff-button application="$ctrl.application"></view-snapshot-diff-button>
`);
}]);

const helpContents$3 = [
  {
    key: "application.chaos.enabled",
    contents: "<p>Chaos Monkey periodically terminates instances in your server groups to ensure resiliency.</p><p>If you do <b>not</b> want your application to participate in Chaos Monkey, unselect this option.</p>"
  },
  {
    key: "chaos.meanTime",
    contents: "<p>The average number of days between terminations for each group</p>"
  },
  {
    key: "chaos.minTime",
    contents: "<p>The minimum number of days Chaos Monkey will leave the groups alone</p>"
  },
  {
    key: "chaos.grouping",
    contents: "<p>Tells Chaos Monkey how to decide which instances to terminate:</p><ul><li><b>App:</b> Only terminate one instance in the entire application, across stacks and clusters</li><li><b>Stack:</b> Only terminate one instance in each stack</li><li><b>Cluster:</b> Terminate an instance in every cluster</li></ul>"
  },
  {
    key: "chaos.regions",
    contents: "<p>If selected, Chaos Monkey will treat each region in each group separately, e.g. if your cluster is deployed in three regions, an instance in each region would be terminated.</p>"
  },
  {
    key: "chaos.exceptions",
    contents: "<p>When Chaos Monkey is enabled, exceptions tell Chaos Monkey to leave certain clusters alone. You can use wildcards (*) to include all matching fields.</p>"
  },
  {
    key: "chaos.documentation",
    contents: `<p>Chaos Monkey documentation can be found
                     <a target="_blank" href="https://github.com/Netflix/chaosmonkey/blob/master/README.md">
                       here
                     </a>.
                   </p>`
  }
];
helpContents$3.forEach((entry) => HelpContentsRegistry.register(entry.key, entry.contents));

var css_248z$Z = "chaos-monkey-exceptions th {\n  font-weight: 600;\n}\n";
styleInject(css_248z$Z);

class ChaosMonkeyExceptionsController {
  constructor() {
    this.accounts = [];
    this.clusterMatches = [];
  }
  addException() {
    this.config.exceptions = this.config.exceptions || [];
    this.config.exceptions.push({ account: null, location: null, stack: null, detail: null, region: null });
    this.updateConfig();
  }
  removeException(index) {
    this.config.exceptions.splice(index, 1);
    this.updateConfig();
  }
  $onInit() {
    AccountService.getCredentialsKeyedByAccount().then((aggregated) => {
      this.accounts = Object.keys(aggregated).map((name) => aggregated[name]).filter((details) => details.regions);
      this.regionsByAccount = {};
      this.accounts.forEach((details) => {
        this.regionsByAccount[details.name] = ["*"].concat(details.regions.map((region) => region.name));
      });
      this.application.getDataSource("serverGroups").ready().then(() => this.configureMatches());
    });
  }
  configureMatches() {
    this.clusterMatches.length = 0;
    this.config.exceptions.forEach((exception) => {
      const { region: location, ...clusterMatchRule } = exception;
      const rule = { ...clusterMatchRule, location };
      this.clusterMatches.push(this.application.clusters.filter((c) => c.serverGroups.some((s) => ClusterMatcher.getMatchingRule(c.account, s.region, c.name, [rule]) !== null)).map((c) => {
        return {
          name: c.name,
          account: exception.account,
          regions: exception.region === "*" ? uniq(c.serverGroups.map((g) => g.region)).sort() : [exception.region]
        };
      }));
    });
    this.clusterMatches.forEach((m) => m.sort((a, b) => a.name.localeCompare(b.name)));
  }
  updateConfig() {
    this.configureMatches();
    this.configChanged();
  }
}
const chaosMonkeyExceptionsComponent = {
  bindings: {
    application: "=",
    config: "=",
    configChanged: "&"
  },
  controller: ChaosMonkeyExceptionsController,
  templateUrl: "core/src/chaosMonkey/chaosMonkeyExceptions.component.html"
};
const CHAOS_MONKEY_EXCEPTIONS_COMPONENT = "spinnaker.core.chaosMonkey.exceptions.directive";
module(CHAOS_MONKEY_EXCEPTIONS_COMPONENT, []).component("chaosMonkeyExceptions", chaosMonkeyExceptionsComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/chaosMonkey/chaosMonkeyExceptions.component.html", `<h5>Exceptions <help-field key="chaos.exceptions"></help-field></h5>
<div class="row">
  <div class="col-md-10 col-md-offset-1">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th style="min-width: 100px">Account</th>
          <th>Region</th>
          <th>Stack</th>
          <th>Detail</th>
          <th>Matched Clusters</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="exception in $ctrl.config.exceptions">
          <td>
            <account-select-field
              component="exception"
              field="account"
              provider="'aws'"
              accounts="$ctrl.accounts"
              on-change="$ctrl.updateConfig()"
            ></account-select-field>
          </td>
          <td>
            <span ng-if="!exception.account">(select account)</span>
            <select
              class="form-control input-sm"
              ng-model="exception.region"
              ng-change="$ctrl.updateConfig()"
              ng-if="exception.account"
            >
              <option ng-repeat="region in $ctrl.regionsByAccount[exception.account]" value="{{ region }}">
                {{ region }}
              </option>
            </select>
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              ng-model="exception.stack"
              ng-change="$ctrl.updateConfig()"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              ng-model="exception.detail"
              ng-change="$ctrl.updateConfig()"
            />
          </td>
          <td>
            <cluster-matches matches="$ctrl.clusterMatches[$index]"></cluster-matches>
          </td>
          <td>
            <a href ng-click="$ctrl.removeException($index)"
              ><span class="glyphicon glyphicon-trash" uib-tooltip="Remove exception"></span
            ></a>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-block btn-add-trigger add-new" ng-click="$ctrl.addException()">
      <span class="glyphicon glyphicon-plus-sign"></span> Add Exception
    </button>
  </div>
</div>
`);
}]);

var css_248z$Y = "chaos-monkey-config input[type='number'].form-control {\n  display: inline-block;\n  width: 55px;\n  margin: 0 5px 0 10px;\n}\nchaos-monkey-config .row {\n  margin-top: 10px;\n}\nchaos-monkey-config h5 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-top: 25px;\n  margin-bottom: 0;\n}\nchaos-monkey-config h5.help-label {\n  font-size: 14px;\n  margin-top: 10px;\n}\nchaos-monkey-config label {\n  font-weight: 600;\n}\nchaos-monkey-config .chaos-enabled {\n  margin-bottom: 20px;\n}\nchaos-monkey-config .chaos-enabled .checkbox-inline {\n  font-size: 110%;\n  font-weight: 600;\n}\nchaos-monkey-config .chaos-enabled .checkbox-inline input[type='checkbox'] {\n  bottom: 4px;\n}\nchaos-monkey-config .first-header {\n  margin-top: 0;\n}\n";
styleInject(css_248z$Y);

class ChaosMonkeyConfig {
  constructor(config) {
    this.enabled = false;
    this.meanTimeBetweenKillsInWorkDays = 2;
    this.minTimeBetweenKillsInWorkDays = 1;
    this.grouping = "cluster";
    this.regionsAreIndependent = true;
    this.exceptions = [];
    Object.assign(this, config);
  }
}
class ChaosMonkeyConfigController {
  constructor() {
    this.chaosEnabled = false;
    this.groupingOptions = [];
    this.viewState = {
      originalConfig: null,
      originalStringVal: null,
      saving: false,
      saveError: false,
      isDirty: false
    };
  }
  $onInit() {
    if (this.application.notFound || this.application.hasError) {
      return;
    }
    this.config = new ChaosMonkeyConfig(this.application.attributes.chaosMonkey || {});
    this.viewState.originalConfig = cloneDeep(this.config);
    this.viewState.originalStringVal = toJson(this.viewState.originalConfig);
    this.chaosEnabled = SETTINGS.feature.chaosMonkey;
    this.groupingOptions = [
      { key: "app", label: "App" },
      { key: "stack", label: "Stack" },
      { key: "cluster", label: "Cluster" }
    ];
  }
  configChanged() {
    this.viewState.isDirty = this.viewState.originalStringVal !== toJson(this.config);
  }
}
const chaosMonkeyConfigComponent = {
  bindings: {
    application: "="
  },
  controller: ChaosMonkeyConfigController,
  templateUrl: "core/src/chaosMonkey/chaosMonkeyConfig.component.html"
};
const CHAOS_MONKEY_CONFIG_COMPONENT = "spinnaker.core.chaosMonkey.config.component";
module(CHAOS_MONKEY_CONFIG_COMPONENT, [
  CLUSTER_MATCHES_COMPONENT,
  CHAOS_MONKEY_EXCEPTIONS_COMPONENT,
  CONFIG_SECTION_FOOTER
]).component("chaosMonkeyConfig", chaosMonkeyConfigComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/chaosMonkey/chaosMonkeyConfig.component.html", `<form name="form" class="form-inline" ng-if="$ctrl.chaosEnabled">
  <div class="chaos-enabled">
    <label class="checkbox-inline">
      <input type="checkbox" ng-model="$ctrl.config.enabled" ng-change="$ctrl.configChanged()" />
      Enabled
    </label>
  </div>
  <h5 class="first-header">Termination frequency</h5>
  <div class="row">
    <div class="col-md-5 col-md-offset-1">
      <label>Mean time between terms</label>
      <input
        type="number"
        class="form-control input-sm"
        min="1"
        ng-model="$ctrl.config.meanTimeBetweenKillsInWorkDays"
        ng-change="$ctrl.configChanged()"
      />
      days <help-field key="chaos.meanTime"></help-field>
    </div>
    <div class="col-md-6">
      <label>Min time between terms</label>
      <input
        type="number"
        class="form-control input-sm"
        min="1"
        ng-model="$ctrl.config.minTimeBetweenKillsInWorkDays"
        ng-change="$ctrl.configChanged()"
      />
      days <help-field key="chaos.minTime"></help-field>
    </div>
  </div>
  <div class="row">
    <div class="col-md-5 col-md-offset-1">
      <label class="control-label">Grouping <help-field key="chaos.grouping"></help-field></label>
      <label class="radio-inline" ng-repeat="grouping in $ctrl.groupingOptions">
        <input
          type="radio"
          ng-model="$ctrl.config.grouping"
          ng-change="$ctrl.configChanged()"
          ng-value="grouping.key"
        />
        {{ grouping.label }}
      </label>
    </div>
    <div class="col-md-6">
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-model="$ctrl.config.regionsAreIndependent" ng-change="$ctrl.configChanged()" />
          Regions are independent
          <help-field key="chaos.regions"></help-field>
        </label>
      </div>
    </div>
  </div>

  <chaos-monkey-exceptions
    application="$ctrl.application"
    config="$ctrl.config"
    config-changed="$ctrl.configChanged()"
  ></chaos-monkey-exceptions>
  <h5 style="margin-top: 0">Documentation</h5>
  <div class="row">
    <div class="col-md-12">
      <help-field key="chaos.documentation" expand="true"></help-field>
    </div>
  </div>

  <config-section-footer
    application="$ctrl.application"
    config="$ctrl.config"
    view-state="$ctrl.viewState"
    config-field="chaosMonkey"
    save-disabled="form.$invalid"
  ></config-section-footer>
</form>
`);
}]);

var css_248z$X = "application-data-source-editor div.checkbox {\n  margin-left: 20px;\n}\napplication-data-source-editor div.checkbox label {\n  font-weight: 600;\n}\napplication-data-source-editor p {\n  margin-left: 20px;\n}\n";
styleInject(css_248z$X);

class DataSourceEditorController {
  constructor() {
    this.model = {};
    this.explicitlyEnabled = [];
    this.explicitlyDisabled = [];
    this.isDirty = false;
    this.saving = false;
    this.saveError = false;
  }
  $onInit() {
    if (this.application.notFound || this.application.hasError) {
      return;
    }
    if (!this.application.attributes) {
      this.application.attributes = {};
    }
    if (!this.application.attributes.dataSources) {
      this.application.attributes.dataSources = { enabled: [], disabled: [] };
    }
    this.dataSources = this.application.dataSources.filter((ds) => ds.visible && ds.optional && !ds.hidden);
    this.explicitlyEnabled = this.application.attributes.dataSources.enabled;
    this.explicitlyDisabled = this.application.attributes.dataSources.disabled;
    this.dataSources.forEach((ds) => {
      this.model[ds.key] = !ds.disabled;
    });
    this.original = JSON.stringify(this.model);
  }
  dataSourceChanged(key) {
    if (this.model[key]) {
      if (!this.explicitlyEnabled.includes(key)) {
        this.explicitlyEnabled.push(key);
      }
      this.explicitlyDisabled = this.explicitlyDisabled.filter((s) => s !== key);
    } else {
      if (!this.explicitlyDisabled.includes(key)) {
        this.explicitlyDisabled.push(key);
      }
      this.explicitlyEnabled = this.explicitlyEnabled.filter((s) => s !== key);
    }
    this.isDirty = JSON.stringify(this.model) !== this.original;
  }
  revert() {
    this.$onInit();
  }
  save() {
    this.saving = true;
    this.saveError = false;
    const newDataSources = { enabled: this.explicitlyEnabled, disabled: this.explicitlyDisabled };
    ApplicationWriter.updateApplication({
      name: this.application.name,
      accounts: this.application.attributes.accounts,
      dataSources: newDataSources
    }).then((task) => {
      return TaskReader.waitUntilTaskCompletes(task);
    }).then(() => {
      this.application.attributes.dataSources = newDataSources;
      ApplicationReader.setDisabledDataSources(this.application);
      this.application.refresh(true);
      this.saving = false;
      this.isDirty = false;
      this.$onInit();
    }, () => {
      this.saving = false;
      this.saveError = true;
    });
  }
}
const applicationDataSourceEditorComponent = {
  bindings: {
    application: "="
  },
  controller: DataSourceEditorController,
  templateUrl: "core/src/application/config/dataSources/applicationDataSourceEditor.component.html"
};
const APPLICATION_DATA_SOURCE_EDITOR = "spinnaker.core.application.config.applicationDataSourceEditor";
module(APPLICATION_DATA_SOURCE_EDITOR, []).component("applicationDataSourceEditor", applicationDataSourceEditorComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/dataSources/applicationDataSourceEditor.component.html", `<p>If you don't need or want certain features for your application, you can disable them here.</p>
<p>Disabling a feature only changes the display in Spinnaker - it won't delete any actual data.</p>
<div ng-repeat="dataSource in $ctrl.dataSources" class="checkbox">
  <label
    ><input
      type="checkbox"
      ng-model="$ctrl.model[dataSource.key]"
      ng-change="$ctrl.dataSourceChanged(dataSource.key)"
    />
    {{ dataSource.label }}</label
  >
  <p ng-if="dataSource.description" ng-bind-html="dataSource.description"></p>
</div>
<div class="row footer">
  <div class="col-md-3">
    <button class="btn btn-default" ng-click="$ctrl.revert()" ng-if="$ctrl.isDirty" style="visibility: visible">
      <span class="glyphicon glyphicon-flash"></span> Revert
    </button>
  </div>
  <div class="col-md-9 text-right">
    <button class="btn btn-primary" ng-if="$ctrl.isDirty" ng-click="$ctrl.save()">
      <span ng-if="!$ctrl.saving"> <span class="far fa-check-circle"></span> Save Changes </span>
      <span ng-if="$ctrl.saving" class="pulsing"> <span class="fa fa-cog fa-spin"></span> Saving&hellip; </span>
    </button>
    <div class="error-message" ng-if="$ctrl.saveError">There was an error saving your changes. Please try again.</div>
    <span ng-if="!$ctrl.isDirty" class="btn btn-link disabled"
      ><span class="far fa-check-circle"></span> In sync with server</span
    >
  </div>
</div>
`);
}]);

var css_248z$W = ".default-filter-config-container {\n  display: flex;\n  flex-direction: column;\n}\n.default-filter-config-description {\n  margin-bottom: 10px;\n}\n";
styleInject(css_248z$W);

class DefaultTagFilterConfig extends React__default.Component {
  constructor(props) {
    super(props);
    this.onTagNameChange = (idx, text) => {
      this.setState({
        defaultTagFilterConfigsEditing: this.state.defaultTagFilterConfigsEditing.map((config, i) => {
          if (i === idx) {
            return {
              ...config,
              tagName: text
            };
          }
          return config;
        })
      });
    };
    this.onTagValueChange = (idx, text) => {
      this.setState({
        defaultTagFilterConfigsEditing: this.state.defaultTagFilterConfigsEditing.map((config, i) => {
          if (i === idx) {
            return {
              ...config,
              tagValue: text
            };
          }
          return config;
        })
      });
    };
    this.addFilterTag = () => {
      this.setState({
        defaultTagFilterConfigsEditing: this.state.defaultTagFilterConfigsEditing.concat([
          {
            tagName: "Name of the tag (E.g. Pipeline Type)",
            tagValue: "Value of the tag (E.g. Default Pipelines)"
          }
        ])
      });
    };
    this.removeFilterTag = (idx) => {
      this.setState({
        defaultTagFilterConfigsEditing: this.state.defaultTagFilterConfigsEditing.filter((_config, i) => i !== idx)
      });
    };
    this.isDirty = () => {
      return !isEqual(this.props.defaultTagFilterConfigs, this.state.defaultTagFilterConfigsEditing);
    };
    this.onRevertClicked = () => {
      this.setState({
        defaultTagFilterConfigsEditing: this.props.defaultTagFilterConfigs
      });
    };
    this.onSaveClicked = () => {
      this.props.updateDefaultTagFilterConfigs(this.state.defaultTagFilterConfigsEditing);
    };
    this.state = {
      defaultTagFilterConfigsEditing: props.defaultTagFilterConfigs
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "default-filter-config-container"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "default-filter-config-description"
    }, "Default Tag filters allow you to specify which tags are immediately filtered to when the pipeline execution page is loaded in."), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-10 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, "Tag Name"), /* @__PURE__ */ React__default.createElement("th", null, "Tag Value"))), /* @__PURE__ */ React__default.createElement("tbody", null, this.state.defaultTagFilterConfigsEditing.map((defaultTagFilter, idx) => /* @__PURE__ */ React__default.createElement("tr", {
      key: idx,
      className: "default-filter-config-row"
    }, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("textarea", {
      className: "form-control input-sm",
      onChange: (e) => this.onTagNameChange(idx, e.target.value),
      value: defaultTagFilter.tagName
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("textarea", {
      className: "form-control input-sm",
      onChange: (e) => this.onTagValueChange(idx, e.target.value),
      value: defaultTagFilter.tagValue
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
      className: "link default-filter-config-remove",
      onClick: () => this.removeFilterTag(idx)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    })))))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-10 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-block add-new",
      onClick: this.addFilterTag
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add Default Filter")), /* @__PURE__ */ React__default.createElement(ConfigSectionFooter, {
      isDirty: this.isDirty(),
      isValid: true,
      isSaving: this.props.isSaving,
      saveError: false,
      onRevertClicked: this.onRevertClicked,
      onSaveClicked: this.onSaveClicked
    }));
  }
}
DefaultTagFilterConfig.defaultProps = {
  defaultTagFilterConfigs: [],
  isSaving: false,
  saveError: false,
  updateDefaultTagFilterConfigs: noop
};

const DEFAULT_TAG_FILTER_CONFIG = "spinnaker.micros.application.defaultTagFilterConfig.component";
module(DEFAULT_TAG_FILTER_CONFIG, []).component("defaultTagFilterConfig", react2angular(withErrorBoundary(DefaultTagFilterConfig, "defaultTagFilterConfig"), [
  "defaultTagFilterConfigs",
  "isSaving",
  "saveError",
  "updateDefaultTagFilterConfigs"
]));

function DeleteApplicationSection(props) {
  const { application } = props;
  const deleteApplication = () => {
    const taskMonitor = {
      application,
      title: `Deleting ${application.name}`,
      onTaskComplete: () => {
        ReactInjector.$state.go("home.infrastructure");
      }
    };
    ConfirmationModalService.confirm({
      header: `Really delete ${application.name} ?`,
      buttonText: `Delete ${application.name}`,
      taskMonitorConfig: taskMonitor,
      submitMethod: () => ApplicationWriter.deleteApplication(application.attributes)
    });
  };
  if (application.notFound) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "Application not found."));
  } else if (application.hasError) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "Something went wrong loading ", /* @__PURE__ */ React__default.createElement("em", null, application.name), "."));
  } else {
    return Boolean(application.serverGroups.data.length) ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "You cannot delete this application because it has server groups.")) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "Deleting the application only removes the associated metadata around the application. It will", " ", /* @__PURE__ */ React__default.createElement("strong", null, "not"), " delete any ", /* @__PURE__ */ React__default.createElement(FirewallLabel, {
      label: "firewalls"
    }), ", load balancers, or pipeline configurations you may have created."), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-link clickable",
      onClick: deleteApplication
    }, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    }), " Delete Application")));
  }
}

const DELETE_APPLICATION_SECTION = "spinnaker.core.application.config.delete.directive";
module(DELETE_APPLICATION_SECTION, []).component("deleteApplicationSection", react2angular(withErrorBoundary(DeleteApplicationSection, "deleteApplicationSection"), ["application"]));

const CORE_APPLICATION_CONFIG_LINKS_EDITLINKS_MODAL_CONTROLLER = "spinnaker.core.application.config.links.editJson";
angular.module(CORE_APPLICATION_CONFIG_LINKS_EDITLINKS_MODAL_CONTROLLER, []).controller("EditLinksModalCtrl", [
  "sections",
  "$uibModalInstance",
  function(sections, $uibModalInstance) {
    this.cancel = $uibModalInstance.dismiss;
    this.initialize = () => {
      this.command = angular.toJson(sections, 2);
    };
    this.update = () => {
      try {
        $uibModalInstance.close(JSON.parse(this.command));
      } catch (e) {
        this.invalid = true;
        this.errorMessage = e.message;
      }
    };
    this.initialize();
  }
]);

var css_248z$V = "application-links .row-heading {\n  padding: 10px 0;\n}\napplication-links .row-heading .heading-label {\n  font-size: 16px;\n}\napplication-links .link-section {\n  margin: 10px 0;\n}\napplication-links .link-header {\n  color: var(--color-concrete);\n  font-size: 12px;\n}\napplication-links .sm-label-right {\n  padding-left: 0;\n}\napplication-links .link-title {\n  display: flex;\n  flex-direction: row;\n}\napplication-links .link-title input {\n  flex: 1;\n}\napplication-links .glyphicon-resize-vertical {\n  margin: 0 5px;\n  padding-top: 7px;\n  border-radius: 2px;\n}\napplication-links .ui-sortable-handle {\n  margin-left: -40px;\n}\napplication-links .ui-select-search {\n  position: absolute;\n}\napplication-links .ui-select-match-item {\n  background-color: var(--color-accent);\n  color: var(--color-text-on-dark);\n}\napplication-links .ui-select-match-close {\n  opacity: 1;\n  color: var(--color-text-on-dark);\n  text-shadow: inherit;\n  padding-left: 6px;\n  padding-top: 2px;\n}\n";
styleInject(css_248z$V);

const CORE_APPLICATION_CONFIG_LINKS_APPLICATIONLINKS_COMPONENT = "spinnaker.core.application.config.applicationLinks.component";
angular.module(CORE_APPLICATION_CONFIG_LINKS_APPLICATIONLINKS_COMPONENT, [
  CORE_APPLICATION_CONFIG_LINKS_EDITLINKS_MODAL_CONTROLLER,
  ANGULAR_UI_BOOTSTRAP,
  CONFIG_SECTION_FOOTER
]).component("applicationLinks", {
  bindings: {
    application: "="
  },
  templateUrl: "core/src/application/config/links/applicationLinks.component.html",
  controller: [
    "$uibModal",
    function($uibModal) {
      const initialize = () => {
        if (this.application.notFound || this.application.hasError) {
          return;
        }
        this.cloudProviders = this.application.attributes.cloudProviders ? this.application.attributes.cloudProviders : [];
        this.sections = ___default.cloneDeep(this.application.attributes.instanceLinks || SETTINGS.defaultInstanceLinks || []).filter((section) => !section.cloudProviders || section.cloudProviders.length === 0 || ___default.intersection(section.cloudProviders, this.cloudProviders).length > 0).map((section) => {
          if (!section.cloudProviders) {
            section.cloudProviders = [];
          }
          return section;
        });
        this.viewState = {
          originalSections: ___default.cloneDeep(this.sections),
          originalStringVal: JSON.stringify(this.sections),
          saving: false,
          saveError: false,
          isDirty: false
        };
        this.setDefaultLinkState();
      };
      this.setDefaultLinkState = () => {
        this.usingDefaultLinks = angular.toJson(this.sections) === angular.toJson(SETTINGS.defaultInstanceLinks);
        this.defaultLinksConfigured = !!SETTINGS.defaultInstanceLinks;
      };
      this.revert = initialize;
      this.useDefaultLinks = () => {
        this.sections = ___default.cloneDeep(SETTINGS.defaultInstanceLinks);
        this.configChanged();
      };
      this.addLink = (section) => {
        section.links.push({ title: "", path: "" });
        this.configChanged();
      };
      this.removeLink = (section, index) => {
        section.links.splice(index, 1);
        this.configChanged();
      };
      this.addSection = () => {
        const section = { title: "", links: [] };
        this.sections.push(section);
        this.addLink(section);
      };
      this.removeSection = (index) => {
        this.sections.splice(index, 1);
        this.configChanged();
      };
      this.configChanged = () => {
        this.setDefaultLinkState();
        this.viewState.isDirty = this.viewState.originalStringVal !== JSON.stringify(angular.copy(this.sections));
      };
      this.editJson = () => {
        $uibModal.open({
          templateUrl: "core/src/application/config/links/editLinks.modal.html",
          controller: "EditLinksModalCtrl as vm",
          size: "lg modal-fullscreen",
          resolve: {
            sections: () => this.sections
          }
        }).result.then((newSections) => {
          this.sections = newSections;
          this.configChanged();
        }).catch(() => {
        });
      };
      this.sortOptions = {
        axis: "y",
        delay: 150,
        stop: () => this.configChanged()
      };
      this.$onInit = initialize;
    }
  ]
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/links/applicationLinks.component.html", `<div class="row section-body">
  <div class="col-md-9">
    <p>
      Links appear in the instance details panel and provide a shortcut to common features, such as logs, health, etc.
    </p>
    <p>
      Links paths are templates - you can customize them using a number of field attributes available on the instance.
    </p>
    <p>
      <a href="https://www.spinnaker.io/guides/user/instance-links/#customizing-application-links" target="_blank">
        Check out the guide
      </a>
      for examples and to see what fields are available for your cloud provider.
    </p>
  </div>
  <div class="col-md-3 text-right">
    <button class="btn btn-sm btn-default" ng-click="$ctrl.editJson()">
      <span class="small glyphicon glyphicon-cog"></span> Edit as JSON
    </button>
  </div>
</div>
<div class="row" ng-if="!$ctrl.usingDefaultLinks && $ctrl.defaultLinksConfigured">
  <div class="col-md-9">
    This application's links have been customized.
    <a href ng-click="$ctrl.useDefaultLinks()">Revert to default links</a>
  </div>
</div>
<div ui-sortable="$ctrl.sortOptions" ng-model="$ctrl.sections">
  <div class="link-section section-body" ng-repeat="section in $ctrl.sections">
    <div class="row row-heading">
      <div class="col-md-1">
        <span ng-if="$ctrl.sections.length > 1" class="clickable glyphicon glyphicon-resize-vertical"></span>
      </div>
      <div class="col-md-2 sm-label-right heading-label">Section Heading</div>
      <div class="col-md-8" style="padding-right: 55px">
        <input type="text" class="form-control input" ng-model="section.title" ng-change="$ctrl.configChanged()" />
      </div>
      <div class="col-md-1" style="padding: 5px 10px">
        <a href ng-click="$ctrl.removeSection($index)" uib-tooltip="Remove section">
          <span class="glyphicon glyphicon-trash"></span>
        </a>
      </div>
    </div>

    <div class="row" ng-if="$ctrl.cloudProviders.length > 1">
      <div class="col-md-2 col-md-offset-1 sm-label-right">Cloud Provider(s)</div>
      <div class="col-md-8" style="padding-right: 55px">
        <ui-select
          class="form-control input"
          search-enabled="false"
          theme="bootstrap"
          ng-model="section.cloudProviders"
          on-select="$ctrl.configChanged()"
          on-remove="$ctrl.configChanged()"
          style="height: 30px; width: 100%"
          multiple
        >
          <ui-select-match placeholder="(All Cloud Providers)">{{ $item }}</ui-select-match>
          <ui-select-choices repeat="provider in $ctrl.cloudProviders">{{ provider }}</ui-select-choices>
        </ui-select>
      </div>
    </div>

    <div class="row" style="margin-top: 10px">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-9" style="margin-left: -22px">
          <div class="col-md-4 link-header"><span style="margin-left: 14px">Name</span></div>
          <div class="col-md-6 link-header">URL</div>
        </div>
      </div>
      <div class="col-md-3 sm-label-right">Links</div>
      <div class="col-md-9" ui-sortable="$ctrl.sortOptions" ng-model="section.links">
        <div class="row" ng-repeat="link in section.links" style="padding-bottom: 5px">
          <div class="col-md-4 link-title" style="padding-right: 0">
            <span ng-if="section.links.length > 1" class="clickable glyphicon glyphicon-resize-vertical"></span>
            <span
              ng-if="section.links.length <= 1"
              class="glyphicon glyphicon-resize-vertical"
              style="visibility: hidden"
            ></span>
            <input
              class="form-control input-sm"
              type="text"
              placeholder="Label, e.g. Health"
              ng-change="$ctrl.configChanged()"
              ng-model="link.title"
            />
          </div>
          <div class="col-md-6">
            <input
              class="form-control input-sm"
              type="text"
              placeholder="Path, e.g. /health, :7002/alt-port-link"
              ng-change="$ctrl.configChanged()"
              ng-model="link.path"
            />
          </div>
          <div class="col-md-2" style="padding: 5px 0">
            <a href ng-click="$ctrl.removeLink(section, $index)"><span class="glyphicon glyphicon-trash"></span></a>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10" style="padding-right: 20px">
            <button class="btn btn-block add-new small" ng-click="$ctrl.addLink(section)">
              <span class="glyphicon glyphicon-plus-sign"></span> Add Link
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-10 col-md-offset-1">
    <button class="btn btn-block add-new" ng-click="$ctrl.addSection()">
      <span class="glyphicon glyphicon-plus-sign"></span> Add Section
    </button>
  </div>
</div>

<config-section-footer
  application="$ctrl.application"
  config="$ctrl.sections"
  view-state="$ctrl.viewState"
  revert="$ctrl.revert()"
  config-field="instanceLinks"
></config-section-footer>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/links/editLinks.modal.html", `<div modal-page class="flex-fill">
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Edit Application Links</h4>
  </div>
  <div class="modal-body flex-fill">
    <form role="form" name="form" class="form-horizontal flex-fill">
      <div class="form-group flex-fill">
        <textarea class="code form-control flex-fill" ng-model="vm.command"></textarea>
      </div>
    </form>
    <div class="row">
      <div class="col-md-12">
        <p>
          <strong>Note:</strong> Clicking "Update" below will not save your changes to the server - it only updates the
          configuration within the browser, so you'll want to verify your changes and click "Save Changes" when you're
          ready.
        </p>
      </div>
    </div>
    <div class="form-group row slide-in" ng-if="vm.invalid">
      <div class="col-sm-9 col-sm-offset-3 error-message">Error: {{vm.errorMessage}}</div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-default" ng-click="vm.cancel()">Cancel</button>
    <button class="btn btn-primary" ng-click="vm.update()"><span class="far fa-check-circle"></span> Update</button>
  </div>
</div>
`);
}]);

const helpContents$2 = [
  {
    key: "trafficGuard.region",
    contents: "<p>Required; you can select the wildcard (*) to include all regions.</p>"
  },
  {
    key: "trafficGuard.stack",
    contents: `<p>Optional; you can use the wildcard (*) to include all stacks (including no stack).
               To apply the guard <em>only</em> to a cluster without a stack, leave this field blank.</p>`
  },
  {
    key: "trafficGuard.detail",
    contents: `<p>Optional; you can use the wildcard (*) to include all stacks (including no detail).
               To apply the guard <em>only</em> to a cluster without a detail, leave this field blank.</p>`
  }
];
helpContents$2.forEach((entry) => HelpContentsRegistry.register(entry.key, entry.contents));

class TrafficGuardConfigController {
  constructor($log) {
    this.$log = $log;
    this.accounts = [];
    this.initializing = true;
    this.clusterMatches = [];
    this.viewState = {
      originalConfig: null,
      originalStringVal: null,
      saving: false,
      saveError: false,
      isDirty: false
    };
  }
  $onInit() {
    if (this.application.notFound || this.application.hasError) {
      return;
    }
    this.config = this.application.attributes.trafficGuards || [];
    this.viewState.originalConfig = cloneDeep(this.config);
    this.viewState.originalStringVal = toJson(this.viewState.originalConfig);
    AccountService.getCredentialsKeyedByAccount().then((aggregated) => {
      const allAccounts = Object.keys(aggregated).map((name) => aggregated[name]);
      const accountsWithRegionsOnly = allAccounts.filter((details) => details.regions && !details.namespaces);
      const accountsWithNamespacesOnly = allAccounts.filter((details) => details.namespaces && !details.regions);
      const unsupportedAccounts = allAccounts.filter((details) => details.regions && details.namespaces);
      if (unsupportedAccounts.length) {
        this.$log.warn("Account(s) ", unsupportedAccounts, " have both namespaces and regions - this is not supported.");
      }
      this.accounts = accountsWithRegionsOnly.concat(accountsWithNamespacesOnly);
      this.locationsByAccount = {};
      accountsWithRegionsOnly.forEach((details) => {
        this.locationsByAccount[details.name] = ["*"].concat(details.regions.map((region) => region.name));
      });
      accountsWithNamespacesOnly.forEach((details) => {
        this.locationsByAccount[details.name] = ["*"].concat(details.namespaces);
      });
      this.application.getDataSource("serverGroups").ready().then(() => this.configureMatches());
      this.initializing = false;
    });
  }
  addGuard() {
    this.config.push({ enabled: true, account: null, location: null, stack: null, detail: null });
    this.configChanged();
  }
  removeGuard(index) {
    this.config.splice(index, 1);
    this.configChanged();
  }
  configChanged() {
    this.configureMatches();
    this.viewState.isDirty = this.viewState.originalStringVal !== toJson(this.config);
  }
  configureMatches() {
    this.clusterMatches.length = 0;
    this.config.forEach((guard) => {
      this.clusterMatches.push(this.application.clusters.filter((c) => c.serverGroups.some((s) => ClusterMatcher.getMatchingRule(c.account, s.region, c.name, [guard]) !== null)).map((c) => {
        return {
          name: c.name,
          account: guard.account,
          regions: guard.location === "*" ? uniq(c.serverGroups.map((g) => g.region)).sort() : [guard.location]
        };
      }));
    });
    this.clusterMatches.forEach((m) => m.sort((a, b) => a.name.localeCompare(b.name)));
  }
}
TrafficGuardConfigController.$inject = ["$log"];
const trafficGuardConfigComponent = {
  bindings: {
    application: "="
  },
  controller: TrafficGuardConfigController,
  templateUrl: "core/src/application/config/trafficGuard/trafficGuardConfig.component.html"
};
const TRAFFIC_GUARD_CONFIG_COMPONENT = "spinnaker.core.application.config.trafficGuard.component";
module(TRAFFIC_GUARD_CONFIG_COMPONENT, [CLUSTER_MATCHES_COMPONENT]).component("trafficGuardConfig", trafficGuardConfigComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/config/trafficGuard/trafficGuardConfig.component.html", `<div>
  <div class="row">
    <div class="col-md-12">
      <p>
        Traffic Guards allow you to specify critical clusters that should always have active instances. If a user or
        process tries to delete, disable, or resize the server group, Spinnaker will verify the operation will not leave
        the cluster with no active instances, and fail the operation if it would.
      </p>
    </div>
  </div>
  <div class="row" ng-if="$ctrl.initializing">
    <div class="horizontal center">
      <loading-spinner size="'medium'"></loading-spinner>
    </div>
  </div>
  <div class="row" ng-if="!$ctrl.initializing">
    <div class="col-md-10 col-md-offset-1">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th>Enabled</th>
            <th style="min-width: 100px">Account</th>
            <th>Region <help-field key="trafficGuard.region"></help-field></th>
            <th>Stack <help-field key="trafficGuard.stack"></help-field></th>
            <th>Detail <help-field key="trafficGuard.detail"></help-field></th>
            <th>Matched clusters</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="guard in $ctrl.config">
            <td class="text-center">
              <input type="checkbox" ng-model="guard.enabled" ng-change="$ctrl.configChanged()" />
            </td>
            <td ng-style="{ opacity: guard.enabled ? 1 : 0.5 }">
              <account-select-field
                component="guard"
                field="account"
                provider="'aws'"
                accounts="$ctrl.accounts"
                on-change="$ctrl.configChanged()"
              ></account-select-field>
            </td>
            <td ng-style="{ opacity: guard.enabled ? 1 : 0.5 }">
              <span ng-if="!guard.account">(select account)</span>
              <select
                class="form-control input-sm"
                ng-model="guard.location"
                ng-change="$ctrl.configChanged()"
                required
                ng-if="guard.account"
              >
                <option ng-repeat="location in $ctrl.locationsByAccount[guard.account]" value="{{ location }}">
                  {{ location }}
                </option>
              </select>
            </td>
            <td ng-style="{ opacity: guard.enabled ? 1 : 0.5 }">
              <input
                type="text"
                class="form-control input-sm"
                ng-model="guard.stack"
                ng-change="$ctrl.configChanged()"
              />
            </td>
            <td ng-style="{ opacity: guard.enabled ? 1 : 0.5 }">
              <input
                type="text"
                class="form-control input-sm"
                ng-model="guard.detail"
                ng-change="$ctrl.configChanged()"
              />
            </td>
            <td ng-style="{ opacity: guard.enabled ? 1 : 0.5 }">
              <cluster-matches matches="$ctrl.clusterMatches[$index]"></cluster-matches>
            </td>
            <td>
              <a href ng-click="$ctrl.removeGuard($index)"
                ><span class="glyphicon glyphicon-trash" uib-tooltip="Remove guard"></span
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-block btn-add-trigger add-new" ng-click="$ctrl.addGuard()">
        <span class="glyphicon glyphicon-plus-sign"></span> Add Traffic Guard
      </button>
    </div>
  </div>
  <div class="row">
    <config-section-footer
      application="$ctrl.application"
      config="$ctrl.config"
      view-state="$ctrl.viewState"
      config-field="trafficGuards"
    ></config-section-footer>
  </div>
</div>
`);
}]);

const CORE_APPLICATION_CONFIG_APPLICATIONCONFIG_CONTROLLER = "spinnaker.core.application.config.controller";
module(CORE_APPLICATION_CONFIG_APPLICATIONCONFIG_CONTROLLER, [
  UIROUTER_ANGULARJS,
  CORE_APPLICATION_CONFIG_APPLICATIONATTRIBUTES_DIRECTIVE,
  CORE_APPLICATION_CONFIG_APPLICATIONNOTIFICATIONS_DIRECTIVE,
  CORE_APPLICATION_CONFIG_APPLICATIONSNAPSHOTSECTION_COMPONENT,
  DELETE_APPLICATION_SECTION,
  APPLICATION_DATA_SOURCE_EDITOR,
  CHAOS_MONKEY_CONFIG_COMPONENT,
  TRAFFIC_GUARD_CONFIG_COMPONENT,
  CORE_APPLICATION_CONFIG_LINKS_APPLICATIONLINKS_COMPONENT,
  DEFAULT_TAG_FILTER_CONFIG
]).controller("ApplicationConfigController", [
  "$state",
  "app",
  "$scope",
  function($state, app, $scope) {
    this.application = app;
    this.isDataSourceEnabled = (key) => app.dataSources.some((ds) => ds.key === key && ds.disabled === false);
    this.feature = SETTINGS.feature;
    if (app.notFound || app.hasError) {
      $state.go("home.infrastructure", null, { location: "replace" });
    } else {
      this.application.attributes.instancePort = this.application.attributes.instancePort || SETTINGS.defaultInstancePort || null;
    }
    this.bannerConfigProps = {
      isSaving: false,
      saveError: false
    };
    this.updateBannerConfigs = (bannerConfigs) => {
      const applicationAttributes = cloneDeep(this.application.attributes);
      applicationAttributes.customBanners = bannerConfigs;
      $scope.$applyAsync(() => {
        this.bannerConfigProps.isSaving = true;
        this.bannerConfigProps.saveError = false;
      });
      ApplicationWriter.updateApplication(applicationAttributes).then(() => {
        $scope.$applyAsync(() => {
          this.bannerConfigProps.isSaving = false;
          this.application.attributes = applicationAttributes;
        });
      }).catch(() => {
        this.bannerConfigProps.isSaving = false;
        this.bannerConfigProps.saveError = true;
      });
    };
    this.defaultTagFilterProps = {
      isSaving: false,
      saveError: false
    };
    this.updateDefaultTagFilterConfigs = (tagConfigs) => {
      const applicationAttributes = cloneDeep(this.application.attributes);
      applicationAttributes.defaultFilteredTags = tagConfigs;
      $scope.$applyAsync(() => {
        this.defaultTagFilterProps.isSaving = true;
        this.defaultTagFilterProps.saveError = false;
      });
      ApplicationWriter.updateApplication(applicationAttributes).then(() => {
        $scope.$applyAsync(() => {
          this.defaultTagFilterProps.isSaving = false;
          this.application.attributes = applicationAttributes;
        });
      }).catch(() => {
        this.defaultTagFilterProps.isSaving = false;
        this.defaultTagFilterProps.saveError = true;
      });
    };
    this.notifications = [];
    this.updateNotifications = (notifications) => {
      $scope.$applyAsync(() => {
        this.notifications = notifications;
      });
    };
    if (this.feature.managedResources) {
      this.hasManagedResources = false;
      this.application.getDataSource("managedResources").ready().then(({ hasManagedResources }) => {
        $scope.$applyAsync(() => {
          this.hasManagedResources = hasManagedResources;
        });
      });
    }
  }
]);

class ChaosMonkeyNewApplicationConfigController {
  constructor() {
    this.enabled = false;
  }
  $onInit() {
    var _a;
    this.enabled = SETTINGS.feature.chaosMonkey;
    if (this.enabled) {
      this.applicationConfig.chaosMonkey = {
        enabled: (_a = SETTINGS.newApplicationDefaults) == null ? void 0 : _a.chaosMonkey,
        meanTimeBetweenKillsInWorkDays: 2,
        minTimeBetweenKillsInWorkDays: 1,
        grouping: "cluster",
        regionsAreIndependent: true,
        exceptions: []
      };
    }
  }
}
const chaosMonkeyNewApplicationConfigComponent = {
  bindings: {
    applicationConfig: "<"
  },
  controller: ChaosMonkeyNewApplicationConfigController,
  template: `
    <div class="form-group row" ng-if="$ctrl.enabled">
      <div class="col-sm-3 sm-label-right">
        Chaos Monkey
        <help-field key="application.chaos.enabled"></help-field>
      </div>
      <div class="col-sm-9" style="margin-bottom: 0">
        <div class="checkbox" style="margin-top: 5px">
          <label>
            <input type="checkbox"
                   ng-model="$ctrl.applicationConfig.chaosMonkey.enabled"/>
            Enabled
          </label>
        </div>
      </div>
    </div>
  `
};
const CHAOS_MONKEY_NEW_APPLICATION_CONFIG_COMPONENT = "spinnaker.core.chaosMonkey.newApplication.config.component";
module(CHAOS_MONKEY_NEW_APPLICATION_CONFIG_COMPONENT, []).component("chaosMonkeyNewApplicationConfig", chaosMonkeyNewApplicationConfigComponent);

class ApplicationNameValidationMessagesController {
  $onChanges() {
    ApplicationNameValidator.validate(this.name, this.cloudProviders).then((r) => this.messages = r);
  }
}
const applicationNameValidationMessagesComponent = {
  bindings: {
    name: "<",
    cloudProviders: "<"
  },
  controller: ApplicationNameValidationMessagesController,
  template: `
    <div class="form-group row slide-in" ng-if="$ctrl.messages.warnings.length">
      <div class="col-sm-9 col-sm-offset-3 warning-message" ng-repeat="warning in $ctrl.messages.warnings">
        <cloud-provider-logo provider="warning.cloudProvider" height="'16px'" width="'16px'"></cloud-provider-logo>
        {{warning.message}}
      </div>
    </div>
    <div class="form-group row slide-in" ng-if="$ctrl.messages.errors.length">
      <div class="col-sm-9 col-sm-offset-3 error-message" ng-repeat="error in $ctrl.messages.errors">
        <cloud-provider-logo provider="error.cloudProvider" height="'16px'" width="'16px'"></cloud-provider-logo>
        {{error.message}}
      </div>
    </div>
  `
};
const APPLICATION_NAME_VALIDATION_MESSAGES = "spinnaker.core.application.applicationNameValidationMessages";
module(APPLICATION_NAME_VALIDATION_MESSAGES, []).component("applicationNameValidationMessages", applicationNameValidationMessagesComponent);

class ValidateApplicationNameController {
  constructor($q) {
    this.$q = $q;
  }
  initialize() {
    this.model.$asyncValidators["validateApplicationName"] = (value) => {
      const deferred = this.$q.defer();
      ApplicationNameValidator.validate(value, this.cloudProviders).then((result) => {
        if (result.errors.length) {
          deferred.reject();
        } else {
          deferred.resolve();
        }
      });
      return deferred.promise;
    };
    this.$scope.$watch(this.$attrs.cloudProviders, () => this.model.$validate());
  }
}
ValidateApplicationNameController.$inject = ["$q"];
const VALIDATE_APPLICATION_NAME = "spinnaker.core.application.modal.validateApplicationName.component";
module(VALIDATE_APPLICATION_NAME, []).directive("validateApplicationName", function() {
  return {
    restrict: "A",
    controller: ValidateApplicationNameController,
    controllerAs: "$ctrl",
    require: "ngModel",
    bindToController: {
      cloudProviders: "<"
    },
    link: ($scope, _$element, $attrs, ctrl) => {
      const $ctrl = $scope["$ctrl"];
      $ctrl.$scope = $scope;
      $ctrl.$attrs = $attrs;
      $ctrl.model = ctrl;
      $ctrl.initialize();
    }
  };
});

const CORE_APPLICATION_MODAL_CREATEAPPLICATION_MODAL_CONTROLLER = "spinnaker.application.create.modal.controller";
module(CORE_APPLICATION_MODAL_CREATEAPPLICATION_MODAL_CONTROLLER, [
  UIROUTER_ANGULARJS,
  APPLICATION_NAME_VALIDATION_MESSAGES,
  VALIDATE_APPLICATION_NAME,
  CORE_APPLICATION_MODAL_APPLICATIONPROVIDERFIELDS_COMPONENT,
  CHAOS_MONKEY_NEW_APPLICATION_CONFIG_COMPONENT
]).controller("CreateApplicationModalCtrl", [
  "$scope",
  "$q",
  "$log",
  "$state",
  "$uibModalInstance",
  "$timeout",
  "name",
  function($scope, $q, $log, $state, $uibModalInstance, $timeout, name2) {
    const applicationLoader = ApplicationReader.listApplications();
    applicationLoader.then((applications) => this.data.appNameList = ___default.map(applications, "name"));
    const providerLoader = AccountService.listProviders();
    providerLoader.then((providers) => this.data.cloudProviders = providers);
    $q.all([applicationLoader, providerLoader]).catch((error) => {
      this.state.initializeFailed = true;
      throw error;
    }).finally(() => this.state.initializing = false);
    this.state = {
      initializing: true,
      initializeFailed: false,
      submitting: false,
      errorMessages: [],
      permissionsInvalid: false
    };
    this.data = {
      gitSources: SETTINGS.gitSources || ["stash", "github", "bitbucket", "gitlab"]
    };
    this.application = {
      cloudProviders: [],
      instancePort: SETTINGS.defaultInstancePort || null
    };
    if (name2) {
      this.application.name = name2;
    }
    const submitting = () => {
      this.state.errorMessages = [];
      this.state.submitting = true;
    };
    const goIdle = () => {
      this.state.submitting = false;
    };
    let navigateTimeout = null;
    const routeToApplication = () => {
      $uibModalInstance.close(this.application);
    };
    $scope.$on("$destroy", () => $timeout.cancel(navigateTimeout));
    const waitUntilApplicationIsCreated = (task) => {
      return TaskReader.waitUntilTaskCompletes(task).then(routeToApplication, () => {
        this.state.errorMessages.push("Could not create application: " + task.failureMessage);
        goIdle();
      });
    };
    const createApplicationFailure = () => {
      this.state.errorMessages.push("Could not create application");
      goIdle();
    };
    this.createApplicationForTests = () => {
      return ApplicationWriter.createApplication(this.application).then(waitUntilApplicationIsCreated, createApplicationFailure);
    };
    this.updateCloudProviderHealthWarning = () => {
      if (!this.application.platformHealthOnlyShowOverride) {
        this.data.showOverrideWarning = `Simply enabling the "Consider only cloud provider health when executing tasks"
          option above is usually sufficient for most applications that want the same health provider behavior for
          all stages. Note that pipelines will require manual updating if this setting is disabled in the future.`;
      }
    };
    function permissionsAreValid(permissions) {
      if (permissions.READ.includes(null) || permissions.WRITE.includes(null)) {
        return false;
      }
      if (permissions.READ.length > 0 && permissions.WRITE.length === 0) {
        return false;
      }
      return true;
    }
    this.handlePermissionsChange = (permissions) => {
      this.state.permissionsInvalid = !permissionsAreValid(permissions);
      this.application.permissions = permissions;
      $scope.$digest();
    };
    this.submit = () => {
      submitting();
      this.application.name = this.application.name.toLowerCase();
      if (this.data.cloudProviders.length === 1) {
        this.application.cloudProviders = this.data.cloudProviders;
      }
      this.createApplicationForTests();
    };
    this.setAttribute = (name3, value) => this.application[name3] = value;
  }
]);

var css_248z$U = ".permissions-configurer .delete-permissions {\n  padding-top: 7px;\n}\n.permissions-configurer .permissions-row {\n  margin-bottom: 3px;\n}\n.permissions-configurer .permissions-group {\n  padding-left: 0;\n}\n.permissions-configurer .add-new:hover,\n.permissions-configurer .add-new:focus,\n.permissions-configurer .add-new:active {\n  background-color: transparent;\n}\n";
styleInject(css_248z$U);

const _PermissionsConfigurer = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleAddPermission = () => {
      const permissionRows = cloneDeep(this.state.permissionRows);
      permissionRows.push({ group: null, access: "READ" });
      this.props.onPermissionsChange(this.buildPermissions(permissionRows));
    };
    this.state = this.getState(props);
    if (this.props.requiredGroupMembership && this.props.requiredGroupMembership.length) {
      this.props.onPermissionsChange(this.convertRequiredGroupMembershipToPermissions());
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState(this.getState(nextProps));
  }
  getState(props) {
    return {
      permissionRows: this.getPermissionRows(props.permissions),
      roleOptions: this.getRoleOptions(props.permissions)
    };
  }
  getPermissionRows(permissions) {
    const permissionRows = [];
    if (!permissions) {
      return permissionRows;
    }
    permissions.READ && permissions.READ.forEach((group) => {
      permissionRows.push({ group, access: "READ" });
    });
    permissions.EXECUTE && permissions.EXECUTE.forEach((group) => {
      const matchingRow = permissionRows.find((row) => row.group === group);
      if (matchingRow) {
        matchingRow.access += ",EXECUTE";
      } else {
        permissionRows.push({ group, access: "EXECUTE" });
      }
    });
    permissions.WRITE && permissions.WRITE.forEach((group) => {
      const matchingRow = permissionRows.find((row) => row.group === group);
      if (matchingRow) {
        matchingRow.access += ",WRITE";
      } else {
        permissionRows.push({ group, access: "WRITE" });
      }
    });
    return permissionRows;
  }
  getRoleOptions(permissions) {
    const availableRoles = AuthenticationService.getAuthenticatedUser().roles;
    return without(availableRoles || [], ...permissions ? (permissions.READ || []).concat(permissions.WRITE || []).concat(permissions.EXECUTE || []) : []).map((role) => ({ value: role, label: role }));
  }
  convertRequiredGroupMembershipToPermissions() {
    let READ = [];
    let WRITE = [];
    if (this.props.permissions && this.props.permissions.READ) {
      READ = this.props.permissions.READ.slice();
    }
    if (this.props.permissions && this.props.permissions.WRITE) {
      WRITE = this.props.permissions.WRITE.slice();
    }
    this.props.requiredGroupMembership.forEach((group) => {
      READ.push(group);
      WRITE.push(group);
    });
    READ = uniq(READ);
    WRITE = uniq(WRITE);
    return { READ, EXECUTE: WRITE, WRITE };
  }
  buildPermissions(permissionRows) {
    const permissions = { READ: [], EXECUTE: [], WRITE: [] };
    permissionRows.forEach((row) => {
      const accessTypes = row.access.split(",");
      accessTypes.forEach((type) => {
        if (type === "READ") {
          permissions.READ.push(row.group);
        } else if (type === "EXECUTE") {
          permissions.EXECUTE.push(row.group);
        } else if (type === "WRITE") {
          permissions.WRITE.push(row.group);
        }
      });
    });
    return permissions;
  }
  willApplicationLockoutForUser() {
    const configuredPermissions = this.props.permissions ? (this.props.permissions.READ || []).concat(this.props.permissions.WRITE || []) : [];
    if (compact(configuredPermissions).length) {
      const userRoles = AuthenticationService.getAuthenticatedUser().roles || [];
      return intersection(configuredPermissions, userRoles).length === 0;
    } else {
      return false;
    }
  }
  willApplicationLockoutAllUsers() {
    return !!this.props.permissions && compact(this.props.permissions.READ).length > 0 && compact(this.props.permissions.WRITE).length === 0;
  }
  handleRoleSelect(rowIndex) {
    return (option) => {
      const permissionRows = cloneDeep(this.state.permissionRows);
      permissionRows[rowIndex].group = option.value;
      this.props.onPermissionsChange(this.buildPermissions(permissionRows));
    };
  }
  handleAccessTypeSelect(rowIndex) {
    return (option) => {
      const permissionRows = cloneDeep(this.state.permissionRows);
      permissionRows[rowIndex].access = option.value;
      this.props.onPermissionsChange(this.buildPermissions(permissionRows));
    };
  }
  handleDeletePermission(rowIndex) {
    return () => {
      const permissionRows = cloneDeep(this.state.permissionRows);
      permissionRows.splice(rowIndex, 1);
      this.props.onPermissionsChange(this.buildPermissions(permissionRows));
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "permissions-configurer"
    }, this.state.permissionRows.map((row, i) => {
      const permissionTypeLabel = [
        ..._PermissionsConfigurer.accessTypes,
        ..._PermissionsConfigurer.legacyAccessTypes
      ].find((type) => type.value === row.access).label;
      return /* @__PURE__ */ React__default.createElement("div", {
        key: row.group || i,
        className: "permissions-row clearfix"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-5 permissions-group"
      }, /* @__PURE__ */ React__default.createElement(Creatable, {
        clearable: false,
        value: { value: row.group, label: row.group },
        options: this.state.roleOptions,
        onChange: this.handleRoleSelect(i)
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-6"
      }, /* @__PURE__ */ React__default.createElement(Select, {
        value: { value: row.access, label: permissionTypeLabel },
        options: _PermissionsConfigurer.accessTypes,
        onChange: this.handleAccessTypeSelect(i),
        clearable: false
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-1 delete-permissions"
      }, /* @__PURE__ */ React__default.createElement("a", {
        onClick: this.handleDeletePermission(i),
        className: "clickable"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-trash"
      }))));
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-11"
    }, /* @__PURE__ */ React__default.createElement(Button$1, {
      className: "btn btn-block add-new small",
      onClick: this.handleAddPermission
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add"))), this.willApplicationLockoutForUser() && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-11"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), "The permissions you have selected will lock you out of this application."))), this.willApplicationLockoutAllUsers() && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-11"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), "The permissions you have selected will lock ALL users out of this application."))));
  }
};
let PermissionsConfigurer = _PermissionsConfigurer;
PermissionsConfigurer.accessTypes = [
  { value: "READ", label: "Read only" },
  { value: "READ,EXECUTE", label: "Read and execute" },
  { value: "READ,EXECUTE,WRITE", label: "Read, execute, write" }
];
PermissionsConfigurer.legacyAccessTypes = [{ value: "READ,WRITE", label: "Read and write" }];

const PERMISSIONS_CONFIGURER_COMPONENT = "spinnaker.application.permissionsConfigurer.component";
module(PERMISSIONS_CONFIGURER_COMPONENT, []).component("permissionsConfigurer", react2angular(withErrorBoundary(PermissionsConfigurer, "permissionsConfigurer"), [
  "permissions",
  "requiredGroupMembership",
  "onPermissionsChange"
]));

const CORE_APPLICATION_MODAL_PLATFORMHEALTHOVERRIDE_DIRECTIVE = "spinnaker.application.platformHealthOverrideCheckbox.directive";
angular.module(CORE_APPLICATION_MODAL_PLATFORMHEALTHOVERRIDE_DIRECTIVE, []).directive("platformHealthOverride", function() {
  return {
    restrict: "E",
    templateUrl: "core/src/application/modal/platformHealthOverrideCheckbox.directive.html",
    scope: {
      command: "=",
      platformHealthType: "=",
      showHelpDetails: "="
    },
    controller: "PlatformHealthOverrideCtrl as platformHealthOverrideCtrl"
  };
}).directive("initPlatformHealth", function() {
  return function(scope, element) {
    angular.element(element).attr("checked", ___default.isEqual(scope.command.interestingHealthProviderNames, [scope.platformHealthType]));
  };
}).controller("PlatformHealthOverrideCtrl", [
  "$scope",
  function($scope) {
    $scope.clicked = function($event) {
      if ($event.currentTarget.checked) {
        $scope.command.interestingHealthProviderNames = [$scope.platformHealthType];
      } else {
        delete $scope.command.interestingHealthProviderNames;
      }
    };
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/modal/platformHealthOverrideCheckbox.directive.html", `<div class="checkbox">
  <label>
    <input type="checkbox" init-platform-health ng-click="clicked($event)" />
    Consider only {{platformHealthType}} health
  </label>
  <help-field key="application.platformHealthOnly" expand="showHelpDetails"></help-field>
</div>
`);
}]);

const helpContents$1 = {
  "application.platformHealthOnly": `
        When this option is enabled, instance status as reported by the cloud provider will be considered sufficient to
        determine task completion. When this option is disabled, tasks will normally need health status reported by some other health provider (e.g. a
        load balancer or discovery service) to determine task completion.`,
  "application.showPlatformHealthOverride": "When this option is enabled, users will be able to toggle the option above on a task-by-task basis.",
  "application.permissions": `
      <ul>
        <li>To read from this application, a user must be a member of at least one group with read access.</li>
        <li>To write to this application, a user must be a member of at least one group with write access.</li>
        <li>If no permissions are specified, any user can read from or write to this application.</li>
        <li>These permissions will only be enforced if Fiat is enabled.</li>
      </ul>
      <p class="small"><strong>Note:</strong> Due to caching, data may be delayed up to 10 minutes</p>
    `,
  "application.enableRestartRunningExecutions": `
        When this option is enabled, users will be able to restart pipeline stages while a pipeline is still running.
        This behavior can have varying unexpected results and is <b>not recommended</b> to enable.`,
  "application.enableRerunActiveExecutions": `
        When this option is enabled, the re-run option also appears on active executions. This is usually not needed
        but may sometimes be useful for submitting multiple executions with identical parameters.`,
  "application.instance.port": `
     <p>This field is only used to generate links within Spinnaker to a running instance when viewing an
     instance's details.</p> The instance port can be used or overridden for specific links configured for your
     application (via the Config screen).
  `
};
Object.keys(helpContents$1).forEach((key) => HelpContentsRegistry.register(key, helpContents$1[key]));

const APPLICATION_MODULE = "spinnaker.core.application";
module(APPLICATION_MODULE, [
  APPLICATION_STATE_PROVIDER,
  APPLICATIONS_STATE_PROVIDER,
  CORE_APPLICATION_CONFIG_APPLICATIONCONFIG_CONTROLLER,
  CORE_APPLICATION_MODAL_CREATEAPPLICATION_MODAL_CONTROLLER,
  CORE_APPLICATION_MODAL_PLATFORMHEALTHOVERRIDE_DIRECTIVE,
  CORE_APPLICATION_CONFIG_APPCONFIG_DATASOURCE,
  PERMISSIONS_CONFIGURER_COMPONENT
]);

var css_248z$T = ".expected-artifact-selector img.artifact-icon,\n.expected-artifact-multi-selector img.artifact-icon {\n  margin-right: 4px;\n}\n";
styleInject(css_248z$T);

class ExpectedArtifactMultiSelectorCtrl {
  iconPath(expected) {
    const artifact = expected && (expected.matchArtifact || expected.defaultArtifact);
    if (artifact == null) {
      return "";
    }
    return ArtifactIconService.getPath(artifact.type);
  }
}
const expectedArtifactMultiSelectorComponent = {
  bindings: {
    command: "=",
    expectedArtifacts: "<",
    artifactLabel: "@",
    idsField: "@",
    helpFieldKey: "@",
    showIcons: "<"
  },
  controller: ExpectedArtifactMultiSelectorCtrl,
  controllerAs: "ctrl",
  template: `
      <ng-form name="artifacts">
        <stage-config-field label="{{ctrl.artifactLabel}}" help-key="{{ctrl.helpFieldKey}}">
          <ui-select multiple
                     ng-model="ctrl.command[ctrl.idsField]"
                     class="form-control input-sm expected-artifact-multi-selector">
            <ui-select-match>
              <img
                ng-if="ctrl.showIcons && ctrl.iconPath($item)"
                width="16"
                height="16"
                class="artifact-icon"
                ng-src="{{ ctrl.iconPath($item) }}" />
              {{ $item.displayName }}
            </ui-select-match>
            <ui-select-choices repeat="expected.id as expected in ctrl.expectedArtifacts">
              <img
                ng-if="ctrl.showIcons && ctrl.iconPath(expected)"
                width="16"
                height="16"
                class="artifact-icon"
                ng-src="{{ ctrl.iconPath(expected) }}" />
              <span>{{ expected.displayName }}</span>
            </ui-select-choices>
          </ui-select>
        </stage-config-field>
      </ng-form>
  `
};
const EXPECTED_ARTIFACT_MULTI_SELECTOR_COMPONENT = "spinnaker.core.artifacts.expected.multiSelector";
module(EXPECTED_ARTIFACT_MULTI_SELECTOR_COMPONENT, []).component("expectedArtifactMultiSelector", expectedArtifactMultiSelectorComponent);

const STAGE_ARTIFACT_SELECTOR_DELEGATE = "spinnaker.core.artifact.stageArtifactSelectorDelegate";
module(STAGE_ARTIFACT_SELECTOR_DELEGATE, []).component("stageArtifactSelectorDelegate", react2angular(withErrorBoundary(StageArtifactSelectorDelegate, "stageArtifactSelectorDelegate"), [
  "artifact",
  "excludedArtifactTypePatterns",
  "expectedArtifactId",
  "fieldColumns",
  "helpKey",
  "label",
  "onArtifactEdited",
  "onExpectedArtifactSelected",
  "pipeline",
  "stage"
]));

const ARTIFACT_MODULE = "spinnaker.core.artifact";
module(ARTIFACT_MODULE, [
  EXECUTION_ARTIFACT_TAB,
  EXPECTED_ARTIFACT_MULTI_SELECTOR_COMPONENT,
  EXPECTED_ARTIFACT_SELECTOR_COMPONENT_REACT,
  EXPECTED_ARTIFACT_EDITOR_COMPONENT_REACT,
  IMAGE_SOURCE_SELECTOR_COMPONENT,
  STAGE_ARTIFACT_SELECTOR_DELEGATE
]);

class AuthenticationInterceptor {
  constructor($q) {
    this.$q = $q;
    this.request = (config) => {
      return this.$q((resolve) => {
        if (config.url === SETTINGS.authEndpoint || config.url.indexOf("http") !== 0) {
          resolve(config);
        } else {
          const user = AuthenticationService.getAuthenticatedUser();
          if (user.authenticated && user.lastAuthenticated + (SETTINGS.authTtl || 6e5) > new Date().getTime()) {
            resolve(config);
          } else {
            AuthenticationService.onAuthentication(() => resolve(config));
          }
        }
      });
    };
  }
}
AuthenticationInterceptor.$inject = ["$q"];
const AUTHENTICATION_INTERCEPTOR_SERVICE = "spinnaker.authentication.interceptor.service";
module(AUTHENTICATION_INTERCEPTOR_SERVICE, []).service("authenticationInterceptor", AuthenticationInterceptor).config([
  "$httpProvider",
  ($httpProvider) => {
    if (SETTINGS.authEnabled) {
      $httpProvider.interceptors.push("authenticationInterceptor");
    }
  }
]);

const AUTHENTICATION_MODULE = "spinnaker.authentication";
module(AUTHENTICATION_MODULE, [AUTHENTICATION_INTERCEPTOR_SERVICE]).config([
  "$httpProvider",
  function($httpProvider) {
    $httpProvider.interceptors.push("gateRequestInterceptor");
  }
]).factory("gateRequestInterceptor", function() {
  return {
    request(config) {
      if (config.url.indexOf(SETTINGS.gateUrl) === 0) {
        config.withCredentials = true;
      }
      return config;
    }
  };
}).run(function() {
  if (SETTINGS.authEnabled) {
    SchedulerFactory.createScheduler(SETTINGS.authTtl || 6e5).subscribe(() => AuthenticationInitializer.reauthenticateUser());
    AuthenticationInitializer.authenticateUser();
  }
});

function transformResultStatus(result) {
  switch (result) {
    case "SUCCESS":
      return "SUCCEEDED";
    case "FAILURE":
      return "FAILED";
    case "BUILDING":
      return "INCOMPLETE";
    case "ABORTED":
      return "ABORTED";
  }
  return result;
}
function transformBuildToUIFormat(build) {
  const { artifacts, properties, scm } = build;
  const startTime = parseInt(properties.startedTs, 10);
  const transformedBuild = {
    author: scm.length == 0 ? "" : scm[0].committer,
    artifacts: artifacts.map((artifact) => ({ name: artifact.fileName, url: artifact.displayPath })),
    branchName: scm.length == 0 ? "" : scm[0].branch,
    commitId: scm.length == 0 ? "" : scm[0].sha1.substr(0, 7),
    commitLink: scm.length == 0 ? "" : scm[0].compareUrl,
    commitMessage: scm.length == 0 ? "" : scm[0].message,
    duration: build.duration,
    fullDisplayName: build.fullDisplayName,
    id: build.id,
    isRunning: build.building,
    number: build.number,
    projectKey: properties.projectKey,
    pullRequestNumber: properties.pullRequestNumber,
    pullRequestUrl: properties.pullRequestUrl,
    repoSlug: properties.repoSlug,
    result: transformResultStatus(build.result),
    startTime,
    url: build.url
  };
  OrchestratedItemTransformer.addRunningTime(transformedBuild);
  return transformedBuild;
}
class CIReader {
  static get MAX_LINES() {
    return 4095;
  }
  static getBuilds(repoType, projectKey, repoSlug) {
    return REST("ci/builds").query({ repoType, projectKey, repoSlug }).get().then((builds) => builds.map((build) => transformBuildToUIFormat(build)));
  }
  static getRunningBuilds(repoType, projectKey, repoSlug) {
    return REST("ci/builds").query({ repoType, projectKey, repoSlug, completionStatus: "INCOMPLETE" }).get();
  }
  static getBuildOutput(buildId, start = -1) {
    return REST("ci/builds").path(buildId, "output").query({ start, limit: CIReader.MAX_LINES }).get();
  }
}

const CI_DATASOURCE = "spinnaker.ci.dataSource";
module(CI_DATASOURCE, []).run([
  "$q",
  ($q) => {
    if (!SETTINGS.feature.ci) {
      return;
    }
    const loadBuilds = (application) => {
      const { repoType, repoProjectKey, repoSlug } = application.attributes;
      if (isEmpty(repoProjectKey) || isEmpty(repoType) || isEmpty(repoSlug)) {
        return $q.when([]);
      }
      return CIReader.getBuilds(repoType, repoProjectKey, repoSlug);
    };
    const loadRunningBuilds = (application) => {
      const { repoType, repoProjectKey, repoSlug } = application.attributes;
      if (isEmpty(repoProjectKey) || isEmpty(repoType) || isEmpty(repoSlug)) {
        return $q.when([]);
      }
      return CIReader.getRunningBuilds(repoType, repoProjectKey, repoSlug);
    };
    navigationCategoryRegistry.register({
      key: "integration",
      label: "Integration",
      icon: "icon-ci-branch",
      iconName: "spCIBranch",
      primary: true,
      order: 0
    });
    ApplicationDataSourceRegistry.registerDataSource({
      key: "integration",
      badge: "runningBuilds",
      icon: "icon-ci-branch",
      iconName: "spCIBranch",
      category: "integration",
      label: "Integration",
      optional: true,
      lazy: true,
      description: "Visibility into builds for pull requests and branches",
      requireConfiguredApp: true,
      defaultData: []
    });
    ApplicationDataSourceRegistry.registerDataSource({
      key: "builds",
      sref: ".builds",
      badge: "runningBuilds",
      icon: "icon-ci-build",
      iconName: "spCIBuild",
      category: "integration",
      label: "Builds",
      lazy: true,
      requireConfiguredApp: true,
      requiresDataSource: "integration",
      loader: loadBuilds,
      onLoad: (_, data) => $q.when(data),
      defaultData: []
    });
    ApplicationDataSourceRegistry.registerDataSource({
      key: "runningBuilds",
      visible: false,
      description: "running builds",
      loader: loadRunningBuilds,
      onLoad: (_, data) => $q.when(data),
      defaultData: []
    });
  }
]);

const BuildDetailsScrollContainerContext = React.createContext(null);

function BuildInfoArtifactsTab({ build }) {
  var _a;
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex-container-v"
  }, (_a = build.artifacts) == null ? void 0 : _a.map((artifact) => /* @__PURE__ */ React.createElement("a", {
    href: artifact.url,
    key: artifact.name,
    target: "_blank"
  }, decodeURIComponent(artifact.name))));
}

const INIT_LOG_RESULT = {
  logs: [],
  state: "loading"
};
function BuildInfoLogsTab({ build }) {
  const [logResult, setLogResult] = React.useState(INIT_LOG_RESULT);
  const [autoScroll, setAutoScroll] = React.useState(false);
  const [scrollTop, setScrollTop] = React.useState(0);
  const logContainerEnd = React.useRef(null);
  const retrieveOutputLogs = (offset = -1) => {
    CIReader.getBuildOutput(build.id, offset).then((response) => setLogResult((logResult2) => ({
      logs: [...logResult2.logs, response.log],
      state: build.isRunning ? "loading" : "loaded"
    })));
  };
  const buildDetailsScrollContainer = React.useContext(BuildDetailsScrollContainerContext);
  React.useEffect(() => {
    setLogResult(INIT_LOG_RESULT);
    setAutoScroll(false);
    retrieveOutputLogs();
  }, [build.id]);
  useInterval(() => {
    var _a;
    if (build.isRunning) {
      retrieveOutputLogs(logResult.logs.length);
      if (autoScroll) {
        (_a = logContainerEnd.current) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, 1e3);
  React.useEffect(() => {
    const scrollContainer = buildDetailsScrollContainer || window;
    const scrollHandler = throttle(() => {
      if (scrollTop > scrollContainer.scrollTop) {
        setAutoScroll(false);
      }
      setScrollTop(scrollContainer.scrollTop);
    }, 300);
    scrollContainer.addEventListener("scroll", scrollHandler);
    return () => {
      scrollContainer.removeEventListener("scroll", scrollHandler);
    };
  }, [scrollTop, buildDetailsScrollContainer]);
  const scrollToBottomHandler = () => {
    if (autoScroll) {
      setAutoScroll(false);
    } else {
      setAutoScroll(true);
      logContainerEnd.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  if (isEmpty(logResult.logs) && logResult.state === "loading") {
    return /* @__PURE__ */ React.createElement("div", {
      className: "build-details-loader flex-container-h center middle"
    }, /* @__PURE__ */ React.createElement(Spinner, {
      size: "medium"
    }));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "text-right auto-scroll-header sticky-header"
  }, /* @__PURE__ */ React.createElement(Tooltip, {
    placement: "top",
    value: "Scroll to bottom"
  }, /* @__PURE__ */ React.createElement("a", {
    onClick: scrollToBottomHandler
  }, /* @__PURE__ */ React.createElement("span", {
    className: classNames("glyphicon glyphicon-circle-arrow-down", { enabled: autoScroll })
  })))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("pre", {
    className: "small"
  }, /* @__PURE__ */ React.createElement("p", {
    style: { fontFamily: "monospace" }
  }, /* @__PURE__ */ React.createElement("span", null), logResult.logs.join(""))), /* @__PURE__ */ React.createElement("div", {
    ref: logContainerEnd
  }))));
}

const infoConfigByBuildStatus = {
  SUCCEEDED: {
    statusClass: "pass",
    text: "Passed"
  },
  FAILED: {
    statusClass: "fail",
    text: "Failed"
  },
  INCOMPLETE: {
    statusClass: "building",
    text: "Running"
  },
  ABORTED: {
    statusClass: "canceled",
    text: "Canceled"
  }
};
function BuildInfoDetails({ build }) {
  var _a, _b, _c, _d;
  const { params } = useCurrentStateAndParams();
  return /* @__PURE__ */ React.createElement("div", {
    className: "ci-builds-details"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ci-builds-details-header"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ci-builds-details-header-left"
  }, /* @__PURE__ */ React.createElement("h3", null, "Build #", build.number), /* @__PURE__ */ React.createElement("span", {
    className: `ci-pill ${(_b = (_a = infoConfigByBuildStatus[build.result]) == null ? void 0 : _a.statusClass) != null ? _b : ""}`
  }, /* @__PURE__ */ React.createElement("span", null, (_c = infoConfigByBuildStatus[build.result]) == null ? void 0 : _c.text)), /* @__PURE__ */ React.createElement("span", {
    className: "note"
  }, relativeTime(build.startTime + build.duration)), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("div", {
    className: "horizontal"
  }, /* @__PURE__ */ React.createElement("dt", {
    className: "sp-margin-l-right"
  }, "Commit"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("i", {
    className: "commit icon-ci-commit"
  }), /* @__PURE__ */ React.createElement("a", {
    href: build.commitLink,
    target: "_blank"
  }, " ", build.commitId), " ", "by ", build.author)), /* @__PURE__ */ React.createElement("div", {
    className: "horizontal"
  }, /* @__PURE__ */ React.createElement("dt", {
    className: "sp-margin-l-right"
  }, "Message"), /* @__PURE__ */ React.createElement("dd", null, build.commitMessage))), /* @__PURE__ */ React.createElement("div", {
    className: "ci-builds-details-header-right"
  }, /* @__PURE__ */ React.createElement("dl", {
    className: "dl-horizontal"
  }, /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("dt", null, "Duration"), /* @__PURE__ */ React.createElement("dd", null, duration(build.duration)), /* @__PURE__ */ React.createElement("dt", null, "Job"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("a", {
    href: build.url,
    target: "_blank"
  }, build.fullDisplayName)), /* @__PURE__ */ React.createElement("dt", null, "Branch"), /* @__PURE__ */ React.createElement("dd", null, build.branchName), build.repoLink && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Repository"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("a", {
    href: build.repoLink,
    target: "_blank"
  }, build.projectKey, "/", build.repoSlug))), /* @__PURE__ */ React.createElement("dt", null, "Pull Request"), ((_d = build.pullRequestNumber) == null ? void 0 : _d.length) < 1 ? /* @__PURE__ */ React.createElement("dd", null, "N/A") : /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("a", {
    href: build.pullRequestUrl,
    target: "_blank"
  }, build.pullRequestNumber))))), /* @__PURE__ */ React.createElement(BuildInfoOutput, {
    build,
    tab: params.tab
  }));
}
function BuildInfoOutput({ build, tab }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    className: "ci-output-tabs"
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames("ci-output-tab", { active: tab === "logs" })
  }, /* @__PURE__ */ React.createElement(UISref, {
    to: "home.applications.application.builds.build.buildTab",
    params: { tab: "logs" }
  }, /* @__PURE__ */ React.createElement("a", null, "Build Log"))), /* @__PURE__ */ React.createElement("div", {
    className: classNames("ci-output-tab", { active: tab === "artifacts" })
  }, /* @__PURE__ */ React.createElement(UISref, {
    to: "home.applications.application.builds.build.buildTab",
    params: { tab: "artifacts" }
  }, /* @__PURE__ */ React.createElement("a", null, build.artifacts.length, " ", build.artifacts.length === 1 ? "Artifact" : "Artifacts", " generated")))), /* @__PURE__ */ React.createElement("div", {
    className: "ci-output-main"
  }, tab === "logs" ? /* @__PURE__ */ React.createElement(BuildInfoLogsTab, {
    build
  }) : null, tab === "artifacts" ? /* @__PURE__ */ React.createElement(BuildInfoArtifactsTab, {
    build
  }) : null));
}

const configByBuildStatus = {
  SUCCEEDED: {
    statusClass: "ci-pass",
    text: "passed"
  },
  FAILED: {
    statusClass: "ci-fail",
    text: "failed"
  },
  INCOMPLETE: {
    statusClass: "ci-building",
    text: "running"
  },
  ABORTED: {
    statusClass: "ci-canceled",
    text: "canceled"
  }
};
function BuildInfoSummaryCard({ build, isActive, onClick }) {
  var _a, _b, _c;
  const config = configByBuildStatus[build.result];
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames("ci-build-box", { active: isActive }),
    onClick
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ci-build-box-title"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "ci-build-box-title-left"
  }, /* @__PURE__ */ React.createElement("i", {
    className: classNames(`icon-ci-build ${(_a = config == null ? void 0 : config.statusClass) != null ? _a : ""}`)
  }), /* @__PURE__ */ React.createElement("span", {
    className: `${(_b = config == null ? void 0 : config.statusClass) != null ? _b : ""}`
  }, "#", build.number, " ", config == null ? void 0 : config.text)), /* @__PURE__ */ React.createElement("span", {
    className: "note"
  }, relativeTime(build.startTime + build.duration))), /* @__PURE__ */ React.createElement("div", {
    className: "ci-build-box-pr horizontal"
  }, /* @__PURE__ */ React.createElement("i", {
    className: "commit icon-ci-commit"
  }), /* @__PURE__ */ React.createElement("a", {
    className: "sp-margin-xs-right",
    href: build.commitLink,
    target: "_blank"
  }, build.commitId), "by ", build.author.length > 15 ? build.author.substr(0, 15) + "..." : build.author, /* @__PURE__ */ React.createElement("span", {
    className: "ci-pill-branch"
  }, ((_c = build.branchName) == null ? void 0 : _c.length) > 15 ? build.branchName.substr(0, 15) + "..." : build.branchName)));
}

var css_248z$S = ".build-detail {\n  margin-left: 20px;\n  flex: 1 1 auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.build-detail .auto-scroll-header {\n  height: 0;\n}\n.build-detail .auto-scroll-header .glyphicon {\n  margin: 10px 20px;\n  background-color: var(--color-white);\n  border-radius: 50%;\n  border: 1px solid var(--color-white);\n  font-size: 20px;\n  color: var(--color-dovegray);\n}\n.build-detail .auto-scroll-header .glyphicon.enabled {\n  color: var(--color-success);\n}\n.build-detail .auto-scroll-header a {\n  cursor: pointer;\n}\n.build-detail .row.heading-sticky {\n  box-shadow: none;\n}\n.build-details-loader {\n  height: 165px;\n}\n.configuration-error {\n  width: 100%;\n  text-align: left;\n  display: block;\n  font-weight: 600;\n}\n.ci-build-box {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-mineshaft);\n  font-size: 14px;\n  margin-bottom: 8px;\n  padding: 16px;\n  cursor: pointer;\n  max-width: 310px;\n}\n.ci-build-box:hover {\n  box-shadow: 0 0 4px 2px #abd7e0;\n}\n.ci-build-box.active {\n  border: 1px solid var(--color-accent-g1);\n  background-color: var(--color-seashell);\n}\n.ci-build-box-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.ci-build-box-pr {\n  overflow: hidden;\n  align-items: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ci-build-box-title-left {\n  font-size: 16px;\n  display: flex;\n}\n.ci-build-box-title-left i {\n  font-size: 24px;\n  margin-right: 8px;\n}\n.commit {\n  font-size: 24px;\n  color: var(--color-concrete);\n  vertical-align: middle;\n}\n.note {\n  font-style: italic;\n  color: var(--color-concrete);\n}\n.ci-pass {\n  color: var(--color-success);\n  font-weight: bold;\n}\n.ci-fail {\n  color: var(--color-danger);\n  font-weight: bold;\n}\n.ci-building {\n  color: var(--color-concrete);\n  font-weight: bold;\n}\n.ci-canceled {\n  color: var(--color-concrete);\n  font-weight: bold;\n}\n.ci-builds-details {\n  flex: 8 0 600px;\n  margin-left: 16px;\n}\n.ci-builds-details-header {\n  display: flex;\n}\n.ci-builds-details-header-left {\n  flex: 2 0 1px;\n}\n.ci-builds-details-header-right {\n  flex: 3 0 1px;\n  margin-top: 16px;\n}\n.ci-pill {\n  border-radius: 32px;\n  padding: 2px 10px;\n  margin-right: 4px;\n  margin-bottom: 4px;\n  color: var(--color-white);\n  display: inline-block;\n}\n.ci-pill.pass {\n  background-color: var(--color-success);\n}\n.ci-pill.fail {\n  background-color: var(--color-danger);\n}\n.ci-pill.building {\n  background-color: var(--color-concrete);\n}\n.ci-pill.canceled {\n  background-color: var(--color-concrete);\n}\n.ci-output-tabs {\n  display: flex;\n  margin-top: 32px;\n  text-transform: uppercase;\n  font-weight: bold;\n  color: var(--color-dovegray);\n  border-bottom: 1px solid var(--color-mineshaft);\n}\n.ci-output-tab {\n  padding: 8px 16px;\n  border-top: 1px solid var(--color-mineshaft);\n  border-left: 1px solid var(--color-mineshaft);\n  border-right: 1px solid var(--color-mineshaft);\n  background-color: var(--color-cirrus);\n  margin-left: -1px;\n  cursor: pointer;\n}\n.ci-output-tab:hover {\n  box-shadow: 0 -3px 3px 0 #abd7e0;\n}\n.ci-output-tab:first-child {\n  margin-left: 0;\n}\n.ci-output-tab.active {\n  background-color: var(--color-white);\n  margin-bottom: -1px;\n  padding-bottom: 9px;\n}\n.ci-output-main {\n  padding: 16px;\n  min-height: 200px;\n  background-color: var(--color-white);\n  border-left: 1px solid var(--color-mineshaft);\n  border-right: 1px solid var(--color-mineshaft);\n  border-bottom: 1px solid var(--color-mineshaft);\n  margin-bottom: 64px;\n}\ni.ci-building {\n  -webkit-animation-name: building;\n          animation-name: building;\n  -webkit-animation-duration: 2s;\n          animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n@-webkit-keyframes building {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes building {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ci-pill-branch {\n  border-radius: 16px;\n  position: relative;\n  padding: 2px 10px;\n  margin-right: 1px;\n  margin-left: auto;\n  margin-bottom: 4px;\n  color: var(--color-mineshaft);\n  background-color: var(--color-alto);\n  display: inline-block;\n  text-overflow: ellipsis;\n  font-size: 12px;\n}\n";
styleInject(css_248z$S);

function Builds({ app }) {
  const dataSource = app.getDataSource("builds");
  const { data: builds, status, loaded } = useDataSource(dataSource);
  const {
    stateService: { go }
  } = useRouter();
  const { params, state } = useCurrentStateAndParams();
  const buildDetailsScrollContainer = React.useRef(null);
  React.useEffect(() => {
    dataSource.activate();
  }, []);
  React.useEffect(() => {
    if (!isEmpty(builds) && !state.name.includes(".build.buildTab")) {
      go("home.applications.application.builds.build.buildTab", { buildId: builds[0].id, tab: "logs" });
    }
  }, [builds]);
  if (!loaded) {
    return /* @__PURE__ */ React.createElement("div", {
      style: { width: "100%" },
      className: "flex-container-h center"
    }, /* @__PURE__ */ React.createElement(Spinner, {
      size: "medium"
    }));
  }
  if (status === "ERROR") {
    return /* @__PURE__ */ React.createElement("div", {
      style: { width: "100%" }
    }, /* @__PURE__ */ React.createElement("h4", {
      className: "text-center"
    }, "There was an error loading builds."));
  }
  const { repoType, repoProjectKey, repoSlug } = app.attributes;
  const hasAllConfig = [repoType, repoProjectKey, repoSlug].every((attr) => trim(attr));
  if (!hasAllConfig) {
    return /* @__PURE__ */ React.createElement("div", {
      className: "row configuration-error"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "col-md-12"
    }, "Welcome! To get started with Builds, you'll need to add a", /* @__PURE__ */ React.createElement(UISref, {
      to: "home.applications.application.config",
      className: "bold config"
    }, /* @__PURE__ */ React.createElement("a", null, " repository to your app's configuration."))));
  }
  if (isEmpty(builds)) {
    return /* @__PURE__ */ React.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React.createElement("span", null, "Welcome! To get started with Builds, you'll need to make sure that RocketCI is configured for this app.", /* @__PURE__ */ React.createElement("br", null), "Please visit", " ", /* @__PURE__ */ React.createElement("a", {
      href: "http://go.netflix.com/rocketci/",
      target: "_blank"
    }, "RocketCI"), " ", "for more details."));
  }
  const selectedBuild = params.buildId ? builds.find((build) => build.id === params.buildId) : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    className: "nav-ci"
  }, builds.map((build) => /* @__PURE__ */ React.createElement(BuildInfoSummaryCard, {
    build,
    isActive: params.buildId === build.id,
    key: build.id,
    onClick: () => go("home.applications.application.builds.build.buildTab", { buildId: build.id, tab: "logs" })
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "build-detail",
    ref: buildDetailsScrollContainer
  }, selectedBuild && /* @__PURE__ */ React.createElement(BuildDetailsScrollContainerContext.Provider, {
    value: buildDetailsScrollContainer.current
  }, /* @__PURE__ */ React.createElement(BuildInfoDetails, {
    build: selectedBuild
  }))));
}

const CI_STATES = "spinnaker.ci.states";
module(CI_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  (applicationStateProvider) => {
    if (!SETTINGS.feature.ci) {
      return;
    }
    const buildDetailTab = {
      name: "buildTab",
      url: "/:tab"
    };
    const buildDetail = {
      name: "build",
      url: "/:buildId",
      children: [buildDetailTab]
    };
    const builds = {
      name: "builds",
      url: "/builds",
      views: {
        insight: {
          component: Builds,
          $type: "react"
        }
      },
      data: {
        pageTitleSection: {
          title: "Builds"
        }
      },
      children: [buildDetail]
    };
    applicationStateProvider.addChildState(builds);
  }
]);

const CI_MODULE = "spinnaker.ci";
module(CI_MODULE, [CI_STATES, CI_DATASOURCE]);

const CORE_CLOUDPROVIDER_CLOUDPROVIDERLABEL_DIRECTIVE = "spinnaker.core.cloudProviderLabel.directive";
module(CORE_CLOUDPROVIDER_CLOUDPROVIDERLABEL_DIRECTIVE, []).directive("cloudProviderLabel", function() {
  return {
    restrict: "E",
    template: '<span ng-bind="providerLabel"></span>',
    scope: {
      provider: "="
    },
    link: function(scope) {
      function setProviderLabel() {
        scope.providerLabel = CloudProviderRegistry.getValue(scope.provider, "name") || scope.provider;
      }
      scope.$watch("provider", setProviderLabel);
    }
  };
});

const CLOUD_PROVIDER_LOGO = "spinnaker.core.cloudProviderLogo.directive";
module(CLOUD_PROVIDER_LOGO, []).component("cloudProviderLogo", react2angular(withErrorBoundary(CloudProviderLogo, "cloudProviderLogo"), [
  "provider",
  "height",
  "width",
  "showTooltip"
]));

const CORE_CLOUDPROVIDER_PROVIDERSELECTION_PROVIDERSELECTOR_DIRECTIVE = "spinnaker.providerSelection.directive";
module(CORE_CLOUDPROVIDER_PROVIDERSELECTION_PROVIDERSELECTOR_DIRECTIVE, []).directive("providerSelector", [
  "$q",
  function($q) {
    return {
      restrict: "E",
      scope: {
        component: "=",
        field: "@",
        readOnly: "=",
        providers: "=?",
        onChange: "&"
      },
      templateUrl: "core/src/cloudProvider/providerSelection/providerSelector.html",
      link: function(scope) {
        scope.initialized = false;
        const getProviderList = scope.providers ? $q.when(scope.providers.sort()) : AccountService.listProviders();
        getProviderList.then(function(providers) {
          scope.initialized = true;
          if (!providers.length) {
            scope.component[scope.field] = "aws";
          }
          if (providers.length === 1) {
            scope.component[scope.field] = providers[0];
          }
          if (providers.length > 1) {
            scope.providers = providers;
            scope.showSelector = true;
          }
        });
      }
    };
  }
]).controller("ProviderSelectCtrl", [
  "$scope",
  "$uibModalInstance",
  "providerOptions",
  function($scope, $uibModalInstance, providerOptions) {
    $scope.command = {
      provider: ""
    };
    $scope.getImage = function(provider) {
      return CloudProviderRegistry.getValue(provider, "logo.path");
    };
    $scope.providerOptions = providerOptions;
    this.selectProvider = function() {
      $uibModalInstance.close($scope.command.provider);
    };
    this.cancel = $uibModalInstance.dismiss;
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/cloudProvider/providerSelection/providerSelector.html", `<ui-select
  ng-model="component[field]"
  on-select="onChange()"
  ng-if="initialized && showSelector && !readOnly"
  class="form-control input-sm"
>
  <ui-select-match placeholder="Select a provider">
    <cloud-provider-logo provider="$select.selected" height="'14px'" width="'14px'"></cloud-provider-logo>
    <cloud-provider-label provider="$select.selected"></cloud-provider-label>
  </ui-select-match>
  <ui-select-choices repeat="provider in providers | filter: $select.search">
    <h5>
      <cloud-provider-logo provider="provider" height="'14px'" width="'14px'"></cloud-provider-logo>
      <cloud-provider-label provider="provider"></cloud-provider-label>
    </h5>
  </ui-select-choices>
</ui-select>
<p class="form-control-static" ng-if="readOnly">
  <cloud-provider-logo provider="component[field]" height="'14px'" width="'14px'"></cloud-provider-logo>
  <cloud-provider-label provider="component[field]"></cloud-provider-label>
</p>
`);
}]);

const CLOUD_PROVIDER_MODULE = "spinnaker.core.cloudProvider";
module(CLOUD_PROVIDER_MODULE, [
  CLOUD_PROVIDER_LOGO,
  CORE_CLOUDPROVIDER_CLOUDPROVIDERLABEL_DIRECTIVE,
  CORE_CLOUDPROVIDER_PROVIDERSELECTION_PROVIDERSELECTOR_DIRECTIVE
]);

const ACCOUNT_SELECT_WRAPPER = "spinnaker.core.account.select.wrapper";
const ngmodule$3 = module(ACCOUNT_SELECT_WRAPPER, []);
ngmodule$3.component("accountSelectWrapper", react2angular(withErrorBoundary(AccountSelectInput, "accountSelectWrapper"), [
  "accounts",
  "provider",
  "readOnly",
  "onChange",
  "value"
]));

const ACCOUNT_SELECT_COMPONENT = "spinnaker.core.account.accountSelectField.component";
module(ACCOUNT_SELECT_COMPONENT, []).component("accountSelectField", {
  template: `
        <account-select-wrapper
          ng-if="$ctrl.accounts"
          accounts="$ctrl.accounts"
          provider="$ctrl.provider"
          read-only="$ctrl.readOnly"
          on-change="$ctrl.handleSelectChanged"
          value="$ctrl.component[$ctrl.field]"
          on-change="$ctrl.fieldChanged"></account-select-wrapper>
      `,
  bindings: {
    accounts: "=",
    component: "=",
    field: "@",
    provider: "=",
    onChange: "&",
    readOnly: "="
  },
  controller: [
    "$timeout",
    function($timeout) {
      this.handleSelectChanged = (event) => {
        const value = event.target.value;
        $timeout(() => {
          this.currentValue = this.component[this.field] = value;
          this.onChange && this.onChange();
        });
      };
    }
  ]
});

var css_248z$R = ".account-tag {\n  display: inline;\n  padding: 2px 6px 3px 6px;\n  margin-right: 2px;\n  font-size: 75%;\n  text-align: center;\n  text-transform: uppercase;\n  color: var(--color-white);\n  background-color: var(--color-dovegray);\n  white-space: nowrap;\n  font-weight: 600;\n}\n.account-tag:empty {\n  display: none;\n}\n.account-tag.account-tag-prod {\n  background-color: var(--color-danger);\n}\n.heading-tag,\n.heading-tag-overflow-group {\n  display: flex;\n}\n.heading-tag .account-tag,\n.heading-tag-overflow-group .account-tag {\n  font-size: 14px;\n  font-weight: 400;\n  display: flex;\n  min-height: 36px;\n  line-height: 16px;\n  align-items: center;\n  flex: 0 0 auto;\n  padding: 0 12px;\n  margin-right: 0;\n  border-right: 1px solid var(--color-alabaster);\n}\n.heading-tag .account-tag .glyphicon,\n.heading-tag-overflow-group .account-tag .glyphicon {\n  margin-right: 3px;\n}\n.heading-tag-overflow-group {\n  pointer-events: none;\n  position: absolute;\n  display: flex;\n  flex-wrap: wrap;\n  top: 100%;\n  left: 0;\n  transition: opacity 0.2s linear;\n  opacity: 0;\n}\n.heading-tag-overflow-group.shown {\n  opacity: 1;\n}\n.heading-tag-overflow-group .account-tag {\n  border-top: 1px solid var(--color-white);\n}\n";
styleInject(css_248z$R);

class AccountTagController {
  $onInit() {
    AccountService.challengeDestructiveActions(this.account).then((isProdAccount) => {
      this.accountType = isProdAccount ? "prod" : this.account;
    });
  }
  $onChanges() {
    this.$onInit();
  }
}
const accountTagComponent = {
  bindings: {
    account: "<"
  },
  controller: AccountTagController,
  template: '<span class="account-tag account-tag-{{$ctrl.accountType}}">{{$ctrl.account}}</span>'
};
const ACCOUNT_TAG_COMPONENT = "spinnaker.core.account.accountTag";
module(ACCOUNT_TAG_COMPONENT, []).component("accountTag", accountTagComponent);

const CORE_ACCOUNT_COLLAPSIBLEACCOUNTTAG_DIRECTIVE = "spinnaker.core.account.collapsibleAccountTag.directive";
module(CORE_ACCOUNT_COLLAPSIBLEACCOUNTTAG_DIRECTIVE, []).directive("collapsibleAccountTag", function() {
  return {
    restrict: "E",
    templateUrl: "core/src/account/collapsibleAccountTag.directive.html",
    scope: {},
    bindToController: {
      account: "@",
      state: "="
    },
    controllerAs: "vm",
    controller: [
      "$scope",
      function($scope) {
        this.getIcon = () => this.state.expanded ? "down" : "right";
        const getAccountType = () => {
          AccountService.challengeDestructiveActions(this.account).then((challenge) => {
            this.accountType = challenge ? "prod" : $scope.account;
          });
        };
        $scope.$watch(() => this.account, getAccountType);
      }
    ]
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/account/collapsibleAccountTag.directive.html", `<div class="heading-tag">
  <span class="account-tag account-tag-{{vm.accountType}}">
    <span class="small glyphicon glyphicon-chevron-{{vm.getIcon()}}"></span>
    {{vm.account}}
  </span>
</div>
`);
}]);

const CORE_ACCOUNT_PROVIDERTOGGLES_DIRECTIVE = "spinnaker.core.account.providerToggle.directive";
module(CORE_ACCOUNT_PROVIDERTOGGLES_DIRECTIVE, []).directive("ifMultipleProviders", function() {
  return {
    restrict: "A",
    link: function(scope, elem) {
      AccountService.listProviders().then(function(providers) {
        if (providers && providers.length && providers.length > 1) {
          elem.show();
        } else {
          elem.hide();
        }
      });
    }
  };
}).directive("ifSingleProvider", function() {
  return {
    restrict: "A",
    link: function(scope, elem) {
      AccountService.listProviders().then(function(providers) {
        if (!providers || !providers.length || providers.length === 1) {
          elem.show();
        } else {
          elem.hide();
        }
      });
    }
  };
});

const CORE_ACCOUNT_ACCOUNT_MODULE = "spinnaker.core.account";
module(CORE_ACCOUNT_ACCOUNT_MODULE, [
  CORE_ACCOUNT_PROVIDERTOGGLES_DIRECTIVE,
  ACCOUNT_SELECT_COMPONENT,
  CORE_ACCOUNT_COLLAPSIBLEACCOUNTTAG_DIRECTIVE,
  ACCOUNT_TAG_COMPONENT,
  ACCOUNT_SELECT_WRAPPER
]);

var css_248z$Q = ".label-filter {\n  margin-right: 5px;\n}\n.label-filter .add-new {\n  margin: 10px 0 130px 0;\n}\n.label-filter-select-container {\n  display: flex;\n  margin-top: 10px;\n}\n.label-filter-select {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.label-filter-select .Select {\n  margin-bottom: 5px;\n  word-break: break-word;\n}\n.label-filter-remove {\n  display: flex;\n  align-items: center;\n}\n.label-filter-remove .link {\n  padding: 0 0 0 5px;\n}\n";
styleInject(css_248z$Q);

class LabelFilter extends React__default.Component {
  constructor() {
    super(...arguments);
    this.onAdd = () => {
      if (this.props.labelFilters.some((l) => l.key === null)) {
        return;
      }
      const newFilter = {
        key: null,
        value: null
      };
      this.props.updateLabelFilters(this.props.labelFilters.concat([newFilter]));
    };
    this.onDelete = (idx) => {
      this.props.updateLabelFilters(this.props.labelFilters.filter((_e, i) => i !== idx));
    };
    this.handleKeyChange = (option, idx) => {
      const nextLabelFilters = this.props.labelFilters.map((filter, i) => {
        if (i !== idx) {
          return filter;
        }
        return {
          key: option.value,
          value: null
        };
      });
      this.props.updateLabelFilters(nextLabelFilters);
    };
    this.handleValueChange = (option, idx) => {
      const nextLabelFilters = this.props.labelFilters.map((filter, i) => {
        if (i !== idx) {
          return filter;
        }
        return {
          key: filter.key,
          value: option.value
        };
      });
      this.props.updateLabelFilters(nextLabelFilters);
    };
    this.getKeyOptions = (idx) => {
      const allLabelKeys = Object.keys(this.props.labelsMap);
      const otherFilters = this.props.labelFilters.filter((_e, i) => i !== idx);
      const availableKeys = without(allLabelKeys, ...otherFilters.map((e) => e.key));
      return availableKeys.map((key) => ({ label: key, value: key }));
    };
    this.getValueOptions = (key) => {
      const values = get(this.props.labelsMap, key, []);
      return values.map((val) => ({ label: val, value: val }));
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "label-filter"
    }, this.props.labelFilters.map(({ key, value }, idx) => /* @__PURE__ */ React__default.createElement(LabelFilterSelect, {
      handleKeyChange: (option) => this.handleKeyChange(option, idx),
      handleValueChange: (option) => this.handleValueChange(option, idx),
      key: idx,
      keyOptions: this.getKeyOptions(idx),
      onDelete: () => this.onDelete(idx),
      selectedKey: key,
      selectedValue: value,
      valueOptions: this.getValueOptions(key)
    })), /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: "btn btn-block btn-sm add-new",
      onClick: this.onAdd
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), "Add label filter"));
  }
}
LabelFilter.defaultProps = {
  labelsMap: {},
  labelFilters: [],
  updateLabelFilters: noop
};
const LabelFilterSelect = ({
  handleKeyChange,
  handleValueChange,
  keyOptions,
  onDelete,
  selectedKey,
  selectedValue,
  valueOptions
}) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "label-filter-select-container"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "label-filter-select"
  }, /* @__PURE__ */ React__default.createElement(Select, {
    autosize: false,
    clearable: false,
    onChange: handleKeyChange,
    options: keyOptions,
    placeholder: "Select key...",
    value: selectedKey
  }), /* @__PURE__ */ React__default.createElement(Select, {
    autosize: false,
    clearable: false,
    onChange: handleValueChange,
    options: valueOptions,
    placeholder: "Select value...",
    value: selectedValue
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "label-filter-remove"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: "link",
    onClick: onDelete
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-trash"
  }))));
};

const poolValueCoordinates$3 = [
  { filterField: "providerType", on: "serverGroup", localField: "type" },
  { filterField: "account", on: "serverGroup", localField: "account" },
  { filterField: "region", on: "serverGroup", localField: "region" },
  { filterField: "availabilityZone", on: "instance", localField: "availabilityZone" },
  { filterField: "instanceType", on: "serverGroup", localField: "instanceType" }
];
const poolBuilder$3 = (serverGroups) => {
  const pool = ___default.chain(serverGroups).map((sg) => {
    const poolUnitTemplate = ___default.chain(poolValueCoordinates$3).filter({ on: "serverGroup" }).reduce((poolUnitTemplate2, coordinate) => {
      poolUnitTemplate2[coordinate.filterField] = sg[coordinate.localField];
      return poolUnitTemplate2;
    }, {}).value();
    const poolUnits = sg.instances.map((instance) => {
      const poolUnit = ___default.cloneDeep(poolUnitTemplate);
      return ___default.chain(poolValueCoordinates$3).filter({ on: "instance" }).reduce((poolUnit2, coordinate) => {
        poolUnit2[coordinate.filterField] = instance[coordinate.localField];
        return poolUnit2;
      }, poolUnit).value();
    });
    if (!poolUnits.length) {
      poolUnits.push(poolUnitTemplate);
    }
    return poolUnits;
  }).flatten().value();
  return pool;
};

const ClusterFilters = ({ app }) => {
  const { serverGroups } = app;
  const { data: serverGroupData, loaded: clustersLoaded } = useDataSource(serverGroups);
  const [tags, setTags] = React__default.useState(ClusterState.filterModel.asFilterModel.tags);
  const [sortFilter, setSortFilter] = React__default.useState(ClusterState.filterModel.asFilterModel.sortFilter);
  const [labelFilters, setLabelFilters] = React__default.useState(trueKeyObjectToLabelFilters(sortFilter.labels));
  const labelsMap = React__default.useMemo(() => buildLabelsMap(serverGroupData), [serverGroupData.length]);
  const showLabelFilter = Object.keys(labelsMap).length > 0;
  const getHeadingsForOption = (option) => compact(uniq(map$1(serverGroupData, option))).sort();
  const [headings, setHeadings] = React__default.useState({
    account: [],
    availabilityZone: [],
    category: getHeadingsForOption("category"),
    detail: ["(none)"].concat(getHeadingsForOption("detail")),
    instanceType: [],
    providerType: [],
    region: [],
    stack: ["(none)"].concat(getHeadingsForOption("stack"))
  });
  useObservable(ClusterState.filterService.groupsUpdatedStream, () => {
    setTags(ClusterState.filterModel.asFilterModel.tags);
    setSortFilter(ClusterState.filterModel.asFilterModel.sortFilter);
    setLabelFilters(trueKeyObjectToLabelFilters(ClusterState.filterModel.asFilterModel.sortFilter.labels));
  });
  useOnStateChanged((state) => {
    if (state.name.includes("clusters")) {
      ClusterState.filterModel.asFilterModel.activate();
    }
  });
  const updateClusterGroups = (applyParamsToUrl = true) => {
    const { providerType, instanceType, account, availabilityZone, region } = digestDependentFilters({
      sortFilter: ClusterState.filterModel.asFilterModel.sortFilter,
      dependencyOrder: ["providerType", "account", "region", "availabilityZone", "instanceType"],
      pool: poolBuilder$3(serverGroupData)
    });
    setHeadings({
      account,
      availabilityZone,
      category: getHeadingsForOption("category"),
      detail: ["(none)"].concat(getHeadingsForOption("detail")),
      instanceType,
      providerType,
      region,
      stack: ["(none)"].concat(getHeadingsForOption("stack"))
    });
    if (applyParamsToUrl) {
      ClusterState.filterModel.asFilterModel.applyParamsToUrl();
    }
    ClusterState.filterService.updateClusterGroups(app);
  };
  const handleLabelFiltersChange = (filters) => {
    const newSortFilter = {
      ...sortFilter,
      labels: labelFiltersToTrueKeyObject(filters)
    };
    setLabelFilters(filters);
    setSortFilter(newSortFilter);
    ClusterState.filterModel.asFilterModel.sortFilter = newSortFilter;
    updateClusterGroups();
  };
  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    const newSortFilter = {
      ...sortFilter,
      filter: searchTerm
    };
    setSortFilter(newSortFilter);
    ClusterState.filterModel.asFilterModel.sortFilter = newSortFilter;
    updateClusterGroups();
  };
  const handleStatusChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    const newSortFilter = {
      ...sortFilter,
      status: {
        ...sortFilter.status,
        [name]: Boolean(value)
      }
    };
    setSortFilter(newSortFilter);
    ClusterState.filterModel.asFilterModel.sortFilter = newSortFilter;
    updateClusterGroups();
  };
  const handleMinInstanceChange = (event) => {
    const numInstances = event.target.value;
    const min = numInstances ? parseInt(numInstances, 10) : void 0;
    const newSortFilter = {
      ...sortFilter,
      minInstances: min
    };
    setSortFilter(newSortFilter);
    ClusterState.filterModel.asFilterModel.sortFilter = newSortFilter;
    updateClusterGroups();
  };
  const handleMaxInstanceChange = (event) => {
    const numInstances = event.target.value;
    const max = numInstances ? parseInt(numInstances, 10) : void 0;
    const newSortFilter = {
      ...sortFilter,
      maxInstances: max
    };
    setSortFilter(newSortFilter);
    ClusterState.filterModel.asFilterModel.sortFilter = newSortFilter;
    updateClusterGroups();
  };
  React__default.useEffect(() => {
    if (clustersLoaded) {
      updateClusterGroups();
    }
  }, [clustersLoaded, tags.length]);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "insight-filter-content"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "heading"
  }, /* @__PURE__ */ React__default.createElement(FilterSearch, {
    helpKey: "cluster.search",
    value: sortFilter.filter,
    onBlur: handleSearchChange,
    onSearchChange: handleSearchChange
  })), clustersLoaded && /* @__PURE__ */ React__default.createElement("div", {
    className: "content"
  }, headings.providerType.length > 1 && /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-provider",
    heading: "Provider",
    expanded: true
  }, headings.providerType.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    isCloudProvider: true,
    key: heading,
    sortFilterType: sortFilter.providerType,
    onChange: updateClusterGroups
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-account",
    heading: "Account",
    expanded: true
  }, headings.account.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.account,
    onChange: updateClusterGroups
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-region",
    heading: "Region",
    expanded: true
  }, headings.region.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.region,
    onChange: updateClusterGroups
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-category",
    heading: "Category",
    expanded: true
  }, headings.category.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading: robotToHuman(heading),
    key: heading,
    sortFilterType: sortFilter.category,
    onChange: updateClusterGroups
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-stack",
    heading: "Stack",
    expanded: true
  }, headings.stack.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.stack,
    onChange: updateClusterGroups
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-detail",
    heading: "Detail",
    expanded: true
  }, headings.detail.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.detail,
    onChange: updateClusterGroups
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-status",
    heading: "Status",
    expanded: true
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form"
  }, ["Up", "Down", "Disabled", "Starting", "OutOfService", "Unknown"].map((status) => /* @__PURE__ */ React__default.createElement("div", {
    className: "checkbox",
    key: status
  }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
    key: status,
    type: "checkbox",
    checked: Boolean(sortFilter.status && sortFilter.status[status]),
    onChange: handleStatusChange,
    name: status
  }), robotToHuman(status)))))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-az",
    heading: "Availability Zones",
    expanded: true
  }, headings.availabilityZone.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.availabilityZone,
    onChange: updateClusterGroups
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-instance-types",
    heading: "Instance Types",
    expanded: true
  }, headings.instanceType.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.instanceType,
    onChange: updateClusterGroups
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-instance-count",
    heading: "Instance Count",
    expanded: true
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-inline"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, "Min:  ", /* @__PURE__ */ React__default.createElement("input", {
    type: "number",
    className: "form-control input-sm",
    value: sortFilter.minInstances || "",
    onChange: handleMinInstanceChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, "Max:  ", /* @__PURE__ */ React__default.createElement("input", {
    type: "number",
    className: "form-control input-sm",
    value: sortFilter.maxInstances || "",
    onChange: handleMaxInstanceChange
  })))), showLabelFilter && /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-label",
    heading: "Labels",
    expanded: true
  }, /* @__PURE__ */ React__default.createElement(LabelFilter, {
    labelsMap,
    labelFilters,
    updateLabelFilters: handleLabelFiltersChange
  }))));
};

const CLUSTER_FILTER = "spinnaker.core.cluster.filter.component";
module(CLUSTER_FILTER, []).component("clusterFilter", react2angular(withErrorBoundary(ClusterFilters, "clusterFilter"), ["app"]));

const FILTER_TAGS_COMPONENT = "spinnaker.core.filterModel.filterTags.component";
module(FILTER_TAGS_COMPONENT, []).component("filterTags", react2angular(withErrorBoundary(FilterTags, "filterTags"), ["tags", "tagCleared", "clearFilters"]));

class WaypointService {
  static registerWaypointContainer(elementScope, element, key, offset) {
    this.waypointRegistry[key] = this.waypointRegistry[key] || Object.create(null);
    this.waypointRegistry[key].container = element;
    this.waypointRegistry[key].offset = offset;
    this.enableWaypointEvent(element, key);
    if (elementScope) {
      elementScope.$on("$destroy", () => {
        this.disableWaypointEvent(key);
      });
    }
  }
  static enableWaypointEvent(element, key) {
    const registryEntry = this.waypointRegistry[key];
    if (!registryEntry.scrollEnabled) {
      element.bind("scroll.waypointEvents resize.waypointEvents", throttle(() => {
        $timeout(() => {
          const containerRect = element.get(0).getBoundingClientRect();
          const topThreshold = containerRect.top + registryEntry.offset;
          const waypoints = element.find("[waypoint]");
          const lastTop = this.waypointRegistry[key].top;
          const newTop = element.get(0).scrollTop;
          const inView = [];
          waypoints.each((_index, waypoint) => {
            const waypointRect = waypoint.getBoundingClientRect();
            if (waypointRect.bottom >= topThreshold && waypointRect.top <= containerRect.bottom) {
              inView.push({ top: waypointRect.top, elem: waypoint.getAttribute("waypoint") });
            }
          });
          this.waypointRegistry[key] = {
            lastWindow: sortBy(inView, "top"),
            top: newTop,
            direction: lastTop > newTop ? "up" : "down"
          };
          if (this.waypointRegistry[key].lastWindow.length) {
            $rootScope.$broadcast("waypoints-changed", this.waypointRegistry[key]);
          }
        });
      }, 200));
      registryEntry.scrollEnabled = true;
    }
  }
  static disableWaypointEvent(key) {
    const registry = this.waypointRegistry[key];
    if (registry && registry.container) {
      registry.container.unbind("scroll.waypointEvents resize.waypointEvents");
      registry.scrollEnabled = false;
      registry.container = null;
    }
  }
}
WaypointService.waypointRegistry = Object.create(null);

const CORE_UTILS_WAYPOINTS_WAYPOINTCONTAINER_DIRECTIVE = "spinnaker.core.utils.waypoints.container.directive";
module(CORE_UTILS_WAYPOINTS_WAYPOINTCONTAINER_DIRECTIVE, []).directive("waypointContainer", function() {
  return {
    restrict: "A",
    scope: {
      key: "@waypointContainerKey",
      offsetHeight: "=waypointOffset"
    },
    link: {
      post: function(scope, elem) {
        const offset = scope.offsetHeight || 0;
        WaypointService.registerWaypointContainer(scope, elem, scope.key, offset);
      }
    }
  };
});

var css_248z$P = ".server-group input[type='checkbox'] {\n  font-size: 200%;\n  margin: 0;\n}\n.server-group .server-group-title input {\n  margin: 0 5px 3px 0;\n}\n.rollup h4 {\n  text-transform: uppercase;\n  font-weight: 600;\n  background-color: var(--color-alabaster);\n  margin: 0;\n  padding: 10px 0;\n}\n.row.rollup-entry {\n  padding: 0;\n  margin: 0 0 23px 0;\n}\n.row.rollup-entry:last-child {\n  padding-bottom: 5px;\n}\n.row.rollup-entry.disabled {\n  opacity: 0.4;\n  border: 1px dashed var(--color-titanium);\n}\n.row.rollup-entry.disabled:hover,\n.row.rollup-entry.disabled.active {\n  opacity: 0.75;\n}\n.row.rollup-entry .glyphicon-th,\n.row.rollup-entry .glyphicon-th-large {\n  color: var(--color-success);\n}\n.row.rollup-entry.unhealthy {\n  border-style: dashed;\n}\n.instance-list {\n  clear: both;\n  padding: 0 10px 0 31px;\n}\ntable.instances {\n  table-layout: fixed;\n  display: table;\n}\ntable.instances td {\n  word-break: break-all;\n}\n.instances {\n  border: none;\n  line-height: 10px;\n  border-radius: 2px;\n  padding-bottom: 5px;\n}\n.instances td:first-child,\n.instances th:first-child {\n  padding-left: 0;\n}\n.instances .instance-group-Starting {\n  -webkit-animation: pulse 1s steps(12) infinite;\n  animation: pulse 1s steps(12) infinite;\n}\n.instances .instance-group-Starting:hover {\n  -webkit-animation: none;\n          animation: none;\n}\n.instances a.instance {\n  margin: 0;\n  display: inline-block;\n  width: 12px;\n  border-right: 1px solid var(--color-white);\n  border-bottom: 1px solid var(--color-white);\n  height: 18px;\n  background-color: var(--color-success-light);\n}\n.instances a.instance.health-status-Up {\n  background-color: var(--color-success-light);\n}\n.instances a.instance.health-status-Down,\n.instances a.instance.health-status-Failed {\n  background-color: var(--color-danger);\n}\n.instances a.instance.health-status-OutOfService {\n  background-color: var(--color-concrete);\n}\n.instances a.instance.health-status-Unknown {\n  background-color: var(--color-accent-g1);\n}\n.instances a.instance.health-status-Starting {\n  background-color: var(--color-accent-g1);\n}\n.instances a.instance:hover,\n.instances a.instance.active,\n.instances a.instance.highlighted {\n  border: none;\n  box-shadow: 0 0 3px 1px var(--color-concrete), inset 0 0 0 1px var(--color-mineshaft);\n  z-index: 2;\n}\n.instances a.instance.active.health-status-Up {\n  background-color: var(--color-success);\n}\n.instances a.instance.active.health-status-Down,\n.instances a.instance.active.health-status-Failed {\n  background-color: var(--color-danger);\n}\n.instances a.instance.active.health-status-OutOfService {\n  background-color: var(--color-dovegray);\n  border-color: var(--color-mineshaft);\n}\n.instances a.instance.active.health-status-Unknown,\n.instances a.instance.active.health-status-Starting {\n  background-color: var(--color-accent);\n}\n.rollup-summary {\n  font-size: 110%;\n  margin: 0;\n  width: 100%;\n  display: flex;\n}\n.rollup-summary .remove-button {\n  display: flex;\n  flex: 0 0 auto;\n  padding: 0 5px;\n  margin-left: 2px;\n  text-align: center;\n  background-color: var(--color-accent-g2);\n}\n.rollup-summary .remove-button button {\n  margin-right: 0;\n}\n.rollup-summary .tooltip {\n  text-transform: none;\n}\n.rollup-summary button {\n  padding: 0;\n  display: inline-block;\n  margin-right: 5px;\n  line-height: 1;\n}\n.rollup-summary button.active,\n.rollup-summary button:focus {\n  outline: 0;\n  box-shadow: none;\n}\n.rollup-summary button .icon {\n  position: relative;\n  font-size: 120%;\n}\n.rollup-summary button .icon-spinner {\n  font-size: 20px;\n}\n.rollup-title-cell {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  height: 36px;\n  line-height: 36px;\n  font-size: 16px;\n  color: var(--color-primary);\n}\n.rollup-title-cell .pod-center {\n  min-width: 0;\n  background-color: var(--color-accent-g2);\n  padding: 0 10px;\n  border-right: 1px solid var(--color-alabaster);\n  border-left: 1px solid var(--color-alabaster);\n  font-weight: 600;\n}\n.rollup-title-cell .pod-center > div {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n.rollup-title-cell .pod-center.no-right-padding {\n  padding-right: 0;\n}\n.rollup-title-cell .health-counts {\n  flex: 0 0 auto;\n  background-color: var(--color-cirrus);\n  padding: 0 10px;\n  border-left: 1px solid var(--color-alabaster);\n}\n.rollup-title-cell:active,\n.rollup-title-cell:hover,\n.rollup-title-cell:focus {\n  text-decoration: none;\n}\n@media (min-width: 768px) and (max-width: 992px) {\n  .rollup-title-cell {\n    font-size: 85%;\n  }\n}\n.rollup-title-cell .instance-health-counts {\n  padding-right: 10px;\n}\nrunning-tasks-tag {\n  margin-right: 10px;\n}\nrunning-tasks-tag .icon-spinner {\n  color: var(--color-accent);\n}\n.popover.menu-running-tasks {\n  border: 1px solid var(--color-dovegray);\n  text-transform: none;\n  color: var(--color-mineshaft);\n  font-weight: 400;\n  font-size: 80%;\n  border-radius: 0;\n}\n.popover.menu-running-tasks.bottom .arrow {\n  border-bottom-color: var(--color-dovegray);\n}\n.popover.menu-running-tasks .popover-content {\n  max-height: 350px;\n  overflow-y: scroll;\n}\n.menu-load-balancers {\n  min-width: 150px;\n}\n.menu-load-balancers.popover.bottom div.arrow:after {\n  border-bottom-color: var(--color-dovegray);\n}\n.menu-load-balancers .popover-title {\n  background-color: var(--color-dovegray);\n  color: var(--color-white);\n}\n.menu-load-balancers .menu-load-balancers-header {\n  font-weight: 600;\n  color: var(--color-cirrus);\n  background-color: var(--color-dovegray);\n}\n.menu-load-balancers .menu-load-balancers-header,\n.menu-load-balancers a {\n  text-transform: none;\n  font-size: 82.5%;\n  padding: 5px 10px;\n  display: block;\n}\n.menu-load-balancers a {\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--color-alto);\n  white-space: nowrap;\n}\n.menu-load-balancers a .health-counts {\n  margin-left: 5px;\n}\n.menu-load-balancers a .health-counts .instance-health-counts {\n  float: none !important;\n}\n.menu-load-balancers a:last-child {\n  border-bottom-width: 0;\n}\n.menu-load-balancers a:hover,\n.menu-load-balancers a:focus {\n  background-color: var(--color-cirrus);\n  text-decoration: none;\n}\n.menu-load-balancers a:focus {\n  padding-left: 15px;\n  padding-right: 5px;\n}\n.load-balancers-tag,\n.server-group-manager-tag {\n  text-align: right;\n  margin-right: 3px;\n}\n.load-balancers-tag.overflowing,\n.server-group-manager-tag.overflowing {\n  position: relative;\n}\n.load-balancers-tag .btn-load-balancer button,\n.server-group-manager-tag .btn-load-balancer button,\n.load-balancers-tag .btn-multiple-load-balancers,\n.server-group-manager-tag .btn-multiple-load-balancers {\n  margin-top: -5px;\n}\n.load-balancers-tag .btn-server-group-manager,\n.server-group-manager-tag .btn-server-group-manager {\n  margin-top: -2px;\n}\n.load-balancers-tag:hover,\n.server-group-manager-tag:hover {\n  text-decoration: none;\n}\n.load-balancers-tag .icon,\n.server-group-manager-tag .icon {\n  width: 30px;\n}\n.load-balancers-tag .icon-sitemap,\n.server-group-manager-tag .icon-sitemap {\n  height: 14px;\n  width: 14px;\n}\n.load-balancers-tag .badge-counter,\n.server-group-manager-tag .badge-counter {\n  color: var(--color-text-link);\n  background-color: var(--color-white);\n  border: 1px solid var(--color-accent);\n  right: 0;\n  font-size: 100%;\n  padding: 1px 4px;\n  border-radius: 4px;\n}\n.load-balancers-tag span,\n.server-group-manager-tag span {\n  position: relative;\n}\n.server-group-manager-tag .badge-counter {\n  margin-top: -5px;\n  height: 19px;\n}\n.server-group-manager-tag .badge-counter .fa-server {\n  padding: 1px 0;\n}\n.rollup-details {\n  background-color: var(--color-alabaster);\n  padding: 0;\n}\n.rollup-details .section-title {\n  margin-bottom: 3px;\n}\n.rollup-details .section-title span {\n  font-size: 13px;\n}\n.rollup-details .clickable-row {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-alto);\n  margin: 5px 15px 3px;\n  position: relative;\n  z-index: 1;\n}\n.rollup-details .clickable-row.active {\n  border-color: var(--color-accent-g1);\n  background-color: var(--color-accent-g3);\n}\n.rollup-details .clickable-row:hover {\n  border-color: var(--color-accent-g1);\n  box-shadow: 0 0 4px 2px var(--color-accent-g1);\n  z-index: 2;\n}\n.rollup-details .clickable-row.managed {\n  margin: 5px;\n  border-style: dashed;\n}\n.rollup-details .permalinks {\n  font-size: 80%;\n}\n.rollup-details .pod-subgroup h6 {\n  text-transform: uppercase;\n  margin: 0;\n  padding: 10px 10px 5px;\n  background-color: var(--color-alabaster);\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group .server-group-title {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group.running {\n  background-color: var(--color-alabaster);\n  -webkit-animation: pulse 1s steps(12) infinite;\n  animation: pulse 1s steps(12) infinite;\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group.running .server-group-title {\n  background-color: var(--color-alabaster);\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group.failed {\n  background-color: var(--color-cirrus);\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group.failed .server-group-title {\n  background-color: var(--color-cirrus);\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group.succeeded {\n  background-color: var(--color-accent-g3);\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group.succeeded .server-group-title {\n  background-color: var(--color-accent-g3);\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group.active {\n  border-color: var(--color-accent-g1);\n  background-color: var(--color-accent-g3);\n}\n.rollup-details .pod-subgroup .rollup-pod-server-group.active .server-group-title {\n  background-color: var(--color-accent-g3);\n}\n.rollup-details .pod-subgroup .table {\n  margin-top: -5px;\n  margin-bottom: 10px;\n  font-size: 90%;\n}\n.rollup-details .pod-subgroup .table th,\n.rollup-details .pod-subgroup .table td {\n  padding: 5px 1px;\n}\n.rollup-details h5,\n.rollup-details h6 {\n  font-weight: 600;\n  margin-bottom: 5px;\n  font-size: 110%;\n}\n.rollup-details .badge-disabled {\n  float: right !important;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding-left: 10px;\n}\n.rollup-details .rollup-details-section {\n  border-right: 1px solid var(--color-silver);\n  padding: 10px;\n}\n.rollup-details .rollup-details-section:last-child {\n  border-right-width: 0;\n}\n.rollup-details .rollup-details-section .rollup-row {\n  padding: 0;\n}\n.rollup-details .rollup-row {\n  padding: 10px;\n}\n.rollup-details .rollup-row:first-child {\n  border-top-width: 0;\n}\n.rollup-details .disabled {\n  opacity: 1;\n}\n.rollup-details .disabled .section-title,\n.rollup-details .disabled .health-counts,\n.rollup-details .disabled .load-balancers-tag .badge,\n.rollup-details .disabled .instances {\n  opacity: 0.4;\n}\n.rollup-details .disabled:hover .section-title,\n.rollup-details .disabled:hover .health-counts,\n.rollup-details .disabled:hover .load-balancers-tag .badge,\n.rollup-details .disabled:hover .instances {\n  opacity: 0.7;\n}\n.instances {\n  display: block;\n}\n.row .rollup-summary:hover {\n  box-shadow: none;\n}\n.row .server-group-sequence {\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-left: 2px;\n}\n.row .build-link {\n  margin-left: 3px;\n}\n.row .server-group-title,\n.row .subgroup-title {\n  padding: 5px 10px 2px;\n  border-bottom-width: 0;\n}\n.row .server-group-title.clickable:hover,\n.row .subgroup-title.clickable:hover,\n.row .server-group-title.clickable.active,\n.row .subgroup-title.clickable.active {\n  background-color: var(--color-cirrus);\n}\n";
styleInject(css_248z$P);

const CORE_CLUSTER_ALLCLUSTERS_CONTROLLER = "spinnaker.core.cluster.allClusters.controller";
module(CORE_CLUSTER_ALLCLUSTERS_CONTROLLER, [
  CLUSTER_FILTER,
  CORE_ACCOUNT_ACCOUNT_MODULE,
  SERVER_GROUP_COMMAND_BUILDER_SERVICE,
  FILTER_TAGS_COMPONENT,
  CORE_UTILS_WAYPOINTS_WAYPOINTCONTAINER_DIRECTIVE,
  ANGULAR_UI_BOOTSTRAP
]).controller("AllClustersCtrl", [
  "$scope",
  "app",
  "$uibModal",
  "$timeout",
  "insightFilterStateModel",
  "serverGroupCommandBuilder",
  function($scope, app, $uibModal, $timeout, insightFilterStateModel, serverGroupCommandBuilder) {
    this.$onInit = () => {
      const groupsUpdatedSubscription = ClusterState.filterService.groupsUpdatedStream.subscribe(() => clusterGroupsUpdated());
      this.application = app;
      ClusterState.filterModel.activate();
      this.initialized = false;
      this.dataSource = app.getDataSource("serverGroups");
      $scope.filterModel = ClusterState.filterModel;
      ProviderSelectionService.isDisabled(app).then((disabled) => {
        $scope.isDisabled = disabled;
      });
      this.createLabel = "Create Server Group";
      app.getDataSource("serverGroups").ready().then(() => {
        insightFilterStateModel.filtersHidden = Boolean(this.dataSource.fetchOnDemand);
        updateClusterGroups();
      }, () => this.clustersLoadError());
      app.setActiveState(app.serverGroups);
      app.serverGroups.onRefresh($scope, updateClusterGroups);
      $scope.$on("$destroy", () => {
        app.setActiveState();
        ClusterState.multiselectModel.clearAll();
        insightFilterStateModel.filtersHidden = false;
        groupsUpdatedSubscription.unsubscribe();
      });
    };
    const updateClusterGroups = () => {
      if (app.getDataSource("serverGroups").fetchOnDemand) {
        insightFilterStateModel.filtersHidden = true;
      }
      ClusterState.filterService.updateClusterGroups(app);
      clusterGroupsUpdated();
      $timeout(() => {
        this.initialized = true;
      }, 50);
    };
    const clusterGroupsUpdated = () => {
      $scope.$applyAsync(() => {
        $scope.groups = ClusterState.filterModel.groups;
        $scope.tags = ClusterState.filterModel.tags;
      });
    };
    this.toggleMultiselect = () => {
      ClusterState.filterModel.sortFilter.multiselect = !ClusterState.filterModel.sortFilter.multiselect;
      ClusterState.multiselectModel.syncNavigation();
      updateClusterGroups();
    };
    this.syncUrlAndUpdateClusterGroups = () => {
      ClusterState.filterModel.applyParamsToUrl();
      this.updateClusterGroups();
    };
    this.clearFilters = function() {
      ClusterState.filterService.clearFilters();
      updateClusterGroups();
    };
    this.createServerGroup = function createServerGroup() {
      ProviderSelectionService.selectProvider(app, "serverGroup").then(function(provider) {
        serverGroupCommandBuilder.buildNewServerGroupCommand(app, provider, null).then((command) => {
          const providerConfig = CloudProviderRegistry.getValue(provider, "serverGroup");
          const title = "Create New Server Group";
          const serverGroup = null;
          if (providerConfig.CloneServerGroupModal) {
            providerConfig.CloneServerGroupModal.show({
              title,
              application: app,
              serverGroup,
              command,
              provider,
              isNew: true
            });
          } else {
            $uibModal.open({
              templateUrl: providerConfig.cloneServerGroupTemplateUrl,
              controller: `${providerConfig.cloneServerGroupController} as ctrl`,
              windowClass: "modal-z-index",
              size: "lg",
              resolve: {
                title: () => title,
                application: () => app,
                serverGroup: () => serverGroup,
                serverGroupCommand: () => command,
                provider: () => provider
              }
            });
          }
        });
      }).catch(noop);
    };
    this.updateClusterGroups = ___default.debounce(updateClusterGroups, 200);
    this.clustersLoadError = () => {
      this.loadError = true;
      this.initialized = true;
    };
  }
]);

const ServerGroupManagerHeading = ({
  onClick,
  health,
  provider,
  heading,
  grouping,
  app
}) => {
  const showEntityTags = SETTINGS.feature && SETTINGS.feature.entityTags;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: `flex-container-h baseline server-group-title`,
    onClick
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h baseline section-title"
  }, /* @__PURE__ */ React__default.createElement(CloudProviderLogo, {
    provider,
    height: "16px",
    width: "16px"
  }), heading), showEntityTags && /* @__PURE__ */ React__default.createElement(EntityNotifications, {
    entity: grouping,
    application: app,
    placement: "bottom",
    hOffsetPercent: "90%",
    entityType: "serverGroupManager",
    pageLocation: "details",
    onUpdate: () => app.serverGroupManagers.refresh()
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h baseline flex-pull-right"
  }, /* @__PURE__ */ React__default.createElement(HealthCounts, {
    container: health
  })));
};

class ServerGroupManager extends React__default.Component {
  constructor() {
    super(...arguments);
    this.isSelected = () => {
      const { manager, serverGroups } = this.props;
      const params = {
        accountId: serverGroups[0].account,
        region: serverGroups[0].region,
        provider: serverGroups[0].cloudProvider,
        serverGroupManager: manager
      };
      return ReactInjector.$state.includes("**.serverGroupManager", params);
    };
    this.handleClick = (e) => {
      const { manager, serverGroups } = this.props;
      const nextState = ReactInjector.$state.current.name.endsWith(".clusters") ? ".serverGroupManager" : "^.serverGroupManager";
      e.preventDefault();
      e.stopPropagation();
      ReactInjector.$state.go(nextState, {
        accountId: serverGroups[0].account,
        region: serverGroups[0].region,
        provider: serverGroups[0].cloudProvider,
        serverGroupManager: manager
      });
    };
    this.buildHealthCounts = () => {
      const { serverGroups } = this.props;
      const pick = (key) => (total, serverGroup) => total + serverGroup.instanceCounts[key];
      return {
        up: serverGroups.reduce(pick("up"), 0),
        down: serverGroups.reduce(pick("down"), 0),
        starting: serverGroups.reduce(pick("starting"), 0),
        succeeded: serverGroups.reduce(pick("succeeded"), 0),
        failed: serverGroups.reduce(pick("failed"), 0),
        unknown: serverGroups.reduce(pick("unknown"), 0),
        outOfService: serverGroups.reduce(pick("outOfService"), 0)
      };
    };
  }
  render() {
    const { application, sortFilter, grouping, serverGroups, manager } = this.props;
    const classes = {
      active: this.isSelected(),
      clickable: true,
      "clickable-row": true,
      "rollup-details": true
    };
    return /* @__PURE__ */ React__default.createElement("div", {
      className: classNames(classes)
    }, /* @__PURE__ */ React__default.createElement(ServerGroupManagerHeading, {
      onClick: this.handleClick,
      health: this.buildHealthCounts(),
      provider: serverGroups[0].type,
      heading: manager,
      grouping,
      app: application
    }), serverGroups.map((sg) => /* @__PURE__ */ React__default.createElement(ServerGroup$1, {
      key: sg.name,
      serverGroup: sg,
      cluster: sg.cluster,
      application,
      sortFilter,
      hasDiscovery: grouping.hasDiscovery,
      hasLoadBalancers: grouping.hasLoadBalancers,
      hasManager: true
    })));
  }
}

class ClusterPod extends React__default.Component {
  constructor(props) {
    super(props);
    this.close = () => {
      const { parentHeading, grouping, application } = this.props;
      delete ClusterState.filterModel.asFilterModel.sortFilter.clusters[`${parentHeading}:${grouping.heading}`];
      ClusterState.filterModel.asFilterModel.applyParamsToUrl();
      application.getDataSource("serverGroups").refresh();
    };
    this.renderSubGroup = (subgroup) => {
      const { grouping, application, sortFilter } = this.props;
      const hasMoniker = subgroup.serverGroups.every((sg) => {
        return !!sg.moniker;
      });
      let iteratee;
      if (hasMoniker) {
        iteratee = "moniker.sequence";
      } else {
        iteratee = "name";
      }
      const sortedServerGroups = orderBy(subgroup.serverGroups, [iteratee], ["desc"]);
      const [managedServerGroups, standaloneServerGroups] = partition(sortedServerGroups, (group) => group.serverGroupManagers && group.serverGroupManagers.length);
      const serverGroupManagers = groupBy(managedServerGroups, (serverGroup) => serverGroup.serverGroupManagers[0].name);
      const showManagedIndicator = !grouping.isManaged && subgroup.isManaged;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "pod-subgroup",
        key: subgroup.key
      }, /* @__PURE__ */ React__default.createElement("h6", {
        className: "sticky-header-2 subgroup-title horizontal middle"
      }, /* @__PURE__ */ React__default.createElement("div", null, subgroup.heading), /* @__PURE__ */ React__default.createElement("div", {
        className: classNames("flex-container-h middle", { "sp-margin-xs-left": showManagedIndicator })
      }, showManagedIndicator && /* @__PURE__ */ React__default.createElement(ManagedResourceStatusIndicator, {
        shape: "circle",
        resourceSummary: subgroup.managedResourceSummary,
        application
      }), /* @__PURE__ */ React__default.createElement(EntityNotifications, {
        entity: subgroup,
        application,
        placement: "top",
        hOffsetPercent: "20%",
        entityType: "cluster",
        pageLocation: "pod",
        onUpdate: () => application.serverGroups.refresh()
      }))), map$1(serverGroupManagers, (serverGroups, manager) => /* @__PURE__ */ React__default.createElement(ServerGroupManager, {
        key: manager,
        manager,
        grouping,
        serverGroups,
        application,
        sortFilter
      })), grouping.cluster.category === "serverGroup" && standaloneServerGroups.map((serverGroup) => /* @__PURE__ */ React__default.createElement(ServerGroup$1, {
        key: serverGroup.name,
        serverGroup,
        cluster: serverGroup.cluster,
        application,
        sortFilter,
        hasDiscovery: grouping.hasDiscovery,
        hasLoadBalancers: grouping.hasLoadBalancers
      })));
    };
    this.state = {
      showCloseButton: props.application.getDataSource("serverGroups").fetchOnDemand
    };
  }
  render() {
    const { grouping } = this.props;
    const { showCloseButton } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row rollup-entry sub-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "sticky-header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-summary"
    }, /* @__PURE__ */ React__default.createElement(ClusterPodTitleWrapper, {
      ...this.props
    }), showCloseButton && /* @__PURE__ */ React__default.createElement("div", {
      className: "remove-button"
    }, /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Remove cluster from view"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-link",
      onClick: this.close
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-remove"
    })))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-details"
    }, grouping.subgroups.map(this.renderSubGroup)));
  }
}

var __defProp$c = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __decorateClass$c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$c(target, key, result);
  return result;
};
let AllClustersGroupings = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.clusterFilterService = ClusterState.filterService;
    this.clusterFilterModel = ClusterState.filterModel;
    this.handleWindowResize = () => {
      this.cellCache.clearAll();
    };
    this.handleRouteChange = (stateChange) => {
      const { to } = stateChange;
      if (to.name === "home.applications.application.insight.clusters.instanceDetails" || to.name === "home.applications.application.insight.clusters") {
        this.cellCache.clearAll();
      }
    };
    this.scrollToRow = () => {
      const { $stateParams } = ReactInjector;
      this.clusterFilterService.groupsUpdatedStream.pipe(take(1)).subscribe(() => {
        const scrollToRow = this.state.groups.findIndex((group) => group.subgroups.some((subgroup) => subgroup.serverGroups.some((sg) => sg.account === $stateParams.accountId && sg.name === $stateParams.serverGroup && sg.region === $stateParams.region)));
        if (scrollToRow >= 0) {
          this.listRef.scrollToRow(scrollToRow);
        }
      });
    };
    this.renderRow = (props) => {
      const { app } = this.props;
      const { groups = [], sortFilter } = this.state;
      const group = groups[props.index];
      const parent = props.parent;
      return /* @__PURE__ */ React__default.createElement(CellMeasurer, {
        cache: this.cellCache,
        key: props.key,
        rowIndex: props.index,
        parent
      }, /* @__PURE__ */ React__default.createElement("div", {
        key: props.index,
        style: props.style
      }, /* @__PURE__ */ React__default.createElement(ClusterPod, {
        grouping: group,
        application: app,
        parentHeading: group.cluster.serverGroups[0].account,
        sortFilter
      })));
    };
    this.noRowsRender = () => {
      const dataSource = this.props.app.getDataSource("serverGroups");
      if (!this.props.initialized || dataSource.loadFailure) {
        return null;
      }
      if (!dataSource.data.length && !dataSource.fetchOnDemand) {
        return /* @__PURE__ */ React__default.createElement("h4", {
          className: "text-center"
        }, "No server groups found in this application");
      }
      if (this.props.app.getDataSource("serverGroups").fetchOnDemand) {
        const filtered = Object.keys(this.state.sortFilter.clusters).length;
        if (!filtered) {
          return null;
        }
      }
      return /* @__PURE__ */ React__default.createElement("h4", {
        className: "text-center"
      }, "No server groups match the filters you've selected");
    };
    this.setListRef = (listRef) => {
      this.listRef = listRef;
    };
    this.cellCache = new CellMeasurerCache({
      fixedWidth: true,
      minHeight: 100,
      defaultHeight: 177,
      keyMapper: (rowIndex) => {
        const group = this.state.groups[rowIndex];
        const instanceCountKeys = [];
        const countInstances = this.clusterFilterModel.asFilterModel.sortFilter.showAllInstances;
        group.subgroups.forEach((subGroup) => {
          const subKeys = [];
          subGroup.serverGroups.forEach((serverGroup) => {
            subKeys.push(countInstances ? serverGroup.instances.length : 0);
          });
          instanceCountKeys.push(subKeys.sort().join(","));
        });
        const instanceCountKey = instanceCountKeys.sort().join("; ");
        if (this.clusterFilterModel.asFilterModel.sortFilter.listInstances) {
          return `${group.key}: ${instanceCountKey}`;
        }
        return instanceCountKey;
      }
    });
    this.state = {
      groups: this.clusterFilterModel.asFilterModel.groups.reduce((a, b) => a.concat(b.subgroups), []),
      sortFilter: this.clusterFilterModel.asFilterModel.sortFilter
    };
  }
  componentDidMount() {
    window.addEventListener("resize", this.handleWindowResize);
    const onGroupsChanged = (groups) => {
      this.setState({ groups: groups.reduce((a, b) => a.concat(b.subgroups), []) }, () => this.listRef && this.listRef.recomputeRowHeights(0));
    };
    this.groupsSubscription = this.clusterFilterService.groupsUpdatedStream.subscribe(onGroupsChanged);
    this.routeChangedSubscription = ReactInjector.stateEvents.stateChangeSuccess.subscribe(this.handleRouteChange);
    const getSortFilter = () => this.clusterFilterModel.asFilterModel.sortFilter;
    const onFilterChanged = ({ ...sortFilter }) => {
      const shouldResetCache = sortFilter.listInstances !== this.state.sortFilter.listInstances;
      this.setState({ sortFilter }, () => shouldResetCache && this.cellCache.clearAll());
    };
    this.unwatchSortFilter = ReactInjector.$rootScope.$watch(getSortFilter, onFilterChanged, true);
    this.scrollToRow();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize);
    this.groupsSubscription.unsubscribe();
    this.routeChangedSubscription.unsubscribe();
    this.unwatchSortFilter();
  }
  render() {
    const { groups = [] } = this.state;
    return /* @__PURE__ */ React__default.createElement(AutoSizer, null, ({ width, height }) => /* @__PURE__ */ React__default.createElement(List, {
      ref: this.setListRef,
      className: "rollup",
      height,
      width,
      rowCount: groups.length,
      deferredMeasurementCache: this.cellCache,
      rowHeight: this.cellCache.rowHeight,
      rowRenderer: this.renderRow,
      noRowsRenderer: this.noRowsRender,
      scrollToAlignment: "start",
      overscanRowCount: 3,
      containerStyle: { overflow: "visible" }
    }));
  }
};
AllClustersGroupings = __decorateClass$c([
  UIRouterContext
], AllClustersGroupings);

const CLUSTER_ALLCLUSTERSGROUPINGS = "core.cluster.allclustergroupings";
module(CLUSTER_ALLCLUSTERSGROUPINGS, []).component("allClustersGroupings", react2angular(withErrorBoundary(AllClustersGroupings, "allClustersGroupings"), ["app", "initialized"]));

class ClustersSearchResultType extends SearchResultType {
  constructor() {
    super(...arguments);
    this.id = "clusters";
    this.order = 2;
    this.displayName = "Clusters";
    this.iconClass = "fa fa-th";
    this.cols = {
      CLUSTER: { key: "cluster", label: "Name" },
      ACCOUNT: { key: "account" }
    };
    this.TabComponent = DefaultSearchResultTab;
    this.HeaderComponent = () => /* @__PURE__ */ React__default.createElement(SearchTableHeader, null, /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.CLUSTER
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.ACCOUNT
    }));
    this.DataComponent = ({ resultSet }) => {
      const itemKeyFn = (item) => `${item.account}-${item.cluster}`;
      const itemSortFn = (a, b) => a.cluster.localeCompare(b.cluster);
      const results = resultSet.results.slice().sort(itemSortFn);
      return /* @__PURE__ */ React__default.createElement(SearchTableBody, null, results.map((item) => /* @__PURE__ */ React__default.createElement(SearchTableRow, {
        key: itemKeyFn(item)
      }, /* @__PURE__ */ React__default.createElement(HrefCell, {
        item,
        col: this.cols.CLUSTER
      }), /* @__PURE__ */ React__default.createElement(AccountCell, {
        item,
        col: this.cols.ACCOUNT
      }))));
    };
  }
  makeSearchResult(serverGroup) {
    const type = this.id;
    const urlBuilder = Registry.urlBuilder.getBuilder(type);
    const input = { type, ...serverGroup };
    const href = urlBuilder.build(input, ReactInjector.$state);
    const { account, application, cluster, provider, stack } = serverGroup;
    return { account, application, cluster, provider, stack, displayName: cluster, href, type };
  }
  search(_params, otherResults) {
    return otherResults.pipe(filter((resultSet) => resultSet.type.id === "serverGroups"), first(), map((resultSet) => {
      const { status, results, error } = resultSet;
      if (status === SearchStatus.ERROR) {
        throw error;
      }
      const serverGroups = results;
      const searchResults = serverGroups.map((sg) => this.makeSearchResult(sg));
      const clusters = uniqBy(searchResults, (sg) => `${sg.account}-${sg.cluster}`);
      return { results: clusters };
    }));
  }
  displayFormatter(searchResult) {
    return searchResult.cluster;
  }
}
searchResultTypeRegistry.register(new ClustersSearchResultType());

var css_248z$O = "on-demand-cluster-picker {\n  display: block;\n  margin-bottom: 20px;\n}\non-demand-cluster-picker .dropdown-menu {\n  max-height: 50vh;\n  overflow-y: auto;\n}\n";
styleInject(css_248z$O);

class OnDemandClusterPickerController {
  constructor($scope) {
    this.$scope = $scope;
    this.optionTemplate = "core/src/cluster/onDemand/onDemandOptionTemplate.html";
  }
  $onInit() {
    this.setAvailableClusters();
    this.application.getDataSource("serverGroups").onRefresh(this.$scope, () => this.setAvailableClusters());
  }
  setAvailableClusters() {
    this.totalClusterCount = this.application.getDataSource("serverGroups").clusters.length;
    const selectedClusters = Object.keys(ClusterState.filterModel.asFilterModel.sortFilter.clusters);
    this.availableClusters = this.application.getDataSource("serverGroups").clusters.filter((cluster) => !selectedClusters.includes(this.makeKey(cluster)));
  }
  selectCluster(cluster) {
    this.lastSelection = void 0;
    ClusterState.filterModel.asFilterModel.sortFilter.clusters[this.makeKey(cluster)] = true;
    ClusterState.filterModel.asFilterModel.applyParamsToUrl();
    this.application.getDataSource("serverGroups").refresh();
  }
  makeKey(cluster) {
    return `${cluster.account}:${cluster.name}`;
  }
}
OnDemandClusterPickerController.$inject = ["$scope"];
const template = `
    <h4>{{$ctrl.totalClusterCount}} clusters found in this application</h4>
    <p><strong>Not all clusters are shown.</strong> Select or enter a cluster name below to view:</p>
    <input type="text"
           class="form-control"
           placeholder="Enter cluster name here"
           ng-model="$ctrl.lastSelection"
           uib-typeahead="cluster for cluster in $ctrl.availableClusters | filter: $viewValue | limitTo: 50"
           typeahead-min-length="0"
           typeahead-focus-on-select="false"
           typeahead-on-select="$ctrl.selectCluster($item)"
           typeahead-template-url="{{$ctrl.optionTemplate}}"
           />
`;
const onDemandClusterPickerComponent = {
  template,
  controller: OnDemandClusterPickerController,
  bindings: {
    application: "<"
  }
};
const ON_DEMAND_CLUSTER_PICKER_COMPONENT = "spinnaker.core.cluster.onDemandClusterPicker.component";
module(ON_DEMAND_CLUSTER_PICKER_COMPONENT, []).component("onDemandClusterPicker", onDemandClusterPickerComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/cluster/onDemand/onDemandOptionTemplate.html", `<a> <account-tag account="match.model.account"></account-tag> <span ng-bind-html="match.model.name"></span> </a>
`);
}]);

const CLUSTER_MODULE = "spinnaker.core.cluster";
module(CLUSTER_MODULE, [
  CORE_CLUSTER_ALLCLUSTERS_CONTROLLER,
  CLUSTER_ALLCLUSTERSGROUPINGS,
  ON_DEMAND_CLUSTER_PICKER_COMPONENT
]);

const bannerBackgroundColorOptions = [
  {
    label: "danger",
    value: "var(--color-danger)"
  },
  {
    label: "danger-light",
    value: "var(--color-danger-light)"
  },
  {
    label: "alert",
    value: "var(--color-alert)"
  },
  {
    label: "alert-light",
    value: "var(--color-alert-light)"
  },
  {
    label: "warning",
    value: "var(--color-warning)"
  },
  {
    label: "warning-light",
    value: "var(--color-warning-light)"
  },
  {
    label: "success",
    value: "var(--color-success)"
  },
  {
    label: "success-light",
    value: "var(--color-success-light)"
  },
  {
    label: "accessory",
    value: "var(--color-accessory)"
  },
  {
    label: "accessory-light",
    value: "var(--color-accessory-light)"
  }
];
const bannerTextColorOptions = [
  {
    label: "text-primary",
    value: "var(--color-text-primary)"
  },
  {
    label: "text-secondary",
    value: "var(--color-text-secondary)"
  },
  {
    label: "text-accent",
    value: "var(--color-text-accent)"
  },
  {
    label: "text-caption",
    value: "var(--color-text-caption)"
  },
  {
    label: "text-link",
    value: "var(--color-text-link)"
  },
  {
    label: "text-on-dark",
    value: "var(--color-text-on-dark)"
  }
];

var css_248z$N = ".custom-banner-config-container {\n  display: flex;\n  flex-direction: column;\n}\n.custom-banner-config-description {\n  margin-bottom: 10px;\n}\n.custom-banner-config-textarea,\n.custom-banner-config-preview {\n  resize: vertical;\n  min-height: 50px;\n  max-height: 150px;\n}\n.custom-banner-config-preview {\n  overflow-y: auto;\n}\n.custom-banner-config-color-option {\n  height: 20px;\n  border: 1px solid var(--color-alto);\n}\n.Select-value .custom-banner-config-color-option {\n  margin: 4px 12px 4px 4px;\n}\n.custom-banner-config-color-option-column {\n  width: 15%;\n}\n";
styleInject(css_248z$N);

class CustomBannerConfig extends React__default.Component {
  constructor(props) {
    super(props);
    this.onEnabledChange = (idx, isChecked) => {
      this.setState({
        bannerConfigsEditing: this.state.bannerConfigsEditing.map((config, i) => {
          if (i === idx) {
            return {
              ...config,
              enabled: isChecked
            };
          }
          return {
            ...config,
            enabled: isChecked ? false : config.enabled
          };
        })
      });
    };
    this.onTextChange = (idx, text) => {
      this.setState({
        bannerConfigsEditing: this.state.bannerConfigsEditing.map((config, i) => {
          if (i === idx) {
            return {
              ...config,
              text
            };
          }
          return config;
        })
      });
    };
    this.onTextColorChange = (idx, option) => {
      this.setState({
        bannerConfigsEditing: this.state.bannerConfigsEditing.map((config, i) => {
          if (i === idx) {
            return {
              ...config,
              textColor: option.value
            };
          }
          return config;
        })
      });
    };
    this.onBackgroundColorChange = (idx, option) => {
      this.setState({
        bannerConfigsEditing: this.state.bannerConfigsEditing.map((config, i) => {
          if (i === idx) {
            return {
              ...config,
              backgroundColor: option.value
            };
          }
          return config;
        })
      });
    };
    this.addBanner = () => {
      this.setState({
        bannerConfigsEditing: this.state.bannerConfigsEditing.concat([
          {
            backgroundColor: "var(--color-alert)",
            enabled: false,
            text: "Your custom banner text",
            textColor: "var(--color-text-on-dark)"
          }
        ])
      });
    };
    this.removeBanner = (idx) => {
      this.setState({
        bannerConfigsEditing: this.state.bannerConfigsEditing.filter((_config, i) => i !== idx)
      });
    };
    this.isDirty = () => {
      return !isEqual(this.props.bannerConfigs, this.state.bannerConfigsEditing);
    };
    this.onRevertClicked = () => {
      this.setState({
        bannerConfigsEditing: this.props.bannerConfigs
      });
    };
    this.onSaveClicked = () => {
      this.props.updateBannerConfigs(this.state.bannerConfigsEditing);
    };
    this.colorOptionRenderer = (option) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "custom-banner-config-color-option",
        style: { backgroundColor: option.value }
      });
    };
    this.state = {
      bannerConfigsEditing: props.bannerConfigs
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "custom-banner-config-container"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "custom-banner-config-description"
    }, "Custom Banners allow you to specify application-specific headers that will appear above the main Spinnaker navigation bar."), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-10 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", {
      className: "text-center"
    }, "Enabled"), /* @__PURE__ */ React__default.createElement("th", null, "Text"), /* @__PURE__ */ React__default.createElement("th", {
      className: "custom-banner-config-color-option-column"
    }, "Text Color"), /* @__PURE__ */ React__default.createElement("th", {
      className: "custom-banner-config-color-option-column"
    }, "Background"), /* @__PURE__ */ React__default.createElement("th", null))), /* @__PURE__ */ React__default.createElement("tbody", null, this.state.bannerConfigsEditing.map((banner, idx) => /* @__PURE__ */ React__default.createElement("tr", {
      key: idx,
      className: "custom-banner-config-row"
    }, /* @__PURE__ */ React__default.createElement("td", {
      className: "text-center"
    }, /* @__PURE__ */ React__default.createElement("input", {
      checked: banner.enabled,
      onChange: (e) => this.onEnabledChange(idx, e.target.checked),
      type: "checkbox"
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("textarea", {
      className: "form-control input-sm custom-banner-config-textarea",
      onChange: (e) => this.onTextChange(idx, e.target.value),
      style: {
        backgroundColor: banner.backgroundColor,
        color: banner.textColor
      },
      value: banner.text
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "small text-right"
    }, "Markdown is okay ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "markdown.examples"
    })), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, "Preview"), /* @__PURE__ */ React__default.createElement("div", {
      className: "input-sm custom-banner-config-preview",
      style: {
        backgroundColor: banner.backgroundColor,
        color: banner.textColor
      }
    }, /* @__PURE__ */ React__default.createElement(Markdown, {
      message: banner.text
    })))), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(Select, {
      clearable: false,
      options: bannerTextColorOptions,
      onChange: (option) => this.onTextColorChange(idx, option),
      optionRenderer: this.colorOptionRenderer,
      value: banner.textColor,
      valueRenderer: this.colorOptionRenderer
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(Select, {
      clearable: false,
      options: bannerBackgroundColorOptions,
      onChange: (option) => this.onBackgroundColorChange(idx, option),
      optionRenderer: this.colorOptionRenderer,
      value: banner.backgroundColor,
      valueRenderer: this.colorOptionRenderer
    })), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
      className: "link custom-banner-config-remove",
      onClick: () => this.removeBanner(idx)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    })))))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-10 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-block add-new",
      onClick: this.addBanner
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add banner")), /* @__PURE__ */ React__default.createElement(ConfigSectionFooter, {
      isDirty: this.isDirty(),
      isValid: true,
      isSaving: this.props.isSaving,
      saveError: false,
      onRevertClicked: this.onRevertClicked,
      onSaveClicked: this.onSaveClicked
    }));
  }
}
CustomBannerConfig.defaultProps = {
  bannerConfigs: [],
  isSaving: false,
  saveError: false,
  updateBannerConfigs: noop
};

const CUSTOM_BANNER_CONFIG = "spinnaker.kubernetes.core.bannerConfig.component";
module(CUSTOM_BANNER_CONFIG, []).component("customBannerConfig", react2angular(withErrorBoundary(CustomBannerConfig, "customBannerConfig"), [
  "bannerConfigs",
  "isSaving",
  "saveError",
  "updateBannerConfigs"
]));

const DEPLOYMENT_STRATEGY_SELECTOR_COMPONENT = "spinnaker.core.deploymentStrategy.deploymentStrategySelector";
module(DEPLOYMENT_STRATEGY_SELECTOR_COMPONENT, []).component("deploymentStrategySelector", react2angular(withErrorBoundary(DeploymentStrategySelector, "deploymentStrategySelector"), [
  "command",
  "onFieldChange",
  "onStrategyChange",
  "labelColumns",
  "fieldColumns"
]));

class PipelineSelector extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      applicationsLoaded: false,
      pipelinesLoaded: false,
      applicationOptions: [],
      pipelineOptions: [],
      pipelines: [],
      pipelineParameters: [],
      useDefaultParameters: {},
      userSuppliedParameters: {}
    };
    this.applicationChange = (option) => {
      if (this.props.type === "pipelines") {
        this.props.command.application = option ? option.value : "";
      } else {
        this.props.command.strategyApplication = option ? option.value : "";
      }
      this.initializePipelines();
    };
    this.pipelineChange = (option) => {
      if (this.props.type === "pipelines") {
        this.props.command.pipelineId = option ? option.value : "";
      } else {
        this.props.command.strategyPipeline = option ? option.value : "";
      }
      this.updatePipelineConfig(this.state.pipelines);
    };
  }
  clearParams() {
    this.setState({ pipelineParameters: [], useDefaultParameters: {}, userSuppliedParameters: {} });
  }
  configureParamDefaults(pipelineParameters) {
    const useDefaultParameters = this.state.useDefaultParameters;
    pipelineParameters.forEach((param) => {
      const defaultValue = param.default;
      if (defaultValue !== null && defaultValue !== void 0) {
        const configuredParamValue = this.props.command.pipelineParameters[param.name];
        if (configuredParamValue === void 0 || configuredParamValue === defaultValue) {
          useDefaultParameters[param.name] = true;
          this.props.command.pipelineParameters[param.name] = defaultValue;
        }
      }
    });
    this.setState({ useDefaultParameters });
  }
  updatePipelineConfig(pipelines) {
    const { command, type } = this.props;
    const pipelineId = type === "pipelines" ? command.pipelineId : command.strategyPipeline;
    if (command && pipelineId) {
      const config = pipelines.find((p) => p.id === pipelineId);
      if (config && config.parameterConfig) {
        if (!command.pipelineParameters) {
          command.pipelineParameters = {};
        }
        this.setState({
          pipelineParameters: config.parameterConfig,
          userSuppliedParameters: command.pipelineParameters,
          useDefaultParameters: {}
        });
        this.configureParamDefaults(this.state.pipelineParameters);
      } else {
        this.clearParams();
      }
    } else {
      this.clearParams();
    }
  }
  validateCurrentPipeline(pipelines) {
    const { command, type } = this.props;
    if (type === "pipelines" && pipelines.every((p) => p.id !== command.pipelineId)) {
      command.pipelineId = "";
    }
    if (type === "strategies" && pipelines.every((p) => p.id !== command.strategyPipeline)) {
      command.pipelineId = "";
    }
  }
  updatePipelines(pipelines) {
    const pipelinesLoaded = true;
    this.updatePipelineConfig(pipelines);
    const pipelineOptions = pipelines.map((p) => ({ label: p.name, value: p.id }));
    this.setState({ pipelines, pipelinesLoaded, pipelineOptions });
  }
  initializePipelines() {
    this.setState({ pipelinesLoaded: false });
    const { command, type } = this.props;
    if (type === "pipelines" && command.application) {
      PipelineConfigService.getPipelinesForApplication(command.application).then((pipelines) => {
        this.validateCurrentPipeline(pipelines);
        this.updatePipelines(pipelines);
      });
    } else if (type === "strategies" && command.strategyApplication) {
      PipelineConfigService.getStrategiesForApplication(command.strategyApplication).then((pipelines) => {
        this.validateCurrentPipeline(pipelines);
        this.updatePipelines(pipelines);
      });
    } else {
      this.forceUpdate();
    }
  }
  componentDidMount() {
    if (this.props.type === "strategies" && !this.props.command.strategyApplication) {
      this.props.command.strategyApplication = this.props.command.application;
    }
    ApplicationReader.listApplications().then((applications) => {
      const applicationOptions = applications.map((a) => a.name).sort().map((a) => ({ label: a, value: a }));
      this.setState({ applicationOptions, applicationsLoaded: true });
      this.initializePipelines();
    });
  }
  updateParam(parameter, value) {
    const { userSuppliedParameters } = this.state;
    userSuppliedParameters[parameter] = value;
    if (this.state.useDefaultParameters[parameter] === true) {
      delete userSuppliedParameters[parameter];
      delete this.props.command.pipelineParameters[parameter];
    } else if (this.state.userSuppliedParameters[parameter]) {
      this.props.command.pipelineParameters[parameter] = this.state.userSuppliedParameters[parameter];
    }
    this.setState({ userSuppliedParameters });
  }
  render() {
    const { command, type } = this.props;
    const {
      applicationsLoaded,
      applicationOptions,
      pipelineParameters,
      pipelineOptions,
      pipelinesLoaded,
      useDefaultParameters,
      userSuppliedParameters
    } = this.state;
    const application = type === "pipelines" ? command.application : command.strategyApplication;
    const pipelineId = type === "pipelines" ? command.pipelineId : command.strategyPipeline;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-2 col-md-offset-1 sm-label-right"
    }, "Application"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, !applicationsLoaded && /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-margin-xs-top"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "small"
    })), applicationsLoaded && /* @__PURE__ */ React__default.createElement(VirtualizedSelect, {
      placeholder: "None",
      value: application,
      options: applicationOptions,
      onChange: this.applicationChange
    }))), application && pipelinesLoaded && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-2 col-md-offset-1 sm-label-right"
    }, "Pipeline"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(VirtualizedSelect, {
      placeholder: "Select a pipeline...",
      value: pipelineId,
      options: pipelineOptions,
      onChange: this.pipelineChange
    })))), pipelineParameters.length > 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "well well-sm clearfix ng-scope col-md-12"
    }, /* @__PURE__ */ React__default.createElement("strong", {
      className: "text-left"
    }, "Parameters"), pipelineParameters.map((parameter) => /* @__PURE__ */ React__default.createElement("div", {
      key: parameter.name,
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, !parameter.description && /* @__PURE__ */ React__default.createElement("span", null, parameter.name), parameter.description && /* @__PURE__ */ React__default.createElement(HelpField, {
      content: parameter.description,
      label: parameter.name
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, useDefaultParameters[parameter.name] && /* @__PURE__ */ React__default.createElement("input", {
      disabled: true,
      type: "text",
      className: "form-control input-sm",
      value: parameter.default
    }), useDefaultParameters[parameter.name] && !parameter.hasOptions && /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: "form-control input-sm",
      value: userSuppliedParameters[parameter.name],
      onChange: (e) => this.updateParam(parameter.name, e.target.value)
    }), !useDefaultParameters[parameter.name] && parameter.hasOptions && /* @__PURE__ */ React__default.createElement(VirtualizedSelect, {
      style: { width: "100%" },
      value: userSuppliedParameters[parameter.name],
      onChange: (o) => this.updateParam(parameter.name, o ? o.value : ""),
      options: parameter.options.map((o) => ({ label: o.value, value: o.value }))
    })), parameter.default !== null && parameter.default !== void 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox col-md-3"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: useDefaultParameters[parameter.name],
      onChange: (e) => this.updateParam(parameter.name, e.target.checked)
    }), "Use default")))))));
  }
}

class AdditionalFields$2 extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement(PipelineSelector, {
      command: this.props.command,
      type: "strategies"
    });
  }
}

DeploymentStrategyRegistry.registerStrategy({
  label: "Custom",
  description: "Runs a custom deployment strategy",
  key: "custom",
  additionalFields: ["pipelineParameters", "strategyApplication", "strategyPipeline"],
  AdditionalFieldsComponent: AdditionalFields$2
});

function HighlanderPreview(props) {
  const isPipeline = props.command.viewState.mode === "editPipeline";
  return isPipeline ? null : /* @__PURE__ */ React.createElement(HighlanderPreviewCmp, {
    ...props
  });
}
function HighlanderPreviewCmp(props) {
  const { credentials, region, application, stack, freeFormDetails } = props.command;
  const cluster = NameUtils.getClusterName(application, stack, freeFormDetails);
  const fetchit = useData(() => REST("/applications").path(application, "serverGroups").get(), [], []);
  const { backingData, ...command } = props.command;
  const { capacity } = command;
  const serverGroups = fetchit.result.filter((sg) => {
    return sg.cluster === cluster && sg.account === credentials && sg.region === region;
  });
  if (fetchit.status === "PENDING") {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (fetchit.status === "REJECTED") {
    return /* @__PURE__ */ React.createElement("pre", null, fetchit.error);
  }
  const currentUpCount = serverGroups.reduce((total, sg) => total + sg.instanceCounts.up, 0);
  const pluralize = (str, val) => val === 1 ? str : str + "s";
  const containStr = serverGroups.length === 1 ? "contains" : "contain";
  const serverGroupStr = pluralize("server group", serverGroups.length);
  const instanceStr = pluralize("instance", currentUpCount);
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex-container-v margin-between-md"
  }, /* @__PURE__ */ React.createElement("div", null, "Highlander will create a new server group with ", capacity.desired, " ", pluralize("instance", capacity.desired), "."), /* @__PURE__ */ React.createElement("div", null, "Then it will destroy the following ", serverGroups.length, " ", serverGroupStr, " which currently ", containStr, " ", currentUpCount, " healthy ", instanceStr, ":"), /* @__PURE__ */ React.createElement("ul", null, serverGroups.map((sg) => /* @__PURE__ */ React.createElement("li", {
    key: sg.name,
    className: "flex-container-h margin-between-lg"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "bold"
  }, sg.name), " ", /* @__PURE__ */ React.createElement(HealthCounts, {
    container: sg.instanceCounts
  })))));
}

DeploymentStrategyRegistry.registerStrategy({
  label: "Highlander",
  description: "Destroys <i>all</i> previous server groups in the cluster as soon as new server group passes health checks",
  key: "highlander",
  AdditionalFieldsComponent: HighlanderPreview
});

class DeploymentMonitorReader {
  static getDeploymentMonitors() {
    return REST("/capabilities/deploymentMonitors").useCache(true).get();
  }
}

var RollbackType;
(function(RollbackType2) {
  RollbackType2["None"] = "None";
  RollbackType2["Automatic"] = "Automatic";
  RollbackType2["Manual"] = "Manual";
})(RollbackType || (RollbackType = {}));
class AdditionalFields$1 extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      deploymentMonitors: []
    };
    this.deployStepsChange = (model) => {
      this.props.command.deploySteps = model;
      this.forceUpdate();
    };
    this.scaleDownChange = (e) => {
      this.props.command.scaleDown = e.target.checked;
      this.forceUpdate();
    };
    this.rollbackOnFailureChange = (e) => {
      this.props.command.failureActions.rollback = e.target.checked ? RollbackType.Automatic : RollbackType.None;
      if (this.props.command.failureActions.rollback === RollbackType.None) {
        this.props.command.failureActions.destroyInstances = false;
      }
      this.forceUpdate();
    };
    this.destroyFailedAsgChange = (e) => {
      this.props.command.failureActions.destroyInstances = e.target.checked;
      this.forceUpdate();
    };
    this.maxRemainingAsgsChange = (e) => {
      this.props.command.maxRemainingAsgs = parseInt(e.target.value, 10);
      this.forceUpdate();
    };
    this.handleDeploymentMonitorChange = (option) => {
      this.props.command.deploymentMonitor.id = option.value;
      this.forceUpdate();
    };
    this.handleChange = (key, value) => {
      set(this.props.command, key, value);
      this.forceUpdate();
    };
  }
  componentDidMount() {
    DeploymentMonitorReader.getDeploymentMonitors().then((deploymentMonitors) => {
      this.setState({ deploymentMonitors });
    });
  }
  render() {
    var _a;
    const { command } = this.props;
    const rollbackOnFailure = command.failureActions && command.failureActions.rollback === RollbackType.Automatic;
    const destroyFailedAsg = command.failureActions && command.failureActions.destroyInstances;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, this.state.deploymentMonitors && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-10"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      clearable: false,
      required: true,
      options: this.state.deploymentMonitors.map((deploymentMonitor) => ({
        label: (deploymentMonitor == null ? void 0 : deploymentMonitor.name) || "",
        value: (deploymentMonitor == null ? void 0 : deploymentMonitor.id) || ""
      })),
      placeholder: "select deployment monitor",
      value: ((_a = command.deploymentMonitor) == null ? void 0 : _a.id) || "",
      onChange: this.handleDeploymentMonitorChange
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 form-inline"
    }, /* @__PURE__ */ React__default.createElement("label", null, "Maximum number of server groups to leave", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.redblack.maxRemainingAsgs"
    })), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      style: { width: "50px" },
      type: "number",
      value: command.maxRemainingAsgs,
      onChange: this.maxRemainingAsgsChange,
      min: "2"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 checkbox",
      style: { marginTop: 0 }
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: rollbackOnFailure,
      onChange: this.rollbackOnFailureChange
    }), "Rollback to previous server group if deployment fails ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.monitored.rollback"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 checkbox",
      style: { marginTop: 0 }
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: destroyFailedAsg,
      disabled: !rollbackOnFailure,
      onChange: this.destroyFailedAsgChange
    }), "Destroy the failed server group after rollback ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.monitored.destroyFailedAsg"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: command.scaleDown,
      onChange: this.scaleDownChange
    }), "Scale down replaced server groups to zero instances ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.redblack.scaleDown"
    }))), command.scaleDown && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 form-inline",
      style: { marginTop: "5px" }
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("span", {
      style: { marginRight: "2px" }
    }, "Wait Before Scale Down"), /* @__PURE__ */ React__default.createElement(HelpField, {
      content: "Time to wait before scaling down all old server groups"
    })), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      style: { width: "60px", marginLeft: "2px", marginRight: "2px" },
      min: "0",
      type: "number",
      value: command.delayBeforeScaleDownSec,
      onChange: (e) => this.handleChange("delayBeforeScaleDownSec", e.target.value),
      placeholder: "0"
    }), "seconds"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6",
      style: { marginTop: "5px" }
    }, /* @__PURE__ */ React__default.createElement("h4", null, "Percentages", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.monitored.deploySteps"
    })), /* @__PURE__ */ React__default.createElement(NumberList, {
      model: command.deploySteps,
      label: "percentage",
      onChange: this.deployStepsChange
    })));
  }
}

DeploymentStrategyRegistry.registerStrategy({
  label: "Monitored Deploy",
  description: `Creates a new version of this server group, then incrementally resizes the new server group while monitoring progress using a deployment monitor.`,
  key: "monitored",
  providerRestricted: true,
  additionalFields: ["deploySteps", "scaleDown"],
  AdditionalFieldsComponent: AdditionalFields$1,
  initializationMethod: (command) => {
    defaultsDeep(command, {
      failureActions: {
        destroyInstances: false,
        rollback: RollbackType.Automatic
      },
      deploymentMonitor: { id: "" },
      maxRemainingAsgs: 2
    });
    if (isEmpty(command.deploySteps)) {
      command.deploySteps = [10, 40, 100];
    }
  }
});

DeploymentStrategyRegistry.registerStrategy({
  label: "None",
  description: "Creates the next server group with no impact on existing server groups",
  key: "",
  providerRestricted: false
});

DeploymentStrategyRegistry.registerStrategy({
  label: "Red/Black",
  description: "Disables <i>all</i> previous server groups in the cluster as soon as new server group passes health checks",
  key: "redblack",
  providerRestricted: true,
  additionalFields: ["scaleDown", "maxRemainingAsgs"],
  AdditionalFieldsComponent: AdditionalFields$3,
  initializationMethod: (command) => {
    var _a;
    defaultsDeep(command, {
      rollback: {
        onFailure: false
      },
      maxRemainingAsgs: (_a = command.maxRemainingAsgs) != null ? _a : 2,
      delayBeforeDisableSec: 0,
      delayBeforeScaleDownSec: 0,
      scaleDown: false
    });
  }
});

class AdditionalFields extends React__default.Component {
  constructor() {
    super(...arguments);
    this.targetPercentagesChange = (model) => {
      this.props.command.targetPercentages = model;
      this.forceUpdate();
    };
    this.delayChange = (e) => {
      this.props.command.delayBeforeDisableSec = e.target.value;
      this.forceUpdate();
    };
    this.scaleDownChange = (e) => {
      this.props.command.scaleDown = e.target.checked;
      this.forceUpdate();
    };
    this.rollbackOnFailureChange = (e) => {
      this.props.command.rollback.onFailure = e.target.checked;
      this.forceUpdate();
    };
    this.handleChange = (key, value) => {
      set(this.props.command, key, value);
      this.forceUpdate();
    };
  }
  render() {
    const { command } = this.props;
    const rollbackOnFailure = command.rollback && command.rollback.onFailure;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 checkbox",
      style: { marginTop: 0 }
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: rollbackOnFailure,
      onChange: this.rollbackOnFailureChange
    }), "Rollback to previous server group if deployment fails ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.rollingRedBlack.rollback"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: command.scaleDown,
      onChange: this.scaleDownChange
    }), "Scale down replaced server groups to zero instances ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.redblack.scaleDown"
    }))), command.scaleDown && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 form-inline",
      style: { marginTop: "5px" }
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("span", {
      style: { marginRight: "2px" }
    }, "Wait Before Scale Down"), /* @__PURE__ */ React__default.createElement(HelpField, {
      content: "Time to wait before scaling down all old server groups"
    })), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      style: { width: "60px", marginLeft: "2px", marginRight: "2px" },
      min: "0",
      type: "number",
      value: command.delayBeforeScaleDownSec,
      onChange: (e) => this.handleChange("delayBeforeScaleDownSec", e.target.value),
      placeholder: "0"
    }), "seconds"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6",
      style: { marginTop: "5px" }
    }, /* @__PURE__ */ React__default.createElement("h4", null, "Percentages", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "strategy.rollingRedBlack.targetPercentages"
    })), /* @__PURE__ */ React__default.createElement(NumberList, {
      model: command.targetPercentages,
      label: "percentage",
      onChange: this.targetPercentagesChange
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12",
      style: { marginTop: "15px" }
    }, /* @__PURE__ */ React__default.createElement("h4", null, "Before Disable")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 form-inline"
    }, /* @__PURE__ */ React__default.createElement("label", null, "Wait", /* @__PURE__ */ React__default.createElement(HelpField, {
      content: "Time to wait after each percentage step before disabling instances in the old server group"
    })), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      style: { width: "60px" },
      min: "0",
      type: "number",
      value: command.delayBeforeDisableSec,
      onChange: this.delayChange,
      placeholder: "0"
    }), "seconds"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12",
      style: { marginTop: "5px" }
    }, /* @__PURE__ */ React__default.createElement("label", null, "Run a Pipeline", /* @__PURE__ */ React__default.createElement(HelpField, {
      content: "Pipeline to run after each percentage step before disabling instances in the old server group"
    })), /* @__PURE__ */ React__default.createElement(PipelineSelector, {
      command: command.pipelineBeforeCleanup,
      type: "pipelines"
    })));
  }
}

DeploymentStrategyRegistry.registerStrategy({
  label: "Rolling Red/Black",
  description: `Creates a new version of this server group, then incrementally resizes the new server group while disabling the same percentage in the previous server group.`,
  key: "rollingredblack",
  providerRestricted: true,
  additionalFields: ["targetPercentages", "scaleDown"],
  AdditionalFieldsComponent: AdditionalFields,
  initializationMethod: (command) => {
    if (!command.targetPercentages) {
      command.targetPercentages = [50, 100];
    }
    command.delayBeforeDisableSec = command.delayBeforeDisableSec || 0;
    if (!command.pipelineBeforeCleanup) {
      command.pipelineBeforeCleanup = {
        application: command.application
      };
    }
  }
});

const DEPLOYMENT_STRATEGY_MODULE = "spinnaker.core.deploymentStrategy";
module(DEPLOYMENT_STRATEGY_MODULE, [DEPLOYMENT_STRATEGY_SELECTOR_COMPONENT]);

const ADD_ENTITY_TAG_LINKS_COMPONENT = "spinnaker.core.entityTag.details.component";
module(ADD_ENTITY_TAG_LINKS_COMPONENT, []).component("addEntityTagLinks", react2angular(withErrorBoundary(AddEntityTagLinks, "addEntityTagLinks"), [
  "application",
  "component",
  "entityType",
  "onUpdate",
  "ownerOptions",
  "tagType"
]));

const ENTITY_SOURCE_COMPONENT = "spinnaker.core.entityTag.entitySource.component";
module(ENTITY_SOURCE_COMPONENT, []).component("entitySource", react2angular(withErrorBoundary(EntitySource, "entitySource"), ["metadata", "relativePath"]));

const ENTITY_TAGS_DATA_SOURCE = "spinnaker.core.entityTag.dataSource";
module(ENTITY_TAGS_DATA_SOURCE, [LOAD_BALANCER_READ_SERVICE]).run([
  "$q",
  ($q) => {
    if (!SETTINGS.feature.entityTags) {
      return;
    }
    const loadEntityTags = (application) => {
      return EntityTagsReader.getAllEntityTagsForApplication(application.name);
    };
    const addEntityTags = (_application, data) => {
      return $q.when(data);
    };
    const addTagsToEntities = (application) => {
      application.getDataSource("serverGroups").ready().then(() => EntityTagsReader.addTagsToServerGroups(application), noop);
      application.getDataSource("serverGroupManagers").ready().then(() => EntityTagsReader.addTagsToServerGroupManagers(application), noop);
      application.getDataSource("loadBalancers").ready().then(() => EntityTagsReader.addTagsToLoadBalancers(application), noop);
      application.getDataSource("securityGroups").ready().then(() => EntityTagsReader.addTagsToSecurityGroups(application), noop);
      application.getDataSource("executions").ready().then(() => EntityTagsReader.addTagsToExecutions(application), noop);
      application.getDataSource("pipelineConfigs").ready().then(() => EntityTagsReader.addTagsToPipelines(application), noop);
    };
    ApplicationDataSourceRegistry.registerDataSource({
      key: "entityTags",
      visible: false,
      loader: loadEntityTags,
      onLoad: addEntityTags,
      afterLoad: addTagsToEntities,
      defaultData: []
    });
  }
]);

const helpContents = [
  {
    key: "entityTags.serverGroup.alert",
    contents: `<p>Alerts indicate an issue with a server group. When present, an alert icon
      <i class="notification fa fa-exclamation-triangle"></i> will be displayed in the clusters view next to the server group.</p>`
  },
  {
    key: "entityTags.serverGroup.notice",
    contents: `<p>Notices provide additional context for a server group. When present, an info icon
      <i class="notification fa fa-flag"></i> will be displayed in the clusters view next to the server group.</p>`
  },
  {
    key: "entityTags.loadBalancer.alert",
    contents: `<p>Alerts indicate an issue with a load balancer. When present, an alert icon
      <i class="notification fa fa-exclamation-triangle"></i> will be displayed in the load balancers view next to the server group.</p>`
  },
  {
    key: "entityTags.loadBalancer.notice",
    contents: `<p>Notices provide additional context for a load balancer. When present, an info icon
      <i class="notification fa fa-flag"></i> will be displayed in the load balancers view next to the server group.</p>`
  },
  {
    key: "entityTags.securityGroup.notice",
    contents: `<p>Notices provide additional context for a {{firewall}}. When present, an info icon
      <i class="notification fa fa-flag"></i> will be displayed in the {{firewalls}} view next to the {{firewall}}.</p>`
  },
  {
    key: "entityTags.securityGroup.alert",
    contents: `<p>Alerts indicate an issue with a {{firewall}}. When present, an alert icon
      <i class="notification fa fa-exclamation-triangle"></i> will be displayed in the {{firewall}} view next to the {{firewall}}.</p>`
  }
];
helpContents.forEach((entry) => HelpContentsRegistry.register(entry.key, entry.contents));

const ENTITY_NOTIFICATIONS = "spinnaker.core.entityTag.alerts.entitynotifications";
const ngmodule$2 = module(ENTITY_NOTIFICATIONS, []);
ngmodule$2.component("entityNotificationsWrapper", react2angular(withErrorBoundary(EntityNotifications, "entityNotificationsWrapper"), [
  "entity",
  "application",
  "placement",
  "hOffsetPercent",
  "className",
  "pageLocation",
  "entityType",
  "onUpdate"
]));
ngmodule$2.component("entityNotifications", {
  template: `
    <entity-notifications-wrapper
      entity="$ctrl.entity"
      application="$ctrl.application"
      placement="$ctrl.placement"
      h-offset-percent="$ctrl.hOffsetPercent"
      class-name="$ctrl.className"
      entity-type="$ctrl.entityType"
      page-location="$ctrl.pageLocation"
      on-update="$ctrl.onUpdate"
    ></entity-notifications-wrapper>
  `,
  bindings: {
    entity: "<",
    application: "<",
    placement: "@",
    hOffsetPercent: "@",
    className: "@",
    entityType: "@",
    pageLocation: "@",
    onUpdate: "&"
  }
});

const ENTITY_TAGS_MODULE = "spinnaker.core.entityTags";
module(ENTITY_TAGS_MODULE, [
  ADD_ENTITY_TAG_LINKS_COMPONENT,
  DATA_SOURCE_NOTIFICATIONS,
  ENTITY_NOTIFICATIONS,
  ENTITY_SOURCE_COMPONENT,
  ENTITY_TAGS_DATA_SOURCE
]);

const HEALTH_COUNTS_COMPONENT = "spinnaker.core.healthCounts.component";
module(HEALTH_COUNTS_COMPONENT, []).component("healthCounts", react2angular(withErrorBoundary(HealthCounts, "healthCounts"), [
  "container",
  "additionalLegendText",
  "legendPlacement"
]));

const HEALTH_COUNTS_MODULE = "spinnaker.core.healthCounts";
module(HEALTH_COUNTS_MODULE, [HEALTH_COUNTS_COMPONENT]);

class HelpFieldCtrl {
}
const helpFieldComponent = {
  bindings: {
    key: "@",
    fallback: "@",
    content: "@",
    placement: "@",
    expand: "=",
    label: "@"
  },
  controller: HelpFieldCtrl,
  template: `<help-field-react
              id="$ctrl.key"
              fallback="$ctrl.fallback"
              content="$ctrl.content"
              placement="$ctrl.placement"
              label="$ctrl.label"
              expand="$ctrl.expand"
            ></help-field-react>`
};
const HELP_FIELD_COMPONENT = "spinnaker.core.help.helpField.component";
module(HELP_FIELD_COMPONENT, []).component("helpField", helpFieldComponent);

const HELP_FIELD_REACT_COMPONENT = "spinnaker.core.help.helpFieldReact.component";
module(HELP_FIELD_REACT_COMPONENT, []).component("helpFieldReact", react2angular(withErrorBoundary(HelpField, "helpFieldReact"), [
  "content",
  "expand",
  "fallback",
  "id",
  "label",
  "placement"
]));

const HELP_MODULE = "spinnaker.core.help";
module(HELP_MODULE, [HELP_FIELD_COMPONENT, HELP_FIELD_REACT_COMPONENT]);

class InsightFilterStateModel {
  constructor() {
    this.filtersExpanded = !CollapsibleSectionStateCache.isSet("insightFilters") || CollapsibleSectionStateCache.isExpanded("insightFilters");
  }
  pinFilters(shouldPin) {
    this.filtersExpanded = shouldPin;
    CollapsibleSectionStateCache.setExpanded("insightFilters", shouldPin);
  }
}
const INSIGHT_FILTER_STATE_MODEL = "spinnaker.core.insight.insightFilterState.model";
module(INSIGHT_FILTER_STATE_MODEL, []).service("insightFilterStateModel", InsightFilterStateModel);

const INSIGHT_LAYOUT_COMPONENT = "spinnaker.core.insight.insightLayout.component";
module(INSIGHT_LAYOUT_COMPONENT, []).component("insightLayout", react2angular(withErrorBoundary(InsightLayout, "insightLayout"), ["app"]));

const INSIGHT_MENU_DIRECTIVE = "spinnaker.core.insightMenu.directive";
module(INSIGHT_MENU_DIRECTIVE, []).directive("insightMenu", function() {
  return {
    templateUrl: "core/src/insight/insightmenu.directive.html",
    restrict: "E",
    replace: true,
    scope: {
      actions: "=",
      title: "@",
      icon: "@",
      rightAlign: "&"
    },
    link: function(scope) {
      scope.status = { isOpen: false };
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/insight/insightmenu.directive.html", `<div class="row">
  <div class="col-md-12 divider">
    <h4 style="display: inline"><span class="glyphicon glyphicon-{{ icon }}"></span> {{ title }}</h4>
    <div
      class="dropdown"
      style="float: right"
      uib-dropdown
      dropdown-append-to-body
      auto-close="disabled"
      is-open="status.isOpen"
    >
      <button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle>
        Actions <span class="caret"></span>
      </button>
      <ul uib-dropdown-menu class="uib-dropdown-menu" ng-class="{'dropdown-menu-right': rightAlign}" role="menu">
        <li ng-repeat="action in actions">
          <a
            href
            ng-if="action.disableAutoClose"
            ng-click="action.action(status)"
            ng-bind-html="action.displayName"
          ></a>
          <a
            href
            ng-if="!action.disableAutoClose"
            ng-click="action.action(); status.isOpen = false"
            ng-bind-html="action.displayName"
          ></a>
        </li>
      </ul>
    </div>
  </div>
</div>
`);
}]);

var css_248z$M = "insight-layout {\n  display: flex;\n}\ninsight-layout insight-filter,\ninsight-layout cluster-filter,\ninsight-layout load-balancer-filter,\ninsight-layout security-group-filter,\ninsight-layout .insight-filter-content {\n  display: flex;\n  overflow-x: hidden;\n  margin-top: var(--m-spacing);\n}\ninsight-layout insight-filter .content,\ninsight-layout cluster-filter .content,\ninsight-layout load-balancer-filter .content,\ninsight-layout security-group-filter .content,\ninsight-layout .insight-filter-content .content {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\ninsight-layout insight-filter,\ninsight-layout .insight-filter-content {\n  flex-direction: column;\n  margin-top: var(--m-spacing);\n}\nui-view[name='insight'],\nreact-ui-view-adapter[name='insight'],\nreact-ui-view-adapter[name='insight'] > .AngularJSAdapter,\nreact-ui-view-adapter[name='detail'] > .AngularJSAdapter {\n  flex: 1 1 auto;\n  display: flex;\n  overflow-x: hidden;\n}\n";
styleInject(css_248z$M);

const INSIGHT_MODULE = "spinnaker.core.insight.module";
module(INSIGHT_MODULE, [INSIGHT_FILTER_STATE_MODEL, INSIGHT_LAYOUT_COMPONENT, INSIGHT_MENU_DIRECTIVE]);

class DebugInterceptor {
  constructor() {
    this.request = (config) => {
      try {
        this.logMutatingRequest(config);
      } catch (e) {
        $log.warn("Debug interceptor bug: ", e.message);
      }
      return config;
    };
  }
  logMutatingRequest(config) {
    if ($location.url() && $location.url().includes("debug=true") && ["POST", "PUT", "DELETE"].includes(config.method)) {
      $log.log(`${config.method}: ${config.url} 
`, JsonUtils.makeSortedStringFromObject(config.data));
    }
  }
}
const DEBUG_INTERCEPTOR = "spinnaker.core.debug.interceptor";
module(DEBUG_INTERCEPTOR, []).service("debugInterceptor", DebugInterceptor).config(["$httpProvider", ($httpProvider) => $httpProvider.interceptors.push("debugInterceptor")]);

const INTERCEPTOR_MODULE = "spinnaker.core.interceptor.module";
module(INTERCEPTOR_MODULE, [DEBUG_INTERCEPTOR]);

const LOAD_BALANCER_DATA_SOURCE = "spinnaker.core.loadBalancer.dataSource";
module(LOAD_BALANCER_DATA_SOURCE, [LOAD_BALANCER_READ_SERVICE]).run([
  "$q",
  "loadBalancerReader",
  ($q, loadBalancerReader) => {
    const loadLoadBalancers = (application) => {
      return loadBalancerReader.loadLoadBalancers(application.name);
    };
    const addLoadBalancers = (_application, loadBalancers) => {
      return $q.when(loadBalancers);
    };
    const addTags = (application) => {
      EntityTagsReader.addTagsToLoadBalancers(application);
      addManagedResourceMetadataToLoadBalancers(application);
    };
    ApplicationDataSourceRegistry.registerDataSource({
      key: "loadBalancers",
      sref: ".insight.loadBalancers",
      category: INFRASTRUCTURE_KEY,
      optional: true,
      icon: "fa fa-xs fa-fw icon-sitemap",
      iconName: "spMenuLoadBalancers",
      loader: loadLoadBalancers,
      onLoad: addLoadBalancers,
      afterLoad: addTags,
      providerField: "cloudProvider",
      credentialsField: "account",
      regionField: "region",
      description: "Traffic distribution management between servers",
      defaultData: []
    });
  }
]);

var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$b(target, key, result);
  return result;
};
let LoadBalancerDetails = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("h3", null, "Load Balancer Details");
  }
};
LoadBalancerDetails = __decorateClass$b([
  Overridable("loadBalancer.details")
], LoadBalancerDetails);

class LoadBalancer$1 extends React__default.Component {
  render() {
    const { application, grouping, loadBalancer, serverGroups, showInstances, showServerGroups } = this.props;
    const config = CloudProviderRegistry.getValue(loadBalancer.provider || loadBalancer.cloudProvider, "loadBalancer");
    const ClusterContainer = config.ClusterContainer || LoadBalancerClusterContainer;
    const showManagedIndicator = !grouping.isManaged && loadBalancer.isManaged;
    const params = {
      application: application.name,
      region: loadBalancer.region,
      accountId: loadBalancer.account,
      name: loadBalancer.name,
      vpcId: loadBalancer.vpcId,
      provider: loadBalancer.cloudProvider
    };
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "pod-subgroup load-balancer"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "load-balancer-header sticky-header-2"
    }, /* @__PURE__ */ React__default.createElement(UISrefActive, {
      class: "active"
    }, /* @__PURE__ */ React__default.createElement(UISref, {
      to: ".loadBalancerDetails",
      params
    }, /* @__PURE__ */ React__default.createElement("h6", {
      className: "clickable clickable-row horizontal middle"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa icon-sitemap"
    }), "\xA0 ", (loadBalancer.region || "").toUpperCase(), /* @__PURE__ */ React__default.createElement("div", {
      className: classNames("flex-container-h middle flex-1", {
        "sp-margin-s-left": showManagedIndicator
      })
    }, showManagedIndicator && /* @__PURE__ */ React__default.createElement(ManagedResourceStatusIndicator, {
      shape: "circle",
      resourceSummary: loadBalancer.managedResourceSummary,
      application
    }), /* @__PURE__ */ React__default.createElement(EntityNotifications, {
      entity: loadBalancer,
      application,
      placement: "bottom",
      entityType: "loadBalancer",
      pageLocation: "pod",
      onUpdate: () => application.loadBalancers.refresh()
    })), /* @__PURE__ */ React__default.createElement(HealthCounts, {
      container: loadBalancer.instanceCounts
    }))))), /* @__PURE__ */ React__default.createElement(ClusterContainer, {
      loadBalancer,
      serverGroups,
      showServerGroups,
      showInstances
    }));
  }
}
LoadBalancer$1.defaultProps = {
  showServerGroups: true,
  showInstances: false
};

var css_248z$L = ".load-balancer-pod .cluster-container {\n  padding: 3px 15px;\n}\n.load-balancer-pod .cluster-container.disabled {\n  opacity: 0.4;\n}\n.load-balancer-pod .cluster-container.disabled:active,\n.load-balancer-pod .cluster-container.disabled:hover {\n  opacity: 0.7;\n}\n.load-balancer-pod .icon-sitemap {\n  color: var(--color-success);\n}\n.load-balancer-pod .rollup-details .pod-subgroup h6 {\n  padding-bottom: 10px;\n  background: rgba(0, 0, 0, 0);\n}\n.load-balancer-pod .load-balancer-header {\n  overflow: hidden;\n  background-color: var(--color-alabaster);\n  padding: 8px 20px 3px 20px;\n}\n.load-balancer-pod .load-balancer-header .health-counts .instance-health-counts {\n  margin-top: -2px;\n}\n.load-balancer-pod .load-balancer > .cluster-container {\n  padding-top: 0;\n}\n";
styleInject(css_248z$L);

class LoadBalancerPod extends React__default.Component {
  render() {
    const { grouping, application, parentHeading, showServerGroups, showInstances } = this.props;
    const subgroups = grouping.subgroups.map((subgroup) => /* @__PURE__ */ React__default.createElement(LoadBalancer$1, {
      key: subgroup.heading,
      application,
      grouping,
      loadBalancer: subgroup.loadBalancer,
      serverGroups: subgroup.serverGroups,
      showServerGroups,
      showInstances
    }));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "load-balancer-pod row rollup-entry sub-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-summary sticky-header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-title-cell"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "heading-tag"
    }, /* @__PURE__ */ React__default.createElement(AccountTag, {
      account: parentHeading
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "pod-center horizontal space-between flex-1 no-right-padding"
    }, /* @__PURE__ */ React__default.createElement("div", null, grouping.heading), grouping.isManaged && /* @__PURE__ */ React__default.createElement(ManagedResourceStatusIndicator, {
      shape: "square",
      resourceSummary: grouping.managedResourceSummary,
      application
    })))), /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-details"
    }, subgroups));
  }
}

var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$a(target, key, result);
  return result;
};
class LoadBalancers$1 extends React__default.Component {
  constructor(props) {
    super(props);
    this.clearFilters = () => {
      LoadBalancerState.filterService.clearFilters();
      this.updateLoadBalancerGroups();
    };
    this.handleInputChange = (event) => {
      const target = event.target;
      const value = target.type === "checkbox" ? target.checked : target.value;
      const name = target.name;
      LoadBalancerState.filterModel.asFilterModel.sortFilter[name] = value;
      const state = {};
      state[name] = value;
      this.updateUIState(state);
      this.setState(state);
    };
    this.tagCleared = () => {
      this.updateLoadBalancerGroups();
    };
    const { $stateParams } = ReactInjector;
    this.state = {
      initialized: false,
      groups: [],
      tags: [],
      showServerGroups: !$stateParams.hideServerGroups || true,
      showInstances: $stateParams.showInstances || false
    };
  }
  componentDidMount() {
    const { app } = this.props;
    this.groupsUpdatedListener = LoadBalancerState.filterService.groupsUpdatedStream.subscribe(() => this.groupsUpdated());
    LoadBalancerState.filterModel.asFilterModel.activate();
    this.loadBalancersRefreshUnsubscribe = app.getDataSource("loadBalancers").onRefresh(null, () => this.updateLoadBalancerGroups());
    app.setActiveState(app.loadBalancers);
    this.updateLoadBalancerGroups();
  }
  componentWillUnmount() {
    this.groupsUpdatedListener.unsubscribe();
    this.loadBalancersRefreshUnsubscribe();
  }
  groupsUpdated() {
    this.setState({
      groups: LoadBalancerState.filterModel.asFilterModel.groups,
      tags: LoadBalancerState.filterModel.asFilterModel.tags
    });
  }
  updateLoadBalancerGroups() {
    LoadBalancerState.filterModel.asFilterModel.applyParamsToUrl();
    LoadBalancerState.filterService.updateLoadBalancerGroups(this.props.app);
    this.groupsUpdated();
    if (this.props.app.getDataSource("loadBalancers").loaded) {
      this.setState({ initialized: true });
    }
  }
  updateUIState(state) {
    const params = {
      hideServerGroups: void 0,
      showInstances: void 0
    };
    if (!state.showServerGroups) {
      params.hideServerGroups = true;
    }
    if (state.showInstances) {
      params.showInstances = true;
    }
    ReactInjector.$state.go(".", params);
  }
  render() {
    const groupings = this.state.initialized ? /* @__PURE__ */ React__default.createElement("div", null, this.state.groups.map((group) => /* @__PURE__ */ React__default.createElement("div", {
      key: group.heading,
      className: "rollup"
    }, group.subgroups && group.subgroups.map((subgroup) => /* @__PURE__ */ React__default.createElement(LoadBalancerPod, {
      key: subgroup.heading,
      grouping: subgroup,
      application: this.props.app,
      parentHeading: group.heading,
      showServerGroups: this.state.showServerGroups,
      showInstances: this.state.showInstances
    })))), this.state.groups.length === 0 && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h4", {
      className: "text-center"
    }, "No load balancers match the filters you've selected."))) : /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    }));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "main-content load-balancers"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "header row header-clusters"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-lg-8 col-md-10"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-inline clearfix filters"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "checkbox"
    }, " Show "), /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, " ", /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      name: "showServerGroups",
      checked: this.state.showServerGroups,
      onChange: this.handleInputChange
    }), " ", "Server Groups ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "loadBalancers.filter.serverGroups"
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, " ", /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      name: "showInstances",
      checked: this.state.showInstances,
      onChange: this.handleInputChange
    }), " ", "Instances", " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      key: "loadBalancers.filter.instances",
      placement: "right",
      id: "loadBalancers.filter.instances"
    })))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-lg-4 col-md-2"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-inline clearfix filters"
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "application-actions"
    }, /* @__PURE__ */ React__default.createElement(CreateLoadBalancerButton, {
      app: this.props.app
    }))), /* @__PURE__ */ React__default.createElement(FilterTags, {
      tags: this.state.tags,
      tagCleared: this.tagCleared,
      clearFilters: this.clearFilters
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "content"
    }, /* @__PURE__ */ React__default.createElement(BannerContainer, {
      app: this.props.app
    }), groupings));
  }
}
__decorateClass$a([
  Debounce(200)
], LoadBalancers$1.prototype, "updateLoadBalancerGroups", 1);

const poolValueCoordinates$2 = [
  { filterField: "providerType", on: "loadBalancer", localField: "type" },
  { filterField: "account", on: "loadBalancer", localField: "account" },
  { filterField: "region", on: "loadBalancer", localField: "region" },
  { filterField: "availabilityZone", on: "instance", localField: "zone" }
];
function poolBuilder$2(loadBalancers) {
  const pool = chain(loadBalancers).map((lb) => {
    const poolUnitTemplate = chain(poolValueCoordinates$2).filter({ on: "loadBalancer" }).reduce((acc, coordinate) => {
      acc[coordinate.filterField] = lb[coordinate.localField];
      return acc;
    }, {}).value();
    const poolUnits = chain(["instances", "detachedInstances"]).map((instanceStatus) => lb[instanceStatus]).flatten().map((instance) => {
      const poolUnit = cloneDeep(poolUnitTemplate);
      if (!instance) {
        return poolUnit;
      }
      return chain(poolValueCoordinates$2).filter({ on: "instance" }).reduce((acc, coordinate) => {
        acc[coordinate.filterField] = instance[coordinate.localField];
        return acc;
      }, poolUnit).value();
    }).value();
    if (!poolUnits.length) {
      poolUnits.push(poolUnitTemplate);
    }
    return poolUnits;
  }).flatten().value();
  return pool;
}
class LoadBalancerFilters extends React__default.Component {
  constructor(props) {
    super(props);
    this.updateLoadBalancerGroups = (applyParamsToUrl = true) => {
      const { app } = this.props;
      if (applyParamsToUrl) {
        LoadBalancerState.filterModel.asFilterModel.applyParamsToUrl();
      }
      LoadBalancerState.filterService.updateLoadBalancerGroups(app);
      const { availabilityZone, region, account } = digestDependentFilters({
        sortFilter: LoadBalancerState.filterModel.asFilterModel.sortFilter,
        dependencyOrder: ["providerType", "account", "region", "availabilityZone"],
        pool: poolBuilder$2(app.loadBalancers.data)
      });
      this.setState({
        accountHeadings: account,
        regionHeadings: region,
        availabilityZoneHeadings: availabilityZone,
        loadBalancerTypeHeadings: this.getHeadingsForOption("loadBalancerType"),
        stackHeadings: ["(none)"].concat(this.getHeadingsForOption("stack")),
        detailHeadings: ["(none)"].concat(this.getHeadingsForOption("detail")),
        providerTypeHeadings: this.getHeadingsForOption("type")
      });
    };
    this.getHeadingsForOption = (option) => {
      return compact(uniq(map$1(this.props.app.loadBalancers.data, option))).sort();
    };
    this.handleStatusChange = (event) => {
      const target = event.target;
      const value = target.type === "checkbox" ? target.checked : target.value;
      const name = target.name;
      this.state.sortFilter.status[name] = Boolean(value);
      this.updateLoadBalancerGroups();
    };
    this.handleSearchBlur = (event) => {
      const target = event.target;
      this.state.sortFilter.filter = target.value;
      this.updateLoadBalancerGroups();
    };
    this.handleSearchChange = (event) => {
      const target = event.target;
      this.state.sortFilter.filter = target.value;
      this.setState({ sortFilter: this.state.sortFilter });
      this.debouncedUpdateLoadBalancerGroups();
    };
    this.state = {
      sortFilter: LoadBalancerState.filterModel.asFilterModel.sortFilter,
      tags: LoadBalancerState.filterModel.asFilterModel.tags,
      availabilityZoneHeadings: [],
      loadBalancerTypeHeadings: [],
      providerTypeHeadings: [],
      accountHeadings: [],
      regionHeadings: [],
      stackHeadings: [],
      detailHeadings: []
    };
    this.debouncedUpdateLoadBalancerGroups = debounce(this.updateLoadBalancerGroups, 300);
  }
  componentDidMount() {
    const { app } = this.props;
    this.groupsUpdatedSubscription = LoadBalancerState.filterService.groupsUpdatedStream.subscribe(() => {
      this.setState({ tags: LoadBalancerState.filterModel.asFilterModel.tags });
    });
    if (app.loadBalancers && app.loadBalancers.loaded) {
      this.updateLoadBalancerGroups();
    }
    this.loadBalancersRefreshUnsubscribe = app.loadBalancers.onRefresh(null, () => this.updateLoadBalancerGroups());
    this.locationChangeUnsubscribe = $rootScope.$on("$locationChangeSuccess", () => {
      LoadBalancerState.filterModel.asFilterModel.activate();
      LoadBalancerState.filterService.updateLoadBalancerGroups(app);
    });
  }
  componentWillUnmount() {
    this.groupsUpdatedSubscription.unsubscribe();
    this.loadBalancersRefreshUnsubscribe();
    this.locationChangeUnsubscribe();
  }
  render() {
    const loadBalancersLoaded = this.props.app.loadBalancers.loaded;
    const {
      accountHeadings,
      loadBalancerTypeHeadings,
      providerTypeHeadings,
      regionHeadings,
      stackHeadings,
      detailHeadings,
      availabilityZoneHeadings,
      sortFilter
    } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "insight-filter-content"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "heading"
    }, /* @__PURE__ */ React__default.createElement(FilterSearch, {
      helpKey: "loadBalancer.search",
      value: sortFilter.filter,
      onBlur: this.handleSearchBlur,
      onSearchChange: this.handleSearchChange
    })), loadBalancersLoaded && /* @__PURE__ */ React__default.createElement("div", {
      className: "content"
    }, providerTypeHeadings.length > 1 && /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Provider",
      expanded: true
    }, providerTypeHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      isCloudProvider: true,
      key: heading,
      sortFilterType: sortFilter.providerType,
      onChange: this.updateLoadBalancerGroups
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Account",
      expanded: true
    }, accountHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      key: heading,
      sortFilterType: sortFilter.account,
      onChange: this.updateLoadBalancerGroups
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Region",
      expanded: true
    }, regionHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      key: heading,
      sortFilterType: sortFilter.region,
      onChange: this.updateLoadBalancerGroups
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Stack",
      expanded: true
    }, stackHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      key: heading,
      sortFilterType: sortFilter.stack,
      onChange: this.updateLoadBalancerGroups
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Detail",
      expanded: true
    }, detailHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      key: heading,
      sortFilterType: sortFilter.detail,
      onChange: this.updateLoadBalancerGroups
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Type",
      expanded: true
    }, loadBalancerTypeHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      key: heading,
      sortFilterType: sortFilter.loadBalancerType,
      onChange: this.updateLoadBalancerGroups
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Instance Status",
      expanded: true
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: Boolean(sortFilter.status && sortFilter.status.Up),
      onChange: this.handleStatusChange,
      name: "Up"
    }), "Healthy")), /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: Boolean(sortFilter.status && sortFilter.status.Down),
      onChange: this.handleStatusChange,
      name: "Down"
    }), "Unhealthy")), /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: Boolean(sortFilter.status && sortFilter.status.OutOfService),
      onChange: this.handleStatusChange,
      name: "OutOfService"
    }), "Out of Service")))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Availability Zones",
      expanded: true
    }, availabilityZoneHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      key: heading,
      sortFilterType: sortFilter.availabilityZone,
      onChange: this.updateLoadBalancerGroups
    })))));
  }
}

const LOAD_BALANCER_STATES = "spinnaker.core.loadBalancer.states";
module(LOAD_BALANCER_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  "stateConfigProvider",
  (applicationStateProvider, stateConfigProvider) => {
    const loadBalancerDetails = {
      name: "loadBalancerDetails",
      url: "/loadBalancerDetails/:provider/:accountId/:region/:vpcId/:name",
      params: {
        vpcId: {
          value: null,
          squash: true
        }
      },
      views: {
        "detail@../insight": {
          component: LoadBalancerDetails,
          $type: "react"
        }
      },
      resolve: {
        accountId: ["$stateParams", ($stateParams) => $stateParams.accountId],
        loadBalancer: [
          "$stateParams",
          ($stateParams) => {
            return {
              name: $stateParams.name,
              accountId: $stateParams.accountId,
              region: $stateParams.region,
              vpcId: $stateParams.vpcId
            };
          }
        ]
      },
      data: {
        pageTitleDetails: {
          title: "Load Balancer Details",
          nameParam: "name",
          accountParam: "accountId",
          regionParam: "region"
        },
        history: {
          type: "loadBalancers"
        }
      }
    };
    const loadBalancers = {
      url: `/loadBalancers?${stateConfigProvider.paramsToQuery(filterModelConfig$2)}`,
      name: "loadBalancers",
      views: {
        nav: { component: LoadBalancerFilters, $type: "react" },
        master: { component: LoadBalancers$1, $type: "react" }
      },
      params: stateConfigProvider.buildDynamicParams(filterModelConfig$2),
      data: {
        pageTitleSection: {
          title: "Load Balancers"
        }
      },
      children: []
    };
    applicationStateProvider.addInsightState(loadBalancers);
    applicationStateProvider.addInsightDetailState(loadBalancerDetails);
  }
]);

class LoadBalancersSearchResultType extends SearchResultType {
  constructor() {
    super(...arguments);
    this.id = "loadBalancers";
    this.order = 5;
    this.displayName = "Load Balancers";
    this.iconClass = "fa icon-sitemap";
    this.cols = {
      LOADBALANCER: { key: "loadBalancer", label: "Name" },
      ACCOUNT: { key: "account" },
      REGION: { key: "region" },
      TYPE: { key: "loadBalancerType", label: "Type" }
    };
    this.TabComponent = DefaultSearchResultTab;
    this.HeaderComponent = () => /* @__PURE__ */ React__default.createElement(SearchTableHeader, null, /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.LOADBALANCER
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.ACCOUNT
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.REGION
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.TYPE
    }));
    this.DataComponent = ({ resultSet }) => {
      const itemKeyFn = (item) => [item.loadBalancer, item.account, item.region].join("|");
      const itemSortFn = (a, b) => {
        const order = a.loadBalancer.localeCompare(b.loadBalancer);
        return order !== 0 ? order : a.region.localeCompare(b.region);
      };
      const results = resultSet.results.slice().sort(itemSortFn);
      return /* @__PURE__ */ React__default.createElement(SearchTableBody, null, results.slice().sort(itemSortFn).map((item) => /* @__PURE__ */ React__default.createElement(SearchTableRow, {
        key: itemKeyFn(item)
      }, /* @__PURE__ */ React__default.createElement(HrefCell, {
        item,
        col: this.cols.LOADBALANCER
      }), /* @__PURE__ */ React__default.createElement(AccountCell, {
        item,
        col: this.cols.ACCOUNT
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.REGION
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.TYPE
      }))));
    };
  }
  displayFormatter(searchResult, fromRoute) {
    const name = fromRoute ? searchResult.name : searchResult.loadBalancer;
    return `${name} (${searchResult.region})`;
  }
}
searchResultTypeRegistry.register(new LoadBalancersSearchResultType());

const LOAD_BALANCER_MODULE = "spinnaker.core.loadBalancer";
module(LOAD_BALANCER_MODULE, [LOAD_BALANCER_DATA_SOURCE, LOAD_BALANCER_STATES]);

var css_248z$K = ".ManagedResourceConfig .rainbow-icon {\n  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.5);\n}\n.ManagedResourceConfig .paused-warning {\n  background-color: var(--color-warning-light);\n}\n";
styleInject(css_248z$K);

const logClick = (label, application) => logger.log({
  category: "Managed Resource Config",
  action: `${label} clicked`,
  data: { label: application }
});
const getManagementStatus = (paused) => {
  if (paused) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "sp-padding-m sp-margin-m-bottom paused-warning"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-pause sp-margin-xs-right"
    }), " ", /* @__PURE__ */ React__default.createElement("b", null, "Resource management is paused.")), /* @__PURE__ */ React__default.createElement("p", {
      className: "sp-margin-l-bottom"
    }, "Spinnaker is configured to manage some of this application's resources, but management has been paused. When resumed, Spinnaker will take action to make each resource match its desired state."));
  } else {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "rainbow-icon"
    }, "\u{1F308}"), " ", /* @__PURE__ */ React__default.createElement("b", null, "Spinnaker is managing some resources.")), /* @__PURE__ */ React__default.createElement("p", {
      className: "sp-margin-l-bottom"
    }, "If you need to temporarily stop Spinnaker from managing resources \u2014 for example, if something is wrong and manual intervention is required \u2014 you can pause management and resume it later. Pausing affects all managed resources within this application."));
  }
};
const ManagedResourceConfigInternal = ({ application }) => {
  var _a;
  const appName = application.name;
  const { data, loading } = useFetchApplicationManagementStatusQuery({ variables: { appName } });
  const [toggleManagement, { loading: pausePending, error: pauseFailed }] = useToggleManagementMutation({
    refetchQueries: [{ query: FetchApplicationManagementDataDocument, variables: { appName } }]
  });
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium",
      message: "Loading management state..."
    });
  }
  if (!data)
    return null;
  const paused = Boolean((_a = data == null ? void 0 : data.application) == null ? void 0 : _a.isPaused);
  const iconClass = paused ? "fa-play" : "fa-pause";
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "ManagedResourceConfig"
  }, getManagementStatus(paused), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    disabled: pausePending,
    onClick: () => toggleManagement({ variables: { isPaused: !paused, application: appName } }),
    type: "button"
  }, !pausePending && /* @__PURE__ */ React__default.createElement("i", {
    className: classNames("fa sp-margin-xs-right", iconClass)
  }) || /* @__PURE__ */ React__default.createElement(Spinner, {
    mode: "circular"
  }), " ", paused ? "Resume Management" : "Pause Management"), pauseFailed && /* @__PURE__ */ React__default.createElement("div", {
    className: "sp-margin-l-top"
  }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    type: "error",
    message: "Saving failed."
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "color-text-caption sp-margin-l-top"
  }, "Not sure what this means?", " ", /* @__PURE__ */ React__default.createElement("a", {
    target: "_blank",
    onClick: () => logClick("Documentation", application.name),
    href: getDocsUrl("root")
  }, "Check out our documentation")));
};
const ManagedResourceConfig = (props) => {
  const { client } = React__default.useMemo(createApolloClient, []);
  return /* @__PURE__ */ React__default.createElement(ApolloProvider, {
    client
  }, /* @__PURE__ */ React__default.createElement(ManagedResourceConfigInternal, {
    ...props
  }));
};
const MANAGED_RESOURCE_CONFIG = "spinnaker.core.managedResourceConfig.component";
module(MANAGED_RESOURCE_CONFIG, []).component("managedResourceConfig", react2angular(withErrorBoundary(ManagedResourceConfig, "managedResourceConfig"), ["application"]));

const FUNCTION_DATA_SOURCE = "spinnaker.core.functions.dataSource";
module(FUNCTION_DATA_SOURCE, [FUNCTION_READ_SERVICE]).run([
  "$q",
  "functionReader",
  ($q, functionReader) => {
    if (!SETTINGS.feature.functions) {
      return;
    }
    const functions = (application) => {
      return functionReader.loadFunctions(application.name);
    };
    const addFunctions = (_application, functionList) => {
      return $q.when(functionList);
    };
    const addTags = (application) => {
      EntityTagsReader.addTagsToFunctions(application);
    };
    ApplicationDataSourceRegistry.registerDataSource({
      key: "functions",
      label: "functions",
      sref: ".insight.functions",
      category: INFRASTRUCTURE_KEY,
      optional: true,
      icon: "fa fa-xs fa-fw fa-asterisk",
      iconName: "spMenuFunctions",
      loader: functions,
      onLoad: addFunctions,
      afterLoad: addTags,
      providerField: "cloudProvider",
      credentialsField: "account",
      regionField: "region",
      description: "Serverless Compute Service.",
      defaultData: []
    });
  }
]);

const Function = (props) => {
  const { application, functionDef } = props;
  const params = {
    application: application.name,
    region: functionDef.region,
    account: functionDef.account,
    functionName: functionDef.functionName,
    cloudProvider: functionDef.cloudProvider
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "pod-subgroup function"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "function-header sticky-header-2"
  }, /* @__PURE__ */ React__default.createElement(UISrefActive, {
    class: "active"
  }, /* @__PURE__ */ React__default.createElement(UISref, {
    to: ".functionDetails",
    params
  }, /* @__PURE__ */ React__default.createElement("h6", {
    className: "clickable clickable-row horizontal middle"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-xs fa-fw fa-asterisk"
  }), "\xA0 ", (functionDef.region || "").toUpperCase(), /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-1"
  }, /* @__PURE__ */ React__default.createElement(EntityNotifications, {
    entity: functionDef,
    application,
    placement: "bottom",
    entityType: "function",
    pageLocation: "pod",
    onUpdate: () => application.functions.refresh()
  })))))));
};

class FunctionPod extends React__default.Component {
  render() {
    const { grouping, application, parentHeading } = this.props;
    const subgroups = grouping.subgroups.map((subgroup) => /* @__PURE__ */ React__default.createElement(Function, {
      key: subgroup.functionDef.functionName,
      application,
      functionDef: subgroup.functionDef
    }));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "load-balancer-pod row rollup-entry sub-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-summary sticky-header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-title-cell"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "heading-tag"
    }, /* @__PURE__ */ React__default.createElement(AccountTag, {
      account: parentHeading
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "pod-center horizontal space-between center flex-1"
    }, /* @__PURE__ */ React__default.createElement("div", null, grouping.heading)))), /* @__PURE__ */ React__default.createElement("div", {
      className: "rollup-details"
    }, subgroups));
  }
}

class FunctionGroupings extends React__default.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, this.props.groups.map((group) => /* @__PURE__ */ React__default.createElement("div", {
      key: group.heading,
      className: "rollup"
    }, group.subgroups && group.subgroups.map((subgroup) => /* @__PURE__ */ React__default.createElement(FunctionPod, {
      key: subgroup.heading,
      grouping: subgroup,
      application: this.props.app,
      parentHeading: group.heading
    })))));
  }
}

var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$9(target, key, result);
  return result;
};
class Functions extends React__default.Component {
  constructor(props) {
    super(props);
    this.clearFilters = () => {
      FunctionState.filterService.clearFilters();
      this.updateFunctionGroups();
    };
    this.tagCleared = () => {
      this.updateFunctionGroups();
    };
    this.state = {
      initialized: false,
      groups: [],
      tags: []
    };
  }
  componentDidMount() {
    const { app } = this.props;
    this.groupsUpdatedListener = FunctionState.filterService.groupsUpdatedStream.subscribe(() => this.groupsUpdated());
    FunctionState.filterModel.asFilterModel.activate();
    this.functionsRefreshUnsubscribe = app.getDataSource("functions").onRefresh(null, () => this.updateFunctionGroups());
    app.setActiveState(app.loadBalancers);
    this.updateFunctionGroups();
  }
  componentWillUnmount() {
    this.groupsUpdatedListener.unsubscribe();
    this.functionsRefreshUnsubscribe();
  }
  groupsUpdated() {
    this.setState({
      groups: FunctionState.filterModel.asFilterModel.groups,
      tags: FunctionState.filterModel.asFilterModel.tags
    });
  }
  updateFunctionGroups() {
    FunctionState.filterModel.asFilterModel.applyParamsToUrl();
    FunctionState.filterService.updateFunctionGroups(this.props.app);
    this.groupsUpdated();
    if (this.props.app.getDataSource("functions").loaded) {
      this.setState({ initialized: true });
    }
  }
  render() {
    const groupings = this.state.initialized ? /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(FunctionGroupings, {
      app: this.props.app,
      groups: this.state.groups
    }), this.state.groups.length === 0 && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h4", {
      className: "text-center"
    }, "No functions match the filters you've selected."))) : /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    }));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "main-content functions"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "header row header-clusters"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-lg-4 col-md-2"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-inline clearfix filters"
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "application-actions"
    }, /* @__PURE__ */ React__default.createElement(CreateFunctionButton, {
      app: this.props.app
    }))), /* @__PURE__ */ React__default.createElement(FilterTags, {
      tags: this.state.tags,
      tagCleared: this.tagCleared,
      clearFilters: this.clearFilters
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "content"
    }, groupings));
  }
}
__decorateClass$9([
  Debounce(200)
], Functions.prototype, "updateFunctionGroups", 1);

const poolValueCoordinates$1 = [
  { filterField: "providerType", on: "function", localField: "type" },
  { filterField: "account", on: "function", localField: "account" },
  { filterField: "region", on: "function", localField: "region" }
];
function poolBuilder$1(functions) {
  const pool = chain(functions).map((fn) => {
    const poolUnits = chain(poolValueCoordinates$1).filter({ on: "function" }).reduce((acc, coordinate) => {
      acc[coordinate.filterField] = fn[coordinate.localField];
      return acc;
    }, {}).value();
    return poolUnits;
  }).flatten().value();
  return pool;
}
class FunctionFilters extends React__default.Component {
  constructor(props) {
    super(props);
    this.updateFunctionGroups = (applyParamsToUrl = true) => {
      const { app } = this.props;
      if (applyParamsToUrl) {
        FunctionState.filterModel.asFilterModel.applyParamsToUrl();
      }
      FunctionState.filterService.updateFunctionGroups(app);
      const { region, account } = digestDependentFilters({
        sortFilter: FunctionState.filterModel.asFilterModel.sortFilter,
        dependencyOrder: ["providerType", "account", "region"],
        pool: poolBuilder$1(app.functions.data)
      });
      this.setState({
        accountHeadings: account,
        regionHeadings: region,
        providerTypeHeadings: this.getHeadingsForOption("type")
      });
    };
    this.getHeadingsForOption = (option) => {
      return compact(uniq(map$1(this.props.app.functions.data, option))).sort();
    };
    this.handleSearchBlur = (event) => {
      const target = event.target;
      this.state.sortFilter.filter = target.value;
      this.updateFunctionGroups();
    };
    this.handleSearchChange = (event) => {
      const target = event.target;
      this.state.sortFilter.filter = target.value;
      this.setState({ sortFilter: this.state.sortFilter });
      this.debouncedUpdateFunctionGroups();
    };
    this.state = {
      sortFilter: FunctionState.filterModel.asFilterModel.sortFilter,
      tags: FunctionState.filterModel.asFilterModel.tags,
      providerTypeHeadings: [],
      accountHeadings: [],
      regionHeadings: []
    };
    this.debouncedUpdateFunctionGroups = debounce(this.updateFunctionGroups, 300);
  }
  componentDidMount() {
    const { app } = this.props;
    this.groupsUpdatedSubscription = FunctionState.filterService.groupsUpdatedStream.subscribe(() => {
      this.setState({ tags: FunctionState.filterModel.asFilterModel.tags });
    });
    if (app.functions && app.functions.loaded) {
      this.updateFunctionGroups();
    }
    this.functionsRefreshUnsubscribe = app.functions.onRefresh(null, () => this.updateFunctionGroups());
    this.locationChangeUnsubscribe = $rootScope.$on("$locationChangeSuccess", () => {
      FunctionState.filterModel.asFilterModel.activate();
      FunctionState.filterService.updateFunctionGroups(app);
    });
  }
  componentWillUnmount() {
    this.groupsUpdatedSubscription.unsubscribe();
    this.functionsRefreshUnsubscribe();
    this.locationChangeUnsubscribe();
  }
  render() {
    const fuctionsLoaded = this.props.app.functions.loaded;
    const { accountHeadings, providerTypeHeadings, regionHeadings, sortFilter } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "insight-filter-content"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "heading"
    }, /* @__PURE__ */ React__default.createElement(FilterSearch, {
      helpKey: "functions.search",
      value: sortFilter.filter,
      onBlur: this.handleSearchBlur,
      onSearchChange: this.handleSearchChange
    })), fuctionsLoaded && /* @__PURE__ */ React__default.createElement("div", {
      className: "content"
    }, providerTypeHeadings.length > 1 && /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Provider",
      expanded: true
    }, providerTypeHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      isCloudProvider: true,
      key: heading,
      sortFilterType: sortFilter.providerType,
      onChange: this.updateFunctionGroups
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Account",
      expanded: true
    }, accountHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      key: heading,
      sortFilterType: sortFilter.account,
      onChange: this.updateFunctionGroups
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Region",
      expanded: true
    }, regionHeadings.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
      heading,
      key: heading,
      sortFilterType: sortFilter.region,
      onChange: this.updateFunctionGroups
    })))));
  }
}

const FUNCTION_STATES = "spinnaker.core.functions.states";
module(FUNCTION_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  "stateConfigProvider",
  (applicationStateProvider, stateConfigProvider) => {
    if (!SETTINGS.feature.functions) {
      return;
    }
    const functionDetails = {
      name: "functionDetails",
      url: "/functionDetails/:cloudProvider/:account/:region/:functionName",
      views: {
        "detail@../insight": {
          component: FunctionDetails,
          $type: "react"
        }
      },
      resolve: {
        accountId: ["$stateParams", ($stateParams) => $stateParams.account],
        functionObj: [
          "$stateParams",
          ($stateParams) => {
            return {
              functionName: $stateParams.functionName,
              account: $stateParams.account,
              region: $stateParams.region
            };
          }
        ]
      },
      data: {
        pageTitleDetails: {
          title: "Function Details",
          nameParam: "functionName",
          accountParam: "credentials",
          regionParam: "region"
        },
        history: {
          type: "functions"
        }
      }
    };
    const functions = {
      url: `/functions?${stateConfigProvider.paramsToQuery(filterModelConfig$3)}`,
      name: "functions",
      views: {
        nav: { component: FunctionFilters, $type: "react" },
        master: { component: Functions, $type: "react" }
      },
      params: stateConfigProvider.buildDynamicParams(filterModelConfig$3),
      data: {
        pageTitleSection: {
          title: "Functions"
        }
      },
      children: []
    };
    applicationStateProvider.addInsightState(functions);
    applicationStateProvider.addInsightDetailState(functionDetails);
  }
]);

const FUNCTION_MODULE = "spinnaker.core.function";
module(FUNCTION_MODULE, [FUNCTION_DATA_SOURCE, FUNCTION_STATES]);

class NetworkInterceptor {
  constructor($q, $window, $timeout, $injector) {
    this.$q = $q;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$injector = $injector;
    this.retryQueue = {};
    this.MAX_RETRIES = 4;
    this.handleOffline = () => {
      this.networkAvailable = this.$q.defer();
    };
    this.handleOnline = () => {
      this.networkAvailable.resolve();
      this.resetNetworkAvailable();
    };
    this.responseError = (response) => {
      const { config, status } = response;
      const retryCount = this.retryQueue[config.url] || 0;
      if (status === -1 && retryCount < this.MAX_RETRIES) {
        this.retryQueue[config.url] = retryCount + 1;
        return this.networkAvailable.promise.then(() => {
          return this.$timeout(() => {
            return this.$q.resolve(this.$injector.get("$http")(config)).then((result) => {
              this.removeFromQueue(config);
              return result;
            });
          }, (retryCount + 1 + Math.random()) * 1e3);
        });
      }
      return this.$q.reject(response).finally(() => this.removeFromQueue(config));
    };
    this.$window.addEventListener("offline", this.handleOffline);
    this.$window.addEventListener("online", this.handleOnline);
    this.resetNetworkAvailable();
  }
  resetNetworkAvailable() {
    this.networkAvailable = this.$q.defer();
    this.networkAvailable.resolve();
  }
  removeFromQueue(config) {
    delete this.retryQueue[config.url];
  }
}
NetworkInterceptor.$inject = ["$q", "$window", "$timeout", "$injector"];
const NETWORK_INTERCEPTOR = "spinnaker.core.network.interceptor";
module(NETWORK_INTERCEPTOR, []).service("networkInterceptor", NetworkInterceptor).config([
  "$httpProvider",
  ($httpProvider) => {
    $httpProvider.interceptors.push("networkInterceptor");
  }
]);

const PAGE_TITLE_MODULE = "spinnaker.core.pageTitle";
module(PAGE_TITLE_MODULE, [PAGE_TITLE_SERVICE]);

class PageModalCtrl {
  constructor($uibModalInstance, application) {
    this.$uibModalInstance = $uibModalInstance;
    this.application = application;
  }
  submit() {
    const taskMonitorConfig = {
      application: this.application,
      title: `Paging ${this.application.name} owner`,
      modalInstance: this.$uibModalInstance
    };
    const submitMethod = () => {
      const reason = `[${this.application.name.toUpperCase()}] ${this.reason}`;
      return PagerDutyWriter.pageApplicationOwner(this.application, reason);
    };
    this.taskMonitor = new TaskMonitor(taskMonitorConfig);
    this.taskMonitor.submit(submitMethod);
  }
}
PageModalCtrl.$inject = ["$uibModalInstance", "application"];
const PAGE_MODAL_CONTROLLER = "spinnaker.core.pageApplicationOwner.modal.controller";
module(PAGE_MODAL_CONTROLLER, []).controller("PageModalCtrl", PageModalCtrl);

class PageModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.close = (evt) => {
      evt && evt.stopPropagation();
      this.setState(this.getDefaultState(this.props));
      this.props.closeCallback(false);
    };
    this.handleSubjectChanged = (event) => {
      const value = event.target.value;
      ReactInjector.$state.go(".", { subject: value }, { location: "replace" });
      this.setState({ subject: value });
    };
    this.handleDetailsChanged = (event) => {
      const value = event.target.value;
      ReactInjector.$state.go(".", { details: value }, { location: "replace" });
      this.setState({ details: value });
    };
    this.sendPage = () => {
      const { applications, services } = this.props;
      const defaultApp = ApplicationModelBuilder.createStandaloneApplication("spinnaker");
      const ownerApp = applications && applications.length === 1 ? applications[0] : defaultApp;
      const taskMonitor = new TaskMonitor({
        application: ownerApp,
        title: `Sending page to ${this.state.pageCount} policies`,
        modalInstance: TaskMonitor.modalInstanceEmulation(() => this.close())
      });
      const submitMethod = () => {
        const { subject, details } = this.state;
        return PagerDutyWriter.sendPage(applications, services.map((s) => s.integration_key), subject, ownerApp, {
          details
        });
      };
      taskMonitor.submit(submitMethod);
      this.setState({ taskMonitor, submitting: true });
    };
    this.state = this.getDefaultState(props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.services.length !== this.state.pageCount) {
      this.setState({ pageCount: nextProps.services.length });
    }
  }
  getDefaultState(props) {
    const {
      $uiRouter: {
        globals: {
          params: { subject, details }
        }
      }
    } = ReactInjector;
    const defaultSubject = subject || get(SETTINGS, "pagerDuty.defaultSubject", "Urgent Issue");
    const defaultDetails = details || get(SETTINGS, "pagerDuty.defaultDetails", "");
    return {
      accountName: SETTINGS.pagerDuty && SETTINGS.pagerDuty.accountName || "",
      subject: defaultSubject,
      details: defaultDetails,
      pageCount: props.services.length,
      submitting: false,
      taskMonitor: null
    };
  }
  render() {
    const { services } = this.props;
    const { accountName, details, pageCount, subject, submitting, taskMonitor } = this.state;
    return /* @__PURE__ */ React__default.createElement(Modal$1, {
      show: this.props.show,
      onHide: this.close,
      className: "page-modal",
      backdrop: "static"
    }, /* @__PURE__ */ React__default.createElement(TaskMonitorWrapper, {
      monitor: taskMonitor
    }), !submitting && /* @__PURE__ */ React__default.createElement(Modal$1.Header, {
      closeButton: true
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Page ", pageCount, " ", pageCount === 1 ? "service" : "services")), !submitting && /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("label", null, "Services to Page"), /* @__PURE__ */ React__default.createElement("div", null, services.map((service) => /* @__PURE__ */ React__default.createElement("span", {
      className: "service-to-page",
      key: service.integration_key
    }, /* @__PURE__ */ React__default.createElement("a", {
      title: service.name,
      href: `https://${accountName}.pagerduty.com/services/${service.id}`,
      target: "_blank"
    }, service.name))))), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("label", null, "Subject"), /* @__PURE__ */ React__default.createElement("input", {
      name: "subject",
      type: "text",
      style: { width: "100%" },
      value: subject,
      onChange: this.handleSubjectChanged
    })), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("label", null, "Details (Not visible/heard in phone/SMS)"), /* @__PURE__ */ React__default.createElement("textarea", {
      name: "details",
      style: { width: "100%", height: "260px" },
      value: details,
      onChange: this.handleDetailsChanged
    })))), !submitting && /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement(Button$1, {
      onClick: this.close
    }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
      label: "Send Page",
      submitting,
      isDisabled: submitting,
      onClick: this.sendPage
    })));
  }
}

class PageButton extends React__default.Component {
  constructor(props) {
    super(props);
    this.closeCallback = (succeeded) => {
      this.setState({ showModal: false });
      this.props.closeCallback(succeeded);
    };
    this.sendPage = () => {
      this.setState({ showModal: true });
    };
    this.state = {
      showModal: props.forceOpen || false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.forceOpen && !this.state.showModal) {
      this.setState({ showModal: true });
    }
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("button", {
      disabled: this.props.disabled,
      className: "btn btn-sm btn-primary",
      style: { marginRight: "5px" },
      onClick: this.sendPage
    }, /* @__PURE__ */ React__default.createElement("span", null, "Send Page"), this.state.showModal && /* @__PURE__ */ React__default.createElement(PageModal, {
      show: this.state.showModal,
      closeCallback: this.closeCallback,
      applications: this.props.applications,
      services: this.props.services
    }));
  }
}

var css_248z$J = ".on-call {\n  flex-direction: column;\n  display: flex;\n}\n.on-call input[type='text'] {\n  padding: 0 5px;\n}\n.on-call input::-moz-placeholder {\n  color: var(--color-titanium);\n  font-size: 12px;\n}\n.on-call input::placeholder {\n  color: var(--color-titanium);\n  font-size: 12px;\n}\n.on-call .hide-checkbox {\n  padding-left: 15px;\n  padding-top: 4px;\n  font-weight: 400;\n}\n.on-call .on-call-table {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  height: 100%;\n  margin-bottom: 50px;\n}\n.on-call .on-call-table .highlighted {\n  background-color: var(--color-warning-light);\n}\n.on-call .on-call-table .table-header {\n  font-weight: 600;\n  font-size: 13px;\n}\n.on-call .on-call-table .ReactVirtualized__Table__row.on-call-row {\n  align-items: stretch;\n}\n.on-call .on-call-table .ReactVirtualized__Table__row.on-call-row:focus {\n  outline: none;\n}\n.on-call .on-call-table .ReactVirtualized__Grid.ReactVirtualized__Table__Grid:focus {\n  outline: 0;\n}\n.on-call .on-call-table .on-call-row:before {\n  content: ' ';\n  left: 0;\n  right: 0;\n  top: 5px;\n  bottom: 5px;\n  position: absolute;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-seashell);\n  z-index: -99999;\n}\n.on-call .on-call-table .on-call-row:hover:before {\n  border-color: var(--color-concrete);\n}\n.on-call .on-call-table .on-call-row.selected:before {\n  border-color: var(--color-accent);\n}\n.on-call .on-call-table .on-call-row.disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.on-call .on-call-table .on-call-row.disabled:hover:before {\n  border-color: var(--color-seashell);\n}\n.on-call .on-call-table .on-call-row.disabled .page-checkbox .fa {\n  cursor: not-allowed;\n}\n.on-call .on-call-table .on-call-row.disabled .page-checkbox .fa:hover {\n  background: var(--color-cirrus);\n  color: var(--color-cirrus);\n}\n.on-call .on-call-table .col-page {\n  overflow: hidden;\n}\n.on-call .on-call-table .col-service {\n  font-size: 15px;\n  font-weight: 600;\n}\n.on-call .on-call-table .col-service a {\n  color: var(--color-black);\n}\n.on-call .on-call-table .col-service a:hover {\n  color: var(--color-primary);\n}\n.on-call .on-call-table .col-application {\n  white-space: normal;\n  color: var(--color-concrete);\n  font-size: 12px;\n}\n.on-call .on-call-table .col-application a {\n  color: var(--color-concrete);\n}\n.on-call .on-call-table .col-application a:hover {\n  color: var(--color-primary);\n}\n.on-call .on-call-table .col-on-call {\n  font-size: 12px;\n}\n.on-call .on-call-table .col-incident {\n  font-size: 12px;\n}\n.on-call .on-call-table .users {\n  display: flex;\n  margin: 3px 0;\n}\n.on-call .on-call-table .users > div > a {\n  display: block;\n}\n.on-call .on-call-table .users .user-level {\n  flex: 0 1 auto;\n  color: var(--color-titanium);\n  padding-right: 3px;\n  margin-right: 5px;\n  border-right: 1px solid var(--color-alto);\n}\n.on-call .on-call-table .users .user-names {\n  flex: 1 1 auto;\n}\n.on-call .on-call-table .page-checkbox {\n  width: 20px;\n  height: 20px;\n  position: relative;\n  border: 2px solid var(--color-titanium);\n  border-radius: 50%;\n  background-color: var(--color-cirrus);\n}\n.on-call .on-call-table .page-checkbox.checked {\n  border-color: var(--color-accent);\n}\n.on-call .on-call-table .page-checkbox.checked .fa {\n  color: var(--color-accent);\n}\n.on-call .on-call-table .page-checkbox .fa {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--color-cirrus);\n}\n.on-call .on-call-table .page-checkbox .fa:hover {\n  color: var(--color-titanium);\n}\n.on-call .on-call-filter {\n  max-height: 40px;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid var(--color-accent-g2);\n}\n.on-call .on-call-filter > span {\n  margin-top: 4px;\n  margin-right: 10px;\n}\n.on-call .on-call-filter > input {\n  width: 250px;\n}\n.on-call .page-actions {\n  height: 60px;\n  padding: 5px;\n  align-self: flex-end;\n}\n.infrastructure .fa-bullhorn {\n  display: inline-block;\n  border-radius: 50%;\n  background-color: var(--color-primary);\n  border: 2px solid var(--color-white);\n  color: var(--color-white);\n  margin-right: 5px;\n  width: 32px;\n  height: 32px;\n  line-height: 29px;\n  font-size: 14px;\n  margin-left: 5px;\n  text-align: center;\n}\n.infrastructure .pager-header {\n  background-color: var(--color-accent-g2);\n  flex: 0 0 auto;\n}\n.infrastructure .pager-header .pager {\n  display: flex;\n  align-content: center;\n  margin-top: 22px;\n}\n.infrastructure .pager-label {\n  font-size: 24px;\n  padding: 0 5px;\n  line-height: 29px;\n  color: var(--color-primary);\n}\n.main-footer {\n  border-top: 1px solid var(--color-alto);\n  padding-top: 10px;\n  margin-top: 10px;\n}\n.main-footer .alert {\n  display: inline-block;\n  margin-bottom: 0;\n  padding: 6px 12px;\n  vertical-align: middle;\n}\n.on-call-footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 10px;\n  background-color: var(--color-white);\n  margin: 0;\n  border-top: 1px solid var(--color-alto);\n  display: flex;\n  justify-content: space-between;\n}\n.on-call-footer .col-md-9,\n.on-call-footer .col-md-3 {\n  padding: 0;\n}\n.selected-policies {\n  display: flex;\n  flex-direction: row;\n}\n.selected-policies .selected-count {\n  padding-top: 4px;\n  font-weight: 600;\n  width: 125px;\n}\n.selected-policies .selected-pills {\n  margin-top: 3px;\n  margin-right: 5px;\n}\n.selected-policies .selected-pills .pill {\n  margin-left: 5px;\n}\n.page-app-list {\n  display: inline;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.page-app-list li {\n  display: inline;\n}\n.page-app-list li:not(:last-child):after {\n  content: ', ';\n}\n.page-modal .modal-body > div {\n  display: flex;\n  flex-direction: column;\n}\n.page-modal .modal-body > div > div:not(:first-child) {\n  margin-top: 15px;\n}\n.page-modal .service-to-page:not(:last-child):after {\n  content: ', ';\n}\n.table.on-call-table .table-header .fa {\n  padding-left: 2px;\n}\n.table.on-call-table .table-header .fa.disabled {\n  color: var(--color-alto);\n}\n";
styleInject(css_248z$J);

var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
const paddingStyle = { paddingTop: "15px", paddingBottom: "15px" };
const ServicePill = (props) => {
  const onClick = () => props.changeCallback(props.service, false);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "pill info"
  }, props.service.name, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-times-circle clickable",
    onClick
  }));
};
const SortIndicator = (props) => {
  if (props.sorted) {
    return props.direction === "ASC" ? /* @__PURE__ */ React__default.createElement("span", {
      className: "fa fa-caret-down"
    }) : /* @__PURE__ */ React__default.createElement("span", {
      className: "fa fa-caret-up"
    });
  }
  return /* @__PURE__ */ React__default.createElement("span", {
    className: "fa fa-caret-down disabled"
  });
};
let PagerBanner = class extends React__default.Component {
  render() {
    return null;
  }
};
PagerBanner = __decorateClass$8([
  Overridable("pager.banner")
], PagerBanner);
class Pager extends React__default.Component {
  constructor(props) {
    super(props);
    this.cache = new CellMeasurerCache({
      defaultHeight: 50,
      fixedWidth: true
    });
    this.allData = [];
    this.searchApi = new SearchApi();
    this.sort = (info) => {
      const { sortBy, sortDirection } = info;
      const { sortedData } = this.state;
      if (sortBy !== this.state.sortBy || sortDirection !== this.state.sortDirection) {
        ReactInjector.$state.go(".", { by: sortBy, direction: sortDirection });
        this.sortList(sortedData, sortBy, sortDirection);
        this.cache.clearAll();
        this.setState({ sortedData, sortBy, sortDirection });
      }
    };
    this.selectedChanged = (service, value) => {
      const { selectedKeys } = this.state;
      value ? selectedKeys.set(service.integration_key, service) : selectedKeys.delete(service.integration_key);
      ReactInjector.$state.go(".", { keys: Array.from(selectedKeys.keys()) });
      this.setState({ selectedKeys });
    };
    this.clearAll = () => {
      const { selectedKeys } = this.state;
      selectedKeys.clear();
      this.setState({ selectedKeys });
    };
    this.rowGetter = (data) => {
      return this.state.sortedData[data.index];
    };
    this.serviceRenderer = (data) => {
      const service = data.cellData;
      return /* @__PURE__ */ React__default.createElement("div", {
        style: paddingStyle
      }, /* @__PURE__ */ React__default.createElement("a", {
        title: service.name,
        href: `https://${this.state.accountName}.pagerduty.com/services/${service.id}`,
        target: "_blank"
      }, /* @__PURE__ */ React__default.createElement(Markdown, {
        tag: "span",
        message: this.highlight(service.name)
      })));
    };
    this.lastIncidentRenderer = (data) => {
      const time = data.cellData;
      return /* @__PURE__ */ React__default.createElement("div", {
        style: paddingStyle
      }, time.isValid ? relativeTime(time.toMillis()) : "Never");
    };
    this.applicationRenderer = (data) => {
      const apps = data.cellData;
      const appList = apps.map((app) => {
        let displayName = app.name;
        if (app.aliases) {
          displayName = `${displayName} (${app.aliases.replace(/,/g, ", ")})`;
        }
        return /* @__PURE__ */ React__default.createElement("li", {
          key: app.name
        }, /* @__PURE__ */ React__default.createElement(UISref, {
          to: "home.applications.application",
          params: { application: app.name }
        }, /* @__PURE__ */ React__default.createElement("a", null, /* @__PURE__ */ React__default.createElement(Markdown, {
          message: this.highlight(displayName),
          tag: "span"
        }))));
      });
      return /* @__PURE__ */ React__default.createElement(CellMeasurer, {
        cache: this.cache,
        columnIndex: data.columnIndex,
        key: data.dataKey,
        parent: data.parent,
        rowIndex: data.rowIndex
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: paddingStyle
      }, /* @__PURE__ */ React__default.createElement("ul", {
        className: "page-app-list"
      }, appList)));
    };
    this.onCallRenderer = (data) => {
      const onCalls = data.cellData;
      return /* @__PURE__ */ React__default.createElement(CellMeasurer, {
        cache: this.cache,
        columnIndex: data.columnIndex,
        key: data.dataKey,
        parent: data.parent,
        rowIndex: data.rowIndex
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: paddingStyle
      }, onCalls ? Object.keys(onCalls).map((level) => {
        return /* @__PURE__ */ React__default.createElement("div", {
          key: level,
          className: "users"
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "user-level"
        }, level), /* @__PURE__ */ React__default.createElement("div", {
          className: "user-names"
        }, onCalls[Number(level)].filter((user) => !user.name.includes("ExcludeFromAudit")).map((user, index) => /* @__PURE__ */ React__default.createElement("a", {
          key: index,
          target: "_blank",
          href: user.url
        }, /* @__PURE__ */ React__default.createElement(Markdown, {
          tag: "span",
          message: this.highlight(user.name)
        })))));
      }) : "Nobody"));
    };
    this.pageRenderer = (data) => {
      const service = data.cellData;
      const checked = this.state.selectedKeys.has(service.integration_key);
      return /* @__PURE__ */ React__default.createElement("div", {
        style: paddingStyle
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: `page-checkbox ${checked ? "checked" : ""}`
      }, /* @__PURE__ */ React__default.createElement("i", {
        className: "fa fa-check"
      })));
    };
    this.pageHeaderRenderer = (_data) => {
      return /* @__PURE__ */ React__default.createElement("span", null);
    };
    this.headerRenderer = (data) => {
      const { dataKey, disableSort, label, sortBy, sortDirection } = data;
      const children = [
        /* @__PURE__ */ React__default.createElement("span", {
          className: "table-header",
          key: "label",
          title: label
        }, label)
      ];
      if (!disableSort) {
        children.push(/* @__PURE__ */ React__default.createElement(SortIndicator, {
          key: "SortIndicator",
          direction: sortDirection,
          sorted: sortBy === dataKey
        }));
      }
      return children;
    };
    this.handleFilterChange = (event) => {
      this.setState({ app: "", filterString: event.target.value });
    };
    this.rowClassName = (info) => {
      if (info.index === -1) {
        return "on-call-header";
      }
      const classNames = ["on-call-row"];
      const onCallsByService = this.state.sortedData[info.index];
      if (this.state.selectedKeys.get(onCallsByService.service.integration_key)) {
        classNames.push("selected");
      }
      if (onCallsByService.service.status === "disabled") {
        classNames.push("disabled");
      }
      return classNames.join(" ");
    };
    this.handleHideNoAppsChanged = (event) => {
      const hideNoApps = event.target.checked;
      this.setState({ hideNoApps });
      ReactInjector.$state.go(".", { hideNoApps });
    };
    this.rowClicked = (info) => {
      if (info.event.target.closest("A") !== null) {
        return;
      }
      const service = info.rowData.service;
      if (service.status !== "disabled") {
        const flippedValue = !this.state.selectedKeys.get(service.integration_key);
        this.selectedChanged(service, flippedValue);
      }
    };
    this.closeCallback = (succeeded) => {
      if (succeeded) {
        this.setState({ selectedKeys: new Map() });
      }
    };
    const { $stateParams } = ReactInjector;
    this.state = {
      accountName: SETTINGS.pagerDuty && SETTINGS.pagerDuty.accountName || "",
      app: $stateParams.app || "",
      filterString: $stateParams.q || "",
      hideNoApps: $stateParams.hideNoApps || false,
      notFoundApps: [],
      initialKeys: $stateParams.keys || [],
      sortBy: $stateParams.by || "service",
      sortDirection: $stateParams.direction || SortDirection.ASC,
      sortedData: [],
      selectedKeys: new Map()
    };
  }
  componentDidMount() {
    forkJoin(from(ApplicationReader.listApplications()), PagerDutyReader.listOnCalls(), PagerDutyReader.listServices()).subscribe((results) => {
      const [applications, onCalls, services] = results;
      const sortedData = this.getOnCallsByService(applications, onCalls, services);
      Object.assign(this.allData, sortedData);
      const { app, initialKeys, filterString, hideNoApps, sortBy, sortDirection } = this.state;
      this.runFilter(app, initialKeys, filterString, sortBy, sortDirection, hideNoApps);
    });
  }
  sortByFunction(a, b, sortBy) {
    if (sortBy === "service") {
      return a.service.name.localeCompare(b.service.name);
    }
    if (sortBy === "last") {
      if (!a.last.isValid) {
        return 1;
      }
      if (!b.last.isValid) {
        return -1;
      }
      return a.last.toMillis() < b.last.toMillis() ? 1 : a.last.toMillis() > b.last.toMillis() ? -1 : 0;
    }
    return 0;
  }
  sortList(sortedData, sortBy, sortDirection) {
    if (sortBy) {
      sortedData.sort((a, b) => this.sortByFunction(a, b, sortBy));
      if (sortDirection === SortDirection.DESC) {
        sortedData.reverse();
      }
    }
  }
  findServiceByApplicationName(applicationName) {
    return this.allData.find((data) => data.applications.some((application) => application.name === applicationName));
  }
  runFilter(app, keys, filterString, sortBy, sortDirection, hideNoApps) {
    const selectedKeys = new Map();
    if (app) {
      const foundServices = [];
      const notFoundApps = [];
      app.split(",").forEach((applicationName) => {
        const service = this.findServiceByApplicationName(applicationName);
        if (service) {
          foundServices.push(service);
        } else {
          notFoundApps.push(applicationName);
        }
      });
      if (foundServices.length > 0) {
        foundServices.forEach((foundService) => selectedKeys.set(foundService.service.integration_key, foundService.service));
        this.setState({ sortedData: foundServices, selectedKeys, notFoundApps });
        return;
      }
      if (!filterString) {
        filterString = app;
      }
      app = "";
    }
    if (keys && keys.length > 0) {
      const selectedServices = this.allData.filter((data) => keys.includes(data.service.integration_key));
      selectedServices.forEach((s) => selectedKeys.set(s.service.integration_key, s.service));
      this.setState({ selectedKeys });
    }
    ReactInjector.$state.go(".", {
      app,
      q: filterString,
      by: sortBy,
      direction: sortDirection,
      hideNoApps,
      selectedKeys
    });
    this.searchApi.search(filterString).then((results) => {
      let data = results.map((serviceId) => this.allData.find((service) => service.service.id === serviceId));
      if (hideNoApps) {
        data = data.filter((s) => s.applications.length);
      }
      this.sortList(data, sortBy, sortDirection);
      this.cache.clearAll();
      this.setState({ sortedData: data });
    });
  }
  componentDidUpdate(_prevProps, prevState) {
    if (prevState.filterString !== this.state.filterString || prevState.hideNoApps !== this.state.hideNoApps) {
      this.runFilter(this.state.app, this.state.initialKeys, this.state.filterString, this.state.sortBy, this.state.sortDirection, this.state.hideNoApps);
    } else {
      this.sort({ sortBy: this.state.sortBy, sortDirection: this.state.sortDirection });
    }
  }
  getOnCallsByService(applications, onCalls, services) {
    const appsByApiKey = groupBy(applications, "pdApiKey");
    return services.filter((a) => a.integration_key).map((service) => {
      var _a;
      let users;
      const searchTokens = [service.name];
      const levels = onCalls[service.policy];
      if (levels) {
        users = groupBy(levels.map((level) => {
          return level.user ? { name: level.user.summary, url: level.user.html_url, level: level.escalation_level } : void 0;
        }).filter((a) => a), "level");
        searchTokens.push(...levels.map((level) => level.user ? level.user.summary : void 0).filter((n) => n));
      }
      const apiKey = service.integration_key;
      const associatedApplications = (_a = appsByApiKey[apiKey]) != null ? _a : [];
      searchTokens.push(...associatedApplications.map((app) => `${app.name},${app.aliases || ""}`));
      const onCallsByService = {
        users,
        applications: associatedApplications,
        service,
        last: DateTime.fromISO(service.lastIncidentTimestamp),
        searchString: searchTokens.join(" ")
      };
      this.searchApi.indexDocument(onCallsByService.service.id, onCallsByService.searchString);
      return onCallsByService;
    });
  }
  highlight(text) {
    const match = this.state.filterString || this.state.app;
    if (match) {
      const re = new RegExp(match, "gi");
      return text.replace(re, '<span class="highlighted">$&</span>');
    }
    return text;
  }
  render() {
    const { app, filterString, hideNoApps, notFoundApps, selectedKeys, sortBy, sortDirection, sortedData } = this.state;
    const forceOpen = app && selectedKeys.size === sortedData.length && sortedData.length !== 0 && notFoundApps.length === 0;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure-section pager-header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "container"
    }, /* @__PURE__ */ React__default.createElement("h2", {
      className: "header-section"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-grow"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "pager"
    }, /* @__PURE__ */ React__default.createElement("i", {
      className: "fa fa-bullhorn"
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "pager-label"
    }, "Pager"))))), /* @__PURE__ */ React__default.createElement(PagerBanner, null)), /* @__PURE__ */ React__default.createElement("div", {
      className: "container main-content on-call scrollable-columns"
    }, notFoundApps.length > 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-warning"
    }, /* @__PURE__ */ React__default.createElement("p", null, "PagerDuty Services were not found for the following applications:", " ", notFoundApps.map((applicationName, i) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(UISref, {
      to: "home.applications.application",
      params: { application: applicationName }
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "clickable"
    }, applicationName)), i + 1 < notFoundApps.length && ", ")))), /* @__PURE__ */ React__default.createElement("div", {
      className: "on-call-filter"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Filter "), /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      value: filterString,
      onChange: this.handleFilterChange,
      placeholder: "Service, application, name"
    }), /* @__PURE__ */ React__default.createElement("label", {
      className: "hide-checkbox"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: hideNoApps,
      onChange: this.handleHideNoAppsChanged
    }), "Hide services with no associated apps")), /* @__PURE__ */ React__default.createElement("div", {
      className: "table on-call-table"
    }, /* @__PURE__ */ React__default.createElement(AutoSizer, null, ({ height, width }) => /* @__PURE__ */ React__default.createElement(Table$1, {
      headerClassName: "table-header",
      headerHeight: 26,
      onRowClick: this.rowClicked,
      overscanRowCount: 20,
      rowGetter: this.rowGetter,
      rowHeight: this.cache.rowHeight,
      rowCount: sortedData.length,
      rowClassName: this.rowClassName,
      sort: this.sort,
      sortBy,
      sortDirection,
      width,
      height
    }, /* @__PURE__ */ React__default.createElement(Column, {
      disableSort: true,
      dataKey: "service",
      width: 25,
      className: "col-page",
      headerRenderer: this.pageHeaderRenderer,
      cellRenderer: this.pageRenderer
    }), /* @__PURE__ */ React__default.createElement(Column, {
      dataKey: "service",
      label: "PagerDuty Service Name",
      cellRenderer: this.serviceRenderer,
      className: "col-service",
      headerRenderer: this.headerRenderer,
      width: 180
    }), /* @__PURE__ */ React__default.createElement(Column, {
      disableSort: true,
      width: 210,
      label: "Application Name(s)",
      cellRenderer: this.applicationRenderer,
      headerRenderer: this.headerRenderer,
      className: "col-application",
      dataKey: "applications",
      flexGrow: 1
    }), /* @__PURE__ */ React__default.createElement(Column, {
      disableSort: true,
      width: 180,
      dataKey: "users",
      label: "Currently On-call",
      cellRenderer: this.onCallRenderer,
      className: "col-on-call",
      headerRenderer: this.headerRenderer
    }), /* @__PURE__ */ React__default.createElement(Column, {
      width: 120,
      dataKey: "last",
      label: "Last Incident",
      className: "col-incident",
      cellRenderer: this.lastIncidentRenderer,
      headerRenderer: this.headerRenderer
    }))))), /* @__PURE__ */ React__default.createElement("div", {
      className: "main-footer on-call-footer"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "selected-policies"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "selected-count"
    }, selectedKeys.size, " ", selectedKeys.size === 1 ? "policy" : "policies", " selected", " "), /* @__PURE__ */ React__default.createElement("div", {
      className: "selected-pills"
    }, Array.from(selectedKeys.values()).map((service) => /* @__PURE__ */ React__default.createElement(ServicePill, {
      key: service.integration_key,
      service,
      changeCallback: this.selectedChanged
    })))), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("button", {
      disabled: selectedKeys.size === 0,
      className: "btn btn-sm btn-default",
      style: { marginRight: "5px" },
      onClick: this.clearAll
    }, "Clear All"), /* @__PURE__ */ React__default.createElement(PageButton, {
      closeCallback: this.closeCallback,
      disabled: selectedKeys.size === 0,
      forceOpen,
      services: Array.from(selectedKeys.values())
    }))));
  }
}
__decorateClass$8([
  Debounce(25)
], Pager.prototype, "runFilter", 1);

const PAGER_STATES = "spinnaker.core.pager.states";
module(PAGER_STATES, [STATE_CONFIG_PROVIDER]).config([
  "stateConfigProvider",
  (stateConfigProvider) => {
    const pageState = {
      url: "/page?app&q&keys&by&direction&hideNoApps&subject&&details",
      name: "page",
      views: {
        "main@": { component: Pager, $type: "react" }
      },
      params: {
        app: {
          dynamic: true,
          type: "string",
          value: "",
          squash: true
        },
        q: {
          dynamic: true,
          type: "string",
          value: "",
          squash: true
        },
        subject: {
          dynamic: true,
          type: "string",
          value: "",
          squash: true
        },
        details: {
          dynamic: true,
          type: "string",
          value: "",
          squash: true
        },
        hideNoApps: {
          dynamic: true,
          type: "boolean",
          value: false,
          squash: true
        },
        keys: {
          dynamic: true,
          value: [],
          squash: true,
          array: true
        },
        by: {
          dynamic: true,
          type: "string",
          value: "service",
          squash: true
        },
        direction: {
          dynamic: true,
          type: "string",
          value: "ASC",
          squash: true
        }
      },
      data: {
        pageTitleSection: {
          title: "Pager"
        }
      }
    };
    stateConfigProvider.addToRootState(pageState);
  }
]);

const PAGER_DUTY_MODULE = "spinnaker.core.pagerDuty";
module(PAGER_DUTY_MODULE, [
  PAGE_MODAL_CONTROLLER,
  PAGER_DUTY_SELECT_FIELD_COMPONENT,
  PAGER_DUTY_TAG_COMPONENT,
  PAGER_STATES
]);

class CreatePipelineButton extends React__default.Component {
  constructor(props) {
    super(props);
    this.showCallBack = (showCreatePipelineModal) => {
      this.setState({ showCreatePipelineModal });
    };
    this.createPipeline = () => {
      logger.log({ category: "Pipelines", action: "Create Pipeline" });
      this.setState({ showCreatePipelineModal: true });
    };
    this.goToPipelineConfig = (id) => {
      const { $state } = ReactInjector;
      if (!$state.current.name.includes(".executions.execution")) {
        $state.go("^.pipelineConfig", { pipelineId: id });
      } else {
        $state.go("^.^.pipelineConfig", { pipelineId: id });
      }
    };
    this.state = {
      showCreatePipelineModal: false
    };
  }
  render() {
    const modal = /* @__PURE__ */ React__default.createElement(CreatePipelineModal, {
      show: this.state.showCreatePipelineModal,
      showCallback: this.showCallBack,
      pipelineSavedCallback: this.goToPipelineConfig,
      application: this.props.application
    });
    if (this.props.asLink) {
      return /* @__PURE__ */ React__default.createElement("a", {
        className: "clickable",
        onClick: this.createPipeline
      }, "Configure a new pipeline", modal);
    }
    return /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-sm btn-default",
      style: { marginRight: "5px" },
      onClick: this.createPipeline
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign visible-xl-inline"
    }), /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Create Pipeline or Strategy"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign hidden-xl-inline"
    })), /* @__PURE__ */ React__default.createElement("span", {
      className: "visible-xl-inline"
    }, " Create"), modal);
  }
}

class CreatePipeline extends React__default.Component {
  constructor() {
    super(...arguments);
    this.dropdownToggled = () => {
      logger.log({ category: "Pipelines", action: "Configure (top level)" });
    };
  }
  render() {
    const { application } = this.props;
    const pipelineConfigs = get(application, "pipelineConfigs.data", []);
    const hasPipelineConfigs = pipelineConfigs.length > 0;
    const hasStrategyConfigs = get(application, "strategyConfigs.data", []).length > 0;
    const header = !(hasPipelineConfigs || hasStrategyConfigs) ? /* @__PURE__ */ React__default.createElement("li", {
      className: "dropdown-header",
      style: { marginTop: 0 }
    }, "None yet, click ", /* @__PURE__ */ React__default.createElement("span", {
      style: { marginLeft: "2px" },
      className: "glyphicon glyphicon-plus-sign"
    }), " Create") : hasPipelineConfigs ? /* @__PURE__ */ React__default.createElement("li", {
      className: "dropdown-header",
      style: { marginTop: 0 }
    }, "PIPELINES") : hasStrategyConfigs ? /* @__PURE__ */ React__default.createElement("li", {
      className: "dropdown-header",
      style: { marginTop: 0 }
    }, "DEPLOYMENT STRATEGIES") : null;
    return /* @__PURE__ */ React__default.createElement(Dropdown, {
      className: "dropdown",
      id: "create-pipeline-dropdown",
      style: { marginRight: "5px" },
      onToggle: this.dropdownToggled
    }, /* @__PURE__ */ React__default.createElement(CreatePipelineButton, {
      application: this.props.application
    }), /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
      className: "btn btn-sm btn-default dropdown-toggle"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "visible-xl-inline"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-cog"
    }), " Configure"), /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Configure pipelines"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "hidden-xl-inline"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-cog"
    })))), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, {
      className: "dropdown-menu"
    }, header, pipelineConfigs.map((pipeline) => /* @__PURE__ */ React__default.createElement(Pipeline$1, {
      key: pipeline.id,
      pipeline,
      type: "pipeline"
    })), hasStrategyConfigs && application.strategyConfigs.data.map((pipeline) => /* @__PURE__ */ React__default.createElement(Pipeline$1, {
      key: pipeline.id,
      pipeline,
      type: "strategy"
    }))));
  }
}
const Pipeline$1 = (props) => {
  const clicked = () => {
    logger.log({ category: "Pipelines", action: `Configure ${props.type} (via top level)` });
    const { $state } = ReactInjector;
    if (!$state.current.name.includes(".executions.execution")) {
      $state.go("^.pipelineConfig", { pipelineId: props.pipeline.id });
    } else {
      $state.go("^.^.pipelineConfig", { pipelineId: props.pipeline.id });
    }
  };
  return /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("a", {
    onClick: clicked
  }, props.pipeline.name, " ", props.pipeline.disabled && props.type === "pipeline" && /* @__PURE__ */ React__default.createElement("span", null, "(disabled)")));
};

const CREATE_PIPELINE_COMPONENT = "spinnaker.core.pipeline.config.createNew.component";
module(CREATE_PIPELINE_COMPONENT, []).component("createPipeline", react2angular(withErrorBoundary(CreatePipeline, "createPipeline"), ["application"]));

const PIPELINE_GRAPH_COMPONENT = "spinnaker.core.pipeline.config.graph.component";
module(PIPELINE_GRAPH_COMPONENT, []).component("pipelineGraph", react2angular(withErrorBoundary(PipelineGraph, "pipelineGraph"), [
  "pipeline",
  "execution",
  "viewState",
  "onNodeClick",
  "shouldValidate"
]));

const CORE_PIPELINE_CONFIG_HEALTH_STAGEPLATFORMHEALTHOVERRIDE_DIRECTIVE = "spinnaker.core.pipeline.config.health.stagePlatformHealthOverride.directive";
angular.module(CORE_PIPELINE_CONFIG_HEALTH_STAGEPLATFORMHEALTHOVERRIDE_DIRECTIVE, []).directive("stagePlatformHealthOverride", function() {
  return {
    restrict: "E",
    templateUrl: "core/src/pipeline/config/health/stagePlatformHealthOverrideCheckbox.directive.html",
    scope: {},
    controller: angular.noop,
    controllerAs: "vm",
    bindToController: {
      stage: "=",
      application: "=",
      platformHealthType: "="
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/health/stagePlatformHealthOverrideCheckbox.directive.html", `<stage-config-field label="Task Completion" ng-if="vm.application.attributes.platformHealthOnlyShowOverride">
  <platform-health-override command="vm.stage" platform-health-type="vm.platformHealthType"> </platform-health-override>
</stage-config-field>
`);
}]);

const PARAMETERS = "spinnaker.core.pipeline.parameters.parameters";
module(PARAMETERS, []).component("parameters", react2angular(withErrorBoundary(Parameters$1, "parameters"), [
  "addParameter",
  "parameters",
  "pipelineName",
  "removeParameter",
  "updateParameter",
  "updateAllParameters"
]));

const CORE_PIPELINE_CONFIG_PARAMETERS_PIPELINE_MODULE = "spinnaker.core.pipeline.parameters";
module(CORE_PIPELINE_CONFIG_PARAMETERS_PIPELINE_MODULE, [PARAMETERS]);

const CORE_PIPELINE_CONFIG_PIPELINECONFIG_CONTROLLER = "spinnaker.core.pipeline.config.controller";
module(CORE_PIPELINE_CONFIG_PIPELINECONFIG_CONTROLLER, [UIROUTER_ANGULARJS]).controller("PipelineConfigCtrl", [
  "$scope",
  "$state",
  "$stateParams",
  "app",
  function($scope, $state, $stateParams, app) {
    this.application = app;
    this.state = {
      pipelinesLoaded: false
    };
    this.containsJinja = (source) => source && (source.includes("{{") || source.includes("{%"));
    this.initialize = () => {
      this.pipelineConfig = ___default.find(app.pipelineConfigs.data, { id: $stateParams.pipelineId });
      const isV2PipelineConfig = this.pipelineConfig && PipelineTemplateV2Service.isV2PipelineConfig(this.pipelineConfig);
      if (this.pipelineConfig && this.pipelineConfig.expectedArtifacts) {
        for (const artifact of this.pipelineConfig.expectedArtifacts) {
          if (!artifact.displayName || artifact.displayName.length === 0) {
            const { name: name2 } = artifact.matchArtifact;
            if (name2) {
              artifact.displayName = name2;
            } else {
              artifact.displayName = hri.random();
            }
          }
        }
      }
      if (this.pipelineConfig && this.pipelineConfig.type === "templatedPipeline") {
        this.isTemplatedPipeline = true;
        this.isV2TemplatedPipeline = isV2PipelineConfig;
        this.hasDynamicSource = !isV2PipelineConfig && this.containsJinja(this.pipelineConfig.config.pipeline.template.source);
        if ($stateParams.new === "1") {
          this.pipelineConfig.isNew = true;
        }
        if (!this.pipelineConfig.isNew || isV2PipelineConfig) {
          return PipelineTemplateReader.getPipelinePlan(this.pipelineConfig, $stateParams.executionId).then((plan) => this.pipelinePlan = plan).catch((error) => {
            this.templateError = error;
            this.pipelineConfig.isNew = true;
          });
        }
      } else if (!this.pipelineConfig) {
        this.pipelineConfig = ___default.find(app.strategyConfigs.data, { id: $stateParams.pipelineId });
        if (!this.pipelineConfig) {
          this.state.notFound = true;
        }
      }
      if (this.pipelineConfig) {
        this.pipelineConfig = ___default.cloneDeep(this.pipelineConfig);
      }
    };
    if (!app.notFound && !app.hasError) {
      app.pipelineConfigs.activate();
      app.pipelineConfigs.refresh().then(this.initialize).then(() => this.state.pipelinesLoaded = true);
    }
  }
]);

const CORE_PIPELINE_CONFIG_PIPELINECONFIGVIEW = "spinnaker.core.pipeline.config.configView";
module(CORE_PIPELINE_CONFIG_PIPELINECONFIGVIEW, []).directive("pipelineConfigView", function() {
  return {
    restrict: "E",
    require: "^pipelineConfigurer",
    scope: {
      pipeline: "=",
      application: "=",
      viewState: "=",
      pipelineConfig: "=",
      stageFieldUpdated: "<",
      updatePipelineConfig: "<",
      isV2TemplatedPipeline: "<"
    },
    templateUrl: "core/src/pipeline/config/pipelineConfigView.html",
    link: function(scope, elem, attrs, pipelineConfigurerCtrl) {
      scope.pipelineConfigurerCtrl = pipelineConfigurerCtrl;
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/pipelineConfigView.html", `<div class="row horizontal">
  <div class="col-md-12">
    <triggers
      ng-if="viewState.section === 'triggers'"
      application="application"
      field-updated="stageFieldUpdated"
      pipeline="isV2TemplatedPipeline ? pipeline : pipelineConfig"
      update-pipeline-config="updatePipelineConfig"
      revert-count="viewState.revertCount"
    >
    </triggers>
    <pipeline-config-stage
      ng-if="viewState.section === 'stage'"
      application="application"
      view-state="viewState"
      stage-field-updated="stageFieldUpdated"
      pipeline="pipeline"
    >
    </pipeline-config-stage>
  </div>
</div>
`);
}]);

function DeletePipelineModal(props) {
  const [errorMessage, setErrorMessage] = React__default.useState(null);
  const [deleteError, setDeleteError] = React__default.useState(false);
  const [deleting, setDeleting] = React__default.useState(false);
  const { application, closeModal, dismissModal, pipeline } = props;
  function deletePipeline() {
    setDeleting(true);
    PipelineConfigService.deletePipeline(application.name, pipeline, pipeline.name).then(() => {
      const idsToUpdatedIndices = {};
      const isPipelineStrategy = pipeline.strategy === true;
      const data = isPipelineStrategy ? application.strategyConfigs.data : application.pipelineConfigs.data;
      data.splice(data.findIndex((p) => p.id === pipeline.id), 1);
      data.forEach((p, index) => {
        if (p.index !== index) {
          p.index = index;
          set(idsToUpdatedIndices, p.id, index);
        }
      });
      if (!isEmpty(idsToUpdatedIndices)) {
        PipelineConfigService.reorderPipelines(application.name, idsToUpdatedIndices, isPipelineStrategy);
      }
      ReactInjector.$state.go("^.executions", null, { location: "replace" });
      closeModal();
    }, (response) => {
      $log.warn(response);
      setDeleting(false);
      setDeleteError(true);
      setErrorMessage(get(response, "data.message", "No message provided"));
    });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Modal$1, {
    key: "modal",
    show: true,
    onHide: () => {
    }
  }, /* @__PURE__ */ React__default.createElement(ModalClose, {
    dismiss: dismissModal
  }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Really Delete ", pipeline.strategy === true ? "Strategy" : "Pipeline", "?")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, deleteError && /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Could not delete ", pipeline.strategy === true ? "strategy" : "pipeline", "."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Reason: "), errorMessage), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
    className: "btn btn-link",
    onClick: (e) => {
      e.preventDefault();
      setDeleteError(false);
    }
  }, "[dismiss]"))), /* @__PURE__ */ React__default.createElement("form", {
    role: "form",
    name: "form",
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Are you sure you want to delete the ", pipeline.strategy === true ? "strategy: " : "pipeline: ", pipeline.name, "?"))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: dismissModal,
    type: "button"
  }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: deletePipeline
  }, !deleting && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
    className: "far fa-check-circle"
  }), " Delete"), deleting && /* @__PURE__ */ React__default.createElement("span", {
    className: "pulsing"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "fa fa-cog fa-spin"
  }), " Deleting\u2026")))));
}

function DisablePipelineModal(props) {
  const [errorMessage, setErrorMessage] = React__default.useState(null);
  const [saveError, setSaveError] = React__default.useState(false);
  const { closeModal, dismissModal, pipeline } = props;
  function disablePipeline() {
    PipelineConfigService.savePipeline({ ...pipeline, disabled: true }).then(() => closeModal(), (response) => {
      setSaveError(true);
      setErrorMessage(get(response, "data.message", "No message provided"));
    });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Modal$1, {
    key: "modal",
    show: true,
    onHide: () => {
    }
  }, /* @__PURE__ */ React__default.createElement(ModalClose, {
    dismiss: dismissModal
  }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Really Disable Pipeline?")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, saveError && /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Could not disable pipeline."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Reason: "), errorMessage), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
    className: "btn btn-link",
    onClick: (e) => {
      e.preventDefault();
      setSaveError(false);
    }
  }, "[dismiss]"))), /* @__PURE__ */ React__default.createElement("form", {
    role: "form",
    name: "form",
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Are you sure you want to disable ", pipeline.name, "?"), /* @__PURE__ */ React__default.createElement("p", null, "This will prevent any triggers from firing, and will also prevent users from running the pipeline manually."))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: dismissModal,
    type: "button"
  }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: disablePipeline,
    type: "button"
  }, "Disable pipeline"))));
}

function EnablePipelineModal(props) {
  const [errorMessage, setErrorMessage] = React__default.useState(null);
  const [saveError, setSaveError] = React__default.useState(false);
  const { closeModal, dismissModal, pipeline } = props;
  function enablePipeline() {
    PipelineConfigService.savePipeline({ ...pipeline, disabled: false }).then(() => closeModal(), (response) => {
      setSaveError(true);
      setErrorMessage(get(response, "data.message", "No message provided"));
    });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Modal$1, {
    key: "modal",
    show: true,
    onHide: () => {
    }
  }, /* @__PURE__ */ React__default.createElement(ModalClose, {
    dismiss: dismissModal
  }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement("h3", null, "Really Enable Pipeline?")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, saveError && /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Could not enable pipeline."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Reason: "), errorMessage), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
    className: "btn btn-link",
    onClick: (e) => {
      e.preventDefault();
      setSaveError(false);
    }
  }, "[dismiss]"))), /* @__PURE__ */ React__default.createElement("form", {
    role: "form",
    name: "form",
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Are you sure you want to enable ", pipeline.name, "?"))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: dismissModal,
    type: "button"
  }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: enablePipeline,
    type: "button"
  }, "Enable pipeline"))));
}

var css_248z$I = ".history-header {\n  padding-bottom: 10px;\n  align-items: stretch;\n}\n.show-history {\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: calc(100vh - 220px);\n  display: flex;\n}\n.diff-section {\n  padding-left: 0;\n}\n.diff-summary {\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 20px;\n  font-size: 120%;\n  font-weight: 600;\n  letter-spacing: -1px;\n}\n.diff-summary .footer-additions {\n  color: var(--color-success);\n}\n.diff-summary .footer-removals {\n  color: var(--color-danger);\n  display: inline-block;\n  margin-left: 5px;\n}\n";
styleInject(css_248z$I);

const emptyDiff = {
  changeBlocks: [],
  details: [],
  summary: {
    additions: 0,
    removals: 0,
    total: 0,
    unchanged: 0
  }
};
function ShowPipelineHistoryModal(props) {
  const compareOptions = ["previous version", "current"];
  const [compareTo, setCompareTo] = React__default.useState(compareOptions[0]);
  const [diff, setDiff] = React__default.useState(emptyDiff);
  const [version, setVersion] = React__default.useState(0);
  const { closeModal, currentConfig, dismissModal, isStrategy, pipelineConfigId } = props;
  const { result: history, status, error } = useData(() => {
    return PipelineConfigService.getHistory(pipelineConfigId, isStrategy, 100).then(historyLoaded);
  }, [], []);
  React__default.useEffect(() => updateDiff(history, version, compareTo), [history, compareTo, version]);
  function historyLoaded(loadedPipelines) {
    const historyToBeProcessed = currentConfig ? [currentConfig].concat(loadedPipelines) : loadedPipelines;
    const pipelineHistory = historyToBeProcessed.map((h, index) => {
      const ts = h.updateTs;
      delete h.updateTs;
      return {
        timestamp: timestamp(ts),
        contents: JSON.stringify(h, null, 2),
        json: h,
        index
      };
    });
    pipelineHistory[0].timestamp += " (current)";
    if (currentConfig) {
      pipelineHistory[0].timestamp = "Current config (not saved)";
      pipelineHistory[1].timestamp += " (last saved)";
    }
    return pipelineHistory;
  }
  function restoreVersion() {
    closeModal(history[version].json);
  }
  function updateDiff(h, v, c) {
    if (h.length > 0) {
      const right = h[v].contents;
      let left;
      if (c === compareOptions[1]) {
        left = h[0].contents;
      } else {
        left = right;
        if (v < h.length - 1) {
          left = h[v + 1].contents;
        }
      }
      setDiff(JsonUtils.diff(left, right, true));
    }
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Modal$1, {
    key: "modal",
    dialogClassName: "modal-lg modal-fullscreen",
    show: true,
    onHide: () => {
    }
  }, /* @__PURE__ */ React__default.createElement(ModalClose, {
    dismiss: dismissModal
  }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Pipeline Revision History")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, status === "PENDING" && /* @__PURE__ */ React__default.createElement("div", {
    className: "horizontal center"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "horizontal center"
  }, /* @__PURE__ */ React__default.createElement(Spinner, {
    size: "medium"
  }))), status === "REJECTED" && /* @__PURE__ */ React__default.createElement("div", {
    className: "horizontal center"
  }, /* @__PURE__ */ React__default.createElement("h4", {
    className: "text-center"
  }, "There was an error loading the history for this pipeline."), /* @__PURE__ */ React__default.createElement("span", null, error)), status === "RESOLVED" && history.length <= 0 && /* @__PURE__ */ React__default.createElement("div", {
    className: "horizontal center"
  }, /* @__PURE__ */ React__default.createElement("h4", {
    className: "text-center"
  }, "Sorry, we couldn't find any history for this pipeline.")), status === "RESOLVED" && history.length > 0 && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "history-header row horizontal"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-4"
  }, /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Revision",
    layout: ({ label, input }) => /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-h baseline margin-between-lg"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "bold"
    }, label), /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-grow"
    }, input)),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      clearable: false,
      options: history.map((h) => ({ label: h.timestamp, value: h.index })),
      ...inputProps
    }),
    onChange: (e) => setVersion(e.target.value),
    value: version
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "diff-section col-md-4 horizontal middle"
  }, /* @__PURE__ */ React__default.createElement(DiffSummary, {
    summary: diff.summary
  }), version > 0 && /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-sm btn-primary",
    onClick: restoreVersion
  }, "Restore this version")), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-4"
  }, /* @__PURE__ */ React__default.createElement(FormField, {
    label: "compare to",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      clearable: false,
      stringOptions: compareOptions,
      ...inputProps
    }),
    onChange: (e) => setCompareTo(e.target.value),
    value: compareTo
  }))), /* @__PURE__ */ React__default.createElement("form", {
    role: "form",
    className: "form-horizontal show-history"
  }, !isEmpty(history) && /* @__PURE__ */ React__default.createElement("div", {
    className: "diff-view flex-fill"
  }, /* @__PURE__ */ React__default.createElement(DiffView, {
    diff
  }))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: dismissModal,
    type: "button"
  }, "Close"))));
}

function LockPipelineModal(props) {
  const [errorMessage, setErrorMessage] = React__default.useState(null);
  const [saveError, setSaveError] = React__default.useState(false);
  const [allowUnlockUi, setAllowUnlockUi] = React__default.useState(true);
  const [description, setDescription] = React__default.useState("");
  const { closeModal, dismissModal, pipeline } = props;
  function lockPipeline() {
    const locked = {
      ui: true,
      allowUnlockUi,
      description
    };
    const newPipeline = { ...pipeline, locked };
    PipelineConfigService.savePipeline(newPipeline).then(() => closeModal(newPipeline), (response) => {
      setSaveError(true);
      setErrorMessage(get(response, "data.message", "No message provided"));
    });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Modal$1, {
    key: "modal",
    show: true,
    onHide: () => {
    }
  }, /* @__PURE__ */ React__default.createElement(ModalClose, {
    dismiss: dismissModal
  }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Really Lock Pipeline?")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, saveError && /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Could not lock pipeline."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Reason: "), errorMessage), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
    className: "btn btn-link",
    onClick: (e) => {
      e.preventDefault();
      setSaveError(false);
    }
  }, "[dismiss]"))), /* @__PURE__ */ React__default.createElement("form", {
    role: "form",
    name: "form",
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Are you sure you want to lock ", pipeline.name, "?"), /* @__PURE__ */ React__default.createElement("p", null, "This will prevent any further modification to this pipeline made via the Spinnaker UI."))), /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Unlock via UI",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.lock.allowUnlockUi"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      ...inputProps
    }),
    onChange: () => setAllowUnlockUi(!allowUnlockUi),
    value: allowUnlockUi
  }), /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Description",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.lock.description"
    }),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...inputProps,
      placeholder: "This pipeline is locked and does not allow modification"
    }),
    onChange: (e) => setDescription(e.target.value),
    value: description
  }))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: dismissModal,
    type: "button"
  }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: lockPipeline,
    type: "button"
  }, "Lock pipeline"))));
}

function PipelineConfigAction(props) {
  return /* @__PURE__ */ React__default.createElement("li", null, /* @__PURE__ */ React__default.createElement("a", {
    className: props.action ? "clickable" : "disable",
    onClick: props.action
  }, props.name));
}

function PipelineConfigActions(props) {
  const closeDropdown = () => document.body.click();
  const {
    pipeline,
    renamePipeline,
    deletePipeline,
    enablePipeline,
    disablePipeline,
    lockPipeline,
    unlockPipeline,
    editPipelineJson,
    showHistory,
    exportPipelineTemplate
  } = props;
  return /* @__PURE__ */ React__default.createElement(Dropdown, {
    className: "dropdown",
    id: "pipeline-actions-dropdown"
  }, /* @__PURE__ */ React__default.createElement(Dropdown.Toggle, {
    className: "btn btn-sm dropdown-toggle"
  }, pipeline.strategy === true ? "Strategy" : "Pipeline", " Actions"), /* @__PURE__ */ React__default.createElement(Dropdown.Menu, {
    className: "dropdown-menu",
    onClick: closeDropdown
  }, !pipeline.locked && /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Rename",
    action: renamePipeline
  }), !pipeline.locked && /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Delete",
    action: deletePipeline
  }), !pipeline.locked && pipeline.disabled && /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Enable",
    action: enablePipeline
  }), !pipeline.locked && !pipeline.disabled && /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Disable",
    action: disablePipeline
  }), !pipeline.locked && /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Lock",
    action: lockPipeline
  }), pipeline.locked && pipeline.locked.allowUnlockUi && /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Unlock",
    action: unlockPipeline
  }), pipeline.locked && /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Show JSON",
    action: editPipelineJson
  }), !pipeline.locked && /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Edit as JSON",
    action: editPipelineJson
  }), /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Show Revision History",
    action: showHistory
  }), /* @__PURE__ */ React__default.createElement(PipelineConfigAction, {
    name: "Export as Pipeline Template",
    action: exportPipelineTemplate
  })));
}

const PIPELINE_CONFIG_ACTIONS = "spinnaker.core.pipeline.config.actions";
module(PIPELINE_CONFIG_ACTIONS, []).component("pipelineConfigActions", react2angular(withErrorBoundary(PipelineConfigActions, "pipelineConfigActions"), [
  "pipeline",
  "renamePipeline",
  "deletePipeline",
  "enablePipeline",
  "disablePipeline",
  "lockPipeline",
  "unlockPipeline",
  "editPipelineJson",
  "showHistory",
  "exportPipelineTemplate"
]));

class EditPipelineJsonModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.updatePipeline = () => {
      const { pipelineJSON } = this.state;
      const { pipeline } = this.props;
      try {
        const parsed = JSON.parse(pipelineJSON);
        parsed.appConfig = parsed.appConfig || {};
        this.validatePipeline(parsed);
        Object.keys(pipeline).filter((k) => !PipelineJSONService.immutableFields.has(k) && !parsed.hasOwnProperty(k)).forEach((k) => delete pipeline[k]);
        this.removeImmutableFields(parsed);
        Object.assign(pipeline, parsed);
        this.props.closeModal();
      } catch (e) {
        this.setState({ errorMessage: e.message });
      }
    };
    this.updateJson = (pipelineJSON) => {
      this.setState({ pipelineJSON });
    };
    this.onValidate = (errorMessage) => {
      this.setState({ errorMessage });
    };
    const copy = PipelineJSONService.clone(props.pipeline);
    let copyPlan;
    if (props.plan) {
      copyPlan = PipelineJSONService.clone(props.plan);
    }
    this.state = {
      pipelineJSON: JsonUtils.makeSortedStringFromObject(copy),
      pipelinePlanJSON: copyPlan ? JsonUtils.makeSortedStringFromObject(copyPlan) : null,
      locked: copy.locked,
      isStrategy: copy.strategy || false,
      activeTab: "pipeline"
    };
  }
  removeImmutableFields(pipeline) {
    PipelineJSONService.immutableFields.forEach((k) => delete pipeline[k]);
  }
  validatePipeline(pipeline) {
    const refIds = new Set();
    const badIds = new Set();
    if (pipeline.stages) {
      pipeline.stages.forEach((stage) => {
        if (refIds.has(stage.refId)) {
          badIds.add(stage.refId);
        }
        refIds.add(stage.refId);
      });
      if (badIds.size) {
        throw new Error(`The refId property must be unique across stages.  Duplicate id(s): ${Array.from(badIds).toString()}`);
      }
    }
  }
  setActiveTab(activeTab) {
    this.setState({ activeTab });
  }
  render() {
    const { pipelineJSON, pipelinePlanJSON, locked, isStrategy, activeTab, errorMessage } = this.state;
    const invalid = !!errorMessage;
    const { dismissModal } = this.props;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, !locked && /* @__PURE__ */ React__default.createElement("span", null, "Edit "), isStrategy ? "Strategy" : "Pipeline", " JSON")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
      className: "flex-fill"
    }, !!pipelinePlanJSON && /* @__PURE__ */ React__default.createElement("ul", {
      className: "tabs-basic",
      style: { listStyle: "none" }
    }, /* @__PURE__ */ React__default.createElement("li", {
      role: "presentation",
      className: activeTab === "pipeline" ? "selected" : ""
    }, /* @__PURE__ */ React__default.createElement("a", {
      onClick: () => this.setActiveTab("pipeline")
    }, "Configuration")), /* @__PURE__ */ React__default.createElement("li", {
      role: "presentation",
      className: activeTab === "renderedPipeline" ? "selected" : ""
    }, /* @__PURE__ */ React__default.createElement("a", {
      onClick: () => this.setActiveTab("renderedPipeline")
    }, "Rendered pipeline"))), activeTab === "pipeline" && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "The JSON below represents the ", isStrategy ? "strategy" : "pipeline", " configuration in its persisted state."), !locked && /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, "Note:"), ' Clicking "Update ', isStrategy ? "Strategy" : "Pipeline", `" below will not save your changes to the server - it only updates the configuration within the browser, so you'll want to verify your changes and click "Save Changes" when you're ready.`), /* @__PURE__ */ React__default.createElement(JsonEditor, {
      value: pipelineJSON,
      onChange: this.updateJson,
      onValidation: this.onValidate
    })), activeTab === "renderedPipeline" && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "This pipeline is based on a template. The JSON below represents the rendered pipeline."), /* @__PURE__ */ React__default.createElement("form", {
      role: "form",
      name: "form",
      className: "form-horizontal flex-fill"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-fill"
    }, /* @__PURE__ */ React__default.createElement(JsonEditor, {
      value: pipelinePlanJSON,
      readOnly: true
    }))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, invalid && /* @__PURE__ */ React__default.createElement("div", {
      className: "slide-in"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "error-message"
    }, "Error: ", errorMessage)), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: () => dismissModal()
    }, "Cancel"), !locked && /* @__PURE__ */ React__default.createElement("button", {
      disabled: invalid,
      className: "btn btn-primary",
      onClick: this.updatePipeline
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "far fa-check-circle"
    }), " Update ", isStrategy ? "Strategy" : "Pipeline")));
  }
}
EditPipelineJsonModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

function RenamePipelineModal(props) {
  const { application, closeModal, dismissModal, pipeline } = props;
  const [errorMessage, setErrorMessage] = React__default.useState(null);
  const [saveError, setSaveError] = React__default.useState(false);
  const [saving, setSaving] = React__default.useState(false);
  const existingNames = without(map$1(application.pipelineConfigs.data, "name"), pipeline.name);
  const pipelineType = pipeline.strategy === true ? "Strategy" : "Pipeline";
  const initialValues = { name: pipeline.name };
  const validPipelineName = () => {
    return (val) => {
      const message = `${pipelineType} cannot contain: \\ ^ / ? % #`;
      return val && !/^[^\\^/?%#]*$/i.test(val) && message;
    };
  };
  function renamePipeline(command) {
    setSaving(true);
    PipelineConfigService.renamePipeline(application.name, pipeline, pipeline.name, command.name).then(() => {
      application.pipelineConfigs.refresh();
      closeModal(command.name);
    }, (response) => {
      setSaving(false);
      setSaveError(true);
      setErrorMessage(get(response, "data.message", "No message provided"));
    });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(SpinFormik, {
    initialValues,
    onSubmit: renamePipeline,
    render: (formik) => /* @__PURE__ */ React__default.createElement(Form, {
      className: "form-horizontal"
    }, /* @__PURE__ */ React__default.createElement(Modal$1, {
      key: "modal",
      show: true,
      onHide: () => {
      }
    }, /* @__PURE__ */ React__default.createElement(ModalClose, {
      dismiss: dismissModal
    }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Rename Pipeline")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, saveError && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-danger"
    }, /* @__PURE__ */ React__default.createElement("p", null, "Could not rename pipeline."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Reason: "), errorMessage), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
      className: "btn btn-link",
      onClick: (e) => {
        e.preventDefault();
        setSaveError(false);
      }
    }, "[dismiss]"))), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "name",
      label: `${pipelineType} Name`,
      input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...inputProps,
        className: "form-control input-sm"
      }),
      required: true,
      validate: [
        Validators.valueUnique(existingNames, `There is already a ${pipelineType} with that name.`),
        validPipelineName()
      ]
    })), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: dismissModal,
      type: "button"
    }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      disabled: !formik.isValid || !formik.dirty,
      type: "submit",
      onClick: () => renamePipeline(formik.values)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: saving ? "fa fa-cog fa-spin" : "far fa-check-circle"
    }), "Rename ", pipelineType))))
  }));
}

var css_248z$H = ".show-pipeline-template-json-modal__copy {\n  margin-bottom: 5px;\n}\n.show-pipeline-template-json-modal__save-error {\n  color: var(--color-danger);\n}\n";
styleInject(css_248z$H);

class ShowPipelineTemplateJsonModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.onChange = (e, property) => {
      if (!this.props.editable) {
        return;
      }
      this.setState({
        template: {
          ...this.state.template,
          metadata: {
            ...this.state.template.metadata,
            [property]: e.target.value
          }
        }
      });
    };
    this.onTemplateSaved = (error) => {
      this.setState({ saveError: error, saving: false });
    };
    this.saveTemplate = () => {
      this.setState({ saveError: null, saving: true });
      this.props.saveTemplate(this.state.template).then((shouldClose) => {
        if (shouldClose) {
          this.props.dismissModal();
        } else {
          this.onTemplateSaved();
        }
      }, (err) => this.onTemplateSaved(err));
    };
    this.state = { template: props.template, saveError: null, saving: false };
  }
  render() {
    const { dismissModal, editable, modalHeading, descriptionText, saveTemplate } = this.props;
    const { template, saveError, saving } = this.state;
    const sortedTemplate = JsonUtils.sortObject(template);
    const templateStr = JsonUtils.makeStringFromObject(sortedTemplate, 0);
    const templateStrWithSpacing = JsonUtils.makeStringFromObject(sortedTemplate);
    const disabled = !editable || !!saving;
    if (saving) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: dismissModal
      }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, modalHeading)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
        className: "flex-fill"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "text-center"
      }, /* @__PURE__ */ React__default.createElement(Spinner, {
        size: "medium",
        message: "Saving ..."
      }))));
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ModalClose, {
      dismiss: dismissModal
    }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, modalHeading)), /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
      className: "flex-fill"
    }, /* @__PURE__ */ React__default.createElement("p", null, descriptionText), /* @__PURE__ */ React__default.createElement("form", {
      className: "form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      htmlFor: "template-name",
      className: "col-md-3 sm-label-right"
    }, "Name"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("input", {
      id: "template-name",
      className: "form-control input-sm",
      type: "text",
      value: template.metadata.name,
      onChange: (e) => this.onChange(e, "name"),
      disabled
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      htmlFor: "template-description",
      className: "col-md-3 sm-label-right"
    }, "Description"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("input", {
      id: "template-description",
      className: "form-control input-sm",
      type: "text",
      value: template.metadata.description,
      onChange: (e) => this.onChange(e, "description"),
      placeholder: "Template Description",
      disabled
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      htmlFor: "template-owner",
      className: "col-md-3 sm-label-right"
    }, "Owner"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement("input", {
      id: "template-owner",
      className: "form-control input-sm",
      type: "text",
      value: template.metadata.owner,
      onChange: (e) => this.onChange(e, "owner"),
      disabled
    }))), !disabled && /* @__PURE__ */ React__default.createElement("div", {
      className: "show-pipeline-template-json-modal__copy text-right"
    }, /* @__PURE__ */ React__default.createElement(CopyToClipboard, {
      buttonInnerNode: /* @__PURE__ */ React__default.createElement("a", null, "Copy the spin command for saving this template"),
      text: `echo '${templateStr}' | spin pipeline-templates save`
    }))), /* @__PURE__ */ React__default.createElement(JsonEditor, {
      value: templateStrWithSpacing,
      readOnly: true
    })), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, saveError && /* @__PURE__ */ React__default.createElement("span", {
      className: "show-pipeline-template-json-modal__save-error"
    }, String(saveError)), /* @__PURE__ */ React__default.createElement(ShowPipelineTemplateJsonModalButtons, {
      onSave: saveTemplate && this.saveTemplate,
      onClose: dismissModal
    })));
  }
}
ShowPipelineTemplateJsonModal.defaultProps = {
  dismissModal: noop,
  editable: true,
  modalHeading: "Export as Pipeline Template",
  descriptionText: "The JSON below is the templated version of your pipeline. Save it by copy/pasting to the Spin CLI tool."
};
const ShowPipelineTemplateJsonModalButtons = (props) => {
  const { onClose, onSave } = props;
  const closeClasses = classNames({ btn: true, "btn-primary": !onSave });
  const saveClasses = classNames({ btn: true, "btn-primary": true });
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("button", {
    className: closeClasses,
    onClick: onClose
  }, "Close"), onSave && /* @__PURE__ */ React__default.createElement("button", {
    className: saveClasses,
    onClick: onSave
  }, "Save"));
};

function UnlockPipelineModal(props) {
  const [errorMessage, setErrorMessage] = React__default.useState(null);
  const [saveError, setSaveError] = React__default.useState(false);
  const { closeModal, dismissModal, pipeline } = props;
  function unlockPipeline() {
    const newPipeline = { ...pipeline };
    unset(newPipeline, "locked");
    PipelineConfigService.savePipeline(newPipeline).then(() => closeModal(), (response) => {
      setSaveError(true);
      setErrorMessage(get(response, "data.message", "No message provided"));
    });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Modal$1, {
    key: "modal",
    show: true,
    onHide: () => {
    }
  }, /* @__PURE__ */ React__default.createElement(ModalClose, {
    dismiss: dismissModal
  }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Really Unlock Pipeline?")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, saveError && /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Could not unlock pipeline."), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Reason: "), errorMessage), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
    className: "btn btn-link",
    onClick: (e) => {
      e.preventDefault();
      setSaveError(false);
    }
  }, "[dismiss]"))), /* @__PURE__ */ React__default.createElement("form", {
    role: "form",
    name: "form",
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("p", null, "Are you sure you want to unlock and allow modifications to ", pipeline.name, "?"))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default",
    onClick: dismissModal,
    type: "button"
  }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-primary",
    onClick: unlockPipeline,
    type: "button"
  }, "Unlock pipeline"))));
}

var css_248z$G = ".copy-stage-card p {\n  margin: 0;\n}\n";
styleInject(css_248z$G);

function CopyStageCard(props) {
  const {
    pipeline,
    strategy,
    stage: { cloudProviderType, comments, name, type }
  } = props;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "copy-stage-card container-fluid"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10"
  }, /* @__PURE__ */ React__default.createElement("b", null, name)), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-2"
  }, cloudProviderType && /* @__PURE__ */ React__default.createElement("div", {
    className: "pull-right"
  }, /* @__PURE__ */ React__default.createElement(CloudProviderLogo, {
    provider: cloudProviderType,
    height: "10px",
    width: "10px"
  })))), /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Type:"), " ", robotToHuman(type)), pipeline && /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Pipeline:"), " ", pipeline), strategy && /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Strategy:"), " ", strategy), /* @__PURE__ */ React__default.createElement("p", {
    className: "small"
  }, comments))));
}

var css_248z$F = ".copy-stage-modal-body .no-stages-message {\n  padding: 0.5rem 2rem;\n}\n.copy-stage-modal-body .well {\n  margin-bottom: 0;\n  padding: 10px;\n}\n.copy-stage-modal-body .well p {\n  margin: 0;\n}\n.copy-stage-modal-body .form-horizontal {\n  margin-bottom: 10px;\n}\n";
styleInject(css_248z$F);

function CopyStageModal(props) {
  const [application, setApplication] = React__default.useState(props.application.name);
  const uncopiableStageTypes = new Set(["deploy"]);
  const initialValues = { application, selectedStage: null };
  const { closeModal, dismissModal, forStrategyConfig } = props;
  const fetchApplications = useLatestPromise(() => ApplicationReader.listApplications(), []);
  const fetchStages = useData(() => getStagesForApplication(application), null, [application]);
  const error = fetchApplications.status === "REJECTED" || fetchStages.status === "REJECTED";
  function getStagesForApplication(applicationName) {
    const configType = forStrategyConfig ? "strategyConfigs" : "pipelineConfigs";
    return REST("/applications").path(applicationName, configType).get().then((configs) => {
      const nestedStageWrappers = configs.map((config) => {
        return (config.stages || []).filter((stage) => !uncopiableStageTypes.has(stage.type)).map((stage) => {
          if (isStrategyConfig(config)) {
            return { strategy: config.name, stage };
          } else {
            return { pipeline: config.name, stage };
          }
        });
      });
      return flatten(nestedStageWrappers);
    });
  }
  function renderCopyStageCard(option) {
    const parsed = JSON.parse(option.value);
    return /* @__PURE__ */ React__default.createElement(CopyStageCard, {
      ...parsed
    });
  }
  function renderCopyStageValue(option) {
    const parsed = JSON.parse(option.value);
    return parsed.stage.name;
  }
  function isStrategyConfig(config) {
    return "strategy" in config;
  }
  function copyStage(command) {
    const parsed = JSON.parse(command.selectedStage);
    closeModal(parsed.stage);
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(SpinFormik, {
    initialValues,
    onSubmit: copyStage,
    render: (formik) => /* @__PURE__ */ React__default.createElement(Modal$1, {
      key: "modal",
      show: true,
      onHide: () => {
      }
    }, /* @__PURE__ */ React__default.createElement(ModalClose, {
      dismiss: dismissModal
    }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Copy Stage")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "copy-stage-modal-body"
    }, error && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-danger"
    }, /* @__PURE__ */ React__default.createElement("p", null, "Could not load stages.")), /* @__PURE__ */ React__default.createElement(Form, {
      name: "form",
      className: "form-horizontal"
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "application",
      label: "From Application",
      input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...inputProps,
        isLoading: fetchApplications.status === "PENDING",
        clearable: false,
        mode: "VIRTUALIZED",
        stringOptions: (fetchApplications.result || []).map((a) => a.name),
        onChange: (e) => setApplication(e.target.value),
        value: application
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "selectedStage",
      label: "Copy Stage",
      required: true,
      input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...inputProps,
        isLoading: fetchStages.status === "PENDING",
        clearable: false,
        disabled: isEmpty(fetchStages.result),
        options: (fetchStages.result || []).map((s) => ({
          label: s.stage.name,
          value: JSON.stringify(s)
        })),
        optionRenderer: renderCopyStageCard,
        valueRenderer: renderCopyStageValue
      })
    }), fetchStages.status === "RESOLVED" && isEmpty(fetchStages.result) && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-offset-3 col-md-7 no-stages-message"
    }, /* @__PURE__ */ React__default.createElement("p", null, "This application has no ", forStrategyConfig ? "strategy" : "pipeline", " stages."))), /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-offset-3 col-md-7"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "well"
    }, /* @__PURE__ */ React__default.createElement("p", {
      className: "small"
    }, "It is not possible to copy a deploy stage, and deploy stages will not be included in the list above."), /* @__PURE__ */ React__default.createElement("br", null), /* @__PURE__ */ React__default.createElement("p", {
      className: "small"
    }, "All source stage fields, including artifact IDs, will be copied into the new stage. If this is not desired behavior, create a new stage from scratch instead."))))))), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: dismissModal,
      type: "button"
    }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      disabled: !formik.isValid || !formik.dirty,
      type: "submit",
      onClick: () => copyStage(formik.values)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "far fa-check-circle"
    }), /* @__PURE__ */ React__default.createElement("span", null, " Copy Stage"))))
  }));
}

class ExecutionBuildTitle extends React__default.Component {
  render() {
    const { execution, defaultToTimestamp } = this.props;
    const hasParentPipeline = !!(execution && execution.trigger.parentPipelineName);
    const hasBuildNumber = !!(execution && execution.buildInfo && execution.buildInfo.number);
    const showBuildInfo = hasBuildNumber && !hasParentPipeline;
    const showStartTime = defaultToTimestamp && !hasParentPipeline && !hasBuildNumber;
    return /* @__PURE__ */ React__default.createElement("span", null, hasParentPipeline && /* @__PURE__ */ React__default.createElement("span", null, execution.trigger.parentPipelineName), showBuildInfo && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "build-label"
    }, "Build"), " #", execution.buildInfo.number), showStartTime && /* @__PURE__ */ React__default.createElement("span", null, timestamp(this.props.execution.startTime)));
  }
}
ExecutionBuildTitle.defaultProps = {
  defaultToTimestamp: false
};
const EXECUTION_BUILD_TITLE = "spinnaker.core.pipeline.executionbuild.executionbuildtitle";
const ngmodule$1 = module(EXECUTION_BUILD_TITLE, []);
ngmodule$1.component("executionBuildTitle", react2angular(withErrorBoundary(ExecutionBuildTitle, "executionBuildTitle"), ["execution", "defaultToTimestamp"]));

class PipelineTemplateWriter {
  static savePipelineTemplateV2(template) {
    return $q((resolve, reject) => {
      REST("/v2/pipelineTemplates/create").post(template).then(resolve, reject);
    });
  }
  static deleteTemplate(template) {
    let request = REST("/v2/pipelineTemplates").path(template.id);
    const params = {};
    if (template.digest) {
      params.digest = template.digest;
    } else if (template.tag) {
      params.tag = template.tag;
    }
    request = request.query(params);
    return request.delete();
  }
}

const CORE_PIPELINE_CONFIG_PIPELINECONFIGURER = "spinnaker.core.pipeline.config.pipelineConfigurer";
angular.module(CORE_PIPELINE_CONFIG_PIPELINECONFIGURER, [OVERRIDE_REGISTRY, PIPELINE_CONFIG_ACTIONS, EXECUTION_BUILD_TITLE]).directive("pipelineConfigurer", function() {
  return {
    restrict: "E",
    scope: {
      pipeline: "=",
      application: "=",
      plan: "<",
      isTemplatedPipeline: "<",
      isV2TemplatedPipeline: "<",
      hasDynamicSource: "<",
      templateError: "<"
    },
    controller: "PipelineConfigurerCtrl as pipelineConfigurerCtrl",
    templateUrl: "core/src/pipeline/config/pipelineConfigurer.html"
  };
}).controller("PipelineConfigurerCtrl", [
  "$scope",
  "$uibModal",
  "$timeout",
  "$window",
  "$q",
  "$state",
  "executionService",
  "overrideRegistry",
  "$location",
  function($scope, $uibModal, $timeout, $window, $q, $state, executionService, overrideRegistry, $location) {
    const ctrl = this;
    const markDirty = () => {
      if (!$scope.viewState.original) {
        setOriginal($scope.pipeline);
      }
      this.setViewState({ isDirty: $scope.viewState.original !== angular.toJson($scope.pipeline) });
    };
    $scope.renderablePipeline = $scope.plan || $scope.pipeline;
    $scope.$watch("renderablePipeline", (newValue, oldValue) => newValue !== oldValue && this.updatePipeline(), true);
    this.warningsPopover = "core/src/pipeline/config/warnings.popover.html";
    const configViewStateCache = ViewStateCache.get("pipelineConfig");
    function buildCacheKey() {
      return PipelineConfigService.buildViewStateCacheKey($scope.application.name, $scope.pipeline.id);
    }
    $scope.viewState = configViewStateCache.get(buildCacheKey()) || {
      section: "triggers",
      stageIndex: 0,
      loading: false,
      revertCount: 0
    };
    const setOriginal = (pipeline) => {
      $scope.viewState.original = angular.toJson(pipeline);
      $scope.viewState.originalRenderablePipeline = angular.toJson($scope.renderablePipeline);
      this.updatePipeline();
    };
    const getOriginal = () => angular.fromJson($scope.viewState.original);
    const getOriginalRenderablePipeline = () => angular.fromJson($scope.viewState.originalRenderablePipeline);
    $scope.navMenuState = {
      showMenu: false
    };
    this.hideNavigationMenu = () => {
      $timeout(() => {
        $scope.navMenuState.showMenu = false;
      }, 200);
    };
    this.deletePipeline = () => {
      ReactModal.show(DeletePipelineModal, { pipeline: $scope.pipeline, application: $scope.application });
    };
    this.addStage = (newStage = { isNew: true }) => {
      $scope.renderablePipeline.stages = $scope.renderablePipeline.stages || [];
      newStage.refId = Math.max(0, ...$scope.renderablePipeline.stages.map((s) => Number(s.refId) || 0)) + 1 + "";
      newStage.requisiteStageRefIds = [];
      if ($scope.renderablePipeline.stages.length && $scope.viewState.section === "stage") {
        newStage.requisiteStageRefIds.push($scope.renderablePipeline.stages[$scope.viewState.stageIndex].refId);
      }
      $scope.renderablePipeline.stages.push(newStage);
      this.navigateToStage($scope.renderablePipeline.stages.length - 1);
    };
    this.copyExistingStage = () => {
      ReactModal.show(CopyStageModal, {
        application: $scope.application,
        forStrategyConfig: $scope.pipeline.strategy
      }).then((stageTemplate) => ctrl.addStage(stageTemplate)).catch(() => {
      });
    };
    $scope.stageSortOptions = {
      axis: "x",
      delay: 150,
      placeholder: "btn btn-default drop-placeholder",
      "ui-floating": true,
      start: (e, ui) => {
        ui.placeholder.width(ui.helper.width()).height(ui.helper.height());
      },
      update: (e, ui) => {
        let itemScope = ui.item.scope();
        const currentPage = $scope.viewState.stageIndex;
        const startingPagePosition = itemScope.$index;
        const isCurrentPage = currentPage === startingPagePosition;
        $timeout(() => {
          itemScope = ui.item.scope();
          const newPagePosition = itemScope.$index;
          if (isCurrentPage) {
            ctrl.navigateToStage(newPagePosition);
          } else {
            const wasBefore = startingPagePosition < currentPage;
            const isBefore = newPagePosition <= currentPage;
            if (wasBefore !== isBefore) {
              const newCurrentPage = isBefore ? currentPage + 1 : currentPage - 1;
              ctrl.navigateToStage(newCurrentPage);
            }
          }
        });
      }
    };
    this.renamePipeline = () => {
      ReactModal.show(RenamePipelineModal, { pipeline: $scope.pipeline, application: $scope.application }).then((pipelineName) => {
        $scope.pipeline.name = pipelineName;
        return this.applyUpdateTs($scope.pipeline);
      }).catch(() => {
      });
    };
    this.editPipelineJson = () => {
      const modalProps = { dialogClassName: "modal-lg modal-fullscreen" };
      ReactModal.show(EditPipelineJsonModal, { pipeline: $scope.pipeline, plan: $scope.plan }, modalProps).then(() => {
        $scope.$broadcast("pipeline-json-edited");
        this.updatePipeline();
      }).catch(() => {
      });
    };
    this.enablePipeline = () => {
      ReactModal.show(EnablePipelineModal, { pipeline: getOriginal() }).then(() => disableToggled(false)).catch(() => {
      });
    };
    this.exportPipelineTemplate = () => {
      const modalProps = { dialogClassName: "modal-lg modal-fullscreen" };
      const pipeline = $scope.pipeline;
      const ownerEmail = ___default.get($scope, "application.attributes.email", "");
      const template = PipelineTemplateV2Service.createPipelineTemplate(pipeline, ownerEmail);
      const templateProps = {
        template,
        saveTemplate: this.saveTemplate
      };
      ReactModal.show(ShowPipelineTemplateJsonModal, templateProps, modalProps);
    };
    this.disablePipeline = () => {
      ReactModal.show(DisablePipelineModal, { pipeline: getOriginal() }).then(() => disableToggled(true)).catch(() => {
      });
    };
    function disableToggled(isDisabled) {
      $scope.pipeline.disabled = isDisabled;
      const original = getOriginal();
      original.disabled = isDisabled;
      setOriginal(original);
    }
    this.lockPipeline = () => {
      ReactModal.show(LockPipelineModal, { pipeline: $scope.pipeline }).then((pipeline) => {
        $scope.pipeline.locked = pipeline.locked;
        setOriginal($scope.pipeline);
      }).catch(() => {
      });
    };
    this.unlockPipeline = () => {
      ReactModal.show(UnlockPipelineModal, { pipeline: $scope.pipeline }).then(() => {
        delete $scope.pipeline.locked;
        setOriginal($scope.pipeline);
      }).catch(() => {
      });
    };
    this.showHistory = () => {
      ReactModal.show(ShowPipelineHistoryModal, {
        pipelineConfigId: $scope.pipeline.id,
        isStrategy: $scope.pipeline.strategy,
        currentConfig: $scope.viewState.isDirty ? JSON.parse(angular.toJson($scope.pipeline)) : null
      }).then((newConfig) => {
        $scope.renderablePipeline = newConfig;
        $scope.pipeline = newConfig;
        $scope.$broadcast("pipeline-json-edited");
        this.savePipeline();
      }).catch(() => {
      });
    };
    this.setViewState = (newViewState) => {
      Object.assign($scope.viewState, newViewState);
      const viewState = ___default.clone($scope.viewState);
      $scope.$applyAsync(() => $scope.viewState = viewState);
    };
    this.updatePipeline = () => {
      $scope.$applyAsync(() => {
        $scope.renderablePipeline = ___default.clone($scope.renderablePipeline);
        if ($scope.isTemplatedPipeline) {
          $scope.plan = $scope.renderablePipeline;
        } else {
          $scope.pipeline = $scope.renderablePipeline;
        }
      });
    };
    this.navigateToStage = (index, event) => {
      if (index < 0 || !$scope.renderablePipeline.stages || $scope.renderablePipeline.stages.length <= index) {
        this.setViewState({ section: "triggers" });
        return;
      }
      this.setViewState({ section: "stage", stageIndex: index });
      if (event && event.target && event.target.focus) {
        event.target.focus();
      }
    };
    this.navigateTo = (stage) => {
      if (stage.section === "stage") {
        ctrl.navigateToStage(stage.index);
      } else {
        this.setViewState({ section: stage.section });
      }
    };
    this.graphNodeClicked = this.navigateTo.bind(this);
    this.isActive = (section) => {
      return $scope.viewState.section === section;
    };
    this.stageIsActive = (index) => {
      return $scope.viewState.section === "stage" && $scope.viewState.stageIndex === index;
    };
    this.removeStage = (stage) => {
      const stageIndex = $scope.renderablePipeline.stages.indexOf(stage);
      $scope.renderablePipeline.stages.splice(stageIndex, 1);
      $scope.renderablePipeline.stages.forEach((test) => {
        if (stage.refId && test.requisiteStageRefIds) {
          if (test.requisiteStageRefIds.includes(stage.refId)) {
            test.requisiteStageRefIds = test.requisiteStageRefIds.filter((id) => id !== stage.refId);
            if (!test.requisiteStageRefIds.length) {
              test.requisiteStageRefIds = [...stage.requisiteStageRefIds];
            }
          }
        }
      });
      if (stageIndex > 0) {
        this.setViewState({ stageIndex: $scope.viewState.stageIndex - 1 });
      }
      if (stageIndex === $scope.viewState.stageIndex && stageIndex === 0) {
        $scope.$broadcast("pipeline-json-edited");
      }
      if (!$scope.renderablePipeline.stages.length) {
        this.navigateTo({ section: "triggers" });
      }
    };
    this.isValid = () => {
      return ___default.every($scope.pipeline.stages, function(item) {
        return item["name"] && item["type"];
      }) && !ctrl.preventSave;
    };
    this.configureTemplate = () => {
      const controller = PipelineTemplateV2Service.isV2PipelineConfig($scope.pipeline) ? {
        name: "ConfigurePipelineTemplateModalV2Ctrl",
        template: "core/src/pipeline/config/templates/v2/configurePipelineTemplateModalV2.html"
      } : {
        name: "ConfigurePipelineTemplateModalCtrl",
        template: "core/src/pipeline/config/templates/configurePipelineTemplateModal.html"
      };
      this.setViewState({ loading: true });
      $uibModal.open({
        size: "lg",
        templateUrl: controller.template,
        controller: `${controller.name} as ctrl`,
        resolve: {
          application: () => $scope.application,
          pipelineTemplateConfig: () => ___default.cloneDeep($scope.pipeline),
          isNew: () => $scope.pipeline.isNew,
          pipelineId: () => $scope.pipeline.id,
          executionId: () => $scope.renderablePipeline.executionId
        }
      }).result.then(({ plan, config }) => {
        $scope.pipeline = config;
        delete $scope.pipeline.isNew;
        $scope.renderablePipeline = plan;
      }).catch(() => {
      }).finally(() => this.setViewState({ loading: false }));
    };
    this.applyUpdateTs = (toSave) => {
      return $scope.application.pipelineConfigs.refresh(true).then((pipelines) => {
        const latestFromServer = pipelines.find((p) => p.id === toSave.id);
        if (latestFromServer && latestFromServer.updateTs) {
          toSave.updateTs = latestFromServer.updateTs;
          this.updatePipelineConfig({ updateTs: latestFromServer.updateTs });
        }
        setOriginal(toSave);
        markDirty();
      });
    };
    this.savePipeline = () => {
      this.setViewState({ saving: true });
      const toSave = ___default.cloneDeep($scope.pipeline);
      PipelineConfigService.savePipeline(toSave).then(() => this.applyUpdateTs(toSave)).then(() => {
        this.setViewState({
          saveError: false,
          saving: false
        });
      }, (err) => this.setViewState({
        saveError: true,
        saving: false,
        saveErrorMessage: ctrl.getErrorMessage(err.data.message)
      }));
    };
    this.getErrorMessage = (errorMsg) => {
      let msg = "There was an error saving your pipeline";
      if (___default.isString(errorMsg)) {
        msg += ": " + errorMsg;
      }
      msg += ".";
      return msg;
    };
    this.getPipelineExecutions = () => {
      executionService.getExecutionsForConfigIds([$scope.pipeline.id], {
        limit: 5,
        transform: true,
        application: $scope.pipeline.application
      }).then((executions) => {
        executions.forEach((execution) => ExecutionsTransformer.addBuildInfo(execution));
        $scope.pipelineExecutions = executions;
        if ($scope.plan && $scope.plan.executionId) {
          $scope.currentExecution = ___default.find($scope.pipelineExecutions, { id: $scope.plan.executionId });
        } else if ($location.search().executionId) {
          $scope.currentExecution = ___default.find($scope.pipelineExecutions, { id: $location.search().executionId });
        } else {
          $scope.currentExecution = $scope.pipelineExecutions[0];
        }
      }).catch(() => $scope.pipelineExecutions = []);
    };
    this.revertPipelineChanges = () => {
      $scope.$applyAsync(() => {
        const original = getOriginal();
        Object.keys($scope.pipeline).forEach((key) => {
          delete $scope.pipeline[key];
        });
        Object.assign($scope.pipeline, original);
        if ($scope.isTemplatedPipeline) {
          const originalRenderablePipeline = getOriginalRenderablePipeline();
          Object.assign($scope.renderablePipeline, originalRenderablePipeline);
          Object.keys($scope.renderablePipeline).forEach((key) => {
            if (!originalRenderablePipeline.hasOwnProperty(key)) {
              delete $scope.renderablePipeline[key];
            }
          });
        } else {
          $scope.renderablePipeline = $scope.pipeline;
        }
        if ($scope.viewState.section === "stage") {
          const lastStage = $scope.renderablePipeline.stages.length - 1;
          if ($scope.viewState.stageIndex > lastStage) {
            this.setViewState({ stageIndex: lastStage });
          }
          if (!$scope.renderablePipeline.stages.length) {
            this.navigateTo({ section: "triggers" });
          }
        }
        $scope.viewState.revertCount = ($scope.viewState.revertCount || 0) + 1;
        $scope.$broadcast("pipeline-reverted");
      });
    };
    this.stageFieldUpdated = () => markDirty();
    function cacheViewState() {
      const toCache = { section: $scope.viewState.section, stageIndex: $scope.viewState.stageIndex };
      configViewStateCache.put(buildCacheKey(), toCache);
    }
    $scope.$watch("pipeline", markDirty, true);
    $scope.$watch("viewState.original", markDirty);
    $scope.$watchGroup(["viewState.section", "viewState.stageIndex"], cacheViewState);
    this.navigateTo({ section: $scope.viewState.section, index: $scope.viewState.stageIndex });
    this.getUrl = () => {
      return $location.absUrl();
    };
    const warningMessage = "You have unsaved changes.\nAre you sure you want to navigate away from this page?";
    const confirmPageLeave = $scope.$on("$stateChangeStart", (event) => {
      if ($scope.viewState.isDirty) {
        if (!$window.confirm(warningMessage)) {
          event.preventDefault();
        }
      }
    });
    const validationSubscription = PipelineConfigValidator.subscribe((validations) => {
      this.validations = validations;
      this.preventSave = validations.preventSave;
    });
    $window.onbeforeunload = () => {
      if ($scope.viewState.isDirty) {
        return warningMessage;
      }
    };
    $scope.$on("$destroy", () => {
      confirmPageLeave();
      validationSubscription.unsubscribe();
      $window.onbeforeunload = void 0;
    });
    if ($scope.hasDynamicSource) {
      this.getPipelineExecutions();
    }
    if ($scope.isTemplatedPipeline && $scope.pipeline.isNew && !$scope.hasDynamicSource) {
      this.configureTemplate();
    }
    this.saveTemplate = (template) => {
      return PipelineTemplateWriter.savePipelineTemplateV2(template).then((response) => {
        const id = response.variables.find((v) => v.key === "pipelineTemplate.id").value;
        $state.go("home.pipeline-templates.pipeline-templates-detail", {
          templateId: PipelineTemplateV2Service.idForTemplate({ id })
        });
        return true;
      }, (err) => {
        throw err;
      });
    };
    this.updatePipelineConfig = (changes) => {
      $scope.pipeline = Object.assign($scope.pipeline, $scope.isV2TemplatedPipeline ? PipelineTemplateV2Service.filterInheritedConfig(Object.assign({}, changes)) : changes);
      if ($scope.isV2TemplatedPipeline) {
        $scope.renderablePipeline = Object.assign($scope.renderablePipeline, changes);
      } else if (!$scope.isTemplatedPipeline) {
        $scope.renderablePipeline = $scope.pipeline;
      }
      markDirty();
    };
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/pipelineConfigurer.html", `<div class="pipeline-configurer" ng-if="!viewState.loading">
  <div class="pipeline-config-heading">
    <div class="config-heading-row">
      <h3>
        <a class="btn btn-configure" ui-sref="^.executions" uib-tooltip="Back to Executions">
          <span class="glyphicon glyphicon glyphicon-circle-arrow-left"></span>
        </a>
        <a
          href
          class="nav-popover"
          ng-click="navMenuState.showMenu = !navMenuState.showMenu"
          ng-blur="pipelineConfigurerCtrl.hideNavigationMenu()"
        >
          {{ pipeline.name }}
          <span ng-if="pipeline.disabled">(disabled)</span>
        </a>
      </h3>
      <div class="config-heading-actions">
        <div class="permalink">
          <a
            target="_blank"
            analytics-on="click"
            analytics-category="Pipeline Config"
            analytics-event="Permalink clicked"
            ng-href="{{ pipelineConfigurerCtrl.getUrl() }}"
            >Permalink</a
          >
          <copy-to-clipboard
            text="pipelineConfigurerCtrl.getUrl()"
            tool-tip="'Copy permalink to clipboard'"
          ></copy-to-clipboard>
        </div>
        <div class="create-action">
          <create-pipeline application="application"></create-pipeline>
        </div>
        <div class="pipeline-actions text-right">
          <Pipeline-Config-Actions
            pipeline="pipeline"
            rename-pipeline="pipelineConfigurerCtrl.renamePipeline"
            delete-pipeline="pipelineConfigurerCtrl.deletePipeline"
            enable-pipeline="pipelineConfigurerCtrl.enablePipeline"
            disable-pipeline="pipelineConfigurerCtrl.disablePipeline"
            lock-pipeline="pipelineConfigurerCtrl.lockPipeline"
            unlock-pipeline="pipelineConfigurerCtrl.unlockPipeline"
            edit-pipeline-json="pipelineConfigurerCtrl.editPipelineJson"
            show-history="pipelineConfigurerCtrl.showHistory"
            export-pipeline-template="pipelineConfigurerCtrl.exportPipelineTemplate"
          ></Pipeline-Config-Actions>
        </div>
      </div>
    </div>
    <div class="band band-info" ng-if="pipeline.locked">
      <span class="glyphicon glyphicon small glyphicon-lock"></span>
      {{ pipeline.locked.description || 'This pipeline is locked and does not allow modification' }}
    </div>
    <div class="band band-info" ng-if="isTemplatedPipeline && !pipeline.locked">
      <span class="glyphicon glyphicon small glyphicon-lock"></span> Manual edits are not allowed on templated pipelines
    </div>
    <div class="band band-info" ng-if="hasDynamicSource && pipelineExecutions.length">
      <span class="glyphicon glyphicon small glyphicon-wrench"></span> This template has a dynamic source. The
      configuration is currently rendered using
      <span ng-if="pipelineExecutions.length > 1" class="dropdown" uib-dropdown>
        &nbsp;&nbsp;<button type="button" class="btn btn-xs btn-default dropdown-toggle" uib-dropdown-toggle>
          <execution-build-title execution="currentExecution" default-to-timestamp="true"></execution-build-title>
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu" role="menu" uib-dropdown-menu>
          <li ng-repeat="p in pipelineExecutions" ng-class="{disabled: p.id == currentExecution.id}">
            <a title="{{ p.startTime | timestamp }}" ui-sref="{ executionId: p.id }"
              ><execution-build-title execution="p" default-to-timestamp="true"></execution-build-title>
              <span class="text-muted small">({{ p.startTime | relativeTime }})</span>
              <span class="glyphicon small glyphicon-ok" ng-if="p.id == currentExecution.id"></span>
            </a>
          </li>
        </ul>
      </span>
      <span ng-if="pipelineExecutions.length === 1"
        ><execution-build-title execution="currentExecution" default-to-timestamp="true"></execution-build-title
      ></span>
    </div>
    <div class="band band-warning" ng-if="pipelineExecutions && !pipelineExecutions.length">
      <span class="glyphicon glyphicon small glyphicon-alert"></span> This template has a dynamic source. The
      configuration cannot be rendered before the pipeline has executed at least once.
    </div>
    <div class="band band-warning" ng-if="templateError && pipelineExecutions.length && isTemplatedPipeline">
      <span class="glyphicon glyphicon small glyphicon-alert"></span> Could not render the pipeline configuration
      because of an error: {{ templateError.data.message }} {{ templateError.data.error }}
    </div>
    <div class="config-heading-body">
      <div class="pipeline-graph-container pipeline-config-graph">
        <pipeline-graph
          view-state="viewState"
          pipeline="renderablePipeline"
          should-validate="true"
          on-node-click="(pipelineConfigurerCtrl.graphNodeClicked)"
        ></pipeline-graph>
      </div>
      <div class="row">
        <div class="col-md-8">
          <button
            class="btn btn-block btn-sm add-new"
            analytics-on="click"
            analytics-category="Pipeline Config"
            analytics-event="Add stage button clicked"
            ng-click="pipelineConfigurerCtrl.addStage()"
          >
            <span class="glyphicon glyphicon-plus-sign"></span> Add stage
          </button>
        </div>
        <div class="col-md-4">
          <button
            class="btn btn-block btn-sm add-new"
            analytics-on="click"
            analytics-category="Pipeline Config"
            analytics-event="Copy existing stage button clicked"
            ng-click="pipelineConfigurerCtrl.copyExistingStage()"
          >
            <span class="glyphicon glyphicon-duplicate"></span> Copy an existing stage
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="pipeline-contents">
    <pipeline-config-view
      application="application"
      is-v2-templated-pipeline="isV2TemplatedPipeline"
      pipeline="renderablePipeline"
      pipeline-config="pipeline"
      stage-field-updated="pipelineConfigurerCtrl.stageFieldUpdated"
      update-pipeline-config="pipelineConfigurerCtrl.updatePipelineConfig"
      view-state="viewState"
    ></pipeline-config-view>

    <div class="row main-footer fixed-footer horizontal">
      <div class="fixed-footer-button">
        <button
          data-test-id="Pipeline.revertChanges"
          is-visible="!pipeline.locked && viewState.isDirty && !viewState.saving"
          class="btn btn-default"
          analytics-on="click"
          analytics-category="Pipeline Config"
          analytics-event="Revert changes clicked"
          ng-click="pipelineConfigurerCtrl.revertPipelineChanges()"
        >
          <span class="glyphicon glyphicon-flash"></span> Revert
        </button>
      </div>
      <div class="text-right">
        <button
          class="btn btn-link"
          ng-if="pipelineConfigurerCtrl.validations.hasWarnings"
          uib-popover-template="pipelineConfigurerCtrl.warningsPopover"
          popover-placement="left-bottom"
          popover-trigger="'mouseenter'"
        >
          <i class="fa fa-exclamation-triangle" style="font-size: 125%"></i>
        </button>
        <span ng-if="viewState.saveError" class="alert alert-danger">
          {{ viewState.saveErrorMessage }}
          <a
            class="alert-dismiss"
            href
            analytics-on="click"
            analytics-category="Pipeline Config"
            analytics-event="Error saving changes dismissed"
            ng-click="viewState.saveError = false; viewState.saveErrorMessage = null"
            >[dismiss]</a
          >
        </span>

        <button
          class="btn btn-default"
          ng-if="isTemplatedPipeline"
          ng-click="pipelineConfigurerCtrl.configureTemplate()"
        >
          <span class="fa fa-wrench"></span> Configure Template
        </button>
        <button
          ng-if="!pipeline.locked && viewState.isDirty"
          ng-disabled="!pipelineConfigurerCtrl.isValid()"
          class="btn btn-primary"
          analytics-on="click"
          analytics-category="Pipeline Config"
          analytics-event="Save pipeline clicked"
          ng-click="pipelineConfigurerCtrl.savePipeline()"
        >
          <span ng-if="!viewState.saving"> <span class="far fa-check-circle"></span> Save Changes </span>
          <span ng-if="viewState.saving" class="pulsing"> <span class="fa fa-cog fa-spin"></span> Saving&hellip; </span>
        </button>
        <span ng-if="!pipeline.locked && !viewState.isDirty" class="btn btn-link disabled"
          ><span class="far fa-check-circle"></span> In sync with server</span
        >
        <span
          ng-if="pipeline.locked"
          class="btn btn-link disabled"
          uib-tooltip="{{ pipeline.locked.description || 'This pipeline is locked and does not allow modification' }}"
        >
          <span class="glyphicon glyphicon-lock"></span> Pipeline is locked
        </span>
      </div>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/warnings.popover.html", `<div>
  <p>The following errors may affect the ability to run this pipeline:</p>
  <div ng-if="pipelineConfigurerCtrl.validations.pipeline">
    <strong>Configuration</strong>
    <ul>
      <li ng-repeat="message in pipelineConfigurerCtrl.validations.pipeline" ng-bind-html="message"></li>
    </ul>
  </div>
  <div ng-repeat="warning in pipelineConfigurerCtrl.validations.stages">
    <strong>{{warning.stage.name}}</strong>
    <ul>
      <li ng-repeat="message in warning.messages" ng-bind-html="message"></li>
    </ul>
  </div>
  <ul>
    <li ng-repeat="message in stage.warnings.messages" ng-bind-html="message"></li>
  </ul>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/templates/v2/configurePipelineTemplateModalV2.html", `<div ng-if="ctrl.state.loading" style="height: 300px">
  <loading-spinner size="'small'"></loading-spinner>
</div>
<v2-modal-wizard
  heading="Define template parameters: {{::ctrl.pipelineName}}"
  dismiss="$dismiss()"
  ng-if="!ctrl.state.loading"
>
  <v2-wizard-page
    key="{{::group.name}}"
    label="{{::group.name}}"
    mark-complete-on-view="false"
    ng-if="!ctrl.state.error && !ctrl.state.loading && !ctrl.state.loadingError && ctrl.variableMetadataGroups"
    ng-repeat="group in ctrl.variableMetadataGroups"
  >
    <variable
      ng-repeat="metadata in group.variableMetadata"
      class="clearfix"
      variable-metadata="metadata"
      variable="ctrl.getVariable(metadata.name)"
      on-change="(ctrl.handleVariableChange)"
    ></variable>
  </v2-wizard-page>
  <div ng-if="ctrl.state.error" class="alert alert-danger">
    <p>Could not generate pipeline from provided template configuration.</p>
    <p><template-plan-errors errors="ctrl.state.planErrors"></template-plan-errors></p>
    <p><a href ng-click="ctrl.dismissError()">[dismiss]</a></p>
  </div>
  <div ng-if="ctrl.state.loadingError" class="alert alert-danger">
    <p>Could not load pipeline template.</p>
  </div>
  <div ng-if="ctrl.state.noVariables && !ctrl.state.error" class="alert alert-info">
    <p>This template has no variables to configure.</p>
  </div>
  <div ng-if="!ctrl.state.error && !ctrl.state.loadingError" class="alert alert-info">
    <strong>Inherit the following configuration from the template</strong>
    <p><input type="checkbox" ng-model="ctrl.state.inheritTemplateNotifications" /> Notifications</p>
    <p><input type="checkbox" ng-model="ctrl.state.inheritTemplateParameters" /> Parameters</p>
    <p><input type="checkbox" ng-model="ctrl.state.inheritTemplateTriggers" /> Triggers</p>
  </div>
  <div class="modal-footer" ng-if="!ctrl.state.loading">
    <button ng-if="!ctrl.isNew && !ctrl.state.noVariables" class="btn btn-default" ng-click="ctrl.cancel()">
      Cancel
    </button>
    <button ng-if="ctrl.state.noVariables" class="btn btn-default" ng-click="ctrl.submit()">Dismiss</button>
    <submit-button
      label="'Configure'"
      ng-if="!ctrl.state.noVariables && !ctrl.state.error && !ctrl.state.loadingError"
      is-disabled="!ctrl.formIsValid()"
      on-click="ctrl.submit()"
    >
    </submit-button>
  </div>
</v2-modal-wizard>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/templates/configurePipelineTemplateModal.html", `<div ng-if="ctrl.state.loading" style="height: 300px">
  <loading-spinner size="'small'"></loading-spinner>
</div>
<v2-modal-wizard
  heading="Define template parameters: {{::ctrl.pipelineName}}"
  dismiss="$dismiss()"
  ng-if="!ctrl.state.loading"
>
  <v2-wizard-page
    key="{{::group.name}}"
    label="{{::group.name}}"
    mark-complete-on-view="false"
    ng-if="!ctrl.state.error && !ctrl.state.loading && !ctrl.state.loadingError && ctrl.variableMetadataGroups"
    ng-repeat="group in ctrl.variableMetadataGroups"
  >
    <variable
      ng-repeat="metadata in group.variableMetadata"
      class="clearfix"
      variable-metadata="metadata"
      variable="ctrl.getVariable(metadata.name)"
      on-change="ctrl.handleVariableChange"
    ></variable>
  </v2-wizard-page>
  <div ng-if="ctrl.state.error" class="alert alert-danger">
    <p>Could not generate pipeline from provided template configuration.</p>
    <p><template-plan-errors errors="ctrl.state.planErrors"></template-plan-errors></p>
    <p><a href ng-click="ctrl.dismissError()">[dismiss]</a></p>
  </div>
  <div ng-if="ctrl.state.loadingError" class="alert alert-danger">
    <p>Could not load pipeline template.</p>
  </div>
  <div ng-if="ctrl.state.noVariables && !ctrl.state.error" class="alert alert-info">
    <p>This template has no variables to configure.</p>
  </div>
  <div ng-if="!ctrl.state.error" class="alert alert-info">
    <strong>Inherit the following configuration from the template</strong>
    <p><input type="checkbox" ng-model="ctrl.state.inheritTemplateExpectedArtifacts" /> Expected Artifacts</p>
    <p><input type="checkbox" ng-model="ctrl.state.inheritTemplateTriggers" /> Triggers</p>
    <p><input type="checkbox" ng-model="ctrl.state.inheritTemplateParameters" /> Parameters</p>
  </div>
  <div class="modal-footer" ng-if="!ctrl.state.loading">
    <button ng-if="!ctrl.isNew && !ctrl.state.noVariables" class="btn btn-default" ng-click="ctrl.cancel()">
      Cancel
    </button>
    <button ng-if="ctrl.state.noVariables" class="btn btn-default" ng-click="ctrl.submit()">Dismiss</button>
    <submit-button
      label="'Configure'"
      ng-if="!ctrl.state.noVariables && !ctrl.state.error && !ctrl.state.loadingError"
      is-disabled="!ctrl.formIsValid()"
      on-click="ctrl.submit()"
    >
    </submit-button>
  </div>
</v2-modal-wizard>
`);
}]);

class StageConfigWrapper extends React__default.Component {
  render() {
    const { component: StageConfig, updateStageField, ...otherProps } = this.props;
    return /* @__PURE__ */ React__default.createElement(StageConfig, {
      updateStage: updateStageField,
      updateStageField: (changes) => {
        updateStageField(changes);
        this.forceUpdate();
      },
      ...otherProps
    });
  }
}

const CORE_PIPELINE_CONFIG_STAGES_BASEPROVIDERSTAGE_BASEPROVIDERSTAGE = "spinnaker.core.pipeline.stage.baseProviderStage";
module(CORE_PIPELINE_CONFIG_STAGES_BASEPROVIDERSTAGE_BASEPROVIDERSTAGE, []).controller("BaseProviderStageCtrl", [
  "$scope",
  "stage",
  "$timeout",
  function($scope, stage, $timeout) {
    const dockerBakeEnabled = SETTINGS.feature.dockerBake && stage.type === "bake";
    $scope.stage = stage;
    $scope.viewState = $scope.viewState || {};
    $scope.viewState.loading = true;
    const stageProviders = Registry.pipeline.getProvidersFor(stage.type);
    if (dockerBakeEnabled) {
      stageProviders.push({ cloudProvider: "docker" });
    }
    AccountService.listProviders$($scope.application).pipe(take(1)).subscribe(function(providers) {
      $scope.viewState.loading = false;
      const availableProviders = [];
      stageProviders.forEach((sp) => {
        if (sp.cloudProvider && providers.includes(sp.cloudProvider)) {
          availableProviders.push(sp.cloudProvider);
        } else if (sp.providesFor) {
          availableProviders.push(...sp.providesFor.filter((p) => providers.includes(p)));
        }
      });
      if (dockerBakeEnabled) {
        availableProviders.push("docker");
      }
      if (availableProviders.length === 1) {
        $scope.stage.cloudProviderType = availableProviders[0];
      } else if (!$scope.stage.cloudProviderType && $scope.stage.cloudProvider) {
        $scope.stage.cloudProviderType = $scope.stage.cloudProvider;
      } else {
        $scope.providers = availableProviders;
      }
    });
    let reactMounted = false;
    function loadProvider() {
      const stageProvider = (stageProviders || []).find((s) => s.cloudProvider === stage.cloudProviderType || (s.providesFor || []).includes(stage.cloudProviderType));
      if (stageProvider) {
        $scope.stage.type = stageProvider.key || $scope.stage.type;
        const el = document.querySelector(".react-stage-details");
        if (reactMounted) {
          ReactDOM__default.unmountComponentAtNode(el);
        }
        if (stageProvider.component) {
          const props = $scope.reactPropsForBaseProviderStage;
          props.component = stageProvider.component;
          $timeout(() => {
            ReactDOM__default.render(React__default.createElement(StageConfigWrapper, props), el || document.querySelector(".react-stage-details"));
          }, 0);
        } else {
          $scope.providerStageDetailsUrl = stageProvider.templateUrl;
        }
        reactMounted = !!stageProvider.component;
      }
    }
    $scope.$watch("stage.cloudProviderType", loadProvider);
  }
]);

const nameFromRefId = (stages, refId) => {
  const stage = stages.find((s) => s.refId === refId);
  if (stage) {
    return stage.name;
  }
  return "";
};
const StageName = (props) => {
  return /* @__PURE__ */ React__default.createElement("span", null, nameFromRefId(props.stages, props.refId));
};
const STAGE_NAME = "spinnaker.core.artifact.stageName.component";
module(STAGE_NAME, []).component("stageName", react2angular(withErrorBoundary(StageName, "stageName"), ["stages", "refId"]));

class EditStageJsonModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.immutableFields = ["$$hashKey", "refId", "requisiteStageRefIds"];
    this.onValidate = (errorMessage) => {
      this.setState({ errorMessage });
    };
    this.updateJson = (stageJSON) => {
      this.setState({ stageJSON });
    };
    const copy = cloneDeepWith(props.stage, (value) => {
      if (value && value.$$hashKey) {
        delete value.$$hashKey;
      }
      return void 0;
    });
    this.immutableFields.forEach((k) => delete copy[k]);
    this.state = {
      stageJSON: JsonUtils.makeSortedStringFromObject(copy)
    };
  }
  updateStage() {
    const { stageJSON } = this.state;
    const { stage } = this.props;
    try {
      const parsed = JSON.parse(stageJSON);
      Object.keys(stage).filter((k) => !this.immutableFields.includes(k)).forEach((k) => delete stage[k]);
      Object.assign(stage, parsed);
      this.props.closeModal();
    } catch (e) {
      this.setState({ errorMessage: e.message });
    }
  }
  render() {
    const { stageJSON, errorMessage } = this.state;
    const invalid = !!errorMessage;
    const { dismissModal } = this.props;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Edit Stage JSON")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, {
      className: "flex-fill"
    }, /* @__PURE__ */ React__default.createElement("p", null, "The JSON below represents the stage configuration in its persisted state."), /* @__PURE__ */ React__default.createElement("form", {
      name: "form",
      className: "form-horizontal flex-fill"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-fill"
    }, /* @__PURE__ */ React__default.createElement(JsonEditor, {
      value: stageJSON,
      onChange: this.updateJson,
      onValidation: this.onValidate
    }))), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, "Note:"), ` Clicking "Update Stage" below will not save your changes to the server - it only updates the configuration within the browser, so you'll want to verify your changes and click "Save Changes" when you're ready.`)), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, invalid && /* @__PURE__ */ React__default.createElement("div", {
      className: "slide-in"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "error-message"
    }, "Error: ", errorMessage)), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: () => dismissModal()
    }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      disabled: invalid,
      onClick: () => this.updateStage()
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "far fa-check-circle"
    }), " Update Stage")));
  }
}
EditStageJsonModal.defaultProps = {
  closeModal: noop,
  dismissModal: noop
};

class BaseExecutionDetailsCtrl {
  constructor($scope, $stateParams, executionDetailsSectionService) {
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.executionDetailsSectionService = executionDetailsSectionService;
    this.$scope.$on("$stateChangeSuccess", () => this.initialize());
    this.$scope.$watch("configSections", () => this.initialize());
  }
  $onInit() {
    this.initialize();
  }
  initialize() {
    this.executionDetailsSectionService.synchronizeSection(this.$scope.configSections, () => this.initialized());
  }
  initialized() {
    this.$scope.detailsSection = this.$stateParams.details;
  }
}
BaseExecutionDetailsCtrl.$inject = ["$scope", "$stateParams", "executionDetailsSectionService"];
const BASE_EXECUTION_DETAILS_CTRL = "spinnaker.core.pipeline.config.stages.common.baseExecutionDetails.controller";
module(BASE_EXECUTION_DETAILS_CTRL, [UIROUTER_ANGULARJS, EXECUTION_DETAILS_SECTION_SERVICE]).controller("BaseExecutionDetailsCtrl", BaseExecutionDetailsCtrl);

var css_248z$E = "stage-config-field {\n  display: block;\n}\nstage-config-field label {\n  font-weight: 600;\n}\nstage-config-field label .help-contents {\n  font-weight: normal;\n}\n";
styleInject(css_248z$E);

const CORE_PIPELINE_CONFIG_STAGES_COMMON_STAGECONFIGFIELD_STAGECONFIGFIELD_DIRECTIVE = "spinnaker.core.pipeline.config.stages.common.stageField.directive";
module(CORE_PIPELINE_CONFIG_STAGES_COMMON_STAGECONFIGFIELD_STAGECONFIGFIELD_DIRECTIVE, [
  HELP_FIELD_COMPONENT
]).directive("stageConfigField", function() {
  return {
    restrict: "E",
    transclude: true,
    scope: {},
    controllerAs: "vm",
    templateUrl: "core/src/pipeline/config/stages/common/stageConfigField/stageConfigField.directive.html",
    bindToController: {
      label: "@",
      helpKey: "@",
      helpKeyExpand: "@",
      fieldColumns: "@"
    },
    controller: function() {
      this.$onInit = () => {
        this.fieldColumns = this.fieldColumns || 8;
      };
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/common/stageConfigField/stageConfigField.directive.html", `<div class="form-group">
  <label class="col-md-3 sm-label-right">
    <span class="label-text" ng-bind="vm.label"></span>
    <help-field key="{{vm.helpKey}}" expand="vm.helpKeyExpand"></help-field>
  </label>
  <div class="col-md-{{vm.fieldColumns}}">
    <ng-transclude></ng-transclude>
  </div>
</div>
`);
}]);

const CORE_PIPELINE_CONFIG_STAGES_FAILONFAILEDEXPRESSIONS_FAILONFAILEDEXPRESSIONS_DIRECTIVE = "spinnaker.core.pipeline.stage.failOnFailedExpressions.directive";
module(CORE_PIPELINE_CONFIG_STAGES_FAILONFAILEDEXPRESSIONS_FAILONFAILEDEXPRESSIONS_DIRECTIVE, []).component("failOnFailedExpressions", {
  bindings: {
    stage: "<"
  },
  templateUrl: "core/src/pipeline/config/stages/failOnFailedExpressions/failOnFailedExpressions.directive.html"
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/failOnFailedExpressions/failOnFailedExpressions.directive.html", `<div>
  <div class="form-group">
    <div class="col-md-8 col-md-offset-1">
      <div class="checkbox pull-left">
        <label>
          <input type="checkbox" ng-false-value="false" ng-model="$ctrl.stage.failOnFailedExpressions" />
          <strong
            >Fail stage on failed
            <a href="http://spinnaker.github.io/guides/user/pipeline-expressions" target="_blank">expressions</a>
          </strong>
          <help-field key="pipeline.config.failOnFailedExpressions"></help-field>
        </label>
      </div>
    </div>
  </div>
</div>
`);
}]);

const CORE_PIPELINE_CONFIG_STAGES_OPTIONALSTAGE_OPTIONALSTAGE_DIRECTIVE = "spinnaker.core.pipeline.stage.optionalStage.directive";
module(CORE_PIPELINE_CONFIG_STAGES_OPTIONALSTAGE_OPTIONALSTAGE_DIRECTIVE, []).directive("optionalStage", function() {
  return {
    restrict: "E",
    scope: {
      stage: "="
    },
    templateUrl: "core/src/pipeline/config/stages/optionalStage/optionalStage.directive.html",
    controller: "OptionalStageCtrl",
    controllerAs: "optionalStageCtrl"
  };
}).controller("OptionalStageCtrl", [
  "$scope",
  function($scope) {
    this.isOptional = function() {
      return $scope.stage && $scope.stage.stageEnabled;
    };
    this.toggleOptional = function() {
      if (this.isOptional()) {
        delete $scope.stage.stageEnabled;
      } else {
        $scope.stage.stageEnabled = {
          type: "expression"
        };
      }
    };
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/optionalStage/optionalStage.directive.html", `<div>
  <div class="form-group">
    <div class="col-md-8 col-md-offset-1">
      <div class="checkbox pull-left">
        <label>
          <input
            type="checkbox"
            ng-false-value="undefined"
            ng-checked="optionalStageCtrl.isOptional()"
            ng-click="optionalStageCtrl.toggleOptional()"
          />
          <strong>
            Conditional on
            <a href="http://spinnaker.github.io/guides/user/pipeline-expressions" target="_blank">Expression</a>
          </strong>
          <help-field key="pipeline.config.optionalStage"></help-field>
        </label>
      </div>
      <div ng-if="optionalStageCtrl.isOptional()" class="col-md-12">
        <input type="text" class="form-control input-sm" ng-model="stage.stageEnabled.expression" />
      </div>
    </div>
  </div>
</div>
`);
}]);

var css_248z$D = ".override-failure-radio-input .inline.clickable {\n  width: 100%;\n}\n";
styleInject(css_248z$D);

const OverrideFailure = (props) => {
  const overrideFailureOptions = [
    {
      label: "halt the entire pipeline",
      value: "fail",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.haltPipelineOnFailure"
      })
    },
    {
      label: "halt this branch of the pipeline",
      value: "stop",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.haltBranchOnFailure"
      })
    },
    {
      label: "halt this branch and fail the pipeline once other branches complete",
      value: "faileventual",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.haltBranchOnFailureFailPipeline"
      })
    },
    {
      label: "ignore the failure",
      value: "ignore",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.ignoreFailure"
      })
    }
  ];
  const getFailureOption = () => {
    let initValue = "fail";
    if (props.completeOtherBranchesThenFail === true) {
      initValue = "faileventual";
    } else if (props.failPipeline === true && props.continuePipeline === false) {
      initValue = "fail";
    } else if (props.failPipeline === false && props.continuePipeline === false) {
      initValue = "stop";
    } else if (props.failPipeline === false && props.continuePipeline === true) {
      initValue = "ignore";
    }
    return initValue;
  };
  const failureOptionChanged = (value) => {
    if (value === "fail") {
      props.updateStageField({
        failPipeline: true,
        continuePipeline: false,
        completeOtherBranchesThenFail: false
      });
    } else if (value === "stop") {
      props.updateStageField({
        failPipeline: false,
        continuePipeline: false,
        completeOtherBranchesThenFail: false
      });
    } else if (value === "ignore") {
      props.updateStageField({
        failPipeline: false,
        continuePipeline: true,
        completeOtherBranchesThenFail: false
      });
    } else if (value === "faileventual") {
      props.updateStageField({
        failPipeline: false,
        continuePipeline: false,
        completeOtherBranchesThenFail: true
      });
    }
  };
  return /* @__PURE__ */ React__default.createElement(StageConfigField, {
    label: "If stage fails"
  }, /* @__PURE__ */ React__default.createElement(RadioButtonInput, {
    inputClassName: "override-failure-radio-input",
    options: overrideFailureOptions,
    value: getFailureOption(),
    onChange: (e) => failureOptionChanged(e.target.value)
  }));
};

const OVERRRIDE_FAILURE = "spinnaker.core.pipeline.stage.overrideFailure";
module(OVERRRIDE_FAILURE, []).component("overrideFailure", react2angular(withErrorBoundary(OverrideFailure, "overrideFailure"), [
  "failPipeline",
  "continuePipeline",
  "completeOtherBranchesThenFail",
  "updateStageField"
]));

const { useEffect: useEffect$1, useState: useState$2 } = React__default;
const toHoursAndMinutes = (ms) => {
  if (!ms) {
    return { hours: 0, minutes: 0 };
  } else {
    const { hours, minutes } = Duration.fromMillis(ms).shiftTo("hours", "minutes").toObject();
    return {
      hours: Math.floor(hours),
      minutes: Math.floor(minutes)
    };
  }
};
const OverrideTimeout = (props) => {
  const [hours, setHours] = useState$2(0);
  const [minutes, setMinutes] = useState$2(0);
  const [overrideTimeout, setOverrideTimeout] = useState$2(false);
  useEffect$1(() => {
    stageChanged();
  }, [props.stageTimeoutMs]);
  const stageChanged = () => {
    if (props.stageTimeoutMs !== void 0 && !isExpression) {
      enableTimeout();
    } else if (props.stageTimeoutMs !== void 0 && isExpression) {
      setOverrideTimeout(true);
      props.updateStageField({
        stageTimeoutMs: props.stageTimeoutMs || null
      });
    } else {
      clearTimeout();
    }
  };
  const synchronizeTimeout = (h, m) => {
    let timeout = 0;
    timeout += 60 * 60 * 1e3 * h;
    timeout += 60 * 1e3 * m;
    props.updateStageField({ stageTimeoutMs: timeout });
  };
  const toggleTimeout = () => {
    overrideTimeout ? clearTimeout() : enableTimeout();
  };
  const clearTimeout = () => {
    props.updateStageField({ stageTimeoutMs: void 0 });
    setOverrideTimeout(false);
  };
  const enableTimeout = () => {
    setOverrideTimeout(true);
    props.updateStageField({
      stageTimeoutMs: props.stageTimeoutMs || null
    });
    setHours(toHoursAndMinutes(props.stageTimeoutMs).hours);
    setMinutes(toHoursAndMinutes(props.stageTimeoutMs).minutes);
  };
  const isConfigurable = !!get(props.stageConfig, "supportsCustomTimeout");
  const isExpression = props.stageTimeoutMs !== void 0 && props.stageTimeoutMs !== null && !isNumber$1(props.stageTimeoutMs) ? props.stageTimeoutMs.includes("${") : false;
  if (isConfigurable) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      text: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("strong", null, "Fail stage after a specific amount of time"), " ", /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.timeout"
      })),
      value: overrideTimeout,
      onChange: toggleTimeout
    })))), overrideTimeout && !isExpression && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group form-inline"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9 col-md-offset-1 checkbox-padding"
    }, "Fail this stage if it takes longer than", /* @__PURE__ */ React__default.createElement(NumberInput$1, {
      inputClassName: "form-control input-sm inline-number with-space-before",
      min: 0,
      onChange: (e) => {
        setHours(e.target.value);
        synchronizeTimeout(e.target.value, minutes);
      },
      value: hours
    }), " ", "hours", /* @__PURE__ */ React__default.createElement(NumberInput$1, {
      inputClassName: "form-control input-sm inline-number with-space-before",
      min: 0,
      onChange: (e) => {
        setMinutes(e.target.value);
        synchronizeTimeout(hours, e.target.value);
      },
      value: minutes
    }), " ", "minutes to complete"))), overrideTimeout && isExpression && /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "sm-control-field"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Resolved at runtime from expression: ", /* @__PURE__ */ React__default.createElement("code", null, props.stageTimeoutMs))))));
  } else {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
};

const OVERRIDE_TIMEOUT_COMPONENT = "spinnaker.core.pipeline.stage.overrideTimeout";
module(OVERRIDE_TIMEOUT_COMPONENT, []).component("overrideTimeout", react2angular(withErrorBoundary(OverrideTimeout, "overrideTimeout"), [
  "stageConfig",
  "stageTimeoutMs",
  "updateStageField"
]));

const ProducesArtifacts = (props) => {
  const excludedArtifactTypePatterns = [ArtifactTypePatterns.FRONT50_PIPELINE_TEMPLATE];
  const { pipeline, stage, onProducesChanged } = props;
  const produces = stage.expectedArtifacts || [];
  const removeExpectedArtifact = (artifact) => {
    const producesAfterRemove = produces.slice(0);
    producesAfterRemove.splice(produces.findIndex((a) => artifact.id === a.id), 1);
    onProducesChanged(producesAfterRemove, stage);
  };
  const editExpectedArtifact = (artifact) => {
    ExpectedArtifactModal.show({
      expectedArtifact: artifact,
      pipeline,
      excludedArtifactTypePatterns,
      excludedDefaultArtifactTypePatterns: excludedArtifactTypePatterns
    }).then((editedArtifact) => {
      const editIndex = produces.findIndex((a) => a.id === editedArtifact.id);
      const producesAfterEdit = produces.slice(0);
      producesAfterEdit[editIndex] = editedArtifact;
      onProducesChanged(producesAfterEdit, stage);
    });
  };
  const defineNewExpectedArtifact = () => {
    ExpectedArtifactModal.show({
      pipeline,
      excludedArtifactTypePatterns,
      excludedDefaultArtifactTypePatterns: excludedArtifactTypePatterns
    }).then((artifact) => {
      const producesAfterNew = produces.slice(0);
      producesAfterNew.push(artifact);
      onProducesChanged(producesAfterNew, stage);
    });
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("table", {
    className: "table table-condensed"
  }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, "Display name"), /* @__PURE__ */ React__default.createElement("th", null, "Actions"))), /* @__PURE__ */ React__default.createElement("tbody", null, produces.map((artifact) => /* @__PURE__ */ React__default.createElement("tr", {
    key: artifact.id
  }, /* @__PURE__ */ React__default.createElement("td", null, artifact.displayName), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("a", {
    className: "glyphicon glyphicon-edit",
    onClick: () => editExpectedArtifact(artifact)
  }), /* @__PURE__ */ React__default.createElement("a", {
    className: "glyphicon glyphicon-trash",
    onClick: () => removeExpectedArtifact(artifact)
  })))))), /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-block btm-sm add-new",
    onClick: defineNewExpectedArtifact
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-plus-sign"
  }), " ", /* @__PURE__ */ React__default.createElement("span", {
    className: "visible-xl-inline"
  }, "Define artifact")));
};
const PRODUCES_ARTIFACTS_REACT = "spinnaker.core.pipeline.stages.produces.artifacts.react";
module(PRODUCES_ARTIFACTS_REACT, []).component("producesArtifactsReact", react2angular(withErrorBoundary(ProducesArtifacts, "producesArtifactsReact"), [
  "pipeline",
  "stage",
  "onProducesChanged"
]));

const CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE = "spinnaker.core.pipeline.config.stage";
module(CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE, [
  PRODUCES_ARTIFACTS_REACT,
  BASE_EXECUTION_DETAILS_CTRL,
  STAGE_NAME,
  OVERRIDE_TIMEOUT_COMPONENT,
  OVERRRIDE_FAILURE,
  CORE_PIPELINE_CONFIG_STAGES_OPTIONALSTAGE_OPTIONALSTAGE_DIRECTIVE,
  CORE_PIPELINE_CONFIG_STAGES_FAILONFAILEDEXPRESSIONS_FAILONFAILEDEXPRESSIONS_DIRECTIVE,
  CORE_PIPELINE_CONFIG_STAGES_COMMON_STAGECONFIGFIELD_STAGECONFIGFIELD_DIRECTIVE
]).directive("pipelineConfigStage", function() {
  return {
    restrict: "E",
    require: "^pipelineConfigurer",
    scope: {
      viewState: "=",
      application: "=",
      pipeline: "=",
      stageFieldUpdated: "<"
    },
    controller: "StageConfigCtrl as stageConfigCtrl",
    templateUrl: "core/src/pipeline/config/stages/stage.html",
    link: function(scope, elem, attrs, pipelineConfigurerCtrl) {
      scope.pipelineConfigurerCtrl = pipelineConfigurerCtrl;
    }
  };
}).controller("StageConfigCtrl", [
  "$scope",
  "$element",
  "$compile",
  "$controller",
  "$templateCache",
  function($scope, $element, $compile, $controller, $templateCache) {
    let lastStageScope, reactComponentMounted;
    let appPermissions = {};
    let appRoles = [];
    $scope.options = {
      stageTypes: [],
      selectedStageType: null,
      stageRoles: []
    };
    AccountService.applicationAccounts($scope.application).then((accounts) => {
      $scope.options.stageTypes = Registry.pipeline.getConfigurableStageTypes(accounts);
      $scope.showProviders = new Set(accounts.map((a) => a.cloudProvider)).size > 1;
    });
    if ($scope.pipeline.strategy) {
      $scope.options.stageTypes = $scope.options.stageTypes.filter((stageType) => {
        return stageType.strategy || false;
      });
    }
    function getConfig(stage) {
      return Registry.pipeline.getStageConfig(stage);
    }
    $scope.groupDependencyOptions = function(stage) {
      const requisiteStageRefIds = $scope.stage.requisiteStageRefIds || [];
      return stage.available ? "Available" : requisiteStageRefIds.includes(stage.refId) ? null : "Downstream dependencies (unavailable)";
    };
    $scope.stageProducesArtifacts = function() {
      if (!$scope.stage) {
        return false;
      }
      const stageConfig = Registry.pipeline.getStageConfig($scope.stage);
      if (!stageConfig) {
        return false;
      } else {
        return !!stageConfig.producesArtifacts;
      }
    };
    $scope.producesArtifactsChanged = function(artifacts) {
      $scope.$applyAsync(() => {
        $scope.stage.expectedArtifacts = artifacts;
      });
    };
    const memoizedGetDependencyCandidateStages = memoizeOne(PipelineConfigService.getDependencyCandidateStages, isEqual);
    $scope.updateAvailableDependencyStages = function() {
      const availableDependencyStages = memoizedGetDependencyCandidateStages($scope.pipeline, $scope.stage);
      $scope.options.dependencies = availableDependencyStages.map(function(stage) {
        return {
          name: stage.name,
          refId: stage.refId,
          available: true
        };
      });
      $scope.pipeline.stages.forEach(function(stage) {
        if (stage !== $scope.stage && !availableDependencyStages.includes(stage)) {
          $scope.options.dependencies.push({
            name: stage.name,
            refId: stage.refId
          });
        }
      });
    };
    $scope.getApplicationPermissions = function() {
      ApplicationReader.getApplicationPermissions($scope.application.name).then((result) => {
        appPermissions = result;
        if (appPermissions) {
          const readArray = appPermissions.READ || [];
          const writeArray = appPermissions.WRITE || [];
          const executeArray = appPermissions.EXECUTE || [];
          appRoles = union(readArray, writeArray, executeArray);
          appRoles = Array.from(new Set(appRoles));
          $scope.updateAvailableStageRoles();
        }
      });
    };
    $scope.updateAvailableStageRoles = function() {
      $scope.options.stageRoles = appRoles.map(function(value, index) {
        return {
          name: value,
          roleId: value,
          id: index,
          available: true
        };
      });
    };
    this.editStageJson = () => {
      const modalProps = { dialogClassName: "modal-lg modal-fullscreen" };
      ReactModal.show(EditStageJsonModal, { stage: $scope.stage }, modalProps).then(() => {
        $scope.$applyAsync(() => $scope.$broadcast("pipeline-json-edited"));
      }).catch(() => {
      });
    };
    this.selectStageType = (stage) => {
      $scope.stage.type = stage.key;
      this.selectStage();
      Object.keys($scope.stage).forEach((k) => {
        if (!["requisiteStageRefIds", "refId", "isNew", "name", "type"].includes(k)) {
          delete $scope.stage[k];
        }
      });
    };
    this.updateStageField = (changes) => {
      extend($scope.stage, changes);
      $scope.stageFieldUpdated();
    };
    this.selectStage = function(newVal, oldVal) {
      const stageDetailsNode = $element.find(".stage-details").get(0);
      if ($scope.viewState.stageIndex >= $scope.pipeline.stages.length) {
        $scope.viewState.stageIndex = $scope.pipeline.stages.length - 1;
      }
      $scope.stage = $scope.pipeline.stages[$scope.viewState.stageIndex];
      if (!$scope.stage) {
        return;
      }
      if (!$scope.stage.type) {
        $scope.options.selectedStageType = null;
      } else {
        $scope.options.selectedStageType = $scope.stage.type;
      }
      $scope.updateAvailableDependencyStages();
      const type = $scope.stage.type;
      const stageScope = $scope.$new();
      if (reactComponentMounted) {
        ReactDOM__default.unmountComponentAtNode(stageDetailsNode);
        reactComponentMounted = false;
      } else {
        $element.find(".stage-details").html("");
      }
      $scope.description = "";
      if (lastStageScope) {
        lastStageScope.$destroy();
      }
      $scope.extendedDescription = "";
      lastStageScope = stageScope;
      $scope.$on("$destroy", function() {
        stageScope.$destroy();
      });
      if (type && stageDetailsNode) {
        const config = getConfig($scope.stage);
        if (config) {
          $scope.canConfigureNotifications = !$scope.pipeline.strategy && !config.disableNotifications;
          $scope.description = config.description;
          $scope.extendedDescription = config.extendedDescription;
          $scope.label = config.label;
          if (config.addAliasToConfig) {
            $scope.stage.alias = config.alias;
          }
          if (config.defaults) {
            defaultsDeep($scope.stage, config.defaults);
          }
          if (config.useBaseProvider || config.provides) {
            config.component = null;
            config.templateUrl = "core/src/pipeline/config/stages/baseProviderStage/baseProviderStage.html";
            config.controller = "BaseProviderStageCtrl as baseProviderStageCtrl";
          }
          updateStageName(config, oldVal);
          applyConfigController(config, stageScope);
          const props = {
            application: $scope.application,
            stageFieldUpdated: $scope.stageFieldUpdated,
            updateStageField: (changes) => {
              const allowedChanges = omit(changes, ["requisiteStageRefIds", "refId", "isNew", "name", "type"]);
              extend($scope.stage, allowedChanges);
              $scope.stageFieldUpdated();
            },
            pipeline: $scope.pipeline,
            stage: $scope.stage,
            component: config.component,
            configuration: config.configuration
          };
          if (config.useBaseProvider || config.provides) {
            stageScope.reactPropsForBaseProviderStage = props;
          }
          if (config.component) {
            ReactDOM__default.render(React__default.createElement(StageConfigWrapper, props), stageDetailsNode);
          } else {
            const template = $templateCache.get(config.templateUrl);
            const templateBody = $compile(template)(stageScope);
            $element.find(".stage-details").html(templateBody);
          }
          reactComponentMounted = !!config.component;
        }
      } else {
        $scope.label = null;
        $scope.description = null;
        $scope.extendedDescription = null;
      }
      updateStageConfig($scope.stage);
    };
    function applyConfigController(config, stageScope) {
      if (config.controller) {
        const ctrl = config.controller.split(" as ");
        const controller = $controller(ctrl[0], {
          $scope: stageScope,
          stage: $scope.stage,
          viewState: $scope.viewState
        });
        if (ctrl.length === 2) {
          stageScope[ctrl[1]] = controller;
        }
        if (config.controllerAs) {
          stageScope[config.controllerAs] = controller;
        }
      }
    }
    function updateStageName(config, oldVal) {
      if (oldVal) {
        const oldConfig = getConfig({ type: oldVal });
        if (oldConfig && $scope.stage.name === oldConfig.label) {
          $scope.stage.name = config.label;
        }
      }
      if (!$scope.stage.name && config.label) {
        $scope.stage.name = config.label;
      }
    }
    function updateStageConfig(stage) {
      $scope.$applyAsync(() => {
        $scope.stageConfig = getConfig(stage);
      });
    }
    this.updateNotifications = function(notifications) {
      $scope.$applyAsync(() => {
        $scope.stage.notifications = notifications;
      });
    };
    this.handleSendNotificationsChanged = function() {
      $scope.$applyAsync(() => {
        $scope.stage.sendNotifications = !$scope.stage.sendNotifications;
      });
    };
    $scope.getApplicationPermissions();
    $scope.$on("pipeline-reverted", this.selectStage);
    $scope.$on("pipeline-json-edited", this.selectStage);
    $scope.$watch("stage.type", this.selectStage);
    $scope.$watch("viewState.stageIndex", this.selectStage);
    $scope.$watch("stage.refId", this.selectStage);
  }
]).controller("RestartStageCtrl", [
  "$scope",
  "$stateParams",
  function($scope, $stateParams) {
    const restartStage = function() {
      return REST("/pipelines").path($stateParams.executionId, "stages", $scope.stage.id, "restart").put({ skip: false }).then(function() {
        $scope.stage.isRestarting = true;
      });
    };
    this.restart = function() {
      let body = null;
      if ($scope.execution.isRunning) {
        body = "<p><strong>This pipeline is currently running - restarting this stage will result in multiple concurrently running pipelines.</strong></p>";
      }
      const configId = $scope.execution.pipelineConfigId;
      const executions = $scope.application.executions.data;
      const concurrentExecutions = executions.filter((e) => e.pipelineConfigId === configId && e.status === "RUNNING");
      if (concurrentExecutions.length && $scope.execution.limitConcurrent) {
        body = '<p class="alert alert-warning"><i class="fa fa-exclamation-triangle sp-margin-xs-right"></i>This stage <strong>will not</strong> restart until the running execution completes since concurrency is disabled for this pipeline';
      }
      ConfirmationModalService.confirm({
        header: "Really restart " + $scope.stage.name + "?",
        buttonText: "Restart " + $scope.stage.name,
        body,
        submitMethod: restartStage
      });
    };
  }
]).filter("stageTypeMatch", () => {
  return (stageTypes, search) => {
    const q = search.toLowerCase();
    return stageTypes.filter((s) => s.label.toLowerCase().includes(q) || s.description.toLowerCase().includes(q)).sort((a, b) => {
      const aLabel = a.label.toLowerCase();
      const bLabel = b.label.toLowerCase();
      const aDescription = a.description.toLowerCase();
      const bDescription = b.description.toLowerCase();
      if (aLabel.includes(q) && !bLabel.includes(q)) {
        return -1;
      }
      if (!aLabel.includes(q) && bLabel.includes(q)) {
        return 1;
      }
      if (aLabel.includes(q) && bLabel.includes(q)) {
        return aLabel.indexOf(q) - bLabel.indexOf(q);
      }
      return aDescription.indexOf(q) - bDescription.indexOf(q);
    });
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/stage.html", `<div class="form-horizontal">
  <div class="row pipeline-stage-config-heading">
    <div class="col-md-3">
      <h4 ng-bind="stage.name || '[new stage]'"></h4>
      <p class="small" ng-if="stage.type && label">
        <strong>Stage type:</strong> {{label}}<br />
        <markdown message="description"></markdown>
      </p>
      <p class="small" ng-if="extendedDescription" ng-bind-html="extendedDescription"></p>
      <p class="small" ng-if="!stage.type">No stage type selected</p>
    </div>
    <div class="col-md-7 form-horizontal">
      <stage-config-field label="Type" field-columns="9" ng-if="stage.isNew || !stage.type">
        <ui-select
          ng-model="options.selectedStageType"
          style="width: 250px"
          class="form-control input-sm"
          autofocus
          on-select="stageConfigCtrl.selectStageType($item)"
        >
          <ui-select-match>
            <strong>{{$select.selected.label}}</strong>
          </ui-select-match>
          <ui-select-choices repeat="option.key as option in options.stageTypes | stageTypeMatch: $select.search">
            <div class="stage-choice">
              <div class="stage-choice-heading">
                <strong ng-bind-html="option.label | highlight: $select.search"></strong>
                <span class="available-providers" ng-if="showProviders">
                  <cloud-provider-logo
                    ng-repeat="provider in option.cloudProviders"
                    provider="provider"
                    height="'12px'"
                    width="'12px'"
                    show-tooltip="true"
                  ></cloud-provider-logo>
                </span>
              </div>
              <div ng-bind-html="option.description | highlight: $select.search"></div>
            </div>
          </ui-select-choices>
        </ui-select>
      </stage-config-field>
      <stage-config-field label="Stage Name">
        <input type="text" class="form-control input-sm" required ng-model="stage.name" />
      </stage-config-field>
      <stage-config-field label="Depends On" help-key="pipeline.config.dependsOn" style="margin-bottom: 10px">
        <ui-select
          ng-model="stage.requisiteStageRefIds"
          multiple
          class="form-control input-sm"
          on-select="updateAvailableDependencyStages()"
          on-remove="updateAvailableDependencyStages()"
        >
          <ui-select-match>{{$item.name}}</ui-select-match>
          <ui-select-choices
            repeat="option.refId as option in options.dependencies | anyFieldFilter: {name: $select.search}"
            ui-disable-choice="!option.available"
            group-by="groupDependencyOptions"
          >
            <span
              ng-if="!stage.requisiteStageRefIds.includes(option.refId)"
              ng-bind-html="option.name | highlight: $select.search"
            ></span>
          </ui-select-choices>
        </ui-select>
      </stage-config-field>
      <render-if-feature feature="fiatEnabled">
        <stage-config-field
          label="Authorized Groups"
          help-key="pipeline.config.trigger.authorizedUser"
          ng-if="stage.type === 'manualJudgment'"
          style="margin-bottom: 10px"
        >
          <ui-select
            ng-model="stage.selectedStageRoles"
            multiple
            class="form-control input-sm"
            on-select="updateAvailableStageRoles()"
            on-remove="updateAvailableStageRoles()"
          >
            <ui-select-match>{{$item.name}}</ui-select-match>
            <ui-select-choices
              repeat="option.roleId as option in options.stageRoles | anyFieldFilter: {name: $select.search}"
              ui-disable-choice="!option.available"
            >
              <span
                ng-if="!stage.selectedStageRoles.includes(option.roleId)"
                ng-bind-html="option.name | highlight: $select.search"
              ></span>
            </ui-select-choices>
          </ui-select>
        </stage-config-field>
      </render-if-feature>
    </div>
    <div class="col-md-2 text-right">
      <button
        type="button"
        class="btn btn-sm btn-default"
        ng-click="pipelineConfigurerCtrl.removeStage(stage)"
        style="margin-bottom: 5px"
      >
        <span class="glyphicon glyphicon-trash" uib-tooltip="Remove stage"></span> Remove stage
      </button>
      <button type="button" class="btn btn-sm btn-default" ng-click="stageConfigCtrl.editStageJson(stage)">
        <i class="fa fa-cog"></i> Edit stage as JSON
      </button>
    </div>
  </div>
  <page-navigator scrollable-container="[ui-view]" ng-show="stage.type" hide-navigation="true">
    <page-section key="stage" label="{{label}} Configuration">
      <div class="stage-details"></div>
    </page-section>
    <page-section key="execution" label="Execution Options">
      <override-failure
        fail-pipeline="stage.failPipeline"
        continue-pipeline="stage.continuePipeline"
        complete-other-branches-then-fail="stage.completeOtherBranchesThenFail"
        update-stage-field="stageConfigCtrl.updateStageField"
      ></override-failure>
      <execution-windows
        ng-if="!pipeline.strategy && stage"
        restrict-execution-during-time-window="stage.restrictExecutionDuringTimeWindow"
        restricted-execution-window="stage.restrictedExecutionWindow"
        skip-window-text="stage.skipWindowText"
        update-stage-field="stageConfigCtrl.updateStageField"
      ></execution-windows>
      <override-timeout
        stage-config="stageConfig"
        stage-timeout-ms="stage.stageTimeoutMs"
        update-stage-field="stageConfigCtrl.updateStageField"
      ></override-timeout>
      <fail-on-failed-expressions stage="stage"></fail-on-failed-expressions>
      <optional-stage stage="stage"></optional-stage>
    </page-section>
    <page-section
      key="notification"
      label="Notifications"
      visible="canConfigureNotifications"
      badge="stage.notifications.length"
    >
      <notification-list
        level="'stage'"
        handle-send-notifications-changed="stageConfigCtrl.handleSendNotificationsChanged"
        notifications="stage.notifications"
        send-notifications="!!stage.sendNotifications"
        type="stage.type"
        update-notifications="stageConfigCtrl.updateNotifications"
      >
      </notification-list>
    </page-section>
    <page-section key="producesArtifacts" label="Produces Artifacts" visible="stageProducesArtifacts()">
      <produces-artifacts-react stage="stage" pipeline="pipeline" on-produces-changed="producesArtifactsChanged" />
    </page-section>
    <page-section key="comments" label="Comments" no-wrapper="true">
      <textarea
        class="form-control"
        ng-model="stage.comments"
        rows="3"
        placeholder="(Optional) anything that might be helpful to explain the purpose of this stage; HTML is okay"
      ></textarea>
    </page-section>
  </page-navigator>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/baseProviderStage/baseProviderStage.html", `<div class="form-horizontal" ng-if="!viewState.loading">
  <stage-config-field label="Provider" ng-if="providers.length > 1">
    <provider-selector
      providers="providers"
      component="stage"
      field="cloudProviderType"
      read-only="!stage.isNew"
    ></provider-selector>
  </stage-config-field>
  <div ng-include="providerStageDetailsUrl"></div>
  <div class="react-stage-details"></div>
</div>
`);
}]);

class ArtifactoryReaderService {
  static getArtifactoryNames() {
    return REST("/artifactory/names").get();
  }
}

function ArtifactoryTrigger() {
  const fetchNames = useLatestPromise(() => ArtifactoryReaderService.getArtifactoryNames(), []);
  const fetchError = () => errorMessage(`Error fetching artifactory names: ${fetchNames.error.data.status} ${fetchNames.error.data.error}`);
  const validationMessage = fetchNames.status === "REJECTED" ? fetchError() : null;
  return /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "artifactorySearchName",
    label: "Artifactory Name",
    touched: true,
    validationMessage,
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      isLoading: status === "PENDING",
      placeholder: "Select Artifactory search name...",
      stringOptions: fetchNames.result,
      clearable: false
    })
  });
}

Registry.pipeline.registerTrigger({
  label: "Artifactory",
  description: "Executes the pipeline on an Artifactory repo update",
  key: "artifactory",
  component: ArtifactoryTrigger,
  validators: [],
  excludedArtifactTypePatterns: excludeAllTypesExcept(ArtifactTypePatterns.MAVEN_FILE)
});

function CDEventsTrigger(cdeventsTriggerProps) {
  const { formik } = cdeventsTriggerProps;
  const trigger = formik.values;
  const { source, type } = trigger;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "source",
    label: "Source",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.trigger.webhook.source"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-v"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    }), /* @__PURE__ */ React__default.createElement("i", null, `${SETTINGS.gateUrl}/webhooks/${type}/${source || "<source>"}`))
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "payloadConstraints",
    label: "Payload Constraints",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.trigger.webhook.payloadConstraints"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
      ...props,
      addButtonLabel: "Add payload constraint"
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "attributeConstraints",
    label: "Attribute Constraints ",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.trigger.cdevents.attributeConstraints"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
      ...props,
      addButtonLabel: "Add attribute constraint"
    })
  }));
}

Registry.pipeline.registerTrigger({
  component: CDEventsTrigger,
  description: "Executes the pipeline when a CDEvents webhook is received.",
  excludedArtifactTypePatterns: [ArtifactTypePatterns.JENKINS_FILE],
  key: "cdevents",
  label: "CDEvents",
  validators: [
    {
      type: "serviceAccountAccess",
      message: `You do not have access to the service account configured in this pipeline's CDEvents trigger.
                You will not be able to save your edits to this pipeline.`,
      preventSave: true
    }
  ]
});

class ConcourseService {
  static listTeamsForMaster(master) {
    return REST("/concourse").path(master, "teams").get();
  }
  static listPipelinesForTeam(master, team) {
    return REST("/concourse").path(master, "teams", team, "pipelines").get();
  }
  static listJobsForPipeline(master, team, pipeline) {
    return REST("/concourse").path(master, "teams", team, "pipelines", pipeline, "jobs").get();
  }
  static listResourcesForPipeline(master, team, pipeline) {
    return REST("/concourse").path(master, "teams", team, "pipelines", pipeline, "resources").get();
  }
}

function ConcourseTrigger({ formik, trigger }) {
  const { team, project, master } = trigger;
  const pipeline = project && project.split("/").pop();
  const onTeamChanged = () => {
    formik.setFieldValue("job", "");
    formik.setFieldValue("jobName", "");
    formik.setFieldValue("project", "");
  };
  const onProjectChanged = () => {
    formik.setFieldValue("job", "");
    formik.setFieldValue("jobName", "");
  };
  const onJobChanged = (job) => {
    const jobName = job && job.split("/").pop();
    formik.setFieldValue("jobName", jobName);
  };
  const fetchMasters = useData(() => IgorService.listMasters(BuildServiceType.Concourse), [], []);
  const fetchTeams = useData(() => ConcourseService.listTeamsForMaster(master), [], [master]);
  const fetchPipelines = useData(() => ConcourseService.listPipelinesForTeam(master, team), [], [master, team]);
  const fetchJobs = useData(() => ConcourseService.listJobsForPipeline(master, team, pipeline).then((jobs) => jobs.map((job) => `${team}/${pipeline}/${job}`)), [], [master, team, pipeline]);
  const lastSegmentOptionRenderer = (option) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, option.value.split("/").pop());
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "master",
    label: "Build Service",
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      clearable: false,
      disabled: fetchMasters.status === "PENDING",
      isLoading: fetchMasters.status === "PENDING",
      stringOptions: fetchMasters.result,
      placeholder: "Select a build service..."
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "team",
    label: "Team",
    onChange: onTeamChanged,
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      clearable: false,
      disabled: !master || fetchTeams.status === "PENDING",
      isLoading: fetchTeams.status === "PENDING",
      stringOptions: fetchTeams.result,
      placeholder: "Select a team..."
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "project",
    label: "Pipeline",
    onChange: onProjectChanged,
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      clearable: false,
      disabled: !team || fetchPipelines.status === "PENDING",
      isLoading: fetchPipelines.status === "PENDING",
      stringOptions: fetchPipelines.result,
      optionRenderer: lastSegmentOptionRenderer,
      valueRenderer: lastSegmentOptionRenderer,
      placeholder: "Select a pipeline..."
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "job",
    label: "Job",
    onChange: onJobChanged,
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      clearable: false,
      disabled: !pipeline || fetchJobs.status === "PENDING",
      isLoading: fetchJobs.status === "PENDING",
      stringOptions: fetchJobs.result,
      optionRenderer: lastSegmentOptionRenderer,
      valueRenderer: lastSegmentOptionRenderer,
      placeholder: "Select a job..."
    })
  }));
}

class ConcourseTriggerTemplate extends React__default.Component {
  constructor() {
    super(...arguments);
    this.optionRenderer = (build) => {
      return /* @__PURE__ */ React__default.createElement("span", {
        style: { fontSize: "13px" }
      }, /* @__PURE__ */ React__default.createElement("strong", null, "Build ", build.number, " "), build.name, " (", timestamp(build.timestamp), ")");
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(BaseBuildTriggerTemplate, {
      ...this.props,
      buildTriggerType: BuildServiceType.Concourse,
      optionRenderer: this.optionRenderer
    });
  }
}
ConcourseTriggerTemplate.formatLabel = BaseBuildTriggerTemplate.formatLabel;

Registry.pipeline.registerTrigger({
  label: "Concourse",
  description: "Listens to a Concourse job",
  key: "concourse",
  component: ConcourseTrigger,
  manualExecutionComponent: ConcourseTriggerTemplate,
  excludedArtifactTypePatterns: [ArtifactTypePatterns.JENKINS_FILE],
  validators: [
    {
      type: "requiredField",
      fieldName: "team",
      message: "<strong>Team</strong> is a required field on Concourse triggers."
    },
    {
      type: "requiredField",
      fieldName: "project",
      message: "<strong>Pipeline</strong> is a required field on Concourse triggers."
    },
    {
      type: "requiredField",
      fieldName: "jobName",
      message: "<strong>Job</strong> is a required field on Concourse triggers."
    },
    {
      type: "serviceAccountAccess",
      message: `You do not have access to the service account configured in this pipeline's Jenkins trigger.
                    You will not be able to save your edits to this pipeline.`,
      preventSave: true
    }
  ]
});

class CronValidatorService {
  static validate(expression) {
    const segments = expression ? expression.split(" ") : [];
    if (segments.length === 7 && segments[6] === "*") {
      segments.pop();
      expression = segments.join(" ");
    }
    return REST("/cron/validate").query({ expression }).get();
  }
}

class CronAdvance extends React__default.Component {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.validateCronExpression = (cronExpression) => {
      from(CronValidatorService.validate(cronExpression)).pipe(takeUntil(this.destroy$)).subscribe((result) => {
        if (result.valid) {
          this.setState({
            description: result.description ? result.description.charAt(0).toUpperCase() + result.description.slice(1) : "",
            errorMessage: ""
          });
        } else {
          this.setState({
            description: "",
            errorMessage: result && result.message ? result.message : "Error validating CRON expression"
          });
        }
      }, (result) => {
        this.setState({
          description: "",
          errorMessage: result && result.message ? result.message : "Error validating CRON expression"
        });
      });
    };
    this.onUpdateTrigger = (event) => {
      const cronExpression = event.target.value.replace(/\s\s+/g, " ");
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression
      });
      this.validateCronExpression(cronExpression);
    };
    this.state = {
      description: "",
      errorMessage: ""
    };
  }
  componentDidMount() {
    this.validateCronExpression(this.props.trigger.cronExpression);
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { cronExpression } = this.props.trigger;
    const { description, errorMessage } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Expression"), /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.cron.expression"
    }), " ", /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: "form-control input-sm",
      onChange: this.onUpdateTrigger,
      required: true,
      value: cronExpression
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("p", null, "More details about how to create these expressions can be found", " ", /* @__PURE__ */ React__default.createElement("a", {
      href: "http://www.quartz-scheduler.org/documentation/2.3.1-SNAPSHOT/tutorials/tutorial-lesson-06.html",
      target: "_blank"
    }, "here"), " ", "and", " ", /* @__PURE__ */ React__default.createElement("a", {
      href: "https://www.freeformatter.com/cron-expression-generator-quartz.html",
      target: "_blank"
    }, "here"), "."))), description && !errorMessage && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, description)))), errorMessage && /* @__PURE__ */ React__default.createElement("div", {
      className: "row slide-in"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12 error-message"
    }, /* @__PURE__ */ React__default.createElement("p", null, "This trigger will NEVER fire."), errorMessage)));
  }
}

const HOURS = [...new Array(24).keys()].map((i) => {
  return {
    label: i < 10 ? `0${i}` : `${i}`,
    value: `${i}`
  };
});
const MINUTES = [...new Array(60).keys()].map((i) => {
  return {
    label: i < 10 ? `0${i}` : `${i}`,
    value: `${i}`
  };
});
const WEEKDAYS = [
  { label: "Sunday", value: "SUN" },
  { label: "Monday", value: "MON" },
  { label: "Tuesday", value: "TUE" },
  { label: "Wednesday", value: "WED" },
  { label: "Thursday", value: "THU" },
  { label: "Friday", value: "FRI" },
  { label: "Saturday", value: "SAT" }
];
const MONTHS_DAYS_WITH_LASTS = ["1W", ...[...new Array(31).keys()].map((x) => `${x + 1}`), "LW", "L"].map((i) => {
  if (i === "L") {
    return { label: "Last Day", value: i };
  } else if (i === "LW") {
    return { label: "Last Weekday", value: i };
  } else if (i === "1W") {
    return { label: "First Weekday", value: i };
  } else {
    if (i.length > 1) {
      const secondToLastDigit = i.charAt(i.length - 2);
      if (secondToLastDigit === "1") {
        return { label: `${i}th Day`, value: i };
      }
    }
    const lastDigit = i.charAt(i.length - 1);
    switch (lastDigit) {
      case "1":
        return { label: `${i}st Day`, value: i };
      case "2":
        return { label: `${i}nd Day`, value: i };
      case "3":
        return { label: `${i}rd Day`, value: i };
      default:
        return { label: `${i}th Day`, value: i };
    }
  }
});
const MONTH_WEEKS = [
  { label: "First", value: "#1" },
  { label: "Second", value: "#2" },
  { label: "Third", value: "#3" },
  { label: "Fourth", value: "#4" },
  { label: "Fifth", value: "#5" },
  { label: "Last", value: "L" }
];

class CronDaily extends React__default.Component {
  constructor(props) {
    super(props);
    this.onUpdateSubTabTrigger = (event) => {
      const subTab = event.target.value;
      this.setState({ subTab });
      if (subTab === "everyDays") {
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 0 0 1/" + this.state.everyDaysDays + " * ? *"
        });
      } else if (subTab === "everyWeekDay") {
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + this.state.minute + " " + this.state.hour + " ? * MON-FRI *"
        });
      }
    };
    this.onUpdateEveryDaysDaysTrigger = (event) => {
      const everyDaysDays = event.target.value;
      this.setState({ everyDaysDays });
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 0 0 1/" + everyDaysDays + " * ? *"
      });
    };
    this.onUpdateHourTrigger = (option) => {
      const hour = option.value;
      const { everyDaysDays, minute, subTab } = this.state;
      this.setState({ hour });
      if (subTab === "everyDays") {
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " 1/" + everyDaysDays + " * ? *"
        });
      } else if (subTab === "everyWeekDay") {
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " ? * MON-FRI *"
        });
      }
    };
    this.onUpdateMinuteTrigger = (option) => {
      const minute = option.value;
      const { everyDaysDays, hour, subTab } = this.state;
      this.setState({ minute });
      if (subTab === "everyDays") {
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " 1/" + everyDaysDays + " * ? *"
        });
      } else if (subTab === "everyWeekDay") {
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " ? * MON-FRI *"
        });
      }
    };
    this.state = {
      subTab: "everyDays",
      everyDaysDays: "1",
      hour: "0",
      minute: "0"
    };
  }
  componentDidMount() {
    const everyDaysRegex = /0 (\d+) (\d+) 1\/(\d+) \* \? \*/g;
    const everyWeekDayRegex = /0 (\d+) (\d+) \? \* MON-FRI \*/g;
    const everyDaysMatches = everyDaysRegex.exec(this.props.trigger.cronExpression);
    const everyWeekDayMatches = everyWeekDayRegex.exec(this.props.trigger.cronExpression);
    if (everyDaysMatches) {
      this.setState({
        subTab: "everyDays",
        minute: everyDaysMatches[1],
        hour: everyDaysMatches[2],
        everyDaysDays: everyDaysMatches[3]
      });
    } else if (everyWeekDayMatches) {
      this.setState({
        subTab: "everyWeekDay",
        minute: everyWeekDayMatches[1],
        hour: everyWeekDayMatches[2]
      });
    } else {
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 0 0 1/" + this.state.everyDaysDays + " * ? *"
      });
    }
  }
  render() {
    const { everyDaysDays, hour, minute, subTab } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      value: "everyDays",
      onChange: this.onUpdateSubTabTrigger,
      checked: subTab === "everyDays"
    }), /* @__PURE__ */ React__default.createElement("span", null, "Every "), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "number",
      min: "1",
      max: "31",
      disabled: subTab !== "everyDays",
      onChange: this.onUpdateEveryDaysDaysTrigger,
      required: subTab === "everyDays",
      value: everyDaysDays
    }), /* @__PURE__ */ React__default.createElement("span", null, " day(s)"))), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      value: "everyWeekDay",
      onChange: this.onUpdateSubTabTrigger,
      checked: subTab === "everyWeekDay"
    }), "Every week day")), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Start time "), /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select",
      clearable: false,
      value: hour,
      options: HOURS,
      onChange: this.onUpdateHourTrigger
    }), " ", /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select",
      clearable: false,
      value: minute,
      options: MINUTES,
      onChange: this.onUpdateMinuteTrigger
    }), " ", /* @__PURE__ */ React__default.createElement(SystemTimezone, null))));
  }
}

class CronHourly extends React__default.Component {
  constructor(props) {
    super(props);
    this.onUpdateHourlyTrigger = (hours) => {
      this.setState({ hours });
      const { minutes } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minutes + " 0/" + hours + " 1/1 * ? *"
      });
    };
    this.onUpdateMinuteTrigger = (minutes) => {
      this.setState({ minutes });
      const { hours } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minutes + " 0/" + hours + " 1/1 * ? *"
      });
    };
    this.state = {
      hours: "1",
      minutes: "1"
    };
  }
  componentDidMount() {
    const regex = /0 (\d+) 0\/(\d+) 1\/1 \* \? \*/g;
    const matches = regex.exec(this.props.trigger.cronExpression);
    if (matches) {
      this.setState({
        minutes: matches[1],
        hours: matches[2]
      });
    } else {
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + this.state.minutes + " 0/" + this.state.hours + " 1/1 * ? *"
      });
    }
  }
  render() {
    const { hours, minutes } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Every "), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "number",
      min: "1",
      max: "23",
      onChange: (event) => this.onUpdateHourlyTrigger(event.target.value),
      required: true,
      value: hours
    }), /* @__PURE__ */ React__default.createElement("span", null, " hour(s) on minute "), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      type: "number",
      min: "0",
      max: "59",
      required: true,
      onChange: (event) => this.onUpdateMinuteTrigger(event.target.value),
      value: minutes
    }))));
  }
}

class CronMinutes extends React__default.Component {
  constructor(props) {
    super(props);
    this.minuteOptions = ["1", "2", "3", "4", "5", "6", "10", "12", "15", "20", "30"];
    this.onUpdateTrigger = (option) => {
      const minutes = option.value;
      this.setState({ minutes });
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 0/" + minutes + " * 1/1 * ? *"
      });
    };
    this.state = { minutes: "1" };
  }
  componentDidMount() {
    const regex = /0 0\/(\d+) \* 1\/1 \* \? \*/g;
    const matches = regex.exec(this.props.trigger.cronExpression);
    if (matches) {
      this.setState({ minutes: matches[1] });
    } else {
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 0/" + this.state.minutes + " * 1/1 * ? *"
      });
    }
  }
  render() {
    const { minutes } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Every "), /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select",
      value: minutes,
      options: this.minuteOptions.map((j) => ({ label: j, value: j })),
      onChange: this.onUpdateTrigger,
      clearable: false
    }), /* @__PURE__ */ React__default.createElement("span", null, " minute(s)"))));
  }
}

class CronMonthly extends React__default.Component {
  constructor(props) {
    super(props);
    this.onUpdateSubTabTrigger = (event) => {
      const subTab = event.target.value;
      this.setState({ subTab });
      const { hour, minute } = this.state;
      if (subTab === "specificDay") {
        const { specificDay } = this.state;
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " " + specificDay.day + " 1/" + specificDay.month + " ? *"
        });
      } else if (subTab === "specificWeekDay") {
        const { specificWeekDay } = this.state;
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " ? 1/" + specificWeekDay.month + " " + specificWeekDay.day + specificWeekDay.monthWeek + " *"
        });
      }
    };
    this.onUpdateSpecificDayDayTrigger = (option) => {
      const day = option.value;
      this.setState({
        specificDay: {
          ...this.state.specificDay,
          day
        }
      });
      const { hour, minute, specificDay } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " " + day + " 1/" + specificDay.month + " ? *"
      });
    };
    this.onUpdateSpecificDayMonthTrigger = (event) => {
      const month = event.target.value;
      this.setState({
        specificDay: {
          ...this.state.specificDay,
          month
        }
      });
      const { hour, minute, specificDay } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " " + specificDay.day + " 1/" + month + " ? *"
      });
    };
    this.onUpdateSpecificWeekDayMonthWeekTrigger = (option) => {
      const monthWeek = option.value;
      this.setState({
        specificWeekDay: {
          ...this.state.specificWeekDay,
          monthWeek
        }
      });
      const { hour, minute, specificWeekDay } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " ? 1/" + specificWeekDay.month + " " + specificWeekDay.day + monthWeek + " *"
      });
    };
    this.onUpdateSpecificWeekDayDayTrigger = (option) => {
      const day = option.value;
      this.setState({
        specificWeekDay: {
          ...this.state.specificWeekDay,
          day
        }
      });
      const { hour, minute, specificWeekDay } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " ? 1/" + specificWeekDay.month + " " + day + specificWeekDay.monthWeek + " *"
      });
    };
    this.onUpdateSpecificWeekDayMonthTrigger = (event) => {
      const month = event.target.value;
      this.setState({
        specificWeekDay: {
          ...this.state.specificWeekDay,
          month
        }
      });
      const { hour, minute, specificWeekDay } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " ? 1/" + month + " " + specificWeekDay.day + specificWeekDay.monthWeek + " *"
      });
    };
    this.onUpdateHourTrigger = (option) => {
      const hour = option.value;
      this.setState({
        hour
      });
      const { minute, subTab } = this.state;
      if (subTab === "specificDay") {
        const { specificDay } = this.state;
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " " + specificDay.day + " 1/" + specificDay.month + " ? *"
        });
      } else if (subTab === "specificWeekDay") {
        const { specificWeekDay } = this.state;
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " ? 1/" + specificWeekDay.month + " " + specificWeekDay.day + specificWeekDay.monthWeek + " *"
        });
      }
    };
    this.onUpdateMinuteTrigger = (option) => {
      const minute = option.value;
      this.setState({
        minute
      });
      const { hour, subTab } = this.state;
      if (subTab === "specificDay") {
        const { specificDay } = this.state;
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " " + specificDay.day + " 1/" + specificDay.month + " ? *"
        });
      } else if (subTab === "specificWeekDay") {
        const { specificWeekDay } = this.state;
        this.props.triggerUpdated({
          ...this.props.trigger,
          cronExpression: "0 " + minute + " " + hour + " ? 1/" + specificWeekDay.month + " " + specificWeekDay.day + specificWeekDay.monthWeek + " *"
        });
      }
    };
    this.state = {
      hour: "0",
      minute: "0",
      subTab: "specificDay",
      specificDay: {
        day: "1W",
        month: "1"
      },
      specificWeekDay: {
        day: "SUN",
        month: "1",
        monthWeek: "#1"
      }
    };
  }
  componentDidMount() {
    const specificDayRegex = /0 (\d+) (\d+) (\d+|1L|LW|L|W) 1\/(\d+) \? \*/g;
    const specificWeekDayRegex = /0 (\d+) (\d+) \? 1\/(\d+) (SUN|MON|TUE|WED|THU|FRI|SAT)(#[1-5]|L) \*/g;
    const specificDayMatches = specificDayRegex.exec(this.props.trigger.cronExpression);
    const specificWeekDayMatches = specificWeekDayRegex.exec(this.props.trigger.cronExpression);
    if (specificDayMatches) {
      this.setState({
        subTab: "specificDay",
        minute: specificDayMatches[1],
        hour: specificDayMatches[2],
        specificDay: {
          day: specificDayMatches[3],
          month: specificDayMatches[4]
        }
      });
    } else if (specificWeekDayMatches) {
      this.setState({
        subTab: "specificWeekDay",
        minute: specificWeekDayMatches[1],
        hour: specificWeekDayMatches[2],
        specificWeekDay: {
          month: specificWeekDayMatches[3],
          day: specificWeekDayMatches[4],
          monthWeek: specificWeekDayMatches[5]
        }
      });
    } else {
      const { minute, hour, specificDay } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " " + specificDay.day + " 1/" + specificDay.month + " ? *"
      });
    }
  }
  render() {
    const { hour, minute, specificDay, specificWeekDay, subTab } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      value: "specificDay",
      onChange: this.onUpdateSubTabTrigger,
      checked: subTab === "specificDay"
    }), /* @__PURE__ */ React__default.createElement("span", null, "On the "), /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select select-month-days",
      clearable: false,
      disabled: subTab !== "specificDay",
      onChange: this.onUpdateSpecificDayDayTrigger,
      value: specificDay.day,
      options: MONTHS_DAYS_WITH_LASTS
    }), /* @__PURE__ */ React__default.createElement("span", null, " of every "), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      disabled: subTab !== "specificDay",
      type: "number",
      min: "1",
      max: "11",
      onChange: this.onUpdateSpecificDayMonthTrigger,
      required: subTab === "specificDay",
      value: specificDay.month
    }), /* @__PURE__ */ React__default.createElement("span", null, " month(s)"))), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("input", {
      type: "radio",
      value: "specificWeekDay",
      onChange: this.onUpdateSubTabTrigger,
      checked: subTab === "specificWeekDay"
    }), /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select select-month-days",
      clearable: false,
      disabled: subTab !== "specificWeekDay",
      onChange: this.onUpdateSpecificWeekDayMonthWeekTrigger,
      value: specificWeekDay.monthWeek,
      options: MONTH_WEEKS
    }), " ", /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select select-weekdays",
      clearable: false,
      disabled: subTab !== "specificWeekDay",
      onChange: this.onUpdateSpecificWeekDayDayTrigger,
      value: specificWeekDay.day,
      options: WEEKDAYS
    }), /* @__PURE__ */ React__default.createElement("span", null, " of every "), /* @__PURE__ */ React__default.createElement("input", {
      className: "form-control input-sm",
      disabled: subTab !== "specificWeekDay",
      type: "number",
      min: "1",
      max: "11",
      onChange: this.onUpdateSpecificWeekDayMonthTrigger,
      required: subTab === "specificWeekDay",
      value: specificWeekDay.month
    }), /* @__PURE__ */ React__default.createElement("span", null, " month(s)"))), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Start time "), /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select",
      clearable: false,
      value: hour,
      options: HOURS,
      onChange: this.onUpdateHourTrigger
    }), " ", /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select",
      clearable: false,
      value: minute,
      options: MINUTES,
      onChange: this.onUpdateMinuteTrigger
    }), " ", /* @__PURE__ */ React__default.createElement(SystemTimezone, null))));
  }
}

class CronWeekly extends React__default.Component {
  constructor(props) {
    super(props);
    this.onUpdateWeeklyTrigger = (option) => {
      const weekly = option.map((o) => o.value);
      const { hour, minute } = this.state;
      this.setState({ weekly });
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " ? *" + (weekly.length > 0 ? " " + weekly.join() : "") + " *"
      });
    };
    this.onUpdateHourTrigger = (option) => {
      const hour = option.value;
      const { minute, weekly } = this.state;
      this.setState({ hour });
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " ? *" + (weekly.length > 0 ? " " + weekly.join() : "") + " *"
      });
    };
    this.onUpdateMinuteTrigger = (option) => {
      const minute = option.value;
      const { hour, weekly } = this.state;
      this.setState({ minute });
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " ? *" + (weekly.length > 0 ? " " + weekly.join() : "") + " *"
      });
    };
    this.state = {
      weekly: [],
      hour: "0",
      minute: "0"
    };
  }
  componentDidMount() {
    const regex = /^0 (\d+) (\d+) \? \* ((?:MON|TUE|WED|THU|FRI|SAT|SUN)(?:,(?:MON|TUE|WED|THU|FRI|SAT|SUN))*) \*$/g;
    const matches = regex.exec(this.props.trigger.cronExpression);
    if (matches) {
      this.setState({
        minute: matches[1],
        hour: matches[2],
        weekly: matches[3].length > 0 ? matches[3].split(",") : []
      });
    } else {
      const { minute, hour, weekly } = this.state;
      this.props.triggerUpdated({
        ...this.props.trigger,
        cronExpression: "0 " + minute + " " + hour + " ? *" + (weekly.length > 0 ? " " + weekly.join() : "") + " *"
      });
    }
  }
  render() {
    const { hour, minute, weekly } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      options: WEEKDAYS,
      multi: true,
      clearable: false,
      value: weekly,
      onChange: this.onUpdateWeeklyTrigger
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("span", null, "Start time "), /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select",
      clearable: false,
      value: hour,
      options: HOURS,
      onChange: this.onUpdateHourTrigger
    }), " ", /* @__PURE__ */ React__default.createElement(Select, {
      className: "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select",
      clearable: false,
      value: minute,
      options: MINUTES,
      onChange: this.onUpdateMinuteTrigger
    }), " ", /* @__PURE__ */ React__default.createElement(SystemTimezone, null))));
  }
}

var css_248z$C = ".cron-gen-main .row {\n  margin-bottom: 10px;\n}\n.cron-gen-main input[type='radio'] {\n  margin-right: 4px;\n}\n.cron-gen-main .vertical-align-select {\n  vertical-align: middle;\n}\n.cron-gen-main .select-month-days {\n  min-width: 100px;\n}\n.cron-gen-main .select-month-week {\n  min-width: 100px;\n}\n.cron-gen-main .select-weekdays {\n  min-width: 200px;\n}\n";
styleInject(css_248z$C);

class CronTrigger extends React__default.Component {
  constructor(props) {
    super(props);
    this.tabOptions = [
      { label: "minutes", value: "minutes", regex: [/^(0 0\/\d+ \* 1\/1 \* \? \*)$/g] },
      { label: "hourly", value: "hourly", regex: [/^(0 \d+ 0\/\d+ 1\/1 \* \? \*)$/g] },
      { label: "daily", value: "daily", regex: [/^(0 \d+ \d+ 1\/\d+ \* \? \*)$/g, /^(0 \d+ \d+ \? \* MON-FRI \*)$/g] },
      {
        label: "weekly",
        value: "weekly",
        regex: [/^(0 \d+ \d+ \? \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*)$/g]
      },
      {
        label: "monthly",
        value: "monthly",
        regex: [
          /^^(0 \d+ \d+ (\d+|1L|LW|L|W) 1\/\d+ \? \*)$/g,
          /^(0 \d+ \d+ \? 1\/\d+ (SUN|MON|TUE|WED|THU|FRI|SAT)(#[1-5]|L) \*)$/g
        ]
      },
      { label: "advanced", value: "advanced", regex: [] }
    ];
    this.renderCronTypeContents = (activeTab) => {
      switch (activeTab) {
        case "minutes":
          return /* @__PURE__ */ React__default.createElement(CronMinutes, {
            ...this.props
          });
        case "hourly":
          return /* @__PURE__ */ React__default.createElement(CronHourly, {
            ...this.props
          });
        case "daily":
          return /* @__PURE__ */ React__default.createElement(CronDaily, {
            ...this.props
          });
        case "weekly":
          return /* @__PURE__ */ React__default.createElement(CronWeekly, {
            ...this.props
          });
        case "monthly":
          return /* @__PURE__ */ React__default.createElement(CronMonthly, {
            ...this.props
          });
        case "advanced":
          return /* @__PURE__ */ React__default.createElement(CronAdvance, {
            ...this.props
          });
        default:
          return /* @__PURE__ */ React__default.createElement("div", null, "An error has occurred");
      }
    };
    this.state = {
      activeTab: "advanced"
    };
  }
  componentDidMount() {
    const cronExpression = this.props.trigger.cronExpression || "0 0 0 1W 1/1 ? *";
    this.tabOptions.forEach((o) => {
      o.regex.forEach((r) => {
        if (r.exec(cronExpression)) {
          this.setState({ activeTab: o.value });
        }
      });
    });
    if (!this.props.trigger.cronExpression) {
      this.setState({ activeTab: "minutes" });
      this.props.triggerUpdated({ cronExpression: "0 0 0 1W 1/1 ? *" });
    }
  }
  render() {
    const { activeTab } = this.state;
    return /* @__PURE__ */ React__default.createElement(FormField, {
      label: "Frequency",
      value: activeTab,
      onChange: (e) => this.setState({ activeTab: e.target.value }),
      input: (props) => /* @__PURE__ */ React__default.createElement("div", {
        className: "cron-gen-main form-inline no-spel"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "row"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-6"
      }, /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        options: this.tabOptions,
        clearable: false
      }))), this.renderCronTypeContents(activeTab))
    });
  }
}

Registry.pipeline.registerTrigger({
  component: CronTrigger,
  description: "Executes the pipeline on a CRON schedule",
  excludedArtifactTypePatterns: [ArtifactTypePatterns.JENKINS_FILE],
  executionTriggerLabel: (trigger) => trigger.cronExpression,
  key: "cron",
  label: "CRON",
  validators: [
    {
      type: "serviceAccountAccess",
      message: `You do not have access to the service account configured in this pipeline's CRON trigger.
                    You will not be able to save your edits to this pipeline.`,
      preventSave: true
    }
  ]
});

const gitTriggerTypes = SETTINGS.gitSources || ["stash", "github", "bitbucket", "gitlab"];
const displayTexts = {
  bitbucket: {
    projectLabel: "Team or User",
    projectPlaceholder: "Team or User name, i.e. spinnaker for bitbucket.org/spinnaker/echo",
    slugLabel: "Repo name",
    slugPlaceholder: "Repository name (not the url), i.e, echo for bitbucket.org/spinnaker/echo"
  },
  github: {
    projectLabel: "Organization or User",
    projectPlaceholder: "Organization or User name, i.e. spinnaker for github.com/spinnaker/echo",
    slugLabel: "Project",
    slugPlaceholder: "Project name (not the url), i.e, echo for github.com/spinnaker/echo"
  },
  gitlab: {
    projectLabel: "Organization or User",
    projectPlaceholder: "Organization or User name, i.e. spinnaker for gitlab.com/spinnaker/echo",
    slugLabel: "Project",
    slugPlaceholder: "Project name (not the url), i.e. echo for gitlab.com/spinnaker/echo"
  },
  stash: {
    projectLabel: "Project",
    projectPlaceholder: "Project name, i.e. SPKR for stash.mycorp.com/projects/SPKR/repos/echo",
    slugLabel: "Repo name",
    slugPlaceholder: "Repository name (not the url), i.e, echo for stash.mycorp.com/projects/SPKR/repos/echo"
  }
};
function GitTrigger(gitTriggerProps) {
  const { formik, application } = gitTriggerProps;
  const trigger = formik.values;
  const { source } = formik.values;
  const { projectLabel, projectPlaceholder, slugLabel, slugPlaceholder } = displayTexts[source || "github"];
  React__default.useEffect(() => {
    if (!trigger.source) {
      const attributes = application.attributes || {};
      const defaultSource = attributes.repoType || (gitTriggerTypes.length === 1 ? gitTriggerTypes[0] : null);
      formik.setFieldValue("source", defaultSource);
      formik.setFieldValue("project", attributes.repoProjectKey);
      formik.setFieldValue("slug", attributes.repoSlug);
    }
  }, []);
  React__default.useEffect(() => {
    if (trigger.source !== "github") {
      formik.setFieldValue("secret", void 0);
    }
  }, [trigger.source]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, gitTriggerTypes && gitTriggerTypes.length > 1 && /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "source",
    label: "Repo Type",
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      placeholder: "Select Repo Type",
      stringOptions: gitTriggerTypes,
      clearable: false
    })
  }), SETTINGS.stashTriggerInfo && trigger.source === "stash" && /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h center"
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "sp-margin-m-yaxis",
    href: SETTINGS.stashTriggerInfo,
    target: "_blank"
  }, "See how to add a stash trigger to Spinnaker")), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "project",
    label: projectLabel,
    required: true,
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props,
      placeholder: projectPlaceholder
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "slug",
    label: slugLabel,
    required: true,
    validate: (value, label) => value && value.match(/:\/\//) && `${label} is a simple name should not contain ://`,
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props,
      placeholder: slugPlaceholder
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "branch",
    label: "Branch",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.git.trigger.branch"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), source === "github" && /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "secret",
    label: "Secret",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.git.trigger.githubSecret"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }));
}

var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$7(target, key, result);
  return result;
};
let GitTriggerExecutionStatus = class extends React__default.Component {
  render() {
    const trigger = this.props.trigger;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("li", null, trigger.project, "/", trigger.slug), /* @__PURE__ */ React__default.createElement("li", null, "Branch: ", trigger.branch));
  }
};
GitTriggerExecutionStatus = __decorateClass$7([
  Overridable("git.trigger.executionStatus")
], GitTriggerExecutionStatus);

Registry.pipeline.registerTrigger({
  component: GitTrigger,
  description: "Executes the pipeline on a git push",
  executionStatusComponent: GitTriggerExecutionStatus,
  excludedArtifactTypePatterns: excludeAllTypesExcept(ArtifactTypePatterns.GITHUB_FILE, ArtifactTypePatterns.GITLAB_FILE, ArtifactTypePatterns.BITBUCKET_FILE),
  key: "git",
  label: "Git",
  providesRepositoryInformation: true,
  validators: [
    {
      type: "serviceAccountAccess",
      message: `You do not have access to the service account configured in this pipeline's git trigger.
                You will not be able to save your edits to this pipeline.`,
      preventSave: true
    }
  ]
});

const HelmTriggerTemplate = (props) => {
  const [accounts, setAccounts] = useState$b([]);
  const [account, setAccount] = useState$b(props.trigger.account);
  const [chart, setChart] = useState$b(props.trigger.chart);
  const [version, setVersion] = useState$b(props.trigger.version);
  useEffect$a(() => {
    AccountService.getArtifactAccounts().then((allAccounts) => {
      const accounts2 = allAccounts.filter((a) => {
        return a.types.includes("helm/chart");
      }).map((it) => it.name);
      setAccounts(accounts2);
    });
  }, []);
  const stateChanged = (setter, field, value) => {
    setter(value);
    if (props.onHelmChanged) {
      props.onHelmChanged(Object.assign({
        accounts,
        account,
        chart,
        version
      }, {
        [field]: value
      }));
    }
  };
  const helpId = `pipeline.config.trigger.helm.version${props.isManual ? ".manual" : ""}`;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Account",
    value: account,
    onChange: (e) => stateChanged(setAccount, "account", e.target.value || ""),
    input: (props2) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props2,
      stringOptions: accounts,
      clearable: false
    })
  }), /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Chart",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.trigger.helm.chart"
    }),
    value: chart || "",
    onChange: (e) => stateChanged(setChart, "chart", e.target.value || ""),
    input: (props2) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props2
    })
  }), /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Version",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: helpId
    }),
    value: version || "",
    onChange: (e) => stateChanged(setVersion, "version", e.target.value || ""),
    input: (props2) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props2
    })
  }));
};

const HelmManualTriggerConfig = (props) => {
  const onHelmChanged = (changes) => {
    const { command, updateCommand } = props;
    updateCommand("extraFields", command.extraFields || {});
    updateCommand("extraFields.chart", changes.chart);
    updateCommand("extraFields.version", changes.version);
    updateCommand("extraFields.artifacts", [
      {
        type: "helm/chart",
        name: changes.chart,
        version: changes.version,
        reference: changes.account
      }
    ]);
    updateCommand("triggerInvalid", false);
  };
  return /* @__PURE__ */ React__default.createElement(HelmTriggerTemplate, {
    isManual: true,
    trigger: props.command.trigger,
    onHelmChanged
  });
};
HelmManualTriggerConfig.formatLabel = (trigger) => {
  return $q.when(`(Helm) ${trigger.account ? trigger.account + ":" : ""}${trigger.chart || ""}`);
};

const HelmTriggerConfig = (props) => {
  const onHelmChanged = (changes) => {
    props.triggerUpdated && props.triggerUpdated({ ...props.trigger, ...changes });
  };
  return /* @__PURE__ */ React__default.createElement(HelmTriggerTemplate, {
    isManual: false,
    trigger: props.trigger,
    onHelmChanged
  });
};

const HelmTriggerExecutionStatus = (props) => {
  const trigger = props.trigger;
  const name = trigger.artifactName;
  const version = trigger.version;
  return /* @__PURE__ */ React.createElement("li", null, name, ":", version);
};

const HELM_TRIGGER_TYPE = "helm";
Registry.pipeline.registerTrigger({
  label: "Helm Chart",
  description: "Executes the pipeline on a Helm chart update",
  key: HELM_TRIGGER_TYPE,
  component: HelmTriggerConfig,
  executionStatusComponent: HelmTriggerExecutionStatus,
  manualExecutionComponent: HelmManualTriggerConfig,
  validators: [
    {
      type: "requiredField",
      fieldName: "account",
      message: "<strong>Account</strong> is a required field for Helm triggers."
    },
    {
      type: "requiredField",
      fieldName: "chart",
      message: "<strong>Chart</strong> is a required field for Helm triggers."
    },
    {
      type: "requiredField",
      fieldName: "version",
      message: "<strong>Version</strong> is a required field for Helm triggers."
    },
    {
      type: "serviceAccountAccess",
      preventSave: true,
      message: `You do not have access to the service account configured in this pipeline's Helm trigger.
                You will not be able to save your edits to this pipeline.`
    }
  ]
});

function RefreshableReactSelectInput(props) {
  const { disabled, isLoading, onRefreshClicked, refreshButtonTooltipText, ...rest } = props;
  const spinnerClassName = "sp-margin-m fa fa-sync-alt " + (isLoading ? "fa-spin" : "");
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h middle"
  }, /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
    ...rest,
    isLoading,
    disabled: isLoading || disabled,
    className: "flex-grow"
  }), /* @__PURE__ */ React__default.createElement(Tooltip, {
    placement: "right",
    value: refreshButtonTooltipText
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: spinnerClassName,
    onClick: onRefreshClicked,
    style: { cursor: "pointer" }
  })));
}

function BaseBuildTrigger(buildTriggerProps) {
  const { formik, buildTriggerType } = buildTriggerProps;
  const trigger = formik.values;
  const { master, job, type } = trigger;
  const fetchMasters = useLatestPromise(() => {
    return IgorService.listMasters(buildTriggerType);
  }, []);
  const fetchJobs = useLatestPromise(() => {
    return master ? IgorService.listJobsForMaster(master) : null;
  }, [master]);
  React__default.useEffect(() => {
    const jobsFetched = fetchJobs.status === "RESOLVED";
    const selectedJobFound = jobsFetched && fetchJobs.result && fetchJobs.result.includes(job);
    if (job && jobsFetched && !selectedJobFound) {
      formik.setFieldValue("job", null);
    }
  }, [fetchJobs.result]);
  const label = buildTriggerType === "jenkins" ? "Controller" : "Build Service";
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "master",
    label,
    input: (props) => /* @__PURE__ */ React__default.createElement(RefreshableReactSelectInput, {
      ...props,
      stringOptions: fetchMasters.result,
      disabled: fetchMasters.status !== "RESOLVED",
      isLoading: fetchMasters.status === "PENDING",
      onRefreshClicked: () => fetchMasters.refresh(),
      refreshButtonTooltipText: fetchMasters.status === "PENDING" ? "Masters refreshing" : "Refresh masters list",
      placeholder: `Select a ${label.toLowerCase()}`
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "job",
    label: "Job",
    input: (props) => /* @__PURE__ */ React__default.createElement(RefreshableReactSelectInput, {
      ...props,
      mode: "VIRTUALIZED",
      stringOptions: fetchJobs.result,
      disabled: !master || fetchJobs.status !== "RESOLVED",
      isLoading: fetchJobs.status === "PENDING",
      onRefreshClicked: () => fetchJobs.refresh(),
      refreshButtonTooltipText: fetchJobs.status === "PENDING" ? "Jobs refreshing" : "Refresh job list",
      placeholder: "Select a job..."
    })
  }), buildTriggerType !== BuildServiceType.Travis && /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "propertyFile",
    label: "Property File",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: `pipeline.config.${type}.trigger.propertyFile`
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "payloadConstraints",
    label: "Payload Constraints",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: `pipeline.config.${type}.trigger.payloadConstraints`
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
      ...props,
      addButtonLabel: "Add payload constraint"
    })
  }));
}

class JenkinsTrigger extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement(BaseBuildTrigger, {
      ...this.props,
      buildTriggerType: BuildServiceType.Jenkins
    });
  }
}

class JenkinsTriggerExecutionStatus extends React__default.Component {
  render() {
    const trigger = this.props.trigger;
    return /* @__PURE__ */ React__default.createElement("li", null, trigger.job);
  }
}

class JenkinsTriggerTemplate extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement(BaseBuildTriggerTemplate, {
      ...this.props,
      buildTriggerType: BuildServiceType.Jenkins
    });
  }
}
JenkinsTriggerTemplate.formatLabel = BaseBuildTriggerTemplate.formatLabel;

Registry.pipeline.registerTrigger({
  component: JenkinsTrigger,
  description: "Listens to a Jenkins job",
  executionStatusComponent: JenkinsTriggerExecutionStatus,
  executionTriggerLabel: () => "Triggered Build",
  key: "jenkins",
  label: "Jenkins",
  manualExecutionComponent: JenkinsTriggerTemplate,
  providesVersionForBake: true,
  validators: [
    {
      type: "requiredField",
      fieldName: "job",
      message: "<strong>Job</strong> is a required field on Jenkins triggers."
    },
    {
      type: "serviceAccountAccess",
      message: `You do not have access to the service account configured in this pipeline's Jenkins trigger.
                You will not be able to save your edits to this pipeline.`,
      preventSave: true
    }
  ]
});

class NexusReaderService {
  static getNexusNames() {
    return REST("/nexus/names").get();
  }
}

function NexusTrigger() {
  const fetchNames = useLatestPromise(() => NexusReaderService.getNexusNames(), []);
  const fetchError = () => errorMessage(`Error fetching nexus names: ${fetchNames.error.data.status} ${fetchNames.error.data.error}`);
  const validationMessage = fetchNames.status === "REJECTED" ? fetchError() : null;
  return /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "nexusSearchName",
    label: "Nexus Name",
    touched: true,
    validationMessage,
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      isLoading: status === "PENDING",
      placeholder: "Select Nexus search name...",
      stringOptions: fetchNames.result,
      clearable: false
    })
  });
}

Registry.pipeline.registerTrigger({
  label: "Nexus",
  description: "Executes the pipeline on a Nexus repo update",
  key: "nexus",
  component: NexusTrigger,
  validators: [],
  excludedArtifactTypePatterns: excludeAllTypesExcept(ArtifactTypePatterns.MAVEN_FILE)
});

const statusOptions = ["successful", "failed", "canceled"];
function PipelineTrigger(pipelineTriggerProps) {
  const { formik, pipelineId } = pipelineTriggerProps;
  const trigger = formik.values;
  const { application } = trigger;
  const fetchApps = useLatestPromise(() => ApplicationReader.listApplications(), []);
  const appsLoaded = fetchApps.status === "RESOLVED";
  const appsLoading = fetchApps.status === "PENDING";
  const applications = React__default.useMemo(() => {
    return appsLoaded ? fetchApps.result.map((app) => app.name).sort() : [];
  }, [appsLoaded, fetchApps.result]);
  const fetchPipelines = useLatestPromise(() => {
    return application ? PipelineConfigService.getPipelinesForApplication(application) : null;
  }, [application]);
  const pipelinesLoaded = fetchPipelines.status === "RESOLVED";
  const pipelinesLoading = fetchPipelines.status === "PENDING";
  const pipelines = React__default.useMemo(() => {
    return pipelinesLoaded ? fetchPipelines.result.filter((p) => p.id !== pipelineId) : [];
  }, [pipelinesLoaded, pipelineId, fetchPipelines.result]);
  React__default.useEffect(() => {
    if (pipelinesLoaded && !pipelines.find((p) => p.id === trigger.pipeline)) {
      formik.setFieldValue("pipeline", null);
    }
  }, [pipelinesLoaded, trigger.pipeline, pipelines]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "application",
    label: "Application",
    required: true,
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      disabled: !appsLoaded,
      isLoading: appsLoading,
      mode: "VIRTUALIZED",
      stringOptions: applications,
      placeholder: "None"
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "pipeline",
    label: "Pipeline",
    required: true,
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      disabled: !application || !pipelinesLoaded,
      isLoading: pipelinesLoading,
      mode: "VIRTUALIZED",
      options: pipelines.map((p) => ({ label: p.name, value: p.id })),
      placeholder: "Select a pipeline..."
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "status",
    label: "Pipeline Status",
    required: true,
    input: (props) => /* @__PURE__ */ React__default.createElement(ChecklistInput, {
      ...props,
      stringOptions: statusOptions,
      inline: true
    })
  }));
}

class PipelineTriggerTemplate extends React__default.Component {
  constructor(props) {
    super(props);
    this.initialize = () => {
      const { command } = this.props;
      command.triggerInvalid = true;
      const trigger = command.trigger;
      const parent = trigger.parentExecution;
      if (parent) {
        trigger.application = parent.application;
        trigger.pipeline = parent.pipelineConfigId;
        trigger.parentPipelineId = parent.id;
      }
      command.extraFields = {};
      if (command.trigger.type !== "pipeline") {
        return;
      }
      ReactInjector.executionService.getExecutionsForConfigIds([trigger.pipeline], { limit: 20 }).then(this.executionLoadSuccess, this.executionLoadFailure);
    };
    this.executionLoadSuccess = (executions) => {
      const newState = { executions };
      const trigger = this.props.command.trigger;
      if (executions.length) {
        executions.forEach((execution) => ExecutionsTransformer.addBuildInfo(execution));
        const defaultSelection = executions.find((e) => e.id === trigger.parentPipelineId) || executions[0];
        newState.selectedExecution = defaultSelection.id;
        this.updateSelectedExecution(defaultSelection);
      }
      newState.executionsLoading = false;
      this.setState(newState);
    };
    this.executionLoadFailure = () => {
      this.setState({
        executionsLoading: false,
        loadError: true
      });
    };
    this.updateSelectedExecution = (item) => {
      this.props.command.extraFields.parentPipelineId = item.id;
      this.props.command.extraFields.parentPipelineApplication = item.application;
      this.props.command.triggerInvalid = false;
      this.setState({ selectedExecution: item.id });
    };
    this.handleExecutionChanged = (option) => {
      const execution = this.getExecutionFromId(option.value);
      this.updateSelectedExecution(execution);
    };
    this.getExecutionFromId = (id) => {
      return this.state.executions.find((e) => e.id === id);
    };
    this.optionRenderer = (option) => {
      const execution = this.getExecutionFromId(option.value);
      const scm = has(execution, "buildInfo.scm[0]") && execution.buildInfo.scm[0];
      return /* @__PURE__ */ React__default.createElement("span", {
        style: { fontSize: "12px" }
      }, /* @__PURE__ */ React__default.createElement("strong", null, /* @__PURE__ */ React__default.createElement(ExecutionBuildTitle, {
        execution,
        defaultToTimestamp: false
      }), " "), timestamp(execution.buildTime), " (", execution.status, ")", scm && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("br", null), scm.branch, " (", scm.sha1 && scm.sha1.substr(0, 6), "): ", scm.message && scm.message.substr(0, 30), scm.message && scm.message.length > 30 && /* @__PURE__ */ React__default.createElement("span", null, "\u2026")));
    };
    this.selectedRenderer = (option) => {
      const execution = this.getExecutionFromId(option.value);
      return /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(ExecutionBuildTitle, {
        execution,
        defaultToTimestamp: true
      }), " ", /* @__PURE__ */ React__default.createElement("strong", null, "(", execution.status, ")"));
    };
    this.state = {
      executions: [],
      executionsLoading: true,
      loadError: false,
      selectedExecution: null
    };
  }
  static formatLabel(trigger) {
    const application = get(trigger, "parentExecution.application", trigger.application);
    const pipelineConfigId = get(trigger, "parentExecution.pipelineConfigId", trigger.pipeline);
    const loadSuccess = (pipelines) => {
      const pipeline = pipelines.find((config) => config.id === pipelineConfigId);
      return pipeline ? `(Pipeline) ${application}: ${pipeline.name}` : "[pipeline not found]";
    };
    const loadFailure = () => {
      return `[could not load pipelines for '${application}']`;
    };
    return PipelineConfigService.getPipelinesForApplication(application).then(loadSuccess, loadFailure);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.command !== this.props.command) {
      this.initialize();
    }
  }
  componentDidMount() {
    this.initialize();
  }
  render() {
    const { executions, executionsLoading, loadError, selectedExecution } = this.state;
    const options = executions.map((execution) => {
      return {
        value: execution.id
      };
    });
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-4 sm-label-right"
    }, "Execution"), executionsLoading && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-control-static text-center"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "small"
    }))), loadError && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, "Error loading executions!"), !executionsLoading && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, executions.length === 0 && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "No recent executions found")), executions.length > 0 && /* @__PURE__ */ React__default.createElement(TetheredSelect, {
      options,
      optionRenderer: this.optionRenderer,
      clearable: false,
      value: selectedExecution,
      valueRenderer: this.selectedRenderer,
      onChange: this.handleExecutionChanged
    })));
  }
}

Registry.pipeline.registerTrigger({
  component: PipelineTrigger,
  description: "Listens to a pipeline execution",
  label: "Pipeline",
  key: "pipeline",
  excludedArtifactTypePatterns: [ArtifactTypePatterns.JENKINS_FILE],
  executionStatusComponent: ExecutionUserStatus,
  manualExecutionComponent: PipelineTriggerTemplate,
  executionTriggerLabel: () => "Pipeline"
});

function PluginTrigger(props) {
  const options = [
    { label: "Plugin Published", value: "PUBLISHED" },
    { label: "Preferred Version Updated", value: "PREFERRED_VERSION_UPDATED" }
  ];
  return /* @__PURE__ */ React__default.createElement(FormikStageConfig, {
    application: props.application,
    stage: props.trigger,
    pipeline: props.pipeline,
    onChange: props.triggerUpdated,
    render: () => /* @__PURE__ */ React__default.createElement(LayoutProvider, {
      value: StandardFieldLayout
    }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "pluginEventType",
      label: "Plugin Event",
      touched: true,
      input: (props2) => /* @__PURE__ */ React__default.createElement(SelectInput, {
        ...props2,
        defaultValue: "PUBLISHED",
        options
      })
    }))
  });
}

Registry.pipeline.registerTrigger({
  key: "plugin",
  label: "Plugin",
  description: "Executes the pipeline in response to a Plugin Event",
  component: PluginTrigger
});

function PubsubTrigger(pubsubTriggerProps) {
  const { formik } = pubsubTriggerProps;
  const trigger = formik.values;
  const pubsubSystems = SETTINGS.pubsubProviders || ["amazon", "google"];
  const fetchSubscriptions = useLatestPromise(() => PubsubSubscriptionReader.getPubsubSubscriptions(), []);
  const pubsubSubscriptions = fetchSubscriptions.result || [];
  const subscriptionsLoaded = fetchSubscriptions.status === "RESOLVED";
  const filteredPubsubSubscriptions = pubsubSubscriptions.filter((subscription) => subscription.pubsubSystem === trigger.pubsubSystem).map((subscription) => subscription.subscriptionName);
  if (subscriptionsLoaded) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "pubsubSystem",
      label: "Pub/Sub System Type",
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        placeholder: "Select Pub/Sub System",
        stringOptions: pubsubSystems
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "subscriptionName",
      label: "Subscription Name",
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        placeholder: "Select Pub/Sub Subscription",
        stringOptions: filteredPubsubSubscriptions
      })
    }), /* @__PURE__ */ React__default.createElement("hr", null), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "payloadConstraints",
      label: "Payload Constraints",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.trigger.pubsub.payloadConstraints"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
        ...props,
        addButtonLabel: "Add payload constraint"
      })
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      name: "attributeConstraints",
      label: "Attribute Constraints ",
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "pipeline.config.trigger.pubsub.attributeConstraints"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
        ...props,
        addButtonLabel: "Add attribute constraint"
      })
    }));
  } else {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal middle center",
      style: { marginBottom: "250px", height: "150px" }
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    }));
  }
}

Registry.pipeline.registerTrigger({
  component: PubsubTrigger,
  description: "Executes the pipeline when a pubsub message is received",
  excludedArtifactTypePatterns: [ArtifactTypePatterns.JENKINS_FILE],
  key: "pubsub",
  label: "Pub/Sub",
  validators: []
});

class TravisTrigger extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(BaseBuildTrigger, {
      ...this.props,
      buildTriggerType: BuildServiceType.Travis
    }), /* @__PURE__ */ React__default.createElement("p", null), /* @__PURE__ */ React__default.createElement("div", {
      className: "well alert alert-info",
      role: "alert"
    }, /* @__PURE__ */ React__default.createElement("p", null, "You can read properties from Travis builds by logging them in the build log using one of the following formats:"), /* @__PURE__ */ React__default.createElement("pre", null, "echo SPINNAKER_PROPERTY_key1=value1", /* @__PURE__ */ React__default.createElement("br", null), "echo SPINNAKER_PROPERTY_key2=value2", /* @__PURE__ */ React__default.createElement("br", null), "echo SPINNAKER_CONFIG_JSON=", "{", '"key3": "value3", "key4": "value4"', "}"), "The properties will be available in the trigger context under the key ", /* @__PURE__ */ React__default.createElement("code", null, "properties"), ".", /* @__PURE__ */ React__default.createElement("br", null), "Example using SpEL:", " ", /* @__PURE__ */ React__default.createElement("code", null, "$", "{", "trigger.properties.key2", "}")));
  }
}

class TravisTriggerTemplate extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement(BaseBuildTriggerTemplate, {
      ...this.props,
      buildTriggerType: BuildServiceType.Travis
    });
  }
}
TravisTriggerTemplate.formatLabel = BaseBuildTriggerTemplate.formatLabel;

Registry.pipeline.registerTrigger({
  component: TravisTrigger,
  description: "Listens to a Travis job",
  excludedArtifactTypePatterns: [ArtifactTypePatterns.JENKINS_FILE],
  key: "travis",
  label: "Travis",
  manualExecutionComponent: TravisTriggerTemplate,
  providesVersionForBake: true,
  validators: [
    {
      type: "requiredField",
      fieldName: "job",
      message: "<strong>Job</strong> is a required field on Travis triggers."
    },
    {
      type: "serviceAccountAccess",
      message: `You do not have access to the service account configured in this pipeline's Travis trigger.
                You will not be able to save your edits to this pipeline.`,
      preventSave: true
    }
  ]
});

function WebhookTrigger(webhookTriggerProps) {
  const { formik } = webhookTriggerProps;
  const trigger = formik.values;
  const { source, type } = trigger;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "source",
    label: "Source",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.trigger.webhook.source"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-v"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    }), /* @__PURE__ */ React__default.createElement("i", null, `${SETTINGS.gateUrl}/webhooks/${type}/${source || "<source>"}`))
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "payloadConstraints",
    label: "Payload Constraints",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.trigger.webhook.payloadConstraints"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
      ...props,
      addButtonLabel: "Add payload constraint"
    })
  }));
}

Registry.pipeline.registerTrigger({
  component: WebhookTrigger,
  description: "Executes the pipeline when a webhook is received.",
  excludedArtifactTypePatterns: [ArtifactTypePatterns.JENKINS_FILE],
  key: "webhook",
  label: "Webhook",
  validators: [
    {
      type: "serviceAccountAccess",
      message: `You do not have access to the service account configured in this pipeline's webhook trigger.
                You will not be able to save your edits to this pipeline.`,
      preventSave: true
    }
  ]
});

function getJobParts(job) {
  const firstSlash = job.indexOf("/");
  const lastSlash = job.lastIndexOf("/");
  const app = job.substring(firstSlash + 1, lastSlash);
  const pipeline = job.substring(lastSlash + 1);
  return { app, pipeline };
}
function WerckerTrigger(werckerTriggerProps) {
  const { formik } = werckerTriggerProps;
  const { app, master, pipeline } = formik.values;
  const fetchMasters = useLatestPromise(() => IgorService.listMasters(BuildServiceType.Wercker), []);
  const mastersLoading = fetchMasters.status === "PENDING";
  const mastersLoaded = fetchMasters.status === "RESOLVED";
  const fetchJobs = useLatestPromise(() => {
    return master && IgorService.listJobsForMaster(master).then((x) => x.map(getJobParts));
  }, [master]);
  const jobs = fetchJobs.result;
  const jobsLoading = fetchJobs.status === "PENDING";
  const jobsLoaded = fetchJobs.status === "RESOLVED";
  const apps = React__default.useMemo(() => {
    return jobsLoaded ? uniq(jobs.map((job) => job.app)) : [];
  }, [jobsLoaded, jobs]);
  const pipelines = React__default.useMemo(() => {
    return jobsLoaded ? jobs.filter((parts) => parts.app === app).map((parts) => parts.pipeline) : [];
  }, [jobsLoaded, app, jobs]);
  React__default.useEffect(() => {
    if (jobsLoaded && !!app && !apps.includes(app)) {
      formik.setFieldValue("app", null);
    }
    if (jobsLoaded && !!pipeline && !pipelines.includes(pipeline)) {
      formik.setFieldValue("pipeline", null);
    }
  }, [jobsLoaded, apps, app, pipelines, pipeline]);
  React__default.useEffect(() => {
    const hasJob = !!app && !!pipeline;
    const job = hasJob ? `${app}/${pipeline}` : null;
    formik.setFieldValue("job", job);
  }, [pipeline, app]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "master",
    label: "Build Service",
    input: (props) => /* @__PURE__ */ React__default.createElement(RefreshableReactSelectInput, {
      ...props,
      stringOptions: fetchMasters.result,
      placeholder: "Select a build service...",
      disabled: !mastersLoaded,
      isLoading: mastersLoading,
      onRefreshClicked: () => fetchMasters.refresh(),
      refreshButtonTooltipText: mastersLoading ? "Masters refreshing" : "Refresh masters list"
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "app",
    label: "Application",
    input: (props) => /* @__PURE__ */ React__default.createElement(RefreshableReactSelectInput, {
      ...props,
      stringOptions: apps,
      placeholder: "Select an application...",
      disabled: !master || !jobsLoaded,
      isLoading: jobsLoading,
      onRefreshClicked: () => fetchJobs.refresh(),
      refreshButtonTooltipText: jobsLoading ? "Apps refreshing" : "Refresh app list"
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "pipeline",
    label: "Pipeline",
    input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...props,
      disabled: !master || !jobsLoaded,
      isLoading: jobsLoading,
      stringOptions: pipelines,
      placeholder: "Select a pipeline"
    })
  }));
}

class WerckerTriggerTemplate extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement(BaseBuildTriggerTemplate, {
      ...this.props,
      buildTriggerType: BuildServiceType.Wercker
    });
  }
}
WerckerTriggerTemplate.formatLabel = BaseBuildTriggerTemplate.formatLabel;

Registry.pipeline.registerTrigger({
  component: WerckerTrigger,
  description: "Listens to a Wercker pipeline",
  excludedArtifactTypePatterns: [ArtifactTypePatterns.JENKINS_FILE],
  key: "wercker",
  label: "Wercker",
  manualExecutionComponent: WerckerTriggerTemplate,
  validators: [
    {
      type: "requiredField",
      fieldName: "job",
      message: "<strong>pipeline</strong> is a required field on Wercker triggers."
    },
    {
      type: "serviceAccountAccess",
      message: `You do not have access to the service account configured in this pipeline's Wercker trigger.
                You will not be able to save your edits to this pipeline.`,
      preventSave: true
    }
  ]
});

class TriggersWrapper extends React__default.Component {
  constructor() {
    super(...arguments);
    this.updatePipelineConfig = (changes) => {
      this.props.updatePipelineConfig(changes);
      this.forceUpdate();
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(Triggers$1, {
      ...this.props,
      updatePipelineConfig: this.updatePipelineConfig
    });
  }
}

const TRIGGERS = "spinnaker.core.pipeline.config.trigger.triggersDirective";
module(TRIGGERS, []).component("triggers", react2angular(withErrorBoundary(TriggersWrapper, "triggers"), [
  "application",
  "pipeline",
  "fieldUpdated",
  "updatePipelineConfig",
  "revertCount"
]));

class BaseRequiredFieldValidator {
  validate(pipeline, stage, validationConfig, config) {
    if (!this.passesValidation(pipeline, stage, validationConfig)) {
      return this.validationMessage(validationConfig, config);
    }
    return null;
  }
  printableFieldLabel(field) {
    const fieldLabel = field.fieldLabel || field.fieldName;
    return upperFirst(fieldLabel);
  }
  fieldIsValid(pipeline, stage, fieldName) {
    if (pipeline.strategy === true && ["cluster", "regions", "zones", "credentials"].includes(fieldName)) {
      return true;
    }
    const fieldExists = has(stage, fieldName);
    const field = get(stage, fieldName);
    return fieldExists && (field || field === 0) && !(Array.isArray(field) && field.length === 0);
  }
}

class AnyFieldRequiredValidator extends BaseRequiredFieldValidator {
  passesValidation(pipeline, stage, validationConfig) {
    return validationConfig.fields.some((requiredField) => {
      return this.fieldIsValid(pipeline, stage, requiredField.fieldName);
    });
  }
  validationMessage(validationConfig, config) {
    const fieldString = validationConfig.fields.map((requiredField) => this.printableFieldLabel(requiredField)).join(", ");
    return validationConfig.message || `At least one of the following fields must be supplied for ${config.label} stages: <strong>${fieldString}</strong>.`;
  }
}
PipelineConfigValidator.registerValidator("anyFieldRequired", new AnyFieldRequiredValidator());

class ImageProviderBeforeTypeValidator {
  validate(pipeline, stage, validator, _config) {
    const triggersToTest = pipeline.triggers || [];
    const hasImageProvider = Boolean(triggersToTest.length) && triggersToTest.every((trigger) => (validator.triggerTypes || []).includes(trigger.type));
    const hasCustomImage = (stage.clusters || []).every((cluster) => cluster.imageId && cluster.imageId !== "${trigger.properties.imageName}");
    const stageTypes = ["findAmi", "findImage", "findImageFromTags"];
    const stagesToTest = PipelineConfigService.getAllUpstreamDependencies(pipeline, stage);
    const hasFindImageStage = stagesToTest.some((test) => stageTypes.includes(test.type));
    if (!hasImageProvider && !hasCustomImage && !hasFindImageStage) {
      return `${validator.message} Update the pipeline with a find image stage or pipeline trigger or update this stage by manually inputting the imageId. Suggested triggers: ${(validator.triggerTypes || []).join(", ")}`;
    }
    return null;
  }
}
PipelineConfigValidator.registerValidator("imageProviderBeforeType", new ImageProviderBeforeTypeValidator());

class StageOrTriggerBeforeTypeValidator {
  constructor() {
    this.pipelineCache = new Map();
  }
  validate(pipeline, stage, validator, _config) {
    const stageTypes = validator.getStageTypes ? validator.getStageTypes() : validator.stageTypes || [validator.stageType];
    const stagesToTest = PipelineConfigService.getAllUpstreamDependencies(pipeline, stage);
    stagesToTest.push(...pipeline.triggers);
    const parentTriggersToCheck = validator.checkParentTriggers ? this.addPipelineTriggers(pipeline, stagesToTest) : [];
    return $q.all(parentTriggersToCheck).then(() => {
      if (stagesToTest.every((test) => !stageTypes.includes(test.type))) {
        return validator.getMessage ? validator.getMessage() : validator.message;
      }
      return null;
    });
  }
  addTriggers(pipelines, pipelineIdToFind, stagesToTest) {
    const match = pipelines.find((p) => p.id === pipelineIdToFind);
    if (match) {
      stagesToTest.push(...match.triggers);
    }
  }
  addExternalTriggers(trigger, stagesToTest, deferred) {
    PipelineConfigService.getPipelinesForApplication(trigger.application).then((pipelines) => {
      this.pipelineCache.set(trigger.application, pipelines);
      this.addTriggers(pipelines, trigger.pipeline, stagesToTest);
      deferred.resolve();
    });
  }
  addPipelineTriggers(pipeline, stagesToTest) {
    const pipelineTriggers = pipeline.triggers.filter((t) => t.type === "pipeline");
    const parentTriggersToCheck = [];
    pipelineTriggers.forEach((trigger) => {
      const deferred = $q.defer();
      if (this.pipelineCache.has(trigger.application)) {
        this.addTriggers(this.pipelineCache.get(trigger.application), trigger.pipeline, stagesToTest);
      } else {
        this.addExternalTriggers(trigger, stagesToTest, deferred);
        parentTriggersToCheck.push(deferred.promise);
      }
    });
    return parentTriggersToCheck;
  }
}
PipelineConfigValidator.registerValidator("stageOrTriggerBeforeType", new StageOrTriggerBeforeTypeValidator());

const buildUpstreamHasFlagValidator = (flag, name) => {
  PipelineConfigValidator.registerValidator(name, {
    validate: (pipeline, stage, validator, _config) => {
      const providingStages = Registry.pipeline.getStageTypes().filter((x) => x[flag]);
      const providingTriggers = Registry.pipeline.getTriggerTypes().filter((x) => x[flag]);
      const defaultProviders = providingStages.concat(providingTriggers);
      const genericUpstreamValidator = new StageOrTriggerBeforeTypeValidator();
      const repositoryProviders = validator.getProviders ? validator.getProviders() : defaultProviders;
      const stageTypes = uniq(map$1(repositoryProviders, "key"));
      const labels = uniq(map$1(repositoryProviders, "label"));
      const message = validator.getMessage(labels);
      const downstreamValidatorConfig = {
        type: "stageOrTriggerBeforeType",
        checkParentTriggers: validator.checkParentTriggers,
        stageTypes,
        message
      };
      return genericUpstreamValidator.validate(pipeline, stage, downstreamValidatorConfig, _config);
    }
  });
};

buildUpstreamHasFlagValidator("providesRepositoryInformation", "repositoryInformationProvided");

class RequiredFieldValidator extends BaseRequiredFieldValidator {
  passesValidation(pipeline, stage, validationConfig) {
    return this.fieldIsValid(pipeline, stage, validationConfig.fieldName);
  }
  validationMessage(validationConfig, config) {
    const fieldLabel = this.printableFieldLabel(validationConfig);
    return validationConfig.message || `<strong>${fieldLabel}</strong> is a required field for ${config.label} stages.`;
  }
}
PipelineConfigValidator.registerValidator("requiredField", new RequiredFieldValidator());

class ServiceAccountAccessValidator {
  validate(_pipeline, stage, validator, _config) {
    if (SETTINGS.feature.fiatEnabled) {
      return ServiceAccountReader.getServiceAccounts().then((serviceAccounts) => {
        if (stage.runAsUser && !serviceAccounts.includes(stage.runAsUser)) {
          return validator.message;
        } else {
          return null;
        }
      });
    } else {
      return null;
    }
  }
}
PipelineConfigValidator.registerValidator("serviceAccountAccess", new ServiceAccountAccessValidator());

class StageBeforeTypeValidator {
  validate(pipeline, stage, validator, _config) {
    if (pipeline.strategy === true && stage.type === "deploy") {
      return null;
    }
    const stageTypes = validator.stageTypes || [validator.stageType];
    const stagesToTest = PipelineConfigService.getAllUpstreamDependencies(pipeline, stage);
    if (stagesToTest.every((test) => !stageTypes.includes(test.type))) {
      return validator.message;
    }
    return null;
  }
}
PipelineConfigValidator.registerValidator("stageBeforeType", new StageBeforeTypeValidator());

class TargetImpedanceValidator {
  validate(pipeline, stage, validator, _config) {
    const stagesToTest = PipelineConfigService.getAllUpstreamDependencies(pipeline, stage);
    const regions = stage["regions"] || [];
    let allRegionsFound = true;
    regions.forEach((region) => {
      let regionFound = false;
      stagesToTest.forEach((toTest) => {
        if (toTest.type === "deploy" && toTest["clusters"] && toTest["clusters"].length) {
          toTest["clusters"].forEach((cluster) => {
            const clusterName = NameUtils.getClusterName(cluster.application, cluster.stack, cluster.freeFormDetails);
            if (clusterName === stage["cluster"] && cluster.account === stage["credentials"] && cluster.availabilityZones && cluster.availabilityZones.hasOwnProperty(region)) {
              regionFound = true;
            }
          });
        } else if (toTest.type === "cloneServerGroup" && NameUtils.getClusterName(toTest["application"], toTest["stack"], toTest["freeFormDetails"]) === stage["cluster"] && toTest["region"] === region) {
          regionFound = true;
        }
      });
      if (!regionFound) {
        allRegionsFound = false;
      }
    });
    if (!allRegionsFound) {
      return validator.message;
    }
    return null;
  }
}
PipelineConfigValidator.registerValidator("targetImpedance", new TargetImpedanceValidator());

buildUpstreamHasFlagValidator("providesVersionForBake", "upstreamVersionProvided");

var css_248z$B = ".stage-choice .ui-select-highlight {\n  text-decoration: underline;\n}\n.stage-choice-heading {\n  display: flex;\n}\n.stage-choice-heading strong {\n  flex: 1 1 auto;\n}\n.stage-choice-heading .available-providers {\n  flex: 1 1 auto;\n  text-align: right;\n}\npipeline-configurer {\n  margin-top: 15px;\n  display: block;\n  background-color: transparent;\n}\npipeline-configurer .band {\n  margin: 0;\n}\npipeline-configurer .pipeline-config-heading {\n  margin-left: -15px;\n  margin-right: -15px;\n  border: 1px solid var(--color-alto);\n  background-color: var(--color-white);\n  margin-bottom: 15px;\n}\npipeline-configurer .pipeline-config-heading .config-heading-row {\n  padding: 10px;\n  display: flex;\n  border-bottom: 1px solid var(--color-alto);\n}\npipeline-configurer .pipeline-config-heading .config-heading-row h3 {\n  margin: 0;\n  display: inline-block;\n  flex: 1 1 auto;\n}\npipeline-configurer .pipeline-config-heading .config-heading-row .config-heading-actions {\n  flex: 1 1 auto;\n  display: inline-block;\n  text-align: right;\n}\npipeline-configurer .pipeline-config-heading .config-heading-body {\n  padding: 15px;\n}\npipeline-configurer .pipeline-config-heading .config-heading-body .add-new {\n  margin-bottom: 0;\n}\npipeline-configurer pipeline-config-view {\n  display: block;\n  margin-left: -15px;\n  margin-right: -15px;\n  padding-bottom: 60px;\n}\npipeline-configurer pipeline-config-view h4 {\n  font-weight: 600;\n}\npipeline-configurer pipeline-config-view .glyphicon.glyphicon-resize-vertical {\n  padding-top: 3px;\n}\npipeline-configurer pipeline-config-view .condensed-actions a.btn-link {\n  padding: 0;\n}\npipeline-configurer .pipeline-stage-config-heading {\n  margin-bottom: 15px;\n  padding: 10px 0 0 10px;\n}\npipeline-configurer .pipeline-stage-config-heading h4 {\n  margin: 0;\n  font-weight: 600;\n}\npipeline-configurer .pipeline-stage-config-heading .select2-container-multi {\n  box-shadow: none;\n}\npipeline-configurer .pipeline-stage-config-heading .select2-container-multi .select2-choices {\n  background-color: transparent;\n}\npipeline-configurer .pipeline-stage-config-heading p {\n  margin-bottom: 0;\n}\npipeline-configurer .stage-details {\n  background-color: var(--color-white);\n}\npipeline-configurer .pipeline-actions,\npipeline-configurer .create-action,\npipeline-configurer .permalink {\n  display: inline-block;\n}\npipeline-configurer .permalink {\n  margin-right: 30px;\n  font-size: 80%;\n  line-height: 30px;\n}\ntriggers .add-new,\n.triggers .add-new {\n  margin: 0;\n}\ntriggers h4,\n.triggers h4 {\n  font-weight: 600;\n  margin-top: 25px;\n  margin-bottom: 10px;\n}\ntriggers trigger,\n.triggers trigger,\ntriggers expected-artifact,\n.triggers expected-artifact,\ntriggers .trigger-config,\n.triggers .trigger-config {\n  display: block;\n  padding: 10px 20px;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-cirrus);\n  margin-bottom: 15px;\n}\n.expected-artifact {\n  display: block;\n  padding: 10px 20px;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-cirrus);\n  margin-bottom: 15px;\n}\n.config-section {\n  padding: 0;\n  display: inline-block;\n}\n.config-section:last-child {\n  border-right-width: 0;\n}\n.config-section a,\n.config-section h4 {\n  display: inline-block;\n  padding-left: 15px;\n}\n.config-section .add-new {\n  margin: 0;\n  padding: 7px;\n}\n.config-section a {\n  padding: 5px 15px;\n}\n.config-section h4 {\n  background-color: transparent;\n  padding-right: 5px;\n  vertical-align: middle;\n  height: 32px;\n  line-height: 32px;\n}\n.panel-pipeline-phase {\n  margin-bottom: 15px;\n}\n.panel-pipeline-phase.no-border {\n  border-width: 0;\n}\n.panel-pipeline-phase .select2-result-label h5 {\n  margin: 5px 0 0 0;\n}\n.pipeline-graph-container {\n  position: relative;\n  overflow-x: hidden;\n}\n.pipeline-graph-container::before,\n.pipeline-graph-container::after {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 12px;\n  content: ' ';\n  z-index: 2;\n}\n.pipeline-graph-container::before {\n  left: 0;\n  box-shadow: inset 5px 0 7px var(--color-white);\n}\n.pipeline-graph-container::after {\n  right: 0;\n  box-shadow: inset -5px 0 7px var(--color-white);\n}\nparameter,\n.parameter-config {\n  display: block;\n  background-color: var(--color-white);\n  margin-bottom: 10px;\n  border: 1px solid var(--color-cirrus);\n}\nparameter .name-field,\n.parameter-config .name-field {\n  padding-bottom: 10px;\n  margin: 10px 0;\n  border-bottom: 1px solid var(--color-alto);\n}\nparameter .name-field .sm-label-right,\n.parameter-config .name-field .sm-label-right {\n  margin-left: -8px;\n}\nparameter .name-field .glyphicon-resize-vertical,\n.parameter-config .name-field .glyphicon-resize-vertical {\n  padding-top: 7px;\n}\n.templated-pipeline-item {\n  pointer-events: none;\n  opacity: 0.75;\n}\n.templated-pipeline-item__status {\n  pointer-events: auto;\n}\n";
styleInject(css_248z$B);

const CORE_PIPELINE_CONFIG_PIPELINECONFIG_MODULE = "spinnaker.core.pipeline.config";
module(CORE_PIPELINE_CONFIG_PIPELINECONFIG_MODULE, [
  CREATE_PIPELINE_COMPONENT,
  PIPELINE_GRAPH_COMPONENT,
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_BASEPROVIDERSTAGE_BASEPROVIDERSTAGE,
  TRIGGERS,
  CORE_PIPELINE_CONFIG_PARAMETERS_PIPELINE_MODULE,
  CORE_PIPELINE_CONFIG_PIPELINECONFIG_CONTROLLER,
  CORE_PIPELINE_CONFIG_PIPELINECONFIGVIEW,
  CORE_PIPELINE_CONFIG_PIPELINECONFIGURER,
  TARGET_SELECT_COMPONENT,
  CORE_PIPELINE_CONFIG_HEALTH_STAGEPLATFORMHEALTHOVERRIDE_DIRECTIVE
]);

const CORE_PIPELINE_CONFIG_PRECONDITIONS_MODAL_EDITPRECONDITION_CONTROLLER_MODAL = "spinnaker.core.pipeline.config.preconditions.modal.controller";
angular.module(CORE_PIPELINE_CONFIG_PRECONDITIONS_MODAL_EDITPRECONDITION_CONTROLLER_MODAL, []).controller("EditPreconditionController", [
  "$scope",
  "$uibModalInstance",
  "precondition",
  "strategy",
  "application",
  "upstreamStages",
  function($scope, $uibModalInstance, precondition, strategy, application, upstreamStages) {
    const vm = this;
    vm.strategy = strategy;
    vm.application = application;
    vm.precondition = angular.copy(precondition);
    vm.upstreamStages = upstreamStages;
    vm.submit = function() {
      $uibModalInstance.close(vm.precondition);
    };
    return vm;
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/modal/editPrecondition.html", `<div modal-page>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Edit Precondition</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="editPreconditionForm">
    <div class="modal-body">
      <precondition-selector
        precondition="editPrecondition.precondition"
        strategy="editPrecondition.strategy"
        application="editPrecondition.application"
        upstream-stages="editPrecondition.upstreamStages"
      ></precondition-selector>
    </div>
    <div class="modal-footer">
      <div ng-show="editApp.submitting">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <button
        type="submit"
        class="btn btn-primary"
        data-purpose="submit"
        ng-click="editPrecondition.submit()"
        ng-disabled="editPreconditionForm.$invalid"
      >
        <span class="far fa-check-circle"></span> Update
      </button>
    </div>
  </form>
</div>
`);
}]);

const CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITION_DETAILS_FILTER = "spinnaker.core.pipeline.config.preconditions.details.filter";
module(CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITION_DETAILS_FILTER, []).filter("preconditionType", function() {
  return function(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
  };
});

var css_248z$A = "td.precondition-details {\n  word-break: break-all;\n}\nth.precondition-details {\n  width: 70%;\n}\n";
styleInject(css_248z$A);

const CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONLIST_DIRECTIVE = "spinnaker.core.pipeline.config.preconditions.preconditionList";
module(CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONLIST_DIRECTIVE, []).directive("preconditionList", function() {
  return {
    restrict: "E",
    scope: {
      preconditions: "=",
      parent: "=",
      strategy: "=",
      application: "=",
      upstreamStages: "="
    },
    templateUrl: "core/src/pipeline/config/preconditions/preconditionList.directive.html",
    controller: "PreconditionListCtrl",
    controllerAs: "preconditionListCtrl"
  };
}).controller("PreconditionListCtrl", [
  "$scope",
  "$uibModal",
  function($scope, $uibModal) {
    const vm = this;
    vm.editPrecondition = function(precondition, strategy) {
      const modalInstance = $uibModal.open({
        templateUrl: "core/src/pipeline/config/preconditions/modal/editPrecondition.html",
        controller: "EditPreconditionController",
        controllerAs: "editPrecondition",
        resolve: {
          precondition: function() {
            return precondition;
          },
          strategy: function() {
            return strategy;
          },
          application: function() {
            return $scope.application;
          },
          upstreamStages: function() {
            return $scope.upstreamStages;
          }
        }
      });
      modalInstance.result.then(function(newPrecondition) {
        if (!precondition) {
          $scope.preconditions.push(newPrecondition);
        } else {
          $scope.preconditions[$scope.preconditions.indexOf(precondition)] = newPrecondition;
        }
        vm.isPreconditionsDirty = true;
      }).catch(() => {
      });
    };
    vm.addPrecondition = function(strategy) {
      if ($scope.parent && !$scope.parent.preconditions) {
        $scope.parent.preconditions = [];
      }
      vm.editPrecondition(void 0, strategy);
    };
    vm.removePrecondition = function(precondition) {
      $scope.preconditions = $scope.preconditions.filter(function(el) {
        return el !== precondition;
      });
      vm.isPreconditionsDirty = true;
    };
    vm.renderContext = function(precondition) {
      let renderedContext = "";
      forEach(precondition.context, function(value, key) {
        renderedContext += "<strong>" + key + ": </strong>" + value + "<br/>";
      });
      return renderedContext;
    };
    return vm;
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/preconditionList.directive.html", `<div class="form-horizontal">
  <stage-config-field label="Preconditions">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th>Type</th>
          <th class="precondition-details">Details</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="precondition in preconditions">
          <td>{{precondition.type|preconditionType}}</td>
          <td class="precondition-details">
            <div ng-repeat="(key, val) in precondition.context"><strong>{{key | robotToHuman}}: </strong> {{val}}</div>
            <strong>Fail Pipeline: </strong> {{precondition.failPipeline}}
          </td>
          <td>
            <a
              class="btn btn-xs btn-link"
              href
              ng-click="preconditionListCtrl.editPrecondition(precondition, strategy)"
            >
              <span class="glyphicon glyphicon-edit" uib-tooltip="Edit"></span
            ></a>
            <a
              class="btn btn-xs btn-link pad-left"
              href
              ng-click="preconditionListCtrl.removePrecondition(precondition)"
            >
              <span class="glyphicon glyphicon-trash" uib-tooltip="Remove"></span
            ></a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="7">
            <button class="btn btn-block add-new" ng-click="preconditionListCtrl.addPrecondition(strategy)">
              <span class="glyphicon glyphicon-plus-sign"></span> Add Precondition
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </stage-config-field>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/modal/editPrecondition.html", `<div modal-page>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Edit Precondition</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="editPreconditionForm">
    <div class="modal-body">
      <precondition-selector
        precondition="editPrecondition.precondition"
        strategy="editPrecondition.strategy"
        application="editPrecondition.application"
        upstream-stages="editPrecondition.upstreamStages"
      ></precondition-selector>
    </div>
    <div class="modal-footer">
      <div ng-show="editApp.submitting">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <button
        type="submit"
        class="btn btn-primary"
        data-purpose="submit"
        ng-click="editPrecondition.submit()"
        ng-disabled="editPreconditionForm.$invalid"
      >
        <span class="far fa-check-circle"></span> Update
      </button>
    </div>
  </form>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/preconditionList.directive.html", `<div class="form-horizontal">
  <stage-config-field label="Preconditions">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th>Type</th>
          <th class="precondition-details">Details</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="precondition in preconditions">
          <td>{{precondition.type|preconditionType}}</td>
          <td class="precondition-details">
            <div ng-repeat="(key, val) in precondition.context"><strong>{{key | robotToHuman}}: </strong> {{val}}</div>
            <strong>Fail Pipeline: </strong> {{precondition.failPipeline}}
          </td>
          <td>
            <a
              class="btn btn-xs btn-link"
              href
              ng-click="preconditionListCtrl.editPrecondition(precondition, strategy)"
            >
              <span class="glyphicon glyphicon-edit" uib-tooltip="Edit"></span
            ></a>
            <a
              class="btn btn-xs btn-link pad-left"
              href
              ng-click="preconditionListCtrl.removePrecondition(precondition)"
            >
              <span class="glyphicon glyphicon-trash" uib-tooltip="Remove"></span
            ></a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="7">
            <button class="btn btn-block add-new" ng-click="preconditionListCtrl.addPrecondition(strategy)">
              <span class="glyphicon glyphicon-plus-sign"></span> Add Precondition
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </stage-config-field>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/modal/editPrecondition.html", `<div modal-page>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Edit Precondition</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="editPreconditionForm">
    <div class="modal-body">
      <precondition-selector
        precondition="editPrecondition.precondition"
        strategy="editPrecondition.strategy"
        application="editPrecondition.application"
        upstream-stages="editPrecondition.upstreamStages"
      ></precondition-selector>
    </div>
    <div class="modal-footer">
      <div ng-show="editApp.submitting">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <button
        type="submit"
        class="btn btn-primary"
        data-purpose="submit"
        ng-click="editPrecondition.submit()"
        ng-disabled="editPreconditionForm.$invalid"
      >
        <span class="far fa-check-circle"></span> Update
      </button>
    </div>
  </form>
</div>
`);
}]);

const CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONTYPECONFIG_PROVIDER = "spinnaker.core.pipeline.config.preconditions.config";
angular.module(CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONTYPECONFIG_PROVIDER, []).provider("preconditionTypeConfig", function() {
  const preconditionTypes = [];
  function registerPreconditionType(config) {
    preconditionTypes.push(config);
  }
  function listPreconditionTypes() {
    return angular.copy(preconditionTypes);
  }
  this.registerPreconditionType = registerPreconditionType;
  this.$get = function() {
    return {
      listPreconditionTypes
    };
  };
});

const CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONTYPE_SERVICE = "spinnaker.core.pipeline.config.preconditions.service";
module(CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONTYPE_SERVICE, [
  CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONTYPECONFIG_PROVIDER
]).factory("preconditionTypeService", [
  "preconditionTypeConfig",
  function(preconditionTypeConfig) {
    function listPreconditionTypes() {
      return preconditionTypeConfig.listPreconditionTypes();
    }
    function getPreconditionType(key) {
      return find(preconditionTypeConfig.listPreconditionTypes(), { key });
    }
    return {
      listPreconditionTypes,
      getPreconditionType
    };
  }
]);

const CORE_PIPELINE_CONFIG_PRECONDITIONS_SELECTOR_PRECONDITIONSELECTOR_DIRECTIVE = "spinnaker.core.pipeline.config.preconditions.selector";
module(CORE_PIPELINE_CONFIG_PRECONDITIONS_SELECTOR_PRECONDITIONSELECTOR_DIRECTIVE, []).directive("preconditionSelector", function() {
  return {
    restrict: "E",
    scope: {
      precondition: "=",
      level: "=",
      strategy: "=",
      application: "=",
      upstreamStages: "="
    },
    templateUrl: "core/src/pipeline/config/preconditions/selector/preconditionSelector.html",
    controller: "PreconditionSelectorCtrl",
    controllerAs: "preconditionCtrl"
  };
}).controller("PreconditionSelectorCtrl", [
  "$scope",
  "preconditionTypeService",
  function($scope, preconditionTypeService) {
    AccountService.listAccounts().then((accounts) => {
      $scope.accounts = accounts;
      setClusterList();
    });
    $scope.preconditionTypes = preconditionTypeService.listPreconditionTypes();
    $scope.regions = [];
    $scope.precondition = $scope.precondition || { failPipeline: true };
    $scope.precondition.context = $scope.precondition.context || {};
    if (!$scope.precondition.type && $scope.preconditionTypes && $scope.preconditionTypes.length) {
      $scope.precondition.type = $scope.preconditionTypes[0].key;
    }
    this.clearContext = function() {
      $scope.precondition.context = null;
    };
    this.setContext = function(context) {
      $scope.$applyAsync(() => {
        $scope.precondition.context = context;
      });
    };
    this.getPreconditionContextTemplateUrl = function() {
      const preconditionConfig = preconditionTypeService.getPreconditionType($scope.precondition.type);
      return preconditionConfig ? preconditionConfig.contextTemplateUrl : "";
    };
    this.clusterChanged = function(clusterName) {
      const clusterFilter = AppListExtractor.monikerClusterNameFilter(clusterName);
      const moniker = first$1(AppListExtractor.getMonikers([$scope.application], clusterFilter));
      if (!isNil(moniker)) {
        moniker.sequence = void 0;
      }
      $scope.precondition.context.moniker = moniker;
    };
    const setClusterList = () => {
      const clusterFilter = AppListExtractor.clusterFilterForCredentialsAndRegion($scope.precondition.context.credentials, $scope.precondition.context.regions);
      $scope.clusterList = AppListExtractor.getClusters([$scope.application], clusterFilter);
    };
    this.resetSelectedCluster = () => {
      $scope.precondition.context.cluster = void 0;
      $scope.precondition.context.moniker = void 0;
      setClusterList();
    };
    this.accountUpdated = function() {
      if (!$scope.precondition.context.credentials) {
        return;
      }
      const accountFilter = (cluster) => cluster ? cluster.account === $scope.precondition.context.credentials : true;
      $scope.regions = AppListExtractor.getRegions([$scope.application], accountFilter);
      const providerFilter = (account) => account.name === $scope.precondition.context.credentials;
      const accountsArray = $scope.accounts;
      if (accountsArray !== null && accountsArray !== void 0) {
        const account = accountsArray.find(providerFilter);
        if (account !== null && account !== void 0) {
          $scope.precondition.cloudProvider = account.type;
        }
      }
    };
    this.reset = () => {
      this.accountUpdated();
      this.resetSelectedCluster();
    };
    this.accountUpdated();
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/selector/preconditionSelector.html", `<div class="form-group row">
  <div class="col-sm-3 sm-label-right" id="type">Check</div>
  <div class="col-sm-9">
    <select
      class="input-sm"
      ng-options="t.key as t.label for t in preconditionTypes"
      ng-model="precondition.type"
      ng-change="preconditionCtrl.clearContext()"
    ></select>
  </div>
</div>
<div ng-include="preconditionCtrl.getPreconditionContextTemplateUrl()"></div>
`);
}]);

const CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONS_MODULE = "spinnaker.core.pipeline.config.preconditions";
module(CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONS_MODULE, [
  CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONTYPECONFIG_PROVIDER,
  CORE_PIPELINE_CONFIG_PRECONDITIONS_SELECTOR_PRECONDITIONSELECTOR_DIRECTIVE,
  CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONLIST_DIRECTIVE,
  CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONTYPE_SERVICE,
  CORE_PIPELINE_CONFIG_PRECONDITIONS_MODAL_EDITPRECONDITION_CONTROLLER_MODAL,
  CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITION_DETAILS_FILTER
]);

const CORE_PIPELINE_CONFIG_PRECONDITIONS_TYPES_CLUSTERSIZE_CLUSTERSIZE_PRECONDITION_TYPE_MODULE = "spinnaker.core.pipeline.config.preconditions.types.clusterSize";
module(CORE_PIPELINE_CONFIG_PRECONDITIONS_TYPES_CLUSTERSIZE_CLUSTERSIZE_PRECONDITION_TYPE_MODULE, []).config([
  "preconditionTypeConfigProvider",
  function(preconditionTypeConfigProvider) {
    preconditionTypeConfigProvider.registerPreconditionType({
      label: "Cluster Size",
      key: "clusterSize",
      contextTemplateUrl: "core/src/pipeline/config/preconditions/types/clusterSize/additionalFields.html"
    });
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/types/clusterSize/additionalFields.html", `<ng-form name="clusterSizeForm">
  <div ng-if="!strategy">
    <div class="form-group row">
      <div class="col-sm-3 sm-label-right">Account</div>
      <div class="col-sm-9">
        <account-select-field
          component="precondition.context"
          field="credentials"
          accounts="accounts"
          provider="'aws'"
          on-change="preconditionCtrl.reset()"
          required
        >
        </account-select-field>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-3 sm-label-right">Regions</div>
      <div class="col-sm-9">
        <p ng-if="!precondition.context.credentials" class="form-control-static">(Select an Account)</p>
        <checklist
          items="regions"
          model="precondition.context.regions"
          inline="true"
          on-change="preconditionCtrl.resetSelectedCluster()"
          include-select-all-button="false"
        >
        </checklist>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-3 sm-label-right">Cluster</div>
      <div class="col-sm-9">
        <cluster-selector
          clusters="clusterList"
          model="precondition.context.cluster"
          on-change="preconditionCtrl.clusterChanged(clusterName)"
        >
        </cluster-selector>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-3 sm-label-right">
      Expected Size
      <help-field key="pipeline.config.checkPreconditions.expectedSize"></help-field>
    </div>
    <div class="col-sm-1">
      <select
        class="input-sm"
        ng-options="c for c in ['==', '<', '<=', '>=', '>']"
        ng-model="precondition.context.comparison"
      ></select>
    </div>
    <div class="col-sm-3">
      <input
        type="number"
        min="0"
        name="expected"
        class="form-control input-sm"
        ng-model="precondition.context.expected"
        required
      />
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-3 sm-label-right">
      Fail Pipeline
      <help-field key="pipeline.config.checkPreconditions.failPipeline"></help-field>
    </div>
    <div class="col-sm-9">
      <input type="checkbox" ng-model="precondition.failPipeline" />
    </div>
  </div>
</ng-form>
`);
}]);

const CORE_PIPELINE_CONFIG_PRECONDITIONS_TYPES_EXPRESSION_EXPRESSION_PRECONDITION_TYPE_MODULE = "spinnaker.core.pipeline.config.preconditions.types.expression";
module(CORE_PIPELINE_CONFIG_PRECONDITIONS_TYPES_EXPRESSION_EXPRESSION_PRECONDITION_TYPE_MODULE, []).config([
  "preconditionTypeConfigProvider",
  function(preconditionTypeConfigProvider) {
    preconditionTypeConfigProvider.registerPreconditionType({
      label: "Expression",
      key: "expression",
      contextTemplateUrl: "core/src/pipeline/config/preconditions/types/expression/additionalFields.html"
    });
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/types/expression/additionalFields.html", `<ng-form name="expressionForm">
  <div class="form-group row">
    <div class="col-sm-3 sm-label-right">
      Expression <help-field key="pipeline.config.checkPreconditions.expression"></help-field>
    </div>
    <div class="col-sm-9">
      <textarea ng-model="precondition.context.expression" rows="4" class="form-control input-sm" required> </textarea>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-3 sm-label-right">
      Fail Pipeline <help-field key="pipeline.config.checkPreconditions.failPipeline"></help-field>
    </div>
    <div class="col-sm-9">
      <input type="checkbox" ng-model="precondition.failPipeline" />
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-3 sm-label-right">
      Failure Message <help-field key="pipeline.config.checkPreconditions.failureMessage"></help-field>
    </div>
    <div class="col-sm-9">
      <textarea ng-model="precondition.context.failureMessage" rows="4" class="form-control input-sm"> </textarea>
    </div>
  </div>
</ng-form>
`);
}]);

const STATUS_OPTIONS = [
  {
    label: "Not Started",
    value: "NOT_STARTED"
  },
  {
    label: "Running",
    value: "RUNNING"
  },
  {
    label: "Paused",
    value: "PAUSED"
  },
  {
    label: "Suspended",
    value: "SUSPENDED"
  },
  {
    label: "Succeeded",
    value: "SUCCEEDED"
  },
  {
    label: "Failed Continue",
    value: "FAILED_CONTINUE"
  },
  {
    label: "Terminal",
    value: "TERMINAL"
  },
  {
    label: "Canceled",
    value: "CANCELED"
  },
  {
    label: "Redirect",
    value: "REDIRECT"
  },
  {
    label: "Stopped",
    value: "STOPPED"
  },
  {
    label: "Skipped",
    value: "SKIPPED"
  },
  {
    label: "Buffered",
    value: "BUFFERED"
  }
];

function StageStatusPreconditionConfig({
  preconditionContext,
  upstreamStages,
  updatePreconditionContext
}) {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group row"
  }, /* @__PURE__ */ React__default.createElement(FormField, {
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      clearable: false,
      options: upstreamStages.map((stage) => ({ value: stage.name, label: stage.name }))
    }),
    label: "Stage",
    onChange: (e) => updatePreconditionContext({
      ...preconditionContext,
      stageName: e.target.value
    }),
    validate: (stageName) => {
      if (!stageName) {
        return "Please select a stage";
      }
      return null;
    },
    value: get(preconditionContext, "stageName", null)
  }), /* @__PURE__ */ React__default.createElement(FormField, {
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      clearable: false,
      options: STATUS_OPTIONS
    }),
    label: "Status",
    onChange: (e) => updatePreconditionContext({
      ...preconditionContext,
      stageStatus: e.target.value
    }),
    validate: (stageStatus) => {
      if (!stageStatus) {
        return "Please select a status";
      }
      return null;
    },
    value: get(preconditionContext, "stageStatus", null)
  }));
}
const STAGE_STATUS_PRECONDITION_CONFIG = "spinnaker.core.stageStatusPreconditionSelector";
module(STAGE_STATUS_PRECONDITION_CONFIG, []).component("stageStatusPreconditionConfig", react2angular(withErrorBoundary(StageStatusPreconditionConfig, "stageStatusPreconditionConfig"), [
  "preconditionContext",
  "upstreamStages",
  "updatePreconditionContext"
]));

const STAGE_STATUS_PRECONDITION = "spinnaker.core.pipeline.config.preconditions.types.stageStatus";
module(STAGE_STATUS_PRECONDITION, [STAGE_STATUS_PRECONDITION_CONFIG]).config([
  "preconditionTypeConfigProvider",
  function(preconditionTypeConfigProvider) {
    preconditionTypeConfigProvider.registerPreconditionType({
      label: "Stage Status",
      key: "stageStatus",
      contextTemplateUrl: "core/src/pipeline/config/preconditions/types/stageStatus/additionalFields.html"
    });
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/preconditions/types/stageStatus/additionalFields.html", `<stage-status-precondition-config
  precondition-context="precondition.context"
  upstream-stages="upstreamStages"
  update-precondition-context="preconditionCtrl.setContext"
/>
`);
}]);

class ApplySourceServerGroupCapacityDetails extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = { parentDeployStage: find(props.execution.stages, (stage) => stage.id === props.stage.parentStageId) };
  }
  render() {
    const { stage, current, name } = this.props;
    const { parentDeployStage } = this.state;
    const snapshot = get(parentDeployStage, "context.sourceServerGroupCapacitySnapshot", {});
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("dl", {
      className: "dl-narrow dl-horizontal"
    }, /* @__PURE__ */ React__default.createElement("dt", null, "Server Group"), stage.context.serverGroupName && /* @__PURE__ */ React__default.createElement("dd", null, stage.context.serverGroupName), !stage.context.serverGroupName && /* @__PURE__ */ React__default.createElement("dd", null, "Unknown"), /* @__PURE__ */ React__default.createElement("dt", null, "Min"), /* @__PURE__ */ React__default.createElement("dd", null, snapshot.min), /* @__PURE__ */ React__default.createElement("dt", null, "Desired"), /* @__PURE__ */ React__default.createElement("dd", null, snapshot.desired), /* @__PURE__ */ React__default.createElement("dt", null, "Max"), /* @__PURE__ */ React__default.createElement("dd", null, snapshot.max)))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: stage.failureMessage
    }));
  }
}
ApplySourceServerGroupCapacityDetails.title = "capacitySnapshot";

const APPLY_SOURCE_SERVER_GROUP_CAPACITY_STAGE = "spinnaker.core.pipeline.stage.applySourceServerGroupCapacityStage";
module(APPLY_SOURCE_SERVER_GROUP_CAPACITY_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    synthetic: true,
    key: "applySourceServerGroupCapacity",
    executionDetailsSections: [ApplySourceServerGroupCapacityDetails, ExecutionDetailsTasks]
  });
});

class AwsCodeBuildExecutionDetails extends React__default.Component {
  render() {
    const { current, name, stage } = this.props;
    const status = get(stage, "context.buildInfo.status");
    const arn = get(stage, "context.buildInfo.arn");
    const buildUrl = get(stage, "context.buildInfo.buildUrl");
    const cwLogs = get(stage, "context.buildInfo.logs.deepLink");
    const s3Logs = get(stage, "context.buildInfo.logs.s3DeepLink");
    const hasS3Logs = s3Logs && status !== "IN_PROGRESS" && status !== "FAULT";
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, status && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Status:")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, status)), arn && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Build ARN:")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, arn)), buildUrl && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Build Link:")), /* @__PURE__ */ React__default.createElement("a", {
      className: "col-md-6",
      href: buildUrl,
      target: "_blank"
    }, "link")), cwLogs && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "CloudWatch Logs:")), /* @__PURE__ */ React__default.createElement("a", {
      className: "col-md-6",
      href: cwLogs,
      target: "_blank"
    }, "link")), hasS3Logs && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "S3 Logs:")), /* @__PURE__ */ React__default.createElement("a", {
      className: "col-md-6",
      href: s3Logs,
      target: "_blank"
    }, "link")))), stage.failureMessage && /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: stage.failureMessage
    }));
  }
}
AwsCodeBuildExecutionDetails.title = "awsCodeBuildStatus";

class EditAwsCodeBuildSecondarySourceVersionModal extends React__default.Component {
  constructor() {
    super(...arguments);
    this.formikRef = React__default.createRef();
    this.submit = (values) => {
      this.props.closeModal(values);
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "modal-md" };
    return ReactModal.show(EditAwsCodeBuildSecondarySourceVersionModal, props, modalProps);
  }
  render() {
    const { dismissModal, secondarySourcesVersionOverride } = this.props;
    return /* @__PURE__ */ React__default.createElement(SpinFormik, {
      ref: this.formikRef,
      initialValues: secondarySourcesVersionOverride,
      onSubmit: this.submit,
      render: (formik) => /* @__PURE__ */ React__default.createElement(Form, {
        className: `form-horizontal`
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: dismissModal
      }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Edit Source")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "pipeline.config.codebuild.sourceIdentifier"
        }),
        label: "Source Identifier",
        name: "sourceIdentifier",
        input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...inputProps
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "pipeline.config.codebuild.sourceVersion"
        }),
        label: "Source Version",
        name: "sourceVersion",
        input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...inputProps
        })
      })), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        onClick: dismissModal,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !formik.isValid,
        isFormSubmit: true,
        submitting: false,
        label: "Update"
      })))
    });
  }
}

const SOURCE_TYPES = ["BITBUCKET", "CODECOMMIT", "GITHUB", "GITHUB_ENTERPRISE", "S3"];
const EXCLUDED_ARTIFACT_TYPES$1 = excludeAllTypesExcept(ArtifactTypePatterns.S3_OBJECT, ArtifactTypePatterns.GIT_REPO);

class EditAwsCodeBuildSourceModal extends React__default.Component {
  constructor() {
    super(...arguments);
    this.formikRef = React__default.createRef();
    this.submit = (values) => {
      this.props.closeModal(values);
    };
    this.onExpectedArtifactSelected = (formik, artifact) => {
      formik.setFieldValue("sourceArtifact.artifactId", artifact.id);
      formik.setFieldValue("sourceArtifact.artifactDisplayName", artifact.displayName);
      formik.setFieldValue("sourceArtifact.artifactType", artifact.matchArtifact && artifact.matchArtifact.type || artifact.defaultArtifact && artifact.defaultArtifact.type);
      formik.setFieldValue("sourceArtifact.artifact", null);
    };
    this.onArtifactEdited = (formik, artifact) => {
      formik.setFieldValue("sourceArtifact.artifact", artifact);
      formik.setFieldValue("sourceArtifact.artifactDisplayName", artifact.reference);
      formik.setFieldValue("sourceArtifact.artifactType", artifact.type);
      formik.setFieldValue("sourceArtifact.artifactId", null);
    };
    this.validate = (values) => {
      const formValidator = new FormValidator(values);
      formValidator.field("sourceArtifact", "Source Artifact").required().withValidators((value) => !value && "Artifact is required");
      return formValidator.validateForm();
    };
  }
  static show(props) {
    const modalProps = { dialogClassName: "modal-md" };
    return ReactModal.show(EditAwsCodeBuildSourceModal, props, modalProps);
  }
  render() {
    const { dismissModal, source, stage, pipeline } = this.props;
    return /* @__PURE__ */ React__default.createElement(SpinFormik, {
      ref: this.formikRef,
      initialValues: source,
      onSubmit: this.submit,
      validate: this.validate,
      render: (formik) => /* @__PURE__ */ React__default.createElement(Form, {
        className: `form-horizontal`
      }, /* @__PURE__ */ React__default.createElement(ModalClose, {
        dismiss: dismissModal
      }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Edit Source")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-3 sm-label-right"
      }, "Source Artifact"), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-9 sm-control-field"
      }, /* @__PURE__ */ React__default.createElement(StageArtifactSelector, {
        artifact: get(formik, "values.sourceArtifact.artifact"),
        excludedArtifactTypePatterns: EXCLUDED_ARTIFACT_TYPES$1,
        expectedArtifactId: get(formik, "values.sourceArtifact.artifactId"),
        onArtifactEdited: (artifact) => this.onArtifactEdited(formik, artifact),
        onExpectedArtifactSelected: (artifact) => this.onExpectedArtifactSelected(formik, artifact),
        pipeline,
        stage
      }))), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "pipeline.config.codebuild.sourceType"
        }),
        label: "Source Type",
        name: "type",
        input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
          ...inputProps,
          clearable: true,
          stringOptions: SOURCE_TYPES
        })
      }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
        help: /* @__PURE__ */ React__default.createElement(HelpField, {
          id: "pipeline.config.codebuild.sourceVersion"
        }),
        label: "Source Version",
        name: "sourceVersion",
        input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...inputProps
        })
      })), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-default",
        onClick: dismissModal,
        type: "button"
      }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
        isDisabled: !formik.isValid,
        isFormSubmit: true,
        submitting: false,
        label: "Update"
      })))
    });
  }
}

class AwsCodeBuildSecondarySourcesVersionList extends React__default.Component {
  constructor(props) {
    super(props);
    this.addSecondarySourcesVersion = () => {
      this.editSecondarySourceVersion();
    };
    this.editSecondarySourceVersion = (source, index) => {
      const { value, stage, pipeline } = this.props;
      const secondarySourcesVersionOverride = source != null ? source : {};
      EditAwsCodeBuildSecondarySourceVersionModal.show({ secondarySourcesVersionOverride, stage, pipeline }).then((newSecondarySource) => {
        const secondarySource = value || [];
        const secondarySourceCopy = [...secondarySource];
        if (!source) {
          secondarySourceCopy.push(newSecondarySource);
        } else {
          secondarySourceCopy[index] = newSecondarySource;
        }
        this.onChange(secondarySourceCopy);
      }).catch(() => {
      });
    };
    this.removeSource = (index) => {
      const secondarySourcesVersionOverride = [...this.props.value];
      secondarySourcesVersionOverride.splice(index, 1);
      this.onChange(secondarySourcesVersionOverride);
    };
  }
  onChange(value) {
    this.props.onChange(createFakeReactSyntheticEvent({ value, name: this.props.name }));
  }
  render() {
    const value = this.props.value;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, "Source Identifier"), /* @__PURE__ */ React__default.createElement("th", null, "Source Version"), /* @__PURE__ */ React__default.createElement("th", null, "Actions"))), /* @__PURE__ */ React__default.createElement("tbody", null, value && value.map((secondarySourceVersion, i) => {
      return /* @__PURE__ */ React__default.createElement("tr", {
        key: i,
        className: classNames({ "templated-pipeline-item": false })
      }, /* @__PURE__ */ React__default.createElement("td", null, secondarySourceVersion.sourceIdentifier), /* @__PURE__ */ React__default.createElement("td", null, secondarySourceVersion.sourceVersion), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-xs btn-link",
        onClick: () => this.editSecondarySourceVersion(secondarySourceVersion, i)
      }, "Edit"), /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-xs btn-link",
        onClick: () => this.removeSource(i)
      }, "Remove")));
    })), /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
      colSpan: 7
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-block add-new",
      onClick: () => this.addSecondarySourcesVersion()
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add Secondary Sources Version Override")))))));
  }
}
class AwsCodeBuildSourceList extends React__default.Component {
  constructor() {
    super(...arguments);
    this.addSource = () => {
      this.editSource();
    };
    this.editSource = (buildSource, index) => {
      const { sources, updateSources, stage, pipeline } = this.props;
      const source = buildSource != null ? buildSource : {};
      EditAwsCodeBuildSourceModal.show({ source, stage, pipeline }).then((newSource) => {
        const sourceCopy = sources || [];
        if (!source) {
          updateSources(sourceCopy.concat(newSource));
        } else {
          const update = [...sourceCopy];
          update[index] = newSource;
          updateSources(update);
        }
      }).catch(() => {
      });
    };
    this.removeSource = (index) => {
      const sources = [...this.props.sources];
      sources.splice(index, 1);
      this.props.updateSources(sources);
    };
  }
  render() {
    const { sources } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("table", {
      className: "table table-condensed"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, "Artifact"), /* @__PURE__ */ React__default.createElement("th", null, "Type"), /* @__PURE__ */ React__default.createElement("th", null, "Source Version"), /* @__PURE__ */ React__default.createElement("th", null, "Actions"))), /* @__PURE__ */ React__default.createElement("tbody", null, sources && sources.map((source, i) => {
      return /* @__PURE__ */ React__default.createElement("tr", {
        key: i,
        className: classNames({ "templated-pipeline-item": false })
      }, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(ArtifactIcon, {
        type: source.sourceArtifact.artifactType,
        width: "16",
        height: "16"
      }), source.sourceArtifact.artifactDisplayName), /* @__PURE__ */ React__default.createElement("td", null, source.type), /* @__PURE__ */ React__default.createElement("td", null, source.sourceVersion), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-xs btn-link",
        onClick: () => this.editSource(source, i)
      }, "Edit"), /* @__PURE__ */ React__default.createElement("button", {
        className: "btn btn-xs btn-link",
        onClick: () => this.removeSource(i)
      }, "Remove")));
    })), /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
      colSpan: 7
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-block add-new",
      onClick: () => this.addSource()
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add Secondary Source")))))));
  }
}

function AwsCodeBuildStageForm(props) {
  const stage = props.formik.values;
  const { result: fetchAccountsResult, status: fetchAccountsStatus } = useData(() => IgorService.getCodeBuildAccounts(), [], []);
  const { result: fetchProjectsResult, status: fetchProjectsStatus } = useData(() => IgorService.getCodeBuildProjects(stage.account), [], [stage.account]);
  const onFieldChange = (fieldName, fieldValue) => {
    props.formik.setFieldValue(fieldName, fieldValue);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement("h4", null, "Basic Settings"), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Account",
    name: "account",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      clearable: false,
      isLoading: fetchAccountsStatus === "PENDING",
      stringOptions: fetchAccountsResult
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Project Name",
    name: "projectName",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      clearable: false,
      isLoading: fetchProjectsStatus === "PENDING",
      stringOptions: fetchProjectsResult
    })
  }), /* @__PURE__ */ React__default.createElement("h4", null, "Source Configuration"), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.codebuild.source"
    }),
    label: "Source",
    name: "source.sourceOverride",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      ...inputProps,
      text: "Override source to Spinnaker artifact"
    })
  }), get(stage, "source.sourceOverride") === true && /* @__PURE__ */ React__default.createElement(FormikFormField, {
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.codebuild.sourceType"
    }),
    label: "Source Type",
    name: "source.sourceType",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      clearable: true,
      stringOptions: SOURCE_TYPES
    })
  }), get(stage, "source.sourceOverride") === true && /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Source Artifact Override",
    name: "source",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(StageArtifactSelector, {
      ...inputProps,
      artifact: get(stage, "source.sourceArtifact.artifact"),
      excludedArtifactTypePatterns: EXCLUDED_ARTIFACT_TYPES$1,
      expectedArtifactId: get(stage, "source.sourceArtifact.artifactId"),
      onArtifactEdited: (artifact) => {
        onFieldChange("source.sourceArtifact.artifact", artifact);
        onFieldChange("source.sourceArtifact.artifactId", null);
      },
      onExpectedArtifactSelected: (artifact) => {
        onFieldChange("source.sourceArtifact.artifact", null);
        onFieldChange("source.sourceArtifact.artifactId", artifact.id);
      },
      pipeline: props.pipeline,
      stage
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.codebuild.sourceVersion"
    }),
    label: "Source Version",
    name: "source.sourceVersion",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...inputProps
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.codebuild.buildspec"
    }),
    label: "Buildspec",
    name: "source.buildspec",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(YamlEditor, {
      ...inputProps,
      value: get(stage, "source.buildspec"),
      onChange: (buildspec, _) => onFieldChange("source.buildspec", buildspec)
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.codebuild.secondarySources"
    }),
    label: "Secondary Sources",
    name: "secondarySources",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(AwsCodeBuildSourceList, {
      ...inputProps,
      sources: get(stage, "secondarySources"),
      updateSources: (sources) => onFieldChange("secondarySources", sources),
      stage,
      pipeline: props.pipeline
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.codebuild.secondarySourcesVersionOverride"
    }),
    label: "Secondary Sources Version",
    name: "secondarySourcesVersionOverride",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(AwsCodeBuildSecondarySourcesVersionList, {
      ...inputProps,
      stage,
      pipeline: props.pipeline
    })
  }), /* @__PURE__ */ React__default.createElement("h4", null, "Environment Configuration"), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.codebuild.image"
    }),
    label: "Image",
    name: "image",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...inputProps
    })
  }), /* @__PURE__ */ React__default.createElement("h4", null, "Advanced Configuration"), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.codebuild.envVar"
    }),
    label: "Environment Variables",
    name: "environmentVariables",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(MapEditorInput, {
      ...inputProps,
      addButtonLabel: "Add environment variable"
    })
  }));
}

const validate$2 = (stage) => {
  const formValidator = new FormValidator(stage);
  formValidator.field("account", "Account").required();
  formValidator.field("projectName", "Project Name").required().withValidators(projectNameValidator);
  return formValidator.validateForm();
};
const projectNameValidator = (value, label) => {
  const projectName = value.match(/^[A-Za-z0-9][A-Za-z0-9-_]{1,149}$/);
  const err = projectName ? void 0 : `Invalid project name.  ${label} must match regular expression: [A-Za-z0-9][A-Za-z0-9-_]{1,149}`;
  return err;
};

function AwsCodeBuildStageConfig({ application, pipeline, stage, updateStage }) {
  const stageWithDefaults = React__default.useMemo(() => {
    return {
      application: application.name,
      ...cloneDeep(stage)
    };
  }, []);
  return /* @__PURE__ */ React__default.createElement(FormikStageConfig, {
    application,
    onChange: updateStage,
    pipeline,
    stage: stageWithDefaults,
    validate: validate$2,
    render: (props) => /* @__PURE__ */ React__default.createElement(AwsCodeBuildStageForm, {
      ...props
    })
  });
}

Registry.pipeline.registerStage({
  label: "AWS CodeBuild",
  description: "Trigger a build in AWS CodeBuild",
  key: "awsCodeBuild",
  producesArtifacts: true,
  component: AwsCodeBuildStageConfig,
  validateFn: validate$2,
  executionDetailsSections: [AwsCodeBuildExecutionDetails, ExecutionDetailsTasks]
});

class ManualExecutionBake extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleChange = (event) => {
      const target = event.target;
      const checked = target.checked;
      this.props.updateCommand("trigger.rebake", checked);
      this.setState({});
    };
  }
  render() {
    const force = get(this.props.command, "trigger.rebake", false);
    return /* @__PURE__ */ React__default.createElement(FormField, {
      label: "Rebake",
      onChange: this.handleChange,
      value: force,
      help: /* @__PURE__ */ React__default.createElement(HelpField, {
        id: "execution.forceRebake"
      }),
      input: (props) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
        ...props,
        text: "Force Rebake"
      })
    });
  }
}

const CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE_TRANSFORMER = "spinnaker.core.pipeline.stage.bake.transformer";
module(CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE_TRANSFORMER, []).service("bakeStageTransformer", function() {
  function propagatePreviouslyBakedFlag(execution) {
    execution.stages.forEach(function(stage) {
      if (stage.type === "bake" && stage.context) {
        const childBakeStages = execution.stages.filter((test) => test.type === "bake" && test.parentStageId === stage.id);
        if (childBakeStages.length) {
          stage.context.allPreviouslyBaked = childBakeStages.every((child) => child.context.previouslyBaked);
          stage.context.somePreviouslyBaked = !stage.context.allPreviouslyBaked && childBakeStages.some((child) => child.context.previouslyBaked);
        }
      }
    });
  }
  this.transform = function(application, execution) {
    propagatePreviouslyBakedFlag(execution);
  };
});

const CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE = "spinnaker.core.pipeline.stage.bakeStage";
module(CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE, [CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE_TRANSFORMER]).config(function() {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    label: "Bake",
    description: "Bakes an image",
    key: "bake",
    restartable: true,
    manualExecutionComponent: ManualExecutionBake
  });
}).run([
  "bakeStageTransformer",
  function(bakeStageTransformer) {
    Registry.pipeline.registerTransformer(bakeStageTransformer);
  }
]);

class BakeStageChooseManagedImageController {
  $onChanges() {
  }
  getManagedImageDescription(managedImageOption) {
    return (managedImageOption == null ? void 0 : managedImageOption.name) || "";
  }
  getManagedImageDetailedDescription(managedImageOption) {
    if (managedImageOption == null ? void 0 : managedImageOption.osType) {
      return `${managedImageOption.name} (${managedImageOption.osType})`;
    }
    return `${managedImageOption.name}`;
  }
  getManagedImageDisabled(managedImageOption) {
    const disabledImages = SETTINGS.disabledImages || [];
    return disabledImages.includes(managedImageOption.id);
  }
}
const bakeStageChooseManagedImageComponent = {
  bindings: {
    managedImageOptions: "<",
    model: "=",
    onChange: "="
  },
  controller: BakeStageChooseManagedImageController,
  templateUrl: "core/src/pipeline/config/stages/bake/bakeStageChooseManagedImage.component.html"
};
const PIPELINE_BAKE_STAGE_CHOOSE_MANAGED_IMAGE = "spinnaker.core.pipeline.bake.chooseManagedImage.component";
module(PIPELINE_BAKE_STAGE_CHOOSE_MANAGED_IMAGE, []).component("bakeStageChooseManagedImage", bakeStageChooseManagedImageComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/bake/bakeStageChooseManagedImage.component.html", `<ui-select ng-model="$ctrl.model" on-select="$ctrl.onChange()" class="form-control input-sm">
  <ui-select-match placeholder="Select a Managed Image">
    <span ng-bind-html="$ctrl.getManagedImageDescription($select.selected)"></span>
  </ui-select-match>
  <ui-select-choices
    repeat="managedImageOption.id as managedImageOption in $ctrl.managedImageOptions | filter: $select.search"
    ui-disable-choice="$ctrl.getManagedImageDisabled(managedImageOption)"
  >
    <strong ng-bind-html="$ctrl.getManagedImageDescription(managedImageOption)"></strong>
    <div ng-bind-html="$ctrl.getManagedImageDetailedDescription(managedImageOption)"></div>
  </ui-select-choices>
</ui-select>
`);
}]);

class BakeStageChooseOSController {
  constructor() {
    this.showRadioButtons = false;
  }
  $onChanges() {
    this.showRadioButtons = this.baseOsOptions && this.baseOsOptions.length <= 2;
  }
  getBaseOsDescription(baseOsOption) {
    const baseOsName = (baseOsOption == null ? void 0 : baseOsOption.displayName) || (baseOsOption == null ? void 0 : baseOsOption.id) || "";
    if (baseOsOption == null ? void 0 : baseOsOption.shortDescription) {
      return `${baseOsName} (${baseOsOption.shortDescription})`;
    }
    return baseOsName;
  }
  getBaseOsDetailedDescription(baseOsOption) {
    return baseOsOption.detailedDescription + (baseOsOption.isImageFamily ? " (family)" : "");
  }
  getBaseOsDisabled(baseOsOption) {
    const disabledImages = SETTINGS.disabledImages || [];
    return disabledImages.includes(baseOsOption.id);
  }
}
const bakeStageChooseOsComponent = {
  bindings: {
    baseOsOptions: "<",
    model: "=",
    onChange: "="
  },
  controller: BakeStageChooseOSController,
  templateUrl: "core/src/pipeline/config/stages/bake/bakeStageChooseOs.component.html"
};
const PIPELINE_BAKE_STAGE_CHOOSE_OS = "spinnaker.core.pipeline.bake.chooseOS.component";
module(PIPELINE_BAKE_STAGE_CHOOSE_OS, []).component("bakeStageChooseOs", bakeStageChooseOsComponent);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/bake/bakeStageChooseOs.component.html", `<ui-select
  ng-if="!$ctrl.showRadioButtons"
  ng-model="$ctrl.model"
  on-select="$ctrl.onChange()"
  class="form-control input-sm"
>
  <ui-select-match placeholder="Select a base OS">
    <span ng-bind-html="$ctrl.getBaseOsDescription($select.selected)"></span>
  </ui-select-match>
  <ui-select-choices
    repeat="baseOsOption.id as baseOsOption in $ctrl.baseOsOptions | filter: $select.search"
    ui-disable-choice="$ctrl.getBaseOsDisabled(baseOsOption)"
  >
    <strong ng-bind-html="$ctrl.getBaseOsDescription(baseOsOption)"></strong>
    <div ng-bind-html="$ctrl.getBaseOsDetailedDescription(baseOsOption)"></div>
  </ui-select-choices>
</ui-select>

<label ng-if="$ctrl.showRadioButtons" class="radio-inline" ng-repeat="baseOsOption in $ctrl.baseOsOptions">
  <input type="radio" ng-model="$ctrl.model" ng-value="baseOsOption.id" />
  {{ $ctrl.getBaseOsDescription(baseOsOption) }}
  <help-field content="{{ $ctrl.getBaseOsDetailedDescription(baseOsOption) }}"></help-field>
</label>
`);
}]);

const CORE_PIPELINE_CONFIG_STAGES_BAKE_MODAL_ADDEXTENDEDATTRIBUTE_CONTROLLER_MODAL = "spinnaker.core.pipeline.stage.bake.modal.addExtendedAttribute";
angular.module(CORE_PIPELINE_CONFIG_STAGES_BAKE_MODAL_ADDEXTENDEDATTRIBUTE_CONTROLLER_MODAL, []).controller("bakeStageAddExtendedAttributeController", [
  "$scope",
  "$uibModalInstance",
  "extendedAttribute",
  function($scope, $uibModalInstance, extendedAttribute) {
    const vm = this;
    $scope.extendedAttribute = angular.copy(extendedAttribute);
    vm.submit = function() {
      $uibModalInstance.close($scope.extendedAttribute);
    };
    return vm;
  }
]);

const CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE_MODULE = "spinnaker.core.pipeline.stage.bake";
module(CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE,
  CORE_PIPELINE_CONFIG_STAGES_BAKE_MODAL_ADDEXTENDEDATTRIBUTE_CONTROLLER_MODAL,
  PIPELINE_BAKE_STAGE_CHOOSE_OS,
  PIPELINE_BAKE_STAGE_CHOOSE_MANAGED_IMAGE
]);

var ManifestRenderers;
(function(ManifestRenderers2) {
  ManifestRenderers2["HELM2"] = "HELM2";
  ManifestRenderers2["HELM3"] = "HELM3";
  ManifestRenderers2["HELMFILE"] = "HELMFILE";
  ManifestRenderers2["KUSTOMIZE"] = "KUSTOMIZE";
  ManifestRenderers2["KUSTOMIZE4"] = "KUSTOMIZE4";
})(ManifestRenderers || (ManifestRenderers = {}));
const HELM_RENDERERS = [ManifestRenderers.HELM2, ManifestRenderers.HELM3];
const HELMFILE_RENDERER = ManifestRenderers.HELMFILE;
const KUSTOMIZE_RENDERERS = [
  ManifestRenderers.KUSTOMIZE,
  ManifestRenderers.KUSTOMIZE4
];

const _BakeHelmConfigForm = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.onTemplateArtifactEdited = (artifact, index) => {
      this.props.formik.setFieldValue(`inputArtifacts[${index}].id`, null);
      this.props.formik.setFieldValue(`inputArtifacts[${index}].artifact`, artifact);
      this.props.formik.setFieldValue(`inputArtifacts[${index}].account`, artifact.artifactAccount);
    };
    this.onTemplateArtifactSelected = (artifact, index) => {
      this.props.formik.setFieldValue(`inputArtifacts[${index}].id`, artifact.id);
      this.props.formik.setFieldValue(`inputArtifacts[${index}].artifact`, null);
      if (artifact.matchArtifact) {
        this.props.formik.setFieldValue(`inputArtifacts[${index}].account`, artifact.matchArtifact.artifactAccount);
      } else {
        this.props.formik.setFieldValue(`inputArtifacts[${index}].account`, null);
      }
    };
    this.addInputArtifact = () => {
      const stage = this.props.formik.values;
      const newInputArtifacts = [
        ...stage.inputArtifacts,
        {
          account: "",
          id: ""
        }
      ];
      this.props.formik.setFieldValue("inputArtifacts", newInputArtifacts);
    };
    this.removeInputArtifact = (index) => {
      const stage = this.props.formik.values;
      const newInputArtifacts = [...stage.inputArtifacts];
      newInputArtifacts.splice(index, 1);
      this.props.formik.setFieldValue("inputArtifacts", newInputArtifacts);
    };
    this.getInputArtifact = (stage, index) => {
      if (!stage.inputArtifacts || stage.inputArtifacts.length === 0) {
        return {
          account: "",
          id: ""
        };
      } else {
        return stage.inputArtifacts[index];
      }
    };
    this.outputNameChange = (outputName) => {
      const stage = this.props.formik.values;
      const expectedArtifacts = stage.expectedArtifacts;
      if (expectedArtifacts && expectedArtifacts.length === 1 && expectedArtifacts[0].matchArtifact && expectedArtifacts[0].matchArtifact.type === "embedded/base64") {
        this.props.formik.setFieldValue("expectedArtifacts", [
          {
            ...expectedArtifacts[0],
            matchArtifact: {
              ...expectedArtifacts[0].matchArtifact,
              name: outputName
            }
          }
        ]);
      }
    };
    this.overrideChanged = (overrides) => {
      this.props.formik.setFieldValue("overrides", overrides);
    };
    this.state = { gitRepoArtifactAccountNames: [] };
  }
  componentDidMount() {
    const stage = this.props.formik.values;
    if (stage.inputArtifacts && stage.inputArtifacts.length === 0) {
      this.props.formik.setFieldValue("inputArtifacts", [
        {
          account: "",
          id: ""
        }
      ]);
    }
    const expectedArtifact = this.getInputArtifact(stage, 0);
    if (expectedArtifact.id && !expectedArtifact.account) {
      const availableArtifacts = ExpectedArtifactService.getExpectedArtifactsAvailableToStage(stage, this.props.pipeline);
      const expectedMatchedArtifact = availableArtifacts.find((a) => a.id === expectedArtifact.id);
      if (expectedMatchedArtifact && expectedMatchedArtifact.matchArtifact) {
        this.props.formik.setFieldValue(`inputArtifacts[0].account`, expectedMatchedArtifact.matchArtifact.artifactAccount);
      }
    }
    AccountService.getArtifactAccounts().then((artifactAccounts) => {
      this.setState({
        gitRepoArtifactAccountNames: artifactAccounts.filter((account) => account.types.some((type) => ArtifactTypePatterns.GIT_REPO.test(type))).map((account) => account.name)
      });
    });
  }
  render() {
    const stage = this.props.formik.values;
    const enableApiVersions = SETTINGS.feature.helmApiVersions;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("h4", null, "Helm Options"), enableApiVersions && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 3,
      label: "ApiVersions"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      onChange: (e) => {
        this.props.formik.setFieldValue("apiVersions", e.target.value);
      },
      value: stage.apiVersions
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 3,
      label: "KubeVersion"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      onChange: (e) => {
        this.props.formik.setFieldValue("kubeVersion", e.target.value);
      },
      value: stage.kubeVersion
    }))), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 3,
      label: "Name"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      onChange: (e) => {
        this.props.formik.setFieldValue("outputName", e.target.value);
        this.outputNameChange(e.target.value);
      },
      value: stage.outputName
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 3,
      label: "Namespace"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      onChange: (e) => {
        this.props.formik.setFieldValue("namespace", e.target.value);
      },
      value: stage.namespace
    })), /* @__PURE__ */ React__default.createElement("h4", null, "Template Artifact"), /* @__PURE__ */ React__default.createElement(StageArtifactSelectorDelegate, {
      artifact: this.getInputArtifact(stage, 0).artifact,
      excludedArtifactTypePatterns: _BakeHelmConfigForm.excludedArtifactTypes,
      expectedArtifactId: this.getInputArtifact(stage, 0).id,
      helpKey: "pipeline.config.bake.manifest.expectedArtifact",
      label: "Expected Artifact",
      onArtifactEdited: (artifact) => {
        this.onTemplateArtifactEdited(artifact, 0);
      },
      onExpectedArtifactSelected: (artifact) => this.onTemplateArtifactSelected(artifact, 0),
      pipeline: this.props.pipeline,
      stage
    }), this.state.gitRepoArtifactAccountNames.includes(this.getInputArtifact(stage, 0).account) && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Helm Chart File Path",
      helpKey: "pipeline.config.bake.manifest.helm.chartFilePath"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      onChange: (e) => {
        this.props.formik.setFieldValue("helmChartFilePath", e.target.value);
      },
      value: stage.helmChartFilePath
    })), /* @__PURE__ */ React__default.createElement("h4", null, "Overrides"), stage.inputArtifacts && stage.inputArtifacts.length > 1 && /* @__PURE__ */ React__default.createElement("div", {
      className: "row form-group"
    }, stage.inputArtifacts.slice(1).map((a, index) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        key: index
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-offset-1 col-md-9"
      }, /* @__PURE__ */ React__default.createElement(StageArtifactSelectorDelegate, {
        artifact: a.artifact,
        excludedArtifactTypePatterns: [],
        expectedArtifactId: a.id,
        label: "Expected Artifact",
        onArtifactEdited: (artifact) => {
          this.onTemplateArtifactEdited(artifact, index + 1);
        },
        onExpectedArtifactSelected: (artifact) => this.onTemplateArtifactSelected(artifact, index + 1),
        pipeline: this.props.pipeline,
        stage
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-1"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "form-control-static"
      }, /* @__PURE__ */ React__default.createElement("button", {
        onClick: () => this.removeInputArtifact(index + 1)
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-trash"
      }), /* @__PURE__ */ React__default.createElement("span", {
        className: "sr-only"
      }, "Remove field")))));
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 8,
      label: ""
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-block btn-sm add-new",
      onClick: () => this.addInputArtifact()
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), "Add value artifact")), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 6,
      label: "Overrides"
    }, stage.overrides && /* @__PURE__ */ React__default.createElement(MapEditor, {
      addButtonLabel: "Add override",
      model: stage.overrides,
      allowEmpty: true,
      onChange: (o) => this.overrideChanged(o)
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 6,
      helpKey: "pipeline.config.bake.manifest.helm.rawOverrides",
      label: "Raw Overrides"
    }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      value: stage.rawOverrides,
      text: "",
      onChange: () => this.props.formik.setFieldValue("rawOverrides", !stage.rawOverrides)
    })), stage.templateRenderer === ManifestRenderers.HELM3 && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 6,
      helpKey: "pipeline.config.bake.manifest.helm.includeCRDs",
      label: "Include CRDs"
    }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      value: stage.includeCRDs,
      text: "",
      onChange: () => this.props.formik.setFieldValue("includeCRDs", !stage.includeCRDs)
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 6,
      helpKey: "pipeline.config.bake.manifest.overrideExpressionEvaluation",
      label: "Expression Evaluation"
    }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      value: stage.evaluateOverrideExpressions,
      text: "Evaluate SpEL expressions in overrides at bake time",
      onChange: () => this.props.formik.setFieldValue("evaluateOverrideExpressions", !stage.evaluateOverrideExpressions)
    })));
  }
};
let BakeHelmConfigForm = _BakeHelmConfigForm;
BakeHelmConfigForm.excludedArtifactTypes = excludeAllTypesExcept(ArtifactTypePatterns.BITBUCKET_FILE, ArtifactTypePatterns.CUSTOM_OBJECT, ArtifactTypePatterns.EMBEDDED_BASE64, ArtifactTypePatterns.GCS_OBJECT, ArtifactTypePatterns.GIT_REPO, ArtifactTypePatterns.GITHUB_FILE, ArtifactTypePatterns.GITLAB_FILE, ArtifactTypePatterns.S3_OBJECT, ArtifactTypePatterns.HELM_CHART, ArtifactTypePatterns.HTTP_FILE, ArtifactTypePatterns.ORACLE_OBJECT);

const _BakeHelmfileConfigForm = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.onTemplateArtifactEdited = (artifact, index) => {
      this.props.formik.setFieldValue(`inputArtifacts[${index}].id`, null);
      this.props.formik.setFieldValue(`inputArtifacts[${index}].artifact`, artifact);
      this.props.formik.setFieldValue(`inputArtifacts[${index}].account`, artifact.artifactAccount);
    };
    this.onTemplateArtifactSelected = (artifact, index) => {
      this.props.formik.setFieldValue(`inputArtifacts[${index}].id`, artifact.id);
      this.props.formik.setFieldValue(`inputArtifacts[${index}].artifact`, null);
      if (artifact.matchArtifact) {
        this.props.formik.setFieldValue(`inputArtifacts[${index}].account`, artifact.matchArtifact.artifactAccount);
      } else {
        this.props.formik.setFieldValue(`inputArtifacts[${index}].account`, null);
      }
    };
    this.addInputArtifact = () => {
      const stage = this.props.formik.values;
      const newInputArtifacts = [
        ...stage.inputArtifacts,
        {
          account: "",
          id: ""
        }
      ];
      this.props.formik.setFieldValue("inputArtifacts", newInputArtifacts);
    };
    this.removeInputArtifact = (index) => {
      const stage = this.props.formik.values;
      const newInputArtifacts = [...stage.inputArtifacts];
      newInputArtifacts.splice(index, 1);
      this.props.formik.setFieldValue("inputArtifacts", newInputArtifacts);
    };
    this.getInputArtifact = (stage, index) => {
      if (!stage.inputArtifacts || stage.inputArtifacts.length === 0) {
        return {
          account: "",
          id: ""
        };
      } else {
        return stage.inputArtifacts[index];
      }
    };
    this.outputNameChange = (outputName) => {
      const stage = this.props.formik.values;
      const expectedArtifacts = stage.expectedArtifacts;
      if (expectedArtifacts && expectedArtifacts.length === 1 && expectedArtifacts[0].matchArtifact && expectedArtifacts[0].matchArtifact.type === "embedded/base64") {
        this.props.formik.setFieldValue("expectedArtifacts", [
          {
            ...expectedArtifacts[0],
            matchArtifact: {
              ...expectedArtifacts[0].matchArtifact,
              name: outputName
            }
          }
        ]);
      }
    };
    this.overrideChanged = (overrides) => {
      this.props.formik.setFieldValue("overrides", overrides);
    };
    this.state = { gitRepoArtifactAccountNames: [] };
  }
  componentDidMount() {
    const stage = this.props.formik.values;
    if (stage.inputArtifacts && stage.inputArtifacts.length === 0) {
      this.props.formik.setFieldValue("inputArtifacts", [
        {
          account: "",
          id: ""
        }
      ]);
    }
    const expectedArtifact = this.getInputArtifact(stage, 0);
    if (expectedArtifact.id && !expectedArtifact.account) {
      const availableArtifacts = ExpectedArtifactService.getExpectedArtifactsAvailableToStage(stage, this.props.pipeline);
      const expectedMatchedArtifact = availableArtifacts.find((a) => a.id === expectedArtifact.id);
      if (expectedMatchedArtifact && expectedMatchedArtifact.matchArtifact) {
        this.props.formik.setFieldValue(`inputArtifacts[0].account`, expectedMatchedArtifact.matchArtifact.artifactAccount);
      }
    }
    AccountService.getArtifactAccounts().then((artifactAccounts) => {
      this.setState({
        gitRepoArtifactAccountNames: artifactAccounts.filter((account) => account.types.some((type) => ArtifactTypePatterns.GIT_REPO.test(type))).map((account) => account.name)
      });
    });
  }
  render() {
    const stage = this.props.formik.values;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("h4", null, "Helmfile Options"), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 3,
      label: "Name",
      helpKey: "pipeline.config.bake.manifest.helmfile.name"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      onChange: (e) => {
        this.props.formik.setFieldValue("outputName", e.target.value);
        this.outputNameChange(e.target.value);
      },
      value: stage.outputName
    })), /* @__PURE__ */ React__default.createElement("h4", null, "Template Artifact"), /* @__PURE__ */ React__default.createElement(StageArtifactSelectorDelegate, {
      artifact: this.getInputArtifact(stage, 0).artifact,
      excludedArtifactTypePatterns: _BakeHelmfileConfigForm.excludedArtifactTypes,
      expectedArtifactId: this.getInputArtifact(stage, 0).id,
      helpKey: "pipeline.config.bake.manifest.expectedArtifact",
      label: "Expected Artifact",
      onArtifactEdited: (artifact) => {
        this.onTemplateArtifactEdited(artifact, 0);
      },
      onExpectedArtifactSelected: (artifact) => this.onTemplateArtifactSelected(artifact, 0),
      pipeline: this.props.pipeline,
      stage
    }), this.state.gitRepoArtifactAccountNames.includes(this.getInputArtifact(stage, 0).account) && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Helmfile File Path",
      helpKey: "pipeline.config.bake.manifest.helmfile.filePath"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      onChange: (e) => {
        this.props.formik.setFieldValue("helmfileFilePath", e.target.value);
      },
      value: stage.helmfileFilePath
    })), /* @__PURE__ */ React__default.createElement("h4", null, "Overrides"), stage.inputArtifacts && stage.inputArtifacts.length > 1 && /* @__PURE__ */ React__default.createElement("div", {
      className: "row form-group"
    }, stage.inputArtifacts.slice(1).map((a, index) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        key: index
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-offset-1 col-md-9"
      }, /* @__PURE__ */ React__default.createElement(StageArtifactSelectorDelegate, {
        artifact: a.artifact,
        excludedArtifactTypePatterns: [],
        expectedArtifactId: a.id,
        label: "Expected Artifact",
        onArtifactEdited: (artifact) => {
          this.onTemplateArtifactEdited(artifact, index + 1);
        },
        onExpectedArtifactSelected: (artifact) => this.onTemplateArtifactSelected(artifact, index + 1),
        pipeline: this.props.pipeline,
        stage
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: "col-md-1"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "form-control-static"
      }, /* @__PURE__ */ React__default.createElement("button", {
        onClick: () => this.removeInputArtifact(index + 1)
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-trash"
      }), /* @__PURE__ */ React__default.createElement("span", {
        className: "sr-only"
      }, "Remove field")))));
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 8,
      label: ""
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-block btn-sm add-new",
      onClick: () => this.addInputArtifact()
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), "Add value artifact")), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 6,
      label: "Overrides"
    }, stage.overrides && /* @__PURE__ */ React__default.createElement(MapEditor, {
      addButtonLabel: "Add override",
      model: stage.overrides,
      allowEmpty: true,
      onChange: (o) => this.overrideChanged(o)
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 6,
      helpKey: "pipeline.config.bake.manifest.helm.includeCRDs",
      label: "Include CRDs"
    }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      value: stage.includeCRDs,
      text: "",
      onChange: () => this.props.formik.setFieldValue("includeCRDs", !stage.includeCRDs)
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      fieldColumns: 6,
      helpKey: "pipeline.config.bake.manifest.overrideExpressionEvaluation",
      label: "Expression Evaluation"
    }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      value: stage.evaluateOverrideExpressions,
      text: "Evaluate SpEL expressions in overrides at bake time",
      onChange: () => this.props.formik.setFieldValue("evaluateOverrideExpressions", !stage.evaluateOverrideExpressions)
    })));
  }
};
let BakeHelmfileConfigForm = _BakeHelmfileConfigForm;
BakeHelmfileConfigForm.excludedArtifactTypes = excludeAllTypesExcept(ArtifactTypePatterns.BITBUCKET_FILE, ArtifactTypePatterns.CUSTOM_OBJECT, ArtifactTypePatterns.EMBEDDED_BASE64, ArtifactTypePatterns.GCS_OBJECT, ArtifactTypePatterns.GIT_REPO, ArtifactTypePatterns.GITHUB_FILE, ArtifactTypePatterns.GITLAB_FILE, ArtifactTypePatterns.S3_OBJECT, ArtifactTypePatterns.HELM_CHART, ArtifactTypePatterns.HTTP_FILE, ArtifactTypePatterns.ORACLE_OBJECT);

var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
let BakeKustomizeConfigForm = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.getInputArtifact = () => {
      const stage = this.props.formik.values;
      if (!stage.inputArtifact) {
        return {
          account: "",
          id: ""
        };
      }
      return stage.inputArtifact;
    };
  }
  render() {
    const stage = this.props.formik.values;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-horizontal clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "container-fluid form-horizontal"
    }, /* @__PURE__ */ React__default.createElement("h4", null, "Kustomize Options"), /* @__PURE__ */ React__default.createElement(StageArtifactSelectorDelegate, {
      artifact: this.getInputArtifact().artifact,
      excludedArtifactTypePatterns: excludeAllTypesExcept(ArtifactTypePatterns.GIT_REPO),
      expectedArtifactId: this.getInputArtifact().id,
      helpKey: "pipeline.config.bake.manifest.expectedArtifact",
      label: "Expected Artifact",
      pipeline: this.props.pipeline,
      stage,
      onArtifactEdited: (artifact) => {
        this.props.formik.setFieldValue("inputArtifact.id", null);
        this.props.formik.setFieldValue("inputArtifact.artifact", artifact);
        this.props.formik.setFieldValue("inputArtifact.account", artifact.artifactAccount);
      },
      onExpectedArtifactSelected: (artifact) => {
        this.props.formik.setFieldValue("inputArtifact.id", artifact.id);
        this.props.formik.setFieldValue("inputArtifact.artifact", null);
      }
    }), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Kustomize File",
      helpKey: "pipeline.config.bake.manifest.kustomize.filePath"
    }, /* @__PURE__ */ React__default.createElement(TextInput, {
      onChange: (e) => {
        this.props.formik.setFieldValue("kustomizeFilePath", e.target.value);
      },
      value: stage.kustomizeFilePath
    }))));
  }
};
BakeKustomizeConfigForm = __decorateClass$6([
  Overridable("bakeKustomizeConfigForm")
], BakeKustomizeConfigForm);

function BakeManifestStageForm({ application, formik, pipeline }) {
  const stage = formik.values;
  React__default.useEffect(() => {
    if (!validateProducedArtifacts(stage.expectedArtifacts)) {
      const defaultProducedArtifact = ExpectedArtifactService.createEmptyArtifact();
      defaultProducedArtifact.matchArtifact.type = BASE_64_ARTIFACT_TYPE;
      defaultProducedArtifact.matchArtifact.artifactAccount = BASE_64_ARTIFACT_ACCOUNT;
      defaultProducedArtifact.matchArtifact.customKind = false;
      formik.setFieldValue("expectedArtifacts", [defaultProducedArtifact]);
    }
  }, []);
  React__default.useEffect(() => {
    if (KUSTOMIZE_RENDERERS.includes(stage.templateRenderer) && !isNil(stage.inputArtifacts)) {
      formik.setFieldValue("inputArtifacts", null);
    }
    if (HELM_RENDERERS.includes(stage.templateRenderer) && !isNil(stage.inputArtifact)) {
      formik.setFieldValue("inputArtifact", null);
    }
    if (HELMFILE_RENDERER === stage.templateRenderer && !isNil(stage.inputArtifact)) {
      formik.setFieldValue("inputArtifact", null);
    }
  }, [stage.templateRenderer]);
  const templateRenderers = React__default.useMemo(() => {
    return [...KUSTOMIZE_RENDERERS, ...HELM_RENDERERS, HELMFILE_RENDERER];
  }, []);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "form-horizontal clearfix"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "container-fluid form-horizontal"
  }, /* @__PURE__ */ React__default.createElement("h4", null, "Template Renderer"), /* @__PURE__ */ React__default.createElement(StageConfigField, {
    fieldColumns: 3,
    label: "Render Engine",
    helpKey: "pipeline.config.bake.manifest.templateRenderer"
  }, /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
    clearable: false,
    onChange: (o) => {
      formik.setFieldValue("templateRenderer", o.target.value);
    },
    value: stage.templateRenderer,
    stringOptions: templateRenderers
  })), KUSTOMIZE_RENDERERS.includes(stage.templateRenderer) && /* @__PURE__ */ React__default.createElement(BakeKustomizeConfigForm, {
    pipeline,
    application,
    formik
  }), HELM_RENDERERS.includes(stage.templateRenderer) && /* @__PURE__ */ React__default.createElement(BakeHelmConfigForm, {
    pipeline,
    application,
    formik
  }), HELMFILE_RENDERER === stage.templateRenderer && /* @__PURE__ */ React__default.createElement(BakeHelmfileConfigForm, {
    pipeline,
    application,
    formik
  })));
}
function validateProducedArtifacts(artifacts) {
  var _a, _b;
  return (artifacts == null ? void 0 : artifacts.length) === 1 && ((_b = (_a = artifacts[0]) == null ? void 0 : _a.matchArtifact) == null ? void 0 : _b.type) === BASE_64_ARTIFACT_TYPE;
}

function BakeManifestConfig({ application, pipeline, stage, updateStage }) {
  const stageWithDefaults = React__default.useMemo(() => {
    return {
      inputArtifacts: [],
      overrides: {},
      ...cloneDeep(stage)
    };
  }, []);
  return /* @__PURE__ */ React__default.createElement(FormikStageConfig, {
    application,
    onChange: updateStage,
    pipeline,
    stage: stageWithDefaults,
    validate: validateBakeManifestStage,
    render: (props) => /* @__PURE__ */ React__default.createElement(BakeManifestStageForm, {
      ...props
    })
  });
}
function validateBakeManifestStage(stage) {
  const formValidator = new FormValidator(stage);
  formValidator.field("expectedArtifacts", "Produced artifacts").required().withValidators((artifacts) => {
    if (validateProducedArtifacts(artifacts)) {
      return void 0;
    }
    return "Exactly one expected artifact of type embedded/base64 must be configured in the Produces Artifacts section";
  });
  if (HELM_RENDERERS.includes(stage.templateRenderer)) {
    formValidator.field("outputName", "Name").required();
  }
  if (HELMFILE_RENDERER === stage.templateRenderer) {
    formValidator.field("outputName", "Name").required();
  }
  return formValidator.validateForm();
}

var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
let BakeManifestDetailsTab = class extends React__default.Component {
  render() {
    const { current, name, stage } = this.props;
    const bakedArtifacts = getBakedArtifacts(stage.context);
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: stage.failureMessage
    }), bakedArtifacts.map((artifact, i) => {
      const linkName = bakedArtifacts.length > 1 ? `Baked Manifest ${i} YAML` : "Baked Manifest YAML";
      return artifact.type === ARTIFACT_TYPE_EMBEDDED ? /* @__PURE__ */ React__default.createElement(ManifestYaml, {
        key: i,
        linkName,
        modalTitle: "Baked Manifest",
        manifestText: decodeUnicodeBase64(artifact.reference)
      }) : /* @__PURE__ */ React__default.createElement(ManifestYaml, {
        key: i,
        linkName,
        modalTitle: "Baked Manifest",
        manifestUri: getContentReference(artifact.reference)
      });
    }));
  }
};
BakeManifestDetailsTab.title = "bakedManifest";
BakeManifestDetailsTab = __decorateClass$5([
  Overridable("bakeManifest.bakeManifestDetailsTab")
], BakeManifestDetailsTab);

const HelmEditor = HelmMatch.editCmp;
function ManualExecutionBakeManifest(props) {
  const [overrideArtifact, setOverrideArtifact] = React__default.useState(true);
  const defaultArtifact = React__default.useMemo(() => {
    const expectedHelmArtifacts = (props.command.pipeline.expectedArtifacts || []).filter((artifact) => artifact.matchArtifact.type === HelmMatch.type);
    if (expectedHelmArtifacts.length === 0) {
      return null;
    }
    const helmTriggersConfigured = (props.command.pipeline.triggers || []).filter((trigger) => trigger.type === HELM_TRIGGER_TYPE);
    if (helmTriggersConfigured.length !== 0) {
      return null;
    }
    return {
      ...expectedHelmArtifacts[0].matchArtifact,
      version: null
    };
  }, []);
  React__default.useEffect(() => {
    if (overrideArtifact === false) {
      removeHelmArtifact();
    } else if (defaultArtifact) {
      updateHelmArtifact(defaultArtifact);
    }
  }, [defaultArtifact, overrideArtifact]);
  const helmArtifact = (props.command.extraFields.artifacts || []).find((a) => a.type === HelmMatch.type);
  const updateHelmArtifact = (artifact) => {
    const updatedArtifacts = (props.command.extraFields.artifacts || []).filter((a) => a.type !== HelmMatch.type);
    updatedArtifacts.push(artifact);
    props.updateCommand("extraFields.artifacts", updatedArtifacts);
  };
  const removeHelmArtifact = () => {
    const updatedArtifacts = (props.command.extraFields.artifacts || []).filter((a) => a.type !== HelmMatch.type);
    props.updateCommand("extraFields.artifacts", updatedArtifacts);
  };
  if (!defaultArtifact) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "sm-label-right col-md-4"
  }, "Helm override"), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-8"
  }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    checked: overrideArtifact,
    onChange: (e) => setOverrideArtifact(e.target.checked),
    text: "Override Helm chart artifact"
  }))), overrideArtifact && /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-2"
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10"
  }, /* @__PURE__ */ React__default.createElement(HelmEditor, {
    account: { name: defaultArtifact.artifactAccount, types: [HelmMatch.type] },
    artifact: helmArtifact || defaultArtifact,
    pipeline: props.command.pipeline,
    onChange: updateHelmArtifact
  }))));
}

const BAKE_MANIFEST_STAGE_KEY = "bakeManifest";
Registry.pipeline.registerStage({
  label: "Bake (Manifest)",
  description: "Bake a manifest (or multi-doc manifest set) using a template renderer such as Helm.",
  key: BAKE_MANIFEST_STAGE_KEY,
  component: BakeManifestConfig,
  producesArtifacts: true,
  cloudProvider: "kubernetes",
  executionDetailsSections: [BakeManifestDetailsTab, ExecutionDetailsTasks, ExecutionArtifactTab],
  artifactExtractor: (fields) => ExpectedArtifactService.accumulateArtifacts(["inputArtifacts"])(fields).map((a) => a.id),
  artifactRemover: (stage, artifactId) => {
    var _a, _b;
    ArtifactReferenceService.removeArtifactFromFields(["expectedArtifactId"])(stage, artifactId);
    const artifactDoesNotMatch = (artifact) => artifact.id !== artifactId;
    stage.expectedArtifacts = ((_a = stage.expectedArtifacts) != null ? _a : []).filter(artifactDoesNotMatch);
    stage.inputArtifacts = ((_b = stage.inputArtifacts) != null ? _b : []).filter(artifactDoesNotMatch);
  },
  validateFn: validateBakeManifestStage,
  manualExecutionComponent: ManualExecutionBakeManifest
});

function CheckPreconditionsExecutionDetails(props) {
  const context = get(props.stage, "context.context", {});
  const userFailureMessage = context.failureMessage;
  const failureMessage = props.stage.failureMessage;
  const stageFailureMessage = failureMessage == null ? userFailureMessage : failureMessage;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-horizontal"
  }, Object.keys(context).filter((key) => !["failureMessage"].includes(key) && context[key] !== null).map((key) => /* @__PURE__ */ React__default.createElement("div", {
    key
  }, /* @__PURE__ */ React__default.createElement("dt", null, robotToHuman(key)), /* @__PURE__ */ React__default.createElement("dd", null, isString(context[key]) || isBoolean(context[key]) ? context[key] : JSON.stringify(context[key])))), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("dt", null, "Fail Pipeline"), /* @__PURE__ */ React__default.createElement("dd", null, String(!!props.stage.context.failPipeline)))))), props.stage.status !== "SUCCEEDED" && /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: stageFailureMessage
  }));
}
(function(CheckPreconditionsExecutionDetails2) {
  CheckPreconditionsExecutionDetails2.title = "checkPreconditions";
})(CheckPreconditionsExecutionDetails || (CheckPreconditionsExecutionDetails = {}));

const CHECK_PRECONDITIONS_STAGE = "spinnaker.pipelines.stage.checkPreconditionsStage";
module(CHECK_PRECONDITIONS_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    label: "Check Preconditions",
    description: "Checks for preconditions before continuing",
    key: "checkPreconditions",
    restartable: true,
    controller: "CheckPreconditionsStageCtrl",
    controllerAs: "checkPreconditionsStageCtrl",
    templateUrl: "core/src/pipeline/config/stages/checkPreconditions/checkPreconditionsStage.html",
    executionDetailsSections: [CheckPreconditionsExecutionDetails, ExecutionDetailsTasks],
    strategy: true
  });
}).controller("CheckPreconditionsStageCtrl", [
  "$scope",
  function($scope) {
    $scope.stage.preconditions = $scope.stage.preconditions || [];
    $scope.upstreamStages = PipelineConfigService.getAllUpstreamDependencies($scope.pipeline, $scope.stage);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/checkPreconditions/checkPreconditionsStage.html", `<precondition-list
  preconditions="stage.preconditions"
  strategy="pipeline.strategy"
  application="application"
  upstream-stages="upstreamStages"
></precondition-list>
`);
}]);

const EXECUTION_STEP_DETAILS_COMPONENT = "spinnaker.core.pipeline.config.stages.common.executionStepDetails.component";
module(EXECUTION_STEP_DETAILS_COMPONENT, []).component("executionStepDetails", react2angular(withErrorBoundary(ExecutionStepDetails, "executionStepDetails"), ["item"]));

const STAGE_COMMON_MODULE = "spinnaker.core.pipeline.stage.common";
module(STAGE_COMMON_MODULE, [EXECUTION_STEP_DETAILS_COMPONENT, DISPLAYABLE_TASKS_FILTER]);

const CHECK_PRECONDITIONS_STAGE_MODULE = "spinnaker.pipelines.stage.checkPreconditions";
module(CHECK_PRECONDITIONS_STAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  STAGE_COMMON_MODULE,
  CHECK_PRECONDITIONS_STAGE
]);

class CloneServerGroupExecutionDetails extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = { deployResults: [] };
  }
  addDeployedArtifacts(props) {
    var _a;
    const context = get(props, "stage.context", {});
    const tasks = (_a = context["kato.tasks"]) != null ? _a : [];
    if (tasks.length === 0) {
      return;
    }
    const resultObjects = tasks[0].resultObjects;
    if (!resultObjects || Object.keys(resultObjects).length === 0) {
      return;
    }
    let deployResults = [];
    const deployedArtifacts = find(resultObjects, "serverGroupNames");
    if (deployedArtifacts) {
      const deployedServerGroups = (deployedArtifacts["serverGroupNames"] || []).filter((a) => a.includes(":"));
      deployResults = deployedServerGroups.map((serverGroupNameAndRegion) => {
        var _a2;
        const [region, serverGroupName] = serverGroupNameAndRegion.split(":");
        const result = {
          type: "serverGroups",
          application: context.application,
          serverGroup: serverGroupName,
          account: context.credentials,
          region,
          provider: (_a2 = context.cloudProvider) != null ? _a2 : "aws",
          project: ReactInjector.$stateParams.project
        };
        result.href = UrlBuilder.buildFromMetadata(result);
        return result;
      });
    }
    this.setState({ deployResults });
  }
  componentDidMount() {
    this.addDeployedArtifacts(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.stage !== this.props.stage) {
      this.addDeployedArtifacts(nextProps);
    }
  }
  render() {
    const { deployResults } = this.state;
    const { stage, current, name } = this.props;
    const specifiedCapacity = !stage.context.useSourceCapacity && stage.context.capacity;
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, /* @__PURE__ */ React__default.createElement("dl", {
      className: "dl-narrow dl-horizontal"
    }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
      account: stage.context.credentials
    })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region), /* @__PURE__ */ React__default.createElement("dt", null, "Cluster"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.targetCluster), /* @__PURE__ */ React__default.createElement("dt", null, "Server Group"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.source && stage.context.source.serverGroupName), specifiedCapacity && /* @__PURE__ */ React__default.createElement("dt", null, "Capacity"), specifiedCapacity && /* @__PURE__ */ React__default.createElement("dd", null, "Min: ", stage.context.capacity.min, " / Desired: ", stage.context.capacity.desired, " / Max:", " ", stage.context.capacity.max)))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: stage.failureMessage
    }), deployResults.length > 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "well alert alert-info"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Deployed: "), (deployResults || []).map((result) => /* @__PURE__ */ React__default.createElement(DeployedServerGroup, {
      key: result.href,
      result
    }))))));
  }
}
CloneServerGroupExecutionDetails.title = "cloneServerGroupConfig";
const DeployedServerGroup = (props) => {
  const deployClicked = (event) => {
    event.stopPropagation();
    ClusterState.filterService.overrideFiltersForUrl(props.result);
  };
  return /* @__PURE__ */ React__default.createElement("a", {
    onClick: deployClicked,
    href: props.result.href
  }, props.result.serverGroup);
};

const CLONE_SERVER_GROUP_STAGE = "spinnaker.core.pipeline.stage.cloneServerGroup";
module(CLONE_SERVER_GROUP_STAGE, [CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE, STAGE_COMMON_MODULE]).config(() => {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    key: "cloneServerGroup",
    label: "Clone Server Group",
    executionDetailsSections: [CloneServerGroupExecutionDetails, ExecutionDetailsTasks],
    description: "Clones a server group",
    strategy: false
  });
});

function ConcourseExecutionDetails(props) {
  const {
    stage: { context = {} },
    stage,
    name,
    current
  } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name,
    current
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Build Service"), /* @__PURE__ */ React__default.createElement("dd", null, context.master), /* @__PURE__ */ React__default.createElement("dt", null, "Team"), /* @__PURE__ */ React__default.createElement("dd", null, context.teamName), /* @__PURE__ */ React__default.createElement("dt", null, "Pipeline"), /* @__PURE__ */ React__default.createElement("dd", null, context.pipelineName), /* @__PURE__ */ React__default.createElement("dt", null, "Job"), /* @__PURE__ */ React__default.createElement("dd", null, context.jobName), /* @__PURE__ */ React__default.createElement("dt", null, "Build"), /* @__PURE__ */ React__default.createElement("dd", null, context.buildNumber)), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage,
    message: stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage
  }));
}
(function(ConcourseExecutionDetails2) {
  ConcourseExecutionDetails2.title = "concourseConfig";
})(ConcourseExecutionDetails || (ConcourseExecutionDetails = {}));

class ConcourseStageConfig extends React__default.Component {
  constructor(props) {
    super(props);
    this.onMasterChanged = (option) => {
      const stage = this.getStage();
      if (stage.master === option.value) {
        return;
      }
      this.props.updateStageField({
        master: option.value,
        team: null,
        pipelineName: null,
        resourceName: null
      });
      this.fetchAvailableTeams();
    };
    this.onTeamChanged = (option) => {
      const stage = this.getStage();
      if (stage.teamName === option.value) {
        return;
      }
      this.props.updateStageField({
        teamName: option.value,
        pipelineName: null,
        resourceName: null
      });
      this.fetchAvailablePipelines();
    };
    this.onPipelineChanged = (option) => {
      const stage = this.getStage();
      if (stage.pipelineName === option.value) {
        return;
      }
      this.props.updateStageField({
        pipelineName: option.value,
        resourceName: null
      });
      this.fetchAvailableResourceNames();
    };
    this.onResourceNameChanged = (option) => {
      const stage = this.getStage();
      if (stage.resourceName === option.value) {
        return;
      }
      this.props.updateStageField({ resourceName: option.value });
      this.props.stageFieldUpdated();
    };
    this.fetchAvailableTeams = () => {
      const { master } = this.getStage();
      if (master) {
        ConcourseService.listTeamsForMaster(master).then((teams) => this.setState({ teams }));
      }
    };
    this.fetchAvailablePipelines = () => {
      const { master, teamName } = this.getStage();
      if (master && teamName) {
        ConcourseService.listPipelinesForTeam(master, teamName).then((pipelines) => this.setState({ pipelines }));
      }
    };
    this.fetchAvailableResourceNames = () => {
      const { master, teamName, pipelineName } = this.getStage();
      if (master && teamName && pipelineName) {
        ConcourseService.listResourcesForPipeline(master, teamName, pipelineName).then((resourceNames) => this.setState({ resourceNames }));
      }
    };
    const { master, teamName, pipelineName, resourceName } = props.stage;
    this.state = {
      masters: master ? [master] : [],
      teams: teamName ? [teamName] : [],
      pipelines: pipelineName ? [pipelineName] : [],
      resourceNames: resourceName ? [resourceName] : []
    };
  }
  componentDidMount() {
    IgorService.listMasters(BuildServiceType.Concourse).then((masters) => {
      this.setState({ masters });
    });
    this.fetchAvailableTeams();
    this.fetchAvailablePipelines();
    this.fetchAvailableResourceNames();
  }
  render() {
    const { masters, teams, pipelines, resourceNames } = this.state;
    const { master, teamName, pipelineName, resourceName } = this.getStage();
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Build Service"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      value: master,
      placeholder: "Select a build service...",
      onChange: this.onMasterChanged,
      options: masters.map((name) => ({ label: name, value: name })),
      clearable: false
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Team"
    }, !master && /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "(Select a build service)"), master && /* @__PURE__ */ React__default.createElement(Select, {
      value: teamName,
      placeholder: "Select a team...",
      onChange: this.onTeamChanged,
      options: teams.map((name) => ({ label: name, value: name })),
      clearable: false
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Pipeline"
    }, !teamName && /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "(Select a build service and team)"), teamName && /* @__PURE__ */ React__default.createElement(Select, {
      value: pipelineName,
      placeholder: "Select a pipeline...",
      onChange: this.onPipelineChanged,
      options: pipelines.map((name) => ({ label: name, value: name })),
      clearable: false
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Resource Name"
    }, !pipelineName && /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "(Select a build service, team, and pipeline)"), pipelineName && /* @__PURE__ */ React__default.createElement(Select, {
      value: resourceName,
      placeholder: "Select a resource...",
      onChange: this.onResourceNameChanged,
      options: resourceNames.map((name) => ({ label: name, value: name })),
      clearable: false
    })));
  }
  getStage() {
    return this.props.stage;
  }
}

Registry.pipeline.registerStage({
  label: "Concourse",
  description: "Runs a Concourse job",
  key: "concourse",
  defaults: {
    failOnFailedExpressions: true
  },
  component: ConcourseStageConfig,
  executionDetailsSections: [ConcourseExecutionDetails],
  strategy: true,
  validators: [
    { type: "requiredField", fieldName: "master" },
    { type: "requiredField", fieldName: "teamName", fieldLabel: "Team Name" },
    { type: "requiredField", fieldName: "pipelineName", fieldLabel: "Pipeline Name" },
    { type: "requiredField", fieldName: "resourceName", fieldLabel: "Resource Name" }
  ]
});

class CreateLoadBalancerDetailsCtrl extends BaseExecutionDetailsCtrl {
  constructor($scope, $stateParams, executionDetailsSectionService) {
    super($scope, $stateParams, executionDetailsSectionService);
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.executionDetailsSectionService = executionDetailsSectionService;
    $scope.configSections = ["loadBalancerConfig", "taskStatus"];
  }
  initialized() {
    super.initialized();
    const context = this.$scope.stage.context || {};
    const results = [];
    if (context && context["kato.tasks"] && context["kato.tasks"].length) {
      const resultObjects = context["kato.tasks"][0].resultObjects;
      if (resultObjects && resultObjects.length) {
        const addCreatedArtifacts = (key) => {
          const createdArtifacts = resultObjects;
          if (createdArtifacts) {
            createdArtifacts.forEach((artifact) => {
              forEach(artifact[key], (valueObj, region) => {
                const result = {
                  type: "loadBalancers",
                  application: context.application,
                  name: valueObj.name,
                  region,
                  account: context.account,
                  dnsName: valueObj.dnsName,
                  provider: context.providerType || context.cloudProvider || "aws"
                };
                results.push(result);
              });
            });
          }
        };
        addCreatedArtifacts("loadBalancers");
      }
    }
    this.$scope.createdLoadBalancers = results;
    this.$scope.provider = context.cloudProvider || context.providerType || "aws";
  }
}
CreateLoadBalancerDetailsCtrl.$inject = ["$scope", "$stateParams", "executionDetailsSectionService"];
const CREATE_LOAD_BALANCER_EXECUTION_DETAILS_CTRL = "spinnaker.core.pipeline.stage.createLoadBalancer.executionDetails.controller";
module(CREATE_LOAD_BALANCER_EXECUTION_DETAILS_CTRL, [UIROUTER_ANGULARJS, EXECUTION_DETAILS_SECTION_SERVICE]).controller("createLoadBalancerExecutionDetailsCtrl", CreateLoadBalancerDetailsCtrl);

const CORE_PIPELINE_CONFIG_STAGES_CREATELOADBALANCER_CREATELOADBALANCERSTAGE = "spinnaker.core.pipeline.stage.createLoadBalancerStage";
angular.module(CORE_PIPELINE_CONFIG_STAGES_CREATELOADBALANCER_CREATELOADBALANCERSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    key: "upsertLoadBalancers",
    label: "Create Load Balancers",
    description: "Creates one or more load balancers. If a load balancer exists with the same name, then that will be updated.",
    templateUrl: "core/src/pipeline/config/stages/createLoadBalancer/createLoadBalancerStage.html",
    executionDetailsUrl: "core/src/pipeline/config/stages/createLoadBalancer/createLoadBalancerExecutionDetails.html",
    supportsCustomTimeout: true,
    validators: []
  });
}).controller("createLoadBalancerStageCtrl", [
  "$scope",
  "$uibModal",
  function($scope, $uibModal) {
    function initializeCommand() {
      $scope.stage.loadBalancers = $scope.stage.loadBalancers || [];
    }
    this.addLoadBalancer = function() {
      ProviderSelectionService.selectProvider($scope.application, "loadBalancer").then(function(selectedProvider) {
        const config = CloudProviderRegistry.getValue(selectedProvider, "loadBalancer");
        $uibModal.open({
          templateUrl: config.createLoadBalancerTemplateUrl,
          controller: `${config.createLoadBalancerController} as ctrl`,
          size: "lg",
          resolve: {
            application: () => $scope.application,
            loadBalancer: () => null,
            isNew: () => true,
            forPipelineConfig: () => true
          }
        }).result.then(function(newLoadBalancer) {
          $scope.stage.loadBalancers.push(newLoadBalancer);
        }).catch(() => {
        });
      });
    };
    this.editLoadBalancer = function(loadBalancer, index) {
      ProviderSelectionService.selectProvider($scope.application, "loadBalancer").then(function(selectedProvider) {
        const config = CloudProviderRegistry.getValue(selectedProvider, "loadBalancer");
        $uibModal.open({
          templateUrl: config.createLoadBalancerTemplateUrl,
          controller: `${config.createLoadBalancerController} as ctrl`,
          size: "lg",
          resolve: {
            application: () => $scope.application,
            loadBalancer: () => angular.copy(loadBalancer),
            isNew: () => false,
            forPipelineConfig: () => true
          }
        }).result.then(function(updatedLoadBalancer) {
          $scope.stage.loadBalancers[index] = updatedLoadBalancer;
        }).catch(() => {
        });
      });
    };
    this.copyLoadBalancer = function(index) {
      $scope.stage.loadBalancers.push(angular.copy($scope.stage.loadBalancers[index]));
    };
    this.removeLoadBalancer = function(index) {
      $scope.stage.loadBalancers.splice(index, 1);
    };
    initializeCommand();
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/createLoadBalancer/createLoadBalancerStage.html", `<div ng-controller="createLoadBalancerStageCtrl as ctrl" class="well well-sm clearfix" ng-if="!pipeline.strategy">
  <div class="row">
    <div class="col-md-12">
      <h4 class="text-left">Load Balancers</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th>Account</th>
            <th>Name</th>
            <th>Region</th>
            <th>Subnet</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="loadBalancer in stage.loadBalancers">
            <td>
              <account-tag account="loadBalancer.credentials"></account-tag>
            </td>
            <td>{{ loadBalancer.name }}</td>
            <td>{{ loadBalancer.region }}</td>
            <td>{{ loadBalancer.subnetType || '[none]' }}</td>

            <td>
              <a class="btn btn-xs btn-link" href ng-click="ctrl.editLoadBalancer(loadBalancer, $index)">Edit</a>
              <a class="btn btn-xs btn-link pad-left" href ng-click="ctrl.removeLoadBalancer($index)">Remove</a>
              <a class="btn btn-xs btn-link pad-left" href ng-click="ctrl.copyLoadBalancer($index)">Duplicate</a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="8">
              <button class="btn btn-block btn-sm add-new" ng-click="ctrl.addLoadBalancer()">
                <span class="glyphicon glyphicon-plus-sign"></span> Add load balancer
              </button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/createLoadBalancer/createLoadBalancerExecutionDetails.html", `<div ng-controller="createLoadBalancerExecutionDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'loadBalancerConfig'">
    <div class="row">
      <div class="col-md-12">
        <table class="table table-condensed">
          <thead>
            <tr>
              <th>Account</th>
              <th>Name</th>
              <th>Region</th>
              <th ng-if="hasSubnetDeployments()">Subnet</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="loadBalancer in stage.context.loadBalancers">
              <td>
                <account-tag account="loadBalancer.credentials"></account-tag>
              </td>
              <td>{{ loadBalancer.name }}</td>
              <td>{{ loadBalancer.region }}</td>
              <td ng-if="hasSubnetDeployments()">{{ loadBalancer.subnetType || '[none]' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <stage-failure-message stage="stage" message="stage.failureMessage"></stage-failure-message>

    <div class="row" ng-if="createdLoadBalancers.length">
      <div class="col-md-12">
        <div class="well alert alert-info">
          <strong>Created:</strong>
          <div ng-repeat="lb in createdLoadBalancers">
            <a target="_blank" href="http://{{lb.dnsName}}"> {{lb.dnsName}} </a>
            <copy-to-clipboard
              class="copy-to-clipboard copy-to-clipboard-sm"
              text="lb.dnsName"
              tool-tip="'Copy DNS Name to clipboard'"
            >
            </copy-to-clipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
</div>
`);
}]);

const CREATE_LOAD_BALANCER_STAGE = "spinnaker.core.pipeline.stage.createLoadBalancer";
module(CREATE_LOAD_BALANCER_STAGE, [
  CORE_PIPELINE_CONFIG_STAGES_CREATELOADBALANCER_CREATELOADBALANCERSTAGE,
  CREATE_LOAD_BALANCER_EXECUTION_DETAILS_CTRL
]);

function clusterNameFilter() {
  return function(input) {
    if (!input) {
      return "n/a";
    }
    return NameUtils.getClusterName(input.application, input.stack, input.freeFormDetails);
  };
}
const CLUSTER_NAME_FILTER = "spinnaker.core.pipeline.clusterName.filter";
module(CLUSTER_NAME_FILTER, []).filter("clusterName", clusterNameFilter);

const CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYEXECUTIONDETAILS_CONTROLLER = "spinnaker.core.pipeline.stage.deploy.details.controller";
module(CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYEXECUTIONDETAILS_CONTROLLER, [
  UIROUTER_ANGULARJS,
  EXECUTION_DETAILS_SECTION_SERVICE
]).controller("DeployExecutionDetailsCtrl", [
  "$scope",
  "$stateParams",
  "executionDetailsSectionService",
  function($scope, $stateParams, executionDetailsSectionService) {
    $scope.configSections = ["deploymentConfig", "taskStatus", "artifactStatus"];
    function areJarDiffsEmpty() {
      let result = true;
      const jarDiffs = $scope.stage.context.jarDiffs;
      if (!___default.isEmpty(jarDiffs)) {
        result = !Object.keys(jarDiffs).some((key) => Array.isArray(jarDiffs[key]) && jarDiffs[key].length);
      }
      return result;
    }
    function evaluateSections() {
      $scope.configSections = ["deploymentConfig", "taskStatus", "artifactStatus"];
      if ($scope.stage.context) {
        if ($scope.stage.context.commits && $scope.stage.context.commits.length > 0 || !areJarDiffsEmpty($scope.stage.context.jarDiffs)) {
          $scope.configSections.push("changes");
        }
      }
    }
    evaluateSections();
    const initialized = () => {
      const context = $scope.stage.context || {};
      let resultObjects;
      evaluateSections();
      $scope.detailsSection = $stateParams.details;
      let results = [];
      function addDeployedArtifacts(key) {
        const deployedArtifacts = ___default.find(resultObjects, key);
        if (deployedArtifacts) {
          ___default.forEach(deployedArtifacts[key], function(serverGroupName, region) {
            const result = {
              type: "serverGroups",
              application: context.application,
              serverGroup: serverGroupName,
              account: context.account,
              region,
              provider: context.providerType || context.cloudProvider || "aws",
              cloudProvider: context.providerType || context.cloudProvider || "aws",
              project: $stateParams.project
            };
            result.href = UrlBuilder.buildFromMetadata(result);
            results.push(result);
          });
        }
      }
      if (context && context["kato.tasks"] && context["kato.tasks"].length) {
        resultObjects = context["kato.tasks"][0].resultObjects;
        if (resultObjects && resultObjects.length) {
          results = [];
          addDeployedArtifacts("serverGroupNameByRegion");
        }
      }
      $scope.deployed = results;
      configureWaitingMessages(results);
      $scope.provider = context.cloudProvider || context.providerType || "aws";
      $scope.changeConfig = {
        buildInfo: context.buildInfo || {},
        commits: $scope.stage.context.commits,
        jarDiffs: $scope.stage.context.jarDiffs
      };
      $scope.customStuckDeployGuide = HelpContentsRegistry.getHelpField("execution.stuckDeploy.guide");
      if (___default.has(context, "source.region") && context["deploy.server.groups"]) {
        const serverGroupName = context["deploy.server.groups"][context.source.region][0];
        ServerGroupReader.getServerGroup(context.application, context.account, context.source.region, serverGroupName).then((serverGroup) => {
          if (___default.has(serverGroup, "buildInfo.jenkins")) {
            $scope.changeConfig.buildInfo.jenkins = serverGroup.buildInfo.jenkins;
          }
        }).catch(() => {
        });
      }
    };
    function configureWaitingMessages(deployedArtifacts) {
      $scope.showWaitingMessage = false;
      $scope.waitingForUpInstances = false;
      $scope.showScalingActivitiesLink = false;
      $scope.showPlatformHealthOverrideMessage = false;
      if (!deployedArtifacts.length) {
        return;
      }
      const deployed = deployedArtifacts[0];
      const stage = $scope.stage;
      const activeWaitTask = (stage.tasks || []).find((t) => ["RUNNING", "TERMINAL"].includes(t.status) && t.name === "waitForUpInstances");
      if (activeWaitTask && stage.context.lastCapacityCheck) {
        $scope.showWaitingMessage = true;
        $scope.waitingForUpInstances = activeWaitTask.status === "RUNNING";
        const lastCapacity = stage.context.lastCapacityCheck;
        const waitDurationExceeded = activeWaitTask.runningTimeInMs > Duration.fromObject({ minutes: 5 }).as("milliseconds");
        lastCapacity.total = lastCapacity.up + lastCapacity.down + lastCapacity.outOfService + lastCapacity.unknown + lastCapacity.succeeded + lastCapacity.failed;
        if (CloudProviderRegistry.getValue(stage.context.cloudProvider, "serverGroup.scalingActivitiesEnabled")) {
          if (waitDurationExceeded && lastCapacity.total < stage.context.capacity.desired) {
            $scope.showScalingActivitiesLink = true;
            $scope.scalingActivitiesTarget = {
              name: deployed.serverGroup,
              app: deployed.application,
              account: deployed.account,
              region: deployed.region,
              cluster: NameUtils.getClusterNameFromServerGroupName(deployed.serverGroup),
              cloudProvider: deployed.cloudProvider
            };
          }
        }
        if (waitDurationExceeded && stage.context.lastCapacityCheck.unknown > 0 && stage.context.lastCapacityCheck.unknown === stage.context.lastCapacityCheck.total && !stage.context.interestingHealthProviderNames && !___default.get($scope.application.attributes, "platformHealthOverride", false)) {
          $scope.showPlatformHealthOverrideMessage = true;
        }
      }
    }
    this.overrideFiltersForUrl = (r) => ClusterState.filterService.overrideFiltersForUrl(r);
    const initialize = () => executionDetailsSectionService.synchronizeSection($scope.configSections, initialized);
    initialize();
    $scope.$on("$stateChangeSuccess", initialize);
    if (___default.hasIn($scope.application, "executions.onRefresh")) {
      $scope.application.executions.onRefresh($scope, initialize);
    }
  }
]);

const CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE = "spinnaker.core.pipeline.stage.deployStage";
angular.module(CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE, [SERVER_GROUP_COMMAND_BUILDER_SERVICE, CLUSTER_SERVICE]).config([
  "clusterServiceProvider",
  function(clusterServiceProvider) {
    Registry.pipeline.registerStage({
      label: "Deploy",
      description: "Deploys the previously baked or found image",
      strategyDescription: "Deploys the image specified",
      key: "deploy",
      alias: "createServerGroup",
      templateUrl: "core/src/pipeline/config/stages/deploy/deployStage.html",
      executionDetailsUrl: "core/src/pipeline/config/stages/deploy/deployExecutionDetails.html",
      controller: "DeployStageCtrl",
      controllerAs: "deployStageCtrl",
      supportsCustomTimeout: true,
      validators: [
        {
          type: "stageBeforeType",
          stageTypes: ["bake", "findAmi", "findImage", "findImageFromTags"],
          message: "You must have a Bake or Find Image stage before any deploy stage.",
          skipValidation: (pipeline, stage) => (stage.clusters || []).every((cluster) => CloudProviderRegistry.getValue(cluster.provider, "serverGroup.skipUpstreamStageCheck") || clusterServiceProvider.$get().isDeployingArtifact(cluster))
        },
        {
          type: "imageProviderBeforeType",
          message: "You must provide the image metadata before any deploy stage.",
          triggerTypes: ["docker", "jenkins"],
          skipValidation: (pipeline, stage) => (stage.clusters || []).every((cluster) => !CloudProviderRegistry.getValue(cluster.provider, "serverGroup.checkForImageProviders"))
        }
      ],
      accountExtractor: (stage) => (stage.context.clusters || []).map((c) => c.account),
      configAccountExtractor: (stage) => (stage.clusters || []).map((c) => c.account),
      artifactExtractor: (stageContext) => {
        const clusterService = clusterServiceProvider.$get();
        const clusters = stageContext.clusters || [stageContext];
        return clusters.map(clusterService.extractArtifacts, clusterService).reduce((array, items) => array.concat(items), []);
      },
      artifactRemover: (stage, artifactId) => {
        const clusterService = clusterServiceProvider.$get();
        (stage.clusters || []).forEach((cluster) => clusterService.getArtifactExtractor(cluster.cloudProvider).removeArtifact(cluster, artifactId));
      },
      strategy: true
    });
  }
]).controller("DeployStageCtrl", [
  "$injector",
  "$scope",
  "$uibModal",
  "stage",
  "serverGroupCommandBuilder",
  "serverGroupTransformer",
  function($injector, $scope, $uibModal, stage, serverGroupCommandBuilder, serverGroupTransformer) {
    $scope.stage = stage;
    function initializeCommand() {
      $scope.stage.clusters = $scope.stage.clusters || [];
    }
    this.getRegion = function(cluster) {
      if (cluster.region) {
        return cluster.region;
      }
      const availabilityZones = cluster.availabilityZones;
      if (availabilityZones) {
        const regions = Object.keys(availabilityZones);
        if (regions && regions.length) {
          return regions[0];
        }
      }
      return "n/a";
    };
    this.hasSubnetDeployments = () => {
      return stage.clusters.some((cluster) => {
        const cloudProvider = cluster.cloudProvider || cluster.provider || cluster.providerType || "aws";
        return CloudProviderRegistry.hasValue(cloudProvider, "subnet");
      });
    };
    this.hasInstanceTypeDeployments = () => {
      return stage.clusters.some((cluster) => {
        return cluster.instanceType !== void 0;
      });
    };
    this.getSubnet = (cluster) => {
      const cloudProvider = cluster.cloudProvider || cluster.provider || cluster.providerType || "aws";
      if (CloudProviderRegistry.hasValue(cloudProvider, "subnet")) {
        const subnetRenderer = CloudProviderRegistry.getValue(cloudProvider, "subnet").renderer;
        if ($injector.has(subnetRenderer)) {
          return $injector.get(subnetRenderer).render(cluster);
        } else {
          throw new Error('No "' + subnetRenderer + '" service found for provider "' + cloudProvider + '".');
        }
      } else {
        return "[none]";
      }
    };
    this.getClusterName = function(cluster) {
      return NameUtils.getClusterName(cluster.application, cluster.stack, cluster.freeFormDetails);
    };
    this.addCluster = function() {
      ProviderSelectionService.selectProvider($scope.application, "serverGroup", providerFilterFn).then(function(selectedProvider) {
        const config = CloudProviderRegistry.getValue(selectedProvider, "serverGroup");
        const handleResult = function(command) {
          command.provider = selectedProvider;
          const stageCluster = serverGroupTransformer.convertServerGroupCommandToDeployConfiguration(command);
          delete stageCluster.credentials;
          $scope.stage.clusters.push(stageCluster);
        };
        const title = "Configure Deployment Cluster";
        const application = $scope.application;
        serverGroupCommandBuilder.buildNewServerGroupCommandForPipeline(selectedProvider, $scope.stage, $scope.$parent.pipeline).then((command) => {
          if (config.CloneServerGroupModal) {
            return config.CloneServerGroupModal.show({ title, application, command });
          } else {
            return $uibModal.open({
              templateUrl: config.cloneServerGroupTemplateUrl,
              controller: `${config.cloneServerGroupController} as ctrl`,
              size: "lg",
              windowClass: "modal-z-index",
              resolve: {
                title: () => title,
                application: () => application,
                serverGroupCommand: () => command
              }
            }).result;
          }
        }).then(handleResult).catch(() => {
        });
      });
    };
    this.editCluster = function(cluster, index) {
      cluster.provider = cluster.cloudProvider || cluster.providerType || "aws";
      const providerConfig = CloudProviderRegistry.getProvider(cluster.provider);
      const handleResult = function(command) {
        const stageCluster = serverGroupTransformer.convertServerGroupCommandToDeployConfiguration(command);
        delete stageCluster.credentials;
        $scope.stage.clusters[index] = stageCluster;
      };
      const title = "Configure Deployment Cluster";
      const application = $scope.application;
      serverGroupCommandBuilder.buildServerGroupCommandFromPipeline(application, cluster, $scope.stage, $scope.$parent.pipeline).then((command) => {
        if (providerConfig.serverGroup.CloneServerGroupModal) {
          return providerConfig.serverGroup.CloneServerGroupModal.show({ title, application, command });
        } else {
          return $uibModal.open({
            templateUrl: providerConfig.serverGroup.cloneServerGroupTemplateUrl,
            controller: `${providerConfig.serverGroup.cloneServerGroupController} as ctrl`,
            size: "lg",
            windowClass: "modal-z-index",
            resolve: {
              title: () => title,
              application: () => application,
              serverGroupCommand: () => command
            }
          }).result;
        }
      }).then(handleResult).catch(() => {
      });
    };
    this.copyCluster = function(index) {
      $scope.stage.clusters.push(angular.copy($scope.stage.clusters[index]));
    };
    this.removeCluster = function(index) {
      $scope.stage.clusters.splice(index, 1);
    };
    this.clusterSortOptions = {
      axis: "y",
      delay: 150,
      start: (_event, ui) => {
        ui.placeholder.height(ui.item.height());
      },
      helper: (_event, element) => {
        const $originalChildren = element.children();
        const $helper = element.clone();
        const $helperChildren = $helper.children();
        $helperChildren.each((index) => {
          $helperChildren.eq(index).width($originalChildren[index].clientWidth);
        });
        return $helper;
      },
      handle: ".handle"
    };
    initializeCommand();
    $scope.trafficOptions = StageConstants.STRATEGY_TRAFFIC_OPTIONS;
    if ($scope.pipeline.strategy) {
      $scope.stage.trafficOptions = $scope.stage.trafficOptions || $scope.trafficOptions[0].val;
    }
    function providerFilterFn(application, account, provider) {
      return !provider.unsupportedStageTypes || provider.unsupportedStageTypes.indexOf("deploy") === -1;
    }
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/deploy/deployStage.html", `<div class="row" ng-if="!pipeline.strategy">
  <div class="col-md-12">
    <table class="table table-condensed table-deployStage">
      <thead>
        <tr>
          <th></th>
          <th if-multiple-providers>Provider</th>
          <th>Account</th>
          <th>Cluster</th>
          <th>Region</th>
          <th ng-if="deployStageCtrl.hasSubnetDeployments()">Subnet</th>
          <th>Strategy</th>
          <th>Capacity</th>
          <th ng-if="deployStageCtrl.hasInstanceTypeDeployments()">Instance Type</th>
          <th style="width: 58px">Actions</th>
        </tr>
      </thead>
      <tbody ui-sortable="deployStageCtrl.clusterSortOptions" ng-model="stage.clusters">
        <tr ng-repeat="cluster in stage.clusters">
          <td class="handle"><span class="glyphicon glyphicon-resize-vertical"></span></td>
          <td if-multiple-providers>
            <cloud-provider-logo
              provider="cluster.cloudProvider || cluster.provider || cluster.providerType || 'aws'"
              width="'20px'"
              height="'20px'"
              show-tooltip="true"
            ></cloud-provider-logo>
          </td>
          <td>
            <account-tag account="cluster.account"></account-tag>
          </td>
          <td>{{ deployStageCtrl.getClusterName(cluster) }}</td>
          <td>{{ deployStageCtrl.getRegion(cluster) }}</td>
          <td ng-if="deployStageCtrl.hasSubnetDeployments()">{{deployStageCtrl.getSubnet(cluster)}}</td>
          <td>{{cluster.strategy || '[none]'}}</td>
          <td>
            <div ng-if="cluster.useSourceCapacity">Current Server Group</div>
            <div ng-if="cluster.capacity">
              <div ng-if="!cluster.useSourceCapacity && cluster.capacity.min === cluster.capacity.max">
                {{cluster.capacity.max}}
              </div>
              <div ng-if="!cluster.useSourceCapacity && cluster.capacity.min !== cluster.capacity.max">
                Min: {{cluster.capacity.min}}, Max: {{cluster.capacity.max}}, Desired: {{cluster.capacity.desired}}
              </div>
            </div>
            <div ng-if="!cluster.capacity">{{cluster.targetSize}}</div>
            <div ng-if="!(cluster.useSourceCapacity || cluster.capacity || cluster.targetSize)">N/A</div>
          </td>
          <td ng-if="deployStageCtrl.hasInstanceTypeDeployments()">{{ cluster.instanceType || '[none]' }}</td>
          <td class="condensed-actions">
            <a class="btn btn-sm btn-link" href ng-click="deployStageCtrl.editCluster(cluster, $index)">
              <span class="glyphicon glyphicon-edit" uib-tooltip="Edit"></span
            ></a>
            <a
              class="btn btn-sm btn-link pad-left"
              href
              analytics-on="click"
              analytics-category="Deploy Stage"
              analytics-event="Duplicate Cluster"
              ng-click="deployStageCtrl.copyCluster($index)"
            >
              <span class="glyphicon glyphicon-duplicate" uib-tooltip="Duplicate"></span>
            </a>
            <a class="btn btn-sm btn-link pad-left" href ng-click="deployStageCtrl.removeCluster($index)">
              <span class="glyphicon glyphicon-trash" uib-tooltip="Remove"></span>
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="10">
            <button class="btn btn-block btn-sm add-new" ng-click="deployStageCtrl.addCluster()">
              <span class="glyphicon glyphicon-plus-sign" data-test-id="Deploy.addServerGroup"></span> Add server group
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

<div ng-if="pipeline.strategy">
  <stage-config-field label="Enable traffic">
    <ui-select ng-model="stage.trafficOptions" class="form-control input-sm">
      <ui-select-match placeholder="None">{{$select.selected.label}}</ui-select-match>
      <ui-select-choices repeat="r.val as r in trafficOptions">
        <strong ng-bind-html="r.label | highlight: $select.search"></strong>
        <div ng-bind-html="r.description"></div>
      </ui-select-choices>
    </ui-select>
  </stage-config-field>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/deploy/deployExecutionDetails.html", `<div ng-controller="DeployExecutionDetailsCtrl as deployDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'deploymentConfig'">
    <div class="row">
      <div class="col-md-12">
        <dl class="dl-narrow dl-horizontal">
          <dt>Account</dt>
          <dd>
            <account-tag account="stage.context.account"></account-tag>
          </dd>
          <dt>Region</dt>
          <div ng-if="stage.context.availabilityZones">
            <dd ng-repeat="(region, zones) in stage.context.availabilityZones">
              {{region}}<br />({{zones.join(', ')}})
            </dd>
          </div>
          <div ng-if="stage.context.namespace">
            <dd>{{stage.context.namespace}}</dd>
          </div>
          <div ng-if="stage.context.region">
            <dd>{{stage.context.region}}</dd>
          </div>
          <dt>Cluster</dt>
          <dd>{{stage.context | clusterName }}</dd>
          <dt ng-if="provider === 'aws'">VPC</dt>
          <dd ng-if="provider === 'aws'">{{stage.context.subnetType || '[none]'}}</dd>
          <dt>Strategy</dt>
          <dd>{{stage.context.strategy || '[none]'}}</dd>
          <dt ng-if="stage.context.capacity || stage.context.useSourceCapacity">Capacity</dt>
          <dd ng-if="!stage.context.capacity">{{stage.context.targetSize}}</dd>
          <dd ng-if="stage.context.useSourceCapacity">Current Server Group</dd>
          <dd ng-if="!stage.context.useSourceCapacity && stage.context.capacity.min === stage.context.capacity.max">
            {{stage.context.capacity.max}}
          </dd>
          <dd ng-if="!stage.context.useSourceCapacity && stage.context.capacity.min !== stage.context.capacity.max">
            Min: {{stage.context.capacity.min}}, Max: {{stage.context.capacity.max}}, Desired:
            {{stage.context.capacity.desired}}
          </dd>
        </dl>
      </div>
    </div>
    <stage-failure-message stage="stage" message="stage.failureMessage"></stage-failure-message>

    <div class="well alert-info" ng-if="showWaitingMessage">
      <p ng-if="waitingForUpInstances">
        <strong>
          Waiting for {{stage.context.targetDesiredSize}} instance<span ng-if="stage.context.targetDesiredSize !== 1"
            >s</span
          >
          to appear healthy.
        </strong>
        <br />
        <span ng-if="stage.context.lastCapacityCheck.total === 0"> (no instances found yet) </span>
        <span ng-if="stage.context.lastCapacityCheck.total !== 0">
          ( current status:
          <health-counts container="stage.context.lastCapacityCheck"></health-counts>)
        </span>
      </p>
      <div ng-if="waitingForUpInstances && customStuckDeployGuide" ng-bind-html="customStuckDeployGuide"></div>
      <div ng-if="showScalingActivitiesLink">
        <p>If your instances are not launching, there might be a problem with your configuration.</p>
        <p>
          <strong>
            <view-scaling-activities-link server-group="scalingActivitiesTarget"></view-scaling-activities-link>
          </strong>
          to troubleshoot common configuration issues.
        </p>
      </div>
      <div ng-if="showPlatformHealthOverrideMessage">
        <p>
          By default, Spinnaker does not consider cloud provider health (i.e. whether your instances have launched and
          are running) as a reliable indicator of instance health.
        </p>
        <p>
          If your instances do not provide a health indicator known to Spinnaker (e.g. a discovery service or load
          balancers), you should configure your application to consider only cloud provider health when executing tasks.
          This option is available under Application Attributes in the
          <a ui-sref="home.applications.application.config({application: application.name})">Config tab</a>.
        </p>
      </div>
    </div>

    <div class="row" ng-if="deployed.length">
      <div class="col-md-12">
        <div class="well alert alert-info">
          <strong>Deployed:</strong>
          <a
            ng-repeat="serverGroup in deployed"
            ng-click="$event.stopPropagation(); deployDetailsCtrl.overrideFiltersForUrl(serverGroup);"
            ng-href="{{serverGroup.href}}"
          >
            {{serverGroup.serverGroup}}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
  <div class="step-section-details" ng-if="detailsSection === 'changes'">
    <view-changes-link view-type="linkOnly" change-config="changeConfig" name-item="stage"></view-changes-link>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'artifactStatus'">
    <execution-artifact-tab stage="stage" execution="execution" config="config"></execution-artifact-tab>
  </div>
</div>
`);
}]);

const CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE_TRANSFORMER = "spinnaker.core.pipeline.stage.deploy.transformer";
module(CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE_TRANSFORMER, []).service("deployStageTransformer", function() {
  function transformRollingPushes(execution) {
    const stagesToRemove = [];
    execution.stages.forEach(function(stage) {
      if (stage.type === "deploy" && stage.context && stage.context.strategy === "rollingpush" && stage.context.source) {
        const modifyLaunchConfigurationStage = ___default.find(execution.stages, {
          type: "modifyAsgLaunchConfiguration",
          parentStageId: stage.id
        });
        const rollingPushStage = ___default.find(execution.stages, {
          type: "rollingPush",
          parentStageId: stage.id
        });
        if (modifyLaunchConfigurationStage) {
          stagesToRemove.push(modifyLaunchConfigurationStage);
          stage.tasks.push({
            name: modifyLaunchConfigurationStage.name,
            startTime: modifyLaunchConfigurationStage.startTime,
            endTime: modifyLaunchConfigurationStage.endTime,
            status: modifyLaunchConfigurationStage.status
          });
          stage.endTime = modifyLaunchConfigurationStage.endTime;
          stage.status = modifyLaunchConfigurationStage.status;
        }
        if (rollingPushStage) {
          stagesToRemove.push(rollingPushStage);
          stage.tasks.push({
            name: rollingPushStage.name,
            startTime: rollingPushStage.startTime,
            endTime: rollingPushStage.endTime,
            status: rollingPushStage.status
          });
          stage.endTime = rollingPushStage.endTime;
          stage.status = rollingPushStage.status;
        }
      }
    });
    execution.stages = execution.stages.filter(function(stage) {
      return !stagesToRemove.includes(stage);
    });
  }
  this.transform = function(application, execution) {
    transformRollingPushes(execution);
  };
});

var css_248z$z = ".table-deployStage .handle {\n  cursor: move;\n}\n.table-deployStage .account-tag {\n  white-space: normal;\n}\n.table-deployStage td {\n  word-break: break-all;\n}\n";
styleInject(css_248z$z);

const CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE_MODULE = "spinnaker.core.pipeline.stage.deploy";
module(CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE,
  CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE_TRANSFORMER,
  CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYEXECUTIONDETAILS_CONTROLLER,
  CLUSTER_NAME_FILTER,
  STAGE_COMMON_MODULE
]).run([
  "deployStageTransformer",
  function(deployStageTransformer) {
    Registry.pipeline.registerTransformer(deployStageTransformer);
  }
]);

function DeployServiceExecutionDetails(props) {
  const { stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region)))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }));
}
(function(DeployServiceExecutionDetails2) {
  DeployServiceExecutionDetails2.title = "deployServiceConfig";
})(DeployServiceExecutionDetails || (DeployServiceExecutionDetails = {}));

Registry.pipeline.registerStage({
  executionDetailsSections: [DeployServiceExecutionDetails, ExecutionDetailsTasks],
  useBaseProvider: true,
  key: "deployService",
  label: "Deploy Service",
  description: "Deploy a service",
  strategy: true
});

function DestroyAsgExecutionDetails(props) {
  return /* @__PURE__ */ React__default.createElement(AsgActionExecutionDetailsSection, {
    ...props,
    action: "Destroyed"
  });
}
(function(DestroyAsgExecutionDetails2) {
  DestroyAsgExecutionDetails2.title = "destroyServerGroupConfig";
})(DestroyAsgExecutionDetails || (DestroyAsgExecutionDetails = {}));

const DESTROY_ASG_STAGE = "spinnaker.core.pipeline.stage.destroyAsg";
module(DESTROY_ASG_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    executionDetailsSections: [DestroyAsgExecutionDetails, ExecutionDetailsTasks],
    useBaseProvider: true,
    key: "destroyServerGroup",
    label: "Destroy Server Group",
    description: "Destroys a server group",
    strategy: true
  });
});

function DestroyServiceExecutionDetails(props) {
  const { stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region)))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }));
}
(function(DestroyServiceExecutionDetails2) {
  DestroyServiceExecutionDetails2.title = "destroyServiceConfig";
})(DestroyServiceExecutionDetails || (DestroyServiceExecutionDetails = {}));

Registry.pipeline.registerStage({
  executionDetailsSections: [DestroyServiceExecutionDetails, ExecutionDetailsTasks],
  useBaseProvider: true,
  key: "destroyService",
  label: "Destroy Service",
  description: "Destroys a service",
  strategy: true
});

function DisableAsgExecutionDetails(props) {
  return /* @__PURE__ */ React__default.createElement(AsgActionExecutionDetailsSection, {
    ...props,
    action: "Disabled"
  });
}
(function(DisableAsgExecutionDetails2) {
  DisableAsgExecutionDetails2.title = "disableServerGroupConfig";
})(DisableAsgExecutionDetails || (DisableAsgExecutionDetails = {}));

const DISABLE_ASG_STAGE_MODULE = "spinnaker.core.pipeline.stage.disableAsg";
module(DISABLE_ASG_STAGE_MODULE, []).config(() => {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    executionDetailsSections: [DisableAsgExecutionDetails, ExecutionDetailsTasks],
    key: "disableServerGroup",
    label: "Disable Server Group",
    description: "Disables a server group",
    strategy: true
  });
});

function ServerGroupStageContext({
  status = "Disabled",
  serverGroups
}) {
  if (!serverGroups) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-11"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, status), /* @__PURE__ */ React__default.createElement("dd", null), Object.keys(serverGroups).map((region) => {
    return [
      /* @__PURE__ */ React__default.createElement("dt", {
        key: `t${region}`
      }, region),
      /* @__PURE__ */ React__default.createElement("dd", {
        key: `d${region}`
      }, serverGroups[region].join(", "))
    ];
  }))));
}

function DisableClusterExecutionDetails(props) {
  const { stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region || (stage.context.regions || []).join(", ")), /* @__PURE__ */ React__default.createElement("dt", null, "Cluster"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.cluster), /* @__PURE__ */ React__default.createElement("dt", null, "Keep Enabled"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.remainingEnabledServerGroups)))), /* @__PURE__ */ React__default.createElement(ServerGroupStageContext, {
    status: "Disabled",
    serverGroups: stage.context["deploy.server.groups"]
  }), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage: props.stage
  }));
}
(function(DisableClusterExecutionDetails2) {
  DisableClusterExecutionDetails2.title = "disableClusterConfig";
})(DisableClusterExecutionDetails || (DisableClusterExecutionDetails = {}));

const DISABLE_CLUSTER_STAGE = "spinnaker.core.pipeline.stage.disableClusterStage";
module(DISABLE_CLUSTER_STAGE, []).config(function() {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    key: "disableCluster",
    label: "Disable Cluster",
    description: "Disables a cluster",
    executionDetailsSections: [DisableClusterExecutionDetails, ExecutionDetailsTasks],
    strategy: true
  });
});

function EnableAsgExecutionDetails(props) {
  return /* @__PURE__ */ React__default.createElement(AsgActionExecutionDetailsSection, {
    ...props,
    action: "Enabled"
  });
}
(function(EnableAsgExecutionDetails2) {
  EnableAsgExecutionDetails2.title = "enableServerGroupConfig";
})(EnableAsgExecutionDetails || (EnableAsgExecutionDetails = {}));

const ENABLE_ASG_STAGE = "spinnaker.core.pipeline.stage.enableAsg";
module(ENABLE_ASG_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    executionDetailsSections: [EnableAsgExecutionDetails, ExecutionDetailsTasks],
    key: "enableServerGroup",
    label: "Enable Server Group",
    description: "Enables a server group",
    strategy: true
  });
});

function ApplyEntityTagsExecutionDetails(props) {
  const { current, name, stage } = props;
  const entityRef = stage.context.entityRef || {};
  const tags = stage.context.tags || {};
  const entityRefSection = /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, "Entity Reference", /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, entityRef.cloudProvider && /* @__PURE__ */ React__default.createElement("dt", null, "Provider"), entityRef.cloudProvider && /* @__PURE__ */ React__default.createElement("dd", null, entityRef.cloudProvider), entityRef.entityType && /* @__PURE__ */ React__default.createElement("dt", null, "Entity Type"), entityRef.entityType && /* @__PURE__ */ React__default.createElement("dd", null, entityRef.entityType), entityRef.entityId && /* @__PURE__ */ React__default.createElement("dt", null, "Entity ID"), entityRef.entityId && /* @__PURE__ */ React__default.createElement("dd", null, entityRef.entityId), entityRef.account && /* @__PURE__ */ React__default.createElement("dt", null, "Account"), entityRef.account && /* @__PURE__ */ React__default.createElement("dd", null, entityRef.account), entityRef.region && /* @__PURE__ */ React__default.createElement("dt", null, "Region"), entityRef.region && /* @__PURE__ */ React__default.createElement("dd", null, entityRef.region), entityRef.vpcId && /* @__PURE__ */ React__default.createElement("dt", null, "VPC ID"), entityRef.vpcId && /* @__PURE__ */ React__default.createElement("dd", null, entityRef.vpcId))));
  const tagsSection = /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, "Tags", /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, tags.map(({ name: tagName, value }) => {
    if (typeof value === "object") {
      try {
        value = JSON.stringify(value);
      } catch (ignored) {
      }
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
      key: tagName
    }, /* @__PURE__ */ React__default.createElement("dt", {
      title: tagName
    }, tagName), /* @__PURE__ */ React__default.createElement("dd", {
      title: value
    }, value));
  }))));
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name,
    current
  }, entityRefSection, tagsSection, /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage,
    message: stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage
  }));
}
(function(ApplyEntityTagsExecutionDetails2) {
  ApplyEntityTagsExecutionDetails2.title = "applyEntityTagsConfig";
})(ApplyEntityTagsExecutionDetails || (ApplyEntityTagsExecutionDetails = {}));

var css_248z$y = ".TagEditor {\n  padding: 10px 5px;\n  border-bottom: 1px solid var(--color-alabaster);\n}\n";
styleInject(css_248z$y);

const typeOptions = [
  { label: "Notice", value: "notice" },
  { label: "Alert", value: "alert" },
  { label: "Custom", value: "custom" }
];
class TagEditor extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleTypeChanged = (type) => {
      this.setState({ type });
      const tag = { ...this.props.tag };
      if (type !== "custom") {
        delete tag.namespace;
        tag.name = `spinnaker_ui_${type}:${UUIDGenerator.generateUuid()}`;
        tag.value = {
          type,
          message: ""
        };
      } else {
        tag.name = "";
        tag.value = "";
      }
      this.props.onChange(tag);
    };
    this.tagValueChanged = (key, value) => {
      if (key === "value") {
        try {
          value = JSON.parse(value);
        } catch (ignored) {
        }
      }
      const tag = { ...this.props.tag };
      set(tag, key, value);
      this.props.onChange(tag);
    };
    const type = props.tag.name.startsWith("spinnaker_ui_notice") ? "notice" : props.tag.name.startsWith("spinnaker_ui_alert") ? "alert" : "custom";
    this.state = {
      type
    };
  }
  render() {
    const { tag } = this.props;
    const { type } = this.state;
    const valueIsObject = typeof tag.value === "object";
    const value = valueIsObject ? JSON.stringify(this.props.tag.value) : this.props.tag.value;
    const namespaceInput = type === "custom" ? /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-3 sm-label-right"
    }, "Namespace ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.entitytags.namespace"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      value: tag.namespace || "",
      onChange: (event) => this.tagValueChanged("namespace", event.target.value)
    }))) : null;
    const nameInput = type === "custom" ? /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-3 sm-label-right"
    }, "Name"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      value: tag.name || "",
      onChange: (event) => this.tagValueChanged("name", event.target.value)
    }))) : null;
    const valueInput = type === "custom" ? /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-3 sm-label-right"
    }, "Value ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.entitytags.value"
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      value: value || "",
      onChange: (event) => this.tagValueChanged("value", event.target.value)
    }))) : /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-3 sm-label-right"
    }, "Message"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      value: tag.value.message || "",
      onChange: (event) => this.tagValueChanged("value.message", event.target.value)
    })));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "TagEditor"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("label", {
      className: "col-md-3 sm-label-right"
    }, "Type"), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...props,
        options: typeOptions,
        clearable: false,
        className: "full-width"
      }),
      required: true,
      onChange: (e) => this.handleTypeChanged(e.target.value),
      value: type
    }))), namespaceInput, nameInput, valueInput);
  }
}

class ApplyEntityTagsStageConfig extends React__default.Component {
  constructor() {
    super(...arguments);
    this.entityOptions = [
      { label: "Server Group", value: "servergroup" },
      { label: "Load Balancer", value: "loadbalancer" },
      { label: "Application", value: "application" },
      { label: "Cluster", value: "cluster" },
      { label: "Security Group", value: "securitygroup" }
    ];
    this.entityRefTypeChanged = (entityType) => {
      const entityRef = { entityType };
      this.props.updateStageField({ entityRef });
    };
    this.entityRefFieldChanged = (key, value) => {
      const entityRef = { ...this.props.stage.entityRef, [key]: value };
      this.props.updateStageField({ entityRef });
    };
    this.tagChanged = (tag, index) => {
      const tags = this.props.stage.tags.slice();
      tags[index] = tag;
      this.props.updateStageField({ tags });
    };
    this.addTag = () => {
      this.props.updateStageField({ tags: this.props.stage.tags.concat({ name: "", value: "" }) });
    };
  }
  render() {
    const {
      stage: { entityRef = {}, tags = [] },
      application: {
        attributes: { cloudProviders = SETTINGS.defaultProviders }
      }
    } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-horizontal"
    }, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Entity Type"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...inputProps,
        options: this.entityOptions,
        clearable: false,
        className: "full-width"
      }),
      onChange: (e) => this.entityRefTypeChanged(e.target.value),
      value: entityRef.entityType || ""
    })), entityRef.entityType && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Name"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      value: entityRef.entityId || "",
      onChange: (e) => this.entityRefFieldChanged("entityId", e.target.value)
    })), entityRef.entityType !== "application" && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Cloud Provider"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        ...inputProps,
        stringOptions: cloudProviders,
        clearable: false,
        className: "full-width"
      }),
      value: entityRef.cloudProvider || "",
      onChange: (e) => this.entityRefFieldChanged("cloudProvider", e.target.value)
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Account"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      value: entityRef.account || "",
      onChange: (e) => this.entityRefFieldChanged("account", e.target.value)
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Region",
      helpKey: "pipeline.config.entitytags.region"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      value: entityRef.region || "",
      onChange: (e) => this.entityRefFieldChanged("region", e.target.value)
    })), entityRef.entityType === "securitygroup" && /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "VPC Id"
    }, /* @__PURE__ */ React__default.createElement(FormField, {
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props
      }),
      value: entityRef.vpcId || "",
      onChange: (e) => this.entityRefFieldChanged("vpcId", e.target.value)
    })))), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Tags"
    }, tags.map((tag, index) => /* @__PURE__ */ React__default.createElement(TagEditor, {
      key: index,
      tag,
      onChange: (t) => this.tagChanged(t, index)
    })), /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: "add-new col-md-12",
      onClick: this.addTag
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add new tag")));
  }
}

Registry.pipeline.registerStage({
  label: "Entity Tags",
  description: "Applies entity tags to a resource.",
  key: "upsertEntityTags",
  defaults: {
    tags: []
  },
  component: ApplyEntityTagsStageConfig,
  executionDetailsSections: [ApplyEntityTagsExecutionDetails, ExecutionDetailsTasks],
  strategy: true,
  validators: [{ type: "requiredField", fieldName: "entityRef.entityType" }]
});

function EvaluateVariablesExecutionDetails(props) {
  const {
    stage: { context = {}, outputs = {} },
    stage,
    name,
    current
  } = props;
  const evaluatedVariables = context.variables ? /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("dl", null, context.variables.map(({ key }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
    key
  }, /* @__PURE__ */ React__default.createElement("dt", null, key), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(Markdown, {
    message: "```\n" + JSON.stringify(outputs[key], null, 2) + "\n```"
  })))))) : /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, "No variables were evaluated."));
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name,
    current
  }, evaluatedVariables, /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage,
    message: stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage
  }));
}
(function(EvaluateVariablesExecutionDetails2) {
  EvaluateVariablesExecutionDetails2.title = "evaluateVariablesConfig";
})(EvaluateVariablesExecutionDetails || (EvaluateVariablesExecutionDetails = {}));

function ExecutionAndStagePicker(props) {
  const { pipeline, pipelineStage, onChange } = props;
  const { executionService } = ReactInjector;
  const [execution, setExecution] = React__default.useState(null);
  const [stageId, setStageId] = React__default.useState(null);
  const [showStageSelector, setShowStageSelector] = React__default.useState(false);
  const fetchExecutions = useData(() => executionService.getExecutionsForConfigIds([pipeline.id], { limit: 100 }), [], []);
  const executions = fetchExecutions.result;
  const stages = execution && execution.stages;
  React__default.useEffect(() => executions && setExecution(executions[0]), [executions]);
  React__default.useEffect(() => {
    const exactStage = findExactStageFromExecution(pipeline, execution, pipelineStage);
    setShowStageSelector(!!exactStage);
    setStageId(exactStage || findCloseStageFromExecution(pipeline, execution, pipelineStage));
  }, [pipeline, pipelineStage, execution]);
  React__default.useEffect(() => {
    onChange({ executionLabel: executionLabel(execution), executionId: execution && execution.id, stageId });
  }, [execution, stageId]);
  const stageOptions = stages ? stages.map((x) => ({ label: x.name, value: x.id })) : [];
  const executionOptions = executions ? executions.map((value) => ({ value })) : [];
  if (fetchExecutions.status === "RESOLVED" && !executions.length) {
    return /* @__PURE__ */ React__default.createElement("p", null, "This pipeline has never been executed. If you run this pipeline at least once, Spinnaker will show previews of the variables on this screen.");
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, "Select a previous execution of this pipeline. Spinnaker will then evaluate each variable as if it had been part of that execution, and generate a preview for you to debug against."), /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Execution",
    value: execution,
    onChange: (e) => setExecution(e.target.value),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      options: executionOptions,
      clearable: false,
      isLoading: fetchExecutions.status === "PENDING",
      optionRenderer: (option) => /* @__PURE__ */ React__default.createElement(ExecutionStatus, {
        execution: option.value,
        showingDetails: true,
        standalone: true
      }),
      valueRenderer: (value) => /* @__PURE__ */ React__default.createElement("span", null, executionLabel(value))
    })
  }), !showStageSelector && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", {
    className: "sp-margin-m-top"
  }, "Spinnaker could not find this exact same Evaluate Variables stage in the previous execution. Select a stage from the previous execution to use as a stand-in."), /* @__PURE__ */ React__default.createElement(FormField, {
    label: "Stage",
    value: stageId,
    onChange: (e) => setStageId(e.target.value),
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      options: stageOptions,
      clearable: false,
      isLoading: !stages
    })
  })));
}
function executionLabel(execution) {
  if (!execution) {
    return null;
  }
  const time = execution.buildTime || execution.startTime;
  return `${timestamp(time)} (${relativeTime(time)})`;
}
function findExactStageFromExecution(pipeline, execution, editStage) {
  if (!pipeline || !execution || !editStage) {
    return null;
  }
  const pipelineStagesById = keyBy(pipeline.stages, "refId");
  const executionStagesById = keyBy(execution.stages, "refId");
  const exactMatch = execution.stages.find((s) => s.refId === editStage.refId && s.type === editStage.type);
  const pipelineRequisiteGraph = stageRequisiteStageGraph(editStage, pipelineStagesById);
  const executionRequisiteGraph = stageRequisiteStageGraph(editStage, executionStagesById);
  const exactGraphMatch = isEqual(pipelineRequisiteGraph, executionRequisiteGraph);
  return exactMatch && exactGraphMatch ? exactMatch.id : null;
}
function findCloseStageFromExecution(pipeline, execution, editStage) {
  if (!pipeline || !execution || !editStage) {
    return null;
  }
  const pipelineStagesById = keyBy(pipeline.stages, "refId");
  const pipelineRequisiteGraph = stageRequisiteStageGraph(editStage, pipelineStagesById);
  const upstreamStages = Object.keys(pipelineRequisiteGraph).map((id) => pipelineStagesById[id]);
  return upstreamStages.map((stage) => findExactStageFromExecution(pipeline, execution, stage)).find((x) => !!x);
}
function stageRequisiteStageGraph(stage, allStages) {
  return stage.requisiteStageRefIds.filter((ref) => /^[0-9]+$/.exec(ref.toString())).reduce((acc, requisiteStageId) => {
    const requisiteStage = allStages[requisiteStageId];
    if (!requisiteStage) {
      return acc;
    }
    return { ...acc, [requisiteStageId]: stageRequisiteStageGraph(requisiteStage, allStages) };
  }, {});
}

var css_248z$x = ".EvaluateVariablesStageConfig .StandardFieldLayout_Label {\n  min-width: 200px;\n  font-family: monospace;\n  text-align: left;\n  flex: 0;\n}\n.EvaluateVariablesStageConfig pre {\n  margin-top: 4px;\n  max-height: 150px;\n}\n.EvaluateVariablesStageConfig .ValidationMessage.infoMessage .message {\n  width: 100%;\n}\n";
styleInject(css_248z$x);

const variableNameValidator = (val, label) => !val.match(/^[a-zA-Z_][a-zA-Z0-9_]*$/) && errorMessage(`${label} should consist only of letters, numbers, or underscore`);
const duplicateKeyValidatorFactory = (variables = []) => {
  const keyCounts = countBy(variables.map((x) => x.key), (x) => x);
  return (key) => keyCounts[key] > 1 && `Duplicate key '${key}'`;
};
function validateEvaluateVariablesStage(stage) {
  const formValidator = new FormValidator(stage);
  const duplicateKeyValidator = duplicateKeyValidatorFactory(stage.variables);
  formValidator.field("variables").withValidators(formValidator.arrayForEach((item) => {
    item.field("key", "Variable Name").required().withValidators(variableNameValidator, duplicateKeyValidator);
    item.field("value", "Expression").required();
  }));
  return formValidator.validateForm();
}
function PreviewConfiguration(props) {
  return /* @__PURE__ */ React__default.createElement("div", {
    style: { marginLeft: "16px", marginRight: "16px" }
  }, /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    type: "info",
    message: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", {
      className: "bold"
    }, "Variable Previews"), /* @__PURE__ */ React__default.createElement(ExecutionAndStagePicker, {
      ...props
    }))
  }));
}
function EvaluateVariablesStageConfig(props) {
  const { application, stage, pipeline, updateStage } = props;
  const [chosenStage, setChosenStage] = React__default.useState({});
  const helpMessage = "Define one or more variables by assigning a **name** _(string)_ and a **value** _([SpEL Expression](https://www.spinnaker.io/guides/user/pipeline/expressions/))_. The evaluated variables can be used in downstream stages, referencing them by name.";
  return /* @__PURE__ */ React__default.createElement(FormikStageConfig, {
    application,
    stage,
    pipeline,
    validate: validateEvaluateVariablesStage,
    onChange: updateStage,
    render: (renderProps) => {
      return /* @__PURE__ */ React__default.createElement(LayoutProvider, {
        value: StandardFieldLayout
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "flex-container-v margin-between-lg"
      }, /* @__PURE__ */ React__default.createElement(Markdown, {
        message: helpMessage
      }), /* @__PURE__ */ React__default.createElement(PreviewConfiguration, {
        pipeline,
        pipelineStage: stage,
        onChange: setChosenStage
      }), /* @__PURE__ */ React__default.createElement(EvaluateVariablesStageForm, {
        ...renderProps,
        chosenStage
      })));
    }
  });
}
function EvaluateVariablesStageForm(props) {
  const { formik, chosenStage } = props;
  const stage = props.formik.values;
  const { variables = [] } = stage;
  const isMountedRef = useIsMountedRef();
  React__default.useEffect(() => {
    if (variables.length === 0) {
      setTimeout(() => isMountedRef.current && formik.setFieldValue("variables", [{ key: null, value: null }]), 100);
    }
  }, []);
  const FieldLayoutComponent = React__default.useContext(LayoutContext);
  const [deleteCount, setDeleteCount] = React__default.useState(0);
  return /* @__PURE__ */ React__default.createElement(FieldArray, {
    key: deleteCount,
    name: "variables",
    render: (arrayHelpers) => /* @__PURE__ */ React__default.createElement("div", {
      className: "EvaluateVariablesStageConfig form-horizontal"
    }, /* @__PURE__ */ React__default.createElement(FieldLayoutComponent, {
      label: /* @__PURE__ */ React__default.createElement("h4", null, "Variable Name"),
      input: /* @__PURE__ */ React__default.createElement("h4", null, "Variable Value"),
      validation: { hidden: true }
    }), variables.map((_, index) => {
      const onDeleteClicked = () => {
        setDeleteCount((count) => count + 1);
        arrayHelpers.handleRemove(index)();
      };
      return /* @__PURE__ */ React__default.createElement(FormikVariable, {
        key: `${deleteCount}-${index}`,
        index,
        previewStage: chosenStage,
        onDeleteClicked
      });
    }), /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: "btn btn-block btn-sm add-new",
      onClick: arrayHelpers.handlePush({ key: null, value: null })
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), "Add Variable"))
  });
}
function FormikVariable({ index, onDeleteClicked, previewStage }) {
  const [touchedOverride, setTouchedOverride] = React__default.useState(void 0);
  const variableNameInputAsLabel = /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: `variables[${index}].key`,
    required: true,
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...inputProps,
      placeholder: "Variable name"
    }),
    layout: VariableNameFormLayout
  });
  const actions = /* @__PURE__ */ React__default.createElement(Tooltip, {
    value: "Remove variable"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-sm btn-default",
    onClick: onDeleteClicked
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-trash"
  })));
  const fieldName = `variables[${index}].value`;
  return /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: fieldName,
    onChange: (value) => {
      if (value && !touchedOverride) {
        setTouchedOverride(true);
      }
    },
    touched: touchedOverride,
    label: variableNameInputAsLabel,
    actions,
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(SpelInput, {
      ...inputProps,
      placeholder: "Variable value, e.g. ${trigger.buildInfo.number}",
      previewStage
    })
  });
}
function VariableNameFormLayout(props) {
  const { input, validation } = props;
  const { messageNode, category, hidden } = validation;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-v margin-between-md"
  }, input, !hidden && /* @__PURE__ */ React__default.createElement(ValidationMessage, {
    message: messageNode,
    type: category
  }));
}

Registry.pipeline.registerStage({
  label: "Evaluate Variables",
  description: "Evaluates variables for use in downstream stages.",
  key: "evaluateVariables",
  defaults: {
    failOnFailedExpressions: true
  },
  component: EvaluateVariablesStageConfig,
  executionDetailsSections: [EvaluateVariablesExecutionDetails, ExecutionDetailsTasks],
  strategy: true,
  validateFn: validateEvaluateVariablesStage
});

const ExecutionWindowDayPicker = (props) => {
  const daySelected = (ordinal) => {
    if (props.days) {
      return props.days.includes(ordinal);
    } else {
      return false;
    }
  };
  const all = () => {
    props.onChange([1, 2, 3, 4, 5, 6, 7]);
  };
  const none = () => {
    props.onChange([]);
  };
  const weekdays = () => {
    props.onChange([2, 3, 4, 5, 6]);
  };
  const weekend = () => {
    props.onChange([1, 7]);
  };
  const updateModel = (day) => {
    const days = props.days ? [...props.days] : [];
    if (days.includes(day.ordinal)) {
      days.splice(days.indexOf(day.ordinal), 1);
    } else {
      days.push(day.ordinal);
    }
    props.onChange(days);
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "btn-group"
  }, DAYS_OF_WEEK.map((d, i) => /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-default " + (daySelected(d.ordinal) ? "active" : ""),
    key: i,
    onClick: () => updateModel(d),
    type: "button"
  }, d.label))), /* @__PURE__ */ React__default.createElement("div", {
    className: "button-controls"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "btn btn-link",
    onClick: all
  }, "All"), /* @__PURE__ */ React__default.createElement("span", {
    className: "btn btn-link",
    onClick: none
  }, "None"), /* @__PURE__ */ React__default.createElement("span", {
    className: "btn btn-link",
    onClick: weekdays
  }, "Weekdays"), /* @__PURE__ */ React__default.createElement("span", {
    className: "btn btn-link",
    onClick: weekend
  }, "Weekend")));
};

class TimePickerOptions {
  static getHours() {
    const hours = [];
    range(0, 10).forEach((hour) => {
      hours.push({ label: "0" + hour, value: hour });
    });
    range(10, 24).forEach((hour) => {
      hours.push({ label: "" + hour, value: hour });
    });
    return hours;
  }
  static getMinutes() {
    const minutes = [];
    range(0, 10).forEach((minute) => {
      minutes.push({ label: "0" + minute, value: minute });
    });
    range(10, 60).forEach((minute) => {
      minutes.push({ label: "" + minute, value: minute });
    });
    return minutes;
  }
}

var css_248z$w = "execution-windows .execution-window-graph,\n.execution-windows .execution-window-graph {\n  width: 100%;\n  height: 70px;\n  border: 1px solid var(--color-concrete);\n  position: relative;\n  margin: 0 0 0 10px;\n}\nexecution-windows .execution-window-graph .execution-window,\n.execution-windows .execution-window-graph .execution-window {\n  height: 69px;\n  background-color: var(--color-success-light);\n  position: absolute;\n  bottom: 0;\n  z-index: 3;\n}\nexecution-windows .execution-window-graph .execution-window:after,\n.execution-windows .execution-window-graph .execution-window:after {\n  content: '';\n  width: calc(100% + 1px);\n  border: 1px solid var(--color-dovegray);\n  border-bottom-width: 0;\n  height: 49px;\n  position: absolute;\n  top: 0;\n  left: -1px;\n}\nexecution-windows .execution-window-graph .divider-label-fill,\n.execution-windows .execution-window-graph .divider-label-fill {\n  background-color: var(--color-cirrus);\n  height: 20px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  z-index: 1;\n}\nexecution-windows .execution-window-graph .dividers .divider,\n.execution-windows .execution-window-graph .dividers .divider {\n  position: absolute;\n  width: 4.16666667%;\n  top: 0;\n  height: 70px;\n  margin-top: 0;\n}\nexecution-windows .execution-window-graph .dividers .divider:first-child,\n.execution-windows .execution-window-graph .dividers .divider:first-child {\n  border-left-width: 0;\n}\nexecution-windows .execution-window-graph .dividers .divider .divider-filler,\n.execution-windows .execution-window-graph .dividers .divider .divider-filler {\n  width: 100%;\n  position: absolute;\n  height: 50px;\n  z-index: 2;\n  border-right: 1px solid var(--color-alto);\n}\nexecution-windows .execution-window-graph .dividers .divider .divider-label,\n.execution-windows .execution-window-graph .dividers .divider .divider-label {\n  font-size: 75%;\n  color: var(--color-dovegray);\n  width: 100%;\n  position: absolute;\n  bottom: 1px;\n  padding: 3px;\n  border-top: 1px solid var(--color-concrete);\n  border-right: 1px solid var(--color-concrete);\n  text-align: center;\n  z-index: 4;\n}\nexecution-windows .execution-window-graph .dividers .divider:last-child .divider-filler,\n.execution-windows .execution-window-graph .dividers .divider:last-child .divider-filler,\nexecution-windows .execution-window-graph .dividers .divider:last-child .divider-label,\n.execution-windows .execution-window-graph .dividers .divider:last-child .divider-label {\n  border-right-width: 0;\n}\nexecution-windows .vertical-align-select,\n.execution-windows .vertical-align-select {\n  vertical-align: bottom;\n}\nexecution-windows .start-end-divider,\n.execution-windows .start-end-divider {\n  padding: 0 15px;\n  font-weight: 600;\n}\nexecution-windows .window-entry,\n.execution-windows .window-entry {\n  padding-bottom: 10px;\n}\nexecution-windows .btn-remove,\n.execution-windows .btn-remove {\n  margin-left: 20px;\n}\np.execution-window-days-of-week {\n  margin-left: 10px;\n}\np.execution-window-days-of-week div.button-controls {\n  display: inline-block;\n}\n";
styleInject(css_248z$w);

const { useState: useState$1 } = React__default;
const ExecutionWindows = (props) => {
  const SELECT_EXECUTION_WINDOW_CLASSES = "visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block vertical-align-select";
  const defaultJitter = {
    minDelay: 0,
    maxDelay: 600,
    enabled: false,
    skipManual: false
  };
  const jitter = get(props.restrictedExecutionWindow, "jitter", defaultJitter);
  const allowlist = get(props.restrictedExecutionWindow, "whitelist", []);
  const days = get(props.restrictedExecutionWindow, "days", []);
  const [timelineWindows, setTimelineWindows] = useState$1(getTimelineWindows(allowlist));
  const [enableCustomSkipWindowText, setEnableCustomSkipWindowText] = useState$1(!!props.skipWindowText);
  const defaultSkipWindowText = DEFAULT_SKIP_WINDOW_TEXT;
  const isWindowExpression = typeof props.restrictExecutionDuringTimeWindow === "string" && props.restrictExecutionDuringTimeWindow.includes("${");
  const hours = TimePickerOptions.getHours();
  const minutes = TimePickerOptions.getMinutes();
  const dividers = hours.map((hour) => ({
    label: hour.label,
    left: hour.value / 24 * 100 + "%"
  }));
  if (!isEqual(getTimelineWindows(allowlist), timelineWindows)) {
    setTimelineWindows(getTimelineWindows(allowlist));
  }
  const jitterUpdated = (changes) => {
    let newJitterValue = { ...jitter };
    extend(newJitterValue, changes);
    if (newJitterValue.enabled) {
      if (newJitterValue.minDelay >= 0 && newJitterValue.maxDelay <= newJitterValue.minDelay) {
        newJitterValue.maxDelay = newJitterValue.minDelay + 1;
      }
    } else {
      newJitterValue = defaultJitter;
    }
    const restrictedExecutionWindow = {
      ...props.restrictedExecutionWindow,
      jitter: newJitterValue
    };
    props.updateStageField({ restrictedExecutionWindow });
  };
  const addExecutionWindow = () => {
    const newExecutionWindow = {
      startHour: 0,
      startMin: 0,
      endHour: 0,
      endMin: 0
    };
    const restrictedExecutionWindow = {
      ...props.restrictedExecutionWindow || {},
      whitelist: [...allowlist, newExecutionWindow]
    };
    props.updateStageField({ restrictedExecutionWindow });
  };
  const removeWindow = (index) => {
    const newAllowlist = [...allowlist];
    newAllowlist.splice(index, 1);
    const restrictedExecutionWindow = {
      ...props.restrictedExecutionWindow,
      whitelist: newAllowlist
    };
    props.updateStageField({ restrictedExecutionWindow });
  };
  const windowDaysUpdated = (newDays) => {
    const restrictedExecutionWindow = {
      ...props.restrictedExecutionWindow,
      days: newDays
    };
    props.updateStageField({ restrictedExecutionWindow });
  };
  const updateAllowlist = (changes, index) => {
    const newAllowlist = [...allowlist];
    extend(newAllowlist[index], changes);
    const restrictedExecutionWindow = {
      ...props.restrictedExecutionWindow,
      whitelist: newAllowlist
    };
    props.updateStageField({ restrictedExecutionWindow });
    setTimelineWindows(getTimelineWindows(newAllowlist));
  };
  function getTimelineWindows(w) {
    const windows = [];
    w.forEach((window) => {
      const start = window.startHour * 60 + window.startMin;
      const end = window.endHour * 60 + window.endMin;
      if (start > end) {
        const firstWindow = {
          startMin: window.startMin,
          startHour: window.startHour,
          endMin: 0,
          endHour: 24,
          wrapEnd: true
        };
        const secondWindow = {
          startMin: 0,
          startHour: 0,
          endMin: window.endMin,
          endHour: window.endHour
        };
        windows.push(buildTimelineWindow(firstWindow, window));
        windows.push(buildTimelineWindow(secondWindow, window));
      } else {
        windows.push(buildTimelineWindow(window));
      }
    });
    return windows;
  }
  function buildTimelineWindow(window, originalWindow) {
    const labelRef = originalWindow || window;
    const timelineWindow = {
      style: getWindowStyle(window),
      start: new Date(2e3, 1, 1, labelRef.startHour, labelRef.startMin),
      end: new Date(2e3, 1, 1, labelRef.endHour, labelRef.endMin),
      displayStart: new Date(2e3, 1, 1, window.startHour, window.startMin),
      displayEnd: new Date(2e3, 1, 1, window.endHour, window.endMin)
    };
    if (window.wrapEnd) {
      timelineWindow.displayEnd = new Date(2e3, 1, 1, 23, 59, 59, 999);
    }
    return timelineWindow;
  }
  function getWindowStyle(window) {
    const dayMinutes = 24 * 60;
    const start = window.startHour * 60 + window.startMin;
    const end = window.endHour * 60 + window.endMin;
    const width = (end - start) / dayMinutes * 100;
    const startOffset = start / dayMinutes * 100;
    return {
      width: width + "%",
      left: startOffset + "%"
    };
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "execution-windows"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9 col-md-offset-1"
  }, isWindowExpression && /* @__PURE__ */ React__default.createElement("div", {
    className: "row",
    style: { marginTop: "20px" }
  }, /* @__PURE__ */ React__default.createElement("strong", null, " Restrict execution to specific time windows when this expression is true"), /* @__PURE__ */ React__default.createElement("input", {
    type: "text",
    className: "form-control input-sm"
  }), /* @__PURE__ */ React__default.createElement(TextInput, {
    value: props.restrictExecutionDuringTimeWindow,
    onChange: (e) => props.updateStageField({ restrictExecutionDuringTimeWindow: e.target.value })
  })), !isWindowExpression && /* @__PURE__ */ React__default.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    text: /* @__PURE__ */ React__default.createElement("strong", null, " Restrict execution to specific time windows"),
    value: props.restrictExecutionDuringTimeWindow,
    onChange: () => props.updateStageField({
      restrictExecutionDuringTimeWindow: !props.restrictExecutionDuringTimeWindow
    })
  })))), props.restrictExecutionDuringTimeWindow && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, /* @__PURE__ */ React__default.createElement("h5", null, /* @__PURE__ */ React__default.createElement("strong", null, "Days of the Week"), /* @__PURE__ */ React__default.createElement("small", null, "(No days selected implies execution on any day if triggered)")), /* @__PURE__ */ React__default.createElement("div", {
    className: "execution-window-days-of-week"
  }, /* @__PURE__ */ React__default.createElement(ExecutionWindowDayPicker, {
    days,
    onChange: windowDaysUpdated
  })))), /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("strong", null, "Time of Day")))), /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "execution-window-graph"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "execution-day"
  }, timelineWindows.map((w, i) => {
    return /* @__PURE__ */ React__default.createElement(Tooltip, {
      key: i,
      value: format(w.start, "HH:mm") + " - " + format(w.end, "HH:mm")
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-window",
      style: w.style
    }));
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "divider-label-fill"
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "dividers"
  }, dividers.map((d, i) => {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "divider",
      key: i,
      style: { left: d.left }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "divider-filler"
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "divider-label"
    }, d.label));
  }))))), /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("p", {
    className: "col-md-9 col-md-offset-1 form-control-static"
  }, "This stage will only run within the following windows (all times in ", /* @__PURE__ */ React__default.createElement(SystemTimezone, null), "):")), allowlist.map((w, i) => {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "window-entry",
      key: i
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 col-md-offset-1"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "start-end-divider"
    }, "From"), /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      clearable: false,
      inputClassName: SELECT_EXECUTION_WINDOW_CLASSES,
      value: w.startHour,
      options: hours.map((h) => ({ label: h.label, value: h.value })),
      onChange: (option) => {
        updateAllowlist({ startHour: option.target.value }, i);
      }
    }), /* @__PURE__ */ React__default.createElement("span", null, " : "), /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      clearable: false,
      inputClassName: SELECT_EXECUTION_WINDOW_CLASSES,
      value: w.startMin,
      options: minutes.map((m) => ({ label: m.label, value: m.value })),
      onChange: (option) => {
        updateAllowlist({ startMin: option.target.value }, i);
      }
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "start-end-divider"
    }, " to "), /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      clearable: false,
      inputClassName: SELECT_EXECUTION_WINDOW_CLASSES,
      value: w.endHour,
      options: hours.map((h) => ({ label: h.label, value: h.value })),
      onChange: (option) => {
        updateAllowlist({ endHour: option.target.value }, i);
      }
    }), /* @__PURE__ */ React__default.createElement("span", null, " : "), /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      clearable: false,
      inputClassName: SELECT_EXECUTION_WINDOW_CLASSES,
      value: w.endMin,
      options: minutes.map((m) => ({ label: m.label, value: m.value })),
      onChange: (option) => {
        updateAllowlist({ endMin: option.target.value }, i);
      }
    }), /* @__PURE__ */ React__default.createElement(Tooltip, {
      value: "Remove window"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn-link btn-remove",
      onClick: () => removeWindow(i)
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-trash"
    }), /* @__PURE__ */ React__default.createElement("span", {
      className: "sr-only"
    }, "Remove window"))))));
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-6 col-md-offset-1"
  }, /* @__PURE__ */ React__default.createElement("button", {
    className: "btn btn-block btn-add-trigger add-new",
    onClick: () => addExecutionWindow()
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "glyphicon glyphicon-plus-sign"
  }), " Add an execution window"))), /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9 col-md-offset-1"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    text: /* @__PURE__ */ React__default.createElement("strong", null, " Add random jitter to start of execution window"),
    value: jitter.enabled,
    onChange: () => {
      jitterUpdated({ enabled: !jitter.enabled });
    }
  })))), jitter.enabled && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1 checkbox-padding"
  }, "Randomly wait between", " ", /* @__PURE__ */ React__default.createElement(NumberInput$1, {
    inputClassName: "form-control input-sm inline-number with-space-before",
    min: 0,
    value: jitter.minDelay,
    onChange: (e) => {
      jitterUpdated({ minDelay: e.target.value });
    }
  }), " ", "and", " ", /* @__PURE__ */ React__default.createElement(NumberInput$1, {
    inputClassName: "form-control input-sm inline-number with-space-before",
    max: 60 * 60 * 72 - 1,
    value: jitter.maxDelay,
    onChange: (e) => {
      jitterUpdated({ maxDelay: e.target.value });
    }
  }), " ", "seconds when entering execution window.")), /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1 checkbox-padding"
  }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    text: /* @__PURE__ */ React__default.createElement("strong", null, " Skip jitter when manually triggering pipeline"),
    value: jitter.skipManual,
    onChange: () => {
      jitterUpdated({ skipManual: !jitter.skipManual });
    }
  })))), /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, /* @__PURE__ */ React__default.createElement(CheckboxInput, {
    text: /* @__PURE__ */ React__default.createElement("strong", null, " Show custom warning when users skip execution window"),
    value: enableCustomSkipWindowText,
    onChange: () => setEnableCustomSkipWindowText(!enableCustomSkipWindowText)
  })), enableCustomSkipWindowText && /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1 checkbox-padding"
  }, /* @__PURE__ */ React__default.createElement(TextAreaInput, {
    rows: 4,
    onChange: (e) => props.updateStageField({ skipWindowText: e.target.value }),
    placeholder: "Default text: '" + defaultSkipWindowText + "' (HTML is okay)",
    style: { marginTop: "5px" },
    value: props.skipWindowText
  })))));
};

const EXECUTION_WINDOWS = "spinnaker.core.pipeline.stage.executionWindows.directive";
module(EXECUTION_WINDOWS, []).component("executionWindows", react2angular(withErrorBoundary(ExecutionWindows, "executionWindows"), [
  "restrictExecutionDuringTimeWindow",
  "restrictedExecutionWindow",
  "skipWindowText",
  "updateStageField"
]));

function ExecutionWindowExecutionDetails(props) {
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement(ExecutionWindowActions, {
    application: props.application,
    execution: props.execution,
    stage: props.stage
  }), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage: props.stage
  }));
}
(function(ExecutionWindowExecutionDetails2) {
  ExecutionWindowExecutionDetails2.title = "windowConfig";
})(ExecutionWindowExecutionDetails || (ExecutionWindowExecutionDetails = {}));

class ExecutionWindowsTransformer {
  transform(_application, execution) {
    applySuspendedStatuses(execution, "restrictExecutionDuringTimeWindow");
  }
}

Registry.pipeline.registerStage({
  label: "Restrict Execution During",
  synthetic: true,
  description: "Restricts execution of stage during specified period of time",
  key: "restrictExecutionDuringTimeWindow",
  executionDetailsSections: [ExecutionWindowExecutionDetails, ExecutionDetailsTasks]
});
Registry.pipeline.registerTransformer(new ExecutionWindowsTransformer());

function FindAmiExecutionDetails(props) {
  const { stage } = props;
  const regions = stage.context && stage.context.regions && stage.context.regions.join(", ");
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-6"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), regions && /* @__PURE__ */ React__default.createElement("dt", null, "Regions"), regions && /* @__PURE__ */ React__default.createElement("dd", null, regions), /* @__PURE__ */ React__default.createElement("dt", null, "Cluster"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.cluster)))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }), stage.context.amiDetails && /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "well alert alert-info"
  }, /* @__PURE__ */ React__default.createElement("h4", null, "Results"), stage.context.amiDetails.map((image) => /* @__PURE__ */ React__default.createElement("dl", {
    key: image.imageId,
    className: "dl-narrow dl-horizontal"
  }, image.region && /* @__PURE__ */ React__default.createElement("dt", null, "Region"), image.region && /* @__PURE__ */ React__default.createElement("dd", null, image.region), /* @__PURE__ */ React__default.createElement("dt", null, "Image ID"), /* @__PURE__ */ React__default.createElement("dd", null, image.imageId), image.imageName && /* @__PURE__ */ React__default.createElement("dt", null, "Name"), image.imageName && /* @__PURE__ */ React__default.createElement("dd", null, image.imageName)))))));
}
(function(FindAmiExecutionDetails2) {
  FindAmiExecutionDetails2.title = "findImageConfig";
})(FindAmiExecutionDetails || (FindAmiExecutionDetails = {}));

const FIND_AMI_STAGE = "spinnaker.core.pipeline.stage.findAmiStage";
module(FIND_AMI_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    executionDetailsSections: [FindAmiExecutionDetails, ExecutionDetailsTasks],
    useBaseProvider: true,
    key: "findImage",
    label: "Find Image from Cluster",
    description: "Finds an image to deploy from an existing cluster"
  });
});

class FindArtifactFromExecutionExecutionDetails extends React__default.Component {
  render() {
    const { current, name, stage } = this.props;
    const expectedArtifacts = Array.isArray(stage.context.expectedArtifacts) ? stage.context.expectedArtifacts : [stage.context.expectedArtifact];
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, expectedArtifacts.map((expectedArtifact) => /* @__PURE__ */ React__default.createElement("div", {
      key: expectedArtifact.id
    }, /* @__PURE__ */ React__default.createElement("h5", null, expectedArtifact.displayName), /* @__PURE__ */ React__default.createElement("div", null, "Match Artifact"), /* @__PURE__ */ React__default.createElement("pre", null, JsonUtils.makeSortedStringFromObject(expectedArtifact.matchArtifact)), expectedArtifact.useDefaultArtifact && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", null, "Default Artifact"), /* @__PURE__ */ React__default.createElement("pre", null, JsonUtils.makeSortedStringFromObject(expectedArtifact.defaultArtifact)))))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: stage.outputs.exception
    }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
      stage
    }));
  }
}
FindArtifactFromExecutionExecutionDetails.title = "artifactDetails";

class FindArtifactFromExecutionCtrl {
  constructor($scope) {
    this.$scope = $scope;
    this.state = {
      applicationsLoaded: false,
      pipelinesLoaded: false,
      applications: [],
      pipelines: [],
      infiniteScroll: {
        numToAdd: 20,
        currentItems: 20
      }
    };
    this.stage = this.$scope.stage;
    if (!this.stage.executionOptions) {
      this.stage.executionOptions = {
        successful: true
      };
    }
    const initialArtifact = ExpectedArtifactService.createEmptyArtifact();
    if (this.stage.expectedArtifact) {
      Object.assign(initialArtifact, this.stage.expectedArtifact);
    }
    if (!Array.isArray(this.stage.expectedArtifacts)) {
      this.stage.expectedArtifacts = [initialArtifact];
    }
    this.loadApplications();
    this.loadPipelines();
  }
  loadApplications() {
    ApplicationReader.listApplications().then((apps) => {
      this.state.applications = apps.map((a) => a.name);
      this.state.applicationsLoaded = true;
    });
  }
  loadPipelines() {
    this.state.pipelinesLoaded = false;
    if (this.stage.application) {
      PipelineConfigService.getPipelinesForApplication(this.stage.application).then((ps) => {
        this.state.pipelines = ps;
        this.state.pipelinesLoaded = true;
      });
    }
  }
  addMoreApplications() {
    this.state.infiniteScroll.currentItems += this.state.infiniteScroll.numToAdd;
  }
  onApplicationSelect() {
    this.loadPipelines();
  }
}
FindArtifactFromExecutionCtrl.$inject = ["$scope"];

const FIND_ARTIFACT_FROM_EXECUTION_STAGE = "spinnaker.core.pipeline.stage.findArtifactStage";
module(FIND_ARTIFACT_FROM_EXECUTION_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    label: "Find Artifacts From Execution",
    description: "Find and bind artifacts from another execution",
    key: "findArtifactFromExecution",
    templateUrl: "core/src/pipeline/config/stages/findArtifactFromExecution/findArtifactFromExecutionConfig.html",
    controller: "findArtifactFromExecutionCtrl",
    controllerAs: "ctrl",
    executionDetailsSections: [
      FindArtifactFromExecutionExecutionDetails,
      ExecutionDetailsTasks,
      ExecutionArtifactTab
    ],
    validators: [
      { type: "requiredField", fieldName: "pipeline", fieldLabel: "Pipeline" },
      { type: "requiredField", fieldName: "application", fieldLabel: "Application" }
    ],
    producesArtifacts: true
  });
}).controller("findArtifactFromExecutionCtrl", FindArtifactFromExecutionCtrl);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/findArtifactFromExecution/findArtifactFromExecutionConfig.html", `<div class="form-horizontal clearfix">
  <h4>Pipeline Selector</h4>
  <stage-config-field label="Application">
    <ui-select class="form-control input-sm" on-select="ctrl.onApplicationSelect()" ng-model="ctrl.stage.application">
      <ui-select-match placeholder="Select an application...">{{$select.selected}}</ui-select-match>
      <ui-select-choices
        repeat="application in ctrl.state.applications | filter: $select.search | limitTo: ctrl.state.infiniteScroll.currentItems"
        infinite-scroll="ctrl.addMoreApplications()"
        infinite-scroll-distance="2"
      >
        <div ng-bind-html="application | highlight: $select.search"></div>
      </ui-select-choices>
    </ui-select>
  </stage-config-field>
  <stage-config-field label="Pipeline">
    <div>
      <ui-select class="form-control input-sm" ng-model="ctrl.stage.pipeline">
        <ui-select-match placeholder="Select a pipeline...">{{$select.selected.name}}</ui-select-match>
        <ui-select-choices
          repeat="pipeline.id as pipeline in ctrl.state.pipelines | filter: $select.search | orderBy: 'index'"
          ><span ng-bind-html="pipeline.name | highlight: $select.search"></span
        ></ui-select-choices>
      </ui-select>
    </div>
  </stage-config-field>
  <h4>Execution Options</h4>
  <label class="col-md-2 col-md-offset-1 sm-label-right">
    Consider executions
    <help-field key="pipeline.config.findArtifactFromExecution.considerExecutions"></help-field>
  </label>
  <div class="col-md-9">
    <div class="checkbox">
      <label> <input type="checkbox" ng-model="ctrl.stage.executionOptions.successful" /> that are successful </label>
    </div>
    <div class="checkbox">
      <label>
        <input type="checkbox" ng-model="ctrl.stage.executionOptions.terminal" /> that are terminal (have failed)
      </label>
    </div>
    <div class="checkbox">
      <label> <input type="checkbox" ng-model="ctrl.stage.executionOptions.running" /> that are still running </label>
    </div>
  </div>
</div>
`);
}]);

const CORE_PIPELINE_CONFIG_STAGES_FINDIMAGEFROMTAGS_FINDIMAGEFROMTAGSSTAGE = "spinnaker.core.pipeline.stage.findImageFromTagsStage";
module(CORE_PIPELINE_CONFIG_STAGES_FINDIMAGEFROMTAGS_FINDIMAGEFROMTAGSSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    key: "findImageFromTags",
    label: "Find Image from Tags",
    description: "Finds an image to deploy from existing tags"
  });
});

const CORE_PIPELINE_CONFIG_STAGES_FINDIMAGEFROMTAGS_FINDIMAGEFROMTAGSSTAGE_MODULE = "spinnaker.core.pipeline.stage.findImageFromTags";
module(CORE_PIPELINE_CONFIG_STAGES_FINDIMAGEFROMTAGS_FINDIMAGEFROMTAGSSTAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  STAGE_COMMON_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_FINDIMAGEFROMTAGS_FINDIMAGEFROMTAGSSTAGE
]);

class GoogleCloudBuildExecutionDetails extends React__default.Component {
  render() {
    const { current, name, stage } = this.props;
    const logUrl = get(stage, "context.buildInfo.logUrl");
    const status = get(stage, "context.buildInfo.status");
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, status && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Status:")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, capitalize(status))), logUrl && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Details:")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6"
    }, /* @__PURE__ */ React__default.createElement("a", {
      href: logUrl,
      target: "_blank"
    }, "Build Logs"))))));
  }
}
GoogleCloudBuildExecutionDetails.title = "googleCloudBuildStatus";

var BuildDefinitionSource;
(function(BuildDefinitionSource2) {
  BuildDefinitionSource2["ARTIFACT"] = "artifact";
  BuildDefinitionSource2["TEXT"] = "text";
  BuildDefinitionSource2["TRIGGER"] = "trigger";
})(BuildDefinitionSource || (BuildDefinitionSource = {}));
var TriggerType;
(function(TriggerType2) {
  TriggerType2["BRANCH"] = "branchName";
  TriggerType2["TAG"] = "tagName";
  TriggerType2["COMMIT"] = "commitSha";
})(TriggerType || (TriggerType = {}));

const SOURCE_OPTIONS = [
  { value: BuildDefinitionSource.TEXT, label: "Text" },
  { value: BuildDefinitionSource.ARTIFACT, label: "Artifact" },
  { value: BuildDefinitionSource.TRIGGER, label: "Trigger" }
];
const TRIGGER_TYPE_OPTIONS = [
  { value: TriggerType.BRANCH, label: "Branch name" },
  { value: TriggerType.TAG, label: "Tag Name" },
  { value: TriggerType.COMMIT, label: "Commit SHA" }
];
const EXCLUDED_ARTIFACT_TYPES = excludeAllTypesExcept(ArtifactTypePatterns.BITBUCKET_FILE, ArtifactTypePatterns.CUSTOM_OBJECT, ArtifactTypePatterns.GCS_OBJECT, ArtifactTypePatterns.GITHUB_FILE, ArtifactTypePatterns.GITLAB_FILE, ArtifactTypePatterns.HTTP_FILE, ArtifactTypePatterns.S3_OBJECT);
function GoogleCloudBuildStageForm(props) {
  const stage = props.formik.values;
  const [rawBuildDefinitionYaml, setRawBuildDefinitionYaml] = React__default.useState(() => stage.buildDefinition ? yamlDocumentsToString([stage.buildDefinition]) : "");
  const { result: fetchAccountsResult, status: fetchAccountsStatus } = useData(() => IgorService.getGcbAccounts(), [], []);
  const { result: fetchTriggersResult, status: fetchTriggersStatus } = useData(() => {
    if (SpelService.includesSpel(stage.account)) {
      return null;
    }
    return IgorService.getGcbTriggers(stage.account);
  }, [], [stage.account]);
  const onYamlChange = (rawYaml, yamlDocs) => {
    setRawBuildDefinitionYaml(rawYaml);
    const buildDefinition = Array.isArray(yamlDocs) && yamlDocs.length > 0 ? yamlDocs[0] : null;
    props.formik.setFieldValue("buildDefinition", buildDefinition);
  };
  const setArtifactId = (expectedArtifactId) => {
    props.formik.setFieldValue("buildDefinitionArtifact.artifactId", expectedArtifactId);
    props.formik.setFieldValue("buildDefinitionArtifact.artifact", null);
  };
  const setArtifact = (artifact) => {
    props.formik.setFieldValue("buildDefinitionArtifact.artifact", artifact);
    props.formik.setFieldValue("buildDefinitionArtifact.artifactId", null);
  };
  React__default.useEffect(() => {
    if (stage.buildDefinitionSource !== BuildDefinitionSource.TEXT && stage.buildDefinition) {
      props.formik.setFieldValue("buildDefinition", null);
      setRawBuildDefinitionYaml("");
    }
    if (stage.buildDefinitionSource !== BuildDefinitionSource.ARTIFACT && stage.buildDefinitionArtifact) {
      props.formik.setFieldValue("buildDefinitionArtifact", null);
    }
    if (stage.buildDefinitionSource !== BuildDefinitionSource.TRIGGER && stage.repoSource) {
      props.formik.setFieldValue("repoSource", null);
    }
    if (stage.buildDefinitionSource !== BuildDefinitionSource.TRIGGER && stage.triggerId) {
      props.formik.setFieldValue("triggerId", null);
    }
    if (stage.buildDefinitionSource !== BuildDefinitionSource.TRIGGER && stage.triggerType) {
      props.formik.setFieldValue("triggerType", null);
    }
  }, [stage.buildDefinitionSource]);
  React__default.useEffect(() => {
    if (stage.buildDefinitionSource !== BuildDefinitionSource.TRIGGER) {
      return;
    }
    const branchKey = `repoSource.${TriggerType.BRANCH}`;
    if (stage.triggerType !== TriggerType.BRANCH && get(stage, branchKey)) {
      props.formik.setFieldValue(branchKey, null);
    }
    const commitKey = `repoSource.${TriggerType.COMMIT}`;
    if (stage.triggerType !== TriggerType.COMMIT && get(stage, commitKey)) {
      props.formik.setFieldValue(commitKey, null);
    }
    const tagKey = `repoSource.${TriggerType.TAG}`;
    if (stage.triggerType !== TriggerType.TAG && get(stage, tagKey)) {
      props.formik.setFieldValue(tagKey, null);
    }
  }, [stage.triggerType]);
  return /* @__PURE__ */ React__default.createElement(FormikSpelContextProvider, {
    value: true
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Account",
    name: "account",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      clearable: false,
      isLoading: fetchAccountsStatus === "PENDING",
      stringOptions: fetchAccountsResult
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Build Definition Source",
    name: "buildDefinitionSource",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(RadioButtonInput, {
      ...inputProps,
      options: SOURCE_OPTIONS
    }),
    spelAware: false
  }), stage.buildDefinitionSource === BuildDefinitionSource.TEXT && /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Build Definition",
    name: "buildDefinition",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(YamlEditor, {
      ...inputProps,
      value: rawBuildDefinitionYaml,
      onChange: onYamlChange
    }),
    spelAware: false
  }), stage.buildDefinitionSource === BuildDefinitionSource.ARTIFACT && /* @__PURE__ */ React__default.createElement(StageArtifactSelectorDelegate, {
    artifact: get(stage, "buildDefinitionArtifact.artifact"),
    excludedArtifactTypePatterns: EXCLUDED_ARTIFACT_TYPES,
    expectedArtifactId: get(stage, "buildDefinitionArtifact.artifactId"),
    label: "Build Definition Artifact",
    onArtifactEdited: setArtifact,
    onExpectedArtifactSelected: (artifact) => setArtifactId(artifact.id),
    pipeline: props.pipeline,
    stage
  }), stage.buildDefinitionSource === BuildDefinitionSource.TRIGGER && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "triggerId",
    label: "Trigger Name",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      clearable: false,
      disabled: !stage.account,
      isLoading: fetchTriggersStatus === "PENDING",
      options: (fetchTriggersResult || []).map((trigger) => ({
        label: trigger.name,
        value: trigger.id
      }))
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "triggerType",
    label: "Trigger Type",
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
      ...inputProps,
      clearable: false,
      disabled: !stage.triggerId,
      options: TRIGGER_TYPE_OPTIONS
    }),
    spelAware: false
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    label: "Value",
    name: `repoSource.${stage.triggerType}`,
    input: (inputProps) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...inputProps,
      disabled: !stage.triggerType
    }),
    spelAware: false
  }))));
}

const validate$1 = (stage) => {
  const formValidator = new FormValidator(stage);
  formValidator.field("account", "Account").required();
  if (stage.buildDefinitionSource === BuildDefinitionSource.TEXT) {
    formValidator.field("buildDefinition", "Build Definition").required();
  }
  if (stage.buildDefinitionSource === BuildDefinitionSource.TRIGGER) {
    formValidator.field("triggerId", "Trigger Name").required();
    formValidator.field("triggerType", "Trigger Type").required();
    const triggerType = stage.triggerType;
    formValidator.field(`repoSource.${triggerType}`, "Value").required();
  }
  return formValidator.validateForm();
};

function GoogleCloudBuildStageConfig({ application, pipeline, stage, updateStage }) {
  const stageWithDefaults = React__default.useMemo(() => {
    return {
      application: application.name,
      buildDefinitionSource: BuildDefinitionSource.TEXT,
      ...cloneDeep(stage)
    };
  }, []);
  return /* @__PURE__ */ React__default.createElement(FormikStageConfig, {
    application,
    onChange: updateStage,
    pipeline,
    stage: stageWithDefaults,
    validate: validate$1,
    render: (props) => /* @__PURE__ */ React__default.createElement(GoogleCloudBuildStageForm, {
      ...props
    })
  });
}

Registry.pipeline.registerStage({
  label: "Google Cloud Build",
  description: "Trigger a build in GCB (Google Cloud Build)",
  key: "googleCloudBuild",
  producesArtifacts: true,
  component: GoogleCloudBuildStageConfig,
  executionDetailsSections: [GoogleCloudBuildExecutionDetails, ExecutionDetailsTasks, ExecutionArtifactTab],
  validateFn: validate$1,
  artifactExtractor: ExpectedArtifactService.accumulateArtifacts(["buildDefinitionArtifact.artifactId"]),
  artifactRemover: ArtifactReferenceService.removeArtifactFromFields(["buildDefinitionArtifact.artifactId"])
});

function GremlinExecutionDetails(props) {
  const { stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage,
    message: stage.failureMessage
  }));
}
(function(GremlinExecutionDetails2) {
  GremlinExecutionDetails2.title = "gremlinConfig";
})(GremlinExecutionDetails || (GremlinExecutionDetails = {}));

class GremlinStageConfig extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { isFetchingData: false, apiError: "", commands: [], targets: [] };
    this.apiErrorMessages = {
      notFound: "API key does not exist.",
      notEnabled: "Gremlin not enabled. Please set integrations.gremlin.enabled to true in your Orca and Gate configuration."
    };
    this.checkInitialLoad = () => {
      const { stage } = this.props;
      if (stage.gremlinApiKey) {
        this.fetchAPIData();
      }
    };
    this.fetchCommands = (apiKey) => {
      return from(REST("/integrations/gremlin/templates/command").post({
        apiKey
      }).catch((response) => {
        this.props.updateStageField({ gremlinCommandTemplateId: null });
        if (response.status === 401) {
          return this.apiErrorMessages.notFound;
        }
        return this.apiErrorMessages.notEnabled;
      }));
    };
    this.fetchTargets = (apiKey) => {
      return from(REST("/integrations/gremlin/templates/target").post({
        apiKey
      }).catch((response) => {
        this.props.updateStageField({ gremlinTargetTemplateId: null });
        if (response.status === 401) {
          return this.apiErrorMessages.notFound;
        }
        return this.apiErrorMessages.notEnabled;
      }));
    };
    this.fetchAPIData = () => {
      const {
        stage: { gremlinApiKey }
      } = this.props;
      this.setState({
        isFetchingData: true,
        apiError: ""
      });
      forkJoin(this.fetchCommands(gremlinApiKey), this.fetchTargets(gremlinApiKey)).subscribe((results) => {
        const newState = {
          isFetchingData: false
        };
        if (Array.isArray(results[0]) && Array.isArray(results[1])) {
          newState.commands = results[0];
          newState.targets = results[1];
        } else {
          newState.apiError = results[0];
          newState.commands = [];
          newState.targets = [];
        }
        this.setState(newState);
      });
    };
    this.onChange = (name, value) => {
      this.props.updateStageField({ [name]: value });
    };
    this.handleGremlinCommandTemplateIdChange = (option) => {
      this.props.updateStageField({ gremlinCommandTemplateId: option.value });
    };
    this.handleGremlinTargetTemplateIdChange = (option) => {
      this.props.updateStageField({ gremlinTargetTemplateId: option.value });
    };
  }
  componentDidMount() {
    this.checkInitialLoad();
  }
  render() {
    const { stage } = this.props;
    const { isFetchingData, apiError, commands, targets } = this.state;
    const selectedCommandTemplateMeta = commands.length && stage.gremlinCommandTemplateId ? commands.find((command) => command.guid === stage.gremlinCommandTemplateId) : {};
    const selectedTargetTemplateMeta = targets.length && stage.gremlinTargetTemplateId ? targets.find((target) => target.guid === stage.gremlinTargetTemplateId) : {};
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-horizontal"
    }, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "API Key"
    }, /* @__PURE__ */ React__default.createElement("input", {
      name: "gremlinApiKey",
      className: "form-control input",
      type: "text",
      value: stage.gremlinApiKey || "",
      onChange: (e) => this.onChange(e.target.name, e.target.value)
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-control-static",
      style: { paddingBottom: 0 }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-container-h middle margin-between-md"
    }, /* @__PURE__ */ React__default.createElement("button", {
      disabled: isFetchingData || !stage.gremlinApiKey,
      onClick: this.fetchAPIData,
      type: "button",
      className: "btn btn-sm btn-default"
    }, isFetchingData ? "Loading..." : "Fetch"), apiError && /* @__PURE__ */ React__default.createElement("span", {
      className: "text-danger text-small"
    }, apiError))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-control-static"
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "text-small",
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://app.gremlin.com/api-keys"
    }, "Create a Gremlin API key"))), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Target Template"
    }, !targets.length ? isFetchingData ? /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "Loading...") : /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "No targets found.") : /* @__PURE__ */ React__default.createElement(Select, {
      name: "gremlinTargetTemplateId",
      options: targets.map((target) => ({
        label: target.name,
        value: target.guid
      })),
      clearable: false,
      value: stage.gremlinTargetTemplateId || null,
      onChange: this.handleGremlinTargetTemplateIdChange
    })), /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Attack Template"
    }, !commands.length ? isFetchingData ? /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "Loading...") : /* @__PURE__ */ React__default.createElement("p", {
      className: "form-control-static"
    }, "No commands found.") : /* @__PURE__ */ React__default.createElement(Select, {
      name: "gremlinCommandTemplateId",
      options: commands.map((command) => ({
        label: command.name,
        value: command.guid
      })),
      clearable: false,
      value: stage.gremlinCommandTemplateId || null,
      onChange: this.handleGremlinCommandTemplateIdChange
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-control-static"
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "text-small",
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://docs.gremlin.com/attacks/#how-to-create-attack-templates-with-gremlin"
    }, "How to create Gremlin templates")))), (stage.gremlinCommandTemplateId || stage.gremlinTargetTemplateId) && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("hr", null), /* @__PURE__ */ React__default.createElement("h3", null, "Summary"), /* @__PURE__ */ React__default.createElement("div", {
      className: "list-group"
    }, stage.gremlinTargetTemplateId && /* @__PURE__ */ React__default.createElement("div", {
      className: "list-group-item"
    }, /* @__PURE__ */ React__default.createElement("h4", {
      className: "list-group-item-heading"
    }, "Target Template (", selectedTargetTemplateMeta.name, ")"), /* @__PURE__ */ React__default.createElement("p", {
      className: "list-group-item-text"
    }, selectedTargetTemplateMeta.synthetic_description)), stage.gremlinCommandTemplateId && /* @__PURE__ */ React__default.createElement("div", {
      className: "list-group-item"
    }, /* @__PURE__ */ React__default.createElement("h4", {
      className: "list-group-item-heading"
    }, "Attack Template (", selectedCommandTemplateMeta.name, ")"), /* @__PURE__ */ React__default.createElement("p", {
      className: "list-group-item-text"
    }, selectedCommandTemplateMeta.synthetic_description)))));
  }
}

Registry.pipeline.registerStage({
  label: "Gremlin",
  description: "Runs a chaos experiment using Gremlin",
  key: "gremlin",
  component: GremlinStageConfig,
  executionDetailsSections: [GremlinExecutionDetails, ExecutionDetailsTasks],
  strategy: true,
  validators: [
    { type: "requiredField", fieldName: "gremlinCommandTemplateId" },
    { type: "requiredField", fieldName: "gremlinTargetTemplateId" },
    { type: "requiredField", fieldName: "gremlinApiKey" }
  ]
});

class GroupExecutionLabel extends React__default.Component {
  constructor() {
    super(...arguments);
    this.subStageClicked = (groupStage, stage) => {
      const { executionService } = ReactInjector;
      executionService.toggleDetails(this.props.execution, groupStage.index, stage.index);
    };
  }
  render() {
    const { stage, width } = this.props;
    if (!this.props.executionMarker) {
      return /* @__PURE__ */ React__default.createElement(ExecutionBarLabel, {
        ...this.props
      });
    }
    return /* @__PURE__ */ React__default.createElement(GroupExecutionPopover, {
      stage,
      subStageClicked: this.subStageClicked,
      width
    }, this.props.children);
  }
}

class GroupMarkerIcon extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "marker-group-icon"
    }, /* @__PURE__ */ React__default.createElement("svg", {
      width: "16",
      height: "12",
      viewBox: "0 0 16 16"
    }, /* @__PURE__ */ React__default.createElement("path", {
      d: "M8 9l-8-4 8-4 8 4zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z"
    })));
  }
}

const GROUP_STAGE = "spinnaker.core.pipeline.stage.groupStage";
class GroupStage {
}
module(GROUP_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    controller: "GroupStageCtrl",
    description: "A group of stages",
    executionLabelComponent: GroupExecutionLabel,
    markerIcon: GroupMarkerIcon,
    key: "group",
    label: "Group",
    templateUrl: "core/src/pipeline/config/stages/group/groupStage.html",
    useCustomTooltip: true,
    synthetic: true,
    validators: []
  });
}).controller("GroupStageCtrl", GroupStage);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/group/groupStage.html", `<div class="form-horizontal"></div>
`);
}]);

const GROUP_STAGE_MODULE = "spinnaker.core.pipeline.stage.group";
module(GROUP_STAGE_MODULE, [GROUP_STAGE]);

const CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSEXECUTIONDETAILS_CONTROLLER = "spinnaker.core.pipeline.stage.jenkins.executionDetails.controller";
module(CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSEXECUTIONDETAILS_CONTROLLER, [UIROUTER_ANGULARJS]).controller("JenkinsExecutionDetailsCtrl", [
  "$scope",
  "$stateParams",
  "executionDetailsSectionService",
  function($scope, $stateParams, executionDetailsSectionService) {
    $scope.configSections = ["jenkinsConfig", "taskStatus", "artifactStatus"];
    const initialized = () => {
      $scope.detailsSection = $stateParams.details;
      getFailureMessage();
    };
    function getFailureMessage() {
      let failureMessage = $scope.stage.failureMessage;
      const context = $scope.stage.context || {};
      const buildInfo = context.buildInfo || {};
      const testResults = buildInfo && buildInfo.testResults && buildInfo.testResults.length ? buildInfo.testResults : [];
      const failingTests = testResults.filter(function(results) {
        return results.failCount > 0;
      });
      const failingTestCount = failingTests.reduce(function(acc, results) {
        return acc + results.failCount;
      }, 0);
      if (buildInfo.result === "FAILURE") {
        failureMessage = "Build failed.";
      }
      if (failingTestCount) {
        failureMessage = failingTestCount + " test(s) failed.";
      }
      $scope.failureMessage = failureMessage;
    }
    const initialize = () => executionDetailsSectionService.synchronizeSection($scope.configSections, initialized);
    initialize();
    $scope.$on("$stateChangeSuccess", initialize);
  }
]);

class JenkinsExecutionLabel extends React__default.Component {
  render() {
    const buildInfo = this.props.stage.masterStage.context.buildInfo || {};
    const testResults = (buildInfo.testResults || []).map((result, index) => /* @__PURE__ */ React__default.createElement("div", {
      key: index
    }, "( ", /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-pass-count"
    }, result.totalCount - result.failCount - result.skipCount), " / ", /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-fail-count"
    }, result.failCount), result.skipCount > 0 && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", null, " / "), /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-skip-count"
    }, result.skipCount)), " )"));
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "stage-label"
    }, /* @__PURE__ */ React__default.createElement("span", null, this.props.stage.name), buildInfo.number && /* @__PURE__ */ React__default.createElement("div", null, "Build #", buildInfo.number), testResults);
  }
}

const CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSSTAGE = "spinnaker.core.pipeline.stage.jenkinsStage";
module(CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    label: "Jenkins",
    description: "Runs a Jenkins job",
    key: "jenkins",
    restartable: true,
    controller: "JenkinsStageCtrl",
    controllerAs: "jenkinsStageCtrl",
    producesArtifacts: true,
    templateUrl: "core/src/pipeline/config/stages/jenkins/jenkinsStage.html",
    executionDetailsUrl: "core/src/pipeline/config/stages/jenkins/jenkinsExecutionDetails.html",
    executionLabelComponent: JenkinsExecutionLabel,
    providesVersionForBake: true,
    extraLabelLines: (stage) => {
      if (!stage.masterStage.context || !stage.masterStage.context.buildInfo) {
        return 0;
      }
      const lines = stage.masterStage.context.buildInfo.number ? 1 : 0;
      return lines + (stage.masterStage.context.buildInfo.testResults || []).length;
    },
    supportsCustomTimeout: true,
    validators: [{ type: "requiredField", fieldName: "job" }],
    strategy: true
  });
}).controller("JenkinsStageCtrl", [
  "$scope",
  "stage",
  function($scope, stage) {
    $scope.stage = stage;
    $scope.stage.failPipeline = $scope.stage.failPipeline === void 0 ? true : $scope.stage.failPipeline;
    $scope.stage.continuePipeline = $scope.stage.continuePipeline === void 0 ? false : $scope.stage.continuePipeline;
    $scope.viewState = {
      mastersLoaded: false,
      mastersRefreshing: false,
      jobsLoaded: false,
      jobsRefreshing: false,
      failureOption: "fail",
      markUnstableAsSuccessful: !!stage.markUnstableAsSuccessful,
      waitForCompletion: stage.waitForCompletion || stage.waitForCompletion === void 0
    };
    this.markUnstableChanged = () => stage.markUnstableAsSuccessful = $scope.viewState.markUnstableAsSuccessful;
    this.waitForCompletionChanged = () => stage.waitForCompletion = $scope.viewState.waitForCompletion;
    function initializeMasters() {
      IgorService.listMasters(BuildServiceType.Jenkins).then(function(masters) {
        $scope.masters = masters;
        $scope.viewState.mastersLoaded = true;
        $scope.viewState.mastersRefreshing = false;
      });
    }
    this.refreshMasters = function() {
      $scope.viewState.mastersRefreshing = true;
      initializeMasters();
    };
    this.refreshJobs = function() {
      $scope.viewState.jobsRefreshing = true;
      updateJobsList();
    };
    function updateJobsList() {
      if ($scope.stage && $scope.stage.master) {
        const master = $scope.stage.master;
        const job = $scope.stage.job || "";
        $scope.viewState.masterIsParameterized = master.includes("${");
        $scope.viewState.jobIsParameterized = job.includes("${");
        if ($scope.viewState.masterIsParameterized || $scope.viewState.jobIsParameterized) {
          $scope.viewState.jobsLoaded = true;
          return;
        }
        $scope.viewState.jobsLoaded = false;
        $scope.jobs = [];
        IgorService.listJobsForMaster($scope.stage.master).then(function(jobs) {
          $scope.viewState.jobsLoaded = true;
          $scope.viewState.jobsRefreshing = false;
          $scope.jobs = jobs;
          if (!$scope.jobs.includes($scope.stage.job)) {
            $scope.stage.job = "";
          }
        });
        $scope.useDefaultParameters = {};
        $scope.userSuppliedParameters = {};
        $scope.jobParams = null;
      }
    }
    function updateJobConfig() {
      const stage2 = $scope.stage;
      const view = $scope.viewState;
      if (stage2 && stage2.master && stage2.job && !view.masterIsParameterized && !view.jobIsParameterized) {
        IgorService.getJobConfig($scope.stage.master, $scope.stage.job).then((config) => {
          config = config || {};
          if (!$scope.stage.parameters) {
            $scope.stage.parameters = {};
          }
          $scope.jobParams = config.parameterDefinitionList;
          $scope.userSuppliedParameters = $scope.stage.parameters;
          $scope.useDefaultParameters = {};
          if ($scope.jobParams) {
            const acceptedJobParameters = $scope.jobParams.map((param) => param.name);
            $scope.invalidParameters = pickBy($scope.userSuppliedParameters, (value, name2) => !acceptedJobParameters.includes(name2));
          }
          const params = $scope.jobParams || [];
          params.forEach((property) => {
            if (!(property.name in $scope.stage.parameters) && property.defaultValue !== null) {
              $scope.useDefaultParameters[property.name] = true;
            }
          });
        });
      }
    }
    $scope.hasInvalidParameters = () => Object.keys($scope.invalidParameters || {}).length;
    $scope.useDefaultParameters = {};
    $scope.userSuppliedParameters = {};
    this.updateParam = function(parameter) {
      if ($scope.useDefaultParameters[parameter] === true) {
        delete $scope.userSuppliedParameters[parameter];
        delete $scope.stage.parameters[parameter];
      } else if ($scope.userSuppliedParameters[parameter]) {
        $scope.stage.parameters[parameter] = $scope.userSuppliedParameters[parameter];
      }
    };
    this.removeInvalidParameters = function() {
      Object.keys($scope.invalidParameters).forEach((param) => {
        if ($scope.stage.parameters[param] !== "undefined") {
          delete $scope.stage.parameters[param];
        }
      });
      $scope.invalidParameters = {};
    };
    initializeMasters();
    $scope.$watch("stage.master", updateJobsList);
    $scope.$watch("stage.job", updateJobConfig);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/jenkins/jenkinsStage.html", `<div class="form-horizontal">
  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">Controller</label>
    <div class="col-md-6">
      <p class="form-control-static" ng-if="viewState.masterIsParameterized">{{stage.master}}</p>
      <ui-select class="form-control input-sm" ng-if="!viewState.masterIsParameterized" ng-model="stage.master">
        <ui-select-match placeholder="Select a controller...">{{$select.selected}}</ui-select-match>
        <ui-select-choices repeat="master in masters | filter: $select.search">
          <span ng-bind-html="master | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="col-md-1 text-center" ng-if="!viewState.masterIsParameterized">
      <a
        href
        ng-click="jenkinsStageCtrl.refreshMasters()"
        tooltip-placement="right"
        uib-tooltip="{{viewState.mastersRefreshing ? 'Masters refreshing.' : 'Refresh masters list' }}"
      >
        <span ng-class="{'fa-spin':viewState.mastersRefreshing}" class="fa fa-sync-alt"></span>
      </a>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">Job</label>
    <div class="col-md-6">
      <p class="form-control-static" ng-if="!stage.master">(Select a controller)</p>
      <p class="form-control-static" ng-if="viewState.masterIsParameterized || viewState.jobIsParameterized">
        {{stage.job}}
      </p>
      <div ng-if="stage.master && viewState.jobsLoaded">
        <ui-select
          class="form-control input-sm"
          ng-if="!viewState.masterIsParameterized && !viewState.jobIsParameterized"
          ng-model="stage.job"
        >
          <ui-select-match placeholder="Select a job...">{{$select.selected}}</ui-select-match>
          <ui-select-choices repeat="job in jobs | filter: $select.search"
            ><span ng-bind-html="job | highlight: $select.search"></span
          ></ui-select-choices>
        </ui-select>
      </div>
      <div class="horizontal center" ng-if="stage.master && !viewState.jobsLoaded">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
    </div>
    <div class="col-md-1 text-center" ng-if="!viewState.masterIsParameterized && !viewState.jobIsParameterized">
      <a
        href
        ng-click="jenkinsStageCtrl.refreshJobs()"
        tooltip-placement="right"
        uib-tooltip="{{viewState.jobsRefreshing ? 'Jobs refreshing.' : 'Refresh job list' }}"
      >
        <span ng-class="{'fa-spin':viewState.jobsRefreshing}" class="fa fa-sync-alt"></span>
      </a>
    </div>
  </div>
  <stage-config-field label="Property File" help-key="pipeline.config.jenkins.propertyFile">
    <input type="text" class="form-control input-sm" ng-model="stage.propertyFile" />
  </stage-config-field>

  <div class="well well-sm clearfix ng-scope col-md-offset-1 col-md-10" ng-if="jobParams">
    <h4 class="text-left">Job Parameters</h4>
    <div class="form-group" ng-repeat="parameter in jobParams | orderBy:'name' ">
      <div class="col-md-3 sm-label-right">
        <b class="break-word">{{parameter.name}}</b>
        <help-field content="{{parameter.description}}" ng-if="parameter.description"></help-field>
      </div>
      <div class="col-md-5" ng-switch on="parameter.type">
        <div ng-switch-when="PasswordParameterDefinition">
          <!-- Passwords do not expose their defaults, for obvious reasons, so we can skip this -->
          <input
            ng-if="!useDefaultParameters[parameter.name]"
            type="password"
            class="form-control input-sm"
            ng-model="userSuppliedParameters[parameter.name]"
            ng-change="updateParam(parameter.name)"
          />
        </div>
        <div ng-switch-when="BooleanParameterDefinition">
          <input
            disabled
            ng-if="useDefaultParameters[parameter.name] && parameter.defaultValue == 'true'"
            type="checkbox"
            class="input-sm"
            checked
          />
          <input
            disabled
            ng-if="useDefaultParameters[parameter.name] && parameter.defaultValue == 'false'"
            type="checkbox"
            class="input-sm"
          />
          <input
            ng-if="!useDefaultParameters[parameter.name]"
            type="checkbox"
            class="input-sm"
            ng-model="userSuppliedParameters[parameter.name]"
            ng-change="updateParam(parameter.name)"
          />
        </div>
        <div ng-switch-when="TextParameterDefinition">
          <textarea
            disabled
            ng-if="useDefaultParameters[parameter.name]"
            class="form-control input-sm"
            ng-model="parameter.defaultValue"
            style="max-width: 100%"
          ></textarea>
          <textarea
            ng-if="!useDefaultParameters[parameter.name]"
            class="form-control input-sm"
            ng-model="userSuppliedParameters[parameter.name]"
            ng-change="updateParam(parameter.name)"
            style="max-width: 100%"
          ></textarea>
        </div>
        <div ng-switch-when="ChoiceParameterDefinition">
          <ui-select
            class="form-control input-sm"
            ng-if="!useDefaultParameters[parameter.name]"
            ng-model="userSuppliedParameters[parameter.name]"
          >
            <ui-select-match placeholder="Select a choice...">{{$select.selected}}</ui-select-match>
            <ui-select-choices repeat="choice in parameter.choices | filter: $select.search track by $index">
              <div ng-class="{ 'break-word' : !choice.includes(' ')}">
                <span ng-bind-html="choice | highlight: $select.search"></span>
              </div>
            </ui-select-choices>
          </ui-select>
          <ui-select
            class="form-control input-sm"
            ng-disabled="useDefaultParameters[parameter.name]"
            search-enabled="false"
            ng-if="useDefaultParameters[parameter.name]"
            ng-model="parameter.defaultValue"
          >
            <ui-select-match placeholder="Select a choice...">{{$select.selected}}</ui-select-match>
            <ui-select-choices repeat="choice in parameter.choices | filter: $select.search track by $index">
              <div ng-class="{ 'break-word' : !choice.includes(' ')}">
                <span ng-bind-html="choice | highlight: $select.search"></span>
              </div>
            </ui-select-choices>
          </ui-select>
        </div>
        <div ng-switch-default>
          <input
            disabled
            ng-if="useDefaultParameters[parameter.name]"
            type="text"
            class="form-control input-sm"
            value="{{parameter.defaultValue}}"
          />
          <input
            ng-if="!useDefaultParameters[parameter.name]"
            type="text"
            class="form-control input-sm"
            ng-model="userSuppliedParameters[parameter.name]"
            ng-change="updateParam(parameter.name)"
          />
        </div>
      </div>
      <div class="checkbox col-md-4" ng-if="parameter.defaultValue!==null">
        <label>
          <input
            type="checkbox"
            ng-model="useDefaultParameters[parameter.name]"
            ng-change="jenkinsStageCtrl.updateParam(parameter.name)"
          />Use default
        </label>
      </div>
    </div>
    <div ng-if="hasInvalidParameters()" class="horizontal center sp-margin-l-top" style="width: 100%">
      <div class="alert alert-danger vertical">
        <p>
          <i class="fa fa-exclamation-triangle"></i>
          The following parameters are not accepted by the jenkins job but are still set in the stage configuration:
        </p>
        <div ng-repeat="(paramName, paramValue) in invalidParameters" class="flex-container-h" style="margin: 0.5em">
          <label class="col-md-2">{{paramName}}</label>
          <input class="flex-grow" type="text" style="width: 100%" disabled value="{{paramValue}}" />
        </div>
        <button class="self-right passive" ng-click="jenkinsStageCtrl.removeInvalidParameters()">Remove all</button>
      </div>
    </div>
  </div>

  <stage-config-field label="Wait for results" help-key="jenkins.waitForCompletion">
    <input
      type="checkbox"
      class="input-sm"
      name="waitForCompletion"
      ng-model="viewState.waitForCompletion"
      ng-change="jenkinsStageCtrl.waitForCompletionChanged()"
    />
  </stage-config-field>

  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">If build is unstable</label>
    <div class="col-md-9">
      <div class="radio">
        <label>
          <input
            type="radio"
            ng-model="viewState.markUnstableAsSuccessful"
            ng-change="jenkinsStageCtrl.markUnstableChanged()"
            ng-value="false"
          />
          fail the stage
          <help-field key="pipeline.config.jenkins.markUnstableAsSuccessful.false"></help-field>
        </label>
      </div>
      <div class="radio">
        <label>
          <input
            type="radio"
            ng-model="viewState.markUnstableAsSuccessful"
            ng-change="jenkinsStageCtrl.markUnstableChanged()"
            ng-value="true"
          />
          consider stage successful
          <help-field key="pipeline.config.jenkins.markUnstableAsSuccessful.true"></help-field>
        </label>
      </div>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/jenkins/jenkinsExecutionDetails.html", `<div ng-controller="JenkinsExecutionDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'jenkinsConfig'">
    <div class="row">
      <div class="col-md-{{stage.context.buildInfo.testResults ? 6 : 12}}">
        <h5>Jenkins Stage Configuration</h5>
        <dl class="dl-narrow dl-horizontal">
          <dt>Controller</dt>
          <dd>{{stage.context.master}}</dd>
          <dt>Job</dt>
          <dd>{{stage.context.job}}</dd>
          <dt>Build</dt>
          <dd>
            <span ng-if="!stage.context.buildInfo">{{stage.context.buildNumber}}</span>
            <a ng-if="stage.context.buildInfo.url" href="{{stage.context.buildInfo.url}}" target="_blank"
              >#{{stage.context.buildInfo.number}}</a
            >
          </dd>
        </dl>
      </div>
      <div class="col-md-6" ng-if="stage.context.buildInfo.testResults">
        <h5>Test Results</h5>
        <div class="row" ng-repeat="result in stage.context.buildInfo.testResults">
          <div class="col-md-6">
            <p>
              <a target="_blank" href="{{stage.context.buildInfo.url}}{{result.urlName}}" class="pad-left">
                {{result.urlName | robotToHuman }}
              </a>
            </p>
          </div>
          <div class="col-md-6">
            <p class="test-results">
              <span class="test-result-section">
                {{result.totalCount - result.failCount - result.skipCount}} <span class="small fa fa-check"></span>
              </span>
              <span class="test-result-section">
                {{result.failCount}} <span class="small glyphicon glyphicon-remove informational"></span>
              </span>
              <span class="test-result-section" ng-if="result.skipCount">
                {{result.skipCount}} <span class="small glyphicon glyphicon-minus"></span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" ng-if="stage.context.parameters">
      <div class="col-md-12">
        <h5 style="margin-bottom: 0; padding-bottom: 5px">Parameters</h5>
        <dl>
          <dt ng-repeat-start="(key, val) in stage.context.parameters">{{key}}</dt>
          <dd ng-repeat-end>{{val}}</dd>
        </dl>
      </div>
    </div>

    <div class="row" ng-if="stage.context.propertyFileContents">
      <div class="col-md-12">
        <h5 style="margin-bottom: 0; padding-bottom: 5px">Property File</h5>
        <dl>
          <dt ng-repeat-start="(key, val) in stage.context.propertyFileContents">{{key}}</dt>
          <dd ng-repeat-end>{{val}}</dd>
        </dl>
      </div>
    </div>

    <stage-failure-message
      stage="stage"
      ng-if="stage.isFailed"
      message="ctrl.getException(stage) || failureMessage"
    ></stage-failure-message>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
  <div class="step-section-details" ng-if="detailsSection === 'artifactStatus'">
    <execution-artifact-tab stage="stage" execution="execution"></execution-artifact-tab>
  </div>
</div>
`);
}]);

const CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSSTAGE_MODULE = "spinnaker.core.pipeline.stage.jenkins";
module(CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSSTAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSSTAGE,
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  STAGE_COMMON_MODULE,
  TIME_FORMATTERS,
  CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSEXECUTIONDETAILS_CONTROLLER
]);

const NOT_FOUND = "Not found";
const ERROR_MESSAGE_MAP = {
  missing_property: "The following property is missing:",
  invalid_type: "The type of the following property is invalid:",
  invalid_format: "The format of the following property is invalid:",
  invalid_value: "The value of the following property is invalid:"
};
const CustomErrorMessage = ({ summary, debugDetails }) => {
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, /* @__PURE__ */ React__default.createElement("b", null, "There was an error importing your delivery config file."), /* @__PURE__ */ React__default.createElement("br", null), /* @__PURE__ */ React__default.createElement(Markdown, {
    message: summary,
    style: { wordBreak: "break-word" }
  }), /* @__PURE__ */ React__default.createElement("br", null), debugDetails && /* @__PURE__ */ React__default.createElement(CollapsibleSection, {
    heading: ({ chevron }) => /* @__PURE__ */ React__default.createElement("span", null, chevron, " Debug Details")
  }, /* @__PURE__ */ React__default.createElement("pre", {
    style: { whiteSpace: "pre-wrap" }
  }, debugDetails))));
};
function extractCustomError(error) {
  if (!error) {
    return null;
  }
  if (!error.details) {
    return { summary: error.message };
  }
  const pathExpression = error.details.pathExpression.substring(1).replace(/\./g, "/");
  const errorMessage = ERROR_MESSAGE_MAP[error.details.error] ? `${ERROR_MESSAGE_MAP[error.details.error]}<br/> \`${pathExpression}\`` : "Unknown error";
  return { summary: errorMessage, debugDetails: error.details.message };
}
function ImportDeliveryConfigExecutionDetails(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { stage } = props;
  const trigger = props.execution.trigger;
  const manifestPath = ((_a = SETTINGS.managedDelivery) == null ? void 0 : _a.manifestBasePath) + "/" + ((_c = stage.context.manifest) != null ? _c : (_b = SETTINGS.managedDelivery) == null ? void 0 : _b.defaultManifest);
  const customError = extractCustomError(stage.context.error);
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "SCM"), /* @__PURE__ */ React__default.createElement("dd", null, (_d = trigger.source) != null ? _d : NOT_FOUND), /* @__PURE__ */ React__default.createElement("dt", null, "Project"), /* @__PURE__ */ React__default.createElement("dd", null, (_e = trigger.project) != null ? _e : NOT_FOUND), /* @__PURE__ */ React__default.createElement("dt", null, "Repository"), /* @__PURE__ */ React__default.createElement("dd", null, (_f = trigger.slug) != null ? _f : NOT_FOUND), /* @__PURE__ */ React__default.createElement("dt", null, "Manifest Path"), /* @__PURE__ */ React__default.createElement("dd", null, manifestPath != null ? manifestPath : NOT_FOUND), /* @__PURE__ */ React__default.createElement("dt", null, "Branch"), /* @__PURE__ */ React__default.createElement("dd", null, (_g = trigger.branch) != null ? _g : NOT_FOUND), /* @__PURE__ */ React__default.createElement("dt", null, "Commit"), /* @__PURE__ */ React__default.createElement("dd", null, (_i = (_h = trigger.hash) == null ? void 0 : _h.substring(0, 7)) != null ? _i : NOT_FOUND)))), customError ? /* @__PURE__ */ React__default.createElement(CustomErrorMessage, {
    summary: customError.summary,
    debugDetails: customError.debugDetails
  }) : /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage
  }));
}
(function(ImportDeliveryConfigExecutionDetails2) {
  ImportDeliveryConfigExecutionDetails2.title = "Configuration";
})(ImportDeliveryConfigExecutionDetails || (ImportDeliveryConfigExecutionDetails = {}));

const ImportDeliveryConfigStageConfig = (stageConfigProps) => /* @__PURE__ */ React__default.createElement(FormikStageConfig, {
  ...stageConfigProps,
  onChange: stageConfigProps.updateStage,
  render: () => /* @__PURE__ */ React__default.createElement("div", {
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "manifest",
    label: "Manifest Path",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.deliveryConfig.manifest"
    }),
    input: (props) => {
      var _a, _b;
      return /* @__PURE__ */ React__default.createElement(TextInput, {
        ...props,
        prefix: ((_a = SETTINGS.managedDelivery) == null ? void 0 : _a.manifestBasePath) + "/",
        placeholder: (_b = SETTINGS.managedDelivery) == null ? void 0 : _b.defaultManifest
      });
    }
  }))
});

if (SETTINGS.feature.managedDelivery) {
  Registry.pipeline.registerStage({
    label: "Import Delivery Config",
    description: "Retrieve a Delivery Config manifest from the git repository configured in the pipeline's trigger, then update it in Spinnaker.",
    extendedDescription: `<a target="_blank" href="https://www.spinnaker.io/guides/user/managed-delivery/git-based-workflows/">
      <span class="small glyphicon glyphicon-file"></span> Documentation</a>`,
    key: "importDeliveryConfig",
    restartable: false,
    component: ImportDeliveryConfigStageConfig,
    executionDetailsSections: [ImportDeliveryConfigExecutionDetails, ExecutionDetailsTasks],
    validators: [
      {
        type: "repositoryInformationProvided",
        getMessage: (labels) => `
          This stage requires one of the following triggers to locate your Delivery Config manifest:
          <ul>${labels.map((label) => `<li>${label}</li>`)}</ul>
          `
      }
    ]
  });
}

class ManualJudgmentService {
  constructor(executionService) {
    this.executionService = executionService;
  }
  provideJudgment(application, execution, stage, judgmentStatus, judgmentInput) {
    const matcher = (result) => {
      const match = result.stages.find((test) => test.id === stage.id);
      return match && match.status !== "RUNNING";
    };
    return this.executionService.patchExecution(execution.id, stage.id, { judgmentStatus, judgmentInput }).then(() => this.executionService.waitUntilExecutionMatches(execution.id, matcher)).then((updated) => this.executionService.updateExecution(application, updated));
  }
}
ManualJudgmentService.$inject = ["executionService"];
const MANUAL_JUDGMENT_SERVICE = "spinnaker.core.pipeline.config.stages.manualJudgment.service";
module(MANUAL_JUDGMENT_SERVICE, [EXECUTION_SERVICE]).service("manualJudgmentService", ManualJudgmentService);

class ManualJudgmentApproval extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleJudgementChanged = (option) => {
      this.setState({ judgmentInput: { value: option.value } });
    };
    this.handleContinueClick = () => {
      this.provideJudgment("continue");
    };
    this.handleStopClick = () => {
      this.provideJudgment("stop");
    };
    this.state = {
      submitting: false,
      judgmentDecision: null,
      judgmentInput: {},
      applicationRoles: {},
      userRoles: [],
      error: false
    };
  }
  componentDidMount() {
    const applicationName = this.props.execution.application;
    ApplicationReader.getApplicationPermissions(applicationName).then((result) => {
      if (result) {
        this.setState({
          applicationRoles: result
        });
      }
    });
    this.setState({
      userRoles: AuthenticationService.getAuthenticatedUser().roles
    });
  }
  provideJudgment(judgmentDecision) {
    const { application, execution, stage } = this.props;
    const judgmentInput = this.state.judgmentInput ? this.state.judgmentInput.value : null;
    this.setState({ submitting: true, error: false, judgmentDecision });
    ReactInjector.manualJudgmentService.provideJudgment(application, execution, stage, judgmentDecision, judgmentInput);
  }
  isManualJudgmentStageNotAuthorized() {
    var _a, _b;
    let isStageNotAuthorized = true;
    let returnOnceFalse = true;
    const { applicationRoles, userRoles } = this.state;
    const stageRoles = ((_b = (_a = this.props.stage) == null ? void 0 : _a.context) == null ? void 0 : _b.selectedStageRoles) || [];
    if (!stageRoles.length) {
      isStageNotAuthorized = false;
      return isStageNotAuthorized;
    }
    const { CREATE, EXECUTE, WRITE } = applicationRoles;
    userRoles.forEach((userRole) => {
      if (returnOnceFalse) {
        if (stageRoles.includes(userRole)) {
          isStageNotAuthorized = (WRITE || []).includes(userRole) || (EXECUTE || []).includes(userRole) || (CREATE || []).includes(userRole);
          if (isStageNotAuthorized) {
            isStageNotAuthorized = false;
            returnOnceFalse = false;
          } else {
            isStageNotAuthorized = true;
          }
        }
      }
    });
    return isStageNotAuthorized;
  }
  isSubmitting(decision) {
    return this.props.stage.context.judgmentStatus === decision || this.state.submitting && this.state.judgmentDecision === decision;
  }
  render() {
    const stage = this.props.stage;
    const status = stage.status;
    const options = (stage.context.judgmentInputs || []).map((o) => {
      return { value: o.value, label: o.value };
    });
    const showOptions = !["SKIPPED", "SUCCEEDED"].includes(status) && (!stage.context.judgmentStatus || status === "RUNNING");
    const hasInstructions = !!stage.context.instructions;
    return /* @__PURE__ */ React__default.createElement("div", null, hasInstructions && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, "Instructions")), /* @__PURE__ */ React__default.createElement(Markdown, {
      message: stage.context.instructions
    })), showOptions && /* @__PURE__ */ React__default.createElement("div", null, options.length > 0 && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("b", null, "Judgment Input")), /* @__PURE__ */ React__default.createElement(Select, {
      options,
      clearable: false,
      value: this.state.judgmentInput.value,
      onChange: this.handleJudgementChanged
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "action-buttons"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-danger",
      onClick: this.handleStopClick,
      disabled: this.isManualJudgmentStageNotAuthorized() || this.state.submitting || stage.context.judgmentStatus || options.length && !this.state.judgmentInput.value
    }, this.isSubmitting("stop") && /* @__PURE__ */ React__default.createElement(Spinner, {
      mode: "circular"
    }), stage.context.stopButtonLabel || "Stop"), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      disabled: this.isManualJudgmentStageNotAuthorized() || this.state.submitting || stage.context.judgmentStatus || options.length && !this.state.judgmentInput.value,
      onClick: this.handleContinueClick
    }, this.isSubmitting("continue") && /* @__PURE__ */ React__default.createElement(Spinner, {
      mode: "circular"
    }), stage.context.continueButtonLabel || "Continue"))), this.state.error && /* @__PURE__ */ React__default.createElement("div", {
      className: "error-message"
    }, "There was an error recording your decision. Please try again."));
  }
}

class ManualJudgmentExecutionDetails extends React__default.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { application, execution, stage, current, name } = this.props;
    const hasJudgment = stage.context.judgmentStatus || ["SKIPPED", "SUCCEEDED"].includes(stage.status);
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React__default.createElement("dl", {
      className: "no-margin"
    }, hasJudgment && /* @__PURE__ */ React__default.createElement("dt", {
      key: "title"
    }, "Judgment"), hasJudgment && /* @__PURE__ */ React__default.createElement("dd", {
      key: "value"
    }, robotToHuman(stage.context.judgmentStatus || "No judgment made")), stage.status === "SKIPPED" && /* @__PURE__ */ React__default.createElement("dd", null, "Skipped"), stage.context.lastModifiedBy && /* @__PURE__ */ React__default.createElement("dt", null, "Judged By"), stage.context.lastModifiedBy && /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement("span", null, stage.context.lastModifiedBy), stage.context.propagateAuthenticationContext && /* @__PURE__ */ React__default.createElement("span", null, " ", "(", /* @__PURE__ */ React__default.createElement("em", null, "authentication propagated"), ")"), /* @__PURE__ */ React__default.createElement("br", null), timestamp(stage.endTime)), stage.context.judgmentInput && /* @__PURE__ */ React__default.createElement("dt", null, "Input"), stage.context.judgmentInput && /* @__PURE__ */ React__default.createElement("dd", null, robotToHuman(stage.context.judgmentInput))), /* @__PURE__ */ React__default.createElement(ManualJudgmentApproval, {
      key: stage.refId,
      application,
      execution,
      stage
    }), stage.context.judgmentInput && /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: stage.failureMessage
    }));
  }
}
ManualJudgmentExecutionDetails.title = "manualJudgment";

class ManualJudgmentExecutionLabel extends React__default.Component {
  render() {
    if (!this.props.executionMarker) {
      return /* @__PURE__ */ React__default.createElement(ExecutionBarLabel, {
        ...this.props
      });
    }
    const stage = this.props.stage;
    if (stage.isRunning) {
      const template = /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, stage.name)), /* @__PURE__ */ React__default.createElement(ManualJudgmentApproval, {
        stage: stage.masterStage,
        application: this.props.application,
        execution: this.props.execution
      }));
      return /* @__PURE__ */ React__default.createElement(HoverablePopover, {
        template
      }, this.props.children);
    }
    const tooltip = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
      id: stage.id
    }, stage.name);
    return /* @__PURE__ */ React__default.createElement(OverlayTrigger, {
      placement: "top",
      overlay: tooltip
    }, /* @__PURE__ */ React__default.createElement("span", null, this.props.children));
  }
}

class ManualJudgmentMarkerIcon extends React__default.Component {
  constructor(props) {
    super(props);
  }
  render() {
    if (this.props.stage.isRunning) {
      return /* @__PURE__ */ React__default.createElement("span", {
        className: "fa fa-child"
      });
    }
    return null;
  }
}

const CORE_PIPELINE_CONFIG_STAGES_MANUALJUDGMENT_MANUALJUDGMENTSTAGE = "spinnaker.core.pipeline.stage.manualJudgmentStage";
module(CORE_PIPELINE_CONFIG_STAGES_MANUALJUDGMENT_MANUALJUDGMENTSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    label: "Manual Judgment",
    description: "Waits for user approval before continuing",
    key: "manualJudgment",
    restartable: true,
    controller: "ManualJudgmentStageCtrl",
    controllerAs: "manualJudgmentStageCtrl",
    templateUrl: "core/src/pipeline/config/stages/manualJudgment/manualJudgmentStage.html",
    executionDetailsSections: [ManualJudgmentExecutionDetails, ExecutionDetailsTasks],
    executionLabelComponent: ManualJudgmentExecutionLabel,
    useCustomTooltip: true,
    markerIcon: ManualJudgmentMarkerIcon,
    strategy: true,
    supportsCustomTimeout: true,
    disableNotifications: true
  });
}).controller("ManualJudgmentStageCtrl", [
  "$scope",
  function($scope) {
    $scope.authEnabled = SETTINGS.authEnabled;
    $scope.stage.notifications = $scope.stage.notifications || [];
    $scope.stage.judgmentInputs = $scope.stage.judgmentInputs || [];
    $scope.stage.failPipeline = $scope.stage.failPipeline === void 0 ? true : $scope.stage.failPipeline;
    this.transformToNewStyleIfNecessary = function(notifications) {
      if (notifications.length && !$scope.stage.sendNotifications) {
        each(notifications, function(notification) {
          notification.level = "stage";
          notification.when = ["manualJudgment"];
        });
        $scope.stage.sendNotifications = true;
      }
    };
    this.transformToNewStyleIfNecessary($scope.stage.notifications);
    this.manageStateOnToggle = function() {
      if (!$scope.stage.sendNotifications) {
        $scope.stage.notifications.length = 0;
      }
    };
    this.addJudgmentInput = function() {
      if (!$scope.stage.judgmentInputs) {
        $scope.stage.judgmentInputs = [];
      }
      const judgmentInput = {};
      $scope.stage.judgmentInputs.push(judgmentInput);
    };
    this.removeJudgmentInput = function(idx) {
      $scope.stage.judgmentInputs.splice(idx, 1);
    };
    this.updateNotifications = function(notifications) {
      if ($scope.parent && !$scope.parent.notifications) {
        $scope.parent.notifications = [];
      }
      $scope.stage.notifications = notifications;
      $scope.$digest();
    };
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/manualJudgment/manualJudgmentStage.html", `<div class="form-horizontal">
  <stage-config-field label="Instructions" help-key="pipeline.config.manualJudgment.instructions">
    <textarea
      class="form-control input-sm"
      ng-model="stage.instructions"
      placeholder="Provide any instructional text that would assist making a manual judgment (can contain HTML)"
    >
    </textarea>
  </stage-config-field>
  <div ng-if="authEnabled">
    <stage-config-field
      label="Propagate Authentication"
      help-key="pipeline.config.manualJudgment.propagateAuthentication"
    >
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-model="stage.propagateAuthenticationContext" />
        </label>
      </div>
    </stage-config-field>
  </div>
  <stage-config-field label="Judgment Inputs" help-key="pipeline.config.manualJudgment.judgmentInputs">
    <table class="table table-condensed packed">
      <thead>
        <tr>
          <th style="width: 30%">Option</th>
          <th class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="judgmentInput in stage.judgmentInputs track by $index">
          <td>
            <input
              type="text"
              required
              ng-model="judgmentInput.value"
              value="{{judgmentInput.value}}"
              class="form-control input-sm"
            />
          </td>
          <td class="text-right">
            <a class="small" href ng-click="manualJudgmentStageCtrl.removeJudgmentInput($index)">Remove</a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="7">
            <button class="btn btn-block btn-sm add-new" ng-click="manualJudgmentStageCtrl.addJudgmentInput()">
              <span class="glyphicon glyphicon-plus-sign"></span> Add judgment input
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </stage-config-field>
  <stage-config-field label="Send Notifications">
    <div class="checkbox">
      <label>
        <input
          type="checkbox"
          ng-false-value="undefined"
          ng-change="manualJudgmentStageCtrl.manageStateOnToggle()"
          ng-model="stage.sendNotifications"
        />
      </label>
    </div>
  </stage-config-field>
  <div class="row" ng-if="stage.sendNotifications">
    <stage-config-field>
      <notification-list
        level="'stage'"
        stage-type="'manualJudgment'"
        notifications="stage.notifications"
        send-notifications="stage.sendNotifications"
        update-notifications="manualJudgmentStageCtrl.updateNotifications"
      ></notification-list>
    </stage-config-field>
  </div>
</div>
`);
}]);

var css_248z$v = ".execution-marker.execution-marker-running.stage-type-manualjudgment {\n  background-color: var(--color-alert);\n  fill: var(--color-alert);\n  -webkit-animation: none;\n          animation: none;\n}\n";
styleInject(css_248z$v);

const MANUAL_JUDGMENT_STAGE_MODULE = "spinnaker.core.pipeline.stage.manualJudgment";
module(MANUAL_JUDGMENT_STAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  MANUAL_JUDGMENT_SERVICE,
  STAGE_COMMON_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_MANUALJUDGMENT_MANUALJUDGMENTSTAGE
]);

function MonitorPipelineStageExecutionDetails(props) {
  const {
    stage: { context = {}, outputs = {} },
    stage,
    name,
    current
  } = props;
  const statuses = ___default.sortBy(Object.keys(outputs.executionStatuses).map((executionId) => {
    var _a, _b, _c, _d;
    const status = { ...outputs.executionStatuses[executionId] };
    status.executionId = executionId;
    const generalException = status.exception;
    if (generalException) {
      const errors = ((_b = (_a = generalException.details) == null ? void 0 : _a.errors) != null ? _b : []).filter((m) => !!m);
      if (errors.length) {
        status.failureMessage = errors.join("\n\n");
      } else {
        status.failureMessage = (_d = (_c = generalException.details) == null ? void 0 : _c.error) != null ? _d : null;
      }
    }
    return status;
  }), "status");
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name,
    current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("h5", null, "Monitor behavior"), context.monitorBehavior, /* @__PURE__ */ React__default.createElement("h5", null, "Executions"), statuses.map((status) => {
    return /* @__PURE__ */ React__default.createElement("div", {
      key: status.executionId
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "label label-default label-" + status.status.toLowerCase()
    }, status.status), " ", /* @__PURE__ */ React__default.createElement(UISref, {
      key: status.executionId,
      to: "home.applications.application.pipelines.executionDetails.execution",
      params: {
        application: status.application,
        executionId: status.executionId
      },
      options: { inherit: false, reload: "home.applications.application.pipelines.executionDetails" }
    }, /* @__PURE__ */ React__default.createElement("a", null, status.executionId)), " ", "(", status.application, ")", status.failureMessage && /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: status.failureMessage
    }));
  }))), /* @__PURE__ */ React__default.createElement("br", null), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage,
    message: stage.failureMessage
  }));
}
(function(MonitorPipelineStageExecutionDetails2) {
  MonitorPipelineStageExecutionDetails2.title = "monitorPipelineConfig";
})(MonitorPipelineStageExecutionDetails || (MonitorPipelineStageExecutionDetails = {}));

const CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE = "spinnaker.core.pipeline.stage.monitorPipelineStage";
module(CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    label: "Monitor Pipeline",
    description: "Monitors pipeline execution",
    key: "monitorPipeline",
    restartable: true,
    synthetic: true,
    executionDetailsSections: [MonitorPipelineStageExecutionDetails, ExecutionDetailsTasks]
  });
});

const CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE_MODULE = "spinnaker.core.pipeline.stage.monitorPipeline";
module(CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE
]);

function getDeploymentMonitorSummary(stage) {
  if (stage.hasNotStarted) {
    return "Not available because the stage hasn't run yet";
  }
  const { context } = stage;
  return get(context, "deploymentMonitorReasons.summary", "<NOT PROVIDED>");
}
function getDeploymentMonitorName(stage, monitors) {
  return monitors.find((x) => x.id === stage.context.deploymentMonitor.id).name;
}
function getDeploymentMonitorSupportUrl(stage, monitors) {
  return monitors.find((x) => x.id === stage.context.deploymentMonitor.id).supportContact;
}
function getDeploymentMonitorDetails(stage) {
  const { context } = stage;
  return get(context, "deploymentMonitorReasons.reason.message", null);
}
function getDeploymentMonitorLog(stage) {
  const { context } = stage;
  const logArray = get(context, "deploymentMonitorReasons.reason.logSummary", null);
  if (isEmpty(logArray)) {
    return null;
  }
  return logArray.map((logLine, i) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
    key: i
  }, /* @__PURE__ */ React__default.createElement("span", null, logLine), /* @__PURE__ */ React__default.createElement("br", null)));
}
function getDeploymentMonitorAdditionalDetails(stage) {
  const { context } = stage;
  const additionalData = get(context, "deploymentMonitorReasons.reason.additionalData", []);
  if (!isEmpty(additionalData)) {
    return additionalData.map(({ key, link, text }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
      key: key + link + text
    }, /* @__PURE__ */ React__default.createElement("dt", null, key), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement("a", {
      href: link,
      target: "_blank"
    }, text))));
  }
  return null;
}
class DeploymentMonitorExecutionDetails extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { deploymentMonitors: null };
  }
  componentDidMount() {
    DeploymentMonitorReader.getDeploymentMonitors().then((deploymentMonitors) => {
      this.setState({ deploymentMonitors });
    });
  }
  render() {
    const { stage, current, name } = this.props;
    const { deploymentMonitors } = this.state;
    const additionalDetails = getDeploymentMonitorAdditionalDetails(stage);
    const log = getDeploymentMonitorLog(stage);
    const details = getDeploymentMonitorDetails(stage);
    const notProvidedFragment = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("i", null, "<NOT PROVIDED>"));
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name,
      current
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-12"
    }, /* @__PURE__ */ React__default.createElement("dl", {
      className: "dl-narrow dl-horizontal"
    }, /* @__PURE__ */ React__default.createElement("dt", null, "Summary"), /* @__PURE__ */ React__default.createElement("dd", null, getDeploymentMonitorSummary(stage)), stage.hasNotStarted ? null : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("dt", {
      className: "sp-margin-l-bottom"
    }, "Deploy %"), /* @__PURE__ */ React__default.createElement("dd", {
      className: "sp-margin-l-bottom"
    }, /* @__PURE__ */ React__default.createElement("span", null, stage.context.currentProgress, "%")), /* @__PURE__ */ React__default.createElement("dt", null, "Details"), /* @__PURE__ */ React__default.createElement("dd", null, details || notProvidedFragment), /* @__PURE__ */ React__default.createElement("dt", {
      className: "sp-margin-l-bottom"
    }, "Log"), /* @__PURE__ */ React__default.createElement("dd", {
      className: "sp-margin-l-bottom"
    }, log ? /* @__PURE__ */ React__default.createElement("pre", null, log) : notProvidedFragment), /* @__PURE__ */ React__default.createElement("dt", null, "More info"), /* @__PURE__ */ React__default.createElement("dd", null, additionalDetails ? null : notProvidedFragment), additionalDetails)), deploymentMonitors && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-info"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "NOTE:"), " This information is provided by the\xA0", /* @__PURE__ */ React__default.createElement("strong", null, getDeploymentMonitorName(stage, deploymentMonitors)), " deployment monitor.", /* @__PURE__ */ React__default.createElement("br", null), "If you are experiencing issues with the analysis, please reach out to", " ", /* @__PURE__ */ React__default.createElement("a", {
      href: getDeploymentMonitorSupportUrl(stage, deploymentMonitors),
      target: "_blank"
    }, "support for ", getDeploymentMonitorName(stage, deploymentMonitors))))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
      stage,
      message: stage.failureMessage
    }));
  }
}
DeploymentMonitorExecutionDetails.title = "evaluateDeploymentHealth";

const EVALUATE_HEALTH_STAGE = "spinnaker.core.pipeline.stage.monitored.evaluatehealthstage";
module(EVALUATE_HEALTH_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    synthetic: true,
    key: "evaluateDeploymentHealth",
    executionDetailsSections: [DeploymentMonitorExecutionDetails]
  });
});

const NOTIFY_DEPLOY_STARTING_STAGE = "spinnaker.core.pipeline.stage.monitored.notifydeploystartingstage";
module(NOTIFY_DEPLOY_STARTING_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    synthetic: true,
    key: "notifyDeployStarting",
    executionDetailsSections: [DeploymentMonitorExecutionDetails]
  });
});

function PipelineParametersExecutionDetails(props) {
  const {
    stage: { context = {} },
    name,
    current
  } = props;
  const { pipelineParameters: parameters = {} } = context;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name,
    current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("h5", null, "Parameters"), /* @__PURE__ */ React__default.createElement("dl", null, Object.keys(parameters).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())).map((key) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
    key
  }, /* @__PURE__ */ React__default.createElement("dt", null, key), /* @__PURE__ */ React__default.createElement("dd", null, parameters[key].toString())))))));
}
(function(PipelineParametersExecutionDetails2) {
  PipelineParametersExecutionDetails2.title = "parameters";
})(PipelineParametersExecutionDetails || (PipelineParametersExecutionDetails = {}));

const CORE_PIPELINE_CONFIG_STAGES_PIPELINE_PIPELINESTAGE = "spinnaker.core.pipeline.stage.pipelineStage";
module(CORE_PIPELINE_CONFIG_STAGES_PIPELINE_PIPELINESTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    label: "Pipeline",
    description: "Runs a pipeline",
    key: "pipeline",
    restartable: true,
    controller: "pipelineStageCtrl",
    controllerAs: "pipelineStageCtrl",
    producesArtifacts: true,
    templateUrl: "core/src/pipeline/config/stages/pipeline/pipelineStage.html",
    executionDetailsSections: [
      PipelineStageExecutionDetails,
      PipelineParametersExecutionDetails,
      ExecutionDetailsTasks
    ],
    supportsCustomTimeout: true,
    validators: [{ type: "requiredField", fieldName: "pipeline" }]
  });
}).controller("pipelineStageCtrl", [
  "$scope",
  "stage",
  function($scope, stage) {
    $scope.stage = stage;
    $scope.stage.failPipeline = $scope.stage.failPipeline === void 0 ? true : $scope.stage.failPipeline;
    $scope.stage.waitForCompletion = $scope.stage.waitForCompletion === void 0 ? true : $scope.stage.waitForCompletion;
    if (!$scope.stage.application) {
      $scope.stage.application = $scope.application.name;
    }
    $scope.viewState = {
      mastersLoaded: false,
      mastersRefreshing: false,
      mastersLastRefreshed: null,
      pipelinesLoaded: false,
      jobsRefreshing: false,
      jobsLastRefreshed: null,
      infiniteScroll: {
        numToAdd: 20,
        currentItems: 20
      }
    };
    this.hasSpel = function(string) {
      return string && string.includes("${");
    };
    this.addMoreItems = function() {
      $scope.viewState.infiniteScroll.currentItems += $scope.viewState.infiniteScroll.numToAdd;
    };
    ApplicationReader.listApplications().then(function(applications) {
      $scope.applications = _.map(applications, "name").sort();
      initializeMasters();
    });
    function initializeMasters() {
      if ($scope.stage.application && !$scope.stage.application.includes("${")) {
        PipelineConfigService.getPipelinesForApplication($scope.stage.application).then(function(pipelines) {
          $scope.pipelines = _.filter(pipelines, (pipeline) => pipeline.id !== $scope.pipeline.id);
          const pipelineId = $scope.stage.pipeline;
          const isFound = _.find(pipelines, (pipeline) => pipeline.id === pipelineId);
          if (!isFound && pipelineId && !pipelineId.includes("${")) {
            $scope.stage.pipeline = null;
          }
          $scope.viewState.pipelinesLoaded = true;
          updatePipelineConfig();
        });
      }
    }
    function updatePipelineConfig() {
      const pipeline = $scope.stage && $scope.stage.pipeline;
      if (pipeline && pipeline.includes("${")) {
        return;
      }
      if ($scope.stage && $scope.stage.application && pipeline) {
        const config = _.find($scope.pipelines, (pipeline2) => pipeline2.id === $scope.stage.pipeline);
        if (config && PipelineTemplateV2Service.isV2PipelineConfig(config)) {
          PipelineTemplateReader.getPipelinePlan(config).then((plan) => applyPipelineConfigParameters(plan)).catch(() => clearParams());
        } else {
          applyPipelineConfigParameters(config);
        }
      } else {
        clearParams();
      }
    }
    function applyPipelineConfigParameters(config) {
      if (config && config.parameterConfig) {
        if (!$scope.stage.pipelineParameters) {
          $scope.stage.pipelineParameters = {};
        }
        $scope.pipelineParameters = config.parameterConfig;
        $scope.pipelineParameters.forEach((parameterConfig) => {
          if (parameterConfig.default && parameterConfig.options && !parameterConfig.options.some((option) => option.value === parameterConfig.default)) {
            parameterConfig.options.unshift({ value: parameterConfig.default });
          }
        });
        $scope.userSuppliedParameters = $scope.stage.pipelineParameters;
        if ($scope.pipelineParameters) {
          const acceptedPipelineParams = $scope.pipelineParameters.map((param) => param.name);
          $scope.invalidParameters = pickBy($scope.userSuppliedParameters, (value, name2) => !acceptedPipelineParams.includes(name2));
        }
        $scope.hasInvalidParameters = () => Object.keys($scope.invalidParameters || {}).length;
        $scope.useDefaultParameters = {};
        _.each($scope.pipelineParameters, function(property) {
          if (!(property.name in $scope.stage.pipelineParameters) && property.default !== null) {
            $scope.useDefaultParameters[property.name] = true;
          }
        });
      } else {
        clearParams();
      }
    }
    function clearParams() {
      $scope.pipelineParameters = {};
      $scope.useDefaultParameters = {};
      $scope.userSuppliedParameters = {};
    }
    $scope.useDefaultParameters = {};
    $scope.userSuppliedParameters = {};
    this.updateParam = function(parameter) {
      if ($scope.useDefaultParameters[parameter] === true) {
        delete $scope.userSuppliedParameters[parameter];
        delete $scope.stage.pipelineParameters[parameter];
      } else if ($scope.userSuppliedParameters[parameter]) {
        $scope.stage.pipelineParameters[parameter] = $scope.userSuppliedParameters[parameter] || "";
      }
    };
    this.removeInvalidParameters = function() {
      Object.keys($scope.invalidParameters).forEach((param) => {
        if ($scope.stage.pipelineParameters[param] !== "undefined") {
          delete $scope.stage.pipelineParameters[param];
        }
      });
      $scope.invalidParameters = [];
    };
    $scope.$watch("stage.application", initializeMasters);
    $scope.$watch("stage.pipeline", updatePipelineConfig);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/pipeline/pipelineStage.html", `<div class="form-horizontal">
  <stage-config-field label="Application">
    <input
      ng-model="stage.application"
      class="form-control input-sm"
      ng-if="pipelineStageCtrl.hasSpel(stage.application)"
    />
    <ui-select
      ng-model="stage.application"
      class="form-control input-sm"
      ng-if="!pipelineStageCtrl.hasSpel(stage.application)"
    >
      <ui-select-match placeholder="None">{{$select.selected}}</ui-select-match>

      <ui-select-choices
        repeat="application in applications | filter: $select.search | limitTo: viewState.infiniteScroll.currentItems"
        infinite-scroll="pipelineStageCtrl.addMoreItems()"
        infinite-scroll-distance="2"
      >
        <div ng-bind-html="application | highlight: $select.search"></div>
      </ui-select-choices>
    </ui-select>
  </stage-config-field>
  <stage-config-field label="Pipeline">
    <input
      ng-model="stage.pipeline"
      class="form-control input-sm"
      ng-if="pipelineStageCtrl.hasSpel(stage.pipeline) || pipelineStageCtrl.hasSpel(stage.application)"
    />
    <div
      ng-if="stage.application && viewState.pipelinesLoaded && stage !== null && !pipelineStageCtrl.hasSpel(stage.pipeline) && !pipelineStageCtrl.hasSpel(stage.application)"
    >
      <ui-select class="form-control input-sm" ng-model="stage.pipeline">
        <ui-select-match placeholder="Select a pipeline...">{{$select.selected.name}}</ui-select-match>
        <ui-select-choices repeat="pipeline.id as pipeline in pipelines | filter: $select.search | orderBy: 'index'"
          ><span ng-bind-html="pipeline.name | highlight: $select.search"></span
        ></ui-select-choices>
      </ui-select>
    </div>
  </stage-config-field>
  <div class="well well-sm clearfix ng-scope col-md-offset-1 col-md-10" ng-if="pipelineParameters.length">
    <h4 class="text-left">Pipeline Parameters</h4>

    <div class="form-group" ng-repeat="parameter in pipelineParameters | orderBy:'name' ">
      <div class="col-md-3 sm-label-right">
        <b>{{parameter.name}}</b>
        <help-field content="{{parameter.description}}" ng-if="parameter.description"></help-field>
      </div>
      <div class="col-md-5">
        <input
          disabled
          ng-if="useDefaultParameters[parameter.name]"
          type="text"
          class="form-control input-sm"
          value="{{parameter.default}}"
        />
        <input
          ng-if="!useDefaultParameters[parameter.name] && !parameter.hasOptions"
          type="text"
          class="form-control input-sm"
          ng-model="userSuppliedParameters[parameter.name]"
          ng-change="updateParam(parameter.name)"
        />

        <spel-select
          ng-if="!useDefaultParameters[parameter.name] && parameter.hasOptions"
          model="userSuppliedParameters[parameter.name]"
        >
          <ui-select
            ng-model="userSuppliedParameters[parameter.name]"
            ng-change="updateParam(parameter.name)"
            style="width: 100%"
            class="form-control input-sm"
          >
            <ui-select-match>
              <strong>{{$select.selected.value}}</strong>
            </ui-select-match>
            <ui-select-choices repeat="option.value as option in parameter.options | filter: $select.search">
              <div><strong>{{option.value}}</strong></div>
            </ui-select-choices>
          </ui-select>
        </spel-select>
      </div>
      <div class="checkbox col-md-4" ng-if="parameter.default!==null">
        <label>
          <input
            type="checkbox"
            ng-model="useDefaultParameters[parameter.name]"
            ng-change="pipelineStageCtrl.updateParam(parameter.name)"
          />Use default
        </label>
      </div>
    </div>
    <div ng-if="hasInvalidParameters()" class="horizontal center sp-margin-l-top" style="width: 100%">
      <div class="alert alert-danger vertical">
        <p>
          <i class="fa fa-exclamation-triangle"></i>
          The following parameters are not accepted by the pipeline but are still set in the stage configuration:
        </p>
        <div ng-repeat="(paramName, paramValue) in invalidParameters" class="flex-container-h" style="margin: 0.5em">
          <label class="col-md-2">{{paramName}}</label>
          <input class="flex-grow" type="text" style="width: 100%" disabled value="{{paramValue}}" />
        </div>
        <button class="self-right passive" ng-click="pipelineStageCtrl.removeInvalidParameters()">Remove all</button>
      </div>
    </div>
  </div>
  <stage-config-field label="Skip downstream output" help-key="pipeline.skipDownstreamOutput">
    <input type="checkbox" class="input-sm" name="skipDownstreamOutput" ng-model="stage.skipDownstreamOutput" />
  </stage-config-field>
  <stage-config-field label="Wait for results" help-key="pipeline.waitForCompletion">
    <input type="checkbox" class="input-sm" name="waitForCompletion" ng-model="stage.waitForCompletion" />
  </stage-config-field>
</div>
`);
}]);

const CORE_PIPELINE_CONFIG_STAGES_PIPELINE_PIPELINESTAGE_MODULE = "spinnaker.core.pipeline.stage.pipeline";
module(CORE_PIPELINE_CONFIG_STAGES_PIPELINE_PIPELINESTAGE_MODULE, [CORE_PIPELINE_CONFIG_STAGES_PIPELINE_PIPELINESTAGE]);

const PRECONFIGUREDJOB_STAGE_MODULE = "spinnaker.core.pipeline.stage.preconfiguredjob";
module(PRECONFIGUREDJOB_STAGE_MODULE, [
  PRECONFIGUREDJOB_STAGE,
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  STAGE_COMMON_MODULE,
  TIME_FORMATTERS
]);

const RESIZE_ASG_STAGE = "spinnaker.core.pipeline.stage.resizeAsgStage";
module(RESIZE_ASG_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    executionConfigSections: ["resizeServerGroupConfig", "taskStatus"],
    executionDetailsUrl: "core/src/pipeline/config/stages/resizeAsg/resizeAsgExecutionDetails.html",
    useBaseProvider: true,
    key: "resizeServerGroup",
    label: "Resize Server Group",
    description: "Resizes a server group",
    strategy: true
  });
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/resizeAsg/resizeAsgExecutionDetails.html", `<div ng-controller="BaseExecutionDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'resizeServerGroupConfig'">
    <div class="row">
      <div class="col-md-9">
        <dl class="dl-narrow dl-horizontal">
          <dt>Account</dt>
          <dd><account-tag account="stage.context.credentials"></account-tag></dd>
          <dt>Region</dt>
          <dd>{{stage.context.region}}</dd>
          <dt>Server Group</dt>
          <dd>{{stage.context.serverGroupName}}</dd>
          <dt>Capacity</dt>
          <dd>
            Min: {{stage.context.capacity.min}} / Desired: {{stage.context.capacity.desired}} / Max:
            {{stage.context.capacity.max}}
          </dd>
        </dl>
      </div>
    </div>
    <stage-failure-message stage="stage" message="stage.failureMessage"></stage-failure-message>

    <div class="row" ng-if="stage.context.execution.logs">
      <div class="col-md-12">
        <div class="well alert alert-info">
          <!-- TODO: Move this to config -->
          <a target="_blank" href="{{stage.context.execution.logs}}"> View Execution Logs </a>
        </div>
      </div>
    </div>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
</div>
`);
}]);

function RollbackClusterExecutionDetails(props) {
  const { stage } = props;
  const imagesToRestore = stage.context.imagesToRestore && stage.context.imagesToRestore.map((entry) => {
    const imageDetails = entry.buildNumber ? "#" + entry.buildNumber : entry.image;
    const method = entry.rollbackMethod === "EXPLICIT" ? "previous server group" : "new server group";
    const helpId = `cluster.rollback.${entry.rollbackMethod.toLowerCase()}`;
    return /* @__PURE__ */ React__default.createElement("div", {
      key: entry.region
    }, /* @__PURE__ */ React__default.createElement("dt", null, entry.region), /* @__PURE__ */ React__default.createElement("dd", null, imageDetails, " via ", method, " ", /* @__PURE__ */ React__default.createElement(HelpField, {
      id: helpId
    })));
  });
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Cluster"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.cluster)))), /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-offset-1 col-md-11"
  }, /* @__PURE__ */ React__default.createElement("strong", null, "Rollback Targets")), /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, imagesToRestore))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage: props.stage
  }));
}
(function(RollbackClusterExecutionDetails2) {
  RollbackClusterExecutionDetails2.title = "rollbackClusterConfig";
})(RollbackClusterExecutionDetails || (RollbackClusterExecutionDetails = {}));

const ROLLBACK_CLUSTER_STAGE = "spinnaker.core.pipeline.stage.rollbackClusterStage";
module(ROLLBACK_CLUSTER_STAGE, []).config(function() {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    key: "rollbackCluster",
    label: "Rollback Cluster",
    description: "Rollback one or more regions in a cluster",
    executionDetailsSections: [RollbackClusterExecutionDetails, ExecutionDetailsTasks]
  });
});

const CORE_PIPELINE_CONFIG_STAGES_RUNJOB_RUNJOBSTAGE = "spinnaker.core.pipeline.stage.runJobStage";
module(CORE_PIPELINE_CONFIG_STAGES_RUNJOB_RUNJOBSTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    key: "runJob",
    label: "Run Job",
    description: "Runs a container",
    restartable: true
  });
});

const CORE_PIPELINE_CONFIG_STAGES_RUNJOB_RUNJOBSTAGE_MODULE = "spinnaker.core.pipeline.stage.runJob";
module(CORE_PIPELINE_CONFIG_STAGES_RUNJOB_RUNJOBSTAGE_MODULE, [CORE_PIPELINE_CONFIG_STAGES_RUNJOB_RUNJOBSTAGE]);

const PipelineRefList = (props) => {
  const pipelineRefs = props.pipelineRefs || [];
  if (pipelineRefs.length === 0) {
    return /* @__PURE__ */ React__default.createElement("div", null);
  } else {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, /* @__PURE__ */ React__default.createElement("strong", null, props.title))), pipelineRefs.map((pipelineRef, i) => /* @__PURE__ */ React__default.createElement("div", {
      key: i,
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-9"
    }, /* @__PURE__ */ React__default.createElement("a", {
      href: `/#/applications/${pipelineRef.application}/executions/${pipelineRef.id ? `configure/${pipelineRef.id}` : ""}`
    }, pipelineRef.application, " - ", pipelineRef.name))))));
  }
};

class SavePipelinesResultsTab extends React__default.Component {
  render() {
    const { stage } = this.props;
    const stageContext = get(stage, ["context"], {});
    return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
      name: this.props.name,
      current: this.props.current
    }, /* @__PURE__ */ React__default.createElement(PipelineRefList, {
      title: "Failed Pipeline Updates",
      pipelineRefs: stageContext.pipelinesFailedToSave || []
    }), /* @__PURE__ */ React__default.createElement(PipelineRefList, {
      title: "Created Pipelines",
      pipelineRefs: stageContext.pipelinesCreated || []
    }), /* @__PURE__ */ React__default.createElement(PipelineRefList, {
      title: "Updated Pipelines",
      pipelineRefs: stageContext.pipelinesUpdated || []
    }));
  }
}
SavePipelinesResultsTab.title = "pipelineUpdates";

const SavePipelinesStageConfig = (props) => {
  const { stage, pipeline } = props;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "container-fluid form-horizontal"
  }, /* @__PURE__ */ React__default.createElement(StageConfigField, {
    label: "Expected Artifact",
    fieldColumns: 8
  }, /* @__PURE__ */ React__default.createElement(StageArtifactSelector, {
    pipeline,
    stage,
    expectedArtifactId: props.stage.pipelinesArtifactId,
    artifact: props.stage.pipelinesArtifact,
    onArtifactEdited: (artifact) => {
      props.updateStageField({ pipelinesArtifact: artifact });
      props.updateStageField({ pipelinesArtifactId: null });
    },
    onExpectedArtifactSelected: (expectedArtifact) => {
      props.updateStageField({ pipelinesArtifactId: expectedArtifact.id });
      props.updateStageField({ pipelinesArtifact: null });
    }
  })));
};

Registry.pipeline.registerStage({
  label: "Save Pipelines",
  description: "Saves pipelines defined in an artifact.",
  key: "savePipelinesFromArtifact",
  component: SavePipelinesStageConfig,
  executionDetailsSections: [ExecutionDetailsTasks, ExecutionArtifactTab, SavePipelinesResultsTab],
  supportsCustomTimeout: true,
  artifactExtractor: ExpectedArtifactService.accumulateArtifacts(["pipelinesArtifactId", "requiredArtifactIds"]),
  artifactRemover: ArtifactReferenceService.removeArtifactFromFields(["pipelinesArtifactId", "requiredArtifactIds"])
});

function ScaleDownClusterExecutionDetails(props) {
  const { stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region || (stage.context.regions || []).join(", ")), /* @__PURE__ */ React__default.createElement("dt", null, "Cluster"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.cluster), /* @__PURE__ */ React__default.createElement("dt", null, "Keep Full Size"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.remainingFullSizeServerGroups), /* @__PURE__ */ React__default.createElement("dt", null, "Scale Active?"), /* @__PURE__ */ React__default.createElement("dd", null, String(!!stage.context.allowScaleDownActive))))), /* @__PURE__ */ React__default.createElement(ServerGroupStageContext, {
    status: "Scaled down",
    serverGroups: stage.context["deploy.server.groups"]
  }), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage: props.stage
  }));
}
(function(ScaleDownClusterExecutionDetails2) {
  ScaleDownClusterExecutionDetails2.title = "scaleDownClusterConfig";
})(ScaleDownClusterExecutionDetails || (ScaleDownClusterExecutionDetails = {}));

const SCALE_DOWN_CLUSTER_STAGE = "spinnaker.core.pipeline.stage.scaleDownClusterStage";
module(SCALE_DOWN_CLUSTER_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    executionDetailsSections: [ScaleDownClusterExecutionDetails, ExecutionDetailsTasks],
    useBaseProvider: true,
    key: "scaleDownCluster",
    label: "Scale Down Cluster",
    description: "Scales down a cluster",
    strategy: true
  });
});

function ScriptExecutionDetails(props) {
  const { stage } = props;
  const scriptRanAndFailed = stage.isFailed && !stage.failureMessage && get(stage.context, "buildInfo.result") === "FAILURE";
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("h5", null, "Script Stage Configuration"), /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, stage.context.repoUrl && /* @__PURE__ */ React__default.createElement("dt", null, "Repository Url"), stage.context.repoUrl && /* @__PURE__ */ React__default.createElement("dd", null, stage.context.repoUrl), stage.context.repoBranch && /* @__PURE__ */ React__default.createElement("dt", null, "Repository Branch"), stage.context.repoBranch && /* @__PURE__ */ React__default.createElement("dd", null, stage.context.repoBranch), /* @__PURE__ */ React__default.createElement("dt", null, "Script Path"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.scriptPath), /* @__PURE__ */ React__default.createElement("dt", null, "Command"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.command), stage.context.propertyFile && /* @__PURE__ */ React__default.createElement("dt", null, "Properties"), stage.context.propertyFile && /* @__PURE__ */ React__default.createElement("dd", null, stage.context.propertyFile)))), stage.context.propertyFileContents && /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("h5", {
    style: { marginBottom: "0px", paddingBottom: "5px" }
  }, "Property File"), /* @__PURE__ */ React__default.createElement(RenderOutputFile, {
    outputFileObject: stage.context.propertyFileContents
  }))), !scriptRanAndFailed && stage.context.buildInfo && stage.context.buildInfo.url && /* @__PURE__ */ React__default.createElement("div", {
    className: "row ng-scope"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-12"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "well alert alert-info"
  }, /* @__PURE__ */ React__default.createElement("a", {
    href: `${stage.context.buildInfo.url}consoleText`,
    target: "_blank"
  }, "Script Results")))), scriptRanAndFailed && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
    className: "alert alert-danger"
  }, "Script execution failed.", /* @__PURE__ */ React__default.createElement("span", null, "Check "), stage.context.buildInfo && stage.context.buildInfo.url && /* @__PURE__ */ React__default.createElement("a", {
    href: `${stage.context.buildInfo.url}consoleText`,
    target: "_blank"
  }, "the script results"), /* @__PURE__ */ React__default.createElement("span", null, " for details."))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }));
}
(function(ScriptExecutionDetails2) {
  ScriptExecutionDetails2.title = "scriptConfig";
})(ScriptExecutionDetails || (ScriptExecutionDetails = {}));

const ScriptStageConfig = (stageConfigProps) => /* @__PURE__ */ React__default.createElement(FormikStageConfig, {
  ...stageConfigProps,
  onChange: stageConfigProps.updateStage,
  validate,
  render: ({ pipeline }) => /* @__PURE__ */ React__default.createElement("div", {
    className: "form-horizontal"
  }, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "repoUrl",
    label: "Repository Url",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.repoUrl"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "repoBranch",
    label: "Repository Branch",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.repoBranch"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "scriptPath",
    label: "Script Path",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.path"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "command",
    label: "Command",
    required: true,
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.command"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextAreaInput, {
      ...props
    })
  }), !pipeline.strategy && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "image",
    label: "Image",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.image"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "account",
    label: "Account",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.account"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "region",
    label: "Region",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.region"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "cluster",
    label: "Cluster",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.cluster"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  })), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "cmc",
    label: "Cmc",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.cmc"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "waitForCompletion",
    label: "Wait for results",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "script.waitForCompletion"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(CheckboxInput, {
      ...props
    })
  }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
    name: "propertyFile",
    label: "Property File",
    help: /* @__PURE__ */ React__default.createElement(HelpField, {
      id: "pipeline.config.script.propertyFile"
    }),
    input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
      ...props
    })
  }))
});
const validate = (stage) => {
  const formValidator = new FormValidator(stage);
  formValidator.field("command", "Command").required();
  formValidator.field("scriptPath", "Script Path").required();
  return formValidator.validateForm();
};

const SCRIPT_STAGE = "spinnaker.core.pipeline.stage.scriptStage";
module(SCRIPT_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    label: "Script",
    description: "Runs a script",
    supportsCustomTimeout: true,
    key: "script",
    restartable: true,
    defaults: {
      waitForCompletion: true,
      failPipeline: true,
      get user() {
        return AuthenticationService.getAuthenticatedUser().name;
      }
    },
    component: ScriptStageConfig,
    executionDetailsSections: [ScriptExecutionDetails, ExecutionDetailsTasks],
    strategy: true,
    validateFn: validate
  });
});

function ShareServiceExecutionDetails(props) {
  const { stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region)))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }));
}
(function(ShareServiceExecutionDetails2) {
  ShareServiceExecutionDetails2.title = "shareServiceConfig";
})(ShareServiceExecutionDetails || (ShareServiceExecutionDetails = {}));

Registry.pipeline.registerStage({
  executionDetailsSections: [ShareServiceExecutionDetails, ExecutionDetailsTasks],
  useBaseProvider: true,
  key: "shareService",
  label: "Share Service",
  description: "Share a service",
  strategy: true
});

function ShrinkClusterExecutionDetails(props) {
  const { stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region || (stage.context.regions || []).join(", ")), /* @__PURE__ */ React__default.createElement("dt", null, "Cluster"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.cluster), /* @__PURE__ */ React__default.createElement("dt", null, "Shrink to Size"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.shrinkToSize), /* @__PURE__ */ React__default.createElement("dt", null, "Delete Active?"), /* @__PURE__ */ React__default.createElement("dd", null, String(!!stage.context.allowDeleteActive))))), /* @__PURE__ */ React__default.createElement(ServerGroupStageContext, {
    status: "Shrunk",
    serverGroups: stage.context["deploy.server.groups"]
  }), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage: props.stage
  }));
}
(function(ShrinkClusterExecutionDetails2) {
  ShrinkClusterExecutionDetails2.title = "shrinkClusterConfig";
})(ShrinkClusterExecutionDetails || (ShrinkClusterExecutionDetails = {}));

const SHRINK_CLUSTER_STAGE = "spinnaker.core.pipeline.stage.shrinkClusterStage";
module(SHRINK_CLUSTER_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    executionDetailsSections: [ShrinkClusterExecutionDetails, ExecutionDetailsTasks],
    useBaseProvider: true,
    key: "shrinkCluster",
    label: "Shrink Cluster",
    description: "Shrinks a cluster",
    strategy: true
  });
});

const CORE_PIPELINE_CONFIG_STAGES_TAGIMAGE_TAGIMAGESTAGE = "spinnaker.core.pipeline.stage.tagImageStage";
module(CORE_PIPELINE_CONFIG_STAGES_TAGIMAGE_TAGIMAGESTAGE, []).config(function() {
  Registry.pipeline.registerStage({
    useBaseProvider: true,
    key: "upsertImageTags",
    label: "Tag Image",
    description: "Tags an image"
  });
});

const CORE_PIPELINE_CONFIG_STAGES_TAGIMAGE_TAGIMAGESTAGE_MODULE = "spinnaker.core.pipeline.stage.tagImage";
module(CORE_PIPELINE_CONFIG_STAGES_TAGIMAGE_TAGIMAGESTAGE_MODULE, [
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  STAGE_COMMON_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_TAGIMAGE_TAGIMAGESTAGE
]);

class TravisStageAddParameter {
  constructor($scope, $uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
  }
  submit() {
    this.$uibModalInstance.close(this.$scope.parameter);
  }
}
TravisStageAddParameter.$inject = ["$scope", "$uibModalInstance"];
const TRAVIS_STAGE_ADD_PARAMETER_MODAL_CONTROLLER = "spinnaker.core.pipeline.stage.travis.modal.addParameter";
module(TRAVIS_STAGE_ADD_PARAMETER_MODAL_CONTROLLER, []).controller("TravisStageAddParameterCtrl", TravisStageAddParameter);

class TravisExecutionDetailsCtrl {
  constructor($stateParams, executionDetailsSectionService, $scope) {
    this.$stateParams = $stateParams;
    this.executionDetailsSectionService = executionDetailsSectionService;
    this.$scope = $scope;
    this.configSections = ["travisConfig", "taskStatus"];
    this.stage = this.$scope.stage;
    this.initialize();
    this.$scope.$on("$stateChangeSuccess", () => this.initialize());
    this.$scope.$watch("stage.refId", () => this.stage = $scope.stage);
  }
  initialized() {
    var _a;
    this.detailsSection = (_a = this.$stateParams.details) != null ? _a : "";
    this.failureMessage = this.getFailureMessage();
  }
  getFailureMessage() {
    var _a;
    let failureMessage = this.stage.failureMessage;
    const context = this.stage.context || {};
    const buildInfo = context.buildInfo || {};
    const testResults = (_a = buildInfo.testResults) != null ? _a : [];
    const failingTests = testResults.filter((results) => results.failCount > 0);
    const failingTestCount = failingTests.reduce((acc, results) => acc + results.failCount, 0);
    if (buildInfo.result === "FAILURE") {
      failureMessage = "Build failed.";
    }
    if (failingTestCount) {
      failureMessage = `${failingTestCount} test${failingTestCount > 1 ? "s" : ""} failed.`;
    }
    return failureMessage;
  }
  initialize() {
    this.executionDetailsSectionService.synchronizeSection(this.configSections, () => this.initialized());
  }
}
TravisExecutionDetailsCtrl.$inject = ["$stateParams", "executionDetailsSectionService", "$scope"];
const TRAVIS_EXECUTION_DETAILS_CONTROLLER = "spinnaker.core.pipeline.stage.travis.executionDetails.controller";
module(TRAVIS_EXECUTION_DETAILS_CONTROLLER, [EXECUTION_DETAILS_SECTION_SERVICE]).controller("TravisExecutionDetailsCtrl", TravisExecutionDetailsCtrl);

class TravisExecutionLabel extends React__default.Component {
  render() {
    const buildInfo = this.props.stage.masterStage.context.buildInfo || {};
    const testResults = (buildInfo.testResults || []).map((result, index) => /* @__PURE__ */ React__default.createElement("div", {
      key: index
    }, "( ", /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-pass-count"
    }, result.totalCount - result.failCount - result.skipCount), " / ", /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-fail-count"
    }, result.failCount), result.skipCount > 0 && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", null, " / "), /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-skip-count"
    }, result.skipCount)), " )"));
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "stage-label"
    }, /* @__PURE__ */ React__default.createElement("span", null, this.props.stage.name), buildInfo.number && /* @__PURE__ */ React__default.createElement("div", null, "Build #", buildInfo.number), testResults);
  }
}

class TravisStage {
  constructor(stage, $scope, $uibModal) {
    this.stage = stage;
    this.$uibModal = $uibModal;
    this.filterLimit = 100;
    this.filterThreshold = 500;
    this.stage.failPipeline = this.stage.failPipeline === void 0 ? true : this.stage.failPipeline;
    this.stage.continuePipeline = this.stage.continuePipeline === void 0 ? false : this.stage.continuePipeline;
    this.viewState = {
      mastersLoaded: false,
      mastersRefreshing: false,
      jobsLoaded: false,
      jobsRefreshing: false,
      failureOption: "fail",
      markUnstableAsSuccessful: !!this.stage.markUnstableAsSuccessful,
      waitForCompletion: this.stage.waitForCompletion || this.stage.waitForCompletion === void 0
    };
    this.useDefaultParameters = {};
    this.userSuppliedParameters = {};
    this.initializeMasters();
    $scope.$watch("stage.master", () => this.updateJobsList());
    $scope.$watch("stage.job", () => this.updateJobConfig());
  }
  markUnstableChanged() {
    this.stage.markUnstableAsSuccessful = this.viewState.markUnstableAsSuccessful;
  }
  waitForCompletionChanged() {
    this.stage.waitForCompletion = this.viewState.waitForCompletion;
  }
  refreshMasters() {
    this.viewState.mastersRefreshing = true;
    this.initializeMasters();
  }
  refreshJobs() {
    this.viewState.jobsRefreshing = true;
    this.updateJobsList();
  }
  initializeMasters() {
    IgorService.listMasters(BuildServiceType.Travis).then((masters) => {
      this.masters = masters;
      this.viewState.mastersLoaded = true;
      this.viewState.mastersRefreshing = false;
    });
  }
  updateJobsList() {
    const master = this.stage.master;
    const job = this.stage.job || "";
    const viewState = this.viewState;
    viewState.masterIsParameterized = master.includes("${");
    viewState.jobIsParameterized = job.includes("${");
    if (viewState.masterIsParameterized || viewState.jobIsParameterized) {
      viewState.jobsLoaded = true;
      return;
    }
    viewState.jobsLoaded = false;
    this.jobs = [];
    IgorService.listJobsForMaster(master).then((jobs) => {
      this.viewState.jobsLoaded = true;
      this.viewState.jobsRefreshing = false;
      this.jobs = jobs;
      if (!this.jobs.includes(this.stage.job)) {
        this.stage.job = "";
      }
    });
    this.useDefaultParameters = {};
    this.userSuppliedParameters = {};
    this.jobParams = null;
  }
  updateJobConfig() {
    const stage = this.stage;
    const view = this.viewState;
    if (stage && stage.job && stage.master && !view.masterIsParameterized && !view.jobIsParameterized) {
      IgorService.getJobConfig(stage.master, stage.job).then((config) => {
        config = config || {};
        if (!stage.parameters) {
          stage.parameters = {};
        }
        this.jobParams = config.parameterDefinitionList;
        this.userSuppliedParameters = stage.parameters;
        this.useDefaultParameters = {};
        const params = this.jobParams || [];
        params.forEach((property) => {
          if (!(property.name in stage.parameters) && property.defaultValue !== null) {
            this.useDefaultParameters[property.name] = true;
          }
        });
      });
    }
  }
  addParameter() {
    this.$uibModal.open({
      templateUrl: "core/src/pipeline/config/stages/travis/modal/addParameter.html",
      controller: "TravisStageAddParameterCtrl",
      controllerAs: "ctrl"
    }).result.then((parameter) => {
      this.stage.parameters[parameter.key] = parameter.value;
    }).catch(() => {
    });
  }
  removeParameter(key) {
    delete this.stage.parameters[key];
  }
  shouldFilter() {
    return this.jobs && this.jobs.length >= this.filterThreshold;
  }
}
TravisStage.$inject = ["stage", "$scope", "$uibModal"];
const TRAVIS_STAGE = "spinnaker.core.pipeline.stage.travisStage";
module(TRAVIS_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    label: "Travis",
    description: "Runs a Travis job",
    key: "travis",
    restartable: true,
    controller: "TravisStageCtrl",
    controllerAs: "$ctrl",
    producesArtifacts: true,
    templateUrl: "core/src/pipeline/config/stages/travis/travisStage.html",
    executionDetailsUrl: "core/src/pipeline/config/stages/travis/travisExecutionDetails.html",
    executionLabelComponent: TravisExecutionLabel,
    providesVersionForBake: true,
    extraLabelLines: (stage) => {
      if (!stage.masterStage.context || !stage.masterStage.context.buildInfo) {
        return 0;
      }
      const lines = stage.masterStage.context.buildInfo.number ? 1 : 0;
      return lines + (stage.masterStage.context.buildInfo.testResults || []).length;
    },
    supportsCustomTimeout: true,
    validators: [{ type: "requiredField", fieldName: "job" }],
    strategy: true
  });
}).controller("TravisStageCtrl", TravisStage);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/travis/modal/addParameter.html", `<div modal-page>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Add Parameter</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="addParameterForm">
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Key</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="parameter.key"
            placeholder="enter a parameter key"
            required
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Value</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="parameter.value"
            placeholder="enter a parameter value"
            required
          />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <button
        type="submit"
        class="btn btn-primary"
        data-purpose="submit"
        ng-click="ctrl.submit()"
        ng-disabled="addParameterForm.$invalid"
      >
        <span class="far fa-check-circle"></span> Add
      </button>
    </div>
  </form>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/travis/travisStage.html", `<div class="form-horizontal">
  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">Build Service</label>
    <div class="col-md-6">
      <p class="form-control-static" ng-if="$ctrl.viewState.masterIsParameterized">{{$ctrl.stage.master}}</p>
      <ui-select
        class="form-control input-sm"
        ng-if="!$ctrl.viewState.masterIsParameterized"
        ng-model="$ctrl.stage.master"
      >
        <ui-select-match placeholder="Select a build service...">{{$select.selected}}</ui-select-match>
        <ui-select-choices repeat="master in $ctrl.masters | filter: $select.search">
          <span ng-bind-html="master | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="col-md-1 text-center" ng-if="!$ctrl.viewState.masterIsParameterized">
      <a
        href
        ng-click="$ctrl.refreshMasters()"
        tooltip-placement="right"
        uib-tooltip="{{$ctrl.viewState.mastersRefreshing ? 'Masters refreshing.' : 'Refresh masters list' }}"
      >
        <span ng-class="{'fa-spin':$ctrl.viewState.mastersRefreshing}" class="fa fa-sync-alt"></span>
      </a>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right"
      >Job<help-field key="pipeline.config.travis.job.isFiltered" ng-if="$ctrl.shouldFilter()"></help-field
    ></label>
    <div class="col-md-6">
      <p class="form-control-static" ng-if="!$ctrl.stage.master">(Select a build service)</p>
      <p
        class="form-control-static"
        ng-if="$ctrl.viewState.masterIsParameterized || $ctrl.viewState.jobIsParameterized"
      >
        {{$ctrl.stage.job}}
      </p>
      <div ng-if="$ctrl.stage.master && $ctrl.viewState.jobsLoaded">
        <ui-select
          class="form-control input-sm"
          ng-if="!$ctrl.viewState.masterIsParameterized && !$ctrl.viewState.jobIsParameterized"
          ng-model="$ctrl.stage.job"
        >
          <ui-select-match placeholder="{{$ctrl.shouldFilter() ? 'Start typing...' : 'Select a job...'}}"
            >{{$select.selected}}</ui-select-match
          >
          <ui-select-choices
            repeat="job in $ctrl.jobs | filter: $select.search | limitTo: $ctrl.shouldFilter() ? $ctrl.filterLimit : undefined"
            ><span ng-bind-html="job | highlight: $select.search"></span
          ></ui-select-choices>
        </ui-select>
      </div>
      <div class="horizontal center" ng-if="$ctrl.stage.master && !$ctrl.viewState.jobsLoaded">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
    </div>
    <div
      class="col-md-1 text-center"
      ng-if="!$ctrl.viewState.masterIsParameterized && !$ctrl.viewState.jobIsParameterized"
    >
      <a
        href
        ng-click="$ctrl.refreshJobs()"
        tooltip-placement="right"
        uib-tooltip="{{$ctrl.viewState.jobsRefreshing ? 'Jobs refreshing.' : 'Refresh job list' }}"
      >
        <span ng-class="{'fa-spin':$ctrl.viewState.jobsRefreshing}" class="fa fa-sync-alt"></span>
      </a>
    </div>
  </div>
  <stage-config-field label="Parameters" help-key="pipeline.config.travis.parameters">
    <table class="table table-condensed packed" ng-if="$ctrl.stage.parameters">
      <thead>
        <tr>
          <th style="width: 40%">Key</th>
          <th style="width: 60%">Value</th>
          <th class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="(key, value) in $ctrl.stage.parameters">
          <td>
            <strong class="small">{{key}}</strong>
          </td>
          <td>
            <input type="text" required ng-model="$ctrl.stage.parameters[key]" class="form-control input-sm" />
          </td>
          <td class="text-center">
            <a href ng-click="$ctrl.removeParameter(key)">
              <span class="glyphicon glyphicon-trash"></span>
              <span class="sr-only">Remove</span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-block btn-sm add-new" ng-click="$ctrl.addParameter()">
          <span class="glyphicon glyphicon-plus-sign"></span> Add Parameter
        </button>
      </div>
    </div>
  </stage-config-field>

  <stage-config-field label="Wait for results" help-key="travis.waitForCompletion">
    <input
      type="checkbox"
      class="input-sm"
      name="waitForCompletion"
      ng-model="$ctrl.viewState.waitForCompletion"
      ng-change="$ctrl.waitForCompletionChanged()"
    />
  </stage-config-field>
  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">If build is unstable</label>
    <div class="col-md-9">
      <div class="radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.markUnstableAsSuccessful"
            ng-change="$ctrl.markUnstableChanged()"
            ng-value="false"
          />
          fail the stage
          <help-field key="pipeline.config.travis.markUnstableAsSuccessful.false"></help-field>
        </label>
      </div>
      <div class="radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.markUnstableAsSuccessful"
            ng-change="$ctrl.markUnstableChanged()"
            ng-value="true"
          />
          consider stage successful
          <help-field key="pipeline.config.travis.markUnstableAsSuccessful.true"></help-field>
        </label>
      </div>
    </div>
  </div>
</div>
<div class="well alert alert-info" role="alert">
  <p>You can read properties from Travis builds by logging them in the build log using one of the following formats:</p>
  <pre>
echo SPINNAKER_PROPERTY_key1=value1
echo SPINNAKER_PROPERTY_key2=value2
echo SPINNAKER_CONFIG_JSON={"key3": "value3", "key4": "value4"}</pre
  >
  The properties will be available in the stage context under the key <code>propertyFileContents</code>.<br />Example
  using SpEL: <code>$&lbrace; #stage('{{ stage.name }}').context.propertyFileContents.key2 &rbrace;</code>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/travis/travisExecutionDetails.html", `<div ng-controller="TravisExecutionDetailsCtrl as ctrl">
  <execution-details-section-nav sections="ctrl.configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="ctrl.detailsSection === 'travisConfig'">
    <div class="row">
      <div class="col-md-{{ctrl.stage.context.buildInfo.testResults ? 6 : 12}}">
        <h5>Travis Stage Configuration</h5>
        <dl class="dl-narrow dl-horizontal">
          <dt>Build Service</dt>
          <dd>{{ctrl.stage.context.master}}</dd>
          <dt>Job</dt>
          <dd>{{ctrl.stage.context.job}}</dd>
          <dt>Build</dt>
          <dd>
            <span ng-if="!ctrl.stage.context.buildInfo">{{ctrl.stage.context.buildNumber}}</span>
            <a ng-if="stage.context.buildInfo.url" href="{{ctrl.stage.context.buildInfo.url}}" target="_blank"
              >#{{ctrl.stage.context.buildInfo.number}}</a
            >
          </dd>
        </dl>
      </div>
      <div class="col-md-6" ng-if="ctrl.stage.context.buildInfo.testResults">
        <h5>Test Results</h5>
        <div class="row" ng-repeat="result in ctrl.stage.context.buildInfo.testResults">
          <div class="col-md-6">
            <p>
              <a target="_blank" href="{{ctrl.stage.context.buildInfo.url}}{{result.urlName}}" class="pad-left">
                {{result.urlName | robotToHuman }}
              </a>
            </p>
          </div>
          <div class="col-md-6">
            <p class="test-results">
              <span class="test-result-section">
                {{result.totalCount - result.failCount - result.skipCount}} <span class="small fa fa-check"></span>
              </span>
              <span class="test-result-section">
                {{result.failCount}} <span class="small glyphicon glyphicon-remove informational"></span>
              </span>
              <span class="test-result-section" ng-if="result.skipCount">
                {{result.skipCount}} <span class="small glyphicon glyphicon-minus"></span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" ng-if="ctrl.stage.context.parameters.length">
      <div class="col-md-12">
        <h5 style="margin-bottom: 0; padding-bottom: 5px">Parameters</h5>
        <dl style="font-size: 12px">
          <dt ng-repeat-start="(key, val) in ctrl.stage.context.parameters">{{key}}</dt>
          <dd ng-repeat-end>{{val}}</dd>
        </dl>
      </div>
    </div>
    <stage-failure-message
      stage="ctrl.stage"
      is-failed="ctrl.stage.isFailed"
      message="ctrl.getException(stage) || ctrl.failureMessage"
    ></stage-failure-message>
  </div>
  <div class="step-section-details" ng-if="ctrl.detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="ctrl.stage"></execution-step-details>
    </div>
  </div>
</div>
`);
}]);

const TRAVIS_STAGE_MODULE = "spinnaker.core.pipeline.stage.travis";
module(TRAVIS_STAGE_MODULE, [
  TRAVIS_STAGE,
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  STAGE_COMMON_MODULE,
  TIME_FORMATTERS,
  TRAVIS_EXECUTION_DETAILS_CONTROLLER,
  TRAVIS_STAGE_ADD_PARAMETER_MODAL_CONTROLLER
]);

class UnmatchedStageTypeStageCtrl {
  constructor($scope) {
    this.$scope = $scope;
    this.keysToHide = new Set([
      "refId",
      "requisiteStageRefIds",
      "failPipeline",
      "continuePipeline",
      "completeOtherBranchesThenFail",
      "restrictExecutionDuringTimeWindow",
      "restrictedExecutionWindow",
      "stageEnabled",
      "sendNotifications",
      "notifications",
      "comments",
      "name"
    ]);
  }
  $onInit() {
    this.stageJson = JsonUtils.makeSortedStringFromObject(this.makeCleanStageCopy(this.$scope.stage || {}));
    this.textareaRows = this.stageJson.split("\n").length;
  }
  updateStage() {
    let parsedStage;
    this.errorMessage = null;
    try {
      parsedStage = JSON.parse(this.stageJson);
    } catch (e) {
      this.errorMessage = e.message;
    }
    if (parsedStage && !parsedStage.type) {
      this.errorMessage = "Cannot delete property <em>type</em>.";
    }
    if (!this.errorMessage) {
      Object.keys(this.$scope.stage).forEach((key) => {
        if (!this.keysToHide.has(key)) {
          delete this.$scope.stage[key];
        }
      });
      Object.assign(this.$scope.stage, parsedStage);
      this.setStageJson();
    }
  }
  setStageJson() {
    const stageCopy = this.makeCleanStageCopy(this.$scope.stage);
    if (!isEqual(stageCopy, JSON.parse(this.stageJson || "{}"))) {
      this.stageJson = JsonUtils.makeStringFromObject(stageCopy);
    }
  }
  makeCleanStageCopy(stage) {
    const stageCopy = cloneDeep(stage);
    this.keysToHide.forEach((key) => {
      if (isDefined(stageCopy[key])) {
        delete stageCopy[key];
      }
    });
    return stageCopy;
  }
}
UnmatchedStageTypeStageCtrl.$inject = ["$scope"];
const UNMATCHED_STAGE_TYPE_STAGE_CTRL = "spinnaker.core.pipeline.stage.unmatchedStageTypeStage.controller";
module(UNMATCHED_STAGE_TYPE_STAGE_CTRL, []).controller("UnmatchedStageTypeStageCtrl", UnmatchedStageTypeStageCtrl);

const UNMATCHED_STAGE_TYPE_STAGE = "spinnaker.core.pipeline.stage.unmatchedStageType";
module(UNMATCHED_STAGE_TYPE_STAGE, [UNMATCHED_STAGE_TYPE_STAGE_CTRL]).config(() => {
  Registry.pipeline.registerStage({
    key: "unmatched",
    synthetic: true,
    templateUrl: "core/src/pipeline/config/stages/unmatchedStageTypeStage/unmatchedStageTypeStage.html"
  });
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/unmatchedStageTypeStage/unmatchedStageTypeStage.html", `<div ng-controller="UnmatchedStageTypeStageCtrl as $ctrl">
  <form name="form" class="form-horizontal flex-fill">
    <div class="flex-fill">
      <textarea
        class="code form-control flex-fill"
        ng-model="$ctrl.stageJson"
        spellcheck="false"
        ng-blur="$ctrl.updateStage()"
        ng-change="$ctrl.updateStage()"
        ng-model-options="{'debounce': 500}"
        rows="{{::$ctrl.textareaRows}}"
      ></textarea>
    </div>
  </form>

  <div class="form-group row" style="margin-top: 10px">
    <div class="col-md-9 col-md-offset-3 error-message slide-in" ng-if="$ctrl.errorMessage">
      Error: <span ng-bind-html="$ctrl.errorMessage"></span>
    </div>
  </div>
</div>
`);
}]);

function UnshareServiceExecutionDetails(props) {
  const { stage } = props;
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-9"
  }, /* @__PURE__ */ React__default.createElement("dl", {
    className: "dl-narrow dl-horizontal"
  }, /* @__PURE__ */ React__default.createElement("dt", null, "Account"), /* @__PURE__ */ React__default.createElement("dd", null, /* @__PURE__ */ React__default.createElement(AccountTag, {
    account: stage.context.credentials
  })), /* @__PURE__ */ React__default.createElement("dt", null, "Region"), /* @__PURE__ */ React__default.createElement("dd", null, stage.context.region)))), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }));
}
(function(UnshareServiceExecutionDetails2) {
  UnshareServiceExecutionDetails2.title = "unshareServiceConfig";
})(UnshareServiceExecutionDetails || (UnshareServiceExecutionDetails = {}));

Registry.pipeline.registerStage({
  executionDetailsSections: [UnshareServiceExecutionDetails, ExecutionDetailsTasks],
  useBaseProvider: true,
  key: "unshareService",
  label: "Unshare Service",
  description: "Unshare a service",
  strategy: true
});

const DEFAULT_SKIP_WAIT_TEXT$1 = "The pipeline will proceed immediately, marking this stage completed.";
class SkipWait extends React__default.Component {
  constructor(props) {
    super(props);
    this.setRemainingWait = (time) => {
      this.setState({ remainingWait: duration(this.props.stage.context.waitTime * 1e3 - time) });
    };
    this.skipRemainingWait = (e) => {
      const { executionService } = ReactInjector;
      e.target.blur();
      const { stage, application } = this.props;
      const matcher = (execution) => {
        const match = execution.stages.find((test) => test.id === stage.id);
        return match.status !== "RUNNING";
      };
      const data = { skipRemainingWait: true };
      ConfirmationModalService.confirm({
        header: "Really skip wait?",
        buttonText: "Skip",
        body: stage.context.skipWaitText || DEFAULT_SKIP_WAIT_TEXT$1,
        submitMethod: () => {
          return executionService.patchExecution(this.props.execution.id, stage.id, data).then(() => executionService.waitUntilExecutionMatches(this.props.execution.id, matcher)).then((updated) => executionService.updateExecution(application, updated));
        }
      });
    };
    this.state = {
      remainingWait: null
    };
  }
  componentDidMount() {
    this.runningTime = new OrchestratedItemRunningTime(this.props.stage, (time) => this.setRemainingWait(time));
  }
  componentWillUnmount() {
    this.runningTime.reset();
  }
  render() {
    const stage = this.props.stage;
    const waitMs = stage.context.waitTime * 1e3;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, "Wait time: "), stage.context.waitTime > 3600 ? duration(waitMs) : `${stage.context.waitTime} seconds`, stage.context.skipRemainingWait && /* @__PURE__ */ React__default.createElement("span", null, "(skipped after ", duration(stage.runningTimeInMs), ")")), stage.isRunning && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, "Remaining: "), this.state.remainingWait), /* @__PURE__ */ React__default.createElement("div", {
      className: "action-buttons"
    }, /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-xs btn-primary",
      onClick: this.skipRemainingWait
    }, /* @__PURE__ */ React__default.createElement("span", {
      style: { marginRight: "5px" },
      className: "small glyphicon glyphicon-fast-forward"
    }), "Skip remaining wait"))));
  }
}

function WaitExecutionDetails(props) {
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement(SkipWait, {
    application: props.application,
    execution: props.execution,
    stage: props.stage
  }), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage: props.stage
  }));
}
(function(WaitExecutionDetails2) {
  WaitExecutionDetails2.title = "waitConfig";
})(WaitExecutionDetails || (WaitExecutionDetails = {}));

class WaitExecutionLabel extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { stage, executionMarker, application, execution, children } = this.props;
    if (!executionMarker) {
      return /* @__PURE__ */ React__default.createElement(ExecutionBarLabel, {
        ...this.props
      });
    }
    if (stage.isRunning) {
      const template = /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("b", null, stage.name)), /* @__PURE__ */ React__default.createElement(SkipWait, {
        stage: stage.masterStage,
        application,
        execution
      }));
      return /* @__PURE__ */ React__default.createElement(HoverablePopover, {
        template
      }, children);
    }
    const tooltip = /* @__PURE__ */ React__default.createElement(Tooltip$1, {
      id: stage.id
    }, stage.name);
    return /* @__PURE__ */ React__default.createElement(OverlayTrigger, {
      placement: "top",
      overlay: tooltip
    }, /* @__PURE__ */ React__default.createElement("span", null, children));
  }
}

const DEFAULT_SKIP_WAIT_TEXT = "The pipeline will proceed immediately, marking this stage completed.";
class WaitStageConfig extends React__default.Component {
  constructor(props) {
    super(props);
    this.updateWaitTime = (waitTime) => {
      this.props.stage.waitTime = waitTime;
      this.setState({ waitTime });
      this.props.stageFieldUpdated();
    };
    this.toggleCustomSkipWaitText = (event) => {
      this.props.stage.skipWaitText = void 0;
      if (!event.target.checked) {
        this.props.stageFieldUpdated();
      }
      this.setState({ enableCustomSkipWaitText: event.target.checked, skipWaitText: void 0 });
    };
    this.customSkipWaitTextChanged = (event) => {
      const skipWaitText = event.target.value || void 0;
      this.props.stage.skipWaitText = skipWaitText;
      this.setState({ skipWaitText });
      this.props.stageFieldUpdated();
    };
    this.state = this.getState(props.stage);
  }
  static getDerivedStateFromProps(props, state) {
    const { stage } = props;
    const { waitTime } = stage;
    if (waitTime === void 0 || !Number.isNaN(waitTime) && waitTime < 0) {
      stage.waitTime = 30;
    }
    return {
      enableCustomSkipWaitText: !!stage.skipWaitText || state.enableCustomSkipWaitText,
      waitTime: stage.waitTime,
      skipWaitText: stage.skipWaitText
    };
  }
  getState(stage) {
    const { waitTime } = stage;
    if (waitTime === void 0 || !Number.isNaN(waitTime) && waitTime < 0) {
      stage.waitTime = 30;
    }
    return {
      enableCustomSkipWaitText: !!stage.skipWaitText,
      waitTime: stage.waitTime,
      skipWaitText: stage.skipWaitText
    };
  }
  render() {
    const { waitTime, enableCustomSkipWaitText, skipWaitText } = this.state;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-horizontal"
    }, /* @__PURE__ */ React__default.createElement(StageConfigField, {
      label: "Wait time (seconds)",
      fieldColumns: 6
    }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(SpelNumberInput, {
      value: waitTime,
      min: 0,
      onChange: this.updateWaitTime
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8 col-md-offset-3"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "checkbox"
    }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      onChange: this.toggleCustomSkipWaitText,
      checked: enableCustomSkipWaitText
    }), /* @__PURE__ */ React__default.createElement("span", null, " Show custom warning when users skip wait")))), enableCustomSkipWaitText && /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-8 col-md-offset-3 checkbox-padding"
    }, /* @__PURE__ */ React__default.createElement("textarea", {
      className: "form-control",
      rows: 4,
      placeholder: `Default text: '${DEFAULT_SKIP_WAIT_TEXT}' (HTML is okay)`,
      style: { marginTop: "5px" },
      value: skipWaitText,
      onChange: this.customSkipWaitTextChanged
    }))));
  }
}

Registry.pipeline.registerStage({
  label: "Wait",
  description: "Waits a specified period of time",
  key: "wait",
  component: WaitStageConfig,
  executionDetailsSections: [WaitExecutionDetails, ExecutionDetailsTasks],
  executionLabelComponent: WaitExecutionLabel,
  useCustomTooltip: true,
  strategy: true,
  validators: [{ type: "requiredField", fieldName: "waitTime" }]
});

function WaitForConditionExecutionDetails(props) {
  return /* @__PURE__ */ React__default.createElement(ExecutionDetailsSection, {
    name: props.name,
    current: props.current
  }, /* @__PURE__ */ React__default.createElement(SkipConditionWait, {
    application: props.application,
    execution: props.execution,
    stage: props.stage
  }), /* @__PURE__ */ React__default.createElement(StageFailureMessage, {
    stage: props.stage,
    message: props.stage.failureMessage
  }), /* @__PURE__ */ React__default.createElement(StageExecutionLogs, {
    stage: props.stage
  }));
}
(function(WaitForConditionExecutionDetails2) {
  WaitForConditionExecutionDetails2.title = "conditions";
})(WaitForConditionExecutionDetails || (WaitForConditionExecutionDetails = {}));

class WaitForConditionTransformer {
  transform(_application, execution) {
    applySuspendedStatuses(execution, "waitForCondition");
  }
}

Registry.pipeline.registerStage({
  label: "Wait For Condition",
  description: "Waits until a set of conditions are met",
  key: "waitForCondition",
  executionDetailsSections: [WaitForConditionExecutionDetails, ExecutionDetailsTasks],
  synthetic: true
});
Registry.pipeline.registerTransformer(new WaitForConditionTransformer());

const CORE_PIPELINE_CONFIG_STAGES_WAITFORPARENTTASKS_WAITFORPARENTTASKS_TRANSFORMER = "spinnaker.core.pipeline.stage.waitForParentTasks.transformer";
module(CORE_PIPELINE_CONFIG_STAGES_WAITFORPARENTTASKS_WAITFORPARENTTASKS_TRANSFORMER, []).service("waitForParentTasksTransformer", function() {
  function injectWaitForParentStages(execution) {
    const stagesToInject = [];
    execution.stages.filter((stage) => stage.requisiteStageRefIds && stage.requisiteStageRefIds.length > 1).forEach(function(stage) {
      const waitStages = execution.stages.filter((candidate) => candidate.type === "waitForRequisiteCompletion" && candidate.context.requisiteIds && candidate.context.requisiteIds.length === stage.requisiteStageRefIds.length && candidate.context.requisiteIds.every((reqId) => stage.requisiteStageRefIds.includes(reqId)));
      if (waitStages.length) {
        const waitStage = waitStages[0];
        const parentStages = execution.stages.filter((parent) => waitStage.context.requisiteIds.includes(parent.refId));
        stagesToInject.push({
          parentTasks: parentStages,
          syntheticStageOwner: "STAGE_BEFORE",
          id: [waitStage.id, stage.refId].join(":"),
          context: waitStage.context,
          parentStageId: stage.id,
          name: "Wait for Parent Stages",
          type: waitStage.type,
          startTime: waitStage.startTime,
          endTime: waitStage.endTime,
          status: waitStage.status
        });
      }
    });
    execution.stages = execution.stages.concat(stagesToInject);
  }
  this.transform = function(application, execution) {
    injectWaitForParentStages(execution);
  };
});

const CORE_PIPELINE_CONFIG_STAGES_WAITFORPARENTTASKS_WAITFORPARENTTASKS = "spinnaker.core.pipeline.stage.waitForParentTasks";
module(CORE_PIPELINE_CONFIG_STAGES_WAITFORPARENTTASKS_WAITFORPARENTTASKS, [
  CORE_PIPELINE_CONFIG_STAGES_WAITFORPARENTTASKS_WAITFORPARENTTASKS_TRANSFORMER
]).config(function() {
  Registry.pipeline.registerStage({
    key: "waitForRequisiteCompletion",
    synthetic: true,
    executionDetailsUrl: "core/src/pipeline/config/stages/waitForParentTasks/waitForParentTasksExecutionDetails.html"
  });
}).run([
  "waitForParentTasksTransformer",
  function(waitForParentTasksTransformer) {
    Registry.pipeline.registerTransformer(waitForParentTasksTransformer);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/waitForParentTasks/waitForParentTasksExecutionDetails.html", `<div>
  <div class="step-section-details">
    <div class="row">
      <div class="col-md-12">
        <h5>Parent Tasks</h5>
      </div>
    </div>
    <div class="row" ng-repeat="task in stage.parentTasks" style="margin-bottom: 10px">
      <div class="col-md-6">{{task.name}}</div>
      <div class="col-md-6">
        <span class="label label-default label-{{task.status.toLowerCase()}}">{{task.status}}</span>
      </div>
    </div>
    <stage-failure-message stage="stage" message="stage.failureMessage"></stage-failure-message>
  </div>
</div>
`);
}]);

class WebhookStageAddCustomHeader {
  constructor($scope, $uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
  }
  submit() {
    this.$uibModalInstance.close(this.$scope.customHeader);
  }
}
WebhookStageAddCustomHeader.$inject = ["$scope", "$uibModalInstance"];
const WEBHOOK_STAGE_ADD_CUSTOM_HEADER_MODAL_CONTROLLER = "spinnaker.core.pipeline.stage.webhookStage.modal.addCustomHeader";
module(WEBHOOK_STAGE_ADD_CUSTOM_HEADER_MODAL_CONTROLLER, []).controller("WebhookStageAddCustomHeaderCtrl", WebhookStageAddCustomHeader);

class WebhookExecutionDetailsCtrl {
  constructor($stateParams, executionDetailsSectionService, $scope) {
    this.$stateParams = $stateParams;
    this.executionDetailsSectionService = executionDetailsSectionService;
    this.$scope = $scope;
    this.configSections = ["webhookConfig", "taskStatus", "artifactStatus"];
    this.initialize();
    this.$scope.$on("$stateChangeSuccess", () => this.initialize());
  }
  initialized() {
    this.stage = this.$scope.stage;
    this.detailsSection = get(this.$stateParams, "details", "");
    this.failureMessage = this.getFailureMessage();
    this.progressMessage = this.getProgressMessage();
    this.body = this.getBodyContent();
    this.payload = JSON.stringify(this.stage.context.payload, null, 2);
  }
  getProgressMessage() {
    const context = this.stage.context || {};
    const webhook = context.webhook || {};
    const monitor = webhook.monitor || {};
    const buildInfo = context.buildInfo || {};
    if (monitor.progressMessage) {
      return monitor.progressMessage;
    } else {
      return buildInfo.progressMessage;
    }
  }
  getFailureMessage() {
    let failureMessage = this.stage.failureMessage;
    const context = this.stage.context || {};
    const webhook = context.webhook || {};
    const monitor = webhook.monitor || {};
    const error = monitor.error || webhook.error || null;
    if (error) {
      failureMessage = `Webhook failed: ${error}`;
    }
    return failureMessage;
  }
  getBodyContent() {
    const context = this.stage.context || {};
    const webhook = context.webhook || {};
    const monitor = webhook.monitor || {};
    const body = monitor.body || webhook.body || null;
    if (!body && this.stage.originalStatus !== "NOT_STARTED" && this.stage.originalStatus !== "RUNNING") {
      return "<NO BODY RETURNED BY SERVER>";
    }
    if (typeof body === "object") {
      return JSON.stringify(body, null, 2);
    }
    return body;
  }
  initialize() {
    this.executionDetailsSectionService.synchronizeSection(this.configSections, () => this.initialized());
  }
}
WebhookExecutionDetailsCtrl.$inject = ["$stateParams", "executionDetailsSectionService", "$scope"];
const WEBHOOK_EXECUTION_DETAILS_CONTROLLER = "spinnaker.core.pipeline.stage.webhook.executionDetails.controller";
module(WEBHOOK_EXECUTION_DETAILS_CONTROLLER, [EXECUTION_DETAILS_SECTION_SERVICE, EXECUTION_ARTIFACT_TAB]).controller("WebhookExecutionDetailsCtrl", WebhookExecutionDetailsCtrl);

const _WebhookStage = class {
  constructor(stage, $uibModal) {
    this.stage = stage;
    this.$uibModal = $uibModal;
    this.parameters = [];
    this.methods = ["GET", "HEAD", "POST", "PUT", "PATCH", "DELETE"];
    this.viewState = {
      waitForCompletion: this.stage.waitForCompletion || false,
      statusUrlResolution: this.stage.statusUrlResolution || "getMethod",
      failFastStatusCodes: this.stage.failFastStatusCodes ? this.stage.failFastStatusCodes.join() : "",
      retryStatusCodes: this.stage.retryStatusCodes ? this.stage.retryStatusCodes.join() : ""
    };
    this.command = {
      payloadJSON: JsonUtils.makeSortedStringFromObject(this.stage.payload || {})
    };
    this.cancelCommand = {
      payloadJSON: JsonUtils.makeSortedStringFromObject(this.stage.cancelPayload || {})
    };
    this.stage.statusUrlResolution = this.viewState.statusUrlResolution;
    const stageConfig = Registry.pipeline.getStageConfig(this.stage);
    if (stageConfig && stageConfig.configuration) {
      this.preconfiguredProperties = stageConfig.configuration.preconfiguredProperties || [];
      this.noUserConfigurableFields = stageConfig.configuration.noUserConfigurableFields;
      this.viewState.waitForCompletion = stageConfig.configuration.waitForCompletion || this.viewState.waitForCompletion;
      this.parameters = stageConfig.configuration.parameters || [];
      this.viewState.failFastStatusCodes = this.stage.failFastStatusCodes ? this.stage.failFastStatusCodes.join() : "";
      this.viewState.retryStatusCodes = this.stage.retryStatusCodes ? this.stage.retryStatusCodes.join() : "";
    }
    if (this.parameters.length && !this.stage.parameterValues) {
      this.stage.parameterValues = {};
    }
    this.parameters.forEach((config) => {
      if (!(config.name in this.stage.parameterValues) && config.defaultValue !== null) {
        this.stage.parameterValues[config.name] = config.defaultValue;
      }
    });
  }
  updatePayload() {
    const payload = _WebhookStage.checkAndGetPayload(this.command);
    if (payload !== void 0) {
      this.stage.payload = payload;
    }
  }
  updateCancelPayload() {
    const payload = _WebhookStage.checkAndGetPayload(this.cancelCommand);
    if (payload !== void 0) {
      this.stage.cancelPayload = payload;
    }
  }
  static checkAndGetPayload(command) {
    command.invalid = false;
    command.errorMessage = "";
    try {
      return command.payloadJSON ? JSON.parse(command.payloadJSON) : null;
    } catch (e) {
      command.invalid = true;
      command.errorMessage = e.message;
    }
    return void 0;
  }
  waitForCompletionChanged() {
    this.stage.waitForCompletion = this.viewState.waitForCompletion;
  }
  signalCancellationChanged() {
    if (!this.viewState.signalCancellation) {
      delete this.stage.cancelEndpoint;
      delete this.stage.cancelMethod;
      delete this.stage.cancelPayload;
      this.cancelCommand = {
        payloadJSON: JsonUtils.makeSortedStringFromObject(this.stage.cancelPayload || {})
      };
    } else {
      this.stage.cancelMethod = "POST";
    }
  }
  statusUrlResolutionChanged() {
    this.stage.statusUrlResolution = this.viewState.statusUrlResolution;
  }
  failFastCodesChanged() {
    const failFastCodes = this.viewState.failFastStatusCodes.split(",").map((x) => x.trim());
    this.stage.failFastStatusCodes = failFastCodes.map((x) => parseInt(x, 10)).filter((x) => !isNaN(x));
  }
  retryCodesChanged() {
    const retryCodes = this.viewState.retryStatusCodes.split(",").map((x) => x.trim());
    this.stage.retryStatusCodes = retryCodes.map((x) => parseInt(x, 10)).filter((x) => !isNaN(x));
  }
  customHeaderCount() {
    return this.stage.customHeaders ? Object.keys(this.stage.customHeaders).length : 0;
  }
  removeCustomHeader(key) {
    delete this.stage.customHeaders[key];
  }
  addCustomHeader() {
    if (!this.stage.customHeaders) {
      this.stage.customHeaders = {};
    }
    this.$uibModal.open({
      templateUrl: "core/src/pipeline/config/stages/webhook/modal/addCustomHeader.html",
      controller: "WebhookStageAddCustomHeaderCtrl",
      controllerAs: "addCustomHeader"
    }).result.then((customHeader) => {
      this.stage.customHeaders[customHeader.key] = customHeader.value;
    }).catch(() => {
    });
  }
  displayField(field) {
    return !this.preconfiguredProperties || !this.preconfiguredProperties.some((property) => property === field);
  }
};
let WebhookStage = _WebhookStage;
WebhookStage.$inject = ["stage", "$uibModal"];
const WEBHOOK_STAGE = "spinnaker.core.pipeline.stage.webhookStage";
module(WEBHOOK_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    label: "Webhook",
    description: "Runs a Webhook job",
    key: "webhook",
    restartable: true,
    controller: "WebhookStageCtrl",
    producesArtifacts: true,
    controllerAs: "$ctrl",
    templateUrl: "core/src/pipeline/config/stages/webhook/webhookStage.html",
    executionDetailsUrl: "core/src/pipeline/config/stages/webhook/webhookExecutionDetails.html",
    supportsCustomTimeout: true,
    validators: [
      { type: "requiredField", fieldName: "url" },
      { type: "requiredField", fieldName: "method" }
    ]
  });
}).run(() => {
  REST("/webhooks/preconfigured").get().then((preconfiguredWebhooks) => {
    preconfiguredWebhooks.forEach((preconfiguredWebhook) => Registry.pipeline.registerStage({
      label: preconfiguredWebhook.label,
      description: preconfiguredWebhook.description,
      key: preconfiguredWebhook.type,
      alias: "preconfiguredWebhook",
      addAliasToConfig: true,
      producesArtifacts: true,
      restartable: true,
      controller: "WebhookStageCtrl",
      controllerAs: "$ctrl",
      templateUrl: "core/src/pipeline/config/stages/webhook/webhookStage.html",
      executionDetailsUrl: "core/src/pipeline/config/stages/webhook/webhookExecutionDetails.html",
      validators: [],
      configuration: {
        preconfiguredProperties: preconfiguredWebhook.preconfiguredProperties,
        waitForCompletion: preconfiguredWebhook.waitForCompletion,
        noUserConfigurableFields: preconfiguredWebhook.noUserConfigurableFields,
        parameters: preconfiguredWebhook.parameters
      }
    }));
  });
}).controller("WebhookStageCtrl", WebhookStage);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/webhook/modal/addCustomHeader.html", `<div modal-page>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Add Custom Header</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="addCustomHeaderForm">
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Key</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="customHeader.key"
            placeholder="enter a header key"
            required
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Value</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="customHeader.value"
            placeholder="enter a header value"
            required
          />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <button
        type="submit"
        class="btn btn-primary"
        data-purpose="submit"
        ng-click="addCustomHeader.submit()"
        ng-disabled="addCustomHeaderForm.$invalid"
      >
        <span class="far fa-check-circle"></span> Add
      </button>
    </div>
  </form>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/webhook/webhookStage.html", `<div class="form-horizontal">
  <div class="alert alert-info" ng-if="$ctrl.preconfiguredProperties.length">
    <strong>Note:</strong> {{$ctrl.noUserConfigurableFields ? 'All' : 'Some'}} of the settings of this stage are
    preconfigured, and cannot be changed.
  </div>
  <stage-config-field label="Webhook URL" ng-if="$ctrl.displayField('url')">
    <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.url" />
  </stage-config-field>
  <stage-config-field label="Method" ng-if="$ctrl.displayField('method')">
    <ui-select ng-model="$ctrl.stage.method" class="form-control input-sm">
      <ui-select-match placeholder="Select a method...">{{$select.selected}}</ui-select-match>
      <ui-select-choices repeat="method in $ctrl.methods | filter: $select.search">
        <span ng-bind-html="method | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </stage-config-field>
  <stage-config-field
    label="Fail Fast HTTP Statuses"
    help-key="pipeline.config.webhook.failFastCodes"
    ng-if="$ctrl.displayField('failFastStatusCodes')"
  >
    <input
      type="text"
      class="form-control input-sm"
      ng-model="$ctrl.viewState.failFastStatusCodes"
      ng-change="$ctrl.failFastCodesChanged()"
    />
  </stage-config-field>
  <stage-config-field label="Parameters" ng-if="$ctrl.parameters.length">
    <div class="form-group" ng-repeat="parameter in $ctrl.parameters | orderBy:['order','name']">
      <div class="col-md-3 sm-label-right">
        <b class="break-word">{{ parameter.label }}</b>
        <help-field content="{{parameter.description}}" ng-if="parameter.description"></help-field>
      </div>
      <div class="col-md-5">
        <input ng-model="$ctrl.stage.parameterValues[parameter.name]" type="text" class="form-control input-sm" />
      </div>
    </div>
  </stage-config-field>
  <stage-config-field
    label="Payload"
    help-key="pipeline.config.webhook.payload"
    ng-if="$ctrl.stage.method !== 'GET' && $ctrl.stage.method !== 'HEAD' && $ctrl.displayField('payload')"
  >
    <textarea
      class="code form-control flex-fill"
      rows="5"
      ng-model="$ctrl.command.payloadJSON"
      ng-change="$ctrl.updatePayload()"
    ></textarea>

    <div class="form-group row slide-in" ng-if="$ctrl.command.invalid">
      <div class="col-sm-9 col-sm-offset-3 error-message">Error: {{$ctrl.command.errorMessage}}</div>
    </div>
  </stage-config-field>
  <stage-config-field
    label="Custom Headers"
    help-key="pipeline.config.webhook.customHeaders"
    ng-if="$ctrl.displayField('customHeaders')"
  >
    <table class="table table-condensed packed" ng-if="$ctrl.customHeaderCount() > 0">
      <thead>
        <tr>
          <th style="width: 40%">Key</th>
          <th style="width: 60%">Value</th>
          <th class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="(key, value) in $ctrl.stage.customHeaders">
          <td>
            <strong class="small">{{key}}</strong>
          </td>
          <td>
            <input type="text" required ng-model="$ctrl.stage.customHeaders[key]" class="form-control input-sm" />
          </td>
          <td class="text-right">
            <a class="small" href ng-click="$ctrl.removeCustomHeader(key)">Remove</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-block btn-sm add-new" ng-click="$ctrl.addCustomHeader()">
          <span class="glyphicon glyphicon-plus-sign"></span> Add Custom Header
        </button>
      </div>
    </div>
  </stage-config-field>
  <div class="form-group" ng-if="$ctrl.displayField('waitForCompletion')">
    <div class="col-md-8 col-md-offset-1">
      <div class="checkbox pull-left">
        <label>
          <input
            type="checkbox"
            name="waitForCompletion"
            ng-model="$ctrl.viewState.waitForCompletion"
            ng-change="$ctrl.waitForCompletionChanged()"
          />
          <strong>Wait for completion</strong>
          <help-field key="pipeline.config.webhook.waitForCompletion"></help-field>
        </label>
      </div>
    </div>
  </div>
  <div
    ng-class="{collapse: $ctrl.viewState.waitForCompletion !== true, 'collapse.in': !$ctrl.viewState.waitForCompletion === true}"
  >
    <div class="form-group" ng-if="$ctrl.displayField('statusUrlResolution')">
      <div class="col-md-3 sm-label-right">Status URL</div>
      <div class="col-md-9 radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.statusUrlResolution"
            ng-change="$ctrl.statusUrlResolutionChanged()"
            value="getMethod"
            id="statusUrlResolutionIsGetMethod"
          />
          GET method against webhook URL
          <help-field key="pipeline.config.webhook.statusUrlResolutionIsGetMethod"></help-field>
        </label>
      </div>
      <div class="col-md-9 col-md-offset-3 radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.statusUrlResolution"
            ng-change="$ctrl.statusUrlResolutionChanged()"
            value="locationHeader"
            id="statusUrlResolutionIsLocationHeader"
          />
          From the Location header
          <help-field key="pipeline.config.webhook.statusUrlResolutionIsLocationHeader"></help-field>
        </label>
      </div>
      <div class="col-md-9 col-md-offset-3 radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.statusUrlResolution"
            ng-change="$ctrl.statusUrlResolutionChanged()"
            value="webhookResponse"
            id="statusUrlResolutionIsWebhookResponse"
          />
          From webhook's response
          <help-field key="pipeline.config.webhook.useStatusUrlFromLocationHeaderFalse"></help-field>
        </label>
      </div>
      <div
        class="form-group"
        ng-if="$ctrl.viewState.statusUrlResolution === 'webhookResponse' && $ctrl.displayField('statusUrlJsonPath')"
      >
        <div class="col-md-offset-3">
          <stage-config-field label="Status URL path" help-key="pipeline.config.webhook.statusUrlJsonPath">
            <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.statusUrlJsonPath" required />
          </stage-config-field>
        </div>
      </div>
    </div>
    <stage-config-field
      label="Delay before monitoring"
      help-key="pipeline.config.webhook.waitBeforeMonitor"
      ng-if="$ctrl.displayField('waitBeforeMonitor')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.waitBeforeMonitor" />
    </stage-config-field>
    <stage-config-field
      label="Retry HTTP Statuses"
      help-key="pipeline.config.webhook.retryStatusCodes"
      ng-if="$ctrl.displayField('retryStatusCodes')"
    >
      <input
        type="text"
        class="form-control input-sm"
        ng-model="$ctrl.viewState.retryStatusCodes"
        ng-change="$ctrl.retryCodesChanged()"
      />
    </stage-config-field>
    <stage-config-field
      label="Status JsonPath"
      help-key="pipeline.config.webhook.statusJsonPath"
      ng-if="$ctrl.displayField('statusJsonPath')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.statusJsonPath" />
    </stage-config-field>
    <stage-config-field
      label="Progress location"
      help-key="pipeline.config.webhook.progressJsonPath"
      ng-if="$ctrl.displayField('progressJsonPath')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.progressJsonPath" />
    </stage-config-field>
    <stage-config-field
      label="SUCCESS status mapping"
      help-key="pipeline.config.webhook.successStatuses"
      ng-if="$ctrl.displayField('successStatuses')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.successStatuses" />
    </stage-config-field>
    <stage-config-field
      label="CANCELED status mapping"
      help-key="pipeline.config.webhook.canceledStatuses"
      ng-if="$ctrl.displayField('canceledStatuses')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.canceledStatuses" />
    </stage-config-field>
    <stage-config-field
      label="TERMINAL status mapping"
      help-key="pipeline.config.webhook.terminalStatuses"
      ng-if="$ctrl.displayField('terminalStatuses')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.terminalStatuses" />
    </stage-config-field>

    <div class="form-group" ng-if="$ctrl.displayField('signalCancellation')">
      <div class="col-md-8 col-md-offset-1">
        <div class="checkbox pull-left">
          <label>
            <input
              type="checkbox"
              name="signalCancellation"
              ng-model="$ctrl.viewState.signalCancellation"
              ng-change="$ctrl.signalCancellationChanged()"
            />
            <strong>Signal on cancellation</strong>
            <help-field key="pipeline.config.webhook.signalCancellation"></help-field>
          </label>
        </div>
      </div>
    </div>
    <div
      ng-class="{collapse: $ctrl.viewState.signalCancellation !== true, 'collapse.in': !$ctrl.viewState.signalCancellation === true}"
    >
      <stage-config-field label="Cancellation URL" ng-if="$ctrl.displayField('cancelEndpoint')">
        <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.cancelEndpoint" />
      </stage-config-field>
      <stage-config-field label="Method" ng-if="$ctrl.displayField('cancelMethod')">
        <ui-select ng-model="$ctrl.stage.cancelMethod" class="form-control input-sm">
          <ui-select-match placeholder="Select a method...">{{$select.selected}}</ui-select-match>
          <ui-select-choices repeat="method in $ctrl.methods | filter: $select.search">
            <span ng-bind-html="method | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </stage-config-field>
      <stage-config-field
        label="Cancellation payload"
        help-key="pipeline.config.webhook.cancelPayload"
        ng-if="$ctrl.stage.cancelMethod !== 'GET' && $ctrl.stage.cancelMethod !== 'HEAD' && $ctrl.displayField('cancelPayload')"
      >
        <textarea
          class="code form-control flex-fill"
          rows="5"
          ng-model="$ctrl.cancelCommand.payloadJSON"
          ng-change="$ctrl.updateCancelPayload()"
        ></textarea>

        <div class="form-group row slide-in" ng-if="$ctrl.cancelCommand.invalid">
          <div class="col-sm-9 col-sm-offset-3 error-message">Error: {{$ctrl.cancelCommand.errorMessage}}</div>
        </div>
      </stage-config-field>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/webhook/webhookExecutionDetails.html", `<div ng-controller="WebhookExecutionDetailsCtrl as ctrl">
  <execution-details-section-nav sections="ctrl.configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="ctrl.detailsSection === 'webhookConfig'">
    <div class="row">
      <div class="col-md-12">
        <h5>Webhook Stage Configuration</h5>
        <dl class="dl-narrow dl-horizontal">
          <dt>Url</dt>
          <dd>{{ctrl.stage.context.url}}</dd>
          <dt>
            <copy-to-clipboard
              class="copy-to-clipboard copy-to-clipboard-sm"
              text="ctrl.payload"
              tool-tip="'Copy response to clipboard'"
            >
            </copy-to-clipboard>
            Payload
          </dt>
          <dd>
            <pre class="ng-binding" style="border: unset; background: unset; padding: 0">{{ctrl.payload}}</pre>
          </dd>
        </dl>
        <dl class="dl-narrow dl-horizontal" ng-if="ctrl.stage.context.waitForCompletion">
          <dt>Status endpoint</dt>
          <dd><p ng-bind-html="ctrl.stage.context.statusEndpoint | linky:'_blank'"></p></dd>
        </dl>
      </div>
      <div class="col-md-12" ng-if="ctrl.stage.context.parameterValues">
        <h5>Parameters</h5>
        <dl class="dl-narrow dl-horizontal">
          <dt ng-repeat-start="(key, val) in ctrl.stage.context.parameterValues">{{key}}</dt>
          <dd ng-repeat-end>{{val}}</dd>
        </dl>
      </div>
    </div>
    <stage-failure-message
      stage="ctrl.stage"
      is-failed="ctrl.stage.isFailed"
      message="ctrl.getException(stage) || ctrl.failureMessage"
    ></stage-failure-message>
    <div class="well alert-info" ng-if="ctrl.progressMessage || ctrl.stage.status">
      <h4>Results</h4>
      <dl class="dl-narrow dl-horizontal ng-scope">
        <dt>Status</dt>
        <dd class="ng-binding">{{ctrl.stage.status}}</dd>
        <dt>Info</dt>
        <dd class="ng-binding">
          <p ng-bind-html="ctrl.progressMessage | linky:'_blank'" style="white-space: pre-line"></p>
        </dd>
        <dt>Code</dt>
        <dd class="ng-binding">
          {{ctrl.stage.context.webhook.monitor.statusCodeValue || ctrl.stage.context.webhook.statusCodeValue}}
        </dd>
        <dt>
          <copy-to-clipboard
            class="copy-to-clipboard copy-to-clipboard-sm"
            text="ctrl.body"
            tool-tip="'Copy response to clipboard'"
          >
          </copy-to-clipboard>
          Response
        </dt>
        <dd>
          <pre
            class="ng-binding"
            style="max-height: 400px; overflow-y: auto; border: unset; background: unset; padding: 0"
          >
{{ctrl.body}}</pre
          >
        </dd>
      </dl>
    </div>
  </div>
  <div class="step-section-details" ng-if="ctrl.detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="ctrl.stage"></execution-step-details>
    </div>
  </div>
  <div ng-if="ctrl.detailsSection == 'artifactStatus'">
    <execution-artifact-tab stage="ctrl.stage" execution=""></execution-artifact-tab>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/webhook/webhookStage.html", `<div class="form-horizontal">
  <div class="alert alert-info" ng-if="$ctrl.preconfiguredProperties.length">
    <strong>Note:</strong> {{$ctrl.noUserConfigurableFields ? 'All' : 'Some'}} of the settings of this stage are
    preconfigured, and cannot be changed.
  </div>
  <stage-config-field label="Webhook URL" ng-if="$ctrl.displayField('url')">
    <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.url" />
  </stage-config-field>
  <stage-config-field label="Method" ng-if="$ctrl.displayField('method')">
    <ui-select ng-model="$ctrl.stage.method" class="form-control input-sm">
      <ui-select-match placeholder="Select a method...">{{$select.selected}}</ui-select-match>
      <ui-select-choices repeat="method in $ctrl.methods | filter: $select.search">
        <span ng-bind-html="method | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </stage-config-field>
  <stage-config-field
    label="Fail Fast HTTP Statuses"
    help-key="pipeline.config.webhook.failFastCodes"
    ng-if="$ctrl.displayField('failFastStatusCodes')"
  >
    <input
      type="text"
      class="form-control input-sm"
      ng-model="$ctrl.viewState.failFastStatusCodes"
      ng-change="$ctrl.failFastCodesChanged()"
    />
  </stage-config-field>
  <stage-config-field label="Parameters" ng-if="$ctrl.parameters.length">
    <div class="form-group" ng-repeat="parameter in $ctrl.parameters | orderBy:['order','name']">
      <div class="col-md-3 sm-label-right">
        <b class="break-word">{{ parameter.label }}</b>
        <help-field content="{{parameter.description}}" ng-if="parameter.description"></help-field>
      </div>
      <div class="col-md-5">
        <input ng-model="$ctrl.stage.parameterValues[parameter.name]" type="text" class="form-control input-sm" />
      </div>
    </div>
  </stage-config-field>
  <stage-config-field
    label="Payload"
    help-key="pipeline.config.webhook.payload"
    ng-if="$ctrl.stage.method !== 'GET' && $ctrl.stage.method !== 'HEAD' && $ctrl.displayField('payload')"
  >
    <textarea
      class="code form-control flex-fill"
      rows="5"
      ng-model="$ctrl.command.payloadJSON"
      ng-change="$ctrl.updatePayload()"
    ></textarea>

    <div class="form-group row slide-in" ng-if="$ctrl.command.invalid">
      <div class="col-sm-9 col-sm-offset-3 error-message">Error: {{$ctrl.command.errorMessage}}</div>
    </div>
  </stage-config-field>
  <stage-config-field
    label="Custom Headers"
    help-key="pipeline.config.webhook.customHeaders"
    ng-if="$ctrl.displayField('customHeaders')"
  >
    <table class="table table-condensed packed" ng-if="$ctrl.customHeaderCount() > 0">
      <thead>
        <tr>
          <th style="width: 40%">Key</th>
          <th style="width: 60%">Value</th>
          <th class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="(key, value) in $ctrl.stage.customHeaders">
          <td>
            <strong class="small">{{key}}</strong>
          </td>
          <td>
            <input type="text" required ng-model="$ctrl.stage.customHeaders[key]" class="form-control input-sm" />
          </td>
          <td class="text-right">
            <a class="small" href ng-click="$ctrl.removeCustomHeader(key)">Remove</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-block btn-sm add-new" ng-click="$ctrl.addCustomHeader()">
          <span class="glyphicon glyphicon-plus-sign"></span> Add Custom Header
        </button>
      </div>
    </div>
  </stage-config-field>
  <div class="form-group" ng-if="$ctrl.displayField('waitForCompletion')">
    <div class="col-md-8 col-md-offset-1">
      <div class="checkbox pull-left">
        <label>
          <input
            type="checkbox"
            name="waitForCompletion"
            ng-model="$ctrl.viewState.waitForCompletion"
            ng-change="$ctrl.waitForCompletionChanged()"
          />
          <strong>Wait for completion</strong>
          <help-field key="pipeline.config.webhook.waitForCompletion"></help-field>
        </label>
      </div>
    </div>
  </div>
  <div
    ng-class="{collapse: $ctrl.viewState.waitForCompletion !== true, 'collapse.in': !$ctrl.viewState.waitForCompletion === true}"
  >
    <div class="form-group" ng-if="$ctrl.displayField('statusUrlResolution')">
      <div class="col-md-3 sm-label-right">Status URL</div>
      <div class="col-md-9 radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.statusUrlResolution"
            ng-change="$ctrl.statusUrlResolutionChanged()"
            value="getMethod"
            id="statusUrlResolutionIsGetMethod"
          />
          GET method against webhook URL
          <help-field key="pipeline.config.webhook.statusUrlResolutionIsGetMethod"></help-field>
        </label>
      </div>
      <div class="col-md-9 col-md-offset-3 radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.statusUrlResolution"
            ng-change="$ctrl.statusUrlResolutionChanged()"
            value="locationHeader"
            id="statusUrlResolutionIsLocationHeader"
          />
          From the Location header
          <help-field key="pipeline.config.webhook.statusUrlResolutionIsLocationHeader"></help-field>
        </label>
      </div>
      <div class="col-md-9 col-md-offset-3 radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.statusUrlResolution"
            ng-change="$ctrl.statusUrlResolutionChanged()"
            value="webhookResponse"
            id="statusUrlResolutionIsWebhookResponse"
          />
          From webhook's response
          <help-field key="pipeline.config.webhook.useStatusUrlFromLocationHeaderFalse"></help-field>
        </label>
      </div>
      <div
        class="form-group"
        ng-if="$ctrl.viewState.statusUrlResolution === 'webhookResponse' && $ctrl.displayField('statusUrlJsonPath')"
      >
        <div class="col-md-offset-3">
          <stage-config-field label="Status URL path" help-key="pipeline.config.webhook.statusUrlJsonPath">
            <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.statusUrlJsonPath" required />
          </stage-config-field>
        </div>
      </div>
    </div>
    <stage-config-field
      label="Delay before monitoring"
      help-key="pipeline.config.webhook.waitBeforeMonitor"
      ng-if="$ctrl.displayField('waitBeforeMonitor')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.waitBeforeMonitor" />
    </stage-config-field>
    <stage-config-field
      label="Retry HTTP Statuses"
      help-key="pipeline.config.webhook.retryStatusCodes"
      ng-if="$ctrl.displayField('retryStatusCodes')"
    >
      <input
        type="text"
        class="form-control input-sm"
        ng-model="$ctrl.viewState.retryStatusCodes"
        ng-change="$ctrl.retryCodesChanged()"
      />
    </stage-config-field>
    <stage-config-field
      label="Status JsonPath"
      help-key="pipeline.config.webhook.statusJsonPath"
      ng-if="$ctrl.displayField('statusJsonPath')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.statusJsonPath" />
    </stage-config-field>
    <stage-config-field
      label="Progress location"
      help-key="pipeline.config.webhook.progressJsonPath"
      ng-if="$ctrl.displayField('progressJsonPath')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.progressJsonPath" />
    </stage-config-field>
    <stage-config-field
      label="SUCCESS status mapping"
      help-key="pipeline.config.webhook.successStatuses"
      ng-if="$ctrl.displayField('successStatuses')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.successStatuses" />
    </stage-config-field>
    <stage-config-field
      label="CANCELED status mapping"
      help-key="pipeline.config.webhook.canceledStatuses"
      ng-if="$ctrl.displayField('canceledStatuses')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.canceledStatuses" />
    </stage-config-field>
    <stage-config-field
      label="TERMINAL status mapping"
      help-key="pipeline.config.webhook.terminalStatuses"
      ng-if="$ctrl.displayField('terminalStatuses')"
    >
      <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.terminalStatuses" />
    </stage-config-field>

    <div class="form-group" ng-if="$ctrl.displayField('signalCancellation')">
      <div class="col-md-8 col-md-offset-1">
        <div class="checkbox pull-left">
          <label>
            <input
              type="checkbox"
              name="signalCancellation"
              ng-model="$ctrl.viewState.signalCancellation"
              ng-change="$ctrl.signalCancellationChanged()"
            />
            <strong>Signal on cancellation</strong>
            <help-field key="pipeline.config.webhook.signalCancellation"></help-field>
          </label>
        </div>
      </div>
    </div>
    <div
      ng-class="{collapse: $ctrl.viewState.signalCancellation !== true, 'collapse.in': !$ctrl.viewState.signalCancellation === true}"
    >
      <stage-config-field label="Cancellation URL" ng-if="$ctrl.displayField('cancelEndpoint')">
        <input type="text" class="form-control input-sm" ng-model="$ctrl.stage.cancelEndpoint" />
      </stage-config-field>
      <stage-config-field label="Method" ng-if="$ctrl.displayField('cancelMethod')">
        <ui-select ng-model="$ctrl.stage.cancelMethod" class="form-control input-sm">
          <ui-select-match placeholder="Select a method...">{{$select.selected}}</ui-select-match>
          <ui-select-choices repeat="method in $ctrl.methods | filter: $select.search">
            <span ng-bind-html="method | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </stage-config-field>
      <stage-config-field
        label="Cancellation payload"
        help-key="pipeline.config.webhook.cancelPayload"
        ng-if="$ctrl.stage.cancelMethod !== 'GET' && $ctrl.stage.cancelMethod !== 'HEAD' && $ctrl.displayField('cancelPayload')"
      >
        <textarea
          class="code form-control flex-fill"
          rows="5"
          ng-model="$ctrl.cancelCommand.payloadJSON"
          ng-change="$ctrl.updateCancelPayload()"
        ></textarea>

        <div class="form-group row slide-in" ng-if="$ctrl.cancelCommand.invalid">
          <div class="col-sm-9 col-sm-offset-3 error-message">Error: {{$ctrl.cancelCommand.errorMessage}}</div>
        </div>
      </stage-config-field>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/webhook/webhookExecutionDetails.html", `<div ng-controller="WebhookExecutionDetailsCtrl as ctrl">
  <execution-details-section-nav sections="ctrl.configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="ctrl.detailsSection === 'webhookConfig'">
    <div class="row">
      <div class="col-md-12">
        <h5>Webhook Stage Configuration</h5>
        <dl class="dl-narrow dl-horizontal">
          <dt>Url</dt>
          <dd>{{ctrl.stage.context.url}}</dd>
          <dt>
            <copy-to-clipboard
              class="copy-to-clipboard copy-to-clipboard-sm"
              text="ctrl.payload"
              tool-tip="'Copy response to clipboard'"
            >
            </copy-to-clipboard>
            Payload
          </dt>
          <dd>
            <pre class="ng-binding" style="border: unset; background: unset; padding: 0">{{ctrl.payload}}</pre>
          </dd>
        </dl>
        <dl class="dl-narrow dl-horizontal" ng-if="ctrl.stage.context.waitForCompletion">
          <dt>Status endpoint</dt>
          <dd><p ng-bind-html="ctrl.stage.context.statusEndpoint | linky:'_blank'"></p></dd>
        </dl>
      </div>
      <div class="col-md-12" ng-if="ctrl.stage.context.parameterValues">
        <h5>Parameters</h5>
        <dl class="dl-narrow dl-horizontal">
          <dt ng-repeat-start="(key, val) in ctrl.stage.context.parameterValues">{{key}}</dt>
          <dd ng-repeat-end>{{val}}</dd>
        </dl>
      </div>
    </div>
    <stage-failure-message
      stage="ctrl.stage"
      is-failed="ctrl.stage.isFailed"
      message="ctrl.getException(stage) || ctrl.failureMessage"
    ></stage-failure-message>
    <div class="well alert-info" ng-if="ctrl.progressMessage || ctrl.stage.status">
      <h4>Results</h4>
      <dl class="dl-narrow dl-horizontal ng-scope">
        <dt>Status</dt>
        <dd class="ng-binding">{{ctrl.stage.status}}</dd>
        <dt>Info</dt>
        <dd class="ng-binding">
          <p ng-bind-html="ctrl.progressMessage | linky:'_blank'" style="white-space: pre-line"></p>
        </dd>
        <dt>Code</dt>
        <dd class="ng-binding">
          {{ctrl.stage.context.webhook.monitor.statusCodeValue || ctrl.stage.context.webhook.statusCodeValue}}
        </dd>
        <dt>
          <copy-to-clipboard
            class="copy-to-clipboard copy-to-clipboard-sm"
            text="ctrl.body"
            tool-tip="'Copy response to clipboard'"
          >
          </copy-to-clipboard>
          Response
        </dt>
        <dd>
          <pre
            class="ng-binding"
            style="max-height: 400px; overflow-y: auto; border: unset; background: unset; padding: 0"
          >
{{ctrl.body}}</pre
          >
        </dd>
      </dl>
    </div>
  </div>
  <div class="step-section-details" ng-if="ctrl.detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="ctrl.stage"></execution-step-details>
    </div>
  </div>
  <div ng-if="ctrl.detailsSection == 'artifactStatus'">
    <execution-artifact-tab stage="ctrl.stage" execution=""></execution-artifact-tab>
  </div>
</div>
`);
}]);

const WEBHOOK_STAGE_MODULE = "spinnaker.core.pipeline.stage.webhook";
module(WEBHOOK_STAGE_MODULE, [
  WEBHOOK_STAGE,
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  STAGE_COMMON_MODULE,
  TIME_FORMATTERS,
  WEBHOOK_EXECUTION_DETAILS_CONTROLLER,
  WEBHOOK_STAGE_ADD_CUSTOM_HEADER_MODAL_CONTROLLER
]);

class WerckerStageAddParameter {
  constructor($scope, $uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
  }
  submit() {
    this.$uibModalInstance.close(this.$scope.parameter);
  }
}
WerckerStageAddParameter.$inject = ["$scope", "$uibModalInstance"];
const WERCKER_STAGE_ADD_PARAMETER_MODAL_CONTROLLER = "spinnaker.core.pipeline.stage.wercker.modal.addParameter";
module(WERCKER_STAGE_ADD_PARAMETER_MODAL_CONTROLLER, []).controller("WerckerStageAddParameterCtrl", WerckerStageAddParameter);

class WerckerExecutionDetailsCtrl {
  constructor($stateParams, executionDetailsSectionService, $scope) {
    this.$stateParams = $stateParams;
    this.executionDetailsSectionService = executionDetailsSectionService;
    this.$scope = $scope;
    this.configSections = ["werckerConfig", "taskStatus"];
    this.stage = this.$scope.stage;
    this.initialize();
    this.$scope.$on("$stateChangeSuccess", () => this.initialize());
  }
  initialized() {
    var _a;
    this.detailsSection = (_a = this.$stateParams.details) != null ? _a : "";
    this.failureMessage = this.getFailureMessage();
  }
  getFailureMessage() {
    var _a;
    let failureMessage = this.stage.failureMessage;
    const context = this.stage.context || {};
    const buildInfo = context.buildInfo || {};
    const testResults = (_a = buildInfo.testResults) != null ? _a : [];
    const failingTests = testResults.filter((results) => results.failCount > 0);
    const failingTestCount = failingTests.reduce((acc, results) => acc + results.failCount, 0);
    if (buildInfo.result === "FAILURE") {
      failureMessage = "Build failed.";
    }
    if (failingTestCount) {
      failureMessage = `${failingTestCount} test${failingTestCount > 1 ? "s" : ""} failed.`;
    }
    return failureMessage;
  }
  initialize() {
    this.executionDetailsSectionService.synchronizeSection(this.configSections, () => this.initialized());
  }
}
WerckerExecutionDetailsCtrl.$inject = ["$stateParams", "executionDetailsSectionService", "$scope"];
const WERCKER_EXECUTION_DETAILS_CONTROLLER = "spinnaker.core.pipeline.stage.wercker.executionDetails.controller";
module(WERCKER_EXECUTION_DETAILS_CONTROLLER, [EXECUTION_DETAILS_SECTION_SERVICE]).controller("WerckerExecutionDetailsCtrl", WerckerExecutionDetailsCtrl);

class WerckerExecutionLabel extends React__default.Component {
  render() {
    const buildInfo = this.props.stage.masterStage.context.buildInfo || {};
    const testResults = (buildInfo.testResults || []).map((result, index) => /* @__PURE__ */ React__default.createElement("div", {
      key: index
    }, "( ", /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-pass-count"
    }, result.totalCount - result.failCount - result.skipCount), " / ", /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-fail-count"
    }, result.failCount), result.skipCount > 0 && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", null, " / "), /* @__PURE__ */ React__default.createElement("span", {
      className: "tests-skip-count"
    }, result.skipCount)), " )"));
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "stage-label"
    }, /* @__PURE__ */ React__default.createElement("span", null, this.props.stage.name), buildInfo.number && /* @__PURE__ */ React__default.createElement("div", null, "Build #", buildInfo.number), testResults);
  }
}

class WerckerStage {
  constructor(stage, $scope, $uibModal) {
    this.stage = stage;
    this.$uibModal = $uibModal;
    this.filterLimit = 100;
    this.filterThreshold = 500;
    this.stage.failPipeline = this.stage.failPipeline === void 0 ? true : this.stage.failPipeline;
    this.stage.continuePipeline = this.stage.continuePipeline === void 0 ? false : this.stage.continuePipeline;
    this.viewState = {
      mastersLoaded: false,
      mastersRefreshing: false,
      appsLoaded: false,
      appsRefreshing: false,
      failureOption: "fail",
      markUnstableAsSuccessful: !!this.stage.markUnstableAsSuccessful,
      waitForCompletion: this.stage.waitForCompletion || this.stage.waitForCompletion === void 0
    };
    this.useDefaultParameters = {};
    this.userSuppliedParameters = {};
    this.initializeMasters();
    $scope.$watch("stage.master", () => this.updateAppsList());
    $scope.$watch("stage.app", () => this.updateJobsList());
    $scope.$watch("stage.pipeline", () => this.updateJob());
    $scope.$watch("stage.job", () => this.updateJobConfig());
  }
  markUnstableChanged() {
    this.stage.markUnstableAsSuccessful = this.viewState.markUnstableAsSuccessful;
  }
  waitForCompletionChanged() {
    this.stage.waitForCompletion = this.viewState.waitForCompletion;
  }
  refreshMasters() {
    this.viewState.mastersRefreshing = true;
    this.initializeMasters();
  }
  initializeMasters() {
    IgorService.listMasters(BuildServiceType.Wercker).then((masters) => {
      this.masters = masters;
      this.viewState.mastersLoaded = true;
      this.viewState.mastersRefreshing = false;
    });
  }
  refreshApps() {
    this.viewState.appsRefreshing = true;
    this.updateAppsList();
  }
  updateAppsList() {
    const master = this.stage.master;
    const job = this.stage.job || "";
    const viewState = this.viewState;
    viewState.masterIsParameterized = master.includes("${");
    viewState.jobIsParameterized = job.includes("${");
    if (viewState.masterIsParameterized || viewState.jobIsParameterized) {
      viewState.appsLoaded = true;
      return;
    }
    if (this.stage && this.stage.master) {
      this.viewState.appsLoaded = false;
      this.apps = [];
      IgorService.listJobsForMaster(this.stage.master).then((jobs) => {
        this.viewState.appsLoaded = true;
        this.viewState.appsRefreshing = false;
        const apps = Object.create({});
        jobs.forEach(function(app) {
          const orgApp = app.substring(app.indexOf("/") + 1, app.lastIndexOf("/"));
          apps[orgApp] = orgApp;
        });
        this.apps = Object.keys(apps);
        this.jobs = jobs;
        if (this.apps.length && !this.apps.includes(this.stage.app)) {
          this.stage.app = "";
          this.stage.pipeline = "";
          this.stage.job = "";
        }
      });
    }
  }
  refreshJobs() {
    this.viewState.appsRefreshing = true;
    this.updateJobsList();
  }
  updateJobsList() {
    if (this.stage && this.stage.app) {
      this.pipelines = [];
      this.viewState.appsLoaded = true;
      this.viewState.appsRefreshing = false;
      if (this.jobs) {
        const pipelines = Object.create({});
        const appSelected = this.stage.app;
        this.jobs.forEach(function(app) {
          if (!app.startsWith("pipeline") && appSelected === app.substring(app.indexOf("/") + 1, app.lastIndexOf("/"))) {
            const pl = app.substring(app.lastIndexOf("/") + 1);
            pipelines[pl] = pl;
          }
        });
        this.pipelines = Object.keys(pipelines);
      }
      if (this.pipelines.length && !this.pipelines.includes(this.stage.pipeline)) {
        this.stage.pipeline = "";
        this.stage.job = "";
      }
    }
  }
  updateJob() {
    if (this.stage && this.stage.app && this.stage.pipeline) {
      this.stage.job = this.stage.app + "/" + this.stage.pipeline;
    }
  }
  updateJobConfig() {
    const stage = this.stage;
    const view = this.viewState;
    if (stage && stage.job && stage.master && !view.masterIsParameterized && !view.jobIsParameterized) {
      IgorService.getJobConfig(stage.master, stage.job).then((config) => {
        config = config || {};
        if (!stage.parameters) {
          stage.parameters = {};
        }
        this.jobParams = config.parameterDefinitionList;
        this.userSuppliedParameters = stage.parameters;
        this.useDefaultParameters = {};
        const params = this.jobParams || [];
        params.forEach((property) => {
          if (!(property.name in stage.parameters) && property.defaultValue !== null) {
            this.useDefaultParameters[property.name] = true;
          }
        });
      });
    }
  }
  addParameter() {
    this.$uibModal.open({
      templateUrl: "core/src/pipeline/config/stages/wercker/modal/addParameter.html",
      controller: "WerckerStageAddParameterCtrl",
      controllerAs: "ctrl"
    }).result.then((parameter) => {
      this.stage.parameters[parameter.key] = parameter.value;
    }).catch(() => {
    });
  }
  removeParameter(key) {
    delete this.stage.parameters[key];
  }
  shouldFilter() {
    return this.jobs && this.jobs.length >= this.filterThreshold;
  }
}
WerckerStage.$inject = ["stage", "$scope", "$uibModal"];
const WERCKER_STAGE = "spinnaker.core.pipeline.stage.werckerStage";
module(WERCKER_STAGE, []).config(() => {
  Registry.pipeline.registerStage({
    label: "Wercker",
    description: "Runs a Wercker build pipeline",
    key: "wercker",
    restartable: true,
    controller: "WerckerStageCtrl",
    controllerAs: "$ctrl",
    templateUrl: "core/src/pipeline/config/stages/wercker/werckerStage.html",
    executionDetailsUrl: "core/src/pipeline/config/stages/wercker/werckerExecutionDetails.html",
    executionLabelComponent: WerckerExecutionLabel,
    extraLabelLines: (stage) => {
      if (!stage.masterStage.context || !stage.masterStage.context.buildInfo) {
        return 0;
      }
      const lines = stage.masterStage.context.buildInfo.number ? 1 : 0;
      return lines + (stage.masterStage.context.buildInfo.testResults || []).length;
    },
    supportsCustomTimeout: true,
    validators: [{ type: "requiredField", fieldName: "job" }],
    strategy: true
  });
}).controller("WerckerStageCtrl", WerckerStage);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/wercker/modal/addParameter.html", `<div modal-page>
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">Add Parameter</h4>
  </div>

  <form role="form" class="container-fluid" novalidate name="addParameterForm">
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Key</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="parameter.key"
            placeholder="enter a parameter key"
            required
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Value</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="parameter.value"
            placeholder="enter a parameter value"
            required
          />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <button
        type="submit"
        class="btn btn-primary"
        data-purpose="submit"
        ng-click="ctrl.submit()"
        ng-disabled="addParameterForm.$invalid"
      >
        <span class="far fa-check-circle"></span> Add
      </button>
    </div>
  </form>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/wercker/werckerStage.html", `<div class="form-horizontal">
  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">Build Service</label>
    <div class="col-md-6">
      <p class="form-control-static" ng-if="$ctrl.viewState.masterIsParameterized">{{$ctrl.stage.master}}</p>
      <ui-select
        class="form-control input-sm"
        ng-if="!$ctrl.viewState.masterIsParameterized"
        ng-model="$ctrl.stage.master"
      >
        <ui-select-match placeholder="Select a Wercker build service...">{{$select.selected}}</ui-select-match>
        <ui-select-choices repeat="master in $ctrl.masters | filter: $select.search">
          <span ng-bind-html="master | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="col-md-1 text-center" ng-if="!$ctrl.viewState.masterIsParameterized">
      <a
        href
        ng-click="$ctrl.refreshMasters()"
        tooltip-placement="right"
        uib-tooltip="{{$ctrl.viewState.mastersRefreshing ? 'Masters refreshing.' : 'Refresh masters list' }}"
      >
        <span ng-class="{'fa-spin':$ctrl.viewState.mastersRefreshing}" class="fa fa-sync-alt"></span>
      </a>
    </div>
  </div>

  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">Application</label>
    <div class="col-md-6">
      <p class="form-control-static" ng-if="!$ctrl.stage.master">(Select a build service)</p>
      <p
        class="form-control-static"
        ng-if="$ctrl.viewState.masterIsParameterized || $ctrl.viewState.appIsParameterized"
      >
        {{$ctrl.stage.app}}
      </p>
      <div ng-if="$ctrl.stage.master && $ctrl.viewState.appsLoaded">
        <ui-select
          class="form-control input-sm"
          ng-if="!$ctrl.viewState.masterIsParameterized && !$ctrl.viewState.appIsParameterized"
          ng-model="$ctrl.stage.app"
        >
          <ui-select-match placeholder="Select an Application...">{{$select.selected}}</ui-select-match>
          <ui-select-choices repeat="app in $ctrl.apps | filter: $select.search"
            ><span ng-bind-html="app | highlight: $select.search"></span
          ></ui-select-choices>
        </ui-select>
      </div>
      <div class="horizontal center" ng-if="$ctrl.stage.master && !$ctrl.viewState.appsLoaded">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
    </div>
    <div
      class="col-md-1 text-center"
      ng-if="!$ctrl.viewState.masterIsParameterized && !$ctrl.viewState.appIsParameterized"
    >
      <a
        href
        ng-click="$ctrl.refreshApps()"
        tooltip-placement="right"
        uib-tooltip="{{$ctrl.viewState.appsRefreshing ? 'Applications refreshing.' : 'Refresh application list' }}"
      >
        <span ng-class="{'fa-spin':$ctrl.viewState.appsRefreshing}" class="fa fa-sync-alt"></span>
      </a>
    </div>
  </div>

  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">Pipeline</label>
    <div class="col-md-6">
      <p class="form-control-static" ng-if="!$ctrl.stage.master">(Select an Application)</p>
      <p
        class="form-control-static"
        ng-if="$ctrl.viewState.masterIsParameterized || $ctrl.viewState.jobIsParameterized"
      >
        {{stage.job}}
      </p>
      <div ng-if="$ctrl.stage.app && $ctrl.viewState.appsLoaded">
        <ui-select
          class="form-control input-sm"
          ng-if="!$ctrl.viewState.masterIsParameterized && !$ctrl.viewState.jobIsParameterized"
          ng-model="$ctrl.stage.pipeline"
        >
          <ui-select-match placeholder="Select a pipeline...">{{$select.selected}}</ui-select-match>
          <ui-select-choices repeat="pipeline in $ctrl.pipelines | filter: $select.search"
            ><span ng-bind-html="pipeline | highlight: $select.search"></span
          ></ui-select-choices>
        </ui-select>
      </div>
      <div class="horizontal center" ng-if="$ctrl.stage.app && !$ctrl.viewState.appsLoaded">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
    </div>
    <div
      class="col-md-1 text-center"
      ng-if="!$ctrl.viewState.masterIsParameterized && !$ctrl.viewState.jobIsParameterized"
    >
      <a
        href
        ng-click="$ctrl.refreshJobs()"
        tooltip-placement="right"
        uib-tooltip="{{$ctrl.viewState.appsRefreshing ? 'Jobs refreshing.' : 'Refresh job list' }}"
      >
        <span ng-class="{'fa-spin':$ctrl.viewState.appsRefreshing}" class="fa fa-sync-alt"></span>
      </a>
    </div>
  </div>

  <stage-config-field label="Wait for results" help-key="wercker.waitForCompletion">
    <input
      type="checkbox"
      class="input-sm"
      name="waitForCompletion"
      ng-model="$ctrl.viewState.waitForCompletion"
      ng-change="$ctrl.waitForCompletionChanged()"
    />
  </stage-config-field>

  <div class="form-group">
    <label class="col-md-2 col-md-offset-1 sm-label-right">If build is unstable</label>
    <div class="col-md-9">
      <div class="radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.markUnstableAsSuccessful"
            ng-change="$ctrl.markUnstableChanged()"
            ng-value="false"
          />
          fail the stage
          <help-field key="pipeline.config.wercker.markUnstableAsSuccessful.false"></help-field>
        </label>
      </div>
      <div class="radio">
        <label>
          <input
            type="radio"
            ng-model="$ctrl.viewState.markUnstableAsSuccessful"
            ng-change="$ctrl.markUnstableChanged()"
            ng-value="true"
          />
          consider stage successful
          <help-field key="pipeline.config.wercker.markUnstableAsSuccessful.true"></help-field>
        </label>
      </div>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/stages/wercker/werckerExecutionDetails.html", `<div ng-controller="WerckerExecutionDetailsCtrl">
  <execution-details-section-nav sections="configSections"></execution-details-section-nav>
  <div class="step-section-details" ng-if="detailsSection === 'werckerConfig'">
    <div class="row">
      <div class="col-md-{{stage.context.buildInfo.testResults ? 6 : 12}}">
        <h5>Wercker Stage Configuration</h5>
        <dl class="dl-narrow dl-horizontal">
          <dt>Build Service</dt>
          <dd>{{stage.context.master}}</dd>
          <dt>Job</dt>
          <dd>{{stage.context.job}}</dd>
          <dt>Build</dt>
          <dd>
            <span ng-if="!stage.context.buildInfo">{{stage.context.buildNumber}}</span>
            <a ng-if="stage.context.buildInfo.url" href="{{stage.context.buildInfo.url}}" target="_blank"
              >#{{stage.context.buildInfo.number}}</a
            >
          </dd>
        </dl>
      </div>
      <div class="col-md-6" ng-if="stage.context.buildInfo.testResults">
        <h5>Test Results</h5>
        <div class="row" ng-repeat="result in stage.context.buildInfo.testResults">
          <div class="col-md-6">
            <p>
              <a target="_blank" href="{{stage.context.buildInfo.url}}{{result.urlName}}" class="pad-left">
                {{result.urlName | robotToHuman }}
              </a>
            </p>
          </div>
          <div class="col-md-6">
            <p class="test-results">
              <span class="test-result-section">
                {{result.totalCount - result.failCount - result.skipCount}} <span class="small fa fa-check"></span>
              </span>
              <span class="test-result-section">
                {{result.failCount}} <span class="small glyphicon glyphicon-remove informational"></span>
              </span>
              <span class="test-result-section" ng-if="result.skipCount">
                {{result.skipCount}} <span class="small glyphicon glyphicon-minus"></span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" ng-if="stage.context.parameters">
      <div class="col-md-12">
        <h5 style="margin-bottom: 0; padding-bottom: 5px">Parameters</h5>
        <dl>
          <dt ng-repeat-start="(key, val) in stage.context.parameters">{{key}}</dt>
          <dd ng-repeat-end>{{val}}</dd>
        </dl>
      </div>
    </div>

    <div class="row" ng-if="stage.context.propertyFileContents">
      <div class="col-md-12">
        <h5 style="margin-bottom: 0; padding-bottom: 5px">Property File</h5>
        <dl>
          <dt ng-repeat-start="(key, val) in stage.context.propertyFileContents">{{key}}</dt>
          <dd ng-repeat-end>{{val}}</dd>
        </dl>
      </div>
    </div>

    <stage-failure-message
      stage="stage"
      ng-if="stage.isFailed"
      message="ctrl.getException(stage) || failureMessage"
    ></stage-failure-message>
  </div>

  <div class="step-section-details" ng-if="detailsSection === 'taskStatus'">
    <div class="row">
      <execution-step-details item="stage"></execution-step-details>
    </div>
  </div>
</div>
`);
}]);

const WERCKER_STAGE_MODULE = "spinnaker.core.pipeline.stage.wercker";
module(WERCKER_STAGE_MODULE, [
  WERCKER_STAGE,
  CORE_PIPELINE_CONFIG_STAGES_STAGE_MODULE,
  STAGE_COMMON_MODULE,
  TIME_FORMATTERS,
  WERCKER_EXECUTION_DETAILS_CONTROLLER,
  WERCKER_STAGE_ADD_PARAMETER_MODAL_CONTROLLER
]);

var css_248z$u = ".delete-pipeline-template-modal__delete-error {\n  color: var(--color-danger);\n}\n";
styleInject(css_248z$u);

class DeletePipelineTemplateV2Modal extends React__default.Component {
  constructor(props) {
    super(props);
    this.deleteTemplate = () => {
      PipelineTemplateWriter.deleteTemplate(this.props.template).then(() => this.props.onClose(), (err) => this.setState({ deleteError: err }));
    };
    this.state = {
      deleteError: null
    };
  }
  getDeleteErrorMessage() {
    const { deleteError } = this.state;
    if (this.state.deleteError) {
      const message = get(deleteError, "data.message", get(deleteError, "message", ""));
      if (message) {
        return message;
      }
      return "An unknown error occurred while deleting this template";
    }
    return "";
  }
  render() {
    const { deleteError } = this.state;
    return /* @__PURE__ */ React__default.createElement(Modal$1, {
      show: true,
      dialogClassName: "modal-lg",
      onHide: () => {
      }
    }, /* @__PURE__ */ React__default.createElement(ModalClose, {
      dismiss: this.props.onClose
    }), /* @__PURE__ */ React__default.createElement(Modal$1.Header, null, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Really delete template ", this.props.template.metadata.name, "?")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, "Deleting a pipeline template will not work if there are any pipelines depending on it."), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, deleteError && /* @__PURE__ */ React__default.createElement("span", {
      className: "delete-pipeline-template-modal__delete-error"
    }, this.getDeleteErrorMessage()), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-default",
      onClick: this.props.onClose
    }, "Cancel"), /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-primary",
      onClick: this.deleteTemplate
    }, "Delete")));
  }
}

class ApplicationSelector extends React__default.Component {
  render() {
    const { applications, applicationSelectCallback, selectedApplication } = this.props;
    const selectedApplicationOption = selectedApplication ? { label: selectedApplication.name, value: selectedApplication.name } : null;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-3 sm-label-right"
    }, /* @__PURE__ */ React__default.createElement("b", null, "Application")), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, /* @__PURE__ */ React__default.createElement(Select, {
      options: applications.map(({ name }) => ({ label: name, value: name })),
      clearable: true,
      value: selectedApplicationOption,
      onChange: applicationSelectCallback,
      onSelectResetsInput: false
    })));
  }
}

var css_248z$t = ".create-pipeline-from-template-modal .modal-content {\n  overflow: visible;\n}\n";
styleInject(css_248z$t);

class CreatePipelineFromTemplate extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      applicationError: "",
      applicationSelectionComplete: false,
      applications: [],
      loading: true,
      loadedApplication: null,
      selectedApplication: null,
      submitting: false
    };
    this.destroy$ = new Subject();
    this.handleApplicationSelect = (selectedApplicationOption) => {
      if (selectedApplicationOption === null) {
        return this.setState({ applicationError: "", selectedApplication: null });
      }
      const selectedApplication = this.state.applications.find(({ name }) => name === selectedApplicationOption.value) || null;
      this.setState({ applicationError: "", selectedApplication });
    };
    this.handleLoadErrorDismissal = () => {
      this.setState({ applicationError: "" });
    };
    this.continueWithCreatingPipeline = () => {
      const {
        selectedApplication: { name }
      } = this.state;
      this.setState({ submitting: true });
      from(ApplicationReader.getApplication(name)).pipe(takeUntil(this.destroy$)).subscribe((loadedApplication) => {
        loadedApplication.getDataSource("pipelineConfigs").activate();
        this.setState({ applicationSelectionComplete: true, loadedApplication, submitting: false });
      }, () => {
        this.setState({
          applicationError: `Could not load application ${name}. Please try again.`,
          selectedApplication: null,
          submitting: false
        });
      });
    };
    this.goToPipelineConfig = (application, id) => {
      const { $state } = ReactInjector;
      $state.go("home.applications.application.pipelines.pipelineConfig", { application, pipelineId: id, new: 1 });
    };
  }
  componentDidMount() {
    from(ApplicationReader.listApplications()).pipe(takeUntil(this.destroy$)).subscribe((applications) => this.setState({ applications, loading: false }), () => {
      this.setState({ applicationError: `Could not load application list. Please try again.`, loading: false });
    });
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const {
      applications,
      applicationError,
      applicationSelectionComplete,
      loading,
      loadedApplication,
      selectedApplication,
      submitting
    } = this.state;
    const { closeModalCallback, template } = this.props;
    if (applicationSelectionComplete) {
      return /* @__PURE__ */ React__default.createElement(CreatePipelineModal, {
        application: loadedApplication,
        show: true,
        showCallback: closeModalCallback,
        pipelineSavedCallback: (id) => {
          this.goToPipelineConfig(loadedApplication.name, id);
        },
        preselectedTemplate: template
      });
    }
    return /* @__PURE__ */ React__default.createElement(Modal$1, {
      show: true,
      onHide: closeModalCallback,
      className: "create-pipeline-from-template-modal"
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Header, {
      closeButton: true
    }, /* @__PURE__ */ React__default.createElement(Modal$1.Title, null, "Select An Application")), /* @__PURE__ */ React__default.createElement(Modal$1.Body, null, applicationError && /* @__PURE__ */ React__default.createElement("div", {
      className: "alert alert-danger"
    }, /* @__PURE__ */ React__default.createElement("p", null, applicationError), /* @__PURE__ */ React__default.createElement("p", null, /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.handleLoadErrorDismissal
    }, "[dismiss]"))), loading ? /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "medium"
    }) : /* @__PURE__ */ React__default.createElement(ApplicationSelector, {
      applications,
      applicationSelectCallback: this.handleApplicationSelect,
      selectedApplication
    })), /* @__PURE__ */ React__default.createElement(Modal$1.Footer, null, /* @__PURE__ */ React__default.createElement(Button$1, {
      onClick: closeModalCallback
    }, "Cancel"), /* @__PURE__ */ React__default.createElement(SubmitButton, {
      label: "Continue",
      submitting,
      isDisabled: loading || submitting || selectedApplication === null,
      onClick: this.continueWithCreatingPipeline
    })));
  }
}

var css_248z$s = ".pipeline-templates-error-banner {\n  margin: 1em 0;\n}\n.pipeline-templates-error-banner i.fa-exclamation-triangle {\n  padding-right: 8px;\n}\n.templates-table__template-actions {\n  display: flex;\n}\n.templates-table__template-actions button.link {\n  padding: 0 1em 0 0;\n}\n.templates-table__template-actions button.link:last-child {\n  padding: 0;\n}\n.templates-table__template-actions .link--create {\n  margin-left: 1rem;\n}\n.templates-table__template-versions {\n  min-width: 300px;\n}\n";
styleInject(css_248z$s);

const { convertTemplateVersionToId, getTemplateVersion } = PipelineTemplateV2Service;
const PipelineTemplatesV2Error = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "pipeline-templates-error-banner horizontal middle center heading-4"
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), /* @__PURE__ */ React__default.createElement("span", null, props.message));
};
class PipelineTemplatesV2 extends React__default.Component {
  constructor() {
    super(...arguments);
    this.routeChangedSubscription = null;
    this.state = {
      fetchError: null,
      searchValue: "",
      selectedTemplate: null,
      templates: {},
      viewTemplateVersion: ReactInjector.$stateParams.templateId,
      templateVersionSelections: {}
    };
    this.onRouteChanged = (stateChange) => {
      const { to, toParams } = stateChange;
      if (to.name === "home.pipeline-templates") {
        this.setState({ viewTemplateVersion: null });
      } else if (to.name === "home.pipeline-templates.pipeline-templates-detail") {
        const { templateId } = toParams;
        this.setState({ viewTemplateVersion: templateId || null });
      }
    };
    this.sortTemplates = (templates) => {
      return templates.sort(([a], [b]) => {
        const caseInsensitiveA = a.toLowerCase();
        const caseInsensitiveB = b.toLowerCase();
        if (caseInsensitiveA > caseInsensitiveB) {
          return 1;
        } else if (caseInsensitiveA < caseInsensitiveB) {
          return -1;
        }
        return 0;
      });
    };
    this.getUpdateTimeForTemplate = (template) => {
      const millis = Number.parseInt(template.updateTs, 10);
      if (isNaN(millis)) {
        return "";
      }
      const dt = DateTime.fromMillis(millis);
      return dt.toLocaleString(DateTime.DATETIME_SHORT);
    };
    this.dismissDetailsModal = () => {
      ReactInjector.$state.go("home.pipeline-templates");
    };
    this.onSearchFieldChanged = (event) => {
      const searchValue = get(event, "target.value", "");
      this.setState({ searchValue });
    };
    this.filterMemoizeResolver = (templateCollections, query) => {
      const templateIds = flatMap(templateCollections, ([, templateCollection]) => templateCollection.map((template) => getTemplateVersion(template)));
      return `${templateIds.join("")}${query}`;
    };
    this.filterSearchResults = memoize((templateCollections, query) => {
      const searchValue = query.trim().toLowerCase();
      if (!searchValue) {
        return templateCollections;
      } else {
        return templateCollections.filter(([, templateCollection]) => templateCollection.some(({ metadata: { name = "", description = "", owner = "" } = {} }) => name.toLowerCase().includes(searchValue) || description.toLowerCase().includes(searchValue) || owner.toLowerCase().includes(searchValue)));
      }
    }, this.filterMemoizeResolver);
    this.getViewTemplate = () => this.findTemplate("viewTemplateVersion");
    this.getDeleteTemplate = () => this.findTemplate("deleteTemplateVersion");
    this.handleCreatePipelineModalClose = () => {
      this.setState({ selectedTemplate: null });
    };
    this.handleSelectedTemplateVersionChange = (e, templateId) => this.setState({
      templateVersionSelections: { ...this.state.templateVersionSelections, [templateId]: e.target.value }
    });
  }
  componentDidMount() {
    this.fetchTemplates();
    this.routeChangedSubscription = ReactInjector.stateEvents.stateChangeSuccess.subscribe(this.onRouteChanged);
  }
  componentWillUnmount() {
    this.routeChangedSubscription.unsubscribe();
  }
  fetchTemplates() {
    PipelineTemplateReader.getV2PipelineTemplateList().then((templates) => this.setState({ templates, templateVersionSelections: {} }), (err) => {
      const errorString = get(err, "data.message", get(err, "message", ""));
      if (errorString) {
        this.setState({ fetchError: errorString });
      } else {
        this.setState({ fetchError: "An unknown error occurred while fetching templates" });
      }
    });
  }
  findTemplate(actionKey) {
    const { [actionKey]: templateVersion, templates } = this.state;
    const templateId = convertTemplateVersionToId(templateVersion);
    const { [templateId]: templateCollection = [] } = templates;
    return templateCollection.find((template) => getTemplateVersion(template) === templateVersion);
  }
  handleCreatePipelineClick(template) {
    this.setState({ selectedTemplate: template });
  }
  render() {
    const {
      templates,
      selectedTemplate,
      searchValue,
      fetchError,
      viewTemplateVersion,
      deleteTemplateVersion,
      templateVersionSelections
    } = this.state;
    const detailsTemplate = viewTemplateVersion ? this.getViewTemplate() : null;
    const searchPerformed = searchValue.trim() !== "";
    const filteredResults = this.sortTemplates(this.filterSearchResults(Object.entries(templates), searchValue));
    const resultsAvailable = filteredResults.length > 0;
    const deleteTemplate = deleteTemplateVersion ? this.getDeleteTemplate() : null;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure-section search-header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "container"
    }, /* @__PURE__ */ React__default.createElement("h2", {
      className: "header-section"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "search-label"
    }, "Pipeline Templates"), /* @__PURE__ */ React__default.createElement("input", {
      type: "search",
      placeholder: "Search pipeline templates",
      className: "form-control input-md",
      ref: (input) => input && input.focus(),
      onChange: this.onSearchFieldChanged,
      value: searchValue
    })))), /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure-section container"
    }, fetchError && /* @__PURE__ */ React__default.createElement(PipelineTemplatesV2Error, {
      message: `There was an error fetching pipeline templates: ${fetchError}`
    }), searchPerformed && !resultsAvailable && /* @__PURE__ */ React__default.createElement("h4", {
      className: "infrastructure-section__message"
    }, "No matches found for '", searchValue, "'"), resultsAvailable && /* @__PURE__ */ React__default.createElement("table", {
      className: "table templates-table"
    }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", null, "Name"), /* @__PURE__ */ React__default.createElement("th", null, "Owner"), /* @__PURE__ */ React__default.createElement("th", null, "Updated"), /* @__PURE__ */ React__default.createElement("th", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "sort-toggle clickable"
    }, "Version", /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-Down-triangle"
    }))), /* @__PURE__ */ React__default.createElement("th", null, "Actions"))), /* @__PURE__ */ React__default.createElement("tbody", null, filteredResults.map(([templateId, templateCollection]) => {
      const templateVersion = templateVersionSelections[templateId] || getTemplateVersion(templateCollection[0]);
      const currentTemplate = templateCollection.find((template) => getTemplateVersion(template) === templateVersion);
      const { metadata } = currentTemplate;
      return /* @__PURE__ */ React__default.createElement("tr", {
        key: templateVersion
      }, /* @__PURE__ */ React__default.createElement("td", {
        className: "templates-table__template-name"
      }, metadata.name || "-"), /* @__PURE__ */ React__default.createElement("td", null, metadata.owner || "-"), /* @__PURE__ */ React__default.createElement("td", null, this.getUpdateTimeForTemplate(currentTemplate) || "-"), /* @__PURE__ */ React__default.createElement("td", {
        className: "templates-table__template-versions"
      }, /* @__PURE__ */ React__default.createElement(ReactSelectInput, {
        clearable: false,
        onChange: (e) => this.handleSelectedTemplateVersionChange(e, templateId),
        value: templateVersion,
        stringOptions: templateCollection.map((templateOption) => getTemplateVersion(templateOption))
      })), /* @__PURE__ */ React__default.createElement("td", {
        className: "templates-table__template-actions"
      }, /* @__PURE__ */ React__default.createElement(UISref, {
        to: `.pipeline-templates-detail`,
        params: { templateId: templateVersion }
      }, /* @__PURE__ */ React__default.createElement("button", {
        className: "link"
      }, "View")), /* @__PURE__ */ React__default.createElement("button", {
        className: "link",
        onClick: () => this.setState({ deleteTemplateVersion: templateVersion })
      }, "Delete"), /* @__PURE__ */ React__default.createElement("button", {
        className: "link link--create",
        onClick: () => this.handleCreatePipelineClick(currentTemplate)
      }, "Create Pipeline")));
    }))))), detailsTemplate && /* @__PURE__ */ React__default.createElement(Modal$1, {
      show: true,
      dialogClassName: "modal-lg modal-fullscreen",
      onHide: () => {
      }
    }, /* @__PURE__ */ React__default.createElement(ShowPipelineTemplateJsonModal, {
      template: detailsTemplate,
      editable: false,
      modalHeading: "View Pipeline Template",
      descriptionText: "The JSON below contains the metadata, variables and pipeline definition for this template.",
      dismissModal: this.dismissDetailsModal
    })), deleteTemplate && /* @__PURE__ */ React__default.createElement(DeletePipelineTemplateV2Modal, {
      template: deleteTemplate,
      onClose: () => {
        this.fetchTemplates();
        this.setState({ deleteTemplateVersion: null });
      }
    }), selectedTemplate && /* @__PURE__ */ React__default.createElement(CreatePipelineFromTemplate, {
      closeModalCallback: this.handleCreatePipelineModalClose,
      template: selectedTemplate
    }));
  }
}

const PIPELINE_TEMPLATES_V2_STATES_CONFIG = "spinnaker.core.pipeline.templates.v2.states.config";
module(PIPELINE_TEMPLATES_V2_STATES_CONFIG, [STATE_CONFIG_PROVIDER]).config([
  "stateConfigProvider",
  (stateConfigProvider) => {
    const pipelineTemplateDetail = {
      name: "pipeline-templates-detail",
      url: "/:templateId",
      data: {
        pageTitleMain: {
          label: "Pipeline Templates"
        }
      }
    };
    const pipelineTemplatesList = {
      name: "pipeline-templates",
      url: "/pipeline-templates",
      views: {
        "main@": {
          component: PipelineTemplatesV2,
          $type: "react"
        }
      },
      data: {
        pageTitleMain: {
          label: "Pipeline Templates"
        }
      },
      children: [pipelineTemplateDetail]
    };
    stateConfigProvider.addToRootState(pipelineTemplatesList);
  }
]);

const EXECUTION_DETAILS_SECTION_NAV = "spinnaker.core.pipeline.details.executionDetailsSectionNav";
module(EXECUTION_DETAILS_SECTION_NAV, []).component("executionDetailsSectionNav", react2angular(withErrorBoundary(ExecutionDetailsSectionNav, "executionDetailsSectionNav"), ["sections"]));

const STAGE_FAILURE_MESSAGE_COMPONENT = "spinnaker.core.pipeline.stageFailureMessage.component";
module(STAGE_FAILURE_MESSAGE_COMPONENT, []).component("stageFailureMessage", react2angular(withErrorBoundary(StageFailureMessage, "stageFailureMessage"), ["message", "messages", "stage"]));

const CORE_PIPELINE_PIPELINE_DATASOURCE = "spinnaker.core.pipeline.dataSource";
module(CORE_PIPELINE_PIPELINE_DATASOURCE, [EXECUTION_SERVICE, CLUSTER_SERVICE]).run([
  "$q",
  "executionService",
  "clusterService",
  function($q, executionService, clusterService) {
    const addExecutions = (application, executions) => {
      executionService.transformExecutions(application, executions, application.executions.data);
      return $q.when(executionService.addExecutionsToApplication(application, executions));
    };
    const loadExecutions = (application) => {
      return executionService.getExecutions(application.name, application);
    };
    const loadPipelineConfigs = (application) => {
      const pipelineLoader = PipelineConfigService.getPipelinesForApplication(application.name);
      const strategyLoader = PipelineConfigService.getStrategiesForApplication(application.name);
      return $q.all([pipelineLoader, strategyLoader]).then(([pipelineConfigs, strategyConfigs]) => ({ pipelineConfigs, strategyConfigs }));
    };
    const addPipelineConfigs = (application, data) => {
      application.strategyConfigs = { data: data.strategyConfigs };
      return $q.when(data.pipelineConfigs);
    };
    const loadRunningExecutions = (application) => {
      return executionService.getRunningExecutions(application.name);
    };
    const addRunningExecutions = (application, data) => {
      executionService.transformExecutions(application, data);
      return $q.when(data);
    };
    const runningExecutionsLoaded = (application) => {
      clusterService.addExecutionsToServerGroups(application);
      executionService.mergeRunningExecutionsIntoExecutions(application);
      application.getDataSource("serverGroups").dataUpdated();
    };
    const executionsLoaded = (application) => {
      addExecutionTags(application);
      executionService.removeCompletedExecutionsFromRunningData(application);
    };
    const addExecutionTags = (application) => {
      EntityTagsReader.addTagsToExecutions(application);
    };
    const addPipelineTags = (application) => {
      EntityTagsReader.addTagsToPipelines(application);
    };
    if (SETTINGS.feature.pipelines !== false) {
      ApplicationDataSourceRegistry.registerDataSource({
        optional: true,
        primary: true,
        icon: "fa fa-xs fa-fw fa-list",
        iconName: "spMenuPipelines",
        key: "executions",
        label: "Pipelines",
        category: DELIVERY_KEY,
        sref: ".pipelines.executions",
        activeState: "**.pipelines.**",
        loader: loadExecutions,
        onLoad: addExecutions,
        afterLoad: executionsLoaded,
        lazy: true,
        badge: "runningExecutions",
        description: "Orchestrated deployment management",
        defaultData: []
      });
      ApplicationDataSourceRegistry.registerDataSource({
        key: "pipelineConfigs",
        loader: loadPipelineConfigs,
        onLoad: addPipelineConfigs,
        afterLoad: addPipelineTags,
        lazy: true,
        visible: false,
        defaultData: []
      });
      ApplicationDataSourceRegistry.registerDataSource({
        key: "runningExecutions",
        visible: false,
        loader: loadRunningExecutions,
        onLoad: addRunningExecutions,
        afterLoad: runningExecutionsLoaded,
        defaultData: []
      });
    }
  }
]);

var css_248z$r = ".single-execution-details__configure {\n  margin: 0 0 5px 1em;\n}\n";
styleInject(css_248z$r);

function getAndTransformExecution(id, app) {
  var _a;
  return ReactInjector.executionService.getExecution(id, (_a = app.pipelineConfigs) == null ? void 0 : _a.data).then((execution) => {
    ExecutionsTransformer.transformExecution(app, execution);
    return execution;
  });
}
function traverseLineage(execution, maxGenerations = 3) {
  var _a;
  const lineage = [];
  if (!execution) {
    return lineage;
  }
  let current = execution;
  lineage.unshift(current.id);
  while (((_a = current.trigger) == null ? void 0 : _a.parentExecution) && lineage.length < maxGenerations) {
    current = current.trigger.parentExecution;
    lineage.unshift(current.id);
  }
  return lineage;
}
function SingleExecutionDetails(props) {
  const scheduler = SchedulerFactory.createScheduler(5e3);
  const { sortFilter } = ExecutionState.filterModel.asFilterModel;
  const { app } = props;
  const [showDurations, setShowDurations] = useState$b(sortFilter.showDurations);
  const { params } = useCurrentStateAndParams();
  const { executionId } = params;
  const getAncestry = (execution2) => {
    const youngest = ancestry[ancestry.length - 1];
    const navigating = execution2 && youngest && youngest.id !== execution2.id;
    const lineage2 = traverseLineage(execution2);
    const ancestryCache = ancestry.reduce((acc, curr) => set(acc, curr.id, curr), {
      [execution2.id]: execution2
    });
    const inactiveCache = ancestry.filter((ancestor) => !ancestor.isActive).reduce((acc, curr) => set(acc, curr.id, curr), { [execution2.id]: execution2 });
    const cache = navigating ? ancestryCache : inactiveCache;
    return Promise.all(lineage2.map((generation) => cache[generation] ? Promise.resolve(cache[generation]) : getAndTransformExecution(generation, app)));
  };
  const { result: execution, status: getExecutionStatus, refresh: refreshExecution } = useLatestPromise(() => getAndTransformExecution(executionId, app), [executionId]);
  const lineage = traverseLineage(execution);
  const transitioningToAncestor = lineage.includes(executionId) && executionId !== (execution == null ? void 0 : execution.id) ? executionId : "";
  const { result: ancestry } = useData(() => getAncestry(execution), [], [execution, executionId]);
  const someActive = [execution].concat(ancestry).filter((x) => x).some((x) => x.isActive);
  useEffect$a(() => {
    const subscription = someActive && scheduler.subscribe(() => refreshExecution());
    return () => {
      subscription && subscription.unsubscribe();
    };
  }, [someActive]);
  const { result: pipelineConfigs } = useLatestPromise(() => {
    app.pipelineConfigs.activate();
    return app.pipelineConfigs.ready();
  }, []);
  const pipelineConfig = pipelineConfigs && execution && pipelineConfigs.find((p) => p.id === execution.pipelineConfigId);
  const showDurationsChanged = (event) => {
    const checked = event.target.checked;
    setShowDurations(checked);
    ExecutionState.filterModel.asFilterModel.sortFilter.showDurations = showDurations;
    logger.log({ category: "Pipelines", action: "Toggle Durations", data: { label: checked.toString() } });
  };
  const rerunExecution = (execution2, application, pipeline) => {
    ManualExecutionModal.show({
      pipeline,
      application,
      trigger: execution2.trigger
    }).then((command) => {
      const { executionService } = ReactInjector;
      executionService.startAndMonitorPipeline(application, command.pipelineName, command.trigger);
      ReactInjector.$state.go("^.^.executions");
    });
  };
  let truncateAncestry = ancestry.length - 1;
  if (executionId && execution && executionId !== execution.id) {
    const idx = ancestry.findIndex((a) => a.id === executionId);
    if (idx > -1) {
      truncateAncestry = idx + 1;
    }
  }
  const hideMainExecution = !(!transitioningToAncestor || transitioningToAncestor === execution.id);
  return /* @__PURE__ */ React__default.createElement("div", {
    style: { width: "100%", paddingTop: 0 }
  }, execution && /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "single-execution-details"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex-container-h baseline"
  }, /* @__PURE__ */ React__default.createElement("h3", null, /* @__PURE__ */ React__default.createElement(UISref, {
    to: "^.executions"
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "clickable"
  }, app.name)), " - ", /* @__PURE__ */ React__default.createElement(UISref, {
    to: "^.executions",
    params: { pipeline: execution.name }
  }, /* @__PURE__ */ React__default.createElement("a", {
    className: "clickable"
  }, execution.name))), /* @__PURE__ */ React__default.createElement("div", {
    className: "form-group checkbox flex-pull-right"
  }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
    type: "checkbox",
    checked: showDurations || false,
    onChange: showDurationsChanged
  }), /* @__PURE__ */ React__default.createElement("span", null, " stage durations"))))))), execution && ancestry.filter((_ancestor, i) => i < truncateAncestry).map((ancestor, i) => /* @__PURE__ */ React__default.createElement("div", {
    className: "row",
    key: ancestor.id
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1 executions"
  }, /* @__PURE__ */ React__default.createElement(Execution$1, {
    key: ancestor.id,
    execution: ancestor,
    descendantExecutionId: i < ancestry.length - 1 ? ancestry[i + 1].id : execution.id,
    showConfigureButton: true,
    application: app,
    pipelineConfig: null,
    standalone: true,
    showDurations
  })))), execution && !hideMainExecution && /* @__PURE__ */ React__default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "col-md-10 col-md-offset-1 executions"
  }, /* @__PURE__ */ React__default.createElement(Execution$1, {
    execution,
    showConfigureButton: true,
    key: execution.id,
    application: app,
    pipelineConfig: null,
    standalone: true,
    showDurations,
    onRerun: pipelineConfig && (() => {
      rerunExecution(execution, app, pipelineConfig);
    })
  }))), getExecutionStatus === "REJECTED" && /* @__PURE__ */ React__default.createElement("div", {
    className: "row",
    style: { minHeight: "300px" }
  }, /* @__PURE__ */ React__default.createElement("h4", {
    className: "text-center"
  }, /* @__PURE__ */ React__default.createElement("p", null, "The execution cannot be found."), /* @__PURE__ */ React__default.createElement(UISref, {
    to: "^.executions",
    params: { application: app.name }
  }, /* @__PURE__ */ React__default.createElement("a", null, "Back to Executions.")))));
}

function NotFound(props) {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "application"
  }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h2", {
    className: "text-center"
  }, props.type, " Not Found"), /* @__PURE__ */ React__default.createElement("p", {
    className: "text-center",
    style: { marginBottom: "20px" }
  }, "Please check your URL - we can't find any data for ", /* @__PURE__ */ React__default.createElement("em", null, props.entityId), ".")));
}

function ExecutionNotFound() {
  const { params } = ReactInjector.$state;
  return /* @__PURE__ */ React__default.createElement(NotFound, {
    type: "Execution",
    entityId: params.executionId
  });
}

var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
let MigrationTag = class extends React.Component {
  render() {
    return /* @__PURE__ */ React.createElement("span", {
      className: "migration-tag sp-margin-s-left"
    }, "MIGRATED");
  }
};
MigrationTag = __decorateClass$4([
  Overridable("core.executions.migrationTag")
], MigrationTag);

class ExecutionAction extends React__default.Component {
  render() {
    const { children, disabled, handleClick, style, tooltipText } = this.props;
    const linkClassNames = classNames("btn", "btn-xs", "btn-link", disabled && "disabled");
    const actionNode = /* @__PURE__ */ React__default.createElement("h4", {
      style
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: linkClassNames,
      onClick: handleClick,
      "aria-disabled": disabled
    }, children));
    if (tooltipText) {
      return /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: tooltipText
      }, actionNode);
    }
    return actionNode;
  }
}
ExecutionAction.defaultProps = {
  disabled: false,
  handleClick: noop,
  style: {},
  tooltipText: ""
};

const later = function() {
  let later2 = {
    version: "1.2.0"
  };
  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(searchElement) {
      if (this == null) {
        throw new TypeError();
      }
      let t = Object(this);
      let len = t.length >>> 0;
      if (len === 0) {
        return -1;
      }
      let n = 0;
      if (arguments.length > 1) {
        n = Number(arguments[1]);
        if (n != n) {
          n = 0;
        } else if (n != 0 && n != Infinity && n != -Infinity) {
          n = (n > 0 || -1) * Math.floor(Math.abs(n));
        }
      }
      if (n >= len) {
        return -1;
      }
      let k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
      for (; k < len; k++) {
        if (k in t && t[k] === searchElement) {
          return k;
        }
      }
      return -1;
    };
  }
  if (!String.prototype.trim) {
    String.prototype.trim = function() {
      return this.replace(/^\s+|\s+$/g, "");
    };
  }
  later2.array = {};
  later2.array.sort = function(arr, zeroIsLast) {
    arr.sort(function(a, b) {
      return +a - +b;
    });
    if (zeroIsLast && arr[0] === 0) {
      arr.push(arr.shift());
    }
  };
  later2.array.next = function(val, values, extent) {
    let cur, zeroIsLargest = extent[0] !== 0, nextIdx = 0;
    for (let i = values.length - 1; i > -1; --i) {
      cur = values[i];
      if (cur === val) {
        return cur;
      }
      if (cur > val || cur === 0 && zeroIsLargest && extent[1] > val) {
        nextIdx = i;
        continue;
      }
      break;
    }
    return values[nextIdx];
  };
  later2.array.nextInvalid = function(val, values, extent) {
    let min = extent[0], max = extent[1], len = values.length, zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0, next = val, i = values.indexOf(val), start = next;
    while (next === (values[i] || zeroVal)) {
      next++;
      if (next > max) {
        next = min;
      }
      i++;
      if (i === len) {
        i = 0;
      }
      if (next === start) {
        return void 0;
      }
    }
    return next;
  };
  later2.array.prev = function(val, values, extent) {
    let cur, len = values.length, zeroIsLargest = extent[0] !== 0, prevIdx = len - 1;
    for (let i = 0; i < len; i++) {
      cur = values[i];
      if (cur === val) {
        return cur;
      }
      if (cur < val || cur === 0 && zeroIsLargest && extent[1] < val) {
        prevIdx = i;
        continue;
      }
      break;
    }
    return values[prevIdx];
  };
  later2.array.prevInvalid = function(val, values, extent) {
    let min = extent[0], max = extent[1], len = values.length, zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0, next = val, i = values.indexOf(val), start = next;
    while (next === (values[i] || zeroVal)) {
      next--;
      if (next < min) {
        next = max;
      }
      i--;
      if (i === -1) {
        i = len - 1;
      }
      if (next === start) {
        return void 0;
      }
    }
    return next;
  };
  later2.day = later2.D = {
    name: "day",
    range: 86400,
    val: function(d) {
      return d.D || (d.D = later2.date.getDate.call(d));
    },
    isValid: function(d, val) {
      return later2.D.val(d) === (val || later2.D.extent(d)[1]);
    },
    extent: function(d) {
      if (d.DExtent)
        return d.DExtent;
      let month = later2.M.val(d), max = later2.DAYS_IN_MONTH[month - 1];
      if (month === 2 && later2.dy.extent(d)[1] === 366) {
        max = max + 1;
      }
      return d.DExtent = [1, max];
    },
    start: function(d) {
      return d.DStart || (d.DStart = later2.date.next(later2.Y.val(d), later2.M.val(d), later2.D.val(d)));
    },
    end: function(d) {
      return d.DEnd || (d.DEnd = later2.date.prev(later2.Y.val(d), later2.M.val(d), later2.D.val(d)));
    },
    next: function(d, val) {
      val = val > later2.D.extent(d)[1] ? 1 : val;
      let month = later2.date.nextRollover(d, val, later2.D, later2.M), DMax = later2.D.extent(month)[1];
      val = val > DMax ? 1 : val || DMax;
      return later2.date.next(later2.Y.val(month), later2.M.val(month), val);
    },
    prev: function(d, val) {
      let month = later2.date.prevRollover(d, val, later2.D, later2.M), DMax = later2.D.extent(month)[1];
      return later2.date.prev(later2.Y.val(month), later2.M.val(month), val > DMax ? DMax : val || DMax);
    }
  };
  later2.dayOfWeekCount = later2.dc = {
    name: "day of week count",
    range: 604800,
    val: function(d) {
      return d.dc || (d.dc = Math.floor((later2.D.val(d) - 1) / 7) + 1);
    },
    isValid: function(d, val) {
      return later2.dc.val(d) === val || val === 0 && later2.D.val(d) > later2.D.extent(d)[1] - 7;
    },
    extent: function(d) {
      return d.dcExtent || (d.dcExtent = [1, Math.ceil(later2.D.extent(d)[1] / 7)]);
    },
    start: function(d) {
      return d.dcStart || (d.dcStart = later2.date.next(later2.Y.val(d), later2.M.val(d), Math.max(1, (later2.dc.val(d) - 1) * 7 + 1 || 1)));
    },
    end: function(d) {
      return d.dcEnd || (d.dcEnd = later2.date.prev(later2.Y.val(d), later2.M.val(d), Math.min(later2.dc.val(d) * 7, later2.D.extent(d)[1])));
    },
    next: function(d, val) {
      val = val > later2.dc.extent(d)[1] ? 1 : val;
      let month = later2.date.nextRollover(d, val, later2.dc, later2.M), dcMax = later2.dc.extent(month)[1];
      val = val > dcMax ? 1 : val;
      let next = later2.date.next(later2.Y.val(month), later2.M.val(month), val === 0 ? later2.D.extent(month)[1] - 6 : 1 + 7 * (val - 1));
      if (next.getTime() <= d.getTime()) {
        month = later2.M.next(d, later2.M.val(d) + 1);
        return later2.date.next(later2.Y.val(month), later2.M.val(month), val === 0 ? later2.D.extent(month)[1] - 6 : 1 + 7 * (val - 1));
      }
      return next;
    },
    prev: function(d, val) {
      let month = later2.date.prevRollover(d, val, later2.dc, later2.M), dcMax = later2.dc.extent(month)[1];
      val = val > dcMax ? dcMax : val || dcMax;
      return later2.dc.end(later2.date.prev(later2.Y.val(month), later2.M.val(month), 1 + 7 * (val - 1)));
    }
  };
  later2.dayOfWeek = later2.dw = later2.d = {
    name: "day of week",
    range: 86400,
    val: function(d) {
      return d.dw || (d.dw = later2.date.getDay.call(d) + 1);
    },
    isValid: function(d, val) {
      return later2.dw.val(d) === (val || 7);
    },
    extent: function() {
      return [1, 7];
    },
    start: function(d) {
      return later2.D.start(d);
    },
    end: function(d) {
      return later2.D.end(d);
    },
    next: function(d, val) {
      val = val > 7 ? 1 : val || 7;
      return later2.date.next(later2.Y.val(d), later2.M.val(d), later2.D.val(d) + (val - later2.dw.val(d)) + (val <= later2.dw.val(d) ? 7 : 0));
    },
    prev: function(d, val) {
      val = val > 7 ? 7 : val || 7;
      return later2.date.prev(later2.Y.val(d), later2.M.val(d), later2.D.val(d) + (val - later2.dw.val(d)) + (val >= later2.dw.val(d) ? -7 : 0));
    }
  };
  later2.dayOfYear = later2.dy = {
    name: "day of year",
    range: 86400,
    val: function(d) {
      return d.dy || (d.dy = Math.ceil(1 + (later2.D.start(d).getTime() - later2.Y.start(d).getTime()) / later2.DAY));
    },
    isValid: function(d, val) {
      return later2.dy.val(d) === (val || later2.dy.extent(d)[1]);
    },
    extent: function(d) {
      let year = later2.Y.val(d);
      return d.dyExtent || (d.dyExtent = [1, year % 4 ? 365 : 366]);
    },
    start: function(d) {
      return later2.D.start(d);
    },
    end: function(d) {
      return later2.D.end(d);
    },
    next: function(d, val) {
      val = val > later2.dy.extent(d)[1] ? 1 : val;
      let year = later2.date.nextRollover(d, val, later2.dy, later2.Y), dyMax = later2.dy.extent(year)[1];
      val = val > dyMax ? 1 : val || dyMax;
      return later2.date.next(later2.Y.val(year), later2.M.val(year), val);
    },
    prev: function(d, val) {
      let year = later2.date.prevRollover(d, val, later2.dy, later2.Y), dyMax = later2.dy.extent(year)[1];
      val = val > dyMax ? dyMax : val || dyMax;
      return later2.date.prev(later2.Y.val(year), later2.M.val(year), val);
    }
  };
  later2.hour = later2.h = {
    name: "hour",
    range: 3600,
    val: function(d) {
      return d.h || (d.h = later2.date.getHour.call(d));
    },
    isValid: function(d, val) {
      return later2.h.val(d) === val;
    },
    extent: function() {
      return [0, 23];
    },
    start: function(d) {
      return d.hStart || (d.hStart = later2.date.next(later2.Y.val(d), later2.M.val(d), later2.D.val(d), later2.h.val(d)));
    },
    end: function(d) {
      return d.hEnd || (d.hEnd = later2.date.prev(later2.Y.val(d), later2.M.val(d), later2.D.val(d), later2.h.val(d)));
    },
    next: function(d, val) {
      val = val > 23 ? 0 : val;
      let next = later2.date.next(later2.Y.val(d), later2.M.val(d), later2.D.val(d) + (val <= later2.h.val(d) ? 1 : 0), val);
      if (!later2.date.isUTC && next.getTime() <= d.getTime()) {
        next = later2.date.next(later2.Y.val(next), later2.M.val(next), later2.D.val(next), val + 1);
      }
      return next;
    },
    prev: function(d, val) {
      val = val > 23 ? 23 : val;
      return later2.date.prev(later2.Y.val(d), later2.M.val(d), later2.D.val(d) + (val >= later2.h.val(d) ? -1 : 0), val);
    }
  };
  later2.minute = later2.m = {
    name: "minute",
    range: 60,
    val: function(d) {
      return d.m || (d.m = later2.date.getMin.call(d));
    },
    isValid: function(d, val) {
      return later2.m.val(d) === val;
    },
    extent: function(d) {
      return [0, 59];
    },
    start: function(d) {
      return d.mStart || (d.mStart = later2.date.next(later2.Y.val(d), later2.M.val(d), later2.D.val(d), later2.h.val(d), later2.m.val(d)));
    },
    end: function(d) {
      return d.mEnd || (d.mEnd = later2.date.prev(later2.Y.val(d), later2.M.val(d), later2.D.val(d), later2.h.val(d), later2.m.val(d)));
    },
    next: function(d, val) {
      let m = later2.m.val(d), s = later2.s.val(d), inc = val > 59 ? 60 - m : val <= m ? 60 - m + val : val - m, next = new Date(d.getTime() + inc * later2.MIN - s * later2.SEC);
      if (!later2.date.isUTC && next.getTime() <= d.getTime()) {
        next = new Date(d.getTime() + (inc + 120) * later2.MIN - s * later2.SEC);
      }
      return next;
    },
    prev: function(d, val) {
      val = val > 59 ? 59 : val;
      return later2.date.prev(later2.Y.val(d), later2.M.val(d), later2.D.val(d), later2.h.val(d) + (val >= later2.m.val(d) ? -1 : 0), val);
    }
  };
  later2.month = later2.M = {
    name: "month",
    range: 2629740,
    val: function(d) {
      return d.M || (d.M = later2.date.getMonth.call(d) + 1);
    },
    isValid: function(d, val) {
      return later2.M.val(d) === (val || 12);
    },
    extent: function() {
      return [1, 12];
    },
    start: function(d) {
      return d.MStart || (d.MStart = later2.date.next(later2.Y.val(d), later2.M.val(d)));
    },
    end: function(d) {
      return d.MEnd || (d.MEnd = later2.date.prev(later2.Y.val(d), later2.M.val(d)));
    },
    next: function(d, val) {
      val = val > 12 ? 1 : val || 12;
      return later2.date.next(later2.Y.val(d) + (val > later2.M.val(d) ? 0 : 1), val);
    },
    prev: function(d, val) {
      val = val > 12 ? 12 : val || 12;
      return later2.date.prev(later2.Y.val(d) - (val >= later2.M.val(d) ? 1 : 0), val);
    }
  };
  later2.second = later2.s = {
    name: "second",
    range: 1,
    val: function(d) {
      return d.s || (d.s = later2.date.getSec.call(d));
    },
    isValid: function(d, val) {
      return later2.s.val(d) === val;
    },
    extent: function() {
      return [0, 59];
    },
    start: function(d) {
      return d;
    },
    end: function(d) {
      return d;
    },
    next: function(d, val) {
      let s = later2.s.val(d), inc = val > 59 ? 60 - s : val <= s ? 60 - s + val : val - s, next = new Date(d.getTime() + inc * later2.SEC);
      if (!later2.date.isUTC && next.getTime() <= d.getTime()) {
        next = new Date(d.getTime() + (inc + 7200) * later2.SEC);
      }
      return next;
    },
    prev: function(d, val, cache) {
      val = val > 59 ? 59 : val;
      return later2.date.prev(later2.Y.val(d), later2.M.val(d), later2.D.val(d), later2.h.val(d), later2.m.val(d) + (val >= later2.s.val(d) ? -1 : 0), val);
    }
  };
  later2.time = later2.t = {
    name: "time",
    range: 1,
    val: function(d) {
      return d.t || (d.t = later2.h.val(d) * 3600 + later2.m.val(d) * 60 + later2.s.val(d));
    },
    isValid: function(d, val) {
      return later2.t.val(d) === val;
    },
    extent: function() {
      return [0, 86399];
    },
    start: function(d) {
      return d;
    },
    end: function(d) {
      return d;
    },
    next: function(d, val) {
      val = val > 86399 ? 0 : val;
      let next = later2.date.next(later2.Y.val(d), later2.M.val(d), later2.D.val(d) + (val <= later2.t.val(d) ? 1 : 0), 0, 0, val);
      if (!later2.date.isUTC && next.getTime() < d.getTime()) {
        next = later2.date.next(later2.Y.val(next), later2.M.val(next), later2.D.val(next), later2.h.val(next), later2.m.val(next), val + 7200);
      }
      return next;
    },
    prev: function(d, val) {
      val = val > 86399 ? 86399 : val;
      return later2.date.next(later2.Y.val(d), later2.M.val(d), later2.D.val(d) + (val >= later2.t.val(d) ? -1 : 0), 0, 0, val);
    }
  };
  later2.weekOfMonth = later2.wm = {
    name: "week of month",
    range: 604800,
    val: function(d) {
      return d.wm || (d.wm = (later2.D.val(d) + (later2.dw.val(later2.M.start(d)) - 1) + (7 - later2.dw.val(d))) / 7);
    },
    isValid: function(d, val) {
      return later2.wm.val(d) === (val || later2.wm.extent(d)[1]);
    },
    extent: function(d) {
      return d.wmExtent || (d.wmExtent = [
        1,
        (later2.D.extent(d)[1] + (later2.dw.val(later2.M.start(d)) - 1) + (7 - later2.dw.val(later2.M.end(d)))) / 7
      ]);
    },
    start: function(d) {
      return d.wmStart || (d.wmStart = later2.date.next(later2.Y.val(d), later2.M.val(d), Math.max(later2.D.val(d) - later2.dw.val(d) + 1, 1)));
    },
    end: function(d) {
      return d.wmEnd || (d.wmEnd = later2.date.prev(later2.Y.val(d), later2.M.val(d), Math.min(later2.D.val(d) + (7 - later2.dw.val(d)), later2.D.extent(d)[1])));
    },
    next: function(d, val) {
      val = val > later2.wm.extent(d)[1] ? 1 : val;
      let month = later2.date.nextRollover(d, val, later2.wm, later2.M), wmMax = later2.wm.extent(month)[1];
      val = val > wmMax ? 1 : val || wmMax;
      return later2.date.next(later2.Y.val(month), later2.M.val(month), Math.max(1, (val - 1) * 7 - (later2.dw.val(month) - 2)));
    },
    prev: function(d, val) {
      let month = later2.date.prevRollover(d, val, later2.wm, later2.M), wmMax = later2.wm.extent(month)[1];
      val = val > wmMax ? wmMax : val || wmMax;
      return later2.wm.end(later2.date.next(later2.Y.val(month), later2.M.val(month), Math.max(1, (val - 1) * 7 - (later2.dw.val(month) - 2))));
    }
  };
  later2.weekOfYear = later2.wy = {
    name: "week of year (ISO)",
    range: 604800,
    val: function(d) {
      if (d.wy)
        return d.wy;
      let wThur = later2.dw.next(later2.wy.start(d), 5), YThur = later2.dw.next(later2.Y.prev(wThur, later2.Y.val(wThur) - 1), 5);
      return d.wy = 1 + Math.ceil((wThur.getTime() - YThur.getTime()) / later2.WEEK);
    },
    isValid: function(d, val) {
      return later2.wy.val(d) === (val || later2.wy.extent(d)[1]);
    },
    extent: function(d) {
      if (d.wyExtent)
        return d.wyExtent;
      let year = later2.dw.next(later2.wy.start(d), 5), dwFirst = later2.dw.val(later2.Y.start(year)), dwLast = later2.dw.val(later2.Y.end(year));
      return d.wyExtent = [1, dwFirst === 5 || dwLast === 5 ? 53 : 52];
    },
    start: function(d) {
      return d.wyStart || (d.wyStart = later2.date.next(later2.Y.val(d), later2.M.val(d), later2.D.val(d) - (later2.dw.val(d) > 1 ? later2.dw.val(d) - 2 : 6)));
    },
    end: function(d) {
      return d.wyEnd || (d.wyEnd = later2.date.prev(later2.Y.val(d), later2.M.val(d), later2.D.val(d) + (later2.dw.val(d) > 1 ? 8 - later2.dw.val(d) : 0)));
    },
    next: function(d, val) {
      val = val > later2.wy.extent(d)[1] ? 1 : val;
      let wyThur = later2.dw.next(later2.wy.start(d), 5), year = later2.date.nextRollover(wyThur, val, later2.wy, later2.Y);
      if (later2.wy.val(year) !== 1) {
        year = later2.dw.next(year, 2);
      }
      let wyMax = later2.wy.extent(year)[1], wyStart = later2.wy.start(year);
      val = val > wyMax ? 1 : val || wyMax;
      return later2.date.next(later2.Y.val(wyStart), later2.M.val(wyStart), later2.D.val(wyStart) + 7 * (val - 1));
    },
    prev: function(d, val) {
      let wyThur = later2.dw.next(later2.wy.start(d), 5), year = later2.date.prevRollover(wyThur, val, later2.wy, later2.Y);
      if (later2.wy.val(year) !== 1) {
        year = later2.dw.next(year, 2);
      }
      let wyMax = later2.wy.extent(year)[1], wyEnd = later2.wy.end(year);
      val = val > wyMax ? wyMax : val || wyMax;
      return later2.wy.end(later2.date.next(later2.Y.val(wyEnd), later2.M.val(wyEnd), later2.D.val(wyEnd) + 7 * (val - 1)));
    }
  };
  later2.year = later2.Y = {
    name: "year",
    range: 31556900,
    val: function(d) {
      return d.Y || (d.Y = later2.date.getYear.call(d));
    },
    isValid: function(d, val) {
      return later2.Y.val(d) === val;
    },
    extent: function() {
      return [1970, 2099];
    },
    start: function(d) {
      return d.YStart || (d.YStart = later2.date.next(later2.Y.val(d)));
    },
    end: function(d) {
      return d.YEnd || (d.YEnd = later2.date.prev(later2.Y.val(d)));
    },
    next: function(d, val) {
      return val > later2.Y.val(d) && val <= later2.Y.extent()[1] ? later2.date.next(val) : later2.NEVER;
    },
    prev: function(d, val) {
      return val < later2.Y.val(d) && val >= later2.Y.extent()[0] ? later2.date.prev(val) : later2.NEVER;
    }
  };
  later2.fullDate = later2.fd = {
    name: "full date",
    range: 1,
    val: function(d) {
      return d.fd || (d.fd = d.getTime());
    },
    isValid: function(d, val) {
      return later2.fd.val(d) === val;
    },
    extent: function() {
      return [0, 3250368e7];
    },
    start: function(d) {
      return d;
    },
    end: function(d) {
      return d;
    },
    next: function(d, val) {
      return later2.fd.val(d) < val ? new Date(val) : later2.NEVER;
    },
    prev: function(d, val) {
      return later2.fd.val(d) > val ? new Date(val) : later2.NEVER;
    }
  };
  later2.modifier = {};
  later2.modifier.after = later2.modifier.a = function(constraint, values) {
    let value = values[0];
    return {
      name: "after " + constraint.name,
      range: (constraint.extent(new Date())[1] - value) * constraint.range,
      val: constraint.val,
      isValid: function(d, val) {
        return this.val(d) >= value;
      },
      extent: constraint.extent,
      start: constraint.start,
      end: constraint.end,
      next: function(startDate, val) {
        if (val != value)
          val = constraint.extent(startDate)[0];
        return constraint.next(startDate, val);
      },
      prev: function(startDate, val) {
        val = val === value ? constraint.extent(startDate)[1] : value - 1;
        return constraint.prev(startDate, val);
      }
    };
  };
  later2.modifier.before = later2.modifier.b = function(constraint, values) {
    let value = values[values.length - 1];
    return {
      name: "before " + constraint.name,
      range: constraint.range * (value - 1),
      val: constraint.val,
      isValid: function(d, val) {
        return this.val(d) < value;
      },
      extent: constraint.extent,
      start: constraint.start,
      end: constraint.end,
      next: function(startDate, val) {
        val = val === value ? constraint.extent(startDate)[0] : value;
        return constraint.next(startDate, val);
      },
      prev: function(startDate, val) {
        val = val === value ? value - 1 : constraint.extent(startDate)[1];
        return constraint.prev(startDate, val);
      }
    };
  };
  later2.compile = function(schedDef) {
    let constraints = [], constraintsLen = 0, tickConstraint;
    for (let key in schedDef) {
      let nameParts = key.split("_"), name = nameParts[0], mod = nameParts[1], vals = schedDef[key], constraint = mod ? later2.modifier[mod](later2[name], vals) : later2[name];
      constraints.push({
        constraint,
        vals
      });
      constraintsLen++;
    }
    constraints.sort(function(a, b) {
      let ra = a.constraint.range, rb = b.constraint.range;
      return rb < ra ? -1 : rb > ra ? 1 : 0;
    });
    tickConstraint = constraints[constraintsLen - 1].constraint;
    function compareFn(dir) {
      return dir === "next" ? function(a, b) {
        return a.getTime() > b.getTime();
      } : function(a, b) {
        return b.getTime() > a.getTime();
      };
    }
    return {
      start: function(dir, startDate) {
        let next = startDate, nextVal = later2.array[dir], maxAttempts = 1e3, done;
        while (maxAttempts-- && !done && next) {
          done = true;
          for (let i = 0; i < constraintsLen; i++) {
            let constraint = constraints[i].constraint, curVal = constraint.val(next), extent = constraint.extent(next), newVal = nextVal(curVal, constraints[i].vals, extent);
            if (!constraint.isValid(next, newVal)) {
              next = constraint[dir](next, newVal);
              done = false;
              break;
            }
          }
        }
        if (next !== later2.NEVER) {
          next = dir === "next" ? tickConstraint.start(next) : tickConstraint.end(next);
        }
        return next;
      },
      end: function(dir, startDate) {
        let result, nextVal = later2.array[dir + "Invalid"], compare = compareFn(dir);
        for (let i = constraintsLen - 1; i >= 0; i--) {
          let constraint = constraints[i].constraint, curVal = constraint.val(startDate), extent = constraint.extent(startDate), newVal = nextVal(curVal, constraints[i].vals, extent), next;
          if (newVal !== void 0) {
            next = constraint[dir](startDate, newVal);
            if (next && (!result || compare(result, next))) {
              result = next;
            }
          }
        }
        return result;
      },
      tick: function(dir, date) {
        return new Date(dir === "next" ? tickConstraint.end(date).getTime() + later2.SEC : tickConstraint.start(date).getTime() - later2.SEC);
      },
      tickStart: function(date) {
        return tickConstraint.start(date);
      }
    };
  };
  later2.schedule = function(sched) {
    if (!sched)
      throw new Error("Missing schedule definition.");
    if (!sched.schedules)
      throw new Error("Definition must include at least one schedule.");
    let schedules = [], schedulesLen = sched.schedules.length, exceptions = [], exceptionsLen = sched.exceptions ? sched.exceptions.length : 0;
    for (let i = 0; i < schedulesLen; i++) {
      schedules.push(later2.compile(sched.schedules[i]));
    }
    for (let j = 0; j < exceptionsLen; j++) {
      exceptions.push(later2.compile(sched.exceptions[j]));
    }
    function getInstances(dir, count, startDate, endDate, isRange) {
      let compare = compareFn(dir), loopCount = count, maxAttempts = 1e3, schedStarts = [], exceptStarts = [], next, end, results = [], isForward = dir === "next", lastResult, rStart = isForward ? 0 : 1, rEnd = isForward ? 1 : 0;
      startDate = startDate ? new Date(startDate) : new Date();
      if (!startDate || !startDate.getTime())
        throw new Error("Invalid start date.");
      setNextStarts(dir, schedules, schedStarts, startDate);
      setRangeStarts(dir, exceptions, exceptStarts, startDate);
      while (maxAttempts-- && loopCount && (next = findNext(schedStarts, compare))) {
        if (endDate && compare(next, endDate)) {
          break;
        }
        if (exceptionsLen) {
          updateRangeStarts(dir, exceptions, exceptStarts, next);
          if (end = calcRangeOverlap(dir, exceptStarts, next)) {
            updateNextStarts(dir, schedules, schedStarts, end);
            continue;
          }
        }
        if (isRange) {
          let maxEndDate = calcMaxEndDate(exceptStarts, compare);
          end = calcEnd(dir, schedules, schedStarts, next, maxEndDate);
          let r = isForward ? [new Date(Math.max(startDate, next)), end ? new Date(endDate ? Math.min(end, endDate) : end) : void 0] : [
            end ? new Date(endDate ? Math.max(endDate, end.getTime() + later2.SEC) : end.getTime() + later2.SEC) : void 0,
            new Date(Math.min(startDate, next.getTime() + later2.SEC))
          ];
          if (lastResult && r[rStart].getTime() === lastResult[rEnd].getTime()) {
            lastResult[rEnd] = r[rEnd];
            loopCount++;
          } else {
            lastResult = r;
            results.push(lastResult);
          }
          if (!end)
            break;
          updateNextStarts(dir, schedules, schedStarts, end);
        } else {
          results.push(isForward ? new Date(Math.max(startDate, next)) : getStart(schedules, schedStarts, next, endDate));
          tickStarts(dir, schedules, schedStarts, next);
        }
        loopCount--;
      }
      for (let i = 0, len = results.length; i < len; i++) {
        let result = results[i];
        results[i] = Object.prototype.toString.call(result) === "[object Array]" ? [cleanDate(result[0]), cleanDate(result[1])] : cleanDate(result);
      }
      return results.length === 0 ? later2.NEVER : count === 1 ? results[0] : results;
    }
    function cleanDate(d) {
      if (d instanceof Date && !isNaN(d.valueOf())) {
        return new Date(d);
      }
      return void 0;
    }
    function setNextStarts(dir, schedArr, startsArr, startDate) {
      for (let i = 0, len = schedArr.length; i < len; i++) {
        startsArr[i] = schedArr[i].start(dir, startDate);
      }
    }
    function updateNextStarts(dir, schedArr, startsArr, startDate) {
      let compare = compareFn(dir);
      for (let i = 0, len = schedArr.length; i < len; i++) {
        if (startsArr[i] && !compare(startsArr[i], startDate)) {
          startsArr[i] = schedArr[i].start(dir, startDate);
        }
      }
    }
    function setRangeStarts(dir, schedArr, rangesArr, startDate) {
      for (let i = 0, len = schedArr.length; i < len; i++) {
        let nextStart = schedArr[i].start(dir, startDate);
        if (!nextStart) {
          rangesArr[i] = later2.NEVER;
        } else {
          rangesArr[i] = [nextStart, schedArr[i].end(dir, nextStart)];
        }
      }
    }
    function updateRangeStarts(dir, schedArr, rangesArr, startDate) {
      let compare = compareFn(dir);
      for (let i = 0, len = schedArr.length; i < len; i++) {
        if (rangesArr[i] && !compare(rangesArr[i][0], startDate)) {
          let nextStart = schedArr[i].start(dir, startDate);
          if (!nextStart) {
            rangesArr[i] = later2.NEVER;
          } else {
            rangesArr[i] = [nextStart, schedArr[i].end(dir, nextStart)];
          }
        }
      }
    }
    function tickStarts(dir, schedArr, startsArr, startDate) {
      for (let i = 0, len = schedArr.length; i < len; i++) {
        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
          startsArr[i] = schedArr[i].start(dir, schedArr[i].tick(dir, startDate));
        }
      }
    }
    function getStart(schedArr, startsArr, startDate, minEndDate) {
      let result;
      for (let i = 0, len = startsArr.length; i < len; i++) {
        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
          let start = schedArr[i].tickStart(startDate);
          if (minEndDate && start < minEndDate) {
            return minEndDate;
          }
          if (!result || start > result) {
            result = start;
          }
        }
      }
      return result;
    }
    function calcRangeOverlap(dir, rangesArr, startDate) {
      let compare = compareFn(dir), result;
      for (let i = 0, len = rangesArr.length; i < len; i++) {
        let range = rangesArr[i];
        if (range && !compare(range[0], startDate) && (!range[1] || compare(range[1], startDate))) {
          if (!result || compare(range[1], result)) {
            result = range[1];
          }
        }
      }
      return result;
    }
    function calcMaxEndDate(exceptsArr, compare) {
      let result;
      for (let i = 0, len = exceptsArr.length; i < len; i++) {
        if (exceptsArr[i] && (!result || compare(result, exceptsArr[i][0]))) {
          result = exceptsArr[i][0];
        }
      }
      return result;
    }
    function calcEnd(dir, schedArr, startsArr, startDate, maxEndDate) {
      let compare = compareFn(dir), result;
      for (let i = 0, len = schedArr.length; i < len; i++) {
        let start = startsArr[i];
        if (start && start.getTime() === startDate.getTime()) {
          let end = schedArr[i].end(dir, start);
          if (maxEndDate && (!end || compare(end, maxEndDate))) {
            return maxEndDate;
          }
          if (!result || compare(end, result)) {
            result = end;
          }
        }
      }
      return result;
    }
    function compareFn(dir) {
      return dir === "next" ? function(a, b) {
        return !b || a.getTime() > b.getTime();
      } : function(a, b) {
        return !a || b.getTime() > a.getTime();
      };
    }
    function findNext(arr, compare) {
      let next = arr[0];
      for (let i = 1, len = arr.length; i < len; i++) {
        if (arr[i] && compare(next, arr[i])) {
          next = arr[i];
        }
      }
      return next;
    }
    return {
      isValid: function(d) {
        return getInstances("next", 1, d, d) !== later2.NEVER;
      },
      next: function(count, startDate, endDate) {
        return getInstances("next", count || 1, startDate, endDate);
      },
      prev: function(count, startDate, endDate) {
        return getInstances("prev", count || 1, startDate, endDate);
      },
      nextRange: function(count, startDate, endDate) {
        return getInstances("next", count || 1, startDate, endDate, true);
      },
      prevRange: function(count, startDate, endDate) {
        return getInstances("prev", count || 1, startDate, endDate, true);
      }
    };
  };
  later2.setTimeout = function(fn, sched) {
    let s = later2.schedule(sched), t;
    if (fn) {
      scheduleTimeout();
    }
    function scheduleTimeout() {
      let now = Date.now(), next = s.next(2, now);
      if (!next[0]) {
        t = void 0;
        return;
      }
      let diff = next[0].getTime() - now;
      if (diff < 1e3) {
        diff = next[1] ? next[1].getTime() - now : 1e3;
      }
      if (diff < 2147483647) {
        t = setTimeout(fn, diff);
      } else {
        t = setTimeout(scheduleTimeout, 2147483647);
      }
    }
    return {
      isDone: function() {
        return !t;
      },
      clear: function() {
        clearTimeout(t);
      }
    };
  };
  later2.setInterval = function(fn, sched) {
    if (!fn) {
      return;
    }
    let t = later2.setTimeout(scheduleTimeout, sched), done = t.isDone();
    function scheduleTimeout() {
      if (!done) {
        fn();
        t = later2.setTimeout(scheduleTimeout, sched);
      }
    }
    return {
      isDone: function() {
        return t.isDone();
      },
      clear: function() {
        done = true;
        t.clear();
      }
    };
  };
  later2.date = {};
  later2.date.timezone = function(useLocalTime) {
    later2.date.build = useLocalTime ? function(Y, M, D, h, m, s) {
      return new Date(Y, M, D, h, m, s);
    } : function(Y, M, D, h, m, s) {
      return new Date(Date.UTC(Y, M, D, h, m, s));
    };
    let get = useLocalTime ? "get" : "getUTC", d = Date.prototype;
    later2.date.getYear = d[get + "FullYear"];
    later2.date.getMonth = d[get + "Month"];
    later2.date.getDate = d[get + "Date"];
    later2.date.getDay = d[get + "Day"];
    later2.date.getHour = d[get + "Hours"];
    later2.date.getMin = d[get + "Minutes"];
    later2.date.getSec = d[get + "Seconds"];
    later2.date.isUTC = !useLocalTime;
  };
  later2.date.UTC = function() {
    later2.date.timezone(false);
  };
  later2.date.localTime = function() {
    later2.date.timezone(true);
  };
  later2.date.UTC();
  later2.SEC = 1e3;
  later2.MIN = later2.SEC * 60;
  later2.HOUR = later2.MIN * 60;
  later2.DAY = later2.HOUR * 24;
  later2.WEEK = later2.DAY * 7;
  later2.DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  later2.NEVER = 0;
  later2.date.next = function(Y, M, D, h, m, s) {
    return later2.date.build(Y, M !== void 0 ? M - 1 : 0, D !== void 0 ? D : 1, h || 0, m || 0, s || 0);
  };
  later2.date.nextRollover = function(d, val, constraint, period) {
    let cur = constraint.val(d), max = constraint.extent(d)[1];
    return (val || max) <= cur || val > max ? new Date(period.end(d).getTime() + later2.SEC) : period.start(d);
  };
  later2.date.prev = function(Y, M, D, h, m, s) {
    let len = arguments.length;
    M = len < 2 ? 11 : M - 1;
    D = len < 3 ? later2.D.extent(later2.date.next(Y, M + 1))[1] : D;
    h = len < 4 ? 23 : h;
    m = len < 5 ? 59 : m;
    s = len < 6 ? 59 : s;
    return later2.date.build(Y, M, D, h, m, s);
  };
  later2.date.prevRollover = function(d, val, constraint, period) {
    let cur = constraint.val(d);
    return val >= cur || !val ? period.start(period.prev(d, period.val(d) - 1)) : period.start(d);
  };
  later2.parse = {};
  later2.parse.cron = function(expr, hasSeconds) {
    let NAMES = {
      JAN: 1,
      FEB: 2,
      MAR: 3,
      APR: 4,
      MAY: 5,
      JUN: 6,
      JUL: 7,
      AUG: 8,
      SEP: 9,
      OCT: 10,
      NOV: 11,
      DEC: 12,
      SUN: 1,
      MON: 2,
      TUE: 3,
      WED: 4,
      THU: 5,
      FRI: 6,
      SAT: 7
    };
    let REPLACEMENTS = {
      "* * * * * *": "0/1 * * * * *",
      "@YEARLY": "0 0 1 1 *",
      "@ANNUALLY": "0 0 1 1 *",
      "@MONTHLY": "0 0 1 * *",
      "@WEEKLY": "0 0 * * 0",
      "@DAILY": "0 0 * * *",
      "@HOURLY": "0 * * * *"
    };
    let FIELDS = {
      s: [0, 0, 59],
      m: [1, 0, 59],
      h: [2, 0, 23],
      D: [3, 1, 31],
      M: [4, 1, 12],
      Y: [6, 1970, 2099],
      d: [5, 1, 7, 1]
    };
    function getValue(value, offset, max) {
      return isNaN(value) ? NAMES[value] || null : Math.min(+value + (offset || 0), max || 9999);
    }
    function cloneSchedule(sched) {
      let clone = {}, field;
      for (field in sched) {
        if (field !== "dc" && field !== "d") {
          clone[field] = sched[field].slice(0);
        }
      }
      return clone;
    }
    function add(sched, name, min, max, inc) {
      let i = min;
      if (!sched[name]) {
        sched[name] = [];
      }
      while (i <= max) {
        if (sched[name].indexOf(i) < 0) {
          sched[name].push(i);
        }
        i += inc || 1;
      }
      sched[name].sort(function(a, b) {
        return a - b;
      });
    }
    function addHash(schedules, curSched, value, hash) {
      if (curSched.d && !curSched.dc || curSched.dc && curSched.dc.indexOf(hash) < 0) {
        schedules.push(cloneSchedule(curSched));
        curSched = schedules[schedules.length - 1];
      }
      add(curSched, "d", value, value);
      add(curSched, "dc", hash, hash);
    }
    function addWeekday(s, curSched, value) {
      let except1 = {}, except2 = {};
      if (value === 1) {
        add(curSched, "D", 1, 3);
        add(curSched, "d", NAMES.MON, NAMES.FRI);
        add(except1, "D", 2, 2);
        add(except1, "d", NAMES.TUE, NAMES.FRI);
        add(except2, "D", 3, 3);
        add(except2, "d", NAMES.TUE, NAMES.FRI);
      } else {
        add(curSched, "D", value - 1, value + 1);
        add(curSched, "d", NAMES.MON, NAMES.FRI);
        add(except1, "D", value - 1, value - 1);
        add(except1, "d", NAMES.MON, NAMES.THU);
        add(except2, "D", value + 1, value + 1);
        add(except2, "d", NAMES.TUE, NAMES.FRI);
      }
      s.exceptions.push(except1);
      s.exceptions.push(except2);
    }
    function addRange(item, curSched, name, min, max, offset) {
      let incSplit = item.split("/"), inc = +incSplit[1], range = incSplit[0];
      if (range !== "*" && range !== "0") {
        let rangeSplit = range.split("-");
        min = getValue(rangeSplit[0], offset, max);
        max = getValue(rangeSplit[1], offset, max) || max;
      }
      add(curSched, name, min, max, inc);
    }
    function parse(item, s, name, min, max, offset) {
      let value, split, schedules = s.schedules, curSched = schedules[schedules.length - 1];
      if (item === "L") {
        item = min - 1;
      }
      if ((value = getValue(item, offset, max)) !== null) {
        add(curSched, name, value, value);
      } else if ((value = getValue(item.replace("W", ""), offset, max)) !== null) {
        addWeekday(s, curSched, value);
      } else if ((value = getValue(item.replace("L", ""), offset, max)) !== null) {
        addHash(schedules, curSched, value, min - 1);
      } else if ((split = item.split("#")).length === 2) {
        value = getValue(split[0], offset, max);
        addHash(schedules, curSched, value, getValue(split[1]));
      } else {
        addRange(item, curSched, name, min, max, offset);
      }
    }
    function isHash(item) {
      return item.indexOf("#") > -1 || item.indexOf("L") > 0;
    }
    function itemSorter(a, b) {
      return isHash(a) && !isHash(b) ? 1 : a - b;
    }
    function parseExpr(expr2) {
      let schedule = {
        schedules: [{}],
        exceptions: []
      }, components = expr2.replace(/(\s)+/g, " ").split(" "), field, f, component, items;
      for (field in FIELDS) {
        f = FIELDS[field];
        component = components[f[0]];
        if (component && component !== "*" && component !== "?") {
          items = component.split(",").sort(itemSorter);
          let i, length = items.length;
          for (i = 0; i < length; i++) {
            parse(items[i], schedule, field, f[1], f[2], f[3]);
          }
        }
      }
      return schedule;
    }
    function prepareExpr(expr2) {
      let prepared = expr2.toUpperCase();
      return REPLACEMENTS[prepared] || prepared;
    }
    let e = prepareExpr(expr);
    return parseExpr(hasSeconds ? e : "0 " + e);
  };
  later2.parse.recur = function() {
    let schedules = [], exceptions = [], cur, curArr = schedules, curName, values, every, modifier, applyMin, applyMax, i, last;
    function add(name, min, max) {
      name = modifier ? name + "_" + modifier : name;
      if (!cur) {
        curArr.push({});
        cur = curArr[0];
      }
      if (!cur[name]) {
        cur[name] = [];
      }
      curName = cur[name];
      if (every) {
        values = [];
        for (i = min; i <= max; i += every) {
          values.push(i);
        }
        last = {
          n: name,
          x: every,
          c: curName.length,
          m: max
        };
      }
      values = applyMin ? [min] : applyMax ? [max] : values;
      let length = values.length;
      for (i = 0; i < length; i += 1) {
        let val = values[i];
        if (curName.indexOf(val) < 0) {
          curName.push(val);
        }
      }
      values = every = modifier = applyMin = applyMax = 0;
    }
    return {
      schedules,
      exceptions,
      on: function() {
        values = arguments[0] instanceof Array ? arguments[0] : arguments;
        return this;
      },
      every: function(x) {
        every = x || 1;
        return this;
      },
      after: function(x) {
        modifier = "a";
        values = [x];
        return this;
      },
      before: function(x) {
        modifier = "b";
        values = [x];
        return this;
      },
      first: function() {
        applyMin = 1;
        return this;
      },
      last: function() {
        applyMax = 1;
        return this;
      },
      time: function() {
        for (let i2 = 0, len = values.length; i2 < len; i2++) {
          let split = values[i2].split(":");
          if (split.length < 3)
            split.push(0);
          values[i2] = +split[0] * 3600 + +split[1] * 60 + +split[2];
        }
        add("t");
        return this;
      },
      second: function() {
        add("s", 0, 59);
        return this;
      },
      minute: function() {
        add("m", 0, 59);
        return this;
      },
      hour: function() {
        add("h", 0, 23);
        return this;
      },
      dayOfMonth: function() {
        add("D", 1, applyMax ? 0 : 31);
        return this;
      },
      dayOfWeek: function() {
        add("d", 1, 7);
        return this;
      },
      onWeekend: function() {
        values = [1, 7];
        return this.dayOfWeek();
      },
      onWeekday: function() {
        values = [2, 3, 4, 5, 6];
        return this.dayOfWeek();
      },
      dayOfWeekCount: function() {
        add("dc", 1, applyMax ? 0 : 5);
        return this;
      },
      dayOfYear: function() {
        add("dy", 1, applyMax ? 0 : 366);
        return this;
      },
      weekOfMonth: function() {
        add("wm", 1, applyMax ? 0 : 5);
        return this;
      },
      weekOfYear: function() {
        add("wy", 1, applyMax ? 0 : 53);
        return this;
      },
      month: function() {
        add("M", 1, 12);
        return this;
      },
      year: function() {
        add("Y", 1970, 2450);
        return this;
      },
      fullDate: function() {
        for (let i2 = 0, len = values.length; i2 < len; i2++) {
          values[i2] = values[i2].getTime();
        }
        add("fd");
        return this;
      },
      customModifier: function(id, vals) {
        let custom = later2.modifier[id];
        if (!custom)
          throw new Error("Custom modifier " + id + " not recognized!");
        modifier = id;
        values = arguments[1] instanceof Array ? arguments[1] : [arguments[1]];
        return this;
      },
      customPeriod: function(id) {
        let custom = later2[id];
        if (!custom)
          throw new Error("Custom time period " + id + " not recognized!");
        add(id, custom.extent(new Date())[0], custom.extent(new Date())[1]);
        return this;
      },
      startingOn: function(start) {
        return this.between(start, last.m);
      },
      between: function(start, end) {
        cur[last.n] = cur[last.n].splice(0, last.c);
        every = last.x;
        add(last.n, start, end);
        return this;
      },
      and: function() {
        cur = curArr[curArr.push({}) - 1];
        return this;
      },
      except: function() {
        curArr = exceptions;
        cur = null;
        return this;
      }
    };
  };
  later2.parse.text = function(str) {
    let recur = later2.parse.recur, pos = 0, input = "", error;
    let TOKENTYPES = {
      eof: /^$/,
      rank: /^((\d\d\d\d)|([2-5]?1(st)?|[2-5]?2(nd)?|[2-5]?3(rd)?|(0|[1-5]?[4-9]|[1-5]0|1[1-3])(th)?))\b/,
      time: /^((([0]?[1-9]|1[0-2]):[0-5]\d(\s)?(am|pm))|(([0]?\d|1\d|2[0-3]):[0-5]\d))\b/,
      dayName: /^((sun|mon|tue(s)?|wed(nes)?|thu(r(s)?)?|fri|sat(ur)?)(day)?)\b/,
      monthName: /^(jan(uary)?|feb(ruary)?|ma((r(ch)?)?|y)|apr(il)?|ju(ly|ne)|aug(ust)?|oct(ober)?|(sept|nov|dec)(ember)?)\b/,
      yearIndex: /^(\d\d\d\d)\b/,
      every: /^every\b/,
      after: /^after\b/,
      before: /^before\b/,
      second: /^(s|sec(ond)?(s)?)\b/,
      minute: /^(m|min(ute)?(s)?)\b/,
      hour: /^(h|hour(s)?)\b/,
      day: /^(day(s)?( of the month)?)\b/,
      dayInstance: /^day instance\b/,
      dayOfWeek: /^day(s)? of the week\b/,
      dayOfYear: /^day(s)? of the year\b/,
      weekOfYear: /^week(s)?( of the year)?\b/,
      weekOfMonth: /^week(s)? of the month\b/,
      weekday: /^weekday\b/,
      weekend: /^weekend\b/,
      month: /^month(s)?\b/,
      year: /^year(s)?\b/,
      between: /^between (the)?\b/,
      start: /^(start(ing)? (at|on( the)?)?)\b/,
      at: /^(at|@)\b/,
      and: /^(,|and\b)/,
      except: /^(except\b)/,
      also: /(also)\b/,
      first: /^(first)\b/,
      last: /^last\b/,
      in: /^in\b/,
      of: /^of\b/,
      onthe: /^on the\b/,
      on: /^on\b/,
      through: /(-|^(to|through)\b)/
    };
    let NAMES = {
      jan: 1,
      feb: 2,
      mar: 3,
      apr: 4,
      may: 5,
      jun: 6,
      jul: 7,
      aug: 8,
      sep: 9,
      oct: 10,
      nov: 11,
      dec: 12,
      sun: 1,
      mon: 2,
      tue: 3,
      wed: 4,
      thu: 5,
      fri: 6,
      sat: 7,
      "1st": 1,
      fir: 1,
      "2nd": 2,
      sec: 2,
      "3rd": 3,
      thi: 3,
      "4th": 4,
      for: 4
    };
    function t(start, end, text, type) {
      return {
        startPos: start,
        endPos: end,
        text,
        type
      };
    }
    function peek(expected) {
      let scanTokens = expected instanceof Array ? expected : [expected], whiteSpace = /\s+/, token, curInput, m, scanToken, start, len;
      scanTokens.push(whiteSpace);
      start = pos;
      while (!token || token.type === whiteSpace) {
        len = -1;
        curInput = input.substring(start);
        token = t(start, start, input.split(whiteSpace)[0]);
        let i, length = scanTokens.length;
        for (i = 0; i < length; i++) {
          scanToken = scanTokens[i];
          m = scanToken.exec(curInput);
          if (m && m.index === 0 && m[0].length > len) {
            len = m[0].length;
            token = t(start, start + len, curInput.substring(0, len), scanToken);
          }
        }
        if (token.type === whiteSpace) {
          start = token.endPos;
        }
      }
      return token;
    }
    function scan(expectedToken) {
      let token = peek(expectedToken);
      pos = token.endPos;
      return token;
    }
    function parseThroughExpr(tokenType) {
      let start = +parseTokenValue(tokenType), end = checkAndParse(TOKENTYPES.through) ? +parseTokenValue(tokenType) : start, nums = [];
      for (let i = start; i <= end; i++) {
        nums.push(i);
      }
      return nums;
    }
    function parseRanges(tokenType) {
      let nums = parseThroughExpr(tokenType);
      while (checkAndParse(TOKENTYPES.and)) {
        nums = nums.concat(parseThroughExpr(tokenType));
      }
      return nums;
    }
    function parseEvery(r) {
      let num, period, start, end;
      if (checkAndParse(TOKENTYPES.weekend)) {
        r.on(NAMES.sun, NAMES.sat).dayOfWeek();
      } else if (checkAndParse(TOKENTYPES.weekday)) {
        r.on(NAMES.mon, NAMES.tue, NAMES.wed, NAMES.thu, NAMES.fri).dayOfWeek();
      } else {
        num = parseTokenValue(TOKENTYPES.rank);
        r.every(num);
        period = parseTimePeriod(r);
        if (checkAndParse(TOKENTYPES.start)) {
          num = parseTokenValue(TOKENTYPES.rank);
          r.startingOn(num);
          parseToken(period.type);
        } else if (checkAndParse(TOKENTYPES.between)) {
          start = parseTokenValue(TOKENTYPES.rank);
          if (checkAndParse(TOKENTYPES.and)) {
            end = parseTokenValue(TOKENTYPES.rank);
            r.between(start, end);
          }
        }
      }
    }
    function parseOnThe(r) {
      if (checkAndParse(TOKENTYPES.first)) {
        r.first();
      } else if (checkAndParse(TOKENTYPES.last)) {
        r.last();
      } else {
        r.on(parseRanges(TOKENTYPES.rank));
      }
      parseTimePeriod(r);
    }
    function parseScheduleExpr(str2) {
      pos = 0;
      input = str2;
      error = -1;
      let r = recur();
      while (pos < input.length && error < 0) {
        let token = parseToken([
          TOKENTYPES.every,
          TOKENTYPES.after,
          TOKENTYPES.before,
          TOKENTYPES.onthe,
          TOKENTYPES.on,
          TOKENTYPES.of,
          TOKENTYPES["in"],
          TOKENTYPES.at,
          TOKENTYPES.and,
          TOKENTYPES.except,
          TOKENTYPES.also
        ]);
        switch (token.type) {
          case TOKENTYPES.every:
            parseEvery(r);
            break;
          case TOKENTYPES.after:
            if (peek(TOKENTYPES.time).type !== void 0) {
              r.after(parseTokenValue(TOKENTYPES.time));
              r.time();
            } else {
              r.after(parseTokenValue(TOKENTYPES.rank));
              parseTimePeriod(r);
            }
            break;
          case TOKENTYPES.before:
            if (peek(TOKENTYPES.time).type !== void 0) {
              r.before(parseTokenValue(TOKENTYPES.time));
              r.time();
            } else {
              r.before(parseTokenValue(TOKENTYPES.rank));
              parseTimePeriod(r);
            }
            break;
          case TOKENTYPES.onthe:
            parseOnThe(r);
            break;
          case TOKENTYPES.on:
            r.on(parseRanges(TOKENTYPES.dayName)).dayOfWeek();
            break;
          case TOKENTYPES.of:
            r.on(parseRanges(TOKENTYPES.monthName)).month();
            break;
          case TOKENTYPES["in"]:
            r.on(parseRanges(TOKENTYPES.yearIndex)).year();
            break;
          case TOKENTYPES.at:
            r.on(parseTokenValue(TOKENTYPES.time)).time();
            while (checkAndParse(TOKENTYPES.and)) {
              r.on(parseTokenValue(TOKENTYPES.time)).time();
            }
            break;
          case TOKENTYPES.and:
            break;
          case TOKENTYPES.also:
            r.and();
            break;
          case TOKENTYPES.except:
            r.except();
            break;
          default:
            error = pos;
        }
      }
      return {
        schedules: r.schedules,
        exceptions: r.exceptions,
        error
      };
    }
    function parseTimePeriod(r) {
      let timePeriod = parseToken([
        TOKENTYPES.second,
        TOKENTYPES.minute,
        TOKENTYPES.hour,
        TOKENTYPES.dayOfYear,
        TOKENTYPES.dayOfWeek,
        TOKENTYPES.dayInstance,
        TOKENTYPES.day,
        TOKENTYPES.month,
        TOKENTYPES.year,
        TOKENTYPES.weekOfMonth,
        TOKENTYPES.weekOfYear
      ]);
      switch (timePeriod.type) {
        case TOKENTYPES.second:
          r.second();
          break;
        case TOKENTYPES.minute:
          r.minute();
          break;
        case TOKENTYPES.hour:
          r.hour();
          break;
        case TOKENTYPES.dayOfYear:
          r.dayOfYear();
          break;
        case TOKENTYPES.dayOfWeek:
          r.dayOfWeek();
          break;
        case TOKENTYPES.dayInstance:
          r.dayOfWeekCount();
          break;
        case TOKENTYPES.day:
          r.dayOfMonth();
          break;
        case TOKENTYPES.weekOfMonth:
          r.weekOfMonth();
          break;
        case TOKENTYPES.weekOfYear:
          r.weekOfYear();
          break;
        case TOKENTYPES.month:
          r.month();
          break;
        case TOKENTYPES.year:
          r.year();
          break;
        default:
          error = pos;
      }
      return timePeriod;
    }
    function checkAndParse(tokenType) {
      let found = peek(tokenType).type === tokenType;
      if (found) {
        scan(tokenType);
      }
      return found;
    }
    function parseToken(tokenType) {
      let t2 = scan(tokenType);
      if (t2.type) {
        t2.text = convertString(t2.text, tokenType);
      } else {
        error = pos;
      }
      return t2;
    }
    function parseTokenValue(tokenType) {
      return parseToken(tokenType).text;
    }
    function convertString(str2, tokenType) {
      let output = str2;
      switch (tokenType) {
        case TOKENTYPES.time:
          let parts = str2.split(/(:|am|pm)/), hour = parts[3] === "pm" && parts[0] < 12 ? parseInt(parts[0], 10) + 12 : parts[0], min = parts[2].trim();
          output = (hour.length === 1 ? "0" : "") + hour + ":" + min;
          break;
        case TOKENTYPES.rank:
          output = parseInt(/^\d+/.exec(str2)[0], 10);
          break;
        case TOKENTYPES.monthName:
        case TOKENTYPES.dayName:
          output = NAMES[str2.substring(0, 3)];
          break;
      }
      return output;
    }
    return parseScheduleExpr(str.toLowerCase());
  };
  return later2;
}();

class NextRunTag extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleMouseEnter = () => {
      this.setState(this.updateSchedule());
    };
    this.state = this.updateSchedule();
  }
  updateSchedule() {
    if (this.props.pipeline) {
      const crons = (this.props.pipeline.triggers || []).filter((t) => t.type === "cron" && t.enabled && t.cronExpression);
      const nextTimes = [];
      crons.forEach((cron) => {
        const timezoneOffsetInMs = DateTime.local().setZone(SETTINGS.defaultTimeZone).offset * 60 * 1e3;
        const nextRun = later.schedule(later.parse.cron(cron.cronExpression, true)).next(1, new Date(Date.now() + timezoneOffsetInMs));
        if (nextRun) {
          nextTimes.push(nextRun.getTime() - timezoneOffsetInMs);
        }
      });
      if (nextTimes.length) {
        return {
          hasNextScheduled: true,
          nextScheduled: Math.min(...nextTimes)
        };
      }
    }
    return {
      hasNextScheduled: false,
      nextScheduled: 0
    };
  }
  render() {
    const nextDuration = relativeTime(this.state.nextScheduled);
    const visible = !this.props.pipeline.disabled && this.state.hasNextScheduled;
    return /* @__PURE__ */ React__default.createElement("span", {
      style: { visibility: visible ? "visible" : "hidden" },
      className: "next-run-tag"
    }, /* @__PURE__ */ React__default.createElement(Popover, {
      value: `Next run: ${timestamp(this.state.nextScheduled)} (${nextDuration})`,
      placement: "left"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-time",
      onMouseEnter: this.handleMouseEnter
    })));
  }
}

class QuietPeriodService {
  static async quietPeriodConfig() {
    var _a;
    this._quietPeriodConfig = (_a = this._quietPeriodConfig) != null ? _a : REST("/capabilities/quietPeriod").get();
    return await this._quietPeriodConfig;
  }
}
function useQuietPeriod() {
  const result = useLatestPromise(() => QuietPeriodService.quietPeriodConfig(), []);
  if (result.status !== "RESOLVED") {
    return { currentStatus: "UNKNOWN", startTime: void 0, endTime: void 0 };
  }
  const { startTime, endTime, enabled } = result.result;
  if (!enabled || !startTime || startTime < 0 || !endTime || endTime < 0) {
    return { currentStatus: "NO_QUIET_PERIOD", startTime: void 0, endTime: void 0 };
  }
  const now = Date.now();
  const currentStatus = now < startTime ? "BEFORE_QUIET_PERIOD" : now > endTime ? "AFTER_QUIET_PERIOD" : "DURING_QUIET_PERIOD";
  return { currentStatus, startTime, endTime };
}

const locale = "en-US";
const dateOptions = {
  weekday: "short",
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit"
};
function QuietPeriodBadge() {
  const quietPeriod = useQuietPeriod();
  if (quietPeriod.currentStatus === "NO_QUIET_PERIOD" || quietPeriod.currentStatus === "UNKNOWN") {
    return null;
  }
  const start = new Date(quietPeriod.startTime);
  const end = new Date(quietPeriod.endTime);
  const message = quietPeriod.currentStatus === "DURING_QUIET_PERIOD" ? "This pipeline will not be automatically triggered until the end of the quiet period. " : "This pipeline will not be automatically triggered during the quiet period. ";
  const template = /* @__PURE__ */ React__default.createElement("span", null, message, /* @__PURE__ */ React__default.createElement("span", null, `(${start.toLocaleString(locale, dateOptions)} - ${end.toLocaleString(locale, dateOptions)})`));
  return /* @__PURE__ */ React__default.createElement(Tooltip, {
    template
  }, /* @__PURE__ */ React__default.createElement("i", {
    className: "fa icon-calendar-warning",
    style: { color: "red" }
  }));
}

function getTriggerLabel(totalTriggers, activeTriggers) {
  if (totalTriggers === 1) {
    return `Trigger: ${activeTriggers ? "enabled" : "disabled"}`;
  } else if (totalTriggers === activeTriggers) {
    return `All triggers: enabled`;
  } else if (activeTriggers === 0) {
    return `All triggers: disabled`;
  } else {
    return `Some triggers: enabled`;
  }
}
function TriggersTag(props) {
  var _a;
  const quietPeriod = useQuietPeriod();
  const { pipeline } = props;
  const triggers = (_a = pipeline == null ? void 0 : pipeline.triggers) != null ? _a : [];
  const isTriggerDisabled = (t) => !t.enabled || pipeline.respectQuietPeriod && quietPeriod.currentStatus === "DURING_QUIET_PERIOD" && t.type !== "pipeline";
  const activeTriggers = triggers.filter((t) => !isTriggerDisabled(t));
  if (triggers.length === 0) {
    return /* @__PURE__ */ React.createElement("div", null);
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: `triggers-toggle ${activeTriggers.length > 0 ? "" : "disabled"}`,
    style: { visibility: pipeline.disabled ? "hidden" : "visible" }
  }, /* @__PURE__ */ React.createElement("span", {
    className: "flex-container-h margin-between-sm baseline"
  }, pipeline.respectQuietPeriod && /* @__PURE__ */ React.createElement(QuietPeriodBadge, null), /* @__PURE__ */ React.createElement("span", null, getTriggerLabel(triggers.length, activeTriggers.length))));
}

var css_248z$q = ".execution-group-container {\n  padding: 10px 30px 0;\n}\n.execution-group-header:before,\n.execution-group-header:after {\n  display: table;\n  content: \" \";\n}\n.execution-group-header:after {\n  clear: both;\n}\n.execution-name .account-tag {\n  height: 20px;\n  line-height: 20px;\n  min-width: 50px;\n  font-size: 14px;\n  padding: 0 12px;\n  margin-right: 5px;\n}\n.execution-group-heading {\n  display: flex;\n  padding: 0;\n  color: var(--color-primary);\n  height: 37px;\n}\n.execution-group-heading .pipeline-toggle {\n  background-color: var(--color-alabaster);\n  display: inline-block;\n  padding: 10px 10px 10px 0;\n  height: 36px;\n  flex: 0 0 auto;\n}\n.execution-group-heading .inline-spinner .load {\n  margin: 2px 2px 0 0;\n}\n.execution-group-heading a {\n  font-weight: 600;\n}\n.execution-group-heading h4 {\n  font-weight: 600;\n  font-size: 16px;\n  display: inline-block;\n  flex: 1 1 auto;\n  padding: 0 10px;\n  margin: 0;\n  cursor: pointer;\n}\n.execution-group-heading h4 .disabled {\n  color: var(--color-concrete);\n}\n.execution-group-heading h4 .badge {\n  margin-left: 5px;\n}\n.execution-group-heading h4 .glyphicon {\n  font-size: 13px;\n}\n.execution-group-heading h4 .glyphicon.glyphicon-certificate,\n.execution-group-heading h4 .glyphicon.glyphicon-play {\n  margin-left: 5px;\n  padding: 2px 0 0 0;\n  font-size: 80%;\n}\n@media (max-width: 1400px) {\n  .execution-group-heading h4 {\n    font-size: 14px;\n  }\n}\n.execution-group-heading .badge {\n  background-color: var(--color-primary);\n  color: var(--color-alabaster);\n  border-radius: 3px;\n}\n.execution-group-heading.inactive {\n  color: var(--color-accessory-light);\n}\n.execution-group-heading.inactive .shadowed,\n.execution-group-heading.inactive .execution-group-actions {\n  background-color: var(--color-accent-g3);\n}\n.execution-group-heading.inactive .label-retired {\n  background-color: transparent;\n  color: var(--color-cirrus);\n  padding: 3px 10px;\n  font-size: 12px;\n}\n.triggers-toggle,\n.next-run-tag {\n  display: inline-block;\n  font-weight: 400;\n  font-size: 85%;\n  position: relative;\n  color: var(--color-success);\n}\n.triggers-toggle.disabled,\n.next-run-tag.disabled {\n  color: var(--color-dovegray);\n}\n.next-run-tag {\n  margin: 0 0 0 5px;\n  vertical-align: middle;\n}\n.migration-tag {\n  background-color: var(--color-warning);\n  border-radius: 8px;\n  color: var(--color-white);\n  font-size: 10px;\n  padding: 2px 8px;\n}\n.execution-group-actions {\n  background-color: var(--color-accent-g2);\n  flex: 0 0 auto;\n}\n.execution-group-actions h4 {\n  margin-left: 20px;\n}\n@media (min-width: 1200px) {\n  .execution-group-actions h4 {\n    margin-left: 40px;\n  }\n}\n.execution-group-actions.in-migration {\n  background-color: var(--color-status-warning-light);\n}\n.execution-group {\n  display: block;\n  margin-bottom: 5px;\n}\n.account-tag-wrapper {\n  max-width: 250px;\n}\n.account-tag-wrapper .account-tag-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n";
styleInject(css_248z$q);

var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
var _a;
const ACCOUNT_TAG_OVERFLOW_LIMIT = (_a = SETTINGS.accountTagLimit) != null ? _a : 1;
let ExecutionGroup = class extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.destroy$ = new Subject();
    this.headerRef = React__default.createRef();
    this.toggle = () => {
      const open = !this.state.open;
      if (this.isShowingDetails()) {
        this.hideDetails();
      }
      CollapsibleSectionStateCache.setExpanded(this.getSectionCacheKey(), open);
      this.setState({ open });
    };
    this.handleHeadingClicked = () => {
      logger.log({
        category: "Pipeline",
        action: `Group ${this.state.open ? "collapsed" : "expanded"}`,
        data: { label: this.props.group.heading }
      });
      this.toggle();
    };
    this.handleConfigureClicked = (e) => {
      logger.log({
        category: "Pipeline",
        action: "Configure pipeline button clicked",
        data: { label: this.props.group.heading }
      });
      this.configure(this.props.group.config.id);
      e.stopPropagation();
    };
    this.handleTriggerClicked = (e) => {
      logger.log({
        category: "Pipeline",
        action: "Trigger pipeline button clicked",
        data: { label: this.props.group.heading }
      });
      this.triggerPipeline();
      e.stopPropagation();
    };
    this.rerunExecutionClicked = (execution, config) => {
      logger.log({ category: "Pipeline", action: "Rerun pipeline button clicked", data: { label: config.name } });
      this.triggerPipeline(execution.trigger, config);
    };
    this.onEnter = (element) => {
      var _a2, _b;
      const { height } = element.lastElementChild.getBoundingClientRect();
      const headerOffset = ((_b = (_a2 = this.headerRef.current) == null ? void 0 : _a2.getBoundingClientRect()) == null ? void 0 : _b.top) + window.scrollY;
      this.setState({ placement: headerOffset - height > 0 ? "top" : "right" });
    };
    const { group, application } = props;
    const strategyConfig = application.strategyConfigs.data.find((c) => c.name === group.heading);
    const pipelineConfig = application.pipelineConfigs.data.find((c) => c.name === group.heading);
    const sectionCacheKey = this.getSectionCacheKey();
    const showingDetails = this.isShowingDetails();
    this.state = {
      deploymentAccounts: this.getDeploymentAccounts(),
      triggeringExecution: false,
      showingDetails,
      open: showingDetails || !CollapsibleSectionStateCache.isSet(sectionCacheKey) || CollapsibleSectionStateCache.isExpanded(sectionCacheKey),
      poll: null,
      displayExecutionActions: !!(pipelineConfig || strategyConfig),
      showAccounts: ExecutionState.filterModel.asFilterModel.sortFilter.groupBy === "name",
      pipelineConfig,
      showOverflowAccountTags: false,
      placement: "top"
    };
  }
  isShowingDetails() {
    const { $state, $stateParams } = ReactInjector;
    return this.props.group.executions.some((execution) => execution.id === $stateParams.executionId && $state.includes("**.execution.**"));
  }
  configure(id) {
    const { $state } = ReactInjector;
    if (!$state.current.name.includes(".executions.execution")) {
      $state.go("^.pipelineConfig", { pipelineId: id });
    } else {
      $state.go("^.^.pipelineConfig", { pipelineId: id });
    }
  }
  hideDetails() {
    ReactInjector.$state.go(".^");
  }
  getSectionCacheKey() {
    const { executionService } = ReactInjector;
    return executionService.getSectionCacheKey(ExecutionState.filterModel.asFilterModel.sortFilter.groupBy, this.props.application.name, this.props.group.heading);
  }
  startPipeline(command) {
    const { executionService } = ReactInjector;
    this.setState({ triggeringExecution: true });
    return executionService.startAndMonitorPipeline(this.props.application, command.pipelineName, command.trigger).then((monitor) => {
      this.setState({ poll: monitor });
      return monitor.promise;
    }).finally(() => {
      this.setState({ triggeringExecution: false });
    });
  }
  triggerPipeline(trigger = null, config = this.state.pipelineConfig) {
    from(new Promise((resolve) => {
      if (PipelineTemplateV2Service.isV2PipelineConfig(config)) {
        PipelineTemplateReader.getPipelinePlan(config).then((plan) => resolve(plan)).catch(() => resolve(config));
      } else {
        resolve(config);
      }
    })).pipe(takeUntil(this.destroy$)).subscribe((pipeline) => ManualExecutionModal.show({
      pipeline,
      application: this.props.application,
      trigger,
      currentlyRunningExecutions: this.props.group.runningExecutions
    }).then((command) => this.startPipeline(command)).catch(() => {
    }));
  }
  componentDidMount() {
    const { stateEvents } = ReactInjector;
    this.expandUpdatedSubscription = ExecutionState.filterModel.expandSubject.subscribe((expanded) => {
      if (this.state.open !== expanded) {
        this.toggle();
      }
    });
    this.stateChangeSuccessSubscription = stateEvents.stateChangeSuccess.subscribe(() => {
      const showingDetails = this.isShowingDetails();
      if (this.isShowingDetails() && !this.state.open) {
        this.toggle();
      }
      if (showingDetails !== this.state.showingDetails) {
        this.setState({ showingDetails });
      }
    });
  }
  componentWillUnmount() {
    if (this.state.poll) {
      this.state.poll.cancel();
    }
    if (this.expandUpdatedSubscription) {
      this.expandUpdatedSubscription.unsubscribe();
    }
    if (this.stateChangeSuccessSubscription) {
      this.stateChangeSuccessSubscription.unsubscribe();
    }
    this.destroy$.next();
  }
  getDeploymentAccounts() {
    return uniq(flatten(this.props.group.executions.map((e) => e.deploymentTargets))).sort().filter((a) => !!a);
  }
  renderExecutions() {
    const { pipelineConfig } = this.state;
    const { executions } = this.props.group;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, executions.map((execution) => /* @__PURE__ */ React__default.createElement(Execution$1, {
      key: execution.id,
      execution,
      pipelineConfig,
      application: this.props.application,
      onRerun: pipelineConfig ? this.rerunExecutionClicked : void 0
    })));
  }
  render() {
    const { group } = this.props;
    const { displayExecutionActions, pipelineConfig, triggeringExecution, showingDetails, placement } = this.state;
    const pipelineDisabled = pipelineConfig && pipelineConfig.disabled;
    const pipelineJustMigrated = (pipelineConfig == null ? void 0 : pipelineConfig.migrationStatus) === "Started";
    const pipelineDescription = pipelineConfig && pipelineConfig.description;
    const hasRunningExecutions = group.runningExecutions && group.runningExecutions.length > 0;
    const deploymentAccountLabels = without(this.state.deploymentAccounts || [], ...group.targetAccounts || []).map((account) => /* @__PURE__ */ React__default.createElement(AccountTag, {
      key: account,
      account
    }));
    const groupTargetAccountLabels = [];
    let groupTargetAccountLabelsExtra = [];
    if (group.targetAccounts && group.targetAccounts.length > 0) {
      group.targetAccounts.slice(0, ACCOUNT_TAG_OVERFLOW_LIMIT).map((account) => {
        groupTargetAccountLabels.push(/* @__PURE__ */ React__default.createElement(AccountTag, {
          key: account,
          account,
          className: "account-tag-wrapper"
        }));
      });
    }
    if (group.targetAccounts && group.targetAccounts.length > ACCOUNT_TAG_OVERFLOW_LIMIT) {
      groupTargetAccountLabels.push(/* @__PURE__ */ React__default.createElement("span", {
        key: "account-overflow",
        onMouseEnter: () => this.setState({ showOverflowAccountTags: true }),
        onMouseLeave: () => this.setState({ showOverflowAccountTags: false })
      }, /* @__PURE__ */ React__default.createElement(AccountTag, {
        className: "overflow-marker",
        account: `(+ ${group.targetAccounts.length - ACCOUNT_TAG_OVERFLOW_LIMIT} more)`
      })));
      groupTargetAccountLabelsExtra = groupTargetAccountLabelsExtra.concat(group.targetAccounts.slice(ACCOUNT_TAG_OVERFLOW_LIMIT).map((account) => {
        return /* @__PURE__ */ React__default.createElement(AccountTag, {
          key: account,
          account
        });
      }));
    }
    const shadowedClassName = classNames({ shadowed: true, "in-migration": pipelineJustMigrated });
    const groupActionsClassName = classNames({
      "text-right": true,
      "execution-group-actions": true,
      "in-migration": pipelineJustMigrated
    });
    return /* @__PURE__ */ React__default.createElement("div", {
      className: `execution-group ${showingDetails ? "showing-details" : "details-hidden"}`
    }, group.heading && /* @__PURE__ */ React__default.createElement("div", {
      className: "clickable sticky-header",
      onClick: this.handleHeadingClicked
    }, /* @__PURE__ */ React__default.createElement("div", {
      ref: this.headerRef,
      className: `execution-group-heading ${pipelineDisabled ? "inactive" : "active"}`
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: `glyphicon pipeline-toggle glyphicon-chevron-${this.state.open ? "down" : "right"}`
    }), /* @__PURE__ */ React__default.createElement("div", {
      className: shadowedClassName,
      style: { position: "relative" }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: `heading-tag-overflow-group ${this.state.showOverflowAccountTags ? "shown" : ""}`
    }, groupTargetAccountLabelsExtra), /* @__PURE__ */ React__default.createElement("div", {
      className: "heading-tag collapsing-heading-tags"
    }, this.state.showAccounts && deploymentAccountLabels, groupTargetAccountLabels), /* @__PURE__ */ React__default.createElement("h4", {
      className: "execution-group-title"
    }, group.fromTemplate && /* @__PURE__ */ React__default.createElement("i", {
      className: "from-template fa fa-table",
      title: "Pipeline from template"
    }), group.heading, pipelineDescription && /* @__PURE__ */ React__default.createElement("span", null, " ", /* @__PURE__ */ React__default.createElement(Popover, {
      onEnter: this.onEnter,
      value: pipelineDescription,
      placement
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-info-sign"
    }))), pipelineDisabled && /* @__PURE__ */ React__default.createElement("span", null, " (disabled)"), hasRunningExecutions && /* @__PURE__ */ React__default.createElement("span", null, " ", /* @__PURE__ */ React__default.createElement("span", {
      className: "badge"
    }, group.runningExecutions.length)), pipelineJustMigrated && /* @__PURE__ */ React__default.createElement(MigrationTag, null)), pipelineConfig && /* @__PURE__ */ React__default.createElement(EntityNotifications, {
      entity: pipelineConfig,
      application: this.props.application,
      "entity-type": "pipeline",
      hOffsetPercent: "20%",
      placement: "top",
      onUpdate: () => this.props.application.refresh()
    }), displayExecutionActions && /* @__PURE__ */ React__default.createElement("div", {
      className: groupActionsClassName
    }, pipelineConfig && /* @__PURE__ */ React__default.createElement(TriggersTag, {
      pipeline: pipelineConfig
    }), pipelineConfig && /* @__PURE__ */ React__default.createElement(NextRunTag, {
      pipeline: pipelineConfig
    }), /* @__PURE__ */ React__default.createElement(ExecutionAction, {
      handleClick: this.handleConfigureClicked
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-cog"
    }), " Configure"), pipelineConfig && /* @__PURE__ */ React__default.createElement(ExecutionAction, {
      handleClick: this.handleTriggerClicked,
      style: { visibility: pipelineDisabled ? "hidden" : "visible" }
    }, triggeringExecution ? /* @__PURE__ */ React__default.createElement("div", {
      className: "horizontal middle inline-spinner"
    }, /* @__PURE__ */ React__default.createElement(Spinner, {
      size: "nano"
    }), /* @__PURE__ */ React__default.createElement("span", null, " Starting Manual Execution")) : /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-play"
    }), " Start Manual Execution")))))), this.state.open && /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-groups"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-group-container"
    }, !group.executions.length && /* @__PURE__ */ React__default.createElement("div", {
      style: { paddingBottom: "10px" }
    }, /* @__PURE__ */ React__default.createElement("em", null, "No executions found matching the selected filters.")), /* @__PURE__ */ React__default.createElement(RenderWhenVisible, {
      container: this.props.parent,
      disableHide: showingDetails,
      initiallyVisible: showingDetails,
      placeholderHeight: group.executions.length * 110,
      bufferHeight: 1e3,
      render: () => this.renderExecutions()
    }))));
  }
};
ExecutionGroup = __decorateClass$3([
  Overridable("PipelineExecutionGroup")
], ExecutionGroup);

var css_248z$p = ".execution-groups-section {\n  display: flex;\n  flex: 1 1 auto;\n  overflow-x: visible;\n}\n";
styleInject(css_248z$p);

class ExecutionGroups extends React__default.Component {
  constructor(props) {
    super(props);
    this.setContainer = (container) => {
      if (this.state.container !== container) {
        this.setState({ container });
      }
    };
    const { stateEvents } = ReactInjector;
    this.state = {
      groups: ExecutionState.filterModel.asFilterModel.groups,
      showingDetails: ReactInjector.$state.includes("**.execution")
    };
    this.applicationRefreshUnsubscribe = props.application.executions.onRefresh(null, () => {
      ExecutionFilterService.updateExecutionGroups(props.application);
    });
    this.groupsUpdatedSubscription = ExecutionFilterService.groupsUpdatedStream.subscribe(() => {
      const newGroups = ExecutionState.filterModel.asFilterModel.groups;
      const { groups } = this.state;
      if (newGroups.length !== groups.length || newGroups.some((g, i) => groups[i] !== g)) {
        this.setState({ groups: newGroups });
      }
    });
    this.stateChangeSuccessSubscription = stateEvents.stateChangeSuccess.subscribe(() => {
      const detailsShown = this.showingDetails();
      if (detailsShown !== this.state.showingDetails) {
        this.setState({ showingDetails: detailsShown });
      }
    });
  }
  showingDetails() {
    const { executionId } = ReactInjector.$stateParams;
    if (!executionId || this.state.groups.every((g) => g.executions.every((e) => e.id !== executionId))) {
      return false;
    }
    return ReactInjector.$state.includes("**.execution");
  }
  componentWillUnmount() {
    if (this.applicationRefreshUnsubscribe) {
      this.applicationRefreshUnsubscribe();
      this.applicationRefreshUnsubscribe = void 0;
    }
    if (this.groupsUpdatedSubscription) {
      this.groupsUpdatedSubscription.unsubscribe();
    }
    if (this.stateChangeSuccessSubscription) {
      this.stateChangeSuccessSubscription.unsubscribe();
    }
  }
  render() {
    const { groups = [], container, showingDetails } = this.state;
    const hasGroups = groups.length > 0;
    const className = `row pipelines executions ${showingDetails ? "showing-details" : ""}`;
    const allGroups = (groups || []).filter((g) => {
      var _a;
      return ((_a = g == null ? void 0 : g.config) == null ? void 0 : _a.migrationStatus) === "Started";
    }).concat(groups.filter((g) => {
      var _a;
      return ((_a = g == null ? void 0 : g.config) == null ? void 0 : _a.migrationStatus) !== "Started";
    }));
    const executionGroups = allGroups.map((group) => /* @__PURE__ */ React__default.createElement(ExecutionGroup, {
      parent: container,
      key: group.heading,
      group,
      application: this.props.application
    }));
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-groups-section"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className
    }, !hasGroups && /* @__PURE__ */ React__default.createElement("div", {
      className: "text-center"
    }, /* @__PURE__ */ React__default.createElement("h4", null, "No executions match the filters you've selected.")), /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-groups all-execution-groups",
      ref: this.setContainer
    }, /* @__PURE__ */ React__default.createElement(BannerContainer, {
      app: this.props.application
    }), container && executionGroups)));
  }
}

var css_248z$o = "execution-filters,\n.execution-filters {\n  display: flex;\n  height: 100%;\n}\nexecution-filters ::-webkit-scrollbar,\n.execution-filters ::-webkit-scrollbar {\n  background: transparent;\n  width: 0;\n}\n@media (min-width: 768px) and (max-width: 992px) {\n  execution-filters,\n  .execution-filters {\n    width: 104px;\n  }\n}\n@media (min-width: 992px) {\n  execution-filters,\n  .execution-filters {\n    width: 124px;\n  }\n}\n@media (min-width: 1200px) {\n  execution-filters,\n  .execution-filters {\n    width: 154px;\n  }\n}\n@media (min-width: 1400px) {\n  execution-filters,\n  .execution-filters {\n    width: 184px;\n  }\n}\n@media (min-width: 1600px) {\n  execution-filters,\n  .execution-filters {\n    width: 214px;\n  }\n}\n@media (min-width: 1800px) {\n  execution-filters,\n  .execution-filters {\n    width: 224px;\n  }\n}\n@media (min-width: 2000px) {\n  execution-filters,\n  .execution-filters {\n    width: 254px;\n  }\n}\nexecution-filters .sortable .pipeline-drag-handle,\n.execution-filters .sortable .pipeline-drag-handle {\n  display: inline-block;\n  margin-left: -14px;\n  margin-right: 3px;\n  opacity: 0.7;\n  font-size: 80%;\n}\nexecution-filters .sortable.disable-user-select,\n.execution-filters .sortable.disable-user-select {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n";
styleInject(css_248z$o);

var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
const DragHandle = SortableHandle(() => /* @__PURE__ */ React__default.createElement("span", {
  className: "pipeline-drag-handle clickable glyphicon glyphicon-resize-vertical"
}));
class ExecutionFilters extends React__default.Component {
  constructor(props) {
    super(props);
    this.enablePipelineReorder = () => {
      this.setState({ pipelineReorderEnabled: true });
      logger.log({ category: "Pipelines", action: "Filter: reorder" });
    };
    this.disablePipelineReorder = () => {
      this.setState({ pipelineReorderEnabled: false });
      logger.log({ category: "Pipelines", action: "Filter: stop reorder" });
    };
    this.refreshExecutions = () => {
      ExecutionState.filterModel.asFilterModel.applyParamsToUrl();
      this.props.setReloadingForFilters(true);
      const dataSource = this.props.application.getDataSource("executions");
      dataSource.refresh(true).then(() => {
        ExecutionFilterService.updateExecutionGroups(this.props.application);
        this.props.setReloadingForFilters(false);
      });
    };
    this.searchFieldUpdated = (event) => {
      this.setState({ searchString: event.currentTarget.value }, () => this.refreshPipelines());
      this.updateFilterSearch(event.currentTarget.value);
    };
    this.handleSortEnd = (sortEnd) => {
      const pipelineNames = arrayMove(this.state.pipelineNames, sortEnd.oldIndex, sortEnd.newIndex);
      this.applyNewPipelineSortOrder(pipelineNames);
    };
    this.sortAlphabetically = () => {
      const pipelineNames = this.state.pipelineNames.slice().sort();
      this.applyNewPipelineSortOrder(pipelineNames);
    };
    this.applyNewPipelineSortOrder = (pipelineNames) => {
      const { application } = this.props;
      logger.log({ category: "Pipelines", action: "Reordered pipeline" });
      const idsToUpdatedIndices = {};
      application.pipelineConfigs.data.forEach((pipeline) => {
        const newIndex = pipelineNames.indexOf(pipeline.name);
        if (pipeline.index !== newIndex) {
          pipeline.index = newIndex;
          idsToUpdatedIndices[pipeline.id] = newIndex;
        }
      });
      if (!isEmpty(idsToUpdatedIndices)) {
        this.updatePipelines(idsToUpdatedIndices);
        this.refreshPipelines();
      }
    };
    const searchString = ExecutionState.filterModel.asFilterModel.sortFilter.filter;
    this.state = {
      pipelineNames: this.getPipelineNames(false).filter((pipelineName) => searchString ? pipelineName.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()) : true),
      strategyNames: this.getPipelineNames(true),
      pipelineTags: this.getPipelineTags(),
      pipelineReorderEnabled: false,
      searchString,
      tags: ExecutionState.filterModel.asFilterModel.tags
    };
  }
  componentDidMount() {
    const { application } = this.props;
    this.executionsRefreshUnsubscribe = application.executions.onRefresh(null, () => {
      ExecutionFilterService.updateExecutionGroups(this.props.application);
    });
    this.groupsUpdatedSubscription = ExecutionFilterService.groupsUpdatedStream.subscribe(() => this.setState({ tags: ExecutionState.filterModel.asFilterModel.tags }));
    this.pipelineConfigsRefreshUnsubscribe = application.pipelineConfigs.onRefresh(null, () => {
      this.refreshPipelines();
    });
    this.initialize();
    this.locationChangeUnsubscribe = ReactInjector.$uiRouter.transitionService.onSuccess({}, () => {
      ExecutionState.filterModel.asFilterModel.activate();
      ExecutionFilterService.updateExecutionGroups(application);
    });
  }
  updateExecutionGroups() {
    ExecutionState.filterModel.asFilterModel.applyParamsToUrl();
    ExecutionFilterService.updateExecutionGroups(this.props.application);
  }
  getPipelineTags() {
    const pipelineConfigs = this.props.application.pipelineConfigs.loadFailure ? [] : get(this.props.application, "pipelineConfigs.data", []);
    const extractedPipelineTags = flatten(pipelineConfigs.filter((pipeline) => pipeline.tags).map((pipeline) => pipeline.tags));
    return extractedPipelineTags.reduce((pipelineTags, { name, value }) => {
      if (!pipelineTags.names.includes(name)) {
        pipelineTags.names.push(name);
      }
      pipelineTags.values[name] = pipelineTags.values[name] || [];
      if (!pipelineTags.values[name].includes(value)) {
        pipelineTags.values[name].push(value);
      }
      return pipelineTags;
    }, {
      names: [],
      values: {}
    });
  }
  getPipelineNames(strategy) {
    const { application } = this.props;
    if (application.pipelineConfigs.loadFailure) {
      return [];
    }
    const source = strategy ? "strategyConfigs" : "pipelineConfigs";
    const otherSource = strategy ? "pipelineConfigs" : "strategyConfigs";
    const configs = get(application, `${source}.data`, []);
    const otherConfigs = get(application, `${otherSource}.data`, []);
    const allConfigIds = configs.concat(otherConfigs).map((c) => c.id);
    const unmatchedExecutions = strategy ? [] : application.executions.data.filter((e) => !allConfigIds.includes(e.pipelineConfigId));
    const allOptions = orderBy(configs, ["strategy", "index"], ["desc", "asc"]).concat(unmatchedExecutions).filter((option) => option && option.name).map((option) => option.name);
    return uniq(allOptions);
  }
  refreshPipelines() {
    const { pipelineNames, strategyNames, searchString } = this.state;
    let newPipelineNames = this.getPipelineNames(false);
    if (searchString.length > 0) {
      newPipelineNames = newPipelineNames.filter((pipelineName) => pipelineName.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()));
      if (this.state.pipelineReorderEnabled) {
        this.disablePipelineReorder();
      }
    }
    const newStrategyNames = this.getPipelineNames(true);
    if (!isEqual(pipelineNames, newPipelineNames) || !isEqual(strategyNames, newStrategyNames)) {
      this.setState({ pipelineNames: newPipelineNames, strategyNames: newStrategyNames });
      this.initialize();
    }
  }
  initialize() {
    const { application } = this.props;
    if (application.pipelineConfigs.loadFailure) {
      return;
    }
    this.updateExecutionGroups();
  }
  componentWillUnmount() {
    this.groupsUpdatedSubscription.unsubscribe();
    this.locationChangeUnsubscribe();
    this.executionsRefreshUnsubscribe();
    this.pipelineConfigsRefreshUnsubscribe();
  }
  updateFilterSearch(searchString) {
    const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
    sortFilter.filter = searchString;
    logger.log({ category: "Pipelines", action: "Filter: search", data: { label: sortFilter.filter } });
    this.updateExecutionGroups();
  }
  updatePipelines(idsToUpdatedIndices) {
    return PipelineConfigService.reorderPipelines(this.props.application.name, idsToUpdatedIndices, false);
  }
  render() {
    const { pipelineNames, searchString, strategyNames, pipelineReorderEnabled, tags, pipelineTags } = this.state;
    const { sortFilter } = ExecutionState.filterModel.asFilterModel;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-filters"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "filters-content"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "heading"
    }, /* @__PURE__ */ React__default.createElement(FilterSearch, {
      helpKey: "executions.search",
      value: searchString,
      onBlur: this.searchFieldUpdated,
      onSearchChange: this.searchFieldUpdated
    })), /* @__PURE__ */ React__default.createElement("div", {
      className: "content"
    }, /* @__PURE__ */ React__default.createElement(PipelineTagFilters, {
      pipelineTags,
      refresh: this.refreshExecutions
    }), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Pipelines",
      expanded: true
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form"
    }, pipelineReorderEnabled && /* @__PURE__ */ React__default.createElement("a", {
      className: "btn btn-xs btn-default clickable margin-left-md",
      onClick: this.sortAlphabetically
    }, "Sort alphabetically"), /* @__PURE__ */ React__default.createElement(Pipelines, {
      names: pipelineNames,
      tags,
      dragEnabled: pipelineReorderEnabled,
      update: this.refreshExecutions,
      onSortEnd: this.handleSortEnd
    }), pipelineNames.length > 0 && /* @__PURE__ */ React__default.createElement("div", null, !pipelineReorderEnabled && /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-xs btn-default",
      onClick: this.enablePipelineReorder,
      disabled: Boolean(searchString)
    }, "Reorder Pipelines"), pipelineReorderEnabled && /* @__PURE__ */ React__default.createElement("button", {
      className: "btn btn-xs btn-default",
      onClick: this.disablePipelineReorder,
      disabled: Boolean(searchString)
    }, "Done")))), strategyNames.length > 0 && /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Strategies",
      expanded: true
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form"
    }, /* @__PURE__ */ React__default.createElement(Pipelines, {
      names: strategyNames,
      tags,
      dragEnabled: false,
      update: this.refreshExecutions,
      onSortEnd: this.handleSortEnd
    }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
      heading: "Status",
      expanded: true
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "form"
    }, /* @__PURE__ */ React__default.createElement(FilterStatus, {
      status: "RUNNING",
      label: "Running",
      refresh: this.refreshExecutions,
      disabled: sortFilter.awaitingJudgement
    }), /* @__PURE__ */ React__default.createElement(FilterAwaitingJudgement, {
      refresh: this.refreshExecutions
    }), /* @__PURE__ */ React__default.createElement(FilterStatus, {
      status: "TERMINAL",
      label: "Terminal",
      refresh: this.refreshExecutions
    }), /* @__PURE__ */ React__default.createElement(FilterStatus, {
      status: "SUCCEEDED",
      label: "Succeeded",
      refresh: this.refreshExecutions
    }), /* @__PURE__ */ React__default.createElement(FilterStatus, {
      status: "NOT_STARTED",
      label: "Not Started",
      refresh: this.refreshExecutions
    }), /* @__PURE__ */ React__default.createElement(FilterStatus, {
      status: "CANCELED",
      label: "Canceled",
      refresh: this.refreshExecutions
    }), /* @__PURE__ */ React__default.createElement(FilterStatus, {
      status: "STOPPED",
      label: "Stopped",
      refresh: this.refreshExecutions
    }), /* @__PURE__ */ React__default.createElement(FilterStatus, {
      status: "PAUSED",
      label: "Paused",
      refresh: this.refreshExecutions
    }), /* @__PURE__ */ React__default.createElement(FilterStatus, {
      status: "BUFFERED",
      label: "Buffered",
      refresh: this.refreshExecutions
    }))))));
  }
}
__decorateClass$2([
  Debounce(300)
], ExecutionFilters.prototype, "updateFilterSearch", 1);
const FilterCheckbox = (props) => {
  const { pipeline, tag, update, visible } = props;
  const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
  const changeHandler = () => {
    logger.log({ category: "Pipelines", action: "Filter: pipeline", data: { label: pipeline } });
    if (tag) {
      tag.clear();
    } else {
      sortFilter.pipeline[pipeline] = true;
    }
    update();
  };
  return /* @__PURE__ */ React__default.createElement("input", {
    type: "checkbox",
    style: { visibility: visible ? "visible" : "hidden" },
    disabled: !visible,
    checked: get(sortFilter, ["pipeline", pipeline], false),
    onChange: changeHandler
  });
};
const Pipeline = SortableElement((props) => /* @__PURE__ */ React__default.createElement("div", {
  className: classNames("checkbox sortable", { "disable-user-select": props.dragEnabled })
}, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("label", null, props.dragEnabled && /* @__PURE__ */ React__default.createElement(DragHandle, null), /* @__PURE__ */ React__default.createElement(FilterCheckbox, {
  pipeline: props.pipeline,
  tag: props.tag,
  visible: !props.dragEnabled,
  update: props.update
}), props.pipeline))));
const Pipelines = SortableContainer((props) => /* @__PURE__ */ React__default.createElement("div", null, props.names.map((pipeline, index) => {
  const tag = props.tags.find((t) => t.key === "pipeline" && t.value === pipeline);
  return /* @__PURE__ */ React__default.createElement(Pipeline, {
    key: pipeline,
    tag,
    index,
    pipeline,
    disabled: !props.dragEnabled,
    dragEnabled: props.dragEnabled,
    update: props.update
  });
})));
const PipelineTagFilters = (props) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, props.pipelineTags.names.map((name) => /* @__PURE__ */ React__default.createElement(FilterSection, {
  key: name,
  heading: name,
  expanded: true
}, (props.pipelineTags.values[name] || []).map((value) => /* @__PURE__ */ React__default.createElement(PipelineTagFilter, {
  key: value,
  group: name,
  value,
  refresh: props.refresh
})))));
const PipelineTagFilter = (props) => {
  const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
  const { group, value, refresh } = props;
  const key = `${encodeURIComponent(group)}:${encodeURIComponent(value)}`;
  const changed = () => {
    sortFilter.tags[key] = !sortFilter.tags[key];
    refresh();
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
    type: "checkbox",
    checked: sortFilter.tags[key] || false,
    onChange: changed
  }), value));
};
const FilterStatus = (props) => {
  const sortFilter = ExecutionState.filterModel.asFilterModel.sortFilter;
  const changed = () => {
    logger.log({ category: "Pipelines", action: "Filter: status", data: { label: props.label.toUpperCase() } });
    sortFilter.status[props.status] = !sortFilter.status[props.status];
    props.refresh();
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
    type: "checkbox",
    checked: sortFilter.status[props.status] || false,
    disabled: !!props.disabled,
    onChange: changed
  }), props.label));
};
const FilterAwaitingJudgement = (props) => {
  const { sortFilter } = ExecutionState.filterModel.asFilterModel;
  const label = "Awaiting Judgement";
  const changed = () => {
    logger.log({ category: "Pipelines", action: "Filter: status", data: { label } });
    sortFilter.awaitingJudgement = !sortFilter.awaitingJudgement;
    if (sortFilter.awaitingJudgement) {
      sortFilter.status["RUNNING"] = true;
    }
    props.refresh();
  };
  const checked = !!sortFilter.awaitingJudgement;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
    type: "checkbox",
    checked,
    onChange: changed
  }), " ", label));
};

var css_248z$n = "[ui-view='pipelines'] {\n  padding-top: 0 !important;\n}\n.executions-section {\n  display: flex;\n  width: 100%;\n  margin-top: 6px;\n}\n.executions-section .insight {\n  margin-left: 0;\n  margin-top: 6px;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n.executions-section .insight .nav {\n  flex-shrink: 0;\n  margin-top: 40px;\n}\n.executions-section .insight .nav-content {\n  margin-left: 12px;\n  max-width: 80%;\n}\n.executions-section .insight .nav-content .execution-groups-header {\n  margin-left: -8px;\n  position: relative;\n  z-index: 20;\n  padding: 30px 0 0 0;\n  margin-top: -30px;\n  background-color: var(--color-alabaster);\n  font-size: 90%;\n}\n.executions-section .insight .nav-content .execution-groups-header h3 {\n  display: inline-block;\n  font-weight: 600;\n  margin-top: 0;\n}\n.executions-section .insight .nav-content .execution-groups-header .execution-filters {\n  padding-bottom: 5px;\n}\n.executions-section .insight .nav-content .execution-groups-header .form-group {\n  margin-right: 17px;\n}\n.executions-section .insight .nav-content .execution-groups-header .form-group label {\n  font-weight: 600;\n}\n.executions-section .insight .nav-content .execution-groups-header .checkbox {\n  height: 24px;\n}\n.executions-section .insight .nav-content .execution-groups-header .checkbox label {\n  font-weight: normal;\n}\n@media (min-width: 1400px) {\n  .executions-section .insight .nav-content .execution-groups-header {\n    font-size: 100%;\n  }\n}\n.executions-section .insight.filters-collapsed .execution-groups-header {\n  margin-left: 84px;\n}\n.executions-section .insight.filters-collapsed .nav-content {\n  max-width: 100%;\n}\n.executions-section .form-group > * {\n  margin-right: 3px;\n}\n.executions-section .fa.from-template {\n  font-size: 1.25rem;\n  padding-right: 0.4rem;\n}\n.executions {\n  padding-top: 0 !important;\n}\n.executions.showing-details .execution-group.details-hidden {\n  opacity: 0.66;\n}\n.executions.showing-details .execution-group.details-hidden:hover {\n  opacity: 1;\n}\n.executions .permalinks {\n  font-size: 80%;\n  flex: 0 0 100%;\n  text-align: right;\n}\n.executions .permalinks .permalinks-content {\n  display: inline-block;\n  width: 50%;\n  background-color: var(--color-accent-g2);\n}\n.executions .execution {\n  margin-bottom: 10px;\n  background-color: var(--color-alabaster);\n}\n.executions .execution .execution-overview {\n  padding: 10px;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-alto);\n}\n.executions .execution .execution-overview .execution-name {\n  margin-top: 0;\n  font-weight: 600;\n}\n.execution-status {\n  color: var(--color-concrete);\n}\n.execution-status-executing,\n.execution-status-running {\n  color: var(--color-accent);\n}\n.execution-status-terminal {\n  color: var(--color-danger);\n}\n.execution-status-succeeded {\n  color: var(--color-success);\n}\n.execution-marker {\n  fill: var(--color-alto);\n  background-color: var(--color-alto);\n  overflow: hidden;\n}\n.execution-marker.execution-marker-terminal {\n  fill: var(--color-danger);\n  background-color: var(--color-danger);\n}\n.execution-marker.execution-marker-failed_continue {\n  fill: var(--color-alert);\n  background-color: var(--color-alert);\n}\n.execution-marker.execution-marker-succeeded {\n  fill: var(--color-success);\n  background-color: var(--color-success);\n}\n.execution-marker.execution-marker-running {\n  fill: var(--color-accent);\n  background-color: var(--color-accent);\n}\n.execution-marker.execution-marker-stopped {\n  fill: var(--color-danger-light);\n  background-color: var(--color-danger-light);\n}\n.execution-marker.execution-marker-not_started,\n.execution-marker.execution-marker-canceled {\n  fill: var(--color-alto);\n  background-color: var(--color-alto);\n}\n.execution-marker.execution-marker-paused {\n  fill: var(--color-accent);\n  background-color: var(--color-accent);\n}\n.execution-marker.execution-marker-skipped {\n  fill: var(--color-titanium);\n  background-color: var(--color-titanium);\n}\n.execution-marker.execution-marker-stopped {\n  fill: var(--color-danger-light);\n  background-color: var(--color-danger-light);\n}\n.execution-marker.execution-marker-stopped.stage-type-checkpreconditions,\n.execution-marker.execution-marker-stopped.stage-type-manualjudgment {\n  fill: var(--color-titanium);\n  background-color: var(--color-titanium);\n}\n";
styleInject(css_248z$n);

var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
const forwardedExecutions = new Set();
let disableForwarding = false;
let Executions = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.insightFilterStateModel = ReactInjector.insightFilterStateModel;
    this.filterCountOptions = [1, 2, 5, 10, 20, 30, 40, 50, 100, 200];
    this.setReloadingForFilters = (reloadingForFilters) => {
      if (this.state.reloadingForFilters !== reloadingForFilters) {
        this.setState({ reloadingForFilters });
      }
    };
    this.loadDefaultFilters = () => {
      const defaultTags = this.props.app.attributes.defaultFilteredTags;
      if (defaultTags != null) {
        this.props.app.attributes.defaultFilteredTags.forEach((defaultTag) => {
          ExecutionState.filterModel.asFilterModel.sortFilter.tags[`${defaultTag.tagName}:${defaultTag.tagValue}`] = true;
        });
        this.updateExecutionGroups(true);
      }
    };
    this.clearFilters = () => {
      ExecutionFilterService.clearFilters();
      this.updateExecutionGroups(true);
    };
    this.forceUpdateExecutionGroups = () => {
      this.updateExecutionGroups(true);
    };
    this.expand = () => {
      logger.log({ category: "Pipelines", action: "Expand All" });
      ExecutionState.filterModel.expandSubject.next(true);
    };
    this.collapse = () => {
      logger.log({ category: "Pipelines", action: "Collapse All" });
      ExecutionState.filterModel.expandSubject.next(false);
    };
    this.startManualExecutionClicked = () => {
      this.triggerPipeline();
    };
    this.toggleFilters = () => {
      const newState = !this.state.filtersExpanded;
      this.setState({ filtersExpanded: newState });
      this.insightFilterStateModel.pinFilters(newState);
    };
    this.groupByChanged = (event) => {
      const value = event.target.value;
      logger.log({ category: "Pipelines", action: "Group By", data: { label: value } });
      this.state.sortFilter.groupBy = value;
      this.updateExecutionGroups();
    };
    this.showCountChanged = (event) => {
      const value = event.target.value;
      this.state.sortFilter.count = parseInt(value, 10);
      logger.log({ category: "Pipelines", action: "Change Count", data: { label: value } });
      this.updateExecutionGroups(true);
    };
    this.showDurationsChanged = (event) => {
      const checked = event.target.checked;
      this.state.sortFilter.showDurations = checked;
      this.setState({ sortFilter: this.state.sortFilter });
      logger.log({ category: "Pipelines", action: "Toggle Durations", data: { label: checked.toString() } });
    };
    this.state = {
      filtersExpanded: this.insightFilterStateModel.filtersExpanded,
      loading: true,
      poll: null,
      sortFilter: ExecutionState.filterModel.asFilterModel.sortFilter,
      tags: [],
      triggeringExecution: false,
      reloadingForFilters: false
    };
  }
  updateExecutionGroups(reload) {
    this.normalizeExecutionNames();
    const { app } = this.props;
    if (reload) {
      this.setReloadingForFilters(true);
      app.executions.refresh(true).then(() => {
        ExecutionFilterService.updateExecutionGroups(app);
        setTimeout(() => this.setReloadingForFilters(false), 50);
      });
    } else {
      ExecutionFilterService.updateExecutionGroups(app);
      this.groupsUpdated();
      setTimeout(() => {
        this.setState({ loading: false });
      }, 50);
    }
  }
  groupsUpdated() {
    const newTags = ExecutionState.filterModel.asFilterModel.tags;
    const currentTags = this.state.tags;
    const areEqual = (t1, t2) => t1.key === t2.key && t1.label === t2.label && t1.value === t2.value;
    const tagsChanged = newTags.length !== currentTags.length || newTags.some((t1) => !currentTags.some((t2) => areEqual(t1, t2)));
    if (tagsChanged) {
      this.setState({ tags: newTags });
    }
  }
  dataInitializationFailure() {
    this.setState({ loading: false, initializationError: true });
  }
  normalizeExecutionNames() {
    const { app } = this.props;
    if (app.executions.loadFailure) {
      this.dataInitializationFailure();
    }
    const executions = app.executions.data || [];
    const configurations = app.pipelineConfigs.data || [];
    executions.forEach((execution) => {
      if (execution.pipelineConfigId) {
        const configMatch = configurations.find((c) => c.id === execution.pipelineConfigId);
        if (configMatch) {
          execution.name = configMatch.name;
        }
      }
    });
  }
  startPipeline(command) {
    const { executionService } = ReactInjector;
    this.setState({ triggeringExecution: true });
    return executionService.startAndMonitorPipeline(this.props.app, command.pipelineName, command.trigger).then((monitor) => {
      this.setState({ poll: monitor });
      return monitor.promise;
    }).finally(() => {
      this.setState({ triggeringExecution: false });
    });
  }
  triggerPipeline(pipeline = null) {
    logger.log({ category: "Pipelines", action: "Trigger Pipeline (top level)" });
    ManualExecutionModal.show({
      pipeline,
      application: this.props.app
    }).then((command) => {
      this.startPipeline(command);
      this.clearManualExecutionParam();
    }).catch(() => this.clearManualExecutionParam());
  }
  clearManualExecutionParam() {
    ReactInjector.$state.go(".", { startManualExecution: null }, { inherit: true, location: "replace" });
  }
  handleAgedOutExecutions(executionId, forwardToPermalink) {
    const { $state, executionService } = ReactInjector;
    if (forwardToPermalink && executionId && !forwardedExecutions.has(executionId)) {
      executionService.getExecution(executionId).then(() => {
        const detailsState = $state.current.name.replace("executions.execution", "executionDetails.execution");
        const { stage, step, details } = $state.params;
        forwardedExecutions.add(executionId);
        $state.go(detailsState, { executionId, stage, step, details });
      });
    } else {
      $state.go(".^");
    }
  }
  componentDidMount() {
    const { app } = this.props;
    if (ExecutionState.filterModel.mostRecentApplication !== app.name) {
      ExecutionState.filterModel.asFilterModel.groups = [];
      ExecutionState.filterModel.mostRecentApplication = app.name;
    }
    if (app.notFound || app.hasError) {
      return;
    }
    app.setActiveState(app.executions);
    app.executions.activate();
    app.pipelineConfigs.activate();
    this.activeRefresher = SchedulerFactory.createScheduler(5e3);
    this.activeRefresher.subscribe(() => {
      app.getDataSource("runningExecutions").refresh();
    });
    this.groupsUpdatedSubscription = ExecutionFilterService.groupsUpdatedStream.subscribe(() => this.groupsUpdated());
    this.executionsRefreshUnsubscribe = app.executions.onRefresh(null, () => {
      this.normalizeExecutionNames();
      const { $state } = ReactInjector;
      if ($state.params.executionId) {
        const executions = app.executions.data;
        if (executions.every((e) => e.id !== $state.params.executionId)) {
          this.handleAgedOutExecutions($state.params.executionId, !disableForwarding);
        }
      }
      disableForwarding = true;
    }, () => this.dataInitializationFailure());
    this.loadDefaultFilters();
    $q.all([app.executions.ready(), app.pipelineConfigs.ready()]).then(() => {
      this.updateExecutionGroups();
      const nameOrIdToStart = ReactInjector.$stateParams.startManualExecution;
      if (nameOrIdToStart) {
        const toStart = app.pipelineConfigs.data.find((p) => [p.id, p.name].includes(nameOrIdToStart));
        if (toStart) {
          this.triggerPipeline(toStart);
        } else {
          this.clearManualExecutionParam();
        }
      }
    });
  }
  componentWillUnmount() {
    const { app } = this.props;
    app.setActiveState();
    app.executions.deactivate();
    app.pipelineConfigs.deactivate();
    this.executionsRefreshUnsubscribe();
    this.groupsUpdatedSubscription.unsubscribe();
    this.activeRefresher && this.activeRefresher.unsubscribe();
    this.state.poll && this.state.poll.cancel();
  }
  render() {
    const { app } = this.props;
    const { filtersExpanded, loading, sortFilter, tags, triggeringExecution, reloadingForFilters } = this.state;
    const hasPipelines = !!(get(app, "executions.data", []).length || get(app, "pipelineConfigs.data", []).length);
    if (!app.notFound && !app.hasError) {
      if (!hasPipelines && !loading) {
        return /* @__PURE__ */ React__default.createElement("div", {
          className: "text-center full-width"
        }, /* @__PURE__ */ React__default.createElement("h3", null, "No pipelines configured for this application."), /* @__PURE__ */ React__default.createElement("h4", null, /* @__PURE__ */ React__default.createElement(CreatePipelineButton, {
          application: app,
          asLink: true
        })));
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "executions-section"
      }, !loading && /* @__PURE__ */ React__default.createElement("div", {
        onClick: this.toggleFilters
      }, /* @__PURE__ */ React__default.createElement(FilterCollapse, null)), /* @__PURE__ */ React__default.createElement("div", {
        className: `insight ${filtersExpanded ? "filters-expanded" : "filters-collapsed"}`
      }, filtersExpanded && /* @__PURE__ */ React__default.createElement("div", {
        className: "nav ng-scope"
      }, !loading && /* @__PURE__ */ React__default.createElement(ExecutionFilters, {
        application: app,
        setReloadingForFilters: this.setReloadingForFilters
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: `nav-content ng-scope ${sortFilter.showDurations ? "show-durations" : ""}`,
        "data-scroll-id": "nav-content"
      }, !loading && /* @__PURE__ */ React__default.createElement("div", {
        className: "execution-groups-header"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group pull-right"
      }, /* @__PURE__ */ React__default.createElement("a", {
        className: "btn btn-sm btn-primary clickable",
        onClick: this.startManualExecutionClicked,
        style: { pointerEvents: triggeringExecution ? "none" : "auto" }
      }, triggeringExecution && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "Starting Execution"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "visible-md-inline visible-sm-inline"
      }, /* @__PURE__ */ React__default.createElement(Spinner, {
        size: "nano"
      }))), /* @__PURE__ */ React__default.createElement("span", {
        className: "visible-lg-inline"
      }, /* @__PURE__ */ React__default.createElement(Spinner, {
        size: "nano"
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "visible-xl-inline"
      }, "Starting Execution"), "\u2026"), !triggeringExecution && /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-play visible-lg-inline"
      }), /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "Start Manual Execution"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-play visible-md-inline visible-sm-inline"
      })), /* @__PURE__ */ React__default.createElement("span", {
        className: "visible-xl-inline"
      }, " Start Manual Execution")))), /* @__PURE__ */ React__default.createElement("div", {
        className: "pull-right"
      }, /* @__PURE__ */ React__default.createElement(CreatePipeline, {
        application: app
      })), /* @__PURE__ */ React__default.createElement("form", {
        className: "form-inline",
        style: { marginBottom: "5px" }
      }, sortFilter.groupBy && /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group",
        style: { marginRight: "20px" }
      }, /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "expand all"
      }, /* @__PURE__ */ React__default.createElement("a", {
        className: "btn btn-xs btn-default clickable",
        onClick: this.expand
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-plus"
      }))), /* @__PURE__ */ React__default.createElement(Tooltip, {
        value: "collapse all"
      }, /* @__PURE__ */ React__default.createElement("a", {
        className: "btn btn-xs btn-default clickable",
        onClick: this.collapse
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-minus"
      })))), /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Group by"), /* @__PURE__ */ React__default.createElement("select", {
        className: "form-control input-sm",
        value: sortFilter.groupBy,
        onChange: this.groupByChanged
      }, /* @__PURE__ */ React__default.createElement("option", {
        value: "none"
      }, "None"), /* @__PURE__ */ React__default.createElement("option", {
        value: "name"
      }, "Pipeline"), /* @__PURE__ */ React__default.createElement("option", {
        value: "timeBoundary"
      }, "Time Boundary"))), /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group"
      }, /* @__PURE__ */ React__default.createElement("label", null, "Show "), /* @__PURE__ */ React__default.createElement("select", {
        className: "form-control input-sm",
        value: sortFilter.count,
        onChange: this.showCountChanged
      }, this.filterCountOptions.map((count) => /* @__PURE__ */ React__default.createElement("option", {
        key: count,
        value: count
      }, count))), /* @__PURE__ */ React__default.createElement("span", null, " executions per pipeline")), /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group checkbox"
      }, /* @__PURE__ */ React__default.createElement("label", null, /* @__PURE__ */ React__default.createElement("input", {
        type: "checkbox",
        checked: sortFilter.showDurations,
        onChange: this.showDurationsChanged
      }), " ", "stage durations"))), /* @__PURE__ */ React__default.createElement(FilterTags, {
        tags,
        tagCleared: this.forceUpdateExecutionGroups,
        clearFilters: this.clearFilters
      })), loading && /* @__PURE__ */ React__default.createElement("div", {
        className: "horizontal center middle spinner-container"
      }, /* @__PURE__ */ React__default.createElement(Spinner, {
        size: "medium"
      })), reloadingForFilters && /* @__PURE__ */ React__default.createElement("div", {
        className: "text-center transition-overlay",
        style: { marginLeft: "-25px" }
      }), !loading && !hasPipelines && /* @__PURE__ */ React__default.createElement("div", {
        className: "text-center"
      }, /* @__PURE__ */ React__default.createElement("h4", null, "No pipelines configured for this application.")), app.executions.loadFailure && /* @__PURE__ */ React__default.createElement("div", {
        className: "text-center"
      }, /* @__PURE__ */ React__default.createElement("h4", null, "There was an error loading executions. We'll try again shortly.")), !loading && hasPipelines && /* @__PURE__ */ React__default.createElement(ExecutionGroups, {
        application: app
      }))));
    }
    return null;
  }
};
Executions = __decorateClass$1([
  Overridable("PipelineExecutions")
], Executions);

const PIPELINE_STATES = "spinnaker.core.pipeline.states";
module(PIPELINE_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  "stateConfigProvider",
  (applicationStateProvider, stateConfigProvider) => {
    const pipelineConfig = {
      name: "pipelineConfig",
      url: "/configure/:pipelineId?executionId&new",
      views: {
        pipelines: {
          templateUrl: "core/src/pipeline/config/pipelineConfig.html",
          controller: "PipelineConfigCtrl",
          controllerAs: "vm"
        }
      },
      data: {
        pageTitleSection: {
          title: "pipeline config"
        }
      }
    };
    const executionDetails = {
      name: "execution",
      url: "/:executionId?refId&stage&subStage&step&details&stageId",
      params: {
        stage: {
          value: "0"
        },
        step: {
          value: "0"
        }
      },
      data: {
        pageTitleDetails: {
          title: "Execution Details",
          nameParam: "executionId"
        }
      }
    };
    const singleExecutionDetails = {
      name: "executionDetails",
      url: "/details",
      views: {
        pipelines: { component: SingleExecutionDetails, $type: "react" }
      },
      params: {
        executionParams: null
      },
      abstract: true,
      children: [executionDetails]
    };
    const executions = {
      name: "executions",
      url: `?startManualExecution&${stateConfigProvider.paramsToQuery(filterModelConfig$1)}`,
      views: {
        pipelines: { component: Executions, $type: "react" }
      },
      params: stateConfigProvider.buildDynamicParams(filterModelConfig$1),
      children: [executionDetails],
      data: {
        pageTitleSection: {
          title: "Pipeline Executions"
        }
      }
    };
    const pipelines = {
      name: "pipelines",
      url: "/executions",
      redirectTo: (trans) => `${trans.to().name}.executions`,
      views: {
        insight: {
          template: '<div ui-view="pipelines" sticky-headers class="flex-fill"></div>'
        }
      },
      children: [executions, pipelineConfig, singleExecutionDetails]
    };
    applicationStateProvider.addChildState(pipelines);
    const executionsLookup = {
      name: "executionLookup",
      url: "/executions/:executionId?refId&stage&subStage&step&details&stageId",
      params: {
        executionId: { dynamic: true }
      },
      redirectTo: (transition) => {
        const { executionId, refId, stage, subStage, step, details, stageId } = transition.params();
        const executionService = transition.injector().get("executionService");
        if (!executionId) {
          return void 0;
        }
        return Promise.resolve(executionService.getExecution(executionId)).then((execution) => transition.router.stateService.target("home.applications.application.pipelines.executionDetails.execution", {
          application: execution.application,
          executionId: execution.id,
          refId,
          stage,
          subStage,
          step,
          details,
          stageId
        })).catch(() => {
        });
      },
      views: {
        "main@": { component: ExecutionNotFound, $type: "react" }
      }
    };
    stateConfigProvider.addToRootState(executionsLookup);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/pipeline/config/pipelineConfig.html", `<div ng-if="vm.pipelineConfig && vm.state.pipelinesLoaded" style="padding-top: 0">
  <div class="row">
    <div class="col-md-10 col-md-offset-1"></div>
  </div>
  <div class="row">
    <div class="col-md-10 col-md-offset-1">
      <pipeline-configurer
        pipeline="vm.pipelineConfig"
        plan="vm.pipelinePlan"
        is-templated-pipeline="vm.isTemplatedPipeline"
        is-v2-templated-pipeline="vm.isV2TemplatedPipeline"
        has-dynamic-source="vm.hasDynamicSource"
        application="vm.application"
        template-error="vm.templateError"
      >
      </pipeline-configurer>
    </div>
  </div>
</div>
<div
  class="row"
  ng-if="!vm.application.notFound && !vm.application.hasError && !vm.state.pipelinesLoaded"
  style="min-height: 300px"
>
  <div class="horizontal center middle spinner-container">
    <loading-spinner size="'small'"></loading-spinner>
  </div>
</div>
<div class="row" ng-if="vm.state.notFound" style="min-height: 300px">
  <h4 class="text-center">No pipeline found with that name.</h4>
</div>
`);
}]);

const ARTIFACT_LIST = "spinnaker.core.pipeline.status.artifactList";
module(ARTIFACT_LIST, []).component("artifactList", react2angular(withErrorBoundary(ArtifactList, "artifactList"), ["artifacts"]));

var css_248z$m = ".pipelines {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.pipelines > .header {\n  flex: none;\n}\n.pipelines > .execution-groups {\n  padding: 0 0 0 10px;\n  flex: 1 0 100px;\n  overflow-y: auto;\n}\n.canary-config-view h4 {\n  margin: 20px 0 20px 0px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--color-concrete);\n}\n.canary-config-view h5 {\n  margin: 20px 0 0px 30px;\n  font-weight: 600;\n}\n.canary-config-view .horizontal-rule {\n  border-top: 1px solid var(--color-alto);\n  margin-top: 5px;\n  margin-left: 30px;\n  margin-bottom: 10px;\n}\n.canary-config-view .sm-label-right,\n.canary-config-view label {\n  padding-right: 5px;\n}\n.canary-config-view .sm-label-right b,\n.canary-config-view label b {\n  font-weight: 600;\n}\n.canary-summary-alert {\n  padding-left: 8px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-right: 4px;\n  margin-bottom: 10px;\n  margin-top: 4px;\n}\n.stage-label .tests-pass-count {\n  color: var(--color-success);\n}\n.stage-label .tests-fail-count {\n  color: var(--color-danger);\n}\n.stage-label .tests-skip-count {\n  color: var(--color-concrete);\n}\n.execution-details .test-results .test-result-section {\n  display: inline-block;\n  text-align: right;\n  width: 65px;\n}\n.execution-details .test-results .test-result-section .fa-check {\n  color: var(--color-success);\n}\n.execution-details .test-results .test-result-section .glyphicon-remove {\n  color: var(--color-danger);\n}\n.execution-details .test-results .test-result-section .glyphicon-remove.informational {\n  color: var(--color-danger) !important;\n  cursor: default;\n}\n";
styleInject(css_248z$m);

const PIPELINE_MODULE = "spinnaker.core.pipeline";
module(PIPELINE_MODULE, [
  "ui.sortable",
  EXECUTION_DETAILS_SECTION_NAV,
  BUILD_DISPLAY_NAME_FILTER,
  STAGE_FAILURE_MESSAGE_COMPONENT,
  STEP_EXECUTION_DETAILS_COMPONENT,
  STAGE_SUMMARY_COMPONENT,
  CORE_PIPELINE_PIPELINE_DATASOURCE,
  ARTIFACT_LIST,
  PIPELINE_STATES,
  CORE_PIPELINE_CONFIG_PIPELINECONFIG_MODULE,
  GROUP_STAGE_MODULE,
  TRAVIS_STAGE_MODULE,
  WERCKER_STAGE_MODULE,
  PRECONFIGUREDJOB_STAGE_MODULE,
  WEBHOOK_STAGE_MODULE,
  UNMATCHED_STAGE_TYPE_STAGE,
  CORE_PIPELINE_CONFIG_STAGES_BAKE_BAKESTAGE_MODULE,
  CHECK_PRECONDITIONS_STAGE_MODULE,
  CLONE_SERVER_GROUP_STAGE,
  STAGE_COMMON_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_DEPLOY_DEPLOYSTAGE_MODULE,
  DESTROY_ASG_STAGE,
  DISABLE_ASG_STAGE_MODULE,
  DISABLE_CLUSTER_STAGE,
  ROLLBACK_CLUSTER_STAGE,
  ENABLE_ASG_STAGE,
  EXECUTION_WINDOWS,
  FIND_AMI_STAGE,
  FIND_ARTIFACT_FROM_EXECUTION_STAGE,
  CORE_PIPELINE_CONFIG_STAGES_FINDIMAGEFROMTAGS_FINDIMAGEFROMTAGSSTAGE_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_JENKINS_JENKINSSTAGE_MODULE,
  MANUAL_JUDGMENT_STAGE_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_TAGIMAGE_TAGIMAGESTAGE_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_PIPELINE_PIPELINESTAGE_MODULE,
  CORE_PIPELINE_CONFIG_STAGES_MONITORPIPELINE_MONITORPIPELINESTAGE_MODULE,
  RESIZE_ASG_STAGE,
  CORE_PIPELINE_CONFIG_STAGES_RUNJOB_RUNJOBSTAGE_MODULE,
  SCALE_DOWN_CLUSTER_STAGE,
  SCRIPT_STAGE,
  SHRINK_CLUSTER_STAGE,
  CORE_PIPELINE_CONFIG_STAGES_WAITFORPARENTTASKS_WAITFORPARENTTASKS,
  CREATE_LOAD_BALANCER_STAGE,
  APPLY_SOURCE_SERVER_GROUP_CAPACITY_STAGE,
  EVALUATE_HEALTH_STAGE,
  NOTIFY_DEPLOY_STARTING_STAGE,
  CORE_PIPELINE_CONFIG_PRECONDITIONS_PRECONDITIONS_MODULE,
  CORE_PIPELINE_CONFIG_PRECONDITIONS_TYPES_CLUSTERSIZE_CLUSTERSIZE_PRECONDITION_TYPE_MODULE,
  CORE_PIPELINE_CONFIG_PRECONDITIONS_TYPES_EXPRESSION_EXPRESSION_PRECONDITION_TYPE_MODULE,
  PIPELINE_TEMPLATES_V2_STATES_CONFIG,
  STAGE_STATUS_PRECONDITION
]);

class VariableValidatorService {
  static addValidator(validator) {
    this.validators.add(validator);
  }
  static validate(variable) {
    const errors = [];
    this.validators.forEach((v) => {
      if (v.handles(variable.type)) {
        v.validate(variable, errors);
      }
    });
    return errors;
  }
}
VariableValidatorService.validators = new Set();

class ConfigurePipelineTemplateModalController {
  constructor($scope, $uibModalInstance, application, pipelineTemplateConfig, isNew, pipelineId, executionId) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.application = application;
    this.pipelineTemplateConfig = pipelineTemplateConfig;
    this.isNew = isNew;
    this.pipelineId = pipelineId;
    this.executionId = executionId;
    this.state = {
      loading: true,
      error: false,
      planErrors: null,
      loadingError: false,
      noVariables: false,
      inheritTemplateParameters: true,
      inheritTemplateTriggers: true,
      inheritTemplateExpectedArtifacts: true
    };
    this.handleVariableChange = (newVariable) => {
      const oldVariable = this.getVariable(newVariable.name);
      newVariable.errors = VariableValidatorService.validate(newVariable);
      this.variables = without(this.variables, oldVariable).concat([newVariable]);
      this.$scope.$digest();
    };
  }
  $onInit() {
    this.initialize();
  }
  initialize() {
    const { config } = this.pipelineTemplateConfig;
    const defaultConfiguration = { inherit: ["expectedArtifacts", "parameters", "triggers"] };
    const inherit = (config.configuration || defaultConfiguration).inherit;
    this.state.inheritTemplateExpectedArtifacts = inherit.includes("expectedArtifacts");
    this.state.inheritTemplateParameters = inherit.includes("parameters");
    this.state.inheritTemplateTriggers = inherit.includes("triggers");
    this.pipelineName = config.pipeline.name;
    this.source = config.pipeline.template.source;
    this.loadTemplate().then(() => {
      this.groupVariableMetadata();
      this.initializeVariables();
      if (!this.variables.length) {
        this.state.noVariables = true;
      }
    }).then(() => this.state.loading = false).catch(() => {
      Object.assign(this.state, { loading: false, error: false, planErrors: null, loadingError: true });
    });
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
  formIsValid() {
    return this.variables.every((v) => v.errors.length === 0);
  }
  submit() {
    const config = this.buildConfig();
    return PipelineTemplateReader.getPipelinePlan(config).then((plan) => {
      const { parameterConfig, expectedArtifacts, triggers } = plan;
      const inherited = {
        ...config,
        ...this.state.inheritTemplateParameters && parameterConfig ? { parameterConfig } : {},
        ...this.state.inheritTemplateExpectedArtifacts && expectedArtifacts ? { expectedArtifacts } : {},
        ...this.state.inheritTemplateTriggers && triggers ? { triggers } : {}
      };
      this.$uibModalInstance.close({ plan, config: inherited });
    }).catch((response) => {
      Object.assign(this.state, { loading: false, error: true, planErrors: response.data && response.data.errors });
    });
  }
  dismissError() {
    Object.assign(this.state, { error: false, planErrors: null, loadingError: false });
  }
  buildConfig() {
    const inheritConfig = [
      ...this.state.inheritTemplateParameters ? ["parameters"] : [],
      ...this.state.inheritTemplateExpectedArtifacts ? ["expectedArtifacts"] : [],
      ...this.state.inheritTemplateTriggers ? ["triggers"] : []
    ];
    return {
      ...this.pipelineTemplateConfig || {},
      type: "templatedPipeline",
      name: this.pipelineName,
      application: this.application.name,
      config: {
        schema: "1",
        pipeline: {
          name: this.pipelineName,
          application: this.application.name,
          pipelineConfigId: this.pipelineId,
          template: { source: this.source },
          variables: this.transformVariablesForPipelinePlan()
        },
        configuration: {
          inherit: inheritConfig
        }
      }
    };
  }
  loadTemplate() {
    return PipelineTemplateReader.getPipelineTemplateFromSourceUrl(this.source, this.executionId, this.pipelineId).then((template) => {
      this.template = template;
    });
  }
  transformVariablesForPipelinePlan() {
    return chain(this.variables || []).cloneDeep().map((v) => {
      if (v.type === "object") {
        v.value = load(v.value);
      } else if (v.type === "int") {
        return [v.name, parseInt(v.value, 10)];
      } else if (v.type === "float") {
        return [v.name, parseFloat(v.value)];
      }
      return [v.name, v.value];
    }).fromPairs().value();
  }
  getVariable(name) {
    return this.variables.find((v) => v.name === name);
  }
  groupVariableMetadata() {
    this.variableMetadataGroups = [];
    (this.template.variables || []).forEach((v) => {
      if (v.group) {
        this.addToGroup(v.group, v);
      } else {
        this.addToGroup("Ungrouped", v);
      }
    });
  }
  addToGroup(groupName, metadata) {
    const group = this.variableMetadataGroups.find((g) => g.name === groupName);
    if (group) {
      group.variableMetadata.push(metadata);
    } else {
      this.variableMetadataGroups.push({ name: groupName, variableMetadata: [metadata] });
    }
  }
  initializeVariables() {
    this.variables = (this.template.variables || []).map((v) => {
      return {
        name: v.name,
        type: v.type || "string",
        errors: [],
        value: this.getInitialVariableValue(v),
        hideErrors: true
      };
    });
    this.variables.forEach((v) => v.errors = VariableValidatorService.validate(v));
  }
  getInitialVariableValue(variable) {
    if (has(this.pipelineTemplateConfig, `config.pipeline.variables.${variable.name}`)) {
      let value = this.pipelineTemplateConfig.config.pipeline.variables[variable.name];
      if (variable.type === "object" && value) {
        value = dump(value);
      }
      return value;
    } else if (variable.type === "object" && has(variable, "defaultValue")) {
      return dump(variable.defaultValue);
    } else {
      return variable.type === "list" && !variable.defaultValue ? [""] : variable.defaultValue;
    }
  }
}
ConfigurePipelineTemplateModalController.$inject = [
  "$scope",
  "$uibModalInstance",
  "application",
  "pipelineTemplateConfig",
  "isNew",
  "pipelineId",
  "executionId"
];
const CONFIGURE_PIPELINE_TEMPLATE_MODAL_CTRL = "spinnaker.core.pipeline.configureTemplate.modal.controller";
module(CONFIGURE_PIPELINE_TEMPLATE_MODAL_CTRL, []).controller("ConfigurePipelineTemplateModalCtrl", ConfigurePipelineTemplateModalController);

class VariableError extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group row slide-in"
    }, this.props.errors.length > 0 && /* @__PURE__ */ React__default.createElement("div", {
      className: "error-message"
    }, /* @__PURE__ */ React__default.createElement("ul", {
      style: { listStyle: "none" }
    }, this.renderErrors())));
  }
  renderErrors() {
    return this.props.errors.map((e) => /* @__PURE__ */ React__default.createElement("li", {
      key: e.key || e.message
    }, e.message));
  }
}

class VariableInputService {
  static addInput(input) {
    this.inputs.add(input);
  }
  static getInputForType(type = "string") {
    return Array.from(this.inputs).find((i) => i.handles(type));
  }
}
VariableInputService.inputs = new Set();

class BooleanInput extends React__default.Component {
  constructor() {
    super(...arguments);
    this.extractValue = () => {
      this.props.onChange({
        value: !this.props.variable.value,
        type: this.props.variable.type,
        name: this.props.variable.name
      });
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "checkbox",
      checked: this.props.variable.value || false,
      onChange: this.extractValue
    }), !this.props.variable.hideErrors && /* @__PURE__ */ React__default.createElement(VariableError, {
      errors: this.props.variable.errors
    }));
  }
}
class BooleanInputBuilder {
  handles(type) {
    return type === "boolean";
  }
  getInput(variable, onChange) {
    return /* @__PURE__ */ React__default.createElement(BooleanInput, {
      variable,
      onChange
    });
  }
}
VariableInputService.addInput(new BooleanInputBuilder());

class ListInput extends React__default.Component {
  constructor() {
    super(...arguments);
    this.handleAddValue = () => {
      const list = this.props.variable.value.slice().concat([""]);
      this.props.onChange({ value: list, type: this.props.variable.type, name: this.props.variable.name });
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, this.createInputFields(), /* @__PURE__ */ React__default.createElement(Button$1, {
      className: "btn-block add-new",
      onClick: this.handleAddValue
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "glyphicon glyphicon-plus-sign"
    }), " Add New"));
  }
  createInputFields() {
    return this.props.variable.value.map((v, i) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "form-group",
        key: i,
        style: { marginBottom: "5px" }
      }, /* @__PURE__ */ React__default.createElement("input", {
        type: "text",
        style: { display: "inline-block", width: "90%" },
        className: "form-control input-sm",
        value: v,
        onChange: this.extractValue(i),
        required: true
      }), /* @__PURE__ */ React__default.createElement("a", {
        onClick: this.handleDeleteValue.bind(this, i),
        className: "clickable",
        style: { marginLeft: "10px" }
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "glyphicon glyphicon-trash"
      })), !this.props.variable.hideErrors && /* @__PURE__ */ React__default.createElement(VariableError, {
        errors: this.findErrorsForInput(i)
      }));
    });
  }
  findErrorsForInput(inputKey) {
    return this.props.variable.errors ? this.props.variable.errors.filter((e) => e.key === inputKey) : [];
  }
  extractValue(i) {
    return (e) => {
      const list = this.props.variable.value.slice();
      list[i] = e.target.value;
      this.props.onChange({ value: list, type: this.props.variable.type, name: this.props.variable.name });
    };
  }
  handleDeleteValue(i) {
    const list = this.props.variable.value.slice();
    list.splice(i, 1);
    this.props.onChange({ value: list, type: this.props.variable.type, name: this.props.variable.name });
  }
}
class ListInputBuilder {
  handles(type) {
    return type === "list";
  }
  getInput(variable, onChange) {
    return /* @__PURE__ */ React__default.createElement(ListInput, {
      variable,
      onChange
    });
  }
}
VariableInputService.addInput(new ListInputBuilder());

class NumberInput extends React__default.Component {
  constructor() {
    super(...arguments);
    this.extractValue = (e) => {
      const value = e.target.value;
      this.props.onChange({ value, type: this.props.variable.type, name: this.props.variable.name });
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "number",
      className: "form-control input-sm",
      value: this.props.variable.value || "",
      onChange: this.extractValue,
      required: true
    }), !this.props.variable.hideErrors && /* @__PURE__ */ React__default.createElement(VariableError, {
      errors: this.props.variable.errors
    }));
  }
}
class NumberInputBuilder {
  handles(type) {
    return ["float", "int"].includes(type);
  }
  getInput(variable, onChange) {
    return /* @__PURE__ */ React__default.createElement(NumberInput, {
      variable,
      onChange
    });
  }
}
VariableInputService.addInput(new NumberInputBuilder());

class ObjectInput extends React__default.Component {
  constructor() {
    super(...arguments);
    this.extractValue = (e) => {
      this.props.onChange({ value: e.target.value, type: this.props.variable.type, name: this.props.variable.name });
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("textarea", {
      className: "form-control input-sm",
      rows: 5,
      value: this.props.variable.value || "",
      onChange: this.extractValue,
      required: true
    }), !this.props.variable.hideErrors && /* @__PURE__ */ React__default.createElement(VariableError, {
      errors: this.props.variable.errors
    }));
  }
}
class ObjectInputBuilder {
  handles(type) {
    return type === "object";
  }
  getInput(variable, onChange) {
    return /* @__PURE__ */ React__default.createElement(ObjectInput, {
      variable,
      onChange
    });
  }
}
VariableInputService.addInput(new ObjectInputBuilder());

class StringInput extends React__default.Component {
  constructor() {
    super(...arguments);
    this.extractValue = (e) => {
      this.props.onChange({ value: e.target.value, type: this.props.variable.type, name: this.props.variable.name });
    };
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("input", {
      type: "text",
      className: "form-control input-sm",
      value: this.props.variable.value || "",
      onChange: this.extractValue,
      required: true
    }), !this.props.variable.hideErrors && /* @__PURE__ */ React__default.createElement(VariableError, {
      errors: this.props.variable.errors
    }));
  }
}
class StringInputBuilder {
  handles(type) {
    return type === "string";
  }
  getInput(variable, onChange) {
    return /* @__PURE__ */ React__default.createElement(StringInput, {
      variable,
      onChange
    });
  }
}
VariableInputService.addInput(new StringInputBuilder());

class TemplatePlanErrors extends React__default.Component {
  render() {
    if (this.props.errors && this.props.errors.length) {
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("strong", null, "Error", this.props.errors.length > 1 ? "s" : "", ":"), this.props.errors.map((e) => this.buildErrorMessage(e)));
    } else {
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("strong", null, "Error:"), " No message provided");
    }
  }
  buildErrorMessage(e, paddingLeft = 15) {
    return /* @__PURE__ */ React__default.createElement("div", {
      style: { paddingLeft: `${paddingLeft}px` },
      key: this.buildErrorKey(e)
    }, e.message && /* @__PURE__ */ React__default.createElement("div", null, "Message: ", e.message), e.severity && /* @__PURE__ */ React__default.createElement("div", null, "Severity: ", e.severity), e.location && /* @__PURE__ */ React__default.createElement("div", null, "Location: ", e.location), e.cause && /* @__PURE__ */ React__default.createElement("div", null, "Cause: ", e.cause), e.suggestion && /* @__PURE__ */ React__default.createElement("div", null, "Suggestion: ", e.suggestion), e.details && /* @__PURE__ */ React__default.createElement("div", null, " ", "Details:", /* @__PURE__ */ React__default.createElement("ul", null, Object.keys(e.details).map((key) => /* @__PURE__ */ React__default.createElement("li", {
      key
    }, key, ": ", e.details[key])))), e.nestedErrors && /* @__PURE__ */ React__default.createElement("div", null, " ", "Nested Errors:", e.nestedErrors.map((nestedError) => this.buildErrorMessage(nestedError, paddingLeft + 15))));
  }
  buildErrorKey(e) {
    return `${e.message}:${e.severity}:${e.location}:${e.cause}`;
  }
}

const TEMPLATE_PLAN_ERRORS = "spinnaker.core.templatePlanErrors.component";
module(TEMPLATE_PLAN_ERRORS, []).component("templatePlanErrors", react2angular(withErrorBoundary(TemplatePlanErrors, "templatePlanErrors"), ["errors"]));

class ConfigurePipelineTemplateModalV2Controller {
  constructor($scope, $uibModalInstance, application, pipelineTemplateConfig, isNew, pipelineId, executionId) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.application = application;
    this.pipelineTemplateConfig = pipelineTemplateConfig;
    this.isNew = isNew;
    this.pipelineId = pipelineId;
    this.executionId = executionId;
    this.state = {
      loading: true,
      error: false,
      planErrors: null,
      loadingError: false,
      noVariables: false,
      inheritTemplateParameters: true,
      inheritTemplateTriggers: true,
      inheritTemplateNotifications: true
    };
    this.handleVariableChange = (newVariable) => {
      const oldVariable = this.getVariable(newVariable.name);
      newVariable.errors = VariableValidatorService.validate(newVariable);
      this.variables = without(this.variables, oldVariable).concat([newVariable]);
      this.$scope.$digest();
    };
  }
  $onInit() {
    this.initialize();
  }
  initialize() {
    const { exclude, name, template } = this.pipelineTemplateConfig;
    const excluded = exclude || [];
    this.state.inheritTemplateNotifications = !excluded.includes("notifications");
    this.state.inheritTemplateParameters = !excluded.includes("parameters");
    this.state.inheritTemplateTriggers = !excluded.includes("triggers");
    this.pipelineName = name;
    this.source = template.reference;
    this.loadTemplate().then(() => {
      this.groupVariableMetadata();
      this.initializeVariables();
      if (!this.variables.length) {
        this.state.noVariables = true;
      }
    }).then(() => this.state.loading = false).catch(() => {
      Object.assign(this.state, { loading: false, error: false, planErrors: null, loadingError: true });
    });
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
  formIsValid() {
    return this.variables.every((v) => v.errors.length === 0);
  }
  submit() {
    const config = this.buildConfig();
    return PipelineTemplateReader.getPipelinePlan(config).then((plan) => {
      const { parameterConfig, notifications, triggers, expectedArtifacts } = plan;
      const { inheritTemplateParameters, inheritTemplateNotifications, inheritTemplateTriggers } = this.state;
      const configWithInheritedValues = {
        ...config,
        ...inheritTemplateParameters && parameterConfig ? { parameterConfig } : {},
        ...inheritTemplateNotifications && notifications ? { notifications } : {},
        ...inheritTemplateTriggers && triggers ? { triggers } : {},
        ...expectedArtifacts ? { expectedArtifacts } : {}
      };
      this.$uibModalInstance.close({ plan, config: configWithInheritedValues });
    }).catch((response) => {
      Object.assign(this.state, { loading: false, error: true, planErrors: response.data && response.data.errors });
    });
  }
  dismissError() {
    Object.assign(this.state, { error: false, planErrors: null, loadingError: false });
  }
  buildConfig() {
    const {
      application: { name: appName },
      state: { inheritTemplateNotifications, inheritTemplateParameters, inheritTemplateTriggers },
      pipelineName,
      pipelineTemplateConfig,
      source
    } = this;
    const excludeConfig = [
      ...inheritTemplateParameters ? [] : ["parameters"],
      ...inheritTemplateNotifications ? [] : ["notifications"],
      ...inheritTemplateTriggers ? [] : ["triggers"]
    ];
    return {
      ...PipelineTemplateV2Service.filterInheritedConfig(pipelineTemplateConfig),
      type: "templatedPipeline",
      name: pipelineName,
      application: appName,
      variables: this.transformVariablesForPipelinePlan(),
      exclude: excludeConfig,
      ...PipelineTemplateV2Service.getPipelineTemplateConfigV2(source)
    };
  }
  loadTemplate() {
    return PipelineTemplateReader.getPipelineTemplateFromSourceUrl(this.source, this.executionId, this.pipelineId).then((template) => {
      this.template = template;
    });
  }
  transformVariablesForPipelinePlan() {
    return chain(this.variables || []).cloneDeep().map((v) => {
      switch (v.type) {
        case "boolean":
          v.value = !!v.value;
          break;
        case "object":
          v.value = JSON.parse(v.value);
          break;
        case "int":
          v.value = parseInt(v.value, 10);
          break;
        case "float":
          v.value = parseFloat(v.value);
          break;
      }
      return [v.name, v.value];
    }).fromPairs().value();
  }
  getVariable(name) {
    return this.variables.find((v) => v.name === name);
  }
  groupVariableMetadata() {
    this.variableMetadataGroups = [];
    (this.template.variables || []).forEach((v) => {
      if (v.group) {
        this.addToGroup(v.group, v);
      } else {
        this.addToGroup("Ungrouped", v);
      }
    });
  }
  addToGroup(groupName, metadata) {
    const group = this.variableMetadataGroups.find((g) => g.name === groupName);
    if (group) {
      group.variableMetadata.push(metadata);
    } else {
      this.variableMetadataGroups.push({ name: groupName, variableMetadata: [metadata] });
    }
  }
  initializeVariables() {
    this.variables = (this.template.variables || []).map((v) => {
      return {
        name: v.name,
        type: v.type || "string",
        errors: [],
        value: this.getInitialVariableValue(v),
        hideErrors: true
      };
    });
    this.variables.forEach((v) => v.errors = VariableValidatorService.validate(v));
  }
  getInitialVariableValue(variable) {
    if (has(this.pipelineTemplateConfig, `variables.${variable.name}`)) {
      let value = this.pipelineTemplateConfig.variables[variable.name];
      if (variable.type === "object" && value) {
        value = JSON.stringify(value);
      }
      return value;
    } else if (variable.type === "object" && has(variable, "defaultValue")) {
      return JSON.stringify(variable.defaultValue);
    } else {
      return variable.type === "list" && !variable.defaultValue ? [""] : variable.defaultValue;
    }
  }
}
ConfigurePipelineTemplateModalV2Controller.$inject = [
  "$scope",
  "$uibModalInstance",
  "application",
  "pipelineTemplateConfig",
  "isNew",
  "pipelineId",
  "executionId"
];
const CONFIGURE_PIPELINE_TEMPLATE_MODAL_V2_CTRL = "spinnaker.core.pipeline.configureTemplate.modal.v2.controller";
module(CONFIGURE_PIPELINE_TEMPLATE_MODAL_V2_CTRL, []).controller("ConfigurePipelineTemplateModalV2Ctrl", ConfigurePipelineTemplateModalV2Controller);

class ListValidator {
  handles(type) {
    return type === "list";
  }
  validate(variable, errors) {
    (variable.value || []).forEach((listElement, i) => {
      if (!listElement) {
        errors.push({ message: "Field is required.", key: i });
      }
    });
  }
}
VariableValidatorService.addValidator(new ListValidator());

class NumberValidator {
  handles(type) {
    return ["int", "float"].includes(type);
  }
  validate(variable, errors) {
    if (!variable.value) {
      errors.push({ message: "Field is required." });
    }
    if (variable.type === "int" && typeof variable.value === "string" && variable.value.split(".").length > 1) {
      errors.push({ message: "Must be an integer." });
    }
  }
}
VariableValidatorService.addValidator(new NumberValidator());

class ObjectValidator {
  handles(type) {
    return type === "object";
  }
  validate(variable, errors) {
    if (!variable.value) {
      errors.push({ message: "Field is required." });
    }
    try {
      load(variable.value);
    } catch (e) {
      errors.push({ message: e.message });
    }
  }
}
VariableValidatorService.addValidator(new ObjectValidator());

class StringValidator {
  handles(type) {
    return type === "string";
  }
  validate(variable, errors) {
    if (!variable.value) {
      errors.push({ message: "Field is required." });
    }
  }
}
VariableValidatorService.addValidator(new StringValidator());

class VariableMetadataHelpField extends React__default.Component {
  render() {
    const content = this.getContent();
    const placement = content.split("\n").length > 10 ? "left" : "top";
    return /* @__PURE__ */ React__default.createElement(HelpField, {
      content,
      placement
    });
  }
  getContent() {
    let content = "";
    if (this.props.metadata.description) {
      content += `<p>${this.props.metadata.description}</p>`;
    }
    content += `<p><strong>Type:</strong> <span>${this.props.metadata.type}</span></p>`;
    if (this.props.metadata.example) {
      content += `<p><strong>Example:</strong> <br> <pre class="small">${this.props.metadata.example}</pre></p>`;
    }
    return content;
  }
}

var css_248z$l = ".pipeline-template-variable .add-new:hover,\n.pipeline-template-variable .add-new:focus,\n.pipeline-template-variable .add-new:active {\n  background-color: transparent;\n}\n.pipeline-template-variable code {\n  color: var(--color-black);\n  margin-right: 3px;\n  max-width: 100px;\n  word-break: break-all;\n}\n";
styleInject(css_248z$l);

class Variable extends React__default.Component {
  getVariableInput() {
    const input = VariableInputService.getInputForType(this.props.variableMetadata.type);
    return input ? input.getInput(this.props.variable, this.props.onChange) : null;
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "form-group clearfix pipeline-template-variable"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-4"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "pull-right"
    }, /* @__PURE__ */ React__default.createElement("code", null, this.props.variable.name), /* @__PURE__ */ React__default.createElement(VariableMetadataHelpField, {
      metadata: this.props.variableMetadata
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-7"
    }, this.getVariableInput())));
  }
}

const VARIABLE = "spinnaker.core.pipelineTemplate.variable.component";
module(VARIABLE, []).component("variable", react2angular(withErrorBoundary(Variable, "variable"), ["variableMetadata", "variable", "onChange"]));

const PIPELINE_TEMPLATE_MODULE = "spinnaker.core.pipelineTemplate.module";
module(PIPELINE_TEMPLATE_MODULE, [
  CONFIGURE_PIPELINE_TEMPLATE_MODAL_CTRL,
  CONFIGURE_PIPELINE_TEMPLATE_MODAL_V2_CTRL,
  TEMPLATE_PLAN_ERRORS,
  VARIABLE
]);

const initGoogleAnalytics = () => {
  if (!SETTINGS.analytics.ga)
    return;
  ReactGA.initialize(SETTINGS.analytics.ga, {});
  logger.subscribe({
    key: "googleAnalytics",
    onEvent: (event) => {
      var _a;
      ReactGA.event({ category: event.category, action: event.action, label: (_a = event.data) == null ? void 0 : _a.label });
    }
  });
};

const CORE_REGION_REGIONSELECTFIELD_DIRECTIVE = "spinnaker.core.region.regionSelectField.directive";
module(CORE_REGION_REGIONSELECTFIELD_DIRECTIVE, []).component("regionSelectFieldWrapper", react2angular(withErrorBoundary(RegionSelectField, "regionSelectFieldWrapper"), [
  "regions",
  "component",
  "field",
  "account",
  "provider",
  "onChange",
  "labelColumns",
  "fieldColumns",
  "readOnly"
])).component("regionSelectField", {
  controllerAs: "vm",
  template: `
      <region-select-field-wrapper regions="vm.regions"
                                   component="vm.component"
                                   field="vm.field"
                                   account="vm.account"
                                   provider="vm.provider"
                                   on-change="vm.propagate"
                                   label-columns="vm.labelColumns"
                                   field-columns="vm.fieldColumns"
                                   read-only="vm.readOnly"></react-region-select-field>
    `,
  bindings: {
    regions: "=",
    component: "=",
    field: "@",
    account: "=",
    provider: "=",
    onChange: "&",
    labelColumns: "<",
    fieldColumns: "<",
    readOnly: "="
  },
  controller: function() {
    this.$onInit = () => {
      const vm = this;
      vm.propagate = function(data) {
        vm.component[vm.field] = data;
        vm.onChange();
      };
    };
  }
});

const REGION_MODULE = "spinnaker.core.region.module";
module(REGION_MODULE, [CORE_REGION_REGIONSELECTFIELD_DIRECTIVE]);

const CORE_SERVERGROUP_CONFIGURE_COMMON_BASICSETTINGSMIXIN_CONTROLLER = "spinnaker.core.serverGroup.basicSettings.controller";
module(CORE_SERVERGROUP_CONFIGURE_COMMON_BASICSETTINGSMIXIN_CONTROLLER, [
  ANGULAR_UI_BOOTSTRAP,
  UIROUTER_ANGULARJS,
  IMAGE_READER
]).controller("BasicSettingsMixin", [
  "$scope",
  "imageReader",
  "$uibModalStack",
  "$state",
  function($scope, imageReader, $uibModalStack, $state) {
    this.createsNewCluster = function() {
      const name2 = this.getNamePreview();
      $scope.latestServerGroup = this.getLatestServerGroup();
      return !___default.find($scope.application.clusters, { name: name2 });
    };
    this.getNamePreview = function() {
      const command = $scope.command;
      if (!command) {
        return "";
      }
      return NameUtils.getClusterName($scope.application.name, command.stack, command.freeFormDetails);
    };
    this.getLatestServerGroup = function() {
      const command = $scope.command;
      const cluster = NameUtils.getClusterName($scope.application.name, command.stack, command.freeFormDetails);
      const inCluster = $scope.application.serverGroups.data.filter(function(serverGroup) {
        return serverGroup.cluster === cluster && serverGroup.account === command.credentials && serverGroup.region === command.region;
      }).sort(function(a, b) {
        return a.createdTime - b.createdTime;
      });
      return inCluster.length ? inCluster.pop() : null;
    };
    this.showPreviewAsWarning = function() {
      const mode = $scope.command.viewState.mode;
      const createsNewCluster = this.createsNewCluster();
      return mode === "create" && !createsNewCluster || mode !== "create" && createsNewCluster;
    };
    this.navigateToLatestServerGroup = function() {
      const latest = $scope.latestServerGroup;
      const params = {
        provider: $scope.command.selectedProvider,
        accountId: latest.account,
        region: latest.region,
        serverGroup: latest.name
      };
      $uibModalStack.dismissAll();
      if ($state.is("home.applications.application.insight.clusters")) {
        $state.go(".serverGroup", params);
      } else {
        $state.go("^.serverGroup", params);
      }
    };
    this.stackPattern = {
      test: function(stack) {
        const pattern = $scope.command.viewState.templatingEnabled ? /^([a-zA-Z_0-9._${}]*(\${.+})*)*$/ : /^[a-zA-Z_0-9._${}]*$/;
        return isNotExpressionLanguage(stack) ? pattern.test(stack) : true;
      }
    };
    this.detailPattern = {
      test: function(detail) {
        const pattern = $scope.command.viewState.templatingEnabled ? /^([a-zA-Z_0-9._${}-]*(\${.+})*)*$/ : /^[a-zA-Z_0-9._${}-]*$/;
        return isNotExpressionLanguage(detail) ? pattern.test(detail) : true;
      }
    };
    const isNotExpressionLanguage = (field) => {
      return field && !field.includes("${");
    };
  }
]);

const HEALTH_PERCENT_SELECTOR = "spinnaker.core.serverGroup.configure.wizard.capacity.targetHealthyPercentageSelector";
module(HEALTH_PERCENT_SELECTOR, []).component("targetHealthyPercentageSelector", {
  bindings: {
    command: "="
  },
  templateUrl: "core/src/serverGroup/configure/common/targetHealthyPercentageSelector.component.html",
  controller: () => {
  }
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/serverGroup/configure/common/targetHealthyPercentageSelector.component.html", `<div class="form-group form-inline" style="margin-top: 20px">
  <div class="col-md-12">
    Consider deployment successful when
    <input
      type="number"
      min="0"
      max="100"
      ng-model="$ctrl.command.targetHealthyDeployPercentage"
      class="form-control input-sm inline-number"
    />
    percent of instances are healthy.
  </div>
</div>
`);
}]);

var css_248z$k = "multiple-server-group {\n  display: block;\n  padding: 0 0 15px 0;\n  margin: 0 15px;\n  border-top: 1px solid var(--color-alto);\n}\nmultiple-server-group .server-group-name {\n  font-weight: 600;\n}\nmultiple-server-group .server-group-details {\n  display: inline;\n  padding-left: 26px;\n}\nmultiple-server-group:last-child {\n  border-bottom: 1px solid var(--color-alto);\n}\n";
styleInject(css_248z$k);

const CORE_SERVERGROUP_DETAILS_MULTIPLESERVERGROUP_COMPONENT = "spinnaker.core.serverGroup.details.multipleServerGroup.component";
module(CORE_SERVERGROUP_DETAILS_MULTIPLESERVERGROUP_COMPONENT, []).component("multipleServerGroup", {
  bindings: {
    serverGroup: "="
  },
  templateUrl: "core/src/serverGroup/details/multipleServerGroup.component.html"
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/serverGroup/details/multipleServerGroup.component.html", `<h5>
  <div class="server-group-name" ng-class="$ctrl.serverGroup.disabled ? 'disabled' : ''">
    <cloud-provider-logo provider="$ctrl.serverGroup.provider" height="'20px'" width="'20px'"></cloud-provider-logo>
    {{ $ctrl.serverGroup.name }}
  </div>
</h5>
<div class="server-group-details">
  <account-tag account="$ctrl.serverGroup.account"></account-tag>
  {{ $ctrl.serverGroup.region }}
  <health-counts container="$ctrl.serverGroup.instanceCounts"></health-counts>
</div>
`);
}]);

const CORE_SERVERGROUP_DETAILS_MULTIPLESERVERGROUPS_CONTROLLER = "spinnaker.core.serverGroup.details.multipleServerGroups.controller";
angular.module(CORE_SERVERGROUP_DETAILS_MULTIPLESERVERGROUPS_CONTROLLER, [
  UIROUTER_ANGULARJS,
  SERVER_GROUP_WRITER,
  PROVIDER_SERVICE_DELEGATE,
  CORE_SERVERGROUP_DETAILS_MULTIPLESERVERGROUP_COMPONENT
]).controller("MultipleServerGroupsCtrl", [
  "$scope",
  "$state",
  "serverGroupWriter",
  "providerServiceDelegate",
  "app",
  function($scope, $state, serverGroupWriter, providerServiceDelegate, app) {
    this.serverGroups = [];
    this.$onInit = () => {
      ProviderSelectionService.isDisabled(app).then((disabled) => {
        $scope.isDisabled = disabled;
      });
    };
    const getDescriptor = () => {
      let descriptor = this.serverGroups.length + " server group";
      if (this.serverGroups.length > 1) {
        descriptor += "s";
      }
      return descriptor;
    };
    const confirm = (submitMethodName, verbs) => {
      const descriptor = getDescriptor();
      const monitorInterval = this.serverGroups.length * 1e3;
      const taskMonitors = this.serverGroups.map((serverGroup) => {
        const provider = serverGroup.provider || serverGroup.type;
        const providerParamsMixin = providerServiceDelegate.hasDelegate(provider, "serverGroup.paramsMixin") ? providerServiceDelegate.getDelegate(provider, "serverGroup.paramsMixin") : {};
        let mixinParams = {};
        const mixinParamsFactory = providerParamsMixin[submitMethodName];
        if (mixinParamsFactory !== void 0) {
          mixinParams = mixinParamsFactory(serverGroup);
        }
        return {
          application: app,
          title: serverGroup.name,
          submitMethod: (params) => serverGroupWriter[submitMethodName](serverGroup, app, angular.extend(params, mixinParams)),
          monitorInterval
        };
      });
      ConfirmationModalService.confirm({
        header: "Really " + verbs.simplePresent.toLowerCase() + " " + descriptor + "?",
        buttonText: verbs.simplePresent + " " + descriptor,
        verificationLabel: 'Verify the number of server groups (<span class="verification-text">' + this.serverGroups.length + "</span>) to be " + verbs.futurePerfect.toLowerCase(),
        textToVerify: this.serverGroups.length + "",
        taskMonitorConfigs: taskMonitors,
        askForReason: true,
        multiTaskTitle: verbs.presentContinuous + " " + descriptor
      });
    };
    this.destroyServerGroups = () => {
      confirm("destroyServerGroup", {
        presentContinuous: "Destroying",
        simplePresent: "Destroy",
        futurePerfect: "Destroyed"
      });
    };
    this.disableServerGroups = () => {
      this.serverGroups = this.serverGroups.filter((group) => !group.disabled);
      confirm("disableServerGroup", {
        presentContinuous: "Disabling",
        simplePresent: "Disable",
        futurePerfect: "Disabled"
      });
    };
    this.enableServerGroups = () => {
      this.serverGroups = this.serverGroups.filter((group) => group.disabled);
      confirm("enableServerGroup", {
        presentContinuous: "Enabling",
        simplePresent: "Enable",
        futurePerfect: "Enabled"
      });
    };
    this.canDisable = () => this.serverGroups.some((group) => !group.disabled);
    this.canEnable = () => this.serverGroups.some((group) => group.disabled);
    const retrieveServerGroups = () => {
      this.serverGroups = ClusterState.multiselectModel.serverGroups.map((multiselectGroup) => {
        const group = _.cloneDeep(multiselectGroup);
        const match = app.serverGroups.data.find((check) => check.name === group.name && check.account === group.account && check.region === group.region);
        if (match) {
          group.instanceCounts = _.cloneDeep(match.instanceCounts);
          group.disabled = match.isDisabled;
        }
        return group;
      });
    };
    const multiselectWatcher = ClusterState.multiselectModel.serverGroupsStream.subscribe(retrieveServerGroups);
    app.serverGroups.onRefresh($scope, retrieveServerGroups);
    retrieveServerGroups();
    $scope.$on("$destroy", () => {
      if (this.serverGroups.length !== 1) {
        ClusterState.multiselectModel.clearAllServerGroups();
      }
      multiselectWatcher.unsubscribe();
    });
  }
]);

const VIEW_SCALING_ACTIVITIES_LINK = "spinnaker.core.serverGroup.details.viewScalingActivities.link";
module(VIEW_SCALING_ACTIVITIES_LINK, []).component("viewScalingActivitiesLink", react2angular(withErrorBoundary(ViewScalingActivitiesLink, "viewScalingActivitiesLink"), ["serverGroup"]));

const SERVER_GROUP_DATA_SOURCE = "spinnaker.core.serverGroup.dataSource";
module(SERVER_GROUP_DATA_SOURCE, [CLUSTER_SERVICE]).run([
  "$q",
  "clusterService",
  ($q, clusterService) => {
    const loadServerGroups = (application) => {
      return clusterService.loadServerGroups(application);
    };
    const addServerGroups = (application, serverGroups) => {
      serverGroups.forEach((serverGroup) => serverGroup.stringVal = JsonUtils.makeSortedStringFromAngularObject(serverGroup, [
        "executions",
        "runningTasks"
      ]));
      application.clusters = clusterService.createServerGroupClusters(serverGroups);
      const data = clusterService.addServerGroupsToApplication(application, serverGroups);
      clusterService.addTasksToServerGroups(application);
      clusterService.addExecutionsToServerGroups(application);
      return $q.when(data);
    };
    const addTags = (application) => {
      EntityTagsReader.addTagsToServerGroups(application);
      addManagedResourceMetadataToServerGroups(application);
    };
    ApplicationDataSourceRegistry.registerDataSource({
      key: "serverGroups",
      label: "Clusters",
      category: INFRASTRUCTURE_KEY,
      sref: ".insight.clusters",
      optional: true,
      primary: true,
      icon: "fas fa-xs fa-fw fa-th-large",
      iconName: "spMenuClusters",
      loader: loadServerGroups,
      onLoad: addServerGroups,
      afterLoad: addTags,
      providerField: "type",
      credentialsField: "account",
      regionField: "region",
      description: "Collections of server groups or jobs",
      defaultData: []
    });
  }
]);

const SERVER_GROUP_STATES = "spinnaker.core.serverGroup.states";
module(SERVER_GROUP_STATES, [APPLICATION_STATE_PROVIDER, STATE_CONFIG_PROVIDER]).config([
  "applicationStateProvider",
  "stateConfigProvider",
  (applicationStateProvider, stateConfigProvider) => {
    const clusters = {
      name: "clusters",
      url: `/clusters?${stateConfigProvider.paramsToQuery(filterModelConfig$4)}`,
      views: {
        nav: { component: ClusterFilters, $type: "react" },
        master: {
          templateUrl: "core/src/cluster/allClusters.html",
          controller: "AllClustersCtrl",
          controllerAs: "ctrl"
        }
      },
      params: stateConfigProvider.buildDynamicParams(filterModelConfig$4),
      data: {
        pageTitleSection: {
          title: "Clusters"
        }
      },
      children: []
    };
    const serverGroupDetails = {
      name: "serverGroup",
      url: "/serverGroupDetails/:provider/:accountId/:region/:serverGroup",
      views: {
        "detail@../insight": { component: ServerGroupDetailsWrapper, $type: "react" }
      },
      resolve: {
        serverGroup: [
          "$stateParams",
          ($stateParams) => {
            return {
              name: $stateParams.serverGroup,
              accountId: $stateParams.accountId,
              region: $stateParams.region
            };
          }
        ]
      },
      data: {
        pageTitleDetails: {
          title: "Server Group Details",
          nameParam: "serverGroup",
          accountParam: "accountId",
          regionParam: "region"
        },
        history: {
          type: "serverGroups"
        }
      }
    };
    const multipleServerGroups = {
      name: "multipleServerGroups",
      url: "/multipleServerGroups",
      views: {
        "detail@../insight": {
          templateUrl: "core/src/serverGroup/details/multipleServerGroups.view.html",
          controller: "MultipleServerGroupsCtrl",
          controllerAs: "vm"
        }
      },
      data: {
        pageTitleDetails: {
          title: "Multiple Server Groups"
        }
      }
    };
    applicationStateProvider.addInsightState(clusters);
    applicationStateProvider.addInsightDetailState(serverGroupDetails);
    applicationStateProvider.addInsightDetailState(multipleServerGroups);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/cluster/allClusters.html", `<div class="header row header-clusters" ng-if="ctrl.initialized">
  <div class="col-lg-9 col-md-10 col-sm-10">
    <div class="form-inline clearfix filters">
      <div class="form-group">
        <button
          class="btn btn-xs btn-default"
          ng-class="{active: filterModel.sortFilter.multiselect}"
          ng-click="ctrl.toggleMultiselect()"
          ng-hide="isDisabled"
        >
          <span class="glyphicon glyphicon-list visible-lg-inline"></span>
          <span class="glyphicon glyphicon-list visible-md-inline visible-sm-inline" uib-tooltip="Edit multiple"></span>
          <span class="visible-lg-inline">Edit multiple</span>
        </button>
      </div>
      <div class="form-group">
        <label class="checkbox">Show </label>
        <div class="checkbox">
          <label>
            <input
              type="checkbox"
              ng-model="filterModel.sortFilter.showAllInstances"
              ng-change="ctrl.syncUrlAndUpdateClusterGroups()"
            />
            Instances
          </label>
        </div>
        <div class="checkbox" is-visible="filterModel.sortFilter.showAllInstances">
          <label>
            <input
              type="checkbox"
              ng-model="filterModel.sortFilter.listInstances"
              ng-change="ctrl.syncUrlAndUpdateClusterGroups()"
            />
            with details
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-2 col-sm-2">
    <div class="application-actions">
      <button class="btn btn-sm btn-default" ng-click="ctrl.createServerGroup()" ng-hide="isDisabled">
        <span class="glyphicon glyphicon-plus-sign visible-lg-inline"></span>
        <span
          class="glyphicon glyphicon-plus-sign visible-md-inline visible-sm-inline"
          uib-tooltip="Create Server Group"
        ></span>
        <span class="visible-lg-inline">{{ctrl.createLabel}}</span>
      </button>
    </div>
  </div>
  <filter-tags
    ng-if="!ctrl.dataSource.fetchOnDemand"
    tags="tags"
    tag-cleared="ctrl.updateClusterGroups"
    clear-filters="ctrl.clearFilters"
  ></filter-tags>
</div>

<div ng-if="ctrl.dataSource.fetchOnDemand">
  <on-demand-cluster-picker application="ctrl.application"></on-demand-cluster-picker>
</div>

<div ng-if="ctrl.loadError">
  <h4 class="text-center">There was an error loading the clusters for this application. We'll try again shortly.</h4>
</div>

<!-- overflow-y is set to avoid flickering when scrollbars are set to always show (react virtualized thing) -->
<div ng-if="!ctrl.initialized">
  <loading-spinner size="medium"></loading-spinner>
</div>
<div ng-if="ctrl.initialized">
  <banner-container app="ctrl.application" />
</div>

<all-clusters-groupings
  class="content"
  app="ctrl.application"
  style="overflow-y: hidden"
  initialized="ctrl.initialized"
></all-clusters-groupings>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/serverGroup/details/multipleServerGroups.view.html", `<div class="details-panel">
  <div class="header">
    <div class="close-button">
      <a class="btn btn-link" ui-sref="^">
        <span class="glyphicon glyphicon-remove"></span>
      </a>
    </div>
    <div class="header-text">
      <span class="glyphicon glyphicon-th {{vm.healthState}}"></span>
      <h3>{{vm.serverGroups.length}} Server Group<span ng-if="vm.serverGroups.length !== 1">s</span></h3>
    </div>
    <div>
      <div class="actions">
        <div class="dropdown" uib-dropdown dropdown-append-to-body>
          <button
            type="button"
            class="btn btn-sm btn-primary dropdown-toggle"
            ng-disabled="disabled"
            ng-hide="isDisabled"
            uib-dropdown-toggle
          >
            Actions <span class="caret"></span>
          </button>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu">
            <li><a href ng-click="vm.destroyServerGroups()">Destroy</a></li>
            <li><a href ng-click="vm.disableServerGroups()" ng-if="vm.canDisable()">Disable</a></li>
            <li><a href ng-click="vm.enableServerGroups()" ng-if="vm.canEnable()">Enable</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="content">
    <multiple-server-group
      ng-repeat="serverGroup in vm.serverGroups"
      server-group="serverGroup"
    ></multiple-server-group>
  </div>
</div>
`);
}]);

var css_248z$j = ".table-search-results-server-groups .table-header .col-server-group,\n.table-search-results-server-groups .table-row .col-server-group {\n  width: 300px;\n}\n.table-search-results-server-groups .table-header .col-instance-counts .instance-health-counts,\n.table-search-results-server-groups .table-row .col-instance-counts .instance-health-counts {\n  float: none;\n}\n";
styleInject(css_248z$j);

const makeServerGroupTuples = (sgToFetch, fetched) => {
  const findFetchedValue = (toFetch) => fetched.find((sg) => sg.name === toFetch.serverGroup && sg.account === toFetch.account && sg.region === toFetch.region);
  return sgToFetch.map((toFetch) => ({ toFetch, fetched: findFetchedValue(toFetch) }));
};
const fetchServerGroups = (toFetch) => {
  const fetchPromise = REST("/serverGroups").query({ ids: toFetch.map((sg) => `${sg.account}:${sg.region}:${sg.serverGroup}`) }).get().then((fetched) => makeServerGroupTuples(toFetch, fetched));
  return from(fetchPromise);
};
const AddHealthCounts = (RawComponent) => {
  return class FetchHealthCounts extends React__default.Component {
    constructor(props) {
      super(props);
      this.state = { serverGroups: [] };
      this.results$ = new BehaviorSubject([]);
      this.stop$ = new Subject();
      const failedFetch = (failedFetches) => of(failedFetches.map((toFetch) => ({ toFetch, fetched: { instanceCounts: null } })));
      const processBatch = (batch) => fetchServerGroups(batch).pipe(catchError(() => failedFetch(batch)));
      this.results$.pipe(mergeMap((searchResults) => {
        return from(searchResults).pipe(filter((result) => result.instanceCounts === void 0), bufferCount(25), concatMap(processBatch));
      }), takeUntil(this.stop$)).subscribe((tuples) => {
        tuples.forEach((result) => result.toFetch.instanceCounts = result.fetched.instanceCounts);
        const resultSet = { ...this.props.resultSet, results: this.results$.value.slice() };
        this.setState({ resultSet });
      });
    }
    applyServerGroups(resultSet) {
      const itemSortFn = (a, b) => {
        const order = a.serverGroup.localeCompare(b.serverGroup);
        return order !== 0 ? order : a.region.localeCompare(b.region);
      };
      const serverGroups = resultSet.results.slice().sort(itemSortFn);
      this.results$.next(serverGroups);
      this.setState({ resultSet: { ...resultSet, results: serverGroups } });
    }
    componentDidMount() {
      this.applyServerGroups(this.props.resultSet);
    }
    componentWillReceiveProps(nextProps) {
      this.applyServerGroups(nextProps.resultSet);
    }
    componentWillUnmount() {
      this.stop$.next();
      this.stop$.complete();
    }
    render() {
      return /* @__PURE__ */ React__default.createElement(RawComponent, {
        resultSet: this.props.resultSet
      });
    }
  };
};
class ServerGroupSearchResultType extends SearchResultType {
  constructor() {
    super(...arguments);
    this.id = "serverGroups";
    this.order = 3;
    this.displayName = "Server Groups";
    this.iconClass = "fa fa-th-large";
    this.cols = {
      SERVERGROUP: { key: "serverGroup", label: "Name" },
      ACCOUNT: { key: "account" },
      REGION: { key: "region" },
      EMAIL: { key: "email" },
      HEALTH: { key: "instanceCounts", label: "Health" }
    };
    this.TabComponent = DefaultSearchResultTab;
    this.HeaderComponent = () => /* @__PURE__ */ React__default.createElement(SearchTableHeader, null, /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.SERVERGROUP
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.ACCOUNT
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.REGION
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.EMAIL
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.HEALTH
    }));
    this.RawDataComponent = ({ resultSet }) => {
      const itemKeyFn = (item) => [item.serverGroup, item.account, item.region].join("|");
      const results = resultSet.results.slice();
      return /* @__PURE__ */ React__default.createElement(SearchTableBody, null, results.map((item) => /* @__PURE__ */ React__default.createElement(SearchTableRow, {
        key: itemKeyFn(item)
      }, /* @__PURE__ */ React__default.createElement(HrefCell, {
        item,
        col: this.cols.SERVERGROUP
      }), /* @__PURE__ */ React__default.createElement(AccountCell, {
        item,
        col: this.cols.ACCOUNT
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.REGION
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.EMAIL
      }), /* @__PURE__ */ React__default.createElement(HealthCountsCell, {
        item,
        col: this.cols.HEALTH
      }))));
    };
    this.DataComponent = AddHealthCounts(this.RawDataComponent);
  }
  displayFormatter(searchResult) {
    return `${searchResult.serverGroup} (${searchResult.region})`;
  }
}
searchResultTypeRegistry.register(new ServerGroupSearchResultType());

const SERVERGROUP_MODULE = "spinnaker.core.serverGroup";
module(SERVERGROUP_MODULE, [
  CORE_SERVERGROUP_SERVERGROUP_TRANSFORMER,
  SERVER_GROUP_CONFIGURATION_SERVICE,
  V2_INSTANCE_ARCHETYPE_SELECTOR,
  V2_INSTANCE_TYPE_SELECTOR,
  CORE_SERVERGROUP_DETAILS_MULTIPLESERVERGROUPS_CONTROLLER,
  SERVER_GROUP_DATA_SOURCE,
  CORE_SERVERGROUP_CONFIGURE_COMMON_BASICSETTINGSMIXIN_CONTROLLER,
  SERVER_GROUP_STATES,
  VIEW_SCALING_ACTIVITIES_LINK,
  DEPLOY_INITIALIZER_COMPONENT,
  HEALTH_PERCENT_SELECTOR
]);

const SERVER_GROUP_MANAGER_MODULE = "spinnaker.core.serverGroupManager.module";
module(SERVER_GROUP_MANAGER_MODULE, [SERVER_GROUP_MANAGER_DATA_SOURCE, SERVER_GROUP_MANAGER_STATES]);

const STYLEGUIDE_STATES = "spinnaker.core.styleguide.states";
module(STYLEGUIDE_STATES, [STATE_CONFIG_PROVIDER]).config([
  "stateConfigProvider",
  (stateConfigProvider) => {
    const styleguideState = {
      url: "/styleguide",
      name: "styleguide",
      views: {
        "main@": {
          templateUrl: "/styleguide.html"
        }
      },
      data: {
        pageTitleSection: {
          title: "Styleguide"
        }
      }
    };
    stateConfigProvider.addToRootState(styleguideState);
  }
]);

module("spinnaker.core.styleguide", [STYLEGUIDE_STATES]);
const STYLEGUIDE_MODULE = "spinnaker.core.styleguide";

const CORE_SUBNET_SUBNETTAG_COMPONENT = "spinnaker.core.subnet.tag.component";
module(CORE_SUBNET_SUBNETTAG_COMPONENT, []).component("subnetTag", react2angular(withErrorBoundary(SubnetTag, "subnetTag"), ["subnetId"]));

const SUBNET_MODULE = "spinnaker.core.subnet.module";
module(SUBNET_MODULE, [CORE_SUBNET_SUBNETTAG_COMPONENT]);

class LabelCtrl {
  $onInit() {
    this.value = FirewallLabels.get(this.label);
  }
}
const FIREWALL_LABEL_COMPONENT = "spinnaker.core.firewall.label.component";
module(FIREWALL_LABEL_COMPONENT, []).component("firewallLabel", {
  bindings: {
    label: "@"
  },
  controller: LabelCtrl,
  template: `<span>{{$ctrl.value}}</span>`
});

const LABEL_FILTER_COMPONENT = "spinnaker.core.labelFilter.component";
module(LABEL_FILTER_COMPONENT, []).component("labelFilter", react2angular(withErrorBoundary(LabelFilter, "labelFilter"), ["labelsMap", "labelFilters", "updateLabelFilters"]));

const CORE_WIDGETS_ACCOUNTNAMESPACECLUSTERSELECTOR_COMPONENT = "spinnaker.core.accountNamespaceClusterSelector.directive";
module(CORE_WIDGETS_ACCOUNTNAMESPACECLUSTERSELECTOR_COMPONENT, []).directive("accountNamespaceClusterSelector", function() {
  return {
    restrict: "E",
    scope: {},
    bindToController: {
      application: "=",
      component: "=",
      accounts: "=",
      clusterField: "@",
      provider: "="
    },
    templateUrl: "core/src/widgets/accountNamespaceClusterSelector.component.html",
    controllerAs: "vm",
    controller: function controller() {
      this.$onInit = () => {
        this.clusterField = this.clusterField || "cluster";
        const vm = this;
        let isTextInputForClusterFiled;
        let namespaces;
        const setNamespaceList = () => {
          const accountFilter = (cluster) => cluster ? cluster.account === vm.component.credentials : true;
          const namespaceList = AppListExtractor.getRegions([vm.application], accountFilter);
          vm.namespaces = namespaceList.length ? namespaceList : namespaces;
        };
        const setClusterList = () => {
          const namespaceField = vm.component.namespaces;
          const clusterFilter = AppListExtractor.clusterFilterForCredentialsAndRegion(vm.component.credentials, namespaceField);
          vm.clusterList = AppListExtractor.getClusters([vm.application], clusterFilter);
        };
        vm.namespaceChanged = () => {
          setClusterList();
          if (!isTextInputForClusterFiled && !___default.includes(vm.clusterList, vm.component[this.clusterField])) {
            vm.component[this.clusterField] = void 0;
          }
        };
        const setToggledState = () => {
          vm.namespaces = namespaces;
          isTextInputForClusterFiled = true;
        };
        const setUnToggledState = () => {
          vm.component[this.clusterField] = void 0;
          isTextInputForClusterFiled = false;
          setNamespaceList();
        };
        vm.clusterSelectInputToggled = (isToggled) => {
          isToggled ? setToggledState() : setUnToggledState();
        };
        vm.accountUpdated = () => {
          vm.component[this.clusterField] = void 0;
          setNamespaceList();
          setClusterList();
        };
        const init = () => {
          AccountService.getUniqueAttributeForAllAccounts(vm.component.cloudProviderType, "namespaces").then((allNamespaces) => {
            namespaces = allNamespaces;
            return allNamespaces;
          }).then((allNamespaces) => {
            setNamespaceList();
            setClusterList();
            vm.namespaces = ___default.includes(vm.clusterList, vm.component[this.clusterField]) ? vm.namespaces : allNamespaces;
          });
        };
        init();
      };
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/widgets/accountNamespaceClusterSelector.component.html", `<stage-config-field label="Account">
  <account-select-field
    component="vm.component"
    field="credentials"
    accounts="vm.accounts"
    provider="vm.provider"
    on-change="vm.accountUpdated()"
    required
  >
  </account-select-field>
</stage-config-field>
<stage-config-field label="Namespaces">
  <p ng-if="!vm.component.credentials" class="form-control-static">(Select an Account)</p>
  <checklist
    ng-if="vm.component.credentials"
    items="vm.namespaces"
    model="vm.component.namespaces"
    inline="true"
    on-change="vm.namespaceChanged()"
    include-select-all-button="true"
  >
  </checklist>
</stage-config-field>
<stage-config-field label="Cluster" help-key="pipeline.config.findAmi.cluster">
  <cluster-selector
    clusters="vm.clusterList"
    model="vm.component[vm.clusterField]"
    toggled="vm.clusterSelectInputToggled(isToggled)"
  >
  </cluster-selector>
</stage-config-field>
`);
}]);

const CORE_WIDGETS_ACCOUNTREGIONCLUSTERSELECTOR_COMPONENT = "spinnaker.core.accountRegionClusterSelector.directive";
module(CORE_WIDGETS_ACCOUNTREGIONCLUSTERSELECTOR_COMPONENT, []).directive("accountRegionClusterSelector", function() {
  return {
    restrict: "E",
    scope: {},
    bindToController: {
      application: "=",
      component: "=",
      accounts: "=",
      clusterField: "@",
      singleRegion: "=",
      showAllRegions: "=?",
      onAccountUpdate: "&?",
      disableRegionSelect: "=?",
      showClusterSelect: "=?"
    },
    templateUrl: "core/src/widgets/accountRegionClusterSelector.component.html",
    controllerAs: "vm",
    controller: function controller() {
      this.$onInit = () => {
        this.clusterField = this.clusterField || "cluster";
        const vm = this;
        if (vm.showClusterSelect === void 0) {
          vm.showClusterSelect = true;
        }
        const showAllRegions = vm.showAllRegions || false;
        let isTextInputForClusterFiled;
        let regions;
        const setRegionList = () => {
          const accountFilter = (cluster) => cluster ? cluster.account === vm.component.credentials : true;
          const regionList = AppListExtractor.getRegions([vm.application], accountFilter);
          vm.regions = showAllRegions ? regions : regionList.length ? regionList : regions;
          (vm.regions || []).sort();
        };
        const setClusterList = () => {
          const regionField = this.singleRegion ? vm.component.region : vm.component.regions;
          const clusterFilter = AppListExtractor.clusterFilterForCredentialsAndRegion(vm.component.credentials, regionField);
          vm.clusterList = AppListExtractor.getClusters([vm.application], clusterFilter);
        };
        vm.regionChanged = () => {
          setClusterList();
          if (!isTextInputForClusterFiled && !___default.includes(vm.clusterList, vm.component[this.clusterField])) {
            vm.component[this.clusterField] = void 0;
          }
        };
        const setToggledState = () => {
          vm.regions = regions;
          isTextInputForClusterFiled = true;
        };
        const setUnToggledState = () => {
          vm.component[this.clusterField] = void 0;
          isTextInputForClusterFiled = false;
          setRegionList();
        };
        vm.clusterSelectInputToggled = (isToggled) => {
          isToggled ? setToggledState() : setUnToggledState();
        };
        vm.clusterChanged = (clusterName) => {
          const filterByCluster = AppListExtractor.monikerClusterNameFilter(clusterName);
          const clusterMoniker = ___default.first(___default.uniq(AppListExtractor.getMonikers([vm.application], filterByCluster)));
          if (___default.isNil(clusterMoniker)) {
            vm.component.moniker = void 0;
          } else {
            clusterMoniker.sequence = null;
            vm.component.moniker = clusterMoniker;
          }
        };
        vm.accountUpdated = () => {
          vm.component[this.clusterField] = void 0;
          setRegionList();
          setClusterList();
          if (vm.onAccountUpdate) {
            vm.onAccountUpdate();
          }
        };
        const init = () => {
          AccountService.getUniqueAttributeForAllAccounts(vm.component.cloudProviderType, "regions").then((allRegions) => {
            regions = allRegions;
            const regionObjs = ___default.filter(regions, (region) => ___default.isObject(region));
            if (regionObjs.length) {
              const oldStyleRegions = ___default.chain(regionObjs).map((regionObj) => ___default.keys(regionObj)).flatten().value();
              regions = ___default.chain(regions).difference(regionObjs).union(oldStyleRegions).value();
            }
            return regions.sort();
          }).then((allRegions) => {
            setRegionList();
            setClusterList();
            vm.regions = ___default.includes(vm.clusterList, vm.component[this.clusterField]) ? vm.regions : allRegions;
          });
        };
        init();
      };
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/widgets/accountRegionClusterSelector.component.html", `<stage-config-field label="Account">
  <account-select-field
    component="vm.component"
    field="credentials"
    accounts="vm.accounts"
    provider="'aws'"
    on-change="vm.accountUpdated()"
    required
  >
  </account-select-field>
</stage-config-field>
<stage-config-field label="{{ vm.singleRegion ? 'Region' : 'Regions' }}">
  <p ng-if="!vm.component.credentials" class="form-control-static">(Select an Account)</p>
  <select
    class="form-control input-sm"
    ng-if="vm.component.credentials && vm.singleRegion"
    ng-model="vm.component.region"
    ng-change="vm.regionChanged()"
    ng-disabled="vm.disableRegionSelect"
    ng-options="region for region in vm.regions"
    required
  ></select>
  <checklist
    ng-if="vm.component.credentials && !vm.singleRegion"
    items="vm.regions"
    model="vm.component.regions"
    inline="true"
    on-change="vm.regionChanged()"
    include-select-all-button="true"
  >
  </checklist>
</stage-config-field>
<div ng-if="vm.showClusterSelect">
  <stage-config-field label="Cluster" help-key="pipeline.config.findAmi.cluster">
    <cluster-selector
      clusters="vm.clusterList"
      model="vm.component[vm.clusterField]"
      toggled="vm.clusterSelectInputToggled(isToggled)"
      on-change="vm.clusterChanged(clusterName)"
    >
    </cluster-selector>
  </stage-config-field>
</div>
`);
}]);

const CORE_WIDGETS_ACTIONICONS_ACTIONICONS_COMPONENT = "spinnaker.core.actionIcons.component";
angular.module(CORE_WIDGETS_ACTIONICONS_ACTIONICONS_COMPONENT, []).component("actionIcons", {
  bindings: {
    edit: "&",
    editInfo: "@",
    destroy: "&",
    destroyInfo: "@"
  },
  templateUrl: "core/src/widgets/actionIcons/actionIcons.component.html",
  controller: angular.noop
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/widgets/actionIcons/actionIcons.component.html", `<div class="actions">
  <button class="btn btn-xs btn-link" ng-click="$ctrl.edit()">
    <span class="glyphicon glyphicon-cog" uib-tooltip="{{:: $ctrl.editInfo }}"></span>
    <span class="sr-only">{{:: $ctrl.editInfo }}</span>
  </button>
  <button ng-click="$ctrl.destroy()" class="btn btn-xs btn-link">
    <span class="glyphicon glyphicon-trash" uib-tooltip="{{:: $ctrl.destroyInfo }}"></span>
    <span class="sr-only">{{:: $ctrl.destroyInfo }}</span>
  </button>
</div>
`);
}]);

const CORE_WIDGETS_SCOPECLUSTERSELECTOR_DIRECTIVE = "spinnaker.widget.clusterSelector.directive";
angular.module(CORE_WIDGETS_SCOPECLUSTERSELECTOR_DIRECTIVE, []).directive("clusterSelector", function() {
  return {
    restrict: "E",
    scope: {},
    bindToController: {
      model: "=",
      clusters: "=",
      required: "=?",
      toggled: "&?",
      onChange: "&?"
    },
    controllerAs: "vm",
    controller: function controller() {
      const vm = this;
      vm.toggled = vm.toggled || angular.noop;
      vm.onChange = vm.onChange || angular.noop;
      vm.required = vm.required || false;
      const selectedNotInClusterList = () => {
        return !(angular.isArray(vm.clusters) && vm.clusters.length && vm.clusters.some((cluster) => cluster === vm.model));
      };
      const modelIsSet = () => {
        return vm.model !== void 0 || vm.model !== null || vm.model.trim() !== "";
      };
      vm.clusterChanged = function() {
        vm.onChange({ clusterName: vm.model });
      };
      vm.freeFormClusterField = modelIsSet() ? selectedNotInClusterList() : false;
      vm.toggleFreeFormClusterField = function(event) {
        event.preventDefault();
        vm.freeFormClusterField = !vm.freeFormClusterField;
        vm.toggled({ isToggled: vm.freeFormClusterField });
      };
    },
    templateUrl: "core/src/widgets/scopeClusterSelector.directive.html"
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/widgets/scopeClusterSelector.directive.html", `<div>
  <div>
    <select
      name="stacks"
      class="form-control input-sm"
      ng-model="vm.model"
      ng-change="vm.clusterChanged()"
      ng-if="!vm.freeFormClusterField"
      ng-required="vm.required"
    >
      <option ng-repeat="cluster in vm.clusters" value="{{cluster}}" ng-selected="vm.model === cluster">
        {{cluster}}
      </option>
    </select>

    <input
      type="text"
      class="form-control input-sm"
      ng-if="vm.freeFormClusterField"
      ng-required="vm.required"
      ng-model="vm.model"
      ng-blur="vm.clusterChanged()"
    />
  </div>

  <div class="pull-right">
    <a href ng-click="vm.toggleFreeFormClusterField($event)" ng-if="!vm.freeFormClusterField">Toggle for text input</a>
    <a href ng-click="vm.toggleFreeFormClusterField($event)" ng-if="vm.freeFormClusterField"
      >Toggle for list of existing clusters
    </a>
  </div>
</div>
`);
}]);

const CORE_WIDGETS_SPELTEXT_SPELSELECT_COMPONENT = "spinnaker.widgets.spelSelect.component";
module(CORE_WIDGETS_SPELTEXT_SPELSELECT_COMPONENT, []).component("spelSelect", {
  template: `
      <div class="navbar-form" style="padding: 0 ;">
        <div class="button-input" ng-class="{select: $ctrl.selectActive, text: $ctrl.textActive, focus: $ctrl.isGlowing}">
          <span class="btn-group btn-group-xs" role="group">
            <button type="button"
              class="btn btn-default"
              ng-click="$ctrl.toggleSelect()"
              ng-class="{active: $ctrl.selectActive}"
              ng-focus="$ctrl.glow(true)"
              ng-blur="$ctrl.glow(false)"
              uib-tooltip="Toggle for select">
              <span class="glyphicon glyphicon-triangle-bottom" style="font-size: 75%"></span>
              </button>
            <button type="button"
              class="btn btn-default"
              ng-click="$ctrl.toggleText()"
              ng-class="{active: $ctrl.expressionActive}"
              ng-focus="$ctrl.glow(true)"
              ng-blur="$ctrl.glow(false)"
              uib-tooltip="Toggle to enter expression">
              \${\u2026}
              </button>
          </span>
          <input
            ng-if="$ctrl.expressionActive"
            type="text" class="form-control borderless"
            ng-model="$ctrl.model" ng-focus="$ctrl.glow(true)"
            ng-blur="$ctrl.glow(false)"
          />
          <div
            ng-transclude
            ng-if="$ctrl.selectActive"
            class="borderless input"
            ng-focus="$ctrl.glow(true)"
            ng-blur="$ctrl.glow(false)"
            >
          </div>

        </div>
      </div>
      `,
  bindings: {
    model: "="
  },
  transclude: true,
  controller: function() {
    const ctrl = this;
    const select = "select";
    const textType = "text";
    const setState = (inputType) => {
      if (inputType == textType) {
        ctrl.expressionActive = true;
        ctrl.selectActive = false;
      } else {
        ctrl.selectActive = true;
        ctrl.expressionActive = false;
      }
    };
    ctrl.$onInit = () => {
      ctrl.inputType = ctrl.model && ctrl.model.includes("${") ? textType : select;
      setState(ctrl.inputType);
    };
    ctrl.toggleSelect = () => {
      setState(select);
    };
    ctrl.toggleText = () => {
      setState(textType);
    };
    ctrl.glow = (isGlowing) => {
      ctrl.isGlowing = isGlowing;
    };
  }
});

const CORE_WIDGETS_SPELTEXT_SPELAUTOCOMPLETE_SERVICE = "spinnaker.core.widget.spelAutocomplete";
module(CORE_WIDGETS_SPELTEXT_SPELAUTOCOMPLETE_SERVICE, [EXECUTION_SERVICE]).factory("spelAutocomplete", [
  "$q",
  "executionService",
  ($q, executionService) => {
    const autocomplete = new SpelAutocompleteService($q, executionService);
    return {
      textcompleteConfig: autocomplete.textcompleteConfig,
      addPipelineInfo: (pipelineConfig) => autocomplete.addPipelineInfo(pipelineConfig)
    };
  }
]);

decorateFn.$inject = ["$delegate", "spelAutocomplete"];
function decorateFn($delegate, spelAutocomplete) {
  const directive = $delegate[0];
  const link = directive.link.pre;
  directive.compile = function() {
    return function(scope, el) {
      link.apply(this, arguments);
      const type = el.attr("type");
      if (type === "checkbox" || type === "radio" || type === "search" || el.closest(".no-spel").length) {
        return;
      }
      el.attr("contenteditable", true);
      spelAutocomplete.addPipelineInfo(scope.pipeline).then((textcompleteConfig) => {
        el.textcomplete && el.textcomplete(textcompleteConfig, {
          maxCount: 1e3,
          zIndex: 5e3,
          dropdownClassName: "dropdown-menu textcomplete-dropdown spel-dropdown"
        });
      });
      function listener(evt) {
        if ($(evt.target).hasClass("no-doc-link")) {
          return;
        }
        const hasSpelPrefix = evt.target.value.includes("$");
        const parent = el.parent();
        const hasLink = parent && parent.nextAll && parent.nextAll(".spelLink");
        if (hasSpelPrefix) {
          if (hasLink.length < 1) {
            el.parent().after('<a class="spelLink" href="http://spinnaker.github.io/guides/user/pipeline-expressions" target="_blank">Expression Docs</a>');
            el.addClass("monospace");
          }
        } else {
          el.removeClass("monospace");
          hasLink.fadeOut(500, function() {
            this.remove();
          });
        }
      }
      el.bind("keyup", listener);
    };
  };
  return $delegate;
}
const CORE_WIDGETS_SPELTEXT_SPELTEXT_DECORATOR = "spinnaker.core.widget.spelText";
module(CORE_WIDGETS_SPELTEXT_SPELTEXT_DECORATOR, [CORE_WIDGETS_SPELTEXT_SPELAUTOCOMPLETE_SERVICE]).config([
  "$provide",
  function($provide) {
    $provide.decorator("inputDirective", decorateFn);
    $provide.decorator("textareaDirective", decorateFn);
  }
]);

const WIDGETS_MODULE = "spinnaker.core.widgets";
module(WIDGETS_MODULE, [
  CORE_WIDGETS_ACCOUNTNAMESPACECLUSTERSELECTOR_COMPONENT,
  CORE_WIDGETS_ACCOUNTREGIONCLUSTERSELECTOR_COMPONENT,
  ACCOUNT_REGION_CLUSTER_SELECTOR_WRAPPER,
  CORE_WIDGETS_SCOPECLUSTERSELECTOR_DIRECTIVE,
  CORE_WIDGETS_SPELTEXT_SPELTEXT_DECORATOR,
  CORE_WIDGETS_SPELTEXT_SPELSELECT_COMPONENT,
  CORE_WIDGETS_ACTIONICONS_ACTIONICONS_COMPONENT
]);

const CORE_FORMS_AUTOFOCUS_AUTOFOCUS_DIRECTIVE = "spinnaker.core.forms.autoFocus.directive";
module(CORE_FORMS_AUTOFOCUS_AUTOFOCUS_DIRECTIVE, []).directive("autoFocus", [
  "$timeout",
  function($timeout) {
    return {
      restrict: "A",
      link: function(scope, elem, attrs) {
        if (scope.$eval(attrs.autoFocus)) {
          $timeout(() => elem.focus());
        }
      }
    };
  }
]);

const CORE_FORMS_CHECKLIST_CHECKLIST_DIRECTIVE = "spinnaker.core.forms.checklist.checklist.directive";
angular.module(CORE_FORMS_CHECKLIST_CHECKLIST_DIRECTIVE, []).directive("checklist", () => {
  return {
    restrict: "E",
    templateUrl: "core/src/forms/checklist/checklist.directive.html",
    scope: {
      items: "=",
      model: "=",
      onChange: "&",
      inline: "=",
      includeSelectAllButton: "="
    },
    link: (scope) => {
      function initializeModelHolder() {
        scope.values = scope.values || {};
        scope.itemsNormalized = scope.itemsNormalized || [];
        scope.model = scope.model || [];
        scope.modelHolder = {};
        scope.model.forEach((val) => {
          scope.modelHolder[val] = true;
        });
      }
      function updateModel() {
        const updatedModel = [];
        scope.itemsNormalized.forEach((testKey) => {
          if (scope.modelHolder[testKey]) {
            updatedModel.push(testKey);
          }
        });
        angular.copy(updatedModel, scope.model);
        if (scope.onChange) {
          scope.$evalAsync(scope.onChange);
        }
      }
      function allItemsSelected() {
        let allSelected = true;
        scope.itemsNormalized.forEach((key) => {
          if (!scope.modelHolder[key]) {
            allSelected = false;
          }
        });
        return allSelected;
      }
      function normalizeItems(items) {
        if (items) {
          if (_.isMap(items)) {
            items.forEach((value, key) => {
              scope.values[key] = value;
            });
            scope.itemsNormalized = Array.from(items, ([key]) => key);
          } else {
            items.forEach((item) => {
              scope.values[item] = item;
            });
            scope.itemsNormalized = items;
          }
        }
      }
      scope.selectAllOrNone = () => {
        if (allItemsSelected()) {
          scope.itemsNormalized.forEach((key) => {
            scope.modelHolder[key] = false;
          });
        } else {
          scope.itemsNormalized.forEach((key) => {
            scope.modelHolder[key] = true;
          });
        }
        updateModel();
      };
      scope.selectButtonText = () => {
        if (allItemsSelected()) {
          return "Deselect All";
        }
        return "Select All";
      };
      scope.allItemsSelected = allItemsSelected;
      scope.updateModel = updateModel;
      scope.$watch("model", initializeModelHolder);
      scope.$watch("items", (newOptions, oldOptions) => {
        normalizeItems(newOptions);
        if (oldOptions && oldOptions !== newOptions) {
          oldOptions.forEach((oldOption, oldKey) => {
            if (_.isMap(newOptions)) {
              if (!newOptions.has(oldKey)) {
                delete scope.modelHolder[oldKey];
              }
            } else {
              if (!newOptions.includes(oldOption)) {
                delete scope.modelHolder[oldOption];
              }
            }
          });
          updateModel();
        }
      });
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/forms/checklist/checklist.directive.html", `<ul class="checklist" ng-if="!inline">
  <li ng-repeat="item in itemsNormalized">
    <label>
      <input ng-model="modelHolder[item]" type="checkbox" ng-change="updateModel()" ng-checked="!!modelHolder[item]" />
      {{values[item]}}
    </label>
  </li>
  <li ng-if="includeSelectAllButton && itemsNormalized.length > 1">
    <a href class="btn btn-default btn-xs push-left" type="button" ng-click="selectAllOrNone()"
      >{{selectButtonText()}}</a
    >
  </li>
</ul>
<label ng-if="inline" class="checkbox-inline" ng-repeat="item in itemsNormalized">
  <input type="checkbox" ng-checked="!!modelHolder[item]" ng-model="modelHolder[item]" ng-change="updateModel()" />
  {{values[item]}}
</label>
<a
  href
  class="btn btn-default btn-xs"
  style="margin: 8px 0 0 10px"
  ng-if="inline && includeSelectAllButton && itemsNormalized.length > 1"
  ng-click="selectAllOrNone()"
  >{{selectButtonText()}}</a
>
`);
}]);

const CORE_FORMS_CHECKMAP_CHECKMAP_DIRECTIVE = "spinnaker.core.forms.checkmap.checkmap.directive";
angular.module(CORE_FORMS_CHECKMAP_CHECKMAP_DIRECTIVE, []).directive("checkmap", function() {
  return {
    restrict: "E",
    templateUrl: "core/src/forms/checkmap/checkmap.directive.html",
    scope: {
      itemMap: "=",
      selectedItems: "=",
      onChange: "&"
    },
    link: function(scope) {
      function initializeModelHolder() {
        scope.selectedItems = scope.selectedItems || [];
        scope.modelHolder = {};
        ___default.forEach(scope.itemMap, function(itemList, key) {
          scope.modelHolder[key] = {};
          ___default.forEach(itemList, function(item) {
            scope.modelHolder[key][item] = ___default.includes(scope.selectedItems, item);
          });
        });
        ___default.forEach(scope.selectedItems, function(selectedItem) {
          ___default.forEach(scope.modelHolder, function(itemList, key) {
            if (___default.includes(itemList, selectedItem)) {
              scope.modelHolder[key][selectedItem] = true;
            }
          });
        });
      }
      function updateSelectedItems() {
        const newSelectedItems = [];
        ___default.forEach(scope.modelHolder, function(valMap) {
          ___default.forEach(valMap, function(selected, item) {
            if (selected) {
              newSelectedItems.push(item);
            }
          });
        });
        angular.copy(newSelectedItems, scope.selectedItems);
        if (scope.onChange) {
          scope.$evalAsync(scope.onChange);
        }
      }
      scope.updateSelectedItems = updateSelectedItems;
      scope.$watch("itemMap", initializeModelHolder);
      scope.$watch("selectedItems", initializeModelHolder);
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/forms/checkmap/checkmap.directive.html", `<ul class="checkmap">
  <li ng-repeat="(key, valList) in itemMap" class="checkmap-group">
    <ul class="checkmap">
      <li class="checkmap-header">{{key}}</li>
      <li ng-repeat="item in valList">
        <label>
          <input
            type="checkbox"
            ng-checked="!!modelHolder[key][item]"
            ng-model="modelHolder[key][item]"
            ng-change="updateSelectedItems()"
          />
          {{item}}
        </label>
      </li>
    </ul>
  </li>
</ul>
`);
}]);

const CORE_FORMS_IGNOREEMPTYDELETE_DIRECTIVE = "spinnaker.core.utils.ignoreEmptyDelete.directive";
module(CORE_FORMS_IGNOREEMPTYDELETE_DIRECTIVE, [UI_SELECT]).config([
  "$provide",
  function($provide) {
    $provide.decorator("uiSelectMultipleDirective", [
      "$delegate",
      function($delegate) {
        const directive = $delegate[0];
        const originalLink = directive.link;
        directive.compile = function() {
          return function(scope, elem, attrs, ctrls) {
            originalLink.apply(this, arguments);
            const $select = ctrls[0];
            function ignoreDelete(e) {
              const key = e.which;
              if (key === 8 || key === 46) {
                if (!$select.searchInput.val().length) {
                  e.preventDefault();
                  e.stopPropagation();
                  if (e.originalEvent) {
                    e.originalEvent.preventDefault();
                    e.originalEvent.stopPropagation();
                  }
                  $select.activate(false, true);
                }
              }
            }
            const events = "keydown.ignoreEmptyDelete keyup.ignoreEmptyDelete";
            $select.searchInput.on(events, ignoreDelete);
            if ($select.focusser) {
              $select.focusser.on(events, ignoreDelete);
            }
          };
        };
        return $delegate;
      }
    ]);
  }
]);

const CORE_VALIDATION_VALIDATEUNIQUE_DIRECTIVE = "spinnaker.core.validation.unique.directive";
module(CORE_VALIDATION_VALIDATEUNIQUE_DIRECTIVE, []).directive("validateUnique", function() {
  return {
    restrict: "A",
    require: "ngModel",
    link: function(scope, elem, attr, ctrl) {
      scope.$watch(attr.validateUnique, function(newVal, oldVal) {
        if (newVal !== oldVal && (ctrl.$viewValue || ctrl.$dirty)) {
          ctrl.$validate();
        }
      }, true);
      const uniqueValidator = function(value) {
        let options = scope.$eval(attr.validateUnique) || [];
        let test = value;
        if (attr.validateIgnoreCase === "true") {
          options = options.map(function(option) {
            return option ? option.toLowerCase() : null;
          });
          test = value ? value.toLowerCase() : value;
        }
        return !options.includes(test);
      };
      ctrl.$validators.validateUnique = uniqueValidator;
    }
  };
});

var css_248z$i = "map-editor .table.no-border-top {\n  border-top: 2px solid var(--color-white);\n}\nmap-editor .table.no-border-top .table-label {\n  padding: 0.8rem 0 0 1rem;\n}\n";
styleInject(css_248z$i);

const CORE_FORMS_MAPEDITOR_MAPEDITOR_COMPONENT = "spinnaker.core.forms.mapEditor.component";
angular.module(CORE_FORMS_MAPEDITOR_MAPEDITOR_COMPONENT, [CORE_VALIDATION_VALIDATEUNIQUE_DIRECTIVE]).component("mapEditor", {
  bindings: {
    model: "=",
    keyLabel: "@",
    valueLabel: "@",
    addButtonLabel: "@",
    allowEmpty: "=?",
    onChange: "&",
    labelsLeft: "<?",
    label: "@",
    hiddenKeys: "<"
  },
  controller: [
    "$scope",
    function($scope) {
      this.backingModel = [];
      const modelKeys = () => Object.keys(this.model);
      this.addField = () => {
        this.backingModel.push({ key: "", value: "", checkUnique: modelKeys() });
      };
      this.removeField = (index) => {
        this.backingModel.splice(index, 1);
        this.synchronize();
        this.onChange();
      };
      this.synchronize = () => {
        if (this.isParameterized) {
          return;
        }
        const modelStart = JSON.stringify(this.model);
        const allKeys = this.backingModel.map((pair) => pair.key);
        modelKeys().forEach((key) => delete this.model[key]);
        this.backingModel.forEach((pair) => {
          if (pair.key && (this.allowEmpty || pair.value)) {
            this.model[pair.key] = pair.value;
          }
          pair.checkUnique = allKeys.filter((key) => pair.key !== key);
        });
        if (modelStart !== JSON.stringify(this.model)) {
          this.onChange();
        }
      };
      this.$onInit = () => {
        this.onChange = this.onChange || angular.noop;
        this.keyLabel = this.keyLabel || "Key";
        this.valueLabel = this.valueLabel || "Value";
        this.addButtonLabel = this.addButtonLabel || "Add Field";
        this.allowEmpty = this.allowEmpty || false;
        this.labelsLeft = this.labelsLeft || false;
        this.tableClass = this.label ? "" : "no-border-top";
        this.columnCount = this.labelsLeft ? 5 : 3;
        this.model = this.model || {};
        this.isParameterized = isString(this.model);
        this.hiddenKeys = this.hiddenKeys || [];
        if (this.model && !this.isParameterized) {
          modelKeys().forEach((key) => {
            this.backingModel.push({ key, value: this.model[key] });
          });
        }
      };
      $scope.$watch(() => JSON.stringify(this.backingModel), this.synchronize);
    }
  ],
  templateUrl: "core/src/forms/mapEditor/mapEditor.component.html"
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/forms/mapEditor/mapEditor.component.html", `<form name="mapEditor">
  <div class="sm-label-left" ng-if="$ctrl.label">
    <b>{{ $ctrl.label }}</b>
  </div>
  <input class="form-control input-sm" ng-model="$ctrl.model" ng-if="$ctrl.isParameterized" />
  <table class="table table-condensed packed tags {{ $ctrl.tableClass }}" ng-if="!$ctrl.isParameterized">
    <thead>
      <tr ng-if="!$ctrl.labelsLeft">
        <th ng-bind="$ctrl.keyLabel"></th>
        <th ng-bind="$ctrl.valueLabel"></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="pair in $ctrl.backingModel" ng-if="!$ctrl.hiddenKeys.includes(pair.key)">
        <td class="table-label" ng-if="$ctrl.labelsLeft">
          <b>{{ $ctrl.keyLabel }}</b>
        </td>
        <td>
          <input
            class="form-control input input-sm"
            type="text"
            name="{{ $index }}"
            ng-model="pair.key"
            validate-unique="pair.checkUnique"
          />
          <div class="error-message" ng-if="mapEditor[$index].$error.validateUnique">Duplicate key</div>
        </td>
        <td class="table-label" ng-if="$ctrl.labelsLeft">
          <b>{{ $ctrl.valueLabel }}</b>
        </td>
        <td><input class="form-control input input-sm" type="text" ng-model="pair.value" /></td>

        <td>
          <div class="form-control-static">
            <a href ng-click="$ctrl.removeField($index)">
              <span class="glyphicon glyphicon-trash"></span>
              <span class="sr-only">Remove field</span>
            </a>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="{{ $ctrl.columnCount }}">
          <button class="btn btn-block btn-sm add-new" ng-click="$ctrl.addField()">
            <span class="glyphicon glyphicon-plus-sign"></span>
            {{ $ctrl.addButtonLabel }}
          </button>
        </td>
      </tr>
    </tfoot>
  </table>
</form>
`);
}]);

const NUMBER_LIST_COMPONENT = "spinnaker.core.forms.numberList";
module(NUMBER_LIST_COMPONENT, []).component("numberList", react2angular(withErrorBoundary(NumberList, "numberList"), ["constraints", "label", "model", "onChange"]));

const CORE_FORMS_VALIDATEONSUBMIT_VALIDATEONSUBMIT_DIRECTIVE = "spinnaker.core.forms.validateOnSubmit.directive";
angular.module(CORE_FORMS_VALIDATEONSUBMIT_VALIDATEONSUBMIT_DIRECTIVE, []).directive("validateOnSubmit", function() {
  return {
    restrict: "A",
    require: "form",
    link: function(scope, element, attrs, formCtrl) {
      element.on("submit", function() {
        const queue = [];
        let invalidCtrl = formCtrl;
        while (invalidCtrl) {
          invalidCtrl.$setDirty();
          angular.forEach(invalidCtrl.$error, function(invalidSubCtrls) {
            if (angular.isArray(invalidSubCtrls)) {
              queue.push.apply(queue, invalidSubCtrls);
            }
          });
          invalidCtrl = queue.shift();
        }
        formCtrl.$$element.click();
        const firstInvalid = element.get(0).querySelector(".form-control.ng-invalid");
        if (firstInvalid) {
          firstInvalid.focus();
          if (firstInvalid.hasChildNodes()) {
            angular.forEach(firstInvalid.childNodes, function(child) {
              if (child.classList && child.classList.contains("ui-select-focusser")) {
                child.focus();
              }
            });
          }
        }
      });
    }
  };
});

const CORE_FORMS_FORMS_MODULE = "spinnaker.core.forms";
module(CORE_FORMS_FORMS_MODULE, [
  CORE_FORMS_AUTOFOCUS_AUTOFOCUS_DIRECTIVE,
  CORE_FORMS_CHECKLIST_CHECKLIST_DIRECTIVE,
  CORE_FORMS_CHECKMAP_CHECKMAP_DIRECTIVE,
  CORE_FORMS_IGNOREEMPTYDELETE_DIRECTIVE,
  CORE_FORMS_MAPEDITOR_MAPEDITOR_COMPONENT,
  CORE_FORMS_VALIDATEONSUBMIT_VALIDATEONSUBMIT_DIRECTIVE,
  NUMBER_LIST_COMPONENT
]);

const CORE_INSTANCE_DETAILS_CONSOLE_CONSOLEOUTPUTLINK_COMPONENT = "spinnaker.core.instance.details.console.link";
const name$6 = CORE_INSTANCE_DETAILS_CONSOLE_CONSOLEOUTPUTLINK_COMPONENT;
module(name$6, []).component("consoleOutputLink", react2angular(withErrorBoundary(ConsoleOutputLink, "consoleOutputLink"), ["instance", "text", "usesMultiOutput"]));

const CORE_INSTANCE_DETAILS_INSTANCEACTIONS_COMPONENT = "spinnaker.core.instance.details.instanceActions";
const name$5 = CORE_INSTANCE_DETAILS_INSTANCEACTIONS_COMPONENT;
module(name$5, []).component("instanceActions", react2angular(withErrorBoundary(InstanceActions, "instanceActions"), ["actions", "title"]));

const CORE_INSTANCE_DETAILS_HEADER_COMPONENT = "spinnaker.core.instance.details.header";
const name$4 = CORE_INSTANCE_DETAILS_HEADER_COMPONENT;
module(name$4, []).component("instanceDetailsHeader", react2angular(withErrorBoundary(InstanceDetailsHeader, "instanceDetailsHeader"), [
  "cloudProvider",
  "healthState",
  "instanceId",
  "loading",
  "sshLink",
  "standalone"
]));

const CORE_INSTANCE_DETAILS_INSTANCEINSIGHTS_COMPONENT = "spinnaker.core.instance.details.instanceInsights";
const name$3 = CORE_INSTANCE_DETAILS_INSTANCEINSIGHTS_COMPONENT;
module(name$3, []).component("instanceInsights", react2angular(withErrorBoundary(InstanceInsights, "instanceInsights"), [
  "analytics",
  "insights",
  "instance",
  "title"
]));

const CORE_INSTANCE_DETAILS_INSTANCELINKS_COMPONENT = "spinnaker.core.instance.details.instanceLinks";
const name$2 = CORE_INSTANCE_DETAILS_INSTANCELINKS_COMPONENT;
module(name$2, []).component("instanceLinks", react2angular(withErrorBoundary(InstanceLinks, "instanceLinks"), [
  "address",
  "application",
  "instance",
  "moniker",
  "environment"
]));

var css_248z$h = "multiple-instance-server-group {\n  display: block;\n  margin-bottom: 20px;\n}\nmultiple-instance-server-group h5 {\n  font-size: 110%;\n  margin-bottom: 5px;\n  padding-bottom: 0;\n}\nmultiple-instance-server-group .server-group-name {\n  font-weight: 600;\n}\nmultiple-instance-server-group .server-group-details {\n  margin-left: 24px;\n  margin-bottom: 5px;\n}\nmultiple-instance-server-group .multiple-instance-list {\n  margin-left: 24px;\n}\nmultiple-instance-server-group .multiple-instance-list ul {\n  font-size: 80%;\n}\n";
styleInject(css_248z$h);

const CORE_INSTANCE_DETAILS_MULTIPLEINSTANCESERVERGROUP_DIRECTIVE = "spinnaker.core.instance.details.multipleInstanceServerGroup.directive";
angular.module(CORE_INSTANCE_DETAILS_MULTIPLEINSTANCESERVERGROUP_DIRECTIVE, []).directive("multipleInstanceServerGroup", function() {
  return {
    restrict: "E",
    scope: {},
    bindToController: {
      instanceGroup: "="
    },
    controller: angular.noop,
    controllerAs: "vm",
    templateUrl: "core/src/instance/details/multipleInstanceServerGroup.directive.html"
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/instance/details/multipleInstanceServerGroup.directive.html", `<h5>
  <div class="server-group-name">
    <cloud-provider-logo provider="vm.instanceGroup.cloudProvider" height="'16px'" width="'16px'"></cloud-provider-logo>
    {{vm.instanceGroup.serverGroup}}
  </div>
</h5>
<div class="server-group-details">
  <account-tag account="vm.instanceGroup.account"></account-tag>
  {{vm.instanceGroup.region}}
</div>
<div class="multiple-instance-list">
  {{vm.instanceGroup.instances.length}} instance<span ng-if="vm.instanceGroup.instances.length !== 1">s</span>
  <ul>
    <li ng-repeat="instance in vm.instanceGroup.instances">
      <span class="glyphicon glyphicon-{{instance.healthState}}-triangle"></span>
      {{instance.name || instance.id}}
    </li>
  </ul>
</div>
`);
}]);

const CORE_INSTANCE_DETAILS_MULTIPLEINSTANCES_CONTROLLER = "spinnaker.core.instance.details.multipleInstances.controller";
module(CORE_INSTANCE_DETAILS_MULTIPLEINSTANCES_CONTROLLER, [
  UIROUTER_ANGULARJS,
  CORE_INSTANCE_DETAILS_MULTIPLEINSTANCESERVERGROUP_DIRECTIVE
]).controller("MultipleInstancesCtrl", [
  "$scope",
  "$state",
  "app",
  function($scope, $state, app) {
    this.selectedGroups = [];
    this.$onInit = () => {
      ProviderSelectionService.isDisabled(app).then((disabled) => {
        $scope.isDisabled = disabled;
      });
    };
    const getDescriptor = () => {
      let descriptor = this.instancesCount + " instance";
      if (this.instancesCount > 1) {
        descriptor += "s";
      }
      return descriptor;
    };
    const confirm = (submitMethod, verbs, body) => {
      const descriptor = getDescriptor();
      const taskMonitor = {
        application: app,
        title: verbs.presentContinuous + " " + descriptor
      };
      ConfirmationModalService.confirm({
        header: "Really " + verbs.simplePresent.toLowerCase() + " " + descriptor + "?",
        buttonText: verbs.simplePresent + " " + descriptor,
        verificationLabel: 'Verify the number of instances (<span class="verification-text">' + this.instancesCount + "</span>) to be " + verbs.futurePerfect.toLowerCase(),
        textToVerify: this.instancesCount + "",
        taskMonitorConfig: taskMonitor,
        body,
        submitMethod
      });
    };
    this.terminateInstances = () => {
      const submitMethod = () => InstanceWriter.terminateInstances(this.selectedGroups, app);
      confirm(submitMethod, {
        presentContinuous: "Terminating",
        simplePresent: "Terminate",
        futurePerfect: "Terminated"
      });
    };
    this.canTerminateInstancesAndShrinkServerGroups = () => {
      return !this.selectedGroups.some((group) => {
        return group.cloudProvider !== "aws";
      });
    };
    this.terminateInstancesAndShrinkServerGroups = () => {
      const submitMethod = () => InstanceWriter.terminateInstancesAndShrinkServerGroups(this.selectedGroups, app);
      confirm(submitMethod, {
        presentContinuous: "Terminating",
        simplePresent: "Terminate",
        futurePerfect: "Terminated"
      });
    };
    this.rebootInstances = () => {
      const submitMethod = () => InstanceWriter.rebootInstances(this.selectedGroups, app);
      confirm(submitMethod, {
        presentContinuous: "Rebooting",
        simplePresent: "Reboot",
        futurePerfect: "Rebooted"
      });
    };
    const allDiscoveryHealthsMatch = (state) => {
      return this.selectedGroups.every((group) => {
        return group.instances.every((instance) => {
          const discoveryHealth = instance.health.filter(function(health) {
            return health.type === "Discovery";
          });
          return discoveryHealth.length ? discoveryHealth[0].state === state : false;
        });
      });
    };
    this.canRegisterWithDiscovery = () => allDiscoveryHealthsMatch("OutOfService");
    this.canDeregisterWithDiscovery = () => allDiscoveryHealthsMatch("Up") || allDiscoveryHealthsMatch("Down");
    this.registerWithDiscovery = () => {
      const submitMethod = () => InstanceWriter.enableInstancesInDiscovery(this.selectedGroups, app);
      confirm(submitMethod, {
        presentContinuous: "Registering",
        simplePresent: "Register",
        futurePerfect: "Registered"
      });
    };
    this.deregisterWithDiscovery = () => {
      const submitMethod = () => InstanceWriter.disableInstancesInDiscovery(this.selectedGroups, app);
      confirm(submitMethod, {
        presentContinuous: "Deregistering",
        simplePresent: "Deregister",
        futurePerfect: "Deregistered"
      });
    };
    const getAllLoadBalancers = () => {
      if (!this.selectedGroups.length) {
        return [];
      }
      const base = this.selectedGroups[0].loadBalancers.sort().join(" ");
      if (this.selectedGroups.every((group) => group.loadBalancers.sort().join(" ") === base)) {
        return this.selectedGroups[0].loadBalancers;
      }
      return [];
    };
    this.canRegisterWithLoadBalancers = () => {
      return getAllLoadBalancers().length !== 0 && this.selectedGroups.every((group) => group.instances.every((instance) => instance.health.every((health) => health.type !== "LoadBalancer")));
    };
    this.canDeregisterFromLoadBalancers = () => {
      const allLoadBalancers = getAllLoadBalancers().sort().join(" ");
      return this.selectedGroups.every((group) => {
        return group.instances.every((instance) => {
          return instance.health.some((health) => {
            return health.type === "LoadBalancer" && allLoadBalancers === health.loadBalancers.map((lb) => lb.name).sort().join(" ");
          });
        });
      });
    };
    this.registerWithLoadBalancers = () => {
      const allLoadBalancers = getAllLoadBalancers().sort();
      const submitMethod = () => InstanceWriter.registerInstancesWithLoadBalancer(this.selectedGroups, app, allLoadBalancers);
      confirm(submitMethod, {
        presentContinuous: "Registering",
        simplePresent: "Register",
        futurePerfect: "Registered"
      }, `<p>Instances will be registered with the following load balancers: <b>${allLoadBalancers.join(", ")}</b></p>`);
    };
    this.deregisterFromLoadBalancers = () => {
      const allLoadBalancers = getAllLoadBalancers().sort();
      const submitMethod = () => InstanceWriter.deregisterInstancesFromLoadBalancer(this.selectedGroups, app, allLoadBalancers);
      confirm(submitMethod, {
        presentContinuous: "Deregistering",
        simplePresent: "Deregister",
        futurePerfect: "Deregistered"
      }, `<p>Instances will be deregistered from the following load balancers: <b>${allLoadBalancers.join(", ")}</b></p>`);
    };
    function getServerGroup(group) {
      return app.serverGroups.data.find((serverGroup) => serverGroup.name === group.serverGroup && serverGroup.account === group.account && serverGroup.region === group.region);
    }
    function getInstanceDetails(group, instanceId) {
      const serverGroup = getServerGroup(group);
      if (!serverGroup) {
        return null;
      }
      return serverGroup.instances.find((instance) => instance.id === instanceId) || {};
    }
    const makeInstanceModel = (group, instanceId) => {
      const instance = getInstanceDetails(group, instanceId);
      return {
        id: instanceId,
        availabilityZone: instance.availabilityZone,
        health: instance.health || [],
        healthState: instance.healthState,
        name: instance.name
      };
    };
    const makeServerGroupModel = (group) => {
      const parentServerGroup = getServerGroup(group);
      const loadBalancers = parentServerGroup ? parentServerGroup.loadBalancers : [];
      return {
        cloudProvider: group.cloudProvider,
        serverGroup: group.serverGroup,
        loadBalancers,
        account: group.account,
        region: group.region,
        instanceIds: group.instanceIds,
        instances: group.instanceIds.map((instanceId) => makeInstanceModel(group, instanceId))
      };
    };
    const countInstances = () => {
      return ClusterState.multiselectModel.instanceGroups.reduce((acc, group) => acc + group.instanceIds.length, 0);
    };
    const retrieveInstances = () => {
      this.instancesCount = countInstances();
      this.selectedGroups = ClusterState.multiselectModel.instanceGroups.filter((group) => group.instanceIds.length).map(makeServerGroupModel);
    };
    const multiselectWatcher = ClusterState.multiselectModel.instancesStream.subscribe(retrieveInstances);
    app.serverGroups.onRefresh($scope, retrieveInstances);
    retrieveInstances();
    $scope.$on("$destroy", () => {
      ClusterState.multiselectModel.deselectAllInstances();
      multiselectWatcher.unsubscribe();
    });
  }
]);

const INSTANCE_STATES = "spinnaker.core.instance.states";
module(INSTANCE_STATES, [APPLICATION_STATE_PROVIDER, STATE_CONFIG_PROVIDER]).config([
  "applicationStateProvider",
  "stateConfigProvider",
  (applicationStateProvider, stateConfigProvider) => {
    const instanceDetails = {
      name: "instanceDetails",
      url: "/instanceDetails/:provider/:instanceId",
      views: {
        "detail@../insight": {
          component: InstanceDetails,
          $type: "react"
        }
      },
      resolve: {
        overrides: () => {
          return {};
        },
        instance: [
          "$stateParams",
          ($stateParams) => {
            return {
              instanceId: $stateParams.instanceId
            };
          }
        ]
      },
      data: {
        pageTitleDetails: {
          title: "Instance Details",
          nameParam: "instanceId"
        },
        history: {
          type: "instances"
        }
      }
    };
    const multipleInstances = {
      name: "multipleInstances",
      url: "/multipleInstances",
      views: {
        "detail@../insight": {
          templateUrl: "core/src/instance/details/multipleInstances.view.html",
          controller: "MultipleInstancesCtrl",
          controllerAs: "vm"
        }
      },
      data: {
        pageTitleDetails: {
          title: "Multiple Instances"
        }
      }
    };
    const standaloneInstance = {
      name: "instanceDetails",
      url: "/instance/:provider/:account/:region/:instanceId",
      views: {
        "main@": {
          templateUrl: "core/src/presentation/standalone.view.html",
          controllerProvider: [
            "$stateParams",
            ($stateParams) => {
              return CloudProviderRegistry.getValue($stateParams.provider, "instance.detailsController");
            }
          ],
          controllerAs: "ctrl"
        }
      },
      resolve: {
        instance: [
          "$stateParams",
          ($stateParams) => {
            return {
              instanceId: $stateParams.instanceId,
              account: $stateParams.account,
              region: $stateParams.region,
              noApplication: true
            };
          }
        ],
        app: [
          () => {
            return ApplicationModelBuilder.createStandaloneApplication("(standalone instance)");
          }
        ],
        overrides: () => {
          return {};
        },
        moniker: () => null,
        environment: () => null
      },
      data: {
        pageTitleDetails: {
          title: "Instance Details",
          nameParam: "instanceId"
        },
        history: {
          type: "instances"
        }
      }
    };
    applicationStateProvider.addInsightDetailState(instanceDetails);
    applicationStateProvider.addInsightDetailState(multipleInstances);
    stateConfigProvider.addToRootState(standaloneInstance);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/instance/details/multipleInstances.view.html", `<div class="details-panel">
  <div class="header">
    <div class="close-button">
      <a class="btn btn-link" ui-sref="^">
        <span class="glyphicon glyphicon-remove"></span>
      </a>
    </div>
    <div class="header-text">
      <span class="glyphicon glyphicon-hdd {{vm.healthState}}"></span>
      <h3>{{vm.instancesCount}} Instance<span ng-if="vm.instancesCount !== 1">s</span></h3>
    </div>
    <div>
      <div class="actions">
        <div class="dropdown" uib-dropdown dropdown-append-to-body>
          <button
            type="button"
            class="btn btn-sm btn-primary dropdown-toggle"
            ng-disabled="disabled"
            ng-hide="isDisabled"
            uib-dropdown-toggle
          >
            Actions <span class="caret"></span>
          </button>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu">
            <li>
              <a href ng-click="vm.registerWithDiscovery()" ng-if="vm.canRegisterWithDiscovery()"
                >Enable in Discovery</a
              >
            </li>
            <li>
              <a href ng-click="vm.deregisterWithDiscovery()" ng-if="vm.canDeregisterWithDiscovery()"
                >Disable in Discovery</a
              >
            </li>
            <li>
              <a href ng-click="vm.registerWithLoadBalancers()" ng-if="vm.canRegisterWithLoadBalancers()"
                >Register with Load Balancer</a
              >
            </li>
            <li>
              <a href ng-click="vm.deregisterFromLoadBalancers()" ng-if="vm.canDeregisterFromLoadBalancers()"
                >Deregister from Load Balancer</a
              >
            </li>
            <li role="presentation" class="divider"></li>
            <li><a href ng-click="vm.rebootInstances()">Reboot</a></li>
            <li><a href ng-click="vm.terminateInstances()">Terminate</a></li>
            <li>
              <a
                href
                ng-click="vm.terminateInstancesAndShrinkServerGroups()"
                ng-if="vm.canTerminateInstancesAndShrinkServerGroups()"
                >Terminate and Shrink Server Groups</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="content">
    <collapsible-section heading="Server Groups" expanded="true">
      <multiple-instance-server-group ng-repeat="instanceGroup in vm.selectedGroups" instance-group="instanceGroup">
      </multiple-instance-server-group>
    </collapsible-section>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/presentation/standalone.view.html", `<div class="standalone">
  <div class="col-md-6 col-md-offset-3">
    <div ng-include="detailsTemplateUrl"></div>
  </div>
</div>
`);
}]);

class InstancesSearchResultType extends SearchResultType {
  constructor() {
    super(...arguments);
    this.id = "instances";
    this.order = 4;
    this.displayName = "Instances";
    this.iconClass = "fa fa-hdd";
    this.cols = {
      INSTANCE: { key: "instanceId", label: "Instance ID" },
      ACCOUNT: { key: "account" },
      REGION: { key: "region" },
      SERVERGROUP: { key: "serverGroup" }
    };
    this.TabComponent = DefaultSearchResultTab;
    this.HeaderComponent = () => /* @__PURE__ */ React__default.createElement(SearchTableHeader, null, /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.INSTANCE
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.ACCOUNT
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.REGION
    }), /* @__PURE__ */ React__default.createElement(HeaderCell, {
      col: this.cols.SERVERGROUP
    }));
    this.DataComponent = ({ resultSet }) => {
      const itemKeyFn = (item) => item.instanceId;
      const itemSortFn = (a, b) => a.instanceId.localeCompare(b.instanceId);
      const results = resultSet.results.slice().sort(itemSortFn);
      return /* @__PURE__ */ React__default.createElement(SearchTableBody, null, results.slice().sort(itemSortFn).map((item) => /* @__PURE__ */ React__default.createElement(SearchTableRow, {
        key: itemKeyFn(item)
      }, /* @__PURE__ */ React__default.createElement(HrefCell, {
        item,
        col: this.cols.INSTANCE
      }), /* @__PURE__ */ React__default.createElement(AccountCell, {
        item,
        col: this.cols.ACCOUNT
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.REGION
      }), /* @__PURE__ */ React__default.createElement(BasicCell, {
        item,
        col: this.cols.SERVERGROUP,
        defaultValue: "Standalone Instance"
      }))));
    };
  }
  displayFormatter(searchResult) {
    const serverGroup = searchResult.serverGroup || "standalone instance";
    return `${searchResult.instanceId} (${serverGroup} - ${searchResult.region})`;
  }
}
searchResultTypeRegistry.register(new InstancesSearchResultType());

const CORE_INSTANCE_LOADBALANCER_INSTANCELOADBALANCERHEALTH_DIRECTIVE = "spinnaker.core.instance.loadBalancer.health.directive";
module(CORE_INSTANCE_LOADBALANCER_INSTANCELOADBALANCERHEALTH_DIRECTIVE, []).component("instanceLoadBalancerHealth", react2angular(withErrorBoundary(InstanceLoadBalancerHealth, "instanceLoadBalancerHealth"), [
  "loadBalancer",
  "ipAddress"
]));

var css_248z$g = ".panel-default > .panel-heading {\n  background-color: transparent;\n  border-bottom: 0;\n}\ninstance-archetype-selector .archetype-columns,\nv2-instance-archetype-selector .archetype-columns,\nv-2-instance-archetype-selector .archetype-columns {\n  display: inline-block;\n}\ninstance-archetype-selector .archetype-columns button,\nv2-instance-archetype-selector .archetype-columns button,\nv-2-instance-archetype-selector .archetype-columns button {\n  width: 100%;\n}\ninstance-archetype-selector .archetype-columns h4,\nv2-instance-archetype-selector .archetype-columns h4,\nv-2-instance-archetype-selector .archetype-columns h4 {\n  min-height: 52px;\n}\ninstance-archetype-selector .archetype-columns .panel-heading,\nv2-instance-archetype-selector .archetype-columns .panel-heading,\nv-2-instance-archetype-selector .archetype-columns .panel-heading {\n  padding: 0 0 0 0;\n}\ninstance-archetype-selector .archetype-columns.archetype-columns-3,\nv2-instance-archetype-selector .archetype-columns.archetype-columns-3,\nv-2-instance-archetype-selector .archetype-columns.archetype-columns-3 {\n  width: calc(33% - 40px);\n  margin: 0 20px 20px;\n}\ninstance-archetype-selector .archetype-columns.archetype-columns-4,\nv2-instance-archetype-selector .archetype-columns.archetype-columns-4,\nv-2-instance-archetype-selector .archetype-columns.archetype-columns-4 {\n  width: calc(25% - 30px);\n  margin: 0 15px 20px;\n}\ninstance-archetype-selector .archetype-columns.archetype-columns-5,\nv2-instance-archetype-selector .archetype-columns.archetype-columns-5,\nv-2-instance-archetype-selector .archetype-columns.archetype-columns-5 {\n  width: calc(20% - 12px);\n  margin: 0 5px 20px;\n}\ninstance-archetype-selector .archetype-columns.archetype-columns-5 h4,\nv2-instance-archetype-selector .archetype-columns.archetype-columns-5 h4,\nv-2-instance-archetype-selector .archetype-columns.archetype-columns-5 h4 {\n  font-size: 16px;\n}\n.instance-profile {\n  vertical-align: top;\n  text-align: left;\n  min-height: 100px;\n  font-size: 90%;\n  border: 1px solid var(--color-silver);\n  border-radius: 3px;\n  color: var(--color-mineshaft);\n  background-color: transparent;\n}\n.instance-profile:hover,\n.instance-profile:focus {\n  color: var(--color-mineshaft);\n  text-decoration: none;\n}\n.instance-profile .selected-indicator {\n  display: block;\n  width: 100%;\n  text-align: right;\n  padding-right: 5px;\n  font-size: 150%;\n  color: var(--color-accent);\n}\n.instance-profile .selected-indicator.custom {\n  margin-top: 5px;\n}\n.instance-profile h4 {\n  margin-top: 0;\n  text-align: center;\n  word-spacing: 300px;\n}\n.instance-profile ul {\n  font-size: 95%;\n  padding-left: 20px;\n}\n.instance-profile .panel-heading {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.instance-profile:hover,\n.instance-profile:focus,\n.instance-profile.active {\n  outline: 0;\n}\n.instance-profile.active {\n  box-shadow: inset 0 0 3px 2px var(--color-accent);\n  border-color: var(--color-accent);\n}\n.instance-profile:hover,\n.instance-profile:focus {\n  box-shadow: 0 0 8px 2px var(--color-accent);\n}\n.cost-factor {\n  color: var(--color-alto);\n}\n.cost-factor .cost {\n  color: var(--color-mineshaft);\n}\n";
styleInject(css_248z$g);

const CORE_INSTANCE_INSTANCE_MODULE = "spinnaker.core.instance";
module(CORE_INSTANCE_INSTANCE_MODULE, [
  CORE_INSTANCE_DETAILS_CONSOLE_CONSOLEOUTPUTLINK_COMPONENT,
  CORE_INSTANCE_LOADBALANCER_INSTANCELOADBALANCERHEALTH_DIRECTIVE,
  CORE_INSTANCE_DETAILS_MULTIPLEINSTANCES_CONTROLLER,
  CORE_INSTANCE_DETAILS_INSTANCELINKS_COMPONENT,
  CORE_INSTANCE_DETAILS_INSTANCEACTIONS_COMPONENT,
  CORE_INSTANCE_DETAILS_INSTANCEINSIGHTS_COMPONENT,
  CORE_INSTANCE_DETAILS_HEADER_COMPONENT,
  INSTANCE_STATES
]);

const modalCloseComponent = {
  bindings: {
    dismiss: "&"
  },
  template: `
    <div class="close-button pull-right">
      <a href class="btn btn-link" ng-click="$ctrl.dismiss()" >
        <span class="glyphicon glyphicon-remove"></span>
      </a>
    </div>
`
};
const MODAL_CLOSE_COMPONENT = "spinnaker.core.modal.modalClose.component";
module(MODAL_CLOSE_COMPONENT, []).component("modalClose", modalCloseComponent);

const submitButtonComponent = {
  bindings: {
    onClick: "&",
    isDisabled: "<",
    isNew: "<",
    submitting: "<",
    label: "<"
  },
  template: `
    <button class="btn btn-primary" ng-disabled="$ctrl.isDisabled" ng-click="$ctrl.onClick()">
      <div class="flex-container-h horizontal middle">
        <i ng-if="!$ctrl.submitting" class="far fa-check-circle"></i>
        <loading-spinner ng-if="$ctrl.submitting" mode="'circular'"></loading-spinner>
        <span class="sp-margin-xs-left">{{$ctrl.label || ($ctrl.isNew ? 'Create' : 'Update')}}</span>
      </div>
    </button>`
};
const SUBMIT_BUTTON_COMPONENT = "spinnaker.core.modal.buttons.submitButton.component";
module(SUBMIT_BUTTON_COMPONENT, []).component("submitButton", submitButtonComponent);

const CORE_MODAL_MODALOVERLAY_DIRECTIVE = "spinnaker.core.modal.modalOverlay.directive";
module(CORE_MODAL_MODALOVERLAY_DIRECTIVE, []).directive("modalOverlay", [
  "$timeout",
  function($timeout) {
    return {
      restrict: "A",
      link: function(scope, elem) {
        $timeout(function() {
          const $uibModal = elem.closest(".modal-content");
          let modalHeight = $uibModal.outerHeight();
          if (modalHeight < 450) {
            modalHeight = 450;
          }
          $uibModal.height(modalHeight);
          elem.show().height(modalHeight).css({ opacity: 1 });
          const headerHeight = elem.find(".modal-header").outerHeight();
          const footerHeight = elem.find(".modal-footer").outerHeight();
          elem.find(".modal-body").css({ height: `calc(100% - ${headerHeight + footerHeight}px)` });
          scope.$on("$destroy", function() {
            elem.hide();
            elem.height(0).css({ opacity: 0, scrollTop: 0 });
            $uibModal.height("auto");
          });
        });
      }
    };
  }
]);

const CORE_MODAL_MODALPAGE_DIRECTIVE = "spinnaker.core.modal.modalPage.directive";
module(CORE_MODAL_MODALPAGE_DIRECTIVE, []).directive("modalPage", function() {
  return {
    restrict: "EA",
    link: function(scope, elem, attrs) {
      if (attrs.modalPage === "false") {
        return;
      }
      function getTabbableElements() {
        const tagSelector = "a[href],input,select,button,textarea";
        return elem.find(tagSelector).filter(":visible").not(":disabled");
      }
      const ts = Math.floor(Math.random() * 4294967295);
      $$1(document).on("keydown.modalPage-" + ts, function(event) {
        if (event.keyCode === 9) {
          const $tabbableElements = getTabbableElements();
          const $firstElem = $tabbableElements[0];
          const $lastElem = $tabbableElements[$tabbableElements.length - 1];
          if ($firstElem === event.target && event.shiftKey) {
            $lastElem.focus();
            return false;
          }
          if ($lastElem === event.target && !event.shiftKey) {
            $firstElem.focus();
            return false;
          }
          if ($tabbableElements.index(event.target) === -1) {
            if (event.shiftKey) {
              $lastElem.focus();
            } else {
              if ($firstElem) {
                $firstElem.focus();
              }
            }
            return false;
          }
        }
      });
      scope.$on("$destroy", function() {
        $$1(document).off(".modalPage-" + ts);
      });
    }
  };
});

const CORE_MODAL_WIZARD_WIZARDSUBFORMVALIDATION_SERVICE = "spinnaker.core.modalWizard.subFormValidation.service";
module(CORE_MODAL_WIZARD_WIZARDSUBFORMVALIDATION_SERVICE, []).factory("wizardSubFormValidation", function() {
  let validatorRegistry = {};
  function buildWatchString(form, subForm, formKey) {
    return `${form}.${subForm}.${formKey}`;
  }
  this.config = ({ form, scope }) => {
    this.form = form;
    this.scope = scope;
    this.scope.$on("destroy", this.reset);
    return this;
  };
  this.register = ({ subForm, page, validators = [] }) => {
    validators.push({
      watchString: buildWatchString(this.form, subForm, "$valid"),
      validator: (subFormIsValid) => subFormIsValid
    });
    validatorRegistry[page] = validators.map((v) => new Validator(v, this.scope, page));
    return this;
  };
  this.subFormsAreValid = () => {
    return ___default.every(validatorRegistry, (validatorsForPage) => validatorsForPage.every((v) => v.state.valid));
  };
  this.reset = () => {
    validatorRegistry = {};
    this.scope = void 0;
    this.form = void 0;
  };
  class Validator {
    constructor({ watchString, validator, collection, watchDeep }, scope, page, state = { valid: false }) {
      this.state = state;
      this.page = page;
      const watchType = collection ? "$watchCollection" : "$watch";
      scope[watchType](watchString, (value) => {
        this.state.valid = validator(value);
        if (ModalWizard.getPage(this.page)) {
          if (this.state.valid) {
            this.emitValid();
          } else {
            this.emitInvalid();
          }
        }
      }, watchDeep || false);
    }
    emitValid() {
      const pageIsValid = validatorRegistry[this.page].every((v) => v.state.valid);
      if (pageIsValid) {
        ModalWizard.markComplete(this.page);
      }
    }
    emitInvalid() {
      ModalWizard.markIncomplete(this.page);
    }
  }
  return this;
});

var css_248z$f = ".modal-backdrop {\n  z-index: 8999;\n}\n.modal {\n  z-index: var(--layer-critical);\n}\n.modal h2,\n.modal h3,\n.modal h4,\n.modal h5 {\n  font-weight: 600;\n}\n.modal .modal-close,\n.modal modal-close {\n  display: block;\n  position: absolute;\n  right: 0;\n  top: 5px;\n  z-index: 6;\n}\n.modal-header {\n  background-color: var(--color-alabaster);\n}\n.modal-header h3 {\n  margin: 0;\n}\n.modal-fullscreen {\n  height: calc(100% - 60px);\n}\n.modal-fullscreen .modal-content {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.modal-fullscreen .modal-content .modal-body {\n  flex: 1;\n  height: 0;\n  overflow-y: scroll;\n}\n.modal-fullscreen .flex-fill {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.modal-fullscreen .fill-no-flex {\n  flex: 1;\n}\n.modal-body h3,\n.modal-body h4 {\n  margin-top: 0;\n}\n.modal-body .section-heading {\n  color: var(--color-mineshaft);\n  background-color: var(--color-accent-g2);\n  padding: 10px;\n  margin-bottom: 0;\n}\n.modal-body .section-body {\n  padding: 10px 0 20px 0;\n}\n/* Fixes an unfortunate Chrome bug where a single selection on a multi-select select2 field\n   causes the backwards navigation animation to hang. */\nselect.select2 option {\n  display: none !important;\n}\n.select2-results .select2-highlighted ul {\n  background-color: transparent;\n  color: var(--color-white);\n}\n.modal-body .select2-container abbr {\n  top: 8px;\n}\n.modal-body .select2-container .select2-drop {\n  position: fixed;\n  top: auto;\n  width: inherit;\n  background: var(--color-white);\n}\n.modal-body .select2-container .select2-drop .select2-results {\n  margin: -1px 0 0 0;\n  border-top: none;\n  padding-right: 4px;\n}\n.modal-body .select2-container.select2-container-multi .select2-drop {\n  padding-right: 29px;\n  border: none;\n  box-shadow: none;\n  background: transparent;\n}\n.modal-body .select2-container.select2-container-multi .select2-results {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-accent-g1);\n  border-top: none;\n  border-left-width: 2px;\n}\n.modal-body .select2-container .select2-result-single {\n  padding-left: 0;\n}\n.modal-body .select2-container .select2-result-single h5 {\n  margin: 3px 0;\n}\n.modal-body .select2-container .select2-result-single .select2-highlighted ul {\n  background-color: transparent;\n  color: var(--color-white);\n}\n.select2-container.form-control {\n  box-shadow: none;\n}\n.ui-select-highlight {\n  font-weight: bold;\n}\n.ui-select-choices-content {\n  background: var(--color-white);\n}\nli.ui-select-choices-row:hover {\n  background-color: var(--color-accent-g1);\n  color: var(--color-white);\n}\nli.ui-select-choices-row.select2-highlighted {\n  background-color: var(--color-accent);\n}\nabbr.select2-search-choice-close {\n  margin-top: 0;\n}\nhtml .select2-container-multi.select2-container-active .select2-choices {\n  border: 0;\n  box-shadow: none;\n  background-color: transparent;\n}\nhtml .select2-container-multi.select2-container-active .select2-choices .select2-search-field {\n  border: 1px solid var(--color-accent);\n}\nhtml .select2-container-multi.select2-container-active .select2-choices .select2-search-field:before {\n  content: '';\n}\nhtml .select2-container-multi .select2-choices {\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  background-image: none;\n}\nhtml .select2-container-multi .select2-choices .select2-search-field {\n  width: calc(100% - 40px);\n  float: none;\n  border: 1px dashed var(--color-concrete);\n  color: var(--color-concrete);\n  padding: 0;\n  margin: 4px 0 0 1px;\n  cursor: pointer;\n  background-color: transparent;\n}\nhtml .select2-container-multi .select2-choices .select2-search-field:before {\n  content: 'Select...';\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  opacity: 0.5;\n  z-index: 2;\n}\nhtml .select2-container-multi .select2-choices .select2-search-field input {\n  position: relative;\n  z-index: 3;\n  background-color: var(--color-white);\n}\nhtml .select2-container-multi .select2-choices .select2-search-choice {\n  float: none;\n  margin: 0 0 5px 1px;\n  border: 0;\n  padding: 0;\n  background-image: none;\n  background-color: transparent;\n  box-shadow: none;\n}\nhtml .select2-container-multi .select2-choices .select2-search-choice div,\nhtml .select2-container-multi .select2-choices .select2-search-choice span {\n  cursor: text;\n  -webkit-user-select: auto;\n     -moz-user-select: auto;\n          user-select: auto;\n  padding: 5px;\n  width: calc(100% - 40px);\n  display: inline-block;\n  border: 1px solid var(--color-alto);\n  background-color: var(--color-white);\n  font-family: 'Source Sans 3', sans-serif;\n  border-radius: 4px;\n}\nhtml .select2-container-multi .select2-choices .select2-search-choice .select2-search-choice-close {\n  float: none;\n  position: relative;\n  top: 50%;\n  display: inline-block;\n  margin-top: 4px;\n  width: 2px;\n}\nhtml .select2-container-multi .select2-choices .select2-search-choice .select2-search-choice-close:before {\n  content: '\\e020';\n  font-size: 12px;\n  font-family: 'Glyphicons Halflings';\n  width: 13px;\n  display: inline-block;\n}\n.task-progress {\n  list-style-type: none;\n}\n.task-progress li {\n  margin-bottom: 5px;\n}\n.task-progress li .fa-check-circle {\n  color: var(--color-success);\n}\n.task-progress li .fa-exclamation-triangle {\n  color: var(--color-danger);\n}\n.task-progress.task-progress-refresh {\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 2px solid var(--color-concrete);\n}\n.task-progress.task-progress-running {\n  margin-top: 20px;\n  text-align: center;\n}\n.task-progress.task-progress-running .glyphicon {\n  font-size: 150%;\n  color: var(--color-success);\n}\n.overlay-modal-appear {\n  transform: scaleY(0);\n}\n.overlay-modal-appear-active {\n  transform: scaleY(1);\n}\n.overlay-modal {\n  transition: transform 0.25s ease-in-out;\n  height: 100%;\n  min-height: 450px;\n  overflow-y: auto;\n  border-bottom: 2px solid var(--color-primary);\n  background-color: var(--color-white);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 6;\n}\n.overlay-modal .overlay-modal-status {\n  padding: 0 30px;\n}\n.overlay-modal .overlay-modal-error {\n  padding: 30px 30px 0 30px;\n  color: var(--color-danger);\n}\n.overlay-modal .modal-body {\n  overflow-y: auto;\n  margin: 0;\n  padding-top: 20px;\n  flex: 1;\n}\n.overlay-modal .modal-header,\n.overlay-modal .modal-footer {\n  position: relative;\n  width: 100%;\n  background-color: var(--color-white);\n  flex: 0;\n}\n.overlay-modal .modal-header {\n  top: 0;\n  z-index: 2;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.overlay-modal .modal-footer {\n  bottom: 0;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.slide-in {\n  -webkit-animation: 0.3s ease-in-out 0 slideDown;\n          animation: 0.3s ease-in-out 0 slideDown;\n  -webkit-animation-iteration-count: 1;\n          animation-iteration-count: 1;\n}\n.actions-popover {\n  text-align: right;\n}\n.actions-popover .glyphicon {\n  padding: 0 5px;\n}\n.card-choices {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.card-choices .card {\n  border: 1px solid var(--color-alto);\n  border-radius: 2px;\n  width: 200px;\n  margin: 15px;\n  padding: 30px 15px;\n  cursor: pointer;\n}\n.card-choices .card.active {\n  border: 1px solid var(--color-accent);\n  background-color: var(--color-accent-g2);\n  box-shadow: 0 0 5px 0 var(--color-accent);\n}\n.card-choices .card.active h3 {\n  color: var(--color-primary);\n}\n.card-choices .card:hover {\n  border: 1px solid var(--color-accent);\n}\n.card-choices .card h3 {\n  text-align: center;\n  flex: 1 1 auto;\n}\n.card-choices .card h3.card-label {\n  margin-bottom: 1px;\n}\n.card-choices .card div {\n  text-align: center;\n  flex: 1 1 auto;\n}\n";
styleInject(css_248z$f);

const CORE_MODAL_MODAL_MODULE = "spinnaker.core.modal";
module(CORE_MODAL_MODAL_MODULE, [
  CORE_MODAL_MODALOVERLAY_DIRECTIVE,
  CORE_MODAL_MODALPAGE_DIRECTIVE,
  CORE_MODAL_WIZARD_WIZARDSUBFORMVALIDATION_SERVICE,
  MODAL_CLOSE_COMPONENT,
  SUBMIT_BUTTON_COMPONENT,
  V2_MODAL_WIZARD_COMPONENT
]).run([
  "$rootScope",
  "$uibModalStack",
  function($rootScope, $uibModalStack) {
    $rootScope.$on("$stateChangeStart", function(event, toState, toParams) {
      if (!toParams.allowModalToStayOpen) {
        $uibModalStack.dismissAll();
      }
    });
  }
]);

class NotificationService {
  static getNotificationTypeMetadata() {
    return REST("/notifications/metadata").useCache().get();
  }
}

const extensionNotificationConfig = (parameters) => {
  return class ExtensionNotificationConfig extends React__default.Component {
    render() {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, parameters.map((param) => /* @__PURE__ */ React__default.createElement(FormikFormField, {
        key: param.name,
        name: param.name,
        label: param.label,
        help: param.description ? /* @__PURE__ */ React__default.createElement(HelpField, {
          content: param.description
        }) : null,
        input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
          ...props
        }),
        ...this.props
      })));
    }
  };
};

class BearychatNotificationType extends React__default.Component {
  render() {
    const { fieldName } = this.props;
    return /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Email Address",
      name: fieldName ? `${fieldName}.address` : "address",
      validate: Validators.emailValue("Please enter a valid email address"),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props
      }),
      required: true
    });
  }
}

const bearyChatNotification = {
  component: BearychatNotificationType,
  key: "bearychat",
  label: "Bearychat"
};

class EmailNotificationType extends React__default.Component {
  render() {
    const { fieldName } = this.props;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Email Address",
      name: fieldName ? `${fieldName}.address` : "address",
      validate: Validators.skipIfSpel(Validators.emailValue("Please enter a valid email address")),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props
      }),
      required: true
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "CC Address",
      name: fieldName ? `${fieldName}.cc` : "cc",
      validate: Validators.skipIfSpel(Validators.emailValue("Please enter a valid email address")),
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props
      })
    }));
  }
}

const emailNotification = {
  component: EmailNotificationType,
  key: "email",
  label: "Email"
};

class GithubNotificationType extends React__default.Component {
  render() {
    const { fieldName } = this.props;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Github Repository",
      name: fieldName ? `${fieldName}.repo` : "repo",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props
      }),
      required: true
    }), /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Commit SHA",
      name: fieldName ? `${fieldName}.commit` : "commit",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props
      })
    }));
  }
}

const githubstatusNotification = {
  component: GithubNotificationType,
  key: "githubStatus",
  label: "Github Status"
};

class GooglechatNotificationType extends React__default.Component {
  render() {
    const { fieldName } = this.props;
    return /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Chat Webhook URL",
      name: fieldName ? `${fieldName}.address` : "address",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props,
        placeholder: "URL starts with https://chat.googleapis.com/v1/spaces/"
      }),
      required: true
    });
  }
}

const googlechatNotification = {
  component: GooglechatNotificationType,
  key: "googlechat",
  label: "Google Chat"
};

class MicrosoftTeamsNotificationType extends React__default.Component {
  render() {
    const { fieldName } = this.props;
    return /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Teams Webhook URL",
      name: fieldName ? `${fieldName}.address` : "address",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props,
        placeholder: "URL starts with https://outlook.office.com/webhook/"
      }),
      required: true
    });
  }
}

const microsoftTeamsNotification = {
  component: MicrosoftTeamsNotificationType,
  key: "microsoftteams",
  label: "Microsoft Teams"
};

class PubsubNotificationType extends React__default.Component {
  render() {
    const { fieldName } = this.props;
    return /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Publisher Name",
      name: fieldName ? `${fieldName}.publisherName` : "publisherName",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props,
        placeholder: "enter a pubsub publisher name"
      }),
      required: true
    });
  }
}

const pubsubNotification = {
  component: PubsubNotificationType,
  key: "pubsub",
  label: "Pubsub"
};

class SlackNotificationType extends React__default.Component {
  render() {
    const { botName, fieldName } = this.props;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Slack Channel",
      name: fieldName ? `${fieldName}.address` : "address",
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props,
        placeholder: "enter a Slack channel"
      }),
      required: true
    }), !!botName && /* @__PURE__ */ React__default.createElement("div", {
      className: "row"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "col-md-6 col-md-offset-4"
    }, /* @__PURE__ */ React__default.createElement("strong", null, "Note:"), " You will need to invite the", /* @__PURE__ */ React__default.createElement("strong", null, " ", botName, " "), "bot to this channel to receive Slack notifications", /* @__PURE__ */ React__default.createElement("br", null))));
  }
}

const slackNotification = {
  component: SlackNotificationType,
  key: "slack",
  label: "Slack"
};

class SmsNotificationType extends React__default.Component {
  constructor() {
    super(...arguments);
    this.validate = (value) => {
      let errorMessage;
      if (!/[0-9-]+$/i.test(value)) {
        errorMessage = "Please enter a valid number";
      }
      return errorMessage;
    };
  }
  render() {
    const { fieldName } = this.props;
    return /* @__PURE__ */ React__default.createElement(FormikFormField, {
      label: "Phone Number",
      name: fieldName ? `${fieldName}.address` : "address",
      validate: this.validate,
      input: (props) => /* @__PURE__ */ React__default.createElement(TextInput, {
        inputClassName: "form-control input-sm",
        ...props,
        placeholder: "enter a phone number"
      }),
      required: true
    });
  }
}

const smsNotification = {
  component: SmsNotificationType,
  key: "sms",
  label: "SMS"
};

[
  bearyChatNotification,
  emailNotification,
  githubstatusNotification,
  googlechatNotification,
  microsoftTeamsNotification,
  pubsubNotification,
  slackNotification,
  smsNotification
].forEach((config) => {
  if (SETTINGS.notifications) {
    const notificationSetting = SETTINGS.notifications[config.key];
    if (notificationSetting == null ? void 0 : notificationSetting.enabled) {
      Registry.pipeline.registerNotification({
        config: { ...notificationSetting },
        ...cloneDeep(config)
      });
    }
  } else {
    Registry.pipeline.registerNotification(cloneDeep(config));
  }
});

const CORE_NOTIFICATION_NOTIFICATIONS_MODULE = "spinnaker.core.notifications";
module(CORE_NOTIFICATION_NOTIFICATIONS_MODULE, [NOTIFICATION_LIST]).run(() => {
  NotificationService.getNotificationTypeMetadata().then((types) => {
    types.filter((t) => t.uiType === "BASIC").forEach((t) => {
      Registry.pipeline.registerNotification({
        config: {},
        component: extensionNotificationConfig(t.parameters),
        key: t.notificationType,
        label: t.notificationType
      });
    });
  });
});

function anyFieldFilter() {
  return function(items, props) {
    let out = [];
    if (Array.isArray(items)) {
      items.forEach(function(item) {
        let itemMatches = false;
        const keys = Object.keys(props);
        for (const prop of keys) {
          const text = props[prop].toLowerCase();
          if (item[prop] && item[prop].toString().toLowerCase().includes(text)) {
            itemMatches = true;
            break;
          }
        }
        if (itemMatches) {
          out.push(item);
        }
      });
    } else {
      out = items;
    }
    return out;
  };
}
const ANY_FIELD_FILTER = "spinnaker.core.presentation.anyFieldFilter";
module(ANY_FIELD_FILTER, []).filter("anyFieldFilter", anyFieldFilter);

class AutoScrollController {
  constructor($timeout) {
    this.$timeout = $timeout;
    this.scrollEnabled = true;
    this.containerEvent = "scroll.autoScrollWatcher";
  }
  toggleAutoScrollEnabled(newVal) {
    if (newVal !== void 0) {
      this.scrollEnabled = newVal;
      this.autoScroll();
    }
  }
  autoScroll() {
    if (this.scrollEnabled) {
      this.$timeout(() => this.scrollableContainer.scrollTop(this.$element.height()));
    }
  }
  initialize() {
    this.scrollableContainer = this.autoScrollParent ? this.$element.closest(this.autoScrollParent) : this.$element.parent();
    if (this.onScroll) {
      this.scrollableContainer.on(this.containerEvent, (event) => {
        this.$timeout(() => this.onScroll(event));
      });
    }
    if (this.scrollToTop) {
      this.scrollToTop.subscribe(() => this.$timeout(() => this.scrollableContainer.scrollTop(0)));
      this.$scope.$on("$destroy", () => this.scrollToTop.unsubscribe());
    }
    this.$scope.$watch(this.$attrs.autoScrollEnabled, (newVal) => this.toggleAutoScrollEnabled(newVal), true);
    this.$scope.$watch(this.$attrs.autoScroll, () => this.autoScroll(), true);
    this.$scope.$on("$destroy", () => this.scrollableContainer.off(this.containerEvent));
  }
}
AutoScrollController.$inject = ["$timeout"];
const AUTO_SCROLL_DIRECTIVE = "spinnaker.core.autoScroll";
module(AUTO_SCROLL_DIRECTIVE, []).directive("autoScroll", function() {
  return {
    restrict: "A",
    controller: AutoScrollController,
    controllerAs: "$ctrl",
    bindToController: {
      autoScrollParent: "@?",
      autoScrollEnabled: "@?",
      onScroll: "=?",
      scrollToTop: "=?"
    },
    link: ($scope, $element, $attrs, ctrl) => {
      ctrl.$scope = $scope;
      ctrl.$element = $element;
      ctrl.$attrs = $attrs;
      ctrl.initialize();
    }
  };
});

const CORE_PRESENTATION_COLLAPSIBLESECTION_COLLAPSIBLESECTION_DIRECTIVE = "spinnaker.core.presentation.collapsibleSection.directive";
module(CORE_PRESENTATION_COLLAPSIBLESECTION_COLLAPSIBLESECTION_DIRECTIVE, []).directive("collapsibleSection", function() {
  return {
    restrict: "E",
    replace: true,
    transclude: {
      heading: "?sectionHeading",
      body: "?sectionBody"
    },
    scope: {
      heading: "@",
      expanded: "@?",
      bodyClass: "@?",
      cacheKey: "@?",
      helpKey: "@",
      subsection: "="
    },
    templateUrl: "core/src/presentation/collapsibleSection/collapsibleSection.directive.html",
    link: function(scope) {
      const cacheKey = scope.cacheKey || scope.heading;
      let expanded = true;
      if (cacheKey) {
        expanded = CollapsibleSectionStateCache.isSet(cacheKey) ? CollapsibleSectionStateCache.isExpanded(cacheKey) : scope.expanded === "true";
      }
      scope.state = { expanded };
      scope.getIconStyle = function() {
        return scope.state.expanded ? "transform: rotate(90deg); transition: all 0.15s ease" : "transform: rotate(0deg); transition: all 0.15s ease";
      };
      scope.getClassType = function() {
        return scope.subsection ? "sub" : "";
      };
      scope.toggle = function() {
        scope.state.expanded = !scope.state.expanded;
        if (cacheKey) {
          CollapsibleSectionStateCache.setExpanded(cacheKey, scope.state.expanded);
        }
      };
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/presentation/collapsibleSection/collapsibleSection.directive.html", `<div class="collapsible-{{getClassType()}}section">
  <a href class="section-{{getClassType()}}heading" ng-click="toggle()">
    <h4 class="collapsible-{{getClassType()}}heading">
      <span class="glyphicon glyphicon-chevron-right" style="{{getIconStyle()}}"></span>
      {{heading}}
      <span ng-transclude="heading"></span>
      <help-field ng-if="helpKey" key="{{helpKey}}" placement="right"></help-field>
    </h4>
  </a>
  <div class="content-body" ng-class="bodyClass" ng-if="heading && state.expanded" ng-transclude></div>
  <div class="content-body" ng-class="bodyClass" ng-if="!heading && state.expanded" ng-transclude="body"></div>
</div>
`);
}]);

function domPurifyOpenLinksInNewWindow() {
  DOMPurify.addHook("afterSanitizeAttributes", function(node) {
    if ("target" in node) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
    if (!node.hasAttribute("target") && (node.hasAttribute("xlink:href") || node.hasAttribute("href"))) {
      node.setAttribute("xlink:show", "new");
    }
    return node;
  });
}

const CORE_PRESENTATION_MARKDOWN = "core.presentation.markdown";
module(CORE_PRESENTATION_MARKDOWN, []).component("markdown", react2angular(withErrorBoundary(Markdown, "markdown"), ["message", "tag", "trim", "className", "options"]));

class PageNavigationState {
  static reset() {
    this.pages.length = 0;
    this.currentPageKey = null;
  }
  static setCurrentPage(key) {
    if (this.pages.some((p) => p.key === key)) {
      this.currentPageKey = key;
    }
  }
  static registerPage(page) {
    this.pages.push(page);
    if (!this.currentPageKey) {
      this.currentPageKey = page.key;
    }
  }
}
PageNavigationState.pages = [];

class PageSectionController {
  $onInit() {
    this.visible = this.visible !== false;
    this.pageConfig = {
      key: this.key,
      label: this.label,
      visible: this.visible,
      badge: this.badge
    };
    PageNavigationState.registerPage(this.pageConfig);
  }
  $onChanges(changes) {
    if (changes.visible && !changes.visible.isFirstChange()) {
      this.pageConfig.visible = changes.visible.currentValue;
    }
    if (changes.label && !changes.label.isFirstChange()) {
      this.pageConfig.label = changes.label.currentValue;
    }
    if (changes.badge && !changes.badge.isFirstChange()) {
      this.pageConfig.badge = changes.badge.currentValue;
    }
  }
}
const pageSectionComponent = {
  bindings: {
    key: "@",
    label: "@",
    badge: "<",
    visible: "<",
    noWrapper: "<"
  },
  controller: PageSectionController,
  transclude: true,
  template: `
    <div ng-if="$ctrl.pageConfig.visible" class="page-subheading flex-1" data-page-id="{{$ctrl.pageConfig.key}}">
      <h4 class="sticky-header">{{$ctrl.pageConfig.label}}</h4>
      <div ng-class="$ctrl.noWrapper ? 'no-wrapper' : 'section-body'" data-page-content="{{$ctrl.pageConfig.key}}" ng-transclude></div>
    </div>
  `
};
const PAGE_SECTION_COMPONENT = "spinnaker.core.presentation.navigation.pageSection";
module(PAGE_SECTION_COMPONENT, []).component("pageSection", pageSectionComponent);

var css_248z$e = "page-navigator,\n.page-navigator {\n  display: flex;\n}\npage-navigator .page-navigation,\n.page-navigator .page-navigation {\n  list-style-type: none;\n  text-transform: uppercase;\n  margin: 0;\n  padding: 0;\n}\npage-navigator .page-navigation li,\n.page-navigator .page-navigation li {\n  display: flex;\n}\npage-navigator .page-navigation li:hover,\n.page-navigator .page-navigation li:hover,\npage-navigator .page-navigation li.current,\n.page-navigator .page-navigation li.current {\n  background-color: var(--color-accent-g2);\n  font-weight: 600;\n}\npage-navigator .page-navigation li:hover a,\n.page-navigator .page-navigation li:hover a,\npage-navigator .page-navigation li.current a,\n.page-navigator .page-navigation li.current a {\n  color: var(--color-primary);\n}\npage-navigator .page-navigation li a,\n.page-navigator .page-navigation li a {\n  display: flex;\n  cursor: pointer;\n  text-decoration: none;\n  line-height: 15px;\n  padding: 10px;\n}\npage-navigator .page-navigation li a:focus,\n.page-navigator .page-navigation li a:focus {\n  color: var(--color-accent);\n}\npage-navigator page-section,\n.page-navigator page-section,\npage-navigator .page-section,\n.page-navigator .page-section {\n  display: flex;\n}\npage-navigator page-section .page-subheading,\n.page-navigator page-section .page-subheading,\npage-navigator .page-section .page-subheading,\n.page-navigator .page-section .page-subheading {\n  display: flex;\n  flex-direction: column;\n}\npage-navigator page-section .page-subheading .no-wrapper,\n.page-navigator page-section .page-subheading .no-wrapper,\npage-navigator .page-section .page-subheading .no-wrapper,\n.page-navigator .page-section .page-subheading .no-wrapper,\npage-navigator page-section .page-subheading .section-body,\n.page-navigator page-section .page-subheading .section-body,\npage-navigator .page-section .page-subheading .section-body,\n.page-navigator .page-section .page-subheading .section-body {\n  margin: 10px 10px 20px 10px;\n}\npage-navigator page-section .page-subheading .no-wrapper .add-new,\n.page-navigator page-section .page-subheading .no-wrapper .add-new,\npage-navigator .page-section .page-subheading .no-wrapper .add-new,\n.page-navigator .page-section .page-subheading .no-wrapper .add-new {\n  border-radius: 0;\n}\npage-navigator page-section .page-subheading .section-body,\n.page-navigator page-section .page-subheading .section-body,\npage-navigator .page-section .page-subheading .section-body,\n.page-navigator .page-section .page-subheading .section-body {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-cirrus);\n  padding: 15px;\n}\npage-navigator page-section .page-subheading:before,\n.page-navigator page-section .page-subheading:before,\npage-navigator .page-section .page-subheading:before,\n.page-navigator .page-section .page-subheading:before,\npage-navigator page-section .page-subheading:after,\n.page-navigator page-section .page-subheading:after,\npage-navigator .page-section .page-subheading:after,\n.page-navigator .page-section .page-subheading:after {\n  display: table;\n  content: \" \";\n}\npage-navigator page-section .page-subheading:after,\n.page-navigator page-section .page-subheading:after,\npage-navigator .page-section .page-subheading:after,\n.page-navigator .page-section .page-subheading:after {\n  clear: both;\n}\npage-navigator page-section .page-subheading h4.sticky-header,\n.page-navigator page-section .page-subheading h4.sticky-header,\npage-navigator .page-section .page-subheading h4.sticky-header,\n.page-navigator .page-section .page-subheading h4.sticky-header {\n  padding: 10px;\n  background-color: var(--color-accent-g2);\n  margin: 0;\n}\npage-navigator page-section .page-subheading .highlighted,\n.page-navigator page-section .page-subheading .highlighted,\npage-navigator .page-section .page-subheading .highlighted,\n.page-navigator .page-section .page-subheading .highlighted {\n  -webkit-animation: 0.5s ease-in-out 0 highlighted;\n          animation: 0.5s ease-in-out 0 highlighted;\n  -webkit-animation-iteration-count: 1;\n          animation-iteration-count: 1;\n}\n@-webkit-keyframes highlighted {\n  0% {\n    opacity: 0.25;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes highlighted {\n  0% {\n    opacity: 0.25;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n";
styleInject(css_248z$e);

class PageNavigatorController {
  constructor($element, $state, $stateParams) {
    this.$element = $element;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.pageNavigationState = PageNavigationState;
    this.hideNavigation = false;
  }
  getEventKey() {
    return `scroll.pageNavigation.${this.id}`;
  }
  $onInit() {
    this.id = UUIDGenerator.generateUuid();
    PageNavigationState.reset();
    this.container = this.$element.closest(this.scrollableContainer);
    if (isFunction(this.container.bind) && !this.hideNavigation) {
      this.container.bind(this.getEventKey(), throttle(() => this.handleScroll(), 20));
    }
    this.navigator = this.$element.find(".page-navigation");
    if (this.deepLinkParam && this.$stateParams[this.deepLinkParam]) {
      this.setCurrentSection(this.$stateParams[this.deepLinkParam]);
    }
  }
  $onDestroy() {
    if (isFunction(this.container.unbind) && !this.hideNavigation) {
      this.container.unbind(this.getEventKey());
    }
  }
  setCurrentSection(key) {
    PageNavigationState.setCurrentPage(key);
    this.syncLocation(key);
    ScrollToService.scrollTo(`[data-page-id=${key}]`, this.scrollableContainer, this.container.offset().top);
    this.container.find(".highlighted").removeClass("highlighted");
    this.container.find(`[data-page-id=${key}]`).addClass("highlighted");
  }
  handleScroll() {
    const navigatorRect = this.$element.get(0).getBoundingClientRect();
    const scrollableContainerTop = this.container.get(0).getBoundingClientRect().top;
    const currentPage = PageNavigationState.pages.find((p) => {
      const content = this.container.find(`[data-page-content=${p.key}]`);
      if (content.length) {
        return content.get(0).getBoundingClientRect().bottom > scrollableContainerTop;
      }
      return false;
    });
    if (currentPage) {
      PageNavigationState.setCurrentPage(currentPage.key);
      this.syncLocation(currentPage.key);
      this.navigator.find("li").removeClass("current");
      this.navigator.find(`[data-page-navigation-link=${currentPage.key}]`).addClass("current");
    }
    if (navigatorRect.top < scrollableContainerTop) {
      this.navigator.css({
        position: "fixed",
        width: this.navigator.get(0).getBoundingClientRect().width,
        top: scrollableContainerTop
      });
    } else {
      this.navigator.css({
        position: "relative",
        top: 0,
        width: "100%"
      });
    }
  }
  syncLocation(key) {
    if (this.deepLinkParam) {
      this.$state.go(".", { [this.deepLinkParam]: key }, { notify: false, location: "replace" });
    }
  }
}
PageNavigatorController.$inject = ["$element", "$state", "$stateParams"];
const pageNavigatorComponent = {
  bindings: {
    scrollableContainer: "@",
    deepLinkParam: "@?",
    hideNavigation: "<?"
  },
  controller: PageNavigatorController,
  transclude: true,
  template: `
    <div class="row flex-1">
      <div class="col-md-3 hidden-sm hidden-xs flex-1" ng-show="!$ctrl.hideNavigation">
        <ul class="page-navigation">
          <li ng-repeat="page in $ctrl.pageNavigationState.pages"
              data-page-navigation-link="{{page.key}}"
              ng-if="page.visible"
              ng-class="{current: $ctrl.pageNavigationState.currentPageKey === page.key}">
            <a href ng-click="$ctrl.setCurrentSection(page.key)">
              {{page.label}}
              <span ng-if="page.badge">({{page.badge}})</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-{{$ctrl.hideNavigation ? 12 : 9}} col-sm-12">
        <div class="sections" ng-transclude></div>
      </div>
    </div>
  `
};
const PAGE_NAVIGATOR_COMPONENT = "spinnaker.core.presentation.navigation.pageNavigator";
module(PAGE_NAVIGATOR_COMPONENT, [PAGE_SECTION_COMPONENT]).component("pageNavigator", pageNavigatorComponent);

const CORE_PRESENTATION_PERCENT_FILTER = "spinnaker.deck.core.filter.percent";
module(CORE_PRESENTATION_PERCENT_FILTER, []).filter("decimalToPercent", function() {
  return function(decimal) {
    return `${Math.round(decimal * 100)}%`;
  };
});

replace.$inject = ["$log"];
function replace($log) {
  return (str, regExStr, replaceValue) => {
    if (!isDefined(regExStr)) {
      $log.debug(`Did not supply regex string for 'replace' filter.`);
      return str;
    } else if (!isDefined(replaceValue)) {
      $log.debug(`Did not supply replacement value for 'replace' filter.`);
      return str;
    } else {
      return str.replace(new RegExp(regExStr, "g"), replaceValue);
    }
  };
}
const REPLACE_FILTER = "spinnaker.core.replace.filter";
module(REPLACE_FILTER, []).filter("replace", replace);

const CORE_PRESENTATION_SORTTOGGLE_SORTTOGGLE_DIRECTIVE = "spinnaker.core.presentation.sortToggle.directive";
module(CORE_PRESENTATION_SORTTOGGLE_SORTTOGGLE_DIRECTIVE, []).directive("sortToggle", function() {
  return {
    templateUrl: "core/src/presentation/sortToggle/sorttoggle.directive.html",
    scope: {
      key: "@",
      label: "@",
      onChange: "&",
      sortModel: "="
    },
    restrict: "A",
    controllerAs: "ctrl",
    controller: [
      "$scope",
      function($scope) {
        const ctrl = this;
        this.isSortKey = function(key) {
          const field = $scope.sortModel.key;
          return field === key || field === "-" + key;
        };
        this.isReverse = function() {
          return $scope.sortModel.key.indexOf("-") === 0;
        };
        this.setSortKey = function(key, $event) {
          $event.preventDefault();
          const predicate = ctrl.isSortKey(key) && ctrl.isReverse() ? "" : "-";
          $scope.sortModel.key = predicate + key;
          if ($scope.onChange) {
            $scope.onChange();
          }
        };
      }
    ]
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/presentation/sortToggle/sorttoggle.directive.html", `<span
  ng-class="{'inactive-sort-key' : !ctrl.isSortKey(key)}"
  class="sort-toggle clickable"
  ng-click="ctrl.setSortKey(key, $event)"
>
  {{ label }}
  <a>
    <span ng-if="!ctrl.isReverse() || !ctrl.isSortKey(key)" class="glyphicon glyphicon-Down-triangle"></span>
    <span ng-if="ctrl.isReverse() && ctrl.isSortKey(key)" class="glyphicon glyphicon-Up-triangle"></span>
  </a>
</span>
`);
}]);

var css_248z$d = ".details-panel.health-status-Healthy {\n  background-color: var(--color-success-light);\n  border-color: var(--color-success);\n}\n.details-panel.health-status-Unhealthy {\n  background-color: var(--color-danger-light);\n  border-color: var(--color-danger);\n}\n.details-panel.health-status-Unknown {\n  background-color: var(--color-accent-g2);\n  border-color: var(--color-accent);\n}\n.standalone {\n  overflow-y: auto;\n  margin-top: 20px;\n}\n.standalone .details-panel {\n  display: block;\n  width: 100%;\n  border-bottom-width: 1px;\n}\n.standalone .details-panel .header {\n  padding-top: 0;\n}\n.standalone .details-panel .content {\n  flex: 1 0 auto;\n}\n.band {\n  margin: 5px 0;\n  padding: 5px;\n  text-align: center;\n  color: var(--color-white);\n}\n.band.band-active {\n  background-color: var(--color-primary);\n}\n.band.band-info {\n  background-color: var(--color-dovegray);\n}\n.band.band-warning {\n  background-color: var(--color-danger);\n}\n.collapsible-section .band {\n  margin: 5px -20px;\n}\n.details-panel {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--color-white);\n  box-shadow: -2px 2px 6px -1px var(--color-alto);\n  margin-left: var(--xs-spacing);\n  padding-bottom: 12px;\n}\n.details-panel .actions {\n  display: flex;\n  flex-flow: row wrap;\n  margin: 0 -4px;\n}\n.details-panel .actions .btn-sm {\n  margin: 4px;\n}\n.details-panel .header {\n  border-bottom: 0;\n}\n.details-panel .header h4.text-center {\n  position: relative;\n  top: 100px;\n}\n.details-panel.disabled .header .header-text .glyphicon,\n.details-panel.OutOfService .header .header-text .glyphicon,\n.details-panel.disabled .header .header-text .icon,\n.details-panel.OutOfService .header .header-text .icon {\n  color: var(--color-titanium);\n}\n.details-panel .content {\n  flex: 1 0 100px;\n  overflow-y: auto;\n}\n.details-panel .header {\n  flex: none;\n  padding: 20px 15px 0 15px;\n  margin-bottom: 10px;\n}\n.details-panel .header .header-text {\n  word-break: break-all;\n  padding: 15px 0;\n}\n.details-panel .header .header-text .copy-to-clipboard .glyphicon {\n  color: inherit;\n  font-size: 150%;\n}\n.details-panel .header .header-text > .glyphicon,\n.details-panel .header .header-text > .fa {\n  color: var(--color-success-light);\n  font-size: 200%;\n  padding-right: 10px;\n}\n.details-panel .header .header-text > .glyphicon.Unhealthy,\n.details-panel .header .header-text > .fa.Unhealthy,\n.details-panel .header .header-text > .glyphicon.Down,\n.details-panel .header .header-text > .fa.Down {\n  color: var(--color-danger);\n}\n.details-panel .header .header-text > .glyphicon.Unknown,\n.details-panel .header .header-text > .fa.Unknown,\n.details-panel .header .header-text > .glyphicon.Starting,\n.details-panel .header .header-text > .fa.Starting {\n  color: var(--color-accent-g1);\n}\n.details-panel .header .header-text > .glyphicon.Starting,\n.details-panel .header .header-text > .fa.Starting {\n  -webkit-animation: pulse 1s steps(12) infinite;\n  animation: pulse 1s steps(12) infinite;\n}\n.details-panel .header .header-text > .glyphicon.disabled,\n.details-panel .header .header-text > .fa.disabled,\n.details-panel .header .header-text > .glyphicon.OutOfService,\n.details-panel .header .header-text > .fa.OutOfService {\n  color: var(--color-alto);\n}\n.details-panel .header .header-text h3 {\n  font-weight: 600;\n  font-size: 20px;\n  padding: 0;\n  margin: 0;\n  line-height: unset;\n}\n.details-panel .header .actions .uib-dropdown-menu {\n  min-width: 80px;\n}\n.details-panel .content-section,\n.details-panel .collapsible-section {\n  padding: 0;\n}\n.details-panel .content-section dl:last-child,\n.details-panel .collapsible-section dl:last-child,\n.details-panel .content-section ul:last-child,\n.details-panel .collapsible-section ul:last-child {\n  margin-bottom: 0;\n}\n.details-panel .content-section h4,\n.details-panel .collapsible-section h4 {\n  text-transform: uppercase;\n  font-size: 110%;\n  font-weight: 600;\n}\n.details-panel .content-section h4 .glyphicon,\n.details-panel .collapsible-section h4 .glyphicon,\n.details-panel .content-section h4 .icon,\n.details-panel .collapsible-section h4 .icon {\n  font-size: 13px;\n  opacity: 0.7;\n  margin-right: 4px;\n}\n.details-panel .content-section .content-body,\n.details-panel .collapsible-section .content-body {\n  padding: 0 17px;\n}\n.details-panel .content-section .content-body ul,\n.details-panel .collapsible-section .content-body ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n.details-panel .content-section .content-body .instance-health-counts,\n.details-panel .collapsible-section .content-body .instance-health-counts {\n  float: left !important;\n}\n.details-panel .content-section .content-body.details-running-tasks,\n.details-panel .collapsible-section .content-body.details-running-tasks {\n  background-color: var(--color-alabaster);\n  margin: 0;\n  padding: 10px 17px 20px;\n}\n.details-panel .content-section:last-child,\n.details-panel .collapsible-section:last-child {\n  border-bottom-width: 0;\n}\n.details-panel .content-section:first-child,\n.details-panel .collapsible-section:first-child {\n  padding-top: 0;\n  border-top: 1px solid var(--color-silver);\n}\n.details-panel .scaling-processes .fa-check {\n  color: var(--color-success);\n}\n";
styleInject(css_248z$d);

var css_248z$c = ".flex-container-h {\n  display: flex;\n  flex-flow: row nowrap;\n}\n.flex-container-h.baseline {\n  align-items: baseline;\n}\n.flex-container-h.center {\n  justify-content: center;\n}\n.flex-container-h.middle {\n  align-items: center;\n}\n.flex-container-h.top {\n  align-items: flex-start;\n}\n.flex-container-h.bottom {\n  align-items: flex-end;\n}\n.flex-container-h.space-between {\n  justify-content: space-between;\n}\n.flex-container-h.space-around {\n  justify-content: space-around;\n}\n.flex-container-h.right {\n  justify-content: flex-end;\n}\n.flex-container-h.margin-between-sm > * + * {\n  margin-left: 4px;\n}\n.flex-container-h.margin-between-md > * + * {\n  margin-left: 8px;\n}\n.flex-container-h.margin-between-lg > * + * {\n  margin-left: 12px;\n}\n.flex-container-v {\n  display: flex;\n  flex-flow: column nowrap;\n}\n.flex-container-v.center {\n  align-items: center;\n}\n.flex-container-v.middle {\n  justify-content: center;\n}\n.flex-container-v.right {\n  align-items: flex-end;\n}\n.flex-container-v.left {\n  align-items: flex-start;\n}\n.flex-container-v.bottom {\n  justify-content: flex-end;\n}\n.flex-container-v.space-around {\n  justify-content: space-around;\n}\n.flex-container-v.space-between {\n  justify-content: space-between;\n}\n.flex-container-v.margin-between-sm > * + * {\n  margin-top: 4px;\n}\n.flex-container-v.margin-between-md > * + * {\n  margin-top: 8px;\n}\n.flex-container-v.margin-between-lg > * + * {\n  margin-top: 12px;\n}\n.wrap {\n  flex-wrap: wrap !important;\n}\n.wrap-reverse {\n  flex-wrap: wrap-reverse;\n}\n.self-left {\n  align-self: flex-start;\n}\n.self-right {\n  align-self: flex-end;\n}\n.self-center {\n  align-self: center;\n}\n.self-stretch {\n  align-self: stretch;\n}\n.flex-grow {\n  flex: auto;\n  /* Same as flex: 1 1 auto; */\n}\n.flex-nogrow {\n  flex: 0 1 auto;\n  /* Same as flex: initial, or omitting flex: */\n}\n.flex-none {\n  flex: none;\n  /* Same as flex: 0 0 auto */\n}\n.flex-container-h .flex-pull-right,\n.flex-pull-right {\n  margin-left: auto;\n}\n.flex-container-h .flex-pull-left,\n.flex-pull-left {\n  margin-right: auto;\n}\n.flex-fill {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n}\n";
styleInject(css_248z$c);

var css_248z$b = "@-webkit-keyframes animate-glow {\n  0% {\n    opacity: 0.9;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 0.9;\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.25;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.25;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* Common mixins extracted from Bootstrap */\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes slideDown {\n  0% {\n    height: 0;\n    opacity: 0;\n  }\n  100% {\n    height: 100%;\n    opacity: 1;\n  }\n}\n@keyframes slideDown {\n  0% {\n    height: 0;\n    opacity: 0;\n  }\n  100% {\n    height: 100%;\n    opacity: 1;\n  }\n}\n.sticky-header {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  height: 36px;\n}\n.sticky-header .shadowed {\n  margin: 0;\n  display: flex;\n  flex: 1 1 auto;\n  background-color: var(--color-accent-g2);\n  align-items: center;\n}\n.sticky-header .shadowed.in-migration {\n  background-color: var(--color-status-warning-light);\n}\n.sticky-header:before,\n.sticky-header:after {\n  display: table;\n  content: \" \";\n}\n.sticky-header:after {\n  clear: both;\n}\n.sticky-header-2 {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 36px;\n  z-index: 2;\n}\n.sticky-header-3 {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 67px;\n  z-index: 1;\n}\n/* Resets for React select */\nhtml .Select--multi .Select-multi-value-wrapper,\nhtml .Select-control,\nhtml .Select-input {\n  height: 30px;\n}\nhtml .Select-input {\n  font-size: 12px;\n}\nhtml .Select-input input:invalid {\n  box-shadow: none;\n}\nhtml .Select-placeholder {\n  line-height: 30px;\n  height: inherit;\n}\nhtml .Select-placeholder,\nhtml .Select--single > .Select-control .Select-value {\n  line-height: 30px;\n}\n.form-field-loading {\n  padding: 12px;\n}\n/* Space out content a bit */\nbody {\n  font-family: 'Source Sans 3', sans-serif;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-bottom: 20px;\n  background-color: var(--color-alabaster);\n  padding-top: 125px;\n}\n.header,\n.footer {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n/* Custom page header */\n.header {\n  border-bottom: 1px solid var(--color-seashell);\n}\n/* Make the masthead heading the same height as the navigation */\n.header h3 {\n  margin-top: 0;\n  margin-bottom: 0;\n  line-height: 40px;\n  padding-bottom: 19px;\n}\n.ReactVirtualized__Grid:focus {\n  outline: none;\n}\nhtml .alert {\n  border-radius: 0;\n}\nhtml a {\n  color: var(--color-accent);\n}\nhtml a.disabled {\n  color: var(--color-concrete);\n}\nhtml .table > tbody > tr.info > td {\n  background-color: var(--color-accent-g2);\n}\nhtml .btn-link {\n  color: var(--color-accent);\n}\nhtml .btn-link.link-inverse {\n  color: var(--color-alabaster);\n}\nhtml .btn-link.link-inverse:active,\nhtml .btn-link.link-inverse:hover,\nhtml .btn-link.link-inverse:focus,\nhtml .btn-link.link-inverse.active {\n  color: var(--color-alto);\n}\nhtml .btn-link:active,\nhtml .btn-link:hover,\nhtml .btn-link:focus,\nhtml .btn-link.active {\n  color: var(--color-primary);\n}\nhtml .btn-primary {\n  background-color: var(--color-accent);\n  border-color: var(--color-accent);\n}\nhtml .btn-primary:active,\nhtml .btn-primary:hover,\nhtml .btn-primary:focus,\nhtml .btn-primary.active {\n  background-color: var(--color-accent);\n  border-color: var(--color-accent);\n}\nhtml .btn-primary[disabled],\nhtml .btn-primary[disabled]:hover {\n  background-color: var(--color-accent);\n  border-color: var(--color-accent);\n  opacity: 0.4;\n}\nhtml .open > .dropdown-toggle.btn-primary {\n  background-color: var(--color-accent);\n  border-color: var(--color-accent);\n}\nhtml .open > .dropdown-toggle.btn-primary:focus,\nhtml .open > .dropdown-toggle.btn-primary:active {\n  background-color: var(--color-accent);\n  border-color: var(--color-accent);\n}\nhtml .select2-container .select2-choices .select2-search-field input,\nhtml .select2-container .select2-choice,\nhtml .select2-container .select2-choices {\n  font-family: 'Source Sans 3', sans-serif;\n}\n.insight .main-content {\n  flex: 1 1 auto;\n}\n.insight .filters-content,\n.insight .nav-content,\n.insight .details-panel,\n.insight .main-content {\n  width: 100%;\n  overflow-x: visible;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.insight .filters-content > .header,\n.insight .nav-content > .header,\n.insight .details-panel > .header,\n.insight .main-content > .header {\n  flex: 0 0 auto;\n}\n.insight .filters-content > .content,\n.insight .nav-content > .content,\n.insight .details-panel > .content,\n.insight .main-content > .content {\n  flex: 1 1 100px;\n  overflow-y: auto;\n}\n.insight .filters-content {\n  overflow-x: hidden;\n}\n@media (min-width: 708px) and (max-width: 992px) {\n  .insight .filters-content {\n    font-size: 90%;\n  }\n  .insight .filters-content h3 {\n    font-size: 120%;\n  }\n  .insight .filters-content filter-section h4 {\n    font-size: 110%;\n  }\n}\n.insight .filters-content .content {\n  padding-bottom: 20px;\n}\n.insight .filters-content .collapsible-section {\n  border-bottom-width: 0;\n}\n.insight .filters-content .collapsible-section h4 {\n  margin: 0;\n  padding: 10px 0 0;\n  background-color: transparent;\n}\n.insight .filters-content .collapsible-section .content-body {\n  padding-left: 20px;\n  margin: 0;\n}\n.insight.filters-collapsed .collapse-margin-on-filter-collapse {\n  margin-left: 0;\n}\n.insight.filters-collapsed .horizontal-when-filters-collapsed dt {\n  float: left;\n  width: 160px;\n  overflow: hidden;\n  clear: left;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.insight.filters-collapsed .horizontal-when-filters-collapsed.dl-medium dt {\n  width: 100px;\n}\n.insight.filters-collapsed .horizontal-when-filters-collapsed.dl-medium dd {\n  margin-left: 120px;\n}\n.insight.filters-collapsed .horizontal-when-filters-collapsed dt {\n  width: 130px;\n}\n.insight.filters-collapsed .horizontal-when-filters-collapsed dd {\n  margin-left: 140px;\n}\n.insight.filters-collapsed .nav .content,\n.insight.filters-collapsed .nav .heading {\n  margin-left: -260px;\n  width: 260px;\n}\n.insight.filters-collapsed .main-content > .header {\n  margin-left: 68px;\n}\n.insight.filters-collapsed .nav-content > .header {\n  margin-left: 80px;\n}\n.insight.filters-expanded .nav .content {\n  padding-bottom: 20px;\n}\n.insight.filters-expanded .nav .content,\n.insight.filters-expanded .nav .heading {\n  margin-left: 0;\n  width: inherit;\n  display: block;\n}\n.insight.filters-expanded .nav ::-webkit-scrollbar {\n  background: transparent;\n  width: 0;\n}\n@media (min-width: 768px) and (max-width: 992px) {\n  .insight.filters-expanded .nav {\n    width: 104px;\n  }\n}\n@media (min-width: 992px) {\n  .insight.filters-expanded .nav {\n    width: 124px;\n  }\n}\n@media (min-width: 1200px) {\n  .insight.filters-expanded .nav {\n    width: 154px;\n  }\n}\n@media (min-width: 1400px) {\n  .insight.filters-expanded .nav {\n    width: 184px;\n  }\n}\n@media (min-width: 1600px) {\n  .insight.filters-expanded .nav {\n    width: 214px;\n  }\n}\n@media (min-width: 1800px) {\n  .insight.filters-expanded .nav {\n    width: 234px;\n  }\n}\n@media (min-width: 2000px) {\n  .insight.filters-expanded .nav {\n    width: 254px;\n  }\n}\n.insight.filters-expanded .nav .filters-placeholder {\n  display: none;\n}\n.insight .nav {\n  overflow-x: hidden;\n  position: relative;\n  padding-top: 5px;\n}\n.insight .nav .pin {\n  padding-left: 5px;\n}\n.insight .nav .unpin {\n  padding-right: 5px;\n}\n.insight .nav .menu-toggle {\n  text-align: right;\n  margin: 10px;\n}\n.insight .nav .filters-placeholder {\n  font-size: 120%;\n}\n.insight .nav .insight-filter-content {\n  width: 100%;\n}\n.insight .detail-content {\n  z-index: var(--layer-high);\n  position: absolute;\n  margin-top: -20px;\n  height: 100%;\n  width: 390px;\n  box-shadow: 2px 2px 6px -1px var(--color-alto);\n  right: 0;\n  overflow-y: hidden;\n}\n@media (max-width: 390px) {\n  .insight .detail-content {\n    width: 100%;\n  }\n}\n.insight .detail-content react-ui-view-adapter {\n  width: 100%;\n  overflow-x: visible !important;\n}\n.insight .nav-content {\n  margin-right: 25px;\n}\n.insight.details-closed .nav-content {\n  max-width: 100%;\n}\n.insight.details-open.filters-collapsed.nav-collapsed .nav-content {\n  max-width: calc(100% - 390px);\n}\n@media (max-width: 1170px) {\n  .insight.details-open.filters-collapsed.nav-collapsed .nav-content {\n    max-width: 100%;\n  }\n}\n.insight.details-open.filters-expanded.nav-collapsed .nav-content {\n  max-width: calc(100% - 390px);\n}\n@media (max-width: 1340px) {\n  .insight.details-open.filters-expanded.nav-collapsed .nav-content {\n    max-width: 100%;\n  }\n}\n.insight.details-open.filters-collapsed.nav-expanded .nav-content {\n  max-width: calc(100% - 390px);\n}\n@media (max-width: 1410px) {\n  .insight.details-open.filters-collapsed.nav-expanded .nav-content {\n    max-width: 100%;\n  }\n}\n.insight.details-open.filters-expanded.nav-expanded .nav-content {\n  max-width: calc(100% - 390px);\n}\n@media (max-width: 1580px) {\n  .insight.details-open.filters-expanded.nav-expanded .nav-content {\n    max-width: 100%;\n  }\n}\n.insight .full-content {\n  margin: 0 25px;\n  flex-direction: column;\n  width: 100%;\n}\n.no-padding {\n  padding: 0;\n}\n.no-left-padding {\n  padding-left: 0 !important;\n}\n.no-margin {\n  margin: 0;\n}\n.no-border {\n  border-width: 0;\n}\n.flat {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.inactive-sort-key .glyphicon {\n  opacity: 0.5;\n}\n.secondary-panel .close-button,\n.details-panel .close-button {\n  float: right;\n  margin-top: -15px;\n  margin-right: -10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n.secondary-panel .close-button a,\n.details-panel .close-button a {\n  padding: 0;\n  font-size: 125%;\n  color: var(--color-concrete);\n}\n.glyphicon-Warn:before {\n  content: '\\26A0';\n  color: var(--color-danger);\n  font-weight: bold;\n}\n.glyphicon-Normal:before {\n  content: '\\2022';\n  color: var(--color-success);\n  font-weight: bold;\n}\n.glyphicon-Up-triangle:before {\n  content: '\\25B2';\n  color: var(--color-success);\n  font-size: 75%;\n}\n.glyphicon-Down-triangle:before {\n  content: '\\25BC';\n  color: var(--color-danger);\n  font-size: 75%;\n}\n.glyphicon-Unknown-triangle,\n.glyphicon-Starting-triangle {\n  display: inline-block;\n  padding-bottom: 3px;\n}\n.glyphicon-Unknown-triangle:before,\n.glyphicon-Starting-triangle:before {\n  content: '\\2666';\n  font-weight: 900;\n  color: var(--color-accent-g1);\n  font-size: 85%;\n}\n.glyphicon-OutOfService-triangle:before {\n  content: '\\2212';\n  font-weight: 900;\n  color: var(--color-titanium);\n  font-size: 80%;\n}\n.glyphicon-Failed-triangle:before {\n  content: '\\2717';\n  font-weight: 900;\n  color: var(--color-danger);\n  font-size: 120%;\n}\n.glyphicon-Succeeded-triangle:before {\n  content: '\\2713';\n  font-weight: 900;\n  color: var(--color-success);\n  font-size: 120%;\n}\ndl {\n  overflow-wrap: break-word;\n}\n.dl-horizontal dt {\n  float: left;\n  width: 160px;\n  overflow: hidden;\n  clear: left;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dl-horizontal.dl-medium dt {\n  width: 100px;\n}\n.dl-horizontal.dl-medium dd {\n  margin-left: 120px;\n}\n.dl-wide dt {\n  width: 130px;\n}\n.dl-wide dd {\n  margin-left: 140px;\n}\n.dl-narrow dt {\n  width: 90px;\n}\n.dl-narrow dd {\n  margin-left: 100px;\n}\n.tooltip-inner {\n  overflow-wrap: break-word;\n  max-width: 350px;\n  text-align: left;\n}\n.tooltip-inner p:last-child {\n  margin-bottom: 0;\n}\n.tooltip-table {\n  width: 120px;\n}\n.tooltip-table td,\n.tooltip-table th {\n  text-align: left;\n  vertical-align: top;\n  padding: 2px;\n}\nbody > .container {\n  margin-top: 20px;\n}\n.container-narrow > hr {\n  margin: 30px 0;\n}\n.no-highlight {\n  color: var(--color-black);\n}\n.no-highlight:hover,\n.no-highlight:focus {\n  text-decoration: none;\n  color: var(--color-black);\n}\n.navbar-inverse {\n  background-color: var(--color-primary);\n  border: none;\n}\n.navbar-inverse .container {\n  padding: 0;\n}\n.navbar-inverse .navbar-brand {\n  color: var(--color-white);\n  text-shadow: none;\n  font-weight: 200;\n  height: 100%;\n  padding: 10px 30px 10px 0;\n}\n@media (max-width: 480px) {\n  .navbar-inverse .navbar-brand {\n    padding-left: 10px;\n  }\n}\n.navbar-inverse .navbar-nav > li > a,\n.navbar-inverse .nav-items > li > a {\n  color: var(--color-white);\n  font-weight: 200;\n  padding: 10px 15px;\n  margin: 0 5px;\n  border: 0;\n}\n@media (max-width: 992px) {\n  .navbar-inverse .navbar-nav > li > a,\n  .navbar-inverse .nav-items > li > a {\n    padding: 10px;\n    margin: 0;\n  }\n}\n.navbar-inverse .navbar-nav > li > a:focus,\n.navbar-inverse .nav-items > li > a:focus,\n.navbar-inverse .navbar-nav > li > a:hover,\n.navbar-inverse .nav-items > li > a:hover {\n  border-top-color: var(--color-cirrus);\n  background-color: var(--color-primary-g1);\n  transition: border-top-color 0.2s, background-color 0.2s;\n}\n.navbar-inverse .nav-items > .active > a,\n.navbar-inverse .nav-items > .active > a:focus,\n.navbar-inverse .nav-items > .active > a:hover,\n.navbar-inverse .navbar-nav > .active > a,\n.navbar-inverse .navbar-nav > .active > a:focus,\n.navbar-inverse .navbar-nav > .active > a:hover {\n  background-color: transparent;\n  font-weight: 200;\n  border-top-color: var(--color-white);\n}\n.form-horizontal .control-label-right {\n  padding-top: 7px;\n  margin-bottom: 0;\n  text-align: right;\n  font-weight: bold;\n}\n.sm-label,\n.sm-label-left,\n.sm-label-right {\n  margin-top: 5px;\n  font-weight: bold;\n  text-align: right;\n}\n.sm-label.compact,\n.sm-label-left.compact,\n.sm-label-right.compact {\n  line-height: 20px;\n}\n.sm-label.table-offset,\n.sm-label-left.table-offset,\n.sm-label-right.table-offset {\n  margin-top: 31px;\n}\n.sm-label .help-text,\n.sm-label-left .help-text,\n.sm-label-right .help-text {\n  font-size: 90%;\n  font-weight: normal;\n  color: var(--color-dovegray);\n  line-height: normal;\n  margin-bottom: 0;\n}\n.sm-control-field {\n  margin-top: 5px;\n}\n.sm-label-left {\n  text-align: left;\n}\n.sm-label-right {\n  text-align: right;\n}\n@media (max-width: 992px) {\n  .sm-label-right {\n    text-align: left;\n  }\n}\n.form-control.inline-number {\n  width: 100px;\n  display: inline-block;\n}\n.form-control.inline-text {\n  width: 150px;\n  display: inline-block;\n}\n.with-space-before {\n  margin-left: 4px;\n}\n.checkbox-padding {\n  padding-left: 35px;\n}\n.modal-content {\n  border-radius: 3px;\n}\n.modal-content ::-webkit-scrollbar {\n  background: transparent;\n  width: 8px;\n}\n.modal-content ::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n.modal-content :hover ::-webkit-scrollbar-thumb {\n  background: var(--color-silver);\n}\n/* This class is used to override the uibModal default z-index value of 1050 */\n.modal-z-index {\n  z-index: var(--layer-critical) !important;\n}\n.modal-pages {\n  width: 1200px;\n}\n.modal-pages .modal-page {\n  position: relative;\n  width: 600px;\n}\n.full-width {\n  display: block;\n  width: 100%;\n}\n.flex-break {\n  flex-basis: 100%;\n  height: 0;\n}\n.add-new {\n  border: 1px dashed var(--color-concrete);\n  color: var(--color-concrete);\n  padding: 8px;\n  margin: 5px 0 20px;\n  cursor: pointer;\n  background-color: transparent;\n}\n.add-new.small {\n  padding: 5px;\n  font-size: 80%;\n}\n.add-new:hover,\n.add-new:focus,\n.add-new:active {\n  border-color: var(--color-black);\n  color: var(--color-black);\n}\n.add-new.sub-select {\n  width: 100%;\n  margin: 20px 0 0 0;\n}\ntfoot .add-new {\n  margin-bottom: 0;\n}\n.form-control.invalid {\n  border-color: var(--color-danger);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.form-control.invalid:focus {\n  border-color: var(--color-danger);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px var(--color-danger-light);\n}\ninput:invalid,\nselect:invalid {\n  border-color: var(--color-danger);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px var(--color-danger-light);\n}\n.form-control.ng-invalid.ng-dirty,\n.form-control.ng-invalid.ng-invalid-validate-min,\n.form-control.ng-invalid.ng-invalid-validate-max,\n.form-control.ng-invalid.ng-invalid-required,\n.form-control.ng-invalid.highlight-pristine {\n  border-color: var(--color-danger);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.form-control.ng-invalid.ng-dirty:focus,\n.form-control.ng-invalid.ng-invalid-validate-min:focus,\n.form-control.ng-invalid.ng-invalid-validate-max:focus,\n.form-control.ng-invalid.ng-invalid-required:focus,\n.form-control.ng-invalid.highlight-pristine:focus {\n  border-color: var(--color-danger);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px var(--color-danger-light);\n}\n.highlight-pristine .ng-invalid {\n  border-color: var(--color-danger);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.highlight-pristine .ng-invalid:focus {\n  border-color: var(--color-danger);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px var(--color-danger-light);\n}\n.table.packed {\n  margin-bottom: 0;\n}\n.form-group {\n  margin-bottom: 5px;\n}\n.row.config-description {\n  margin-bottom: 30px;\n}\n.checklist li {\n  list-style-type: none;\n}\n.checklist li label {\n  font-weight: normal;\n}\n.checklist ul {\n  padding-left: 0;\n  margin-bottom: 0;\n}\n.error-message {\n  text-align: left;\n  display: block;\n  font-weight: 600;\n  color: var(--color-danger);\n}\n.success-message {\n  text-align: left;\n  display: block;\n  font-weight: 600;\n  color: var(--color-success);\n}\n.warning-message {\n  text-align: left;\n  display: block;\n  font-weight: 600;\n  color: var(--color-warning);\n}\n.application-list a {\n  color: var(--color-accent);\n}\n.spinner {\n  width: 14px;\n  height: 14px;\n  top: 8px;\n  left: 5px;\n  position: relative;\n  display: inline-block;\n}\n.loading {\n  text-align: center;\n  padding-top: 160px;\n}\n.loader {\n  opacity: 0.6;\n  text-align: center;\n  margin-top: 3px;\n}\n.loader:before {\n  font-family: 'Glyphicons Halflings';\n  font-weight: 400;\n  position: relative;\n  height: 0 !important;\n  line-height: 0 !important;\n  padding-top: 0.5px;\n  margin: 0;\n  opacity: 0.7;\n  transform: translateZ(0);\n  -webkit-animation: spin 4s steps(120) infinite;\n  animation: spin 4s steps(120) infinite;\n  content: '*';\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 4px;\n}\n.dropdown .dropdown-header {\n  margin-top: 15px;\n}\n.dropdown .dropdown-header:first-child {\n  margin-top: 0;\n}\n.pad-left {\n  padding-left: 10px;\n}\n.transition-overlay {\n  z-index: 1031;\n  background-color: var(--color-alabaster);\n  opacity: 0.7;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  transition: opacity 0.2s;\n}\n.panel {\n  border: 1px solid var(--color-silver);\n  border-radius: 3px;\n}\n.panel .summary {\n  font-size: 110%;\n  padding: 10px;\n}\n.panel .details {\n  border-top: 1px solid var(--color-silver);\n  background-color: var(--color-white);\n}\n.collapsible-subsection {\n  padding: 0;\n}\n.collapsible-subsection a.section-subheading {\n  color: var(--color-black);\n}\n.collapsible-subsection h4.collapsible-subheading {\n  padding: 10px 15px;\n  background-color: var(--color-alabaster);\n  margin: 0;\n  font-size: 115%;\n  font-weight: 200;\n}\n.collapsible-subsection h4.collapsible-subheading .glyphicon {\n  font-size: 13px;\n  opacity: 0.7;\n  margin-right: 4px;\n  font-weight: 200;\n}\n.collapsible-subsection .content-body {\n  -webkit-animation: 0.15 ease-in 0 fadeIn;\n          animation: 0.15 ease-in 0 fadeIn;\n  -webkit-animation-iteration-count: 1;\n          animation-iteration-count: 1;\n  padding-left: 17px;\n  margin: 10px 0 20px 0;\n}\n.collapsible-subsection .content-body:before,\n.collapsible-subsection .content-body:after {\n  display: table;\n  content: \" \";\n}\n.collapsible-subsection .content-body:after {\n  clear: both;\n}\n.collapsible-subsection .content-body ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n.collapsible-subsection:last-child {\n  border-bottom-width: 0;\n}\n.collapsible-subsection:first-child {\n  padding-top: 0;\n}\n.section-heading-chevron {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n.section-heading-chevron.left {\n  margin-right: 4px;\n}\n.section-heading-chevron.right {\n  margin-left: 4px;\n}\n.rotate-0 {\n  transition: transform 0.15s ease;\n  transform: rotate(0deg);\n}\n.rotate-m90 {\n  transition: transform 0.15s ease;\n  transform: rotate(-90deg);\n}\n.rotate-p90 {\n  transition: transform 0.15s ease;\n  transform: rotate(90deg);\n}\n.rotate-m180 {\n  transition: transform 0.15s ease;\n  transform: rotate(-180deg);\n}\n.rotate-p180 {\n  transition: transform 0.15s ease;\n  transform: rotate(180deg);\n}\n.rotate-m270 {\n  transition: transform 0.15s ease;\n  transform: rotate(-270deg);\n}\n.rotate-p270 {\n  transition: transform 0.15s ease;\n  transform: rotate(270deg);\n}\n.collapsible-section {\n  padding: 0;\n  border-top: 1px solid var(--color-silver);\n}\n.collapsible-section a.section-heading {\n  color: var(--color-black);\n}\n.collapsible-section h4.collapsible-heading {\n  padding: 10px 15px;\n  background-color: var(--color-alabaster);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 115%;\n}\n.collapsible-section .content-body {\n  -webkit-animation: 0.15 ease-in 0 fadeIn;\n          animation: 0.15 ease-in 0 fadeIn;\n  -webkit-animation-iteration-count: 1;\n          animation-iteration-count: 1;\n  padding-left: 17px;\n  margin: 10px 0 20px 0;\n}\n.collapsible-section .content-body:before,\n.collapsible-section .content-body:after {\n  display: table;\n  content: \" \";\n}\n.collapsible-section .content-body:after {\n  clear: both;\n}\n.collapsible-section .content-body ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n.collapsible-section:last-child {\n  border-bottom-width: 0;\n}\n.collapsible-section:first-child {\n  padding-top: 0;\n}\n.collapsible-filter-section {\n  padding: 0;\n}\n.collapsible-filter-section a.section-heading {\n  color: var(--color-black);\n  text-decoration: none;\n}\n.collapsible-filter-section h4 {\n  padding: 10px 5px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 115%;\n}\n.collapsible-filter-section h4 .glyphicon {\n  font-size: 13px;\n  margin-right: 4px;\n  margin-left: auto;\n}\n.collapsible-filter-section h4 .arrow {\n  visibility: hidden;\n}\n.collapsible-filter-section h4:hover {\n  background-color: var(--color-accent-g3);\n}\n.collapsible-filter-section h4:hover .arrow {\n  visibility: visible;\n  text-decoration: none;\n}\n.collapsible-filter-section .content-body {\n  -webkit-animation: 0.15 ease-in 0 fadeIn;\n          animation: 0.15 ease-in 0 fadeIn;\n  -webkit-animation-iteration-count: 1;\n          animation-iteration-count: 1;\n  padding-left: 4px;\n}\n.collapsible-filter-section .content-body:before,\n.collapsible-filter-section .content-body:after {\n  display: table;\n  content: \" \";\n}\n.collapsible-filter-section .content-body:after {\n  clear: both;\n}\n.collapsible-filter-section .content-body ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n.collapsible-filter-section .content-body .form-group {\n  margin-top: 10px;\n}\n.collapsible-filter-section .content-body .form-group input[type='number'] {\n  width: 55px;\n}\n.collapsible-filter-section:last-child {\n  border-bottom-width: 0;\n}\n.collapsible-filter-section:first-child {\n  padding-top: 0;\n}\n.sort-toggle a {\n  color: var(--color-black);\n}\n.sort-toggle .glyphicon {\n  font-size: 0.75em;\n  top: 0px;\n}\n.sort-toggle .glyphicon:before {\n  color: var(--color-dovegray);\n}\n.clickable {\n  cursor: pointer;\n}\n.as-link {\n  cursor: pointer;\n}\n.as-link:hover {\n  text-decoration: underline;\n}\n.glyphicon-spinning {\n  display: inline-block;\n  height: 0 !important;\n  line-height: 0 !important;\n  padding-top: 0.5px;\n  margin: 0;\n  opacity: 0.7;\n  transform: translateZ(0);\n  -webkit-animation: spin 4s steps(120) infinite;\n  animation: spin 4s steps(120) infinite;\n}\n.fa.fa-spin {\n  transform: translateZ(0);\n  -webkit-animation: spin 4s steps(120) infinite;\n  animation: spin 4s steps(120) infinite;\n  opacity: 0.7;\n}\n.fa-spin-slow {\n  transform: translateZ(0);\n  -webkit-animation: spin 6s steps(180) infinite;\n  animation: spin 6s steps(180) infinite;\n}\n.help-field {\n  color: var(--color-concrete);\n  opacity: 0.8;\n}\n.help-field:active,\n.help-field:hover {\n  opacity: 1;\n}\n.help-field span,\n.help-field i {\n  top: 0;\n  font-size: 70%;\n}\ndiv.text-only {\n  display: inline-block;\n}\ndiv.text-only .help-field {\n  color: var(--color-mineshaft);\n  text-decoration: none;\n  border-bottom: 1px dashed var(--color-concrete);\n}\n.popover {\n  max-width: 400px;\n}\ntextarea.code {\n  font-family: monospace;\n  width: 100%;\n}\n.warning-text {\n  color: var(--color-danger);\n}\n.modal.no-animate {\n  transition: none;\n}\n.modal.no-animate .modal-dialog {\n  transition: none;\n}\n.modal-open .modal {\n  z-index: var(--layer-critical) !important;\n}\n.modal.in .modal-dialog {\n  transform: none;\n}\n.modal-backdrop {\n  z-index: 9500 !important;\n}\n.modal-backdrop.modal-backdrop-no-animate {\n  background-color: var(--color-alabaster);\n  transition: none;\n}\n.modal-backdrop.modal-backdrop-no-animate.fade .modal-dialog {\n  transition: none;\n}\n.btn-light {\n  border: none;\n  background: transparent;\n}\n.nest {\n  margin-left: 30px;\n}\n.well-compact {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n.text-disabled {\n  color: var(--color-concrete);\n}\nselect.input-sm {\n  padding-left: 5px;\n  padding-right: 0;\n}\n.Select.input-sm {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  border: none;\n}\n.Select.input-sm .Select-option {\n  padding: 5px 10px;\n}\n.Select.input-sm .Select-control {\n  display: flex;\n  justify-content: space-between;\n}\n.Select.input-sm .Select-control .Select-value,\n.Select.input-sm .Select-control .Select-arrow-zone {\n  line-height: 30px;\n}\n.Select.input-sm .Select-menu-outer {\n  margin: -1px 0 0;\n  left: 0;\n  right: 0;\n  width: unset;\n}\n.Select.input-sm .Select-clear-zone {\n  position: absolute;\n  right: 25px;\n  line-height: 30px;\n}\n.select-placeholder {\n  display: inline-block;\n  padding-left: 14px;\n}\n.Select.is-open {\n  z-index: 10000;\n}\nhtml {\n  overflow: hidden;\n}\nbody,\nhtml {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n.spinnaker-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 768px) and (max-width: 1200px) {\n  .spinnaker-container .container {\n    width: 100%;\n    padding: 0;\n  }\n}\n.spinnaker-container .spinnaker-content {\n  flex: 1 1 auto;\n  display: flex;\n  overflow-y: auto;\n  flex-direction: column;\n  align-items: stretch;\n}\n.spinnaker-container .spinnaker-content > [name='main'] {\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  flex: 1 1 auto;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  position: relative;\n}\n@media (min-width: 768px) and (max-width: 992px) {\n  .spinnaker-container .spinnaker-content > [name='main'] {\n    margin: 0;\n    width: 100%;\n  }\n}\n.spinnaker-container .spinnaker-content .scrollable-columns {\n  background-color: var(--color-alabaster);\n  flex: 1 1 auto;\n  display: flex;\n  overflow-y: hidden;\n  padding-top: 20px;\n  padding-left: 15px;\n}\n.spinnaker-container .spinnaker-content .scrollable-columns > div {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n}\n.spinnaker-container .spinnaker-content .scrollable-columns .insight {\n  display: flex;\n  flex: 1;\n  margin-left: 0;\n}\n.spinnaker-container .spinnaker-content .scrollable-columns .insight > div {\n  display: flex;\n  overflow: visible;\n}\n.spinnaker-container .spinnaker-content .scrollable-columns .insight react-ui-view-adapter {\n  display: flex;\n  width: 100%;\n  overflow-x: hidden;\n}\n.ui-select-multiple .select2-drop {\n  width: calc(100% - 40px);\n  margin-left: 1px;\n}\n.select2-results .select2-disabled {\n  background-color: transparent;\n  opacity: 0.5;\n}\n.select2-results .select2-disabled:hover,\n.select2-results .select2-disabled.select2-highlighted {\n  background-color: transparent;\n}\n.select2-results .select2-disabled .select2-result-label {\n  cursor: default;\n  background-color: transparent;\n}\nul.select2-results {\n  max-height: 225px;\n}\n.select2.select2-container.ng-invalid-required a.select2-default {\n  border: 1px solid var(--color-danger);\n}\n.select2-container.input-sm.direction-up .select2-drop-active {\n  border-top: 1px solid var(--color-accent);\n  padding-top: 3px;\n  margin-bottom: 3px;\n}\n.select2-container.input-sm.direction-up .select2-choice {\n  border-bottom-color: var(--color-accent);\n}\nbody > .select2-container.open {\n  z-index: 10003;\n}\n.tooltip,\n.popover {\n  font-family: 'Source Sans 3', sans-serif;\n  z-index: 10004;\n}\n.btn-configure {\n  padding: 6px;\n}\n.btn-configure:hover,\n.btn-configure:active {\n  border: 1px solid var(--color-accent);\n  background-color: var(--color-cirrus);\n  transition: border-color 0.2s, background-color 0.2s, color 0.2s;\n}\n.checkbox help-field .help-contents {\n  margin-left: 20px;\n}\n.checkbox-inline + .checkbox-inline,\n.radio-inline + .radio-inline {\n  margin-left: 0 !important;\n}\n.checkbox-inline,\n.radio-inline {\n  margin-right: 15px;\n}\n.checkbox-inline:last-of-type,\n.radio-inline:last-of-type {\n  margin-right: 0;\n}\nul.checkmap {\n  padding-left: 0;\n}\nul.checkmap li {\n  list-style-type: none;\n}\nul.checkmap li label {\n  font-weight: normal;\n}\nul.checkmap ul {\n  padding-left: 0;\n  margin-bottom: 0;\n}\n.checkmap-group {\n  display: inline-table;\n  min-width: 120px;\n}\n.checkmap-header {\n  font-weight: bold;\n  text-decoration: underline;\n  padding-left: 16px;\n}\n.break-word {\n  overflow-wrap: break-word;\n}\n.horizontal-rule {\n  border-top: 1px solid var(--color-alto);\n  margin-top: 2px;\n  margin-bottom: 5px;\n}\n.bottom-border {\n  border-bottom: 1px solid var(--color-cirrus);\n  padding-bottom: 10px;\n}\n.visible-xl-inline {\n  display: none !important;\n}\n@media (min-width: 1400px) {\n  .visible-xl-inline {\n    display: inline !important;\n  }\n  .hidden-xl-inline {\n    display: none !important;\n  }\n}\n.popover.no-padding .popover-content {\n  padding: 0;\n  max-height: 50vh;\n  overflow-y: auto;\n}\n.fa-exclamation-triangle {\n  color: var(--color-danger);\n}\n.fa-info-circle {\n  color: var(--color-accent);\n}\n.dropdown-menu {\n  z-index: var(--layer-critical);\n}\n.dropdown-menu li > a {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  color: var(--color-mineshaft);\n  white-space: nowrap;\n  cursor: pointer;\n}\n.dropdown-menu li > a:hover,\n.dropdown-menu li > a:focus {\n  background-color: var(--color-alabaster);\n  text-decoration: none;\n  color: var(--color-mineshaft);\n}\ndiv.modal-header.has-sticky-headers {\n  position: relative;\n  z-index: 5;\n}\n.component-heading {\n  padding: 0;\n  margin-bottom: 10px;\n}\n.component-heading.sticky-header {\n  top: -15px;\n}\n.component-heading h4 {\n  padding: 10px;\n  margin-bottom: 0;\n  color: var(--color-primary);\n  background-color: var(--color-accent-g2);\n}\n.component-body {\n  padding: 0 10px;\n}\n.component-body table.table th {\n  border-top: none;\n}\n.component-body table.table.no-lines th {\n  border-bottom: 1px solid var(--color-seashell);\n}\n.component-body table.table.no-lines tr td {\n  border-top: none;\n}\n.badge.badge-running-count {\n  border-radius: 3px;\n  background-color: var(--color-accent);\n  padding: 3px 6px;\n}\n@media (max-width: 1400px) {\n  .badge.badge-running-count {\n    font-size: 10px;\n  }\n}\n.spinner-container {\n  height: 100px;\n}\n.main-footer {\n  border-top: 1px solid var(--color-alto);\n  padding-top: 10px;\n  margin-top: 10px;\n}\n.main-footer .alert {\n  display: inline-block;\n  margin-bottom: 0;\n  padding: 6px 12px;\n  vertical-align: middle;\n}\n.fixed-footer {\n  position: fixed;\n  z-index: 4;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 5px;\n  background-color: var(--color-white);\n  margin: 0;\n  border-top: 1px solid var(--color-alto);\n}\n.fixed-footer .fixed-footer-button {\n  padding: 0;\n  margin-left: auto;\n}\nbutton.as-link {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\nbutton.as-link:hover {\n  text-decoration: underline;\n}\n";
styleInject(css_248z$b);

var css_248z$a = ".nav-popover {\n  font-weight: 600;\n  color: var(--color-mineshaft);\n}\n.nav-popover .small {\n  color: var(--color-mineshaft);\n}\n.nav-popover:hover,\n.nav-popover:active,\n.nav-popover:focus {\n  color: var(--color-mineshaft);\n  text-decoration: none;\n}\n";
styleInject(css_248z$a);

const CORE_PRESENTATION_PRESENTATION_MODULE = "spinnaker.core.presentation";
module(CORE_PRESENTATION_PRESENTATION_MODULE, [
  ANY_FIELD_FILTER,
  AUTO_SCROLL_DIRECTIVE,
  LINK_WITH_CLIPBOARD,
  PAGE_NAVIGATOR_COMPONENT,
  PAGE_SECTION_COMPONENT,
  CORE_PRESENTATION_COLLAPSIBLESECTION_COLLAPSIBLESECTION_DIRECTIVE,
  CORE_PRESENTATION_ISVISIBLE_ISVISIBLE_DIRECTIVE,
  CORE_PRESENTATION_MARKDOWN,
  ROBOT_TO_HUMAN_FILTER,
  CORE_PRESENTATION_SORTTOGGLE_SORTTOGGLE_DIRECTIVE,
  CORE_PRESENTATION_PERCENT_FILTER,
  REPLACE_FILTER
]).run(domPurifyOpenLinksInNewWindow);

const CORE_PROJECTS_DASHBOARD_REGIONFILTER_REGIONFILTER_SERVICE = "spinnaker.deck.projects.dashboard.regionFilter.service";
module(CORE_PROJECTS_DASHBOARD_REGIONFILTER_REGIONFILTER_SERVICE, []).factory("regionFilterService", function() {
  let callbacks = [];
  const filterModelConfig = [{ model: "region", param: "reg", type: "trueKeyObject" }];
  FilterModelService.configureFilterModel(this, filterModelConfig);
  this.registerCallback = (cb) => callbacks.push(cb);
  this.deregisterCallback = (cb) => callbacks = ___default.without(callbacks, cb);
  this.runCallbacks = () => callbacks.forEach((cb) => cb(this.sortFilter.region));
  this.toggleRegion = (region) => {
    const path = `sortFilter.region[${region}]`;
    ___default.set(this, path, !___default.get(this, path));
    this.applyParamsToUrl();
    this.runCallbacks();
  };
  this.clearFilter = () => {
    ___default.forEach(this.sortFilter.region, (val, key) => delete this.sortFilter.region[key]);
    this.applyParamsToUrl();
    this.runCallbacks();
  };
  this.activate();
  return this;
});

var css_248z$9 = "project-cluster .rollup-summary .container-fluid {\n  width: 100%;\n}\nproject-cluster .cluster-name {\n  display: inline-block;\n  margin-right: 10px;\n  text-transform: uppercase;\n}\nproject-cluster .cluster-health {\n  background-color: var(--color-accent-g2);\n  font-size: 80%;\n  padding-right: 10px;\n}\nproject-cluster .rollup-title-cell .pod-center {\n  border-right: none;\n}\nproject-cluster .health-counts {\n  font-size: 80%;\n}\nproject-cluster table .instance-health-counts {\n  float: none !important;\n  font-size: 120%;\n}\nproject-cluster table.table > thead > tr > th {\n  border-bottom-width: 1px;\n}\nproject-cluster .rollup-entry,\nproject-cluster .table {\n  margin-bottom: 0;\n  background-color: transparent;\n  border: none;\n}\nproject-cluster .rollup-entry:last-child,\nproject-cluster .table:last-child {\n  background-color: transparent;\n}\nproject-cluster .rollup-details {\n  background-color: transparent;\n  border: none;\n  margin-left: 25px;\n  margin-right: 10px;\n}\nproject-cluster .rollup-details a {\n  color: var(--color-mineshaft);\n}\nproject-cluster .rollup-details a.heavy {\n  font-weight: 600;\n}\nproject-cluster .rollup-details a:hover,\nproject-cluster .rollup-details a:active {\n  color: var(--color-mineshaft);\n}\nproject-cluster .rollup-details .text-warning {\n  color: var(--color-alert);\n}\nproject-cluster .rollup-details .instance-health-counts {\n  padding-left: 0;\n}\n";
styleInject(css_248z$9);

const CORE_PROJECTS_DASHBOARD_CLUSTER_PROJECTCLUSTER_DIRECTIVE = "spinnaker.core.projects.dashboard.clusters.projectCluster.directive";
module(CORE_PROJECTS_DASHBOARD_CLUSTER_PROJECTCLUSTER_DIRECTIVE, [
  TIME_FORMATTERS,
  HEALTH_COUNTS_COMPONENT,
  CORE_PROJECTS_DASHBOARD_REGIONFILTER_REGIONFILTER_SERVICE
]).directive("projectCluster", function() {
  return {
    restrict: "E",
    templateUrl: "core/src/projects/dashboard/cluster/projectCluster.directive.html",
    scope: {},
    bindToController: {
      project: "=",
      cluster: "="
    },
    controller: "ProjectClusterCtrl",
    controllerAs: "vm"
  };
}).controller("ProjectClusterCtrl", [
  "$scope",
  "regionFilterService",
  function($scope, regionFilterService) {
    const stateCache = CollapsibleSectionStateCache;
    const getCacheKey = () => [this.project.name, this.cluster.account, this.cluster.stack].join(":");
    this.clearFilters = (r) => ClusterState.filterService.overrideFiltersForUrl(r);
    this.refreshTooltipTemplate = "core/src/projects/dashboard/cluster/projectClusterRefresh.tooltip.html";
    this.inconsistentBuildsTemplate = "core/src/projects/dashboard/cluster/inconsistentBuilds.tooltip.html";
    this.toggle = () => {
      this.state.expanded = !this.state.expanded;
      stateCache.setExpanded(getCacheKey(), this.state.expanded);
    };
    const getMetadata = (application) => {
      const stack = this.cluster.stack;
      const detail = this.cluster.detail;
      const clusterParam = !stack && !detail ? application.name : null;
      const stackParam = stack && stack !== "*" ? stack : null;
      const detailParam = detail && detail !== "*" ? detail : null;
      return {
        type: "clusters",
        project: this.project.name,
        application: application.application,
        cluster: clusterParam,
        stack: stackParam,
        detail: detailParam,
        account: this.cluster.account
      };
    };
    const addMetadata = (application) => {
      const baseMetadata = getMetadata(application);
      application.metadata = baseMetadata;
      application.metadata.href = UrlBuilder.buildFromMetadata(baseMetadata);
      application.clusters.forEach((cluster) => {
        const clusterMetadata = getMetadata(application);
        clusterMetadata.region = cluster.region;
        clusterMetadata.href = UrlBuilder.buildFromMetadata(clusterMetadata);
        cluster.metadata = clusterMetadata;
      });
    };
    const getBuildUrl = (build) => [build.host + "job", build.job, build.buildNumber, ""].join("/");
    const addApplicationBuild = (application) => {
      const allBuilds = ___default.chain((application.clusters || []).map((cluster) => cluster.builds)).flatten().compact().uniqBy((build) => build.buildNumber).value();
      if (allBuilds.length) {
        application.build = ___default.maxBy(allBuilds, (build) => Number(build.buildNumber));
        application.build.url = getBuildUrl(application.build);
        application.hasInconsistentBuilds = allBuilds.length > 1;
      }
    };
    const applyInconsistentBuildFlag = (application) => {
      application.clusters.forEach((cluster) => {
        const builds = cluster.builds || [];
        if (builds.length && (builds.length > 1 || builds[0].buildNumber !== application.build.buildNumber)) {
          application.hasInconsistentBuilds = true;
          cluster.inconsistentBuilds = cluster.builds.filter((build) => build.buildNumber !== application.build.buildNumber);
        }
      });
    };
    const mapClustersToRegions = (cluster, application) => {
      application.regions = {};
      cluster.regions.forEach((region) => {
        application.regions[region] = ___default.find(application.clusters, (regionCluster) => regionCluster.region === region);
      });
    };
    const addRegions = (cluster) => {
      cluster.regions = ___default.uniq(___default.flatten(cluster.applications.map((application) => application.clusters.map((regionCluster) => regionCluster.region)))).sort();
    };
    const setViewRegions = (updatedFilter) => {
      const unfilteredRegions = this.cluster.regions;
      if (Object.keys(___default.filter(updatedFilter)).length) {
        this.regions = unfilteredRegions.filter((region) => updatedFilter[region]);
      } else {
        this.regions = unfilteredRegions;
      }
    };
    const setViewInstanceCounts = (updatedFilter) => {
      if (Object.keys(___default.filter(updatedFilter)).length) {
        this.instanceCounts = ___default.chain(this.cluster.applications).map("clusters").flatten().value().reduce((instanceCounts, cluster) => {
          if (updatedFilter[cluster.region]) {
            ___default.forEach(cluster.instanceCounts, (count, key) => {
              if (!instanceCounts[key]) {
                instanceCounts[key] = 0;
              }
              instanceCounts[key] += count;
            });
          }
          return instanceCounts;
        }, {});
      } else {
        this.instanceCounts = this.cluster.instanceCounts;
      }
    };
    const initialize = () => {
      this.state = {
        expanded: stateCache.isSet(getCacheKey()) ? stateCache.isExpanded(getCacheKey()) : true
      };
      [setViewInstanceCounts, setViewRegions].forEach((cb) => {
        regionFilterService.registerCallback(cb);
        $scope.$on("$destroy", () => regionFilterService.deregisterCallback(cb));
      });
      addRegions(this.cluster);
      regionFilterService.runCallbacks();
      this.cluster.applications.forEach((application) => {
        mapClustersToRegions(this.cluster, application);
        addApplicationBuild(application);
        applyInconsistentBuildFlag(application);
        addMetadata(application);
      });
      this.clusterLabel = this.cluster.detail ? [this.cluster.stack, this.cluster.detail].join("-") : this.cluster.stack;
    };
    this.$onInit = () => initialize();
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/projects/dashboard/cluster/projectCluster.directive.html", `<div class="row rollup-entry sub-group">
  <div class="rollup-summary">
    <div class="container-fluid no-padding">
      <div class="row clickable" ng-click="vm.toggle()">
        <div class="col-md-12">
          <div class="rollup-title-cell">
            <collapsible-account-tag account="{{vm.cluster.account}}" state="vm.state"></collapsible-account-tag>
            <div class="pod-center horizontal space-between center flex-1">
              <span class="cluster-name">{{vm.clusterLabel}}</span>
            </div>
            <span class="cluster-health">
              {{vm.cluster.applications.length}} Application<span ng-if="vm.cluster.applications.length !== 1">s</span>
            </span>
            <span class="cluster-health"> {{vm.instanceCounts.total}} Instances </span>
            <health-counts container="vm.instanceCounts"></health-counts>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="rollup-details" ng-if="vm.state.expanded">
    <div ng-if="!vm.cluster.applications.length" class="text-center">
      <p>No clusters found for any applications.</p>
    </div>
    <div ng-if="!vm.regions.length" class="text-center">
      <p>No clusters found for selected regions / namespaces.</p>
    </div>
    <table class="table table-condensed" ng-if="vm.cluster.applications.length && vm.regions.length">
      <thead>
        <tr>
          <th width="18%"></th>
          <th width="9%"></th>
          <th width="15%">Last Push</th>
          <th ng-repeat="region in vm.regions" width="{{57/vm.regions.length}}%">{{region}}</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="application in vm.cluster.applications | orderBy: 'name'">
          <td>
            <a
              class="heavy"
              ng-click="vm.clearFilters(application.metadata)"
              ng-href="{{application.metadata.href}}"
              ng-class="application.hasInconsistentBuilds ? 'text-warning' : ''"
            >
              {{application.application | uppercase}}
            </a>
          </td>
          <td>
            <a
              class="heavy"
              ng-if="application.build.buildNumber && !application.build.images"
              href="{{application.build.url}}"
              target="_blank"
            >
              <span>#</span>{{application.build.buildNumber}}
            </a>
            <ul class="list-unstyled" ng-if="application.build.images">
              <li ng-repeat="image in application.build.images">{{ image }}</li>
            </ul>
            <i
              ng-if="application.hasInconsistentBuilds"
              class="fa fa-exclamation-triangle text-warning"
              uib-tooltip="Some server groups are deployed with an older build."
            ></i>
          </td>
          <td>
            <span ng-if="!application.lastPush"> - </span>
            <span class="small" ng-if="application.lastPush"> {{application.lastPush | relativeTime }} </span>
          </td>
          <td ng-repeat="region in vm.regions">
            <span ng-if="application.regions[region]">
              <a
                ng-click="vm.clearFilters(application.regions[region].metadata)"
                ng-href="{{application.regions[region].metadata.href}}"
              >
                <health-counts
                  container="application.regions[region].instanceCounts"
                  additional-legend-text="'(Click to view cluster in this region)'"
                  legend-placement="'right'"
                ></health-counts>
              </a>
              <span ng-if="application.regions[region].inconsistentBuilds.length">
                <i class="fa fa-exclamation-triangle" uib-tooltip-template="vm.inconsistentBuildsTemplate"></i>
              </span>
            </span>
            <span ng-if="!application.regions[region]"> - </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/projects/dashboard/cluster/projectClusterRefresh.tooltip.html", `<p ng-if="vm.state.refreshing">Cluster data is <strong>refreshing</strong></p>
<p ng-if="!vm.state.refreshing">(click <span class="fa fa-sync-alt"></span> to refresh)</p>
<p>
  Last refresh: {{vm.state.lastRefresh | timestamp }} <br />
  ({{vm.state.lastRefresh | relativeTime }})
</p>
<p class="small"><strong>Note:</strong> Due to caching, data may be delayed up to 2 minutes</p>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/projects/dashboard/cluster/inconsistentBuilds.tooltip.html", `<span ng-repeat="build in application.regions[region].inconsistentBuilds">
  Build #{{build.buildNumber}}: deployed {{build.deployed | relativeTime }}
</span>
`);
}]);

var css_248z$8 = "project-pipeline {\n  display: block;\n}\nproject-pipeline a {\n  color: var(--color-mineshaft);\n  text-decoration: none;\n}\nproject-pipeline .execution-title {\n  font-weight: 600;\n  display: inline-block;\n  margin: 5px 0 0 0;\n}\nproject-pipeline .build-label.execution-build-number {\n  display: none;\n}\nproject-pipeline a.execution-build-number {\n  display: inline;\n}\nproject-pipeline .execution-bar {\n  width: 100%;\n  padding-top: 0;\n}\nproject-pipeline .execution-bar .stage {\n  display: inline-block;\n  height: 15px;\n  opacity: 0.65;\n}\nproject-pipeline .execution-bar .stage:hover {\n  opacity: 1;\n}\n";
styleInject(css_248z$8);

class ProjectPipeline extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleExecutionTitleClick = () => {
      ReactInjector.$state.go("^.application.pipelines.executions.execution", {
        application: this.props.execution.application,
        executionId: this.props.execution.id
      });
    };
    this.handleStageClick = (stageIndex) => {
      ReactInjector.$state.go("^.application.pipelines.executionDetails.execution", {
        application: this.props.execution.application,
        executionId: this.props.execution.id,
        stage: stageIndex
      });
    };
    this.state = {
      hasBuildInfo: this.props.execution.buildInfo || has(this.props.execution, "trigger.buildInfo") || has(this.props.execution, "trigger.parentPipelineId"),
      loaded: true,
      stageWidth: `${100 / this.props.execution.stageSummaries.length}%`
    };
  }
  render() {
    const execution = this.props.execution;
    const stages = execution.stageSummaries.map((stage) => /* @__PURE__ */ React__default.createElement(ExecutionMarker, {
      key: stage.refId,
      ...this.props,
      stage,
      onClick: this.handleStageClick,
      width: this.state.stageWidth
    }));
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("h5", {
      className: "execution-title"
    }, /* @__PURE__ */ React__default.createElement("a", {
      onClick: this.handleExecutionTitleClick
    }, `${execution.application.toUpperCase()}: ${execution.name}`)), "\xA0(", /* @__PURE__ */ React__default.createElement(ExecutionBuildLink, {
      execution
    }), this.state.hasBuildInfo && /* @__PURE__ */ React__default.createElement("span", null, ", "), "started ", timestamp(this.props.execution.startTime), ")", /* @__PURE__ */ React__default.createElement("div", {
      className: "execution-bar"
    }, stages));
  }
}

const PROJECT_PIPELINE_COMPONENT = "spinnaker.core.projects.dashboard.pipelines.projectPipeline.component";
module(PROJECT_PIPELINE_COMPONENT, []).component("projectPipeline", react2angular(withErrorBoundary(ProjectPipeline, "projectPipeline"), ["execution", "application"]));

var css_248z$7 = "region-filter .region-filter-button {\n  margin-right: 5px;\n}\n";
styleInject(css_248z$7);

const CORE_PROJECTS_DASHBOARD_REGIONFILTER_REGIONFILTER_COMPONENT = "spinnaker.deck.projects.dashboard.regionFilter.component";
module(CORE_PROJECTS_DASHBOARD_REGIONFILTER_REGIONFILTER_COMPONENT, [
  CORE_PROJECTS_DASHBOARD_REGIONFILTER_REGIONFILTER_SERVICE
]).component("regionFilter", {
  bindings: {
    regionFilter: "=",
    regions: "="
  },
  templateUrl: "core/src/projects/dashboard/regionFilter/regionFilter.component.html",
  controller: [
    "regionFilterService",
    function(regionFilterService) {
      this.clearFilter = regionFilterService.clearFilter;
      this.toggleRegion = regionFilterService.toggleRegion;
      this.sortFilter = regionFilterService.sortFilter;
    }
  ]
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/projects/dashboard/regionFilter/regionFilter.component.html", `<span uib-dropdown class="pull-right clickable" on-toggle="toggled(open)" auto-close="outsideClick">
  <h6 href uib-dropdown-toggle>
    <span class="region-filter-button">Filter by region / namespace</span>
    <span class="small glyphicon glyphicon-chevron-down"></span>
  </h6>
  <ul class="dropdown-menu" uib-dropdown-menu role="menu">
    <li ng-repeat="region in $ctrl.regions">
      <a ng-click="$ctrl.toggleRegion(region)">
        <label>{{ region }}</label>
        <input class="pull-right" type="checkbox" ng-model="$ctrl.sortFilter.region[region]" />
      </a>
    </li>
    <li class="text-center">
      <a ng-click="$ctrl.clearFilter()">Clear all</a>
    </li>
  </ul>
</span>
`);
}]);

var css_248z$6 = ".project-dashboard {\n  overflow-y: auto;\n}\n.project-dashboard h3 {\n  font-weight: 600;\n}\n.project-dashboard .project-column {\n  overflow-x: scroll;\n}\n";
styleInject(css_248z$6);

const CORE_PROJECTS_DASHBOARD_DASHBOARD_CONTROLLER = "spinnaker.core.projects.dashboard.controller";
module(CORE_PROJECTS_DASHBOARD_DASHBOARD_CONTROLLER, [
  CORE_PROJECTS_DASHBOARD_CLUSTER_PROJECTCLUSTER_DIRECTIVE,
  PROJECT_PIPELINE_COMPONENT,
  EXECUTION_SERVICE,
  CORE_PROJECTS_DASHBOARD_REGIONFILTER_REGIONFILTER_COMPONENT,
  CORE_PROJECTS_DASHBOARD_REGIONFILTER_REGIONFILTER_SERVICE
]).controller("ProjectDashboardCtrl", [
  "$scope",
  "$rootScope",
  "projectConfiguration",
  "executionService",
  "regionFilterService",
  "$q",
  function($scope, $rootScope, projectConfiguration, executionService, regionFilterService, $q) {
    this.project = projectConfiguration;
    this.application = ApplicationModelBuilder.createStandaloneApplication("project");
    this.clusterRefreshTooltipTemplate = "core/src/projects/dashboard/clusterRefresh.tooltip.html";
    this.executionRefreshTooltipTemplate = "core/src/projects/dashboard/executionRefresh.tooltip.html";
    if (projectConfiguration.notFound) {
      RecentHistoryService.removeLastItem("projects");
      return;
    } else {
      RecentHistoryService.addExtraDataToLatest("projects", {
        config: {
          applications: projectConfiguration.config.applications
        }
      });
    }
    this.state = {
      executions: {
        initializing: true,
        refreshing: false,
        loaded: false,
        error: false
      },
      clusters: {
        initializing: true,
        refreshing: false,
        loaded: false,
        error: false
      }
    };
    const getClusters = () => {
      const state = this.state.clusters;
      state.error = false;
      state.refreshing = true;
      const clusterCount = ___default.get(projectConfiguration.config.clusters, "length");
      let clustersPromise;
      if (clusterCount > 0) {
        clustersPromise = ProjectReader.getProjectClusters(projectConfiguration.name);
      } else if (clusterCount === 0) {
        clustersPromise = $q.when([]);
      } else {
        clustersPromise = $q.reject(null);
      }
      return clustersPromise.then((clusters) => {
        this.clusters = clusters;
        this.allRegions = getAllRegions(clusters);
        state.initializing = false;
        state.loaded = true;
        state.refreshing = false;
        state.lastRefresh = new Date().getTime();
      }).catch(() => {
        state.initializing = false;
        state.refreshing = false;
        state.error = true;
      });
    };
    const getExecutions = () => {
      const state = this.state.executions;
      state.error = false;
      state.refreshing = true;
      return executionService.getProjectExecutions(projectConfiguration.name).then((executions) => {
        this.executions = executions;
        state.initializing = false;
        state.loaded = true;
        state.refreshing = false;
        state.lastRefresh = new Date().getTime();
        regionFilterService.activate();
        regionFilterService.runCallbacks();
      }).catch(() => {
        state.initializing = false;
        state.refreshing = false;
        state.error = true;
      });
    };
    const getAllRegions = (clusters) => {
      return ___default.chain(clusters).map("applications").flatten().map("clusters").flatten().map("region").uniq().value();
    };
    const clusterScheduler = SchedulerFactory.createScheduler(3 * 60 * 1e3);
    const executionScheduler = SchedulerFactory.createScheduler(3 * 60 * 1e3);
    const clusterLoader = clusterScheduler.subscribe(getClusters);
    const executionLoader = executionScheduler.subscribe(getExecutions);
    $scope.$on("$destroy", () => {
      clusterScheduler.unsubscribe();
      clusterLoader.unsubscribe();
      executionScheduler.unsubscribe();
      executionLoader.unsubscribe();
    });
    this.refreshClusters = clusterScheduler.scheduleImmediate;
    this.refreshExecutions = executionScheduler.scheduleImmediate;
    this.refreshClusters();
    this.refreshExecutions();
    $scope.$on("$destroy", $rootScope.$on("$locationChangeSuccess", () => {
      regionFilterService.activate();
      regionFilterService.runCallbacks();
    }));
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/projects/dashboard/clusterRefresh.tooltip.html", `<p ng-if="vm.state.refreshing">Cluster data is <strong>refreshing</strong>.</p>
<p ng-if="!vm.state.refreshing">(click <span class="fa fa-sync-alt"></span> to refresh)</p>
<p>
  Last refresh:<br />
  {{vm.state.lastRefresh | timestamp }} <br />
  ({{vm.state.lastRefresh | relativeTime }})
</p>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/projects/dashboard/executionRefresh.tooltip.html", `<p ng-if="vm.state.refreshing">Pipeline data is <strong>refreshing</strong>.</p>
<p ng-if="!vm.state.refreshing">(click <span class="fa fa-sync-alt"></span> to refresh)</p>
<p>
  Last refresh:<br />
  {{vm.state.lastRefresh | timestamp }} <br />
  ({{vm.state.lastRefresh | relativeTime }})
</p>
`);
}]);

const CORE_PROJECTS_PROJECTS_CONTROLLER = "spinnaker.projects.controller";
module(CORE_PROJECTS_PROJECTS_CONTROLLER, [
  UIROUTER_ANGULARJS,
  ANY_FIELD_FILTER,
  CORE_PRESENTATION_SORTTOGGLE_SORTTOGGLE_DIRECTIVE,
  INSIGHT_MENU_DIRECTIVE
]).component("projectInsightMenu", react2angular(withErrorBoundary(InsightMenu, "projectInsightMenu"), [
  "createApp",
  "createProject",
  "refreshCaches"
])).controller("ProjectsCtrl", [
  "$scope",
  "$uibModal",
  "$log",
  "$filter",
  function($scope, $uibModal, $log, $filter) {
    const projectsViewStateCache = ViewStateCache.get("projects") || ViewStateCache.createCache("projects", { version: 1 });
    function cacheViewState() {
      projectsViewStateCache.put("#global", $scope.viewState);
    }
    function initializeViewState() {
      $scope.viewState = projectsViewStateCache.get("#global") || {
        sortModel: { key: "name" },
        projectFilter: ""
      };
    }
    $scope.projectsLoaded = false;
    $scope.projectFilter = "";
    $scope.menuActions = [
      {
        displayName: "Create Project",
        action: function() {
          ConfigureProjectModal.show().catch(() => {
          });
        }
      }
    ];
    this.filterProjects = function filterProjects() {
      const filtered = $filter("anyFieldFilter")($scope.projects, {
        name: $scope.viewState.projectFilter,
        email: $scope.viewState.projectFilter
      });
      const sorted = $filter("orderBy")(filtered, $scope.viewState.sortModel.key);
      $scope.filteredProjects = sorted;
      this.resetPaginator();
    };
    this.resultPage = function resultPage() {
      const pagination = $scope.pagination;
      const allFiltered = $scope.filteredProjects;
      const start = (pagination.currentPage - 1) * pagination.itemsPerPage;
      const end = pagination.currentPage * pagination.itemsPerPage;
      if (!allFiltered || !allFiltered.length) {
        return [];
      }
      if (allFiltered.length < pagination.itemsPerPage) {
        return allFiltered;
      }
      if (allFiltered.length < end) {
        return allFiltered.slice(start);
      }
      return allFiltered.slice(start, end);
    };
    this.resetPaginator = function resetPaginator() {
      $scope.pagination = {
        currentPage: 1,
        itemsPerPage: 12,
        maxSize: 12
      };
    };
    const ctrl = this;
    ProjectReader.listProjects().then(function(projects) {
      $scope.projects = projects;
      ctrl.filterProjects();
      $scope.projectsLoaded = true;
    });
    $scope.$watch("viewState", cacheViewState, true);
    initializeViewState();
  }
]);

const PROJECTS_STATES_CONFIG = "spinnaker.core.projects.state.config";
module(PROJECTS_STATES_CONFIG, [
  CORE_PROJECTS_PROJECTS_CONTROLLER,
  CORE_PROJECTS_DASHBOARD_DASHBOARD_CONTROLLER,
  APPLICATION_STATE_PROVIDER,
  STATE_CONFIG_PROVIDER
]).config([
  "stateConfigProvider",
  "applicationStateProvider",
  (stateConfigProvider, applicationStateProvider) => {
    const dashboard = {
      name: "dashboard",
      url: "/dashboard",
      views: {
        detail: {
          templateUrl: "core/src/projects/dashboard/dashboard.html",
          controller: "ProjectDashboardCtrl",
          controllerAs: "vm"
        }
      },
      data: {
        pageTitleSection: {
          title: "Dashboard"
        }
      }
    };
    const project = {
      name: "project",
      url: "/projects/{project}",
      resolve: {
        projectConfiguration: [
          "$stateParams",
          ($stateParams) => {
            return ProjectReader.getProjectConfig($stateParams.project).then((projectConfig) => projectConfig, () => {
              return {
                id: null,
                name: $stateParams.project,
                email: null,
                config: null,
                notFound: true
              };
            });
          }
        ]
      },
      views: {
        "main@": {
          component: ProjectHeader,
          $type: "react"
        }
      },
      data: {
        pageTitleMain: {
          field: "project"
        },
        history: {
          type: "projects",
          state: "home.project",
          keyParams: ["project"]
        }
      },
      children: [dashboard]
    };
    const allProjects = {
      name: "projects",
      url: "/projects",
      views: {
        "main@": {
          templateUrl: "core/src/projects/projects.html",
          controller: "ProjectsCtrl",
          controllerAs: "ctrl"
        }
      },
      data: {
        pageTitleMain: {
          label: "Projects"
        }
      }
    };
    stateConfigProvider.addToRootState(allProjects);
    stateConfigProvider.addToRootState(project);
    applicationStateProvider.addParentState(project, "detail", "/applications");
    stateConfigProvider.addRewriteRule("/projects/{project}", "/projects/{project}/dashboard");
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/projects/dashboard/dashboard.html", `<div ng-if="!vm.project.notFound" class="project-dashboard container">
  <div class="row">
    <div class="col-md-7 project-column">
      <h3>
        Application Status
        <component-refresher
          state="vm.state.clusters"
          template-url="vm.clusterRefreshTooltipTemplate"
          refresh="vm.refreshClusters()"
        ></component-refresher>
        <region-filter region-filter="regionFilter" regions="vm.allRegions"></region-filter>
      </h3>
      <project-cluster ng-repeat="cluster in vm.clusters" project="vm.project" cluster="cluster"></project-cluster>
      <div class="horizontal center" ng-if="!vm.state.clusters.loaded">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
      <h4 ng-if="!vm.project.config.clusters.length">No clusters configured</h4>
      <h4 ng-if="vm.state.clusters.error">There was a problem loading the clusters for this project.</h4>
    </div>
    <div class="col-md-5 project-column">
      <h3>
        Pipeline Status
        <component-refresher
          state="vm.state.executions"
          template-url="vm.executionRefreshTooltipTemplate"
          refresh="vm.refreshExecutions()"
        ></component-refresher>
      </h3>
      <div class="horizontal center" ng-if="!vm.state.executions.loaded">
        <loading-spinner size="'small'"></loading-spinner>
      </div>
      <project-pipeline
        ng-repeat="execution in vm.executions"
        execution="execution"
        application="vm.application"
      ></project-pipeline>
      <h4 ng-if="!vm.project.config.pipelineConfigs.length">No pipelines configured</h4>
      <h4 ng-if="vm.state.executions.error">There was a problem loading the executions for this project.</h4>
    </div>
  </div>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/projects/projects.html", `<div class="infrastructure">
  <div class="infrastructure-section search-header">
    <div class="container">
      <h2 class="header-section">
        <span class="search-label">Projects</span>
        <input
          type="search"
          placeholder="Search projects"
          class="form-control input-md"
          focus
          ng-model="viewState.projectFilter"
          ng-change="ctrl.filterProjects()"
        />
      </h2>
      <div class="header-actions">
        <project-insight-menu create-app="false" create-project="true" refresh-caches="false" />
      </div>
    </div>
  </div>
  <div class="container">
    <div ng-if="!projectsLoaded" class="horizontal center middle" style="margin-bottom: 250px; height: 100px">
      <loading-spinner size="'small'"></loading-spinner>
    </div>
    <table ng-if="projectsLoaded" class="table table-hover">
      <thead>
        <tr>
          <th
            width="20%"
            sort-toggle
            key="name"
            label="Name"
            sort-model="viewState.sortModel"
            on-change="ctrl.filterProjects()"
          ></th>
          <th
            width="20%"
            sort-toggle
            key="createTs"
            label="Created"
            sort-model="viewState.sortModel"
            on-change="ctrl.filterProjects()"
          ></th>
          <th
            width="20%"
            sort-toggle
            key="updateTs"
            label="Updated"
            sort-model="viewState.sortModel"
            on-change="ctrl.filterProjects()"
          ></th>
          <th
            width="25%"
            sort-toggle
            key="email"
            label="Owner"
            sort-model="viewState.sortModel"
            on-change="ctrl.filterProjects()"
          ></th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="clickable"
          ng-repeat="project in ctrl.resultPage()"
          ui-sref="home.project.dashboard({project: project.name.toLowerCase()})"
        >
          <td>
            <a href ui-sref="home.project.dashboard({project: project.name.toLowerCase()})">
              {{ project.name.toLowerCase() }}
            </a>
          </td>
          <td>{{ project.createTs | timestamp }}</td>
          <td>{{ project.updateTs | timestamp }}</td>
          <td>{{ project.email }}</td>
        </tr>
      </tbody>
    </table>
    <ul
      uib-pagination
      ng-if="projectsLoaded"
      items-per-page="pagination.itemsPerPage"
      total-items="filteredProjects.length"
      max-size="pagination.maxSize"
      ng-model="pagination.currentPage"
    ></ul>
  </div>
</div>
`);
}]);

const CORE_PROJECTS_PROJECTS_MODULE = "spinnaker.projects";
module(CORE_PROJECTS_PROJECTS_MODULE, [PROJECTS_STATES_CONFIG]);

const GLOBAL_SEARCH_COMPONENT = "spinnaker.core.search.global.component";
module(GLOBAL_SEARCH_COMPONENT, []).component("globalSearch", react2angular(withErrorBoundary(GlobalSearch, "globalSearch")));

var css_248z$5 = "global-search {\n  position: relative;\n}\n.global-search form {\n  margin: 5px;\n}\n@media (min-width: 768px) {\n  .global-search form {\n    padding: 0 15px;\n  }\n}\n.global-search form input[type='search'] {\n  width: 200px;\n}\n.global-search .glyphicon-search {\n  color: var(--color-text-link);\n}\n.global-search .spinner-section {\n  min-height: 30px;\n}\n.global-search .dropdown-menu {\n  width: 400px;\n  top: 34px;\n  right: 0;\n  margin: 2px 19px;\n  border-radius: 0;\n  z-index: 10001;\n  overflow-y: auto;\n}\n.global-search .dropdown-menu li {\n  color: var(--color-concrete);\n}\n.global-search .dropdown-menu li strong {\n  font-weight: 600;\n}\n.global-search .dropdown-menu li.category-heading {\n  padding: 10px 0 0 15px;\n  margin-top: 10px;\n  border-top: 1px solid var(--color-cirrus);\n}\n.global-search .dropdown-menu li.category-heading span {\n  text-transform: uppercase;\n  white-space: nowrap;\n  flex: 1;\n}\n.global-search .dropdown-menu li a {\n  padding-left: 15px;\n  padding-right: 15px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-variant: normal;\n  color: var(--color-black);\n  transition: background-color 0.2s, outline-width 0.2s;\n}\n.global-search .dropdown-menu li a .expand-results {\n  font-weight: bold;\n}\n.global-search .dropdown-menu li a.sublinked,\n.global-search .dropdown-menu li a.sublink {\n  display: inline-block;\n  padding-right: 5px;\n}\n.global-search .dropdown-menu li a.sublink {\n  padding: 3px 4px;\n}\n.global-search .dropdown-menu li a.query-match {\n  background-color: var(--color-primary-g1);\n}\n.global-search .dropdown-menu li .sublink-label {\n  display: inline-block;\n  padding: 3px 0;\n  overflow: hidden;\n}\n.global-search .dropdown-menu li:first-child {\n  margin-top: 0;\n  border: none;\n}\n@media (max-width: 480px) {\n  .global-search .dropdown-menu {\n    position: static;\n    margin: 2px 4px;\n  }\n}\n@media (min-width: 480px) {\n  .global-search .dropdown-menu {\n    max-height: 600px;\n  }\n}\n.global-search .glyphicon-search {\n  pointer-events: initial;\n}\n.global-search-header {\n  top: 48px;\n  margin-top: 10px;\n  border-bottom: 1px solid var(--color-alto);\n}\n.global-search-header h2 {\n  font-weight: 700;\n}\n.keyboard-key {\n  color: var(--color-alert);\n  font-family: monospace;\n  font-weight: bold;\n}\n";
styleInject(css_248z$5);

const GLOBAL_SEARCH = "spinnaker.core.search.global";
module(GLOBAL_SEARCH, [GLOBAL_SEARCH_COMPONENT]);

const INFRASTRUCTURE_STATES = "spinnaker.core.search.states";
module(INFRASTRUCTURE_STATES, [STATE_CONFIG_PROVIDER]).config([
  "stateConfigProvider",
  (stateConfigProvider) => {
    stateConfigProvider.addToRootState({
      name: "search",
      url: "/search?q&key&tab&name&account&region&stack",
      params: {
        account: { dynamic: true, value: null },
        key: { dynamic: true, value: null },
        name: { dynamic: true, value: null },
        q: { dynamic: true, value: null },
        region: { dynamic: true, value: null },
        stack: { dynamic: true, value: null },
        tab: { dynamic: true, value: null }
      },
      views: {
        "main@": {
          template: `
          <infrastructure-search-v1 ng-if="$resolve.version == 1" class="flex-fill"></infrastructure-search-v1>
          <infrastructure-search-v2 ng-if="$resolve.version == 2" class="flex-fill"></infrastructure-search-v2>
        `
        }
      },
      data: {
        pageTitleMain: {
          label: "Search"
        }
      },
      resolve: {
        version: () => SETTINGS.searchVersion || 1
      }
    });
    stateConfigProvider.addToRootState({ name: "infrastructure", url: "/search?q", redirectTo: "home.search" });
    stateConfigProvider.addRewriteRule("/infrastructure?q", "/search?q");
    stateConfigProvider.addRewriteRule("", "/search");
    stateConfigProvider.addRewriteRule("/", "/search");
  }
]);

const PROJECT_SUMMARY_POD_COMPONENT = "spinnaker.core.search.infrastructure.projectSummaryPod.component";
module(PROJECT_SUMMARY_POD_COMPONENT, []).component("projectSummaryPod", react2angular(withErrorBoundary(ProjectSummaryPod, "projectSummaryPod"), ["projectName", "applications"]));

const RECENTLY_VIEWED_ITEMS_COMPONENT = "spinnaker.core.search.infrastructure.recentlyViewedItems.component";
module(RECENTLY_VIEWED_ITEMS_COMPONENT, []).component("recentlyViewedItems", react2angular(withErrorBoundary(RecentlyViewedItems, "recentlyViewedItems")));

const SEARCH_RESULT_COMPONENT = "spinnaker.core.search.infrastructure.searchResult.component";
module(SEARCH_RESULT_COMPONENT, []).component("searchResult", react2angular(withErrorBoundary(SearchResult, "searchResult"), ["displayName", "account"]));

const SPINNER_COMPONENT = "spinnaker.core.spinner.component";
module(SPINNER_COMPONENT, []).component("loadingSpinner", react2angular(withErrorBoundary(Spinner, "loadingSpinner"), ["size", "message", "mode"]));

const CORE_SEARCH_INFRASTRUCTURE_INFRASTRUCTURE_CONTROLLER = "spinnaker.search.infrastructure.controller";
angular.module(CORE_SEARCH_INFRASTRUCTURE_INFRASTRUCTURE_CONTROLLER, [
  INFRASTRUCTURE_SEARCH_SERVICE,
  SEARCH_RESULT_COMPONENT,
  PAGE_TITLE_SERVICE,
  PROJECT_SUMMARY_POD_COMPONENT,
  SEARCH_RANK_FILTER,
  OVERRIDE_REGISTRY,
  RECENTLY_VIEWED_ITEMS_COMPONENT,
  SPINNER_COMPONENT
]).component("searchInsightMenu", react2angular(withErrorBoundary(InsightMenu, "searchInsightMenu"), [
  "createApp",
  "createProject",
  "refreshCaches"
])).controller("InfrastructureCtrl", [
  "$scope",
  "infrastructureSearchService",
  "$stateParams",
  "$location",
  "overrideRegistry",
  "pageTitleService",
  "$uibModal",
  "$state",
  function($scope, infrastructureSearchService, $stateParams, $location, overrideRegistry, pageTitleService, $uibModal, $state) {
    const search = infrastructureSearchService.getSearcher();
    $scope.firewallsLabel = FirewallLabels.get("firewalls");
    $scope.categories = [];
    $scope.projects = [];
    $scope.viewState = {
      searching: false,
      minCharactersToSearch: 3
    };
    this.clearFilters = (r) => ClusterState.filterService.overrideFiltersForUrl(r);
    function updateLocation() {
      $location.search("q", $scope.query || null);
      $location.replace();
    }
    $scope.pageSize = SearchService.DEFAULT_PAGE_SIZE;
    let autoNavigate = false;
    if (angular.isDefined($location.search().q)) {
      $scope.query = $location.search().q;
      autoNavigate = !!$location.search().route;
      $location.search("route", null);
    }
    $scope.$watch("query", function(query) {
      $scope.categories = [];
      $scope.projects = [];
      if (query && query.length < $scope.viewState.minCharactersToSearch) {
        $scope.viewState.searching = false;
        updateLocation();
        return;
      }
      $scope.viewState.searching = true;
      search.query(query).then(function(resultSets) {
        const allResults = ___default.flatten(resultSets.map((r) => r.results));
        if (allResults.length === 1 && autoNavigate) {
          $location.url(allResults[0].href.substring(1));
        } else {
          autoNavigate = false;
        }
        $scope.categories = resultSets.filter((resultSet) => resultSet.type.id !== "projects" && resultSet.results.length).sort((a, b) => a.type.id - b.type.id);
        $scope.projects = resultSets.filter((resultSet) => resultSet.type.id === "projects" && resultSet.results.length);
        $scope.moreResults = ___default.sumBy(resultSets, function(resultSet) {
          return resultSet.results.length;
        }) === $scope.pageSize;
        updateLocation();
        pageTitleService.handleRoutingSuccess({
          pageTitleMain: {
            label: query ? ' search results for "' + query + '"' : "Infrastructure"
          }
        });
        $scope.viewState.searching = false;
      });
    });
    this.createProject = () => ConfigureProjectModal.show().catch(() => {
    });
    this.createApplicationForTests = () => {
      $uibModal.open({
        scope: $scope,
        templateUrl: overrideRegistry.getTemplate("createApplicationModal", "core/src/application/modal/newapplication.html"),
        resolve: {
          name: () => ""
        },
        controller: overrideRegistry.getController("CreateApplicationModalCtrl"),
        controllerAs: "newAppModal"
      }).result.then(routeToApplication).catch(() => {
      });
    };
    function routeToApplication(app) {
      $state.go("home.applications.application", {
        application: app.name
      });
    }
    this.menuActions = [
      {
        displayName: "Create Project",
        action: this.createProject
      },
      {
        displayName: "Create Application",
        action: this.createApplicationForTests
      }
    ];
    this.hasResults = () => {
      return $scope.categories.length || $scope.projects.length;
    };
    this.noMatches = () => !this.hasResults() && $scope.query && $scope.query.length > 0;
    this.showRecentResults = () => !$scope.viewState.searching && !$scope.projects.length && $scope.categories.every((category) => !category.results.length);
  }
]).directive("infrastructureSearchV1", function() {
  return {
    restrict: "E",
    templateUrl: "core/src/search/infrastructure/infrastructure.html",
    controller: "InfrastructureCtrl",
    controllerAs: "ctrl"
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/application/modal/newapplication.html", `<div class="modal-page">
  <modal-close dismiss="$dismiss()"></modal-close>
  <div class="modal-header">
    <h4 class="modal-title">New Application</h4>
  </div>
  <div ng-if="newAppModal.state.initializing" style="height: 200px">
    <loading-spinner size="'medium'"></loading-spinner>
  </div>
  <div ng-if="newAppModal.state.initializeFailed" style="...">
    <div
      class="horizontal middle center heading-4"
      style="padding-left: 15px; padding-right: 15px; margin-bottom: 250px; height: 150px"
    >
      <i class="fa fa-exclamation-triangle" style="padding-right: 8px"></i>
      <span>
        Error initializing dialog. Check that your gate endpoint is accessible. Further information on troubleshooting
        this error is available <a href="https://www.spinnaker.io/setup/quickstart/faq/">here</a>.
      </span>
    </div>
  </div>
  <form
    role="form"
    class="container-fluid"
    novalidate
    name="newApplicationForm"
    ng-if="!(newAppModal.state.initializing || newAppModal.state.initializeFailed)"
  >
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Name *</div>
        <div class="col-sm-9">
          <input
            type="text"
            autofocus
            name="name"
            class="form-control input-sm"
            data-purpose="application-name"
            ng-model="newAppModal.application.name"
            placeholder="Enter an application name"
            validate-unique="newAppModal.data.appNameList"
            ng-model-options="{allowInvalid: true}"
            validate-application-name
            cloud-providers="newAppModal.application.cloudProviders"
            required
          />
        </div>
      </div>

      <application-name-validation-messages
        name="newAppModal.application.name"
        cloud-providers="newAppModal.application.cloudProviders"
      ></application-name-validation-messages>

      <div class="form-group row slide-in" ng-if="newApplicationForm.name.$error.validateUnique">
        <div class="col-sm-9 col-sm-offset-3 error-message">
          <span>Application name must be unique.</span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Owner Email *</div>
        <div class="col-sm-9">
          <input
            type="email"
            name="email"
            class="form-control input-sm"
            data-purpose="application-email"
            ng-model="newAppModal.application.email"
            placeholder="Enter an email address"
            required
          />
        </div>
      </div>

      <div class="form-group row slide-in" ng-if="newApplicationForm.email.$dirty && newApplicationForm.email.$invalid">
        <div class="col-sm-9 col-sm-offset-3 error-message">
          <span>Please enter a valid email address</span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Repo Type</div>
        <div class="col-sm-9">
          <select
            class="form-control input-sm"
            ng-options="repoType for repoType in newAppModal.data.gitSources"
            ng-model="newAppModal.application.repoType"
          >
            <option value="">Select Repo Type</option>
          </select>
        </div>
      </div>
      <div class="form-group row" ng-if="newAppModal.application.repoType">
        <div class="col-sm-3 sm-label-right">Repo Project</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="newAppModal.application.repoProjectKey"
            placeholder="Enter your source repository project name"
          />
        </div>
      </div>
      <div class="form-group row" ng-if="newAppModal.application.repoType">
        <div class="col-sm-3 sm-label-right">Repo Name</div>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control input-sm"
            ng-model="newAppModal.application.repoSlug"
            placeholder="Enter your source repository name (not the URL)"
            pattern="^((?!://).)*$"
            name="repoSlug"
          />
        </div>
      </div>

      <div class="form-group row slide-in" ng-messages="newApplicationForm.repoSlug.$error">
        <div class="col-sm-9 col-sm-offset-3 error-message" ng-message="pattern">
          Enter your source repository name (not the URL).
        </div>
      </div>

      <chaos-monkey-new-application-config
        application-config="newAppModal.application"
      ></chaos-monkey-new-application-config>

      <render-if-feature feature="pagerDuty">
        <pager-duty-select-field component="newAppModal.application"></pager-duty-select-field>
      </render-if-feature>

      <render-if-feature feature="slack">
        <slack-channel-selector
          channel="newAppModal.application.slackChannel"
          callback="newAppModal.setAttribute"
        ></slack-channel-selector>
      </render-if-feature>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Description</div>
        <div class="col-sm-9">
          <textarea
            class="form-control input-sm"
            ng-model="newAppModal.application.description"
            placeholder="Enter a description"
            data-purpose="application-description"
          >
          </textarea>
        </div>
      </div>

      <div class="form-group row" ng-if="newAppModal.data.cloudProviders.length > 1">
        <div class="col-md-3 sm-label-right">Cloud Providers</div>
        <div class="col-md-5">
          <ui-select multiple ng-model="newAppModal.application.cloudProviders" class="form-control input-sm">
            <ui-select-match> {{$item}} </ui-select-match>
            <ui-select-choices repeat="provider in newAppModal.data.cloudProviders | filter: $select.search">
              {{provider}}
            </ui-select-choices>
          </ui-select>
        </div>
      </div>

      <application-provider-fields
        cloud-providers="newAppModal.data.cloudProviders"
        application="newAppModal.application"
      >
      </application-provider-fields>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Instance Health</div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input type="checkbox" ng-model="newAppModal.application.platformHealthOnly" />
            Consider only cloud provider health when executing tasks
            <help-field key="application.platformHealthOnly"></help-field>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right"></div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input
              type="checkbox"
              ng-model="newAppModal.application.platformHealthOnlyShowOverride"
              ng-click="newAppModal.updateCloudProviderHealthWarning()"
            />
            Show health override option for each operation
            <help-field key="application.showPlatformHealthOverride"></help-field>
          </label>
        </div>
      </div>

      <div class="col-md-12" ng-if="newAppModal.data.showOverrideWarning">
        <div class="alert alert-warning">
          <p>
            <i class="fa fa-exclamation-triangle"></i>
            {{newAppModal.data.showOverrideWarning}}
          </p>
          <p class="text-right">
            <a
              class="btn btn-sm btn-default dirty-flag-dismiss"
              href
              ng-click="newAppModal.data.showOverrideWarning = null"
              >Okay</a
            >
          </p>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">
          Instance Port
          <help-field key="application.instance.port"></help-field>
        </div>
        <div class="col-sm-2">
          <input
            type="number"
            min="0"
            max="65536"
            class="form-control input-sm"
            ng-model="newAppModal.application.instancePort"
            name="instancePort"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3 sm-label-right">Pipeline Behavior</div>
        <div class="col-sm-9 sm-control-field checkbox">
          <label>
            <input type="checkbox" ng-model="editApp.applicationAttributes.enableRestartRunningExecutions" />
            Enable restarting running pipelines
          </label>
          <help-field key="application.enableRestartRunningExecutions"></help-field>
          <label>
            <input type="checkbox" ng-model="editApp.applicationAttributes.enableRerunActiveExecutions" />
            Enable re-run button on active pipelines
          </label>
          <help-field key="application.enableRerunActiveExecutions"></help-field>
        </div>
      </div>

      <render-if-feature feature="fiatEnabled">
        <div class="form-group row">
          <div class="col-sm-3 sm-label-right">Permissions <help-field key="application.permissions"></help-field></div>
          <div class="col-sm-9">
            <permissions-configurer
              permissions="newAppModal.application.permissions"
              on-permissions-change="newAppModal.handlePermissionsChange"
              required-group-membership="newAppModal.application.requiredGroupMembership"
            >
            </permissions-configurer>
          </div>
        </div>
      </render-if-feature>

      <div class="form-group row slide-in" ng-if="newAppModal.state.errorMessages.length">
        <div class="col-md-12">
          <div class="alert alert-danger">
            <div ng-repeat="errorMessage in newAppModal.state.errorMessages">
              <status-glyph item="{isFailed: true}"></status-glyph> {{errorMessage}}
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <em>* Required</em>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <a href class="btn btn-default" ng-click="$dismiss()">Cancel</a>
      <submit-button
        is-new="true"
        is-disabled="newApplicationForm.$invalid || newAppModal.state.submitting || newAppModal.data.showOverrideWarning || newAppModal.state.permissionsInvalid"
        submitting="newAppModal.state.submitting"
        on-click="newAppModal.submit()"
      ></submit-button>
    </div>
  </form>
</div>
`);
}]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/search/infrastructure/infrastructure.html", `<div class="infrastructure">
  <div class="infrastructure-section search-header">
    <div class="container">
      <h2 class="header-section">
        <i class="fa fa-search"></i>
        <span class="search-label">Search</span>
        <input
          type="search"
          class="form-control input-lg"
          placeholder="projects, applications, clusters, load balancers, server groups, {{firewallsLabel}}"
          autofocus
          ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 300, 'blur': 0 } }"
          ng-model="query"
        />
        <div ng-if="query && query.length && query.length < viewState.minCharactersToSearch">
          <p style="margin: 10px 20px 0">
            Please enter at least {{viewState.minCharactersToSearch}} characters to begin searching.
          </p>
        </div>
      </h2>
      <div class="header-actions">
        <search-insight-menu create-app="true" createProject="true" refresh-caches="false" />
      </div>
    </div>
  </div>
  <div ng-if="ctrl.hasResults()" class="container">
    <div class="row" ng-if="moreResults">
      <div class="col-md-12">
        <p style="margin: 10px 20px 0">Only showing the first {{pageSize}} results found.</p>
      </div>
    </div>
    <div class="row infrastructure-section">
      <div class="col-md-3" ng-if="projects.length">
        <div class="row">
          <div class="col-md-12">
            <h3>Projects</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="no-results" ng-if="!projects.length">
              No projects found matching "{{query}}".<br />
              <a href ng-click="ctrl.createProject()">Create a new project</a>
            </div>
            <project-summary-pod
              ng-repeat="project in projects[0].results"
              project-name="project.name"
              applications="project.config.applications"
            >
            </project-summary-pod>
          </div>
        </div>
      </div>
      <div class="col-md-{{projects.length ? 9 : 12}}">
        <div class="row">
          <div class="col-md-12">
            <h3>Results matching "{{query}}"</h3>
          </div>
        </div>
        <div class="row" ng-if="!categories.length">
          <div class="col-md-12">
            <h4>No Infrastructure results found.</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 category-container" ng-repeat="category in categories | orderBy:'order'">
            <div class="panel category row">
              <div class="summary">
                <span class="category-icon" ng-if="category.icon || category.iconClass">
                  <i ng-if="category.icon" class="fa fa-{{category.icon}}"></i>
                  <span ng-if="category.iconClass" class="{{category.iconClass}}"></span>
                </span>
                {{ category.type.displayName }} ({{category.results.length}})
              </div>
              <div class="details-container list-group">
                <a
                  class="list-group-item"
                  ng-repeat="result in ::category.results | searchRank: query"
                  ng-click="ctrl.clearFilters(result)"
                  href="{{ ::result.href }}"
                >
                  <search-result display-name="::result.displayName" account="::result.account"></search-result>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div ng-if="viewState.searching" class="horizontal center middle flex-1" style="margin: 25px 0; height: 100%">
    <loading-spinner size="'large'"></loading-spinner>
  </div>
  <div ng-if="ctrl.noMatches() && !viewState.searching" class="container">
    <div class="row">
      <div class="col-md-12">
        <h4 class="no-results">No results matching "{{ query }}".</h4>
      </div>
    </div>
  </div>

  <div ng-if="ctrl.showRecentResults()" class="infrastructure-section container">
    <recently-viewed-items></recently-viewed-items>
  </div>
</div>
`);
}]);

const API_PARAMS = ["key", "name", "account", "region", "stack"];
class SearchV2 extends React__default.Component {
  constructor(props) {
    super(props);
    this.$state = ReactInjector.$state;
    this.$uiRouter = ReactInjector.$uiRouter;
    this.searchResultTypes = searchResultTypeRegistry.getAll();
    this.INITIAL_RESULTS = this.searchResultTypes.map((type) => ({
      type,
      status: SearchStatus.SEARCHING,
      results: []
    }));
    this.destroy$ = new Subject();
    this.handleFilterChange = (filters) => {
      const blankApiParams = API_PARAMS.reduce((acc, key) => ({ ...acc, [key]: void 0 }), {});
      const newParams = filters.reduce((params, filter) => ({ ...params, [filter.key]: filter.text }), blankApiParams);
      this.$state.go(".", newParams, { location: "replace" });
    };
    this.state = {
      selectedTab: this.$state.params.tab,
      params: {},
      resultSets: this.INITIAL_RESULTS,
      isSearching: false,
      refreshingCache: false
    };
    ReactInjector.pageTitleService.handleRoutingSuccess({ pageTitleMain: { field: void 0, label: "Search" } });
  }
  getApiFilterParams(params) {
    const isValidApiParam = (val, key) => {
      return API_PARAMS.includes(key) && val !== null && val !== void 0 && !(typeof val === "string" && val.trim() === "");
    };
    return pickBy(params, isValidApiParam);
  }
  componentDidMount() {
    const autoNavigate = window.location.href.endsWith("route=true");
    this.$uiRouter.globals.params$.pipe(map((stateParams) => this.getApiFilterParams(stateParams)), tap((params) => this.setState({ params })), distinctUntilChanged((a, b) => API_PARAMS.every((key) => a[key] === b[key])), tap(() => this.setState({ resultSets: this.INITIAL_RESULTS, isSearching: true })), switchMap((params) => {
      if (isEmpty(params)) {
        return empty();
      }
      return InfrastructureSearchServiceV2.search({ ...params }).pipe(scan((acc, resultSet) => {
        const status = resultSet.status === SearchStatus.SEARCHING ? SearchStatus.FINISHED : resultSet.status;
        resultSet = { ...resultSet, status };
        return acc.filter((set) => set.type !== resultSet.type).concat(resultSet);
      }, this.INITIAL_RESULTS));
    }), takeUntil(this.destroy$)).subscribe((resultSets) => {
      const finishedSearching = resultSets.map((r) => r.status).every((s) => s === SearchStatus.FINISHED);
      if (finishedSearching && autoNavigate) {
        const allResults = resultSets.reduce((acc, rs) => acc.concat(rs.results), []);
        if (allResults.length === 1) {
          window.location.href = allResults[0].href;
          return;
        }
      }
      if (!this.state.selectedTab) {
        this.selectTab(resultSets);
      }
      this.setState({ resultSets, isSearching: !finishedSearching });
    }, null, () => this.setState({ isSearching: false }));
    this.$uiRouter.globals.params$.pipe(map((params) => params.tab), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe((selectedTab) => this.setState({ selectedTab }));
  }
  selectTab(resultSets) {
    const order = (rs) => rs.type.id === "applications" ? -1 : rs.type.order;
    const tabs = resultSets.slice().sort((a, b) => order(a) - order(b));
    const found = tabs.reduce((previous, tab) => {
      const resultAlreadyFound = previous.tabId || previous.unfinished;
      const unfinished = tab.status !== SearchStatus.FINISHED;
      const tabId = tab.results.length ? tab.type.id : null;
      return resultAlreadyFound ? previous : { ...previous, unfinished, tabId };
    }, { tabId: null, unfinished: false });
    if (found.tabId) {
      this.$state.go(".", { tab: found.tabId });
    }
  }
  componentWillUnmount() {
    this.destroy$.next();
  }
  render() {
    const { params, resultSets, selectedTab, isSearching } = this.state;
    const hasSearchQuery = Object.keys(params).length > 0;
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "infrastructure-section search-header"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "container"
    }, /* @__PURE__ */ React__default.createElement("h2", {
      className: "header-section"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-grow"
    }, /* @__PURE__ */ React__default.createElement(Search, {
      params: this.state.params,
      onChange: this.handleFilterChange
    }))), /* @__PURE__ */ React__default.createElement("div", {
      className: "header-actions"
    }, /* @__PURE__ */ React__default.createElement(InsightMenu, null)))), /* @__PURE__ */ React__default.createElement("div", {
      className: "container flex-fill",
      style: { overflowY: "auto" }
    }, !hasSearchQuery && /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(RecentlyViewedItems, {
      Component: SearchResultPods
    })), hasSearchQuery && /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-fill"
    }, /* @__PURE__ */ React__default.createElement(SearchResults, {
      selectedTab,
      resultSets,
      isSearching
    }))));
  }
}

const SEARCH_INFRASTRUCTURE_V2_CONTROLLER = "spinnaker.search.infrastructureNew.controller";
module(SEARCH_INFRASTRUCTURE_V2_CONTROLLER, [
  PAGE_TITLE_SERVICE,
  CACHE_INITIALIZER_SERVICE,
  OVERRIDE_REGISTRY
]).component("infrastructureSearchV2", react2angular(withErrorBoundary(SearchV2, "infrastructureSearchV2")));

const SEARCH_COMPONENT = "spinnaker.core.search.component";
module(SEARCH_COMPONENT, []).component("tagSearch", react2angular(withErrorBoundary(Search, "tagSearch"), ["params", "onChange"])).run(() => {
  SearchFilterTypeRegistry.register({ key: "account", name: "Account" });
  SearchFilterTypeRegistry.register({ key: "region", name: "Region" });
  SearchFilterTypeRegistry.register({ key: "stack", name: "Stack" });
});

var css_248z$4 = ".infrastructure {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  height: 100%;\n}\n.infrastructure-section__message {\n  text-align: center;\n}\n.infrastructure .infrastructure-section.container {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.infrastructure .search-header {\n  background-color: var(--color-accent-g2);\n  flex: 0 0 auto;\n}\n.infrastructure .search-header .fa-search {\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  line-height: 29px;\n  font-size: 14px;\n  border-radius: 50%;\n  margin-left: 5px;\n  background-color: var(--color-primary);\n  border: 2px solid var(--color-white);\n  color: var(--color-white);\n  text-align: center;\n}\n.infrastructure .search-header .search-label {\n  color: var(--color-primary);\n  display: inline-block;\n  font-size: 24px;\n  padding: 0 20px 0 5px;\n}\n.infrastructure .search-header .container {\n  display: flex;\n  justify-content: space-between;\n}\n.infrastructure .search-header .container .header-section {\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  margin-right: 30px;\n}\n.infrastructure .search-header input {\n  display: inline-block;\n  max-width: 600px;\n  font-weight: 400;\n}\n.infrastructure .search-header input::-webkit-input-placeholder {\n  font-size: 14px;\n}\n.infrastructure .search-header .header-actions {\n  flex: 0 0 auto;\n  margin: 21px 0;\n}\n.infrastructure .search-header .header-actions .dropdown-toggle {\n  background-color: transparent;\n  border: none;\n  font-size: 14px;\n  box-shadow: none;\n}\n.infrastructure .input-group-search {\n  margin-top: 20px;\n}\n.infrastructure h2 {\n  font-weight: 600;\n  margin-top: 15px;\n}\n.infrastructure h3 {\n  font-weight: 600;\n}\n.infrastructure h4.no-results {\n  padding: 30px 0;\n  margin-top: 0;\n  border-bottom: 1px solid var(--color-alto);\n  font-size: 180%;\n}\n.infrastructure .input-group {\n  margin-bottom: 10px;\n}\n.infrastructure .summary {\n  background-color: var(--color-accent-g2);\n  text-transform: uppercase;\n  font-weight: 600;\n  padding: 0 10px;\n  margin-bottom: 3px;\n  height: 33px;\n  line-height: 35px;\n}\n.infrastructure .projects-summary {\n  margin-bottom: 15px;\n}\n.infrastructure a .remove-result-link {\n  width: 20px;\n  opacity: 0;\n}\n.infrastructure a:hover .remove-result-link,\n.infrastructure a:focus .remove-result-link {\n  opacity: 1;\n  transition: opacity 0.25s ease-in;\n  color: var(--color-concrete);\n}\n.infrastructure a:hover .remove-result-link:hover,\n.infrastructure a:focus .remove-result-link:hover,\n.infrastructure a:hover .remove-result-link:active,\n.infrastructure a:focus .remove-result-link:active {\n  color: var(--color-accent);\n}\n.infrastructure .panel {\n  box-shadow: none;\n  border: 0;\n}\n.infrastructure .panel .details-container {\n  background-color: var(--color-alabaster);\n  height: 200px;\n  overflow-y: auto;\n}\n.infrastructure .panel .details-container a {\n  line-height: 18px;\n  padding-right: 0;\n  background-color: var(--color-alabaster);\n}\n.infrastructure .panel .details-container a:hover,\n.infrastructure .panel .details-container a:focus {\n  background-color: var(--color-white);\n}\n.infrastructure .panel .details-container a:first-child {\n  border-top: none;\n}\n.infrastructure .category {\n  margin: 0 0 15px 0;\n  background-color: transparent;\n  border-bottom: 2px solid var(--color-concrete);\n  border-radius: 0;\n}\n.infrastructure .category .category-icon {\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  line-height: 29px;\n  border-radius: 50%;\n  margin-left: 5px;\n  background-color: var(--color-primary);\n  border: 2px solid var(--color-white);\n  color: var(--color-white);\n  text-align: center;\n}\n";
styleInject(css_248z$4);

const SEARCH_INFRASTRUCTURE = "spinnaker.search.infrastructure";
module(SEARCH_INFRASTRUCTURE, [
  CORE_SEARCH_INFRASTRUCTURE_INFRASTRUCTURE_CONTROLLER,
  PROJECT_SUMMARY_POD_COMPONENT,
  RECENTLY_VIEWED_ITEMS_COMPONENT,
  SEARCH_COMPONENT,
  SEARCH_INFRASTRUCTURE_V2_CONTROLLER,
  SEARCH_RESULT_COMPONENT
]);

const CORE_SEARCH_SEARCH_MODULE = "spinnaker.core.search";
module(CORE_SEARCH_SEARCH_MODULE, [SEARCH_INFRASTRUCTURE, GLOBAL_SEARCH, INFRASTRUCTURE_STATES]);

const poolValueCoordinates = [
  { filterField: "providerType", on: "securityGroup", localField: "provider" },
  { filterField: "account", on: "securityGroup", localField: "account" },
  { filterField: "region", on: "securityGroup", localField: "region" }
];
const poolBuilder = (securityGroups) => {
  const pool = securityGroups.map((sg) => {
    const poolUnit = chain(poolValueCoordinates).filter({ on: "securityGroup" }).reduce((poolUnitTemplate, coordinate) => {
      poolUnitTemplate[coordinate.filterField] = sg[coordinate.localField];
      return poolUnitTemplate;
    }, {}).value();
    return poolUnit;
  });
  return pool;
};
const SecurityGroupFilters = ({ app }) => {
  const { securityGroups } = app;
  const { data: securityGroupData, loaded: securityGroupsLoaded } = useDataSource(securityGroups);
  const [tags, setTags] = React__default.useState(SecurityGroupState.filterModel.asFilterModel.tags);
  const [sortFilter, setSortFilter] = React__default.useState(SecurityGroupState.filterModel.asFilterModel.sortFilter);
  const getHeadingsForOption = (option) => compact(uniq(map$1(securityGroupData, option))).sort();
  const [headings, setHeadings] = React__default.useState({
    account: [],
    detail: ["(none)"].concat(getHeadingsForOption("detail")),
    providerType: getHeadingsForOption("provider"),
    region: [],
    stack: ["(none)"].concat(getHeadingsForOption("stack"))
  });
  useObservable(SecurityGroupState.filterService.groupsUpdatedStream, () => {
    setTags(SecurityGroupState.filterModel.asFilterModel.tags);
  });
  useOnStateChanged(() => {
    SecurityGroupState.filterModel.asFilterModel.activate();
    SecurityGroupState.filterService.updateSecurityGroups(app);
  });
  const updateSecurityGroups = (applyParamsToUrl = true) => {
    const { account, region } = digestDependentFilters({
      sortFilter: SecurityGroupState.filterModel.asFilterModel.sortFilter,
      dependencyOrder: ["providerType", "account", "region"],
      pool: poolBuilder(securityGroupData)
    });
    setHeadings({
      account,
      detail: ["(none)"].concat(getHeadingsForOption("detail")),
      providerType: getHeadingsForOption("provider"),
      region,
      stack: ["(none)"].concat(getHeadingsForOption("stack"))
    });
    if (applyParamsToUrl) {
      SecurityGroupState.filterModel.asFilterModel.applyParamsToUrl();
    }
  };
  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    const newSortFilter = {
      ...sortFilter,
      filter: searchTerm
    };
    setSortFilter(newSortFilter);
    SecurityGroupState.filterModel.asFilterModel.sortFilter = newSortFilter;
    updateSecurityGroups();
  };
  const handleFilterChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const [header, filter] = target.name.split(".");
    const newSortFilter = {
      ...sortFilter,
      [header]: {
        ...sortFilter[header],
        [filter]: Boolean(value)
      }
    };
    setSortFilter(newSortFilter);
    SecurityGroupState.filterModel.asFilterModel.sortFilter = newSortFilter;
    updateSecurityGroups();
  };
  React__default.useEffect(() => {
    if (securityGroupsLoaded) {
      updateSecurityGroups();
    }
  }, [securityGroupsLoaded, tags.length]);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "insight-filter-content"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "heading"
  }, /* @__PURE__ */ React__default.createElement(FilterSearch, {
    helpKey: "securityGroup.search",
    value: sortFilter.filter,
    onBlur: handleSearchChange,
    onSearchChange: handleSearchChange
  })), securityGroupsLoaded && /* @__PURE__ */ React__default.createElement("div", {
    className: "content"
  }, headings.providerType.length > 1 && /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-provider",
    heading: "Provider",
    expanded: true
  }, headings.providerType.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    isCloudProvider: true,
    key: heading,
    sortFilterType: sortFilter.providerType,
    onChangeEvent: handleFilterChange,
    name: `providerType.${heading}`
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-account",
    heading: "Account",
    expanded: true
  }, headings.account.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.account,
    onChangeEvent: handleFilterChange,
    name: `account.${heading}`
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-region",
    heading: "Region",
    expanded: true
  }, headings.region.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.region || {},
    onChangeEvent: handleFilterChange,
    name: `region.${heading}`
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-stack",
    heading: "Stack",
    expanded: true
  }, headings.stack.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.stack,
    onChangeEvent: handleFilterChange,
    name: `stack.${heading}`
  }))), /* @__PURE__ */ React__default.createElement(FilterSection, {
    key: "filter-detail",
    heading: "Detail",
    expanded: true
  }, headings.detail.map((heading) => /* @__PURE__ */ React__default.createElement(FilterCheckbox$1, {
    heading,
    key: heading,
    sortFilterType: sortFilter.detail,
    onChangeEvent: handleFilterChange,
    name: `detail.${heading}`
  })))));
};

const SECURITY_GROUP_FILTER = "securityGroup.filter.controller";
module(SECURITY_GROUP_FILTER, []).component("securityGroupFilter", react2angular(withErrorBoundary(SecurityGroupFilters, "securityGroupFilter"), ["app"]));

const SECURITY_GROUP_DATA_SOURCE = "spinnaker.core.securityGroup.dataSource";
module(SECURITY_GROUP_DATA_SOURCE, [SECURITY_GROUP_READER]).run([
  "securityGroupReader",
  (securityGroupReader) => {
    const loadSecurityGroups = (application) => {
      return securityGroupReader.loadSecurityGroupsByApplicationName(application.name);
    };
    const addSecurityGroups = (application, securityGroups) => {
      return securityGroupReader.getApplicationSecurityGroups(application, securityGroups);
    };
    const addTags = (application) => {
      EntityTagsReader.addTagsToSecurityGroups(application);
      addManagedResourceMetadataToSecurityGroups(application);
    };
    ApplicationDataSourceRegistry.registerDataSource({
      key: "securityGroups",
      label: "Firewalls",
      category: INFRASTRUCTURE_KEY,
      sref: ".insight.firewalls",
      optional: true,
      icon: "fa fa-xs fa-fw fa-lock",
      iconName: "spMenuSecurityGroups",
      loader: loadSecurityGroups,
      onLoad: addSecurityGroups,
      afterLoad: addTags,
      providerField: "provider",
      credentialsField: "accountName",
      regionField: "region",
      description: "Network traffic access management",
      defaultData: []
    });
  }
]);

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let SecurityGroupDetails = class extends React__default.Component {
  render() {
    return /* @__PURE__ */ React__default.createElement("h3", null, FirewallLabels.get("Firewalls"), " Details");
  }
};
SecurityGroupDetails = __decorateClass([
  Overridable("securityGroup.details")
], SecurityGroupDetails);

const providerFilterFn = (_application, _account, provider) => {
  const sgConfig = provider.securityGroup;
  return sgConfig && (sgConfig.CreateSecurityGroupModal || sgConfig.createSecurityGroupTemplateUrl && sgConfig.createSecurityGroupController);
};
const getDefaultCredentials = (app, provider) => app.defaultCredentials[provider] || SETTINGS.providers[provider].defaults.account;
const getDefaultRegion = (app, provider) => app.defaultRegions[provider] || SETTINGS.providers[provider].defaults.region;
const getAngularModalOptions = (provider, selectedProvider, app) => ({
  templateUrl: provider.createSecurityGroupTemplateUrl,
  controller: `${provider.createSecurityGroupController} as ctrl`,
  windowClass: "modal-z-index",
  size: "lg",
  resolve: {
    securityGroup: () => {
      return {
        credentials: getDefaultCredentials(app, selectedProvider),
        subnet: "none",
        regions: [getDefaultRegion(app, selectedProvider)]
      };
    },
    application: () => {
      return app;
    }
  }
});
const getReactModalOptions = (selectedProvider, app) => ({
  credentials: getDefaultCredentials(app, selectedProvider),
  application: app,
  isNew: true
});
const CreateSecurityGroupButton = ({ app }) => {
  const createSecurityGroup = () => {
    ProviderSelectionService.selectProvider(app, "securityGroup", providerFilterFn).then((selectedProvider) => {
      const provider = CloudProviderRegistry.getValue(selectedProvider, "securityGroup");
      if (provider.CreateSecurityGroupModal) {
        provider.CreateSecurityGroupModal.show(getReactModalOptions(selectedProvider, app));
      } else {
        ModalInjector.modalService.open(getAngularModalOptions(provider, selectedProvider, app)).result.catch(() => {
        });
      }
    });
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", {
    className: "btn btn-sm btn-default",
    onClick: createSecurityGroup
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon glyphicon-plus-sign visible-lg-inline"
  }), /* @__PURE__ */ React.createElement(Tooltip, {
    value: "Create Load Balancer"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "glyphicon glyphicon-plus-sign visible-md-inline visible-sm-inline"
  })), /* @__PURE__ */ React.createElement("span", {
    className: "visible-lg-inline"
  }, " Create ", FirewallLabels.get("Firewall"))));
};

var css_248z$3 = ".table-search-results-security-group .table-header .col-name,\n.table-search-results-security-group .table-row .col-name {\n  width: 300px;\n}\n.security-group-pod .rollup-details .disabled {\n  opacity: 0.4;\n}\n.security-group-pod .rollup-details .disabled:active,\n.security-group-pod .rollup-details .disabled:hover {\n  opacity: 0.7;\n}\n.security-group-pod .highlightable-header {\n  border: 1px solid transparent;\n}\n.security-group-pod .highlightable-header.active {\n  border-color: var(--color-accent-g1);\n  background-color: var(--color-accent-g3);\n}\n";
styleInject(css_248z$3);

const Heading = ({ application, parentGrouping, securityGroup, heading }) => /* @__PURE__ */ React.createElement("h6", {
  className: "sticky-header-2 highlightable-header"
}, /* @__PURE__ */ React.createElement("div", {
  className: "clickable-header horizontal middle"
}, /* @__PURE__ */ React.createElement("span", {
  className: "glyphicon glyphicon-transfer sp-padding-xs-right"
}), /* @__PURE__ */ React.createElement("div", {
  className: "flex-1"
}, (heading || "").toUpperCase()), !parentGrouping.isManaged && securityGroup.isManaged && /* @__PURE__ */ React.createElement(ManagedResourceStatusIndicator, {
  shape: "circle",
  resourceSummary: securityGroup.managedResourceSummary,
  application
}), /* @__PURE__ */ React.createElement(EntityNotifications, {
  entity: securityGroup,
  application,
  placement: "bottom",
  entityType: "securityGroup",
  pageLocation: "details",
  onUpdate: () => application.securityGroups.refresh()
})));
const getSecurityGroupDetailsParams = (securityGroup, application) => ({
  application: application.name,
  region: securityGroup.region,
  accountId: securityGroup.accountName,
  name: securityGroup.name,
  vpcId: securityGroup.vpcId,
  provider: securityGroup.provider
});
const ServerGroup = ({ serverGroup }) => /* @__PURE__ */ React.createElement("div", {
  className: `rollup-row ${serverGroup.isDisabled ? "disabled" : ""}`,
  key: serverGroup.name
}, /* @__PURE__ */ React.createElement(UISref, {
  to: ".serverGroup",
  params: {
    region: serverGroup.region,
    accountId: serverGroup.account,
    serverGroup: serverGroup.name,
    provider: serverGroup.cloudProvider
  }
}, /* @__PURE__ */ React.createElement("a", null, /* @__PURE__ */ React.createElement(CloudProviderLogo, {
  provider: serverGroup.cloudProvider,
  height: "16px",
  width: "16px"
}), /* @__PURE__ */ React.createElement("span", {
  className: "sp-padding-xs-left"
}, serverGroup.name))));
const ServerGroups = ({ serverGroups }) => {
  if (!SecurityGroupState.filterModel.asFilterModel.sortFilter.showServerGroups) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "rollup-details-section col-md-6"
  }, serverGroups.length === 0 && /* @__PURE__ */ React.createElement("div", {
    className: "small"
  }, "No server groups"), serverGroups.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, serverGroups.map((serverGroup) => /* @__PURE__ */ React.createElement(ServerGroup, {
    key: serverGroup.name,
    serverGroup
  }))));
};
const LoadBalancer = ({
  loadBalancer,
  securityGroup
}) => /* @__PURE__ */ React.createElement("div", {
  className: "rollup-row",
  key: loadBalancer.name
}, /* @__PURE__ */ React.createElement(UISref, {
  to: ".loadBalancerDetails",
  params: {
    region: securityGroup.region,
    accountId: securityGroup.account,
    name: loadBalancer.name,
    vpcId: securityGroup.vpcId,
    provider: securityGroup.provider
  }
}, /* @__PURE__ */ React.createElement("a", null, /* @__PURE__ */ React.createElement("i", {
  className: "fa icon-sitemap sp-padding-xs-right"
}), " ", loadBalancer.name)));
const LoadBalancers = ({ securityGroup }) => {
  if (!SecurityGroupState.filterModel.asFilterModel.sortFilter.showLoadBalancers) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "rollup-details-section col-md-6"
  }, securityGroup.usages.loadBalancers.length === 0 && /* @__PURE__ */ React.createElement("div", {
    className: "small"
  }, "No load balancers"), securityGroup.usages.loadBalancers.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, securityGroup.usages.loadBalancers.map((loadBalancer) => /* @__PURE__ */ React.createElement(LoadBalancer, {
    key: loadBalancer.name,
    loadBalancer,
    securityGroup
  }))));
};
const SecurityGroup = (props) => {
  const params = getSecurityGroupDetailsParams(props.securityGroup, props.application);
  const active = ReactInjector.$state.includes("**.firewallDetails", params);
  return /* @__PURE__ */ React.createElement(UISref, {
    to: ".firewallDetails",
    params
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames("pod-subgroup clickable clickable-row clearfix", { active })
  }, /* @__PURE__ */ React.createElement(Heading, {
    ...props
  }), /* @__PURE__ */ React.createElement("div", {
    className: "cluster-container"
  }, /* @__PURE__ */ React.createElement(ServerGroups, {
    serverGroups: props.securityGroup.usages.serverGroups
  }), /* @__PURE__ */ React.createElement(LoadBalancers, {
    securityGroup: props.securityGroup
  }))));
};

const SecurityGroupPod = ({ grouping, application, parentHeading }) => /* @__PURE__ */ React.createElement("div", {
  className: "row rollup-entry sub-group security-group-pod"
}, /* @__PURE__ */ React.createElement("div", {
  className: "rollup-summary sticky-header"
}, /* @__PURE__ */ React.createElement("div", {
  className: "rollup-title-cell"
}, /* @__PURE__ */ React.createElement("div", {
  className: "heading-tag"
}, /* @__PURE__ */ React.createElement(AccountTag, {
  account: parentHeading
})), /* @__PURE__ */ React.createElement("div", {
  className: "pod-center horizontal space-between flex-1 no-right-padding"
}, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", {
  className: "glyphicon glyphicon-transfer sp-padding-xs-right"
}), grouping.heading), grouping.isManaged && /* @__PURE__ */ React.createElement(ManagedResourceStatusIndicator, {
  shape: "square",
  resourceSummary: grouping.managedResourceSummary,
  application
})))), /* @__PURE__ */ React.createElement("div", {
  className: "rollup-details"
}, grouping.subgroups.map((subgroup) => /* @__PURE__ */ React.createElement("div", {
  className: "pod-subgroup",
  key: subgroup.heading
}, /* @__PURE__ */ React.createElement(SecurityGroup, {
  application,
  securityGroup: subgroup.securityGroup,
  parentGrouping: grouping,
  heading: subgroup.heading
})))));

const { useEffect, useState } = React;
const Groupings = ({ groups, app }) => /* @__PURE__ */ React.createElement("div", null, groups.map((group) => /* @__PURE__ */ React.createElement("div", {
  key: group.heading,
  className: "rollup"
}, group.subgroups && group.subgroups.map((subgroup) => /* @__PURE__ */ React.createElement(SecurityGroupPod, {
  key: subgroup.heading,
  grouping: subgroup,
  application: app,
  parentHeading: group.heading
})))), groups.length === 0 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", {
  className: "text-center"
}, "No ", FirewallLabels.get("firewalls"), " match the filters you've selected.")));
const Filters = () => {
  const { showServerGroups, showLoadBalancers } = SecurityGroupState.filterModel.asFilterModel.sortFilter;
  const toggleParam = (event) => {
    const { checked } = event.target;
    const name = event.target.name;
    SecurityGroupState.filterModel.asFilterModel.sortFilter[name] = !!checked;
    SecurityGroupState.filterModel.asFilterModel.applyParamsToUrl();
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "col-lg-8 col-md-10"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "form-inline clearfix filters"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "form-group"
  }, /* @__PURE__ */ React.createElement("label", {
    className: "checkbox"
  }, " Show "), /* @__PURE__ */ React.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement("input", {
    type: "checkbox",
    name: "showServerGroups",
    checked: showServerGroups,
    onChange: toggleParam
  }), " Server Groups")), /* @__PURE__ */ React.createElement("div", {
    className: "checkbox"
  }, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement("input", {
    type: "checkbox",
    name: "showLoadBalancers",
    checked: showLoadBalancers,
    onChange: toggleParam
  }), " Load Balancers")))));
};
const SecurityGroups = ({ app }) => {
  const [filterModel, setFilterModel] = useState({ groups: [], tags: [] });
  const [initialized, setInitialized] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(true);
  const groupsUpdated = () => {
    setFilterModel({
      groups: SecurityGroupState.filterModel.asFilterModel.groups,
      tags: SecurityGroupState.filterModel.asFilterModel.tags
    });
  };
  const updateSecurityGroupGroups = () => {
    SecurityGroupState.filterModel.asFilterModel.applyParamsToUrl();
    const waiter = SETTINGS.feature.managedResources ? app.managedResources.ready() : Promise.resolve();
    waiter.catch(noop).finally(() => {
      SecurityGroupState.filterService.updateSecurityGroups(app);
      if (!initialized) {
        setInitialized(true);
      }
    });
  };
  const clearFilters = () => {
    SecurityGroupState.filterService.clearFilters();
    updateSecurityGroupGroups();
  };
  useEffect(() => {
    const groupsUpdatedListener = SecurityGroupState.filterService.groupsUpdatedStream.subscribe(groupsUpdated);
    const dataSource = app.getDataSource("securityGroups");
    const securityGroupsRefreshUnsubscribe = dataSource.onRefresh(null, updateSecurityGroupGroups);
    dataSource.ready().then(() => {
      updateSecurityGroupGroups();
    });
    app.setActiveState(app.securityGroups);
    SecurityGroupState.filterModel.asFilterModel.activate();
    ProviderSelectionService.isDisabled(app).then((val) => {
      setButtonDisable(val);
    });
    return () => {
      groupsUpdatedListener.unsubscribe();
      securityGroupsRefreshUnsubscribe();
    };
  }, [app]);
  const groupings = initialized ? /* @__PURE__ */ React.createElement(Groupings, {
    groups: filterModel.groups,
    app
  }) : /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Spinner, {
    size: "medium"
  }));
  return /* @__PURE__ */ React.createElement("div", {
    className: "main-content"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "header row header-clusters"
  }, /* @__PURE__ */ React.createElement(Filters, null), /* @__PURE__ */ React.createElement("div", {
    className: "col-lg-4 col-md-2"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "application-actions"
  }, buttonDisable ? /* @__PURE__ */ React.createElement("div", null) : /* @__PURE__ */ React.createElement(CreateSecurityGroupButton, {
    app
  }))), /* @__PURE__ */ React.createElement(FilterTags, {
    tags: filterModel.tags,
    tagCleared: updateSecurityGroupGroups,
    clearFilters
  })), /* @__PURE__ */ React.createElement("div", {
    className: "content"
  }, /* @__PURE__ */ React.createElement(BannerContainer, {
    app
  }), groupings));
};

const SECURITY_GROUP_STATES = "spinnaker.core.securityGroup.states";
module(SECURITY_GROUP_STATES, [APPLICATION_STATE_PROVIDER, STATE_CONFIG_PROVIDER]).config([
  "applicationStateProvider",
  "stateConfigProvider",
  (applicationStateProvider, stateConfigProvider) => {
    const firewallDetails = {
      name: "firewallDetails",
      url: "/firewallDetails/:provider/:accountId/:region/:vpcId/:name",
      params: {
        vpcId: {
          value: null,
          squash: true
        }
      },
      views: {
        "detail@../insight": {
          component: SecurityGroupDetails,
          $type: "react"
        }
      },
      resolve: {
        accountId: ["$stateParams", ($stateParams) => $stateParams.accountId],
        resolvedSecurityGroup: [
          "$stateParams",
          ($stateParams) => {
            return {
              name: $stateParams.name,
              accountId: $stateParams.accountId,
              provider: $stateParams.provider,
              region: $stateParams.region,
              vpcId: $stateParams.vpcId
            };
          }
        ]
      },
      data: {
        pageTitleDetails: {
          title: `${FirewallLabels.get("Firewall")} Details`,
          nameParam: "name",
          accountParam: "accountId",
          regionParam: "region"
        },
        history: {
          type: "securityGroups"
        }
      }
    };
    const securityGroupSummary = {
      url: `/firewalls?${stateConfigProvider.paramsToQuery(filterModelConfig)}`,
      name: "firewalls",
      views: {
        nav: { component: SecurityGroupFilters, $type: "react" },
        master: {
          component: SecurityGroups,
          $type: "react"
        }
      },
      params: stateConfigProvider.buildDynamicParams(filterModelConfig),
      data: {
        pageTitleSection: {
          title: FirewallLabels.get("Firewalls")
        }
      }
    };
    const standaloneFirewall = {
      name: "firewallDetails",
      url: "/firewallDetails/:provider/:accountId/:region/:vpcId/:name",
      params: {
        vpcId: {
          value: null,
          squash: true
        }
      },
      views: {
        "main@": {
          templateUrl: "core/src/presentation/standalone.view.html",
          controllerProvider: [
            "$stateParams",
            ($stateParams) => {
              return CloudProviderRegistry.getValue($stateParams.provider, "securityGroup.detailsController");
            }
          ],
          controllerAs: "ctrl"
        }
      },
      resolve: {
        resolvedSecurityGroup: [
          "$stateParams",
          ($stateParams) => {
            return {
              name: $stateParams.name,
              accountId: $stateParams.accountId,
              provider: $stateParams.provider,
              region: $stateParams.region,
              vpcId: $stateParams.vpcId
            };
          }
        ],
        app: [
          "$stateParams",
          "securityGroupReader",
          ($stateParams, securityGroupReader) => {
            return securityGroupReader.loadSecurityGroups().then((securityGroupsIndex) => {
              const application = ApplicationModelBuilder.createStandaloneApplication($stateParams.name);
              application["securityGroupsIndex"] = securityGroupsIndex;
              return application;
            });
          }
        ]
      },
      data: {
        pageTitleDetails: {
          title: `${FirewallLabels.get("Firewall")} Details`,
          nameParam: "name",
          accountParam: "accountId",
          regionParam: "region"
        },
        history: {
          type: "securityGroups"
        }
      }
    };
    applicationStateProvider.addInsightState(securityGroupSummary);
    applicationStateProvider.addInsightDetailState(firewallDetails);
    stateConfigProvider.addToRootState(standaloneFirewall);
    stateConfigProvider.addRewriteRule("/applications/{application}/securityGroups", "/applications/{application}/firewalls");
    stateConfigProvider.addRewriteRule(/(.+?)\/securityGroupDetails\/(.*)/, ($match) => {
      return `${$match[1]}/firewallDetails/${$match[2]}`;
    });
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/presentation/standalone.view.html", `<div class="standalone">
  <div class="col-md-6 col-md-offset-3">
    <div ng-include="detailsTemplateUrl"></div>
  </div>
</div>
`);
}]);

const CORE_SECURITYGROUP_SECURITYGROUP_MODULE = "spinnaker.core.securityGroup";
module(CORE_SECURITYGROUP_SECURITYGROUP_MODULE, [
  SECURITY_GROUP_FILTER,
  SECURITY_GROUP_DATA_SOURCE,
  SECURITY_GROUP_STATES
]);

const CORE_TASK_MODAL_REASON_DIRECTIVE = "spinnaker.task.reason.directive";
angular.module(CORE_TASK_MODAL_REASON_DIRECTIVE, []).directive("taskReason", function() {
  return {
    restrict: "E",
    bindToController: {
      command: "="
    },
    scope: {},
    controller: angular.noop,
    controllerAs: "vm",
    templateUrl: "core/src/task/modal/reason.directive.html"
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/task/modal/reason.directive.html", `<div class="row" style="margin-top: 10px; margin-bottom: 10px">
  <div class="col-md-3 sm-label-right">Reason</div>
  <div class="col-md-7">
    <textarea
      class="form-control"
      ng-model="vm.command.reason"
      rows="3"
      placeholder="(Optional) anything that might be helpful to explain the reason for this change; HTML is okay"
    ></textarea>
  </div>
</div>
`);
}]);

var css_248z$2 = "task-monitor {\n  display: block;\n}\n.not-started {\n  color: var(--color-concrete);\n}\n";
styleInject(css_248z$2);

const TASKS_MONITOR_DIRECTIVE = "spinnaker.tasks.monitor.directive";
const ngmodule = module(TASKS_MONITOR_DIRECTIVE, []);
ngmodule.component("taskMonitor", react2angular(withErrorBoundary(TaskMonitorWrapper, "taskMonitor"), ["monitor"]));

const CORE_TASK_MONITOR_TASKMONITOR_MODULE = "spinnaker.tasks.monitor";
module(CORE_TASK_MONITOR_TASKMONITOR_MODULE, [TASKS_MONITOR_DIRECTIVE]);

class PlatformHealthOverrideMessageController {
  constructor() {
    this.messageTemplate = "core/src/task/platformHealthOverrideMessage.html";
  }
  $onInit() {
    const lastCapacity = this.task.getValueFor("lastCapacityCheck");
    if (lastCapacity) {
      const lastCapacityTotal = lastCapacity.up + lastCapacity.down + lastCapacity.outOfService + lastCapacity.unknown + lastCapacity.succeeded + lastCapacity.failed;
      const isRelevantTask = this.task.execution.stages.some((stage) => {
        return (stage.type === "cloneServerGroup" || stage.type === "createServerGroup") && stage.tasks.some((task) => task.startTime === this.step.startTime);
      });
      this.showMessage = isRelevantTask && this.step.name === "waitForUpInstances" && this.step.runningTimeInMs > Duration.fromObject({ minutes: 5 }).as("milliseconds") && lastCapacity.unknown > 0 && lastCapacity.unknown === lastCapacityTotal && !get(this.application, "attributes.platformHealthOnly");
    }
  }
}
const platformHealthOverrideMessage = {
  bindings: {
    application: "<",
    step: "<",
    task: "<"
  },
  controller: PlatformHealthOverrideMessageController,
  template: `<i ng-if="$ctrl.showMessage"
                        uib-tooltip-template="::$ctrl.messageTemplate"
                        class="fa fa-exclamation-circle" style="font-size: smaller;"></i>`
};
const PLATFORM_HEALTH_OVERRIDE_MESSAGE = "spinnaker.core.platformHealthOverrideMessage.component";
module(PLATFORM_HEALTH_OVERRIDE_MESSAGE, []).component("platformHealthOverrideMessage", platformHealthOverrideMessage);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/task/platformHealthOverrideMessage.html", `<p>Task not completing?</p>
<p>
  By default, Spinnaker does not consider cloud provider health (i.e. whether your instances have launched and are
  running) as a reliable indicator of instance health.
</p>
<p>
  If your instances do not provide a health indicator known to Spinnaker (e.g. a discovery service or load balancers),
  you should configure your application to consider only cloud provider health when executing tasks. This option is
  available under Application Attributes in the <b>Config tab</b>.
</p>
`);
}]);

const STATUS_GLYPH_COMPONENT = "spinnaker.core.task.statusGlyph.component";
module(STATUS_GLYPH_COMPONENT, []).component("statusGlyph", react2angular(withErrorBoundary(StatusGlyph, "statusGlyph"), ["item"]));

const CORE_TASK_TASK_DATASOURCE = "spinnaker.core.task.dataSource";
angular.module(CORE_TASK_TASK_DATASOURCE, [CLUSTER_SERVICE]).run([
  "$q",
  "clusterService",
  function($q, clusterService) {
    const addTasks = (application, tasks) => {
      return $q.when(angular.isArray(tasks) ? tasks : []);
    };
    const loadPaginatedTasks = async (application, page = 1) => {
      let limitPerPage = SETTINGS.tasksViewLimitPerPage;
      const tasks = await TaskReader.getTasks(application.name, [], limitPerPage, page);
      if (tasks.length === limitPerPage) {
        return tasks.concat(await loadPaginatedTasks(application, page + 1));
      } else {
        return tasks;
      }
    };
    const loadTasks = (application, page = 1) => {
      let limitPerPage = SETTINGS.tasksViewLimitPerPage;
      if (limitPerPage === void 0) {
        return TaskReader.getTasks(application.name);
      } else {
        return loadPaginatedTasks(application, page);
      }
    };
    const loadRunningTasks = (application) => {
      return TaskReader.getRunningTasks(application.name);
    };
    const addRunningTasks = (application, data) => {
      return $q.when(data);
    };
    const runningTasksLoaded = (application) => {
      clusterService.addTasksToServerGroups(application);
      application.getDataSource("serverGroups").dataUpdated();
    };
    ApplicationDataSourceRegistry.registerDataSource({
      key: "tasks",
      sref: ".tasks",
      badge: "runningTasks",
      category: "tasks",
      loader: loadTasks,
      onLoad: addTasks,
      afterLoad: runningTasksLoaded,
      lazy: true,
      primary: true,
      icon: "fa fa-sm fa-fw fa-check-square",
      iconName: "spMenuTasks",
      defaultData: []
    });
    ApplicationDataSourceRegistry.registerDataSource({
      key: "runningTasks",
      visible: false,
      loader: loadRunningTasks,
      onLoad: addRunningTasks,
      defaultData: []
    });
  }
]);

function TaskNotFound() {
  const { params } = ReactInjector.$state;
  return /* @__PURE__ */ React__default.createElement(NotFound, {
    type: "Task",
    entityId: params.taskId
  });
}

const TASK_STATES = "spinnaker.core.task.states";
module(TASK_STATES, [APPLICATION_STATE_PROVIDER]).config([
  "applicationStateProvider",
  "stateConfigProvider",
  (applicationStateProvider, stateConfigProvider) => {
    const taskDetails = {
      name: "taskDetails",
      url: "/:taskId",
      views: {},
      data: {
        pageTitleDetails: {
          title: "Task Details",
          nameParam: "taskId"
        }
      }
    };
    const tasks = {
      name: "tasks",
      url: "/tasks?q",
      views: {
        insight: {
          templateUrl: "core/src/task/tasks.html",
          controller: "TasksCtrl",
          controllerAs: "tasks"
        }
      },
      params: {
        q: { dynamic: true, value: null }
      },
      data: {
        pageTitleSection: {
          title: "Tasks"
        }
      },
      children: [taskDetails]
    };
    const taskLookup = {
      name: "taskLookup",
      url: "/tasks/:taskId",
      params: {
        taskId: { dynamic: true }
      },
      redirectTo: (transition) => {
        const { taskId } = transition.params();
        if (!taskId) {
          return void 0;
        }
        return Promise.resolve(TaskReader.getTask(taskId)).then((task) => transition.router.stateService.target("home.applications.application.tasks.taskDetails", {
          application: task.application,
          taskId
        })).catch(() => {
        });
      },
      views: {
        "main@": { component: TaskNotFound, $type: "react" }
      }
    };
    applicationStateProvider.addChildState(tasks);
    stateConfigProvider.addToRootState(taskLookup);
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/task/tasks.html", `<div class="row tasks-wrapper">
  <div class="horizontal center spinner-container" ng-if="viewState.loading" style="width: 100%">
    <loading-spinner size="'medium'"></loading-spinner>
  </div>
  <div class="col-md-12" ng-if="viewState.loadError">
    <h4 class="text-center">There was an error loading tasks. Please try again later.</h4>
  </div>
  <div class="col-md-12 tasks" ng-if="!viewState.loading && !viewState.loadError">
    <div class="row tasks-header">
      <div class="col-md-5">
        <div class="btn-group">
          <label class="btn btn-sm btn-default" ng-model="viewState.taskStateFilter" uib-btn-radio="''">
            <a href>All</a>
          </label>
          <label class="btn btn-sm btn-default" ng-model="viewState.taskStateFilter" uib-btn-radio="'NOT_STARTED'">
            <a href> <status-glyph item="{hasNotStarted: true}"></status-glyph> Not Started </a>
          </label>
          <label class="btn btn-sm btn-default" ng-model="viewState.taskStateFilter" uib-btn-radio="'RUNNING'">
            <a href> <status-glyph item="{isRunning: true}"></status-glyph> Running </a>
          </label>
          <label class="btn btn-sm btn-default" ng-model="viewState.taskStateFilter" uib-btn-radio="'SUCCEEDED'">
            <a href> <status-glyph item="{isCompleted: true}"></status-glyph> Succeeded </a>
          </label>
          <label class="btn btn-sm btn-default" ng-model="viewState.taskStateFilter" uib-btn-radio="'TERMINAL'">
            <a href> <status-glyph item="{isFailed: true}"></status-glyph> Terminal </a>
          </label>
          <label class="btn btn-sm btn-default" ng-model="viewState.taskStateFilter" uib-btn-radio="'CANCELED'">
            <a href> <status-glyph item="{isCanceled: true}"></status-glyph> Canceled </a>
          </label>
        </div>
      </div>
      <div class="col-md-4 text-right horizontal right" style="padding-right: 0; margin-left: auto">
        <a
          class="btn btn-link"
          ng-click="tasks.clearNameFilter()"
          style="padding-right: 5px"
          ng-if="viewState.nameFilter.length > 0"
        >
          <span class="glyphicon glyphicon-remove" uib-tooltip="clear search filter"></span>
        </a>
        <div class="form-group has-feedback">
          <label class="sr-only" for="task-filter">Filter tasks by name, user, or task ID</label>
          <input
            type="search"
            id="task-filter"
            class="form-control input-sm"
            placeholder="Filter tasks by name, user, or task ID"
            ng-change="tasks.nameFilterUpdated()"
            ng-model="viewState.nameFilter"
          />
          <span class="glyphicon glyphicon-search form-control-feedback"></span>
        </div>
      </div>
    </div>
    <div class="row tasks-content">
      <div class="col-md-10 col-md-offset-1 text-center" ng-if="!tasks.sortedTasks.length" style="margin-top: 30px">
        <h4 ng-if="!viewState.nameFilter && !viewState.taskStateFilter">
          We couldn't find any tasks for {{tasks.application.name}}
        </h4>
        <div ng-if="viewState.nameFilter  || viewState.taskStateFilter">
          <h4>We couldn't find any tasks matching the filters you've specified.</h4>
          <p style="margin-top: 20px"><strong>Note</strong> that Spinnaker only tracks tasks for two weeks.</p>
        </div>
      </div>
      <div class="col-md-12" ng-if="tasks.sortedTasks.length">
        <table class="table table-condensed">
          <thead>
            <tr>
              <th width="30%">Task</th>
              <th width="5%">Account</th>
              <th width="8%">Region</th>
              <th width="12%">Progress</th>
              <th width="12%">Started</th>
              <th width="12%">Ended</th>
              <th width="8%">Running Time</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr class="clickable" ng-click="tasks.toggleDetails(task.id)" ng-repeat-start="task in tasks.resultPage()">
              <td>
                <div class="task-name">
                  <a href id="task-{{task.id}}"
                    ><span class="glyphicon glyphicon-chevron-{{tasks.isExpanded(task.id) ? 'down' : 'right'}}"></span
                  ></a>
                  {{task.name}}
                </div>

                <div ng-if="tasks.getFirstDeployServerGroupName(task)" class="task-name">
                  <a href><span class="glyphicon glyphicon-none"></span></a>
                  <span ng-if="tasks.getProviderForServerGroupByTask(task)">
                    Deployed
                    <a
                      ui-sref="^.insight.clusters.serverGroup({application: tasks.application.name, serverGroup: tasks.getFirstDeployServerGroupName(task), accountId: tasks.getAccountId(task), region: tasks.getRegion(task), provider: tasks.getProviderForServerGroupByTask(task)})"
                      ng-click="$event.stopPropagation()"
                    >
                      {{tasks.getFirstDeployServerGroupName(task)}}</a
                    >
                  </span>

                  <span ng-if="!tasks.getProviderForServerGroupByTask(task)">
                    Deployed {{tasks.getFirstDeployServerGroupName(task)}}
                  </span>
                </div>
              </td>
              <td>
                <account-tag
                  account="task.getValueFor('credentials') ? task.getValueFor('credentials') : task.getValueFor('account')"
                  pad="both"
                ></account-tag>
              </td>
              <td>
                <span ng-if="task.getValueFor('region')">{{task.getValueFor('region')}}</span>
                <span ng-if="!task.getValueFor('region') && task.getValueFor('regions')"
                  >{{task.getValueFor('regions').join(', ')}}</span
                >
                <span
                  ng-if="!task.getValueFor('region') && !task.getValueFor('regions') && task.getValueFor('location')"
                >
                  {{task.getValueFor('location')}}
                </span>
              </td>
              <td>
                <task-progress-bar task="task"></task-progress-bar>
              </td>
              <td>{{ task.startTime | timestamp }}</td>
              <td>{{ task.endTime | timestamp }}</td>
              <td>
                <span ng-if="task.runningTimeInMs && !viewState.cancelling">
                  {{ task.runningTimeInMs | duration }}
                </span>
                <span ng-if="viewState.cancelling || !task.runningTimeInMs"> - </span>
              </td>
              <td>{{ task.getDisplayUser() }}</td>
              <td class="small text-center">
                <a
                  ng-if="task.isRunning || task.hasNotStarted"
                  href
                  ng-click="tasks.cancelTask(task.id); $event.stopPropagation();"
                >
                  <span class="glyphicon glyphicon-remove" uib-tooltip="Cancel Task"></span>
                </a>
              </td>
            </tr>
            <tr ng-repeat="step in task.steps | displayableTasks" ng-if="tasks.isExpanded(task.id)" class="task-step">
              <td colspan="4">
                <status-glyph item="step"></status-glyph>
                {{step.name | robotToHuman }}
              </td>
              <td>{{ step.startTime | timestamp }}</td>
              <td>{{ step.endTime | timestamp }}</td>
              <td colspan="3">{{ step.runningTimeInMs | duration }}</td>
            </tr>
            <tr class="task-error-message danger" ng-if="task.isFailed && tasks.isExpanded(task.id)">
              <td colspan="9">
                <strong>Exception:</strong> <span ng-bind-html="task.failureMessage || 'No reason provided'"></span>
              </td>
            </tr>
            <tr ng-if="tasks.isExpanded(task.id) && task.getValueFor('reason')" class="task-reason">
              <td colspan="9"><strong>Reason:</strong> <span ng-bind-html="task.getValueFor('reason')"></span></td>
            </tr>
            <tr ng-if="tasks.isExpanded(task.id)" ng-repeat-end>
              <td colspan="9" class="small text-right">
                <a href="{{tasksUrl + task.id}}" target="_blank">View as JSON</a> |
                <a target="_blank" ui-sref=".taskDetails({taskId: task.id})">Permalink</a>
                <copy-to-clipboard
                  text="$state.href(viewState.nameFilter ? '.' : '.taskDetails', {taskId: task.id}, {absolute:true} )"
                  tool-tip="'Copy permalink to clipboard'"
                ></copy-to-clipboard>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row pagination-footer">
      <div class="col-md-9">
        <ul
          uib-pagination
          ng-if="!viewState.loading && tasks.sortedTasks.length > pagination.itemsPerPage"
          items-per-page="pagination.itemsPerPage"
          total-items="tasks.sortedTasks.length"
          max-size="pagination.maxSize"
          ng-model="pagination.currentPage"
          class="pagination-sm"
        ></ul>
      </div>
      <div class="col-md-3 text-right">
        <div class="form-group">
          Show
          <select
            class="input input-sm"
            ng-model="viewState.itemsPerPage"
            ng-change="tasks.sortTasksAndResetPaginator()"
            ng-options="count for count in filterCountOptions"
            style="width: 50px"
          ></select>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
`);
}]);

const CORE_TASK_TASKPROGRESSBAR_DIRECTIVE = "spinnaker.core.task.progressBar.directive";
module(CORE_TASK_TASKPROGRESSBAR_DIRECTIVE, []).component("taskProgressBar", react2angular(withErrorBoundary(TaskProgressBar, "taskProgressBar"), ["task"]));

const CORE_TASK_TASKS_CONTROLLER = "spinnaker.core.task.controller";
module(CORE_TASK_TASKS_CONTROLLER, [
  UIROUTER_ANGULARJS,
  CORE_TASK_TASKPROGRESSBAR_DIRECTIVE,
  DISPLAYABLE_TASKS_FILTER
]).controller("TasksCtrl", [
  "$scope",
  "$state",
  "$stateParams",
  "$q",
  "app",
  function($scope, $state, $stateParams, $q, app) {
    if (app.notFound || app.hasError) {
      return;
    }
    const controller = this;
    const application = app;
    $scope.$state = $state;
    const tasksViewStateCache = ViewStateCache.get("tasks") || ViewStateCache.createCache("tasks", { version: 1 });
    function cacheViewState() {
      tasksViewStateCache.put(application.name, $scope.viewState);
      cacheGlobalViewState();
    }
    function cacheGlobalViewState() {
      tasksViewStateCache.put("#common", {
        itemsPerPage: $scope.viewState.itemsPerPage
      });
    }
    $scope.tasksUrl = [SETTINGS.gateUrl, "applications", application.name, "tasks/"].join("/");
    $scope.filterCountOptions = [10, 20, 30, 50, 100, 200];
    function initializeViewState() {
      const viewState = tasksViewStateCache.get(application.name) || {
        taskStateFilter: "",
        expandedTasks: []
      };
      viewState.nameFilter = $stateParams.q || "";
      viewState.loading = true;
      viewState.cancelling = false;
      viewState.itemsPerPage = tasksViewStateCache.get("#common") ? tasksViewStateCache.get("#common").itemsPerPage : 20;
      $scope.viewState = viewState;
      if ($stateParams.taskId) {
        setTaskFilter();
      }
    }
    const setTaskFilter = () => {
      const taskId = $stateParams.taskId;
      if (!$scope.viewState.expandedTasks.includes(taskId)) {
        controller.toggleDetails(taskId);
      }
      $scope.viewState.nameFilter = taskId;
      $scope.viewState.taskStateFilter = "";
      controller.sortTasksAndResetPaginator();
    };
    controller.taskStateFilter = "All";
    controller.application = application;
    controller.sortedTasks = [];
    controller.toggleDetails = function(taskId) {
      const index = $scope.viewState.expandedTasks.indexOf(taskId);
      if (index === -1) {
        $scope.viewState.expandedTasks.push(taskId);
      } else {
        $scope.viewState.expandedTasks.splice(index, 1);
      }
    };
    controller.isExpanded = function(taskId) {
      return taskId && $scope.viewState.expandedTasks.includes(taskId);
    };
    controller.sortTasksAndResetPaginator = function() {
      controller.sortTasks();
      controller.resetPaginator();
    };
    controller.sortTasks = function() {
      const joinedLists = filterRunningTasks().concat(filterNonRunningTasks());
      controller.sortedTasks = joinedLists;
      if ($scope.viewState.nameFilter) {
        const normalizedSearch = $scope.viewState.nameFilter.toLowerCase();
        controller.sortedTasks = ___default.filter(joinedLists, function(task) {
          return task.name.toLowerCase().includes(normalizedSearch) || task.id.toLowerCase().includes(normalizedSearch) || (task.getValueFor("credentials") || "").toLowerCase().includes(normalizedSearch) || (task.getValueFor("region") || "").toLowerCase().includes(normalizedSearch) || (task.getValueFor("regions") || []).join(" ").toLowerCase().includes(normalizedSearch) || (task.getValueFor("user") || "").toLowerCase().includes(normalizedSearch) || ___default.get(task, "execution.authentication.user", "").toLowerCase().includes(normalizedSearch);
        });
      }
      if ($scope.viewState.taskStateFilter) {
        controller.sortedTasks = ___default.filter(controller.sortedTasks, { status: $scope.viewState.taskStateFilter });
      }
    };
    controller.clearNameFilter = function() {
      $scope.viewState.nameFilter = "";
      controller.nameFilterUpdated();
    };
    controller.nameFilterUpdated = ___default.debounce(() => {
      const params = { q: $scope.viewState.nameFilter };
      if ($state.includes("**.taskDetails")) {
        $state.go("^", params);
      } else {
        $state.go(".", params);
      }
      controller.sortTasksAndResetPaginator();
    }, 300);
    controller.cancelTask = function(taskId) {
      const task = application.tasks.data.filter(function(task2) {
        return task2.id === taskId;
      })[0];
      const submitMethod = function() {
        $scope.viewState.cancelling = true;
        return TaskWriter.cancelTask(taskId).then(() => {
          $scope.viewState.cancelling = false;
          application.tasks.refresh();
        });
      };
      ConfirmationModalService.confirm({
        header: "Really cancel " + task.name + "?",
        buttonText: "Yes",
        cancelButtonText: "No",
        submitMethod
      });
    };
    controller.resetPaginator = function resetPaginator() {
      $scope.pagination = {
        currentPage: 1,
        itemsPerPage: $scope.viewState.itemsPerPage,
        maxSize: 12
      };
    };
    controller.resultPage = function resultPage() {
      const pagination = $scope.pagination;
      const allFiltered = controller.sortedTasks;
      const start = (pagination.currentPage - 1) * pagination.itemsPerPage;
      const end = pagination.currentPage * pagination.itemsPerPage;
      if (!allFiltered || !allFiltered.length) {
        return [];
      }
      if (allFiltered.length < pagination.itemsPerPage) {
        return allFiltered;
      }
      if (allFiltered.length < end) {
        return allFiltered.slice(start);
      }
      return allFiltered.slice(start, end);
    };
    controller.getFirstDeployServerGroupName = function(task) {
      if (task.execution && task.execution.stages) {
        const stage = findStageWithTaskInExecution(task.execution, [
          "createCopyLastAsg",
          "createDeploy",
          "cloneServerGroup",
          "createServerGroup"
        ]);
        return ___default.chain(stage).get("context").get("deploy.server.groups").values().head().head().value();
      }
    };
    controller.getAccountId = function(task) {
      return ___default.chain(task.variables).find({ key: "account" }).result("value").value();
    };
    controller.getRegion = function(task) {
      const regionVariable = (task.variables || []).find((variable) => {
        return ["deploy.server.groups", "availabilityZones"].includes(variable.key) && Object.keys(variable.value).length;
      });
      return regionVariable && Object.keys(regionVariable.value)[0];
    };
    controller.getProviderForServerGroupByTask = function(task) {
      const serverGroupName = controller.getFirstDeployServerGroupName(task);
      return ___default.chain(application.serverGroups.data).find(function(serverGroup) {
        return serverGroup.name === serverGroupName;
      }).result("type").value();
    };
    function findStageWithTaskInExecution(execution, stageName) {
      return ___default.chain(execution.stages).find(function(stage) {
        return ___default.some(stage.tasks, function(task) {
          return stageName.includes(task.name);
        });
      }).value();
    }
    function filterRunningTasks() {
      const running = ___default.chain(application.tasks.data).filter(function(task) {
        return task.name && task.isActive;
      }).value();
      return running.sort(taskStartTimeComparator);
    }
    function filterNonRunningTasks() {
      const notRunning = ___default.chain(application.tasks.data).filter(function(task) {
        return task.name && !task.isActive;
      }).value();
      return notRunning.sort(taskStartTimeComparator);
    }
    function taskStartTimeComparator(taskA, taskB) {
      return taskB.startTime > taskA.startTime ? 1 : taskB.startTime < taskA.startTime ? -1 : 0;
    }
    $scope.$watch("viewState.taskStateFilter", controller.sortTasksAndResetPaginator);
    $scope.$watch("viewState", cacheViewState, true);
    initializeViewState();
    application.tasks.activate();
    application.tasks.ready().then(() => {
      $scope.viewState.loading = false;
      $scope.viewState.loadError = app.tasks.loadFailure;
      if (!app.tasks.loadFailure) {
        this.sortTasks();
      }
    });
    application.setActiveState(application.tasks);
    $scope.$on("$destroy", () => {
      application.setActiveState();
      application.tasks.deactivate();
    });
    this.stateChanged = (q) => {
      if ($scope.viewState.nameFilter !== q) {
        $scope.viewState.nameFilter = q;
        this.sortTasksAndResetPaginator();
      } else if ($stateParams.taskId) {
        setTaskFilter();
      }
    };
    $scope.$on("$stateChangeSuccess", (_event, _toState, toParams) => this.stateChanged(toParams.q));
    this.application.tasks.onRefresh($scope, this.sortTasks);
  }
]);

var css_248z$1 = ".user-verification,\nuser-verification {\n  text-align: right;\n  font-size: 90%;\n  display: block;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n.user-verification .verification-text,\nuser-verification .verification-text {\n  font-weight: 600;\n  color: var(--color-danger);\n}\n.user-verification .form-group .input-sm,\nuser-verification .form-group .input-sm {\n  height: 25px;\n  padding: 5px;\n  width: 110px;\n  text-align: center;\n  margin-left: 5px;\n}\n";
styleInject(css_248z$1);

const CORE_TASK_VERIFICATION_USERVERIFICATION_DIRECTIVE = "spinnaker.core.task.verification.userVerification.directive";
module(CORE_TASK_VERIFICATION_USERVERIFICATION_DIRECTIVE, []).directive("userVerification", function() {
  return {
    restrict: "E",
    templateUrl: "core/src/task/verification/userVerification.directive.html",
    scope: {},
    bindToController: {
      verification: "=",
      account: "=",
      label: "=?",
      autofocus: "=?"
    },
    controllerAs: "vm",
    controller: "UserVerificationCtrl"
  };
}).controller("UserVerificationCtrl", [
  "$scope",
  function($scope) {
    this.$onInit = () => {
      this.label = this.label || `Type the name of the account (<span class="verification-text">${this.account}</span>) to continue`;
      this.userVerification = "";
      this.required = false;
      this.verification.verified = true;
      $scope.$watch(() => this.account, initialize);
    };
    const initialize = () => {
      if (this.verification.toVerify) {
        this.required = true;
        this.verification.verified = false;
      }
      if (this.account) {
        this.verification.toVerify = this.account;
        AccountService.challengeDestructiveActions(this.account).then((challenge) => {
          this.required = challenge;
          this.verification.verified = !challenge;
        });
      }
    };
    this.verify = () => {
      this.verification.verified = this.userVerification.toUpperCase() === this.verification.toVerify.toUpperCase();
    };
  }
]);
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/task/verification/userVerification.directive.html", `<div class="row verification" ng-if="vm.required">
  <div class="col-sm-12">
    <div class="form-inline">
      <div class="form-group">
        <div class="form-control-static" ng-bind-html="vm.label"></div>
        <help-field key="user.verification"></help-field>
        <input
          type="text"
          class="form-control input-sm highlight-pristine"
          ng-model="vm.userVerification"
          ng-change="vm.verify()"
          auto-focus="vm.autofocus"
          ng-class="{'ng-invalid': !vm.verification.verified}"
        />
      </div>
    </div>
  </div>
</div>
`);
}]);

var css_248z = ".tasks-wrapper {\n  display: flex;\n}\n.tasks {\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin-right: 24px;\n}\n.tasks > .tasks-header {\n  flex: 0 0 auto;\n  display: flex;\n  z-index: 4;\n  box-shadow: 0 20px 10px -10px var(--color-alabaster);\n  padding-bottom: 0;\n}\n.tasks > .tasks-header h3 {\n  margin-top: 0;\n  font-weight: 600;\n}\n.tasks > .tasks-header .btn-group a {\n  text-decoration: none;\n  color: var(--color-mineshaft);\n}\n.tasks > .tasks-header .btn-group a:active,\n.tasks > .tasks-header .btn-group a:focus,\n.tasks > .tasks-header .btn-group a:hover {\n  color: var(--color-mineshaft);\n}\n.tasks > .tasks-content {\n  padding: 10px 15px;\n  flex: 1 1 auto;\n  overflow-y: auto;\n}\n.tasks .pagination-footer {\n  margin-bottom: 15px;\n  margin-top: 5px;\n  z-index: 4;\n  box-shadow: 0 -15px 8px -8px var(--color-alabaster);\n}\n.tasks .pagination-footer .pagination {\n  margin: 0;\n}\n.tasks .task-name {\n  text-indent: -14px;\n  margin-left: 20px;\n}\n.tasks .task-name .glyphicon {\n  font-size: 75%;\n  color: var(--color-concrete);\n  display: inline;\n}\n.tasks .task-step {\n  background-color: var(--color-cirrus);\n  font-size: 90%;\n}\n.tasks .task-step,\n.tasks .task-error-message {\n  word-break: break-all;\n}\n.tasks .task-step > :first-child,\n.tasks .task-error-message > :first-child {\n  padding-left: 20px;\n}\n.tasks .task-reason {\n  background-color: var(--color-white);\n}\n.tasks .task-reason td {\n  padding-top: 5px;\n  padding-left: 40px;\n}\n.tasks .progress {\n  height: 10px;\n  margin-bottom: 0;\n  margin-top: 5px;\n}\n.tasks .progress .progress-bar-danger {\n  background-color: var(--color-danger);\n}\n.tasks .progress .progress-bar-success {\n  background-color: var(--color-success);\n}\n.tasks .progress .progress-bar-disabled {\n  background-color: var(--color-concrete);\n}\n.status-glyph.fa-check {\n  color: var(--color-success);\n}\n.status-glyph.fa-exclamation-triangle {\n  color: var(--color-danger);\n}\n.status-glyph.glyphicon-play {\n  color: var(--color-accent);\n}\n.status-glyph.glyphicon-stop,\n.status-glyph.glyphicon-pause,\n.status-glyph.glyphicon-time {\n  color: var(--color-concrete);\n}\n";
styleInject(css_248z);

const CORE_TASK_TASK_MODULE = "spinnaker.core.task";
module(CORE_TASK_TASK_MODULE, [
  CORE_TASK_VERIFICATION_USERVERIFICATION_DIRECTIVE,
  CORE_TASK_MODAL_REASON_DIRECTIVE,
  CORE_TASK_MONITOR_TASKMONITOR_MODULE,
  STATUS_GLYPH_COMPONENT,
  CORE_TASK_TASKS_CONTROLLER,
  CORE_TASK_TASK_DATASOURCE,
  TASK_STATES,
  PLATFORM_HEALTH_OVERRIDE_MESSAGE
]);

const COPY_TO_CLIPBOARD_COMPONENT = "spinnaker.core.utils.copyToClipboard.directive";
module(COPY_TO_CLIPBOARD_COMPONENT, []).component("copyToClipboard", react2angular(withErrorBoundary(CopyToClipboard, "copyToClipboard"), [
  "analyticsLabel",
  "buttonInnerNode",
  "displayText",
  "text",
  "toolTip",
  "className",
  "stopPropagation"
]));

const CORE_UTILS_INFINITESCROLL_DIRECTIVE = "spinnaker.core.utils.infiniteScroll.directive";
angular.module(CORE_UTILS_INFINITESCROLL_DIRECTIVE, []).directive("infiniteScroll", [
  "$rootScope",
  "$window",
  "$timeout",
  function($rootScope, $window, $timeout) {
    return {
      link: function(scope, elem, attrs) {
        let scrollDistance = 0;
        let scrollEnabled = true;
        let checkWhenEnabled = false;
        $window = angular.element($window);
        elem.css("overflow-y", "auto");
        elem.css("overflow-x", "hidden");
        elem.css("height", "inherit");
        if (attrs.infiniteScrollDistance != null) {
          scope.$watch(attrs.infiniteScrollDistance, function(value) {
            return scrollDistance = parseInt(value, 10);
          });
        }
        if (attrs.infiniteScrollDisabled != null) {
          scope.$watch(attrs.infiniteScrollDisabled, function(value) {
            scrollEnabled = !value;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              return handler();
            }
          });
        }
        $rootScope.$on("refreshStart", function() {
          elem.animate({ scrollTop: "0" });
        });
        const handler = function() {
          const container = $(elem.children()[0]);
          const elementBottom = elem.offset().top + elem.height();
          const containerBottom = container.offset().top + container.height();
          const remaining = containerBottom - elementBottom;
          const shouldScroll = remaining <= elem.height() * scrollDistance;
          if (shouldScroll && scrollEnabled) {
            if ($rootScope.$$phase) {
              return scope.$eval(attrs.infiniteScroll);
            } else {
              return scope.$apply(attrs.infiniteScroll);
            }
          } else if (shouldScroll) {
            return checkWhenEnabled = true;
          }
        };
        elem.on("scroll", handler);
        scope.$on("$destroy", function() {
          return $window.off("scroll", handler);
        });
        return $timeout(function() {
          if (attrs.infiniteScrollImmediateCheck) {
            if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
              return handler();
            }
          } else {
            return handler();
          }
        }, 0);
      }
    };
  }
]);

class DoubleClickController {
  constructor() {
    this.BOUND_EVENT = "dblclick.textselection";
  }
  selectText() {
    const selection = window.getSelection();
    const range = window.document.createRange();
    range.selectNodeContents(this.$element.get(0));
    selection.removeAllRanges();
    selection.addRange(range);
  }
  initialize() {
    this.$element.bind(this.BOUND_EVENT, () => this.selectText());
    this.$scope.$on("$destroy", () => this.$element.unbind(this.BOUND_EVENT));
  }
}
const SELECT_ON_DOUBLE_CLICK_DIRECTIVE = "spinnaker.core.utils.selectOnDblClick";
module(SELECT_ON_DOUBLE_CLICK_DIRECTIVE, []).directive("selectOnDblClick", function() {
  return {
    restrict: "A",
    controller: DoubleClickController,
    link: ($scope, $element, _$attrs, ctrl) => {
      ctrl.$scope = $scope;
      ctrl.$element = $element;
      ctrl.$attrs = _$attrs;
      ctrl.initialize();
    }
  };
});

const UIB_MODAL_REJECTIONS = "spinnaker.core.utils.uibModalRejections";
module(UIB_MODAL_REJECTIONS, []).decorator("$uibModal", [
  "$delegate",
  function($delegate) {
    const realOpen = $delegate.open;
    $delegate.open = function() {
      const modalInstance = realOpen.apply(this, arguments);
      modalInstance.result.catch(() => {
      });
      return modalInstance;
    };
    return $delegate;
  }
]);

const CORE_UTILS_WAYPOINTS_WAYPOINT_DIRECTIVE = "spinnaker.core.utils.waypoints.directive";
module(CORE_UTILS_WAYPOINTS_WAYPOINT_DIRECTIVE, []).directive("waypoint", function() {
  return {
    restrict: "A",
    link: {
      post: function(scope, elem) {
        scope.$on("$destroy", function() {
          elem.removeData();
        });
      }
    }
  };
});

const CORE_UTILS_UTILS_MODULE = "spinnaker.utils";
module(CORE_UTILS_UTILS_MODULE, [
  COPY_TO_CLIPBOARD_COMPONENT,
  TIME_FORMATTERS,
  SELECT_ON_DOUBLE_CLICK_DIRECTIVE,
  CORE_UTILS_INFINITESCROLL_DIRECTIVE,
  RENDER_IF_FEATURE,
  UIB_MODAL_REJECTIONS,
  CORE_UTILS_WAYPOINTS_WAYPOINT_DIRECTIVE,
  CORE_UTILS_WAYPOINTS_WAYPOINTCONTAINER_DIRECTIVE
]);

const CORE_VALIDATION_TRIGGERVALIDATION_DIRECTIVE = "spinnaker.core.validation.trigger.directive";
module(CORE_VALIDATION_TRIGGERVALIDATION_DIRECTIVE, []).directive("triggerValidation", function() {
  return {
    restrict: "A",
    require: "ngModel",
    link: function(scope, elem, attr, ctrl) {
      const watches = attr.triggerValidation.split(",");
      watches.forEach(function(watchValue) {
        scope.$watch(watchValue, function() {
          if (ctrl.$viewValue) {
            ctrl.$validate();
          }
        });
      });
    }
  };
});

const CORE_VALIDATION_VALIDATIONERROR_DIRECTIVE = "spinnaker.core.validation.error.directive";
module(CORE_VALIDATION_VALIDATIONERROR_DIRECTIVE, []).directive("validationError", function() {
  return {
    restrict: "E",
    templateUrl: "core/src/validation/validationError.html",
    scope: {
      message: "@"
    }
  };
});
window.angular.module("ng").run(["$templateCache", function(templateCache) {
  templateCache.put("core/src/validation/validationError.html", `<div class="error-message"><span class="fa fa-exclamation-circle"></span> {{message}}</div>
`);
}]);

const CORE_VALIDATION_VALIDATION_MODULE = "spinnaker.core.validation";
module(CORE_VALIDATION_VALIDATION_MODULE, [
  CORE_VALIDATION_VALIDATEUNIQUE_DIRECTIVE,
  CORE_VALIDATION_TRIGGERVALIDATION_DIRECTIVE,
  CORE_VALIDATION_VALIDATIONERROR_DIRECTIVE
]);

const CORE_BANNER_CONTAINER_COMPONENT = "spinnaker.core.banner.container";
const name$1 = CORE_BANNER_CONTAINER_COMPONENT;
module(name$1, []).component("bannerContainer", react2angular(withErrorBoundary(BannerContainer, "bannerContainer"), ["app"]));

const CORE_BANNER_CONTAINER_MODULE = "spinnaker.core.bannerContainer";
module(CORE_BANNER_CONTAINER_MODULE, [CORE_BANNER_CONTAINER_COMPONENT]);

initGoogleAnalytics();
const UI_ROUTER_STATE_EVENTS_SHIM = "ui.router.state.events";
const CORE_MODULE = "spinnaker.core";
module(CORE_MODULE, [
  ANGULAR_MESSAGES,
  ANGULAR_SANITIZE,
  UIROUTER_ANGULARJS,
  UI_ROUTER_STATE_EVENTS_SHIM,
  UI_ROUTER_REACT_HYBRID,
  UI_ROUTER_REACT_ERROR_BOUNDARY,
  REACT_MODULE,
  ANGULAR_UI_BOOTSTRAP,
  UI_SELECT,
  angularSpinner.name,
  ANALYTICS_MODULE,
  APPLICATION_MODULE,
  APPLICATION_BOOTSTRAP_MODULE,
  ARTIFACT_MODULE,
  AUTHENTICATION_MODULE,
  CI_MODULE,
  CLOUD_PROVIDER_MODULE,
  CLUSTER_MODULE,
  CUSTOM_BANNER_CONFIG,
  DEBUG_WINDOW,
  DEPLOYMENT_STRATEGY_MODULE,
  DIFF_MODULE,
  ENTITY_TAGS_MODULE,
  FIREWALL_LABEL_COMPONENT,
  CORE_FORMS_FORMS_MODULE,
  HEALTH_COUNTS_MODULE,
  HELP_MODULE,
  INSIGHT_MODULE,
  CORE_INSTANCE_INSTANCE_MODULE,
  INTERCEPTOR_MODULE,
  LABEL_FILTER_COMPONENT,
  LOAD_BALANCER_MODULE,
  FUNCTION_MODULE,
  MANAGED_RESOURCE_CONFIG,
  MANAGED_RESOURCES_DATA_SOURCE,
  CORE_MANAGED_MANAGED_MODULE,
  CORE_MODAL_MODAL_MODULE,
  NETWORK_INTERCEPTOR,
  CORE_NOTIFICATION_NOTIFICATIONS_MODULE,
  PAGE_TITLE_MODULE,
  PAGER_DUTY_MODULE,
  PIPELINE_TEMPLATE_MODULE,
  PIPELINE_MODULE,
  PLUGINS_MODULE,
  CORE_PRESENTATION_PRESENTATION_MODULE,
  CORE_PROJECTS_PROJECTS_MODULE,
  RECENT_HISTORY_SERVICE,
  REGION_MODULE,
  CORE_SEARCH_SEARCH_MODULE,
  CORE_SECURITYGROUP_SECURITYGROUP_MODULE,
  SERVERGROUP_MODULE,
  SERVER_GROUP_MANAGER_MODULE,
  SLACK_COMPONENT,
  STYLEGUIDE_MODULE,
  SUBNET_MODULE,
  CORE_TASK_TASK_MODULE,
  CORE_UTILS_UTILS_MODULE,
  WIDGETS_MODULE,
  CORE_VALIDATION_VALIDATION_MODULE,
  CORE_BANNER_CONTAINER_MODULE
]).run(() => {
  initialize();
});

export { API, APPLICATION_STATE_PROVIDER, ARTIFACT_ACCOUNT_SELECTOR_COMPONENT_REACT, ARTIFACT_TYPE_EMBEDDED, ARTIFACT_TYPE_REMOTE, AccountCell, AccountSelectInput, AccountService, AccountTag, AddEntityTagLinks, Alerts, AngularJSAdapter, AppListExtractor, Application, ApplicationContext, ApplicationContextProvider, ApplicationDataSource, ApplicationDataSourceRegistry, ApplicationIcon, ApplicationModelBuilder, ApplicationNameValidator, ApplicationReader, ApplicationStateProvider, ApplicationWriter, Applications$1 as Applications, ApplicationsPickerInput, ArtifactAccountSelector, ArtifactIcon, ArtifactIconList, ArtifactIconService, ArtifactList, ArtifactReferenceService, ArtifactTypePatterns, AsgActionExecutionDetailsSection, AuthenticationInitializer, AuthenticationService, BakeExecutionLabel, BakeryReader, BannerContainer, BannerContainerContent, BaseBuildTriggerTemplate, BasicCell, BreakString, BuildServiceType, CACHE_INITIALIZER_SERVICE, CLUSTER_MATCHES_COMPONENT, CLUSTER_SERVICE, CONFIG_SECTION_FOOTER, CORE_MANAGED_MANAGED_MODULE, CORE_MODULE, CacheInitializerService, CapacityDetailsSection, CategorizedNotifications, CertificateReader, CheckboxInput, ChecklistInput, CloudMetricsReader, CloudProviderIcon, CloudProviderLabel, CloudProviderLogo, CloudProviderRegistry, ClusterFilterService, ClusterMatcher, ClusterMatches, ClusterPodTitleWrapper, ClusterService, ClusterState, ClusterTargetBuilder, Clusters, CollapsibleElement, CollapsibleSection, CollapsibleSectionStateCache, CollapsibleSectionStateCacheInternal, ConfigSectionFooter, ConfigSectionFooterController, ConfigureProjectModal, ConfirmationModalService, ConsoleOutputLink, CopyToClipboard, CoreModalInject, CoreReactInject, AdditionalFields$3 as CoreRedBlackAdditionalFields, CreateFunctionButton, CreateLoadBalancerButton, CreatePipelineModal, CurrentCapacity, CustomLabels, DELIVERY_KEY, DEPLOY_INITIALIZER_COMPONENT, DIFF_MODULE, DayPickerInput, DebugTiming, DebugTimingCumulative, DeckCacheFactory, DefaultClusterMatcher, DefaultPodNameProvider, DefaultSearchResultTab, DeleteType, DeployInitializer, DeployInitializerController, DeployingIntoManagedClusterWarning, DeploymentStrategyRegistrar, DeploymentStrategyRegistry, DeploymentStrategySelector, DeprecatedRequestBuilder, DesiredCapacity, Details, DiffView, EXECUTION_ARTIFACT_TAB, EXECUTION_DETAILS_SECTION_SERVICE, EXECUTION_SERVICE, EXPECTED_ARTIFACT_EDITOR_COMPONENT_REACT, EXPECTED_ARTIFACT_SELECTOR_COMPONENT_REACT, EXPECTED_ARTIFACT_SOURCE_SELECTOR_COMPONENT_REACT, EditNotificationModal, EntityName, EntityNotifications, EntitySource, EntityTagEditor, EntityTagWriter, EntityTagsReader, EventBus, Execution$1 as Execution, ExecutionArtifactTab, ExecutionBarLabel, ExecutionDetailsSection, ExecutionDetailsSectionNav, ExecutionDetailsSectionService, ExecutionDetailsTasks, ExecutionFilterModel, ExecutionMarkerIcon, ExecutionService, ExecutionState, ExecutionStepDetails, ExecutionsTransformer, ExpectedArtifactEditor, ExpectedArtifactModal, ExpectedArtifactSelector, ExpectedArtifactSelectorViewController, ExpectedArtifactService, ExpectedArtifactSourceSelector, ExpressionError, ExpressionInput, ExpressionPreview, FORM_VALIDATION_VALIDATABLE_FIELD_IS_VALID_SHORT_CIRCUIT, FUNCTION_READ_SERVICE, Filter, FilterCheckbox$1 as FilterCheckbox, FilterCollapse, FilterModelService, FilterSearch, FilterSection, FilterTags, FilterTypeRegistry, Filters$1 as Filters, FirewallLabels, FormField, FormValidator, FormValidatorField, FormikExpressionField, FormikExpressionRegexField, FormikForm, FormikFormField, FormikSpelContext, FormikSpelContextProvider, FormikStageConfig, FunctionDetails, FunctionReader, FunctionState, FunctionWriter, GlobalSearch, GroupedNotificationList, HeaderCell, Health, HealthCounts, HealthCountsCell, HelpContentsRegistry, HelpField, HelpMenu, HelpTextExpandedContext, HoverablePopover, HrefCell, IMAGE_READER, IMAGE_SOURCE_SELECTOR_COMPONENT, INFRASTRUCTURE_CACHE_CONFIG, INFRASTRUCTURE_KEY, INFRASTRUCTURE_SEARCH_SERVICE, INSTANCE_TYPE_SERVICE, IconTooltip, IgorService, ImageList, ImageReader, InfrastructureCaches, InfrastructureCachesInternal, InfrastructureSearchService, InfrastructureSearcher, InstanceActions, InstanceDetails, InstanceDetailsCmp, InstanceDetailsHeader, InstanceDetailsPane, InstanceInsights, InstanceLinks, InstanceLoadBalancerHealth, InstanceReader, InstanceTypeService, InstanceWriter, InvalidAPIResponse, JobEventBasedPodNameProvider, JobManifestPodLogs, JobStageExecutionLogs, JsonEditor, JsonUtils, Key, LINK_WITH_CLIPBOARD, LOAD_BALANCER_READ_SERVICE, LabelComponent, LabeledValue, LabeledValueList, LayoutConsumer, LayoutContext, LayoutProvider, LinkWithClipboard, LoadBalancerClusterContainer, LoadBalancerDataUtils, LoadBalancerInstances, LoadBalancerReader, LoadBalancerServerGroup, LoadBalancerState, LoadBalancerWriter, LoadBalancers$2 as LoadBalancers, LoadBalancersTagWrapper, MANAGED_RESOURCES_DATA_SOURCE, MANAGED_RESOURCE_DETAILS_INDICATOR, ManagedMenuItem, ManagedReader, ManagedResourceDetailsIndicator, ManagedResourceStatus, ManagedResourceStatusIndicator, ManagedWriter, ManifestReader, ManifestWriter, ManifestYaml, ManualExecutionModal, MapEditor, MapEditorInput, MapPair, Markdown, MinMaxDesiredChanges, Modal, ModalBody, ModalClose, ModalFooter, ModalHeader, ModalInjector, ModalWizard, MultiSelectCheckbox, NOTIFICATION_LIST, NameUtils, NavigationCategoryRegistry, NetworkReader, NgAppEngineDeployArtifactDelegate, NgAppengineConfigArtifactDelegate, NgBakeManifestArtifactDelegate, NgGCEImageArtifactDelegate, NgGenericArtifactDelegate, NgReact, NgReactInjector, NotificationCategories, NotificationCategory, NotificationDetails$1 as NotificationDetails, NotificationList, NotificationSelector, NotificationTransformer, NotificationsList, NotifierService, NumberInput$1 as NumberInput, NumberList, OVERRIDE_REGISTRY, OrchestratedItemTransformer, Overridable, OverrideRegistry, Overrides, PAGER_DUTY_SELECT_FIELD_COMPONENT, PAGER_DUTY_TAG_COMPONENT, PAGE_TITLE_SERVICE, PLUGINS_MODULE, PRECONFIGUREDJOB_STAGE, PROVIDER_SERVICE_DELEGATE, PageNavigator, PageSection, PageTitleService, PagerDutyReader, PagerDutySelectFieldController, PagerDutyTagComponentController, PagerDutyWriter, PipelineConfigService, PipelineConfigValidator, PipelineRegistry, PipelineStageExecutionDetails, PipelineTemplateReader, PipelineTemplateV2Service, PipelineTemplates, Pipelines$1 as Pipelines, PlatformHealthOverride, PlatformHealthOverrideInput, PlatformHealthOverrideMessage, PluginRegistry, PreconfiguredJobExecutionDetails, PreconfiguredJobReader, PreconfiguredJobStageConfig, ProjectAttributes, ProjectHeader, ProjectReader, ProjectWriter, ProviderSelectionService, ProviderServiceDelegate, PubsubSubscriptionReader, REACT_MODULE, RECENT_HISTORY_SERVICE, RENDER_IF_FEATURE, REST, ROBOT_TO_HUMAN_FILTER, RadioButtonInput, ReactInject, ReactInjector, ReactModal, ReactSelectInput, RecentHistoryService, RegionSelectField, RegionSelectInput, RegistrationQueue, Registry, RenderOutputFile, RenderWhenVisible, RequestBuilder, ResponsiveFieldLayout, RetryService, RunAsUserInput, RunningTasks$1 as RunningTasks, SECURITY_GROUP_READER, SERVER_GROUP_COMMAND_BUILDER_SERVICE, SERVER_GROUP_COMMAND_REGISTRY_PROVIDER, SERVER_GROUP_CONFIGURATION_SERVICE, SERVER_GROUP_MANAGER_DATA_SOURCE, SERVER_GROUP_MANAGER_STATES, SERVER_GROUP_WRITER, SETTINGS, SLACK_COMPONENT, STAGE_ARTIFACT_SELECTOR_COMPONENT_REACT, STATE_CONFIG_PROVIDER, STATE_EVENTS, SchedulerFactory, ScopeClusterSelector, ScrollToService, Search, SearchFilterTypeRegistry, SearchResultType, SearchResultTypeRegistry, SearchResults, SearchService, SearchStatus, SearchTableBody, SearchTableHeader, SearchTableRow, SecurityGroupReader, SecurityGroupState, SecurityGroupWriter, SelectInput, SequenceAndBuildAndImages, ServerGroup$1 as ServerGroup, ServerGroupCommandBuilderService, ServerGroupCommandRegistry, ServerGroupConfigurationService, ServerGroupDetails, ServerGroupDetailsField, ServerGroupDetailsWrapper, ServerGroupHeader, ServerGroupManagerReader, ServerGroupManagerTag, ServerGroupNamePreview, ServerGroupReader, ServerGroupTemplates, ServerGroupWarningMessageService, ServerGroupWriter, ServiceAccountReader, ServicesReader, ShowUserData, SimpleSpelInput, SingleLineString, SlackReader, SortToggle, SpInput, SpanDropdownTrigger, SpelAwareInputMode, SpelInput, SpelNumberInput, SpelService, SpelText, SpelToggle, SpinErrorBoundary, SpinFormik, Spinner, StageArtifactSelector, StageArtifactSelectorDelegate, StageConfigField, StageConstants, StageExecutionLogs, StageFailureMessage, StageFailureMessages, StageSummary, StandardFieldLayout, StateConfigProvider, StateEvents, StorageAccountReader, StringsAsOptions, SubmitButton, SubnetReader, SubnetTag, TIME_FORMATTERS, TabBoundary, Table, TableCell, TableRow, Tag, TagList, TaskExecutor, TaskMatcher, TaskMonitor, TaskMonitorModal, TaskMonitorWrapper, TaskReader, TaskReason, TetheredCreatable, TetheredSelect, TextAreaInput, TextInput, TitusExecutionLogs, ToggleButtonGroup, ToggleSize, Tooltip, TriggerTemplate, Triggers$1 as Triggers, UI_ROUTER_REACT_ERROR_BOUNDARY, UUIDGenerator, UrlBuilder, UrlBuilderRegistry, UrlParser, UserMenu, UserVerification, V2ModalWizard, V2_MODAL_WIZARD_COMPONENT, VIEW_CHANGES_LINK, ValidationMessage, Validators, VersionChecker, ViewChangesLink, ViewScalingActivitiesLink, ViewStateCache, ViewStateCacheInternal, WatchValue, WizardModal, WizardPage, WizardStepLabel, WorkerPool, YAML_EDITOR_COMPONENT, YamlEditor, addManagedResourceMetadataToLoadBalancers, addManagedResourceMetadataToSecurityGroups, addManagedResourceMetadataToServerGroups, applySuspendedStatuses, arePropsEqual, asyncMessage, booleanParamType, categorizeValidationMessage, categorizeValidationMessages, categoryLabels, composeValidators, confirmNotManaged, createFakeReactSyntheticEvent, createFieldValidator, decodeUnicodeBase64, defaultExcludedArtifactTypes, digestDependentFilters, duration, errorMessage, evaluateExpression, excludeAllTypesExcept, filterModelConfig$1 as filterModelConfig, filterObjectValues, firstDefined, getBakedArtifacts, getContentReference, getGridColumnsStyle, getKindName, getResourceKindForLoadBalancerType, infoMessage, initialize, invalidContentMessage, inverseBooleanParamType, isStringArray, logger, makePreconfiguredJobStage, makeRequestBuilderConfig, messageMessage, minimalNativeTableLayout, navigationCategoryRegistry, noop, now, orEmptyString, overridableComponent, overrideRegistrationQueue, overridesComponent, parseSpelExpressions, reactSelectOnBlurAdapter, reactSelectOnChangeAdapter, reactSelectValidationErrorStyle, registerManagedDeliveryPlugin, registerPluginExtensions, relativeTime, renderContent, resourceManager, robotToHuman, robotToHumanFilter, searchResultTypeRegistry, setMatchingResourceSummary, showModal, sortKeyParamType, spelNumberCheck, standardGridTableLayout, successMessage, taskMatcher, timeDiffToString, timePickerTime, timestamp, toIPromise, toMarkdown, toggleResourcePause, traverseObject, trueKeyObjectParamType, useApplicationContext, useApplicationContextSafe, useContainerClassNames, useData, useDataSource, useDebouncedValue, useDeepObjectDiff, useEscapeKeyPressed, useEventListener, useForceUpdate, useFormInputValueMapper, useInternalValidator, useInterval, useIsMobile, useIsMountedRef, useLatestCallback, useLatestPromise, useMountStatusRef, useObservable, useObservableValue, usePollingData, usePrevious, useSaveRestoreMutuallyExclusiveFields, useValidationData, validationClassName, verticalNavExpandedAtom, warningMessage, withErrorBoundary, yamlDocumentsToString, yamlStringToDocuments };
//# sourceMappingURL=index.js.map
